(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
  }) : x)(function(x) {
    if (typeof require !== "undefined")
      return require.apply(this, arguments);
    throw new Error('Dynamic require of "' + x + '" is not supported');
  });
  var __esm = (fn, res) => function __init() {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  };
  var __commonJS = (cb, mod) => function __require2() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // <define:process>
  var define_process_default;
  var init_define_process = __esm({
    "<define:process>"() {
      define_process_default = { env: { NODE_ENV: "production", STANDALONE: "true" } };
    }
  });

  // node_modules/base64-js/index.js
  var require_base64_js = __commonJS({
    "node_modules/base64-js/index.js"(exports2) {
      "use strict";
      init_define_process();
      exports2.byteLength = byteLength;
      exports2.toByteArray = toByteArray;
      exports2.fromByteArray = fromByteArray;
      var lookup = [];
      var revLookup = [];
      var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
      var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      for (i = 0, len = code.length; i < len; ++i) {
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
      }
      var i;
      var len;
      revLookup["-".charCodeAt(0)] = 62;
      revLookup["_".charCodeAt(0)] = 63;
      function getLens(b64) {
        var len2 = b64.length;
        if (len2 % 4 > 0) {
          throw new Error("Invalid string. Length must be a multiple of 4");
        }
        var validLen = b64.indexOf("=");
        if (validLen === -1)
          validLen = len2;
        var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
        return [validLen, placeHoldersLen];
      }
      function byteLength(b64) {
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
      }
      function _byteLength(b64, validLen, placeHoldersLen) {
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
      }
      function toByteArray(b64) {
        var tmp;
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
        var curByte = 0;
        var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
        var i2;
        for (i2 = 0; i2 < len2; i2 += 4) {
          tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
          arr[curByte++] = tmp >> 16 & 255;
          arr[curByte++] = tmp >> 8 & 255;
          arr[curByte++] = tmp & 255;
        }
        if (placeHoldersLen === 2) {
          tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
          arr[curByte++] = tmp & 255;
        }
        if (placeHoldersLen === 1) {
          tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
          arr[curByte++] = tmp >> 8 & 255;
          arr[curByte++] = tmp & 255;
        }
        return arr;
      }
      function tripletToBase64(num) {
        return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
      }
      function encodeChunk(uint8, start, end) {
        var tmp;
        var output = [];
        for (var i2 = start; i2 < end; i2 += 3) {
          tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
          output.push(tripletToBase64(tmp));
        }
        return output.join("");
      }
      function fromByteArray(uint8) {
        var tmp;
        var len2 = uint8.length;
        var extraBytes = len2 % 3;
        var parts = [];
        var maxChunkLength = 16383;
        for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
          parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
        }
        if (extraBytes === 1) {
          tmp = uint8[len2 - 1];
          parts.push(
            lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
          );
        } else if (extraBytes === 2) {
          tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
          parts.push(
            lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
          );
        }
        return parts.join("");
      }
    }
  });

  // node_modules/ieee754/index.js
  var require_ieee754 = __commonJS({
    "node_modules/ieee754/index.js"(exports2) {
      init_define_process();
      exports2.read = function(buffer, offset, isLE, mLen, nBytes) {
        var e, m;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = -7;
        var i = isLE ? nBytes - 1 : 0;
        var d = isLE ? -1 : 1;
        var s = buffer[offset + i];
        i += d;
        e = s & (1 << -nBits) - 1;
        s >>= -nBits;
        nBits += eLen;
        for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
        }
        m = e & (1 << -nBits) - 1;
        e >>= -nBits;
        nBits += mLen;
        for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
        }
        if (e === 0) {
          e = 1 - eBias;
        } else if (e === eMax) {
          return m ? NaN : (s ? -1 : 1) * Infinity;
        } else {
          m = m + Math.pow(2, mLen);
          e = e - eBias;
        }
        return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
      };
      exports2.write = function(buffer, value, offset, isLE, mLen, nBytes) {
        var e, m, c;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
        var i = isLE ? 0 : nBytes - 1;
        var d = isLE ? 1 : -1;
        var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
        value = Math.abs(value);
        if (isNaN(value) || value === Infinity) {
          m = isNaN(value) ? 1 : 0;
          e = eMax;
        } else {
          e = Math.floor(Math.log(value) / Math.LN2);
          if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
          }
          if (e + eBias >= 1) {
            value += rt / c;
          } else {
            value += rt * Math.pow(2, 1 - eBias);
          }
          if (value * c >= 2) {
            e++;
            c /= 2;
          }
          if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
          } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
          } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
          }
        }
        for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
        }
        e = e << mLen | m;
        eLen += mLen;
        for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
        }
        buffer[offset + i - d] |= s * 128;
      };
    }
  });

  // node_modules/buffer/index.js
  var require_buffer = __commonJS({
    "node_modules/buffer/index.js"(exports2) {
      "use strict";
      init_define_process();
      var base64 = require_base64_js();
      var ieee754 = require_ieee754();
      var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
      exports2.Buffer = Buffer5;
      exports2.SlowBuffer = SlowBuffer;
      exports2.INSPECT_MAX_BYTES = 50;
      var K_MAX_LENGTH = 2147483647;
      exports2.kMaxLength = K_MAX_LENGTH;
      Buffer5.TYPED_ARRAY_SUPPORT = typedArraySupport();
      if (!Buffer5.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
        console.error(
          "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
        );
      }
      function typedArraySupport() {
        try {
          const arr = new Uint8Array(1);
          const proto = { foo: function() {
            return 42;
          } };
          Object.setPrototypeOf(proto, Uint8Array.prototype);
          Object.setPrototypeOf(arr, proto);
          return arr.foo() === 42;
        } catch (e) {
          return false;
        }
      }
      Object.defineProperty(Buffer5.prototype, "parent", {
        enumerable: true,
        get: function() {
          if (!Buffer5.isBuffer(this))
            return void 0;
          return this.buffer;
        }
      });
      Object.defineProperty(Buffer5.prototype, "offset", {
        enumerable: true,
        get: function() {
          if (!Buffer5.isBuffer(this))
            return void 0;
          return this.byteOffset;
        }
      });
      function createBuffer(length) {
        if (length > K_MAX_LENGTH) {
          throw new RangeError('The value "' + length + '" is invalid for option "size"');
        }
        const buf = new Uint8Array(length);
        Object.setPrototypeOf(buf, Buffer5.prototype);
        return buf;
      }
      function Buffer5(arg, encodingOrOffset, length) {
        if (typeof arg === "number") {
          if (typeof encodingOrOffset === "string") {
            throw new TypeError(
              'The "string" argument must be of type string. Received type number'
            );
          }
          return allocUnsafe2(arg);
        }
        return from(arg, encodingOrOffset, length);
      }
      Buffer5.poolSize = 8192;
      function from(value, encodingOrOffset, length) {
        if (typeof value === "string") {
          return fromString(value, encodingOrOffset);
        }
        if (ArrayBuffer.isView(value)) {
          return fromArrayView(value);
        }
        if (value == null) {
          throw new TypeError(
            "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
          );
        }
        if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
          return fromArrayBuffer(value, encodingOrOffset, length);
        }
        if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
          return fromArrayBuffer(value, encodingOrOffset, length);
        }
        if (typeof value === "number") {
          throw new TypeError(
            'The "value" argument must not be of type number. Received type number'
          );
        }
        const valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) {
          return Buffer5.from(valueOf, encodingOrOffset, length);
        }
        const b = fromObject(value);
        if (b)
          return b;
        if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
          return Buffer5.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
        }
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
        );
      }
      Buffer5.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
      };
      Object.setPrototypeOf(Buffer5.prototype, Uint8Array.prototype);
      Object.setPrototypeOf(Buffer5, Uint8Array);
      function assertSize(size2) {
        if (typeof size2 !== "number") {
          throw new TypeError('"size" argument must be of type number');
        } else if (size2 < 0) {
          throw new RangeError('The value "' + size2 + '" is invalid for option "size"');
        }
      }
      function alloc(size2, fill2, encoding) {
        assertSize(size2);
        if (size2 <= 0) {
          return createBuffer(size2);
        }
        if (fill2 !== void 0) {
          return typeof encoding === "string" ? createBuffer(size2).fill(fill2, encoding) : createBuffer(size2).fill(fill2);
        }
        return createBuffer(size2);
      }
      Buffer5.alloc = function(size2, fill2, encoding) {
        return alloc(size2, fill2, encoding);
      };
      function allocUnsafe2(size2) {
        assertSize(size2);
        return createBuffer(size2 < 0 ? 0 : checked(size2) | 0);
      }
      Buffer5.allocUnsafe = function(size2) {
        return allocUnsafe2(size2);
      };
      Buffer5.allocUnsafeSlow = function(size2) {
        return allocUnsafe2(size2);
      };
      function fromString(string, encoding) {
        if (typeof encoding !== "string" || encoding === "") {
          encoding = "utf8";
        }
        if (!Buffer5.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
        const length = byteLength(string, encoding) | 0;
        let buf = createBuffer(length);
        const actual = buf.write(string, encoding);
        if (actual !== length) {
          buf = buf.slice(0, actual);
        }
        return buf;
      }
      function fromArrayLike(array) {
        const length = array.length < 0 ? 0 : checked(array.length) | 0;
        const buf = createBuffer(length);
        for (let i = 0; i < length; i += 1) {
          buf[i] = array[i] & 255;
        }
        return buf;
      }
      function fromArrayView(arrayView) {
        if (isInstance(arrayView, Uint8Array)) {
          const copy = new Uint8Array(arrayView);
          return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
      }
      function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) {
          throw new RangeError('"offset" is outside of buffer bounds');
        }
        if (array.byteLength < byteOffset + (length || 0)) {
          throw new RangeError('"length" is outside of buffer bounds');
        }
        let buf;
        if (byteOffset === void 0 && length === void 0) {
          buf = new Uint8Array(array);
        } else if (length === void 0) {
          buf = new Uint8Array(array, byteOffset);
        } else {
          buf = new Uint8Array(array, byteOffset, length);
        }
        Object.setPrototypeOf(buf, Buffer5.prototype);
        return buf;
      }
      function fromObject(obj) {
        if (Buffer5.isBuffer(obj)) {
          const len = checked(obj.length) | 0;
          const buf = createBuffer(len);
          if (buf.length === 0) {
            return buf;
          }
          obj.copy(buf, 0, 0, len);
          return buf;
        }
        if (obj.length !== void 0) {
          if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
            return createBuffer(0);
          }
          return fromArrayLike(obj);
        }
        if (obj.type === "Buffer" && Array.isArray(obj.data)) {
          return fromArrayLike(obj.data);
        }
      }
      function checked(length) {
        if (length >= K_MAX_LENGTH) {
          throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
        }
        return length | 0;
      }
      function SlowBuffer(length) {
        if (+length != length) {
          length = 0;
        }
        return Buffer5.alloc(+length);
      }
      Buffer5.isBuffer = function isBuffer2(b) {
        return b != null && b._isBuffer === true && b !== Buffer5.prototype;
      };
      Buffer5.compare = function compare(a, b) {
        if (isInstance(a, Uint8Array))
          a = Buffer5.from(a, a.offset, a.byteLength);
        if (isInstance(b, Uint8Array))
          b = Buffer5.from(b, b.offset, b.byteLength);
        if (!Buffer5.isBuffer(a) || !Buffer5.isBuffer(b)) {
          throw new TypeError(
            'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
          );
        }
        if (a === b)
          return 0;
        let x = a.length;
        let y = b.length;
        for (let i = 0, len = Math.min(x, y); i < len; ++i) {
          if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
          }
        }
        if (x < y)
          return -1;
        if (y < x)
          return 1;
        return 0;
      };
      Buffer5.isEncoding = function isEncoding(encoding) {
        switch (String(encoding).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return true;
          default:
            return false;
        }
      };
      Buffer5.concat = function concat2(list, length) {
        if (!Array.isArray(list)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        }
        if (list.length === 0) {
          return Buffer5.alloc(0);
        }
        let i;
        if (length === void 0) {
          length = 0;
          for (i = 0; i < list.length; ++i) {
            length += list[i].length;
          }
        }
        const buffer = Buffer5.allocUnsafe(length);
        let pos = 0;
        for (i = 0; i < list.length; ++i) {
          let buf = list[i];
          if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
              if (!Buffer5.isBuffer(buf))
                buf = Buffer5.from(buf);
              buf.copy(buffer, pos);
            } else {
              Uint8Array.prototype.set.call(
                buffer,
                buf,
                pos
              );
            }
          } else if (!Buffer5.isBuffer(buf)) {
            throw new TypeError('"list" argument must be an Array of Buffers');
          } else {
            buf.copy(buffer, pos);
          }
          pos += buf.length;
        }
        return buffer;
      };
      function byteLength(string, encoding) {
        if (Buffer5.isBuffer(string)) {
          return string.length;
        }
        if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
          return string.byteLength;
        }
        if (typeof string !== "string") {
          throw new TypeError(
            'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string
          );
        }
        const len = string.length;
        const mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0)
          return 0;
        let loweredCase = false;
        for (; ; ) {
          switch (encoding) {
            case "ascii":
            case "latin1":
            case "binary":
              return len;
            case "utf8":
            case "utf-8":
              return utf8ToBytes(string).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return len * 2;
            case "hex":
              return len >>> 1;
            case "base64":
              return base64ToBytes(string).length;
            default:
              if (loweredCase) {
                return mustMatch ? -1 : utf8ToBytes(string).length;
              }
              encoding = ("" + encoding).toLowerCase();
              loweredCase = true;
          }
        }
      }
      Buffer5.byteLength = byteLength;
      function slowToString(encoding, start, end) {
        let loweredCase = false;
        if (start === void 0 || start < 0) {
          start = 0;
        }
        if (start > this.length) {
          return "";
        }
        if (end === void 0 || end > this.length) {
          end = this.length;
        }
        if (end <= 0) {
          return "";
        }
        end >>>= 0;
        start >>>= 0;
        if (end <= start) {
          return "";
        }
        if (!encoding)
          encoding = "utf8";
        while (true) {
          switch (encoding) {
            case "hex":
              return hexSlice(this, start, end);
            case "utf8":
            case "utf-8":
              return utf8Slice(this, start, end);
            case "ascii":
              return asciiSlice(this, start, end);
            case "latin1":
            case "binary":
              return latin1Slice(this, start, end);
            case "base64":
              return base64Slice(this, start, end);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return utf16leSlice(this, start, end);
            default:
              if (loweredCase)
                throw new TypeError("Unknown encoding: " + encoding);
              encoding = (encoding + "").toLowerCase();
              loweredCase = true;
          }
        }
      }
      Buffer5.prototype._isBuffer = true;
      function swap(b, n, m) {
        const i = b[n];
        b[n] = b[m];
        b[m] = i;
      }
      Buffer5.prototype.swap16 = function swap16() {
        const len = this.length;
        if (len % 2 !== 0) {
          throw new RangeError("Buffer size must be a multiple of 16-bits");
        }
        for (let i = 0; i < len; i += 2) {
          swap(this, i, i + 1);
        }
        return this;
      };
      Buffer5.prototype.swap32 = function swap32() {
        const len = this.length;
        if (len % 4 !== 0) {
          throw new RangeError("Buffer size must be a multiple of 32-bits");
        }
        for (let i = 0; i < len; i += 4) {
          swap(this, i, i + 3);
          swap(this, i + 1, i + 2);
        }
        return this;
      };
      Buffer5.prototype.swap64 = function swap64() {
        const len = this.length;
        if (len % 8 !== 0) {
          throw new RangeError("Buffer size must be a multiple of 64-bits");
        }
        for (let i = 0; i < len; i += 8) {
          swap(this, i, i + 7);
          swap(this, i + 1, i + 6);
          swap(this, i + 2, i + 5);
          swap(this, i + 3, i + 4);
        }
        return this;
      };
      Buffer5.prototype.toString = function toString2() {
        const length = this.length;
        if (length === 0)
          return "";
        if (arguments.length === 0)
          return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
      };
      Buffer5.prototype.toLocaleString = Buffer5.prototype.toString;
      Buffer5.prototype.equals = function equals(b) {
        if (!Buffer5.isBuffer(b))
          throw new TypeError("Argument must be a Buffer");
        if (this === b)
          return true;
        return Buffer5.compare(this, b) === 0;
      };
      Buffer5.prototype.inspect = function inspect() {
        let str = "";
        const max2 = exports2.INSPECT_MAX_BYTES;
        str = this.toString("hex", 0, max2).replace(/(.{2})/g, "$1 ").trim();
        if (this.length > max2)
          str += " ... ";
        return "<Buffer " + str + ">";
      };
      if (customInspectSymbol) {
        Buffer5.prototype[customInspectSymbol] = Buffer5.prototype.inspect;
      }
      Buffer5.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, Uint8Array)) {
          target = Buffer5.from(target, target.offset, target.byteLength);
        }
        if (!Buffer5.isBuffer(target)) {
          throw new TypeError(
            'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target
          );
        }
        if (start === void 0) {
          start = 0;
        }
        if (end === void 0) {
          end = target ? target.length : 0;
        }
        if (thisStart === void 0) {
          thisStart = 0;
        }
        if (thisEnd === void 0) {
          thisEnd = this.length;
        }
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
          throw new RangeError("out of range index");
        }
        if (thisStart >= thisEnd && start >= end) {
          return 0;
        }
        if (thisStart >= thisEnd) {
          return -1;
        }
        if (start >= end) {
          return 1;
        }
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target)
          return 0;
        let x = thisEnd - thisStart;
        let y = end - start;
        const len = Math.min(x, y);
        const thisCopy = this.slice(thisStart, thisEnd);
        const targetCopy = target.slice(start, end);
        for (let i = 0; i < len; ++i) {
          if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
          }
        }
        if (x < y)
          return -1;
        if (y < x)
          return 1;
        return 0;
      };
      function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        if (buffer.length === 0)
          return -1;
        if (typeof byteOffset === "string") {
          encoding = byteOffset;
          byteOffset = 0;
        } else if (byteOffset > 2147483647) {
          byteOffset = 2147483647;
        } else if (byteOffset < -2147483648) {
          byteOffset = -2147483648;
        }
        byteOffset = +byteOffset;
        if (numberIsNaN(byteOffset)) {
          byteOffset = dir ? 0 : buffer.length - 1;
        }
        if (byteOffset < 0)
          byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
          if (dir)
            return -1;
          else
            byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
          if (dir)
            byteOffset = 0;
          else
            return -1;
        }
        if (typeof val === "string") {
          val = Buffer5.from(val, encoding);
        }
        if (Buffer5.isBuffer(val)) {
          if (val.length === 0) {
            return -1;
          }
          return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === "number") {
          val = val & 255;
          if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) {
              return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            } else {
              return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
          }
          return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
        }
        throw new TypeError("val must be string, number or Buffer");
      }
      function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        let indexSize = 1;
        let arrLength = arr.length;
        let valLength = val.length;
        if (encoding !== void 0) {
          encoding = String(encoding).toLowerCase();
          if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) {
              return -1;
            }
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
          }
        }
        function read(buf, i2) {
          if (indexSize === 1) {
            return buf[i2];
          } else {
            return buf.readUInt16BE(i2 * indexSize);
          }
        }
        let i;
        if (dir) {
          let foundIndex = -1;
          for (i = byteOffset; i < arrLength; i++) {
            if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
              if (foundIndex === -1)
                foundIndex = i;
              if (i - foundIndex + 1 === valLength)
                return foundIndex * indexSize;
            } else {
              if (foundIndex !== -1)
                i -= i - foundIndex;
              foundIndex = -1;
            }
          }
        } else {
          if (byteOffset + valLength > arrLength)
            byteOffset = arrLength - valLength;
          for (i = byteOffset; i >= 0; i--) {
            let found = true;
            for (let j = 0; j < valLength; j++) {
              if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
              }
            }
            if (found)
              return i;
          }
        }
        return -1;
      }
      Buffer5.prototype.includes = function includes2(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
      };
      Buffer5.prototype.indexOf = function indexOf2(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
      };
      Buffer5.prototype.lastIndexOf = function lastIndexOf2(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
      };
      function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        const remaining = buf.length - offset;
        if (!length) {
          length = remaining;
        } else {
          length = Number(length);
          if (length > remaining) {
            length = remaining;
          }
        }
        const strLen = string.length;
        if (length > strLen / 2) {
          length = strLen / 2;
        }
        let i;
        for (i = 0; i < length; ++i) {
          const parsed = parseInt(string.substr(i * 2, 2), 16);
          if (numberIsNaN(parsed))
            return i;
          buf[offset + i] = parsed;
        }
        return i;
      }
      function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
      }
      function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
      }
      function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
      }
      function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
      }
      Buffer5.prototype.write = function write(string, offset, length, encoding) {
        if (offset === void 0) {
          encoding = "utf8";
          length = this.length;
          offset = 0;
        } else if (length === void 0 && typeof offset === "string") {
          encoding = offset;
          length = this.length;
          offset = 0;
        } else if (isFinite(offset)) {
          offset = offset >>> 0;
          if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === void 0)
              encoding = "utf8";
          } else {
            encoding = length;
            length = void 0;
          }
        } else {
          throw new Error(
            "Buffer.write(string, encoding, offset[, length]) is no longer supported"
          );
        }
        const remaining = this.length - offset;
        if (length === void 0 || length > remaining)
          length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
          throw new RangeError("Attempt to write outside buffer bounds");
        }
        if (!encoding)
          encoding = "utf8";
        let loweredCase = false;
        for (; ; ) {
          switch (encoding) {
            case "hex":
              return hexWrite(this, string, offset, length);
            case "utf8":
            case "utf-8":
              return utf8Write(this, string, offset, length);
            case "ascii":
            case "latin1":
            case "binary":
              return asciiWrite(this, string, offset, length);
            case "base64":
              return base64Write(this, string, offset, length);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return ucs2Write(this, string, offset, length);
            default:
              if (loweredCase)
                throw new TypeError("Unknown encoding: " + encoding);
              encoding = ("" + encoding).toLowerCase();
              loweredCase = true;
          }
        }
      };
      Buffer5.prototype.toJSON = function toJSON() {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) {
          return base64.fromByteArray(buf);
        } else {
          return base64.fromByteArray(buf.slice(start, end));
        }
      }
      function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        const res = [];
        let i = start;
        while (i < end) {
          const firstByte = buf[i];
          let codePoint = null;
          let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
          if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch (bytesPerSequence) {
              case 1:
                if (firstByte < 128) {
                  codePoint = firstByte;
                }
                break;
              case 2:
                secondByte = buf[i + 1];
                if ((secondByte & 192) === 128) {
                  tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                  if (tempCodePoint > 127) {
                    codePoint = tempCodePoint;
                  }
                }
                break;
              case 3:
                secondByte = buf[i + 1];
                thirdByte = buf[i + 2];
                if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                  tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                  if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                    codePoint = tempCodePoint;
                  }
                }
                break;
              case 4:
                secondByte = buf[i + 1];
                thirdByte = buf[i + 2];
                fourthByte = buf[i + 3];
                if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                  tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                  if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                    codePoint = tempCodePoint;
                  }
                }
            }
          }
          if (codePoint === null) {
            codePoint = 65533;
            bytesPerSequence = 1;
          } else if (codePoint > 65535) {
            codePoint -= 65536;
            res.push(codePoint >>> 10 & 1023 | 55296);
            codePoint = 56320 | codePoint & 1023;
          }
          res.push(codePoint);
          i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
      }
      var MAX_ARGUMENTS_LENGTH = 4096;
      function decodeCodePointsArray(codePoints) {
        const len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) {
          return String.fromCharCode.apply(String, codePoints);
        }
        let res = "";
        let i = 0;
        while (i < len) {
          res += String.fromCharCode.apply(
            String,
            codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
          );
        }
        return res;
      }
      function asciiSlice(buf, start, end) {
        let ret = "";
        end = Math.min(buf.length, end);
        for (let i = start; i < end; ++i) {
          ret += String.fromCharCode(buf[i] & 127);
        }
        return ret;
      }
      function latin1Slice(buf, start, end) {
        let ret = "";
        end = Math.min(buf.length, end);
        for (let i = start; i < end; ++i) {
          ret += String.fromCharCode(buf[i]);
        }
        return ret;
      }
      function hexSlice(buf, start, end) {
        const len = buf.length;
        if (!start || start < 0)
          start = 0;
        if (!end || end < 0 || end > len)
          end = len;
        let out = "";
        for (let i = start; i < end; ++i) {
          out += hexSliceLookupTable[buf[i]];
        }
        return out;
      }
      function utf16leSlice(buf, start, end) {
        const bytes = buf.slice(start, end);
        let res = "";
        for (let i = 0; i < bytes.length - 1; i += 2) {
          res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        }
        return res;
      }
      Buffer5.prototype.slice = function slice2(start, end) {
        const len = this.length;
        start = ~~start;
        end = end === void 0 ? len : ~~end;
        if (start < 0) {
          start += len;
          if (start < 0)
            start = 0;
        } else if (start > len) {
          start = len;
        }
        if (end < 0) {
          end += len;
          if (end < 0)
            end = 0;
        } else if (end > len) {
          end = len;
        }
        if (end < start)
          end = start;
        const newBuf = this.subarray(start, end);
        Object.setPrototypeOf(newBuf, Buffer5.prototype);
        return newBuf;
      };
      function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0)
          throw new RangeError("offset is not uint");
        if (offset + ext > length)
          throw new RangeError("Trying to access beyond buffer length");
      }
      Buffer5.prototype.readUintLE = Buffer5.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert)
          checkOffset(offset, byteLength2, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while (++i < byteLength2 && (mul *= 256)) {
          val += this[offset + i] * mul;
        }
        return val;
      };
      Buffer5.prototype.readUintBE = Buffer5.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) {
          checkOffset(offset, byteLength2, this.length);
        }
        let val = this[offset + --byteLength2];
        let mul = 1;
        while (byteLength2 > 0 && (mul *= 256)) {
          val += this[offset + --byteLength2] * mul;
        }
        return val;
      };
      Buffer5.prototype.readUint8 = Buffer5.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 1, this.length);
        return this[offset];
      };
      Buffer5.prototype.readUint16LE = Buffer5.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
      };
      Buffer5.prototype.readUint16BE = Buffer5.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
      };
      Buffer5.prototype.readUint32LE = Buffer5.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
      };
      Buffer5.prototype.readUint32BE = Buffer5.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
      };
      Buffer5.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last2 = this[offset + 7];
        if (first === void 0 || last2 === void 0) {
          boundsError(offset, this.length - 8);
        }
        const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
        const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last2 * 2 ** 24;
        return BigInt(lo) + (BigInt(hi) << BigInt(32));
      });
      Buffer5.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last2 = this[offset + 7];
        if (first === void 0 || last2 === void 0) {
          boundsError(offset, this.length - 8);
        }
        const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
        const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last2;
        return (BigInt(hi) << BigInt(32)) + BigInt(lo);
      });
      Buffer5.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert)
          checkOffset(offset, byteLength2, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while (++i < byteLength2 && (mul *= 256)) {
          val += this[offset + i] * mul;
        }
        mul *= 128;
        if (val >= mul)
          val -= Math.pow(2, 8 * byteLength2);
        return val;
      };
      Buffer5.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert)
          checkOffset(offset, byteLength2, this.length);
        let i = byteLength2;
        let mul = 1;
        let val = this[offset + --i];
        while (i > 0 && (mul *= 256)) {
          val += this[offset + --i] * mul;
        }
        mul *= 128;
        if (val >= mul)
          val -= Math.pow(2, 8 * byteLength2);
        return val;
      };
      Buffer5.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 1, this.length);
        if (!(this[offset] & 128))
          return this[offset];
        return (255 - this[offset] + 1) * -1;
      };
      Buffer5.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 2, this.length);
        const val = this[offset] | this[offset + 1] << 8;
        return val & 32768 ? val | 4294901760 : val;
      };
      Buffer5.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 2, this.length);
        const val = this[offset + 1] | this[offset] << 8;
        return val & 32768 ? val | 4294901760 : val;
      };
      Buffer5.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
      };
      Buffer5.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
      };
      Buffer5.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last2 = this[offset + 7];
        if (first === void 0 || last2 === void 0) {
          boundsError(offset, this.length - 8);
        }
        const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last2 << 24);
        return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
      });
      Buffer5.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last2 = this[offset + 7];
        if (first === void 0 || last2 === void 0) {
          boundsError(offset, this.length - 8);
        }
        const val = (first << 24) + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
        return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last2);
      });
      Buffer5.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return ieee754.read(this, offset, true, 23, 4);
      };
      Buffer5.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 4, this.length);
        return ieee754.read(this, offset, false, 23, 4);
      };
      Buffer5.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 8, this.length);
        return ieee754.read(this, offset, true, 52, 8);
      };
      Buffer5.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert)
          checkOffset(offset, 8, this.length);
        return ieee754.read(this, offset, false, 52, 8);
      };
      function checkInt(buf, value, offset, ext, max2, min2) {
        if (!Buffer5.isBuffer(buf))
          throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max2 || value < min2)
          throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length)
          throw new RangeError("Index out of range");
      }
      Buffer5.prototype.writeUintLE = Buffer5.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) {
          const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
          checkInt(this, value, offset, byteLength2, maxBytes, 0);
        }
        let mul = 1;
        let i = 0;
        this[offset] = value & 255;
        while (++i < byteLength2 && (mul *= 256)) {
          this[offset + i] = value / mul & 255;
        }
        return offset + byteLength2;
      };
      Buffer5.prototype.writeUintBE = Buffer5.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) {
          const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
          checkInt(this, value, offset, byteLength2, maxBytes, 0);
        }
        let i = byteLength2 - 1;
        let mul = 1;
        this[offset + i] = value & 255;
        while (--i >= 0 && (mul *= 256)) {
          this[offset + i] = value / mul & 255;
        }
        return offset + byteLength2;
      };
      Buffer5.prototype.writeUint8 = Buffer5.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 1, 255, 0);
        this[offset] = value & 255;
        return offset + 1;
      };
      Buffer5.prototype.writeUint16LE = Buffer5.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 2, 65535, 0);
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        return offset + 2;
      };
      Buffer5.prototype.writeUint16BE = Buffer5.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 2, 65535, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 255;
        return offset + 2;
      };
      Buffer5.prototype.writeUint32LE = Buffer5.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 4, 4294967295, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 255;
        return offset + 4;
      };
      Buffer5.prototype.writeUint32BE = Buffer5.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 4, 4294967295, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 255;
        return offset + 4;
      };
      function wrtBigUInt64LE(buf, value, offset, min2, max2) {
        checkIntBI(value, min2, max2, buf, offset, 7);
        let lo = Number(value & BigInt(4294967295));
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(4294967295));
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        return offset;
      }
      function wrtBigUInt64BE(buf, value, offset, min2, max2) {
        checkIntBI(value, min2, max2, buf, offset, 7);
        let lo = Number(value & BigInt(4294967295));
        buf[offset + 7] = lo;
        lo = lo >> 8;
        buf[offset + 6] = lo;
        lo = lo >> 8;
        buf[offset + 5] = lo;
        lo = lo >> 8;
        buf[offset + 4] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(4294967295));
        buf[offset + 3] = hi;
        hi = hi >> 8;
        buf[offset + 2] = hi;
        hi = hi >> 8;
        buf[offset + 1] = hi;
        hi = hi >> 8;
        buf[offset] = hi;
        return offset + 8;
      }
      Buffer5.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
      });
      Buffer5.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
      });
      Buffer5.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          const limit = Math.pow(2, 8 * byteLength2 - 1);
          checkInt(this, value, offset, byteLength2, limit - 1, -limit);
        }
        let i = 0;
        let mul = 1;
        let sub = 0;
        this[offset] = value & 255;
        while (++i < byteLength2 && (mul *= 256)) {
          if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
            sub = 1;
          }
          this[offset + i] = (value / mul >> 0) - sub & 255;
        }
        return offset + byteLength2;
      };
      Buffer5.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          const limit = Math.pow(2, 8 * byteLength2 - 1);
          checkInt(this, value, offset, byteLength2, limit - 1, -limit);
        }
        let i = byteLength2 - 1;
        let mul = 1;
        let sub = 0;
        this[offset + i] = value & 255;
        while (--i >= 0 && (mul *= 256)) {
          if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
            sub = 1;
          }
          this[offset + i] = (value / mul >> 0) - sub & 255;
        }
        return offset + byteLength2;
      };
      Buffer5.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 1, 127, -128);
        if (value < 0)
          value = 255 + value + 1;
        this[offset] = value & 255;
        return offset + 1;
      };
      Buffer5.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 2, 32767, -32768);
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        return offset + 2;
      };
      Buffer5.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 2, 32767, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 255;
        return offset + 2;
      };
      Buffer5.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 4, 2147483647, -2147483648);
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
      };
      Buffer5.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert)
          checkInt(this, value, offset, 4, 2147483647, -2147483648);
        if (value < 0)
          value = 4294967295 + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 255;
        return offset + 4;
      };
      Buffer5.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      });
      Buffer5.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      });
      function checkIEEE754(buf, value, offset, ext, max2, min2) {
        if (offset + ext > buf.length)
          throw new RangeError("Index out of range");
        if (offset < 0)
          throw new RangeError("Index out of range");
      }
      function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          checkIEEE754(buf, value, offset, 4, 34028234663852886e22, -34028234663852886e22);
        }
        ieee754.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
      }
      Buffer5.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
      };
      Buffer5.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
      };
      function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          checkIEEE754(buf, value, offset, 8, 17976931348623157e292, -17976931348623157e292);
        }
        ieee754.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
      }
      Buffer5.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
      };
      Buffer5.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
      };
      Buffer5.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer5.isBuffer(target))
          throw new TypeError("argument should be a Buffer");
        if (!start)
          start = 0;
        if (!end && end !== 0)
          end = this.length;
        if (targetStart >= target.length)
          targetStart = target.length;
        if (!targetStart)
          targetStart = 0;
        if (end > 0 && end < start)
          end = start;
        if (end === start)
          return 0;
        if (target.length === 0 || this.length === 0)
          return 0;
        if (targetStart < 0) {
          throw new RangeError("targetStart out of bounds");
        }
        if (start < 0 || start >= this.length)
          throw new RangeError("Index out of range");
        if (end < 0)
          throw new RangeError("sourceEnd out of bounds");
        if (end > this.length)
          end = this.length;
        if (target.length - targetStart < end - start) {
          end = target.length - targetStart + start;
        }
        const len = end - start;
        if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
          this.copyWithin(targetStart, start, end);
        } else {
          Uint8Array.prototype.set.call(
            target,
            this.subarray(start, end),
            targetStart
          );
        }
        return len;
      };
      Buffer5.prototype.fill = function fill2(val, start, end, encoding) {
        if (typeof val === "string") {
          if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
          } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
          }
          if (encoding !== void 0 && typeof encoding !== "string") {
            throw new TypeError("encoding must be a string");
          }
          if (typeof encoding === "string" && !Buffer5.isEncoding(encoding)) {
            throw new TypeError("Unknown encoding: " + encoding);
          }
          if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") {
              val = code;
            }
          }
        } else if (typeof val === "number") {
          val = val & 255;
        } else if (typeof val === "boolean") {
          val = Number(val);
        }
        if (start < 0 || this.length < start || this.length < end) {
          throw new RangeError("Out of range index");
        }
        if (end <= start) {
          return this;
        }
        start = start >>> 0;
        end = end === void 0 ? this.length : end >>> 0;
        if (!val)
          val = 0;
        let i;
        if (typeof val === "number") {
          for (i = start; i < end; ++i) {
            this[i] = val;
          }
        } else {
          const bytes = Buffer5.isBuffer(val) ? val : Buffer5.from(val, encoding);
          const len = bytes.length;
          if (len === 0) {
            throw new TypeError('The value "' + val + '" is invalid for argument "value"');
          }
          for (i = 0; i < end - start; ++i) {
            this[i + start] = bytes[i % len];
          }
        }
        return this;
      };
      var errors = {};
      function E(sym, getMessage, Base) {
        errors[sym] = class NodeError extends Base {
          constructor() {
            super();
            Object.defineProperty(this, "message", {
              value: getMessage.apply(this, arguments),
              writable: true,
              configurable: true
            });
            this.name = `${this.name} [${sym}]`;
            this.stack;
            delete this.name;
          }
          get code() {
            return sym;
          }
          set code(value) {
            Object.defineProperty(this, "code", {
              configurable: true,
              enumerable: true,
              value,
              writable: true
            });
          }
          toString() {
            return `${this.name} [${sym}]: ${this.message}`;
          }
        };
      }
      E(
        "ERR_BUFFER_OUT_OF_BOUNDS",
        function(name) {
          if (name) {
            return `${name} is outside of buffer bounds`;
          }
          return "Attempt to access memory outside buffer bounds";
        },
        RangeError
      );
      E(
        "ERR_INVALID_ARG_TYPE",
        function(name, actual) {
          return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
        },
        TypeError
      );
      E(
        "ERR_OUT_OF_RANGE",
        function(str, range2, input) {
          let msg = `The value of "${str}" is out of range.`;
          let received = input;
          if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
            received = addNumericalSeparator(String(input));
          } else if (typeof input === "bigint") {
            received = String(input);
            if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
              received = addNumericalSeparator(received);
            }
            received += "n";
          }
          msg += ` It must be ${range2}. Received ${received}`;
          return msg;
        },
        RangeError
      );
      function addNumericalSeparator(val) {
        let res = "";
        let i = val.length;
        const start = val[0] === "-" ? 1 : 0;
        for (; i >= start + 4; i -= 3) {
          res = `_${val.slice(i - 3, i)}${res}`;
        }
        return `${val.slice(0, i)}${res}`;
      }
      function checkBounds(buf, offset, byteLength2) {
        validateNumber(offset, "offset");
        if (buf[offset] === void 0 || buf[offset + byteLength2] === void 0) {
          boundsError(offset, buf.length - (byteLength2 + 1));
        }
      }
      function checkIntBI(value, min2, max2, buf, offset, byteLength2) {
        if (value > max2 || value < min2) {
          const n = typeof min2 === "bigint" ? "n" : "";
          let range2;
          if (byteLength2 > 3) {
            if (min2 === 0 || min2 === BigInt(0)) {
              range2 = `>= 0${n} and < 2${n} ** ${(byteLength2 + 1) * 8}${n}`;
            } else {
              range2 = `>= -(2${n} ** ${(byteLength2 + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength2 + 1) * 8 - 1}${n}`;
            }
          } else {
            range2 = `>= ${min2}${n} and <= ${max2}${n}`;
          }
          throw new errors.ERR_OUT_OF_RANGE("value", range2, value);
        }
        checkBounds(buf, offset, byteLength2);
      }
      function validateNumber(value, name) {
        if (typeof value !== "number") {
          throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
        }
      }
      function boundsError(value, length, type) {
        if (Math.floor(value) !== value) {
          validateNumber(value, type);
          throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
        }
        if (length < 0) {
          throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
        }
        throw new errors.ERR_OUT_OF_RANGE(
          type || "offset",
          `>= ${type ? 1 : 0} and <= ${length}`,
          value
        );
      }
      var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
      function base64clean(str) {
        str = str.split("=")[0];
        str = str.trim().replace(INVALID_BASE64_RE, "");
        if (str.length < 2)
          return "";
        while (str.length % 4 !== 0) {
          str = str + "=";
        }
        return str;
      }
      function utf8ToBytes(string, units) {
        units = units || Infinity;
        let codePoint;
        const length = string.length;
        let leadSurrogate = null;
        const bytes = [];
        for (let i = 0; i < length; ++i) {
          codePoint = string.charCodeAt(i);
          if (codePoint > 55295 && codePoint < 57344) {
            if (!leadSurrogate) {
              if (codePoint > 56319) {
                if ((units -= 3) > -1)
                  bytes.push(239, 191, 189);
                continue;
              } else if (i + 1 === length) {
                if ((units -= 3) > -1)
                  bytes.push(239, 191, 189);
                continue;
              }
              leadSurrogate = codePoint;
              continue;
            }
            if (codePoint < 56320) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              leadSurrogate = codePoint;
              continue;
            }
            codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
          } else if (leadSurrogate) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
          }
          leadSurrogate = null;
          if (codePoint < 128) {
            if ((units -= 1) < 0)
              break;
            bytes.push(codePoint);
          } else if (codePoint < 2048) {
            if ((units -= 2) < 0)
              break;
            bytes.push(
              codePoint >> 6 | 192,
              codePoint & 63 | 128
            );
          } else if (codePoint < 65536) {
            if ((units -= 3) < 0)
              break;
            bytes.push(
              codePoint >> 12 | 224,
              codePoint >> 6 & 63 | 128,
              codePoint & 63 | 128
            );
          } else if (codePoint < 1114112) {
            if ((units -= 4) < 0)
              break;
            bytes.push(
              codePoint >> 18 | 240,
              codePoint >> 12 & 63 | 128,
              codePoint >> 6 & 63 | 128,
              codePoint & 63 | 128
            );
          } else {
            throw new Error("Invalid code point");
          }
        }
        return bytes;
      }
      function asciiToBytes(str) {
        const byteArray = [];
        for (let i = 0; i < str.length; ++i) {
          byteArray.push(str.charCodeAt(i) & 255);
        }
        return byteArray;
      }
      function utf16leToBytes(str, units) {
        let c, hi, lo;
        const byteArray = [];
        for (let i = 0; i < str.length; ++i) {
          if ((units -= 2) < 0)
            break;
          c = str.charCodeAt(i);
          hi = c >> 8;
          lo = c % 256;
          byteArray.push(lo);
          byteArray.push(hi);
        }
        return byteArray;
      }
      function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
      }
      function blitBuffer(src, dst, offset, length) {
        let i;
        for (i = 0; i < length; ++i) {
          if (i + offset >= dst.length || i >= src.length)
            break;
          dst[i + offset] = src[i];
        }
        return i;
      }
      function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
      }
      function numberIsNaN(obj) {
        return obj !== obj;
      }
      var hexSliceLookupTable = function() {
        const alphabet = "0123456789abcdef";
        const table = new Array(256);
        for (let i = 0; i < 16; ++i) {
          const i16 = i * 16;
          for (let j = 0; j < 16; ++j) {
            table[i16 + j] = alphabet[i] + alphabet[j];
          }
        }
        return table;
      }();
      function defineBigIntMethod(fn) {
        return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
      }
      function BufferBigIntNotDefined() {
        throw new Error("BigInt not supported");
      }
    }
  });

  // node_modules/lower-case/lower-case.js
  var require_lower_case = __commonJS({
    "node_modules/lower-case/lower-case.js"(exports2, module2) {
      init_define_process();
      var LANGUAGES = {
        tr: {
          regexp: /\u0130|\u0049|\u0049\u0307/g,
          map: {
            "\u0130": "i",
            "I": "\u0131",
            "I\u0307": "i"
          }
        },
        az: {
          regexp: /[\u0130]/g,
          map: {
            "\u0130": "i",
            "I": "\u0131",
            "I\u0307": "i"
          }
        },
        lt: {
          regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
          map: {
            "I": "i\u0307",
            "J": "j\u0307",
            "\u012E": "\u012F\u0307",
            "\xCC": "i\u0307\u0300",
            "\xCD": "i\u0307\u0301",
            "\u0128": "i\u0307\u0303"
          }
        }
      };
      module2.exports = function(str, locale) {
        var lang = LANGUAGES[locale];
        str = str == null ? "" : String(str);
        if (lang) {
          str = str.replace(lang.regexp, function(m) {
            return lang.map[m];
          });
        }
        return str.toLowerCase();
      };
    }
  });

  // node_modules/no-case/vendor/non-word-regexp.js
  var require_non_word_regexp = __commonJS({
    "node_modules/no-case/vendor/non-word-regexp.js"(exports2, module2) {
      init_define_process();
      module2.exports = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g;
    }
  });

  // node_modules/no-case/vendor/camel-case-regexp.js
  var require_camel_case_regexp = __commonJS({
    "node_modules/no-case/vendor/camel-case-regexp.js"(exports2, module2) {
      init_define_process();
      module2.exports = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g;
    }
  });

  // node_modules/no-case/vendor/camel-case-upper-regexp.js
  var require_camel_case_upper_regexp = __commonJS({
    "node_modules/no-case/vendor/camel-case-upper-regexp.js"(exports2, module2) {
      init_define_process();
      module2.exports = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g;
    }
  });

  // node_modules/no-case/no-case.js
  var require_no_case = __commonJS({
    "node_modules/no-case/no-case.js"(exports2, module2) {
      init_define_process();
      var lowerCase2 = require_lower_case();
      var NON_WORD_REGEXP = require_non_word_regexp();
      var CAMEL_CASE_REGEXP = require_camel_case_regexp();
      var CAMEL_CASE_UPPER_REGEXP = require_camel_case_upper_regexp();
      module2.exports = function(str, locale, replacement) {
        if (str == null) {
          return "";
        }
        replacement = typeof replacement !== "string" ? " " : replacement;
        function replace2(match, index, value) {
          if (index === 0 || index === value.length - match.length) {
            return "";
          }
          return replacement;
        }
        str = String(str).replace(CAMEL_CASE_REGEXP, "$1 $2").replace(CAMEL_CASE_UPPER_REGEXP, "$1 $2").replace(NON_WORD_REGEXP, replace2);
        return lowerCase2(str, locale);
      };
    }
  });

  // node_modules/dot-case/dot-case.js
  var require_dot_case = __commonJS({
    "node_modules/dot-case/dot-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, ".");
      };
    }
  });

  // node_modules/upper-case/upper-case.js
  var require_upper_case = __commonJS({
    "node_modules/upper-case/upper-case.js"(exports2, module2) {
      init_define_process();
      var LANGUAGES = {
        tr: {
          regexp: /[\u0069]/g,
          map: {
            "i": "\u0130"
          }
        },
        az: {
          regexp: /[\u0069]/g,
          map: {
            "i": "\u0130"
          }
        },
        lt: {
          regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
          map: {
            "i\u0307": "I",
            "j\u0307": "J",
            "\u012F\u0307": "\u012E",
            "i\u0307\u0300": "\xCC",
            "i\u0307\u0301": "\xCD",
            "i\u0307\u0303": "\u0128"
          }
        }
      };
      module2.exports = function(str, locale) {
        var lang = LANGUAGES[locale];
        str = str == null ? "" : String(str);
        if (lang) {
          str = str.replace(lang.regexp, function(m) {
            return lang.map[m];
          });
        }
        return str.toUpperCase();
      };
    }
  });

  // node_modules/swap-case/swap-case.js
  var require_swap_case = __commonJS({
    "node_modules/swap-case/swap-case.js"(exports2, module2) {
      init_define_process();
      var upperCase2 = require_upper_case();
      var lowerCase2 = require_lower_case();
      module2.exports = function(str, locale) {
        if (str == null) {
          return "";
        }
        var result2 = "";
        for (var i = 0; i < str.length; i++) {
          var c = str[i];
          var u = upperCase2(c, locale);
          result2 += u === c ? lowerCase2(c, locale) : u;
        }
        return result2;
      };
    }
  });

  // node_modules/path-case/path-case.js
  var require_path_case = __commonJS({
    "node_modules/path-case/path-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "/");
      };
    }
  });

  // node_modules/camel-case/camel-case.js
  var require_camel_case = __commonJS({
    "node_modules/camel-case/camel-case.js"(exports2, module2) {
      init_define_process();
      var upperCase2 = require_upper_case();
      var noCase = require_no_case();
      module2.exports = function(value, locale, mergeNumbers) {
        var result2 = noCase(value, locale);
        if (!mergeNumbers) {
          result2 = result2.replace(/ (?=\d)/g, "_");
        }
        return result2.replace(/ (.)/g, function(m, $1) {
          return upperCase2($1, locale);
        });
      };
    }
  });

  // node_modules/snake-case/snake-case.js
  var require_snake_case = __commonJS({
    "node_modules/snake-case/snake-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "_");
      };
    }
  });

  // node_modules/title-case/title-case.js
  var require_title_case = __commonJS({
    "node_modules/title-case/title-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      var upperCase2 = require_upper_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale).replace(/^.| ./g, function(m) {
          return upperCase2(m, locale);
        });
      };
    }
  });

  // node_modules/param-case/param-case.js
  var require_param_case = __commonJS({
    "node_modules/param-case/param-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "-");
      };
    }
  });

  // node_modules/header-case/header-case.js
  var require_header_case = __commonJS({
    "node_modules/header-case/header-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      var upperCase2 = require_upper_case();
      module2.exports = function(value, locale) {
        return noCase(value, locale, "-").replace(/^.|-./g, function(m) {
          return upperCase2(m, locale);
        });
      };
    }
  });

  // node_modules/upper-case-first/upper-case-first.js
  var require_upper_case_first = __commonJS({
    "node_modules/upper-case-first/upper-case-first.js"(exports2, module2) {
      init_define_process();
      var upperCase2 = require_upper_case();
      module2.exports = function(str, locale) {
        if (str == null) {
          return "";
        }
        str = String(str);
        return upperCase2(str.charAt(0), locale) + str.substr(1);
      };
    }
  });

  // node_modules/pascal-case/pascal-case.js
  var require_pascal_case = __commonJS({
    "node_modules/pascal-case/pascal-case.js"(exports2, module2) {
      init_define_process();
      var camelCase2 = require_camel_case();
      var upperCaseFirst2 = require_upper_case_first();
      module2.exports = function(value, locale, mergeNumbers) {
        return upperCaseFirst2(camelCase2(value, locale, mergeNumbers), locale);
      };
    }
  });

  // node_modules/constant-case/constant-case.js
  var require_constant_case = __commonJS({
    "node_modules/constant-case/constant-case.js"(exports2, module2) {
      init_define_process();
      var upperCase2 = require_upper_case();
      var snakeCase2 = require_snake_case();
      module2.exports = function(value, locale) {
        return upperCase2(snakeCase2(value, locale), locale);
      };
    }
  });

  // node_modules/sentence-case/sentence-case.js
  var require_sentence_case = __commonJS({
    "node_modules/sentence-case/sentence-case.js"(exports2, module2) {
      init_define_process();
      var noCase = require_no_case();
      var upperCaseFirst2 = require_upper_case_first();
      module2.exports = function(value, locale) {
        return upperCaseFirst2(noCase(value, locale), locale);
      };
    }
  });

  // node_modules/is-upper-case/is-upper-case.js
  var require_is_upper_case = __commonJS({
    "node_modules/is-upper-case/is-upper-case.js"(exports2, module2) {
      init_define_process();
      var upperCase2 = require_upper_case();
      module2.exports = function(string, locale) {
        return upperCase2(string, locale) === string;
      };
    }
  });

  // node_modules/is-lower-case/is-lower-case.js
  var require_is_lower_case = __commonJS({
    "node_modules/is-lower-case/is-lower-case.js"(exports2, module2) {
      init_define_process();
      var lowerCase2 = require_lower_case();
      module2.exports = function(string, locale) {
        return lowerCase2(string, locale) === string;
      };
    }
  });

  // node_modules/lower-case-first/lower-case-first.js
  var require_lower_case_first = __commonJS({
    "node_modules/lower-case-first/lower-case-first.js"(exports2, module2) {
      init_define_process();
      var lowerCase2 = require_lower_case();
      module2.exports = function(str, locale) {
        if (str == null) {
          return "";
        }
        str = String(str);
        return lowerCase2(str.charAt(0), locale) + str.substr(1);
      };
    }
  });

  // node_modules/change-case/change-case.js
  var require_change_case = __commonJS({
    "node_modules/change-case/change-case.js"(exports2) {
      init_define_process();
      exports2.no = exports2.noCase = require_no_case();
      exports2.dot = exports2.dotCase = require_dot_case();
      exports2.swap = exports2.swapCase = require_swap_case();
      exports2.path = exports2.pathCase = require_path_case();
      exports2.upper = exports2.upperCase = require_upper_case();
      exports2.lower = exports2.lowerCase = require_lower_case();
      exports2.camel = exports2.camelCase = require_camel_case();
      exports2.snake = exports2.snakeCase = require_snake_case();
      exports2.title = exports2.titleCase = require_title_case();
      exports2.param = exports2.paramCase = require_param_case();
      exports2.kebab = exports2.kebabCase = exports2.paramCase;
      exports2.hyphen = exports2.hyphenCase = exports2.paramCase;
      exports2.header = exports2.headerCase = require_header_case();
      exports2.pascal = exports2.pascalCase = require_pascal_case();
      exports2.constant = exports2.constantCase = require_constant_case();
      exports2.sentence = exports2.sentenceCase = require_sentence_case();
      exports2.isUpper = exports2.isUpperCase = require_is_upper_case();
      exports2.isLower = exports2.isLowerCase = require_is_lower_case();
      exports2.ucFirst = exports2.upperCaseFirst = require_upper_case_first();
      exports2.lcFirst = exports2.lowerCaseFirst = require_lower_case_first();
    }
  });

  // node_modules/any-base/src/converter.js
  var require_converter = __commonJS({
    "node_modules/any-base/src/converter.js"(exports2, module2) {
      "use strict";
      init_define_process();
      function Converter(srcAlphabet, dstAlphabet) {
        if (!srcAlphabet || !dstAlphabet || !srcAlphabet.length || !dstAlphabet.length) {
          throw new Error("Bad alphabet");
        }
        this.srcAlphabet = srcAlphabet;
        this.dstAlphabet = dstAlphabet;
      }
      Converter.prototype.convert = function(number) {
        var i, divide2, newlen, numberMap = {}, fromBase = this.srcAlphabet.length, toBase = this.dstAlphabet.length, length = number.length, result2 = typeof number === "string" ? "" : [];
        if (!this.isValid(number)) {
          throw new Error('Number "' + number + '" contains of non-alphabetic digits (' + this.srcAlphabet + ")");
        }
        if (this.srcAlphabet === this.dstAlphabet) {
          return number;
        }
        for (i = 0; i < length; i++) {
          numberMap[i] = this.srcAlphabet.indexOf(number[i]);
        }
        do {
          divide2 = 0;
          newlen = 0;
          for (i = 0; i < length; i++) {
            divide2 = divide2 * fromBase + numberMap[i];
            if (divide2 >= toBase) {
              numberMap[newlen++] = parseInt(divide2 / toBase, 10);
              divide2 = divide2 % toBase;
            } else if (newlen > 0) {
              numberMap[newlen++] = 0;
            }
          }
          length = newlen;
          result2 = this.dstAlphabet.slice(divide2, divide2 + 1).concat(result2);
        } while (newlen !== 0);
        return result2;
      };
      Converter.prototype.isValid = function(number) {
        var i = 0;
        for (; i < number.length; ++i) {
          if (this.srcAlphabet.indexOf(number[i]) === -1) {
            return false;
          }
        }
        return true;
      };
      module2.exports = Converter;
    }
  });

  // node_modules/any-base/index.js
  var require_any_base = __commonJS({
    "node_modules/any-base/index.js"(exports2, module2) {
      init_define_process();
      var Converter = require_converter();
      function anyBase(srcAlphabet, dstAlphabet) {
        var converter = new Converter(srcAlphabet, dstAlphabet);
        return function(number) {
          return converter.convert(number);
        };
      }
      anyBase.BIN = "01";
      anyBase.OCT = "01234567";
      anyBase.DEC = "0123456789";
      anyBase.HEX = "0123456789abcdef";
      module2.exports = anyBase;
    }
  });

  // node_modules/uuid/lib/rng-browser.js
  var require_rng_browser = __commonJS({
    "node_modules/uuid/lib/rng-browser.js"(exports2, module2) {
      init_define_process();
      var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
      if (getRandomValues) {
        rnds8 = new Uint8Array(16);
        module2.exports = function whatwgRNG() {
          getRandomValues(rnds8);
          return rnds8;
        };
      } else {
        rnds = new Array(16);
        module2.exports = function mathRNG() {
          for (var i = 0, r; i < 16; i++) {
            if ((i & 3) === 0)
              r = Math.random() * 4294967296;
            rnds[i] = r >>> ((i & 3) << 3) & 255;
          }
          return rnds;
        };
      }
      var rnds8;
      var rnds;
    }
  });

  // node_modules/uuid/lib/bytesToUuid.js
  var require_bytesToUuid = __commonJS({
    "node_modules/uuid/lib/bytesToUuid.js"(exports2, module2) {
      init_define_process();
      var byteToHex = [];
      for (i = 0; i < 256; ++i) {
        byteToHex[i] = (i + 256).toString(16).substr(1);
      }
      var i;
      function bytesToUuid(buf, offset) {
        var i2 = offset || 0;
        var bth = byteToHex;
        return [
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          "-",
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]],
          bth[buf[i2++]]
        ].join("");
      }
      module2.exports = bytesToUuid;
    }
  });

  // node_modules/uuid/v4.js
  var require_v4 = __commonJS({
    "node_modules/uuid/v4.js"(exports2, module2) {
      init_define_process();
      var rng = require_rng_browser();
      var bytesToUuid = require_bytesToUuid();
      function v4(options, buf, offset) {
        var i = buf && offset || 0;
        if (typeof options == "string") {
          buf = options === "binary" ? new Array(16) : null;
          options = null;
        }
        options = options || {};
        var rnds = options.random || (options.rng || rng)();
        rnds[6] = rnds[6] & 15 | 64;
        rnds[8] = rnds[8] & 63 | 128;
        if (buf) {
          for (var ii = 0; ii < 16; ++ii) {
            buf[i + ii] = rnds[ii];
          }
        }
        return buf || bytesToUuid(rnds);
      }
      module2.exports = v4;
    }
  });

  // node_modules/short-uuid/index.js
  var require_short_uuid = __commonJS({
    "node_modules/short-uuid/index.js"(exports2, module2) {
      init_define_process();
      var anyBase = require_any_base();
      var uuidV4 = require_v4();
      var flickrBase58 = "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ";
      var cookieBase90 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%&'()*+-./:<=>?@[]^_`{|}~";
      var toFlickr;
      function shortenUUID(longId, translator) {
        return translator(longId.toLowerCase().replace(/-/g, ""));
      }
      function enlargeUUID(shortId, translator) {
        var uu1 = translator(shortId);
        var leftPad = "";
        var m;
        for (var i = 0, len = 32 - uu1.length; i < len; ++i) {
          leftPad += "0";
        }
        m = (leftPad + uu1).match(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/);
        return [m[1], m[2], m[3], m[4], m[5]].join("-");
      }
      module2.exports = function() {
        function MakeConvertor(toAlphabet) {
          var useAlphabet = toAlphabet || flickrBase58;
          var fromHex = anyBase(anyBase.HEX, useAlphabet);
          var toHex = anyBase(useAlphabet, anyBase.HEX);
          var generate4 = function() {
            return shortenUUID(uuidV4(), fromHex);
          };
          return {
            new: generate4,
            generate: generate4,
            uuid: uuidV4,
            fromUUID: function(uuid) {
              return shortenUUID(uuid, fromHex);
            },
            toUUID: function(shortUuid) {
              return enlargeUUID(shortUuid, toHex);
            },
            alphabet: useAlphabet
          };
        }
        MakeConvertor.constants = {
          flickrBase58,
          cookieBase90
        };
        MakeConvertor.uuid = uuidV4;
        MakeConvertor.generate = function() {
          if (!toFlickr) {
            toFlickr = anyBase(anyBase.HEX, flickrBase58);
          }
          return shortenUUID(uuidV4(), toFlickr);
        };
        return MakeConvertor;
      }();
    }
  });

  // node_modules/has-symbols/shams.js
  var require_shams = __commonJS({
    "node_modules/has-symbols/shams.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function hasSymbols() {
        if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
          return false;
        }
        if (typeof Symbol.iterator === "symbol") {
          return true;
        }
        var obj = {};
        var sym = Symbol("test");
        var symObj = Object(sym);
        if (typeof sym === "string") {
          return false;
        }
        if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
          return false;
        }
        if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
          return false;
        }
        var symVal = 42;
        obj[sym] = symVal;
        for (sym in obj) {
          return false;
        }
        if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
          return false;
        }
        if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
          return false;
        }
        var syms = Object.getOwnPropertySymbols(obj);
        if (syms.length !== 1 || syms[0] !== sym) {
          return false;
        }
        if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
          return false;
        }
        if (typeof Object.getOwnPropertyDescriptor === "function") {
          var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
          if (descriptor.value !== symVal || descriptor.enumerable !== true) {
            return false;
          }
        }
        return true;
      };
    }
  });

  // node_modules/has-tostringtag/shams.js
  var require_shams2 = __commonJS({
    "node_modules/has-tostringtag/shams.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var hasSymbols = require_shams();
      module2.exports = function hasToStringTagShams() {
        return hasSymbols() && !!Symbol.toStringTag;
      };
    }
  });

  // node_modules/has-symbols/index.js
  var require_has_symbols = __commonJS({
    "node_modules/has-symbols/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var origSymbol = typeof Symbol !== "undefined" && Symbol;
      var hasSymbolSham = require_shams();
      module2.exports = function hasNativeSymbols() {
        if (typeof origSymbol !== "function") {
          return false;
        }
        if (typeof Symbol !== "function") {
          return false;
        }
        if (typeof origSymbol("foo") !== "symbol") {
          return false;
        }
        if (typeof Symbol("bar") !== "symbol") {
          return false;
        }
        return hasSymbolSham();
      };
    }
  });

  // node_modules/function-bind/implementation.js
  var require_implementation = __commonJS({
    "node_modules/function-bind/implementation.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
      var slice2 = Array.prototype.slice;
      var toStr = Object.prototype.toString;
      var funcType = "[object Function]";
      module2.exports = function bind2(that) {
        var target = this;
        if (typeof target !== "function" || toStr.call(target) !== funcType) {
          throw new TypeError(ERROR_MESSAGE + target);
        }
        var args = slice2.call(arguments, 1);
        var bound;
        var binder = function() {
          if (this instanceof bound) {
            var result2 = target.apply(
              this,
              args.concat(slice2.call(arguments))
            );
            if (Object(result2) === result2) {
              return result2;
            }
            return this;
          } else {
            return target.apply(
              that,
              args.concat(slice2.call(arguments))
            );
          }
        };
        var boundLength = Math.max(0, target.length - args.length);
        var boundArgs = [];
        for (var i = 0; i < boundLength; i++) {
          boundArgs.push("$" + i);
        }
        bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
        if (target.prototype) {
          var Empty = function Empty2() {
          };
          Empty.prototype = target.prototype;
          bound.prototype = new Empty();
          Empty.prototype = null;
        }
        return bound;
      };
    }
  });

  // node_modules/function-bind/index.js
  var require_function_bind = __commonJS({
    "node_modules/function-bind/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var implementation = require_implementation();
      module2.exports = Function.prototype.bind || implementation;
    }
  });

  // node_modules/has/src/index.js
  var require_src = __commonJS({
    "node_modules/has/src/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var bind2 = require_function_bind();
      module2.exports = bind2.call(Function.call, Object.prototype.hasOwnProperty);
    }
  });

  // node_modules/get-intrinsic/index.js
  var require_get_intrinsic = __commonJS({
    "node_modules/get-intrinsic/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var undefined2;
      var $SyntaxError = SyntaxError;
      var $Function = Function;
      var $TypeError = TypeError;
      var getEvalledConstructor = function(expressionSyntax) {
        try {
          return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
        } catch (e) {
        }
      };
      var $gOPD = Object.getOwnPropertyDescriptor;
      if ($gOPD) {
        try {
          $gOPD({}, "");
        } catch (e) {
          $gOPD = null;
        }
      }
      var throwTypeError = function() {
        throw new $TypeError();
      };
      var ThrowTypeError = $gOPD ? function() {
        try {
          arguments.callee;
          return throwTypeError;
        } catch (calleeThrows) {
          try {
            return $gOPD(arguments, "callee").get;
          } catch (gOPDthrows) {
            return throwTypeError;
          }
        }
      }() : throwTypeError;
      var hasSymbols = require_has_symbols()();
      var getProto = Object.getPrototypeOf || function(x) {
        return x.__proto__;
      };
      var needsEval = {};
      var TypedArray = typeof Uint8Array === "undefined" ? undefined2 : getProto(Uint8Array);
      var INTRINSICS = {
        "%AggregateError%": typeof AggregateError === "undefined" ? undefined2 : AggregateError,
        "%Array%": Array,
        "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined2 : ArrayBuffer,
        "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined2,
        "%AsyncFromSyncIteratorPrototype%": undefined2,
        "%AsyncFunction%": needsEval,
        "%AsyncGenerator%": needsEval,
        "%AsyncGeneratorFunction%": needsEval,
        "%AsyncIteratorPrototype%": needsEval,
        "%Atomics%": typeof Atomics === "undefined" ? undefined2 : Atomics,
        "%BigInt%": typeof BigInt === "undefined" ? undefined2 : BigInt,
        "%Boolean%": Boolean,
        "%DataView%": typeof DataView === "undefined" ? undefined2 : DataView,
        "%Date%": Date,
        "%decodeURI%": decodeURI,
        "%decodeURIComponent%": decodeURIComponent,
        "%encodeURI%": encodeURI,
        "%encodeURIComponent%": encodeURIComponent,
        "%Error%": Error,
        "%eval%": eval,
        "%EvalError%": EvalError,
        "%Float32Array%": typeof Float32Array === "undefined" ? undefined2 : Float32Array,
        "%Float64Array%": typeof Float64Array === "undefined" ? undefined2 : Float64Array,
        "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined2 : FinalizationRegistry,
        "%Function%": $Function,
        "%GeneratorFunction%": needsEval,
        "%Int8Array%": typeof Int8Array === "undefined" ? undefined2 : Int8Array,
        "%Int16Array%": typeof Int16Array === "undefined" ? undefined2 : Int16Array,
        "%Int32Array%": typeof Int32Array === "undefined" ? undefined2 : Int32Array,
        "%isFinite%": isFinite,
        "%isNaN%": isNaN,
        "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined2,
        "%JSON%": typeof JSON === "object" ? JSON : undefined2,
        "%Map%": typeof Map === "undefined" ? undefined2 : Map,
        "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
        "%Math%": Math,
        "%Number%": Number,
        "%Object%": Object,
        "%parseFloat%": parseFloat,
        "%parseInt%": parseInt,
        "%Promise%": typeof Promise === "undefined" ? undefined2 : Promise,
        "%Proxy%": typeof Proxy === "undefined" ? undefined2 : Proxy,
        "%RangeError%": RangeError,
        "%ReferenceError%": ReferenceError,
        "%Reflect%": typeof Reflect === "undefined" ? undefined2 : Reflect,
        "%RegExp%": RegExp,
        "%Set%": typeof Set === "undefined" ? undefined2 : Set,
        "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
        "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined2 : SharedArrayBuffer,
        "%String%": String,
        "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined2,
        "%Symbol%": hasSymbols ? Symbol : undefined2,
        "%SyntaxError%": $SyntaxError,
        "%ThrowTypeError%": ThrowTypeError,
        "%TypedArray%": TypedArray,
        "%TypeError%": $TypeError,
        "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined2 : Uint8Array,
        "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined2 : Uint8ClampedArray,
        "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined2 : Uint16Array,
        "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined2 : Uint32Array,
        "%URIError%": URIError,
        "%WeakMap%": typeof WeakMap === "undefined" ? undefined2 : WeakMap,
        "%WeakRef%": typeof WeakRef === "undefined" ? undefined2 : WeakRef,
        "%WeakSet%": typeof WeakSet === "undefined" ? undefined2 : WeakSet
      };
      var doEval = function doEval2(name) {
        var value;
        if (name === "%AsyncFunction%") {
          value = getEvalledConstructor("async function () {}");
        } else if (name === "%GeneratorFunction%") {
          value = getEvalledConstructor("function* () {}");
        } else if (name === "%AsyncGeneratorFunction%") {
          value = getEvalledConstructor("async function* () {}");
        } else if (name === "%AsyncGenerator%") {
          var fn = doEval2("%AsyncGeneratorFunction%");
          if (fn) {
            value = fn.prototype;
          }
        } else if (name === "%AsyncIteratorPrototype%") {
          var gen = doEval2("%AsyncGenerator%");
          if (gen) {
            value = getProto(gen.prototype);
          }
        }
        INTRINSICS[name] = value;
        return value;
      };
      var LEGACY_ALIASES = {
        "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
        "%ArrayPrototype%": ["Array", "prototype"],
        "%ArrayProto_entries%": ["Array", "prototype", "entries"],
        "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
        "%ArrayProto_keys%": ["Array", "prototype", "keys"],
        "%ArrayProto_values%": ["Array", "prototype", "values"],
        "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
        "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
        "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
        "%BooleanPrototype%": ["Boolean", "prototype"],
        "%DataViewPrototype%": ["DataView", "prototype"],
        "%DatePrototype%": ["Date", "prototype"],
        "%ErrorPrototype%": ["Error", "prototype"],
        "%EvalErrorPrototype%": ["EvalError", "prototype"],
        "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
        "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
        "%FunctionPrototype%": ["Function", "prototype"],
        "%Generator%": ["GeneratorFunction", "prototype"],
        "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
        "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
        "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
        "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
        "%JSONParse%": ["JSON", "parse"],
        "%JSONStringify%": ["JSON", "stringify"],
        "%MapPrototype%": ["Map", "prototype"],
        "%NumberPrototype%": ["Number", "prototype"],
        "%ObjectPrototype%": ["Object", "prototype"],
        "%ObjProto_toString%": ["Object", "prototype", "toString"],
        "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
        "%PromisePrototype%": ["Promise", "prototype"],
        "%PromiseProto_then%": ["Promise", "prototype", "then"],
        "%Promise_all%": ["Promise", "all"],
        "%Promise_reject%": ["Promise", "reject"],
        "%Promise_resolve%": ["Promise", "resolve"],
        "%RangeErrorPrototype%": ["RangeError", "prototype"],
        "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
        "%RegExpPrototype%": ["RegExp", "prototype"],
        "%SetPrototype%": ["Set", "prototype"],
        "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
        "%StringPrototype%": ["String", "prototype"],
        "%SymbolPrototype%": ["Symbol", "prototype"],
        "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
        "%TypedArrayPrototype%": ["TypedArray", "prototype"],
        "%TypeErrorPrototype%": ["TypeError", "prototype"],
        "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
        "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
        "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
        "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
        "%URIErrorPrototype%": ["URIError", "prototype"],
        "%WeakMapPrototype%": ["WeakMap", "prototype"],
        "%WeakSetPrototype%": ["WeakSet", "prototype"]
      };
      var bind2 = require_function_bind();
      var hasOwn = require_src();
      var $concat = bind2.call(Function.call, Array.prototype.concat);
      var $spliceApply = bind2.call(Function.apply, Array.prototype.splice);
      var $replace = bind2.call(Function.call, String.prototype.replace);
      var $strSlice = bind2.call(Function.call, String.prototype.slice);
      var $exec = bind2.call(Function.call, RegExp.prototype.exec);
      var rePropName2 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
      var reEscapeChar2 = /\\(\\)?/g;
      var stringToPath2 = function stringToPath3(string) {
        var first = $strSlice(string, 0, 1);
        var last2 = $strSlice(string, -1);
        if (first === "%" && last2 !== "%") {
          throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
        } else if (last2 === "%" && first !== "%") {
          throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
        }
        var result2 = [];
        $replace(string, rePropName2, function(match, number, quote, subString) {
          result2[result2.length] = quote ? $replace(subString, reEscapeChar2, "$1") : number || match;
        });
        return result2;
      };
      var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
        var intrinsicName = name;
        var alias;
        if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
          alias = LEGACY_ALIASES[intrinsicName];
          intrinsicName = "%" + alias[0] + "%";
        }
        if (hasOwn(INTRINSICS, intrinsicName)) {
          var value = INTRINSICS[intrinsicName];
          if (value === needsEval) {
            value = doEval(intrinsicName);
          }
          if (typeof value === "undefined" && !allowMissing) {
            throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
          }
          return {
            alias,
            name: intrinsicName,
            value
          };
        }
        throw new $SyntaxError("intrinsic " + name + " does not exist!");
      };
      module2.exports = function GetIntrinsic(name, allowMissing) {
        if (typeof name !== "string" || name.length === 0) {
          throw new $TypeError("intrinsic name must be a non-empty string");
        }
        if (arguments.length > 1 && typeof allowMissing !== "boolean") {
          throw new $TypeError('"allowMissing" argument must be a boolean');
        }
        if ($exec(/^%?[^%]*%?$/, name) === null) {
          throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
        }
        var parts = stringToPath2(name);
        var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
        var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
        var intrinsicRealName = intrinsic.name;
        var value = intrinsic.value;
        var skipFurtherCaching = false;
        var alias = intrinsic.alias;
        if (alias) {
          intrinsicBaseName = alias[0];
          $spliceApply(parts, $concat([0, 1], alias));
        }
        for (var i = 1, isOwn = true; i < parts.length; i += 1) {
          var part = parts[i];
          var first = $strSlice(part, 0, 1);
          var last2 = $strSlice(part, -1);
          if ((first === '"' || first === "'" || first === "`" || (last2 === '"' || last2 === "'" || last2 === "`")) && first !== last2) {
            throw new $SyntaxError("property names with quotes must have matching quotes");
          }
          if (part === "constructor" || !isOwn) {
            skipFurtherCaching = true;
          }
          intrinsicBaseName += "." + part;
          intrinsicRealName = "%" + intrinsicBaseName + "%";
          if (hasOwn(INTRINSICS, intrinsicRealName)) {
            value = INTRINSICS[intrinsicRealName];
          } else if (value != null) {
            if (!(part in value)) {
              if (!allowMissing) {
                throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
              }
              return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
              var desc = $gOPD(value, part);
              isOwn = !!desc;
              if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
                value = desc.get;
              } else {
                value = value[part];
              }
            } else {
              isOwn = hasOwn(value, part);
              value = value[part];
            }
            if (isOwn && !skipFurtherCaching) {
              INTRINSICS[intrinsicRealName] = value;
            }
          }
        }
        return value;
      };
    }
  });

  // node_modules/call-bind/index.js
  var require_call_bind = __commonJS({
    "node_modules/call-bind/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var bind2 = require_function_bind();
      var GetIntrinsic = require_get_intrinsic();
      var $apply = GetIntrinsic("%Function.prototype.apply%");
      var $call = GetIntrinsic("%Function.prototype.call%");
      var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind2.call($call, $apply);
      var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
      var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
      var $max = GetIntrinsic("%Math.max%");
      if ($defineProperty) {
        try {
          $defineProperty({}, "a", { value: 1 });
        } catch (e) {
          $defineProperty = null;
        }
      }
      module2.exports = function callBind(originalFunction) {
        var func = $reflectApply(bind2, $call, arguments);
        if ($gOPD && $defineProperty) {
          var desc = $gOPD(func, "length");
          if (desc.configurable) {
            $defineProperty(
              func,
              "length",
              { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
            );
          }
        }
        return func;
      };
      var applyBind = function applyBind2() {
        return $reflectApply(bind2, $apply, arguments);
      };
      if ($defineProperty) {
        $defineProperty(module2.exports, "apply", { value: applyBind });
      } else {
        module2.exports.apply = applyBind;
      }
    }
  });

  // node_modules/call-bind/callBound.js
  var require_callBound = __commonJS({
    "node_modules/call-bind/callBound.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var GetIntrinsic = require_get_intrinsic();
      var callBind = require_call_bind();
      var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
      module2.exports = function callBoundIntrinsic(name, allowMissing) {
        var intrinsic = GetIntrinsic(name, !!allowMissing);
        if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
          return callBind(intrinsic);
        }
        return intrinsic;
      };
    }
  });

  // node_modules/is-arguments/index.js
  var require_is_arguments = __commonJS({
    "node_modules/is-arguments/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var hasToStringTag = require_shams2()();
      var callBound = require_callBound();
      var $toString = callBound("Object.prototype.toString");
      var isStandardArguments = function isArguments2(value) {
        if (hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) {
          return false;
        }
        return $toString(value) === "[object Arguments]";
      };
      var isLegacyArguments = function isArguments2(value) {
        if (isStandardArguments(value)) {
          return true;
        }
        return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
      };
      var supportsStandardArguments = function() {
        return isStandardArguments(arguments);
      }();
      isStandardArguments.isLegacyArguments = isLegacyArguments;
      module2.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
    }
  });

  // node_modules/is-generator-function/index.js
  var require_is_generator_function = __commonJS({
    "node_modules/is-generator-function/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var toStr = Object.prototype.toString;
      var fnToStr = Function.prototype.toString;
      var isFnRegex = /^\s*(?:function)?\*/;
      var hasToStringTag = require_shams2()();
      var getProto = Object.getPrototypeOf;
      var getGeneratorFunc = function() {
        if (!hasToStringTag) {
          return false;
        }
        try {
          return Function("return function*() {}")();
        } catch (e) {
        }
      };
      var GeneratorFunction;
      module2.exports = function isGeneratorFunction(fn) {
        if (typeof fn !== "function") {
          return false;
        }
        if (isFnRegex.test(fnToStr.call(fn))) {
          return true;
        }
        if (!hasToStringTag) {
          var str = toStr.call(fn);
          return str === "[object GeneratorFunction]";
        }
        if (!getProto) {
          return false;
        }
        if (typeof GeneratorFunction === "undefined") {
          var generatorFunc = getGeneratorFunc();
          GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
        }
        return getProto(fn) === GeneratorFunction;
      };
    }
  });

  // node_modules/is-callable/index.js
  var require_is_callable = __commonJS({
    "node_modules/is-callable/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var fnToStr = Function.prototype.toString;
      var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
      var badArrayLike;
      var isCallableMarker;
      if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") {
        try {
          badArrayLike = Object.defineProperty({}, "length", {
            get: function() {
              throw isCallableMarker;
            }
          });
          isCallableMarker = {};
          reflectApply(function() {
            throw 42;
          }, null, badArrayLike);
        } catch (_) {
          if (_ !== isCallableMarker) {
            reflectApply = null;
          }
        }
      } else {
        reflectApply = null;
      }
      var constructorRegex = /^\s*class\b/;
      var isES6ClassFn = function isES6ClassFunction(value) {
        try {
          var fnStr = fnToStr.call(value);
          return constructorRegex.test(fnStr);
        } catch (e) {
          return false;
        }
      };
      var tryFunctionObject = function tryFunctionToStr(value) {
        try {
          if (isES6ClassFn(value)) {
            return false;
          }
          fnToStr.call(value);
          return true;
        } catch (e) {
          return false;
        }
      };
      var toStr = Object.prototype.toString;
      var objectClass = "[object Object]";
      var fnClass = "[object Function]";
      var genClass = "[object GeneratorFunction]";
      var ddaClass = "[object HTMLAllCollection]";
      var ddaClass2 = "[object HTML document.all class]";
      var ddaClass3 = "[object HTMLCollection]";
      var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag;
      var isIE68 = !(0 in [,]);
      var isDDA = function isDocumentDotAll() {
        return false;
      };
      if (typeof document === "object") {
        all = document.all;
        if (toStr.call(all) === toStr.call(document.all)) {
          isDDA = function isDocumentDotAll(value) {
            if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) {
              try {
                var str = toStr.call(value);
                return (str === ddaClass || str === ddaClass2 || str === ddaClass3 || str === objectClass) && value("") == null;
              } catch (e) {
              }
            }
            return false;
          };
        }
      }
      var all;
      module2.exports = reflectApply ? function isCallable(value) {
        if (isDDA(value)) {
          return true;
        }
        if (!value) {
          return false;
        }
        if (typeof value !== "function" && typeof value !== "object") {
          return false;
        }
        try {
          reflectApply(value, null, badArrayLike);
        } catch (e) {
          if (e !== isCallableMarker) {
            return false;
          }
        }
        return !isES6ClassFn(value) && tryFunctionObject(value);
      } : function isCallable(value) {
        if (isDDA(value)) {
          return true;
        }
        if (!value) {
          return false;
        }
        if (typeof value !== "function" && typeof value !== "object") {
          return false;
        }
        if (hasToStringTag) {
          return tryFunctionObject(value);
        }
        if (isES6ClassFn(value)) {
          return false;
        }
        var strClass = toStr.call(value);
        if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) {
          return false;
        }
        return tryFunctionObject(value);
      };
    }
  });

  // node_modules/for-each/index.js
  var require_for_each = __commonJS({
    "node_modules/for-each/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isCallable = require_is_callable();
      var toStr = Object.prototype.toString;
      var hasOwnProperty26 = Object.prototype.hasOwnProperty;
      var forEachArray = function forEachArray2(array, iterator, receiver) {
        for (var i = 0, len = array.length; i < len; i++) {
          if (hasOwnProperty26.call(array, i)) {
            if (receiver == null) {
              iterator(array[i], i, array);
            } else {
              iterator.call(receiver, array[i], i, array);
            }
          }
        }
      };
      var forEachString = function forEachString2(string, iterator, receiver) {
        for (var i = 0, len = string.length; i < len; i++) {
          if (receiver == null) {
            iterator(string.charAt(i), i, string);
          } else {
            iterator.call(receiver, string.charAt(i), i, string);
          }
        }
      };
      var forEachObject = function forEachObject2(object, iterator, receiver) {
        for (var k in object) {
          if (hasOwnProperty26.call(object, k)) {
            if (receiver == null) {
              iterator(object[k], k, object);
            } else {
              iterator.call(receiver, object[k], k, object);
            }
          }
        }
      };
      var forEach2 = function forEach3(list, iterator, thisArg) {
        if (!isCallable(iterator)) {
          throw new TypeError("iterator must be a function");
        }
        var receiver;
        if (arguments.length >= 3) {
          receiver = thisArg;
        }
        if (toStr.call(list) === "[object Array]") {
          forEachArray(list, iterator, receiver);
        } else if (typeof list === "string") {
          forEachString(list, iterator, receiver);
        } else {
          forEachObject(list, iterator, receiver);
        }
      };
      module2.exports = forEach2;
    }
  });

  // node_modules/available-typed-arrays/index.js
  var require_available_typed_arrays = __commonJS({
    "node_modules/available-typed-arrays/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var possibleNames = [
        "BigInt64Array",
        "BigUint64Array",
        "Float32Array",
        "Float64Array",
        "Int16Array",
        "Int32Array",
        "Int8Array",
        "Uint16Array",
        "Uint32Array",
        "Uint8Array",
        "Uint8ClampedArray"
      ];
      var g = typeof globalThis === "undefined" ? global : globalThis;
      module2.exports = function availableTypedArrays() {
        var out = [];
        for (var i = 0; i < possibleNames.length; i++) {
          if (typeof g[possibleNames[i]] === "function") {
            out[out.length] = possibleNames[i];
          }
        }
        return out;
      };
    }
  });

  // node_modules/gopd/index.js
  var require_gopd = __commonJS({
    "node_modules/gopd/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var GetIntrinsic = require_get_intrinsic();
      var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
      if ($gOPD) {
        try {
          $gOPD([], "length");
        } catch (e) {
          $gOPD = null;
        }
      }
      module2.exports = $gOPD;
    }
  });

  // node_modules/is-typed-array/index.js
  var require_is_typed_array = __commonJS({
    "node_modules/is-typed-array/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var forEach2 = require_for_each();
      var availableTypedArrays = require_available_typed_arrays();
      var callBound = require_callBound();
      var $toString = callBound("Object.prototype.toString");
      var hasToStringTag = require_shams2()();
      var gOPD = require_gopd();
      var g = typeof globalThis === "undefined" ? global : globalThis;
      var typedArrays = availableTypedArrays();
      var $indexOf = callBound("Array.prototype.indexOf", true) || function indexOf2(array, value) {
        for (var i = 0; i < array.length; i += 1) {
          if (array[i] === value) {
            return i;
          }
        }
        return -1;
      };
      var $slice = callBound("String.prototype.slice");
      var toStrTags = {};
      var getPrototypeOf = Object.getPrototypeOf;
      if (hasToStringTag && gOPD && getPrototypeOf) {
        forEach2(typedArrays, function(typedArray) {
          var arr = new g[typedArray]();
          if (Symbol.toStringTag in arr) {
            var proto = getPrototypeOf(arr);
            var descriptor = gOPD(proto, Symbol.toStringTag);
            if (!descriptor) {
              var superProto = getPrototypeOf(proto);
              descriptor = gOPD(superProto, Symbol.toStringTag);
            }
            toStrTags[typedArray] = descriptor.get;
          }
        });
      }
      var tryTypedArrays = function tryAllTypedArrays(value) {
        var anyTrue = false;
        forEach2(toStrTags, function(getter, typedArray) {
          if (!anyTrue) {
            try {
              anyTrue = getter.call(value) === typedArray;
            } catch (e) {
            }
          }
        });
        return anyTrue;
      };
      module2.exports = function isTypedArray2(value) {
        if (!value || typeof value !== "object") {
          return false;
        }
        if (!hasToStringTag || !(Symbol.toStringTag in value)) {
          var tag = $slice($toString(value), 8, -1);
          return $indexOf(typedArrays, tag) > -1;
        }
        if (!gOPD) {
          return false;
        }
        return tryTypedArrays(value);
      };
    }
  });

  // node_modules/which-typed-array/index.js
  var require_which_typed_array = __commonJS({
    "node_modules/which-typed-array/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var forEach2 = require_for_each();
      var availableTypedArrays = require_available_typed_arrays();
      var callBound = require_callBound();
      var gOPD = require_gopd();
      var $toString = callBound("Object.prototype.toString");
      var hasToStringTag = require_shams2()();
      var g = typeof globalThis === "undefined" ? global : globalThis;
      var typedArrays = availableTypedArrays();
      var $slice = callBound("String.prototype.slice");
      var toStrTags = {};
      var getPrototypeOf = Object.getPrototypeOf;
      if (hasToStringTag && gOPD && getPrototypeOf) {
        forEach2(typedArrays, function(typedArray) {
          if (typeof g[typedArray] === "function") {
            var arr = new g[typedArray]();
            if (Symbol.toStringTag in arr) {
              var proto = getPrototypeOf(arr);
              var descriptor = gOPD(proto, Symbol.toStringTag);
              if (!descriptor) {
                var superProto = getPrototypeOf(proto);
                descriptor = gOPD(superProto, Symbol.toStringTag);
              }
              toStrTags[typedArray] = descriptor.get;
            }
          }
        });
      }
      var tryTypedArrays = function tryAllTypedArrays(value) {
        var foundName = false;
        forEach2(toStrTags, function(getter, typedArray) {
          if (!foundName) {
            try {
              var name = getter.call(value);
              if (name === typedArray) {
                foundName = name;
              }
            } catch (e) {
            }
          }
        });
        return foundName;
      };
      var isTypedArray2 = require_is_typed_array();
      module2.exports = function whichTypedArray(value) {
        if (!isTypedArray2(value)) {
          return false;
        }
        if (!hasToStringTag || !(Symbol.toStringTag in value)) {
          return $slice($toString(value), 8, -1);
        }
        return tryTypedArrays(value);
      };
    }
  });

  // node_modules/util/support/types.js
  var require_types = __commonJS({
    "node_modules/util/support/types.js"(exports2) {
      "use strict";
      init_define_process();
      var isArgumentsObject = require_is_arguments();
      var isGeneratorFunction = require_is_generator_function();
      var whichTypedArray = require_which_typed_array();
      var isTypedArray2 = require_is_typed_array();
      function uncurryThis(f) {
        return f.call.bind(f);
      }
      var BigIntSupported = typeof BigInt !== "undefined";
      var SymbolSupported = typeof Symbol !== "undefined";
      var ObjectToString = uncurryThis(Object.prototype.toString);
      var numberValue = uncurryThis(Number.prototype.valueOf);
      var stringValue = uncurryThis(String.prototype.valueOf);
      var booleanValue = uncurryThis(Boolean.prototype.valueOf);
      if (BigIntSupported) {
        bigIntValue = uncurryThis(BigInt.prototype.valueOf);
      }
      var bigIntValue;
      if (SymbolSupported) {
        symbolValue = uncurryThis(Symbol.prototype.valueOf);
      }
      var symbolValue;
      function checkBoxedPrimitive(value, prototypeValueOf) {
        if (typeof value !== "object") {
          return false;
        }
        try {
          prototypeValueOf(value);
          return true;
        } catch (e) {
          return false;
        }
      }
      exports2.isArgumentsObject = isArgumentsObject;
      exports2.isGeneratorFunction = isGeneratorFunction;
      exports2.isTypedArray = isTypedArray2;
      function isPromise(input) {
        return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
      }
      exports2.isPromise = isPromise;
      function isArrayBufferView(value) {
        if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
          return ArrayBuffer.isView(value);
        }
        return isTypedArray2(value) || isDataView(value);
      }
      exports2.isArrayBufferView = isArrayBufferView;
      function isUint8Array(value) {
        return whichTypedArray(value) === "Uint8Array";
      }
      exports2.isUint8Array = isUint8Array;
      function isUint8ClampedArray(value) {
        return whichTypedArray(value) === "Uint8ClampedArray";
      }
      exports2.isUint8ClampedArray = isUint8ClampedArray;
      function isUint16Array(value) {
        return whichTypedArray(value) === "Uint16Array";
      }
      exports2.isUint16Array = isUint16Array;
      function isUint32Array(value) {
        return whichTypedArray(value) === "Uint32Array";
      }
      exports2.isUint32Array = isUint32Array;
      function isInt8Array(value) {
        return whichTypedArray(value) === "Int8Array";
      }
      exports2.isInt8Array = isInt8Array;
      function isInt16Array(value) {
        return whichTypedArray(value) === "Int16Array";
      }
      exports2.isInt16Array = isInt16Array;
      function isInt32Array(value) {
        return whichTypedArray(value) === "Int32Array";
      }
      exports2.isInt32Array = isInt32Array;
      function isFloat32Array(value) {
        return whichTypedArray(value) === "Float32Array";
      }
      exports2.isFloat32Array = isFloat32Array;
      function isFloat64Array(value) {
        return whichTypedArray(value) === "Float64Array";
      }
      exports2.isFloat64Array = isFloat64Array;
      function isBigInt64Array(value) {
        return whichTypedArray(value) === "BigInt64Array";
      }
      exports2.isBigInt64Array = isBigInt64Array;
      function isBigUint64Array(value) {
        return whichTypedArray(value) === "BigUint64Array";
      }
      exports2.isBigUint64Array = isBigUint64Array;
      function isMapToString(value) {
        return ObjectToString(value) === "[object Map]";
      }
      isMapToString.working = typeof Map !== "undefined" && isMapToString(/* @__PURE__ */ new Map());
      function isMap2(value) {
        if (typeof Map === "undefined") {
          return false;
        }
        return isMapToString.working ? isMapToString(value) : value instanceof Map;
      }
      exports2.isMap = isMap2;
      function isSetToString(value) {
        return ObjectToString(value) === "[object Set]";
      }
      isSetToString.working = typeof Set !== "undefined" && isSetToString(/* @__PURE__ */ new Set());
      function isSet2(value) {
        if (typeof Set === "undefined") {
          return false;
        }
        return isSetToString.working ? isSetToString(value) : value instanceof Set;
      }
      exports2.isSet = isSet2;
      function isWeakMapToString(value) {
        return ObjectToString(value) === "[object WeakMap]";
      }
      isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(/* @__PURE__ */ new WeakMap());
      function isWeakMap2(value) {
        if (typeof WeakMap === "undefined") {
          return false;
        }
        return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
      }
      exports2.isWeakMap = isWeakMap2;
      function isWeakSetToString(value) {
        return ObjectToString(value) === "[object WeakSet]";
      }
      isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(/* @__PURE__ */ new WeakSet());
      function isWeakSet2(value) {
        return isWeakSetToString(value);
      }
      exports2.isWeakSet = isWeakSet2;
      function isArrayBufferToString(value) {
        return ObjectToString(value) === "[object ArrayBuffer]";
      }
      isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
      function isArrayBuffer2(value) {
        if (typeof ArrayBuffer === "undefined") {
          return false;
        }
        return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
      }
      exports2.isArrayBuffer = isArrayBuffer2;
      function isDataViewToString(value) {
        return ObjectToString(value) === "[object DataView]";
      }
      isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
      function isDataView(value) {
        if (typeof DataView === "undefined") {
          return false;
        }
        return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
      }
      exports2.isDataView = isDataView;
      var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : void 0;
      function isSharedArrayBufferToString(value) {
        return ObjectToString(value) === "[object SharedArrayBuffer]";
      }
      function isSharedArrayBuffer(value) {
        if (typeof SharedArrayBufferCopy === "undefined") {
          return false;
        }
        if (typeof isSharedArrayBufferToString.working === "undefined") {
          isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
        }
        return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
      }
      exports2.isSharedArrayBuffer = isSharedArrayBuffer;
      function isAsyncFunction(value) {
        return ObjectToString(value) === "[object AsyncFunction]";
      }
      exports2.isAsyncFunction = isAsyncFunction;
      function isMapIterator(value) {
        return ObjectToString(value) === "[object Map Iterator]";
      }
      exports2.isMapIterator = isMapIterator;
      function isSetIterator(value) {
        return ObjectToString(value) === "[object Set Iterator]";
      }
      exports2.isSetIterator = isSetIterator;
      function isGeneratorObject(value) {
        return ObjectToString(value) === "[object Generator]";
      }
      exports2.isGeneratorObject = isGeneratorObject;
      function isWebAssemblyCompiledModule(value) {
        return ObjectToString(value) === "[object WebAssembly.Module]";
      }
      exports2.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
      function isNumberObject(value) {
        return checkBoxedPrimitive(value, numberValue);
      }
      exports2.isNumberObject = isNumberObject;
      function isStringObject(value) {
        return checkBoxedPrimitive(value, stringValue);
      }
      exports2.isStringObject = isStringObject;
      function isBooleanObject(value) {
        return checkBoxedPrimitive(value, booleanValue);
      }
      exports2.isBooleanObject = isBooleanObject;
      function isBigIntObject(value) {
        return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
      }
      exports2.isBigIntObject = isBigIntObject;
      function isSymbolObject(value) {
        return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
      }
      exports2.isSymbolObject = isSymbolObject;
      function isBoxedPrimitive(value) {
        return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
      }
      exports2.isBoxedPrimitive = isBoxedPrimitive;
      function isAnyArrayBuffer(value) {
        return typeof Uint8Array !== "undefined" && (isArrayBuffer2(value) || isSharedArrayBuffer(value));
      }
      exports2.isAnyArrayBuffer = isAnyArrayBuffer;
      ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(method2) {
        Object.defineProperty(exports2, method2, {
          enumerable: false,
          value: function() {
            throw new Error(method2 + " is not supported in userland");
          }
        });
      });
    }
  });

  // node_modules/util/support/isBufferBrowser.js
  var require_isBufferBrowser = __commonJS({
    "node_modules/util/support/isBufferBrowser.js"(exports2, module2) {
      init_define_process();
      module2.exports = function isBuffer2(arg) {
        return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
      };
    }
  });

  // node_modules/inherits/inherits_browser.js
  var require_inherits_browser = __commonJS({
    "node_modules/inherits/inherits_browser.js"(exports2, module2) {
      init_define_process();
      if (typeof Object.create === "function") {
        module2.exports = function inherits(ctor, superCtor) {
          if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
              constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
              }
            });
          }
        };
      } else {
        module2.exports = function inherits(ctor, superCtor) {
          if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {
            };
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
          }
        };
      }
    }
  });

  // node_modules/util/util.js
  var require_util = __commonJS({
    "node_modules/util/util.js"(exports2) {
      init_define_process();
      var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors2(obj) {
        var keys2 = Object.keys(obj);
        var descriptors = {};
        for (var i = 0; i < keys2.length; i++) {
          descriptors[keys2[i]] = Object.getOwnPropertyDescriptor(obj, keys2[i]);
        }
        return descriptors;
      };
      var formatRegExp = /%[sdj%]/g;
      exports2.format = function(f) {
        if (!isString2(f)) {
          var objects = [];
          for (var i = 0; i < arguments.length; i++) {
            objects.push(inspect(arguments[i]));
          }
          return objects.join(" ");
        }
        var i = 1;
        var args = arguments;
        var len = args.length;
        var str = String(f).replace(formatRegExp, function(x2) {
          if (x2 === "%%")
            return "%";
          if (i >= len)
            return x2;
          switch (x2) {
            case "%s":
              return String(args[i++]);
            case "%d":
              return Number(args[i++]);
            case "%j":
              try {
                return JSON.stringify(args[i++]);
              } catch (_) {
                return "[Circular]";
              }
            default:
              return x2;
          }
        });
        for (var x = args[i]; i < len; x = args[++i]) {
          if (isNull2(x) || !isObject2(x)) {
            str += " " + x;
          } else {
            str += " " + inspect(x);
          }
        }
        return str;
      };
      exports2.deprecate = function(fn, msg) {
        if (typeof define_process_default !== "undefined" && define_process_default.noDeprecation === true) {
          return fn;
        }
        if (typeof define_process_default === "undefined") {
          return function() {
            return exports2.deprecate(fn, msg).apply(this, arguments);
          };
        }
        var warned = false;
        function deprecated() {
          if (!warned) {
            if (define_process_default.throwDeprecation) {
              throw new Error(msg);
            } else if (define_process_default.traceDeprecation) {
              console.trace(msg);
            } else {
              console.error(msg);
            }
            warned = true;
          }
          return fn.apply(this, arguments);
        }
        return deprecated;
      };
      var debugs = {};
      var debugEnvRegex = /^$/;
      if (define_process_default.env.NODE_DEBUG) {
        debugEnv = define_process_default.env.NODE_DEBUG;
        debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase();
        debugEnvRegex = new RegExp("^" + debugEnv + "$", "i");
      }
      var debugEnv;
      exports2.debuglog = function(set2) {
        set2 = set2.toUpperCase();
        if (!debugs[set2]) {
          if (debugEnvRegex.test(set2)) {
            var pid = define_process_default.pid;
            debugs[set2] = function() {
              var msg = exports2.format.apply(exports2, arguments);
              console.error("%s %d: %s", set2, pid, msg);
            };
          } else {
            debugs[set2] = function() {
            };
          }
        }
        return debugs[set2];
      };
      function inspect(obj, opts) {
        var ctx = {
          seen: [],
          stylize: stylizeNoColor
        };
        if (arguments.length >= 3)
          ctx.depth = arguments[2];
        if (arguments.length >= 4)
          ctx.colors = arguments[3];
        if (isBoolean2(opts)) {
          ctx.showHidden = opts;
        } else if (opts) {
          exports2._extend(ctx, opts);
        }
        if (isUndefined2(ctx.showHidden))
          ctx.showHidden = false;
        if (isUndefined2(ctx.depth))
          ctx.depth = 2;
        if (isUndefined2(ctx.colors))
          ctx.colors = false;
        if (isUndefined2(ctx.customInspect))
          ctx.customInspect = true;
        if (ctx.colors)
          ctx.stylize = stylizeWithColor;
        return formatValue(ctx, obj, ctx.depth);
      }
      exports2.inspect = inspect;
      inspect.colors = {
        "bold": [1, 22],
        "italic": [3, 23],
        "underline": [4, 24],
        "inverse": [7, 27],
        "white": [37, 39],
        "grey": [90, 39],
        "black": [30, 39],
        "blue": [34, 39],
        "cyan": [36, 39],
        "green": [32, 39],
        "magenta": [35, 39],
        "red": [31, 39],
        "yellow": [33, 39]
      };
      inspect.styles = {
        "special": "cyan",
        "number": "yellow",
        "boolean": "yellow",
        "undefined": "grey",
        "null": "bold",
        "string": "green",
        "date": "magenta",
        "regexp": "red"
      };
      function stylizeWithColor(str, styleType) {
        var style = inspect.styles[styleType];
        if (style) {
          return "\x1B[" + inspect.colors[style][0] + "m" + str + "\x1B[" + inspect.colors[style][1] + "m";
        } else {
          return str;
        }
      }
      function stylizeNoColor(str, styleType) {
        return str;
      }
      function arrayToHash(array) {
        var hash = {};
        array.forEach(function(val, idx) {
          hash[val] = true;
        });
        return hash;
      }
      function formatValue(ctx, value, recurseTimes) {
        if (ctx.customInspect && value && isFunction2(value.inspect) && value.inspect !== exports2.inspect && !(value.constructor && value.constructor.prototype === value)) {
          var ret = value.inspect(recurseTimes, ctx);
          if (!isString2(ret)) {
            ret = formatValue(ctx, ret, recurseTimes);
          }
          return ret;
        }
        var primitive = formatPrimitive(ctx, value);
        if (primitive) {
          return primitive;
        }
        var keys2 = Object.keys(value);
        var visibleKeys = arrayToHash(keys2);
        if (ctx.showHidden) {
          keys2 = Object.getOwnPropertyNames(value);
        }
        if (isError2(value) && (keys2.indexOf("message") >= 0 || keys2.indexOf("description") >= 0)) {
          return formatError(value);
        }
        if (keys2.length === 0) {
          if (isFunction2(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
          }
          if (isRegExp2(value)) {
            return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
          }
          if (isDate2(value)) {
            return ctx.stylize(Date.prototype.toString.call(value), "date");
          }
          if (isError2(value)) {
            return formatError(value);
          }
        }
        var base = "", array = false, braces = ["{", "}"];
        if (isArray2(value)) {
          array = true;
          braces = ["[", "]"];
        }
        if (isFunction2(value)) {
          var n = value.name ? ": " + value.name : "";
          base = " [Function" + n + "]";
        }
        if (isRegExp2(value)) {
          base = " " + RegExp.prototype.toString.call(value);
        }
        if (isDate2(value)) {
          base = " " + Date.prototype.toUTCString.call(value);
        }
        if (isError2(value)) {
          base = " " + formatError(value);
        }
        if (keys2.length === 0 && (!array || value.length == 0)) {
          return braces[0] + base + braces[1];
        }
        if (recurseTimes < 0) {
          if (isRegExp2(value)) {
            return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
          } else {
            return ctx.stylize("[Object]", "special");
          }
        }
        ctx.seen.push(value);
        var output;
        if (array) {
          output = formatArray(ctx, value, recurseTimes, visibleKeys, keys2);
        } else {
          output = keys2.map(function(key) {
            return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
          });
        }
        ctx.seen.pop();
        return reduceToSingleString(output, base, braces);
      }
      function formatPrimitive(ctx, value) {
        if (isUndefined2(value))
          return ctx.stylize("undefined", "undefined");
        if (isString2(value)) {
          var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return ctx.stylize(simple, "string");
        }
        if (isNumber2(value))
          return ctx.stylize("" + value, "number");
        if (isBoolean2(value))
          return ctx.stylize("" + value, "boolean");
        if (isNull2(value))
          return ctx.stylize("null", "null");
      }
      function formatError(value) {
        return "[" + Error.prototype.toString.call(value) + "]";
      }
      function formatArray(ctx, value, recurseTimes, visibleKeys, keys2) {
        var output = [];
        for (var i = 0, l = value.length; i < l; ++i) {
          if (hasOwnProperty26(value, String(i))) {
            output.push(formatProperty(
              ctx,
              value,
              recurseTimes,
              visibleKeys,
              String(i),
              true
            ));
          } else {
            output.push("");
          }
        }
        keys2.forEach(function(key) {
          if (!key.match(/^\d+$/)) {
            output.push(formatProperty(
              ctx,
              value,
              recurseTimes,
              visibleKeys,
              key,
              true
            ));
          }
        });
        return output;
      }
      function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
        var name, str, desc;
        desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
        if (desc.get) {
          if (desc.set) {
            str = ctx.stylize("[Getter/Setter]", "special");
          } else {
            str = ctx.stylize("[Getter]", "special");
          }
        } else {
          if (desc.set) {
            str = ctx.stylize("[Setter]", "special");
          }
        }
        if (!hasOwnProperty26(visibleKeys, key)) {
          name = "[" + key + "]";
        }
        if (!str) {
          if (ctx.seen.indexOf(desc.value) < 0) {
            if (isNull2(recurseTimes)) {
              str = formatValue(ctx, desc.value, null);
            } else {
              str = formatValue(ctx, desc.value, recurseTimes - 1);
            }
            if (str.indexOf("\n") > -1) {
              if (array) {
                str = str.split("\n").map(function(line) {
                  return "  " + line;
                }).join("\n").slice(2);
              } else {
                str = "\n" + str.split("\n").map(function(line) {
                  return "   " + line;
                }).join("\n");
              }
            }
          } else {
            str = ctx.stylize("[Circular]", "special");
          }
        }
        if (isUndefined2(name)) {
          if (array && key.match(/^\d+$/)) {
            return str;
          }
          name = JSON.stringify("" + key);
          if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
          } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
          }
        }
        return name + ": " + str;
      }
      function reduceToSingleString(output, base, braces) {
        var numLinesEst = 0;
        var length = output.reduce(function(prev, cur) {
          numLinesEst++;
          if (cur.indexOf("\n") >= 0)
            numLinesEst++;
          return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0);
        if (length > 60) {
          return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
        }
        return braces[0] + base + " " + output.join(", ") + " " + braces[1];
      }
      exports2.types = require_types();
      function isArray2(ar) {
        return Array.isArray(ar);
      }
      exports2.isArray = isArray2;
      function isBoolean2(arg) {
        return typeof arg === "boolean";
      }
      exports2.isBoolean = isBoolean2;
      function isNull2(arg) {
        return arg === null;
      }
      exports2.isNull = isNull2;
      function isNullOrUndefined(arg) {
        return arg == null;
      }
      exports2.isNullOrUndefined = isNullOrUndefined;
      function isNumber2(arg) {
        return typeof arg === "number";
      }
      exports2.isNumber = isNumber2;
      function isString2(arg) {
        return typeof arg === "string";
      }
      exports2.isString = isString2;
      function isSymbol2(arg) {
        return typeof arg === "symbol";
      }
      exports2.isSymbol = isSymbol2;
      function isUndefined2(arg) {
        return arg === void 0;
      }
      exports2.isUndefined = isUndefined2;
      function isRegExp2(re) {
        return isObject2(re) && objectToString2(re) === "[object RegExp]";
      }
      exports2.isRegExp = isRegExp2;
      exports2.types.isRegExp = isRegExp2;
      function isObject2(arg) {
        return typeof arg === "object" && arg !== null;
      }
      exports2.isObject = isObject2;
      function isDate2(d) {
        return isObject2(d) && objectToString2(d) === "[object Date]";
      }
      exports2.isDate = isDate2;
      exports2.types.isDate = isDate2;
      function isError2(e) {
        return isObject2(e) && (objectToString2(e) === "[object Error]" || e instanceof Error);
      }
      exports2.isError = isError2;
      exports2.types.isNativeError = isError2;
      function isFunction2(arg) {
        return typeof arg === "function";
      }
      exports2.isFunction = isFunction2;
      function isPrimitive(arg) {
        return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || typeof arg === "undefined";
      }
      exports2.isPrimitive = isPrimitive;
      exports2.isBuffer = require_isBufferBrowser();
      function objectToString2(o) {
        return Object.prototype.toString.call(o);
      }
      function pad2(n) {
        return n < 10 ? "0" + n.toString(10) : n.toString(10);
      }
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      function timestamp() {
        var d = new Date();
        var time = [
          pad2(d.getHours()),
          pad2(d.getMinutes()),
          pad2(d.getSeconds())
        ].join(":");
        return [d.getDate(), months[d.getMonth()], time].join(" ");
      }
      exports2.log = function() {
        console.log("%s - %s", timestamp(), exports2.format.apply(exports2, arguments));
      };
      exports2.inherits = require_inherits_browser();
      exports2._extend = function(origin, add2) {
        if (!add2 || !isObject2(add2))
          return origin;
        var keys2 = Object.keys(add2);
        var i = keys2.length;
        while (i--) {
          origin[keys2[i]] = add2[keys2[i]];
        }
        return origin;
      };
      function hasOwnProperty26(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
      }
      var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : void 0;
      exports2.promisify = function promisify(original) {
        if (typeof original !== "function")
          throw new TypeError('The "original" argument must be of type Function');
        if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
          var fn = original[kCustomPromisifiedSymbol];
          if (typeof fn !== "function") {
            throw new TypeError('The "util.promisify.custom" argument must be of type Function');
          }
          Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
          });
          return fn;
        }
        function fn() {
          var promiseResolve, promiseReject;
          var promise = new Promise(function(resolve, reject2) {
            promiseResolve = resolve;
            promiseReject = reject2;
          });
          var args = [];
          for (var i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
          }
          args.push(function(err, value) {
            if (err) {
              promiseReject(err);
            } else {
              promiseResolve(value);
            }
          });
          try {
            original.apply(this, args);
          } catch (err) {
            promiseReject(err);
          }
          return promise;
        }
        Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
        if (kCustomPromisifiedSymbol)
          Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
          });
        return Object.defineProperties(
          fn,
          getOwnPropertyDescriptors(original)
        );
      };
      exports2.promisify.custom = kCustomPromisifiedSymbol;
      function callbackifyOnRejected(reason, cb) {
        if (!reason) {
          var newReason = new Error("Promise was rejected with a falsy value");
          newReason.reason = reason;
          reason = newReason;
        }
        return cb(reason);
      }
      function callbackify(original) {
        if (typeof original !== "function") {
          throw new TypeError('The "original" argument must be of type Function');
        }
        function callbackified() {
          var args = [];
          for (var i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
          }
          var maybeCb = args.pop();
          if (typeof maybeCb !== "function") {
            throw new TypeError("The last argument must be of type Function");
          }
          var self2 = this;
          var cb = function() {
            return maybeCb.apply(self2, arguments);
          };
          original.apply(this, args).then(
            function(ret) {
              define_process_default.nextTick(cb.bind(null, null, ret));
            },
            function(rej) {
              define_process_default.nextTick(callbackifyOnRejected.bind(null, rej, cb));
            }
          );
        }
        Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
        Object.defineProperties(
          callbackified,
          getOwnPropertyDescriptors(original)
        );
        return callbackified;
      }
      exports2.callbackify = callbackify;
    }
  });

  // node_modules/ret/lib/types.js
  var require_types2 = __commonJS({
    "node_modules/ret/lib/types.js"(exports2, module2) {
      init_define_process();
      module2.exports = {
        ROOT: 0,
        GROUP: 1,
        POSITION: 2,
        SET: 3,
        RANGE: 4,
        REPETITION: 5,
        REFERENCE: 6,
        CHAR: 7
      };
    }
  });

  // node_modules/ret/lib/sets.js
  var require_sets = __commonJS({
    "node_modules/ret/lib/sets.js"(exports2) {
      init_define_process();
      var types = require_types2();
      var INTS = function() {
        return [{ type: types.RANGE, from: 48, to: 57 }];
      };
      var WORDS = function() {
        return [
          { type: types.CHAR, value: 95 },
          { type: types.RANGE, from: 97, to: 122 },
          { type: types.RANGE, from: 65, to: 90 }
        ].concat(INTS());
      };
      var WHITESPACE = function() {
        return [
          { type: types.CHAR, value: 9 },
          { type: types.CHAR, value: 10 },
          { type: types.CHAR, value: 11 },
          { type: types.CHAR, value: 12 },
          { type: types.CHAR, value: 13 },
          { type: types.CHAR, value: 32 },
          { type: types.CHAR, value: 160 },
          { type: types.CHAR, value: 5760 },
          { type: types.CHAR, value: 6158 },
          { type: types.CHAR, value: 8192 },
          { type: types.CHAR, value: 8193 },
          { type: types.CHAR, value: 8194 },
          { type: types.CHAR, value: 8195 },
          { type: types.CHAR, value: 8196 },
          { type: types.CHAR, value: 8197 },
          { type: types.CHAR, value: 8198 },
          { type: types.CHAR, value: 8199 },
          { type: types.CHAR, value: 8200 },
          { type: types.CHAR, value: 8201 },
          { type: types.CHAR, value: 8202 },
          { type: types.CHAR, value: 8232 },
          { type: types.CHAR, value: 8233 },
          { type: types.CHAR, value: 8239 },
          { type: types.CHAR, value: 8287 },
          { type: types.CHAR, value: 12288 },
          { type: types.CHAR, value: 65279 }
        ];
      };
      var NOTANYCHAR = function() {
        return [
          { type: types.CHAR, value: 10 },
          { type: types.CHAR, value: 13 },
          { type: types.CHAR, value: 8232 },
          { type: types.CHAR, value: 8233 }
        ];
      };
      exports2.words = function() {
        return { type: types.SET, set: WORDS(), not: false };
      };
      exports2.notWords = function() {
        return { type: types.SET, set: WORDS(), not: true };
      };
      exports2.ints = function() {
        return { type: types.SET, set: INTS(), not: false };
      };
      exports2.notInts = function() {
        return { type: types.SET, set: INTS(), not: true };
      };
      exports2.whitespace = function() {
        return { type: types.SET, set: WHITESPACE(), not: false };
      };
      exports2.notWhitespace = function() {
        return { type: types.SET, set: WHITESPACE(), not: true };
      };
      exports2.anyChar = function() {
        return { type: types.SET, set: NOTANYCHAR(), not: true };
      };
    }
  });

  // node_modules/ret/lib/util.js
  var require_util2 = __commonJS({
    "node_modules/ret/lib/util.js"(exports2) {
      init_define_process();
      var types = require_types2();
      var sets = require_sets();
      var CTRL = "@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^ ?";
      var SLSH = { "0": 0, "t": 9, "n": 10, "v": 11, "f": 12, "r": 13 };
      exports2.strToChars = function(str) {
        var chars_regex = /(\[\\b\])|(\\)?\\(?:u([A-F0-9]{4})|x([A-F0-9]{2})|(0?[0-7]{2})|c([@A-Z\[\\\]\^?])|([0tnvfr]))/g;
        str = str.replace(chars_regex, function(s, b, lbs, a16, b16, c8, dctrl, eslsh) {
          if (lbs) {
            return s;
          }
          var code = b ? 8 : a16 ? parseInt(a16, 16) : b16 ? parseInt(b16, 16) : c8 ? parseInt(c8, 8) : dctrl ? CTRL.indexOf(dctrl) : SLSH[eslsh];
          var c = String.fromCharCode(code);
          if (/[\[\]{}\^$.|?*+()]/.test(c)) {
            c = "\\" + c;
          }
          return c;
        });
        return str;
      };
      exports2.tokenizeClass = function(str, regexpStr) {
        var tokens = [];
        var regexp = /\\(?:(w)|(d)|(s)|(W)|(D)|(S))|((?:(?:\\)(.)|([^\]\\]))-(?:\\)?([^\]]))|(\])|(?:\\)?(.)/g;
        var rs, c;
        while ((rs = regexp.exec(str)) != null) {
          if (rs[1]) {
            tokens.push(sets.words());
          } else if (rs[2]) {
            tokens.push(sets.ints());
          } else if (rs[3]) {
            tokens.push(sets.whitespace());
          } else if (rs[4]) {
            tokens.push(sets.notWords());
          } else if (rs[5]) {
            tokens.push(sets.notInts());
          } else if (rs[6]) {
            tokens.push(sets.notWhitespace());
          } else if (rs[7]) {
            tokens.push({
              type: types.RANGE,
              from: (rs[8] || rs[9]).charCodeAt(0),
              to: rs[10].charCodeAt(0)
            });
          } else if (c = rs[12]) {
            tokens.push({
              type: types.CHAR,
              value: c.charCodeAt(0)
            });
          } else {
            return [tokens, regexp.lastIndex];
          }
        }
        exports2.error(regexpStr, "Unterminated character class");
      };
      exports2.error = function(regexp, msg) {
        throw new SyntaxError("Invalid regular expression: /" + regexp + "/: " + msg);
      };
    }
  });

  // node_modules/ret/lib/positions.js
  var require_positions = __commonJS({
    "node_modules/ret/lib/positions.js"(exports2) {
      init_define_process();
      var types = require_types2();
      exports2.wordBoundary = function() {
        return { type: types.POSITION, value: "b" };
      };
      exports2.nonWordBoundary = function() {
        return { type: types.POSITION, value: "B" };
      };
      exports2.begin = function() {
        return { type: types.POSITION, value: "^" };
      };
      exports2.end = function() {
        return { type: types.POSITION, value: "$" };
      };
    }
  });

  // node_modules/ret/lib/index.js
  var require_lib = __commonJS({
    "node_modules/ret/lib/index.js"(exports2, module2) {
      init_define_process();
      var util = require_util2();
      var types = require_types2();
      var sets = require_sets();
      var positions = require_positions();
      module2.exports = function(regexpStr) {
        var i = 0, l, c, start = { type: types.ROOT, stack: [] }, lastGroup = start, last2 = start.stack, groupStack = [];
        var repeatErr = function(i2) {
          util.error(regexpStr, "Nothing to repeat at column " + (i2 - 1));
        };
        var str = util.strToChars(regexpStr);
        l = str.length;
        while (i < l) {
          c = str[i++];
          switch (c) {
            case "\\":
              c = str[i++];
              switch (c) {
                case "b":
                  last2.push(positions.wordBoundary());
                  break;
                case "B":
                  last2.push(positions.nonWordBoundary());
                  break;
                case "w":
                  last2.push(sets.words());
                  break;
                case "W":
                  last2.push(sets.notWords());
                  break;
                case "d":
                  last2.push(sets.ints());
                  break;
                case "D":
                  last2.push(sets.notInts());
                  break;
                case "s":
                  last2.push(sets.whitespace());
                  break;
                case "S":
                  last2.push(sets.notWhitespace());
                  break;
                default:
                  if (/\d/.test(c)) {
                    last2.push({ type: types.REFERENCE, value: parseInt(c, 10) });
                  } else {
                    last2.push({ type: types.CHAR, value: c.charCodeAt(0) });
                  }
              }
              break;
            case "^":
              last2.push(positions.begin());
              break;
            case "$":
              last2.push(positions.end());
              break;
            case "[":
              var not;
              if (str[i] === "^") {
                not = true;
                i++;
              } else {
                not = false;
              }
              var classTokens = util.tokenizeClass(str.slice(i), regexpStr);
              i += classTokens[1];
              last2.push({
                type: types.SET,
                set: classTokens[0],
                not
              });
              break;
            case ".":
              last2.push(sets.anyChar());
              break;
            case "(":
              var group = {
                type: types.GROUP,
                stack: [],
                remember: true
              };
              c = str[i];
              if (c === "?") {
                c = str[i + 1];
                i += 2;
                if (c === "=") {
                  group.followedBy = true;
                } else if (c === "!") {
                  group.notFollowedBy = true;
                } else if (c !== ":") {
                  util.error(
                    regexpStr,
                    "Invalid group, character '" + c + "' after '?' at column " + (i - 1)
                  );
                }
                group.remember = false;
              }
              last2.push(group);
              groupStack.push(lastGroup);
              lastGroup = group;
              last2 = group.stack;
              break;
            case ")":
              if (groupStack.length === 0) {
                util.error(regexpStr, "Unmatched ) at column " + (i - 1));
              }
              lastGroup = groupStack.pop();
              last2 = lastGroup.options ? lastGroup.options[lastGroup.options.length - 1] : lastGroup.stack;
              break;
            case "|":
              if (!lastGroup.options) {
                lastGroup.options = [lastGroup.stack];
                delete lastGroup.stack;
              }
              var stack = [];
              lastGroup.options.push(stack);
              last2 = stack;
              break;
            case "{":
              var rs = /^(\d+)(,(\d+)?)?\}/.exec(str.slice(i)), min2, max2;
              if (rs !== null) {
                if (last2.length === 0) {
                  repeatErr(i);
                }
                min2 = parseInt(rs[1], 10);
                max2 = rs[2] ? rs[3] ? parseInt(rs[3], 10) : Infinity : min2;
                i += rs[0].length;
                last2.push({
                  type: types.REPETITION,
                  min: min2,
                  max: max2,
                  value: last2.pop()
                });
              } else {
                last2.push({
                  type: types.CHAR,
                  value: 123
                });
              }
              break;
            case "?":
              if (last2.length === 0) {
                repeatErr(i);
              }
              last2.push({
                type: types.REPETITION,
                min: 0,
                max: 1,
                value: last2.pop()
              });
              break;
            case "+":
              if (last2.length === 0) {
                repeatErr(i);
              }
              last2.push({
                type: types.REPETITION,
                min: 1,
                max: Infinity,
                value: last2.pop()
              });
              break;
            case "*":
              if (last2.length === 0) {
                repeatErr(i);
              }
              last2.push({
                type: types.REPETITION,
                min: 0,
                max: Infinity,
                value: last2.pop()
              });
              break;
            default:
              last2.push({
                type: types.CHAR,
                value: c.charCodeAt(0)
              });
          }
        }
        if (groupStack.length !== 0) {
          util.error(regexpStr, "Unterminated group");
        }
        return start;
      };
      module2.exports.types = types;
    }
  });

  // node_modules/safe-regex/index.js
  var require_safe_regex = __commonJS({
    "node_modules/safe-regex/index.js"(exports2, module2) {
      init_define_process();
      var parse3 = require_lib();
      var types = parse3.types;
      module2.exports = function(re, opts) {
        if (!opts)
          opts = {};
        var replimit = opts.limit === void 0 ? 25 : opts.limit;
        if (isRegExp2(re))
          re = re.source;
        else if (typeof re !== "string")
          re = String(re);
        try {
          re = parse3(re);
        } catch (err) {
          return false;
        }
        var reps = 0;
        return function walk(node, starHeight) {
          if (node.type === types.REPETITION) {
            starHeight++;
            reps++;
            if (starHeight > 1)
              return false;
            if (reps > replimit)
              return false;
          }
          if (node.options) {
            for (var i = 0, len = node.options.length; i < len; i++) {
              var ok = walk({ stack: node.options[i] }, starHeight);
              if (!ok)
                return false;
            }
          }
          var stack = node.stack || node.value && node.value.stack;
          if (!stack)
            return true;
          for (var i = 0; i < stack.length; i++) {
            var ok = walk(stack[i], starHeight);
            if (!ok)
              return false;
          }
          return true;
        }(re, 0);
      };
      function isRegExp2(x) {
        return {}.toString.call(x) === "[object RegExp]";
      }
    }
  });

  // node_modules/isobject/index.js
  var require_isobject = __commonJS({
    "node_modules/isobject/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function isObject2(val) {
        return val != null && typeof val === "object" && Array.isArray(val) === false;
      };
    }
  });

  // node_modules/is-descriptor/node_modules/kind-of/index.js
  var require_kind_of = __commonJS({
    "node_modules/is-descriptor/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (val === void 0)
          return "undefined";
        if (val === null)
          return "null";
        var type = typeof val;
        if (type === "boolean")
          return "boolean";
        if (type === "string")
          return "string";
        if (type === "number")
          return "number";
        if (type === "symbol")
          return "symbol";
        if (type === "function") {
          return isGeneratorFn(val) ? "generatorfunction" : "function";
        }
        if (isArray2(val))
          return "array";
        if (isBuffer2(val))
          return "buffer";
        if (isArguments2(val))
          return "arguments";
        if (isDate2(val))
          return "date";
        if (isError2(val))
          return "error";
        if (isRegexp(val))
          return "regexp";
        switch (ctorName(val)) {
          case "Symbol":
            return "symbol";
          case "Promise":
            return "promise";
          case "WeakMap":
            return "weakmap";
          case "WeakSet":
            return "weakset";
          case "Map":
            return "map";
          case "Set":
            return "set";
          case "Int8Array":
            return "int8array";
          case "Uint8Array":
            return "uint8array";
          case "Uint8ClampedArray":
            return "uint8clampedarray";
          case "Int16Array":
            return "int16array";
          case "Uint16Array":
            return "uint16array";
          case "Int32Array":
            return "int32array";
          case "Uint32Array":
            return "uint32array";
          case "Float32Array":
            return "float32array";
          case "Float64Array":
            return "float64array";
        }
        if (isGeneratorObj(val)) {
          return "generator";
        }
        type = toString2.call(val);
        switch (type) {
          case "[object Object]":
            return "object";
          case "[object Map Iterator]":
            return "mapiterator";
          case "[object Set Iterator]":
            return "setiterator";
          case "[object String Iterator]":
            return "stringiterator";
          case "[object Array Iterator]":
            return "arrayiterator";
        }
        return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
      };
      function ctorName(val) {
        return typeof val.constructor === "function" ? val.constructor.name : null;
      }
      function isArray2(val) {
        if (Array.isArray)
          return Array.isArray(val);
        return val instanceof Array;
      }
      function isError2(val) {
        return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
      }
      function isDate2(val) {
        if (val instanceof Date)
          return true;
        return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
      }
      function isRegexp(val) {
        if (val instanceof RegExp)
          return true;
        return typeof val.flags === "string" && typeof val.ignoreCase === "boolean" && typeof val.multiline === "boolean" && typeof val.global === "boolean";
      }
      function isGeneratorFn(name, val) {
        return ctorName(name) === "GeneratorFunction";
      }
      function isGeneratorObj(val) {
        return typeof val.throw === "function" && typeof val.return === "function" && typeof val.next === "function";
      }
      function isArguments2(val) {
        try {
          if (typeof val.length === "number" && typeof val.callee === "function") {
            return true;
          }
        } catch (err) {
          if (err.message.indexOf("callee") !== -1) {
            return true;
          }
        }
        return false;
      }
      function isBuffer2(val) {
        if (val.constructor && typeof val.constructor.isBuffer === "function") {
          return val.constructor.isBuffer(val);
        }
        return false;
      }
    }
  });

  // node_modules/is-accessor-descriptor/node_modules/kind-of/index.js
  var require_kind_of2 = __commonJS({
    "node_modules/is-accessor-descriptor/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (val === void 0)
          return "undefined";
        if (val === null)
          return "null";
        var type = typeof val;
        if (type === "boolean")
          return "boolean";
        if (type === "string")
          return "string";
        if (type === "number")
          return "number";
        if (type === "symbol")
          return "symbol";
        if (type === "function") {
          return isGeneratorFn(val) ? "generatorfunction" : "function";
        }
        if (isArray2(val))
          return "array";
        if (isBuffer2(val))
          return "buffer";
        if (isArguments2(val))
          return "arguments";
        if (isDate2(val))
          return "date";
        if (isError2(val))
          return "error";
        if (isRegexp(val))
          return "regexp";
        switch (ctorName(val)) {
          case "Symbol":
            return "symbol";
          case "Promise":
            return "promise";
          case "WeakMap":
            return "weakmap";
          case "WeakSet":
            return "weakset";
          case "Map":
            return "map";
          case "Set":
            return "set";
          case "Int8Array":
            return "int8array";
          case "Uint8Array":
            return "uint8array";
          case "Uint8ClampedArray":
            return "uint8clampedarray";
          case "Int16Array":
            return "int16array";
          case "Uint16Array":
            return "uint16array";
          case "Int32Array":
            return "int32array";
          case "Uint32Array":
            return "uint32array";
          case "Float32Array":
            return "float32array";
          case "Float64Array":
            return "float64array";
        }
        if (isGeneratorObj(val)) {
          return "generator";
        }
        type = toString2.call(val);
        switch (type) {
          case "[object Object]":
            return "object";
          case "[object Map Iterator]":
            return "mapiterator";
          case "[object Set Iterator]":
            return "setiterator";
          case "[object String Iterator]":
            return "stringiterator";
          case "[object Array Iterator]":
            return "arrayiterator";
        }
        return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
      };
      function ctorName(val) {
        return typeof val.constructor === "function" ? val.constructor.name : null;
      }
      function isArray2(val) {
        if (Array.isArray)
          return Array.isArray(val);
        return val instanceof Array;
      }
      function isError2(val) {
        return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
      }
      function isDate2(val) {
        if (val instanceof Date)
          return true;
        return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
      }
      function isRegexp(val) {
        if (val instanceof RegExp)
          return true;
        return typeof val.flags === "string" && typeof val.ignoreCase === "boolean" && typeof val.multiline === "boolean" && typeof val.global === "boolean";
      }
      function isGeneratorFn(name, val) {
        return ctorName(name) === "GeneratorFunction";
      }
      function isGeneratorObj(val) {
        return typeof val.throw === "function" && typeof val.return === "function" && typeof val.next === "function";
      }
      function isArguments2(val) {
        try {
          if (typeof val.length === "number" && typeof val.callee === "function") {
            return true;
          }
        } catch (err) {
          if (err.message.indexOf("callee") !== -1) {
            return true;
          }
        }
        return false;
      }
      function isBuffer2(val) {
        if (val.constructor && typeof val.constructor.isBuffer === "function") {
          return val.constructor.isBuffer(val);
        }
        return false;
      }
    }
  });

  // node_modules/is-accessor-descriptor/index.js
  var require_is_accessor_descriptor = __commonJS({
    "node_modules/is-accessor-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of2();
      var accessor = {
        get: "function",
        set: "function",
        configurable: "boolean",
        enumerable: "boolean"
      };
      function isAccessorDescriptor(obj, prop) {
        if (typeof prop === "string") {
          var val = Object.getOwnPropertyDescriptor(obj, prop);
          return typeof val !== "undefined";
        }
        if (typeOf(obj) !== "object") {
          return false;
        }
        if (has2(obj, "value") || has2(obj, "writable")) {
          return false;
        }
        if (!has2(obj, "get") || typeof obj.get !== "function") {
          return false;
        }
        if (has2(obj, "set") && typeof obj[key] !== "function" && typeof obj[key] !== "undefined") {
          return false;
        }
        for (var key in obj) {
          if (!accessor.hasOwnProperty(key)) {
            continue;
          }
          if (typeOf(obj[key]) === accessor[key]) {
            continue;
          }
          if (typeof obj[key] !== "undefined") {
            return false;
          }
        }
        return true;
      }
      function has2(obj, key) {
        return {}.hasOwnProperty.call(obj, key);
      }
      module2.exports = isAccessorDescriptor;
    }
  });

  // node_modules/is-data-descriptor/node_modules/kind-of/index.js
  var require_kind_of3 = __commonJS({
    "node_modules/is-data-descriptor/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (val === void 0)
          return "undefined";
        if (val === null)
          return "null";
        var type = typeof val;
        if (type === "boolean")
          return "boolean";
        if (type === "string")
          return "string";
        if (type === "number")
          return "number";
        if (type === "symbol")
          return "symbol";
        if (type === "function") {
          return isGeneratorFn(val) ? "generatorfunction" : "function";
        }
        if (isArray2(val))
          return "array";
        if (isBuffer2(val))
          return "buffer";
        if (isArguments2(val))
          return "arguments";
        if (isDate2(val))
          return "date";
        if (isError2(val))
          return "error";
        if (isRegexp(val))
          return "regexp";
        switch (ctorName(val)) {
          case "Symbol":
            return "symbol";
          case "Promise":
            return "promise";
          case "WeakMap":
            return "weakmap";
          case "WeakSet":
            return "weakset";
          case "Map":
            return "map";
          case "Set":
            return "set";
          case "Int8Array":
            return "int8array";
          case "Uint8Array":
            return "uint8array";
          case "Uint8ClampedArray":
            return "uint8clampedarray";
          case "Int16Array":
            return "int16array";
          case "Uint16Array":
            return "uint16array";
          case "Int32Array":
            return "int32array";
          case "Uint32Array":
            return "uint32array";
          case "Float32Array":
            return "float32array";
          case "Float64Array":
            return "float64array";
        }
        if (isGeneratorObj(val)) {
          return "generator";
        }
        type = toString2.call(val);
        switch (type) {
          case "[object Object]":
            return "object";
          case "[object Map Iterator]":
            return "mapiterator";
          case "[object Set Iterator]":
            return "setiterator";
          case "[object String Iterator]":
            return "stringiterator";
          case "[object Array Iterator]":
            return "arrayiterator";
        }
        return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
      };
      function ctorName(val) {
        return typeof val.constructor === "function" ? val.constructor.name : null;
      }
      function isArray2(val) {
        if (Array.isArray)
          return Array.isArray(val);
        return val instanceof Array;
      }
      function isError2(val) {
        return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
      }
      function isDate2(val) {
        if (val instanceof Date)
          return true;
        return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
      }
      function isRegexp(val) {
        if (val instanceof RegExp)
          return true;
        return typeof val.flags === "string" && typeof val.ignoreCase === "boolean" && typeof val.multiline === "boolean" && typeof val.global === "boolean";
      }
      function isGeneratorFn(name, val) {
        return ctorName(name) === "GeneratorFunction";
      }
      function isGeneratorObj(val) {
        return typeof val.throw === "function" && typeof val.return === "function" && typeof val.next === "function";
      }
      function isArguments2(val) {
        try {
          if (typeof val.length === "number" && typeof val.callee === "function") {
            return true;
          }
        } catch (err) {
          if (err.message.indexOf("callee") !== -1) {
            return true;
          }
        }
        return false;
      }
      function isBuffer2(val) {
        if (val.constructor && typeof val.constructor.isBuffer === "function") {
          return val.constructor.isBuffer(val);
        }
        return false;
      }
    }
  });

  // node_modules/is-data-descriptor/index.js
  var require_is_data_descriptor = __commonJS({
    "node_modules/is-data-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of3();
      module2.exports = function isDataDescriptor(obj, prop) {
        var data = {
          configurable: "boolean",
          enumerable: "boolean",
          writable: "boolean"
        };
        if (typeOf(obj) !== "object") {
          return false;
        }
        if (typeof prop === "string") {
          var val = Object.getOwnPropertyDescriptor(obj, prop);
          return typeof val !== "undefined";
        }
        if (!("value" in obj) && !("writable" in obj)) {
          return false;
        }
        for (var key in obj) {
          if (key === "value")
            continue;
          if (!data.hasOwnProperty(key)) {
            continue;
          }
          if (typeOf(obj[key]) === data[key]) {
            continue;
          }
          if (typeof obj[key] !== "undefined") {
            return false;
          }
        }
        return true;
      };
    }
  });

  // node_modules/is-descriptor/index.js
  var require_is_descriptor = __commonJS({
    "node_modules/is-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of();
      var isAccessor = require_is_accessor_descriptor();
      var isData = require_is_data_descriptor();
      module2.exports = function isDescriptor(obj, key) {
        if (typeOf(obj) !== "object") {
          return false;
        }
        if ("get" in obj) {
          return isAccessor(obj, key);
        }
        return isData(obj, key);
      };
    }
  });

  // node_modules/to-regex/node_modules/define-property/index.js
  var require_define_property = __commonJS({
    "node_modules/to-regex/node_modules/define-property/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isobject = require_isobject();
      var isDescriptor = require_is_descriptor();
      var define2 = typeof Reflect !== "undefined" && Reflect.defineProperty ? Reflect.defineProperty : Object.defineProperty;
      module2.exports = function defineProperty2(obj, key, val) {
        if (!isobject(obj) && typeof obj !== "function" && !Array.isArray(obj)) {
          throw new TypeError("expected an object, function, or array");
        }
        if (typeof key !== "string") {
          throw new TypeError('expected "key" to be a string');
        }
        if (isDescriptor(val)) {
          define2(obj, key, val);
          return obj;
        }
        define2(obj, key, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
        return obj;
      };
    }
  });

  // node_modules/is-plain-object/index.js
  var require_is_plain_object = __commonJS({
    "node_modules/is-plain-object/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      function isObjectObject(o) {
        return isObject2(o) === true && Object.prototype.toString.call(o) === "[object Object]";
      }
      module2.exports = function isPlainObject2(o) {
        var ctor, prot;
        if (isObjectObject(o) === false)
          return false;
        ctor = o.constructor;
        if (typeof ctor !== "function")
          return false;
        prot = ctor.prototype;
        if (isObjectObject(prot) === false)
          return false;
        if (prot.hasOwnProperty("isPrototypeOf") === false) {
          return false;
        }
        return true;
      };
    }
  });

  // node_modules/extend-shallow/node_modules/is-extendable/index.js
  var require_is_extendable = __commonJS({
    "node_modules/extend-shallow/node_modules/is-extendable/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isPlainObject2 = require_is_plain_object();
      module2.exports = function isExtendable(val) {
        return isPlainObject2(val) || typeof val === "function" || Array.isArray(val);
      };
    }
  });

  // node_modules/assign-symbols/index.js
  var require_assign_symbols = __commonJS({
    "node_modules/assign-symbols/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function(receiver, objects) {
        if (receiver === null || typeof receiver === "undefined") {
          throw new TypeError("expected first argument to be an object.");
        }
        if (typeof objects === "undefined" || typeof Symbol === "undefined") {
          return receiver;
        }
        if (typeof Object.getOwnPropertySymbols !== "function") {
          return receiver;
        }
        var isEnumerable = Object.prototype.propertyIsEnumerable;
        var target = Object(receiver);
        var len = arguments.length, i = 0;
        while (++i < len) {
          var provider = Object(arguments[i]);
          var names = Object.getOwnPropertySymbols(provider);
          for (var j = 0; j < names.length; j++) {
            var key = names[j];
            if (isEnumerable.call(provider, key)) {
              target[key] = provider[key];
            }
          }
        }
        return target;
      };
    }
  });

  // node_modules/extend-shallow/index.js
  var require_extend_shallow = __commonJS({
    "node_modules/extend-shallow/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isExtendable = require_is_extendable();
      var assignSymbols = require_assign_symbols();
      module2.exports = Object.assign || function(obj) {
        if (obj === null || typeof obj === "undefined") {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        if (!isObject2(obj)) {
          obj = {};
        }
        for (var i = 1; i < arguments.length; i++) {
          var val = arguments[i];
          if (isString2(val)) {
            val = toObject(val);
          }
          if (isObject2(val)) {
            assign2(obj, val);
            assignSymbols(obj, val);
          }
        }
        return obj;
      };
      function assign2(a, b) {
        for (var key in b) {
          if (hasOwn(b, key)) {
            a[key] = b[key];
          }
        }
      }
      function isString2(val) {
        return val && typeof val === "string";
      }
      function toObject(str) {
        var obj = {};
        for (var i in str) {
          obj[i] = str[i];
        }
        return obj;
      }
      function isObject2(val) {
        return val && typeof val === "object" || isExtendable(val);
      }
      function hasOwn(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
    }
  });

  // node_modules/regex-not/index.js
  var require_regex_not = __commonJS({
    "node_modules/regex-not/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var extend = require_extend_shallow();
      var safe = require_safe_regex();
      function toRegex(pattern, options) {
        return new RegExp(toRegex.create(pattern, options));
      }
      toRegex.create = function(pattern, options) {
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        var opts = extend({}, options);
        if (opts.contains === true) {
          opts.strictNegate = false;
        }
        var open = opts.strictOpen !== false ? "^" : "";
        var close = opts.strictClose !== false ? "$" : "";
        var endChar = opts.endChar ? opts.endChar : "+";
        var str = pattern;
        if (opts.strictNegate === false) {
          str = "(?:(?!(?:" + pattern + ")).)" + endChar;
        } else {
          str = "(?:(?!^(?:" + pattern + ")$).)" + endChar;
        }
        var res = open + str + close;
        if (opts.safe === true && safe(res) === false) {
          throw new Error("potentially unsafe regular expression: " + res);
        }
        return res;
      };
      module2.exports = toRegex;
    }
  });

  // node_modules/to-regex/index.js
  var require_to_regex = __commonJS({
    "node_modules/to-regex/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var safe = require_safe_regex();
      var define2 = require_define_property();
      var extend = require_extend_shallow();
      var not = require_regex_not();
      var MAX_LENGTH = 1024 * 64;
      var cache = {};
      module2.exports = function(patterns, options) {
        if (!Array.isArray(patterns)) {
          return makeRe(patterns, options);
        }
        return makeRe(patterns.join("|"), options);
      };
      function makeRe(pattern, options) {
        if (pattern instanceof RegExp) {
          return pattern;
        }
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        if (pattern.length > MAX_LENGTH) {
          throw new Error("expected pattern to be less than " + MAX_LENGTH + " characters");
        }
        var key = pattern;
        if (!options || options && options.cache !== false) {
          key = createKey(pattern, options);
          if (cache.hasOwnProperty(key)) {
            return cache[key];
          }
        }
        var opts = extend({}, options);
        if (opts.contains === true) {
          if (opts.negate === true) {
            opts.strictNegate = false;
          } else {
            opts.strict = false;
          }
        }
        if (opts.strict === false) {
          opts.strictOpen = false;
          opts.strictClose = false;
        }
        var open = opts.strictOpen !== false ? "^" : "";
        var close = opts.strictClose !== false ? "$" : "";
        var flags = opts.flags || "";
        var regex;
        if (opts.nocase === true && !/i/.test(flags)) {
          flags += "i";
        }
        try {
          if (opts.negate || typeof opts.strictNegate === "boolean") {
            pattern = not.create(pattern, opts);
          }
          var str = open + "(?:" + pattern + ")" + close;
          regex = new RegExp(str, flags);
          if (opts.safe === true && safe(regex) === false) {
            throw new Error("potentially unsafe regular expression: " + regex.source);
          }
        } catch (err) {
          if (opts.strictErrors === true || opts.safe === true) {
            err.key = key;
            err.pattern = pattern;
            err.originalOptions = options;
            err.createdOptions = opts;
            throw err;
          }
          try {
            regex = new RegExp("^" + pattern.replace(/(\W)/g, "\\$1") + "$");
          } catch (err2) {
            regex = /.^/;
          }
        }
        if (opts.cache !== false) {
          memoize2(regex, key, pattern, opts);
        }
        return regex;
      }
      function memoize2(regex, key, pattern, options) {
        define2(regex, "cached", true);
        define2(regex, "pattern", pattern);
        define2(regex, "options", options);
        define2(regex, "key", key);
        cache[key] = regex;
      }
      function createKey(pattern, options) {
        if (!options)
          return pattern;
        var key = pattern;
        for (var prop in options) {
          if (options.hasOwnProperty(prop)) {
            key += ";" + prop + "=" + String(options[prop]);
          }
        }
        return key;
      }
      module2.exports.makeRe = makeRe;
    }
  });

  // node_modules/nanomatch/lib/compilers.js
  var require_compilers = __commonJS({
    "node_modules/nanomatch/lib/compilers.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function(nanomatch, options) {
        function slash() {
          if (options && typeof options.slash === "string") {
            return options.slash;
          }
          if (options && typeof options.slash === "function") {
            return options.slash.call(nanomatch);
          }
          return "\\\\/";
        }
        function star() {
          if (options && typeof options.star === "string") {
            return options.star;
          }
          if (options && typeof options.star === "function") {
            return options.star.call(nanomatch);
          }
          return "[^" + slash() + "]*?";
        }
        var ast = nanomatch.ast = nanomatch.parser.ast;
        ast.state = nanomatch.parser.state;
        nanomatch.compiler.state = ast.state;
        nanomatch.compiler.set("not", function(node) {
          var prev = this.prev();
          if (this.options.nonegate === true || prev.type !== "bos") {
            return this.emit("\\" + node.val, node);
          }
          return this.emit(node.val, node);
        }).set("escape", function(node) {
          if (this.options.unescape && /^[-\w_.]/.test(node.val)) {
            return this.emit(node.val, node);
          }
          return this.emit("\\" + node.val, node);
        }).set("quoted", function(node) {
          return this.emit(node.val, node);
        }).set("dollar", function(node) {
          if (node.parent.type === "bracket") {
            return this.emit(node.val, node);
          }
          return this.emit("\\" + node.val, node);
        }).set("dot", function(node) {
          if (node.dotfiles === true)
            this.dotfiles = true;
          return this.emit("\\" + node.val, node);
        }).set("backslash", function(node) {
          return this.emit(node.val, node);
        }).set("slash", function(node, nodes, i) {
          var val = "[" + slash() + "]";
          var parent2 = node.parent;
          var prev = this.prev();
          while (parent2.type === "paren" && !parent2.hasSlash) {
            parent2.hasSlash = true;
            parent2 = parent2.parent;
          }
          if (prev.addQmark) {
            val += "?";
          }
          if (node.rest.slice(0, 2) === "\\b") {
            return this.emit(val, node);
          }
          if (node.parsed === "**" || node.parsed === "./**") {
            this.output = "(?:" + this.output;
            return this.emit(val + ")?", node);
          }
          if (node.parsed === "!**" && this.options.nonegate !== true) {
            return this.emit(val + "?\\b", node);
          }
          return this.emit(val, node);
        }).set("bracket", function(node) {
          var close = node.close;
          var open = !node.escaped ? "[" : "\\[";
          var negated = node.negated;
          var inner = node.inner;
          var val = node.val;
          if (node.escaped === true) {
            inner = inner.replace(/\\?(\W)/g, "\\$1");
            negated = "";
          }
          if (inner === "]-") {
            inner = "\\]\\-";
          }
          if (negated && inner.indexOf(".") === -1) {
            inner += ".";
          }
          if (negated && inner.indexOf("/") === -1) {
            inner += "/";
          }
          val = open + negated + inner + close;
          return this.emit(val, node);
        }).set("square", function(node) {
          var val = (/^\W/.test(node.val) ? "\\" : "") + node.val;
          return this.emit(val, node);
        }).set("qmark", function(node) {
          var prev = this.prev();
          var val = "[^.\\\\/]";
          if (this.options.dot || prev.type !== "bos" && prev.type !== "slash") {
            val = "[^\\\\/]";
          }
          if (node.parsed.slice(-1) === "(") {
            var ch = node.rest.charAt(0);
            if (ch === "!" || ch === "=" || ch === ":") {
              return this.emit(node.val, node);
            }
          }
          if (node.val.length > 1) {
            val += "{" + node.val.length + "}";
          }
          return this.emit(val, node);
        }).set("plus", function(node) {
          var prev = node.parsed.slice(-1);
          if (prev === "]" || prev === ")") {
            return this.emit(node.val, node);
          }
          if (!this.output || /[?*+]/.test(ch) && node.parent.type !== "bracket") {
            return this.emit("\\+", node);
          }
          var ch = this.output.slice(-1);
          if (/\w/.test(ch) && !node.inside) {
            return this.emit("+\\+?", node);
          }
          return this.emit("+", node);
        }).set("globstar", function(node, nodes, i) {
          if (!this.output) {
            this.state.leadingGlobstar = true;
          }
          var prev = this.prev();
          var before2 = this.prev(2);
          var next = this.next();
          var after2 = this.next(2);
          var type = prev.type;
          var val = node.val;
          if (prev.type === "slash" && next.type === "slash") {
            if (before2.type === "text") {
              this.output += "?";
              if (after2.type !== "text") {
                this.output += "\\b";
              }
            }
          }
          var parsed = node.parsed;
          if (parsed.charAt(0) === "!") {
            parsed = parsed.slice(1);
          }
          var isInside = node.isInside.paren || node.isInside.brace;
          if (parsed && type !== "slash" && type !== "bos" && !isInside) {
            val = star();
          } else {
            val = this.options.dot !== true ? "(?:(?!(?:[" + slash() + "]|^)\\.).)*?" : "(?:(?!(?:[" + slash() + "]|^)(?:\\.{1,2})($|[" + slash() + "]))(?!\\.{2}).)*?";
          }
          if ((type === "slash" || type === "bos") && this.options.dot !== true) {
            val = "(?!\\.)" + val;
          }
          if (prev.type === "slash" && next.type === "slash" && before2.type !== "text") {
            if (after2.type === "text" || after2.type === "star") {
              node.addQmark = true;
            }
          }
          if (this.options.capture) {
            val = "(" + val + ")";
          }
          return this.emit(val, node);
        }).set("star", function(node, nodes, i) {
          var prior = nodes[i - 2] || {};
          var prev = this.prev();
          var next = this.next();
          var type = prev.type;
          function isStart(n) {
            return n.type === "bos" || n.type === "slash";
          }
          if (this.output === "" && this.options.contains !== true) {
            this.output = "(?![" + slash() + "])";
          }
          if (type === "bracket" && this.options.bash === false) {
            var str = next && next.type === "bracket" ? star() : "*?";
            if (!prev.nodes || prev.nodes[1].type !== "posix") {
              return this.emit(str, node);
            }
          }
          var prefix = !this.dotfiles && type !== "text" && type !== "escape" ? this.options.dot ? "(?!(?:^|[" + slash() + "])\\.{1,2}(?:$|[" + slash() + "]))" : "(?!\\.)" : "";
          if (isStart(prev) || isStart(prior) && type === "not") {
            if (prefix !== "(?!\\.)") {
              prefix += "(?!(\\.{2}|\\.[" + slash() + "]))(?=.)";
            } else {
              prefix += "(?=.)";
            }
          } else if (prefix === "(?!\\.)") {
            prefix = "";
          }
          if (prev.type === "not" && prior.type === "bos" && this.options.dot === true) {
            this.output = "(?!\\.)" + this.output;
          }
          var output = prefix + star();
          if (this.options.capture) {
            output = "(" + output + ")";
          }
          return this.emit(output, node);
        }).set("text", function(node) {
          return this.emit(node.val, node);
        }).set("eos", function(node) {
          var prev = this.prev();
          var val = node.val;
          this.output = "(?:\\.[" + slash() + "](?=.))?" + this.output;
          if (this.state.metachar && prev.type !== "qmark" && prev.type !== "slash") {
            val += this.options.contains ? "[" + slash() + "]?" : "(?:[" + slash() + "]|$)";
          }
          return this.emit(val, node);
        });
        if (options && typeof options.compilers === "function") {
          options.compilers(nanomatch.compiler);
        }
      };
    }
  });

  // node_modules/nanomatch/lib/parsers.js
  var require_parsers = __commonJS({
    "node_modules/nanomatch/lib/parsers.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var regexNot = require_regex_not();
      var toRegex = require_to_regex();
      var cached;
      var NOT_REGEX = `[\\[!*+?$^"'.\\\\/]+`;
      var not = createTextRegex(NOT_REGEX);
      module2.exports = function(nanomatch, options) {
        var parser3 = nanomatch.parser;
        var opts = parser3.options;
        parser3.state = {
          slashes: 0,
          paths: []
        };
        parser3.ast.state = parser3.state;
        parser3.capture("prefix", function() {
          if (this.parsed)
            return;
          var m = this.match(/^\.[\\/]/);
          if (!m)
            return;
          this.state.strictOpen = !!this.options.strictOpen;
          this.state.addPrefix = true;
        }).capture("escape", function() {
          if (this.isInside("bracket"))
            return;
          var pos = this.position();
          var m = this.match(/^(?:\\(.)|([$^]))/);
          if (!m)
            return;
          return pos({
            type: "escape",
            val: m[2] || m[1]
          });
        }).capture("quoted", function() {
          var pos = this.position();
          var m = this.match(/^["']/);
          if (!m)
            return;
          var quote = m[0];
          if (this.input.indexOf(quote) === -1) {
            return pos({
              type: "escape",
              val: quote
            });
          }
          var tok = advanceTo(this.input, quote);
          this.consume(tok.len);
          return pos({
            type: "quoted",
            val: tok.esc
          });
        }).capture("not", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(this.notRegex || /^!+/);
          if (!m)
            return;
          var val = m[0];
          var isNegated = val.length % 2 === 1;
          if (parsed === "" && !isNegated) {
            val = "";
          }
          if (parsed === "" && isNegated && this.options.nonegate !== true) {
            this.bos.val = "(?!^(?:";
            this.append = ")$).*";
            val = "";
          }
          return pos({
            type: "not",
            val
          });
        }).capture("dot", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(/^\.+/);
          if (!m)
            return;
          var val = m[0];
          this.state.dot = val === "." && (parsed === "" || parsed.slice(-1) === "/");
          return pos({
            type: "dot",
            dotfiles: this.state.dot,
            val
          });
        }).capture("plus", /^\+(?!\()/).capture("qmark", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(/^\?+(?!\()/);
          if (!m)
            return;
          this.state.metachar = true;
          this.state.qmark = true;
          return pos({
            type: "qmark",
            parsed,
            val: m[0]
          });
        }).capture("globstar", function() {
          var parsed = this.parsed;
          var pos = this.position();
          var m = this.match(/^\*{2}(?![*(])(?=[,)/]|$)/);
          if (!m)
            return;
          var type = opts.noglobstar !== true ? "globstar" : "star";
          var node = pos({ type, parsed });
          this.state.metachar = true;
          while (this.input.slice(0, 4) === "/**/") {
            this.input = this.input.slice(3);
          }
          node.isInside = {
            brace: this.isInside("brace"),
            paren: this.isInside("paren")
          };
          if (type === "globstar") {
            this.state.globstar = true;
            node.val = "**";
          } else {
            this.state.star = true;
            node.val = "*";
          }
          return node;
        }).capture("star", function() {
          var pos = this.position();
          var starRe = /^(?:\*(?![*(])|[*]{3,}(?!\()|[*]{2}(?![(/]|$)|\*(?=\*\())/;
          var m = this.match(starRe);
          if (!m)
            return;
          this.state.metachar = true;
          this.state.star = true;
          return pos({
            type: "star",
            val: m[0]
          });
        }).capture("slash", function() {
          var pos = this.position();
          var m = this.match(/^\//);
          if (!m)
            return;
          this.state.slashes++;
          return pos({
            type: "slash",
            val: m[0]
          });
        }).capture("backslash", function() {
          var pos = this.position();
          var m = this.match(/^\\(?![*+?(){}[\]'"])/);
          if (!m)
            return;
          var val = m[0];
          if (this.isInside("bracket")) {
            val = "\\";
          } else if (val.length > 1) {
            val = "\\\\";
          }
          return pos({
            type: "backslash",
            val
          });
        }).capture("square", function() {
          if (this.isInside("bracket"))
            return;
          var pos = this.position();
          var m = this.match(/^\[([^!^\\])\]/);
          if (!m)
            return;
          return pos({
            type: "square",
            val: m[1]
          });
        }).capture("bracket", function() {
          var pos = this.position();
          var m = this.match(/^(?:\[([!^]?)([^\]]+|\]-)(\]|[^*+?]+)|\[)/);
          if (!m)
            return;
          var val = m[0];
          var negated = m[1] ? "^" : "";
          var inner = (m[2] || "").replace(/\\\\+/, "\\\\");
          var close = m[3] || "";
          if (m[2] && inner.length < m[2].length) {
            val = val.replace(/\\\\+/, "\\\\");
          }
          var esc = this.input.slice(0, 2);
          if (inner === "" && esc === "\\]") {
            inner += esc;
            this.consume(2);
            var str = this.input;
            var idx = -1;
            var ch;
            while (ch = str[++idx]) {
              this.consume(1);
              if (ch === "]") {
                close = ch;
                break;
              }
              inner += ch;
            }
          }
          return pos({
            type: "bracket",
            val,
            escaped: close !== "]",
            negated,
            inner,
            close
          });
        }).capture("text", function() {
          if (this.isInside("bracket"))
            return;
          var pos = this.position();
          var m = this.match(not);
          if (!m || !m[0])
            return;
          return pos({
            type: "text",
            val: m[0]
          });
        });
        if (options && typeof options.parsers === "function") {
          options.parsers(nanomatch.parser);
        }
      };
      function advanceTo(input, endChar) {
        var ch = input.charAt(0);
        var tok = { len: 1, val: "", esc: "" };
        var idx = 0;
        function advance() {
          if (ch !== "\\") {
            tok.esc += "\\" + ch;
            tok.val += ch;
          }
          ch = input.charAt(++idx);
          tok.len++;
          if (ch === "\\") {
            advance();
            advance();
          }
        }
        while (ch && ch !== endChar) {
          advance();
        }
        return tok;
      }
      function createTextRegex(pattern) {
        if (cached)
          return cached;
        var opts = { contains: true, strictClose: false };
        var not2 = regexNot.create(pattern, opts);
        var re = toRegex("^(?:[*]\\((?=.)|" + not2 + ")", opts);
        return cached = re;
      }
      module2.exports.not = NOT_REGEX;
    }
  });

  // node_modules/map-cache/index.js
  var require_map_cache = __commonJS({
    "node_modules/map-cache/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var hasOwn = Object.prototype.hasOwnProperty;
      module2.exports = MapCache2;
      function MapCache2(data) {
        this.__data__ = data || {};
      }
      MapCache2.prototype.set = function mapSet(key, value) {
        if (key !== "__proto__") {
          this.__data__[key] = value;
        }
        return this;
      };
      MapCache2.prototype.get = function mapGet(key) {
        return key === "__proto__" ? void 0 : this.__data__[key];
      };
      MapCache2.prototype.has = function mapHas(key) {
        return key !== "__proto__" && hasOwn.call(this.__data__, key);
      };
      MapCache2.prototype.del = function mapDelete(key) {
        return this.has(key) && delete this.__data__[key];
      };
    }
  });

  // node_modules/fragment-cache/index.js
  var require_fragment_cache = __commonJS({
    "node_modules/fragment-cache/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var MapCache2 = require_map_cache();
      function FragmentCache(caches) {
        this.caches = caches || {};
      }
      FragmentCache.prototype = {
        cache: function(cacheName) {
          return this.caches[cacheName] || (this.caches[cacheName] = new MapCache2());
        },
        set: function(cacheName, key, val) {
          var cache = this.cache(cacheName);
          cache.set(key, val);
          return cache;
        },
        has: function(cacheName, key) {
          return typeof this.get(cacheName, key) !== "undefined";
        },
        get: function(name, key) {
          var cache = this.cache(name);
          if (typeof key === "string") {
            return cache.get(key);
          }
          return cache;
        }
      };
      exports2 = module2.exports = FragmentCache;
    }
  });

  // node_modules/nanomatch/lib/cache.js
  var require_cache = __commonJS({
    "node_modules/nanomatch/lib/cache.js"(exports2, module2) {
      init_define_process();
      module2.exports = new (require_fragment_cache())();
    }
  });

  // node_modules/path-browserify/index.js
  var require_path_browserify = __commonJS({
    "node_modules/path-browserify/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      function assertPath(path) {
        if (typeof path !== "string") {
          throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
        }
      }
      function normalizeStringPosix(path, allowAboveRoot) {
        var res = "";
        var lastSegmentLength = 0;
        var lastSlash = -1;
        var dots = 0;
        var code;
        for (var i = 0; i <= path.length; ++i) {
          if (i < path.length)
            code = path.charCodeAt(i);
          else if (code === 47)
            break;
          else
            code = 47;
          if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) {
            } else if (lastSlash !== i - 1 && dots === 2) {
              if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                if (res.length > 2) {
                  var lastSlashIndex = res.lastIndexOf("/");
                  if (lastSlashIndex !== res.length - 1) {
                    if (lastSlashIndex === -1) {
                      res = "";
                      lastSegmentLength = 0;
                    } else {
                      res = res.slice(0, lastSlashIndex);
                      lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                    }
                    lastSlash = i;
                    dots = 0;
                    continue;
                  }
                } else if (res.length === 2 || res.length === 1) {
                  res = "";
                  lastSegmentLength = 0;
                  lastSlash = i;
                  dots = 0;
                  continue;
                }
              }
              if (allowAboveRoot) {
                if (res.length > 0)
                  res += "/..";
                else
                  res = "..";
                lastSegmentLength = 2;
              }
            } else {
              if (res.length > 0)
                res += "/" + path.slice(lastSlash + 1, i);
              else
                res = path.slice(lastSlash + 1, i);
              lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
          } else if (code === 46 && dots !== -1) {
            ++dots;
          } else {
            dots = -1;
          }
        }
        return res;
      }
      function _format(sep, pathObject) {
        var dir = pathObject.dir || pathObject.root;
        var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
        if (!dir) {
          return base;
        }
        if (dir === pathObject.root) {
          return dir + base;
        }
        return dir + sep + base;
      }
      var posix = {
        resolve: function resolve() {
          var resolvedPath = "";
          var resolvedAbsolute = false;
          var cwd;
          for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
            var path;
            if (i >= 0)
              path = arguments[i];
            else {
              if (cwd === void 0)
                cwd = define_process_default.cwd();
              path = cwd;
            }
            assertPath(path);
            if (path.length === 0) {
              continue;
            }
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47;
          }
          resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);
          if (resolvedAbsolute) {
            if (resolvedPath.length > 0)
              return "/" + resolvedPath;
            else
              return "/";
          } else if (resolvedPath.length > 0) {
            return resolvedPath;
          } else {
            return ".";
          }
        },
        normalize: function normalize(path) {
          assertPath(path);
          if (path.length === 0)
            return ".";
          var isAbsolute = path.charCodeAt(0) === 47;
          var trailingSeparator = path.charCodeAt(path.length - 1) === 47;
          path = normalizeStringPosix(path, !isAbsolute);
          if (path.length === 0 && !isAbsolute)
            path = ".";
          if (path.length > 0 && trailingSeparator)
            path += "/";
          if (isAbsolute)
            return "/" + path;
          return path;
        },
        isAbsolute: function isAbsolute(path) {
          assertPath(path);
          return path.length > 0 && path.charCodeAt(0) === 47;
        },
        join: function join2() {
          if (arguments.length === 0)
            return ".";
          var joined;
          for (var i = 0; i < arguments.length; ++i) {
            var arg = arguments[i];
            assertPath(arg);
            if (arg.length > 0) {
              if (joined === void 0)
                joined = arg;
              else
                joined += "/" + arg;
            }
          }
          if (joined === void 0)
            return ".";
          return posix.normalize(joined);
        },
        relative: function relative(from, to) {
          assertPath(from);
          assertPath(to);
          if (from === to)
            return "";
          from = posix.resolve(from);
          to = posix.resolve(to);
          if (from === to)
            return "";
          var fromStart = 1;
          for (; fromStart < from.length; ++fromStart) {
            if (from.charCodeAt(fromStart) !== 47)
              break;
          }
          var fromEnd = from.length;
          var fromLen = fromEnd - fromStart;
          var toStart = 1;
          for (; toStart < to.length; ++toStart) {
            if (to.charCodeAt(toStart) !== 47)
              break;
          }
          var toEnd = to.length;
          var toLen = toEnd - toStart;
          var length = fromLen < toLen ? fromLen : toLen;
          var lastCommonSep = -1;
          var i = 0;
          for (; i <= length; ++i) {
            if (i === length) {
              if (toLen > length) {
                if (to.charCodeAt(toStart + i) === 47) {
                  return to.slice(toStart + i + 1);
                } else if (i === 0) {
                  return to.slice(toStart + i);
                }
              } else if (fromLen > length) {
                if (from.charCodeAt(fromStart + i) === 47) {
                  lastCommonSep = i;
                } else if (i === 0) {
                  lastCommonSep = 0;
                }
              }
              break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode)
              break;
            else if (fromCode === 47)
              lastCommonSep = i;
          }
          var out = "";
          for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
            if (i === fromEnd || from.charCodeAt(i) === 47) {
              if (out.length === 0)
                out += "..";
              else
                out += "/..";
            }
          }
          if (out.length > 0)
            return out + to.slice(toStart + lastCommonSep);
          else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47)
              ++toStart;
            return to.slice(toStart);
          }
        },
        _makeLong: function _makeLong(path) {
          return path;
        },
        dirname: function dirname(path) {
          assertPath(path);
          if (path.length === 0)
            return ".";
          var code = path.charCodeAt(0);
          var hasRoot = code === 47;
          var end = -1;
          var matchedSlash = true;
          for (var i = path.length - 1; i >= 1; --i) {
            code = path.charCodeAt(i);
            if (code === 47) {
              if (!matchedSlash) {
                end = i;
                break;
              }
            } else {
              matchedSlash = false;
            }
          }
          if (end === -1)
            return hasRoot ? "/" : ".";
          if (hasRoot && end === 1)
            return "//";
          return path.slice(0, end);
        },
        basename: function basename(path, ext) {
          if (ext !== void 0 && typeof ext !== "string")
            throw new TypeError('"ext" argument must be a string');
          assertPath(path);
          var start = 0;
          var end = -1;
          var matchedSlash = true;
          var i;
          if (ext !== void 0 && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path)
              return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for (i = path.length - 1; i >= 0; --i) {
              var code = path.charCodeAt(i);
              if (code === 47) {
                if (!matchedSlash) {
                  start = i + 1;
                  break;
                }
              } else {
                if (firstNonSlashEnd === -1) {
                  matchedSlash = false;
                  firstNonSlashEnd = i + 1;
                }
                if (extIdx >= 0) {
                  if (code === ext.charCodeAt(extIdx)) {
                    if (--extIdx === -1) {
                      end = i;
                    }
                  } else {
                    extIdx = -1;
                    end = firstNonSlashEnd;
                  }
                }
              }
            }
            if (start === end)
              end = firstNonSlashEnd;
            else if (end === -1)
              end = path.length;
            return path.slice(start, end);
          } else {
            for (i = path.length - 1; i >= 0; --i) {
              if (path.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                  start = i + 1;
                  break;
                }
              } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
              }
            }
            if (end === -1)
              return "";
            return path.slice(start, end);
          }
        },
        extname: function extname(path) {
          assertPath(path);
          var startDot = -1;
          var startPart = 0;
          var end = -1;
          var matchedSlash = true;
          var preDotState = 0;
          for (var i = path.length - 1; i >= 0; --i) {
            var code = path.charCodeAt(i);
            if (code === 47) {
              if (!matchedSlash) {
                startPart = i + 1;
                break;
              }
              continue;
            }
            if (end === -1) {
              matchedSlash = false;
              end = i + 1;
            }
            if (code === 46) {
              if (startDot === -1)
                startDot = i;
              else if (preDotState !== 1)
                preDotState = 1;
            } else if (startDot !== -1) {
              preDotState = -1;
            }
          }
          if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            return "";
          }
          return path.slice(startDot, end);
        },
        format: function format(pathObject) {
          if (pathObject === null || typeof pathObject !== "object") {
            throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
          }
          return _format("/", pathObject);
        },
        parse: function parse3(path) {
          assertPath(path);
          var ret = { root: "", dir: "", base: "", ext: "", name: "" };
          if (path.length === 0)
            return ret;
          var code = path.charCodeAt(0);
          var isAbsolute = code === 47;
          var start;
          if (isAbsolute) {
            ret.root = "/";
            start = 1;
          } else {
            start = 0;
          }
          var startDot = -1;
          var startPart = 0;
          var end = -1;
          var matchedSlash = true;
          var i = path.length - 1;
          var preDotState = 0;
          for (; i >= start; --i) {
            code = path.charCodeAt(i);
            if (code === 47) {
              if (!matchedSlash) {
                startPart = i + 1;
                break;
              }
              continue;
            }
            if (end === -1) {
              matchedSlash = false;
              end = i + 1;
            }
            if (code === 46) {
              if (startDot === -1)
                startDot = i;
              else if (preDotState !== 1)
                preDotState = 1;
            } else if (startDot !== -1) {
              preDotState = -1;
            }
          }
          if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
              if (startPart === 0 && isAbsolute)
                ret.base = ret.name = path.slice(1, end);
              else
                ret.base = ret.name = path.slice(startPart, end);
            }
          } else {
            if (startPart === 0 && isAbsolute) {
              ret.name = path.slice(1, startDot);
              ret.base = path.slice(1, end);
            } else {
              ret.name = path.slice(startPart, startDot);
              ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
          }
          if (startPart > 0)
            ret.dir = path.slice(0, startPart - 1);
          else if (isAbsolute)
            ret.dir = "/";
          return ret;
        },
        sep: "/",
        delimiter: ":",
        win32: null,
        posix: null
      };
      posix.posix = posix;
      module2.exports = posix;
    }
  });

  // node_modules/is-windows/index.js
  var require_is_windows = __commonJS({
    "node_modules/is-windows/index.js"(exports2, module2) {
      init_define_process();
      (function(factory2) {
        if (exports2 && typeof exports2 === "object" && typeof module2 !== "undefined") {
          module2.exports = factory2();
        } else if (typeof define === "function" && define.amd) {
          define([], factory2);
        } else if (typeof window !== "undefined") {
          window.isWindows = factory2();
        } else if (typeof global !== "undefined") {
          global.isWindows = factory2();
        } else if (typeof self !== "undefined") {
          self.isWindows = factory2();
        } else {
          this.isWindows = factory2();
        }
      })(function() {
        "use strict";
        return function isWindows() {
          return define_process_default && (define_process_default.platform === "win32" || /^(msys|cygwin)$/.test(define_process_default.env.OSTYPE));
        };
      });
    }
  });

  // node_modules/base/node_modules/define-property/index.js
  var require_define_property2 = __commonJS({
    "node_modules/base/node_modules/define-property/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isDescriptor = require_is_descriptor();
      module2.exports = function defineProperty2(obj, prop, val) {
        if (typeof obj !== "object" && typeof obj !== "function") {
          throw new TypeError("expected an object or function.");
        }
        if (typeof prop !== "string") {
          throw new TypeError("expected `prop` to be a string.");
        }
        if (isDescriptor(val) && ("set" in val || "get" in val)) {
          return Object.defineProperty(obj, prop, val);
        }
        return Object.defineProperty(obj, prop, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
      };
    }
  });

  // node_modules/component-emitter/index.js
  var require_component_emitter = __commonJS({
    "node_modules/component-emitter/index.js"(exports2, module2) {
      init_define_process();
      if (typeof module2 !== "undefined") {
        module2.exports = Emitter;
      }
      function Emitter(obj) {
        if (obj)
          return mixin3(obj);
      }
      function mixin3(obj) {
        for (var key in Emitter.prototype) {
          obj[key] = Emitter.prototype[key];
        }
        return obj;
      }
      Emitter.prototype.on = Emitter.prototype.addEventListener = function(event, fn) {
        this._callbacks = this._callbacks || {};
        (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
        return this;
      };
      Emitter.prototype.once = function(event, fn) {
        function on() {
          this.off(event, on);
          fn.apply(this, arguments);
        }
        on.fn = fn;
        this.on(event, on);
        return this;
      };
      Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event, fn) {
        this._callbacks = this._callbacks || {};
        if (0 == arguments.length) {
          this._callbacks = {};
          return this;
        }
        var callbacks = this._callbacks["$" + event];
        if (!callbacks)
          return this;
        if (1 == arguments.length) {
          delete this._callbacks["$" + event];
          return this;
        }
        var cb;
        for (var i = 0; i < callbacks.length; i++) {
          cb = callbacks[i];
          if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
          }
        }
        if (callbacks.length === 0) {
          delete this._callbacks["$" + event];
        }
        return this;
      };
      Emitter.prototype.emit = function(event) {
        this._callbacks = this._callbacks || {};
        var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
        if (callbacks) {
          callbacks = callbacks.slice(0);
          for (var i = 0, len = callbacks.length; i < len; ++i) {
            callbacks[i].apply(this, args);
          }
        }
        return this;
      };
      Emitter.prototype.listeners = function(event) {
        this._callbacks = this._callbacks || {};
        return this._callbacks["$" + event] || [];
      };
      Emitter.prototype.hasListeners = function(event) {
        return !!this.listeners(event).length;
      };
    }
  });

  // node_modules/object-visit/index.js
  var require_object_visit = __commonJS({
    "node_modules/object-visit/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      module2.exports = function visit(thisArg, method2, target, val) {
        if (!isObject2(thisArg) && typeof thisArg !== "function") {
          throw new Error("object-visit expects `thisArg` to be an object.");
        }
        if (typeof method2 !== "string") {
          throw new Error("object-visit expects `method` name to be a string");
        }
        if (typeof thisArg[method2] !== "function") {
          return thisArg;
        }
        var args = [].slice.call(arguments, 3);
        target = target || {};
        for (var key in target) {
          var arr = [key, target[key]].concat(args);
          thisArg[method2].apply(thisArg, arr);
        }
        return thisArg;
      };
    }
  });

  // node_modules/map-visit/index.js
  var require_map_visit = __commonJS({
    "node_modules/map-visit/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var util = require_util();
      var visit = require_object_visit();
      module2.exports = function mapVisit(collection, method2, val) {
        if (isObject2(val)) {
          return visit.apply(null, arguments);
        }
        if (!Array.isArray(val)) {
          throw new TypeError("expected an array: " + util.inspect(val));
        }
        var args = [].slice.call(arguments, 3);
        for (var i = 0; i < val.length; i++) {
          var ele = val[i];
          if (isObject2(ele)) {
            visit.apply(null, [collection, method2, ele].concat(args));
          } else {
            collection[method2].apply(collection, [ele].concat(args));
          }
        }
      };
      function isObject2(val) {
        return val && (typeof val === "function" || !Array.isArray(val) && typeof val === "object");
      }
    }
  });

  // node_modules/collection-visit/index.js
  var require_collection_visit = __commonJS({
    "node_modules/collection-visit/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var visit = require_object_visit();
      var mapVisit = require_map_visit();
      module2.exports = function(collection, method2, val) {
        var result2;
        if (typeof val === "string" && method2 in collection) {
          var args = [].slice.call(arguments, 2);
          result2 = collection[method2].apply(collection, args);
        } else if (Array.isArray(val)) {
          result2 = mapVisit.apply(null, arguments);
        } else {
          result2 = visit.apply(null, arguments);
        }
        if (typeof result2 !== "undefined") {
          return result2;
        }
        return collection;
      };
    }
  });

  // node_modules/is-buffer/index.js
  var require_is_buffer = __commonJS({
    "node_modules/is-buffer/index.js"(exports2, module2) {
      init_define_process();
      module2.exports = function(obj) {
        return obj != null && (isBuffer2(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
      };
      function isBuffer2(obj) {
        return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
      }
      function isSlowBuffer(obj) {
        return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer2(obj.slice(0, 0));
      }
    }
  });

  // node_modules/kind-of/index.js
  var require_kind_of4 = __commonJS({
    "node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var isBuffer2 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // node_modules/to-object-path/index.js
  var require_to_object_path = __commonJS({
    "node_modules/to-object-path/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of4();
      module2.exports = function toPath2(args) {
        if (typeOf(args) !== "arguments") {
          args = arguments;
        }
        return filter2(args).join(".");
      };
      function filter2(arr) {
        var len = arr.length;
        var idx = -1;
        var res = [];
        while (++idx < len) {
          var ele = arr[idx];
          if (typeOf(ele) === "arguments" || Array.isArray(ele)) {
            res.push.apply(res, filter2(ele));
          } else if (typeof ele === "string") {
            res.push(ele);
          }
        }
        return res;
      }
    }
  });

  // node_modules/is-extendable/index.js
  var require_is_extendable2 = __commonJS({
    "node_modules/is-extendable/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function isExtendable(val) {
        return typeof val !== "undefined" && val !== null && (typeof val === "object" || typeof val === "function");
      };
    }
  });

  // node_modules/arr-union/index.js
  var require_arr_union = __commonJS({
    "node_modules/arr-union/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function union2(init) {
        if (!Array.isArray(init)) {
          throw new TypeError("arr-union expects the first argument to be an array.");
        }
        var len = arguments.length;
        var i = 0;
        while (++i < len) {
          var arg = arguments[i];
          if (!arg)
            continue;
          if (!Array.isArray(arg)) {
            arg = [arg];
          }
          for (var j = 0; j < arg.length; j++) {
            var ele = arg[j];
            if (init.indexOf(ele) >= 0) {
              continue;
            }
            init.push(ele);
          }
        }
        return init;
      };
    }
  });

  // node_modules/get-value/index.js
  var require_get_value = __commonJS({
    "node_modules/get-value/index.js"(exports2, module2) {
      init_define_process();
      module2.exports = function(obj, prop, a, b, c) {
        if (!isObject2(obj) || !prop) {
          return obj;
        }
        prop = toString2(prop);
        if (a)
          prop += "." + toString2(a);
        if (b)
          prop += "." + toString2(b);
        if (c)
          prop += "." + toString2(c);
        if (prop in obj) {
          return obj[prop];
        }
        var segs = prop.split(".");
        var len = segs.length;
        var i = -1;
        while (obj && ++i < len) {
          var key = segs[i];
          while (key[key.length - 1] === "\\") {
            key = key.slice(0, -1) + "." + segs[++i];
          }
          obj = obj[key];
        }
        return obj;
      };
      function isObject2(val) {
        return val !== null && (typeof val === "object" || typeof val === "function");
      }
      function toString2(val) {
        if (!val)
          return "";
        if (Array.isArray(val)) {
          return val.join(".");
        }
        return val;
      }
    }
  });

  // node_modules/split-string/index.js
  var require_split_string = __commonJS({
    "node_modules/split-string/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var extend = require_extend_shallow();
      module2.exports = function(str, options, fn) {
        if (typeof str !== "string") {
          throw new TypeError("expected a string");
        }
        if (typeof options === "function") {
          fn = options;
          options = null;
        }
        if (typeof options === "string") {
          options = { sep: options };
        }
        var opts = extend({ sep: "." }, options);
        var quotes = opts.quotes || ['"', "'", "`"];
        var brackets;
        if (opts.brackets === true) {
          brackets = {
            "<": ">",
            "(": ")",
            "[": "]",
            "{": "}"
          };
        } else if (opts.brackets) {
          brackets = opts.brackets;
        }
        var tokens = [];
        var stack = [];
        var arr = [""];
        var sep = opts.sep;
        var len = str.length;
        var idx = -1;
        var closeIdx;
        function expected() {
          if (brackets && stack.length) {
            return brackets[stack[stack.length - 1]];
          }
        }
        while (++idx < len) {
          var ch = str[idx];
          var next = str[idx + 1];
          var tok = { val: ch, idx, arr, str };
          tokens.push(tok);
          if (ch === "\\") {
            tok.val = keepEscaping(opts, str, idx) === true ? ch + next : next;
            tok.escaped = true;
            if (typeof fn === "function") {
              fn(tok);
            }
            arr[arr.length - 1] += tok.val;
            idx++;
            continue;
          }
          if (brackets && brackets[ch]) {
            stack.push(ch);
            var e = expected();
            var i = idx + 1;
            if (str.indexOf(e, i + 1) !== -1) {
              while (stack.length && i < len) {
                var s = str[++i];
                if (s === "\\") {
                  s++;
                  continue;
                }
                if (quotes.indexOf(s) !== -1) {
                  i = getClosingQuote(str, s, i + 1);
                  continue;
                }
                e = expected();
                if (stack.length && str.indexOf(e, i + 1) === -1) {
                  break;
                }
                if (brackets[s]) {
                  stack.push(s);
                  continue;
                }
                if (e === s) {
                  stack.pop();
                }
              }
            }
            closeIdx = i;
            if (closeIdx === -1) {
              arr[arr.length - 1] += ch;
              continue;
            }
            ch = str.slice(idx, closeIdx + 1);
            tok.val = ch;
            tok.idx = idx = closeIdx;
          }
          if (quotes.indexOf(ch) !== -1) {
            closeIdx = getClosingQuote(str, ch, idx + 1);
            if (closeIdx === -1) {
              arr[arr.length - 1] += ch;
              continue;
            }
            if (keepQuotes(ch, opts) === true) {
              ch = str.slice(idx, closeIdx + 1);
            } else {
              ch = str.slice(idx + 1, closeIdx);
            }
            tok.val = ch;
            tok.idx = idx = closeIdx;
          }
          if (typeof fn === "function") {
            fn(tok, tokens);
            ch = tok.val;
            idx = tok.idx;
          }
          if (tok.val === sep && tok.split !== false) {
            arr.push("");
            continue;
          }
          arr[arr.length - 1] += tok.val;
        }
        return arr;
      };
      function getClosingQuote(str, ch, i, brackets) {
        var idx = str.indexOf(ch, i);
        if (str.charAt(idx - 1) === "\\") {
          return getClosingQuote(str, ch, idx + 1);
        }
        return idx;
      }
      function keepQuotes(ch, opts) {
        if (opts.keepDoubleQuotes === true && ch === '"')
          return true;
        if (opts.keepSingleQuotes === true && ch === "'")
          return true;
        return opts.keepQuotes;
      }
      function keepEscaping(opts, str, idx) {
        if (typeof opts.keepEscaping === "function") {
          return opts.keepEscaping(str, idx);
        }
        return opts.keepEscaping === true || str[idx + 1] === "\\";
      }
    }
  });

  // node_modules/set-value/node_modules/extend-shallow/index.js
  var require_extend_shallow2 = __commonJS({
    "node_modules/set-value/node_modules/extend-shallow/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_is_extendable2();
      module2.exports = function extend(o) {
        if (!isObject2(o)) {
          o = {};
        }
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
          var obj = arguments[i];
          if (isObject2(obj)) {
            assign2(o, obj);
          }
        }
        return o;
      };
      function assign2(a, b) {
        for (var key in b) {
          if (hasOwn(b, key)) {
            a[key] = b[key];
          }
        }
      }
      function hasOwn(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
    }
  });

  // node_modules/set-value/index.js
  var require_set_value = __commonJS({
    "node_modules/set-value/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var split2 = require_split_string();
      var extend = require_extend_shallow2();
      var isPlainObject2 = require_is_plain_object();
      var isObject2 = require_is_extendable2();
      module2.exports = function(obj, prop, val) {
        if (!isObject2(obj)) {
          return obj;
        }
        if (Array.isArray(prop)) {
          prop = [].concat.apply([], prop).join(".");
        }
        if (typeof prop !== "string") {
          return obj;
        }
        var keys2 = split2(prop, { sep: ".", brackets: true }).filter(isValidKey);
        var len = keys2.length;
        var idx = -1;
        var current = obj;
        while (++idx < len) {
          var key = keys2[idx];
          if (idx !== len - 1) {
            if (!isObject2(current[key])) {
              current[key] = {};
            }
            current = current[key];
            continue;
          }
          if (isPlainObject2(current[key]) && isPlainObject2(val)) {
            current[key] = extend({}, current[key], val);
          } else {
            current[key] = val;
          }
        }
        return obj;
      };
      function isValidKey(key) {
        return key !== "__proto__" && key !== "constructor" && key !== "prototype";
      }
    }
  });

  // node_modules/union-value/index.js
  var require_union_value = __commonJS({
    "node_modules/union-value/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_is_extendable2();
      var union2 = require_arr_union();
      var get2 = require_get_value();
      var set2 = require_set_value();
      module2.exports = function unionValue(obj, prop, value) {
        if (!isObject2(obj)) {
          throw new TypeError("union-value expects the first argument to be an object.");
        }
        if (typeof prop !== "string") {
          throw new TypeError("union-value expects `prop` to be a string.");
        }
        var arr = arrayify(get2(obj, prop));
        set2(obj, prop, union2(arr, arrayify(value)));
        return obj;
      };
      function arrayify(val) {
        if (val === null || typeof val === "undefined") {
          return [];
        }
        if (Array.isArray(val)) {
          return val;
        }
        return [val];
      }
    }
  });

  // node_modules/isarray/index.js
  var require_isarray = __commonJS({
    "node_modules/isarray/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = {}.toString;
      module2.exports = Array.isArray || function(arr) {
        return toString2.call(arr) == "[object Array]";
      };
    }
  });

  // node_modules/unset-value/node_modules/has-value/node_modules/isobject/index.js
  var require_isobject2 = __commonJS({
    "node_modules/unset-value/node_modules/has-value/node_modules/isobject/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isArray2 = require_isarray();
      module2.exports = function isObject2(val) {
        return val != null && typeof val === "object" && isArray2(val) === false;
      };
    }
  });

  // node_modules/unset-value/node_modules/has-values/index.js
  var require_has_values = __commonJS({
    "node_modules/unset-value/node_modules/has-values/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function hasValue(o, noZero) {
        if (o === null || o === void 0) {
          return false;
        }
        if (typeof o === "boolean") {
          return true;
        }
        if (typeof o === "number") {
          if (o === 0 && noZero === true) {
            return false;
          }
          return true;
        }
        if (o.length !== void 0) {
          return o.length !== 0;
        }
        for (var key in o) {
          if (o.hasOwnProperty(key)) {
            return true;
          }
        }
        return false;
      };
    }
  });

  // node_modules/unset-value/node_modules/has-value/index.js
  var require_has_value = __commonJS({
    "node_modules/unset-value/node_modules/has-value/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject2();
      var hasValues = require_has_values();
      var get2 = require_get_value();
      module2.exports = function(obj, prop, noZero) {
        if (isObject2(obj)) {
          return hasValues(get2(obj, prop), noZero);
        }
        return hasValues(obj, prop);
      };
    }
  });

  // node_modules/unset-value/index.js
  var require_unset_value = __commonJS({
    "node_modules/unset-value/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      var has2 = require_has_value();
      module2.exports = function unset2(obj, prop) {
        if (!isObject2(obj)) {
          throw new TypeError("expected an object.");
        }
        if (obj.hasOwnProperty(prop)) {
          delete obj[prop];
          return true;
        }
        if (has2(obj, prop)) {
          var segs = prop.split(".");
          var last2 = segs.pop();
          while (segs.length && segs[segs.length - 1].slice(-1) === "\\") {
            last2 = segs.pop().slice(0, -1) + "." + last2;
          }
          while (segs.length)
            obj = obj[prop = segs.shift()];
          return delete obj[last2];
        }
        return true;
      };
    }
  });

  // node_modules/has-values/node_modules/kind-of/index.js
  var require_kind_of5 = __commonJS({
    "node_modules/has-values/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var isBuffer2 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (type === "[object Promise]") {
          return "promise";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // node_modules/has-values/node_modules/is-number/node_modules/kind-of/index.js
  var require_kind_of6 = __commonJS({
    "node_modules/has-values/node_modules/is-number/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var isBuffer2 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // node_modules/has-values/node_modules/is-number/index.js
  var require_is_number = __commonJS({
    "node_modules/has-values/node_modules/is-number/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of6();
      module2.exports = function isNumber2(num) {
        var type = typeOf(num);
        if (type === "string") {
          if (!num.trim())
            return false;
        } else if (type !== "number") {
          return false;
        }
        return num - num + 1 >= 0;
      };
    }
  });

  // node_modules/has-values/index.js
  var require_has_values2 = __commonJS({
    "node_modules/has-values/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of5();
      var isNumber2 = require_is_number();
      module2.exports = function hasValue(val) {
        if (isNumber2(val)) {
          return true;
        }
        switch (typeOf(val)) {
          case "null":
          case "boolean":
          case "function":
            return true;
          case "string":
          case "arguments":
            return val.length !== 0;
          case "error":
            return val.message !== "";
          case "array":
            var len = val.length;
            if (len === 0) {
              return false;
            }
            for (var i = 0; i < len; i++) {
              if (hasValue(val[i])) {
                return true;
              }
            }
            return false;
          case "file":
          case "map":
          case "set":
            return val.size !== 0;
          case "object":
            var keys2 = Object.keys(val);
            if (keys2.length === 0) {
              return false;
            }
            for (var i = 0; i < keys2.length; i++) {
              var key = keys2[i];
              if (hasValue(val[key])) {
                return true;
              }
            }
            return false;
          default: {
            return false;
          }
        }
      };
    }
  });

  // node_modules/has-value/index.js
  var require_has_value2 = __commonJS({
    "node_modules/has-value/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      var hasValues = require_has_values2();
      var get2 = require_get_value();
      module2.exports = function(val, prop) {
        return hasValues(isObject2(val) && prop ? get2(val, prop) : val);
      };
    }
  });

  // node_modules/cache-base/index.js
  var require_cache_base = __commonJS({
    "node_modules/cache-base/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      var Emitter = require_component_emitter();
      var visit = require_collection_visit();
      var toPath2 = require_to_object_path();
      var union2 = require_union_value();
      var del = require_unset_value();
      var get2 = require_get_value();
      var has2 = require_has_value2();
      var set2 = require_set_value();
      function namespace(prop) {
        function Cache(cache) {
          if (prop) {
            this[prop] = {};
          }
          if (cache) {
            this.set(cache);
          }
        }
        Emitter(Cache.prototype);
        Cache.prototype.set = function(key, val) {
          if (Array.isArray(key) && arguments.length === 2) {
            key = toPath2(key);
          }
          if (isObject2(key) || Array.isArray(key)) {
            this.visit("set", key);
          } else {
            set2(prop ? this[prop] : this, key, val);
            this.emit("set", key, val);
          }
          return this;
        };
        Cache.prototype.union = function(key, val) {
          if (Array.isArray(key) && arguments.length === 2) {
            key = toPath2(key);
          }
          var ctx = prop ? this[prop] : this;
          union2(ctx, key, arrayify(val));
          this.emit("union", val);
          return this;
        };
        Cache.prototype.get = function(key) {
          key = toPath2(arguments);
          var ctx = prop ? this[prop] : this;
          var val = get2(ctx, key);
          this.emit("get", key, val);
          return val;
        };
        Cache.prototype.has = function(key) {
          key = toPath2(arguments);
          var ctx = prop ? this[prop] : this;
          var val = get2(ctx, key);
          var has3 = typeof val !== "undefined";
          this.emit("has", key, has3);
          return has3;
        };
        Cache.prototype.del = function(key) {
          if (Array.isArray(key)) {
            this.visit("del", key);
          } else {
            del(prop ? this[prop] : this, key);
            this.emit("del", key);
          }
          return this;
        };
        Cache.prototype.clear = function() {
          if (prop) {
            this[prop] = {};
          }
        };
        Cache.prototype.visit = function(method2, val) {
          visit(this, method2, val);
          return this;
        };
        return Cache;
      }
      function arrayify(val) {
        return val ? Array.isArray(val) ? val : [val] : [];
      }
      module2.exports = namespace();
      module2.exports.namespace = namespace;
    }
  });

  // node_modules/mixin-deep/node_modules/is-extendable/index.js
  var require_is_extendable3 = __commonJS({
    "node_modules/mixin-deep/node_modules/is-extendable/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isPlainObject2 = require_is_plain_object();
      module2.exports = function isExtendable(val) {
        return isPlainObject2(val) || typeof val === "function" || Array.isArray(val);
      };
    }
  });

  // node_modules/for-in/index.js
  var require_for_in = __commonJS({
    "node_modules/for-in/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function forIn2(obj, fn, thisArg) {
        for (var key in obj) {
          if (fn.call(thisArg, obj[key], key, obj) === false) {
            break;
          }
        }
      };
    }
  });

  // node_modules/mixin-deep/index.js
  var require_mixin_deep = __commonJS({
    "node_modules/mixin-deep/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isExtendable = require_is_extendable3();
      var forIn2 = require_for_in();
      function mixinDeep(target, objects) {
        var len = arguments.length, i = 0;
        while (++i < len) {
          var obj = arguments[i];
          if (isObject2(obj)) {
            forIn2(obj, copy, target);
          }
        }
        return target;
      }
      function copy(val, key) {
        if (!isValidKey(key)) {
          return;
        }
        var obj = this[key];
        if (isObject2(val) && isObject2(obj)) {
          mixinDeep(obj, val);
        } else {
          this[key] = val;
        }
      }
      function isObject2(val) {
        return isExtendable(val) && !Array.isArray(val);
      }
      function isValidKey(key) {
        return key !== "__proto__" && key !== "constructor" && key !== "prototype";
      }
      module2.exports = mixinDeep;
    }
  });

  // node_modules/pascalcase/index.js
  var require_pascalcase = __commonJS({
    "node_modules/pascalcase/index.js"(exports2, module2) {
      init_define_process();
      function pascalcase(str) {
        if (typeof str !== "string") {
          throw new TypeError("expected a string.");
        }
        str = str.replace(/([A-Z])/g, " $1");
        if (str.length === 1) {
          return str.toUpperCase();
        }
        str = str.replace(/^[\W_]+|[\W_]+$/g, "").toLowerCase();
        str = str.charAt(0).toUpperCase() + str.slice(1);
        return str.replace(/[\W_]+(\w|$)/g, function(_, ch) {
          return ch.toUpperCase();
        });
      }
      module2.exports = pascalcase;
    }
  });

  // node_modules/define-property/node_modules/kind-of/index.js
  var require_kind_of7 = __commonJS({
    "node_modules/define-property/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        var type = typeof val;
        if (type === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (type === "string" || val instanceof String) {
          return "string";
        }
        if (type === "number" || val instanceof Number) {
          return "number";
        }
        if (type === "function" || val instanceof Function) {
          if (typeof val.constructor.name !== "undefined" && val.constructor.name.slice(0, 9) === "Generator") {
            return "generatorfunction";
          }
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (type === "[object Promise]") {
          return "promise";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Map Iterator]") {
          return "mapiterator";
        }
        if (type === "[object Set Iterator]") {
          return "setiterator";
        }
        if (type === "[object String Iterator]") {
          return "stringiterator";
        }
        if (type === "[object Array Iterator]") {
          return "arrayiterator";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
      function isBuffer2(val) {
        return val.constructor && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
      }
    }
  });

  // node_modules/define-property/node_modules/is-accessor-descriptor/node_modules/kind-of/index.js
  var require_kind_of8 = __commonJS({
    "node_modules/define-property/node_modules/is-accessor-descriptor/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var isBuffer2 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // node_modules/define-property/node_modules/is-accessor-descriptor/index.js
  var require_is_accessor_descriptor2 = __commonJS({
    "node_modules/define-property/node_modules/is-accessor-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of8();
      var accessor = {
        get: "function",
        set: "function",
        configurable: "boolean",
        enumerable: "boolean"
      };
      function isAccessorDescriptor(obj, prop) {
        if (typeof prop === "string") {
          var val = Object.getOwnPropertyDescriptor(obj, prop);
          return typeof val !== "undefined";
        }
        if (typeOf(obj) !== "object") {
          return false;
        }
        if (has2(obj, "value") || has2(obj, "writable")) {
          return false;
        }
        if (!has2(obj, "get") || typeof obj.get !== "function") {
          return false;
        }
        if (has2(obj, "set") && typeof obj[key] !== "function" && typeof obj[key] !== "undefined") {
          return false;
        }
        for (var key in obj) {
          if (!accessor.hasOwnProperty(key)) {
            continue;
          }
          if (typeOf(obj[key]) === accessor[key]) {
            continue;
          }
          if (typeof obj[key] !== "undefined") {
            return false;
          }
        }
        return true;
      }
      function has2(obj, key) {
        return {}.hasOwnProperty.call(obj, key);
      }
      module2.exports = isAccessorDescriptor;
    }
  });

  // node_modules/define-property/node_modules/is-data-descriptor/node_modules/kind-of/index.js
  var require_kind_of9 = __commonJS({
    "node_modules/define-property/node_modules/is-data-descriptor/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var isBuffer2 = require_is_buffer();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (typeof val === "undefined") {
          return "undefined";
        }
        if (val === null) {
          return "null";
        }
        if (val === true || val === false || val instanceof Boolean) {
          return "boolean";
        }
        if (typeof val === "string" || val instanceof String) {
          return "string";
        }
        if (typeof val === "number" || val instanceof Number) {
          return "number";
        }
        if (typeof val === "function" || val instanceof Function) {
          return "function";
        }
        if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
          return "array";
        }
        if (val instanceof RegExp) {
          return "regexp";
        }
        if (val instanceof Date) {
          return "date";
        }
        var type = toString2.call(val);
        if (type === "[object RegExp]") {
          return "regexp";
        }
        if (type === "[object Date]") {
          return "date";
        }
        if (type === "[object Arguments]") {
          return "arguments";
        }
        if (type === "[object Error]") {
          return "error";
        }
        if (isBuffer2(val)) {
          return "buffer";
        }
        if (type === "[object Set]") {
          return "set";
        }
        if (type === "[object WeakSet]") {
          return "weakset";
        }
        if (type === "[object Map]") {
          return "map";
        }
        if (type === "[object WeakMap]") {
          return "weakmap";
        }
        if (type === "[object Symbol]") {
          return "symbol";
        }
        if (type === "[object Int8Array]") {
          return "int8array";
        }
        if (type === "[object Uint8Array]") {
          return "uint8array";
        }
        if (type === "[object Uint8ClampedArray]") {
          return "uint8clampedarray";
        }
        if (type === "[object Int16Array]") {
          return "int16array";
        }
        if (type === "[object Uint16Array]") {
          return "uint16array";
        }
        if (type === "[object Int32Array]") {
          return "int32array";
        }
        if (type === "[object Uint32Array]") {
          return "uint32array";
        }
        if (type === "[object Float32Array]") {
          return "float32array";
        }
        if (type === "[object Float64Array]") {
          return "float64array";
        }
        return "object";
      };
    }
  });

  // node_modules/define-property/node_modules/is-data-descriptor/index.js
  var require_is_data_descriptor2 = __commonJS({
    "node_modules/define-property/node_modules/is-data-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of9();
      var data = {
        configurable: "boolean",
        enumerable: "boolean",
        writable: "boolean"
      };
      function isDataDescriptor(obj, prop) {
        if (typeOf(obj) !== "object") {
          return false;
        }
        if (typeof prop === "string") {
          var val = Object.getOwnPropertyDescriptor(obj, prop);
          return typeof val !== "undefined";
        }
        if (!("value" in obj) && !("writable" in obj)) {
          return false;
        }
        for (var key in obj) {
          if (key === "value")
            continue;
          if (!data.hasOwnProperty(key)) {
            continue;
          }
          if (typeOf(obj[key]) === data[key]) {
            continue;
          }
          if (typeof obj[key] !== "undefined") {
            return false;
          }
        }
        return true;
      }
      module2.exports = isDataDescriptor;
    }
  });

  // node_modules/define-property/node_modules/is-descriptor/index.js
  var require_is_descriptor2 = __commonJS({
    "node_modules/define-property/node_modules/is-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of7();
      var isAccessor = require_is_accessor_descriptor2();
      var isData = require_is_data_descriptor2();
      module2.exports = function isDescriptor(obj, key) {
        if (typeOf(obj) !== "object") {
          return false;
        }
        if ("get" in obj) {
          return isAccessor(obj, key);
        }
        return isData(obj, key);
      };
    }
  });

  // node_modules/define-property/index.js
  var require_define_property3 = __commonJS({
    "node_modules/define-property/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isDescriptor = require_is_descriptor2();
      module2.exports = function defineProperty2(obj, prop, val) {
        if (typeof obj !== "object" && typeof obj !== "function") {
          throw new TypeError("expected an object or function.");
        }
        if (typeof prop !== "string") {
          throw new TypeError("expected `prop` to be a string.");
        }
        if (isDescriptor(val) && ("set" in val || "get" in val)) {
          return Object.defineProperty(obj, prop, val);
        }
        return Object.defineProperty(obj, prop, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
      };
    }
  });

  // node_modules/copy-descriptor/index.js
  var require_copy_descriptor = __commonJS({
    "node_modules/copy-descriptor/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function copyDescriptor(receiver, provider, from, to) {
        if (!isObject2(provider) && typeof provider !== "function") {
          to = from;
          from = provider;
          provider = receiver;
        }
        if (!isObject2(receiver) && typeof receiver !== "function") {
          throw new TypeError("expected the first argument to be an object");
        }
        if (!isObject2(provider) && typeof provider !== "function") {
          throw new TypeError("expected provider to be an object");
        }
        if (typeof to !== "string") {
          to = from;
        }
        if (typeof from !== "string") {
          throw new TypeError("expected key to be a string");
        }
        if (!(from in provider)) {
          throw new Error('property "' + from + '" does not exist');
        }
        var val = Object.getOwnPropertyDescriptor(provider, from);
        if (val)
          Object.defineProperty(receiver, to, val);
      };
      function isObject2(val) {
        return {}.toString.call(val) === "[object Object]";
      }
    }
  });

  // node_modules/object-copy/index.js
  var require_object_copy = __commonJS({
    "node_modules/object-copy/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var typeOf = require_kind_of4();
      var copyDescriptor = require_copy_descriptor();
      var define2 = require_define_property3();
      function copy(receiver, provider, omit2) {
        if (!isObject2(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!isObject2(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        var props = nativeKeys2(provider);
        var keys2 = Object.keys(provider);
        var len = props.length;
        omit2 = arrayify(omit2);
        while (len--) {
          var key = props[len];
          if (has2(keys2, key)) {
            define2(receiver, key, provider[key]);
          } else if (!(key in receiver) && !has2(omit2, key)) {
            copyDescriptor(receiver, provider, key);
          }
        }
      }
      function isObject2(val) {
        return typeOf(val) === "object" || typeof val === "function";
      }
      function has2(obj, val) {
        val = arrayify(val);
        var len = val.length;
        if (isObject2(obj)) {
          for (var key in obj) {
            if (val.indexOf(key) > -1) {
              return true;
            }
          }
          var keys2 = nativeKeys2(obj);
          return has2(keys2, val);
        }
        if (Array.isArray(obj)) {
          var arr = obj;
          while (len--) {
            if (arr.indexOf(val[len]) > -1) {
              return true;
            }
          }
          return false;
        }
        throw new TypeError("expected an array or object.");
      }
      function arrayify(val) {
        return val ? Array.isArray(val) ? val : [val] : [];
      }
      function hasConstructor(val) {
        return isObject2(val) && typeof val.constructor !== "undefined";
      }
      function nativeKeys2(val) {
        if (!hasConstructor(val))
          return [];
        return Object.getOwnPropertyNames(val);
      }
      module2.exports = copy;
      module2.exports.has = has2;
    }
  });

  // node_modules/static-extend/index.js
  var require_static_extend = __commonJS({
    "node_modules/static-extend/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var copy = require_object_copy();
      var define2 = require_define_property3();
      var util = require_util();
      function extend(Parent, extendFn) {
        if (typeof Parent !== "function") {
          throw new TypeError("expected Parent to be a function.");
        }
        return function(Ctor, proto) {
          if (typeof Ctor !== "function") {
            throw new TypeError("expected Ctor to be a function.");
          }
          util.inherits(Ctor, Parent);
          copy(Ctor, Parent);
          if (typeof proto === "object") {
            var obj = Object.create(proto);
            for (var k in obj) {
              Ctor.prototype[k] = obj[k];
            }
          }
          define2(Ctor.prototype, "_parent_", {
            configurable: true,
            set: function() {
            },
            get: function() {
              return Parent.prototype;
            }
          });
          if (typeof extendFn === "function") {
            extendFn(Ctor, Parent);
          }
          Ctor.extend = extend(Ctor, extendFn);
        };
      }
      module2.exports = extend;
    }
  });

  // node_modules/class-utils/index.js
  var require_class_utils = __commonJS({
    "node_modules/class-utils/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var util = require_util();
      var union2 = require_arr_union();
      var define2 = require_define_property3();
      var staticExtend = require_static_extend();
      var isObj = require_isobject();
      var cu = module2.exports;
      cu.isObject = function isObject2(val) {
        return isObj(val) || typeof val === "function";
      };
      cu.has = function has2(obj, val) {
        val = cu.arrayify(val);
        var len = val.length;
        if (cu.isObject(obj)) {
          for (var key in obj) {
            if (val.indexOf(key) > -1) {
              return true;
            }
          }
          var keys2 = cu.nativeKeys(obj);
          return cu.has(keys2, val);
        }
        if (Array.isArray(obj)) {
          var arr = obj;
          while (len--) {
            if (arr.indexOf(val[len]) > -1) {
              return true;
            }
          }
          return false;
        }
        throw new TypeError("expected an array or object.");
      };
      cu.hasAll = function hasAll(val, values2) {
        values2 = cu.arrayify(values2);
        var len = values2.length;
        while (len--) {
          if (!cu.has(val, values2[len])) {
            return false;
          }
        }
        return true;
      };
      cu.arrayify = function arrayify(val) {
        return val ? Array.isArray(val) ? val : [val] : [];
      };
      cu.noop = function noop3() {
        return;
      };
      cu.identity = function identity2(val) {
        return val;
      };
      cu.hasConstructor = function hasConstructor(val) {
        return cu.isObject(val) && typeof val.constructor !== "undefined";
      };
      cu.nativeKeys = function nativeKeys2(val) {
        if (!cu.hasConstructor(val))
          return [];
        var keys2 = Object.getOwnPropertyNames(val);
        if ("caller" in val)
          keys2.push("caller");
        return keys2;
      };
      cu.getDescriptor = function getDescriptor(obj, key) {
        if (!cu.isObject(obj)) {
          throw new TypeError("expected an object.");
        }
        if (typeof key !== "string") {
          throw new TypeError("expected key to be a string.");
        }
        return Object.getOwnPropertyDescriptor(obj, key);
      };
      cu.copyDescriptor = function copyDescriptor(receiver, provider, name) {
        if (!cu.isObject(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!cu.isObject(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        if (typeof name !== "string") {
          throw new TypeError("expected name to be a string.");
        }
        var val = cu.getDescriptor(provider, name);
        if (val)
          Object.defineProperty(receiver, name, val);
      };
      cu.copy = function copy(receiver, provider, omit2) {
        if (!cu.isObject(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!cu.isObject(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        var props = Object.getOwnPropertyNames(provider);
        var keys2 = Object.keys(provider);
        var len = props.length, key;
        omit2 = cu.arrayify(omit2);
        while (len--) {
          key = props[len];
          if (cu.has(keys2, key)) {
            define2(receiver, key, provider[key]);
          } else if (!(key in receiver) && !cu.has(omit2, key)) {
            cu.copyDescriptor(receiver, provider, key);
          }
        }
      };
      cu.inherit = function inherit(receiver, provider, omit2) {
        if (!cu.isObject(receiver)) {
          throw new TypeError("expected receiving object to be an object.");
        }
        if (!cu.isObject(provider)) {
          throw new TypeError("expected providing object to be an object.");
        }
        var keys2 = [];
        for (var key in provider) {
          keys2.push(key);
          receiver[key] = provider[key];
        }
        keys2 = keys2.concat(cu.arrayify(omit2));
        var a = provider.prototype || provider;
        var b = receiver.prototype || receiver;
        cu.copy(b, a, keys2);
      };
      cu.extend = function() {
        return staticExtend.apply(null, arguments);
      };
      cu.bubble = function(Parent, events) {
        events = events || [];
        Parent.bubble = function(Child, arr) {
          if (Array.isArray(arr)) {
            events = union2([], events, arr);
          }
          var len = events.length;
          var idx = -1;
          while (++idx < len) {
            var name = events[idx];
            Parent.on(name, Child.emit.bind(Child, name));
          }
          cu.bubble(Child, events);
        };
      };
    }
  });

  // node_modules/base/index.js
  var require_base = __commonJS({
    "node_modules/base/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var util = require_util();
      var define2 = require_define_property2();
      var CacheBase = require_cache_base();
      var Emitter = require_component_emitter();
      var isObject2 = require_isobject();
      var merge2 = require_mixin_deep();
      var pascal = require_pascalcase();
      var cu = require_class_utils();
      function namespace(name) {
        var Cache = name ? CacheBase.namespace(name) : CacheBase;
        var fns = [];
        function Base(config, options) {
          if (!(this instanceof Base)) {
            return new Base(config, options);
          }
          Cache.call(this, config);
          this.is("base");
          this.initBase(config, options);
        }
        util.inherits(Base, Cache);
        Emitter(Base);
        Base.prototype.initBase = function(config, options) {
          this.options = merge2({}, this.options, options);
          this.cache = this.cache || {};
          this.define("registered", {});
          if (name)
            this[name] = {};
          this.define("_callbacks", this._callbacks);
          if (isObject2(config)) {
            this.visit("set", config);
          }
          Base.run(this, "use", fns);
        };
        Base.prototype.is = function(name2) {
          if (typeof name2 !== "string") {
            throw new TypeError("expected name to be a string");
          }
          this.define("is" + pascal(name2), true);
          this.define("_name", name2);
          this.define("_appname", name2);
          return this;
        };
        Base.prototype.isRegistered = function(name2, register) {
          if (this.registered.hasOwnProperty(name2)) {
            return true;
          }
          if (register !== false) {
            this.registered[name2] = true;
            this.emit("plugin", name2);
          }
          return false;
        };
        Base.prototype.use = function(fn) {
          fn.call(this, this);
          return this;
        };
        Base.prototype.define = function(key, val) {
          if (isObject2(key)) {
            return this.visit("define", key);
          }
          define2(this, key, val);
          return this;
        };
        Base.prototype.mixin = function(key, val) {
          Base.prototype[key] = val;
          return this;
        };
        Base.prototype.mixins = Base.prototype.mixins || [];
        Object.defineProperty(Base.prototype, "base", {
          configurable: true,
          get: function() {
            return this.parent ? this.parent.base : this;
          }
        });
        define2(Base, "use", function(fn) {
          fns.push(fn);
          return Base;
        });
        define2(Base, "run", function(obj, prop, arr) {
          var len = arr.length, i = 0;
          while (len--) {
            obj[prop](arr[i++]);
          }
          return Base;
        });
        define2(Base, "extend", cu.extend(Base, function(Ctor, Parent) {
          Ctor.prototype.mixins = Ctor.prototype.mixins || [];
          define2(Ctor, "mixin", function(fn) {
            var mixin3 = fn(Ctor.prototype, Ctor);
            if (typeof mixin3 === "function") {
              Ctor.prototype.mixins.push(mixin3);
            }
            return Ctor;
          });
          define2(Ctor, "mixins", function(Child) {
            Base.run(Child, "mixin", Ctor.prototype.mixins);
            return Ctor;
          });
          Ctor.prototype.mixin = function(key, value) {
            Ctor.prototype[key] = value;
            return this;
          };
          return Base;
        }));
        define2(Base, "mixin", function(fn) {
          var mixin3 = fn(Base.prototype, Base);
          if (typeof mixin3 === "function") {
            Base.prototype.mixins.push(mixin3);
          }
          return Base;
        });
        define2(Base, "mixins", function(Child) {
          Base.run(Child, "mixin", Base.prototype.mixins);
          return Base;
        });
        define2(Base, "inherit", cu.inherit);
        define2(Base, "bubble", cu.bubble);
        return Base;
      }
      module2.exports = namespace();
      module2.exports.namespace = namespace;
    }
  });

  // node_modules/use/index.js
  var require_use = __commonJS({
    "node_modules/use/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function base(app, options) {
        if (!isObject2(app) && typeof app !== "function") {
          throw new TypeError("expected an object or function");
        }
        var opts = isObject2(options) ? options : {};
        var prop = typeof opts.prop === "string" ? opts.prop : "fns";
        if (!Array.isArray(app[prop])) {
          define2(app, prop, []);
        }
        define2(app, "use", use);
        define2(app, "run", function(val) {
          if (!isObject2(val))
            return;
          if (!val.use || !val.run) {
            define2(val, prop, val[prop] || []);
            define2(val, "use", use);
          }
          if (!val[prop] || val[prop].indexOf(base) === -1) {
            val.use(base);
          }
          var self2 = this || app;
          var fns = self2[prop];
          var len = fns.length;
          var idx = -1;
          while (++idx < len) {
            val.use(fns[idx]);
          }
          return val;
        });
        function use(type, fn, options2) {
          var offset = 1;
          if (typeof type === "string" || Array.isArray(type)) {
            fn = wrap2(type, fn);
            offset++;
          } else {
            options2 = fn;
            fn = type;
          }
          if (typeof fn !== "function") {
            throw new TypeError("expected a function");
          }
          var self2 = this || app;
          var fns = self2[prop];
          var args = [].slice.call(arguments, offset);
          args.unshift(self2);
          if (typeof opts.hook === "function") {
            opts.hook.apply(self2, args);
          }
          var val = fn.apply(self2, args);
          if (typeof val === "function" && fns.indexOf(val) === -1) {
            fns.push(val);
          }
          return self2;
        }
        function wrap2(type, fn) {
          return function plugin() {
            return this.type === type ? fn.apply(this, arguments) : plugin;
          };
        }
        return app;
      };
      function isObject2(val) {
        return val && typeof val === "object" && !Array.isArray(val);
      }
      function define2(obj, key, val) {
        Object.defineProperty(obj, key, {
          configurable: true,
          writable: true,
          value: val
        });
      }
    }
  });

  // node_modules/snapdragon/node_modules/ms/index.js
  var require_ms = __commonJS({
    "node_modules/snapdragon/node_modules/ms/index.js"(exports2, module2) {
      init_define_process();
      var s = 1e3;
      var m = s * 60;
      var h = m * 60;
      var d = h * 24;
      var y = d * 365.25;
      module2.exports = function(val, options) {
        options = options || {};
        var type = typeof val;
        if (type === "string" && val.length > 0) {
          return parse3(val);
        } else if (type === "number" && isNaN(val) === false) {
          return options.long ? fmtLong(val) : fmtShort(val);
        }
        throw new Error(
          "val is not a non-empty string or a valid number. val=" + JSON.stringify(val)
        );
      };
      function parse3(str) {
        str = String(str);
        if (str.length > 100) {
          return;
        }
        var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
          str
        );
        if (!match) {
          return;
        }
        var n = parseFloat(match[1]);
        var type = (match[2] || "ms").toLowerCase();
        switch (type) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return n * y;
          case "days":
          case "day":
          case "d":
            return n * d;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return n * h;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return n * m;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return n * s;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return n;
          default:
            return void 0;
        }
      }
      function fmtShort(ms) {
        if (ms >= d) {
          return Math.round(ms / d) + "d";
        }
        if (ms >= h) {
          return Math.round(ms / h) + "h";
        }
        if (ms >= m) {
          return Math.round(ms / m) + "m";
        }
        if (ms >= s) {
          return Math.round(ms / s) + "s";
        }
        return ms + "ms";
      }
      function fmtLong(ms) {
        return plural(ms, d, "day") || plural(ms, h, "hour") || plural(ms, m, "minute") || plural(ms, s, "second") || ms + " ms";
      }
      function plural(ms, n, name) {
        if (ms < n) {
          return;
        }
        if (ms < n * 1.5) {
          return Math.floor(ms / n) + " " + name;
        }
        return Math.ceil(ms / n) + " " + name + "s";
      }
    }
  });

  // node_modules/snapdragon/node_modules/debug/src/debug.js
  var require_debug = __commonJS({
    "node_modules/snapdragon/node_modules/debug/src/debug.js"(exports2, module2) {
      init_define_process();
      exports2 = module2.exports = createDebug2.debug = createDebug2["default"] = createDebug2;
      exports2.coerce = coerce;
      exports2.disable = disable;
      exports2.enable = enable;
      exports2.enabled = enabled;
      exports2.humanize = require_ms();
      exports2.names = [];
      exports2.skips = [];
      exports2.formatters = {};
      var prevTime;
      function selectColor(namespace) {
        var hash = 0, i;
        for (i in namespace) {
          hash = (hash << 5) - hash + namespace.charCodeAt(i);
          hash |= 0;
        }
        return exports2.colors[Math.abs(hash) % exports2.colors.length];
      }
      function createDebug2(namespace) {
        function debug2() {
          if (!debug2.enabled)
            return;
          var self2 = debug2;
          var curr = +new Date();
          var ms = curr - (prevTime || curr);
          self2.diff = ms;
          self2.prev = prevTime;
          self2.curr = curr;
          prevTime = curr;
          var args = new Array(arguments.length);
          for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i];
          }
          args[0] = exports2.coerce(args[0]);
          if ("string" !== typeof args[0]) {
            args.unshift("%O");
          }
          var index = 0;
          args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            if (match === "%%")
              return match;
            index++;
            var formatter = exports2.formatters[format];
            if ("function" === typeof formatter) {
              var val = args[index];
              match = formatter.call(self2, val);
              args.splice(index, 1);
              index--;
            }
            return match;
          });
          exports2.formatArgs.call(self2, args);
          var logFn = debug2.log || exports2.log || console.log.bind(console);
          logFn.apply(self2, args);
        }
        debug2.namespace = namespace;
        debug2.enabled = exports2.enabled(namespace);
        debug2.useColors = exports2.useColors();
        debug2.color = selectColor(namespace);
        if ("function" === typeof exports2.init) {
          exports2.init(debug2);
        }
        return debug2;
      }
      function enable(namespaces) {
        exports2.save(namespaces);
        exports2.names = [];
        exports2.skips = [];
        var split2 = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        var len = split2.length;
        for (var i = 0; i < len; i++) {
          if (!split2[i])
            continue;
          namespaces = split2[i].replace(/\*/g, ".*?");
          if (namespaces[0] === "-") {
            exports2.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
          } else {
            exports2.names.push(new RegExp("^" + namespaces + "$"));
          }
        }
      }
      function disable() {
        exports2.enable("");
      }
      function enabled(name) {
        var i, len;
        for (i = 0, len = exports2.skips.length; i < len; i++) {
          if (exports2.skips[i].test(name)) {
            return false;
          }
        }
        for (i = 0, len = exports2.names.length; i < len; i++) {
          if (exports2.names[i].test(name)) {
            return true;
          }
        }
        return false;
      }
      function coerce(val) {
        if (val instanceof Error)
          return val.stack || val.message;
        return val;
      }
    }
  });

  // node_modules/snapdragon/node_modules/debug/src/browser.js
  var require_browser = __commonJS({
    "node_modules/snapdragon/node_modules/debug/src/browser.js"(exports2, module2) {
      init_define_process();
      exports2 = module2.exports = require_debug();
      exports2.log = log;
      exports2.formatArgs = formatArgs;
      exports2.save = save;
      exports2.load = load;
      exports2.useColors = useColors;
      exports2.storage = "undefined" != typeof chrome && "undefined" != typeof chrome.storage ? chrome.storage.local : localstorage();
      exports2.colors = [
        "lightseagreen",
        "forestgreen",
        "goldenrod",
        "dodgerblue",
        "darkorchid",
        "crimson"
      ];
      function useColors() {
        if (typeof window !== "undefined" && window.process && window.process.type === "renderer") {
          return true;
        }
        return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }
      exports2.formatters.j = function(v) {
        try {
          return JSON.stringify(v);
        } catch (err) {
          return "[UnexpectedJSONParseError]: " + err.message;
        }
      };
      function formatArgs(args) {
        var useColors2 = this.useColors;
        args[0] = (useColors2 ? "%c" : "") + this.namespace + (useColors2 ? " %c" : " ") + args[0] + (useColors2 ? "%c " : " ") + "+" + exports2.humanize(this.diff);
        if (!useColors2)
          return;
        var c = "color: " + this.color;
        args.splice(1, 0, c, "color: inherit");
        var index = 0;
        var lastC = 0;
        args[0].replace(/%[a-zA-Z%]/g, function(match) {
          if ("%%" === match)
            return;
          index++;
          if ("%c" === match) {
            lastC = index;
          }
        });
        args.splice(lastC, 0, c);
      }
      function log() {
        return "object" === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
      }
      function save(namespaces) {
        try {
          if (null == namespaces) {
            exports2.storage.removeItem("debug");
          } else {
            exports2.storage.debug = namespaces;
          }
        } catch (e) {
        }
      }
      function load() {
        var r;
        try {
          r = exports2.storage.debug;
        } catch (e) {
        }
        if (!r && typeof define_process_default !== "undefined" && "env" in define_process_default) {
          r = define_process_default.env.DEBUG;
        }
        return r;
      }
      exports2.enable(load());
      function localstorage() {
        try {
          return window.localStorage;
        } catch (e) {
        }
      }
    }
  });

  // node_modules/snapdragon/node_modules/extend-shallow/index.js
  var require_extend_shallow3 = __commonJS({
    "node_modules/snapdragon/node_modules/extend-shallow/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_is_extendable2();
      module2.exports = function extend(o) {
        if (!isObject2(o)) {
          o = {};
        }
        var len = arguments.length;
        for (var i = 1; i < len; i++) {
          var obj = arguments[i];
          if (isObject2(obj)) {
            assign2(o, obj);
          }
        }
        return o;
      };
      function assign2(a, b) {
        for (var key in b) {
          if (hasOwn(b, key)) {
            a[key] = b[key];
          }
        }
      }
      function hasOwn(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/base64.js
  var require_base64 = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/base64.js"(exports2) {
      init_define_process();
      var intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
      exports2.encode = function(number) {
        if (0 <= number && number < intToCharMap.length) {
          return intToCharMap[number];
        }
        throw new TypeError("Must be between 0 and 63: " + number);
      };
      exports2.decode = function(charCode) {
        var bigA = 65;
        var bigZ = 90;
        var littleA = 97;
        var littleZ = 122;
        var zero = 48;
        var nine = 57;
        var plus = 43;
        var slash = 47;
        var littleOffset = 26;
        var numberOffset = 52;
        if (bigA <= charCode && charCode <= bigZ) {
          return charCode - bigA;
        }
        if (littleA <= charCode && charCode <= littleZ) {
          return charCode - littleA + littleOffset;
        }
        if (zero <= charCode && charCode <= nine) {
          return charCode - zero + numberOffset;
        }
        if (charCode == plus) {
          return 62;
        }
        if (charCode == slash) {
          return 63;
        }
        return -1;
      };
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/base64-vlq.js
  var require_base64_vlq = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/base64-vlq.js"(exports2) {
      init_define_process();
      var base64 = require_base64();
      var VLQ_BASE_SHIFT = 5;
      var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
      var VLQ_BASE_MASK = VLQ_BASE - 1;
      var VLQ_CONTINUATION_BIT = VLQ_BASE;
      function toVLQSigned(aValue) {
        return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
      }
      function fromVLQSigned(aValue) {
        var isNegative = (aValue & 1) === 1;
        var shifted = aValue >> 1;
        return isNegative ? -shifted : shifted;
      }
      exports2.encode = function base64VLQ_encode(aValue) {
        var encoded = "";
        var digit;
        var vlq = toVLQSigned(aValue);
        do {
          digit = vlq & VLQ_BASE_MASK;
          vlq >>>= VLQ_BASE_SHIFT;
          if (vlq > 0) {
            digit |= VLQ_CONTINUATION_BIT;
          }
          encoded += base64.encode(digit);
        } while (vlq > 0);
        return encoded;
      };
      exports2.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
        var strLen = aStr.length;
        var result2 = 0;
        var shift = 0;
        var continuation, digit;
        do {
          if (aIndex >= strLen) {
            throw new Error("Expected more digits in base 64 VLQ value.");
          }
          digit = base64.decode(aStr.charCodeAt(aIndex++));
          if (digit === -1) {
            throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
          }
          continuation = !!(digit & VLQ_CONTINUATION_BIT);
          digit &= VLQ_BASE_MASK;
          result2 = result2 + (digit << shift);
          shift += VLQ_BASE_SHIFT;
        } while (continuation);
        aOutParam.value = fromVLQSigned(result2);
        aOutParam.rest = aIndex;
      };
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/util.js
  var require_util3 = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/util.js"(exports2) {
      init_define_process();
      function getArg(aArgs, aName, aDefaultValue) {
        if (aName in aArgs) {
          return aArgs[aName];
        } else if (arguments.length === 3) {
          return aDefaultValue;
        } else {
          throw new Error('"' + aName + '" is a required argument.');
        }
      }
      exports2.getArg = getArg;
      var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
      var dataUrlRegexp = /^data:.+\,.+$/;
      function urlParse(aUrl) {
        var match = aUrl.match(urlRegexp);
        if (!match) {
          return null;
        }
        return {
          scheme: match[1],
          auth: match[2],
          host: match[3],
          port: match[4],
          path: match[5]
        };
      }
      exports2.urlParse = urlParse;
      function urlGenerate(aParsedUrl) {
        var url = "";
        if (aParsedUrl.scheme) {
          url += aParsedUrl.scheme + ":";
        }
        url += "//";
        if (aParsedUrl.auth) {
          url += aParsedUrl.auth + "@";
        }
        if (aParsedUrl.host) {
          url += aParsedUrl.host;
        }
        if (aParsedUrl.port) {
          url += ":" + aParsedUrl.port;
        }
        if (aParsedUrl.path) {
          url += aParsedUrl.path;
        }
        return url;
      }
      exports2.urlGenerate = urlGenerate;
      function normalize(aPath) {
        var path = aPath;
        var url = urlParse(aPath);
        if (url) {
          if (!url.path) {
            return aPath;
          }
          path = url.path;
        }
        var isAbsolute = exports2.isAbsolute(path);
        var parts = path.split(/\/+/);
        for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
          part = parts[i];
          if (part === ".") {
            parts.splice(i, 1);
          } else if (part === "..") {
            up++;
          } else if (up > 0) {
            if (part === "") {
              parts.splice(i + 1, up);
              up = 0;
            } else {
              parts.splice(i, 2);
              up--;
            }
          }
        }
        path = parts.join("/");
        if (path === "") {
          path = isAbsolute ? "/" : ".";
        }
        if (url) {
          url.path = path;
          return urlGenerate(url);
        }
        return path;
      }
      exports2.normalize = normalize;
      function join2(aRoot, aPath) {
        if (aRoot === "") {
          aRoot = ".";
        }
        if (aPath === "") {
          aPath = ".";
        }
        var aPathUrl = urlParse(aPath);
        var aRootUrl = urlParse(aRoot);
        if (aRootUrl) {
          aRoot = aRootUrl.path || "/";
        }
        if (aPathUrl && !aPathUrl.scheme) {
          if (aRootUrl) {
            aPathUrl.scheme = aRootUrl.scheme;
          }
          return urlGenerate(aPathUrl);
        }
        if (aPathUrl || aPath.match(dataUrlRegexp)) {
          return aPath;
        }
        if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
          aRootUrl.host = aPath;
          return urlGenerate(aRootUrl);
        }
        var joined = aPath.charAt(0) === "/" ? aPath : normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
        if (aRootUrl) {
          aRootUrl.path = joined;
          return urlGenerate(aRootUrl);
        }
        return joined;
      }
      exports2.join = join2;
      exports2.isAbsolute = function(aPath) {
        return aPath.charAt(0) === "/" || !!aPath.match(urlRegexp);
      };
      function relative(aRoot, aPath) {
        if (aRoot === "") {
          aRoot = ".";
        }
        aRoot = aRoot.replace(/\/$/, "");
        var level = 0;
        while (aPath.indexOf(aRoot + "/") !== 0) {
          var index = aRoot.lastIndexOf("/");
          if (index < 0) {
            return aPath;
          }
          aRoot = aRoot.slice(0, index);
          if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
            return aPath;
          }
          ++level;
        }
        return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
      }
      exports2.relative = relative;
      var supportsNullProto = function() {
        var obj = /* @__PURE__ */ Object.create(null);
        return !("__proto__" in obj);
      }();
      function identity2(s) {
        return s;
      }
      function toSetString(aStr) {
        if (isProtoString(aStr)) {
          return "$" + aStr;
        }
        return aStr;
      }
      exports2.toSetString = supportsNullProto ? identity2 : toSetString;
      function fromSetString(aStr) {
        if (isProtoString(aStr)) {
          return aStr.slice(1);
        }
        return aStr;
      }
      exports2.fromSetString = supportsNullProto ? identity2 : fromSetString;
      function isProtoString(s) {
        if (!s) {
          return false;
        }
        var length = s.length;
        if (length < 9) {
          return false;
        }
        if (s.charCodeAt(length - 1) !== 95 || s.charCodeAt(length - 2) !== 95 || s.charCodeAt(length - 3) !== 111 || s.charCodeAt(length - 4) !== 116 || s.charCodeAt(length - 5) !== 111 || s.charCodeAt(length - 6) !== 114 || s.charCodeAt(length - 7) !== 112 || s.charCodeAt(length - 8) !== 95 || s.charCodeAt(length - 9) !== 95) {
          return false;
        }
        for (var i = length - 10; i >= 0; i--) {
          if (s.charCodeAt(i) !== 36) {
            return false;
          }
        }
        return true;
      }
      function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
        var cmp = mappingA.source - mappingB.source;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalLine - mappingB.originalLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalColumn - mappingB.originalColumn;
        if (cmp !== 0 || onlyCompareOriginal) {
          return cmp;
        }
        cmp = mappingA.generatedColumn - mappingB.generatedColumn;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.generatedLine - mappingB.generatedLine;
        if (cmp !== 0) {
          return cmp;
        }
        return mappingA.name - mappingB.name;
      }
      exports2.compareByOriginalPositions = compareByOriginalPositions;
      function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
        var cmp = mappingA.generatedLine - mappingB.generatedLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.generatedColumn - mappingB.generatedColumn;
        if (cmp !== 0 || onlyCompareGenerated) {
          return cmp;
        }
        cmp = mappingA.source - mappingB.source;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalLine - mappingB.originalLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalColumn - mappingB.originalColumn;
        if (cmp !== 0) {
          return cmp;
        }
        return mappingA.name - mappingB.name;
      }
      exports2.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
      function strcmp(aStr1, aStr2) {
        if (aStr1 === aStr2) {
          return 0;
        }
        if (aStr1 > aStr2) {
          return 1;
        }
        return -1;
      }
      function compareByGeneratedPositionsInflated(mappingA, mappingB) {
        var cmp = mappingA.generatedLine - mappingB.generatedLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.generatedColumn - mappingB.generatedColumn;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = strcmp(mappingA.source, mappingB.source);
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalLine - mappingB.originalLine;
        if (cmp !== 0) {
          return cmp;
        }
        cmp = mappingA.originalColumn - mappingB.originalColumn;
        if (cmp !== 0) {
          return cmp;
        }
        return strcmp(mappingA.name, mappingB.name);
      }
      exports2.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/array-set.js
  var require_array_set = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/array-set.js"(exports2) {
      init_define_process();
      var util = require_util3();
      var has2 = Object.prototype.hasOwnProperty;
      var hasNativeMap = typeof Map !== "undefined";
      function ArraySet() {
        this._array = [];
        this._set = hasNativeMap ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
      }
      ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
        var set2 = new ArraySet();
        for (var i = 0, len = aArray.length; i < len; i++) {
          set2.add(aArray[i], aAllowDuplicates);
        }
        return set2;
      };
      ArraySet.prototype.size = function ArraySet_size() {
        return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
      };
      ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
        var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
        var isDuplicate = hasNativeMap ? this.has(aStr) : has2.call(this._set, sStr);
        var idx = this._array.length;
        if (!isDuplicate || aAllowDuplicates) {
          this._array.push(aStr);
        }
        if (!isDuplicate) {
          if (hasNativeMap) {
            this._set.set(aStr, idx);
          } else {
            this._set[sStr] = idx;
          }
        }
      };
      ArraySet.prototype.has = function ArraySet_has(aStr) {
        if (hasNativeMap) {
          return this._set.has(aStr);
        } else {
          var sStr = util.toSetString(aStr);
          return has2.call(this._set, sStr);
        }
      };
      ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
        if (hasNativeMap) {
          var idx = this._set.get(aStr);
          if (idx >= 0) {
            return idx;
          }
        } else {
          var sStr = util.toSetString(aStr);
          if (has2.call(this._set, sStr)) {
            return this._set[sStr];
          }
        }
        throw new Error('"' + aStr + '" is not in the set.');
      };
      ArraySet.prototype.at = function ArraySet_at(aIdx) {
        if (aIdx >= 0 && aIdx < this._array.length) {
          return this._array[aIdx];
        }
        throw new Error("No element indexed by " + aIdx);
      };
      ArraySet.prototype.toArray = function ArraySet_toArray() {
        return this._array.slice();
      };
      exports2.ArraySet = ArraySet;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/mapping-list.js
  var require_mapping_list = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/mapping-list.js"(exports2) {
      init_define_process();
      var util = require_util3();
      function generatedPositionAfter(mappingA, mappingB) {
        var lineA = mappingA.generatedLine;
        var lineB = mappingB.generatedLine;
        var columnA = mappingA.generatedColumn;
        var columnB = mappingB.generatedColumn;
        return lineB > lineA || lineB == lineA && columnB >= columnA || util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
      }
      function MappingList() {
        this._array = [];
        this._sorted = true;
        this._last = { generatedLine: -1, generatedColumn: 0 };
      }
      MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
        this._array.forEach(aCallback, aThisArg);
      };
      MappingList.prototype.add = function MappingList_add(aMapping) {
        if (generatedPositionAfter(this._last, aMapping)) {
          this._last = aMapping;
          this._array.push(aMapping);
        } else {
          this._sorted = false;
          this._array.push(aMapping);
        }
      };
      MappingList.prototype.toArray = function MappingList_toArray() {
        if (!this._sorted) {
          this._array.sort(util.compareByGeneratedPositionsInflated);
          this._sorted = true;
        }
        return this._array;
      };
      exports2.MappingList = MappingList;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/source-map-generator.js
  var require_source_map_generator = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/source-map-generator.js"(exports2) {
      init_define_process();
      var base64VLQ = require_base64_vlq();
      var util = require_util3();
      var ArraySet = require_array_set().ArraySet;
      var MappingList = require_mapping_list().MappingList;
      function SourceMapGenerator(aArgs) {
        if (!aArgs) {
          aArgs = {};
        }
        this._file = util.getArg(aArgs, "file", null);
        this._sourceRoot = util.getArg(aArgs, "sourceRoot", null);
        this._skipValidation = util.getArg(aArgs, "skipValidation", false);
        this._sources = new ArraySet();
        this._names = new ArraySet();
        this._mappings = new MappingList();
        this._sourcesContents = null;
      }
      SourceMapGenerator.prototype._version = 3;
      SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
        var sourceRoot = aSourceMapConsumer.sourceRoot;
        var generator = new SourceMapGenerator({
          file: aSourceMapConsumer.file,
          sourceRoot
        });
        aSourceMapConsumer.eachMapping(function(mapping) {
          var newMapping = {
            generated: {
              line: mapping.generatedLine,
              column: mapping.generatedColumn
            }
          };
          if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) {
              newMapping.source = util.relative(sourceRoot, newMapping.source);
            }
            newMapping.original = {
              line: mapping.originalLine,
              column: mapping.originalColumn
            };
            if (mapping.name != null) {
              newMapping.name = mapping.name;
            }
          }
          generator.addMapping(newMapping);
        });
        aSourceMapConsumer.sources.forEach(function(sourceFile) {
          var content = aSourceMapConsumer.sourceContentFor(sourceFile);
          if (content != null) {
            generator.setSourceContent(sourceFile, content);
          }
        });
        return generator;
      };
      SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
        var generated = util.getArg(aArgs, "generated");
        var original = util.getArg(aArgs, "original", null);
        var source = util.getArg(aArgs, "source", null);
        var name = util.getArg(aArgs, "name", null);
        if (!this._skipValidation) {
          this._validateMapping(generated, original, source, name);
        }
        if (source != null) {
          source = String(source);
          if (!this._sources.has(source)) {
            this._sources.add(source);
          }
        }
        if (name != null) {
          name = String(name);
          if (!this._names.has(name)) {
            this._names.add(name);
          }
        }
        this._mappings.add({
          generatedLine: generated.line,
          generatedColumn: generated.column,
          originalLine: original != null && original.line,
          originalColumn: original != null && original.column,
          source,
          name
        });
      };
      SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
        var source = aSourceFile;
        if (this._sourceRoot != null) {
          source = util.relative(this._sourceRoot, source);
        }
        if (aSourceContent != null) {
          if (!this._sourcesContents) {
            this._sourcesContents = /* @__PURE__ */ Object.create(null);
          }
          this._sourcesContents[util.toSetString(source)] = aSourceContent;
        } else if (this._sourcesContents) {
          delete this._sourcesContents[util.toSetString(source)];
          if (Object.keys(this._sourcesContents).length === 0) {
            this._sourcesContents = null;
          }
        }
      };
      SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
        var sourceFile = aSourceFile;
        if (aSourceFile == null) {
          if (aSourceMapConsumer.file == null) {
            throw new Error(
              `SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`
            );
          }
          sourceFile = aSourceMapConsumer.file;
        }
        var sourceRoot = this._sourceRoot;
        if (sourceRoot != null) {
          sourceFile = util.relative(sourceRoot, sourceFile);
        }
        var newSources = new ArraySet();
        var newNames = new ArraySet();
        this._mappings.unsortedForEach(function(mapping) {
          if (mapping.source === sourceFile && mapping.originalLine != null) {
            var original = aSourceMapConsumer.originalPositionFor({
              line: mapping.originalLine,
              column: mapping.originalColumn
            });
            if (original.source != null) {
              mapping.source = original.source;
              if (aSourceMapPath != null) {
                mapping.source = util.join(aSourceMapPath, mapping.source);
              }
              if (sourceRoot != null) {
                mapping.source = util.relative(sourceRoot, mapping.source);
              }
              mapping.originalLine = original.line;
              mapping.originalColumn = original.column;
              if (original.name != null) {
                mapping.name = original.name;
              }
            }
          }
          var source = mapping.source;
          if (source != null && !newSources.has(source)) {
            newSources.add(source);
          }
          var name = mapping.name;
          if (name != null && !newNames.has(name)) {
            newNames.add(name);
          }
        }, this);
        this._sources = newSources;
        this._names = newNames;
        aSourceMapConsumer.sources.forEach(function(sourceFile2) {
          var content = aSourceMapConsumer.sourceContentFor(sourceFile2);
          if (content != null) {
            if (aSourceMapPath != null) {
              sourceFile2 = util.join(aSourceMapPath, sourceFile2);
            }
            if (sourceRoot != null) {
              sourceFile2 = util.relative(sourceRoot, sourceFile2);
            }
            this.setSourceContent(sourceFile2, content);
          }
        }, this);
      };
      SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
        if (aOriginal && typeof aOriginal.line !== "number" && typeof aOriginal.column !== "number") {
          throw new Error(
            "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values."
          );
        }
        if (aGenerated && "line" in aGenerated && "column" in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) {
          return;
        } else if (aGenerated && "line" in aGenerated && "column" in aGenerated && aOriginal && "line" in aOriginal && "column" in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) {
          return;
        } else {
          throw new Error("Invalid mapping: " + JSON.stringify({
            generated: aGenerated,
            source: aSource,
            original: aOriginal,
            name: aName
          }));
        }
      };
      SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
        var previousGeneratedColumn = 0;
        var previousGeneratedLine = 1;
        var previousOriginalColumn = 0;
        var previousOriginalLine = 0;
        var previousName = 0;
        var previousSource = 0;
        var result2 = "";
        var next;
        var mapping;
        var nameIdx;
        var sourceIdx;
        var mappings = this._mappings.toArray();
        for (var i = 0, len = mappings.length; i < len; i++) {
          mapping = mappings[i];
          next = "";
          if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while (mapping.generatedLine !== previousGeneratedLine) {
              next += ";";
              previousGeneratedLine++;
            }
          } else {
            if (i > 0) {
              if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
                continue;
              }
              next += ",";
            }
          }
          next += base64VLQ.encode(mapping.generatedColumn - previousGeneratedColumn);
          previousGeneratedColumn = mapping.generatedColumn;
          if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += base64VLQ.encode(sourceIdx - previousSource);
            previousSource = sourceIdx;
            next += base64VLQ.encode(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += base64VLQ.encode(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
              nameIdx = this._names.indexOf(mapping.name);
              next += base64VLQ.encode(nameIdx - previousName);
              previousName = nameIdx;
            }
          }
          result2 += next;
        }
        return result2;
      };
      SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
        return aSources.map(function(source) {
          if (!this._sourcesContents) {
            return null;
          }
          if (aSourceRoot != null) {
            source = util.relative(aSourceRoot, source);
          }
          var key = util.toSetString(source);
          return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
        }, this);
      };
      SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
        var map2 = {
          version: this._version,
          sources: this._sources.toArray(),
          names: this._names.toArray(),
          mappings: this._serializeMappings()
        };
        if (this._file != null) {
          map2.file = this._file;
        }
        if (this._sourceRoot != null) {
          map2.sourceRoot = this._sourceRoot;
        }
        if (this._sourcesContents) {
          map2.sourcesContent = this._generateSourcesContent(map2.sources, map2.sourceRoot);
        }
        return map2;
      };
      SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
        return JSON.stringify(this.toJSON());
      };
      exports2.SourceMapGenerator = SourceMapGenerator;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/binary-search.js
  var require_binary_search = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/binary-search.js"(exports2) {
      init_define_process();
      exports2.GREATEST_LOWER_BOUND = 1;
      exports2.LEAST_UPPER_BOUND = 2;
      function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
        var mid = Math.floor((aHigh - aLow) / 2) + aLow;
        var cmp = aCompare(aNeedle, aHaystack[mid], true);
        if (cmp === 0) {
          return mid;
        } else if (cmp > 0) {
          if (aHigh - mid > 1) {
            return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
          }
          if (aBias == exports2.LEAST_UPPER_BOUND) {
            return aHigh < aHaystack.length ? aHigh : -1;
          } else {
            return mid;
          }
        } else {
          if (mid - aLow > 1) {
            return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
          }
          if (aBias == exports2.LEAST_UPPER_BOUND) {
            return mid;
          } else {
            return aLow < 0 ? -1 : aLow;
          }
        }
      }
      exports2.search = function search(aNeedle, aHaystack, aCompare, aBias) {
        if (aHaystack.length === 0) {
          return -1;
        }
        var index = recursiveSearch(
          -1,
          aHaystack.length,
          aNeedle,
          aHaystack,
          aCompare,
          aBias || exports2.GREATEST_LOWER_BOUND
        );
        if (index < 0) {
          return -1;
        }
        while (index - 1 >= 0) {
          if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
            break;
          }
          --index;
        }
        return index;
      };
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/quick-sort.js
  var require_quick_sort = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/quick-sort.js"(exports2) {
      init_define_process();
      function swap(ary2, x, y) {
        var temp = ary2[x];
        ary2[x] = ary2[y];
        ary2[y] = temp;
      }
      function randomIntInRange(low, high) {
        return Math.round(low + Math.random() * (high - low));
      }
      function doQuickSort(ary2, comparator, p, r) {
        if (p < r) {
          var pivotIndex = randomIntInRange(p, r);
          var i = p - 1;
          swap(ary2, pivotIndex, r);
          var pivot = ary2[r];
          for (var j = p; j < r; j++) {
            if (comparator(ary2[j], pivot) <= 0) {
              i += 1;
              swap(ary2, i, j);
            }
          }
          swap(ary2, i + 1, j);
          var q = i + 1;
          doQuickSort(ary2, comparator, p, q - 1);
          doQuickSort(ary2, comparator, q + 1, r);
        }
      }
      exports2.quickSort = function(ary2, comparator) {
        doQuickSort(ary2, comparator, 0, ary2.length - 1);
      };
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/source-map-consumer.js
  var require_source_map_consumer = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/source-map-consumer.js"(exports2) {
      init_define_process();
      var util = require_util3();
      var binarySearch = require_binary_search();
      var ArraySet = require_array_set().ArraySet;
      var base64VLQ = require_base64_vlq();
      var quickSort = require_quick_sort().quickSort;
      function SourceMapConsumer(aSourceMap) {
        var sourceMap = aSourceMap;
        if (typeof aSourceMap === "string") {
          sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
        }
        return sourceMap.sections != null ? new IndexedSourceMapConsumer(sourceMap) : new BasicSourceMapConsumer(sourceMap);
      }
      SourceMapConsumer.fromSourceMap = function(aSourceMap) {
        return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
      };
      SourceMapConsumer.prototype._version = 3;
      SourceMapConsumer.prototype.__generatedMappings = null;
      Object.defineProperty(SourceMapConsumer.prototype, "_generatedMappings", {
        get: function() {
          if (!this.__generatedMappings) {
            this._parseMappings(this._mappings, this.sourceRoot);
          }
          return this.__generatedMappings;
        }
      });
      SourceMapConsumer.prototype.__originalMappings = null;
      Object.defineProperty(SourceMapConsumer.prototype, "_originalMappings", {
        get: function() {
          if (!this.__originalMappings) {
            this._parseMappings(this._mappings, this.sourceRoot);
          }
          return this.__originalMappings;
        }
      });
      SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
        var c = aStr.charAt(index);
        return c === ";" || c === ",";
      };
      SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
        throw new Error("Subclasses must implement _parseMappings");
      };
      SourceMapConsumer.GENERATED_ORDER = 1;
      SourceMapConsumer.ORIGINAL_ORDER = 2;
      SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
      SourceMapConsumer.LEAST_UPPER_BOUND = 2;
      SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
        var context = aContext || null;
        var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
        var mappings;
        switch (order) {
          case SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
          case SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
          default:
            throw new Error("Unknown order of iteration.");
        }
        var sourceRoot = this.sourceRoot;
        mappings.map(function(mapping) {
          var source = mapping.source === null ? null : this._sources.at(mapping.source);
          if (source != null && sourceRoot != null) {
            source = util.join(sourceRoot, source);
          }
          return {
            source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
          };
        }, this).forEach(aCallback, context);
      };
      SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
        var line = util.getArg(aArgs, "line");
        var needle = {
          source: util.getArg(aArgs, "source"),
          originalLine: line,
          originalColumn: util.getArg(aArgs, "column", 0)
        };
        if (this.sourceRoot != null) {
          needle.source = util.relative(this.sourceRoot, needle.source);
        }
        if (!this._sources.has(needle.source)) {
          return [];
        }
        needle.source = this._sources.indexOf(needle.source);
        var mappings = [];
        var index = this._findMapping(
          needle,
          this._originalMappings,
          "originalLine",
          "originalColumn",
          util.compareByOriginalPositions,
          binarySearch.LEAST_UPPER_BOUND
        );
        if (index >= 0) {
          var mapping = this._originalMappings[index];
          if (aArgs.column === void 0) {
            var originalLine = mapping.originalLine;
            while (mapping && mapping.originalLine === originalLine) {
              mappings.push({
                line: util.getArg(mapping, "generatedLine", null),
                column: util.getArg(mapping, "generatedColumn", null),
                lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
              });
              mapping = this._originalMappings[++index];
            }
          } else {
            var originalColumn = mapping.originalColumn;
            while (mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn) {
              mappings.push({
                line: util.getArg(mapping, "generatedLine", null),
                column: util.getArg(mapping, "generatedColumn", null),
                lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
              });
              mapping = this._originalMappings[++index];
            }
          }
        }
        return mappings;
      };
      exports2.SourceMapConsumer = SourceMapConsumer;
      function BasicSourceMapConsumer(aSourceMap) {
        var sourceMap = aSourceMap;
        if (typeof aSourceMap === "string") {
          sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
        }
        var version = util.getArg(sourceMap, "version");
        var sources = util.getArg(sourceMap, "sources");
        var names = util.getArg(sourceMap, "names", []);
        var sourceRoot = util.getArg(sourceMap, "sourceRoot", null);
        var sourcesContent = util.getArg(sourceMap, "sourcesContent", null);
        var mappings = util.getArg(sourceMap, "mappings");
        var file2 = util.getArg(sourceMap, "file", null);
        if (version != this._version) {
          throw new Error("Unsupported version: " + version);
        }
        sources = sources.map(String).map(util.normalize).map(function(source) {
          return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source) ? util.relative(sourceRoot, source) : source;
        });
        this._names = ArraySet.fromArray(names.map(String), true);
        this._sources = ArraySet.fromArray(sources, true);
        this.sourceRoot = sourceRoot;
        this.sourcesContent = sourcesContent;
        this._mappings = mappings;
        this.file = file2;
      }
      BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
      BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
      BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap) {
        var smc = Object.create(BasicSourceMapConsumer.prototype);
        var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
        var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
        smc.sourceRoot = aSourceMap._sourceRoot;
        smc.sourcesContent = aSourceMap._generateSourcesContent(
          smc._sources.toArray(),
          smc.sourceRoot
        );
        smc.file = aSourceMap._file;
        var generatedMappings = aSourceMap._mappings.toArray().slice();
        var destGeneratedMappings = smc.__generatedMappings = [];
        var destOriginalMappings = smc.__originalMappings = [];
        for (var i = 0, length = generatedMappings.length; i < length; i++) {
          var srcMapping = generatedMappings[i];
          var destMapping = new Mapping();
          destMapping.generatedLine = srcMapping.generatedLine;
          destMapping.generatedColumn = srcMapping.generatedColumn;
          if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) {
              destMapping.name = names.indexOf(srcMapping.name);
            }
            destOriginalMappings.push(destMapping);
          }
          destGeneratedMappings.push(destMapping);
        }
        quickSort(smc.__originalMappings, util.compareByOriginalPositions);
        return smc;
      };
      BasicSourceMapConsumer.prototype._version = 3;
      Object.defineProperty(BasicSourceMapConsumer.prototype, "sources", {
        get: function() {
          return this._sources.toArray().map(function(s) {
            return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
          }, this);
        }
      });
      function Mapping() {
        this.generatedLine = 0;
        this.generatedColumn = 0;
        this.source = null;
        this.originalLine = null;
        this.originalColumn = null;
        this.name = null;
      }
      BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
        var generatedLine = 1;
        var previousGeneratedColumn = 0;
        var previousOriginalLine = 0;
        var previousOriginalColumn = 0;
        var previousSource = 0;
        var previousName = 0;
        var length = aStr.length;
        var index = 0;
        var cachedSegments = {};
        var temp = {};
        var originalMappings = [];
        var generatedMappings = [];
        var mapping, str, segment, end, value;
        while (index < length) {
          if (aStr.charAt(index) === ";") {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
          } else if (aStr.charAt(index) === ",") {
            index++;
          } else {
            mapping = new Mapping();
            mapping.generatedLine = generatedLine;
            for (end = index; end < length; end++) {
              if (this._charIsMappingSeparator(aStr, end)) {
                break;
              }
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) {
              index += str.length;
            } else {
              segment = [];
              while (index < end) {
                base64VLQ.decode(aStr, index, temp);
                value = temp.value;
                index = temp.rest;
                segment.push(value);
              }
              if (segment.length === 2) {
                throw new Error("Found a source, but no line and column");
              }
              if (segment.length === 3) {
                throw new Error("Found a source and line, but no column");
              }
              cachedSegments[str] = segment;
            }
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
              mapping.source = previousSource + segment[1];
              previousSource += segment[1];
              mapping.originalLine = previousOriginalLine + segment[2];
              previousOriginalLine = mapping.originalLine;
              mapping.originalLine += 1;
              mapping.originalColumn = previousOriginalColumn + segment[3];
              previousOriginalColumn = mapping.originalColumn;
              if (segment.length > 4) {
                mapping.name = previousName + segment[4];
                previousName += segment[4];
              }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === "number") {
              originalMappings.push(mapping);
            }
          }
        }
        quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
        this.__generatedMappings = generatedMappings;
        quickSort(originalMappings, util.compareByOriginalPositions);
        this.__originalMappings = originalMappings;
      };
      BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
        if (aNeedle[aLineName] <= 0) {
          throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
        }
        if (aNeedle[aColumnName] < 0) {
          throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
        }
        return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
      };
      BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
        for (var index = 0; index < this._generatedMappings.length; ++index) {
          var mapping = this._generatedMappings[index];
          if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
              mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
              continue;
            }
          }
          mapping.lastGeneratedColumn = Infinity;
        }
      };
      BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
        var needle = {
          generatedLine: util.getArg(aArgs, "line"),
          generatedColumn: util.getArg(aArgs, "column")
        };
        var index = this._findMapping(
          needle,
          this._generatedMappings,
          "generatedLine",
          "generatedColumn",
          util.compareByGeneratedPositionsDeflated,
          util.getArg(aArgs, "bias", SourceMapConsumer.GREATEST_LOWER_BOUND)
        );
        if (index >= 0) {
          var mapping = this._generatedMappings[index];
          if (mapping.generatedLine === needle.generatedLine) {
            var source = util.getArg(mapping, "source", null);
            if (source !== null) {
              source = this._sources.at(source);
              if (this.sourceRoot != null) {
                source = util.join(this.sourceRoot, source);
              }
            }
            var name = util.getArg(mapping, "name", null);
            if (name !== null) {
              name = this._names.at(name);
            }
            return {
              source,
              line: util.getArg(mapping, "originalLine", null),
              column: util.getArg(mapping, "originalColumn", null),
              name
            };
          }
        }
        return {
          source: null,
          line: null,
          column: null,
          name: null
        };
      };
      BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
        if (!this.sourcesContent) {
          return false;
        }
        return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
          return sc == null;
        });
      };
      BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
        if (!this.sourcesContent) {
          return null;
        }
        if (this.sourceRoot != null) {
          aSource = util.relative(this.sourceRoot, aSource);
        }
        if (this._sources.has(aSource)) {
          return this.sourcesContent[this._sources.indexOf(aSource)];
        }
        var url;
        if (this.sourceRoot != null && (url = util.urlParse(this.sourceRoot))) {
          var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
          if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) {
            return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
          }
          if ((!url.path || url.path == "/") && this._sources.has("/" + aSource)) {
            return this.sourcesContent[this._sources.indexOf("/" + aSource)];
          }
        }
        if (nullOnMissing) {
          return null;
        } else {
          throw new Error('"' + aSource + '" is not in the SourceMap.');
        }
      };
      BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
        var source = util.getArg(aArgs, "source");
        if (this.sourceRoot != null) {
          source = util.relative(this.sourceRoot, source);
        }
        if (!this._sources.has(source)) {
          return {
            line: null,
            column: null,
            lastColumn: null
          };
        }
        source = this._sources.indexOf(source);
        var needle = {
          source,
          originalLine: util.getArg(aArgs, "line"),
          originalColumn: util.getArg(aArgs, "column")
        };
        var index = this._findMapping(
          needle,
          this._originalMappings,
          "originalLine",
          "originalColumn",
          util.compareByOriginalPositions,
          util.getArg(aArgs, "bias", SourceMapConsumer.GREATEST_LOWER_BOUND)
        );
        if (index >= 0) {
          var mapping = this._originalMappings[index];
          if (mapping.source === needle.source) {
            return {
              line: util.getArg(mapping, "generatedLine", null),
              column: util.getArg(mapping, "generatedColumn", null),
              lastColumn: util.getArg(mapping, "lastGeneratedColumn", null)
            };
          }
        }
        return {
          line: null,
          column: null,
          lastColumn: null
        };
      };
      exports2.BasicSourceMapConsumer = BasicSourceMapConsumer;
      function IndexedSourceMapConsumer(aSourceMap) {
        var sourceMap = aSourceMap;
        if (typeof aSourceMap === "string") {
          sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
        }
        var version = util.getArg(sourceMap, "version");
        var sections = util.getArg(sourceMap, "sections");
        if (version != this._version) {
          throw new Error("Unsupported version: " + version);
        }
        this._sources = new ArraySet();
        this._names = new ArraySet();
        var lastOffset = {
          line: -1,
          column: 0
        };
        this._sections = sections.map(function(s) {
          if (s.url) {
            throw new Error("Support for url field in sections not implemented.");
          }
          var offset = util.getArg(s, "offset");
          var offsetLine = util.getArg(offset, "line");
          var offsetColumn = util.getArg(offset, "column");
          if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) {
            throw new Error("Section offsets must be ordered and non-overlapping.");
          }
          lastOffset = offset;
          return {
            generatedOffset: {
              generatedLine: offsetLine + 1,
              generatedColumn: offsetColumn + 1
            },
            consumer: new SourceMapConsumer(util.getArg(s, "map"))
          };
        });
      }
      IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
      IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
      IndexedSourceMapConsumer.prototype._version = 3;
      Object.defineProperty(IndexedSourceMapConsumer.prototype, "sources", {
        get: function() {
          var sources = [];
          for (var i = 0; i < this._sections.length; i++) {
            for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
              sources.push(this._sections[i].consumer.sources[j]);
            }
          }
          return sources;
        }
      });
      IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
        var needle = {
          generatedLine: util.getArg(aArgs, "line"),
          generatedColumn: util.getArg(aArgs, "column")
        };
        var sectionIndex = binarySearch.search(
          needle,
          this._sections,
          function(needle2, section2) {
            var cmp = needle2.generatedLine - section2.generatedOffset.generatedLine;
            if (cmp) {
              return cmp;
            }
            return needle2.generatedColumn - section2.generatedOffset.generatedColumn;
          }
        );
        var section = this._sections[sectionIndex];
        if (!section) {
          return {
            source: null,
            line: null,
            column: null,
            name: null
          };
        }
        return section.consumer.originalPositionFor({
          line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
          column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
          bias: aArgs.bias
        });
      };
      IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
        return this._sections.every(function(s) {
          return s.consumer.hasContentsOfAllSources();
        });
      };
      IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
        for (var i = 0; i < this._sections.length; i++) {
          var section = this._sections[i];
          var content = section.consumer.sourceContentFor(aSource, true);
          if (content) {
            return content;
          }
        }
        if (nullOnMissing) {
          return null;
        } else {
          throw new Error('"' + aSource + '" is not in the SourceMap.');
        }
      };
      IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
        for (var i = 0; i < this._sections.length; i++) {
          var section = this._sections[i];
          if (section.consumer.sources.indexOf(util.getArg(aArgs, "source")) === -1) {
            continue;
          }
          var generatedPosition = section.consumer.generatedPositionFor(aArgs);
          if (generatedPosition) {
            var ret = {
              line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
              column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
          }
        }
        return {
          line: null,
          column: null
        };
      };
      IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
        this.__generatedMappings = [];
        this.__originalMappings = [];
        for (var i = 0; i < this._sections.length; i++) {
          var section = this._sections[i];
          var sectionMappings = section.consumer._generatedMappings;
          for (var j = 0; j < sectionMappings.length; j++) {
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            if (section.consumer.sourceRoot !== null) {
              source = util.join(section.consumer.sourceRoot, source);
            }
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = section.consumer._names.at(mapping.name);
            this._names.add(name);
            name = this._names.indexOf(name);
            var adjustedMapping = {
              source,
              generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
              generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
              originalLine: mapping.originalLine,
              originalColumn: mapping.originalColumn,
              name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === "number") {
              this.__originalMappings.push(adjustedMapping);
            }
          }
        }
        quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
        quickSort(this.__originalMappings, util.compareByOriginalPositions);
      };
      exports2.IndexedSourceMapConsumer = IndexedSourceMapConsumer;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/lib/source-node.js
  var require_source_node = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/lib/source-node.js"(exports2) {
      init_define_process();
      var SourceMapGenerator = require_source_map_generator().SourceMapGenerator;
      var util = require_util3();
      var REGEX_NEWLINE = /(\r?\n)/;
      var NEWLINE_CODE = 10;
      var isSourceNode = "$$$isSourceNode$$$";
      function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
        this.children = [];
        this.sourceContents = {};
        this.line = aLine == null ? null : aLine;
        this.column = aColumn == null ? null : aColumn;
        this.source = aSource == null ? null : aSource;
        this.name = aName == null ? null : aName;
        this[isSourceNode] = true;
        if (aChunks != null)
          this.add(aChunks);
      }
      SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
        var node = new SourceNode();
        var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
        var remainingLinesIndex = 0;
        var shiftNextLine = function() {
          var lineContents = getNextLine();
          var newLine = getNextLine() || "";
          return lineContents + newLine;
          function getNextLine() {
            return remainingLinesIndex < remainingLines.length ? remainingLines[remainingLinesIndex++] : void 0;
          }
        };
        var lastGeneratedLine = 1, lastGeneratedColumn = 0;
        var lastMapping = null;
        aSourceMapConsumer.eachMapping(function(mapping) {
          if (lastMapping !== null) {
            if (lastGeneratedLine < mapping.generatedLine) {
              addMappingWithCode(lastMapping, shiftNextLine());
              lastGeneratedLine++;
              lastGeneratedColumn = 0;
            } else {
              var nextLine = remainingLines[remainingLinesIndex];
              var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
              remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
              lastGeneratedColumn = mapping.generatedColumn;
              addMappingWithCode(lastMapping, code);
              lastMapping = mapping;
              return;
            }
          }
          while (lastGeneratedLine < mapping.generatedLine) {
            node.add(shiftNextLine());
            lastGeneratedLine++;
          }
          if (lastGeneratedColumn < mapping.generatedColumn) {
            var nextLine = remainingLines[remainingLinesIndex];
            node.add(nextLine.substr(0, mapping.generatedColumn));
            remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
            lastGeneratedColumn = mapping.generatedColumn;
          }
          lastMapping = mapping;
        }, this);
        if (remainingLinesIndex < remainingLines.length) {
          if (lastMapping) {
            addMappingWithCode(lastMapping, shiftNextLine());
          }
          node.add(remainingLines.splice(remainingLinesIndex).join(""));
        }
        aSourceMapConsumer.sources.forEach(function(sourceFile) {
          var content = aSourceMapConsumer.sourceContentFor(sourceFile);
          if (content != null) {
            if (aRelativePath != null) {
              sourceFile = util.join(aRelativePath, sourceFile);
            }
            node.setSourceContent(sourceFile, content);
          }
        });
        return node;
        function addMappingWithCode(mapping, code) {
          if (mapping === null || mapping.source === void 0) {
            node.add(code);
          } else {
            var source = aRelativePath ? util.join(aRelativePath, mapping.source) : mapping.source;
            node.add(new SourceNode(
              mapping.originalLine,
              mapping.originalColumn,
              source,
              code,
              mapping.name
            ));
          }
        }
      };
      SourceNode.prototype.add = function SourceNode_add(aChunk) {
        if (Array.isArray(aChunk)) {
          aChunk.forEach(function(chunk2) {
            this.add(chunk2);
          }, this);
        } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
          if (aChunk) {
            this.children.push(aChunk);
          }
        } else {
          throw new TypeError(
            "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
          );
        }
        return this;
      };
      SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
        if (Array.isArray(aChunk)) {
          for (var i = aChunk.length - 1; i >= 0; i--) {
            this.prepend(aChunk[i]);
          }
        } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
          this.children.unshift(aChunk);
        } else {
          throw new TypeError(
            "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
          );
        }
        return this;
      };
      SourceNode.prototype.walk = function SourceNode_walk(aFn) {
        var chunk2;
        for (var i = 0, len = this.children.length; i < len; i++) {
          chunk2 = this.children[i];
          if (chunk2[isSourceNode]) {
            chunk2.walk(aFn);
          } else {
            if (chunk2 !== "") {
              aFn(chunk2, {
                source: this.source,
                line: this.line,
                column: this.column,
                name: this.name
              });
            }
          }
        }
      };
      SourceNode.prototype.join = function SourceNode_join(aSep) {
        var newChildren;
        var i;
        var len = this.children.length;
        if (len > 0) {
          newChildren = [];
          for (i = 0; i < len - 1; i++) {
            newChildren.push(this.children[i]);
            newChildren.push(aSep);
          }
          newChildren.push(this.children[i]);
          this.children = newChildren;
        }
        return this;
      };
      SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
        var lastChild = this.children[this.children.length - 1];
        if (lastChild[isSourceNode]) {
          lastChild.replaceRight(aPattern, aReplacement);
        } else if (typeof lastChild === "string") {
          this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
        } else {
          this.children.push("".replace(aPattern, aReplacement));
        }
        return this;
      };
      SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
        this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
      };
      SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
        for (var i = 0, len = this.children.length; i < len; i++) {
          if (this.children[i][isSourceNode]) {
            this.children[i].walkSourceContents(aFn);
          }
        }
        var sources = Object.keys(this.sourceContents);
        for (var i = 0, len = sources.length; i < len; i++) {
          aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
        }
      };
      SourceNode.prototype.toString = function SourceNode_toString() {
        var str = "";
        this.walk(function(chunk2) {
          str += chunk2;
        });
        return str;
      };
      SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
        var generated = {
          code: "",
          line: 1,
          column: 0
        };
        var map2 = new SourceMapGenerator(aArgs);
        var sourceMappingActive = false;
        var lastOriginalSource = null;
        var lastOriginalLine = null;
        var lastOriginalColumn = null;
        var lastOriginalName = null;
        this.walk(function(chunk2, original) {
          generated.code += chunk2;
          if (original.source !== null && original.line !== null && original.column !== null) {
            if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) {
              map2.addMapping({
                source: original.source,
                original: {
                  line: original.line,
                  column: original.column
                },
                generated: {
                  line: generated.line,
                  column: generated.column
                },
                name: original.name
              });
            }
            lastOriginalSource = original.source;
            lastOriginalLine = original.line;
            lastOriginalColumn = original.column;
            lastOriginalName = original.name;
            sourceMappingActive = true;
          } else if (sourceMappingActive) {
            map2.addMapping({
              generated: {
                line: generated.line,
                column: generated.column
              }
            });
            lastOriginalSource = null;
            sourceMappingActive = false;
          }
          for (var idx = 0, length = chunk2.length; idx < length; idx++) {
            if (chunk2.charCodeAt(idx) === NEWLINE_CODE) {
              generated.line++;
              generated.column = 0;
              if (idx + 1 === length) {
                lastOriginalSource = null;
                sourceMappingActive = false;
              } else if (sourceMappingActive) {
                map2.addMapping({
                  source: original.source,
                  original: {
                    line: original.line,
                    column: original.column
                  },
                  generated: {
                    line: generated.line,
                    column: generated.column
                  },
                  name: original.name
                });
              }
            } else {
              generated.column++;
            }
          }
        });
        this.walkSourceContents(function(sourceFile, sourceContent) {
          map2.setSourceContent(sourceFile, sourceContent);
        });
        return { code: generated.code, map: map2 };
      };
      exports2.SourceNode = SourceNode;
    }
  });

  // node_modules/snapdragon/node_modules/source-map/source-map.js
  var require_source_map = __commonJS({
    "node_modules/snapdragon/node_modules/source-map/source-map.js"(exports2) {
      init_define_process();
      exports2.SourceMapGenerator = require_source_map_generator().SourceMapGenerator;
      exports2.SourceMapConsumer = require_source_map_consumer().SourceMapConsumer;
      exports2.SourceNode = require_source_node().SourceNode;
    }
  });

  // node_modules/source-map-url/source-map-url.js
  var require_source_map_url = __commonJS({
    "node_modules/source-map-url/source-map-url.js"(exports2, module2) {
      init_define_process();
      void function(root2, factory2) {
        if (typeof define === "function" && define.amd) {
          define(factory2);
        } else if (typeof exports2 === "object") {
          module2.exports = factory2();
        } else {
          root2.sourceMappingURL = factory2();
        }
      }(exports2, function() {
        var innerRegex = /[#@] sourceMappingURL=([^\s'"]*)/;
        var regex = RegExp(
          "(?:/\\*(?:\\s*\r?\n(?://)?)?(?:" + innerRegex.source + ")\\s*\\*/|//(?:" + innerRegex.source + "))\\s*"
        );
        return {
          regex,
          _innerRegex: innerRegex,
          getFrom: function(code) {
            var match = code.match(regex);
            return match ? match[1] || match[2] || "" : null;
          },
          existsIn: function(code) {
            return regex.test(code);
          },
          removeFrom: function(code) {
            return code.replace(regex, "");
          },
          insertBefore: function(code, string) {
            var match = code.match(regex);
            if (match) {
              return code.slice(0, match.index) + string + code.slice(match.index);
            } else {
              return code + string;
            }
          }
        };
      });
    }
  });

  // node_modules/resolve-url/resolve-url.js
  var require_resolve_url = __commonJS({
    "node_modules/resolve-url/resolve-url.js"(exports2, module2) {
      init_define_process();
      void function(root2, factory2) {
        if (typeof define === "function" && define.amd) {
          define(factory2);
        } else if (typeof exports2 === "object") {
          module2.exports = factory2();
        } else {
          root2.resolveUrl = factory2();
        }
      }(exports2, function() {
        function resolveUrl() {
          var numUrls = arguments.length;
          if (numUrls === 0) {
            throw new Error("resolveUrl requires at least one argument; got none.");
          }
          var base = document.createElement("base");
          base.href = arguments[0];
          if (numUrls === 1) {
            return base.href;
          }
          var head2 = document.getElementsByTagName("head")[0];
          head2.insertBefore(base, head2.firstChild);
          var a = document.createElement("a");
          var resolved;
          for (var index = 1; index < numUrls; index++) {
            a.href = arguments[index];
            resolved = a.href;
            base.href = resolved;
          }
          head2.removeChild(base);
          return resolved;
        }
        return resolveUrl;
      });
    }
  });

  // node_modules/source-map-resolve/source-map-resolve.js
  var require_source_map_resolve = __commonJS({
    "node_modules/source-map-resolve/source-map-resolve.js"(exports2, module2) {
      init_define_process();
      void function(root2, factory2) {
        if (typeof define === "function" && define.amd) {
          define(["source-map-url", "resolve-url"], factory2);
        } else if (typeof exports2 === "object") {
          var sourceMappingURL = require_source_map_url();
          var resolveUrl = require_resolve_url();
          module2.exports = factory2(sourceMappingURL, resolveUrl);
        } else {
          root2.sourceMapResolve = factory2(root2.sourceMappingURL, root2.resolveUrl);
        }
      }(exports2, function(sourceMappingURL, resolveUrl) {
        function callbackAsync(callback, error, result2) {
          setImmediate(function() {
            callback(error, result2);
          });
        }
        function parseMapToJSON(string, data) {
          try {
            return JSON.parse(string.replace(/^\)\]\}'/, ""));
          } catch (error) {
            error.sourceMapData = data;
            throw error;
          }
        }
        function readSync(read, url, data) {
          var readUrl = url;
          try {
            return String(read(readUrl));
          } catch (error) {
            error.sourceMapData = data;
            throw error;
          }
        }
        function resolveSourceMap(code, codeUrl, read, callback) {
          var mapData;
          try {
            mapData = resolveSourceMapHelper(code, codeUrl);
          } catch (error) {
            return callbackAsync(callback, error);
          }
          if (!mapData || mapData.map) {
            return callbackAsync(callback, null, mapData);
          }
          var readUrl = mapData.url;
          read(readUrl, function(error, result2) {
            if (error) {
              error.sourceMapData = mapData;
              return callback(error);
            }
            mapData.map = String(result2);
            try {
              mapData.map = parseMapToJSON(mapData.map, mapData);
            } catch (error2) {
              return callback(error2);
            }
            callback(null, mapData);
          });
        }
        function resolveSourceMapSync(code, codeUrl, read) {
          var mapData = resolveSourceMapHelper(code, codeUrl);
          if (!mapData || mapData.map) {
            return mapData;
          }
          mapData.map = readSync(read, mapData.url, mapData);
          mapData.map = parseMapToJSON(mapData.map, mapData);
          return mapData;
        }
        var dataUriRegex = /^data:([^,;]*)(;[^,;]*)*(?:,(.*))?$/;
        var jsonMimeTypeRegex = /^(?:application|text)\/json$/;
        var jsonCharacterEncoding = "utf-8";
        function base64ToBuf(b64) {
          var binStr = atob(b64);
          var len = binStr.length;
          var arr = new Uint8Array(len);
          for (var i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
          }
          return arr;
        }
        function decodeBase64String(b64) {
          if (typeof TextDecoder === "undefined" || typeof Uint8Array === "undefined") {
            return atob(b64);
          }
          var buf = base64ToBuf(b64);
          var decoder = new TextDecoder(jsonCharacterEncoding, { fatal: true });
          return decoder.decode(buf);
        }
        function resolveSourceMapHelper(code, codeUrl) {
          var url = sourceMappingURL.getFrom(code);
          if (!url) {
            return null;
          }
          var dataUri = url.match(dataUriRegex);
          if (dataUri) {
            var mimeType = dataUri[1] || "text/plain";
            var lastParameter = dataUri[2] || "";
            var encoded = dataUri[3] || "";
            var data = {
              sourceMappingURL: url,
              url: null,
              sourcesRelativeTo: codeUrl,
              map: encoded
            };
            if (!jsonMimeTypeRegex.test(mimeType)) {
              var error = new Error("Unuseful data uri mime type: " + mimeType);
              error.sourceMapData = data;
              throw error;
            }
            try {
              data.map = parseMapToJSON(
                lastParameter === ";base64" ? decodeBase64String(encoded) : decodeURIComponent(encoded),
                data
              );
            } catch (error2) {
              error2.sourceMapData = data;
              throw error2;
            }
            return data;
          }
          var mapUrl = resolveUrl(codeUrl, url);
          return {
            sourceMappingURL: url,
            url: mapUrl,
            sourcesRelativeTo: mapUrl,
            map: null
          };
        }
        function resolveSources(map2, mapUrl, read, options, callback) {
          if (typeof options === "function") {
            callback = options;
            options = {};
          }
          var pending = map2.sources ? map2.sources.length : 0;
          var result2 = {
            sourcesResolved: [],
            sourcesContent: []
          };
          if (pending === 0) {
            callbackAsync(callback, null, result2);
            return;
          }
          var done = function() {
            pending--;
            if (pending === 0) {
              callback(null, result2);
            }
          };
          resolveSourcesHelper(map2, mapUrl, options, function(fullUrl, sourceContent, index) {
            result2.sourcesResolved[index] = fullUrl;
            if (typeof sourceContent === "string") {
              result2.sourcesContent[index] = sourceContent;
              callbackAsync(done, null);
            } else {
              var readUrl = fullUrl;
              read(readUrl, function(error, source) {
                result2.sourcesContent[index] = error ? error : String(source);
                done();
              });
            }
          });
        }
        function resolveSourcesSync(map2, mapUrl, read, options) {
          var result2 = {
            sourcesResolved: [],
            sourcesContent: []
          };
          if (!map2.sources || map2.sources.length === 0) {
            return result2;
          }
          resolveSourcesHelper(map2, mapUrl, options, function(fullUrl, sourceContent, index) {
            result2.sourcesResolved[index] = fullUrl;
            if (read !== null) {
              if (typeof sourceContent === "string") {
                result2.sourcesContent[index] = sourceContent;
              } else {
                var readUrl = fullUrl;
                try {
                  result2.sourcesContent[index] = String(read(readUrl));
                } catch (error) {
                  result2.sourcesContent[index] = error;
                }
              }
            }
          });
          return result2;
        }
        var endingSlash = /\/?$/;
        function resolveSourcesHelper(map2, mapUrl, options, fn) {
          options = options || {};
          var fullUrl;
          var sourceContent;
          var sourceRoot;
          for (var index = 0, len = map2.sources.length; index < len; index++) {
            sourceRoot = null;
            if (typeof options.sourceRoot === "string") {
              sourceRoot = options.sourceRoot;
            } else if (typeof map2.sourceRoot === "string" && options.sourceRoot !== false) {
              sourceRoot = map2.sourceRoot;
            }
            if (sourceRoot === null || sourceRoot === "") {
              fullUrl = resolveUrl(mapUrl, map2.sources[index]);
            } else {
              fullUrl = resolveUrl(mapUrl, sourceRoot.replace(endingSlash, "/"), map2.sources[index]);
            }
            sourceContent = (map2.sourcesContent || [])[index];
            fn(fullUrl, sourceContent, index);
          }
        }
        function resolve(code, codeUrl, read, options, callback) {
          if (typeof options === "function") {
            callback = options;
            options = {};
          }
          if (code === null) {
            var mapUrl = codeUrl;
            var data = {
              sourceMappingURL: null,
              url: mapUrl,
              sourcesRelativeTo: mapUrl,
              map: null
            };
            var readUrl = mapUrl;
            read(readUrl, function(error, result2) {
              if (error) {
                error.sourceMapData = data;
                return callback(error);
              }
              data.map = String(result2);
              try {
                data.map = parseMapToJSON(data.map, data);
              } catch (error2) {
                return callback(error2);
              }
              _resolveSources(data);
            });
          } else {
            resolveSourceMap(code, codeUrl, read, function(error, mapData) {
              if (error) {
                return callback(error);
              }
              if (!mapData) {
                return callback(null, null);
              }
              _resolveSources(mapData);
            });
          }
          function _resolveSources(mapData) {
            resolveSources(mapData.map, mapData.sourcesRelativeTo, read, options, function(error, result2) {
              if (error) {
                return callback(error);
              }
              mapData.sourcesResolved = result2.sourcesResolved;
              mapData.sourcesContent = result2.sourcesContent;
              callback(null, mapData);
            });
          }
        }
        function resolveSync(code, codeUrl, read, options) {
          var mapData;
          if (code === null) {
            var mapUrl = codeUrl;
            mapData = {
              sourceMappingURL: null,
              url: mapUrl,
              sourcesRelativeTo: mapUrl,
              map: null
            };
            mapData.map = readSync(read, mapUrl, mapData);
            mapData.map = parseMapToJSON(mapData.map, mapData);
          } else {
            mapData = resolveSourceMapSync(code, codeUrl, read);
            if (!mapData) {
              return null;
            }
          }
          var result2 = resolveSourcesSync(mapData.map, mapData.sourcesRelativeTo, read, options);
          mapData.sourcesResolved = result2.sourcesResolved;
          mapData.sourcesContent = result2.sourcesContent;
          return mapData;
        }
        return {
          resolveSourceMap,
          resolveSourceMapSync,
          resolveSources,
          resolveSourcesSync,
          resolve,
          resolveSync,
          parseMapToJSON
        };
      });
    }
  });

  // node_modules/snapdragon/lib/utils.js
  var require_utils = __commonJS({
    "node_modules/snapdragon/lib/utils.js"(exports2) {
      "use strict";
      init_define_process();
      exports2.extend = require_extend_shallow3();
      exports2.SourceMap = require_source_map();
      exports2.sourceMapResolve = require_source_map_resolve();
      exports2.unixify = function(fp) {
        return fp.split(/\\+/).join("/");
      };
      exports2.isString = function(str) {
        return str && typeof str === "string";
      };
      exports2.arrayify = function(val) {
        if (typeof val === "string")
          return [val];
        return val ? Array.isArray(val) ? val : [val] : [];
      };
      exports2.last = function(arr, n) {
        return arr[arr.length - (n || 1)];
      };
    }
  });

  // ignore:fs
  var require_fs = __commonJS({
    "ignore:fs"() {
      init_define_process();
    }
  });

  // node_modules/snapdragon/lib/source-maps.js
  var require_source_maps = __commonJS({
    "node_modules/snapdragon/lib/source-maps.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var fs = require_fs();
      var path = require_path_browserify();
      var define2 = require_define_property3();
      var utils = require_utils();
      module2.exports = mixin3;
      function mixin3(compiler) {
        define2(compiler, "_comment", compiler.comment);
        compiler.map = new utils.SourceMap.SourceMapGenerator();
        compiler.position = { line: 1, column: 1 };
        compiler.content = {};
        compiler.files = {};
        for (var key in exports2) {
          define2(compiler, key, exports2[key]);
        }
      }
      exports2.updatePosition = function(str) {
        var lines = str.match(/\n/g);
        if (lines)
          this.position.line += lines.length;
        var i = str.lastIndexOf("\n");
        this.position.column = ~i ? str.length - i : this.position.column + str.length;
      };
      exports2.emit = function(str, node) {
        var position = node.position || {};
        var source = position.source;
        if (source) {
          if (position.filepath) {
            source = utils.unixify(position.filepath);
          }
          this.map.addMapping({
            source,
            generated: {
              line: this.position.line,
              column: Math.max(this.position.column - 1, 0)
            },
            original: {
              line: position.start.line,
              column: position.start.column - 1
            }
          });
          if (position.content) {
            this.addContent(source, position);
          }
          if (position.filepath) {
            this.addFile(source, position);
          }
          this.updatePosition(str);
          this.output += str;
        }
        return str;
      };
      exports2.addFile = function(file2, position) {
        if (typeof position.content !== "string")
          return;
        if (Object.prototype.hasOwnProperty.call(this.files, file2))
          return;
        this.files[file2] = position.content;
      };
      exports2.addContent = function(source, position) {
        if (typeof position.content !== "string")
          return;
        if (Object.prototype.hasOwnProperty.call(this.content, source))
          return;
        this.map.setSourceContent(source, position.content);
      };
      exports2.applySourceMaps = function() {
        Object.keys(this.files).forEach(function(file2) {
          var content = this.files[file2];
          this.map.setSourceContent(file2, content);
          if (this.options.inputSourcemaps === true) {
            var originalMap = utils.sourceMapResolve.resolveSync(content, file2, fs.readFileSync);
            if (originalMap) {
              var map2 = new utils.SourceMap.SourceMapConsumer(originalMap.map);
              var relativeTo = originalMap.sourcesRelativeTo;
              this.map.applySourceMap(map2, file2, utils.unixify(path.dirname(relativeTo)));
            }
          }
        }, this);
      };
      exports2.comment = function(node) {
        if (/^# sourceMappingURL=/.test(node.comment)) {
          return this.emit("", node.position);
        }
        return this._comment(node);
      };
    }
  });

  // node_modules/snapdragon/lib/compiler.js
  var require_compiler = __commonJS({
    "node_modules/snapdragon/lib/compiler.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var use = require_use();
      var define2 = require_define_property3();
      var debug2 = require_browser()("snapdragon:compiler");
      var utils = require_utils();
      function Compiler(options, state) {
        debug2("initializing", __filename);
        this.options = utils.extend({ source: "string" }, options);
        this.state = state || {};
        this.compilers = {};
        this.output = "";
        this.set("eos", function(node) {
          return this.emit(node.val, node);
        });
        this.set("noop", function(node) {
          return this.emit(node.val, node);
        });
        this.set("bos", function(node) {
          return this.emit(node.val, node);
        });
        use(this);
      }
      Compiler.prototype = {
        error: function(msg, node) {
          var pos = node.position || { start: { column: 0 } };
          var message = this.options.source + " column:" + pos.start.column + ": " + msg;
          var err = new Error(message);
          err.reason = msg;
          err.column = pos.start.column;
          err.source = this.pattern;
          if (this.options.silent) {
            this.errors.push(err);
          } else {
            throw err;
          }
        },
        define: function(key, val) {
          define2(this, key, val);
          return this;
        },
        emit: function(str, node) {
          this.output += str;
          return str;
        },
        set: function(name, fn) {
          this.compilers[name] = fn;
          return this;
        },
        get: function(name) {
          return this.compilers[name];
        },
        prev: function(n) {
          return this.ast.nodes[this.idx - (n || 1)] || { type: "bos", val: "" };
        },
        next: function(n) {
          return this.ast.nodes[this.idx + (n || 1)] || { type: "eos", val: "" };
        },
        visit: function(node, nodes, i) {
          var fn = this.compilers[node.type];
          this.idx = i;
          if (typeof fn !== "function") {
            throw this.error('compiler "' + node.type + '" is not registered', node);
          }
          return fn.call(this, node, nodes, i);
        },
        mapVisit: function(nodes) {
          if (!Array.isArray(nodes)) {
            throw new TypeError("expected an array");
          }
          var len = nodes.length;
          var idx = -1;
          while (++idx < len) {
            this.visit(nodes[idx], nodes, idx);
          }
          return this;
        },
        compile: function(ast, options) {
          var opts = utils.extend({}, this.options, options);
          this.ast = ast;
          this.parsingErrors = this.ast.errors;
          this.output = "";
          if (opts.sourcemap) {
            var sourcemaps = require_source_maps();
            sourcemaps(this);
            this.mapVisit(this.ast.nodes);
            this.applySourceMaps();
            this.map = opts.sourcemap === "generator" ? this.map : this.map.toJSON();
            return this;
          }
          this.mapVisit(this.ast.nodes);
          return this;
        }
      };
      module2.exports = Compiler;
    }
  });

  // node_modules/snapdragon/lib/position.js
  var require_position = __commonJS({
    "node_modules/snapdragon/lib/position.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var define2 = require_define_property3();
      module2.exports = function Position(start, parser3) {
        this.start = start;
        this.end = { line: parser3.line, column: parser3.column };
        define2(this, "content", parser3.orig);
        define2(this, "source", parser3.options.source);
      };
    }
  });

  // node_modules/snapdragon/lib/parser.js
  var require_parser = __commonJS({
    "node_modules/snapdragon/lib/parser.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var use = require_use();
      var util = require_util();
      var Cache = require_map_cache();
      var define2 = require_define_property3();
      var debug2 = require_browser()("snapdragon:parser");
      var Position = require_position();
      var utils = require_utils();
      function Parser(options) {
        debug2("initializing", __filename);
        this.options = utils.extend({ source: "string" }, options);
        this.init(this.options);
        use(this);
      }
      Parser.prototype = {
        constructor: Parser,
        init: function(options) {
          this.orig = "";
          this.input = "";
          this.parsed = "";
          this.column = 1;
          this.line = 1;
          this.regex = new Cache();
          this.errors = this.errors || [];
          this.parsers = this.parsers || {};
          this.types = this.types || [];
          this.sets = this.sets || {};
          this.fns = this.fns || [];
          this.currentType = "root";
          var pos = this.position();
          this.bos = pos({ type: "bos", val: "" });
          this.ast = {
            type: "root",
            errors: this.errors,
            nodes: [this.bos]
          };
          define2(this.bos, "parent", this.ast);
          this.nodes = [this.ast];
          this.count = 0;
          this.setCount = 0;
          this.stack = [];
        },
        error: function(msg, node) {
          var pos = node.position || { start: { column: 0, line: 0 } };
          var line = pos.start.line;
          var column = pos.start.column;
          var source = this.options.source;
          var message = source + " <line:" + line + " column:" + column + ">: " + msg;
          var err = new Error(message);
          err.source = source;
          err.reason = msg;
          err.pos = pos;
          if (this.options.silent) {
            this.errors.push(err);
          } else {
            throw err;
          }
        },
        define: function(key, val) {
          define2(this, key, val);
          return this;
        },
        position: function() {
          var start = { line: this.line, column: this.column };
          var self2 = this;
          return function(node) {
            define2(node, "position", new Position(start, self2));
            return node;
          };
        },
        set: function(type, fn) {
          if (this.types.indexOf(type) === -1) {
            this.types.push(type);
          }
          this.parsers[type] = fn.bind(this);
          return this;
        },
        get: function(name) {
          return this.parsers[name];
        },
        push: function(type, token) {
          this.sets[type] = this.sets[type] || [];
          this.count++;
          this.stack.push(token);
          return this.sets[type].push(token);
        },
        pop: function(type) {
          this.sets[type] = this.sets[type] || [];
          this.count--;
          this.stack.pop();
          return this.sets[type].pop();
        },
        isInside: function(type) {
          this.sets[type] = this.sets[type] || [];
          return this.sets[type].length > 0;
        },
        isType: function(node, type) {
          return node && node.type === type;
        },
        prev: function(n) {
          return this.stack.length > 0 ? utils.last(this.stack, n) : utils.last(this.nodes, n);
        },
        consume: function(len) {
          this.input = this.input.substr(len);
        },
        updatePosition: function(str, len) {
          var lines = str.match(/\n/g);
          if (lines)
            this.line += lines.length;
          var i = str.lastIndexOf("\n");
          this.column = ~i ? len - i : this.column + len;
          this.parsed += str;
          this.consume(len);
        },
        match: function(regex) {
          var m = regex.exec(this.input);
          if (m) {
            this.updatePosition(m[0], m[0].length);
            return m;
          }
        },
        capture: function(type, regex) {
          if (typeof regex === "function") {
            return this.set.apply(this, arguments);
          }
          this.regex.set(type, regex);
          this.set(type, function() {
            var parsed = this.parsed;
            var pos = this.position();
            var m = this.match(regex);
            if (!m || !m[0])
              return;
            var prev = this.prev();
            var node = pos({
              type,
              val: m[0],
              parsed,
              rest: this.input
            });
            if (m[1]) {
              node.inner = m[1];
            }
            define2(node, "inside", this.stack.length > 0);
            define2(node, "parent", prev);
            prev.nodes.push(node);
          }.bind(this));
          return this;
        },
        capturePair: function(type, openRegex, closeRegex, fn) {
          this.sets[type] = this.sets[type] || [];
          this.set(type + ".open", function() {
            var parsed = this.parsed;
            var pos = this.position();
            var m = this.match(openRegex);
            if (!m || !m[0])
              return;
            var val = m[0];
            this.setCount++;
            this.specialChars = true;
            var open = pos({
              type: type + ".open",
              val,
              rest: this.input
            });
            if (typeof m[1] !== "undefined") {
              open.inner = m[1];
            }
            var prev = this.prev();
            var node = pos({
              type,
              nodes: [open]
            });
            define2(node, "rest", this.input);
            define2(node, "parsed", parsed);
            define2(node, "prefix", m[1]);
            define2(node, "parent", prev);
            define2(open, "parent", node);
            if (typeof fn === "function") {
              fn.call(this, open, node);
            }
            this.push(type, node);
            prev.nodes.push(node);
          });
          this.set(type + ".close", function() {
            var pos = this.position();
            var m = this.match(closeRegex);
            if (!m || !m[0])
              return;
            var parent2 = this.pop(type);
            var node = pos({
              type: type + ".close",
              rest: this.input,
              suffix: m[1],
              val: m[0]
            });
            if (!this.isType(parent2, type)) {
              if (this.options.strict) {
                throw new Error('missing opening "' + type + '"');
              }
              this.setCount--;
              node.escaped = true;
              return node;
            }
            if (node.suffix === "\\") {
              parent2.escaped = true;
              node.escaped = true;
            }
            parent2.nodes.push(node);
            define2(node, "parent", parent2);
          });
          return this;
        },
        eos: function() {
          var pos = this.position();
          if (this.input)
            return;
          var prev = this.prev();
          while (prev.type !== "root" && !prev.visited) {
            if (this.options.strict === true) {
              throw new SyntaxError("invalid syntax:" + util.inspect(prev, null, 2));
            }
            if (!hasDelims(prev)) {
              prev.parent.escaped = true;
              prev.escaped = true;
            }
            visit(prev, function(node) {
              if (!hasDelims(node.parent)) {
                node.parent.escaped = true;
                node.escaped = true;
              }
            });
            prev = prev.parent;
          }
          var tok = pos({
            type: "eos",
            val: this.append || ""
          });
          define2(tok, "parent", this.ast);
          return tok;
        },
        next: function() {
          var parsed = this.parsed;
          var len = this.types.length;
          var idx = -1;
          var tok;
          while (++idx < len) {
            if (tok = this.parsers[this.types[idx]].call(this)) {
              define2(tok, "rest", this.input);
              define2(tok, "parsed", parsed);
              this.last = tok;
              return tok;
            }
          }
        },
        parse: function(input) {
          if (typeof input !== "string") {
            throw new TypeError("expected a string");
          }
          this.init(this.options);
          this.orig = input;
          this.input = input;
          var self2 = this;
          function parse3() {
            input = self2.input;
            var node2 = self2.next();
            if (node2) {
              var prev = self2.prev();
              if (prev) {
                define2(node2, "parent", prev);
                if (prev.nodes) {
                  prev.nodes.push(node2);
                }
              }
              if (self2.sets.hasOwnProperty(prev.type)) {
                self2.currentType = prev.type;
              }
            }
            if (self2.input && input === self2.input) {
              throw new Error('no parsers registered for: "' + self2.input.slice(0, 5) + '"');
            }
          }
          while (this.input)
            parse3();
          if (this.stack.length && this.options.strict) {
            var node = this.stack.pop();
            throw this.error("missing opening " + node.type + ': "' + this.orig + '"');
          }
          var eos = this.eos();
          var tok = this.prev();
          if (tok.type !== "eos") {
            this.ast.nodes.push(eos);
          }
          return this.ast;
        }
      };
      function visit(node, fn) {
        if (!node.visited) {
          define2(node, "visited", true);
          return node.nodes ? mapVisit(node.nodes, fn) : fn(node);
        }
        return node;
      }
      function mapVisit(nodes, fn) {
        var len = nodes.length;
        var idx = -1;
        while (++idx < len) {
          visit(nodes[idx], fn);
        }
      }
      function hasOpen(node) {
        return node.nodes && node.nodes[0].type === node.type + ".open";
      }
      function hasClose(node) {
        return node.nodes && utils.last(node.nodes).type === node.type + ".close";
      }
      function hasDelims(node) {
        return hasOpen(node) && hasClose(node);
      }
      module2.exports = Parser;
    }
  });

  // node_modules/snapdragon/index.js
  var require_snapdragon = __commonJS({
    "node_modules/snapdragon/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var Base = require_base();
      var define2 = require_define_property3();
      var Compiler = require_compiler();
      var Parser = require_parser();
      var utils = require_utils();
      function Snapdragon(options) {
        Base.call(this, null, options);
        this.options = utils.extend({ source: "string" }, this.options);
        this.compiler = new Compiler(this.options);
        this.parser = new Parser(this.options);
        Object.defineProperty(this, "compilers", {
          get: function() {
            return this.compiler.compilers;
          }
        });
        Object.defineProperty(this, "parsers", {
          get: function() {
            return this.parser.parsers;
          }
        });
        Object.defineProperty(this, "regex", {
          get: function() {
            return this.parser.regex;
          }
        });
      }
      Base.extend(Snapdragon);
      Snapdragon.prototype.capture = function() {
        return this.parser.capture.apply(this.parser, arguments);
      };
      Snapdragon.prototype.use = function(fn) {
        fn.call(this, this);
        return this;
      };
      Snapdragon.prototype.parse = function(str, options) {
        this.options = utils.extend({}, this.options, options);
        var parsed = this.parser.parse(str, this.options);
        define2(parsed, "parser", this.parser);
        return parsed;
      };
      Snapdragon.prototype.compile = function(ast, options) {
        this.options = utils.extend({}, this.options, options);
        var compiled = this.compiler.compile(ast, this.options);
        define2(compiled, "compiler", this.compiler);
        return compiled;
      };
      module2.exports = Snapdragon;
      module2.exports.Compiler = Compiler;
      module2.exports.Parser = Parser;
    }
  });

  // node_modules/nanomatch/node_modules/define-property/index.js
  var require_define_property4 = __commonJS({
    "node_modules/nanomatch/node_modules/define-property/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isobject = require_isobject();
      var isDescriptor = require_is_descriptor();
      var define2 = typeof Reflect !== "undefined" && Reflect.defineProperty ? Reflect.defineProperty : Object.defineProperty;
      module2.exports = function defineProperty2(obj, key, val) {
        if (!isobject(obj) && typeof obj !== "function" && !Array.isArray(obj)) {
          throw new TypeError("expected an object, function, or array");
        }
        if (typeof key !== "string") {
          throw new TypeError('expected "key" to be a string');
        }
        if (isDescriptor(val)) {
          define2(obj, key, val);
          return obj;
        }
        define2(obj, key, {
          configurable: true,
          enumerable: false,
          writable: true,
          value: val
        });
        return obj;
      };
    }
  });

  // node_modules/arr-diff/index.js
  var require_arr_diff = __commonJS({
    "node_modules/arr-diff/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function diff(arr) {
        var len = arguments.length;
        var idx = 0;
        while (++idx < len) {
          arr = diffArray(arr, arguments[idx]);
        }
        return arr;
      };
      function diffArray(one, two) {
        if (!Array.isArray(two)) {
          return one.slice();
        }
        var tlen = two.length;
        var olen = one.length;
        var idx = -1;
        var arr = [];
        while (++idx < olen) {
          var ele = one[idx];
          var hasEle = false;
          for (var i = 0; i < tlen; i++) {
            var val = two[i];
            if (ele === val) {
              hasEle = true;
              break;
            }
          }
          if (hasEle === false) {
            arr.push(ele);
          }
        }
        return arr;
      }
    }
  });

  // node_modules/object.pick/index.js
  var require_object = __commonJS({
    "node_modules/object.pick/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var isObject2 = require_isobject();
      module2.exports = function pick2(obj, keys2) {
        if (!isObject2(obj) && typeof obj !== "function") {
          return {};
        }
        var res = {};
        if (typeof keys2 === "string") {
          if (keys2 in obj) {
            res[keys2] = obj[keys2];
          }
          return res;
        }
        var len = keys2.length;
        var idx = -1;
        while (++idx < len) {
          var key = keys2[idx];
          if (key in obj) {
            res[key] = obj[key];
          }
        }
        return res;
      };
    }
  });

  // node_modules/nanomatch/node_modules/kind-of/index.js
  var require_kind_of10 = __commonJS({
    "node_modules/nanomatch/node_modules/kind-of/index.js"(exports2, module2) {
      init_define_process();
      var toString2 = Object.prototype.toString;
      module2.exports = function kindOf(val) {
        if (val === void 0)
          return "undefined";
        if (val === null)
          return "null";
        var type = typeof val;
        if (type === "boolean")
          return "boolean";
        if (type === "string")
          return "string";
        if (type === "number")
          return "number";
        if (type === "symbol")
          return "symbol";
        if (type === "function") {
          return isGeneratorFn(val) ? "generatorfunction" : "function";
        }
        if (isArray2(val))
          return "array";
        if (isBuffer2(val))
          return "buffer";
        if (isArguments2(val))
          return "arguments";
        if (isDate2(val))
          return "date";
        if (isError2(val))
          return "error";
        if (isRegexp(val))
          return "regexp";
        switch (ctorName(val)) {
          case "Symbol":
            return "symbol";
          case "Promise":
            return "promise";
          case "WeakMap":
            return "weakmap";
          case "WeakSet":
            return "weakset";
          case "Map":
            return "map";
          case "Set":
            return "set";
          case "Int8Array":
            return "int8array";
          case "Uint8Array":
            return "uint8array";
          case "Uint8ClampedArray":
            return "uint8clampedarray";
          case "Int16Array":
            return "int16array";
          case "Uint16Array":
            return "uint16array";
          case "Int32Array":
            return "int32array";
          case "Uint32Array":
            return "uint32array";
          case "Float32Array":
            return "float32array";
          case "Float64Array":
            return "float64array";
        }
        if (isGeneratorObj(val)) {
          return "generator";
        }
        type = toString2.call(val);
        switch (type) {
          case "[object Object]":
            return "object";
          case "[object Map Iterator]":
            return "mapiterator";
          case "[object Set Iterator]":
            return "setiterator";
          case "[object String Iterator]":
            return "stringiterator";
          case "[object Array Iterator]":
            return "arrayiterator";
        }
        return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
      };
      function ctorName(val) {
        return typeof val.constructor === "function" ? val.constructor.name : null;
      }
      function isArray2(val) {
        if (Array.isArray)
          return Array.isArray(val);
        return val instanceof Array;
      }
      function isError2(val) {
        return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
      }
      function isDate2(val) {
        if (val instanceof Date)
          return true;
        return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
      }
      function isRegexp(val) {
        if (val instanceof RegExp)
          return true;
        return typeof val.flags === "string" && typeof val.ignoreCase === "boolean" && typeof val.multiline === "boolean" && typeof val.global === "boolean";
      }
      function isGeneratorFn(name, val) {
        return ctorName(name) === "GeneratorFunction";
      }
      function isGeneratorObj(val) {
        return typeof val.throw === "function" && typeof val.return === "function" && typeof val.next === "function";
      }
      function isArguments2(val) {
        try {
          if (typeof val.length === "number" && typeof val.callee === "function") {
            return true;
          }
        } catch (err) {
          if (err.message.indexOf("callee") !== -1) {
            return true;
          }
        }
        return false;
      }
      function isBuffer2(val) {
        if (val.constructor && typeof val.constructor.isBuffer === "function") {
          return val.constructor.isBuffer(val);
        }
        return false;
      }
    }
  });

  // node_modules/array-unique/index.js
  var require_array_unique = __commonJS({
    "node_modules/array-unique/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function unique(arr) {
        if (!Array.isArray(arr)) {
          throw new TypeError("array-unique expects an array.");
        }
        var len = arr.length;
        var i = -1;
        while (i++ < len) {
          var j = i + 1;
          for (; j < arr.length; ++j) {
            if (arr[i] === arr[j]) {
              arr.splice(j--, 1);
            }
          }
        }
        return arr;
      };
      module2.exports.immutable = function uniqueImmutable(arr) {
        if (!Array.isArray(arr)) {
          throw new TypeError("array-unique expects an array.");
        }
        var arrLen = arr.length;
        var newArr = new Array(arrLen);
        for (var i = 0; i < arrLen; i++) {
          newArr[i] = arr[i];
        }
        return module2.exports(newArr);
      };
    }
  });

  // node_modules/nanomatch/lib/utils.js
  var require_utils2 = __commonJS({
    "node_modules/nanomatch/lib/utils.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var utils = module2.exports;
      var path = require_path_browserify();
      var isWindows = require_is_windows()();
      var Snapdragon = require_snapdragon();
      utils.define = require_define_property4();
      utils.diff = require_arr_diff();
      utils.extend = require_extend_shallow();
      utils.pick = require_object();
      utils.typeOf = require_kind_of10();
      utils.unique = require_array_unique();
      utils.isEmptyString = function(val) {
        return String(val) === "" || String(val) === "./";
      };
      utils.isWindows = function() {
        return path.sep === "\\" || isWindows === true;
      };
      utils.last = function(arr, n) {
        return arr[arr.length - (n || 1)];
      };
      utils.instantiate = function(ast, options) {
        var snapdragon;
        if (utils.typeOf(ast) === "object" && ast.snapdragon) {
          snapdragon = ast.snapdragon;
        } else if (utils.typeOf(options) === "object" && options.snapdragon) {
          snapdragon = options.snapdragon;
        } else {
          snapdragon = new Snapdragon(options);
        }
        utils.define(snapdragon, "parse", function(str, options2) {
          var parsed = Snapdragon.prototype.parse.call(this, str, options2);
          parsed.input = str;
          var last2 = this.parser.stack.pop();
          if (last2 && this.options.strictErrors !== true) {
            var open = last2.nodes[0];
            var inner = last2.nodes[1];
            if (last2.type === "bracket") {
              if (inner.val.charAt(0) === "[") {
                inner.val = "\\" + inner.val;
              }
            } else {
              open.val = "\\" + open.val;
              var sibling = open.parent.nodes[1];
              if (sibling.type === "star") {
                sibling.loose = true;
              }
            }
          }
          utils.define(parsed, "parser", this.parser);
          return parsed;
        });
        return snapdragon;
      };
      utils.createKey = function(pattern, options) {
        if (typeof options === "undefined") {
          return pattern;
        }
        var key = pattern;
        for (var prop in options) {
          if (options.hasOwnProperty(prop)) {
            key += ";" + prop + "=" + String(options[prop]);
          }
        }
        return key;
      };
      utils.arrayify = function(val) {
        if (typeof val === "string")
          return [val];
        return val ? Array.isArray(val) ? val : [val] : [];
      };
      utils.isString = function(val) {
        return typeof val === "string";
      };
      utils.isRegex = function(val) {
        return utils.typeOf(val) === "regexp";
      };
      utils.isObject = function(val) {
        return utils.typeOf(val) === "object";
      };
      utils.escapeRegex = function(str) {
        return str.replace(/[-[\]{}()^$|*+?.\\/\s]/g, "\\$&");
      };
      utils.combineDupes = function(input, patterns) {
        patterns = utils.arrayify(patterns).join("|").split("|");
        patterns = patterns.map(function(s) {
          return s.replace(/\\?([+*\\/])/g, "\\$1");
        });
        var substr = patterns.join("|");
        var regex = new RegExp("(" + substr + ")(?=\\1)", "g");
        return input.replace(regex, "");
      };
      utils.hasSpecialChars = function(str) {
        return /(?:(?:(^|\/)[!.])|[*?+()|[\]{}]|[+@]\()/.test(str);
      };
      utils.toPosixPath = function(str) {
        return str.replace(/\\+/g, "/");
      };
      utils.unescape = function(str) {
        return utils.toPosixPath(str.replace(/\\(?=[*+?!.])/g, ""));
      };
      utils.stripDrive = function(fp) {
        return utils.isWindows() ? fp.replace(/^[a-z]:[\\/]+?/i, "/") : fp;
      };
      utils.stripPrefix = function(str) {
        if (str.charAt(0) === "." && (str.charAt(1) === "/" || str.charAt(1) === "\\")) {
          return str.slice(2);
        }
        return str;
      };
      utils.isSimpleChar = function(str) {
        return str.trim() === "" || str === ".";
      };
      utils.isSlash = function(str) {
        return str === "/" || str === "\\/" || str === "\\" || str === "\\\\";
      };
      utils.matchPath = function(pattern, options) {
        return options && options.contains ? utils.containsPattern(pattern, options) : utils.equalsPattern(pattern, options);
      };
      utils._equals = function(filepath, unixPath, pattern) {
        return pattern === filepath || pattern === unixPath;
      };
      utils._contains = function(filepath, unixPath, pattern) {
        return filepath.indexOf(pattern) !== -1 || unixPath.indexOf(pattern) !== -1;
      };
      utils.equalsPattern = function(pattern, options) {
        var unixify = utils.unixify(options);
        options = options || {};
        return function fn(filepath) {
          var equal = utils._equals(filepath, unixify(filepath), pattern);
          if (equal === true || options.nocase !== true) {
            return equal;
          }
          var lower = filepath.toLowerCase();
          return utils._equals(lower, unixify(lower), pattern);
        };
      };
      utils.containsPattern = function(pattern, options) {
        var unixify = utils.unixify(options);
        options = options || {};
        return function(filepath) {
          var contains = utils._contains(filepath, unixify(filepath), pattern);
          if (contains === true || options.nocase !== true) {
            return contains;
          }
          var lower = filepath.toLowerCase();
          return utils._contains(lower, unixify(lower), pattern);
        };
      };
      utils.matchBasename = function(re) {
        return function(filepath) {
          return re.test(filepath) || re.test(path.basename(filepath));
        };
      };
      utils.identity = function(val) {
        return val;
      };
      utils.value = function(str, unixify, options) {
        if (options && options.unixify === false) {
          return str;
        }
        if (options && typeof options.unixify === "function") {
          return options.unixify(str);
        }
        return unixify(str);
      };
      utils.unixify = function(options) {
        var opts = options || {};
        return function(filepath) {
          if (opts.stripPrefix !== false) {
            filepath = utils.stripPrefix(filepath);
          }
          if (opts.unescape === true) {
            filepath = utils.unescape(filepath);
          }
          if (opts.unixify === true || utils.isWindows()) {
            filepath = utils.toPosixPath(filepath);
          }
          return filepath;
        };
      };
    }
  });

  // node_modules/nanomatch/index.js
  var require_nanomatch = __commonJS({
    "node_modules/nanomatch/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var util = require_util();
      var toRegex = require_to_regex();
      var extend = require_extend_shallow();
      var compilers = require_compilers();
      var parsers = require_parsers();
      var cache = require_cache();
      var utils = require_utils2();
      var MAX_LENGTH = 1024 * 64;
      function nanomatch(list, patterns, options) {
        patterns = utils.arrayify(patterns);
        list = utils.arrayify(list);
        var len = patterns.length;
        if (list.length === 0 || len === 0) {
          return [];
        }
        if (len === 1) {
          return nanomatch.match(list, patterns[0], options);
        }
        var negated = false;
        var omit2 = [];
        var keep = [];
        var idx = -1;
        while (++idx < len) {
          var pattern = patterns[idx];
          if (typeof pattern === "string" && pattern.charCodeAt(0) === 33) {
            omit2.push.apply(omit2, nanomatch.match(list, pattern.slice(1), options));
            negated = true;
          } else {
            keep.push.apply(keep, nanomatch.match(list, pattern, options));
          }
        }
        if (negated && keep.length === 0) {
          if (options && options.unixify === false) {
            keep = list.slice();
          } else {
            var unixify = utils.unixify(options);
            for (var i = 0; i < list.length; i++) {
              keep.push(unixify(list[i]));
            }
          }
        }
        var matches2 = utils.diff(keep, omit2);
        if (!options || options.nodupes !== false) {
          return utils.unique(matches2);
        }
        return matches2;
      }
      nanomatch.match = function(list, pattern, options) {
        if (Array.isArray(pattern)) {
          throw new TypeError("expected pattern to be a string");
        }
        var unixify = utils.unixify(options);
        var isMatch2 = memoize2("match", pattern, options, nanomatch.matcher);
        var matches2 = [];
        list = utils.arrayify(list);
        var len = list.length;
        var idx = -1;
        while (++idx < len) {
          var ele = list[idx];
          if (ele === pattern || isMatch2(ele)) {
            matches2.push(utils.value(ele, unixify, options));
          }
        }
        if (typeof options === "undefined") {
          return utils.unique(matches2);
        }
        if (matches2.length === 0) {
          if (options.failglob === true) {
            throw new Error('no matches found for "' + pattern + '"');
          }
          if (options.nonull === true || options.nullglob === true) {
            return [options.unescape ? utils.unescape(pattern) : pattern];
          }
        }
        if (options.ignore) {
          matches2 = nanomatch.not(matches2, options.ignore, options);
        }
        return options.nodupes !== false ? utils.unique(matches2) : matches2;
      };
      nanomatch.isMatch = function(str, pattern, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (utils.isEmptyString(str) || utils.isEmptyString(pattern)) {
          return false;
        }
        var equals = utils.equalsPattern(options);
        if (equals(str)) {
          return true;
        }
        var isMatch2 = memoize2("isMatch", pattern, options, nanomatch.matcher);
        return isMatch2(str);
      };
      nanomatch.some = function(list, patterns, options) {
        if (typeof list === "string") {
          list = [list];
        }
        for (var i = 0; i < list.length; i++) {
          if (nanomatch(list[i], patterns, options).length === 1) {
            return true;
          }
        }
        return false;
      };
      nanomatch.every = function(list, patterns, options) {
        if (typeof list === "string") {
          list = [list];
        }
        for (var i = 0; i < list.length; i++) {
          if (nanomatch(list[i], patterns, options).length !== 1) {
            return false;
          }
        }
        return true;
      };
      nanomatch.any = function(str, patterns, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (utils.isEmptyString(str) || utils.isEmptyString(patterns)) {
          return false;
        }
        if (typeof patterns === "string") {
          patterns = [patterns];
        }
        for (var i = 0; i < patterns.length; i++) {
          if (nanomatch.isMatch(str, patterns[i], options)) {
            return true;
          }
        }
        return false;
      };
      nanomatch.all = function(str, patterns, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (typeof patterns === "string") {
          patterns = [patterns];
        }
        for (var i = 0; i < patterns.length; i++) {
          if (!nanomatch.isMatch(str, patterns[i], options)) {
            return false;
          }
        }
        return true;
      };
      nanomatch.not = function(list, patterns, options) {
        var opts = extend({}, options);
        var ignore = opts.ignore;
        delete opts.ignore;
        list = utils.arrayify(list);
        var matches2 = utils.diff(list, nanomatch(list, patterns, opts));
        if (ignore) {
          matches2 = utils.diff(matches2, nanomatch(list, ignore));
        }
        return opts.nodupes !== false ? utils.unique(matches2) : matches2;
      };
      nanomatch.contains = function(str, patterns, options) {
        if (typeof str !== "string") {
          throw new TypeError('expected a string: "' + util.inspect(str) + '"');
        }
        if (typeof patterns === "string") {
          if (utils.isEmptyString(str) || utils.isEmptyString(patterns)) {
            return false;
          }
          var equals = utils.equalsPattern(patterns, options);
          if (equals(str)) {
            return true;
          }
          var contains = utils.containsPattern(patterns, options);
          if (contains(str)) {
            return true;
          }
        }
        var opts = extend({}, options, { contains: true });
        return nanomatch.any(str, patterns, opts);
      };
      nanomatch.matchBase = function(pattern, options) {
        if (pattern && pattern.indexOf("/") !== -1 || !options)
          return false;
        return options.basename === true || options.matchBase === true;
      };
      nanomatch.matchKeys = function(obj, patterns, options) {
        if (!utils.isObject(obj)) {
          throw new TypeError("expected the first argument to be an object");
        }
        var keys2 = nanomatch(Object.keys(obj), patterns, options);
        return utils.pick(obj, keys2);
      };
      nanomatch.matcher = function matcher(pattern, options) {
        if (utils.isEmptyString(pattern)) {
          return function() {
            return false;
          };
        }
        if (Array.isArray(pattern)) {
          return compose(pattern, options, matcher);
        }
        if (pattern instanceof RegExp) {
          return test(pattern);
        }
        if (!utils.isString(pattern)) {
          throw new TypeError("expected pattern to be an array, string or regex");
        }
        if (!utils.hasSpecialChars(pattern)) {
          if (options && options.nocase === true) {
            pattern = pattern.toLowerCase();
          }
          return utils.matchPath(pattern, options);
        }
        var re = nanomatch.makeRe(pattern, options);
        if (nanomatch.matchBase(pattern, options)) {
          return utils.matchBasename(re, options);
        }
        function test(regex) {
          var equals = utils.equalsPattern(options);
          var unixify = utils.unixify(options);
          return function(str) {
            if (equals(str)) {
              return true;
            }
            if (regex.test(unixify(str))) {
              return true;
            }
            return false;
          };
        }
        var matcherFn = test(re);
        utils.define(matcherFn, "result", re.result);
        return matcherFn;
      };
      nanomatch.capture = function(pattern, str, options) {
        var re = nanomatch.makeRe(pattern, extend({ capture: true }, options));
        var unixify = utils.unixify(options);
        function match() {
          return function(string) {
            var match2 = re.exec(unixify(string));
            if (!match2) {
              return null;
            }
            return match2.slice(1);
          };
        }
        var capture = memoize2("capture", pattern, options, match);
        return capture(str);
      };
      nanomatch.makeRe = function(pattern, options) {
        if (pattern instanceof RegExp) {
          return pattern;
        }
        if (typeof pattern !== "string") {
          throw new TypeError("expected pattern to be a string");
        }
        if (pattern.length > MAX_LENGTH) {
          throw new Error("expected pattern to be less than " + MAX_LENGTH + " characters");
        }
        function makeRe() {
          var opts = utils.extend({ wrap: false }, options);
          var result2 = nanomatch.create(pattern, opts);
          var regex = toRegex(result2.output, opts);
          utils.define(regex, "result", result2);
          return regex;
        }
        return memoize2("makeRe", pattern, options, makeRe);
      };
      nanomatch.create = function(pattern, options) {
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        function create2() {
          return nanomatch.compile(nanomatch.parse(pattern, options), options);
        }
        return memoize2("create", pattern, options, create2);
      };
      nanomatch.parse = function(pattern, options) {
        if (typeof pattern !== "string") {
          throw new TypeError("expected a string");
        }
        function parse3() {
          var snapdragon = utils.instantiate(null, options);
          parsers(snapdragon, options);
          var ast = snapdragon.parse(pattern, options);
          utils.define(ast, "snapdragon", snapdragon);
          ast.input = pattern;
          return ast;
        }
        return memoize2("parse", pattern, options, parse3);
      };
      nanomatch.compile = function(ast, options) {
        if (typeof ast === "string") {
          ast = nanomatch.parse(ast, options);
        }
        function compile() {
          var snapdragon = utils.instantiate(ast, options);
          compilers(snapdragon, options);
          return snapdragon.compile(ast, options);
        }
        return memoize2("compile", ast.input, options, compile);
      };
      nanomatch.clearCache = function() {
        nanomatch.cache.__data__ = {};
      };
      function compose(patterns, options, matcher) {
        var matchers;
        return memoize2("compose", String(patterns), options, function() {
          return function(file2) {
            if (!matchers) {
              matchers = [];
              for (var i = 0; i < patterns.length; i++) {
                matchers.push(matcher(patterns[i], options));
              }
            }
            var len = matchers.length;
            while (len--) {
              if (matchers[len](file2) === true) {
                return true;
              }
            }
            return false;
          };
        });
      }
      function memoize2(type, pattern, options, fn) {
        var key = utils.createKey(type + "=" + pattern, options);
        if (options && options.cache === false) {
          return fn(pattern, options);
        }
        if (cache.has(type, key)) {
          return cache.get(type, key);
        }
        var val = fn(pattern, options);
        cache.set(type, key, val);
        return val;
      }
      nanomatch.compilers = compilers;
      nanomatch.parsers = parsers;
      nanomatch.cache = cache;
      module2.exports = nanomatch;
    }
  });

  // node_modules/jszip/dist/jszip.min.js
  var require_jszip_min = __commonJS({
    "node_modules/jszip/dist/jszip.min.js"(exports2, module2) {
      init_define_process();
      !function(e) {
        if ("object" == typeof exports2 && "undefined" != typeof module2)
          module2.exports = e();
        else if ("function" == typeof define && define.amd)
          define([], e);
        else {
          ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).JSZip = e();
        }
      }(function() {
        return function s(a, o, h) {
          function u(r, e2) {
            if (!o[r]) {
              if (!a[r]) {
                var t3 = "function" == typeof __require && __require;
                if (!e2 && t3)
                  return t3(r, true);
                if (l)
                  return l(r, true);
                var n = new Error("Cannot find module '" + r + "'");
                throw n.code = "MODULE_NOT_FOUND", n;
              }
              var i = o[r] = { exports: {} };
              a[r][0].call(i.exports, function(e3) {
                var t4 = a[r][1][e3];
                return u(t4 || e3);
              }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
          }
          for (var l = "function" == typeof __require && __require, e = 0; e < h.length; e++)
            u(h[e]);
          return u;
        }({ 1: [function(e, t3, r) {
          "use strict";
          var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          r.encode = function(e2) {
            for (var t4, r2, n, i, s, a, o, h = [], u = 0, l = e2.length, f = l, c2 = "string" !== d.getTypeOf(e2); u < e2.length; )
              f = l - u, n = c2 ? (t4 = e2[u++], r2 = u < l ? e2[u++] : 0, u < l ? e2[u++] : 0) : (t4 = e2.charCodeAt(u++), r2 = u < l ? e2.charCodeAt(u++) : 0, u < l ? e2.charCodeAt(u++) : 0), i = t4 >> 2, s = (3 & t4) << 4 | r2 >> 4, a = 1 < f ? (15 & r2) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
            return h.join("");
          }, r.decode = function(e2) {
            var t4, r2, n, i, s, a, o = 0, h = 0, u = "data:";
            if (e2.substr(0, u.length) === u)
              throw new Error("Invalid base64 input, it looks like a data url.");
            var l, f = 3 * (e2 = e2.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
            if (e2.charAt(e2.length - 1) === p.charAt(64) && f--, e2.charAt(e2.length - 2) === p.charAt(64) && f--, f % 1 != 0)
              throw new Error("Invalid base64 input, bad content length.");
            for (l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e2.length; )
              t4 = p.indexOf(e2.charAt(o++)) << 2 | (i = p.indexOf(e2.charAt(o++))) >> 4, r2 = (15 & i) << 4 | (s = p.indexOf(e2.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e2.charAt(o++))), l[h++] = t4, 64 !== s && (l[h++] = r2), 64 !== a && (l[h++] = n);
            return l;
          };
        }, { "./support": 30, "./utils": 32 }], 2: [function(e, t3, r) {
          "use strict";
          var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
          function o(e2, t4, r2, n2, i2) {
            this.compressedSize = e2, this.uncompressedSize = t4, this.crc32 = r2, this.compression = n2, this.compressedContent = i2;
          }
          o.prototype = { getContentWorker: function() {
            var e2 = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t4 = this;
            return e2.on("end", function() {
              if (this.streamInfo.data_length !== t4.uncompressedSize)
                throw new Error("Bug : uncompressed data size mismatch");
            }), e2;
          }, getCompressedWorker: function() {
            return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
          } }, o.createWorkerFrom = function(e2, t4, r2) {
            return e2.pipe(new s()).pipe(new a("uncompressedSize")).pipe(t4.compressWorker(r2)).pipe(new a("compressedSize")).withStreamInfo("compression", t4);
          }, t3.exports = o;
        }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(e, t3, r) {
          "use strict";
          var n = e("./stream/GenericWorker");
          r.STORE = { magic: "\0\0", compressWorker: function() {
            return new n("STORE compression");
          }, uncompressWorker: function() {
            return new n("STORE decompression");
          } }, r.DEFLATE = e("./flate");
        }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(e, t3, r) {
          "use strict";
          var n = e("./utils");
          var o = function() {
            for (var e2, t4 = [], r2 = 0; r2 < 256; r2++) {
              e2 = r2;
              for (var n2 = 0; n2 < 8; n2++)
                e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
              t4[r2] = e2;
            }
            return t4;
          }();
          t3.exports = function(e2, t4) {
            return void 0 !== e2 && e2.length ? "string" !== n.getTypeOf(e2) ? function(e3, t5, r2, n2) {
              var i = o, s = n2 + r2;
              e3 ^= -1;
              for (var a = n2; a < s; a++)
                e3 = e3 >>> 8 ^ i[255 & (e3 ^ t5[a])];
              return -1 ^ e3;
            }(0 | t4, e2, e2.length, 0) : function(e3, t5, r2, n2) {
              var i = o, s = n2 + r2;
              e3 ^= -1;
              for (var a = n2; a < s; a++)
                e3 = e3 >>> 8 ^ i[255 & (e3 ^ t5.charCodeAt(a))];
              return -1 ^ e3;
            }(0 | t4, e2, e2.length, 0) : 0;
          };
        }, { "./utils": 32 }], 5: [function(e, t3, r) {
          "use strict";
          r.base64 = false, r.binary = false, r.dir = false, r.createFolders = true, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
        }, {}], 6: [function(e, t3, r) {
          "use strict";
          var n = null;
          n = "undefined" != typeof Promise ? Promise : e("lie"), t3.exports = { Promise: n };
        }, { lie: 37 }], 7: [function(e, t3, r) {
          "use strict";
          var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
          function h(e2, t4) {
            a.call(this, "FlateWorker/" + e2), this._pako = null, this._pakoAction = e2, this._pakoOptions = t4, this.meta = {};
          }
          r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e2) {
            this.meta = e2.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e2.data), false);
          }, h.prototype.flush = function() {
            a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], true);
          }, h.prototype.cleanUp = function() {
            a.prototype.cleanUp.call(this), this._pako = null;
          }, h.prototype._createPako = function() {
            this._pako = new i[this._pakoAction]({ raw: true, level: this._pakoOptions.level || -1 });
            var t4 = this;
            this._pako.onData = function(e2) {
              t4.push({ data: e2, meta: t4.meta });
            };
          }, r.compressWorker = function(e2) {
            return new h("Deflate", e2);
          }, r.uncompressWorker = function() {
            return new h("Inflate", {});
          };
        }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(e, t3, r) {
          "use strict";
          function A(e2, t4) {
            var r2, n2 = "";
            for (r2 = 0; r2 < t4; r2++)
              n2 += String.fromCharCode(255 & e2), e2 >>>= 8;
            return n2;
          }
          function n(e2, t4, r2, n2, i2, s2) {
            var a, o, h = e2.file, u = e2.compression, l = s2 !== O.utf8encode, f = I.transformTo("string", s2(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s2(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
            t4 && !r2 || (x.crc32 = e2.crc32, x.compressedSize = e2.compressedSize, x.uncompressedSize = e2.uncompressedSize);
            var S = 0;
            t4 && (S |= 8), l || !_ && !g || (S |= 2048);
            var z = 0, C = 0;
            w && (z |= 16), "UNIX" === i2 ? (C = 798, z |= function(e3, t5) {
              var r3 = e3;
              return e3 || (r3 = t5 ? 16893 : 33204), (65535 & r3) << 16;
            }(h.unixPermissions, w)) : (C = 20, z |= function(e3) {
              return 63 & (e3 || 0);
            }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
            var E = "";
            return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), { fileRecord: R.LOCAL_FILE_HEADER + E + f + b, dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n2, 4) + f + b + p };
          }
          var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
          function s(e2, t4, r2, n2) {
            i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t4, this.zipPlatform = r2, this.encodeFileName = n2, this.streamFiles = e2, this.accumulate = false, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
          }
          I.inherits(s, i), s.prototype.push = function(e2) {
            var t4 = e2.meta.percent || 0, r2 = this.entriesCount, n2 = this._sources.length;
            this.accumulate ? this.contentBuffer.push(e2) : (this.bytesWritten += e2.data.length, i.prototype.push.call(this, { data: e2.data, meta: { currentFile: this.currentFile, percent: r2 ? (t4 + 100 * (r2 - n2 - 1)) / r2 : 100 } }));
          }, s.prototype.openedSource = function(e2) {
            this.currentSourceOffset = this.bytesWritten, this.currentFile = e2.file.name;
            var t4 = this.streamFiles && !e2.file.dir;
            if (t4) {
              var r2 = n(e2, t4, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
              this.push({ data: r2.fileRecord, meta: { percent: 0 } });
            } else
              this.accumulate = true;
          }, s.prototype.closedSource = function(e2) {
            this.accumulate = false;
            var t4 = this.streamFiles && !e2.file.dir, r2 = n(e2, t4, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
            if (this.dirRecords.push(r2.dirRecord), t4)
              this.push({ data: function(e3) {
                return R.DATA_DESCRIPTOR + A(e3.crc32, 4) + A(e3.compressedSize, 4) + A(e3.uncompressedSize, 4);
              }(e2), meta: { percent: 100 } });
            else
              for (this.push({ data: r2.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
                this.push(this.contentBuffer.shift());
            this.currentFile = null;
          }, s.prototype.flush = function() {
            for (var e2 = this.bytesWritten, t4 = 0; t4 < this.dirRecords.length; t4++)
              this.push({ data: this.dirRecords[t4], meta: { percent: 100 } });
            var r2 = this.bytesWritten - e2, n2 = function(e3, t5, r3, n3, i2) {
              var s2 = I.transformTo("string", i2(n3));
              return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e3, 2) + A(e3, 2) + A(t5, 4) + A(r3, 4) + A(s2.length, 2) + s2;
            }(this.dirRecords.length, r2, e2, this.zipComment, this.encodeFileName);
            this.push({ data: n2, meta: { percent: 100 } });
          }, s.prototype.prepareNextSource = function() {
            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
          }, s.prototype.registerPrevious = function(e2) {
            this._sources.push(e2);
            var t4 = this;
            return e2.on("data", function(e3) {
              t4.processChunk(e3);
            }), e2.on("end", function() {
              t4.closedSource(t4.previous.streamInfo), t4._sources.length ? t4.prepareNextSource() : t4.end();
            }), e2.on("error", function(e3) {
              t4.error(e3);
            }), this;
          }, s.prototype.resume = function() {
            return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), true) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), true));
          }, s.prototype.error = function(e2) {
            var t4 = this._sources;
            if (!i.prototype.error.call(this, e2))
              return false;
            for (var r2 = 0; r2 < t4.length; r2++)
              try {
                t4[r2].error(e2);
              } catch (e3) {
              }
            return true;
          }, s.prototype.lock = function() {
            i.prototype.lock.call(this);
            for (var e2 = this._sources, t4 = 0; t4 < e2.length; t4++)
              e2[t4].lock();
          }, t3.exports = s;
        }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(e, t3, r) {
          "use strict";
          var u = e("../compressions"), n = e("./ZipFileWorker");
          r.generateWorker = function(e2, a, t4) {
            var o = new n(a.streamFiles, t4, a.platform, a.encodeFileName), h = 0;
            try {
              e2.forEach(function(e3, t5) {
                h++;
                var r2 = function(e4, t6) {
                  var r3 = e4 || t6, n3 = u[r3];
                  if (!n3)
                    throw new Error(r3 + " is not a valid compression method !");
                  return n3;
                }(t5.options.compression, a.compression), n2 = t5.options.compressionOptions || a.compressionOptions || {}, i = t5.dir, s = t5.date;
                t5._compressWorker(r2, n2).withStreamInfo("file", { name: e3, dir: i, date: s, comment: t5.comment || "", unixPermissions: t5.unixPermissions, dosPermissions: t5.dosPermissions }).pipe(o);
              }), o.entriesCount = h;
            } catch (e3) {
              o.error(e3);
            }
            return o;
          };
        }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(e, t3, r) {
          "use strict";
          function n() {
            if (!(this instanceof n))
              return new n();
            if (arguments.length)
              throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
            this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
              var e2 = new n();
              for (var t4 in this)
                "function" != typeof this[t4] && (e2[t4] = this[t4]);
              return e2;
            };
          }
          (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e2, t4) {
            return new n().loadAsync(e2, t4);
          }, n.external = e("./external"), t3.exports = n;
        }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(e, t3, r) {
          "use strict";
          var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
          function f(n2) {
            return new i.Promise(function(e2, t4) {
              var r2 = n2.decompressed.getContentWorker().pipe(new a());
              r2.on("error", function(e3) {
                t4(e3);
              }).on("end", function() {
                r2.streamInfo.crc32 !== n2.decompressed.crc32 ? t4(new Error("Corrupted zip : CRC32 mismatch")) : e2();
              }).resume();
            });
          }
          t3.exports = function(e2, o) {
            var h = this;
            return o = u.extend(o || {}, { base64: false, checkCRC32: false, optimizedBinaryString: false, createFolders: false, decodeFileName: n.utf8decode }), l.isNode && l.isStream(e2) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e2, true, o.optimizedBinaryString, o.base64).then(function(e3) {
              var t4 = new s(o);
              return t4.load(e3), t4;
            }).then(function(e3) {
              var t4 = [i.Promise.resolve(e3)], r2 = e3.files;
              if (o.checkCRC32)
                for (var n2 = 0; n2 < r2.length; n2++)
                  t4.push(f(r2[n2]));
              return i.Promise.all(t4);
            }).then(function(e3) {
              for (var t4 = e3.shift(), r2 = t4.files, n2 = 0; n2 < r2.length; n2++) {
                var i2 = r2[n2], s2 = i2.fileNameStr, a2 = u.resolve(i2.fileNameStr);
                h.file(a2, i2.decompressed, { binary: true, optimizedBinaryString: true, date: i2.date, dir: i2.dir, comment: i2.fileCommentStr.length ? i2.fileCommentStr : null, unixPermissions: i2.unixPermissions, dosPermissions: i2.dosPermissions, createFolders: o.createFolders }), i2.dir || (h.file(a2).unsafeOriginalName = s2);
              }
              return t4.zipComment.length && (h.comment = t4.zipComment), h;
            });
          };
        }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("../stream/GenericWorker");
          function s(e2, t4) {
            i.call(this, "Nodejs stream input adapter for " + e2), this._upstreamEnded = false, this._bindStream(t4);
          }
          n.inherits(s, i), s.prototype._bindStream = function(e2) {
            var t4 = this;
            (this._stream = e2).pause(), e2.on("data", function(e3) {
              t4.push({ data: e3, meta: { percent: 0 } });
            }).on("error", function(e3) {
              t4.isPaused ? this.generatedError = e3 : t4.error(e3);
            }).on("end", function() {
              t4.isPaused ? t4._upstreamEnded = true : t4.end();
            });
          }, s.prototype.pause = function() {
            return !!i.prototype.pause.call(this) && (this._stream.pause(), true);
          }, s.prototype.resume = function() {
            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), true);
          }, t3.exports = s;
        }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(e, t3, r) {
          "use strict";
          var i = e("readable-stream").Readable;
          function n(e2, t4, r2) {
            i.call(this, t4), this._helper = e2;
            var n2 = this;
            e2.on("data", function(e3, t5) {
              n2.push(e3) || n2._helper.pause(), r2 && r2(t5);
            }).on("error", function(e3) {
              n2.emit("error", e3);
            }).on("end", function() {
              n2.push(null);
            });
          }
          e("../utils").inherits(n, i), n.prototype._read = function() {
            this._helper.resume();
          }, t3.exports = n;
        }, { "../utils": 32, "readable-stream": 16 }], 14: [function(e, t3, r) {
          "use strict";
          t3.exports = { isNode: "undefined" != typeof Buffer, newBufferFrom: function(e2, t4) {
            if (Buffer.from && Buffer.from !== Uint8Array.from)
              return Buffer.from(e2, t4);
            if ("number" == typeof e2)
              throw new Error('The "data" argument must not be a number');
            return new Buffer(e2, t4);
          }, allocBuffer: function(e2) {
            if (Buffer.alloc)
              return Buffer.alloc(e2);
            var t4 = new Buffer(e2);
            return t4.fill(0), t4;
          }, isBuffer: function(e2) {
            return Buffer.isBuffer(e2);
          }, isStream: function(e2) {
            return e2 && "function" == typeof e2.on && "function" == typeof e2.pause && "function" == typeof e2.resume;
          } };
        }, {}], 15: [function(e, t3, r) {
          "use strict";
          function s(e2, t4, r2) {
            var n2, i2 = u.getTypeOf(t4), s2 = u.extend(r2 || {}, f);
            s2.date = s2.date || new Date(), null !== s2.compression && (s2.compression = s2.compression.toUpperCase()), "string" == typeof s2.unixPermissions && (s2.unixPermissions = parseInt(s2.unixPermissions, 8)), s2.unixPermissions && 16384 & s2.unixPermissions && (s2.dir = true), s2.dosPermissions && 16 & s2.dosPermissions && (s2.dir = true), s2.dir && (e2 = g(e2)), s2.createFolders && (n2 = _(e2)) && b.call(this, n2, true);
            var a2 = "string" === i2 && false === s2.binary && false === s2.base64;
            r2 && void 0 !== r2.binary || (s2.binary = !a2), (t4 instanceof c && 0 === t4.uncompressedSize || s2.dir || !t4 || 0 === t4.length) && (s2.base64 = false, s2.binary = true, t4 = "", s2.compression = "STORE", i2 = "string");
            var o2 = null;
            o2 = t4 instanceof c || t4 instanceof l ? t4 : p.isNode && p.isStream(t4) ? new m(e2, t4) : u.prepareContent(e2, t4, s2.binary, s2.optimizedBinaryString, s2.base64);
            var h2 = new d(e2, o2, s2);
            this.files[e2] = h2;
          }
          var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e2) {
            "/" === e2.slice(-1) && (e2 = e2.substring(0, e2.length - 1));
            var t4 = e2.lastIndexOf("/");
            return 0 < t4 ? e2.substring(0, t4) : "";
          }, g = function(e2) {
            return "/" !== e2.slice(-1) && (e2 += "/"), e2;
          }, b = function(e2, t4) {
            return t4 = void 0 !== t4 ? t4 : f.createFolders, e2 = g(e2), this.files[e2] || s.call(this, e2, null, { dir: true, createFolders: t4 }), this.files[e2];
          };
          function h(e2) {
            return "[object RegExp]" === Object.prototype.toString.call(e2);
          }
          var n = { load: function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, forEach: function(e2) {
            var t4, r2, n2;
            for (t4 in this.files)
              n2 = this.files[t4], (r2 = t4.slice(this.root.length, t4.length)) && t4.slice(0, this.root.length) === this.root && e2(r2, n2);
          }, filter: function(r2) {
            var n2 = [];
            return this.forEach(function(e2, t4) {
              r2(e2, t4) && n2.push(t4);
            }), n2;
          }, file: function(e2, t4, r2) {
            if (1 !== arguments.length)
              return e2 = this.root + e2, s.call(this, e2, t4, r2), this;
            if (h(e2)) {
              var n2 = e2;
              return this.filter(function(e3, t5) {
                return !t5.dir && n2.test(e3);
              });
            }
            var i2 = this.files[this.root + e2];
            return i2 && !i2.dir ? i2 : null;
          }, folder: function(r2) {
            if (!r2)
              return this;
            if (h(r2))
              return this.filter(function(e3, t5) {
                return t5.dir && r2.test(e3);
              });
            var e2 = this.root + r2, t4 = b.call(this, e2), n2 = this.clone();
            return n2.root = t4.name, n2;
          }, remove: function(r2) {
            r2 = this.root + r2;
            var e2 = this.files[r2];
            if (e2 || ("/" !== r2.slice(-1) && (r2 += "/"), e2 = this.files[r2]), e2 && !e2.dir)
              delete this.files[r2];
            else
              for (var t4 = this.filter(function(e3, t5) {
                return t5.name.slice(0, r2.length) === r2;
              }), n2 = 0; n2 < t4.length; n2++)
                delete this.files[t4[n2].name];
            return this;
          }, generate: function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, generateInternalStream: function(e2) {
            var t4, r2 = {};
            try {
              if ((r2 = u.extend(e2 || {}, { streamFiles: false, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: i.utf8encode })).type = r2.type.toLowerCase(), r2.compression = r2.compression.toUpperCase(), "binarystring" === r2.type && (r2.type = "string"), !r2.type)
                throw new Error("No output type specified.");
              u.checkSupport(r2.type), "darwin" !== r2.platform && "freebsd" !== r2.platform && "linux" !== r2.platform && "sunos" !== r2.platform || (r2.platform = "UNIX"), "win32" === r2.platform && (r2.platform = "DOS");
              var n2 = r2.comment || this.comment || "";
              t4 = o.generateWorker(this, r2, n2);
            } catch (e3) {
              (t4 = new l("error")).error(e3);
            }
            return new a(t4, r2.type || "string", r2.mimeType);
          }, generateAsync: function(e2, t4) {
            return this.generateInternalStream(e2).accumulate(t4);
          }, generateNodeStream: function(e2, t4) {
            return (e2 = e2 || {}).type || (e2.type = "nodebuffer"), this.generateInternalStream(e2).toNodejsStream(t4);
          } };
          t3.exports = n;
        }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(e, t3, r) {
          "use strict";
          t3.exports = e("stream");
        }, { stream: void 0 }], 17: [function(e, t3, r) {
          "use strict";
          var n = e("./DataReader");
          function i(e2) {
            n.call(this, e2);
            for (var t4 = 0; t4 < this.data.length; t4++)
              e2[t4] = 255 & e2[t4];
          }
          e("../utils").inherits(i, n), i.prototype.byteAt = function(e2) {
            return this.data[this.zero + e2];
          }, i.prototype.lastIndexOfSignature = function(e2) {
            for (var t4 = e2.charCodeAt(0), r2 = e2.charCodeAt(1), n2 = e2.charCodeAt(2), i2 = e2.charCodeAt(3), s = this.length - 4; 0 <= s; --s)
              if (this.data[s] === t4 && this.data[s + 1] === r2 && this.data[s + 2] === n2 && this.data[s + 3] === i2)
                return s - this.zero;
            return -1;
          }, i.prototype.readAndCheckSignature = function(e2) {
            var t4 = e2.charCodeAt(0), r2 = e2.charCodeAt(1), n2 = e2.charCodeAt(2), i2 = e2.charCodeAt(3), s = this.readData(4);
            return t4 === s[0] && r2 === s[1] && n2 === s[2] && i2 === s[3];
          }, i.prototype.readData = function(e2) {
            if (this.checkOffset(e2), 0 === e2)
              return [];
            var t4 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./DataReader": 18 }], 18: [function(e, t3, r) {
          "use strict";
          var n = e("../utils");
          function i(e2) {
            this.data = e2, this.length = e2.length, this.index = 0, this.zero = 0;
          }
          i.prototype = { checkOffset: function(e2) {
            this.checkIndex(this.index + e2);
          }, checkIndex: function(e2) {
            if (this.length < this.zero + e2 || e2 < 0)
              throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e2 + "). Corrupted zip ?");
          }, setIndex: function(e2) {
            this.checkIndex(e2), this.index = e2;
          }, skip: function(e2) {
            this.setIndex(this.index + e2);
          }, byteAt: function() {
          }, readInt: function(e2) {
            var t4, r2 = 0;
            for (this.checkOffset(e2), t4 = this.index + e2 - 1; t4 >= this.index; t4--)
              r2 = (r2 << 8) + this.byteAt(t4);
            return this.index += e2, r2;
          }, readString: function(e2) {
            return n.transformTo("string", this.readData(e2));
          }, readData: function() {
          }, lastIndexOfSignature: function() {
          }, readAndCheckSignature: function() {
          }, readDate: function() {
            var e2 = this.readInt(4);
            return new Date(Date.UTC(1980 + (e2 >> 25 & 127), (e2 >> 21 & 15) - 1, e2 >> 16 & 31, e2 >> 11 & 31, e2 >> 5 & 63, (31 & e2) << 1));
          } }, t3.exports = i;
        }, { "../utils": 32 }], 19: [function(e, t3, r) {
          "use strict";
          var n = e("./Uint8ArrayReader");
          function i(e2) {
            n.call(this, e2);
          }
          e("../utils").inherits(i, n), i.prototype.readData = function(e2) {
            this.checkOffset(e2);
            var t4 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(e, t3, r) {
          "use strict";
          var n = e("./DataReader");
          function i(e2) {
            n.call(this, e2);
          }
          e("../utils").inherits(i, n), i.prototype.byteAt = function(e2) {
            return this.data.charCodeAt(this.zero + e2);
          }, i.prototype.lastIndexOfSignature = function(e2) {
            return this.data.lastIndexOf(e2) - this.zero;
          }, i.prototype.readAndCheckSignature = function(e2) {
            return e2 === this.readData(4);
          }, i.prototype.readData = function(e2) {
            this.checkOffset(e2);
            var t4 = this.data.slice(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./DataReader": 18 }], 21: [function(e, t3, r) {
          "use strict";
          var n = e("./ArrayReader");
          function i(e2) {
            n.call(this, e2);
          }
          e("../utils").inherits(i, n), i.prototype.readData = function(e2) {
            if (this.checkOffset(e2), 0 === e2)
              return new Uint8Array(0);
            var t4 = this.data.subarray(this.zero + this.index, this.zero + this.index + e2);
            return this.index += e2, t4;
          }, t3.exports = i;
        }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
          t3.exports = function(e2) {
            var t4 = n.getTypeOf(e2);
            return n.checkSupport(t4), "string" !== t4 || i.uint8array ? "nodebuffer" === t4 ? new o(e2) : i.uint8array ? new h(n.transformTo("uint8array", e2)) : new s(n.transformTo("array", e2)) : new a(e2);
          };
        }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(e, t3, r) {
          "use strict";
          r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\x07\b";
        }, {}], 24: [function(e, t3, r) {
          "use strict";
          var n = e("./GenericWorker"), i = e("../utils");
          function s(e2) {
            n.call(this, "ConvertWorker to " + e2), this.destType = e2;
          }
          i.inherits(s, n), s.prototype.processChunk = function(e2) {
            this.push({ data: i.transformTo(this.destType, e2.data), meta: e2.meta });
          }, t3.exports = s;
        }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(e, t3, r) {
          "use strict";
          var n = e("./GenericWorker"), i = e("../crc32");
          function s() {
            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
          }
          e("../utils").inherits(s, n), s.prototype.processChunk = function(e2) {
            this.streamInfo.crc32 = i(e2.data, this.streamInfo.crc32 || 0), this.push(e2);
          }, t3.exports = s;
        }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("./GenericWorker");
          function s(e2) {
            i.call(this, "DataLengthProbe for " + e2), this.propName = e2, this.withStreamInfo(e2, 0);
          }
          n.inherits(s, i), s.prototype.processChunk = function(e2) {
            if (e2) {
              var t4 = this.streamInfo[this.propName] || 0;
              this.streamInfo[this.propName] = t4 + e2.data.length;
            }
            i.prototype.processChunk.call(this, e2);
          }, t3.exports = s;
        }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(e, t3, r) {
          "use strict";
          var n = e("../utils"), i = e("./GenericWorker");
          function s(e2) {
            i.call(this, "DataWorker");
            var t4 = this;
            this.dataIsReady = false, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = false, e2.then(function(e3) {
              t4.dataIsReady = true, t4.data = e3, t4.max = e3 && e3.length || 0, t4.type = n.getTypeOf(e3), t4.isPaused || t4._tickAndRepeat();
            }, function(e3) {
              t4.error(e3);
            });
          }
          n.inherits(s, i), s.prototype.cleanUp = function() {
            i.prototype.cleanUp.call(this), this.data = null;
          }, s.prototype.resume = function() {
            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = true, n.delay(this._tickAndRepeat, [], this)), true);
          }, s.prototype._tickAndRepeat = function() {
            this._tickScheduled = false, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = true));
          }, s.prototype._tick = function() {
            if (this.isPaused || this.isFinished)
              return false;
            var e2 = null, t4 = Math.min(this.max, this.index + 16384);
            if (this.index >= this.max)
              return this.end();
            switch (this.type) {
              case "string":
                e2 = this.data.substring(this.index, t4);
                break;
              case "uint8array":
                e2 = this.data.subarray(this.index, t4);
                break;
              case "array":
              case "nodebuffer":
                e2 = this.data.slice(this.index, t4);
            }
            return this.index = t4, this.push({ data: e2, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
          }, t3.exports = s;
        }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(e, t3, r) {
          "use strict";
          function n(e2) {
            this.name = e2 || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = true, this.isFinished = false, this.isLocked = false, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
          }
          n.prototype = { push: function(e2) {
            this.emit("data", e2);
          }, end: function() {
            if (this.isFinished)
              return false;
            this.flush();
            try {
              this.emit("end"), this.cleanUp(), this.isFinished = true;
            } catch (e2) {
              this.emit("error", e2);
            }
            return true;
          }, error: function(e2) {
            return !this.isFinished && (this.isPaused ? this.generatedError = e2 : (this.isFinished = true, this.emit("error", e2), this.previous && this.previous.error(e2), this.cleanUp()), true);
          }, on: function(e2, t4) {
            return this._listeners[e2].push(t4), this;
          }, cleanUp: function() {
            this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
          }, emit: function(e2, t4) {
            if (this._listeners[e2])
              for (var r2 = 0; r2 < this._listeners[e2].length; r2++)
                this._listeners[e2][r2].call(this, t4);
          }, pipe: function(e2) {
            return e2.registerPrevious(this);
          }, registerPrevious: function(e2) {
            if (this.isLocked)
              throw new Error("The stream '" + this + "' has already been used.");
            this.streamInfo = e2.streamInfo, this.mergeStreamInfo(), this.previous = e2;
            var t4 = this;
            return e2.on("data", function(e3) {
              t4.processChunk(e3);
            }), e2.on("end", function() {
              t4.end();
            }), e2.on("error", function(e3) {
              t4.error(e3);
            }), this;
          }, pause: function() {
            return !this.isPaused && !this.isFinished && (this.isPaused = true, this.previous && this.previous.pause(), true);
          }, resume: function() {
            if (!this.isPaused || this.isFinished)
              return false;
            var e2 = this.isPaused = false;
            return this.generatedError && (this.error(this.generatedError), e2 = true), this.previous && this.previous.resume(), !e2;
          }, flush: function() {
          }, processChunk: function(e2) {
            this.push(e2);
          }, withStreamInfo: function(e2, t4) {
            return this.extraStreamInfo[e2] = t4, this.mergeStreamInfo(), this;
          }, mergeStreamInfo: function() {
            for (var e2 in this.extraStreamInfo)
              Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e2) && (this.streamInfo[e2] = this.extraStreamInfo[e2]);
          }, lock: function() {
            if (this.isLocked)
              throw new Error("The stream '" + this + "' has already been used.");
            this.isLocked = true, this.previous && this.previous.lock();
          }, toString: function() {
            var e2 = "Worker " + this.name;
            return this.previous ? this.previous + " -> " + e2 : e2;
          } }, t3.exports = n;
        }, {}], 29: [function(e, t3, r) {
          "use strict";
          var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
          if (n.nodestream)
            try {
              o = e("../nodejs/NodejsStreamOutputAdapter");
            } catch (e2) {
            }
          function l(e2, o2) {
            return new a.Promise(function(t4, r2) {
              var n2 = [], i2 = e2._internalType, s2 = e2._outputType, a2 = e2._mimeType;
              e2.on("data", function(e3, t5) {
                n2.push(e3), o2 && o2(t5);
              }).on("error", function(e3) {
                n2 = [], r2(e3);
              }).on("end", function() {
                try {
                  var e3 = function(e4, t5, r3) {
                    switch (e4) {
                      case "blob":
                        return h.newBlob(h.transformTo("arraybuffer", t5), r3);
                      case "base64":
                        return u.encode(t5);
                      default:
                        return h.transformTo(e4, t5);
                    }
                  }(s2, function(e4, t5) {
                    var r3, n3 = 0, i3 = null, s3 = 0;
                    for (r3 = 0; r3 < t5.length; r3++)
                      s3 += t5[r3].length;
                    switch (e4) {
                      case "string":
                        return t5.join("");
                      case "array":
                        return Array.prototype.concat.apply([], t5);
                      case "uint8array":
                        for (i3 = new Uint8Array(s3), r3 = 0; r3 < t5.length; r3++)
                          i3.set(t5[r3], n3), n3 += t5[r3].length;
                        return i3;
                      case "nodebuffer":
                        return Buffer.concat(t5);
                      default:
                        throw new Error("concat : unsupported type '" + e4 + "'");
                    }
                  }(i2, n2), a2);
                  t4(e3);
                } catch (e4) {
                  r2(e4);
                }
                n2 = [];
              }).resume();
            });
          }
          function f(e2, t4, r2) {
            var n2 = t4;
            switch (t4) {
              case "blob":
              case "arraybuffer":
                n2 = "uint8array";
                break;
              case "base64":
                n2 = "string";
            }
            try {
              this._internalType = n2, this._outputType = t4, this._mimeType = r2, h.checkSupport(n2), this._worker = e2.pipe(new i(n2)), e2.lock();
            } catch (e3) {
              this._worker = new s("error"), this._worker.error(e3);
            }
          }
          f.prototype = { accumulate: function(e2) {
            return l(this, e2);
          }, on: function(e2, t4) {
            var r2 = this;
            return "data" === e2 ? this._worker.on(e2, function(e3) {
              t4.call(r2, e3.data, e3.meta);
            }) : this._worker.on(e2, function() {
              h.delay(t4, arguments, r2);
            }), this;
          }, resume: function() {
            return h.delay(this._worker.resume, [], this._worker), this;
          }, pause: function() {
            return this._worker.pause(), this;
          }, toNodejsStream: function(e2) {
            if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType)
              throw new Error(this._outputType + " is not supported by this method");
            return new o(this, { objectMode: "nodebuffer" !== this._outputType }, e2);
          } }, t3.exports = f;
        }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(e, t3, r) {
          "use strict";
          if (r.base64 = true, r.array = true, r.string = true, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer)
            r.blob = false;
          else {
            var n = new ArrayBuffer(0);
            try {
              r.blob = 0 === new Blob([n], { type: "application/zip" }).size;
            } catch (e2) {
              try {
                var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
              } catch (e3) {
                r.blob = false;
              }
            }
          }
          try {
            r.nodestream = !!e("readable-stream").Readable;
          } catch (e2) {
            r.nodestream = false;
          }
        }, { "readable-stream": 16 }], 31: [function(e, t3, s) {
          "use strict";
          for (var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)
            u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
          u[254] = u[254] = 1;
          function a() {
            n.call(this, "utf-8 decode"), this.leftOver = null;
          }
          function l() {
            n.call(this, "utf-8 encode");
          }
          s.utf8encode = function(e2) {
            return h.nodebuffer ? r.newBufferFrom(e2, "utf-8") : function(e3) {
              var t4, r2, n2, i2, s2, a2 = e3.length, o2 = 0;
              for (i2 = 0; i2 < a2; i2++)
                55296 == (64512 & (r2 = e3.charCodeAt(i2))) && i2 + 1 < a2 && 56320 == (64512 & (n2 = e3.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), o2 += r2 < 128 ? 1 : r2 < 2048 ? 2 : r2 < 65536 ? 3 : 4;
              for (t4 = h.uint8array ? new Uint8Array(o2) : new Array(o2), i2 = s2 = 0; s2 < o2; i2++)
                55296 == (64512 & (r2 = e3.charCodeAt(i2))) && i2 + 1 < a2 && 56320 == (64512 & (n2 = e3.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), r2 < 128 ? t4[s2++] = r2 : (r2 < 2048 ? t4[s2++] = 192 | r2 >>> 6 : (r2 < 65536 ? t4[s2++] = 224 | r2 >>> 12 : (t4[s2++] = 240 | r2 >>> 18, t4[s2++] = 128 | r2 >>> 12 & 63), t4[s2++] = 128 | r2 >>> 6 & 63), t4[s2++] = 128 | 63 & r2);
              return t4;
            }(e2);
          }, s.utf8decode = function(e2) {
            return h.nodebuffer ? o.transformTo("nodebuffer", e2).toString("utf-8") : function(e3) {
              var t4, r2, n2, i2, s2 = e3.length, a2 = new Array(2 * s2);
              for (t4 = r2 = 0; t4 < s2; )
                if ((n2 = e3[t4++]) < 128)
                  a2[r2++] = n2;
                else if (4 < (i2 = u[n2]))
                  a2[r2++] = 65533, t4 += i2 - 1;
                else {
                  for (n2 &= 2 === i2 ? 31 : 3 === i2 ? 15 : 7; 1 < i2 && t4 < s2; )
                    n2 = n2 << 6 | 63 & e3[t4++], i2--;
                  1 < i2 ? a2[r2++] = 65533 : n2 < 65536 ? a2[r2++] = n2 : (n2 -= 65536, a2[r2++] = 55296 | n2 >> 10 & 1023, a2[r2++] = 56320 | 1023 & n2);
                }
              return a2.length !== r2 && (a2.subarray ? a2 = a2.subarray(0, r2) : a2.length = r2), o.applyFromCharCode(a2);
            }(e2 = o.transformTo(h.uint8array ? "uint8array" : "array", e2));
          }, o.inherits(a, n), a.prototype.processChunk = function(e2) {
            var t4 = o.transformTo(h.uint8array ? "uint8array" : "array", e2.data);
            if (this.leftOver && this.leftOver.length) {
              if (h.uint8array) {
                var r2 = t4;
                (t4 = new Uint8Array(r2.length + this.leftOver.length)).set(this.leftOver, 0), t4.set(r2, this.leftOver.length);
              } else
                t4 = this.leftOver.concat(t4);
              this.leftOver = null;
            }
            var n2 = function(e3, t5) {
              var r3;
              for ((t5 = t5 || e3.length) > e3.length && (t5 = e3.length), r3 = t5 - 1; 0 <= r3 && 128 == (192 & e3[r3]); )
                r3--;
              return r3 < 0 ? t5 : 0 === r3 ? t5 : r3 + u[e3[r3]] > t5 ? r3 : t5;
            }(t4), i2 = t4;
            n2 !== t4.length && (h.uint8array ? (i2 = t4.subarray(0, n2), this.leftOver = t4.subarray(n2, t4.length)) : (i2 = t4.slice(0, n2), this.leftOver = t4.slice(n2, t4.length))), this.push({ data: s.utf8decode(i2), meta: e2.meta });
          }, a.prototype.flush = function() {
            this.leftOver && this.leftOver.length && (this.push({ data: s.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
          }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e2) {
            this.push({ data: s.utf8encode(e2.data), meta: e2.meta });
          }, s.Utf8EncodeWorker = l;
        }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(e, t3, a) {
          "use strict";
          var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
          function n(e2) {
            return e2;
          }
          function l(e2, t4) {
            for (var r2 = 0; r2 < e2.length; ++r2)
              t4[r2] = 255 & e2.charCodeAt(r2);
            return t4;
          }
          e("setimmediate"), a.newBlob = function(t4, r2) {
            a.checkSupport("blob");
            try {
              return new Blob([t4], { type: r2 });
            } catch (e2) {
              try {
                var n2 = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
                return n2.append(t4), n2.getBlob(r2);
              } catch (e3) {
                throw new Error("Bug : can't construct the Blob.");
              }
            }
          };
          var i = { stringifyByChunk: function(e2, t4, r2) {
            var n2 = [], i2 = 0, s2 = e2.length;
            if (s2 <= r2)
              return String.fromCharCode.apply(null, e2);
            for (; i2 < s2; )
              "array" === t4 || "nodebuffer" === t4 ? n2.push(String.fromCharCode.apply(null, e2.slice(i2, Math.min(i2 + r2, s2)))) : n2.push(String.fromCharCode.apply(null, e2.subarray(i2, Math.min(i2 + r2, s2)))), i2 += r2;
            return n2.join("");
          }, stringifyByChar: function(e2) {
            for (var t4 = "", r2 = 0; r2 < e2.length; r2++)
              t4 += String.fromCharCode(e2[r2]);
            return t4;
          }, applyCanBeUsed: { uint8array: function() {
            try {
              return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
            } catch (e2) {
              return false;
            }
          }(), nodebuffer: function() {
            try {
              return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
            } catch (e2) {
              return false;
            }
          }() } };
          function s(e2) {
            var t4 = 65536, r2 = a.getTypeOf(e2), n2 = true;
            if ("uint8array" === r2 ? n2 = i.applyCanBeUsed.uint8array : "nodebuffer" === r2 && (n2 = i.applyCanBeUsed.nodebuffer), n2)
              for (; 1 < t4; )
                try {
                  return i.stringifyByChunk(e2, r2, t4);
                } catch (e3) {
                  t4 = Math.floor(t4 / 2);
                }
            return i.stringifyByChar(e2);
          }
          function f(e2, t4) {
            for (var r2 = 0; r2 < e2.length; r2++)
              t4[r2] = e2[r2];
            return t4;
          }
          a.applyFromCharCode = s;
          var c = {};
          c.string = { string: n, array: function(e2) {
            return l(e2, new Array(e2.length));
          }, arraybuffer: function(e2) {
            return c.string.uint8array(e2).buffer;
          }, uint8array: function(e2) {
            return l(e2, new Uint8Array(e2.length));
          }, nodebuffer: function(e2) {
            return l(e2, r.allocBuffer(e2.length));
          } }, c.array = { string: s, array: n, arraybuffer: function(e2) {
            return new Uint8Array(e2).buffer;
          }, uint8array: function(e2) {
            return new Uint8Array(e2);
          }, nodebuffer: function(e2) {
            return r.newBufferFrom(e2);
          } }, c.arraybuffer = { string: function(e2) {
            return s(new Uint8Array(e2));
          }, array: function(e2) {
            return f(new Uint8Array(e2), new Array(e2.byteLength));
          }, arraybuffer: n, uint8array: function(e2) {
            return new Uint8Array(e2);
          }, nodebuffer: function(e2) {
            return r.newBufferFrom(new Uint8Array(e2));
          } }, c.uint8array = { string: s, array: function(e2) {
            return f(e2, new Array(e2.length));
          }, arraybuffer: function(e2) {
            return e2.buffer;
          }, uint8array: n, nodebuffer: function(e2) {
            return r.newBufferFrom(e2);
          } }, c.nodebuffer = { string: s, array: function(e2) {
            return f(e2, new Array(e2.length));
          }, arraybuffer: function(e2) {
            return c.nodebuffer.uint8array(e2).buffer;
          }, uint8array: function(e2) {
            return f(e2, new Uint8Array(e2.length));
          }, nodebuffer: n }, a.transformTo = function(e2, t4) {
            if (t4 = t4 || "", !e2)
              return t4;
            a.checkSupport(e2);
            var r2 = a.getTypeOf(t4);
            return c[r2][e2](t4);
          }, a.resolve = function(e2) {
            for (var t4 = e2.split("/"), r2 = [], n2 = 0; n2 < t4.length; n2++) {
              var i2 = t4[n2];
              "." === i2 || "" === i2 && 0 !== n2 && n2 !== t4.length - 1 || (".." === i2 ? r2.pop() : r2.push(i2));
            }
            return r2.join("/");
          }, a.getTypeOf = function(e2) {
            return "string" == typeof e2 ? "string" : "[object Array]" === Object.prototype.toString.call(e2) ? "array" : o.nodebuffer && r.isBuffer(e2) ? "nodebuffer" : o.uint8array && e2 instanceof Uint8Array ? "uint8array" : o.arraybuffer && e2 instanceof ArrayBuffer ? "arraybuffer" : void 0;
          }, a.checkSupport = function(e2) {
            if (!o[e2.toLowerCase()])
              throw new Error(e2 + " is not supported by this platform");
          }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e2) {
            var t4, r2, n2 = "";
            for (r2 = 0; r2 < (e2 || "").length; r2++)
              n2 += "\\x" + ((t4 = e2.charCodeAt(r2)) < 16 ? "0" : "") + t4.toString(16).toUpperCase();
            return n2;
          }, a.delay = function(e2, t4, r2) {
            setImmediate(function() {
              e2.apply(r2 || null, t4 || []);
            });
          }, a.inherits = function(e2, t4) {
            function r2() {
            }
            r2.prototype = t4.prototype, e2.prototype = new r2();
          }, a.extend = function() {
            var e2, t4, r2 = {};
            for (e2 = 0; e2 < arguments.length; e2++)
              for (t4 in arguments[e2])
                Object.prototype.hasOwnProperty.call(arguments[e2], t4) && void 0 === r2[t4] && (r2[t4] = arguments[e2][t4]);
            return r2;
          }, a.prepareContent = function(r2, e2, n2, i2, s2) {
            return u.Promise.resolve(e2).then(function(n3) {
              return o.blob && (n3 instanceof Blob || -1 !== ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(n3))) && "undefined" != typeof FileReader ? new u.Promise(function(t4, r3) {
                var e3 = new FileReader();
                e3.onload = function(e4) {
                  t4(e4.target.result);
                }, e3.onerror = function(e4) {
                  r3(e4.target.error);
                }, e3.readAsArrayBuffer(n3);
              }) : n3;
            }).then(function(e3) {
              var t4 = a.getTypeOf(e3);
              return t4 ? ("arraybuffer" === t4 ? e3 = a.transformTo("uint8array", e3) : "string" === t4 && (s2 ? e3 = h.decode(e3) : n2 && true !== i2 && (e3 = function(e4) {
                return l(e4, o.uint8array ? new Uint8Array(e4.length) : new Array(e4.length));
              }(e3))), e3) : u.Promise.reject(new Error("Can't read the data of '" + r2 + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
            });
          };
        }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(e, t3, r) {
          "use strict";
          var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
          function h(e2) {
            this.files = [], this.loadOptions = e2;
          }
          h.prototype = { checkSignature: function(e2) {
            if (!this.reader.readAndCheckSignature(e2)) {
              this.reader.index -= 4;
              var t4 = this.reader.readString(4);
              throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t4) + ", expected " + i.pretty(e2) + ")");
            }
          }, isSignature: function(e2, t4) {
            var r2 = this.reader.index;
            this.reader.setIndex(e2);
            var n2 = this.reader.readString(4) === t4;
            return this.reader.setIndex(r2), n2;
          }, readBlockEndOfCentral: function() {
            this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
            var e2 = this.reader.readData(this.zipCommentLength), t4 = o.uint8array ? "uint8array" : "array", r2 = i.transformTo(t4, e2);
            this.zipComment = this.loadOptions.decodeFileName(r2);
          }, readBlockZip64EndOfCentral: function() {
            this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
            for (var e2, t4, r2, n2 = this.zip64EndOfCentralSize - 44; 0 < n2; )
              e2 = this.reader.readInt(2), t4 = this.reader.readInt(4), r2 = this.reader.readData(t4), this.zip64ExtensibleData[e2] = { id: e2, length: t4, value: r2 };
          }, readBlockZip64EndOfCentralLocator: function() {
            if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
              throw new Error("Multi-volumes zip are not supported");
          }, readLocalFiles: function() {
            var e2, t4;
            for (e2 = 0; e2 < this.files.length; e2++)
              t4 = this.files[e2], this.reader.setIndex(t4.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t4.readLocalPart(this.reader), t4.handleUTF8(), t4.processAttributes();
          }, readCentralDir: function() {
            var e2;
            for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER); )
              (e2 = new a({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e2);
            if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length)
              throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
          }, readEndOfCentral: function() {
            var e2 = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
            if (e2 < 0)
              throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
            this.reader.setIndex(e2);
            var t4 = e2;
            if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
              if (this.zip64 = true, (e2 = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
              if (this.reader.setIndex(e2), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
              this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
            }
            var r2 = this.centralDirOffset + this.centralDirSize;
            this.zip64 && (r2 += 20, r2 += 12 + this.zip64EndOfCentralSize);
            var n2 = t4 - r2;
            if (0 < n2)
              this.isSignature(t4, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n2);
            else if (n2 < 0)
              throw new Error("Corrupted zip: missing " + Math.abs(n2) + " bytes.");
          }, prepareReader: function(e2) {
            this.reader = n(e2);
          }, load: function(e2) {
            this.prepareReader(e2), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
          } }, t3.exports = h;
        }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(e, t3, r) {
          "use strict";
          var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
          function l(e2, t4) {
            this.options = e2, this.loadOptions = t4;
          }
          l.prototype = { isEncrypted: function() {
            return 1 == (1 & this.bitFlag);
          }, useUTF8: function() {
            return 2048 == (2048 & this.bitFlag);
          }, readLocalPart: function(e2) {
            var t4, r2;
            if (e2.skip(22), this.fileNameLength = e2.readInt(2), r2 = e2.readInt(2), this.fileName = e2.readData(this.fileNameLength), e2.skip(r2), -1 === this.compressedSize || -1 === this.uncompressedSize)
              throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
            if (null === (t4 = function(e3) {
              for (var t5 in h)
                if (Object.prototype.hasOwnProperty.call(h, t5) && h[t5].magic === e3)
                  return h[t5];
              return null;
            }(this.compressionMethod)))
              throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
            this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t4, e2.readData(this.compressedSize));
          }, readCentralPart: function(e2) {
            this.versionMadeBy = e2.readInt(2), e2.skip(2), this.bitFlag = e2.readInt(2), this.compressionMethod = e2.readString(2), this.date = e2.readDate(), this.crc32 = e2.readInt(4), this.compressedSize = e2.readInt(4), this.uncompressedSize = e2.readInt(4);
            var t4 = e2.readInt(2);
            if (this.extraFieldsLength = e2.readInt(2), this.fileCommentLength = e2.readInt(2), this.diskNumberStart = e2.readInt(2), this.internalFileAttributes = e2.readInt(2), this.externalFileAttributes = e2.readInt(4), this.localHeaderOffset = e2.readInt(4), this.isEncrypted())
              throw new Error("Encrypted zip are not supported");
            e2.skip(t4), this.readExtraFields(e2), this.parseZIP64ExtraField(e2), this.fileComment = e2.readData(this.fileCommentLength);
          }, processAttributes: function() {
            this.unixPermissions = null, this.dosPermissions = null;
            var e2 = this.versionMadeBy >> 8;
            this.dir = !!(16 & this.externalFileAttributes), 0 == e2 && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e2 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = true);
          }, parseZIP64ExtraField: function() {
            if (this.extraFields[1]) {
              var e2 = n(this.extraFields[1].value);
              this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e2.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e2.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e2.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e2.readInt(4));
            }
          }, readExtraFields: function(e2) {
            var t4, r2, n2, i2 = e2.index + this.extraFieldsLength;
            for (this.extraFields || (this.extraFields = {}); e2.index + 4 < i2; )
              t4 = e2.readInt(2), r2 = e2.readInt(2), n2 = e2.readData(r2), this.extraFields[t4] = { id: t4, length: r2, value: n2 };
            e2.setIndex(i2);
          }, handleUTF8: function() {
            var e2 = u.uint8array ? "uint8array" : "array";
            if (this.useUTF8())
              this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
            else {
              var t4 = this.findExtraFieldUnicodePath();
              if (null !== t4)
                this.fileNameStr = t4;
              else {
                var r2 = s.transformTo(e2, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(r2);
              }
              var n2 = this.findExtraFieldUnicodeComment();
              if (null !== n2)
                this.fileCommentStr = n2;
              else {
                var i2 = s.transformTo(e2, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(i2);
              }
            }
          }, findExtraFieldUnicodePath: function() {
            var e2 = this.extraFields[28789];
            if (e2) {
              var t4 = n(e2.value);
              return 1 !== t4.readInt(1) ? null : a(this.fileName) !== t4.readInt(4) ? null : o.utf8decode(t4.readData(e2.length - 5));
            }
            return null;
          }, findExtraFieldUnicodeComment: function() {
            var e2 = this.extraFields[25461];
            if (e2) {
              var t4 = n(e2.value);
              return 1 !== t4.readInt(1) ? null : a(this.fileComment) !== t4.readInt(4) ? null : o.utf8decode(t4.readData(e2.length - 5));
            }
            return null;
          } }, t3.exports = l;
        }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(e, t3, r) {
          "use strict";
          function n(e2, t4, r2) {
            this.name = e2, this.dir = r2.dir, this.date = r2.date, this.comment = r2.comment, this.unixPermissions = r2.unixPermissions, this.dosPermissions = r2.dosPermissions, this._data = t4, this._dataBinary = r2.binary, this.options = { compression: r2.compression, compressionOptions: r2.compressionOptions };
          }
          var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
          n.prototype = { internalStream: function(e2) {
            var t4 = null, r2 = "string";
            try {
              if (!e2)
                throw new Error("No output type specified.");
              var n2 = "string" === (r2 = e2.toLowerCase()) || "text" === r2;
              "binarystring" !== r2 && "text" !== r2 || (r2 = "string"), t4 = this._decompressWorker();
              var i2 = !this._dataBinary;
              i2 && !n2 && (t4 = t4.pipe(new a.Utf8EncodeWorker())), !i2 && n2 && (t4 = t4.pipe(new a.Utf8DecodeWorker()));
            } catch (e3) {
              (t4 = new h("error")).error(e3);
            }
            return new s(t4, r2, "");
          }, async: function(e2, t4) {
            return this.internalStream(e2).accumulate(t4);
          }, nodeStream: function(e2, t4) {
            return this.internalStream(e2 || "nodebuffer").toNodejsStream(t4);
          }, _compressWorker: function(e2, t4) {
            if (this._data instanceof o && this._data.compression.magic === e2.magic)
              return this._data.getCompressedWorker();
            var r2 = this._decompressWorker();
            return this._dataBinary || (r2 = r2.pipe(new a.Utf8EncodeWorker())), o.createWorkerFrom(r2, e2, t4);
          }, _decompressWorker: function() {
            return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
          } };
          for (var u = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], l = function() {
            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
          }, f = 0; f < u.length; f++)
            n.prototype[u[f]] = l;
          t3.exports = n;
        }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(e, l, t3) {
          (function(t4) {
            "use strict";
            var r, n, e2 = t4.MutationObserver || t4.WebKitMutationObserver;
            if (e2) {
              var i = 0, s = new e2(u), a = t4.document.createTextNode("");
              s.observe(a, { characterData: true }), r = function() {
                a.data = i = ++i % 2;
              };
            } else if (t4.setImmediate || void 0 === t4.MessageChannel)
              r = "document" in t4 && "onreadystatechange" in t4.document.createElement("script") ? function() {
                var e3 = t4.document.createElement("script");
                e3.onreadystatechange = function() {
                  u(), e3.onreadystatechange = null, e3.parentNode.removeChild(e3), e3 = null;
                }, t4.document.documentElement.appendChild(e3);
              } : function() {
                setTimeout(u, 0);
              };
            else {
              var o = new t4.MessageChannel();
              o.port1.onmessage = u, r = function() {
                o.port2.postMessage(0);
              };
            }
            var h = [];
            function u() {
              var e3, t5;
              n = true;
              for (var r2 = h.length; r2; ) {
                for (t5 = h, h = [], e3 = -1; ++e3 < r2; )
                  t5[e3]();
                r2 = h.length;
              }
              n = false;
            }
            l.exports = function(e3) {
              1 !== h.push(e3) || n || r();
            };
          }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {}], 37: [function(e, t3, r) {
          "use strict";
          var i = e("immediate");
          function u() {
          }
          var l = {}, s = ["REJECTED"], a = ["FULFILLED"], n = ["PENDING"];
          function o(e2) {
            if ("function" != typeof e2)
              throw new TypeError("resolver must be a function");
            this.state = n, this.queue = [], this.outcome = void 0, e2 !== u && d(this, e2);
          }
          function h(e2, t4, r2) {
            this.promise = e2, "function" == typeof t4 && (this.onFulfilled = t4, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r2 && (this.onRejected = r2, this.callRejected = this.otherCallRejected);
          }
          function f(t4, r2, n2) {
            i(function() {
              var e2;
              try {
                e2 = r2(n2);
              } catch (e3) {
                return l.reject(t4, e3);
              }
              e2 === t4 ? l.reject(t4, new TypeError("Cannot resolve promise with itself")) : l.resolve(t4, e2);
            });
          }
          function c(e2) {
            var t4 = e2 && e2.then;
            if (e2 && ("object" == typeof e2 || "function" == typeof e2) && "function" == typeof t4)
              return function() {
                t4.apply(e2, arguments);
              };
          }
          function d(t4, e2) {
            var r2 = false;
            function n2(e3) {
              r2 || (r2 = true, l.reject(t4, e3));
            }
            function i2(e3) {
              r2 || (r2 = true, l.resolve(t4, e3));
            }
            var s2 = p(function() {
              e2(i2, n2);
            });
            "error" === s2.status && n2(s2.value);
          }
          function p(e2, t4) {
            var r2 = {};
            try {
              r2.value = e2(t4), r2.status = "success";
            } catch (e3) {
              r2.status = "error", r2.value = e3;
            }
            return r2;
          }
          (t3.exports = o).prototype.finally = function(t4) {
            if ("function" != typeof t4)
              return this;
            var r2 = this.constructor;
            return this.then(function(e2) {
              return r2.resolve(t4()).then(function() {
                return e2;
              });
            }, function(e2) {
              return r2.resolve(t4()).then(function() {
                throw e2;
              });
            });
          }, o.prototype.catch = function(e2) {
            return this.then(null, e2);
          }, o.prototype.then = function(e2, t4) {
            if ("function" != typeof e2 && this.state === a || "function" != typeof t4 && this.state === s)
              return this;
            var r2 = new this.constructor(u);
            this.state !== n ? f(r2, this.state === a ? e2 : t4, this.outcome) : this.queue.push(new h(r2, e2, t4));
            return r2;
          }, h.prototype.callFulfilled = function(e2) {
            l.resolve(this.promise, e2);
          }, h.prototype.otherCallFulfilled = function(e2) {
            f(this.promise, this.onFulfilled, e2);
          }, h.prototype.callRejected = function(e2) {
            l.reject(this.promise, e2);
          }, h.prototype.otherCallRejected = function(e2) {
            f(this.promise, this.onRejected, e2);
          }, l.resolve = function(e2, t4) {
            var r2 = p(c, t4);
            if ("error" === r2.status)
              return l.reject(e2, r2.value);
            var n2 = r2.value;
            if (n2)
              d(e2, n2);
            else {
              e2.state = a, e2.outcome = t4;
              for (var i2 = -1, s2 = e2.queue.length; ++i2 < s2; )
                e2.queue[i2].callFulfilled(t4);
            }
            return e2;
          }, l.reject = function(e2, t4) {
            e2.state = s, e2.outcome = t4;
            for (var r2 = -1, n2 = e2.queue.length; ++r2 < n2; )
              e2.queue[r2].callRejected(t4);
            return e2;
          }, o.resolve = function(e2) {
            if (e2 instanceof this)
              return e2;
            return l.resolve(new this(u), e2);
          }, o.reject = function(e2) {
            var t4 = new this(u);
            return l.reject(t4, e2);
          }, o.all = function(e2) {
            var r2 = this;
            if ("[object Array]" !== Object.prototype.toString.call(e2))
              return this.reject(new TypeError("must be an array"));
            var n2 = e2.length, i2 = false;
            if (!n2)
              return this.resolve([]);
            var s2 = new Array(n2), a2 = 0, t4 = -1, o2 = new this(u);
            for (; ++t4 < n2; )
              h2(e2[t4], t4);
            return o2;
            function h2(e3, t5) {
              r2.resolve(e3).then(function(e4) {
                s2[t5] = e4, ++a2 !== n2 || i2 || (i2 = true, l.resolve(o2, s2));
              }, function(e4) {
                i2 || (i2 = true, l.reject(o2, e4));
              });
            }
          }, o.race = function(e2) {
            var t4 = this;
            if ("[object Array]" !== Object.prototype.toString.call(e2))
              return this.reject(new TypeError("must be an array"));
            var r2 = e2.length, n2 = false;
            if (!r2)
              return this.resolve([]);
            var i2 = -1, s2 = new this(u);
            for (; ++i2 < r2; )
              a2 = e2[i2], t4.resolve(a2).then(function(e3) {
                n2 || (n2 = true, l.resolve(s2, e3));
              }, function(e3) {
                n2 || (n2 = true, l.reject(s2, e3));
              });
            var a2;
            return s2;
          };
        }, { immediate: 36 }], 38: [function(e, t3, r) {
          "use strict";
          var n = {};
          (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t3.exports = n;
        }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(e, t3, r) {
          "use strict";
          var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
          function p(e2) {
            if (!(this instanceof p))
              return new p(e2);
            this.options = o.assign({ level: f, method: d, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: c, to: "" }, e2 || {});
            var t4 = this.options;
            t4.raw && 0 < t4.windowBits ? t4.windowBits = -t4.windowBits : t4.gzip && 0 < t4.windowBits && t4.windowBits < 16 && (t4.windowBits += 16), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
            var r2 = a.deflateInit2(this.strm, t4.level, t4.method, t4.windowBits, t4.memLevel, t4.strategy);
            if (r2 !== l)
              throw new Error(i[r2]);
            if (t4.header && a.deflateSetHeader(this.strm, t4.header), t4.dictionary) {
              var n2;
              if (n2 = "string" == typeof t4.dictionary ? h.string2buf(t4.dictionary) : "[object ArrayBuffer]" === u.call(t4.dictionary) ? new Uint8Array(t4.dictionary) : t4.dictionary, (r2 = a.deflateSetDictionary(this.strm, n2)) !== l)
                throw new Error(i[r2]);
              this._dict_set = true;
            }
          }
          function n(e2, t4) {
            var r2 = new p(t4);
            if (r2.push(e2, true), r2.err)
              throw r2.msg || i[r2.err];
            return r2.result;
          }
          p.prototype.push = function(e2, t4) {
            var r2, n2, i2 = this.strm, s2 = this.options.chunkSize;
            if (this.ended)
              return false;
            n2 = t4 === ~~t4 ? t4 : true === t4 ? 4 : 0, "string" == typeof e2 ? i2.input = h.string2buf(e2) : "[object ArrayBuffer]" === u.call(e2) ? i2.input = new Uint8Array(e2) : i2.input = e2, i2.next_in = 0, i2.avail_in = i2.input.length;
            do {
              if (0 === i2.avail_out && (i2.output = new o.Buf8(s2), i2.next_out = 0, i2.avail_out = s2), 1 !== (r2 = a.deflate(i2, n2)) && r2 !== l)
                return this.onEnd(r2), !(this.ended = true);
              0 !== i2.avail_out && (0 !== i2.avail_in || 4 !== n2 && 2 !== n2) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i2.output, i2.next_out))) : this.onData(o.shrinkBuf(i2.output, i2.next_out)));
            } while ((0 < i2.avail_in || 0 === i2.avail_out) && 1 !== r2);
            return 4 === n2 ? (r2 = a.deflateEnd(this.strm), this.onEnd(r2), this.ended = true, r2 === l) : 2 !== n2 || (this.onEnd(l), !(i2.avail_out = 0));
          }, p.prototype.onData = function(e2) {
            this.chunks.push(e2);
          }, p.prototype.onEnd = function(e2) {
            e2 === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e2, this.msg = this.strm.msg;
          }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e2, t4) {
            return (t4 = t4 || {}).raw = true, n(e2, t4);
          }, r.gzip = function(e2, t4) {
            return (t4 = t4 || {}).gzip = true, n(e2, t4);
          };
        }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(e, t3, r) {
          "use strict";
          var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
          function a(e2) {
            if (!(this instanceof a))
              return new a(e2);
            this.options = d.assign({ chunkSize: 16384, windowBits: 0, to: "" }, e2 || {});
            var t4 = this.options;
            t4.raw && 0 <= t4.windowBits && t4.windowBits < 16 && (t4.windowBits = -t4.windowBits, 0 === t4.windowBits && (t4.windowBits = -15)), !(0 <= t4.windowBits && t4.windowBits < 16) || e2 && e2.windowBits || (t4.windowBits += 32), 15 < t4.windowBits && t4.windowBits < 48 && 0 == (15 & t4.windowBits) && (t4.windowBits |= 15), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
            var r2 = c.inflateInit2(this.strm, t4.windowBits);
            if (r2 !== m.Z_OK)
              throw new Error(n[r2]);
            this.header = new s(), c.inflateGetHeader(this.strm, this.header);
          }
          function o(e2, t4) {
            var r2 = new a(t4);
            if (r2.push(e2, true), r2.err)
              throw r2.msg || n[r2.err];
            return r2.result;
          }
          a.prototype.push = function(e2, t4) {
            var r2, n2, i2, s2, a2, o2, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = false;
            if (this.ended)
              return false;
            n2 = t4 === ~~t4 ? t4 : true === t4 ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e2 ? h.input = p.binstring2buf(e2) : "[object ArrayBuffer]" === _.call(e2) ? h.input = new Uint8Array(e2) : h.input = e2, h.next_in = 0, h.avail_in = h.input.length;
            do {
              if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r2 = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o2 = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r2 = c.inflateSetDictionary(this.strm, o2)), r2 === m.Z_BUF_ERROR && true === f && (r2 = m.Z_OK, f = false), r2 !== m.Z_STREAM_END && r2 !== m.Z_OK)
                return this.onEnd(r2), !(this.ended = true);
              h.next_out && (0 !== h.avail_out && r2 !== m.Z_STREAM_END && (0 !== h.avail_in || n2 !== m.Z_FINISH && n2 !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i2 = p.utf8border(h.output, h.next_out), s2 = h.next_out - i2, a2 = p.buf2string(h.output, i2), h.next_out = s2, h.avail_out = u - s2, s2 && d.arraySet(h.output, h.output, i2, s2, 0), this.onData(a2)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = true);
            } while ((0 < h.avail_in || 0 === h.avail_out) && r2 !== m.Z_STREAM_END);
            return r2 === m.Z_STREAM_END && (n2 = m.Z_FINISH), n2 === m.Z_FINISH ? (r2 = c.inflateEnd(this.strm), this.onEnd(r2), this.ended = true, r2 === m.Z_OK) : n2 !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), !(h.avail_out = 0));
          }, a.prototype.onData = function(e2) {
            this.chunks.push(e2);
          }, a.prototype.onEnd = function(e2) {
            e2 === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e2, this.msg = this.strm.msg;
          }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e2, t4) {
            return (t4 = t4 || {}).raw = true, o(e2, t4);
          }, r.ungzip = o;
        }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(e, t3, r) {
          "use strict";
          var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
          r.assign = function(e2) {
            for (var t4 = Array.prototype.slice.call(arguments, 1); t4.length; ) {
              var r2 = t4.shift();
              if (r2) {
                if ("object" != typeof r2)
                  throw new TypeError(r2 + "must be non-object");
                for (var n2 in r2)
                  r2.hasOwnProperty(n2) && (e2[n2] = r2[n2]);
              }
            }
            return e2;
          }, r.shrinkBuf = function(e2, t4) {
            return e2.length === t4 ? e2 : e2.subarray ? e2.subarray(0, t4) : (e2.length = t4, e2);
          };
          var i = { arraySet: function(e2, t4, r2, n2, i2) {
            if (t4.subarray && e2.subarray)
              e2.set(t4.subarray(r2, r2 + n2), i2);
            else
              for (var s2 = 0; s2 < n2; s2++)
                e2[i2 + s2] = t4[r2 + s2];
          }, flattenChunks: function(e2) {
            var t4, r2, n2, i2, s2, a;
            for (t4 = n2 = 0, r2 = e2.length; t4 < r2; t4++)
              n2 += e2[t4].length;
            for (a = new Uint8Array(n2), t4 = i2 = 0, r2 = e2.length; t4 < r2; t4++)
              s2 = e2[t4], a.set(s2, i2), i2 += s2.length;
            return a;
          } }, s = { arraySet: function(e2, t4, r2, n2, i2) {
            for (var s2 = 0; s2 < n2; s2++)
              e2[i2 + s2] = t4[r2 + s2];
          }, flattenChunks: function(e2) {
            return [].concat.apply([], e2);
          } };
          r.setTyped = function(e2) {
            e2 ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
          }, r.setTyped(n);
        }, {}], 42: [function(e, t3, r) {
          "use strict";
          var h = e("./common"), i = true, s = true;
          try {
            String.fromCharCode.apply(null, [0]);
          } catch (e2) {
            i = false;
          }
          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch (e2) {
            s = false;
          }
          for (var u = new h.Buf8(256), n = 0; n < 256; n++)
            u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
          function l(e2, t4) {
            if (t4 < 65537 && (e2.subarray && s || !e2.subarray && i))
              return String.fromCharCode.apply(null, h.shrinkBuf(e2, t4));
            for (var r2 = "", n2 = 0; n2 < t4; n2++)
              r2 += String.fromCharCode(e2[n2]);
            return r2;
          }
          u[254] = u[254] = 1, r.string2buf = function(e2) {
            var t4, r2, n2, i2, s2, a = e2.length, o = 0;
            for (i2 = 0; i2 < a; i2++)
              55296 == (64512 & (r2 = e2.charCodeAt(i2))) && i2 + 1 < a && 56320 == (64512 & (n2 = e2.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), o += r2 < 128 ? 1 : r2 < 2048 ? 2 : r2 < 65536 ? 3 : 4;
            for (t4 = new h.Buf8(o), i2 = s2 = 0; s2 < o; i2++)
              55296 == (64512 & (r2 = e2.charCodeAt(i2))) && i2 + 1 < a && 56320 == (64512 & (n2 = e2.charCodeAt(i2 + 1))) && (r2 = 65536 + (r2 - 55296 << 10) + (n2 - 56320), i2++), r2 < 128 ? t4[s2++] = r2 : (r2 < 2048 ? t4[s2++] = 192 | r2 >>> 6 : (r2 < 65536 ? t4[s2++] = 224 | r2 >>> 12 : (t4[s2++] = 240 | r2 >>> 18, t4[s2++] = 128 | r2 >>> 12 & 63), t4[s2++] = 128 | r2 >>> 6 & 63), t4[s2++] = 128 | 63 & r2);
            return t4;
          }, r.buf2binstring = function(e2) {
            return l(e2, e2.length);
          }, r.binstring2buf = function(e2) {
            for (var t4 = new h.Buf8(e2.length), r2 = 0, n2 = t4.length; r2 < n2; r2++)
              t4[r2] = e2.charCodeAt(r2);
            return t4;
          }, r.buf2string = function(e2, t4) {
            var r2, n2, i2, s2, a = t4 || e2.length, o = new Array(2 * a);
            for (r2 = n2 = 0; r2 < a; )
              if ((i2 = e2[r2++]) < 128)
                o[n2++] = i2;
              else if (4 < (s2 = u[i2]))
                o[n2++] = 65533, r2 += s2 - 1;
              else {
                for (i2 &= 2 === s2 ? 31 : 3 === s2 ? 15 : 7; 1 < s2 && r2 < a; )
                  i2 = i2 << 6 | 63 & e2[r2++], s2--;
                1 < s2 ? o[n2++] = 65533 : i2 < 65536 ? o[n2++] = i2 : (i2 -= 65536, o[n2++] = 55296 | i2 >> 10 & 1023, o[n2++] = 56320 | 1023 & i2);
              }
            return l(o, n2);
          }, r.utf8border = function(e2, t4) {
            var r2;
            for ((t4 = t4 || e2.length) > e2.length && (t4 = e2.length), r2 = t4 - 1; 0 <= r2 && 128 == (192 & e2[r2]); )
              r2--;
            return r2 < 0 ? t4 : 0 === r2 ? t4 : r2 + u[e2[r2]] > t4 ? r2 : t4;
          };
        }, { "./common": 41 }], 43: [function(e, t3, r) {
          "use strict";
          t3.exports = function(e2, t4, r2, n) {
            for (var i = 65535 & e2 | 0, s = e2 >>> 16 & 65535 | 0, a = 0; 0 !== r2; ) {
              for (r2 -= a = 2e3 < r2 ? 2e3 : r2; s = s + (i = i + t4[n++] | 0) | 0, --a; )
                ;
              i %= 65521, s %= 65521;
            }
            return i | s << 16 | 0;
          };
        }, {}], 44: [function(e, t3, r) {
          "use strict";
          t3.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
        }, {}], 45: [function(e, t3, r) {
          "use strict";
          var o = function() {
            for (var e2, t4 = [], r2 = 0; r2 < 256; r2++) {
              e2 = r2;
              for (var n = 0; n < 8; n++)
                e2 = 1 & e2 ? 3988292384 ^ e2 >>> 1 : e2 >>> 1;
              t4[r2] = e2;
            }
            return t4;
          }();
          t3.exports = function(e2, t4, r2, n) {
            var i = o, s = n + r2;
            e2 ^= -1;
            for (var a = n; a < s; a++)
              e2 = e2 >>> 8 ^ i[255 & (e2 ^ t4[a])];
            return -1 ^ e2;
          };
        }, {}], 46: [function(e, t3, r) {
          "use strict";
          var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
          function R(e2, t4) {
            return e2.msg = n[t4], t4;
          }
          function T(e2) {
            return (e2 << 1) - (4 < e2 ? 9 : 0);
          }
          function D(e2) {
            for (var t4 = e2.length; 0 <= --t4; )
              e2[t4] = 0;
          }
          function F(e2) {
            var t4 = e2.state, r2 = t4.pending;
            r2 > e2.avail_out && (r2 = e2.avail_out), 0 !== r2 && (c.arraySet(e2.output, t4.pending_buf, t4.pending_out, r2, e2.next_out), e2.next_out += r2, t4.pending_out += r2, e2.total_out += r2, e2.avail_out -= r2, t4.pending -= r2, 0 === t4.pending && (t4.pending_out = 0));
          }
          function N(e2, t4) {
            u._tr_flush_block(e2, 0 <= e2.block_start ? e2.block_start : -1, e2.strstart - e2.block_start, t4), e2.block_start = e2.strstart, F(e2.strm);
          }
          function U(e2, t4) {
            e2.pending_buf[e2.pending++] = t4;
          }
          function P(e2, t4) {
            e2.pending_buf[e2.pending++] = t4 >>> 8 & 255, e2.pending_buf[e2.pending++] = 255 & t4;
          }
          function L(e2, t4) {
            var r2, n2, i2 = e2.max_chain_length, s2 = e2.strstart, a2 = e2.prev_length, o2 = e2.nice_match, h2 = e2.strstart > e2.w_size - z ? e2.strstart - (e2.w_size - z) : 0, u2 = e2.window, l2 = e2.w_mask, f2 = e2.prev, c2 = e2.strstart + S, d2 = u2[s2 + a2 - 1], p2 = u2[s2 + a2];
            e2.prev_length >= e2.good_match && (i2 >>= 2), o2 > e2.lookahead && (o2 = e2.lookahead);
            do {
              if (u2[(r2 = t4) + a2] === p2 && u2[r2 + a2 - 1] === d2 && u2[r2] === u2[s2] && u2[++r2] === u2[s2 + 1]) {
                s2 += 2, r2++;
                do {
                } while (u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && u2[++s2] === u2[++r2] && s2 < c2);
                if (n2 = S - (c2 - s2), s2 = c2 - S, a2 < n2) {
                  if (e2.match_start = t4, o2 <= (a2 = n2))
                    break;
                  d2 = u2[s2 + a2 - 1], p2 = u2[s2 + a2];
                }
              }
            } while ((t4 = f2[t4 & l2]) > h2 && 0 != --i2);
            return a2 <= e2.lookahead ? a2 : e2.lookahead;
          }
          function j(e2) {
            var t4, r2, n2, i2, s2, a2, o2, h2, u2, l2, f2 = e2.w_size;
            do {
              if (i2 = e2.window_size - e2.lookahead - e2.strstart, e2.strstart >= f2 + (f2 - z)) {
                for (c.arraySet(e2.window, e2.window, f2, f2, 0), e2.match_start -= f2, e2.strstart -= f2, e2.block_start -= f2, t4 = r2 = e2.hash_size; n2 = e2.head[--t4], e2.head[t4] = f2 <= n2 ? n2 - f2 : 0, --r2; )
                  ;
                for (t4 = r2 = f2; n2 = e2.prev[--t4], e2.prev[t4] = f2 <= n2 ? n2 - f2 : 0, --r2; )
                  ;
                i2 += f2;
              }
              if (0 === e2.strm.avail_in)
                break;
              if (a2 = e2.strm, o2 = e2.window, h2 = e2.strstart + e2.lookahead, u2 = i2, l2 = void 0, l2 = a2.avail_in, u2 < l2 && (l2 = u2), r2 = 0 === l2 ? 0 : (a2.avail_in -= l2, c.arraySet(o2, a2.input, a2.next_in, l2, h2), 1 === a2.state.wrap ? a2.adler = d(a2.adler, o2, l2, h2) : 2 === a2.state.wrap && (a2.adler = p(a2.adler, o2, l2, h2)), a2.next_in += l2, a2.total_in += l2, l2), e2.lookahead += r2, e2.lookahead + e2.insert >= x)
                for (s2 = e2.strstart - e2.insert, e2.ins_h = e2.window[s2], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[s2 + 1]) & e2.hash_mask; e2.insert && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[s2 + x - 1]) & e2.hash_mask, e2.prev[s2 & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = s2, s2++, e2.insert--, !(e2.lookahead + e2.insert < x)); )
                  ;
            } while (e2.lookahead < z && 0 !== e2.strm.avail_in);
          }
          function Z(e2, t4) {
            for (var r2, n2; ; ) {
              if (e2.lookahead < z) {
                if (j(e2), e2.lookahead < z && t4 === l)
                  return A;
                if (0 === e2.lookahead)
                  break;
              }
              if (r2 = 0, e2.lookahead >= x && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 !== r2 && e2.strstart - r2 <= e2.w_size - z && (e2.match_length = L(e2, r2)), e2.match_length >= x)
                if (n2 = u._tr_tally(e2, e2.strstart - e2.match_start, e2.match_length - x), e2.lookahead -= e2.match_length, e2.match_length <= e2.max_lazy_match && e2.lookahead >= x) {
                  for (e2.match_length--; e2.strstart++, e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart, 0 != --e2.match_length; )
                    ;
                  e2.strstart++;
                } else
                  e2.strstart += e2.match_length, e2.match_length = 0, e2.ins_h = e2.window[e2.strstart], e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + 1]) & e2.hash_mask;
              else
                n2 = u._tr_tally(e2, 0, e2.window[e2.strstart]), e2.lookahead--, e2.strstart++;
              if (n2 && (N(e2, false), 0 === e2.strm.avail_out))
                return A;
            }
            return e2.insert = e2.strstart < x - 1 ? e2.strstart : x - 1, t4 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : e2.last_lit && (N(e2, false), 0 === e2.strm.avail_out) ? A : I;
          }
          function W(e2, t4) {
            for (var r2, n2, i2; ; ) {
              if (e2.lookahead < z) {
                if (j(e2), e2.lookahead < z && t4 === l)
                  return A;
                if (0 === e2.lookahead)
                  break;
              }
              if (r2 = 0, e2.lookahead >= x && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), e2.prev_length = e2.match_length, e2.prev_match = e2.match_start, e2.match_length = x - 1, 0 !== r2 && e2.prev_length < e2.max_lazy_match && e2.strstart - r2 <= e2.w_size - z && (e2.match_length = L(e2, r2), e2.match_length <= 5 && (1 === e2.strategy || e2.match_length === x && 4096 < e2.strstart - e2.match_start) && (e2.match_length = x - 1)), e2.prev_length >= x && e2.match_length <= e2.prev_length) {
                for (i2 = e2.strstart + e2.lookahead - x, n2 = u._tr_tally(e2, e2.strstart - 1 - e2.prev_match, e2.prev_length - x), e2.lookahead -= e2.prev_length - 1, e2.prev_length -= 2; ++e2.strstart <= i2 && (e2.ins_h = (e2.ins_h << e2.hash_shift ^ e2.window[e2.strstart + x - 1]) & e2.hash_mask, r2 = e2.prev[e2.strstart & e2.w_mask] = e2.head[e2.ins_h], e2.head[e2.ins_h] = e2.strstart), 0 != --e2.prev_length; )
                  ;
                if (e2.match_available = 0, e2.match_length = x - 1, e2.strstart++, n2 && (N(e2, false), 0 === e2.strm.avail_out))
                  return A;
              } else if (e2.match_available) {
                if ((n2 = u._tr_tally(e2, 0, e2.window[e2.strstart - 1])) && N(e2, false), e2.strstart++, e2.lookahead--, 0 === e2.strm.avail_out)
                  return A;
              } else
                e2.match_available = 1, e2.strstart++, e2.lookahead--;
            }
            return e2.match_available && (n2 = u._tr_tally(e2, 0, e2.window[e2.strstart - 1]), e2.match_available = 0), e2.insert = e2.strstart < x - 1 ? e2.strstart : x - 1, t4 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : e2.last_lit && (N(e2, false), 0 === e2.strm.avail_out) ? A : I;
          }
          function M(e2, t4, r2, n2, i2) {
            this.good_length = e2, this.max_lazy = t4, this.nice_length = r2, this.max_chain = n2, this.func = i2;
          }
          function H() {
            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
          }
          function G(e2) {
            var t4;
            return e2 && e2.state ? (e2.total_in = e2.total_out = 0, e2.data_type = i, (t4 = e2.state).pending = 0, t4.pending_out = 0, t4.wrap < 0 && (t4.wrap = -t4.wrap), t4.status = t4.wrap ? C : E, e2.adler = 2 === t4.wrap ? 0 : 1, t4.last_flush = l, u._tr_init(t4), m) : R(e2, _);
          }
          function K(e2) {
            var t4 = G(e2);
            return t4 === m && function(e3) {
              e3.window_size = 2 * e3.w_size, D(e3.head), e3.max_lazy_match = h[e3.level].max_lazy, e3.good_match = h[e3.level].good_length, e3.nice_match = h[e3.level].nice_length, e3.max_chain_length = h[e3.level].max_chain, e3.strstart = 0, e3.block_start = 0, e3.lookahead = 0, e3.insert = 0, e3.match_length = e3.prev_length = x - 1, e3.match_available = 0, e3.ins_h = 0;
            }(e2.state), t4;
          }
          function Y(e2, t4, r2, n2, i2, s2) {
            if (!e2)
              return _;
            var a2 = 1;
            if (t4 === g && (t4 = 6), n2 < 0 ? (a2 = 0, n2 = -n2) : 15 < n2 && (a2 = 2, n2 -= 16), i2 < 1 || y < i2 || r2 !== v || n2 < 8 || 15 < n2 || t4 < 0 || 9 < t4 || s2 < 0 || b < s2)
              return R(e2, _);
            8 === n2 && (n2 = 9);
            var o2 = new H();
            return (e2.state = o2).strm = e2, o2.wrap = a2, o2.gzhead = null, o2.w_bits = n2, o2.w_size = 1 << o2.w_bits, o2.w_mask = o2.w_size - 1, o2.hash_bits = i2 + 7, o2.hash_size = 1 << o2.hash_bits, o2.hash_mask = o2.hash_size - 1, o2.hash_shift = ~~((o2.hash_bits + x - 1) / x), o2.window = new c.Buf8(2 * o2.w_size), o2.head = new c.Buf16(o2.hash_size), o2.prev = new c.Buf16(o2.w_size), o2.lit_bufsize = 1 << i2 + 6, o2.pending_buf_size = 4 * o2.lit_bufsize, o2.pending_buf = new c.Buf8(o2.pending_buf_size), o2.d_buf = 1 * o2.lit_bufsize, o2.l_buf = 3 * o2.lit_bufsize, o2.level = t4, o2.strategy = s2, o2.method = r2, K(e2);
          }
          h = [new M(0, 0, 0, 0, function(e2, t4) {
            var r2 = 65535;
            for (r2 > e2.pending_buf_size - 5 && (r2 = e2.pending_buf_size - 5); ; ) {
              if (e2.lookahead <= 1) {
                if (j(e2), 0 === e2.lookahead && t4 === l)
                  return A;
                if (0 === e2.lookahead)
                  break;
              }
              e2.strstart += e2.lookahead, e2.lookahead = 0;
              var n2 = e2.block_start + r2;
              if ((0 === e2.strstart || e2.strstart >= n2) && (e2.lookahead = e2.strstart - n2, e2.strstart = n2, N(e2, false), 0 === e2.strm.avail_out))
                return A;
              if (e2.strstart - e2.block_start >= e2.w_size - z && (N(e2, false), 0 === e2.strm.avail_out))
                return A;
            }
            return e2.insert = 0, t4 === f ? (N(e2, true), 0 === e2.strm.avail_out ? O : B) : (e2.strstart > e2.block_start && (N(e2, false), e2.strm.avail_out), A);
          }), new M(4, 4, 8, 4, Z), new M(4, 5, 16, 8, Z), new M(4, 6, 32, 32, Z), new M(4, 4, 16, 16, W), new M(8, 16, 32, 32, W), new M(8, 16, 128, 128, W), new M(8, 32, 128, 256, W), new M(32, 128, 258, 1024, W), new M(32, 258, 258, 4096, W)], r.deflateInit = function(e2, t4) {
            return Y(e2, t4, v, 15, 8, 0);
          }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e2, t4) {
            return e2 && e2.state ? 2 !== e2.state.wrap ? _ : (e2.state.gzhead = t4, m) : _;
          }, r.deflate = function(e2, t4) {
            var r2, n2, i2, s2;
            if (!e2 || !e2.state || 5 < t4 || t4 < 0)
              return e2 ? R(e2, _) : _;
            if (n2 = e2.state, !e2.output || !e2.input && 0 !== e2.avail_in || 666 === n2.status && t4 !== f)
              return R(e2, 0 === e2.avail_out ? -5 : _);
            if (n2.strm = e2, r2 = n2.last_flush, n2.last_flush = t4, n2.status === C)
              if (2 === n2.wrap)
                e2.adler = 0, U(n2, 31), U(n2, 139), U(n2, 8), n2.gzhead ? (U(n2, (n2.gzhead.text ? 1 : 0) + (n2.gzhead.hcrc ? 2 : 0) + (n2.gzhead.extra ? 4 : 0) + (n2.gzhead.name ? 8 : 0) + (n2.gzhead.comment ? 16 : 0)), U(n2, 255 & n2.gzhead.time), U(n2, n2.gzhead.time >> 8 & 255), U(n2, n2.gzhead.time >> 16 & 255), U(n2, n2.gzhead.time >> 24 & 255), U(n2, 9 === n2.level ? 2 : 2 <= n2.strategy || n2.level < 2 ? 4 : 0), U(n2, 255 & n2.gzhead.os), n2.gzhead.extra && n2.gzhead.extra.length && (U(n2, 255 & n2.gzhead.extra.length), U(n2, n2.gzhead.extra.length >> 8 & 255)), n2.gzhead.hcrc && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending, 0)), n2.gzindex = 0, n2.status = 69) : (U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 0), U(n2, 9 === n2.level ? 2 : 2 <= n2.strategy || n2.level < 2 ? 4 : 0), U(n2, 3), n2.status = E);
              else {
                var a2 = v + (n2.w_bits - 8 << 4) << 8;
                a2 |= (2 <= n2.strategy || n2.level < 2 ? 0 : n2.level < 6 ? 1 : 6 === n2.level ? 2 : 3) << 6, 0 !== n2.strstart && (a2 |= 32), a2 += 31 - a2 % 31, n2.status = E, P(n2, a2), 0 !== n2.strstart && (P(n2, e2.adler >>> 16), P(n2, 65535 & e2.adler)), e2.adler = 1;
              }
            if (69 === n2.status)
              if (n2.gzhead.extra) {
                for (i2 = n2.pending; n2.gzindex < (65535 & n2.gzhead.extra.length) && (n2.pending !== n2.pending_buf_size || (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending !== n2.pending_buf_size)); )
                  U(n2, 255 & n2.gzhead.extra[n2.gzindex]), n2.gzindex++;
                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), n2.gzindex === n2.gzhead.extra.length && (n2.gzindex = 0, n2.status = 73);
              } else
                n2.status = 73;
            if (73 === n2.status)
              if (n2.gzhead.name) {
                i2 = n2.pending;
                do {
                  if (n2.pending === n2.pending_buf_size && (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending === n2.pending_buf_size)) {
                    s2 = 1;
                    break;
                  }
                  s2 = n2.gzindex < n2.gzhead.name.length ? 255 & n2.gzhead.name.charCodeAt(n2.gzindex++) : 0, U(n2, s2);
                } while (0 !== s2);
                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), 0 === s2 && (n2.gzindex = 0, n2.status = 91);
              } else
                n2.status = 91;
            if (91 === n2.status)
              if (n2.gzhead.comment) {
                i2 = n2.pending;
                do {
                  if (n2.pending === n2.pending_buf_size && (n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), F(e2), i2 = n2.pending, n2.pending === n2.pending_buf_size)) {
                    s2 = 1;
                    break;
                  }
                  s2 = n2.gzindex < n2.gzhead.comment.length ? 255 & n2.gzhead.comment.charCodeAt(n2.gzindex++) : 0, U(n2, s2);
                } while (0 !== s2);
                n2.gzhead.hcrc && n2.pending > i2 && (e2.adler = p(e2.adler, n2.pending_buf, n2.pending - i2, i2)), 0 === s2 && (n2.status = 103);
              } else
                n2.status = 103;
            if (103 === n2.status && (n2.gzhead.hcrc ? (n2.pending + 2 > n2.pending_buf_size && F(e2), n2.pending + 2 <= n2.pending_buf_size && (U(n2, 255 & e2.adler), U(n2, e2.adler >> 8 & 255), e2.adler = 0, n2.status = E)) : n2.status = E), 0 !== n2.pending) {
              if (F(e2), 0 === e2.avail_out)
                return n2.last_flush = -1, m;
            } else if (0 === e2.avail_in && T(t4) <= T(r2) && t4 !== f)
              return R(e2, -5);
            if (666 === n2.status && 0 !== e2.avail_in)
              return R(e2, -5);
            if (0 !== e2.avail_in || 0 !== n2.lookahead || t4 !== l && 666 !== n2.status) {
              var o2 = 2 === n2.strategy ? function(e3, t5) {
                for (var r3; ; ) {
                  if (0 === e3.lookahead && (j(e3), 0 === e3.lookahead)) {
                    if (t5 === l)
                      return A;
                    break;
                  }
                  if (e3.match_length = 0, r3 = u._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++, r3 && (N(e3, false), 0 === e3.strm.avail_out))
                    return A;
                }
                return e3.insert = 0, t5 === f ? (N(e3, true), 0 === e3.strm.avail_out ? O : B) : e3.last_lit && (N(e3, false), 0 === e3.strm.avail_out) ? A : I;
              }(n2, t4) : 3 === n2.strategy ? function(e3, t5) {
                for (var r3, n3, i3, s3, a3 = e3.window; ; ) {
                  if (e3.lookahead <= S) {
                    if (j(e3), e3.lookahead <= S && t5 === l)
                      return A;
                    if (0 === e3.lookahead)
                      break;
                  }
                  if (e3.match_length = 0, e3.lookahead >= x && 0 < e3.strstart && (n3 = a3[i3 = e3.strstart - 1]) === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3]) {
                    s3 = e3.strstart + S;
                    do {
                    } while (n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && n3 === a3[++i3] && i3 < s3);
                    e3.match_length = S - (s3 - i3), e3.match_length > e3.lookahead && (e3.match_length = e3.lookahead);
                  }
                  if (e3.match_length >= x ? (r3 = u._tr_tally(e3, 1, e3.match_length - x), e3.lookahead -= e3.match_length, e3.strstart += e3.match_length, e3.match_length = 0) : (r3 = u._tr_tally(e3, 0, e3.window[e3.strstart]), e3.lookahead--, e3.strstart++), r3 && (N(e3, false), 0 === e3.strm.avail_out))
                    return A;
                }
                return e3.insert = 0, t5 === f ? (N(e3, true), 0 === e3.strm.avail_out ? O : B) : e3.last_lit && (N(e3, false), 0 === e3.strm.avail_out) ? A : I;
              }(n2, t4) : h[n2.level].func(n2, t4);
              if (o2 !== O && o2 !== B || (n2.status = 666), o2 === A || o2 === O)
                return 0 === e2.avail_out && (n2.last_flush = -1), m;
              if (o2 === I && (1 === t4 ? u._tr_align(n2) : 5 !== t4 && (u._tr_stored_block(n2, 0, 0, false), 3 === t4 && (D(n2.head), 0 === n2.lookahead && (n2.strstart = 0, n2.block_start = 0, n2.insert = 0))), F(e2), 0 === e2.avail_out))
                return n2.last_flush = -1, m;
            }
            return t4 !== f ? m : n2.wrap <= 0 ? 1 : (2 === n2.wrap ? (U(n2, 255 & e2.adler), U(n2, e2.adler >> 8 & 255), U(n2, e2.adler >> 16 & 255), U(n2, e2.adler >> 24 & 255), U(n2, 255 & e2.total_in), U(n2, e2.total_in >> 8 & 255), U(n2, e2.total_in >> 16 & 255), U(n2, e2.total_in >> 24 & 255)) : (P(n2, e2.adler >>> 16), P(n2, 65535 & e2.adler)), F(e2), 0 < n2.wrap && (n2.wrap = -n2.wrap), 0 !== n2.pending ? m : 1);
          }, r.deflateEnd = function(e2) {
            var t4;
            return e2 && e2.state ? (t4 = e2.state.status) !== C && 69 !== t4 && 73 !== t4 && 91 !== t4 && 103 !== t4 && t4 !== E && 666 !== t4 ? R(e2, _) : (e2.state = null, t4 === E ? R(e2, -3) : m) : _;
          }, r.deflateSetDictionary = function(e2, t4) {
            var r2, n2, i2, s2, a2, o2, h2, u2, l2 = t4.length;
            if (!e2 || !e2.state)
              return _;
            if (2 === (s2 = (r2 = e2.state).wrap) || 1 === s2 && r2.status !== C || r2.lookahead)
              return _;
            for (1 === s2 && (e2.adler = d(e2.adler, t4, l2, 0)), r2.wrap = 0, l2 >= r2.w_size && (0 === s2 && (D(r2.head), r2.strstart = 0, r2.block_start = 0, r2.insert = 0), u2 = new c.Buf8(r2.w_size), c.arraySet(u2, t4, l2 - r2.w_size, r2.w_size, 0), t4 = u2, l2 = r2.w_size), a2 = e2.avail_in, o2 = e2.next_in, h2 = e2.input, e2.avail_in = l2, e2.next_in = 0, e2.input = t4, j(r2); r2.lookahead >= x; ) {
              for (n2 = r2.strstart, i2 = r2.lookahead - (x - 1); r2.ins_h = (r2.ins_h << r2.hash_shift ^ r2.window[n2 + x - 1]) & r2.hash_mask, r2.prev[n2 & r2.w_mask] = r2.head[r2.ins_h], r2.head[r2.ins_h] = n2, n2++, --i2; )
                ;
              r2.strstart = n2, r2.lookahead = x - 1, j(r2);
            }
            return r2.strstart += r2.lookahead, r2.block_start = r2.strstart, r2.insert = r2.lookahead, r2.lookahead = 0, r2.match_length = r2.prev_length = x - 1, r2.match_available = 0, e2.next_in = o2, e2.input = h2, e2.avail_in = a2, r2.wrap = s2, m;
          }, r.deflateInfo = "pako deflate (from Nodeca project)";
        }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(e, t3, r) {
          "use strict";
          t3.exports = function() {
            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = false;
          };
        }, {}], 48: [function(e, t3, r) {
          "use strict";
          t3.exports = function(e2, t4) {
            var r2, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
            r2 = e2.state, n = e2.next_in, z = e2.input, i = n + (e2.avail_in - 5), s = e2.next_out, C = e2.output, a = s - (t4 - e2.avail_out), o = s + (e2.avail_out - 257), h = r2.dmax, u = r2.wsize, l = r2.whave, f = r2.wnext, c = r2.window, d = r2.hold, p = r2.bits, m = r2.lencode, _ = r2.distcode, g = (1 << r2.lenbits) - 1, b = (1 << r2.distbits) - 1;
            e:
              do {
                p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                t:
                  for (; ; ) {
                    if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255))
                      C[s++] = 65535 & v;
                    else {
                      if (!(16 & y)) {
                        if (0 == (64 & y)) {
                          v = m[(65535 & v) + (d & (1 << y) - 1)];
                          continue t;
                        }
                        if (32 & y) {
                          r2.mode = 12;
                          break e;
                        }
                        e2.msg = "invalid literal/length code", r2.mode = 30;
                        break e;
                      }
                      w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                      r:
                        for (; ; ) {
                          if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                            if (0 == (64 & y)) {
                              v = _[(65535 & v) + (d & (1 << y) - 1)];
                              continue r;
                            }
                            e2.msg = "invalid distance code", r2.mode = 30;
                            break e;
                          }
                          if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                            e2.msg = "invalid distance too far back", r2.mode = 30;
                            break e;
                          }
                          if (d >>>= y, p -= y, (y = s - a) < k) {
                            if (l < (y = k - y) && r2.sane) {
                              e2.msg = "invalid distance too far back", r2.mode = 30;
                              break e;
                            }
                            if (S = c, (x = 0) === f) {
                              if (x += u - y, y < w) {
                                for (w -= y; C[s++] = c[x++], --y; )
                                  ;
                                x = s - k, S = C;
                              }
                            } else if (f < y) {
                              if (x += u + f - y, (y -= f) < w) {
                                for (w -= y; C[s++] = c[x++], --y; )
                                  ;
                                if (x = 0, f < w) {
                                  for (w -= y = f; C[s++] = c[x++], --y; )
                                    ;
                                  x = s - k, S = C;
                                }
                              }
                            } else if (x += f - y, y < w) {
                              for (w -= y; C[s++] = c[x++], --y; )
                                ;
                              x = s - k, S = C;
                            }
                            for (; 2 < w; )
                              C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                            w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                          } else {
                            for (x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3); )
                              ;
                            w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                          }
                          break;
                        }
                    }
                    break;
                  }
              } while (n < i && s < o);
            n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e2.next_in = n, e2.next_out = s, e2.avail_in = n < i ? i - n + 5 : 5 - (n - i), e2.avail_out = s < o ? o - s + 257 : 257 - (s - o), r2.hold = d, r2.bits = p;
          };
        }, {}], 49: [function(e, t3, r) {
          "use strict";
          var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
          function L(e2) {
            return (e2 >>> 24 & 255) + (e2 >>> 8 & 65280) + ((65280 & e2) << 8) + ((255 & e2) << 24);
          }
          function s() {
            this.mode = 0, this.last = false, this.wrap = 0, this.havedict = false, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
          }
          function a(e2) {
            var t4;
            return e2 && e2.state ? (t4 = e2.state, e2.total_in = e2.total_out = t4.total = 0, e2.msg = "", t4.wrap && (e2.adler = 1 & t4.wrap), t4.mode = P, t4.last = 0, t4.havedict = 0, t4.dmax = 32768, t4.head = null, t4.hold = 0, t4.bits = 0, t4.lencode = t4.lendyn = new I.Buf32(n), t4.distcode = t4.distdyn = new I.Buf32(i), t4.sane = 1, t4.back = -1, N) : U;
          }
          function o(e2) {
            var t4;
            return e2 && e2.state ? ((t4 = e2.state).wsize = 0, t4.whave = 0, t4.wnext = 0, a(e2)) : U;
          }
          function h(e2, t4) {
            var r2, n2;
            return e2 && e2.state ? (n2 = e2.state, t4 < 0 ? (r2 = 0, t4 = -t4) : (r2 = 1 + (t4 >> 4), t4 < 48 && (t4 &= 15)), t4 && (t4 < 8 || 15 < t4) ? U : (null !== n2.window && n2.wbits !== t4 && (n2.window = null), n2.wrap = r2, n2.wbits = t4, o(e2))) : U;
          }
          function u(e2, t4) {
            var r2, n2;
            return e2 ? (n2 = new s(), (e2.state = n2).window = null, (r2 = h(e2, t4)) !== N && (e2.state = null), r2) : U;
          }
          var l, f, c = true;
          function j(e2) {
            if (c) {
              var t4;
              for (l = new I.Buf32(512), f = new I.Buf32(32), t4 = 0; t4 < 144; )
                e2.lens[t4++] = 8;
              for (; t4 < 256; )
                e2.lens[t4++] = 9;
              for (; t4 < 280; )
                e2.lens[t4++] = 7;
              for (; t4 < 288; )
                e2.lens[t4++] = 8;
              for (T(D, e2.lens, 0, 288, l, 0, e2.work, { bits: 9 }), t4 = 0; t4 < 32; )
                e2.lens[t4++] = 5;
              T(F, e2.lens, 0, 32, f, 0, e2.work, { bits: 5 }), c = false;
            }
            e2.lencode = l, e2.lenbits = 9, e2.distcode = f, e2.distbits = 5;
          }
          function Z(e2, t4, r2, n2) {
            var i2, s2 = e2.state;
            return null === s2.window && (s2.wsize = 1 << s2.wbits, s2.wnext = 0, s2.whave = 0, s2.window = new I.Buf8(s2.wsize)), n2 >= s2.wsize ? (I.arraySet(s2.window, t4, r2 - s2.wsize, s2.wsize, 0), s2.wnext = 0, s2.whave = s2.wsize) : (n2 < (i2 = s2.wsize - s2.wnext) && (i2 = n2), I.arraySet(s2.window, t4, r2 - n2, i2, s2.wnext), (n2 -= i2) ? (I.arraySet(s2.window, t4, r2 - n2, n2, 0), s2.wnext = n2, s2.whave = s2.wsize) : (s2.wnext += i2, s2.wnext === s2.wsize && (s2.wnext = 0), s2.whave < s2.wsize && (s2.whave += i2))), 0;
          }
          r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e2) {
            return u(e2, 15);
          }, r.inflateInit2 = u, r.inflate = function(e2, t4) {
            var r2, n2, i2, s2, a2, o2, h2, u2, l2, f2, c2, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
            if (!e2 || !e2.state || !e2.output || !e2.input && 0 !== e2.avail_in)
              return U;
            12 === (r2 = e2.state).mode && (r2.mode = 13), a2 = e2.next_out, i2 = e2.output, h2 = e2.avail_out, s2 = e2.next_in, n2 = e2.input, o2 = e2.avail_in, u2 = r2.hold, l2 = r2.bits, f2 = o2, c2 = h2, x = N;
            e:
              for (; ; )
                switch (r2.mode) {
                  case P:
                    if (0 === r2.wrap) {
                      r2.mode = 13;
                      break;
                    }
                    for (; l2 < 16; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (2 & r2.wrap && 35615 === u2) {
                      E[r2.check = 0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0), l2 = u2 = 0, r2.mode = 2;
                      break;
                    }
                    if (r2.flags = 0, r2.head && (r2.head.done = false), !(1 & r2.wrap) || (((255 & u2) << 8) + (u2 >> 8)) % 31) {
                      e2.msg = "incorrect header check", r2.mode = 30;
                      break;
                    }
                    if (8 != (15 & u2)) {
                      e2.msg = "unknown compression method", r2.mode = 30;
                      break;
                    }
                    if (l2 -= 4, k = 8 + (15 & (u2 >>>= 4)), 0 === r2.wbits)
                      r2.wbits = k;
                    else if (k > r2.wbits) {
                      e2.msg = "invalid window size", r2.mode = 30;
                      break;
                    }
                    r2.dmax = 1 << k, e2.adler = r2.check = 1, r2.mode = 512 & u2 ? 10 : 12, l2 = u2 = 0;
                    break;
                  case 2:
                    for (; l2 < 16; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (r2.flags = u2, 8 != (255 & r2.flags)) {
                      e2.msg = "unknown compression method", r2.mode = 30;
                      break;
                    }
                    if (57344 & r2.flags) {
                      e2.msg = "unknown header flags set", r2.mode = 30;
                      break;
                    }
                    r2.head && (r2.head.text = u2 >> 8 & 1), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0, r2.mode = 3;
                  case 3:
                    for (; l2 < 32; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    r2.head && (r2.head.time = u2), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, E[2] = u2 >>> 16 & 255, E[3] = u2 >>> 24 & 255, r2.check = B(r2.check, E, 4, 0)), l2 = u2 = 0, r2.mode = 4;
                  case 4:
                    for (; l2 < 16; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    r2.head && (r2.head.xflags = 255 & u2, r2.head.os = u2 >> 8), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0, r2.mode = 5;
                  case 5:
                    if (1024 & r2.flags) {
                      for (; l2 < 16; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.length = u2, r2.head && (r2.head.extra_len = u2), 512 & r2.flags && (E[0] = 255 & u2, E[1] = u2 >>> 8 & 255, r2.check = B(r2.check, E, 2, 0)), l2 = u2 = 0;
                    } else
                      r2.head && (r2.head.extra = null);
                    r2.mode = 6;
                  case 6:
                    if (1024 & r2.flags && (o2 < (d = r2.length) && (d = o2), d && (r2.head && (k = r2.head.extra_len - r2.length, r2.head.extra || (r2.head.extra = new Array(r2.head.extra_len)), I.arraySet(r2.head.extra, n2, s2, d, k)), 512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, r2.length -= d), r2.length))
                      break e;
                    r2.length = 0, r2.mode = 7;
                  case 7:
                    if (2048 & r2.flags) {
                      if (0 === o2)
                        break e;
                      for (d = 0; k = n2[s2 + d++], r2.head && k && r2.length < 65536 && (r2.head.name += String.fromCharCode(k)), k && d < o2; )
                        ;
                      if (512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, k)
                        break e;
                    } else
                      r2.head && (r2.head.name = null);
                    r2.length = 0, r2.mode = 8;
                  case 8:
                    if (4096 & r2.flags) {
                      if (0 === o2)
                        break e;
                      for (d = 0; k = n2[s2 + d++], r2.head && k && r2.length < 65536 && (r2.head.comment += String.fromCharCode(k)), k && d < o2; )
                        ;
                      if (512 & r2.flags && (r2.check = B(r2.check, n2, d, s2)), o2 -= d, s2 += d, k)
                        break e;
                    } else
                      r2.head && (r2.head.comment = null);
                    r2.mode = 9;
                  case 9:
                    if (512 & r2.flags) {
                      for (; l2 < 16; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      if (u2 !== (65535 & r2.check)) {
                        e2.msg = "header crc mismatch", r2.mode = 30;
                        break;
                      }
                      l2 = u2 = 0;
                    }
                    r2.head && (r2.head.hcrc = r2.flags >> 9 & 1, r2.head.done = true), e2.adler = r2.check = 0, r2.mode = 12;
                    break;
                  case 10:
                    for (; l2 < 32; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    e2.adler = r2.check = L(u2), l2 = u2 = 0, r2.mode = 11;
                  case 11:
                    if (0 === r2.havedict)
                      return e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, 2;
                    e2.adler = r2.check = 1, r2.mode = 12;
                  case 12:
                    if (5 === t4 || 6 === t4)
                      break e;
                  case 13:
                    if (r2.last) {
                      u2 >>>= 7 & l2, l2 -= 7 & l2, r2.mode = 27;
                      break;
                    }
                    for (; l2 < 3; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    switch (r2.last = 1 & u2, l2 -= 1, 3 & (u2 >>>= 1)) {
                      case 0:
                        r2.mode = 14;
                        break;
                      case 1:
                        if (j(r2), r2.mode = 20, 6 !== t4)
                          break;
                        u2 >>>= 2, l2 -= 2;
                        break e;
                      case 2:
                        r2.mode = 17;
                        break;
                      case 3:
                        e2.msg = "invalid block type", r2.mode = 30;
                    }
                    u2 >>>= 2, l2 -= 2;
                    break;
                  case 14:
                    for (u2 >>>= 7 & l2, l2 -= 7 & l2; l2 < 32; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if ((65535 & u2) != (u2 >>> 16 ^ 65535)) {
                      e2.msg = "invalid stored block lengths", r2.mode = 30;
                      break;
                    }
                    if (r2.length = 65535 & u2, l2 = u2 = 0, r2.mode = 15, 6 === t4)
                      break e;
                  case 15:
                    r2.mode = 16;
                  case 16:
                    if (d = r2.length) {
                      if (o2 < d && (d = o2), h2 < d && (d = h2), 0 === d)
                        break e;
                      I.arraySet(i2, n2, s2, d, a2), o2 -= d, s2 += d, h2 -= d, a2 += d, r2.length -= d;
                      break;
                    }
                    r2.mode = 12;
                    break;
                  case 17:
                    for (; l2 < 14; ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (r2.nlen = 257 + (31 & u2), u2 >>>= 5, l2 -= 5, r2.ndist = 1 + (31 & u2), u2 >>>= 5, l2 -= 5, r2.ncode = 4 + (15 & u2), u2 >>>= 4, l2 -= 4, 286 < r2.nlen || 30 < r2.ndist) {
                      e2.msg = "too many length or distance symbols", r2.mode = 30;
                      break;
                    }
                    r2.have = 0, r2.mode = 18;
                  case 18:
                    for (; r2.have < r2.ncode; ) {
                      for (; l2 < 3; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.lens[A[r2.have++]] = 7 & u2, u2 >>>= 3, l2 -= 3;
                    }
                    for (; r2.have < 19; )
                      r2.lens[A[r2.have++]] = 0;
                    if (r2.lencode = r2.lendyn, r2.lenbits = 7, S = { bits: r2.lenbits }, x = T(0, r2.lens, 0, 19, r2.lencode, 0, r2.work, S), r2.lenbits = S.bits, x) {
                      e2.msg = "invalid code lengths set", r2.mode = 30;
                      break;
                    }
                    r2.have = 0, r2.mode = 19;
                  case 19:
                    for (; r2.have < r2.nlen + r2.ndist; ) {
                      for (; g = (C = r2.lencode[u2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2); ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      if (b < 16)
                        u2 >>>= _, l2 -= _, r2.lens[r2.have++] = b;
                      else {
                        if (16 === b) {
                          for (z = _ + 2; l2 < z; ) {
                            if (0 === o2)
                              break e;
                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                          }
                          if (u2 >>>= _, l2 -= _, 0 === r2.have) {
                            e2.msg = "invalid bit length repeat", r2.mode = 30;
                            break;
                          }
                          k = r2.lens[r2.have - 1], d = 3 + (3 & u2), u2 >>>= 2, l2 -= 2;
                        } else if (17 === b) {
                          for (z = _ + 3; l2 < z; ) {
                            if (0 === o2)
                              break e;
                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                          }
                          l2 -= _, k = 0, d = 3 + (7 & (u2 >>>= _)), u2 >>>= 3, l2 -= 3;
                        } else {
                          for (z = _ + 7; l2 < z; ) {
                            if (0 === o2)
                              break e;
                            o2--, u2 += n2[s2++] << l2, l2 += 8;
                          }
                          l2 -= _, k = 0, d = 11 + (127 & (u2 >>>= _)), u2 >>>= 7, l2 -= 7;
                        }
                        if (r2.have + d > r2.nlen + r2.ndist) {
                          e2.msg = "invalid bit length repeat", r2.mode = 30;
                          break;
                        }
                        for (; d--; )
                          r2.lens[r2.have++] = k;
                      }
                    }
                    if (30 === r2.mode)
                      break;
                    if (0 === r2.lens[256]) {
                      e2.msg = "invalid code -- missing end-of-block", r2.mode = 30;
                      break;
                    }
                    if (r2.lenbits = 9, S = { bits: r2.lenbits }, x = T(D, r2.lens, 0, r2.nlen, r2.lencode, 0, r2.work, S), r2.lenbits = S.bits, x) {
                      e2.msg = "invalid literal/lengths set", r2.mode = 30;
                      break;
                    }
                    if (r2.distbits = 6, r2.distcode = r2.distdyn, S = { bits: r2.distbits }, x = T(F, r2.lens, r2.nlen, r2.ndist, r2.distcode, 0, r2.work, S), r2.distbits = S.bits, x) {
                      e2.msg = "invalid distances set", r2.mode = 30;
                      break;
                    }
                    if (r2.mode = 20, 6 === t4)
                      break e;
                  case 20:
                    r2.mode = 21;
                  case 21:
                    if (6 <= o2 && 258 <= h2) {
                      e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, R(e2, c2), a2 = e2.next_out, i2 = e2.output, h2 = e2.avail_out, s2 = e2.next_in, n2 = e2.input, o2 = e2.avail_in, u2 = r2.hold, l2 = r2.bits, 12 === r2.mode && (r2.back = -1);
                      break;
                    }
                    for (r2.back = 0; g = (C = r2.lencode[u2 & (1 << r2.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2); ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (g && 0 == (240 & g)) {
                      for (v = _, y = g, w = b; g = (C = r2.lencode[w + ((u2 & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l2); ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      u2 >>>= v, l2 -= v, r2.back += v;
                    }
                    if (u2 >>>= _, l2 -= _, r2.back += _, r2.length = b, 0 === g) {
                      r2.mode = 26;
                      break;
                    }
                    if (32 & g) {
                      r2.back = -1, r2.mode = 12;
                      break;
                    }
                    if (64 & g) {
                      e2.msg = "invalid literal/length code", r2.mode = 30;
                      break;
                    }
                    r2.extra = 15 & g, r2.mode = 22;
                  case 22:
                    if (r2.extra) {
                      for (z = r2.extra; l2 < z; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.length += u2 & (1 << r2.extra) - 1, u2 >>>= r2.extra, l2 -= r2.extra, r2.back += r2.extra;
                    }
                    r2.was = r2.length, r2.mode = 23;
                  case 23:
                    for (; g = (C = r2.distcode[u2 & (1 << r2.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l2); ) {
                      if (0 === o2)
                        break e;
                      o2--, u2 += n2[s2++] << l2, l2 += 8;
                    }
                    if (0 == (240 & g)) {
                      for (v = _, y = g, w = b; g = (C = r2.distcode[w + ((u2 & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l2); ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      u2 >>>= v, l2 -= v, r2.back += v;
                    }
                    if (u2 >>>= _, l2 -= _, r2.back += _, 64 & g) {
                      e2.msg = "invalid distance code", r2.mode = 30;
                      break;
                    }
                    r2.offset = b, r2.extra = 15 & g, r2.mode = 24;
                  case 24:
                    if (r2.extra) {
                      for (z = r2.extra; l2 < z; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      r2.offset += u2 & (1 << r2.extra) - 1, u2 >>>= r2.extra, l2 -= r2.extra, r2.back += r2.extra;
                    }
                    if (r2.offset > r2.dmax) {
                      e2.msg = "invalid distance too far back", r2.mode = 30;
                      break;
                    }
                    r2.mode = 25;
                  case 25:
                    if (0 === h2)
                      break e;
                    if (d = c2 - h2, r2.offset > d) {
                      if ((d = r2.offset - d) > r2.whave && r2.sane) {
                        e2.msg = "invalid distance too far back", r2.mode = 30;
                        break;
                      }
                      p = d > r2.wnext ? (d -= r2.wnext, r2.wsize - d) : r2.wnext - d, d > r2.length && (d = r2.length), m = r2.window;
                    } else
                      m = i2, p = a2 - r2.offset, d = r2.length;
                    for (h2 < d && (d = h2), h2 -= d, r2.length -= d; i2[a2++] = m[p++], --d; )
                      ;
                    0 === r2.length && (r2.mode = 21);
                    break;
                  case 26:
                    if (0 === h2)
                      break e;
                    i2[a2++] = r2.length, h2--, r2.mode = 21;
                    break;
                  case 27:
                    if (r2.wrap) {
                      for (; l2 < 32; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 |= n2[s2++] << l2, l2 += 8;
                      }
                      if (c2 -= h2, e2.total_out += c2, r2.total += c2, c2 && (e2.adler = r2.check = r2.flags ? B(r2.check, i2, c2, a2 - c2) : O(r2.check, i2, c2, a2 - c2)), c2 = h2, (r2.flags ? u2 : L(u2)) !== r2.check) {
                        e2.msg = "incorrect data check", r2.mode = 30;
                        break;
                      }
                      l2 = u2 = 0;
                    }
                    r2.mode = 28;
                  case 28:
                    if (r2.wrap && r2.flags) {
                      for (; l2 < 32; ) {
                        if (0 === o2)
                          break e;
                        o2--, u2 += n2[s2++] << l2, l2 += 8;
                      }
                      if (u2 !== (4294967295 & r2.total)) {
                        e2.msg = "incorrect length check", r2.mode = 30;
                        break;
                      }
                      l2 = u2 = 0;
                    }
                    r2.mode = 29;
                  case 29:
                    x = 1;
                    break e;
                  case 30:
                    x = -3;
                    break e;
                  case 31:
                    return -4;
                  case 32:
                  default:
                    return U;
                }
            return e2.next_out = a2, e2.avail_out = h2, e2.next_in = s2, e2.avail_in = o2, r2.hold = u2, r2.bits = l2, (r2.wsize || c2 !== e2.avail_out && r2.mode < 30 && (r2.mode < 27 || 4 !== t4)) && Z(e2, e2.output, e2.next_out, c2 - e2.avail_out) ? (r2.mode = 31, -4) : (f2 -= e2.avail_in, c2 -= e2.avail_out, e2.total_in += f2, e2.total_out += c2, r2.total += c2, r2.wrap && c2 && (e2.adler = r2.check = r2.flags ? B(r2.check, i2, c2, e2.next_out - c2) : O(r2.check, i2, c2, e2.next_out - c2)), e2.data_type = r2.bits + (r2.last ? 64 : 0) + (12 === r2.mode ? 128 : 0) + (20 === r2.mode || 15 === r2.mode ? 256 : 0), (0 == f2 && 0 === c2 || 4 === t4) && x === N && (x = -5), x);
          }, r.inflateEnd = function(e2) {
            if (!e2 || !e2.state)
              return U;
            var t4 = e2.state;
            return t4.window && (t4.window = null), e2.state = null, N;
          }, r.inflateGetHeader = function(e2, t4) {
            var r2;
            return e2 && e2.state ? 0 == (2 & (r2 = e2.state).wrap) ? U : ((r2.head = t4).done = false, N) : U;
          }, r.inflateSetDictionary = function(e2, t4) {
            var r2, n2 = t4.length;
            return e2 && e2.state ? 0 !== (r2 = e2.state).wrap && 11 !== r2.mode ? U : 11 === r2.mode && O(1, t4, n2, 0) !== r2.check ? -3 : Z(e2, t4, n2, n2) ? (r2.mode = 31, -4) : (r2.havedict = 1, N) : U;
          }, r.inflateInfo = "pako inflate (from Nodeca project)";
        }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(e, t3, r) {
          "use strict";
          var D = e("../utils/common"), F = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], N = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], U = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], P = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
          t3.exports = function(e2, t4, r2, n, i, s, a, o) {
            var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
            for (b = 0; b <= 15; b++)
              O[b] = 0;
            for (v = 0; v < n; v++)
              O[t4[r2 + v]]++;
            for (k = g, w = 15; 1 <= w && 0 === O[w]; w--)
              ;
            if (w < k && (k = w), 0 === w)
              return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
            for (y = 1; y < w && 0 === O[y]; y++)
              ;
            for (k < y && (k = y), b = z = 1; b <= 15; b++)
              if (z <<= 1, (z -= O[b]) < 0)
                return -1;
            if (0 < z && (0 === e2 || 1 !== w))
              return -1;
            for (B[1] = 0, b = 1; b < 15; b++)
              B[b + 1] = B[b] + O[b];
            for (v = 0; v < n; v++)
              0 !== t4[r2 + v] && (a[B[t4[r2 + v]]++] = v);
            if (d = 0 === e2 ? (A = R = a, 19) : 1 === e2 ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e2 && 852 < C || 2 === e2 && 592 < C)
              return 1;
            for (; ; ) {
              for (p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u; )
                ;
              for (h = 1 << b - 1; E & h; )
                h >>= 1;
              if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                if (b === w)
                  break;
                b = t4[r2 + a[v]];
              }
              if (k < b && (E & f) !== l) {
                for (0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0); )
                  x++, z <<= 1;
                if (C += 1 << x, 1 === e2 && 852 < C || 2 === e2 && 592 < C)
                  return 1;
                i[l = E & f] = k << 24 | x << 16 | c - s | 0;
              }
            }
            return 0 !== E && (i[c + E] = b - S << 24 | 64 << 16 | 0), o.bits = k, 0;
          };
        }, { "../utils/common": 41 }], 51: [function(e, t3, r) {
          "use strict";
          t3.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
        }, {}], 52: [function(e, t3, r) {
          "use strict";
          var i = e("../utils/common"), o = 0, h = 1;
          function n(e2) {
            for (var t4 = e2.length; 0 <= --t4; )
              e2[t4] = 0;
          }
          var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], k = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], x = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], S = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], z = new Array(2 * (l + 2));
          n(z);
          var C = new Array(2 * f);
          n(C);
          var E = new Array(512);
          n(E);
          var A = new Array(256);
          n(A);
          var I = new Array(a);
          n(I);
          var O, B, R, T = new Array(f);
          function D(e2, t4, r2, n2, i2) {
            this.static_tree = e2, this.extra_bits = t4, this.extra_base = r2, this.elems = n2, this.max_length = i2, this.has_stree = e2 && e2.length;
          }
          function F(e2, t4) {
            this.dyn_tree = e2, this.max_code = 0, this.stat_desc = t4;
          }
          function N(e2) {
            return e2 < 256 ? E[e2] : E[256 + (e2 >>> 7)];
          }
          function U(e2, t4) {
            e2.pending_buf[e2.pending++] = 255 & t4, e2.pending_buf[e2.pending++] = t4 >>> 8 & 255;
          }
          function P(e2, t4, r2) {
            e2.bi_valid > d - r2 ? (e2.bi_buf |= t4 << e2.bi_valid & 65535, U(e2, e2.bi_buf), e2.bi_buf = t4 >> d - e2.bi_valid, e2.bi_valid += r2 - d) : (e2.bi_buf |= t4 << e2.bi_valid & 65535, e2.bi_valid += r2);
          }
          function L(e2, t4, r2) {
            P(e2, r2[2 * t4], r2[2 * t4 + 1]);
          }
          function j(e2, t4) {
            for (var r2 = 0; r2 |= 1 & e2, e2 >>>= 1, r2 <<= 1, 0 < --t4; )
              ;
            return r2 >>> 1;
          }
          function Z(e2, t4, r2) {
            var n2, i2, s2 = new Array(g + 1), a2 = 0;
            for (n2 = 1; n2 <= g; n2++)
              s2[n2] = a2 = a2 + r2[n2 - 1] << 1;
            for (i2 = 0; i2 <= t4; i2++) {
              var o2 = e2[2 * i2 + 1];
              0 !== o2 && (e2[2 * i2] = j(s2[o2]++, o2));
            }
          }
          function W(e2) {
            var t4;
            for (t4 = 0; t4 < l; t4++)
              e2.dyn_ltree[2 * t4] = 0;
            for (t4 = 0; t4 < f; t4++)
              e2.dyn_dtree[2 * t4] = 0;
            for (t4 = 0; t4 < c; t4++)
              e2.bl_tree[2 * t4] = 0;
            e2.dyn_ltree[2 * m] = 1, e2.opt_len = e2.static_len = 0, e2.last_lit = e2.matches = 0;
          }
          function M(e2) {
            8 < e2.bi_valid ? U(e2, e2.bi_buf) : 0 < e2.bi_valid && (e2.pending_buf[e2.pending++] = e2.bi_buf), e2.bi_buf = 0, e2.bi_valid = 0;
          }
          function H(e2, t4, r2, n2) {
            var i2 = 2 * t4, s2 = 2 * r2;
            return e2[i2] < e2[s2] || e2[i2] === e2[s2] && n2[t4] <= n2[r2];
          }
          function G(e2, t4, r2) {
            for (var n2 = e2.heap[r2], i2 = r2 << 1; i2 <= e2.heap_len && (i2 < e2.heap_len && H(t4, e2.heap[i2 + 1], e2.heap[i2], e2.depth) && i2++, !H(t4, n2, e2.heap[i2], e2.depth)); )
              e2.heap[r2] = e2.heap[i2], r2 = i2, i2 <<= 1;
            e2.heap[r2] = n2;
          }
          function K(e2, t4, r2) {
            var n2, i2, s2, a2, o2 = 0;
            if (0 !== e2.last_lit)
              for (; n2 = e2.pending_buf[e2.d_buf + 2 * o2] << 8 | e2.pending_buf[e2.d_buf + 2 * o2 + 1], i2 = e2.pending_buf[e2.l_buf + o2], o2++, 0 === n2 ? L(e2, i2, t4) : (L(e2, (s2 = A[i2]) + u + 1, t4), 0 !== (a2 = w[s2]) && P(e2, i2 -= I[s2], a2), L(e2, s2 = N(--n2), r2), 0 !== (a2 = k[s2]) && P(e2, n2 -= T[s2], a2)), o2 < e2.last_lit; )
                ;
            L(e2, m, t4);
          }
          function Y(e2, t4) {
            var r2, n2, i2, s2 = t4.dyn_tree, a2 = t4.stat_desc.static_tree, o2 = t4.stat_desc.has_stree, h2 = t4.stat_desc.elems, u2 = -1;
            for (e2.heap_len = 0, e2.heap_max = _, r2 = 0; r2 < h2; r2++)
              0 !== s2[2 * r2] ? (e2.heap[++e2.heap_len] = u2 = r2, e2.depth[r2] = 0) : s2[2 * r2 + 1] = 0;
            for (; e2.heap_len < 2; )
              s2[2 * (i2 = e2.heap[++e2.heap_len] = u2 < 2 ? ++u2 : 0)] = 1, e2.depth[i2] = 0, e2.opt_len--, o2 && (e2.static_len -= a2[2 * i2 + 1]);
            for (t4.max_code = u2, r2 = e2.heap_len >> 1; 1 <= r2; r2--)
              G(e2, s2, r2);
            for (i2 = h2; r2 = e2.heap[1], e2.heap[1] = e2.heap[e2.heap_len--], G(e2, s2, 1), n2 = e2.heap[1], e2.heap[--e2.heap_max] = r2, e2.heap[--e2.heap_max] = n2, s2[2 * i2] = s2[2 * r2] + s2[2 * n2], e2.depth[i2] = (e2.depth[r2] >= e2.depth[n2] ? e2.depth[r2] : e2.depth[n2]) + 1, s2[2 * r2 + 1] = s2[2 * n2 + 1] = i2, e2.heap[1] = i2++, G(e2, s2, 1), 2 <= e2.heap_len; )
              ;
            e2.heap[--e2.heap_max] = e2.heap[1], function(e3, t5) {
              var r3, n3, i3, s3, a3, o3, h3 = t5.dyn_tree, u3 = t5.max_code, l2 = t5.stat_desc.static_tree, f2 = t5.stat_desc.has_stree, c2 = t5.stat_desc.extra_bits, d2 = t5.stat_desc.extra_base, p2 = t5.stat_desc.max_length, m2 = 0;
              for (s3 = 0; s3 <= g; s3++)
                e3.bl_count[s3] = 0;
              for (h3[2 * e3.heap[e3.heap_max] + 1] = 0, r3 = e3.heap_max + 1; r3 < _; r3++)
                p2 < (s3 = h3[2 * h3[2 * (n3 = e3.heap[r3]) + 1] + 1] + 1) && (s3 = p2, m2++), h3[2 * n3 + 1] = s3, u3 < n3 || (e3.bl_count[s3]++, a3 = 0, d2 <= n3 && (a3 = c2[n3 - d2]), o3 = h3[2 * n3], e3.opt_len += o3 * (s3 + a3), f2 && (e3.static_len += o3 * (l2[2 * n3 + 1] + a3)));
              if (0 !== m2) {
                do {
                  for (s3 = p2 - 1; 0 === e3.bl_count[s3]; )
                    s3--;
                  e3.bl_count[s3]--, e3.bl_count[s3 + 1] += 2, e3.bl_count[p2]--, m2 -= 2;
                } while (0 < m2);
                for (s3 = p2; 0 !== s3; s3--)
                  for (n3 = e3.bl_count[s3]; 0 !== n3; )
                    u3 < (i3 = e3.heap[--r3]) || (h3[2 * i3 + 1] !== s3 && (e3.opt_len += (s3 - h3[2 * i3 + 1]) * h3[2 * i3], h3[2 * i3 + 1] = s3), n3--);
              }
            }(e2, t4), Z(s2, u2, e2.bl_count);
          }
          function X(e2, t4, r2) {
            var n2, i2, s2 = -1, a2 = t4[1], o2 = 0, h2 = 7, u2 = 4;
            for (0 === a2 && (h2 = 138, u2 = 3), t4[2 * (r2 + 1) + 1] = 65535, n2 = 0; n2 <= r2; n2++)
              i2 = a2, a2 = t4[2 * (n2 + 1) + 1], ++o2 < h2 && i2 === a2 || (o2 < u2 ? e2.bl_tree[2 * i2] += o2 : 0 !== i2 ? (i2 !== s2 && e2.bl_tree[2 * i2]++, e2.bl_tree[2 * b]++) : o2 <= 10 ? e2.bl_tree[2 * v]++ : e2.bl_tree[2 * y]++, s2 = i2, u2 = (o2 = 0) === a2 ? (h2 = 138, 3) : i2 === a2 ? (h2 = 6, 3) : (h2 = 7, 4));
          }
          function V(e2, t4, r2) {
            var n2, i2, s2 = -1, a2 = t4[1], o2 = 0, h2 = 7, u2 = 4;
            for (0 === a2 && (h2 = 138, u2 = 3), n2 = 0; n2 <= r2; n2++)
              if (i2 = a2, a2 = t4[2 * (n2 + 1) + 1], !(++o2 < h2 && i2 === a2)) {
                if (o2 < u2)
                  for (; L(e2, i2, e2.bl_tree), 0 != --o2; )
                    ;
                else
                  0 !== i2 ? (i2 !== s2 && (L(e2, i2, e2.bl_tree), o2--), L(e2, b, e2.bl_tree), P(e2, o2 - 3, 2)) : o2 <= 10 ? (L(e2, v, e2.bl_tree), P(e2, o2 - 3, 3)) : (L(e2, y, e2.bl_tree), P(e2, o2 - 11, 7));
                s2 = i2, u2 = (o2 = 0) === a2 ? (h2 = 138, 3) : i2 === a2 ? (h2 = 6, 3) : (h2 = 7, 4);
              }
          }
          n(T);
          var q = false;
          function J(e2, t4, r2, n2) {
            P(e2, (s << 1) + (n2 ? 1 : 0), 3), function(e3, t5, r3, n3) {
              M(e3), n3 && (U(e3, r3), U(e3, ~r3)), i.arraySet(e3.pending_buf, e3.window, t5, r3, e3.pending), e3.pending += r3;
            }(e2, t4, r2, true);
          }
          r._tr_init = function(e2) {
            q || (function() {
              var e3, t4, r2, n2, i2, s2 = new Array(g + 1);
              for (n2 = r2 = 0; n2 < a - 1; n2++)
                for (I[n2] = r2, e3 = 0; e3 < 1 << w[n2]; e3++)
                  A[r2++] = n2;
              for (A[r2 - 1] = n2, n2 = i2 = 0; n2 < 16; n2++)
                for (T[n2] = i2, e3 = 0; e3 < 1 << k[n2]; e3++)
                  E[i2++] = n2;
              for (i2 >>= 7; n2 < f; n2++)
                for (T[n2] = i2 << 7, e3 = 0; e3 < 1 << k[n2] - 7; e3++)
                  E[256 + i2++] = n2;
              for (t4 = 0; t4 <= g; t4++)
                s2[t4] = 0;
              for (e3 = 0; e3 <= 143; )
                z[2 * e3 + 1] = 8, e3++, s2[8]++;
              for (; e3 <= 255; )
                z[2 * e3 + 1] = 9, e3++, s2[9]++;
              for (; e3 <= 279; )
                z[2 * e3 + 1] = 7, e3++, s2[7]++;
              for (; e3 <= 287; )
                z[2 * e3 + 1] = 8, e3++, s2[8]++;
              for (Z(z, l + 1, s2), e3 = 0; e3 < f; e3++)
                C[2 * e3 + 1] = 5, C[2 * e3] = j(e3, 5);
              O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
            }(), q = true), e2.l_desc = new F(e2.dyn_ltree, O), e2.d_desc = new F(e2.dyn_dtree, B), e2.bl_desc = new F(e2.bl_tree, R), e2.bi_buf = 0, e2.bi_valid = 0, W(e2);
          }, r._tr_stored_block = J, r._tr_flush_block = function(e2, t4, r2, n2) {
            var i2, s2, a2 = 0;
            0 < e2.level ? (2 === e2.strm.data_type && (e2.strm.data_type = function(e3) {
              var t5, r3 = 4093624447;
              for (t5 = 0; t5 <= 31; t5++, r3 >>>= 1)
                if (1 & r3 && 0 !== e3.dyn_ltree[2 * t5])
                  return o;
              if (0 !== e3.dyn_ltree[18] || 0 !== e3.dyn_ltree[20] || 0 !== e3.dyn_ltree[26])
                return h;
              for (t5 = 32; t5 < u; t5++)
                if (0 !== e3.dyn_ltree[2 * t5])
                  return h;
              return o;
            }(e2)), Y(e2, e2.l_desc), Y(e2, e2.d_desc), a2 = function(e3) {
              var t5;
              for (X(e3, e3.dyn_ltree, e3.l_desc.max_code), X(e3, e3.dyn_dtree, e3.d_desc.max_code), Y(e3, e3.bl_desc), t5 = c - 1; 3 <= t5 && 0 === e3.bl_tree[2 * S[t5] + 1]; t5--)
                ;
              return e3.opt_len += 3 * (t5 + 1) + 5 + 5 + 4, t5;
            }(e2), i2 = e2.opt_len + 3 + 7 >>> 3, (s2 = e2.static_len + 3 + 7 >>> 3) <= i2 && (i2 = s2)) : i2 = s2 = r2 + 5, r2 + 4 <= i2 && -1 !== t4 ? J(e2, t4, r2, n2) : 4 === e2.strategy || s2 === i2 ? (P(e2, 2 + (n2 ? 1 : 0), 3), K(e2, z, C)) : (P(e2, 4 + (n2 ? 1 : 0), 3), function(e3, t5, r3, n3) {
              var i3;
              for (P(e3, t5 - 257, 5), P(e3, r3 - 1, 5), P(e3, n3 - 4, 4), i3 = 0; i3 < n3; i3++)
                P(e3, e3.bl_tree[2 * S[i3] + 1], 3);
              V(e3, e3.dyn_ltree, t5 - 1), V(e3, e3.dyn_dtree, r3 - 1);
            }(e2, e2.l_desc.max_code + 1, e2.d_desc.max_code + 1, a2 + 1), K(e2, e2.dyn_ltree, e2.dyn_dtree)), W(e2), n2 && M(e2);
          }, r._tr_tally = function(e2, t4, r2) {
            return e2.pending_buf[e2.d_buf + 2 * e2.last_lit] = t4 >>> 8 & 255, e2.pending_buf[e2.d_buf + 2 * e2.last_lit + 1] = 255 & t4, e2.pending_buf[e2.l_buf + e2.last_lit] = 255 & r2, e2.last_lit++, 0 === t4 ? e2.dyn_ltree[2 * r2]++ : (e2.matches++, t4--, e2.dyn_ltree[2 * (A[r2] + u + 1)]++, e2.dyn_dtree[2 * N(t4)]++), e2.last_lit === e2.lit_bufsize - 1;
          }, r._tr_align = function(e2) {
            P(e2, 2, 3), L(e2, m, z), function(e3) {
              16 === e3.bi_valid ? (U(e3, e3.bi_buf), e3.bi_buf = 0, e3.bi_valid = 0) : 8 <= e3.bi_valid && (e3.pending_buf[e3.pending++] = 255 & e3.bi_buf, e3.bi_buf >>= 8, e3.bi_valid -= 8);
            }(e2);
          };
        }, { "../utils/common": 41 }], 53: [function(e, t3, r) {
          "use strict";
          t3.exports = function() {
            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
          };
        }, {}], 54: [function(e, t3, r) {
          (function(e2) {
            !function(r2, n) {
              "use strict";
              if (!r2.setImmediate) {
                var i, s, t4, a, o = 1, h = {}, u = false, l = r2.document, e3 = Object.getPrototypeOf && Object.getPrototypeOf(r2);
                e3 = e3 && e3.setTimeout ? e3 : r2, i = "[object process]" === {}.toString.call(r2.process) ? function(e4) {
                  define_process_default.nextTick(function() {
                    c(e4);
                  });
                } : function() {
                  if (r2.postMessage && !r2.importScripts) {
                    var e4 = true, t5 = r2.onmessage;
                    return r2.onmessage = function() {
                      e4 = false;
                    }, r2.postMessage("", "*"), r2.onmessage = t5, e4;
                  }
                }() ? (a = "setImmediate$" + Math.random() + "$", r2.addEventListener ? r2.addEventListener("message", d, false) : r2.attachEvent("onmessage", d), function(e4) {
                  r2.postMessage(a + e4, "*");
                }) : r2.MessageChannel ? ((t4 = new MessageChannel()).port1.onmessage = function(e4) {
                  c(e4.data);
                }, function(e4) {
                  t4.port2.postMessage(e4);
                }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e4) {
                  var t5 = l.createElement("script");
                  t5.onreadystatechange = function() {
                    c(e4), t5.onreadystatechange = null, s.removeChild(t5), t5 = null;
                  }, s.appendChild(t5);
                }) : function(e4) {
                  setTimeout(c, 0, e4);
                }, e3.setImmediate = function(e4) {
                  "function" != typeof e4 && (e4 = new Function("" + e4));
                  for (var t5 = new Array(arguments.length - 1), r3 = 0; r3 < t5.length; r3++)
                    t5[r3] = arguments[r3 + 1];
                  var n2 = { callback: e4, args: t5 };
                  return h[o] = n2, i(o), o++;
                }, e3.clearImmediate = f;
              }
              function f(e4) {
                delete h[e4];
              }
              function c(e4) {
                if (u)
                  setTimeout(c, 0, e4);
                else {
                  var t5 = h[e4];
                  if (t5) {
                    u = true;
                    try {
                      !function(e5) {
                        var t6 = e5.callback, r3 = e5.args;
                        switch (r3.length) {
                          case 0:
                            t6();
                            break;
                          case 1:
                            t6(r3[0]);
                            break;
                          case 2:
                            t6(r3[0], r3[1]);
                            break;
                          case 3:
                            t6(r3[0], r3[1], r3[2]);
                            break;
                          default:
                            t6.apply(n, r3);
                        }
                      }(t5);
                    } finally {
                      f(e4), u = false;
                    }
                  }
                }
              }
              function d(e4) {
                e4.source === r2 && "string" == typeof e4.data && 0 === e4.data.indexOf(a) && c(+e4.data.slice(a.length));
              }
            }("undefined" == typeof self ? void 0 === e2 ? this : e2 : self);
          }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {}] }, {}, [10])(10);
      });
    }
  });

  // node_modules/@babel/parser/lib/index.js
  var require_lib2 = __commonJS({
    "node_modules/@babel/parser/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", { value: true });
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null)
          return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0)
            continue;
          target[key] = source[key];
        }
        return target;
      }
      var Position = class {
        constructor(line, col, index) {
          this.line = void 0;
          this.column = void 0;
          this.index = void 0;
          this.line = line;
          this.column = col;
          this.index = index;
        }
      };
      var SourceLocation = class {
        constructor(start, end) {
          this.start = void 0;
          this.end = void 0;
          this.filename = void 0;
          this.identifierName = void 0;
          this.start = start;
          this.end = end;
        }
      };
      function createPositionWithColumnOffset(position, columnOffset) {
        const {
          line,
          column,
          index
        } = position;
        return new Position(line, column + columnOffset, index + columnOffset);
      }
      var ParseErrorCode = {
        SyntaxError: "BABEL_PARSER_SYNTAX_ERROR",
        SourceTypeModuleError: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED"
      };
      var reflect = (keys2, last2 = keys2.length - 1) => ({
        get() {
          return keys2.reduce((object, key) => object[key], this);
        },
        set(value) {
          keys2.reduce(
            (item, key, i) => i === last2 ? item[key] = value : item[key],
            this
          );
        }
      });
      var instantiate = (constructor, properties, descriptors) => Object.keys(descriptors).map((key) => [key, descriptors[key]]).filter(([, descriptor]) => !!descriptor).map(([key, descriptor]) => [key, typeof descriptor === "function" ? {
        value: descriptor,
        enumerable: false
      } : typeof descriptor.reflect === "string" ? Object.assign({}, descriptor, reflect(descriptor.reflect.split("."))) : descriptor]).reduce((instance, [key, descriptor]) => Object.defineProperty(instance, key, Object.assign({
        configurable: true
      }, descriptor)), Object.assign(new constructor(), properties));
      var ModuleErrors = {
        ImportMetaOutsideModule: {
          message: `import.meta may appear only with 'sourceType: "module"'`,
          code: ParseErrorCode.SourceTypeModuleError
        },
        ImportOutsideModule: {
          message: `'import' and 'export' may appear only with 'sourceType: "module"'`,
          code: ParseErrorCode.SourceTypeModuleError
        }
      };
      var NodeDescriptions = {
        ArrayPattern: "array destructuring pattern",
        AssignmentExpression: "assignment expression",
        AssignmentPattern: "assignment expression",
        ArrowFunctionExpression: "arrow function expression",
        ConditionalExpression: "conditional expression",
        CatchClause: "catch clause",
        ForOfStatement: "for-of statement",
        ForInStatement: "for-in statement",
        ForStatement: "for-loop",
        FormalParameters: "function parameter list",
        Identifier: "identifier",
        ImportSpecifier: "import specifier",
        ImportDefaultSpecifier: "import default specifier",
        ImportNamespaceSpecifier: "import namespace specifier",
        ObjectPattern: "object destructuring pattern",
        ParenthesizedExpression: "parenthesized expression",
        RestElement: "rest element",
        UpdateExpression: {
          true: "prefix operation",
          false: "postfix operation"
        },
        VariableDeclarator: "variable declaration",
        YieldExpression: "yield expression"
      };
      var toNodeDescription = ({
        type,
        prefix: prefix2
      }) => type === "UpdateExpression" ? NodeDescriptions.UpdateExpression[String(prefix2)] : NodeDescriptions[type];
      var StandardErrors = {
        AccessorIsGenerator: ({
          kind
        }) => `A ${kind}ter cannot be a generator.`,
        ArgumentsInClass: "'arguments' is only allowed in functions and class methods.",
        AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.",
        AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.",
        AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.",
        AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.",
        AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.",
        AwaitNotInAsyncFunction: "'await' is only allowed within async functions.",
        BadGetterArity: "A 'get' accesor must not have any formal parameters.",
        BadSetterArity: "A 'set' accesor must have exactly one formal parameter.",
        BadSetterRestParameter: "A 'set' accesor function argument must not be a rest parameter.",
        ConstructorClassField: "Classes may not have a field named 'constructor'.",
        ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.",
        ConstructorIsAccessor: "Class constructor may not be an accessor.",
        ConstructorIsAsync: "Constructor can't be an async function.",
        ConstructorIsGenerator: "Constructor can't be a generator.",
        DeclarationMissingInitializer: ({
          kind
        }) => `Missing initializer in ${kind} declaration.`,
        DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.",
        DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. You can set the 'decoratorsBeforeExport' option to false to use the 'export @decorator class {}' syntax.",
        DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?",
        DecoratorExportClass: "Using the export keyword between a decorator and a class is not allowed. Please use `export @dec class` instead.",
        DecoratorSemicolon: "Decorators must not be followed by a semicolon.",
        DecoratorStaticBlock: "Decorators can't be used with a static block.",
        DeletePrivateField: "Deleting a private field is not allowed.",
        DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.",
        DuplicateConstructor: "Duplicate constructor in the same class.",
        DuplicateDefaultExport: "Only one default export allowed per module.",
        DuplicateExport: ({
          exportName
        }) => `\`${exportName}\` has already been exported. Exported identifiers must be unique.`,
        DuplicateProto: "Redefinition of __proto__ property.",
        DuplicateRegExpFlags: "Duplicate regular expression flag.",
        ElementAfterRest: "Rest element must be last element.",
        EscapedCharNotAnIdentifier: "Invalid Unicode escape.",
        ExportBindingIsString: ({
          localName,
          exportName
        }) => `A string literal cannot be used as an exported binding without \`from\`.
- Did you mean \`export { '${localName}' as '${exportName}' } from 'some-module'\`?`,
        ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.",
        ForInOfLoopInitializer: ({
          type
        }) => `'${type === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`,
        ForInUsing: "For-in loop may not start with 'using' declaration.",
        ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.",
        ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.",
        GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.",
        IllegalBreakContinue: ({
          type
        }) => `Unsyntactic ${type === "BreakStatement" ? "break" : "continue"}.`,
        IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.",
        IllegalReturn: "'return' outside of function.",
        ImportBindingIsString: ({
          importName
        }) => `A string literal cannot be used as an imported binding.
- Did you mean \`import { "${importName}" as foo }\`?`,
        ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments.",
        ImportCallArity: ({
          maxArgumentCount
        }) => `\`import()\` requires exactly ${maxArgumentCount === 1 ? "one argument" : "one or two arguments"}.`,
        ImportCallNotNewExpression: "Cannot use new with import(...).",
        ImportCallSpreadArgument: "`...` is not allowed in `import()`.",
        ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.",
        ImportReflectionHasAssertion: "`import module x` cannot have assertions.",
        ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.',
        IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.",
        InvalidBigIntLiteral: "Invalid BigIntLiteral.",
        InvalidCodePoint: "Code point out of bounds.",
        InvalidCoverInitializedName: "Invalid shorthand property initializer.",
        InvalidDecimal: "Invalid decimal.",
        InvalidDigit: ({
          radix
        }) => `Expected number in radix ${radix}.`,
        InvalidEscapeSequence: "Bad character escape sequence.",
        InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.",
        InvalidEscapedReservedWord: ({
          reservedWord
        }) => `Escape sequence in keyword ${reservedWord}.`,
        InvalidIdentifier: ({
          identifierName
        }) => `Invalid identifier ${identifierName}.`,
        InvalidLhs: ({
          ancestor
        }) => `Invalid left-hand side in ${toNodeDescription(ancestor)}.`,
        InvalidLhsBinding: ({
          ancestor
        }) => `Binding invalid left-hand side in ${toNodeDescription(ancestor)}.`,
        InvalidNumber: "Invalid number.",
        InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.",
        InvalidOrUnexpectedToken: ({
          unexpected
        }) => `Unexpected character '${unexpected}'.`,
        InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.",
        InvalidPrivateFieldResolution: ({
          identifierName
        }) => `Private name #${identifierName} is not defined.`,
        InvalidPropertyBindingPattern: "Binding member expression.",
        InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.",
        InvalidRestAssignmentPattern: "Invalid rest operator's argument.",
        LabelRedeclaration: ({
          labelName
        }) => `Label '${labelName}' is already declared.`,
        LetInLexicalBinding: "'let' is not allowed to be used as a name in 'let' or 'const' declarations.",
        LineTerminatorBeforeArrow: "No line break is allowed before '=>'.",
        MalformedRegExpFlags: "Invalid regular expression flag.",
        MissingClassName: "A class name is required.",
        MissingEqInAssignment: "Only '=' operator can be used for specifying default value.",
        MissingSemicolon: "Missing semicolon.",
        MissingPlugin: ({
          missingPlugin
        }) => `This experimental syntax requires enabling the parser plugin: ${missingPlugin.map((name) => JSON.stringify(name)).join(", ")}.`,
        MissingOneOfPlugins: ({
          missingPlugin
        }) => `This experimental syntax requires enabling one of the following parser plugin(s): ${missingPlugin.map((name) => JSON.stringify(name)).join(", ")}.`,
        MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.",
        MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.",
        ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.",
        ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.",
        ModuleAttributesWithDuplicateKeys: ({
          key
        }) => `Duplicate key "${key}" is not allowed in module attributes.`,
        ModuleExportNameHasLoneSurrogate: ({
          surrogateCharCode
        }) => `An export name cannot include a lone surrogate, found '\\u${surrogateCharCode.toString(16)}'.`,
        ModuleExportUndefined: ({
          localName
        }) => `Export '${localName}' is not defined.`,
        MultipleDefaultsInSwitch: "Multiple default clauses.",
        NewlineAfterThrow: "Illegal newline after throw.",
        NoCatchOrFinally: "Missing catch or finally clause.",
        NumberIdentifier: "Identifier directly after number.",
        NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.",
        ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.",
        OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.",
        OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.",
        OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.",
        ParamDupe: "Argument name clash.",
        PatternHasAccessor: "Object pattern can't contain getter or setter.",
        PatternHasMethod: "Object pattern can't contain methods.",
        PrivateInExpectedIn: ({
          identifierName
        }) => `Private names are only allowed in property accesses (\`obj.#${identifierName}\`) or in \`in\` expressions (\`#${identifierName} in obj\`).`,
        PrivateNameRedeclaration: ({
          identifierName
        }) => `Duplicate private name #${identifierName}.`,
        RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.",
        RecordNoProto: "'__proto__' is not allowed in Record expressions.",
        RestTrailingComma: "Unexpected trailing comma after rest element.",
        SloppyFunction: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.",
        StaticPrototype: "Classes may not have static property named prototype.",
        SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?",
        SuperPrivateField: "Private fields can't be accessed on super.",
        TrailingDecorator: "Decorators must be attached to a class element.",
        TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.",
        TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.",
        UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.",
        UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.',
        UnexpectedDigitAfterHash: "Unexpected digit after hash token.",
        UnexpectedImportExport: "'import' and 'export' may only appear at the top level.",
        UnexpectedKeyword: ({
          keyword
        }) => `Unexpected keyword '${keyword}'.`,
        UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.",
        UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.",
        UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.",
        UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.",
        UnexpectedPrivateField: "Unexpected private name.",
        UnexpectedReservedWord: ({
          reservedWord
        }) => `Unexpected reserved word '${reservedWord}'.`,
        UnexpectedSuper: "'super' is only allowed in object methods and classes.",
        UnexpectedToken: ({
          expected,
          unexpected
        }) => `Unexpected token${unexpected ? ` '${unexpected}'.` : ""}${expected ? `, expected "${expected}"` : ""}`,
        UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.",
        UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script`.",
        UnsupportedBind: "Binding should be performed on object property.",
        UnsupportedDecoratorExport: "A decorated export must export a class declaration.",
        UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.",
        UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.",
        UnsupportedMetaProperty: ({
          target,
          onlyValidPropertyName
        }) => `The only valid meta property for ${target} is ${target}.${onlyValidPropertyName}.`,
        UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.",
        UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.",
        UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).",
        UnterminatedComment: "Unterminated comment.",
        UnterminatedRegExp: "Unterminated regular expression.",
        UnterminatedString: "Unterminated string constant.",
        UnterminatedTemplate: "Unterminated template.",
        UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.",
        VarRedeclaration: ({
          identifierName
        }) => `Identifier '${identifierName}' has already been declared.`,
        YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.",
        YieldInParameter: "Yield expression is not allowed in formal parameters.",
        ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0."
      };
      var StrictModeErrors = {
        StrictDelete: "Deleting local variable in strict mode.",
        StrictEvalArguments: ({
          referenceName
        }) => `Assigning to '${referenceName}' in strict mode.`,
        StrictEvalArgumentsBinding: ({
          bindingName
        }) => `Binding '${bindingName}' in strict mode.`,
        StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.",
        StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.",
        StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.",
        StrictWith: "'with' in strict mode."
      };
      var UnparenthesizedPipeBodyDescriptions = /* @__PURE__ */ new Set(["ArrowFunctionExpression", "AssignmentExpression", "ConditionalExpression", "YieldExpression"]);
      var PipelineOperatorErrors = {
        PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.",
        PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.',
        PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.",
        PipeTopicUnconfiguredToken: ({
          token
        }) => `Invalid topic token ${token}. In order to use ${token} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${token}" }.`,
        PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.",
        PipeUnparenthesizedBody: ({
          type
        }) => `Hack-style pipe body cannot be an unparenthesized ${toNodeDescription({
          type
        })}; please wrap it in parentheses.`,
        PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.',
        PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.",
        PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.",
        PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.",
        PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.",
        PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.'
      };
      var _excluded$1 = ["toMessage"];
      var _excluded2$1 = ["message"];
      function toParseErrorConstructor(_ref) {
        let {
          toMessage
        } = _ref, properties = _objectWithoutPropertiesLoose(_ref, _excluded$1);
        return function constructor({
          loc,
          details
        }) {
          return instantiate(SyntaxError, Object.assign({}, properties, {
            loc
          }), {
            clone(overrides = {}) {
              const loc2 = overrides.loc || {};
              return constructor({
                loc: new Position("line" in loc2 ? loc2.line : this.loc.line, "column" in loc2 ? loc2.column : this.loc.column, "index" in loc2 ? loc2.index : this.loc.index),
                details: Object.assign({}, this.details, overrides.details)
              });
            },
            details: {
              value: details,
              enumerable: false
            },
            message: {
              get() {
                return `${toMessage(this.details)} (${this.loc.line}:${this.loc.column})`;
              },
              set(value) {
                Object.defineProperty(this, "message", {
                  value
                });
              }
            },
            pos: {
              reflect: "loc.index",
              enumerable: true
            },
            missingPlugin: "missingPlugin" in details && {
              reflect: "details.missingPlugin",
              enumerable: true
            }
          });
        };
      }
      function ParseErrorEnum(argument, syntaxPlugin) {
        if (Array.isArray(argument)) {
          return (parseErrorTemplates) => ParseErrorEnum(parseErrorTemplates, argument[0]);
        }
        const ParseErrorConstructors = {};
        for (const reasonCode of Object.keys(argument)) {
          const template2 = argument[reasonCode];
          const _ref2 = typeof template2 === "string" ? {
            message: () => template2
          } : typeof template2 === "function" ? {
            message: template2
          } : template2, {
            message
          } = _ref2, rest2 = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
          const toMessage = typeof message === "string" ? () => message : message;
          ParseErrorConstructors[reasonCode] = toParseErrorConstructor(Object.assign({
            code: ParseErrorCode.SyntaxError,
            reasonCode,
            toMessage
          }, syntaxPlugin ? {
            syntaxPlugin
          } : {}, rest2));
        }
        return ParseErrorConstructors;
      }
      var Errors = Object.assign({}, ParseErrorEnum(ModuleErrors), ParseErrorEnum(StandardErrors), ParseErrorEnum(StrictModeErrors), ParseErrorEnum`pipelineOperator`(PipelineOperatorErrors));
      var {
        defineProperty: defineProperty2
      } = Object;
      var toUnenumerable = (object, key) => defineProperty2(object, key, {
        enumerable: false,
        value: object[key]
      });
      function toESTreeLocation(node) {
        node.loc.start && toUnenumerable(node.loc.start, "index");
        node.loc.end && toUnenumerable(node.loc.end, "index");
        return node;
      }
      var estree = (superClass) => class ESTreeParserMixin extends superClass {
        parse() {
          const file2 = toESTreeLocation(super.parse());
          if (this.options.tokens) {
            file2.tokens = file2.tokens.map(toESTreeLocation);
          }
          return file2;
        }
        parseRegExpLiteral({
          pattern,
          flags
        }) {
          let regex = null;
          try {
            regex = new RegExp(pattern, flags);
          } catch (e) {
          }
          const node = this.estreeParseLiteral(regex);
          node.regex = {
            pattern,
            flags
          };
          return node;
        }
        parseBigIntLiteral(value) {
          let bigInt;
          try {
            bigInt = BigInt(value);
          } catch (_unused) {
            bigInt = null;
          }
          const node = this.estreeParseLiteral(bigInt);
          node.bigint = String(node.value || value);
          return node;
        }
        parseDecimalLiteral(value) {
          const decimal = null;
          const node = this.estreeParseLiteral(decimal);
          node.decimal = String(node.value || value);
          return node;
        }
        estreeParseLiteral(value) {
          return this.parseLiteral(value, "Literal");
        }
        parseStringLiteral(value) {
          return this.estreeParseLiteral(value);
        }
        parseNumericLiteral(value) {
          return this.estreeParseLiteral(value);
        }
        parseNullLiteral() {
          return this.estreeParseLiteral(null);
        }
        parseBooleanLiteral(value) {
          return this.estreeParseLiteral(value);
        }
        directiveToStmt(directive) {
          const expression = directive.value;
          delete directive.value;
          expression.type = "Literal";
          expression.raw = expression.extra.raw;
          expression.value = expression.extra.expressionValue;
          const stmt = directive;
          stmt.type = "ExpressionStatement";
          stmt.expression = expression;
          stmt.directive = expression.extra.rawValue;
          delete expression.extra;
          return stmt;
        }
        initFunction(node, isAsync) {
          super.initFunction(node, isAsync);
          node.expression = false;
        }
        checkDeclaration(node) {
          if (node != null && this.isObjectProperty(node)) {
            this.checkDeclaration(node.value);
          } else {
            super.checkDeclaration(node);
          }
        }
        getObjectOrClassMethodParams(method2) {
          return method2.value.params;
        }
        isValidDirective(stmt) {
          var _stmt$expression$extr;
          return stmt.type === "ExpressionStatement" && stmt.expression.type === "Literal" && typeof stmt.expression.value === "string" && !((_stmt$expression$extr = stmt.expression.extra) != null && _stmt$expression$extr.parenthesized);
        }
        parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse) {
          super.parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse);
          const directiveStatements = node.directives.map((d) => this.directiveToStmt(d));
          node.body = directiveStatements.concat(node.body);
          delete node.directives;
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          this.parseMethod(method2, isGenerator, isAsync, isConstructor, allowsDirectSuper, "ClassMethod", true);
          if (method2.typeParameters) {
            method2.value.typeParameters = method2.typeParameters;
            delete method2.typeParameters;
          }
          classBody.body.push(method2);
        }
        parsePrivateName() {
          const node = super.parsePrivateName();
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return node;
            }
          }
          return this.convertPrivateNameToPrivateIdentifier(node);
        }
        convertPrivateNameToPrivateIdentifier(node) {
          const name = super.getPrivateNameSV(node);
          node = node;
          delete node.id;
          node.name = name;
          node.type = "PrivateIdentifier";
          return node;
        }
        isPrivateName(node) {
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return super.isPrivateName(node);
            }
          }
          return node.type === "PrivateIdentifier";
        }
        getPrivateNameSV(node) {
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return super.getPrivateNameSV(node);
            }
          }
          return node.name;
        }
        parseLiteral(value, type) {
          const node = super.parseLiteral(value, type);
          node.raw = node.extra.raw;
          delete node.extra;
          return node;
        }
        parseFunctionBody(node, allowExpression, isMethod = false) {
          super.parseFunctionBody(node, allowExpression, isMethod);
          node.expression = node.body.type !== "BlockStatement";
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope = false) {
          let funcNode = this.startNode();
          funcNode.kind = node.kind;
          funcNode = super.parseMethod(
            funcNode,
            isGenerator,
            isAsync,
            isConstructor,
            allowDirectSuper,
            type,
            inClassScope
          );
          funcNode.type = "FunctionExpression";
          delete funcNode.kind;
          node.value = funcNode;
          if (type === "ClassPrivateMethod") {
            node.computed = false;
          }
          return this.finishNode(
            node,
            "MethodDefinition"
          );
        }
        parseClassProperty(...args) {
          const propertyNode = super.parseClassProperty(...args);
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return propertyNode;
            }
          }
          propertyNode.type = "PropertyDefinition";
          return propertyNode;
        }
        parseClassPrivateProperty(...args) {
          const propertyNode = super.parseClassPrivateProperty(...args);
          {
            if (!this.getPluginOption("estree", "classFeatures")) {
              return propertyNode;
            }
          }
          propertyNode.type = "PropertyDefinition";
          propertyNode.computed = false;
          return propertyNode;
        }
        parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) {
          const node = super.parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor);
          if (node) {
            node.type = "Property";
            if (node.kind === "method") {
              node.kind = "init";
            }
            node.shorthand = false;
          }
          return node;
        }
        parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors) {
          const node = super.parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors);
          if (node) {
            node.kind = "init";
            node.type = "Property";
          }
          return node;
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding) {
          return type === "Property" ? "value" : super.isValidLVal(type, isUnparenthesizedInAssign, binding);
        }
        isAssignable(node, isBinding) {
          if (node != null && this.isObjectProperty(node)) {
            return this.isAssignable(node.value, isBinding);
          }
          return super.isAssignable(node, isBinding);
        }
        toAssignable(node, isLHS = false) {
          if (node != null && this.isObjectProperty(node)) {
            const {
              key,
              value
            } = node;
            if (this.isPrivateName(key)) {
              this.classScope.usePrivateName(this.getPrivateNameSV(key), key.loc.start);
            }
            this.toAssignable(value, isLHS);
          } else {
            super.toAssignable(node, isLHS);
          }
        }
        toAssignableObjectExpressionProp(prop, isLast, isLHS) {
          if (prop.kind === "get" || prop.kind === "set") {
            this.raise(Errors.PatternHasAccessor, {
              at: prop.key
            });
          } else if (prop.method) {
            this.raise(Errors.PatternHasMethod, {
              at: prop.key
            });
          } else {
            super.toAssignableObjectExpressionProp(prop, isLast, isLHS);
          }
        }
        finishCallExpression(unfinished, optional) {
          const node = super.finishCallExpression(unfinished, optional);
          if (node.callee.type === "Import") {
            node.type = "ImportExpression";
            node.source = node.arguments[0];
            if (this.hasPlugin("importAssertions")) {
              var _node$arguments$;
              node.attributes = (_node$arguments$ = node.arguments[1]) != null ? _node$arguments$ : null;
            }
            delete node.arguments;
            delete node.callee;
          }
          return node;
        }
        toReferencedArguments(node) {
          if (node.type === "ImportExpression") {
            return;
          }
          super.toReferencedArguments(node);
        }
        parseExport(unfinished, decorators) {
          const exportStartLoc = this.state.lastTokStartLoc;
          const node = super.parseExport(unfinished, decorators);
          switch (node.type) {
            case "ExportAllDeclaration":
              node.exported = null;
              break;
            case "ExportNamedDeclaration":
              if (node.specifiers.length === 1 && node.specifiers[0].type === "ExportNamespaceSpecifier") {
                node.type = "ExportAllDeclaration";
                node.exported = node.specifiers[0].exported;
                delete node.specifiers;
              }
            case "ExportDefaultDeclaration":
              {
                var _declaration$decorato;
                const {
                  declaration
                } = node;
                if ((declaration == null ? void 0 : declaration.type) === "ClassDeclaration" && ((_declaration$decorato = declaration.decorators) == null ? void 0 : _declaration$decorato.length) > 0 && declaration.start === node.start) {
                  this.resetStartLocation(
                    node,
                    exportStartLoc
                  );
                }
              }
              break;
          }
          return node;
        }
        parseSubscript(base, startLoc, noCalls, state) {
          const node = super.parseSubscript(base, startLoc, noCalls, state);
          if (state.optionalChainMember) {
            if (node.type === "OptionalMemberExpression" || node.type === "OptionalCallExpression") {
              node.type = node.type.substring(8);
            }
            if (state.stop) {
              const chain2 = this.startNodeAtNode(node);
              chain2.expression = node;
              return this.finishNode(chain2, "ChainExpression");
            }
          } else if (node.type === "MemberExpression" || node.type === "CallExpression") {
            node.optional = false;
          }
          return node;
        }
        hasPropertyAsPrivateName(node) {
          if (node.type === "ChainExpression") {
            node = node.expression;
          }
          return super.hasPropertyAsPrivateName(node);
        }
        isOptionalChain(node) {
          return node.type === "ChainExpression";
        }
        isObjectProperty(node) {
          return node.type === "Property" && node.kind === "init" && !node.method;
        }
        isObjectMethod(node) {
          return node.method || node.kind === "get" || node.kind === "set";
        }
        finishNodeAt(node, type, endLoc) {
          return toESTreeLocation(super.finishNodeAt(node, type, endLoc));
        }
        resetStartLocation(node, startLoc) {
          super.resetStartLocation(node, startLoc);
          toESTreeLocation(node);
        }
        resetEndLocation(node, endLoc = this.state.lastTokEndLoc) {
          super.resetEndLocation(node, endLoc);
          toESTreeLocation(node);
        }
      };
      var TokContext = class {
        constructor(token, preserveSpace) {
          this.token = void 0;
          this.preserveSpace = void 0;
          this.token = token;
          this.preserveSpace = !!preserveSpace;
        }
      };
      var types = {
        brace: new TokContext("{"),
        j_oTag: new TokContext("<tag"),
        j_cTag: new TokContext("</tag"),
        j_expr: new TokContext("<tag>...</tag>", true)
      };
      {
        types.template = new TokContext("`", true);
      }
      var beforeExpr = true;
      var startsExpr = true;
      var isLoop = true;
      var isAssign = true;
      var prefix = true;
      var postfix = true;
      var ExportedTokenType = class {
        constructor(label, conf = {}) {
          this.label = void 0;
          this.keyword = void 0;
          this.beforeExpr = void 0;
          this.startsExpr = void 0;
          this.rightAssociative = void 0;
          this.isLoop = void 0;
          this.isAssign = void 0;
          this.prefix = void 0;
          this.postfix = void 0;
          this.binop = void 0;
          this.label = label;
          this.keyword = conf.keyword;
          this.beforeExpr = !!conf.beforeExpr;
          this.startsExpr = !!conf.startsExpr;
          this.rightAssociative = !!conf.rightAssociative;
          this.isLoop = !!conf.isLoop;
          this.isAssign = !!conf.isAssign;
          this.prefix = !!conf.prefix;
          this.postfix = !!conf.postfix;
          this.binop = conf.binop != null ? conf.binop : null;
          {
            this.updateContext = null;
          }
        }
      };
      var keywords$1 = /* @__PURE__ */ new Map();
      function createKeyword(name, options = {}) {
        options.keyword = name;
        const token = createToken(name, options);
        keywords$1.set(name, token);
        return token;
      }
      function createBinop(name, binop) {
        return createToken(name, {
          beforeExpr,
          binop
        });
      }
      var tokenTypeCounter = -1;
      var tokenTypes = [];
      var tokenLabels = [];
      var tokenBinops = [];
      var tokenBeforeExprs = [];
      var tokenStartsExprs = [];
      var tokenPrefixes = [];
      function createToken(name, options = {}) {
        var _options$binop, _options$beforeExpr, _options$startsExpr, _options$prefix;
        ++tokenTypeCounter;
        tokenLabels.push(name);
        tokenBinops.push((_options$binop = options.binop) != null ? _options$binop : -1);
        tokenBeforeExprs.push((_options$beforeExpr = options.beforeExpr) != null ? _options$beforeExpr : false);
        tokenStartsExprs.push((_options$startsExpr = options.startsExpr) != null ? _options$startsExpr : false);
        tokenPrefixes.push((_options$prefix = options.prefix) != null ? _options$prefix : false);
        tokenTypes.push(new ExportedTokenType(name, options));
        return tokenTypeCounter;
      }
      function createKeywordLike(name, options = {}) {
        var _options$binop2, _options$beforeExpr2, _options$startsExpr2, _options$prefix2;
        ++tokenTypeCounter;
        keywords$1.set(name, tokenTypeCounter);
        tokenLabels.push(name);
        tokenBinops.push((_options$binop2 = options.binop) != null ? _options$binop2 : -1);
        tokenBeforeExprs.push((_options$beforeExpr2 = options.beforeExpr) != null ? _options$beforeExpr2 : false);
        tokenStartsExprs.push((_options$startsExpr2 = options.startsExpr) != null ? _options$startsExpr2 : false);
        tokenPrefixes.push((_options$prefix2 = options.prefix) != null ? _options$prefix2 : false);
        tokenTypes.push(new ExportedTokenType("name", options));
        return tokenTypeCounter;
      }
      var tt = {
        bracketL: createToken("[", {
          beforeExpr,
          startsExpr
        }),
        bracketHashL: createToken("#[", {
          beforeExpr,
          startsExpr
        }),
        bracketBarL: createToken("[|", {
          beforeExpr,
          startsExpr
        }),
        bracketR: createToken("]"),
        bracketBarR: createToken("|]"),
        braceL: createToken("{", {
          beforeExpr,
          startsExpr
        }),
        braceBarL: createToken("{|", {
          beforeExpr,
          startsExpr
        }),
        braceHashL: createToken("#{", {
          beforeExpr,
          startsExpr
        }),
        braceR: createToken("}"),
        braceBarR: createToken("|}"),
        parenL: createToken("(", {
          beforeExpr,
          startsExpr
        }),
        parenR: createToken(")"),
        comma: createToken(",", {
          beforeExpr
        }),
        semi: createToken(";", {
          beforeExpr
        }),
        colon: createToken(":", {
          beforeExpr
        }),
        doubleColon: createToken("::", {
          beforeExpr
        }),
        dot: createToken("."),
        question: createToken("?", {
          beforeExpr
        }),
        questionDot: createToken("?."),
        arrow: createToken("=>", {
          beforeExpr
        }),
        template: createToken("template"),
        ellipsis: createToken("...", {
          beforeExpr
        }),
        backQuote: createToken("`", {
          startsExpr
        }),
        dollarBraceL: createToken("${", {
          beforeExpr,
          startsExpr
        }),
        templateTail: createToken("...`", {
          startsExpr
        }),
        templateNonTail: createToken("...${", {
          beforeExpr,
          startsExpr
        }),
        at: createToken("@"),
        hash: createToken("#", {
          startsExpr
        }),
        interpreterDirective: createToken("#!..."),
        eq: createToken("=", {
          beforeExpr,
          isAssign
        }),
        assign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        slashAssign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        xorAssign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        moduloAssign: createToken("_=", {
          beforeExpr,
          isAssign
        }),
        incDec: createToken("++/--", {
          prefix,
          postfix,
          startsExpr
        }),
        bang: createToken("!", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        tilde: createToken("~", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        doubleCaret: createToken("^^", {
          startsExpr
        }),
        doubleAt: createToken("@@", {
          startsExpr
        }),
        pipeline: createBinop("|>", 0),
        nullishCoalescing: createBinop("??", 1),
        logicalOR: createBinop("||", 1),
        logicalAND: createBinop("&&", 2),
        bitwiseOR: createBinop("|", 3),
        bitwiseXOR: createBinop("^", 4),
        bitwiseAND: createBinop("&", 5),
        equality: createBinop("==/!=/===/!==", 6),
        lt: createBinop("</>/<=/>=", 7),
        gt: createBinop("</>/<=/>=", 7),
        relational: createBinop("</>/<=/>=", 7),
        bitShift: createBinop("<</>>/>>>", 8),
        bitShiftL: createBinop("<</>>/>>>", 8),
        bitShiftR: createBinop("<</>>/>>>", 8),
        plusMin: createToken("+/-", {
          beforeExpr,
          binop: 9,
          prefix,
          startsExpr
        }),
        modulo: createToken("%", {
          binop: 10,
          startsExpr
        }),
        star: createToken("*", {
          binop: 10
        }),
        slash: createBinop("/", 10),
        exponent: createToken("**", {
          beforeExpr,
          binop: 11,
          rightAssociative: true
        }),
        _in: createKeyword("in", {
          beforeExpr,
          binop: 7
        }),
        _instanceof: createKeyword("instanceof", {
          beforeExpr,
          binop: 7
        }),
        _break: createKeyword("break"),
        _case: createKeyword("case", {
          beforeExpr
        }),
        _catch: createKeyword("catch"),
        _continue: createKeyword("continue"),
        _debugger: createKeyword("debugger"),
        _default: createKeyword("default", {
          beforeExpr
        }),
        _else: createKeyword("else", {
          beforeExpr
        }),
        _finally: createKeyword("finally"),
        _function: createKeyword("function", {
          startsExpr
        }),
        _if: createKeyword("if"),
        _return: createKeyword("return", {
          beforeExpr
        }),
        _switch: createKeyword("switch"),
        _throw: createKeyword("throw", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _try: createKeyword("try"),
        _var: createKeyword("var"),
        _const: createKeyword("const"),
        _with: createKeyword("with"),
        _new: createKeyword("new", {
          beforeExpr,
          startsExpr
        }),
        _this: createKeyword("this", {
          startsExpr
        }),
        _super: createKeyword("super", {
          startsExpr
        }),
        _class: createKeyword("class", {
          startsExpr
        }),
        _extends: createKeyword("extends", {
          beforeExpr
        }),
        _export: createKeyword("export"),
        _import: createKeyword("import", {
          startsExpr
        }),
        _null: createKeyword("null", {
          startsExpr
        }),
        _true: createKeyword("true", {
          startsExpr
        }),
        _false: createKeyword("false", {
          startsExpr
        }),
        _typeof: createKeyword("typeof", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _void: createKeyword("void", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _delete: createKeyword("delete", {
          beforeExpr,
          prefix,
          startsExpr
        }),
        _do: createKeyword("do", {
          isLoop,
          beforeExpr
        }),
        _for: createKeyword("for", {
          isLoop
        }),
        _while: createKeyword("while", {
          isLoop
        }),
        _as: createKeywordLike("as", {
          startsExpr
        }),
        _assert: createKeywordLike("assert", {
          startsExpr
        }),
        _async: createKeywordLike("async", {
          startsExpr
        }),
        _await: createKeywordLike("await", {
          startsExpr
        }),
        _from: createKeywordLike("from", {
          startsExpr
        }),
        _get: createKeywordLike("get", {
          startsExpr
        }),
        _let: createKeywordLike("let", {
          startsExpr
        }),
        _meta: createKeywordLike("meta", {
          startsExpr
        }),
        _of: createKeywordLike("of", {
          startsExpr
        }),
        _sent: createKeywordLike("sent", {
          startsExpr
        }),
        _set: createKeywordLike("set", {
          startsExpr
        }),
        _static: createKeywordLike("static", {
          startsExpr
        }),
        _using: createKeywordLike("using", {
          startsExpr
        }),
        _yield: createKeywordLike("yield", {
          startsExpr
        }),
        _asserts: createKeywordLike("asserts", {
          startsExpr
        }),
        _checks: createKeywordLike("checks", {
          startsExpr
        }),
        _exports: createKeywordLike("exports", {
          startsExpr
        }),
        _global: createKeywordLike("global", {
          startsExpr
        }),
        _implements: createKeywordLike("implements", {
          startsExpr
        }),
        _intrinsic: createKeywordLike("intrinsic", {
          startsExpr
        }),
        _infer: createKeywordLike("infer", {
          startsExpr
        }),
        _is: createKeywordLike("is", {
          startsExpr
        }),
        _mixins: createKeywordLike("mixins", {
          startsExpr
        }),
        _proto: createKeywordLike("proto", {
          startsExpr
        }),
        _require: createKeywordLike("require", {
          startsExpr
        }),
        _satisfies: createKeywordLike("satisfies", {
          startsExpr
        }),
        _keyof: createKeywordLike("keyof", {
          startsExpr
        }),
        _readonly: createKeywordLike("readonly", {
          startsExpr
        }),
        _unique: createKeywordLike("unique", {
          startsExpr
        }),
        _abstract: createKeywordLike("abstract", {
          startsExpr
        }),
        _declare: createKeywordLike("declare", {
          startsExpr
        }),
        _enum: createKeywordLike("enum", {
          startsExpr
        }),
        _module: createKeywordLike("module", {
          startsExpr
        }),
        _namespace: createKeywordLike("namespace", {
          startsExpr
        }),
        _interface: createKeywordLike("interface", {
          startsExpr
        }),
        _type: createKeywordLike("type", {
          startsExpr
        }),
        _opaque: createKeywordLike("opaque", {
          startsExpr
        }),
        name: createToken("name", {
          startsExpr
        }),
        string: createToken("string", {
          startsExpr
        }),
        num: createToken("num", {
          startsExpr
        }),
        bigint: createToken("bigint", {
          startsExpr
        }),
        decimal: createToken("decimal", {
          startsExpr
        }),
        regexp: createToken("regexp", {
          startsExpr
        }),
        privateName: createToken("#name", {
          startsExpr
        }),
        eof: createToken("eof"),
        jsxName: createToken("jsxName"),
        jsxText: createToken("jsxText", {
          beforeExpr: true
        }),
        jsxTagStart: createToken("jsxTagStart", {
          startsExpr: true
        }),
        jsxTagEnd: createToken("jsxTagEnd"),
        placeholder: createToken("%%", {
          startsExpr: true
        })
      };
      function tokenIsIdentifier(token) {
        return token >= 93 && token <= 130;
      }
      function tokenKeywordOrIdentifierIsKeyword(token) {
        return token <= 92;
      }
      function tokenIsKeywordOrIdentifier(token) {
        return token >= 58 && token <= 130;
      }
      function tokenIsLiteralPropertyName(token) {
        return token >= 58 && token <= 134;
      }
      function tokenComesBeforeExpression(token) {
        return tokenBeforeExprs[token];
      }
      function tokenCanStartExpression(token) {
        return tokenStartsExprs[token];
      }
      function tokenIsAssignment(token) {
        return token >= 29 && token <= 33;
      }
      function tokenIsFlowInterfaceOrTypeOrOpaque(token) {
        return token >= 127 && token <= 129;
      }
      function tokenIsLoop(token) {
        return token >= 90 && token <= 92;
      }
      function tokenIsKeyword(token) {
        return token >= 58 && token <= 92;
      }
      function tokenIsOperator(token) {
        return token >= 39 && token <= 59;
      }
      function tokenIsPostfix(token) {
        return token === 34;
      }
      function tokenIsPrefix(token) {
        return tokenPrefixes[token];
      }
      function tokenIsTSTypeOperator(token) {
        return token >= 119 && token <= 121;
      }
      function tokenIsTSDeclarationStart(token) {
        return token >= 122 && token <= 128;
      }
      function tokenLabelName(token) {
        return tokenLabels[token];
      }
      function tokenOperatorPrecedence(token) {
        return tokenBinops[token];
      }
      function tokenIsRightAssociative(token) {
        return token === 57;
      }
      function tokenIsTemplate(token) {
        return token >= 24 && token <= 25;
      }
      function getExportedToken(token) {
        return tokenTypes[token];
      }
      {
        tokenTypes[8].updateContext = (context) => {
          context.pop();
        };
        tokenTypes[5].updateContext = tokenTypes[7].updateContext = tokenTypes[23].updateContext = (context) => {
          context.push(types.brace);
        };
        tokenTypes[22].updateContext = (context) => {
          if (context[context.length - 1] === types.template) {
            context.pop();
          } else {
            context.push(types.template);
          }
        };
        tokenTypes[140].updateContext = (context) => {
          context.push(types.j_expr, types.j_oTag);
        };
      }
      var nonASCIIidentifierStartChars = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
      var nonASCIIidentifierChars = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F";
      var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
      var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
      nonASCIIidentifierStartChars = nonASCIIidentifierChars = null;
      var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938, 6, 4191];
      var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
      function isInAstralSet(code, set2) {
        let pos = 65536;
        for (let i = 0, length = set2.length; i < length; i += 2) {
          pos += set2[i];
          if (pos > code)
            return false;
          pos += set2[i + 1];
          if (pos >= code)
            return true;
        }
        return false;
      }
      function isIdentifierStart(code) {
        if (code < 65)
          return code === 36;
        if (code <= 90)
          return true;
        if (code < 97)
          return code === 95;
        if (code <= 122)
          return true;
        if (code <= 65535) {
          return code >= 170 && nonASCIIidentifierStart.test(String.fromCharCode(code));
        }
        return isInAstralSet(code, astralIdentifierStartCodes);
      }
      function isIdentifierChar(code) {
        if (code < 48)
          return code === 36;
        if (code < 58)
          return true;
        if (code < 65)
          return false;
        if (code <= 90)
          return true;
        if (code < 97)
          return code === 95;
        if (code <= 122)
          return true;
        if (code <= 65535) {
          return code >= 170 && nonASCIIidentifier.test(String.fromCharCode(code));
        }
        return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes);
      }
      var reservedWords = {
        keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"],
        strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"],
        strictBind: ["eval", "arguments"]
      };
      var keywords = new Set(reservedWords.keyword);
      var reservedWordsStrictSet = new Set(reservedWords.strict);
      var reservedWordsStrictBindSet = new Set(reservedWords.strictBind);
      function isReservedWord(word, inModule) {
        return inModule && word === "await" || word === "enum";
      }
      function isStrictReservedWord(word, inModule) {
        return isReservedWord(word, inModule) || reservedWordsStrictSet.has(word);
      }
      function isStrictBindOnlyReservedWord(word) {
        return reservedWordsStrictBindSet.has(word);
      }
      function isStrictBindReservedWord(word, inModule) {
        return isStrictReservedWord(word, inModule) || isStrictBindOnlyReservedWord(word);
      }
      function isKeyword(word) {
        return keywords.has(word);
      }
      function isIteratorStart(current, next, next2) {
        return current === 64 && next === 64 && isIdentifierStart(next2);
      }
      var reservedWordLikeSet = /* @__PURE__ */ new Set([
        "break",
        "case",
        "catch",
        "continue",
        "debugger",
        "default",
        "do",
        "else",
        "finally",
        "for",
        "function",
        "if",
        "return",
        "switch",
        "throw",
        "try",
        "var",
        "const",
        "while",
        "with",
        "new",
        "this",
        "super",
        "class",
        "extends",
        "export",
        "import",
        "null",
        "true",
        "false",
        "in",
        "instanceof",
        "typeof",
        "void",
        "delete",
        "implements",
        "interface",
        "let",
        "package",
        "private",
        "protected",
        "public",
        "static",
        "yield",
        "eval",
        "arguments",
        "enum",
        "await"
      ]);
      function canBeReservedWord(word) {
        return reservedWordLikeSet.has(word);
      }
      var SCOPE_OTHER = 0;
      var SCOPE_PROGRAM = 1;
      var SCOPE_FUNCTION = 2;
      var SCOPE_ARROW = 4;
      var SCOPE_SIMPLE_CATCH = 8;
      var SCOPE_SUPER = 16;
      var SCOPE_DIRECT_SUPER = 32;
      var SCOPE_CLASS = 64;
      var SCOPE_STATIC_BLOCK = 128;
      var SCOPE_TS_MODULE = 256;
      var SCOPE_VAR = SCOPE_PROGRAM | SCOPE_FUNCTION | SCOPE_STATIC_BLOCK | SCOPE_TS_MODULE;
      var BIND_KIND_VALUE = 1;
      var BIND_KIND_TYPE = 2;
      var BIND_SCOPE_VAR = 4;
      var BIND_SCOPE_LEXICAL = 8;
      var BIND_SCOPE_FUNCTION = 16;
      var BIND_FLAGS_NONE = 64;
      var BIND_FLAGS_CLASS = 128;
      var BIND_FLAGS_TS_ENUM = 256;
      var BIND_FLAGS_TS_CONST_ENUM = 512;
      var BIND_FLAGS_TS_EXPORT_ONLY = 1024;
      var BIND_FLAGS_FLOW_DECLARE_FN = 2048;
      var BIND_FLAGS_TS_IMPORT = 4096;
      var BIND_CLASS = BIND_KIND_VALUE | BIND_KIND_TYPE | BIND_SCOPE_LEXICAL | BIND_FLAGS_CLASS;
      var BIND_LEXICAL = BIND_KIND_VALUE | 0 | BIND_SCOPE_LEXICAL | 0;
      var BIND_VAR = BIND_KIND_VALUE | 0 | BIND_SCOPE_VAR | 0;
      var BIND_FUNCTION = BIND_KIND_VALUE | 0 | BIND_SCOPE_FUNCTION | 0;
      var BIND_TS_INTERFACE = 0 | BIND_KIND_TYPE | 0 | BIND_FLAGS_CLASS;
      var BIND_TS_TYPE = 0 | BIND_KIND_TYPE | 0 | 0;
      var BIND_TS_ENUM = BIND_KIND_VALUE | BIND_KIND_TYPE | BIND_SCOPE_LEXICAL | BIND_FLAGS_TS_ENUM;
      var BIND_TS_AMBIENT = 0 | 0 | 0 | BIND_FLAGS_TS_EXPORT_ONLY;
      var BIND_NONE = 0 | 0 | 0 | BIND_FLAGS_NONE;
      var BIND_OUTSIDE = BIND_KIND_VALUE | 0 | 0 | BIND_FLAGS_NONE;
      var BIND_TS_CONST_ENUM = BIND_TS_ENUM | BIND_FLAGS_TS_CONST_ENUM;
      var BIND_TS_NAMESPACE = 0 | 0 | 0 | BIND_FLAGS_TS_EXPORT_ONLY;
      var BIND_TS_TYPE_IMPORT = 0 | BIND_KIND_TYPE | 0 | BIND_FLAGS_TS_IMPORT;
      var BIND_FLOW_DECLARE_FN = BIND_FLAGS_FLOW_DECLARE_FN;
      var CLASS_ELEMENT_FLAG_STATIC = 4;
      var CLASS_ELEMENT_KIND_GETTER = 2;
      var CLASS_ELEMENT_KIND_SETTER = 1;
      var CLASS_ELEMENT_KIND_ACCESSOR = CLASS_ELEMENT_KIND_GETTER | CLASS_ELEMENT_KIND_SETTER;
      var CLASS_ELEMENT_STATIC_GETTER = CLASS_ELEMENT_KIND_GETTER | CLASS_ELEMENT_FLAG_STATIC;
      var CLASS_ELEMENT_STATIC_SETTER = CLASS_ELEMENT_KIND_SETTER | CLASS_ELEMENT_FLAG_STATIC;
      var CLASS_ELEMENT_INSTANCE_GETTER = CLASS_ELEMENT_KIND_GETTER;
      var CLASS_ELEMENT_INSTANCE_SETTER = CLASS_ELEMENT_KIND_SETTER;
      var CLASS_ELEMENT_OTHER = 0;
      var Scope2 = class {
        constructor(flags) {
          this.var = /* @__PURE__ */ new Set();
          this.lexical = /* @__PURE__ */ new Set();
          this.functions = /* @__PURE__ */ new Set();
          this.flags = flags;
        }
      };
      var ScopeHandler = class {
        constructor(parser3, inModule) {
          this.parser = void 0;
          this.scopeStack = [];
          this.inModule = void 0;
          this.undefinedExports = /* @__PURE__ */ new Map();
          this.parser = parser3;
          this.inModule = inModule;
        }
        get inTopLevel() {
          return (this.currentScope().flags & SCOPE_PROGRAM) > 0;
        }
        get inFunction() {
          return (this.currentVarScopeFlags() & SCOPE_FUNCTION) > 0;
        }
        get allowSuper() {
          return (this.currentThisScopeFlags() & SCOPE_SUPER) > 0;
        }
        get allowDirectSuper() {
          return (this.currentThisScopeFlags() & SCOPE_DIRECT_SUPER) > 0;
        }
        get inClass() {
          return (this.currentThisScopeFlags() & SCOPE_CLASS) > 0;
        }
        get inClassAndNotInNonArrowFunction() {
          const flags = this.currentThisScopeFlags();
          return (flags & SCOPE_CLASS) > 0 && (flags & SCOPE_FUNCTION) === 0;
        }
        get inStaticBlock() {
          for (let i = this.scopeStack.length - 1; ; i--) {
            const {
              flags
            } = this.scopeStack[i];
            if (flags & SCOPE_STATIC_BLOCK) {
              return true;
            }
            if (flags & (SCOPE_VAR | SCOPE_CLASS)) {
              return false;
            }
          }
        }
        get inNonArrowFunction() {
          return (this.currentThisScopeFlags() & SCOPE_FUNCTION) > 0;
        }
        get treatFunctionsAsVar() {
          return this.treatFunctionsAsVarInScope(this.currentScope());
        }
        createScope(flags) {
          return new Scope2(flags);
        }
        enter(flags) {
          this.scopeStack.push(this.createScope(flags));
        }
        exit() {
          const scope = this.scopeStack.pop();
          return scope.flags;
        }
        treatFunctionsAsVarInScope(scope) {
          return !!(scope.flags & (SCOPE_FUNCTION | SCOPE_STATIC_BLOCK) || !this.parser.inModule && scope.flags & SCOPE_PROGRAM);
        }
        declareName(name, bindingType, loc) {
          let scope = this.currentScope();
          if (bindingType & BIND_SCOPE_LEXICAL || bindingType & BIND_SCOPE_FUNCTION) {
            this.checkRedeclarationInScope(scope, name, bindingType, loc);
            if (bindingType & BIND_SCOPE_FUNCTION) {
              scope.functions.add(name);
            } else {
              scope.lexical.add(name);
            }
            if (bindingType & BIND_SCOPE_LEXICAL) {
              this.maybeExportDefined(scope, name);
            }
          } else if (bindingType & BIND_SCOPE_VAR) {
            for (let i = this.scopeStack.length - 1; i >= 0; --i) {
              scope = this.scopeStack[i];
              this.checkRedeclarationInScope(scope, name, bindingType, loc);
              scope.var.add(name);
              this.maybeExportDefined(scope, name);
              if (scope.flags & SCOPE_VAR)
                break;
            }
          }
          if (this.parser.inModule && scope.flags & SCOPE_PROGRAM) {
            this.undefinedExports.delete(name);
          }
        }
        maybeExportDefined(scope, name) {
          if (this.parser.inModule && scope.flags & SCOPE_PROGRAM) {
            this.undefinedExports.delete(name);
          }
        }
        checkRedeclarationInScope(scope, name, bindingType, loc) {
          if (this.isRedeclaredInScope(scope, name, bindingType)) {
            this.parser.raise(Errors.VarRedeclaration, {
              at: loc,
              identifierName: name
            });
          }
        }
        isRedeclaredInScope(scope, name, bindingType) {
          if (!(bindingType & BIND_KIND_VALUE))
            return false;
          if (bindingType & BIND_SCOPE_LEXICAL) {
            return scope.lexical.has(name) || scope.functions.has(name) || scope.var.has(name);
          }
          if (bindingType & BIND_SCOPE_FUNCTION) {
            return scope.lexical.has(name) || !this.treatFunctionsAsVarInScope(scope) && scope.var.has(name);
          }
          return scope.lexical.has(name) && !(scope.flags & SCOPE_SIMPLE_CATCH && scope.lexical.values().next().value === name) || !this.treatFunctionsAsVarInScope(scope) && scope.functions.has(name);
        }
        checkLocalExport(id) {
          const {
            name
          } = id;
          const topLevelScope = this.scopeStack[0];
          if (!topLevelScope.lexical.has(name) && !topLevelScope.var.has(name) && !topLevelScope.functions.has(name)) {
            this.undefinedExports.set(name, id.loc.start);
          }
        }
        currentScope() {
          return this.scopeStack[this.scopeStack.length - 1];
        }
        currentVarScopeFlags() {
          for (let i = this.scopeStack.length - 1; ; i--) {
            const {
              flags
            } = this.scopeStack[i];
            if (flags & SCOPE_VAR) {
              return flags;
            }
          }
        }
        currentThisScopeFlags() {
          for (let i = this.scopeStack.length - 1; ; i--) {
            const {
              flags
            } = this.scopeStack[i];
            if (flags & (SCOPE_VAR | SCOPE_CLASS) && !(flags & SCOPE_ARROW)) {
              return flags;
            }
          }
        }
      };
      var FlowScope = class extends Scope2 {
        constructor(...args) {
          super(...args);
          this.declareFunctions = /* @__PURE__ */ new Set();
        }
      };
      var FlowScopeHandler = class extends ScopeHandler {
        createScope(flags) {
          return new FlowScope(flags);
        }
        declareName(name, bindingType, loc) {
          const scope = this.currentScope();
          if (bindingType & BIND_FLAGS_FLOW_DECLARE_FN) {
            this.checkRedeclarationInScope(scope, name, bindingType, loc);
            this.maybeExportDefined(scope, name);
            scope.declareFunctions.add(name);
            return;
          }
          super.declareName(name, bindingType, loc);
        }
        isRedeclaredInScope(scope, name, bindingType) {
          if (super.isRedeclaredInScope(scope, name, bindingType))
            return true;
          if (bindingType & BIND_FLAGS_FLOW_DECLARE_FN) {
            return !scope.declareFunctions.has(name) && (scope.lexical.has(name) || scope.functions.has(name));
          }
          return false;
        }
        checkLocalExport(id) {
          if (!this.scopeStack[0].declareFunctions.has(id.name)) {
            super.checkLocalExport(id);
          }
        }
      };
      var BaseParser = class {
        constructor() {
          this.sawUnambiguousESM = false;
          this.ambiguousScriptDifferentAst = false;
        }
        hasPlugin(pluginConfig) {
          if (typeof pluginConfig === "string") {
            return this.plugins.has(pluginConfig);
          } else {
            const [pluginName, pluginOptions] = pluginConfig;
            if (!this.hasPlugin(pluginName)) {
              return false;
            }
            const actualOptions = this.plugins.get(pluginName);
            for (const key of Object.keys(pluginOptions)) {
              if ((actualOptions == null ? void 0 : actualOptions[key]) !== pluginOptions[key]) {
                return false;
              }
            }
            return true;
          }
        }
        getPluginOption(plugin, name) {
          var _this$plugins$get;
          return (_this$plugins$get = this.plugins.get(plugin)) == null ? void 0 : _this$plugins$get[name];
        }
      };
      function setTrailingComments(node, comments) {
        if (node.trailingComments === void 0) {
          node.trailingComments = comments;
        } else {
          node.trailingComments.unshift(...comments);
        }
      }
      function setLeadingComments(node, comments) {
        if (node.leadingComments === void 0) {
          node.leadingComments = comments;
        } else {
          node.leadingComments.unshift(...comments);
        }
      }
      function setInnerComments(node, comments) {
        if (node.innerComments === void 0) {
          node.innerComments = comments;
        } else {
          node.innerComments.unshift(...comments);
        }
      }
      function adjustInnerComments(node, elements, commentWS) {
        let lastElement = null;
        let i = elements.length;
        while (lastElement === null && i > 0) {
          lastElement = elements[--i];
        }
        if (lastElement === null || lastElement.start > commentWS.start) {
          setInnerComments(node, commentWS.comments);
        } else {
          setTrailingComments(lastElement, commentWS.comments);
        }
      }
      var CommentsParser = class extends BaseParser {
        addComment(comment) {
          if (this.filename)
            comment.loc.filename = this.filename;
          this.state.comments.push(comment);
        }
        processComment(node) {
          const {
            commentStack
          } = this.state;
          const commentStackLength = commentStack.length;
          if (commentStackLength === 0)
            return;
          let i = commentStackLength - 1;
          const lastCommentWS = commentStack[i];
          if (lastCommentWS.start === node.end) {
            lastCommentWS.leadingNode = node;
            i--;
          }
          const {
            start: nodeStart
          } = node;
          for (; i >= 0; i--) {
            const commentWS = commentStack[i];
            const commentEnd = commentWS.end;
            if (commentEnd > nodeStart) {
              commentWS.containingNode = node;
              this.finalizeComment(commentWS);
              commentStack.splice(i, 1);
            } else {
              if (commentEnd === nodeStart) {
                commentWS.trailingNode = node;
              }
              break;
            }
          }
        }
        finalizeComment(commentWS) {
          const {
            comments
          } = commentWS;
          if (commentWS.leadingNode !== null || commentWS.trailingNode !== null) {
            if (commentWS.leadingNode !== null) {
              setTrailingComments(commentWS.leadingNode, comments);
            }
            if (commentWS.trailingNode !== null) {
              setLeadingComments(commentWS.trailingNode, comments);
            }
          } else {
            const {
              containingNode: node,
              start: commentStart
            } = commentWS;
            if (this.input.charCodeAt(commentStart - 1) === 44) {
              switch (node.type) {
                case "ObjectExpression":
                case "ObjectPattern":
                case "RecordExpression":
                  adjustInnerComments(node, node.properties, commentWS);
                  break;
                case "CallExpression":
                case "OptionalCallExpression":
                  adjustInnerComments(node, node.arguments, commentWS);
                  break;
                case "FunctionDeclaration":
                case "FunctionExpression":
                case "ArrowFunctionExpression":
                case "ObjectMethod":
                case "ClassMethod":
                case "ClassPrivateMethod":
                  adjustInnerComments(node, node.params, commentWS);
                  break;
                case "ArrayExpression":
                case "ArrayPattern":
                case "TupleExpression":
                  adjustInnerComments(node, node.elements, commentWS);
                  break;
                case "ExportNamedDeclaration":
                case "ImportDeclaration":
                  adjustInnerComments(node, node.specifiers, commentWS);
                  break;
                default: {
                  setInnerComments(node, comments);
                }
              }
            } else {
              setInnerComments(node, comments);
            }
          }
        }
        finalizeRemainingComments() {
          const {
            commentStack
          } = this.state;
          for (let i = commentStack.length - 1; i >= 0; i--) {
            this.finalizeComment(commentStack[i]);
          }
          this.state.commentStack = [];
        }
        resetPreviousNodeTrailingComments(node) {
          const {
            commentStack
          } = this.state;
          const {
            length
          } = commentStack;
          if (length === 0)
            return;
          const commentWS = commentStack[length - 1];
          if (commentWS.leadingNode === node) {
            commentWS.leadingNode = null;
          }
        }
        takeSurroundingComments(node, start, end) {
          const {
            commentStack
          } = this.state;
          const commentStackLength = commentStack.length;
          if (commentStackLength === 0)
            return;
          let i = commentStackLength - 1;
          for (; i >= 0; i--) {
            const commentWS = commentStack[i];
            const commentEnd = commentWS.end;
            const commentStart = commentWS.start;
            if (commentStart === end) {
              commentWS.leadingNode = node;
            } else if (commentEnd === start) {
              commentWS.trailingNode = node;
            } else if (commentEnd < start) {
              break;
            }
          }
        }
      };
      var lineBreak = /\r\n?|[\n\u2028\u2029]/;
      var lineBreakG = new RegExp(lineBreak.source, "g");
      function isNewLine(code) {
        switch (code) {
          case 10:
          case 13:
          case 8232:
          case 8233:
            return true;
          default:
            return false;
        }
      }
      var skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
      var skipWhiteSpaceInLine = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/y;
      var skipWhiteSpaceToLineBreak = new RegExp(
        "(?=(" + skipWhiteSpaceInLine.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source,
        "y"
      );
      function isWhitespace(code) {
        switch (code) {
          case 9:
          case 11:
          case 12:
          case 32:
          case 160:
          case 5760:
          case 8192:
          case 8193:
          case 8194:
          case 8195:
          case 8196:
          case 8197:
          case 8198:
          case 8199:
          case 8200:
          case 8201:
          case 8202:
          case 8239:
          case 8287:
          case 12288:
          case 65279:
            return true;
          default:
            return false;
        }
      }
      var State = class {
        constructor() {
          this.strict = void 0;
          this.curLine = void 0;
          this.lineStart = void 0;
          this.startLoc = void 0;
          this.endLoc = void 0;
          this.errors = [];
          this.potentialArrowAt = -1;
          this.noArrowAt = [];
          this.noArrowParamsConversionAt = [];
          this.maybeInArrowParameters = false;
          this.inType = false;
          this.noAnonFunctionType = false;
          this.hasFlowComment = false;
          this.isAmbientContext = false;
          this.inAbstractClass = false;
          this.inDisallowConditionalTypesContext = false;
          this.topicContext = {
            maxNumOfResolvableTopics: 0,
            maxTopicIndex: null
          };
          this.soloAwait = false;
          this.inFSharpPipelineDirectBody = false;
          this.labels = [];
          this.comments = [];
          this.commentStack = [];
          this.pos = 0;
          this.type = 137;
          this.value = null;
          this.start = 0;
          this.end = 0;
          this.lastTokEndLoc = null;
          this.lastTokStartLoc = null;
          this.lastTokStart = 0;
          this.context = [types.brace];
          this.canStartJSXElement = true;
          this.containsEsc = false;
          this.firstInvalidTemplateEscapePos = null;
          this.strictErrors = /* @__PURE__ */ new Map();
          this.tokensLength = 0;
        }
        init({
          strictMode,
          sourceType,
          startLine,
          startColumn
        }) {
          this.strict = strictMode === false ? false : strictMode === true ? true : sourceType === "module";
          this.curLine = startLine;
          this.lineStart = -startColumn;
          this.startLoc = this.endLoc = new Position(startLine, startColumn, 0);
        }
        curPosition() {
          return new Position(this.curLine, this.pos - this.lineStart, this.pos);
        }
        clone(skipArrays) {
          const state = new State();
          const keys2 = Object.keys(this);
          for (let i = 0, length = keys2.length; i < length; i++) {
            const key = keys2[i];
            let val = this[key];
            if (!skipArrays && Array.isArray(val)) {
              val = val.slice();
            }
            state[key] = val;
          }
          return state;
        }
      };
      var _isDigit = function isDigit(code) {
        return code >= 48 && code <= 57;
      };
      var forbiddenNumericSeparatorSiblings = {
        decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]),
        hex: /* @__PURE__ */ new Set([46, 88, 95, 120])
      };
      var isAllowedNumericSeparatorSibling = {
        bin: (ch) => ch === 48 || ch === 49,
        oct: (ch) => ch >= 48 && ch <= 55,
        dec: (ch) => ch >= 48 && ch <= 57,
        hex: (ch) => ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102
      };
      function readStringContents(type, input, pos, lineStart, curLine, errors) {
        const initialPos = pos;
        const initialLineStart = lineStart;
        const initialCurLine = curLine;
        let out = "";
        let firstInvalidLoc = null;
        let chunkStart = pos;
        const {
          length
        } = input;
        for (; ; ) {
          if (pos >= length) {
            errors.unterminated(initialPos, initialLineStart, initialCurLine);
            out += input.slice(chunkStart, pos);
            break;
          }
          const ch = input.charCodeAt(pos);
          if (isStringEnd(type, ch, input, pos)) {
            out += input.slice(chunkStart, pos);
            break;
          }
          if (ch === 92) {
            out += input.slice(chunkStart, pos);
            const res = readEscapedChar(input, pos, lineStart, curLine, type === "template", errors);
            if (res.ch === null && !firstInvalidLoc) {
              firstInvalidLoc = {
                pos,
                lineStart,
                curLine
              };
            } else {
              out += res.ch;
            }
            ({
              pos,
              lineStart,
              curLine
            } = res);
            chunkStart = pos;
          } else if (ch === 8232 || ch === 8233) {
            ++pos;
            ++curLine;
            lineStart = pos;
          } else if (ch === 10 || ch === 13) {
            if (type === "template") {
              out += input.slice(chunkStart, pos) + "\n";
              ++pos;
              if (ch === 13 && input.charCodeAt(pos) === 10) {
                ++pos;
              }
              ++curLine;
              chunkStart = lineStart = pos;
            } else {
              errors.unterminated(initialPos, initialLineStart, initialCurLine);
            }
          } else {
            ++pos;
          }
        }
        return {
          pos,
          str: out,
          firstInvalidLoc,
          lineStart,
          curLine,
          containsInvalid: !!firstInvalidLoc
        };
      }
      function isStringEnd(type, ch, input, pos) {
        if (type === "template") {
          return ch === 96 || ch === 36 && input.charCodeAt(pos + 1) === 123;
        }
        return ch === (type === "double" ? 34 : 39);
      }
      function readEscapedChar(input, pos, lineStart, curLine, inTemplate, errors) {
        const throwOnInvalid = !inTemplate;
        pos++;
        const res = (ch2) => ({
          pos,
          ch: ch2,
          lineStart,
          curLine
        });
        const ch = input.charCodeAt(pos++);
        switch (ch) {
          case 110:
            return res("\n");
          case 114:
            return res("\r");
          case 120: {
            let code;
            ({
              code,
              pos
            } = readHexChar(input, pos, lineStart, curLine, 2, false, throwOnInvalid, errors));
            return res(code === null ? null : String.fromCharCode(code));
          }
          case 117: {
            let code;
            ({
              code,
              pos
            } = readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors));
            return res(code === null ? null : String.fromCodePoint(code));
          }
          case 116:
            return res("	");
          case 98:
            return res("\b");
          case 118:
            return res("\v");
          case 102:
            return res("\f");
          case 13:
            if (input.charCodeAt(pos) === 10) {
              ++pos;
            }
          case 10:
            lineStart = pos;
            ++curLine;
          case 8232:
          case 8233:
            return res("");
          case 56:
          case 57:
            if (inTemplate) {
              return res(null);
            } else {
              errors.strictNumericEscape(pos - 1, lineStart, curLine);
            }
          default:
            if (ch >= 48 && ch <= 55) {
              const startPos = pos - 1;
              const match = input.slice(startPos, pos + 2).match(/^[0-7]+/);
              let octalStr = match[0];
              let octal = parseInt(octalStr, 8);
              if (octal > 255) {
                octalStr = octalStr.slice(0, -1);
                octal = parseInt(octalStr, 8);
              }
              pos += octalStr.length - 1;
              const next = input.charCodeAt(pos);
              if (octalStr !== "0" || next === 56 || next === 57) {
                if (inTemplate) {
                  return res(null);
                } else {
                  errors.strictNumericEscape(startPos, lineStart, curLine);
                }
              }
              return res(String.fromCharCode(octal));
            }
            return res(String.fromCharCode(ch));
        }
      }
      function readHexChar(input, pos, lineStart, curLine, len, forceLen, throwOnInvalid, errors) {
        const initialPos = pos;
        let n;
        ({
          n,
          pos
        } = readInt(input, pos, lineStart, curLine, 16, len, forceLen, false, errors, !throwOnInvalid));
        if (n === null) {
          if (throwOnInvalid) {
            errors.invalidEscapeSequence(initialPos, lineStart, curLine);
          } else {
            pos = initialPos - 1;
          }
        }
        return {
          code: n,
          pos
        };
      }
      function readInt(input, pos, lineStart, curLine, radix, len, forceLen, allowNumSeparator, errors, bailOnError) {
        const start = pos;
        const forbiddenSiblings = radix === 16 ? forbiddenNumericSeparatorSiblings.hex : forbiddenNumericSeparatorSiblings.decBinOct;
        const isAllowedSibling = radix === 16 ? isAllowedNumericSeparatorSibling.hex : radix === 10 ? isAllowedNumericSeparatorSibling.dec : radix === 8 ? isAllowedNumericSeparatorSibling.oct : isAllowedNumericSeparatorSibling.bin;
        let invalid = false;
        let total = 0;
        for (let i = 0, e = len == null ? Infinity : len; i < e; ++i) {
          const code = input.charCodeAt(pos);
          let val;
          if (code === 95 && allowNumSeparator !== "bail") {
            const prev = input.charCodeAt(pos - 1);
            const next = input.charCodeAt(pos + 1);
            if (!allowNumSeparator) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.numericSeparatorInEscapeSequence(pos, lineStart, curLine);
            } else if (Number.isNaN(next) || !isAllowedSibling(next) || forbiddenSiblings.has(prev) || forbiddenSiblings.has(next)) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.unexpectedNumericSeparator(pos, lineStart, curLine);
            }
            ++pos;
            continue;
          }
          if (code >= 97) {
            val = code - 97 + 10;
          } else if (code >= 65) {
            val = code - 65 + 10;
          } else if (_isDigit(code)) {
            val = code - 48;
          } else {
            val = Infinity;
          }
          if (val >= radix) {
            if (val <= 9 && bailOnError) {
              return {
                n: null,
                pos
              };
            } else if (val <= 9 && errors.invalidDigit(pos, lineStart, curLine, radix)) {
              val = 0;
            } else if (forceLen) {
              val = 0;
              invalid = true;
            } else {
              break;
            }
          }
          ++pos;
          total = total * radix + val;
        }
        if (pos === start || len != null && pos - start !== len || invalid) {
          return {
            n: null,
            pos
          };
        }
        return {
          n: total,
          pos
        };
      }
      function readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors) {
        const ch = input.charCodeAt(pos);
        let code;
        if (ch === 123) {
          ++pos;
          ({
            code,
            pos
          } = readHexChar(input, pos, lineStart, curLine, input.indexOf("}", pos) - pos, true, throwOnInvalid, errors));
          ++pos;
          if (code !== null && code > 1114111) {
            if (throwOnInvalid) {
              errors.invalidCodePoint(pos, lineStart, curLine);
            } else {
              return {
                code: null,
                pos
              };
            }
          }
        } else {
          ({
            code,
            pos
          } = readHexChar(input, pos, lineStart, curLine, 4, false, throwOnInvalid, errors));
        }
        return {
          code,
          pos
        };
      }
      var _excluded = ["at"];
      var _excluded2 = ["at"];
      function buildPosition(pos, lineStart, curLine) {
        return new Position(curLine, pos - lineStart, pos);
      }
      var VALID_REGEX_FLAGS = /* @__PURE__ */ new Set([103, 109, 115, 105, 121, 117, 100, 118]);
      var Token = class {
        constructor(state) {
          this.type = state.type;
          this.value = state.value;
          this.start = state.start;
          this.end = state.end;
          this.loc = new SourceLocation(state.startLoc, state.endLoc);
        }
      };
      var Tokenizer = class extends CommentsParser {
        constructor(options, input) {
          super();
          this.isLookahead = void 0;
          this.tokens = [];
          this.errorHandlers_readInt = {
            invalidDigit: (pos, lineStart, curLine, radix) => {
              if (!this.options.errorRecovery)
                return false;
              this.raise(Errors.InvalidDigit, {
                at: buildPosition(pos, lineStart, curLine),
                radix
              });
              return true;
            },
            numericSeparatorInEscapeSequence: this.errorBuilder(Errors.NumericSeparatorInEscapeSequence),
            unexpectedNumericSeparator: this.errorBuilder(Errors.UnexpectedNumericSeparator)
          };
          this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, {
            invalidEscapeSequence: this.errorBuilder(Errors.InvalidEscapeSequence),
            invalidCodePoint: this.errorBuilder(Errors.InvalidCodePoint)
          });
          this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, {
            strictNumericEscape: (pos, lineStart, curLine) => {
              this.recordStrictModeErrors(Errors.StrictNumericEscape, {
                at: buildPosition(pos, lineStart, curLine)
              });
            },
            unterminated: (pos, lineStart, curLine) => {
              throw this.raise(Errors.UnterminatedString, {
                at: buildPosition(pos - 1, lineStart, curLine)
              });
            }
          });
          this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, {
            strictNumericEscape: this.errorBuilder(Errors.StrictNumericEscape),
            unterminated: (pos, lineStart, curLine) => {
              throw this.raise(Errors.UnterminatedTemplate, {
                at: buildPosition(pos, lineStart, curLine)
              });
            }
          });
          this.state = new State();
          this.state.init(options);
          this.input = input;
          this.length = input.length;
          this.isLookahead = false;
        }
        pushToken(token) {
          this.tokens.length = this.state.tokensLength;
          this.tokens.push(token);
          ++this.state.tokensLength;
        }
        next() {
          this.checkKeywordEscapes();
          if (this.options.tokens) {
            this.pushToken(new Token(this.state));
          }
          this.state.lastTokStart = this.state.start;
          this.state.lastTokEndLoc = this.state.endLoc;
          this.state.lastTokStartLoc = this.state.startLoc;
          this.nextToken();
        }
        eat(type) {
          if (this.match(type)) {
            this.next();
            return true;
          } else {
            return false;
          }
        }
        match(type) {
          return this.state.type === type;
        }
        createLookaheadState(state) {
          return {
            pos: state.pos,
            value: null,
            type: state.type,
            start: state.start,
            end: state.end,
            context: [this.curContext()],
            inType: state.inType,
            startLoc: state.startLoc,
            lastTokEndLoc: state.lastTokEndLoc,
            curLine: state.curLine,
            lineStart: state.lineStart,
            curPosition: state.curPosition
          };
        }
        lookahead() {
          const old = this.state;
          this.state = this.createLookaheadState(old);
          this.isLookahead = true;
          this.nextToken();
          this.isLookahead = false;
          const curr = this.state;
          this.state = old;
          return curr;
        }
        nextTokenStart() {
          return this.nextTokenStartSince(this.state.pos);
        }
        nextTokenStartSince(pos) {
          skipWhiteSpace.lastIndex = pos;
          return skipWhiteSpace.test(this.input) ? skipWhiteSpace.lastIndex : pos;
        }
        lookaheadCharCode() {
          return this.input.charCodeAt(this.nextTokenStart());
        }
        codePointAtPos(pos) {
          let cp = this.input.charCodeAt(pos);
          if ((cp & 64512) === 55296 && ++pos < this.input.length) {
            const trail = this.input.charCodeAt(pos);
            if ((trail & 64512) === 56320) {
              cp = 65536 + ((cp & 1023) << 10) + (trail & 1023);
            }
          }
          return cp;
        }
        setStrict(strict) {
          this.state.strict = strict;
          if (strict) {
            this.state.strictErrors.forEach(([toParseError, at2]) => this.raise(toParseError, {
              at: at2
            }));
            this.state.strictErrors.clear();
          }
        }
        curContext() {
          return this.state.context[this.state.context.length - 1];
        }
        nextToken() {
          this.skipSpace();
          this.state.start = this.state.pos;
          if (!this.isLookahead)
            this.state.startLoc = this.state.curPosition();
          if (this.state.pos >= this.length) {
            this.finishToken(137);
            return;
          }
          this.getTokenFromCode(this.codePointAtPos(this.state.pos));
        }
        skipBlockComment(commentEnd) {
          let startLoc;
          if (!this.isLookahead)
            startLoc = this.state.curPosition();
          const start = this.state.pos;
          const end = this.input.indexOf(commentEnd, start + 2);
          if (end === -1) {
            throw this.raise(Errors.UnterminatedComment, {
              at: this.state.curPosition()
            });
          }
          this.state.pos = end + commentEnd.length;
          lineBreakG.lastIndex = start + 2;
          while (lineBreakG.test(this.input) && lineBreakG.lastIndex <= end) {
            ++this.state.curLine;
            this.state.lineStart = lineBreakG.lastIndex;
          }
          if (this.isLookahead)
            return;
          const comment = {
            type: "CommentBlock",
            value: this.input.slice(start + 2, end),
            start,
            end: end + commentEnd.length,
            loc: new SourceLocation(startLoc, this.state.curPosition())
          };
          if (this.options.tokens)
            this.pushToken(comment);
          return comment;
        }
        skipLineComment(startSkip) {
          const start = this.state.pos;
          let startLoc;
          if (!this.isLookahead)
            startLoc = this.state.curPosition();
          let ch = this.input.charCodeAt(this.state.pos += startSkip);
          if (this.state.pos < this.length) {
            while (!isNewLine(ch) && ++this.state.pos < this.length) {
              ch = this.input.charCodeAt(this.state.pos);
            }
          }
          if (this.isLookahead)
            return;
          const end = this.state.pos;
          const value = this.input.slice(start + startSkip, end);
          const comment = {
            type: "CommentLine",
            value,
            start,
            end,
            loc: new SourceLocation(startLoc, this.state.curPosition())
          };
          if (this.options.tokens)
            this.pushToken(comment);
          return comment;
        }
        skipSpace() {
          const spaceStart = this.state.pos;
          const comments = [];
          loop:
            while (this.state.pos < this.length) {
              const ch = this.input.charCodeAt(this.state.pos);
              switch (ch) {
                case 32:
                case 160:
                case 9:
                  ++this.state.pos;
                  break;
                case 13:
                  if (this.input.charCodeAt(this.state.pos + 1) === 10) {
                    ++this.state.pos;
                  }
                case 10:
                case 8232:
                case 8233:
                  ++this.state.pos;
                  ++this.state.curLine;
                  this.state.lineStart = this.state.pos;
                  break;
                case 47:
                  switch (this.input.charCodeAt(this.state.pos + 1)) {
                    case 42: {
                      const comment = this.skipBlockComment("*/");
                      if (comment !== void 0) {
                        this.addComment(comment);
                        if (this.options.attachComment)
                          comments.push(comment);
                      }
                      break;
                    }
                    case 47: {
                      const comment = this.skipLineComment(2);
                      if (comment !== void 0) {
                        this.addComment(comment);
                        if (this.options.attachComment)
                          comments.push(comment);
                      }
                      break;
                    }
                    default:
                      break loop;
                  }
                  break;
                default:
                  if (isWhitespace(ch)) {
                    ++this.state.pos;
                  } else if (ch === 45 && !this.inModule) {
                    const pos = this.state.pos;
                    if (this.input.charCodeAt(pos + 1) === 45 && this.input.charCodeAt(pos + 2) === 62 && (spaceStart === 0 || this.state.lineStart > spaceStart)) {
                      const comment = this.skipLineComment(3);
                      if (comment !== void 0) {
                        this.addComment(comment);
                        if (this.options.attachComment)
                          comments.push(comment);
                      }
                    } else {
                      break loop;
                    }
                  } else if (ch === 60 && !this.inModule) {
                    const pos = this.state.pos;
                    if (this.input.charCodeAt(pos + 1) === 33 && this.input.charCodeAt(pos + 2) === 45 && this.input.charCodeAt(pos + 3) === 45) {
                      const comment = this.skipLineComment(4);
                      if (comment !== void 0) {
                        this.addComment(comment);
                        if (this.options.attachComment)
                          comments.push(comment);
                      }
                    } else {
                      break loop;
                    }
                  } else {
                    break loop;
                  }
              }
            }
          if (comments.length > 0) {
            const end = this.state.pos;
            const commentWhitespace = {
              start: spaceStart,
              end,
              comments,
              leadingNode: null,
              trailingNode: null,
              containingNode: null
            };
            this.state.commentStack.push(commentWhitespace);
          }
        }
        finishToken(type, val) {
          this.state.end = this.state.pos;
          this.state.endLoc = this.state.curPosition();
          const prevType = this.state.type;
          this.state.type = type;
          this.state.value = val;
          if (!this.isLookahead) {
            this.updateContext(prevType);
          }
        }
        replaceToken(type) {
          this.state.type = type;
          this.updateContext();
        }
        readToken_numberSign() {
          if (this.state.pos === 0 && this.readToken_interpreter()) {
            return;
          }
          const nextPos = this.state.pos + 1;
          const next = this.codePointAtPos(nextPos);
          if (next >= 48 && next <= 57) {
            throw this.raise(Errors.UnexpectedDigitAfterHash, {
              at: this.state.curPosition()
            });
          }
          if (next === 123 || next === 91 && this.hasPlugin("recordAndTuple")) {
            this.expectPlugin("recordAndTuple");
            if (this.getPluginOption("recordAndTuple", "syntaxType") === "bar") {
              throw this.raise(next === 123 ? Errors.RecordExpressionHashIncorrectStartSyntaxType : Errors.TupleExpressionHashIncorrectStartSyntaxType, {
                at: this.state.curPosition()
              });
            }
            this.state.pos += 2;
            if (next === 123) {
              this.finishToken(7);
            } else {
              this.finishToken(1);
            }
          } else if (isIdentifierStart(next)) {
            ++this.state.pos;
            this.finishToken(136, this.readWord1(next));
          } else if (next === 92) {
            ++this.state.pos;
            this.finishToken(136, this.readWord1());
          } else {
            this.finishOp(27, 1);
          }
        }
        readToken_dot() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next >= 48 && next <= 57) {
            this.readNumber(true);
            return;
          }
          if (next === 46 && this.input.charCodeAt(this.state.pos + 2) === 46) {
            this.state.pos += 3;
            this.finishToken(21);
          } else {
            ++this.state.pos;
            this.finishToken(16);
          }
        }
        readToken_slash() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 61) {
            this.finishOp(31, 2);
          } else {
            this.finishOp(56, 1);
          }
        }
        readToken_interpreter() {
          if (this.state.pos !== 0 || this.length < 2)
            return false;
          let ch = this.input.charCodeAt(this.state.pos + 1);
          if (ch !== 33)
            return false;
          const start = this.state.pos;
          this.state.pos += 1;
          while (!isNewLine(ch) && ++this.state.pos < this.length) {
            ch = this.input.charCodeAt(this.state.pos);
          }
          const value = this.input.slice(start + 2, this.state.pos);
          this.finishToken(28, value);
          return true;
        }
        readToken_mult_modulo(code) {
          let type = code === 42 ? 55 : 54;
          let width = 1;
          let next = this.input.charCodeAt(this.state.pos + 1);
          if (code === 42 && next === 42) {
            width++;
            next = this.input.charCodeAt(this.state.pos + 2);
            type = 57;
          }
          if (next === 61 && !this.state.inType) {
            width++;
            type = code === 37 ? 33 : 30;
          }
          this.finishOp(type, width);
        }
        readToken_pipe_amp(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === code) {
            if (this.input.charCodeAt(this.state.pos + 2) === 61) {
              this.finishOp(30, 3);
            } else {
              this.finishOp(code === 124 ? 41 : 42, 2);
            }
            return;
          }
          if (code === 124) {
            if (next === 62) {
              this.finishOp(39, 2);
              return;
            }
            if (this.hasPlugin("recordAndTuple") && next === 125) {
              if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                throw this.raise(Errors.RecordExpressionBarIncorrectEndSyntaxType, {
                  at: this.state.curPosition()
                });
              }
              this.state.pos += 2;
              this.finishToken(9);
              return;
            }
            if (this.hasPlugin("recordAndTuple") && next === 93) {
              if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                throw this.raise(Errors.TupleExpressionBarIncorrectEndSyntaxType, {
                  at: this.state.curPosition()
                });
              }
              this.state.pos += 2;
              this.finishToken(4);
              return;
            }
          }
          if (next === 61) {
            this.finishOp(30, 2);
            return;
          }
          this.finishOp(code === 124 ? 43 : 45, 1);
        }
        readToken_caret() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 61 && !this.state.inType) {
            this.finishOp(32, 2);
          } else if (next === 94 && this.hasPlugin(["pipelineOperator", {
            proposal: "hack",
            topicToken: "^^"
          }])) {
            this.finishOp(37, 2);
            const lookaheadCh = this.input.codePointAt(this.state.pos);
            if (lookaheadCh === 94) {
              throw this.unexpected();
            }
          } else {
            this.finishOp(44, 1);
          }
        }
        readToken_atSign() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 64 && this.hasPlugin(["pipelineOperator", {
            proposal: "hack",
            topicToken: "@@"
          }])) {
            this.finishOp(38, 2);
          } else {
            this.finishOp(26, 1);
          }
        }
        readToken_plus_min(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === code) {
            this.finishOp(34, 2);
            return;
          }
          if (next === 61) {
            this.finishOp(30, 2);
          } else {
            this.finishOp(53, 1);
          }
        }
        readToken_lt() {
          const {
            pos
          } = this.state;
          const next = this.input.charCodeAt(pos + 1);
          if (next === 60) {
            if (this.input.charCodeAt(pos + 2) === 61) {
              this.finishOp(30, 3);
              return;
            }
            this.finishOp(51, 2);
            return;
          }
          if (next === 61) {
            this.finishOp(49, 2);
            return;
          }
          this.finishOp(47, 1);
        }
        readToken_gt() {
          const {
            pos
          } = this.state;
          const next = this.input.charCodeAt(pos + 1);
          if (next === 62) {
            const size2 = this.input.charCodeAt(pos + 2) === 62 ? 3 : 2;
            if (this.input.charCodeAt(pos + size2) === 61) {
              this.finishOp(30, size2 + 1);
              return;
            }
            this.finishOp(52, size2);
            return;
          }
          if (next === 61) {
            this.finishOp(49, 2);
            return;
          }
          this.finishOp(48, 1);
        }
        readToken_eq_excl(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (next === 61) {
            this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
            return;
          }
          if (code === 61 && next === 62) {
            this.state.pos += 2;
            this.finishToken(19);
            return;
          }
          this.finishOp(code === 61 ? 29 : 35, 1);
        }
        readToken_question() {
          const next = this.input.charCodeAt(this.state.pos + 1);
          const next2 = this.input.charCodeAt(this.state.pos + 2);
          if (next === 63) {
            if (next2 === 61) {
              this.finishOp(30, 3);
            } else {
              this.finishOp(40, 2);
            }
          } else if (next === 46 && !(next2 >= 48 && next2 <= 57)) {
            this.state.pos += 2;
            this.finishToken(18);
          } else {
            ++this.state.pos;
            this.finishToken(17);
          }
        }
        getTokenFromCode(code) {
          switch (code) {
            case 46:
              this.readToken_dot();
              return;
            case 40:
              ++this.state.pos;
              this.finishToken(10);
              return;
            case 41:
              ++this.state.pos;
              this.finishToken(11);
              return;
            case 59:
              ++this.state.pos;
              this.finishToken(13);
              return;
            case 44:
              ++this.state.pos;
              this.finishToken(12);
              return;
            case 91:
              if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                  throw this.raise(Errors.TupleExpressionBarIncorrectStartSyntaxType, {
                    at: this.state.curPosition()
                  });
                }
                this.state.pos += 2;
                this.finishToken(2);
              } else {
                ++this.state.pos;
                this.finishToken(0);
              }
              return;
            case 93:
              ++this.state.pos;
              this.finishToken(3);
              return;
            case 123:
              if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") {
                  throw this.raise(Errors.RecordExpressionBarIncorrectStartSyntaxType, {
                    at: this.state.curPosition()
                  });
                }
                this.state.pos += 2;
                this.finishToken(6);
              } else {
                ++this.state.pos;
                this.finishToken(5);
              }
              return;
            case 125:
              ++this.state.pos;
              this.finishToken(8);
              return;
            case 58:
              if (this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58) {
                this.finishOp(15, 2);
              } else {
                ++this.state.pos;
                this.finishToken(14);
              }
              return;
            case 63:
              this.readToken_question();
              return;
            case 96:
              this.readTemplateToken();
              return;
            case 48: {
              const next = this.input.charCodeAt(this.state.pos + 1);
              if (next === 120 || next === 88) {
                this.readRadixNumber(16);
                return;
              }
              if (next === 111 || next === 79) {
                this.readRadixNumber(8);
                return;
              }
              if (next === 98 || next === 66) {
                this.readRadixNumber(2);
                return;
              }
            }
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
              this.readNumber(false);
              return;
            case 34:
            case 39:
              this.readString(code);
              return;
            case 47:
              this.readToken_slash();
              return;
            case 37:
            case 42:
              this.readToken_mult_modulo(code);
              return;
            case 124:
            case 38:
              this.readToken_pipe_amp(code);
              return;
            case 94:
              this.readToken_caret();
              return;
            case 43:
            case 45:
              this.readToken_plus_min(code);
              return;
            case 60:
              this.readToken_lt();
              return;
            case 62:
              this.readToken_gt();
              return;
            case 61:
            case 33:
              this.readToken_eq_excl(code);
              return;
            case 126:
              this.finishOp(36, 1);
              return;
            case 64:
              this.readToken_atSign();
              return;
            case 35:
              this.readToken_numberSign();
              return;
            case 92:
              this.readWord();
              return;
            default:
              if (isIdentifierStart(code)) {
                this.readWord(code);
                return;
              }
          }
          throw this.raise(Errors.InvalidOrUnexpectedToken, {
            at: this.state.curPosition(),
            unexpected: String.fromCodePoint(code)
          });
        }
        finishOp(type, size2) {
          const str = this.input.slice(this.state.pos, this.state.pos + size2);
          this.state.pos += size2;
          this.finishToken(type, str);
        }
        readRegexp() {
          const startLoc = this.state.startLoc;
          const start = this.state.start + 1;
          let escaped, inClass;
          let {
            pos
          } = this.state;
          for (; ; ++pos) {
            if (pos >= this.length) {
              throw this.raise(Errors.UnterminatedRegExp, {
                at: createPositionWithColumnOffset(startLoc, 1)
              });
            }
            const ch = this.input.charCodeAt(pos);
            if (isNewLine(ch)) {
              throw this.raise(Errors.UnterminatedRegExp, {
                at: createPositionWithColumnOffset(startLoc, 1)
              });
            }
            if (escaped) {
              escaped = false;
            } else {
              if (ch === 91) {
                inClass = true;
              } else if (ch === 93 && inClass) {
                inClass = false;
              } else if (ch === 47 && !inClass) {
                break;
              }
              escaped = ch === 92;
            }
          }
          const content = this.input.slice(start, pos);
          ++pos;
          let mods = "";
          const nextPos = () => createPositionWithColumnOffset(startLoc, pos + 2 - start);
          while (pos < this.length) {
            const cp = this.codePointAtPos(pos);
            const char = String.fromCharCode(cp);
            if (VALID_REGEX_FLAGS.has(cp)) {
              if (cp === 118) {
                this.expectPlugin("regexpUnicodeSets", nextPos());
                if (mods.includes("u")) {
                  this.raise(Errors.IncompatibleRegExpUVFlags, {
                    at: nextPos()
                  });
                }
              } else if (cp === 117) {
                if (mods.includes("v")) {
                  this.raise(Errors.IncompatibleRegExpUVFlags, {
                    at: nextPos()
                  });
                }
              }
              if (mods.includes(char)) {
                this.raise(Errors.DuplicateRegExpFlags, {
                  at: nextPos()
                });
              }
            } else if (isIdentifierChar(cp) || cp === 92) {
              this.raise(Errors.MalformedRegExpFlags, {
                at: nextPos()
              });
            } else {
              break;
            }
            ++pos;
            mods += char;
          }
          this.state.pos = pos;
          this.finishToken(135, {
            pattern: content,
            flags: mods
          });
        }
        readInt(radix, len, forceLen = false, allowNumSeparator = true) {
          const {
            n,
            pos
          } = readInt(this.input, this.state.pos, this.state.lineStart, this.state.curLine, radix, len, forceLen, allowNumSeparator, this.errorHandlers_readInt, false);
          this.state.pos = pos;
          return n;
        }
        readRadixNumber(radix) {
          const startLoc = this.state.curPosition();
          let isBigInt = false;
          this.state.pos += 2;
          const val = this.readInt(radix);
          if (val == null) {
            this.raise(Errors.InvalidDigit, {
              at: createPositionWithColumnOffset(startLoc, 2),
              radix
            });
          }
          const next = this.input.charCodeAt(this.state.pos);
          if (next === 110) {
            ++this.state.pos;
            isBigInt = true;
          } else if (next === 109) {
            throw this.raise(Errors.InvalidDecimal, {
              at: startLoc
            });
          }
          if (isIdentifierStart(this.codePointAtPos(this.state.pos))) {
            throw this.raise(Errors.NumberIdentifier, {
              at: this.state.curPosition()
            });
          }
          if (isBigInt) {
            const str = this.input.slice(startLoc.index, this.state.pos).replace(/[_n]/g, "");
            this.finishToken(133, str);
            return;
          }
          this.finishToken(132, val);
        }
        readNumber(startsWithDot) {
          const start = this.state.pos;
          const startLoc = this.state.curPosition();
          let isFloat = false;
          let isBigInt = false;
          let isDecimal = false;
          let hasExponent = false;
          let isOctal = false;
          if (!startsWithDot && this.readInt(10) === null) {
            this.raise(Errors.InvalidNumber, {
              at: this.state.curPosition()
            });
          }
          const hasLeadingZero = this.state.pos - start >= 2 && this.input.charCodeAt(start) === 48;
          if (hasLeadingZero) {
            const integer = this.input.slice(start, this.state.pos);
            this.recordStrictModeErrors(Errors.StrictOctalLiteral, {
              at: startLoc
            });
            if (!this.state.strict) {
              const underscorePos = integer.indexOf("_");
              if (underscorePos > 0) {
                this.raise(Errors.ZeroDigitNumericSeparator, {
                  at: createPositionWithColumnOffset(startLoc, underscorePos)
                });
              }
            }
            isOctal = hasLeadingZero && !/[89]/.test(integer);
          }
          let next = this.input.charCodeAt(this.state.pos);
          if (next === 46 && !isOctal) {
            ++this.state.pos;
            this.readInt(10);
            isFloat = true;
            next = this.input.charCodeAt(this.state.pos);
          }
          if ((next === 69 || next === 101) && !isOctal) {
            next = this.input.charCodeAt(++this.state.pos);
            if (next === 43 || next === 45) {
              ++this.state.pos;
            }
            if (this.readInt(10) === null) {
              this.raise(Errors.InvalidOrMissingExponent, {
                at: startLoc
              });
            }
            isFloat = true;
            hasExponent = true;
            next = this.input.charCodeAt(this.state.pos);
          }
          if (next === 110) {
            if (isFloat || hasLeadingZero) {
              this.raise(Errors.InvalidBigIntLiteral, {
                at: startLoc
              });
            }
            ++this.state.pos;
            isBigInt = true;
          }
          if (next === 109) {
            this.expectPlugin("decimal", this.state.curPosition());
            if (hasExponent || hasLeadingZero) {
              this.raise(Errors.InvalidDecimal, {
                at: startLoc
              });
            }
            ++this.state.pos;
            isDecimal = true;
          }
          if (isIdentifierStart(this.codePointAtPos(this.state.pos))) {
            throw this.raise(Errors.NumberIdentifier, {
              at: this.state.curPosition()
            });
          }
          const str = this.input.slice(start, this.state.pos).replace(/[_mn]/g, "");
          if (isBigInt) {
            this.finishToken(133, str);
            return;
          }
          if (isDecimal) {
            this.finishToken(134, str);
            return;
          }
          const val = isOctal ? parseInt(str, 8) : parseFloat(str);
          this.finishToken(132, val);
        }
        readCodePoint(throwOnInvalid) {
          const {
            code,
            pos
          } = readCodePoint(this.input, this.state.pos, this.state.lineStart, this.state.curLine, throwOnInvalid, this.errorHandlers_readCodePoint);
          this.state.pos = pos;
          return code;
        }
        readString(quote) {
          const {
            str,
            pos,
            curLine,
            lineStart
          } = readStringContents(
            quote === 34 ? "double" : "single",
            this.input,
            this.state.pos + 1,
            this.state.lineStart,
            this.state.curLine,
            this.errorHandlers_readStringContents_string
          );
          this.state.pos = pos + 1;
          this.state.lineStart = lineStart;
          this.state.curLine = curLine;
          this.finishToken(131, str);
        }
        readTemplateContinuation() {
          if (!this.match(8)) {
            this.unexpected(null, 8);
          }
          this.state.pos--;
          this.readTemplateToken();
        }
        readTemplateToken() {
          const opening = this.input[this.state.pos];
          const {
            str,
            firstInvalidLoc,
            pos,
            curLine,
            lineStart
          } = readStringContents(
            "template",
            this.input,
            this.state.pos + 1,
            this.state.lineStart,
            this.state.curLine,
            this.errorHandlers_readStringContents_template
          );
          this.state.pos = pos + 1;
          this.state.lineStart = lineStart;
          this.state.curLine = curLine;
          if (firstInvalidLoc) {
            this.state.firstInvalidTemplateEscapePos = new Position(firstInvalidLoc.curLine, firstInvalidLoc.pos - firstInvalidLoc.lineStart, firstInvalidLoc.pos);
          }
          if (this.input.codePointAt(pos) === 96) {
            this.finishToken(24, firstInvalidLoc ? null : opening + str + "`");
          } else {
            this.state.pos++;
            this.finishToken(25, firstInvalidLoc ? null : opening + str + "${");
          }
        }
        recordStrictModeErrors(toParseError, {
          at: at2
        }) {
          const index = at2.index;
          if (this.state.strict && !this.state.strictErrors.has(index)) {
            this.raise(toParseError, {
              at: at2
            });
          } else {
            this.state.strictErrors.set(index, [toParseError, at2]);
          }
        }
        readWord1(firstCode) {
          this.state.containsEsc = false;
          let word = "";
          const start = this.state.pos;
          let chunkStart = this.state.pos;
          if (firstCode !== void 0) {
            this.state.pos += firstCode <= 65535 ? 1 : 2;
          }
          while (this.state.pos < this.length) {
            const ch = this.codePointAtPos(this.state.pos);
            if (isIdentifierChar(ch)) {
              this.state.pos += ch <= 65535 ? 1 : 2;
            } else if (ch === 92) {
              this.state.containsEsc = true;
              word += this.input.slice(chunkStart, this.state.pos);
              const escStart = this.state.curPosition();
              const identifierCheck = this.state.pos === start ? isIdentifierStart : isIdentifierChar;
              if (this.input.charCodeAt(++this.state.pos) !== 117) {
                this.raise(Errors.MissingUnicodeEscape, {
                  at: this.state.curPosition()
                });
                chunkStart = this.state.pos - 1;
                continue;
              }
              ++this.state.pos;
              const esc = this.readCodePoint(true);
              if (esc !== null) {
                if (!identifierCheck(esc)) {
                  this.raise(Errors.EscapedCharNotAnIdentifier, {
                    at: escStart
                  });
                }
                word += String.fromCodePoint(esc);
              }
              chunkStart = this.state.pos;
            } else {
              break;
            }
          }
          return word + this.input.slice(chunkStart, this.state.pos);
        }
        readWord(firstCode) {
          const word = this.readWord1(firstCode);
          const type = keywords$1.get(word);
          if (type !== void 0) {
            this.finishToken(type, tokenLabelName(type));
          } else {
            this.finishToken(130, word);
          }
        }
        checkKeywordEscapes() {
          const {
            type
          } = this.state;
          if (tokenIsKeyword(type) && this.state.containsEsc) {
            this.raise(Errors.InvalidEscapedReservedWord, {
              at: this.state.startLoc,
              reservedWord: tokenLabelName(type)
            });
          }
        }
        raise(toParseError, raiseProperties) {
          const {
            at: at2
          } = raiseProperties, details = _objectWithoutPropertiesLoose(raiseProperties, _excluded);
          const loc = at2 instanceof Position ? at2 : at2.loc.start;
          const error = toParseError({
            loc,
            details
          });
          if (!this.options.errorRecovery)
            throw error;
          if (!this.isLookahead)
            this.state.errors.push(error);
          return error;
        }
        raiseOverwrite(toParseError, raiseProperties) {
          const {
            at: at2
          } = raiseProperties, details = _objectWithoutPropertiesLoose(raiseProperties, _excluded2);
          const loc = at2 instanceof Position ? at2 : at2.loc.start;
          const pos = loc.index;
          const errors = this.state.errors;
          for (let i = errors.length - 1; i >= 0; i--) {
            const error = errors[i];
            if (error.loc.index === pos) {
              return errors[i] = toParseError({
                loc,
                details
              });
            }
            if (error.loc.index < pos)
              break;
          }
          return this.raise(toParseError, raiseProperties);
        }
        updateContext(prevType) {
        }
        unexpected(loc, type) {
          throw this.raise(Errors.UnexpectedToken, {
            expected: type ? tokenLabelName(type) : null,
            at: loc != null ? loc : this.state.startLoc
          });
        }
        expectPlugin(pluginName, loc) {
          if (this.hasPlugin(pluginName)) {
            return true;
          }
          throw this.raise(Errors.MissingPlugin, {
            at: loc != null ? loc : this.state.startLoc,
            missingPlugin: [pluginName]
          });
        }
        expectOnePlugin(pluginNames) {
          if (!pluginNames.some((name) => this.hasPlugin(name))) {
            throw this.raise(Errors.MissingOneOfPlugins, {
              at: this.state.startLoc,
              missingPlugin: pluginNames
            });
          }
        }
        errorBuilder(error) {
          return (pos, lineStart, curLine) => {
            this.raise(error, {
              at: buildPosition(pos, lineStart, curLine)
            });
          };
        }
      };
      var ClassScope = class {
        constructor() {
          this.privateNames = /* @__PURE__ */ new Set();
          this.loneAccessors = /* @__PURE__ */ new Map();
          this.undefinedPrivateNames = /* @__PURE__ */ new Map();
        }
      };
      var ClassScopeHandler = class {
        constructor(parser3) {
          this.parser = void 0;
          this.stack = [];
          this.undefinedPrivateNames = /* @__PURE__ */ new Map();
          this.parser = parser3;
        }
        current() {
          return this.stack[this.stack.length - 1];
        }
        enter() {
          this.stack.push(new ClassScope());
        }
        exit() {
          const oldClassScope = this.stack.pop();
          const current = this.current();
          for (const [name, loc] of Array.from(oldClassScope.undefinedPrivateNames)) {
            if (current) {
              if (!current.undefinedPrivateNames.has(name)) {
                current.undefinedPrivateNames.set(name, loc);
              }
            } else {
              this.parser.raise(Errors.InvalidPrivateFieldResolution, {
                at: loc,
                identifierName: name
              });
            }
          }
        }
        declarePrivateName(name, elementType, loc) {
          const {
            privateNames,
            loneAccessors,
            undefinedPrivateNames
          } = this.current();
          let redefined = privateNames.has(name);
          if (elementType & CLASS_ELEMENT_KIND_ACCESSOR) {
            const accessor = redefined && loneAccessors.get(name);
            if (accessor) {
              const oldStatic = accessor & CLASS_ELEMENT_FLAG_STATIC;
              const newStatic = elementType & CLASS_ELEMENT_FLAG_STATIC;
              const oldKind = accessor & CLASS_ELEMENT_KIND_ACCESSOR;
              const newKind = elementType & CLASS_ELEMENT_KIND_ACCESSOR;
              redefined = oldKind === newKind || oldStatic !== newStatic;
              if (!redefined)
                loneAccessors.delete(name);
            } else if (!redefined) {
              loneAccessors.set(name, elementType);
            }
          }
          if (redefined) {
            this.parser.raise(Errors.PrivateNameRedeclaration, {
              at: loc,
              identifierName: name
            });
          }
          privateNames.add(name);
          undefinedPrivateNames.delete(name);
        }
        usePrivateName(name, loc) {
          let classScope;
          for (classScope of this.stack) {
            if (classScope.privateNames.has(name))
              return;
          }
          if (classScope) {
            classScope.undefinedPrivateNames.set(name, loc);
          } else {
            this.parser.raise(Errors.InvalidPrivateFieldResolution, {
              at: loc,
              identifierName: name
            });
          }
        }
      };
      var kExpression = 0;
      var kMaybeArrowParameterDeclaration = 1;
      var kMaybeAsyncArrowParameterDeclaration = 2;
      var kParameterDeclaration = 3;
      var ExpressionScope = class {
        constructor(type = kExpression) {
          this.type = void 0;
          this.type = type;
        }
        canBeArrowParameterDeclaration() {
          return this.type === kMaybeAsyncArrowParameterDeclaration || this.type === kMaybeArrowParameterDeclaration;
        }
        isCertainlyParameterDeclaration() {
          return this.type === kParameterDeclaration;
        }
      };
      var ArrowHeadParsingScope = class extends ExpressionScope {
        constructor(type) {
          super(type);
          this.declarationErrors = /* @__PURE__ */ new Map();
        }
        recordDeclarationError(ParsingErrorClass, {
          at: at2
        }) {
          const index = at2.index;
          this.declarationErrors.set(index, [ParsingErrorClass, at2]);
        }
        clearDeclarationError(index) {
          this.declarationErrors.delete(index);
        }
        iterateErrors(iterator) {
          this.declarationErrors.forEach(iterator);
        }
      };
      var ExpressionScopeHandler = class {
        constructor(parser3) {
          this.parser = void 0;
          this.stack = [new ExpressionScope()];
          this.parser = parser3;
        }
        enter(scope) {
          this.stack.push(scope);
        }
        exit() {
          this.stack.pop();
        }
        recordParameterInitializerError(toParseError, {
          at: node
        }) {
          const origin = {
            at: node.loc.start
          };
          const {
            stack
          } = this;
          let i = stack.length - 1;
          let scope = stack[i];
          while (!scope.isCertainlyParameterDeclaration()) {
            if (scope.canBeArrowParameterDeclaration()) {
              scope.recordDeclarationError(toParseError, origin);
            } else {
              return;
            }
            scope = stack[--i];
          }
          this.parser.raise(toParseError, origin);
        }
        recordArrowParemeterBindingError(error, {
          at: node
        }) {
          const {
            stack
          } = this;
          const scope = stack[stack.length - 1];
          const origin = {
            at: node.loc.start
          };
          if (scope.isCertainlyParameterDeclaration()) {
            this.parser.raise(error, origin);
          } else if (scope.canBeArrowParameterDeclaration()) {
            scope.recordDeclarationError(error, origin);
          } else {
            return;
          }
        }
        recordAsyncArrowParametersError({
          at: at2
        }) {
          const {
            stack
          } = this;
          let i = stack.length - 1;
          let scope = stack[i];
          while (scope.canBeArrowParameterDeclaration()) {
            if (scope.type === kMaybeAsyncArrowParameterDeclaration) {
              scope.recordDeclarationError(Errors.AwaitBindingIdentifier, {
                at: at2
              });
            }
            scope = stack[--i];
          }
        }
        validateAsPattern() {
          const {
            stack
          } = this;
          const currentScope = stack[stack.length - 1];
          if (!currentScope.canBeArrowParameterDeclaration())
            return;
          currentScope.iterateErrors(([toParseError, loc]) => {
            this.parser.raise(toParseError, {
              at: loc
            });
            let i = stack.length - 2;
            let scope = stack[i];
            while (scope.canBeArrowParameterDeclaration()) {
              scope.clearDeclarationError(loc.index);
              scope = stack[--i];
            }
          });
        }
      };
      function newParameterDeclarationScope() {
        return new ExpressionScope(kParameterDeclaration);
      }
      function newArrowHeadScope() {
        return new ArrowHeadParsingScope(kMaybeArrowParameterDeclaration);
      }
      function newAsyncArrowScope() {
        return new ArrowHeadParsingScope(kMaybeAsyncArrowParameterDeclaration);
      }
      function newExpressionScope() {
        return new ExpressionScope();
      }
      var PARAM = 0;
      var PARAM_YIELD = 1;
      var PARAM_AWAIT = 2;
      var PARAM_RETURN = 4;
      var PARAM_IN = 8;
      var ProductionParameterHandler = class {
        constructor() {
          this.stacks = [];
        }
        enter(flags) {
          this.stacks.push(flags);
        }
        exit() {
          this.stacks.pop();
        }
        currentFlags() {
          return this.stacks[this.stacks.length - 1];
        }
        get hasAwait() {
          return (this.currentFlags() & PARAM_AWAIT) > 0;
        }
        get hasYield() {
          return (this.currentFlags() & PARAM_YIELD) > 0;
        }
        get hasReturn() {
          return (this.currentFlags() & PARAM_RETURN) > 0;
        }
        get hasIn() {
          return (this.currentFlags() & PARAM_IN) > 0;
        }
      };
      function functionFlags(isAsync, isGenerator) {
        return (isAsync ? PARAM_AWAIT : 0) | (isGenerator ? PARAM_YIELD : 0);
      }
      var UtilParser = class extends Tokenizer {
        addExtra(node, key, value, enumerable = true) {
          if (!node)
            return;
          const extra = node.extra = node.extra || {};
          if (enumerable) {
            extra[key] = value;
          } else {
            Object.defineProperty(extra, key, {
              enumerable,
              value
            });
          }
        }
        isContextual(token) {
          return this.state.type === token && !this.state.containsEsc;
        }
        isUnparsedContextual(nameStart, name) {
          const nameEnd = nameStart + name.length;
          if (this.input.slice(nameStart, nameEnd) === name) {
            const nextCh = this.input.charCodeAt(nameEnd);
            return !(isIdentifierChar(nextCh) || (nextCh & 64512) === 55296);
          }
          return false;
        }
        isLookaheadContextual(name) {
          const next = this.nextTokenStart();
          return this.isUnparsedContextual(next, name);
        }
        eatContextual(token) {
          if (this.isContextual(token)) {
            this.next();
            return true;
          }
          return false;
        }
        expectContextual(token, toParseError) {
          if (!this.eatContextual(token)) {
            if (toParseError != null) {
              throw this.raise(toParseError, {
                at: this.state.startLoc
              });
            }
            throw this.unexpected(null, token);
          }
        }
        canInsertSemicolon() {
          return this.match(137) || this.match(8) || this.hasPrecedingLineBreak();
        }
        hasPrecedingLineBreak() {
          return lineBreak.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
        }
        hasFollowingLineBreak() {
          skipWhiteSpaceToLineBreak.lastIndex = this.state.end;
          return skipWhiteSpaceToLineBreak.test(this.input);
        }
        isLineTerminator() {
          return this.eat(13) || this.canInsertSemicolon();
        }
        semicolon(allowAsi = true) {
          if (allowAsi ? this.isLineTerminator() : this.eat(13))
            return;
          this.raise(Errors.MissingSemicolon, {
            at: this.state.lastTokEndLoc
          });
        }
        expect(type, loc) {
          this.eat(type) || this.unexpected(loc, type);
        }
        tryParse(fn, oldState = this.state.clone()) {
          const abortSignal = {
            node: null
          };
          try {
            const node = fn((node2 = null) => {
              abortSignal.node = node2;
              throw abortSignal;
            });
            if (this.state.errors.length > oldState.errors.length) {
              const failState = this.state;
              this.state = oldState;
              this.state.tokensLength = failState.tokensLength;
              return {
                node,
                error: failState.errors[oldState.errors.length],
                thrown: false,
                aborted: false,
                failState
              };
            }
            return {
              node,
              error: null,
              thrown: false,
              aborted: false,
              failState: null
            };
          } catch (error) {
            const failState = this.state;
            this.state = oldState;
            if (error instanceof SyntaxError) {
              return {
                node: null,
                error,
                thrown: true,
                aborted: false,
                failState
              };
            }
            if (error === abortSignal) {
              return {
                node: abortSignal.node,
                error: null,
                thrown: false,
                aborted: true,
                failState
              };
            }
            throw error;
          }
        }
        checkExpressionErrors(refExpressionErrors, andThrow) {
          if (!refExpressionErrors)
            return false;
          const {
            shorthandAssignLoc,
            doubleProtoLoc,
            privateKeyLoc,
            optionalParametersLoc
          } = refExpressionErrors;
          const hasErrors = !!shorthandAssignLoc || !!doubleProtoLoc || !!optionalParametersLoc || !!privateKeyLoc;
          if (!andThrow) {
            return hasErrors;
          }
          if (shorthandAssignLoc != null) {
            this.raise(Errors.InvalidCoverInitializedName, {
              at: shorthandAssignLoc
            });
          }
          if (doubleProtoLoc != null) {
            this.raise(Errors.DuplicateProto, {
              at: doubleProtoLoc
            });
          }
          if (privateKeyLoc != null) {
            this.raise(Errors.UnexpectedPrivateField, {
              at: privateKeyLoc
            });
          }
          if (optionalParametersLoc != null) {
            this.unexpected(optionalParametersLoc);
          }
        }
        isLiteralPropertyName() {
          return tokenIsLiteralPropertyName(this.state.type);
        }
        isPrivateName(node) {
          return node.type === "PrivateName";
        }
        getPrivateNameSV(node) {
          return node.id.name;
        }
        hasPropertyAsPrivateName(node) {
          return (node.type === "MemberExpression" || node.type === "OptionalMemberExpression") && this.isPrivateName(node.property);
        }
        isOptionalChain(node) {
          return node.type === "OptionalMemberExpression" || node.type === "OptionalCallExpression";
        }
        isObjectProperty(node) {
          return node.type === "ObjectProperty";
        }
        isObjectMethod(node) {
          return node.type === "ObjectMethod";
        }
        initializeScopes(inModule = this.options.sourceType === "module") {
          const oldLabels = this.state.labels;
          this.state.labels = [];
          const oldExportedIdentifiers = this.exportedIdentifiers;
          this.exportedIdentifiers = /* @__PURE__ */ new Set();
          const oldInModule = this.inModule;
          this.inModule = inModule;
          const oldScope = this.scope;
          const ScopeHandler2 = this.getScopeHandler();
          this.scope = new ScopeHandler2(this, inModule);
          const oldProdParam = this.prodParam;
          this.prodParam = new ProductionParameterHandler();
          const oldClassScope = this.classScope;
          this.classScope = new ClassScopeHandler(this);
          const oldExpressionScope = this.expressionScope;
          this.expressionScope = new ExpressionScopeHandler(this);
          return () => {
            this.state.labels = oldLabels;
            this.exportedIdentifiers = oldExportedIdentifiers;
            this.inModule = oldInModule;
            this.scope = oldScope;
            this.prodParam = oldProdParam;
            this.classScope = oldClassScope;
            this.expressionScope = oldExpressionScope;
          };
        }
        enterInitialScopes() {
          let paramFlags = PARAM;
          if (this.inModule) {
            paramFlags |= PARAM_AWAIT;
          }
          this.scope.enter(SCOPE_PROGRAM);
          this.prodParam.enter(paramFlags);
        }
        checkDestructuringPrivate(refExpressionErrors) {
          const {
            privateKeyLoc
          } = refExpressionErrors;
          if (privateKeyLoc !== null) {
            this.expectPlugin("destructuringPrivate", privateKeyLoc);
          }
        }
      };
      var ExpressionErrors = class {
        constructor() {
          this.shorthandAssignLoc = null;
          this.doubleProtoLoc = null;
          this.privateKeyLoc = null;
          this.optionalParametersLoc = null;
        }
      };
      var Node2 = class {
        constructor(parser3, pos, loc) {
          this.type = "";
          this.start = pos;
          this.end = 0;
          this.loc = new SourceLocation(loc);
          if (parser3 != null && parser3.options.ranges)
            this.range = [pos, 0];
          if (parser3 != null && parser3.filename)
            this.loc.filename = parser3.filename;
        }
      };
      var NodePrototype = Node2.prototype;
      {
        NodePrototype.__clone = function() {
          const newNode = new Node2(void 0, this.start, this.loc.start);
          const keys2 = Object.keys(this);
          for (let i = 0, length = keys2.length; i < length; i++) {
            const key = keys2[i];
            if (key !== "leadingComments" && key !== "trailingComments" && key !== "innerComments") {
              newNode[key] = this[key];
            }
          }
          return newNode;
        };
      }
      function clonePlaceholder(node) {
        return cloneIdentifier(node);
      }
      function cloneIdentifier(node) {
        const {
          type,
          start,
          end,
          loc,
          range: range2,
          extra,
          name
        } = node;
        const cloned = Object.create(NodePrototype);
        cloned.type = type;
        cloned.start = start;
        cloned.end = end;
        cloned.loc = loc;
        cloned.range = range2;
        cloned.extra = extra;
        cloned.name = name;
        if (type === "Placeholder") {
          cloned.expectedNode = node.expectedNode;
        }
        return cloned;
      }
      function cloneStringLiteral(node) {
        const {
          type,
          start,
          end,
          loc,
          range: range2,
          extra
        } = node;
        if (type === "Placeholder") {
          return clonePlaceholder(node);
        }
        const cloned = Object.create(NodePrototype);
        cloned.type = type;
        cloned.start = start;
        cloned.end = end;
        cloned.loc = loc;
        cloned.range = range2;
        if (node.raw !== void 0) {
          cloned.raw = node.raw;
        } else {
          cloned.extra = extra;
        }
        cloned.value = node.value;
        return cloned;
      }
      var NodeUtils = class extends UtilParser {
        startNode() {
          return new Node2(this, this.state.start, this.state.startLoc);
        }
        startNodeAt(loc) {
          return new Node2(this, loc.index, loc);
        }
        startNodeAtNode(type) {
          return this.startNodeAt(type.loc.start);
        }
        finishNode(node, type) {
          return this.finishNodeAt(node, type, this.state.lastTokEndLoc);
        }
        finishNodeAt(node, type, endLoc) {
          node.type = type;
          node.end = endLoc.index;
          node.loc.end = endLoc;
          if (this.options.ranges)
            node.range[1] = endLoc.index;
          if (this.options.attachComment)
            this.processComment(node);
          return node;
        }
        resetStartLocation(node, startLoc) {
          node.start = startLoc.index;
          node.loc.start = startLoc;
          if (this.options.ranges)
            node.range[0] = startLoc.index;
        }
        resetEndLocation(node, endLoc = this.state.lastTokEndLoc) {
          node.end = endLoc.index;
          node.loc.end = endLoc;
          if (this.options.ranges)
            node.range[1] = endLoc.index;
        }
        resetStartLocationFromNode(node, locationNode) {
          this.resetStartLocation(node, locationNode.loc.start);
        }
      };
      var reservedTypes = /* @__PURE__ */ new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]);
      var FlowErrors = ParseErrorEnum`flow`({
        AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.",
        AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.",
        AssignReservedType: ({
          reservedType
        }) => `Cannot overwrite reserved type ${reservedType}.`,
        DeclareClassElement: "The `declare` modifier can only appear on class fields.",
        DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.",
        DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.",
        EnumBooleanMemberNotInitialized: ({
          memberName,
          enumName
        }) => `Boolean enum members need to be initialized. Use either \`${memberName} = true,\` or \`${memberName} = false,\` in enum \`${enumName}\`.`,
        EnumDuplicateMemberName: ({
          memberName,
          enumName
        }) => `Enum member names need to be unique, but the name \`${memberName}\` has already been used before in enum \`${enumName}\`.`,
        EnumInconsistentMemberValues: ({
          enumName
        }) => `Enum \`${enumName}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`,
        EnumInvalidExplicitType: ({
          invalidEnumType,
          enumName
        }) => `Enum type \`${invalidEnumType}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${enumName}\`.`,
        EnumInvalidExplicitTypeUnknownSupplied: ({
          enumName
        }) => `Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${enumName}\`.`,
        EnumInvalidMemberInitializerPrimaryType: ({
          enumName,
          memberName,
          explicitType
        }) => `Enum \`${enumName}\` has type \`${explicitType}\`, so the initializer of \`${memberName}\` needs to be a ${explicitType} literal.`,
        EnumInvalidMemberInitializerSymbolType: ({
          enumName,
          memberName
        }) => `Symbol enum members cannot be initialized. Use \`${memberName},\` in enum \`${enumName}\`.`,
        EnumInvalidMemberInitializerUnknownType: ({
          enumName,
          memberName
        }) => `The enum member initializer for \`${memberName}\` needs to be a literal (either a boolean, number, or string) in enum \`${enumName}\`.`,
        EnumInvalidMemberName: ({
          enumName,
          memberName,
          suggestion
        }) => `Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${memberName}\`, consider using \`${suggestion}\`, in enum \`${enumName}\`.`,
        EnumNumberMemberNotInitialized: ({
          enumName,
          memberName
        }) => `Number enum members need to be initialized, e.g. \`${memberName} = 1\` in enum \`${enumName}\`.`,
        EnumStringMemberInconsistentlyInitailized: ({
          enumName
        }) => `String enum members need to consistently either all use initializers, or use no initializers, in enum \`${enumName}\`.`,
        GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.",
        ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.",
        ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.",
        InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.",
        InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.",
        InexactVariance: "Explicit inexact syntax cannot have variance.",
        InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.",
        MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.",
        NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.",
        NestedFlowComment: "Cannot have a flow comment inside another flow comment.",
        PatternIsOptional: Object.assign({
          message: "A binding pattern parameter cannot be optional in an implementation signature."
        }, {
          reasonCode: "OptionalBindingPattern"
        }),
        SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.",
        SpreadVariance: "Spread properties cannot have variance.",
        ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.",
        ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.",
        ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.",
        ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.",
        ThisParamNoDefault: "The `this` parameter may not have a default value.",
        TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.",
        TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.",
        UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.",
        UnexpectedReservedType: ({
          reservedType
        }) => `Unexpected reserved type ${reservedType}.`,
        UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.",
        UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.",
        UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.",
        UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".',
        UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.",
        UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.",
        UnsupportedDeclareExportKind: ({
          unsupportedExportKind,
          suggestion
        }) => `\`declare export ${unsupportedExportKind}\` is not supported. Use \`${suggestion}\` instead.`,
        UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.",
        UnterminatedFlowComment: "Unterminated flow-comment."
      });
      function isEsModuleType(bodyElement) {
        return bodyElement.type === "DeclareExportAllDeclaration" || bodyElement.type === "DeclareExportDeclaration" && (!bodyElement.declaration || bodyElement.declaration.type !== "TypeAlias" && bodyElement.declaration.type !== "InterfaceDeclaration");
      }
      function hasTypeImportKind(node) {
        return node.importKind === "type" || node.importKind === "typeof";
      }
      function isMaybeDefaultImport(type) {
        return tokenIsKeywordOrIdentifier(type) && type !== 97;
      }
      var exportSuggestions = {
        const: "declare export var",
        let: "declare export var",
        type: "export type",
        interface: "export interface"
      };
      function partition2(list, test) {
        const list1 = [];
        const list2 = [];
        for (let i = 0; i < list.length; i++) {
          (test(list[i], i, list) ? list1 : list2).push(list[i]);
        }
        return [list1, list2];
      }
      var FLOW_PRAGMA_REGEX = /\*?\s*@((?:no)?flow)\b/;
      var flow2 = (superClass) => class FlowParserMixin extends superClass {
        constructor(...args) {
          super(...args);
          this.flowPragma = void 0;
        }
        getScopeHandler() {
          return FlowScopeHandler;
        }
        shouldParseTypes() {
          return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
        }
        shouldParseEnums() {
          return !!this.getPluginOption("flow", "enums");
        }
        finishToken(type, val) {
          if (type !== 131 && type !== 13 && type !== 28) {
            if (this.flowPragma === void 0) {
              this.flowPragma = null;
            }
          }
          return super.finishToken(type, val);
        }
        addComment(comment) {
          if (this.flowPragma === void 0) {
            const matches2 = FLOW_PRAGMA_REGEX.exec(comment.value);
            if (!matches2)
              ;
            else if (matches2[1] === "flow") {
              this.flowPragma = "flow";
            } else if (matches2[1] === "noflow") {
              this.flowPragma = "noflow";
            } else {
              throw new Error("Unexpected flow pragma");
            }
          }
          return super.addComment(comment);
        }
        flowParseTypeInitialiser(tok) {
          const oldInType = this.state.inType;
          this.state.inType = true;
          this.expect(tok || 14);
          const type = this.flowParseType();
          this.state.inType = oldInType;
          return type;
        }
        flowParsePredicate() {
          const node = this.startNode();
          const moduloLoc = this.state.startLoc;
          this.next();
          this.expectContextual(108);
          if (this.state.lastTokStart > moduloLoc.index + 1) {
            this.raise(FlowErrors.UnexpectedSpaceBetweenModuloChecks, {
              at: moduloLoc
            });
          }
          if (this.eat(10)) {
            node.value = super.parseExpression();
            this.expect(11);
            return this.finishNode(node, "DeclaredPredicate");
          } else {
            return this.finishNode(node, "InferredPredicate");
          }
        }
        flowParseTypeAndPredicateInitialiser() {
          const oldInType = this.state.inType;
          this.state.inType = true;
          this.expect(14);
          let type = null;
          let predicate = null;
          if (this.match(54)) {
            this.state.inType = oldInType;
            predicate = this.flowParsePredicate();
          } else {
            type = this.flowParseType();
            this.state.inType = oldInType;
            if (this.match(54)) {
              predicate = this.flowParsePredicate();
            }
          }
          return [type, predicate];
        }
        flowParseDeclareClass(node) {
          this.next();
          this.flowParseInterfaceish(node, true);
          return this.finishNode(node, "DeclareClass");
        }
        flowParseDeclareFunction(node) {
          this.next();
          const id = node.id = this.parseIdentifier();
          const typeNode = this.startNode();
          const typeContainer = this.startNode();
          if (this.match(47)) {
            typeNode.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            typeNode.typeParameters = null;
          }
          this.expect(10);
          const tmp = this.flowParseFunctionTypeParams();
          typeNode.params = tmp.params;
          typeNode.rest = tmp.rest;
          typeNode.this = tmp._this;
          this.expect(11);
          [typeNode.returnType, node.predicate] = this.flowParseTypeAndPredicateInitialiser();
          typeContainer.typeAnnotation = this.finishNode(typeNode, "FunctionTypeAnnotation");
          id.typeAnnotation = this.finishNode(typeContainer, "TypeAnnotation");
          this.resetEndLocation(id);
          this.semicolon();
          this.scope.declareName(node.id.name, BIND_FLOW_DECLARE_FN, node.id.loc.start);
          return this.finishNode(node, "DeclareFunction");
        }
        flowParseDeclare(node, insideModule) {
          if (this.match(80)) {
            return this.flowParseDeclareClass(node);
          } else if (this.match(68)) {
            return this.flowParseDeclareFunction(node);
          } else if (this.match(74)) {
            return this.flowParseDeclareVariable(node);
          } else if (this.eatContextual(125)) {
            if (this.match(16)) {
              return this.flowParseDeclareModuleExports(node);
            } else {
              if (insideModule) {
                this.raise(FlowErrors.NestedDeclareModule, {
                  at: this.state.lastTokStartLoc
                });
              }
              return this.flowParseDeclareModule(node);
            }
          } else if (this.isContextual(128)) {
            return this.flowParseDeclareTypeAlias(node);
          } else if (this.isContextual(129)) {
            return this.flowParseDeclareOpaqueType(node);
          } else if (this.isContextual(127)) {
            return this.flowParseDeclareInterface(node);
          } else if (this.match(82)) {
            return this.flowParseDeclareExportDeclaration(node, insideModule);
          } else {
            throw this.unexpected();
          }
        }
        flowParseDeclareVariable(node) {
          this.next();
          node.id = this.flowParseTypeAnnotatableIdentifier(true);
          this.scope.declareName(node.id.name, BIND_VAR, node.id.loc.start);
          this.semicolon();
          return this.finishNode(node, "DeclareVariable");
        }
        flowParseDeclareModule(node) {
          this.scope.enter(SCOPE_OTHER);
          if (this.match(131)) {
            node.id = super.parseExprAtom();
          } else {
            node.id = this.parseIdentifier();
          }
          const bodyNode = node.body = this.startNode();
          const body = bodyNode.body = [];
          this.expect(5);
          while (!this.match(8)) {
            let bodyNode2 = this.startNode();
            if (this.match(83)) {
              this.next();
              if (!this.isContextual(128) && !this.match(87)) {
                this.raise(FlowErrors.InvalidNonTypeImportInDeclareModule, {
                  at: this.state.lastTokStartLoc
                });
              }
              super.parseImport(bodyNode2);
            } else {
              this.expectContextual(123, FlowErrors.UnsupportedStatementInDeclareModule);
              bodyNode2 = this.flowParseDeclare(bodyNode2, true);
            }
            body.push(bodyNode2);
          }
          this.scope.exit();
          this.expect(8);
          this.finishNode(bodyNode, "BlockStatement");
          let kind = null;
          let hasModuleExport = false;
          body.forEach((bodyElement) => {
            if (isEsModuleType(bodyElement)) {
              if (kind === "CommonJS") {
                this.raise(FlowErrors.AmbiguousDeclareModuleKind, {
                  at: bodyElement
                });
              }
              kind = "ES";
            } else if (bodyElement.type === "DeclareModuleExports") {
              if (hasModuleExport) {
                this.raise(FlowErrors.DuplicateDeclareModuleExports, {
                  at: bodyElement
                });
              }
              if (kind === "ES") {
                this.raise(FlowErrors.AmbiguousDeclareModuleKind, {
                  at: bodyElement
                });
              }
              kind = "CommonJS";
              hasModuleExport = true;
            }
          });
          node.kind = kind || "CommonJS";
          return this.finishNode(node, "DeclareModule");
        }
        flowParseDeclareExportDeclaration(node, insideModule) {
          this.expect(82);
          if (this.eat(65)) {
            if (this.match(68) || this.match(80)) {
              node.declaration = this.flowParseDeclare(this.startNode());
            } else {
              node.declaration = this.flowParseType();
              this.semicolon();
            }
            node.default = true;
            return this.finishNode(node, "DeclareExportDeclaration");
          } else {
            if (this.match(75) || this.isLet() || (this.isContextual(128) || this.isContextual(127)) && !insideModule) {
              const label = this.state.value;
              throw this.raise(FlowErrors.UnsupportedDeclareExportKind, {
                at: this.state.startLoc,
                unsupportedExportKind: label,
                suggestion: exportSuggestions[label]
              });
            }
            if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(129)) {
              node.declaration = this.flowParseDeclare(this.startNode());
              node.default = false;
              return this.finishNode(node, "DeclareExportDeclaration");
            } else if (this.match(55) || this.match(5) || this.isContextual(127) || this.isContextual(128) || this.isContextual(129)) {
              node = this.parseExport(node, null);
              if (node.type === "ExportNamedDeclaration") {
                node.type = "ExportDeclaration";
                node.default = false;
                delete node.exportKind;
              }
              node.type = "Declare" + node.type;
              return node;
            }
          }
          throw this.unexpected();
        }
        flowParseDeclareModuleExports(node) {
          this.next();
          this.expectContextual(109);
          node.typeAnnotation = this.flowParseTypeAnnotation();
          this.semicolon();
          return this.finishNode(node, "DeclareModuleExports");
        }
        flowParseDeclareTypeAlias(node) {
          this.next();
          const finished = this.flowParseTypeAlias(node);
          finished.type = "DeclareTypeAlias";
          return finished;
        }
        flowParseDeclareOpaqueType(node) {
          this.next();
          const finished = this.flowParseOpaqueType(node, true);
          finished.type = "DeclareOpaqueType";
          return finished;
        }
        flowParseDeclareInterface(node) {
          this.next();
          this.flowParseInterfaceish(node);
          return this.finishNode(node, "DeclareInterface");
        }
        flowParseInterfaceish(node, isClass = false) {
          node.id = this.flowParseRestrictedIdentifier(!isClass, true);
          this.scope.declareName(node.id.name, isClass ? BIND_FUNCTION : BIND_LEXICAL, node.id.loc.start);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            node.typeParameters = null;
          }
          node.extends = [];
          node.implements = [];
          node.mixins = [];
          if (this.eat(81)) {
            do {
              node.extends.push(this.flowParseInterfaceExtends());
            } while (!isClass && this.eat(12));
          }
          if (this.isContextual(115)) {
            this.next();
            do {
              node.mixins.push(this.flowParseInterfaceExtends());
            } while (this.eat(12));
          }
          if (this.isContextual(111)) {
            this.next();
            do {
              node.implements.push(this.flowParseInterfaceExtends());
            } while (this.eat(12));
          }
          node.body = this.flowParseObjectType({
            allowStatic: isClass,
            allowExact: false,
            allowSpread: false,
            allowProto: isClass,
            allowInexact: false
          });
        }
        flowParseInterfaceExtends() {
          const node = this.startNode();
          node.id = this.flowParseQualifiedTypeIdentifier();
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterInstantiation();
          } else {
            node.typeParameters = null;
          }
          return this.finishNode(node, "InterfaceExtends");
        }
        flowParseInterface(node) {
          this.flowParseInterfaceish(node);
          return this.finishNode(node, "InterfaceDeclaration");
        }
        checkNotUnderscore(word) {
          if (word === "_") {
            this.raise(FlowErrors.UnexpectedReservedUnderscore, {
              at: this.state.startLoc
            });
          }
        }
        checkReservedType(word, startLoc, declaration) {
          if (!reservedTypes.has(word))
            return;
          this.raise(declaration ? FlowErrors.AssignReservedType : FlowErrors.UnexpectedReservedType, {
            at: startLoc,
            reservedType: word
          });
        }
        flowParseRestrictedIdentifier(liberal, declaration) {
          this.checkReservedType(this.state.value, this.state.startLoc, declaration);
          return this.parseIdentifier(liberal);
        }
        flowParseTypeAlias(node) {
          node.id = this.flowParseRestrictedIdentifier(false, true);
          this.scope.declareName(node.id.name, BIND_LEXICAL, node.id.loc.start);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            node.typeParameters = null;
          }
          node.right = this.flowParseTypeInitialiser(29);
          this.semicolon();
          return this.finishNode(node, "TypeAlias");
        }
        flowParseOpaqueType(node, declare) {
          this.expectContextual(128);
          node.id = this.flowParseRestrictedIdentifier(true, true);
          this.scope.declareName(node.id.name, BIND_LEXICAL, node.id.loc.start);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          } else {
            node.typeParameters = null;
          }
          node.supertype = null;
          if (this.match(14)) {
            node.supertype = this.flowParseTypeInitialiser(14);
          }
          node.impltype = null;
          if (!declare) {
            node.impltype = this.flowParseTypeInitialiser(29);
          }
          this.semicolon();
          return this.finishNode(node, "OpaqueType");
        }
        flowParseTypeParameter(requireDefault = false) {
          const nodeStartLoc = this.state.startLoc;
          const node = this.startNode();
          const variance = this.flowParseVariance();
          const ident = this.flowParseTypeAnnotatableIdentifier();
          node.name = ident.name;
          node.variance = variance;
          node.bound = ident.typeAnnotation;
          if (this.match(29)) {
            this.eat(29);
            node.default = this.flowParseType();
          } else {
            if (requireDefault) {
              this.raise(FlowErrors.MissingTypeParamDefault, {
                at: nodeStartLoc
              });
            }
          }
          return this.finishNode(node, "TypeParameter");
        }
        flowParseTypeParameterDeclaration() {
          const oldInType = this.state.inType;
          const node = this.startNode();
          node.params = [];
          this.state.inType = true;
          if (this.match(47) || this.match(140)) {
            this.next();
          } else {
            this.unexpected();
          }
          let defaultRequired = false;
          do {
            const typeParameter = this.flowParseTypeParameter(defaultRequired);
            node.params.push(typeParameter);
            if (typeParameter.default) {
              defaultRequired = true;
            }
            if (!this.match(48)) {
              this.expect(12);
            }
          } while (!this.match(48));
          this.expect(48);
          this.state.inType = oldInType;
          return this.finishNode(node, "TypeParameterDeclaration");
        }
        flowParseTypeParameterInstantiation() {
          const node = this.startNode();
          const oldInType = this.state.inType;
          node.params = [];
          this.state.inType = true;
          this.expect(47);
          const oldNoAnonFunctionType = this.state.noAnonFunctionType;
          this.state.noAnonFunctionType = false;
          while (!this.match(48)) {
            node.params.push(this.flowParseType());
            if (!this.match(48)) {
              this.expect(12);
            }
          }
          this.state.noAnonFunctionType = oldNoAnonFunctionType;
          this.expect(48);
          this.state.inType = oldInType;
          return this.finishNode(node, "TypeParameterInstantiation");
        }
        flowParseTypeParameterInstantiationCallOrNew() {
          const node = this.startNode();
          const oldInType = this.state.inType;
          node.params = [];
          this.state.inType = true;
          this.expect(47);
          while (!this.match(48)) {
            node.params.push(this.flowParseTypeOrImplicitInstantiation());
            if (!this.match(48)) {
              this.expect(12);
            }
          }
          this.expect(48);
          this.state.inType = oldInType;
          return this.finishNode(node, "TypeParameterInstantiation");
        }
        flowParseInterfaceType() {
          const node = this.startNode();
          this.expectContextual(127);
          node.extends = [];
          if (this.eat(81)) {
            do {
              node.extends.push(this.flowParseInterfaceExtends());
            } while (this.eat(12));
          }
          node.body = this.flowParseObjectType({
            allowStatic: false,
            allowExact: false,
            allowSpread: false,
            allowProto: false,
            allowInexact: false
          });
          return this.finishNode(node, "InterfaceTypeAnnotation");
        }
        flowParseObjectPropertyKey() {
          return this.match(132) || this.match(131) ? super.parseExprAtom() : this.parseIdentifier(true);
        }
        flowParseObjectTypeIndexer(node, isStatic, variance) {
          node.static = isStatic;
          if (this.lookahead().type === 14) {
            node.id = this.flowParseObjectPropertyKey();
            node.key = this.flowParseTypeInitialiser();
          } else {
            node.id = null;
            node.key = this.flowParseType();
          }
          this.expect(3);
          node.value = this.flowParseTypeInitialiser();
          node.variance = variance;
          return this.finishNode(node, "ObjectTypeIndexer");
        }
        flowParseObjectTypeInternalSlot(node, isStatic) {
          node.static = isStatic;
          node.id = this.flowParseObjectPropertyKey();
          this.expect(3);
          this.expect(3);
          if (this.match(47) || this.match(10)) {
            node.method = true;
            node.optional = false;
            node.value = this.flowParseObjectTypeMethodish(this.startNodeAt(node.loc.start));
          } else {
            node.method = false;
            if (this.eat(17)) {
              node.optional = true;
            }
            node.value = this.flowParseTypeInitialiser();
          }
          return this.finishNode(node, "ObjectTypeInternalSlot");
        }
        flowParseObjectTypeMethodish(node) {
          node.params = [];
          node.rest = null;
          node.typeParameters = null;
          node.this = null;
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          this.expect(10);
          if (this.match(78)) {
            node.this = this.flowParseFunctionTypeParam(true);
            node.this.name = null;
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          while (!this.match(11) && !this.match(21)) {
            node.params.push(this.flowParseFunctionTypeParam(false));
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          if (this.eat(21)) {
            node.rest = this.flowParseFunctionTypeParam(false);
          }
          this.expect(11);
          node.returnType = this.flowParseTypeInitialiser();
          return this.finishNode(node, "FunctionTypeAnnotation");
        }
        flowParseObjectTypeCallProperty(node, isStatic) {
          const valueNode = this.startNode();
          node.static = isStatic;
          node.value = this.flowParseObjectTypeMethodish(valueNode);
          return this.finishNode(node, "ObjectTypeCallProperty");
        }
        flowParseObjectType({
          allowStatic,
          allowExact,
          allowSpread,
          allowProto,
          allowInexact
        }) {
          const oldInType = this.state.inType;
          this.state.inType = true;
          const nodeStart = this.startNode();
          nodeStart.callProperties = [];
          nodeStart.properties = [];
          nodeStart.indexers = [];
          nodeStart.internalSlots = [];
          let endDelim;
          let exact;
          let inexact = false;
          if (allowExact && this.match(6)) {
            this.expect(6);
            endDelim = 9;
            exact = true;
          } else {
            this.expect(5);
            endDelim = 8;
            exact = false;
          }
          nodeStart.exact = exact;
          while (!this.match(endDelim)) {
            let isStatic = false;
            let protoStartLoc = null;
            let inexactStartLoc = null;
            const node = this.startNode();
            if (allowProto && this.isContextual(116)) {
              const lookahead = this.lookahead();
              if (lookahead.type !== 14 && lookahead.type !== 17) {
                this.next();
                protoStartLoc = this.state.startLoc;
                allowStatic = false;
              }
            }
            if (allowStatic && this.isContextual(104)) {
              const lookahead = this.lookahead();
              if (lookahead.type !== 14 && lookahead.type !== 17) {
                this.next();
                isStatic = true;
              }
            }
            const variance = this.flowParseVariance();
            if (this.eat(0)) {
              if (protoStartLoc != null) {
                this.unexpected(protoStartLoc);
              }
              if (this.eat(0)) {
                if (variance) {
                  this.unexpected(variance.loc.start);
                }
                nodeStart.internalSlots.push(this.flowParseObjectTypeInternalSlot(node, isStatic));
              } else {
                nodeStart.indexers.push(this.flowParseObjectTypeIndexer(node, isStatic, variance));
              }
            } else if (this.match(10) || this.match(47)) {
              if (protoStartLoc != null) {
                this.unexpected(protoStartLoc);
              }
              if (variance) {
                this.unexpected(variance.loc.start);
              }
              nodeStart.callProperties.push(this.flowParseObjectTypeCallProperty(node, isStatic));
            } else {
              let kind = "init";
              if (this.isContextual(98) || this.isContextual(103)) {
                const lookahead = this.lookahead();
                if (tokenIsLiteralPropertyName(lookahead.type)) {
                  kind = this.state.value;
                  this.next();
                }
              }
              const propOrInexact = this.flowParseObjectTypeProperty(node, isStatic, protoStartLoc, variance, kind, allowSpread, allowInexact != null ? allowInexact : !exact);
              if (propOrInexact === null) {
                inexact = true;
                inexactStartLoc = this.state.lastTokStartLoc;
              } else {
                nodeStart.properties.push(propOrInexact);
              }
            }
            this.flowObjectTypeSemicolon();
            if (inexactStartLoc && !this.match(8) && !this.match(9)) {
              this.raise(FlowErrors.UnexpectedExplicitInexactInObject, {
                at: inexactStartLoc
              });
            }
          }
          this.expect(endDelim);
          if (allowSpread) {
            nodeStart.inexact = inexact;
          }
          const out = this.finishNode(nodeStart, "ObjectTypeAnnotation");
          this.state.inType = oldInType;
          return out;
        }
        flowParseObjectTypeProperty(node, isStatic, protoStartLoc, variance, kind, allowSpread, allowInexact) {
          if (this.eat(21)) {
            const isInexactToken = this.match(12) || this.match(13) || this.match(8) || this.match(9);
            if (isInexactToken) {
              if (!allowSpread) {
                this.raise(FlowErrors.InexactInsideNonObject, {
                  at: this.state.lastTokStartLoc
                });
              } else if (!allowInexact) {
                this.raise(FlowErrors.InexactInsideExact, {
                  at: this.state.lastTokStartLoc
                });
              }
              if (variance) {
                this.raise(FlowErrors.InexactVariance, {
                  at: variance
                });
              }
              return null;
            }
            if (!allowSpread) {
              this.raise(FlowErrors.UnexpectedSpreadType, {
                at: this.state.lastTokStartLoc
              });
            }
            if (protoStartLoc != null) {
              this.unexpected(protoStartLoc);
            }
            if (variance) {
              this.raise(FlowErrors.SpreadVariance, {
                at: variance
              });
            }
            node.argument = this.flowParseType();
            return this.finishNode(node, "ObjectTypeSpreadProperty");
          } else {
            node.key = this.flowParseObjectPropertyKey();
            node.static = isStatic;
            node.proto = protoStartLoc != null;
            node.kind = kind;
            let optional = false;
            if (this.match(47) || this.match(10)) {
              node.method = true;
              if (protoStartLoc != null) {
                this.unexpected(protoStartLoc);
              }
              if (variance) {
                this.unexpected(variance.loc.start);
              }
              node.value = this.flowParseObjectTypeMethodish(this.startNodeAt(node.loc.start));
              if (kind === "get" || kind === "set") {
                this.flowCheckGetterSetterParams(node);
              }
              if (!allowSpread && node.key.name === "constructor" && node.value.this) {
                this.raise(FlowErrors.ThisParamBannedInConstructor, {
                  at: node.value.this
                });
              }
            } else {
              if (kind !== "init")
                this.unexpected();
              node.method = false;
              if (this.eat(17)) {
                optional = true;
              }
              node.value = this.flowParseTypeInitialiser();
              node.variance = variance;
            }
            node.optional = optional;
            return this.finishNode(node, "ObjectTypeProperty");
          }
        }
        flowCheckGetterSetterParams(property2) {
          const paramCount = property2.kind === "get" ? 0 : 1;
          const length = property2.value.params.length + (property2.value.rest ? 1 : 0);
          if (property2.value.this) {
            this.raise(property2.kind === "get" ? FlowErrors.GetterMayNotHaveThisParam : FlowErrors.SetterMayNotHaveThisParam, {
              at: property2.value.this
            });
          }
          if (length !== paramCount) {
            this.raise(property2.kind === "get" ? Errors.BadGetterArity : Errors.BadSetterArity, {
              at: property2
            });
          }
          if (property2.kind === "set" && property2.value.rest) {
            this.raise(Errors.BadSetterRestParameter, {
              at: property2
            });
          }
        }
        flowObjectTypeSemicolon() {
          if (!this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9)) {
            this.unexpected();
          }
        }
        flowParseQualifiedTypeIdentifier(startLoc, id) {
          var _startLoc;
          (_startLoc = startLoc) != null ? _startLoc : startLoc = this.state.startLoc;
          let node = id || this.flowParseRestrictedIdentifier(true);
          while (this.eat(16)) {
            const node2 = this.startNodeAt(startLoc);
            node2.qualification = node;
            node2.id = this.flowParseRestrictedIdentifier(true);
            node = this.finishNode(node2, "QualifiedTypeIdentifier");
          }
          return node;
        }
        flowParseGenericType(startLoc, id) {
          const node = this.startNodeAt(startLoc);
          node.typeParameters = null;
          node.id = this.flowParseQualifiedTypeIdentifier(startLoc, id);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterInstantiation();
          }
          return this.finishNode(node, "GenericTypeAnnotation");
        }
        flowParseTypeofType() {
          const node = this.startNode();
          this.expect(87);
          node.argument = this.flowParsePrimaryType();
          return this.finishNode(node, "TypeofTypeAnnotation");
        }
        flowParseTupleType() {
          const node = this.startNode();
          node.types = [];
          this.expect(0);
          while (this.state.pos < this.length && !this.match(3)) {
            node.types.push(this.flowParseType());
            if (this.match(3))
              break;
            this.expect(12);
          }
          this.expect(3);
          return this.finishNode(node, "TupleTypeAnnotation");
        }
        flowParseFunctionTypeParam(first) {
          let name = null;
          let optional = false;
          let typeAnnotation = null;
          const node = this.startNode();
          const lh = this.lookahead();
          const isThis = this.state.type === 78;
          if (lh.type === 14 || lh.type === 17) {
            if (isThis && !first) {
              this.raise(FlowErrors.ThisParamMustBeFirst, {
                at: node
              });
            }
            name = this.parseIdentifier(isThis);
            if (this.eat(17)) {
              optional = true;
              if (isThis) {
                this.raise(FlowErrors.ThisParamMayNotBeOptional, {
                  at: node
                });
              }
            }
            typeAnnotation = this.flowParseTypeInitialiser();
          } else {
            typeAnnotation = this.flowParseType();
          }
          node.name = name;
          node.optional = optional;
          node.typeAnnotation = typeAnnotation;
          return this.finishNode(node, "FunctionTypeParam");
        }
        reinterpretTypeAsFunctionTypeParam(type) {
          const node = this.startNodeAt(type.loc.start);
          node.name = null;
          node.optional = false;
          node.typeAnnotation = type;
          return this.finishNode(node, "FunctionTypeParam");
        }
        flowParseFunctionTypeParams(params = []) {
          let rest2 = null;
          let _this = null;
          if (this.match(78)) {
            _this = this.flowParseFunctionTypeParam(true);
            _this.name = null;
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          while (!this.match(11) && !this.match(21)) {
            params.push(this.flowParseFunctionTypeParam(false));
            if (!this.match(11)) {
              this.expect(12);
            }
          }
          if (this.eat(21)) {
            rest2 = this.flowParseFunctionTypeParam(false);
          }
          return {
            params,
            rest: rest2,
            _this
          };
        }
        flowIdentToTypeAnnotation(startLoc, node, id) {
          switch (id.name) {
            case "any":
              return this.finishNode(node, "AnyTypeAnnotation");
            case "bool":
            case "boolean":
              return this.finishNode(node, "BooleanTypeAnnotation");
            case "mixed":
              return this.finishNode(node, "MixedTypeAnnotation");
            case "empty":
              return this.finishNode(node, "EmptyTypeAnnotation");
            case "number":
              return this.finishNode(node, "NumberTypeAnnotation");
            case "string":
              return this.finishNode(node, "StringTypeAnnotation");
            case "symbol":
              return this.finishNode(node, "SymbolTypeAnnotation");
            default:
              this.checkNotUnderscore(id.name);
              return this.flowParseGenericType(startLoc, id);
          }
        }
        flowParsePrimaryType() {
          const startLoc = this.state.startLoc;
          const node = this.startNode();
          let tmp;
          let type;
          let isGroupedType = false;
          const oldNoAnonFunctionType = this.state.noAnonFunctionType;
          switch (this.state.type) {
            case 5:
              return this.flowParseObjectType({
                allowStatic: false,
                allowExact: false,
                allowSpread: true,
                allowProto: false,
                allowInexact: true
              });
            case 6:
              return this.flowParseObjectType({
                allowStatic: false,
                allowExact: true,
                allowSpread: true,
                allowProto: false,
                allowInexact: false
              });
            case 0:
              this.state.noAnonFunctionType = false;
              type = this.flowParseTupleType();
              this.state.noAnonFunctionType = oldNoAnonFunctionType;
              return type;
            case 47:
              node.typeParameters = this.flowParseTypeParameterDeclaration();
              this.expect(10);
              tmp = this.flowParseFunctionTypeParams();
              node.params = tmp.params;
              node.rest = tmp.rest;
              node.this = tmp._this;
              this.expect(11);
              this.expect(19);
              node.returnType = this.flowParseType();
              return this.finishNode(node, "FunctionTypeAnnotation");
            case 10:
              this.next();
              if (!this.match(11) && !this.match(21)) {
                if (tokenIsIdentifier(this.state.type) || this.match(78)) {
                  const token = this.lookahead().type;
                  isGroupedType = token !== 17 && token !== 14;
                } else {
                  isGroupedType = true;
                }
              }
              if (isGroupedType) {
                this.state.noAnonFunctionType = false;
                type = this.flowParseType();
                this.state.noAnonFunctionType = oldNoAnonFunctionType;
                if (this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19)) {
                  this.expect(11);
                  return type;
                } else {
                  this.eat(12);
                }
              }
              if (type) {
                tmp = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(type)]);
              } else {
                tmp = this.flowParseFunctionTypeParams();
              }
              node.params = tmp.params;
              node.rest = tmp.rest;
              node.this = tmp._this;
              this.expect(11);
              this.expect(19);
              node.returnType = this.flowParseType();
              node.typeParameters = null;
              return this.finishNode(node, "FunctionTypeAnnotation");
            case 131:
              return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
            case 85:
            case 86:
              node.value = this.match(85);
              this.next();
              return this.finishNode(node, "BooleanLiteralTypeAnnotation");
            case 53:
              if (this.state.value === "-") {
                this.next();
                if (this.match(132)) {
                  return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", node);
                }
                if (this.match(133)) {
                  return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", node);
                }
                throw this.raise(FlowErrors.UnexpectedSubtractionOperand, {
                  at: this.state.startLoc
                });
              }
              throw this.unexpected();
            case 132:
              return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
            case 133:
              return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
            case 88:
              this.next();
              return this.finishNode(node, "VoidTypeAnnotation");
            case 84:
              this.next();
              return this.finishNode(node, "NullLiteralTypeAnnotation");
            case 78:
              this.next();
              return this.finishNode(node, "ThisTypeAnnotation");
            case 55:
              this.next();
              return this.finishNode(node, "ExistsTypeAnnotation");
            case 87:
              return this.flowParseTypeofType();
            default:
              if (tokenIsKeyword(this.state.type)) {
                const label = tokenLabelName(this.state.type);
                this.next();
                return super.createIdentifier(node, label);
              } else if (tokenIsIdentifier(this.state.type)) {
                if (this.isContextual(127)) {
                  return this.flowParseInterfaceType();
                }
                return this.flowIdentToTypeAnnotation(startLoc, node, this.parseIdentifier());
              }
          }
          throw this.unexpected();
        }
        flowParsePostfixType() {
          const startLoc = this.state.startLoc;
          let type = this.flowParsePrimaryType();
          let seenOptionalIndexedAccess = false;
          while ((this.match(0) || this.match(18)) && !this.canInsertSemicolon()) {
            const node = this.startNodeAt(startLoc);
            const optional = this.eat(18);
            seenOptionalIndexedAccess = seenOptionalIndexedAccess || optional;
            this.expect(0);
            if (!optional && this.match(3)) {
              node.elementType = type;
              this.next();
              type = this.finishNode(node, "ArrayTypeAnnotation");
            } else {
              node.objectType = type;
              node.indexType = this.flowParseType();
              this.expect(3);
              if (seenOptionalIndexedAccess) {
                node.optional = optional;
                type = this.finishNode(
                  node,
                  "OptionalIndexedAccessType"
                );
              } else {
                type = this.finishNode(
                  node,
                  "IndexedAccessType"
                );
              }
            }
          }
          return type;
        }
        flowParsePrefixType() {
          const node = this.startNode();
          if (this.eat(17)) {
            node.typeAnnotation = this.flowParsePrefixType();
            return this.finishNode(node, "NullableTypeAnnotation");
          } else {
            return this.flowParsePostfixType();
          }
        }
        flowParseAnonFunctionWithoutParens() {
          const param = this.flowParsePrefixType();
          if (!this.state.noAnonFunctionType && this.eat(19)) {
            const node = this.startNodeAt(param.loc.start);
            node.params = [this.reinterpretTypeAsFunctionTypeParam(param)];
            node.rest = null;
            node.this = null;
            node.returnType = this.flowParseType();
            node.typeParameters = null;
            return this.finishNode(node, "FunctionTypeAnnotation");
          }
          return param;
        }
        flowParseIntersectionType() {
          const node = this.startNode();
          this.eat(45);
          const type = this.flowParseAnonFunctionWithoutParens();
          node.types = [type];
          while (this.eat(45)) {
            node.types.push(this.flowParseAnonFunctionWithoutParens());
          }
          return node.types.length === 1 ? type : this.finishNode(node, "IntersectionTypeAnnotation");
        }
        flowParseUnionType() {
          const node = this.startNode();
          this.eat(43);
          const type = this.flowParseIntersectionType();
          node.types = [type];
          while (this.eat(43)) {
            node.types.push(this.flowParseIntersectionType());
          }
          return node.types.length === 1 ? type : this.finishNode(node, "UnionTypeAnnotation");
        }
        flowParseType() {
          const oldInType = this.state.inType;
          this.state.inType = true;
          const type = this.flowParseUnionType();
          this.state.inType = oldInType;
          return type;
        }
        flowParseTypeOrImplicitInstantiation() {
          if (this.state.type === 130 && this.state.value === "_") {
            const startLoc = this.state.startLoc;
            const node = this.parseIdentifier();
            return this.flowParseGenericType(startLoc, node);
          } else {
            return this.flowParseType();
          }
        }
        flowParseTypeAnnotation() {
          const node = this.startNode();
          node.typeAnnotation = this.flowParseTypeInitialiser();
          return this.finishNode(node, "TypeAnnotation");
        }
        flowParseTypeAnnotatableIdentifier(allowPrimitiveOverride) {
          const ident = allowPrimitiveOverride ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
          if (this.match(14)) {
            ident.typeAnnotation = this.flowParseTypeAnnotation();
            this.resetEndLocation(ident);
          }
          return ident;
        }
        typeCastToParameter(node) {
          node.expression.typeAnnotation = node.typeAnnotation;
          this.resetEndLocation(node.expression, node.typeAnnotation.loc.end);
          return node.expression;
        }
        flowParseVariance() {
          let variance = null;
          if (this.match(53)) {
            variance = this.startNode();
            if (this.state.value === "+") {
              variance.kind = "plus";
            } else {
              variance.kind = "minus";
            }
            this.next();
            return this.finishNode(variance, "Variance");
          }
          return variance;
        }
        parseFunctionBody(node, allowExpressionBody, isMethod = false) {
          if (allowExpressionBody) {
            return this.forwardNoArrowParamsConversionAt(node, () => super.parseFunctionBody(node, true, isMethod));
          }
          return super.parseFunctionBody(node, false, isMethod);
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
          if (this.match(14)) {
            const typeNode = this.startNode();
            [
              typeNode.typeAnnotation,
              node.predicate
            ] = this.flowParseTypeAndPredicateInitialiser();
            node.returnType = typeNode.typeAnnotation ? this.finishNode(typeNode, "TypeAnnotation") : null;
          }
          return super.parseFunctionBodyAndFinish(node, type, isMethod);
        }
        parseStatement(context, topLevel) {
          if (this.state.strict && this.isContextual(127)) {
            const lookahead = this.lookahead();
            if (tokenIsKeywordOrIdentifier(lookahead.type)) {
              const node = this.startNode();
              this.next();
              return this.flowParseInterface(node);
            }
          } else if (this.shouldParseEnums() && this.isContextual(124)) {
            const node = this.startNode();
            this.next();
            return this.flowParseEnumDeclaration(node);
          }
          const stmt = super.parseStatement(context, topLevel);
          if (this.flowPragma === void 0 && !this.isValidDirective(stmt)) {
            this.flowPragma = null;
          }
          return stmt;
        }
        parseExpressionStatement(node, expr, decorators) {
          if (expr.type === "Identifier") {
            if (expr.name === "declare") {
              if (this.match(80) || tokenIsIdentifier(this.state.type) || this.match(68) || this.match(74) || this.match(82)) {
                return this.flowParseDeclare(node);
              }
            } else if (tokenIsIdentifier(this.state.type)) {
              if (expr.name === "interface") {
                return this.flowParseInterface(node);
              } else if (expr.name === "type") {
                return this.flowParseTypeAlias(node);
              } else if (expr.name === "opaque") {
                return this.flowParseOpaqueType(node, false);
              }
            }
          }
          return super.parseExpressionStatement(node, expr, decorators);
        }
        shouldParseExportDeclaration() {
          const {
            type
          } = this.state;
          if (tokenIsFlowInterfaceOrTypeOrOpaque(type) || this.shouldParseEnums() && type === 124) {
            return !this.state.containsEsc;
          }
          return super.shouldParseExportDeclaration();
        }
        isExportDefaultSpecifier() {
          const {
            type
          } = this.state;
          if (tokenIsFlowInterfaceOrTypeOrOpaque(type) || this.shouldParseEnums() && type === 124) {
            return this.state.containsEsc;
          }
          return super.isExportDefaultSpecifier();
        }
        parseExportDefaultExpression() {
          if (this.shouldParseEnums() && this.isContextual(124)) {
            const node = this.startNode();
            this.next();
            return this.flowParseEnumDeclaration(node);
          }
          return super.parseExportDefaultExpression();
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
          if (!this.match(17))
            return expr;
          if (this.state.maybeInArrowParameters) {
            const nextCh = this.lookaheadCharCode();
            if (nextCh === 44 || nextCh === 61 || nextCh === 58 || nextCh === 41) {
              this.setOptionalParametersError(refExpressionErrors);
              return expr;
            }
          }
          this.expect(17);
          const state = this.state.clone();
          const originalNoArrowAt = this.state.noArrowAt;
          const node = this.startNodeAt(startLoc);
          let {
            consequent,
            failed
          } = this.tryParseConditionalConsequent();
          let [valid, invalid] = this.getArrowLikeExpressions(consequent);
          if (failed || invalid.length > 0) {
            const noArrowAt = [...originalNoArrowAt];
            if (invalid.length > 0) {
              this.state = state;
              this.state.noArrowAt = noArrowAt;
              for (let i = 0; i < invalid.length; i++) {
                noArrowAt.push(invalid[i].start);
              }
              ({
                consequent,
                failed
              } = this.tryParseConditionalConsequent());
              [valid, invalid] = this.getArrowLikeExpressions(consequent);
            }
            if (failed && valid.length > 1) {
              this.raise(FlowErrors.AmbiguousConditionalArrow, {
                at: state.startLoc
              });
            }
            if (failed && valid.length === 1) {
              this.state = state;
              noArrowAt.push(valid[0].start);
              this.state.noArrowAt = noArrowAt;
              ({
                consequent,
                failed
              } = this.tryParseConditionalConsequent());
            }
          }
          this.getArrowLikeExpressions(consequent, true);
          this.state.noArrowAt = originalNoArrowAt;
          this.expect(14);
          node.test = expr;
          node.consequent = consequent;
          node.alternate = this.forwardNoArrowParamsConversionAt(node, () => this.parseMaybeAssign(void 0, void 0));
          return this.finishNode(node, "ConditionalExpression");
        }
        tryParseConditionalConsequent() {
          this.state.noArrowParamsConversionAt.push(this.state.start);
          const consequent = this.parseMaybeAssignAllowIn();
          const failed = !this.match(14);
          this.state.noArrowParamsConversionAt.pop();
          return {
            consequent,
            failed
          };
        }
        getArrowLikeExpressions(node, disallowInvalid) {
          const stack = [node];
          const arrows = [];
          while (stack.length !== 0) {
            const node2 = stack.pop();
            if (node2.type === "ArrowFunctionExpression") {
              if (node2.typeParameters || !node2.returnType) {
                this.finishArrowValidation(node2);
              } else {
                arrows.push(node2);
              }
              stack.push(node2.body);
            } else if (node2.type === "ConditionalExpression") {
              stack.push(node2.consequent);
              stack.push(node2.alternate);
            }
          }
          if (disallowInvalid) {
            arrows.forEach((node2) => this.finishArrowValidation(node2));
            return [arrows, []];
          }
          return partition2(arrows, (node2) => node2.params.every((param) => this.isAssignable(param, true)));
        }
        finishArrowValidation(node) {
          var _node$extra;
          this.toAssignableList(
            node.params,
            (_node$extra = node.extra) == null ? void 0 : _node$extra.trailingCommaLoc,
            false
          );
          this.scope.enter(SCOPE_FUNCTION | SCOPE_ARROW);
          super.checkParams(node, false, true);
          this.scope.exit();
        }
        forwardNoArrowParamsConversionAt(node, parse4) {
          let result2;
          if (this.state.noArrowParamsConversionAt.indexOf(node.start) !== -1) {
            this.state.noArrowParamsConversionAt.push(this.state.start);
            result2 = parse4();
            this.state.noArrowParamsConversionAt.pop();
          } else {
            result2 = parse4();
          }
          return result2;
        }
        parseParenItem(node, startLoc) {
          node = super.parseParenItem(node, startLoc);
          if (this.eat(17)) {
            node.optional = true;
            this.resetEndLocation(node);
          }
          if (this.match(14)) {
            const typeCastNode = this.startNodeAt(startLoc);
            typeCastNode.expression = node;
            typeCastNode.typeAnnotation = this.flowParseTypeAnnotation();
            return this.finishNode(typeCastNode, "TypeCastExpression");
          }
          return node;
        }
        assertModuleNodeAllowed(node) {
          if (node.type === "ImportDeclaration" && (node.importKind === "type" || node.importKind === "typeof") || node.type === "ExportNamedDeclaration" && node.exportKind === "type" || node.type === "ExportAllDeclaration" && node.exportKind === "type") {
            return;
          }
          super.assertModuleNodeAllowed(node);
        }
        parseExport(node, decorators) {
          const decl = super.parseExport(node, decorators);
          if (decl.type === "ExportNamedDeclaration" || decl.type === "ExportAllDeclaration") {
            decl.exportKind = decl.exportKind || "value";
          }
          return decl;
        }
        parseExportDeclaration(node) {
          if (this.isContextual(128)) {
            node.exportKind = "type";
            const declarationNode = this.startNode();
            this.next();
            if (this.match(5)) {
              node.specifiers = this.parseExportSpecifiers(true);
              super.parseExportFrom(node);
              return null;
            } else {
              return this.flowParseTypeAlias(declarationNode);
            }
          } else if (this.isContextual(129)) {
            node.exportKind = "type";
            const declarationNode = this.startNode();
            this.next();
            return this.flowParseOpaqueType(declarationNode, false);
          } else if (this.isContextual(127)) {
            node.exportKind = "type";
            const declarationNode = this.startNode();
            this.next();
            return this.flowParseInterface(declarationNode);
          } else if (this.shouldParseEnums() && this.isContextual(124)) {
            node.exportKind = "value";
            const declarationNode = this.startNode();
            this.next();
            return this.flowParseEnumDeclaration(declarationNode);
          } else {
            return super.parseExportDeclaration(node);
          }
        }
        eatExportStar(node) {
          if (super.eatExportStar(node))
            return true;
          if (this.isContextual(128) && this.lookahead().type === 55) {
            node.exportKind = "type";
            this.next();
            this.next();
            return true;
          }
          return false;
        }
        maybeParseExportNamespaceSpecifier(node) {
          const {
            startLoc
          } = this.state;
          const hasNamespace = super.maybeParseExportNamespaceSpecifier(node);
          if (hasNamespace && node.exportKind === "type") {
            this.unexpected(startLoc);
          }
          return hasNamespace;
        }
        parseClassId(node, isStatement, optionalId) {
          super.parseClassId(node, isStatement, optionalId);
          if (this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          }
        }
        parseClassMember(classBody, member, state) {
          const {
            startLoc
          } = this.state;
          if (this.isContextual(123)) {
            if (super.parseClassMemberFromModifier(classBody, member)) {
              return;
            }
            member.declare = true;
          }
          super.parseClassMember(classBody, member, state);
          if (member.declare) {
            if (member.type !== "ClassProperty" && member.type !== "ClassPrivateProperty" && member.type !== "PropertyDefinition") {
              this.raise(FlowErrors.DeclareClassElement, {
                at: startLoc
              });
            } else if (member.value) {
              this.raise(FlowErrors.DeclareClassFieldInitializer, {
                at: member.value
              });
            }
          }
        }
        isIterator(word) {
          return word === "iterator" || word === "asyncIterator";
        }
        readIterator() {
          const word = super.readWord1();
          const fullWord = "@@" + word;
          if (!this.isIterator(word) || !this.state.inType) {
            this.raise(Errors.InvalidIdentifier, {
              at: this.state.curPosition(),
              identifierName: fullWord
            });
          }
          this.finishToken(130, fullWord);
        }
        getTokenFromCode(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (code === 123 && next === 124) {
            return this.finishOp(6, 2);
          } else if (this.state.inType && (code === 62 || code === 60)) {
            return this.finishOp(code === 62 ? 48 : 47, 1);
          } else if (this.state.inType && code === 63) {
            if (next === 46) {
              return this.finishOp(18, 2);
            }
            return this.finishOp(17, 1);
          } else if (isIteratorStart(code, next, this.input.charCodeAt(this.state.pos + 2))) {
            this.state.pos += 2;
            return this.readIterator();
          } else {
            return super.getTokenFromCode(code);
          }
        }
        isAssignable(node, isBinding) {
          if (node.type === "TypeCastExpression") {
            return this.isAssignable(node.expression, isBinding);
          } else {
            return super.isAssignable(node, isBinding);
          }
        }
        toAssignable(node, isLHS = false) {
          if (!isLHS && node.type === "AssignmentExpression" && node.left.type === "TypeCastExpression") {
            node.left = this.typeCastToParameter(node.left);
          }
          super.toAssignable(node, isLHS);
        }
        toAssignableList(exprList, trailingCommaLoc, isLHS) {
          for (let i = 0; i < exprList.length; i++) {
            const expr = exprList[i];
            if ((expr == null ? void 0 : expr.type) === "TypeCastExpression") {
              exprList[i] = this.typeCastToParameter(expr);
            }
          }
          super.toAssignableList(exprList, trailingCommaLoc, isLHS);
        }
        toReferencedList(exprList, isParenthesizedExpr) {
          for (let i = 0; i < exprList.length; i++) {
            var _expr$extra;
            const expr = exprList[i];
            if (expr && expr.type === "TypeCastExpression" && !((_expr$extra = expr.extra) != null && _expr$extra.parenthesized) && (exprList.length > 1 || !isParenthesizedExpr)) {
              this.raise(FlowErrors.TypeCastInPattern, {
                at: expr.typeAnnotation
              });
            }
          }
          return exprList;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
          const node = super.parseArrayLike(close, canBePattern, isTuple, refExpressionErrors);
          if (canBePattern && !this.state.maybeInArrowParameters) {
            this.toReferencedList(node.elements);
          }
          return node;
        }
        isValidLVal(type, isParenthesized, binding) {
          return type === "TypeCastExpression" || super.isValidLVal(type, isParenthesized, binding);
        }
        parseClassProperty(node) {
          if (this.match(14)) {
            node.typeAnnotation = this.flowParseTypeAnnotation();
          }
          return super.parseClassProperty(node);
        }
        parseClassPrivateProperty(node) {
          if (this.match(14)) {
            node.typeAnnotation = this.flowParseTypeAnnotation();
          }
          return super.parseClassPrivateProperty(node);
        }
        isClassMethod() {
          return this.match(47) || super.isClassMethod();
        }
        isClassProperty() {
          return this.match(14) || super.isClassProperty();
        }
        isNonstaticConstructor(method2) {
          return !this.match(14) && super.isNonstaticConstructor(method2);
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          if (method2.variance) {
            this.unexpected(method2.variance.loc.start);
          }
          delete method2.variance;
          if (this.match(47)) {
            method2.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          super.pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper);
          if (method2.params && isConstructor) {
            const params = method2.params;
            if (params.length > 0 && this.isThisParam(params[0])) {
              this.raise(FlowErrors.ThisParamBannedInConstructor, {
                at: method2
              });
            }
          } else if (method2.type === "MethodDefinition" && isConstructor && method2.value.params) {
            const params = method2.value.params;
            if (params.length > 0 && this.isThisParam(params[0])) {
              this.raise(FlowErrors.ThisParamBannedInConstructor, {
                at: method2
              });
            }
          }
        }
        pushClassPrivateMethod(classBody, method2, isGenerator, isAsync) {
          if (method2.variance) {
            this.unexpected(method2.variance.loc.start);
          }
          delete method2.variance;
          if (this.match(47)) {
            method2.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          super.pushClassPrivateMethod(classBody, method2, isGenerator, isAsync);
        }
        parseClassSuper(node) {
          super.parseClassSuper(node);
          if (node.superClass && this.match(47)) {
            node.superTypeParameters = this.flowParseTypeParameterInstantiation();
          }
          if (this.isContextual(111)) {
            this.next();
            const implemented = node.implements = [];
            do {
              const node2 = this.startNode();
              node2.id = this.flowParseRestrictedIdentifier(true);
              if (this.match(47)) {
                node2.typeParameters = this.flowParseTypeParameterInstantiation();
              } else {
                node2.typeParameters = null;
              }
              implemented.push(this.finishNode(node2, "ClassImplements"));
            } while (this.eat(12));
          }
        }
        checkGetterSetterParams(method2) {
          super.checkGetterSetterParams(method2);
          const params = this.getObjectOrClassMethodParams(method2);
          if (params.length > 0) {
            const param = params[0];
            if (this.isThisParam(param) && method2.kind === "get") {
              this.raise(FlowErrors.GetterMayNotHaveThisParam, {
                at: param
              });
            } else if (this.isThisParam(param)) {
              this.raise(FlowErrors.SetterMayNotHaveThisParam, {
                at: param
              });
            }
          }
        }
        parsePropertyNamePrefixOperator(node) {
          node.variance = this.flowParseVariance();
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
          if (prop.variance) {
            this.unexpected(prop.variance.loc.start);
          }
          delete prop.variance;
          let typeParameters;
          if (this.match(47) && !isAccessor) {
            typeParameters = this.flowParseTypeParameterDeclaration();
            if (!this.match(10))
              this.unexpected();
          }
          const result2 = super.parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors);
          if (typeParameters) {
            (result2.value || result2).typeParameters = typeParameters;
          }
          return result2;
        }
        parseAssignableListItemTypes(param) {
          if (this.eat(17)) {
            if (param.type !== "Identifier") {
              this.raise(FlowErrors.PatternIsOptional, {
                at: param
              });
            }
            if (this.isThisParam(param)) {
              this.raise(FlowErrors.ThisParamMayNotBeOptional, {
                at: param
              });
            }
            param.optional = true;
          }
          if (this.match(14)) {
            param.typeAnnotation = this.flowParseTypeAnnotation();
          } else if (this.isThisParam(param)) {
            this.raise(FlowErrors.ThisParamAnnotationRequired, {
              at: param
            });
          }
          if (this.match(29) && this.isThisParam(param)) {
            this.raise(FlowErrors.ThisParamNoDefault, {
              at: param
            });
          }
          this.resetEndLocation(param);
          return param;
        }
        parseMaybeDefault(startLoc, left) {
          const node = super.parseMaybeDefault(startLoc, left);
          if (node.type === "AssignmentPattern" && node.typeAnnotation && node.right.start < node.typeAnnotation.start) {
            this.raise(FlowErrors.TypeBeforeInitializer, {
              at: node.typeAnnotation
            });
          }
          return node;
        }
        shouldParseDefaultImport(node) {
          if (!hasTypeImportKind(node)) {
            return super.shouldParseDefaultImport(node);
          }
          return isMaybeDefaultImport(this.state.type);
        }
        checkImportReflection(node) {
          super.checkImportReflection(node);
          if (node.module && node.importKind !== "value") {
            this.raise(FlowErrors.ImportReflectionHasImportType, {
              at: node.specifiers[0].loc.start
            });
          }
        }
        parseImportSpecifierLocal(node, specifier, type) {
          specifier.local = hasTypeImportKind(node) ? this.flowParseRestrictedIdentifier(true, true) : this.parseIdentifier();
          node.specifiers.push(this.finishImportSpecifier(specifier, type));
        }
        maybeParseDefaultImportSpecifier(node) {
          node.importKind = "value";
          let kind = null;
          if (this.match(87)) {
            kind = "typeof";
          } else if (this.isContextual(128)) {
            kind = "type";
          }
          if (kind) {
            const lh = this.lookahead();
            const {
              type
            } = lh;
            if (kind === "type" && type === 55) {
              this.unexpected(null, lh.type);
            }
            if (isMaybeDefaultImport(type) || type === 5 || type === 55) {
              this.next();
              node.importKind = kind;
            }
          }
          return super.maybeParseDefaultImportSpecifier(node);
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
          const firstIdent = specifier.imported;
          let specifierTypeKind = null;
          if (firstIdent.type === "Identifier") {
            if (firstIdent.name === "type") {
              specifierTypeKind = "type";
            } else if (firstIdent.name === "typeof") {
              specifierTypeKind = "typeof";
            }
          }
          let isBinding = false;
          if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
            const as_ident = this.parseIdentifier(true);
            if (specifierTypeKind !== null && !tokenIsKeywordOrIdentifier(this.state.type)) {
              specifier.imported = as_ident;
              specifier.importKind = specifierTypeKind;
              specifier.local = cloneIdentifier(as_ident);
            } else {
              specifier.imported = firstIdent;
              specifier.importKind = null;
              specifier.local = this.parseIdentifier();
            }
          } else {
            if (specifierTypeKind !== null && tokenIsKeywordOrIdentifier(this.state.type)) {
              specifier.imported = this.parseIdentifier(true);
              specifier.importKind = specifierTypeKind;
            } else {
              if (importedIsString) {
                throw this.raise(Errors.ImportBindingIsString, {
                  at: specifier,
                  importName: firstIdent.value
                });
              }
              specifier.imported = firstIdent;
              specifier.importKind = null;
            }
            if (this.eatContextual(93)) {
              specifier.local = this.parseIdentifier();
            } else {
              isBinding = true;
              specifier.local = cloneIdentifier(specifier.imported);
            }
          }
          const specifierIsTypeImport = hasTypeImportKind(specifier);
          if (isInTypeOnlyImport && specifierIsTypeImport) {
            this.raise(FlowErrors.ImportTypeShorthandOnlyInPureImport, {
              at: specifier
            });
          }
          if (isInTypeOnlyImport || specifierIsTypeImport) {
            this.checkReservedType(specifier.local.name, specifier.local.loc.start, true);
          }
          if (isBinding && !isInTypeOnlyImport && !specifierIsTypeImport) {
            this.checkReservedWord(specifier.local.name, specifier.loc.start, true, true);
          }
          return this.finishImportSpecifier(specifier, "ImportSpecifier");
        }
        parseBindingAtom() {
          switch (this.state.type) {
            case 78:
              return this.parseIdentifier(true);
            default:
              return super.parseBindingAtom();
          }
        }
        parseFunctionParams(node, allowModifiers) {
          const kind = node.kind;
          if (kind !== "get" && kind !== "set" && this.match(47)) {
            node.typeParameters = this.flowParseTypeParameterDeclaration();
          }
          super.parseFunctionParams(node, allowModifiers);
        }
        parseVarId(decl, kind) {
          super.parseVarId(decl, kind);
          if (this.match(14)) {
            decl.id.typeAnnotation = this.flowParseTypeAnnotation();
            this.resetEndLocation(decl.id);
          }
        }
        parseAsyncArrowFromCallExpression(node, call) {
          if (this.match(14)) {
            const oldNoAnonFunctionType = this.state.noAnonFunctionType;
            this.state.noAnonFunctionType = true;
            node.returnType = this.flowParseTypeAnnotation();
            this.state.noAnonFunctionType = oldNoAnonFunctionType;
          }
          return super.parseAsyncArrowFromCallExpression(node, call);
        }
        shouldParseAsyncArrow() {
          return this.match(14) || super.shouldParseAsyncArrow();
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
          var _jsx;
          let state = null;
          let jsx2;
          if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
            state = this.state.clone();
            jsx2 = this.tryParse(() => super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
            if (!jsx2.error)
              return jsx2.node;
            const {
              context
            } = this.state;
            const currentContext = context[context.length - 1];
            if (currentContext === types.j_oTag || currentContext === types.j_expr) {
              context.pop();
            }
          }
          if ((_jsx = jsx2) != null && _jsx.error || this.match(47)) {
            var _jsx2, _jsx3;
            state = state || this.state.clone();
            let typeParameters;
            const arrow = this.tryParse((abort) => {
              var _arrowExpression$extr;
              typeParameters = this.flowParseTypeParameterDeclaration();
              const arrowExpression2 = this.forwardNoArrowParamsConversionAt(typeParameters, () => {
                const result2 = super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
                this.resetStartLocationFromNode(result2, typeParameters);
                return result2;
              });
              if ((_arrowExpression$extr = arrowExpression2.extra) != null && _arrowExpression$extr.parenthesized)
                abort();
              const expr = this.maybeUnwrapTypeCastExpression(arrowExpression2);
              if (expr.type !== "ArrowFunctionExpression")
                abort();
              expr.typeParameters = typeParameters;
              this.resetStartLocationFromNode(expr, typeParameters);
              return arrowExpression2;
            }, state);
            let arrowExpression = null;
            if (arrow.node && this.maybeUnwrapTypeCastExpression(arrow.node).type === "ArrowFunctionExpression") {
              if (!arrow.error && !arrow.aborted) {
                if (arrow.node.async) {
                  this.raise(FlowErrors.UnexpectedTypeParameterBeforeAsyncArrowFunction, {
                    at: typeParameters
                  });
                }
                return arrow.node;
              }
              arrowExpression = arrow.node;
            }
            if ((_jsx2 = jsx2) != null && _jsx2.node) {
              this.state = jsx2.failState;
              return jsx2.node;
            }
            if (arrowExpression) {
              this.state = arrow.failState;
              return arrowExpression;
            }
            if ((_jsx3 = jsx2) != null && _jsx3.thrown)
              throw jsx2.error;
            if (arrow.thrown)
              throw arrow.error;
            throw this.raise(FlowErrors.UnexpectedTokenAfterTypeParameter, {
              at: typeParameters
            });
          }
          return super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
        }
        parseArrow(node) {
          if (this.match(14)) {
            const result2 = this.tryParse(() => {
              const oldNoAnonFunctionType = this.state.noAnonFunctionType;
              this.state.noAnonFunctionType = true;
              const typeNode = this.startNode();
              [
                typeNode.typeAnnotation,
                node.predicate
              ] = this.flowParseTypeAndPredicateInitialiser();
              this.state.noAnonFunctionType = oldNoAnonFunctionType;
              if (this.canInsertSemicolon())
                this.unexpected();
              if (!this.match(19))
                this.unexpected();
              return typeNode;
            });
            if (result2.thrown)
              return null;
            if (result2.error)
              this.state = result2.failState;
            node.returnType = result2.node.typeAnnotation ? this.finishNode(result2.node, "TypeAnnotation") : null;
          }
          return super.parseArrow(node);
        }
        shouldParseArrow(params) {
          return this.match(14) || super.shouldParseArrow(params);
        }
        setArrowFunctionParameters(node, params) {
          if (this.state.noArrowParamsConversionAt.indexOf(node.start) !== -1) {
            node.params = params;
          } else {
            super.setArrowFunctionParameters(node, params);
          }
        }
        checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged = true) {
          if (isArrowFunction && this.state.noArrowParamsConversionAt.indexOf(node.start) !== -1) {
            return;
          }
          for (let i = 0; i < node.params.length; i++) {
            if (this.isThisParam(node.params[i]) && i > 0) {
              this.raise(FlowErrors.ThisParamMustBeFirst, {
                at: node.params[i]
              });
            }
          }
          return super.checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged);
        }
        parseParenAndDistinguishExpression(canBeArrow) {
          return super.parseParenAndDistinguishExpression(canBeArrow && this.state.noArrowAt.indexOf(this.state.start) === -1);
        }
        parseSubscripts(base, startLoc, noCalls) {
          if (base.type === "Identifier" && base.name === "async" && this.state.noArrowAt.indexOf(startLoc.index) !== -1) {
            this.next();
            const node = this.startNodeAt(startLoc);
            node.callee = base;
            node.arguments = super.parseCallExpressionArguments(11, false);
            base = this.finishNode(node, "CallExpression");
          } else if (base.type === "Identifier" && base.name === "async" && this.match(47)) {
            const state = this.state.clone();
            const arrow = this.tryParse((abort) => this.parseAsyncArrowWithTypeParameters(startLoc) || abort(), state);
            if (!arrow.error && !arrow.aborted)
              return arrow.node;
            const result2 = this.tryParse(() => super.parseSubscripts(base, startLoc, noCalls), state);
            if (result2.node && !result2.error)
              return result2.node;
            if (arrow.node) {
              this.state = arrow.failState;
              return arrow.node;
            }
            if (result2.node) {
              this.state = result2.failState;
              return result2.node;
            }
            throw arrow.error || result2.error;
          }
          return super.parseSubscripts(base, startLoc, noCalls);
        }
        parseSubscript(base, startLoc, noCalls, subscriptState) {
          if (this.match(18) && this.isLookaheadToken_lt()) {
            subscriptState.optionalChainMember = true;
            if (noCalls) {
              subscriptState.stop = true;
              return base;
            }
            this.next();
            const node = this.startNodeAt(startLoc);
            node.callee = base;
            node.typeArguments = this.flowParseTypeParameterInstantiation();
            this.expect(10);
            node.arguments = this.parseCallExpressionArguments(11, false);
            node.optional = true;
            return this.finishCallExpression(node, true);
          } else if (!noCalls && this.shouldParseTypes() && this.match(47)) {
            const node = this.startNodeAt(startLoc);
            node.callee = base;
            const result2 = this.tryParse(() => {
              node.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew();
              this.expect(10);
              node.arguments = super.parseCallExpressionArguments(11, false);
              if (subscriptState.optionalChainMember) {
                node.optional = false;
              }
              return this.finishCallExpression(node, subscriptState.optionalChainMember);
            });
            if (result2.node) {
              if (result2.error)
                this.state = result2.failState;
              return result2.node;
            }
          }
          return super.parseSubscript(base, startLoc, noCalls, subscriptState);
        }
        parseNewCallee(node) {
          super.parseNewCallee(node);
          let targs = null;
          if (this.shouldParseTypes() && this.match(47)) {
            targs = this.tryParse(() => this.flowParseTypeParameterInstantiationCallOrNew()).node;
          }
          node.typeArguments = targs;
        }
        parseAsyncArrowWithTypeParameters(startLoc) {
          const node = this.startNodeAt(startLoc);
          this.parseFunctionParams(node);
          if (!this.parseArrow(node))
            return;
          return super.parseArrowExpression(node, void 0, true);
        }
        readToken_mult_modulo(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (code === 42 && next === 47 && this.state.hasFlowComment) {
            this.state.hasFlowComment = false;
            this.state.pos += 2;
            this.nextToken();
            return;
          }
          super.readToken_mult_modulo(code);
        }
        readToken_pipe_amp(code) {
          const next = this.input.charCodeAt(this.state.pos + 1);
          if (code === 124 && next === 125) {
            this.finishOp(9, 2);
            return;
          }
          super.readToken_pipe_amp(code);
        }
        parseTopLevel(file2, program3) {
          const fileNode = super.parseTopLevel(file2, program3);
          if (this.state.hasFlowComment) {
            this.raise(FlowErrors.UnterminatedFlowComment, {
              at: this.state.curPosition()
            });
          }
          return fileNode;
        }
        skipBlockComment() {
          if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
            if (this.state.hasFlowComment) {
              throw this.raise(FlowErrors.NestedFlowComment, {
                at: this.state.startLoc
              });
            }
            this.hasFlowCommentCompletion();
            const commentSkip = this.skipFlowComment();
            if (commentSkip) {
              this.state.pos += commentSkip;
              this.state.hasFlowComment = true;
            }
            return;
          }
          return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
        }
        skipFlowComment() {
          const {
            pos
          } = this.state;
          let shiftToFirstNonWhiteSpace = 2;
          while ([32, 9].includes(
            this.input.charCodeAt(pos + shiftToFirstNonWhiteSpace)
          )) {
            shiftToFirstNonWhiteSpace++;
          }
          const ch2 = this.input.charCodeAt(shiftToFirstNonWhiteSpace + pos);
          const ch3 = this.input.charCodeAt(shiftToFirstNonWhiteSpace + pos + 1);
          if (ch2 === 58 && ch3 === 58) {
            return shiftToFirstNonWhiteSpace + 2;
          }
          if (this.input.slice(shiftToFirstNonWhiteSpace + pos, shiftToFirstNonWhiteSpace + pos + 12) === "flow-include") {
            return shiftToFirstNonWhiteSpace + 12;
          }
          if (ch2 === 58 && ch3 !== 58) {
            return shiftToFirstNonWhiteSpace;
          }
          return false;
        }
        hasFlowCommentCompletion() {
          const end = this.input.indexOf("*/", this.state.pos);
          if (end === -1) {
            throw this.raise(Errors.UnterminatedComment, {
              at: this.state.curPosition()
            });
          }
        }
        flowEnumErrorBooleanMemberNotInitialized(loc, {
          enumName,
          memberName
        }) {
          this.raise(FlowErrors.EnumBooleanMemberNotInitialized, {
            at: loc,
            memberName,
            enumName
          });
        }
        flowEnumErrorInvalidMemberInitializer(loc, enumContext) {
          return this.raise(!enumContext.explicitType ? FlowErrors.EnumInvalidMemberInitializerUnknownType : enumContext.explicitType === "symbol" ? FlowErrors.EnumInvalidMemberInitializerSymbolType : FlowErrors.EnumInvalidMemberInitializerPrimaryType, Object.assign({
            at: loc
          }, enumContext));
        }
        flowEnumErrorNumberMemberNotInitialized(loc, {
          enumName,
          memberName
        }) {
          this.raise(FlowErrors.EnumNumberMemberNotInitialized, {
            at: loc,
            enumName,
            memberName
          });
        }
        flowEnumErrorStringMemberInconsistentlyInitailized(node, {
          enumName
        }) {
          this.raise(FlowErrors.EnumStringMemberInconsistentlyInitailized, {
            at: node,
            enumName
          });
        }
        flowEnumMemberInit() {
          const startLoc = this.state.startLoc;
          const endOfInit = () => this.match(12) || this.match(8);
          switch (this.state.type) {
            case 132: {
              const literal = this.parseNumericLiteral(this.state.value);
              if (endOfInit()) {
                return {
                  type: "number",
                  loc: literal.loc.start,
                  value: literal
                };
              }
              return {
                type: "invalid",
                loc: startLoc
              };
            }
            case 131: {
              const literal = this.parseStringLiteral(this.state.value);
              if (endOfInit()) {
                return {
                  type: "string",
                  loc: literal.loc.start,
                  value: literal
                };
              }
              return {
                type: "invalid",
                loc: startLoc
              };
            }
            case 85:
            case 86: {
              const literal = this.parseBooleanLiteral(this.match(85));
              if (endOfInit()) {
                return {
                  type: "boolean",
                  loc: literal.loc.start,
                  value: literal
                };
              }
              return {
                type: "invalid",
                loc: startLoc
              };
            }
            default:
              return {
                type: "invalid",
                loc: startLoc
              };
          }
        }
        flowEnumMemberRaw() {
          const loc = this.state.startLoc;
          const id = this.parseIdentifier(true);
          const init = this.eat(29) ? this.flowEnumMemberInit() : {
            type: "none",
            loc
          };
          return {
            id,
            init
          };
        }
        flowEnumCheckExplicitTypeMismatch(loc, context, expectedType) {
          const {
            explicitType
          } = context;
          if (explicitType === null) {
            return;
          }
          if (explicitType !== expectedType) {
            this.flowEnumErrorInvalidMemberInitializer(loc, context);
          }
        }
        flowEnumMembers({
          enumName,
          explicitType
        }) {
          const seenNames = /* @__PURE__ */ new Set();
          const members = {
            booleanMembers: [],
            numberMembers: [],
            stringMembers: [],
            defaultedMembers: []
          };
          let hasUnknownMembers = false;
          while (!this.match(8)) {
            if (this.eat(21)) {
              hasUnknownMembers = true;
              break;
            }
            const memberNode = this.startNode();
            const {
              id,
              init
            } = this.flowEnumMemberRaw();
            const memberName = id.name;
            if (memberName === "") {
              continue;
            }
            if (/^[a-z]/.test(memberName)) {
              this.raise(FlowErrors.EnumInvalidMemberName, {
                at: id,
                memberName,
                suggestion: memberName[0].toUpperCase() + memberName.slice(1),
                enumName
              });
            }
            if (seenNames.has(memberName)) {
              this.raise(FlowErrors.EnumDuplicateMemberName, {
                at: id,
                memberName,
                enumName
              });
            }
            seenNames.add(memberName);
            const context = {
              enumName,
              explicitType,
              memberName
            };
            memberNode.id = id;
            switch (init.type) {
              case "boolean": {
                this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "boolean");
                memberNode.init = init.value;
                members.booleanMembers.push(this.finishNode(memberNode, "EnumBooleanMember"));
                break;
              }
              case "number": {
                this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "number");
                memberNode.init = init.value;
                members.numberMembers.push(this.finishNode(memberNode, "EnumNumberMember"));
                break;
              }
              case "string": {
                this.flowEnumCheckExplicitTypeMismatch(init.loc, context, "string");
                memberNode.init = init.value;
                members.stringMembers.push(this.finishNode(memberNode, "EnumStringMember"));
                break;
              }
              case "invalid": {
                throw this.flowEnumErrorInvalidMemberInitializer(init.loc, context);
              }
              case "none": {
                switch (explicitType) {
                  case "boolean":
                    this.flowEnumErrorBooleanMemberNotInitialized(init.loc, context);
                    break;
                  case "number":
                    this.flowEnumErrorNumberMemberNotInitialized(init.loc, context);
                    break;
                  default:
                    members.defaultedMembers.push(this.finishNode(memberNode, "EnumDefaultedMember"));
                }
              }
            }
            if (!this.match(8)) {
              this.expect(12);
            }
          }
          return {
            members,
            hasUnknownMembers
          };
        }
        flowEnumStringMembers(initializedMembers, defaultedMembers, {
          enumName
        }) {
          if (initializedMembers.length === 0) {
            return defaultedMembers;
          } else if (defaultedMembers.length === 0) {
            return initializedMembers;
          } else if (defaultedMembers.length > initializedMembers.length) {
            for (const member of initializedMembers) {
              this.flowEnumErrorStringMemberInconsistentlyInitailized(member, {
                enumName
              });
            }
            return defaultedMembers;
          } else {
            for (const member of defaultedMembers) {
              this.flowEnumErrorStringMemberInconsistentlyInitailized(member, {
                enumName
              });
            }
            return initializedMembers;
          }
        }
        flowEnumParseExplicitType({
          enumName
        }) {
          if (!this.eatContextual(101))
            return null;
          if (!tokenIsIdentifier(this.state.type)) {
            throw this.raise(FlowErrors.EnumInvalidExplicitTypeUnknownSupplied, {
              at: this.state.startLoc,
              enumName
            });
          }
          const {
            value
          } = this.state;
          this.next();
          if (value !== "boolean" && value !== "number" && value !== "string" && value !== "symbol") {
            this.raise(FlowErrors.EnumInvalidExplicitType, {
              at: this.state.startLoc,
              enumName,
              invalidEnumType: value
            });
          }
          return value;
        }
        flowEnumBody(node, id) {
          const enumName = id.name;
          const nameLoc = id.loc.start;
          const explicitType = this.flowEnumParseExplicitType({
            enumName
          });
          this.expect(5);
          const {
            members,
            hasUnknownMembers
          } = this.flowEnumMembers({
            enumName,
            explicitType
          });
          node.hasUnknownMembers = hasUnknownMembers;
          switch (explicitType) {
            case "boolean":
              node.explicitType = true;
              node.members = members.booleanMembers;
              this.expect(8);
              return this.finishNode(node, "EnumBooleanBody");
            case "number":
              node.explicitType = true;
              node.members = members.numberMembers;
              this.expect(8);
              return this.finishNode(node, "EnumNumberBody");
            case "string":
              node.explicitType = true;
              node.members = this.flowEnumStringMembers(members.stringMembers, members.defaultedMembers, {
                enumName
              });
              this.expect(8);
              return this.finishNode(node, "EnumStringBody");
            case "symbol":
              node.members = members.defaultedMembers;
              this.expect(8);
              return this.finishNode(node, "EnumSymbolBody");
            default: {
              const empty = () => {
                node.members = [];
                this.expect(8);
                return this.finishNode(node, "EnumStringBody");
              };
              node.explicitType = false;
              const boolsLen = members.booleanMembers.length;
              const numsLen = members.numberMembers.length;
              const strsLen = members.stringMembers.length;
              const defaultedLen = members.defaultedMembers.length;
              if (!boolsLen && !numsLen && !strsLen && !defaultedLen) {
                return empty();
              } else if (!boolsLen && !numsLen) {
                node.members = this.flowEnumStringMembers(members.stringMembers, members.defaultedMembers, {
                  enumName
                });
                this.expect(8);
                return this.finishNode(node, "EnumStringBody");
              } else if (!numsLen && !strsLen && boolsLen >= defaultedLen) {
                for (const member of members.defaultedMembers) {
                  this.flowEnumErrorBooleanMemberNotInitialized(member.loc.start, {
                    enumName,
                    memberName: member.id.name
                  });
                }
                node.members = members.booleanMembers;
                this.expect(8);
                return this.finishNode(node, "EnumBooleanBody");
              } else if (!boolsLen && !strsLen && numsLen >= defaultedLen) {
                for (const member of members.defaultedMembers) {
                  this.flowEnumErrorNumberMemberNotInitialized(member.loc.start, {
                    enumName,
                    memberName: member.id.name
                  });
                }
                node.members = members.numberMembers;
                this.expect(8);
                return this.finishNode(node, "EnumNumberBody");
              } else {
                this.raise(FlowErrors.EnumInconsistentMemberValues, {
                  at: nameLoc,
                  enumName
                });
                return empty();
              }
            }
          }
        }
        flowParseEnumDeclaration(node) {
          const id = this.parseIdentifier();
          node.id = id;
          node.body = this.flowEnumBody(this.startNode(), id);
          return this.finishNode(node, "EnumDeclaration");
        }
        isLookaheadToken_lt() {
          const next = this.nextTokenStart();
          if (this.input.charCodeAt(next) === 60) {
            const afterNext = this.input.charCodeAt(next + 1);
            return afterNext !== 60 && afterNext !== 61;
          }
          return false;
        }
        maybeUnwrapTypeCastExpression(node) {
          return node.type === "TypeCastExpression" ? node.expression : node;
        }
      };
      var entities = {
        __proto__: null,
        quot: '"',
        amp: "&",
        apos: "'",
        lt: "<",
        gt: ">",
        nbsp: "\xA0",
        iexcl: "\xA1",
        cent: "\xA2",
        pound: "\xA3",
        curren: "\xA4",
        yen: "\xA5",
        brvbar: "\xA6",
        sect: "\xA7",
        uml: "\xA8",
        copy: "\xA9",
        ordf: "\xAA",
        laquo: "\xAB",
        not: "\xAC",
        shy: "\xAD",
        reg: "\xAE",
        macr: "\xAF",
        deg: "\xB0",
        plusmn: "\xB1",
        sup2: "\xB2",
        sup3: "\xB3",
        acute: "\xB4",
        micro: "\xB5",
        para: "\xB6",
        middot: "\xB7",
        cedil: "\xB8",
        sup1: "\xB9",
        ordm: "\xBA",
        raquo: "\xBB",
        frac14: "\xBC",
        frac12: "\xBD",
        frac34: "\xBE",
        iquest: "\xBF",
        Agrave: "\xC0",
        Aacute: "\xC1",
        Acirc: "\xC2",
        Atilde: "\xC3",
        Auml: "\xC4",
        Aring: "\xC5",
        AElig: "\xC6",
        Ccedil: "\xC7",
        Egrave: "\xC8",
        Eacute: "\xC9",
        Ecirc: "\xCA",
        Euml: "\xCB",
        Igrave: "\xCC",
        Iacute: "\xCD",
        Icirc: "\xCE",
        Iuml: "\xCF",
        ETH: "\xD0",
        Ntilde: "\xD1",
        Ograve: "\xD2",
        Oacute: "\xD3",
        Ocirc: "\xD4",
        Otilde: "\xD5",
        Ouml: "\xD6",
        times: "\xD7",
        Oslash: "\xD8",
        Ugrave: "\xD9",
        Uacute: "\xDA",
        Ucirc: "\xDB",
        Uuml: "\xDC",
        Yacute: "\xDD",
        THORN: "\xDE",
        szlig: "\xDF",
        agrave: "\xE0",
        aacute: "\xE1",
        acirc: "\xE2",
        atilde: "\xE3",
        auml: "\xE4",
        aring: "\xE5",
        aelig: "\xE6",
        ccedil: "\xE7",
        egrave: "\xE8",
        eacute: "\xE9",
        ecirc: "\xEA",
        euml: "\xEB",
        igrave: "\xEC",
        iacute: "\xED",
        icirc: "\xEE",
        iuml: "\xEF",
        eth: "\xF0",
        ntilde: "\xF1",
        ograve: "\xF2",
        oacute: "\xF3",
        ocirc: "\xF4",
        otilde: "\xF5",
        ouml: "\xF6",
        divide: "\xF7",
        oslash: "\xF8",
        ugrave: "\xF9",
        uacute: "\xFA",
        ucirc: "\xFB",
        uuml: "\xFC",
        yacute: "\xFD",
        thorn: "\xFE",
        yuml: "\xFF",
        OElig: "\u0152",
        oelig: "\u0153",
        Scaron: "\u0160",
        scaron: "\u0161",
        Yuml: "\u0178",
        fnof: "\u0192",
        circ: "\u02C6",
        tilde: "\u02DC",
        Alpha: "\u0391",
        Beta: "\u0392",
        Gamma: "\u0393",
        Delta: "\u0394",
        Epsilon: "\u0395",
        Zeta: "\u0396",
        Eta: "\u0397",
        Theta: "\u0398",
        Iota: "\u0399",
        Kappa: "\u039A",
        Lambda: "\u039B",
        Mu: "\u039C",
        Nu: "\u039D",
        Xi: "\u039E",
        Omicron: "\u039F",
        Pi: "\u03A0",
        Rho: "\u03A1",
        Sigma: "\u03A3",
        Tau: "\u03A4",
        Upsilon: "\u03A5",
        Phi: "\u03A6",
        Chi: "\u03A7",
        Psi: "\u03A8",
        Omega: "\u03A9",
        alpha: "\u03B1",
        beta: "\u03B2",
        gamma: "\u03B3",
        delta: "\u03B4",
        epsilon: "\u03B5",
        zeta: "\u03B6",
        eta: "\u03B7",
        theta: "\u03B8",
        iota: "\u03B9",
        kappa: "\u03BA",
        lambda: "\u03BB",
        mu: "\u03BC",
        nu: "\u03BD",
        xi: "\u03BE",
        omicron: "\u03BF",
        pi: "\u03C0",
        rho: "\u03C1",
        sigmaf: "\u03C2",
        sigma: "\u03C3",
        tau: "\u03C4",
        upsilon: "\u03C5",
        phi: "\u03C6",
        chi: "\u03C7",
        psi: "\u03C8",
        omega: "\u03C9",
        thetasym: "\u03D1",
        upsih: "\u03D2",
        piv: "\u03D6",
        ensp: "\u2002",
        emsp: "\u2003",
        thinsp: "\u2009",
        zwnj: "\u200C",
        zwj: "\u200D",
        lrm: "\u200E",
        rlm: "\u200F",
        ndash: "\u2013",
        mdash: "\u2014",
        lsquo: "\u2018",
        rsquo: "\u2019",
        sbquo: "\u201A",
        ldquo: "\u201C",
        rdquo: "\u201D",
        bdquo: "\u201E",
        dagger: "\u2020",
        Dagger: "\u2021",
        bull: "\u2022",
        hellip: "\u2026",
        permil: "\u2030",
        prime: "\u2032",
        Prime: "\u2033",
        lsaquo: "\u2039",
        rsaquo: "\u203A",
        oline: "\u203E",
        frasl: "\u2044",
        euro: "\u20AC",
        image: "\u2111",
        weierp: "\u2118",
        real: "\u211C",
        trade: "\u2122",
        alefsym: "\u2135",
        larr: "\u2190",
        uarr: "\u2191",
        rarr: "\u2192",
        darr: "\u2193",
        harr: "\u2194",
        crarr: "\u21B5",
        lArr: "\u21D0",
        uArr: "\u21D1",
        rArr: "\u21D2",
        dArr: "\u21D3",
        hArr: "\u21D4",
        forall: "\u2200",
        part: "\u2202",
        exist: "\u2203",
        empty: "\u2205",
        nabla: "\u2207",
        isin: "\u2208",
        notin: "\u2209",
        ni: "\u220B",
        prod: "\u220F",
        sum: "\u2211",
        minus: "\u2212",
        lowast: "\u2217",
        radic: "\u221A",
        prop: "\u221D",
        infin: "\u221E",
        ang: "\u2220",
        and: "\u2227",
        or: "\u2228",
        cap: "\u2229",
        cup: "\u222A",
        int: "\u222B",
        there4: "\u2234",
        sim: "\u223C",
        cong: "\u2245",
        asymp: "\u2248",
        ne: "\u2260",
        equiv: "\u2261",
        le: "\u2264",
        ge: "\u2265",
        sub: "\u2282",
        sup: "\u2283",
        nsub: "\u2284",
        sube: "\u2286",
        supe: "\u2287",
        oplus: "\u2295",
        otimes: "\u2297",
        perp: "\u22A5",
        sdot: "\u22C5",
        lceil: "\u2308",
        rceil: "\u2309",
        lfloor: "\u230A",
        rfloor: "\u230B",
        lang: "\u2329",
        rang: "\u232A",
        loz: "\u25CA",
        spades: "\u2660",
        clubs: "\u2663",
        hearts: "\u2665",
        diams: "\u2666"
      };
      var JsxErrors = ParseErrorEnum`jsx`({
        AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.",
        MissingClosingTagElement: ({
          openingTagName
        }) => `Expected corresponding JSX closing tag for <${openingTagName}>.`,
        MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.",
        UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?",
        UnexpectedToken: ({
          unexpected,
          HTMLEntity
        }) => `Unexpected token \`${unexpected}\`. Did you mean \`${HTMLEntity}\` or \`{'${unexpected}'}\`?`,
        UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.",
        UnterminatedJsxContent: "Unterminated JSX contents.",
        UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?"
      });
      function isFragment(object) {
        return object ? object.type === "JSXOpeningFragment" || object.type === "JSXClosingFragment" : false;
      }
      function getQualifiedJSXName(object) {
        if (object.type === "JSXIdentifier") {
          return object.name;
        }
        if (object.type === "JSXNamespacedName") {
          return object.namespace.name + ":" + object.name.name;
        }
        if (object.type === "JSXMemberExpression") {
          return getQualifiedJSXName(object.object) + "." + getQualifiedJSXName(object.property);
        }
        throw new Error("Node had unexpected type: " + object.type);
      }
      var jsx = (superClass) => class JSXParserMixin extends superClass {
        jsxReadToken() {
          let out = "";
          let chunkStart = this.state.pos;
          for (; ; ) {
            if (this.state.pos >= this.length) {
              throw this.raise(JsxErrors.UnterminatedJsxContent, {
                at: this.state.startLoc
              });
            }
            const ch = this.input.charCodeAt(this.state.pos);
            switch (ch) {
              case 60:
              case 123:
                if (this.state.pos === this.state.start) {
                  if (ch === 60 && this.state.canStartJSXElement) {
                    ++this.state.pos;
                    return this.finishToken(140);
                  }
                  return super.getTokenFromCode(ch);
                }
                out += this.input.slice(chunkStart, this.state.pos);
                return this.finishToken(139, out);
              case 38:
                out += this.input.slice(chunkStart, this.state.pos);
                out += this.jsxReadEntity();
                chunkStart = this.state.pos;
                break;
              case 62:
              case 125:
              default:
                if (isNewLine(ch)) {
                  out += this.input.slice(chunkStart, this.state.pos);
                  out += this.jsxReadNewLine(true);
                  chunkStart = this.state.pos;
                } else {
                  ++this.state.pos;
                }
            }
          }
        }
        jsxReadNewLine(normalizeCRLF) {
          const ch = this.input.charCodeAt(this.state.pos);
          let out;
          ++this.state.pos;
          if (ch === 13 && this.input.charCodeAt(this.state.pos) === 10) {
            ++this.state.pos;
            out = normalizeCRLF ? "\n" : "\r\n";
          } else {
            out = String.fromCharCode(ch);
          }
          ++this.state.curLine;
          this.state.lineStart = this.state.pos;
          return out;
        }
        jsxReadString(quote) {
          let out = "";
          let chunkStart = ++this.state.pos;
          for (; ; ) {
            if (this.state.pos >= this.length) {
              throw this.raise(Errors.UnterminatedString, {
                at: this.state.startLoc
              });
            }
            const ch = this.input.charCodeAt(this.state.pos);
            if (ch === quote)
              break;
            if (ch === 38) {
              out += this.input.slice(chunkStart, this.state.pos);
              out += this.jsxReadEntity();
              chunkStart = this.state.pos;
            } else if (isNewLine(ch)) {
              out += this.input.slice(chunkStart, this.state.pos);
              out += this.jsxReadNewLine(false);
              chunkStart = this.state.pos;
            } else {
              ++this.state.pos;
            }
          }
          out += this.input.slice(chunkStart, this.state.pos++);
          return this.finishToken(131, out);
        }
        jsxReadEntity() {
          const startPos = ++this.state.pos;
          if (this.codePointAtPos(this.state.pos) === 35) {
            ++this.state.pos;
            let radix = 10;
            if (this.codePointAtPos(this.state.pos) === 120) {
              radix = 16;
              ++this.state.pos;
            }
            const codePoint = this.readInt(radix, void 0, false, "bail");
            if (codePoint !== null && this.codePointAtPos(this.state.pos) === 59) {
              ++this.state.pos;
              return String.fromCodePoint(codePoint);
            }
          } else {
            let count = 0;
            let semi = false;
            while (count++ < 10 && this.state.pos < this.length && !(semi = this.codePointAtPos(this.state.pos) == 59)) {
              ++this.state.pos;
            }
            if (semi) {
              const desc = this.input.slice(startPos, this.state.pos);
              const entity = entities[desc];
              ++this.state.pos;
              if (entity) {
                return entity;
              }
            }
          }
          this.state.pos = startPos;
          return "&";
        }
        jsxReadWord() {
          let ch;
          const start = this.state.pos;
          do {
            ch = this.input.charCodeAt(++this.state.pos);
          } while (isIdentifierChar(ch) || ch === 45);
          return this.finishToken(138, this.input.slice(start, this.state.pos));
        }
        jsxParseIdentifier() {
          const node = this.startNode();
          if (this.match(138)) {
            node.name = this.state.value;
          } else if (tokenIsKeyword(this.state.type)) {
            node.name = tokenLabelName(this.state.type);
          } else {
            this.unexpected();
          }
          this.next();
          return this.finishNode(node, "JSXIdentifier");
        }
        jsxParseNamespacedName() {
          const startLoc = this.state.startLoc;
          const name = this.jsxParseIdentifier();
          if (!this.eat(14))
            return name;
          const node = this.startNodeAt(startLoc);
          node.namespace = name;
          node.name = this.jsxParseIdentifier();
          return this.finishNode(node, "JSXNamespacedName");
        }
        jsxParseElementName() {
          const startLoc = this.state.startLoc;
          let node = this.jsxParseNamespacedName();
          if (node.type === "JSXNamespacedName") {
            return node;
          }
          while (this.eat(16)) {
            const newNode = this.startNodeAt(startLoc);
            newNode.object = node;
            newNode.property = this.jsxParseIdentifier();
            node = this.finishNode(newNode, "JSXMemberExpression");
          }
          return node;
        }
        jsxParseAttributeValue() {
          let node;
          switch (this.state.type) {
            case 5:
              node = this.startNode();
              this.setContext(types.brace);
              this.next();
              node = this.jsxParseExpressionContainer(node, types.j_oTag);
              if (node.expression.type === "JSXEmptyExpression") {
                this.raise(JsxErrors.AttributeIsEmpty, {
                  at: node
                });
              }
              return node;
            case 140:
            case 131:
              return this.parseExprAtom();
            default:
              throw this.raise(JsxErrors.UnsupportedJsxValue, {
                at: this.state.startLoc
              });
          }
        }
        jsxParseEmptyExpression() {
          const node = this.startNodeAt(this.state.lastTokEndLoc);
          return this.finishNodeAt(node, "JSXEmptyExpression", this.state.startLoc);
        }
        jsxParseSpreadChild(node) {
          this.next();
          node.expression = this.parseExpression();
          this.setContext(types.j_expr);
          this.state.canStartJSXElement = true;
          this.expect(8);
          return this.finishNode(node, "JSXSpreadChild");
        }
        jsxParseExpressionContainer(node, previousContext) {
          if (this.match(8)) {
            node.expression = this.jsxParseEmptyExpression();
          } else {
            const expression = this.parseExpression();
            node.expression = expression;
          }
          this.setContext(previousContext);
          this.state.canStartJSXElement = true;
          this.expect(8);
          return this.finishNode(node, "JSXExpressionContainer");
        }
        jsxParseAttribute() {
          const node = this.startNode();
          if (this.match(5)) {
            this.setContext(types.brace);
            this.next();
            this.expect(21);
            node.argument = this.parseMaybeAssignAllowIn();
            this.setContext(types.j_oTag);
            this.state.canStartJSXElement = true;
            this.expect(8);
            return this.finishNode(node, "JSXSpreadAttribute");
          }
          node.name = this.jsxParseNamespacedName();
          node.value = this.eat(29) ? this.jsxParseAttributeValue() : null;
          return this.finishNode(node, "JSXAttribute");
        }
        jsxParseOpeningElementAt(startLoc) {
          const node = this.startNodeAt(startLoc);
          if (this.eat(141)) {
            return this.finishNode(node, "JSXOpeningFragment");
          }
          node.name = this.jsxParseElementName();
          return this.jsxParseOpeningElementAfterName(node);
        }
        jsxParseOpeningElementAfterName(node) {
          const attributes = [];
          while (!this.match(56) && !this.match(141)) {
            attributes.push(this.jsxParseAttribute());
          }
          node.attributes = attributes;
          node.selfClosing = this.eat(56);
          this.expect(141);
          return this.finishNode(node, "JSXOpeningElement");
        }
        jsxParseClosingElementAt(startLoc) {
          const node = this.startNodeAt(startLoc);
          if (this.eat(141)) {
            return this.finishNode(node, "JSXClosingFragment");
          }
          node.name = this.jsxParseElementName();
          this.expect(141);
          return this.finishNode(node, "JSXClosingElement");
        }
        jsxParseElementAt(startLoc) {
          const node = this.startNodeAt(startLoc);
          const children = [];
          const openingElement = this.jsxParseOpeningElementAt(startLoc);
          let closingElement = null;
          if (!openingElement.selfClosing) {
            contents:
              for (; ; ) {
                switch (this.state.type) {
                  case 140:
                    startLoc = this.state.startLoc;
                    this.next();
                    if (this.eat(56)) {
                      closingElement = this.jsxParseClosingElementAt(startLoc);
                      break contents;
                    }
                    children.push(this.jsxParseElementAt(startLoc));
                    break;
                  case 139:
                    children.push(this.parseExprAtom());
                    break;
                  case 5: {
                    const node2 = this.startNode();
                    this.setContext(types.brace);
                    this.next();
                    if (this.match(21)) {
                      children.push(this.jsxParseSpreadChild(node2));
                    } else {
                      children.push(this.jsxParseExpressionContainer(node2, types.j_expr));
                    }
                    break;
                  }
                  default:
                    throw this.unexpected();
                }
              }
            if (isFragment(openingElement) && !isFragment(closingElement) && closingElement !== null) {
              this.raise(JsxErrors.MissingClosingTagFragment, {
                at: closingElement
              });
            } else if (!isFragment(openingElement) && isFragment(closingElement)) {
              this.raise(JsxErrors.MissingClosingTagElement, {
                at: closingElement,
                openingTagName: getQualifiedJSXName(openingElement.name)
              });
            } else if (!isFragment(openingElement) && !isFragment(closingElement)) {
              if (getQualifiedJSXName(closingElement.name) !== getQualifiedJSXName(openingElement.name)) {
                this.raise(JsxErrors.MissingClosingTagElement, {
                  at: closingElement,
                  openingTagName: getQualifiedJSXName(openingElement.name)
                });
              }
            }
          }
          if (isFragment(openingElement)) {
            node.openingFragment = openingElement;
            node.closingFragment = closingElement;
          } else {
            node.openingElement = openingElement;
            node.closingElement = closingElement;
          }
          node.children = children;
          if (this.match(47)) {
            throw this.raise(JsxErrors.UnwrappedAdjacentJSXElements, {
              at: this.state.startLoc
            });
          }
          return isFragment(openingElement) ? this.finishNode(node, "JSXFragment") : this.finishNode(node, "JSXElement");
        }
        jsxParseElement() {
          const startLoc = this.state.startLoc;
          this.next();
          return this.jsxParseElementAt(startLoc);
        }
        setContext(newContext) {
          const {
            context
          } = this.state;
          context[context.length - 1] = newContext;
        }
        parseExprAtom(refExpressionErrors) {
          if (this.match(139)) {
            return this.parseLiteral(this.state.value, "JSXText");
          } else if (this.match(140)) {
            return this.jsxParseElement();
          } else if (this.match(47) && this.input.charCodeAt(this.state.pos) !== 33) {
            this.replaceToken(140);
            return this.jsxParseElement();
          } else {
            return super.parseExprAtom(refExpressionErrors);
          }
        }
        skipSpace() {
          const curContext = this.curContext();
          if (!curContext.preserveSpace)
            super.skipSpace();
        }
        getTokenFromCode(code) {
          const context = this.curContext();
          if (context === types.j_expr) {
            return this.jsxReadToken();
          }
          if (context === types.j_oTag || context === types.j_cTag) {
            if (isIdentifierStart(code)) {
              return this.jsxReadWord();
            }
            if (code === 62) {
              ++this.state.pos;
              return this.finishToken(141);
            }
            if ((code === 34 || code === 39) && context === types.j_oTag) {
              return this.jsxReadString(code);
            }
          }
          if (code === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33) {
            ++this.state.pos;
            return this.finishToken(140);
          }
          return super.getTokenFromCode(code);
        }
        updateContext(prevType) {
          const {
            context,
            type
          } = this.state;
          if (type === 56 && prevType === 140) {
            context.splice(-2, 2, types.j_cTag);
            this.state.canStartJSXElement = false;
          } else if (type === 140) {
            context.push(types.j_oTag);
          } else if (type === 141) {
            const out = context[context.length - 1];
            if (out === types.j_oTag && prevType === 56 || out === types.j_cTag) {
              context.pop();
              this.state.canStartJSXElement = context[context.length - 1] === types.j_expr;
            } else {
              this.setContext(types.j_expr);
              this.state.canStartJSXElement = true;
            }
          } else {
            this.state.canStartJSXElement = tokenComesBeforeExpression(type);
          }
        }
      };
      var TypeScriptScope = class extends Scope2 {
        constructor(...args) {
          super(...args);
          this.types = /* @__PURE__ */ new Set();
          this.enums = /* @__PURE__ */ new Set();
          this.constEnums = /* @__PURE__ */ new Set();
          this.classes = /* @__PURE__ */ new Set();
          this.exportOnlyBindings = /* @__PURE__ */ new Set();
        }
      };
      var TypeScriptScopeHandler = class extends ScopeHandler {
        constructor(...args) {
          super(...args);
          this.importsStack = [];
        }
        createScope(flags) {
          this.importsStack.push(/* @__PURE__ */ new Set());
          return new TypeScriptScope(flags);
        }
        enter(flags) {
          if (flags == SCOPE_TS_MODULE) {
            this.importsStack.push(/* @__PURE__ */ new Set());
          }
          super.enter(flags);
        }
        exit() {
          const flags = super.exit();
          if (flags == SCOPE_TS_MODULE) {
            this.importsStack.pop();
          }
          return flags;
        }
        hasImport(name, allowShadow) {
          const len = this.importsStack.length;
          if (this.importsStack[len - 1].has(name)) {
            return true;
          }
          if (!allowShadow && len > 1) {
            for (let i = 0; i < len - 1; i++) {
              if (this.importsStack[i].has(name))
                return true;
            }
          }
          return false;
        }
        declareName(name, bindingType, loc) {
          if (bindingType & BIND_FLAGS_TS_IMPORT) {
            if (this.hasImport(name, true)) {
              this.parser.raise(Errors.VarRedeclaration, {
                at: loc,
                identifierName: name
              });
            }
            this.importsStack[this.importsStack.length - 1].add(name);
            return;
          }
          const scope = this.currentScope();
          if (bindingType & BIND_FLAGS_TS_EXPORT_ONLY) {
            this.maybeExportDefined(scope, name);
            scope.exportOnlyBindings.add(name);
            return;
          }
          super.declareName(name, bindingType, loc);
          if (bindingType & BIND_KIND_TYPE) {
            if (!(bindingType & BIND_KIND_VALUE)) {
              this.checkRedeclarationInScope(scope, name, bindingType, loc);
              this.maybeExportDefined(scope, name);
            }
            scope.types.add(name);
          }
          if (bindingType & BIND_FLAGS_TS_ENUM)
            scope.enums.add(name);
          if (bindingType & BIND_FLAGS_TS_CONST_ENUM)
            scope.constEnums.add(name);
          if (bindingType & BIND_FLAGS_CLASS)
            scope.classes.add(name);
        }
        isRedeclaredInScope(scope, name, bindingType) {
          if (scope.enums.has(name)) {
            if (bindingType & BIND_FLAGS_TS_ENUM) {
              const isConst = !!(bindingType & BIND_FLAGS_TS_CONST_ENUM);
              const wasConst = scope.constEnums.has(name);
              return isConst !== wasConst;
            }
            return true;
          }
          if (bindingType & BIND_FLAGS_CLASS && scope.classes.has(name)) {
            if (scope.lexical.has(name)) {
              return !!(bindingType & BIND_KIND_VALUE);
            } else {
              return false;
            }
          }
          if (bindingType & BIND_KIND_TYPE && scope.types.has(name)) {
            return true;
          }
          return super.isRedeclaredInScope(scope, name, bindingType);
        }
        checkLocalExport(id) {
          const {
            name
          } = id;
          if (this.hasImport(name))
            return;
          const len = this.scopeStack.length;
          for (let i = len - 1; i >= 0; i--) {
            const scope = this.scopeStack[i];
            if (scope.types.has(name) || scope.exportOnlyBindings.has(name))
              return;
          }
          super.checkLocalExport(id);
        }
      };
      var getOwn$1 = (object, key) => Object.hasOwnProperty.call(object, key) && object[key];
      function nonNull(x) {
        if (x == null) {
          throw new Error(`Unexpected ${x} value.`);
        }
        return x;
      }
      function assert(x) {
        if (!x) {
          throw new Error("Assert fail");
        }
      }
      var TSErrors = ParseErrorEnum`typescript`({
        AbstractMethodHasImplementation: ({
          methodName
        }) => `Method '${methodName}' cannot have an implementation because it is marked abstract.`,
        AbstractPropertyHasInitializer: ({
          propertyName
        }) => `Property '${propertyName}' cannot have an initializer because it is marked abstract.`,
        AccesorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.",
        AccesorCannotHaveTypeParameters: "An accessor cannot have type parameters.",
        ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.",
        ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.",
        ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.",
        ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.",
        DeclareAccessor: ({
          kind
        }) => `'declare' is not allowed in ${kind}ters.`,
        DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.",
        DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.",
        DuplicateAccessibilityModifier: ({
          modifier
        }) => `Accessibility modifier already seen.`,
        DuplicateModifier: ({
          modifier
        }) => `Duplicate modifier: '${modifier}'.`,
        EmptyHeritageClauseType: ({
          token
        }) => `'${token}' list cannot be empty.`,
        EmptyTypeArguments: "Type argument list cannot be empty.",
        EmptyTypeParameters: "Type parameter list cannot be empty.",
        ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.",
        ImportAliasHasImportType: "An import alias can not use 'import type'.",
        ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier",
        IncompatibleModifiers: ({
          modifiers
        }) => `'${modifiers[0]}' modifier cannot be used with '${modifiers[1]}' modifier.`,
        IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.",
        IndexSignatureHasAccessibility: ({
          modifier
        }) => `Index signatures cannot have an accessibility modifier ('${modifier}').`,
        IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.",
        IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.",
        IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.",
        InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.",
        InvalidModifierOnTypeMember: ({
          modifier
        }) => `'${modifier}' modifier cannot appear on a type member.`,
        InvalidModifierOnTypeParameter: ({
          modifier
        }) => `'${modifier}' modifier cannot appear on a type parameter.`,
        InvalidModifierOnTypeParameterPositions: ({
          modifier
        }) => `'${modifier}' modifier can only appear on a type parameter of a class, interface or type alias.`,
        InvalidModifiersOrder: ({
          orderedModifiers
        }) => `'${orderedModifiers[0]}' modifier must precede '${orderedModifiers[1]}' modifier.`,
        InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.",
        InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.",
        MissingInterfaceName: "'interface' declarations must be followed by an identifier.",
        MixedLabeledAndUnlabeledElements: "Tuple members must all have names or all not have names.",
        NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.",
        NonClassMethodPropertyHasAbstractModifer: "'abstract' modifier can only appear on a class, method, or property declaration.",
        OptionalTypeBeforeRequired: "A required element cannot follow an optional element.",
        OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.",
        PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.",
        PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.",
        PrivateElementHasAccessibility: ({
          modifier
        }) => `Private elements cannot have an accessibility modifier ('${modifier}').`,
        ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.",
        ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.",
        ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.",
        SetAccesorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.",
        SetAccesorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.",
        SetAccesorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.",
        SingleTypeParameterWithoutTrailingComma: ({
          typeParameterName
        }) => `Single type parameter ${typeParameterName} should have a trailing comma. Example usage: <${typeParameterName},>.`,
        StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.",
        TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.",
        TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.",
        TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.",
        TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.",
        UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.",
        UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.",
        UnexpectedTypeAnnotation: "Did not expect a type annotation here.",
        UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.",
        UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.",
        UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.",
        UnsupportedSignatureParameterKind: ({
          type
        }) => `Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${type}.`
      });
      function keywordTypeFromName(value) {
        switch (value) {
          case "any":
            return "TSAnyKeyword";
          case "boolean":
            return "TSBooleanKeyword";
          case "bigint":
            return "TSBigIntKeyword";
          case "never":
            return "TSNeverKeyword";
          case "number":
            return "TSNumberKeyword";
          case "object":
            return "TSObjectKeyword";
          case "string":
            return "TSStringKeyword";
          case "symbol":
            return "TSSymbolKeyword";
          case "undefined":
            return "TSUndefinedKeyword";
          case "unknown":
            return "TSUnknownKeyword";
          default:
            return void 0;
        }
      }
      function tsIsAccessModifier(modifier) {
        return modifier === "private" || modifier === "public" || modifier === "protected";
      }
      function tsIsVarianceAnnotations(modifier) {
        return modifier === "in" || modifier === "out";
      }
      var typescript = (superClass) => class TypeScriptParserMixin extends superClass {
        getScopeHandler() {
          return TypeScriptScopeHandler;
        }
        tsIsIdentifier() {
          return tokenIsIdentifier(this.state.type);
        }
        tsTokenCanFollowModifier() {
          return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(136) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
        }
        tsNextTokenCanFollowModifier() {
          this.next();
          return this.tsTokenCanFollowModifier();
        }
        tsParseModifier(allowedModifiers, stopOnStartOfClassStaticBlock) {
          if (!tokenIsIdentifier(this.state.type) && this.state.type !== 58) {
            return void 0;
          }
          const modifier = this.state.value;
          if (allowedModifiers.indexOf(modifier) !== -1) {
            if (stopOnStartOfClassStaticBlock && this.tsIsStartOfStaticBlocks()) {
              return void 0;
            }
            if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this))) {
              return modifier;
            }
          }
          return void 0;
        }
        tsParseModifiers({
          modified,
          allowedModifiers,
          disallowedModifiers,
          stopOnStartOfClassStaticBlock,
          errorTemplate = TSErrors.InvalidModifierOnTypeMember
        }) {
          const enforceOrder = (loc, modifier, before2, after2) => {
            if (modifier === before2 && modified[after2]) {
              this.raise(TSErrors.InvalidModifiersOrder, {
                at: loc,
                orderedModifiers: [before2, after2]
              });
            }
          };
          const incompatible = (loc, modifier, mod1, mod2) => {
            if (modified[mod1] && modifier === mod2 || modified[mod2] && modifier === mod1) {
              this.raise(TSErrors.IncompatibleModifiers, {
                at: loc,
                modifiers: [mod1, mod2]
              });
            }
          };
          for (; ; ) {
            const {
              startLoc
            } = this.state;
            const modifier = this.tsParseModifier(allowedModifiers.concat(disallowedModifiers != null ? disallowedModifiers : []), stopOnStartOfClassStaticBlock);
            if (!modifier)
              break;
            if (tsIsAccessModifier(modifier)) {
              if (modified.accessibility) {
                this.raise(TSErrors.DuplicateAccessibilityModifier, {
                  at: startLoc,
                  modifier
                });
              } else {
                enforceOrder(startLoc, modifier, modifier, "override");
                enforceOrder(startLoc, modifier, modifier, "static");
                enforceOrder(startLoc, modifier, modifier, "readonly");
                modified.accessibility = modifier;
              }
            } else if (tsIsVarianceAnnotations(modifier)) {
              if (modified[modifier]) {
                this.raise(TSErrors.DuplicateModifier, {
                  at: startLoc,
                  modifier
                });
              }
              modified[modifier] = true;
              enforceOrder(startLoc, modifier, "in", "out");
            } else {
              if (Object.hasOwnProperty.call(modified, modifier)) {
                this.raise(TSErrors.DuplicateModifier, {
                  at: startLoc,
                  modifier
                });
              } else {
                enforceOrder(startLoc, modifier, "static", "readonly");
                enforceOrder(startLoc, modifier, "static", "override");
                enforceOrder(startLoc, modifier, "override", "readonly");
                enforceOrder(startLoc, modifier, "abstract", "override");
                incompatible(startLoc, modifier, "declare", "override");
                incompatible(startLoc, modifier, "static", "abstract");
              }
              modified[modifier] = true;
            }
            if (disallowedModifiers != null && disallowedModifiers.includes(modifier)) {
              this.raise(errorTemplate, {
                at: startLoc,
                modifier
              });
            }
          }
        }
        tsIsListTerminator(kind) {
          switch (kind) {
            case "EnumMembers":
            case "TypeMembers":
              return this.match(8);
            case "HeritageClauseElement":
              return this.match(5);
            case "TupleElementTypes":
              return this.match(3);
            case "TypeParametersOrArguments":
              return this.match(48);
          }
          throw new Error("Unreachable");
        }
        tsParseList(kind, parseElement) {
          const result2 = [];
          while (!this.tsIsListTerminator(kind)) {
            result2.push(parseElement());
          }
          return result2;
        }
        tsParseDelimitedList(kind, parseElement, refTrailingCommaPos) {
          return nonNull(this.tsParseDelimitedListWorker(kind, parseElement, true, refTrailingCommaPos));
        }
        tsParseDelimitedListWorker(kind, parseElement, expectSuccess, refTrailingCommaPos) {
          const result2 = [];
          let trailingCommaPos = -1;
          for (; ; ) {
            if (this.tsIsListTerminator(kind)) {
              break;
            }
            trailingCommaPos = -1;
            const element = parseElement();
            if (element == null) {
              return void 0;
            }
            result2.push(element);
            if (this.eat(12)) {
              trailingCommaPos = this.state.lastTokStart;
              continue;
            }
            if (this.tsIsListTerminator(kind)) {
              break;
            }
            if (expectSuccess) {
              this.expect(12);
            }
            return void 0;
          }
          if (refTrailingCommaPos) {
            refTrailingCommaPos.value = trailingCommaPos;
          }
          return result2;
        }
        tsParseBracketedList(kind, parseElement, bracket, skipFirstToken, refTrailingCommaPos) {
          if (!skipFirstToken) {
            if (bracket) {
              this.expect(0);
            } else {
              this.expect(47);
            }
          }
          const result2 = this.tsParseDelimitedList(kind, parseElement, refTrailingCommaPos);
          if (bracket) {
            this.expect(3);
          } else {
            this.expect(48);
          }
          return result2;
        }
        tsParseImportType() {
          const node = this.startNode();
          this.expect(83);
          this.expect(10);
          if (!this.match(131)) {
            this.raise(TSErrors.UnsupportedImportTypeArgument, {
              at: this.state.startLoc
            });
          }
          node.argument = super.parseExprAtom();
          this.expect(11);
          if (this.eat(16)) {
            node.qualifier = this.tsParseEntityName();
          }
          if (this.match(47)) {
            node.typeParameters = this.tsParseTypeArguments();
          }
          return this.finishNode(node, "TSImportType");
        }
        tsParseEntityName(allowReservedWords = true) {
          let entity = this.parseIdentifier(allowReservedWords);
          while (this.eat(16)) {
            const node = this.startNodeAtNode(entity);
            node.left = entity;
            node.right = this.parseIdentifier(allowReservedWords);
            entity = this.finishNode(node, "TSQualifiedName");
          }
          return entity;
        }
        tsParseTypeReference() {
          const node = this.startNode();
          node.typeName = this.tsParseEntityName();
          if (!this.hasPrecedingLineBreak() && this.match(47)) {
            node.typeParameters = this.tsParseTypeArguments();
          }
          return this.finishNode(node, "TSTypeReference");
        }
        tsParseThisTypePredicate(lhs) {
          this.next();
          const node = this.startNodeAtNode(lhs);
          node.parameterName = lhs;
          node.typeAnnotation = this.tsParseTypeAnnotation(false);
          node.asserts = false;
          return this.finishNode(node, "TSTypePredicate");
        }
        tsParseThisTypeNode() {
          const node = this.startNode();
          this.next();
          return this.finishNode(node, "TSThisType");
        }
        tsParseTypeQuery() {
          const node = this.startNode();
          this.expect(87);
          if (this.match(83)) {
            node.exprName = this.tsParseImportType();
          } else {
            node.exprName = this.tsParseEntityName();
          }
          if (!this.hasPrecedingLineBreak() && this.match(47)) {
            node.typeParameters = this.tsParseTypeArguments();
          }
          return this.finishNode(node, "TSTypeQuery");
        }
        tsParseInOutModifiers(node) {
          this.tsParseModifiers({
            modified: node,
            allowedModifiers: ["in", "out"],
            disallowedModifiers: ["public", "private", "protected", "readonly", "declare", "abstract", "override"],
            errorTemplate: TSErrors.InvalidModifierOnTypeParameter
          });
        }
        tsParseNoneModifiers(node) {
          this.tsParseModifiers({
            modified: node,
            allowedModifiers: [],
            disallowedModifiers: ["in", "out"],
            errorTemplate: TSErrors.InvalidModifierOnTypeParameterPositions
          });
        }
        tsParseTypeParameter(parseModifiers = this.tsParseNoneModifiers.bind(this)) {
          const node = this.startNode();
          parseModifiers(node);
          node.name = this.tsParseTypeParameterName();
          node.constraint = this.tsEatThenParseType(81);
          node.default = this.tsEatThenParseType(29);
          return this.finishNode(node, "TSTypeParameter");
        }
        tsTryParseTypeParameters(parseModifiers) {
          if (this.match(47)) {
            return this.tsParseTypeParameters(parseModifiers);
          }
        }
        tsParseTypeParameters(parseModifiers) {
          const node = this.startNode();
          if (this.match(47) || this.match(140)) {
            this.next();
          } else {
            this.unexpected();
          }
          const refTrailingCommaPos = {
            value: -1
          };
          node.params = this.tsParseBracketedList(
            "TypeParametersOrArguments",
            this.tsParseTypeParameter.bind(this, parseModifiers),
            false,
            true,
            refTrailingCommaPos
          );
          if (node.params.length === 0) {
            this.raise(TSErrors.EmptyTypeParameters, {
              at: node
            });
          }
          if (refTrailingCommaPos.value !== -1) {
            this.addExtra(node, "trailingComma", refTrailingCommaPos.value);
          }
          return this.finishNode(node, "TSTypeParameterDeclaration");
        }
        tsFillSignature(returnToken, signature) {
          const returnTokenRequired = returnToken === 19;
          const paramsKey = "parameters";
          const returnTypeKey = "typeAnnotation";
          signature.typeParameters = this.tsTryParseTypeParameters();
          this.expect(10);
          signature[paramsKey] = this.tsParseBindingListForSignature();
          if (returnTokenRequired) {
            signature[returnTypeKey] = this.tsParseTypeOrTypePredicateAnnotation(returnToken);
          } else if (this.match(returnToken)) {
            signature[returnTypeKey] = this.tsParseTypeOrTypePredicateAnnotation(returnToken);
          }
        }
        tsParseBindingListForSignature() {
          return super.parseBindingList(11, 41).map((pattern) => {
            if (pattern.type !== "Identifier" && pattern.type !== "RestElement" && pattern.type !== "ObjectPattern" && pattern.type !== "ArrayPattern") {
              this.raise(TSErrors.UnsupportedSignatureParameterKind, {
                at: pattern,
                type: pattern.type
              });
            }
            return pattern;
          });
        }
        tsParseTypeMemberSemicolon() {
          if (!this.eat(12) && !this.isLineTerminator()) {
            this.expect(13);
          }
        }
        tsParseSignatureMember(kind, node) {
          this.tsFillSignature(14, node);
          this.tsParseTypeMemberSemicolon();
          return this.finishNode(node, kind);
        }
        tsIsUnambiguouslyIndexSignature() {
          this.next();
          if (tokenIsIdentifier(this.state.type)) {
            this.next();
            return this.match(14);
          }
          return false;
        }
        tsTryParseIndexSignature(node) {
          if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this)))) {
            return void 0;
          }
          this.expect(0);
          const id = this.parseIdentifier();
          id.typeAnnotation = this.tsParseTypeAnnotation();
          this.resetEndLocation(id);
          this.expect(3);
          node.parameters = [id];
          const type = this.tsTryParseTypeAnnotation();
          if (type)
            node.typeAnnotation = type;
          this.tsParseTypeMemberSemicolon();
          return this.finishNode(node, "TSIndexSignature");
        }
        tsParsePropertyOrMethodSignature(node, readonly) {
          if (this.eat(17))
            node.optional = true;
          const nodeAny = node;
          if (this.match(10) || this.match(47)) {
            if (readonly) {
              this.raise(TSErrors.ReadonlyForMethodSignature, {
                at: node
              });
            }
            const method2 = nodeAny;
            if (method2.kind && this.match(47)) {
              this.raise(TSErrors.AccesorCannotHaveTypeParameters, {
                at: this.state.curPosition()
              });
            }
            this.tsFillSignature(14, method2);
            this.tsParseTypeMemberSemicolon();
            const paramsKey = "parameters";
            const returnTypeKey = "typeAnnotation";
            if (method2.kind === "get") {
              if (method2[paramsKey].length > 0) {
                this.raise(Errors.BadGetterArity, {
                  at: this.state.curPosition()
                });
                if (this.isThisParam(method2[paramsKey][0])) {
                  this.raise(TSErrors.AccesorCannotDeclareThisParameter, {
                    at: this.state.curPosition()
                  });
                }
              }
            } else if (method2.kind === "set") {
              if (method2[paramsKey].length !== 1) {
                this.raise(Errors.BadSetterArity, {
                  at: this.state.curPosition()
                });
              } else {
                const firstParameter = method2[paramsKey][0];
                if (this.isThisParam(firstParameter)) {
                  this.raise(TSErrors.AccesorCannotDeclareThisParameter, {
                    at: this.state.curPosition()
                  });
                }
                if (firstParameter.type === "Identifier" && firstParameter.optional) {
                  this.raise(TSErrors.SetAccesorCannotHaveOptionalParameter, {
                    at: this.state.curPosition()
                  });
                }
                if (firstParameter.type === "RestElement") {
                  this.raise(TSErrors.SetAccesorCannotHaveRestParameter, {
                    at: this.state.curPosition()
                  });
                }
              }
              if (method2[returnTypeKey]) {
                this.raise(TSErrors.SetAccesorCannotHaveReturnType, {
                  at: method2[returnTypeKey]
                });
              }
            } else {
              method2.kind = "method";
            }
            return this.finishNode(method2, "TSMethodSignature");
          } else {
            const property2 = nodeAny;
            if (readonly)
              property2.readonly = true;
            const type = this.tsTryParseTypeAnnotation();
            if (type)
              property2.typeAnnotation = type;
            this.tsParseTypeMemberSemicolon();
            return this.finishNode(property2, "TSPropertySignature");
          }
        }
        tsParseTypeMember() {
          const node = this.startNode();
          if (this.match(10) || this.match(47)) {
            return this.tsParseSignatureMember("TSCallSignatureDeclaration", node);
          }
          if (this.match(77)) {
            const id = this.startNode();
            this.next();
            if (this.match(10) || this.match(47)) {
              return this.tsParseSignatureMember("TSConstructSignatureDeclaration", node);
            } else {
              node.key = this.createIdentifier(id, "new");
              return this.tsParsePropertyOrMethodSignature(node, false);
            }
          }
          this.tsParseModifiers({
            modified: node,
            allowedModifiers: ["readonly"],
            disallowedModifiers: ["declare", "abstract", "private", "protected", "public", "static", "override"]
          });
          const idx = this.tsTryParseIndexSignature(node);
          if (idx) {
            return idx;
          }
          super.parsePropertyName(node);
          if (!node.computed && node.key.type === "Identifier" && (node.key.name === "get" || node.key.name === "set") && this.tsTokenCanFollowModifier()) {
            node.kind = node.key.name;
            super.parsePropertyName(node);
          }
          return this.tsParsePropertyOrMethodSignature(node, !!node.readonly);
        }
        tsParseTypeLiteral() {
          const node = this.startNode();
          node.members = this.tsParseObjectTypeMembers();
          return this.finishNode(node, "TSTypeLiteral");
        }
        tsParseObjectTypeMembers() {
          this.expect(5);
          const members = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
          this.expect(8);
          return members;
        }
        tsIsStartOfMappedType() {
          this.next();
          if (this.eat(53)) {
            return this.isContextual(120);
          }
          if (this.isContextual(120)) {
            this.next();
          }
          if (!this.match(0)) {
            return false;
          }
          this.next();
          if (!this.tsIsIdentifier()) {
            return false;
          }
          this.next();
          return this.match(58);
        }
        tsParseMappedTypeParameter() {
          const node = this.startNode();
          node.name = this.tsParseTypeParameterName();
          node.constraint = this.tsExpectThenParseType(58);
          return this.finishNode(node, "TSTypeParameter");
        }
        tsParseMappedType() {
          const node = this.startNode();
          this.expect(5);
          if (this.match(53)) {
            node.readonly = this.state.value;
            this.next();
            this.expectContextual(120);
          } else if (this.eatContextual(120)) {
            node.readonly = true;
          }
          this.expect(0);
          node.typeParameter = this.tsParseMappedTypeParameter();
          node.nameType = this.eatContextual(93) ? this.tsParseType() : null;
          this.expect(3);
          if (this.match(53)) {
            node.optional = this.state.value;
            this.next();
            this.expect(17);
          } else if (this.eat(17)) {
            node.optional = true;
          }
          node.typeAnnotation = this.tsTryParseType();
          this.semicolon();
          this.expect(8);
          return this.finishNode(node, "TSMappedType");
        }
        tsParseTupleType() {
          const node = this.startNode();
          node.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), true, false);
          let seenOptionalElement = false;
          let labeledElements = null;
          node.elementTypes.forEach((elementNode) => {
            var _labeledElements;
            const {
              type
            } = elementNode;
            if (seenOptionalElement && type !== "TSRestType" && type !== "TSOptionalType" && !(type === "TSNamedTupleMember" && elementNode.optional)) {
              this.raise(TSErrors.OptionalTypeBeforeRequired, {
                at: elementNode
              });
            }
            seenOptionalElement || (seenOptionalElement = type === "TSNamedTupleMember" && elementNode.optional || type === "TSOptionalType");
            let checkType = type;
            if (type === "TSRestType") {
              elementNode = elementNode.typeAnnotation;
              checkType = elementNode.type;
            }
            const isLabeled = checkType === "TSNamedTupleMember";
            (_labeledElements = labeledElements) != null ? _labeledElements : labeledElements = isLabeled;
            if (labeledElements !== isLabeled) {
              this.raise(TSErrors.MixedLabeledAndUnlabeledElements, {
                at: elementNode
              });
            }
          });
          return this.finishNode(node, "TSTupleType");
        }
        tsParseTupleElementType() {
          const {
            startLoc
          } = this.state;
          const rest2 = this.eat(21);
          let type = this.tsParseType();
          const optional = this.eat(17);
          const labeled = this.eat(14);
          if (labeled) {
            const labeledNode = this.startNodeAtNode(type);
            labeledNode.optional = optional;
            if (type.type === "TSTypeReference" && !type.typeParameters && type.typeName.type === "Identifier") {
              labeledNode.label = type.typeName;
            } else {
              this.raise(TSErrors.InvalidTupleMemberLabel, {
                at: type
              });
              labeledNode.label = type;
            }
            labeledNode.elementType = this.tsParseType();
            type = this.finishNode(labeledNode, "TSNamedTupleMember");
          } else if (optional) {
            const optionalTypeNode = this.startNodeAtNode(type);
            optionalTypeNode.typeAnnotation = type;
            type = this.finishNode(optionalTypeNode, "TSOptionalType");
          }
          if (rest2) {
            const restNode = this.startNodeAt(startLoc);
            restNode.typeAnnotation = type;
            type = this.finishNode(restNode, "TSRestType");
          }
          return type;
        }
        tsParseParenthesizedType() {
          const node = this.startNode();
          this.expect(10);
          node.typeAnnotation = this.tsParseType();
          this.expect(11);
          return this.finishNode(node, "TSParenthesizedType");
        }
        tsParseFunctionOrConstructorType(type, abstract) {
          const node = this.startNode();
          if (type === "TSConstructorType") {
            node.abstract = !!abstract;
            if (abstract)
              this.next();
            this.next();
          }
          this.tsInAllowConditionalTypesContext(() => this.tsFillSignature(19, node));
          return this.finishNode(node, type);
        }
        tsParseLiteralTypeNode() {
          const node = this.startNode();
          node.literal = (() => {
            switch (this.state.type) {
              case 132:
              case 133:
              case 131:
              case 85:
              case 86:
                return super.parseExprAtom();
              default:
                throw this.unexpected();
            }
          })();
          return this.finishNode(node, "TSLiteralType");
        }
        tsParseTemplateLiteralType() {
          const node = this.startNode();
          node.literal = super.parseTemplate(false);
          return this.finishNode(node, "TSLiteralType");
        }
        parseTemplateSubstitution() {
          if (this.state.inType)
            return this.tsParseType();
          return super.parseTemplateSubstitution();
        }
        tsParseThisTypeOrThisTypePredicate() {
          const thisKeyword = this.tsParseThisTypeNode();
          if (this.isContextual(114) && !this.hasPrecedingLineBreak()) {
            return this.tsParseThisTypePredicate(thisKeyword);
          } else {
            return thisKeyword;
          }
        }
        tsParseNonArrayType() {
          switch (this.state.type) {
            case 131:
            case 132:
            case 133:
            case 85:
            case 86:
              return this.tsParseLiteralTypeNode();
            case 53:
              if (this.state.value === "-") {
                const node = this.startNode();
                const nextToken = this.lookahead();
                if (nextToken.type !== 132 && nextToken.type !== 133) {
                  throw this.unexpected();
                }
                node.literal = this.parseMaybeUnary();
                return this.finishNode(node, "TSLiteralType");
              }
              break;
            case 78:
              return this.tsParseThisTypeOrThisTypePredicate();
            case 87:
              return this.tsParseTypeQuery();
            case 83:
              return this.tsParseImportType();
            case 5:
              return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
            case 0:
              return this.tsParseTupleType();
            case 10:
              return this.tsParseParenthesizedType();
            case 25:
            case 24:
              return this.tsParseTemplateLiteralType();
            default: {
              const {
                type
              } = this.state;
              if (tokenIsIdentifier(type) || type === 88 || type === 84) {
                const nodeType = type === 88 ? "TSVoidKeyword" : type === 84 ? "TSNullKeyword" : keywordTypeFromName(this.state.value);
                if (nodeType !== void 0 && this.lookaheadCharCode() !== 46) {
                  const node = this.startNode();
                  this.next();
                  return this.finishNode(node, nodeType);
                }
                return this.tsParseTypeReference();
              }
            }
          }
          throw this.unexpected();
        }
        tsParseArrayTypeOrHigher() {
          let type = this.tsParseNonArrayType();
          while (!this.hasPrecedingLineBreak() && this.eat(0)) {
            if (this.match(3)) {
              const node = this.startNodeAtNode(type);
              node.elementType = type;
              this.expect(3);
              type = this.finishNode(node, "TSArrayType");
            } else {
              const node = this.startNodeAtNode(type);
              node.objectType = type;
              node.indexType = this.tsParseType();
              this.expect(3);
              type = this.finishNode(node, "TSIndexedAccessType");
            }
          }
          return type;
        }
        tsParseTypeOperator() {
          const node = this.startNode();
          const operator = this.state.value;
          this.next();
          node.operator = operator;
          node.typeAnnotation = this.tsParseTypeOperatorOrHigher();
          if (operator === "readonly") {
            this.tsCheckTypeAnnotationForReadOnly(
              node
            );
          }
          return this.finishNode(node, "TSTypeOperator");
        }
        tsCheckTypeAnnotationForReadOnly(node) {
          switch (node.typeAnnotation.type) {
            case "TSTupleType":
            case "TSArrayType":
              return;
            default:
              this.raise(TSErrors.UnexpectedReadonly, {
                at: node
              });
          }
        }
        tsParseInferType() {
          const node = this.startNode();
          this.expectContextual(113);
          const typeParameter = this.startNode();
          typeParameter.name = this.tsParseTypeParameterName();
          typeParameter.constraint = this.tsTryParse(() => this.tsParseConstraintForInferType());
          node.typeParameter = this.finishNode(typeParameter, "TSTypeParameter");
          return this.finishNode(node, "TSInferType");
        }
        tsParseConstraintForInferType() {
          if (this.eat(81)) {
            const constraint = this.tsInDisallowConditionalTypesContext(() => this.tsParseType());
            if (this.state.inDisallowConditionalTypesContext || !this.match(17)) {
              return constraint;
            }
          }
        }
        tsParseTypeOperatorOrHigher() {
          const isTypeOperator = tokenIsTSTypeOperator(this.state.type) && !this.state.containsEsc;
          return isTypeOperator ? this.tsParseTypeOperator() : this.isContextual(113) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(() => this.tsParseArrayTypeOrHigher());
        }
        tsParseUnionOrIntersectionType(kind, parseConstituentType, operator) {
          const node = this.startNode();
          const hasLeadingOperator = this.eat(operator);
          const types2 = [];
          do {
            types2.push(parseConstituentType());
          } while (this.eat(operator));
          if (types2.length === 1 && !hasLeadingOperator) {
            return types2[0];
          }
          node.types = types2;
          return this.finishNode(node, kind);
        }
        tsParseIntersectionTypeOrHigher() {
          return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
        }
        tsParseUnionTypeOrHigher() {
          return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
        }
        tsIsStartOfFunctionType() {
          if (this.match(47)) {
            return true;
          }
          return this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
        }
        tsSkipParameterStart() {
          if (tokenIsIdentifier(this.state.type) || this.match(78)) {
            this.next();
            return true;
          }
          if (this.match(5)) {
            const {
              errors
            } = this.state;
            const previousErrorCount = errors.length;
            try {
              this.parseObjectLike(8, true);
              return errors.length === previousErrorCount;
            } catch (_unused) {
              return false;
            }
          }
          if (this.match(0)) {
            this.next();
            const {
              errors
            } = this.state;
            const previousErrorCount = errors.length;
            try {
              super.parseBindingList(3, 93, true);
              return errors.length === previousErrorCount;
            } catch (_unused2) {
              return false;
            }
          }
          return false;
        }
        tsIsUnambiguouslyStartOfFunctionType() {
          this.next();
          if (this.match(11) || this.match(21)) {
            return true;
          }
          if (this.tsSkipParameterStart()) {
            if (this.match(14) || this.match(12) || this.match(17) || this.match(29)) {
              return true;
            }
            if (this.match(11)) {
              this.next();
              if (this.match(19)) {
                return true;
              }
            }
          }
          return false;
        }
        tsParseTypeOrTypePredicateAnnotation(returnToken) {
          return this.tsInType(() => {
            const t3 = this.startNode();
            this.expect(returnToken);
            const node = this.startNode();
            const asserts = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
            if (asserts && this.match(78)) {
              let thisTypePredicate = this.tsParseThisTypeOrThisTypePredicate();
              if (thisTypePredicate.type === "TSThisType") {
                node.parameterName = thisTypePredicate;
                node.asserts = true;
                node.typeAnnotation = null;
                thisTypePredicate = this.finishNode(node, "TSTypePredicate");
              } else {
                this.resetStartLocationFromNode(thisTypePredicate, node);
                thisTypePredicate.asserts = true;
              }
              t3.typeAnnotation = thisTypePredicate;
              return this.finishNode(t3, "TSTypeAnnotation");
            }
            const typePredicateVariable = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
            if (!typePredicateVariable) {
              if (!asserts) {
                return this.tsParseTypeAnnotation(false, t3);
              }
              node.parameterName = this.parseIdentifier();
              node.asserts = asserts;
              node.typeAnnotation = null;
              t3.typeAnnotation = this.finishNode(node, "TSTypePredicate");
              return this.finishNode(t3, "TSTypeAnnotation");
            }
            const type = this.tsParseTypeAnnotation(false);
            node.parameterName = typePredicateVariable;
            node.typeAnnotation = type;
            node.asserts = asserts;
            t3.typeAnnotation = this.finishNode(node, "TSTypePredicate");
            return this.finishNode(t3, "TSTypeAnnotation");
          });
        }
        tsTryParseTypeOrTypePredicateAnnotation() {
          return this.match(14) ? this.tsParseTypeOrTypePredicateAnnotation(14) : void 0;
        }
        tsTryParseTypeAnnotation() {
          return this.match(14) ? this.tsParseTypeAnnotation() : void 0;
        }
        tsTryParseType() {
          return this.tsEatThenParseType(14);
        }
        tsParseTypePredicatePrefix() {
          const id = this.parseIdentifier();
          if (this.isContextual(114) && !this.hasPrecedingLineBreak()) {
            this.next();
            return id;
          }
        }
        tsParseTypePredicateAsserts() {
          if (this.state.type !== 107) {
            return false;
          }
          const containsEsc = this.state.containsEsc;
          this.next();
          if (!tokenIsIdentifier(this.state.type) && !this.match(78)) {
            return false;
          }
          if (containsEsc) {
            this.raise(Errors.InvalidEscapedReservedWord, {
              at: this.state.lastTokStartLoc,
              reservedWord: "asserts"
            });
          }
          return true;
        }
        tsParseTypeAnnotation(eatColon = true, t3 = this.startNode()) {
          this.tsInType(() => {
            if (eatColon)
              this.expect(14);
            t3.typeAnnotation = this.tsParseType();
          });
          return this.finishNode(t3, "TSTypeAnnotation");
        }
        tsParseType() {
          assert(this.state.inType);
          const type = this.tsParseNonConditionalType();
          if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81)) {
            return type;
          }
          const node = this.startNodeAtNode(type);
          node.checkType = type;
          node.extendsType = this.tsInDisallowConditionalTypesContext(() => this.tsParseNonConditionalType());
          this.expect(17);
          node.trueType = this.tsInAllowConditionalTypesContext(() => this.tsParseType());
          this.expect(14);
          node.falseType = this.tsInAllowConditionalTypesContext(() => this.tsParseType());
          return this.finishNode(node, "TSConditionalType");
        }
        isAbstractConstructorSignature() {
          return this.isContextual(122) && this.lookahead().type === 77;
        }
        tsParseNonConditionalType() {
          if (this.tsIsStartOfFunctionType()) {
            return this.tsParseFunctionOrConstructorType("TSFunctionType");
          }
          if (this.match(77)) {
            return this.tsParseFunctionOrConstructorType("TSConstructorType");
          } else if (this.isAbstractConstructorSignature()) {
            return this.tsParseFunctionOrConstructorType("TSConstructorType", true);
          }
          return this.tsParseUnionTypeOrHigher();
        }
        tsParseTypeAssertion() {
          if (this.getPluginOption("typescript", "disallowAmbiguousJSXLike")) {
            this.raise(TSErrors.ReservedTypeAssertion, {
              at: this.state.startLoc
            });
          }
          const node = this.startNode();
          node.typeAnnotation = this.tsInType(() => {
            this.next();
            return this.match(75) ? this.tsParseTypeReference() : this.tsParseType();
          });
          this.expect(48);
          node.expression = this.parseMaybeUnary();
          return this.finishNode(node, "TSTypeAssertion");
        }
        tsParseHeritageClause(token) {
          const originalStartLoc = this.state.startLoc;
          const delimitedList = this.tsParseDelimitedList("HeritageClauseElement", () => {
            const node = this.startNode();
            node.expression = this.tsParseEntityName();
            if (this.match(47)) {
              node.typeParameters = this.tsParseTypeArguments();
            }
            return this.finishNode(node, "TSExpressionWithTypeArguments");
          });
          if (!delimitedList.length) {
            this.raise(TSErrors.EmptyHeritageClauseType, {
              at: originalStartLoc,
              token
            });
          }
          return delimitedList;
        }
        tsParseInterfaceDeclaration(node, properties = {}) {
          if (this.hasFollowingLineBreak())
            return null;
          this.expectContextual(127);
          if (properties.declare)
            node.declare = true;
          if (tokenIsIdentifier(this.state.type)) {
            node.id = this.parseIdentifier();
            this.checkIdentifier(node.id, BIND_TS_INTERFACE);
          } else {
            node.id = null;
            this.raise(TSErrors.MissingInterfaceName, {
              at: this.state.startLoc
            });
          }
          node.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this));
          if (this.eat(81)) {
            node.extends = this.tsParseHeritageClause("extends");
          }
          const body = this.startNode();
          body.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this));
          node.body = this.finishNode(body, "TSInterfaceBody");
          return this.finishNode(node, "TSInterfaceDeclaration");
        }
        tsParseTypeAliasDeclaration(node) {
          node.id = this.parseIdentifier();
          this.checkIdentifier(node.id, BIND_TS_TYPE);
          node.typeAnnotation = this.tsInType(() => {
            node.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this));
            this.expect(29);
            if (this.isContextual(112) && this.lookahead().type !== 16) {
              const node2 = this.startNode();
              this.next();
              return this.finishNode(node2, "TSIntrinsicKeyword");
            }
            return this.tsParseType();
          });
          this.semicolon();
          return this.finishNode(node, "TSTypeAliasDeclaration");
        }
        tsInNoContext(cb) {
          const oldContext = this.state.context;
          this.state.context = [oldContext[0]];
          try {
            return cb();
          } finally {
            this.state.context = oldContext;
          }
        }
        tsInType(cb) {
          const oldInType = this.state.inType;
          this.state.inType = true;
          try {
            return cb();
          } finally {
            this.state.inType = oldInType;
          }
        }
        tsInDisallowConditionalTypesContext(cb) {
          const oldInDisallowConditionalTypesContext = this.state.inDisallowConditionalTypesContext;
          this.state.inDisallowConditionalTypesContext = true;
          try {
            return cb();
          } finally {
            this.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
          }
        }
        tsInAllowConditionalTypesContext(cb) {
          const oldInDisallowConditionalTypesContext = this.state.inDisallowConditionalTypesContext;
          this.state.inDisallowConditionalTypesContext = false;
          try {
            return cb();
          } finally {
            this.state.inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
          }
        }
        tsEatThenParseType(token) {
          return !this.match(token) ? void 0 : this.tsNextThenParseType();
        }
        tsExpectThenParseType(token) {
          return this.tsDoThenParseType(() => this.expect(token));
        }
        tsNextThenParseType() {
          return this.tsDoThenParseType(() => this.next());
        }
        tsDoThenParseType(cb) {
          return this.tsInType(() => {
            cb();
            return this.tsParseType();
          });
        }
        tsParseEnumMember() {
          const node = this.startNode();
          node.id = this.match(131) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(true);
          if (this.eat(29)) {
            node.initializer = super.parseMaybeAssignAllowIn();
          }
          return this.finishNode(node, "TSEnumMember");
        }
        tsParseEnumDeclaration(node, properties = {}) {
          if (properties.const)
            node.const = true;
          if (properties.declare)
            node.declare = true;
          this.expectContextual(124);
          node.id = this.parseIdentifier();
          this.checkIdentifier(node.id, node.const ? BIND_TS_CONST_ENUM : BIND_TS_ENUM);
          this.expect(5);
          node.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this));
          this.expect(8);
          return this.finishNode(node, "TSEnumDeclaration");
        }
        tsParseModuleBlock() {
          const node = this.startNode();
          this.scope.enter(SCOPE_OTHER);
          this.expect(5);
          super.parseBlockOrModuleBlockBody(node.body = [], void 0, true, 8);
          this.scope.exit();
          return this.finishNode(node, "TSModuleBlock");
        }
        tsParseModuleOrNamespaceDeclaration(node, nested = false) {
          node.id = this.parseIdentifier();
          if (!nested) {
            this.checkIdentifier(node.id, BIND_TS_NAMESPACE);
          }
          if (this.eat(16)) {
            const inner = this.startNode();
            this.tsParseModuleOrNamespaceDeclaration(inner, true);
            node.body = inner;
          } else {
            this.scope.enter(SCOPE_TS_MODULE);
            this.prodParam.enter(PARAM);
            node.body = this.tsParseModuleBlock();
            this.prodParam.exit();
            this.scope.exit();
          }
          return this.finishNode(node, "TSModuleDeclaration");
        }
        tsParseAmbientExternalModuleDeclaration(node) {
          if (this.isContextual(110)) {
            node.global = true;
            node.id = this.parseIdentifier();
          } else if (this.match(131)) {
            node.id = super.parseStringLiteral(this.state.value);
          } else {
            this.unexpected();
          }
          if (this.match(5)) {
            this.scope.enter(SCOPE_TS_MODULE);
            this.prodParam.enter(PARAM);
            node.body = this.tsParseModuleBlock();
            this.prodParam.exit();
            this.scope.exit();
          } else {
            this.semicolon();
          }
          return this.finishNode(node, "TSModuleDeclaration");
        }
        tsParseImportEqualsDeclaration(node, isExport) {
          node.isExport = isExport || false;
          node.id = this.parseIdentifier();
          this.checkIdentifier(node.id, BIND_FLAGS_TS_IMPORT);
          this.expect(29);
          const moduleReference = this.tsParseModuleReference();
          if (node.importKind === "type" && moduleReference.type !== "TSExternalModuleReference") {
            this.raise(TSErrors.ImportAliasHasImportType, {
              at: moduleReference
            });
          }
          node.moduleReference = moduleReference;
          this.semicolon();
          return this.finishNode(node, "TSImportEqualsDeclaration");
        }
        tsIsExternalModuleReference() {
          return this.isContextual(117) && this.lookaheadCharCode() === 40;
        }
        tsParseModuleReference() {
          return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(false);
        }
        tsParseExternalModuleReference() {
          const node = this.startNode();
          this.expectContextual(117);
          this.expect(10);
          if (!this.match(131)) {
            throw this.unexpected();
          }
          node.expression = super.parseExprAtom();
          this.expect(11);
          return this.finishNode(node, "TSExternalModuleReference");
        }
        tsLookAhead(f) {
          const state = this.state.clone();
          const res = f();
          this.state = state;
          return res;
        }
        tsTryParseAndCatch(f) {
          const result2 = this.tryParse((abort) => f() || abort());
          if (result2.aborted || !result2.node)
            return void 0;
          if (result2.error)
            this.state = result2.failState;
          return result2.node;
        }
        tsTryParse(f) {
          const state = this.state.clone();
          const result2 = f();
          if (result2 !== void 0 && result2 !== false) {
            return result2;
          } else {
            this.state = state;
            return void 0;
          }
        }
        tsTryParseDeclare(nany) {
          if (this.isLineTerminator()) {
            return;
          }
          let starttype = this.state.type;
          let kind;
          if (this.isContextual(99)) {
            starttype = 74;
            kind = "let";
          }
          return this.tsInAmbientContext(() => {
            if (starttype === 68) {
              nany.declare = true;
              return super.parseFunctionStatement(nany, false, true);
            }
            if (starttype === 80) {
              nany.declare = true;
              return this.parseClass(nany, true, false);
            }
            if (starttype === 124) {
              return this.tsParseEnumDeclaration(nany, {
                declare: true
              });
            }
            if (starttype === 110) {
              return this.tsParseAmbientExternalModuleDeclaration(nany);
            }
            if (starttype === 75 || starttype === 74) {
              if (!this.match(75) || !this.isLookaheadContextual("enum")) {
                nany.declare = true;
                return this.parseVarStatement(nany, kind || this.state.value, true);
              }
              this.expect(75);
              return this.tsParseEnumDeclaration(nany, {
                const: true,
                declare: true
              });
            }
            if (starttype === 127) {
              const result2 = this.tsParseInterfaceDeclaration(nany, {
                declare: true
              });
              if (result2)
                return result2;
            }
            if (tokenIsIdentifier(starttype)) {
              return this.tsParseDeclaration(nany, this.state.value, true, null);
            }
          });
        }
        tsTryParseExportDeclaration() {
          return this.tsParseDeclaration(this.startNode(), this.state.value, true, null);
        }
        tsParseExpressionStatement(node, expr, decorators) {
          switch (expr.name) {
            case "declare": {
              const declaration = this.tsTryParseDeclare(node);
              if (declaration) {
                declaration.declare = true;
                return declaration;
              }
              break;
            }
            case "global":
              if (this.match(5)) {
                this.scope.enter(SCOPE_TS_MODULE);
                this.prodParam.enter(PARAM);
                const mod = node;
                mod.global = true;
                mod.id = expr;
                mod.body = this.tsParseModuleBlock();
                this.scope.exit();
                this.prodParam.exit();
                return this.finishNode(mod, "TSModuleDeclaration");
              }
              break;
            default:
              return this.tsParseDeclaration(node, expr.name, false, decorators);
          }
        }
        tsParseDeclaration(node, value, next, decorators) {
          switch (value) {
            case "abstract":
              if (this.tsCheckLineTerminator(next) && (this.match(80) || tokenIsIdentifier(this.state.type))) {
                return this.tsParseAbstractDeclaration(node, decorators);
              }
              break;
            case "module":
              if (this.tsCheckLineTerminator(next)) {
                if (this.match(131)) {
                  return this.tsParseAmbientExternalModuleDeclaration(node);
                } else if (tokenIsIdentifier(this.state.type)) {
                  return this.tsParseModuleOrNamespaceDeclaration(node);
                }
              }
              break;
            case "namespace":
              if (this.tsCheckLineTerminator(next) && tokenIsIdentifier(this.state.type)) {
                return this.tsParseModuleOrNamespaceDeclaration(node);
              }
              break;
            case "type":
              if (this.tsCheckLineTerminator(next) && tokenIsIdentifier(this.state.type)) {
                return this.tsParseTypeAliasDeclaration(node);
              }
              break;
          }
        }
        tsCheckLineTerminator(next) {
          if (next) {
            if (this.hasFollowingLineBreak())
              return false;
            this.next();
            return true;
          }
          return !this.isLineTerminator();
        }
        tsTryParseGenericAsyncArrowFunction(startLoc) {
          if (!this.match(47)) {
            return void 0;
          }
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          this.state.maybeInArrowParameters = true;
          const res = this.tsTryParseAndCatch(() => {
            const node = this.startNodeAt(startLoc);
            node.typeParameters = this.tsParseTypeParameters();
            super.parseFunctionParams(node);
            node.returnType = this.tsTryParseTypeOrTypePredicateAnnotation();
            this.expect(19);
            return node;
          });
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          if (!res) {
            return void 0;
          }
          return super.parseArrowExpression(res, null, true);
        }
        tsParseTypeArgumentsInExpression() {
          if (this.reScan_lt() !== 47) {
            return void 0;
          }
          return this.tsParseTypeArguments();
        }
        tsParseTypeArguments() {
          const node = this.startNode();
          node.params = this.tsInType(() => this.tsInNoContext(() => {
            this.expect(47);
            return this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this));
          }));
          if (node.params.length === 0) {
            this.raise(TSErrors.EmptyTypeArguments, {
              at: node
            });
          }
          this.expect(48);
          return this.finishNode(node, "TSTypeParameterInstantiation");
        }
        tsIsDeclarationStart() {
          return tokenIsTSDeclarationStart(this.state.type);
        }
        isExportDefaultSpecifier() {
          if (this.tsIsDeclarationStart())
            return false;
          return super.isExportDefaultSpecifier();
        }
        parseAssignableListItem(allowModifiers, decorators) {
          const startLoc = this.state.startLoc;
          let accessibility;
          let readonly = false;
          let override = false;
          if (allowModifiers !== void 0) {
            const modified = {};
            this.tsParseModifiers({
              modified,
              allowedModifiers: ["public", "private", "protected", "override", "readonly"]
            });
            accessibility = modified.accessibility;
            override = modified.override;
            readonly = modified.readonly;
            if (allowModifiers === false && (accessibility || readonly || override)) {
              this.raise(TSErrors.UnexpectedParameterModifier, {
                at: startLoc
              });
            }
          }
          const left = this.parseMaybeDefault();
          this.parseAssignableListItemTypes(left);
          const elt = this.parseMaybeDefault(left.loc.start, left);
          if (accessibility || readonly || override) {
            const pp = this.startNodeAt(startLoc);
            if (decorators.length) {
              pp.decorators = decorators;
            }
            if (accessibility)
              pp.accessibility = accessibility;
            if (readonly)
              pp.readonly = readonly;
            if (override)
              pp.override = override;
            if (elt.type !== "Identifier" && elt.type !== "AssignmentPattern") {
              this.raise(TSErrors.UnsupportedParameterPropertyKind, {
                at: pp
              });
            }
            pp.parameter = elt;
            return this.finishNode(pp, "TSParameterProperty");
          }
          if (decorators.length) {
            left.decorators = decorators;
          }
          return elt;
        }
        isSimpleParameter(node) {
          return node.type === "TSParameterProperty" && super.isSimpleParameter(node.parameter) || super.isSimpleParameter(node);
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
          if (this.match(14)) {
            node.returnType = this.tsParseTypeOrTypePredicateAnnotation(14);
          }
          const bodilessType = type === "FunctionDeclaration" ? "TSDeclareFunction" : type === "ClassMethod" || type === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
          if (bodilessType && !this.match(5) && this.isLineTerminator()) {
            return this.finishNode(node, bodilessType);
          }
          if (bodilessType === "TSDeclareFunction" && this.state.isAmbientContext) {
            this.raise(TSErrors.DeclareFunctionHasImplementation, {
              at: node
            });
            if (node.declare) {
              return super.parseFunctionBodyAndFinish(node, bodilessType, isMethod);
            }
          }
          return super.parseFunctionBodyAndFinish(node, type, isMethod);
        }
        registerFunctionStatementId(node) {
          if (!node.body && node.id) {
            this.checkIdentifier(node.id, BIND_TS_AMBIENT);
          } else {
            super.registerFunctionStatementId(node);
          }
        }
        tsCheckForInvalidTypeCasts(items) {
          items.forEach((node) => {
            if ((node == null ? void 0 : node.type) === "TSTypeCastExpression") {
              this.raise(TSErrors.UnexpectedTypeAnnotation, {
                at: node.typeAnnotation
              });
            }
          });
        }
        toReferencedList(exprList, isInParens) {
          this.tsCheckForInvalidTypeCasts(exprList);
          return exprList;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
          const node = super.parseArrayLike(close, canBePattern, isTuple, refExpressionErrors);
          if (node.type === "ArrayExpression") {
            this.tsCheckForInvalidTypeCasts(node.elements);
          }
          return node;
        }
        parseSubscript(base, startLoc, noCalls, state) {
          if (!this.hasPrecedingLineBreak() && this.match(35)) {
            this.state.canStartJSXElement = false;
            this.next();
            const nonNullExpression = this.startNodeAt(startLoc);
            nonNullExpression.expression = base;
            return this.finishNode(nonNullExpression, "TSNonNullExpression");
          }
          let isOptionalCall = false;
          if (this.match(18) && this.lookaheadCharCode() === 60) {
            if (noCalls) {
              state.stop = true;
              return base;
            }
            state.optionalChainMember = isOptionalCall = true;
            this.next();
          }
          if (this.match(47) || this.match(51)) {
            let missingParenErrorLoc;
            const result2 = this.tsTryParseAndCatch(() => {
              if (!noCalls && this.atPossibleAsyncArrow(base)) {
                const asyncArrowFn = this.tsTryParseGenericAsyncArrowFunction(startLoc);
                if (asyncArrowFn) {
                  return asyncArrowFn;
                }
              }
              const typeArguments = this.tsParseTypeArgumentsInExpression();
              if (!typeArguments)
                return;
              if (isOptionalCall && !this.match(10)) {
                missingParenErrorLoc = this.state.curPosition();
                return;
              }
              if (tokenIsTemplate(this.state.type)) {
                const result3 = super.parseTaggedTemplateExpression(base, startLoc, state);
                result3.typeParameters = typeArguments;
                return result3;
              }
              if (!noCalls && this.eat(10)) {
                const node2 = this.startNodeAt(startLoc);
                node2.callee = base;
                node2.arguments = this.parseCallExpressionArguments(11, false);
                this.tsCheckForInvalidTypeCasts(node2.arguments);
                node2.typeParameters = typeArguments;
                if (state.optionalChainMember) {
                  node2.optional = isOptionalCall;
                }
                return this.finishCallExpression(node2, state.optionalChainMember);
              }
              const tokenType = this.state.type;
              if (tokenType === 48 || tokenType === 52 || tokenType !== 10 && tokenCanStartExpression(tokenType) && !this.hasPrecedingLineBreak()) {
                return;
              }
              const node = this.startNodeAt(startLoc);
              node.expression = base;
              node.typeParameters = typeArguments;
              return this.finishNode(node, "TSInstantiationExpression");
            });
            if (missingParenErrorLoc) {
              this.unexpected(missingParenErrorLoc, 10);
            }
            if (result2) {
              if (result2.type === "TSInstantiationExpression" && (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40)) {
                this.raise(TSErrors.InvalidPropertyAccessAfterInstantiationExpression, {
                  at: this.state.startLoc
                });
              }
              return result2;
            }
          }
          return super.parseSubscript(base, startLoc, noCalls, state);
        }
        parseNewCallee(node) {
          var _callee$extra;
          super.parseNewCallee(node);
          const {
            callee
          } = node;
          if (callee.type === "TSInstantiationExpression" && !((_callee$extra = callee.extra) != null && _callee$extra.parenthesized)) {
            node.typeParameters = callee.typeParameters;
            node.callee = callee.expression;
          }
        }
        parseExprOp(left, leftStartLoc, minPrec) {
          let isSatisfies;
          if (tokenOperatorPrecedence(58) > minPrec && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (isSatisfies = this.isContextual(118)))) {
            const node = this.startNodeAt(leftStartLoc);
            node.expression = left;
            node.typeAnnotation = this.tsInType(() => {
              this.next();
              if (this.match(75)) {
                if (isSatisfies) {
                  this.raise(Errors.UnexpectedKeyword, {
                    at: this.state.startLoc,
                    keyword: "const"
                  });
                }
                return this.tsParseTypeReference();
              }
              return this.tsParseType();
            });
            this.finishNode(node, isSatisfies ? "TSSatisfiesExpression" : "TSAsExpression");
            this.reScan_lt_gt();
            return this.parseExprOp(
              node,
              leftStartLoc,
              minPrec
            );
          }
          return super.parseExprOp(left, leftStartLoc, minPrec);
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
          if (!this.state.isAmbientContext) {
            super.checkReservedWord(word, startLoc, checkKeywords, isBinding);
          }
        }
        checkImportReflection(node) {
          super.checkImportReflection(node);
          if (node.module && node.importKind !== "value") {
            this.raise(TSErrors.ImportReflectionHasImportType, {
              at: node.specifiers[0].loc.start
            });
          }
        }
        checkDuplicateExports() {
        }
        parseImport(node) {
          node.importKind = "value";
          if (tokenIsIdentifier(this.state.type) || this.match(55) || this.match(5)) {
            let ahead = this.lookahead();
            if (this.isContextual(128) && ahead.type !== 12 && ahead.type !== 97 && ahead.type !== 29) {
              node.importKind = "type";
              this.next();
              ahead = this.lookahead();
            }
            if (tokenIsIdentifier(this.state.type) && ahead.type === 29) {
              return this.tsParseImportEqualsDeclaration(node);
            }
          }
          const importNode = super.parseImport(node);
          if (importNode.importKind === "type" && importNode.specifiers.length > 1 && importNode.specifiers[0].type === "ImportDefaultSpecifier") {
            this.raise(TSErrors.TypeImportCannotSpecifyDefaultAndNamed, {
              at: importNode
            });
          }
          return importNode;
        }
        parseExport(node, decorators) {
          if (this.match(83)) {
            this.next();
            if (this.isContextual(128) && this.lookaheadCharCode() !== 61) {
              node.importKind = "type";
              this.next();
            } else {
              node.importKind = "value";
            }
            return this.tsParseImportEqualsDeclaration(node, true);
          } else if (this.eat(29)) {
            const assign2 = node;
            assign2.expression = super.parseExpression();
            this.semicolon();
            return this.finishNode(assign2, "TSExportAssignment");
          } else if (this.eatContextual(93)) {
            const decl = node;
            this.expectContextual(126);
            decl.id = this.parseIdentifier();
            this.semicolon();
            return this.finishNode(decl, "TSNamespaceExportDeclaration");
          } else {
            if (this.isContextual(128) && this.lookahead().type === 5) {
              this.next();
              node.exportKind = "type";
            } else {
              node.exportKind = "value";
            }
            return super.parseExport(node, decorators);
          }
        }
        isAbstractClass() {
          return this.isContextual(122) && this.lookahead().type === 80;
        }
        parseExportDefaultExpression() {
          if (this.isAbstractClass()) {
            const cls = this.startNode();
            this.next();
            cls.abstract = true;
            return this.parseClass(cls, true, true);
          }
          if (this.match(127)) {
            const result2 = this.tsParseInterfaceDeclaration(this.startNode());
            if (result2)
              return result2;
          }
          return super.parseExportDefaultExpression();
        }
        parseVarStatement(node, kind, allowMissingInitializer = false) {
          const {
            isAmbientContext
          } = this.state;
          const declaration = super.parseVarStatement(node, kind, allowMissingInitializer || isAmbientContext);
          if (!isAmbientContext)
            return declaration;
          for (const {
            id,
            init
          } of declaration.declarations) {
            if (!init)
              continue;
            if (kind !== "const" || !!id.typeAnnotation) {
              this.raise(TSErrors.InitializerNotAllowedInAmbientContext, {
                at: init
              });
            } else if (init.type !== "StringLiteral" && init.type !== "BooleanLiteral" && init.type !== "NumericLiteral" && init.type !== "BigIntLiteral" && (init.type !== "TemplateLiteral" || init.expressions.length > 0) && !isPossiblyLiteralEnum(init)) {
              this.raise(TSErrors.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, {
                at: init
              });
            }
          }
          return declaration;
        }
        parseStatementContent(context, topLevel, decorators) {
          if (this.match(75) && this.isLookaheadContextual("enum")) {
            const node = this.startNode();
            this.expect(75);
            return this.tsParseEnumDeclaration(node, {
              const: true
            });
          }
          if (this.isContextual(124)) {
            return this.tsParseEnumDeclaration(this.startNode());
          }
          if (this.isContextual(127)) {
            const result2 = this.tsParseInterfaceDeclaration(this.startNode());
            if (result2)
              return result2;
          }
          return super.parseStatementContent(context, topLevel, decorators);
        }
        parseAccessModifier() {
          return this.tsParseModifier(["public", "protected", "private"]);
        }
        tsHasSomeModifiers(member, modifiers) {
          return modifiers.some((modifier) => {
            if (tsIsAccessModifier(modifier)) {
              return member.accessibility === modifier;
            }
            return !!member[modifier];
          });
        }
        tsIsStartOfStaticBlocks() {
          return this.isContextual(104) && this.lookaheadCharCode() === 123;
        }
        parseClassMember(classBody, member, state) {
          const modifiers = ["declare", "private", "public", "protected", "override", "abstract", "readonly", "static"];
          this.tsParseModifiers({
            modified: member,
            allowedModifiers: modifiers,
            disallowedModifiers: ["in", "out"],
            stopOnStartOfClassStaticBlock: true,
            errorTemplate: TSErrors.InvalidModifierOnTypeParameterPositions
          });
          const callParseClassMemberWithIsStatic = () => {
            if (this.tsIsStartOfStaticBlocks()) {
              this.next();
              this.next();
              if (this.tsHasSomeModifiers(member, modifiers)) {
                this.raise(TSErrors.StaticBlockCannotHaveModifier, {
                  at: this.state.curPosition()
                });
              }
              super.parseClassStaticBlock(classBody, member);
            } else {
              this.parseClassMemberWithIsStatic(classBody, member, state, !!member.static);
            }
          };
          if (member.declare) {
            this.tsInAmbientContext(callParseClassMemberWithIsStatic);
          } else {
            callParseClassMemberWithIsStatic();
          }
        }
        parseClassMemberWithIsStatic(classBody, member, state, isStatic) {
          const idx = this.tsTryParseIndexSignature(member);
          if (idx) {
            classBody.body.push(idx);
            if (member.abstract) {
              this.raise(TSErrors.IndexSignatureHasAbstract, {
                at: member
              });
            }
            if (member.accessibility) {
              this.raise(TSErrors.IndexSignatureHasAccessibility, {
                at: member,
                modifier: member.accessibility
              });
            }
            if (member.declare) {
              this.raise(TSErrors.IndexSignatureHasDeclare, {
                at: member
              });
            }
            if (member.override) {
              this.raise(TSErrors.IndexSignatureHasOverride, {
                at: member
              });
            }
            return;
          }
          if (!this.state.inAbstractClass && member.abstract) {
            this.raise(TSErrors.NonAbstractClassHasAbstractMethod, {
              at: member
            });
          }
          if (member.override) {
            if (!state.hadSuperClass) {
              this.raise(TSErrors.OverrideNotInSubClass, {
                at: member
              });
            }
          }
          super.parseClassMemberWithIsStatic(classBody, member, state, isStatic);
        }
        parsePostMemberNameModifiers(methodOrProp) {
          const optional = this.eat(17);
          if (optional)
            methodOrProp.optional = true;
          if (methodOrProp.readonly && this.match(10)) {
            this.raise(TSErrors.ClassMethodHasReadonly, {
              at: methodOrProp
            });
          }
          if (methodOrProp.declare && this.match(10)) {
            this.raise(TSErrors.ClassMethodHasDeclare, {
              at: methodOrProp
            });
          }
        }
        parseExpressionStatement(node, expr, decorators) {
          const decl = expr.type === "Identifier" ? this.tsParseExpressionStatement(node, expr, decorators) : void 0;
          return decl || super.parseExpressionStatement(node, expr, decorators);
        }
        shouldParseExportDeclaration() {
          if (this.tsIsDeclarationStart())
            return true;
          return super.shouldParseExportDeclaration();
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
          if (!this.state.maybeInArrowParameters || !this.match(17)) {
            return super.parseConditional(expr, startLoc, refExpressionErrors);
          }
          const result2 = this.tryParse(() => super.parseConditional(expr, startLoc));
          if (!result2.node) {
            if (result2.error) {
              super.setOptionalParametersError(refExpressionErrors, result2.error);
            }
            return expr;
          }
          if (result2.error)
            this.state = result2.failState;
          return result2.node;
        }
        parseParenItem(node, startLoc) {
          node = super.parseParenItem(node, startLoc);
          if (this.eat(17)) {
            node.optional = true;
            this.resetEndLocation(node);
          }
          if (this.match(14)) {
            const typeCastNode = this.startNodeAt(startLoc);
            typeCastNode.expression = node;
            typeCastNode.typeAnnotation = this.tsParseTypeAnnotation();
            return this.finishNode(typeCastNode, "TSTypeCastExpression");
          }
          return node;
        }
        parseExportDeclaration(node) {
          if (!this.state.isAmbientContext && this.isContextual(123)) {
            return this.tsInAmbientContext(() => this.parseExportDeclaration(node));
          }
          const startLoc = this.state.startLoc;
          const isDeclare = this.eatContextual(123);
          if (isDeclare && (this.isContextual(123) || !this.shouldParseExportDeclaration())) {
            throw this.raise(TSErrors.ExpectedAmbientAfterExportDeclare, {
              at: this.state.startLoc
            });
          }
          const isIdentifier2 = tokenIsIdentifier(this.state.type);
          const declaration = isIdentifier2 && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(node);
          if (!declaration)
            return null;
          if (declaration.type === "TSInterfaceDeclaration" || declaration.type === "TSTypeAliasDeclaration" || isDeclare) {
            node.exportKind = "type";
          }
          if (isDeclare) {
            this.resetStartLocation(declaration, startLoc);
            declaration.declare = true;
          }
          return declaration;
        }
        parseClassId(node, isStatement, optionalId, bindingType) {
          if ((!isStatement || optionalId) && this.isContextual(111)) {
            return;
          }
          super.parseClassId(node, isStatement, optionalId, node.declare ? BIND_TS_AMBIENT : BIND_CLASS);
          const typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this));
          if (typeParameters)
            node.typeParameters = typeParameters;
        }
        parseClassPropertyAnnotation(node) {
          if (!node.optional && this.eat(35)) {
            node.definite = true;
          }
          const type = this.tsTryParseTypeAnnotation();
          if (type)
            node.typeAnnotation = type;
        }
        parseClassProperty(node) {
          this.parseClassPropertyAnnotation(node);
          if (this.state.isAmbientContext && !(node.readonly && !node.typeAnnotation) && this.match(29)) {
            this.raise(TSErrors.DeclareClassFieldHasInitializer, {
              at: this.state.startLoc
            });
          }
          if (node.abstract && this.match(29)) {
            const {
              key
            } = node;
            this.raise(TSErrors.AbstractPropertyHasInitializer, {
              at: this.state.startLoc,
              propertyName: key.type === "Identifier" && !node.computed ? key.name : `[${this.input.slice(key.start, key.end)}]`
            });
          }
          return super.parseClassProperty(node);
        }
        parseClassPrivateProperty(node) {
          if (node.abstract) {
            this.raise(TSErrors.PrivateElementHasAbstract, {
              at: node
            });
          }
          if (node.accessibility) {
            this.raise(TSErrors.PrivateElementHasAccessibility, {
              at: node,
              modifier: node.accessibility
            });
          }
          this.parseClassPropertyAnnotation(node);
          return super.parseClassPrivateProperty(node);
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          const typeParameters = this.tsTryParseTypeParameters();
          if (typeParameters && isConstructor) {
            this.raise(TSErrors.ConstructorHasTypeParameters, {
              at: typeParameters
            });
          }
          const {
            declare = false,
            kind
          } = method2;
          if (declare && (kind === "get" || kind === "set")) {
            this.raise(TSErrors.DeclareAccessor, {
              at: method2,
              kind
            });
          }
          if (typeParameters)
            method2.typeParameters = typeParameters;
          super.pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper);
        }
        pushClassPrivateMethod(classBody, method2, isGenerator, isAsync) {
          const typeParameters = this.tsTryParseTypeParameters();
          if (typeParameters)
            method2.typeParameters = typeParameters;
          super.pushClassPrivateMethod(classBody, method2, isGenerator, isAsync);
        }
        declareClassPrivateMethodInScope(node, kind) {
          if (node.type === "TSDeclareMethod")
            return;
          if (node.type === "MethodDefinition" && !node.value.body)
            return;
          super.declareClassPrivateMethodInScope(node, kind);
        }
        parseClassSuper(node) {
          super.parseClassSuper(node);
          if (node.superClass && (this.match(47) || this.match(51))) {
            node.superTypeParameters = this.tsParseTypeArgumentsInExpression();
          }
          if (this.eatContextual(111)) {
            node.implements = this.tsParseHeritageClause("implements");
          }
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
          const typeParameters = this.tsTryParseTypeParameters();
          if (typeParameters)
            prop.typeParameters = typeParameters;
          return super.parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors);
        }
        parseFunctionParams(node, allowModifiers) {
          const typeParameters = this.tsTryParseTypeParameters();
          if (typeParameters)
            node.typeParameters = typeParameters;
          super.parseFunctionParams(node, allowModifiers);
        }
        parseVarId(decl, kind) {
          super.parseVarId(decl, kind);
          if (decl.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35)) {
            decl.definite = true;
          }
          const type = this.tsTryParseTypeAnnotation();
          if (type) {
            decl.id.typeAnnotation = type;
            this.resetEndLocation(decl.id);
          }
        }
        parseAsyncArrowFromCallExpression(node, call) {
          if (this.match(14)) {
            node.returnType = this.tsParseTypeAnnotation();
          }
          return super.parseAsyncArrowFromCallExpression(node, call);
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
          var _jsx, _jsx2, _typeCast, _jsx3, _typeCast2, _jsx4, _typeCast3;
          let state;
          let jsx2;
          let typeCast;
          if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
            state = this.state.clone();
            jsx2 = this.tryParse(() => super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
            if (!jsx2.error)
              return jsx2.node;
            const {
              context
            } = this.state;
            const currentContext = context[context.length - 1];
            if (currentContext === types.j_oTag || currentContext === types.j_expr) {
              context.pop();
            }
          }
          if (!((_jsx = jsx2) != null && _jsx.error) && !this.match(47)) {
            return super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
          }
          if (!state || state === this.state)
            state = this.state.clone();
          let typeParameters;
          const arrow = this.tryParse((abort) => {
            var _expr$extra, _typeParameters;
            typeParameters = this.tsParseTypeParameters();
            const expr = super.parseMaybeAssign(refExpressionErrors, afterLeftParse);
            if (expr.type !== "ArrowFunctionExpression" || (_expr$extra = expr.extra) != null && _expr$extra.parenthesized) {
              abort();
            }
            if (((_typeParameters = typeParameters) == null ? void 0 : _typeParameters.params.length) !== 0) {
              this.resetStartLocationFromNode(expr, typeParameters);
            }
            expr.typeParameters = typeParameters;
            return expr;
          }, state);
          if (!arrow.error && !arrow.aborted) {
            if (typeParameters)
              this.reportReservedArrowTypeParam(typeParameters);
            return arrow.node;
          }
          if (!jsx2) {
            assert(!this.hasPlugin("jsx"));
            typeCast = this.tryParse(() => super.parseMaybeAssign(refExpressionErrors, afterLeftParse), state);
            if (!typeCast.error)
              return typeCast.node;
          }
          if ((_jsx2 = jsx2) != null && _jsx2.node) {
            this.state = jsx2.failState;
            return jsx2.node;
          }
          if (arrow.node) {
            this.state = arrow.failState;
            if (typeParameters)
              this.reportReservedArrowTypeParam(typeParameters);
            return arrow.node;
          }
          if ((_typeCast = typeCast) != null && _typeCast.node) {
            this.state = typeCast.failState;
            return typeCast.node;
          }
          if ((_jsx3 = jsx2) != null && _jsx3.thrown)
            throw jsx2.error;
          if (arrow.thrown)
            throw arrow.error;
          if ((_typeCast2 = typeCast) != null && _typeCast2.thrown)
            throw typeCast.error;
          throw ((_jsx4 = jsx2) == null ? void 0 : _jsx4.error) || arrow.error || ((_typeCast3 = typeCast) == null ? void 0 : _typeCast3.error);
        }
        reportReservedArrowTypeParam(node) {
          var _node$extra;
          if (node.params.length === 1 && !((_node$extra = node.extra) != null && _node$extra.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike")) {
            this.raise(TSErrors.ReservedArrowTypeParam, {
              at: node
            });
          }
        }
        parseMaybeUnary(refExpressionErrors, sawUnary) {
          if (!this.hasPlugin("jsx") && this.match(47)) {
            return this.tsParseTypeAssertion();
          } else {
            return super.parseMaybeUnary(refExpressionErrors, sawUnary);
          }
        }
        parseArrow(node) {
          if (this.match(14)) {
            const result2 = this.tryParse((abort) => {
              const returnType = this.tsParseTypeOrTypePredicateAnnotation(14);
              if (this.canInsertSemicolon() || !this.match(19))
                abort();
              return returnType;
            });
            if (result2.aborted)
              return;
            if (!result2.thrown) {
              if (result2.error)
                this.state = result2.failState;
              node.returnType = result2.node;
            }
          }
          return super.parseArrow(node);
        }
        parseAssignableListItemTypes(param) {
          if (this.eat(17)) {
            if (param.type !== "Identifier" && !this.state.isAmbientContext && !this.state.inType) {
              this.raise(TSErrors.PatternIsOptional, {
                at: param
              });
            }
            param.optional = true;
          }
          const type = this.tsTryParseTypeAnnotation();
          if (type)
            param.typeAnnotation = type;
          this.resetEndLocation(param);
          return param;
        }
        isAssignable(node, isBinding) {
          switch (node.type) {
            case "TSTypeCastExpression":
              return this.isAssignable(node.expression, isBinding);
            case "TSParameterProperty":
              return true;
            default:
              return super.isAssignable(node, isBinding);
          }
        }
        toAssignable(node, isLHS = false) {
          switch (node.type) {
            case "ParenthesizedExpression":
              this.toAssignableParenthesizedExpression(node, isLHS);
              break;
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSNonNullExpression":
            case "TSTypeAssertion":
              if (isLHS) {
                this.expressionScope.recordArrowParemeterBindingError(TSErrors.UnexpectedTypeCastInParameter, {
                  at: node
                });
              } else {
                this.raise(TSErrors.UnexpectedTypeCastInParameter, {
                  at: node
                });
              }
              this.toAssignable(node.expression, isLHS);
              break;
            case "AssignmentExpression":
              if (!isLHS && node.left.type === "TSTypeCastExpression") {
                node.left = this.typeCastToParameter(node.left);
              }
            default:
              super.toAssignable(node, isLHS);
          }
        }
        toAssignableParenthesizedExpression(node, isLHS) {
          switch (node.expression.type) {
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSNonNullExpression":
            case "TSTypeAssertion":
            case "ParenthesizedExpression":
              this.toAssignable(node.expression, isLHS);
              break;
            default:
              super.toAssignable(node, isLHS);
          }
        }
        checkToRestConversion(node, allowPattern) {
          switch (node.type) {
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSTypeAssertion":
            case "TSNonNullExpression":
              this.checkToRestConversion(node.expression, false);
              break;
            default:
              super.checkToRestConversion(node, allowPattern);
          }
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding) {
          return getOwn$1({
            TSTypeCastExpression: true,
            TSParameterProperty: "parameter",
            TSNonNullExpression: "expression",
            TSAsExpression: (binding !== BIND_NONE || !isUnparenthesizedInAssign) && ["expression", true],
            TSSatisfiesExpression: (binding !== BIND_NONE || !isUnparenthesizedInAssign) && ["expression", true],
            TSTypeAssertion: (binding !== BIND_NONE || !isUnparenthesizedInAssign) && ["expression", true]
          }, type) || super.isValidLVal(type, isUnparenthesizedInAssign, binding);
        }
        parseBindingAtom() {
          switch (this.state.type) {
            case 78:
              return this.parseIdentifier(true);
            default:
              return super.parseBindingAtom();
          }
        }
        parseMaybeDecoratorArguments(expr) {
          if (this.match(47) || this.match(51)) {
            const typeArguments = this.tsParseTypeArgumentsInExpression();
            if (this.match(10)) {
              const call = super.parseMaybeDecoratorArguments(expr);
              call.typeParameters = typeArguments;
              return call;
            }
            this.unexpected(null, 10);
          }
          return super.parseMaybeDecoratorArguments(expr);
        }
        checkCommaAfterRest(close) {
          if (this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === close) {
            this.next();
            return false;
          } else {
            return super.checkCommaAfterRest(close);
          }
        }
        isClassMethod() {
          return this.match(47) || super.isClassMethod();
        }
        isClassProperty() {
          return this.match(35) || this.match(14) || super.isClassProperty();
        }
        parseMaybeDefault(startLoc, left) {
          const node = super.parseMaybeDefault(startLoc, left);
          if (node.type === "AssignmentPattern" && node.typeAnnotation && node.right.start < node.typeAnnotation.start) {
            this.raise(TSErrors.TypeAnnotationAfterAssign, {
              at: node.typeAnnotation
            });
          }
          return node;
        }
        getTokenFromCode(code) {
          if (this.state.inType) {
            if (code === 62) {
              return this.finishOp(48, 1);
            }
            if (code === 60) {
              return this.finishOp(47, 1);
            }
          }
          return super.getTokenFromCode(code);
        }
        reScan_lt_gt() {
          const {
            type
          } = this.state;
          if (type === 47) {
            this.state.pos -= 1;
            this.readToken_lt();
          } else if (type === 48) {
            this.state.pos -= 1;
            this.readToken_gt();
          }
        }
        reScan_lt() {
          const {
            type
          } = this.state;
          if (type === 51) {
            this.state.pos -= 2;
            this.finishOp(47, 1);
            return 47;
          }
          return type;
        }
        toAssignableList(exprList, trailingCommaLoc, isLHS) {
          for (let i = 0; i < exprList.length; i++) {
            const expr = exprList[i];
            if ((expr == null ? void 0 : expr.type) === "TSTypeCastExpression") {
              exprList[i] = this.typeCastToParameter(expr);
            }
          }
          super.toAssignableList(exprList, trailingCommaLoc, isLHS);
        }
        typeCastToParameter(node) {
          node.expression.typeAnnotation = node.typeAnnotation;
          this.resetEndLocation(node.expression, node.typeAnnotation.loc.end);
          return node.expression;
        }
        shouldParseArrow(params) {
          if (this.match(14)) {
            return params.every((expr) => this.isAssignable(expr, true));
          }
          return super.shouldParseArrow(params);
        }
        shouldParseAsyncArrow() {
          return this.match(14) || super.shouldParseAsyncArrow();
        }
        canHaveLeadingDecorator() {
          return super.canHaveLeadingDecorator() || this.isAbstractClass();
        }
        jsxParseOpeningElementAfterName(node) {
          if (this.match(47) || this.match(51)) {
            const typeArguments = this.tsTryParseAndCatch(() => this.tsParseTypeArgumentsInExpression());
            if (typeArguments)
              node.typeParameters = typeArguments;
          }
          return super.jsxParseOpeningElementAfterName(node);
        }
        getGetterSetterExpectedParamCount(method2) {
          const baseCount = super.getGetterSetterExpectedParamCount(method2);
          const params = this.getObjectOrClassMethodParams(method2);
          const firstParam = params[0];
          const hasContextParam = firstParam && this.isThisParam(firstParam);
          return hasContextParam ? baseCount + 1 : baseCount;
        }
        parseCatchClauseParam() {
          const param = super.parseCatchClauseParam();
          const type = this.tsTryParseTypeAnnotation();
          if (type) {
            param.typeAnnotation = type;
            this.resetEndLocation(param);
          }
          return param;
        }
        tsInAmbientContext(cb) {
          const oldIsAmbientContext = this.state.isAmbientContext;
          this.state.isAmbientContext = true;
          try {
            return cb();
          } finally {
            this.state.isAmbientContext = oldIsAmbientContext;
          }
        }
        parseClass(node, isStatement, optionalId) {
          const oldInAbstractClass = this.state.inAbstractClass;
          this.state.inAbstractClass = !!node.abstract;
          try {
            return super.parseClass(node, isStatement, optionalId);
          } finally {
            this.state.inAbstractClass = oldInAbstractClass;
          }
        }
        tsParseAbstractDeclaration(node, decorators) {
          if (this.match(80)) {
            node.abstract = true;
            return this.maybeTakeDecorators(decorators, this.parseClass(node, true, false));
          } else if (this.isContextual(127)) {
            if (!this.hasFollowingLineBreak()) {
              node.abstract = true;
              this.raise(TSErrors.NonClassMethodPropertyHasAbstractModifer, {
                at: node
              });
              return this.tsParseInterfaceDeclaration(node);
            }
          } else {
            this.unexpected(null, 80);
          }
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope) {
          const method2 = super.parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope);
          if (method2.abstract) {
            const hasBody = this.hasPlugin("estree") ? !!method2.value.body : !!method2.body;
            if (hasBody) {
              const {
                key
              } = method2;
              this.raise(TSErrors.AbstractMethodHasImplementation, {
                at: method2,
                methodName: key.type === "Identifier" && !method2.computed ? key.name : `[${this.input.slice(key.start, key.end)}]`
              });
            }
          }
          return method2;
        }
        tsParseTypeParameterName() {
          const typeName = this.parseIdentifier();
          return typeName.name;
        }
        shouldParseAsAmbientContext() {
          return !!this.getPluginOption("typescript", "dts");
        }
        parse() {
          if (this.shouldParseAsAmbientContext()) {
            this.state.isAmbientContext = true;
          }
          return super.parse();
        }
        getExpression() {
          if (this.shouldParseAsAmbientContext()) {
            this.state.isAmbientContext = true;
          }
          return super.getExpression();
        }
        parseExportSpecifier(node, isString2, isInTypeExport, isMaybeTypeOnly) {
          if (!isString2 && isMaybeTypeOnly) {
            this.parseTypeOnlyImportExportSpecifier(node, false, isInTypeExport);
            return this.finishNode(node, "ExportSpecifier");
          }
          node.exportKind = "value";
          return super.parseExportSpecifier(node, isString2, isInTypeExport, isMaybeTypeOnly);
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
          if (!importedIsString && isMaybeTypeOnly) {
            this.parseTypeOnlyImportExportSpecifier(specifier, true, isInTypeOnlyImport);
            return this.finishNode(specifier, "ImportSpecifier");
          }
          specifier.importKind = "value";
          return super.parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, isInTypeOnlyImport ? BIND_TS_TYPE_IMPORT : BIND_FLAGS_TS_IMPORT);
        }
        parseTypeOnlyImportExportSpecifier(node, isImport, isInTypeOnlyImportExport) {
          const leftOfAsKey = isImport ? "imported" : "local";
          const rightOfAsKey = isImport ? "local" : "exported";
          let leftOfAs = node[leftOfAsKey];
          let rightOfAs;
          let hasTypeSpecifier = false;
          let canParseAsKeyword = true;
          const loc = leftOfAs.loc.start;
          if (this.isContextual(93)) {
            const firstAs = this.parseIdentifier();
            if (this.isContextual(93)) {
              const secondAs = this.parseIdentifier();
              if (tokenIsKeywordOrIdentifier(this.state.type)) {
                hasTypeSpecifier = true;
                leftOfAs = firstAs;
                rightOfAs = isImport ? this.parseIdentifier() : this.parseModuleExportName();
                canParseAsKeyword = false;
              } else {
                rightOfAs = secondAs;
                canParseAsKeyword = false;
              }
            } else if (tokenIsKeywordOrIdentifier(this.state.type)) {
              canParseAsKeyword = false;
              rightOfAs = isImport ? this.parseIdentifier() : this.parseModuleExportName();
            } else {
              hasTypeSpecifier = true;
              leftOfAs = firstAs;
            }
          } else if (tokenIsKeywordOrIdentifier(this.state.type)) {
            hasTypeSpecifier = true;
            if (isImport) {
              leftOfAs = this.parseIdentifier(true);
              if (!this.isContextual(93)) {
                this.checkReservedWord(leftOfAs.name, leftOfAs.loc.start, true, true);
              }
            } else {
              leftOfAs = this.parseModuleExportName();
            }
          }
          if (hasTypeSpecifier && isInTypeOnlyImportExport) {
            this.raise(isImport ? TSErrors.TypeModifierIsUsedInTypeImports : TSErrors.TypeModifierIsUsedInTypeExports, {
              at: loc
            });
          }
          node[leftOfAsKey] = leftOfAs;
          node[rightOfAsKey] = rightOfAs;
          const kindKey = isImport ? "importKind" : "exportKind";
          node[kindKey] = hasTypeSpecifier ? "type" : "value";
          if (canParseAsKeyword && this.eatContextual(93)) {
            node[rightOfAsKey] = isImport ? this.parseIdentifier() : this.parseModuleExportName();
          }
          if (!node[rightOfAsKey]) {
            node[rightOfAsKey] = cloneIdentifier(node[leftOfAsKey]);
          }
          if (isImport) {
            this.checkIdentifier(node[rightOfAsKey], hasTypeSpecifier ? BIND_TS_TYPE_IMPORT : BIND_FLAGS_TS_IMPORT);
          }
        }
      };
      function isPossiblyLiteralEnum(expression) {
        if (expression.type !== "MemberExpression")
          return false;
        const {
          computed,
          property: property2
        } = expression;
        if (computed && property2.type !== "StringLiteral" && (property2.type !== "TemplateLiteral" || property2.expressions.length > 0)) {
          return false;
        }
        return isUncomputedMemberExpressionChain(expression.object);
      }
      function isUncomputedMemberExpressionChain(expression) {
        if (expression.type === "Identifier")
          return true;
        if (expression.type !== "MemberExpression")
          return false;
        if (expression.computed)
          return false;
        return isUncomputedMemberExpressionChain(expression.object);
      }
      var PlaceholderErrors = ParseErrorEnum`placeholders`({
        ClassNameIsRequired: "A class name is required.",
        UnexpectedSpace: "Unexpected space in placeholder."
      });
      var placeholders = (superClass) => class PlaceholdersParserMixin extends superClass {
        parsePlaceholder(expectedNode) {
          if (this.match(142)) {
            const node = this.startNode();
            this.next();
            this.assertNoSpace();
            node.name = super.parseIdentifier(true);
            this.assertNoSpace();
            this.expect(142);
            return this.finishPlaceholder(node, expectedNode);
          }
        }
        finishPlaceholder(node, expectedNode) {
          const isFinished = !!(node.expectedNode && node.type === "Placeholder");
          node.expectedNode = expectedNode;
          return isFinished ? node : this.finishNode(node, "Placeholder");
        }
        getTokenFromCode(code) {
          if (code === 37 && this.input.charCodeAt(this.state.pos + 1) === 37) {
            return this.finishOp(142, 2);
          }
          return super.getTokenFromCode(code);
        }
        parseExprAtom(refExpressionErrors) {
          return this.parsePlaceholder("Expression") || super.parseExprAtom(refExpressionErrors);
        }
        parseIdentifier(liberal) {
          return this.parsePlaceholder("Identifier") || super.parseIdentifier(liberal);
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
          if (word !== void 0) {
            super.checkReservedWord(word, startLoc, checkKeywords, isBinding);
          }
        }
        parseBindingAtom() {
          return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
        }
        isValidLVal(type, isParenthesized, binding) {
          return type === "Placeholder" || super.isValidLVal(type, isParenthesized, binding);
        }
        toAssignable(node, isLHS) {
          if (node && node.type === "Placeholder" && node.expectedNode === "Expression") {
            node.expectedNode = "Pattern";
          } else {
            super.toAssignable(node, isLHS);
          }
        }
        hasFollowingIdentifier(context) {
          if (super.hasFollowingIdentifier(context)) {
            return true;
          }
          if (context)
            return false;
          const nextToken = this.lookahead();
          if (nextToken.type === 142) {
            return true;
          }
          return false;
        }
        verifyBreakContinue(node, isBreak) {
          if (node.label && node.label.type === "Placeholder")
            return;
          super.verifyBreakContinue(node, isBreak);
        }
        parseExpressionStatement(node, expr) {
          if (expr.type !== "Placeholder" || expr.extra && expr.extra.parenthesized) {
            return super.parseExpressionStatement(node, expr);
          }
          if (this.match(14)) {
            const stmt = node;
            stmt.label = this.finishPlaceholder(expr, "Identifier");
            this.next();
            stmt.body = super.parseStatement("label");
            return this.finishNode(stmt, "LabeledStatement");
          }
          this.semicolon();
          node.name = expr.name;
          return this.finishPlaceholder(node, "Statement");
        }
        parseBlock(allowDirectives, createNewLexicalScope, afterBlockParse) {
          return this.parsePlaceholder("BlockStatement") || super.parseBlock(allowDirectives, createNewLexicalScope, afterBlockParse);
        }
        parseFunctionId(requireId) {
          return this.parsePlaceholder("Identifier") || super.parseFunctionId(requireId);
        }
        parseClass(node, isStatement, optionalId) {
          const type = isStatement ? "ClassDeclaration" : "ClassExpression";
          this.next();
          const oldStrict = this.state.strict;
          const placeholder = this.parsePlaceholder("Identifier");
          if (placeholder) {
            if (this.match(81) || this.match(142) || this.match(5)) {
              node.id = placeholder;
            } else if (optionalId || !isStatement) {
              node.id = null;
              node.body = this.finishPlaceholder(placeholder, "ClassBody");
              return this.finishNode(node, type);
            } else {
              throw this.raise(PlaceholderErrors.ClassNameIsRequired, {
                at: this.state.startLoc
              });
            }
          } else {
            this.parseClassId(node, isStatement, optionalId);
          }
          super.parseClassSuper(node);
          node.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!node.superClass, oldStrict);
          return this.finishNode(node, type);
        }
        parseExport(node, decorators) {
          const placeholder = this.parsePlaceholder("Identifier");
          if (!placeholder)
            return super.parseExport(node, decorators);
          if (!this.isContextual(97) && !this.match(12)) {
            node.specifiers = [];
            node.source = null;
            node.declaration = this.finishPlaceholder(placeholder, "Declaration");
            return this.finishNode(node, "ExportNamedDeclaration");
          }
          this.expectPlugin("exportDefaultFrom");
          const specifier = this.startNode();
          specifier.exported = placeholder;
          node.specifiers = [this.finishNode(specifier, "ExportDefaultSpecifier")];
          return super.parseExport(node, decorators);
        }
        isExportDefaultSpecifier() {
          if (this.match(65)) {
            const next = this.nextTokenStart();
            if (this.isUnparsedContextual(next, "from")) {
              if (this.input.startsWith(tokenLabelName(142), this.nextTokenStartSince(next + 4))) {
                return true;
              }
            }
          }
          return super.isExportDefaultSpecifier();
        }
        maybeParseExportDefaultSpecifier(node) {
          if (node.specifiers && node.specifiers.length > 0) {
            return true;
          }
          return super.maybeParseExportDefaultSpecifier(node);
        }
        checkExport(node) {
          const {
            specifiers
          } = node;
          if (specifiers != null && specifiers.length) {
            node.specifiers = specifiers.filter(
              (node2) => node2.exported.type === "Placeholder"
            );
          }
          super.checkExport(node);
          node.specifiers = specifiers;
        }
        parseImport(node) {
          const placeholder = this.parsePlaceholder("Identifier");
          if (!placeholder)
            return super.parseImport(node);
          node.specifiers = [];
          if (!this.isContextual(97) && !this.match(12)) {
            node.source = this.finishPlaceholder(placeholder, "StringLiteral");
            this.semicolon();
            return this.finishNode(node, "ImportDeclaration");
          }
          const specifier = this.startNodeAtNode(placeholder);
          specifier.local = placeholder;
          node.specifiers.push(this.finishNode(specifier, "ImportDefaultSpecifier"));
          if (this.eat(12)) {
            const hasStarImport = this.maybeParseStarImportSpecifier(node);
            if (!hasStarImport)
              this.parseNamedImportSpecifiers(node);
          }
          this.expectContextual(97);
          node.source = this.parseImportSource();
          this.semicolon();
          return this.finishNode(node, "ImportDeclaration");
        }
        parseImportSource() {
          return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
        }
        assertNoSpace() {
          if (this.state.start > this.state.lastTokEndLoc.index) {
            this.raise(PlaceholderErrors.UnexpectedSpace, {
              at: this.state.lastTokEndLoc
            });
          }
        }
      };
      var v8intrinsic = (superClass) => class V8IntrinsicMixin extends superClass {
        parseV8Intrinsic() {
          if (this.match(54)) {
            const v8IntrinsicStartLoc = this.state.startLoc;
            const node = this.startNode();
            this.next();
            if (tokenIsIdentifier(this.state.type)) {
              const name = this.parseIdentifierName();
              const identifier3 = this.createIdentifier(node, name);
              identifier3.type = "V8IntrinsicIdentifier";
              if (this.match(10)) {
                return identifier3;
              }
            }
            this.unexpected(v8IntrinsicStartLoc);
          }
        }
        parseExprAtom(refExpressionErrors) {
          return this.parseV8Intrinsic() || super.parseExprAtom(refExpressionErrors);
        }
      };
      function hasPlugin(plugins5, expectedConfig) {
        const [expectedName, expectedOptions] = typeof expectedConfig === "string" ? [expectedConfig, {}] : expectedConfig;
        const expectedKeys = Object.keys(expectedOptions);
        const expectedOptionsIsEmpty = expectedKeys.length === 0;
        return plugins5.some((p) => {
          if (typeof p === "string") {
            return expectedOptionsIsEmpty && p === expectedName;
          } else {
            const [pluginName, pluginOptions] = p;
            if (pluginName !== expectedName) {
              return false;
            }
            for (const key of expectedKeys) {
              if (pluginOptions[key] !== expectedOptions[key]) {
                return false;
              }
            }
            return true;
          }
        });
      }
      function getPluginOption(plugins5, name, option) {
        const plugin = plugins5.find((plugin2) => {
          if (Array.isArray(plugin2)) {
            return plugin2[0] === name;
          } else {
            return plugin2 === name;
          }
        });
        if (plugin && Array.isArray(plugin) && plugin.length > 1) {
          return plugin[1][option];
        }
        return null;
      }
      var PIPELINE_PROPOSALS = ["minimal", "fsharp", "hack", "smart"];
      var TOPIC_TOKENS = ["^^", "@@", "^", "%", "#"];
      var RECORD_AND_TUPLE_SYNTAX_TYPES = ["hash", "bar"];
      function validatePlugins(plugins5) {
        if (hasPlugin(plugins5, "decorators")) {
          if (hasPlugin(plugins5, "decorators-legacy")) {
            throw new Error("Cannot use the decorators and decorators-legacy plugin together");
          }
          const decoratorsBeforeExport = getPluginOption(plugins5, "decorators", "decoratorsBeforeExport");
          if (decoratorsBeforeExport != null && typeof decoratorsBeforeExport !== "boolean") {
            throw new Error("'decoratorsBeforeExport' must be a boolean.");
          }
          const allowCallParenthesized = getPluginOption(plugins5, "decorators", "allowCallParenthesized");
          if (allowCallParenthesized != null && typeof allowCallParenthesized !== "boolean") {
            throw new Error("'allowCallParenthesized' must be a boolean.");
          }
        }
        if (hasPlugin(plugins5, "flow") && hasPlugin(plugins5, "typescript")) {
          throw new Error("Cannot combine flow and typescript plugins.");
        }
        if (hasPlugin(plugins5, "placeholders") && hasPlugin(plugins5, "v8intrinsic")) {
          throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
        }
        if (hasPlugin(plugins5, "pipelineOperator")) {
          const proposal = getPluginOption(plugins5, "pipelineOperator", "proposal");
          if (!PIPELINE_PROPOSALS.includes(proposal)) {
            const proposalList = PIPELINE_PROPOSALS.map((p) => `"${p}"`).join(", ");
            throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${proposalList}.`);
          }
          const tupleSyntaxIsHash = hasPlugin(plugins5, ["recordAndTuple", {
            syntaxType: "hash"
          }]);
          if (proposal === "hack") {
            if (hasPlugin(plugins5, "placeholders")) {
              throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
            }
            if (hasPlugin(plugins5, "v8intrinsic")) {
              throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
            }
            const topicToken = getPluginOption(plugins5, "pipelineOperator", "topicToken");
            if (!TOPIC_TOKENS.includes(topicToken)) {
              const tokenList = TOPIC_TOKENS.map((t3) => `"${t3}"`).join(", ");
              throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${tokenList}.`);
            }
            if (topicToken === "#" && tupleSyntaxIsHash) {
              throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "hack", topicToken: "#" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
            }
          } else if (proposal === "smart" && tupleSyntaxIsHash) {
            throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "smart" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
          }
        }
        if (hasPlugin(plugins5, "moduleAttributes")) {
          {
            if (hasPlugin(plugins5, "importAssertions")) {
              throw new Error("Cannot combine importAssertions and moduleAttributes plugins.");
            }
            const moduleAttributesVersionPluginOption = getPluginOption(plugins5, "moduleAttributes", "version");
            if (moduleAttributesVersionPluginOption !== "may-2020") {
              throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
            }
          }
        }
        if (hasPlugin(plugins5, "recordAndTuple") && getPluginOption(plugins5, "recordAndTuple", "syntaxType") != null && !RECORD_AND_TUPLE_SYNTAX_TYPES.includes(getPluginOption(plugins5, "recordAndTuple", "syntaxType"))) {
          throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + RECORD_AND_TUPLE_SYNTAX_TYPES.map((p) => `'${p}'`).join(", "));
        }
        if (hasPlugin(plugins5, "asyncDoExpressions") && !hasPlugin(plugins5, "doExpressions")) {
          const error = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
          error.missingPlugins = "doExpressions";
          throw error;
        }
      }
      var mixinPlugins = {
        estree,
        jsx,
        flow: flow2,
        typescript,
        v8intrinsic,
        placeholders
      };
      var mixinPluginNames = Object.keys(mixinPlugins);
      var defaultOptions = {
        sourceType: "script",
        sourceFilename: void 0,
        startColumn: 0,
        startLine: 1,
        allowAwaitOutsideFunction: false,
        allowReturnOutsideFunction: false,
        allowImportExportEverywhere: false,
        allowSuperOutsideMethod: false,
        allowUndeclaredExports: false,
        plugins: [],
        strictMode: null,
        ranges: false,
        tokens: false,
        createParenthesizedExpressions: false,
        errorRecovery: false,
        attachComment: true
      };
      function getOptions(opts) {
        const options = {};
        for (const key of Object.keys(defaultOptions)) {
          options[key] = opts && opts[key] != null ? opts[key] : defaultOptions[key];
        }
        return options;
      }
      var getOwn = (object, key) => Object.hasOwnProperty.call(object, key) && object[key];
      var unwrapParenthesizedExpression = (node) => {
        return node.type === "ParenthesizedExpression" ? unwrapParenthesizedExpression(node.expression) : node;
      };
      var LValParser = class extends NodeUtils {
        toAssignable(node, isLHS = false) {
          var _node$extra, _node$extra3;
          let parenthesized = void 0;
          if (node.type === "ParenthesizedExpression" || (_node$extra = node.extra) != null && _node$extra.parenthesized) {
            parenthesized = unwrapParenthesizedExpression(node);
            if (isLHS) {
              if (parenthesized.type === "Identifier") {
                this.expressionScope.recordArrowParemeterBindingError(Errors.InvalidParenthesizedAssignment, {
                  at: node
                });
              } else if (parenthesized.type !== "MemberExpression") {
                this.raise(Errors.InvalidParenthesizedAssignment, {
                  at: node
                });
              }
            } else {
              this.raise(Errors.InvalidParenthesizedAssignment, {
                at: node
              });
            }
          }
          switch (node.type) {
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              node.type = "ObjectPattern";
              for (let i = 0, length = node.properties.length, last2 = length - 1; i < length; i++) {
                var _node$extra2;
                const prop = node.properties[i];
                const isLast = i === last2;
                this.toAssignableObjectExpressionProp(prop, isLast, isLHS);
                if (isLast && prop.type === "RestElement" && (_node$extra2 = node.extra) != null && _node$extra2.trailingCommaLoc) {
                  this.raise(Errors.RestTrailingComma, {
                    at: node.extra.trailingCommaLoc
                  });
                }
              }
              break;
            case "ObjectProperty": {
              const {
                key,
                value
              } = node;
              if (this.isPrivateName(key)) {
                this.classScope.usePrivateName(this.getPrivateNameSV(key), key.loc.start);
              }
              this.toAssignable(value, isLHS);
              break;
            }
            case "SpreadElement": {
              throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
            }
            case "ArrayExpression":
              node.type = "ArrayPattern";
              this.toAssignableList(node.elements, (_node$extra3 = node.extra) == null ? void 0 : _node$extra3.trailingCommaLoc, isLHS);
              break;
            case "AssignmentExpression":
              if (node.operator !== "=") {
                this.raise(Errors.MissingEqInAssignment, {
                  at: node.left.loc.end
                });
              }
              node.type = "AssignmentPattern";
              delete node.operator;
              this.toAssignable(node.left, isLHS);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(parenthesized, isLHS);
              break;
          }
        }
        toAssignableObjectExpressionProp(prop, isLast, isLHS) {
          if (prop.type === "ObjectMethod") {
            this.raise(prop.kind === "get" || prop.kind === "set" ? Errors.PatternHasAccessor : Errors.PatternHasMethod, {
              at: prop.key
            });
          } else if (prop.type === "SpreadElement") {
            prop.type = "RestElement";
            const arg = prop.argument;
            this.checkToRestConversion(arg, false);
            this.toAssignable(arg, isLHS);
            if (!isLast) {
              this.raise(Errors.RestTrailingComma, {
                at: prop
              });
            }
          } else {
            this.toAssignable(prop, isLHS);
          }
        }
        toAssignableList(exprList, trailingCommaLoc, isLHS) {
          const end = exprList.length - 1;
          for (let i = 0; i <= end; i++) {
            const elt = exprList[i];
            if (!elt)
              continue;
            if (elt.type === "SpreadElement") {
              elt.type = "RestElement";
              const arg = elt.argument;
              this.checkToRestConversion(arg, true);
              this.toAssignable(arg, isLHS);
            } else {
              this.toAssignable(elt, isLHS);
            }
            if (elt.type === "RestElement") {
              if (i < end) {
                this.raise(Errors.RestTrailingComma, {
                  at: elt
                });
              } else if (trailingCommaLoc) {
                this.raise(Errors.RestTrailingComma, {
                  at: trailingCommaLoc
                });
              }
            }
          }
        }
        isAssignable(node, isBinding) {
          switch (node.type) {
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              return true;
            case "ObjectExpression": {
              const last2 = node.properties.length - 1;
              return node.properties.every((prop, i) => {
                return prop.type !== "ObjectMethod" && (i === last2 || prop.type !== "SpreadElement") && this.isAssignable(prop);
              });
            }
            case "ObjectProperty":
              return this.isAssignable(node.value);
            case "SpreadElement":
              return this.isAssignable(node.argument);
            case "ArrayExpression":
              return node.elements.every((element) => element === null || this.isAssignable(element));
            case "AssignmentExpression":
              return node.operator === "=";
            case "ParenthesizedExpression":
              return this.isAssignable(node.expression);
            case "MemberExpression":
            case "OptionalMemberExpression":
              return !isBinding;
            default:
              return false;
          }
        }
        toReferencedList(exprList, isParenthesizedExpr) {
          return exprList;
        }
        toReferencedListDeep(exprList, isParenthesizedExpr) {
          this.toReferencedList(exprList, isParenthesizedExpr);
          for (const expr of exprList) {
            if ((expr == null ? void 0 : expr.type) === "ArrayExpression") {
              this.toReferencedListDeep(expr.elements);
            }
          }
        }
        parseSpread(refExpressionErrors) {
          const node = this.startNode();
          this.next();
          node.argument = this.parseMaybeAssignAllowIn(refExpressionErrors, void 0);
          return this.finishNode(node, "SpreadElement");
        }
        parseRestBinding() {
          const node = this.startNode();
          this.next();
          node.argument = this.parseBindingAtom();
          return this.finishNode(node, "RestElement");
        }
        parseBindingAtom() {
          switch (this.state.type) {
            case 0: {
              const node = this.startNode();
              this.next();
              node.elements = this.parseBindingList(3, 93, true);
              return this.finishNode(node, "ArrayPattern");
            }
            case 5:
              return this.parseObjectLike(8, true);
          }
          return this.parseIdentifier();
        }
        parseBindingList(close, closeCharCode, allowEmpty, allowModifiers) {
          const elts = [];
          let first = true;
          while (!this.eat(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
            }
            if (allowEmpty && this.match(12)) {
              elts.push(null);
            } else if (this.eat(close)) {
              break;
            } else if (this.match(21)) {
              elts.push(this.parseAssignableListItemTypes(this.parseRestBinding()));
              if (!this.checkCommaAfterRest(closeCharCode)) {
                this.expect(close);
                break;
              }
            } else {
              const decorators = [];
              if (this.match(26) && this.hasPlugin("decorators")) {
                this.raise(Errors.UnsupportedParameterDecorator, {
                  at: this.state.startLoc
                });
              }
              while (this.match(26)) {
                decorators.push(this.parseDecorator());
              }
              elts.push(this.parseAssignableListItem(allowModifiers, decorators));
            }
          }
          return elts;
        }
        parseBindingRestProperty(prop) {
          this.next();
          prop.argument = this.parseIdentifier();
          this.checkCommaAfterRest(125);
          return this.finishNode(prop, "RestElement");
        }
        parseBindingProperty() {
          const prop = this.startNode();
          const {
            type,
            startLoc
          } = this.state;
          if (type === 21) {
            return this.parseBindingRestProperty(prop);
          } else if (type === 136) {
            this.expectPlugin("destructuringPrivate", startLoc);
            this.classScope.usePrivateName(this.state.value, startLoc);
            prop.key = this.parsePrivateName();
          } else {
            this.parsePropertyName(prop);
          }
          prop.method = false;
          return this.parseObjPropValue(prop, startLoc, false, false, true, false);
        }
        parseAssignableListItem(allowModifiers, decorators) {
          const left = this.parseMaybeDefault();
          this.parseAssignableListItemTypes(left);
          const elt = this.parseMaybeDefault(left.loc.start, left);
          if (decorators.length) {
            left.decorators = decorators;
          }
          return elt;
        }
        parseAssignableListItemTypes(param) {
          return param;
        }
        parseMaybeDefault(startLoc, left) {
          var _startLoc, _left;
          (_startLoc = startLoc) != null ? _startLoc : startLoc = this.state.startLoc;
          left = (_left = left) != null ? _left : this.parseBindingAtom();
          if (!this.eat(29))
            return left;
          const node = this.startNodeAt(startLoc);
          node.left = left;
          node.right = this.parseMaybeAssignAllowIn();
          return this.finishNode(node, "AssignmentPattern");
        }
        isValidLVal(type, isUnparenthesizedInAssign, binding) {
          return getOwn(
            {
              AssignmentPattern: "left",
              RestElement: "argument",
              ObjectProperty: "value",
              ParenthesizedExpression: "expression",
              ArrayPattern: "elements",
              ObjectPattern: "properties"
            },
            type
          );
        }
        checkLVal(expression, {
          in: ancestor,
          binding = BIND_NONE,
          checkClashes = false,
          strictModeChanged = false,
          allowingSloppyLetBinding = !(binding & BIND_SCOPE_LEXICAL),
          hasParenthesizedAncestor = false
        }) {
          var _expression$extra;
          const type = expression.type;
          if (this.isObjectMethod(expression))
            return;
          if (type === "MemberExpression") {
            if (binding !== BIND_NONE) {
              this.raise(Errors.InvalidPropertyBindingPattern, {
                at: expression
              });
            }
            return;
          }
          if (expression.type === "Identifier") {
            this.checkIdentifier(expression, binding, strictModeChanged, allowingSloppyLetBinding);
            const {
              name
            } = expression;
            if (checkClashes) {
              if (checkClashes.has(name)) {
                this.raise(Errors.ParamDupe, {
                  at: expression
                });
              } else {
                checkClashes.add(name);
              }
            }
            return;
          }
          const validity = this.isValidLVal(expression.type, !(hasParenthesizedAncestor || (_expression$extra = expression.extra) != null && _expression$extra.parenthesized) && ancestor.type === "AssignmentExpression", binding);
          if (validity === true)
            return;
          if (validity === false) {
            const ParseErrorClass = binding === BIND_NONE ? Errors.InvalidLhs : Errors.InvalidLhsBinding;
            this.raise(ParseErrorClass, {
              at: expression,
              ancestor: ancestor.type === "UpdateExpression" ? {
                type: "UpdateExpression",
                prefix: ancestor.prefix
              } : {
                type: ancestor.type
              }
            });
            return;
          }
          const [key, isParenthesizedExpression] = Array.isArray(validity) ? validity : [validity, type === "ParenthesizedExpression"];
          const nextAncestor = expression.type === "ArrayPattern" || expression.type === "ObjectPattern" || expression.type === "ParenthesizedExpression" ? expression : ancestor;
          for (const child of [].concat(expression[key])) {
            if (child) {
              this.checkLVal(child, {
                in: nextAncestor,
                binding,
                checkClashes,
                allowingSloppyLetBinding,
                strictModeChanged,
                hasParenthesizedAncestor: isParenthesizedExpression
              });
            }
          }
        }
        checkIdentifier(at2, bindingType, strictModeChanged = false, allowLetBinding = !(bindingType & BIND_SCOPE_LEXICAL)) {
          if (this.state.strict && (strictModeChanged ? isStrictBindReservedWord(at2.name, this.inModule) : isStrictBindOnlyReservedWord(at2.name))) {
            if (bindingType === BIND_NONE) {
              this.raise(Errors.StrictEvalArguments, {
                at: at2,
                referenceName: at2.name
              });
            } else {
              this.raise(Errors.StrictEvalArgumentsBinding, {
                at: at2,
                bindingName: at2.name
              });
            }
          }
          if (!allowLetBinding && at2.name === "let") {
            this.raise(Errors.LetInLexicalBinding, {
              at: at2
            });
          }
          if (!(bindingType & BIND_NONE)) {
            this.declareNameFromIdentifier(at2, bindingType);
          }
        }
        declareNameFromIdentifier(identifier3, binding) {
          this.scope.declareName(identifier3.name, binding, identifier3.loc.start);
        }
        checkToRestConversion(node, allowPattern) {
          switch (node.type) {
            case "ParenthesizedExpression":
              this.checkToRestConversion(node.expression, allowPattern);
              break;
            case "Identifier":
            case "MemberExpression":
              break;
            case "ArrayExpression":
            case "ObjectExpression":
              if (allowPattern)
                break;
            default:
              this.raise(Errors.InvalidRestAssignmentPattern, {
                at: node
              });
          }
        }
        checkCommaAfterRest(close) {
          if (!this.match(12)) {
            return false;
          }
          this.raise(this.lookaheadCharCode() === close ? Errors.RestTrailingComma : Errors.ElementAfterRest, {
            at: this.state.startLoc
          });
          return true;
        }
      };
      var ExpressionParser = class extends LValParser {
        checkProto(prop, isRecord, protoRef, refExpressionErrors) {
          if (prop.type === "SpreadElement" || this.isObjectMethod(prop) || prop.computed || prop.shorthand) {
            return;
          }
          const key = prop.key;
          const name = key.type === "Identifier" ? key.name : key.value;
          if (name === "__proto__") {
            if (isRecord) {
              this.raise(Errors.RecordNoProto, {
                at: key
              });
              return;
            }
            if (protoRef.used) {
              if (refExpressionErrors) {
                if (refExpressionErrors.doubleProtoLoc === null) {
                  refExpressionErrors.doubleProtoLoc = key.loc.start;
                }
              } else {
                this.raise(Errors.DuplicateProto, {
                  at: key
                });
              }
            }
            protoRef.used = true;
          }
        }
        shouldExitDescending(expr, potentialArrowAt) {
          return expr.type === "ArrowFunctionExpression" && expr.start === potentialArrowAt;
        }
        getExpression() {
          this.enterInitialScopes();
          this.nextToken();
          const expr = this.parseExpression();
          if (!this.match(137)) {
            this.unexpected();
          }
          this.finalizeRemainingComments();
          expr.comments = this.state.comments;
          expr.errors = this.state.errors;
          if (this.options.tokens) {
            expr.tokens = this.tokens;
          }
          return expr;
        }
        parseExpression(disallowIn, refExpressionErrors) {
          if (disallowIn) {
            return this.disallowInAnd(() => this.parseExpressionBase(refExpressionErrors));
          }
          return this.allowInAnd(() => this.parseExpressionBase(refExpressionErrors));
        }
        parseExpressionBase(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const expr = this.parseMaybeAssign(refExpressionErrors);
          if (this.match(12)) {
            const node = this.startNodeAt(startLoc);
            node.expressions = [expr];
            while (this.eat(12)) {
              node.expressions.push(this.parseMaybeAssign(refExpressionErrors));
            }
            this.toReferencedList(node.expressions);
            return this.finishNode(node, "SequenceExpression");
          }
          return expr;
        }
        parseMaybeAssignDisallowIn(refExpressionErrors, afterLeftParse) {
          return this.disallowInAnd(() => this.parseMaybeAssign(refExpressionErrors, afterLeftParse));
        }
        parseMaybeAssignAllowIn(refExpressionErrors, afterLeftParse) {
          return this.allowInAnd(() => this.parseMaybeAssign(refExpressionErrors, afterLeftParse));
        }
        setOptionalParametersError(refExpressionErrors, resultError) {
          var _resultError$loc;
          refExpressionErrors.optionalParametersLoc = (_resultError$loc = resultError == null ? void 0 : resultError.loc) != null ? _resultError$loc : this.state.startLoc;
        }
        parseMaybeAssign(refExpressionErrors, afterLeftParse) {
          const startLoc = this.state.startLoc;
          if (this.isContextual(106)) {
            if (this.prodParam.hasYield) {
              let left2 = this.parseYield();
              if (afterLeftParse) {
                left2 = afterLeftParse.call(this, left2, startLoc);
              }
              return left2;
            }
          }
          let ownExpressionErrors;
          if (refExpressionErrors) {
            ownExpressionErrors = false;
          } else {
            refExpressionErrors = new ExpressionErrors();
            ownExpressionErrors = true;
          }
          const {
            type
          } = this.state;
          if (type === 10 || tokenIsIdentifier(type)) {
            this.state.potentialArrowAt = this.state.start;
          }
          let left = this.parseMaybeConditional(refExpressionErrors);
          if (afterLeftParse) {
            left = afterLeftParse.call(this, left, startLoc);
          }
          if (tokenIsAssignment(this.state.type)) {
            const node = this.startNodeAt(startLoc);
            const operator = this.state.value;
            node.operator = operator;
            if (this.match(29)) {
              this.toAssignable(left, true);
              node.left = left;
              const startIndex = startLoc.index;
              if (refExpressionErrors.doubleProtoLoc != null && refExpressionErrors.doubleProtoLoc.index >= startIndex) {
                refExpressionErrors.doubleProtoLoc = null;
              }
              if (refExpressionErrors.shorthandAssignLoc != null && refExpressionErrors.shorthandAssignLoc.index >= startIndex) {
                refExpressionErrors.shorthandAssignLoc = null;
              }
              if (refExpressionErrors.privateKeyLoc != null && refExpressionErrors.privateKeyLoc.index >= startIndex) {
                this.checkDestructuringPrivate(refExpressionErrors);
                refExpressionErrors.privateKeyLoc = null;
              }
            } else {
              node.left = left;
            }
            this.next();
            node.right = this.parseMaybeAssign();
            this.checkLVal(left, {
              in: this.finishNode(node, "AssignmentExpression")
            });
            return node;
          } else if (ownExpressionErrors) {
            this.checkExpressionErrors(refExpressionErrors, true);
          }
          return left;
        }
        parseMaybeConditional(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const potentialArrowAt = this.state.potentialArrowAt;
          const expr = this.parseExprOps(refExpressionErrors);
          if (this.shouldExitDescending(expr, potentialArrowAt)) {
            return expr;
          }
          return this.parseConditional(expr, startLoc, refExpressionErrors);
        }
        parseConditional(expr, startLoc, refExpressionErrors) {
          if (this.eat(17)) {
            const node = this.startNodeAt(startLoc);
            node.test = expr;
            node.consequent = this.parseMaybeAssignAllowIn();
            this.expect(14);
            node.alternate = this.parseMaybeAssign();
            return this.finishNode(node, "ConditionalExpression");
          }
          return expr;
        }
        parseMaybeUnaryOrPrivate(refExpressionErrors) {
          return this.match(136) ? this.parsePrivateName() : this.parseMaybeUnary(refExpressionErrors);
        }
        parseExprOps(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const potentialArrowAt = this.state.potentialArrowAt;
          const expr = this.parseMaybeUnaryOrPrivate(refExpressionErrors);
          if (this.shouldExitDescending(expr, potentialArrowAt)) {
            return expr;
          }
          return this.parseExprOp(expr, startLoc, -1);
        }
        parseExprOp(left, leftStartLoc, minPrec) {
          if (this.isPrivateName(left)) {
            const value = this.getPrivateNameSV(left);
            if (minPrec >= tokenOperatorPrecedence(58) || !this.prodParam.hasIn || !this.match(58)) {
              this.raise(Errors.PrivateInExpectedIn, {
                at: left,
                identifierName: value
              });
            }
            this.classScope.usePrivateName(value, left.loc.start);
          }
          const op = this.state.type;
          if (tokenIsOperator(op) && (this.prodParam.hasIn || !this.match(58))) {
            let prec = tokenOperatorPrecedence(op);
            if (prec > minPrec) {
              if (op === 39) {
                this.expectPlugin("pipelineOperator");
                if (this.state.inFSharpPipelineDirectBody) {
                  return left;
                }
                this.checkPipelineAtInfixOperator(left, leftStartLoc);
              }
              const node = this.startNodeAt(leftStartLoc);
              node.left = left;
              node.operator = this.state.value;
              const logical = op === 41 || op === 42;
              const coalesce = op === 40;
              if (coalesce) {
                prec = tokenOperatorPrecedence(42);
              }
              this.next();
              if (op === 39 && this.hasPlugin(["pipelineOperator", {
                proposal: "minimal"
              }])) {
                if (this.state.type === 96 && this.prodParam.hasAwait) {
                  throw this.raise(Errors.UnexpectedAwaitAfterPipelineBody, {
                    at: this.state.startLoc
                  });
                }
              }
              node.right = this.parseExprOpRightExpr(op, prec);
              const finishedNode = this.finishNode(node, logical || coalesce ? "LogicalExpression" : "BinaryExpression");
              const nextOp = this.state.type;
              if (coalesce && (nextOp === 41 || nextOp === 42) || logical && nextOp === 40) {
                throw this.raise(Errors.MixingCoalesceWithLogical, {
                  at: this.state.startLoc
                });
              }
              return this.parseExprOp(finishedNode, leftStartLoc, minPrec);
            }
          }
          return left;
        }
        parseExprOpRightExpr(op, prec) {
          const startLoc = this.state.startLoc;
          switch (op) {
            case 39:
              switch (this.getPluginOption("pipelineOperator", "proposal")) {
                case "hack":
                  return this.withTopicBindingContext(() => {
                    return this.parseHackPipeBody();
                  });
                case "smart":
                  return this.withTopicBindingContext(() => {
                    if (this.prodParam.hasYield && this.isContextual(106)) {
                      throw this.raise(Errors.PipeBodyIsTighter, {
                        at: this.state.startLoc
                      });
                    }
                    return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(op, prec), startLoc);
                  });
                case "fsharp":
                  return this.withSoloAwaitPermittingContext(() => {
                    return this.parseFSharpPipelineBody(prec);
                  });
              }
            default:
              return this.parseExprOpBaseRightExpr(op, prec);
          }
        }
        parseExprOpBaseRightExpr(op, prec) {
          const startLoc = this.state.startLoc;
          return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), startLoc, tokenIsRightAssociative(op) ? prec - 1 : prec);
        }
        parseHackPipeBody() {
          var _body$extra;
          const {
            startLoc
          } = this.state;
          const body = this.parseMaybeAssign();
          const requiredParentheses = UnparenthesizedPipeBodyDescriptions.has(
            body.type
          );
          if (requiredParentheses && !((_body$extra = body.extra) != null && _body$extra.parenthesized)) {
            this.raise(Errors.PipeUnparenthesizedBody, {
              at: startLoc,
              type: body.type
            });
          }
          if (!this.topicReferenceWasUsedInCurrentContext()) {
            this.raise(Errors.PipeTopicUnused, {
              at: startLoc
            });
          }
          return body;
        }
        checkExponentialAfterUnary(node) {
          if (this.match(57)) {
            this.raise(Errors.UnexpectedTokenUnaryExponentiation, {
              at: node.argument
            });
          }
        }
        parseMaybeUnary(refExpressionErrors, sawUnary) {
          const startLoc = this.state.startLoc;
          const isAwait = this.isContextual(96);
          if (isAwait && this.isAwaitAllowed()) {
            this.next();
            const expr2 = this.parseAwait(startLoc);
            if (!sawUnary)
              this.checkExponentialAfterUnary(expr2);
            return expr2;
          }
          const update2 = this.match(34);
          const node = this.startNode();
          if (tokenIsPrefix(this.state.type)) {
            node.operator = this.state.value;
            node.prefix = true;
            if (this.match(72)) {
              this.expectPlugin("throwExpressions");
            }
            const isDelete = this.match(89);
            this.next();
            node.argument = this.parseMaybeUnary(null, true);
            this.checkExpressionErrors(refExpressionErrors, true);
            if (this.state.strict && isDelete) {
              const arg = node.argument;
              if (arg.type === "Identifier") {
                this.raise(Errors.StrictDelete, {
                  at: node
                });
              } else if (this.hasPropertyAsPrivateName(arg)) {
                this.raise(Errors.DeletePrivateField, {
                  at: node
                });
              }
            }
            if (!update2) {
              if (!sawUnary) {
                this.checkExponentialAfterUnary(node);
              }
              return this.finishNode(node, "UnaryExpression");
            }
          }
          const expr = this.parseUpdate(
            node,
            update2,
            refExpressionErrors
          );
          if (isAwait) {
            const {
              type
            } = this.state;
            const startsExpr2 = this.hasPlugin("v8intrinsic") ? tokenCanStartExpression(type) : tokenCanStartExpression(type) && !this.match(54);
            if (startsExpr2 && !this.isAmbiguousAwait()) {
              this.raiseOverwrite(Errors.AwaitNotInAsyncContext, {
                at: startLoc
              });
              return this.parseAwait(startLoc);
            }
          }
          return expr;
        }
        parseUpdate(node, update2, refExpressionErrors) {
          if (update2) {
            const updateExpressionNode = node;
            this.checkLVal(updateExpressionNode.argument, {
              in: this.finishNode(updateExpressionNode, "UpdateExpression")
            });
            return node;
          }
          const startLoc = this.state.startLoc;
          let expr = this.parseExprSubscripts(refExpressionErrors);
          if (this.checkExpressionErrors(refExpressionErrors, false))
            return expr;
          while (tokenIsPostfix(this.state.type) && !this.canInsertSemicolon()) {
            const node2 = this.startNodeAt(startLoc);
            node2.operator = this.state.value;
            node2.prefix = false;
            node2.argument = expr;
            this.next();
            this.checkLVal(expr, {
              in: expr = this.finishNode(node2, "UpdateExpression")
            });
          }
          return expr;
        }
        parseExprSubscripts(refExpressionErrors) {
          const startLoc = this.state.startLoc;
          const potentialArrowAt = this.state.potentialArrowAt;
          const expr = this.parseExprAtom(refExpressionErrors);
          if (this.shouldExitDescending(expr, potentialArrowAt)) {
            return expr;
          }
          return this.parseSubscripts(expr, startLoc);
        }
        parseSubscripts(base, startLoc, noCalls) {
          const state = {
            optionalChainMember: false,
            maybeAsyncArrow: this.atPossibleAsyncArrow(base),
            stop: false
          };
          do {
            base = this.parseSubscript(base, startLoc, noCalls, state);
            state.maybeAsyncArrow = false;
          } while (!state.stop);
          return base;
        }
        parseSubscript(base, startLoc, noCalls, state) {
          const {
            type
          } = this.state;
          if (!noCalls && type === 15) {
            return this.parseBind(base, startLoc, noCalls, state);
          } else if (tokenIsTemplate(type)) {
            return this.parseTaggedTemplateExpression(base, startLoc, state);
          }
          let optional = false;
          if (type === 18) {
            if (noCalls && this.lookaheadCharCode() === 40) {
              state.stop = true;
              return base;
            }
            state.optionalChainMember = optional = true;
            this.next();
          }
          if (!noCalls && this.match(10)) {
            return this.parseCoverCallAndAsyncArrowHead(base, startLoc, state, optional);
          } else {
            const computed = this.eat(0);
            if (computed || optional || this.eat(16)) {
              return this.parseMember(base, startLoc, state, computed, optional);
            } else {
              state.stop = true;
              return base;
            }
          }
        }
        parseMember(base, startLoc, state, computed, optional) {
          const node = this.startNodeAt(startLoc);
          node.object = base;
          node.computed = computed;
          if (computed) {
            node.property = this.parseExpression();
            this.expect(3);
          } else if (this.match(136)) {
            if (base.type === "Super") {
              this.raise(Errors.SuperPrivateField, {
                at: startLoc
              });
            }
            this.classScope.usePrivateName(this.state.value, this.state.startLoc);
            node.property = this.parsePrivateName();
          } else {
            node.property = this.parseIdentifier(true);
          }
          if (state.optionalChainMember) {
            node.optional = optional;
            return this.finishNode(node, "OptionalMemberExpression");
          } else {
            return this.finishNode(node, "MemberExpression");
          }
        }
        parseBind(base, startLoc, noCalls, state) {
          const node = this.startNodeAt(startLoc);
          node.object = base;
          this.next();
          node.callee = this.parseNoCallExpr();
          state.stop = true;
          return this.parseSubscripts(this.finishNode(node, "BindExpression"), startLoc, noCalls);
        }
        parseCoverCallAndAsyncArrowHead(base, startLoc, state, optional) {
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          let refExpressionErrors = null;
          this.state.maybeInArrowParameters = true;
          this.next();
          const node = this.startNodeAt(startLoc);
          node.callee = base;
          const {
            maybeAsyncArrow,
            optionalChainMember
          } = state;
          if (maybeAsyncArrow) {
            this.expressionScope.enter(newAsyncArrowScope());
            refExpressionErrors = new ExpressionErrors();
          }
          if (optionalChainMember) {
            node.optional = optional;
          }
          if (optional) {
            node.arguments = this.parseCallExpressionArguments(11);
          } else {
            node.arguments = this.parseCallExpressionArguments(
              11,
              base.type === "Import",
              base.type !== "Super",
              node,
              refExpressionErrors
            );
          }
          let finishedNode = this.finishCallExpression(node, optionalChainMember);
          if (maybeAsyncArrow && this.shouldParseAsyncArrow() && !optional) {
            state.stop = true;
            this.checkDestructuringPrivate(refExpressionErrors);
            this.expressionScope.validateAsPattern();
            this.expressionScope.exit();
            finishedNode = this.parseAsyncArrowFromCallExpression(this.startNodeAt(startLoc), finishedNode);
          } else {
            if (maybeAsyncArrow) {
              this.checkExpressionErrors(refExpressionErrors, true);
              this.expressionScope.exit();
            }
            this.toReferencedArguments(finishedNode);
          }
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          return finishedNode;
        }
        toReferencedArguments(node, isParenthesizedExpr) {
          this.toReferencedListDeep(node.arguments, isParenthesizedExpr);
        }
        parseTaggedTemplateExpression(base, startLoc, state) {
          const node = this.startNodeAt(startLoc);
          node.tag = base;
          node.quasi = this.parseTemplate(true);
          if (state.optionalChainMember) {
            this.raise(Errors.OptionalChainingNoTemplate, {
              at: startLoc
            });
          }
          return this.finishNode(node, "TaggedTemplateExpression");
        }
        atPossibleAsyncArrow(base) {
          return base.type === "Identifier" && base.name === "async" && this.state.lastTokEndLoc.index === base.end && !this.canInsertSemicolon() && base.end - base.start === 5 && base.start === this.state.potentialArrowAt;
        }
        finishCallExpression(node, optional) {
          if (node.callee.type === "Import") {
            if (node.arguments.length === 2) {
              {
                if (!this.hasPlugin("moduleAttributes")) {
                  this.expectPlugin("importAssertions");
                }
              }
            }
            if (node.arguments.length === 0 || node.arguments.length > 2) {
              this.raise(Errors.ImportCallArity, {
                at: node,
                maxArgumentCount: this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1
              });
            } else {
              for (const arg of node.arguments) {
                if (arg.type === "SpreadElement") {
                  this.raise(Errors.ImportCallSpreadArgument, {
                    at: arg
                  });
                }
              }
            }
          }
          return this.finishNode(node, optional ? "OptionalCallExpression" : "CallExpression");
        }
        parseCallExpressionArguments(close, dynamicImport, allowPlaceholder, nodeForExtra, refExpressionErrors) {
          const elts = [];
          let first = true;
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = false;
          while (!this.eat(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.match(close)) {
                if (dynamicImport && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes")) {
                  this.raise(Errors.ImportCallArgumentTrailingComma, {
                    at: this.state.lastTokStartLoc
                  });
                }
                if (nodeForExtra) {
                  this.addTrailingCommaExtraToNode(nodeForExtra);
                }
                this.next();
                break;
              }
            }
            elts.push(this.parseExprListItem(false, refExpressionErrors, allowPlaceholder));
          }
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          return elts;
        }
        shouldParseAsyncArrow() {
          return this.match(19) && !this.canInsertSemicolon();
        }
        parseAsyncArrowFromCallExpression(node, call) {
          var _call$extra;
          this.resetPreviousNodeTrailingComments(call);
          this.expect(19);
          this.parseArrowExpression(node, call.arguments, true, (_call$extra = call.extra) == null ? void 0 : _call$extra.trailingCommaLoc);
          if (call.innerComments) {
            setInnerComments(node, call.innerComments);
          }
          if (call.callee.trailingComments) {
            setInnerComments(node, call.callee.trailingComments);
          }
          return node;
        }
        parseNoCallExpr() {
          const startLoc = this.state.startLoc;
          return this.parseSubscripts(this.parseExprAtom(), startLoc, true);
        }
        parseExprAtom(refExpressionErrors) {
          let node;
          let decorators = null;
          const {
            type
          } = this.state;
          switch (type) {
            case 79:
              return this.parseSuper();
            case 83:
              node = this.startNode();
              this.next();
              if (this.match(16)) {
                return this.parseImportMetaProperty(node);
              }
              if (!this.match(10)) {
                this.raise(Errors.UnsupportedImport, {
                  at: this.state.lastTokStartLoc
                });
              }
              return this.finishNode(node, "Import");
            case 78:
              node = this.startNode();
              this.next();
              return this.finishNode(node, "ThisExpression");
            case 90: {
              return this.parseDo(this.startNode(), false);
            }
            case 56:
            case 31: {
              this.readRegexp();
              return this.parseRegExpLiteral(this.state.value);
            }
            case 132:
              return this.parseNumericLiteral(this.state.value);
            case 133:
              return this.parseBigIntLiteral(this.state.value);
            case 134:
              return this.parseDecimalLiteral(this.state.value);
            case 131:
              return this.parseStringLiteral(this.state.value);
            case 84:
              return this.parseNullLiteral();
            case 85:
              return this.parseBooleanLiteral(true);
            case 86:
              return this.parseBooleanLiteral(false);
            case 10: {
              const canBeArrow = this.state.potentialArrowAt === this.state.start;
              return this.parseParenAndDistinguishExpression(canBeArrow);
            }
            case 2:
            case 1: {
              return this.parseArrayLike(this.state.type === 2 ? 4 : 3, false, true);
            }
            case 0: {
              return this.parseArrayLike(3, true, false, refExpressionErrors);
            }
            case 6:
            case 7: {
              return this.parseObjectLike(this.state.type === 6 ? 9 : 8, false, true);
            }
            case 5: {
              return this.parseObjectLike(8, false, false, refExpressionErrors);
            }
            case 68:
              return this.parseFunctionOrFunctionSent();
            case 26:
              decorators = this.parseDecorators();
            case 80:
              return this.parseClass(this.maybeTakeDecorators(decorators, this.startNode()), false);
            case 77:
              return this.parseNewOrNewTarget();
            case 25:
            case 24:
              return this.parseTemplate(false);
            case 15: {
              node = this.startNode();
              this.next();
              node.object = null;
              const callee = node.callee = this.parseNoCallExpr();
              if (callee.type === "MemberExpression") {
                return this.finishNode(node, "BindExpression");
              } else {
                throw this.raise(Errors.UnsupportedBind, {
                  at: callee
                });
              }
            }
            case 136: {
              this.raise(Errors.PrivateInExpectedIn, {
                at: this.state.startLoc,
                identifierName: this.state.value
              });
              return this.parsePrivateName();
            }
            case 33: {
              return this.parseTopicReferenceThenEqualsSign(54, "%");
            }
            case 32: {
              return this.parseTopicReferenceThenEqualsSign(44, "^");
            }
            case 37:
            case 38: {
              return this.parseTopicReference("hack");
            }
            case 44:
            case 54:
            case 27: {
              const pipeProposal = this.getPluginOption("pipelineOperator", "proposal");
              if (pipeProposal) {
                return this.parseTopicReference(pipeProposal);
              } else {
                throw this.unexpected();
              }
            }
            case 47: {
              const lookaheadCh = this.input.codePointAt(this.nextTokenStart());
              if (isIdentifierStart(lookaheadCh) || lookaheadCh === 62) {
                this.expectOnePlugin(["jsx", "flow", "typescript"]);
                break;
              } else {
                throw this.unexpected();
              }
            }
            default:
              if (tokenIsIdentifier(type)) {
                if (this.isContextual(125) && this.lookaheadCharCode() === 123 && !this.hasFollowingLineBreak()) {
                  return this.parseModuleExpression();
                }
                const canBeArrow = this.state.potentialArrowAt === this.state.start;
                const containsEsc = this.state.containsEsc;
                const id = this.parseIdentifier();
                if (!containsEsc && id.name === "async" && !this.canInsertSemicolon()) {
                  const {
                    type: type2
                  } = this.state;
                  if (type2 === 68) {
                    this.resetPreviousNodeTrailingComments(id);
                    this.next();
                    return this.parseFunction(this.startNodeAtNode(id), void 0, true);
                  } else if (tokenIsIdentifier(type2)) {
                    if (this.lookaheadCharCode() === 61) {
                      return this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(id));
                    } else {
                      return id;
                    }
                  } else if (type2 === 90) {
                    this.resetPreviousNodeTrailingComments(id);
                    return this.parseDo(this.startNodeAtNode(id), true);
                  }
                }
                if (canBeArrow && this.match(19) && !this.canInsertSemicolon()) {
                  this.next();
                  return this.parseArrowExpression(this.startNodeAtNode(id), [id], false);
                }
                return id;
              } else {
                throw this.unexpected();
              }
          }
        }
        parseTopicReferenceThenEqualsSign(topicTokenType, topicTokenValue) {
          const pipeProposal = this.getPluginOption("pipelineOperator", "proposal");
          if (pipeProposal) {
            this.state.type = topicTokenType;
            this.state.value = topicTokenValue;
            this.state.pos--;
            this.state.end--;
            this.state.endLoc = createPositionWithColumnOffset(this.state.endLoc, -1);
            return this.parseTopicReference(pipeProposal);
          } else {
            throw this.unexpected();
          }
        }
        parseTopicReference(pipeProposal) {
          const node = this.startNode();
          const startLoc = this.state.startLoc;
          const tokenType = this.state.type;
          this.next();
          return this.finishTopicReference(node, startLoc, pipeProposal, tokenType);
        }
        finishTopicReference(node, startLoc, pipeProposal, tokenType) {
          if (this.testTopicReferenceConfiguration(pipeProposal, startLoc, tokenType)) {
            const nodeType = pipeProposal === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
            if (!this.topicReferenceIsAllowedInCurrentContext()) {
              this.raise(
                pipeProposal === "smart" ? Errors.PrimaryTopicNotAllowed : Errors.PipeTopicUnbound,
                {
                  at: startLoc
                }
              );
            }
            this.registerTopicReference();
            return this.finishNode(node, nodeType);
          } else {
            throw this.raise(Errors.PipeTopicUnconfiguredToken, {
              at: startLoc,
              token: tokenLabelName(tokenType)
            });
          }
        }
        testTopicReferenceConfiguration(pipeProposal, startLoc, tokenType) {
          switch (pipeProposal) {
            case "hack": {
              return this.hasPlugin(["pipelineOperator", {
                topicToken: tokenLabelName(tokenType)
              }]);
            }
            case "smart":
              return tokenType === 27;
            default:
              throw this.raise(Errors.PipeTopicRequiresHackPipes, {
                at: startLoc
              });
          }
        }
        parseAsyncArrowUnaryFunction(node) {
          this.prodParam.enter(functionFlags(true, this.prodParam.hasYield));
          const params = [this.parseIdentifier()];
          this.prodParam.exit();
          if (this.hasPrecedingLineBreak()) {
            this.raise(Errors.LineTerminatorBeforeArrow, {
              at: this.state.curPosition()
            });
          }
          this.expect(19);
          return this.parseArrowExpression(node, params, true);
        }
        parseDo(node, isAsync) {
          this.expectPlugin("doExpressions");
          if (isAsync) {
            this.expectPlugin("asyncDoExpressions");
          }
          node.async = isAsync;
          this.next();
          const oldLabels = this.state.labels;
          this.state.labels = [];
          if (isAsync) {
            this.prodParam.enter(PARAM_AWAIT);
            node.body = this.parseBlock();
            this.prodParam.exit();
          } else {
            node.body = this.parseBlock();
          }
          this.state.labels = oldLabels;
          return this.finishNode(node, "DoExpression");
        }
        parseSuper() {
          const node = this.startNode();
          this.next();
          if (this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod) {
            this.raise(Errors.SuperNotAllowed, {
              at: node
            });
          } else if (!this.scope.allowSuper && !this.options.allowSuperOutsideMethod) {
            this.raise(Errors.UnexpectedSuper, {
              at: node
            });
          }
          if (!this.match(10) && !this.match(0) && !this.match(16)) {
            this.raise(Errors.UnsupportedSuper, {
              at: node
            });
          }
          return this.finishNode(node, "Super");
        }
        parsePrivateName() {
          const node = this.startNode();
          const id = this.startNodeAt(
            createPositionWithColumnOffset(this.state.startLoc, 1)
          );
          const name = this.state.value;
          this.next();
          node.id = this.createIdentifier(id, name);
          return this.finishNode(node, "PrivateName");
        }
        parseFunctionOrFunctionSent() {
          const node = this.startNode();
          this.next();
          if (this.prodParam.hasYield && this.match(16)) {
            const meta = this.createIdentifier(this.startNodeAtNode(node), "function");
            this.next();
            if (this.match(102)) {
              this.expectPlugin("functionSent");
            } else if (!this.hasPlugin("functionSent")) {
              this.unexpected();
            }
            return this.parseMetaProperty(node, meta, "sent");
          }
          return this.parseFunction(node);
        }
        parseMetaProperty(node, meta, propertyName) {
          node.meta = meta;
          const containsEsc = this.state.containsEsc;
          node.property = this.parseIdentifier(true);
          if (node.property.name !== propertyName || containsEsc) {
            this.raise(Errors.UnsupportedMetaProperty, {
              at: node.property,
              target: meta.name,
              onlyValidPropertyName: propertyName
            });
          }
          return this.finishNode(node, "MetaProperty");
        }
        parseImportMetaProperty(node) {
          const id = this.createIdentifier(this.startNodeAtNode(node), "import");
          this.next();
          if (this.isContextual(100)) {
            if (!this.inModule) {
              this.raise(Errors.ImportMetaOutsideModule, {
                at: id
              });
            }
            this.sawUnambiguousESM = true;
          }
          return this.parseMetaProperty(node, id, "meta");
        }
        parseLiteralAtNode(value, type, node) {
          this.addExtra(node, "rawValue", value);
          this.addExtra(node, "raw", this.input.slice(node.start, this.state.end));
          node.value = value;
          this.next();
          return this.finishNode(node, type);
        }
        parseLiteral(value, type) {
          const node = this.startNode();
          return this.parseLiteralAtNode(value, type, node);
        }
        parseStringLiteral(value) {
          return this.parseLiteral(value, "StringLiteral");
        }
        parseNumericLiteral(value) {
          return this.parseLiteral(value, "NumericLiteral");
        }
        parseBigIntLiteral(value) {
          return this.parseLiteral(value, "BigIntLiteral");
        }
        parseDecimalLiteral(value) {
          return this.parseLiteral(value, "DecimalLiteral");
        }
        parseRegExpLiteral(value) {
          const node = this.parseLiteral(value.value, "RegExpLiteral");
          node.pattern = value.pattern;
          node.flags = value.flags;
          return node;
        }
        parseBooleanLiteral(value) {
          const node = this.startNode();
          node.value = value;
          this.next();
          return this.finishNode(node, "BooleanLiteral");
        }
        parseNullLiteral() {
          const node = this.startNode();
          this.next();
          return this.finishNode(node, "NullLiteral");
        }
        parseParenAndDistinguishExpression(canBeArrow) {
          const startLoc = this.state.startLoc;
          let val;
          this.next();
          this.expressionScope.enter(newArrowHeadScope());
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.maybeInArrowParameters = true;
          this.state.inFSharpPipelineDirectBody = false;
          const innerStartLoc = this.state.startLoc;
          const exprList = [];
          const refExpressionErrors = new ExpressionErrors();
          let first = true;
          let spreadStartLoc;
          let optionalCommaStartLoc;
          while (!this.match(11)) {
            if (first) {
              first = false;
            } else {
              this.expect(12, refExpressionErrors.optionalParametersLoc === null ? null : refExpressionErrors.optionalParametersLoc);
              if (this.match(11)) {
                optionalCommaStartLoc = this.state.startLoc;
                break;
              }
            }
            if (this.match(21)) {
              const spreadNodeStartLoc = this.state.startLoc;
              spreadStartLoc = this.state.startLoc;
              exprList.push(this.parseParenItem(this.parseRestBinding(), spreadNodeStartLoc));
              if (!this.checkCommaAfterRest(41)) {
                break;
              }
            } else {
              exprList.push(this.parseMaybeAssignAllowIn(refExpressionErrors, this.parseParenItem));
            }
          }
          const innerEndLoc = this.state.lastTokEndLoc;
          this.expect(11);
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          let arrowNode = this.startNodeAt(startLoc);
          if (canBeArrow && this.shouldParseArrow(exprList) && (arrowNode = this.parseArrow(arrowNode))) {
            this.checkDestructuringPrivate(refExpressionErrors);
            this.expressionScope.validateAsPattern();
            this.expressionScope.exit();
            this.parseArrowExpression(arrowNode, exprList, false);
            return arrowNode;
          }
          this.expressionScope.exit();
          if (!exprList.length) {
            this.unexpected(this.state.lastTokStartLoc);
          }
          if (optionalCommaStartLoc)
            this.unexpected(optionalCommaStartLoc);
          if (spreadStartLoc)
            this.unexpected(spreadStartLoc);
          this.checkExpressionErrors(refExpressionErrors, true);
          this.toReferencedListDeep(exprList, true);
          if (exprList.length > 1) {
            val = this.startNodeAt(innerStartLoc);
            val.expressions = exprList;
            this.finishNode(val, "SequenceExpression");
            this.resetEndLocation(val, innerEndLoc);
          } else {
            val = exprList[0];
          }
          return this.wrapParenthesis(
            startLoc,
            val
          );
        }
        wrapParenthesis(startLoc, expression) {
          if (!this.options.createParenthesizedExpressions) {
            this.addExtra(expression, "parenthesized", true);
            this.addExtra(expression, "parenStart", startLoc.index);
            this.takeSurroundingComments(expression, startLoc.index, this.state.lastTokEndLoc.index);
            return expression;
          }
          const parenExpression = this.startNodeAt(startLoc);
          parenExpression.expression = expression;
          return this.finishNode(parenExpression, "ParenthesizedExpression");
        }
        shouldParseArrow(params) {
          return !this.canInsertSemicolon();
        }
        parseArrow(node) {
          if (this.eat(19)) {
            return node;
          }
        }
        parseParenItem(node, startLoc) {
          return node;
        }
        parseNewOrNewTarget() {
          const node = this.startNode();
          this.next();
          if (this.match(16)) {
            const meta = this.createIdentifier(this.startNodeAtNode(node), "new");
            this.next();
            const metaProp = this.parseMetaProperty(node, meta, "target");
            if (!this.scope.inNonArrowFunction && !this.scope.inClass) {
              this.raise(Errors.UnexpectedNewTarget, {
                at: metaProp
              });
            }
            return metaProp;
          }
          return this.parseNew(node);
        }
        parseNew(node) {
          this.parseNewCallee(node);
          if (this.eat(10)) {
            const args = this.parseExprList(11);
            this.toReferencedList(args);
            node.arguments = args;
          } else {
            node.arguments = [];
          }
          return this.finishNode(node, "NewExpression");
        }
        parseNewCallee(node) {
          node.callee = this.parseNoCallExpr();
          if (node.callee.type === "Import") {
            this.raise(Errors.ImportCallNotNewExpression, {
              at: node.callee
            });
          } else if (this.isOptionalChain(node.callee)) {
            this.raise(Errors.OptionalChainingNoNew, {
              at: this.state.lastTokEndLoc
            });
          } else if (this.eat(18)) {
            this.raise(Errors.OptionalChainingNoNew, {
              at: this.state.startLoc
            });
          }
        }
        parseTemplateElement(isTagged) {
          const {
            start,
            startLoc,
            end,
            value
          } = this.state;
          const elemStart = start + 1;
          const elem = this.startNodeAt(createPositionWithColumnOffset(startLoc, 1));
          if (value === null) {
            if (!isTagged) {
              this.raise(Errors.InvalidEscapeSequenceTemplate, {
                at: createPositionWithColumnOffset(this.state.firstInvalidTemplateEscapePos, 1)
              });
            }
          }
          const isTail = this.match(24);
          const endOffset = isTail ? -1 : -2;
          const elemEnd = end + endOffset;
          elem.value = {
            raw: this.input.slice(elemStart, elemEnd).replace(/\r\n?/g, "\n"),
            cooked: value === null ? null : value.slice(1, endOffset)
          };
          elem.tail = isTail;
          this.next();
          const finishedNode = this.finishNode(elem, "TemplateElement");
          this.resetEndLocation(finishedNode, createPositionWithColumnOffset(this.state.lastTokEndLoc, endOffset));
          return finishedNode;
        }
        parseTemplate(isTagged) {
          const node = this.startNode();
          node.expressions = [];
          let curElt = this.parseTemplateElement(isTagged);
          node.quasis = [curElt];
          while (!curElt.tail) {
            node.expressions.push(this.parseTemplateSubstitution());
            this.readTemplateContinuation();
            node.quasis.push(curElt = this.parseTemplateElement(isTagged));
          }
          return this.finishNode(node, "TemplateLiteral");
        }
        parseTemplateSubstitution() {
          return this.parseExpression();
        }
        parseObjectLike(close, isPattern, isRecord, refExpressionErrors) {
          if (isRecord) {
            this.expectPlugin("recordAndTuple");
          }
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = false;
          const propHash = /* @__PURE__ */ Object.create(null);
          let first = true;
          const node = this.startNode();
          node.properties = [];
          this.next();
          while (!this.match(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.match(close)) {
                this.addTrailingCommaExtraToNode(
                  node
                );
                break;
              }
            }
            let prop;
            if (isPattern) {
              prop = this.parseBindingProperty();
            } else {
              prop = this.parsePropertyDefinition(refExpressionErrors);
              this.checkProto(prop, isRecord, propHash, refExpressionErrors);
            }
            if (isRecord && !this.isObjectProperty(prop) && prop.type !== "SpreadElement") {
              this.raise(Errors.InvalidRecordProperty, {
                at: prop
              });
            }
            if (prop.shorthand) {
              this.addExtra(prop, "shorthand", true);
            }
            node.properties.push(prop);
          }
          this.next();
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          let type = "ObjectExpression";
          if (isPattern) {
            type = "ObjectPattern";
          } else if (isRecord) {
            type = "RecordExpression";
          }
          return this.finishNode(node, type);
        }
        addTrailingCommaExtraToNode(node) {
          this.addExtra(node, "trailingComma", this.state.lastTokStart);
          this.addExtra(node, "trailingCommaLoc", this.state.lastTokStartLoc, false);
        }
        maybeAsyncOrAccessorProp(prop) {
          return !prop.computed && prop.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
        }
        parsePropertyDefinition(refExpressionErrors) {
          let decorators = [];
          if (this.match(26)) {
            if (this.hasPlugin("decorators")) {
              this.raise(Errors.UnsupportedPropertyDecorator, {
                at: this.state.startLoc
              });
            }
            while (this.match(26)) {
              decorators.push(this.parseDecorator());
            }
          }
          const prop = this.startNode();
          let isAsync = false;
          let isAccessor = false;
          let startLoc;
          if (this.match(21)) {
            if (decorators.length)
              this.unexpected();
            return this.parseSpread();
          }
          if (decorators.length) {
            prop.decorators = decorators;
            decorators = [];
          }
          prop.method = false;
          if (refExpressionErrors) {
            startLoc = this.state.startLoc;
          }
          let isGenerator = this.eat(55);
          this.parsePropertyNamePrefixOperator(prop);
          const containsEsc = this.state.containsEsc;
          const key = this.parsePropertyName(prop, refExpressionErrors);
          if (!isGenerator && !containsEsc && this.maybeAsyncOrAccessorProp(prop)) {
            const keyName = key.name;
            if (keyName === "async" && !this.hasPrecedingLineBreak()) {
              isAsync = true;
              this.resetPreviousNodeTrailingComments(key);
              isGenerator = this.eat(55);
              this.parsePropertyName(prop);
            }
            if (keyName === "get" || keyName === "set") {
              isAccessor = true;
              this.resetPreviousNodeTrailingComments(key);
              prop.kind = keyName;
              if (this.match(55)) {
                isGenerator = true;
                this.raise(Errors.AccessorIsGenerator, {
                  at: this.state.curPosition(),
                  kind: keyName
                });
                this.next();
              }
              this.parsePropertyName(prop);
            }
          }
          return this.parseObjPropValue(prop, startLoc, isGenerator, isAsync, false, isAccessor, refExpressionErrors);
        }
        getGetterSetterExpectedParamCount(method2) {
          return method2.kind === "get" ? 0 : 1;
        }
        getObjectOrClassMethodParams(method2) {
          return method2.params;
        }
        checkGetterSetterParams(method2) {
          var _params;
          const paramCount = this.getGetterSetterExpectedParamCount(method2);
          const params = this.getObjectOrClassMethodParams(method2);
          if (params.length !== paramCount) {
            this.raise(method2.kind === "get" ? Errors.BadGetterArity : Errors.BadSetterArity, {
              at: method2
            });
          }
          if (method2.kind === "set" && ((_params = params[params.length - 1]) == null ? void 0 : _params.type) === "RestElement") {
            this.raise(Errors.BadSetterRestParameter, {
              at: method2
            });
          }
        }
        parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) {
          if (isAccessor) {
            const finishedProp = this.parseMethod(
              prop,
              isGenerator,
              false,
              false,
              false,
              "ObjectMethod"
            );
            this.checkGetterSetterParams(finishedProp);
            return finishedProp;
          }
          if (isAsync || isGenerator || this.match(10)) {
            if (isPattern)
              this.unexpected();
            prop.kind = "method";
            prop.method = true;
            return this.parseMethod(prop, isGenerator, isAsync, false, false, "ObjectMethod");
          }
        }
        parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors) {
          prop.shorthand = false;
          if (this.eat(14)) {
            prop.value = isPattern ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowIn(refExpressionErrors);
            return this.finishNode(prop, "ObjectProperty");
          }
          if (!prop.computed && prop.key.type === "Identifier") {
            this.checkReservedWord(prop.key.name, prop.key.loc.start, true, false);
            if (isPattern) {
              prop.value = this.parseMaybeDefault(startLoc, cloneIdentifier(prop.key));
            } else if (this.match(29)) {
              const shorthandAssignLoc = this.state.startLoc;
              if (refExpressionErrors != null) {
                if (refExpressionErrors.shorthandAssignLoc === null) {
                  refExpressionErrors.shorthandAssignLoc = shorthandAssignLoc;
                }
              } else {
                this.raise(Errors.InvalidCoverInitializedName, {
                  at: shorthandAssignLoc
                });
              }
              prop.value = this.parseMaybeDefault(startLoc, cloneIdentifier(prop.key));
            } else {
              prop.value = cloneIdentifier(prop.key);
            }
            prop.shorthand = true;
            return this.finishNode(prop, "ObjectProperty");
          }
        }
        parseObjPropValue(prop, startLoc, isGenerator, isAsync, isPattern, isAccessor, refExpressionErrors) {
          const node = this.parseObjectMethod(prop, isGenerator, isAsync, isPattern, isAccessor) || this.parseObjectProperty(prop, startLoc, isPattern, refExpressionErrors);
          if (!node)
            this.unexpected();
          return node;
        }
        parsePropertyName(prop, refExpressionErrors) {
          if (this.eat(0)) {
            prop.computed = true;
            prop.key = this.parseMaybeAssignAllowIn();
            this.expect(3);
          } else {
            const {
              type,
              value
            } = this.state;
            let key;
            if (tokenIsKeywordOrIdentifier(type)) {
              key = this.parseIdentifier(true);
            } else {
              switch (type) {
                case 132:
                  key = this.parseNumericLiteral(value);
                  break;
                case 131:
                  key = this.parseStringLiteral(value);
                  break;
                case 133:
                  key = this.parseBigIntLiteral(value);
                  break;
                case 134:
                  key = this.parseDecimalLiteral(value);
                  break;
                case 136: {
                  const privateKeyLoc = this.state.startLoc;
                  if (refExpressionErrors != null) {
                    if (refExpressionErrors.privateKeyLoc === null) {
                      refExpressionErrors.privateKeyLoc = privateKeyLoc;
                    }
                  } else {
                    this.raise(Errors.UnexpectedPrivateField, {
                      at: privateKeyLoc
                    });
                  }
                  key = this.parsePrivateName();
                  break;
                }
                default:
                  throw this.unexpected();
              }
            }
            prop.key = key;
            if (type !== 136) {
              prop.computed = false;
            }
          }
          return prop.key;
        }
        initFunction(node, isAsync) {
          node.id = null;
          node.generator = false;
          node.async = !!isAsync;
        }
        parseMethod(node, isGenerator, isAsync, isConstructor, allowDirectSuper, type, inClassScope = false) {
          this.initFunction(node, isAsync);
          node.generator = !!isGenerator;
          const allowModifiers = isConstructor;
          this.scope.enter(SCOPE_FUNCTION | SCOPE_SUPER | (inClassScope ? SCOPE_CLASS : 0) | (allowDirectSuper ? SCOPE_DIRECT_SUPER : 0));
          this.prodParam.enter(functionFlags(isAsync, node.generator));
          this.parseFunctionParams(node, allowModifiers);
          const finishedNode = this.parseFunctionBodyAndFinish(node, type, true);
          this.prodParam.exit();
          this.scope.exit();
          return finishedNode;
        }
        parseArrayLike(close, canBePattern, isTuple, refExpressionErrors) {
          if (isTuple) {
            this.expectPlugin("recordAndTuple");
          }
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = false;
          const node = this.startNode();
          this.next();
          node.elements = this.parseExprList(
            close,
            !isTuple,
            refExpressionErrors,
            node
          );
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          return this.finishNode(node, isTuple ? "TupleExpression" : "ArrayExpression");
        }
        parseArrowExpression(node, params, isAsync, trailingCommaLoc) {
          this.scope.enter(SCOPE_FUNCTION | SCOPE_ARROW);
          let flags = functionFlags(isAsync, false);
          if (!this.match(5) && this.prodParam.hasIn) {
            flags |= PARAM_IN;
          }
          this.prodParam.enter(flags);
          this.initFunction(node, isAsync);
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          if (params) {
            this.state.maybeInArrowParameters = true;
            this.setArrowFunctionParameters(node, params, trailingCommaLoc);
          }
          this.state.maybeInArrowParameters = false;
          this.parseFunctionBody(node, true);
          this.prodParam.exit();
          this.scope.exit();
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          return this.finishNode(node, "ArrowFunctionExpression");
        }
        setArrowFunctionParameters(node, params, trailingCommaLoc) {
          this.toAssignableList(params, trailingCommaLoc, false);
          node.params = params;
        }
        parseFunctionBodyAndFinish(node, type, isMethod = false) {
          this.parseFunctionBody(node, false, isMethod);
          return this.finishNode(node, type);
        }
        parseFunctionBody(node, allowExpression, isMethod = false) {
          const isExpression = allowExpression && !this.match(5);
          this.expressionScope.enter(newExpressionScope());
          if (isExpression) {
            node.body = this.parseMaybeAssign();
            this.checkParams(node, false, allowExpression, false);
          } else {
            const oldStrict = this.state.strict;
            const oldLabels = this.state.labels;
            this.state.labels = [];
            this.prodParam.enter(this.prodParam.currentFlags() | PARAM_RETURN);
            node.body = this.parseBlock(
              true,
              false,
              (hasStrictModeDirective) => {
                const nonSimple = !this.isSimpleParamList(node.params);
                if (hasStrictModeDirective && nonSimple) {
                  this.raise(Errors.IllegalLanguageModeDirective, {
                    at: (node.kind === "method" || node.kind === "constructor") && !!node.key ? node.key.loc.end : node
                  });
                }
                const strictModeChanged = !oldStrict && this.state.strict;
                this.checkParams(node, !this.state.strict && !allowExpression && !isMethod && !nonSimple, allowExpression, strictModeChanged);
                if (this.state.strict && node.id) {
                  this.checkIdentifier(node.id, BIND_OUTSIDE, strictModeChanged);
                }
              }
            );
            this.prodParam.exit();
            this.state.labels = oldLabels;
          }
          this.expressionScope.exit();
        }
        isSimpleParameter(node) {
          return node.type === "Identifier";
        }
        isSimpleParamList(params) {
          for (let i = 0, len = params.length; i < len; i++) {
            if (!this.isSimpleParameter(params[i]))
              return false;
          }
          return true;
        }
        checkParams(node, allowDuplicates, isArrowFunction, strictModeChanged = true) {
          const checkClashes = !allowDuplicates && /* @__PURE__ */ new Set();
          const formalParameters = {
            type: "FormalParameters"
          };
          for (const param of node.params) {
            this.checkLVal(param, {
              in: formalParameters,
              binding: BIND_VAR,
              checkClashes,
              strictModeChanged
            });
          }
        }
        parseExprList(close, allowEmpty, refExpressionErrors, nodeForExtra) {
          const elts = [];
          let first = true;
          while (!this.eat(close)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.match(close)) {
                if (nodeForExtra) {
                  this.addTrailingCommaExtraToNode(nodeForExtra);
                }
                this.next();
                break;
              }
            }
            elts.push(this.parseExprListItem(allowEmpty, refExpressionErrors));
          }
          return elts;
        }
        parseExprListItem(allowEmpty, refExpressionErrors, allowPlaceholder) {
          let elt;
          if (this.match(12)) {
            if (!allowEmpty) {
              this.raise(Errors.UnexpectedToken, {
                at: this.state.curPosition(),
                unexpected: ","
              });
            }
            elt = null;
          } else if (this.match(21)) {
            const spreadNodeStartLoc = this.state.startLoc;
            elt = this.parseParenItem(this.parseSpread(refExpressionErrors), spreadNodeStartLoc);
          } else if (this.match(17)) {
            this.expectPlugin("partialApplication");
            if (!allowPlaceholder) {
              this.raise(Errors.UnexpectedArgumentPlaceholder, {
                at: this.state.startLoc
              });
            }
            const node = this.startNode();
            this.next();
            elt = this.finishNode(node, "ArgumentPlaceholder");
          } else {
            elt = this.parseMaybeAssignAllowIn(refExpressionErrors, this.parseParenItem);
          }
          return elt;
        }
        parseIdentifier(liberal) {
          const node = this.startNode();
          const name = this.parseIdentifierName(liberal);
          return this.createIdentifier(node, name);
        }
        createIdentifier(node, name) {
          node.name = name;
          node.loc.identifierName = name;
          return this.finishNode(node, "Identifier");
        }
        parseIdentifierName(liberal) {
          let name;
          const {
            startLoc,
            type
          } = this.state;
          if (tokenIsKeywordOrIdentifier(type)) {
            name = this.state.value;
          } else {
            throw this.unexpected();
          }
          const tokenIsKeyword2 = tokenKeywordOrIdentifierIsKeyword(type);
          if (liberal) {
            if (tokenIsKeyword2) {
              this.replaceToken(130);
            }
          } else {
            this.checkReservedWord(name, startLoc, tokenIsKeyword2, false);
          }
          this.next();
          return name;
        }
        checkReservedWord(word, startLoc, checkKeywords, isBinding) {
          if (word.length > 10) {
            return;
          }
          if (!canBeReservedWord(word)) {
            return;
          }
          if (word === "yield") {
            if (this.prodParam.hasYield) {
              this.raise(Errors.YieldBindingIdentifier, {
                at: startLoc
              });
              return;
            }
          } else if (word === "await") {
            if (this.prodParam.hasAwait) {
              this.raise(Errors.AwaitBindingIdentifier, {
                at: startLoc
              });
              return;
            }
            if (this.scope.inStaticBlock) {
              this.raise(Errors.AwaitBindingIdentifierInStaticBlock, {
                at: startLoc
              });
              return;
            }
            this.expressionScope.recordAsyncArrowParametersError({
              at: startLoc
            });
          } else if (word === "arguments") {
            if (this.scope.inClassAndNotInNonArrowFunction) {
              this.raise(Errors.ArgumentsInClass, {
                at: startLoc
              });
              return;
            }
          }
          if (checkKeywords && isKeyword(word)) {
            this.raise(Errors.UnexpectedKeyword, {
              at: startLoc,
              keyword: word
            });
            return;
          }
          const reservedTest = !this.state.strict ? isReservedWord : isBinding ? isStrictBindReservedWord : isStrictReservedWord;
          if (reservedTest(word, this.inModule)) {
            this.raise(Errors.UnexpectedReservedWord, {
              at: startLoc,
              reservedWord: word
            });
          }
        }
        isAwaitAllowed() {
          if (this.prodParam.hasAwait)
            return true;
          if (this.options.allowAwaitOutsideFunction && !this.scope.inFunction) {
            return true;
          }
          return false;
        }
        parseAwait(startLoc) {
          const node = this.startNodeAt(startLoc);
          this.expressionScope.recordParameterInitializerError(Errors.AwaitExpressionFormalParameter, {
            at: node
          });
          if (this.eat(55)) {
            this.raise(Errors.ObsoleteAwaitStar, {
              at: node
            });
          }
          if (!this.scope.inFunction && !this.options.allowAwaitOutsideFunction) {
            if (this.isAmbiguousAwait()) {
              this.ambiguousScriptDifferentAst = true;
            } else {
              this.sawUnambiguousESM = true;
            }
          }
          if (!this.state.soloAwait) {
            node.argument = this.parseMaybeUnary(null, true);
          }
          return this.finishNode(node, "AwaitExpression");
        }
        isAmbiguousAwait() {
          if (this.hasPrecedingLineBreak())
            return true;
          const {
            type
          } = this.state;
          return type === 53 || type === 10 || type === 0 || tokenIsTemplate(type) || type === 101 && !this.state.containsEsc || type === 135 || type === 56 || this.hasPlugin("v8intrinsic") && type === 54;
        }
        parseYield() {
          const node = this.startNode();
          this.expressionScope.recordParameterInitializerError(Errors.YieldInParameter, {
            at: node
          });
          this.next();
          let delegating = false;
          let argument = null;
          if (!this.hasPrecedingLineBreak()) {
            delegating = this.eat(55);
            switch (this.state.type) {
              case 13:
              case 137:
              case 8:
              case 11:
              case 3:
              case 9:
              case 14:
              case 12:
                if (!delegating)
                  break;
              default:
                argument = this.parseMaybeAssign();
            }
          }
          node.delegate = delegating;
          node.argument = argument;
          return this.finishNode(node, "YieldExpression");
        }
        checkPipelineAtInfixOperator(left, leftStartLoc) {
          if (this.hasPlugin(["pipelineOperator", {
            proposal: "smart"
          }])) {
            if (left.type === "SequenceExpression") {
              this.raise(Errors.PipelineHeadSequenceExpression, {
                at: leftStartLoc
              });
            }
          }
        }
        parseSmartPipelineBodyInStyle(childExpr, startLoc) {
          if (this.isSimpleReference(childExpr)) {
            const bodyNode = this.startNodeAt(startLoc);
            bodyNode.callee = childExpr;
            return this.finishNode(bodyNode, "PipelineBareFunction");
          } else {
            const bodyNode = this.startNodeAt(startLoc);
            this.checkSmartPipeTopicBodyEarlyErrors(startLoc);
            bodyNode.expression = childExpr;
            return this.finishNode(bodyNode, "PipelineTopicExpression");
          }
        }
        isSimpleReference(expression) {
          switch (expression.type) {
            case "MemberExpression":
              return !expression.computed && this.isSimpleReference(expression.object);
            case "Identifier":
              return true;
            default:
              return false;
          }
        }
        checkSmartPipeTopicBodyEarlyErrors(startLoc) {
          if (this.match(19)) {
            throw this.raise(Errors.PipelineBodyNoArrow, {
              at: this.state.startLoc
            });
          }
          if (!this.topicReferenceWasUsedInCurrentContext()) {
            this.raise(Errors.PipelineTopicUnused, {
              at: startLoc
            });
          }
        }
        withTopicBindingContext(callback) {
          const outerContextTopicState = this.state.topicContext;
          this.state.topicContext = {
            maxNumOfResolvableTopics: 1,
            maxTopicIndex: null
          };
          try {
            return callback();
          } finally {
            this.state.topicContext = outerContextTopicState;
          }
        }
        withSmartMixTopicForbiddingContext(callback) {
          if (this.hasPlugin(["pipelineOperator", {
            proposal: "smart"
          }])) {
            const outerContextTopicState = this.state.topicContext;
            this.state.topicContext = {
              maxNumOfResolvableTopics: 0,
              maxTopicIndex: null
            };
            try {
              return callback();
            } finally {
              this.state.topicContext = outerContextTopicState;
            }
          } else {
            return callback();
          }
        }
        withSoloAwaitPermittingContext(callback) {
          const outerContextSoloAwaitState = this.state.soloAwait;
          this.state.soloAwait = true;
          try {
            return callback();
          } finally {
            this.state.soloAwait = outerContextSoloAwaitState;
          }
        }
        allowInAnd(callback) {
          const flags = this.prodParam.currentFlags();
          const prodParamToSet = PARAM_IN & ~flags;
          if (prodParamToSet) {
            this.prodParam.enter(flags | PARAM_IN);
            try {
              return callback();
            } finally {
              this.prodParam.exit();
            }
          }
          return callback();
        }
        disallowInAnd(callback) {
          const flags = this.prodParam.currentFlags();
          const prodParamToClear = PARAM_IN & flags;
          if (prodParamToClear) {
            this.prodParam.enter(flags & ~PARAM_IN);
            try {
              return callback();
            } finally {
              this.prodParam.exit();
            }
          }
          return callback();
        }
        registerTopicReference() {
          this.state.topicContext.maxTopicIndex = 0;
        }
        topicReferenceIsAllowedInCurrentContext() {
          return this.state.topicContext.maxNumOfResolvableTopics >= 1;
        }
        topicReferenceWasUsedInCurrentContext() {
          return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
        }
        parseFSharpPipelineBody(prec) {
          const startLoc = this.state.startLoc;
          this.state.potentialArrowAt = this.state.start;
          const oldInFSharpPipelineDirectBody = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = true;
          const ret = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), startLoc, prec);
          this.state.inFSharpPipelineDirectBody = oldInFSharpPipelineDirectBody;
          return ret;
        }
        parseModuleExpression() {
          this.expectPlugin("moduleBlocks");
          const node = this.startNode();
          this.next();
          if (!this.match(5)) {
            this.unexpected(null, 5);
          }
          const program3 = this.startNodeAt(this.state.endLoc);
          this.next();
          const revertScopes = this.initializeScopes(true);
          this.enterInitialScopes();
          try {
            node.body = this.parseProgram(program3, 8, "module");
          } finally {
            revertScopes();
          }
          return this.finishNode(node, "ModuleExpression");
        }
        parsePropertyNamePrefixOperator(prop) {
        }
      };
      var loopLabel = {
        kind: "loop"
      };
      var switchLabel = {
        kind: "switch"
      };
      var FUNC_NO_FLAGS = 0;
      var FUNC_STATEMENT = 1;
      var FUNC_HANGING_STATEMENT = 2;
      var FUNC_NULLABLE_ID = 4;
      var loneSurrogate = /[\uD800-\uDFFF]/u;
      var keywordRelationalOperator = /in(?:stanceof)?/y;
      function babel7CompatTokens(tokens, input) {
        for (let i = 0; i < tokens.length; i++) {
          const token = tokens[i];
          const {
            type
          } = token;
          if (typeof type === "number") {
            {
              if (type === 136) {
                const {
                  loc,
                  start,
                  value,
                  end
                } = token;
                const hashEndPos = start + 1;
                const hashEndLoc = createPositionWithColumnOffset(loc.start, 1);
                tokens.splice(i, 1, new Token({
                  type: getExportedToken(27),
                  value: "#",
                  start,
                  end: hashEndPos,
                  startLoc: loc.start,
                  endLoc: hashEndLoc
                }), new Token({
                  type: getExportedToken(130),
                  value,
                  start: hashEndPos,
                  end,
                  startLoc: hashEndLoc,
                  endLoc: loc.end
                }));
                i++;
                continue;
              }
              if (tokenIsTemplate(type)) {
                const {
                  loc,
                  start,
                  value,
                  end
                } = token;
                const backquoteEnd = start + 1;
                const backquoteEndLoc = createPositionWithColumnOffset(loc.start, 1);
                let startToken;
                if (input.charCodeAt(start) === 96) {
                  startToken = new Token({
                    type: getExportedToken(22),
                    value: "`",
                    start,
                    end: backquoteEnd,
                    startLoc: loc.start,
                    endLoc: backquoteEndLoc
                  });
                } else {
                  startToken = new Token({
                    type: getExportedToken(8),
                    value: "}",
                    start,
                    end: backquoteEnd,
                    startLoc: loc.start,
                    endLoc: backquoteEndLoc
                  });
                }
                let templateValue, templateElementEnd, templateElementEndLoc, endToken;
                if (type === 24) {
                  templateElementEnd = end - 1;
                  templateElementEndLoc = createPositionWithColumnOffset(loc.end, -1);
                  templateValue = value === null ? null : value.slice(1, -1);
                  endToken = new Token({
                    type: getExportedToken(22),
                    value: "`",
                    start: templateElementEnd,
                    end,
                    startLoc: templateElementEndLoc,
                    endLoc: loc.end
                  });
                } else {
                  templateElementEnd = end - 2;
                  templateElementEndLoc = createPositionWithColumnOffset(loc.end, -2);
                  templateValue = value === null ? null : value.slice(1, -2);
                  endToken = new Token({
                    type: getExportedToken(23),
                    value: "${",
                    start: templateElementEnd,
                    end,
                    startLoc: templateElementEndLoc,
                    endLoc: loc.end
                  });
                }
                tokens.splice(i, 1, startToken, new Token({
                  type: getExportedToken(20),
                  value: templateValue,
                  start: backquoteEnd,
                  end: templateElementEnd,
                  startLoc: backquoteEndLoc,
                  endLoc: templateElementEndLoc
                }), endToken);
                i += 2;
                continue;
              }
            }
            token.type = getExportedToken(type);
          }
        }
        return tokens;
      }
      var StatementParser = class extends ExpressionParser {
        parseTopLevel(file2, program3) {
          file2.program = this.parseProgram(program3);
          file2.comments = this.state.comments;
          if (this.options.tokens) {
            file2.tokens = babel7CompatTokens(this.tokens, this.input);
          }
          return this.finishNode(file2, "File");
        }
        parseProgram(program3, end = 137, sourceType = this.options.sourceType) {
          program3.sourceType = sourceType;
          program3.interpreter = this.parseInterpreterDirective();
          this.parseBlockBody(program3, true, true, end);
          if (this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0) {
            for (const [localName, at2] of Array.from(this.scope.undefinedExports)) {
              this.raise(Errors.ModuleExportUndefined, {
                at: at2,
                localName
              });
            }
          }
          let finishedProgram;
          if (end === 137) {
            finishedProgram = this.finishNode(program3, "Program");
          } else {
            finishedProgram = this.finishNodeAt(program3, "Program", createPositionWithColumnOffset(this.state.startLoc, -1));
          }
          return finishedProgram;
        }
        stmtToDirective(stmt) {
          const directive = stmt;
          directive.type = "Directive";
          directive.value = directive.expression;
          delete directive.expression;
          const directiveLiteral = directive.value;
          const expressionValue = directiveLiteral.value;
          const raw = this.input.slice(directiveLiteral.start, directiveLiteral.end);
          const val = directiveLiteral.value = raw.slice(1, -1);
          this.addExtra(directiveLiteral, "raw", raw);
          this.addExtra(directiveLiteral, "rawValue", val);
          this.addExtra(directiveLiteral, "expressionValue", expressionValue);
          directiveLiteral.type = "DirectiveLiteral";
          return directive;
        }
        parseInterpreterDirective() {
          if (!this.match(28)) {
            return null;
          }
          const node = this.startNode();
          node.value = this.state.value;
          this.next();
          return this.finishNode(node, "InterpreterDirective");
        }
        isLet(context) {
          if (!this.isContextual(99)) {
            return false;
          }
          return this.hasFollowingIdentifier(context);
        }
        hasFollowingIdentifier(context) {
          const next = this.nextTokenStart();
          const nextCh = this.codePointAtPos(next);
          if (nextCh === 92 || nextCh === 91) {
            return true;
          }
          if (context)
            return false;
          if (nextCh === 123)
            return true;
          if (isIdentifierStart(nextCh)) {
            keywordRelationalOperator.lastIndex = next;
            if (keywordRelationalOperator.test(this.input)) {
              const endCh = this.codePointAtPos(keywordRelationalOperator.lastIndex);
              if (!isIdentifierChar(endCh) && endCh !== 92) {
                return false;
              }
            }
            return true;
          }
          return false;
        }
        startsUsingForOf() {
          const lookahead = this.lookahead();
          if (lookahead.type === 101 && !lookahead.containsEsc) {
            return false;
          } else {
            this.expectPlugin("explicitResourceManagement");
            return true;
          }
        }
        parseStatement(context, topLevel) {
          let decorators = null;
          if (this.match(26)) {
            decorators = this.parseDecorators(true);
          }
          return this.parseStatementContent(context, topLevel, decorators);
        }
        parseStatementContent(context, topLevel, decorators) {
          const starttype = this.state.type;
          const node = this.startNode();
          switch (starttype) {
            case 60:
              return this.parseBreakContinueStatement(node, true);
            case 63:
              return this.parseBreakContinueStatement(node, false);
            case 64:
              return this.parseDebuggerStatement(node);
            case 90:
              return this.parseDoStatement(node);
            case 91:
              return this.parseForStatement(node);
            case 68:
              if (this.lookaheadCharCode() === 46)
                break;
              if (context) {
                if (this.state.strict) {
                  this.raise(Errors.StrictFunction, {
                    at: this.state.startLoc
                  });
                } else if (context !== "if" && context !== "label") {
                  this.raise(Errors.SloppyFunction, {
                    at: this.state.startLoc
                  });
                }
              }
              return this.parseFunctionStatement(node, false, !context);
            case 80:
              if (context)
                this.unexpected();
              return this.parseClass(this.maybeTakeDecorators(decorators, node), true);
            case 69:
              return this.parseIfStatement(node);
            case 70:
              return this.parseReturnStatement(node);
            case 71:
              return this.parseSwitchStatement(node);
            case 72:
              return this.parseThrowStatement(node);
            case 73:
              return this.parseTryStatement(node);
            case 105:
              if (this.hasFollowingLineBreak()) {
                break;
              }
            case 99:
              if (this.state.containsEsc || !this.hasFollowingIdentifier(context)) {
                break;
              }
            case 75:
            case 74: {
              const kind = this.state.value;
              if (kind === "using") {
                this.expectPlugin("explicitResourceManagement");
                if (!this.scope.inModule && this.scope.inTopLevel) {
                  this.raise(Errors.UnexpectedUsingDeclaration, {
                    at: this.state.startLoc
                  });
                }
              }
              if (context && kind !== "var") {
                this.raise(Errors.UnexpectedLexicalDeclaration, {
                  at: this.state.startLoc
                });
              }
              return this.parseVarStatement(node, kind);
            }
            case 92:
              return this.parseWhileStatement(node);
            case 76:
              return this.parseWithStatement(node);
            case 5:
              return this.parseBlock();
            case 13:
              return this.parseEmptyStatement(node);
            case 83: {
              const nextTokenCharCode = this.lookaheadCharCode();
              if (nextTokenCharCode === 40 || nextTokenCharCode === 46) {
                break;
              }
            }
            case 82: {
              if (!this.options.allowImportExportEverywhere && !topLevel) {
                this.raise(Errors.UnexpectedImportExport, {
                  at: this.state.startLoc
                });
              }
              this.next();
              let result2;
              if (starttype === 83) {
                result2 = this.parseImport(node);
                if (result2.type === "ImportDeclaration" && (!result2.importKind || result2.importKind === "value")) {
                  this.sawUnambiguousESM = true;
                }
              } else {
                result2 = this.parseExport(node, decorators);
                if (result2.type === "ExportNamedDeclaration" && (!result2.exportKind || result2.exportKind === "value") || result2.type === "ExportAllDeclaration" && (!result2.exportKind || result2.exportKind === "value") || result2.type === "ExportDefaultDeclaration") {
                  this.sawUnambiguousESM = true;
                }
              }
              this.assertModuleNodeAllowed(result2);
              return result2;
            }
            default: {
              if (this.isAsyncFunction()) {
                if (context) {
                  this.raise(Errors.AsyncFunctionInSingleStatementContext, {
                    at: this.state.startLoc
                  });
                }
                this.next();
                return this.parseFunctionStatement(node, true, !context);
              }
            }
          }
          const maybeName = this.state.value;
          const expr = this.parseExpression();
          if (tokenIsIdentifier(starttype) && expr.type === "Identifier" && this.eat(14)) {
            return this.parseLabeledStatement(
              node,
              maybeName,
              expr,
              context
            );
          } else {
            return this.parseExpressionStatement(node, expr, decorators);
          }
        }
        assertModuleNodeAllowed(node) {
          if (!this.options.allowImportExportEverywhere && !this.inModule) {
            this.raise(Errors.ImportOutsideModule, {
              at: node
            });
          }
        }
        decoratorsEnabledBeforeExport() {
          if (this.hasPlugin("decorators-legacy"))
            return true;
          return this.hasPlugin("decorators") && !!this.getPluginOption("decorators", "decoratorsBeforeExport");
        }
        maybeTakeDecorators(maybeDecorators, classNode, exportNode) {
          if (maybeDecorators) {
            classNode.decorators = maybeDecorators;
            this.resetStartLocationFromNode(classNode, maybeDecorators[0]);
            if (exportNode)
              this.resetStartLocationFromNode(exportNode, classNode);
          }
          return classNode;
        }
        canHaveLeadingDecorator() {
          return this.match(80);
        }
        parseDecorators(allowExport) {
          const decorators = [];
          do {
            decorators.push(this.parseDecorator());
          } while (this.match(26));
          if (this.match(82)) {
            if (!allowExport) {
              this.unexpected();
            }
            if (!this.decoratorsEnabledBeforeExport()) {
              this.raise(Errors.DecoratorExportClass, {
                at: this.state.startLoc
              });
            }
          } else if (!this.canHaveLeadingDecorator()) {
            throw this.raise(Errors.UnexpectedLeadingDecorator, {
              at: this.state.startLoc
            });
          }
          return decorators;
        }
        parseDecorator() {
          this.expectOnePlugin(["decorators", "decorators-legacy"]);
          const node = this.startNode();
          this.next();
          if (this.hasPlugin("decorators")) {
            const startLoc = this.state.startLoc;
            let expr;
            if (this.match(10)) {
              const startLoc2 = this.state.startLoc;
              this.next();
              expr = this.parseExpression();
              this.expect(11);
              expr = this.wrapParenthesis(startLoc2, expr);
              const paramsStartLoc = this.state.startLoc;
              node.expression = this.parseMaybeDecoratorArguments(expr);
              if (this.getPluginOption("decorators", "allowCallParenthesized") === false && node.expression !== expr) {
                this.raise(Errors.DecoratorArgumentsOutsideParentheses, {
                  at: paramsStartLoc
                });
              }
            } else {
              expr = this.parseIdentifier(false);
              while (this.eat(16)) {
                const node2 = this.startNodeAt(startLoc);
                node2.object = expr;
                if (this.match(136)) {
                  this.classScope.usePrivateName(this.state.value, this.state.startLoc);
                  node2.property = this.parsePrivateName();
                } else {
                  node2.property = this.parseIdentifier(true);
                }
                node2.computed = false;
                expr = this.finishNode(node2, "MemberExpression");
              }
              node.expression = this.parseMaybeDecoratorArguments(expr);
            }
          } else {
            node.expression = this.parseExprSubscripts();
          }
          return this.finishNode(node, "Decorator");
        }
        parseMaybeDecoratorArguments(expr) {
          if (this.eat(10)) {
            const node = this.startNodeAtNode(expr);
            node.callee = expr;
            node.arguments = this.parseCallExpressionArguments(11, false);
            this.toReferencedList(node.arguments);
            return this.finishNode(node, "CallExpression");
          }
          return expr;
        }
        parseBreakContinueStatement(node, isBreak) {
          this.next();
          if (this.isLineTerminator()) {
            node.label = null;
          } else {
            node.label = this.parseIdentifier();
            this.semicolon();
          }
          this.verifyBreakContinue(node, isBreak);
          return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
        }
        verifyBreakContinue(node, isBreak) {
          let i;
          for (i = 0; i < this.state.labels.length; ++i) {
            const lab = this.state.labels[i];
            if (node.label == null || lab.name === node.label.name) {
              if (lab.kind != null && (isBreak || lab.kind === "loop"))
                break;
              if (node.label && isBreak)
                break;
            }
          }
          if (i === this.state.labels.length) {
            const type = isBreak ? "BreakStatement" : "ContinueStatement";
            this.raise(Errors.IllegalBreakContinue, {
              at: node,
              type
            });
          }
        }
        parseDebuggerStatement(node) {
          this.next();
          this.semicolon();
          return this.finishNode(node, "DebuggerStatement");
        }
        parseHeaderExpression() {
          this.expect(10);
          const val = this.parseExpression();
          this.expect(11);
          return val;
        }
        parseDoStatement(node) {
          this.next();
          this.state.labels.push(loopLabel);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("do"));
          this.state.labels.pop();
          this.expect(92);
          node.test = this.parseHeaderExpression();
          this.eat(13);
          return this.finishNode(node, "DoWhileStatement");
        }
        parseForStatement(node) {
          this.next();
          this.state.labels.push(loopLabel);
          let awaitAt = null;
          if (this.isAwaitAllowed() && this.eatContextual(96)) {
            awaitAt = this.state.lastTokStartLoc;
          }
          this.scope.enter(SCOPE_OTHER);
          this.expect(10);
          if (this.match(13)) {
            if (awaitAt !== null) {
              this.unexpected(awaitAt);
            }
            return this.parseFor(node, null);
          }
          const startsWithLet = this.isContextual(99);
          const startsWithUsing = this.isContextual(105) && !this.hasFollowingLineBreak();
          const isLetOrUsing = startsWithLet && this.hasFollowingIdentifier() || startsWithUsing && this.hasFollowingIdentifier() && this.startsUsingForOf();
          if (this.match(74) || this.match(75) || isLetOrUsing) {
            const initNode = this.startNode();
            const kind = this.state.value;
            this.next();
            this.parseVar(initNode, true, kind);
            const init2 = this.finishNode(initNode, "VariableDeclaration");
            const isForIn = this.match(58);
            if (isForIn && startsWithUsing) {
              this.raise(Errors.ForInUsing, {
                at: init2
              });
            }
            if ((isForIn || this.isContextual(101)) && init2.declarations.length === 1) {
              return this.parseForIn(node, init2, awaitAt);
            }
            if (awaitAt !== null) {
              this.unexpected(awaitAt);
            }
            return this.parseFor(node, init2);
          }
          const startsWithAsync = this.isContextual(95);
          const refExpressionErrors = new ExpressionErrors();
          const init = this.parseExpression(true, refExpressionErrors);
          const isForOf = this.isContextual(101);
          if (isForOf) {
            if (startsWithLet) {
              this.raise(Errors.ForOfLet, {
                at: init
              });
            }
            if (awaitAt === null && startsWithAsync && init.type === "Identifier") {
              this.raise(Errors.ForOfAsync, {
                at: init
              });
            }
          }
          if (isForOf || this.match(58)) {
            this.checkDestructuringPrivate(refExpressionErrors);
            this.toAssignable(init, true);
            const type = isForOf ? "ForOfStatement" : "ForInStatement";
            this.checkLVal(init, {
              in: {
                type
              }
            });
            return this.parseForIn(
              node,
              init,
              awaitAt
            );
          } else {
            this.checkExpressionErrors(refExpressionErrors, true);
          }
          if (awaitAt !== null) {
            this.unexpected(awaitAt);
          }
          return this.parseFor(node, init);
        }
        parseFunctionStatement(node, isAsync, declarationPosition) {
          this.next();
          return this.parseFunction(node, FUNC_STATEMENT | (declarationPosition ? 0 : FUNC_HANGING_STATEMENT), isAsync);
        }
        parseIfStatement(node) {
          this.next();
          node.test = this.parseHeaderExpression();
          node.consequent = this.parseStatement("if");
          node.alternate = this.eat(66) ? this.parseStatement("if") : null;
          return this.finishNode(node, "IfStatement");
        }
        parseReturnStatement(node) {
          if (!this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction) {
            this.raise(Errors.IllegalReturn, {
              at: this.state.startLoc
            });
          }
          this.next();
          if (this.isLineTerminator()) {
            node.argument = null;
          } else {
            node.argument = this.parseExpression();
            this.semicolon();
          }
          return this.finishNode(node, "ReturnStatement");
        }
        parseSwitchStatement(node) {
          this.next();
          node.discriminant = this.parseHeaderExpression();
          const cases = node.cases = [];
          this.expect(5);
          this.state.labels.push(switchLabel);
          this.scope.enter(SCOPE_OTHER);
          let cur;
          for (let sawDefault; !this.match(8); ) {
            if (this.match(61) || this.match(65)) {
              const isCase = this.match(61);
              if (cur)
                this.finishNode(cur, "SwitchCase");
              cases.push(cur = this.startNode());
              cur.consequent = [];
              this.next();
              if (isCase) {
                cur.test = this.parseExpression();
              } else {
                if (sawDefault) {
                  this.raise(Errors.MultipleDefaultsInSwitch, {
                    at: this.state.lastTokStartLoc
                  });
                }
                sawDefault = true;
                cur.test = null;
              }
              this.expect(14);
            } else {
              if (cur) {
                cur.consequent.push(this.parseStatement(null));
              } else {
                this.unexpected();
              }
            }
          }
          this.scope.exit();
          if (cur)
            this.finishNode(cur, "SwitchCase");
          this.next();
          this.state.labels.pop();
          return this.finishNode(node, "SwitchStatement");
        }
        parseThrowStatement(node) {
          this.next();
          if (this.hasPrecedingLineBreak()) {
            this.raise(Errors.NewlineAfterThrow, {
              at: this.state.lastTokEndLoc
            });
          }
          node.argument = this.parseExpression();
          this.semicolon();
          return this.finishNode(node, "ThrowStatement");
        }
        parseCatchClauseParam() {
          const param = this.parseBindingAtom();
          const simple = param.type === "Identifier";
          this.scope.enter(simple ? SCOPE_SIMPLE_CATCH : 0);
          this.checkLVal(param, {
            in: {
              type: "CatchClause"
            },
            binding: BIND_LEXICAL,
            allowingSloppyLetBinding: true
          });
          return param;
        }
        parseTryStatement(node) {
          this.next();
          node.block = this.parseBlock();
          node.handler = null;
          if (this.match(62)) {
            const clause = this.startNode();
            this.next();
            if (this.match(10)) {
              this.expect(10);
              clause.param = this.parseCatchClauseParam();
              this.expect(11);
            } else {
              clause.param = null;
              this.scope.enter(SCOPE_OTHER);
            }
            clause.body = this.withSmartMixTopicForbiddingContext(() => this.parseBlock(false, false));
            this.scope.exit();
            node.handler = this.finishNode(clause, "CatchClause");
          }
          node.finalizer = this.eat(67) ? this.parseBlock() : null;
          if (!node.handler && !node.finalizer) {
            this.raise(Errors.NoCatchOrFinally, {
              at: node
            });
          }
          return this.finishNode(node, "TryStatement");
        }
        parseVarStatement(node, kind, allowMissingInitializer = false) {
          this.next();
          this.parseVar(node, false, kind, allowMissingInitializer);
          this.semicolon();
          return this.finishNode(node, "VariableDeclaration");
        }
        parseWhileStatement(node) {
          this.next();
          node.test = this.parseHeaderExpression();
          this.state.labels.push(loopLabel);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("while"));
          this.state.labels.pop();
          return this.finishNode(node, "WhileStatement");
        }
        parseWithStatement(node) {
          if (this.state.strict) {
            this.raise(Errors.StrictWith, {
              at: this.state.startLoc
            });
          }
          this.next();
          node.object = this.parseHeaderExpression();
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("with"));
          return this.finishNode(node, "WithStatement");
        }
        parseEmptyStatement(node) {
          this.next();
          return this.finishNode(node, "EmptyStatement");
        }
        parseLabeledStatement(node, maybeName, expr, context) {
          for (const label of this.state.labels) {
            if (label.name === maybeName) {
              this.raise(Errors.LabelRedeclaration, {
                at: expr,
                labelName: maybeName
              });
            }
          }
          const kind = tokenIsLoop(this.state.type) ? "loop" : this.match(71) ? "switch" : null;
          for (let i = this.state.labels.length - 1; i >= 0; i--) {
            const label = this.state.labels[i];
            if (label.statementStart === node.start) {
              label.statementStart = this.state.start;
              label.kind = kind;
            } else {
              break;
            }
          }
          this.state.labels.push({
            name: maybeName,
            kind,
            statementStart: this.state.start
          });
          node.body = this.parseStatement(context ? context.indexOf("label") === -1 ? context + "label" : context : "label");
          this.state.labels.pop();
          node.label = expr;
          return this.finishNode(node, "LabeledStatement");
        }
        parseExpressionStatement(node, expr, decorators) {
          node.expression = expr;
          this.semicolon();
          return this.finishNode(node, "ExpressionStatement");
        }
        parseBlock(allowDirectives = false, createNewLexicalScope = true, afterBlockParse) {
          const node = this.startNode();
          if (allowDirectives) {
            this.state.strictErrors.clear();
          }
          this.expect(5);
          if (createNewLexicalScope) {
            this.scope.enter(SCOPE_OTHER);
          }
          this.parseBlockBody(node, allowDirectives, false, 8, afterBlockParse);
          if (createNewLexicalScope) {
            this.scope.exit();
          }
          return this.finishNode(node, "BlockStatement");
        }
        isValidDirective(stmt) {
          return stmt.type === "ExpressionStatement" && stmt.expression.type === "StringLiteral" && !stmt.expression.extra.parenthesized;
        }
        parseBlockBody(node, allowDirectives, topLevel, end, afterBlockParse) {
          const body = node.body = [];
          const directives = node.directives = [];
          this.parseBlockOrModuleBlockBody(body, allowDirectives ? directives : void 0, topLevel, end, afterBlockParse);
        }
        parseBlockOrModuleBlockBody(body, directives, topLevel, end, afterBlockParse) {
          const oldStrict = this.state.strict;
          let hasStrictModeDirective = false;
          let parsedNonDirective = false;
          while (!this.match(end)) {
            const stmt = this.parseStatement(null, topLevel);
            if (directives && !parsedNonDirective) {
              if (this.isValidDirective(stmt)) {
                const directive = this.stmtToDirective(stmt);
                directives.push(directive);
                if (!hasStrictModeDirective && directive.value.value === "use strict") {
                  hasStrictModeDirective = true;
                  this.setStrict(true);
                }
                continue;
              }
              parsedNonDirective = true;
              this.state.strictErrors.clear();
            }
            body.push(stmt);
          }
          if (afterBlockParse) {
            afterBlockParse.call(this, hasStrictModeDirective);
          }
          if (!oldStrict) {
            this.setStrict(false);
          }
          this.next();
        }
        parseFor(node, init) {
          node.init = init;
          this.semicolon(false);
          node.test = this.match(13) ? null : this.parseExpression();
          this.semicolon(false);
          node.update = this.match(11) ? null : this.parseExpression();
          this.expect(11);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("for"));
          this.scope.exit();
          this.state.labels.pop();
          return this.finishNode(node, "ForStatement");
        }
        parseForIn(node, init, awaitAt) {
          const isForIn = this.match(58);
          this.next();
          if (isForIn) {
            if (awaitAt !== null)
              this.unexpected(awaitAt);
          } else {
            node.await = awaitAt !== null;
          }
          if (init.type === "VariableDeclaration" && init.declarations[0].init != null && (!isForIn || this.state.strict || init.kind !== "var" || init.declarations[0].id.type !== "Identifier")) {
            this.raise(Errors.ForInOfLoopInitializer, {
              at: init,
              type: isForIn ? "ForInStatement" : "ForOfStatement"
            });
          }
          if (init.type === "AssignmentPattern") {
            this.raise(Errors.InvalidLhs, {
              at: init,
              ancestor: {
                type: "ForStatement"
              }
            });
          }
          node.left = init;
          node.right = isForIn ? this.parseExpression() : this.parseMaybeAssignAllowIn();
          this.expect(11);
          node.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("for"));
          this.scope.exit();
          this.state.labels.pop();
          return this.finishNode(node, isForIn ? "ForInStatement" : "ForOfStatement");
        }
        parseVar(node, isFor, kind, allowMissingInitializer = false) {
          const declarations = node.declarations = [];
          node.kind = kind;
          for (; ; ) {
            const decl = this.startNode();
            this.parseVarId(decl, kind);
            decl.init = !this.eat(29) ? null : isFor ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn();
            if (decl.init === null && !allowMissingInitializer) {
              if (decl.id.type !== "Identifier" && !(isFor && (this.match(58) || this.isContextual(101)))) {
                this.raise(Errors.DeclarationMissingInitializer, {
                  at: this.state.lastTokEndLoc,
                  kind: "destructuring"
                });
              } else if (kind === "const" && !(this.match(58) || this.isContextual(101))) {
                this.raise(Errors.DeclarationMissingInitializer, {
                  at: this.state.lastTokEndLoc,
                  kind: "const"
                });
              }
            }
            declarations.push(this.finishNode(decl, "VariableDeclarator"));
            if (!this.eat(12))
              break;
          }
          return node;
        }
        parseVarId(decl, kind) {
          const id = this.parseBindingAtom();
          if (kind === "using" && id.type !== "Identifier") {
            this.raise(Errors.UsingDeclarationHasBindingPattern, {
              at: id
            });
          }
          this.checkLVal(id, {
            in: {
              type: "VariableDeclarator"
            },
            binding: kind === "var" ? BIND_VAR : BIND_LEXICAL
          });
          decl.id = id;
        }
        parseFunction(node, statement = FUNC_NO_FLAGS, isAsync = false) {
          const isStatement = statement & FUNC_STATEMENT;
          const isHangingStatement = statement & FUNC_HANGING_STATEMENT;
          const requireId = !!isStatement && !(statement & FUNC_NULLABLE_ID);
          this.initFunction(node, isAsync);
          if (this.match(55) && isHangingStatement) {
            this.raise(Errors.GeneratorInSingleStatementContext, {
              at: this.state.startLoc
            });
          }
          node.generator = this.eat(55);
          if (isStatement) {
            node.id = this.parseFunctionId(requireId);
          }
          const oldMaybeInArrowParameters = this.state.maybeInArrowParameters;
          this.state.maybeInArrowParameters = false;
          this.scope.enter(SCOPE_FUNCTION);
          this.prodParam.enter(functionFlags(isAsync, node.generator));
          if (!isStatement) {
            node.id = this.parseFunctionId();
          }
          this.parseFunctionParams(node, false);
          this.withSmartMixTopicForbiddingContext(() => {
            this.parseFunctionBodyAndFinish(node, isStatement ? "FunctionDeclaration" : "FunctionExpression");
          });
          this.prodParam.exit();
          this.scope.exit();
          if (isStatement && !isHangingStatement) {
            this.registerFunctionStatementId(node);
          }
          this.state.maybeInArrowParameters = oldMaybeInArrowParameters;
          return node;
        }
        parseFunctionId(requireId) {
          return requireId || tokenIsIdentifier(this.state.type) ? this.parseIdentifier() : null;
        }
        parseFunctionParams(node, allowModifiers) {
          this.expect(10);
          this.expressionScope.enter(newParameterDeclarationScope());
          node.params = this.parseBindingList(11, 41, false, allowModifiers);
          this.expressionScope.exit();
        }
        registerFunctionStatementId(node) {
          if (!node.id)
            return;
          this.scope.declareName(node.id.name, this.state.strict || node.generator || node.async ? this.scope.treatFunctionsAsVar ? BIND_VAR : BIND_LEXICAL : BIND_FUNCTION, node.id.loc.start);
        }
        parseClass(node, isStatement, optionalId) {
          this.next();
          const oldStrict = this.state.strict;
          this.state.strict = true;
          this.parseClassId(node, isStatement, optionalId);
          this.parseClassSuper(node);
          node.body = this.parseClassBody(!!node.superClass, oldStrict);
          return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
        }
        isClassProperty() {
          return this.match(29) || this.match(13) || this.match(8);
        }
        isClassMethod() {
          return this.match(10);
        }
        isNonstaticConstructor(method2) {
          return !method2.computed && !method2.static && (method2.key.name === "constructor" || method2.key.value === "constructor");
        }
        parseClassBody(hadSuperClass, oldStrict) {
          this.classScope.enter();
          const state = {
            hadConstructor: false,
            hadSuperClass
          };
          let decorators = [];
          const classBody = this.startNode();
          classBody.body = [];
          this.expect(5);
          this.withSmartMixTopicForbiddingContext(() => {
            while (!this.match(8)) {
              if (this.eat(13)) {
                if (decorators.length > 0) {
                  throw this.raise(Errors.DecoratorSemicolon, {
                    at: this.state.lastTokEndLoc
                  });
                }
                continue;
              }
              if (this.match(26)) {
                decorators.push(this.parseDecorator());
                continue;
              }
              const member = this.startNode();
              if (decorators.length) {
                member.decorators = decorators;
                this.resetStartLocationFromNode(member, decorators[0]);
                decorators = [];
              }
              this.parseClassMember(classBody, member, state);
              if (member.kind === "constructor" && member.decorators && member.decorators.length > 0) {
                this.raise(Errors.DecoratorConstructor, {
                  at: member
                });
              }
            }
          });
          this.state.strict = oldStrict;
          this.next();
          if (decorators.length) {
            throw this.raise(Errors.TrailingDecorator, {
              at: this.state.startLoc
            });
          }
          this.classScope.exit();
          return this.finishNode(classBody, "ClassBody");
        }
        parseClassMemberFromModifier(classBody, member) {
          const key = this.parseIdentifier(true);
          if (this.isClassMethod()) {
            const method2 = member;
            method2.kind = "method";
            method2.computed = false;
            method2.key = key;
            method2.static = false;
            this.pushClassMethod(classBody, method2, false, false, false, false);
            return true;
          } else if (this.isClassProperty()) {
            const prop = member;
            prop.computed = false;
            prop.key = key;
            prop.static = false;
            classBody.body.push(this.parseClassProperty(prop));
            return true;
          }
          this.resetPreviousNodeTrailingComments(key);
          return false;
        }
        parseClassMember(classBody, member, state) {
          const isStatic = this.isContextual(104);
          if (isStatic) {
            if (this.parseClassMemberFromModifier(classBody, member)) {
              return;
            }
            if (this.eat(5)) {
              this.parseClassStaticBlock(classBody, member);
              return;
            }
          }
          this.parseClassMemberWithIsStatic(classBody, member, state, isStatic);
        }
        parseClassMemberWithIsStatic(classBody, member, state, isStatic) {
          const publicMethod = member;
          const privateMethod = member;
          const publicProp = member;
          const privateProp = member;
          const accessorProp = member;
          const method2 = publicMethod;
          const publicMember = publicMethod;
          member.static = isStatic;
          this.parsePropertyNamePrefixOperator(member);
          if (this.eat(55)) {
            method2.kind = "method";
            const isPrivateName = this.match(136);
            this.parseClassElementName(method2);
            if (isPrivateName) {
              this.pushClassPrivateMethod(classBody, privateMethod, true, false);
              return;
            }
            if (this.isNonstaticConstructor(publicMethod)) {
              this.raise(Errors.ConstructorIsGenerator, {
                at: publicMethod.key
              });
            }
            this.pushClassMethod(classBody, publicMethod, true, false, false, false);
            return;
          }
          const isContextual = tokenIsIdentifier(this.state.type) && !this.state.containsEsc;
          const isPrivate = this.match(136);
          const key = this.parseClassElementName(member);
          const maybeQuestionTokenStartLoc = this.state.startLoc;
          this.parsePostMemberNameModifiers(publicMember);
          if (this.isClassMethod()) {
            method2.kind = "method";
            if (isPrivate) {
              this.pushClassPrivateMethod(classBody, privateMethod, false, false);
              return;
            }
            const isConstructor = this.isNonstaticConstructor(publicMethod);
            let allowsDirectSuper = false;
            if (isConstructor) {
              publicMethod.kind = "constructor";
              if (state.hadConstructor && !this.hasPlugin("typescript")) {
                this.raise(Errors.DuplicateConstructor, {
                  at: key
                });
              }
              if (isConstructor && this.hasPlugin("typescript") && member.override) {
                this.raise(Errors.OverrideOnConstructor, {
                  at: key
                });
              }
              state.hadConstructor = true;
              allowsDirectSuper = state.hadSuperClass;
            }
            this.pushClassMethod(classBody, publicMethod, false, false, isConstructor, allowsDirectSuper);
          } else if (this.isClassProperty()) {
            if (isPrivate) {
              this.pushClassPrivateProperty(classBody, privateProp);
            } else {
              this.pushClassProperty(classBody, publicProp);
            }
          } else if (isContextual && key.name === "async" && !this.isLineTerminator()) {
            this.resetPreviousNodeTrailingComments(key);
            const isGenerator = this.eat(55);
            if (publicMember.optional) {
              this.unexpected(maybeQuestionTokenStartLoc);
            }
            method2.kind = "method";
            const isPrivate2 = this.match(136);
            this.parseClassElementName(method2);
            this.parsePostMemberNameModifiers(publicMember);
            if (isPrivate2) {
              this.pushClassPrivateMethod(classBody, privateMethod, isGenerator, true);
            } else {
              if (this.isNonstaticConstructor(publicMethod)) {
                this.raise(Errors.ConstructorIsAsync, {
                  at: publicMethod.key
                });
              }
              this.pushClassMethod(classBody, publicMethod, isGenerator, true, false, false);
            }
          } else if (isContextual && (key.name === "get" || key.name === "set") && !(this.match(55) && this.isLineTerminator())) {
            this.resetPreviousNodeTrailingComments(key);
            method2.kind = key.name;
            const isPrivate2 = this.match(136);
            this.parseClassElementName(publicMethod);
            if (isPrivate2) {
              this.pushClassPrivateMethod(classBody, privateMethod, false, false);
            } else {
              if (this.isNonstaticConstructor(publicMethod)) {
                this.raise(Errors.ConstructorIsAccessor, {
                  at: publicMethod.key
                });
              }
              this.pushClassMethod(classBody, publicMethod, false, false, false, false);
            }
            this.checkGetterSetterParams(publicMethod);
          } else if (isContextual && key.name === "accessor" && !this.isLineTerminator()) {
            this.expectPlugin("decoratorAutoAccessors");
            this.resetPreviousNodeTrailingComments(key);
            const isPrivate2 = this.match(136);
            this.parseClassElementName(publicProp);
            this.pushClassAccessorProperty(classBody, accessorProp, isPrivate2);
          } else if (this.isLineTerminator()) {
            if (isPrivate) {
              this.pushClassPrivateProperty(classBody, privateProp);
            } else {
              this.pushClassProperty(classBody, publicProp);
            }
          } else {
            this.unexpected();
          }
        }
        parseClassElementName(member) {
          const {
            type,
            value
          } = this.state;
          if ((type === 130 || type === 131) && member.static && value === "prototype") {
            this.raise(Errors.StaticPrototype, {
              at: this.state.startLoc
            });
          }
          if (type === 136) {
            if (value === "constructor") {
              this.raise(Errors.ConstructorClassPrivateField, {
                at: this.state.startLoc
              });
            }
            const key = this.parsePrivateName();
            member.key = key;
            return key;
          }
          return this.parsePropertyName(member);
        }
        parseClassStaticBlock(classBody, member) {
          var _member$decorators;
          this.scope.enter(SCOPE_CLASS | SCOPE_STATIC_BLOCK | SCOPE_SUPER);
          const oldLabels = this.state.labels;
          this.state.labels = [];
          this.prodParam.enter(PARAM);
          const body = member.body = [];
          this.parseBlockOrModuleBlockBody(body, void 0, false, 8);
          this.prodParam.exit();
          this.scope.exit();
          this.state.labels = oldLabels;
          classBody.body.push(this.finishNode(member, "StaticBlock"));
          if ((_member$decorators = member.decorators) != null && _member$decorators.length) {
            this.raise(Errors.DecoratorStaticBlock, {
              at: member
            });
          }
        }
        pushClassProperty(classBody, prop) {
          if (!prop.computed && (prop.key.name === "constructor" || prop.key.value === "constructor")) {
            this.raise(Errors.ConstructorClassField, {
              at: prop.key
            });
          }
          classBody.body.push(this.parseClassProperty(prop));
        }
        pushClassPrivateProperty(classBody, prop) {
          const node = this.parseClassPrivateProperty(prop);
          classBody.body.push(node);
          this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), CLASS_ELEMENT_OTHER, node.key.loc.start);
        }
        pushClassAccessorProperty(classBody, prop, isPrivate) {
          if (!isPrivate && !prop.computed) {
            const key = prop.key;
            if (key.name === "constructor" || key.value === "constructor") {
              this.raise(Errors.ConstructorClassField, {
                at: key
              });
            }
          }
          const node = this.parseClassAccessorProperty(prop);
          classBody.body.push(node);
          if (isPrivate) {
            this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), CLASS_ELEMENT_OTHER, node.key.loc.start);
          }
        }
        pushClassMethod(classBody, method2, isGenerator, isAsync, isConstructor, allowsDirectSuper) {
          classBody.body.push(this.parseMethod(method2, isGenerator, isAsync, isConstructor, allowsDirectSuper, "ClassMethod", true));
        }
        pushClassPrivateMethod(classBody, method2, isGenerator, isAsync) {
          const node = this.parseMethod(method2, isGenerator, isAsync, false, false, "ClassPrivateMethod", true);
          classBody.body.push(node);
          const kind = node.kind === "get" ? node.static ? CLASS_ELEMENT_STATIC_GETTER : CLASS_ELEMENT_INSTANCE_GETTER : node.kind === "set" ? node.static ? CLASS_ELEMENT_STATIC_SETTER : CLASS_ELEMENT_INSTANCE_SETTER : CLASS_ELEMENT_OTHER;
          this.declareClassPrivateMethodInScope(node, kind);
        }
        declareClassPrivateMethodInScope(node, kind) {
          this.classScope.declarePrivateName(this.getPrivateNameSV(node.key), kind, node.key.loc.start);
        }
        parsePostMemberNameModifiers(methodOrProp) {
        }
        parseClassPrivateProperty(node) {
          this.parseInitializer(node);
          this.semicolon();
          return this.finishNode(node, "ClassPrivateProperty");
        }
        parseClassProperty(node) {
          this.parseInitializer(node);
          this.semicolon();
          return this.finishNode(node, "ClassProperty");
        }
        parseClassAccessorProperty(node) {
          this.parseInitializer(node);
          this.semicolon();
          return this.finishNode(node, "ClassAccessorProperty");
        }
        parseInitializer(node) {
          this.scope.enter(SCOPE_CLASS | SCOPE_SUPER);
          this.expressionScope.enter(newExpressionScope());
          this.prodParam.enter(PARAM);
          node.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null;
          this.expressionScope.exit();
          this.prodParam.exit();
          this.scope.exit();
        }
        parseClassId(node, isStatement, optionalId, bindingType = BIND_CLASS) {
          if (tokenIsIdentifier(this.state.type)) {
            node.id = this.parseIdentifier();
            if (isStatement) {
              this.declareNameFromIdentifier(node.id, bindingType);
            }
          } else {
            if (optionalId || !isStatement) {
              node.id = null;
            } else {
              throw this.raise(Errors.MissingClassName, {
                at: this.state.startLoc
              });
            }
          }
        }
        parseClassSuper(node) {
          node.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
        }
        parseExport(node, decorators) {
          const hasDefault = this.maybeParseExportDefaultSpecifier(
            node
          );
          const parseAfterDefault = !hasDefault || this.eat(12);
          const hasStar = parseAfterDefault && this.eatExportStar(
            node
          );
          const hasNamespace = hasStar && this.maybeParseExportNamespaceSpecifier(
            node
          );
          const parseAfterNamespace = parseAfterDefault && (!hasNamespace || this.eat(12));
          const isFromRequired = hasDefault || hasStar;
          if (hasStar && !hasNamespace) {
            if (hasDefault)
              this.unexpected();
            if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, {
                at: node
              });
            }
            this.parseExportFrom(node, true);
            return this.finishNode(node, "ExportAllDeclaration");
          }
          const hasSpecifiers = this.maybeParseExportNamedSpecifiers(
            node
          );
          if (hasDefault && parseAfterDefault && !hasStar && !hasSpecifiers || hasNamespace && parseAfterNamespace && !hasSpecifiers) {
            throw this.unexpected(null, 5);
          }
          let hasDeclaration;
          if (isFromRequired || hasSpecifiers) {
            hasDeclaration = false;
            if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, {
                at: node
              });
            }
            this.parseExportFrom(node, isFromRequired);
          } else {
            hasDeclaration = this.maybeParseExportDeclaration(node);
          }
          if (isFromRequired || hasSpecifiers || hasDeclaration) {
            var _node2$declaration;
            const node2 = node;
            this.checkExport(node2, true, false, !!node2.source);
            if (((_node2$declaration = node2.declaration) == null ? void 0 : _node2$declaration.type) === "ClassDeclaration") {
              this.maybeTakeDecorators(decorators, node2.declaration, node2);
            } else if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, {
                at: node
              });
            }
            return this.finishNode(node2, "ExportNamedDeclaration");
          }
          if (this.eat(65)) {
            const node2 = node;
            const decl = this.parseExportDefaultExpression();
            node2.declaration = decl;
            if (decl.type === "ClassDeclaration") {
              this.maybeTakeDecorators(decorators, decl, node2);
            } else if (decorators) {
              throw this.raise(Errors.UnsupportedDecoratorExport, {
                at: node
              });
            }
            this.checkExport(node2, true, true);
            return this.finishNode(node2, "ExportDefaultDeclaration");
          }
          throw this.unexpected(null, 5);
        }
        eatExportStar(node) {
          return this.eat(55);
        }
        maybeParseExportDefaultSpecifier(node) {
          if (this.isExportDefaultSpecifier()) {
            this.expectPlugin("exportDefaultFrom");
            const specifier = this.startNode();
            specifier.exported = this.parseIdentifier(true);
            node.specifiers = [this.finishNode(specifier, "ExportDefaultSpecifier")];
            return true;
          }
          return false;
        }
        maybeParseExportNamespaceSpecifier(node) {
          if (this.isContextual(93)) {
            if (!node.specifiers)
              node.specifiers = [];
            const specifier = this.startNodeAt(this.state.lastTokStartLoc);
            this.next();
            specifier.exported = this.parseModuleExportName();
            node.specifiers.push(this.finishNode(specifier, "ExportNamespaceSpecifier"));
            return true;
          }
          return false;
        }
        maybeParseExportNamedSpecifiers(node) {
          if (this.match(5)) {
            if (!node.specifiers)
              node.specifiers = [];
            const isTypeExport = node.exportKind === "type";
            node.specifiers.push(...this.parseExportSpecifiers(isTypeExport));
            node.source = null;
            node.declaration = null;
            if (this.hasPlugin("importAssertions")) {
              node.assertions = [];
            }
            return true;
          }
          return false;
        }
        maybeParseExportDeclaration(node) {
          if (this.shouldParseExportDeclaration()) {
            node.specifiers = [];
            node.source = null;
            if (this.hasPlugin("importAssertions")) {
              node.assertions = [];
            }
            node.declaration = this.parseExportDeclaration(node);
            return true;
          }
          return false;
        }
        isAsyncFunction() {
          if (!this.isContextual(95))
            return false;
          const next = this.nextTokenStart();
          return !lineBreak.test(this.input.slice(this.state.pos, next)) && this.isUnparsedContextual(next, "function");
        }
        parseExportDefaultExpression() {
          const expr = this.startNode();
          const isAsync = this.isAsyncFunction();
          if (this.match(68) || isAsync) {
            this.next();
            if (isAsync) {
              this.next();
            }
            return this.parseFunction(expr, FUNC_STATEMENT | FUNC_NULLABLE_ID, isAsync);
          }
          if (this.match(80)) {
            return this.parseClass(expr, true, true);
          }
          if (this.match(26)) {
            if (this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport")) {
              this.raise(Errors.DecoratorBeforeExport, {
                at: this.state.startLoc
              });
            }
            return this.parseClass(this.maybeTakeDecorators(this.parseDecorators(false), this.startNode()), true, true);
          }
          if (this.match(75) || this.match(74) || this.isLet()) {
            throw this.raise(Errors.UnsupportedDefaultExport, {
              at: this.state.startLoc
            });
          }
          const res = this.parseMaybeAssignAllowIn();
          this.semicolon();
          return res;
        }
        parseExportDeclaration(node) {
          if (this.match(80)) {
            const node2 = this.parseClass(this.startNode(), true, false);
            return node2;
          }
          return this.parseStatement(null);
        }
        isExportDefaultSpecifier() {
          const {
            type
          } = this.state;
          if (tokenIsIdentifier(type)) {
            if (type === 95 && !this.state.containsEsc || type === 99) {
              return false;
            }
            if ((type === 128 || type === 127) && !this.state.containsEsc) {
              const {
                type: nextType
              } = this.lookahead();
              if (tokenIsIdentifier(nextType) && nextType !== 97 || nextType === 5) {
                this.expectOnePlugin(["flow", "typescript"]);
                return false;
              }
            }
          } else if (!this.match(65)) {
            return false;
          }
          const next = this.nextTokenStart();
          const hasFrom = this.isUnparsedContextual(next, "from");
          if (this.input.charCodeAt(next) === 44 || tokenIsIdentifier(this.state.type) && hasFrom) {
            return true;
          }
          if (this.match(65) && hasFrom) {
            const nextAfterFrom = this.input.charCodeAt(this.nextTokenStartSince(next + 4));
            return nextAfterFrom === 34 || nextAfterFrom === 39;
          }
          return false;
        }
        parseExportFrom(node, expect) {
          if (this.eatContextual(97)) {
            node.source = this.parseImportSource();
            this.checkExport(node);
            const assertions = this.maybeParseImportAssertions();
            if (assertions) {
              node.assertions = assertions;
              this.checkJSONModuleImport(node);
            }
          } else if (expect) {
            this.unexpected();
          }
          this.semicolon();
        }
        shouldParseExportDeclaration() {
          const {
            type
          } = this.state;
          if (type === 26) {
            this.expectOnePlugin(["decorators", "decorators-legacy"]);
            if (this.hasPlugin("decorators")) {
              if (this.getPluginOption("decorators", "decoratorsBeforeExport")) {
                throw this.raise(Errors.DecoratorBeforeExport, {
                  at: this.state.startLoc
                });
              }
              return true;
            }
          }
          return type === 74 || type === 75 || type === 68 || type === 80 || this.isLet() || this.isAsyncFunction();
        }
        checkExport(node, checkNames, isDefault, isFrom) {
          if (checkNames) {
            if (isDefault) {
              this.checkDuplicateExports(node, "default");
              if (this.hasPlugin("exportDefaultFrom")) {
                var _declaration$extra;
                const declaration = node.declaration;
                if (declaration.type === "Identifier" && declaration.name === "from" && declaration.end - declaration.start === 4 && !((_declaration$extra = declaration.extra) != null && _declaration$extra.parenthesized)) {
                  this.raise(Errors.ExportDefaultFromAsIdentifier, {
                    at: declaration
                  });
                }
              }
            } else if (node.specifiers && node.specifiers.length) {
              for (const specifier of node.specifiers) {
                const {
                  exported
                } = specifier;
                const exportName = exported.type === "Identifier" ? exported.name : exported.value;
                this.checkDuplicateExports(specifier, exportName);
                if (!isFrom && specifier.local) {
                  const {
                    local
                  } = specifier;
                  if (local.type !== "Identifier") {
                    this.raise(Errors.ExportBindingIsString, {
                      at: specifier,
                      localName: local.value,
                      exportName
                    });
                  } else {
                    this.checkReservedWord(local.name, local.loc.start, true, false);
                    this.scope.checkLocalExport(local);
                  }
                }
              }
            } else if (node.declaration) {
              if (node.declaration.type === "FunctionDeclaration" || node.declaration.type === "ClassDeclaration") {
                const id = node.declaration.id;
                if (!id)
                  throw new Error("Assertion failure");
                this.checkDuplicateExports(node, id.name);
              } else if (node.declaration.type === "VariableDeclaration") {
                for (const declaration of node.declaration.declarations) {
                  this.checkDeclaration(declaration.id);
                }
              }
            }
          }
        }
        checkDeclaration(node) {
          if (node.type === "Identifier") {
            this.checkDuplicateExports(node, node.name);
          } else if (node.type === "ObjectPattern") {
            for (const prop of node.properties) {
              this.checkDeclaration(prop);
            }
          } else if (node.type === "ArrayPattern") {
            for (const elem of node.elements) {
              if (elem) {
                this.checkDeclaration(elem);
              }
            }
          } else if (node.type === "ObjectProperty") {
            this.checkDeclaration(node.value);
          } else if (node.type === "RestElement") {
            this.checkDeclaration(node.argument);
          } else if (node.type === "AssignmentPattern") {
            this.checkDeclaration(node.left);
          }
        }
        checkDuplicateExports(node, exportName) {
          if (this.exportedIdentifiers.has(exportName)) {
            if (exportName === "default") {
              this.raise(Errors.DuplicateDefaultExport, {
                at: node
              });
            } else {
              this.raise(Errors.DuplicateExport, {
                at: node,
                exportName
              });
            }
          }
          this.exportedIdentifiers.add(exportName);
        }
        parseExportSpecifiers(isInTypeExport) {
          const nodes = [];
          let first = true;
          this.expect(5);
          while (!this.eat(8)) {
            if (first) {
              first = false;
            } else {
              this.expect(12);
              if (this.eat(8))
                break;
            }
            const isMaybeTypeOnly = this.isContextual(128);
            const isString2 = this.match(131);
            const node = this.startNode();
            node.local = this.parseModuleExportName();
            nodes.push(this.parseExportSpecifier(node, isString2, isInTypeExport, isMaybeTypeOnly));
          }
          return nodes;
        }
        parseExportSpecifier(node, isString2, isInTypeExport, isMaybeTypeOnly) {
          if (this.eatContextual(93)) {
            node.exported = this.parseModuleExportName();
          } else if (isString2) {
            node.exported = cloneStringLiteral(node.local);
          } else if (!node.exported) {
            node.exported = cloneIdentifier(node.local);
          }
          return this.finishNode(node, "ExportSpecifier");
        }
        parseModuleExportName() {
          if (this.match(131)) {
            const result2 = this.parseStringLiteral(this.state.value);
            const surrogate = result2.value.match(loneSurrogate);
            if (surrogate) {
              this.raise(Errors.ModuleExportNameHasLoneSurrogate, {
                at: result2,
                surrogateCharCode: surrogate[0].charCodeAt(0)
              });
            }
            return result2;
          }
          return this.parseIdentifier(true);
        }
        isJSONModuleImport(node) {
          if (node.assertions != null) {
            return node.assertions.some(({
              key,
              value
            }) => {
              return value.value === "json" && (key.type === "Identifier" ? key.name === "type" : key.value === "type");
            });
          }
          return false;
        }
        checkImportReflection(node) {
          if (node.module) {
            var _node$assertions;
            if (node.specifiers.length !== 1 || node.specifiers[0].type !== "ImportDefaultSpecifier") {
              this.raise(Errors.ImportReflectionNotBinding, {
                at: node.specifiers[0].loc.start
              });
            }
            if (((_node$assertions = node.assertions) == null ? void 0 : _node$assertions.length) > 0) {
              this.raise(Errors.ImportReflectionHasAssertion, {
                at: node.specifiers[0].loc.start
              });
            }
          }
        }
        checkJSONModuleImport(node) {
          if (this.isJSONModuleImport(node) && node.type !== "ExportAllDeclaration") {
            const {
              specifiers
            } = node;
            if (specifiers != null) {
              const nonDefaultNamedSpecifier = specifiers.find((specifier) => {
                let imported;
                if (specifier.type === "ExportSpecifier") {
                  imported = specifier.local;
                } else if (specifier.type === "ImportSpecifier") {
                  imported = specifier.imported;
                }
                if (imported !== void 0) {
                  return imported.type === "Identifier" ? imported.name !== "default" : imported.value !== "default";
                }
              });
              if (nonDefaultNamedSpecifier !== void 0) {
                this.raise(Errors.ImportJSONBindingNotDefault, {
                  at: nonDefaultNamedSpecifier.loc.start
                });
              }
            }
          }
        }
        parseMaybeImportReflection(node) {
          let isImportReflection = false;
          if (this.isContextual(125)) {
            const lookahead = this.lookahead();
            if (tokenIsIdentifier(lookahead.type)) {
              if (lookahead.type !== 97) {
                isImportReflection = true;
              } else {
                const nextNextTokenFirstChar = this.input.charCodeAt(this.nextTokenStartSince(lookahead.end));
                if (nextNextTokenFirstChar === 102) {
                  isImportReflection = true;
                }
              }
            } else {
              isImportReflection = true;
            }
          }
          if (isImportReflection) {
            this.expectPlugin("importReflection");
            this.next();
            node.module = true;
          } else if (this.hasPlugin("importReflection")) {
            node.module = false;
          }
        }
        parseImport(node) {
          node.specifiers = [];
          if (!this.match(131)) {
            this.parseMaybeImportReflection(node);
            const hasDefault = this.maybeParseDefaultImportSpecifier(node);
            const parseNext = !hasDefault || this.eat(12);
            const hasStar = parseNext && this.maybeParseStarImportSpecifier(node);
            if (parseNext && !hasStar)
              this.parseNamedImportSpecifiers(node);
            this.expectContextual(97);
          }
          node.source = this.parseImportSource();
          const assertions = this.maybeParseImportAssertions();
          if (assertions) {
            node.assertions = assertions;
          } else {
            const attributes = this.maybeParseModuleAttributes();
            if (attributes) {
              node.attributes = attributes;
            }
          }
          this.checkImportReflection(node);
          this.checkJSONModuleImport(node);
          this.semicolon();
          return this.finishNode(node, "ImportDeclaration");
        }
        parseImportSource() {
          if (!this.match(131))
            this.unexpected();
          return this.parseExprAtom();
        }
        shouldParseDefaultImport(node) {
          return tokenIsIdentifier(this.state.type);
        }
        parseImportSpecifierLocal(node, specifier, type) {
          specifier.local = this.parseIdentifier();
          node.specifiers.push(this.finishImportSpecifier(specifier, type));
        }
        finishImportSpecifier(specifier, type, bindingType = BIND_LEXICAL) {
          this.checkLVal(specifier.local, {
            in: specifier,
            binding: bindingType
          });
          return this.finishNode(specifier, type);
        }
        parseAssertEntries() {
          const attrs = [];
          const attrNames = /* @__PURE__ */ new Set();
          do {
            if (this.match(8)) {
              break;
            }
            const node = this.startNode();
            const keyName = this.state.value;
            if (attrNames.has(keyName)) {
              this.raise(Errors.ModuleAttributesWithDuplicateKeys, {
                at: this.state.startLoc,
                key: keyName
              });
            }
            attrNames.add(keyName);
            if (this.match(131)) {
              node.key = this.parseStringLiteral(keyName);
            } else {
              node.key = this.parseIdentifier(true);
            }
            this.expect(14);
            if (!this.match(131)) {
              throw this.raise(Errors.ModuleAttributeInvalidValue, {
                at: this.state.startLoc
              });
            }
            node.value = this.parseStringLiteral(this.state.value);
            attrs.push(this.finishNode(node, "ImportAttribute"));
          } while (this.eat(12));
          return attrs;
        }
        maybeParseModuleAttributes() {
          if (this.match(76) && !this.hasPrecedingLineBreak()) {
            this.expectPlugin("moduleAttributes");
            this.next();
          } else {
            if (this.hasPlugin("moduleAttributes"))
              return [];
            return null;
          }
          const attrs = [];
          const attributes = /* @__PURE__ */ new Set();
          do {
            const node = this.startNode();
            node.key = this.parseIdentifier(true);
            if (node.key.name !== "type") {
              this.raise(Errors.ModuleAttributeDifferentFromType, {
                at: node.key
              });
            }
            if (attributes.has(node.key.name)) {
              this.raise(Errors.ModuleAttributesWithDuplicateKeys, {
                at: node.key,
                key: node.key.name
              });
            }
            attributes.add(node.key.name);
            this.expect(14);
            if (!this.match(131)) {
              throw this.raise(Errors.ModuleAttributeInvalidValue, {
                at: this.state.startLoc
              });
            }
            node.value = this.parseStringLiteral(this.state.value);
            this.finishNode(node, "ImportAttribute");
            attrs.push(node);
          } while (this.eat(12));
          return attrs;
        }
        maybeParseImportAssertions() {
          if (this.isContextual(94) && !this.hasPrecedingLineBreak()) {
            this.expectPlugin("importAssertions");
            this.next();
          } else {
            if (this.hasPlugin("importAssertions"))
              return [];
            return null;
          }
          this.eat(5);
          const attrs = this.parseAssertEntries();
          this.eat(8);
          return attrs;
        }
        maybeParseDefaultImportSpecifier(node) {
          if (this.shouldParseDefaultImport(node)) {
            this.parseImportSpecifierLocal(node, this.startNode(), "ImportDefaultSpecifier");
            return true;
          }
          return false;
        }
        maybeParseStarImportSpecifier(node) {
          if (this.match(55)) {
            const specifier = this.startNode();
            this.next();
            this.expectContextual(93);
            this.parseImportSpecifierLocal(node, specifier, "ImportNamespaceSpecifier");
            return true;
          }
          return false;
        }
        parseNamedImportSpecifiers(node) {
          let first = true;
          this.expect(5);
          while (!this.eat(8)) {
            if (first) {
              first = false;
            } else {
              if (this.eat(14)) {
                throw this.raise(Errors.DestructureNamedImport, {
                  at: this.state.startLoc
                });
              }
              this.expect(12);
              if (this.eat(8))
                break;
            }
            const specifier = this.startNode();
            const importedIsString = this.match(131);
            const isMaybeTypeOnly = this.isContextual(128);
            specifier.imported = this.parseModuleExportName();
            const importSpecifier = this.parseImportSpecifier(specifier, importedIsString, node.importKind === "type" || node.importKind === "typeof", isMaybeTypeOnly, void 0);
            node.specifiers.push(importSpecifier);
          }
        }
        parseImportSpecifier(specifier, importedIsString, isInTypeOnlyImport, isMaybeTypeOnly, bindingType) {
          if (this.eatContextual(93)) {
            specifier.local = this.parseIdentifier();
          } else {
            const {
              imported
            } = specifier;
            if (importedIsString) {
              throw this.raise(Errors.ImportBindingIsString, {
                at: specifier,
                importName: imported.value
              });
            }
            this.checkReservedWord(imported.name, specifier.loc.start, true, true);
            if (!specifier.local) {
              specifier.local = cloneIdentifier(imported);
            }
          }
          return this.finishImportSpecifier(specifier, "ImportSpecifier", bindingType);
        }
        isThisParam(param) {
          return param.type === "Identifier" && param.name === "this";
        }
      };
      var Parser = class extends StatementParser {
        constructor(options, input) {
          options = getOptions(options);
          super(options, input);
          this.options = options;
          this.initializeScopes();
          this.plugins = pluginsMap(this.options.plugins);
          this.filename = options.sourceFilename;
        }
        getScopeHandler() {
          return ScopeHandler;
        }
        parse() {
          this.enterInitialScopes();
          const file2 = this.startNode();
          const program3 = this.startNode();
          this.nextToken();
          file2.errors = null;
          this.parseTopLevel(file2, program3);
          file2.errors = this.state.errors;
          return file2;
        }
      };
      function pluginsMap(plugins5) {
        const pluginMap = /* @__PURE__ */ new Map();
        for (const plugin of plugins5) {
          const [name, options] = Array.isArray(plugin) ? plugin : [plugin, {}];
          if (!pluginMap.has(name))
            pluginMap.set(name, options || {});
        }
        return pluginMap;
      }
      function parse3(input, options) {
        var _options;
        if (((_options = options) == null ? void 0 : _options.sourceType) === "unambiguous") {
          options = Object.assign({}, options);
          try {
            options.sourceType = "module";
            const parser3 = getParser(options, input);
            const ast = parser3.parse();
            if (parser3.sawUnambiguousESM) {
              return ast;
            }
            if (parser3.ambiguousScriptDifferentAst) {
              try {
                options.sourceType = "script";
                return getParser(options, input).parse();
              } catch (_unused) {
              }
            } else {
              ast.program.sourceType = "script";
            }
            return ast;
          } catch (moduleError) {
            try {
              options.sourceType = "script";
              return getParser(options, input).parse();
            } catch (_unused2) {
            }
            throw moduleError;
          }
        } else {
          return getParser(options, input).parse();
        }
      }
      function parseExpression3(input, options) {
        const parser3 = getParser(options, input);
        if (parser3.options.strictMode) {
          parser3.state.strict = true;
        }
        return parser3.getExpression();
      }
      function generateExportedTokenTypes(internalTokenTypes) {
        const tokenTypes2 = {};
        for (const typeName of Object.keys(internalTokenTypes)) {
          tokenTypes2[typeName] = getExportedToken(internalTokenTypes[typeName]);
        }
        return tokenTypes2;
      }
      var tokTypes = generateExportedTokenTypes(tt);
      function getParser(options, input) {
        let cls = Parser;
        if (options != null && options.plugins) {
          validatePlugins(options.plugins);
          cls = getParserClass(options.plugins);
        }
        return new cls(options, input);
      }
      var parserClassCache = {};
      function getParserClass(pluginsFromOptions) {
        const pluginList = mixinPluginNames.filter((name) => hasPlugin(pluginsFromOptions, name));
        const key = pluginList.join("/");
        let cls = parserClassCache[key];
        if (!cls) {
          cls = Parser;
          for (const plugin of pluginList) {
            cls = mixinPlugins[plugin](cls);
          }
          parserClassCache[key] = cls;
        }
        return cls;
      }
      exports2.parse = parse3;
      exports2.parseExpression = parseExpression3;
      exports2.tokTypes = tokTypes;
    }
  });

  // node_modules/@jridgewell/set-array/dist/set-array.umd.js
  var require_set_array_umd = __commonJS({
    "node_modules/@jridgewell/set-array/dist/set-array.umd.js"(exports2, module2) {
      init_define_process();
      (function(global2, factory2) {
        typeof exports2 === "object" && typeof module2 !== "undefined" ? factory2(exports2) : typeof define === "function" && define.amd ? define(["exports"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(global2.setArray = {}));
      })(exports2, function(exports3) {
        "use strict";
        exports3.get = void 0;
        exports3.put = void 0;
        exports3.pop = void 0;
        class SetArray {
          constructor() {
            this._indexes = { __proto__: null };
            this.array = [];
          }
        }
        (() => {
          exports3.get = (strarr, key) => strarr._indexes[key];
          exports3.put = (strarr, key) => {
            const index = exports3.get(strarr, key);
            if (index !== void 0)
              return index;
            const { array, _indexes: indexes } = strarr;
            return indexes[key] = array.push(key) - 1;
          };
          exports3.pop = (strarr) => {
            const { array, _indexes: indexes } = strarr;
            if (array.length === 0)
              return;
            const last2 = array.pop();
            indexes[last2] = void 0;
          };
        })();
        exports3.SetArray = SetArray;
        Object.defineProperty(exports3, "__esModule", { value: true });
      });
    }
  });

  // node_modules/@jridgewell/sourcemap-codec/dist/sourcemap-codec.umd.js
  var require_sourcemap_codec_umd = __commonJS({
    "node_modules/@jridgewell/sourcemap-codec/dist/sourcemap-codec.umd.js"(exports2, module2) {
      init_define_process();
      (function(global2, factory2) {
        typeof exports2 === "object" && typeof module2 !== "undefined" ? factory2(exports2) : typeof define === "function" && define.amd ? define(["exports"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(global2.sourcemapCodec = {}));
      })(exports2, function(exports3) {
        "use strict";
        const comma = ",".charCodeAt(0);
        const semicolon = ";".charCodeAt(0);
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        const intToChar = new Uint8Array(64);
        const charToInt = new Uint8Array(128);
        for (let i = 0; i < chars.length; i++) {
          const c = chars.charCodeAt(i);
          intToChar[i] = c;
          charToInt[c] = i;
        }
        const td = typeof TextDecoder !== "undefined" ? /* @__PURE__ */ new TextDecoder() : typeof Buffer !== "undefined" ? {
          decode(buf) {
            const out = Buffer.from(buf.buffer, buf.byteOffset, buf.byteLength);
            return out.toString();
          }
        } : {
          decode(buf) {
            let out = "";
            for (let i = 0; i < buf.length; i++) {
              out += String.fromCharCode(buf[i]);
            }
            return out;
          }
        };
        function decode(mappings) {
          const state = new Int32Array(5);
          const decoded = [];
          let index = 0;
          do {
            const semi = indexOf2(mappings, index);
            const line = [];
            let sorted = true;
            let lastCol = 0;
            state[0] = 0;
            for (let i = index; i < semi; i++) {
              let seg;
              i = decodeInteger(mappings, i, state, 0);
              const col = state[0];
              if (col < lastCol)
                sorted = false;
              lastCol = col;
              if (hasMoreVlq(mappings, i, semi)) {
                i = decodeInteger(mappings, i, state, 1);
                i = decodeInteger(mappings, i, state, 2);
                i = decodeInteger(mappings, i, state, 3);
                if (hasMoreVlq(mappings, i, semi)) {
                  i = decodeInteger(mappings, i, state, 4);
                  seg = [col, state[1], state[2], state[3], state[4]];
                } else {
                  seg = [col, state[1], state[2], state[3]];
                }
              } else {
                seg = [col];
              }
              line.push(seg);
            }
            if (!sorted)
              sort(line);
            decoded.push(line);
            index = semi + 1;
          } while (index <= mappings.length);
          return decoded;
        }
        function indexOf2(mappings, index) {
          const idx = mappings.indexOf(";", index);
          return idx === -1 ? mappings.length : idx;
        }
        function decodeInteger(mappings, pos, state, j) {
          let value = 0;
          let shift = 0;
          let integer = 0;
          do {
            const c = mappings.charCodeAt(pos++);
            integer = charToInt[c];
            value |= (integer & 31) << shift;
            shift += 5;
          } while (integer & 32);
          const shouldNegate = value & 1;
          value >>>= 1;
          if (shouldNegate) {
            value = -2147483648 | -value;
          }
          state[j] += value;
          return pos;
        }
        function hasMoreVlq(mappings, i, length) {
          if (i >= length)
            return false;
          return mappings.charCodeAt(i) !== comma;
        }
        function sort(line) {
          line.sort(sortComparator);
        }
        function sortComparator(a, b) {
          return a[0] - b[0];
        }
        function encode(decoded) {
          const state = new Int32Array(5);
          const bufLength = 1024 * 16;
          const subLength = bufLength - 36;
          const buf = new Uint8Array(bufLength);
          const sub = buf.subarray(0, subLength);
          let pos = 0;
          let out = "";
          for (let i = 0; i < decoded.length; i++) {
            const line = decoded[i];
            if (i > 0) {
              if (pos === bufLength) {
                out += td.decode(buf);
                pos = 0;
              }
              buf[pos++] = semicolon;
            }
            if (line.length === 0)
              continue;
            state[0] = 0;
            for (let j = 0; j < line.length; j++) {
              const segment = line[j];
              if (pos > subLength) {
                out += td.decode(sub);
                buf.copyWithin(0, subLength, pos);
                pos -= subLength;
              }
              if (j > 0)
                buf[pos++] = comma;
              pos = encodeInteger(buf, pos, state, segment, 0);
              if (segment.length === 1)
                continue;
              pos = encodeInteger(buf, pos, state, segment, 1);
              pos = encodeInteger(buf, pos, state, segment, 2);
              pos = encodeInteger(buf, pos, state, segment, 3);
              if (segment.length === 4)
                continue;
              pos = encodeInteger(buf, pos, state, segment, 4);
            }
          }
          return out + td.decode(buf.subarray(0, pos));
        }
        function encodeInteger(buf, pos, state, segment, j) {
          const next = segment[j];
          let num = next - state[j];
          state[j] = next;
          num = num < 0 ? -num << 1 | 1 : num << 1;
          do {
            let clamped = num & 31;
            num >>>= 5;
            if (num > 0)
              clamped |= 32;
            buf[pos++] = intToChar[clamped];
          } while (num > 0);
          return pos;
        }
        exports3.decode = decode;
        exports3.encode = encode;
        Object.defineProperty(exports3, "__esModule", { value: true });
      });
    }
  });

  // node_modules/@jridgewell/resolve-uri/dist/resolve-uri.umd.js
  var require_resolve_uri_umd = __commonJS({
    "node_modules/@jridgewell/resolve-uri/dist/resolve-uri.umd.js"(exports2, module2) {
      init_define_process();
      (function(global2, factory2) {
        typeof exports2 === "object" && typeof module2 !== "undefined" ? module2.exports = factory2() : typeof define === "function" && define.amd ? define(factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, global2.resolveURI = factory2());
      })(exports2, function() {
        "use strict";
        const schemeRegex = /^[\w+.-]+:\/\//;
        const urlRegex = /^([\w+.-]+:)\/\/([^@/#?]*@)?([^:/#?]*)(:\d+)?(\/[^#?]*)?(\?[^#]*)?(#.*)?/;
        const fileRegex = /^file:(?:\/\/((?![a-z]:)[^/#?]*)?)?(\/?[^#?]*)(\?[^#]*)?(#.*)?/i;
        var UrlType;
        (function(UrlType2) {
          UrlType2[UrlType2["Empty"] = 1] = "Empty";
          UrlType2[UrlType2["Hash"] = 2] = "Hash";
          UrlType2[UrlType2["Query"] = 3] = "Query";
          UrlType2[UrlType2["RelativePath"] = 4] = "RelativePath";
          UrlType2[UrlType2["AbsolutePath"] = 5] = "AbsolutePath";
          UrlType2[UrlType2["SchemeRelative"] = 6] = "SchemeRelative";
          UrlType2[UrlType2["Absolute"] = 7] = "Absolute";
        })(UrlType || (UrlType = {}));
        function isAbsoluteUrl(input) {
          return schemeRegex.test(input);
        }
        function isSchemeRelativeUrl(input) {
          return input.startsWith("//");
        }
        function isAbsolutePath(input) {
          return input.startsWith("/");
        }
        function isFileUrl(input) {
          return input.startsWith("file:");
        }
        function isRelative(input) {
          return /^[.?#]/.test(input);
        }
        function parseAbsoluteUrl(input) {
          const match = urlRegex.exec(input);
          return makeUrl(match[1], match[2] || "", match[3], match[4] || "", match[5] || "/", match[6] || "", match[7] || "");
        }
        function parseFileUrl(input) {
          const match = fileRegex.exec(input);
          const path = match[2];
          return makeUrl("file:", "", match[1] || "", "", isAbsolutePath(path) ? path : "/" + path, match[3] || "", match[4] || "");
        }
        function makeUrl(scheme, user, host, port, path, query, hash) {
          return {
            scheme,
            user,
            host,
            port,
            path,
            query,
            hash,
            type: UrlType.Absolute
          };
        }
        function parseUrl(input) {
          if (isSchemeRelativeUrl(input)) {
            const url2 = parseAbsoluteUrl("http:" + input);
            url2.scheme = "";
            url2.type = UrlType.SchemeRelative;
            return url2;
          }
          if (isAbsolutePath(input)) {
            const url2 = parseAbsoluteUrl("http://foo.com" + input);
            url2.scheme = "";
            url2.host = "";
            url2.type = UrlType.AbsolutePath;
            return url2;
          }
          if (isFileUrl(input))
            return parseFileUrl(input);
          if (isAbsoluteUrl(input))
            return parseAbsoluteUrl(input);
          const url = parseAbsoluteUrl("http://foo.com/" + input);
          url.scheme = "";
          url.host = "";
          url.type = input ? input.startsWith("?") ? UrlType.Query : input.startsWith("#") ? UrlType.Hash : UrlType.RelativePath : UrlType.Empty;
          return url;
        }
        function stripPathFilename(path) {
          if (path.endsWith("/.."))
            return path;
          const index = path.lastIndexOf("/");
          return path.slice(0, index + 1);
        }
        function mergePaths(url, base) {
          normalizePath(base, base.type);
          if (url.path === "/") {
            url.path = base.path;
          } else {
            url.path = stripPathFilename(base.path) + url.path;
          }
        }
        function normalizePath(url, type) {
          const rel = type <= UrlType.RelativePath;
          const pieces = url.path.split("/");
          let pointer = 1;
          let positive = 0;
          let addTrailingSlash = false;
          for (let i = 1; i < pieces.length; i++) {
            const piece = pieces[i];
            if (!piece) {
              addTrailingSlash = true;
              continue;
            }
            addTrailingSlash = false;
            if (piece === ".")
              continue;
            if (piece === "..") {
              if (positive) {
                addTrailingSlash = true;
                positive--;
                pointer--;
              } else if (rel) {
                pieces[pointer++] = piece;
              }
              continue;
            }
            pieces[pointer++] = piece;
            positive++;
          }
          let path = "";
          for (let i = 1; i < pointer; i++) {
            path += "/" + pieces[i];
          }
          if (!path || addTrailingSlash && !path.endsWith("/..")) {
            path += "/";
          }
          url.path = path;
        }
        function resolve(input, base) {
          if (!input && !base)
            return "";
          const url = parseUrl(input);
          let inputType = url.type;
          if (base && inputType !== UrlType.Absolute) {
            const baseUrl = parseUrl(base);
            const baseType = baseUrl.type;
            switch (inputType) {
              case UrlType.Empty:
                url.hash = baseUrl.hash;
              case UrlType.Hash:
                url.query = baseUrl.query;
              case UrlType.Query:
              case UrlType.RelativePath:
                mergePaths(url, baseUrl);
              case UrlType.AbsolutePath:
                url.user = baseUrl.user;
                url.host = baseUrl.host;
                url.port = baseUrl.port;
              case UrlType.SchemeRelative:
                url.scheme = baseUrl.scheme;
            }
            if (baseType > inputType)
              inputType = baseType;
          }
          normalizePath(url, inputType);
          const queryHash = url.query + url.hash;
          switch (inputType) {
            case UrlType.Hash:
            case UrlType.Query:
              return queryHash;
            case UrlType.RelativePath: {
              const path = url.path.slice(1);
              if (!path)
                return queryHash || ".";
              if (isRelative(base || input) && !isRelative(path)) {
                return "./" + path + queryHash;
              }
              return path + queryHash;
            }
            case UrlType.AbsolutePath:
              return url.path + queryHash;
            default:
              return url.scheme + "//" + url.user + url.host + url.port + url.path + queryHash;
          }
        }
        return resolve;
      });
    }
  });

  // node_modules/@jridgewell/trace-mapping/dist/trace-mapping.umd.js
  var require_trace_mapping_umd = __commonJS({
    "node_modules/@jridgewell/trace-mapping/dist/trace-mapping.umd.js"(exports2, module2) {
      init_define_process();
      (function(global2, factory2) {
        typeof exports2 === "object" && typeof module2 !== "undefined" ? factory2(exports2, require_sourcemap_codec_umd(), require_resolve_uri_umd()) : typeof define === "function" && define.amd ? define(["exports", "@jridgewell/sourcemap-codec", "@jridgewell/resolve-uri"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(global2.traceMapping = {}, global2.sourcemapCodec, global2.resolveURI));
      })(exports2, function(exports3, sourcemapCodec, resolveUri) {
        "use strict";
        function _interopDefaultLegacy(e) {
          return e && typeof e === "object" && "default" in e ? e : { "default": e };
        }
        var resolveUri__default = /* @__PURE__ */ _interopDefaultLegacy(resolveUri);
        function resolve(input, base) {
          if (base && !base.endsWith("/"))
            base += "/";
          return resolveUri__default["default"](input, base);
        }
        function stripFilename(path) {
          if (!path)
            return "";
          const index = path.lastIndexOf("/");
          return path.slice(0, index + 1);
        }
        const COLUMN = 0;
        const SOURCES_INDEX = 1;
        const SOURCE_LINE = 2;
        const SOURCE_COLUMN = 3;
        const NAMES_INDEX = 4;
        const REV_GENERATED_LINE = 1;
        const REV_GENERATED_COLUMN = 2;
        function maybeSort(mappings, owned) {
          const unsortedIndex = nextUnsortedSegmentLine(mappings, 0);
          if (unsortedIndex === mappings.length)
            return mappings;
          if (!owned)
            mappings = mappings.slice();
          for (let i = unsortedIndex; i < mappings.length; i = nextUnsortedSegmentLine(mappings, i + 1)) {
            mappings[i] = sortSegments(mappings[i], owned);
          }
          return mappings;
        }
        function nextUnsortedSegmentLine(mappings, start) {
          for (let i = start; i < mappings.length; i++) {
            if (!isSorted(mappings[i]))
              return i;
          }
          return mappings.length;
        }
        function isSorted(line) {
          for (let j = 1; j < line.length; j++) {
            if (line[j][COLUMN] < line[j - 1][COLUMN]) {
              return false;
            }
          }
          return true;
        }
        function sortSegments(line, owned) {
          if (!owned)
            line = line.slice();
          return line.sort(sortComparator);
        }
        function sortComparator(a, b) {
          return a[COLUMN] - b[COLUMN];
        }
        let found = false;
        function binarySearch(haystack, needle, low, high) {
          while (low <= high) {
            const mid = low + (high - low >> 1);
            const cmp = haystack[mid][COLUMN] - needle;
            if (cmp === 0) {
              found = true;
              return mid;
            }
            if (cmp < 0) {
              low = mid + 1;
            } else {
              high = mid - 1;
            }
          }
          found = false;
          return low - 1;
        }
        function upperBound(haystack, needle, index) {
          for (let i = index + 1; i < haystack.length; index = i++) {
            if (haystack[i][COLUMN] !== needle)
              break;
          }
          return index;
        }
        function lowerBound(haystack, needle, index) {
          for (let i = index - 1; i >= 0; index = i--) {
            if (haystack[i][COLUMN] !== needle)
              break;
          }
          return index;
        }
        function memoizedState() {
          return {
            lastKey: -1,
            lastNeedle: -1,
            lastIndex: -1
          };
        }
        function memoizedBinarySearch(haystack, needle, state, key) {
          const { lastKey, lastNeedle, lastIndex } = state;
          let low = 0;
          let high = haystack.length - 1;
          if (key === lastKey) {
            if (needle === lastNeedle) {
              found = lastIndex !== -1 && haystack[lastIndex][COLUMN] === needle;
              return lastIndex;
            }
            if (needle >= lastNeedle) {
              low = lastIndex === -1 ? 0 : lastIndex;
            } else {
              high = lastIndex;
            }
          }
          state.lastKey = key;
          state.lastNeedle = needle;
          return state.lastIndex = binarySearch(haystack, needle, low, high);
        }
        function buildBySources(decoded, memos) {
          const sources = memos.map(buildNullArray);
          for (let i = 0; i < decoded.length; i++) {
            const line = decoded[i];
            for (let j = 0; j < line.length; j++) {
              const seg = line[j];
              if (seg.length === 1)
                continue;
              const sourceIndex = seg[SOURCES_INDEX];
              const sourceLine = seg[SOURCE_LINE];
              const sourceColumn = seg[SOURCE_COLUMN];
              const originalSource = sources[sourceIndex];
              const originalLine = originalSource[sourceLine] || (originalSource[sourceLine] = []);
              const memo = memos[sourceIndex];
              const index = upperBound(originalLine, sourceColumn, memoizedBinarySearch(originalLine, sourceColumn, memo, sourceLine));
              insert(originalLine, memo.lastIndex = index + 1, [sourceColumn, i, seg[COLUMN]]);
            }
          }
          return sources;
        }
        function insert(array, index, value) {
          for (let i = array.length; i > index; i--) {
            array[i] = array[i - 1];
          }
          array[index] = value;
        }
        function buildNullArray() {
          return { __proto__: null };
        }
        const AnyMap = function(map2, mapUrl) {
          const parsed = typeof map2 === "string" ? JSON.parse(map2) : map2;
          if (!("sections" in parsed))
            return new TraceMap(parsed, mapUrl);
          const mappings = [];
          const sources = [];
          const sourcesContent = [];
          const names = [];
          recurse(parsed, mapUrl, mappings, sources, sourcesContent, names, 0, 0, Infinity, Infinity);
          const joined = {
            version: 3,
            file: parsed.file,
            names,
            sources,
            sourcesContent,
            mappings
          };
          return exports3.presortedDecodedMap(joined);
        };
        function recurse(input, mapUrl, mappings, sources, sourcesContent, names, lineOffset, columnOffset, stopLine, stopColumn) {
          const { sections } = input;
          for (let i = 0; i < sections.length; i++) {
            const { map: map2, offset } = sections[i];
            let sl = stopLine;
            let sc = stopColumn;
            if (i + 1 < sections.length) {
              const nextOffset = sections[i + 1].offset;
              sl = Math.min(stopLine, lineOffset + nextOffset.line);
              if (sl === stopLine) {
                sc = Math.min(stopColumn, columnOffset + nextOffset.column);
              } else if (sl < stopLine) {
                sc = columnOffset + nextOffset.column;
              }
            }
            addSection(map2, mapUrl, mappings, sources, sourcesContent, names, lineOffset + offset.line, columnOffset + offset.column, sl, sc);
          }
        }
        function addSection(input, mapUrl, mappings, sources, sourcesContent, names, lineOffset, columnOffset, stopLine, stopColumn) {
          if ("sections" in input)
            return recurse(...arguments);
          const map2 = new TraceMap(input, mapUrl);
          const sourcesOffset = sources.length;
          const namesOffset = names.length;
          const decoded = exports3.decodedMappings(map2);
          const { resolvedSources, sourcesContent: contents } = map2;
          append(sources, resolvedSources);
          append(names, map2.names);
          if (contents)
            append(sourcesContent, contents);
          else
            for (let i = 0; i < resolvedSources.length; i++)
              sourcesContent.push(null);
          for (let i = 0; i < decoded.length; i++) {
            const lineI = lineOffset + i;
            if (lineI > stopLine)
              return;
            const out = getLine(mappings, lineI);
            const cOffset = i === 0 ? columnOffset : 0;
            const line = decoded[i];
            for (let j = 0; j < line.length; j++) {
              const seg = line[j];
              const column = cOffset + seg[COLUMN];
              if (lineI === stopLine && column >= stopColumn)
                return;
              if (seg.length === 1) {
                out.push([column]);
                continue;
              }
              const sourcesIndex = sourcesOffset + seg[SOURCES_INDEX];
              const sourceLine = seg[SOURCE_LINE];
              const sourceColumn = seg[SOURCE_COLUMN];
              out.push(seg.length === 4 ? [column, sourcesIndex, sourceLine, sourceColumn] : [column, sourcesIndex, sourceLine, sourceColumn, namesOffset + seg[NAMES_INDEX]]);
            }
          }
        }
        function append(arr, other) {
          for (let i = 0; i < other.length; i++)
            arr.push(other[i]);
        }
        function getLine(arr, index) {
          for (let i = arr.length; i <= index; i++)
            arr[i] = [];
          return arr[index];
        }
        const LINE_GTR_ZERO = "`line` must be greater than 0 (lines start at line 1)";
        const COL_GTR_EQ_ZERO = "`column` must be greater than or equal to 0 (columns start at column 0)";
        const LEAST_UPPER_BOUND = -1;
        const GREATEST_LOWER_BOUND = 1;
        exports3.encodedMappings = void 0;
        exports3.decodedMappings = void 0;
        exports3.traceSegment = void 0;
        exports3.originalPositionFor = void 0;
        exports3.generatedPositionFor = void 0;
        exports3.allGeneratedPositionsFor = void 0;
        exports3.eachMapping = void 0;
        exports3.sourceContentFor = void 0;
        exports3.presortedDecodedMap = void 0;
        exports3.decodedMap = void 0;
        exports3.encodedMap = void 0;
        class TraceMap {
          constructor(map2, mapUrl) {
            const isString2 = typeof map2 === "string";
            if (!isString2 && map2._decodedMemo)
              return map2;
            const parsed = isString2 ? JSON.parse(map2) : map2;
            const { version, file: file2, names, sourceRoot, sources, sourcesContent } = parsed;
            this.version = version;
            this.file = file2;
            this.names = names;
            this.sourceRoot = sourceRoot;
            this.sources = sources;
            this.sourcesContent = sourcesContent;
            const from = resolve(sourceRoot || "", stripFilename(mapUrl));
            this.resolvedSources = sources.map((s) => resolve(s || "", from));
            const { mappings } = parsed;
            if (typeof mappings === "string") {
              this._encoded = mappings;
              this._decoded = void 0;
            } else {
              this._encoded = void 0;
              this._decoded = maybeSort(mappings, isString2);
            }
            this._decodedMemo = memoizedState();
            this._bySources = void 0;
            this._bySourceMemos = void 0;
          }
        }
        (() => {
          exports3.encodedMappings = (map2) => {
            var _a;
            return (_a = map2._encoded) !== null && _a !== void 0 ? _a : map2._encoded = sourcemapCodec.encode(map2._decoded);
          };
          exports3.decodedMappings = (map2) => {
            return map2._decoded || (map2._decoded = sourcemapCodec.decode(map2._encoded));
          };
          exports3.traceSegment = (map2, line, column) => {
            const decoded = exports3.decodedMappings(map2);
            if (line >= decoded.length)
              return null;
            const segments = decoded[line];
            const index = traceSegmentInternal(segments, map2._decodedMemo, line, column, GREATEST_LOWER_BOUND);
            return index === -1 ? null : segments[index];
          };
          exports3.originalPositionFor = (map2, { line, column, bias }) => {
            line--;
            if (line < 0)
              throw new Error(LINE_GTR_ZERO);
            if (column < 0)
              throw new Error(COL_GTR_EQ_ZERO);
            const decoded = exports3.decodedMappings(map2);
            if (line >= decoded.length)
              return OMapping(null, null, null, null);
            const segments = decoded[line];
            const index = traceSegmentInternal(segments, map2._decodedMemo, line, column, bias || GREATEST_LOWER_BOUND);
            if (index === -1)
              return OMapping(null, null, null, null);
            const segment = segments[index];
            if (segment.length === 1)
              return OMapping(null, null, null, null);
            const { names, resolvedSources } = map2;
            return OMapping(resolvedSources[segment[SOURCES_INDEX]], segment[SOURCE_LINE] + 1, segment[SOURCE_COLUMN], segment.length === 5 ? names[segment[NAMES_INDEX]] : null);
          };
          exports3.allGeneratedPositionsFor = (map2, { source, line, column, bias }) => {
            return generatedPosition(map2, source, line, column, bias || LEAST_UPPER_BOUND, true);
          };
          exports3.generatedPositionFor = (map2, { source, line, column, bias }) => {
            return generatedPosition(map2, source, line, column, bias || GREATEST_LOWER_BOUND, false);
          };
          exports3.eachMapping = (map2, cb) => {
            const decoded = exports3.decodedMappings(map2);
            const { names, resolvedSources } = map2;
            for (let i = 0; i < decoded.length; i++) {
              const line = decoded[i];
              for (let j = 0; j < line.length; j++) {
                const seg = line[j];
                const generatedLine = i + 1;
                const generatedColumn = seg[0];
                let source = null;
                let originalLine = null;
                let originalColumn = null;
                let name = null;
                if (seg.length !== 1) {
                  source = resolvedSources[seg[1]];
                  originalLine = seg[2] + 1;
                  originalColumn = seg[3];
                }
                if (seg.length === 5)
                  name = names[seg[4]];
                cb({
                  generatedLine,
                  generatedColumn,
                  source,
                  originalLine,
                  originalColumn,
                  name
                });
              }
            }
          };
          exports3.sourceContentFor = (map2, source) => {
            const { sources, resolvedSources, sourcesContent } = map2;
            if (sourcesContent == null)
              return null;
            let index = sources.indexOf(source);
            if (index === -1)
              index = resolvedSources.indexOf(source);
            return index === -1 ? null : sourcesContent[index];
          };
          exports3.presortedDecodedMap = (map2, mapUrl) => {
            const tracer = new TraceMap(clone2(map2, []), mapUrl);
            tracer._decoded = map2.mappings;
            return tracer;
          };
          exports3.decodedMap = (map2) => {
            return clone2(map2, exports3.decodedMappings(map2));
          };
          exports3.encodedMap = (map2) => {
            return clone2(map2, exports3.encodedMappings(map2));
          };
          function generatedPosition(map2, source, line, column, bias, all) {
            line--;
            if (line < 0)
              throw new Error(LINE_GTR_ZERO);
            if (column < 0)
              throw new Error(COL_GTR_EQ_ZERO);
            const { sources, resolvedSources } = map2;
            let sourceIndex = sources.indexOf(source);
            if (sourceIndex === -1)
              sourceIndex = resolvedSources.indexOf(source);
            if (sourceIndex === -1)
              return all ? [] : GMapping(null, null);
            const generated = map2._bySources || (map2._bySources = buildBySources(exports3.decodedMappings(map2), map2._bySourceMemos = sources.map(memoizedState)));
            const segments = generated[sourceIndex][line];
            if (segments == null)
              return all ? [] : GMapping(null, null);
            const memo = map2._bySourceMemos[sourceIndex];
            if (all)
              return sliceGeneratedPositions(segments, memo, line, column, bias);
            const index = traceSegmentInternal(segments, memo, line, column, bias);
            if (index === -1)
              return GMapping(null, null);
            const segment = segments[index];
            return GMapping(segment[REV_GENERATED_LINE] + 1, segment[REV_GENERATED_COLUMN]);
          }
        })();
        function clone2(map2, mappings) {
          return {
            version: map2.version,
            file: map2.file,
            names: map2.names,
            sourceRoot: map2.sourceRoot,
            sources: map2.sources,
            sourcesContent: map2.sourcesContent,
            mappings
          };
        }
        function OMapping(source, line, column, name) {
          return { source, line, column, name };
        }
        function GMapping(line, column) {
          return { line, column };
        }
        function traceSegmentInternal(segments, memo, line, column, bias) {
          let index = memoizedBinarySearch(segments, column, memo, line);
          if (found) {
            index = (bias === LEAST_UPPER_BOUND ? upperBound : lowerBound)(segments, column, index);
          } else if (bias === LEAST_UPPER_BOUND)
            index++;
          if (index === -1 || index === segments.length)
            return -1;
          return index;
        }
        function sliceGeneratedPositions(segments, memo, line, column, bias) {
          let min2 = traceSegmentInternal(segments, memo, line, column, GREATEST_LOWER_BOUND);
          if (!found && bias === LEAST_UPPER_BOUND)
            min2++;
          if (min2 === -1 || min2 === segments.length)
            return [];
          const matchedColumn = found ? column : segments[min2][COLUMN];
          if (!found)
            min2 = lowerBound(segments, matchedColumn, min2);
          const max2 = upperBound(segments, matchedColumn, min2);
          const result2 = [];
          for (; min2 <= max2; min2++) {
            const segment = segments[min2];
            result2.push(GMapping(segment[REV_GENERATED_LINE] + 1, segment[REV_GENERATED_COLUMN]));
          }
          return result2;
        }
        exports3.AnyMap = AnyMap;
        exports3.GREATEST_LOWER_BOUND = GREATEST_LOWER_BOUND;
        exports3.LEAST_UPPER_BOUND = LEAST_UPPER_BOUND;
        exports3.TraceMap = TraceMap;
        Object.defineProperty(exports3, "__esModule", { value: true });
      });
    }
  });

  // node_modules/@jridgewell/gen-mapping/dist/gen-mapping.umd.js
  var require_gen_mapping_umd = __commonJS({
    "node_modules/@jridgewell/gen-mapping/dist/gen-mapping.umd.js"(exports2, module2) {
      init_define_process();
      (function(global2, factory2) {
        typeof exports2 === "object" && typeof module2 !== "undefined" ? factory2(exports2, require_set_array_umd(), require_sourcemap_codec_umd(), require_trace_mapping_umd()) : typeof define === "function" && define.amd ? define(["exports", "@jridgewell/set-array", "@jridgewell/sourcemap-codec", "@jridgewell/trace-mapping"], factory2) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, factory2(global2.genMapping = {}, global2.setArray, global2.sourcemapCodec, global2.traceMapping));
      })(exports2, function(exports3, setArray, sourcemapCodec, traceMapping) {
        "use strict";
        const COLUMN = 0;
        const SOURCES_INDEX = 1;
        const SOURCE_LINE = 2;
        const SOURCE_COLUMN = 3;
        const NAMES_INDEX = 4;
        const NO_NAME = -1;
        exports3.addSegment = void 0;
        exports3.addMapping = void 0;
        exports3.maybeAddSegment = void 0;
        exports3.maybeAddMapping = void 0;
        exports3.setSourceContent = void 0;
        exports3.toDecodedMap = void 0;
        exports3.toEncodedMap = void 0;
        exports3.fromMap = void 0;
        exports3.allMappings = void 0;
        let addSegmentInternal;
        class GenMapping {
          constructor({ file: file2, sourceRoot } = {}) {
            this._names = new setArray.SetArray();
            this._sources = new setArray.SetArray();
            this._sourcesContent = [];
            this._mappings = [];
            this.file = file2;
            this.sourceRoot = sourceRoot;
          }
        }
        (() => {
          exports3.addSegment = (map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content) => {
            return addSegmentInternal(false, map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
          };
          exports3.maybeAddSegment = (map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content) => {
            return addSegmentInternal(true, map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
          };
          exports3.addMapping = (map2, mapping) => {
            return addMappingInternal(false, map2, mapping);
          };
          exports3.maybeAddMapping = (map2, mapping) => {
            return addMappingInternal(true, map2, mapping);
          };
          exports3.setSourceContent = (map2, source, content) => {
            const { _sources: sources, _sourcesContent: sourcesContent } = map2;
            sourcesContent[setArray.put(sources, source)] = content;
          };
          exports3.toDecodedMap = (map2) => {
            const { file: file2, sourceRoot, _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names } = map2;
            removeEmptyFinalLines(mappings);
            return {
              version: 3,
              file: file2 || void 0,
              names: names.array,
              sourceRoot: sourceRoot || void 0,
              sources: sources.array,
              sourcesContent,
              mappings
            };
          };
          exports3.toEncodedMap = (map2) => {
            const decoded = exports3.toDecodedMap(map2);
            return Object.assign(Object.assign({}, decoded), { mappings: sourcemapCodec.encode(decoded.mappings) });
          };
          exports3.allMappings = (map2) => {
            const out = [];
            const { _mappings: mappings, _sources: sources, _names: names } = map2;
            for (let i = 0; i < mappings.length; i++) {
              const line = mappings[i];
              for (let j = 0; j < line.length; j++) {
                const seg = line[j];
                const generated = { line: i + 1, column: seg[COLUMN] };
                let source = void 0;
                let original = void 0;
                let name = void 0;
                if (seg.length !== 1) {
                  source = sources.array[seg[SOURCES_INDEX]];
                  original = { line: seg[SOURCE_LINE] + 1, column: seg[SOURCE_COLUMN] };
                  if (seg.length === 5)
                    name = names.array[seg[NAMES_INDEX]];
                }
                out.push({ generated, source, original, name });
              }
            }
            return out;
          };
          exports3.fromMap = (input) => {
            const map2 = new traceMapping.TraceMap(input);
            const gen = new GenMapping({ file: map2.file, sourceRoot: map2.sourceRoot });
            putAll(gen._names, map2.names);
            putAll(gen._sources, map2.sources);
            gen._sourcesContent = map2.sourcesContent || map2.sources.map(() => null);
            gen._mappings = traceMapping.decodedMappings(map2);
            return gen;
          };
          addSegmentInternal = (skipable, map2, genLine, genColumn, source, sourceLine, sourceColumn, name, content) => {
            const { _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names } = map2;
            const line = getLine(mappings, genLine);
            const index = getColumnIndex(line, genColumn);
            if (!source) {
              if (skipable && skipSourceless(line, index))
                return;
              return insert(line, index, [genColumn]);
            }
            const sourcesIndex = setArray.put(sources, source);
            const namesIndex = name ? setArray.put(names, name) : NO_NAME;
            if (sourcesIndex === sourcesContent.length)
              sourcesContent[sourcesIndex] = content !== null && content !== void 0 ? content : null;
            if (skipable && skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex)) {
              return;
            }
            return insert(line, index, name ? [genColumn, sourcesIndex, sourceLine, sourceColumn, namesIndex] : [genColumn, sourcesIndex, sourceLine, sourceColumn]);
          };
        })();
        function getLine(mappings, index) {
          for (let i = mappings.length; i <= index; i++) {
            mappings[i] = [];
          }
          return mappings[index];
        }
        function getColumnIndex(line, genColumn) {
          let index = line.length;
          for (let i = index - 1; i >= 0; index = i--) {
            const current = line[i];
            if (genColumn >= current[COLUMN])
              break;
          }
          return index;
        }
        function insert(array, index, value) {
          for (let i = array.length; i > index; i--) {
            array[i] = array[i - 1];
          }
          array[index] = value;
        }
        function removeEmptyFinalLines(mappings) {
          const { length } = mappings;
          let len = length;
          for (let i = len - 1; i >= 0; len = i, i--) {
            if (mappings[i].length > 0)
              break;
          }
          if (len < length)
            mappings.length = len;
        }
        function putAll(strarr, array) {
          for (let i = 0; i < array.length; i++)
            setArray.put(strarr, array[i]);
        }
        function skipSourceless(line, index) {
          if (index === 0)
            return true;
          const prev = line[index - 1];
          return prev.length === 1;
        }
        function skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex) {
          if (index === 0)
            return false;
          const prev = line[index - 1];
          if (prev.length === 1)
            return false;
          return sourcesIndex === prev[SOURCES_INDEX] && sourceLine === prev[SOURCE_LINE] && sourceColumn === prev[SOURCE_COLUMN] && namesIndex === (prev.length === 5 ? prev[NAMES_INDEX] : NO_NAME);
        }
        function addMappingInternal(skipable, map2, mapping) {
          const { generated, source, original, name, content } = mapping;
          if (!source) {
            return addSegmentInternal(skipable, map2, generated.line - 1, generated.column, null, null, null, null, null);
          }
          const s = source;
          return addSegmentInternal(skipable, map2, generated.line - 1, generated.column, s, original.line - 1, original.column, name, content);
        }
        exports3.GenMapping = GenMapping;
        Object.defineProperty(exports3, "__esModule", { value: true });
      });
    }
  });

  // node_modules/@babel/generator/lib/source-map.js
  var require_source_map2 = __commonJS({
    "node_modules/@babel/generator/lib/source-map.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _genMapping = require_gen_mapping_umd();
      var SourceMap = class {
        constructor(opts, code) {
          var _opts$sourceFileName;
          this._map = void 0;
          this._rawMappings = void 0;
          this._sourceFileName = void 0;
          this._lastGenLine = 0;
          this._lastSourceLine = 0;
          this._lastSourceColumn = 0;
          const map2 = this._map = new _genMapping.GenMapping({
            sourceRoot: opts.sourceRoot
          });
          this._sourceFileName = (_opts$sourceFileName = opts.sourceFileName) == null ? void 0 : _opts$sourceFileName.replace(/\\/g, "/");
          this._rawMappings = void 0;
          if (typeof code === "string") {
            (0, _genMapping.setSourceContent)(map2, this._sourceFileName, code);
          } else if (typeof code === "object") {
            Object.keys(code).forEach((sourceFileName) => {
              (0, _genMapping.setSourceContent)(map2, sourceFileName.replace(/\\/g, "/"), code[sourceFileName]);
            });
          }
        }
        get() {
          return (0, _genMapping.toEncodedMap)(this._map);
        }
        getDecoded() {
          return (0, _genMapping.toDecodedMap)(this._map);
        }
        getRawMappings() {
          return this._rawMappings || (this._rawMappings = (0, _genMapping.allMappings)(this._map));
        }
        mark(generated, line, column, identifierName, filename) {
          this._rawMappings = void 0;
          (0, _genMapping.maybeAddMapping)(this._map, {
            name: identifierName,
            generated,
            source: line == null ? void 0 : (filename == null ? void 0 : filename.replace(/\\/g, "/")) || this._sourceFileName,
            original: line == null ? void 0 : {
              line,
              column
            }
          });
        }
      };
      exports2.default = SourceMap;
    }
  });

  // node_modules/@babel/generator/lib/buffer.js
  var require_buffer2 = __commonJS({
    "node_modules/@babel/generator/lib/buffer.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var Buffer5 = class {
        constructor(map2) {
          this._map = null;
          this._buf = "";
          this._str = "";
          this._appendCount = 0;
          this._last = 0;
          this._queue = [];
          this._queueCursor = 0;
          this._position = {
            line: 1,
            column: 0
          };
          this._sourcePosition = {
            identifierName: void 0,
            line: void 0,
            column: void 0,
            filename: void 0
          };
          this._map = map2;
          this._allocQueue();
        }
        _allocQueue() {
          const queue = this._queue;
          for (let i = 0; i < 16; i++) {
            queue.push({
              char: 0,
              repeat: 1,
              line: void 0,
              column: void 0,
              identifierName: void 0,
              filename: ""
            });
          }
        }
        _pushQueue(char, repeat2, line, column, identifierName, filename) {
          const cursor = this._queueCursor;
          if (cursor === this._queue.length) {
            this._allocQueue();
          }
          const item = this._queue[cursor];
          item.char = char;
          item.repeat = repeat2;
          item.line = line;
          item.column = column;
          item.identifierName = identifierName;
          item.filename = filename;
          this._queueCursor++;
        }
        _popQueue() {
          if (this._queueCursor === 0) {
            throw new Error("Cannot pop from empty queue");
          }
          return this._queue[--this._queueCursor];
        }
        get() {
          this._flush();
          const map2 = this._map;
          const result2 = {
            code: (this._buf + this._str).trimRight(),
            decodedMap: map2 == null ? void 0 : map2.getDecoded(),
            get map() {
              const resultMap = map2 ? map2.get() : null;
              result2.map = resultMap;
              return resultMap;
            },
            set map(value) {
              Object.defineProperty(result2, "map", {
                value,
                writable: true
              });
            },
            get rawMappings() {
              const mappings = map2 == null ? void 0 : map2.getRawMappings();
              result2.rawMappings = mappings;
              return mappings;
            },
            set rawMappings(value) {
              Object.defineProperty(result2, "rawMappings", {
                value,
                writable: true
              });
            }
          };
          return result2;
        }
        append(str, maybeNewline) {
          this._flush();
          this._append(str, this._sourcePosition, maybeNewline);
        }
        appendChar(char) {
          this._flush();
          this._appendChar(char, 1, this._sourcePosition);
        }
        queue(char) {
          if (char === 10) {
            while (this._queueCursor !== 0) {
              const char2 = this._queue[this._queueCursor - 1].char;
              if (char2 !== 32 && char2 !== 9) {
                break;
              }
              this._queueCursor--;
            }
          }
          const sourcePosition = this._sourcePosition;
          this._pushQueue(char, 1, sourcePosition.line, sourcePosition.column, sourcePosition.identifierName, sourcePosition.filename);
        }
        queueIndentation(char, repeat2) {
          this._pushQueue(char, repeat2, void 0, void 0, void 0, void 0);
        }
        _flush() {
          const queueCursor = this._queueCursor;
          const queue = this._queue;
          for (let i = 0; i < queueCursor; i++) {
            const item = queue[i];
            this._appendChar(item.char, item.repeat, item);
          }
          this._queueCursor = 0;
        }
        _appendChar(char, repeat2, sourcePos) {
          this._last = char;
          this._str += repeat2 > 1 ? String.fromCharCode(char).repeat(repeat2) : String.fromCharCode(char);
          if (char !== 10) {
            this._mark(sourcePos.line, sourcePos.column, sourcePos.identifierName, sourcePos.filename);
            this._position.column += repeat2;
          } else {
            this._position.line++;
            this._position.column = 0;
          }
        }
        _append(str, sourcePos, maybeNewline) {
          const len = str.length;
          const position = this._position;
          this._last = str.charCodeAt(len - 1);
          if (++this._appendCount > 4096) {
            +this._str;
            this._buf += this._str;
            this._str = str;
            this._appendCount = 0;
          } else {
            this._str += str;
          }
          if (!maybeNewline && !this._map) {
            position.column += len;
            return;
          }
          const {
            column,
            identifierName,
            filename
          } = sourcePos;
          let line = sourcePos.line;
          let i = str.indexOf("\n");
          let last2 = 0;
          if (i !== 0) {
            this._mark(line, column, identifierName, filename);
          }
          while (i !== -1) {
            position.line++;
            position.column = 0;
            last2 = i + 1;
            if (last2 < len) {
              this._mark(++line, 0, identifierName, filename);
            }
            i = str.indexOf("\n", last2);
          }
          position.column += len - last2;
        }
        _mark(line, column, identifierName, filename) {
          var _this$_map;
          (_this$_map = this._map) == null ? void 0 : _this$_map.mark(this._position, line, column, identifierName, filename);
        }
        removeTrailingNewline() {
          const queueCursor = this._queueCursor;
          if (queueCursor !== 0 && this._queue[queueCursor - 1].char === 10) {
            this._queueCursor--;
          }
        }
        removeLastSemicolon() {
          const queueCursor = this._queueCursor;
          if (queueCursor !== 0 && this._queue[queueCursor - 1].char === 59) {
            this._queueCursor--;
          }
        }
        getLastChar() {
          const queueCursor = this._queueCursor;
          return queueCursor !== 0 ? this._queue[queueCursor - 1].char : this._last;
        }
        getNewlineCount() {
          const queueCursor = this._queueCursor;
          let count = 0;
          if (queueCursor === 0)
            return this._last === 10 ? 1 : 0;
          for (let i = queueCursor - 1; i >= 0; i--) {
            if (this._queue[i].char !== 10) {
              break;
            }
            count++;
          }
          return count === queueCursor && this._last === 10 ? count + 1 : count;
        }
        endsWithCharAndNewline() {
          const queue = this._queue;
          const queueCursor = this._queueCursor;
          if (queueCursor !== 0) {
            const lastCp = queue[queueCursor - 1].char;
            if (lastCp !== 10)
              return;
            if (queueCursor > 1) {
              return queue[queueCursor - 2].char;
            } else {
              return this._last;
            }
          }
        }
        hasContent() {
          return this._queueCursor !== 0 || !!this._last;
        }
        exactSource(loc, cb) {
          if (!this._map)
            return cb();
          this.source("start", loc);
          cb();
          this.source("end", loc);
        }
        source(prop, loc) {
          if (!this._map)
            return;
          this._normalizePosition(prop, loc, 0, 0);
        }
        sourceWithOffset(prop, loc, lineOffset, columnOffset) {
          if (!this._map)
            return;
          this._normalizePosition(prop, loc, lineOffset, columnOffset);
        }
        withSource(prop, loc, cb) {
          if (!this._map)
            return cb();
          this.source(prop, loc);
          cb();
        }
        _normalizePosition(prop, loc, lineOffset, columnOffset) {
          const pos = loc[prop];
          const target = this._sourcePosition;
          target.identifierName = prop === "start" && loc.identifierName || void 0;
          if (pos) {
            target.line = pos.line + lineOffset;
            target.column = pos.column + columnOffset;
            target.filename = loc.filename;
          }
        }
        getCurrentColumn() {
          const queue = this._queue;
          const queueCursor = this._queueCursor;
          let lastIndex = -1;
          let len = 0;
          for (let i = 0; i < queueCursor; i++) {
            const item = queue[i];
            if (item.char === 10) {
              lastIndex = len;
            }
            len += item.repeat;
          }
          return lastIndex === -1 ? this._position.column + len : len - 1 - lastIndex;
        }
        getCurrentLine() {
          let count = 0;
          const queue = this._queue;
          for (let i = 0; i < this._queueCursor; i++) {
            if (queue[i].char === 10) {
              count++;
            }
          }
          return this._position.line + count;
        }
      };
      exports2.default = Buffer5;
    }
  });

  // node_modules/@babel/types/lib/utils/shallowEqual.js
  var require_shallowEqual = __commonJS({
    "node_modules/@babel/types/lib/utils/shallowEqual.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = shallowEqual;
      function shallowEqual(actual, expected) {
        const keys2 = Object.keys(expected);
        for (const key of keys2) {
          if (actual[key] !== expected[key]) {
            return false;
          }
        }
        return true;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/generated/index.js
  var require_generated = __commonJS({
    "node_modules/@babel/types/lib/validators/generated/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.isAccessor = isAccessor;
      exports2.isAnyTypeAnnotation = isAnyTypeAnnotation;
      exports2.isArgumentPlaceholder = isArgumentPlaceholder;
      exports2.isArrayExpression = isArrayExpression;
      exports2.isArrayPattern = isArrayPattern;
      exports2.isArrayTypeAnnotation = isArrayTypeAnnotation;
      exports2.isArrowFunctionExpression = isArrowFunctionExpression;
      exports2.isAssignmentExpression = isAssignmentExpression;
      exports2.isAssignmentPattern = isAssignmentPattern;
      exports2.isAwaitExpression = isAwaitExpression;
      exports2.isBigIntLiteral = isBigIntLiteral;
      exports2.isBinary = isBinary;
      exports2.isBinaryExpression = isBinaryExpression;
      exports2.isBindExpression = isBindExpression;
      exports2.isBlock = isBlock;
      exports2.isBlockParent = isBlockParent;
      exports2.isBlockStatement = isBlockStatement;
      exports2.isBooleanLiteral = isBooleanLiteral;
      exports2.isBooleanLiteralTypeAnnotation = isBooleanLiteralTypeAnnotation;
      exports2.isBooleanTypeAnnotation = isBooleanTypeAnnotation;
      exports2.isBreakStatement = isBreakStatement;
      exports2.isCallExpression = isCallExpression;
      exports2.isCatchClause = isCatchClause;
      exports2.isClass = isClass;
      exports2.isClassAccessorProperty = isClassAccessorProperty;
      exports2.isClassBody = isClassBody;
      exports2.isClassDeclaration = isClassDeclaration;
      exports2.isClassExpression = isClassExpression;
      exports2.isClassImplements = isClassImplements;
      exports2.isClassMethod = isClassMethod;
      exports2.isClassPrivateMethod = isClassPrivateMethod;
      exports2.isClassPrivateProperty = isClassPrivateProperty;
      exports2.isClassProperty = isClassProperty;
      exports2.isCompletionStatement = isCompletionStatement;
      exports2.isConditional = isConditional;
      exports2.isConditionalExpression = isConditionalExpression;
      exports2.isContinueStatement = isContinueStatement;
      exports2.isDebuggerStatement = isDebuggerStatement;
      exports2.isDecimalLiteral = isDecimalLiteral;
      exports2.isDeclaration = isDeclaration;
      exports2.isDeclareClass = isDeclareClass;
      exports2.isDeclareExportAllDeclaration = isDeclareExportAllDeclaration;
      exports2.isDeclareExportDeclaration = isDeclareExportDeclaration;
      exports2.isDeclareFunction = isDeclareFunction;
      exports2.isDeclareInterface = isDeclareInterface;
      exports2.isDeclareModule = isDeclareModule;
      exports2.isDeclareModuleExports = isDeclareModuleExports;
      exports2.isDeclareOpaqueType = isDeclareOpaqueType;
      exports2.isDeclareTypeAlias = isDeclareTypeAlias;
      exports2.isDeclareVariable = isDeclareVariable;
      exports2.isDeclaredPredicate = isDeclaredPredicate;
      exports2.isDecorator = isDecorator;
      exports2.isDirective = isDirective;
      exports2.isDirectiveLiteral = isDirectiveLiteral;
      exports2.isDoExpression = isDoExpression;
      exports2.isDoWhileStatement = isDoWhileStatement;
      exports2.isEmptyStatement = isEmptyStatement;
      exports2.isEmptyTypeAnnotation = isEmptyTypeAnnotation;
      exports2.isEnumBody = isEnumBody;
      exports2.isEnumBooleanBody = isEnumBooleanBody;
      exports2.isEnumBooleanMember = isEnumBooleanMember;
      exports2.isEnumDeclaration = isEnumDeclaration;
      exports2.isEnumDefaultedMember = isEnumDefaultedMember;
      exports2.isEnumMember = isEnumMember;
      exports2.isEnumNumberBody = isEnumNumberBody;
      exports2.isEnumNumberMember = isEnumNumberMember;
      exports2.isEnumStringBody = isEnumStringBody;
      exports2.isEnumStringMember = isEnumStringMember;
      exports2.isEnumSymbolBody = isEnumSymbolBody;
      exports2.isExistsTypeAnnotation = isExistsTypeAnnotation;
      exports2.isExportAllDeclaration = isExportAllDeclaration;
      exports2.isExportDeclaration = isExportDeclaration;
      exports2.isExportDefaultDeclaration = isExportDefaultDeclaration;
      exports2.isExportDefaultSpecifier = isExportDefaultSpecifier;
      exports2.isExportNamedDeclaration = isExportNamedDeclaration;
      exports2.isExportNamespaceSpecifier = isExportNamespaceSpecifier;
      exports2.isExportSpecifier = isExportSpecifier;
      exports2.isExpression = isExpression;
      exports2.isExpressionStatement = isExpressionStatement;
      exports2.isExpressionWrapper = isExpressionWrapper;
      exports2.isFile = isFile;
      exports2.isFlow = isFlow;
      exports2.isFlowBaseAnnotation = isFlowBaseAnnotation;
      exports2.isFlowDeclaration = isFlowDeclaration;
      exports2.isFlowPredicate = isFlowPredicate;
      exports2.isFlowType = isFlowType;
      exports2.isFor = isFor;
      exports2.isForInStatement = isForInStatement;
      exports2.isForOfStatement = isForOfStatement;
      exports2.isForStatement = isForStatement;
      exports2.isForXStatement = isForXStatement;
      exports2.isFunction = isFunction2;
      exports2.isFunctionDeclaration = isFunctionDeclaration;
      exports2.isFunctionExpression = isFunctionExpression;
      exports2.isFunctionParent = isFunctionParent;
      exports2.isFunctionTypeAnnotation = isFunctionTypeAnnotation;
      exports2.isFunctionTypeParam = isFunctionTypeParam;
      exports2.isGenericTypeAnnotation = isGenericTypeAnnotation;
      exports2.isIdentifier = isIdentifier2;
      exports2.isIfStatement = isIfStatement;
      exports2.isImmutable = isImmutable;
      exports2.isImport = isImport;
      exports2.isImportAttribute = isImportAttribute;
      exports2.isImportDeclaration = isImportDeclaration;
      exports2.isImportDefaultSpecifier = isImportDefaultSpecifier;
      exports2.isImportNamespaceSpecifier = isImportNamespaceSpecifier;
      exports2.isImportSpecifier = isImportSpecifier;
      exports2.isIndexedAccessType = isIndexedAccessType;
      exports2.isInferredPredicate = isInferredPredicate;
      exports2.isInterfaceDeclaration = isInterfaceDeclaration;
      exports2.isInterfaceExtends = isInterfaceExtends;
      exports2.isInterfaceTypeAnnotation = isInterfaceTypeAnnotation;
      exports2.isInterpreterDirective = isInterpreterDirective;
      exports2.isIntersectionTypeAnnotation = isIntersectionTypeAnnotation;
      exports2.isJSX = isJSX;
      exports2.isJSXAttribute = isJSXAttribute;
      exports2.isJSXClosingElement = isJSXClosingElement;
      exports2.isJSXClosingFragment = isJSXClosingFragment;
      exports2.isJSXElement = isJSXElement;
      exports2.isJSXEmptyExpression = isJSXEmptyExpression;
      exports2.isJSXExpressionContainer = isJSXExpressionContainer;
      exports2.isJSXFragment = isJSXFragment;
      exports2.isJSXIdentifier = isJSXIdentifier;
      exports2.isJSXMemberExpression = isJSXMemberExpression;
      exports2.isJSXNamespacedName = isJSXNamespacedName;
      exports2.isJSXOpeningElement = isJSXOpeningElement;
      exports2.isJSXOpeningFragment = isJSXOpeningFragment;
      exports2.isJSXSpreadAttribute = isJSXSpreadAttribute;
      exports2.isJSXSpreadChild = isJSXSpreadChild;
      exports2.isJSXText = isJSXText;
      exports2.isLVal = isLVal;
      exports2.isLabeledStatement = isLabeledStatement;
      exports2.isLiteral = isLiteral;
      exports2.isLogicalExpression = isLogicalExpression;
      exports2.isLoop = isLoop;
      exports2.isMemberExpression = isMemberExpression;
      exports2.isMetaProperty = isMetaProperty;
      exports2.isMethod = isMethod;
      exports2.isMiscellaneous = isMiscellaneous;
      exports2.isMixedTypeAnnotation = isMixedTypeAnnotation;
      exports2.isModuleDeclaration = isModuleDeclaration;
      exports2.isModuleExpression = isModuleExpression;
      exports2.isModuleSpecifier = isModuleSpecifier;
      exports2.isNewExpression = isNewExpression;
      exports2.isNoop = isNoop;
      exports2.isNullLiteral = isNullLiteral;
      exports2.isNullLiteralTypeAnnotation = isNullLiteralTypeAnnotation;
      exports2.isNullableTypeAnnotation = isNullableTypeAnnotation;
      exports2.isNumberLiteral = isNumberLiteral;
      exports2.isNumberLiteralTypeAnnotation = isNumberLiteralTypeAnnotation;
      exports2.isNumberTypeAnnotation = isNumberTypeAnnotation;
      exports2.isNumericLiteral = isNumericLiteral;
      exports2.isObjectExpression = isObjectExpression;
      exports2.isObjectMember = isObjectMember;
      exports2.isObjectMethod = isObjectMethod;
      exports2.isObjectPattern = isObjectPattern;
      exports2.isObjectProperty = isObjectProperty;
      exports2.isObjectTypeAnnotation = isObjectTypeAnnotation;
      exports2.isObjectTypeCallProperty = isObjectTypeCallProperty;
      exports2.isObjectTypeIndexer = isObjectTypeIndexer;
      exports2.isObjectTypeInternalSlot = isObjectTypeInternalSlot;
      exports2.isObjectTypeProperty = isObjectTypeProperty;
      exports2.isObjectTypeSpreadProperty = isObjectTypeSpreadProperty;
      exports2.isOpaqueType = isOpaqueType;
      exports2.isOptionalCallExpression = isOptionalCallExpression;
      exports2.isOptionalIndexedAccessType = isOptionalIndexedAccessType;
      exports2.isOptionalMemberExpression = isOptionalMemberExpression;
      exports2.isParenthesizedExpression = isParenthesizedExpression;
      exports2.isPattern = isPattern;
      exports2.isPatternLike = isPatternLike;
      exports2.isPipelineBareFunction = isPipelineBareFunction;
      exports2.isPipelinePrimaryTopicReference = isPipelinePrimaryTopicReference;
      exports2.isPipelineTopicExpression = isPipelineTopicExpression;
      exports2.isPlaceholder = isPlaceholder;
      exports2.isPrivate = isPrivate;
      exports2.isPrivateName = isPrivateName;
      exports2.isProgram = isProgram;
      exports2.isProperty = isProperty;
      exports2.isPureish = isPureish;
      exports2.isQualifiedTypeIdentifier = isQualifiedTypeIdentifier;
      exports2.isRecordExpression = isRecordExpression;
      exports2.isRegExpLiteral = isRegExpLiteral;
      exports2.isRegexLiteral = isRegexLiteral;
      exports2.isRestElement = isRestElement;
      exports2.isRestProperty = isRestProperty;
      exports2.isReturnStatement = isReturnStatement;
      exports2.isScopable = isScopable;
      exports2.isSequenceExpression = isSequenceExpression;
      exports2.isSpreadElement = isSpreadElement;
      exports2.isSpreadProperty = isSpreadProperty;
      exports2.isStandardized = isStandardized;
      exports2.isStatement = isStatement;
      exports2.isStaticBlock = isStaticBlock;
      exports2.isStringLiteral = isStringLiteral;
      exports2.isStringLiteralTypeAnnotation = isStringLiteralTypeAnnotation;
      exports2.isStringTypeAnnotation = isStringTypeAnnotation;
      exports2.isSuper = isSuper;
      exports2.isSwitchCase = isSwitchCase;
      exports2.isSwitchStatement = isSwitchStatement;
      exports2.isSymbolTypeAnnotation = isSymbolTypeAnnotation;
      exports2.isTSAnyKeyword = isTSAnyKeyword;
      exports2.isTSArrayType = isTSArrayType;
      exports2.isTSAsExpression = isTSAsExpression;
      exports2.isTSBaseType = isTSBaseType;
      exports2.isTSBigIntKeyword = isTSBigIntKeyword;
      exports2.isTSBooleanKeyword = isTSBooleanKeyword;
      exports2.isTSCallSignatureDeclaration = isTSCallSignatureDeclaration;
      exports2.isTSConditionalType = isTSConditionalType;
      exports2.isTSConstructSignatureDeclaration = isTSConstructSignatureDeclaration;
      exports2.isTSConstructorType = isTSConstructorType;
      exports2.isTSDeclareFunction = isTSDeclareFunction;
      exports2.isTSDeclareMethod = isTSDeclareMethod;
      exports2.isTSEntityName = isTSEntityName;
      exports2.isTSEnumDeclaration = isTSEnumDeclaration;
      exports2.isTSEnumMember = isTSEnumMember;
      exports2.isTSExportAssignment = isTSExportAssignment;
      exports2.isTSExpressionWithTypeArguments = isTSExpressionWithTypeArguments;
      exports2.isTSExternalModuleReference = isTSExternalModuleReference;
      exports2.isTSFunctionType = isTSFunctionType;
      exports2.isTSImportEqualsDeclaration = isTSImportEqualsDeclaration;
      exports2.isTSImportType = isTSImportType;
      exports2.isTSIndexSignature = isTSIndexSignature;
      exports2.isTSIndexedAccessType = isTSIndexedAccessType;
      exports2.isTSInferType = isTSInferType;
      exports2.isTSInstantiationExpression = isTSInstantiationExpression;
      exports2.isTSInterfaceBody = isTSInterfaceBody;
      exports2.isTSInterfaceDeclaration = isTSInterfaceDeclaration;
      exports2.isTSIntersectionType = isTSIntersectionType;
      exports2.isTSIntrinsicKeyword = isTSIntrinsicKeyword;
      exports2.isTSLiteralType = isTSLiteralType;
      exports2.isTSMappedType = isTSMappedType;
      exports2.isTSMethodSignature = isTSMethodSignature;
      exports2.isTSModuleBlock = isTSModuleBlock;
      exports2.isTSModuleDeclaration = isTSModuleDeclaration;
      exports2.isTSNamedTupleMember = isTSNamedTupleMember;
      exports2.isTSNamespaceExportDeclaration = isTSNamespaceExportDeclaration;
      exports2.isTSNeverKeyword = isTSNeverKeyword;
      exports2.isTSNonNullExpression = isTSNonNullExpression;
      exports2.isTSNullKeyword = isTSNullKeyword;
      exports2.isTSNumberKeyword = isTSNumberKeyword;
      exports2.isTSObjectKeyword = isTSObjectKeyword;
      exports2.isTSOptionalType = isTSOptionalType;
      exports2.isTSParameterProperty = isTSParameterProperty;
      exports2.isTSParenthesizedType = isTSParenthesizedType;
      exports2.isTSPropertySignature = isTSPropertySignature;
      exports2.isTSQualifiedName = isTSQualifiedName;
      exports2.isTSRestType = isTSRestType;
      exports2.isTSSatisfiesExpression = isTSSatisfiesExpression;
      exports2.isTSStringKeyword = isTSStringKeyword;
      exports2.isTSSymbolKeyword = isTSSymbolKeyword;
      exports2.isTSThisType = isTSThisType;
      exports2.isTSTupleType = isTSTupleType;
      exports2.isTSType = isTSType;
      exports2.isTSTypeAliasDeclaration = isTSTypeAliasDeclaration;
      exports2.isTSTypeAnnotation = isTSTypeAnnotation;
      exports2.isTSTypeAssertion = isTSTypeAssertion;
      exports2.isTSTypeElement = isTSTypeElement;
      exports2.isTSTypeLiteral = isTSTypeLiteral;
      exports2.isTSTypeOperator = isTSTypeOperator;
      exports2.isTSTypeParameter = isTSTypeParameter;
      exports2.isTSTypeParameterDeclaration = isTSTypeParameterDeclaration;
      exports2.isTSTypeParameterInstantiation = isTSTypeParameterInstantiation;
      exports2.isTSTypePredicate = isTSTypePredicate;
      exports2.isTSTypeQuery = isTSTypeQuery;
      exports2.isTSTypeReference = isTSTypeReference;
      exports2.isTSUndefinedKeyword = isTSUndefinedKeyword;
      exports2.isTSUnionType = isTSUnionType;
      exports2.isTSUnknownKeyword = isTSUnknownKeyword;
      exports2.isTSVoidKeyword = isTSVoidKeyword;
      exports2.isTaggedTemplateExpression = isTaggedTemplateExpression;
      exports2.isTemplateElement = isTemplateElement;
      exports2.isTemplateLiteral = isTemplateLiteral;
      exports2.isTerminatorless = isTerminatorless;
      exports2.isThisExpression = isThisExpression;
      exports2.isThisTypeAnnotation = isThisTypeAnnotation;
      exports2.isThrowStatement = isThrowStatement;
      exports2.isTopicReference = isTopicReference;
      exports2.isTryStatement = isTryStatement;
      exports2.isTupleExpression = isTupleExpression;
      exports2.isTupleTypeAnnotation = isTupleTypeAnnotation;
      exports2.isTypeAlias = isTypeAlias;
      exports2.isTypeAnnotation = isTypeAnnotation;
      exports2.isTypeCastExpression = isTypeCastExpression;
      exports2.isTypeParameter = isTypeParameter;
      exports2.isTypeParameterDeclaration = isTypeParameterDeclaration;
      exports2.isTypeParameterInstantiation = isTypeParameterInstantiation;
      exports2.isTypeScript = isTypeScript;
      exports2.isTypeofTypeAnnotation = isTypeofTypeAnnotation;
      exports2.isUnaryExpression = isUnaryExpression;
      exports2.isUnaryLike = isUnaryLike;
      exports2.isUnionTypeAnnotation = isUnionTypeAnnotation;
      exports2.isUpdateExpression = isUpdateExpression;
      exports2.isUserWhitespacable = isUserWhitespacable;
      exports2.isV8IntrinsicIdentifier = isV8IntrinsicIdentifier;
      exports2.isVariableDeclaration = isVariableDeclaration;
      exports2.isVariableDeclarator = isVariableDeclarator;
      exports2.isVariance = isVariance;
      exports2.isVoidTypeAnnotation = isVoidTypeAnnotation;
      exports2.isWhile = isWhile;
      exports2.isWhileStatement = isWhileStatement;
      exports2.isWithStatement = isWithStatement;
      exports2.isYieldExpression = isYieldExpression;
      var _shallowEqual = require_shallowEqual();
      function isArrayExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ArrayExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isAssignmentExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "AssignmentExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBinaryExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BinaryExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isInterpreterDirective(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "InterpreterDirective") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDirective(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Directive") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDirectiveLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DirectiveLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBlockStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BlockStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBreakStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BreakStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isCallExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "CallExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isCatchClause(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "CatchClause") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isConditionalExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ConditionalExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isContinueStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ContinueStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDebuggerStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DebuggerStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDoWhileStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DoWhileStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEmptyStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EmptyStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExpressionStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExpressionStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFile(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "File") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isForInStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ForInStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isForStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ForStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunctionDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "FunctionDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunctionExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "FunctionExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isIdentifier2(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Identifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isIfStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "IfStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isLabeledStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "LabeledStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStringLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "StringLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNumericLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NumericLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNullLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NullLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBooleanLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BooleanLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isRegExpLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "RegExpLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isLogicalExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "LogicalExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isMemberExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "MemberExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNewExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NewExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isProgram(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Program") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectMethod(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectMethod") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isRestElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "RestElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isReturnStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ReturnStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSequenceExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SequenceExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isParenthesizedExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ParenthesizedExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSwitchCase(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SwitchCase") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSwitchStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SwitchStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isThisExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ThisExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isThrowStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ThrowStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTryStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TryStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isUnaryExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "UnaryExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isUpdateExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "UpdateExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isVariableDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "VariableDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isVariableDeclarator(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "VariableDeclarator") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isWhileStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "WhileStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isWithStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "WithStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isAssignmentPattern(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "AssignmentPattern") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isArrayPattern(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ArrayPattern") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isArrowFunctionExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ArrowFunctionExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportAllDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportAllDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportDefaultDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportDefaultDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportNamedDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportNamedDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isForOfStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ForOfStatement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImportDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ImportDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImportDefaultSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ImportDefaultSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImportNamespaceSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ImportNamespaceSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImportSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ImportSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isMetaProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "MetaProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassMethod(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassMethod") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectPattern(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectPattern") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSpreadElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SpreadElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSuper(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Super") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTaggedTemplateExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TaggedTemplateExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTemplateElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TemplateElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTemplateLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TemplateLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isYieldExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "YieldExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isAwaitExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "AwaitExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImport(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Import") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBigIntLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BigIntLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportNamespaceSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportNamespaceSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isOptionalMemberExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "OptionalMemberExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isOptionalCallExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "OptionalCallExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassAccessorProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassAccessorProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassPrivateProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassPrivateProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassPrivateMethod(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassPrivateMethod") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPrivateName(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "PrivateName") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStaticBlock(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "StaticBlock") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isAnyTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "AnyTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isArrayTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ArrayTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBooleanTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BooleanTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBooleanLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BooleanLiteralTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNullLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NullLiteralTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClassImplements(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ClassImplements") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareClass(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareClass") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareFunction(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareFunction") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareInterface(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareInterface") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareModule(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareModule") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareModuleExports(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareModuleExports") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareTypeAlias(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareTypeAlias") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareOpaqueType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareOpaqueType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareVariable(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareVariable") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareExportDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareExportDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclareExportAllDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclareExportAllDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclaredPredicate(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DeclaredPredicate") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExistsTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExistsTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunctionTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "FunctionTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunctionTypeParam(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "FunctionTypeParam") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isGenericTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "GenericTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isInferredPredicate(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "InferredPredicate") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isInterfaceExtends(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "InterfaceExtends") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isInterfaceDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "InterfaceDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isInterfaceTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "InterfaceTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isIntersectionTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "IntersectionTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isMixedTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "MixedTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEmptyTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EmptyTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNullableTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NullableTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNumberLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NumberLiteralTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNumberTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NumberTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeInternalSlot(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeInternalSlot") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeCallProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeCallProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeIndexer(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeIndexer") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectTypeSpreadProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ObjectTypeSpreadProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isOpaqueType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "OpaqueType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isQualifiedTypeIdentifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "QualifiedTypeIdentifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStringLiteralTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "StringLiteralTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStringTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "StringTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSymbolTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SymbolTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isThisTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ThisTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTupleTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TupleTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeofTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeofTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeAlias(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeAlias") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeCastExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeCastExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeParameter(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeParameter") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeParameterDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeParameterDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeParameterInstantiation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TypeParameterInstantiation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isUnionTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "UnionTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isVariance(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Variance") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isVoidTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "VoidTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumBooleanBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumBooleanBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumNumberBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumNumberBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumStringBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumStringBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumSymbolBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumSymbolBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumBooleanMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumBooleanMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumNumberMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumNumberMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumStringMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumStringMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumDefaultedMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "EnumDefaultedMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isIndexedAccessType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "IndexedAccessType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isOptionalIndexedAccessType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "OptionalIndexedAccessType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXAttribute(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXAttribute") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXClosingElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXClosingElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXEmptyExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXEmptyExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXExpressionContainer(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXExpressionContainer") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXSpreadChild(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXSpreadChild") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXIdentifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXIdentifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXMemberExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXMemberExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXNamespacedName(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXNamespacedName") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXOpeningElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXOpeningElement") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXSpreadAttribute(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXSpreadAttribute") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXText(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXText") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXFragment(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXFragment") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXOpeningFragment(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXOpeningFragment") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSXClosingFragment(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "JSXClosingFragment") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNoop(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Noop") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPlaceholder(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Placeholder") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isV8IntrinsicIdentifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "V8IntrinsicIdentifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isArgumentPlaceholder(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ArgumentPlaceholder") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBindExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "BindExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImportAttribute(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ImportAttribute") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDecorator(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "Decorator") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDoExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DoExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportDefaultSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ExportDefaultSpecifier") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isRecordExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "RecordExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTupleExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TupleExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDecimalLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "DecimalLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isModuleExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "ModuleExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTopicReference(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TopicReference") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPipelineTopicExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "PipelineTopicExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPipelineBareFunction(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "PipelineBareFunction") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPipelinePrimaryTopicReference(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "PipelinePrimaryTopicReference") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSParameterProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSParameterProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSDeclareFunction(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSDeclareFunction") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSDeclareMethod(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSDeclareMethod") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSQualifiedName(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSQualifiedName") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSCallSignatureDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSCallSignatureDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSConstructSignatureDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSConstructSignatureDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSPropertySignature(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSPropertySignature") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSMethodSignature(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSMethodSignature") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSIndexSignature(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSIndexSignature") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSAnyKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSAnyKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSBooleanKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSBooleanKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSBigIntKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSBigIntKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSIntrinsicKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSIntrinsicKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNeverKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNeverKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNullKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNullKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNumberKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNumberKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSObjectKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSObjectKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSStringKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSStringKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSSymbolKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSSymbolKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSUndefinedKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSUndefinedKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSUnknownKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSUnknownKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSVoidKeyword(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSVoidKeyword") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSThisType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSThisType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSFunctionType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSFunctionType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSConstructorType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSConstructorType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeReference(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeReference") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypePredicate(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypePredicate") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeQuery(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeQuery") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSArrayType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSArrayType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTupleType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTupleType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSOptionalType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSOptionalType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSRestType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSRestType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNamedTupleMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNamedTupleMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSUnionType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSUnionType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSIntersectionType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSIntersectionType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSConditionalType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSConditionalType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSInferType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSInferType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSParenthesizedType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSParenthesizedType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeOperator(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeOperator") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSIndexedAccessType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSIndexedAccessType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSMappedType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSMappedType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSLiteralType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSLiteralType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSExpressionWithTypeArguments(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSExpressionWithTypeArguments") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSInterfaceDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSInterfaceDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSInterfaceBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSInterfaceBody") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeAliasDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeAliasDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSInstantiationExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSInstantiationExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSAsExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSAsExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSSatisfiesExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSSatisfiesExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeAssertion(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeAssertion") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSEnumDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSEnumDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSEnumMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSEnumMember") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSModuleDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSModuleDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSModuleBlock(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSModuleBlock") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSImportType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSImportType") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSImportEqualsDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSImportEqualsDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSExternalModuleReference(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSExternalModuleReference") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNonNullExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNonNullExpression") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSExportAssignment(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSExportAssignment") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSNamespaceExportDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSNamespaceExportDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeAnnotation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeParameterInstantiation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeParameterInstantiation") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeParameterDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeParameterDeclaration") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeParameter(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "TSTypeParameter") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStandardized(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ArrayExpression" === nodeType || "AssignmentExpression" === nodeType || "BinaryExpression" === nodeType || "InterpreterDirective" === nodeType || "Directive" === nodeType || "DirectiveLiteral" === nodeType || "BlockStatement" === nodeType || "BreakStatement" === nodeType || "CallExpression" === nodeType || "CatchClause" === nodeType || "ConditionalExpression" === nodeType || "ContinueStatement" === nodeType || "DebuggerStatement" === nodeType || "DoWhileStatement" === nodeType || "EmptyStatement" === nodeType || "ExpressionStatement" === nodeType || "File" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "Identifier" === nodeType || "IfStatement" === nodeType || "LabeledStatement" === nodeType || "StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "RegExpLiteral" === nodeType || "LogicalExpression" === nodeType || "MemberExpression" === nodeType || "NewExpression" === nodeType || "Program" === nodeType || "ObjectExpression" === nodeType || "ObjectMethod" === nodeType || "ObjectProperty" === nodeType || "RestElement" === nodeType || "ReturnStatement" === nodeType || "SequenceExpression" === nodeType || "ParenthesizedExpression" === nodeType || "SwitchCase" === nodeType || "SwitchStatement" === nodeType || "ThisExpression" === nodeType || "ThrowStatement" === nodeType || "TryStatement" === nodeType || "UnaryExpression" === nodeType || "UpdateExpression" === nodeType || "VariableDeclaration" === nodeType || "VariableDeclarator" === nodeType || "WhileStatement" === nodeType || "WithStatement" === nodeType || "AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassBody" === nodeType || "ClassExpression" === nodeType || "ClassDeclaration" === nodeType || "ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ExportSpecifier" === nodeType || "ForOfStatement" === nodeType || "ImportDeclaration" === nodeType || "ImportDefaultSpecifier" === nodeType || "ImportNamespaceSpecifier" === nodeType || "ImportSpecifier" === nodeType || "MetaProperty" === nodeType || "ClassMethod" === nodeType || "ObjectPattern" === nodeType || "SpreadElement" === nodeType || "Super" === nodeType || "TaggedTemplateExpression" === nodeType || "TemplateElement" === nodeType || "TemplateLiteral" === nodeType || "YieldExpression" === nodeType || "AwaitExpression" === nodeType || "Import" === nodeType || "BigIntLiteral" === nodeType || "ExportNamespaceSpecifier" === nodeType || "OptionalMemberExpression" === nodeType || "OptionalCallExpression" === nodeType || "ClassProperty" === nodeType || "ClassAccessorProperty" === nodeType || "ClassPrivateProperty" === nodeType || "ClassPrivateMethod" === nodeType || "PrivateName" === nodeType || "StaticBlock" === nodeType || nodeType === "Placeholder" && ("Identifier" === node.expectedNode || "StringLiteral" === node.expectedNode || "BlockStatement" === node.expectedNode || "ClassBody" === node.expectedNode)) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExpression(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ArrayExpression" === nodeType || "AssignmentExpression" === nodeType || "BinaryExpression" === nodeType || "CallExpression" === nodeType || "ConditionalExpression" === nodeType || "FunctionExpression" === nodeType || "Identifier" === nodeType || "StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "RegExpLiteral" === nodeType || "LogicalExpression" === nodeType || "MemberExpression" === nodeType || "NewExpression" === nodeType || "ObjectExpression" === nodeType || "SequenceExpression" === nodeType || "ParenthesizedExpression" === nodeType || "ThisExpression" === nodeType || "UnaryExpression" === nodeType || "UpdateExpression" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassExpression" === nodeType || "MetaProperty" === nodeType || "Super" === nodeType || "TaggedTemplateExpression" === nodeType || "TemplateLiteral" === nodeType || "YieldExpression" === nodeType || "AwaitExpression" === nodeType || "Import" === nodeType || "BigIntLiteral" === nodeType || "OptionalMemberExpression" === nodeType || "OptionalCallExpression" === nodeType || "TypeCastExpression" === nodeType || "JSXElement" === nodeType || "JSXFragment" === nodeType || "BindExpression" === nodeType || "DoExpression" === nodeType || "RecordExpression" === nodeType || "TupleExpression" === nodeType || "DecimalLiteral" === nodeType || "ModuleExpression" === nodeType || "TopicReference" === nodeType || "PipelineTopicExpression" === nodeType || "PipelineBareFunction" === nodeType || "PipelinePrimaryTopicReference" === nodeType || "TSInstantiationExpression" === nodeType || "TSAsExpression" === nodeType || "TSSatisfiesExpression" === nodeType || "TSTypeAssertion" === nodeType || "TSNonNullExpression" === nodeType || nodeType === "Placeholder" && ("Expression" === node.expectedNode || "Identifier" === node.expectedNode || "StringLiteral" === node.expectedNode)) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBinary(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BinaryExpression" === nodeType || "LogicalExpression" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isScopable(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BlockStatement" === nodeType || "CatchClause" === nodeType || "DoWhileStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "Program" === nodeType || "ObjectMethod" === nodeType || "SwitchStatement" === nodeType || "WhileStatement" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassExpression" === nodeType || "ClassDeclaration" === nodeType || "ForOfStatement" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType || "StaticBlock" === nodeType || "TSModuleBlock" === nodeType || nodeType === "Placeholder" && "BlockStatement" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBlockParent(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BlockStatement" === nodeType || "CatchClause" === nodeType || "DoWhileStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "Program" === nodeType || "ObjectMethod" === nodeType || "SwitchStatement" === nodeType || "WhileStatement" === nodeType || "ArrowFunctionExpression" === nodeType || "ForOfStatement" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType || "StaticBlock" === nodeType || "TSModuleBlock" === nodeType || nodeType === "Placeholder" && "BlockStatement" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isBlock(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BlockStatement" === nodeType || "Program" === nodeType || "TSModuleBlock" === nodeType || nodeType === "Placeholder" && "BlockStatement" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BlockStatement" === nodeType || "BreakStatement" === nodeType || "ContinueStatement" === nodeType || "DebuggerStatement" === nodeType || "DoWhileStatement" === nodeType || "EmptyStatement" === nodeType || "ExpressionStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "FunctionDeclaration" === nodeType || "IfStatement" === nodeType || "LabeledStatement" === nodeType || "ReturnStatement" === nodeType || "SwitchStatement" === nodeType || "ThrowStatement" === nodeType || "TryStatement" === nodeType || "VariableDeclaration" === nodeType || "WhileStatement" === nodeType || "WithStatement" === nodeType || "ClassDeclaration" === nodeType || "ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ForOfStatement" === nodeType || "ImportDeclaration" === nodeType || "DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "InterfaceDeclaration" === nodeType || "OpaqueType" === nodeType || "TypeAlias" === nodeType || "EnumDeclaration" === nodeType || "TSDeclareFunction" === nodeType || "TSInterfaceDeclaration" === nodeType || "TSTypeAliasDeclaration" === nodeType || "TSEnumDeclaration" === nodeType || "TSModuleDeclaration" === nodeType || "TSImportEqualsDeclaration" === nodeType || "TSExportAssignment" === nodeType || "TSNamespaceExportDeclaration" === nodeType || nodeType === "Placeholder" && ("Statement" === node.expectedNode || "Declaration" === node.expectedNode || "BlockStatement" === node.expectedNode)) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTerminatorless(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BreakStatement" === nodeType || "ContinueStatement" === nodeType || "ReturnStatement" === nodeType || "ThrowStatement" === nodeType || "YieldExpression" === nodeType || "AwaitExpression" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isCompletionStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("BreakStatement" === nodeType || "ContinueStatement" === nodeType || "ReturnStatement" === nodeType || "ThrowStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isConditional(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ConditionalExpression" === nodeType || "IfStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isLoop(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("DoWhileStatement" === nodeType || "ForInStatement" === nodeType || "ForStatement" === nodeType || "WhileStatement" === nodeType || "ForOfStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isWhile(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("DoWhileStatement" === nodeType || "WhileStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExpressionWrapper(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ExpressionStatement" === nodeType || "ParenthesizedExpression" === nodeType || "TypeCastExpression" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFor(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ForInStatement" === nodeType || "ForStatement" === nodeType || "ForOfStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isForXStatement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ForInStatement" === nodeType || "ForOfStatement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunction2(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "ObjectMethod" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFunctionParent(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "ObjectMethod" === nodeType || "ArrowFunctionExpression" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType || "StaticBlock" === nodeType || "TSModuleBlock" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPureish(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("FunctionDeclaration" === nodeType || "FunctionExpression" === nodeType || "StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "RegExpLiteral" === nodeType || "ArrowFunctionExpression" === nodeType || "BigIntLiteral" === nodeType || "DecimalLiteral" === nodeType || nodeType === "Placeholder" && "StringLiteral" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("FunctionDeclaration" === nodeType || "VariableDeclaration" === nodeType || "ClassDeclaration" === nodeType || "ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ImportDeclaration" === nodeType || "DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "InterfaceDeclaration" === nodeType || "OpaqueType" === nodeType || "TypeAlias" === nodeType || "EnumDeclaration" === nodeType || "TSDeclareFunction" === nodeType || "TSInterfaceDeclaration" === nodeType || "TSTypeAliasDeclaration" === nodeType || "TSEnumDeclaration" === nodeType || "TSModuleDeclaration" === nodeType || nodeType === "Placeholder" && "Declaration" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPatternLike(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("Identifier" === nodeType || "RestElement" === nodeType || "AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ObjectPattern" === nodeType || "TSAsExpression" === nodeType || "TSSatisfiesExpression" === nodeType || "TSTypeAssertion" === nodeType || "TSNonNullExpression" === nodeType || nodeType === "Placeholder" && ("Pattern" === node.expectedNode || "Identifier" === node.expectedNode)) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isLVal(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("Identifier" === nodeType || "MemberExpression" === nodeType || "RestElement" === nodeType || "AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ObjectPattern" === nodeType || "TSParameterProperty" === nodeType || "TSAsExpression" === nodeType || "TSSatisfiesExpression" === nodeType || "TSTypeAssertion" === nodeType || "TSNonNullExpression" === nodeType || nodeType === "Placeholder" && ("Pattern" === node.expectedNode || "Identifier" === node.expectedNode)) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSEntityName(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("Identifier" === nodeType || "TSQualifiedName" === nodeType || nodeType === "Placeholder" && "Identifier" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isLiteral(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "RegExpLiteral" === nodeType || "TemplateLiteral" === nodeType || "BigIntLiteral" === nodeType || "DecimalLiteral" === nodeType || nodeType === "Placeholder" && "StringLiteral" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isImmutable(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("StringLiteral" === nodeType || "NumericLiteral" === nodeType || "NullLiteral" === nodeType || "BooleanLiteral" === nodeType || "BigIntLiteral" === nodeType || "JSXAttribute" === nodeType || "JSXClosingElement" === nodeType || "JSXElement" === nodeType || "JSXExpressionContainer" === nodeType || "JSXSpreadChild" === nodeType || "JSXOpeningElement" === nodeType || "JSXText" === nodeType || "JSXFragment" === nodeType || "JSXOpeningFragment" === nodeType || "JSXClosingFragment" === nodeType || "DecimalLiteral" === nodeType || nodeType === "Placeholder" && "StringLiteral" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isUserWhitespacable(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ObjectMethod" === nodeType || "ObjectProperty" === nodeType || "ObjectTypeInternalSlot" === nodeType || "ObjectTypeCallProperty" === nodeType || "ObjectTypeIndexer" === nodeType || "ObjectTypeProperty" === nodeType || "ObjectTypeSpreadProperty" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isMethod(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ObjectMethod" === nodeType || "ClassMethod" === nodeType || "ClassPrivateMethod" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isObjectMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ObjectMethod" === nodeType || "ObjectProperty" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isProperty(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ObjectProperty" === nodeType || "ClassProperty" === nodeType || "ClassAccessorProperty" === nodeType || "ClassPrivateProperty" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isUnaryLike(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("UnaryExpression" === nodeType || "SpreadElement" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPattern(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("AssignmentPattern" === nodeType || "ArrayPattern" === nodeType || "ObjectPattern" === nodeType || nodeType === "Placeholder" && "Pattern" === node.expectedNode) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isClass(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ClassExpression" === nodeType || "ClassDeclaration" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isModuleDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType || "ImportDeclaration" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isExportDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ExportAllDeclaration" === nodeType || "ExportDefaultDeclaration" === nodeType || "ExportNamedDeclaration" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isModuleSpecifier(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ExportSpecifier" === nodeType || "ImportDefaultSpecifier" === nodeType || "ImportNamespaceSpecifier" === nodeType || "ImportSpecifier" === nodeType || "ExportNamespaceSpecifier" === nodeType || "ExportDefaultSpecifier" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isAccessor(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ClassAccessorProperty" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isPrivate(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("ClassPrivateProperty" === nodeType || "ClassPrivateMethod" === nodeType || "PrivateName" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFlow(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("AnyTypeAnnotation" === nodeType || "ArrayTypeAnnotation" === nodeType || "BooleanTypeAnnotation" === nodeType || "BooleanLiteralTypeAnnotation" === nodeType || "NullLiteralTypeAnnotation" === nodeType || "ClassImplements" === nodeType || "DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "DeclaredPredicate" === nodeType || "ExistsTypeAnnotation" === nodeType || "FunctionTypeAnnotation" === nodeType || "FunctionTypeParam" === nodeType || "GenericTypeAnnotation" === nodeType || "InferredPredicate" === nodeType || "InterfaceExtends" === nodeType || "InterfaceDeclaration" === nodeType || "InterfaceTypeAnnotation" === nodeType || "IntersectionTypeAnnotation" === nodeType || "MixedTypeAnnotation" === nodeType || "EmptyTypeAnnotation" === nodeType || "NullableTypeAnnotation" === nodeType || "NumberLiteralTypeAnnotation" === nodeType || "NumberTypeAnnotation" === nodeType || "ObjectTypeAnnotation" === nodeType || "ObjectTypeInternalSlot" === nodeType || "ObjectTypeCallProperty" === nodeType || "ObjectTypeIndexer" === nodeType || "ObjectTypeProperty" === nodeType || "ObjectTypeSpreadProperty" === nodeType || "OpaqueType" === nodeType || "QualifiedTypeIdentifier" === nodeType || "StringLiteralTypeAnnotation" === nodeType || "StringTypeAnnotation" === nodeType || "SymbolTypeAnnotation" === nodeType || "ThisTypeAnnotation" === nodeType || "TupleTypeAnnotation" === nodeType || "TypeofTypeAnnotation" === nodeType || "TypeAlias" === nodeType || "TypeAnnotation" === nodeType || "TypeCastExpression" === nodeType || "TypeParameter" === nodeType || "TypeParameterDeclaration" === nodeType || "TypeParameterInstantiation" === nodeType || "UnionTypeAnnotation" === nodeType || "Variance" === nodeType || "VoidTypeAnnotation" === nodeType || "EnumDeclaration" === nodeType || "EnumBooleanBody" === nodeType || "EnumNumberBody" === nodeType || "EnumStringBody" === nodeType || "EnumSymbolBody" === nodeType || "EnumBooleanMember" === nodeType || "EnumNumberMember" === nodeType || "EnumStringMember" === nodeType || "EnumDefaultedMember" === nodeType || "IndexedAccessType" === nodeType || "OptionalIndexedAccessType" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFlowType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("AnyTypeAnnotation" === nodeType || "ArrayTypeAnnotation" === nodeType || "BooleanTypeAnnotation" === nodeType || "BooleanLiteralTypeAnnotation" === nodeType || "NullLiteralTypeAnnotation" === nodeType || "ExistsTypeAnnotation" === nodeType || "FunctionTypeAnnotation" === nodeType || "GenericTypeAnnotation" === nodeType || "InterfaceTypeAnnotation" === nodeType || "IntersectionTypeAnnotation" === nodeType || "MixedTypeAnnotation" === nodeType || "EmptyTypeAnnotation" === nodeType || "NullableTypeAnnotation" === nodeType || "NumberLiteralTypeAnnotation" === nodeType || "NumberTypeAnnotation" === nodeType || "ObjectTypeAnnotation" === nodeType || "StringLiteralTypeAnnotation" === nodeType || "StringTypeAnnotation" === nodeType || "SymbolTypeAnnotation" === nodeType || "ThisTypeAnnotation" === nodeType || "TupleTypeAnnotation" === nodeType || "TypeofTypeAnnotation" === nodeType || "UnionTypeAnnotation" === nodeType || "VoidTypeAnnotation" === nodeType || "IndexedAccessType" === nodeType || "OptionalIndexedAccessType" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFlowBaseAnnotation(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("AnyTypeAnnotation" === nodeType || "BooleanTypeAnnotation" === nodeType || "NullLiteralTypeAnnotation" === nodeType || "MixedTypeAnnotation" === nodeType || "EmptyTypeAnnotation" === nodeType || "NumberTypeAnnotation" === nodeType || "StringTypeAnnotation" === nodeType || "SymbolTypeAnnotation" === nodeType || "ThisTypeAnnotation" === nodeType || "VoidTypeAnnotation" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFlowDeclaration(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("DeclareClass" === nodeType || "DeclareFunction" === nodeType || "DeclareInterface" === nodeType || "DeclareModule" === nodeType || "DeclareModuleExports" === nodeType || "DeclareTypeAlias" === nodeType || "DeclareOpaqueType" === nodeType || "DeclareVariable" === nodeType || "DeclareExportDeclaration" === nodeType || "DeclareExportAllDeclaration" === nodeType || "InterfaceDeclaration" === nodeType || "OpaqueType" === nodeType || "TypeAlias" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isFlowPredicate(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("DeclaredPredicate" === nodeType || "InferredPredicate" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumBody(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("EnumBooleanBody" === nodeType || "EnumNumberBody" === nodeType || "EnumStringBody" === nodeType || "EnumSymbolBody" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isEnumMember(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("EnumBooleanMember" === nodeType || "EnumNumberMember" === nodeType || "EnumStringMember" === nodeType || "EnumDefaultedMember" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isJSX(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("JSXAttribute" === nodeType || "JSXClosingElement" === nodeType || "JSXElement" === nodeType || "JSXEmptyExpression" === nodeType || "JSXExpressionContainer" === nodeType || "JSXSpreadChild" === nodeType || "JSXIdentifier" === nodeType || "JSXMemberExpression" === nodeType || "JSXNamespacedName" === nodeType || "JSXOpeningElement" === nodeType || "JSXSpreadAttribute" === nodeType || "JSXText" === nodeType || "JSXFragment" === nodeType || "JSXOpeningFragment" === nodeType || "JSXClosingFragment" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isMiscellaneous(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("Noop" === nodeType || "Placeholder" === nodeType || "V8IntrinsicIdentifier" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTypeScript(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("TSParameterProperty" === nodeType || "TSDeclareFunction" === nodeType || "TSDeclareMethod" === nodeType || "TSQualifiedName" === nodeType || "TSCallSignatureDeclaration" === nodeType || "TSConstructSignatureDeclaration" === nodeType || "TSPropertySignature" === nodeType || "TSMethodSignature" === nodeType || "TSIndexSignature" === nodeType || "TSAnyKeyword" === nodeType || "TSBooleanKeyword" === nodeType || "TSBigIntKeyword" === nodeType || "TSIntrinsicKeyword" === nodeType || "TSNeverKeyword" === nodeType || "TSNullKeyword" === nodeType || "TSNumberKeyword" === nodeType || "TSObjectKeyword" === nodeType || "TSStringKeyword" === nodeType || "TSSymbolKeyword" === nodeType || "TSUndefinedKeyword" === nodeType || "TSUnknownKeyword" === nodeType || "TSVoidKeyword" === nodeType || "TSThisType" === nodeType || "TSFunctionType" === nodeType || "TSConstructorType" === nodeType || "TSTypeReference" === nodeType || "TSTypePredicate" === nodeType || "TSTypeQuery" === nodeType || "TSTypeLiteral" === nodeType || "TSArrayType" === nodeType || "TSTupleType" === nodeType || "TSOptionalType" === nodeType || "TSRestType" === nodeType || "TSNamedTupleMember" === nodeType || "TSUnionType" === nodeType || "TSIntersectionType" === nodeType || "TSConditionalType" === nodeType || "TSInferType" === nodeType || "TSParenthesizedType" === nodeType || "TSTypeOperator" === nodeType || "TSIndexedAccessType" === nodeType || "TSMappedType" === nodeType || "TSLiteralType" === nodeType || "TSExpressionWithTypeArguments" === nodeType || "TSInterfaceDeclaration" === nodeType || "TSInterfaceBody" === nodeType || "TSTypeAliasDeclaration" === nodeType || "TSInstantiationExpression" === nodeType || "TSAsExpression" === nodeType || "TSSatisfiesExpression" === nodeType || "TSTypeAssertion" === nodeType || "TSEnumDeclaration" === nodeType || "TSEnumMember" === nodeType || "TSModuleDeclaration" === nodeType || "TSModuleBlock" === nodeType || "TSImportType" === nodeType || "TSImportEqualsDeclaration" === nodeType || "TSExternalModuleReference" === nodeType || "TSNonNullExpression" === nodeType || "TSExportAssignment" === nodeType || "TSNamespaceExportDeclaration" === nodeType || "TSTypeAnnotation" === nodeType || "TSTypeParameterInstantiation" === nodeType || "TSTypeParameterDeclaration" === nodeType || "TSTypeParameter" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSTypeElement(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("TSCallSignatureDeclaration" === nodeType || "TSConstructSignatureDeclaration" === nodeType || "TSPropertySignature" === nodeType || "TSMethodSignature" === nodeType || "TSIndexSignature" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("TSAnyKeyword" === nodeType || "TSBooleanKeyword" === nodeType || "TSBigIntKeyword" === nodeType || "TSIntrinsicKeyword" === nodeType || "TSNeverKeyword" === nodeType || "TSNullKeyword" === nodeType || "TSNumberKeyword" === nodeType || "TSObjectKeyword" === nodeType || "TSStringKeyword" === nodeType || "TSSymbolKeyword" === nodeType || "TSUndefinedKeyword" === nodeType || "TSUnknownKeyword" === nodeType || "TSVoidKeyword" === nodeType || "TSThisType" === nodeType || "TSFunctionType" === nodeType || "TSConstructorType" === nodeType || "TSTypeReference" === nodeType || "TSTypePredicate" === nodeType || "TSTypeQuery" === nodeType || "TSTypeLiteral" === nodeType || "TSArrayType" === nodeType || "TSTupleType" === nodeType || "TSOptionalType" === nodeType || "TSRestType" === nodeType || "TSUnionType" === nodeType || "TSIntersectionType" === nodeType || "TSConditionalType" === nodeType || "TSInferType" === nodeType || "TSParenthesizedType" === nodeType || "TSTypeOperator" === nodeType || "TSIndexedAccessType" === nodeType || "TSMappedType" === nodeType || "TSLiteralType" === nodeType || "TSExpressionWithTypeArguments" === nodeType || "TSImportType" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isTSBaseType(node, opts) {
        if (!node)
          return false;
        const nodeType = node.type;
        if ("TSAnyKeyword" === nodeType || "TSBooleanKeyword" === nodeType || "TSBigIntKeyword" === nodeType || "TSIntrinsicKeyword" === nodeType || "TSNeverKeyword" === nodeType || "TSNullKeyword" === nodeType || "TSNumberKeyword" === nodeType || "TSObjectKeyword" === nodeType || "TSStringKeyword" === nodeType || "TSSymbolKeyword" === nodeType || "TSUndefinedKeyword" === nodeType || "TSUnknownKeyword" === nodeType || "TSVoidKeyword" === nodeType || "TSThisType" === nodeType || "TSLiteralType" === nodeType) {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isNumberLiteral(node, opts) {
        console.trace("The node type NumberLiteral has been renamed to NumericLiteral");
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "NumberLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isRegexLiteral(node, opts) {
        console.trace("The node type RegexLiteral has been renamed to RegExpLiteral");
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "RegexLiteral") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isRestProperty(node, opts) {
        console.trace("The node type RestProperty has been renamed to RestElement");
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "RestProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
      function isSpreadProperty(node, opts) {
        console.trace("The node type SpreadProperty has been renamed to SpreadElement");
        if (!node)
          return false;
        const nodeType = node.type;
        if (nodeType === "SpreadProperty") {
          if (typeof opts === "undefined") {
            return true;
          } else {
            return (0, _shallowEqual.default)(node, opts);
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/matchesPattern.js
  var require_matchesPattern = __commonJS({
    "node_modules/@babel/types/lib/validators/matchesPattern.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = matchesPattern;
      var _generated = require_generated();
      function matchesPattern(member, match, allowPartial) {
        if (!(0, _generated.isMemberExpression)(member))
          return false;
        const parts = Array.isArray(match) ? match : match.split(".");
        const nodes = [];
        let node;
        for (node = member; (0, _generated.isMemberExpression)(node); node = node.object) {
          nodes.push(node.property);
        }
        nodes.push(node);
        if (nodes.length < parts.length)
          return false;
        if (!allowPartial && nodes.length > parts.length)
          return false;
        for (let i = 0, j = nodes.length - 1; i < parts.length; i++, j--) {
          const node2 = nodes[j];
          let value;
          if ((0, _generated.isIdentifier)(node2)) {
            value = node2.name;
          } else if ((0, _generated.isStringLiteral)(node2)) {
            value = node2.value;
          } else if ((0, _generated.isThisExpression)(node2)) {
            value = "this";
          } else {
            return false;
          }
          if (parts[i] !== value)
            return false;
        }
        return true;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/buildMatchMemberExpression.js
  var require_buildMatchMemberExpression = __commonJS({
    "node_modules/@babel/types/lib/validators/buildMatchMemberExpression.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = buildMatchMemberExpression;
      var _matchesPattern = require_matchesPattern();
      function buildMatchMemberExpression(match, allowPartial) {
        const parts = match.split(".");
        return (member) => (0, _matchesPattern.default)(member, parts, allowPartial);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/react/isReactComponent.js
  var require_isReactComponent = __commonJS({
    "node_modules/@babel/types/lib/validators/react/isReactComponent.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _buildMatchMemberExpression = require_buildMatchMemberExpression();
      var isReactComponent = (0, _buildMatchMemberExpression.default)("React.Component");
      var _default = isReactComponent;
      exports2.default = _default;
    }
  });

  // node_modules/@babel/types/lib/validators/react/isCompatTag.js
  var require_isCompatTag = __commonJS({
    "node_modules/@babel/types/lib/validators/react/isCompatTag.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isCompatTag;
      function isCompatTag(tagName) {
        return !!tagName && /^[a-z]/.test(tagName);
      }
    }
  });

  // node_modules/to-fast-properties/index.js
  var require_to_fast_properties = __commonJS({
    "node_modules/to-fast-properties/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var fastProto = null;
      function FastObject(o) {
        if (fastProto !== null && typeof fastProto.property) {
          const result2 = fastProto;
          fastProto = FastObject.prototype = null;
          return result2;
        }
        fastProto = FastObject.prototype = o == null ? /* @__PURE__ */ Object.create(null) : o;
        return new FastObject();
      }
      FastObject();
      module2.exports = function toFastproperties(o) {
        return FastObject(o);
      };
    }
  });

  // node_modules/@babel/types/lib/validators/isType.js
  var require_isType = __commonJS({
    "node_modules/@babel/types/lib/validators/isType.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isType;
      var _definitions = require_definitions();
      function isType(nodeType, targetType) {
        if (nodeType === targetType)
          return true;
        if (_definitions.ALIAS_KEYS[targetType])
          return false;
        const aliases = _definitions.FLIPPED_ALIAS_KEYS[targetType];
        if (aliases) {
          if (aliases[0] === nodeType)
            return true;
          for (const alias of aliases) {
            if (nodeType === alias)
              return true;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isPlaceholderType.js
  var require_isPlaceholderType = __commonJS({
    "node_modules/@babel/types/lib/validators/isPlaceholderType.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isPlaceholderType;
      var _definitions = require_definitions();
      function isPlaceholderType(placeholderType, targetType) {
        if (placeholderType === targetType)
          return true;
        const aliases = _definitions.PLACEHOLDERS_ALIAS[placeholderType];
        if (aliases) {
          for (const alias of aliases) {
            if (targetType === alias)
              return true;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/is.js
  var require_is = __commonJS({
    "node_modules/@babel/types/lib/validators/is.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = is;
      var _shallowEqual = require_shallowEqual();
      var _isType = require_isType();
      var _isPlaceholderType = require_isPlaceholderType();
      var _definitions = require_definitions();
      function is(type, node, opts) {
        if (!node)
          return false;
        const matches2 = (0, _isType.default)(node.type, type);
        if (!matches2) {
          if (!opts && node.type === "Placeholder" && type in _definitions.FLIPPED_ALIAS_KEYS) {
            return (0, _isPlaceholderType.default)(node.expectedNode, type);
          }
          return false;
        }
        if (typeof opts === "undefined") {
          return true;
        } else {
          return (0, _shallowEqual.default)(node, opts);
        }
      }
    }
  });

  // node_modules/@babel/helper-validator-identifier/lib/identifier.js
  var require_identifier = __commonJS({
    "node_modules/@babel/helper-validator-identifier/lib/identifier.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.isIdentifierChar = isIdentifierChar;
      exports2.isIdentifierName = isIdentifierName;
      exports2.isIdentifierStart = isIdentifierStart;
      var nonASCIIidentifierStartChars = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
      var nonASCIIidentifierChars = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F";
      var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
      var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
      nonASCIIidentifierStartChars = nonASCIIidentifierChars = null;
      var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938, 6, 4191];
      var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
      function isInAstralSet(code, set2) {
        let pos = 65536;
        for (let i = 0, length = set2.length; i < length; i += 2) {
          pos += set2[i];
          if (pos > code)
            return false;
          pos += set2[i + 1];
          if (pos >= code)
            return true;
        }
        return false;
      }
      function isIdentifierStart(code) {
        if (code < 65)
          return code === 36;
        if (code <= 90)
          return true;
        if (code < 97)
          return code === 95;
        if (code <= 122)
          return true;
        if (code <= 65535) {
          return code >= 170 && nonASCIIidentifierStart.test(String.fromCharCode(code));
        }
        return isInAstralSet(code, astralIdentifierStartCodes);
      }
      function isIdentifierChar(code) {
        if (code < 48)
          return code === 36;
        if (code < 58)
          return true;
        if (code < 65)
          return false;
        if (code <= 90)
          return true;
        if (code < 97)
          return code === 95;
        if (code <= 122)
          return true;
        if (code <= 65535) {
          return code >= 170 && nonASCIIidentifier.test(String.fromCharCode(code));
        }
        return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes);
      }
      function isIdentifierName(name) {
        let isFirst = true;
        for (let i = 0; i < name.length; i++) {
          let cp = name.charCodeAt(i);
          if ((cp & 64512) === 55296 && i + 1 < name.length) {
            const trail = name.charCodeAt(++i);
            if ((trail & 64512) === 56320) {
              cp = 65536 + ((cp & 1023) << 10) + (trail & 1023);
            }
          }
          if (isFirst) {
            isFirst = false;
            if (!isIdentifierStart(cp)) {
              return false;
            }
          } else if (!isIdentifierChar(cp)) {
            return false;
          }
        }
        return !isFirst;
      }
    }
  });

  // node_modules/@babel/helper-validator-identifier/lib/keyword.js
  var require_keyword = __commonJS({
    "node_modules/@babel/helper-validator-identifier/lib/keyword.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.isKeyword = isKeyword;
      exports2.isReservedWord = isReservedWord;
      exports2.isStrictBindOnlyReservedWord = isStrictBindOnlyReservedWord;
      exports2.isStrictBindReservedWord = isStrictBindReservedWord;
      exports2.isStrictReservedWord = isStrictReservedWord;
      var reservedWords = {
        keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"],
        strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"],
        strictBind: ["eval", "arguments"]
      };
      var keywords = new Set(reservedWords.keyword);
      var reservedWordsStrictSet = new Set(reservedWords.strict);
      var reservedWordsStrictBindSet = new Set(reservedWords.strictBind);
      function isReservedWord(word, inModule) {
        return inModule && word === "await" || word === "enum";
      }
      function isStrictReservedWord(word, inModule) {
        return isReservedWord(word, inModule) || reservedWordsStrictSet.has(word);
      }
      function isStrictBindOnlyReservedWord(word) {
        return reservedWordsStrictBindSet.has(word);
      }
      function isStrictBindReservedWord(word, inModule) {
        return isStrictReservedWord(word, inModule) || isStrictBindOnlyReservedWord(word);
      }
      function isKeyword(word) {
        return keywords.has(word);
      }
    }
  });

  // node_modules/@babel/helper-validator-identifier/lib/index.js
  var require_lib3 = __commonJS({
    "node_modules/@babel/helper-validator-identifier/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      Object.defineProperty(exports2, "isIdentifierChar", {
        enumerable: true,
        get: function() {
          return _identifier.isIdentifierChar;
        }
      });
      Object.defineProperty(exports2, "isIdentifierName", {
        enumerable: true,
        get: function() {
          return _identifier.isIdentifierName;
        }
      });
      Object.defineProperty(exports2, "isIdentifierStart", {
        enumerable: true,
        get: function() {
          return _identifier.isIdentifierStart;
        }
      });
      Object.defineProperty(exports2, "isKeyword", {
        enumerable: true,
        get: function() {
          return _keyword.isKeyword;
        }
      });
      Object.defineProperty(exports2, "isReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isReservedWord;
        }
      });
      Object.defineProperty(exports2, "isStrictBindOnlyReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isStrictBindOnlyReservedWord;
        }
      });
      Object.defineProperty(exports2, "isStrictBindReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isStrictBindReservedWord;
        }
      });
      Object.defineProperty(exports2, "isStrictReservedWord", {
        enumerable: true,
        get: function() {
          return _keyword.isStrictReservedWord;
        }
      });
      var _identifier = require_identifier();
      var _keyword = require_keyword();
    }
  });

  // node_modules/@babel/types/lib/validators/isValidIdentifier.js
  var require_isValidIdentifier = __commonJS({
    "node_modules/@babel/types/lib/validators/isValidIdentifier.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isValidIdentifier2;
      var _helperValidatorIdentifier = require_lib3();
      function isValidIdentifier2(name, reserved = true) {
        if (typeof name !== "string")
          return false;
        if (reserved) {
          if ((0, _helperValidatorIdentifier.isKeyword)(name) || (0, _helperValidatorIdentifier.isStrictReservedWord)(name, true)) {
            return false;
          }
        }
        return (0, _helperValidatorIdentifier.isIdentifierName)(name);
      }
    }
  });

  // node_modules/@babel/helper-string-parser/lib/index.js
  var require_lib4 = __commonJS({
    "node_modules/@babel/helper-string-parser/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.readCodePoint = readCodePoint;
      exports2.readInt = readInt;
      exports2.readStringContents = readStringContents;
      var _isDigit = function isDigit(code) {
        return code >= 48 && code <= 57;
      };
      var forbiddenNumericSeparatorSiblings = {
        decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]),
        hex: /* @__PURE__ */ new Set([46, 88, 95, 120])
      };
      var isAllowedNumericSeparatorSibling = {
        bin: (ch) => ch === 48 || ch === 49,
        oct: (ch) => ch >= 48 && ch <= 55,
        dec: (ch) => ch >= 48 && ch <= 57,
        hex: (ch) => ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102
      };
      function readStringContents(type, input, pos, lineStart, curLine, errors) {
        const initialPos = pos;
        const initialLineStart = lineStart;
        const initialCurLine = curLine;
        let out = "";
        let firstInvalidLoc = null;
        let chunkStart = pos;
        const {
          length
        } = input;
        for (; ; ) {
          if (pos >= length) {
            errors.unterminated(initialPos, initialLineStart, initialCurLine);
            out += input.slice(chunkStart, pos);
            break;
          }
          const ch = input.charCodeAt(pos);
          if (isStringEnd(type, ch, input, pos)) {
            out += input.slice(chunkStart, pos);
            break;
          }
          if (ch === 92) {
            out += input.slice(chunkStart, pos);
            const res = readEscapedChar(input, pos, lineStart, curLine, type === "template", errors);
            if (res.ch === null && !firstInvalidLoc) {
              firstInvalidLoc = {
                pos,
                lineStart,
                curLine
              };
            } else {
              out += res.ch;
            }
            ({
              pos,
              lineStart,
              curLine
            } = res);
            chunkStart = pos;
          } else if (ch === 8232 || ch === 8233) {
            ++pos;
            ++curLine;
            lineStart = pos;
          } else if (ch === 10 || ch === 13) {
            if (type === "template") {
              out += input.slice(chunkStart, pos) + "\n";
              ++pos;
              if (ch === 13 && input.charCodeAt(pos) === 10) {
                ++pos;
              }
              ++curLine;
              chunkStart = lineStart = pos;
            } else {
              errors.unterminated(initialPos, initialLineStart, initialCurLine);
            }
          } else {
            ++pos;
          }
        }
        return {
          pos,
          str: out,
          firstInvalidLoc,
          lineStart,
          curLine,
          containsInvalid: !!firstInvalidLoc
        };
      }
      function isStringEnd(type, ch, input, pos) {
        if (type === "template") {
          return ch === 96 || ch === 36 && input.charCodeAt(pos + 1) === 123;
        }
        return ch === (type === "double" ? 34 : 39);
      }
      function readEscapedChar(input, pos, lineStart, curLine, inTemplate, errors) {
        const throwOnInvalid = !inTemplate;
        pos++;
        const res = (ch2) => ({
          pos,
          ch: ch2,
          lineStart,
          curLine
        });
        const ch = input.charCodeAt(pos++);
        switch (ch) {
          case 110:
            return res("\n");
          case 114:
            return res("\r");
          case 120: {
            let code;
            ({
              code,
              pos
            } = readHexChar(input, pos, lineStart, curLine, 2, false, throwOnInvalid, errors));
            return res(code === null ? null : String.fromCharCode(code));
          }
          case 117: {
            let code;
            ({
              code,
              pos
            } = readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors));
            return res(code === null ? null : String.fromCodePoint(code));
          }
          case 116:
            return res("	");
          case 98:
            return res("\b");
          case 118:
            return res("\v");
          case 102:
            return res("\f");
          case 13:
            if (input.charCodeAt(pos) === 10) {
              ++pos;
            }
          case 10:
            lineStart = pos;
            ++curLine;
          case 8232:
          case 8233:
            return res("");
          case 56:
          case 57:
            if (inTemplate) {
              return res(null);
            } else {
              errors.strictNumericEscape(pos - 1, lineStart, curLine);
            }
          default:
            if (ch >= 48 && ch <= 55) {
              const startPos = pos - 1;
              const match = input.slice(startPos, pos + 2).match(/^[0-7]+/);
              let octalStr = match[0];
              let octal = parseInt(octalStr, 8);
              if (octal > 255) {
                octalStr = octalStr.slice(0, -1);
                octal = parseInt(octalStr, 8);
              }
              pos += octalStr.length - 1;
              const next = input.charCodeAt(pos);
              if (octalStr !== "0" || next === 56 || next === 57) {
                if (inTemplate) {
                  return res(null);
                } else {
                  errors.strictNumericEscape(startPos, lineStart, curLine);
                }
              }
              return res(String.fromCharCode(octal));
            }
            return res(String.fromCharCode(ch));
        }
      }
      function readHexChar(input, pos, lineStart, curLine, len, forceLen, throwOnInvalid, errors) {
        const initialPos = pos;
        let n;
        ({
          n,
          pos
        } = readInt(input, pos, lineStart, curLine, 16, len, forceLen, false, errors, !throwOnInvalid));
        if (n === null) {
          if (throwOnInvalid) {
            errors.invalidEscapeSequence(initialPos, lineStart, curLine);
          } else {
            pos = initialPos - 1;
          }
        }
        return {
          code: n,
          pos
        };
      }
      function readInt(input, pos, lineStart, curLine, radix, len, forceLen, allowNumSeparator, errors, bailOnError) {
        const start = pos;
        const forbiddenSiblings = radix === 16 ? forbiddenNumericSeparatorSiblings.hex : forbiddenNumericSeparatorSiblings.decBinOct;
        const isAllowedSibling = radix === 16 ? isAllowedNumericSeparatorSibling.hex : radix === 10 ? isAllowedNumericSeparatorSibling.dec : radix === 8 ? isAllowedNumericSeparatorSibling.oct : isAllowedNumericSeparatorSibling.bin;
        let invalid = false;
        let total = 0;
        for (let i = 0, e = len == null ? Infinity : len; i < e; ++i) {
          const code = input.charCodeAt(pos);
          let val;
          if (code === 95 && allowNumSeparator !== "bail") {
            const prev = input.charCodeAt(pos - 1);
            const next = input.charCodeAt(pos + 1);
            if (!allowNumSeparator) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.numericSeparatorInEscapeSequence(pos, lineStart, curLine);
            } else if (Number.isNaN(next) || !isAllowedSibling(next) || forbiddenSiblings.has(prev) || forbiddenSiblings.has(next)) {
              if (bailOnError)
                return {
                  n: null,
                  pos
                };
              errors.unexpectedNumericSeparator(pos, lineStart, curLine);
            }
            ++pos;
            continue;
          }
          if (code >= 97) {
            val = code - 97 + 10;
          } else if (code >= 65) {
            val = code - 65 + 10;
          } else if (_isDigit(code)) {
            val = code - 48;
          } else {
            val = Infinity;
          }
          if (val >= radix) {
            if (val <= 9 && bailOnError) {
              return {
                n: null,
                pos
              };
            } else if (val <= 9 && errors.invalidDigit(pos, lineStart, curLine, radix)) {
              val = 0;
            } else if (forceLen) {
              val = 0;
              invalid = true;
            } else {
              break;
            }
          }
          ++pos;
          total = total * radix + val;
        }
        if (pos === start || len != null && pos - start !== len || invalid) {
          return {
            n: null,
            pos
          };
        }
        return {
          n: total,
          pos
        };
      }
      function readCodePoint(input, pos, lineStart, curLine, throwOnInvalid, errors) {
        const ch = input.charCodeAt(pos);
        let code;
        if (ch === 123) {
          ++pos;
          ({
            code,
            pos
          } = readHexChar(input, pos, lineStart, curLine, input.indexOf("}", pos) - pos, true, throwOnInvalid, errors));
          ++pos;
          if (code !== null && code > 1114111) {
            if (throwOnInvalid) {
              errors.invalidCodePoint(pos, lineStart, curLine);
            } else {
              return {
                code: null,
                pos
              };
            }
          }
        } else {
          ({
            code,
            pos
          } = readHexChar(input, pos, lineStart, curLine, 4, false, throwOnInvalid, errors));
        }
        return {
          code,
          pos
        };
      }
    }
  });

  // node_modules/@babel/types/lib/constants/index.js
  var require_constants = __commonJS({
    "node_modules/@babel/types/lib/constants/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.UPDATE_OPERATORS = exports2.UNARY_OPERATORS = exports2.STRING_UNARY_OPERATORS = exports2.STATEMENT_OR_BLOCK_KEYS = exports2.NUMBER_UNARY_OPERATORS = exports2.NUMBER_BINARY_OPERATORS = exports2.NOT_LOCAL_BINDING = exports2.LOGICAL_OPERATORS = exports2.INHERIT_KEYS = exports2.FOR_INIT_KEYS = exports2.FLATTENABLE_KEYS = exports2.EQUALITY_BINARY_OPERATORS = exports2.COMPARISON_BINARY_OPERATORS = exports2.COMMENT_KEYS = exports2.BOOLEAN_UNARY_OPERATORS = exports2.BOOLEAN_NUMBER_BINARY_OPERATORS = exports2.BOOLEAN_BINARY_OPERATORS = exports2.BLOCK_SCOPED_SYMBOL = exports2.BINARY_OPERATORS = exports2.ASSIGNMENT_OPERATORS = void 0;
      var STATEMENT_OR_BLOCK_KEYS = ["consequent", "body", "alternate"];
      exports2.STATEMENT_OR_BLOCK_KEYS = STATEMENT_OR_BLOCK_KEYS;
      var FLATTENABLE_KEYS = ["body", "expressions"];
      exports2.FLATTENABLE_KEYS = FLATTENABLE_KEYS;
      var FOR_INIT_KEYS = ["left", "init"];
      exports2.FOR_INIT_KEYS = FOR_INIT_KEYS;
      var COMMENT_KEYS = ["leadingComments", "trailingComments", "innerComments"];
      exports2.COMMENT_KEYS = COMMENT_KEYS;
      var LOGICAL_OPERATORS = ["||", "&&", "??"];
      exports2.LOGICAL_OPERATORS = LOGICAL_OPERATORS;
      var UPDATE_OPERATORS = ["++", "--"];
      exports2.UPDATE_OPERATORS = UPDATE_OPERATORS;
      var BOOLEAN_NUMBER_BINARY_OPERATORS = [">", "<", ">=", "<="];
      exports2.BOOLEAN_NUMBER_BINARY_OPERATORS = BOOLEAN_NUMBER_BINARY_OPERATORS;
      var EQUALITY_BINARY_OPERATORS = ["==", "===", "!=", "!=="];
      exports2.EQUALITY_BINARY_OPERATORS = EQUALITY_BINARY_OPERATORS;
      var COMPARISON_BINARY_OPERATORS = [...EQUALITY_BINARY_OPERATORS, "in", "instanceof"];
      exports2.COMPARISON_BINARY_OPERATORS = COMPARISON_BINARY_OPERATORS;
      var BOOLEAN_BINARY_OPERATORS = [...COMPARISON_BINARY_OPERATORS, ...BOOLEAN_NUMBER_BINARY_OPERATORS];
      exports2.BOOLEAN_BINARY_OPERATORS = BOOLEAN_BINARY_OPERATORS;
      var NUMBER_BINARY_OPERATORS = ["-", "/", "%", "*", "**", "&", "|", ">>", ">>>", "<<", "^"];
      exports2.NUMBER_BINARY_OPERATORS = NUMBER_BINARY_OPERATORS;
      var BINARY_OPERATORS = ["+", ...NUMBER_BINARY_OPERATORS, ...BOOLEAN_BINARY_OPERATORS, "|>"];
      exports2.BINARY_OPERATORS = BINARY_OPERATORS;
      var ASSIGNMENT_OPERATORS = ["=", "+=", ...NUMBER_BINARY_OPERATORS.map((op) => op + "="), ...LOGICAL_OPERATORS.map((op) => op + "=")];
      exports2.ASSIGNMENT_OPERATORS = ASSIGNMENT_OPERATORS;
      var BOOLEAN_UNARY_OPERATORS = ["delete", "!"];
      exports2.BOOLEAN_UNARY_OPERATORS = BOOLEAN_UNARY_OPERATORS;
      var NUMBER_UNARY_OPERATORS = ["+", "-", "~"];
      exports2.NUMBER_UNARY_OPERATORS = NUMBER_UNARY_OPERATORS;
      var STRING_UNARY_OPERATORS = ["typeof"];
      exports2.STRING_UNARY_OPERATORS = STRING_UNARY_OPERATORS;
      var UNARY_OPERATORS = ["void", "throw", ...BOOLEAN_UNARY_OPERATORS, ...NUMBER_UNARY_OPERATORS, ...STRING_UNARY_OPERATORS];
      exports2.UNARY_OPERATORS = UNARY_OPERATORS;
      var INHERIT_KEYS = {
        optional: ["typeAnnotation", "typeParameters", "returnType"],
        force: ["start", "loc", "end"]
      };
      exports2.INHERIT_KEYS = INHERIT_KEYS;
      var BLOCK_SCOPED_SYMBOL = Symbol.for("var used to be block scoped");
      exports2.BLOCK_SCOPED_SYMBOL = BLOCK_SCOPED_SYMBOL;
      var NOT_LOCAL_BINDING = Symbol.for("should not be considered a local binding");
      exports2.NOT_LOCAL_BINDING = NOT_LOCAL_BINDING;
    }
  });

  // node_modules/@babel/types/lib/definitions/utils.js
  var require_utils3 = __commonJS({
    "node_modules/@babel/types/lib/definitions/utils.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.VISITOR_KEYS = exports2.NODE_PARENT_VALIDATIONS = exports2.NODE_FIELDS = exports2.FLIPPED_ALIAS_KEYS = exports2.DEPRECATED_KEYS = exports2.BUILDER_KEYS = exports2.ALIAS_KEYS = void 0;
      exports2.arrayOf = arrayOf;
      exports2.arrayOfType = arrayOfType;
      exports2.assertEach = assertEach;
      exports2.assertNodeOrValueType = assertNodeOrValueType;
      exports2.assertNodeType = assertNodeType;
      exports2.assertOneOf = assertOneOf;
      exports2.assertOptionalChainStart = assertOptionalChainStart;
      exports2.assertShape = assertShape;
      exports2.assertValueType = assertValueType;
      exports2.chain = chain2;
      exports2.default = defineType;
      exports2.defineAliasedType = defineAliasedType;
      exports2.typeIs = typeIs;
      exports2.validate = validate;
      exports2.validateArrayOfType = validateArrayOfType;
      exports2.validateOptional = validateOptional;
      exports2.validateOptionalType = validateOptionalType;
      exports2.validateType = validateType;
      var _is = require_is();
      var _validate = require_validate();
      var VISITOR_KEYS = {};
      exports2.VISITOR_KEYS = VISITOR_KEYS;
      var ALIAS_KEYS = {};
      exports2.ALIAS_KEYS = ALIAS_KEYS;
      var FLIPPED_ALIAS_KEYS = {};
      exports2.FLIPPED_ALIAS_KEYS = FLIPPED_ALIAS_KEYS;
      var NODE_FIELDS = {};
      exports2.NODE_FIELDS = NODE_FIELDS;
      var BUILDER_KEYS = {};
      exports2.BUILDER_KEYS = BUILDER_KEYS;
      var DEPRECATED_KEYS = {};
      exports2.DEPRECATED_KEYS = DEPRECATED_KEYS;
      var NODE_PARENT_VALIDATIONS = {};
      exports2.NODE_PARENT_VALIDATIONS = NODE_PARENT_VALIDATIONS;
      function getType(val) {
        if (Array.isArray(val)) {
          return "array";
        } else if (val === null) {
          return "null";
        } else {
          return typeof val;
        }
      }
      function validate(validate2) {
        return {
          validate: validate2
        };
      }
      function typeIs(typeName) {
        return typeof typeName === "string" ? assertNodeType(typeName) : assertNodeType(...typeName);
      }
      function validateType(typeName) {
        return validate(typeIs(typeName));
      }
      function validateOptional(validate2) {
        return {
          validate: validate2,
          optional: true
        };
      }
      function validateOptionalType(typeName) {
        return {
          validate: typeIs(typeName),
          optional: true
        };
      }
      function arrayOf(elementType) {
        return chain2(assertValueType("array"), assertEach(elementType));
      }
      function arrayOfType(typeName) {
        return arrayOf(typeIs(typeName));
      }
      function validateArrayOfType(typeName) {
        return validate(arrayOfType(typeName));
      }
      function assertEach(callback) {
        function validator(node, key, val) {
          if (!Array.isArray(val))
            return;
          for (let i = 0; i < val.length; i++) {
            const subkey = `${key}[${i}]`;
            const v = val[i];
            callback(node, subkey, v);
            if (define_process_default.env.BABEL_TYPES_8_BREAKING)
              (0, _validate.validateChild)(node, subkey, v);
          }
        }
        validator.each = callback;
        return validator;
      }
      function assertOneOf(...values2) {
        function validate2(node, key, val) {
          if (values2.indexOf(val) < 0) {
            throw new TypeError(`Property ${key} expected value to be one of ${JSON.stringify(values2)} but got ${JSON.stringify(val)}`);
          }
        }
        validate2.oneOf = values2;
        return validate2;
      }
      function assertNodeType(...types) {
        function validate2(node, key, val) {
          for (const type of types) {
            if ((0, _is.default)(type, val)) {
              (0, _validate.validateChild)(node, key, val);
              return;
            }
          }
          throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types)} but instead got ${JSON.stringify(val == null ? void 0 : val.type)}`);
        }
        validate2.oneOfNodeTypes = types;
        return validate2;
      }
      function assertNodeOrValueType(...types) {
        function validate2(node, key, val) {
          for (const type of types) {
            if (getType(val) === type || (0, _is.default)(type, val)) {
              (0, _validate.validateChild)(node, key, val);
              return;
            }
          }
          throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types)} but instead got ${JSON.stringify(val == null ? void 0 : val.type)}`);
        }
        validate2.oneOfNodeOrValueTypes = types;
        return validate2;
      }
      function assertValueType(type) {
        function validate2(node, key, val) {
          const valid = getType(val) === type;
          if (!valid) {
            throw new TypeError(`Property ${key} expected type of ${type} but got ${getType(val)}`);
          }
        }
        validate2.type = type;
        return validate2;
      }
      function assertShape(shape) {
        function validate2(node, key, val) {
          const errors = [];
          for (const property2 of Object.keys(shape)) {
            try {
              (0, _validate.validateField)(node, property2, val[property2], shape[property2]);
            } catch (error) {
              if (error instanceof TypeError) {
                errors.push(error.message);
                continue;
              }
              throw error;
            }
          }
          if (errors.length) {
            throw new TypeError(`Property ${key} of ${node.type} expected to have the following:
${errors.join("\n")}`);
          }
        }
        validate2.shapeOf = shape;
        return validate2;
      }
      function assertOptionalChainStart() {
        function validate2(node) {
          var _current;
          let current = node;
          while (node) {
            const {
              type
            } = current;
            if (type === "OptionalCallExpression") {
              if (current.optional)
                return;
              current = current.callee;
              continue;
            }
            if (type === "OptionalMemberExpression") {
              if (current.optional)
                return;
              current = current.object;
              continue;
            }
            break;
          }
          throw new TypeError(`Non-optional ${node.type} must chain from an optional OptionalMemberExpression or OptionalCallExpression. Found chain from ${(_current = current) == null ? void 0 : _current.type}`);
        }
        return validate2;
      }
      function chain2(...fns) {
        function validate2(...args) {
          for (const fn of fns) {
            fn(...args);
          }
        }
        validate2.chainOf = fns;
        if (fns.length >= 2 && "type" in fns[0] && fns[0].type === "array" && !("each" in fns[1])) {
          throw new Error(`An assertValueType("array") validator can only be followed by an assertEach(...) validator.`);
        }
        return validate2;
      }
      var validTypeOpts = ["aliases", "builder", "deprecatedAlias", "fields", "inherits", "visitor", "validate"];
      var validFieldKeys = ["default", "optional", "validate"];
      var store = {};
      function defineAliasedType(...aliases) {
        return (type, opts = {}) => {
          let defined = opts.aliases;
          if (!defined) {
            var _store$opts$inherits$, _defined;
            if (opts.inherits)
              defined = (_store$opts$inherits$ = store[opts.inherits].aliases) == null ? void 0 : _store$opts$inherits$.slice();
            (_defined = defined) != null ? _defined : defined = [];
            opts.aliases = defined;
          }
          const additional = aliases.filter((a) => !defined.includes(a));
          defined.unshift(...additional);
          return defineType(type, opts);
        };
      }
      function defineType(type, opts = {}) {
        const inherits = opts.inherits && store[opts.inherits] || {};
        let fields = opts.fields;
        if (!fields) {
          fields = {};
          if (inherits.fields) {
            const keys2 = Object.getOwnPropertyNames(inherits.fields);
            for (const key of keys2) {
              const field = inherits.fields[key];
              const def = field.default;
              if (Array.isArray(def) ? def.length > 0 : def && typeof def === "object") {
                throw new Error("field defaults can only be primitives or empty arrays currently");
              }
              fields[key] = {
                default: Array.isArray(def) ? [] : def,
                optional: field.optional,
                validate: field.validate
              };
            }
          }
        }
        const visitor = opts.visitor || inherits.visitor || [];
        const aliases = opts.aliases || inherits.aliases || [];
        const builder = opts.builder || inherits.builder || opts.visitor || [];
        for (const k of Object.keys(opts)) {
          if (validTypeOpts.indexOf(k) === -1) {
            throw new Error(`Unknown type option "${k}" on ${type}`);
          }
        }
        if (opts.deprecatedAlias) {
          DEPRECATED_KEYS[opts.deprecatedAlias] = type;
        }
        for (const key of visitor.concat(builder)) {
          fields[key] = fields[key] || {};
        }
        for (const key of Object.keys(fields)) {
          const field = fields[key];
          if (field.default !== void 0 && builder.indexOf(key) === -1) {
            field.optional = true;
          }
          if (field.default === void 0) {
            field.default = null;
          } else if (!field.validate && field.default != null) {
            field.validate = assertValueType(getType(field.default));
          }
          for (const k of Object.keys(field)) {
            if (validFieldKeys.indexOf(k) === -1) {
              throw new Error(`Unknown field key "${k}" on ${type}.${key}`);
            }
          }
        }
        VISITOR_KEYS[type] = opts.visitor = visitor;
        BUILDER_KEYS[type] = opts.builder = builder;
        NODE_FIELDS[type] = opts.fields = fields;
        ALIAS_KEYS[type] = opts.aliases = aliases;
        aliases.forEach((alias) => {
          FLIPPED_ALIAS_KEYS[alias] = FLIPPED_ALIAS_KEYS[alias] || [];
          FLIPPED_ALIAS_KEYS[alias].push(type);
        });
        if (opts.validate) {
          NODE_PARENT_VALIDATIONS[type] = opts.validate;
        }
        store[type] = opts;
      }
    }
  });

  // node_modules/@babel/types/lib/definitions/core.js
  var require_core = __commonJS({
    "node_modules/@babel/types/lib/definitions/core.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.patternLikeCommon = exports2.functionTypeAnnotationCommon = exports2.functionDeclarationCommon = exports2.functionCommon = exports2.classMethodOrPropertyCommon = exports2.classMethodOrDeclareMethodCommon = void 0;
      var _is = require_is();
      var _isValidIdentifier = require_isValidIdentifier();
      var _helperValidatorIdentifier = require_lib3();
      var _helperStringParser = require_lib4();
      var _constants = require_constants();
      var _utils = require_utils3();
      var defineType = (0, _utils.defineAliasedType)("Standardized");
      defineType("ArrayExpression", {
        fields: {
          elements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeOrValueType)("null", "Expression", "SpreadElement"))),
            default: !define_process_default.env.BABEL_TYPES_8_BREAKING ? [] : void 0
          }
        },
        visitor: ["elements"],
        aliases: ["Expression"]
      });
      defineType("AssignmentExpression", {
        fields: {
          operator: {
            validate: function() {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING) {
                return (0, _utils.assertValueType)("string");
              }
              const identifier3 = (0, _utils.assertOneOf)(..._constants.ASSIGNMENT_OPERATORS);
              const pattern = (0, _utils.assertOneOf)("=");
              return function(node, key, val) {
                const validator = (0, _is.default)("Pattern", node.left) ? pattern : identifier3;
                validator(node, key, val);
              };
            }()
          },
          left: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("LVal") : (0, _utils.assertNodeType)("Identifier", "MemberExpression", "ArrayPattern", "ObjectPattern", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        builder: ["operator", "left", "right"],
        visitor: ["left", "right"],
        aliases: ["Expression"]
      });
      defineType("BinaryExpression", {
        builder: ["operator", "left", "right"],
        fields: {
          operator: {
            validate: (0, _utils.assertOneOf)(..._constants.BINARY_OPERATORS)
          },
          left: {
            validate: function() {
              const expression = (0, _utils.assertNodeType)("Expression");
              const inOp = (0, _utils.assertNodeType)("Expression", "PrivateName");
              const validator = Object.assign(
                function(node, key, val) {
                  const validator2 = node.operator === "in" ? inOp : expression;
                  validator2(node, key, val);
                },
                {
                  oneOfNodeTypes: ["Expression", "PrivateName"]
                }
              );
              return validator;
            }()
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        visitor: ["left", "right"],
        aliases: ["Binary", "Expression"]
      });
      defineType("InterpreterDirective", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("Directive", {
        visitor: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertNodeType)("DirectiveLiteral")
          }
        }
      });
      defineType("DirectiveLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("BlockStatement", {
        builder: ["body", "directives"],
        visitor: ["directives", "body"],
        fields: {
          directives: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Directive"))),
            default: []
          },
          body: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
          }
        },
        aliases: ["Scopable", "BlockParent", "Block", "Statement"]
      });
      defineType("BreakStatement", {
        visitor: ["label"],
        fields: {
          label: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          }
        },
        aliases: ["Statement", "Terminatorless", "CompletionStatement"]
      });
      defineType("CallExpression", {
        visitor: ["callee", "arguments", "typeParameters", "typeArguments"],
        builder: ["callee", "arguments"],
        aliases: ["Expression"],
        fields: Object.assign({
          callee: {
            validate: (0, _utils.assertNodeType)("Expression", "Super", "V8IntrinsicIdentifier")
          },
          arguments: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression", "SpreadElement", "JSXNamespacedName", "ArgumentPlaceholder")))
          }
        }, !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
          optional: {
            validate: (0, _utils.assertOneOf)(true, false),
            optional: true
          }
        } : {}, {
          typeArguments: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation"),
            optional: true
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TSTypeParameterInstantiation"),
            optional: true
          }
        })
      });
      defineType("CatchClause", {
        visitor: ["param", "body"],
        fields: {
          param: {
            validate: (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        },
        aliases: ["Scopable", "BlockParent"]
      });
      defineType("ConditionalExpression", {
        visitor: ["test", "consequent", "alternate"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          consequent: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          alternate: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Expression", "Conditional"]
      });
      defineType("ContinueStatement", {
        visitor: ["label"],
        fields: {
          label: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          }
        },
        aliases: ["Statement", "Terminatorless", "CompletionStatement"]
      });
      defineType("DebuggerStatement", {
        aliases: ["Statement"]
      });
      defineType("DoWhileStatement", {
        visitor: ["test", "body"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        },
        aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"]
      });
      defineType("EmptyStatement", {
        aliases: ["Statement"]
      });
      defineType("ExpressionStatement", {
        visitor: ["expression"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Statement", "ExpressionWrapper"]
      });
      defineType("File", {
        builder: ["program", "comments", "tokens"],
        visitor: ["program"],
        fields: {
          program: {
            validate: (0, _utils.assertNodeType)("Program")
          },
          comments: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? Object.assign(() => {
            }, {
              each: {
                oneOfNodeTypes: ["CommentBlock", "CommentLine"]
              }
            }) : (0, _utils.assertEach)((0, _utils.assertNodeType)("CommentBlock", "CommentLine")),
            optional: true
          },
          tokens: {
            validate: (0, _utils.assertEach)(Object.assign(() => {
            }, {
              type: "any"
            })),
            optional: true
          }
        }
      });
      defineType("ForInStatement", {
        visitor: ["left", "right", "body"],
        aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
        fields: {
          left: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("VariableDeclaration", "LVal") : (0, _utils.assertNodeType)("VariableDeclaration", "Identifier", "MemberExpression", "ArrayPattern", "ObjectPattern", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("ForStatement", {
        visitor: ["init", "test", "update", "body"],
        aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop"],
        fields: {
          init: {
            validate: (0, _utils.assertNodeType)("VariableDeclaration", "Expression"),
            optional: true
          },
          test: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          update: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      var functionCommon = () => ({
        params: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Identifier", "Pattern", "RestElement")))
        },
        generator: {
          default: false
        },
        async: {
          default: false
        }
      });
      exports2.functionCommon = functionCommon;
      var functionTypeAnnotationCommon = () => ({
        returnType: {
          validate: (0, _utils.assertNodeType)(
            "TypeAnnotation",
            "TSTypeAnnotation",
            "Noop"
          ),
          optional: true
        },
        typeParameters: {
          validate: (0, _utils.assertNodeType)(
            "TypeParameterDeclaration",
            "TSTypeParameterDeclaration",
            "Noop"
          ),
          optional: true
        }
      });
      exports2.functionTypeAnnotationCommon = functionTypeAnnotationCommon;
      var functionDeclarationCommon = () => Object.assign({}, functionCommon(), {
        declare: {
          validate: (0, _utils.assertValueType)("boolean"),
          optional: true
        },
        id: {
          validate: (0, _utils.assertNodeType)("Identifier"),
          optional: true
        }
      });
      exports2.functionDeclarationCommon = functionDeclarationCommon;
      defineType("FunctionDeclaration", {
        builder: ["id", "params", "body", "generator", "async"],
        visitor: ["id", "params", "body", "returnType", "typeParameters"],
        fields: Object.assign({}, functionDeclarationCommon(), functionTypeAnnotationCommon(), {
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          },
          predicate: {
            validate: (0, _utils.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
          }
        }),
        aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Statement", "Pureish", "Declaration"],
        validate: function() {
          if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
            return () => {
            };
          const identifier3 = (0, _utils.assertNodeType)("Identifier");
          return function(parent2, key, node) {
            if (!(0, _is.default)("ExportDefaultDeclaration", parent2)) {
              identifier3(node, "id", node.id);
            }
          };
        }()
      });
      defineType("FunctionExpression", {
        inherits: "FunctionDeclaration",
        aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
        fields: Object.assign({}, functionCommon(), functionTypeAnnotationCommon(), {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          },
          predicate: {
            validate: (0, _utils.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
          }
        })
      });
      var patternLikeCommon = () => ({
        typeAnnotation: {
          validate: (0, _utils.assertNodeType)(
            "TypeAnnotation",
            "TSTypeAnnotation",
            "Noop"
          ),
          optional: true
        },
        decorators: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
          optional: true
        }
      });
      exports2.patternLikeCommon = patternLikeCommon;
      defineType("Identifier", {
        builder: ["name"],
        visitor: ["typeAnnotation", "decorators"],
        aliases: ["Expression", "PatternLike", "LVal", "TSEntityName"],
        fields: Object.assign({}, patternLikeCommon(), {
          name: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (!(0, _isValidIdentifier.default)(val, false)) {
                throw new TypeError(`"${val}" is not a valid identifier name`);
              }
            }, {
              type: "string"
            }))
          },
          optional: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        }),
        validate(parent2, key, node) {
          if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
            return;
          const match = /\.(\w+)$/.exec(key);
          if (!match)
            return;
          const [, parentKey] = match;
          const nonComp = {
            computed: false
          };
          if (parentKey === "property") {
            if ((0, _is.default)("MemberExpression", parent2, nonComp))
              return;
            if ((0, _is.default)("OptionalMemberExpression", parent2, nonComp))
              return;
          } else if (parentKey === "key") {
            if ((0, _is.default)("Property", parent2, nonComp))
              return;
            if ((0, _is.default)("Method", parent2, nonComp))
              return;
          } else if (parentKey === "exported") {
            if ((0, _is.default)("ExportSpecifier", parent2))
              return;
          } else if (parentKey === "imported") {
            if ((0, _is.default)("ImportSpecifier", parent2, {
              imported: node
            }))
              return;
          } else if (parentKey === "meta") {
            if ((0, _is.default)("MetaProperty", parent2, {
              meta: node
            }))
              return;
          }
          if (((0, _helperValidatorIdentifier.isKeyword)(node.name) || (0, _helperValidatorIdentifier.isReservedWord)(node.name, false)) && node.name !== "this") {
            throw new TypeError(`"${node.name}" is not a valid identifier`);
          }
        }
      });
      defineType("IfStatement", {
        visitor: ["test", "consequent", "alternate"],
        aliases: ["Statement", "Conditional"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          consequent: {
            validate: (0, _utils.assertNodeType)("Statement")
          },
          alternate: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("LabeledStatement", {
        visitor: ["label", "body"],
        aliases: ["Statement"],
        fields: {
          label: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("StringLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("NumericLiteral", {
        builder: ["value"],
        deprecatedAlias: "NumberLiteral",
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("number")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("NullLiteral", {
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("BooleanLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("boolean")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("RegExpLiteral", {
        builder: ["pattern", "flags"],
        deprecatedAlias: "RegexLiteral",
        aliases: ["Expression", "Pureish", "Literal"],
        fields: {
          pattern: {
            validate: (0, _utils.assertValueType)("string")
          },
          flags: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              const invalid = /[^gimsuy]/.exec(val);
              if (invalid) {
                throw new TypeError(`"${invalid[0]}" is not a valid RegExp flag`);
              }
            }, {
              type: "string"
            })),
            default: ""
          }
        }
      });
      defineType("LogicalExpression", {
        builder: ["operator", "left", "right"],
        visitor: ["left", "right"],
        aliases: ["Binary", "Expression"],
        fields: {
          operator: {
            validate: (0, _utils.assertOneOf)(..._constants.LOGICAL_OPERATORS)
          },
          left: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("MemberExpression", {
        builder: ["object", "property", "computed", ...!define_process_default.env.BABEL_TYPES_8_BREAKING ? ["optional"] : []],
        visitor: ["object", "property"],
        aliases: ["Expression", "LVal"],
        fields: Object.assign({
          object: {
            validate: (0, _utils.assertNodeType)("Expression", "Super")
          },
          property: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "PrivateName");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = function(node, key, val) {
                const validator2 = node.computed ? computed : normal;
                validator2(node, key, val);
              };
              validator.oneOfNodeTypes = ["Expression", "Identifier", "PrivateName"];
              return validator;
            }()
          },
          computed: {
            default: false
          }
        }, !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
          optional: {
            validate: (0, _utils.assertOneOf)(true, false),
            optional: true
          }
        } : {})
      });
      defineType("NewExpression", {
        inherits: "CallExpression"
      });
      defineType("Program", {
        visitor: ["directives", "body"],
        builder: ["body", "directives", "sourceType", "interpreter"],
        fields: {
          sourceFile: {
            validate: (0, _utils.assertValueType)("string")
          },
          sourceType: {
            validate: (0, _utils.assertOneOf)("script", "module"),
            default: "script"
          },
          interpreter: {
            validate: (0, _utils.assertNodeType)("InterpreterDirective"),
            default: null,
            optional: true
          },
          directives: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Directive"))),
            default: []
          },
          body: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
          }
        },
        aliases: ["Scopable", "BlockParent", "Block"]
      });
      defineType("ObjectExpression", {
        visitor: ["properties"],
        aliases: ["Expression"],
        fields: {
          properties: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ObjectMethod", "ObjectProperty", "SpreadElement")))
          }
        }
      });
      defineType("ObjectMethod", {
        builder: ["kind", "key", "params", "body", "computed", "generator", "async"],
        fields: Object.assign({}, functionCommon(), functionTypeAnnotationCommon(), {
          kind: Object.assign({
            validate: (0, _utils.assertOneOf)("method", "get", "set")
          }, !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
            default: "method"
          } : {}),
          computed: {
            default: false
          },
          key: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = function(node, key, val) {
                const validator2 = node.computed ? computed : normal;
                validator2(node, key, val);
              };
              validator.oneOfNodeTypes = ["Expression", "Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral"];
              return validator;
            }()
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        }),
        visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
        aliases: ["UserWhitespacable", "Function", "Scopable", "BlockParent", "FunctionParent", "Method", "ObjectMember"]
      });
      defineType("ObjectProperty", {
        builder: ["key", "value", "computed", "shorthand", ...!define_process_default.env.BABEL_TYPES_8_BREAKING ? ["decorators"] : []],
        fields: {
          computed: {
            default: false
          },
          key: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "PrivateName");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = Object.assign(function(node, key, val) {
                const validator2 = node.computed ? computed : normal;
                validator2(node, key, val);
              }, {
                oneOfNodeTypes: ["Expression", "Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "PrivateName"]
              });
              return validator;
            }()
          },
          value: {
            validate: (0, _utils.assertNodeType)("Expression", "PatternLike")
          },
          shorthand: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("boolean"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (val && node.computed) {
                throw new TypeError("Property shorthand of ObjectProperty cannot be true if computed is true");
              }
            }, {
              type: "boolean"
            }), function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (val && !(0, _is.default)("Identifier", node.key)) {
                throw new TypeError("Property shorthand of ObjectProperty cannot be true if key is not an Identifier");
              }
            }),
            default: false
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          }
        },
        visitor: ["key", "value", "decorators"],
        aliases: ["UserWhitespacable", "Property", "ObjectMember"],
        validate: function() {
          const pattern = (0, _utils.assertNodeType)("Identifier", "Pattern", "TSAsExpression", "TSSatisfiesExpression", "TSNonNullExpression", "TSTypeAssertion");
          const expression = (0, _utils.assertNodeType)("Expression");
          return function(parent2, key, node) {
            if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
              return;
            const validator = (0, _is.default)("ObjectPattern", parent2) ? pattern : expression;
            validator(node, "value", node.value);
          };
        }()
      });
      defineType("RestElement", {
        visitor: ["argument", "typeAnnotation"],
        builder: ["argument"],
        aliases: ["LVal", "PatternLike"],
        deprecatedAlias: "RestProperty",
        fields: Object.assign({}, patternLikeCommon(), {
          argument: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("LVal") : (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern", "MemberExpression", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          optional: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        }),
        validate(parent2, key) {
          if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
            return;
          const match = /(\w+)\[(\d+)\]/.exec(key);
          if (!match)
            throw new Error("Internal Babel error: malformed key.");
          const [, listKey, index] = match;
          if (parent2[listKey].length > +index + 1) {
            throw new TypeError(`RestElement must be last element of ${listKey}`);
          }
        }
      });
      defineType("ReturnStatement", {
        visitor: ["argument"],
        aliases: ["Statement", "Terminatorless", "CompletionStatement"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          }
        }
      });
      defineType("SequenceExpression", {
        visitor: ["expressions"],
        fields: {
          expressions: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression")))
          }
        },
        aliases: ["Expression"]
      });
      defineType("ParenthesizedExpression", {
        visitor: ["expression"],
        aliases: ["Expression", "ExpressionWrapper"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("SwitchCase", {
        visitor: ["test", "consequent"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          consequent: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
          }
        }
      });
      defineType("SwitchStatement", {
        visitor: ["discriminant", "cases"],
        aliases: ["Statement", "BlockParent", "Scopable"],
        fields: {
          discriminant: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          cases: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("SwitchCase")))
          }
        }
      });
      defineType("ThisExpression", {
        aliases: ["Expression"]
      });
      defineType("ThrowStatement", {
        visitor: ["argument"],
        aliases: ["Statement", "Terminatorless", "CompletionStatement"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("TryStatement", {
        visitor: ["block", "handler", "finalizer"],
        aliases: ["Statement"],
        fields: {
          block: {
            validate: (0, _utils.chain)((0, _utils.assertNodeType)("BlockStatement"), Object.assign(function(node) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (!node.handler && !node.finalizer) {
                throw new TypeError("TryStatement expects either a handler or finalizer, or both");
              }
            }, {
              oneOfNodeTypes: ["BlockStatement"]
            }))
          },
          handler: {
            optional: true,
            validate: (0, _utils.assertNodeType)("CatchClause")
          },
          finalizer: {
            optional: true,
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        }
      });
      defineType("UnaryExpression", {
        builder: ["operator", "argument", "prefix"],
        fields: {
          prefix: {
            default: true
          },
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          operator: {
            validate: (0, _utils.assertOneOf)(..._constants.UNARY_OPERATORS)
          }
        },
        visitor: ["argument"],
        aliases: ["UnaryLike", "Expression"]
      });
      defineType("UpdateExpression", {
        builder: ["operator", "argument", "prefix"],
        fields: {
          prefix: {
            default: false
          },
          argument: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertNodeType)("Expression") : (0, _utils.assertNodeType)("Identifier", "MemberExpression")
          },
          operator: {
            validate: (0, _utils.assertOneOf)(..._constants.UPDATE_OPERATORS)
          }
        },
        visitor: ["argument"],
        aliases: ["Expression"]
      });
      defineType("VariableDeclaration", {
        builder: ["kind", "declarations"],
        visitor: ["declarations"],
        aliases: ["Statement", "Declaration"],
        fields: {
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          kind: {
            validate: (0, _utils.assertOneOf)(
              "var",
              "let",
              "const",
              "using"
            )
          },
          declarations: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("VariableDeclarator")))
          }
        },
        validate(parent2, key, node) {
          if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
            return;
          if (!(0, _is.default)("ForXStatement", parent2, {
            left: node
          }))
            return;
          if (node.declarations.length !== 1) {
            throw new TypeError(`Exactly one VariableDeclarator is required in the VariableDeclaration of a ${parent2.type}`);
          }
        }
      });
      defineType("VariableDeclarator", {
        visitor: ["id", "init"],
        fields: {
          id: {
            validate: function() {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING) {
                return (0, _utils.assertNodeType)("LVal");
              }
              const normal = (0, _utils.assertNodeType)("Identifier", "ArrayPattern", "ObjectPattern");
              const without2 = (0, _utils.assertNodeType)("Identifier");
              return function(node, key, val) {
                const validator = node.init ? normal : without2;
                validator(node, key, val);
              };
            }()
          },
          definite: {
            optional: true,
            validate: (0, _utils.assertValueType)("boolean")
          },
          init: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("WhileStatement", {
        visitor: ["test", "body"],
        aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"],
        fields: {
          test: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("WithStatement", {
        visitor: ["object", "body"],
        aliases: ["Statement"],
        fields: {
          object: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          }
        }
      });
      defineType("AssignmentPattern", {
        visitor: ["left", "right", "decorators"],
        builder: ["left", "right"],
        aliases: ["Pattern", "PatternLike", "LVal"],
        fields: Object.assign({}, patternLikeCommon(), {
          left: {
            validate: (0, _utils.assertNodeType)("Identifier", "ObjectPattern", "ArrayPattern", "MemberExpression", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression")
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          }
        })
      });
      defineType("ArrayPattern", {
        visitor: ["elements", "typeAnnotation"],
        builder: ["elements"],
        aliases: ["Pattern", "PatternLike", "LVal"],
        fields: Object.assign({}, patternLikeCommon(), {
          elements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeOrValueType)("null", "PatternLike", "LVal")))
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          optional: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        })
      });
      defineType("ArrowFunctionExpression", {
        builder: ["params", "body", "async"],
        visitor: ["params", "body", "returnType", "typeParameters"],
        aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
        fields: Object.assign({}, functionCommon(), functionTypeAnnotationCommon(), {
          expression: {
            validate: (0, _utils.assertValueType)("boolean")
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement", "Expression")
          },
          predicate: {
            validate: (0, _utils.assertNodeType)("DeclaredPredicate", "InferredPredicate"),
            optional: true
          }
        })
      });
      defineType("ClassBody", {
        visitor: ["body"],
        fields: {
          body: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ClassMethod", "ClassPrivateMethod", "ClassProperty", "ClassPrivateProperty", "ClassAccessorProperty", "TSDeclareMethod", "TSIndexSignature", "StaticBlock")))
          }
        }
      });
      defineType("ClassExpression", {
        builder: ["id", "superClass", "body", "decorators"],
        visitor: ["id", "body", "superClass", "mixins", "typeParameters", "superTypeParameters", "implements", "decorators"],
        aliases: ["Scopable", "Class", "Expression"],
        fields: {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier"),
            optional: true
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)(
              "TypeParameterDeclaration",
              "TSTypeParameterDeclaration",
              "Noop"
            ),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("ClassBody")
          },
          superClass: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          },
          superTypeParameters: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          },
          implements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSExpressionWithTypeArguments", "ClassImplements"))),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          mixins: {
            validate: (0, _utils.assertNodeType)("InterfaceExtends"),
            optional: true
          }
        }
      });
      defineType("ClassDeclaration", {
        inherits: "ClassExpression",
        aliases: ["Scopable", "Class", "Statement", "Declaration"],
        fields: {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)(
              "TypeParameterDeclaration",
              "TSTypeParameterDeclaration",
              "Noop"
            ),
            optional: true
          },
          body: {
            validate: (0, _utils.assertNodeType)("ClassBody")
          },
          superClass: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          },
          superTypeParameters: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          },
          implements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSExpressionWithTypeArguments", "ClassImplements"))),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          mixins: {
            validate: (0, _utils.assertNodeType)("InterfaceExtends"),
            optional: true
          },
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          abstract: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        },
        validate: function() {
          const identifier3 = (0, _utils.assertNodeType)("Identifier");
          return function(parent2, key, node) {
            if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
              return;
            if (!(0, _is.default)("ExportDefaultDeclaration", parent2)) {
              identifier3(node, "id", node.id);
            }
          };
        }()
      });
      defineType("ExportAllDeclaration", {
        visitor: ["source"],
        aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
        fields: {
          source: {
            validate: (0, _utils.assertNodeType)("StringLiteral")
          },
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("type", "value")),
          assertions: {
            optional: true,
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ImportAttribute")))
          }
        }
      });
      defineType("ExportDefaultDeclaration", {
        visitor: ["declaration"],
        aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
        fields: {
          declaration: {
            validate: (0, _utils.assertNodeType)("TSDeclareFunction", "FunctionDeclaration", "ClassDeclaration", "Expression")
          },
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("value"))
        }
      });
      defineType("ExportNamedDeclaration", {
        visitor: ["declaration", "specifiers", "source"],
        aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
        fields: {
          declaration: {
            optional: true,
            validate: (0, _utils.chain)((0, _utils.assertNodeType)("Declaration"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (val && node.specifiers.length) {
                throw new TypeError("Only declaration or specifiers is allowed on ExportNamedDeclaration");
              }
            }, {
              oneOfNodeTypes: ["Declaration"]
            }), function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (val && node.source) {
                throw new TypeError("Cannot export a declaration from a source");
              }
            })
          },
          assertions: {
            optional: true,
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ImportAttribute")))
          },
          specifiers: {
            default: [],
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)(function() {
              const sourced = (0, _utils.assertNodeType)("ExportSpecifier", "ExportDefaultSpecifier", "ExportNamespaceSpecifier");
              const sourceless = (0, _utils.assertNodeType)("ExportSpecifier");
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return sourced;
              return function(node, key, val) {
                const validator = node.source ? sourced : sourceless;
                validator(node, key, val);
              };
            }()))
          },
          source: {
            validate: (0, _utils.assertNodeType)("StringLiteral"),
            optional: true
          },
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("type", "value"))
        }
      });
      defineType("ExportSpecifier", {
        visitor: ["local", "exported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          exported: {
            validate: (0, _utils.assertNodeType)("Identifier", "StringLiteral")
          },
          exportKind: {
            validate: (0, _utils.assertOneOf)("type", "value"),
            optional: true
          }
        }
      });
      defineType("ForOfStatement", {
        visitor: ["left", "right", "body"],
        builder: ["left", "right", "body", "await"],
        aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
        fields: {
          left: {
            validate: function() {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING) {
                return (0, _utils.assertNodeType)("VariableDeclaration", "LVal");
              }
              const declaration = (0, _utils.assertNodeType)("VariableDeclaration");
              const lval = (0, _utils.assertNodeType)("Identifier", "MemberExpression", "ArrayPattern", "ObjectPattern", "TSAsExpression", "TSSatisfiesExpression", "TSTypeAssertion", "TSNonNullExpression");
              return function(node, key, val) {
                if ((0, _is.default)("VariableDeclaration", val)) {
                  declaration(node, key, val);
                } else {
                  lval(node, key, val);
                }
              };
            }()
          },
          right: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          body: {
            validate: (0, _utils.assertNodeType)("Statement")
          },
          await: {
            default: false
          }
        }
      });
      defineType("ImportDeclaration", {
        visitor: ["specifiers", "source"],
        aliases: ["Statement", "Declaration", "ModuleDeclaration"],
        fields: {
          assertions: {
            optional: true,
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ImportAttribute")))
          },
          module: {
            optional: true,
            validate: (0, _utils.assertValueType)("boolean")
          },
          specifiers: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ImportSpecifier", "ImportDefaultSpecifier", "ImportNamespaceSpecifier")))
          },
          source: {
            validate: (0, _utils.assertNodeType)("StringLiteral")
          },
          importKind: {
            validate: (0, _utils.assertOneOf)("type", "typeof", "value"),
            optional: true
          }
        }
      });
      defineType("ImportDefaultSpecifier", {
        visitor: ["local"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("ImportNamespaceSpecifier", {
        visitor: ["local"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("ImportSpecifier", {
        visitor: ["local", "imported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          local: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          imported: {
            validate: (0, _utils.assertNodeType)("Identifier", "StringLiteral")
          },
          importKind: {
            validate: (0, _utils.assertOneOf)("type", "typeof", "value"),
            optional: true
          }
        }
      });
      defineType("MetaProperty", {
        visitor: ["meta", "property"],
        aliases: ["Expression"],
        fields: {
          meta: {
            validate: (0, _utils.chain)((0, _utils.assertNodeType)("Identifier"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              let property2;
              switch (val.name) {
                case "function":
                  property2 = "sent";
                  break;
                case "new":
                  property2 = "target";
                  break;
                case "import":
                  property2 = "meta";
                  break;
              }
              if (!(0, _is.default)("Identifier", node.property, {
                name: property2
              })) {
                throw new TypeError("Unrecognised MetaProperty");
              }
            }, {
              oneOfNodeTypes: ["Identifier"]
            }))
          },
          property: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      var classMethodOrPropertyCommon = () => ({
        abstract: {
          validate: (0, _utils.assertValueType)("boolean"),
          optional: true
        },
        accessibility: {
          validate: (0, _utils.assertOneOf)("public", "private", "protected"),
          optional: true
        },
        static: {
          default: false
        },
        override: {
          default: false
        },
        computed: {
          default: false
        },
        optional: {
          validate: (0, _utils.assertValueType)("boolean"),
          optional: true
        },
        key: {
          validate: (0, _utils.chain)(function() {
            const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral");
            const computed = (0, _utils.assertNodeType)("Expression");
            return function(node, key, val) {
              const validator = node.computed ? computed : normal;
              validator(node, key, val);
            };
          }(), (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "Expression"))
        }
      });
      exports2.classMethodOrPropertyCommon = classMethodOrPropertyCommon;
      var classMethodOrDeclareMethodCommon = () => Object.assign({}, functionCommon(), classMethodOrPropertyCommon(), {
        params: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Identifier", "Pattern", "RestElement", "TSParameterProperty")))
        },
        kind: {
          validate: (0, _utils.assertOneOf)("get", "set", "method", "constructor"),
          default: "method"
        },
        access: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("string"), (0, _utils.assertOneOf)("public", "private", "protected")),
          optional: true
        },
        decorators: {
          validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
          optional: true
        }
      });
      exports2.classMethodOrDeclareMethodCommon = classMethodOrDeclareMethodCommon;
      defineType("ClassMethod", {
        aliases: ["Function", "Scopable", "BlockParent", "FunctionParent", "Method"],
        builder: ["kind", "key", "params", "body", "computed", "static", "generator", "async"],
        visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
        fields: Object.assign({}, classMethodOrDeclareMethodCommon(), functionTypeAnnotationCommon(), {
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        })
      });
      defineType("ObjectPattern", {
        visitor: ["properties", "typeAnnotation", "decorators"],
        builder: ["properties"],
        aliases: ["Pattern", "PatternLike", "LVal"],
        fields: Object.assign({}, patternLikeCommon(), {
          properties: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("RestElement", "ObjectProperty")))
          }
        })
      });
      defineType("SpreadElement", {
        visitor: ["argument"],
        aliases: ["UnaryLike"],
        deprecatedAlias: "SpreadProperty",
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("Super", {
        aliases: ["Expression"]
      });
      defineType("TaggedTemplateExpression", {
        visitor: ["tag", "quasi", "typeParameters"],
        builder: ["tag", "quasi"],
        aliases: ["Expression"],
        fields: {
          tag: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          quasi: {
            validate: (0, _utils.assertNodeType)("TemplateLiteral")
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          }
        }
      });
      defineType("TemplateElement", {
        builder: ["value", "tail"],
        fields: {
          value: {
            validate: (0, _utils.chain)((0, _utils.assertShape)({
              raw: {
                validate: (0, _utils.assertValueType)("string")
              },
              cooked: {
                validate: (0, _utils.assertValueType)("string"),
                optional: true
              }
            }), function templateElementCookedValidator(node) {
              const raw = node.value.raw;
              let unterminatedCalled = false;
              const error = () => {
                throw new Error("Internal @babel/types error.");
              };
              const {
                str,
                firstInvalidLoc
              } = (0, _helperStringParser.readStringContents)("template", raw, 0, 0, 0, {
                unterminated() {
                  unterminatedCalled = true;
                },
                strictNumericEscape: error,
                invalidEscapeSequence: error,
                numericSeparatorInEscapeSequence: error,
                unexpectedNumericSeparator: error,
                invalidDigit: error,
                invalidCodePoint: error
              });
              if (!unterminatedCalled)
                throw new Error("Invalid raw");
              node.value.cooked = firstInvalidLoc ? null : str;
            })
          },
          tail: {
            default: false
          }
        }
      });
      defineType("TemplateLiteral", {
        visitor: ["quasis", "expressions"],
        aliases: ["Expression", "Literal"],
        fields: {
          quasis: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TemplateElement")))
          },
          expressions: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)(
              "Expression",
              "TSType"
            )), function(node, key, val) {
              if (node.quasis.length !== val.length + 1) {
                throw new TypeError(`Number of ${node.type} quasis should be exactly one more than the number of expressions.
Expected ${val.length + 1} quasis but got ${node.quasis.length}`);
              }
            })
          }
        }
      });
      defineType("YieldExpression", {
        builder: ["argument", "delegate"],
        visitor: ["argument"],
        aliases: ["Expression", "Terminatorless"],
        fields: {
          delegate: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("boolean"), Object.assign(function(node, key, val) {
              if (!define_process_default.env.BABEL_TYPES_8_BREAKING)
                return;
              if (val && !node.argument) {
                throw new TypeError("Property delegate of YieldExpression cannot be true if there is no argument");
              }
            }, {
              type: "boolean"
            })),
            default: false
          },
          argument: {
            optional: true,
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("AwaitExpression", {
        builder: ["argument"],
        visitor: ["argument"],
        aliases: ["Expression", "Terminatorless"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("Import", {
        aliases: ["Expression"]
      });
      defineType("BigIntLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      defineType("ExportNamespaceSpecifier", {
        visitor: ["exported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          exported: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("OptionalMemberExpression", {
        builder: ["object", "property", "computed", "optional"],
        visitor: ["object", "property"],
        aliases: ["Expression"],
        fields: {
          object: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          property: {
            validate: function() {
              const normal = (0, _utils.assertNodeType)("Identifier");
              const computed = (0, _utils.assertNodeType)("Expression");
              const validator = Object.assign(
                function(node, key, val) {
                  const validator2 = node.computed ? computed : normal;
                  validator2(node, key, val);
                },
                {
                  oneOfNodeTypes: ["Expression", "Identifier"]
                }
              );
              return validator;
            }()
          },
          computed: {
            default: false
          },
          optional: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertValueType)("boolean") : (0, _utils.chain)((0, _utils.assertValueType)("boolean"), (0, _utils.assertOptionalChainStart)())
          }
        }
      });
      defineType("OptionalCallExpression", {
        visitor: ["callee", "arguments", "typeParameters", "typeArguments"],
        builder: ["callee", "arguments", "optional"],
        aliases: ["Expression"],
        fields: {
          callee: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          arguments: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression", "SpreadElement", "JSXNamespacedName", "ArgumentPlaceholder")))
          },
          optional: {
            validate: !define_process_default.env.BABEL_TYPES_8_BREAKING ? (0, _utils.assertValueType)("boolean") : (0, _utils.chain)((0, _utils.assertValueType)("boolean"), (0, _utils.assertOptionalChainStart)())
          },
          typeArguments: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation"),
            optional: true
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TSTypeParameterInstantiation"),
            optional: true
          }
        }
      });
      defineType("ClassProperty", {
        visitor: ["key", "value", "typeAnnotation", "decorators"],
        builder: ["key", "value", "typeAnnotation", "decorators", "computed", "static"],
        aliases: ["Property"],
        fields: Object.assign({}, classMethodOrPropertyCommon(), {
          value: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          definite: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)(
              "TypeAnnotation",
              "TSTypeAnnotation",
              "Noop"
            ),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          variance: {
            validate: (0, _utils.assertNodeType)("Variance"),
            optional: true
          }
        })
      });
      defineType("ClassAccessorProperty", {
        visitor: ["key", "value", "typeAnnotation", "decorators"],
        builder: ["key", "value", "typeAnnotation", "decorators", "computed", "static"],
        aliases: ["Property", "Accessor"],
        fields: Object.assign({}, classMethodOrPropertyCommon(), {
          key: {
            validate: (0, _utils.chain)(function() {
              const normal = (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "PrivateName");
              const computed = (0, _utils.assertNodeType)("Expression");
              return function(node, key, val) {
                const validator = node.computed ? computed : normal;
                validator(node, key, val);
              };
            }(), (0, _utils.assertNodeType)("Identifier", "StringLiteral", "NumericLiteral", "BigIntLiteral", "Expression", "PrivateName"))
          },
          value: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          definite: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)(
              "TypeAnnotation",
              "TSTypeAnnotation",
              "Noop"
            ),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          declare: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          variance: {
            validate: (0, _utils.assertNodeType)("Variance"),
            optional: true
          }
        })
      });
      defineType("ClassPrivateProperty", {
        visitor: ["key", "value", "decorators", "typeAnnotation"],
        builder: ["key", "value", "decorators", "static"],
        aliases: ["Property", "Private"],
        fields: {
          key: {
            validate: (0, _utils.assertNodeType)("PrivateName")
          },
          value: {
            validate: (0, _utils.assertNodeType)("Expression"),
            optional: true
          },
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)(
              "TypeAnnotation",
              "TSTypeAnnotation",
              "Noop"
            ),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          },
          static: {
            validate: (0, _utils.assertValueType)("boolean"),
            default: false
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          definite: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          variance: {
            validate: (0, _utils.assertNodeType)("Variance"),
            optional: true
          }
        }
      });
      defineType("ClassPrivateMethod", {
        builder: ["kind", "key", "params", "body", "static"],
        visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
        aliases: ["Function", "Scopable", "BlockParent", "FunctionParent", "Method", "Private"],
        fields: Object.assign({}, classMethodOrDeclareMethodCommon(), functionTypeAnnotationCommon(), {
          kind: {
            validate: (0, _utils.assertOneOf)("get", "set", "method"),
            default: "method"
          },
          key: {
            validate: (0, _utils.assertNodeType)("PrivateName")
          },
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          }
        })
      });
      defineType("PrivateName", {
        visitor: ["id"],
        aliases: ["Private"],
        fields: {
          id: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      defineType("StaticBlock", {
        visitor: ["body"],
        fields: {
          body: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Statement")))
          }
        },
        aliases: ["Scopable", "BlockParent", "FunctionParent"]
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/flow.js
  var require_flow = __commonJS({
    "node_modules/@babel/types/lib/definitions/flow.js"() {
      "use strict";
      init_define_process();
      var _utils = require_utils3();
      var defineType = (0, _utils.defineAliasedType)("Flow");
      var defineInterfaceishType = (name) => {
        defineType(name, {
          builder: ["id", "typeParameters", "extends", "body"],
          visitor: ["id", "typeParameters", "extends", "mixins", "implements", "body"],
          aliases: ["FlowDeclaration", "Statement", "Declaration"],
          fields: {
            id: (0, _utils.validateType)("Identifier"),
            typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
            extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
            mixins: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
            implements: (0, _utils.validateOptional)((0, _utils.arrayOfType)("ClassImplements")),
            body: (0, _utils.validateType)("ObjectTypeAnnotation")
          }
        });
      };
      defineType("AnyTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ArrayTypeAnnotation", {
        visitor: ["elementType"],
        aliases: ["FlowType"],
        fields: {
          elementType: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("BooleanTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("BooleanLiteralTypeAnnotation", {
        builder: ["value"],
        aliases: ["FlowType"],
        fields: {
          value: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("NullLiteralTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ClassImplements", {
        visitor: ["id", "typeParameters"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
        }
      });
      defineInterfaceishType("DeclareClass");
      defineType("DeclareFunction", {
        visitor: ["id"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          predicate: (0, _utils.validateOptionalType)("DeclaredPredicate")
        }
      });
      defineInterfaceishType("DeclareInterface");
      defineType("DeclareModule", {
        builder: ["id", "body", "kind"],
        visitor: ["id", "body"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
          body: (0, _utils.validateType)("BlockStatement"),
          kind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("CommonJS", "ES"))
        }
      });
      defineType("DeclareModuleExports", {
        visitor: ["typeAnnotation"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TypeAnnotation")
        }
      });
      defineType("DeclareTypeAlias", {
        visitor: ["id", "typeParameters", "right"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          right: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("DeclareOpaqueType", {
        visitor: ["id", "typeParameters", "supertype"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          supertype: (0, _utils.validateOptionalType)("FlowType"),
          impltype: (0, _utils.validateOptionalType)("FlowType")
        }
      });
      defineType("DeclareVariable", {
        visitor: ["id"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier")
        }
      });
      defineType("DeclareExportDeclaration", {
        visitor: ["declaration", "specifiers", "source"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          declaration: (0, _utils.validateOptionalType)("Flow"),
          specifiers: (0, _utils.validateOptional)((0, _utils.arrayOfType)(["ExportSpecifier", "ExportNamespaceSpecifier"])),
          source: (0, _utils.validateOptionalType)("StringLiteral"),
          default: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("DeclareExportAllDeclaration", {
        visitor: ["source"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          source: (0, _utils.validateType)("StringLiteral"),
          exportKind: (0, _utils.validateOptional)((0, _utils.assertOneOf)("type", "value"))
        }
      });
      defineType("DeclaredPredicate", {
        visitor: ["value"],
        aliases: ["FlowPredicate"],
        fields: {
          value: (0, _utils.validateType)("Flow")
        }
      });
      defineType("ExistsTypeAnnotation", {
        aliases: ["FlowType"]
      });
      defineType("FunctionTypeAnnotation", {
        visitor: ["typeParameters", "params", "rest", "returnType"],
        aliases: ["FlowType"],
        fields: {
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          params: (0, _utils.validate)((0, _utils.arrayOfType)("FunctionTypeParam")),
          rest: (0, _utils.validateOptionalType)("FunctionTypeParam"),
          this: (0, _utils.validateOptionalType)("FunctionTypeParam"),
          returnType: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("FunctionTypeParam", {
        visitor: ["name", "typeAnnotation"],
        fields: {
          name: (0, _utils.validateOptionalType)("Identifier"),
          typeAnnotation: (0, _utils.validateType)("FlowType"),
          optional: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("GenericTypeAnnotation", {
        visitor: ["id", "typeParameters"],
        aliases: ["FlowType"],
        fields: {
          id: (0, _utils.validateType)(["Identifier", "QualifiedTypeIdentifier"]),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
        }
      });
      defineType("InferredPredicate", {
        aliases: ["FlowPredicate"]
      });
      defineType("InterfaceExtends", {
        visitor: ["id", "typeParameters"],
        fields: {
          id: (0, _utils.validateType)(["Identifier", "QualifiedTypeIdentifier"]),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterInstantiation")
        }
      });
      defineInterfaceishType("InterfaceDeclaration");
      defineType("InterfaceTypeAnnotation", {
        visitor: ["extends", "body"],
        aliases: ["FlowType"],
        fields: {
          extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("InterfaceExtends")),
          body: (0, _utils.validateType)("ObjectTypeAnnotation")
        }
      });
      defineType("IntersectionTypeAnnotation", {
        visitor: ["types"],
        aliases: ["FlowType"],
        fields: {
          types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("MixedTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("EmptyTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("NullableTypeAnnotation", {
        visitor: ["typeAnnotation"],
        aliases: ["FlowType"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("NumberLiteralTypeAnnotation", {
        builder: ["value"],
        aliases: ["FlowType"],
        fields: {
          value: (0, _utils.validate)((0, _utils.assertValueType)("number"))
        }
      });
      defineType("NumberTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ObjectTypeAnnotation", {
        visitor: ["properties", "indexers", "callProperties", "internalSlots"],
        aliases: ["FlowType"],
        builder: ["properties", "indexers", "callProperties", "internalSlots", "exact"],
        fields: {
          properties: (0, _utils.validate)((0, _utils.arrayOfType)(["ObjectTypeProperty", "ObjectTypeSpreadProperty"])),
          indexers: {
            validate: (0, _utils.arrayOfType)("ObjectTypeIndexer"),
            optional: true,
            default: []
          },
          callProperties: {
            validate: (0, _utils.arrayOfType)("ObjectTypeCallProperty"),
            optional: true,
            default: []
          },
          internalSlots: {
            validate: (0, _utils.arrayOfType)("ObjectTypeInternalSlot"),
            optional: true,
            default: []
          },
          exact: {
            validate: (0, _utils.assertValueType)("boolean"),
            default: false
          },
          inexact: (0, _utils.validateOptional)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeInternalSlot", {
        visitor: ["id", "value", "optional", "static", "method"],
        aliases: ["UserWhitespacable"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          value: (0, _utils.validateType)("FlowType"),
          optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          method: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeCallProperty", {
        visitor: ["value"],
        aliases: ["UserWhitespacable"],
        fields: {
          value: (0, _utils.validateType)("FlowType"),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeIndexer", {
        visitor: ["id", "key", "value", "variance"],
        aliases: ["UserWhitespacable"],
        fields: {
          id: (0, _utils.validateOptionalType)("Identifier"),
          key: (0, _utils.validateType)("FlowType"),
          value: (0, _utils.validateType)("FlowType"),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          variance: (0, _utils.validateOptionalType)("Variance")
        }
      });
      defineType("ObjectTypeProperty", {
        visitor: ["key", "value", "variance"],
        aliases: ["UserWhitespacable"],
        fields: {
          key: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
          value: (0, _utils.validateType)("FlowType"),
          kind: (0, _utils.validate)((0, _utils.assertOneOf)("init", "get", "set")),
          static: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          proto: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          variance: (0, _utils.validateOptionalType)("Variance"),
          method: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("ObjectTypeSpreadProperty", {
        visitor: ["argument"],
        aliases: ["UserWhitespacable"],
        fields: {
          argument: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("OpaqueType", {
        visitor: ["id", "typeParameters", "supertype", "impltype"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          supertype: (0, _utils.validateOptionalType)("FlowType"),
          impltype: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("QualifiedTypeIdentifier", {
        visitor: ["id", "qualification"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          qualification: (0, _utils.validateType)(["Identifier", "QualifiedTypeIdentifier"])
        }
      });
      defineType("StringLiteralTypeAnnotation", {
        builder: ["value"],
        aliases: ["FlowType"],
        fields: {
          value: (0, _utils.validate)((0, _utils.assertValueType)("string"))
        }
      });
      defineType("StringTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("SymbolTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("ThisTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("TupleTypeAnnotation", {
        visitor: ["types"],
        aliases: ["FlowType"],
        fields: {
          types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("TypeofTypeAnnotation", {
        visitor: ["argument"],
        aliases: ["FlowType"],
        fields: {
          argument: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("TypeAlias", {
        visitor: ["id", "typeParameters", "right"],
        aliases: ["FlowDeclaration", "Statement", "Declaration"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TypeParameterDeclaration"),
          right: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("TypeAnnotation", {
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("TypeCastExpression", {
        visitor: ["expression", "typeAnnotation"],
        aliases: ["ExpressionWrapper", "Expression"],
        fields: {
          expression: (0, _utils.validateType)("Expression"),
          typeAnnotation: (0, _utils.validateType)("TypeAnnotation")
        }
      });
      defineType("TypeParameter", {
        visitor: ["bound", "default", "variance"],
        fields: {
          name: (0, _utils.validate)((0, _utils.assertValueType)("string")),
          bound: (0, _utils.validateOptionalType)("TypeAnnotation"),
          default: (0, _utils.validateOptionalType)("FlowType"),
          variance: (0, _utils.validateOptionalType)("Variance")
        }
      });
      defineType("TypeParameterDeclaration", {
        visitor: ["params"],
        fields: {
          params: (0, _utils.validate)((0, _utils.arrayOfType)("TypeParameter"))
        }
      });
      defineType("TypeParameterInstantiation", {
        visitor: ["params"],
        fields: {
          params: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("UnionTypeAnnotation", {
        visitor: ["types"],
        aliases: ["FlowType"],
        fields: {
          types: (0, _utils.validate)((0, _utils.arrayOfType)("FlowType"))
        }
      });
      defineType("Variance", {
        builder: ["kind"],
        fields: {
          kind: (0, _utils.validate)((0, _utils.assertOneOf)("minus", "plus"))
        }
      });
      defineType("VoidTypeAnnotation", {
        aliases: ["FlowType", "FlowBaseAnnotation"]
      });
      defineType("EnumDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "body"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          body: (0, _utils.validateType)(["EnumBooleanBody", "EnumNumberBody", "EnumStringBody", "EnumSymbolBody"])
        }
      });
      defineType("EnumBooleanBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          explicitType: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          members: (0, _utils.validateArrayOfType)("EnumBooleanMember"),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumNumberBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          explicitType: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          members: (0, _utils.validateArrayOfType)("EnumNumberMember"),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumStringBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          explicitType: (0, _utils.validate)((0, _utils.assertValueType)("boolean")),
          members: (0, _utils.validateArrayOfType)(["EnumStringMember", "EnumDefaultedMember"]),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumSymbolBody", {
        aliases: ["EnumBody"],
        visitor: ["members"],
        fields: {
          members: (0, _utils.validateArrayOfType)("EnumDefaultedMember"),
          hasUnknownMembers: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
      defineType("EnumBooleanMember", {
        aliases: ["EnumMember"],
        visitor: ["id"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          init: (0, _utils.validateType)("BooleanLiteral")
        }
      });
      defineType("EnumNumberMember", {
        aliases: ["EnumMember"],
        visitor: ["id", "init"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          init: (0, _utils.validateType)("NumericLiteral")
        }
      });
      defineType("EnumStringMember", {
        aliases: ["EnumMember"],
        visitor: ["id", "init"],
        fields: {
          id: (0, _utils.validateType)("Identifier"),
          init: (0, _utils.validateType)("StringLiteral")
        }
      });
      defineType("EnumDefaultedMember", {
        aliases: ["EnumMember"],
        visitor: ["id"],
        fields: {
          id: (0, _utils.validateType)("Identifier")
        }
      });
      defineType("IndexedAccessType", {
        visitor: ["objectType", "indexType"],
        aliases: ["FlowType"],
        fields: {
          objectType: (0, _utils.validateType)("FlowType"),
          indexType: (0, _utils.validateType)("FlowType")
        }
      });
      defineType("OptionalIndexedAccessType", {
        visitor: ["objectType", "indexType"],
        aliases: ["FlowType"],
        fields: {
          objectType: (0, _utils.validateType)("FlowType"),
          indexType: (0, _utils.validateType)("FlowType"),
          optional: (0, _utils.validate)((0, _utils.assertValueType)("boolean"))
        }
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/jsx.js
  var require_jsx = __commonJS({
    "node_modules/@babel/types/lib/definitions/jsx.js"() {
      "use strict";
      init_define_process();
      var _utils = require_utils3();
      var defineType = (0, _utils.defineAliasedType)("JSX");
      defineType("JSXAttribute", {
        visitor: ["name", "value"],
        aliases: ["Immutable"],
        fields: {
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXNamespacedName")
          },
          value: {
            optional: true,
            validate: (0, _utils.assertNodeType)("JSXElement", "JSXFragment", "StringLiteral", "JSXExpressionContainer")
          }
        }
      });
      defineType("JSXClosingElement", {
        visitor: ["name"],
        aliases: ["Immutable"],
        fields: {
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXMemberExpression", "JSXNamespacedName")
          }
        }
      });
      defineType("JSXElement", {
        builder: ["openingElement", "closingElement", "children", "selfClosing"],
        visitor: ["openingElement", "children", "closingElement"],
        aliases: ["Immutable", "Expression"],
        fields: Object.assign({
          openingElement: {
            validate: (0, _utils.assertNodeType)("JSXOpeningElement")
          },
          closingElement: {
            optional: true,
            validate: (0, _utils.assertNodeType)("JSXClosingElement")
          },
          children: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement", "JSXFragment")))
          }
        }, {
          selfClosing: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          }
        })
      });
      defineType("JSXEmptyExpression", {});
      defineType("JSXExpressionContainer", {
        visitor: ["expression"],
        aliases: ["Immutable"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression", "JSXEmptyExpression")
          }
        }
      });
      defineType("JSXSpreadChild", {
        visitor: ["expression"],
        aliases: ["Immutable"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("JSXIdentifier", {
        builder: ["name"],
        fields: {
          name: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("JSXMemberExpression", {
        visitor: ["object", "property"],
        fields: {
          object: {
            validate: (0, _utils.assertNodeType)("JSXMemberExpression", "JSXIdentifier")
          },
          property: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier")
          }
        }
      });
      defineType("JSXNamespacedName", {
        visitor: ["namespace", "name"],
        fields: {
          namespace: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier")
          },
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier")
          }
        }
      });
      defineType("JSXOpeningElement", {
        builder: ["name", "attributes", "selfClosing"],
        visitor: ["name", "attributes"],
        aliases: ["Immutable"],
        fields: {
          name: {
            validate: (0, _utils.assertNodeType)("JSXIdentifier", "JSXMemberExpression", "JSXNamespacedName")
          },
          selfClosing: {
            default: false
          },
          attributes: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("JSXAttribute", "JSXSpreadAttribute")))
          },
          typeParameters: {
            validate: (0, _utils.assertNodeType)("TypeParameterInstantiation", "TSTypeParameterInstantiation"),
            optional: true
          }
        }
      });
      defineType("JSXSpreadAttribute", {
        visitor: ["argument"],
        fields: {
          argument: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      defineType("JSXText", {
        aliases: ["Immutable"],
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
      defineType("JSXFragment", {
        builder: ["openingFragment", "closingFragment", "children"],
        visitor: ["openingFragment", "children", "closingFragment"],
        aliases: ["Immutable", "Expression"],
        fields: {
          openingFragment: {
            validate: (0, _utils.assertNodeType)("JSXOpeningFragment")
          },
          closingFragment: {
            validate: (0, _utils.assertNodeType)("JSXClosingFragment")
          },
          children: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement", "JSXFragment")))
          }
        }
      });
      defineType("JSXOpeningFragment", {
        aliases: ["Immutable"]
      });
      defineType("JSXClosingFragment", {
        aliases: ["Immutable"]
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/placeholders.js
  var require_placeholders = __commonJS({
    "node_modules/@babel/types/lib/definitions/placeholders.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.PLACEHOLDERS_FLIPPED_ALIAS = exports2.PLACEHOLDERS_ALIAS = exports2.PLACEHOLDERS = void 0;
      var _utils = require_utils3();
      var PLACEHOLDERS = ["Identifier", "StringLiteral", "Expression", "Statement", "Declaration", "BlockStatement", "ClassBody", "Pattern"];
      exports2.PLACEHOLDERS = PLACEHOLDERS;
      var PLACEHOLDERS_ALIAS = {
        Declaration: ["Statement"],
        Pattern: ["PatternLike", "LVal"]
      };
      exports2.PLACEHOLDERS_ALIAS = PLACEHOLDERS_ALIAS;
      for (const type of PLACEHOLDERS) {
        const alias = _utils.ALIAS_KEYS[type];
        if (alias != null && alias.length)
          PLACEHOLDERS_ALIAS[type] = alias;
      }
      var PLACEHOLDERS_FLIPPED_ALIAS = {};
      exports2.PLACEHOLDERS_FLIPPED_ALIAS = PLACEHOLDERS_FLIPPED_ALIAS;
      Object.keys(PLACEHOLDERS_ALIAS).forEach((type) => {
        PLACEHOLDERS_ALIAS[type].forEach((alias) => {
          if (!Object.hasOwnProperty.call(PLACEHOLDERS_FLIPPED_ALIAS, alias)) {
            PLACEHOLDERS_FLIPPED_ALIAS[alias] = [];
          }
          PLACEHOLDERS_FLIPPED_ALIAS[alias].push(type);
        });
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/misc.js
  var require_misc = __commonJS({
    "node_modules/@babel/types/lib/definitions/misc.js"() {
      "use strict";
      init_define_process();
      var _utils = require_utils3();
      var _placeholders = require_placeholders();
      var defineType = (0, _utils.defineAliasedType)("Miscellaneous");
      {
        defineType("Noop", {
          visitor: []
        });
      }
      defineType("Placeholder", {
        visitor: [],
        builder: ["expectedNode", "name"],
        fields: {
          name: {
            validate: (0, _utils.assertNodeType)("Identifier")
          },
          expectedNode: {
            validate: (0, _utils.assertOneOf)(..._placeholders.PLACEHOLDERS)
          }
        }
      });
      defineType("V8IntrinsicIdentifier", {
        builder: ["name"],
        fields: {
          name: {
            validate: (0, _utils.assertValueType)("string")
          }
        }
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/experimental.js
  var require_experimental = __commonJS({
    "node_modules/@babel/types/lib/definitions/experimental.js"() {
      "use strict";
      init_define_process();
      var _utils = require_utils3();
      (0, _utils.default)("ArgumentPlaceholder", {});
      (0, _utils.default)("BindExpression", {
        visitor: ["object", "callee"],
        aliases: ["Expression"],
        fields: !define_process_default.env.BABEL_TYPES_8_BREAKING ? {
          object: {
            validate: Object.assign(() => {
            }, {
              oneOfNodeTypes: ["Expression"]
            })
          },
          callee: {
            validate: Object.assign(() => {
            }, {
              oneOfNodeTypes: ["Expression"]
            })
          }
        } : {
          object: {
            validate: (0, _utils.assertNodeType)("Expression")
          },
          callee: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      (0, _utils.default)("ImportAttribute", {
        visitor: ["key", "value"],
        fields: {
          key: {
            validate: (0, _utils.assertNodeType)("Identifier", "StringLiteral")
          },
          value: {
            validate: (0, _utils.assertNodeType)("StringLiteral")
          }
        }
      });
      (0, _utils.default)("Decorator", {
        visitor: ["expression"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        }
      });
      (0, _utils.default)("DoExpression", {
        visitor: ["body"],
        builder: ["body", "async"],
        aliases: ["Expression"],
        fields: {
          body: {
            validate: (0, _utils.assertNodeType)("BlockStatement")
          },
          async: {
            validate: (0, _utils.assertValueType)("boolean"),
            default: false
          }
        }
      });
      (0, _utils.default)("ExportDefaultSpecifier", {
        visitor: ["exported"],
        aliases: ["ModuleSpecifier"],
        fields: {
          exported: {
            validate: (0, _utils.assertNodeType)("Identifier")
          }
        }
      });
      (0, _utils.default)("RecordExpression", {
        visitor: ["properties"],
        aliases: ["Expression"],
        fields: {
          properties: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("ObjectProperty", "SpreadElement")))
          }
        }
      });
      (0, _utils.default)("TupleExpression", {
        fields: {
          elements: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Expression", "SpreadElement"))),
            default: []
          }
        },
        visitor: ["elements"],
        aliases: ["Expression"]
      });
      (0, _utils.default)("DecimalLiteral", {
        builder: ["value"],
        fields: {
          value: {
            validate: (0, _utils.assertValueType)("string")
          }
        },
        aliases: ["Expression", "Pureish", "Literal", "Immutable"]
      });
      (0, _utils.default)("ModuleExpression", {
        visitor: ["body"],
        fields: {
          body: {
            validate: (0, _utils.assertNodeType)("Program")
          }
        },
        aliases: ["Expression"]
      });
      (0, _utils.default)("TopicReference", {
        aliases: ["Expression"]
      });
      (0, _utils.default)("PipelineTopicExpression", {
        builder: ["expression"],
        visitor: ["expression"],
        fields: {
          expression: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Expression"]
      });
      (0, _utils.default)("PipelineBareFunction", {
        builder: ["callee"],
        visitor: ["callee"],
        fields: {
          callee: {
            validate: (0, _utils.assertNodeType)("Expression")
          }
        },
        aliases: ["Expression"]
      });
      (0, _utils.default)("PipelinePrimaryTopicReference", {
        aliases: ["Expression"]
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/typescript.js
  var require_typescript = __commonJS({
    "node_modules/@babel/types/lib/definitions/typescript.js"() {
      "use strict";
      init_define_process();
      var _utils = require_utils3();
      var _core = require_core();
      var _is = require_is();
      var defineType = (0, _utils.defineAliasedType)("TypeScript");
      var bool = (0, _utils.assertValueType)("boolean");
      var tSFunctionTypeAnnotationCommon = () => ({
        returnType: {
          validate: (0, _utils.assertNodeType)("TSTypeAnnotation", "Noop"),
          optional: true
        },
        typeParameters: {
          validate: (0, _utils.assertNodeType)("TSTypeParameterDeclaration", "Noop"),
          optional: true
        }
      });
      defineType("TSParameterProperty", {
        aliases: ["LVal"],
        visitor: ["parameter"],
        fields: {
          accessibility: {
            validate: (0, _utils.assertOneOf)("public", "private", "protected"),
            optional: true
          },
          readonly: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          parameter: {
            validate: (0, _utils.assertNodeType)("Identifier", "AssignmentPattern")
          },
          override: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          decorators: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("Decorator"))),
            optional: true
          }
        }
      });
      defineType("TSDeclareFunction", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "typeParameters", "params", "returnType"],
        fields: Object.assign({}, (0, _core.functionDeclarationCommon)(), tSFunctionTypeAnnotationCommon())
      });
      defineType("TSDeclareMethod", {
        visitor: ["decorators", "key", "typeParameters", "params", "returnType"],
        fields: Object.assign({}, (0, _core.classMethodOrDeclareMethodCommon)(), tSFunctionTypeAnnotationCommon())
      });
      defineType("TSQualifiedName", {
        aliases: ["TSEntityName"],
        visitor: ["left", "right"],
        fields: {
          left: (0, _utils.validateType)("TSEntityName"),
          right: (0, _utils.validateType)("Identifier")
        }
      });
      var signatureDeclarationCommon = () => ({
        typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
        ["parameters"]: (0, _utils.validateArrayOfType)(["Identifier", "RestElement"]),
        ["typeAnnotation"]: (0, _utils.validateOptionalType)("TSTypeAnnotation")
      });
      var callConstructSignatureDeclaration = {
        aliases: ["TSTypeElement"],
        visitor: ["typeParameters", "parameters", "typeAnnotation"],
        fields: signatureDeclarationCommon()
      };
      defineType("TSCallSignatureDeclaration", callConstructSignatureDeclaration);
      defineType("TSConstructSignatureDeclaration", callConstructSignatureDeclaration);
      var namedTypeElementCommon = () => ({
        key: (0, _utils.validateType)("Expression"),
        computed: {
          default: false
        },
        optional: (0, _utils.validateOptional)(bool)
      });
      defineType("TSPropertySignature", {
        aliases: ["TSTypeElement"],
        visitor: ["key", "typeAnnotation", "initializer"],
        fields: Object.assign({}, namedTypeElementCommon(), {
          readonly: (0, _utils.validateOptional)(bool),
          typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation"),
          initializer: (0, _utils.validateOptionalType)("Expression"),
          kind: {
            validate: (0, _utils.assertOneOf)("get", "set")
          }
        })
      });
      defineType("TSMethodSignature", {
        aliases: ["TSTypeElement"],
        visitor: ["key", "typeParameters", "parameters", "typeAnnotation"],
        fields: Object.assign({}, signatureDeclarationCommon(), namedTypeElementCommon(), {
          kind: {
            validate: (0, _utils.assertOneOf)("method", "get", "set")
          }
        })
      });
      defineType("TSIndexSignature", {
        aliases: ["TSTypeElement"],
        visitor: ["parameters", "typeAnnotation"],
        fields: {
          readonly: (0, _utils.validateOptional)(bool),
          static: (0, _utils.validateOptional)(bool),
          parameters: (0, _utils.validateArrayOfType)("Identifier"),
          typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation")
        }
      });
      var tsKeywordTypes = ["TSAnyKeyword", "TSBooleanKeyword", "TSBigIntKeyword", "TSIntrinsicKeyword", "TSNeverKeyword", "TSNullKeyword", "TSNumberKeyword", "TSObjectKeyword", "TSStringKeyword", "TSSymbolKeyword", "TSUndefinedKeyword", "TSUnknownKeyword", "TSVoidKeyword"];
      for (const type of tsKeywordTypes) {
        defineType(type, {
          aliases: ["TSType", "TSBaseType"],
          visitor: [],
          fields: {}
        });
      }
      defineType("TSThisType", {
        aliases: ["TSType", "TSBaseType"],
        visitor: [],
        fields: {}
      });
      var fnOrCtrBase = {
        aliases: ["TSType"],
        visitor: ["typeParameters", "parameters", "typeAnnotation"]
      };
      defineType("TSFunctionType", Object.assign({}, fnOrCtrBase, {
        fields: signatureDeclarationCommon()
      }));
      defineType("TSConstructorType", Object.assign({}, fnOrCtrBase, {
        fields: Object.assign({}, signatureDeclarationCommon(), {
          abstract: (0, _utils.validateOptional)(bool)
        })
      }));
      defineType("TSTypeReference", {
        aliases: ["TSType"],
        visitor: ["typeName", "typeParameters"],
        fields: {
          typeName: (0, _utils.validateType)("TSEntityName"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      defineType("TSTypePredicate", {
        aliases: ["TSType"],
        visitor: ["parameterName", "typeAnnotation"],
        builder: ["parameterName", "typeAnnotation", "asserts"],
        fields: {
          parameterName: (0, _utils.validateType)(["Identifier", "TSThisType"]),
          typeAnnotation: (0, _utils.validateOptionalType)("TSTypeAnnotation"),
          asserts: (0, _utils.validateOptional)(bool)
        }
      });
      defineType("TSTypeQuery", {
        aliases: ["TSType"],
        visitor: ["exprName", "typeParameters"],
        fields: {
          exprName: (0, _utils.validateType)(["TSEntityName", "TSImportType"]),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      defineType("TSTypeLiteral", {
        aliases: ["TSType"],
        visitor: ["members"],
        fields: {
          members: (0, _utils.validateArrayOfType)("TSTypeElement")
        }
      });
      defineType("TSArrayType", {
        aliases: ["TSType"],
        visitor: ["elementType"],
        fields: {
          elementType: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSTupleType", {
        aliases: ["TSType"],
        visitor: ["elementTypes"],
        fields: {
          elementTypes: (0, _utils.validateArrayOfType)(["TSType", "TSNamedTupleMember"])
        }
      });
      defineType("TSOptionalType", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSRestType", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSNamedTupleMember", {
        visitor: ["label", "elementType"],
        builder: ["label", "elementType", "optional"],
        fields: {
          label: (0, _utils.validateType)("Identifier"),
          optional: {
            validate: bool,
            default: false
          },
          elementType: (0, _utils.validateType)("TSType")
        }
      });
      var unionOrIntersection = {
        aliases: ["TSType"],
        visitor: ["types"],
        fields: {
          types: (0, _utils.validateArrayOfType)("TSType")
        }
      };
      defineType("TSUnionType", unionOrIntersection);
      defineType("TSIntersectionType", unionOrIntersection);
      defineType("TSConditionalType", {
        aliases: ["TSType"],
        visitor: ["checkType", "extendsType", "trueType", "falseType"],
        fields: {
          checkType: (0, _utils.validateType)("TSType"),
          extendsType: (0, _utils.validateType)("TSType"),
          trueType: (0, _utils.validateType)("TSType"),
          falseType: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSInferType", {
        aliases: ["TSType"],
        visitor: ["typeParameter"],
        fields: {
          typeParameter: (0, _utils.validateType)("TSTypeParameter")
        }
      });
      defineType("TSParenthesizedType", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSTypeOperator", {
        aliases: ["TSType"],
        visitor: ["typeAnnotation"],
        fields: {
          operator: (0, _utils.validate)((0, _utils.assertValueType)("string")),
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSIndexedAccessType", {
        aliases: ["TSType"],
        visitor: ["objectType", "indexType"],
        fields: {
          objectType: (0, _utils.validateType)("TSType"),
          indexType: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSMappedType", {
        aliases: ["TSType"],
        visitor: ["typeParameter", "typeAnnotation", "nameType"],
        fields: {
          readonly: (0, _utils.validateOptional)((0, _utils.assertOneOf)(true, false, "+", "-")),
          typeParameter: (0, _utils.validateType)("TSTypeParameter"),
          optional: (0, _utils.validateOptional)((0, _utils.assertOneOf)(true, false, "+", "-")),
          typeAnnotation: (0, _utils.validateOptionalType)("TSType"),
          nameType: (0, _utils.validateOptionalType)("TSType")
        }
      });
      defineType("TSLiteralType", {
        aliases: ["TSType", "TSBaseType"],
        visitor: ["literal"],
        fields: {
          literal: {
            validate: function() {
              const unaryExpression = (0, _utils.assertNodeType)("NumericLiteral", "BigIntLiteral");
              const unaryOperator = (0, _utils.assertOneOf)("-");
              const literal = (0, _utils.assertNodeType)("NumericLiteral", "StringLiteral", "BooleanLiteral", "BigIntLiteral", "TemplateLiteral");
              function validator(parent2, key, node) {
                if ((0, _is.default)("UnaryExpression", node)) {
                  unaryOperator(node, "operator", node.operator);
                  unaryExpression(node, "argument", node.argument);
                } else {
                  literal(parent2, key, node);
                }
              }
              validator.oneOfNodeTypes = ["NumericLiteral", "StringLiteral", "BooleanLiteral", "BigIntLiteral", "TemplateLiteral", "UnaryExpression"];
              return validator;
            }()
          }
        }
      });
      defineType("TSExpressionWithTypeArguments", {
        aliases: ["TSType"],
        visitor: ["expression", "typeParameters"],
        fields: {
          expression: (0, _utils.validateType)("TSEntityName"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      defineType("TSInterfaceDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "typeParameters", "extends", "body"],
        fields: {
          declare: (0, _utils.validateOptional)(bool),
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
          extends: (0, _utils.validateOptional)((0, _utils.arrayOfType)("TSExpressionWithTypeArguments")),
          body: (0, _utils.validateType)("TSInterfaceBody")
        }
      });
      defineType("TSInterfaceBody", {
        visitor: ["body"],
        fields: {
          body: (0, _utils.validateArrayOfType)("TSTypeElement")
        }
      });
      defineType("TSTypeAliasDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "typeParameters", "typeAnnotation"],
        fields: {
          declare: (0, _utils.validateOptional)(bool),
          id: (0, _utils.validateType)("Identifier"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterDeclaration"),
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      });
      defineType("TSInstantiationExpression", {
        aliases: ["Expression"],
        visitor: ["expression", "typeParameters"],
        fields: {
          expression: (0, _utils.validateType)("Expression"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      var TSTypeExpression = {
        aliases: ["Expression", "LVal", "PatternLike"],
        visitor: ["expression", "typeAnnotation"],
        fields: {
          expression: (0, _utils.validateType)("Expression"),
          typeAnnotation: (0, _utils.validateType)("TSType")
        }
      };
      defineType("TSAsExpression", TSTypeExpression);
      defineType("TSSatisfiesExpression", TSTypeExpression);
      defineType("TSTypeAssertion", {
        aliases: ["Expression", "LVal", "PatternLike"],
        visitor: ["typeAnnotation", "expression"],
        fields: {
          typeAnnotation: (0, _utils.validateType)("TSType"),
          expression: (0, _utils.validateType)("Expression")
        }
      });
      defineType("TSEnumDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "members"],
        fields: {
          declare: (0, _utils.validateOptional)(bool),
          const: (0, _utils.validateOptional)(bool),
          id: (0, _utils.validateType)("Identifier"),
          members: (0, _utils.validateArrayOfType)("TSEnumMember"),
          initializer: (0, _utils.validateOptionalType)("Expression")
        }
      });
      defineType("TSEnumMember", {
        visitor: ["id", "initializer"],
        fields: {
          id: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
          initializer: (0, _utils.validateOptionalType)("Expression")
        }
      });
      defineType("TSModuleDeclaration", {
        aliases: ["Statement", "Declaration"],
        visitor: ["id", "body"],
        fields: {
          declare: (0, _utils.validateOptional)(bool),
          global: (0, _utils.validateOptional)(bool),
          id: (0, _utils.validateType)(["Identifier", "StringLiteral"]),
          body: (0, _utils.validateType)(["TSModuleBlock", "TSModuleDeclaration"])
        }
      });
      defineType("TSModuleBlock", {
        aliases: ["Scopable", "Block", "BlockParent", "FunctionParent"],
        visitor: ["body"],
        fields: {
          body: (0, _utils.validateArrayOfType)("Statement")
        }
      });
      defineType("TSImportType", {
        aliases: ["TSType"],
        visitor: ["argument", "qualifier", "typeParameters"],
        fields: {
          argument: (0, _utils.validateType)("StringLiteral"),
          qualifier: (0, _utils.validateOptionalType)("TSEntityName"),
          typeParameters: (0, _utils.validateOptionalType)("TSTypeParameterInstantiation")
        }
      });
      defineType("TSImportEqualsDeclaration", {
        aliases: ["Statement"],
        visitor: ["id", "moduleReference"],
        fields: {
          isExport: (0, _utils.validate)(bool),
          id: (0, _utils.validateType)("Identifier"),
          moduleReference: (0, _utils.validateType)(["TSEntityName", "TSExternalModuleReference"]),
          importKind: {
            validate: (0, _utils.assertOneOf)("type", "value"),
            optional: true
          }
        }
      });
      defineType("TSExternalModuleReference", {
        visitor: ["expression"],
        fields: {
          expression: (0, _utils.validateType)("StringLiteral")
        }
      });
      defineType("TSNonNullExpression", {
        aliases: ["Expression", "LVal", "PatternLike"],
        visitor: ["expression"],
        fields: {
          expression: (0, _utils.validateType)("Expression")
        }
      });
      defineType("TSExportAssignment", {
        aliases: ["Statement"],
        visitor: ["expression"],
        fields: {
          expression: (0, _utils.validateType)("Expression")
        }
      });
      defineType("TSNamespaceExportDeclaration", {
        aliases: ["Statement"],
        visitor: ["id"],
        fields: {
          id: (0, _utils.validateType)("Identifier")
        }
      });
      defineType("TSTypeAnnotation", {
        visitor: ["typeAnnotation"],
        fields: {
          typeAnnotation: {
            validate: (0, _utils.assertNodeType)("TSType")
          }
        }
      });
      defineType("TSTypeParameterInstantiation", {
        visitor: ["params"],
        fields: {
          params: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSType")))
          }
        }
      });
      defineType("TSTypeParameterDeclaration", {
        visitor: ["params"],
        fields: {
          params: {
            validate: (0, _utils.chain)((0, _utils.assertValueType)("array"), (0, _utils.assertEach)((0, _utils.assertNodeType)("TSTypeParameter")))
          }
        }
      });
      defineType("TSTypeParameter", {
        builder: ["constraint", "default", "name"],
        visitor: ["constraint", "default"],
        fields: {
          name: {
            validate: (0, _utils.assertValueType)("string")
          },
          in: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          out: {
            validate: (0, _utils.assertValueType)("boolean"),
            optional: true
          },
          constraint: {
            validate: (0, _utils.assertNodeType)("TSType"),
            optional: true
          },
          default: {
            validate: (0, _utils.assertNodeType)("TSType"),
            optional: true
          }
        }
      });
    }
  });

  // node_modules/@babel/types/lib/definitions/index.js
  var require_definitions = __commonJS({
    "node_modules/@babel/types/lib/definitions/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      Object.defineProperty(exports2, "ALIAS_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.ALIAS_KEYS;
        }
      });
      Object.defineProperty(exports2, "BUILDER_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.BUILDER_KEYS;
        }
      });
      Object.defineProperty(exports2, "DEPRECATED_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.DEPRECATED_KEYS;
        }
      });
      Object.defineProperty(exports2, "FLIPPED_ALIAS_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.FLIPPED_ALIAS_KEYS;
        }
      });
      Object.defineProperty(exports2, "NODE_FIELDS", {
        enumerable: true,
        get: function() {
          return _utils.NODE_FIELDS;
        }
      });
      Object.defineProperty(exports2, "NODE_PARENT_VALIDATIONS", {
        enumerable: true,
        get: function() {
          return _utils.NODE_PARENT_VALIDATIONS;
        }
      });
      Object.defineProperty(exports2, "PLACEHOLDERS", {
        enumerable: true,
        get: function() {
          return _placeholders.PLACEHOLDERS;
        }
      });
      Object.defineProperty(exports2, "PLACEHOLDERS_ALIAS", {
        enumerable: true,
        get: function() {
          return _placeholders.PLACEHOLDERS_ALIAS;
        }
      });
      Object.defineProperty(exports2, "PLACEHOLDERS_FLIPPED_ALIAS", {
        enumerable: true,
        get: function() {
          return _placeholders.PLACEHOLDERS_FLIPPED_ALIAS;
        }
      });
      exports2.TYPES = void 0;
      Object.defineProperty(exports2, "VISITOR_KEYS", {
        enumerable: true,
        get: function() {
          return _utils.VISITOR_KEYS;
        }
      });
      var _toFastProperties = require_to_fast_properties();
      require_core();
      require_flow();
      require_jsx();
      require_misc();
      require_experimental();
      require_typescript();
      var _utils = require_utils3();
      var _placeholders = require_placeholders();
      _toFastProperties(_utils.VISITOR_KEYS);
      _toFastProperties(_utils.ALIAS_KEYS);
      _toFastProperties(_utils.FLIPPED_ALIAS_KEYS);
      _toFastProperties(_utils.NODE_FIELDS);
      _toFastProperties(_utils.BUILDER_KEYS);
      _toFastProperties(_utils.DEPRECATED_KEYS);
      _toFastProperties(_placeholders.PLACEHOLDERS_ALIAS);
      _toFastProperties(_placeholders.PLACEHOLDERS_FLIPPED_ALIAS);
      var TYPES = [].concat(Object.keys(_utils.VISITOR_KEYS), Object.keys(_utils.FLIPPED_ALIAS_KEYS), Object.keys(_utils.DEPRECATED_KEYS));
      exports2.TYPES = TYPES;
    }
  });

  // node_modules/@babel/types/lib/validators/validate.js
  var require_validate = __commonJS({
    "node_modules/@babel/types/lib/validators/validate.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = validate;
      exports2.validateChild = validateChild;
      exports2.validateField = validateField;
      var _definitions = require_definitions();
      function validate(node, key, val) {
        if (!node)
          return;
        const fields = _definitions.NODE_FIELDS[node.type];
        if (!fields)
          return;
        const field = fields[key];
        validateField(node, key, val, field);
        validateChild(node, key, val);
      }
      function validateField(node, key, val, field) {
        if (!(field != null && field.validate))
          return;
        if (field.optional && val == null)
          return;
        field.validate(node, key, val);
      }
      function validateChild(node, key, val) {
        if (val == null)
          return;
        const validate2 = _definitions.NODE_PARENT_VALIDATIONS[val.type];
        if (!validate2)
          return;
        validate2(node, key, val);
      }
    }
  });

  // node_modules/@babel/types/lib/builders/validateNode.js
  var require_validateNode = __commonJS({
    "node_modules/@babel/types/lib/builders/validateNode.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = validateNode;
      var _validate = require_validate();
      var _ = require_lib5();
      function validateNode(node) {
        const keys2 = _.BUILDER_KEYS[node.type];
        for (const key of keys2) {
          (0, _validate.default)(node, key, node[key]);
        }
        return node;
      }
    }
  });

  // node_modules/@babel/types/lib/builders/generated/index.js
  var require_generated2 = __commonJS({
    "node_modules/@babel/types/lib/builders/generated/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.anyTypeAnnotation = anyTypeAnnotation;
      exports2.argumentPlaceholder = argumentPlaceholder;
      exports2.arrayExpression = arrayExpression;
      exports2.arrayPattern = arrayPattern;
      exports2.arrayTypeAnnotation = arrayTypeAnnotation;
      exports2.arrowFunctionExpression = arrowFunctionExpression2;
      exports2.assignmentExpression = assignmentExpression;
      exports2.assignmentPattern = assignmentPattern;
      exports2.awaitExpression = awaitExpression;
      exports2.bigIntLiteral = bigIntLiteral;
      exports2.binaryExpression = binaryExpression;
      exports2.bindExpression = bindExpression;
      exports2.blockStatement = blockStatement;
      exports2.booleanLiteral = booleanLiteral;
      exports2.booleanLiteralTypeAnnotation = booleanLiteralTypeAnnotation;
      exports2.booleanTypeAnnotation = booleanTypeAnnotation;
      exports2.breakStatement = breakStatement;
      exports2.callExpression = callExpression;
      exports2.catchClause = catchClause;
      exports2.classAccessorProperty = classAccessorProperty;
      exports2.classBody = classBody;
      exports2.classDeclaration = classDeclaration;
      exports2.classExpression = classExpression;
      exports2.classImplements = classImplements;
      exports2.classMethod = classMethod2;
      exports2.classPrivateMethod = classPrivateMethod;
      exports2.classPrivateProperty = classPrivateProperty;
      exports2.classProperty = classProperty;
      exports2.conditionalExpression = conditionalExpression;
      exports2.continueStatement = continueStatement;
      exports2.debuggerStatement = debuggerStatement;
      exports2.decimalLiteral = decimalLiteral;
      exports2.declareClass = declareClass;
      exports2.declareExportAllDeclaration = declareExportAllDeclaration;
      exports2.declareExportDeclaration = declareExportDeclaration;
      exports2.declareFunction = declareFunction;
      exports2.declareInterface = declareInterface;
      exports2.declareModule = declareModule;
      exports2.declareModuleExports = declareModuleExports;
      exports2.declareOpaqueType = declareOpaqueType;
      exports2.declareTypeAlias = declareTypeAlias;
      exports2.declareVariable = declareVariable;
      exports2.declaredPredicate = declaredPredicate;
      exports2.decorator = decorator;
      exports2.directive = directive;
      exports2.directiveLiteral = directiveLiteral;
      exports2.doExpression = doExpression;
      exports2.doWhileStatement = doWhileStatement;
      exports2.emptyStatement = emptyStatement;
      exports2.emptyTypeAnnotation = emptyTypeAnnotation;
      exports2.enumBooleanBody = enumBooleanBody;
      exports2.enumBooleanMember = enumBooleanMember;
      exports2.enumDeclaration = enumDeclaration;
      exports2.enumDefaultedMember = enumDefaultedMember;
      exports2.enumNumberBody = enumNumberBody;
      exports2.enumNumberMember = enumNumberMember;
      exports2.enumStringBody = enumStringBody;
      exports2.enumStringMember = enumStringMember;
      exports2.enumSymbolBody = enumSymbolBody;
      exports2.existsTypeAnnotation = existsTypeAnnotation;
      exports2.exportAllDeclaration = exportAllDeclaration;
      exports2.exportDefaultDeclaration = exportDefaultDeclaration;
      exports2.exportDefaultSpecifier = exportDefaultSpecifier;
      exports2.exportNamedDeclaration = exportNamedDeclaration;
      exports2.exportNamespaceSpecifier = exportNamespaceSpecifier;
      exports2.exportSpecifier = exportSpecifier;
      exports2.expressionStatement = expressionStatement2;
      exports2.file = file2;
      exports2.forInStatement = forInStatement;
      exports2.forOfStatement = forOfStatement;
      exports2.forStatement = forStatement;
      exports2.functionDeclaration = functionDeclaration;
      exports2.functionExpression = functionExpression;
      exports2.functionTypeAnnotation = functionTypeAnnotation;
      exports2.functionTypeParam = functionTypeParam;
      exports2.genericTypeAnnotation = genericTypeAnnotation;
      exports2.identifier = identifier3;
      exports2.ifStatement = ifStatement;
      exports2.import = _import;
      exports2.importAttribute = importAttribute;
      exports2.importDeclaration = importDeclaration;
      exports2.importDefaultSpecifier = importDefaultSpecifier;
      exports2.importNamespaceSpecifier = importNamespaceSpecifier;
      exports2.importSpecifier = importSpecifier;
      exports2.indexedAccessType = indexedAccessType;
      exports2.inferredPredicate = inferredPredicate;
      exports2.interfaceDeclaration = interfaceDeclaration;
      exports2.interfaceExtends = interfaceExtends;
      exports2.interfaceTypeAnnotation = interfaceTypeAnnotation;
      exports2.interpreterDirective = interpreterDirective;
      exports2.intersectionTypeAnnotation = intersectionTypeAnnotation;
      exports2.jSXAttribute = exports2.jsxAttribute = jsxAttribute;
      exports2.jSXClosingElement = exports2.jsxClosingElement = jsxClosingElement;
      exports2.jSXClosingFragment = exports2.jsxClosingFragment = jsxClosingFragment;
      exports2.jSXElement = exports2.jsxElement = jsxElement;
      exports2.jSXEmptyExpression = exports2.jsxEmptyExpression = jsxEmptyExpression;
      exports2.jSXExpressionContainer = exports2.jsxExpressionContainer = jsxExpressionContainer;
      exports2.jSXFragment = exports2.jsxFragment = jsxFragment;
      exports2.jSXIdentifier = exports2.jsxIdentifier = jsxIdentifier;
      exports2.jSXMemberExpression = exports2.jsxMemberExpression = jsxMemberExpression;
      exports2.jSXNamespacedName = exports2.jsxNamespacedName = jsxNamespacedName;
      exports2.jSXOpeningElement = exports2.jsxOpeningElement = jsxOpeningElement;
      exports2.jSXOpeningFragment = exports2.jsxOpeningFragment = jsxOpeningFragment;
      exports2.jSXSpreadAttribute = exports2.jsxSpreadAttribute = jsxSpreadAttribute;
      exports2.jSXSpreadChild = exports2.jsxSpreadChild = jsxSpreadChild;
      exports2.jSXText = exports2.jsxText = jsxText;
      exports2.labeledStatement = labeledStatement;
      exports2.logicalExpression = logicalExpression;
      exports2.memberExpression = memberExpression;
      exports2.metaProperty = metaProperty;
      exports2.mixedTypeAnnotation = mixedTypeAnnotation;
      exports2.moduleExpression = moduleExpression;
      exports2.newExpression = newExpression;
      exports2.noop = noop3;
      exports2.nullLiteral = nullLiteral;
      exports2.nullLiteralTypeAnnotation = nullLiteralTypeAnnotation;
      exports2.nullableTypeAnnotation = nullableTypeAnnotation;
      exports2.numberLiteral = NumberLiteral;
      exports2.numberLiteralTypeAnnotation = numberLiteralTypeAnnotation;
      exports2.numberTypeAnnotation = numberTypeAnnotation;
      exports2.numericLiteral = numericLiteral;
      exports2.objectExpression = objectExpression;
      exports2.objectMethod = objectMethod;
      exports2.objectPattern = objectPattern;
      exports2.objectProperty = objectProperty;
      exports2.objectTypeAnnotation = objectTypeAnnotation;
      exports2.objectTypeCallProperty = objectTypeCallProperty;
      exports2.objectTypeIndexer = objectTypeIndexer;
      exports2.objectTypeInternalSlot = objectTypeInternalSlot;
      exports2.objectTypeProperty = objectTypeProperty;
      exports2.objectTypeSpreadProperty = objectTypeSpreadProperty;
      exports2.opaqueType = opaqueType;
      exports2.optionalCallExpression = optionalCallExpression;
      exports2.optionalIndexedAccessType = optionalIndexedAccessType;
      exports2.optionalMemberExpression = optionalMemberExpression;
      exports2.parenthesizedExpression = parenthesizedExpression;
      exports2.pipelineBareFunction = pipelineBareFunction;
      exports2.pipelinePrimaryTopicReference = pipelinePrimaryTopicReference;
      exports2.pipelineTopicExpression = pipelineTopicExpression;
      exports2.placeholder = placeholder;
      exports2.privateName = privateName;
      exports2.program = program3;
      exports2.qualifiedTypeIdentifier = qualifiedTypeIdentifier;
      exports2.recordExpression = recordExpression;
      exports2.regExpLiteral = regExpLiteral;
      exports2.regexLiteral = RegexLiteral;
      exports2.restElement = restElement;
      exports2.restProperty = RestProperty;
      exports2.returnStatement = returnStatement;
      exports2.sequenceExpression = sequenceExpression;
      exports2.spreadElement = spreadElement;
      exports2.spreadProperty = SpreadProperty;
      exports2.staticBlock = staticBlock;
      exports2.stringLiteral = stringLiteral;
      exports2.stringLiteralTypeAnnotation = stringLiteralTypeAnnotation;
      exports2.stringTypeAnnotation = stringTypeAnnotation;
      exports2.super = _super;
      exports2.switchCase = switchCase;
      exports2.switchStatement = switchStatement;
      exports2.symbolTypeAnnotation = symbolTypeAnnotation;
      exports2.taggedTemplateExpression = taggedTemplateExpression;
      exports2.templateElement = templateElement;
      exports2.templateLiteral = templateLiteral;
      exports2.thisExpression = thisExpression;
      exports2.thisTypeAnnotation = thisTypeAnnotation;
      exports2.throwStatement = throwStatement;
      exports2.topicReference = topicReference;
      exports2.tryStatement = tryStatement;
      exports2.tSAnyKeyword = exports2.tsAnyKeyword = tsAnyKeyword;
      exports2.tSArrayType = exports2.tsArrayType = tsArrayType;
      exports2.tSAsExpression = exports2.tsAsExpression = tsAsExpression;
      exports2.tSBigIntKeyword = exports2.tsBigIntKeyword = tsBigIntKeyword;
      exports2.tSBooleanKeyword = exports2.tsBooleanKeyword = tsBooleanKeyword;
      exports2.tSCallSignatureDeclaration = exports2.tsCallSignatureDeclaration = tsCallSignatureDeclaration;
      exports2.tSConditionalType = exports2.tsConditionalType = tsConditionalType;
      exports2.tSConstructSignatureDeclaration = exports2.tsConstructSignatureDeclaration = tsConstructSignatureDeclaration;
      exports2.tSConstructorType = exports2.tsConstructorType = tsConstructorType;
      exports2.tSDeclareFunction = exports2.tsDeclareFunction = tsDeclareFunction;
      exports2.tSDeclareMethod = exports2.tsDeclareMethod = tsDeclareMethod;
      exports2.tSEnumDeclaration = exports2.tsEnumDeclaration = tsEnumDeclaration;
      exports2.tSEnumMember = exports2.tsEnumMember = tsEnumMember;
      exports2.tSExportAssignment = exports2.tsExportAssignment = tsExportAssignment;
      exports2.tSExpressionWithTypeArguments = exports2.tsExpressionWithTypeArguments = tsExpressionWithTypeArguments;
      exports2.tSExternalModuleReference = exports2.tsExternalModuleReference = tsExternalModuleReference;
      exports2.tSFunctionType = exports2.tsFunctionType = tsFunctionType;
      exports2.tSImportEqualsDeclaration = exports2.tsImportEqualsDeclaration = tsImportEqualsDeclaration;
      exports2.tSImportType = exports2.tsImportType = tsImportType;
      exports2.tSIndexSignature = exports2.tsIndexSignature = tsIndexSignature;
      exports2.tSIndexedAccessType = exports2.tsIndexedAccessType = tsIndexedAccessType;
      exports2.tSInferType = exports2.tsInferType = tsInferType;
      exports2.tSInstantiationExpression = exports2.tsInstantiationExpression = tsInstantiationExpression;
      exports2.tSInterfaceBody = exports2.tsInterfaceBody = tsInterfaceBody;
      exports2.tSInterfaceDeclaration = exports2.tsInterfaceDeclaration = tsInterfaceDeclaration;
      exports2.tSIntersectionType = exports2.tsIntersectionType = tsIntersectionType;
      exports2.tSIntrinsicKeyword = exports2.tsIntrinsicKeyword = tsIntrinsicKeyword;
      exports2.tSLiteralType = exports2.tsLiteralType = tsLiteralType;
      exports2.tSMappedType = exports2.tsMappedType = tsMappedType;
      exports2.tSMethodSignature = exports2.tsMethodSignature = tsMethodSignature;
      exports2.tSModuleBlock = exports2.tsModuleBlock = tsModuleBlock;
      exports2.tSModuleDeclaration = exports2.tsModuleDeclaration = tsModuleDeclaration;
      exports2.tSNamedTupleMember = exports2.tsNamedTupleMember = tsNamedTupleMember;
      exports2.tSNamespaceExportDeclaration = exports2.tsNamespaceExportDeclaration = tsNamespaceExportDeclaration;
      exports2.tSNeverKeyword = exports2.tsNeverKeyword = tsNeverKeyword;
      exports2.tSNonNullExpression = exports2.tsNonNullExpression = tsNonNullExpression;
      exports2.tSNullKeyword = exports2.tsNullKeyword = tsNullKeyword;
      exports2.tSNumberKeyword = exports2.tsNumberKeyword = tsNumberKeyword;
      exports2.tSObjectKeyword = exports2.tsObjectKeyword = tsObjectKeyword;
      exports2.tSOptionalType = exports2.tsOptionalType = tsOptionalType;
      exports2.tSParameterProperty = exports2.tsParameterProperty = tsParameterProperty;
      exports2.tSParenthesizedType = exports2.tsParenthesizedType = tsParenthesizedType;
      exports2.tSPropertySignature = exports2.tsPropertySignature = tsPropertySignature;
      exports2.tSQualifiedName = exports2.tsQualifiedName = tsQualifiedName;
      exports2.tSRestType = exports2.tsRestType = tsRestType;
      exports2.tSSatisfiesExpression = exports2.tsSatisfiesExpression = tsSatisfiesExpression;
      exports2.tSStringKeyword = exports2.tsStringKeyword = tsStringKeyword;
      exports2.tSSymbolKeyword = exports2.tsSymbolKeyword = tsSymbolKeyword;
      exports2.tSThisType = exports2.tsThisType = tsThisType;
      exports2.tSTupleType = exports2.tsTupleType = tsTupleType;
      exports2.tSTypeAliasDeclaration = exports2.tsTypeAliasDeclaration = tsTypeAliasDeclaration;
      exports2.tSTypeAnnotation = exports2.tsTypeAnnotation = tsTypeAnnotation;
      exports2.tSTypeAssertion = exports2.tsTypeAssertion = tsTypeAssertion;
      exports2.tSTypeLiteral = exports2.tsTypeLiteral = tsTypeLiteral;
      exports2.tSTypeOperator = exports2.tsTypeOperator = tsTypeOperator;
      exports2.tSTypeParameter = exports2.tsTypeParameter = tsTypeParameter;
      exports2.tSTypeParameterDeclaration = exports2.tsTypeParameterDeclaration = tsTypeParameterDeclaration;
      exports2.tSTypeParameterInstantiation = exports2.tsTypeParameterInstantiation = tsTypeParameterInstantiation;
      exports2.tSTypePredicate = exports2.tsTypePredicate = tsTypePredicate;
      exports2.tSTypeQuery = exports2.tsTypeQuery = tsTypeQuery;
      exports2.tSTypeReference = exports2.tsTypeReference = tsTypeReference;
      exports2.tSUndefinedKeyword = exports2.tsUndefinedKeyword = tsUndefinedKeyword;
      exports2.tSUnionType = exports2.tsUnionType = tsUnionType;
      exports2.tSUnknownKeyword = exports2.tsUnknownKeyword = tsUnknownKeyword;
      exports2.tSVoidKeyword = exports2.tsVoidKeyword = tsVoidKeyword;
      exports2.tupleExpression = tupleExpression;
      exports2.tupleTypeAnnotation = tupleTypeAnnotation;
      exports2.typeAlias = typeAlias;
      exports2.typeAnnotation = typeAnnotation;
      exports2.typeCastExpression = typeCastExpression;
      exports2.typeParameter = typeParameter;
      exports2.typeParameterDeclaration = typeParameterDeclaration;
      exports2.typeParameterInstantiation = typeParameterInstantiation;
      exports2.typeofTypeAnnotation = typeofTypeAnnotation;
      exports2.unaryExpression = unaryExpression;
      exports2.unionTypeAnnotation = unionTypeAnnotation;
      exports2.updateExpression = updateExpression;
      exports2.v8IntrinsicIdentifier = v8IntrinsicIdentifier;
      exports2.variableDeclaration = variableDeclaration;
      exports2.variableDeclarator = variableDeclarator;
      exports2.variance = variance;
      exports2.voidTypeAnnotation = voidTypeAnnotation;
      exports2.whileStatement = whileStatement;
      exports2.withStatement = withStatement;
      exports2.yieldExpression = yieldExpression;
      var _validateNode = require_validateNode();
      function arrayExpression(elements = []) {
        return (0, _validateNode.default)({
          type: "ArrayExpression",
          elements
        });
      }
      function assignmentExpression(operator, left, right) {
        return (0, _validateNode.default)({
          type: "AssignmentExpression",
          operator,
          left,
          right
        });
      }
      function binaryExpression(operator, left, right) {
        return (0, _validateNode.default)({
          type: "BinaryExpression",
          operator,
          left,
          right
        });
      }
      function interpreterDirective(value) {
        return (0, _validateNode.default)({
          type: "InterpreterDirective",
          value
        });
      }
      function directive(value) {
        return (0, _validateNode.default)({
          type: "Directive",
          value
        });
      }
      function directiveLiteral(value) {
        return (0, _validateNode.default)({
          type: "DirectiveLiteral",
          value
        });
      }
      function blockStatement(body, directives = []) {
        return (0, _validateNode.default)({
          type: "BlockStatement",
          body,
          directives
        });
      }
      function breakStatement(label = null) {
        return (0, _validateNode.default)({
          type: "BreakStatement",
          label
        });
      }
      function callExpression(callee, _arguments) {
        return (0, _validateNode.default)({
          type: "CallExpression",
          callee,
          arguments: _arguments
        });
      }
      function catchClause(param = null, body) {
        return (0, _validateNode.default)({
          type: "CatchClause",
          param,
          body
        });
      }
      function conditionalExpression(test, consequent, alternate) {
        return (0, _validateNode.default)({
          type: "ConditionalExpression",
          test,
          consequent,
          alternate
        });
      }
      function continueStatement(label = null) {
        return (0, _validateNode.default)({
          type: "ContinueStatement",
          label
        });
      }
      function debuggerStatement() {
        return {
          type: "DebuggerStatement"
        };
      }
      function doWhileStatement(test, body) {
        return (0, _validateNode.default)({
          type: "DoWhileStatement",
          test,
          body
        });
      }
      function emptyStatement() {
        return {
          type: "EmptyStatement"
        };
      }
      function expressionStatement2(expression) {
        return (0, _validateNode.default)({
          type: "ExpressionStatement",
          expression
        });
      }
      function file2(program4, comments = null, tokens = null) {
        return (0, _validateNode.default)({
          type: "File",
          program: program4,
          comments,
          tokens
        });
      }
      function forInStatement(left, right, body) {
        return (0, _validateNode.default)({
          type: "ForInStatement",
          left,
          right,
          body
        });
      }
      function forStatement(init = null, test = null, update2 = null, body) {
        return (0, _validateNode.default)({
          type: "ForStatement",
          init,
          test,
          update: update2,
          body
        });
      }
      function functionDeclaration(id = null, params, body, generator = false, async = false) {
        return (0, _validateNode.default)({
          type: "FunctionDeclaration",
          id,
          params,
          body,
          generator,
          async
        });
      }
      function functionExpression(id = null, params, body, generator = false, async = false) {
        return (0, _validateNode.default)({
          type: "FunctionExpression",
          id,
          params,
          body,
          generator,
          async
        });
      }
      function identifier3(name) {
        return (0, _validateNode.default)({
          type: "Identifier",
          name
        });
      }
      function ifStatement(test, consequent, alternate = null) {
        return (0, _validateNode.default)({
          type: "IfStatement",
          test,
          consequent,
          alternate
        });
      }
      function labeledStatement(label, body) {
        return (0, _validateNode.default)({
          type: "LabeledStatement",
          label,
          body
        });
      }
      function stringLiteral(value) {
        return (0, _validateNode.default)({
          type: "StringLiteral",
          value
        });
      }
      function numericLiteral(value) {
        return (0, _validateNode.default)({
          type: "NumericLiteral",
          value
        });
      }
      function nullLiteral() {
        return {
          type: "NullLiteral"
        };
      }
      function booleanLiteral(value) {
        return (0, _validateNode.default)({
          type: "BooleanLiteral",
          value
        });
      }
      function regExpLiteral(pattern, flags = "") {
        return (0, _validateNode.default)({
          type: "RegExpLiteral",
          pattern,
          flags
        });
      }
      function logicalExpression(operator, left, right) {
        return (0, _validateNode.default)({
          type: "LogicalExpression",
          operator,
          left,
          right
        });
      }
      function memberExpression(object, property2, computed = false, optional = null) {
        return (0, _validateNode.default)({
          type: "MemberExpression",
          object,
          property: property2,
          computed,
          optional
        });
      }
      function newExpression(callee, _arguments) {
        return (0, _validateNode.default)({
          type: "NewExpression",
          callee,
          arguments: _arguments
        });
      }
      function program3(body, directives = [], sourceType = "script", interpreter = null) {
        return (0, _validateNode.default)({
          type: "Program",
          body,
          directives,
          sourceType,
          interpreter,
          sourceFile: null
        });
      }
      function objectExpression(properties) {
        return (0, _validateNode.default)({
          type: "ObjectExpression",
          properties
        });
      }
      function objectMethod(kind = "method", key, params, body, computed = false, generator = false, async = false) {
        return (0, _validateNode.default)({
          type: "ObjectMethod",
          kind,
          key,
          params,
          body,
          computed,
          generator,
          async
        });
      }
      function objectProperty(key, value, computed = false, shorthand = false, decorators = null) {
        return (0, _validateNode.default)({
          type: "ObjectProperty",
          key,
          value,
          computed,
          shorthand,
          decorators
        });
      }
      function restElement(argument) {
        return (0, _validateNode.default)({
          type: "RestElement",
          argument
        });
      }
      function returnStatement(argument = null) {
        return (0, _validateNode.default)({
          type: "ReturnStatement",
          argument
        });
      }
      function sequenceExpression(expressions) {
        return (0, _validateNode.default)({
          type: "SequenceExpression",
          expressions
        });
      }
      function parenthesizedExpression(expression) {
        return (0, _validateNode.default)({
          type: "ParenthesizedExpression",
          expression
        });
      }
      function switchCase(test = null, consequent) {
        return (0, _validateNode.default)({
          type: "SwitchCase",
          test,
          consequent
        });
      }
      function switchStatement(discriminant, cases) {
        return (0, _validateNode.default)({
          type: "SwitchStatement",
          discriminant,
          cases
        });
      }
      function thisExpression() {
        return {
          type: "ThisExpression"
        };
      }
      function throwStatement(argument) {
        return (0, _validateNode.default)({
          type: "ThrowStatement",
          argument
        });
      }
      function tryStatement(block, handler = null, finalizer = null) {
        return (0, _validateNode.default)({
          type: "TryStatement",
          block,
          handler,
          finalizer
        });
      }
      function unaryExpression(operator, argument, prefix = true) {
        return (0, _validateNode.default)({
          type: "UnaryExpression",
          operator,
          argument,
          prefix
        });
      }
      function updateExpression(operator, argument, prefix = false) {
        return (0, _validateNode.default)({
          type: "UpdateExpression",
          operator,
          argument,
          prefix
        });
      }
      function variableDeclaration(kind, declarations) {
        return (0, _validateNode.default)({
          type: "VariableDeclaration",
          kind,
          declarations
        });
      }
      function variableDeclarator(id, init = null) {
        return (0, _validateNode.default)({
          type: "VariableDeclarator",
          id,
          init
        });
      }
      function whileStatement(test, body) {
        return (0, _validateNode.default)({
          type: "WhileStatement",
          test,
          body
        });
      }
      function withStatement(object, body) {
        return (0, _validateNode.default)({
          type: "WithStatement",
          object,
          body
        });
      }
      function assignmentPattern(left, right) {
        return (0, _validateNode.default)({
          type: "AssignmentPattern",
          left,
          right
        });
      }
      function arrayPattern(elements) {
        return (0, _validateNode.default)({
          type: "ArrayPattern",
          elements
        });
      }
      function arrowFunctionExpression2(params, body, async = false) {
        return (0, _validateNode.default)({
          type: "ArrowFunctionExpression",
          params,
          body,
          async,
          expression: null
        });
      }
      function classBody(body) {
        return (0, _validateNode.default)({
          type: "ClassBody",
          body
        });
      }
      function classExpression(id = null, superClass = null, body, decorators = null) {
        return (0, _validateNode.default)({
          type: "ClassExpression",
          id,
          superClass,
          body,
          decorators
        });
      }
      function classDeclaration(id, superClass = null, body, decorators = null) {
        return (0, _validateNode.default)({
          type: "ClassDeclaration",
          id,
          superClass,
          body,
          decorators
        });
      }
      function exportAllDeclaration(source) {
        return (0, _validateNode.default)({
          type: "ExportAllDeclaration",
          source
        });
      }
      function exportDefaultDeclaration(declaration) {
        return (0, _validateNode.default)({
          type: "ExportDefaultDeclaration",
          declaration
        });
      }
      function exportNamedDeclaration(declaration = null, specifiers = [], source = null) {
        return (0, _validateNode.default)({
          type: "ExportNamedDeclaration",
          declaration,
          specifiers,
          source
        });
      }
      function exportSpecifier(local, exported) {
        return (0, _validateNode.default)({
          type: "ExportSpecifier",
          local,
          exported
        });
      }
      function forOfStatement(left, right, body, _await = false) {
        return (0, _validateNode.default)({
          type: "ForOfStatement",
          left,
          right,
          body,
          await: _await
        });
      }
      function importDeclaration(specifiers, source) {
        return (0, _validateNode.default)({
          type: "ImportDeclaration",
          specifiers,
          source
        });
      }
      function importDefaultSpecifier(local) {
        return (0, _validateNode.default)({
          type: "ImportDefaultSpecifier",
          local
        });
      }
      function importNamespaceSpecifier(local) {
        return (0, _validateNode.default)({
          type: "ImportNamespaceSpecifier",
          local
        });
      }
      function importSpecifier(local, imported) {
        return (0, _validateNode.default)({
          type: "ImportSpecifier",
          local,
          imported
        });
      }
      function metaProperty(meta, property2) {
        return (0, _validateNode.default)({
          type: "MetaProperty",
          meta,
          property: property2
        });
      }
      function classMethod2(kind = "method", key, params, body, computed = false, _static = false, generator = false, async = false) {
        return (0, _validateNode.default)({
          type: "ClassMethod",
          kind,
          key,
          params,
          body,
          computed,
          static: _static,
          generator,
          async
        });
      }
      function objectPattern(properties) {
        return (0, _validateNode.default)({
          type: "ObjectPattern",
          properties
        });
      }
      function spreadElement(argument) {
        return (0, _validateNode.default)({
          type: "SpreadElement",
          argument
        });
      }
      function _super() {
        return {
          type: "Super"
        };
      }
      function taggedTemplateExpression(tag, quasi) {
        return (0, _validateNode.default)({
          type: "TaggedTemplateExpression",
          tag,
          quasi
        });
      }
      function templateElement(value, tail2 = false) {
        return (0, _validateNode.default)({
          type: "TemplateElement",
          value,
          tail: tail2
        });
      }
      function templateLiteral(quasis, expressions) {
        return (0, _validateNode.default)({
          type: "TemplateLiteral",
          quasis,
          expressions
        });
      }
      function yieldExpression(argument = null, delegate = false) {
        return (0, _validateNode.default)({
          type: "YieldExpression",
          argument,
          delegate
        });
      }
      function awaitExpression(argument) {
        return (0, _validateNode.default)({
          type: "AwaitExpression",
          argument
        });
      }
      function _import() {
        return {
          type: "Import"
        };
      }
      function bigIntLiteral(value) {
        return (0, _validateNode.default)({
          type: "BigIntLiteral",
          value
        });
      }
      function exportNamespaceSpecifier(exported) {
        return (0, _validateNode.default)({
          type: "ExportNamespaceSpecifier",
          exported
        });
      }
      function optionalMemberExpression(object, property2, computed = false, optional) {
        return (0, _validateNode.default)({
          type: "OptionalMemberExpression",
          object,
          property: property2,
          computed,
          optional
        });
      }
      function optionalCallExpression(callee, _arguments, optional) {
        return (0, _validateNode.default)({
          type: "OptionalCallExpression",
          callee,
          arguments: _arguments,
          optional
        });
      }
      function classProperty(key, value = null, typeAnnotation2 = null, decorators = null, computed = false, _static = false) {
        return (0, _validateNode.default)({
          type: "ClassProperty",
          key,
          value,
          typeAnnotation: typeAnnotation2,
          decorators,
          computed,
          static: _static
        });
      }
      function classAccessorProperty(key, value = null, typeAnnotation2 = null, decorators = null, computed = false, _static = false) {
        return (0, _validateNode.default)({
          type: "ClassAccessorProperty",
          key,
          value,
          typeAnnotation: typeAnnotation2,
          decorators,
          computed,
          static: _static
        });
      }
      function classPrivateProperty(key, value = null, decorators = null, _static = false) {
        return (0, _validateNode.default)({
          type: "ClassPrivateProperty",
          key,
          value,
          decorators,
          static: _static
        });
      }
      function classPrivateMethod(kind = "method", key, params, body, _static = false) {
        return (0, _validateNode.default)({
          type: "ClassPrivateMethod",
          kind,
          key,
          params,
          body,
          static: _static
        });
      }
      function privateName(id) {
        return (0, _validateNode.default)({
          type: "PrivateName",
          id
        });
      }
      function staticBlock(body) {
        return (0, _validateNode.default)({
          type: "StaticBlock",
          body
        });
      }
      function anyTypeAnnotation() {
        return {
          type: "AnyTypeAnnotation"
        };
      }
      function arrayTypeAnnotation(elementType) {
        return (0, _validateNode.default)({
          type: "ArrayTypeAnnotation",
          elementType
        });
      }
      function booleanTypeAnnotation() {
        return {
          type: "BooleanTypeAnnotation"
        };
      }
      function booleanLiteralTypeAnnotation(value) {
        return (0, _validateNode.default)({
          type: "BooleanLiteralTypeAnnotation",
          value
        });
      }
      function nullLiteralTypeAnnotation() {
        return {
          type: "NullLiteralTypeAnnotation"
        };
      }
      function classImplements(id, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "ClassImplements",
          id,
          typeParameters
        });
      }
      function declareClass(id, typeParameters = null, _extends = null, body) {
        return (0, _validateNode.default)({
          type: "DeclareClass",
          id,
          typeParameters,
          extends: _extends,
          body
        });
      }
      function declareFunction(id) {
        return (0, _validateNode.default)({
          type: "DeclareFunction",
          id
        });
      }
      function declareInterface(id, typeParameters = null, _extends = null, body) {
        return (0, _validateNode.default)({
          type: "DeclareInterface",
          id,
          typeParameters,
          extends: _extends,
          body
        });
      }
      function declareModule(id, body, kind = null) {
        return (0, _validateNode.default)({
          type: "DeclareModule",
          id,
          body,
          kind
        });
      }
      function declareModuleExports(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "DeclareModuleExports",
          typeAnnotation: typeAnnotation2
        });
      }
      function declareTypeAlias(id, typeParameters = null, right) {
        return (0, _validateNode.default)({
          type: "DeclareTypeAlias",
          id,
          typeParameters,
          right
        });
      }
      function declareOpaqueType(id, typeParameters = null, supertype = null) {
        return (0, _validateNode.default)({
          type: "DeclareOpaqueType",
          id,
          typeParameters,
          supertype
        });
      }
      function declareVariable(id) {
        return (0, _validateNode.default)({
          type: "DeclareVariable",
          id
        });
      }
      function declareExportDeclaration(declaration = null, specifiers = null, source = null) {
        return (0, _validateNode.default)({
          type: "DeclareExportDeclaration",
          declaration,
          specifiers,
          source
        });
      }
      function declareExportAllDeclaration(source) {
        return (0, _validateNode.default)({
          type: "DeclareExportAllDeclaration",
          source
        });
      }
      function declaredPredicate(value) {
        return (0, _validateNode.default)({
          type: "DeclaredPredicate",
          value
        });
      }
      function existsTypeAnnotation() {
        return {
          type: "ExistsTypeAnnotation"
        };
      }
      function functionTypeAnnotation(typeParameters = null, params, rest2 = null, returnType) {
        return (0, _validateNode.default)({
          type: "FunctionTypeAnnotation",
          typeParameters,
          params,
          rest: rest2,
          returnType
        });
      }
      function functionTypeParam(name = null, typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "FunctionTypeParam",
          name,
          typeAnnotation: typeAnnotation2
        });
      }
      function genericTypeAnnotation(id, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "GenericTypeAnnotation",
          id,
          typeParameters
        });
      }
      function inferredPredicate() {
        return {
          type: "InferredPredicate"
        };
      }
      function interfaceExtends(id, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "InterfaceExtends",
          id,
          typeParameters
        });
      }
      function interfaceDeclaration(id, typeParameters = null, _extends = null, body) {
        return (0, _validateNode.default)({
          type: "InterfaceDeclaration",
          id,
          typeParameters,
          extends: _extends,
          body
        });
      }
      function interfaceTypeAnnotation(_extends = null, body) {
        return (0, _validateNode.default)({
          type: "InterfaceTypeAnnotation",
          extends: _extends,
          body
        });
      }
      function intersectionTypeAnnotation(types) {
        return (0, _validateNode.default)({
          type: "IntersectionTypeAnnotation",
          types
        });
      }
      function mixedTypeAnnotation() {
        return {
          type: "MixedTypeAnnotation"
        };
      }
      function emptyTypeAnnotation() {
        return {
          type: "EmptyTypeAnnotation"
        };
      }
      function nullableTypeAnnotation(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "NullableTypeAnnotation",
          typeAnnotation: typeAnnotation2
        });
      }
      function numberLiteralTypeAnnotation(value) {
        return (0, _validateNode.default)({
          type: "NumberLiteralTypeAnnotation",
          value
        });
      }
      function numberTypeAnnotation() {
        return {
          type: "NumberTypeAnnotation"
        };
      }
      function objectTypeAnnotation(properties, indexers = [], callProperties = [], internalSlots = [], exact = false) {
        return (0, _validateNode.default)({
          type: "ObjectTypeAnnotation",
          properties,
          indexers,
          callProperties,
          internalSlots,
          exact
        });
      }
      function objectTypeInternalSlot(id, value, optional, _static, method2) {
        return (0, _validateNode.default)({
          type: "ObjectTypeInternalSlot",
          id,
          value,
          optional,
          static: _static,
          method: method2
        });
      }
      function objectTypeCallProperty(value) {
        return (0, _validateNode.default)({
          type: "ObjectTypeCallProperty",
          value,
          static: null
        });
      }
      function objectTypeIndexer(id = null, key, value, variance2 = null) {
        return (0, _validateNode.default)({
          type: "ObjectTypeIndexer",
          id,
          key,
          value,
          variance: variance2,
          static: null
        });
      }
      function objectTypeProperty(key, value, variance2 = null) {
        return (0, _validateNode.default)({
          type: "ObjectTypeProperty",
          key,
          value,
          variance: variance2,
          kind: null,
          method: null,
          optional: null,
          proto: null,
          static: null
        });
      }
      function objectTypeSpreadProperty(argument) {
        return (0, _validateNode.default)({
          type: "ObjectTypeSpreadProperty",
          argument
        });
      }
      function opaqueType(id, typeParameters = null, supertype = null, impltype) {
        return (0, _validateNode.default)({
          type: "OpaqueType",
          id,
          typeParameters,
          supertype,
          impltype
        });
      }
      function qualifiedTypeIdentifier(id, qualification) {
        return (0, _validateNode.default)({
          type: "QualifiedTypeIdentifier",
          id,
          qualification
        });
      }
      function stringLiteralTypeAnnotation(value) {
        return (0, _validateNode.default)({
          type: "StringLiteralTypeAnnotation",
          value
        });
      }
      function stringTypeAnnotation() {
        return {
          type: "StringTypeAnnotation"
        };
      }
      function symbolTypeAnnotation() {
        return {
          type: "SymbolTypeAnnotation"
        };
      }
      function thisTypeAnnotation() {
        return {
          type: "ThisTypeAnnotation"
        };
      }
      function tupleTypeAnnotation(types) {
        return (0, _validateNode.default)({
          type: "TupleTypeAnnotation",
          types
        });
      }
      function typeofTypeAnnotation(argument) {
        return (0, _validateNode.default)({
          type: "TypeofTypeAnnotation",
          argument
        });
      }
      function typeAlias(id, typeParameters = null, right) {
        return (0, _validateNode.default)({
          type: "TypeAlias",
          id,
          typeParameters,
          right
        });
      }
      function typeAnnotation(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TypeAnnotation",
          typeAnnotation: typeAnnotation2
        });
      }
      function typeCastExpression(expression, typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TypeCastExpression",
          expression,
          typeAnnotation: typeAnnotation2
        });
      }
      function typeParameter(bound = null, _default = null, variance2 = null) {
        return (0, _validateNode.default)({
          type: "TypeParameter",
          bound,
          default: _default,
          variance: variance2,
          name: null
        });
      }
      function typeParameterDeclaration(params) {
        return (0, _validateNode.default)({
          type: "TypeParameterDeclaration",
          params
        });
      }
      function typeParameterInstantiation(params) {
        return (0, _validateNode.default)({
          type: "TypeParameterInstantiation",
          params
        });
      }
      function unionTypeAnnotation(types) {
        return (0, _validateNode.default)({
          type: "UnionTypeAnnotation",
          types
        });
      }
      function variance(kind) {
        return (0, _validateNode.default)({
          type: "Variance",
          kind
        });
      }
      function voidTypeAnnotation() {
        return {
          type: "VoidTypeAnnotation"
        };
      }
      function enumDeclaration(id, body) {
        return (0, _validateNode.default)({
          type: "EnumDeclaration",
          id,
          body
        });
      }
      function enumBooleanBody(members) {
        return (0, _validateNode.default)({
          type: "EnumBooleanBody",
          members,
          explicitType: null,
          hasUnknownMembers: null
        });
      }
      function enumNumberBody(members) {
        return (0, _validateNode.default)({
          type: "EnumNumberBody",
          members,
          explicitType: null,
          hasUnknownMembers: null
        });
      }
      function enumStringBody(members) {
        return (0, _validateNode.default)({
          type: "EnumStringBody",
          members,
          explicitType: null,
          hasUnknownMembers: null
        });
      }
      function enumSymbolBody(members) {
        return (0, _validateNode.default)({
          type: "EnumSymbolBody",
          members,
          hasUnknownMembers: null
        });
      }
      function enumBooleanMember(id) {
        return (0, _validateNode.default)({
          type: "EnumBooleanMember",
          id,
          init: null
        });
      }
      function enumNumberMember(id, init) {
        return (0, _validateNode.default)({
          type: "EnumNumberMember",
          id,
          init
        });
      }
      function enumStringMember(id, init) {
        return (0, _validateNode.default)({
          type: "EnumStringMember",
          id,
          init
        });
      }
      function enumDefaultedMember(id) {
        return (0, _validateNode.default)({
          type: "EnumDefaultedMember",
          id
        });
      }
      function indexedAccessType(objectType, indexType) {
        return (0, _validateNode.default)({
          type: "IndexedAccessType",
          objectType,
          indexType
        });
      }
      function optionalIndexedAccessType(objectType, indexType) {
        return (0, _validateNode.default)({
          type: "OptionalIndexedAccessType",
          objectType,
          indexType,
          optional: null
        });
      }
      function jsxAttribute(name, value = null) {
        return (0, _validateNode.default)({
          type: "JSXAttribute",
          name,
          value
        });
      }
      function jsxClosingElement(name) {
        return (0, _validateNode.default)({
          type: "JSXClosingElement",
          name
        });
      }
      function jsxElement(openingElement, closingElement = null, children, selfClosing = null) {
        return (0, _validateNode.default)({
          type: "JSXElement",
          openingElement,
          closingElement,
          children,
          selfClosing
        });
      }
      function jsxEmptyExpression() {
        return {
          type: "JSXEmptyExpression"
        };
      }
      function jsxExpressionContainer(expression) {
        return (0, _validateNode.default)({
          type: "JSXExpressionContainer",
          expression
        });
      }
      function jsxSpreadChild(expression) {
        return (0, _validateNode.default)({
          type: "JSXSpreadChild",
          expression
        });
      }
      function jsxIdentifier(name) {
        return (0, _validateNode.default)({
          type: "JSXIdentifier",
          name
        });
      }
      function jsxMemberExpression(object, property2) {
        return (0, _validateNode.default)({
          type: "JSXMemberExpression",
          object,
          property: property2
        });
      }
      function jsxNamespacedName(namespace, name) {
        return (0, _validateNode.default)({
          type: "JSXNamespacedName",
          namespace,
          name
        });
      }
      function jsxOpeningElement(name, attributes, selfClosing = false) {
        return (0, _validateNode.default)({
          type: "JSXOpeningElement",
          name,
          attributes,
          selfClosing
        });
      }
      function jsxSpreadAttribute(argument) {
        return (0, _validateNode.default)({
          type: "JSXSpreadAttribute",
          argument
        });
      }
      function jsxText(value) {
        return (0, _validateNode.default)({
          type: "JSXText",
          value
        });
      }
      function jsxFragment(openingFragment, closingFragment, children) {
        return (0, _validateNode.default)({
          type: "JSXFragment",
          openingFragment,
          closingFragment,
          children
        });
      }
      function jsxOpeningFragment() {
        return {
          type: "JSXOpeningFragment"
        };
      }
      function jsxClosingFragment() {
        return {
          type: "JSXClosingFragment"
        };
      }
      function noop3() {
        return {
          type: "Noop"
        };
      }
      function placeholder(expectedNode, name) {
        return (0, _validateNode.default)({
          type: "Placeholder",
          expectedNode,
          name
        });
      }
      function v8IntrinsicIdentifier(name) {
        return (0, _validateNode.default)({
          type: "V8IntrinsicIdentifier",
          name
        });
      }
      function argumentPlaceholder() {
        return {
          type: "ArgumentPlaceholder"
        };
      }
      function bindExpression(object, callee) {
        return (0, _validateNode.default)({
          type: "BindExpression",
          object,
          callee
        });
      }
      function importAttribute(key, value) {
        return (0, _validateNode.default)({
          type: "ImportAttribute",
          key,
          value
        });
      }
      function decorator(expression) {
        return (0, _validateNode.default)({
          type: "Decorator",
          expression
        });
      }
      function doExpression(body, async = false) {
        return (0, _validateNode.default)({
          type: "DoExpression",
          body,
          async
        });
      }
      function exportDefaultSpecifier(exported) {
        return (0, _validateNode.default)({
          type: "ExportDefaultSpecifier",
          exported
        });
      }
      function recordExpression(properties) {
        return (0, _validateNode.default)({
          type: "RecordExpression",
          properties
        });
      }
      function tupleExpression(elements = []) {
        return (0, _validateNode.default)({
          type: "TupleExpression",
          elements
        });
      }
      function decimalLiteral(value) {
        return (0, _validateNode.default)({
          type: "DecimalLiteral",
          value
        });
      }
      function moduleExpression(body) {
        return (0, _validateNode.default)({
          type: "ModuleExpression",
          body
        });
      }
      function topicReference() {
        return {
          type: "TopicReference"
        };
      }
      function pipelineTopicExpression(expression) {
        return (0, _validateNode.default)({
          type: "PipelineTopicExpression",
          expression
        });
      }
      function pipelineBareFunction(callee) {
        return (0, _validateNode.default)({
          type: "PipelineBareFunction",
          callee
        });
      }
      function pipelinePrimaryTopicReference() {
        return {
          type: "PipelinePrimaryTopicReference"
        };
      }
      function tsParameterProperty(parameter) {
        return (0, _validateNode.default)({
          type: "TSParameterProperty",
          parameter
        });
      }
      function tsDeclareFunction(id = null, typeParameters = null, params, returnType = null) {
        return (0, _validateNode.default)({
          type: "TSDeclareFunction",
          id,
          typeParameters,
          params,
          returnType
        });
      }
      function tsDeclareMethod(decorators = null, key, typeParameters = null, params, returnType = null) {
        return (0, _validateNode.default)({
          type: "TSDeclareMethod",
          decorators,
          key,
          typeParameters,
          params,
          returnType
        });
      }
      function tsQualifiedName(left, right) {
        return (0, _validateNode.default)({
          type: "TSQualifiedName",
          left,
          right
        });
      }
      function tsCallSignatureDeclaration(typeParameters = null, parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSCallSignatureDeclaration",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsConstructSignatureDeclaration(typeParameters = null, parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSConstructSignatureDeclaration",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsPropertySignature(key, typeAnnotation2 = null, initializer = null) {
        return (0, _validateNode.default)({
          type: "TSPropertySignature",
          key,
          typeAnnotation: typeAnnotation2,
          initializer,
          kind: null
        });
      }
      function tsMethodSignature(key, typeParameters = null, parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSMethodSignature",
          key,
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2,
          kind: null
        });
      }
      function tsIndexSignature(parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSIndexSignature",
          parameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsAnyKeyword() {
        return {
          type: "TSAnyKeyword"
        };
      }
      function tsBooleanKeyword() {
        return {
          type: "TSBooleanKeyword"
        };
      }
      function tsBigIntKeyword() {
        return {
          type: "TSBigIntKeyword"
        };
      }
      function tsIntrinsicKeyword() {
        return {
          type: "TSIntrinsicKeyword"
        };
      }
      function tsNeverKeyword() {
        return {
          type: "TSNeverKeyword"
        };
      }
      function tsNullKeyword() {
        return {
          type: "TSNullKeyword"
        };
      }
      function tsNumberKeyword() {
        return {
          type: "TSNumberKeyword"
        };
      }
      function tsObjectKeyword() {
        return {
          type: "TSObjectKeyword"
        };
      }
      function tsStringKeyword() {
        return {
          type: "TSStringKeyword"
        };
      }
      function tsSymbolKeyword() {
        return {
          type: "TSSymbolKeyword"
        };
      }
      function tsUndefinedKeyword() {
        return {
          type: "TSUndefinedKeyword"
        };
      }
      function tsUnknownKeyword() {
        return {
          type: "TSUnknownKeyword"
        };
      }
      function tsVoidKeyword() {
        return {
          type: "TSVoidKeyword"
        };
      }
      function tsThisType() {
        return {
          type: "TSThisType"
        };
      }
      function tsFunctionType(typeParameters = null, parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSFunctionType",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsConstructorType(typeParameters = null, parameters, typeAnnotation2 = null) {
        return (0, _validateNode.default)({
          type: "TSConstructorType",
          typeParameters,
          parameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsTypeReference(typeName, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "TSTypeReference",
          typeName,
          typeParameters
        });
      }
      function tsTypePredicate(parameterName, typeAnnotation2 = null, asserts = null) {
        return (0, _validateNode.default)({
          type: "TSTypePredicate",
          parameterName,
          typeAnnotation: typeAnnotation2,
          asserts
        });
      }
      function tsTypeQuery(exprName, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "TSTypeQuery",
          exprName,
          typeParameters
        });
      }
      function tsTypeLiteral(members) {
        return (0, _validateNode.default)({
          type: "TSTypeLiteral",
          members
        });
      }
      function tsArrayType(elementType) {
        return (0, _validateNode.default)({
          type: "TSArrayType",
          elementType
        });
      }
      function tsTupleType(elementTypes) {
        return (0, _validateNode.default)({
          type: "TSTupleType",
          elementTypes
        });
      }
      function tsOptionalType(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSOptionalType",
          typeAnnotation: typeAnnotation2
        });
      }
      function tsRestType(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSRestType",
          typeAnnotation: typeAnnotation2
        });
      }
      function tsNamedTupleMember(label, elementType, optional = false) {
        return (0, _validateNode.default)({
          type: "TSNamedTupleMember",
          label,
          elementType,
          optional
        });
      }
      function tsUnionType(types) {
        return (0, _validateNode.default)({
          type: "TSUnionType",
          types
        });
      }
      function tsIntersectionType(types) {
        return (0, _validateNode.default)({
          type: "TSIntersectionType",
          types
        });
      }
      function tsConditionalType(checkType, extendsType, trueType, falseType) {
        return (0, _validateNode.default)({
          type: "TSConditionalType",
          checkType,
          extendsType,
          trueType,
          falseType
        });
      }
      function tsInferType(typeParameter2) {
        return (0, _validateNode.default)({
          type: "TSInferType",
          typeParameter: typeParameter2
        });
      }
      function tsParenthesizedType(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSParenthesizedType",
          typeAnnotation: typeAnnotation2
        });
      }
      function tsTypeOperator(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSTypeOperator",
          typeAnnotation: typeAnnotation2,
          operator: null
        });
      }
      function tsIndexedAccessType(objectType, indexType) {
        return (0, _validateNode.default)({
          type: "TSIndexedAccessType",
          objectType,
          indexType
        });
      }
      function tsMappedType(typeParameter2, typeAnnotation2 = null, nameType = null) {
        return (0, _validateNode.default)({
          type: "TSMappedType",
          typeParameter: typeParameter2,
          typeAnnotation: typeAnnotation2,
          nameType
        });
      }
      function tsLiteralType(literal) {
        return (0, _validateNode.default)({
          type: "TSLiteralType",
          literal
        });
      }
      function tsExpressionWithTypeArguments(expression, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "TSExpressionWithTypeArguments",
          expression,
          typeParameters
        });
      }
      function tsInterfaceDeclaration(id, typeParameters = null, _extends = null, body) {
        return (0, _validateNode.default)({
          type: "TSInterfaceDeclaration",
          id,
          typeParameters,
          extends: _extends,
          body
        });
      }
      function tsInterfaceBody(body) {
        return (0, _validateNode.default)({
          type: "TSInterfaceBody",
          body
        });
      }
      function tsTypeAliasDeclaration(id, typeParameters = null, typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSTypeAliasDeclaration",
          id,
          typeParameters,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsInstantiationExpression(expression, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "TSInstantiationExpression",
          expression,
          typeParameters
        });
      }
      function tsAsExpression(expression, typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSAsExpression",
          expression,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsSatisfiesExpression(expression, typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSSatisfiesExpression",
          expression,
          typeAnnotation: typeAnnotation2
        });
      }
      function tsTypeAssertion(typeAnnotation2, expression) {
        return (0, _validateNode.default)({
          type: "TSTypeAssertion",
          typeAnnotation: typeAnnotation2,
          expression
        });
      }
      function tsEnumDeclaration(id, members) {
        return (0, _validateNode.default)({
          type: "TSEnumDeclaration",
          id,
          members
        });
      }
      function tsEnumMember(id, initializer = null) {
        return (0, _validateNode.default)({
          type: "TSEnumMember",
          id,
          initializer
        });
      }
      function tsModuleDeclaration(id, body) {
        return (0, _validateNode.default)({
          type: "TSModuleDeclaration",
          id,
          body
        });
      }
      function tsModuleBlock(body) {
        return (0, _validateNode.default)({
          type: "TSModuleBlock",
          body
        });
      }
      function tsImportType(argument, qualifier = null, typeParameters = null) {
        return (0, _validateNode.default)({
          type: "TSImportType",
          argument,
          qualifier,
          typeParameters
        });
      }
      function tsImportEqualsDeclaration(id, moduleReference) {
        return (0, _validateNode.default)({
          type: "TSImportEqualsDeclaration",
          id,
          moduleReference,
          isExport: null
        });
      }
      function tsExternalModuleReference(expression) {
        return (0, _validateNode.default)({
          type: "TSExternalModuleReference",
          expression
        });
      }
      function tsNonNullExpression(expression) {
        return (0, _validateNode.default)({
          type: "TSNonNullExpression",
          expression
        });
      }
      function tsExportAssignment(expression) {
        return (0, _validateNode.default)({
          type: "TSExportAssignment",
          expression
        });
      }
      function tsNamespaceExportDeclaration(id) {
        return (0, _validateNode.default)({
          type: "TSNamespaceExportDeclaration",
          id
        });
      }
      function tsTypeAnnotation(typeAnnotation2) {
        return (0, _validateNode.default)({
          type: "TSTypeAnnotation",
          typeAnnotation: typeAnnotation2
        });
      }
      function tsTypeParameterInstantiation(params) {
        return (0, _validateNode.default)({
          type: "TSTypeParameterInstantiation",
          params
        });
      }
      function tsTypeParameterDeclaration(params) {
        return (0, _validateNode.default)({
          type: "TSTypeParameterDeclaration",
          params
        });
      }
      function tsTypeParameter(constraint = null, _default = null, name) {
        return (0, _validateNode.default)({
          type: "TSTypeParameter",
          constraint,
          default: _default,
          name
        });
      }
      function NumberLiteral(value) {
        console.trace("The node type NumberLiteral has been renamed to NumericLiteral");
        return numericLiteral(value);
      }
      function RegexLiteral(pattern, flags = "") {
        console.trace("The node type RegexLiteral has been renamed to RegExpLiteral");
        return regExpLiteral(pattern, flags);
      }
      function RestProperty(argument) {
        console.trace("The node type RestProperty has been renamed to RestElement");
        return restElement(argument);
      }
      function SpreadProperty(argument) {
        console.trace("The node type SpreadProperty has been renamed to SpreadElement");
        return spreadElement(argument);
      }
    }
  });

  // node_modules/@babel/types/lib/utils/react/cleanJSXElementLiteralChild.js
  var require_cleanJSXElementLiteralChild = __commonJS({
    "node_modules/@babel/types/lib/utils/react/cleanJSXElementLiteralChild.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = cleanJSXElementLiteralChild;
      var _generated = require_generated2();
      function cleanJSXElementLiteralChild(child, args) {
        const lines = child.value.split(/\r\n|\n|\r/);
        let lastNonEmptyLine = 0;
        for (let i = 0; i < lines.length; i++) {
          if (lines[i].match(/[^ \t]/)) {
            lastNonEmptyLine = i;
          }
        }
        let str = "";
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          const isFirstLine = i === 0;
          const isLastLine = i === lines.length - 1;
          const isLastNonEmptyLine = i === lastNonEmptyLine;
          let trimmedLine = line.replace(/\t/g, " ");
          if (!isFirstLine) {
            trimmedLine = trimmedLine.replace(/^[ ]+/, "");
          }
          if (!isLastLine) {
            trimmedLine = trimmedLine.replace(/[ ]+$/, "");
          }
          if (trimmedLine) {
            if (!isLastNonEmptyLine) {
              trimmedLine += " ";
            }
            str += trimmedLine;
          }
        }
        if (str)
          args.push((0, _generated.stringLiteral)(str));
      }
    }
  });

  // node_modules/@babel/types/lib/builders/react/buildChildren.js
  var require_buildChildren = __commonJS({
    "node_modules/@babel/types/lib/builders/react/buildChildren.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = buildChildren;
      var _generated = require_generated();
      var _cleanJSXElementLiteralChild = require_cleanJSXElementLiteralChild();
      function buildChildren(node) {
        const elements = [];
        for (let i = 0; i < node.children.length; i++) {
          let child = node.children[i];
          if ((0, _generated.isJSXText)(child)) {
            (0, _cleanJSXElementLiteralChild.default)(child, elements);
            continue;
          }
          if ((0, _generated.isJSXExpressionContainer)(child))
            child = child.expression;
          if ((0, _generated.isJSXEmptyExpression)(child))
            continue;
          elements.push(child);
        }
        return elements;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isNode.js
  var require_isNode = __commonJS({
    "node_modules/@babel/types/lib/validators/isNode.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isNode;
      var _definitions = require_definitions();
      function isNode(node) {
        return !!(node && _definitions.VISITOR_KEYS[node.type]);
      }
    }
  });

  // node_modules/@babel/types/lib/asserts/assertNode.js
  var require_assertNode = __commonJS({
    "node_modules/@babel/types/lib/asserts/assertNode.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = assertNode;
      var _isNode = require_isNode();
      function assertNode(node) {
        if (!(0, _isNode.default)(node)) {
          var _node$type;
          const type = (_node$type = node == null ? void 0 : node.type) != null ? _node$type : JSON.stringify(node);
          throw new TypeError(`Not a valid node of type "${type}"`);
        }
      }
    }
  });

  // node_modules/@babel/types/lib/asserts/generated/index.js
  var require_generated3 = __commonJS({
    "node_modules/@babel/types/lib/asserts/generated/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.assertAccessor = assertAccessor;
      exports2.assertAnyTypeAnnotation = assertAnyTypeAnnotation;
      exports2.assertArgumentPlaceholder = assertArgumentPlaceholder;
      exports2.assertArrayExpression = assertArrayExpression;
      exports2.assertArrayPattern = assertArrayPattern;
      exports2.assertArrayTypeAnnotation = assertArrayTypeAnnotation;
      exports2.assertArrowFunctionExpression = assertArrowFunctionExpression;
      exports2.assertAssignmentExpression = assertAssignmentExpression;
      exports2.assertAssignmentPattern = assertAssignmentPattern;
      exports2.assertAwaitExpression = assertAwaitExpression;
      exports2.assertBigIntLiteral = assertBigIntLiteral;
      exports2.assertBinary = assertBinary;
      exports2.assertBinaryExpression = assertBinaryExpression;
      exports2.assertBindExpression = assertBindExpression;
      exports2.assertBlock = assertBlock;
      exports2.assertBlockParent = assertBlockParent;
      exports2.assertBlockStatement = assertBlockStatement;
      exports2.assertBooleanLiteral = assertBooleanLiteral;
      exports2.assertBooleanLiteralTypeAnnotation = assertBooleanLiteralTypeAnnotation;
      exports2.assertBooleanTypeAnnotation = assertBooleanTypeAnnotation;
      exports2.assertBreakStatement = assertBreakStatement;
      exports2.assertCallExpression = assertCallExpression;
      exports2.assertCatchClause = assertCatchClause;
      exports2.assertClass = assertClass;
      exports2.assertClassAccessorProperty = assertClassAccessorProperty;
      exports2.assertClassBody = assertClassBody;
      exports2.assertClassDeclaration = assertClassDeclaration;
      exports2.assertClassExpression = assertClassExpression;
      exports2.assertClassImplements = assertClassImplements;
      exports2.assertClassMethod = assertClassMethod;
      exports2.assertClassPrivateMethod = assertClassPrivateMethod;
      exports2.assertClassPrivateProperty = assertClassPrivateProperty;
      exports2.assertClassProperty = assertClassProperty;
      exports2.assertCompletionStatement = assertCompletionStatement;
      exports2.assertConditional = assertConditional;
      exports2.assertConditionalExpression = assertConditionalExpression;
      exports2.assertContinueStatement = assertContinueStatement;
      exports2.assertDebuggerStatement = assertDebuggerStatement;
      exports2.assertDecimalLiteral = assertDecimalLiteral;
      exports2.assertDeclaration = assertDeclaration;
      exports2.assertDeclareClass = assertDeclareClass;
      exports2.assertDeclareExportAllDeclaration = assertDeclareExportAllDeclaration;
      exports2.assertDeclareExportDeclaration = assertDeclareExportDeclaration;
      exports2.assertDeclareFunction = assertDeclareFunction;
      exports2.assertDeclareInterface = assertDeclareInterface;
      exports2.assertDeclareModule = assertDeclareModule;
      exports2.assertDeclareModuleExports = assertDeclareModuleExports;
      exports2.assertDeclareOpaqueType = assertDeclareOpaqueType;
      exports2.assertDeclareTypeAlias = assertDeclareTypeAlias;
      exports2.assertDeclareVariable = assertDeclareVariable;
      exports2.assertDeclaredPredicate = assertDeclaredPredicate;
      exports2.assertDecorator = assertDecorator;
      exports2.assertDirective = assertDirective;
      exports2.assertDirectiveLiteral = assertDirectiveLiteral;
      exports2.assertDoExpression = assertDoExpression;
      exports2.assertDoWhileStatement = assertDoWhileStatement;
      exports2.assertEmptyStatement = assertEmptyStatement;
      exports2.assertEmptyTypeAnnotation = assertEmptyTypeAnnotation;
      exports2.assertEnumBody = assertEnumBody;
      exports2.assertEnumBooleanBody = assertEnumBooleanBody;
      exports2.assertEnumBooleanMember = assertEnumBooleanMember;
      exports2.assertEnumDeclaration = assertEnumDeclaration;
      exports2.assertEnumDefaultedMember = assertEnumDefaultedMember;
      exports2.assertEnumMember = assertEnumMember;
      exports2.assertEnumNumberBody = assertEnumNumberBody;
      exports2.assertEnumNumberMember = assertEnumNumberMember;
      exports2.assertEnumStringBody = assertEnumStringBody;
      exports2.assertEnumStringMember = assertEnumStringMember;
      exports2.assertEnumSymbolBody = assertEnumSymbolBody;
      exports2.assertExistsTypeAnnotation = assertExistsTypeAnnotation;
      exports2.assertExportAllDeclaration = assertExportAllDeclaration;
      exports2.assertExportDeclaration = assertExportDeclaration;
      exports2.assertExportDefaultDeclaration = assertExportDefaultDeclaration;
      exports2.assertExportDefaultSpecifier = assertExportDefaultSpecifier;
      exports2.assertExportNamedDeclaration = assertExportNamedDeclaration;
      exports2.assertExportNamespaceSpecifier = assertExportNamespaceSpecifier;
      exports2.assertExportSpecifier = assertExportSpecifier;
      exports2.assertExpression = assertExpression;
      exports2.assertExpressionStatement = assertExpressionStatement;
      exports2.assertExpressionWrapper = assertExpressionWrapper;
      exports2.assertFile = assertFile;
      exports2.assertFlow = assertFlow;
      exports2.assertFlowBaseAnnotation = assertFlowBaseAnnotation;
      exports2.assertFlowDeclaration = assertFlowDeclaration;
      exports2.assertFlowPredicate = assertFlowPredicate;
      exports2.assertFlowType = assertFlowType;
      exports2.assertFor = assertFor;
      exports2.assertForInStatement = assertForInStatement;
      exports2.assertForOfStatement = assertForOfStatement;
      exports2.assertForStatement = assertForStatement;
      exports2.assertForXStatement = assertForXStatement;
      exports2.assertFunction = assertFunction;
      exports2.assertFunctionDeclaration = assertFunctionDeclaration;
      exports2.assertFunctionExpression = assertFunctionExpression;
      exports2.assertFunctionParent = assertFunctionParent;
      exports2.assertFunctionTypeAnnotation = assertFunctionTypeAnnotation;
      exports2.assertFunctionTypeParam = assertFunctionTypeParam;
      exports2.assertGenericTypeAnnotation = assertGenericTypeAnnotation;
      exports2.assertIdentifier = assertIdentifier;
      exports2.assertIfStatement = assertIfStatement;
      exports2.assertImmutable = assertImmutable;
      exports2.assertImport = assertImport;
      exports2.assertImportAttribute = assertImportAttribute;
      exports2.assertImportDeclaration = assertImportDeclaration;
      exports2.assertImportDefaultSpecifier = assertImportDefaultSpecifier;
      exports2.assertImportNamespaceSpecifier = assertImportNamespaceSpecifier;
      exports2.assertImportSpecifier = assertImportSpecifier;
      exports2.assertIndexedAccessType = assertIndexedAccessType;
      exports2.assertInferredPredicate = assertInferredPredicate;
      exports2.assertInterfaceDeclaration = assertInterfaceDeclaration;
      exports2.assertInterfaceExtends = assertInterfaceExtends;
      exports2.assertInterfaceTypeAnnotation = assertInterfaceTypeAnnotation;
      exports2.assertInterpreterDirective = assertInterpreterDirective;
      exports2.assertIntersectionTypeAnnotation = assertIntersectionTypeAnnotation;
      exports2.assertJSX = assertJSX;
      exports2.assertJSXAttribute = assertJSXAttribute;
      exports2.assertJSXClosingElement = assertJSXClosingElement;
      exports2.assertJSXClosingFragment = assertJSXClosingFragment;
      exports2.assertJSXElement = assertJSXElement;
      exports2.assertJSXEmptyExpression = assertJSXEmptyExpression;
      exports2.assertJSXExpressionContainer = assertJSXExpressionContainer;
      exports2.assertJSXFragment = assertJSXFragment;
      exports2.assertJSXIdentifier = assertJSXIdentifier;
      exports2.assertJSXMemberExpression = assertJSXMemberExpression;
      exports2.assertJSXNamespacedName = assertJSXNamespacedName;
      exports2.assertJSXOpeningElement = assertJSXOpeningElement;
      exports2.assertJSXOpeningFragment = assertJSXOpeningFragment;
      exports2.assertJSXSpreadAttribute = assertJSXSpreadAttribute;
      exports2.assertJSXSpreadChild = assertJSXSpreadChild;
      exports2.assertJSXText = assertJSXText;
      exports2.assertLVal = assertLVal;
      exports2.assertLabeledStatement = assertLabeledStatement;
      exports2.assertLiteral = assertLiteral;
      exports2.assertLogicalExpression = assertLogicalExpression;
      exports2.assertLoop = assertLoop;
      exports2.assertMemberExpression = assertMemberExpression;
      exports2.assertMetaProperty = assertMetaProperty;
      exports2.assertMethod = assertMethod;
      exports2.assertMiscellaneous = assertMiscellaneous;
      exports2.assertMixedTypeAnnotation = assertMixedTypeAnnotation;
      exports2.assertModuleDeclaration = assertModuleDeclaration;
      exports2.assertModuleExpression = assertModuleExpression;
      exports2.assertModuleSpecifier = assertModuleSpecifier;
      exports2.assertNewExpression = assertNewExpression;
      exports2.assertNoop = assertNoop;
      exports2.assertNullLiteral = assertNullLiteral;
      exports2.assertNullLiteralTypeAnnotation = assertNullLiteralTypeAnnotation;
      exports2.assertNullableTypeAnnotation = assertNullableTypeAnnotation;
      exports2.assertNumberLiteral = assertNumberLiteral;
      exports2.assertNumberLiteralTypeAnnotation = assertNumberLiteralTypeAnnotation;
      exports2.assertNumberTypeAnnotation = assertNumberTypeAnnotation;
      exports2.assertNumericLiteral = assertNumericLiteral;
      exports2.assertObjectExpression = assertObjectExpression;
      exports2.assertObjectMember = assertObjectMember;
      exports2.assertObjectMethod = assertObjectMethod;
      exports2.assertObjectPattern = assertObjectPattern;
      exports2.assertObjectProperty = assertObjectProperty;
      exports2.assertObjectTypeAnnotation = assertObjectTypeAnnotation;
      exports2.assertObjectTypeCallProperty = assertObjectTypeCallProperty;
      exports2.assertObjectTypeIndexer = assertObjectTypeIndexer;
      exports2.assertObjectTypeInternalSlot = assertObjectTypeInternalSlot;
      exports2.assertObjectTypeProperty = assertObjectTypeProperty;
      exports2.assertObjectTypeSpreadProperty = assertObjectTypeSpreadProperty;
      exports2.assertOpaqueType = assertOpaqueType;
      exports2.assertOptionalCallExpression = assertOptionalCallExpression;
      exports2.assertOptionalIndexedAccessType = assertOptionalIndexedAccessType;
      exports2.assertOptionalMemberExpression = assertOptionalMemberExpression;
      exports2.assertParenthesizedExpression = assertParenthesizedExpression;
      exports2.assertPattern = assertPattern;
      exports2.assertPatternLike = assertPatternLike;
      exports2.assertPipelineBareFunction = assertPipelineBareFunction;
      exports2.assertPipelinePrimaryTopicReference = assertPipelinePrimaryTopicReference;
      exports2.assertPipelineTopicExpression = assertPipelineTopicExpression;
      exports2.assertPlaceholder = assertPlaceholder;
      exports2.assertPrivate = assertPrivate;
      exports2.assertPrivateName = assertPrivateName;
      exports2.assertProgram = assertProgram;
      exports2.assertProperty = assertProperty;
      exports2.assertPureish = assertPureish;
      exports2.assertQualifiedTypeIdentifier = assertQualifiedTypeIdentifier;
      exports2.assertRecordExpression = assertRecordExpression;
      exports2.assertRegExpLiteral = assertRegExpLiteral;
      exports2.assertRegexLiteral = assertRegexLiteral;
      exports2.assertRestElement = assertRestElement;
      exports2.assertRestProperty = assertRestProperty;
      exports2.assertReturnStatement = assertReturnStatement;
      exports2.assertScopable = assertScopable;
      exports2.assertSequenceExpression = assertSequenceExpression;
      exports2.assertSpreadElement = assertSpreadElement;
      exports2.assertSpreadProperty = assertSpreadProperty;
      exports2.assertStandardized = assertStandardized;
      exports2.assertStatement = assertStatement;
      exports2.assertStaticBlock = assertStaticBlock;
      exports2.assertStringLiteral = assertStringLiteral;
      exports2.assertStringLiteralTypeAnnotation = assertStringLiteralTypeAnnotation;
      exports2.assertStringTypeAnnotation = assertStringTypeAnnotation;
      exports2.assertSuper = assertSuper;
      exports2.assertSwitchCase = assertSwitchCase;
      exports2.assertSwitchStatement = assertSwitchStatement;
      exports2.assertSymbolTypeAnnotation = assertSymbolTypeAnnotation;
      exports2.assertTSAnyKeyword = assertTSAnyKeyword;
      exports2.assertTSArrayType = assertTSArrayType;
      exports2.assertTSAsExpression = assertTSAsExpression;
      exports2.assertTSBaseType = assertTSBaseType;
      exports2.assertTSBigIntKeyword = assertTSBigIntKeyword;
      exports2.assertTSBooleanKeyword = assertTSBooleanKeyword;
      exports2.assertTSCallSignatureDeclaration = assertTSCallSignatureDeclaration;
      exports2.assertTSConditionalType = assertTSConditionalType;
      exports2.assertTSConstructSignatureDeclaration = assertTSConstructSignatureDeclaration;
      exports2.assertTSConstructorType = assertTSConstructorType;
      exports2.assertTSDeclareFunction = assertTSDeclareFunction;
      exports2.assertTSDeclareMethod = assertTSDeclareMethod;
      exports2.assertTSEntityName = assertTSEntityName;
      exports2.assertTSEnumDeclaration = assertTSEnumDeclaration;
      exports2.assertTSEnumMember = assertTSEnumMember;
      exports2.assertTSExportAssignment = assertTSExportAssignment;
      exports2.assertTSExpressionWithTypeArguments = assertTSExpressionWithTypeArguments;
      exports2.assertTSExternalModuleReference = assertTSExternalModuleReference;
      exports2.assertTSFunctionType = assertTSFunctionType;
      exports2.assertTSImportEqualsDeclaration = assertTSImportEqualsDeclaration;
      exports2.assertTSImportType = assertTSImportType;
      exports2.assertTSIndexSignature = assertTSIndexSignature;
      exports2.assertTSIndexedAccessType = assertTSIndexedAccessType;
      exports2.assertTSInferType = assertTSInferType;
      exports2.assertTSInstantiationExpression = assertTSInstantiationExpression;
      exports2.assertTSInterfaceBody = assertTSInterfaceBody;
      exports2.assertTSInterfaceDeclaration = assertTSInterfaceDeclaration;
      exports2.assertTSIntersectionType = assertTSIntersectionType;
      exports2.assertTSIntrinsicKeyword = assertTSIntrinsicKeyword;
      exports2.assertTSLiteralType = assertTSLiteralType;
      exports2.assertTSMappedType = assertTSMappedType;
      exports2.assertTSMethodSignature = assertTSMethodSignature;
      exports2.assertTSModuleBlock = assertTSModuleBlock;
      exports2.assertTSModuleDeclaration = assertTSModuleDeclaration;
      exports2.assertTSNamedTupleMember = assertTSNamedTupleMember;
      exports2.assertTSNamespaceExportDeclaration = assertTSNamespaceExportDeclaration;
      exports2.assertTSNeverKeyword = assertTSNeverKeyword;
      exports2.assertTSNonNullExpression = assertTSNonNullExpression;
      exports2.assertTSNullKeyword = assertTSNullKeyword;
      exports2.assertTSNumberKeyword = assertTSNumberKeyword;
      exports2.assertTSObjectKeyword = assertTSObjectKeyword;
      exports2.assertTSOptionalType = assertTSOptionalType;
      exports2.assertTSParameterProperty = assertTSParameterProperty;
      exports2.assertTSParenthesizedType = assertTSParenthesizedType;
      exports2.assertTSPropertySignature = assertTSPropertySignature;
      exports2.assertTSQualifiedName = assertTSQualifiedName;
      exports2.assertTSRestType = assertTSRestType;
      exports2.assertTSSatisfiesExpression = assertTSSatisfiesExpression;
      exports2.assertTSStringKeyword = assertTSStringKeyword;
      exports2.assertTSSymbolKeyword = assertTSSymbolKeyword;
      exports2.assertTSThisType = assertTSThisType;
      exports2.assertTSTupleType = assertTSTupleType;
      exports2.assertTSType = assertTSType;
      exports2.assertTSTypeAliasDeclaration = assertTSTypeAliasDeclaration;
      exports2.assertTSTypeAnnotation = assertTSTypeAnnotation;
      exports2.assertTSTypeAssertion = assertTSTypeAssertion;
      exports2.assertTSTypeElement = assertTSTypeElement;
      exports2.assertTSTypeLiteral = assertTSTypeLiteral;
      exports2.assertTSTypeOperator = assertTSTypeOperator;
      exports2.assertTSTypeParameter = assertTSTypeParameter;
      exports2.assertTSTypeParameterDeclaration = assertTSTypeParameterDeclaration;
      exports2.assertTSTypeParameterInstantiation = assertTSTypeParameterInstantiation;
      exports2.assertTSTypePredicate = assertTSTypePredicate;
      exports2.assertTSTypeQuery = assertTSTypeQuery;
      exports2.assertTSTypeReference = assertTSTypeReference;
      exports2.assertTSUndefinedKeyword = assertTSUndefinedKeyword;
      exports2.assertTSUnionType = assertTSUnionType;
      exports2.assertTSUnknownKeyword = assertTSUnknownKeyword;
      exports2.assertTSVoidKeyword = assertTSVoidKeyword;
      exports2.assertTaggedTemplateExpression = assertTaggedTemplateExpression;
      exports2.assertTemplateElement = assertTemplateElement;
      exports2.assertTemplateLiteral = assertTemplateLiteral;
      exports2.assertTerminatorless = assertTerminatorless;
      exports2.assertThisExpression = assertThisExpression;
      exports2.assertThisTypeAnnotation = assertThisTypeAnnotation;
      exports2.assertThrowStatement = assertThrowStatement;
      exports2.assertTopicReference = assertTopicReference;
      exports2.assertTryStatement = assertTryStatement;
      exports2.assertTupleExpression = assertTupleExpression;
      exports2.assertTupleTypeAnnotation = assertTupleTypeAnnotation;
      exports2.assertTypeAlias = assertTypeAlias;
      exports2.assertTypeAnnotation = assertTypeAnnotation;
      exports2.assertTypeCastExpression = assertTypeCastExpression;
      exports2.assertTypeParameter = assertTypeParameter;
      exports2.assertTypeParameterDeclaration = assertTypeParameterDeclaration;
      exports2.assertTypeParameterInstantiation = assertTypeParameterInstantiation;
      exports2.assertTypeScript = assertTypeScript;
      exports2.assertTypeofTypeAnnotation = assertTypeofTypeAnnotation;
      exports2.assertUnaryExpression = assertUnaryExpression;
      exports2.assertUnaryLike = assertUnaryLike;
      exports2.assertUnionTypeAnnotation = assertUnionTypeAnnotation;
      exports2.assertUpdateExpression = assertUpdateExpression;
      exports2.assertUserWhitespacable = assertUserWhitespacable;
      exports2.assertV8IntrinsicIdentifier = assertV8IntrinsicIdentifier;
      exports2.assertVariableDeclaration = assertVariableDeclaration;
      exports2.assertVariableDeclarator = assertVariableDeclarator;
      exports2.assertVariance = assertVariance;
      exports2.assertVoidTypeAnnotation = assertVoidTypeAnnotation;
      exports2.assertWhile = assertWhile;
      exports2.assertWhileStatement = assertWhileStatement;
      exports2.assertWithStatement = assertWithStatement;
      exports2.assertYieldExpression = assertYieldExpression;
      var _is = require_is();
      function assert(type, node, opts) {
        if (!(0, _is.default)(type, node, opts)) {
          throw new Error(`Expected type "${type}" with option ${JSON.stringify(opts)}, but instead got "${node.type}".`);
        }
      }
      function assertArrayExpression(node, opts) {
        assert("ArrayExpression", node, opts);
      }
      function assertAssignmentExpression(node, opts) {
        assert("AssignmentExpression", node, opts);
      }
      function assertBinaryExpression(node, opts) {
        assert("BinaryExpression", node, opts);
      }
      function assertInterpreterDirective(node, opts) {
        assert("InterpreterDirective", node, opts);
      }
      function assertDirective(node, opts) {
        assert("Directive", node, opts);
      }
      function assertDirectiveLiteral(node, opts) {
        assert("DirectiveLiteral", node, opts);
      }
      function assertBlockStatement(node, opts) {
        assert("BlockStatement", node, opts);
      }
      function assertBreakStatement(node, opts) {
        assert("BreakStatement", node, opts);
      }
      function assertCallExpression(node, opts) {
        assert("CallExpression", node, opts);
      }
      function assertCatchClause(node, opts) {
        assert("CatchClause", node, opts);
      }
      function assertConditionalExpression(node, opts) {
        assert("ConditionalExpression", node, opts);
      }
      function assertContinueStatement(node, opts) {
        assert("ContinueStatement", node, opts);
      }
      function assertDebuggerStatement(node, opts) {
        assert("DebuggerStatement", node, opts);
      }
      function assertDoWhileStatement(node, opts) {
        assert("DoWhileStatement", node, opts);
      }
      function assertEmptyStatement(node, opts) {
        assert("EmptyStatement", node, opts);
      }
      function assertExpressionStatement(node, opts) {
        assert("ExpressionStatement", node, opts);
      }
      function assertFile(node, opts) {
        assert("File", node, opts);
      }
      function assertForInStatement(node, opts) {
        assert("ForInStatement", node, opts);
      }
      function assertForStatement(node, opts) {
        assert("ForStatement", node, opts);
      }
      function assertFunctionDeclaration(node, opts) {
        assert("FunctionDeclaration", node, opts);
      }
      function assertFunctionExpression(node, opts) {
        assert("FunctionExpression", node, opts);
      }
      function assertIdentifier(node, opts) {
        assert("Identifier", node, opts);
      }
      function assertIfStatement(node, opts) {
        assert("IfStatement", node, opts);
      }
      function assertLabeledStatement(node, opts) {
        assert("LabeledStatement", node, opts);
      }
      function assertStringLiteral(node, opts) {
        assert("StringLiteral", node, opts);
      }
      function assertNumericLiteral(node, opts) {
        assert("NumericLiteral", node, opts);
      }
      function assertNullLiteral(node, opts) {
        assert("NullLiteral", node, opts);
      }
      function assertBooleanLiteral(node, opts) {
        assert("BooleanLiteral", node, opts);
      }
      function assertRegExpLiteral(node, opts) {
        assert("RegExpLiteral", node, opts);
      }
      function assertLogicalExpression(node, opts) {
        assert("LogicalExpression", node, opts);
      }
      function assertMemberExpression(node, opts) {
        assert("MemberExpression", node, opts);
      }
      function assertNewExpression(node, opts) {
        assert("NewExpression", node, opts);
      }
      function assertProgram(node, opts) {
        assert("Program", node, opts);
      }
      function assertObjectExpression(node, opts) {
        assert("ObjectExpression", node, opts);
      }
      function assertObjectMethod(node, opts) {
        assert("ObjectMethod", node, opts);
      }
      function assertObjectProperty(node, opts) {
        assert("ObjectProperty", node, opts);
      }
      function assertRestElement(node, opts) {
        assert("RestElement", node, opts);
      }
      function assertReturnStatement(node, opts) {
        assert("ReturnStatement", node, opts);
      }
      function assertSequenceExpression(node, opts) {
        assert("SequenceExpression", node, opts);
      }
      function assertParenthesizedExpression(node, opts) {
        assert("ParenthesizedExpression", node, opts);
      }
      function assertSwitchCase(node, opts) {
        assert("SwitchCase", node, opts);
      }
      function assertSwitchStatement(node, opts) {
        assert("SwitchStatement", node, opts);
      }
      function assertThisExpression(node, opts) {
        assert("ThisExpression", node, opts);
      }
      function assertThrowStatement(node, opts) {
        assert("ThrowStatement", node, opts);
      }
      function assertTryStatement(node, opts) {
        assert("TryStatement", node, opts);
      }
      function assertUnaryExpression(node, opts) {
        assert("UnaryExpression", node, opts);
      }
      function assertUpdateExpression(node, opts) {
        assert("UpdateExpression", node, opts);
      }
      function assertVariableDeclaration(node, opts) {
        assert("VariableDeclaration", node, opts);
      }
      function assertVariableDeclarator(node, opts) {
        assert("VariableDeclarator", node, opts);
      }
      function assertWhileStatement(node, opts) {
        assert("WhileStatement", node, opts);
      }
      function assertWithStatement(node, opts) {
        assert("WithStatement", node, opts);
      }
      function assertAssignmentPattern(node, opts) {
        assert("AssignmentPattern", node, opts);
      }
      function assertArrayPattern(node, opts) {
        assert("ArrayPattern", node, opts);
      }
      function assertArrowFunctionExpression(node, opts) {
        assert("ArrowFunctionExpression", node, opts);
      }
      function assertClassBody(node, opts) {
        assert("ClassBody", node, opts);
      }
      function assertClassExpression(node, opts) {
        assert("ClassExpression", node, opts);
      }
      function assertClassDeclaration(node, opts) {
        assert("ClassDeclaration", node, opts);
      }
      function assertExportAllDeclaration(node, opts) {
        assert("ExportAllDeclaration", node, opts);
      }
      function assertExportDefaultDeclaration(node, opts) {
        assert("ExportDefaultDeclaration", node, opts);
      }
      function assertExportNamedDeclaration(node, opts) {
        assert("ExportNamedDeclaration", node, opts);
      }
      function assertExportSpecifier(node, opts) {
        assert("ExportSpecifier", node, opts);
      }
      function assertForOfStatement(node, opts) {
        assert("ForOfStatement", node, opts);
      }
      function assertImportDeclaration(node, opts) {
        assert("ImportDeclaration", node, opts);
      }
      function assertImportDefaultSpecifier(node, opts) {
        assert("ImportDefaultSpecifier", node, opts);
      }
      function assertImportNamespaceSpecifier(node, opts) {
        assert("ImportNamespaceSpecifier", node, opts);
      }
      function assertImportSpecifier(node, opts) {
        assert("ImportSpecifier", node, opts);
      }
      function assertMetaProperty(node, opts) {
        assert("MetaProperty", node, opts);
      }
      function assertClassMethod(node, opts) {
        assert("ClassMethod", node, opts);
      }
      function assertObjectPattern(node, opts) {
        assert("ObjectPattern", node, opts);
      }
      function assertSpreadElement(node, opts) {
        assert("SpreadElement", node, opts);
      }
      function assertSuper(node, opts) {
        assert("Super", node, opts);
      }
      function assertTaggedTemplateExpression(node, opts) {
        assert("TaggedTemplateExpression", node, opts);
      }
      function assertTemplateElement(node, opts) {
        assert("TemplateElement", node, opts);
      }
      function assertTemplateLiteral(node, opts) {
        assert("TemplateLiteral", node, opts);
      }
      function assertYieldExpression(node, opts) {
        assert("YieldExpression", node, opts);
      }
      function assertAwaitExpression(node, opts) {
        assert("AwaitExpression", node, opts);
      }
      function assertImport(node, opts) {
        assert("Import", node, opts);
      }
      function assertBigIntLiteral(node, opts) {
        assert("BigIntLiteral", node, opts);
      }
      function assertExportNamespaceSpecifier(node, opts) {
        assert("ExportNamespaceSpecifier", node, opts);
      }
      function assertOptionalMemberExpression(node, opts) {
        assert("OptionalMemberExpression", node, opts);
      }
      function assertOptionalCallExpression(node, opts) {
        assert("OptionalCallExpression", node, opts);
      }
      function assertClassProperty(node, opts) {
        assert("ClassProperty", node, opts);
      }
      function assertClassAccessorProperty(node, opts) {
        assert("ClassAccessorProperty", node, opts);
      }
      function assertClassPrivateProperty(node, opts) {
        assert("ClassPrivateProperty", node, opts);
      }
      function assertClassPrivateMethod(node, opts) {
        assert("ClassPrivateMethod", node, opts);
      }
      function assertPrivateName(node, opts) {
        assert("PrivateName", node, opts);
      }
      function assertStaticBlock(node, opts) {
        assert("StaticBlock", node, opts);
      }
      function assertAnyTypeAnnotation(node, opts) {
        assert("AnyTypeAnnotation", node, opts);
      }
      function assertArrayTypeAnnotation(node, opts) {
        assert("ArrayTypeAnnotation", node, opts);
      }
      function assertBooleanTypeAnnotation(node, opts) {
        assert("BooleanTypeAnnotation", node, opts);
      }
      function assertBooleanLiteralTypeAnnotation(node, opts) {
        assert("BooleanLiteralTypeAnnotation", node, opts);
      }
      function assertNullLiteralTypeAnnotation(node, opts) {
        assert("NullLiteralTypeAnnotation", node, opts);
      }
      function assertClassImplements(node, opts) {
        assert("ClassImplements", node, opts);
      }
      function assertDeclareClass(node, opts) {
        assert("DeclareClass", node, opts);
      }
      function assertDeclareFunction(node, opts) {
        assert("DeclareFunction", node, opts);
      }
      function assertDeclareInterface(node, opts) {
        assert("DeclareInterface", node, opts);
      }
      function assertDeclareModule(node, opts) {
        assert("DeclareModule", node, opts);
      }
      function assertDeclareModuleExports(node, opts) {
        assert("DeclareModuleExports", node, opts);
      }
      function assertDeclareTypeAlias(node, opts) {
        assert("DeclareTypeAlias", node, opts);
      }
      function assertDeclareOpaqueType(node, opts) {
        assert("DeclareOpaqueType", node, opts);
      }
      function assertDeclareVariable(node, opts) {
        assert("DeclareVariable", node, opts);
      }
      function assertDeclareExportDeclaration(node, opts) {
        assert("DeclareExportDeclaration", node, opts);
      }
      function assertDeclareExportAllDeclaration(node, opts) {
        assert("DeclareExportAllDeclaration", node, opts);
      }
      function assertDeclaredPredicate(node, opts) {
        assert("DeclaredPredicate", node, opts);
      }
      function assertExistsTypeAnnotation(node, opts) {
        assert("ExistsTypeAnnotation", node, opts);
      }
      function assertFunctionTypeAnnotation(node, opts) {
        assert("FunctionTypeAnnotation", node, opts);
      }
      function assertFunctionTypeParam(node, opts) {
        assert("FunctionTypeParam", node, opts);
      }
      function assertGenericTypeAnnotation(node, opts) {
        assert("GenericTypeAnnotation", node, opts);
      }
      function assertInferredPredicate(node, opts) {
        assert("InferredPredicate", node, opts);
      }
      function assertInterfaceExtends(node, opts) {
        assert("InterfaceExtends", node, opts);
      }
      function assertInterfaceDeclaration(node, opts) {
        assert("InterfaceDeclaration", node, opts);
      }
      function assertInterfaceTypeAnnotation(node, opts) {
        assert("InterfaceTypeAnnotation", node, opts);
      }
      function assertIntersectionTypeAnnotation(node, opts) {
        assert("IntersectionTypeAnnotation", node, opts);
      }
      function assertMixedTypeAnnotation(node, opts) {
        assert("MixedTypeAnnotation", node, opts);
      }
      function assertEmptyTypeAnnotation(node, opts) {
        assert("EmptyTypeAnnotation", node, opts);
      }
      function assertNullableTypeAnnotation(node, opts) {
        assert("NullableTypeAnnotation", node, opts);
      }
      function assertNumberLiteralTypeAnnotation(node, opts) {
        assert("NumberLiteralTypeAnnotation", node, opts);
      }
      function assertNumberTypeAnnotation(node, opts) {
        assert("NumberTypeAnnotation", node, opts);
      }
      function assertObjectTypeAnnotation(node, opts) {
        assert("ObjectTypeAnnotation", node, opts);
      }
      function assertObjectTypeInternalSlot(node, opts) {
        assert("ObjectTypeInternalSlot", node, opts);
      }
      function assertObjectTypeCallProperty(node, opts) {
        assert("ObjectTypeCallProperty", node, opts);
      }
      function assertObjectTypeIndexer(node, opts) {
        assert("ObjectTypeIndexer", node, opts);
      }
      function assertObjectTypeProperty(node, opts) {
        assert("ObjectTypeProperty", node, opts);
      }
      function assertObjectTypeSpreadProperty(node, opts) {
        assert("ObjectTypeSpreadProperty", node, opts);
      }
      function assertOpaqueType(node, opts) {
        assert("OpaqueType", node, opts);
      }
      function assertQualifiedTypeIdentifier(node, opts) {
        assert("QualifiedTypeIdentifier", node, opts);
      }
      function assertStringLiteralTypeAnnotation(node, opts) {
        assert("StringLiteralTypeAnnotation", node, opts);
      }
      function assertStringTypeAnnotation(node, opts) {
        assert("StringTypeAnnotation", node, opts);
      }
      function assertSymbolTypeAnnotation(node, opts) {
        assert("SymbolTypeAnnotation", node, opts);
      }
      function assertThisTypeAnnotation(node, opts) {
        assert("ThisTypeAnnotation", node, opts);
      }
      function assertTupleTypeAnnotation(node, opts) {
        assert("TupleTypeAnnotation", node, opts);
      }
      function assertTypeofTypeAnnotation(node, opts) {
        assert("TypeofTypeAnnotation", node, opts);
      }
      function assertTypeAlias(node, opts) {
        assert("TypeAlias", node, opts);
      }
      function assertTypeAnnotation(node, opts) {
        assert("TypeAnnotation", node, opts);
      }
      function assertTypeCastExpression(node, opts) {
        assert("TypeCastExpression", node, opts);
      }
      function assertTypeParameter(node, opts) {
        assert("TypeParameter", node, opts);
      }
      function assertTypeParameterDeclaration(node, opts) {
        assert("TypeParameterDeclaration", node, opts);
      }
      function assertTypeParameterInstantiation(node, opts) {
        assert("TypeParameterInstantiation", node, opts);
      }
      function assertUnionTypeAnnotation(node, opts) {
        assert("UnionTypeAnnotation", node, opts);
      }
      function assertVariance(node, opts) {
        assert("Variance", node, opts);
      }
      function assertVoidTypeAnnotation(node, opts) {
        assert("VoidTypeAnnotation", node, opts);
      }
      function assertEnumDeclaration(node, opts) {
        assert("EnumDeclaration", node, opts);
      }
      function assertEnumBooleanBody(node, opts) {
        assert("EnumBooleanBody", node, opts);
      }
      function assertEnumNumberBody(node, opts) {
        assert("EnumNumberBody", node, opts);
      }
      function assertEnumStringBody(node, opts) {
        assert("EnumStringBody", node, opts);
      }
      function assertEnumSymbolBody(node, opts) {
        assert("EnumSymbolBody", node, opts);
      }
      function assertEnumBooleanMember(node, opts) {
        assert("EnumBooleanMember", node, opts);
      }
      function assertEnumNumberMember(node, opts) {
        assert("EnumNumberMember", node, opts);
      }
      function assertEnumStringMember(node, opts) {
        assert("EnumStringMember", node, opts);
      }
      function assertEnumDefaultedMember(node, opts) {
        assert("EnumDefaultedMember", node, opts);
      }
      function assertIndexedAccessType(node, opts) {
        assert("IndexedAccessType", node, opts);
      }
      function assertOptionalIndexedAccessType(node, opts) {
        assert("OptionalIndexedAccessType", node, opts);
      }
      function assertJSXAttribute(node, opts) {
        assert("JSXAttribute", node, opts);
      }
      function assertJSXClosingElement(node, opts) {
        assert("JSXClosingElement", node, opts);
      }
      function assertJSXElement(node, opts) {
        assert("JSXElement", node, opts);
      }
      function assertJSXEmptyExpression(node, opts) {
        assert("JSXEmptyExpression", node, opts);
      }
      function assertJSXExpressionContainer(node, opts) {
        assert("JSXExpressionContainer", node, opts);
      }
      function assertJSXSpreadChild(node, opts) {
        assert("JSXSpreadChild", node, opts);
      }
      function assertJSXIdentifier(node, opts) {
        assert("JSXIdentifier", node, opts);
      }
      function assertJSXMemberExpression(node, opts) {
        assert("JSXMemberExpression", node, opts);
      }
      function assertJSXNamespacedName(node, opts) {
        assert("JSXNamespacedName", node, opts);
      }
      function assertJSXOpeningElement(node, opts) {
        assert("JSXOpeningElement", node, opts);
      }
      function assertJSXSpreadAttribute(node, opts) {
        assert("JSXSpreadAttribute", node, opts);
      }
      function assertJSXText(node, opts) {
        assert("JSXText", node, opts);
      }
      function assertJSXFragment(node, opts) {
        assert("JSXFragment", node, opts);
      }
      function assertJSXOpeningFragment(node, opts) {
        assert("JSXOpeningFragment", node, opts);
      }
      function assertJSXClosingFragment(node, opts) {
        assert("JSXClosingFragment", node, opts);
      }
      function assertNoop(node, opts) {
        assert("Noop", node, opts);
      }
      function assertPlaceholder(node, opts) {
        assert("Placeholder", node, opts);
      }
      function assertV8IntrinsicIdentifier(node, opts) {
        assert("V8IntrinsicIdentifier", node, opts);
      }
      function assertArgumentPlaceholder(node, opts) {
        assert("ArgumentPlaceholder", node, opts);
      }
      function assertBindExpression(node, opts) {
        assert("BindExpression", node, opts);
      }
      function assertImportAttribute(node, opts) {
        assert("ImportAttribute", node, opts);
      }
      function assertDecorator(node, opts) {
        assert("Decorator", node, opts);
      }
      function assertDoExpression(node, opts) {
        assert("DoExpression", node, opts);
      }
      function assertExportDefaultSpecifier(node, opts) {
        assert("ExportDefaultSpecifier", node, opts);
      }
      function assertRecordExpression(node, opts) {
        assert("RecordExpression", node, opts);
      }
      function assertTupleExpression(node, opts) {
        assert("TupleExpression", node, opts);
      }
      function assertDecimalLiteral(node, opts) {
        assert("DecimalLiteral", node, opts);
      }
      function assertModuleExpression(node, opts) {
        assert("ModuleExpression", node, opts);
      }
      function assertTopicReference(node, opts) {
        assert("TopicReference", node, opts);
      }
      function assertPipelineTopicExpression(node, opts) {
        assert("PipelineTopicExpression", node, opts);
      }
      function assertPipelineBareFunction(node, opts) {
        assert("PipelineBareFunction", node, opts);
      }
      function assertPipelinePrimaryTopicReference(node, opts) {
        assert("PipelinePrimaryTopicReference", node, opts);
      }
      function assertTSParameterProperty(node, opts) {
        assert("TSParameterProperty", node, opts);
      }
      function assertTSDeclareFunction(node, opts) {
        assert("TSDeclareFunction", node, opts);
      }
      function assertTSDeclareMethod(node, opts) {
        assert("TSDeclareMethod", node, opts);
      }
      function assertTSQualifiedName(node, opts) {
        assert("TSQualifiedName", node, opts);
      }
      function assertTSCallSignatureDeclaration(node, opts) {
        assert("TSCallSignatureDeclaration", node, opts);
      }
      function assertTSConstructSignatureDeclaration(node, opts) {
        assert("TSConstructSignatureDeclaration", node, opts);
      }
      function assertTSPropertySignature(node, opts) {
        assert("TSPropertySignature", node, opts);
      }
      function assertTSMethodSignature(node, opts) {
        assert("TSMethodSignature", node, opts);
      }
      function assertTSIndexSignature(node, opts) {
        assert("TSIndexSignature", node, opts);
      }
      function assertTSAnyKeyword(node, opts) {
        assert("TSAnyKeyword", node, opts);
      }
      function assertTSBooleanKeyword(node, opts) {
        assert("TSBooleanKeyword", node, opts);
      }
      function assertTSBigIntKeyword(node, opts) {
        assert("TSBigIntKeyword", node, opts);
      }
      function assertTSIntrinsicKeyword(node, opts) {
        assert("TSIntrinsicKeyword", node, opts);
      }
      function assertTSNeverKeyword(node, opts) {
        assert("TSNeverKeyword", node, opts);
      }
      function assertTSNullKeyword(node, opts) {
        assert("TSNullKeyword", node, opts);
      }
      function assertTSNumberKeyword(node, opts) {
        assert("TSNumberKeyword", node, opts);
      }
      function assertTSObjectKeyword(node, opts) {
        assert("TSObjectKeyword", node, opts);
      }
      function assertTSStringKeyword(node, opts) {
        assert("TSStringKeyword", node, opts);
      }
      function assertTSSymbolKeyword(node, opts) {
        assert("TSSymbolKeyword", node, opts);
      }
      function assertTSUndefinedKeyword(node, opts) {
        assert("TSUndefinedKeyword", node, opts);
      }
      function assertTSUnknownKeyword(node, opts) {
        assert("TSUnknownKeyword", node, opts);
      }
      function assertTSVoidKeyword(node, opts) {
        assert("TSVoidKeyword", node, opts);
      }
      function assertTSThisType(node, opts) {
        assert("TSThisType", node, opts);
      }
      function assertTSFunctionType(node, opts) {
        assert("TSFunctionType", node, opts);
      }
      function assertTSConstructorType(node, opts) {
        assert("TSConstructorType", node, opts);
      }
      function assertTSTypeReference(node, opts) {
        assert("TSTypeReference", node, opts);
      }
      function assertTSTypePredicate(node, opts) {
        assert("TSTypePredicate", node, opts);
      }
      function assertTSTypeQuery(node, opts) {
        assert("TSTypeQuery", node, opts);
      }
      function assertTSTypeLiteral(node, opts) {
        assert("TSTypeLiteral", node, opts);
      }
      function assertTSArrayType(node, opts) {
        assert("TSArrayType", node, opts);
      }
      function assertTSTupleType(node, opts) {
        assert("TSTupleType", node, opts);
      }
      function assertTSOptionalType(node, opts) {
        assert("TSOptionalType", node, opts);
      }
      function assertTSRestType(node, opts) {
        assert("TSRestType", node, opts);
      }
      function assertTSNamedTupleMember(node, opts) {
        assert("TSNamedTupleMember", node, opts);
      }
      function assertTSUnionType(node, opts) {
        assert("TSUnionType", node, opts);
      }
      function assertTSIntersectionType(node, opts) {
        assert("TSIntersectionType", node, opts);
      }
      function assertTSConditionalType(node, opts) {
        assert("TSConditionalType", node, opts);
      }
      function assertTSInferType(node, opts) {
        assert("TSInferType", node, opts);
      }
      function assertTSParenthesizedType(node, opts) {
        assert("TSParenthesizedType", node, opts);
      }
      function assertTSTypeOperator(node, opts) {
        assert("TSTypeOperator", node, opts);
      }
      function assertTSIndexedAccessType(node, opts) {
        assert("TSIndexedAccessType", node, opts);
      }
      function assertTSMappedType(node, opts) {
        assert("TSMappedType", node, opts);
      }
      function assertTSLiteralType(node, opts) {
        assert("TSLiteralType", node, opts);
      }
      function assertTSExpressionWithTypeArguments(node, opts) {
        assert("TSExpressionWithTypeArguments", node, opts);
      }
      function assertTSInterfaceDeclaration(node, opts) {
        assert("TSInterfaceDeclaration", node, opts);
      }
      function assertTSInterfaceBody(node, opts) {
        assert("TSInterfaceBody", node, opts);
      }
      function assertTSTypeAliasDeclaration(node, opts) {
        assert("TSTypeAliasDeclaration", node, opts);
      }
      function assertTSInstantiationExpression(node, opts) {
        assert("TSInstantiationExpression", node, opts);
      }
      function assertTSAsExpression(node, opts) {
        assert("TSAsExpression", node, opts);
      }
      function assertTSSatisfiesExpression(node, opts) {
        assert("TSSatisfiesExpression", node, opts);
      }
      function assertTSTypeAssertion(node, opts) {
        assert("TSTypeAssertion", node, opts);
      }
      function assertTSEnumDeclaration(node, opts) {
        assert("TSEnumDeclaration", node, opts);
      }
      function assertTSEnumMember(node, opts) {
        assert("TSEnumMember", node, opts);
      }
      function assertTSModuleDeclaration(node, opts) {
        assert("TSModuleDeclaration", node, opts);
      }
      function assertTSModuleBlock(node, opts) {
        assert("TSModuleBlock", node, opts);
      }
      function assertTSImportType(node, opts) {
        assert("TSImportType", node, opts);
      }
      function assertTSImportEqualsDeclaration(node, opts) {
        assert("TSImportEqualsDeclaration", node, opts);
      }
      function assertTSExternalModuleReference(node, opts) {
        assert("TSExternalModuleReference", node, opts);
      }
      function assertTSNonNullExpression(node, opts) {
        assert("TSNonNullExpression", node, opts);
      }
      function assertTSExportAssignment(node, opts) {
        assert("TSExportAssignment", node, opts);
      }
      function assertTSNamespaceExportDeclaration(node, opts) {
        assert("TSNamespaceExportDeclaration", node, opts);
      }
      function assertTSTypeAnnotation(node, opts) {
        assert("TSTypeAnnotation", node, opts);
      }
      function assertTSTypeParameterInstantiation(node, opts) {
        assert("TSTypeParameterInstantiation", node, opts);
      }
      function assertTSTypeParameterDeclaration(node, opts) {
        assert("TSTypeParameterDeclaration", node, opts);
      }
      function assertTSTypeParameter(node, opts) {
        assert("TSTypeParameter", node, opts);
      }
      function assertStandardized(node, opts) {
        assert("Standardized", node, opts);
      }
      function assertExpression(node, opts) {
        assert("Expression", node, opts);
      }
      function assertBinary(node, opts) {
        assert("Binary", node, opts);
      }
      function assertScopable(node, opts) {
        assert("Scopable", node, opts);
      }
      function assertBlockParent(node, opts) {
        assert("BlockParent", node, opts);
      }
      function assertBlock(node, opts) {
        assert("Block", node, opts);
      }
      function assertStatement(node, opts) {
        assert("Statement", node, opts);
      }
      function assertTerminatorless(node, opts) {
        assert("Terminatorless", node, opts);
      }
      function assertCompletionStatement(node, opts) {
        assert("CompletionStatement", node, opts);
      }
      function assertConditional(node, opts) {
        assert("Conditional", node, opts);
      }
      function assertLoop(node, opts) {
        assert("Loop", node, opts);
      }
      function assertWhile(node, opts) {
        assert("While", node, opts);
      }
      function assertExpressionWrapper(node, opts) {
        assert("ExpressionWrapper", node, opts);
      }
      function assertFor(node, opts) {
        assert("For", node, opts);
      }
      function assertForXStatement(node, opts) {
        assert("ForXStatement", node, opts);
      }
      function assertFunction(node, opts) {
        assert("Function", node, opts);
      }
      function assertFunctionParent(node, opts) {
        assert("FunctionParent", node, opts);
      }
      function assertPureish(node, opts) {
        assert("Pureish", node, opts);
      }
      function assertDeclaration(node, opts) {
        assert("Declaration", node, opts);
      }
      function assertPatternLike(node, opts) {
        assert("PatternLike", node, opts);
      }
      function assertLVal(node, opts) {
        assert("LVal", node, opts);
      }
      function assertTSEntityName(node, opts) {
        assert("TSEntityName", node, opts);
      }
      function assertLiteral(node, opts) {
        assert("Literal", node, opts);
      }
      function assertImmutable(node, opts) {
        assert("Immutable", node, opts);
      }
      function assertUserWhitespacable(node, opts) {
        assert("UserWhitespacable", node, opts);
      }
      function assertMethod(node, opts) {
        assert("Method", node, opts);
      }
      function assertObjectMember(node, opts) {
        assert("ObjectMember", node, opts);
      }
      function assertProperty(node, opts) {
        assert("Property", node, opts);
      }
      function assertUnaryLike(node, opts) {
        assert("UnaryLike", node, opts);
      }
      function assertPattern(node, opts) {
        assert("Pattern", node, opts);
      }
      function assertClass(node, opts) {
        assert("Class", node, opts);
      }
      function assertModuleDeclaration(node, opts) {
        assert("ModuleDeclaration", node, opts);
      }
      function assertExportDeclaration(node, opts) {
        assert("ExportDeclaration", node, opts);
      }
      function assertModuleSpecifier(node, opts) {
        assert("ModuleSpecifier", node, opts);
      }
      function assertAccessor(node, opts) {
        assert("Accessor", node, opts);
      }
      function assertPrivate(node, opts) {
        assert("Private", node, opts);
      }
      function assertFlow(node, opts) {
        assert("Flow", node, opts);
      }
      function assertFlowType(node, opts) {
        assert("FlowType", node, opts);
      }
      function assertFlowBaseAnnotation(node, opts) {
        assert("FlowBaseAnnotation", node, opts);
      }
      function assertFlowDeclaration(node, opts) {
        assert("FlowDeclaration", node, opts);
      }
      function assertFlowPredicate(node, opts) {
        assert("FlowPredicate", node, opts);
      }
      function assertEnumBody(node, opts) {
        assert("EnumBody", node, opts);
      }
      function assertEnumMember(node, opts) {
        assert("EnumMember", node, opts);
      }
      function assertJSX(node, opts) {
        assert("JSX", node, opts);
      }
      function assertMiscellaneous(node, opts) {
        assert("Miscellaneous", node, opts);
      }
      function assertTypeScript(node, opts) {
        assert("TypeScript", node, opts);
      }
      function assertTSTypeElement(node, opts) {
        assert("TSTypeElement", node, opts);
      }
      function assertTSType(node, opts) {
        assert("TSType", node, opts);
      }
      function assertTSBaseType(node, opts) {
        assert("TSBaseType", node, opts);
      }
      function assertNumberLiteral(node, opts) {
        console.trace("The node type NumberLiteral has been renamed to NumericLiteral");
        assert("NumberLiteral", node, opts);
      }
      function assertRegexLiteral(node, opts) {
        console.trace("The node type RegexLiteral has been renamed to RegExpLiteral");
        assert("RegexLiteral", node, opts);
      }
      function assertRestProperty(node, opts) {
        console.trace("The node type RestProperty has been renamed to RestElement");
        assert("RestProperty", node, opts);
      }
      function assertSpreadProperty(node, opts) {
        console.trace("The node type SpreadProperty has been renamed to SpreadElement");
        assert("SpreadProperty", node, opts);
      }
    }
  });

  // node_modules/@babel/types/lib/builders/flow/createTypeAnnotationBasedOnTypeof.js
  var require_createTypeAnnotationBasedOnTypeof = __commonJS({
    "node_modules/@babel/types/lib/builders/flow/createTypeAnnotationBasedOnTypeof.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _generated = require_generated2();
      var _default = createTypeAnnotationBasedOnTypeof;
      exports2.default = _default;
      function createTypeAnnotationBasedOnTypeof(type) {
        switch (type) {
          case "string":
            return (0, _generated.stringTypeAnnotation)();
          case "number":
            return (0, _generated.numberTypeAnnotation)();
          case "undefined":
            return (0, _generated.voidTypeAnnotation)();
          case "boolean":
            return (0, _generated.booleanTypeAnnotation)();
          case "function":
            return (0, _generated.genericTypeAnnotation)((0, _generated.identifier)("Function"));
          case "object":
            return (0, _generated.genericTypeAnnotation)((0, _generated.identifier)("Object"));
          case "symbol":
            return (0, _generated.genericTypeAnnotation)((0, _generated.identifier)("Symbol"));
          case "bigint":
            return (0, _generated.anyTypeAnnotation)();
        }
        throw new Error("Invalid typeof value: " + type);
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/flow/removeTypeDuplicates.js
  var require_removeTypeDuplicates = __commonJS({
    "node_modules/@babel/types/lib/modifications/flow/removeTypeDuplicates.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = removeTypeDuplicates;
      var _generated = require_generated();
      function getQualifiedName(node) {
        return (0, _generated.isIdentifier)(node) ? node.name : `${node.id.name}.${getQualifiedName(node.qualification)}`;
      }
      function removeTypeDuplicates(nodes) {
        const generics = /* @__PURE__ */ new Map();
        const bases = /* @__PURE__ */ new Map();
        const typeGroups = /* @__PURE__ */ new Set();
        const types = [];
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          if (!node)
            continue;
          if (types.indexOf(node) >= 0) {
            continue;
          }
          if ((0, _generated.isAnyTypeAnnotation)(node)) {
            return [node];
          }
          if ((0, _generated.isFlowBaseAnnotation)(node)) {
            bases.set(node.type, node);
            continue;
          }
          if ((0, _generated.isUnionTypeAnnotation)(node)) {
            if (!typeGroups.has(node.types)) {
              nodes = nodes.concat(node.types);
              typeGroups.add(node.types);
            }
            continue;
          }
          if ((0, _generated.isGenericTypeAnnotation)(node)) {
            const name = getQualifiedName(node.id);
            if (generics.has(name)) {
              let existing = generics.get(name);
              if (existing.typeParameters) {
                if (node.typeParameters) {
                  existing.typeParameters.params = removeTypeDuplicates(existing.typeParameters.params.concat(node.typeParameters.params));
                }
              } else {
                existing = node.typeParameters;
              }
            } else {
              generics.set(name, node);
            }
            continue;
          }
          types.push(node);
        }
        for (const [, baseType] of bases) {
          types.push(baseType);
        }
        for (const [, genericName] of generics) {
          types.push(genericName);
        }
        return types;
      }
    }
  });

  // node_modules/@babel/types/lib/builders/flow/createFlowUnionType.js
  var require_createFlowUnionType = __commonJS({
    "node_modules/@babel/types/lib/builders/flow/createFlowUnionType.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = createFlowUnionType;
      var _generated = require_generated2();
      var _removeTypeDuplicates = require_removeTypeDuplicates();
      function createFlowUnionType(types) {
        const flattened = (0, _removeTypeDuplicates.default)(types);
        if (flattened.length === 1) {
          return flattened[0];
        } else {
          return (0, _generated.unionTypeAnnotation)(flattened);
        }
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/typescript/removeTypeDuplicates.js
  var require_removeTypeDuplicates2 = __commonJS({
    "node_modules/@babel/types/lib/modifications/typescript/removeTypeDuplicates.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = removeTypeDuplicates;
      var _generated = require_generated();
      function getQualifiedName(node) {
        return (0, _generated.isIdentifier)(node) ? node.name : `${node.right.name}.${getQualifiedName(node.left)}`;
      }
      function removeTypeDuplicates(nodes) {
        const generics = /* @__PURE__ */ new Map();
        const bases = /* @__PURE__ */ new Map();
        const typeGroups = /* @__PURE__ */ new Set();
        const types = [];
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          if (!node)
            continue;
          if (types.indexOf(node) >= 0) {
            continue;
          }
          if ((0, _generated.isTSAnyKeyword)(node)) {
            return [node];
          }
          if ((0, _generated.isTSBaseType)(node)) {
            bases.set(node.type, node);
            continue;
          }
          if ((0, _generated.isTSUnionType)(node)) {
            if (!typeGroups.has(node.types)) {
              nodes.push(...node.types);
              typeGroups.add(node.types);
            }
            continue;
          }
          if ((0, _generated.isTSTypeReference)(node) && node.typeParameters) {
            const name = getQualifiedName(node.typeName);
            if (generics.has(name)) {
              let existing = generics.get(name);
              if (existing.typeParameters) {
                if (node.typeParameters) {
                  existing.typeParameters.params = removeTypeDuplicates(existing.typeParameters.params.concat(node.typeParameters.params));
                }
              } else {
                existing = node.typeParameters;
              }
            } else {
              generics.set(name, node);
            }
            continue;
          }
          types.push(node);
        }
        for (const [, baseType] of bases) {
          types.push(baseType);
        }
        for (const [, genericName] of generics) {
          types.push(genericName);
        }
        return types;
      }
    }
  });

  // node_modules/@babel/types/lib/builders/typescript/createTSUnionType.js
  var require_createTSUnionType = __commonJS({
    "node_modules/@babel/types/lib/builders/typescript/createTSUnionType.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = createTSUnionType;
      var _generated = require_generated2();
      var _removeTypeDuplicates = require_removeTypeDuplicates2();
      var _index = require_generated();
      function createTSUnionType(typeAnnotations) {
        const types = typeAnnotations.map((type) => {
          return (0, _index.isTSTypeAnnotation)(type) ? type.typeAnnotation : type;
        });
        const flattened = (0, _removeTypeDuplicates.default)(types);
        if (flattened.length === 1) {
          return flattened[0];
        } else {
          return (0, _generated.tsUnionType)(flattened);
        }
      }
    }
  });

  // node_modules/@babel/types/lib/builders/generated/uppercase.js
  var require_uppercase = __commonJS({
    "node_modules/@babel/types/lib/builders/generated/uppercase.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      Object.defineProperty(exports2, "AnyTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.anyTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ArgumentPlaceholder", {
        enumerable: true,
        get: function() {
          return _index.argumentPlaceholder;
        }
      });
      Object.defineProperty(exports2, "ArrayExpression", {
        enumerable: true,
        get: function() {
          return _index.arrayExpression;
        }
      });
      Object.defineProperty(exports2, "ArrayPattern", {
        enumerable: true,
        get: function() {
          return _index.arrayPattern;
        }
      });
      Object.defineProperty(exports2, "ArrayTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.arrayTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ArrowFunctionExpression", {
        enumerable: true,
        get: function() {
          return _index.arrowFunctionExpression;
        }
      });
      Object.defineProperty(exports2, "AssignmentExpression", {
        enumerable: true,
        get: function() {
          return _index.assignmentExpression;
        }
      });
      Object.defineProperty(exports2, "AssignmentPattern", {
        enumerable: true,
        get: function() {
          return _index.assignmentPattern;
        }
      });
      Object.defineProperty(exports2, "AwaitExpression", {
        enumerable: true,
        get: function() {
          return _index.awaitExpression;
        }
      });
      Object.defineProperty(exports2, "BigIntLiteral", {
        enumerable: true,
        get: function() {
          return _index.bigIntLiteral;
        }
      });
      Object.defineProperty(exports2, "BinaryExpression", {
        enumerable: true,
        get: function() {
          return _index.binaryExpression;
        }
      });
      Object.defineProperty(exports2, "BindExpression", {
        enumerable: true,
        get: function() {
          return _index.bindExpression;
        }
      });
      Object.defineProperty(exports2, "BlockStatement", {
        enumerable: true,
        get: function() {
          return _index.blockStatement;
        }
      });
      Object.defineProperty(exports2, "BooleanLiteral", {
        enumerable: true,
        get: function() {
          return _index.booleanLiteral;
        }
      });
      Object.defineProperty(exports2, "BooleanLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.booleanLiteralTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "BooleanTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.booleanTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "BreakStatement", {
        enumerable: true,
        get: function() {
          return _index.breakStatement;
        }
      });
      Object.defineProperty(exports2, "CallExpression", {
        enumerable: true,
        get: function() {
          return _index.callExpression;
        }
      });
      Object.defineProperty(exports2, "CatchClause", {
        enumerable: true,
        get: function() {
          return _index.catchClause;
        }
      });
      Object.defineProperty(exports2, "ClassAccessorProperty", {
        enumerable: true,
        get: function() {
          return _index.classAccessorProperty;
        }
      });
      Object.defineProperty(exports2, "ClassBody", {
        enumerable: true,
        get: function() {
          return _index.classBody;
        }
      });
      Object.defineProperty(exports2, "ClassDeclaration", {
        enumerable: true,
        get: function() {
          return _index.classDeclaration;
        }
      });
      Object.defineProperty(exports2, "ClassExpression", {
        enumerable: true,
        get: function() {
          return _index.classExpression;
        }
      });
      Object.defineProperty(exports2, "ClassImplements", {
        enumerable: true,
        get: function() {
          return _index.classImplements;
        }
      });
      Object.defineProperty(exports2, "ClassMethod", {
        enumerable: true,
        get: function() {
          return _index.classMethod;
        }
      });
      Object.defineProperty(exports2, "ClassPrivateMethod", {
        enumerable: true,
        get: function() {
          return _index.classPrivateMethod;
        }
      });
      Object.defineProperty(exports2, "ClassPrivateProperty", {
        enumerable: true,
        get: function() {
          return _index.classPrivateProperty;
        }
      });
      Object.defineProperty(exports2, "ClassProperty", {
        enumerable: true,
        get: function() {
          return _index.classProperty;
        }
      });
      Object.defineProperty(exports2, "ConditionalExpression", {
        enumerable: true,
        get: function() {
          return _index.conditionalExpression;
        }
      });
      Object.defineProperty(exports2, "ContinueStatement", {
        enumerable: true,
        get: function() {
          return _index.continueStatement;
        }
      });
      Object.defineProperty(exports2, "DebuggerStatement", {
        enumerable: true,
        get: function() {
          return _index.debuggerStatement;
        }
      });
      Object.defineProperty(exports2, "DecimalLiteral", {
        enumerable: true,
        get: function() {
          return _index.decimalLiteral;
        }
      });
      Object.defineProperty(exports2, "DeclareClass", {
        enumerable: true,
        get: function() {
          return _index.declareClass;
        }
      });
      Object.defineProperty(exports2, "DeclareExportAllDeclaration", {
        enumerable: true,
        get: function() {
          return _index.declareExportAllDeclaration;
        }
      });
      Object.defineProperty(exports2, "DeclareExportDeclaration", {
        enumerable: true,
        get: function() {
          return _index.declareExportDeclaration;
        }
      });
      Object.defineProperty(exports2, "DeclareFunction", {
        enumerable: true,
        get: function() {
          return _index.declareFunction;
        }
      });
      Object.defineProperty(exports2, "DeclareInterface", {
        enumerable: true,
        get: function() {
          return _index.declareInterface;
        }
      });
      Object.defineProperty(exports2, "DeclareModule", {
        enumerable: true,
        get: function() {
          return _index.declareModule;
        }
      });
      Object.defineProperty(exports2, "DeclareModuleExports", {
        enumerable: true,
        get: function() {
          return _index.declareModuleExports;
        }
      });
      Object.defineProperty(exports2, "DeclareOpaqueType", {
        enumerable: true,
        get: function() {
          return _index.declareOpaqueType;
        }
      });
      Object.defineProperty(exports2, "DeclareTypeAlias", {
        enumerable: true,
        get: function() {
          return _index.declareTypeAlias;
        }
      });
      Object.defineProperty(exports2, "DeclareVariable", {
        enumerable: true,
        get: function() {
          return _index.declareVariable;
        }
      });
      Object.defineProperty(exports2, "DeclaredPredicate", {
        enumerable: true,
        get: function() {
          return _index.declaredPredicate;
        }
      });
      Object.defineProperty(exports2, "Decorator", {
        enumerable: true,
        get: function() {
          return _index.decorator;
        }
      });
      Object.defineProperty(exports2, "Directive", {
        enumerable: true,
        get: function() {
          return _index.directive;
        }
      });
      Object.defineProperty(exports2, "DirectiveLiteral", {
        enumerable: true,
        get: function() {
          return _index.directiveLiteral;
        }
      });
      Object.defineProperty(exports2, "DoExpression", {
        enumerable: true,
        get: function() {
          return _index.doExpression;
        }
      });
      Object.defineProperty(exports2, "DoWhileStatement", {
        enumerable: true,
        get: function() {
          return _index.doWhileStatement;
        }
      });
      Object.defineProperty(exports2, "EmptyStatement", {
        enumerable: true,
        get: function() {
          return _index.emptyStatement;
        }
      });
      Object.defineProperty(exports2, "EmptyTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.emptyTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "EnumBooleanBody", {
        enumerable: true,
        get: function() {
          return _index.enumBooleanBody;
        }
      });
      Object.defineProperty(exports2, "EnumBooleanMember", {
        enumerable: true,
        get: function() {
          return _index.enumBooleanMember;
        }
      });
      Object.defineProperty(exports2, "EnumDeclaration", {
        enumerable: true,
        get: function() {
          return _index.enumDeclaration;
        }
      });
      Object.defineProperty(exports2, "EnumDefaultedMember", {
        enumerable: true,
        get: function() {
          return _index.enumDefaultedMember;
        }
      });
      Object.defineProperty(exports2, "EnumNumberBody", {
        enumerable: true,
        get: function() {
          return _index.enumNumberBody;
        }
      });
      Object.defineProperty(exports2, "EnumNumberMember", {
        enumerable: true,
        get: function() {
          return _index.enumNumberMember;
        }
      });
      Object.defineProperty(exports2, "EnumStringBody", {
        enumerable: true,
        get: function() {
          return _index.enumStringBody;
        }
      });
      Object.defineProperty(exports2, "EnumStringMember", {
        enumerable: true,
        get: function() {
          return _index.enumStringMember;
        }
      });
      Object.defineProperty(exports2, "EnumSymbolBody", {
        enumerable: true,
        get: function() {
          return _index.enumSymbolBody;
        }
      });
      Object.defineProperty(exports2, "ExistsTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.existsTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ExportAllDeclaration", {
        enumerable: true,
        get: function() {
          return _index.exportAllDeclaration;
        }
      });
      Object.defineProperty(exports2, "ExportDefaultDeclaration", {
        enumerable: true,
        get: function() {
          return _index.exportDefaultDeclaration;
        }
      });
      Object.defineProperty(exports2, "ExportDefaultSpecifier", {
        enumerable: true,
        get: function() {
          return _index.exportDefaultSpecifier;
        }
      });
      Object.defineProperty(exports2, "ExportNamedDeclaration", {
        enumerable: true,
        get: function() {
          return _index.exportNamedDeclaration;
        }
      });
      Object.defineProperty(exports2, "ExportNamespaceSpecifier", {
        enumerable: true,
        get: function() {
          return _index.exportNamespaceSpecifier;
        }
      });
      Object.defineProperty(exports2, "ExportSpecifier", {
        enumerable: true,
        get: function() {
          return _index.exportSpecifier;
        }
      });
      Object.defineProperty(exports2, "ExpressionStatement", {
        enumerable: true,
        get: function() {
          return _index.expressionStatement;
        }
      });
      Object.defineProperty(exports2, "File", {
        enumerable: true,
        get: function() {
          return _index.file;
        }
      });
      Object.defineProperty(exports2, "ForInStatement", {
        enumerable: true,
        get: function() {
          return _index.forInStatement;
        }
      });
      Object.defineProperty(exports2, "ForOfStatement", {
        enumerable: true,
        get: function() {
          return _index.forOfStatement;
        }
      });
      Object.defineProperty(exports2, "ForStatement", {
        enumerable: true,
        get: function() {
          return _index.forStatement;
        }
      });
      Object.defineProperty(exports2, "FunctionDeclaration", {
        enumerable: true,
        get: function() {
          return _index.functionDeclaration;
        }
      });
      Object.defineProperty(exports2, "FunctionExpression", {
        enumerable: true,
        get: function() {
          return _index.functionExpression;
        }
      });
      Object.defineProperty(exports2, "FunctionTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.functionTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "FunctionTypeParam", {
        enumerable: true,
        get: function() {
          return _index.functionTypeParam;
        }
      });
      Object.defineProperty(exports2, "GenericTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.genericTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "Identifier", {
        enumerable: true,
        get: function() {
          return _index.identifier;
        }
      });
      Object.defineProperty(exports2, "IfStatement", {
        enumerable: true,
        get: function() {
          return _index.ifStatement;
        }
      });
      Object.defineProperty(exports2, "Import", {
        enumerable: true,
        get: function() {
          return _index.import;
        }
      });
      Object.defineProperty(exports2, "ImportAttribute", {
        enumerable: true,
        get: function() {
          return _index.importAttribute;
        }
      });
      Object.defineProperty(exports2, "ImportDeclaration", {
        enumerable: true,
        get: function() {
          return _index.importDeclaration;
        }
      });
      Object.defineProperty(exports2, "ImportDefaultSpecifier", {
        enumerable: true,
        get: function() {
          return _index.importDefaultSpecifier;
        }
      });
      Object.defineProperty(exports2, "ImportNamespaceSpecifier", {
        enumerable: true,
        get: function() {
          return _index.importNamespaceSpecifier;
        }
      });
      Object.defineProperty(exports2, "ImportSpecifier", {
        enumerable: true,
        get: function() {
          return _index.importSpecifier;
        }
      });
      Object.defineProperty(exports2, "IndexedAccessType", {
        enumerable: true,
        get: function() {
          return _index.indexedAccessType;
        }
      });
      Object.defineProperty(exports2, "InferredPredicate", {
        enumerable: true,
        get: function() {
          return _index.inferredPredicate;
        }
      });
      Object.defineProperty(exports2, "InterfaceDeclaration", {
        enumerable: true,
        get: function() {
          return _index.interfaceDeclaration;
        }
      });
      Object.defineProperty(exports2, "InterfaceExtends", {
        enumerable: true,
        get: function() {
          return _index.interfaceExtends;
        }
      });
      Object.defineProperty(exports2, "InterfaceTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.interfaceTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "InterpreterDirective", {
        enumerable: true,
        get: function() {
          return _index.interpreterDirective;
        }
      });
      Object.defineProperty(exports2, "IntersectionTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.intersectionTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "JSXAttribute", {
        enumerable: true,
        get: function() {
          return _index.jsxAttribute;
        }
      });
      Object.defineProperty(exports2, "JSXClosingElement", {
        enumerable: true,
        get: function() {
          return _index.jsxClosingElement;
        }
      });
      Object.defineProperty(exports2, "JSXClosingFragment", {
        enumerable: true,
        get: function() {
          return _index.jsxClosingFragment;
        }
      });
      Object.defineProperty(exports2, "JSXElement", {
        enumerable: true,
        get: function() {
          return _index.jsxElement;
        }
      });
      Object.defineProperty(exports2, "JSXEmptyExpression", {
        enumerable: true,
        get: function() {
          return _index.jsxEmptyExpression;
        }
      });
      Object.defineProperty(exports2, "JSXExpressionContainer", {
        enumerable: true,
        get: function() {
          return _index.jsxExpressionContainer;
        }
      });
      Object.defineProperty(exports2, "JSXFragment", {
        enumerable: true,
        get: function() {
          return _index.jsxFragment;
        }
      });
      Object.defineProperty(exports2, "JSXIdentifier", {
        enumerable: true,
        get: function() {
          return _index.jsxIdentifier;
        }
      });
      Object.defineProperty(exports2, "JSXMemberExpression", {
        enumerable: true,
        get: function() {
          return _index.jsxMemberExpression;
        }
      });
      Object.defineProperty(exports2, "JSXNamespacedName", {
        enumerable: true,
        get: function() {
          return _index.jsxNamespacedName;
        }
      });
      Object.defineProperty(exports2, "JSXOpeningElement", {
        enumerable: true,
        get: function() {
          return _index.jsxOpeningElement;
        }
      });
      Object.defineProperty(exports2, "JSXOpeningFragment", {
        enumerable: true,
        get: function() {
          return _index.jsxOpeningFragment;
        }
      });
      Object.defineProperty(exports2, "JSXSpreadAttribute", {
        enumerable: true,
        get: function() {
          return _index.jsxSpreadAttribute;
        }
      });
      Object.defineProperty(exports2, "JSXSpreadChild", {
        enumerable: true,
        get: function() {
          return _index.jsxSpreadChild;
        }
      });
      Object.defineProperty(exports2, "JSXText", {
        enumerable: true,
        get: function() {
          return _index.jsxText;
        }
      });
      Object.defineProperty(exports2, "LabeledStatement", {
        enumerable: true,
        get: function() {
          return _index.labeledStatement;
        }
      });
      Object.defineProperty(exports2, "LogicalExpression", {
        enumerable: true,
        get: function() {
          return _index.logicalExpression;
        }
      });
      Object.defineProperty(exports2, "MemberExpression", {
        enumerable: true,
        get: function() {
          return _index.memberExpression;
        }
      });
      Object.defineProperty(exports2, "MetaProperty", {
        enumerable: true,
        get: function() {
          return _index.metaProperty;
        }
      });
      Object.defineProperty(exports2, "MixedTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.mixedTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ModuleExpression", {
        enumerable: true,
        get: function() {
          return _index.moduleExpression;
        }
      });
      Object.defineProperty(exports2, "NewExpression", {
        enumerable: true,
        get: function() {
          return _index.newExpression;
        }
      });
      Object.defineProperty(exports2, "Noop", {
        enumerable: true,
        get: function() {
          return _index.noop;
        }
      });
      Object.defineProperty(exports2, "NullLiteral", {
        enumerable: true,
        get: function() {
          return _index.nullLiteral;
        }
      });
      Object.defineProperty(exports2, "NullLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.nullLiteralTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "NullableTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.nullableTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "NumberLiteral", {
        enumerable: true,
        get: function() {
          return _index.numberLiteral;
        }
      });
      Object.defineProperty(exports2, "NumberLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.numberLiteralTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "NumberTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.numberTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "NumericLiteral", {
        enumerable: true,
        get: function() {
          return _index.numericLiteral;
        }
      });
      Object.defineProperty(exports2, "ObjectExpression", {
        enumerable: true,
        get: function() {
          return _index.objectExpression;
        }
      });
      Object.defineProperty(exports2, "ObjectMethod", {
        enumerable: true,
        get: function() {
          return _index.objectMethod;
        }
      });
      Object.defineProperty(exports2, "ObjectPattern", {
        enumerable: true,
        get: function() {
          return _index.objectPattern;
        }
      });
      Object.defineProperty(exports2, "ObjectProperty", {
        enumerable: true,
        get: function() {
          return _index.objectProperty;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.objectTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeCallProperty", {
        enumerable: true,
        get: function() {
          return _index.objectTypeCallProperty;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeIndexer", {
        enumerable: true,
        get: function() {
          return _index.objectTypeIndexer;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeInternalSlot", {
        enumerable: true,
        get: function() {
          return _index.objectTypeInternalSlot;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeProperty", {
        enumerable: true,
        get: function() {
          return _index.objectTypeProperty;
        }
      });
      Object.defineProperty(exports2, "ObjectTypeSpreadProperty", {
        enumerable: true,
        get: function() {
          return _index.objectTypeSpreadProperty;
        }
      });
      Object.defineProperty(exports2, "OpaqueType", {
        enumerable: true,
        get: function() {
          return _index.opaqueType;
        }
      });
      Object.defineProperty(exports2, "OptionalCallExpression", {
        enumerable: true,
        get: function() {
          return _index.optionalCallExpression;
        }
      });
      Object.defineProperty(exports2, "OptionalIndexedAccessType", {
        enumerable: true,
        get: function() {
          return _index.optionalIndexedAccessType;
        }
      });
      Object.defineProperty(exports2, "OptionalMemberExpression", {
        enumerable: true,
        get: function() {
          return _index.optionalMemberExpression;
        }
      });
      Object.defineProperty(exports2, "ParenthesizedExpression", {
        enumerable: true,
        get: function() {
          return _index.parenthesizedExpression;
        }
      });
      Object.defineProperty(exports2, "PipelineBareFunction", {
        enumerable: true,
        get: function() {
          return _index.pipelineBareFunction;
        }
      });
      Object.defineProperty(exports2, "PipelinePrimaryTopicReference", {
        enumerable: true,
        get: function() {
          return _index.pipelinePrimaryTopicReference;
        }
      });
      Object.defineProperty(exports2, "PipelineTopicExpression", {
        enumerable: true,
        get: function() {
          return _index.pipelineTopicExpression;
        }
      });
      Object.defineProperty(exports2, "Placeholder", {
        enumerable: true,
        get: function() {
          return _index.placeholder;
        }
      });
      Object.defineProperty(exports2, "PrivateName", {
        enumerable: true,
        get: function() {
          return _index.privateName;
        }
      });
      Object.defineProperty(exports2, "Program", {
        enumerable: true,
        get: function() {
          return _index.program;
        }
      });
      Object.defineProperty(exports2, "QualifiedTypeIdentifier", {
        enumerable: true,
        get: function() {
          return _index.qualifiedTypeIdentifier;
        }
      });
      Object.defineProperty(exports2, "RecordExpression", {
        enumerable: true,
        get: function() {
          return _index.recordExpression;
        }
      });
      Object.defineProperty(exports2, "RegExpLiteral", {
        enumerable: true,
        get: function() {
          return _index.regExpLiteral;
        }
      });
      Object.defineProperty(exports2, "RegexLiteral", {
        enumerable: true,
        get: function() {
          return _index.regexLiteral;
        }
      });
      Object.defineProperty(exports2, "RestElement", {
        enumerable: true,
        get: function() {
          return _index.restElement;
        }
      });
      Object.defineProperty(exports2, "RestProperty", {
        enumerable: true,
        get: function() {
          return _index.restProperty;
        }
      });
      Object.defineProperty(exports2, "ReturnStatement", {
        enumerable: true,
        get: function() {
          return _index.returnStatement;
        }
      });
      Object.defineProperty(exports2, "SequenceExpression", {
        enumerable: true,
        get: function() {
          return _index.sequenceExpression;
        }
      });
      Object.defineProperty(exports2, "SpreadElement", {
        enumerable: true,
        get: function() {
          return _index.spreadElement;
        }
      });
      Object.defineProperty(exports2, "SpreadProperty", {
        enumerable: true,
        get: function() {
          return _index.spreadProperty;
        }
      });
      Object.defineProperty(exports2, "StaticBlock", {
        enumerable: true,
        get: function() {
          return _index.staticBlock;
        }
      });
      Object.defineProperty(exports2, "StringLiteral", {
        enumerable: true,
        get: function() {
          return _index.stringLiteral;
        }
      });
      Object.defineProperty(exports2, "StringLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.stringLiteralTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "StringTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.stringTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "Super", {
        enumerable: true,
        get: function() {
          return _index.super;
        }
      });
      Object.defineProperty(exports2, "SwitchCase", {
        enumerable: true,
        get: function() {
          return _index.switchCase;
        }
      });
      Object.defineProperty(exports2, "SwitchStatement", {
        enumerable: true,
        get: function() {
          return _index.switchStatement;
        }
      });
      Object.defineProperty(exports2, "SymbolTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.symbolTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "TSAnyKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsAnyKeyword;
        }
      });
      Object.defineProperty(exports2, "TSArrayType", {
        enumerable: true,
        get: function() {
          return _index.tsArrayType;
        }
      });
      Object.defineProperty(exports2, "TSAsExpression", {
        enumerable: true,
        get: function() {
          return _index.tsAsExpression;
        }
      });
      Object.defineProperty(exports2, "TSBigIntKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsBigIntKeyword;
        }
      });
      Object.defineProperty(exports2, "TSBooleanKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsBooleanKeyword;
        }
      });
      Object.defineProperty(exports2, "TSCallSignatureDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsCallSignatureDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSConditionalType", {
        enumerable: true,
        get: function() {
          return _index.tsConditionalType;
        }
      });
      Object.defineProperty(exports2, "TSConstructSignatureDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsConstructSignatureDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSConstructorType", {
        enumerable: true,
        get: function() {
          return _index.tsConstructorType;
        }
      });
      Object.defineProperty(exports2, "TSDeclareFunction", {
        enumerable: true,
        get: function() {
          return _index.tsDeclareFunction;
        }
      });
      Object.defineProperty(exports2, "TSDeclareMethod", {
        enumerable: true,
        get: function() {
          return _index.tsDeclareMethod;
        }
      });
      Object.defineProperty(exports2, "TSEnumDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsEnumDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSEnumMember", {
        enumerable: true,
        get: function() {
          return _index.tsEnumMember;
        }
      });
      Object.defineProperty(exports2, "TSExportAssignment", {
        enumerable: true,
        get: function() {
          return _index.tsExportAssignment;
        }
      });
      Object.defineProperty(exports2, "TSExpressionWithTypeArguments", {
        enumerable: true,
        get: function() {
          return _index.tsExpressionWithTypeArguments;
        }
      });
      Object.defineProperty(exports2, "TSExternalModuleReference", {
        enumerable: true,
        get: function() {
          return _index.tsExternalModuleReference;
        }
      });
      Object.defineProperty(exports2, "TSFunctionType", {
        enumerable: true,
        get: function() {
          return _index.tsFunctionType;
        }
      });
      Object.defineProperty(exports2, "TSImportEqualsDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsImportEqualsDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSImportType", {
        enumerable: true,
        get: function() {
          return _index.tsImportType;
        }
      });
      Object.defineProperty(exports2, "TSIndexSignature", {
        enumerable: true,
        get: function() {
          return _index.tsIndexSignature;
        }
      });
      Object.defineProperty(exports2, "TSIndexedAccessType", {
        enumerable: true,
        get: function() {
          return _index.tsIndexedAccessType;
        }
      });
      Object.defineProperty(exports2, "TSInferType", {
        enumerable: true,
        get: function() {
          return _index.tsInferType;
        }
      });
      Object.defineProperty(exports2, "TSInstantiationExpression", {
        enumerable: true,
        get: function() {
          return _index.tsInstantiationExpression;
        }
      });
      Object.defineProperty(exports2, "TSInterfaceBody", {
        enumerable: true,
        get: function() {
          return _index.tsInterfaceBody;
        }
      });
      Object.defineProperty(exports2, "TSInterfaceDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsInterfaceDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSIntersectionType", {
        enumerable: true,
        get: function() {
          return _index.tsIntersectionType;
        }
      });
      Object.defineProperty(exports2, "TSIntrinsicKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsIntrinsicKeyword;
        }
      });
      Object.defineProperty(exports2, "TSLiteralType", {
        enumerable: true,
        get: function() {
          return _index.tsLiteralType;
        }
      });
      Object.defineProperty(exports2, "TSMappedType", {
        enumerable: true,
        get: function() {
          return _index.tsMappedType;
        }
      });
      Object.defineProperty(exports2, "TSMethodSignature", {
        enumerable: true,
        get: function() {
          return _index.tsMethodSignature;
        }
      });
      Object.defineProperty(exports2, "TSModuleBlock", {
        enumerable: true,
        get: function() {
          return _index.tsModuleBlock;
        }
      });
      Object.defineProperty(exports2, "TSModuleDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsModuleDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSNamedTupleMember", {
        enumerable: true,
        get: function() {
          return _index.tsNamedTupleMember;
        }
      });
      Object.defineProperty(exports2, "TSNamespaceExportDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsNamespaceExportDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSNeverKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsNeverKeyword;
        }
      });
      Object.defineProperty(exports2, "TSNonNullExpression", {
        enumerable: true,
        get: function() {
          return _index.tsNonNullExpression;
        }
      });
      Object.defineProperty(exports2, "TSNullKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsNullKeyword;
        }
      });
      Object.defineProperty(exports2, "TSNumberKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsNumberKeyword;
        }
      });
      Object.defineProperty(exports2, "TSObjectKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsObjectKeyword;
        }
      });
      Object.defineProperty(exports2, "TSOptionalType", {
        enumerable: true,
        get: function() {
          return _index.tsOptionalType;
        }
      });
      Object.defineProperty(exports2, "TSParameterProperty", {
        enumerable: true,
        get: function() {
          return _index.tsParameterProperty;
        }
      });
      Object.defineProperty(exports2, "TSParenthesizedType", {
        enumerable: true,
        get: function() {
          return _index.tsParenthesizedType;
        }
      });
      Object.defineProperty(exports2, "TSPropertySignature", {
        enumerable: true,
        get: function() {
          return _index.tsPropertySignature;
        }
      });
      Object.defineProperty(exports2, "TSQualifiedName", {
        enumerable: true,
        get: function() {
          return _index.tsQualifiedName;
        }
      });
      Object.defineProperty(exports2, "TSRestType", {
        enumerable: true,
        get: function() {
          return _index.tsRestType;
        }
      });
      Object.defineProperty(exports2, "TSSatisfiesExpression", {
        enumerable: true,
        get: function() {
          return _index.tsSatisfiesExpression;
        }
      });
      Object.defineProperty(exports2, "TSStringKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsStringKeyword;
        }
      });
      Object.defineProperty(exports2, "TSSymbolKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsSymbolKeyword;
        }
      });
      Object.defineProperty(exports2, "TSThisType", {
        enumerable: true,
        get: function() {
          return _index.tsThisType;
        }
      });
      Object.defineProperty(exports2, "TSTupleType", {
        enumerable: true,
        get: function() {
          return _index.tsTupleType;
        }
      });
      Object.defineProperty(exports2, "TSTypeAliasDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsTypeAliasDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.tsTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "TSTypeAssertion", {
        enumerable: true,
        get: function() {
          return _index.tsTypeAssertion;
        }
      });
      Object.defineProperty(exports2, "TSTypeLiteral", {
        enumerable: true,
        get: function() {
          return _index.tsTypeLiteral;
        }
      });
      Object.defineProperty(exports2, "TSTypeOperator", {
        enumerable: true,
        get: function() {
          return _index.tsTypeOperator;
        }
      });
      Object.defineProperty(exports2, "TSTypeParameter", {
        enumerable: true,
        get: function() {
          return _index.tsTypeParameter;
        }
      });
      Object.defineProperty(exports2, "TSTypeParameterDeclaration", {
        enumerable: true,
        get: function() {
          return _index.tsTypeParameterDeclaration;
        }
      });
      Object.defineProperty(exports2, "TSTypeParameterInstantiation", {
        enumerable: true,
        get: function() {
          return _index.tsTypeParameterInstantiation;
        }
      });
      Object.defineProperty(exports2, "TSTypePredicate", {
        enumerable: true,
        get: function() {
          return _index.tsTypePredicate;
        }
      });
      Object.defineProperty(exports2, "TSTypeQuery", {
        enumerable: true,
        get: function() {
          return _index.tsTypeQuery;
        }
      });
      Object.defineProperty(exports2, "TSTypeReference", {
        enumerable: true,
        get: function() {
          return _index.tsTypeReference;
        }
      });
      Object.defineProperty(exports2, "TSUndefinedKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsUndefinedKeyword;
        }
      });
      Object.defineProperty(exports2, "TSUnionType", {
        enumerable: true,
        get: function() {
          return _index.tsUnionType;
        }
      });
      Object.defineProperty(exports2, "TSUnknownKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsUnknownKeyword;
        }
      });
      Object.defineProperty(exports2, "TSVoidKeyword", {
        enumerable: true,
        get: function() {
          return _index.tsVoidKeyword;
        }
      });
      Object.defineProperty(exports2, "TaggedTemplateExpression", {
        enumerable: true,
        get: function() {
          return _index.taggedTemplateExpression;
        }
      });
      Object.defineProperty(exports2, "TemplateElement", {
        enumerable: true,
        get: function() {
          return _index.templateElement;
        }
      });
      Object.defineProperty(exports2, "TemplateLiteral", {
        enumerable: true,
        get: function() {
          return _index.templateLiteral;
        }
      });
      Object.defineProperty(exports2, "ThisExpression", {
        enumerable: true,
        get: function() {
          return _index.thisExpression;
        }
      });
      Object.defineProperty(exports2, "ThisTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.thisTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "ThrowStatement", {
        enumerable: true,
        get: function() {
          return _index.throwStatement;
        }
      });
      Object.defineProperty(exports2, "TopicReference", {
        enumerable: true,
        get: function() {
          return _index.topicReference;
        }
      });
      Object.defineProperty(exports2, "TryStatement", {
        enumerable: true,
        get: function() {
          return _index.tryStatement;
        }
      });
      Object.defineProperty(exports2, "TupleExpression", {
        enumerable: true,
        get: function() {
          return _index.tupleExpression;
        }
      });
      Object.defineProperty(exports2, "TupleTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.tupleTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "TypeAlias", {
        enumerable: true,
        get: function() {
          return _index.typeAlias;
        }
      });
      Object.defineProperty(exports2, "TypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.typeAnnotation;
        }
      });
      Object.defineProperty(exports2, "TypeCastExpression", {
        enumerable: true,
        get: function() {
          return _index.typeCastExpression;
        }
      });
      Object.defineProperty(exports2, "TypeParameter", {
        enumerable: true,
        get: function() {
          return _index.typeParameter;
        }
      });
      Object.defineProperty(exports2, "TypeParameterDeclaration", {
        enumerable: true,
        get: function() {
          return _index.typeParameterDeclaration;
        }
      });
      Object.defineProperty(exports2, "TypeParameterInstantiation", {
        enumerable: true,
        get: function() {
          return _index.typeParameterInstantiation;
        }
      });
      Object.defineProperty(exports2, "TypeofTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.typeofTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "UnaryExpression", {
        enumerable: true,
        get: function() {
          return _index.unaryExpression;
        }
      });
      Object.defineProperty(exports2, "UnionTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.unionTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "UpdateExpression", {
        enumerable: true,
        get: function() {
          return _index.updateExpression;
        }
      });
      Object.defineProperty(exports2, "V8IntrinsicIdentifier", {
        enumerable: true,
        get: function() {
          return _index.v8IntrinsicIdentifier;
        }
      });
      Object.defineProperty(exports2, "VariableDeclaration", {
        enumerable: true,
        get: function() {
          return _index.variableDeclaration;
        }
      });
      Object.defineProperty(exports2, "VariableDeclarator", {
        enumerable: true,
        get: function() {
          return _index.variableDeclarator;
        }
      });
      Object.defineProperty(exports2, "Variance", {
        enumerable: true,
        get: function() {
          return _index.variance;
        }
      });
      Object.defineProperty(exports2, "VoidTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _index.voidTypeAnnotation;
        }
      });
      Object.defineProperty(exports2, "WhileStatement", {
        enumerable: true,
        get: function() {
          return _index.whileStatement;
        }
      });
      Object.defineProperty(exports2, "WithStatement", {
        enumerable: true,
        get: function() {
          return _index.withStatement;
        }
      });
      Object.defineProperty(exports2, "YieldExpression", {
        enumerable: true,
        get: function() {
          return _index.yieldExpression;
        }
      });
      var _index = require_generated2();
    }
  });

  // node_modules/@babel/types/lib/clone/cloneNode.js
  var require_cloneNode = __commonJS({
    "node_modules/@babel/types/lib/clone/cloneNode.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = cloneNode;
      var _definitions = require_definitions();
      var _generated = require_generated();
      var has2 = Function.call.bind(Object.prototype.hasOwnProperty);
      function cloneIfNode(obj, deep, withoutLoc, commentsCache) {
        if (obj && typeof obj.type === "string") {
          return cloneNodeInternal(obj, deep, withoutLoc, commentsCache);
        }
        return obj;
      }
      function cloneIfNodeOrArray(obj, deep, withoutLoc, commentsCache) {
        if (Array.isArray(obj)) {
          return obj.map((node) => cloneIfNode(node, deep, withoutLoc, commentsCache));
        }
        return cloneIfNode(obj, deep, withoutLoc, commentsCache);
      }
      function cloneNode(node, deep = true, withoutLoc = false) {
        return cloneNodeInternal(node, deep, withoutLoc, /* @__PURE__ */ new Map());
      }
      function cloneNodeInternal(node, deep = true, withoutLoc = false, commentsCache) {
        if (!node)
          return node;
        const {
          type
        } = node;
        const newNode = {
          type: node.type
        };
        if ((0, _generated.isIdentifier)(node)) {
          newNode.name = node.name;
          if (has2(node, "optional") && typeof node.optional === "boolean") {
            newNode.optional = node.optional;
          }
          if (has2(node, "typeAnnotation")) {
            newNode.typeAnnotation = deep ? cloneIfNodeOrArray(node.typeAnnotation, true, withoutLoc, commentsCache) : node.typeAnnotation;
          }
        } else if (!has2(_definitions.NODE_FIELDS, type)) {
          throw new Error(`Unknown node type: "${type}"`);
        } else {
          for (const field of Object.keys(_definitions.NODE_FIELDS[type])) {
            if (has2(node, field)) {
              if (deep) {
                newNode[field] = (0, _generated.isFile)(node) && field === "comments" ? maybeCloneComments(node.comments, deep, withoutLoc, commentsCache) : cloneIfNodeOrArray(
                  node[field],
                  true,
                  withoutLoc,
                  commentsCache
                );
              } else {
                newNode[field] = node[field];
              }
            }
          }
        }
        if (has2(node, "loc")) {
          if (withoutLoc) {
            newNode.loc = null;
          } else {
            newNode.loc = node.loc;
          }
        }
        if (has2(node, "leadingComments")) {
          newNode.leadingComments = maybeCloneComments(node.leadingComments, deep, withoutLoc, commentsCache);
        }
        if (has2(node, "innerComments")) {
          newNode.innerComments = maybeCloneComments(node.innerComments, deep, withoutLoc, commentsCache);
        }
        if (has2(node, "trailingComments")) {
          newNode.trailingComments = maybeCloneComments(node.trailingComments, deep, withoutLoc, commentsCache);
        }
        if (has2(node, "extra")) {
          newNode.extra = Object.assign({}, node.extra);
        }
        return newNode;
      }
      function maybeCloneComments(comments, deep, withoutLoc, commentsCache) {
        if (!comments || !deep) {
          return comments;
        }
        return comments.map((comment) => {
          const cache = commentsCache.get(comment);
          if (cache)
            return cache;
          const {
            type,
            value,
            loc
          } = comment;
          const ret = {
            type,
            value,
            loc
          };
          if (withoutLoc) {
            ret.loc = null;
          }
          commentsCache.set(comment, ret);
          return ret;
        });
      }
    }
  });

  // node_modules/@babel/types/lib/clone/clone.js
  var require_clone = __commonJS({
    "node_modules/@babel/types/lib/clone/clone.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = clone2;
      var _cloneNode = require_cloneNode();
      function clone2(node) {
        return (0, _cloneNode.default)(node, false);
      }
    }
  });

  // node_modules/@babel/types/lib/clone/cloneDeep.js
  var require_cloneDeep = __commonJS({
    "node_modules/@babel/types/lib/clone/cloneDeep.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = cloneDeep2;
      var _cloneNode = require_cloneNode();
      function cloneDeep2(node) {
        return (0, _cloneNode.default)(node);
      }
    }
  });

  // node_modules/@babel/types/lib/clone/cloneDeepWithoutLoc.js
  var require_cloneDeepWithoutLoc = __commonJS({
    "node_modules/@babel/types/lib/clone/cloneDeepWithoutLoc.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = cloneDeepWithoutLoc;
      var _cloneNode = require_cloneNode();
      function cloneDeepWithoutLoc(node) {
        return (0, _cloneNode.default)(node, true, true);
      }
    }
  });

  // node_modules/@babel/types/lib/clone/cloneWithoutLoc.js
  var require_cloneWithoutLoc = __commonJS({
    "node_modules/@babel/types/lib/clone/cloneWithoutLoc.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = cloneWithoutLoc;
      var _cloneNode = require_cloneNode();
      function cloneWithoutLoc(node) {
        return (0, _cloneNode.default)(node, false, true);
      }
    }
  });

  // node_modules/@babel/types/lib/comments/addComments.js
  var require_addComments = __commonJS({
    "node_modules/@babel/types/lib/comments/addComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = addComments;
      function addComments(node, type, comments) {
        if (!comments || !node)
          return node;
        const key = `${type}Comments`;
        if (node[key]) {
          if (type === "leading") {
            node[key] = comments.concat(node[key]);
          } else {
            node[key].push(...comments);
          }
        } else {
          node[key] = comments;
        }
        return node;
      }
    }
  });

  // node_modules/@babel/types/lib/comments/addComment.js
  var require_addComment = __commonJS({
    "node_modules/@babel/types/lib/comments/addComment.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = addComment;
      var _addComments = require_addComments();
      function addComment(node, type, content, line) {
        return (0, _addComments.default)(node, type, [{
          type: line ? "CommentLine" : "CommentBlock",
          value: content
        }]);
      }
    }
  });

  // node_modules/@babel/types/lib/utils/inherit.js
  var require_inherit = __commonJS({
    "node_modules/@babel/types/lib/utils/inherit.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inherit;
      function inherit(key, child, parent2) {
        if (child && parent2) {
          child[key] = Array.from(new Set([].concat(child[key], parent2[key]).filter(Boolean)));
        }
      }
    }
  });

  // node_modules/@babel/types/lib/comments/inheritInnerComments.js
  var require_inheritInnerComments = __commonJS({
    "node_modules/@babel/types/lib/comments/inheritInnerComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inheritInnerComments;
      var _inherit = require_inherit();
      function inheritInnerComments(child, parent2) {
        (0, _inherit.default)("innerComments", child, parent2);
      }
    }
  });

  // node_modules/@babel/types/lib/comments/inheritLeadingComments.js
  var require_inheritLeadingComments = __commonJS({
    "node_modules/@babel/types/lib/comments/inheritLeadingComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inheritLeadingComments;
      var _inherit = require_inherit();
      function inheritLeadingComments(child, parent2) {
        (0, _inherit.default)("leadingComments", child, parent2);
      }
    }
  });

  // node_modules/@babel/types/lib/comments/inheritTrailingComments.js
  var require_inheritTrailingComments = __commonJS({
    "node_modules/@babel/types/lib/comments/inheritTrailingComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inheritTrailingComments;
      var _inherit = require_inherit();
      function inheritTrailingComments(child, parent2) {
        (0, _inherit.default)("trailingComments", child, parent2);
      }
    }
  });

  // node_modules/@babel/types/lib/comments/inheritsComments.js
  var require_inheritsComments = __commonJS({
    "node_modules/@babel/types/lib/comments/inheritsComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inheritsComments;
      var _inheritTrailingComments = require_inheritTrailingComments();
      var _inheritLeadingComments = require_inheritLeadingComments();
      var _inheritInnerComments = require_inheritInnerComments();
      function inheritsComments(child, parent2) {
        (0, _inheritTrailingComments.default)(child, parent2);
        (0, _inheritLeadingComments.default)(child, parent2);
        (0, _inheritInnerComments.default)(child, parent2);
        return child;
      }
    }
  });

  // node_modules/@babel/types/lib/comments/removeComments.js
  var require_removeComments = __commonJS({
    "node_modules/@babel/types/lib/comments/removeComments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = removeComments;
      var _constants = require_constants();
      function removeComments(node) {
        _constants.COMMENT_KEYS.forEach((key) => {
          node[key] = null;
        });
        return node;
      }
    }
  });

  // node_modules/@babel/types/lib/constants/generated/index.js
  var require_generated4 = __commonJS({
    "node_modules/@babel/types/lib/constants/generated/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.WHILE_TYPES = exports2.USERWHITESPACABLE_TYPES = exports2.UNARYLIKE_TYPES = exports2.TYPESCRIPT_TYPES = exports2.TSTYPE_TYPES = exports2.TSTYPEELEMENT_TYPES = exports2.TSENTITYNAME_TYPES = exports2.TSBASETYPE_TYPES = exports2.TERMINATORLESS_TYPES = exports2.STATEMENT_TYPES = exports2.STANDARDIZED_TYPES = exports2.SCOPABLE_TYPES = exports2.PUREISH_TYPES = exports2.PROPERTY_TYPES = exports2.PRIVATE_TYPES = exports2.PATTERN_TYPES = exports2.PATTERNLIKE_TYPES = exports2.OBJECTMEMBER_TYPES = exports2.MODULESPECIFIER_TYPES = exports2.MODULEDECLARATION_TYPES = exports2.MISCELLANEOUS_TYPES = exports2.METHOD_TYPES = exports2.LVAL_TYPES = exports2.LOOP_TYPES = exports2.LITERAL_TYPES = exports2.JSX_TYPES = exports2.IMMUTABLE_TYPES = exports2.FUNCTION_TYPES = exports2.FUNCTIONPARENT_TYPES = exports2.FOR_TYPES = exports2.FORXSTATEMENT_TYPES = exports2.FLOW_TYPES = exports2.FLOWTYPE_TYPES = exports2.FLOWPREDICATE_TYPES = exports2.FLOWDECLARATION_TYPES = exports2.FLOWBASEANNOTATION_TYPES = exports2.EXPRESSION_TYPES = exports2.EXPRESSIONWRAPPER_TYPES = exports2.EXPORTDECLARATION_TYPES = exports2.ENUMMEMBER_TYPES = exports2.ENUMBODY_TYPES = exports2.DECLARATION_TYPES = exports2.CONDITIONAL_TYPES = exports2.COMPLETIONSTATEMENT_TYPES = exports2.CLASS_TYPES = exports2.BLOCK_TYPES = exports2.BLOCKPARENT_TYPES = exports2.BINARY_TYPES = exports2.ACCESSOR_TYPES = void 0;
      var _definitions = require_definitions();
      var STANDARDIZED_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Standardized"];
      exports2.STANDARDIZED_TYPES = STANDARDIZED_TYPES;
      var EXPRESSION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Expression"];
      exports2.EXPRESSION_TYPES = EXPRESSION_TYPES;
      var BINARY_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Binary"];
      exports2.BINARY_TYPES = BINARY_TYPES;
      var SCOPABLE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Scopable"];
      exports2.SCOPABLE_TYPES = SCOPABLE_TYPES;
      var BLOCKPARENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["BlockParent"];
      exports2.BLOCKPARENT_TYPES = BLOCKPARENT_TYPES;
      var BLOCK_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Block"];
      exports2.BLOCK_TYPES = BLOCK_TYPES;
      var STATEMENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Statement"];
      exports2.STATEMENT_TYPES = STATEMENT_TYPES;
      var TERMINATORLESS_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Terminatorless"];
      exports2.TERMINATORLESS_TYPES = TERMINATORLESS_TYPES;
      var COMPLETIONSTATEMENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["CompletionStatement"];
      exports2.COMPLETIONSTATEMENT_TYPES = COMPLETIONSTATEMENT_TYPES;
      var CONDITIONAL_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Conditional"];
      exports2.CONDITIONAL_TYPES = CONDITIONAL_TYPES;
      var LOOP_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Loop"];
      exports2.LOOP_TYPES = LOOP_TYPES;
      var WHILE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["While"];
      exports2.WHILE_TYPES = WHILE_TYPES;
      var EXPRESSIONWRAPPER_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ExpressionWrapper"];
      exports2.EXPRESSIONWRAPPER_TYPES = EXPRESSIONWRAPPER_TYPES;
      var FOR_TYPES = _definitions.FLIPPED_ALIAS_KEYS["For"];
      exports2.FOR_TYPES = FOR_TYPES;
      var FORXSTATEMENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ForXStatement"];
      exports2.FORXSTATEMENT_TYPES = FORXSTATEMENT_TYPES;
      var FUNCTION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Function"];
      exports2.FUNCTION_TYPES = FUNCTION_TYPES;
      var FUNCTIONPARENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["FunctionParent"];
      exports2.FUNCTIONPARENT_TYPES = FUNCTIONPARENT_TYPES;
      var PUREISH_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Pureish"];
      exports2.PUREISH_TYPES = PUREISH_TYPES;
      var DECLARATION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Declaration"];
      exports2.DECLARATION_TYPES = DECLARATION_TYPES;
      var PATTERNLIKE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["PatternLike"];
      exports2.PATTERNLIKE_TYPES = PATTERNLIKE_TYPES;
      var LVAL_TYPES = _definitions.FLIPPED_ALIAS_KEYS["LVal"];
      exports2.LVAL_TYPES = LVAL_TYPES;
      var TSENTITYNAME_TYPES = _definitions.FLIPPED_ALIAS_KEYS["TSEntityName"];
      exports2.TSENTITYNAME_TYPES = TSENTITYNAME_TYPES;
      var LITERAL_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Literal"];
      exports2.LITERAL_TYPES = LITERAL_TYPES;
      var IMMUTABLE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Immutable"];
      exports2.IMMUTABLE_TYPES = IMMUTABLE_TYPES;
      var USERWHITESPACABLE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["UserWhitespacable"];
      exports2.USERWHITESPACABLE_TYPES = USERWHITESPACABLE_TYPES;
      var METHOD_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Method"];
      exports2.METHOD_TYPES = METHOD_TYPES;
      var OBJECTMEMBER_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ObjectMember"];
      exports2.OBJECTMEMBER_TYPES = OBJECTMEMBER_TYPES;
      var PROPERTY_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Property"];
      exports2.PROPERTY_TYPES = PROPERTY_TYPES;
      var UNARYLIKE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["UnaryLike"];
      exports2.UNARYLIKE_TYPES = UNARYLIKE_TYPES;
      var PATTERN_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Pattern"];
      exports2.PATTERN_TYPES = PATTERN_TYPES;
      var CLASS_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Class"];
      exports2.CLASS_TYPES = CLASS_TYPES;
      var MODULEDECLARATION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ModuleDeclaration"];
      exports2.MODULEDECLARATION_TYPES = MODULEDECLARATION_TYPES;
      var EXPORTDECLARATION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ExportDeclaration"];
      exports2.EXPORTDECLARATION_TYPES = EXPORTDECLARATION_TYPES;
      var MODULESPECIFIER_TYPES = _definitions.FLIPPED_ALIAS_KEYS["ModuleSpecifier"];
      exports2.MODULESPECIFIER_TYPES = MODULESPECIFIER_TYPES;
      var ACCESSOR_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Accessor"];
      exports2.ACCESSOR_TYPES = ACCESSOR_TYPES;
      var PRIVATE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Private"];
      exports2.PRIVATE_TYPES = PRIVATE_TYPES;
      var FLOW_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Flow"];
      exports2.FLOW_TYPES = FLOW_TYPES;
      var FLOWTYPE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["FlowType"];
      exports2.FLOWTYPE_TYPES = FLOWTYPE_TYPES;
      var FLOWBASEANNOTATION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["FlowBaseAnnotation"];
      exports2.FLOWBASEANNOTATION_TYPES = FLOWBASEANNOTATION_TYPES;
      var FLOWDECLARATION_TYPES = _definitions.FLIPPED_ALIAS_KEYS["FlowDeclaration"];
      exports2.FLOWDECLARATION_TYPES = FLOWDECLARATION_TYPES;
      var FLOWPREDICATE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["FlowPredicate"];
      exports2.FLOWPREDICATE_TYPES = FLOWPREDICATE_TYPES;
      var ENUMBODY_TYPES = _definitions.FLIPPED_ALIAS_KEYS["EnumBody"];
      exports2.ENUMBODY_TYPES = ENUMBODY_TYPES;
      var ENUMMEMBER_TYPES = _definitions.FLIPPED_ALIAS_KEYS["EnumMember"];
      exports2.ENUMMEMBER_TYPES = ENUMMEMBER_TYPES;
      var JSX_TYPES = _definitions.FLIPPED_ALIAS_KEYS["JSX"];
      exports2.JSX_TYPES = JSX_TYPES;
      var MISCELLANEOUS_TYPES = _definitions.FLIPPED_ALIAS_KEYS["Miscellaneous"];
      exports2.MISCELLANEOUS_TYPES = MISCELLANEOUS_TYPES;
      var TYPESCRIPT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["TypeScript"];
      exports2.TYPESCRIPT_TYPES = TYPESCRIPT_TYPES;
      var TSTYPEELEMENT_TYPES = _definitions.FLIPPED_ALIAS_KEYS["TSTypeElement"];
      exports2.TSTYPEELEMENT_TYPES = TSTYPEELEMENT_TYPES;
      var TSTYPE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["TSType"];
      exports2.TSTYPE_TYPES = TSTYPE_TYPES;
      var TSBASETYPE_TYPES = _definitions.FLIPPED_ALIAS_KEYS["TSBaseType"];
      exports2.TSBASETYPE_TYPES = TSBASETYPE_TYPES;
    }
  });

  // node_modules/@babel/types/lib/converters/toBlock.js
  var require_toBlock = __commonJS({
    "node_modules/@babel/types/lib/converters/toBlock.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toBlock;
      var _generated = require_generated();
      var _generated2 = require_generated2();
      function toBlock(node, parent2) {
        if ((0, _generated.isBlockStatement)(node)) {
          return node;
        }
        let blockNodes = [];
        if ((0, _generated.isEmptyStatement)(node)) {
          blockNodes = [];
        } else {
          if (!(0, _generated.isStatement)(node)) {
            if ((0, _generated.isFunction)(parent2)) {
              node = (0, _generated2.returnStatement)(node);
            } else {
              node = (0, _generated2.expressionStatement)(node);
            }
          }
          blockNodes = [node];
        }
        return (0, _generated2.blockStatement)(blockNodes);
      }
    }
  });

  // node_modules/@babel/types/lib/converters/ensureBlock.js
  var require_ensureBlock = __commonJS({
    "node_modules/@babel/types/lib/converters/ensureBlock.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = ensureBlock;
      var _toBlock = require_toBlock();
      function ensureBlock(node, key = "body") {
        const result2 = (0, _toBlock.default)(node[key], node);
        node[key] = result2;
        return result2;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toIdentifier.js
  var require_toIdentifier = __commonJS({
    "node_modules/@babel/types/lib/converters/toIdentifier.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toIdentifier;
      var _isValidIdentifier = require_isValidIdentifier();
      var _helperValidatorIdentifier = require_lib3();
      function toIdentifier(input) {
        input = input + "";
        let name = "";
        for (const c of input) {
          name += (0, _helperValidatorIdentifier.isIdentifierChar)(c.codePointAt(0)) ? c : "-";
        }
        name = name.replace(/^[-0-9]+/, "");
        name = name.replace(/[-\s]+(.)?/g, function(match, c) {
          return c ? c.toUpperCase() : "";
        });
        if (!(0, _isValidIdentifier.default)(name)) {
          name = `_${name}`;
        }
        return name || "_";
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toBindingIdentifierName.js
  var require_toBindingIdentifierName = __commonJS({
    "node_modules/@babel/types/lib/converters/toBindingIdentifierName.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toBindingIdentifierName;
      var _toIdentifier = require_toIdentifier();
      function toBindingIdentifierName(name) {
        name = (0, _toIdentifier.default)(name);
        if (name === "eval" || name === "arguments")
          name = "_" + name;
        return name;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toComputedKey.js
  var require_toComputedKey = __commonJS({
    "node_modules/@babel/types/lib/converters/toComputedKey.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toComputedKey;
      var _generated = require_generated();
      var _generated2 = require_generated2();
      function toComputedKey(node, key = node.key || node.property) {
        if (!node.computed && (0, _generated.isIdentifier)(key))
          key = (0, _generated2.stringLiteral)(key.name);
        return key;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toExpression.js
  var require_toExpression = __commonJS({
    "node_modules/@babel/types/lib/converters/toExpression.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _generated = require_generated();
      var _default = toExpression;
      exports2.default = _default;
      function toExpression(node) {
        if ((0, _generated.isExpressionStatement)(node)) {
          node = node.expression;
        }
        if ((0, _generated.isExpression)(node)) {
          return node;
        }
        if ((0, _generated.isClass)(node)) {
          node.type = "ClassExpression";
        } else if ((0, _generated.isFunction)(node)) {
          node.type = "FunctionExpression";
        }
        if (!(0, _generated.isExpression)(node)) {
          throw new Error(`cannot turn ${node.type} to an expression`);
        }
        return node;
      }
    }
  });

  // node_modules/@babel/types/lib/traverse/traverseFast.js
  var require_traverseFast = __commonJS({
    "node_modules/@babel/types/lib/traverse/traverseFast.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = traverseFast;
      var _definitions = require_definitions();
      function traverseFast(node, enter, opts) {
        if (!node)
          return;
        const keys2 = _definitions.VISITOR_KEYS[node.type];
        if (!keys2)
          return;
        opts = opts || {};
        enter(node, opts);
        for (const key of keys2) {
          const subNode = node[key];
          if (Array.isArray(subNode)) {
            for (const node2 of subNode) {
              traverseFast(node2, enter, opts);
            }
          } else {
            traverseFast(subNode, enter, opts);
          }
        }
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/removeProperties.js
  var require_removeProperties = __commonJS({
    "node_modules/@babel/types/lib/modifications/removeProperties.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = removeProperties;
      var _constants = require_constants();
      var CLEAR_KEYS = [
        "tokens",
        "start",
        "end",
        "loc",
        "raw",
        "rawValue"
      ];
      var CLEAR_KEYS_PLUS_COMMENTS = [..._constants.COMMENT_KEYS, "comments", ...CLEAR_KEYS];
      function removeProperties(node, opts = {}) {
        const map2 = opts.preserveComments ? CLEAR_KEYS : CLEAR_KEYS_PLUS_COMMENTS;
        for (const key of map2) {
          if (node[key] != null)
            node[key] = void 0;
        }
        for (const key of Object.keys(node)) {
          if (key[0] === "_" && node[key] != null)
            node[key] = void 0;
        }
        const symbols = Object.getOwnPropertySymbols(node);
        for (const sym of symbols) {
          node[sym] = null;
        }
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/removePropertiesDeep.js
  var require_removePropertiesDeep = __commonJS({
    "node_modules/@babel/types/lib/modifications/removePropertiesDeep.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = removePropertiesDeep;
      var _traverseFast = require_traverseFast();
      var _removeProperties = require_removeProperties();
      function removePropertiesDeep(tree, opts) {
        (0, _traverseFast.default)(tree, _removeProperties.default, opts);
        return tree;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toKeyAlias.js
  var require_toKeyAlias = __commonJS({
    "node_modules/@babel/types/lib/converters/toKeyAlias.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toKeyAlias;
      var _generated = require_generated();
      var _cloneNode = require_cloneNode();
      var _removePropertiesDeep = require_removePropertiesDeep();
      function toKeyAlias(node, key = node.key) {
        let alias;
        if (node.kind === "method") {
          return toKeyAlias.increment() + "";
        } else if ((0, _generated.isIdentifier)(key)) {
          alias = key.name;
        } else if ((0, _generated.isStringLiteral)(key)) {
          alias = JSON.stringify(key.value);
        } else {
          alias = JSON.stringify((0, _removePropertiesDeep.default)((0, _cloneNode.default)(key)));
        }
        if (node.computed) {
          alias = `[${alias}]`;
        }
        if (node.static) {
          alias = `static:${alias}`;
        }
        return alias;
      }
      toKeyAlias.uid = 0;
      toKeyAlias.increment = function() {
        if (toKeyAlias.uid >= Number.MAX_SAFE_INTEGER) {
          return toKeyAlias.uid = 0;
        } else {
          return toKeyAlias.uid++;
        }
      };
    }
  });

  // node_modules/@babel/types/lib/retrievers/getBindingIdentifiers.js
  var require_getBindingIdentifiers = __commonJS({
    "node_modules/@babel/types/lib/retrievers/getBindingIdentifiers.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = getBindingIdentifiers;
      var _generated = require_generated();
      function getBindingIdentifiers(node, duplicates, outerOnly) {
        const search = [].concat(node);
        const ids = /* @__PURE__ */ Object.create(null);
        while (search.length) {
          const id = search.shift();
          if (!id)
            continue;
          const keys2 = getBindingIdentifiers.keys[id.type];
          if ((0, _generated.isIdentifier)(id)) {
            if (duplicates) {
              const _ids = ids[id.name] = ids[id.name] || [];
              _ids.push(id);
            } else {
              ids[id.name] = id;
            }
            continue;
          }
          if ((0, _generated.isExportDeclaration)(id) && !(0, _generated.isExportAllDeclaration)(id)) {
            if ((0, _generated.isDeclaration)(id.declaration)) {
              search.push(id.declaration);
            }
            continue;
          }
          if (outerOnly) {
            if ((0, _generated.isFunctionDeclaration)(id)) {
              search.push(id.id);
              continue;
            }
            if ((0, _generated.isFunctionExpression)(id)) {
              continue;
            }
          }
          if (keys2) {
            for (let i = 0; i < keys2.length; i++) {
              const key = keys2[i];
              const nodes = id[key];
              if (nodes) {
                Array.isArray(nodes) ? search.push(...nodes) : search.push(nodes);
              }
            }
          }
        }
        return ids;
      }
      getBindingIdentifiers.keys = {
        DeclareClass: ["id"],
        DeclareFunction: ["id"],
        DeclareModule: ["id"],
        DeclareVariable: ["id"],
        DeclareInterface: ["id"],
        DeclareTypeAlias: ["id"],
        DeclareOpaqueType: ["id"],
        InterfaceDeclaration: ["id"],
        TypeAlias: ["id"],
        OpaqueType: ["id"],
        CatchClause: ["param"],
        LabeledStatement: ["label"],
        UnaryExpression: ["argument"],
        AssignmentExpression: ["left"],
        ImportSpecifier: ["local"],
        ImportNamespaceSpecifier: ["local"],
        ImportDefaultSpecifier: ["local"],
        ImportDeclaration: ["specifiers"],
        ExportSpecifier: ["exported"],
        ExportNamespaceSpecifier: ["exported"],
        ExportDefaultSpecifier: ["exported"],
        FunctionDeclaration: ["id", "params"],
        FunctionExpression: ["id", "params"],
        ArrowFunctionExpression: ["params"],
        ObjectMethod: ["params"],
        ClassMethod: ["params"],
        ClassPrivateMethod: ["params"],
        ForInStatement: ["left"],
        ForOfStatement: ["left"],
        ClassDeclaration: ["id"],
        ClassExpression: ["id"],
        RestElement: ["argument"],
        UpdateExpression: ["argument"],
        ObjectProperty: ["value"],
        AssignmentPattern: ["left"],
        ArrayPattern: ["elements"],
        ObjectPattern: ["properties"],
        VariableDeclaration: ["declarations"],
        VariableDeclarator: ["id"]
      };
    }
  });

  // node_modules/@babel/types/lib/converters/gatherSequenceExpressions.js
  var require_gatherSequenceExpressions = __commonJS({
    "node_modules/@babel/types/lib/converters/gatherSequenceExpressions.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = gatherSequenceExpressions;
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      var _generated = require_generated();
      var _generated2 = require_generated2();
      var _cloneNode = require_cloneNode();
      function gatherSequenceExpressions(nodes, scope, declars) {
        const exprs = [];
        let ensureLastUndefined = true;
        for (const node of nodes) {
          if (!(0, _generated.isEmptyStatement)(node)) {
            ensureLastUndefined = false;
          }
          if ((0, _generated.isExpression)(node)) {
            exprs.push(node);
          } else if ((0, _generated.isExpressionStatement)(node)) {
            exprs.push(node.expression);
          } else if ((0, _generated.isVariableDeclaration)(node)) {
            if (node.kind !== "var")
              return;
            for (const declar of node.declarations) {
              const bindings = (0, _getBindingIdentifiers.default)(declar);
              for (const key of Object.keys(bindings)) {
                declars.push({
                  kind: node.kind,
                  id: (0, _cloneNode.default)(bindings[key])
                });
              }
              if (declar.init) {
                exprs.push((0, _generated2.assignmentExpression)("=", declar.id, declar.init));
              }
            }
            ensureLastUndefined = true;
          } else if ((0, _generated.isIfStatement)(node)) {
            const consequent = node.consequent ? gatherSequenceExpressions([node.consequent], scope, declars) : scope.buildUndefinedNode();
            const alternate = node.alternate ? gatherSequenceExpressions([node.alternate], scope, declars) : scope.buildUndefinedNode();
            if (!consequent || !alternate)
              return;
            exprs.push((0, _generated2.conditionalExpression)(node.test, consequent, alternate));
          } else if ((0, _generated.isBlockStatement)(node)) {
            const body = gatherSequenceExpressions(node.body, scope, declars);
            if (!body)
              return;
            exprs.push(body);
          } else if ((0, _generated.isEmptyStatement)(node)) {
            if (nodes.indexOf(node) === 0) {
              ensureLastUndefined = true;
            }
          } else {
            return;
          }
        }
        if (ensureLastUndefined) {
          exprs.push(scope.buildUndefinedNode());
        }
        if (exprs.length === 1) {
          return exprs[0];
        } else {
          return (0, _generated2.sequenceExpression)(exprs);
        }
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toSequenceExpression.js
  var require_toSequenceExpression = __commonJS({
    "node_modules/@babel/types/lib/converters/toSequenceExpression.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = toSequenceExpression;
      var _gatherSequenceExpressions = require_gatherSequenceExpressions();
      function toSequenceExpression(nodes, scope) {
        if (!(nodes != null && nodes.length))
          return;
        const declars = [];
        const result2 = (0, _gatherSequenceExpressions.default)(nodes, scope, declars);
        if (!result2)
          return;
        for (const declar of declars) {
          scope.push(declar);
        }
        return result2;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/toStatement.js
  var require_toStatement = __commonJS({
    "node_modules/@babel/types/lib/converters/toStatement.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _generated = require_generated();
      var _generated2 = require_generated2();
      var _default = toStatement;
      exports2.default = _default;
      function toStatement(node, ignore) {
        if ((0, _generated.isStatement)(node)) {
          return node;
        }
        let mustHaveId = false;
        let newType;
        if ((0, _generated.isClass)(node)) {
          mustHaveId = true;
          newType = "ClassDeclaration";
        } else if ((0, _generated.isFunction)(node)) {
          mustHaveId = true;
          newType = "FunctionDeclaration";
        } else if ((0, _generated.isAssignmentExpression)(node)) {
          return (0, _generated2.expressionStatement)(node);
        }
        if (mustHaveId && !node.id) {
          newType = false;
        }
        if (!newType) {
          if (ignore) {
            return false;
          } else {
            throw new Error(`cannot turn ${node.type} to a statement`);
          }
        }
        node.type = newType;
        return node;
      }
    }
  });

  // node_modules/@babel/types/lib/converters/valueToNode.js
  var require_valueToNode = __commonJS({
    "node_modules/@babel/types/lib/converters/valueToNode.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _isValidIdentifier = require_isValidIdentifier();
      var _generated = require_generated2();
      var _default = valueToNode;
      exports2.default = _default;
      var objectToString2 = Function.call.bind(Object.prototype.toString);
      function isRegExp2(value) {
        return objectToString2(value) === "[object RegExp]";
      }
      function isPlainObject2(value) {
        if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") {
          return false;
        }
        const proto = Object.getPrototypeOf(value);
        return proto === null || Object.getPrototypeOf(proto) === null;
      }
      function valueToNode(value) {
        if (value === void 0) {
          return (0, _generated.identifier)("undefined");
        }
        if (value === true || value === false) {
          return (0, _generated.booleanLiteral)(value);
        }
        if (value === null) {
          return (0, _generated.nullLiteral)();
        }
        if (typeof value === "string") {
          return (0, _generated.stringLiteral)(value);
        }
        if (typeof value === "number") {
          let result2;
          if (Number.isFinite(value)) {
            result2 = (0, _generated.numericLiteral)(Math.abs(value));
          } else {
            let numerator;
            if (Number.isNaN(value)) {
              numerator = (0, _generated.numericLiteral)(0);
            } else {
              numerator = (0, _generated.numericLiteral)(1);
            }
            result2 = (0, _generated.binaryExpression)("/", numerator, (0, _generated.numericLiteral)(0));
          }
          if (value < 0 || Object.is(value, -0)) {
            result2 = (0, _generated.unaryExpression)("-", result2);
          }
          return result2;
        }
        if (isRegExp2(value)) {
          const pattern = value.source;
          const flags = value.toString().match(/\/([a-z]+|)$/)[1];
          return (0, _generated.regExpLiteral)(pattern, flags);
        }
        if (Array.isArray(value)) {
          return (0, _generated.arrayExpression)(value.map(valueToNode));
        }
        if (isPlainObject2(value)) {
          const props = [];
          for (const key of Object.keys(value)) {
            let nodeKey;
            if ((0, _isValidIdentifier.default)(key)) {
              nodeKey = (0, _generated.identifier)(key);
            } else {
              nodeKey = (0, _generated.stringLiteral)(key);
            }
            props.push((0, _generated.objectProperty)(nodeKey, valueToNode(
              value[key]
            )));
          }
          return (0, _generated.objectExpression)(props);
        }
        throw new Error("don't know how to turn this value into a node");
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/appendToMemberExpression.js
  var require_appendToMemberExpression = __commonJS({
    "node_modules/@babel/types/lib/modifications/appendToMemberExpression.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = appendToMemberExpression;
      var _generated = require_generated2();
      function appendToMemberExpression(member, append, computed = false) {
        member.object = (0, _generated.memberExpression)(member.object, member.property, member.computed);
        member.property = append;
        member.computed = !!computed;
        return member;
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/inherits.js
  var require_inherits = __commonJS({
    "node_modules/@babel/types/lib/modifications/inherits.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = inherits;
      var _constants = require_constants();
      var _inheritsComments = require_inheritsComments();
      function inherits(child, parent2) {
        if (!child || !parent2)
          return child;
        for (const key of _constants.INHERIT_KEYS.optional) {
          if (child[key] == null) {
            child[key] = parent2[key];
          }
        }
        for (const key of Object.keys(parent2)) {
          if (key[0] === "_" && key !== "__clone") {
            child[key] = parent2[key];
          }
        }
        for (const key of _constants.INHERIT_KEYS.force) {
          child[key] = parent2[key];
        }
        (0, _inheritsComments.default)(child, parent2);
        return child;
      }
    }
  });

  // node_modules/@babel/types/lib/modifications/prependToMemberExpression.js
  var require_prependToMemberExpression = __commonJS({
    "node_modules/@babel/types/lib/modifications/prependToMemberExpression.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = prependToMemberExpression;
      var _generated = require_generated2();
      var _ = require_lib5();
      function prependToMemberExpression(member, prepend) {
        if ((0, _.isSuper)(member.object)) {
          throw new Error("Cannot prepend node to super property access (`super.foo`).");
        }
        member.object = (0, _generated.memberExpression)(prepend, member.object);
        return member;
      }
    }
  });

  // node_modules/@babel/types/lib/retrievers/getOuterBindingIdentifiers.js
  var require_getOuterBindingIdentifiers = __commonJS({
    "node_modules/@babel/types/lib/retrievers/getOuterBindingIdentifiers.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      var _default = getOuterBindingIdentifiers;
      exports2.default = _default;
      function getOuterBindingIdentifiers(node, duplicates) {
        return (0, _getBindingIdentifiers.default)(node, duplicates, true);
      }
    }
  });

  // node_modules/@babel/types/lib/traverse/traverse.js
  var require_traverse = __commonJS({
    "node_modules/@babel/types/lib/traverse/traverse.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = traverse3;
      var _definitions = require_definitions();
      function traverse3(node, handlers, state) {
        if (typeof handlers === "function") {
          handlers = {
            enter: handlers
          };
        }
        const {
          enter,
          exit
        } = handlers;
        traverseSimpleImpl(node, enter, exit, state, []);
      }
      function traverseSimpleImpl(node, enter, exit, state, ancestors) {
        const keys2 = _definitions.VISITOR_KEYS[node.type];
        if (!keys2)
          return;
        if (enter)
          enter(node, ancestors, state);
        for (const key of keys2) {
          const subNode = node[key];
          if (Array.isArray(subNode)) {
            for (let i = 0; i < subNode.length; i++) {
              const child = subNode[i];
              if (!child)
                continue;
              ancestors.push({
                node,
                key,
                index: i
              });
              traverseSimpleImpl(child, enter, exit, state, ancestors);
              ancestors.pop();
            }
          } else if (subNode) {
            ancestors.push({
              node,
              key
            });
            traverseSimpleImpl(subNode, enter, exit, state, ancestors);
            ancestors.pop();
          }
        }
        if (exit)
          exit(node, ancestors, state);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isBinding.js
  var require_isBinding = __commonJS({
    "node_modules/@babel/types/lib/validators/isBinding.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isBinding;
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      function isBinding(node, parent2, grandparent) {
        if (grandparent && node.type === "Identifier" && parent2.type === "ObjectProperty" && grandparent.type === "ObjectExpression") {
          return false;
        }
        const keys2 = _getBindingIdentifiers.default.keys[parent2.type];
        if (keys2) {
          for (let i = 0; i < keys2.length; i++) {
            const key = keys2[i];
            const val = parent2[key];
            if (Array.isArray(val)) {
              if (val.indexOf(node) >= 0)
                return true;
            } else {
              if (val === node)
                return true;
            }
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isLet.js
  var require_isLet = __commonJS({
    "node_modules/@babel/types/lib/validators/isLet.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isLet;
      var _generated = require_generated();
      var _constants = require_constants();
      function isLet(node) {
        return (0, _generated.isVariableDeclaration)(node) && (node.kind !== "var" || node[_constants.BLOCK_SCOPED_SYMBOL]);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isBlockScoped.js
  var require_isBlockScoped = __commonJS({
    "node_modules/@babel/types/lib/validators/isBlockScoped.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isBlockScoped;
      var _generated = require_generated();
      var _isLet = require_isLet();
      function isBlockScoped(node) {
        return (0, _generated.isFunctionDeclaration)(node) || (0, _generated.isClassDeclaration)(node) || (0, _isLet.default)(node);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isImmutable.js
  var require_isImmutable = __commonJS({
    "node_modules/@babel/types/lib/validators/isImmutable.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isImmutable;
      var _isType = require_isType();
      var _generated = require_generated();
      function isImmutable(node) {
        if ((0, _isType.default)(node.type, "Immutable"))
          return true;
        if ((0, _generated.isIdentifier)(node)) {
          if (node.name === "undefined") {
            return true;
          } else {
            return false;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isNodesEquivalent.js
  var require_isNodesEquivalent = __commonJS({
    "node_modules/@babel/types/lib/validators/isNodesEquivalent.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isNodesEquivalent;
      var _definitions = require_definitions();
      function isNodesEquivalent(a, b) {
        if (typeof a !== "object" || typeof b !== "object" || a == null || b == null) {
          return a === b;
        }
        if (a.type !== b.type) {
          return false;
        }
        const fields = Object.keys(_definitions.NODE_FIELDS[a.type] || a.type);
        const visitorKeys = _definitions.VISITOR_KEYS[a.type];
        for (const field of fields) {
          const val_a = a[field];
          const val_b = b[field];
          if (typeof val_a !== typeof val_b) {
            return false;
          }
          if (val_a == null && val_b == null) {
            continue;
          } else if (val_a == null || val_b == null) {
            return false;
          }
          if (Array.isArray(val_a)) {
            if (!Array.isArray(val_b)) {
              return false;
            }
            if (val_a.length !== val_b.length) {
              return false;
            }
            for (let i = 0; i < val_a.length; i++) {
              if (!isNodesEquivalent(val_a[i], val_b[i])) {
                return false;
              }
            }
            continue;
          }
          if (typeof val_a === "object" && !(visitorKeys != null && visitorKeys.includes(field))) {
            for (const key of Object.keys(val_a)) {
              if (val_a[key] !== val_b[key]) {
                return false;
              }
            }
            continue;
          }
          if (!isNodesEquivalent(val_a, val_b)) {
            return false;
          }
        }
        return true;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isReferenced.js
  var require_isReferenced = __commonJS({
    "node_modules/@babel/types/lib/validators/isReferenced.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isReferenced;
      function isReferenced(node, parent2, grandparent) {
        switch (parent2.type) {
          case "MemberExpression":
          case "OptionalMemberExpression":
            if (parent2.property === node) {
              return !!parent2.computed;
            }
            return parent2.object === node;
          case "JSXMemberExpression":
            return parent2.object === node;
          case "VariableDeclarator":
            return parent2.init === node;
          case "ArrowFunctionExpression":
            return parent2.body === node;
          case "PrivateName":
            return false;
          case "ClassMethod":
          case "ClassPrivateMethod":
          case "ObjectMethod":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return false;
          case "ObjectProperty":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return !grandparent || grandparent.type !== "ObjectPattern";
          case "ClassProperty":
          case "ClassAccessorProperty":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return true;
          case "ClassPrivateProperty":
            return parent2.key !== node;
          case "ClassDeclaration":
          case "ClassExpression":
            return parent2.superClass === node;
          case "AssignmentExpression":
            return parent2.right === node;
          case "AssignmentPattern":
            return parent2.right === node;
          case "LabeledStatement":
            return false;
          case "CatchClause":
            return false;
          case "RestElement":
            return false;
          case "BreakStatement":
          case "ContinueStatement":
            return false;
          case "FunctionDeclaration":
          case "FunctionExpression":
            return false;
          case "ExportNamespaceSpecifier":
          case "ExportDefaultSpecifier":
            return false;
          case "ExportSpecifier":
            if (grandparent != null && grandparent.source) {
              return false;
            }
            return parent2.local === node;
          case "ImportDefaultSpecifier":
          case "ImportNamespaceSpecifier":
          case "ImportSpecifier":
            return false;
          case "ImportAttribute":
            return false;
          case "JSXAttribute":
            return false;
          case "ObjectPattern":
          case "ArrayPattern":
            return false;
          case "MetaProperty":
            return false;
          case "ObjectTypeProperty":
            return parent2.key !== node;
          case "TSEnumMember":
            return parent2.id !== node;
          case "TSPropertySignature":
            if (parent2.key === node) {
              return !!parent2.computed;
            }
            return true;
        }
        return true;
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isScope.js
  var require_isScope = __commonJS({
    "node_modules/@babel/types/lib/validators/isScope.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isScope;
      var _generated = require_generated();
      function isScope(node, parent2) {
        if ((0, _generated.isBlockStatement)(node) && ((0, _generated.isFunction)(parent2) || (0, _generated.isCatchClause)(parent2))) {
          return false;
        }
        if ((0, _generated.isPattern)(node) && ((0, _generated.isFunction)(parent2) || (0, _generated.isCatchClause)(parent2))) {
          return true;
        }
        return (0, _generated.isScopable)(node);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isSpecifierDefault.js
  var require_isSpecifierDefault = __commonJS({
    "node_modules/@babel/types/lib/validators/isSpecifierDefault.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isSpecifierDefault;
      var _generated = require_generated();
      function isSpecifierDefault(specifier) {
        return (0, _generated.isImportDefaultSpecifier)(specifier) || (0, _generated.isIdentifier)(specifier.imported || specifier.exported, {
          name: "default"
        });
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isValidES3Identifier.js
  var require_isValidES3Identifier = __commonJS({
    "node_modules/@babel/types/lib/validators/isValidES3Identifier.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isValidES3Identifier;
      var _isValidIdentifier = require_isValidIdentifier();
      var RESERVED_WORDS_ES3_ONLY = /* @__PURE__ */ new Set(["abstract", "boolean", "byte", "char", "double", "enum", "final", "float", "goto", "implements", "int", "interface", "long", "native", "package", "private", "protected", "public", "short", "static", "synchronized", "throws", "transient", "volatile"]);
      function isValidES3Identifier(name) {
        return (0, _isValidIdentifier.default)(name) && !RESERVED_WORDS_ES3_ONLY.has(name);
      }
    }
  });

  // node_modules/@babel/types/lib/validators/isVar.js
  var require_isVar = __commonJS({
    "node_modules/@babel/types/lib/validators/isVar.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = isVar;
      var _generated = require_generated();
      var _constants = require_constants();
      function isVar(node) {
        return (0, _generated.isVariableDeclaration)(node, {
          kind: "var"
        }) && !node[_constants.BLOCK_SCOPED_SYMBOL];
      }
    }
  });

  // node_modules/@babel/types/lib/ast-types/generated/index.js
  var require_generated5 = __commonJS({
    "node_modules/@babel/types/lib/ast-types/generated/index.js"() {
      init_define_process();
    }
  });

  // node_modules/@babel/types/lib/index.js
  var require_lib5 = __commonJS({
    "node_modules/@babel/types/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      var _exportNames = {
        react: true,
        assertNode: true,
        createTypeAnnotationBasedOnTypeof: true,
        createUnionTypeAnnotation: true,
        createFlowUnionType: true,
        createTSUnionType: true,
        cloneNode: true,
        clone: true,
        cloneDeep: true,
        cloneDeepWithoutLoc: true,
        cloneWithoutLoc: true,
        addComment: true,
        addComments: true,
        inheritInnerComments: true,
        inheritLeadingComments: true,
        inheritsComments: true,
        inheritTrailingComments: true,
        removeComments: true,
        ensureBlock: true,
        toBindingIdentifierName: true,
        toBlock: true,
        toComputedKey: true,
        toExpression: true,
        toIdentifier: true,
        toKeyAlias: true,
        toSequenceExpression: true,
        toStatement: true,
        valueToNode: true,
        appendToMemberExpression: true,
        inherits: true,
        prependToMemberExpression: true,
        removeProperties: true,
        removePropertiesDeep: true,
        removeTypeDuplicates: true,
        getBindingIdentifiers: true,
        getOuterBindingIdentifiers: true,
        traverse: true,
        traverseFast: true,
        shallowEqual: true,
        is: true,
        isBinding: true,
        isBlockScoped: true,
        isImmutable: true,
        isLet: true,
        isNode: true,
        isNodesEquivalent: true,
        isPlaceholderType: true,
        isReferenced: true,
        isScope: true,
        isSpecifierDefault: true,
        isType: true,
        isValidES3Identifier: true,
        isValidIdentifier: true,
        isVar: true,
        matchesPattern: true,
        validate: true,
        buildMatchMemberExpression: true
      };
      Object.defineProperty(exports2, "addComment", {
        enumerable: true,
        get: function() {
          return _addComment.default;
        }
      });
      Object.defineProperty(exports2, "addComments", {
        enumerable: true,
        get: function() {
          return _addComments.default;
        }
      });
      Object.defineProperty(exports2, "appendToMemberExpression", {
        enumerable: true,
        get: function() {
          return _appendToMemberExpression.default;
        }
      });
      Object.defineProperty(exports2, "assertNode", {
        enumerable: true,
        get: function() {
          return _assertNode.default;
        }
      });
      Object.defineProperty(exports2, "buildMatchMemberExpression", {
        enumerable: true,
        get: function() {
          return _buildMatchMemberExpression.default;
        }
      });
      Object.defineProperty(exports2, "clone", {
        enumerable: true,
        get: function() {
          return _clone.default;
        }
      });
      Object.defineProperty(exports2, "cloneDeep", {
        enumerable: true,
        get: function() {
          return _cloneDeep.default;
        }
      });
      Object.defineProperty(exports2, "cloneDeepWithoutLoc", {
        enumerable: true,
        get: function() {
          return _cloneDeepWithoutLoc.default;
        }
      });
      Object.defineProperty(exports2, "cloneNode", {
        enumerable: true,
        get: function() {
          return _cloneNode.default;
        }
      });
      Object.defineProperty(exports2, "cloneWithoutLoc", {
        enumerable: true,
        get: function() {
          return _cloneWithoutLoc.default;
        }
      });
      Object.defineProperty(exports2, "createFlowUnionType", {
        enumerable: true,
        get: function() {
          return _createFlowUnionType.default;
        }
      });
      Object.defineProperty(exports2, "createTSUnionType", {
        enumerable: true,
        get: function() {
          return _createTSUnionType.default;
        }
      });
      Object.defineProperty(exports2, "createTypeAnnotationBasedOnTypeof", {
        enumerable: true,
        get: function() {
          return _createTypeAnnotationBasedOnTypeof.default;
        }
      });
      Object.defineProperty(exports2, "createUnionTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _createFlowUnionType.default;
        }
      });
      Object.defineProperty(exports2, "ensureBlock", {
        enumerable: true,
        get: function() {
          return _ensureBlock.default;
        }
      });
      Object.defineProperty(exports2, "getBindingIdentifiers", {
        enumerable: true,
        get: function() {
          return _getBindingIdentifiers.default;
        }
      });
      Object.defineProperty(exports2, "getOuterBindingIdentifiers", {
        enumerable: true,
        get: function() {
          return _getOuterBindingIdentifiers.default;
        }
      });
      Object.defineProperty(exports2, "inheritInnerComments", {
        enumerable: true,
        get: function() {
          return _inheritInnerComments.default;
        }
      });
      Object.defineProperty(exports2, "inheritLeadingComments", {
        enumerable: true,
        get: function() {
          return _inheritLeadingComments.default;
        }
      });
      Object.defineProperty(exports2, "inheritTrailingComments", {
        enumerable: true,
        get: function() {
          return _inheritTrailingComments.default;
        }
      });
      Object.defineProperty(exports2, "inherits", {
        enumerable: true,
        get: function() {
          return _inherits.default;
        }
      });
      Object.defineProperty(exports2, "inheritsComments", {
        enumerable: true,
        get: function() {
          return _inheritsComments.default;
        }
      });
      Object.defineProperty(exports2, "is", {
        enumerable: true,
        get: function() {
          return _is.default;
        }
      });
      Object.defineProperty(exports2, "isBinding", {
        enumerable: true,
        get: function() {
          return _isBinding.default;
        }
      });
      Object.defineProperty(exports2, "isBlockScoped", {
        enumerable: true,
        get: function() {
          return _isBlockScoped.default;
        }
      });
      Object.defineProperty(exports2, "isImmutable", {
        enumerable: true,
        get: function() {
          return _isImmutable.default;
        }
      });
      Object.defineProperty(exports2, "isLet", {
        enumerable: true,
        get: function() {
          return _isLet.default;
        }
      });
      Object.defineProperty(exports2, "isNode", {
        enumerable: true,
        get: function() {
          return _isNode.default;
        }
      });
      Object.defineProperty(exports2, "isNodesEquivalent", {
        enumerable: true,
        get: function() {
          return _isNodesEquivalent.default;
        }
      });
      Object.defineProperty(exports2, "isPlaceholderType", {
        enumerable: true,
        get: function() {
          return _isPlaceholderType.default;
        }
      });
      Object.defineProperty(exports2, "isReferenced", {
        enumerable: true,
        get: function() {
          return _isReferenced.default;
        }
      });
      Object.defineProperty(exports2, "isScope", {
        enumerable: true,
        get: function() {
          return _isScope.default;
        }
      });
      Object.defineProperty(exports2, "isSpecifierDefault", {
        enumerable: true,
        get: function() {
          return _isSpecifierDefault.default;
        }
      });
      Object.defineProperty(exports2, "isType", {
        enumerable: true,
        get: function() {
          return _isType.default;
        }
      });
      Object.defineProperty(exports2, "isValidES3Identifier", {
        enumerable: true,
        get: function() {
          return _isValidES3Identifier.default;
        }
      });
      Object.defineProperty(exports2, "isValidIdentifier", {
        enumerable: true,
        get: function() {
          return _isValidIdentifier.default;
        }
      });
      Object.defineProperty(exports2, "isVar", {
        enumerable: true,
        get: function() {
          return _isVar.default;
        }
      });
      Object.defineProperty(exports2, "matchesPattern", {
        enumerable: true,
        get: function() {
          return _matchesPattern.default;
        }
      });
      Object.defineProperty(exports2, "prependToMemberExpression", {
        enumerable: true,
        get: function() {
          return _prependToMemberExpression.default;
        }
      });
      exports2.react = void 0;
      Object.defineProperty(exports2, "removeComments", {
        enumerable: true,
        get: function() {
          return _removeComments.default;
        }
      });
      Object.defineProperty(exports2, "removeProperties", {
        enumerable: true,
        get: function() {
          return _removeProperties.default;
        }
      });
      Object.defineProperty(exports2, "removePropertiesDeep", {
        enumerable: true,
        get: function() {
          return _removePropertiesDeep.default;
        }
      });
      Object.defineProperty(exports2, "removeTypeDuplicates", {
        enumerable: true,
        get: function() {
          return _removeTypeDuplicates.default;
        }
      });
      Object.defineProperty(exports2, "shallowEqual", {
        enumerable: true,
        get: function() {
          return _shallowEqual.default;
        }
      });
      Object.defineProperty(exports2, "toBindingIdentifierName", {
        enumerable: true,
        get: function() {
          return _toBindingIdentifierName.default;
        }
      });
      Object.defineProperty(exports2, "toBlock", {
        enumerable: true,
        get: function() {
          return _toBlock.default;
        }
      });
      Object.defineProperty(exports2, "toComputedKey", {
        enumerable: true,
        get: function() {
          return _toComputedKey.default;
        }
      });
      Object.defineProperty(exports2, "toExpression", {
        enumerable: true,
        get: function() {
          return _toExpression.default;
        }
      });
      Object.defineProperty(exports2, "toIdentifier", {
        enumerable: true,
        get: function() {
          return _toIdentifier.default;
        }
      });
      Object.defineProperty(exports2, "toKeyAlias", {
        enumerable: true,
        get: function() {
          return _toKeyAlias.default;
        }
      });
      Object.defineProperty(exports2, "toSequenceExpression", {
        enumerable: true,
        get: function() {
          return _toSequenceExpression.default;
        }
      });
      Object.defineProperty(exports2, "toStatement", {
        enumerable: true,
        get: function() {
          return _toStatement.default;
        }
      });
      Object.defineProperty(exports2, "traverse", {
        enumerable: true,
        get: function() {
          return _traverse.default;
        }
      });
      Object.defineProperty(exports2, "traverseFast", {
        enumerable: true,
        get: function() {
          return _traverseFast.default;
        }
      });
      Object.defineProperty(exports2, "validate", {
        enumerable: true,
        get: function() {
          return _validate.default;
        }
      });
      Object.defineProperty(exports2, "valueToNode", {
        enumerable: true,
        get: function() {
          return _valueToNode.default;
        }
      });
      var _isReactComponent = require_isReactComponent();
      var _isCompatTag = require_isCompatTag();
      var _buildChildren = require_buildChildren();
      var _assertNode = require_assertNode();
      var _generated = require_generated3();
      Object.keys(_generated).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _generated[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _generated[key];
          }
        });
      });
      var _createTypeAnnotationBasedOnTypeof = require_createTypeAnnotationBasedOnTypeof();
      var _createFlowUnionType = require_createFlowUnionType();
      var _createTSUnionType = require_createTSUnionType();
      var _generated2 = require_generated2();
      Object.keys(_generated2).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _generated2[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _generated2[key];
          }
        });
      });
      var _uppercase = require_uppercase();
      Object.keys(_uppercase).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _uppercase[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _uppercase[key];
          }
        });
      });
      var _cloneNode = require_cloneNode();
      var _clone = require_clone();
      var _cloneDeep = require_cloneDeep();
      var _cloneDeepWithoutLoc = require_cloneDeepWithoutLoc();
      var _cloneWithoutLoc = require_cloneWithoutLoc();
      var _addComment = require_addComment();
      var _addComments = require_addComments();
      var _inheritInnerComments = require_inheritInnerComments();
      var _inheritLeadingComments = require_inheritLeadingComments();
      var _inheritsComments = require_inheritsComments();
      var _inheritTrailingComments = require_inheritTrailingComments();
      var _removeComments = require_removeComments();
      var _generated3 = require_generated4();
      Object.keys(_generated3).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _generated3[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _generated3[key];
          }
        });
      });
      var _constants = require_constants();
      Object.keys(_constants).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _constants[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _constants[key];
          }
        });
      });
      var _ensureBlock = require_ensureBlock();
      var _toBindingIdentifierName = require_toBindingIdentifierName();
      var _toBlock = require_toBlock();
      var _toComputedKey = require_toComputedKey();
      var _toExpression = require_toExpression();
      var _toIdentifier = require_toIdentifier();
      var _toKeyAlias = require_toKeyAlias();
      var _toSequenceExpression = require_toSequenceExpression();
      var _toStatement = require_toStatement();
      var _valueToNode = require_valueToNode();
      var _definitions = require_definitions();
      Object.keys(_definitions).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _definitions[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _definitions[key];
          }
        });
      });
      var _appendToMemberExpression = require_appendToMemberExpression();
      var _inherits = require_inherits();
      var _prependToMemberExpression = require_prependToMemberExpression();
      var _removeProperties = require_removeProperties();
      var _removePropertiesDeep = require_removePropertiesDeep();
      var _removeTypeDuplicates = require_removeTypeDuplicates();
      var _getBindingIdentifiers = require_getBindingIdentifiers();
      var _getOuterBindingIdentifiers = require_getOuterBindingIdentifiers();
      var _traverse = require_traverse();
      Object.keys(_traverse).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _traverse[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _traverse[key];
          }
        });
      });
      var _traverseFast = require_traverseFast();
      var _shallowEqual = require_shallowEqual();
      var _is = require_is();
      var _isBinding = require_isBinding();
      var _isBlockScoped = require_isBlockScoped();
      var _isImmutable = require_isImmutable();
      var _isLet = require_isLet();
      var _isNode = require_isNode();
      var _isNodesEquivalent = require_isNodesEquivalent();
      var _isPlaceholderType = require_isPlaceholderType();
      var _isReferenced = require_isReferenced();
      var _isScope = require_isScope();
      var _isSpecifierDefault = require_isSpecifierDefault();
      var _isType = require_isType();
      var _isValidES3Identifier = require_isValidES3Identifier();
      var _isValidIdentifier = require_isValidIdentifier();
      var _isVar = require_isVar();
      var _matchesPattern = require_matchesPattern();
      var _validate = require_validate();
      var _buildMatchMemberExpression = require_buildMatchMemberExpression();
      var _generated4 = require_generated();
      Object.keys(_generated4).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _generated4[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _generated4[key];
          }
        });
      });
      var _generated5 = require_generated5();
      Object.keys(_generated5).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports2 && exports2[key] === _generated5[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _generated5[key];
          }
        });
      });
      var react = {
        isReactComponent: _isReactComponent.default,
        isCompatTag: _isCompatTag.default,
        buildChildren: _buildChildren.default
      };
      exports2.react = react;
    }
  });

  // node_modules/@babel/generator/lib/node/whitespace.js
  var require_whitespace = __commonJS({
    "node_modules/@babel/generator/lib/node/whitespace.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.nodes = void 0;
      var _t = require_lib5();
      var {
        FLIPPED_ALIAS_KEYS,
        isArrayExpression,
        isAssignmentExpression,
        isBinary,
        isBlockStatement,
        isCallExpression,
        isFunction: isFunction2,
        isIdentifier: isIdentifier2,
        isLiteral,
        isMemberExpression,
        isObjectExpression,
        isOptionalCallExpression,
        isOptionalMemberExpression,
        isStringLiteral
      } = _t;
      function crawlInternal(node, state) {
        if (!node)
          return state;
        if (isMemberExpression(node) || isOptionalMemberExpression(node)) {
          crawlInternal(node.object, state);
          if (node.computed)
            crawlInternal(node.property, state);
        } else if (isBinary(node) || isAssignmentExpression(node)) {
          crawlInternal(node.left, state);
          crawlInternal(node.right, state);
        } else if (isCallExpression(node) || isOptionalCallExpression(node)) {
          state.hasCall = true;
          crawlInternal(node.callee, state);
        } else if (isFunction2(node)) {
          state.hasFunction = true;
        } else if (isIdentifier2(node)) {
          state.hasHelper = state.hasHelper || node.callee && isHelper(node.callee);
        }
        return state;
      }
      function crawl(node) {
        return crawlInternal(node, {
          hasCall: false,
          hasFunction: false,
          hasHelper: false
        });
      }
      function isHelper(node) {
        if (!node)
          return false;
        if (isMemberExpression(node)) {
          return isHelper(node.object) || isHelper(node.property);
        } else if (isIdentifier2(node)) {
          return node.name === "require" || node.name.charCodeAt(0) === 95;
        } else if (isCallExpression(node)) {
          return isHelper(node.callee);
        } else if (isBinary(node) || isAssignmentExpression(node)) {
          return isIdentifier2(node.left) && isHelper(node.left) || isHelper(node.right);
        } else {
          return false;
        }
      }
      function isType(node) {
        return isLiteral(node) || isObjectExpression(node) || isArrayExpression(node) || isIdentifier2(node) || isMemberExpression(node);
      }
      var nodes = {
        AssignmentExpression(node) {
          const state = crawl(node.right);
          if (state.hasCall && state.hasHelper || state.hasFunction) {
            return state.hasFunction ? 1 | 2 : 2;
          }
        },
        SwitchCase(node, parent2) {
          return (!!node.consequent.length || parent2.cases[0] === node ? 1 : 0) | (!node.consequent.length && parent2.cases[parent2.cases.length - 1] === node ? 2 : 0);
        },
        LogicalExpression(node) {
          if (isFunction2(node.left) || isFunction2(node.right)) {
            return 2;
          }
        },
        Literal(node) {
          if (isStringLiteral(node) && node.value === "use strict") {
            return 2;
          }
        },
        CallExpression(node) {
          if (isFunction2(node.callee) || isHelper(node)) {
            return 1 | 2;
          }
        },
        OptionalCallExpression(node) {
          if (isFunction2(node.callee)) {
            return 1 | 2;
          }
        },
        VariableDeclaration(node) {
          for (let i = 0; i < node.declarations.length; i++) {
            const declar = node.declarations[i];
            let enabled = isHelper(declar.id) && !isType(declar.init);
            if (!enabled && declar.init) {
              const state = crawl(declar.init);
              enabled = isHelper(declar.init) && state.hasCall || state.hasFunction;
            }
            if (enabled) {
              return 1 | 2;
            }
          }
        },
        IfStatement(node) {
          if (isBlockStatement(node.consequent)) {
            return 1 | 2;
          }
        }
      };
      exports2.nodes = nodes;
      nodes.ObjectProperty = nodes.ObjectTypeProperty = nodes.ObjectMethod = function(node, parent2) {
        if (parent2.properties[0] === node) {
          return 1;
        }
      };
      nodes.ObjectTypeCallProperty = function(node, parent2) {
        var _parent$properties;
        if (parent2.callProperties[0] === node && !((_parent$properties = parent2.properties) != null && _parent$properties.length)) {
          return 1;
        }
      };
      nodes.ObjectTypeIndexer = function(node, parent2) {
        var _parent$properties2, _parent$callPropertie;
        if (parent2.indexers[0] === node && !((_parent$properties2 = parent2.properties) != null && _parent$properties2.length) && !((_parent$callPropertie = parent2.callProperties) != null && _parent$callPropertie.length)) {
          return 1;
        }
      };
      nodes.ObjectTypeInternalSlot = function(node, parent2) {
        var _parent$properties3, _parent$callPropertie2, _parent$indexers;
        if (parent2.internalSlots[0] === node && !((_parent$properties3 = parent2.properties) != null && _parent$properties3.length) && !((_parent$callPropertie2 = parent2.callProperties) != null && _parent$callPropertie2.length) && !((_parent$indexers = parent2.indexers) != null && _parent$indexers.length)) {
          return 1;
        }
      };
      [["Function", true], ["Class", true], ["Loop", true], ["LabeledStatement", true], ["SwitchStatement", true], ["TryStatement", true]].forEach(function([type, amounts]) {
        [type].concat(FLIPPED_ALIAS_KEYS[type] || []).forEach(function(type2) {
          const ret = amounts ? 1 | 2 : 0;
          nodes[type2] = () => ret;
        });
      });
    }
  });

  // node_modules/@babel/generator/lib/node/parentheses.js
  var require_parentheses = __commonJS({
    "node_modules/@babel/generator/lib/node/parentheses.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ArrowFunctionExpression = ArrowFunctionExpression;
      exports2.AssignmentExpression = AssignmentExpression;
      exports2.Binary = Binary;
      exports2.BinaryExpression = BinaryExpression;
      exports2.ClassExpression = ClassExpression;
      exports2.ConditionalExpression = ConditionalExpression;
      exports2.DoExpression = DoExpression;
      exports2.FunctionExpression = FunctionExpression;
      exports2.FunctionTypeAnnotation = FunctionTypeAnnotation;
      exports2.Identifier = Identifier;
      exports2.LogicalExpression = LogicalExpression;
      exports2.NullableTypeAnnotation = NullableTypeAnnotation;
      exports2.ObjectExpression = ObjectExpression;
      exports2.OptionalIndexedAccessType = OptionalIndexedAccessType;
      exports2.OptionalCallExpression = exports2.OptionalMemberExpression = OptionalMemberExpression;
      exports2.SequenceExpression = SequenceExpression;
      exports2.TSTypeAssertion = exports2.TSSatisfiesExpression = exports2.TSAsExpression = TSAsExpression;
      exports2.TSInferType = TSInferType;
      exports2.TSInstantiationExpression = TSInstantiationExpression;
      exports2.TSIntersectionType = exports2.TSUnionType = TSUnionType;
      exports2.UnaryLike = UnaryLike;
      exports2.IntersectionTypeAnnotation = exports2.UnionTypeAnnotation = UnionTypeAnnotation;
      exports2.UpdateExpression = UpdateExpression;
      exports2.AwaitExpression = exports2.YieldExpression = YieldExpression;
      var _t = require_lib5();
      var {
        isArrayTypeAnnotation,
        isArrowFunctionExpression,
        isAssignmentExpression,
        isAwaitExpression,
        isBinary,
        isBinaryExpression,
        isUpdateExpression,
        isCallExpression,
        isClass,
        isClassExpression,
        isConditional,
        isConditionalExpression,
        isExportDeclaration,
        isExportDefaultDeclaration,
        isExpressionStatement,
        isFor,
        isForInStatement,
        isForOfStatement,
        isForStatement,
        isFunctionExpression,
        isIfStatement,
        isIndexedAccessType,
        isIntersectionTypeAnnotation,
        isLogicalExpression,
        isMemberExpression,
        isNewExpression,
        isNullableTypeAnnotation,
        isObjectPattern,
        isOptionalCallExpression,
        isOptionalMemberExpression,
        isReturnStatement,
        isSequenceExpression,
        isSwitchStatement,
        isTSArrayType,
        isTSAsExpression,
        isTSInstantiationExpression,
        isTSIntersectionType,
        isTSNonNullExpression,
        isTSOptionalType,
        isTSRestType,
        isTSTypeAssertion,
        isTSUnionType,
        isTaggedTemplateExpression,
        isThrowStatement,
        isTypeAnnotation,
        isUnaryLike,
        isUnionTypeAnnotation,
        isVariableDeclarator,
        isWhileStatement,
        isYieldExpression,
        isTSSatisfiesExpression
      } = _t;
      var PRECEDENCE = {
        "||": 0,
        "??": 0,
        "|>": 0,
        "&&": 1,
        "|": 2,
        "^": 3,
        "&": 4,
        "==": 5,
        "===": 5,
        "!=": 5,
        "!==": 5,
        "<": 6,
        ">": 6,
        "<=": 6,
        ">=": 6,
        in: 6,
        instanceof: 6,
        ">>": 7,
        "<<": 7,
        ">>>": 7,
        "+": 8,
        "-": 8,
        "*": 9,
        "/": 9,
        "%": 9,
        "**": 10
      };
      var isClassExtendsClause = (node, parent2) => isClass(parent2, {
        superClass: node
      });
      var hasPostfixPart = (node, parent2) => (isMemberExpression(parent2) || isOptionalMemberExpression(parent2)) && parent2.object === node || (isCallExpression(parent2) || isOptionalCallExpression(parent2) || isNewExpression(parent2)) && parent2.callee === node || isTaggedTemplateExpression(parent2) && parent2.tag === node || isTSNonNullExpression(parent2);
      function NullableTypeAnnotation(node, parent2) {
        return isArrayTypeAnnotation(parent2);
      }
      function FunctionTypeAnnotation(node, parent2, printStack) {
        if (printStack.length < 3)
          return;
        return isUnionTypeAnnotation(parent2) || isIntersectionTypeAnnotation(parent2) || isArrayTypeAnnotation(parent2) || isTypeAnnotation(parent2) && isArrowFunctionExpression(printStack[printStack.length - 3]);
      }
      function UpdateExpression(node, parent2) {
        return hasPostfixPart(node, parent2) || isClassExtendsClause(node, parent2);
      }
      function ObjectExpression(node, parent2, printStack) {
        return isFirstInContext(printStack, 1 | 2);
      }
      function DoExpression(node, parent2, printStack) {
        return !node.async && isFirstInContext(printStack, 1);
      }
      function Binary(node, parent2) {
        if (node.operator === "**" && isBinaryExpression(parent2, {
          operator: "**"
        })) {
          return parent2.left === node;
        }
        if (isClassExtendsClause(node, parent2)) {
          return true;
        }
        if (hasPostfixPart(node, parent2) || isUnaryLike(parent2) || isAwaitExpression(parent2)) {
          return true;
        }
        if (isBinary(parent2)) {
          const parentOp = parent2.operator;
          const parentPos = PRECEDENCE[parentOp];
          const nodeOp = node.operator;
          const nodePos = PRECEDENCE[nodeOp];
          if (parentPos === nodePos && parent2.right === node && !isLogicalExpression(parent2) || parentPos > nodePos) {
            return true;
          }
        }
      }
      function UnionTypeAnnotation(node, parent2) {
        return isArrayTypeAnnotation(parent2) || isNullableTypeAnnotation(parent2) || isIntersectionTypeAnnotation(parent2) || isUnionTypeAnnotation(parent2);
      }
      function OptionalIndexedAccessType(node, parent2) {
        return isIndexedAccessType(parent2, {
          objectType: node
        });
      }
      function TSAsExpression() {
        return true;
      }
      function TSUnionType(node, parent2) {
        return isTSArrayType(parent2) || isTSOptionalType(parent2) || isTSIntersectionType(parent2) || isTSUnionType(parent2) || isTSRestType(parent2);
      }
      function TSInferType(node, parent2) {
        return isTSArrayType(parent2) || isTSOptionalType(parent2);
      }
      function TSInstantiationExpression(node, parent2) {
        return (isCallExpression(parent2) || isOptionalCallExpression(parent2) || isNewExpression(parent2) || isTSInstantiationExpression(parent2)) && !!parent2.typeParameters;
      }
      function BinaryExpression(node, parent2) {
        return node.operator === "in" && (isVariableDeclarator(parent2) || isFor(parent2));
      }
      function SequenceExpression(node, parent2) {
        if (isForStatement(parent2) || isThrowStatement(parent2) || isReturnStatement(parent2) || isIfStatement(parent2) && parent2.test === node || isWhileStatement(parent2) && parent2.test === node || isForInStatement(parent2) && parent2.right === node || isSwitchStatement(parent2) && parent2.discriminant === node || isExpressionStatement(parent2) && parent2.expression === node) {
          return false;
        }
        return true;
      }
      function YieldExpression(node, parent2) {
        return isBinary(parent2) || isUnaryLike(parent2) || hasPostfixPart(node, parent2) || isAwaitExpression(parent2) && isYieldExpression(node) || isConditionalExpression(parent2) && node === parent2.test || isClassExtendsClause(node, parent2);
      }
      function ClassExpression(node, parent2, printStack) {
        return isFirstInContext(printStack, 1 | 4);
      }
      function UnaryLike(node, parent2) {
        return hasPostfixPart(node, parent2) || isBinaryExpression(parent2, {
          operator: "**",
          left: node
        }) || isClassExtendsClause(node, parent2);
      }
      function FunctionExpression(node, parent2, printStack) {
        return isFirstInContext(printStack, 1 | 4);
      }
      function ArrowFunctionExpression(node, parent2) {
        return isExportDeclaration(parent2) || ConditionalExpression(node, parent2);
      }
      function ConditionalExpression(node, parent2) {
        if (isUnaryLike(parent2) || isBinary(parent2) || isConditionalExpression(parent2, {
          test: node
        }) || isAwaitExpression(parent2) || isTSTypeAssertion(parent2) || isTSAsExpression(parent2) || isTSSatisfiesExpression(parent2)) {
          return true;
        }
        return UnaryLike(node, parent2);
      }
      function OptionalMemberExpression(node, parent2) {
        return isCallExpression(parent2, {
          callee: node
        }) || isMemberExpression(parent2, {
          object: node
        });
      }
      function AssignmentExpression(node, parent2) {
        if (isObjectPattern(node.left)) {
          return true;
        } else {
          return ConditionalExpression(node, parent2);
        }
      }
      function LogicalExpression(node, parent2) {
        switch (node.operator) {
          case "||":
            if (!isLogicalExpression(parent2))
              return false;
            return parent2.operator === "??" || parent2.operator === "&&";
          case "&&":
            return isLogicalExpression(parent2, {
              operator: "??"
            });
          case "??":
            return isLogicalExpression(parent2) && parent2.operator !== "??";
        }
      }
      function Identifier(node, parent2, printStack) {
        var _node$extra;
        if ((_node$extra = node.extra) != null && _node$extra.parenthesized && isAssignmentExpression(parent2, {
          left: node
        }) && (isFunctionExpression(parent2.right) || isClassExpression(parent2.right)) && parent2.right.id == null) {
          return true;
        }
        if (node.name === "let") {
          const isFollowedByBracket = isMemberExpression(parent2, {
            object: node,
            computed: true
          }) || isOptionalMemberExpression(parent2, {
            object: node,
            computed: true,
            optional: false
          });
          return isFirstInContext(printStack, isFollowedByBracket ? 1 | 8 | 16 | 32 : 32);
        }
        return node.name === "async" && isForOfStatement(parent2) && node === parent2.left;
      }
      function isFirstInContext(printStack, checkParam) {
        const expressionStatement2 = checkParam & 1;
        const arrowBody = checkParam & 2;
        const exportDefault = checkParam & 4;
        const forHead = checkParam & 8;
        const forInHead = checkParam & 16;
        const forOfHead = checkParam & 32;
        let i = printStack.length - 1;
        if (i <= 0)
          return;
        let node = printStack[i];
        i--;
        let parent2 = printStack[i];
        while (i >= 0) {
          if (expressionStatement2 && isExpressionStatement(parent2, {
            expression: node
          }) || exportDefault && isExportDefaultDeclaration(parent2, {
            declaration: node
          }) || arrowBody && isArrowFunctionExpression(parent2, {
            body: node
          }) || forHead && isForStatement(parent2, {
            init: node
          }) || forInHead && isForInStatement(parent2, {
            left: node
          }) || forOfHead && isForOfStatement(parent2, {
            left: node
          })) {
            return true;
          }
          if (i > 0 && (hasPostfixPart(node, parent2) && !isNewExpression(parent2) || isSequenceExpression(parent2) && parent2.expressions[0] === node || isUpdateExpression(parent2) && !parent2.prefix || isConditional(parent2, {
            test: node
          }) || isBinary(parent2, {
            left: node
          }) || isAssignmentExpression(parent2, {
            left: node
          }))) {
            node = parent2;
            i--;
            parent2 = printStack[i];
          } else {
            return false;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/generator/lib/node/index.js
  var require_node = __commonJS({
    "node_modules/@babel/generator/lib/node/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.needsParens = needsParens;
      exports2.needsWhitespace = needsWhitespace;
      exports2.needsWhitespaceAfter = needsWhitespaceAfter;
      exports2.needsWhitespaceBefore = needsWhitespaceBefore;
      var whitespace = require_whitespace();
      var parens = require_parentheses();
      var _t = require_lib5();
      var {
        FLIPPED_ALIAS_KEYS,
        isCallExpression,
        isExpressionStatement,
        isMemberExpression,
        isNewExpression
      } = _t;
      function expandAliases(obj) {
        const newObj = {};
        function add2(type, func) {
          const fn = newObj[type];
          newObj[type] = fn ? function(node, parent2, stack) {
            const result2 = fn(node, parent2, stack);
            return result2 == null ? func(node, parent2, stack) : result2;
          } : func;
        }
        for (const type of Object.keys(obj)) {
          const aliases = FLIPPED_ALIAS_KEYS[type];
          if (aliases) {
            for (const alias of aliases) {
              add2(alias, obj[type]);
            }
          } else {
            add2(type, obj[type]);
          }
        }
        return newObj;
      }
      var expandedParens = expandAliases(parens);
      var expandedWhitespaceNodes = expandAliases(whitespace.nodes);
      function find2(obj, node, parent2, printStack) {
        const fn = obj[node.type];
        return fn ? fn(node, parent2, printStack) : null;
      }
      function isOrHasCallExpression(node) {
        if (isCallExpression(node)) {
          return true;
        }
        return isMemberExpression(node) && isOrHasCallExpression(node.object);
      }
      function needsWhitespace(node, parent2, type) {
        if (!node)
          return false;
        if (isExpressionStatement(node)) {
          node = node.expression;
        }
        const flag = find2(expandedWhitespaceNodes, node, parent2);
        if (typeof flag === "number") {
          return (flag & type) !== 0;
        }
        return false;
      }
      function needsWhitespaceBefore(node, parent2) {
        return needsWhitespace(node, parent2, 1);
      }
      function needsWhitespaceAfter(node, parent2) {
        return needsWhitespace(node, parent2, 2);
      }
      function needsParens(node, parent2, printStack) {
        if (!parent2)
          return false;
        if (isNewExpression(parent2) && parent2.callee === node) {
          if (isOrHasCallExpression(node))
            return true;
        }
        return find2(expandedParens, node, parent2, printStack);
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/template-literals.js
  var require_template_literals = __commonJS({
    "node_modules/@babel/generator/lib/generators/template-literals.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.TaggedTemplateExpression = TaggedTemplateExpression;
      exports2.TemplateElement = TemplateElement;
      exports2.TemplateLiteral = TemplateLiteral;
      function TaggedTemplateExpression(node) {
        this.print(node.tag, node);
        this.print(node.typeParameters, node);
        this.print(node.quasi, node);
      }
      function TemplateElement(node, parent2) {
        const isFirst = parent2.quasis[0] === node;
        const isLast = parent2.quasis[parent2.quasis.length - 1] === node;
        const value = (isFirst ? "`" : "}") + node.value.raw + (isLast ? "`" : "${");
        this.token(value, true);
      }
      function TemplateLiteral(node) {
        const quasis = node.quasis;
        for (let i = 0; i < quasis.length; i++) {
          this.print(quasis[i], node);
          if (i + 1 < quasis.length) {
            this.print(node.expressions[i], node);
          }
        }
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/expressions.js
  var require_expressions = __commonJS({
    "node_modules/@babel/generator/lib/generators/expressions.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.LogicalExpression = exports2.BinaryExpression = exports2.AssignmentExpression = AssignmentExpression;
      exports2.AssignmentPattern = AssignmentPattern;
      exports2.AwaitExpression = AwaitExpression;
      exports2.BindExpression = BindExpression;
      exports2.CallExpression = CallExpression;
      exports2.ConditionalExpression = ConditionalExpression;
      exports2.Decorator = Decorator;
      exports2.DoExpression = DoExpression;
      exports2.EmptyStatement = EmptyStatement;
      exports2.ExpressionStatement = ExpressionStatement;
      exports2.Import = Import;
      exports2.MemberExpression = MemberExpression;
      exports2.MetaProperty = MetaProperty;
      exports2.ModuleExpression = ModuleExpression;
      exports2.NewExpression = NewExpression;
      exports2.OptionalCallExpression = OptionalCallExpression;
      exports2.OptionalMemberExpression = OptionalMemberExpression;
      exports2.ParenthesizedExpression = ParenthesizedExpression;
      exports2.PrivateName = PrivateName;
      exports2.SequenceExpression = SequenceExpression;
      exports2.Super = Super;
      exports2.ThisExpression = ThisExpression;
      exports2.UnaryExpression = UnaryExpression;
      exports2.UpdateExpression = UpdateExpression;
      exports2.V8IntrinsicIdentifier = V8IntrinsicIdentifier;
      exports2.YieldExpression = YieldExpression;
      var _t = require_lib5();
      var n = require_node();
      var {
        isCallExpression,
        isLiteral,
        isMemberExpression,
        isNewExpression
      } = _t;
      function UnaryExpression(node) {
        if (node.operator === "void" || node.operator === "delete" || node.operator === "typeof" || node.operator === "throw") {
          this.word(node.operator);
          this.space();
        } else {
          this.token(node.operator);
        }
        this.print(node.argument, node);
      }
      function DoExpression(node) {
        if (node.async) {
          this.word("async", true);
          this.space();
        }
        this.word("do");
        this.space();
        this.print(node.body, node);
      }
      function ParenthesizedExpression(node) {
        this.tokenChar(40);
        this.print(node.expression, node);
        this.tokenChar(41);
      }
      function UpdateExpression(node) {
        if (node.prefix) {
          this.token(node.operator);
          this.print(node.argument, node);
        } else {
          this.printTerminatorless(node.argument, node, true);
          this.token(node.operator);
        }
      }
      function ConditionalExpression(node) {
        this.print(node.test, node);
        this.space();
        this.tokenChar(63);
        this.space();
        this.print(node.consequent, node);
        this.space();
        this.tokenChar(58);
        this.space();
        this.print(node.alternate, node);
      }
      function NewExpression(node, parent2) {
        this.word("new");
        this.space();
        this.print(node.callee, node);
        if (this.format.minified && node.arguments.length === 0 && !node.optional && !isCallExpression(parent2, {
          callee: node
        }) && !isMemberExpression(parent2) && !isNewExpression(parent2)) {
          return;
        }
        this.print(node.typeArguments, node);
        this.print(node.typeParameters, node);
        if (node.optional) {
          this.token("?.");
        }
        this.tokenChar(40);
        this.printList(node.arguments, node);
        this.tokenChar(41);
      }
      function SequenceExpression(node) {
        this.printList(node.expressions, node);
      }
      function ThisExpression() {
        this.word("this");
      }
      function Super() {
        this.word("super");
      }
      function isDecoratorMemberExpression(node) {
        switch (node.type) {
          case "Identifier":
            return true;
          case "MemberExpression":
            return !node.computed && node.property.type === "Identifier" && isDecoratorMemberExpression(node.object);
          default:
            return false;
        }
      }
      function shouldParenthesizeDecoratorExpression(node) {
        if (node.type === "ParenthesizedExpression") {
          return false;
        }
        return !isDecoratorMemberExpression(node.type === "CallExpression" ? node.callee : node);
      }
      function Decorator(node) {
        this.tokenChar(64);
        const {
          expression
        } = node;
        if (shouldParenthesizeDecoratorExpression(expression)) {
          this.tokenChar(40);
          this.print(expression, node);
          this.tokenChar(41);
        } else {
          this.print(expression, node);
        }
        this.newline();
      }
      function OptionalMemberExpression(node) {
        this.print(node.object, node);
        if (!node.computed && isMemberExpression(node.property)) {
          throw new TypeError("Got a MemberExpression for MemberExpression property");
        }
        let computed = node.computed;
        if (isLiteral(node.property) && typeof node.property.value === "number") {
          computed = true;
        }
        if (node.optional) {
          this.token("?.");
        }
        if (computed) {
          this.tokenChar(91);
          this.print(node.property, node);
          this.tokenChar(93);
        } else {
          if (!node.optional) {
            this.tokenChar(46);
          }
          this.print(node.property, node);
        }
      }
      function OptionalCallExpression(node) {
        this.print(node.callee, node);
        this.print(node.typeParameters, node);
        if (node.optional) {
          this.token("?.");
        }
        this.print(node.typeArguments, node);
        this.tokenChar(40);
        this.printList(node.arguments, node);
        this.tokenChar(41);
      }
      function CallExpression(node) {
        this.print(node.callee, node);
        this.print(node.typeArguments, node);
        this.print(node.typeParameters, node);
        this.tokenChar(40);
        this.printList(node.arguments, node);
        this.tokenChar(41);
      }
      function Import() {
        this.word("import");
      }
      function AwaitExpression(node) {
        this.word("await");
        if (node.argument) {
          this.space();
          this.printTerminatorless(node.argument, node, false);
        }
      }
      function YieldExpression(node) {
        this.word("yield", true);
        if (node.delegate) {
          this.tokenChar(42);
          if (node.argument) {
            this.space();
            this.print(node.argument, node);
          }
        } else {
          if (node.argument) {
            this.space();
            this.printTerminatorless(node.argument, node, false);
          }
        }
      }
      function EmptyStatement() {
        this.semicolon(true);
      }
      function ExpressionStatement(node) {
        this.print(node.expression, node);
        this.semicolon();
      }
      function AssignmentPattern(node) {
        this.print(node.left, node);
        if (node.left.optional)
          this.tokenChar(63);
        this.print(node.left.typeAnnotation, node);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.right, node);
      }
      function AssignmentExpression(node, parent2) {
        const parens = this.inForStatementInitCounter && node.operator === "in" && !n.needsParens(node, parent2);
        if (parens) {
          this.tokenChar(40);
        }
        this.print(node.left, node);
        this.space();
        if (node.operator === "in" || node.operator === "instanceof") {
          this.word(node.operator);
        } else {
          this.token(node.operator);
        }
        this.space();
        this.print(node.right, node);
        if (parens) {
          this.tokenChar(41);
        }
      }
      function BindExpression(node) {
        this.print(node.object, node);
        this.token("::");
        this.print(node.callee, node);
      }
      function MemberExpression(node) {
        this.print(node.object, node);
        if (!node.computed && isMemberExpression(node.property)) {
          throw new TypeError("Got a MemberExpression for MemberExpression property");
        }
        let computed = node.computed;
        if (isLiteral(node.property) && typeof node.property.value === "number") {
          computed = true;
        }
        if (computed) {
          this.tokenChar(91);
          this.print(node.property, node);
          this.tokenChar(93);
        } else {
          this.tokenChar(46);
          this.print(node.property, node);
        }
      }
      function MetaProperty(node) {
        this.print(node.meta, node);
        this.tokenChar(46);
        this.print(node.property, node);
      }
      function PrivateName(node) {
        this.tokenChar(35);
        this.print(node.id, node);
      }
      function V8IntrinsicIdentifier(node) {
        this.tokenChar(37);
        this.word(node.name);
      }
      function ModuleExpression(node) {
        this.word("module", true);
        this.space();
        this.tokenChar(123);
        this.indent();
        const {
          body
        } = node;
        if (body.body.length || body.directives.length) {
          this.newline();
        }
        this.print(body, node);
        this.dedent();
        this.sourceWithOffset("end", node.loc, 0, -1);
        this.rightBrace();
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/statements.js
  var require_statements = __commonJS({
    "node_modules/@babel/generator/lib/generators/statements.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.BreakStatement = BreakStatement;
      exports2.CatchClause = CatchClause;
      exports2.ContinueStatement = ContinueStatement;
      exports2.DebuggerStatement = DebuggerStatement;
      exports2.DoWhileStatement = DoWhileStatement;
      exports2.ForOfStatement = exports2.ForInStatement = void 0;
      exports2.ForStatement = ForStatement;
      exports2.IfStatement = IfStatement;
      exports2.LabeledStatement = LabeledStatement;
      exports2.ReturnStatement = ReturnStatement;
      exports2.SwitchCase = SwitchCase;
      exports2.SwitchStatement = SwitchStatement;
      exports2.ThrowStatement = ThrowStatement;
      exports2.TryStatement = TryStatement;
      exports2.VariableDeclaration = VariableDeclaration;
      exports2.VariableDeclarator = VariableDeclarator;
      exports2.WhileStatement = WhileStatement;
      exports2.WithStatement = WithStatement;
      var _t = require_lib5();
      var {
        isFor,
        isForStatement,
        isIfStatement,
        isStatement
      } = _t;
      function WithStatement(node) {
        this.word("with");
        this.space();
        this.tokenChar(40);
        this.print(node.object, node);
        this.tokenChar(41);
        this.printBlock(node);
      }
      function IfStatement(node) {
        this.word("if");
        this.space();
        this.tokenChar(40);
        this.print(node.test, node);
        this.tokenChar(41);
        this.space();
        const needsBlock = node.alternate && isIfStatement(getLastStatement(node.consequent));
        if (needsBlock) {
          this.tokenChar(123);
          this.newline();
          this.indent();
        }
        this.printAndIndentOnComments(node.consequent, node);
        if (needsBlock) {
          this.dedent();
          this.newline();
          this.tokenChar(125);
        }
        if (node.alternate) {
          if (this.endsWith(125))
            this.space();
          this.word("else");
          this.space();
          this.printAndIndentOnComments(node.alternate, node);
        }
      }
      function getLastStatement(statement) {
        const {
          body
        } = statement;
        if (isStatement(body) === false) {
          return statement;
        }
        return getLastStatement(body);
      }
      function ForStatement(node) {
        this.word("for");
        this.space();
        this.tokenChar(40);
        this.inForStatementInitCounter++;
        this.print(node.init, node);
        this.inForStatementInitCounter--;
        this.tokenChar(59);
        if (node.test) {
          this.space();
          this.print(node.test, node);
        }
        this.tokenChar(59);
        if (node.update) {
          this.space();
          this.print(node.update, node);
        }
        this.tokenChar(41);
        this.printBlock(node);
      }
      function WhileStatement(node) {
        this.word("while");
        this.space();
        this.tokenChar(40);
        this.print(node.test, node);
        this.tokenChar(41);
        this.printBlock(node);
      }
      function ForXStatement(node) {
        this.word("for");
        this.space();
        const isForOf = node.type === "ForOfStatement";
        if (isForOf && node.await) {
          this.word("await");
          this.space();
        }
        this.noIndentInnerCommentsHere();
        this.tokenChar(40);
        this.print(node.left, node);
        this.space();
        this.word(isForOf ? "of" : "in");
        this.space();
        this.print(node.right, node);
        this.tokenChar(41);
        this.printBlock(node);
      }
      var ForInStatement = ForXStatement;
      exports2.ForInStatement = ForInStatement;
      var ForOfStatement = ForXStatement;
      exports2.ForOfStatement = ForOfStatement;
      function DoWhileStatement(node) {
        this.word("do");
        this.space();
        this.print(node.body, node);
        this.space();
        this.word("while");
        this.space();
        this.tokenChar(40);
        this.print(node.test, node);
        this.tokenChar(41);
        this.semicolon();
      }
      function printStatementAfterKeyword(printer, node, parent2, isLabel) {
        if (node) {
          printer.space();
          printer.printTerminatorless(node, parent2, isLabel);
        }
        printer.semicolon();
      }
      function BreakStatement(node) {
        this.word("break");
        printStatementAfterKeyword(this, node.label, node, true);
      }
      function ContinueStatement(node) {
        this.word("continue");
        printStatementAfterKeyword(this, node.label, node, true);
      }
      function ReturnStatement(node) {
        this.word("return");
        printStatementAfterKeyword(this, node.argument, node, false);
      }
      function ThrowStatement(node) {
        this.word("throw");
        printStatementAfterKeyword(this, node.argument, node, false);
      }
      function LabeledStatement(node) {
        this.print(node.label, node);
        this.tokenChar(58);
        this.space();
        this.print(node.body, node);
      }
      function TryStatement(node) {
        this.word("try");
        this.space();
        this.print(node.block, node);
        this.space();
        if (node.handlers) {
          this.print(node.handlers[0], node);
        } else {
          this.print(node.handler, node);
        }
        if (node.finalizer) {
          this.space();
          this.word("finally");
          this.space();
          this.print(node.finalizer, node);
        }
      }
      function CatchClause(node) {
        this.word("catch");
        this.space();
        if (node.param) {
          this.tokenChar(40);
          this.print(node.param, node);
          this.print(node.param.typeAnnotation, node);
          this.tokenChar(41);
          this.space();
        }
        this.print(node.body, node);
      }
      function SwitchStatement(node) {
        this.word("switch");
        this.space();
        this.tokenChar(40);
        this.print(node.discriminant, node);
        this.tokenChar(41);
        this.space();
        this.tokenChar(123);
        this.printSequence(node.cases, node, {
          indent: true,
          addNewlines(leading, cas) {
            if (!leading && node.cases[node.cases.length - 1] === cas)
              return -1;
          }
        });
        this.tokenChar(125);
      }
      function SwitchCase(node) {
        if (node.test) {
          this.word("case");
          this.space();
          this.print(node.test, node);
          this.tokenChar(58);
        } else {
          this.word("default");
          this.tokenChar(58);
        }
        if (node.consequent.length) {
          this.newline();
          this.printSequence(node.consequent, node, {
            indent: true
          });
        }
      }
      function DebuggerStatement() {
        this.word("debugger");
        this.semicolon();
      }
      function VariableDeclaration(node, parent2) {
        if (node.declare) {
          this.word("declare");
          this.space();
        }
        const {
          kind
        } = node;
        this.word(kind, kind === "using");
        this.space();
        let hasInits = false;
        if (!isFor(parent2)) {
          for (const declar of node.declarations) {
            if (declar.init) {
              hasInits = true;
            }
          }
        }
        this.printList(node.declarations, node, {
          separator: hasInits ? function() {
            this.tokenChar(44);
            this.newline();
          } : void 0,
          indent: node.declarations.length > 1 ? true : false
        });
        if (isFor(parent2)) {
          if (isForStatement(parent2)) {
            if (parent2.init === node)
              return;
          } else {
            if (parent2.left === node)
              return;
          }
        }
        this.semicolon();
      }
      function VariableDeclarator(node) {
        this.print(node.id, node);
        if (node.definite)
          this.tokenChar(33);
        this.print(node.id.typeAnnotation, node);
        if (node.init) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.init, node);
        }
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/classes.js
  var require_classes = __commonJS({
    "node_modules/@babel/generator/lib/generators/classes.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ClassAccessorProperty = ClassAccessorProperty;
      exports2.ClassBody = ClassBody;
      exports2.ClassExpression = exports2.ClassDeclaration = ClassDeclaration;
      exports2.ClassMethod = ClassMethod;
      exports2.ClassPrivateMethod = ClassPrivateMethod;
      exports2.ClassPrivateProperty = ClassPrivateProperty;
      exports2.ClassProperty = ClassProperty;
      exports2.StaticBlock = StaticBlock;
      exports2._classMethodHead = _classMethodHead;
      var _t = require_lib5();
      var {
        isExportDefaultDeclaration,
        isExportNamedDeclaration
      } = _t;
      function ClassDeclaration(node, parent2) {
        {
          if (!this.format.decoratorsBeforeExport || !isExportDefaultDeclaration(parent2) && !isExportNamedDeclaration(parent2)) {
            this.printJoin(node.decorators, node);
          }
        }
        if (node.declare) {
          this.word("declare");
          this.space();
        }
        if (node.abstract) {
          this.word("abstract");
          this.space();
        }
        this.word("class");
        if (node.id) {
          this.space();
          this.print(node.id, node);
        }
        this.print(node.typeParameters, node);
        if (node.superClass) {
          this.space();
          this.word("extends");
          this.space();
          this.print(node.superClass, node);
          this.print(node.superTypeParameters, node);
        }
        if (node.implements) {
          this.space();
          this.word("implements");
          this.space();
          this.printList(node.implements, node);
        }
        this.space();
        this.print(node.body, node);
      }
      function ClassBody(node) {
        this.tokenChar(123);
        if (node.body.length === 0) {
          this.tokenChar(125);
        } else {
          this.newline();
          this.indent();
          this.printSequence(node.body, node);
          this.dedent();
          if (!this.endsWith(10))
            this.newline();
          this.sourceWithOffset("end", node.loc, 0, -1);
          this.rightBrace();
        }
      }
      function ClassProperty(node) {
        var _node$key$loc, _node$key$loc$end;
        this.printJoin(node.decorators, node);
        const endLine = (_node$key$loc = node.key.loc) == null ? void 0 : (_node$key$loc$end = _node$key$loc.end) == null ? void 0 : _node$key$loc$end.line;
        if (endLine)
          this.catchUp(endLine);
        this.tsPrintClassMemberModifiers(node);
        if (node.computed) {
          this.tokenChar(91);
          this.print(node.key, node);
          this.tokenChar(93);
        } else {
          this._variance(node);
          this.print(node.key, node);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
        if (node.definite) {
          this.tokenChar(33);
        }
        this.print(node.typeAnnotation, node);
        if (node.value) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.value, node);
        }
        this.semicolon();
      }
      function ClassAccessorProperty(node) {
        var _node$key$loc2, _node$key$loc2$end;
        this.printJoin(node.decorators, node);
        const endLine = (_node$key$loc2 = node.key.loc) == null ? void 0 : (_node$key$loc2$end = _node$key$loc2.end) == null ? void 0 : _node$key$loc2$end.line;
        if (endLine)
          this.catchUp(endLine);
        this.tsPrintClassMemberModifiers(node);
        this.word("accessor", true);
        this.space();
        if (node.computed) {
          this.tokenChar(91);
          this.print(node.key, node);
          this.tokenChar(93);
        } else {
          this._variance(node);
          this.print(node.key, node);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
        if (node.definite) {
          this.tokenChar(33);
        }
        this.print(node.typeAnnotation, node);
        if (node.value) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.value, node);
        }
        this.semicolon();
      }
      function ClassPrivateProperty(node) {
        this.printJoin(node.decorators, node);
        if (node.static) {
          this.word("static");
          this.space();
        }
        this.print(node.key, node);
        this.print(node.typeAnnotation, node);
        if (node.value) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.value, node);
        }
        this.semicolon();
      }
      function ClassMethod(node) {
        this._classMethodHead(node);
        this.space();
        this.print(node.body, node);
      }
      function ClassPrivateMethod(node) {
        this._classMethodHead(node);
        this.space();
        this.print(node.body, node);
      }
      function _classMethodHead(node) {
        var _node$key$loc3, _node$key$loc3$end;
        this.printJoin(node.decorators, node);
        const endLine = (_node$key$loc3 = node.key.loc) == null ? void 0 : (_node$key$loc3$end = _node$key$loc3.end) == null ? void 0 : _node$key$loc3$end.line;
        if (endLine)
          this.catchUp(endLine);
        this.tsPrintClassMemberModifiers(node);
        this._methodHead(node);
      }
      function StaticBlock(node) {
        this.word("static");
        this.space();
        this.tokenChar(123);
        if (node.body.length === 0) {
          this.tokenChar(125);
        } else {
          this.newline();
          this.printSequence(node.body, node, {
            indent: true
          });
          this.sourceWithOffset("end", node.loc, 0, -1);
          this.rightBrace();
        }
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/methods.js
  var require_methods = __commonJS({
    "node_modules/@babel/generator/lib/generators/methods.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ArrowFunctionExpression = ArrowFunctionExpression;
      exports2.FunctionDeclaration = exports2.FunctionExpression = FunctionExpression;
      exports2._functionHead = _functionHead;
      exports2._methodHead = _methodHead;
      exports2._param = _param;
      exports2._parameters = _parameters;
      exports2._params = _params;
      exports2._predicate = _predicate;
      var _t = require_lib5();
      var {
        isIdentifier: isIdentifier2
      } = _t;
      function _params(node) {
        this.print(node.typeParameters, node);
        this.tokenChar(40);
        this._parameters(node.params, node);
        this.tokenChar(41);
        const noLineTerminator = node.type === "ArrowFunctionExpression";
        this.print(node.returnType, node, noLineTerminator);
        this._noLineTerminator = noLineTerminator;
      }
      function _parameters(parameters, parent2) {
        const paramLength = parameters.length;
        for (let i = 0; i < paramLength; i++) {
          this._param(parameters[i], parent2);
          if (i < parameters.length - 1) {
            this.tokenChar(44);
            this.space();
          }
        }
      }
      function _param(parameter, parent2) {
        this.printJoin(parameter.decorators, parameter);
        this.print(parameter, parent2);
        if (parameter.optional) {
          this.tokenChar(63);
        }
        this.print(
          parameter.typeAnnotation,
          parameter
        );
      }
      function _methodHead(node) {
        const kind = node.kind;
        const key = node.key;
        if (kind === "get" || kind === "set") {
          this.word(kind);
          this.space();
        }
        if (node.async) {
          this.word("async", true);
          this.space();
        }
        if (kind === "method" || kind === "init") {
          if (node.generator) {
            this.tokenChar(42);
          }
        }
        if (node.computed) {
          this.tokenChar(91);
          this.print(key, node);
          this.tokenChar(93);
        } else {
          this.print(key, node);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
        this._params(node);
      }
      function _predicate(node, noLineTerminatorAfter) {
        if (node.predicate) {
          if (!node.returnType) {
            this.tokenChar(58);
          }
          this.space();
          this.print(node.predicate, node, noLineTerminatorAfter);
        }
      }
      function _functionHead(node) {
        if (node.async) {
          this.word("async");
          this._endsWithInnerRaw = false;
          this.space();
        }
        this.word("function");
        if (node.generator) {
          this._endsWithInnerRaw = false;
          this.tokenChar(42);
        }
        this.space();
        if (node.id) {
          this.print(node.id, node);
        }
        this._params(node);
        if (node.type !== "TSDeclareFunction") {
          this._predicate(node);
        }
      }
      function FunctionExpression(node) {
        this._functionHead(node);
        this.space();
        this.print(node.body, node);
      }
      function ArrowFunctionExpression(node) {
        if (node.async) {
          this.word("async", true);
          this.space();
        }
        let firstParam;
        if (!this.format.retainLines && node.params.length === 1 && isIdentifier2(firstParam = node.params[0]) && !hasTypesOrComments(node, firstParam)) {
          this.print(firstParam, node, true);
        } else {
          this._params(node);
        }
        this._predicate(node, true);
        this.space();
        this.printInnerComments();
        this.token("=>");
        this.space();
        this.print(node.body, node);
      }
      function hasTypesOrComments(node, param) {
        var _param$leadingComment, _param$trailingCommen;
        return !!(node.typeParameters || node.returnType || node.predicate || param.typeAnnotation || param.optional || (_param$leadingComment = param.leadingComments) != null && _param$leadingComment.length || (_param$trailingCommen = param.trailingComments) != null && _param$trailingCommen.length);
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/modules.js
  var require_modules = __commonJS({
    "node_modules/@babel/generator/lib/generators/modules.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ExportAllDeclaration = ExportAllDeclaration;
      exports2.ExportDefaultDeclaration = ExportDefaultDeclaration;
      exports2.ExportDefaultSpecifier = ExportDefaultSpecifier;
      exports2.ExportNamedDeclaration = ExportNamedDeclaration;
      exports2.ExportNamespaceSpecifier = ExportNamespaceSpecifier;
      exports2.ExportSpecifier = ExportSpecifier;
      exports2.ImportAttribute = ImportAttribute;
      exports2.ImportDeclaration = ImportDeclaration;
      exports2.ImportDefaultSpecifier = ImportDefaultSpecifier;
      exports2.ImportNamespaceSpecifier = ImportNamespaceSpecifier;
      exports2.ImportSpecifier = ImportSpecifier;
      exports2._printAssertions = _printAssertions;
      var _t = require_lib5();
      var {
        isClassDeclaration,
        isExportDefaultSpecifier,
        isExportNamespaceSpecifier,
        isImportDefaultSpecifier,
        isImportNamespaceSpecifier,
        isStatement
      } = _t;
      function ImportSpecifier(node) {
        if (node.importKind === "type" || node.importKind === "typeof") {
          this.word(node.importKind);
          this.space();
        }
        this.print(node.imported, node);
        if (node.local && node.local.name !== node.imported.name) {
          this.space();
          this.word("as");
          this.space();
          this.print(node.local, node);
        }
      }
      function ImportDefaultSpecifier(node) {
        this.print(node.local, node);
      }
      function ExportDefaultSpecifier(node) {
        this.print(node.exported, node);
      }
      function ExportSpecifier(node) {
        if (node.exportKind === "type") {
          this.word("type");
          this.space();
        }
        this.print(node.local, node);
        if (node.exported && node.local.name !== node.exported.name) {
          this.space();
          this.word("as");
          this.space();
          this.print(node.exported, node);
        }
      }
      function ExportNamespaceSpecifier(node) {
        this.tokenChar(42);
        this.space();
        this.word("as");
        this.space();
        this.print(node.exported, node);
      }
      function _printAssertions(node) {
        this.word("assert");
        this.space();
        this.tokenChar(123);
        this.space();
        this.printList(node.assertions, node);
        this.space();
        this.tokenChar(125);
      }
      function ExportAllDeclaration(node) {
        var _node$assertions;
        this.word("export");
        this.space();
        if (node.exportKind === "type") {
          this.word("type");
          this.space();
        }
        this.tokenChar(42);
        this.space();
        this.word("from");
        this.space();
        if ((_node$assertions = node.assertions) != null && _node$assertions.length) {
          this.print(node.source, node, true);
          this.space();
          this._printAssertions(node);
        } else {
          this.print(node.source, node);
        }
        this.semicolon();
      }
      function ExportNamedDeclaration(node) {
        {
          if (this.format.decoratorsBeforeExport && isClassDeclaration(node.declaration)) {
            this.printJoin(node.declaration.decorators, node);
          }
        }
        this.word("export");
        this.space();
        if (node.declaration) {
          const declar = node.declaration;
          this.print(declar, node);
          if (!isStatement(declar))
            this.semicolon();
        } else {
          if (node.exportKind === "type") {
            this.word("type");
            this.space();
          }
          const specifiers = node.specifiers.slice(0);
          let hasSpecial = false;
          for (; ; ) {
            const first = specifiers[0];
            if (isExportDefaultSpecifier(first) || isExportNamespaceSpecifier(first)) {
              hasSpecial = true;
              this.print(specifiers.shift(), node);
              if (specifiers.length) {
                this.tokenChar(44);
                this.space();
              }
            } else {
              break;
            }
          }
          if (specifiers.length || !specifiers.length && !hasSpecial) {
            this.tokenChar(123);
            if (specifiers.length) {
              this.space();
              this.printList(specifiers, node);
              this.space();
            }
            this.tokenChar(125);
          }
          if (node.source) {
            var _node$assertions2;
            this.space();
            this.word("from");
            this.space();
            if ((_node$assertions2 = node.assertions) != null && _node$assertions2.length) {
              this.print(node.source, node, true);
              this.space();
              this._printAssertions(node);
            } else {
              this.print(node.source, node);
            }
          }
          this.semicolon();
        }
      }
      function ExportDefaultDeclaration(node) {
        {
          if (this.format.decoratorsBeforeExport && isClassDeclaration(node.declaration)) {
            this.printJoin(node.declaration.decorators, node);
          }
        }
        this.word("export");
        this.noIndentInnerCommentsHere();
        this.space();
        this.word("default");
        this.space();
        const declar = node.declaration;
        this.print(declar, node);
        if (!isStatement(declar))
          this.semicolon();
      }
      function ImportDeclaration(node) {
        var _node$assertions3;
        this.word("import");
        this.space();
        const isTypeKind = node.importKind === "type" || node.importKind === "typeof";
        if (isTypeKind) {
          this.noIndentInnerCommentsHere();
          this.word(node.importKind);
          this.space();
        } else if (node.module) {
          this.noIndentInnerCommentsHere();
          this.word("module");
          this.space();
        }
        const specifiers = node.specifiers.slice(0);
        const hasSpecifiers = !!specifiers.length;
        while (hasSpecifiers) {
          const first = specifiers[0];
          if (isImportDefaultSpecifier(first) || isImportNamespaceSpecifier(first)) {
            this.print(specifiers.shift(), node);
            if (specifiers.length) {
              this.tokenChar(44);
              this.space();
            }
          } else {
            break;
          }
        }
        if (specifiers.length) {
          this.tokenChar(123);
          this.space();
          this.printList(specifiers, node);
          this.space();
          this.tokenChar(125);
        } else if (isTypeKind && !hasSpecifiers) {
          this.tokenChar(123);
          this.tokenChar(125);
        }
        if (hasSpecifiers || isTypeKind) {
          this.space();
          this.word("from");
          this.space();
        }
        if ((_node$assertions3 = node.assertions) != null && _node$assertions3.length) {
          this.print(node.source, node, true);
          this.space();
          this._printAssertions(node);
        } else {
          this.print(node.source, node);
        }
        {
          var _node$attributes;
          if ((_node$attributes = node.attributes) != null && _node$attributes.length) {
            this.space();
            this.word("with");
            this.space();
            this.printList(node.attributes, node);
          }
        }
        this.semicolon();
      }
      function ImportAttribute(node) {
        this.print(node.key);
        this.tokenChar(58);
        this.space();
        this.print(node.value);
      }
      function ImportNamespaceSpecifier(node) {
        this.tokenChar(42);
        this.space();
        this.word("as");
        this.space();
        this.print(node.local, node);
      }
    }
  });

  // node_modules/jsesc/jsesc.js
  var require_jsesc = __commonJS({
    "node_modules/jsesc/jsesc.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var object = {};
      var hasOwnProperty26 = object.hasOwnProperty;
      var forOwn2 = (object2, callback) => {
        for (const key in object2) {
          if (hasOwnProperty26.call(object2, key)) {
            callback(key, object2[key]);
          }
        }
      };
      var extend = (destination, source) => {
        if (!source) {
          return destination;
        }
        forOwn2(source, (key, value) => {
          destination[key] = value;
        });
        return destination;
      };
      var forEach2 = (array, callback) => {
        const length = array.length;
        let index = -1;
        while (++index < length) {
          callback(array[index]);
        }
      };
      var toString2 = object.toString;
      var isArray2 = Array.isArray;
      var isBuffer2 = Buffer.isBuffer;
      var isObject2 = (value) => {
        return toString2.call(value) == "[object Object]";
      };
      var isString2 = (value) => {
        return typeof value == "string" || toString2.call(value) == "[object String]";
      };
      var isNumber2 = (value) => {
        return typeof value == "number" || toString2.call(value) == "[object Number]";
      };
      var isFunction2 = (value) => {
        return typeof value == "function";
      };
      var isMap2 = (value) => {
        return toString2.call(value) == "[object Map]";
      };
      var isSet2 = (value) => {
        return toString2.call(value) == "[object Set]";
      };
      var singleEscapes = {
        '"': '\\"',
        "'": "\\'",
        "\\": "\\\\",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "	": "\\t"
      };
      var regexSingleEscape = /["'\\\b\f\n\r\t]/;
      var regexDigit = /[0-9]/;
      var regexWhitelist = /[ !#-&\(-\[\]-_a-~]/;
      var jsesc = (argument, options) => {
        const increaseIndentation = () => {
          oldIndent = indent;
          ++options.indentLevel;
          indent = options.indent.repeat(options.indentLevel);
        };
        const defaults2 = {
          "escapeEverything": false,
          "minimal": false,
          "isScriptContext": false,
          "quotes": "single",
          "wrap": false,
          "es6": false,
          "json": false,
          "compact": true,
          "lowercaseHex": false,
          "numbers": "decimal",
          "indent": "	",
          "indentLevel": 0,
          "__inline1__": false,
          "__inline2__": false
        };
        const json = options && options.json;
        if (json) {
          defaults2.quotes = "double";
          defaults2.wrap = true;
        }
        options = extend(defaults2, options);
        if (options.quotes != "single" && options.quotes != "double" && options.quotes != "backtick") {
          options.quotes = "single";
        }
        const quote = options.quotes == "double" ? '"' : options.quotes == "backtick" ? "`" : "'";
        const compact2 = options.compact;
        const lowercaseHex = options.lowercaseHex;
        let indent = options.indent.repeat(options.indentLevel);
        let oldIndent = "";
        const inline1 = options.__inline1__;
        const inline2 = options.__inline2__;
        const newLine = compact2 ? "" : "\n";
        let result2;
        let isEmpty2 = true;
        const useBinNumbers = options.numbers == "binary";
        const useOctNumbers = options.numbers == "octal";
        const useDecNumbers = options.numbers == "decimal";
        const useHexNumbers = options.numbers == "hexadecimal";
        if (json && argument && isFunction2(argument.toJSON)) {
          argument = argument.toJSON();
        }
        if (!isString2(argument)) {
          if (isMap2(argument)) {
            if (argument.size == 0) {
              return "new Map()";
            }
            if (!compact2) {
              options.__inline1__ = true;
              options.__inline2__ = false;
            }
            return "new Map(" + jsesc(Array.from(argument), options) + ")";
          }
          if (isSet2(argument)) {
            if (argument.size == 0) {
              return "new Set()";
            }
            return "new Set(" + jsesc(Array.from(argument), options) + ")";
          }
          if (isBuffer2(argument)) {
            if (argument.length == 0) {
              return "Buffer.from([])";
            }
            return "Buffer.from(" + jsesc(Array.from(argument), options) + ")";
          }
          if (isArray2(argument)) {
            result2 = [];
            options.wrap = true;
            if (inline1) {
              options.__inline1__ = false;
              options.__inline2__ = true;
            }
            if (!inline2) {
              increaseIndentation();
            }
            forEach2(argument, (value) => {
              isEmpty2 = false;
              if (inline2) {
                options.__inline2__ = false;
              }
              result2.push(
                (compact2 || inline2 ? "" : indent) + jsesc(value, options)
              );
            });
            if (isEmpty2) {
              return "[]";
            }
            if (inline2) {
              return "[" + result2.join(", ") + "]";
            }
            return "[" + newLine + result2.join("," + newLine) + newLine + (compact2 ? "" : oldIndent) + "]";
          } else if (isNumber2(argument)) {
            if (json) {
              return JSON.stringify(argument);
            }
            if (useDecNumbers) {
              return String(argument);
            }
            if (useHexNumbers) {
              let hexadecimal = argument.toString(16);
              if (!lowercaseHex) {
                hexadecimal = hexadecimal.toUpperCase();
              }
              return "0x" + hexadecimal;
            }
            if (useBinNumbers) {
              return "0b" + argument.toString(2);
            }
            if (useOctNumbers) {
              return "0o" + argument.toString(8);
            }
          } else if (!isObject2(argument)) {
            if (json) {
              return JSON.stringify(argument) || "null";
            }
            return String(argument);
          } else {
            result2 = [];
            options.wrap = true;
            increaseIndentation();
            forOwn2(argument, (key, value) => {
              isEmpty2 = false;
              result2.push(
                (compact2 ? "" : indent) + jsesc(key, options) + ":" + (compact2 ? "" : " ") + jsesc(value, options)
              );
            });
            if (isEmpty2) {
              return "{}";
            }
            return "{" + newLine + result2.join("," + newLine) + newLine + (compact2 ? "" : oldIndent) + "}";
          }
        }
        const string = argument;
        let index = -1;
        const length = string.length;
        result2 = "";
        while (++index < length) {
          const character = string.charAt(index);
          if (options.es6) {
            const first = string.charCodeAt(index);
            if (first >= 55296 && first <= 56319 && length > index + 1) {
              const second = string.charCodeAt(index + 1);
              if (second >= 56320 && second <= 57343) {
                const codePoint = (first - 55296) * 1024 + second - 56320 + 65536;
                let hexadecimal2 = codePoint.toString(16);
                if (!lowercaseHex) {
                  hexadecimal2 = hexadecimal2.toUpperCase();
                }
                result2 += "\\u{" + hexadecimal2 + "}";
                ++index;
                continue;
              }
            }
          }
          if (!options.escapeEverything) {
            if (regexWhitelist.test(character)) {
              result2 += character;
              continue;
            }
            if (character == '"') {
              result2 += quote == character ? '\\"' : character;
              continue;
            }
            if (character == "`") {
              result2 += quote == character ? "\\`" : character;
              continue;
            }
            if (character == "'") {
              result2 += quote == character ? "\\'" : character;
              continue;
            }
          }
          if (character == "\0" && !json && !regexDigit.test(string.charAt(index + 1))) {
            result2 += "\\0";
            continue;
          }
          if (regexSingleEscape.test(character)) {
            result2 += singleEscapes[character];
            continue;
          }
          const charCode = character.charCodeAt(0);
          if (options.minimal && charCode != 8232 && charCode != 8233) {
            result2 += character;
            continue;
          }
          let hexadecimal = charCode.toString(16);
          if (!lowercaseHex) {
            hexadecimal = hexadecimal.toUpperCase();
          }
          const longhand = hexadecimal.length > 2 || json;
          const escaped = "\\" + (longhand ? "u" : "x") + ("0000" + hexadecimal).slice(longhand ? -4 : -2);
          result2 += escaped;
          continue;
        }
        if (options.wrap) {
          result2 = quote + result2 + quote;
        }
        if (quote == "`") {
          result2 = result2.replace(/\$\{/g, "\\${");
        }
        if (options.isScriptContext) {
          return result2.replace(/<\/(script|style)/gi, "<\\/$1").replace(/<!--/g, json ? "\\u003C!--" : "\\x3C!--");
        }
        return result2;
      };
      jsesc.version = "2.5.2";
      module2.exports = jsesc;
    }
  });

  // node_modules/@babel/generator/lib/generators/types.js
  var require_types3 = __commonJS({
    "node_modules/@babel/generator/lib/generators/types.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ArgumentPlaceholder = ArgumentPlaceholder;
      exports2.ArrayPattern = exports2.ArrayExpression = ArrayExpression;
      exports2.BigIntLiteral = BigIntLiteral;
      exports2.BooleanLiteral = BooleanLiteral;
      exports2.DecimalLiteral = DecimalLiteral;
      exports2.Identifier = Identifier;
      exports2.NullLiteral = NullLiteral;
      exports2.NumericLiteral = NumericLiteral;
      exports2.ObjectPattern = exports2.ObjectExpression = ObjectExpression;
      exports2.ObjectMethod = ObjectMethod;
      exports2.ObjectProperty = ObjectProperty;
      exports2.PipelineBareFunction = PipelineBareFunction;
      exports2.PipelinePrimaryTopicReference = PipelinePrimaryTopicReference;
      exports2.PipelineTopicExpression = PipelineTopicExpression;
      exports2.RecordExpression = RecordExpression;
      exports2.RegExpLiteral = RegExpLiteral;
      exports2.SpreadElement = exports2.RestElement = RestElement;
      exports2.StringLiteral = StringLiteral;
      exports2.TopicReference = TopicReference;
      exports2.TupleExpression = TupleExpression;
      var _t = require_lib5();
      var _jsesc = require_jsesc();
      var {
        isAssignmentPattern,
        isIdentifier: isIdentifier2
      } = _t;
      function Identifier(node) {
        this.word(node.name);
      }
      function ArgumentPlaceholder() {
        this.tokenChar(63);
      }
      function RestElement(node) {
        this.token("...");
        this.print(node.argument, node);
      }
      function ObjectExpression(node) {
        const props = node.properties;
        this.tokenChar(123);
        if (props.length) {
          this.space();
          this.printList(props, node, {
            indent: true,
            statement: true
          });
          this.space();
        }
        this.sourceWithOffset("end", node.loc, 0, -1);
        this.tokenChar(125);
      }
      function ObjectMethod(node) {
        this.printJoin(node.decorators, node);
        this._methodHead(node);
        this.space();
        this.print(node.body, node);
      }
      function ObjectProperty(node) {
        this.printJoin(node.decorators, node);
        if (node.computed) {
          this.tokenChar(91);
          this.print(node.key, node);
          this.tokenChar(93);
        } else {
          if (isAssignmentPattern(node.value) && isIdentifier2(node.key) && node.key.name === node.value.left.name) {
            this.print(node.value, node);
            return;
          }
          this.print(node.key, node);
          if (node.shorthand && isIdentifier2(node.key) && isIdentifier2(node.value) && node.key.name === node.value.name) {
            return;
          }
        }
        this.tokenChar(58);
        this.space();
        this.print(node.value, node);
      }
      function ArrayExpression(node) {
        const elems = node.elements;
        const len = elems.length;
        this.tokenChar(91);
        for (let i = 0; i < elems.length; i++) {
          const elem = elems[i];
          if (elem) {
            if (i > 0)
              this.space();
            this.print(elem, node);
            if (i < len - 1)
              this.tokenChar(44);
          } else {
            this.tokenChar(44);
          }
        }
        this.tokenChar(93);
      }
      function RecordExpression(node) {
        const props = node.properties;
        let startToken;
        let endToken;
        if (this.format.recordAndTupleSyntaxType === "bar") {
          startToken = "{|";
          endToken = "|}";
        } else if (this.format.recordAndTupleSyntaxType !== "hash" && this.format.recordAndTupleSyntaxType != null) {
          throw new Error(`The "recordAndTupleSyntaxType" generator option must be "bar" or "hash" (${JSON.stringify(this.format.recordAndTupleSyntaxType)} received).`);
        } else {
          startToken = "#{";
          endToken = "}";
        }
        this.token(startToken);
        if (props.length) {
          this.space();
          this.printList(props, node, {
            indent: true,
            statement: true
          });
          this.space();
        }
        this.token(endToken);
      }
      function TupleExpression(node) {
        const elems = node.elements;
        const len = elems.length;
        let startToken;
        let endToken;
        if (this.format.recordAndTupleSyntaxType === "bar") {
          startToken = "[|";
          endToken = "|]";
        } else if (this.format.recordAndTupleSyntaxType === "hash") {
          startToken = "#[";
          endToken = "]";
        } else {
          throw new Error(`${this.format.recordAndTupleSyntaxType} is not a valid recordAndTuple syntax type`);
        }
        this.token(startToken);
        for (let i = 0; i < elems.length; i++) {
          const elem = elems[i];
          if (elem) {
            if (i > 0)
              this.space();
            this.print(elem, node);
            if (i < len - 1)
              this.tokenChar(44);
          }
        }
        this.token(endToken);
      }
      function RegExpLiteral(node) {
        this.word(`/${node.pattern}/${node.flags}`);
      }
      function BooleanLiteral(node) {
        this.word(node.value ? "true" : "false");
      }
      function NullLiteral() {
        this.word("null");
      }
      function NumericLiteral(node) {
        const raw = this.getPossibleRaw(node);
        const opts = this.format.jsescOption;
        const value = node.value + "";
        if (opts.numbers) {
          this.number(_jsesc(node.value, opts));
        } else if (raw == null) {
          this.number(value);
        } else if (this.format.minified) {
          this.number(raw.length < value.length ? raw : value);
        } else {
          this.number(raw);
        }
      }
      function StringLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.token(raw);
          return;
        }
        const val = _jsesc(node.value, Object.assign(this.format.jsescOption, this.format.jsonCompatibleStrings && {
          json: true
        }));
        return this.token(val);
      }
      function BigIntLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.word(raw);
          return;
        }
        this.word(node.value + "n");
      }
      function DecimalLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.word(raw);
          return;
        }
        this.word(node.value + "m");
      }
      var validTopicTokenSet = /* @__PURE__ */ new Set(["^^", "@@", "^", "%", "#"]);
      function TopicReference() {
        const {
          topicToken
        } = this.format;
        if (validTopicTokenSet.has(topicToken)) {
          this.token(topicToken);
        } else {
          const givenTopicTokenJSON = JSON.stringify(topicToken);
          const validTopics = Array.from(validTopicTokenSet, (v) => JSON.stringify(v));
          throw new Error(`The "topicToken" generator option must be one of ${validTopics.join(", ")} (${givenTopicTokenJSON} received instead).`);
        }
      }
      function PipelineTopicExpression(node) {
        this.print(node.expression, node);
      }
      function PipelineBareFunction(node) {
        this.print(node.callee, node);
      }
      function PipelinePrimaryTopicReference() {
        this.tokenChar(35);
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/flow.js
  var require_flow2 = __commonJS({
    "node_modules/@babel/generator/lib/generators/flow.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.AnyTypeAnnotation = AnyTypeAnnotation;
      exports2.ArrayTypeAnnotation = ArrayTypeAnnotation;
      exports2.BooleanLiteralTypeAnnotation = BooleanLiteralTypeAnnotation;
      exports2.BooleanTypeAnnotation = BooleanTypeAnnotation;
      exports2.DeclareClass = DeclareClass;
      exports2.DeclareExportAllDeclaration = DeclareExportAllDeclaration;
      exports2.DeclareExportDeclaration = DeclareExportDeclaration;
      exports2.DeclareFunction = DeclareFunction;
      exports2.DeclareInterface = DeclareInterface;
      exports2.DeclareModule = DeclareModule;
      exports2.DeclareModuleExports = DeclareModuleExports;
      exports2.DeclareOpaqueType = DeclareOpaqueType;
      exports2.DeclareTypeAlias = DeclareTypeAlias;
      exports2.DeclareVariable = DeclareVariable;
      exports2.DeclaredPredicate = DeclaredPredicate;
      exports2.EmptyTypeAnnotation = EmptyTypeAnnotation;
      exports2.EnumBooleanBody = EnumBooleanBody;
      exports2.EnumBooleanMember = EnumBooleanMember;
      exports2.EnumDeclaration = EnumDeclaration;
      exports2.EnumDefaultedMember = EnumDefaultedMember;
      exports2.EnumNumberBody = EnumNumberBody;
      exports2.EnumNumberMember = EnumNumberMember;
      exports2.EnumStringBody = EnumStringBody;
      exports2.EnumStringMember = EnumStringMember;
      exports2.EnumSymbolBody = EnumSymbolBody;
      exports2.ExistsTypeAnnotation = ExistsTypeAnnotation;
      exports2.FunctionTypeAnnotation = FunctionTypeAnnotation;
      exports2.FunctionTypeParam = FunctionTypeParam;
      exports2.IndexedAccessType = IndexedAccessType;
      exports2.InferredPredicate = InferredPredicate;
      exports2.InterfaceDeclaration = InterfaceDeclaration;
      exports2.GenericTypeAnnotation = exports2.ClassImplements = exports2.InterfaceExtends = InterfaceExtends;
      exports2.InterfaceTypeAnnotation = InterfaceTypeAnnotation;
      exports2.IntersectionTypeAnnotation = IntersectionTypeAnnotation;
      exports2.MixedTypeAnnotation = MixedTypeAnnotation;
      exports2.NullLiteralTypeAnnotation = NullLiteralTypeAnnotation;
      exports2.NullableTypeAnnotation = NullableTypeAnnotation;
      Object.defineProperty(exports2, "NumberLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _types2.NumericLiteral;
        }
      });
      exports2.NumberTypeAnnotation = NumberTypeAnnotation;
      exports2.ObjectTypeAnnotation = ObjectTypeAnnotation;
      exports2.ObjectTypeCallProperty = ObjectTypeCallProperty;
      exports2.ObjectTypeIndexer = ObjectTypeIndexer;
      exports2.ObjectTypeInternalSlot = ObjectTypeInternalSlot;
      exports2.ObjectTypeProperty = ObjectTypeProperty;
      exports2.ObjectTypeSpreadProperty = ObjectTypeSpreadProperty;
      exports2.OpaqueType = OpaqueType;
      exports2.OptionalIndexedAccessType = OptionalIndexedAccessType;
      exports2.QualifiedTypeIdentifier = QualifiedTypeIdentifier;
      Object.defineProperty(exports2, "StringLiteralTypeAnnotation", {
        enumerable: true,
        get: function() {
          return _types2.StringLiteral;
        }
      });
      exports2.StringTypeAnnotation = StringTypeAnnotation;
      exports2.SymbolTypeAnnotation = SymbolTypeAnnotation;
      exports2.ThisTypeAnnotation = ThisTypeAnnotation;
      exports2.TupleTypeAnnotation = TupleTypeAnnotation;
      exports2.TypeAlias = TypeAlias;
      exports2.TypeAnnotation = TypeAnnotation;
      exports2.TypeCastExpression = TypeCastExpression;
      exports2.TypeParameter = TypeParameter;
      exports2.TypeParameterDeclaration = exports2.TypeParameterInstantiation = TypeParameterInstantiation;
      exports2.TypeofTypeAnnotation = TypeofTypeAnnotation;
      exports2.UnionTypeAnnotation = UnionTypeAnnotation;
      exports2.Variance = Variance;
      exports2.VoidTypeAnnotation = VoidTypeAnnotation;
      exports2._interfaceish = _interfaceish;
      exports2._variance = _variance;
      var _t = require_lib5();
      var _modules = require_modules();
      var _types2 = require_types3();
      var {
        isDeclareExportDeclaration,
        isStatement
      } = _t;
      function AnyTypeAnnotation() {
        this.word("any");
      }
      function ArrayTypeAnnotation(node) {
        this.print(node.elementType, node, true);
        this.tokenChar(91);
        this.tokenChar(93);
      }
      function BooleanTypeAnnotation() {
        this.word("boolean");
      }
      function BooleanLiteralTypeAnnotation(node) {
        this.word(node.value ? "true" : "false");
      }
      function NullLiteralTypeAnnotation() {
        this.word("null");
      }
      function DeclareClass(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.word("class");
        this.space();
        this._interfaceish(node);
      }
      function DeclareFunction(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.word("function");
        this.space();
        this.print(node.id, node);
        this.print(node.id.typeAnnotation.typeAnnotation, node);
        if (node.predicate) {
          this.space();
          this.print(node.predicate, node);
        }
        this.semicolon();
      }
      function InferredPredicate() {
        this.tokenChar(37);
        this.word("checks");
      }
      function DeclaredPredicate(node) {
        this.tokenChar(37);
        this.word("checks");
        this.tokenChar(40);
        this.print(node.value, node);
        this.tokenChar(41);
      }
      function DeclareInterface(node) {
        this.word("declare");
        this.space();
        this.InterfaceDeclaration(node);
      }
      function DeclareModule(node) {
        this.word("declare");
        this.space();
        this.word("module");
        this.space();
        this.print(node.id, node);
        this.space();
        this.print(node.body, node);
      }
      function DeclareModuleExports(node) {
        this.word("declare");
        this.space();
        this.word("module");
        this.tokenChar(46);
        this.word("exports");
        this.print(node.typeAnnotation, node);
      }
      function DeclareTypeAlias(node) {
        this.word("declare");
        this.space();
        this.TypeAlias(node);
      }
      function DeclareOpaqueType(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.OpaqueType(node);
      }
      function DeclareVariable(node, parent2) {
        if (!isDeclareExportDeclaration(parent2)) {
          this.word("declare");
          this.space();
        }
        this.word("var");
        this.space();
        this.print(node.id, node);
        this.print(node.id.typeAnnotation, node);
        this.semicolon();
      }
      function DeclareExportDeclaration(node) {
        this.word("declare");
        this.space();
        this.word("export");
        this.space();
        if (node.default) {
          this.word("default");
          this.space();
        }
        FlowExportDeclaration.call(this, node);
      }
      function DeclareExportAllDeclaration(node) {
        this.word("declare");
        this.space();
        _modules.ExportAllDeclaration.call(this, node);
      }
      function EnumDeclaration(node) {
        const {
          id,
          body
        } = node;
        this.word("enum");
        this.space();
        this.print(id, node);
        this.print(body, node);
      }
      function enumExplicitType(context, name, hasExplicitType) {
        if (hasExplicitType) {
          context.space();
          context.word("of");
          context.space();
          context.word(name);
        }
        context.space();
      }
      function enumBody(context, node) {
        const {
          members
        } = node;
        context.token("{");
        context.indent();
        context.newline();
        for (const member of members) {
          context.print(member, node);
          context.newline();
        }
        if (node.hasUnknownMembers) {
          context.token("...");
          context.newline();
        }
        context.dedent();
        context.token("}");
      }
      function EnumBooleanBody(node) {
        const {
          explicitType
        } = node;
        enumExplicitType(this, "boolean", explicitType);
        enumBody(this, node);
      }
      function EnumNumberBody(node) {
        const {
          explicitType
        } = node;
        enumExplicitType(this, "number", explicitType);
        enumBody(this, node);
      }
      function EnumStringBody(node) {
        const {
          explicitType
        } = node;
        enumExplicitType(this, "string", explicitType);
        enumBody(this, node);
      }
      function EnumSymbolBody(node) {
        enumExplicitType(this, "symbol", true);
        enumBody(this, node);
      }
      function EnumDefaultedMember(node) {
        const {
          id
        } = node;
        this.print(id, node);
        this.tokenChar(44);
      }
      function enumInitializedMember(context, node) {
        const {
          id,
          init
        } = node;
        context.print(id, node);
        context.space();
        context.token("=");
        context.space();
        context.print(init, node);
        context.token(",");
      }
      function EnumBooleanMember(node) {
        enumInitializedMember(this, node);
      }
      function EnumNumberMember(node) {
        enumInitializedMember(this, node);
      }
      function EnumStringMember(node) {
        enumInitializedMember(this, node);
      }
      function FlowExportDeclaration(node) {
        if (node.declaration) {
          const declar = node.declaration;
          this.print(declar, node);
          if (!isStatement(declar))
            this.semicolon();
        } else {
          this.tokenChar(123);
          if (node.specifiers.length) {
            this.space();
            this.printList(node.specifiers, node);
            this.space();
          }
          this.tokenChar(125);
          if (node.source) {
            this.space();
            this.word("from");
            this.space();
            this.print(node.source, node);
          }
          this.semicolon();
        }
      }
      function ExistsTypeAnnotation() {
        this.tokenChar(42);
      }
      function FunctionTypeAnnotation(node, parent2) {
        this.print(node.typeParameters, node);
        this.tokenChar(40);
        if (node.this) {
          this.word("this");
          this.tokenChar(58);
          this.space();
          this.print(node.this.typeAnnotation, node);
          if (node.params.length || node.rest) {
            this.tokenChar(44);
            this.space();
          }
        }
        this.printList(node.params, node);
        if (node.rest) {
          if (node.params.length) {
            this.tokenChar(44);
            this.space();
          }
          this.token("...");
          this.print(node.rest, node);
        }
        this.tokenChar(41);
        if (parent2 && (parent2.type === "ObjectTypeCallProperty" || parent2.type === "ObjectTypeInternalSlot" || parent2.type === "DeclareFunction" || parent2.type === "ObjectTypeProperty" && parent2.method)) {
          this.tokenChar(58);
        } else {
          this.space();
          this.token("=>");
        }
        this.space();
        this.print(node.returnType, node);
      }
      function FunctionTypeParam(node) {
        this.print(node.name, node);
        if (node.optional)
          this.tokenChar(63);
        if (node.name) {
          this.tokenChar(58);
          this.space();
        }
        this.print(node.typeAnnotation, node);
      }
      function InterfaceExtends(node) {
        this.print(node.id, node);
        this.print(node.typeParameters, node, true);
      }
      function _interfaceish(node) {
        var _node$extends;
        this.print(node.id, node);
        this.print(node.typeParameters, node);
        if ((_node$extends = node.extends) != null && _node$extends.length) {
          this.space();
          this.word("extends");
          this.space();
          this.printList(node.extends, node);
        }
        if (node.mixins && node.mixins.length) {
          this.space();
          this.word("mixins");
          this.space();
          this.printList(node.mixins, node);
        }
        if (node.implements && node.implements.length) {
          this.space();
          this.word("implements");
          this.space();
          this.printList(node.implements, node);
        }
        this.space();
        this.print(node.body, node);
      }
      function _variance(node) {
        if (node.variance) {
          if (node.variance.kind === "plus") {
            this.tokenChar(43);
          } else if (node.variance.kind === "minus") {
            this.tokenChar(45);
          }
        }
      }
      function InterfaceDeclaration(node) {
        this.word("interface");
        this.space();
        this._interfaceish(node);
      }
      function andSeparator() {
        this.space();
        this.tokenChar(38);
        this.space();
      }
      function InterfaceTypeAnnotation(node) {
        this.word("interface");
        if (node.extends && node.extends.length) {
          this.space();
          this.word("extends");
          this.space();
          this.printList(node.extends, node);
        }
        this.space();
        this.print(node.body, node);
      }
      function IntersectionTypeAnnotation(node) {
        this.printJoin(node.types, node, {
          separator: andSeparator
        });
      }
      function MixedTypeAnnotation() {
        this.word("mixed");
      }
      function EmptyTypeAnnotation() {
        this.word("empty");
      }
      function NullableTypeAnnotation(node) {
        this.tokenChar(63);
        this.print(node.typeAnnotation, node);
      }
      function NumberTypeAnnotation() {
        this.word("number");
      }
      function StringTypeAnnotation() {
        this.word("string");
      }
      function ThisTypeAnnotation() {
        this.word("this");
      }
      function TupleTypeAnnotation(node) {
        this.tokenChar(91);
        this.printList(node.types, node);
        this.tokenChar(93);
      }
      function TypeofTypeAnnotation(node) {
        this.word("typeof");
        this.space();
        this.print(node.argument, node);
      }
      function TypeAlias(node) {
        this.word("type");
        this.space();
        this.print(node.id, node);
        this.print(node.typeParameters, node);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.right, node);
        this.semicolon();
      }
      function TypeAnnotation(node) {
        this.tokenChar(58);
        this.space();
        if (node.optional)
          this.tokenChar(63);
        this.print(node.typeAnnotation, node);
      }
      function TypeParameterInstantiation(node) {
        this.tokenChar(60);
        this.printList(node.params, node, {});
        this.tokenChar(62);
      }
      function TypeParameter(node) {
        this._variance(node);
        this.word(node.name);
        if (node.bound) {
          this.print(node.bound, node);
        }
        if (node.default) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.default, node);
        }
      }
      function OpaqueType(node) {
        this.word("opaque");
        this.space();
        this.word("type");
        this.space();
        this.print(node.id, node);
        this.print(node.typeParameters, node);
        if (node.supertype) {
          this.tokenChar(58);
          this.space();
          this.print(node.supertype, node);
        }
        if (node.impltype) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.impltype, node);
        }
        this.semicolon();
      }
      function ObjectTypeAnnotation(node) {
        if (node.exact) {
          this.token("{|");
        } else {
          this.tokenChar(123);
        }
        const props = [...node.properties, ...node.callProperties || [], ...node.indexers || [], ...node.internalSlots || []];
        if (props.length) {
          this.newline();
          this.space();
          this.printJoin(props, node, {
            addNewlines(leading) {
              if (leading && !props[0])
                return 1;
            },
            indent: true,
            statement: true,
            iterator: () => {
              if (props.length !== 1 || node.inexact) {
                this.tokenChar(44);
                this.space();
              }
            }
          });
          this.space();
        }
        if (node.inexact) {
          this.indent();
          this.token("...");
          if (props.length) {
            this.newline();
          }
          this.dedent();
        }
        if (node.exact) {
          this.token("|}");
        } else {
          this.tokenChar(125);
        }
      }
      function ObjectTypeInternalSlot(node) {
        if (node.static) {
          this.word("static");
          this.space();
        }
        this.tokenChar(91);
        this.tokenChar(91);
        this.print(node.id, node);
        this.tokenChar(93);
        this.tokenChar(93);
        if (node.optional)
          this.tokenChar(63);
        if (!node.method) {
          this.tokenChar(58);
          this.space();
        }
        this.print(node.value, node);
      }
      function ObjectTypeCallProperty(node) {
        if (node.static) {
          this.word("static");
          this.space();
        }
        this.print(node.value, node);
      }
      function ObjectTypeIndexer(node) {
        if (node.static) {
          this.word("static");
          this.space();
        }
        this._variance(node);
        this.tokenChar(91);
        if (node.id) {
          this.print(node.id, node);
          this.tokenChar(58);
          this.space();
        }
        this.print(node.key, node);
        this.tokenChar(93);
        this.tokenChar(58);
        this.space();
        this.print(node.value, node);
      }
      function ObjectTypeProperty(node) {
        if (node.proto) {
          this.word("proto");
          this.space();
        }
        if (node.static) {
          this.word("static");
          this.space();
        }
        if (node.kind === "get" || node.kind === "set") {
          this.word(node.kind);
          this.space();
        }
        this._variance(node);
        this.print(node.key, node);
        if (node.optional)
          this.tokenChar(63);
        if (!node.method) {
          this.tokenChar(58);
          this.space();
        }
        this.print(node.value, node);
      }
      function ObjectTypeSpreadProperty(node) {
        this.token("...");
        this.print(node.argument, node);
      }
      function QualifiedTypeIdentifier(node) {
        this.print(node.qualification, node);
        this.tokenChar(46);
        this.print(node.id, node);
      }
      function SymbolTypeAnnotation() {
        this.word("symbol");
      }
      function orSeparator() {
        this.space();
        this.tokenChar(124);
        this.space();
      }
      function UnionTypeAnnotation(node) {
        this.printJoin(node.types, node, {
          separator: orSeparator
        });
      }
      function TypeCastExpression(node) {
        this.tokenChar(40);
        this.print(node.expression, node);
        this.print(node.typeAnnotation, node);
        this.tokenChar(41);
      }
      function Variance(node) {
        if (node.kind === "plus") {
          this.tokenChar(43);
        } else {
          this.tokenChar(45);
        }
      }
      function VoidTypeAnnotation() {
        this.word("void");
      }
      function IndexedAccessType(node) {
        this.print(node.objectType, node, true);
        this.tokenChar(91);
        this.print(node.indexType, node);
        this.tokenChar(93);
      }
      function OptionalIndexedAccessType(node) {
        this.print(node.objectType, node);
        if (node.optional) {
          this.token("?.");
        }
        this.tokenChar(91);
        this.print(node.indexType, node);
        this.tokenChar(93);
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/base.js
  var require_base2 = __commonJS({
    "node_modules/@babel/generator/lib/generators/base.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.BlockStatement = BlockStatement;
      exports2.Directive = Directive;
      exports2.DirectiveLiteral = DirectiveLiteral;
      exports2.File = File;
      exports2.InterpreterDirective = InterpreterDirective;
      exports2.Placeholder = Placeholder;
      exports2.Program = Program;
      function File(node) {
        if (node.program) {
          this.print(node.program.interpreter, node);
        }
        this.print(node.program, node);
      }
      function Program(node) {
        var _node$directives;
        this.noIndentInnerCommentsHere();
        this.printInnerComments();
        const directivesLen = (_node$directives = node.directives) == null ? void 0 : _node$directives.length;
        if (directivesLen) {
          var _node$directives$trai;
          const newline = node.body.length ? 2 : 1;
          this.printSequence(node.directives, node, {
            trailingCommentsLineOffset: newline
          });
          if (!((_node$directives$trai = node.directives[directivesLen - 1].trailingComments) != null && _node$directives$trai.length)) {
            this.newline(newline);
          }
        }
        this.printSequence(node.body, node);
      }
      function BlockStatement(node) {
        var _node$directives2;
        this.tokenChar(123);
        const directivesLen = (_node$directives2 = node.directives) == null ? void 0 : _node$directives2.length;
        if (directivesLen) {
          var _node$directives$trai2;
          const newline = node.body.length ? 2 : 1;
          this.printSequence(node.directives, node, {
            indent: true,
            trailingCommentsLineOffset: newline
          });
          if (!((_node$directives$trai2 = node.directives[directivesLen - 1].trailingComments) != null && _node$directives$trai2.length)) {
            this.newline(newline);
          }
        }
        this.printSequence(node.body, node, {
          indent: true
        });
        this.sourceWithOffset("end", node.loc, 0, -1);
        this.rightBrace();
      }
      function Directive(node) {
        this.print(node.value, node);
        this.semicolon();
      }
      var unescapedSingleQuoteRE = /(?:^|[^\\])(?:\\\\)*'/;
      var unescapedDoubleQuoteRE = /(?:^|[^\\])(?:\\\\)*"/;
      function DirectiveLiteral(node) {
        const raw = this.getPossibleRaw(node);
        if (!this.format.minified && raw !== void 0) {
          this.token(raw);
          return;
        }
        const {
          value
        } = node;
        if (!unescapedDoubleQuoteRE.test(value)) {
          this.token(`"${value}"`);
        } else if (!unescapedSingleQuoteRE.test(value)) {
          this.token(`'${value}'`);
        } else {
          throw new Error("Malformed AST: it is not possible to print a directive containing both unescaped single and double quotes.");
        }
      }
      function InterpreterDirective(node) {
        this.token(`#!${node.value}`);
        this.newline(1, true);
      }
      function Placeholder(node) {
        this.token("%%");
        this.print(node.name);
        this.token("%%");
        if (node.expectedNode === "Statement") {
          this.semicolon();
        }
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/jsx.js
  var require_jsx2 = __commonJS({
    "node_modules/@babel/generator/lib/generators/jsx.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.JSXAttribute = JSXAttribute;
      exports2.JSXClosingElement = JSXClosingElement;
      exports2.JSXClosingFragment = JSXClosingFragment;
      exports2.JSXElement = JSXElement;
      exports2.JSXEmptyExpression = JSXEmptyExpression;
      exports2.JSXExpressionContainer = JSXExpressionContainer;
      exports2.JSXFragment = JSXFragment;
      exports2.JSXIdentifier = JSXIdentifier;
      exports2.JSXMemberExpression = JSXMemberExpression;
      exports2.JSXNamespacedName = JSXNamespacedName;
      exports2.JSXOpeningElement = JSXOpeningElement;
      exports2.JSXOpeningFragment = JSXOpeningFragment;
      exports2.JSXSpreadAttribute = JSXSpreadAttribute;
      exports2.JSXSpreadChild = JSXSpreadChild;
      exports2.JSXText = JSXText;
      function JSXAttribute(node) {
        this.print(node.name, node);
        if (node.value) {
          this.tokenChar(61);
          this.print(node.value, node);
        }
      }
      function JSXIdentifier(node) {
        this.word(node.name);
      }
      function JSXNamespacedName(node) {
        this.print(node.namespace, node);
        this.tokenChar(58);
        this.print(node.name, node);
      }
      function JSXMemberExpression(node) {
        this.print(node.object, node);
        this.tokenChar(46);
        this.print(node.property, node);
      }
      function JSXSpreadAttribute(node) {
        this.tokenChar(123);
        this.token("...");
        this.print(node.argument, node);
        this.tokenChar(125);
      }
      function JSXExpressionContainer(node) {
        this.tokenChar(123);
        this.print(node.expression, node);
        this.tokenChar(125);
      }
      function JSXSpreadChild(node) {
        this.tokenChar(123);
        this.token("...");
        this.print(node.expression, node);
        this.tokenChar(125);
      }
      function JSXText(node) {
        const raw = this.getPossibleRaw(node);
        if (raw !== void 0) {
          this.token(raw, true);
        } else {
          this.token(node.value, true);
        }
      }
      function JSXElement(node) {
        const open = node.openingElement;
        this.print(open, node);
        if (open.selfClosing)
          return;
        this.indent();
        for (const child of node.children) {
          this.print(child, node);
        }
        this.dedent();
        this.print(node.closingElement, node);
      }
      function spaceSeparator() {
        this.space();
      }
      function JSXOpeningElement(node) {
        this.tokenChar(60);
        this.print(node.name, node);
        this.print(node.typeParameters, node);
        if (node.attributes.length > 0) {
          this.space();
          this.printJoin(node.attributes, node, {
            separator: spaceSeparator
          });
        }
        if (node.selfClosing) {
          this.space();
          this.token("/>");
        } else {
          this.tokenChar(62);
        }
      }
      function JSXClosingElement(node) {
        this.token("</");
        this.print(node.name, node);
        this.tokenChar(62);
      }
      function JSXEmptyExpression() {
        this.printInnerComments();
      }
      function JSXFragment(node) {
        this.print(node.openingFragment, node);
        this.indent();
        for (const child of node.children) {
          this.print(child, node);
        }
        this.dedent();
        this.print(node.closingFragment, node);
      }
      function JSXOpeningFragment() {
        this.tokenChar(60);
        this.tokenChar(62);
      }
      function JSXClosingFragment() {
        this.token("</");
        this.tokenChar(62);
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/typescript.js
  var require_typescript2 = __commonJS({
    "node_modules/@babel/generator/lib/generators/typescript.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.TSAnyKeyword = TSAnyKeyword;
      exports2.TSArrayType = TSArrayType;
      exports2.TSSatisfiesExpression = exports2.TSAsExpression = TSTypeExpression;
      exports2.TSBigIntKeyword = TSBigIntKeyword;
      exports2.TSBooleanKeyword = TSBooleanKeyword;
      exports2.TSCallSignatureDeclaration = TSCallSignatureDeclaration;
      exports2.TSConditionalType = TSConditionalType;
      exports2.TSConstructSignatureDeclaration = TSConstructSignatureDeclaration;
      exports2.TSConstructorType = TSConstructorType;
      exports2.TSDeclareFunction = TSDeclareFunction;
      exports2.TSDeclareMethod = TSDeclareMethod;
      exports2.TSEnumDeclaration = TSEnumDeclaration;
      exports2.TSEnumMember = TSEnumMember;
      exports2.TSExportAssignment = TSExportAssignment;
      exports2.TSExpressionWithTypeArguments = TSExpressionWithTypeArguments;
      exports2.TSExternalModuleReference = TSExternalModuleReference;
      exports2.TSFunctionType = TSFunctionType;
      exports2.TSImportEqualsDeclaration = TSImportEqualsDeclaration;
      exports2.TSImportType = TSImportType;
      exports2.TSIndexSignature = TSIndexSignature;
      exports2.TSIndexedAccessType = TSIndexedAccessType;
      exports2.TSInferType = TSInferType;
      exports2.TSInstantiationExpression = TSInstantiationExpression;
      exports2.TSInterfaceBody = TSInterfaceBody;
      exports2.TSInterfaceDeclaration = TSInterfaceDeclaration;
      exports2.TSIntersectionType = TSIntersectionType;
      exports2.TSIntrinsicKeyword = TSIntrinsicKeyword;
      exports2.TSLiteralType = TSLiteralType;
      exports2.TSMappedType = TSMappedType;
      exports2.TSMethodSignature = TSMethodSignature;
      exports2.TSModuleBlock = TSModuleBlock;
      exports2.TSModuleDeclaration = TSModuleDeclaration;
      exports2.TSNamedTupleMember = TSNamedTupleMember;
      exports2.TSNamespaceExportDeclaration = TSNamespaceExportDeclaration;
      exports2.TSNeverKeyword = TSNeverKeyword;
      exports2.TSNonNullExpression = TSNonNullExpression;
      exports2.TSNullKeyword = TSNullKeyword;
      exports2.TSNumberKeyword = TSNumberKeyword;
      exports2.TSObjectKeyword = TSObjectKeyword;
      exports2.TSOptionalType = TSOptionalType;
      exports2.TSParameterProperty = TSParameterProperty;
      exports2.TSParenthesizedType = TSParenthesizedType;
      exports2.TSPropertySignature = TSPropertySignature;
      exports2.TSQualifiedName = TSQualifiedName;
      exports2.TSRestType = TSRestType;
      exports2.TSStringKeyword = TSStringKeyword;
      exports2.TSSymbolKeyword = TSSymbolKeyword;
      exports2.TSThisType = TSThisType;
      exports2.TSTupleType = TSTupleType;
      exports2.TSTypeAliasDeclaration = TSTypeAliasDeclaration;
      exports2.TSTypeAnnotation = TSTypeAnnotation;
      exports2.TSTypeAssertion = TSTypeAssertion;
      exports2.TSTypeLiteral = TSTypeLiteral;
      exports2.TSTypeOperator = TSTypeOperator;
      exports2.TSTypeParameter = TSTypeParameter;
      exports2.TSTypeParameterDeclaration = exports2.TSTypeParameterInstantiation = TSTypeParameterInstantiation;
      exports2.TSTypePredicate = TSTypePredicate;
      exports2.TSTypeQuery = TSTypeQuery;
      exports2.TSTypeReference = TSTypeReference;
      exports2.TSUndefinedKeyword = TSUndefinedKeyword;
      exports2.TSUnionType = TSUnionType;
      exports2.TSUnknownKeyword = TSUnknownKeyword;
      exports2.TSVoidKeyword = TSVoidKeyword;
      exports2.tsPrintClassMemberModifiers = tsPrintClassMemberModifiers;
      exports2.tsPrintFunctionOrConstructorType = tsPrintFunctionOrConstructorType;
      exports2.tsPrintPropertyOrMethodName = tsPrintPropertyOrMethodName;
      exports2.tsPrintSignatureDeclarationBase = tsPrintSignatureDeclarationBase;
      exports2.tsPrintTypeLiteralOrInterfaceBody = tsPrintTypeLiteralOrInterfaceBody;
      function TSTypeAnnotation(node) {
        this.tokenChar(58);
        this.space();
        if (node.optional)
          this.tokenChar(63);
        this.print(node.typeAnnotation, node);
      }
      function TSTypeParameterInstantiation(node, parent2) {
        this.tokenChar(60);
        this.printList(node.params, node, {});
        if (parent2.type === "ArrowFunctionExpression" && node.params.length === 1) {
          this.tokenChar(44);
        }
        this.tokenChar(62);
      }
      function TSTypeParameter(node) {
        if (node.in) {
          this.word("in");
          this.space();
        }
        if (node.out) {
          this.word("out");
          this.space();
        }
        this.word(node.name);
        if (node.constraint) {
          this.space();
          this.word("extends");
          this.space();
          this.print(node.constraint, node);
        }
        if (node.default) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(node.default, node);
        }
      }
      function TSParameterProperty(node) {
        if (node.accessibility) {
          this.word(node.accessibility);
          this.space();
        }
        if (node.readonly) {
          this.word("readonly");
          this.space();
        }
        this._param(node.parameter);
      }
      function TSDeclareFunction(node) {
        if (node.declare) {
          this.word("declare");
          this.space();
        }
        this._functionHead(node);
        this.tokenChar(59);
      }
      function TSDeclareMethod(node) {
        this._classMethodHead(node);
        this.tokenChar(59);
      }
      function TSQualifiedName(node) {
        this.print(node.left, node);
        this.tokenChar(46);
        this.print(node.right, node);
      }
      function TSCallSignatureDeclaration(node) {
        this.tsPrintSignatureDeclarationBase(node);
        this.tokenChar(59);
      }
      function TSConstructSignatureDeclaration(node) {
        this.word("new");
        this.space();
        this.tsPrintSignatureDeclarationBase(node);
        this.tokenChar(59);
      }
      function TSPropertySignature(node) {
        const {
          readonly,
          initializer
        } = node;
        if (readonly) {
          this.word("readonly");
          this.space();
        }
        this.tsPrintPropertyOrMethodName(node);
        this.print(node.typeAnnotation, node);
        if (initializer) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(initializer, node);
        }
        this.tokenChar(59);
      }
      function tsPrintPropertyOrMethodName(node) {
        if (node.computed) {
          this.tokenChar(91);
        }
        this.print(node.key, node);
        if (node.computed) {
          this.tokenChar(93);
        }
        if (node.optional) {
          this.tokenChar(63);
        }
      }
      function TSMethodSignature(node) {
        const {
          kind
        } = node;
        if (kind === "set" || kind === "get") {
          this.word(kind);
          this.space();
        }
        this.tsPrintPropertyOrMethodName(node);
        this.tsPrintSignatureDeclarationBase(node);
        this.tokenChar(59);
      }
      function TSIndexSignature(node) {
        const {
          readonly,
          static: isStatic
        } = node;
        if (isStatic) {
          this.word("static");
          this.space();
        }
        if (readonly) {
          this.word("readonly");
          this.space();
        }
        this.tokenChar(91);
        this._parameters(node.parameters, node);
        this.tokenChar(93);
        this.print(node.typeAnnotation, node);
        this.tokenChar(59);
      }
      function TSAnyKeyword() {
        this.word("any");
      }
      function TSBigIntKeyword() {
        this.word("bigint");
      }
      function TSUnknownKeyword() {
        this.word("unknown");
      }
      function TSNumberKeyword() {
        this.word("number");
      }
      function TSObjectKeyword() {
        this.word("object");
      }
      function TSBooleanKeyword() {
        this.word("boolean");
      }
      function TSStringKeyword() {
        this.word("string");
      }
      function TSSymbolKeyword() {
        this.word("symbol");
      }
      function TSVoidKeyword() {
        this.word("void");
      }
      function TSUndefinedKeyword() {
        this.word("undefined");
      }
      function TSNullKeyword() {
        this.word("null");
      }
      function TSNeverKeyword() {
        this.word("never");
      }
      function TSIntrinsicKeyword() {
        this.word("intrinsic");
      }
      function TSThisType() {
        this.word("this");
      }
      function TSFunctionType(node) {
        this.tsPrintFunctionOrConstructorType(node);
      }
      function TSConstructorType(node) {
        if (node.abstract) {
          this.word("abstract");
          this.space();
        }
        this.word("new");
        this.space();
        this.tsPrintFunctionOrConstructorType(node);
      }
      function tsPrintFunctionOrConstructorType(node) {
        const {
          typeParameters
        } = node;
        const parameters = node.parameters;
        this.print(typeParameters, node);
        this.tokenChar(40);
        this._parameters(parameters, node);
        this.tokenChar(41);
        this.space();
        this.token("=>");
        this.space();
        const returnType = node.typeAnnotation;
        this.print(returnType.typeAnnotation, node);
      }
      function TSTypeReference(node) {
        this.print(node.typeName, node, true);
        this.print(node.typeParameters, node, true);
      }
      function TSTypePredicate(node) {
        if (node.asserts) {
          this.word("asserts");
          this.space();
        }
        this.print(node.parameterName);
        if (node.typeAnnotation) {
          this.space();
          this.word("is");
          this.space();
          this.print(node.typeAnnotation.typeAnnotation);
        }
      }
      function TSTypeQuery(node) {
        this.word("typeof");
        this.space();
        this.print(node.exprName);
        if (node.typeParameters) {
          this.print(node.typeParameters, node);
        }
      }
      function TSTypeLiteral(node) {
        this.tsPrintTypeLiteralOrInterfaceBody(node.members, node);
      }
      function tsPrintTypeLiteralOrInterfaceBody(members, node) {
        tsPrintBraced(this, members, node);
      }
      function tsPrintBraced(printer, members, node) {
        printer.token("{");
        if (members.length) {
          printer.indent();
          printer.newline();
          for (const member of members) {
            printer.print(member, node);
            printer.newline();
          }
          printer.dedent();
        }
        printer.sourceWithOffset("end", node.loc, 0, -1);
        printer.rightBrace();
      }
      function TSArrayType(node) {
        this.print(node.elementType, node, true);
        this.token("[]");
      }
      function TSTupleType(node) {
        this.tokenChar(91);
        this.printList(node.elementTypes, node);
        this.tokenChar(93);
      }
      function TSOptionalType(node) {
        this.print(node.typeAnnotation, node);
        this.tokenChar(63);
      }
      function TSRestType(node) {
        this.token("...");
        this.print(node.typeAnnotation, node);
      }
      function TSNamedTupleMember(node) {
        this.print(node.label, node);
        if (node.optional)
          this.tokenChar(63);
        this.tokenChar(58);
        this.space();
        this.print(node.elementType, node);
      }
      function TSUnionType(node) {
        tsPrintUnionOrIntersectionType(this, node, "|");
      }
      function TSIntersectionType(node) {
        tsPrintUnionOrIntersectionType(this, node, "&");
      }
      function tsPrintUnionOrIntersectionType(printer, node, sep) {
        printer.printJoin(node.types, node, {
          separator() {
            this.space();
            this.token(sep);
            this.space();
          }
        });
      }
      function TSConditionalType(node) {
        this.print(node.checkType);
        this.space();
        this.word("extends");
        this.space();
        this.print(node.extendsType);
        this.space();
        this.tokenChar(63);
        this.space();
        this.print(node.trueType);
        this.space();
        this.tokenChar(58);
        this.space();
        this.print(node.falseType);
      }
      function TSInferType(node) {
        this.token("infer");
        this.space();
        this.print(node.typeParameter);
      }
      function TSParenthesizedType(node) {
        this.tokenChar(40);
        this.print(node.typeAnnotation, node);
        this.tokenChar(41);
      }
      function TSTypeOperator(node) {
        this.word(node.operator);
        this.space();
        this.print(node.typeAnnotation, node);
      }
      function TSIndexedAccessType(node) {
        this.print(node.objectType, node, true);
        this.tokenChar(91);
        this.print(node.indexType, node);
        this.tokenChar(93);
      }
      function TSMappedType(node) {
        const {
          nameType,
          optional,
          readonly,
          typeParameter
        } = node;
        this.tokenChar(123);
        this.space();
        if (readonly) {
          tokenIfPlusMinus(this, readonly);
          this.word("readonly");
          this.space();
        }
        this.tokenChar(91);
        this.word(typeParameter.name);
        this.space();
        this.word("in");
        this.space();
        this.print(typeParameter.constraint, typeParameter);
        if (nameType) {
          this.space();
          this.word("as");
          this.space();
          this.print(nameType, node);
        }
        this.tokenChar(93);
        if (optional) {
          tokenIfPlusMinus(this, optional);
          this.tokenChar(63);
        }
        this.tokenChar(58);
        this.space();
        this.print(node.typeAnnotation, node);
        this.space();
        this.tokenChar(125);
      }
      function tokenIfPlusMinus(self2, tok) {
        if (tok !== true) {
          self2.token(tok);
        }
      }
      function TSLiteralType(node) {
        this.print(node.literal, node);
      }
      function TSExpressionWithTypeArguments(node) {
        this.print(node.expression, node);
        this.print(node.typeParameters, node);
      }
      function TSInterfaceDeclaration(node) {
        const {
          declare,
          id,
          typeParameters,
          extends: extendz,
          body
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        this.word("interface");
        this.space();
        this.print(id, node);
        this.print(typeParameters, node);
        if (extendz != null && extendz.length) {
          this.space();
          this.word("extends");
          this.space();
          this.printList(extendz, node);
        }
        this.space();
        this.print(body, node);
      }
      function TSInterfaceBody(node) {
        this.tsPrintTypeLiteralOrInterfaceBody(node.body, node);
      }
      function TSTypeAliasDeclaration(node) {
        const {
          declare,
          id,
          typeParameters,
          typeAnnotation
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        this.word("type");
        this.space();
        this.print(id, node);
        this.print(typeParameters, node);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(typeAnnotation, node);
        this.tokenChar(59);
      }
      function TSTypeExpression(node) {
        var _expression$trailingC;
        const {
          type,
          expression,
          typeAnnotation
        } = node;
        const forceParens = !!((_expression$trailingC = expression.trailingComments) != null && _expression$trailingC.length);
        this.print(expression, node, true, void 0, forceParens);
        this.space();
        this.word(type === "TSAsExpression" ? "as" : "satisfies");
        this.space();
        this.print(typeAnnotation, node);
      }
      function TSTypeAssertion(node) {
        const {
          typeAnnotation,
          expression
        } = node;
        this.tokenChar(60);
        this.print(typeAnnotation, node);
        this.tokenChar(62);
        this.space();
        this.print(expression, node);
      }
      function TSInstantiationExpression(node) {
        this.print(node.expression, node);
        this.print(node.typeParameters, node);
      }
      function TSEnumDeclaration(node) {
        const {
          declare,
          const: isConst,
          id,
          members
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        if (isConst) {
          this.word("const");
          this.space();
        }
        this.word("enum");
        this.space();
        this.print(id, node);
        this.space();
        tsPrintBraced(this, members, node);
      }
      function TSEnumMember(node) {
        const {
          id,
          initializer
        } = node;
        this.print(id, node);
        if (initializer) {
          this.space();
          this.tokenChar(61);
          this.space();
          this.print(initializer, node);
        }
        this.tokenChar(44);
      }
      function TSModuleDeclaration(node) {
        const {
          declare,
          id
        } = node;
        if (declare) {
          this.word("declare");
          this.space();
        }
        if (!node.global) {
          this.word(id.type === "Identifier" ? "namespace" : "module");
          this.space();
        }
        this.print(id, node);
        if (!node.body) {
          this.tokenChar(59);
          return;
        }
        let body = node.body;
        while (body.type === "TSModuleDeclaration") {
          this.tokenChar(46);
          this.print(body.id, body);
          body = body.body;
        }
        this.space();
        this.print(body, node);
      }
      function TSModuleBlock(node) {
        tsPrintBraced(this, node.body, node);
      }
      function TSImportType(node) {
        const {
          argument,
          qualifier,
          typeParameters
        } = node;
        this.word("import");
        this.tokenChar(40);
        this.print(argument, node);
        this.tokenChar(41);
        if (qualifier) {
          this.tokenChar(46);
          this.print(qualifier, node);
        }
        if (typeParameters) {
          this.print(typeParameters, node);
        }
      }
      function TSImportEqualsDeclaration(node) {
        const {
          isExport,
          id,
          moduleReference
        } = node;
        if (isExport) {
          this.word("export");
          this.space();
        }
        this.word("import");
        this.space();
        this.print(id, node);
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(moduleReference, node);
        this.tokenChar(59);
      }
      function TSExternalModuleReference(node) {
        this.token("require(");
        this.print(node.expression, node);
        this.tokenChar(41);
      }
      function TSNonNullExpression(node) {
        this.print(node.expression, node);
        this.tokenChar(33);
      }
      function TSExportAssignment(node) {
        this.word("export");
        this.space();
        this.tokenChar(61);
        this.space();
        this.print(node.expression, node);
        this.tokenChar(59);
      }
      function TSNamespaceExportDeclaration(node) {
        this.word("export");
        this.space();
        this.word("as");
        this.space();
        this.word("namespace");
        this.space();
        this.print(node.id, node);
      }
      function tsPrintSignatureDeclarationBase(node) {
        const {
          typeParameters
        } = node;
        const parameters = node.parameters;
        this.print(typeParameters, node);
        this.tokenChar(40);
        this._parameters(parameters, node);
        this.tokenChar(41);
        const returnType = node.typeAnnotation;
        this.print(returnType, node);
      }
      function tsPrintClassMemberModifiers(node) {
        const isField = node.type === "ClassAccessorProperty" || node.type === "ClassProperty";
        if (isField && node.declare) {
          this.word("declare");
          this.space();
        }
        if (node.accessibility) {
          this.word(node.accessibility);
          this.space();
        }
        if (node.static) {
          this.word("static");
          this.space();
        }
        if (node.override) {
          this.word("override");
          this.space();
        }
        if (node.abstract) {
          this.word("abstract");
          this.space();
        }
        if (isField && node.readonly) {
          this.word("readonly");
          this.space();
        }
      }
    }
  });

  // node_modules/@babel/generator/lib/generators/index.js
  var require_generators = __commonJS({
    "node_modules/@babel/generator/lib/generators/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      var _templateLiterals = require_template_literals();
      Object.keys(_templateLiterals).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _templateLiterals[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _templateLiterals[key];
          }
        });
      });
      var _expressions = require_expressions();
      Object.keys(_expressions).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _expressions[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _expressions[key];
          }
        });
      });
      var _statements = require_statements();
      Object.keys(_statements).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _statements[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _statements[key];
          }
        });
      });
      var _classes = require_classes();
      Object.keys(_classes).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _classes[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _classes[key];
          }
        });
      });
      var _methods = require_methods();
      Object.keys(_methods).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _methods[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _methods[key];
          }
        });
      });
      var _modules = require_modules();
      Object.keys(_modules).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _modules[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _modules[key];
          }
        });
      });
      var _types = require_types3();
      Object.keys(_types).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _types[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _types[key];
          }
        });
      });
      var _flow = require_flow2();
      Object.keys(_flow).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _flow[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _flow[key];
          }
        });
      });
      var _base = require_base2();
      Object.keys(_base).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _base[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _base[key];
          }
        });
      });
      var _jsx = require_jsx2();
      Object.keys(_jsx).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _jsx[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _jsx[key];
          }
        });
      });
      var _typescript = require_typescript2();
      Object.keys(_typescript).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports2 && exports2[key] === _typescript[key])
          return;
        Object.defineProperty(exports2, key, {
          enumerable: true,
          get: function() {
            return _typescript[key];
          }
        });
      });
    }
  });

  // node_modules/@babel/generator/lib/printer.js
  var require_printer = __commonJS({
    "node_modules/@babel/generator/lib/printer.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _buffer = require_buffer2();
      var n = require_node();
      var _t = require_lib5();
      var generatorFunctions = require_generators();
      var {
        isFunction: isFunction2,
        isStatement,
        isClassBody,
        isTSInterfaceBody
      } = _t;
      var SCIENTIFIC_NOTATION = /e/i;
      var ZERO_DECIMAL_INTEGER = /\.0+$/;
      var NON_DECIMAL_LITERAL = /^0[box]/;
      var PURE_ANNOTATION_RE = /^\s*[@#]__PURE__\s*$/;
      var HAS_NEWLINE = /[\n\r\u2028\u2029]/;
      var HAS_BlOCK_COMMENT_END = /\*\//;
      var {
        needsParens
      } = n;
      var Printer = class {
        constructor(format, map2) {
          this.inForStatementInitCounter = 0;
          this._printStack = [];
          this._indent = 0;
          this._indentChar = 0;
          this._indentRepeat = 0;
          this._insideAux = false;
          this._parenPushNewlineState = null;
          this._noLineTerminator = false;
          this._printAuxAfterOnNextUserNode = false;
          this._printedComments = /* @__PURE__ */ new Set();
          this._endsWithInteger = false;
          this._endsWithWord = false;
          this._lastCommentLine = 0;
          this._endsWithInnerRaw = false;
          this._indentInnerComments = true;
          this.format = format;
          this._buf = new _buffer.default(map2);
          this._indentChar = format.indent.style.charCodeAt(0);
          this._indentRepeat = format.indent.style.length;
        }
        generate(ast) {
          this.print(ast);
          this._maybeAddAuxComment();
          return this._buf.get();
        }
        indent() {
          if (this.format.compact || this.format.concise)
            return;
          this._indent++;
        }
        dedent() {
          if (this.format.compact || this.format.concise)
            return;
          this._indent--;
        }
        semicolon(force = false) {
          this._maybeAddAuxComment();
          if (force) {
            this._appendChar(59);
          } else {
            this._queue(59);
          }
          this._noLineTerminator = false;
        }
        rightBrace() {
          if (this.format.minified) {
            this._buf.removeLastSemicolon();
          }
          this.tokenChar(125);
        }
        space(force = false) {
          if (this.format.compact)
            return;
          if (force) {
            this._space();
          } else if (this._buf.hasContent()) {
            const lastCp = this.getLastChar();
            if (lastCp !== 32 && lastCp !== 10) {
              this._space();
            }
          }
        }
        word(str, noLineTerminatorAfter = false) {
          this._maybePrintInnerComments();
          if (this._endsWithWord || str.charCodeAt(0) === 47 && this.endsWith(47)) {
            this._space();
          }
          this._maybeAddAuxComment();
          this._append(str, false);
          this._endsWithWord = true;
          this._noLineTerminator = noLineTerminatorAfter;
        }
        number(str) {
          this.word(str);
          this._endsWithInteger = Number.isInteger(+str) && !NON_DECIMAL_LITERAL.test(str) && !SCIENTIFIC_NOTATION.test(str) && !ZERO_DECIMAL_INTEGER.test(str) && str.charCodeAt(str.length - 1) !== 46;
        }
        token(str, maybeNewline = false) {
          this._maybePrintInnerComments();
          const lastChar = this.getLastChar();
          const strFirst = str.charCodeAt(0);
          if (lastChar === 33 && str === "--" || strFirst === 43 && lastChar === 43 || strFirst === 45 && lastChar === 45 || strFirst === 46 && this._endsWithInteger) {
            this._space();
          }
          this._maybeAddAuxComment();
          this._append(str, maybeNewline);
          this._noLineTerminator = false;
        }
        tokenChar(char) {
          this._maybePrintInnerComments();
          const lastChar = this.getLastChar();
          if (char === 43 && lastChar === 43 || char === 45 && lastChar === 45 || char === 46 && this._endsWithInteger) {
            this._space();
          }
          this._maybeAddAuxComment();
          this._appendChar(char);
          this._noLineTerminator = false;
        }
        newline(i = 1, force) {
          if (i <= 0)
            return;
          if (!force) {
            if (this.format.retainLines || this.format.compact)
              return;
            if (this.format.concise) {
              this.space();
              return;
            }
          }
          if (i > 2)
            i = 2;
          i -= this._buf.getNewlineCount();
          for (let j = 0; j < i; j++) {
            this._newline();
          }
          return;
        }
        endsWith(char) {
          return this.getLastChar() === char;
        }
        getLastChar() {
          return this._buf.getLastChar();
        }
        endsWithCharAndNewline() {
          return this._buf.endsWithCharAndNewline();
        }
        removeTrailingNewline() {
          this._buf.removeTrailingNewline();
        }
        exactSource(loc, cb) {
          if (!loc)
            return cb();
          this._catchUp("start", loc);
          this._buf.exactSource(loc, cb);
        }
        source(prop, loc) {
          if (!loc)
            return;
          this._catchUp(prop, loc);
          this._buf.source(prop, loc);
        }
        sourceWithOffset(prop, loc, lineOffset, columnOffset) {
          if (!loc)
            return;
          this._catchUp(prop, loc);
          this._buf.sourceWithOffset(prop, loc, lineOffset, columnOffset);
        }
        withSource(prop, loc, cb) {
          if (!loc)
            return cb();
          this._catchUp(prop, loc);
          this._buf.withSource(prop, loc, cb);
        }
        _space() {
          this._queue(32);
        }
        _newline() {
          this._queue(10);
        }
        _append(str, maybeNewline) {
          this._maybeAddParen(str);
          this._maybeIndent(str.charCodeAt(0));
          this._buf.append(str, maybeNewline);
          this._endsWithWord = false;
          this._endsWithInteger = false;
        }
        _appendChar(char) {
          this._maybeAddParenChar(char);
          this._maybeIndent(char);
          this._buf.appendChar(char);
          this._endsWithWord = false;
          this._endsWithInteger = false;
        }
        _queue(char) {
          this._maybeAddParenChar(char);
          this._maybeIndent(char);
          this._buf.queue(char);
          this._endsWithWord = false;
          this._endsWithInteger = false;
        }
        _maybeIndent(firstChar) {
          if (this._indent && firstChar !== 10 && this.endsWith(10)) {
            this._buf.queueIndentation(this._indentChar, this._getIndent());
          }
        }
        _shouldIndent(firstChar) {
          if (this._indent && firstChar !== 10 && this.endsWith(10)) {
            return true;
          }
        }
        _maybeAddParenChar(char) {
          const parenPushNewlineState = this._parenPushNewlineState;
          if (!parenPushNewlineState)
            return;
          if (char === 32) {
            return;
          }
          if (char !== 10) {
            this._parenPushNewlineState = null;
            return;
          }
          this.tokenChar(40);
          this.indent();
          parenPushNewlineState.printed = true;
        }
        _maybeAddParen(str) {
          const parenPushNewlineState = this._parenPushNewlineState;
          if (!parenPushNewlineState)
            return;
          const len = str.length;
          let i;
          for (i = 0; i < len && str.charCodeAt(i) === 32; i++)
            continue;
          if (i === len) {
            return;
          }
          const cha = str.charCodeAt(i);
          if (cha !== 10) {
            if (cha !== 47 || i + 1 === len) {
              this._parenPushNewlineState = null;
              return;
            }
            const chaPost = str.charCodeAt(i + 1);
            if (chaPost === 42) {
              if (PURE_ANNOTATION_RE.test(str.slice(i + 2, len - 2))) {
                return;
              }
            } else if (chaPost !== 47) {
              this._parenPushNewlineState = null;
              return;
            }
          }
          this.tokenChar(40);
          this.indent();
          parenPushNewlineState.printed = true;
        }
        catchUp(line) {
          if (!this.format.retainLines)
            return;
          const count = line - this._buf.getCurrentLine();
          for (let i = 0; i < count; i++) {
            this._newline();
          }
        }
        _catchUp(prop, loc) {
          if (!this.format.retainLines)
            return;
          const pos = loc ? loc[prop] : null;
          if ((pos == null ? void 0 : pos.line) != null) {
            const count = pos.line - this._buf.getCurrentLine();
            for (let i = 0; i < count; i++) {
              this._newline();
            }
          }
        }
        _getIndent() {
          return this._indentRepeat * this._indent;
        }
        printTerminatorless(node, parent2, isLabel) {
          if (isLabel) {
            this._noLineTerminator = true;
            this.print(node, parent2);
          } else {
            const terminatorState = {
              printed: false
            };
            this._parenPushNewlineState = terminatorState;
            this.print(node, parent2);
            if (terminatorState.printed) {
              this.dedent();
              this.newline();
              this.tokenChar(41);
            }
          }
        }
        print(node, parent2, noLineTerminatorAfter, trailingCommentsLineOffset, forceParens) {
          if (!node)
            return;
          this._endsWithInnerRaw = false;
          const nodeType = node.type;
          const format = this.format;
          const oldConcise = format.concise;
          if (node._compact) {
            format.concise = true;
          }
          const printMethod = this[nodeType];
          if (printMethod === void 0) {
            throw new ReferenceError(`unknown node of type ${JSON.stringify(nodeType)} with constructor ${JSON.stringify(node.constructor.name)}`);
          }
          this._printStack.push(node);
          const oldInAux = this._insideAux;
          this._insideAux = node.loc == void 0;
          this._maybeAddAuxComment(this._insideAux && !oldInAux);
          let shouldPrintParens = false;
          if (forceParens) {
            shouldPrintParens = true;
          } else if (format.retainFunctionParens && nodeType === "FunctionExpression" && node.extra && node.extra.parenthesized) {
            shouldPrintParens = true;
          } else {
            shouldPrintParens = needsParens(node, parent2, this._printStack);
          }
          if (shouldPrintParens)
            this.tokenChar(40);
          this._lastCommentLine = 0;
          this._printLeadingComments(node, parent2);
          const loc = nodeType === "Program" || nodeType === "File" ? null : node.loc;
          this.exactSource(loc, printMethod.bind(this, node, parent2));
          if (shouldPrintParens) {
            this._printTrailingComments(node, parent2);
            this.tokenChar(41);
            this._noLineTerminator = noLineTerminatorAfter;
          } else if (noLineTerminatorAfter && !this._noLineTerminator) {
            this._noLineTerminator = true;
            this._printTrailingComments(node, parent2);
          } else {
            this._printTrailingComments(node, parent2, trailingCommentsLineOffset);
          }
          this._printStack.pop();
          format.concise = oldConcise;
          this._insideAux = oldInAux;
          this._endsWithInnerRaw = false;
        }
        _maybeAddAuxComment(enteredPositionlessNode) {
          if (enteredPositionlessNode)
            this._printAuxBeforeComment();
          if (!this._insideAux)
            this._printAuxAfterComment();
        }
        _printAuxBeforeComment() {
          if (this._printAuxAfterOnNextUserNode)
            return;
          this._printAuxAfterOnNextUserNode = true;
          const comment = this.format.auxiliaryCommentBefore;
          if (comment) {
            this._printComment({
              type: "CommentBlock",
              value: comment
            }, 0);
          }
        }
        _printAuxAfterComment() {
          if (!this._printAuxAfterOnNextUserNode)
            return;
          this._printAuxAfterOnNextUserNode = false;
          const comment = this.format.auxiliaryCommentAfter;
          if (comment) {
            this._printComment({
              type: "CommentBlock",
              value: comment
            }, 0);
          }
        }
        getPossibleRaw(node) {
          const extra = node.extra;
          if (extra && extra.raw != null && extra.rawValue != null && node.value === extra.rawValue) {
            return extra.raw;
          }
        }
        printJoin(nodes, parent2, opts = {}) {
          if (!(nodes != null && nodes.length))
            return;
          if (opts.indent)
            this.indent();
          const newlineOpts = {
            addNewlines: opts.addNewlines,
            nextNodeStartLine: 0
          };
          const separator = opts.separator ? opts.separator.bind(this) : null;
          const len = nodes.length;
          for (let i = 0; i < len; i++) {
            const node = nodes[i];
            if (!node)
              continue;
            if (opts.statement)
              this._printNewline(i === 0, newlineOpts);
            this.print(node, parent2, void 0, opts.trailingCommentsLineOffset || 0);
            opts.iterator == null ? void 0 : opts.iterator(node, i);
            if (i < len - 1)
              separator == null ? void 0 : separator();
            if (opts.statement) {
              if (i + 1 === len) {
                this.newline(1);
              } else {
                var _nextNode$loc;
                const nextNode = nodes[i + 1];
                newlineOpts.nextNodeStartLine = ((_nextNode$loc = nextNode.loc) == null ? void 0 : _nextNode$loc.start.line) || 0;
                this._printNewline(true, newlineOpts);
              }
            }
          }
          if (opts.indent)
            this.dedent();
        }
        printAndIndentOnComments(node, parent2) {
          const indent = node.leadingComments && node.leadingComments.length > 0;
          if (indent)
            this.indent();
          this.print(node, parent2);
          if (indent)
            this.dedent();
        }
        printBlock(parent2) {
          const node = parent2.body;
          if (node.type !== "EmptyStatement") {
            this.space();
          }
          this.print(node, parent2);
        }
        _printTrailingComments(node, parent2, lineOffset) {
          const {
            innerComments,
            trailingComments
          } = node;
          if (innerComments != null && innerComments.length) {
            this._printComments(2, innerComments, node, parent2, lineOffset);
          }
          if (trailingComments != null && trailingComments.length) {
            this._printComments(2, trailingComments, node, parent2, lineOffset);
          }
        }
        _printLeadingComments(node, parent2) {
          const comments = node.leadingComments;
          if (!(comments != null && comments.length))
            return;
          this._printComments(0, comments, node, parent2);
        }
        _maybePrintInnerComments() {
          if (this._endsWithInnerRaw)
            this.printInnerComments();
          this._endsWithInnerRaw = true;
          this._indentInnerComments = true;
        }
        printInnerComments() {
          const node = this._printStack[this._printStack.length - 1];
          const comments = node.innerComments;
          if (!(comments != null && comments.length))
            return;
          const hasSpace = this.endsWith(32);
          const indent = this._indentInnerComments;
          const printedCommentsCount = this._printedComments.size;
          if (indent)
            this.indent();
          this._printComments(1, comments, node);
          if (hasSpace && printedCommentsCount !== this._printedComments.size) {
            this.space();
          }
          if (indent)
            this.dedent();
        }
        noIndentInnerCommentsHere() {
          this._indentInnerComments = false;
        }
        printSequence(nodes, parent2, opts = {}) {
          opts.statement = true;
          return this.printJoin(nodes, parent2, opts);
        }
        printList(items, parent2, opts = {}) {
          if (opts.separator == null) {
            opts.separator = commaSeparator;
          }
          return this.printJoin(items, parent2, opts);
        }
        _printNewline(newLine, opts) {
          if (this.format.retainLines || this.format.compact)
            return;
          if (this.format.concise) {
            this.space();
            return;
          }
          if (!newLine) {
            return;
          }
          const startLine = opts.nextNodeStartLine;
          const lastCommentLine = this._lastCommentLine;
          if (startLine > 0 && lastCommentLine > 0) {
            const offset = startLine - lastCommentLine;
            if (offset >= 0) {
              this.newline(offset || 1);
              return;
            }
          }
          if (this._buf.hasContent()) {
            this.newline(1);
          }
        }
        _printComment(comment, skipNewLines) {
          if (comment.ignore)
            return false;
          if (this._printedComments.has(comment))
            return false;
          const noLineTerminator = this._noLineTerminator;
          if (noLineTerminator && (HAS_NEWLINE.test(comment.value) || HAS_BlOCK_COMMENT_END.test(comment.value))) {
            return true;
          }
          if (!this.format.shouldPrintComment(comment.value))
            return false;
          this._printedComments.add(comment);
          const isBlockComment = comment.type === "CommentBlock";
          const printNewLines = isBlockComment && skipNewLines !== 1 && !this._noLineTerminator;
          if (printNewLines && this._buf.hasContent() && skipNewLines !== 2) {
            this.newline(1);
          }
          const lastCharCode = this.getLastChar();
          if (lastCharCode !== 91 && lastCharCode !== 123) {
            this.space();
          }
          let val;
          if (isBlockComment) {
            val = `/*${comment.value}*/`;
            if (this.format.indent.adjustMultilineComment) {
              var _comment$loc;
              const offset = (_comment$loc = comment.loc) == null ? void 0 : _comment$loc.start.column;
              if (offset) {
                const newlineRegex = new RegExp("\\n\\s{1," + offset + "}", "g");
                val = val.replace(newlineRegex, "\n");
              }
              let indentSize = this.format.retainLines ? 0 : this._buf.getCurrentColumn();
              if (this._shouldIndent(47) || this.format.retainLines) {
                indentSize += this._getIndent();
              }
              val = val.replace(/\n(?!$)/g, `
${" ".repeat(indentSize)}`);
            }
          } else if (!noLineTerminator) {
            val = `//${comment.value}`;
          } else {
            val = `/*${comment.value}*/`;
          }
          if (this.endsWith(47))
            this._space();
          this.source("start", comment.loc);
          this._append(val, isBlockComment);
          if (!isBlockComment && !noLineTerminator) {
            this.newline(1, true);
          }
          if (printNewLines && skipNewLines !== 3) {
            this.newline(1);
          }
          return false;
        }
        _printComments(type, comments, node, parent2, lineOffset = 0) {
          const nodeLoc = node.loc;
          const len = comments.length;
          let hasLoc = !!nodeLoc;
          const nodeStartLine = hasLoc ? nodeLoc.start.line : 0;
          const nodeEndLine = hasLoc ? nodeLoc.end.line : 0;
          let lastLine = 0;
          let leadingCommentNewline = 0;
          const maybeNewline = this._noLineTerminator ? function() {
          } : this.newline.bind(this);
          for (let i = 0; i < len; i++) {
            const comment = comments[i];
            const printed = this._printedComments.has(comment);
            if (hasLoc && comment.loc && !printed) {
              const commentStartLine = comment.loc.start.line;
              const commentEndLine = comment.loc.end.line;
              if (type === 0) {
                let offset = 0;
                if (i === 0) {
                  if (this._buf.hasContent() && (comment.type === "CommentLine" || commentStartLine != commentEndLine)) {
                    offset = leadingCommentNewline = 1;
                  }
                } else {
                  offset = commentStartLine - lastLine;
                }
                lastLine = commentEndLine;
                maybeNewline(offset);
                this._printComment(comment, 1);
                if (i + 1 === len) {
                  maybeNewline(Math.max(nodeStartLine - lastLine, leadingCommentNewline));
                  lastLine = nodeStartLine;
                }
              } else if (type === 1) {
                const offset = commentStartLine - (i === 0 ? nodeStartLine : lastLine);
                lastLine = commentEndLine;
                maybeNewline(offset);
                if (this._printComment(comment, 1))
                  break;
                if (i + 1 === len) {
                  maybeNewline(Math.min(1, nodeEndLine - lastLine));
                  lastLine = nodeEndLine;
                }
              } else {
                const offset = commentStartLine - (i === 0 ? nodeEndLine - lineOffset : lastLine);
                lastLine = commentEndLine;
                maybeNewline(offset);
                this._printComment(comment, 1);
              }
            } else {
              hasLoc = false;
              if (printed)
                continue;
              if (len === 1) {
                const singleLine = comment.loc ? comment.loc.start.line === comment.loc.end.line : !HAS_NEWLINE.test(comment.value);
                const shouldSkipNewline = singleLine && !isStatement(node) && !isClassBody(parent2) && !isTSInterfaceBody(parent2);
                if (type === 0) {
                  this._printComment(comment, shouldSkipNewline && node.type !== "ObjectExpression" || singleLine && isFunction2(parent2, {
                    body: node
                  }) ? 1 : 0);
                } else if (shouldSkipNewline && type === 2) {
                  if (this._printComment(comment, 1)) {
                    break;
                  }
                } else {
                  this._printComment(comment, 0);
                }
              } else if (type === 1 && !(node.type === "ObjectExpression" && node.properties.length > 1) && node.type !== "ClassBody" && node.type !== "TSInterfaceBody") {
                const skippedDueToNewline = this._printComment(comment, i === 0 ? 2 : i === len - 1 ? 3 : 0);
                if (skippedDueToNewline)
                  break;
              } else {
                this._printComment(comment, 0);
              }
            }
          }
          if (type === 2 && hasLoc && lastLine) {
            this._lastCommentLine = lastLine;
          }
        }
      };
      Object.assign(Printer.prototype, generatorFunctions);
      {
        Printer.prototype.Noop = function Noop() {
        };
      }
      var _default = Printer;
      exports2.default = _default;
      function commaSeparator() {
        this.tokenChar(44);
        this.space();
      }
    }
  });

  // node_modules/@babel/generator/lib/index.js
  var require_lib6 = __commonJS({
    "node_modules/@babel/generator/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.CodeGenerator = void 0;
      exports2.default = generate4;
      var _sourceMap = require_source_map2();
      var _printer = require_printer();
      var Generator = class extends _printer.default {
        constructor(ast, opts = {}, code) {
          const format = normalizeOptions(code, opts);
          const map2 = opts.sourceMaps ? new _sourceMap.default(opts, code) : null;
          super(format, map2);
          this.ast = void 0;
          this.ast = ast;
        }
        generate() {
          return super.generate(this.ast);
        }
      };
      function normalizeOptions(code, opts) {
        const format = {
          auxiliaryCommentBefore: opts.auxiliaryCommentBefore,
          auxiliaryCommentAfter: opts.auxiliaryCommentAfter,
          shouldPrintComment: opts.shouldPrintComment,
          retainLines: opts.retainLines,
          retainFunctionParens: opts.retainFunctionParens,
          comments: opts.comments == null || opts.comments,
          compact: opts.compact,
          minified: opts.minified,
          concise: opts.concise,
          indent: {
            adjustMultilineComment: true,
            style: "  "
          },
          jsescOption: Object.assign({
            quotes: "double",
            wrap: true,
            minimal: false
          }, opts.jsescOption),
          recordAndTupleSyntaxType: opts.recordAndTupleSyntaxType,
          topicToken: opts.topicToken
        };
        {
          format.decoratorsBeforeExport = !!opts.decoratorsBeforeExport;
          format.jsonCompatibleStrings = opts.jsonCompatibleStrings;
        }
        if (format.minified) {
          format.compact = true;
          format.shouldPrintComment = format.shouldPrintComment || (() => format.comments);
        } else {
          format.shouldPrintComment = format.shouldPrintComment || ((value) => format.comments || value.includes("@license") || value.includes("@preserve"));
        }
        if (format.compact === "auto") {
          format.compact = code.length > 5e5;
          if (format.compact) {
            console.error(`[BABEL] Note: The code generator has deoptimised the styling of ${opts.filename} as it exceeds the max of ${"500KB"}.`);
          }
        }
        if (format.compact) {
          format.indent.adjustMultilineComment = false;
        }
        return format;
      }
      var CodeGenerator = class {
        constructor(ast, opts, code) {
          this._generator = void 0;
          this._generator = new Generator(ast, opts, code);
        }
        generate() {
          return this._generator.generate();
        }
      };
      exports2.CodeGenerator = CodeGenerator;
      function generate4(ast, opts, code) {
        const gen = new Generator(ast, opts, code);
        return gen.generate();
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/lib/virtual-types.js
  var require_virtual_types = __commonJS({
    "node_modules/@babel/traverse/lib/path/lib/virtual-types.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.Var = exports2.User = exports2.Statement = exports2.SpreadProperty = exports2.Scope = exports2.RestProperty = exports2.ReferencedMemberExpression = exports2.ReferencedIdentifier = exports2.Referenced = exports2.Pure = exports2.NumericLiteralTypeAnnotation = exports2.Generated = exports2.ForAwaitStatement = exports2.Flow = exports2.Expression = exports2.ExistentialTypeParam = exports2.BlockScoped = exports2.BindingIdentifier = void 0;
      var ReferencedIdentifier = ["Identifier", "JSXIdentifier"];
      exports2.ReferencedIdentifier = ReferencedIdentifier;
      var ReferencedMemberExpression = ["MemberExpression"];
      exports2.ReferencedMemberExpression = ReferencedMemberExpression;
      var BindingIdentifier = ["Identifier"];
      exports2.BindingIdentifier = BindingIdentifier;
      var Statement = ["Statement"];
      exports2.Statement = Statement;
      var Expression = ["Expression"];
      exports2.Expression = Expression;
      var Scope2 = ["Scopable", "Pattern"];
      exports2.Scope = Scope2;
      var Referenced = null;
      exports2.Referenced = Referenced;
      var BlockScoped = null;
      exports2.BlockScoped = BlockScoped;
      var Var = ["VariableDeclaration"];
      exports2.Var = Var;
      var User = null;
      exports2.User = User;
      var Generated = null;
      exports2.Generated = Generated;
      var Pure = null;
      exports2.Pure = Pure;
      var Flow = ["Flow", "ImportDeclaration", "ExportDeclaration", "ImportSpecifier"];
      exports2.Flow = Flow;
      var RestProperty = ["RestElement"];
      exports2.RestProperty = RestProperty;
      var SpreadProperty = ["RestElement"];
      exports2.SpreadProperty = SpreadProperty;
      var ExistentialTypeParam = ["ExistsTypeAnnotation"];
      exports2.ExistentialTypeParam = ExistentialTypeParam;
      var NumericLiteralTypeAnnotation = ["NumberLiteralTypeAnnotation"];
      exports2.NumericLiteralTypeAnnotation = NumericLiteralTypeAnnotation;
      var ForAwaitStatement = ["ForOfStatement"];
      exports2.ForAwaitStatement = ForAwaitStatement;
    }
  });

  // node_modules/@babel/traverse/lib/visitors.js
  var require_visitors = __commonJS({
    "node_modules/@babel/traverse/lib/visitors.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.explode = explode;
      exports2.merge = merge2;
      exports2.verify = verify;
      var virtualTypes = require_virtual_types();
      var _t = require_lib5();
      var {
        DEPRECATED_KEYS,
        FLIPPED_ALIAS_KEYS,
        TYPES
      } = _t;
      function isVirtualType(type) {
        return type in virtualTypes;
      }
      function explode(visitor) {
        if (visitor._exploded)
          return visitor;
        visitor._exploded = true;
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          const parts = nodeType.split("|");
          if (parts.length === 1)
            continue;
          const fns = visitor[nodeType];
          delete visitor[nodeType];
          for (const part of parts) {
            visitor[part] = fns;
          }
        }
        verify(visitor);
        delete visitor.__esModule;
        ensureEntranceObjects(visitor);
        ensureCallbackArrays(visitor);
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          if (!isVirtualType(nodeType))
            continue;
          const fns = visitor[nodeType];
          for (const type of Object.keys(fns)) {
            fns[type] = wrapCheck(nodeType, fns[type]);
          }
          delete visitor[nodeType];
          const types = virtualTypes[nodeType];
          if (types !== null) {
            for (const type of types) {
              if (visitor[type]) {
                mergePair(visitor[type], fns);
              } else {
                visitor[type] = fns;
              }
            }
          } else {
            mergePair(visitor, fns);
          }
        }
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          const fns = visitor[nodeType];
          let aliases = FLIPPED_ALIAS_KEYS[nodeType];
          const deprecatedKey = DEPRECATED_KEYS[nodeType];
          if (deprecatedKey) {
            console.trace(`Visitor defined for ${nodeType} but it has been renamed to ${deprecatedKey}`);
            aliases = [deprecatedKey];
          }
          if (!aliases)
            continue;
          delete visitor[nodeType];
          for (const alias of aliases) {
            const existing = visitor[alias];
            if (existing) {
              mergePair(existing, fns);
            } else {
              visitor[alias] = Object.assign({}, fns);
            }
          }
        }
        for (const nodeType of Object.keys(visitor)) {
          if (shouldIgnoreKey(nodeType))
            continue;
          ensureCallbackArrays(
            visitor[nodeType]
          );
        }
        return visitor;
      }
      function verify(visitor) {
        if (visitor._verified)
          return;
        if (typeof visitor === "function") {
          throw new Error("You passed `traverse()` a function when it expected a visitor object, are you sure you didn't mean `{ enter: Function }`?");
        }
        for (const nodeType of Object.keys(visitor)) {
          if (nodeType === "enter" || nodeType === "exit") {
            validateVisitorMethods(nodeType, visitor[nodeType]);
          }
          if (shouldIgnoreKey(nodeType))
            continue;
          if (TYPES.indexOf(nodeType) < 0) {
            throw new Error(`You gave us a visitor for the node type ${nodeType} but it's not a valid type`);
          }
          const visitors = visitor[nodeType];
          if (typeof visitors === "object") {
            for (const visitorKey of Object.keys(visitors)) {
              if (visitorKey === "enter" || visitorKey === "exit") {
                validateVisitorMethods(`${nodeType}.${visitorKey}`, visitors[visitorKey]);
              } else {
                throw new Error(`You passed \`traverse()\` a visitor object with the property ${nodeType} that has the invalid property ${visitorKey}`);
              }
            }
          }
        }
        visitor._verified = true;
      }
      function validateVisitorMethods(path, val) {
        const fns = [].concat(val);
        for (const fn of fns) {
          if (typeof fn !== "function") {
            throw new TypeError(`Non-function found defined in ${path} with type ${typeof fn}`);
          }
        }
      }
      function merge2(visitors, states = [], wrapper) {
        const rootVisitor = {};
        for (let i = 0; i < visitors.length; i++) {
          const visitor = visitors[i];
          const state = states[i];
          explode(visitor);
          for (const type of Object.keys(visitor)) {
            let visitorType = visitor[type];
            if (state || wrapper) {
              visitorType = wrapWithStateOrWrapper(visitorType, state, wrapper);
            }
            const nodeVisitor = rootVisitor[type] || (rootVisitor[type] = {});
            mergePair(nodeVisitor, visitorType);
          }
        }
        return rootVisitor;
      }
      function wrapWithStateOrWrapper(oldVisitor, state, wrapper) {
        const newVisitor = {};
        for (const key of Object.keys(oldVisitor)) {
          let fns = oldVisitor[key];
          if (!Array.isArray(fns))
            continue;
          fns = fns.map(function(fn) {
            let newFn = fn;
            if (state) {
              newFn = function(path) {
                return fn.call(state, path, state);
              };
            }
            if (wrapper) {
              newFn = wrapper(state.key, key, newFn);
            }
            if (newFn !== fn) {
              newFn.toString = () => fn.toString();
            }
            return newFn;
          });
          newVisitor[key] = fns;
        }
        return newVisitor;
      }
      function ensureEntranceObjects(obj) {
        for (const key of Object.keys(obj)) {
          if (shouldIgnoreKey(key))
            continue;
          const fns = obj[key];
          if (typeof fns === "function") {
            obj[key] = {
              enter: fns
            };
          }
        }
      }
      function ensureCallbackArrays(obj) {
        if (obj.enter && !Array.isArray(obj.enter))
          obj.enter = [obj.enter];
        if (obj.exit && !Array.isArray(obj.exit))
          obj.exit = [obj.exit];
      }
      function wrapCheck(nodeType, fn) {
        const newFn = function(path) {
          if (path[`is${nodeType}`]()) {
            return fn.apply(this, arguments);
          }
        };
        newFn.toString = () => fn.toString();
        return newFn;
      }
      function shouldIgnoreKey(key) {
        if (key[0] === "_")
          return true;
        if (key === "enter" || key === "exit" || key === "shouldSkip")
          return true;
        if (key === "denylist" || key === "noScope" || key === "skipKeys" || key === "blacklist") {
          return true;
        }
        return false;
      }
      function mergePair(dest, src) {
        for (const key of Object.keys(src)) {
          dest[key] = [].concat(dest[key] || [], src[key]);
        }
      }
    }
  });

  // node_modules/@babel/traverse/lib/cache.js
  var require_cache2 = __commonJS({
    "node_modules/@babel/traverse/lib/cache.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.clear = clear;
      exports2.clearPath = clearPath;
      exports2.clearScope = clearScope;
      exports2.scope = exports2.path = void 0;
      var path = /* @__PURE__ */ new WeakMap();
      exports2.path = path;
      var scope = /* @__PURE__ */ new WeakMap();
      exports2.scope = scope;
      function clear() {
        clearPath();
        clearScope();
      }
      function clearPath() {
        exports2.path = path = /* @__PURE__ */ new WeakMap();
      }
      function clearScope() {
        exports2.scope = scope = /* @__PURE__ */ new WeakMap();
      }
    }
  });

  // node_modules/ms/index.js
  var require_ms2 = __commonJS({
    "node_modules/ms/index.js"(exports2, module2) {
      init_define_process();
      var s = 1e3;
      var m = s * 60;
      var h = m * 60;
      var d = h * 24;
      var w = d * 7;
      var y = d * 365.25;
      module2.exports = function(val, options) {
        options = options || {};
        var type = typeof val;
        if (type === "string" && val.length > 0) {
          return parse3(val);
        } else if (type === "number" && isFinite(val)) {
          return options.long ? fmtLong(val) : fmtShort(val);
        }
        throw new Error(
          "val is not a non-empty string or a valid number. val=" + JSON.stringify(val)
        );
      };
      function parse3(str) {
        str = String(str);
        if (str.length > 100) {
          return;
        }
        var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
          str
        );
        if (!match) {
          return;
        }
        var n = parseFloat(match[1]);
        var type = (match[2] || "ms").toLowerCase();
        switch (type) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return n * y;
          case "weeks":
          case "week":
          case "w":
            return n * w;
          case "days":
          case "day":
          case "d":
            return n * d;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return n * h;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return n * m;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return n * s;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return n;
          default:
            return void 0;
        }
      }
      function fmtShort(ms) {
        var msAbs = Math.abs(ms);
        if (msAbs >= d) {
          return Math.round(ms / d) + "d";
        }
        if (msAbs >= h) {
          return Math.round(ms / h) + "h";
        }
        if (msAbs >= m) {
          return Math.round(ms / m) + "m";
        }
        if (msAbs >= s) {
          return Math.round(ms / s) + "s";
        }
        return ms + "ms";
      }
      function fmtLong(ms) {
        var msAbs = Math.abs(ms);
        if (msAbs >= d) {
          return plural(ms, msAbs, d, "day");
        }
        if (msAbs >= h) {
          return plural(ms, msAbs, h, "hour");
        }
        if (msAbs >= m) {
          return plural(ms, msAbs, m, "minute");
        }
        if (msAbs >= s) {
          return plural(ms, msAbs, s, "second");
        }
        return ms + " ms";
      }
      function plural(ms, msAbs, n, name) {
        var isPlural = msAbs >= n * 1.5;
        return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
      }
    }
  });

  // node_modules/debug/src/common.js
  var require_common = __commonJS({
    "node_modules/debug/src/common.js"(exports2, module2) {
      init_define_process();
      function setup(env) {
        createDebug2.debug = createDebug2;
        createDebug2.default = createDebug2;
        createDebug2.coerce = coerce;
        createDebug2.disable = disable;
        createDebug2.enable = enable;
        createDebug2.enabled = enabled;
        createDebug2.humanize = require_ms2();
        createDebug2.destroy = destroy;
        Object.keys(env).forEach((key) => {
          createDebug2[key] = env[key];
        });
        createDebug2.names = [];
        createDebug2.skips = [];
        createDebug2.formatters = {};
        function selectColor(namespace) {
          let hash = 0;
          for (let i = 0; i < namespace.length; i++) {
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0;
          }
          return createDebug2.colors[Math.abs(hash) % createDebug2.colors.length];
        }
        createDebug2.selectColor = selectColor;
        function createDebug2(namespace) {
          let prevTime;
          let enableOverride = null;
          let namespacesCache;
          let enabledCache;
          function debug2(...args) {
            if (!debug2.enabled) {
              return;
            }
            const self2 = debug2;
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self2.diff = ms;
            self2.prev = prevTime;
            self2.curr = curr;
            prevTime = curr;
            args[0] = createDebug2.coerce(args[0]);
            if (typeof args[0] !== "string") {
              args.unshift("%O");
            }
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
              if (match === "%%") {
                return "%";
              }
              index++;
              const formatter = createDebug2.formatters[format];
              if (typeof formatter === "function") {
                const val = args[index];
                match = formatter.call(self2, val);
                args.splice(index, 1);
                index--;
              }
              return match;
            });
            createDebug2.formatArgs.call(self2, args);
            const logFn = self2.log || createDebug2.log;
            logFn.apply(self2, args);
          }
          debug2.namespace = namespace;
          debug2.useColors = createDebug2.useColors();
          debug2.color = createDebug2.selectColor(namespace);
          debug2.extend = extend;
          debug2.destroy = createDebug2.destroy;
          Object.defineProperty(debug2, "enabled", {
            enumerable: true,
            configurable: false,
            get: () => {
              if (enableOverride !== null) {
                return enableOverride;
              }
              if (namespacesCache !== createDebug2.namespaces) {
                namespacesCache = createDebug2.namespaces;
                enabledCache = createDebug2.enabled(namespace);
              }
              return enabledCache;
            },
            set: (v) => {
              enableOverride = v;
            }
          });
          if (typeof createDebug2.init === "function") {
            createDebug2.init(debug2);
          }
          return debug2;
        }
        function extend(namespace, delimiter) {
          const newDebug = createDebug2(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
          newDebug.log = this.log;
          return newDebug;
        }
        function enable(namespaces) {
          createDebug2.save(namespaces);
          createDebug2.namespaces = namespaces;
          createDebug2.names = [];
          createDebug2.skips = [];
          let i;
          const split2 = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
          const len = split2.length;
          for (i = 0; i < len; i++) {
            if (!split2[i]) {
              continue;
            }
            namespaces = split2[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") {
              createDebug2.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            } else {
              createDebug2.names.push(new RegExp("^" + namespaces + "$"));
            }
          }
        }
        function disable() {
          const namespaces = [
            ...createDebug2.names.map(toNamespace),
            ...createDebug2.skips.map(toNamespace).map((namespace) => "-" + namespace)
          ].join(",");
          createDebug2.enable("");
          return namespaces;
        }
        function enabled(name) {
          if (name[name.length - 1] === "*") {
            return true;
          }
          let i;
          let len;
          for (i = 0, len = createDebug2.skips.length; i < len; i++) {
            if (createDebug2.skips[i].test(name)) {
              return false;
            }
          }
          for (i = 0, len = createDebug2.names.length; i < len; i++) {
            if (createDebug2.names[i].test(name)) {
              return true;
            }
          }
          return false;
        }
        function toNamespace(regexp) {
          return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
        }
        function coerce(val) {
          if (val instanceof Error) {
            return val.stack || val.message;
          }
          return val;
        }
        function destroy() {
          console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
        createDebug2.enable(createDebug2.load());
        return createDebug2;
      }
      module2.exports = setup;
    }
  });

  // node_modules/debug/src/browser.js
  var require_browser2 = __commonJS({
    "node_modules/debug/src/browser.js"(exports2, module2) {
      init_define_process();
      exports2.formatArgs = formatArgs;
      exports2.save = save;
      exports2.load = load;
      exports2.useColors = useColors;
      exports2.storage = localstorage();
      exports2.destroy = (() => {
        let warned = false;
        return () => {
          if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
          }
        };
      })();
      exports2.colors = [
        "#0000CC",
        "#0000FF",
        "#0033CC",
        "#0033FF",
        "#0066CC",
        "#0066FF",
        "#0099CC",
        "#0099FF",
        "#00CC00",
        "#00CC33",
        "#00CC66",
        "#00CC99",
        "#00CCCC",
        "#00CCFF",
        "#3300CC",
        "#3300FF",
        "#3333CC",
        "#3333FF",
        "#3366CC",
        "#3366FF",
        "#3399CC",
        "#3399FF",
        "#33CC00",
        "#33CC33",
        "#33CC66",
        "#33CC99",
        "#33CCCC",
        "#33CCFF",
        "#6600CC",
        "#6600FF",
        "#6633CC",
        "#6633FF",
        "#66CC00",
        "#66CC33",
        "#9900CC",
        "#9900FF",
        "#9933CC",
        "#9933FF",
        "#99CC00",
        "#99CC33",
        "#CC0000",
        "#CC0033",
        "#CC0066",
        "#CC0099",
        "#CC00CC",
        "#CC00FF",
        "#CC3300",
        "#CC3333",
        "#CC3366",
        "#CC3399",
        "#CC33CC",
        "#CC33FF",
        "#CC6600",
        "#CC6633",
        "#CC9900",
        "#CC9933",
        "#CCCC00",
        "#CCCC33",
        "#FF0000",
        "#FF0033",
        "#FF0066",
        "#FF0099",
        "#FF00CC",
        "#FF00FF",
        "#FF3300",
        "#FF3333",
        "#FF3366",
        "#FF3399",
        "#FF33CC",
        "#FF33FF",
        "#FF6600",
        "#FF6633",
        "#FF9900",
        "#FF9933",
        "#FFCC00",
        "#FFCC33"
      ];
      function useColors() {
        if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) {
          return true;
        }
        if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
          return false;
        }
        return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
      }
      function formatArgs(args) {
        args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module2.exports.humanize(this.diff);
        if (!this.useColors) {
          return;
        }
        const c = "color: " + this.color;
        args.splice(1, 0, c, "color: inherit");
        let index = 0;
        let lastC = 0;
        args[0].replace(/%[a-zA-Z%]/g, (match) => {
          if (match === "%%") {
            return;
          }
          index++;
          if (match === "%c") {
            lastC = index;
          }
        });
        args.splice(lastC, 0, c);
      }
      exports2.log = console.debug || console.log || (() => {
      });
      function save(namespaces) {
        try {
          if (namespaces) {
            exports2.storage.setItem("debug", namespaces);
          } else {
            exports2.storage.removeItem("debug");
          }
        } catch (error) {
        }
      }
      function load() {
        let r;
        try {
          r = exports2.storage.getItem("debug");
        } catch (error) {
        }
        if (!r && typeof define_process_default !== "undefined" && "env" in define_process_default) {
          r = define_process_default.env.DEBUG;
        }
        return r;
      }
      function localstorage() {
        try {
          return localStorage;
        } catch (error) {
        }
      }
      module2.exports = require_common()(exports2);
      var { formatters } = module2.exports;
      formatters.j = function(v) {
        try {
          return JSON.stringify(v);
        } catch (error) {
          return "[UnexpectedJSONParseError]: " + error.message;
        }
      };
    }
  });

  // node_modules/@babel/helper-split-export-declaration/lib/index.js
  var require_lib7 = __commonJS({
    "node_modules/@babel/helper-split-export-declaration/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = splitExportDeclaration;
      var _t = require_lib5();
      var {
        cloneNode,
        exportNamedDeclaration,
        exportSpecifier,
        identifier: identifier3,
        variableDeclaration,
        variableDeclarator
      } = _t;
      function splitExportDeclaration(exportDeclaration) {
        if (!exportDeclaration.isExportDeclaration() || exportDeclaration.isExportAllDeclaration()) {
          throw new Error("Only default and named export declarations can be split.");
        }
        if (exportDeclaration.isExportDefaultDeclaration()) {
          const declaration2 = exportDeclaration.get("declaration");
          const standaloneDeclaration = declaration2.isFunctionDeclaration() || declaration2.isClassDeclaration();
          const scope = declaration2.isScope() ? declaration2.scope.parent : declaration2.scope;
          let id = declaration2.node.id;
          let needBindingRegistration = false;
          if (!id) {
            needBindingRegistration = true;
            id = scope.generateUidIdentifier("default");
            if (standaloneDeclaration || declaration2.isFunctionExpression() || declaration2.isClassExpression()) {
              declaration2.node.id = cloneNode(id);
            }
          }
          const updatedDeclaration = standaloneDeclaration ? declaration2.node : variableDeclaration("var", [variableDeclarator(cloneNode(id), declaration2.node)]);
          const updatedExportDeclaration = exportNamedDeclaration(null, [exportSpecifier(cloneNode(id), identifier3("default"))]);
          exportDeclaration.insertAfter(updatedExportDeclaration);
          exportDeclaration.replaceWith(updatedDeclaration);
          if (needBindingRegistration) {
            scope.registerDeclaration(exportDeclaration);
          }
          return exportDeclaration;
        } else if (exportDeclaration.get("specifiers").length > 0) {
          throw new Error("It doesn't make sense to split exported specifiers.");
        }
        const declaration = exportDeclaration.get("declaration");
        const bindingIdentifiers = declaration.getOuterBindingIdentifiers();
        const specifiers = Object.keys(bindingIdentifiers).map((name) => {
          return exportSpecifier(identifier3(name), identifier3(name));
        });
        const aliasDeclar = exportNamedDeclaration(null, specifiers);
        exportDeclaration.insertAfter(aliasDeclar);
        exportDeclaration.replaceWith(declaration.node);
        return exportDeclaration;
      }
    }
  });

  // node_modules/@babel/helper-environment-visitor/lib/index.js
  var require_lib8 = __commonJS({
    "node_modules/@babel/helper-environment-visitor/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      exports2.requeueComputedKeyAndDecorators = requeueComputedKeyAndDecorators;
      exports2.skipAllButComputedKey = skipAllButComputedKey;
      function skipAllButComputedKey(path) {
        path.skip();
        if (path.node.computed) {
          path.context.maybeQueue(path.get("key"));
        }
      }
      function requeueComputedKeyAndDecorators(path) {
        const {
          context,
          node
        } = path;
        if (node.computed) {
          context.maybeQueue(path.get("key"));
        }
        if (node.decorators) {
          for (const decorator of path.get("decorators")) {
            context.maybeQueue(decorator);
          }
        }
      }
      var visitor = {
        FunctionParent(path) {
          if (path.isArrowFunctionExpression()) {
            return;
          } else {
            path.skip();
            if (path.isMethod()) {
              requeueComputedKeyAndDecorators(path);
            }
          }
        },
        Property(path) {
          if (path.isObjectProperty()) {
            return;
          }
          path.skip();
          requeueComputedKeyAndDecorators(path);
        }
      };
      var _default = visitor;
      exports2.default = _default;
    }
  });

  // node_modules/@babel/traverse/lib/scope/lib/renamer.js
  var require_renamer = __commonJS({
    "node_modules/@babel/traverse/lib/scope/lib/renamer.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _helperSplitExportDeclaration = require_lib7();
      var t3 = require_lib5();
      var _helperEnvironmentVisitor = require_lib8();
      var renameVisitor = {
        ReferencedIdentifier({
          node
        }, state) {
          if (node.name === state.oldName) {
            node.name = state.newName;
          }
        },
        Scope(path, state) {
          if (!path.scope.bindingIdentifierEquals(state.oldName, state.binding.identifier)) {
            path.skip();
            if (path.isMethod()) {
              (0, _helperEnvironmentVisitor.requeueComputedKeyAndDecorators)(path);
            }
          }
        },
        "AssignmentExpression|Declaration|VariableDeclarator"(path, state) {
          if (path.isVariableDeclaration())
            return;
          const ids = path.getOuterBindingIdentifiers();
          for (const name in ids) {
            if (name === state.oldName)
              ids[name].name = state.newName;
          }
        }
      };
      var Renamer = class {
        constructor(binding, oldName, newName) {
          this.newName = newName;
          this.oldName = oldName;
          this.binding = binding;
        }
        maybeConvertFromExportDeclaration(parentDeclar) {
          const maybeExportDeclar = parentDeclar.parentPath;
          if (!maybeExportDeclar.isExportDeclaration()) {
            return;
          }
          if (maybeExportDeclar.isExportDefaultDeclaration()) {
            const {
              declaration
            } = maybeExportDeclar.node;
            if (t3.isDeclaration(declaration) && !declaration.id) {
              return;
            }
          }
          if (maybeExportDeclar.isExportAllDeclaration()) {
            return;
          }
          (0, _helperSplitExportDeclaration.default)(maybeExportDeclar);
        }
        maybeConvertFromClassFunctionDeclaration(path) {
          return path;
        }
        maybeConvertFromClassFunctionExpression(path) {
          return path;
        }
        rename(block) {
          const {
            binding,
            oldName,
            newName
          } = this;
          const {
            scope,
            path
          } = binding;
          const parentDeclar = path.find((path2) => path2.isDeclaration() || path2.isFunctionExpression() || path2.isClassExpression());
          if (parentDeclar) {
            const bindingIds = parentDeclar.getOuterBindingIdentifiers();
            if (bindingIds[oldName] === binding.identifier) {
              this.maybeConvertFromExportDeclaration(parentDeclar);
            }
          }
          const blockToTraverse = block || scope.block;
          if ((blockToTraverse == null ? void 0 : blockToTraverse.type) === "SwitchStatement") {
            blockToTraverse.cases.forEach((c) => {
              scope.traverse(c, renameVisitor, this);
            });
          } else {
            scope.traverse(blockToTraverse, renameVisitor, this);
          }
          if (!block) {
            scope.removeOwnBinding(oldName);
            scope.bindings[newName] = binding;
            this.binding.identifier.name = newName;
          }
          if (parentDeclar) {
            this.maybeConvertFromClassFunctionDeclaration(path);
            this.maybeConvertFromClassFunctionExpression(path);
          }
        }
      };
      exports2.default = Renamer;
    }
  });

  // node_modules/@babel/traverse/lib/scope/binding.js
  var require_binding = __commonJS({
    "node_modules/@babel/traverse/lib/scope/binding.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var Binding = class {
        constructor({
          identifier: identifier3,
          scope,
          path,
          kind
        }) {
          this.identifier = void 0;
          this.scope = void 0;
          this.path = void 0;
          this.kind = void 0;
          this.constantViolations = [];
          this.constant = true;
          this.referencePaths = [];
          this.referenced = false;
          this.references = 0;
          this.identifier = identifier3;
          this.scope = scope;
          this.path = path;
          this.kind = kind;
          if ((kind === "var" || kind === "hoisted") && isDeclaredInLoop(path || (() => {
            throw new Error("Internal Babel error: unreachable ");
          })())) {
            this.reassign(path);
          }
          this.clearValue();
        }
        deoptValue() {
          this.clearValue();
          this.hasDeoptedValue = true;
        }
        setValue(value) {
          if (this.hasDeoptedValue)
            return;
          this.hasValue = true;
          this.value = value;
        }
        clearValue() {
          this.hasDeoptedValue = false;
          this.hasValue = false;
          this.value = null;
        }
        reassign(path) {
          this.constant = false;
          if (this.constantViolations.indexOf(path) !== -1) {
            return;
          }
          this.constantViolations.push(path);
        }
        reference(path) {
          if (this.referencePaths.indexOf(path) !== -1) {
            return;
          }
          this.referenced = true;
          this.references++;
          this.referencePaths.push(path);
        }
        dereference() {
          this.references--;
          this.referenced = !!this.references;
        }
      };
      exports2.default = Binding;
      function isDeclaredInLoop(path) {
        for (let {
          parentPath,
          key
        } = path; parentPath; {
          parentPath,
          key
        } = parentPath) {
          if (parentPath.isFunctionParent())
            return false;
          if (parentPath.isWhile() || parentPath.isForXStatement() || parentPath.isForStatement() && key === "body") {
            return true;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/traverse/node_modules/globals/globals.json
  var require_globals = __commonJS({
    "node_modules/@babel/traverse/node_modules/globals/globals.json"(exports2, module2) {
      module2.exports = {
        builtin: {
          Array: false,
          ArrayBuffer: false,
          Atomics: false,
          BigInt: false,
          BigInt64Array: false,
          BigUint64Array: false,
          Boolean: false,
          constructor: false,
          DataView: false,
          Date: false,
          decodeURI: false,
          decodeURIComponent: false,
          encodeURI: false,
          encodeURIComponent: false,
          Error: false,
          escape: false,
          eval: false,
          EvalError: false,
          Float32Array: false,
          Float64Array: false,
          Function: false,
          globalThis: false,
          hasOwnProperty: false,
          Infinity: false,
          Int16Array: false,
          Int32Array: false,
          Int8Array: false,
          isFinite: false,
          isNaN: false,
          isPrototypeOf: false,
          JSON: false,
          Map: false,
          Math: false,
          NaN: false,
          Number: false,
          Object: false,
          parseFloat: false,
          parseInt: false,
          Promise: false,
          propertyIsEnumerable: false,
          Proxy: false,
          RangeError: false,
          ReferenceError: false,
          Reflect: false,
          RegExp: false,
          Set: false,
          SharedArrayBuffer: false,
          String: false,
          Symbol: false,
          SyntaxError: false,
          toLocaleString: false,
          toString: false,
          TypeError: false,
          Uint16Array: false,
          Uint32Array: false,
          Uint8Array: false,
          Uint8ClampedArray: false,
          undefined: false,
          unescape: false,
          URIError: false,
          valueOf: false,
          WeakMap: false,
          WeakSet: false
        },
        es5: {
          Array: false,
          Boolean: false,
          constructor: false,
          Date: false,
          decodeURI: false,
          decodeURIComponent: false,
          encodeURI: false,
          encodeURIComponent: false,
          Error: false,
          escape: false,
          eval: false,
          EvalError: false,
          Function: false,
          hasOwnProperty: false,
          Infinity: false,
          isFinite: false,
          isNaN: false,
          isPrototypeOf: false,
          JSON: false,
          Math: false,
          NaN: false,
          Number: false,
          Object: false,
          parseFloat: false,
          parseInt: false,
          propertyIsEnumerable: false,
          RangeError: false,
          ReferenceError: false,
          RegExp: false,
          String: false,
          SyntaxError: false,
          toLocaleString: false,
          toString: false,
          TypeError: false,
          undefined: false,
          unescape: false,
          URIError: false,
          valueOf: false
        },
        es2015: {
          Array: false,
          ArrayBuffer: false,
          Boolean: false,
          constructor: false,
          DataView: false,
          Date: false,
          decodeURI: false,
          decodeURIComponent: false,
          encodeURI: false,
          encodeURIComponent: false,
          Error: false,
          escape: false,
          eval: false,
          EvalError: false,
          Float32Array: false,
          Float64Array: false,
          Function: false,
          hasOwnProperty: false,
          Infinity: false,
          Int16Array: false,
          Int32Array: false,
          Int8Array: false,
          isFinite: false,
          isNaN: false,
          isPrototypeOf: false,
          JSON: false,
          Map: false,
          Math: false,
          NaN: false,
          Number: false,
          Object: false,
          parseFloat: false,
          parseInt: false,
          Promise: false,
          propertyIsEnumerable: false,
          Proxy: false,
          RangeError: false,
          ReferenceError: false,
          Reflect: false,
          RegExp: false,
          Set: false,
          String: false,
          Symbol: false,
          SyntaxError: false,
          toLocaleString: false,
          toString: false,
          TypeError: false,
          Uint16Array: false,
          Uint32Array: false,
          Uint8Array: false,
          Uint8ClampedArray: false,
          undefined: false,
          unescape: false,
          URIError: false,
          valueOf: false,
          WeakMap: false,
          WeakSet: false
        },
        es2017: {
          Array: false,
          ArrayBuffer: false,
          Atomics: false,
          Boolean: false,
          constructor: false,
          DataView: false,
          Date: false,
          decodeURI: false,
          decodeURIComponent: false,
          encodeURI: false,
          encodeURIComponent: false,
          Error: false,
          escape: false,
          eval: false,
          EvalError: false,
          Float32Array: false,
          Float64Array: false,
          Function: false,
          hasOwnProperty: false,
          Infinity: false,
          Int16Array: false,
          Int32Array: false,
          Int8Array: false,
          isFinite: false,
          isNaN: false,
          isPrototypeOf: false,
          JSON: false,
          Map: false,
          Math: false,
          NaN: false,
          Number: false,
          Object: false,
          parseFloat: false,
          parseInt: false,
          Promise: false,
          propertyIsEnumerable: false,
          Proxy: false,
          RangeError: false,
          ReferenceError: false,
          Reflect: false,
          RegExp: false,
          Set: false,
          SharedArrayBuffer: false,
          String: false,
          Symbol: false,
          SyntaxError: false,
          toLocaleString: false,
          toString: false,
          TypeError: false,
          Uint16Array: false,
          Uint32Array: false,
          Uint8Array: false,
          Uint8ClampedArray: false,
          undefined: false,
          unescape: false,
          URIError: false,
          valueOf: false,
          WeakMap: false,
          WeakSet: false
        },
        browser: {
          AbortController: false,
          AbortSignal: false,
          addEventListener: false,
          alert: false,
          AnalyserNode: false,
          Animation: false,
          AnimationEffectReadOnly: false,
          AnimationEffectTiming: false,
          AnimationEffectTimingReadOnly: false,
          AnimationEvent: false,
          AnimationPlaybackEvent: false,
          AnimationTimeline: false,
          applicationCache: false,
          ApplicationCache: false,
          ApplicationCacheErrorEvent: false,
          atob: false,
          Attr: false,
          Audio: false,
          AudioBuffer: false,
          AudioBufferSourceNode: false,
          AudioContext: false,
          AudioDestinationNode: false,
          AudioListener: false,
          AudioNode: false,
          AudioParam: false,
          AudioProcessingEvent: false,
          AudioScheduledSourceNode: false,
          "AudioWorkletGlobalScope ": false,
          AudioWorkletNode: false,
          AudioWorkletProcessor: false,
          BarProp: false,
          BaseAudioContext: false,
          BatteryManager: false,
          BeforeUnloadEvent: false,
          BiquadFilterNode: false,
          Blob: false,
          BlobEvent: false,
          blur: false,
          BroadcastChannel: false,
          btoa: false,
          BudgetService: false,
          ByteLengthQueuingStrategy: false,
          Cache: false,
          caches: false,
          CacheStorage: false,
          cancelAnimationFrame: false,
          cancelIdleCallback: false,
          CanvasCaptureMediaStreamTrack: false,
          CanvasGradient: false,
          CanvasPattern: false,
          CanvasRenderingContext2D: false,
          ChannelMergerNode: false,
          ChannelSplitterNode: false,
          CharacterData: false,
          clearInterval: false,
          clearTimeout: false,
          clientInformation: false,
          ClipboardEvent: false,
          close: false,
          closed: false,
          CloseEvent: false,
          Comment: false,
          CompositionEvent: false,
          confirm: false,
          console: false,
          ConstantSourceNode: false,
          ConvolverNode: false,
          CountQueuingStrategy: false,
          createImageBitmap: false,
          Credential: false,
          CredentialsContainer: false,
          crypto: false,
          Crypto: false,
          CryptoKey: false,
          CSS: false,
          CSSConditionRule: false,
          CSSFontFaceRule: false,
          CSSGroupingRule: false,
          CSSImportRule: false,
          CSSKeyframeRule: false,
          CSSKeyframesRule: false,
          CSSMediaRule: false,
          CSSNamespaceRule: false,
          CSSPageRule: false,
          CSSRule: false,
          CSSRuleList: false,
          CSSStyleDeclaration: false,
          CSSStyleRule: false,
          CSSStyleSheet: false,
          CSSSupportsRule: false,
          CustomElementRegistry: false,
          customElements: false,
          CustomEvent: false,
          DataTransfer: false,
          DataTransferItem: false,
          DataTransferItemList: false,
          defaultstatus: false,
          defaultStatus: false,
          DelayNode: false,
          DeviceMotionEvent: false,
          DeviceOrientationEvent: false,
          devicePixelRatio: false,
          dispatchEvent: false,
          document: false,
          Document: false,
          DocumentFragment: false,
          DocumentType: false,
          DOMError: false,
          DOMException: false,
          DOMImplementation: false,
          DOMMatrix: false,
          DOMMatrixReadOnly: false,
          DOMParser: false,
          DOMPoint: false,
          DOMPointReadOnly: false,
          DOMQuad: false,
          DOMRect: false,
          DOMRectReadOnly: false,
          DOMStringList: false,
          DOMStringMap: false,
          DOMTokenList: false,
          DragEvent: false,
          DynamicsCompressorNode: false,
          Element: false,
          ErrorEvent: false,
          event: false,
          Event: false,
          EventSource: false,
          EventTarget: false,
          external: false,
          fetch: false,
          File: false,
          FileList: false,
          FileReader: false,
          find: false,
          focus: false,
          FocusEvent: false,
          FontFace: false,
          FontFaceSetLoadEvent: false,
          FormData: false,
          frameElement: false,
          frames: false,
          GainNode: false,
          Gamepad: false,
          GamepadButton: false,
          GamepadEvent: false,
          getComputedStyle: false,
          getSelection: false,
          HashChangeEvent: false,
          Headers: false,
          history: false,
          History: false,
          HTMLAllCollection: false,
          HTMLAnchorElement: false,
          HTMLAreaElement: false,
          HTMLAudioElement: false,
          HTMLBaseElement: false,
          HTMLBodyElement: false,
          HTMLBRElement: false,
          HTMLButtonElement: false,
          HTMLCanvasElement: false,
          HTMLCollection: false,
          HTMLContentElement: false,
          HTMLDataElement: false,
          HTMLDataListElement: false,
          HTMLDetailsElement: false,
          HTMLDialogElement: false,
          HTMLDirectoryElement: false,
          HTMLDivElement: false,
          HTMLDListElement: false,
          HTMLDocument: false,
          HTMLElement: false,
          HTMLEmbedElement: false,
          HTMLFieldSetElement: false,
          HTMLFontElement: false,
          HTMLFormControlsCollection: false,
          HTMLFormElement: false,
          HTMLFrameElement: false,
          HTMLFrameSetElement: false,
          HTMLHeadElement: false,
          HTMLHeadingElement: false,
          HTMLHRElement: false,
          HTMLHtmlElement: false,
          HTMLIFrameElement: false,
          HTMLImageElement: false,
          HTMLInputElement: false,
          HTMLLabelElement: false,
          HTMLLegendElement: false,
          HTMLLIElement: false,
          HTMLLinkElement: false,
          HTMLMapElement: false,
          HTMLMarqueeElement: false,
          HTMLMediaElement: false,
          HTMLMenuElement: false,
          HTMLMetaElement: false,
          HTMLMeterElement: false,
          HTMLModElement: false,
          HTMLObjectElement: false,
          HTMLOListElement: false,
          HTMLOptGroupElement: false,
          HTMLOptionElement: false,
          HTMLOptionsCollection: false,
          HTMLOutputElement: false,
          HTMLParagraphElement: false,
          HTMLParamElement: false,
          HTMLPictureElement: false,
          HTMLPreElement: false,
          HTMLProgressElement: false,
          HTMLQuoteElement: false,
          HTMLScriptElement: false,
          HTMLSelectElement: false,
          HTMLShadowElement: false,
          HTMLSlotElement: false,
          HTMLSourceElement: false,
          HTMLSpanElement: false,
          HTMLStyleElement: false,
          HTMLTableCaptionElement: false,
          HTMLTableCellElement: false,
          HTMLTableColElement: false,
          HTMLTableElement: false,
          HTMLTableRowElement: false,
          HTMLTableSectionElement: false,
          HTMLTemplateElement: false,
          HTMLTextAreaElement: false,
          HTMLTimeElement: false,
          HTMLTitleElement: false,
          HTMLTrackElement: false,
          HTMLUListElement: false,
          HTMLUnknownElement: false,
          HTMLVideoElement: false,
          IDBCursor: false,
          IDBCursorWithValue: false,
          IDBDatabase: false,
          IDBFactory: false,
          IDBIndex: false,
          IDBKeyRange: false,
          IDBObjectStore: false,
          IDBOpenDBRequest: false,
          IDBRequest: false,
          IDBTransaction: false,
          IDBVersionChangeEvent: false,
          IdleDeadline: false,
          IIRFilterNode: false,
          Image: false,
          ImageBitmap: false,
          ImageBitmapRenderingContext: false,
          ImageCapture: false,
          ImageData: false,
          indexedDB: false,
          innerHeight: false,
          innerWidth: false,
          InputEvent: false,
          IntersectionObserver: false,
          IntersectionObserverEntry: false,
          Intl: false,
          isSecureContext: false,
          KeyboardEvent: false,
          KeyframeEffect: false,
          KeyframeEffectReadOnly: false,
          length: false,
          localStorage: false,
          location: true,
          Location: false,
          locationbar: false,
          matchMedia: false,
          MediaDeviceInfo: false,
          MediaDevices: false,
          MediaElementAudioSourceNode: false,
          MediaEncryptedEvent: false,
          MediaError: false,
          MediaKeyMessageEvent: false,
          MediaKeySession: false,
          MediaKeyStatusMap: false,
          MediaKeySystemAccess: false,
          MediaList: false,
          MediaQueryList: false,
          MediaQueryListEvent: false,
          MediaRecorder: false,
          MediaSettingsRange: false,
          MediaSource: false,
          MediaStream: false,
          MediaStreamAudioDestinationNode: false,
          MediaStreamAudioSourceNode: false,
          MediaStreamEvent: false,
          MediaStreamTrack: false,
          MediaStreamTrackEvent: false,
          menubar: false,
          MessageChannel: false,
          MessageEvent: false,
          MessagePort: false,
          MIDIAccess: false,
          MIDIConnectionEvent: false,
          MIDIInput: false,
          MIDIInputMap: false,
          MIDIMessageEvent: false,
          MIDIOutput: false,
          MIDIOutputMap: false,
          MIDIPort: false,
          MimeType: false,
          MimeTypeArray: false,
          MouseEvent: false,
          moveBy: false,
          moveTo: false,
          MutationEvent: false,
          MutationObserver: false,
          MutationRecord: false,
          name: false,
          NamedNodeMap: false,
          NavigationPreloadManager: false,
          navigator: false,
          Navigator: false,
          NetworkInformation: false,
          Node: false,
          NodeFilter: false,
          NodeIterator: false,
          NodeList: false,
          Notification: false,
          OfflineAudioCompletionEvent: false,
          OfflineAudioContext: false,
          offscreenBuffering: false,
          OffscreenCanvas: true,
          onabort: true,
          onafterprint: true,
          onanimationend: true,
          onanimationiteration: true,
          onanimationstart: true,
          onappinstalled: true,
          onauxclick: true,
          onbeforeinstallprompt: true,
          onbeforeprint: true,
          onbeforeunload: true,
          onblur: true,
          oncancel: true,
          oncanplay: true,
          oncanplaythrough: true,
          onchange: true,
          onclick: true,
          onclose: true,
          oncontextmenu: true,
          oncuechange: true,
          ondblclick: true,
          ondevicemotion: true,
          ondeviceorientation: true,
          ondeviceorientationabsolute: true,
          ondrag: true,
          ondragend: true,
          ondragenter: true,
          ondragleave: true,
          ondragover: true,
          ondragstart: true,
          ondrop: true,
          ondurationchange: true,
          onemptied: true,
          onended: true,
          onerror: true,
          onfocus: true,
          ongotpointercapture: true,
          onhashchange: true,
          oninput: true,
          oninvalid: true,
          onkeydown: true,
          onkeypress: true,
          onkeyup: true,
          onlanguagechange: true,
          onload: true,
          onloadeddata: true,
          onloadedmetadata: true,
          onloadstart: true,
          onlostpointercapture: true,
          onmessage: true,
          onmessageerror: true,
          onmousedown: true,
          onmouseenter: true,
          onmouseleave: true,
          onmousemove: true,
          onmouseout: true,
          onmouseover: true,
          onmouseup: true,
          onmousewheel: true,
          onoffline: true,
          ononline: true,
          onpagehide: true,
          onpageshow: true,
          onpause: true,
          onplay: true,
          onplaying: true,
          onpointercancel: true,
          onpointerdown: true,
          onpointerenter: true,
          onpointerleave: true,
          onpointermove: true,
          onpointerout: true,
          onpointerover: true,
          onpointerup: true,
          onpopstate: true,
          onprogress: true,
          onratechange: true,
          onrejectionhandled: true,
          onreset: true,
          onresize: true,
          onscroll: true,
          onsearch: true,
          onseeked: true,
          onseeking: true,
          onselect: true,
          onstalled: true,
          onstorage: true,
          onsubmit: true,
          onsuspend: true,
          ontimeupdate: true,
          ontoggle: true,
          ontransitionend: true,
          onunhandledrejection: true,
          onunload: true,
          onvolumechange: true,
          onwaiting: true,
          onwheel: true,
          open: false,
          openDatabase: false,
          opener: false,
          Option: false,
          origin: false,
          OscillatorNode: false,
          outerHeight: false,
          outerWidth: false,
          PageTransitionEvent: false,
          pageXOffset: false,
          pageYOffset: false,
          PannerNode: false,
          parent: false,
          Path2D: false,
          PaymentAddress: false,
          PaymentRequest: false,
          PaymentRequestUpdateEvent: false,
          PaymentResponse: false,
          performance: false,
          Performance: false,
          PerformanceEntry: false,
          PerformanceLongTaskTiming: false,
          PerformanceMark: false,
          PerformanceMeasure: false,
          PerformanceNavigation: false,
          PerformanceNavigationTiming: false,
          PerformanceObserver: false,
          PerformanceObserverEntryList: false,
          PerformancePaintTiming: false,
          PerformanceResourceTiming: false,
          PerformanceTiming: false,
          PeriodicWave: false,
          Permissions: false,
          PermissionStatus: false,
          personalbar: false,
          PhotoCapabilities: false,
          Plugin: false,
          PluginArray: false,
          PointerEvent: false,
          PopStateEvent: false,
          postMessage: false,
          Presentation: false,
          PresentationAvailability: false,
          PresentationConnection: false,
          PresentationConnectionAvailableEvent: false,
          PresentationConnectionCloseEvent: false,
          PresentationConnectionList: false,
          PresentationReceiver: false,
          PresentationRequest: false,
          print: false,
          ProcessingInstruction: false,
          ProgressEvent: false,
          PromiseRejectionEvent: false,
          prompt: false,
          PushManager: false,
          PushSubscription: false,
          PushSubscriptionOptions: false,
          queueMicrotask: false,
          RadioNodeList: false,
          Range: false,
          ReadableStream: false,
          registerProcessor: false,
          RemotePlayback: false,
          removeEventListener: false,
          Request: false,
          requestAnimationFrame: false,
          requestIdleCallback: false,
          resizeBy: false,
          ResizeObserver: false,
          ResizeObserverEntry: false,
          resizeTo: false,
          Response: false,
          RTCCertificate: false,
          RTCDataChannel: false,
          RTCDataChannelEvent: false,
          RTCDtlsTransport: false,
          RTCIceCandidate: false,
          RTCIceGatherer: false,
          RTCIceTransport: false,
          RTCPeerConnection: false,
          RTCPeerConnectionIceEvent: false,
          RTCRtpContributingSource: false,
          RTCRtpReceiver: false,
          RTCRtpSender: false,
          RTCSctpTransport: false,
          RTCSessionDescription: false,
          RTCStatsReport: false,
          RTCTrackEvent: false,
          screen: false,
          Screen: false,
          screenLeft: false,
          ScreenOrientation: false,
          screenTop: false,
          screenX: false,
          screenY: false,
          ScriptProcessorNode: false,
          scroll: false,
          scrollbars: false,
          scrollBy: false,
          scrollTo: false,
          scrollX: false,
          scrollY: false,
          SecurityPolicyViolationEvent: false,
          Selection: false,
          self: false,
          ServiceWorker: false,
          ServiceWorkerContainer: false,
          ServiceWorkerRegistration: false,
          sessionStorage: false,
          setInterval: false,
          setTimeout: false,
          ShadowRoot: false,
          SharedWorker: false,
          SourceBuffer: false,
          SourceBufferList: false,
          speechSynthesis: false,
          SpeechSynthesisEvent: false,
          SpeechSynthesisUtterance: false,
          StaticRange: false,
          status: false,
          statusbar: false,
          StereoPannerNode: false,
          stop: false,
          Storage: false,
          StorageEvent: false,
          StorageManager: false,
          styleMedia: false,
          StyleSheet: false,
          StyleSheetList: false,
          SubtleCrypto: false,
          SVGAElement: false,
          SVGAngle: false,
          SVGAnimatedAngle: false,
          SVGAnimatedBoolean: false,
          SVGAnimatedEnumeration: false,
          SVGAnimatedInteger: false,
          SVGAnimatedLength: false,
          SVGAnimatedLengthList: false,
          SVGAnimatedNumber: false,
          SVGAnimatedNumberList: false,
          SVGAnimatedPreserveAspectRatio: false,
          SVGAnimatedRect: false,
          SVGAnimatedString: false,
          SVGAnimatedTransformList: false,
          SVGAnimateElement: false,
          SVGAnimateMotionElement: false,
          SVGAnimateTransformElement: false,
          SVGAnimationElement: false,
          SVGCircleElement: false,
          SVGClipPathElement: false,
          SVGComponentTransferFunctionElement: false,
          SVGDefsElement: false,
          SVGDescElement: false,
          SVGDiscardElement: false,
          SVGElement: false,
          SVGEllipseElement: false,
          SVGFEBlendElement: false,
          SVGFEColorMatrixElement: false,
          SVGFEComponentTransferElement: false,
          SVGFECompositeElement: false,
          SVGFEConvolveMatrixElement: false,
          SVGFEDiffuseLightingElement: false,
          SVGFEDisplacementMapElement: false,
          SVGFEDistantLightElement: false,
          SVGFEDropShadowElement: false,
          SVGFEFloodElement: false,
          SVGFEFuncAElement: false,
          SVGFEFuncBElement: false,
          SVGFEFuncGElement: false,
          SVGFEFuncRElement: false,
          SVGFEGaussianBlurElement: false,
          SVGFEImageElement: false,
          SVGFEMergeElement: false,
          SVGFEMergeNodeElement: false,
          SVGFEMorphologyElement: false,
          SVGFEOffsetElement: false,
          SVGFEPointLightElement: false,
          SVGFESpecularLightingElement: false,
          SVGFESpotLightElement: false,
          SVGFETileElement: false,
          SVGFETurbulenceElement: false,
          SVGFilterElement: false,
          SVGForeignObjectElement: false,
          SVGGElement: false,
          SVGGeometryElement: false,
          SVGGradientElement: false,
          SVGGraphicsElement: false,
          SVGImageElement: false,
          SVGLength: false,
          SVGLengthList: false,
          SVGLinearGradientElement: false,
          SVGLineElement: false,
          SVGMarkerElement: false,
          SVGMaskElement: false,
          SVGMatrix: false,
          SVGMetadataElement: false,
          SVGMPathElement: false,
          SVGNumber: false,
          SVGNumberList: false,
          SVGPathElement: false,
          SVGPatternElement: false,
          SVGPoint: false,
          SVGPointList: false,
          SVGPolygonElement: false,
          SVGPolylineElement: false,
          SVGPreserveAspectRatio: false,
          SVGRadialGradientElement: false,
          SVGRect: false,
          SVGRectElement: false,
          SVGScriptElement: false,
          SVGSetElement: false,
          SVGStopElement: false,
          SVGStringList: false,
          SVGStyleElement: false,
          SVGSVGElement: false,
          SVGSwitchElement: false,
          SVGSymbolElement: false,
          SVGTextContentElement: false,
          SVGTextElement: false,
          SVGTextPathElement: false,
          SVGTextPositioningElement: false,
          SVGTitleElement: false,
          SVGTransform: false,
          SVGTransformList: false,
          SVGTSpanElement: false,
          SVGUnitTypes: false,
          SVGUseElement: false,
          SVGViewElement: false,
          TaskAttributionTiming: false,
          Text: false,
          TextDecoder: false,
          TextEncoder: false,
          TextEvent: false,
          TextMetrics: false,
          TextTrack: false,
          TextTrackCue: false,
          TextTrackCueList: false,
          TextTrackList: false,
          TimeRanges: false,
          toolbar: false,
          top: false,
          Touch: false,
          TouchEvent: false,
          TouchList: false,
          TrackEvent: false,
          TransitionEvent: false,
          TreeWalker: false,
          UIEvent: false,
          URL: false,
          URLSearchParams: false,
          ValidityState: false,
          visualViewport: false,
          VisualViewport: false,
          VTTCue: false,
          WaveShaperNode: false,
          WebAssembly: false,
          WebGL2RenderingContext: false,
          WebGLActiveInfo: false,
          WebGLBuffer: false,
          WebGLContextEvent: false,
          WebGLFramebuffer: false,
          WebGLProgram: false,
          WebGLQuery: false,
          WebGLRenderbuffer: false,
          WebGLRenderingContext: false,
          WebGLSampler: false,
          WebGLShader: false,
          WebGLShaderPrecisionFormat: false,
          WebGLSync: false,
          WebGLTexture: false,
          WebGLTransformFeedback: false,
          WebGLUniformLocation: false,
          WebGLVertexArrayObject: false,
          WebSocket: false,
          WheelEvent: false,
          window: false,
          Window: false,
          Worker: false,
          WritableStream: false,
          XMLDocument: false,
          XMLHttpRequest: false,
          XMLHttpRequestEventTarget: false,
          XMLHttpRequestUpload: false,
          XMLSerializer: false,
          XPathEvaluator: false,
          XPathExpression: false,
          XPathResult: false,
          XSLTProcessor: false
        },
        worker: {
          addEventListener: false,
          applicationCache: false,
          atob: false,
          Blob: false,
          BroadcastChannel: false,
          btoa: false,
          Cache: false,
          caches: false,
          clearInterval: false,
          clearTimeout: false,
          close: true,
          console: false,
          fetch: false,
          FileReaderSync: false,
          FormData: false,
          Headers: false,
          IDBCursor: false,
          IDBCursorWithValue: false,
          IDBDatabase: false,
          IDBFactory: false,
          IDBIndex: false,
          IDBKeyRange: false,
          IDBObjectStore: false,
          IDBOpenDBRequest: false,
          IDBRequest: false,
          IDBTransaction: false,
          IDBVersionChangeEvent: false,
          ImageData: false,
          importScripts: true,
          indexedDB: false,
          location: false,
          MessageChannel: false,
          MessagePort: false,
          name: false,
          navigator: false,
          Notification: false,
          onclose: true,
          onconnect: true,
          onerror: true,
          onlanguagechange: true,
          onmessage: true,
          onoffline: true,
          ononline: true,
          onrejectionhandled: true,
          onunhandledrejection: true,
          performance: false,
          Performance: false,
          PerformanceEntry: false,
          PerformanceMark: false,
          PerformanceMeasure: false,
          PerformanceNavigation: false,
          PerformanceResourceTiming: false,
          PerformanceTiming: false,
          postMessage: true,
          Promise: false,
          queueMicrotask: false,
          removeEventListener: false,
          Request: false,
          Response: false,
          self: true,
          ServiceWorkerRegistration: false,
          setInterval: false,
          setTimeout: false,
          TextDecoder: false,
          TextEncoder: false,
          URL: false,
          URLSearchParams: false,
          WebSocket: false,
          Worker: false,
          WorkerGlobalScope: false,
          XMLHttpRequest: false
        },
        node: {
          __dirname: false,
          __filename: false,
          Buffer: false,
          clearImmediate: false,
          clearInterval: false,
          clearTimeout: false,
          console: false,
          exports: true,
          global: false,
          Intl: false,
          module: false,
          process: false,
          queueMicrotask: false,
          require: false,
          setImmediate: false,
          setInterval: false,
          setTimeout: false,
          TextDecoder: false,
          TextEncoder: false,
          URL: false,
          URLSearchParams: false
        },
        commonjs: {
          exports: true,
          global: false,
          module: false,
          require: false
        },
        amd: {
          define: false,
          require: false
        },
        mocha: {
          after: false,
          afterEach: false,
          before: false,
          beforeEach: false,
          context: false,
          describe: false,
          it: false,
          mocha: false,
          run: false,
          setup: false,
          specify: false,
          suite: false,
          suiteSetup: false,
          suiteTeardown: false,
          teardown: false,
          test: false,
          xcontext: false,
          xdescribe: false,
          xit: false,
          xspecify: false
        },
        jasmine: {
          afterAll: false,
          afterEach: false,
          beforeAll: false,
          beforeEach: false,
          describe: false,
          expect: false,
          fail: false,
          fdescribe: false,
          fit: false,
          it: false,
          jasmine: false,
          pending: false,
          runs: false,
          spyOn: false,
          spyOnProperty: false,
          waits: false,
          waitsFor: false,
          xdescribe: false,
          xit: false
        },
        jest: {
          afterAll: false,
          afterEach: false,
          beforeAll: false,
          beforeEach: false,
          describe: false,
          expect: false,
          fdescribe: false,
          fit: false,
          it: false,
          jest: false,
          pit: false,
          require: false,
          test: false,
          xdescribe: false,
          xit: false,
          xtest: false
        },
        qunit: {
          asyncTest: false,
          deepEqual: false,
          equal: false,
          expect: false,
          module: false,
          notDeepEqual: false,
          notEqual: false,
          notOk: false,
          notPropEqual: false,
          notStrictEqual: false,
          ok: false,
          propEqual: false,
          QUnit: false,
          raises: false,
          start: false,
          stop: false,
          strictEqual: false,
          test: false,
          throws: false
        },
        phantomjs: {
          console: true,
          exports: true,
          phantom: true,
          require: true,
          WebPage: true
        },
        couch: {
          emit: false,
          exports: false,
          getRow: false,
          log: false,
          module: false,
          provides: false,
          require: false,
          respond: false,
          send: false,
          start: false,
          sum: false
        },
        rhino: {
          defineClass: false,
          deserialize: false,
          gc: false,
          help: false,
          importClass: false,
          importPackage: false,
          java: false,
          load: false,
          loadClass: false,
          Packages: false,
          print: false,
          quit: false,
          readFile: false,
          readUrl: false,
          runCommand: false,
          seal: false,
          serialize: false,
          spawn: false,
          sync: false,
          toint32: false,
          version: false
        },
        nashorn: {
          __DIR__: false,
          __FILE__: false,
          __LINE__: false,
          com: false,
          edu: false,
          exit: false,
          java: false,
          Java: false,
          javafx: false,
          JavaImporter: false,
          javax: false,
          JSAdapter: false,
          load: false,
          loadWithNewGlobal: false,
          org: false,
          Packages: false,
          print: false,
          quit: false
        },
        wsh: {
          ActiveXObject: true,
          Enumerator: true,
          GetObject: true,
          ScriptEngine: true,
          ScriptEngineBuildVersion: true,
          ScriptEngineMajorVersion: true,
          ScriptEngineMinorVersion: true,
          VBArray: true,
          WScript: true,
          WSH: true,
          XDomainRequest: true
        },
        jquery: {
          $: false,
          jQuery: false
        },
        yui: {
          YAHOO: false,
          YAHOO_config: false,
          YUI: false,
          YUI_config: false
        },
        shelljs: {
          cat: false,
          cd: false,
          chmod: false,
          config: false,
          cp: false,
          dirs: false,
          echo: false,
          env: false,
          error: false,
          exec: false,
          exit: false,
          find: false,
          grep: false,
          ln: false,
          ls: false,
          mkdir: false,
          mv: false,
          popd: false,
          pushd: false,
          pwd: false,
          rm: false,
          sed: false,
          set: false,
          target: false,
          tempdir: false,
          test: false,
          touch: false,
          which: false
        },
        prototypejs: {
          $: false,
          $$: false,
          $A: false,
          $break: false,
          $continue: false,
          $F: false,
          $H: false,
          $R: false,
          $w: false,
          Abstract: false,
          Ajax: false,
          Autocompleter: false,
          Builder: false,
          Class: false,
          Control: false,
          Draggable: false,
          Draggables: false,
          Droppables: false,
          Effect: false,
          Element: false,
          Enumerable: false,
          Event: false,
          Field: false,
          Form: false,
          Hash: false,
          Insertion: false,
          ObjectRange: false,
          PeriodicalExecuter: false,
          Position: false,
          Prototype: false,
          Scriptaculous: false,
          Selector: false,
          Sortable: false,
          SortableObserver: false,
          Sound: false,
          Template: false,
          Toggle: false,
          Try: false
        },
        meteor: {
          _: false,
          $: false,
          Accounts: false,
          AccountsClient: false,
          AccountsCommon: false,
          AccountsServer: false,
          App: false,
          Assets: false,
          Blaze: false,
          check: false,
          Cordova: false,
          DDP: false,
          DDPRateLimiter: false,
          DDPServer: false,
          Deps: false,
          EJSON: false,
          Email: false,
          HTTP: false,
          Log: false,
          Match: false,
          Meteor: false,
          Mongo: false,
          MongoInternals: false,
          Npm: false,
          Package: false,
          Plugin: false,
          process: false,
          Random: false,
          ReactiveDict: false,
          ReactiveVar: false,
          Router: false,
          ServiceConfiguration: false,
          Session: false,
          share: false,
          Spacebars: false,
          Template: false,
          Tinytest: false,
          Tracker: false,
          UI: false,
          Utils: false,
          WebApp: false,
          WebAppInternals: false
        },
        mongo: {
          _isWindows: false,
          _rand: false,
          BulkWriteResult: false,
          cat: false,
          cd: false,
          connect: false,
          db: false,
          getHostName: false,
          getMemInfo: false,
          hostname: false,
          ISODate: false,
          listFiles: false,
          load: false,
          ls: false,
          md5sumFile: false,
          mkdir: false,
          Mongo: false,
          NumberInt: false,
          NumberLong: false,
          ObjectId: false,
          PlanCache: false,
          print: false,
          printjson: false,
          pwd: false,
          quit: false,
          removeFile: false,
          rs: false,
          sh: false,
          UUID: false,
          version: false,
          WriteResult: false
        },
        applescript: {
          $: false,
          Application: false,
          Automation: false,
          console: false,
          delay: false,
          Library: false,
          ObjC: false,
          ObjectSpecifier: false,
          Path: false,
          Progress: false,
          Ref: false
        },
        serviceworker: {
          addEventListener: false,
          applicationCache: false,
          atob: false,
          Blob: false,
          BroadcastChannel: false,
          btoa: false,
          Cache: false,
          caches: false,
          CacheStorage: false,
          clearInterval: false,
          clearTimeout: false,
          Client: false,
          clients: false,
          Clients: false,
          close: true,
          console: false,
          ExtendableEvent: false,
          ExtendableMessageEvent: false,
          fetch: false,
          FetchEvent: false,
          FileReaderSync: false,
          FormData: false,
          Headers: false,
          IDBCursor: false,
          IDBCursorWithValue: false,
          IDBDatabase: false,
          IDBFactory: false,
          IDBIndex: false,
          IDBKeyRange: false,
          IDBObjectStore: false,
          IDBOpenDBRequest: false,
          IDBRequest: false,
          IDBTransaction: false,
          IDBVersionChangeEvent: false,
          ImageData: false,
          importScripts: false,
          indexedDB: false,
          location: false,
          MessageChannel: false,
          MessagePort: false,
          name: false,
          navigator: false,
          Notification: false,
          onclose: true,
          onconnect: true,
          onerror: true,
          onfetch: true,
          oninstall: true,
          onlanguagechange: true,
          onmessage: true,
          onmessageerror: true,
          onnotificationclick: true,
          onnotificationclose: true,
          onoffline: true,
          ononline: true,
          onpush: true,
          onpushsubscriptionchange: true,
          onrejectionhandled: true,
          onsync: true,
          onunhandledrejection: true,
          performance: false,
          Performance: false,
          PerformanceEntry: false,
          PerformanceMark: false,
          PerformanceMeasure: false,
          PerformanceNavigation: false,
          PerformanceResourceTiming: false,
          PerformanceTiming: false,
          postMessage: true,
          Promise: false,
          queueMicrotask: false,
          registration: false,
          removeEventListener: false,
          Request: false,
          Response: false,
          self: false,
          ServiceWorker: false,
          ServiceWorkerContainer: false,
          ServiceWorkerGlobalScope: false,
          ServiceWorkerMessageEvent: false,
          ServiceWorkerRegistration: false,
          setInterval: false,
          setTimeout: false,
          skipWaiting: false,
          TextDecoder: false,
          TextEncoder: false,
          URL: false,
          URLSearchParams: false,
          WebSocket: false,
          WindowClient: false,
          Worker: false,
          WorkerGlobalScope: false,
          XMLHttpRequest: false
        },
        atomtest: {
          advanceClock: false,
          fakeClearInterval: false,
          fakeClearTimeout: false,
          fakeSetInterval: false,
          fakeSetTimeout: false,
          resetTimeouts: false,
          waitsForPromise: false
        },
        embertest: {
          andThen: false,
          click: false,
          currentPath: false,
          currentRouteName: false,
          currentURL: false,
          fillIn: false,
          find: false,
          findAll: false,
          findWithAssert: false,
          keyEvent: false,
          pauseTest: false,
          resumeTest: false,
          triggerEvent: false,
          visit: false,
          wait: false
        },
        protractor: {
          $: false,
          $$: false,
          browser: false,
          by: false,
          By: false,
          DartObject: false,
          element: false,
          protractor: false
        },
        "shared-node-browser": {
          clearInterval: false,
          clearTimeout: false,
          console: false,
          setInterval: false,
          setTimeout: false,
          URL: false,
          URLSearchParams: false
        },
        webextensions: {
          browser: false,
          chrome: false,
          opr: false
        },
        greasemonkey: {
          cloneInto: false,
          createObjectIn: false,
          exportFunction: false,
          GM: false,
          GM_addStyle: false,
          GM_deleteValue: false,
          GM_getResourceText: false,
          GM_getResourceURL: false,
          GM_getValue: false,
          GM_info: false,
          GM_listValues: false,
          GM_log: false,
          GM_openInTab: false,
          GM_registerMenuCommand: false,
          GM_setClipboard: false,
          GM_setValue: false,
          GM_xmlhttpRequest: false,
          unsafeWindow: false
        },
        devtools: {
          $: false,
          $_: false,
          $$: false,
          $0: false,
          $1: false,
          $2: false,
          $3: false,
          $4: false,
          $x: false,
          chrome: false,
          clear: false,
          copy: false,
          debug: false,
          dir: false,
          dirxml: false,
          getEventListeners: false,
          inspect: false,
          keys: false,
          monitor: false,
          monitorEvents: false,
          profile: false,
          profileEnd: false,
          queryObjects: false,
          table: false,
          undebug: false,
          unmonitor: false,
          unmonitorEvents: false,
          values: false
        }
      };
    }
  });

  // node_modules/@babel/traverse/node_modules/globals/index.js
  var require_globals2 = __commonJS({
    "node_modules/@babel/traverse/node_modules/globals/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = require_globals();
    }
  });

  // node_modules/@babel/traverse/lib/scope/index.js
  var require_scope = __commonJS({
    "node_modules/@babel/traverse/lib/scope/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _renamer = require_renamer();
      var _index = require_lib14();
      var _binding = require_binding();
      var _globals = require_globals2();
      var _t = require_lib5();
      var _cache = require_cache2();
      var {
        NOT_LOCAL_BINDING,
        callExpression,
        cloneNode,
        getBindingIdentifiers,
        identifier: identifier3,
        isArrayExpression,
        isBinary,
        isClass,
        isClassBody,
        isClassDeclaration,
        isExportAllDeclaration,
        isExportDefaultDeclaration,
        isExportNamedDeclaration,
        isFunctionDeclaration,
        isIdentifier: isIdentifier2,
        isImportDeclaration,
        isLiteral,
        isMethod,
        isModuleDeclaration,
        isModuleSpecifier,
        isNullLiteral,
        isObjectExpression,
        isProperty,
        isPureish,
        isRegExpLiteral,
        isSuper,
        isTaggedTemplateExpression,
        isTemplateLiteral,
        isThisExpression,
        isUnaryExpression,
        isVariableDeclaration,
        matchesPattern,
        memberExpression,
        numericLiteral,
        toIdentifier,
        unaryExpression,
        variableDeclaration,
        variableDeclarator,
        isRecordExpression,
        isTupleExpression,
        isObjectProperty,
        isTopicReference,
        isMetaProperty,
        isPrivateName
      } = _t;
      function gatherNodeParts(node, parts) {
        switch (node == null ? void 0 : node.type) {
          default:
            if (isModuleDeclaration(node)) {
              if ((isExportAllDeclaration(node) || isExportNamedDeclaration(node) || isImportDeclaration(node)) && node.source) {
                gatherNodeParts(node.source, parts);
              } else if ((isExportNamedDeclaration(node) || isImportDeclaration(node)) && node.specifiers && node.specifiers.length) {
                for (const e of node.specifiers)
                  gatherNodeParts(e, parts);
              } else if ((isExportDefaultDeclaration(node) || isExportNamedDeclaration(node)) && node.declaration) {
                gatherNodeParts(node.declaration, parts);
              }
            } else if (isModuleSpecifier(node)) {
              gatherNodeParts(node.local, parts);
            } else if (isLiteral(node) && !isNullLiteral(node) && !isRegExpLiteral(node) && !isTemplateLiteral(node)) {
              parts.push(node.value);
            }
            break;
          case "MemberExpression":
          case "OptionalMemberExpression":
          case "JSXMemberExpression":
            gatherNodeParts(node.object, parts);
            gatherNodeParts(node.property, parts);
            break;
          case "Identifier":
          case "JSXIdentifier":
            parts.push(node.name);
            break;
          case "CallExpression":
          case "OptionalCallExpression":
          case "NewExpression":
            gatherNodeParts(node.callee, parts);
            break;
          case "ObjectExpression":
          case "ObjectPattern":
            for (const e of node.properties) {
              gatherNodeParts(e, parts);
            }
            break;
          case "SpreadElement":
          case "RestElement":
            gatherNodeParts(node.argument, parts);
            break;
          case "ObjectProperty":
          case "ObjectMethod":
          case "ClassProperty":
          case "ClassMethod":
          case "ClassPrivateProperty":
          case "ClassPrivateMethod":
            gatherNodeParts(node.key, parts);
            break;
          case "ThisExpression":
            parts.push("this");
            break;
          case "Super":
            parts.push("super");
            break;
          case "Import":
            parts.push("import");
            break;
          case "DoExpression":
            parts.push("do");
            break;
          case "YieldExpression":
            parts.push("yield");
            gatherNodeParts(node.argument, parts);
            break;
          case "AwaitExpression":
            parts.push("await");
            gatherNodeParts(node.argument, parts);
            break;
          case "AssignmentExpression":
            gatherNodeParts(node.left, parts);
            break;
          case "VariableDeclarator":
            gatherNodeParts(node.id, parts);
            break;
          case "FunctionExpression":
          case "FunctionDeclaration":
          case "ClassExpression":
          case "ClassDeclaration":
            gatherNodeParts(node.id, parts);
            break;
          case "PrivateName":
            gatherNodeParts(node.id, parts);
            break;
          case "ParenthesizedExpression":
            gatherNodeParts(node.expression, parts);
            break;
          case "UnaryExpression":
          case "UpdateExpression":
            gatherNodeParts(node.argument, parts);
            break;
          case "MetaProperty":
            gatherNodeParts(node.meta, parts);
            gatherNodeParts(node.property, parts);
            break;
          case "JSXElement":
            gatherNodeParts(node.openingElement, parts);
            break;
          case "JSXOpeningElement":
            gatherNodeParts(node.name, parts);
            break;
          case "JSXFragment":
            gatherNodeParts(node.openingFragment, parts);
            break;
          case "JSXOpeningFragment":
            parts.push("Fragment");
            break;
          case "JSXNamespacedName":
            gatherNodeParts(node.namespace, parts);
            gatherNodeParts(node.name, parts);
            break;
        }
      }
      var collectorVisitor = {
        ForStatement(path) {
          const declar = path.get("init");
          if (declar.isVar()) {
            const {
              scope
            } = path;
            const parentScope = scope.getFunctionParent() || scope.getProgramParent();
            parentScope.registerBinding("var", declar);
          }
        },
        Declaration(path) {
          if (path.isBlockScoped())
            return;
          if (path.isImportDeclaration())
            return;
          if (path.isExportDeclaration())
            return;
          const parent2 = path.scope.getFunctionParent() || path.scope.getProgramParent();
          parent2.registerDeclaration(path);
        },
        ImportDeclaration(path) {
          const parent2 = path.scope.getBlockParent();
          parent2.registerDeclaration(path);
        },
        ReferencedIdentifier(path, state) {
          state.references.push(path);
        },
        ForXStatement(path, state) {
          const left = path.get("left");
          if (left.isPattern() || left.isIdentifier()) {
            state.constantViolations.push(path);
          } else if (left.isVar()) {
            const {
              scope
            } = path;
            const parentScope = scope.getFunctionParent() || scope.getProgramParent();
            parentScope.registerBinding("var", left);
          }
        },
        ExportDeclaration: {
          exit(path) {
            const {
              node,
              scope
            } = path;
            if (isExportAllDeclaration(node))
              return;
            const declar = node.declaration;
            if (isClassDeclaration(declar) || isFunctionDeclaration(declar)) {
              const id = declar.id;
              if (!id)
                return;
              const binding = scope.getBinding(id.name);
              binding == null ? void 0 : binding.reference(path);
            } else if (isVariableDeclaration(declar)) {
              for (const decl of declar.declarations) {
                for (const name of Object.keys(getBindingIdentifiers(decl))) {
                  const binding = scope.getBinding(name);
                  binding == null ? void 0 : binding.reference(path);
                }
              }
            }
          }
        },
        LabeledStatement(path) {
          path.scope.getBlockParent().registerDeclaration(path);
        },
        AssignmentExpression(path, state) {
          state.assignments.push(path);
        },
        UpdateExpression(path, state) {
          state.constantViolations.push(path);
        },
        UnaryExpression(path, state) {
          if (path.node.operator === "delete") {
            state.constantViolations.push(path);
          }
        },
        BlockScoped(path) {
          let scope = path.scope;
          if (scope.path === path)
            scope = scope.parent;
          const parent2 = scope.getBlockParent();
          parent2.registerDeclaration(path);
          if (path.isClassDeclaration() && path.node.id) {
            const id = path.node.id;
            const name = id.name;
            path.scope.bindings[name] = path.scope.parent.getBinding(name);
          }
        },
        CatchClause(path) {
          path.scope.registerBinding("let", path);
        },
        Function(path) {
          const params = path.get("params");
          for (const param of params) {
            path.scope.registerBinding("param", param);
          }
          if (path.isFunctionExpression() && path.has("id") && !path.get("id").node[NOT_LOCAL_BINDING]) {
            path.scope.registerBinding("local", path.get("id"), path);
          }
        },
        ClassExpression(path) {
          if (path.has("id") && !path.get("id").node[NOT_LOCAL_BINDING]) {
            path.scope.registerBinding("local", path);
          }
        }
      };
      var uid = 0;
      var Scope2 = class {
        constructor(path) {
          this.uid = void 0;
          this.path = void 0;
          this.block = void 0;
          this.labels = void 0;
          this.inited = void 0;
          this.bindings = void 0;
          this.references = void 0;
          this.globals = void 0;
          this.uids = void 0;
          this.data = void 0;
          this.crawling = void 0;
          const {
            node
          } = path;
          const cached = _cache.scope.get(node);
          if ((cached == null ? void 0 : cached.path) === path) {
            return cached;
          }
          _cache.scope.set(node, this);
          this.uid = uid++;
          this.block = node;
          this.path = path;
          this.labels = /* @__PURE__ */ new Map();
          this.inited = false;
        }
        get parent() {
          var _parent;
          let parent2, path = this.path;
          do {
            const shouldSkip = path.key === "key" || path.listKey === "decorators";
            path = path.parentPath;
            if (shouldSkip && path.isMethod())
              path = path.parentPath;
            if (path && path.isScope())
              parent2 = path;
          } while (path && !parent2);
          return (_parent = parent2) == null ? void 0 : _parent.scope;
        }
        get parentBlock() {
          return this.path.parent;
        }
        get hub() {
          return this.path.hub;
        }
        traverse(node, opts, state) {
          (0, _index.default)(node, opts, this, state, this.path);
        }
        generateDeclaredUidIdentifier(name) {
          const id = this.generateUidIdentifier(name);
          this.push({
            id
          });
          return cloneNode(id);
        }
        generateUidIdentifier(name) {
          return identifier3(this.generateUid(name));
        }
        generateUid(name = "temp") {
          name = toIdentifier(name).replace(/^_+/, "").replace(/[0-9]+$/g, "");
          let uid2;
          let i = 1;
          do {
            uid2 = this._generateUid(name, i);
            i++;
          } while (this.hasLabel(uid2) || this.hasBinding(uid2) || this.hasGlobal(uid2) || this.hasReference(uid2));
          const program3 = this.getProgramParent();
          program3.references[uid2] = true;
          program3.uids[uid2] = true;
          return uid2;
        }
        _generateUid(name, i) {
          let id = name;
          if (i > 1)
            id += i;
          return `_${id}`;
        }
        generateUidBasedOnNode(node, defaultName) {
          const parts = [];
          gatherNodeParts(node, parts);
          let id = parts.join("$");
          id = id.replace(/^_/, "") || defaultName || "ref";
          return this.generateUid(id.slice(0, 20));
        }
        generateUidIdentifierBasedOnNode(node, defaultName) {
          return identifier3(this.generateUidBasedOnNode(node, defaultName));
        }
        isStatic(node) {
          if (isThisExpression(node) || isSuper(node) || isTopicReference(node)) {
            return true;
          }
          if (isIdentifier2(node)) {
            const binding = this.getBinding(node.name);
            if (binding) {
              return binding.constant;
            } else {
              return this.hasBinding(node.name);
            }
          }
          return false;
        }
        maybeGenerateMemoised(node, dontPush) {
          if (this.isStatic(node)) {
            return null;
          } else {
            const id = this.generateUidIdentifierBasedOnNode(node);
            if (!dontPush) {
              this.push({
                id
              });
              return cloneNode(id);
            }
            return id;
          }
        }
        checkBlockScopedCollisions(local, kind, name, id) {
          if (kind === "param")
            return;
          if (local.kind === "local")
            return;
          const duplicate = kind === "let" || local.kind === "let" || local.kind === "const" || local.kind === "module" || local.kind === "param" && kind === "const";
          if (duplicate) {
            throw this.hub.buildError(id, `Duplicate declaration "${name}"`, TypeError);
          }
        }
        rename(oldName, newName, block) {
          const binding = this.getBinding(oldName);
          if (binding) {
            newName = newName || this.generateUidIdentifier(oldName).name;
            return new _renamer.default(binding, oldName, newName).rename(block);
          }
        }
        _renameFromMap(map2, oldName, newName, value) {
          if (map2[oldName]) {
            map2[newName] = value;
            map2[oldName] = null;
          }
        }
        dump() {
          const sep = "-".repeat(60);
          console.log(sep);
          let scope = this;
          do {
            console.log("#", scope.block.type);
            for (const name of Object.keys(scope.bindings)) {
              const binding = scope.bindings[name];
              console.log(" -", name, {
                constant: binding.constant,
                references: binding.references,
                violations: binding.constantViolations.length,
                kind: binding.kind
              });
            }
          } while (scope = scope.parent);
          console.log(sep);
        }
        toArray(node, i, arrayLikeIsIterable) {
          if (isIdentifier2(node)) {
            const binding = this.getBinding(node.name);
            if (binding != null && binding.constant && binding.path.isGenericType("Array")) {
              return node;
            }
          }
          if (isArrayExpression(node)) {
            return node;
          }
          if (isIdentifier2(node, {
            name: "arguments"
          })) {
            return callExpression(memberExpression(memberExpression(memberExpression(identifier3("Array"), identifier3("prototype")), identifier3("slice")), identifier3("call")), [node]);
          }
          let helperName;
          const args = [node];
          if (i === true) {
            helperName = "toConsumableArray";
          } else if (i) {
            args.push(numericLiteral(i));
            helperName = "slicedToArray";
          } else {
            helperName = "toArray";
          }
          if (arrayLikeIsIterable) {
            args.unshift(this.hub.addHelper(helperName));
            helperName = "maybeArrayLike";
          }
          return callExpression(this.hub.addHelper(helperName), args);
        }
        hasLabel(name) {
          return !!this.getLabel(name);
        }
        getLabel(name) {
          return this.labels.get(name);
        }
        registerLabel(path) {
          this.labels.set(path.node.label.name, path);
        }
        registerDeclaration(path) {
          if (path.isLabeledStatement()) {
            this.registerLabel(path);
          } else if (path.isFunctionDeclaration()) {
            this.registerBinding("hoisted", path.get("id"), path);
          } else if (path.isVariableDeclaration()) {
            const declarations = path.get("declarations");
            const {
              kind
            } = path.node;
            for (const declar of declarations) {
              this.registerBinding(kind === "using" ? "const" : kind, declar);
            }
          } else if (path.isClassDeclaration()) {
            if (path.node.declare)
              return;
            this.registerBinding("let", path);
          } else if (path.isImportDeclaration()) {
            const specifiers = path.get("specifiers");
            for (const specifier of specifiers) {
              this.registerBinding("module", specifier);
            }
          } else if (path.isExportDeclaration()) {
            const declar = path.get("declaration");
            if (declar.isClassDeclaration() || declar.isFunctionDeclaration() || declar.isVariableDeclaration()) {
              this.registerDeclaration(declar);
            }
          } else {
            this.registerBinding("unknown", path);
          }
        }
        buildUndefinedNode() {
          return unaryExpression("void", numericLiteral(0), true);
        }
        registerConstantViolation(path) {
          const ids = path.getBindingIdentifiers();
          for (const name of Object.keys(ids)) {
            const binding = this.getBinding(name);
            if (binding)
              binding.reassign(path);
          }
        }
        registerBinding(kind, path, bindingPath = path) {
          if (!kind)
            throw new ReferenceError("no `kind`");
          if (path.isVariableDeclaration()) {
            const declarators = path.get("declarations");
            for (const declar of declarators) {
              this.registerBinding(kind, declar);
            }
            return;
          }
          const parent2 = this.getProgramParent();
          const ids = path.getOuterBindingIdentifiers(true);
          for (const name of Object.keys(ids)) {
            parent2.references[name] = true;
            for (const id of ids[name]) {
              const local = this.getOwnBinding(name);
              if (local) {
                if (local.identifier === id)
                  continue;
                this.checkBlockScopedCollisions(local, kind, name, id);
              }
              if (local) {
                this.registerConstantViolation(bindingPath);
              } else {
                this.bindings[name] = new _binding.default({
                  identifier: id,
                  scope: this,
                  path: bindingPath,
                  kind
                });
              }
            }
          }
        }
        addGlobal(node) {
          this.globals[node.name] = node;
        }
        hasUid(name) {
          let scope = this;
          do {
            if (scope.uids[name])
              return true;
          } while (scope = scope.parent);
          return false;
        }
        hasGlobal(name) {
          let scope = this;
          do {
            if (scope.globals[name])
              return true;
          } while (scope = scope.parent);
          return false;
        }
        hasReference(name) {
          return !!this.getProgramParent().references[name];
        }
        isPure(node, constantsOnly) {
          if (isIdentifier2(node)) {
            const binding = this.getBinding(node.name);
            if (!binding)
              return false;
            if (constantsOnly)
              return binding.constant;
            return true;
          } else if (isThisExpression(node) || isMetaProperty(node) || isTopicReference(node) || isPrivateName(node)) {
            return true;
          } else if (isClass(node)) {
            var _node$decorators;
            if (node.superClass && !this.isPure(node.superClass, constantsOnly)) {
              return false;
            }
            if (((_node$decorators = node.decorators) == null ? void 0 : _node$decorators.length) > 0) {
              return false;
            }
            return this.isPure(node.body, constantsOnly);
          } else if (isClassBody(node)) {
            for (const method2 of node.body) {
              if (!this.isPure(method2, constantsOnly))
                return false;
            }
            return true;
          } else if (isBinary(node)) {
            return this.isPure(node.left, constantsOnly) && this.isPure(node.right, constantsOnly);
          } else if (isArrayExpression(node) || isTupleExpression(node)) {
            for (const elem of node.elements) {
              if (elem !== null && !this.isPure(elem, constantsOnly))
                return false;
            }
            return true;
          } else if (isObjectExpression(node) || isRecordExpression(node)) {
            for (const prop of node.properties) {
              if (!this.isPure(prop, constantsOnly))
                return false;
            }
            return true;
          } else if (isMethod(node)) {
            var _node$decorators2;
            if (node.computed && !this.isPure(node.key, constantsOnly))
              return false;
            if (((_node$decorators2 = node.decorators) == null ? void 0 : _node$decorators2.length) > 0) {
              return false;
            }
            return true;
          } else if (isProperty(node)) {
            var _node$decorators3;
            if (node.computed && !this.isPure(node.key, constantsOnly))
              return false;
            if (((_node$decorators3 = node.decorators) == null ? void 0 : _node$decorators3.length) > 0) {
              return false;
            }
            if (isObjectProperty(node) || node.static) {
              if (node.value !== null && !this.isPure(node.value, constantsOnly)) {
                return false;
              }
            }
            return true;
          } else if (isUnaryExpression(node)) {
            return this.isPure(node.argument, constantsOnly);
          } else if (isTaggedTemplateExpression(node)) {
            return matchesPattern(node.tag, "String.raw") && !this.hasBinding("String", true) && this.isPure(node.quasi, constantsOnly);
          } else if (isTemplateLiteral(node)) {
            for (const expression of node.expressions) {
              if (!this.isPure(expression, constantsOnly))
                return false;
            }
            return true;
          } else {
            return isPureish(node);
          }
        }
        setData(key, val) {
          return this.data[key] = val;
        }
        getData(key) {
          let scope = this;
          do {
            const data = scope.data[key];
            if (data != null)
              return data;
          } while (scope = scope.parent);
        }
        removeData(key) {
          let scope = this;
          do {
            const data = scope.data[key];
            if (data != null)
              scope.data[key] = null;
          } while (scope = scope.parent);
        }
        init() {
          if (!this.inited) {
            this.inited = true;
            this.crawl();
          }
        }
        crawl() {
          const path = this.path;
          this.references = /* @__PURE__ */ Object.create(null);
          this.bindings = /* @__PURE__ */ Object.create(null);
          this.globals = /* @__PURE__ */ Object.create(null);
          this.uids = /* @__PURE__ */ Object.create(null);
          this.data = /* @__PURE__ */ Object.create(null);
          const programParent = this.getProgramParent();
          if (programParent.crawling)
            return;
          const state = {
            references: [],
            constantViolations: [],
            assignments: []
          };
          this.crawling = true;
          if (path.type !== "Program" && collectorVisitor._exploded) {
            for (const visit of collectorVisitor.enter) {
              visit(path, state);
            }
            const typeVisitors = collectorVisitor[path.type];
            if (typeVisitors) {
              for (const visit of typeVisitors.enter) {
                visit(path, state);
              }
            }
          }
          path.traverse(collectorVisitor, state);
          this.crawling = false;
          for (const path2 of state.assignments) {
            const ids = path2.getBindingIdentifiers();
            for (const name of Object.keys(ids)) {
              if (path2.scope.getBinding(name))
                continue;
              programParent.addGlobal(ids[name]);
            }
            path2.scope.registerConstantViolation(path2);
          }
          for (const ref of state.references) {
            const binding = ref.scope.getBinding(ref.node.name);
            if (binding) {
              binding.reference(ref);
            } else {
              programParent.addGlobal(ref.node);
            }
          }
          for (const path2 of state.constantViolations) {
            path2.scope.registerConstantViolation(path2);
          }
        }
        push(opts) {
          let path = this.path;
          if (path.isPattern()) {
            path = this.getPatternParent().path;
          } else if (!path.isBlockStatement() && !path.isProgram()) {
            path = this.getBlockParent().path;
          }
          if (path.isSwitchStatement()) {
            path = (this.getFunctionParent() || this.getProgramParent()).path;
          }
          if (path.isLoop() || path.isCatchClause() || path.isFunction()) {
            path.ensureBlock();
            path = path.get("body");
          }
          const unique = opts.unique;
          const kind = opts.kind || "var";
          const blockHoist = opts._blockHoist == null ? 2 : opts._blockHoist;
          const dataKey = `declaration:${kind}:${blockHoist}`;
          let declarPath = !unique && path.getData(dataKey);
          if (!declarPath) {
            const declar = variableDeclaration(kind, []);
            declar._blockHoist = blockHoist;
            [declarPath] = path.unshiftContainer("body", [declar]);
            if (!unique)
              path.setData(dataKey, declarPath);
          }
          const declarator = variableDeclarator(opts.id, opts.init);
          const len = declarPath.node.declarations.push(declarator);
          path.scope.registerBinding(kind, declarPath.get("declarations")[len - 1]);
        }
        getProgramParent() {
          let scope = this;
          do {
            if (scope.path.isProgram()) {
              return scope;
            }
          } while (scope = scope.parent);
          throw new Error("Couldn't find a Program");
        }
        getFunctionParent() {
          let scope = this;
          do {
            if (scope.path.isFunctionParent()) {
              return scope;
            }
          } while (scope = scope.parent);
          return null;
        }
        getBlockParent() {
          let scope = this;
          do {
            if (scope.path.isBlockParent()) {
              return scope;
            }
          } while (scope = scope.parent);
          throw new Error("We couldn't find a BlockStatement, For, Switch, Function, Loop or Program...");
        }
        getPatternParent() {
          let scope = this;
          do {
            if (!scope.path.isPattern()) {
              return scope.getBlockParent();
            }
          } while (scope = scope.parent.parent);
          throw new Error("We couldn't find a BlockStatement, For, Switch, Function, Loop or Program...");
        }
        getAllBindings() {
          const ids = /* @__PURE__ */ Object.create(null);
          let scope = this;
          do {
            for (const key of Object.keys(scope.bindings)) {
              if (key in ids === false) {
                ids[key] = scope.bindings[key];
              }
            }
            scope = scope.parent;
          } while (scope);
          return ids;
        }
        getAllBindingsOfKind(...kinds) {
          const ids = /* @__PURE__ */ Object.create(null);
          for (const kind of kinds) {
            let scope = this;
            do {
              for (const name of Object.keys(scope.bindings)) {
                const binding = scope.bindings[name];
                if (binding.kind === kind)
                  ids[name] = binding;
              }
              scope = scope.parent;
            } while (scope);
          }
          return ids;
        }
        bindingIdentifierEquals(name, node) {
          return this.getBindingIdentifier(name) === node;
        }
        getBinding(name) {
          let scope = this;
          let previousPath;
          do {
            const binding = scope.getOwnBinding(name);
            if (binding) {
              var _previousPath;
              if ((_previousPath = previousPath) != null && _previousPath.isPattern() && binding.kind !== "param" && binding.kind !== "local") {
              } else {
                return binding;
              }
            } else if (!binding && name === "arguments" && scope.path.isFunction() && !scope.path.isArrowFunctionExpression()) {
              break;
            }
            previousPath = scope.path;
          } while (scope = scope.parent);
        }
        getOwnBinding(name) {
          return this.bindings[name];
        }
        getBindingIdentifier(name) {
          var _this$getBinding;
          return (_this$getBinding = this.getBinding(name)) == null ? void 0 : _this$getBinding.identifier;
        }
        getOwnBindingIdentifier(name) {
          const binding = this.bindings[name];
          return binding == null ? void 0 : binding.identifier;
        }
        hasOwnBinding(name) {
          return !!this.getOwnBinding(name);
        }
        hasBinding(name, noGlobals) {
          if (!name)
            return false;
          if (this.hasOwnBinding(name))
            return true;
          if (this.parentHasBinding(name, noGlobals))
            return true;
          if (this.hasUid(name))
            return true;
          if (!noGlobals && Scope2.globals.includes(name))
            return true;
          if (!noGlobals && Scope2.contextVariables.includes(name))
            return true;
          return false;
        }
        parentHasBinding(name, noGlobals) {
          var _this$parent;
          return (_this$parent = this.parent) == null ? void 0 : _this$parent.hasBinding(name, noGlobals);
        }
        moveBindingTo(name, scope) {
          const info = this.getBinding(name);
          if (info) {
            info.scope.removeOwnBinding(name);
            info.scope = scope;
            scope.bindings[name] = info;
          }
        }
        removeOwnBinding(name) {
          delete this.bindings[name];
        }
        removeBinding(name) {
          var _this$getBinding2;
          (_this$getBinding2 = this.getBinding(name)) == null ? void 0 : _this$getBinding2.scope.removeOwnBinding(name);
          let scope = this;
          do {
            if (scope.uids[name]) {
              scope.uids[name] = false;
            }
          } while (scope = scope.parent);
        }
      };
      exports2.default = Scope2;
      Scope2.globals = Object.keys(_globals.builtin);
      Scope2.contextVariables = ["arguments", "undefined", "Infinity", "NaN"];
    }
  });

  // node_modules/@babel/traverse/lib/path/ancestry.js
  var require_ancestry = __commonJS({
    "node_modules/@babel/traverse/lib/path/ancestry.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.find = find2;
      exports2.findParent = findParent;
      exports2.getAncestry = getAncestry;
      exports2.getDeepestCommonAncestorFrom = getDeepestCommonAncestorFrom;
      exports2.getEarliestCommonAncestorFrom = getEarliestCommonAncestorFrom;
      exports2.getFunctionParent = getFunctionParent;
      exports2.getStatementParent = getStatementParent;
      exports2.inType = inType;
      exports2.isAncestor = isAncestor;
      exports2.isDescendant = isDescendant;
      var _t = require_lib5();
      var {
        VISITOR_KEYS
      } = _t;
      function findParent(callback) {
        let path = this;
        while (path = path.parentPath) {
          if (callback(path))
            return path;
        }
        return null;
      }
      function find2(callback) {
        let path = this;
        do {
          if (callback(path))
            return path;
        } while (path = path.parentPath);
        return null;
      }
      function getFunctionParent() {
        return this.findParent((p) => p.isFunction());
      }
      function getStatementParent() {
        let path = this;
        do {
          if (!path.parentPath || Array.isArray(path.container) && path.isStatement()) {
            break;
          } else {
            path = path.parentPath;
          }
        } while (path);
        if (path && (path.isProgram() || path.isFile())) {
          throw new Error("File/Program node, we can't possibly find a statement parent to this");
        }
        return path;
      }
      function getEarliestCommonAncestorFrom(paths) {
        return this.getDeepestCommonAncestorFrom(paths, function(deepest, i, ancestries) {
          let earliest;
          const keys2 = VISITOR_KEYS[deepest.type];
          for (const ancestry of ancestries) {
            const path = ancestry[i + 1];
            if (!earliest) {
              earliest = path;
              continue;
            }
            if (path.listKey && earliest.listKey === path.listKey) {
              if (path.key < earliest.key) {
                earliest = path;
                continue;
              }
            }
            const earliestKeyIndex = keys2.indexOf(earliest.parentKey);
            const currentKeyIndex = keys2.indexOf(path.parentKey);
            if (earliestKeyIndex > currentKeyIndex) {
              earliest = path;
            }
          }
          return earliest;
        });
      }
      function getDeepestCommonAncestorFrom(paths, filter2) {
        if (!paths.length) {
          return this;
        }
        if (paths.length === 1) {
          return paths[0];
        }
        let minDepth = Infinity;
        let lastCommonIndex, lastCommon;
        const ancestries = paths.map((path) => {
          const ancestry = [];
          do {
            ancestry.unshift(path);
          } while ((path = path.parentPath) && path !== this);
          if (ancestry.length < minDepth) {
            minDepth = ancestry.length;
          }
          return ancestry;
        });
        const first = ancestries[0];
        depthLoop:
          for (let i = 0; i < minDepth; i++) {
            const shouldMatch = first[i];
            for (const ancestry of ancestries) {
              if (ancestry[i] !== shouldMatch) {
                break depthLoop;
              }
            }
            lastCommonIndex = i;
            lastCommon = shouldMatch;
          }
        if (lastCommon) {
          if (filter2) {
            return filter2(lastCommon, lastCommonIndex, ancestries);
          } else {
            return lastCommon;
          }
        } else {
          throw new Error("Couldn't find intersection");
        }
      }
      function getAncestry() {
        let path = this;
        const paths = [];
        do {
          paths.push(path);
        } while (path = path.parentPath);
        return paths;
      }
      function isAncestor(maybeDescendant) {
        return maybeDescendant.isDescendant(this);
      }
      function isDescendant(maybeAncestor) {
        return !!this.findParent((parent2) => parent2 === maybeAncestor);
      }
      function inType(...candidateTypes) {
        let path = this;
        while (path) {
          for (const type of candidateTypes) {
            if (path.node.type === type)
              return true;
          }
          path = path.parentPath;
        }
        return false;
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/inference/util.js
  var require_util4 = __commonJS({
    "node_modules/@babel/traverse/lib/path/inference/util.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.createUnionType = createUnionType;
      var _t = require_lib5();
      var {
        createFlowUnionType,
        createTSUnionType,
        createUnionTypeAnnotation,
        isFlowType,
        isTSType
      } = _t;
      function createUnionType(types) {
        {
          if (isFlowType(types[0])) {
            if (createFlowUnionType) {
              return createFlowUnionType(types);
            }
            return createUnionTypeAnnotation(types);
          } else {
            if (createTSUnionType) {
              return createTSUnionType(types);
            }
          }
        }
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/inference/inferer-reference.js
  var require_inferer_reference = __commonJS({
    "node_modules/@babel/traverse/lib/path/inference/inferer-reference.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = _default;
      var _t = require_lib5();
      var _util = require_util4();
      var {
        BOOLEAN_NUMBER_BINARY_OPERATORS,
        createTypeAnnotationBasedOnTypeof,
        numberTypeAnnotation,
        voidTypeAnnotation
      } = _t;
      function _default(node) {
        if (!this.isReferenced())
          return;
        const binding = this.scope.getBinding(node.name);
        if (binding) {
          if (binding.identifier.typeAnnotation) {
            return binding.identifier.typeAnnotation;
          } else {
            return getTypeAnnotationBindingConstantViolations(binding, this, node.name);
          }
        }
        if (node.name === "undefined") {
          return voidTypeAnnotation();
        } else if (node.name === "NaN" || node.name === "Infinity") {
          return numberTypeAnnotation();
        } else if (node.name === "arguments") {
        }
      }
      function getTypeAnnotationBindingConstantViolations(binding, path, name) {
        const types = [];
        const functionConstantViolations = [];
        let constantViolations = getConstantViolationsBefore(binding, path, functionConstantViolations);
        const testType = getConditionalAnnotation(binding, path, name);
        if (testType) {
          const testConstantViolations = getConstantViolationsBefore(binding, testType.ifStatement);
          constantViolations = constantViolations.filter((path2) => testConstantViolations.indexOf(path2) < 0);
          types.push(testType.typeAnnotation);
        }
        if (constantViolations.length) {
          constantViolations.push(...functionConstantViolations);
          for (const violation of constantViolations) {
            types.push(violation.getTypeAnnotation());
          }
        }
        if (!types.length) {
          return;
        }
        return (0, _util.createUnionType)(types);
      }
      function getConstantViolationsBefore(binding, path, functions2) {
        const violations = binding.constantViolations.slice();
        violations.unshift(binding.path);
        return violations.filter((violation) => {
          violation = violation.resolve();
          const status = violation._guessExecutionStatusRelativeTo(path);
          if (functions2 && status === "unknown")
            functions2.push(violation);
          return status === "before";
        });
      }
      function inferAnnotationFromBinaryExpression(name, path) {
        const operator = path.node.operator;
        const right = path.get("right").resolve();
        const left = path.get("left").resolve();
        let target;
        if (left.isIdentifier({
          name
        })) {
          target = right;
        } else if (right.isIdentifier({
          name
        })) {
          target = left;
        }
        if (target) {
          if (operator === "===") {
            return target.getTypeAnnotation();
          }
          if (BOOLEAN_NUMBER_BINARY_OPERATORS.indexOf(operator) >= 0) {
            return numberTypeAnnotation();
          }
          return;
        }
        if (operator !== "===" && operator !== "==")
          return;
        let typeofPath;
        let typePath;
        if (left.isUnaryExpression({
          operator: "typeof"
        })) {
          typeofPath = left;
          typePath = right;
        } else if (right.isUnaryExpression({
          operator: "typeof"
        })) {
          typeofPath = right;
          typePath = left;
        }
        if (!typeofPath)
          return;
        if (!typeofPath.get("argument").isIdentifier({
          name
        }))
          return;
        typePath = typePath.resolve();
        if (!typePath.isLiteral())
          return;
        const typeValue = typePath.node.value;
        if (typeof typeValue !== "string")
          return;
        return createTypeAnnotationBasedOnTypeof(typeValue);
      }
      function getParentConditionalPath(binding, path, name) {
        let parentPath;
        while (parentPath = path.parentPath) {
          if (parentPath.isIfStatement() || parentPath.isConditionalExpression()) {
            if (path.key === "test") {
              return;
            }
            return parentPath;
          }
          if (parentPath.isFunction()) {
            if (parentPath.parentPath.scope.getBinding(name) !== binding)
              return;
          }
          path = parentPath;
        }
      }
      function getConditionalAnnotation(binding, path, name) {
        const ifStatement = getParentConditionalPath(binding, path, name);
        if (!ifStatement)
          return;
        const test = ifStatement.get("test");
        const paths = [test];
        const types = [];
        for (let i = 0; i < paths.length; i++) {
          const path2 = paths[i];
          if (path2.isLogicalExpression()) {
            if (path2.node.operator === "&&") {
              paths.push(path2.get("left"));
              paths.push(path2.get("right"));
            }
          } else if (path2.isBinaryExpression()) {
            const type = inferAnnotationFromBinaryExpression(name, path2);
            if (type)
              types.push(type);
          }
        }
        if (types.length) {
          return {
            typeAnnotation: (0, _util.createUnionType)(types),
            ifStatement
          };
        }
        return getConditionalAnnotation(binding, ifStatement, name);
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/inference/inferers.js
  var require_inferers = __commonJS({
    "node_modules/@babel/traverse/lib/path/inference/inferers.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.ArrayExpression = ArrayExpression;
      exports2.AssignmentExpression = AssignmentExpression;
      exports2.BinaryExpression = BinaryExpression;
      exports2.BooleanLiteral = BooleanLiteral;
      exports2.CallExpression = CallExpression;
      exports2.ConditionalExpression = ConditionalExpression;
      exports2.ClassDeclaration = exports2.ClassExpression = exports2.FunctionDeclaration = exports2.ArrowFunctionExpression = exports2.FunctionExpression = Func;
      Object.defineProperty(exports2, "Identifier", {
        enumerable: true,
        get: function() {
          return _infererReference.default;
        }
      });
      exports2.LogicalExpression = LogicalExpression;
      exports2.NewExpression = NewExpression;
      exports2.NullLiteral = NullLiteral;
      exports2.NumericLiteral = NumericLiteral;
      exports2.ObjectExpression = ObjectExpression;
      exports2.ParenthesizedExpression = ParenthesizedExpression;
      exports2.RegExpLiteral = RegExpLiteral;
      exports2.RestElement = RestElement;
      exports2.SequenceExpression = SequenceExpression;
      exports2.StringLiteral = StringLiteral;
      exports2.TSAsExpression = TSAsExpression;
      exports2.TSNonNullExpression = TSNonNullExpression;
      exports2.TaggedTemplateExpression = TaggedTemplateExpression;
      exports2.TemplateLiteral = TemplateLiteral;
      exports2.TypeCastExpression = TypeCastExpression;
      exports2.UnaryExpression = UnaryExpression;
      exports2.UpdateExpression = UpdateExpression;
      exports2.VariableDeclarator = VariableDeclarator;
      var _t = require_lib5();
      var _infererReference = require_inferer_reference();
      var _util = require_util4();
      var {
        BOOLEAN_BINARY_OPERATORS,
        BOOLEAN_UNARY_OPERATORS,
        NUMBER_BINARY_OPERATORS,
        NUMBER_UNARY_OPERATORS,
        STRING_UNARY_OPERATORS,
        anyTypeAnnotation,
        arrayTypeAnnotation,
        booleanTypeAnnotation,
        buildMatchMemberExpression,
        genericTypeAnnotation,
        identifier: identifier3,
        nullLiteralTypeAnnotation,
        numberTypeAnnotation,
        stringTypeAnnotation,
        tupleTypeAnnotation,
        unionTypeAnnotation,
        voidTypeAnnotation,
        isIdentifier: isIdentifier2
      } = _t;
      function VariableDeclarator() {
        if (!this.get("id").isIdentifier())
          return;
        return this.get("init").getTypeAnnotation();
      }
      function TypeCastExpression(node) {
        return node.typeAnnotation;
      }
      TypeCastExpression.validParent = true;
      function TSAsExpression(node) {
        return node.typeAnnotation;
      }
      TSAsExpression.validParent = true;
      function TSNonNullExpression() {
        return this.get("expression").getTypeAnnotation();
      }
      function NewExpression(node) {
        if (node.callee.type === "Identifier") {
          return genericTypeAnnotation(node.callee);
        }
      }
      function TemplateLiteral() {
        return stringTypeAnnotation();
      }
      function UnaryExpression(node) {
        const operator = node.operator;
        if (operator === "void") {
          return voidTypeAnnotation();
        } else if (NUMBER_UNARY_OPERATORS.indexOf(operator) >= 0) {
          return numberTypeAnnotation();
        } else if (STRING_UNARY_OPERATORS.indexOf(operator) >= 0) {
          return stringTypeAnnotation();
        } else if (BOOLEAN_UNARY_OPERATORS.indexOf(operator) >= 0) {
          return booleanTypeAnnotation();
        }
      }
      function BinaryExpression(node) {
        const operator = node.operator;
        if (NUMBER_BINARY_OPERATORS.indexOf(operator) >= 0) {
          return numberTypeAnnotation();
        } else if (BOOLEAN_BINARY_OPERATORS.indexOf(operator) >= 0) {
          return booleanTypeAnnotation();
        } else if (operator === "+") {
          const right = this.get("right");
          const left = this.get("left");
          if (left.isBaseType("number") && right.isBaseType("number")) {
            return numberTypeAnnotation();
          } else if (left.isBaseType("string") || right.isBaseType("string")) {
            return stringTypeAnnotation();
          }
          return unionTypeAnnotation([stringTypeAnnotation(), numberTypeAnnotation()]);
        }
      }
      function LogicalExpression() {
        const argumentTypes = [this.get("left").getTypeAnnotation(), this.get("right").getTypeAnnotation()];
        return (0, _util.createUnionType)(argumentTypes);
      }
      function ConditionalExpression() {
        const argumentTypes = [this.get("consequent").getTypeAnnotation(), this.get("alternate").getTypeAnnotation()];
        return (0, _util.createUnionType)(argumentTypes);
      }
      function SequenceExpression() {
        return this.get("expressions").pop().getTypeAnnotation();
      }
      function ParenthesizedExpression() {
        return this.get("expression").getTypeAnnotation();
      }
      function AssignmentExpression() {
        return this.get("right").getTypeAnnotation();
      }
      function UpdateExpression(node) {
        const operator = node.operator;
        if (operator === "++" || operator === "--") {
          return numberTypeAnnotation();
        }
      }
      function StringLiteral() {
        return stringTypeAnnotation();
      }
      function NumericLiteral() {
        return numberTypeAnnotation();
      }
      function BooleanLiteral() {
        return booleanTypeAnnotation();
      }
      function NullLiteral() {
        return nullLiteralTypeAnnotation();
      }
      function RegExpLiteral() {
        return genericTypeAnnotation(identifier3("RegExp"));
      }
      function ObjectExpression() {
        return genericTypeAnnotation(identifier3("Object"));
      }
      function ArrayExpression() {
        return genericTypeAnnotation(identifier3("Array"));
      }
      function RestElement() {
        return ArrayExpression();
      }
      RestElement.validParent = true;
      function Func() {
        return genericTypeAnnotation(identifier3("Function"));
      }
      var isArrayFrom = buildMatchMemberExpression("Array.from");
      var isObjectKeys = buildMatchMemberExpression("Object.keys");
      var isObjectValues = buildMatchMemberExpression("Object.values");
      var isObjectEntries = buildMatchMemberExpression("Object.entries");
      function CallExpression() {
        const {
          callee
        } = this.node;
        if (isObjectKeys(callee)) {
          return arrayTypeAnnotation(stringTypeAnnotation());
        } else if (isArrayFrom(callee) || isObjectValues(callee) || isIdentifier2(callee, {
          name: "Array"
        })) {
          return arrayTypeAnnotation(anyTypeAnnotation());
        } else if (isObjectEntries(callee)) {
          return arrayTypeAnnotation(tupleTypeAnnotation([stringTypeAnnotation(), anyTypeAnnotation()]));
        }
        return resolveCall(this.get("callee"));
      }
      function TaggedTemplateExpression() {
        return resolveCall(this.get("tag"));
      }
      function resolveCall(callee) {
        callee = callee.resolve();
        if (callee.isFunction()) {
          const {
            node
          } = callee;
          if (node.async) {
            if (node.generator) {
              return genericTypeAnnotation(identifier3("AsyncIterator"));
            } else {
              return genericTypeAnnotation(identifier3("Promise"));
            }
          } else {
            if (node.generator) {
              return genericTypeAnnotation(identifier3("Iterator"));
            } else if (callee.node.returnType) {
              return callee.node.returnType;
            } else {
            }
          }
        }
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/inference/index.js
  var require_inference = __commonJS({
    "node_modules/@babel/traverse/lib/path/inference/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._getTypeAnnotation = _getTypeAnnotation;
      exports2.baseTypeStrictlyMatches = baseTypeStrictlyMatches;
      exports2.couldBeBaseType = couldBeBaseType;
      exports2.getTypeAnnotation = getTypeAnnotation;
      exports2.isBaseType = isBaseType;
      exports2.isGenericType = isGenericType;
      var inferers = require_inferers();
      var _t = require_lib5();
      var {
        anyTypeAnnotation,
        isAnyTypeAnnotation,
        isArrayTypeAnnotation,
        isBooleanTypeAnnotation,
        isEmptyTypeAnnotation,
        isFlowBaseAnnotation,
        isGenericTypeAnnotation,
        isIdentifier: isIdentifier2,
        isMixedTypeAnnotation,
        isNumberTypeAnnotation,
        isStringTypeAnnotation,
        isTSArrayType,
        isTSTypeAnnotation,
        isTSTypeReference,
        isTupleTypeAnnotation,
        isTypeAnnotation,
        isUnionTypeAnnotation,
        isVoidTypeAnnotation,
        stringTypeAnnotation,
        voidTypeAnnotation
      } = _t;
      function getTypeAnnotation() {
        let type = this.getData("typeAnnotation");
        if (type != null) {
          return type;
        }
        type = this._getTypeAnnotation() || anyTypeAnnotation();
        if (isTypeAnnotation(type) || isTSTypeAnnotation(type)) {
          type = type.typeAnnotation;
        }
        this.setData("typeAnnotation", type);
        return type;
      }
      var typeAnnotationInferringNodes = /* @__PURE__ */ new WeakSet();
      function _getTypeAnnotation() {
        const node = this.node;
        if (!node) {
          if (this.key === "init" && this.parentPath.isVariableDeclarator()) {
            const declar = this.parentPath.parentPath;
            const declarParent = declar.parentPath;
            if (declar.key === "left" && declarParent.isForInStatement()) {
              return stringTypeAnnotation();
            }
            if (declar.key === "left" && declarParent.isForOfStatement()) {
              return anyTypeAnnotation();
            }
            return voidTypeAnnotation();
          } else {
            return;
          }
        }
        if (node.typeAnnotation) {
          return node.typeAnnotation;
        }
        if (typeAnnotationInferringNodes.has(node)) {
          return;
        }
        typeAnnotationInferringNodes.add(node);
        try {
          var _inferer;
          let inferer = inferers[node.type];
          if (inferer) {
            return inferer.call(this, node);
          }
          inferer = inferers[this.parentPath.type];
          if ((_inferer = inferer) != null && _inferer.validParent) {
            return this.parentPath.getTypeAnnotation();
          }
        } finally {
          typeAnnotationInferringNodes.delete(node);
        }
      }
      function isBaseType(baseName, soft) {
        return _isBaseType(baseName, this.getTypeAnnotation(), soft);
      }
      function _isBaseType(baseName, type, soft) {
        if (baseName === "string") {
          return isStringTypeAnnotation(type);
        } else if (baseName === "number") {
          return isNumberTypeAnnotation(type);
        } else if (baseName === "boolean") {
          return isBooleanTypeAnnotation(type);
        } else if (baseName === "any") {
          return isAnyTypeAnnotation(type);
        } else if (baseName === "mixed") {
          return isMixedTypeAnnotation(type);
        } else if (baseName === "empty") {
          return isEmptyTypeAnnotation(type);
        } else if (baseName === "void") {
          return isVoidTypeAnnotation(type);
        } else {
          if (soft) {
            return false;
          } else {
            throw new Error(`Unknown base type ${baseName}`);
          }
        }
      }
      function couldBeBaseType(name) {
        const type = this.getTypeAnnotation();
        if (isAnyTypeAnnotation(type))
          return true;
        if (isUnionTypeAnnotation(type)) {
          for (const type2 of type.types) {
            if (isAnyTypeAnnotation(type2) || _isBaseType(name, type2, true)) {
              return true;
            }
          }
          return false;
        } else {
          return _isBaseType(name, type, true);
        }
      }
      function baseTypeStrictlyMatches(rightArg) {
        const left = this.getTypeAnnotation();
        const right = rightArg.getTypeAnnotation();
        if (!isAnyTypeAnnotation(left) && isFlowBaseAnnotation(left)) {
          return right.type === left.type;
        }
        return false;
      }
      function isGenericType(genericName) {
        const type = this.getTypeAnnotation();
        if (genericName === "Array") {
          if (isTSArrayType(type) || isArrayTypeAnnotation(type) || isTupleTypeAnnotation(type)) {
            return true;
          }
        }
        return isGenericTypeAnnotation(type) && isIdentifier2(type.id, {
          name: genericName
        }) || isTSTypeReference(type) && isIdentifier2(type.typeName, {
          name: genericName
        });
      }
    }
  });

  // node_modules/js-tokens/index.js
  var require_js_tokens = __commonJS({
    "node_modules/js-tokens/index.js"(exports2) {
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = /((['"])(?:(?!\2|\\).|\\(?:\r\n|[\s\S]))*(\2)?|`(?:[^`\\$]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{[^}]*\}?)*\}?)*(`)?)|(\/\/.*)|(\/\*(?:[^*]|\*(?!\/))*(\*\/)?)|(\/(?!\*)(?:\[(?:(?![\]\\]).|\\.)*\]|(?![\/\]\\]).|\\.)+\/(?:(?!\s*(?:\b|[\u0080-\uFFFF$\\'"~({]|[+\-!](?!=)|\.?\d))|[gmiyus]{1,6}\b(?![\u0080-\uFFFF$\\]|\s*(?:[+\-*%&|^<>!=?({]|\/(?![\/*])))))|(0[xX][\da-fA-F]+|0[oO][0-7]+|0[bB][01]+|(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?)|((?!\d)(?:(?!\s)[$\w\u0080-\uFFFF]|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+)|(--|\+\+|&&|\|\||=>|\.{3}|(?:[+\-\/%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2})=?|[?~.,:;[\](){}])|(\s+)|(^$|[\s\S])/g;
      exports2.matchToToken = function(match) {
        var token = { type: "invalid", value: match[0], closed: void 0 };
        if (match[1])
          token.type = "string", token.closed = !!(match[3] || match[4]);
        else if (match[5])
          token.type = "comment";
        else if (match[6])
          token.type = "comment", token.closed = !!match[7];
        else if (match[8])
          token.type = "regex";
        else if (match[9])
          token.type = "number";
        else if (match[10])
          token.type = "name";
        else if (match[11])
          token.type = "punctuator";
        else if (match[12])
          token.type = "whitespace";
        return token;
      };
    }
  });

  // node_modules/escape-string-regexp/index.js
  var require_escape_string_regexp = __commonJS({
    "node_modules/escape-string-regexp/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
      module2.exports = function(str) {
        if (typeof str !== "string") {
          throw new TypeError("Expected a string");
        }
        return str.replace(matchOperatorsRe, "\\$&");
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/color-name/index.js
  var require_color_name = __commonJS({
    "node_modules/@babel/highlight/node_modules/color-name/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = {
        "aliceblue": [240, 248, 255],
        "antiquewhite": [250, 235, 215],
        "aqua": [0, 255, 255],
        "aquamarine": [127, 255, 212],
        "azure": [240, 255, 255],
        "beige": [245, 245, 220],
        "bisque": [255, 228, 196],
        "black": [0, 0, 0],
        "blanchedalmond": [255, 235, 205],
        "blue": [0, 0, 255],
        "blueviolet": [138, 43, 226],
        "brown": [165, 42, 42],
        "burlywood": [222, 184, 135],
        "cadetblue": [95, 158, 160],
        "chartreuse": [127, 255, 0],
        "chocolate": [210, 105, 30],
        "coral": [255, 127, 80],
        "cornflowerblue": [100, 149, 237],
        "cornsilk": [255, 248, 220],
        "crimson": [220, 20, 60],
        "cyan": [0, 255, 255],
        "darkblue": [0, 0, 139],
        "darkcyan": [0, 139, 139],
        "darkgoldenrod": [184, 134, 11],
        "darkgray": [169, 169, 169],
        "darkgreen": [0, 100, 0],
        "darkgrey": [169, 169, 169],
        "darkkhaki": [189, 183, 107],
        "darkmagenta": [139, 0, 139],
        "darkolivegreen": [85, 107, 47],
        "darkorange": [255, 140, 0],
        "darkorchid": [153, 50, 204],
        "darkred": [139, 0, 0],
        "darksalmon": [233, 150, 122],
        "darkseagreen": [143, 188, 143],
        "darkslateblue": [72, 61, 139],
        "darkslategray": [47, 79, 79],
        "darkslategrey": [47, 79, 79],
        "darkturquoise": [0, 206, 209],
        "darkviolet": [148, 0, 211],
        "deeppink": [255, 20, 147],
        "deepskyblue": [0, 191, 255],
        "dimgray": [105, 105, 105],
        "dimgrey": [105, 105, 105],
        "dodgerblue": [30, 144, 255],
        "firebrick": [178, 34, 34],
        "floralwhite": [255, 250, 240],
        "forestgreen": [34, 139, 34],
        "fuchsia": [255, 0, 255],
        "gainsboro": [220, 220, 220],
        "ghostwhite": [248, 248, 255],
        "gold": [255, 215, 0],
        "goldenrod": [218, 165, 32],
        "gray": [128, 128, 128],
        "green": [0, 128, 0],
        "greenyellow": [173, 255, 47],
        "grey": [128, 128, 128],
        "honeydew": [240, 255, 240],
        "hotpink": [255, 105, 180],
        "indianred": [205, 92, 92],
        "indigo": [75, 0, 130],
        "ivory": [255, 255, 240],
        "khaki": [240, 230, 140],
        "lavender": [230, 230, 250],
        "lavenderblush": [255, 240, 245],
        "lawngreen": [124, 252, 0],
        "lemonchiffon": [255, 250, 205],
        "lightblue": [173, 216, 230],
        "lightcoral": [240, 128, 128],
        "lightcyan": [224, 255, 255],
        "lightgoldenrodyellow": [250, 250, 210],
        "lightgray": [211, 211, 211],
        "lightgreen": [144, 238, 144],
        "lightgrey": [211, 211, 211],
        "lightpink": [255, 182, 193],
        "lightsalmon": [255, 160, 122],
        "lightseagreen": [32, 178, 170],
        "lightskyblue": [135, 206, 250],
        "lightslategray": [119, 136, 153],
        "lightslategrey": [119, 136, 153],
        "lightsteelblue": [176, 196, 222],
        "lightyellow": [255, 255, 224],
        "lime": [0, 255, 0],
        "limegreen": [50, 205, 50],
        "linen": [250, 240, 230],
        "magenta": [255, 0, 255],
        "maroon": [128, 0, 0],
        "mediumaquamarine": [102, 205, 170],
        "mediumblue": [0, 0, 205],
        "mediumorchid": [186, 85, 211],
        "mediumpurple": [147, 112, 219],
        "mediumseagreen": [60, 179, 113],
        "mediumslateblue": [123, 104, 238],
        "mediumspringgreen": [0, 250, 154],
        "mediumturquoise": [72, 209, 204],
        "mediumvioletred": [199, 21, 133],
        "midnightblue": [25, 25, 112],
        "mintcream": [245, 255, 250],
        "mistyrose": [255, 228, 225],
        "moccasin": [255, 228, 181],
        "navajowhite": [255, 222, 173],
        "navy": [0, 0, 128],
        "oldlace": [253, 245, 230],
        "olive": [128, 128, 0],
        "olivedrab": [107, 142, 35],
        "orange": [255, 165, 0],
        "orangered": [255, 69, 0],
        "orchid": [218, 112, 214],
        "palegoldenrod": [238, 232, 170],
        "palegreen": [152, 251, 152],
        "paleturquoise": [175, 238, 238],
        "palevioletred": [219, 112, 147],
        "papayawhip": [255, 239, 213],
        "peachpuff": [255, 218, 185],
        "peru": [205, 133, 63],
        "pink": [255, 192, 203],
        "plum": [221, 160, 221],
        "powderblue": [176, 224, 230],
        "purple": [128, 0, 128],
        "rebeccapurple": [102, 51, 153],
        "red": [255, 0, 0],
        "rosybrown": [188, 143, 143],
        "royalblue": [65, 105, 225],
        "saddlebrown": [139, 69, 19],
        "salmon": [250, 128, 114],
        "sandybrown": [244, 164, 96],
        "seagreen": [46, 139, 87],
        "seashell": [255, 245, 238],
        "sienna": [160, 82, 45],
        "silver": [192, 192, 192],
        "skyblue": [135, 206, 235],
        "slateblue": [106, 90, 205],
        "slategray": [112, 128, 144],
        "slategrey": [112, 128, 144],
        "snow": [255, 250, 250],
        "springgreen": [0, 255, 127],
        "steelblue": [70, 130, 180],
        "tan": [210, 180, 140],
        "teal": [0, 128, 128],
        "thistle": [216, 191, 216],
        "tomato": [255, 99, 71],
        "turquoise": [64, 224, 208],
        "violet": [238, 130, 238],
        "wheat": [245, 222, 179],
        "white": [255, 255, 255],
        "whitesmoke": [245, 245, 245],
        "yellow": [255, 255, 0],
        "yellowgreen": [154, 205, 50]
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/color-convert/conversions.js
  var require_conversions = __commonJS({
    "node_modules/@babel/highlight/node_modules/color-convert/conversions.js"(exports2, module2) {
      init_define_process();
      var cssKeywords = require_color_name();
      var reverseKeywords = {};
      for (key in cssKeywords) {
        if (cssKeywords.hasOwnProperty(key)) {
          reverseKeywords[cssKeywords[key]] = key;
        }
      }
      var key;
      var convert = module2.exports = {
        rgb: { channels: 3, labels: "rgb" },
        hsl: { channels: 3, labels: "hsl" },
        hsv: { channels: 3, labels: "hsv" },
        hwb: { channels: 3, labels: "hwb" },
        cmyk: { channels: 4, labels: "cmyk" },
        xyz: { channels: 3, labels: "xyz" },
        lab: { channels: 3, labels: "lab" },
        lch: { channels: 3, labels: "lch" },
        hex: { channels: 1, labels: ["hex"] },
        keyword: { channels: 1, labels: ["keyword"] },
        ansi16: { channels: 1, labels: ["ansi16"] },
        ansi256: { channels: 1, labels: ["ansi256"] },
        hcg: { channels: 3, labels: ["h", "c", "g"] },
        apple: { channels: 3, labels: ["r16", "g16", "b16"] },
        gray: { channels: 1, labels: ["gray"] }
      };
      for (model in convert) {
        if (convert.hasOwnProperty(model)) {
          if (!("channels" in convert[model])) {
            throw new Error("missing channels property: " + model);
          }
          if (!("labels" in convert[model])) {
            throw new Error("missing channel labels property: " + model);
          }
          if (convert[model].labels.length !== convert[model].channels) {
            throw new Error("channel and label counts mismatch: " + model);
          }
          channels = convert[model].channels;
          labels = convert[model].labels;
          delete convert[model].channels;
          delete convert[model].labels;
          Object.defineProperty(convert[model], "channels", { value: channels });
          Object.defineProperty(convert[model], "labels", { value: labels });
        }
      }
      var channels;
      var labels;
      var model;
      convert.rgb.hsl = function(rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var min2 = Math.min(r, g, b);
        var max2 = Math.max(r, g, b);
        var delta = max2 - min2;
        var h;
        var s;
        var l;
        if (max2 === min2) {
          h = 0;
        } else if (r === max2) {
          h = (g - b) / delta;
        } else if (g === max2) {
          h = 2 + (b - r) / delta;
        } else if (b === max2) {
          h = 4 + (r - g) / delta;
        }
        h = Math.min(h * 60, 360);
        if (h < 0) {
          h += 360;
        }
        l = (min2 + max2) / 2;
        if (max2 === min2) {
          s = 0;
        } else if (l <= 0.5) {
          s = delta / (max2 + min2);
        } else {
          s = delta / (2 - max2 - min2);
        }
        return [h, s * 100, l * 100];
      };
      convert.rgb.hsv = function(rgb) {
        var rdif;
        var gdif;
        var bdif;
        var h;
        var s;
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var v = Math.max(r, g, b);
        var diff = v - Math.min(r, g, b);
        var diffc = function(c) {
          return (v - c) / 6 / diff + 1 / 2;
        };
        if (diff === 0) {
          h = s = 0;
        } else {
          s = diff / v;
          rdif = diffc(r);
          gdif = diffc(g);
          bdif = diffc(b);
          if (r === v) {
            h = bdif - gdif;
          } else if (g === v) {
            h = 1 / 3 + rdif - bdif;
          } else if (b === v) {
            h = 2 / 3 + gdif - rdif;
          }
          if (h < 0) {
            h += 1;
          } else if (h > 1) {
            h -= 1;
          }
        }
        return [
          h * 360,
          s * 100,
          v * 100
        ];
      };
      convert.rgb.hwb = function(rgb) {
        var r = rgb[0];
        var g = rgb[1];
        var b = rgb[2];
        var h = convert.rgb.hsl(rgb)[0];
        var w = 1 / 255 * Math.min(r, Math.min(g, b));
        b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
        return [h, w * 100, b * 100];
      };
      convert.rgb.cmyk = function(rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var c;
        var m;
        var y;
        var k;
        k = Math.min(1 - r, 1 - g, 1 - b);
        c = (1 - r - k) / (1 - k) || 0;
        m = (1 - g - k) / (1 - k) || 0;
        y = (1 - b - k) / (1 - k) || 0;
        return [c * 100, m * 100, y * 100, k * 100];
      };
      function comparativeDistance(x, y) {
        return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
      }
      convert.rgb.keyword = function(rgb) {
        var reversed = reverseKeywords[rgb];
        if (reversed) {
          return reversed;
        }
        var currentClosestDistance = Infinity;
        var currentClosestKeyword;
        for (var keyword in cssKeywords) {
          if (cssKeywords.hasOwnProperty(keyword)) {
            var value = cssKeywords[keyword];
            var distance = comparativeDistance(rgb, value);
            if (distance < currentClosestDistance) {
              currentClosestDistance = distance;
              currentClosestKeyword = keyword;
            }
          }
        }
        return currentClosestKeyword;
      };
      convert.keyword.rgb = function(keyword) {
        return cssKeywords[keyword];
      };
      convert.rgb.xyz = function(rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
        var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
        var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
        return [x * 100, y * 100, z * 100];
      };
      convert.rgb.lab = function(rgb) {
        var xyz = convert.rgb.xyz(rgb);
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 8856e-6 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 8856e-6 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 8856e-6 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.hsl.rgb = function(hsl) {
        var h = hsl[0] / 360;
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var t1;
        var t22;
        var t3;
        var rgb;
        var val;
        if (s === 0) {
          val = l * 255;
          return [val, val, val];
        }
        if (l < 0.5) {
          t22 = l * (1 + s);
        } else {
          t22 = l + s - l * s;
        }
        t1 = 2 * l - t22;
        rgb = [0, 0, 0];
        for (var i = 0; i < 3; i++) {
          t3 = h + 1 / 3 * -(i - 1);
          if (t3 < 0) {
            t3++;
          }
          if (t3 > 1) {
            t3--;
          }
          if (6 * t3 < 1) {
            val = t1 + (t22 - t1) * 6 * t3;
          } else if (2 * t3 < 1) {
            val = t22;
          } else if (3 * t3 < 2) {
            val = t1 + (t22 - t1) * (2 / 3 - t3) * 6;
          } else {
            val = t1;
          }
          rgb[i] = val * 255;
        }
        return rgb;
      };
      convert.hsl.hsv = function(hsl) {
        var h = hsl[0];
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var smin = s;
        var lmin = Math.max(l, 0.01);
        var sv;
        var v;
        l *= 2;
        s *= l <= 1 ? l : 2 - l;
        smin *= lmin <= 1 ? lmin : 2 - lmin;
        v = (l + s) / 2;
        sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
        return [h, sv * 100, v * 100];
      };
      convert.hsv.rgb = function(hsv) {
        var h = hsv[0] / 60;
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var hi = Math.floor(h) % 6;
        var f = h - Math.floor(h);
        var p = 255 * v * (1 - s);
        var q = 255 * v * (1 - s * f);
        var t3 = 255 * v * (1 - s * (1 - f));
        v *= 255;
        switch (hi) {
          case 0:
            return [v, t3, p];
          case 1:
            return [q, v, p];
          case 2:
            return [p, v, t3];
          case 3:
            return [p, q, v];
          case 4:
            return [t3, p, v];
          case 5:
            return [v, p, q];
        }
      };
      convert.hsv.hsl = function(hsv) {
        var h = hsv[0];
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var vmin = Math.max(v, 0.01);
        var lmin;
        var sl;
        var l;
        l = (2 - s) * v;
        lmin = (2 - s) * vmin;
        sl = s * vmin;
        sl /= lmin <= 1 ? lmin : 2 - lmin;
        sl = sl || 0;
        l /= 2;
        return [h, sl * 100, l * 100];
      };
      convert.hwb.rgb = function(hwb) {
        var h = hwb[0] / 360;
        var wh = hwb[1] / 100;
        var bl = hwb[2] / 100;
        var ratio = wh + bl;
        var i;
        var v;
        var f;
        var n;
        if (ratio > 1) {
          wh /= ratio;
          bl /= ratio;
        }
        i = Math.floor(6 * h);
        v = 1 - bl;
        f = 6 * h - i;
        if ((i & 1) !== 0) {
          f = 1 - f;
        }
        n = wh + f * (v - wh);
        var r;
        var g;
        var b;
        switch (i) {
          default:
          case 6:
          case 0:
            r = v;
            g = n;
            b = wh;
            break;
          case 1:
            r = n;
            g = v;
            b = wh;
            break;
          case 2:
            r = wh;
            g = v;
            b = n;
            break;
          case 3:
            r = wh;
            g = n;
            b = v;
            break;
          case 4:
            r = n;
            g = wh;
            b = v;
            break;
          case 5:
            r = v;
            g = wh;
            b = n;
            break;
        }
        return [r * 255, g * 255, b * 255];
      };
      convert.cmyk.rgb = function(cmyk) {
        var c = cmyk[0] / 100;
        var m = cmyk[1] / 100;
        var y = cmyk[2] / 100;
        var k = cmyk[3] / 100;
        var r;
        var g;
        var b;
        r = 1 - Math.min(1, c * (1 - k) + k);
        g = 1 - Math.min(1, m * (1 - k) + k);
        b = 1 - Math.min(1, y * (1 - k) + k);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.rgb = function(xyz) {
        var x = xyz[0] / 100;
        var y = xyz[1] / 100;
        var z = xyz[2] / 100;
        var r;
        var g;
        var b;
        r = x * 3.2406 + y * -1.5372 + z * -0.4986;
        g = x * -0.9689 + y * 1.8758 + z * 0.0415;
        b = x * 0.0557 + y * -0.204 + z * 1.057;
        r = r > 31308e-7 ? 1.055 * Math.pow(r, 1 / 2.4) - 0.055 : r * 12.92;
        g = g > 31308e-7 ? 1.055 * Math.pow(g, 1 / 2.4) - 0.055 : g * 12.92;
        b = b > 31308e-7 ? 1.055 * Math.pow(b, 1 / 2.4) - 0.055 : b * 12.92;
        r = Math.min(Math.max(0, r), 1);
        g = Math.min(Math.max(0, g), 1);
        b = Math.min(Math.max(0, b), 1);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.lab = function(xyz) {
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 8856e-6 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 8856e-6 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 8856e-6 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.lab.xyz = function(lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var x;
        var y;
        var z;
        y = (l + 16) / 116;
        x = a / 500 + y;
        z = y - b / 200;
        var y2 = Math.pow(y, 3);
        var x2 = Math.pow(x, 3);
        var z2 = Math.pow(z, 3);
        y = y2 > 8856e-6 ? y2 : (y - 16 / 116) / 7.787;
        x = x2 > 8856e-6 ? x2 : (x - 16 / 116) / 7.787;
        z = z2 > 8856e-6 ? z2 : (z - 16 / 116) / 7.787;
        x *= 95.047;
        y *= 100;
        z *= 108.883;
        return [x, y, z];
      };
      convert.lab.lch = function(lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var hr;
        var h;
        var c;
        hr = Math.atan2(b, a);
        h = hr * 360 / 2 / Math.PI;
        if (h < 0) {
          h += 360;
        }
        c = Math.sqrt(a * a + b * b);
        return [l, c, h];
      };
      convert.lch.lab = function(lch) {
        var l = lch[0];
        var c = lch[1];
        var h = lch[2];
        var a;
        var b;
        var hr;
        hr = h / 360 * 2 * Math.PI;
        a = c * Math.cos(hr);
        b = c * Math.sin(hr);
        return [l, a, b];
      };
      convert.rgb.ansi16 = function(args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2];
        value = Math.round(value / 50);
        if (value === 0) {
          return 30;
        }
        var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
        if (value === 2) {
          ansi += 60;
        }
        return ansi;
      };
      convert.hsv.ansi16 = function(args) {
        return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
      };
      convert.rgb.ansi256 = function(args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        if (r === g && g === b) {
          if (r < 8) {
            return 16;
          }
          if (r > 248) {
            return 231;
          }
          return Math.round((r - 8) / 247 * 24) + 232;
        }
        var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
        return ansi;
      };
      convert.ansi16.rgb = function(args) {
        var color = args % 10;
        if (color === 0 || color === 7) {
          if (args > 50) {
            color += 3.5;
          }
          color = color / 10.5 * 255;
          return [color, color, color];
        }
        var mult = (~~(args > 50) + 1) * 0.5;
        var r = (color & 1) * mult * 255;
        var g = (color >> 1 & 1) * mult * 255;
        var b = (color >> 2 & 1) * mult * 255;
        return [r, g, b];
      };
      convert.ansi256.rgb = function(args) {
        if (args >= 232) {
          var c = (args - 232) * 10 + 8;
          return [c, c, c];
        }
        args -= 16;
        var rem;
        var r = Math.floor(args / 36) / 5 * 255;
        var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
        var b = rem % 6 / 5 * 255;
        return [r, g, b];
      };
      convert.rgb.hex = function(args) {
        var integer = ((Math.round(args[0]) & 255) << 16) + ((Math.round(args[1]) & 255) << 8) + (Math.round(args[2]) & 255);
        var string = integer.toString(16).toUpperCase();
        return "000000".substring(string.length) + string;
      };
      convert.hex.rgb = function(args) {
        var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
        if (!match) {
          return [0, 0, 0];
        }
        var colorString = match[0];
        if (match[0].length === 3) {
          colorString = colorString.split("").map(function(char) {
            return char + char;
          }).join("");
        }
        var integer = parseInt(colorString, 16);
        var r = integer >> 16 & 255;
        var g = integer >> 8 & 255;
        var b = integer & 255;
        return [r, g, b];
      };
      convert.rgb.hcg = function(rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var max2 = Math.max(Math.max(r, g), b);
        var min2 = Math.min(Math.min(r, g), b);
        var chroma = max2 - min2;
        var grayscale;
        var hue;
        if (chroma < 1) {
          grayscale = min2 / (1 - chroma);
        } else {
          grayscale = 0;
        }
        if (chroma <= 0) {
          hue = 0;
        } else if (max2 === r) {
          hue = (g - b) / chroma % 6;
        } else if (max2 === g) {
          hue = 2 + (b - r) / chroma;
        } else {
          hue = 4 + (r - g) / chroma + 4;
        }
        hue /= 6;
        hue %= 1;
        return [hue * 360, chroma * 100, grayscale * 100];
      };
      convert.hsl.hcg = function(hsl) {
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var c = 1;
        var f = 0;
        if (l < 0.5) {
          c = 2 * s * l;
        } else {
          c = 2 * s * (1 - l);
        }
        if (c < 1) {
          f = (l - 0.5 * c) / (1 - c);
        }
        return [hsl[0], c * 100, f * 100];
      };
      convert.hsv.hcg = function(hsv) {
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var c = s * v;
        var f = 0;
        if (c < 1) {
          f = (v - c) / (1 - c);
        }
        return [hsv[0], c * 100, f * 100];
      };
      convert.hcg.rgb = function(hcg) {
        var h = hcg[0] / 360;
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        if (c === 0) {
          return [g * 255, g * 255, g * 255];
        }
        var pure = [0, 0, 0];
        var hi = h % 1 * 6;
        var v = hi % 1;
        var w = 1 - v;
        var mg = 0;
        switch (Math.floor(hi)) {
          case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
          case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
          case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
          case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
          case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
          default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
        }
        mg = (1 - c) * g;
        return [
          (c * pure[0] + mg) * 255,
          (c * pure[1] + mg) * 255,
          (c * pure[2] + mg) * 255
        ];
      };
      convert.hcg.hsv = function(hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1 - c);
        var f = 0;
        if (v > 0) {
          f = c / v;
        }
        return [hcg[0], f * 100, v * 100];
      };
      convert.hcg.hsl = function(hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var l = g * (1 - c) + 0.5 * c;
        var s = 0;
        if (l > 0 && l < 0.5) {
          s = c / (2 * l);
        } else if (l >= 0.5 && l < 1) {
          s = c / (2 * (1 - l));
        }
        return [hcg[0], s * 100, l * 100];
      };
      convert.hcg.hwb = function(hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1 - c);
        return [hcg[0], (v - c) * 100, (1 - v) * 100];
      };
      convert.hwb.hcg = function(hwb) {
        var w = hwb[1] / 100;
        var b = hwb[2] / 100;
        var v = 1 - b;
        var c = v - w;
        var g = 0;
        if (c < 1) {
          g = (v - c) / (1 - c);
        }
        return [hwb[0], c * 100, g * 100];
      };
      convert.apple.rgb = function(apple) {
        return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
      };
      convert.rgb.apple = function(rgb) {
        return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
      };
      convert.gray.rgb = function(args) {
        return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
      };
      convert.gray.hsl = convert.gray.hsv = function(args) {
        return [0, 0, args[0]];
      };
      convert.gray.hwb = function(gray) {
        return [0, 100, gray[0]];
      };
      convert.gray.cmyk = function(gray) {
        return [0, 0, 0, gray[0]];
      };
      convert.gray.lab = function(gray) {
        return [gray[0], 0, 0];
      };
      convert.gray.hex = function(gray) {
        var val = Math.round(gray[0] / 100 * 255) & 255;
        var integer = (val << 16) + (val << 8) + val;
        var string = integer.toString(16).toUpperCase();
        return "000000".substring(string.length) + string;
      };
      convert.rgb.gray = function(rgb) {
        var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
        return [val / 255 * 100];
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/color-convert/route.js
  var require_route = __commonJS({
    "node_modules/@babel/highlight/node_modules/color-convert/route.js"(exports2, module2) {
      init_define_process();
      var conversions = require_conversions();
      function buildGraph() {
        var graph = {};
        var models = Object.keys(conversions);
        for (var len = models.length, i = 0; i < len; i++) {
          graph[models[i]] = {
            distance: -1,
            parent: null
          };
        }
        return graph;
      }
      function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [fromModel];
        graph[fromModel].distance = 0;
        while (queue.length) {
          var current = queue.pop();
          var adjacents = Object.keys(conversions[current]);
          for (var len = adjacents.length, i = 0; i < len; i++) {
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
              node.distance = graph[current].distance + 1;
              node.parent = current;
              queue.unshift(adjacent);
            }
          }
        }
        return graph;
      }
      function link(from, to) {
        return function(args) {
          return to(from(args));
        };
      }
      function wrapConversion(toModel, graph) {
        var path = [graph[toModel].parent, toModel];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while (graph[cur].parent) {
          path.unshift(graph[cur].parent);
          fn = link(conversions[graph[cur].parent][cur], fn);
          cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
      }
      module2.exports = function(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for (var len = models.length, i = 0; i < len; i++) {
          var toModel = models[i];
          var node = graph[toModel];
          if (node.parent === null) {
            continue;
          }
          conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/color-convert/index.js
  var require_color_convert = __commonJS({
    "node_modules/@babel/highlight/node_modules/color-convert/index.js"(exports2, module2) {
      init_define_process();
      var conversions = require_conversions();
      var route = require_route();
      var convert = {};
      var models = Object.keys(conversions);
      function wrapRaw(fn) {
        var wrappedFn = function(args) {
          if (args === void 0 || args === null) {
            return args;
          }
          if (arguments.length > 1) {
            args = Array.prototype.slice.call(arguments);
          }
          return fn(args);
        };
        if ("conversion" in fn) {
          wrappedFn.conversion = fn.conversion;
        }
        return wrappedFn;
      }
      function wrapRounded(fn) {
        var wrappedFn = function(args) {
          if (args === void 0 || args === null) {
            return args;
          }
          if (arguments.length > 1) {
            args = Array.prototype.slice.call(arguments);
          }
          var result2 = fn(args);
          if (typeof result2 === "object") {
            for (var len = result2.length, i = 0; i < len; i++) {
              result2[i] = Math.round(result2[i]);
            }
          }
          return result2;
        };
        if ("conversion" in fn) {
          wrappedFn.conversion = fn.conversion;
        }
        return wrappedFn;
      }
      models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], "channels", { value: conversions[fromModel].channels });
        Object.defineProperty(convert[fromModel], "labels", { value: conversions[fromModel].labels });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
          var fn = routes[toModel];
          convert[fromModel][toModel] = wrapRounded(fn);
          convert[fromModel][toModel].raw = wrapRaw(fn);
        });
      });
      module2.exports = convert;
    }
  });

  // node_modules/@babel/highlight/node_modules/ansi-styles/index.js
  var require_ansi_styles = __commonJS({
    "node_modules/@babel/highlight/node_modules/ansi-styles/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var colorConvert = require_color_convert();
      var wrapAnsi16 = (fn, offset) => function() {
        const code = fn.apply(colorConvert, arguments);
        return `\x1B[${code + offset}m`;
      };
      var wrapAnsi256 = (fn, offset) => function() {
        const code = fn.apply(colorConvert, arguments);
        return `\x1B[${38 + offset};5;${code}m`;
      };
      var wrapAnsi16m = (fn, offset) => function() {
        const rgb = fn.apply(colorConvert, arguments);
        return `\x1B[${38 + offset};2;${rgb[0]};${rgb[1]};${rgb[2]}m`;
      };
      function assembleStyles() {
        const codes = /* @__PURE__ */ new Map();
        const styles = {
          modifier: {
            reset: [0, 0],
            bold: [1, 22],
            dim: [2, 22],
            italic: [3, 23],
            underline: [4, 24],
            inverse: [7, 27],
            hidden: [8, 28],
            strikethrough: [9, 29]
          },
          color: {
            black: [30, 39],
            red: [31, 39],
            green: [32, 39],
            yellow: [33, 39],
            blue: [34, 39],
            magenta: [35, 39],
            cyan: [36, 39],
            white: [37, 39],
            gray: [90, 39],
            redBright: [91, 39],
            greenBright: [92, 39],
            yellowBright: [93, 39],
            blueBright: [94, 39],
            magentaBright: [95, 39],
            cyanBright: [96, 39],
            whiteBright: [97, 39]
          },
          bgColor: {
            bgBlack: [40, 49],
            bgRed: [41, 49],
            bgGreen: [42, 49],
            bgYellow: [43, 49],
            bgBlue: [44, 49],
            bgMagenta: [45, 49],
            bgCyan: [46, 49],
            bgWhite: [47, 49],
            bgBlackBright: [100, 49],
            bgRedBright: [101, 49],
            bgGreenBright: [102, 49],
            bgYellowBright: [103, 49],
            bgBlueBright: [104, 49],
            bgMagentaBright: [105, 49],
            bgCyanBright: [106, 49],
            bgWhiteBright: [107, 49]
          }
        };
        styles.color.grey = styles.color.gray;
        for (const groupName of Object.keys(styles)) {
          const group = styles[groupName];
          for (const styleName of Object.keys(group)) {
            const style = group[styleName];
            styles[styleName] = {
              open: `\x1B[${style[0]}m`,
              close: `\x1B[${style[1]}m`
            };
            group[styleName] = styles[styleName];
            codes.set(style[0], style[1]);
          }
          Object.defineProperty(styles, groupName, {
            value: group,
            enumerable: false
          });
          Object.defineProperty(styles, "codes", {
            value: codes,
            enumerable: false
          });
        }
        const ansi2ansi = (n) => n;
        const rgb2rgb = (r, g, b) => [r, g, b];
        styles.color.close = "\x1B[39m";
        styles.bgColor.close = "\x1B[49m";
        styles.color.ansi = {
          ansi: wrapAnsi16(ansi2ansi, 0)
        };
        styles.color.ansi256 = {
          ansi256: wrapAnsi256(ansi2ansi, 0)
        };
        styles.color.ansi16m = {
          rgb: wrapAnsi16m(rgb2rgb, 0)
        };
        styles.bgColor.ansi = {
          ansi: wrapAnsi16(ansi2ansi, 10)
        };
        styles.bgColor.ansi256 = {
          ansi256: wrapAnsi256(ansi2ansi, 10)
        };
        styles.bgColor.ansi16m = {
          rgb: wrapAnsi16m(rgb2rgb, 10)
        };
        for (let key of Object.keys(colorConvert)) {
          if (typeof colorConvert[key] !== "object") {
            continue;
          }
          const suite = colorConvert[key];
          if (key === "ansi16") {
            key = "ansi";
          }
          if ("ansi16" in suite) {
            styles.color.ansi[key] = wrapAnsi16(suite.ansi16, 0);
            styles.bgColor.ansi[key] = wrapAnsi16(suite.ansi16, 10);
          }
          if ("ansi256" in suite) {
            styles.color.ansi256[key] = wrapAnsi256(suite.ansi256, 0);
            styles.bgColor.ansi256[key] = wrapAnsi256(suite.ansi256, 10);
          }
          if ("rgb" in suite) {
            styles.color.ansi16m[key] = wrapAnsi16m(suite.rgb, 0);
            styles.bgColor.ansi16m[key] = wrapAnsi16m(suite.rgb, 10);
          }
        }
        return styles;
      }
      Object.defineProperty(module2, "exports", {
        enumerable: true,
        get: assembleStyles
      });
    }
  });

  // node_modules/@babel/highlight/node_modules/supports-color/browser.js
  var require_browser3 = __commonJS({
    "node_modules/@babel/highlight/node_modules/supports-color/browser.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = {
        stdout: false,
        stderr: false
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/chalk/templates.js
  var require_templates = __commonJS({
    "node_modules/@babel/highlight/node_modules/chalk/templates.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var TEMPLATE_REGEX = /(?:\\(u[a-f\d]{4}|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi;
      var STYLE_REGEX = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g;
      var STRING_REGEX = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/;
      var ESCAPE_REGEX = /\\(u[a-f\d]{4}|x[a-f\d]{2}|.)|([^\\])/gi;
      var ESCAPES = /* @__PURE__ */ new Map([
        ["n", "\n"],
        ["r", "\r"],
        ["t", "	"],
        ["b", "\b"],
        ["f", "\f"],
        ["v", "\v"],
        ["0", "\0"],
        ["\\", "\\"],
        ["e", "\x1B"],
        ["a", "\x07"]
      ]);
      function unescape2(c) {
        if (c[0] === "u" && c.length === 5 || c[0] === "x" && c.length === 3) {
          return String.fromCharCode(parseInt(c.slice(1), 16));
        }
        return ESCAPES.get(c) || c;
      }
      function parseArguments(name, args) {
        const results = [];
        const chunks = args.trim().split(/\s*,\s*/g);
        let matches2;
        for (const chunk2 of chunks) {
          if (!isNaN(chunk2)) {
            results.push(Number(chunk2));
          } else if (matches2 = chunk2.match(STRING_REGEX)) {
            results.push(matches2[2].replace(ESCAPE_REGEX, (m, escape2, chr) => escape2 ? unescape2(escape2) : chr));
          } else {
            throw new Error(`Invalid Chalk template style argument: ${chunk2} (in style '${name}')`);
          }
        }
        return results;
      }
      function parseStyle(style) {
        STYLE_REGEX.lastIndex = 0;
        const results = [];
        let matches2;
        while ((matches2 = STYLE_REGEX.exec(style)) !== null) {
          const name = matches2[1];
          if (matches2[2]) {
            const args = parseArguments(name, matches2[2]);
            results.push([name].concat(args));
          } else {
            results.push([name]);
          }
        }
        return results;
      }
      function buildStyle(chalk, styles) {
        const enabled = {};
        for (const layer of styles) {
          for (const style of layer.styles) {
            enabled[style[0]] = layer.inverse ? null : style.slice(1);
          }
        }
        let current = chalk;
        for (const styleName of Object.keys(enabled)) {
          if (Array.isArray(enabled[styleName])) {
            if (!(styleName in current)) {
              throw new Error(`Unknown Chalk style: ${styleName}`);
            }
            if (enabled[styleName].length > 0) {
              current = current[styleName].apply(current, enabled[styleName]);
            } else {
              current = current[styleName];
            }
          }
        }
        return current;
      }
      module2.exports = (chalk, tmp) => {
        const styles = [];
        const chunks = [];
        let chunk2 = [];
        tmp.replace(TEMPLATE_REGEX, (m, escapeChar, inverse, style, close, chr) => {
          if (escapeChar) {
            chunk2.push(unescape2(escapeChar));
          } else if (style) {
            const str = chunk2.join("");
            chunk2 = [];
            chunks.push(styles.length === 0 ? str : buildStyle(chalk, styles)(str));
            styles.push({ inverse, styles: parseStyle(style) });
          } else if (close) {
            if (styles.length === 0) {
              throw new Error("Found extraneous } in Chalk template literal");
            }
            chunks.push(buildStyle(chalk, styles)(chunk2.join("")));
            chunk2 = [];
            styles.pop();
          } else {
            chunk2.push(chr);
          }
        });
        chunks.push(chunk2.join(""));
        if (styles.length > 0) {
          const errMsg = `Chalk template literal is missing ${styles.length} closing bracket${styles.length === 1 ? "" : "s"} (\`}\`)`;
          throw new Error(errMsg);
        }
        return chunks.join("");
      };
    }
  });

  // node_modules/@babel/highlight/node_modules/chalk/index.js
  var require_chalk = __commonJS({
    "node_modules/@babel/highlight/node_modules/chalk/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var escapeStringRegexp = require_escape_string_regexp();
      var ansiStyles = require_ansi_styles();
      var stdoutColor = require_browser3().stdout;
      var template2 = require_templates();
      var isSimpleWindowsTerm = define_process_default.platform === "win32" && !(define_process_default.env.TERM || "").toLowerCase().startsWith("xterm");
      var levelMapping = ["ansi", "ansi", "ansi256", "ansi16m"];
      var skipModels = /* @__PURE__ */ new Set(["gray"]);
      var styles = /* @__PURE__ */ Object.create(null);
      function applyOptions(obj, options) {
        options = options || {};
        const scLevel = stdoutColor ? stdoutColor.level : 0;
        obj.level = options.level === void 0 ? scLevel : options.level;
        obj.enabled = "enabled" in options ? options.enabled : obj.level > 0;
      }
      function Chalk(options) {
        if (!this || !(this instanceof Chalk) || this.template) {
          const chalk = {};
          applyOptions(chalk, options);
          chalk.template = function() {
            const args = [].slice.call(arguments);
            return chalkTag.apply(null, [chalk.template].concat(args));
          };
          Object.setPrototypeOf(chalk, Chalk.prototype);
          Object.setPrototypeOf(chalk.template, chalk);
          chalk.template.constructor = Chalk;
          return chalk.template;
        }
        applyOptions(this, options);
      }
      if (isSimpleWindowsTerm) {
        ansiStyles.blue.open = "\x1B[94m";
      }
      for (const key of Object.keys(ansiStyles)) {
        ansiStyles[key].closeRe = new RegExp(escapeStringRegexp(ansiStyles[key].close), "g");
        styles[key] = {
          get() {
            const codes = ansiStyles[key];
            return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, key);
          }
        };
      }
      styles.visible = {
        get() {
          return build.call(this, this._styles || [], true, "visible");
        }
      };
      ansiStyles.color.closeRe = new RegExp(escapeStringRegexp(ansiStyles.color.close), "g");
      for (const model of Object.keys(ansiStyles.color.ansi)) {
        if (skipModels.has(model)) {
          continue;
        }
        styles[model] = {
          get() {
            const level = this.level;
            return function() {
              const open = ansiStyles.color[levelMapping[level]][model].apply(null, arguments);
              const codes = {
                open,
                close: ansiStyles.color.close,
                closeRe: ansiStyles.color.closeRe
              };
              return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, model);
            };
          }
        };
      }
      ansiStyles.bgColor.closeRe = new RegExp(escapeStringRegexp(ansiStyles.bgColor.close), "g");
      for (const model of Object.keys(ansiStyles.bgColor.ansi)) {
        if (skipModels.has(model)) {
          continue;
        }
        const bgModel = "bg" + model[0].toUpperCase() + model.slice(1);
        styles[bgModel] = {
          get() {
            const level = this.level;
            return function() {
              const open = ansiStyles.bgColor[levelMapping[level]][model].apply(null, arguments);
              const codes = {
                open,
                close: ansiStyles.bgColor.close,
                closeRe: ansiStyles.bgColor.closeRe
              };
              return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, model);
            };
          }
        };
      }
      var proto = Object.defineProperties(() => {
      }, styles);
      function build(_styles, _empty, key) {
        const builder = function() {
          return applyStyle.apply(builder, arguments);
        };
        builder._styles = _styles;
        builder._empty = _empty;
        const self2 = this;
        Object.defineProperty(builder, "level", {
          enumerable: true,
          get() {
            return self2.level;
          },
          set(level) {
            self2.level = level;
          }
        });
        Object.defineProperty(builder, "enabled", {
          enumerable: true,
          get() {
            return self2.enabled;
          },
          set(enabled) {
            self2.enabled = enabled;
          }
        });
        builder.hasGrey = this.hasGrey || key === "gray" || key === "grey";
        builder.__proto__ = proto;
        return builder;
      }
      function applyStyle() {
        const args = arguments;
        const argsLen = args.length;
        let str = String(arguments[0]);
        if (argsLen === 0) {
          return "";
        }
        if (argsLen > 1) {
          for (let a = 1; a < argsLen; a++) {
            str += " " + args[a];
          }
        }
        if (!this.enabled || this.level <= 0 || !str) {
          return this._empty ? "" : str;
        }
        const originalDim = ansiStyles.dim.open;
        if (isSimpleWindowsTerm && this.hasGrey) {
          ansiStyles.dim.open = "";
        }
        for (const code of this._styles.slice().reverse()) {
          str = code.open + str.replace(code.closeRe, code.open) + code.close;
          str = str.replace(/\r?\n/g, `${code.close}$&${code.open}`);
        }
        ansiStyles.dim.open = originalDim;
        return str;
      }
      function chalkTag(chalk, strings) {
        if (!Array.isArray(strings)) {
          return [].slice.call(arguments, 1).join(" ");
        }
        const args = [].slice.call(arguments, 2);
        const parts = [strings.raw[0]];
        for (let i = 1; i < strings.length; i++) {
          parts.push(String(args[i - 1]).replace(/[{}\\]/g, "\\$&"));
          parts.push(String(strings.raw[i]));
        }
        return template2(chalk, parts.join(""));
      }
      Object.defineProperties(Chalk.prototype, styles);
      module2.exports = Chalk();
      module2.exports.supportsColor = stdoutColor;
      module2.exports.default = module2.exports;
    }
  });

  // node_modules/@babel/highlight/lib/index.js
  var require_lib9 = __commonJS({
    "node_modules/@babel/highlight/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = highlight;
      exports2.getChalk = getChalk;
      exports2.shouldHighlight = shouldHighlight;
      var _jsTokens = require_js_tokens();
      var _helperValidatorIdentifier = require_lib3();
      var _chalk = require_chalk();
      var sometimesKeywords = /* @__PURE__ */ new Set(["as", "async", "from", "get", "of", "set"]);
      function getDefs(chalk) {
        return {
          keyword: chalk.cyan,
          capitalized: chalk.yellow,
          jsxIdentifier: chalk.yellow,
          punctuator: chalk.yellow,
          number: chalk.magenta,
          string: chalk.green,
          regex: chalk.magenta,
          comment: chalk.grey,
          invalid: chalk.white.bgRed.bold
        };
      }
      var NEWLINE = /\r\n|[\n\r\u2028\u2029]/;
      var BRACKET = /^[()[\]{}]$/;
      var tokenize;
      {
        const JSX_TAG = /^[a-z][\w-]*$/i;
        const getTokenType = function(token, offset, text) {
          if (token.type === "name") {
            if ((0, _helperValidatorIdentifier.isKeyword)(token.value) || (0, _helperValidatorIdentifier.isStrictReservedWord)(token.value, true) || sometimesKeywords.has(token.value)) {
              return "keyword";
            }
            if (JSX_TAG.test(token.value) && (text[offset - 1] === "<" || text.slice(offset - 2, offset) == "</")) {
              return "jsxIdentifier";
            }
            if (token.value[0] !== token.value[0].toLowerCase()) {
              return "capitalized";
            }
          }
          if (token.type === "punctuator" && BRACKET.test(token.value)) {
            return "bracket";
          }
          if (token.type === "invalid" && (token.value === "@" || token.value === "#")) {
            return "punctuator";
          }
          return token.type;
        };
        tokenize = function* (text) {
          let match;
          while (match = _jsTokens.default.exec(text)) {
            const token = _jsTokens.matchToToken(match);
            yield {
              type: getTokenType(token, match.index, text),
              value: token.value
            };
          }
        };
      }
      function highlightTokens(defs, text) {
        let highlighted = "";
        for (const {
          type,
          value
        } of tokenize(text)) {
          const colorize = defs[type];
          if (colorize) {
            highlighted += value.split(NEWLINE).map((str) => colorize(str)).join("\n");
          } else {
            highlighted += value;
          }
        }
        return highlighted;
      }
      function shouldHighlight(options) {
        return !!_chalk.supportsColor || options.forceColor;
      }
      function getChalk(options) {
        return options.forceColor ? new _chalk.constructor({
          enabled: true,
          level: 1
        }) : _chalk;
      }
      function highlight(code, options = {}) {
        if (code !== "" && shouldHighlight(options)) {
          const chalk = getChalk(options);
          const defs = getDefs(chalk);
          return highlightTokens(defs, code);
        } else {
          return code;
        }
      }
    }
  });

  // node_modules/@babel/code-frame/lib/index.js
  var require_lib10 = __commonJS({
    "node_modules/@babel/code-frame/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.codeFrameColumns = codeFrameColumns;
      exports2.default = _default;
      var _highlight = require_lib9();
      var deprecationWarningShown = false;
      function getDefs(chalk) {
        return {
          gutter: chalk.grey,
          marker: chalk.red.bold,
          message: chalk.red.bold
        };
      }
      var NEWLINE = /\r\n|[\n\r\u2028\u2029]/;
      function getMarkerLines(loc, source, opts) {
        const startLoc = Object.assign({
          column: 0,
          line: -1
        }, loc.start);
        const endLoc = Object.assign({}, startLoc, loc.end);
        const {
          linesAbove = 2,
          linesBelow = 3
        } = opts || {};
        const startLine = startLoc.line;
        const startColumn = startLoc.column;
        const endLine = endLoc.line;
        const endColumn = endLoc.column;
        let start = Math.max(startLine - (linesAbove + 1), 0);
        let end = Math.min(source.length, endLine + linesBelow);
        if (startLine === -1) {
          start = 0;
        }
        if (endLine === -1) {
          end = source.length;
        }
        const lineDiff = endLine - startLine;
        const markerLines = {};
        if (lineDiff) {
          for (let i = 0; i <= lineDiff; i++) {
            const lineNumber = i + startLine;
            if (!startColumn) {
              markerLines[lineNumber] = true;
            } else if (i === 0) {
              const sourceLength = source[lineNumber - 1].length;
              markerLines[lineNumber] = [startColumn, sourceLength - startColumn + 1];
            } else if (i === lineDiff) {
              markerLines[lineNumber] = [0, endColumn];
            } else {
              const sourceLength = source[lineNumber - i].length;
              markerLines[lineNumber] = [0, sourceLength];
            }
          }
        } else {
          if (startColumn === endColumn) {
            if (startColumn) {
              markerLines[startLine] = [startColumn, 0];
            } else {
              markerLines[startLine] = true;
            }
          } else {
            markerLines[startLine] = [startColumn, endColumn - startColumn];
          }
        }
        return {
          start,
          end,
          markerLines
        };
      }
      function codeFrameColumns(rawLines, loc, opts = {}) {
        const highlighted = (opts.highlightCode || opts.forceColor) && (0, _highlight.shouldHighlight)(opts);
        const chalk = (0, _highlight.getChalk)(opts);
        const defs = getDefs(chalk);
        const maybeHighlight = (chalkFn, string) => {
          return highlighted ? chalkFn(string) : string;
        };
        const lines = rawLines.split(NEWLINE);
        const {
          start,
          end,
          markerLines
        } = getMarkerLines(loc, lines, opts);
        const hasColumns = loc.start && typeof loc.start.column === "number";
        const numberMaxWidth = String(end).length;
        const highlightedLines = highlighted ? (0, _highlight.default)(rawLines, opts) : rawLines;
        let frame = highlightedLines.split(NEWLINE, end).slice(start, end).map((line, index) => {
          const number = start + 1 + index;
          const paddedNumber = ` ${number}`.slice(-numberMaxWidth);
          const gutter = ` ${paddedNumber} |`;
          const hasMarker = markerLines[number];
          const lastMarkerLine = !markerLines[number + 1];
          if (hasMarker) {
            let markerLine = "";
            if (Array.isArray(hasMarker)) {
              const markerSpacing = line.slice(0, Math.max(hasMarker[0] - 1, 0)).replace(/[^\t]/g, " ");
              const numberOfMarkers = hasMarker[1] || 1;
              markerLine = ["\n ", maybeHighlight(defs.gutter, gutter.replace(/\d/g, " ")), " ", markerSpacing, maybeHighlight(defs.marker, "^").repeat(numberOfMarkers)].join("");
              if (lastMarkerLine && opts.message) {
                markerLine += " " + maybeHighlight(defs.message, opts.message);
              }
            }
            return [maybeHighlight(defs.marker, ">"), maybeHighlight(defs.gutter, gutter), line.length > 0 ? ` ${line}` : "", markerLine].join("");
          } else {
            return ` ${maybeHighlight(defs.gutter, gutter)}${line.length > 0 ? ` ${line}` : ""}`;
          }
        }).join("\n");
        if (opts.message && !hasColumns) {
          frame = `${" ".repeat(numberMaxWidth + 1)}${opts.message}
${frame}`;
        }
        if (highlighted) {
          return chalk.reset(frame);
        } else {
          return frame;
        }
      }
      function _default(rawLines, lineNumber, colNumber, opts = {}) {
        if (!deprecationWarningShown) {
          deprecationWarningShown = true;
          const message = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
          if (define_process_default.emitWarning) {
            define_process_default.emitWarning(message, "DeprecationWarning");
          } else {
            const deprecationError = new Error(message);
            deprecationError.name = "DeprecationWarning";
            console.warn(new Error(message));
          }
        }
        colNumber = Math.max(colNumber, 0);
        const location = {
          start: {
            column: colNumber,
            line: lineNumber
          }
        };
        return codeFrameColumns(rawLines, location, opts);
      }
    }
  });

  // node_modules/@babel/helper-hoist-variables/lib/index.js
  var require_lib11 = __commonJS({
    "node_modules/@babel/helper-hoist-variables/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = hoistVariables;
      var _t = require_lib5();
      var {
        assignmentExpression,
        expressionStatement: expressionStatement2,
        identifier: identifier3
      } = _t;
      var visitor = {
        Scope(path, state) {
          if (state.kind === "let")
            path.skip();
        },
        FunctionParent(path) {
          path.skip();
        },
        VariableDeclaration(path, state) {
          if (state.kind && path.node.kind !== state.kind)
            return;
          const nodes = [];
          const declarations = path.get("declarations");
          let firstId;
          for (const declar of declarations) {
            firstId = declar.node.id;
            if (declar.node.init) {
              nodes.push(expressionStatement2(assignmentExpression("=", declar.node.id, declar.node.init)));
            }
            for (const name of Object.keys(declar.getBindingIdentifiers())) {
              state.emit(identifier3(name), name, declar.node.init !== null);
            }
          }
          if (path.parentPath.isFor({
            left: path.node
          })) {
            path.replaceWith(firstId);
          } else {
            path.replaceWithMultiple(nodes);
          }
        }
      };
      function hoistVariables(path, emit, kind = "var") {
        path.traverse(visitor, {
          kind,
          emit
        });
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/replacement.js
  var require_replacement = __commonJS({
    "node_modules/@babel/traverse/lib/path/replacement.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._replaceWith = _replaceWith;
      exports2.replaceExpressionWithStatements = replaceExpressionWithStatements;
      exports2.replaceInline = replaceInline;
      exports2.replaceWith = replaceWith;
      exports2.replaceWithMultiple = replaceWithMultiple;
      exports2.replaceWithSourceString = replaceWithSourceString;
      var _codeFrame = require_lib10();
      var _index = require_lib14();
      var _index2 = require_path();
      var _cache = require_cache2();
      var _parser = require_lib2();
      var _t = require_lib5();
      var _helperHoistVariables = require_lib11();
      var {
        FUNCTION_TYPES,
        arrowFunctionExpression: arrowFunctionExpression2,
        assignmentExpression,
        awaitExpression,
        blockStatement,
        callExpression,
        cloneNode,
        expressionStatement: expressionStatement2,
        identifier: identifier3,
        inheritLeadingComments,
        inheritTrailingComments,
        inheritsComments,
        isExpression,
        isProgram,
        isStatement,
        removeComments,
        returnStatement,
        toSequenceExpression,
        validate,
        yieldExpression
      } = _t;
      function replaceWithMultiple(nodes) {
        var _pathCache$get;
        this.resync();
        nodes = this._verifyNodeList(nodes);
        inheritLeadingComments(nodes[0], this.node);
        inheritTrailingComments(nodes[nodes.length - 1], this.node);
        (_pathCache$get = _cache.path.get(this.parent)) == null ? void 0 : _pathCache$get.delete(this.node);
        this.node = this.container[this.key] = null;
        const paths = this.insertAfter(nodes);
        if (this.node) {
          this.requeue();
        } else {
          this.remove();
        }
        return paths;
      }
      function replaceWithSourceString(replacement) {
        this.resync();
        let ast;
        try {
          replacement = `(${replacement})`;
          ast = (0, _parser.parse)(replacement);
        } catch (err) {
          const loc = err.loc;
          if (loc) {
            err.message += " - make sure this is an expression.\n" + (0, _codeFrame.codeFrameColumns)(replacement, {
              start: {
                line: loc.line,
                column: loc.column + 1
              }
            });
            err.code = "BABEL_REPLACE_SOURCE_ERROR";
          }
          throw err;
        }
        const expressionAST = ast.program.body[0].expression;
        _index.default.removeProperties(expressionAST);
        return this.replaceWith(expressionAST);
      }
      function replaceWith(replacementPath) {
        this.resync();
        if (this.removed) {
          throw new Error("You can't replace this node, we've already removed it");
        }
        let replacement = replacementPath instanceof _index2.default ? replacementPath.node : replacementPath;
        if (!replacement) {
          throw new Error("You passed `path.replaceWith()` a falsy node, use `path.remove()` instead");
        }
        if (this.node === replacement) {
          return [this];
        }
        if (this.isProgram() && !isProgram(replacement)) {
          throw new Error("You can only replace a Program root node with another Program node");
        }
        if (Array.isArray(replacement)) {
          throw new Error("Don't use `path.replaceWith()` with an array of nodes, use `path.replaceWithMultiple()`");
        }
        if (typeof replacement === "string") {
          throw new Error("Don't use `path.replaceWith()` with a source string, use `path.replaceWithSourceString()`");
        }
        let nodePath = "";
        if (this.isNodeType("Statement") && isExpression(replacement)) {
          if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement) && !this.parentPath.isExportDefaultDeclaration()) {
            replacement = expressionStatement2(replacement);
            nodePath = "expression";
          }
        }
        if (this.isNodeType("Expression") && isStatement(replacement)) {
          if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement)) {
            return this.replaceExpressionWithStatements([replacement]);
          }
        }
        const oldNode = this.node;
        if (oldNode) {
          inheritsComments(replacement, oldNode);
          removeComments(oldNode);
        }
        this._replaceWith(replacement);
        this.type = replacement.type;
        this.setScope();
        this.requeue();
        return [nodePath ? this.get(nodePath) : this];
      }
      function _replaceWith(node) {
        var _pathCache$get2;
        if (!this.container) {
          throw new ReferenceError("Container is falsy");
        }
        if (this.inList) {
          validate(this.parent, this.key, [node]);
        } else {
          validate(this.parent, this.key, node);
        }
        this.debug(`Replace with ${node == null ? void 0 : node.type}`);
        (_pathCache$get2 = _cache.path.get(this.parent)) == null ? void 0 : _pathCache$get2.set(node, this).delete(this.node);
        this.node = this.container[this.key] = node;
      }
      function replaceExpressionWithStatements(nodes) {
        this.resync();
        const nodesAsSequenceExpression = toSequenceExpression(nodes, this.scope);
        if (nodesAsSequenceExpression) {
          return this.replaceWith(nodesAsSequenceExpression)[0].get("expressions");
        }
        const functionParent = this.getFunctionParent();
        const isParentAsync = functionParent == null ? void 0 : functionParent.is("async");
        const isParentGenerator = functionParent == null ? void 0 : functionParent.is("generator");
        const container = arrowFunctionExpression2([], blockStatement(nodes));
        this.replaceWith(callExpression(container, []));
        const callee = this.get("callee");
        (0, _helperHoistVariables.default)(callee.get("body"), (id) => {
          this.scope.push({
            id
          });
        }, "var");
        const completionRecords = this.get("callee").getCompletionRecords();
        for (const path of completionRecords) {
          if (!path.isExpressionStatement())
            continue;
          const loop = path.findParent((path2) => path2.isLoop());
          if (loop) {
            let uid = loop.getData("expressionReplacementReturnUid");
            if (!uid) {
              uid = callee.scope.generateDeclaredUidIdentifier("ret");
              callee.get("body").pushContainer("body", returnStatement(cloneNode(uid)));
              loop.setData("expressionReplacementReturnUid", uid);
            } else {
              uid = identifier3(uid.name);
            }
            path.get("expression").replaceWith(assignmentExpression("=", cloneNode(uid), path.node.expression));
          } else {
            path.replaceWith(returnStatement(path.node.expression));
          }
        }
        callee.arrowFunctionToExpression();
        const newCallee = callee;
        const needToAwaitFunction = isParentAsync && _index.default.hasType(this.get("callee.body").node, "AwaitExpression", FUNCTION_TYPES);
        const needToYieldFunction = isParentGenerator && _index.default.hasType(this.get("callee.body").node, "YieldExpression", FUNCTION_TYPES);
        if (needToAwaitFunction) {
          newCallee.set("async", true);
          if (!needToYieldFunction) {
            this.replaceWith(awaitExpression(this.node));
          }
        }
        if (needToYieldFunction) {
          newCallee.set("generator", true);
          this.replaceWith(yieldExpression(this.node, true));
        }
        return newCallee.get("body.body");
      }
      function replaceInline(nodes) {
        this.resync();
        if (Array.isArray(nodes)) {
          if (Array.isArray(this.container)) {
            nodes = this._verifyNodeList(nodes);
            const paths = this._containerInsertAfter(nodes);
            this.remove();
            return paths;
          } else {
            return this.replaceWithMultiple(nodes);
          }
        } else {
          return this.replaceWith(nodes);
        }
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/evaluation.js
  var require_evaluation = __commonJS({
    "node_modules/@babel/traverse/lib/path/evaluation.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.evaluate = evaluate;
      exports2.evaluateTruthy = evaluateTruthy;
      var VALID_CALLEES = ["String", "Number", "Math"];
      var INVALID_METHODS = ["random"];
      function isValidCallee(val) {
        return VALID_CALLEES.includes(
          val
        );
      }
      function isInvalidMethod(val) {
        return INVALID_METHODS.includes(
          val
        );
      }
      function evaluateTruthy() {
        const res = this.evaluate();
        if (res.confident)
          return !!res.value;
      }
      function deopt(path, state) {
        if (!state.confident)
          return;
        state.deoptPath = path;
        state.confident = false;
      }
      function evaluateCached(path, state) {
        const {
          node
        } = path;
        const {
          seen
        } = state;
        if (seen.has(node)) {
          const existing = seen.get(node);
          if (existing.resolved) {
            return existing.value;
          } else {
            deopt(path, state);
            return;
          }
        } else {
          const item = {
            resolved: false
          };
          seen.set(node, item);
          const val = _evaluate(path, state);
          if (state.confident) {
            item.resolved = true;
            item.value = val;
          }
          return val;
        }
      }
      function _evaluate(path, state) {
        if (!state.confident)
          return;
        if (path.isSequenceExpression()) {
          const exprs = path.get("expressions");
          return evaluateCached(exprs[exprs.length - 1], state);
        }
        if (path.isStringLiteral() || path.isNumericLiteral() || path.isBooleanLiteral()) {
          return path.node.value;
        }
        if (path.isNullLiteral()) {
          return null;
        }
        if (path.isTemplateLiteral()) {
          return evaluateQuasis(path, path.node.quasis, state);
        }
        if (path.isTaggedTemplateExpression() && path.get("tag").isMemberExpression()) {
          const object = path.get("tag.object");
          const {
            node: {
              name
            }
          } = object;
          const property2 = path.get("tag.property");
          if (object.isIdentifier() && name === "String" && !path.scope.getBinding(name) && property2.isIdentifier() && property2.node.name === "raw") {
            return evaluateQuasis(path, path.node.quasi.quasis, state, true);
          }
        }
        if (path.isConditionalExpression()) {
          const testResult = evaluateCached(path.get("test"), state);
          if (!state.confident)
            return;
          if (testResult) {
            return evaluateCached(path.get("consequent"), state);
          } else {
            return evaluateCached(path.get("alternate"), state);
          }
        }
        if (path.isExpressionWrapper()) {
          return evaluateCached(path.get("expression"), state);
        }
        if (path.isMemberExpression() && !path.parentPath.isCallExpression({
          callee: path.node
        })) {
          const property2 = path.get("property");
          const object = path.get("object");
          if (object.isLiteral() && property2.isIdentifier()) {
            const value = object.node.value;
            const type = typeof value;
            if (type === "number" || type === "string") {
              return value[property2.node.name];
            }
          }
        }
        if (path.isReferencedIdentifier()) {
          const binding = path.scope.getBinding(path.node.name);
          if (binding && binding.constantViolations.length > 0) {
            return deopt(binding.path, state);
          }
          if (binding && path.node.start < binding.path.node.end) {
            return deopt(binding.path, state);
          }
          if (binding != null && binding.hasValue) {
            return binding.value;
          } else {
            if (path.node.name === "undefined") {
              return binding ? deopt(binding.path, state) : void 0;
            } else if (path.node.name === "Infinity") {
              return binding ? deopt(binding.path, state) : Infinity;
            } else if (path.node.name === "NaN") {
              return binding ? deopt(binding.path, state) : NaN;
            }
            const resolved = path.resolve();
            if (resolved === path) {
              return deopt(path, state);
            } else {
              return evaluateCached(resolved, state);
            }
          }
        }
        if (path.isUnaryExpression({
          prefix: true
        })) {
          if (path.node.operator === "void") {
            return void 0;
          }
          const argument = path.get("argument");
          if (path.node.operator === "typeof" && (argument.isFunction() || argument.isClass())) {
            return "function";
          }
          const arg = evaluateCached(argument, state);
          if (!state.confident)
            return;
          switch (path.node.operator) {
            case "!":
              return !arg;
            case "+":
              return +arg;
            case "-":
              return -arg;
            case "~":
              return ~arg;
            case "typeof":
              return typeof arg;
          }
        }
        if (path.isArrayExpression()) {
          const arr = [];
          const elems = path.get("elements");
          for (const elem of elems) {
            const elemValue = elem.evaluate();
            if (elemValue.confident) {
              arr.push(elemValue.value);
            } else {
              return deopt(elemValue.deopt, state);
            }
          }
          return arr;
        }
        if (path.isObjectExpression()) {
          const obj = {};
          const props = path.get("properties");
          for (const prop of props) {
            if (prop.isObjectMethod() || prop.isSpreadElement()) {
              return deopt(prop, state);
            }
            const keyPath = prop.get("key");
            let key;
            if (prop.node.computed) {
              key = keyPath.evaluate();
              if (!key.confident) {
                return deopt(key.deopt, state);
              }
              key = key.value;
            } else if (keyPath.isIdentifier()) {
              key = keyPath.node.name;
            } else {
              key = keyPath.node.value;
            }
            const valuePath = prop.get("value");
            let value = valuePath.evaluate();
            if (!value.confident) {
              return deopt(value.deopt, state);
            }
            value = value.value;
            obj[key] = value;
          }
          return obj;
        }
        if (path.isLogicalExpression()) {
          const wasConfident = state.confident;
          const left = evaluateCached(path.get("left"), state);
          const leftConfident = state.confident;
          state.confident = wasConfident;
          const right = evaluateCached(path.get("right"), state);
          const rightConfident = state.confident;
          switch (path.node.operator) {
            case "||":
              state.confident = leftConfident && (!!left || rightConfident);
              if (!state.confident)
                return;
              return left || right;
            case "&&":
              state.confident = leftConfident && (!left || rightConfident);
              if (!state.confident)
                return;
              return left && right;
            case "??":
              state.confident = leftConfident && (left != null || rightConfident);
              if (!state.confident)
                return;
              return left != null ? left : right;
          }
        }
        if (path.isBinaryExpression()) {
          const left = evaluateCached(path.get("left"), state);
          if (!state.confident)
            return;
          const right = evaluateCached(path.get("right"), state);
          if (!state.confident)
            return;
          switch (path.node.operator) {
            case "-":
              return left - right;
            case "+":
              return left + right;
            case "/":
              return left / right;
            case "*":
              return left * right;
            case "%":
              return left % right;
            case "**":
              return Math.pow(left, right);
            case "<":
              return left < right;
            case ">":
              return left > right;
            case "<=":
              return left <= right;
            case ">=":
              return left >= right;
            case "==":
              return left == right;
            case "!=":
              return left != right;
            case "===":
              return left === right;
            case "!==":
              return left !== right;
            case "|":
              return left | right;
            case "&":
              return left & right;
            case "^":
              return left ^ right;
            case "<<":
              return left << right;
            case ">>":
              return left >> right;
            case ">>>":
              return left >>> right;
          }
        }
        if (path.isCallExpression()) {
          const callee = path.get("callee");
          let context;
          let func;
          if (callee.isIdentifier() && !path.scope.getBinding(callee.node.name) && isValidCallee(callee.node.name)) {
            func = global[callee.node.name];
          }
          if (callee.isMemberExpression()) {
            const object = callee.get("object");
            const property2 = callee.get("property");
            if (object.isIdentifier() && property2.isIdentifier() && isValidCallee(object.node.name) && !isInvalidMethod(property2.node.name)) {
              context = global[object.node.name];
              func = context[property2.node.name];
            }
            if (object.isLiteral() && property2.isIdentifier()) {
              const type = typeof object.node.value;
              if (type === "string" || type === "number") {
                context = object.node.value;
                func = context[property2.node.name];
              }
            }
          }
          if (func) {
            const args = path.get("arguments").map((arg) => evaluateCached(arg, state));
            if (!state.confident)
              return;
            return func.apply(context, args);
          }
        }
        deopt(path, state);
      }
      function evaluateQuasis(path, quasis, state, raw = false) {
        let str = "";
        let i = 0;
        const exprs = path.get("expressions");
        for (const elem of quasis) {
          if (!state.confident)
            break;
          str += raw ? elem.value.raw : elem.value.cooked;
          const expr = exprs[i++];
          if (expr)
            str += String(evaluateCached(expr, state));
        }
        if (!state.confident)
          return;
        return str;
      }
      function evaluate() {
        const state = {
          confident: true,
          deoptPath: null,
          seen: /* @__PURE__ */ new Map()
        };
        let value = evaluateCached(this, state);
        if (!state.confident)
          value = void 0;
        return {
          confident: state.confident,
          deopt: state.deoptPath,
          value
        };
      }
    }
  });

  // node_modules/@babel/template/lib/formatters.js
  var require_formatters = __commonJS({
    "node_modules/@babel/template/lib/formatters.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.statements = exports2.statement = exports2.smart = exports2.program = exports2.expression = void 0;
      var _t = require_lib5();
      var {
        assertExpressionStatement
      } = _t;
      function makeStatementFormatter(fn) {
        return {
          code: (str) => `/* @babel/template */;
${str}`,
          validate: () => {
          },
          unwrap: (ast) => {
            return fn(ast.program.body.slice(1));
          }
        };
      }
      var smart = makeStatementFormatter((body) => {
        if (body.length > 1) {
          return body;
        } else {
          return body[0];
        }
      });
      exports2.smart = smart;
      var statements = makeStatementFormatter((body) => body);
      exports2.statements = statements;
      var statement = makeStatementFormatter((body) => {
        if (body.length === 0) {
          throw new Error("Found nothing to return.");
        }
        if (body.length > 1) {
          throw new Error("Found multiple statements but wanted one");
        }
        return body[0];
      });
      exports2.statement = statement;
      var expression = {
        code: (str) => `(
${str}
)`,
        validate: (ast) => {
          if (ast.program.body.length > 1) {
            throw new Error("Found multiple statements but wanted one");
          }
          if (expression.unwrap(ast).start === 0) {
            throw new Error("Parse result included parens.");
          }
        },
        unwrap: ({
          program: program4
        }) => {
          const [stmt] = program4.body;
          assertExpressionStatement(stmt);
          return stmt.expression;
        }
      };
      exports2.expression = expression;
      var program3 = {
        code: (str) => str,
        validate: () => {
        },
        unwrap: (ast) => ast.program
      };
      exports2.program = program3;
    }
  });

  // node_modules/@babel/template/lib/options.js
  var require_options = __commonJS({
    "node_modules/@babel/template/lib/options.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.merge = merge2;
      exports2.normalizeReplacements = normalizeReplacements;
      exports2.validate = validate;
      var _excluded = ["placeholderWhitelist", "placeholderPattern", "preserveComments", "syntacticPlaceholders"];
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null)
          return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0)
            continue;
          target[key] = source[key];
        }
        return target;
      }
      function merge2(a, b) {
        const {
          placeholderWhitelist = a.placeholderWhitelist,
          placeholderPattern = a.placeholderPattern,
          preserveComments = a.preserveComments,
          syntacticPlaceholders = a.syntacticPlaceholders
        } = b;
        return {
          parser: Object.assign({}, a.parser, b.parser),
          placeholderWhitelist,
          placeholderPattern,
          preserveComments,
          syntacticPlaceholders
        };
      }
      function validate(opts) {
        if (opts != null && typeof opts !== "object") {
          throw new Error("Unknown template options.");
        }
        const _ref = opts || {}, {
          placeholderWhitelist,
          placeholderPattern,
          preserveComments,
          syntacticPlaceholders
        } = _ref, parser3 = _objectWithoutPropertiesLoose(_ref, _excluded);
        if (placeholderWhitelist != null && !(placeholderWhitelist instanceof Set)) {
          throw new Error("'.placeholderWhitelist' must be a Set, null, or undefined");
        }
        if (placeholderPattern != null && !(placeholderPattern instanceof RegExp) && placeholderPattern !== false) {
          throw new Error("'.placeholderPattern' must be a RegExp, false, null, or undefined");
        }
        if (preserveComments != null && typeof preserveComments !== "boolean") {
          throw new Error("'.preserveComments' must be a boolean, null, or undefined");
        }
        if (syntacticPlaceholders != null && typeof syntacticPlaceholders !== "boolean") {
          throw new Error("'.syntacticPlaceholders' must be a boolean, null, or undefined");
        }
        if (syntacticPlaceholders === true && (placeholderWhitelist != null || placeholderPattern != null)) {
          throw new Error("'.placeholderWhitelist' and '.placeholderPattern' aren't compatible with '.syntacticPlaceholders: true'");
        }
        return {
          parser: parser3,
          placeholderWhitelist: placeholderWhitelist || void 0,
          placeholderPattern: placeholderPattern == null ? void 0 : placeholderPattern,
          preserveComments: preserveComments == null ? void 0 : preserveComments,
          syntacticPlaceholders: syntacticPlaceholders == null ? void 0 : syntacticPlaceholders
        };
      }
      function normalizeReplacements(replacements) {
        if (Array.isArray(replacements)) {
          return replacements.reduce((acc, replacement, i) => {
            acc["$" + i] = replacement;
            return acc;
          }, {});
        } else if (typeof replacements === "object" || replacements == null) {
          return replacements || void 0;
        }
        throw new Error("Template replacements must be an array, object, null, or undefined");
      }
    }
  });

  // node_modules/@babel/template/lib/parse.js
  var require_parse = __commonJS({
    "node_modules/@babel/template/lib/parse.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = parseAndBuildMetadata;
      var _t = require_lib5();
      var _parser = require_lib2();
      var _codeFrame = require_lib10();
      var {
        isCallExpression,
        isExpressionStatement,
        isFunction: isFunction2,
        isIdentifier: isIdentifier2,
        isJSXIdentifier,
        isNewExpression,
        isPlaceholder,
        isStatement,
        isStringLiteral,
        removePropertiesDeep,
        traverse: traverse3
      } = _t;
      var PATTERN = /^[_$A-Z0-9]+$/;
      function parseAndBuildMetadata(formatter, code, opts) {
        const {
          placeholderWhitelist,
          placeholderPattern,
          preserveComments,
          syntacticPlaceholders
        } = opts;
        const ast = parseWithCodeFrame(code, opts.parser, syntacticPlaceholders);
        removePropertiesDeep(ast, {
          preserveComments
        });
        formatter.validate(ast);
        const syntactic = {
          placeholders: [],
          placeholderNames: /* @__PURE__ */ new Set()
        };
        const legacy = {
          placeholders: [],
          placeholderNames: /* @__PURE__ */ new Set()
        };
        const isLegacyRef = {
          value: void 0
        };
        traverse3(ast, placeholderVisitorHandler, {
          syntactic,
          legacy,
          isLegacyRef,
          placeholderWhitelist,
          placeholderPattern,
          syntacticPlaceholders
        });
        return Object.assign({
          ast
        }, isLegacyRef.value ? legacy : syntactic);
      }
      function placeholderVisitorHandler(node, ancestors, state) {
        var _state$placeholderWhi;
        let name;
        if (isPlaceholder(node)) {
          if (state.syntacticPlaceholders === false) {
            throw new Error("%%foo%%-style placeholders can't be used when '.syntacticPlaceholders' is false.");
          } else {
            name = node.name.name;
            state.isLegacyRef.value = false;
          }
        } else if (state.isLegacyRef.value === false || state.syntacticPlaceholders) {
          return;
        } else if (isIdentifier2(node) || isJSXIdentifier(node)) {
          name = node.name;
          state.isLegacyRef.value = true;
        } else if (isStringLiteral(node)) {
          name = node.value;
          state.isLegacyRef.value = true;
        } else {
          return;
        }
        if (!state.isLegacyRef.value && (state.placeholderPattern != null || state.placeholderWhitelist != null)) {
          throw new Error("'.placeholderWhitelist' and '.placeholderPattern' aren't compatible with '.syntacticPlaceholders: true'");
        }
        if (state.isLegacyRef.value && (state.placeholderPattern === false || !(state.placeholderPattern || PATTERN).test(name)) && !((_state$placeholderWhi = state.placeholderWhitelist) != null && _state$placeholderWhi.has(name))) {
          return;
        }
        ancestors = ancestors.slice();
        const {
          node: parent2,
          key
        } = ancestors[ancestors.length - 1];
        let type;
        if (isStringLiteral(node) || isPlaceholder(node, {
          expectedNode: "StringLiteral"
        })) {
          type = "string";
        } else if (isNewExpression(parent2) && key === "arguments" || isCallExpression(parent2) && key === "arguments" || isFunction2(parent2) && key === "params") {
          type = "param";
        } else if (isExpressionStatement(parent2) && !isPlaceholder(node)) {
          type = "statement";
          ancestors = ancestors.slice(0, -1);
        } else if (isStatement(node) && isPlaceholder(node)) {
          type = "statement";
        } else {
          type = "other";
        }
        const {
          placeholders,
          placeholderNames
        } = state.isLegacyRef.value ? state.legacy : state.syntactic;
        placeholders.push({
          name,
          type,
          resolve: (ast) => resolveAncestors(ast, ancestors),
          isDuplicate: placeholderNames.has(name)
        });
        placeholderNames.add(name);
      }
      function resolveAncestors(ast, ancestors) {
        let parent2 = ast;
        for (let i = 0; i < ancestors.length - 1; i++) {
          const {
            key: key2,
            index: index2
          } = ancestors[i];
          if (index2 === void 0) {
            parent2 = parent2[key2];
          } else {
            parent2 = parent2[key2][index2];
          }
        }
        const {
          key,
          index
        } = ancestors[ancestors.length - 1];
        return {
          parent: parent2,
          key,
          index
        };
      }
      function parseWithCodeFrame(code, parserOpts, syntacticPlaceholders) {
        const plugins5 = (parserOpts.plugins || []).slice();
        if (syntacticPlaceholders !== false) {
          plugins5.push("placeholders");
        }
        parserOpts = Object.assign({
          allowReturnOutsideFunction: true,
          allowSuperOutsideMethod: true,
          sourceType: "module"
        }, parserOpts, {
          plugins: plugins5
        });
        try {
          return (0, _parser.parse)(code, parserOpts);
        } catch (err) {
          const loc = err.loc;
          if (loc) {
            err.message += "\n" + (0, _codeFrame.codeFrameColumns)(code, {
              start: loc
            });
            err.code = "BABEL_TEMPLATE_PARSE_ERROR";
          }
          throw err;
        }
      }
    }
  });

  // node_modules/@babel/template/lib/populate.js
  var require_populate = __commonJS({
    "node_modules/@babel/template/lib/populate.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = populatePlaceholders;
      var _t = require_lib5();
      var {
        blockStatement,
        cloneNode,
        emptyStatement,
        expressionStatement: expressionStatement2,
        identifier: identifier3,
        isStatement,
        isStringLiteral,
        stringLiteral,
        validate
      } = _t;
      function populatePlaceholders(metadata, replacements) {
        const ast = cloneNode(metadata.ast);
        if (replacements) {
          metadata.placeholders.forEach((placeholder) => {
            if (!Object.prototype.hasOwnProperty.call(replacements, placeholder.name)) {
              const placeholderName = placeholder.name;
              throw new Error(`Error: No substitution given for "${placeholderName}". If this is not meant to be a
            placeholder you may want to consider passing one of the following options to @babel/template:
            - { placeholderPattern: false, placeholderWhitelist: new Set(['${placeholderName}'])}
            - { placeholderPattern: /^${placeholderName}$/ }`);
            }
          });
          Object.keys(replacements).forEach((key) => {
            if (!metadata.placeholderNames.has(key)) {
              throw new Error(`Unknown substitution "${key}" given`);
            }
          });
        }
        metadata.placeholders.slice().reverse().forEach((placeholder) => {
          try {
            applyReplacement(placeholder, ast, replacements && replacements[placeholder.name] || null);
          } catch (e) {
            e.message = `@babel/template placeholder "${placeholder.name}": ${e.message}`;
            throw e;
          }
        });
        return ast;
      }
      function applyReplacement(placeholder, ast, replacement) {
        if (placeholder.isDuplicate) {
          if (Array.isArray(replacement)) {
            replacement = replacement.map((node) => cloneNode(node));
          } else if (typeof replacement === "object") {
            replacement = cloneNode(replacement);
          }
        }
        const {
          parent: parent2,
          key,
          index
        } = placeholder.resolve(ast);
        if (placeholder.type === "string") {
          if (typeof replacement === "string") {
            replacement = stringLiteral(replacement);
          }
          if (!replacement || !isStringLiteral(replacement)) {
            throw new Error("Expected string substitution");
          }
        } else if (placeholder.type === "statement") {
          if (index === void 0) {
            if (!replacement) {
              replacement = emptyStatement();
            } else if (Array.isArray(replacement)) {
              replacement = blockStatement(replacement);
            } else if (typeof replacement === "string") {
              replacement = expressionStatement2(identifier3(replacement));
            } else if (!isStatement(replacement)) {
              replacement = expressionStatement2(replacement);
            }
          } else {
            if (replacement && !Array.isArray(replacement)) {
              if (typeof replacement === "string") {
                replacement = identifier3(replacement);
              }
              if (!isStatement(replacement)) {
                replacement = expressionStatement2(replacement);
              }
            }
          }
        } else if (placeholder.type === "param") {
          if (typeof replacement === "string") {
            replacement = identifier3(replacement);
          }
          if (index === void 0)
            throw new Error("Assertion failure.");
        } else {
          if (typeof replacement === "string") {
            replacement = identifier3(replacement);
          }
          if (Array.isArray(replacement)) {
            throw new Error("Cannot replace single expression with an array.");
          }
        }
        if (index === void 0) {
          validate(parent2, key, replacement);
          parent2[key] = replacement;
        } else {
          const items = parent2[key].slice();
          if (placeholder.type === "statement" || placeholder.type === "param") {
            if (replacement == null) {
              items.splice(index, 1);
            } else if (Array.isArray(replacement)) {
              items.splice(index, 1, ...replacement);
            } else {
              items[index] = replacement;
            }
          } else {
            items[index] = replacement;
          }
          validate(parent2, key, items);
          parent2[key] = items;
        }
      }
    }
  });

  // node_modules/@babel/template/lib/string.js
  var require_string = __commonJS({
    "node_modules/@babel/template/lib/string.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = stringTemplate;
      var _options = require_options();
      var _parse = require_parse();
      var _populate = require_populate();
      function stringTemplate(formatter, code, opts) {
        code = formatter.code(code);
        let metadata;
        return (arg) => {
          const replacements = (0, _options.normalizeReplacements)(arg);
          if (!metadata)
            metadata = (0, _parse.default)(formatter, code, opts);
          return formatter.unwrap((0, _populate.default)(metadata, replacements));
        };
      }
    }
  });

  // node_modules/@babel/template/lib/literal.js
  var require_literal = __commonJS({
    "node_modules/@babel/template/lib/literal.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = literalTemplate;
      var _options = require_options();
      var _parse = require_parse();
      var _populate = require_populate();
      function literalTemplate(formatter, tpl, opts) {
        const {
          metadata,
          names
        } = buildLiteralData(formatter, tpl, opts);
        return (arg) => {
          const defaultReplacements = {};
          arg.forEach((replacement, i) => {
            defaultReplacements[names[i]] = replacement;
          });
          return (arg2) => {
            const replacements = (0, _options.normalizeReplacements)(arg2);
            if (replacements) {
              Object.keys(replacements).forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(defaultReplacements, key)) {
                  throw new Error("Unexpected replacement overlap.");
                }
              });
            }
            return formatter.unwrap((0, _populate.default)(metadata, replacements ? Object.assign(replacements, defaultReplacements) : defaultReplacements));
          };
        };
      }
      function buildLiteralData(formatter, tpl, opts) {
        let names;
        let nameSet;
        let metadata;
        let prefix = "";
        do {
          prefix += "$";
          const result2 = buildTemplateCode(tpl, prefix);
          names = result2.names;
          nameSet = new Set(names);
          metadata = (0, _parse.default)(formatter, formatter.code(result2.code), {
            parser: opts.parser,
            placeholderWhitelist: new Set(result2.names.concat(opts.placeholderWhitelist ? Array.from(opts.placeholderWhitelist) : [])),
            placeholderPattern: opts.placeholderPattern,
            preserveComments: opts.preserveComments,
            syntacticPlaceholders: opts.syntacticPlaceholders
          });
        } while (metadata.placeholders.some((placeholder) => placeholder.isDuplicate && nameSet.has(placeholder.name)));
        return {
          metadata,
          names
        };
      }
      function buildTemplateCode(tpl, prefix) {
        const names = [];
        let code = tpl[0];
        for (let i = 1; i < tpl.length; i++) {
          const value = `${prefix}${i - 1}`;
          names.push(value);
          code += value + tpl[i];
        }
        return {
          names,
          code
        };
      }
    }
  });

  // node_modules/@babel/template/lib/builder.js
  var require_builder = __commonJS({
    "node_modules/@babel/template/lib/builder.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = createTemplateBuilder;
      var _options = require_options();
      var _string = require_string();
      var _literal = require_literal();
      var NO_PLACEHOLDER = (0, _options.validate)({
        placeholderPattern: false
      });
      function createTemplateBuilder(formatter, defaultOpts) {
        const templateFnCache = /* @__PURE__ */ new WeakMap();
        const templateAstCache = /* @__PURE__ */ new WeakMap();
        const cachedOpts = defaultOpts || (0, _options.validate)(null);
        return Object.assign((tpl, ...args) => {
          if (typeof tpl === "string") {
            if (args.length > 1)
              throw new Error("Unexpected extra params.");
            return extendedTrace((0, _string.default)(formatter, tpl, (0, _options.merge)(cachedOpts, (0, _options.validate)(args[0]))));
          } else if (Array.isArray(tpl)) {
            let builder = templateFnCache.get(tpl);
            if (!builder) {
              builder = (0, _literal.default)(formatter, tpl, cachedOpts);
              templateFnCache.set(tpl, builder);
            }
            return extendedTrace(builder(args));
          } else if (typeof tpl === "object" && tpl) {
            if (args.length > 0)
              throw new Error("Unexpected extra params.");
            return createTemplateBuilder(formatter, (0, _options.merge)(cachedOpts, (0, _options.validate)(tpl)));
          }
          throw new Error(`Unexpected template param ${typeof tpl}`);
        }, {
          ast: (tpl, ...args) => {
            if (typeof tpl === "string") {
              if (args.length > 1)
                throw new Error("Unexpected extra params.");
              return (0, _string.default)(formatter, tpl, (0, _options.merge)((0, _options.merge)(cachedOpts, (0, _options.validate)(args[0])), NO_PLACEHOLDER))();
            } else if (Array.isArray(tpl)) {
              let builder = templateAstCache.get(tpl);
              if (!builder) {
                builder = (0, _literal.default)(formatter, tpl, (0, _options.merge)(cachedOpts, NO_PLACEHOLDER));
                templateAstCache.set(tpl, builder);
              }
              return builder(args)();
            }
            throw new Error(`Unexpected template param ${typeof tpl}`);
          }
        });
      }
      function extendedTrace(fn) {
        let rootStack = "";
        try {
          throw new Error();
        } catch (error) {
          if (error.stack) {
            rootStack = error.stack.split("\n").slice(3).join("\n");
          }
        }
        return (arg) => {
          try {
            return fn(arg);
          } catch (err) {
            err.stack += `
    =============
${rootStack}`;
            throw err;
          }
        };
      }
    }
  });

  // node_modules/@babel/template/lib/index.js
  var require_lib12 = __commonJS({
    "node_modules/@babel/template/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.statements = exports2.statement = exports2.smart = exports2.program = exports2.expression = exports2.default = void 0;
      var formatters = require_formatters();
      var _builder = require_builder();
      var smart = (0, _builder.default)(formatters.smart);
      exports2.smart = smart;
      var statement = (0, _builder.default)(formatters.statement);
      exports2.statement = statement;
      var statements = (0, _builder.default)(formatters.statements);
      exports2.statements = statements;
      var expression = (0, _builder.default)(formatters.expression);
      exports2.expression = expression;
      var program3 = (0, _builder.default)(formatters.program);
      exports2.program = program3;
      var _default = Object.assign(smart.bind(void 0), {
        smart,
        statement,
        statements,
        expression,
        program: program3,
        ast: smart.ast
      });
      exports2.default = _default;
    }
  });

  // node_modules/@babel/helper-function-name/lib/index.js
  var require_lib13 = __commonJS({
    "node_modules/@babel/helper-function-name/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = _default;
      var _template = require_lib12();
      var _t = require_lib5();
      var {
        NOT_LOCAL_BINDING,
        cloneNode,
        identifier: identifier3,
        isAssignmentExpression,
        isAssignmentPattern,
        isFunction: isFunction2,
        isIdentifier: isIdentifier2,
        isLiteral,
        isNullLiteral,
        isObjectMethod,
        isObjectProperty,
        isRegExpLiteral,
        isRestElement,
        isTemplateLiteral,
        isVariableDeclarator,
        toBindingIdentifierName
      } = _t;
      function getFunctionArity(node) {
        const count = node.params.findIndex((param) => isAssignmentPattern(param) || isRestElement(param));
        return count === -1 ? node.params.length : count;
      }
      var buildPropertyMethodAssignmentWrapper = _template.default.statement(`
  (function (FUNCTION_KEY) {
    function FUNCTION_ID() {
      return FUNCTION_KEY.apply(this, arguments);
    }

    FUNCTION_ID.toString = function () {
      return FUNCTION_KEY.toString();
    }

    return FUNCTION_ID;
  })(FUNCTION)
`);
      var buildGeneratorPropertyMethodAssignmentWrapper = _template.default.statement(`
  (function (FUNCTION_KEY) {
    function* FUNCTION_ID() {
      return yield* FUNCTION_KEY.apply(this, arguments);
    }

    FUNCTION_ID.toString = function () {
      return FUNCTION_KEY.toString();
    };

    return FUNCTION_ID;
  })(FUNCTION)
`);
      var visitor = {
        "ReferencedIdentifier|BindingIdentifier"(path, state) {
          if (path.node.name !== state.name)
            return;
          const localDeclar = path.scope.getBindingIdentifier(state.name);
          if (localDeclar !== state.outerDeclar)
            return;
          state.selfReference = true;
          path.stop();
        }
      };
      function getNameFromLiteralId(id) {
        if (isNullLiteral(id)) {
          return "null";
        }
        if (isRegExpLiteral(id)) {
          return `_${id.pattern}_${id.flags}`;
        }
        if (isTemplateLiteral(id)) {
          return id.quasis.map((quasi) => quasi.value.raw).join("");
        }
        if (id.value !== void 0) {
          return id.value + "";
        }
        return "";
      }
      function wrap2(state, method2, id, scope) {
        if (state.selfReference) {
          if (scope.hasBinding(id.name) && !scope.hasGlobal(id.name)) {
            scope.rename(id.name);
          } else {
            if (!isFunction2(method2))
              return;
            let build = buildPropertyMethodAssignmentWrapper;
            if (method2.generator) {
              build = buildGeneratorPropertyMethodAssignmentWrapper;
            }
            const template2 = build({
              FUNCTION: method2,
              FUNCTION_ID: id,
              FUNCTION_KEY: scope.generateUidIdentifier(id.name)
            }).expression;
            const params = template2.callee.body.body[0].params;
            for (let i = 0, len = getFunctionArity(method2); i < len; i++) {
              params.push(scope.generateUidIdentifier("x"));
            }
            return template2;
          }
        }
        method2.id = id;
        scope.getProgramParent().references[id.name] = true;
      }
      function visit(node, name, scope) {
        const state = {
          selfAssignment: false,
          selfReference: false,
          outerDeclar: scope.getBindingIdentifier(name),
          name
        };
        const binding = scope.getOwnBinding(name);
        if (binding) {
          if (binding.kind === "param") {
            state.selfReference = true;
          } else {
          }
        } else if (state.outerDeclar || scope.hasGlobal(name)) {
          scope.traverse(node, visitor, state);
        }
        return state;
      }
      function _default({
        node,
        parent: parent2,
        scope,
        id
      }, localBinding = false, supportUnicodeId = false) {
        if (node.id)
          return;
        if ((isObjectProperty(parent2) || isObjectMethod(parent2, {
          kind: "method"
        })) && (!parent2.computed || isLiteral(parent2.key))) {
          id = parent2.key;
        } else if (isVariableDeclarator(parent2)) {
          id = parent2.id;
          if (isIdentifier2(id) && !localBinding) {
            const binding = scope.parent.getBinding(id.name);
            if (binding && binding.constant && scope.getBinding(id.name) === binding) {
              node.id = cloneNode(id);
              node.id[NOT_LOCAL_BINDING] = true;
              return;
            }
          }
        } else if (isAssignmentExpression(parent2, {
          operator: "="
        })) {
          id = parent2.left;
        } else if (!id) {
          return;
        }
        let name;
        if (id && isLiteral(id)) {
          name = getNameFromLiteralId(id);
        } else if (id && isIdentifier2(id)) {
          name = id.name;
        }
        if (name === void 0) {
          return;
        }
        if (!supportUnicodeId && isFunction2(node) && /[\uD800-\uDFFF]/.test(name)) {
          return;
        }
        name = toBindingIdentifierName(name);
        const newId = identifier3(name);
        newId[NOT_LOCAL_BINDING] = true;
        const state = visit(node, name, scope);
        return wrap2(state, node, newId, scope) || node;
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/conversion.js
  var require_conversion = __commonJS({
    "node_modules/@babel/traverse/lib/path/conversion.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.arrowFunctionToExpression = arrowFunctionToExpression;
      exports2.arrowFunctionToShadowed = arrowFunctionToShadowed;
      exports2.ensureBlock = ensureBlock;
      exports2.toComputedKey = toComputedKey;
      exports2.unwrapFunctionEnvironment = unwrapFunctionEnvironment;
      var _t = require_lib5();
      var _helperEnvironmentVisitor = require_lib8();
      var _helperFunctionName = require_lib13();
      var _visitors = require_visitors();
      var {
        arrowFunctionExpression: arrowFunctionExpression2,
        assignmentExpression,
        binaryExpression,
        blockStatement,
        callExpression,
        conditionalExpression,
        expressionStatement: expressionStatement2,
        identifier: identifier3,
        isIdentifier: isIdentifier2,
        jsxIdentifier,
        logicalExpression,
        LOGICAL_OPERATORS,
        memberExpression,
        metaProperty,
        numericLiteral,
        objectExpression,
        restElement,
        returnStatement,
        sequenceExpression,
        spreadElement,
        stringLiteral,
        super: _super,
        thisExpression,
        toExpression,
        unaryExpression
      } = _t;
      function toComputedKey() {
        let key;
        if (this.isMemberExpression()) {
          key = this.node.property;
        } else if (this.isProperty() || this.isMethod()) {
          key = this.node.key;
        } else {
          throw new ReferenceError("todo");
        }
        if (!this.node.computed) {
          if (isIdentifier2(key))
            key = stringLiteral(key.name);
        }
        return key;
      }
      function ensureBlock() {
        const body = this.get("body");
        const bodyNode = body.node;
        if (Array.isArray(body)) {
          throw new Error("Can't convert array path to a block statement");
        }
        if (!bodyNode) {
          throw new Error("Can't convert node without a body");
        }
        if (body.isBlockStatement()) {
          return bodyNode;
        }
        const statements = [];
        let stringPath = "body";
        let key;
        let listKey;
        if (body.isStatement()) {
          listKey = "body";
          key = 0;
          statements.push(body.node);
        } else {
          stringPath += ".body.0";
          if (this.isFunction()) {
            key = "argument";
            statements.push(returnStatement(body.node));
          } else {
            key = "expression";
            statements.push(expressionStatement2(body.node));
          }
        }
        this.node.body = blockStatement(statements);
        const parentPath = this.get(stringPath);
        body.setup(parentPath, listKey ? parentPath.node[listKey] : parentPath.node, listKey, key);
        return this.node;
      }
      function arrowFunctionToShadowed() {
        if (!this.isArrowFunctionExpression())
          return;
        this.arrowFunctionToExpression();
      }
      function unwrapFunctionEnvironment() {
        if (!this.isArrowFunctionExpression() && !this.isFunctionExpression() && !this.isFunctionDeclaration()) {
          throw this.buildCodeFrameError("Can only unwrap the environment of a function.");
        }
        hoistFunctionEnvironment(this);
      }
      function setType(path, type) {
        path.node.type = type;
      }
      function arrowFunctionToExpression({
        allowInsertArrow = true,
        specCompliant = false,
        noNewArrows = !specCompliant
      } = {}) {
        if (!this.isArrowFunctionExpression()) {
          throw this.buildCodeFrameError("Cannot convert non-arrow function to a function expression.");
        }
        const {
          thisBinding,
          fnPath: fn
        } = hoistFunctionEnvironment(this, noNewArrows, allowInsertArrow);
        fn.ensureBlock();
        setType(fn, "FunctionExpression");
        if (!noNewArrows) {
          const checkBinding = thisBinding ? null : fn.scope.generateUidIdentifier("arrowCheckId");
          if (checkBinding) {
            fn.parentPath.scope.push({
              id: checkBinding,
              init: objectExpression([])
            });
          }
          fn.get("body").unshiftContainer("body", expressionStatement2(callExpression(this.hub.addHelper("newArrowCheck"), [thisExpression(), checkBinding ? identifier3(checkBinding.name) : identifier3(thisBinding)])));
          fn.replaceWith(callExpression(memberExpression(
            (0, _helperFunctionName.default)(this, true) || fn.node,
            identifier3("bind")
          ), [checkBinding ? identifier3(checkBinding.name) : thisExpression()]));
          return fn.get("callee.object");
        }
        return fn;
      }
      var getSuperCallsVisitor = (0, _visitors.merge)([{
        CallExpression(child, {
          allSuperCalls
        }) {
          if (!child.get("callee").isSuper())
            return;
          allSuperCalls.push(child);
        }
      }, _helperEnvironmentVisitor.default]);
      function hoistFunctionEnvironment(fnPath, noNewArrows = true, allowInsertArrow = true) {
        let arrowParent;
        let thisEnvFn = fnPath.findParent((p) => {
          if (p.isArrowFunctionExpression()) {
            var _arrowParent;
            (_arrowParent = arrowParent) != null ? _arrowParent : arrowParent = p;
            return false;
          }
          return p.isFunction() || p.isProgram() || p.isClassProperty({
            static: false
          }) || p.isClassPrivateProperty({
            static: false
          });
        });
        const inConstructor = thisEnvFn.isClassMethod({
          kind: "constructor"
        });
        if (thisEnvFn.isClassProperty() || thisEnvFn.isClassPrivateProperty()) {
          if (arrowParent) {
            thisEnvFn = arrowParent;
          } else if (allowInsertArrow) {
            fnPath.replaceWith(callExpression(arrowFunctionExpression2([], toExpression(fnPath.node)), []));
            thisEnvFn = fnPath.get("callee");
            fnPath = thisEnvFn.get("body");
          } else {
            throw fnPath.buildCodeFrameError("Unable to transform arrow inside class property");
          }
        }
        const {
          thisPaths,
          argumentsPaths,
          newTargetPaths,
          superProps,
          superCalls
        } = getScopeInformation(fnPath);
        if (inConstructor && superCalls.length > 0) {
          if (!allowInsertArrow) {
            throw superCalls[0].buildCodeFrameError("Unable to handle nested super() usage in arrow");
          }
          const allSuperCalls = [];
          thisEnvFn.traverse(getSuperCallsVisitor, {
            allSuperCalls
          });
          const superBinding = getSuperBinding(thisEnvFn);
          allSuperCalls.forEach((superCall) => {
            const callee = identifier3(superBinding);
            callee.loc = superCall.node.callee.loc;
            superCall.get("callee").replaceWith(callee);
          });
        }
        if (argumentsPaths.length > 0) {
          const argumentsBinding = getBinding(thisEnvFn, "arguments", () => {
            const args = () => identifier3("arguments");
            if (thisEnvFn.scope.path.isProgram()) {
              return conditionalExpression(binaryExpression("===", unaryExpression("typeof", args()), stringLiteral("undefined")), thisEnvFn.scope.buildUndefinedNode(), args());
            } else {
              return args();
            }
          });
          argumentsPaths.forEach((argumentsChild) => {
            const argsRef = identifier3(argumentsBinding);
            argsRef.loc = argumentsChild.node.loc;
            argumentsChild.replaceWith(argsRef);
          });
        }
        if (newTargetPaths.length > 0) {
          const newTargetBinding = getBinding(thisEnvFn, "newtarget", () => metaProperty(identifier3("new"), identifier3("target")));
          newTargetPaths.forEach((targetChild) => {
            const targetRef = identifier3(newTargetBinding);
            targetRef.loc = targetChild.node.loc;
            targetChild.replaceWith(targetRef);
          });
        }
        if (superProps.length > 0) {
          if (!allowInsertArrow) {
            throw superProps[0].buildCodeFrameError("Unable to handle nested super.prop usage");
          }
          const flatSuperProps = superProps.reduce((acc, superProp) => acc.concat(standardizeSuperProperty(superProp)), []);
          flatSuperProps.forEach((superProp) => {
            const key = superProp.node.computed ? "" : superProp.get("property").node.name;
            const superParentPath = superProp.parentPath;
            const isAssignment = superParentPath.isAssignmentExpression({
              left: superProp.node
            });
            const isCall = superParentPath.isCallExpression({
              callee: superProp.node
            });
            const isTaggedTemplate = superParentPath.isTaggedTemplateExpression({
              tag: superProp.node
            });
            const superBinding = getSuperPropBinding(thisEnvFn, isAssignment, key);
            const args = [];
            if (superProp.node.computed) {
              args.push(superProp.get("property").node);
            }
            if (isAssignment) {
              const value = superParentPath.node.right;
              args.push(value);
            }
            const call = callExpression(identifier3(superBinding), args);
            if (isCall) {
              superParentPath.unshiftContainer("arguments", thisExpression());
              superProp.replaceWith(memberExpression(call, identifier3("call")));
              thisPaths.push(superParentPath.get("arguments.0"));
            } else if (isAssignment) {
              superParentPath.replaceWith(call);
            } else if (isTaggedTemplate) {
              superProp.replaceWith(callExpression(memberExpression(call, identifier3("bind"), false), [thisExpression()]));
              thisPaths.push(superProp.get("arguments.0"));
            } else {
              superProp.replaceWith(call);
            }
          });
        }
        let thisBinding;
        if (thisPaths.length > 0 || !noNewArrows) {
          thisBinding = getThisBinding(thisEnvFn, inConstructor);
          if (noNewArrows || inConstructor && hasSuperClass(thisEnvFn)) {
            thisPaths.forEach((thisChild) => {
              const thisRef = thisChild.isJSX() ? jsxIdentifier(thisBinding) : identifier3(thisBinding);
              thisRef.loc = thisChild.node.loc;
              thisChild.replaceWith(thisRef);
            });
            if (!noNewArrows)
              thisBinding = null;
          }
        }
        return {
          thisBinding,
          fnPath
        };
      }
      function isLogicalOp(op) {
        return LOGICAL_OPERATORS.includes(op);
      }
      function standardizeSuperProperty(superProp) {
        if (superProp.parentPath.isAssignmentExpression() && superProp.parentPath.node.operator !== "=") {
          const assignmentPath = superProp.parentPath;
          const op = assignmentPath.node.operator.slice(0, -1);
          const value = assignmentPath.node.right;
          const isLogicalAssignment = isLogicalOp(op);
          if (superProp.node.computed) {
            const tmp = superProp.scope.generateDeclaredUidIdentifier("tmp");
            const object = superProp.node.object;
            const property2 = superProp.node.property;
            assignmentPath.get("left").replaceWith(memberExpression(object, assignmentExpression("=", tmp, property2), true));
            assignmentPath.get("right").replaceWith(rightExpression(isLogicalAssignment ? "=" : op, memberExpression(object, identifier3(tmp.name), true), value));
          } else {
            const object = superProp.node.object;
            const property2 = superProp.node.property;
            assignmentPath.get("left").replaceWith(memberExpression(object, property2));
            assignmentPath.get("right").replaceWith(rightExpression(isLogicalAssignment ? "=" : op, memberExpression(object, identifier3(property2.name)), value));
          }
          if (isLogicalAssignment) {
            assignmentPath.replaceWith(logicalExpression(op, assignmentPath.node.left, assignmentPath.node.right));
          } else {
            assignmentPath.node.operator = "=";
          }
          return [assignmentPath.get("left"), assignmentPath.get("right").get("left")];
        } else if (superProp.parentPath.isUpdateExpression()) {
          const updateExpr = superProp.parentPath;
          const tmp = superProp.scope.generateDeclaredUidIdentifier("tmp");
          const computedKey = superProp.node.computed ? superProp.scope.generateDeclaredUidIdentifier("prop") : null;
          const parts = [assignmentExpression("=", tmp, memberExpression(superProp.node.object, computedKey ? assignmentExpression("=", computedKey, superProp.node.property) : superProp.node.property, superProp.node.computed)), assignmentExpression("=", memberExpression(superProp.node.object, computedKey ? identifier3(computedKey.name) : superProp.node.property, superProp.node.computed), binaryExpression(
            superProp.parentPath.node.operator[0],
            identifier3(tmp.name),
            numericLiteral(1)
          ))];
          if (!superProp.parentPath.node.prefix) {
            parts.push(identifier3(tmp.name));
          }
          updateExpr.replaceWith(sequenceExpression(parts));
          const left = updateExpr.get("expressions.0.right");
          const right = updateExpr.get("expressions.1.left");
          return [left, right];
        }
        return [superProp];
        function rightExpression(op, left, right) {
          if (op === "=") {
            return assignmentExpression("=", left, right);
          } else {
            return binaryExpression(op, left, right);
          }
        }
      }
      function hasSuperClass(thisEnvFn) {
        return thisEnvFn.isClassMethod() && !!thisEnvFn.parentPath.parentPath.node.superClass;
      }
      var assignSuperThisVisitor = (0, _visitors.merge)([{
        CallExpression(child, {
          supers,
          thisBinding
        }) {
          if (!child.get("callee").isSuper())
            return;
          if (supers.has(child.node))
            return;
          supers.add(child.node);
          child.replaceWithMultiple([child.node, assignmentExpression("=", identifier3(thisBinding), identifier3("this"))]);
        }
      }, _helperEnvironmentVisitor.default]);
      function getThisBinding(thisEnvFn, inConstructor) {
        return getBinding(thisEnvFn, "this", (thisBinding) => {
          if (!inConstructor || !hasSuperClass(thisEnvFn))
            return thisExpression();
          thisEnvFn.traverse(assignSuperThisVisitor, {
            supers: /* @__PURE__ */ new WeakSet(),
            thisBinding
          });
        });
      }
      function getSuperBinding(thisEnvFn) {
        return getBinding(thisEnvFn, "supercall", () => {
          const argsBinding = thisEnvFn.scope.generateUidIdentifier("args");
          return arrowFunctionExpression2([restElement(argsBinding)], callExpression(_super(), [spreadElement(identifier3(argsBinding.name))]));
        });
      }
      function getSuperPropBinding(thisEnvFn, isAssignment, propName) {
        const op = isAssignment ? "set" : "get";
        return getBinding(thisEnvFn, `superprop_${op}:${propName || ""}`, () => {
          const argsList = [];
          let fnBody;
          if (propName) {
            fnBody = memberExpression(_super(), identifier3(propName));
          } else {
            const method2 = thisEnvFn.scope.generateUidIdentifier("prop");
            argsList.unshift(method2);
            fnBody = memberExpression(_super(), identifier3(method2.name), true);
          }
          if (isAssignment) {
            const valueIdent = thisEnvFn.scope.generateUidIdentifier("value");
            argsList.push(valueIdent);
            fnBody = assignmentExpression("=", fnBody, identifier3(valueIdent.name));
          }
          return arrowFunctionExpression2(argsList, fnBody);
        });
      }
      function getBinding(thisEnvFn, key, init) {
        const cacheKey = "binding:" + key;
        let data = thisEnvFn.getData(cacheKey);
        if (!data) {
          const id = thisEnvFn.scope.generateUidIdentifier(key);
          data = id.name;
          thisEnvFn.setData(cacheKey, data);
          thisEnvFn.scope.push({
            id,
            init: init(data)
          });
        }
        return data;
      }
      var getScopeInformationVisitor = (0, _visitors.merge)([{
        ThisExpression(child, {
          thisPaths
        }) {
          thisPaths.push(child);
        },
        JSXIdentifier(child, {
          thisPaths
        }) {
          if (child.node.name !== "this")
            return;
          if (!child.parentPath.isJSXMemberExpression({
            object: child.node
          }) && !child.parentPath.isJSXOpeningElement({
            name: child.node
          })) {
            return;
          }
          thisPaths.push(child);
        },
        CallExpression(child, {
          superCalls
        }) {
          if (child.get("callee").isSuper())
            superCalls.push(child);
        },
        MemberExpression(child, {
          superProps
        }) {
          if (child.get("object").isSuper())
            superProps.push(child);
        },
        Identifier(child, {
          argumentsPaths
        }) {
          if (!child.isReferencedIdentifier({
            name: "arguments"
          }))
            return;
          let curr = child.scope;
          do {
            if (curr.hasOwnBinding("arguments")) {
              curr.rename("arguments");
              return;
            }
            if (curr.path.isFunction() && !curr.path.isArrowFunctionExpression()) {
              break;
            }
          } while (curr = curr.parent);
          argumentsPaths.push(child);
        },
        MetaProperty(child, {
          newTargetPaths
        }) {
          if (!child.get("meta").isIdentifier({
            name: "new"
          }))
            return;
          if (!child.get("property").isIdentifier({
            name: "target"
          }))
            return;
          newTargetPaths.push(child);
        }
      }, _helperEnvironmentVisitor.default]);
      function getScopeInformation(fnPath) {
        const thisPaths = [];
        const argumentsPaths = [];
        const newTargetPaths = [];
        const superProps = [];
        const superCalls = [];
        fnPath.traverse(getScopeInformationVisitor, {
          thisPaths,
          argumentsPaths,
          newTargetPaths,
          superProps,
          superCalls
        });
        return {
          thisPaths,
          argumentsPaths,
          newTargetPaths,
          superProps,
          superCalls
        };
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/introspection.js
  var require_introspection = __commonJS({
    "node_modules/@babel/traverse/lib/path/introspection.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._guessExecutionStatusRelativeTo = _guessExecutionStatusRelativeTo;
      exports2._resolve = _resolve;
      exports2.canHaveVariableDeclarationOrExpression = canHaveVariableDeclarationOrExpression;
      exports2.canSwapBetweenExpressionAndStatement = canSwapBetweenExpressionAndStatement;
      exports2.equals = equals;
      exports2.getSource = getSource;
      exports2.has = has2;
      exports2.is = void 0;
      exports2.isCompletionRecord = isCompletionRecord;
      exports2.isConstantExpression = isConstantExpression;
      exports2.isInStrictMode = isInStrictMode;
      exports2.isNodeType = isNodeType;
      exports2.isStatementOrBlock = isStatementOrBlock;
      exports2.isStatic = isStatic;
      exports2.isnt = isnt;
      exports2.matchesPattern = matchesPattern;
      exports2.referencesImport = referencesImport;
      exports2.resolve = resolve;
      exports2.willIMaybeExecuteBefore = willIMaybeExecuteBefore;
      var _t = require_lib5();
      var {
        STATEMENT_OR_BLOCK_KEYS,
        VISITOR_KEYS,
        isBlockStatement,
        isExpression,
        isIdentifier: isIdentifier2,
        isLiteral,
        isStringLiteral,
        isType,
        matchesPattern: _matchesPattern
      } = _t;
      function matchesPattern(pattern, allowPartial) {
        return _matchesPattern(this.node, pattern, allowPartial);
      }
      function has2(key) {
        const val = this.node && this.node[key];
        if (val && Array.isArray(val)) {
          return !!val.length;
        } else {
          return !!val;
        }
      }
      function isStatic() {
        return this.scope.isStatic(this.node);
      }
      var is = has2;
      exports2.is = is;
      function isnt(key) {
        return !this.has(key);
      }
      function equals(key, value) {
        return this.node[key] === value;
      }
      function isNodeType(type) {
        return isType(this.type, type);
      }
      function canHaveVariableDeclarationOrExpression() {
        return (this.key === "init" || this.key === "left") && this.parentPath.isFor();
      }
      function canSwapBetweenExpressionAndStatement(replacement) {
        if (this.key !== "body" || !this.parentPath.isArrowFunctionExpression()) {
          return false;
        }
        if (this.isExpression()) {
          return isBlockStatement(replacement);
        } else if (this.isBlockStatement()) {
          return isExpression(replacement);
        }
        return false;
      }
      function isCompletionRecord(allowInsideFunction) {
        let path = this;
        let first = true;
        do {
          const {
            type,
            container
          } = path;
          if (!first && (path.isFunction() || type === "StaticBlock")) {
            return !!allowInsideFunction;
          }
          first = false;
          if (Array.isArray(container) && path.key !== container.length - 1) {
            return false;
          }
        } while ((path = path.parentPath) && !path.isProgram() && !path.isDoExpression());
        return true;
      }
      function isStatementOrBlock() {
        if (this.parentPath.isLabeledStatement() || isBlockStatement(this.container)) {
          return false;
        } else {
          return STATEMENT_OR_BLOCK_KEYS.includes(this.key);
        }
      }
      function referencesImport(moduleSource, importName) {
        if (!this.isReferencedIdentifier()) {
          if (this.isJSXMemberExpression() && this.node.property.name === importName || (this.isMemberExpression() || this.isOptionalMemberExpression()) && (this.node.computed ? isStringLiteral(this.node.property, {
            value: importName
          }) : this.node.property.name === importName)) {
            const object = this.get("object");
            return object.isReferencedIdentifier() && object.referencesImport(moduleSource, "*");
          }
          return false;
        }
        const binding = this.scope.getBinding(this.node.name);
        if (!binding || binding.kind !== "module")
          return false;
        const path = binding.path;
        const parent2 = path.parentPath;
        if (!parent2.isImportDeclaration())
          return false;
        if (parent2.node.source.value === moduleSource) {
          if (!importName)
            return true;
        } else {
          return false;
        }
        if (path.isImportDefaultSpecifier() && importName === "default") {
          return true;
        }
        if (path.isImportNamespaceSpecifier() && importName === "*") {
          return true;
        }
        if (path.isImportSpecifier() && isIdentifier2(path.node.imported, {
          name: importName
        })) {
          return true;
        }
        return false;
      }
      function getSource() {
        const node = this.node;
        if (node.end) {
          const code = this.hub.getCode();
          if (code)
            return code.slice(node.start, node.end);
        }
        return "";
      }
      function willIMaybeExecuteBefore(target) {
        return this._guessExecutionStatusRelativeTo(target) !== "after";
      }
      function getOuterFunction(path) {
        return (path.scope.getFunctionParent() || path.scope.getProgramParent()).path;
      }
      function isExecutionUncertain(type, key) {
        switch (type) {
          case "LogicalExpression":
            return key === "right";
          case "ConditionalExpression":
          case "IfStatement":
            return key === "consequent" || key === "alternate";
          case "WhileStatement":
          case "DoWhileStatement":
          case "ForInStatement":
          case "ForOfStatement":
            return key === "body";
          case "ForStatement":
            return key === "body" || key === "update";
          case "SwitchStatement":
            return key === "cases";
          case "TryStatement":
            return key === "handler";
          case "AssignmentPattern":
            return key === "right";
          case "OptionalMemberExpression":
            return key === "property";
          case "OptionalCallExpression":
            return key === "arguments";
          default:
            return false;
        }
      }
      function isExecutionUncertainInList(paths, maxIndex) {
        for (let i = 0; i < maxIndex; i++) {
          const path = paths[i];
          if (isExecutionUncertain(path.parent.type, path.parentKey)) {
            return true;
          }
        }
        return false;
      }
      function _guessExecutionStatusRelativeTo(target) {
        return _guessExecutionStatusRelativeToCached(this, target, /* @__PURE__ */ new Map());
      }
      function _guessExecutionStatusRelativeToCached(base, target, cache) {
        const funcParent = {
          this: getOuterFunction(base),
          target: getOuterFunction(target)
        };
        if (funcParent.target.node !== funcParent.this.node) {
          return _guessExecutionStatusRelativeToDifferentFunctionsCached(base, funcParent.target, cache);
        }
        const paths = {
          target: target.getAncestry(),
          this: base.getAncestry()
        };
        if (paths.target.indexOf(base) >= 0)
          return "after";
        if (paths.this.indexOf(target) >= 0)
          return "before";
        let commonPath;
        const commonIndex = {
          target: 0,
          this: 0
        };
        while (!commonPath && commonIndex.this < paths.this.length) {
          const path = paths.this[commonIndex.this];
          commonIndex.target = paths.target.indexOf(path);
          if (commonIndex.target >= 0) {
            commonPath = path;
          } else {
            commonIndex.this++;
          }
        }
        if (!commonPath) {
          throw new Error("Internal Babel error - The two compared nodes don't appear to belong to the same program.");
        }
        if (isExecutionUncertainInList(paths.this, commonIndex.this - 1) || isExecutionUncertainInList(paths.target, commonIndex.target - 1)) {
          return "unknown";
        }
        const divergence = {
          this: paths.this[commonIndex.this - 1],
          target: paths.target[commonIndex.target - 1]
        };
        if (divergence.target.listKey && divergence.this.listKey && divergence.target.container === divergence.this.container) {
          return divergence.target.key > divergence.this.key ? "before" : "after";
        }
        const keys2 = VISITOR_KEYS[commonPath.type];
        const keyPosition = {
          this: keys2.indexOf(divergence.this.parentKey),
          target: keys2.indexOf(divergence.target.parentKey)
        };
        return keyPosition.target > keyPosition.this ? "before" : "after";
      }
      var executionOrderCheckedNodes = /* @__PURE__ */ new Set();
      function _guessExecutionStatusRelativeToDifferentFunctionsInternal(base, target, cache) {
        if (!target.isFunctionDeclaration() || target.parentPath.isExportDeclaration()) {
          return "unknown";
        }
        const binding = target.scope.getBinding(target.node.id.name);
        if (!binding.references)
          return "before";
        const referencePaths = binding.referencePaths;
        let allStatus;
        for (const path of referencePaths) {
          const childOfFunction = !!path.find((path2) => path2.node === target.node);
          if (childOfFunction)
            continue;
          if (path.key !== "callee" || !path.parentPath.isCallExpression()) {
            return "unknown";
          }
          if (executionOrderCheckedNodes.has(path.node))
            continue;
          executionOrderCheckedNodes.add(path.node);
          try {
            const status = _guessExecutionStatusRelativeToCached(base, path, cache);
            if (allStatus && allStatus !== status) {
              return "unknown";
            } else {
              allStatus = status;
            }
          } finally {
            executionOrderCheckedNodes.delete(path.node);
          }
        }
        return allStatus;
      }
      function _guessExecutionStatusRelativeToDifferentFunctionsCached(base, target, cache) {
        let nodeMap = cache.get(base.node);
        if (!nodeMap) {
          cache.set(base.node, nodeMap = /* @__PURE__ */ new Map());
        } else if (nodeMap.has(target.node)) {
          return nodeMap.get(target.node);
        }
        const result2 = _guessExecutionStatusRelativeToDifferentFunctionsInternal(base, target, cache);
        nodeMap.set(target.node, result2);
        return result2;
      }
      function resolve(dangerous, resolved) {
        return this._resolve(dangerous, resolved) || this;
      }
      function _resolve(dangerous, resolved) {
        if (resolved && resolved.indexOf(this) >= 0)
          return;
        resolved = resolved || [];
        resolved.push(this);
        if (this.isVariableDeclarator()) {
          if (this.get("id").isIdentifier()) {
            return this.get("init").resolve(dangerous, resolved);
          } else {
          }
        } else if (this.isReferencedIdentifier()) {
          const binding = this.scope.getBinding(this.node.name);
          if (!binding)
            return;
          if (!binding.constant)
            return;
          if (binding.kind === "module")
            return;
          if (binding.path !== this) {
            const ret = binding.path.resolve(dangerous, resolved);
            if (this.find((parent2) => parent2.node === ret.node))
              return;
            return ret;
          }
        } else if (this.isTypeCastExpression()) {
          return this.get("expression").resolve(dangerous, resolved);
        } else if (dangerous && this.isMemberExpression()) {
          const targetKey = this.toComputedKey();
          if (!isLiteral(targetKey))
            return;
          const targetName = targetKey.value;
          const target = this.get("object").resolve(dangerous, resolved);
          if (target.isObjectExpression()) {
            const props = target.get("properties");
            for (const prop of props) {
              if (!prop.isProperty())
                continue;
              const key = prop.get("key");
              let match = prop.isnt("computed") && key.isIdentifier({
                name: targetName
              });
              match = match || key.isLiteral({
                value: targetName
              });
              if (match)
                return prop.get("value").resolve(dangerous, resolved);
            }
          } else if (target.isArrayExpression() && !isNaN(+targetName)) {
            const elems = target.get("elements");
            const elem = elems[targetName];
            if (elem)
              return elem.resolve(dangerous, resolved);
          }
        }
      }
      function isConstantExpression() {
        if (this.isIdentifier()) {
          const binding = this.scope.getBinding(this.node.name);
          if (!binding)
            return false;
          return binding.constant;
        }
        if (this.isLiteral()) {
          if (this.isRegExpLiteral()) {
            return false;
          }
          if (this.isTemplateLiteral()) {
            return this.get("expressions").every((expression) => expression.isConstantExpression());
          }
          return true;
        }
        if (this.isUnaryExpression()) {
          if (this.node.operator !== "void") {
            return false;
          }
          return this.get("argument").isConstantExpression();
        }
        if (this.isBinaryExpression()) {
          const {
            operator
          } = this.node;
          return operator !== "in" && operator !== "instanceof" && this.get("left").isConstantExpression() && this.get("right").isConstantExpression();
        }
        return false;
      }
      function isInStrictMode() {
        const start = this.isProgram() ? this : this.parentPath;
        const strictParent = start.find((path) => {
          if (path.isProgram({
            sourceType: "module"
          }))
            return true;
          if (path.isClass())
            return true;
          if (path.isArrowFunctionExpression() && !path.get("body").isBlockStatement()) {
            return false;
          }
          let body;
          if (path.isFunction()) {
            body = path.node.body;
          } else if (path.isProgram()) {
            body = path.node;
          } else {
            return false;
          }
          for (const directive of body.directives) {
            if (directive.value.value === "use strict") {
              return true;
            }
          }
        });
        return !!strictParent;
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/context.js
  var require_context = __commonJS({
    "node_modules/@babel/traverse/lib/path/context.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._call = _call;
      exports2._getQueueContexts = _getQueueContexts;
      exports2._resyncKey = _resyncKey;
      exports2._resyncList = _resyncList;
      exports2._resyncParent = _resyncParent;
      exports2._resyncRemoved = _resyncRemoved;
      exports2.call = call;
      exports2.isBlacklisted = exports2.isDenylisted = isDenylisted;
      exports2.popContext = popContext;
      exports2.pushContext = pushContext;
      exports2.requeue = requeue;
      exports2.resync = resync;
      exports2.setContext = setContext;
      exports2.setKey = setKey;
      exports2.setScope = setScope;
      exports2.setup = setup;
      exports2.skip = skip;
      exports2.skipKey = skipKey;
      exports2.stop = stop;
      exports2.visit = visit;
      var _traverseNode = require_traverse_node();
      var _index = require_path();
      function call(key) {
        const opts = this.opts;
        this.debug(key);
        if (this.node) {
          if (this._call(opts[key]))
            return true;
        }
        if (this.node) {
          return this._call(opts[this.node.type] && opts[this.node.type][key]);
        }
        return false;
      }
      function _call(fns) {
        if (!fns)
          return false;
        for (const fn of fns) {
          if (!fn)
            continue;
          const node = this.node;
          if (!node)
            return true;
          const ret = fn.call(this.state, this, this.state);
          if (ret && typeof ret === "object" && typeof ret.then === "function") {
            throw new Error(`You appear to be using a plugin with an async traversal visitor, which your current version of Babel does not support. If you're using a published plugin, you may need to upgrade your @babel/core version.`);
          }
          if (ret) {
            throw new Error(`Unexpected return value from visitor method ${fn}`);
          }
          if (this.node !== node)
            return true;
          if (this._traverseFlags > 0)
            return true;
        }
        return false;
      }
      function isDenylisted() {
        var _this$opts$denylist;
        const denylist = (_this$opts$denylist = this.opts.denylist) != null ? _this$opts$denylist : this.opts.blacklist;
        return denylist && denylist.indexOf(this.node.type) > -1;
      }
      function restoreContext(path, context) {
        if (path.context !== context) {
          path.context = context;
          path.state = context.state;
          path.opts = context.opts;
        }
      }
      function visit() {
        if (!this.node) {
          return false;
        }
        if (this.isDenylisted()) {
          return false;
        }
        if (this.opts.shouldSkip && this.opts.shouldSkip(this)) {
          return false;
        }
        const currentContext = this.context;
        if (this.shouldSkip || this.call("enter")) {
          this.debug("Skip...");
          return this.shouldStop;
        }
        restoreContext(this, currentContext);
        this.debug("Recursing into...");
        this.shouldStop = (0, _traverseNode.traverseNode)(this.node, this.opts, this.scope, this.state, this, this.skipKeys);
        restoreContext(this, currentContext);
        this.call("exit");
        return this.shouldStop;
      }
      function skip() {
        this.shouldSkip = true;
      }
      function skipKey(key) {
        if (this.skipKeys == null) {
          this.skipKeys = {};
        }
        this.skipKeys[key] = true;
      }
      function stop() {
        this._traverseFlags |= _index.SHOULD_SKIP | _index.SHOULD_STOP;
      }
      function setScope() {
        if (this.opts && this.opts.noScope)
          return;
        let path = this.parentPath;
        if ((this.key === "key" || this.listKey === "decorators") && path.isMethod()) {
          path = path.parentPath;
        }
        let target;
        while (path && !target) {
          if (path.opts && path.opts.noScope)
            return;
          target = path.scope;
          path = path.parentPath;
        }
        this.scope = this.getScope(target);
        if (this.scope)
          this.scope.init();
      }
      function setContext(context) {
        if (this.skipKeys != null) {
          this.skipKeys = {};
        }
        this._traverseFlags = 0;
        if (context) {
          this.context = context;
          this.state = context.state;
          this.opts = context.opts;
        }
        this.setScope();
        return this;
      }
      function resync() {
        if (this.removed)
          return;
        this._resyncParent();
        this._resyncList();
        this._resyncKey();
      }
      function _resyncParent() {
        if (this.parentPath) {
          this.parent = this.parentPath.node;
        }
      }
      function _resyncKey() {
        if (!this.container)
          return;
        if (this.node === this.container[this.key]) {
          return;
        }
        if (Array.isArray(this.container)) {
          for (let i = 0; i < this.container.length; i++) {
            if (this.container[i] === this.node) {
              return this.setKey(i);
            }
          }
        } else {
          for (const key of Object.keys(this.container)) {
            if (this.container[key] === this.node) {
              return this.setKey(key);
            }
          }
        }
        this.key = null;
      }
      function _resyncList() {
        if (!this.parent || !this.inList)
          return;
        const newContainer = this.parent[this.listKey];
        if (this.container === newContainer)
          return;
        this.container = newContainer || null;
      }
      function _resyncRemoved() {
        if (this.key == null || !this.container || this.container[this.key] !== this.node) {
          this._markRemoved();
        }
      }
      function popContext() {
        this.contexts.pop();
        if (this.contexts.length > 0) {
          this.setContext(this.contexts[this.contexts.length - 1]);
        } else {
          this.setContext(void 0);
        }
      }
      function pushContext(context) {
        this.contexts.push(context);
        this.setContext(context);
      }
      function setup(parentPath, container, listKey, key) {
        this.listKey = listKey;
        this.container = container;
        this.parentPath = parentPath || this.parentPath;
        this.setKey(key);
      }
      function setKey(key) {
        var _this$node;
        this.key = key;
        this.node = this.container[this.key];
        this.type = (_this$node = this.node) == null ? void 0 : _this$node.type;
      }
      function requeue(pathToQueue = this) {
        if (pathToQueue.removed)
          return;
        ;
        const contexts = this.contexts;
        for (const context of contexts) {
          context.maybeQueue(pathToQueue);
        }
      }
      function _getQueueContexts() {
        let path = this;
        let contexts = this.contexts;
        while (!contexts.length) {
          path = path.parentPath;
          if (!path)
            break;
          contexts = path.contexts;
        }
        return contexts;
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/lib/removal-hooks.js
  var require_removal_hooks = __commonJS({
    "node_modules/@babel/traverse/lib/path/lib/removal-hooks.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.hooks = void 0;
      var hooks = [function(self2, parent2) {
        const removeParent = self2.key === "test" && (parent2.isWhile() || parent2.isSwitchCase()) || self2.key === "declaration" && parent2.isExportDeclaration() || self2.key === "body" && parent2.isLabeledStatement() || self2.listKey === "declarations" && parent2.isVariableDeclaration() && parent2.node.declarations.length === 1 || self2.key === "expression" && parent2.isExpressionStatement();
        if (removeParent) {
          parent2.remove();
          return true;
        }
      }, function(self2, parent2) {
        if (parent2.isSequenceExpression() && parent2.node.expressions.length === 1) {
          parent2.replaceWith(parent2.node.expressions[0]);
          return true;
        }
      }, function(self2, parent2) {
        if (parent2.isBinary()) {
          if (self2.key === "left") {
            parent2.replaceWith(parent2.node.right);
          } else {
            parent2.replaceWith(parent2.node.left);
          }
          return true;
        }
      }, function(self2, parent2) {
        if (parent2.isIfStatement() && self2.key === "consequent" || self2.key === "body" && (parent2.isLoop() || parent2.isArrowFunctionExpression())) {
          self2.replaceWith({
            type: "BlockStatement",
            body: []
          });
          return true;
        }
      }];
      exports2.hooks = hooks;
    }
  });

  // node_modules/@babel/traverse/lib/path/removal.js
  var require_removal = __commonJS({
    "node_modules/@babel/traverse/lib/path/removal.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._assertUnremoved = _assertUnremoved;
      exports2._callRemovalHooks = _callRemovalHooks;
      exports2._markRemoved = _markRemoved;
      exports2._remove = _remove;
      exports2._removeFromScope = _removeFromScope;
      exports2.remove = remove2;
      var _removalHooks = require_removal_hooks();
      var _cache = require_cache2();
      var _index = require_path();
      function remove2() {
        var _this$opts;
        this._assertUnremoved();
        this.resync();
        if (!((_this$opts = this.opts) != null && _this$opts.noScope)) {
          this._removeFromScope();
        }
        if (this._callRemovalHooks()) {
          this._markRemoved();
          return;
        }
        this.shareCommentsWithSiblings();
        this._remove();
        this._markRemoved();
      }
      function _removeFromScope() {
        const bindings = this.getBindingIdentifiers();
        Object.keys(bindings).forEach((name) => this.scope.removeBinding(name));
      }
      function _callRemovalHooks() {
        for (const fn of _removalHooks.hooks) {
          if (fn(this, this.parentPath))
            return true;
        }
      }
      function _remove() {
        if (Array.isArray(this.container)) {
          this.container.splice(this.key, 1);
          this.updateSiblingKeys(this.key, -1);
        } else {
          this._replaceWith(null);
        }
      }
      function _markRemoved() {
        this._traverseFlags |= _index.SHOULD_SKIP | _index.REMOVED;
        if (this.parent)
          _cache.path.get(this.parent).delete(this.node);
        this.node = null;
      }
      function _assertUnremoved() {
        if (this.removed) {
          throw this.buildCodeFrameError("NodePath has been removed so is read-only.");
        }
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/lib/hoister.js
  var require_hoister = __commonJS({
    "node_modules/@babel/traverse/lib/path/lib/hoister.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _t = require_lib5();
      var _t2 = _t;
      var {
        react
      } = _t;
      var {
        cloneNode,
        jsxExpressionContainer,
        variableDeclaration,
        variableDeclarator
      } = _t2;
      var referenceVisitor = {
        ReferencedIdentifier(path, state) {
          if (path.isJSXIdentifier() && react.isCompatTag(path.node.name) && !path.parentPath.isJSXMemberExpression()) {
            return;
          }
          if (path.node.name === "this") {
            let scope = path.scope;
            do {
              if (scope.path.isFunction() && !scope.path.isArrowFunctionExpression()) {
                break;
              }
            } while (scope = scope.parent);
            if (scope)
              state.breakOnScopePaths.push(scope.path);
          }
          const binding = path.scope.getBinding(path.node.name);
          if (!binding)
            return;
          for (const violation of binding.constantViolations) {
            if (violation.scope !== binding.path.scope) {
              state.mutableBinding = true;
              path.stop();
              return;
            }
          }
          if (binding !== state.scope.getBinding(path.node.name))
            return;
          state.bindings[path.node.name] = binding;
        }
      };
      var PathHoister = class {
        constructor(path, scope) {
          this.breakOnScopePaths = void 0;
          this.bindings = void 0;
          this.mutableBinding = void 0;
          this.scopes = void 0;
          this.scope = void 0;
          this.path = void 0;
          this.attachAfter = void 0;
          this.breakOnScopePaths = [];
          this.bindings = {};
          this.mutableBinding = false;
          this.scopes = [];
          this.scope = scope;
          this.path = path;
          this.attachAfter = false;
        }
        isCompatibleScope(scope) {
          for (const key of Object.keys(this.bindings)) {
            const binding = this.bindings[key];
            if (!scope.bindingIdentifierEquals(key, binding.identifier)) {
              return false;
            }
          }
          return true;
        }
        getCompatibleScopes() {
          let scope = this.path.scope;
          do {
            if (this.isCompatibleScope(scope)) {
              this.scopes.push(scope);
            } else {
              break;
            }
            if (this.breakOnScopePaths.indexOf(scope.path) >= 0) {
              break;
            }
          } while (scope = scope.parent);
        }
        getAttachmentPath() {
          let path = this._getAttachmentPath();
          if (!path)
            return;
          let targetScope = path.scope;
          if (targetScope.path === path) {
            targetScope = path.scope.parent;
          }
          if (targetScope.path.isProgram() || targetScope.path.isFunction()) {
            for (const name of Object.keys(this.bindings)) {
              if (!targetScope.hasOwnBinding(name))
                continue;
              const binding = this.bindings[name];
              if (binding.kind === "param" || binding.path.parentKey === "params") {
                continue;
              }
              const bindingParentPath = this.getAttachmentParentForPath(binding.path);
              if (bindingParentPath.key >= path.key) {
                this.attachAfter = true;
                path = binding.path;
                for (const violationPath of binding.constantViolations) {
                  if (this.getAttachmentParentForPath(violationPath).key > path.key) {
                    path = violationPath;
                  }
                }
              }
            }
          }
          return path;
        }
        _getAttachmentPath() {
          const scopes = this.scopes;
          const scope = scopes.pop();
          if (!scope)
            return;
          if (scope.path.isFunction()) {
            if (this.hasOwnParamBindings(scope)) {
              if (this.scope === scope)
                return;
              const bodies = scope.path.get("body").get("body");
              for (let i = 0; i < bodies.length; i++) {
                if (bodies[i].node._blockHoist)
                  continue;
                return bodies[i];
              }
            } else {
              return this.getNextScopeAttachmentParent();
            }
          } else if (scope.path.isProgram()) {
            return this.getNextScopeAttachmentParent();
          }
        }
        getNextScopeAttachmentParent() {
          const scope = this.scopes.pop();
          if (scope)
            return this.getAttachmentParentForPath(scope.path);
        }
        getAttachmentParentForPath(path) {
          do {
            if (!path.parentPath || Array.isArray(path.container) && path.isStatement()) {
              return path;
            }
          } while (path = path.parentPath);
        }
        hasOwnParamBindings(scope) {
          for (const name of Object.keys(this.bindings)) {
            if (!scope.hasOwnBinding(name))
              continue;
            const binding = this.bindings[name];
            if (binding.kind === "param" && binding.constant)
              return true;
          }
          return false;
        }
        run() {
          this.path.traverse(referenceVisitor, this);
          if (this.mutableBinding)
            return;
          this.getCompatibleScopes();
          const attachTo = this.getAttachmentPath();
          if (!attachTo)
            return;
          if (attachTo.getFunctionParent() === this.path.getFunctionParent())
            return;
          let uid = attachTo.scope.generateUidIdentifier("ref");
          const declarator = variableDeclarator(uid, this.path.node);
          const insertFn = this.attachAfter ? "insertAfter" : "insertBefore";
          const [attached] = attachTo[insertFn]([attachTo.isVariableDeclarator() ? declarator : variableDeclaration("var", [declarator])]);
          const parent2 = this.path.parentPath;
          if (parent2.isJSXElement() && this.path.container === parent2.node.children) {
            uid = jsxExpressionContainer(uid);
          }
          this.path.replaceWith(cloneNode(uid));
          return attachTo.isVariableDeclarator() ? attached.get("init") : attached.get("declarations.0.init");
        }
      };
      exports2.default = PathHoister;
    }
  });

  // node_modules/@babel/traverse/lib/path/modification.js
  var require_modification = __commonJS({
    "node_modules/@babel/traverse/lib/path/modification.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._containerInsert = _containerInsert;
      exports2._containerInsertAfter = _containerInsertAfter;
      exports2._containerInsertBefore = _containerInsertBefore;
      exports2._verifyNodeList = _verifyNodeList;
      exports2.hoist = hoist;
      exports2.insertAfter = insertAfter;
      exports2.insertBefore = insertBefore;
      exports2.pushContainer = pushContainer;
      exports2.unshiftContainer = unshiftContainer;
      exports2.updateSiblingKeys = updateSiblingKeys;
      var _cache = require_cache2();
      var _hoister = require_hoister();
      var _index = require_path();
      var _t = require_lib5();
      var {
        arrowFunctionExpression: arrowFunctionExpression2,
        assertExpression,
        assignmentExpression,
        blockStatement,
        callExpression,
        cloneNode,
        expressionStatement: expressionStatement2,
        isAssignmentExpression,
        isCallExpression,
        isExpression,
        isIdentifier: isIdentifier2,
        isSequenceExpression,
        isSuper,
        thisExpression
      } = _t;
      function insertBefore(nodes_) {
        this._assertUnremoved();
        const nodes = this._verifyNodeList(nodes_);
        const {
          parentPath
        } = this;
        if (parentPath.isExpressionStatement() || parentPath.isLabeledStatement() || parentPath.isExportNamedDeclaration() || parentPath.isExportDefaultDeclaration() && this.isDeclaration()) {
          return parentPath.insertBefore(nodes);
        } else if (this.isNodeType("Expression") && !this.isJSXElement() || parentPath.isForStatement() && this.key === "init") {
          if (this.node)
            nodes.push(this.node);
          return this.replaceExpressionWithStatements(nodes);
        } else if (Array.isArray(this.container)) {
          return this._containerInsertBefore(nodes);
        } else if (this.isStatementOrBlock()) {
          const node = this.node;
          const shouldInsertCurrentNode = node && (!this.isExpressionStatement() || node.expression != null);
          this.replaceWith(blockStatement(shouldInsertCurrentNode ? [node] : []));
          return this.unshiftContainer(
            "body",
            nodes
          );
        } else {
          throw new Error("We don't know what to do with this node type. We were previously a Statement but we can't fit in here?");
        }
      }
      function _containerInsert(from, nodes) {
        this.updateSiblingKeys(from, nodes.length);
        const paths = [];
        this.container.splice(from, 0, ...nodes);
        for (let i = 0; i < nodes.length; i++) {
          const to = from + i;
          const path = this.getSibling(to);
          paths.push(path);
          if (this.context && this.context.queue) {
            path.pushContext(this.context);
          }
        }
        const contexts = this._getQueueContexts();
        for (const path of paths) {
          path.setScope();
          path.debug("Inserted.");
          for (const context of contexts) {
            context.maybeQueue(path, true);
          }
        }
        return paths;
      }
      function _containerInsertBefore(nodes) {
        return this._containerInsert(this.key, nodes);
      }
      function _containerInsertAfter(nodes) {
        return this._containerInsert(this.key + 1, nodes);
      }
      var last2 = (arr) => arr[arr.length - 1];
      function isHiddenInSequenceExpression(path) {
        return isSequenceExpression(path.parent) && (last2(path.parent.expressions) !== path.node || isHiddenInSequenceExpression(path.parentPath));
      }
      function isAlmostConstantAssignment(node, scope) {
        if (!isAssignmentExpression(node) || !isIdentifier2(node.left)) {
          return false;
        }
        const blockScope = scope.getBlockParent();
        return blockScope.hasOwnBinding(node.left.name) && blockScope.getOwnBinding(node.left.name).constantViolations.length <= 1;
      }
      function insertAfter(nodes_) {
        this._assertUnremoved();
        if (this.isSequenceExpression()) {
          return last2(this.get("expressions")).insertAfter(nodes_);
        }
        const nodes = this._verifyNodeList(nodes_);
        const {
          parentPath
        } = this;
        if (parentPath.isExpressionStatement() || parentPath.isLabeledStatement() || parentPath.isExportNamedDeclaration() || parentPath.isExportDefaultDeclaration() && this.isDeclaration()) {
          return parentPath.insertAfter(nodes.map((node) => {
            return isExpression(node) ? expressionStatement2(node) : node;
          }));
        } else if (this.isNodeType("Expression") && !this.isJSXElement() && !parentPath.isJSXElement() || parentPath.isForStatement() && this.key === "init") {
          if (this.node) {
            const node = this.node;
            let {
              scope
            } = this;
            if (scope.path.isPattern()) {
              assertExpression(node);
              this.replaceWith(callExpression(arrowFunctionExpression2([], node), []));
              this.get("callee.body").insertAfter(nodes);
              return [this];
            }
            if (isHiddenInSequenceExpression(this)) {
              nodes.unshift(node);
            } else if (isCallExpression(node) && isSuper(node.callee)) {
              nodes.unshift(node);
              nodes.push(thisExpression());
            } else if (isAlmostConstantAssignment(node, scope)) {
              nodes.unshift(node);
              nodes.push(cloneNode(node.left));
            } else if (scope.isPure(node, true)) {
              nodes.push(node);
            } else {
              if (parentPath.isMethod({
                computed: true,
                key: node
              })) {
                scope = scope.parent;
              }
              const temp = scope.generateDeclaredUidIdentifier();
              nodes.unshift(expressionStatement2(
                assignmentExpression("=", cloneNode(temp), node)
              ));
              nodes.push(expressionStatement2(cloneNode(temp)));
            }
          }
          return this.replaceExpressionWithStatements(nodes);
        } else if (Array.isArray(this.container)) {
          return this._containerInsertAfter(nodes);
        } else if (this.isStatementOrBlock()) {
          const node = this.node;
          const shouldInsertCurrentNode = node && (!this.isExpressionStatement() || node.expression != null);
          this.replaceWith(blockStatement(shouldInsertCurrentNode ? [node] : []));
          return this.pushContainer("body", nodes);
        } else {
          throw new Error("We don't know what to do with this node type. We were previously a Statement but we can't fit in here?");
        }
      }
      function updateSiblingKeys(fromIndex, incrementBy) {
        if (!this.parent)
          return;
        const paths = _cache.path.get(this.parent);
        for (const [, path] of paths) {
          if (path.key >= fromIndex) {
            path.key += incrementBy;
          }
        }
      }
      function _verifyNodeList(nodes) {
        if (!nodes) {
          return [];
        }
        if (!Array.isArray(nodes)) {
          nodes = [nodes];
        }
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          let msg;
          if (!node) {
            msg = "has falsy node";
          } else if (typeof node !== "object") {
            msg = "contains a non-object node";
          } else if (!node.type) {
            msg = "without a type";
          } else if (node instanceof _index.default) {
            msg = "has a NodePath when it expected a raw object";
          }
          if (msg) {
            const type = Array.isArray(node) ? "array" : typeof node;
            throw new Error(`Node list ${msg} with the index of ${i} and type of ${type}`);
          }
        }
        return nodes;
      }
      function unshiftContainer(listKey, nodes) {
        this._assertUnremoved();
        nodes = this._verifyNodeList(nodes);
        const path = _index.default.get({
          parentPath: this,
          parent: this.node,
          container: this.node[listKey],
          listKey,
          key: 0
        }).setContext(this.context);
        return path._containerInsertBefore(
          nodes
        );
      }
      function pushContainer(listKey, nodes) {
        this._assertUnremoved();
        const verifiedNodes = this._verifyNodeList(
          nodes
        );
        const container = this.node[listKey];
        const path = _index.default.get({
          parentPath: this,
          parent: this.node,
          container,
          listKey,
          key: container.length
        }).setContext(this.context);
        return path.replaceWithMultiple(verifiedNodes);
      }
      function hoist(scope = this.scope) {
        const hoister = new _hoister.default(this, scope);
        return hoister.run();
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/family.js
  var require_family = __commonJS({
    "node_modules/@babel/traverse/lib/path/family.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2._getKey = _getKey;
      exports2._getPattern = _getPattern;
      exports2.get = get2;
      exports2.getAllNextSiblings = getAllNextSiblings;
      exports2.getAllPrevSiblings = getAllPrevSiblings;
      exports2.getBindingIdentifierPaths = getBindingIdentifierPaths;
      exports2.getBindingIdentifiers = getBindingIdentifiers;
      exports2.getCompletionRecords = getCompletionRecords;
      exports2.getNextSibling = getNextSibling;
      exports2.getOpposite = getOpposite;
      exports2.getOuterBindingIdentifierPaths = getOuterBindingIdentifierPaths;
      exports2.getOuterBindingIdentifiers = getOuterBindingIdentifiers;
      exports2.getPrevSibling = getPrevSibling;
      exports2.getSibling = getSibling;
      var _index = require_path();
      var _t = require_lib5();
      var {
        getBindingIdentifiers: _getBindingIdentifiers,
        getOuterBindingIdentifiers: _getOuterBindingIdentifiers,
        isDeclaration,
        numericLiteral,
        unaryExpression
      } = _t;
      var NORMAL_COMPLETION = 0;
      var BREAK_COMPLETION = 1;
      function NormalCompletion(path) {
        return {
          type: NORMAL_COMPLETION,
          path
        };
      }
      function BreakCompletion(path) {
        return {
          type: BREAK_COMPLETION,
          path
        };
      }
      function getOpposite() {
        if (this.key === "left") {
          return this.getSibling("right");
        } else if (this.key === "right") {
          return this.getSibling("left");
        }
        return null;
      }
      function addCompletionRecords(path, records, context) {
        if (path) {
          records.push(..._getCompletionRecords(path, context));
        }
        return records;
      }
      function completionRecordForSwitch(cases, records, context) {
        let lastNormalCompletions = [];
        for (let i = 0; i < cases.length; i++) {
          const casePath = cases[i];
          const caseCompletions = _getCompletionRecords(casePath, context);
          const normalCompletions = [];
          const breakCompletions = [];
          for (const c of caseCompletions) {
            if (c.type === NORMAL_COMPLETION) {
              normalCompletions.push(c);
            }
            if (c.type === BREAK_COMPLETION) {
              breakCompletions.push(c);
            }
          }
          if (normalCompletions.length) {
            lastNormalCompletions = normalCompletions;
          }
          records.push(...breakCompletions);
        }
        records.push(...lastNormalCompletions);
        return records;
      }
      function normalCompletionToBreak(completions) {
        completions.forEach((c) => {
          c.type = BREAK_COMPLETION;
        });
      }
      function replaceBreakStatementInBreakCompletion(completions, reachable) {
        completions.forEach((c) => {
          if (c.path.isBreakStatement({
            label: null
          })) {
            if (reachable) {
              c.path.replaceWith(unaryExpression("void", numericLiteral(0)));
            } else {
              c.path.remove();
            }
          }
        });
      }
      function getStatementListCompletion(paths, context) {
        const completions = [];
        if (context.canHaveBreak) {
          let lastNormalCompletions = [];
          for (let i = 0; i < paths.length; i++) {
            const path = paths[i];
            const newContext = Object.assign({}, context, {
              inCaseClause: false
            });
            if (path.isBlockStatement() && (context.inCaseClause || context.shouldPopulateBreak)) {
              newContext.shouldPopulateBreak = true;
            } else {
              newContext.shouldPopulateBreak = false;
            }
            const statementCompletions = _getCompletionRecords(path, newContext);
            if (statementCompletions.length > 0 && statementCompletions.every((c) => c.type === BREAK_COMPLETION)) {
              if (lastNormalCompletions.length > 0 && statementCompletions.every((c) => c.path.isBreakStatement({
                label: null
              }))) {
                normalCompletionToBreak(lastNormalCompletions);
                completions.push(...lastNormalCompletions);
                if (lastNormalCompletions.some((c) => c.path.isDeclaration())) {
                  completions.push(...statementCompletions);
                  replaceBreakStatementInBreakCompletion(statementCompletions, true);
                }
                replaceBreakStatementInBreakCompletion(statementCompletions, false);
              } else {
                completions.push(...statementCompletions);
                if (!context.shouldPopulateBreak) {
                  replaceBreakStatementInBreakCompletion(statementCompletions, true);
                }
              }
              break;
            }
            if (i === paths.length - 1) {
              completions.push(...statementCompletions);
            } else {
              lastNormalCompletions = [];
              for (let i2 = 0; i2 < statementCompletions.length; i2++) {
                const c = statementCompletions[i2];
                if (c.type === BREAK_COMPLETION) {
                  completions.push(c);
                }
                if (c.type === NORMAL_COMPLETION) {
                  lastNormalCompletions.push(c);
                }
              }
            }
          }
        } else if (paths.length) {
          for (let i = paths.length - 1; i >= 0; i--) {
            const pathCompletions = _getCompletionRecords(paths[i], context);
            if (pathCompletions.length > 1 || pathCompletions.length === 1 && !pathCompletions[0].path.isVariableDeclaration()) {
              completions.push(...pathCompletions);
              break;
            }
          }
        }
        return completions;
      }
      function _getCompletionRecords(path, context) {
        let records = [];
        if (path.isIfStatement()) {
          records = addCompletionRecords(path.get("consequent"), records, context);
          records = addCompletionRecords(path.get("alternate"), records, context);
        } else if (path.isDoExpression() || path.isFor() || path.isWhile() || path.isLabeledStatement()) {
          return addCompletionRecords(path.get("body"), records, context);
        } else if (path.isProgram() || path.isBlockStatement()) {
          return getStatementListCompletion(path.get("body"), context);
        } else if (path.isFunction()) {
          return _getCompletionRecords(path.get("body"), context);
        } else if (path.isTryStatement()) {
          records = addCompletionRecords(path.get("block"), records, context);
          records = addCompletionRecords(path.get("handler"), records, context);
        } else if (path.isCatchClause()) {
          return addCompletionRecords(path.get("body"), records, context);
        } else if (path.isSwitchStatement()) {
          return completionRecordForSwitch(path.get("cases"), records, context);
        } else if (path.isSwitchCase()) {
          return getStatementListCompletion(path.get("consequent"), {
            canHaveBreak: true,
            shouldPopulateBreak: false,
            inCaseClause: true
          });
        } else if (path.isBreakStatement()) {
          records.push(BreakCompletion(path));
        } else {
          records.push(NormalCompletion(path));
        }
        return records;
      }
      function getCompletionRecords() {
        const records = _getCompletionRecords(this, {
          canHaveBreak: false,
          shouldPopulateBreak: false,
          inCaseClause: false
        });
        return records.map((r) => r.path);
      }
      function getSibling(key) {
        return _index.default.get({
          parentPath: this.parentPath,
          parent: this.parent,
          container: this.container,
          listKey: this.listKey,
          key
        }).setContext(this.context);
      }
      function getPrevSibling() {
        return this.getSibling(this.key - 1);
      }
      function getNextSibling() {
        return this.getSibling(this.key + 1);
      }
      function getAllNextSiblings() {
        let _key = this.key;
        let sibling = this.getSibling(++_key);
        const siblings = [];
        while (sibling.node) {
          siblings.push(sibling);
          sibling = this.getSibling(++_key);
        }
        return siblings;
      }
      function getAllPrevSiblings() {
        let _key = this.key;
        let sibling = this.getSibling(--_key);
        const siblings = [];
        while (sibling.node) {
          siblings.push(sibling);
          sibling = this.getSibling(--_key);
        }
        return siblings;
      }
      function get2(key, context = true) {
        if (context === true)
          context = this.context;
        const parts = key.split(".");
        if (parts.length === 1) {
          return this._getKey(key, context);
        } else {
          return this._getPattern(parts, context);
        }
      }
      function _getKey(key, context) {
        const node = this.node;
        const container = node[key];
        if (Array.isArray(container)) {
          return container.map((_, i) => {
            return _index.default.get({
              listKey: key,
              parentPath: this,
              parent: node,
              container,
              key: i
            }).setContext(context);
          });
        } else {
          return _index.default.get({
            parentPath: this,
            parent: node,
            container: node,
            key
          }).setContext(context);
        }
      }
      function _getPattern(parts, context) {
        let path = this;
        for (const part of parts) {
          if (part === ".") {
            path = path.parentPath;
          } else {
            if (Array.isArray(path)) {
              path = path[part];
            } else {
              path = path.get(part, context);
            }
          }
        }
        return path;
      }
      function getBindingIdentifiers(duplicates) {
        return _getBindingIdentifiers(this.node, duplicates);
      }
      function getOuterBindingIdentifiers(duplicates) {
        return _getOuterBindingIdentifiers(this.node, duplicates);
      }
      function getBindingIdentifierPaths(duplicates = false, outerOnly = false) {
        const path = this;
        const search = [path];
        const ids = /* @__PURE__ */ Object.create(null);
        while (search.length) {
          const id = search.shift();
          if (!id)
            continue;
          if (!id.node)
            continue;
          const keys2 = _getBindingIdentifiers.keys[id.node.type];
          if (id.isIdentifier()) {
            if (duplicates) {
              const _ids = ids[id.node.name] = ids[id.node.name] || [];
              _ids.push(id);
            } else {
              ids[id.node.name] = id;
            }
            continue;
          }
          if (id.isExportDeclaration()) {
            const declaration = id.get("declaration");
            if (isDeclaration(declaration)) {
              search.push(declaration);
            }
            continue;
          }
          if (outerOnly) {
            if (id.isFunctionDeclaration()) {
              search.push(id.get("id"));
              continue;
            }
            if (id.isFunctionExpression()) {
              continue;
            }
          }
          if (keys2) {
            for (let i = 0; i < keys2.length; i++) {
              const key = keys2[i];
              const child = id.get(key);
              if (Array.isArray(child)) {
                search.push(...child);
              } else if (child.node) {
                search.push(child);
              }
            }
          }
        }
        return ids;
      }
      function getOuterBindingIdentifierPaths(duplicates = false) {
        return this.getBindingIdentifierPaths(duplicates, true);
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/comments.js
  var require_comments = __commonJS({
    "node_modules/@babel/traverse/lib/path/comments.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.addComment = addComment;
      exports2.addComments = addComments;
      exports2.shareCommentsWithSiblings = shareCommentsWithSiblings;
      var _t = require_lib5();
      var {
        addComment: _addComment,
        addComments: _addComments
      } = _t;
      function shareCommentsWithSiblings() {
        if (typeof this.key === "string")
          return;
        const node = this.node;
        if (!node)
          return;
        const trailing = node.trailingComments;
        const leading = node.leadingComments;
        if (!trailing && !leading)
          return;
        const prev = this.getSibling(this.key - 1);
        const next = this.getSibling(this.key + 1);
        const hasPrev = Boolean(prev.node);
        const hasNext = Boolean(next.node);
        if (hasPrev && !hasNext) {
          prev.addComments("trailing", trailing);
        } else if (hasNext && !hasPrev) {
          next.addComments("leading", leading);
        }
      }
      function addComment(type, content, line) {
        _addComment(this.node, type, content, line);
      }
      function addComments(type, comments) {
        _addComments(this.node, type, comments);
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/lib/virtual-types-validator.js
  var require_virtual_types_validator = __commonJS({
    "node_modules/@babel/traverse/lib/path/lib/virtual-types-validator.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.isBindingIdentifier = isBindingIdentifier;
      exports2.isBlockScoped = isBlockScoped;
      exports2.isExistentialTypeParam = isExistentialTypeParam;
      exports2.isExpression = isExpression;
      exports2.isFlow = isFlow;
      exports2.isForAwaitStatement = isForAwaitStatement;
      exports2.isGenerated = isGenerated;
      exports2.isNumericLiteralTypeAnnotation = isNumericLiteralTypeAnnotation;
      exports2.isPure = isPure;
      exports2.isReferenced = isReferenced;
      exports2.isReferencedIdentifier = isReferencedIdentifier;
      exports2.isReferencedMemberExpression = isReferencedMemberExpression;
      exports2.isRestProperty = isRestProperty;
      exports2.isScope = isScope;
      exports2.isSpreadProperty = isSpreadProperty;
      exports2.isStatement = isStatement;
      exports2.isUser = isUser;
      exports2.isVar = isVar;
      var _t = require_lib5();
      var {
        isBinding,
        isBlockScoped: nodeIsBlockScoped,
        isExportDeclaration,
        isExpression: nodeIsExpression,
        isFlow: nodeIsFlow,
        isForStatement,
        isForXStatement,
        isIdentifier: isIdentifier2,
        isImportDeclaration,
        isImportSpecifier,
        isJSXIdentifier,
        isJSXMemberExpression,
        isMemberExpression,
        isRestElement: nodeIsRestElement,
        isReferenced: nodeIsReferenced,
        isScope: nodeIsScope,
        isStatement: nodeIsStatement,
        isVar: nodeIsVar,
        isVariableDeclaration,
        react,
        isForOfStatement
      } = _t;
      var {
        isCompatTag
      } = react;
      function isReferencedIdentifier(opts) {
        const {
          node,
          parent: parent2
        } = this;
        if (!isIdentifier2(node, opts) && !isJSXMemberExpression(parent2, opts)) {
          if (isJSXIdentifier(node, opts)) {
            if (isCompatTag(node.name))
              return false;
          } else {
            return false;
          }
        }
        return nodeIsReferenced(node, parent2, this.parentPath.parent);
      }
      function isReferencedMemberExpression() {
        const {
          node,
          parent: parent2
        } = this;
        return isMemberExpression(node) && nodeIsReferenced(node, parent2);
      }
      function isBindingIdentifier() {
        const {
          node,
          parent: parent2
        } = this;
        const grandparent = this.parentPath.parent;
        return isIdentifier2(node) && isBinding(node, parent2, grandparent);
      }
      function isStatement() {
        const {
          node,
          parent: parent2
        } = this;
        if (nodeIsStatement(node)) {
          if (isVariableDeclaration(node)) {
            if (isForXStatement(parent2, {
              left: node
            }))
              return false;
            if (isForStatement(parent2, {
              init: node
            }))
              return false;
          }
          return true;
        } else {
          return false;
        }
      }
      function isExpression() {
        if (this.isIdentifier()) {
          return this.isReferencedIdentifier();
        } else {
          return nodeIsExpression(this.node);
        }
      }
      function isScope() {
        return nodeIsScope(this.node, this.parent);
      }
      function isReferenced() {
        return nodeIsReferenced(this.node, this.parent);
      }
      function isBlockScoped() {
        return nodeIsBlockScoped(this.node);
      }
      function isVar() {
        return nodeIsVar(this.node);
      }
      function isUser() {
        return this.node && !!this.node.loc;
      }
      function isGenerated() {
        return !this.isUser();
      }
      function isPure(constantsOnly) {
        return this.scope.isPure(this.node, constantsOnly);
      }
      function isFlow() {
        const {
          node
        } = this;
        if (nodeIsFlow(node)) {
          return true;
        } else if (isImportDeclaration(node)) {
          return node.importKind === "type" || node.importKind === "typeof";
        } else if (isExportDeclaration(node)) {
          return node.exportKind === "type";
        } else if (isImportSpecifier(node)) {
          return node.importKind === "type" || node.importKind === "typeof";
        } else {
          return false;
        }
      }
      function isRestProperty() {
        return nodeIsRestElement(this.node) && this.parentPath && this.parentPath.isObjectPattern();
      }
      function isSpreadProperty() {
        return nodeIsRestElement(this.node) && this.parentPath && this.parentPath.isObjectExpression();
      }
      function isForAwaitStatement() {
        return isForOfStatement(this.node, {
          await: true
        });
      }
      function isExistentialTypeParam() {
        throw new Error("`path.isExistentialTypeParam` has been renamed to `path.isExistsTypeAnnotation()` in Babel 7.");
      }
      function isNumericLiteralTypeAnnotation() {
        throw new Error("`path.isNumericLiteralTypeAnnotation()` has been renamed to `path.isNumberLiteralTypeAnnotation()` in Babel 7.");
      }
    }
  });

  // node_modules/@babel/traverse/lib/path/index.js
  var require_path = __commonJS({
    "node_modules/@babel/traverse/lib/path/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = exports2.SHOULD_STOP = exports2.SHOULD_SKIP = exports2.REMOVED = void 0;
      var virtualTypes = require_virtual_types();
      var _debug = require_browser2();
      var _index = require_lib14();
      var _scope = require_scope();
      var _t = require_lib5();
      var t3 = _t;
      var _cache = require_cache2();
      var _generator = require_lib6();
      var NodePath_ancestry = require_ancestry();
      var NodePath_inference = require_inference();
      var NodePath_replacement = require_replacement();
      var NodePath_evaluation = require_evaluation();
      var NodePath_conversion = require_conversion();
      var NodePath_introspection = require_introspection();
      var NodePath_context = require_context();
      var NodePath_removal = require_removal();
      var NodePath_modification = require_modification();
      var NodePath_family = require_family();
      var NodePath_comments = require_comments();
      var NodePath_virtual_types_validator = require_virtual_types_validator();
      var {
        validate
      } = _t;
      var debug2 = _debug("babel");
      var REMOVED = 1 << 0;
      exports2.REMOVED = REMOVED;
      var SHOULD_STOP = 1 << 1;
      exports2.SHOULD_STOP = SHOULD_STOP;
      var SHOULD_SKIP = 1 << 2;
      exports2.SHOULD_SKIP = SHOULD_SKIP;
      var NodePath2 = class {
        constructor(hub, parent2) {
          this.contexts = [];
          this.state = null;
          this.opts = null;
          this._traverseFlags = 0;
          this.skipKeys = null;
          this.parentPath = null;
          this.container = null;
          this.listKey = null;
          this.key = null;
          this.node = null;
          this.type = null;
          this.parent = parent2;
          this.hub = hub;
          this.data = null;
          this.context = null;
          this.scope = null;
        }
        static get({
          hub,
          parentPath,
          parent: parent2,
          container,
          listKey,
          key
        }) {
          if (!hub && parentPath) {
            hub = parentPath.hub;
          }
          if (!parent2) {
            throw new Error("To get a node path the parent needs to exist");
          }
          const targetNode = container[key];
          let paths = _cache.path.get(parent2);
          if (!paths) {
            paths = /* @__PURE__ */ new Map();
            _cache.path.set(parent2, paths);
          }
          let path = paths.get(targetNode);
          if (!path) {
            path = new NodePath2(hub, parent2);
            if (targetNode)
              paths.set(targetNode, path);
          }
          path.setup(parentPath, container, listKey, key);
          return path;
        }
        getScope(scope) {
          return this.isScope() ? new _scope.default(this) : scope;
        }
        setData(key, val) {
          if (this.data == null) {
            this.data = /* @__PURE__ */ Object.create(null);
          }
          return this.data[key] = val;
        }
        getData(key, def) {
          if (this.data == null) {
            this.data = /* @__PURE__ */ Object.create(null);
          }
          let val = this.data[key];
          if (val === void 0 && def !== void 0)
            val = this.data[key] = def;
          return val;
        }
        hasNode() {
          return this.node != null;
        }
        buildCodeFrameError(msg, Error2 = SyntaxError) {
          return this.hub.buildError(this.node, msg, Error2);
        }
        traverse(visitor, state) {
          (0, _index.default)(this.node, visitor, this.scope, state, this);
        }
        set(key, node) {
          validate(this.node, key, node);
          this.node[key] = node;
        }
        getPathLocation() {
          const parts = [];
          let path = this;
          do {
            let key = path.key;
            if (path.inList)
              key = `${path.listKey}[${key}]`;
            parts.unshift(key);
          } while (path = path.parentPath);
          return parts.join(".");
        }
        debug(message) {
          if (!debug2.enabled)
            return;
          debug2(`${this.getPathLocation()} ${this.type}: ${message}`);
        }
        toString() {
          return (0, _generator.default)(this.node).code;
        }
        get inList() {
          return !!this.listKey;
        }
        set inList(inList) {
          if (!inList) {
            this.listKey = null;
          }
        }
        get parentKey() {
          return this.listKey || this.key;
        }
        get shouldSkip() {
          return !!(this._traverseFlags & SHOULD_SKIP);
        }
        set shouldSkip(v) {
          if (v) {
            this._traverseFlags |= SHOULD_SKIP;
          } else {
            this._traverseFlags &= ~SHOULD_SKIP;
          }
        }
        get shouldStop() {
          return !!(this._traverseFlags & SHOULD_STOP);
        }
        set shouldStop(v) {
          if (v) {
            this._traverseFlags |= SHOULD_STOP;
          } else {
            this._traverseFlags &= ~SHOULD_STOP;
          }
        }
        get removed() {
          return !!(this._traverseFlags & REMOVED);
        }
        set removed(v) {
          if (v) {
            this._traverseFlags |= REMOVED;
          } else {
            this._traverseFlags &= ~REMOVED;
          }
        }
      };
      Object.assign(NodePath2.prototype, NodePath_ancestry, NodePath_inference, NodePath_replacement, NodePath_evaluation, NodePath_conversion, NodePath_introspection, NodePath_context, NodePath_removal, NodePath_modification, NodePath_family, NodePath_comments);
      {
        NodePath2.prototype._guessExecutionStatusRelativeToDifferentFunctions = NodePath_introspection._guessExecutionStatusRelativeTo;
      }
      for (const type of t3.TYPES) {
        const typeKey = `is${type}`;
        const fn = t3[typeKey];
        NodePath2.prototype[typeKey] = function(opts) {
          return fn(this.node, opts);
        };
        NodePath2.prototype[`assert${type}`] = function(opts) {
          if (!fn(this.node, opts)) {
            throw new TypeError(`Expected node path of type ${type}`);
          }
        };
      }
      Object.assign(NodePath2.prototype, NodePath_virtual_types_validator);
      for (const type of Object.keys(virtualTypes)) {
        if (type[0] === "_")
          continue;
        if (!t3.TYPES.includes(type))
          t3.TYPES.push(type);
      }
      var _default = NodePath2;
      exports2.default = _default;
    }
  });

  // node_modules/@babel/traverse/lib/context.js
  var require_context2 = __commonJS({
    "node_modules/@babel/traverse/lib/context.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var _path = require_path();
      var _t = require_lib5();
      var {
        VISITOR_KEYS
      } = _t;
      var TraversalContext = class {
        constructor(scope, opts, state, parentPath) {
          this.queue = null;
          this.priorityQueue = null;
          this.parentPath = parentPath;
          this.scope = scope;
          this.state = state;
          this.opts = opts;
        }
        shouldVisit(node) {
          const opts = this.opts;
          if (opts.enter || opts.exit)
            return true;
          if (opts[node.type])
            return true;
          const keys2 = VISITOR_KEYS[node.type];
          if (!(keys2 != null && keys2.length))
            return false;
          for (const key of keys2) {
            if (node[key]) {
              return true;
            }
          }
          return false;
        }
        create(node, container, key, listKey) {
          return _path.default.get({
            parentPath: this.parentPath,
            parent: node,
            container,
            key,
            listKey
          });
        }
        maybeQueue(path, notPriority) {
          if (this.queue) {
            if (notPriority) {
              this.queue.push(path);
            } else {
              this.priorityQueue.push(path);
            }
          }
        }
        visitMultiple(container, parent2, listKey) {
          if (container.length === 0)
            return false;
          const queue = [];
          for (let key = 0; key < container.length; key++) {
            const node = container[key];
            if (node && this.shouldVisit(node)) {
              queue.push(this.create(parent2, container, key, listKey));
            }
          }
          return this.visitQueue(queue);
        }
        visitSingle(node, key) {
          if (this.shouldVisit(
            node[key]
          )) {
            return this.visitQueue([this.create(node, node, key)]);
          } else {
            return false;
          }
        }
        visitQueue(queue) {
          this.queue = queue;
          this.priorityQueue = [];
          const visited = /* @__PURE__ */ new WeakSet();
          let stop = false;
          for (const path of queue) {
            path.resync();
            if (path.contexts.length === 0 || path.contexts[path.contexts.length - 1] !== this) {
              path.pushContext(this);
            }
            if (path.key === null)
              continue;
            const {
              node
            } = path;
            if (visited.has(node))
              continue;
            if (node)
              visited.add(node);
            if (path.visit()) {
              stop = true;
              break;
            }
            if (this.priorityQueue.length) {
              stop = this.visitQueue(this.priorityQueue);
              this.priorityQueue = [];
              this.queue = queue;
              if (stop)
                break;
            }
          }
          for (const path of queue) {
            path.popContext();
          }
          this.queue = null;
          return stop;
        }
        visit(node, key) {
          const nodes = node[key];
          if (!nodes)
            return false;
          if (Array.isArray(nodes)) {
            return this.visitMultiple(nodes, node, key);
          } else {
            return this.visitSingle(node, key);
          }
        }
      };
      exports2.default = TraversalContext;
    }
  });

  // node_modules/@babel/traverse/lib/traverse-node.js
  var require_traverse_node = __commonJS({
    "node_modules/@babel/traverse/lib/traverse-node.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.traverseNode = traverseNode;
      var _context = require_context2();
      var _t = require_lib5();
      var {
        VISITOR_KEYS
      } = _t;
      function traverseNode(node, opts, scope, state, path, skipKeys) {
        const keys2 = VISITOR_KEYS[node.type];
        if (!keys2)
          return false;
        const context = new _context.default(scope, opts, state, path);
        for (const key of keys2) {
          if (skipKeys && skipKeys[key])
            continue;
          if (context.visit(node, key)) {
            return true;
          }
        }
        return false;
      }
    }
  });

  // node_modules/@babel/traverse/lib/hub.js
  var require_hub = __commonJS({
    "node_modules/@babel/traverse/lib/hub.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      exports2.default = void 0;
      var Hub = class {
        getCode() {
        }
        getScope() {
        }
        addHelper() {
          throw new Error("Helpers are not supported by the default hub.");
        }
        buildError(node, msg, Error2 = TypeError) {
          return new Error2(msg);
        }
      };
      exports2.default = Hub;
    }
  });

  // node_modules/@babel/traverse/lib/index.js
  var require_lib14 = __commonJS({
    "node_modules/@babel/traverse/lib/index.js"(exports2) {
      "use strict";
      init_define_process();
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      Object.defineProperty(exports2, "Hub", {
        enumerable: true,
        get: function() {
          return _hub.default;
        }
      });
      Object.defineProperty(exports2, "NodePath", {
        enumerable: true,
        get: function() {
          return _path.default;
        }
      });
      Object.defineProperty(exports2, "Scope", {
        enumerable: true,
        get: function() {
          return _scope.default;
        }
      });
      exports2.visitors = exports2.default = void 0;
      var visitors = require_visitors();
      exports2.visitors = visitors;
      var _t = require_lib5();
      var cache = require_cache2();
      var _traverseNode = require_traverse_node();
      var _path = require_path();
      var _scope = require_scope();
      var _hub = require_hub();
      var {
        VISITOR_KEYS,
        removeProperties,
        traverseFast
      } = _t;
      function traverse3(parent2, opts = {}, scope, state, parentPath) {
        if (!parent2)
          return;
        if (!opts.noScope && !scope) {
          if (parent2.type !== "Program" && parent2.type !== "File") {
            throw new Error(`You must pass a scope and parentPath unless traversing a Program/File. Instead of that you tried to traverse a ${parent2.type} node without passing scope and parentPath.`);
          }
        }
        if (!VISITOR_KEYS[parent2.type]) {
          return;
        }
        visitors.explode(opts);
        (0, _traverseNode.traverseNode)(parent2, opts, scope, state, parentPath);
      }
      var _default = traverse3;
      exports2.default = _default;
      traverse3.visitors = visitors;
      traverse3.verify = visitors.verify;
      traverse3.explode = visitors.explode;
      traverse3.cheap = function(node, enter) {
        return traverseFast(node, enter);
      };
      traverse3.node = function(node, opts, scope, state, path, skipKeys) {
        (0, _traverseNode.traverseNode)(node, opts, scope, state, path, skipKeys);
      };
      traverse3.clearNode = function(node, opts) {
        removeProperties(node, opts);
        cache.path.delete(node);
      };
      traverse3.removeProperties = function(tree, opts) {
        traverseFast(tree, traverse3.clearNode, opts);
        return tree;
      };
      function hasDenylistedType(path, state) {
        if (path.node.type === state.type) {
          state.has = true;
          path.stop();
        }
      }
      traverse3.hasType = function(tree, type, denylistTypes) {
        if (denylistTypes != null && denylistTypes.includes(tree.type))
          return false;
        if (tree.type === type)
          return true;
        const state = {
          has: false,
          type
        };
        traverse3(tree, {
          noScope: true,
          denylist: denylistTypes,
          enter: hasDenylistedType
        }, null, state);
        return state.has;
      };
      traverse3.cache = cache;
    }
  });

  // node_modules/prettier/standalone.js
  var require_standalone = __commonJS({
    "node_modules/prettier/standalone.js"(exports2, module2) {
      init_define_process();
      (function(e) {
        if (typeof exports2 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var f = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          f.prettier = e();
        }
      })(function() {
        "use strict";
        var we = (e, n) => () => (n || e((n = { exports: {} }).exports, n), n.exports);
        var Ye = we((Ig, ru) => {
          var rr = function(e) {
            return e && e.Math == Math && e;
          };
          ru.exports = rr(typeof globalThis == "object" && globalThis) || rr(typeof window == "object" && window) || rr(typeof self == "object" && self) || rr(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var Dt = we((Lg, nu) => {
          nu.exports = function(e) {
            try {
              return !!e();
            } catch {
              return true;
            }
          };
        });
        var Ct = we((jg, uu) => {
          var So = Dt();
          uu.exports = !So(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var nr = we((Og, su) => {
          var xo = Dt();
          su.exports = !xo(function() {
            var e = function() {
            }.bind();
            return typeof e != "function" || e.hasOwnProperty("prototype");
          });
        });
        var Et = we((qg, iu) => {
          var bo = nr(), ur = Function.prototype.call;
          iu.exports = bo ? ur.bind(ur) : function() {
            return ur.apply(ur, arguments);
          };
        });
        var cu = we((lu) => {
          "use strict";
          var au = {}.propertyIsEnumerable, ou = Object.getOwnPropertyDescriptor, To = ou && !au.call({ 1: 2 }, 1);
          lu.f = To ? function(n) {
            var t3 = ou(this, n);
            return !!t3 && t3.enumerable;
          } : au;
        });
        var sr = we((Rg, pu) => {
          pu.exports = function(e, n) {
            return { enumerable: !(e & 1), configurable: !(e & 2), writable: !(e & 4), value: n };
          };
        });
        var at2 = we((Vg, mu) => {
          var fu = nr(), Du = Function.prototype, Bo = Du.bind, Or = Du.call, No = fu && Bo.bind(Or, Or);
          mu.exports = fu ? function(e) {
            return e && No(e);
          } : function(e) {
            return e && function() {
              return Or.apply(e, arguments);
            };
          };
        });
        var ir = we((Wg, gu) => {
          var du = at2(), wo = du({}.toString), _o = du("".slice);
          gu.exports = function(e) {
            return _o(wo(e), 8, -1);
          };
        });
        var hu = we(($g, yu) => {
          var Po = Ye(), ko = at2(), Io = Dt(), Lo = ir(), qr = Po.Object, jo = ko("".split);
          yu.exports = Io(function() {
            return !qr("z").propertyIsEnumerable(0);
          }) ? function(e) {
            return Lo(e) == "String" ? jo(e, "") : qr(e);
          } : qr;
        });
        var Mr = we((Hg, vu) => {
          var Oo = Ye(), qo = Oo.TypeError;
          vu.exports = function(e) {
            if (e == null)
              throw qo("Can't call method on " + e);
            return e;
          };
        });
        var ar = we((Gg, Cu) => {
          var Mo = hu(), Ro = Mr();
          Cu.exports = function(e) {
            return Mo(Ro(e));
          };
        });
        var ot = we((Jg, Eu) => {
          Eu.exports = function(e) {
            return typeof e == "function";
          };
        });
        var Ft = we((Ug, Fu) => {
          var Vo = ot();
          Fu.exports = function(e) {
            return typeof e == "object" ? e !== null : Vo(e);
          };
        });
        var Rt = we((zg, Au) => {
          var Rr = Ye(), Wo = ot(), $o = function(e) {
            return Wo(e) ? e : void 0;
          };
          Au.exports = function(e, n) {
            return arguments.length < 2 ? $o(Rr[e]) : Rr[e] && Rr[e][n];
          };
        });
        var Vr = we((Xg, Su) => {
          var Ho = at2();
          Su.exports = Ho({}.isPrototypeOf);
        });
        var bu = we((Kg, xu) => {
          var Go = Rt();
          xu.exports = Go("navigator", "userAgent") || "";
        });
        var ku = we((Yg, Pu) => {
          var _u = Ye(), Wr = bu(), Tu = _u.process, Bu = _u.Deno, Nu = Tu && Tu.versions || Bu && Bu.version, wu = Nu && Nu.v8, ft, or;
          wu && (ft = wu.split("."), or = ft[0] > 0 && ft[0] < 4 ? 1 : +(ft[0] + ft[1]));
          !or && Wr && (ft = Wr.match(/Edge\/(\d+)/), (!ft || ft[1] >= 74) && (ft = Wr.match(/Chrome\/(\d+)/), ft && (or = +ft[1])));
          Pu.exports = or;
        });
        var $r = we((Qg, Lu) => {
          var Iu = ku(), Jo = Dt();
          Lu.exports = !!Object.getOwnPropertySymbols && !Jo(function() {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && Iu && Iu < 41;
          });
        });
        var Hr = we((Zg, ju) => {
          var Uo = $r();
          ju.exports = Uo && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var Gr = we((e0, Ou) => {
          var zo = Ye(), Xo = Rt(), Ko = ot(), Yo = Vr(), Qo = Hr(), Zo = zo.Object;
          Ou.exports = Qo ? function(e) {
            return typeof e == "symbol";
          } : function(e) {
            var n = Xo("Symbol");
            return Ko(n) && Yo(n.prototype, Zo(e));
          };
        });
        var lr = we((t0, qu) => {
          var el = Ye(), tl = el.String;
          qu.exports = function(e) {
            try {
              return tl(e);
            } catch {
              return "Object";
            }
          };
        });
        var Vt = we((r0, Mu) => {
          var rl = Ye(), nl = ot(), ul = lr(), sl = rl.TypeError;
          Mu.exports = function(e) {
            if (nl(e))
              return e;
            throw sl(ul(e) + " is not a function");
          };
        });
        var cr = we((n0, Ru) => {
          var il = Vt();
          Ru.exports = function(e, n) {
            var t3 = e[n];
            return t3 == null ? void 0 : il(t3);
          };
        });
        var Wu = we((u0, Vu) => {
          var al = Ye(), Jr = Et(), Ur = ot(), zr = Ft(), ol = al.TypeError;
          Vu.exports = function(e, n) {
            var t3, s;
            if (n === "string" && Ur(t3 = e.toString) && !zr(s = Jr(t3, e)) || Ur(t3 = e.valueOf) && !zr(s = Jr(t3, e)) || n !== "string" && Ur(t3 = e.toString) && !zr(s = Jr(t3, e)))
              return s;
            throw ol("Can't convert object to primitive value");
          };
        });
        var Hu = we((s0, $u) => {
          $u.exports = false;
        });
        var pr = we((i0, Ju) => {
          var Gu = Ye(), ll = Object.defineProperty;
          Ju.exports = function(e, n) {
            try {
              ll(Gu, e, { value: n, configurable: true, writable: true });
            } catch {
              Gu[e] = n;
            }
            return n;
          };
        });
        var fr = we((a0, zu) => {
          var cl = Ye(), pl = pr(), Uu = "__core-js_shared__", fl = cl[Uu] || pl(Uu, {});
          zu.exports = fl;
        });
        var Xr = we((o0, Ku) => {
          var Dl = Hu(), Xu = fr();
          (Ku.exports = function(e, n) {
            return Xu[e] || (Xu[e] = n !== void 0 ? n : {});
          })("versions", []).push({ version: "3.22.2", mode: Dl ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.22.2/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var Dr = we((l0, Yu) => {
          var ml = Ye(), dl = Mr(), gl = ml.Object;
          Yu.exports = function(e) {
            return gl(dl(e));
          };
        });
        var gt2 = we((c0, Qu) => {
          var yl = at2(), hl = Dr(), vl = yl({}.hasOwnProperty);
          Qu.exports = Object.hasOwn || function(n, t3) {
            return vl(hl(n), t3);
          };
        });
        var Kr = we((p0, Zu) => {
          var Cl = at2(), El = 0, Fl = Math.random(), Al = Cl(1 .toString);
          Zu.exports = function(e) {
            return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Al(++El + Fl, 36);
          };
        });
        var St = we((f0, us) => {
          var Sl = Ye(), xl = Xr(), es = gt2(), bl = Kr(), ts = $r(), ns = Hr(), Nt = xl("wks"), At = Sl.Symbol, rs = At && At.for, Tl = ns ? At : At && At.withoutSetter || bl;
          us.exports = function(e) {
            if (!es(Nt, e) || !(ts || typeof Nt[e] == "string")) {
              var n = "Symbol." + e;
              ts && es(At, e) ? Nt[e] = At[e] : ns && rs ? Nt[e] = rs(n) : Nt[e] = Tl(n);
            }
            return Nt[e];
          };
        });
        var os = we((D0, as) => {
          var Bl = Ye(), Nl = Et(), ss = Ft(), is = Gr(), wl = cr(), _l = Wu(), Pl = St(), kl = Bl.TypeError, Il = Pl("toPrimitive");
          as.exports = function(e, n) {
            if (!ss(e) || is(e))
              return e;
            var t3 = wl(e, Il), s;
            if (t3) {
              if (n === void 0 && (n = "default"), s = Nl(t3, e, n), !ss(s) || is(s))
                return s;
              throw kl("Can't convert object to primitive value");
            }
            return n === void 0 && (n = "number"), _l(e, n);
          };
        });
        var mr = we((m0, ls) => {
          var Ll = os(), jl = Gr();
          ls.exports = function(e) {
            var n = Ll(e, "string");
            return jl(n) ? n : n + "";
          };
        });
        var fs = we((d0, ps) => {
          var Ol = Ye(), cs = Ft(), Yr = Ol.document, ql = cs(Yr) && cs(Yr.createElement);
          ps.exports = function(e) {
            return ql ? Yr.createElement(e) : {};
          };
        });
        var Qr = we((g0, Ds) => {
          var Ml = Ct(), Rl = Dt(), Vl = fs();
          Ds.exports = !Ml && !Rl(function() {
            return Object.defineProperty(Vl("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var Zr = we((ds) => {
          var Wl = Ct(), $l = Et(), Hl = cu(), Gl = sr(), Jl = ar(), Ul = mr(), zl = gt2(), Xl = Qr(), ms = Object.getOwnPropertyDescriptor;
          ds.f = Wl ? ms : function(n, t3) {
            if (n = Jl(n), t3 = Ul(t3), Xl)
              try {
                return ms(n, t3);
              } catch {
              }
            if (zl(n, t3))
              return Gl(!$l(Hl.f, n, t3), n[t3]);
          };
        });
        var ys = we((h0, gs) => {
          var Kl = Ct(), Yl = Dt();
          gs.exports = Kl && Yl(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var wt = we((v0, vs) => {
          var hs = Ye(), Ql = Ft(), Zl = hs.String, ec = hs.TypeError;
          vs.exports = function(e) {
            if (Ql(e))
              return e;
            throw ec(Zl(e) + " is not an object");
          };
        });
        var gr = we((Es) => {
          var tc = Ye(), rc = Ct(), nc = Qr(), uc = ys(), dr = wt(), Cs = mr(), sc = tc.TypeError, en = Object.defineProperty, ic = Object.getOwnPropertyDescriptor, tn = "enumerable", rn = "configurable", nn = "writable";
          Es.f = rc ? uc ? function(n, t3, s) {
            if (dr(n), t3 = Cs(t3), dr(s), typeof n == "function" && t3 === "prototype" && "value" in s && nn in s && !s[nn]) {
              var a = ic(n, t3);
              a && a[nn] && (n[t3] = s.value, s = { configurable: rn in s ? s[rn] : a[rn], enumerable: tn in s ? s[tn] : a[tn], writable: false });
            }
            return en(n, t3, s);
          } : en : function(n, t3, s) {
            if (dr(n), t3 = Cs(t3), dr(s), nc)
              try {
                return en(n, t3, s);
              } catch {
              }
            if ("get" in s || "set" in s)
              throw sc("Accessors not supported");
            return "value" in s && (n[t3] = s.value), n;
          };
        });
        var yr = we((E0, Fs) => {
          var ac = Ct(), oc = gr(), lc = sr();
          Fs.exports = ac ? function(e, n, t3) {
            return oc.f(e, n, lc(1, t3));
          } : function(e, n, t3) {
            return e[n] = t3, e;
          };
        });
        var hr = we((F0, As) => {
          var cc = at2(), pc = ot(), un = fr(), fc = cc(Function.toString);
          pc(un.inspectSource) || (un.inspectSource = function(e) {
            return fc(e);
          });
          As.exports = un.inspectSource;
        });
        var bs = we((A0, xs) => {
          var Dc = Ye(), mc = ot(), dc = hr(), Ss = Dc.WeakMap;
          xs.exports = mc(Ss) && /native code/.test(dc(Ss));
        });
        var Ns = we((S0, Bs) => {
          var gc = Xr(), yc = Kr(), Ts = gc("keys");
          Bs.exports = function(e) {
            return Ts[e] || (Ts[e] = yc(e));
          };
        });
        var sn = we((x0, ws) => {
          ws.exports = {};
        });
        var js = we((b0, Ls) => {
          var hc = bs(), Is = Ye(), an = at2(), vc = Ft(), Cc = yr(), on = gt2(), ln = fr(), Ec = Ns(), Fc = sn(), _s = "Object already initialized", pn = Is.TypeError, Ac = Is.WeakMap, vr, Wt, Cr, Sc = function(e) {
            return Cr(e) ? Wt(e) : vr(e, {});
          }, xc = function(e) {
            return function(n) {
              var t3;
              if (!vc(n) || (t3 = Wt(n)).type !== e)
                throw pn("Incompatible receiver, " + e + " required");
              return t3;
            };
          };
          hc || ln.state ? (yt = ln.state || (ln.state = new Ac()), Ps = an(yt.get), cn = an(yt.has), ks = an(yt.set), vr = function(e, n) {
            if (cn(yt, e))
              throw new pn(_s);
            return n.facade = e, ks(yt, e, n), n;
          }, Wt = function(e) {
            return Ps(yt, e) || {};
          }, Cr = function(e) {
            return cn(yt, e);
          }) : (xt = Ec("state"), Fc[xt] = true, vr = function(e, n) {
            if (on(e, xt))
              throw new pn(_s);
            return n.facade = e, Cc(e, xt, n), n;
          }, Wt = function(e) {
            return on(e, xt) ? e[xt] : {};
          }, Cr = function(e) {
            return on(e, xt);
          });
          var yt, Ps, cn, ks, xt;
          Ls.exports = { set: vr, get: Wt, has: Cr, enforce: Sc, getterFor: xc };
        });
        var Ms = we((T0, qs) => {
          var fn = Ct(), bc = gt2(), Os = Function.prototype, Tc = fn && Object.getOwnPropertyDescriptor, Dn = bc(Os, "name"), Bc = Dn && function() {
          }.name === "something", Nc = Dn && (!fn || fn && Tc(Os, "name").configurable);
          qs.exports = { EXISTS: Dn, PROPER: Bc, CONFIGURABLE: Nc };
        });
        var Hs = we((B0, $s) => {
          var wc = Ye(), Rs = ot(), _c = gt2(), Vs = yr(), Pc = pr(), kc = hr(), Ws = js(), Ic = Ms().CONFIGURABLE, Lc = Ws.get, jc = Ws.enforce, Oc = String(String).split("String");
          ($s.exports = function(e, n, t3, s) {
            var a = s ? !!s.unsafe : false, r = s ? !!s.enumerable : false, u = s ? !!s.noTargetGet : false, i = s && s.name !== void 0 ? s.name : n, o;
            if (Rs(t3) && (String(i).slice(0, 7) === "Symbol(" && (i = "[" + String(i).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!_c(t3, "name") || Ic && t3.name !== i) && Vs(t3, "name", i), o = jc(t3), o.source || (o.source = Oc.join(typeof i == "string" ? i : ""))), e === wc) {
              r ? e[n] = t3 : Pc(n, t3);
              return;
            } else
              a ? !u && e[n] && (r = true) : delete e[n];
            r ? e[n] = t3 : Vs(e, n, t3);
          })(Function.prototype, "toString", function() {
            return Rs(this) && Lc(this).source || kc(this);
          });
        });
        var Er = we((N0, Gs) => {
          var qc = Math.ceil, Mc = Math.floor;
          Gs.exports = function(e) {
            var n = +e;
            return n !== n || n === 0 ? 0 : (n > 0 ? Mc : qc)(n);
          };
        });
        var Us = we((w0, Js) => {
          var Rc = Er(), Vc = Math.max, Wc = Math.min;
          Js.exports = function(e, n) {
            var t3 = Rc(e);
            return t3 < 0 ? Vc(t3 + n, 0) : Wc(t3, n);
          };
        });
        var Xs = we((_0, zs) => {
          var $c = Er(), Hc = Math.min;
          zs.exports = function(e) {
            return e > 0 ? Hc($c(e), 9007199254740991) : 0;
          };
        });
        var _t = we((P0, Ks) => {
          var Gc = Xs();
          Ks.exports = function(e) {
            return Gc(e.length);
          };
        });
        var Zs = we((k0, Qs) => {
          var Jc = ar(), Uc = Us(), zc = _t(), Ys = function(e) {
            return function(n, t3, s) {
              var a = Jc(n), r = zc(a), u = Uc(s, r), i;
              if (e && t3 != t3) {
                for (; r > u; )
                  if (i = a[u++], i != i)
                    return true;
              } else
                for (; r > u; u++)
                  if ((e || u in a) && a[u] === t3)
                    return e || u || 0;
              return !e && -1;
            };
          };
          Qs.exports = { includes: Ys(true), indexOf: Ys(false) };
        });
        var ri = we((I0, ti) => {
          var Xc = at2(), mn = gt2(), Kc = ar(), Yc = Zs().indexOf, Qc = sn(), ei = Xc([].push);
          ti.exports = function(e, n) {
            var t3 = Kc(e), s = 0, a = [], r;
            for (r in t3)
              !mn(Qc, r) && mn(t3, r) && ei(a, r);
            for (; n.length > s; )
              mn(t3, r = n[s++]) && (~Yc(a, r) || ei(a, r));
            return a;
          };
        });
        var ui = we((L0, ni) => {
          ni.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var ii = we((si) => {
          var Zc = ri(), ep = ui(), tp = ep.concat("length", "prototype");
          si.f = Object.getOwnPropertyNames || function(n) {
            return Zc(n, tp);
          };
        });
        var oi = we((ai) => {
          ai.f = Object.getOwnPropertySymbols;
        });
        var ci = we((q0, li) => {
          var rp = Rt(), np = at2(), up = ii(), sp = oi(), ip = wt(), ap = np([].concat);
          li.exports = rp("Reflect", "ownKeys") || function(n) {
            var t3 = up.f(ip(n)), s = sp.f;
            return s ? ap(t3, s(n)) : t3;
          };
        });
        var Di = we((M0, fi) => {
          var pi = gt2(), op = ci(), lp = Zr(), cp = gr();
          fi.exports = function(e, n, t3) {
            for (var s = op(n), a = cp.f, r = lp.f, u = 0; u < s.length; u++) {
              var i = s[u];
              !pi(e, i) && !(t3 && pi(t3, i)) && a(e, i, r(n, i));
            }
          };
        });
        var di = we((R0, mi) => {
          var pp = Dt(), fp = ot(), Dp = /#|\.prototype\./, $t = function(e, n) {
            var t3 = dp[mp(e)];
            return t3 == yp ? true : t3 == gp ? false : fp(n) ? pp(n) : !!n;
          }, mp = $t.normalize = function(e) {
            return String(e).replace(Dp, ".").toLowerCase();
          }, dp = $t.data = {}, gp = $t.NATIVE = "N", yp = $t.POLYFILL = "P";
          mi.exports = $t;
        });
        var Ht = we((V0, gi) => {
          var dn = Ye(), hp = Zr().f, vp = yr(), Cp = Hs(), Ep = pr(), Fp = Di(), Ap = di();
          gi.exports = function(e, n) {
            var t3 = e.target, s = e.global, a = e.stat, r, u, i, o, c, v;
            if (s ? u = dn : a ? u = dn[t3] || Ep(t3, {}) : u = (dn[t3] || {}).prototype, u)
              for (i in n) {
                if (c = n[i], e.noTargetGet ? (v = hp(u, i), o = v && v.value) : o = u[i], r = Ap(s ? i : t3 + (a ? "." : "#") + i, e.forced), !r && o !== void 0) {
                  if (typeof c == typeof o)
                    continue;
                  Fp(c, o);
                }
                (e.sham || o && o.sham) && vp(c, "sham", true), Cp(u, i, c, e);
              }
          };
        });
        var gn = we((W0, yi) => {
          var Sp = ir();
          yi.exports = Array.isArray || function(n) {
            return Sp(n) == "Array";
          };
        });
        var yn = we(($0, vi) => {
          var hi = at2(), xp = Vt(), bp = nr(), Tp = hi(hi.bind);
          vi.exports = function(e, n) {
            return xp(e), n === void 0 ? e : bp ? Tp(e, n) : function() {
              return e.apply(n, arguments);
            };
          };
        });
        var hn = we((H0, Ei) => {
          "use strict";
          var Bp = Ye(), Np = gn(), wp = _t(), _p = yn(), Pp = Bp.TypeError, Ci = function(e, n, t3, s, a, r, u, i) {
            for (var o = a, c = 0, v = u ? _p(u, i) : false, m, d; c < s; ) {
              if (c in t3) {
                if (m = v ? v(t3[c], c, n) : t3[c], r > 0 && Np(m))
                  d = wp(m), o = Ci(e, n, m, d, o, r - 1) - 1;
                else {
                  if (o >= 9007199254740991)
                    throw Pp("Exceed the acceptable array length");
                  e[o] = m;
                }
                o++;
              }
              c++;
            }
            return o;
          };
          Ei.exports = Ci;
        });
        var Si = we((G0, Ai) => {
          var kp = St(), Ip = kp("toStringTag"), Fi = {};
          Fi[Ip] = "z";
          Ai.exports = String(Fi) === "[object z]";
        });
        var vn = we((J0, xi) => {
          var Lp = Ye(), jp = Si(), Op = ot(), Fr = ir(), qp = St(), Mp = qp("toStringTag"), Rp = Lp.Object, Vp = Fr(function() {
            return arguments;
          }()) == "Arguments", Wp = function(e, n) {
            try {
              return e[n];
            } catch {
            }
          };
          xi.exports = jp ? Fr : function(e) {
            var n, t3, s;
            return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t3 = Wp(n = Rp(e), Mp)) == "string" ? t3 : Vp ? Fr(n) : (s = Fr(n)) == "Object" && Op(n.callee) ? "Arguments" : s;
          };
        });
        var _i = we((U0, wi) => {
          var $p = at2(), Hp = Dt(), bi = ot(), Gp = vn(), Jp = Rt(), Up = hr(), Ti = function() {
          }, zp = [], Bi = Jp("Reflect", "construct"), Cn = /^\s*(?:class|function)\b/, Xp = $p(Cn.exec), Kp = !Cn.exec(Ti), Gt = function(n) {
            if (!bi(n))
              return false;
            try {
              return Bi(Ti, zp, n), true;
            } catch {
              return false;
            }
          }, Ni = function(n) {
            if (!bi(n))
              return false;
            switch (Gp(n)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return false;
            }
            try {
              return Kp || !!Xp(Cn, Up(n));
            } catch {
              return true;
            }
          };
          Ni.sham = true;
          wi.exports = !Bi || Hp(function() {
            var e;
            return Gt(Gt.call) || !Gt(Object) || !Gt(function() {
              e = true;
            }) || e;
          }) ? Ni : Gt;
        });
        var Li = we((z0, Ii) => {
          var Yp = Ye(), Pi = gn(), Qp = _i(), Zp = Ft(), ef = St(), tf = ef("species"), ki = Yp.Array;
          Ii.exports = function(e) {
            var n;
            return Pi(e) && (n = e.constructor, Qp(n) && (n === ki || Pi(n.prototype)) ? n = void 0 : Zp(n) && (n = n[tf], n === null && (n = void 0))), n === void 0 ? ki : n;
          };
        });
        var En = we((X0, ji) => {
          var rf = Li();
          ji.exports = function(e, n) {
            return new (rf(e))(n === 0 ? 0 : n);
          };
        });
        var Oi = we(() => {
          "use strict";
          var nf = Ht(), uf = hn(), sf = Vt(), af = Dr(), of = _t(), lf = En();
          nf({ target: "Array", proto: true }, { flatMap: function(n) {
            var t3 = af(this), s = of(t3), a;
            return sf(n), a = lf(t3, 0), a.length = uf(a, t3, t3, s, 0, 1, n, arguments.length > 1 ? arguments[1] : void 0), a;
          } });
        });
        var Fn = we((Q0, qi) => {
          qi.exports = {};
        });
        var Ri = we((Z0, Mi) => {
          var cf = St(), pf = Fn(), ff = cf("iterator"), Df = Array.prototype;
          Mi.exports = function(e) {
            return e !== void 0 && (pf.Array === e || Df[ff] === e);
          };
        });
        var An = we((ey, Wi) => {
          var mf = vn(), Vi = cr(), df = Fn(), gf = St(), yf = gf("iterator");
          Wi.exports = function(e) {
            if (e != null)
              return Vi(e, yf) || Vi(e, "@@iterator") || df[mf(e)];
          };
        });
        var Hi = we((ty, $i) => {
          var hf = Ye(), vf = Et(), Cf = Vt(), Ef = wt(), Ff = lr(), Af = An(), Sf = hf.TypeError;
          $i.exports = function(e, n) {
            var t3 = arguments.length < 2 ? Af(e) : n;
            if (Cf(t3))
              return Ef(vf(t3, e));
            throw Sf(Ff(e) + " is not iterable");
          };
        });
        var Ui = we((ry, Ji) => {
          var xf = Et(), Gi = wt(), bf = cr();
          Ji.exports = function(e, n, t3) {
            var s, a;
            Gi(e);
            try {
              if (s = bf(e, "return"), !s) {
                if (n === "throw")
                  throw t3;
                return t3;
              }
              s = xf(s, e);
            } catch (r) {
              a = true, s = r;
            }
            if (n === "throw")
              throw t3;
            if (a)
              throw s;
            return Gi(s), t3;
          };
        });
        var Qi = we((ny, Yi) => {
          var Tf = Ye(), Bf = yn(), Nf = Et(), wf = wt(), _f = lr(), Pf = Ri(), kf = _t(), zi = Vr(), If = Hi(), Lf = An(), Xi = Ui(), jf = Tf.TypeError, Ar = function(e, n) {
            this.stopped = e, this.result = n;
          }, Ki = Ar.prototype;
          Yi.exports = function(e, n, t3) {
            var s = t3 && t3.that, a = !!(t3 && t3.AS_ENTRIES), r = !!(t3 && t3.IS_ITERATOR), u = !!(t3 && t3.INTERRUPTED), i = Bf(n, s), o, c, v, m, d, p, f, h = function(T) {
              return o && Xi(o, "normal", T), new Ar(true, T);
            }, w = function(T) {
              return a ? (wf(T), u ? i(T[0], T[1], h) : i(T[0], T[1])) : u ? i(T, h) : i(T);
            };
            if (r)
              o = e;
            else {
              if (c = Lf(e), !c)
                throw jf(_f(e) + " is not iterable");
              if (Pf(c)) {
                for (v = 0, m = kf(e); m > v; v++)
                  if (d = w(e[v]), d && zi(Ki, d))
                    return d;
                return new Ar(false);
              }
              o = If(e, c);
            }
            for (p = o.next; !(f = Nf(p, o)).done; ) {
              try {
                d = w(f.value);
              } catch (T) {
                Xi(o, "throw", T);
              }
              if (typeof d == "object" && d && zi(Ki, d))
                return d;
            }
            return new Ar(false);
          };
        });
        var ea = we((uy, Zi) => {
          "use strict";
          var Of = mr(), qf = gr(), Mf = sr();
          Zi.exports = function(e, n, t3) {
            var s = Of(n);
            s in e ? qf.f(e, s, Mf(0, t3)) : e[s] = t3;
          };
        });
        var ta = we(() => {
          var Rf = Ht(), Vf = Qi(), Wf = ea();
          Rf({ target: "Object", stat: true }, { fromEntries: function(n) {
            var t3 = {};
            return Vf(n, function(s, a) {
              Wf(t3, s, a);
            }, { AS_ENTRIES: true }), t3;
          } });
        });
        var ra = we(() => {
          var $f = Ht(), Hf = Ye();
          $f({ global: true }, { globalThis: Hf });
        });
        var na = we(() => {
          ra();
        });
        var ua = we(() => {
          "use strict";
          var Gf = Ht(), Jf = hn(), Uf = Dr(), zf = _t(), Xf = Er(), Kf = En();
          Gf({ target: "Array", proto: true }, { flat: function() {
            var n = arguments.length ? arguments[0] : void 0, t3 = Uf(this), s = zf(t3), a = Kf(t3, 0);
            return a.length = Jf(a, t3, t3, s, 0, n === void 0 ? 1 : Xf(n)), a;
          } });
        });
        var Pg = we((my, Co) => {
          var Yf = ["cliName", "cliCategory", "cliDescription"], Qf = ["_"], Zf = ["languageId"], sa, ia, aa, oa, la, ca;
          function kn(e, n) {
            if (e == null)
              return {};
            var t3 = eD(e, n), s, a;
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              for (a = 0; a < r.length; a++)
                s = r[a], !(n.indexOf(s) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, s) || (t3[s] = e[s]));
            }
            return t3;
          }
          function eD(e, n) {
            if (e == null)
              return {};
            var t3 = {}, s = Object.keys(e), a, r;
            for (r = 0; r < s.length; r++)
              a = s[r], !(n.indexOf(a) >= 0) && (t3[a] = e[a]);
            return t3;
          }
          Oi();
          ta();
          na();
          ua();
          function Pt(e, n) {
            return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(n) } }));
          }
          var tD = Object.create, Br = Object.defineProperty, rD = Object.getOwnPropertyDescriptor, In = Object.getOwnPropertyNames, nD = Object.getPrototypeOf, uD = Object.prototype.hasOwnProperty, mt = (e, n) => function() {
            return e && (n = (0, e[In(e)[0]])(e = 0)), n;
          }, Z = (e, n) => function() {
            return n || (0, e[In(e)[0]])((n = { exports: {} }).exports, n), n.exports;
          }, Ut = (e, n) => {
            for (var t3 in n)
              Br(e, t3, { get: n[t3], enumerable: true });
          }, ga = (e, n, t3, s) => {
            if (n && typeof n == "object" || typeof n == "function")
              for (let a of In(n))
                !uD.call(e, a) && a !== t3 && Br(e, a, { get: () => n[a], enumerable: !(s = rD(n, a)) || s.enumerable });
            return e;
          }, sD = (e, n, t3) => (t3 = e != null ? tD(nD(e)) : {}, ga(n || !e || !e.__esModule ? Br(t3, "default", { value: e, enumerable: true }) : t3, e)), lt2 = (e) => ga(Br({}, "__esModule", { value: true }), e), pa, fa, Tt, re = mt({ "<define:process>"() {
            pa = {}, fa = [], Tt = { env: pa, argv: fa };
          } }), ya = Z({ "package.json"(e, n) {
            n.exports = { version: "2.7.1" };
          } }), iD = Z({ "node_modules/diff/lib/diff/base.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.default = n;
            function n() {
            }
            n.prototype = { diff: function(r, u) {
              var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = i.callback;
              typeof i == "function" && (o = i, i = {}), this.options = i;
              var c = this;
              function v(S) {
                return o ? (setTimeout(function() {
                  o(void 0, S);
                }, 0), true) : S;
              }
              r = this.castInput(r), u = this.castInput(u), r = this.removeEmpty(this.tokenize(r)), u = this.removeEmpty(this.tokenize(u));
              var m = u.length, d = r.length, p = 1, f = m + d, h = [{ newPos: -1, components: [] }], w = this.extractCommon(h[0], u, r, 0);
              if (h[0].newPos + 1 >= m && w + 1 >= d)
                return v([{ value: this.join(u), count: u.length }]);
              function T() {
                for (var S = -1 * p; S <= p; S += 2) {
                  var B = void 0, I = h[S - 1], k = h[S + 1], P = (k ? k.newPos : 0) - S;
                  I && (h[S - 1] = void 0);
                  var C = I && I.newPos + 1 < m, D = k && 0 <= P && P < d;
                  if (!C && !D) {
                    h[S] = void 0;
                    continue;
                  }
                  if (!C || D && I.newPos < k.newPos ? (B = s(k), c.pushComponent(B.components, void 0, true)) : (B = I, B.newPos++, c.pushComponent(B.components, true, void 0)), P = c.extractCommon(B, u, r, S), B.newPos + 1 >= m && P + 1 >= d)
                    return v(t3(c, B.components, u, r, c.useLongestToken));
                  h[S] = B;
                }
                p++;
              }
              if (o)
                (function S() {
                  setTimeout(function() {
                    if (p > f)
                      return o();
                    T() || S();
                  }, 0);
                })();
              else
                for (; p <= f; ) {
                  var A = T();
                  if (A)
                    return A;
                }
            }, pushComponent: function(r, u, i) {
              var o = r[r.length - 1];
              o && o.added === u && o.removed === i ? r[r.length - 1] = { count: o.count + 1, added: u, removed: i } : r.push({ count: 1, added: u, removed: i });
            }, extractCommon: function(r, u, i, o) {
              for (var c = u.length, v = i.length, m = r.newPos, d = m - o, p = 0; m + 1 < c && d + 1 < v && this.equals(u[m + 1], i[d + 1]); )
                m++, d++, p++;
              return p && r.components.push({ count: p }), r.newPos = m, d;
            }, equals: function(r, u) {
              return this.options.comparator ? this.options.comparator(r, u) : r === u || this.options.ignoreCase && r.toLowerCase() === u.toLowerCase();
            }, removeEmpty: function(r) {
              for (var u = [], i = 0; i < r.length; i++)
                r[i] && u.push(r[i]);
              return u;
            }, castInput: function(r) {
              return r;
            }, tokenize: function(r) {
              return r.split("");
            }, join: function(r) {
              return r.join("");
            } };
            function t3(a, r, u, i, o) {
              for (var c = 0, v = r.length, m = 0, d = 0; c < v; c++) {
                var p = r[c];
                if (p.removed) {
                  if (p.value = a.join(i.slice(d, d + p.count)), d += p.count, c && r[c - 1].added) {
                    var h = r[c - 1];
                    r[c - 1] = r[c], r[c] = h;
                  }
                } else {
                  if (!p.added && o) {
                    var f = u.slice(m, m + p.count);
                    f = f.map(function(T, A) {
                      var S = i[d + A];
                      return S.length > T.length ? S : T;
                    }), p.value = a.join(f);
                  } else
                    p.value = a.join(u.slice(m, m + p.count));
                  m += p.count, p.added || (d += p.count);
                }
              }
              var w = r[v - 1];
              return v > 1 && typeof w.value == "string" && (w.added || w.removed) && a.equals("", w.value) && (r[v - 2].value += w.value, r.pop()), r;
            }
            function s(a) {
              return { newPos: a.newPos, components: a.components.slice(0) };
            }
          } }), aD = Z({ "node_modules/diff/lib/diff/array.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.diffArrays = a, e.arrayDiff = void 0;
            var n = t3(iD());
            function t3(r) {
              return r && r.__esModule ? r : { default: r };
            }
            var s = new n.default();
            e.arrayDiff = s, s.tokenize = function(r) {
              return r.slice();
            }, s.join = s.removeEmpty = function(r) {
              return r;
            };
            function a(r, u, i) {
              return s.diff(r, u, i);
            }
          } }), Ln = Z({ "src/document/doc-builders.js"(e, n) {
            "use strict";
            re();
            function t3(F) {
              return { type: "concat", parts: F };
            }
            function s(F) {
              return { type: "indent", contents: F };
            }
            function a(F, l) {
              return { type: "align", contents: l, n: F };
            }
            function r(F) {
              let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              return { type: "group", id: l.id, contents: F, break: Boolean(l.shouldBreak), expandedStates: l.expandedStates };
            }
            function u(F) {
              return a(Number.NEGATIVE_INFINITY, F);
            }
            function i(F) {
              return a({ type: "root" }, F);
            }
            function o(F) {
              return a(-1, F);
            }
            function c(F, l) {
              return r(F[0], Object.assign(Object.assign({}, l), {}, { expandedStates: F }));
            }
            function v(F) {
              return { type: "fill", parts: F };
            }
            function m(F, l) {
              let E = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              return { type: "if-break", breakContents: F, flatContents: l, groupId: E.groupId };
            }
            function d(F, l) {
              return { type: "indent-if-break", contents: F, groupId: l.groupId, negate: l.negate };
            }
            function p(F) {
              return { type: "line-suffix", contents: F };
            }
            var f = { type: "line-suffix-boundary" }, h = { type: "break-parent" }, w = { type: "trim" }, T = { type: "line", hard: true }, A = { type: "line", hard: true, literal: true }, S = { type: "line" }, B = { type: "line", soft: true }, I = t3([T, h]), k = t3([A, h]), P = { type: "cursor", placeholder: Symbol("cursor") };
            function C(F, l) {
              let E = [];
              for (let y = 0; y < l.length; y++)
                y !== 0 && E.push(F), E.push(l[y]);
              return t3(E);
            }
            function D(F, l, E) {
              let y = F;
              if (l > 0) {
                for (let N = 0; N < Math.floor(l / E); ++N)
                  y = s(y);
                y = a(l % E, y), y = a(Number.NEGATIVE_INFINITY, y);
              }
              return y;
            }
            function g(F, l) {
              return { type: "label", label: F, contents: l };
            }
            n.exports = { concat: t3, join: C, line: S, softline: B, hardline: I, literalline: k, group: r, conditionalGroup: c, fill: v, lineSuffix: p, lineSuffixBoundary: f, cursor: P, breakParent: h, ifBreak: m, trim: w, indent: s, indentIfBreak: d, align: a, addAlignmentToDoc: D, markAsRoot: i, dedentToRoot: u, dedent: o, hardlineWithoutBreakParent: T, literallineWithoutBreakParent: A, label: g };
          } }), jn = Z({ "src/common/end-of-line.js"(e, n) {
            "use strict";
            re();
            function t3(u) {
              let i = u.indexOf("\r");
              return i >= 0 ? u.charAt(i + 1) === `
` ? "crlf" : "cr" : "lf";
            }
            function s(u) {
              switch (u) {
                case "cr":
                  return "\r";
                case "crlf":
                  return `\r
`;
                default:
                  return `
`;
              }
            }
            function a(u, i) {
              let o;
              switch (i) {
                case `
`:
                  o = /\n/g;
                  break;
                case "\r":
                  o = /\r/g;
                  break;
                case `\r
`:
                  o = /\r\n/g;
                  break;
                default:
                  throw new Error('Unexpected "eol" '.concat(JSON.stringify(i), "."));
              }
              let c = u.match(o);
              return c ? c.length : 0;
            }
            function r(u) {
              return u.replace(/\r\n?/g, `
`);
            }
            n.exports = { guessEndOfLine: t3, convertEndOfLineToChars: s, countEndOfLineChars: a, normalizeEndOfLine: r };
          } }), it = Z({ "src/utils/get-last.js"(e, n) {
            "use strict";
            re();
            var t3 = (s) => s[s.length - 1];
            n.exports = t3;
          } });
          function oD() {
            let { onlyFirst: e = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
            return new RegExp(n, e ? void 0 : "g");
          }
          var lD = mt({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
            re();
          } });
          function cD(e) {
            if (typeof e != "string")
              throw new TypeError("Expected a `string`, got `".concat(typeof e, "`"));
            return e.replace(oD(), "");
          }
          var pD = mt({ "node_modules/strip-ansi/index.js"() {
            re(), lD();
          } });
          function fD(e) {
            return Number.isInteger(e) ? e >= 4352 && (e <= 4447 || e === 9001 || e === 9002 || 11904 <= e && e <= 12871 && e !== 12351 || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141) : false;
          }
          var DD = mt({ "node_modules/is-fullwidth-code-point/index.js"() {
            re();
          } }), mD = Z({ "node_modules/emoji-regex/index.js"(e, n) {
            "use strict";
            re(), n.exports = function() {
              return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
            };
          } }), ha = {};
          Ut(ha, { default: () => dD });
          function dD(e) {
            if (typeof e != "string" || e.length === 0 || (e = cD(e), e.length === 0))
              return 0;
            e = e.replace((0, va.default)(), "  ");
            let n = 0;
            for (let t3 = 0; t3 < e.length; t3++) {
              let s = e.codePointAt(t3);
              s <= 31 || s >= 127 && s <= 159 || s >= 768 && s <= 879 || (s > 65535 && t3++, n += fD(s) ? 2 : 1);
            }
            return n;
          }
          var va, gD = mt({ "node_modules/string-width/index.js"() {
            re(), pD(), DD(), va = sD(mD());
          } }), Ca = Z({ "src/utils/get-string-width.js"(e, n) {
            "use strict";
            re();
            var t3 = (gD(), lt2(ha)).default, s = /[^\x20-\x7F]/;
            function a(r) {
              return r ? s.test(r) ? t3(r) : r.length : 0;
            }
            n.exports = a;
          } }), On = Z({ "src/document/doc-utils.js"(e, n) {
            "use strict";
            re();
            var t3 = it(), { literalline: s, join: a } = Ln(), r = (l) => Array.isArray(l) || l && l.type === "concat", u = (l) => {
              if (Array.isArray(l))
                return l;
              if (l.type !== "concat" && l.type !== "fill")
                throw new Error("Expect doc type to be `concat` or `fill`.");
              return l.parts;
            }, i = {};
            function o(l, E, y, N) {
              let x = [l];
              for (; x.length > 0; ) {
                let b = x.pop();
                if (b === i) {
                  y(x.pop());
                  continue;
                }
                if (y && x.push(b, i), !E || E(b) !== false)
                  if (r(b) || b.type === "fill") {
                    let L = u(b);
                    for (let M = L.length, j = M - 1; j >= 0; --j)
                      x.push(L[j]);
                  } else if (b.type === "if-break")
                    b.flatContents && x.push(b.flatContents), b.breakContents && x.push(b.breakContents);
                  else if (b.type === "group" && b.expandedStates)
                    if (N)
                      for (let L = b.expandedStates.length, M = L - 1; M >= 0; --M)
                        x.push(b.expandedStates[M]);
                    else
                      x.push(b.contents);
                  else
                    b.contents && x.push(b.contents);
              }
            }
            function c(l, E) {
              let y = /* @__PURE__ */ new Map();
              return N(l);
              function N(b) {
                if (y.has(b))
                  return y.get(b);
                let L = x(b);
                return y.set(b, L), L;
              }
              function x(b) {
                if (Array.isArray(b))
                  return E(b.map(N));
                if (b.type === "concat" || b.type === "fill") {
                  let L = b.parts.map(N);
                  return E(Object.assign(Object.assign({}, b), {}, { parts: L }));
                }
                if (b.type === "if-break") {
                  let L = b.breakContents && N(b.breakContents), M = b.flatContents && N(b.flatContents);
                  return E(Object.assign(Object.assign({}, b), {}, { breakContents: L, flatContents: M }));
                }
                if (b.type === "group" && b.expandedStates) {
                  let L = b.expandedStates.map(N), M = L[0];
                  return E(Object.assign(Object.assign({}, b), {}, { contents: M, expandedStates: L }));
                }
                if (b.contents) {
                  let L = N(b.contents);
                  return E(Object.assign(Object.assign({}, b), {}, { contents: L }));
                }
                return E(b);
              }
            }
            function v(l, E, y) {
              let N = y, x = false;
              function b(L) {
                let M = E(L);
                if (M !== void 0 && (x = true, N = M), x)
                  return false;
              }
              return o(l, b), N;
            }
            function m(l) {
              if (l.type === "group" && l.break || l.type === "line" && l.hard || l.type === "break-parent")
                return true;
            }
            function d(l) {
              return v(l, m, false);
            }
            function p(l) {
              if (l.length > 0) {
                let E = t3(l);
                !E.expandedStates && !E.break && (E.break = "propagated");
              }
              return null;
            }
            function f(l) {
              let E = /* @__PURE__ */ new Set(), y = [];
              function N(b) {
                if (b.type === "break-parent" && p(y), b.type === "group") {
                  if (y.push(b), E.has(b))
                    return false;
                  E.add(b);
                }
              }
              function x(b) {
                b.type === "group" && y.pop().break && p(y);
              }
              o(l, N, x, true);
            }
            function h(l) {
              return l.type === "line" && !l.hard ? l.soft ? "" : " " : l.type === "if-break" ? l.flatContents || "" : l;
            }
            function w(l) {
              return c(l, h);
            }
            var T = (l, E) => l && l.type === "line" && l.hard && E && E.type === "break-parent";
            function A(l) {
              if (!l)
                return l;
              if (r(l) || l.type === "fill") {
                let E = u(l);
                for (; E.length > 1 && T(...E.slice(-2)); )
                  E.length -= 2;
                if (E.length > 0) {
                  let y = A(t3(E));
                  E[E.length - 1] = y;
                }
                return Array.isArray(l) ? E : Object.assign(Object.assign({}, l), {}, { parts: E });
              }
              switch (l.type) {
                case "align":
                case "indent":
                case "indent-if-break":
                case "group":
                case "line-suffix":
                case "label": {
                  let E = A(l.contents);
                  return Object.assign(Object.assign({}, l), {}, { contents: E });
                }
                case "if-break": {
                  let E = A(l.breakContents), y = A(l.flatContents);
                  return Object.assign(Object.assign({}, l), {}, { breakContents: E, flatContents: y });
                }
              }
              return l;
            }
            function S(l) {
              return A(I(l));
            }
            function B(l) {
              switch (l.type) {
                case "fill":
                  if (l.parts.every((y) => y === ""))
                    return "";
                  break;
                case "group":
                  if (!l.contents && !l.id && !l.break && !l.expandedStates)
                    return "";
                  if (l.contents.type === "group" && l.contents.id === l.id && l.contents.break === l.break && l.contents.expandedStates === l.expandedStates)
                    return l.contents;
                  break;
                case "align":
                case "indent":
                case "indent-if-break":
                case "line-suffix":
                  if (!l.contents)
                    return "";
                  break;
                case "if-break":
                  if (!l.flatContents && !l.breakContents)
                    return "";
                  break;
              }
              if (!r(l))
                return l;
              let E = [];
              for (let y of u(l)) {
                if (!y)
                  continue;
                let [N, ...x] = r(y) ? u(y) : [y];
                typeof N == "string" && typeof t3(E) == "string" ? E[E.length - 1] += N : E.push(N), E.push(...x);
              }
              return E.length === 0 ? "" : E.length === 1 ? E[0] : Array.isArray(l) ? E : Object.assign(Object.assign({}, l), {}, { parts: E });
            }
            function I(l) {
              return c(l, (E) => B(E));
            }
            function k(l) {
              let E = [], y = l.filter(Boolean);
              for (; y.length > 0; ) {
                let N = y.shift();
                if (!!N) {
                  if (r(N)) {
                    y.unshift(...u(N));
                    continue;
                  }
                  if (E.length > 0 && typeof t3(E) == "string" && typeof N == "string") {
                    E[E.length - 1] += N;
                    continue;
                  }
                  E.push(N);
                }
              }
              return E;
            }
            function P(l) {
              return c(l, (E) => Array.isArray(E) ? k(E) : E.parts ? Object.assign(Object.assign({}, E), {}, { parts: k(E.parts) }) : E);
            }
            function C(l) {
              return c(l, (E) => typeof E == "string" && E.includes(`
`) ? D(E) : E);
            }
            function D(l) {
              let E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s;
              return a(E, l.split(`
`)).parts;
            }
            function g(l) {
              if (l.type === "line")
                return true;
            }
            function F(l) {
              return v(l, g, false);
            }
            n.exports = { isConcat: r, getDocParts: u, willBreak: d, traverseDoc: o, findInDoc: v, mapDoc: c, propagateBreaks: f, removeLines: w, stripTrailingHardline: S, normalizeParts: k, normalizeDoc: P, cleanDoc: I, replaceTextEndOfLine: D, replaceEndOfLine: C, canBreak: F };
          } }), yD = Z({ "src/document/doc-printer.js"(e, n) {
            "use strict";
            re();
            var { convertEndOfLineToChars: t3 } = jn(), s = it(), a = Ca(), { fill: r, cursor: u, indent: i } = Ln(), { isConcat: o, getDocParts: c } = On(), v, m = 1, d = 2;
            function p() {
              return { value: "", length: 0, queue: [] };
            }
            function f(B, I) {
              return w(B, { type: "indent" }, I);
            }
            function h(B, I, k) {
              return I === Number.NEGATIVE_INFINITY ? B.root || p() : I < 0 ? w(B, { type: "dedent" }, k) : I ? I.type === "root" ? Object.assign(Object.assign({}, B), {}, { root: B }) : w(B, { type: typeof I == "string" ? "stringAlign" : "numberAlign", n: I }, k) : B;
            }
            function w(B, I, k) {
              let P = I.type === "dedent" ? B.queue.slice(0, -1) : [...B.queue, I], C = "", D = 0, g = 0, F = 0;
              for (let L of P)
                switch (L.type) {
                  case "indent":
                    y(), k.useTabs ? l(1) : E(k.tabWidth);
                    break;
                  case "stringAlign":
                    y(), C += L.n, D += L.n.length;
                    break;
                  case "numberAlign":
                    g += 1, F += L.n;
                    break;
                  default:
                    throw new Error("Unexpected type '".concat(L.type, "'"));
                }
              return x(), Object.assign(Object.assign({}, B), {}, { value: C, length: D, queue: P });
              function l(L) {
                C += "	".repeat(L), D += k.tabWidth * L;
              }
              function E(L) {
                C += " ".repeat(L), D += L;
              }
              function y() {
                k.useTabs ? N() : x();
              }
              function N() {
                g > 0 && l(g), b();
              }
              function x() {
                F > 0 && E(F), b();
              }
              function b() {
                g = 0, F = 0;
              }
            }
            function T(B) {
              if (B.length === 0)
                return 0;
              let I = 0;
              for (; B.length > 0 && typeof s(B) == "string" && /^[\t ]*$/.test(s(B)); )
                I += B.pop().length;
              if (B.length > 0 && typeof s(B) == "string") {
                let k = s(B).replace(/[\t ]*$/, "");
                I += s(B).length - k.length, B[B.length - 1] = k;
              }
              return I;
            }
            function A(B, I, k, P, C, D) {
              let g = I.length, F = [B], l = [];
              for (; k >= 0; ) {
                if (F.length === 0) {
                  if (g === 0)
                    return true;
                  F.push(I[g - 1]), g--;
                  continue;
                }
                let [E, y, N] = F.pop();
                if (typeof N == "string")
                  l.push(N), k -= a(N);
                else if (o(N)) {
                  let x = c(N);
                  for (let b = x.length - 1; b >= 0; b--)
                    F.push([E, y, x[b]]);
                } else
                  switch (N.type) {
                    case "indent":
                      F.push([f(E, P), y, N.contents]);
                      break;
                    case "align":
                      F.push([h(E, N.n, P), y, N.contents]);
                      break;
                    case "trim":
                      k += T(l);
                      break;
                    case "group": {
                      if (D && N.break)
                        return false;
                      let x = N.break ? m : y;
                      F.push([E, x, N.expandedStates && x === m ? s(N.expandedStates) : N.contents]), N.id && (v[N.id] = x);
                      break;
                    }
                    case "fill":
                      for (let x = N.parts.length - 1; x >= 0; x--)
                        F.push([E, y, N.parts[x]]);
                      break;
                    case "if-break":
                    case "indent-if-break": {
                      let x = N.groupId ? v[N.groupId] : y;
                      if (x === m) {
                        let b = N.type === "if-break" ? N.breakContents : N.negate ? N.contents : i(N.contents);
                        b && F.push([E, y, b]);
                      }
                      if (x === d) {
                        let b = N.type === "if-break" ? N.flatContents : N.negate ? i(N.contents) : N.contents;
                        b && F.push([E, y, b]);
                      }
                      break;
                    }
                    case "line":
                      switch (y) {
                        case d:
                          if (!N.hard) {
                            N.soft || (l.push(" "), k -= 1);
                            break;
                          }
                          return true;
                        case m:
                          return true;
                      }
                      break;
                    case "line-suffix":
                      C = true;
                      break;
                    case "line-suffix-boundary":
                      if (C)
                        return false;
                      break;
                    case "label":
                      F.push([E, y, N.contents]);
                      break;
                  }
              }
              return false;
            }
            function S(B, I) {
              v = {};
              let k = I.printWidth, P = t3(I.endOfLine), C = 0, D = [[p(), m, B]], g = [], F = false, l = [];
              for (; D.length > 0; ) {
                let [y, N, x] = D.pop();
                if (typeof x == "string") {
                  let b = P !== `
` ? x.replace(/\n/g, P) : x;
                  g.push(b), C += a(b);
                } else if (o(x)) {
                  let b = c(x);
                  for (let L = b.length - 1; L >= 0; L--)
                    D.push([y, N, b[L]]);
                } else
                  switch (x.type) {
                    case "cursor":
                      g.push(u.placeholder);
                      break;
                    case "indent":
                      D.push([f(y, I), N, x.contents]);
                      break;
                    case "align":
                      D.push([h(y, x.n, I), N, x.contents]);
                      break;
                    case "trim":
                      C -= T(g);
                      break;
                    case "group":
                      switch (N) {
                        case d:
                          if (!F) {
                            D.push([y, x.break ? m : d, x.contents]);
                            break;
                          }
                        case m: {
                          F = false;
                          let b = [y, d, x.contents], L = k - C, M = l.length > 0;
                          if (!x.break && A(b, D, L, I, M))
                            D.push(b);
                          else if (x.expandedStates) {
                            let j = s(x.expandedStates);
                            if (x.break) {
                              D.push([y, m, j]);
                              break;
                            } else
                              for (let $ = 1; $ < x.expandedStates.length + 1; $++)
                                if ($ >= x.expandedStates.length) {
                                  D.push([y, m, j]);
                                  break;
                                } else {
                                  let V = x.expandedStates[$], q = [y, d, V];
                                  if (A(q, D, L, I, M)) {
                                    D.push(q);
                                    break;
                                  }
                                }
                          } else
                            D.push([y, m, x.contents]);
                          break;
                        }
                      }
                      x.id && (v[x.id] = s(D)[1]);
                      break;
                    case "fill": {
                      let b = k - C, { parts: L } = x;
                      if (L.length === 0)
                        break;
                      let [M, j] = L, $ = [y, d, M], V = [y, m, M], q = A($, [], b, I, l.length > 0, true);
                      if (L.length === 1) {
                        q ? D.push($) : D.push(V);
                        break;
                      }
                      let Y = [y, d, j], H = [y, m, j];
                      if (L.length === 2) {
                        q ? D.push(Y, $) : D.push(H, V);
                        break;
                      }
                      L.splice(0, 2);
                      let R = [y, N, r(L)], Q = L[0];
                      A([y, d, [M, j, Q]], [], b, I, l.length > 0, true) ? D.push(R, Y, $) : q ? D.push(R, H, $) : D.push(R, H, V);
                      break;
                    }
                    case "if-break":
                    case "indent-if-break": {
                      let b = x.groupId ? v[x.groupId] : N;
                      if (b === m) {
                        let L = x.type === "if-break" ? x.breakContents : x.negate ? x.contents : i(x.contents);
                        L && D.push([y, N, L]);
                      }
                      if (b === d) {
                        let L = x.type === "if-break" ? x.flatContents : x.negate ? i(x.contents) : x.contents;
                        L && D.push([y, N, L]);
                      }
                      break;
                    }
                    case "line-suffix":
                      l.push([y, N, x.contents]);
                      break;
                    case "line-suffix-boundary":
                      l.length > 0 && D.push([y, N, { type: "line", hard: true }]);
                      break;
                    case "line":
                      switch (N) {
                        case d:
                          if (x.hard)
                            F = true;
                          else {
                            x.soft || (g.push(" "), C += 1);
                            break;
                          }
                        case m:
                          if (l.length > 0) {
                            D.push([y, N, x], ...l.reverse()), l = [];
                            break;
                          }
                          x.literal ? y.root ? (g.push(P, y.root.value), C = y.root.length) : (g.push(P), C = 0) : (C -= T(g), g.push(P + y.value), C = y.length);
                          break;
                      }
                      break;
                    case "label":
                      D.push([y, N, x.contents]);
                      break;
                    default:
                  }
                D.length === 0 && l.length > 0 && (D.push(...l.reverse()), l = []);
              }
              let E = g.indexOf(u.placeholder);
              if (E !== -1) {
                let y = g.indexOf(u.placeholder, E + 1), N = g.slice(0, E).join(""), x = g.slice(E + 1, y).join(""), b = g.slice(y + 1).join("");
                return { formatted: N + x + b, cursorNodeStart: N.length, cursorNodeText: x };
              }
              return { formatted: g.join("") };
            }
            n.exports = { printDocToString: S };
          } }), hD = Z({ "src/document/doc-debug.js"(e, n) {
            "use strict";
            re();
            var { isConcat: t3, getDocParts: s } = On();
            function a(u) {
              if (!u)
                return "";
              if (t3(u)) {
                let i = [];
                for (let o of s(u))
                  if (t3(o))
                    i.push(...a(o).parts);
                  else {
                    let c = a(o);
                    c !== "" && i.push(c);
                  }
                return { type: "concat", parts: i };
              }
              return u.type === "if-break" ? Object.assign(Object.assign({}, u), {}, { breakContents: a(u.breakContents), flatContents: a(u.flatContents) }) : u.type === "group" ? Object.assign(Object.assign({}, u), {}, { contents: a(u.contents), expandedStates: u.expandedStates && u.expandedStates.map(a) }) : u.type === "fill" ? { type: "fill", parts: u.parts.map(a) } : u.contents ? Object.assign(Object.assign({}, u), {}, { contents: a(u.contents) }) : u;
            }
            function r(u) {
              let i = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ new Set();
              return c(a(u));
              function c(m, d, p) {
                if (typeof m == "string")
                  return JSON.stringify(m);
                if (t3(m)) {
                  let f = s(m).map(c).filter(Boolean);
                  return f.length === 1 ? f[0] : "[".concat(f.join(", "), "]");
                }
                if (m.type === "line") {
                  let f = Array.isArray(p) && p[d + 1] && p[d + 1].type === "break-parent";
                  return m.literal ? f ? "literalline" : "literallineWithoutBreakParent" : m.hard ? f ? "hardline" : "hardlineWithoutBreakParent" : m.soft ? "softline" : "line";
                }
                if (m.type === "break-parent")
                  return Array.isArray(p) && p[d - 1] && p[d - 1].type === "line" && p[d - 1].hard ? void 0 : "breakParent";
                if (m.type === "trim")
                  return "trim";
                if (m.type === "indent")
                  return "indent(" + c(m.contents) + ")";
                if (m.type === "align")
                  return m.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + c(m.contents) + ")" : m.n < 0 ? "dedent(" + c(m.contents) + ")" : m.n.type === "root" ? "markAsRoot(" + c(m.contents) + ")" : "align(" + JSON.stringify(m.n) + ", " + c(m.contents) + ")";
                if (m.type === "if-break")
                  return "ifBreak(" + c(m.breakContents) + (m.flatContents ? ", " + c(m.flatContents) : "") + (m.groupId ? (m.flatContents ? "" : ', ""') + ", { groupId: ".concat(v(m.groupId), " }") : "") + ")";
                if (m.type === "indent-if-break") {
                  let f = [];
                  m.negate && f.push("negate: true"), m.groupId && f.push("groupId: ".concat(v(m.groupId)));
                  let h = f.length > 0 ? ", { ".concat(f.join(", "), " }") : "";
                  return "indentIfBreak(".concat(c(m.contents)).concat(h, ")");
                }
                if (m.type === "group") {
                  let f = [];
                  m.break && m.break !== "propagated" && f.push("shouldBreak: true"), m.id && f.push("id: ".concat(v(m.id)));
                  let h = f.length > 0 ? ", { ".concat(f.join(", "), " }") : "";
                  return m.expandedStates ? "conditionalGroup([".concat(m.expandedStates.map((w) => c(w)).join(","), "]").concat(h, ")") : "group(".concat(c(m.contents)).concat(h, ")");
                }
                if (m.type === "fill")
                  return "fill([".concat(m.parts.map((f) => c(f)).join(", "), "])");
                if (m.type === "line-suffix")
                  return "lineSuffix(" + c(m.contents) + ")";
                if (m.type === "line-suffix-boundary")
                  return "lineSuffixBoundary";
                if (m.type === "label")
                  return "label(".concat(JSON.stringify(m.label), ", ").concat(c(m.contents), ")");
                throw new Error("Unknown doc type " + m.type);
              }
              function v(m) {
                if (typeof m != "symbol")
                  return JSON.stringify(String(m));
                if (m in i)
                  return i[m];
                let d = String(m).slice(7, -1) || "symbol";
                for (let p = 0; ; p++) {
                  let f = d + (p > 0 ? " #".concat(p) : "");
                  if (!o.has(f))
                    return o.add(f), i[m] = "Symbol.for(".concat(JSON.stringify(f), ")");
                }
              }
            }
            n.exports = { printDocToDebug: r };
          } }), Oe = Z({ "src/document/index.js"(e, n) {
            "use strict";
            re(), n.exports = { builders: Ln(), printer: yD(), utils: On(), debug: hD() };
          } }), Ea = {};
          Ut(Ea, { default: () => vD });
          function vD(e) {
            if (typeof e != "string")
              throw new TypeError("Expected a string");
            return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
          }
          var CD = mt({ "node_modules/escape-string-regexp/index.js"() {
            re();
          } }), Fa = Z({ "node_modules/semver/internal/debug.js"(e, n) {
            re();
            var t3 = typeof Tt == "object" && Tt.env && Tt.env.NODE_DEBUG && /\bsemver\b/i.test(Tt.env.NODE_DEBUG) ? function() {
              for (var s = arguments.length, a = new Array(s), r = 0; r < s; r++)
                a[r] = arguments[r];
              return console.error("SEMVER", ...a);
            } : () => {
            };
            n.exports = t3;
          } }), Aa = Z({ "node_modules/semver/internal/constants.js"(e, n) {
            re();
            var t3 = "2.0.0", s = 256, a = Number.MAX_SAFE_INTEGER || 9007199254740991, r = 16;
            n.exports = { SEMVER_SPEC_VERSION: t3, MAX_LENGTH: s, MAX_SAFE_INTEGER: a, MAX_SAFE_COMPONENT_LENGTH: r };
          } }), ED = Z({ "node_modules/semver/internal/re.js"(e, n) {
            re();
            var { MAX_SAFE_COMPONENT_LENGTH: t3 } = Aa(), s = Fa();
            e = n.exports = {};
            var a = e.re = [], r = e.src = [], u = e.t = {}, i = 0, o = (c, v, m) => {
              let d = i++;
              s(c, d, v), u[c] = d, r[d] = v, a[d] = new RegExp(v, m ? "g" : void 0);
            };
            o("NUMERICIDENTIFIER", "0|[1-9]\\d*"), o("NUMERICIDENTIFIERLOOSE", "[0-9]+"), o("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), o("MAINVERSION", "(".concat(r[u.NUMERICIDENTIFIER], ")\\.(").concat(r[u.NUMERICIDENTIFIER], ")\\.(").concat(r[u.NUMERICIDENTIFIER], ")")), o("MAINVERSIONLOOSE", "(".concat(r[u.NUMERICIDENTIFIERLOOSE], ")\\.(").concat(r[u.NUMERICIDENTIFIERLOOSE], ")\\.(").concat(r[u.NUMERICIDENTIFIERLOOSE], ")")), o("PRERELEASEIDENTIFIER", "(?:".concat(r[u.NUMERICIDENTIFIER], "|").concat(r[u.NONNUMERICIDENTIFIER], ")")), o("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(r[u.NUMERICIDENTIFIERLOOSE], "|").concat(r[u.NONNUMERICIDENTIFIER], ")")), o("PRERELEASE", "(?:-(".concat(r[u.PRERELEASEIDENTIFIER], "(?:\\.").concat(r[u.PRERELEASEIDENTIFIER], ")*))")), o("PRERELEASELOOSE", "(?:-?(".concat(r[u.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(r[u.PRERELEASEIDENTIFIERLOOSE], ")*))")), o("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), o("BUILD", "(?:\\+(".concat(r[u.BUILDIDENTIFIER], "(?:\\.").concat(r[u.BUILDIDENTIFIER], ")*))")), o("FULLPLAIN", "v?".concat(r[u.MAINVERSION]).concat(r[u.PRERELEASE], "?").concat(r[u.BUILD], "?")), o("FULL", "^".concat(r[u.FULLPLAIN], "$")), o("LOOSEPLAIN", "[v=\\s]*".concat(r[u.MAINVERSIONLOOSE]).concat(r[u.PRERELEASELOOSE], "?").concat(r[u.BUILD], "?")), o("LOOSE", "^".concat(r[u.LOOSEPLAIN], "$")), o("GTLT", "((?:<|>)?=?)"), o("XRANGEIDENTIFIERLOOSE", "".concat(r[u.NUMERICIDENTIFIERLOOSE], "|x|X|\\*")), o("XRANGEIDENTIFIER", "".concat(r[u.NUMERICIDENTIFIER], "|x|X|\\*")), o("XRANGEPLAIN", "[v=\\s]*(".concat(r[u.XRANGEIDENTIFIER], ")(?:\\.(").concat(r[u.XRANGEIDENTIFIER], ")(?:\\.(").concat(r[u.XRANGEIDENTIFIER], ")(?:").concat(r[u.PRERELEASE], ")?").concat(r[u.BUILD], "?)?)?")), o("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(r[u.XRANGEIDENTIFIERLOOSE], ")(?:\\.(").concat(r[u.XRANGEIDENTIFIERLOOSE], ")(?:\\.(").concat(r[u.XRANGEIDENTIFIERLOOSE], ")(?:").concat(r[u.PRERELEASELOOSE], ")?").concat(r[u.BUILD], "?)?)?")), o("XRANGE", "^".concat(r[u.GTLT], "\\s*").concat(r[u.XRANGEPLAIN], "$")), o("XRANGELOOSE", "^".concat(r[u.GTLT], "\\s*").concat(r[u.XRANGEPLAINLOOSE], "$")), o("COERCE", "(^|[^\\d])(\\d{1,".concat(t3, "})(?:\\.(\\d{1,").concat(t3, "}))?(?:\\.(\\d{1,").concat(t3, "}))?(?:$|[^\\d])")), o("COERCERTL", r[u.COERCE], true), o("LONETILDE", "(?:~>?)"), o("TILDETRIM", "(\\s*)".concat(r[u.LONETILDE], "\\s+"), true), e.tildeTrimReplace = "$1~", o("TILDE", "^".concat(r[u.LONETILDE]).concat(r[u.XRANGEPLAIN], "$")), o("TILDELOOSE", "^".concat(r[u.LONETILDE]).concat(r[u.XRANGEPLAINLOOSE], "$")), o("LONECARET", "(?:\\^)"), o("CARETTRIM", "(\\s*)".concat(r[u.LONECARET], "\\s+"), true), e.caretTrimReplace = "$1^", o("CARET", "^".concat(r[u.LONECARET]).concat(r[u.XRANGEPLAIN], "$")), o("CARETLOOSE", "^".concat(r[u.LONECARET]).concat(r[u.XRANGEPLAINLOOSE], "$")), o("COMPARATORLOOSE", "^".concat(r[u.GTLT], "\\s*(").concat(r[u.LOOSEPLAIN], ")$|^$")), o("COMPARATOR", "^".concat(r[u.GTLT], "\\s*(").concat(r[u.FULLPLAIN], ")$|^$")), o("COMPARATORTRIM", "(\\s*)".concat(r[u.GTLT], "\\s*(").concat(r[u.LOOSEPLAIN], "|").concat(r[u.XRANGEPLAIN], ")"), true), e.comparatorTrimReplace = "$1$2$3", o("HYPHENRANGE", "^\\s*(".concat(r[u.XRANGEPLAIN], ")\\s+-\\s+(").concat(r[u.XRANGEPLAIN], ")\\s*$")), o("HYPHENRANGELOOSE", "^\\s*(".concat(r[u.XRANGEPLAINLOOSE], ")\\s+-\\s+(").concat(r[u.XRANGEPLAINLOOSE], ")\\s*$")), o("STAR", "(<|>)?=?\\s*\\*"), o("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), o("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
          } }), FD = Z({ "node_modules/semver/internal/parse-options.js"(e, n) {
            re();
            var t3 = ["includePrerelease", "loose", "rtl"], s = (a) => a ? typeof a != "object" ? { loose: true } : t3.filter((r) => a[r]).reduce((r, u) => (r[u] = true, r), {}) : {};
            n.exports = s;
          } }), AD = Z({ "node_modules/semver/internal/identifiers.js"(e, n) {
            re();
            var t3 = /^[0-9]+$/, s = (r, u) => {
              let i = t3.test(r), o = t3.test(u);
              return i && o && (r = +r, u = +u), r === u ? 0 : i && !o ? -1 : o && !i ? 1 : r < u ? -1 : 1;
            }, a = (r, u) => s(u, r);
            n.exports = { compareIdentifiers: s, rcompareIdentifiers: a };
          } }), SD = Z({ "node_modules/semver/classes/semver.js"(e, n) {
            re();
            var t3 = Fa(), { MAX_LENGTH: s, MAX_SAFE_INTEGER: a } = Aa(), { re: r, t: u } = ED(), i = FD(), { compareIdentifiers: o } = AD(), c = class {
              constructor(v, m) {
                if (m = i(m), v instanceof c) {
                  if (v.loose === !!m.loose && v.includePrerelease === !!m.includePrerelease)
                    return v;
                  v = v.version;
                } else if (typeof v != "string")
                  throw new TypeError("Invalid Version: ".concat(v));
                if (v.length > s)
                  throw new TypeError("version is longer than ".concat(s, " characters"));
                t3("SemVer", v, m), this.options = m, this.loose = !!m.loose, this.includePrerelease = !!m.includePrerelease;
                let d = v.trim().match(m.loose ? r[u.LOOSE] : r[u.FULL]);
                if (!d)
                  throw new TypeError("Invalid Version: ".concat(v));
                if (this.raw = v, this.major = +d[1], this.minor = +d[2], this.patch = +d[3], this.major > a || this.major < 0)
                  throw new TypeError("Invalid major version");
                if (this.minor > a || this.minor < 0)
                  throw new TypeError("Invalid minor version");
                if (this.patch > a || this.patch < 0)
                  throw new TypeError("Invalid patch version");
                d[4] ? this.prerelease = d[4].split(".").map((p) => {
                  if (/^[0-9]+$/.test(p)) {
                    let f = +p;
                    if (f >= 0 && f < a)
                      return f;
                  }
                  return p;
                }) : this.prerelease = [], this.build = d[5] ? d[5].split(".") : [], this.format();
              }
              format() {
                return this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch), this.prerelease.length && (this.version += "-".concat(this.prerelease.join("."))), this.version;
              }
              toString() {
                return this.version;
              }
              compare(v) {
                if (t3("SemVer.compare", this.version, this.options, v), !(v instanceof c)) {
                  if (typeof v == "string" && v === this.version)
                    return 0;
                  v = new c(v, this.options);
                }
                return v.version === this.version ? 0 : this.compareMain(v) || this.comparePre(v);
              }
              compareMain(v) {
                return v instanceof c || (v = new c(v, this.options)), o(this.major, v.major) || o(this.minor, v.minor) || o(this.patch, v.patch);
              }
              comparePre(v) {
                if (v instanceof c || (v = new c(v, this.options)), this.prerelease.length && !v.prerelease.length)
                  return -1;
                if (!this.prerelease.length && v.prerelease.length)
                  return 1;
                if (!this.prerelease.length && !v.prerelease.length)
                  return 0;
                let m = 0;
                do {
                  let d = this.prerelease[m], p = v.prerelease[m];
                  if (t3("prerelease compare", m, d, p), d === void 0 && p === void 0)
                    return 0;
                  if (p === void 0)
                    return 1;
                  if (d === void 0)
                    return -1;
                  if (d === p)
                    continue;
                  return o(d, p);
                } while (++m);
              }
              compareBuild(v) {
                v instanceof c || (v = new c(v, this.options));
                let m = 0;
                do {
                  let d = this.build[m], p = v.build[m];
                  if (t3("prerelease compare", m, d, p), d === void 0 && p === void 0)
                    return 0;
                  if (p === void 0)
                    return 1;
                  if (d === void 0)
                    return -1;
                  if (d === p)
                    continue;
                  return o(d, p);
                } while (++m);
              }
              inc(v, m) {
                switch (v) {
                  case "premajor":
                    this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", m);
                    break;
                  case "preminor":
                    this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", m);
                    break;
                  case "prepatch":
                    this.prerelease.length = 0, this.inc("patch", m), this.inc("pre", m);
                    break;
                  case "prerelease":
                    this.prerelease.length === 0 && this.inc("patch", m), this.inc("pre", m);
                    break;
                  case "major":
                    (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                    break;
                  case "minor":
                    (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                    break;
                  case "patch":
                    this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                    break;
                  case "pre":
                    if (this.prerelease.length === 0)
                      this.prerelease = [0];
                    else {
                      let d = this.prerelease.length;
                      for (; --d >= 0; )
                        typeof this.prerelease[d] == "number" && (this.prerelease[d]++, d = -2);
                      d === -1 && this.prerelease.push(0);
                    }
                    m && (o(this.prerelease[0], m) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [m, 0]) : this.prerelease = [m, 0]);
                    break;
                  default:
                    throw new Error("invalid increment argument: ".concat(v));
                }
                return this.format(), this.raw = this.version, this;
              }
            };
            n.exports = c;
          } }), qn = Z({ "node_modules/semver/functions/compare.js"(e, n) {
            re();
            var t3 = SD(), s = (a, r, u) => new t3(a, u).compare(new t3(r, u));
            n.exports = s;
          } }), xD = Z({ "node_modules/semver/functions/lt.js"(e, n) {
            re();
            var t3 = qn(), s = (a, r, u) => t3(a, r, u) < 0;
            n.exports = s;
          } }), bD = Z({ "node_modules/semver/functions/gte.js"(e, n) {
            re();
            var t3 = qn(), s = (a, r, u) => t3(a, r, u) >= 0;
            n.exports = s;
          } }), TD = Z({ "src/utils/arrayify.js"(e, n) {
            "use strict";
            re(), n.exports = (t3, s) => Object.entries(t3).map((a) => {
              let [r, u] = a;
              return Object.assign({ [s]: r }, u);
            });
          } }), BD = Z({ "node_modules/outdent/lib/index.js"(e, n) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.outdent = void 0;
            function t3() {
              for (var A = [], S = 0; S < arguments.length; S++)
                A[S] = arguments[S];
            }
            function s() {
              return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : a();
            }
            function a() {
              return { add: t3, delete: t3, get: t3, set: t3, has: function(A) {
                return false;
              } };
            }
            var r = Object.prototype.hasOwnProperty, u = function(A, S) {
              return r.call(A, S);
            };
            function i(A, S) {
              for (var B in S)
                u(S, B) && (A[B] = S[B]);
              return A;
            }
            var o = /^[ \t]*(?:\r\n|\r|\n)/, c = /(?:\r\n|\r|\n)[ \t]*$/, v = /^(?:[\r\n]|$)/, m = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, d = /^[ \t]*[\r\n][ \t\r\n]*$/;
            function p(A, S, B) {
              var I = 0, k = A[0].match(m);
              k && (I = k[1].length);
              var P = "(\\r\\n|\\r|\\n).{0," + I + "}", C = new RegExp(P, "g");
              S && (A = A.slice(1));
              var D = B.newline, g = B.trimLeadingNewline, F = B.trimTrailingNewline, l = typeof D == "string", E = A.length, y = A.map(function(N, x) {
                return N = N.replace(C, "$1"), x === 0 && g && (N = N.replace(o, "")), x === E - 1 && F && (N = N.replace(c, "")), l && (N = N.replace(/\r\n|\n|\r/g, function(b) {
                  return D;
                })), N;
              });
              return y;
            }
            function f(A, S) {
              for (var B = "", I = 0, k = A.length; I < k; I++)
                B += A[I], I < k - 1 && (B += S[I]);
              return B;
            }
            function h(A) {
              return u(A, "raw") && u(A, "length");
            }
            function w(A) {
              var S = s(), B = s();
              function I(P) {
                for (var C = [], D = 1; D < arguments.length; D++)
                  C[D - 1] = arguments[D];
                if (h(P)) {
                  var g = P, F = (C[0] === I || C[0] === T) && d.test(g[0]) && v.test(g[1]), l = F ? B : S, E = l.get(g);
                  if (E || (E = p(g, F, A), l.set(g, E)), C.length === 0)
                    return E[0];
                  var y = f(E, F ? C.slice(1) : C);
                  return y;
                } else
                  return w(i(i({}, A), P || {}));
              }
              var k = i(I, { string: function(P) {
                return p([P], false, A)[0];
              } });
              return k;
            }
            var T = w({ trimLeadingNewline: true, trimTrailingNewline: true });
            if (e.outdent = T, e.default = T, typeof n < "u")
              try {
                n.exports = T, Object.defineProperty(T, "__esModule", { value: true }), T.default = T, T.outdent = T;
              } catch {
              }
          } }), ND = Z({ "src/main/core-options.js"(e, n) {
            "use strict";
            re();
            var { outdent: t3 } = BD(), s = "Config", a = "Editor", r = "Format", u = "Other", i = "Output", o = "Global", c = "Special", v = { cursorOffset: { since: "1.4.0", category: c, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3(sa || (sa = Pt([`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `]))), cliCategory: a }, endOfLine: { since: "1.15.0", category: o, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: t3(ia || (ia = Pt([`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        `]))) }] }, filepath: { since: "1.4.0", category: c, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: u, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: c, type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: u }, parser: { since: "0.0.10", category: o, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (m) => typeof m == "string" || typeof m == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: true, default: [{ value: [] }], category: o, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (m) => typeof m == "string" || typeof m == "object", cliName: "plugin", cliCategory: s }, pluginSearchDirs: { since: "1.13.0", type: "path", array: true, default: [{ value: [] }], category: o, description: t3(aa || (aa = Pt([`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `]))), exception: (m) => typeof m == "string" || typeof m == "object", cliName: "plugin-search-dir", cliCategory: s }, printWidth: { since: "0.0.0", category: o, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: c, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3(oa || (oa = Pt([`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `]))), cliCategory: a }, rangeStart: { since: "1.4.0", category: c, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3(la || (la = Pt([`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `]))), cliCategory: a }, requirePragma: { since: "1.7.0", category: c, type: "boolean", default: false, description: t3(ca || (ca = Pt([`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `]))), cliCategory: u }, tabWidth: { type: "int", category: o, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: o, type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: o, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
            n.exports = { CATEGORY_CONFIG: s, CATEGORY_EDITOR: a, CATEGORY_FORMAT: r, CATEGORY_OTHER: u, CATEGORY_OUTPUT: i, CATEGORY_GLOBAL: o, CATEGORY_SPECIAL: c, options: v };
          } }), Mn = Z({ "src/main/support.js"(e, n) {
            "use strict";
            re();
            var t3 = { compare: qn(), lt: xD(), gte: bD() }, s = TD(), a = ya().version, r = ND().options;
            function u() {
              let { plugins: o = [], showUnreleased: c = false, showDeprecated: v = false, showInternal: m = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = a.split("-", 1)[0], p = o.flatMap((A) => A.languages || []).filter(h), f = s(Object.assign({}, ...o.map((A) => {
                let { options: S } = A;
                return S;
              }), r), "name").filter((A) => h(A) && w(A)).sort((A, S) => A.name === S.name ? 0 : A.name < S.name ? -1 : 1).map(T).map((A) => {
                A = Object.assign({}, A), Array.isArray(A.default) && (A.default = A.default.length === 1 ? A.default[0].value : A.default.filter(h).sort((B, I) => t3.compare(I.since, B.since))[0].value), Array.isArray(A.choices) && (A.choices = A.choices.filter((B) => h(B) && w(B)), A.name === "parser" && i(A, p, o));
                let S = Object.fromEntries(o.filter((B) => B.defaultOptions && B.defaultOptions[A.name] !== void 0).map((B) => [B.name, B.defaultOptions[A.name]]));
                return Object.assign(Object.assign({}, A), {}, { pluginDefaults: S });
              });
              return { languages: p, options: f };
              function h(A) {
                return c || !("since" in A) || A.since && t3.gte(d, A.since);
              }
              function w(A) {
                return v || !("deprecated" in A) || A.deprecated && t3.lt(d, A.deprecated);
              }
              function T(A) {
                if (m)
                  return A;
                let { cliName: S, cliCategory: B, cliDescription: I } = A;
                return kn(A, Yf);
              }
            }
            function i(o, c, v) {
              let m = new Set(o.choices.map((d) => d.value));
              for (let d of c)
                if (d.parsers) {
                  for (let p of d.parsers)
                    if (!m.has(p)) {
                      m.add(p);
                      let f = v.find((w) => w.parsers && w.parsers[p]), h = d.name;
                      f && f.name && (h += " (plugin: ".concat(f.name, ")")), o.choices.push({ value: p, description: h });
                    }
                }
            }
            n.exports = { getSupportInfo: u };
          } }), Rn = Z({ "src/utils/is-non-empty-array.js"(e, n) {
            "use strict";
            re();
            function t3(s) {
              return Array.isArray(s) && s.length > 0;
            }
            n.exports = t3;
          } }), Nr = Z({ "src/utils/text/skip.js"(e, n) {
            "use strict";
            re();
            function t3(i) {
              return (o, c, v) => {
                let m = v && v.backwards;
                if (c === false)
                  return false;
                let { length: d } = o, p = c;
                for (; p >= 0 && p < d; ) {
                  let f = o.charAt(p);
                  if (i instanceof RegExp) {
                    if (!i.test(f))
                      return p;
                  } else if (!i.includes(f))
                    return p;
                  m ? p-- : p++;
                }
                return p === -1 || p === d ? p : false;
              };
            }
            var s = t3(/\s/), a = t3(" 	"), r = t3(",; 	"), u = t3(/[^\n\r]/);
            n.exports = { skipWhitespace: s, skipSpaces: a, skipToLineEnd: r, skipEverythingButNewLine: u };
          } }), Sa = Z({ "src/utils/text/skip-inline-comment.js"(e, n) {
            "use strict";
            re();
            function t3(s, a) {
              if (a === false)
                return false;
              if (s.charAt(a) === "/" && s.charAt(a + 1) === "*") {
                for (let r = a + 2; r < s.length; ++r)
                  if (s.charAt(r) === "*" && s.charAt(r + 1) === "/")
                    return r + 2;
              }
              return a;
            }
            n.exports = t3;
          } }), xa = Z({ "src/utils/text/skip-trailing-comment.js"(e, n) {
            "use strict";
            re();
            var { skipEverythingButNewLine: t3 } = Nr();
            function s(a, r) {
              return r === false ? false : a.charAt(r) === "/" && a.charAt(r + 1) === "/" ? t3(a, r) : r;
            }
            n.exports = s;
          } }), ba = Z({ "src/utils/text/skip-newline.js"(e, n) {
            "use strict";
            re();
            function t3(s, a, r) {
              let u = r && r.backwards;
              if (a === false)
                return false;
              let i = s.charAt(a);
              if (u) {
                if (s.charAt(a - 1) === "\r" && i === `
`)
                  return a - 2;
                if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029")
                  return a - 1;
              } else {
                if (i === "\r" && s.charAt(a + 1) === `
`)
                  return a + 2;
                if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029")
                  return a + 1;
              }
              return a;
            }
            n.exports = t3;
          } }), wD = Z({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e, n) {
            "use strict";
            re();
            var t3 = Sa(), s = ba(), a = xa(), { skipSpaces: r } = Nr();
            function u(i, o) {
              let c = null, v = o;
              for (; v !== c; )
                c = v, v = r(i, v), v = t3(i, v), v = a(i, v), v = s(i, v);
              return v;
            }
            n.exports = u;
          } }), Ue = Z({ "src/common/util.js"(e, n) {
            "use strict";
            re();
            var { default: t3 } = (CD(), lt2(Ea)), s = it(), { getSupportInfo: a } = Mn(), r = Rn(), u = Ca(), { skipWhitespace: i, skipSpaces: o, skipToLineEnd: c, skipEverythingButNewLine: v } = Nr(), m = Sa(), d = xa(), p = ba(), f = wD(), h = (H) => H[H.length - 2];
            function w(H) {
              return (R, Q, ee) => {
                let te = ee && ee.backwards;
                if (Q === false)
                  return false;
                let { length: oe } = R, W = Q;
                for (; W >= 0 && W < oe; ) {
                  let X = R.charAt(W);
                  if (H instanceof RegExp) {
                    if (!H.test(X))
                      return W;
                  } else if (!H.includes(X))
                    return W;
                  te ? W-- : W++;
                }
                return W === -1 || W === oe ? W : false;
              };
            }
            function T(H, R) {
              let Q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ee = o(H, Q.backwards ? R - 1 : R, Q), te = p(H, ee, Q);
              return ee !== te;
            }
            function A(H, R, Q) {
              for (let ee = R; ee < Q; ++ee)
                if (H.charAt(ee) === `
`)
                  return true;
              return false;
            }
            function S(H, R, Q) {
              let ee = Q(R) - 1;
              ee = o(H, ee, { backwards: true }), ee = p(H, ee, { backwards: true }), ee = o(H, ee, { backwards: true });
              let te = p(H, ee, { backwards: true });
              return ee !== te;
            }
            function B(H, R) {
              let Q = null, ee = R;
              for (; ee !== Q; )
                Q = ee, ee = c(H, ee), ee = m(H, ee), ee = o(H, ee);
              return ee = d(H, ee), ee = p(H, ee), ee !== false && T(H, ee);
            }
            function I(H, R, Q) {
              return B(H, Q(R));
            }
            function k(H, R, Q) {
              return f(H, Q(R));
            }
            function P(H, R, Q) {
              return H.charAt(k(H, R, Q));
            }
            function C(H, R) {
              let Q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              return o(H, Q.backwards ? R - 1 : R, Q) !== R;
            }
            function D(H, R) {
              let Q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, ee = 0;
              for (let te = Q; te < H.length; ++te)
                H[te] === "	" ? ee = ee + R - ee % R : ee++;
              return ee;
            }
            function g(H, R) {
              let Q = H.lastIndexOf(`
`);
              return Q === -1 ? 0 : D(H.slice(Q + 1).match(/^[\t ]*/)[0], R);
            }
            function F(H, R) {
              let Q = { quote: '"', regex: /"/g, escaped: "&quot;" }, ee = { quote: "'", regex: /'/g, escaped: "&apos;" }, te = R === "'" ? ee : Q, oe = te === ee ? Q : ee, W = te;
              if (H.includes(te.quote) || H.includes(oe.quote)) {
                let X = (H.match(te.regex) || []).length, ue = (H.match(oe.regex) || []).length;
                W = X > ue ? oe : te;
              }
              return W;
            }
            function l(H, R) {
              let Q = H.slice(1, -1), ee = R.parser === "json" || R.parser === "json5" && R.quoteProps === "preserve" && !R.singleQuote ? '"' : R.__isInHtmlAttribute ? "'" : F(Q, R.singleQuote ? "'" : '"').quote;
              return E(Q, ee, !(R.parser === "css" || R.parser === "less" || R.parser === "scss" || R.__embeddedInHtml));
            }
            function E(H, R, Q) {
              let ee = R === '"' ? "'" : '"', te = /\\(.)|(["'])/gs, oe = H.replace(te, (W, X, ue) => X === ee ? X : ue === R ? "\\" + ue : ue || (Q && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(X) ? X : "\\" + X));
              return R + oe + R;
            }
            function y(H) {
              return H.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
            }
            function N(H, R) {
              let Q = H.match(new RegExp("(".concat(t3(R), ")+"), "g"));
              return Q === null ? 0 : Q.reduce((ee, te) => Math.max(ee, te.length / R.length), 0);
            }
            function x(H, R) {
              let Q = H.match(new RegExp("(".concat(t3(R), ")+"), "g"));
              if (Q === null)
                return 0;
              let ee = /* @__PURE__ */ new Map(), te = 0;
              for (let oe of Q) {
                let W = oe.length / R.length;
                ee.set(W, true), W > te && (te = W);
              }
              for (let oe = 1; oe < te; oe++)
                if (!ee.get(oe))
                  return oe;
              return te + 1;
            }
            function b(H, R) {
              (H.comments || (H.comments = [])).push(R), R.printed = false, R.nodeDescription = Y(H);
            }
            function L(H, R) {
              R.leading = true, R.trailing = false, b(H, R);
            }
            function M(H, R, Q) {
              R.leading = false, R.trailing = false, Q && (R.marker = Q), b(H, R);
            }
            function j(H, R) {
              R.leading = false, R.trailing = true, b(H, R);
            }
            function $(H, R) {
              let { languages: Q } = a({ plugins: R.plugins }), ee = Q.find((te) => {
                let { name: oe } = te;
                return oe.toLowerCase() === H;
              }) || Q.find((te) => {
                let { aliases: oe } = te;
                return Array.isArray(oe) && oe.includes(H);
              }) || Q.find((te) => {
                let { extensions: oe } = te;
                return Array.isArray(oe) && oe.includes(".".concat(H));
              });
              return ee && ee.parsers[0];
            }
            function V(H) {
              return H && H.type === "front-matter";
            }
            function q(H) {
              let R = /* @__PURE__ */ new WeakMap();
              return function(Q) {
                return R.has(Q) || R.set(Q, Symbol(H)), R.get(Q);
              };
            }
            function Y(H) {
              let R = H.type || H.kind || "(unknown type)", Q = String(H.name || H.id && (typeof H.id == "object" ? H.id.name : H.id) || H.key && (typeof H.key == "object" ? H.key.name : H.key) || H.value && (typeof H.value == "object" ? "" : String(H.value)) || H.operator || "");
              return Q.length > 20 && (Q = Q.slice(0, 19) + "\u2026"), R + (Q ? " " + Q : "");
            }
            n.exports = { inferParserByLanguage: $, getStringWidth: u, getMaxContinuousCount: N, getMinNotPresentContinuousCount: x, getPenultimate: h, getLast: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: f, getNextNonSpaceNonCommentCharacterIndex: k, getNextNonSpaceNonCommentCharacter: P, skip: w, skipWhitespace: i, skipSpaces: o, skipToLineEnd: c, skipEverythingButNewLine: v, skipInlineComment: m, skipTrailingComment: d, skipNewline: p, isNextLineEmptyAfterIndex: B, isNextLineEmpty: I, isPreviousLineEmpty: S, hasNewline: T, hasNewlineInRange: A, hasSpaces: C, getAlignmentSize: D, getIndentSize: g, getPreferredQuote: F, printString: l, printNumber: y, makeString: E, addLeadingComment: L, addDanglingComment: M, addTrailingComment: j, isFrontMatterNode: V, isNonEmptyArray: r, createGroupIdMapper: q };
          } }), Ta = {};
          Ut(Ta, { basename: () => Pa, default: () => Ia, delimiter: () => Bn, dirname: () => _a, extname: () => ka, isAbsolute: () => Wn, join: () => Na, normalize: () => Vn, relative: () => wa, resolve: () => Tr, sep: () => Tn });
          function Ba(e, n) {
            for (var t3 = 0, s = e.length - 1; s >= 0; s--) {
              var a = e[s];
              a === "." ? e.splice(s, 1) : a === ".." ? (e.splice(s, 1), t3++) : t3 && (e.splice(s, 1), t3--);
            }
            if (n)
              for (; t3--; t3)
                e.unshift("..");
            return e;
          }
          function Tr() {
            for (var e = "", n = false, t3 = arguments.length - 1; t3 >= -1 && !n; t3--) {
              var s = t3 >= 0 ? arguments[t3] : "/";
              if (typeof s != "string")
                throw new TypeError("Arguments to path.resolve must be strings");
              if (!s)
                continue;
              e = s + "/" + e, n = s.charAt(0) === "/";
            }
            return e = Ba($n(e.split("/"), function(a) {
              return !!a;
            }), !n).join("/"), (n ? "/" : "") + e || ".";
          }
          function Vn(e) {
            var n = Wn(e), t3 = La(e, -1) === "/";
            return e = Ba($n(e.split("/"), function(s) {
              return !!s;
            }), !n).join("/"), !e && !n && (e = "."), e && t3 && (e += "/"), (n ? "/" : "") + e;
          }
          function Wn(e) {
            return e.charAt(0) === "/";
          }
          function Na() {
            var e = Array.prototype.slice.call(arguments, 0);
            return Vn($n(e, function(n, t3) {
              if (typeof n != "string")
                throw new TypeError("Arguments to path.join must be strings");
              return n;
            }).join("/"));
          }
          function wa(e, n) {
            e = Tr(e).substr(1), n = Tr(n).substr(1);
            function t3(c) {
              for (var v = 0; v < c.length && c[v] === ""; v++)
                ;
              for (var m = c.length - 1; m >= 0 && c[m] === ""; m--)
                ;
              return v > m ? [] : c.slice(v, m - v + 1);
            }
            for (var s = t3(e.split("/")), a = t3(n.split("/")), r = Math.min(s.length, a.length), u = r, i = 0; i < r; i++)
              if (s[i] !== a[i]) {
                u = i;
                break;
              }
            for (var o = [], i = u; i < s.length; i++)
              o.push("..");
            return o = o.concat(a.slice(u)), o.join("/");
          }
          function _a(e) {
            var n = wr(e), t3 = n[0], s = n[1];
            return !t3 && !s ? "." : (s && (s = s.substr(0, s.length - 1)), t3 + s);
          }
          function Pa(e, n) {
            var t3 = wr(e)[2];
            return n && t3.substr(-1 * n.length) === n && (t3 = t3.substr(0, t3.length - n.length)), t3;
          }
          function ka(e) {
            return wr(e)[3];
          }
          function $n(e, n) {
            if (e.filter)
              return e.filter(n);
            for (var t3 = [], s = 0; s < e.length; s++)
              n(e[s], s, e) && t3.push(e[s]);
            return t3;
          }
          var Da, wr, Tn, Bn, Ia, La, _D = mt({ "node-modules-polyfills:path"() {
            re(), Da = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, wr = function(e) {
              return Da.exec(e).slice(1);
            }, Tn = "/", Bn = ":", Ia = { extname: ka, basename: Pa, dirname: _a, sep: Tn, delimiter: Bn, relative: wa, join: Na, isAbsolute: Wn, normalize: Vn, resolve: Tr }, La = "ab".substr(-1) === "b" ? function(e, n, t3) {
              return e.substr(n, t3);
            } : function(e, n, t3) {
              return n < 0 && (n = e.length + n), e.substr(n, t3);
            };
          } }), PD = Z({ "node-modules-polyfills-commonjs:path"(e, n) {
            re();
            var t3 = (_D(), lt2(Ta));
            if (t3 && t3.default) {
              n.exports = t3.default;
              for (let s in t3)
                n.exports[s] = t3[s];
            } else
              t3 && (n.exports = t3);
          } }), zt = Z({ "src/common/errors.js"(e, n) {
            "use strict";
            re();
            var t3 = class extends Error {
            }, s = class extends Error {
            }, a = class extends Error {
            }, r = class extends Error {
            };
            n.exports = { ConfigError: t3, DebugError: s, UndefinedParserError: a, ArgExpansionBailout: r };
          } }), dt = {};
          Ut(dt, { __assign: () => br, __asyncDelegator: () => GD, __asyncGenerator: () => HD, __asyncValues: () => JD, __await: () => Jt, __awaiter: () => qD, __classPrivateFieldGet: () => KD, __classPrivateFieldSet: () => YD, __createBinding: () => RD, __decorate: () => LD, __exportStar: () => VD, __extends: () => kD, __generator: () => MD, __importDefault: () => XD, __importStar: () => zD, __makeTemplateObject: () => UD, __metadata: () => OD, __param: () => jD, __read: () => ja, __rest: () => ID, __spread: () => WD, __spreadArrays: () => $D, __values: () => Nn });
          function kD(e, n) {
            xr(e, n);
            function t3() {
              this.constructor = e;
            }
            e.prototype = n === null ? Object.create(n) : (t3.prototype = n.prototype, new t3());
          }
          function ID(e, n) {
            var t3 = {};
            for (var s in e)
              Object.prototype.hasOwnProperty.call(e, s) && n.indexOf(s) < 0 && (t3[s] = e[s]);
            if (e != null && typeof Object.getOwnPropertySymbols == "function")
              for (var a = 0, s = Object.getOwnPropertySymbols(e); a < s.length; a++)
                n.indexOf(s[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, s[a]) && (t3[s[a]] = e[s[a]]);
            return t3;
          }
          function LD(e, n, t3, s) {
            var a = arguments.length, r = a < 3 ? n : s === null ? s = Object.getOwnPropertyDescriptor(n, t3) : s, u;
            if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
              r = Reflect.decorate(e, n, t3, s);
            else
              for (var i = e.length - 1; i >= 0; i--)
                (u = e[i]) && (r = (a < 3 ? u(r) : a > 3 ? u(n, t3, r) : u(n, t3)) || r);
            return a > 3 && r && Object.defineProperty(n, t3, r), r;
          }
          function jD(e, n) {
            return function(t3, s) {
              n(t3, s, e);
            };
          }
          function OD(e, n) {
            if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
              return Reflect.metadata(e, n);
          }
          function qD(e, n, t3, s) {
            function a(r) {
              return r instanceof t3 ? r : new t3(function(u) {
                u(r);
              });
            }
            return new (t3 || (t3 = Promise))(function(r, u) {
              function i(v) {
                try {
                  c(s.next(v));
                } catch (m) {
                  u(m);
                }
              }
              function o(v) {
                try {
                  c(s.throw(v));
                } catch (m) {
                  u(m);
                }
              }
              function c(v) {
                v.done ? r(v.value) : a(v.value).then(i, o);
              }
              c((s = s.apply(e, n || [])).next());
            });
          }
          function MD(e, n) {
            var t3 = { label: 0, sent: function() {
              if (r[0] & 1)
                throw r[1];
              return r[1];
            }, trys: [], ops: [] }, s, a, r, u;
            return u = { next: i(0), throw: i(1), return: i(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
              return this;
            }), u;
            function i(c) {
              return function(v) {
                return o([c, v]);
              };
            }
            function o(c) {
              if (s)
                throw new TypeError("Generator is already executing.");
              for (; t3; )
                try {
                  if (s = 1, a && (r = c[0] & 2 ? a.return : c[0] ? a.throw || ((r = a.return) && r.call(a), 0) : a.next) && !(r = r.call(a, c[1])).done)
                    return r;
                  switch (a = 0, r && (c = [c[0] & 2, r.value]), c[0]) {
                    case 0:
                    case 1:
                      r = c;
                      break;
                    case 4:
                      return t3.label++, { value: c[1], done: false };
                    case 5:
                      t3.label++, a = c[1], c = [0];
                      continue;
                    case 7:
                      c = t3.ops.pop(), t3.trys.pop();
                      continue;
                    default:
                      if (r = t3.trys, !(r = r.length > 0 && r[r.length - 1]) && (c[0] === 6 || c[0] === 2)) {
                        t3 = 0;
                        continue;
                      }
                      if (c[0] === 3 && (!r || c[1] > r[0] && c[1] < r[3])) {
                        t3.label = c[1];
                        break;
                      }
                      if (c[0] === 6 && t3.label < r[1]) {
                        t3.label = r[1], r = c;
                        break;
                      }
                      if (r && t3.label < r[2]) {
                        t3.label = r[2], t3.ops.push(c);
                        break;
                      }
                      r[2] && t3.ops.pop(), t3.trys.pop();
                      continue;
                  }
                  c = n.call(e, t3);
                } catch (v) {
                  c = [6, v], a = 0;
                } finally {
                  s = r = 0;
                }
              if (c[0] & 5)
                throw c[1];
              return { value: c[0] ? c[1] : void 0, done: true };
            }
          }
          function RD(e, n, t3, s) {
            s === void 0 && (s = t3), e[s] = n[t3];
          }
          function VD(e, n) {
            for (var t3 in e)
              t3 !== "default" && !n.hasOwnProperty(t3) && (n[t3] = e[t3]);
          }
          function Nn(e) {
            var n = typeof Symbol == "function" && Symbol.iterator, t3 = n && e[n], s = 0;
            if (t3)
              return t3.call(e);
            if (e && typeof e.length == "number")
              return { next: function() {
                return e && s >= e.length && (e = void 0), { value: e && e[s++], done: !e };
              } };
            throw new TypeError(n ? "Object is not iterable." : "Symbol.iterator is not defined.");
          }
          function ja(e, n) {
            var t3 = typeof Symbol == "function" && e[Symbol.iterator];
            if (!t3)
              return e;
            var s = t3.call(e), a, r = [], u;
            try {
              for (; (n === void 0 || n-- > 0) && !(a = s.next()).done; )
                r.push(a.value);
            } catch (i) {
              u = { error: i };
            } finally {
              try {
                a && !a.done && (t3 = s.return) && t3.call(s);
              } finally {
                if (u)
                  throw u.error;
              }
            }
            return r;
          }
          function WD() {
            for (var e = [], n = 0; n < arguments.length; n++)
              e = e.concat(ja(arguments[n]));
            return e;
          }
          function $D() {
            for (var e = 0, n = 0, t3 = arguments.length; n < t3; n++)
              e += arguments[n].length;
            for (var s = Array(e), a = 0, n = 0; n < t3; n++)
              for (var r = arguments[n], u = 0, i = r.length; u < i; u++, a++)
                s[a] = r[u];
            return s;
          }
          function Jt(e) {
            return this instanceof Jt ? (this.v = e, this) : new Jt(e);
          }
          function HD(e, n, t3) {
            if (!Symbol.asyncIterator)
              throw new TypeError("Symbol.asyncIterator is not defined.");
            var s = t3.apply(e, n || []), a, r = [];
            return a = {}, u("next"), u("throw"), u("return"), a[Symbol.asyncIterator] = function() {
              return this;
            }, a;
            function u(d) {
              s[d] && (a[d] = function(p) {
                return new Promise(function(f, h) {
                  r.push([d, p, f, h]) > 1 || i(d, p);
                });
              });
            }
            function i(d, p) {
              try {
                o(s[d](p));
              } catch (f) {
                m(r[0][3], f);
              }
            }
            function o(d) {
              d.value instanceof Jt ? Promise.resolve(d.value.v).then(c, v) : m(r[0][2], d);
            }
            function c(d) {
              i("next", d);
            }
            function v(d) {
              i("throw", d);
            }
            function m(d, p) {
              d(p), r.shift(), r.length && i(r[0][0], r[0][1]);
            }
          }
          function GD(e) {
            var n, t3;
            return n = {}, s("next"), s("throw", function(a) {
              throw a;
            }), s("return"), n[Symbol.iterator] = function() {
              return this;
            }, n;
            function s(a, r) {
              n[a] = e[a] ? function(u) {
                return (t3 = !t3) ? { value: Jt(e[a](u)), done: a === "return" } : r ? r(u) : u;
              } : r;
            }
          }
          function JD(e) {
            if (!Symbol.asyncIterator)
              throw new TypeError("Symbol.asyncIterator is not defined.");
            var n = e[Symbol.asyncIterator], t3;
            return n ? n.call(e) : (e = typeof Nn == "function" ? Nn(e) : e[Symbol.iterator](), t3 = {}, s("next"), s("throw"), s("return"), t3[Symbol.asyncIterator] = function() {
              return this;
            }, t3);
            function s(r) {
              t3[r] = e[r] && function(u) {
                return new Promise(function(i, o) {
                  u = e[r](u), a(i, o, u.done, u.value);
                });
              };
            }
            function a(r, u, i, o) {
              Promise.resolve(o).then(function(c) {
                r({ value: c, done: i });
              }, u);
            }
          }
          function UD(e, n) {
            return Object.defineProperty ? Object.defineProperty(e, "raw", { value: n }) : e.raw = n, e;
          }
          function zD(e) {
            if (e && e.__esModule)
              return e;
            var n = {};
            if (e != null)
              for (var t3 in e)
                Object.hasOwnProperty.call(e, t3) && (n[t3] = e[t3]);
            return n.default = e, n;
          }
          function XD(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function KD(e, n) {
            if (!n.has(e))
              throw new TypeError("attempted to get private field on non-instance");
            return n.get(e);
          }
          function YD(e, n, t3) {
            if (!n.has(e))
              throw new TypeError("attempted to set private field on non-instance");
            return n.set(e, t3), t3;
          }
          var xr, br, ht = mt({ "node_modules/tslib/tslib.es6.js"() {
            re(), xr = function(e, n) {
              return xr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t3, s) {
                t3.__proto__ = s;
              } || function(t3, s) {
                for (var a in s)
                  s.hasOwnProperty(a) && (t3[a] = s[a]);
              }, xr(e, n);
            }, br = function() {
              return br = Object.assign || function(n) {
                for (var t3, s = 1, a = arguments.length; s < a; s++) {
                  t3 = arguments[s];
                  for (var r in t3)
                    Object.prototype.hasOwnProperty.call(t3, r) && (n[r] = t3[r]);
                }
                return n;
              }, br.apply(this, arguments);
            };
          } }), Oa = Z({ "node_modules/vnopts/lib/descriptors/api.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.apiDescriptor = { key: (n) => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(n) ? n : JSON.stringify(n), value(n) {
              if (n === null || typeof n != "object")
                return JSON.stringify(n);
              if (Array.isArray(n))
                return "[".concat(n.map((s) => e.apiDescriptor.value(s)).join(", "), "]");
              let t3 = Object.keys(n);
              return t3.length === 0 ? "{}" : "{ ".concat(t3.map((s) => "".concat(e.apiDescriptor.key(s), ": ").concat(e.apiDescriptor.value(n[s]))).join(", "), " }");
            }, pair: (n) => {
              let { key: t3, value: s } = n;
              return e.apiDescriptor.value({ [t3]: s });
            } };
          } }), QD = Z({ "node_modules/vnopts/lib/descriptors/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (ht(), lt2(dt));
            n.__exportStar(Oa(), e);
          } }), _r = Z({ "scripts/build/shims/chalk.cjs"(e, n) {
            "use strict";
            re();
            var t3 = (s) => s;
            t3.grey = t3, t3.red = t3, t3.bold = t3, t3.yellow = t3, t3.blue = t3, t3.default = t3, n.exports = t3;
          } }), qa = Z({ "node_modules/vnopts/lib/handlers/deprecated/common.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = _r();
            e.commonDeprecatedHandler = (t3, s, a) => {
              let { descriptor: r } = a, u = ["".concat(n.default.yellow(typeof t3 == "string" ? r.key(t3) : r.pair(t3)), " is deprecated")];
              return s && u.push("we now treat it as ".concat(n.default.blue(typeof s == "string" ? r.key(s) : r.pair(s)))), u.join("; ") + ".";
            };
          } }), ZD = Z({ "node_modules/vnopts/lib/handlers/deprecated/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (ht(), lt2(dt));
            n.__exportStar(qa(), e);
          } }), em = Z({ "node_modules/vnopts/lib/handlers/invalid/common.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = _r();
            e.commonInvalidHandler = (t3, s, a) => ["Invalid ".concat(n.default.red(a.descriptor.key(t3)), " value."), "Expected ".concat(n.default.blue(a.schemas[t3].expected(a)), ","), "but received ".concat(n.default.red(a.descriptor.value(s)), ".")].join(" ");
          } }), Ma = Z({ "node_modules/vnopts/lib/handlers/invalid/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (ht(), lt2(dt));
            n.__exportStar(em(), e);
          } }), tm = Z({ "node_modules/vnopts/node_modules/leven/index.js"(e, n) {
            "use strict";
            re();
            var t3 = [], s = [];
            n.exports = function(a, r) {
              if (a === r)
                return 0;
              var u = a;
              a.length > r.length && (a = r, r = u);
              var i = a.length, o = r.length;
              if (i === 0)
                return o;
              if (o === 0)
                return i;
              for (; i > 0 && a.charCodeAt(~-i) === r.charCodeAt(~-o); )
                i--, o--;
              if (i === 0)
                return o;
              for (var c = 0; c < i && a.charCodeAt(c) === r.charCodeAt(c); )
                c++;
              if (i -= c, o -= c, i === 0)
                return o;
              for (var v, m, d, p, f = 0, h = 0; f < i; )
                s[c + f] = a.charCodeAt(c + f), t3[f] = ++f;
              for (; h < o; )
                for (v = r.charCodeAt(c + h), d = h++, m = h, f = 0; f < i; f++)
                  p = v === s[c + f] ? d : d + 1, d = t3[f], m = t3[f] = d > m ? p > m ? m + 1 : p : p > d ? d + 1 : p;
              return m;
            };
          } }), Ra = Z({ "node_modules/vnopts/lib/handlers/unknown/leven.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = _r(), t3 = tm();
            e.levenUnknownHandler = (s, a, r) => {
              let { descriptor: u, logger: i, schemas: o } = r, c = ["Ignored unknown option ".concat(n.default.yellow(u.pair({ key: s, value: a })), ".")], v = Object.keys(o).sort().find((m) => t3(s, m) < 3);
              v && c.push("Did you mean ".concat(n.default.blue(u.key(v)), "?")), i.warn(c.join(" "));
            };
          } }), rm = Z({ "node_modules/vnopts/lib/handlers/unknown/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (ht(), lt2(dt));
            n.__exportStar(Ra(), e);
          } }), nm2 = Z({ "node_modules/vnopts/lib/handlers/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (ht(), lt2(dt));
            n.__exportStar(ZD(), e), n.__exportStar(Ma(), e), n.__exportStar(rm(), e);
          } }), vt = Z({ "node_modules/vnopts/lib/schema.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = ["default", "expected", "validate", "deprecated", "forward", "redirect", "overlap", "preprocess", "postprocess"];
            function t3(r, u) {
              let i = new r(u), o = Object.create(i);
              for (let c of n)
                c in u && (o[c] = a(u[c], i, s.prototype[c].length));
              return o;
            }
            e.createSchema = t3;
            var s = class {
              constructor(r) {
                this.name = r.name;
              }
              static create(r) {
                return t3(this, r);
              }
              default(r) {
              }
              expected(r) {
                return "nothing";
              }
              validate(r, u) {
                return false;
              }
              deprecated(r, u) {
                return false;
              }
              forward(r, u) {
              }
              redirect(r, u) {
              }
              overlap(r, u, i) {
                return r;
              }
              preprocess(r, u) {
                return r;
              }
              postprocess(r, u) {
                return r;
              }
            };
            e.Schema = s;
            function a(r, u, i) {
              return typeof r == "function" ? function() {
                for (var o = arguments.length, c = new Array(o), v = 0; v < o; v++)
                  c[v] = arguments[v];
                return r(...c.slice(0, i - 1), u, ...c.slice(i - 1));
              } : () => r;
            }
          } }), um = Z({ "node_modules/vnopts/lib/schemas/alias.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = vt(), t3 = class extends n.Schema {
              constructor(s) {
                super(s), this._sourceName = s.sourceName;
              }
              expected(s) {
                return s.schemas[this._sourceName].expected(s);
              }
              validate(s, a) {
                return a.schemas[this._sourceName].validate(s, a);
              }
              redirect(s, a) {
                return this._sourceName;
              }
            };
            e.AliasSchema = t3;
          } }), sm = Z({ "node_modules/vnopts/lib/schemas/any.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = vt(), t3 = class extends n.Schema {
              expected() {
                return "anything";
              }
              validate() {
                return true;
              }
            };
            e.AnySchema = t3;
          } }), im = Z({ "node_modules/vnopts/lib/schemas/array.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (ht(), lt2(dt)), t3 = vt(), s = class extends t3.Schema {
              constructor(r) {
                var { valueSchema: u, name: i = u.name } = r, o = n.__rest(r, ["valueSchema", "name"]);
                super(Object.assign({}, o, { name: i })), this._valueSchema = u;
              }
              expected(r) {
                return "an array of ".concat(this._valueSchema.expected(r));
              }
              validate(r, u) {
                if (!Array.isArray(r))
                  return false;
                let i = [];
                for (let o of r) {
                  let c = u.normalizeValidateResult(this._valueSchema.validate(o, u), o);
                  c !== true && i.push(c.value);
                }
                return i.length === 0 ? true : { value: i };
              }
              deprecated(r, u) {
                let i = [];
                for (let o of r) {
                  let c = u.normalizeDeprecatedResult(this._valueSchema.deprecated(o, u), o);
                  c !== false && i.push(...c.map((v) => {
                    let { value: m } = v;
                    return { value: [m] };
                  }));
                }
                return i;
              }
              forward(r, u) {
                let i = [];
                for (let o of r) {
                  let c = u.normalizeForwardResult(this._valueSchema.forward(o, u), o);
                  i.push(...c.map(a));
                }
                return i;
              }
              redirect(r, u) {
                let i = [], o = [];
                for (let c of r) {
                  let v = u.normalizeRedirectResult(this._valueSchema.redirect(c, u), c);
                  "remain" in v && i.push(v.remain), o.push(...v.redirect.map(a));
                }
                return i.length === 0 ? { redirect: o } : { redirect: o, remain: i };
              }
              overlap(r, u) {
                return r.concat(u);
              }
            };
            e.ArraySchema = s;
            function a(r) {
              let { from: u, to: i } = r;
              return { from: [u], to: i };
            }
          } }), am = Z({ "node_modules/vnopts/lib/schemas/boolean.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = vt(), t3 = class extends n.Schema {
              expected() {
                return "true or false";
              }
              validate(s) {
                return typeof s == "boolean";
              }
            };
            e.BooleanSchema = t3;
          } }), Hn = Z({ "node_modules/vnopts/lib/utils.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            function n(p, f) {
              let h = /* @__PURE__ */ Object.create(null);
              for (let w of p) {
                let T = w[f];
                if (h[T])
                  throw new Error("Duplicate ".concat(f, " ").concat(JSON.stringify(T)));
                h[T] = w;
              }
              return h;
            }
            e.recordFromArray = n;
            function t3(p, f) {
              let h = /* @__PURE__ */ new Map();
              for (let w of p) {
                let T = w[f];
                if (h.has(T))
                  throw new Error("Duplicate ".concat(f, " ").concat(JSON.stringify(T)));
                h.set(T, w);
              }
              return h;
            }
            e.mapFromArray = t3;
            function s() {
              let p = /* @__PURE__ */ Object.create(null);
              return (f) => {
                let h = JSON.stringify(f);
                return p[h] ? true : (p[h] = true, false);
              };
            }
            e.createAutoChecklist = s;
            function a(p, f) {
              let h = [], w = [];
              for (let T of p)
                f(T) ? h.push(T) : w.push(T);
              return [h, w];
            }
            e.partition = a;
            function r(p) {
              return p === Math.floor(p);
            }
            e.isInt = r;
            function u(p, f) {
              if (p === f)
                return 0;
              let h = typeof p, w = typeof f, T = ["undefined", "object", "boolean", "number", "string"];
              return h !== w ? T.indexOf(h) - T.indexOf(w) : h !== "string" ? Number(p) - Number(f) : p.localeCompare(f);
            }
            e.comparePrimitive = u;
            function i(p) {
              return p === void 0 ? {} : p;
            }
            e.normalizeDefaultResult = i;
            function o(p, f) {
              return p === true ? true : p === false ? { value: f } : p;
            }
            e.normalizeValidateResult = o;
            function c(p, f) {
              let h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
              return p === false ? false : p === true ? h ? true : [{ value: f }] : "value" in p ? [p] : p.length === 0 ? false : p;
            }
            e.normalizeDeprecatedResult = c;
            function v(p, f) {
              return typeof p == "string" || "key" in p ? { from: f, to: p } : "from" in p ? { from: p.from, to: p.to } : { from: f, to: p.to };
            }
            e.normalizeTransferResult = v;
            function m(p, f) {
              return p === void 0 ? [] : Array.isArray(p) ? p.map((h) => v(h, f)) : [v(p, f)];
            }
            e.normalizeForwardResult = m;
            function d(p, f) {
              let h = m(typeof p == "object" && "redirect" in p ? p.redirect : p, f);
              return h.length === 0 ? { remain: f, redirect: h } : typeof p == "object" && "remain" in p ? { remain: p.remain, redirect: h } : { redirect: h };
            }
            e.normalizeRedirectResult = d;
          } }), om = Z({ "node_modules/vnopts/lib/schemas/choice.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = vt(), t3 = Hn(), s = class extends n.Schema {
              constructor(a) {
                super(a), this._choices = t3.mapFromArray(a.choices.map((r) => r && typeof r == "object" ? r : { value: r }), "value");
              }
              expected(a) {
                let { descriptor: r } = a, u = Array.from(this._choices.keys()).map((c) => this._choices.get(c)).filter((c) => !c.deprecated).map((c) => c.value).sort(t3.comparePrimitive).map(r.value), i = u.slice(0, -2), o = u.slice(-2);
                return i.concat(o.join(" or ")).join(", ");
              }
              validate(a) {
                return this._choices.has(a);
              }
              deprecated(a) {
                let r = this._choices.get(a);
                return r && r.deprecated ? { value: a } : false;
              }
              forward(a) {
                let r = this._choices.get(a);
                return r ? r.forward : void 0;
              }
              redirect(a) {
                let r = this._choices.get(a);
                return r ? r.redirect : void 0;
              }
            };
            e.ChoiceSchema = s;
          } }), Va = Z({ "node_modules/vnopts/lib/schemas/number.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = vt(), t3 = class extends n.Schema {
              expected() {
                return "a number";
              }
              validate(s, a) {
                return typeof s == "number";
              }
            };
            e.NumberSchema = t3;
          } }), lm = Z({ "node_modules/vnopts/lib/schemas/integer.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Hn(), t3 = Va(), s = class extends t3.NumberSchema {
              expected() {
                return "an integer";
              }
              validate(a, r) {
                return r.normalizeValidateResult(super.validate(a, r), a) === true && n.isInt(a);
              }
            };
            e.IntegerSchema = s;
          } }), cm = Z({ "node_modules/vnopts/lib/schemas/string.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = vt(), t3 = class extends n.Schema {
              expected() {
                return "a string";
              }
              validate(s) {
                return typeof s == "string";
              }
            };
            e.StringSchema = t3;
          } }), pm = Z({ "node_modules/vnopts/lib/schemas/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (ht(), lt2(dt));
            n.__exportStar(um(), e), n.__exportStar(sm(), e), n.__exportStar(im(), e), n.__exportStar(am(), e), n.__exportStar(om(), e), n.__exportStar(lm(), e), n.__exportStar(Va(), e), n.__exportStar(cm(), e);
          } }), fm = Z({ "node_modules/vnopts/lib/defaults.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Oa(), t3 = qa(), s = Ma(), a = Ra();
            e.defaultDescriptor = n.apiDescriptor, e.defaultUnknownHandler = a.levenUnknownHandler, e.defaultInvalidHandler = s.commonInvalidHandler, e.defaultDeprecatedHandler = t3.commonDeprecatedHandler;
          } }), Dm = Z({ "node_modules/vnopts/lib/normalize.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = fm(), t3 = Hn();
            e.normalize = (a, r, u) => new s(r, u).normalize(a);
            var s = class {
              constructor(a, r) {
                let { logger: u = console, descriptor: i = n.defaultDescriptor, unknown: o = n.defaultUnknownHandler, invalid: c = n.defaultInvalidHandler, deprecated: v = n.defaultDeprecatedHandler } = r || {};
                this._utils = { descriptor: i, logger: u || { warn: () => {
                } }, schemas: t3.recordFromArray(a, "name"), normalizeDefaultResult: t3.normalizeDefaultResult, normalizeDeprecatedResult: t3.normalizeDeprecatedResult, normalizeForwardResult: t3.normalizeForwardResult, normalizeRedirectResult: t3.normalizeRedirectResult, normalizeValidateResult: t3.normalizeValidateResult }, this._unknownHandler = o, this._invalidHandler = c, this._deprecatedHandler = v, this.cleanHistory();
              }
              cleanHistory() {
                this._hasDeprecationWarned = t3.createAutoChecklist();
              }
              normalize(a) {
                let r = {}, u = [a], i = () => {
                  for (; u.length !== 0; ) {
                    let o = u.shift(), c = this._applyNormalization(o, r);
                    u.push(...c);
                  }
                };
                i();
                for (let o of Object.keys(this._utils.schemas)) {
                  let c = this._utils.schemas[o];
                  if (!(o in r)) {
                    let v = t3.normalizeDefaultResult(c.default(this._utils));
                    "value" in v && u.push({ [o]: v.value });
                  }
                }
                i();
                for (let o of Object.keys(this._utils.schemas)) {
                  let c = this._utils.schemas[o];
                  o in r && (r[o] = c.postprocess(r[o], this._utils));
                }
                return r;
              }
              _applyNormalization(a, r) {
                let u = [], [i, o] = t3.partition(Object.keys(a), (c) => c in this._utils.schemas);
                for (let c of i) {
                  let v = this._utils.schemas[c], m = v.preprocess(a[c], this._utils), d = t3.normalizeValidateResult(v.validate(m, this._utils), m);
                  if (d !== true) {
                    let { value: T } = d, A = this._invalidHandler(c, T, this._utils);
                    throw typeof A == "string" ? new Error(A) : A;
                  }
                  let p = (T) => {
                    let { from: A, to: S } = T;
                    u.push(typeof S == "string" ? { [S]: A } : { [S.key]: S.value });
                  }, f = (T) => {
                    let { value: A, redirectTo: S } = T, B = t3.normalizeDeprecatedResult(v.deprecated(A, this._utils), m, true);
                    if (B !== false)
                      if (B === true)
                        this._hasDeprecationWarned(c) || this._utils.logger.warn(this._deprecatedHandler(c, S, this._utils));
                      else
                        for (let { value: I } of B) {
                          let k = { key: c, value: I };
                          if (!this._hasDeprecationWarned(k)) {
                            let P = typeof S == "string" ? { key: S, value: I } : S;
                            this._utils.logger.warn(this._deprecatedHandler(k, P, this._utils));
                          }
                        }
                  };
                  t3.normalizeForwardResult(v.forward(m, this._utils), m).forEach(p);
                  let w = t3.normalizeRedirectResult(v.redirect(m, this._utils), m);
                  if (w.redirect.forEach(p), "remain" in w) {
                    let T = w.remain;
                    r[c] = c in r ? v.overlap(r[c], T, this._utils) : T, f({ value: T });
                  }
                  for (let { from: T, to: A } of w.redirect)
                    f({ value: T, redirectTo: A });
                }
                for (let c of o) {
                  let v = a[c], m = this._unknownHandler(c, v, this._utils);
                  if (m)
                    for (let d of Object.keys(m)) {
                      let p = { [d]: m[d] };
                      d in this._utils.schemas ? u.push(p) : Object.assign(r, p);
                    }
                }
                return u;
              }
            };
            e.Normalizer = s;
          } }), mm = Z({ "node_modules/vnopts/lib/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = (ht(), lt2(dt));
            n.__exportStar(QD(), e), n.__exportStar(nm2(), e), n.__exportStar(pm(), e), n.__exportStar(Dm(), e), n.__exportStar(vt(), e);
          } }), dm = Z({ "src/main/options-normalizer.js"(e, n) {
            "use strict";
            re();
            var t3 = mm(), s = it(), a = { key: (d) => d.length === 1 ? "-".concat(d) : "--".concat(d), value: (d) => t3.apiDescriptor.value(d), pair: (d) => {
              let { key: p, value: f } = d;
              return f === false ? "--no-".concat(p) : f === true ? a.key(p) : f === "" ? "".concat(a.key(p), " without an argument") : "".concat(a.key(p), "=").concat(f);
            } }, r = (d) => {
              let { colorsModule: p, levenshteinDistance: f } = d;
              return class extends t3.ChoiceSchema {
                constructor(w) {
                  let { name: T, flags: A } = w;
                  super({ name: T, choices: A }), this._flags = [...A].sort();
                }
                preprocess(w, T) {
                  if (typeof w == "string" && w.length > 0 && !this._flags.includes(w)) {
                    let A = this._flags.find((S) => f(S, w) < 3);
                    if (A)
                      return T.logger.warn(["Unknown flag ".concat(p.yellow(T.descriptor.value(w)), ","), "did you mean ".concat(p.blue(T.descriptor.value(A)), "?")].join(" ")), A;
                  }
                  return w;
                }
                expected() {
                  return "a flag";
                }
              };
            }, u;
            function i(d, p) {
              let { logger: f = false, isCLI: h = false, passThrough: w = false, colorsModule: T = null, levenshteinDistance: A = null } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, S = w ? Array.isArray(w) ? (D, g) => w.includes(D) ? { [D]: g } : void 0 : (D, g) => ({ [D]: g }) : (D, g, F) => {
                let l = F.schemas, { _: E } = l, y = kn(l, Qf);
                return t3.levenUnknownHandler(D, g, Object.assign(Object.assign({}, F), {}, { schemas: y }));
              }, B = h ? a : t3.apiDescriptor, I = o(p, { isCLI: h, colorsModule: T, levenshteinDistance: A }), k = new t3.Normalizer(I, { logger: f, unknown: S, descriptor: B }), P = f !== false;
              P && u && (k._hasDeprecationWarned = u);
              let C = k.normalize(d);
              return P && (u = k._hasDeprecationWarned), h && C["plugin-search"] === false && (C["plugin-search-dir"] = false), C;
            }
            function o(d, p) {
              let { isCLI: f, colorsModule: h, levenshteinDistance: w } = p, T = [];
              f && T.push(t3.AnySchema.create({ name: "_" }));
              for (let A of d)
                T.push(c(A, { isCLI: f, optionInfos: d, colorsModule: h, levenshteinDistance: w })), A.alias && f && T.push(t3.AliasSchema.create({ name: A.alias, sourceName: A.name }));
              return T;
            }
            function c(d, p) {
              let { isCLI: f, optionInfos: h, colorsModule: w, levenshteinDistance: T } = p, { name: A } = d;
              if (A === "plugin-search-dir" || A === "pluginSearchDirs")
                return t3.AnySchema.create({ name: A, preprocess(k) {
                  return k === false || (k = Array.isArray(k) ? k : [k]), k;
                }, validate(k) {
                  return k === false ? true : k.every((P) => typeof P == "string");
                }, expected() {
                  return "false or paths to plugin search dir";
                } });
              let S = { name: A }, B, I = {};
              switch (d.type) {
                case "int":
                  B = t3.IntegerSchema, f && (S.preprocess = Number);
                  break;
                case "string":
                  B = t3.StringSchema;
                  break;
                case "choice":
                  B = t3.ChoiceSchema, S.choices = d.choices.map((k) => typeof k == "object" && k.redirect ? Object.assign(Object.assign({}, k), {}, { redirect: { to: { key: d.name, value: k.redirect } } }) : k);
                  break;
                case "boolean":
                  B = t3.BooleanSchema;
                  break;
                case "flag":
                  B = r({ colorsModule: w, levenshteinDistance: T }), S.flags = h.flatMap((k) => [k.alias, k.description && k.name, k.oppositeDescription && "no-".concat(k.name)].filter(Boolean));
                  break;
                case "path":
                  B = t3.StringSchema;
                  break;
                default:
                  throw new Error("Unexpected type ".concat(d.type));
              }
              if (d.exception ? S.validate = (k, P, C) => d.exception(k) || P.validate(k, C) : S.validate = (k, P, C) => k === void 0 || P.validate(k, C), d.redirect && (I.redirect = (k) => k ? { to: { key: d.redirect.option, value: d.redirect.value } } : void 0), d.deprecated && (I.deprecated = true), f && !d.array) {
                let k = S.preprocess || ((P) => P);
                S.preprocess = (P, C, D) => C.preprocess(k(Array.isArray(P) ? s(P) : P), D);
              }
              return d.array ? t3.ArraySchema.create(Object.assign(Object.assign(Object.assign({}, f ? { preprocess: (k) => Array.isArray(k) ? k : [k] } : {}), I), {}, { valueSchema: B.create(S) })) : B.create(Object.assign(Object.assign({}, S), I));
            }
            function v(d, p, f) {
              return i(d, p, f);
            }
            function m(d, p, f) {
              return i(d, p, Object.assign({ isCLI: true }, f));
            }
            n.exports = { normalizeApiOptions: v, normalizeCliOptions: m };
          } }), st = Z({ "src/language-js/loc.js"(e, n) {
            "use strict";
            re();
            var t3 = Rn();
            function s(o, c) {
              let { ignoreDecorators: v } = c || {};
              if (!v) {
                let m = o.declaration && o.declaration.decorators || o.decorators;
                if (t3(m))
                  return s(m[0]);
              }
              return o.range ? o.range[0] : o.start;
            }
            function a(o) {
              return o.range ? o.range[1] : o.end;
            }
            function r(o, c) {
              let v = s(o);
              return Number.isInteger(v) && v === s(c);
            }
            function u(o, c) {
              let v = a(o);
              return Number.isInteger(v) && v === a(c);
            }
            function i(o, c) {
              return r(o, c) && u(o, c);
            }
            n.exports = { locStart: s, locEnd: a, hasSameLocStart: r, hasSameLoc: i };
          } }), gm = Z({ "src/main/load-parser.js"(e, n) {
            re(), n.exports = () => {
            };
          } }), ym = Z({ "scripts/build/shims/babel-highlight.cjs"(e, n) {
            "use strict";
            re();
            var t3 = _r(), s = { shouldHighlight: () => false, getChalk: () => t3 };
            n.exports = s;
          } }), hm = Z({ "node_modules/@babel/code-frame/lib/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.codeFrameColumns = u, e.default = i;
            var n = ym(), t3 = false;
            function s(o) {
              return { gutter: o.grey, marker: o.red.bold, message: o.red.bold };
            }
            var a = /\r\n|[\n\r\u2028\u2029]/;
            function r(o, c, v) {
              let m = Object.assign({ column: 0, line: -1 }, o.start), d = Object.assign({}, m, o.end), { linesAbove: p = 2, linesBelow: f = 3 } = v || {}, h = m.line, w = m.column, T = d.line, A = d.column, S = Math.max(h - (p + 1), 0), B = Math.min(c.length, T + f);
              h === -1 && (S = 0), T === -1 && (B = c.length);
              let I = T - h, k = {};
              if (I)
                for (let P = 0; P <= I; P++) {
                  let C = P + h;
                  if (!w)
                    k[C] = true;
                  else if (P === 0) {
                    let D = c[C - 1].length;
                    k[C] = [w, D - w + 1];
                  } else if (P === I)
                    k[C] = [0, A];
                  else {
                    let D = c[C - P].length;
                    k[C] = [0, D];
                  }
                }
              else
                w === A ? w ? k[h] = [w, 0] : k[h] = true : k[h] = [w, A - w];
              return { start: S, end: B, markerLines: k };
            }
            function u(o, c) {
              let v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, m = (v.highlightCode || v.forceColor) && (0, n.shouldHighlight)(v), d = (0, n.getChalk)(v), p = s(d), f = (P, C) => m ? P(C) : C, h = o.split(a), { start: w, end: T, markerLines: A } = r(c, h, v), S = c.start && typeof c.start.column == "number", B = String(T).length, k = (m ? (0, n.default)(o, v) : o).split(a, T).slice(w, T).map((P, C) => {
                let D = w + 1 + C, g = " ".concat(D).slice(-B), F = " ".concat(g, " |"), l = A[D], E = !A[D + 1];
                if (l) {
                  let y = "";
                  if (Array.isArray(l)) {
                    let N = P.slice(0, Math.max(l[0] - 1, 0)).replace(/[^\t]/g, " "), x = l[1] || 1;
                    y = [`
 `, f(p.gutter, F.replace(/\d/g, " ")), " ", N, f(p.marker, "^").repeat(x)].join(""), E && v.message && (y += " " + f(p.message, v.message));
                  }
                  return [f(p.marker, ">"), f(p.gutter, F), P.length > 0 ? " ".concat(P) : "", y].join("");
                } else
                  return " ".concat(f(p.gutter, F)).concat(P.length > 0 ? " ".concat(P) : "");
              }).join(`
`);
              return v.message && !S && (k = "".concat(" ".repeat(B + 1)).concat(v.message, `
`).concat(k)), m ? d.reset(k) : k;
            }
            function i(o, c, v) {
              let m = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
              if (!t3) {
                t3 = true;
                let p = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
                if (Tt.emitWarning)
                  Tt.emitWarning(p, "DeprecationWarning");
                else {
                  let f = new Error(p);
                  f.name = "DeprecationWarning", console.warn(new Error(p));
                }
              }
              return v = Math.max(v, 0), u(o, { start: { column: v, line: c } }, m);
            }
          } }), Gn = Z({ "src/main/parser.js"(e, n) {
            "use strict";
            re();
            var { ConfigError: t3 } = zt(), s = st(), a = gm(), { locStart: r, locEnd: u } = s, i = Object.getOwnPropertyNames, o = Object.getOwnPropertyDescriptor;
            function c(d) {
              let p = {};
              for (let f of d.plugins)
                if (!!f.parsers)
                  for (let h of i(f.parsers))
                    Object.defineProperty(p, h, o(f.parsers, h));
              return p;
            }
            function v(d) {
              let p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c(d);
              if (typeof d.parser == "function")
                return { parse: d.parser, astFormat: "estree", locStart: r, locEnd: u };
              if (typeof d.parser == "string") {
                if (Object.prototype.hasOwnProperty.call(p, d.parser))
                  return p[d.parser];
                throw new t3(`Couldn't resolve parser "`.concat(d.parser, '". Parsers must be explicitly added to the standalone bundle.'));
              }
            }
            function m(d, p) {
              let f = c(p), h = Object.defineProperties({}, Object.fromEntries(Object.keys(f).map((T) => [T, { enumerable: true, get() {
                return f[T].parse;
              } }]))), w = v(p, f);
              try {
                return w.preprocess && (d = w.preprocess(d, p)), { text: d, ast: w.parse(d, h, p) };
              } catch (T) {
                let { loc: A } = T;
                if (A) {
                  let { codeFrameColumns: S } = hm();
                  throw T.codeFrame = S(d, A, { highlightCode: true }), T.message += `
` + T.codeFrame, T;
                }
                throw T.stack;
              }
            }
            n.exports = { parse: m, resolveParser: v };
          } }), Wa = Z({ "src/main/options.js"(e, n) {
            "use strict";
            re();
            var t3 = PD(), { UndefinedParserError: s } = zt(), { getSupportInfo: a } = Mn(), r = dm(), { resolveParser: u } = Gn(), i = { astFormat: "estree", printer: {}, originalText: void 0, locStart: null, locEnd: null };
            function o(m) {
              let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = Object.assign({}, m), f = a({ plugins: m.plugins, showUnreleased: true, showDeprecated: true }).options, h = Object.assign(Object.assign({}, i), Object.fromEntries(f.filter((B) => B.default !== void 0).map((B) => [B.name, B.default])));
              if (!p.parser) {
                if (!p.filepath)
                  (d.logger || console).warn("No parser and no filepath given, using 'babel' the parser now but this will throw an error in the future. Please specify a parser or a filepath so one can be inferred."), p.parser = "babel";
                else if (p.parser = v(p.filepath, p.plugins), !p.parser)
                  throw new s("No parser could be inferred for file: ".concat(p.filepath));
              }
              let w = u(r.normalizeApiOptions(p, [f.find((B) => B.name === "parser")], { passThrough: true, logger: false }));
              p.astFormat = w.astFormat, p.locEnd = w.locEnd, p.locStart = w.locStart;
              let T = c(p);
              p.printer = T.printers[p.astFormat];
              let A = Object.fromEntries(f.filter((B) => B.pluginDefaults && B.pluginDefaults[T.name] !== void 0).map((B) => [B.name, B.pluginDefaults[T.name]])), S = Object.assign(Object.assign({}, h), A);
              for (let [B, I] of Object.entries(S))
                (p[B] === null || p[B] === void 0) && (p[B] = I);
              return p.parser === "json" && (p.trailingComma = "none"), r.normalizeApiOptions(p, f, Object.assign({ passThrough: Object.keys(i) }, d));
            }
            function c(m) {
              let { astFormat: d } = m;
              if (!d)
                throw new Error("getPlugin() requires astFormat to be set");
              let p = m.plugins.find((f) => f.printers && f.printers[d]);
              if (!p)
                throw new Error(`Couldn't find plugin for AST format "`.concat(d, '"'));
              return p;
            }
            function v(m, d) {
              let p = t3.basename(m).toLowerCase(), h = a({ plugins: d }).languages.filter((w) => w.since !== null).find((w) => w.extensions && w.extensions.some((T) => p.endsWith(T)) || w.filenames && w.filenames.some((T) => T.toLowerCase() === p));
              return h && h.parsers[0];
            }
            n.exports = { normalize: o, hiddenDefaults: i, inferParser: v };
          } }), vm = Z({ "src/main/massage-ast.js"(e, n) {
            "use strict";
            re();
            function t3(s, a, r) {
              if (Array.isArray(s))
                return s.map((c) => t3(c, a, r)).filter(Boolean);
              if (!s || typeof s != "object")
                return s;
              let u = a.printer.massageAstNode, i;
              u && u.ignoredProperties ? i = u.ignoredProperties : i = /* @__PURE__ */ new Set();
              let o = {};
              for (let [c, v] of Object.entries(s))
                !i.has(c) && typeof v != "function" && (o[c] = t3(v, a, s));
              if (u) {
                let c = u(s, o, r);
                if (c === null)
                  return;
                if (c)
                  return c;
              }
              return o;
            }
            n.exports = t3;
          } }), Xt = Z({ "scripts/build/shims/assert.cjs"(e, n) {
            "use strict";
            re();
            var t3 = () => {
            };
            t3.ok = t3, t3.strictEqual = t3, n.exports = t3;
          } }), et = Z({ "src/main/comments.js"(e, n) {
            "use strict";
            re();
            var t3 = Xt(), { builders: { line: s, hardline: a, breakParent: r, indent: u, lineSuffix: i, join: o, cursor: c } } = Oe(), { hasNewline: v, skipNewline: m, skipSpaces: d, isPreviousLineEmpty: p, addLeadingComment: f, addDanglingComment: h, addTrailingComment: w } = Ue(), T = /* @__PURE__ */ new WeakMap();
            function A(L, M, j) {
              if (!L)
                return;
              let { printer: $, locStart: V, locEnd: q } = M;
              if (j) {
                if ($.canAttachComment && $.canAttachComment(L)) {
                  let H;
                  for (H = j.length - 1; H >= 0 && !(V(j[H]) <= V(L) && q(j[H]) <= q(L)); --H)
                    ;
                  j.splice(H + 1, 0, L);
                  return;
                }
              } else if (T.has(L))
                return T.get(L);
              let Y = $.getCommentChildNodes && $.getCommentChildNodes(L, M) || typeof L == "object" && Object.entries(L).filter((H) => {
                let [R] = H;
                return R !== "enclosingNode" && R !== "precedingNode" && R !== "followingNode" && R !== "tokens" && R !== "comments" && R !== "parent";
              }).map((H) => {
                let [, R] = H;
                return R;
              });
              if (!!Y) {
                j || (j = [], T.set(L, j));
                for (let H of Y)
                  A(H, M, j);
                return j;
              }
            }
            function S(L, M, j, $) {
              let { locStart: V, locEnd: q } = j, Y = V(M), H = q(M), R = A(L, j), Q, ee, te = 0, oe = R.length;
              for (; te < oe; ) {
                let W = te + oe >> 1, X = R[W], ue = V(X), De = q(X);
                if (ue <= Y && H <= De)
                  return S(X, M, j, X);
                if (De <= Y) {
                  Q = X, te = W + 1;
                  continue;
                }
                if (H <= ue) {
                  ee = X, oe = W;
                  continue;
                }
                throw new Error("Comment location overlaps with node location");
              }
              if ($ && $.type === "TemplateLiteral") {
                let { quasis: W } = $, X = F(W, M, j);
                Q && F(W, Q, j) !== X && (Q = null), ee && F(W, ee, j) !== X && (ee = null);
              }
              return { enclosingNode: $, precedingNode: Q, followingNode: ee };
            }
            var B = () => false;
            function I(L, M, j, $) {
              if (!Array.isArray(L))
                return;
              let V = [], { locStart: q, locEnd: Y, printer: { handleComments: H = {} } } = $, { avoidAstMutation: R, ownLine: Q = B, endOfLine: ee = B, remaining: te = B } = H, oe = L.map((W, X) => Object.assign(Object.assign({}, S(M, W, $)), {}, { comment: W, text: j, options: $, ast: M, isLastComment: L.length - 1 === X }));
              for (let [W, X] of oe.entries()) {
                let { comment: ue, precedingNode: De, enclosingNode: ie, followingNode: G, text: z, options: U, ast: le, isLastComment: ge } = X;
                if (U.parser === "json" || U.parser === "json5" || U.parser === "__js_expression" || U.parser === "__vue_expression" || U.parser === "__vue_ts_expression") {
                  if (q(ue) - q(le) <= 0) {
                    f(le, ue);
                    continue;
                  }
                  if (Y(ue) - Y(le) >= 0) {
                    w(le, ue);
                    continue;
                  }
                }
                let Ae;
                if (R ? Ae = [X] : (ue.enclosingNode = ie, ue.precedingNode = De, ue.followingNode = G, Ae = [ue, z, U, le, ge]), P(z, U, oe, W))
                  ue.placement = "ownLine", Q(...Ae) || (G ? f(G, ue) : De ? w(De, ue) : h(ie || le, ue));
                else if (C(z, U, oe, W))
                  ue.placement = "endOfLine", ee(...Ae) || (De ? w(De, ue) : G ? f(G, ue) : h(ie || le, ue));
                else if (ue.placement = "remaining", !te(...Ae))
                  if (De && G) {
                    let Ne = V.length;
                    Ne > 0 && V[Ne - 1].followingNode !== G && D(V, z, U), V.push(X);
                  } else
                    De ? w(De, ue) : G ? f(G, ue) : h(ie || le, ue);
              }
              if (D(V, j, $), !R)
                for (let W of L)
                  delete W.precedingNode, delete W.enclosingNode, delete W.followingNode;
            }
            var k = (L) => !/[\S\n\u2028\u2029]/.test(L);
            function P(L, M, j, $) {
              let { comment: V, precedingNode: q } = j[$], { locStart: Y, locEnd: H } = M, R = Y(V);
              if (q)
                for (let Q = $ - 1; Q >= 0; Q--) {
                  let { comment: ee, precedingNode: te } = j[Q];
                  if (te !== q || !k(L.slice(H(ee), R)))
                    break;
                  R = Y(ee);
                }
              return v(L, R, { backwards: true });
            }
            function C(L, M, j, $) {
              let { comment: V, followingNode: q } = j[$], { locStart: Y, locEnd: H } = M, R = H(V);
              if (q)
                for (let Q = $ + 1; Q < j.length; Q++) {
                  let { comment: ee, followingNode: te } = j[Q];
                  if (te !== q || !k(L.slice(R, Y(ee))))
                    break;
                  R = H(ee);
                }
              return v(L, R);
            }
            function D(L, M, j) {
              let $ = L.length;
              if ($ === 0)
                return;
              let { precedingNode: V, followingNode: q, enclosingNode: Y } = L[0], H = j.printer.getGapRegex && j.printer.getGapRegex(Y) || /^[\s(]*$/, R = j.locStart(q), Q;
              for (Q = $; Q > 0; --Q) {
                let { comment: ee, precedingNode: te, followingNode: oe } = L[Q - 1];
                t3.strictEqual(te, V), t3.strictEqual(oe, q);
                let W = M.slice(j.locEnd(ee), R);
                if (H.test(W))
                  R = j.locStart(ee);
                else
                  break;
              }
              for (let [ee, { comment: te }] of L.entries())
                ee < Q ? w(V, te) : f(q, te);
              for (let ee of [V, q])
                ee.comments && ee.comments.length > 1 && ee.comments.sort((te, oe) => j.locStart(te) - j.locStart(oe));
              L.length = 0;
            }
            function g(L, M) {
              let j = L.getValue();
              return j.printed = true, M.printer.printComment(L, M);
            }
            function F(L, M, j) {
              let $ = j.locStart(M) - 1;
              for (let V = 1; V < L.length; ++V)
                if ($ < j.locStart(L[V]))
                  return V - 1;
              return 0;
            }
            function l(L, M) {
              let j = L.getValue(), $ = [g(L, M)], { printer: V, originalText: q, locStart: Y, locEnd: H } = M;
              if (V.isBlockComment && V.isBlockComment(j)) {
                let ee = v(q, H(j)) ? v(q, Y(j), { backwards: true }) ? a : s : " ";
                $.push(ee);
              } else
                $.push(a);
              let Q = m(q, d(q, H(j)));
              return Q !== false && v(q, Q) && $.push(a), $;
            }
            function E(L, M) {
              let j = L.getValue(), $ = g(L, M), { printer: V, originalText: q, locStart: Y } = M, H = V.isBlockComment && V.isBlockComment(j);
              if (v(q, Y(j), { backwards: true })) {
                let Q = p(q, j, Y);
                return i([a, Q ? a : "", $]);
              }
              let R = [" ", $];
              return H || (R = [i(R), r]), R;
            }
            function y(L, M, j, $) {
              let V = [], q = L.getValue();
              return !q || !q.comments || (L.each(() => {
                let Y = L.getValue();
                !Y.leading && !Y.trailing && (!$ || $(Y)) && V.push(g(L, M));
              }, "comments"), V.length === 0) ? "" : j ? o(a, V) : u([a, o(a, V)]);
            }
            function N(L, M, j) {
              let $ = L.getValue();
              if (!$)
                return {};
              let V = $.comments || [];
              j && (V = V.filter((R) => !j.has(R)));
              let q = $ === M.cursorNode;
              if (V.length === 0) {
                let R = q ? c : "";
                return { leading: R, trailing: R };
              }
              let Y = [], H = [];
              return L.each(() => {
                let R = L.getValue();
                if (j && j.has(R))
                  return;
                let { leading: Q, trailing: ee } = R;
                Q ? Y.push(l(L, M)) : ee && H.push(E(L, M));
              }, "comments"), q && (Y.unshift(c), H.push(c)), { leading: Y, trailing: H };
            }
            function x(L, M, j, $) {
              let { leading: V, trailing: q } = N(L, j, $);
              return !V && !q ? M : [V, M, q];
            }
            function b(L) {
              if (!!L)
                for (let M of L) {
                  if (!M.printed)
                    throw new Error('Comment "' + M.value.trim() + '" was not printed. Please report this error!');
                  delete M.printed;
                }
            }
            n.exports = { attach: I, printComments: x, printCommentsSeparately: N, printDanglingComments: y, getSortedChildNodes: A, ensureAllCommentsPrinted: b };
          } }), Cm = Z({ "src/common/ast-path.js"(e, n) {
            "use strict";
            re();
            var t3 = it();
            function s(u, i) {
              let o = a(u.stack, i);
              return o === -1 ? null : u.stack[o];
            }
            function a(u, i) {
              for (let o = u.length - 1; o >= 0; o -= 2) {
                let c = u[o];
                if (c && !Array.isArray(c) && --i < 0)
                  return o;
              }
              return -1;
            }
            var r = class {
              constructor(u) {
                this.stack = [u];
              }
              getName() {
                let { stack: u } = this, { length: i } = u;
                return i > 1 ? u[i - 2] : null;
              }
              getValue() {
                return t3(this.stack);
              }
              getNode() {
                let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return s(this, u);
              }
              getParentNode() {
                let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return s(this, u + 1);
              }
              call(u) {
                let { stack: i } = this, { length: o } = i, c = t3(i);
                for (var v = arguments.length, m = new Array(v > 1 ? v - 1 : 0), d = 1; d < v; d++)
                  m[d - 1] = arguments[d];
                for (let f of m)
                  c = c[f], i.push(f, c);
                let p = u(this);
                return i.length = o, p;
              }
              callParent(u) {
                let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = a(this.stack, i + 1), c = this.stack.splice(o + 1), v = u(this);
                return this.stack.push(...c), v;
              }
              each(u) {
                let { stack: i } = this, { length: o } = i, c = t3(i);
                for (var v = arguments.length, m = new Array(v > 1 ? v - 1 : 0), d = 1; d < v; d++)
                  m[d - 1] = arguments[d];
                for (let p of m)
                  c = c[p], i.push(p, c);
                for (let p = 0; p < c.length; ++p)
                  i.push(p, c[p]), u(this, p, c), i.length -= 2;
                i.length = o;
              }
              map(u) {
                let i = [];
                for (var o = arguments.length, c = new Array(o > 1 ? o - 1 : 0), v = 1; v < o; v++)
                  c[v - 1] = arguments[v];
                return this.each((m, d, p) => {
                  i[d] = u(m, d, p);
                }, ...c), i;
              }
              try(u) {
                let { stack: i } = this, o = [...i];
                try {
                  return u();
                } finally {
                  i.length = 0, i.push(...o);
                }
              }
              match() {
                let u = this.stack.length - 1, i = null, o = this.stack[u--];
                for (var c = arguments.length, v = new Array(c), m = 0; m < c; m++)
                  v[m] = arguments[m];
                for (let d of v) {
                  if (o === void 0)
                    return false;
                  let p = null;
                  if (typeof i == "number" && (p = i, i = this.stack[u--], o = this.stack[u--]), d && !d(o, i, p))
                    return false;
                  i = this.stack[u--], o = this.stack[u--];
                }
                return true;
              }
              findAncestor(u) {
                let i = this.stack.length - 1, o = null, c = this.stack[i--];
                for (; c; ) {
                  let v = null;
                  if (typeof o == "number" && (v = o, o = this.stack[i--], c = this.stack[i--]), o !== null && u(c, o, v))
                    return c;
                  o = this.stack[i--], c = this.stack[i--];
                }
              }
            };
            n.exports = r;
          } }), Em = Z({ "src/main/multiparser.js"(e, n) {
            "use strict";
            re();
            var { utils: { stripTrailingHardline: t3 } } = Oe(), { normalize: s } = Wa(), a = et();
            function r(i, o, c, v) {
              if (c.printer.embed && c.embeddedLanguageFormatting === "auto")
                return c.printer.embed(i, o, (m, d, p) => u(m, d, c, v, p), c);
            }
            function u(i, o, c, v) {
              let { stripTrailingHardline: m = false } = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, d = s(Object.assign(Object.assign(Object.assign({}, c), o), {}, { parentParser: c.parser, originalText: i }), { passThrough: true }), p = Gn().parse(i, d), { ast: f } = p;
              i = p.text;
              let h = f.comments;
              delete f.comments, a.attach(h, f, i, d), d[Symbol.for("comments")] = h || [], d[Symbol.for("tokens")] = f.tokens || [];
              let w = v(f, d);
              return a.ensureAllCommentsPrinted(h), m ? typeof w == "string" ? w.replace(/(?:\r?\n)*$/, "") : t3(w) : w;
            }
            n.exports = { printSubtree: r };
          } }), Fm = Z({ "src/main/ast-to-doc.js"(e, n) {
            "use strict";
            re();
            var t3 = Cm(), { builders: { hardline: s, addAlignmentToDoc: a }, utils: { propagateBreaks: r } } = Oe(), { printComments: u } = et(), i = Em();
            function o(m, d) {
              let p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, { printer: f } = d;
              f.preprocess && (m = f.preprocess(m, d));
              let h = /* @__PURE__ */ new Map(), w = new t3(m), T = A();
              return p > 0 && (T = a([s, T], p, d.tabWidth)), r(T), T;
              function A(B, I) {
                return B === void 0 || B === w ? S(I) : Array.isArray(B) ? w.call(() => S(I), ...B) : w.call(() => S(I), B);
              }
              function S(B) {
                let I = w.getValue(), k = I && typeof I == "object" && B === void 0;
                if (k && h.has(I))
                  return h.get(I);
                let P = v(w, d, A, B);
                return k && h.set(I, P), P;
              }
            }
            function c(m, d) {
              let { originalText: p, [Symbol.for("comments")]: f, locStart: h, locEnd: w } = d, T = h(m), A = w(m), S = /* @__PURE__ */ new Set();
              for (let B of f)
                h(B) >= T && w(B) <= A && (B.printed = true, S.add(B));
              return { doc: p.slice(T, A), printedComments: S };
            }
            function v(m, d, p, f) {
              let h = m.getValue(), { printer: w } = d, T, A;
              if (w.hasPrettierIgnore && w.hasPrettierIgnore(m))
                ({ doc: T, printedComments: A } = c(h, d));
              else {
                if (h)
                  try {
                    T = i.printSubtree(m, p, d, o);
                  } catch (S) {
                    if (globalThis.PRETTIER_DEBUG)
                      throw S;
                  }
                T || (T = w.print(m, d, p, f));
              }
              return (!w.willPrintOwnComments || !w.willPrintOwnComments(m, d)) && (T = u(m, T, d, A)), T;
            }
            n.exports = o;
          } }), Am = Z({ "src/main/range-util.js"(e, n) {
            "use strict";
            re();
            var t3 = Xt(), s = et(), a = (f) => {
              let { parser: h } = f;
              return h === "json" || h === "json5" || h === "json-stringify";
            };
            function r(f, h) {
              let w = [f.node, ...f.parentNodes], T = /* @__PURE__ */ new Set([h.node, ...h.parentNodes]);
              return w.find((A) => v.has(A.type) && T.has(A));
            }
            function u(f) {
              let h = f.length - 1;
              for (; ; ) {
                let w = f[h];
                if (w && (w.type === "Program" || w.type === "File"))
                  h--;
                else
                  break;
              }
              return f.slice(0, h + 1);
            }
            function i(f, h, w) {
              let { locStart: T, locEnd: A } = w, S = f.node, B = h.node;
              if (S === B)
                return { startNode: S, endNode: B };
              let I = T(f.node);
              for (let P of u(h.parentNodes))
                if (T(P) >= I)
                  B = P;
                else
                  break;
              let k = A(h.node);
              for (let P of u(f.parentNodes))
                if (A(P) <= k)
                  S = P;
                else
                  break;
              return { startNode: S, endNode: B };
            }
            function o(f, h, w, T) {
              let A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], S = arguments.length > 5 ? arguments[5] : void 0, { locStart: B, locEnd: I } = w, k = B(f), P = I(f);
              if (!(h > P || h < k || S === "rangeEnd" && h === k || S === "rangeStart" && h === P)) {
                for (let C of s.getSortedChildNodes(f, w)) {
                  let D = o(C, h, w, T, [f, ...A], S);
                  if (D)
                    return D;
                }
                if (!T || T(f, A[0]))
                  return { node: f, parentNodes: A };
              }
            }
            function c(f, h) {
              return h !== "DeclareExportDeclaration" && f !== "TypeParameterDeclaration" && (f === "Directive" || f === "TypeAlias" || f === "TSExportAssignment" || f.startsWith("Declare") || f.startsWith("TSDeclare") || f.endsWith("Statement") || f.endsWith("Declaration"));
            }
            var v = /* @__PURE__ */ new Set(["ObjectExpression", "ArrayExpression", "StringLiteral", "NumericLiteral", "BooleanLiteral", "NullLiteral", "UnaryExpression", "TemplateLiteral"]), m = /* @__PURE__ */ new Set(["OperationDefinition", "FragmentDefinition", "VariableDefinition", "TypeExtensionDefinition", "ObjectTypeDefinition", "FieldDefinition", "DirectiveDefinition", "EnumTypeDefinition", "EnumValueDefinition", "InputValueDefinition", "InputObjectTypeDefinition", "SchemaDefinition", "OperationTypeDefinition", "InterfaceTypeDefinition", "UnionTypeDefinition", "ScalarTypeDefinition"]);
            function d(f, h, w) {
              if (!h)
                return false;
              switch (f.parser) {
                case "flow":
                case "babel":
                case "babel-flow":
                case "babel-ts":
                case "typescript":
                case "acorn":
                case "espree":
                case "meriyah":
                case "__babel_estree":
                  return c(h.type, w && w.type);
                case "json":
                case "json5":
                case "json-stringify":
                  return v.has(h.type);
                case "graphql":
                  return m.has(h.kind);
                case "vue":
                  return h.tag !== "root";
              }
              return false;
            }
            function p(f, h, w) {
              let { rangeStart: T, rangeEnd: A, locStart: S, locEnd: B } = h;
              t3.ok(A > T);
              let I = f.slice(T, A).search(/\S/), k = I === -1;
              if (!k)
                for (T += I; A > T && !/\S/.test(f[A - 1]); --A)
                  ;
              let P = o(w, T, h, (F, l) => d(h, F, l), [], "rangeStart"), C = k ? P : o(w, A, h, (F) => d(h, F), [], "rangeEnd");
              if (!P || !C)
                return { rangeStart: 0, rangeEnd: 0 };
              let D, g;
              if (a(h)) {
                let F = r(P, C);
                D = F, g = F;
              } else
                ({ startNode: D, endNode: g } = i(P, C, h));
              return { rangeStart: Math.min(S(D), S(g)), rangeEnd: Math.max(B(D), B(g)) };
            }
            n.exports = { calculateRange: p, findNodeAtOffset: o };
          } }), Sm = Z({ "src/main/core.js"(e, n) {
            "use strict";
            re();
            var { diffArrays: t3 } = aD(), { printer: { printDocToString: s }, debug: { printDocToDebug: a } } = Oe(), { getAlignmentSize: r } = Ue(), { guessEndOfLine: u, convertEndOfLineToChars: i, countEndOfLineChars: o, normalizeEndOfLine: c } = jn(), v = Wa().normalize, m = vm(), d = et(), p = Gn(), f = Fm(), h = Am(), w = "\uFEFF", T = Symbol("cursor");
            function A(g, F, l) {
              let E = F.comments;
              return E && (delete F.comments, d.attach(E, F, g, l)), l[Symbol.for("comments")] = E || [], l[Symbol.for("tokens")] = F.tokens || [], l.originalText = g, E;
            }
            function S(g, F) {
              let l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
              if (!g || g.trim().length === 0)
                return { formatted: "", cursorOffset: -1, comments: [] };
              let { ast: E, text: y } = p.parse(g, F);
              if (F.cursorOffset >= 0) {
                let L = h.findNodeAtOffset(E, F.cursorOffset, F);
                L && L.node && (F.cursorNode = L.node);
              }
              let N = A(y, E, F), x = f(E, F, l), b = s(x, F);
              if (d.ensureAllCommentsPrinted(N), l > 0) {
                let L = b.formatted.trim();
                b.cursorNodeStart !== void 0 && (b.cursorNodeStart -= b.formatted.indexOf(L)), b.formatted = L + i(F.endOfLine);
              }
              if (F.cursorOffset >= 0) {
                let L, M, j, $, V;
                if (F.cursorNode && b.cursorNodeText ? (L = F.locStart(F.cursorNode), M = y.slice(L, F.locEnd(F.cursorNode)), j = F.cursorOffset - L, $ = b.cursorNodeStart, V = b.cursorNodeText) : (L = 0, M = y, j = F.cursorOffset, $ = 0, V = b.formatted), M === V)
                  return { formatted: b.formatted, cursorOffset: $ + j, comments: N };
                let q = [...M];
                q.splice(j, 0, T);
                let Y = [...V], H = t3(q, Y), R = $;
                for (let Q of H)
                  if (Q.removed) {
                    if (Q.value.includes(T))
                      break;
                  } else
                    R += Q.count;
                return { formatted: b.formatted, cursorOffset: R, comments: N };
              }
              return { formatted: b.formatted, cursorOffset: -1, comments: N };
            }
            function B(g, F) {
              let { ast: l, text: E } = p.parse(g, F), { rangeStart: y, rangeEnd: N } = h.calculateRange(E, F, l), x = E.slice(y, N), b = Math.min(y, E.lastIndexOf(`
`, y) + 1), L = E.slice(b, y).match(/^\s*/)[0], M = r(L, F.tabWidth), j = S(x, Object.assign(Object.assign({}, F), {}, { rangeStart: 0, rangeEnd: Number.POSITIVE_INFINITY, cursorOffset: F.cursorOffset > y && F.cursorOffset <= N ? F.cursorOffset - y : -1, endOfLine: "lf" }), M), $ = j.formatted.trimEnd(), { cursorOffset: V } = F;
              V > N ? V += $.length - x.length : j.cursorOffset >= 0 && (V = j.cursorOffset + y);
              let q = E.slice(0, y) + $ + E.slice(N);
              if (F.endOfLine !== "lf") {
                let Y = i(F.endOfLine);
                V >= 0 && Y === `\r
` && (V += o(q.slice(0, V), `
`)), q = q.replace(/\n/g, Y);
              }
              return { formatted: q, cursorOffset: V, comments: j.comments };
            }
            function I(g, F, l) {
              return typeof F != "number" || Number.isNaN(F) || F < 0 || F > g.length ? l : F;
            }
            function k(g, F) {
              let { cursorOffset: l, rangeStart: E, rangeEnd: y } = F;
              return l = I(g, l, -1), E = I(g, E, 0), y = I(g, y, g.length), Object.assign(Object.assign({}, F), {}, { cursorOffset: l, rangeStart: E, rangeEnd: y });
            }
            function P(g, F) {
              let { cursorOffset: l, rangeStart: E, rangeEnd: y, endOfLine: N } = k(g, F), x = g.charAt(0) === w;
              if (x && (g = g.slice(1), l--, E--, y--), N === "auto" && (N = u(g)), g.includes("\r")) {
                let b = (L) => o(g.slice(0, Math.max(L, 0)), `\r
`);
                l -= b(l), E -= b(E), y -= b(y), g = c(g);
              }
              return { hasBOM: x, text: g, options: k(g, Object.assign(Object.assign({}, F), {}, { cursorOffset: l, rangeStart: E, rangeEnd: y, endOfLine: N })) };
            }
            function C(g, F) {
              let l = p.resolveParser(F);
              return !l.hasPragma || l.hasPragma(g);
            }
            function D(g, F) {
              let { hasBOM: l, text: E, options: y } = P(g, v(F));
              if (y.rangeStart >= y.rangeEnd && E !== "" || y.requirePragma && !C(E, y))
                return { formatted: g, cursorOffset: F.cursorOffset, comments: [] };
              let N;
              return y.rangeStart > 0 || y.rangeEnd < E.length ? N = B(E, y) : (!y.requirePragma && y.insertPragma && y.printer.insertPragma && !C(E, y) && (E = y.printer.insertPragma(E)), N = S(E, y)), l && (N.formatted = w + N.formatted, N.cursorOffset >= 0 && N.cursorOffset++), N;
            }
            n.exports = { formatWithCursor: D, parse(g, F, l) {
              let { text: E, options: y } = P(g, v(F)), N = p.parse(E, y);
              return l && (N.ast = m(N.ast, y)), N;
            }, formatAST(g, F) {
              F = v(F);
              let l = f(g, F);
              return s(l, F);
            }, formatDoc(g, F) {
              return D(a(g), Object.assign(Object.assign({}, F), {}, { parser: "__js_expression" })).formatted;
            }, printToDoc(g, F) {
              F = v(F);
              let { ast: l, text: E } = p.parse(g, F);
              return A(E, l, F), f(l, F);
            }, printDocToString(g, F) {
              return s(g, v(F));
            } };
          } }), xm = Z({ "src/common/util-shared.js"(e, n) {
            "use strict";
            re();
            var { getMaxContinuousCount: t3, getStringWidth: s, getAlignmentSize: a, getIndentSize: r, skip: u, skipWhitespace: i, skipSpaces: o, skipNewline: c, skipToLineEnd: v, skipEverythingButNewLine: m, skipInlineComment: d, skipTrailingComment: p, hasNewline: f, hasNewlineInRange: h, hasSpaces: w, isNextLineEmpty: T, isNextLineEmptyAfterIndex: A, isPreviousLineEmpty: S, getNextNonSpaceNonCommentCharacterIndex: B, makeString: I, addLeadingComment: k, addDanglingComment: P, addTrailingComment: C } = Ue();
            n.exports = { getMaxContinuousCount: t3, getStringWidth: s, getAlignmentSize: a, getIndentSize: r, skip: u, skipWhitespace: i, skipSpaces: o, skipNewline: c, skipToLineEnd: v, skipEverythingButNewLine: m, skipInlineComment: d, skipTrailingComment: p, hasNewline: f, hasNewlineInRange: h, hasSpaces: w, isNextLineEmpty: T, isNextLineEmptyAfterIndex: A, isPreviousLineEmpty: S, getNextNonSpaceNonCommentCharacterIndex: B, makeString: I, addLeadingComment: k, addDanglingComment: P, addTrailingComment: C };
          } }), Bt = Z({ "src/utils/create-language.js"(e, n) {
            "use strict";
            re(), n.exports = function(t3, s) {
              let { languageId: a } = t3, r = kn(t3, Zf);
              return Object.assign(Object.assign({ linguistLanguageId: a }, r), s(t3));
            };
          } }), bm = Z({ "node_modules/esutils/lib/ast.js"(e, n) {
            re(), function() {
              "use strict";
              function t3(o) {
                if (o == null)
                  return false;
                switch (o.type) {
                  case "ArrayExpression":
                  case "AssignmentExpression":
                  case "BinaryExpression":
                  case "CallExpression":
                  case "ConditionalExpression":
                  case "FunctionExpression":
                  case "Identifier":
                  case "Literal":
                  case "LogicalExpression":
                  case "MemberExpression":
                  case "NewExpression":
                  case "ObjectExpression":
                  case "SequenceExpression":
                  case "ThisExpression":
                  case "UnaryExpression":
                  case "UpdateExpression":
                    return true;
                }
                return false;
              }
              function s(o) {
                if (o == null)
                  return false;
                switch (o.type) {
                  case "DoWhileStatement":
                  case "ForInStatement":
                  case "ForStatement":
                  case "WhileStatement":
                    return true;
                }
                return false;
              }
              function a(o) {
                if (o == null)
                  return false;
                switch (o.type) {
                  case "BlockStatement":
                  case "BreakStatement":
                  case "ContinueStatement":
                  case "DebuggerStatement":
                  case "DoWhileStatement":
                  case "EmptyStatement":
                  case "ExpressionStatement":
                  case "ForInStatement":
                  case "ForStatement":
                  case "IfStatement":
                  case "LabeledStatement":
                  case "ReturnStatement":
                  case "SwitchStatement":
                  case "ThrowStatement":
                  case "TryStatement":
                  case "VariableDeclaration":
                  case "WhileStatement":
                  case "WithStatement":
                    return true;
                }
                return false;
              }
              function r(o) {
                return a(o) || o != null && o.type === "FunctionDeclaration";
              }
              function u(o) {
                switch (o.type) {
                  case "IfStatement":
                    return o.alternate != null ? o.alternate : o.consequent;
                  case "LabeledStatement":
                  case "ForStatement":
                  case "ForInStatement":
                  case "WhileStatement":
                  case "WithStatement":
                    return o.body;
                }
                return null;
              }
              function i(o) {
                var c;
                if (o.type !== "IfStatement" || o.alternate == null)
                  return false;
                c = o.consequent;
                do {
                  if (c.type === "IfStatement" && c.alternate == null)
                    return true;
                  c = u(c);
                } while (c);
                return false;
              }
              n.exports = { isExpression: t3, isStatement: a, isIterationStatement: s, isSourceElement: r, isProblematicIfStatement: i, trailingStatement: u };
            }();
          } }), $a = Z({ "node_modules/esutils/lib/code.js"(e, n) {
            re(), function() {
              "use strict";
              var t3, s, a, r, u, i;
              s = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/, NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/ }, t3 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/, NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/ };
              function o(A) {
                return 48 <= A && A <= 57;
              }
              function c(A) {
                return 48 <= A && A <= 57 || 97 <= A && A <= 102 || 65 <= A && A <= 70;
              }
              function v(A) {
                return A >= 48 && A <= 55;
              }
              a = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279];
              function m(A) {
                return A === 32 || A === 9 || A === 11 || A === 12 || A === 160 || A >= 5760 && a.indexOf(A) >= 0;
              }
              function d(A) {
                return A === 10 || A === 13 || A === 8232 || A === 8233;
              }
              function p(A) {
                if (A <= 65535)
                  return String.fromCharCode(A);
                var S = String.fromCharCode(Math.floor((A - 65536) / 1024) + 55296), B = String.fromCharCode((A - 65536) % 1024 + 56320);
                return S + B;
              }
              for (r = new Array(128), i = 0; i < 128; ++i)
                r[i] = i >= 97 && i <= 122 || i >= 65 && i <= 90 || i === 36 || i === 95;
              for (u = new Array(128), i = 0; i < 128; ++i)
                u[i] = i >= 97 && i <= 122 || i >= 65 && i <= 90 || i >= 48 && i <= 57 || i === 36 || i === 95;
              function f(A) {
                return A < 128 ? r[A] : s.NonAsciiIdentifierStart.test(p(A));
              }
              function h(A) {
                return A < 128 ? u[A] : s.NonAsciiIdentifierPart.test(p(A));
              }
              function w(A) {
                return A < 128 ? r[A] : t3.NonAsciiIdentifierStart.test(p(A));
              }
              function T(A) {
                return A < 128 ? u[A] : t3.NonAsciiIdentifierPart.test(p(A));
              }
              n.exports = { isDecimalDigit: o, isHexDigit: c, isOctalDigit: v, isWhiteSpace: m, isLineTerminator: d, isIdentifierStartES5: f, isIdentifierPartES5: h, isIdentifierStartES6: w, isIdentifierPartES6: T };
            }();
          } }), Tm = Z({ "node_modules/esutils/lib/keyword.js"(e, n) {
            re(), function() {
              "use strict";
              var t3 = $a();
              function s(f) {
                switch (f) {
                  case "implements":
                  case "interface":
                  case "package":
                  case "private":
                  case "protected":
                  case "public":
                  case "static":
                  case "let":
                    return true;
                  default:
                    return false;
                }
              }
              function a(f, h) {
                return !h && f === "yield" ? false : r(f, h);
              }
              function r(f, h) {
                if (h && s(f))
                  return true;
                switch (f.length) {
                  case 2:
                    return f === "if" || f === "in" || f === "do";
                  case 3:
                    return f === "var" || f === "for" || f === "new" || f === "try";
                  case 4:
                    return f === "this" || f === "else" || f === "case" || f === "void" || f === "with" || f === "enum";
                  case 5:
                    return f === "while" || f === "break" || f === "catch" || f === "throw" || f === "const" || f === "yield" || f === "class" || f === "super";
                  case 6:
                    return f === "return" || f === "typeof" || f === "delete" || f === "switch" || f === "export" || f === "import";
                  case 7:
                    return f === "default" || f === "finally" || f === "extends";
                  case 8:
                    return f === "function" || f === "continue" || f === "debugger";
                  case 10:
                    return f === "instanceof";
                  default:
                    return false;
                }
              }
              function u(f, h) {
                return f === "null" || f === "true" || f === "false" || a(f, h);
              }
              function i(f, h) {
                return f === "null" || f === "true" || f === "false" || r(f, h);
              }
              function o(f) {
                return f === "eval" || f === "arguments";
              }
              function c(f) {
                var h, w, T;
                if (f.length === 0 || (T = f.charCodeAt(0), !t3.isIdentifierStartES5(T)))
                  return false;
                for (h = 1, w = f.length; h < w; ++h)
                  if (T = f.charCodeAt(h), !t3.isIdentifierPartES5(T))
                    return false;
                return true;
              }
              function v(f, h) {
                return (f - 55296) * 1024 + (h - 56320) + 65536;
              }
              function m(f) {
                var h, w, T, A, S;
                if (f.length === 0)
                  return false;
                for (S = t3.isIdentifierStartES6, h = 0, w = f.length; h < w; ++h) {
                  if (T = f.charCodeAt(h), 55296 <= T && T <= 56319) {
                    if (++h, h >= w || (A = f.charCodeAt(h), !(56320 <= A && A <= 57343)))
                      return false;
                    T = v(T, A);
                  }
                  if (!S(T))
                    return false;
                  S = t3.isIdentifierPartES6;
                }
                return true;
              }
              function d(f, h) {
                return c(f) && !u(f, h);
              }
              function p(f, h) {
                return m(f) && !i(f, h);
              }
              n.exports = { isKeywordES5: a, isKeywordES6: r, isReservedWordES5: u, isReservedWordES6: i, isRestrictedWord: o, isIdentifierNameES5: c, isIdentifierNameES6: m, isIdentifierES5: d, isIdentifierES6: p };
            }();
          } }), Bm = Z({ "node_modules/esutils/lib/utils.js"(e) {
            re(), function() {
              "use strict";
              e.ast = bm(), e.code = $a(), e.keyword = Tm();
            }();
          } }), It = Z({ "src/language-js/utils/is-block-comment.js"(e, n) {
            "use strict";
            re();
            var t3 = /* @__PURE__ */ new Set(["Block", "CommentBlock", "MultiLine"]), s = (a) => t3.has(a == null ? void 0 : a.type);
            n.exports = s;
          } }), Nm = Z({ "src/language-js/utils/is-node-matches.js"(e, n) {
            "use strict";
            re();
            function t3(a, r) {
              let u = r.split(".");
              for (let i = u.length - 1; i >= 0; i--) {
                let o = u[i];
                if (i === 0)
                  return a.type === "Identifier" && a.name === o;
                if (a.type !== "MemberExpression" || a.optional || a.computed || a.property.type !== "Identifier" || a.property.name !== o)
                  return false;
                a = a.object;
              }
            }
            function s(a, r) {
              return r.some((u) => t3(a, u));
            }
            n.exports = s;
          } }), Ke = Z({ "src/language-js/utils/index.js"(e, n) {
            "use strict";
            re();
            var t3 = Bm().keyword.isIdentifierNameES5, { getLast: s, hasNewline: a, skipWhitespace: r, isNonEmptyArray: u, isNextLineEmptyAfterIndex: i, getStringWidth: o } = Ue(), { locStart: c, locEnd: v, hasSameLocStart: m } = st(), d = It(), p = Nm(), f = "(?:(?=.)\\s)", h = new RegExp("^".concat(f, "*:")), w = new RegExp("^".concat(f, "*::"));
            function T(O) {
              var fe, Te;
              return ((fe = O.extra) === null || fe === void 0 ? void 0 : fe.parenthesized) && d((Te = O.trailingComments) === null || Te === void 0 ? void 0 : Te[0]) && h.test(O.trailingComments[0].value);
            }
            function A(O) {
              let fe = O == null ? void 0 : O[0];
              return d(fe) && w.test(fe.value);
            }
            function S(O, fe) {
              if (!O || typeof O != "object")
                return false;
              if (Array.isArray(O))
                return O.some(($e) => S($e, fe));
              let Te = fe(O);
              return typeof Te == "boolean" ? Te : Object.values(O).some(($e) => S($e, fe));
            }
            function B(O) {
              return O.type === "AssignmentExpression" || O.type === "BinaryExpression" || O.type === "LogicalExpression" || O.type === "NGPipeExpression" || O.type === "ConditionalExpression" || ue(O) || De(O) || O.type === "SequenceExpression" || O.type === "TaggedTemplateExpression" || O.type === "BindExpression" || O.type === "UpdateExpression" && !O.prefix || O.type === "TSAsExpression" || O.type === "TSNonNullExpression";
            }
            function I(O) {
              var fe, Te, $e, Je, Ze, ut;
              return O.expressions ? O.expressions[0] : (fe = (Te = ($e = (Je = (Ze = (ut = O.left) !== null && ut !== void 0 ? ut : O.test) !== null && Ze !== void 0 ? Ze : O.callee) !== null && Je !== void 0 ? Je : O.object) !== null && $e !== void 0 ? $e : O.tag) !== null && Te !== void 0 ? Te : O.argument) !== null && fe !== void 0 ? fe : O.expression;
            }
            function k(O, fe) {
              if (fe.expressions)
                return ["expressions", 0];
              if (fe.left)
                return ["left"];
              if (fe.test)
                return ["test"];
              if (fe.object)
                return ["object"];
              if (fe.callee)
                return ["callee"];
              if (fe.tag)
                return ["tag"];
              if (fe.argument)
                return ["argument"];
              if (fe.expression)
                return ["expression"];
              throw new Error("Unexpected node has no left side.");
            }
            function P(O) {
              return O = new Set(O), (fe) => O.has(fe == null ? void 0 : fe.type);
            }
            var C = P(["Line", "CommentLine", "SingleLine", "HashbangComment", "HTMLOpen", "HTMLClose"]), D = P(["ExportDefaultDeclaration", "ExportDefaultSpecifier", "DeclareExportDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration"]);
            function g(O) {
              let fe = O.getParentNode();
              return O.getName() === "declaration" && D(fe) ? fe : null;
            }
            var F = P(["BooleanLiteral", "DirectiveLiteral", "Literal", "NullLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "RegExpLiteral", "StringLiteral", "TemplateLiteral", "TSTypeLiteral", "JSXText"]);
            function l(O) {
              return O.type === "NumericLiteral" || O.type === "Literal" && typeof O.value == "number";
            }
            function E(O) {
              return O.type === "UnaryExpression" && (O.operator === "+" || O.operator === "-") && l(O.argument);
            }
            function y(O) {
              return O.type === "StringLiteral" || O.type === "Literal" && typeof O.value == "string";
            }
            var N = P(["ObjectTypeAnnotation", "TSTypeLiteral", "TSMappedType"]), x = P(["FunctionExpression", "ArrowFunctionExpression"]);
            function b(O) {
              return O.type === "FunctionExpression" || O.type === "ArrowFunctionExpression" && O.body.type === "BlockStatement";
            }
            function L(O) {
              return ue(O) && O.callee.type === "Identifier" && ["async", "inject", "fakeAsync", "waitForAsync"].includes(O.callee.name);
            }
            var M = P(["JSXElement", "JSXFragment"]);
            function j(O, fe) {
              if (O.parentParser !== "markdown" && O.parentParser !== "mdx")
                return false;
              let Te = fe.getNode();
              if (!Te.expression || !M(Te.expression))
                return false;
              let $e = fe.getParentNode();
              return $e.type === "Program" && $e.body.length === 1;
            }
            function $(O) {
              return O.kind === "get" || O.kind === "set";
            }
            function V(O) {
              return $(O) || m(O, O.value);
            }
            function q(O) {
              return (O.type === "ObjectTypeProperty" || O.type === "ObjectTypeInternalSlot") && O.value.type === "FunctionTypeAnnotation" && !O.static && !V(O);
            }
            function Y(O) {
              return (O.type === "TypeAnnotation" || O.type === "TSTypeAnnotation") && O.typeAnnotation.type === "FunctionTypeAnnotation" && !O.static && !m(O, O.typeAnnotation);
            }
            var H = P(["BinaryExpression", "LogicalExpression", "NGPipeExpression"]);
            function R(O) {
              return De(O) || O.type === "BindExpression" && Boolean(O.object);
            }
            var Q = /* @__PURE__ */ new Set(["AnyTypeAnnotation", "TSAnyKeyword", "NullLiteralTypeAnnotation", "TSNullKeyword", "ThisTypeAnnotation", "TSThisType", "NumberTypeAnnotation", "TSNumberKeyword", "VoidTypeAnnotation", "TSVoidKeyword", "BooleanTypeAnnotation", "TSBooleanKeyword", "BigIntTypeAnnotation", "TSBigIntKeyword", "SymbolTypeAnnotation", "TSSymbolKeyword", "StringTypeAnnotation", "TSStringKeyword", "BooleanLiteralTypeAnnotation", "StringLiteralTypeAnnotation", "BigIntLiteralTypeAnnotation", "NumberLiteralTypeAnnotation", "TSLiteralType", "TSTemplateLiteralType", "EmptyTypeAnnotation", "MixedTypeAnnotation", "TSNeverKeyword", "TSObjectKeyword", "TSUndefinedKeyword", "TSUnknownKeyword"]);
            function ee(O) {
              return O ? !!((O.type === "GenericTypeAnnotation" || O.type === "TSTypeReference") && !O.typeParameters || Q.has(O.type)) : false;
            }
            function te(O) {
              let fe = /^(?:before|after)(?:Each|All)$/;
              return O.callee.type === "Identifier" && fe.test(O.callee.name) && O.arguments.length === 1;
            }
            var oe = ["it", "it.only", "it.skip", "describe", "describe.only", "describe.skip", "test", "test.only", "test.skip", "test.step", "test.describe", "test.describe.only", "test.describe.parallel", "test.describe.parallel.only", "test.describe.serial", "test.describe.serial.only", "skip", "xit", "xdescribe", "xtest", "fit", "fdescribe", "ftest"];
            function W(O) {
              return p(O, oe);
            }
            function X(O, fe) {
              if (O.type !== "CallExpression")
                return false;
              if (O.arguments.length === 1) {
                if (L(O) && fe && X(fe))
                  return x(O.arguments[0]);
                if (te(O))
                  return L(O.arguments[0]);
              } else if ((O.arguments.length === 2 || O.arguments.length === 3) && (O.arguments[0].type === "TemplateLiteral" || y(O.arguments[0])) && W(O.callee))
                return O.arguments[2] && !l(O.arguments[2]) ? false : (O.arguments.length === 2 ? x(O.arguments[1]) : b(O.arguments[1]) && Se(O.arguments[1]).length <= 1) || L(O.arguments[1]);
              return false;
            }
            var ue = P(["CallExpression", "OptionalCallExpression"]), De = P(["MemberExpression", "OptionalMemberExpression"]);
            function ie(O) {
              let fe = "expressions";
              O.type === "TSTemplateLiteralType" && (fe = "types");
              let Te = O[fe];
              return Te.length === 0 ? false : Te.every(($e) => {
                if (se($e))
                  return false;
                if ($e.type === "Identifier" || $e.type === "ThisExpression")
                  return true;
                if (De($e)) {
                  let Je = $e;
                  for (; De(Je); )
                    if (Je.property.type !== "Identifier" && Je.property.type !== "Literal" && Je.property.type !== "StringLiteral" && Je.property.type !== "NumericLiteral" || (Je = Je.object, se(Je)))
                      return false;
                  return Je.type === "Identifier" || Je.type === "ThisExpression";
                }
                return false;
              });
            }
            function G(O, fe) {
              return O === "+" || O === "-" ? O + fe : fe;
            }
            function z(O, fe) {
              let Te = c(fe), $e = r(O, v(fe));
              return $e !== false && O.slice(Te, Te + 2) === "/*" && O.slice($e, $e + 2) === "*/";
            }
            function U(O, fe) {
              return M(fe) ? Re(fe) : se(fe, Le.Leading, (Te) => a(O, v(Te)));
            }
            function le(O, fe) {
              return fe.parser !== "json" && y(O.key) && ve(O.key).slice(1, -1) === O.key.value && (t3(O.key.value) && !(fe.parser === "babel-ts" && O.type === "ClassProperty" || fe.parser === "typescript" && O.type === "PropertyDefinition") || ge(O.key.value) && String(Number(O.key.value)) === O.key.value && (fe.parser === "babel" || fe.parser === "acorn" || fe.parser === "espree" || fe.parser === "meriyah" || fe.parser === "__babel_estree"));
            }
            function ge(O) {
              return /^(?:\d+|\d+\.\d+)$/.test(O);
            }
            function Ae(O, fe) {
              let Te = /^[fx]?(?:describe|it|test)$/;
              return fe.type === "TaggedTemplateExpression" && fe.quasi === O && fe.tag.type === "MemberExpression" && fe.tag.property.type === "Identifier" && fe.tag.property.name === "each" && (fe.tag.object.type === "Identifier" && Te.test(fe.tag.object.name) || fe.tag.object.type === "MemberExpression" && fe.tag.object.property.type === "Identifier" && (fe.tag.object.property.name === "only" || fe.tag.object.property.name === "skip") && fe.tag.object.object.type === "Identifier" && Te.test(fe.tag.object.object.name));
            }
            function Ne(O) {
              return O.quasis.some((fe) => fe.value.raw.includes(`
`));
            }
            function ke(O, fe) {
              return (O.type === "TemplateLiteral" && Ne(O) || O.type === "TaggedTemplateExpression" && Ne(O.quasi)) && !a(fe, c(O), { backwards: true });
            }
            function ce(O) {
              if (!se(O))
                return false;
              let fe = s(He(O, Le.Dangling));
              return fe && !d(fe);
            }
            function pe(O) {
              if (O.length <= 1)
                return false;
              let fe = 0;
              for (let Te of O)
                if (x(Te)) {
                  if (fe += 1, fe > 1)
                    return true;
                } else if (ue(Te)) {
                  for (let $e of Te.arguments)
                    if (x($e))
                      return true;
                }
              return false;
            }
            function de(O) {
              let fe = O.getValue(), Te = O.getParentNode();
              return ue(fe) && ue(Te) && Te.callee === fe && fe.arguments.length > Te.arguments.length && Te.arguments.length > 0;
            }
            function ae(O, fe) {
              if (fe >= 2)
                return false;
              let Te = (Je) => ae(Je, fe + 1), $e = O.type === "Literal" && "regex" in O && O.regex.pattern || O.type === "RegExpLiteral" && O.pattern;
              return $e && o($e) > 5 ? false : O.type === "Literal" || O.type === "BigIntLiteral" || O.type === "DecimalLiteral" || O.type === "BooleanLiteral" || O.type === "NullLiteral" || O.type === "NumericLiteral" || O.type === "RegExpLiteral" || O.type === "StringLiteral" || O.type === "Identifier" || O.type === "ThisExpression" || O.type === "Super" || O.type === "PrivateName" || O.type === "PrivateIdentifier" || O.type === "ArgumentPlaceholder" || O.type === "Import" ? true : O.type === "TemplateLiteral" ? O.quasis.every((Je) => !Je.value.raw.includes(`
`)) && O.expressions.every(Te) : O.type === "ObjectExpression" ? O.properties.every((Je) => !Je.computed && (Je.shorthand || Je.value && Te(Je.value))) : O.type === "ArrayExpression" ? O.elements.every((Je) => Je === null || Te(Je)) : ze(O) ? (O.type === "ImportExpression" || ae(O.callee, fe)) && Xe(O).every(Te) : De(O) ? ae(O.object, fe) && ae(O.property, fe) : O.type === "UnaryExpression" && (O.operator === "!" || O.operator === "-") ? ae(O.argument, fe) : O.type === "TSNonNullExpression" ? ae(O.expression, fe) : false;
            }
            function ve(O) {
              var fe, Te;
              return (fe = (Te = O.extra) === null || Te === void 0 ? void 0 : Te.raw) !== null && fe !== void 0 ? fe : O.raw;
            }
            function K(O) {
              return O;
            }
            function he(O) {
              return O.filepath && /\.tsx$/i.test(O.filepath);
            }
            function ye(O) {
              let fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "es5";
              return O.trailingComma === "es5" && fe === "es5" || O.trailingComma === "all" && (fe === "all" || fe === "es5");
            }
            function Ce(O, fe) {
              switch (O = Ee(O), O.type) {
                case "FunctionExpression":
                case "ClassExpression":
                case "DoExpression":
                  return fe;
                case "ObjectExpression":
                  return true;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return Ce(O.object, fe);
                case "TaggedTemplateExpression":
                  return O.tag.type === "FunctionExpression" ? false : Ce(O.tag, fe);
                case "CallExpression":
                case "OptionalCallExpression":
                  return O.callee.type === "FunctionExpression" ? false : Ce(O.callee, fe);
                case "ConditionalExpression":
                  return Ce(O.test, fe);
                case "UpdateExpression":
                  return !O.prefix && Ce(O.argument, fe);
                case "BindExpression":
                  return O.object && Ce(O.object, fe);
                case "SequenceExpression":
                  return Ce(O.expressions[0], fe);
                case "TSAsExpression":
                case "TSNonNullExpression":
                  return Ce(O.expression, fe);
                default:
                  return false;
              }
            }
            var Ie = { "==": true, "!=": true, "===": true, "!==": true }, Fe = { "*": true, "/": true, "%": true }, me = { ">>": true, ">>>": true, "<<": true };
            function _(O, fe) {
              return !(ne(fe) !== ne(O) || O === "**" || Ie[O] && Ie[fe] || fe === "%" && Fe[O] || O === "%" && Fe[fe] || fe !== O && Fe[fe] && Fe[O] || me[O] && me[fe]);
            }
            var J = new Map([["|>"], ["??"], ["||"], ["&&"], ["|"], ["^"], ["&"], ["==", "===", "!=", "!=="], ["<", ">", "<=", ">=", "in", "instanceof"], [">>", "<<", ">>>"], ["+", "-"], ["*", "/", "%"], ["**"]].flatMap((O, fe) => O.map((Te) => [Te, fe])));
            function ne(O) {
              return J.get(O);
            }
            function Ee(O) {
              for (; O.left; )
                O = O.left;
              return O;
            }
            function We(O) {
              return Boolean(me[O]) || O === "|" || O === "^" || O === "&";
            }
            function Be(O) {
              var fe;
              if (O.rest)
                return true;
              let Te = Se(O);
              return ((fe = s(Te)) === null || fe === void 0 ? void 0 : fe.type) === "RestElement";
            }
            var Pe = /* @__PURE__ */ new WeakMap();
            function Se(O) {
              if (Pe.has(O))
                return Pe.get(O);
              let fe = [];
              return O.this && fe.push(O.this), Array.isArray(O.parameters) ? fe.push(...O.parameters) : Array.isArray(O.params) && fe.push(...O.params), O.rest && fe.push(O.rest), Pe.set(O, fe), fe;
            }
            function Qe(O, fe) {
              let Te = O.getValue(), $e = 0, Je = (Ze) => fe(Ze, $e++);
              Te.this && O.call(Je, "this"), Array.isArray(Te.parameters) ? O.each(Je, "parameters") : Array.isArray(Te.params) && O.each(Je, "params"), Te.rest && O.call(Je, "rest");
            }
            var xe = /* @__PURE__ */ new WeakMap();
            function Xe(O) {
              if (xe.has(O))
                return xe.get(O);
              let fe = O.arguments;
              return O.type === "ImportExpression" && (fe = [O.source], O.attributes && fe.push(O.attributes)), xe.set(O, fe), fe;
            }
            function _e(O, fe) {
              let Te = O.getValue();
              Te.type === "ImportExpression" ? (O.call(($e) => fe($e, 0), "source"), Te.attributes && O.call(($e) => fe($e, 1), "attributes")) : O.each(fe, "arguments");
            }
            function je(O) {
              return O.value.trim() === "prettier-ignore" && !O.unignore;
            }
            function Re(O) {
              return O && (O.prettierIgnore || se(O, Le.PrettierIgnore));
            }
            function be(O) {
              let fe = O.getValue();
              return Re(fe);
            }
            var Le = { Leading: 1 << 1, Trailing: 1 << 2, Dangling: 1 << 3, Block: 1 << 4, Line: 1 << 5, PrettierIgnore: 1 << 6, First: 1 << 7, Last: 1 << 8 }, qe = (O, fe) => {
              if (typeof O == "function" && (fe = O, O = 0), O || fe)
                return (Te, $e, Je) => !(O & Le.Leading && !Te.leading || O & Le.Trailing && !Te.trailing || O & Le.Dangling && (Te.leading || Te.trailing) || O & Le.Block && !d(Te) || O & Le.Line && !C(Te) || O & Le.First && $e !== 0 || O & Le.Last && $e !== Je.length - 1 || O & Le.PrettierIgnore && !je(Te) || fe && !fe(Te));
            };
            function se(O, fe, Te) {
              if (!u(O == null ? void 0 : O.comments))
                return false;
              let $e = qe(fe, Te);
              return $e ? O.comments.some($e) : true;
            }
            function He(O, fe, Te) {
              if (!Array.isArray(O == null ? void 0 : O.comments))
                return [];
              let $e = qe(fe, Te);
              return $e ? O.comments.filter($e) : O.comments;
            }
            var Me = (O, fe) => {
              let { originalText: Te } = fe;
              return i(Te, v(O));
            };
            function ze(O) {
              return ue(O) || O.type === "NewExpression" || O.type === "ImportExpression";
            }
            function nt(O) {
              return O && (O.type === "ObjectProperty" || O.type === "Property" && !O.method && O.kind === "init");
            }
            function tt(O) {
              return Boolean(O.__isUsingHackPipeline);
            }
            var pt = Symbol("ifWithoutBlockAndSameLineComment");
            n.exports = { getFunctionParameters: Se, iterateFunctionParametersPath: Qe, getCallArguments: Xe, iterateCallArgumentsPath: _e, hasRestParameter: Be, getLeftSide: I, getLeftSidePathName: k, getParentExportDeclaration: g, getTypeScriptMappedTypeModifier: G, hasFlowAnnotationComment: A, hasFlowShorthandAnnotationComment: T, hasLeadingOwnLineComment: U, hasNakedLeftSide: B, hasNode: S, hasIgnoreComment: be, hasNodeIgnoreComment: Re, identity: K, isBinaryish: H, isCallLikeExpression: ze, isEnabledHackPipeline: tt, isLineComment: C, isPrettierIgnoreComment: je, isCallExpression: ue, isMemberExpression: De, isExportDeclaration: D, isFlowAnnotationComment: z, isFunctionCompositionArgs: pe, isFunctionNotation: V, isFunctionOrArrowExpression: x, isGetterOrSetter: $, isJestEachTemplateLiteral: Ae, isJsxNode: M, isLiteral: F, isLongCurriedCallExpression: de, isSimpleCallArgument: ae, isMemberish: R, isNumericLiteral: l, isSignedNumericLiteral: E, isObjectProperty: nt, isObjectType: N, isObjectTypePropertyAFunction: q, isSimpleType: ee, isSimpleNumber: ge, isSimpleTemplateLiteral: ie, isStringLiteral: y, isStringPropSafeToUnquote: le, isTemplateOnItsOwnLine: ke, isTestCall: X, isTheOnlyJsxElementInMarkdown: j, isTSXFile: he, isTypeAnnotationAFunction: Y, isNextLineEmpty: Me, needsHardlineAfterDanglingComment: ce, rawText: ve, shouldPrintComma: ye, isBitwiseOperator: We, shouldFlatten: _, startsWithNoLookaheadToken: Ce, getPrecedence: ne, hasComment: se, getComments: He, CommentCheckFlags: Le, markerForIfWithoutBlockAndSameLineComment: pt };
          } }), Lt = Z({ "src/language-js/print/template-literal.js"(e, n) {
            "use strict";
            re();
            var t3 = it(), { getStringWidth: s, getIndentSize: a } = Ue(), { builders: { join: r, hardline: u, softline: i, group: o, indent: c, align: v, lineSuffixBoundary: m, addAlignmentToDoc: d }, printer: { printDocToString: p }, utils: { mapDoc: f } } = Oe(), { isBinaryish: h, isJestEachTemplateLiteral: w, isSimpleTemplateLiteral: T, hasComment: A, isMemberExpression: S } = Ke();
            function B(g, F, l) {
              let E = g.getValue();
              if (E.type === "TemplateLiteral" && w(E, g.getParentNode())) {
                let M = I(g, l, F);
                if (M)
                  return M;
              }
              let N = "expressions";
              E.type === "TSTemplateLiteralType" && (N = "types");
              let x = [], b = g.map(F, N), L = T(E);
              return L && (b = b.map((M) => p(M, Object.assign(Object.assign({}, l), {}, { printWidth: Number.POSITIVE_INFINITY })).formatted)), x.push(m, "`"), g.each((M) => {
                let j = M.getName();
                if (x.push(F()), j < b.length) {
                  let { tabWidth: $ } = l, V = M.getValue(), q = a(V.value.raw, $), Y = b[j];
                  if (!L) {
                    let R = E[N][j];
                    (A(R) || S(R) || R.type === "ConditionalExpression" || R.type === "SequenceExpression" || R.type === "TSAsExpression" || h(R)) && (Y = [c([i, Y]), i]);
                  }
                  let H = q === 0 && V.value.raw.endsWith(`
`) ? v(Number.NEGATIVE_INFINITY, Y) : d(Y, q, $);
                  x.push(o(["${", H, m, "}"]));
                }
              }, "quasis"), x.push("`"), x;
            }
            function I(g, F, l) {
              let E = g.getNode(), y = E.quasis[0].value.raw.trim().split(/\s*\|\s*/);
              if (y.length > 1 || y.some((N) => N.length > 0)) {
                F.__inJestEach = true;
                let N = g.map(l, "expressions");
                F.__inJestEach = false;
                let x = [], b = N.map((V) => "${" + p(V, Object.assign(Object.assign({}, F), {}, { printWidth: Number.POSITIVE_INFINITY, endOfLine: "lf" })).formatted + "}"), L = [{ hasLineBreak: false, cells: [] }];
                for (let V = 1; V < E.quasis.length; V++) {
                  let q = t3(L), Y = b[V - 1];
                  q.cells.push(Y), Y.includes(`
`) && (q.hasLineBreak = true), E.quasis[V].value.raw.includes(`
`) && L.push({ hasLineBreak: false, cells: [] });
                }
                let M = Math.max(y.length, ...L.map((V) => V.cells.length)), j = Array.from({ length: M }).fill(0), $ = [{ cells: y }, ...L.filter((V) => V.cells.length > 0)];
                for (let { cells: V } of $.filter((q) => !q.hasLineBreak))
                  for (let [q, Y] of V.entries())
                    j[q] = Math.max(j[q], s(Y));
                return x.push(m, "`", c([u, r(u, $.map((V) => r(" | ", V.cells.map((q, Y) => V.hasLineBreak ? q : q + " ".repeat(j[Y] - s(q))))))]), u, "`"), x;
              }
            }
            function k(g, F) {
              let l = g.getValue(), E = F();
              return A(l) && (E = o([c([i, E]), i])), ["${", E, m, "}"];
            }
            function P(g, F) {
              return g.map((l) => k(l, F), "expressions");
            }
            function C(g, F) {
              return f(g, (l) => typeof l == "string" ? F ? l.replace(/(\\*)`/g, "$1$1\\`") : D(l) : l);
            }
            function D(g) {
              return g.replace(/([\\`]|\${)/g, "\\$1");
            }
            n.exports = { printTemplateLiteral: B, printTemplateExpressions: P, escapeTemplateCharacters: C, uncookTemplateElementValue: D };
          } }), wm = Z({ "src/language-js/embed/markdown.js"(e, n) {
            "use strict";
            re();
            var { builders: { indent: t3, softline: s, literalline: a, dedentToRoot: r } } = Oe(), { escapeTemplateCharacters: u } = Lt();
            function i(c, v, m) {
              let p = c.getValue().quasis[0].value.raw.replace(/((?:\\\\)*)\\`/g, (T, A) => "\\".repeat(A.length / 2) + "`"), f = o(p), h = f !== "";
              h && (p = p.replace(new RegExp("^".concat(f), "gm"), ""));
              let w = u(m(p, { parser: "markdown", __inJsTemplate: true }, { stripTrailingHardline: true }), true);
              return ["`", h ? t3([s, w]) : [a, r(w)], s, "`"];
            }
            function o(c) {
              let v = c.match(/^([^\S\n]*)\S/m);
              return v === null ? "" : v[1];
            }
            n.exports = i;
          } }), _m = Z({ "src/language-js/embed/css.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3 } = Ue(), { builders: { indent: s, hardline: a, softline: r }, utils: { mapDoc: u, replaceEndOfLine: i, cleanDoc: o } } = Oe(), { printTemplateExpressions: c } = Lt();
            function v(p, f, h) {
              let w = p.getValue(), T = w.quasis.map((k) => k.value.raw), A = 0, S = T.reduce((k, P, C) => C === 0 ? P : k + "@prettier-placeholder-" + A++ + "-id" + P, ""), B = h(S, { parser: "scss" }, { stripTrailingHardline: true }), I = c(p, f);
              return m(B, w, I);
            }
            function m(p, f, h) {
              if (f.quasis.length === 1 && !f.quasis[0].value.raw.trim())
                return "``";
              let T = d(p, h);
              if (!T)
                throw new Error("Couldn't insert all the expressions");
              return ["`", s([a, T]), r, "`"];
            }
            function d(p, f) {
              if (!t3(f))
                return p;
              let h = 0, w = u(o(p), (T) => typeof T != "string" || !T.includes("@prettier-placeholder") ? T : T.split(/@prettier-placeholder-(\d+)-id/).map((A, S) => S % 2 === 0 ? i(A) : (h++, f[A])));
              return f.length === h ? w : null;
            }
            n.exports = v;
          } }), Pm = Z({ "src/language-js/embed/graphql.js"(e, n) {
            "use strict";
            re();
            var { builders: { indent: t3, join: s, hardline: a } } = Oe(), { escapeTemplateCharacters: r, printTemplateExpressions: u } = Lt();
            function i(c, v, m) {
              let d = c.getValue(), p = d.quasis.length;
              if (p === 1 && d.quasis[0].value.raw.trim() === "")
                return "``";
              let f = u(c, v), h = [];
              for (let w = 0; w < p; w++) {
                let T = d.quasis[w], A = w === 0, S = w === p - 1, B = T.value.cooked, I = B.split(`
`), k = I.length, P = f[w], C = k > 2 && I[0].trim() === "" && I[1].trim() === "", D = k > 2 && I[k - 1].trim() === "" && I[k - 2].trim() === "", g = I.every((l) => /^\s*(?:#[^\n\r]*)?$/.test(l));
                if (!S && /#[^\n\r]*$/.test(I[k - 1]))
                  return null;
                let F = null;
                g ? F = o(I) : F = m(B, { parser: "graphql" }, { stripTrailingHardline: true }), F ? (F = r(F, false), !A && C && h.push(""), h.push(F), !S && D && h.push("")) : !A && !S && C && h.push(""), P && h.push(P);
              }
              return ["`", t3([a, s(a, h)]), a, "`"];
            }
            function o(c) {
              let v = [], m = false, d = c.map((p) => p.trim());
              for (let [p, f] of d.entries())
                f !== "" && (d[p - 1] === "" && m ? v.push([a, f]) : v.push(f), m = true);
              return v.length === 0 ? null : s(a, v);
            }
            n.exports = i;
          } }), km = Z({ "src/language-js/embed/html.js"(e, n) {
            "use strict";
            re();
            var { builders: { indent: t3, line: s, hardline: a, group: r }, utils: { mapDoc: u } } = Oe(), { printTemplateExpressions: i, uncookTemplateElementValue: o } = Lt(), c = 0;
            function v(m, d, p, f, h) {
              let { parser: w } = h, T = m.getValue(), A = c;
              c = c + 1 >>> 0;
              let S = (E) => "PRETTIER_HTML_PLACEHOLDER_".concat(E, "_").concat(A, "_IN_JS"), B = T.quasis.map((E, y, N) => y === N.length - 1 ? E.value.cooked : E.value.cooked + S(y)).join(""), I = i(m, d);
              if (I.length === 0 && B.trim().length === 0)
                return "``";
              let k = new RegExp(S("(\\d+)"), "g"), P = 0, C = p(B, { parser: w, __onHtmlRoot(E) {
                P = E.children.length;
              } }, { stripTrailingHardline: true }), D = u(C, (E) => {
                if (typeof E != "string")
                  return E;
                let y = [], N = E.split(k);
                for (let x = 0; x < N.length; x++) {
                  let b = N[x];
                  if (x % 2 === 0) {
                    b && (b = o(b), f.__embeddedInHtml && (b = b.replace(/<\/(script)\b/gi, "<\\/$1")), y.push(b));
                    continue;
                  }
                  let L = Number(b);
                  y.push(I[L]);
                }
                return y;
              }), g = /^\s/.test(B) ? " " : "", F = /\s$/.test(B) ? " " : "", l = f.htmlWhitespaceSensitivity === "ignore" ? a : g && F ? s : null;
              return r(l ? ["`", t3([l, r(D)]), l, "`"] : ["`", g, P > 1 ? t3(r(D)) : r(D), F, "`"]);
            }
            n.exports = v;
          } }), Im = Z({ "src/language-js/embed.js"(e, n) {
            "use strict";
            re();
            var { hasComment: t3, CommentCheckFlags: s, isObjectProperty: a } = Ke(), r = wm(), u = _m(), i = Pm(), o = km();
            function c(C) {
              if (d(C) || w(C) || T(C) || p(C))
                return "css";
              if (B(C))
                return "graphql";
              if (k(C))
                return "html";
              if (f(C))
                return "angular";
              if (m(C))
                return "markdown";
            }
            function v(C, D, g, F) {
              let l = C.getValue();
              if (l.type !== "TemplateLiteral" || P(l))
                return;
              let E = c(C);
              if (!!E) {
                if (E === "markdown")
                  return r(C, D, g);
                if (E === "css")
                  return u(C, D, g);
                if (E === "graphql")
                  return i(C, D, g);
                if (E === "html" || E === "angular")
                  return o(C, D, g, F, { parser: E });
              }
            }
            function m(C) {
              let D = C.getValue(), g = C.getParentNode();
              return g && g.type === "TaggedTemplateExpression" && D.quasis.length === 1 && g.tag.type === "Identifier" && (g.tag.name === "md" || g.tag.name === "markdown");
            }
            function d(C) {
              let D = C.getValue(), g = C.getParentNode(), F = C.getParentNode(1);
              return F && D.quasis && g.type === "JSXExpressionContainer" && F.type === "JSXElement" && F.openingElement.name.name === "style" && F.openingElement.attributes.some((l) => l.name.name === "jsx") || g && g.type === "TaggedTemplateExpression" && g.tag.type === "Identifier" && g.tag.name === "css" || g && g.type === "TaggedTemplateExpression" && g.tag.type === "MemberExpression" && g.tag.object.name === "css" && (g.tag.property.name === "global" || g.tag.property.name === "resolve");
            }
            function p(C) {
              return C.match((D) => D.type === "TemplateLiteral", (D, g) => D.type === "ArrayExpression" && g === "elements", (D, g) => a(D) && D.key.type === "Identifier" && D.key.name === "styles" && g === "value", ...h);
            }
            function f(C) {
              return C.match((D) => D.type === "TemplateLiteral", (D, g) => a(D) && D.key.type === "Identifier" && D.key.name === "template" && g === "value", ...h);
            }
            var h = [(C, D) => C.type === "ObjectExpression" && D === "properties", (C, D) => C.type === "CallExpression" && C.callee.type === "Identifier" && C.callee.name === "Component" && D === "arguments", (C, D) => C.type === "Decorator" && D === "expression"];
            function w(C) {
              let D = C.getParentNode();
              if (!D || D.type !== "TaggedTemplateExpression")
                return false;
              let g = D.tag.type === "ParenthesizedExpression" ? D.tag.expression : D.tag;
              switch (g.type) {
                case "MemberExpression":
                  return A(g.object) || S(g);
                case "CallExpression":
                  return A(g.callee) || g.callee.type === "MemberExpression" && (g.callee.object.type === "MemberExpression" && (A(g.callee.object.object) || S(g.callee.object)) || g.callee.object.type === "CallExpression" && A(g.callee.object.callee));
                case "Identifier":
                  return g.name === "css";
                default:
                  return false;
              }
            }
            function T(C) {
              let D = C.getParentNode(), g = C.getParentNode(1);
              return g && D.type === "JSXExpressionContainer" && g.type === "JSXAttribute" && g.name.type === "JSXIdentifier" && g.name.name === "css";
            }
            function A(C) {
              return C.type === "Identifier" && C.name === "styled";
            }
            function S(C) {
              return /^[A-Z]/.test(C.object.name) && C.property.name === "extend";
            }
            function B(C) {
              let D = C.getValue(), g = C.getParentNode();
              return I(D, "GraphQL") || g && (g.type === "TaggedTemplateExpression" && (g.tag.type === "MemberExpression" && g.tag.object.name === "graphql" && g.tag.property.name === "experimental" || g.tag.type === "Identifier" && (g.tag.name === "gql" || g.tag.name === "graphql")) || g.type === "CallExpression" && g.callee.type === "Identifier" && g.callee.name === "graphql");
            }
            function I(C, D) {
              return t3(C, s.Block | s.Leading, (g) => {
                let { value: F } = g;
                return F === " ".concat(D, " ");
              });
            }
            function k(C) {
              return I(C.getValue(), "HTML") || C.match((D) => D.type === "TemplateLiteral", (D, g) => D.type === "TaggedTemplateExpression" && D.tag.type === "Identifier" && D.tag.name === "html" && g === "quasi");
            }
            function P(C) {
              let { quasis: D } = C;
              return D.some((g) => {
                let { value: { cooked: F } } = g;
                return F === null;
              });
            }
            n.exports = v;
          } }), Lm = Z({ "src/language-js/clean.js"(e, n) {
            "use strict";
            re();
            var t3 = It(), s = /* @__PURE__ */ new Set(["range", "raw", "comments", "leadingComments", "trailingComments", "innerComments", "extra", "start", "end", "loc", "flags", "errors", "tokens"]), a = (u) => {
              for (let i of u.quasis)
                delete i.value;
            };
            function r(u, i, o) {
              if (u.type === "Program" && delete i.sourceType, (u.type === "BigIntLiteral" || u.type === "BigIntLiteralTypeAnnotation") && i.value && (i.value = i.value.toLowerCase()), (u.type === "BigIntLiteral" || u.type === "Literal") && i.bigint && (i.bigint = i.bigint.toLowerCase()), u.type === "DecimalLiteral" && (i.value = Number(i.value)), u.type === "Literal" && i.decimal && (i.decimal = Number(i.decimal)), u.type === "EmptyStatement" || u.type === "JSXText" || u.type === "JSXExpressionContainer" && (u.expression.type === "Literal" || u.expression.type === "StringLiteral") && u.expression.value === " ")
                return null;
              if ((u.type === "Property" || u.type === "ObjectProperty" || u.type === "MethodDefinition" || u.type === "ClassProperty" || u.type === "ClassMethod" || u.type === "PropertyDefinition" || u.type === "TSDeclareMethod" || u.type === "TSPropertySignature" || u.type === "ObjectTypeProperty") && typeof u.key == "object" && u.key && (u.key.type === "Literal" || u.key.type === "NumericLiteral" || u.key.type === "StringLiteral" || u.key.type === "Identifier") && delete i.key, u.type === "JSXElement" && u.openingElement.name.name === "style" && u.openingElement.attributes.some((m) => m.name.name === "jsx"))
                for (let { type: m, expression: d } of i.children)
                  m === "JSXExpressionContainer" && d.type === "TemplateLiteral" && a(d);
              u.type === "JSXAttribute" && u.name.name === "css" && u.value.type === "JSXExpressionContainer" && u.value.expression.type === "TemplateLiteral" && a(i.value.expression), u.type === "JSXAttribute" && u.value && u.value.type === "Literal" && /["']|&quot;|&apos;/.test(u.value.value) && (i.value.value = i.value.value.replace(/["']|&quot;|&apos;/g, '"'));
              let c = u.expression || u.callee;
              if (u.type === "Decorator" && c.type === "CallExpression" && c.callee.name === "Component" && c.arguments.length === 1) {
                let m = u.expression.arguments[0].properties;
                for (let [d, p] of i.expression.arguments[0].properties.entries())
                  switch (m[d].key.name) {
                    case "styles":
                      p.value.type === "ArrayExpression" && a(p.value.elements[0]);
                      break;
                    case "template":
                      p.value.type === "TemplateLiteral" && a(p.value);
                      break;
                  }
              }
              if (u.type === "TaggedTemplateExpression" && (u.tag.type === "MemberExpression" || u.tag.type === "Identifier" && (u.tag.name === "gql" || u.tag.name === "graphql" || u.tag.name === "css" || u.tag.name === "md" || u.tag.name === "markdown" || u.tag.name === "html") || u.tag.type === "CallExpression") && a(i.quasi), u.type === "TemplateLiteral") {
                var v;
                (((v = u.leadingComments) === null || v === void 0 ? void 0 : v.some((d) => t3(d) && ["GraphQL", "HTML"].some((p) => d.value === " ".concat(p, " ")))) || o.type === "CallExpression" && o.callee.name === "graphql" || !u.leadingComments) && a(i);
              }
              if (u.type === "InterpreterDirective" && (i.value = i.value.trimEnd()), (u.type === "TSIntersectionType" || u.type === "TSUnionType") && u.types.length === 1)
                return i.types[0];
            }
            r.ignoredProperties = s, n.exports = r;
          } }), Ha = {};
          Ut(Ha, { EOL: () => Pn, arch: () => jm, cpus: () => Ya, default: () => ro, endianness: () => Ga, freemem: () => Xa, getNetworkInterfaces: () => to, hostname: () => Ja, loadavg: () => Ua, networkInterfaces: () => eo, platform: () => Om, release: () => Za, tmpDir: () => wn, tmpdir: () => _n, totalmem: () => Ka, type: () => Qa, uptime: () => za });
          function Ga() {
            if (typeof Sr > "u") {
              var e = new ArrayBuffer(2), n = new Uint8Array(e), t3 = new Uint16Array(e);
              if (n[0] = 1, n[1] = 2, t3[0] === 258)
                Sr = "BE";
              else if (t3[0] === 513)
                Sr = "LE";
              else
                throw new Error("unable to figure out endianess");
            }
            return Sr;
          }
          function Ja() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
          }
          function Ua() {
            return [];
          }
          function za() {
            return 0;
          }
          function Xa() {
            return Number.MAX_VALUE;
          }
          function Ka() {
            return Number.MAX_VALUE;
          }
          function Ya() {
            return [];
          }
          function Qa() {
            return "Browser";
          }
          function Za() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
          }
          function eo() {
          }
          function to() {
          }
          function jm() {
            return "javascript";
          }
          function Om() {
            return "browser";
          }
          function wn() {
            return "/tmp";
          }
          var Sr, _n, Pn, ro, qm = mt({ "node-modules-polyfills:os"() {
            re(), _n = wn, Pn = `
`, ro = { EOL: Pn, tmpdir: _n, tmpDir: wn, networkInterfaces: eo, getNetworkInterfaces: to, release: Za, type: Qa, cpus: Ya, totalmem: Ka, freemem: Xa, uptime: za, loadavg: Ua, hostname: Ja, endianness: Ga };
          } }), Mm = Z({ "node-modules-polyfills-commonjs:os"(e, n) {
            re();
            var t3 = (qm(), lt2(Ha));
            if (t3 && t3.default) {
              n.exports = t3.default;
              for (let s in t3)
                n.exports[s] = t3[s];
            } else
              t3 && (n.exports = t3);
          } }), Rm = Z({ "node_modules/detect-newline/index.js"(e, n) {
            "use strict";
            re();
            var t3 = (s) => {
              if (typeof s != "string")
                throw new TypeError("Expected a string");
              let a = s.match(/(?:\r?\n)/g) || [];
              if (a.length === 0)
                return;
              let r = a.filter((i) => i === `\r
`).length, u = a.length - r;
              return r > u ? `\r
` : `
`;
            };
            n.exports = t3, n.exports.graceful = (s) => typeof s == "string" && t3(s) || `
`;
          } }), Vm = Z({ "node_modules/jest-docblock/build/index.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.extract = p, e.parse = h, e.parseWithComments = w, e.print = T, e.strip = f;
            function n() {
              let S = Mm();
              return n = function() {
                return S;
              }, S;
            }
            function t3() {
              let S = s(Rm());
              return t3 = function() {
                return S;
              }, S;
            }
            function s(S) {
              return S && S.__esModule ? S : { default: S };
            }
            var a = /\*\/$/, r = /^\/\*\*/, u = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, i = /(^|\s+)\/\/([^\r\n]*)/g, o = /^(\r?\n)+/, c = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, v = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, m = /(\r?\n|^) *\* ?/g, d = [];
            function p(S) {
              let B = S.match(u);
              return B ? B[0].trimLeft() : "";
            }
            function f(S) {
              let B = S.match(u);
              return B && B[0] ? S.substring(B[0].length) : S;
            }
            function h(S) {
              return w(S).pragmas;
            }
            function w(S) {
              let B = (0, t3().default)(S) || n().EOL;
              S = S.replace(r, "").replace(a, "").replace(m, "$1");
              let I = "";
              for (; I !== S; )
                I = S, S = S.replace(c, "".concat(B, "$1 $2").concat(B));
              S = S.replace(o, "").trimRight();
              let k = /* @__PURE__ */ Object.create(null), P = S.replace(v, "").replace(o, "").trimRight(), C;
              for (; C = v.exec(S); ) {
                let D = C[2].replace(i, "");
                typeof k[C[1]] == "string" || Array.isArray(k[C[1]]) ? k[C[1]] = d.concat(k[C[1]], D) : k[C[1]] = D;
              }
              return { comments: P, pragmas: k };
            }
            function T(S) {
              let { comments: B = "", pragmas: I = {} } = S, k = (0, t3().default)(B) || n().EOL, P = "/**", C = " *", D = " */", g = Object.keys(I), F = g.map((E) => A(E, I[E])).reduce((E, y) => E.concat(y), []).map((E) => C + " " + E + k).join("");
              if (!B) {
                if (g.length === 0)
                  return "";
                if (g.length === 1 && !Array.isArray(I[g[0]])) {
                  let E = I[g[0]];
                  return "".concat(P, " ").concat(A(g[0], E)[0]).concat(D);
                }
              }
              let l = B.split(k).map((E) => "".concat(C, " ").concat(E)).join(k) + k;
              return P + k + (B ? l : "") + (B && g.length ? C + k : "") + F + D;
            }
            function A(S, B) {
              return d.concat(B).map((I) => "@".concat(S, " ").concat(I).trim());
            }
          } }), Wm = Z({ "src/language-js/utils/get-shebang.js"(e, n) {
            "use strict";
            re();
            function t3(s) {
              if (!s.startsWith("#!"))
                return "";
              let a = s.indexOf(`
`);
              return a === -1 ? s : s.slice(0, a);
            }
            n.exports = t3;
          } }), no = Z({ "src/language-js/pragma.js"(e, n) {
            "use strict";
            re();
            var { parseWithComments: t3, strip: s, extract: a, print: r } = Vm(), { normalizeEndOfLine: u } = jn(), i = Wm();
            function o(m) {
              let d = i(m);
              d && (m = m.slice(d.length + 1));
              let p = a(m), { pragmas: f, comments: h } = t3(p);
              return { shebang: d, text: m, pragmas: f, comments: h };
            }
            function c(m) {
              let d = Object.keys(o(m).pragmas);
              return d.includes("prettier") || d.includes("format");
            }
            function v(m) {
              let { shebang: d, text: p, pragmas: f, comments: h } = o(m), w = s(p), T = r({ pragmas: Object.assign({ format: "" }, f), comments: h.trimStart() });
              return (d ? "".concat(d, `
`) : "") + u(T) + (w.startsWith(`
`) ? `
` : `

`) + w;
            }
            n.exports = { hasPragma: c, insertPragma: v };
          } }), uo = Z({ "src/language-js/comments.js"(e, n) {
            "use strict";
            re();
            var { getLast: t3, hasNewline: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: a, getNextNonSpaceNonCommentCharacter: r, hasNewlineInRange: u, addLeadingComment: i, addTrailingComment: o, addDanglingComment: c, getNextNonSpaceNonCommentCharacterIndex: v, isNonEmptyArray: m } = Ue(), { getFunctionParameters: d, isPrettierIgnoreComment: p, isJsxNode: f, hasFlowShorthandAnnotationComment: h, hasFlowAnnotationComment: w, hasIgnoreComment: T, isCallLikeExpression: A, getCallArguments: S, isCallExpression: B, isMemberExpression: I, isObjectProperty: k, isLineComment: P, getComments: C, CommentCheckFlags: D, markerForIfWithoutBlockAndSameLineComment: g } = Ke(), { locStart: F, locEnd: l } = st(), E = It();
            function y(me) {
              return [ve, De, q, j, $, V, Q, Ae, U, ge, Ne, ke, te, ie, G].some((_) => _(me));
            }
            function N(me) {
              return [M, De, Y, Ne, j, $, V, Q, ie, z, le, ge, de, G, he].some((_) => _(me));
            }
            function x(me) {
              return [ve, j, $, H, ue, te, ge, X, W, K, G, ae].some((_) => _(me));
            }
            function b(me, _) {
              let J = (me.body || me.properties).find((ne) => {
                let { type: Ee } = ne;
                return Ee !== "EmptyStatement";
              });
              J ? i(J, _) : c(me, _);
            }
            function L(me, _) {
              me.type === "BlockStatement" ? b(me, _) : i(me, _);
            }
            function M(me) {
              let { comment: _, followingNode: J } = me;
              return J && Ie(_) ? (i(J, _), true) : false;
            }
            function j(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, followingNode: Ee, text: We } = me;
              if ((ne == null ? void 0 : ne.type) !== "IfStatement" || !Ee)
                return false;
              if (r(We, _, l) === ")")
                return o(J, _), true;
              if (J === ne.consequent && Ee === ne.alternate) {
                if (J.type === "BlockStatement")
                  o(J, _);
                else {
                  let Pe = _.type === "SingleLine" || _.loc.start.line === _.loc.end.line, Se = _.loc.start.line === J.loc.start.line;
                  Pe && Se ? c(J, _, g) : c(ne, _);
                }
                return true;
              }
              return Ee.type === "BlockStatement" ? (b(Ee, _), true) : Ee.type === "IfStatement" ? (L(Ee.consequent, _), true) : ne.consequent === Ee ? (i(Ee, _), true) : false;
            }
            function $(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, followingNode: Ee, text: We } = me;
              return (ne == null ? void 0 : ne.type) !== "WhileStatement" || !Ee ? false : r(We, _, l) === ")" ? (o(J, _), true) : Ee.type === "BlockStatement" ? (b(Ee, _), true) : ne.body === Ee ? (i(Ee, _), true) : false;
            }
            function V(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, followingNode: Ee } = me;
              return (ne == null ? void 0 : ne.type) !== "TryStatement" && (ne == null ? void 0 : ne.type) !== "CatchClause" || !Ee ? false : ne.type === "CatchClause" && J ? (o(J, _), true) : Ee.type === "BlockStatement" ? (b(Ee, _), true) : Ee.type === "TryStatement" ? (L(Ee.finalizer, _), true) : Ee.type === "CatchClause" ? (L(Ee.body, _), true) : false;
            }
            function q(me) {
              let { comment: _, enclosingNode: J, followingNode: ne } = me;
              return I(J) && (ne == null ? void 0 : ne.type) === "Identifier" ? (i(J, _), true) : false;
            }
            function Y(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, followingNode: Ee, text: We } = me, Be = J && !u(We, l(J), F(_));
              return (!J || !Be) && ((ne == null ? void 0 : ne.type) === "ConditionalExpression" || (ne == null ? void 0 : ne.type) === "TSConditionalType") && Ee ? (i(Ee, _), true) : false;
            }
            function H(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne } = me;
              return k(ne) && ne.shorthand && ne.key === J && ne.value.type === "AssignmentPattern" ? (o(ne.value.left, _), true) : false;
            }
            var R = /* @__PURE__ */ new Set(["ClassDeclaration", "ClassExpression", "DeclareClass", "DeclareInterface", "InterfaceDeclaration", "TSInterfaceDeclaration"]);
            function Q(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, followingNode: Ee } = me;
              if (R.has(ne == null ? void 0 : ne.type)) {
                if (m(ne.decorators) && !(Ee && Ee.type === "Decorator"))
                  return o(t3(ne.decorators), _), true;
                if (ne.body && Ee === ne.body)
                  return b(ne.body, _), true;
                if (Ee) {
                  if (ne.superClass && Ee === ne.superClass && J && (J === ne.id || J === ne.typeParameters))
                    return o(J, _), true;
                  for (let We of ["implements", "extends", "mixins"])
                    if (ne[We] && Ee === ne[We][0])
                      return J && (J === ne.id || J === ne.typeParameters || J === ne.superClass) ? o(J, _) : c(ne, _, We), true;
                }
              }
              return false;
            }
            var ee = /* @__PURE__ */ new Set(["ClassMethod", "ClassProperty", "PropertyDefinition", "TSAbstractPropertyDefinition", "TSAbstractMethodDefinition", "TSDeclareMethod", "MethodDefinition"]);
            function te(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, text: Ee } = me;
              return ne && J && r(Ee, _, l) === "(" && (ne.type === "Property" || ne.type === "TSDeclareMethod" || ne.type === "TSAbstractMethodDefinition") && J.type === "Identifier" && ne.key === J && r(Ee, J, l) !== ":" || (J == null ? void 0 : J.type) === "Decorator" && ee.has(ne == null ? void 0 : ne.type) ? (o(J, _), true) : false;
            }
            var oe = /* @__PURE__ */ new Set(["FunctionDeclaration", "FunctionExpression", "ClassMethod", "MethodDefinition", "ObjectMethod"]);
            function W(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, text: Ee } = me;
              return r(Ee, _, l) !== "(" ? false : J && oe.has(ne == null ? void 0 : ne.type) ? (o(J, _), true) : false;
            }
            function X(me) {
              let { comment: _, enclosingNode: J, text: ne } = me;
              if ((J == null ? void 0 : J.type) !== "ArrowFunctionExpression")
                return false;
              let Ee = v(ne, _, l);
              return Ee !== false && ne.slice(Ee, Ee + 2) === "=>" ? (c(J, _), true) : false;
            }
            function ue(me) {
              let { comment: _, enclosingNode: J, text: ne } = me;
              return r(ne, _, l) !== ")" ? false : J && (ye(J) && d(J).length === 0 || A(J) && S(J).length === 0) ? (c(J, _), true) : ((J == null ? void 0 : J.type) === "MethodDefinition" || (J == null ? void 0 : J.type) === "TSAbstractMethodDefinition") && d(J.value).length === 0 ? (c(J.value, _), true) : false;
            }
            function De(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, followingNode: Ee, text: We } = me;
              if ((J == null ? void 0 : J.type) === "FunctionTypeParam" && (ne == null ? void 0 : ne.type) === "FunctionTypeAnnotation" && (Ee == null ? void 0 : Ee.type) !== "FunctionTypeParam" || ((J == null ? void 0 : J.type) === "Identifier" || (J == null ? void 0 : J.type) === "AssignmentPattern") && ne && ye(ne) && r(We, _, l) === ")")
                return o(J, _), true;
              if ((ne == null ? void 0 : ne.type) === "FunctionDeclaration" && (Ee == null ? void 0 : Ee.type) === "BlockStatement") {
                let Be = (() => {
                  let Pe = d(ne);
                  if (Pe.length > 0)
                    return a(We, l(t3(Pe)));
                  let Se = a(We, l(ne.id));
                  return Se !== false && a(We, Se + 1);
                })();
                if (F(_) > Be)
                  return b(Ee, _), true;
              }
              return false;
            }
            function ie(me) {
              let { comment: _, enclosingNode: J } = me;
              return (J == null ? void 0 : J.type) === "LabeledStatement" ? (i(J, _), true) : false;
            }
            function G(me) {
              let { comment: _, enclosingNode: J } = me;
              return ((J == null ? void 0 : J.type) === "ContinueStatement" || (J == null ? void 0 : J.type) === "BreakStatement") && !J.label ? (o(J, _), true) : false;
            }
            function z(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne } = me;
              return B(ne) && J && ne.callee === J && ne.arguments.length > 0 ? (i(ne.arguments[0], _), true) : false;
            }
            function U(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, followingNode: Ee } = me;
              return (ne == null ? void 0 : ne.type) === "UnionTypeAnnotation" || (ne == null ? void 0 : ne.type) === "TSUnionType" ? (p(_) && (Ee.prettierIgnore = true, _.unignore = true), J ? (o(J, _), true) : false) : (((Ee == null ? void 0 : Ee.type) === "UnionTypeAnnotation" || (Ee == null ? void 0 : Ee.type) === "TSUnionType") && p(_) && (Ee.types[0].prettierIgnore = true, _.unignore = true), false);
            }
            function le(me) {
              let { comment: _, enclosingNode: J } = me;
              return k(J) ? (i(J, _), true) : false;
            }
            function ge(me) {
              let { comment: _, enclosingNode: J, followingNode: ne, ast: Ee, isLastComment: We } = me;
              return Ee && Ee.body && Ee.body.length === 0 ? (We ? c(Ee, _) : i(Ee, _), true) : (J == null ? void 0 : J.type) === "Program" && (J == null ? void 0 : J.body.length) === 0 && !m(J.directives) ? (We ? c(J, _) : i(J, _), true) : (ne == null ? void 0 : ne.type) === "Program" && (ne == null ? void 0 : ne.body.length) === 0 && (J == null ? void 0 : J.type) === "ModuleExpression" ? (c(ne, _), true) : false;
            }
            function Ae(me) {
              let { comment: _, enclosingNode: J } = me;
              return (J == null ? void 0 : J.type) === "ForInStatement" || (J == null ? void 0 : J.type) === "ForOfStatement" ? (i(J, _), true) : false;
            }
            function Ne(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, text: Ee } = me;
              if ((ne == null ? void 0 : ne.type) === "ImportSpecifier" || (ne == null ? void 0 : ne.type) === "ExportSpecifier")
                return i(ne, _), true;
              let We = (J == null ? void 0 : J.type) === "ImportSpecifier" && (ne == null ? void 0 : ne.type) === "ImportDeclaration", Be = (J == null ? void 0 : J.type) === "ExportSpecifier" && (ne == null ? void 0 : ne.type) === "ExportNamedDeclaration";
              return (We || Be) && s(Ee, l(_)) ? (o(J, _), true) : false;
            }
            function ke(me) {
              let { comment: _, enclosingNode: J } = me;
              return (J == null ? void 0 : J.type) === "AssignmentPattern" ? (i(J, _), true) : false;
            }
            var ce = /* @__PURE__ */ new Set(["VariableDeclarator", "AssignmentExpression", "TypeAlias", "TSTypeAliasDeclaration"]), pe = /* @__PURE__ */ new Set(["ObjectExpression", "ArrayExpression", "TemplateLiteral", "TaggedTemplateExpression", "ObjectTypeAnnotation", "TSTypeLiteral"]);
            function de(me) {
              let { comment: _, enclosingNode: J, followingNode: ne } = me;
              return ce.has(J == null ? void 0 : J.type) && ne && (pe.has(ne.type) || E(_)) ? (i(ne, _), true) : false;
            }
            function ae(me) {
              let { comment: _, enclosingNode: J, followingNode: ne, text: Ee } = me;
              return !ne && ((J == null ? void 0 : J.type) === "TSMethodSignature" || (J == null ? void 0 : J.type) === "TSDeclareFunction" || (J == null ? void 0 : J.type) === "TSAbstractMethodDefinition") && r(Ee, _, l) === ";" ? (o(J, _), true) : false;
            }
            function ve(me) {
              let { comment: _, enclosingNode: J, followingNode: ne } = me;
              if (p(_) && (J == null ? void 0 : J.type) === "TSMappedType" && (ne == null ? void 0 : ne.type) === "TSTypeParameter" && ne.constraint)
                return J.prettierIgnore = true, _.unignore = true, true;
            }
            function K(me) {
              let { comment: _, precedingNode: J, enclosingNode: ne, followingNode: Ee } = me;
              return (ne == null ? void 0 : ne.type) !== "TSMappedType" ? false : (Ee == null ? void 0 : Ee.type) === "TSTypeParameter" && Ee.name ? (i(Ee.name, _), true) : (J == null ? void 0 : J.type) === "TSTypeParameter" && J.constraint ? (o(J.constraint, _), true) : false;
            }
            function he(me) {
              let { comment: _, enclosingNode: J, followingNode: ne } = me;
              return !J || J.type !== "SwitchCase" || J.test ? false : (ne.type === "BlockStatement" && P(_) ? b(ne, _) : c(J, _), true);
            }
            function ye(me) {
              return me.type === "ArrowFunctionExpression" || me.type === "FunctionExpression" || me.type === "FunctionDeclaration" || me.type === "ObjectMethod" || me.type === "ClassMethod" || me.type === "TSDeclareFunction" || me.type === "TSCallSignatureDeclaration" || me.type === "TSConstructSignatureDeclaration" || me.type === "TSMethodSignature" || me.type === "TSConstructorType" || me.type === "TSFunctionType" || me.type === "TSDeclareMethod";
            }
            function Ce(me, _) {
              if ((_.parser === "typescript" || _.parser === "flow" || _.parser === "acorn" || _.parser === "espree" || _.parser === "meriyah" || _.parser === "__babel_estree") && me.type === "MethodDefinition" && me.value && me.value.type === "FunctionExpression" && d(me.value).length === 0 && !me.value.returnType && !m(me.value.typeParameters) && me.value.body)
                return [...me.decorators || [], me.key, me.value.body];
            }
            function Ie(me) {
              return E(me) && me.value[0] === "*" && /@type\b/.test(me.value);
            }
            function Fe(me) {
              let _ = me.getValue(), J = me.getParentNode(), ne = (Ee) => w(C(Ee, D.Leading)) || w(C(Ee, D.Trailing));
              return (_ && (f(_) || h(_) || B(J) && ne(_)) || J && (J.type === "JSXSpreadAttribute" || J.type === "JSXSpreadChild" || J.type === "UnionTypeAnnotation" || J.type === "TSUnionType" || (J.type === "ClassDeclaration" || J.type === "ClassExpression") && J.superClass === _)) && (!T(me) || J.type === "UnionTypeAnnotation" || J.type === "TSUnionType");
            }
            n.exports = { handleOwnLineComment: y, handleEndOfLineComment: N, handleRemainingComment: x, isTypeCastComment: Ie, getCommentChildNodes: Ce, willPrintOwnComments: Fe };
          } }), jt = Z({ "src/language-js/needs-parens.js"(e, n) {
            "use strict";
            re();
            var t3 = it(), s = Rn(), { getFunctionParameters: a, getLeftSidePathName: r, hasFlowShorthandAnnotationComment: u, hasNakedLeftSide: i, hasNode: o, isBitwiseOperator: c, startsWithNoLookaheadToken: v, shouldFlatten: m, getPrecedence: d, isCallExpression: p, isMemberExpression: f, isObjectProperty: h } = Ke();
            function w(P, C) {
              let D = P.getParentNode();
              if (!D)
                return false;
              let g = P.getName(), F = P.getNode();
              if (C.__isInHtmlInterpolation && !C.bracketSpacing && B(F) && I(P))
                return true;
              if (T(F))
                return false;
              if (C.parser !== "flow" && u(P.getValue()))
                return true;
              if (F.type === "Identifier")
                return !!(F.extra && F.extra.parenthesized && /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(F.name) || g === "left" && F.name === "async" && D.type === "ForOfStatement" && !D.await);
              switch (D.type) {
                case "ParenthesizedExpression":
                  return false;
                case "ClassDeclaration":
                case "ClassExpression": {
                  if (g === "superClass" && (F.type === "ArrowFunctionExpression" || F.type === "AssignmentExpression" || F.type === "AwaitExpression" || F.type === "BinaryExpression" || F.type === "ConditionalExpression" || F.type === "LogicalExpression" || F.type === "NewExpression" || F.type === "ObjectExpression" || F.type === "SequenceExpression" || F.type === "TaggedTemplateExpression" || F.type === "UnaryExpression" || F.type === "UpdateExpression" || F.type === "YieldExpression" || F.type === "TSNonNullExpression"))
                    return true;
                  break;
                }
                case "ExportDefaultDeclaration":
                  return k(P, C) || F.type === "SequenceExpression";
                case "Decorator": {
                  if (g === "expression") {
                    let l = false, E = false, y = F;
                    for (; y; )
                      switch (y.type) {
                        case "MemberExpression":
                          E = true, y = y.object;
                          break;
                        case "CallExpression":
                          if (E || l)
                            return C.parser !== "typescript";
                          l = true, y = y.callee;
                          break;
                        case "Identifier":
                          return false;
                        case "TaggedTemplateExpression":
                          return C.parser !== "typescript";
                        default:
                          return true;
                      }
                    return true;
                  }
                  break;
                }
                case "ExpressionStatement": {
                  if (v(F, true))
                    return true;
                  break;
                }
                case "ArrowFunctionExpression": {
                  if (g === "body" && F.type !== "SequenceExpression" && v(F, false))
                    return true;
                  break;
                }
              }
              switch (F.type) {
                case "UpdateExpression":
                  if (D.type === "UnaryExpression")
                    return F.prefix && (F.operator === "++" && D.operator === "+" || F.operator === "--" && D.operator === "-");
                case "UnaryExpression":
                  switch (D.type) {
                    case "UnaryExpression":
                      return F.operator === D.operator && (F.operator === "+" || F.operator === "-");
                    case "BindExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return g === "object";
                    case "TaggedTemplateExpression":
                      return true;
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return g === "callee";
                    case "BinaryExpression":
                      return g === "left" && D.operator === "**";
                    case "TSNonNullExpression":
                      return true;
                    default:
                      return false;
                  }
                case "BinaryExpression": {
                  if (D.type === "UpdateExpression" || F.operator === "in" && A(P))
                    return true;
                  if (F.operator === "|>" && F.extra && F.extra.parenthesized) {
                    let l = P.getParentNode(1);
                    if (l.type === "BinaryExpression" && l.operator === "|>")
                      return true;
                  }
                }
                case "TSTypeAssertion":
                case "TSAsExpression":
                case "LogicalExpression":
                  switch (D.type) {
                    case "TSAsExpression":
                      return F.type !== "TSAsExpression";
                    case "ConditionalExpression":
                      return F.type === "TSAsExpression";
                    case "CallExpression":
                    case "NewExpression":
                    case "OptionalCallExpression":
                      return g === "callee";
                    case "ClassExpression":
                    case "ClassDeclaration":
                      return g === "superClass";
                    case "TSTypeAssertion":
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "JSXSpreadAttribute":
                    case "SpreadElement":
                    case "SpreadProperty":
                    case "BindExpression":
                    case "AwaitExpression":
                    case "TSNonNullExpression":
                    case "UpdateExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return g === "object";
                    case "AssignmentExpression":
                    case "AssignmentPattern":
                      return g === "left" && (F.type === "TSTypeAssertion" || F.type === "TSAsExpression");
                    case "LogicalExpression":
                      if (F.type === "LogicalExpression")
                        return D.operator !== F.operator;
                    case "BinaryExpression": {
                      let { operator: l, type: E } = F;
                      if (!l && E !== "TSTypeAssertion")
                        return true;
                      let y = d(l), N = D.operator, x = d(N);
                      return x > y || g === "right" && x === y || x === y && !m(N, l) ? true : x < y && l === "%" ? N === "+" || N === "-" : !!c(N);
                    }
                    default:
                      return false;
                  }
                case "SequenceExpression":
                  switch (D.type) {
                    case "ReturnStatement":
                      return false;
                    case "ForStatement":
                      return false;
                    case "ExpressionStatement":
                      return g !== "expression";
                    case "ArrowFunctionExpression":
                      return g !== "body";
                    default:
                      return true;
                  }
                case "YieldExpression":
                  if (D.type === "UnaryExpression" || D.type === "AwaitExpression" || D.type === "TSAsExpression" || D.type === "TSNonNullExpression")
                    return true;
                case "AwaitExpression":
                  switch (D.type) {
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "LogicalExpression":
                    case "SpreadElement":
                    case "SpreadProperty":
                    case "TSAsExpression":
                    case "TSNonNullExpression":
                    case "BindExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return g === "object";
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return g === "callee";
                    case "ConditionalExpression":
                      return g === "test";
                    case "BinaryExpression":
                      return !(!F.argument && D.operator === "|>");
                    default:
                      return false;
                  }
                case "TSConditionalType":
                  if (g === "extendsType" && D.type === "TSConditionalType")
                    return true;
                case "TSFunctionType":
                case "TSConstructorType":
                  if (g === "checkType" && D.type === "TSConditionalType")
                    return true;
                case "TSUnionType":
                case "TSIntersectionType":
                  if ((D.type === "TSUnionType" || D.type === "TSIntersectionType") && D.types.length > 1 && (!F.types || F.types.length > 1))
                    return true;
                case "TSInferType":
                  if (F.type === "TSInferType" && D.type === "TSRestType")
                    return false;
                case "TSTypeOperator":
                  return D.type === "TSArrayType" || D.type === "TSOptionalType" || D.type === "TSRestType" || g === "objectType" && D.type === "TSIndexedAccessType" || D.type === "TSTypeOperator" || D.type === "TSTypeAnnotation" && P.getParentNode(1).type.startsWith("TSJSDoc");
                case "ArrayTypeAnnotation":
                  return D.type === "NullableTypeAnnotation";
                case "IntersectionTypeAnnotation":
                case "UnionTypeAnnotation":
                  return D.type === "ArrayTypeAnnotation" || D.type === "NullableTypeAnnotation" || D.type === "IntersectionTypeAnnotation" || D.type === "UnionTypeAnnotation" || g === "objectType" && (D.type === "IndexedAccessType" || D.type === "OptionalIndexedAccessType");
                case "NullableTypeAnnotation":
                  return D.type === "ArrayTypeAnnotation" || g === "objectType" && (D.type === "IndexedAccessType" || D.type === "OptionalIndexedAccessType");
                case "FunctionTypeAnnotation": {
                  let l = D.type === "NullableTypeAnnotation" ? P.getParentNode(1) : D;
                  return l.type === "UnionTypeAnnotation" || l.type === "IntersectionTypeAnnotation" || l.type === "ArrayTypeAnnotation" || g === "objectType" && (l.type === "IndexedAccessType" || l.type === "OptionalIndexedAccessType") || l.type === "NullableTypeAnnotation" || D.type === "FunctionTypeParam" && D.name === null && a(F).some((E) => E.typeAnnotation && E.typeAnnotation.type === "NullableTypeAnnotation");
                }
                case "OptionalIndexedAccessType":
                  return g === "objectType" && D.type === "IndexedAccessType";
                case "TypeofTypeAnnotation":
                  return g === "objectType" && (D.type === "IndexedAccessType" || D.type === "OptionalIndexedAccessType");
                case "StringLiteral":
                case "NumericLiteral":
                case "Literal":
                  if (typeof F.value == "string" && D.type === "ExpressionStatement" && !D.directive) {
                    let l = P.getParentNode(1);
                    return l.type === "Program" || l.type === "BlockStatement";
                  }
                  return g === "object" && D.type === "MemberExpression" && typeof F.value == "number";
                case "AssignmentExpression": {
                  let l = P.getParentNode(1);
                  return g === "body" && D.type === "ArrowFunctionExpression" ? true : g === "key" && (D.type === "ClassProperty" || D.type === "PropertyDefinition") && D.computed || (g === "init" || g === "update") && D.type === "ForStatement" ? false : D.type === "ExpressionStatement" ? F.left.type === "ObjectPattern" : !(g === "key" && D.type === "TSPropertySignature" || D.type === "AssignmentExpression" || D.type === "SequenceExpression" && l && l.type === "ForStatement" && (l.init === D || l.update === D) || g === "value" && D.type === "Property" && l && l.type === "ObjectPattern" && l.properties.includes(D) || D.type === "NGChainedExpression");
                }
                case "ConditionalExpression":
                  switch (D.type) {
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "SpreadElement":
                    case "SpreadProperty":
                    case "BinaryExpression":
                    case "LogicalExpression":
                    case "NGPipeExpression":
                    case "ExportDefaultDeclaration":
                    case "AwaitExpression":
                    case "JSXSpreadAttribute":
                    case "TSTypeAssertion":
                    case "TypeCastExpression":
                    case "TSAsExpression":
                    case "TSNonNullExpression":
                      return true;
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return g === "callee";
                    case "ConditionalExpression":
                      return g === "test";
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return g === "object";
                    default:
                      return false;
                  }
                case "FunctionExpression":
                  switch (D.type) {
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return g === "callee";
                    case "TaggedTemplateExpression":
                      return true;
                    default:
                      return false;
                  }
                case "ArrowFunctionExpression":
                  switch (D.type) {
                    case "BinaryExpression":
                      return D.operator !== "|>" || F.extra && F.extra.parenthesized;
                    case "NewExpression":
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return g === "callee";
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                      return g === "object";
                    case "TSAsExpression":
                    case "TSNonNullExpression":
                    case "BindExpression":
                    case "TaggedTemplateExpression":
                    case "UnaryExpression":
                    case "LogicalExpression":
                    case "AwaitExpression":
                    case "TSTypeAssertion":
                      return true;
                    case "ConditionalExpression":
                      return g === "test";
                    default:
                      return false;
                  }
                case "ClassExpression":
                  if (s(F.decorators))
                    return true;
                  switch (D.type) {
                    case "NewExpression":
                      return g === "callee";
                    default:
                      return false;
                  }
                case "OptionalMemberExpression":
                case "OptionalCallExpression": {
                  let l = P.getParentNode(1);
                  if (g === "object" && D.type === "MemberExpression" || g === "callee" && (D.type === "CallExpression" || D.type === "NewExpression") || D.type === "TSNonNullExpression" && l.type === "MemberExpression" && l.object === D)
                    return true;
                }
                case "CallExpression":
                case "MemberExpression":
                case "TaggedTemplateExpression":
                case "TSNonNullExpression":
                  if (g === "callee" && (D.type === "BindExpression" || D.type === "NewExpression")) {
                    let l = F;
                    for (; l; )
                      switch (l.type) {
                        case "CallExpression":
                        case "OptionalCallExpression":
                          return true;
                        case "MemberExpression":
                        case "OptionalMemberExpression":
                        case "BindExpression":
                          l = l.object;
                          break;
                        case "TaggedTemplateExpression":
                          l = l.tag;
                          break;
                        case "TSNonNullExpression":
                          l = l.expression;
                          break;
                        default:
                          return false;
                      }
                  }
                  return false;
                case "BindExpression":
                  return g === "callee" && (D.type === "BindExpression" || D.type === "NewExpression") || g === "object" && f(D);
                case "NGPipeExpression":
                  return !(D.type === "NGRoot" || D.type === "NGMicrosyntaxExpression" || D.type === "ObjectProperty" && !(F.extra && F.extra.parenthesized) || D.type === "ArrayExpression" || p(D) && D.arguments[g] === F || g === "right" && D.type === "NGPipeExpression" || g === "property" && D.type === "MemberExpression" || D.type === "AssignmentExpression");
                case "JSXFragment":
                case "JSXElement":
                  return g === "callee" || g === "left" && D.type === "BinaryExpression" && D.operator === "<" || D.type !== "ArrayExpression" && D.type !== "ArrowFunctionExpression" && D.type !== "AssignmentExpression" && D.type !== "AssignmentPattern" && D.type !== "BinaryExpression" && D.type !== "NewExpression" && D.type !== "ConditionalExpression" && D.type !== "ExpressionStatement" && D.type !== "JsExpressionRoot" && D.type !== "JSXAttribute" && D.type !== "JSXElement" && D.type !== "JSXExpressionContainer" && D.type !== "JSXFragment" && D.type !== "LogicalExpression" && !p(D) && !h(D) && D.type !== "ReturnStatement" && D.type !== "ThrowStatement" && D.type !== "TypeCastExpression" && D.type !== "VariableDeclarator" && D.type !== "YieldExpression";
                case "TypeAnnotation":
                  return g === "returnType" && D.type === "ArrowFunctionExpression" && S(F);
              }
              return false;
            }
            function T(P) {
              return P.type === "BlockStatement" || P.type === "BreakStatement" || P.type === "ClassBody" || P.type === "ClassDeclaration" || P.type === "ClassMethod" || P.type === "ClassProperty" || P.type === "PropertyDefinition" || P.type === "ClassPrivateProperty" || P.type === "ContinueStatement" || P.type === "DebuggerStatement" || P.type === "DeclareClass" || P.type === "DeclareExportAllDeclaration" || P.type === "DeclareExportDeclaration" || P.type === "DeclareFunction" || P.type === "DeclareInterface" || P.type === "DeclareModule" || P.type === "DeclareModuleExports" || P.type === "DeclareVariable" || P.type === "DoWhileStatement" || P.type === "EnumDeclaration" || P.type === "ExportAllDeclaration" || P.type === "ExportDefaultDeclaration" || P.type === "ExportNamedDeclaration" || P.type === "ExpressionStatement" || P.type === "ForInStatement" || P.type === "ForOfStatement" || P.type === "ForStatement" || P.type === "FunctionDeclaration" || P.type === "IfStatement" || P.type === "ImportDeclaration" || P.type === "InterfaceDeclaration" || P.type === "LabeledStatement" || P.type === "MethodDefinition" || P.type === "ReturnStatement" || P.type === "SwitchStatement" || P.type === "ThrowStatement" || P.type === "TryStatement" || P.type === "TSDeclareFunction" || P.type === "TSEnumDeclaration" || P.type === "TSImportEqualsDeclaration" || P.type === "TSInterfaceDeclaration" || P.type === "TSModuleDeclaration" || P.type === "TSNamespaceExportDeclaration" || P.type === "TypeAlias" || P.type === "VariableDeclaration" || P.type === "WhileStatement" || P.type === "WithStatement";
            }
            function A(P) {
              let C = 0, D = P.getValue();
              for (; D; ) {
                let g = P.getParentNode(C++);
                if (g && g.type === "ForStatement" && g.init === D)
                  return true;
                D = g;
              }
              return false;
            }
            function S(P) {
              return o(P, (C) => C.type === "ObjectTypeAnnotation" && o(C, (D) => D.type === "FunctionTypeAnnotation" || void 0) || void 0);
            }
            function B(P) {
              switch (P.type) {
                case "ObjectExpression":
                  return true;
                default:
                  return false;
              }
            }
            function I(P) {
              let C = P.getValue(), D = P.getParentNode(), g = P.getName();
              switch (D.type) {
                case "NGPipeExpression":
                  if (typeof g == "number" && D.arguments[g] === C && D.arguments.length - 1 === g)
                    return P.callParent(I);
                  break;
                case "ObjectProperty":
                  if (g === "value") {
                    let F = P.getParentNode(1);
                    return t3(F.properties) === D;
                  }
                  break;
                case "BinaryExpression":
                case "LogicalExpression":
                  if (g === "right")
                    return P.callParent(I);
                  break;
                case "ConditionalExpression":
                  if (g === "alternate")
                    return P.callParent(I);
                  break;
                case "UnaryExpression":
                  if (D.prefix)
                    return P.callParent(I);
                  break;
              }
              return false;
            }
            function k(P, C) {
              let D = P.getValue(), g = P.getParentNode();
              return D.type === "FunctionExpression" || D.type === "ClassExpression" ? g.type === "ExportDefaultDeclaration" || !w(P, C) : !i(D) || g.type !== "ExportDefaultDeclaration" && w(P, C) ? false : P.call((F) => k(F, C), ...r(P, D));
            }
            n.exports = w;
          } }), so = Z({ "src/language-js/print-preprocess.js"(e, n) {
            "use strict";
            re();
            function t3(s, a) {
              switch (a.parser) {
                case "json":
                case "json5":
                case "json-stringify":
                case "__js_expression":
                case "__vue_expression":
                case "__vue_ts_expression":
                  return Object.assign(Object.assign({}, s), {}, { type: a.parser.startsWith("__") ? "JsExpressionRoot" : "JsonRoot", node: s, comments: [], rootMarker: a.rootMarker });
                default:
                  return s;
              }
            }
            n.exports = t3;
          } }), $m = Z({ "src/language-js/print/html-binding.js"(e, n) {
            "use strict";
            re();
            var { builders: { join: t3, line: s, group: a, softline: r, indent: u } } = Oe();
            function i(c, v, m) {
              let d = c.getValue();
              if (v.__onHtmlBindingRoot && c.getName() === null && v.__onHtmlBindingRoot(d, v), d.type === "File") {
                if (v.__isVueForBindingLeft)
                  return c.call((p) => {
                    let f = t3([",", s], p.map(m, "params")), { params: h } = p.getValue();
                    return h.length === 1 ? f : ["(", u([r, a(f)]), r, ")"];
                  }, "program", "body", 0);
                if (v.__isVueBindings)
                  return c.call((p) => t3([",", s], p.map(m, "params")), "program", "body", 0);
              }
            }
            function o(c) {
              switch (c.type) {
                case "MemberExpression":
                  switch (c.property.type) {
                    case "Identifier":
                    case "NumericLiteral":
                    case "StringLiteral":
                      return o(c.object);
                  }
                  return false;
                case "Identifier":
                  return true;
                default:
                  return false;
              }
            }
            n.exports = { isVueEventBindingExpression: o, printHtmlBinding: i };
          } }), Jn = Z({ "src/language-js/print/binaryish.js"(e, n) {
            "use strict";
            re();
            var { printComments: t3 } = et(), { getLast: s } = Ue(), { builders: { join: a, line: r, softline: u, group: i, indent: o, align: c, ifBreak: v, indentIfBreak: m }, utils: { cleanDoc: d, getDocParts: p, isConcat: f } } = Oe(), { hasLeadingOwnLineComment: h, isBinaryish: w, isJsxNode: T, shouldFlatten: A, hasComment: S, CommentCheckFlags: B, isCallExpression: I, isMemberExpression: k, isObjectProperty: P, isEnabledHackPipeline: C } = Ke(), D = 0;
            function g(E, y, N) {
              let x = E.getValue(), b = E.getParentNode(), L = E.getParentNode(1), M = x !== b.body && (b.type === "IfStatement" || b.type === "WhileStatement" || b.type === "SwitchStatement" || b.type === "DoWhileStatement"), j = C(y) && x.operator === "|>", $ = F(E, N, y, false, M);
              if (M)
                return $;
              if (j)
                return i($);
              if (I(b) && b.callee === x || b.type === "UnaryExpression" || k(b) && !b.computed)
                return i([o([u, ...$]), u]);
              let V = b.type === "ReturnStatement" || b.type === "ThrowStatement" || b.type === "JSXExpressionContainer" && L.type === "JSXAttribute" || x.operator !== "|" && b.type === "JsExpressionRoot" || x.type !== "NGPipeExpression" && (b.type === "NGRoot" && y.parser === "__ng_binding" || b.type === "NGMicrosyntaxExpression" && L.type === "NGMicrosyntax" && L.body.length === 1) || x === b.body && b.type === "ArrowFunctionExpression" || x !== b.body && b.type === "ForStatement" || b.type === "ConditionalExpression" && L.type !== "ReturnStatement" && L.type !== "ThrowStatement" && !I(L) || b.type === "TemplateLiteral", q = b.type === "AssignmentExpression" || b.type === "VariableDeclarator" || b.type === "ClassProperty" || b.type === "PropertyDefinition" || b.type === "TSAbstractPropertyDefinition" || b.type === "ClassPrivateProperty" || P(b), Y = w(x.left) && A(x.operator, x.left.operator);
              if (V || l(x) && !Y || !l(x) && q)
                return i($);
              if ($.length === 0)
                return "";
              let H = T(x.right), R = $.findIndex((X) => typeof X != "string" && !Array.isArray(X) && X.type === "group"), Q = $.slice(0, R === -1 ? 1 : R + 1), ee = $.slice(Q.length, H ? -1 : void 0), te = Symbol("logicalChain-" + ++D), oe = i([...Q, o(ee)], { id: te });
              if (!H)
                return oe;
              let W = s($);
              return i([oe, m(W, { groupId: te })]);
            }
            function F(E, y, N, x, b) {
              let L = E.getValue();
              if (!w(L))
                return [i(y())];
              let M = [];
              A(L.operator, L.left.operator) ? M = E.call((ee) => F(ee, y, N, true, b), "left") : M.push(i(y("left")));
              let j = l(L), $ = (L.operator === "|>" || L.type === "NGPipeExpression" || L.operator === "|" && N.parser === "__vue_expression") && !h(N.originalText, L.right), V = L.type === "NGPipeExpression" ? "|" : L.operator, q = L.type === "NGPipeExpression" && L.arguments.length > 0 ? i(o([u, ": ", a([u, ":", v(" ")], E.map(y, "arguments").map((ee) => c(2, i(ee))))])) : "", Y;
              if (j)
                Y = [V, " ", y("right"), q];
              else {
                let te = C(N) && V === "|>" ? E.call((oe) => F(oe, y, N, true, b), "right") : y("right");
                Y = [$ ? r : "", V, $ ? " " : r, te, q];
              }
              let H = E.getParentNode(), R = S(L.left, B.Trailing | B.Line), Q = R || !(b && L.type === "LogicalExpression") && H.type !== L.type && L.left.type !== L.type && L.right.type !== L.type;
              if (M.push($ ? "" : " ", Q ? i(Y, { shouldBreak: R }) : Y), x && S(L)) {
                let ee = d(t3(E, M, N));
                return f(ee) || ee.type === "fill" ? p(ee) : [ee];
              }
              return M;
            }
            function l(E) {
              return E.type !== "LogicalExpression" ? false : !!(E.right.type === "ObjectExpression" && E.right.properties.length > 0 || E.right.type === "ArrayExpression" && E.right.elements.length > 0 || T(E.right));
            }
            n.exports = { printBinaryishExpression: g, shouldInlineLogicalExpression: l };
          } }), Hm = Z({ "src/language-js/print/angular.js"(e, n) {
            "use strict";
            re();
            var { builders: { join: t3, line: s, group: a } } = Oe(), { hasNode: r, hasComment: u, getComments: i } = Ke(), { printBinaryishExpression: o } = Jn();
            function c(d, p, f) {
              let h = d.getValue();
              if (!!h.type.startsWith("NG"))
                switch (h.type) {
                  case "NGRoot":
                    return [f("node"), u(h.node) ? " //" + i(h.node)[0].value.trimEnd() : ""];
                  case "NGPipeExpression":
                    return o(d, p, f);
                  case "NGChainedExpression":
                    return a(t3([";", s], d.map((w) => m(w) ? f() : ["(", f(), ")"], "expressions")));
                  case "NGEmptyExpression":
                    return "";
                  case "NGQuotedExpression":
                    return [h.prefix, ": ", h.value.trim()];
                  case "NGMicrosyntax":
                    return d.map((w, T) => [T === 0 ? "" : v(w.getValue(), T, h) ? " " : [";", s], f()], "body");
                  case "NGMicrosyntaxKey":
                    return /^[$_a-z][\w$]*(?:-[$_a-z][\w$])*$/i.test(h.name) ? h.name : JSON.stringify(h.name);
                  case "NGMicrosyntaxExpression":
                    return [f("expression"), h.alias === null ? "" : [" as ", f("alias")]];
                  case "NGMicrosyntaxKeyedExpression": {
                    let w = d.getName(), T = d.getParentNode(), A = v(h, w, T) || (w === 1 && (h.key.name === "then" || h.key.name === "else") || w === 2 && h.key.name === "else" && T.body[w - 1].type === "NGMicrosyntaxKeyedExpression" && T.body[w - 1].key.name === "then") && T.body[0].type === "NGMicrosyntaxExpression";
                    return [f("key"), A ? " " : ": ", f("expression")];
                  }
                  case "NGMicrosyntaxLet":
                    return ["let ", f("key"), h.value === null ? "" : [" = ", f("value")]];
                  case "NGMicrosyntaxAs":
                    return [f("key"), " as ", f("alias")];
                  default:
                    throw new Error("Unknown Angular node type: ".concat(JSON.stringify(h.type), "."));
                }
            }
            function v(d, p, f) {
              return d.type === "NGMicrosyntaxKeyedExpression" && d.key.name === "of" && p === 1 && f.body[0].type === "NGMicrosyntaxLet" && f.body[0].value === null;
            }
            function m(d) {
              return r(d.getValue(), (p) => {
                switch (p.type) {
                  case void 0:
                    return false;
                  case "CallExpression":
                  case "OptionalCallExpression":
                  case "AssignmentExpression":
                    return true;
                }
              });
            }
            n.exports = { printAngular: c };
          } }), Gm = Z({ "src/language-js/print/jsx.js"(e, n) {
            "use strict";
            re();
            var { printComments: t3, printDanglingComments: s } = et(), { builders: { line: a, hardline: r, softline: u, group: i, indent: o, conditionalGroup: c, fill: v, ifBreak: m, lineSuffixBoundary: d, join: p }, utils: { willBreak: f } } = Oe(), { getLast: h, getPreferredQuote: w } = Ue(), { isJsxNode: T, rawText: A, isLiteral: S, isCallExpression: B, isStringLiteral: I, isBinaryish: k, hasComment: P, CommentCheckFlags: C, hasNodeIgnoreComment: D } = Ke(), g = jt(), { willPrintOwnComments: F } = uo(), l = (ie) => ie === "" || ie === a || ie === r || ie === u;
            function E(ie, G, z) {
              let U = ie.getValue();
              if (U.type === "JSXElement" && W(U))
                return [z("openingElement"), z("closingElement")];
              let le = U.type === "JSXElement" ? z("openingElement") : z("openingFragment"), ge = U.type === "JSXElement" ? z("closingElement") : z("closingFragment");
              if (U.children.length === 1 && U.children[0].type === "JSXExpressionContainer" && (U.children[0].expression.type === "TemplateLiteral" || U.children[0].expression.type === "TaggedTemplateExpression"))
                return [le, ...ie.map(z, "children"), ge];
              U.children = U.children.map((Fe) => ue(Fe) ? { type: "JSXText", value: " ", raw: " " } : Fe);
              let Ae = U.children.some(T), Ne = U.children.filter((Fe) => Fe.type === "JSXExpressionContainer").length > 1, ke = U.type === "JSXElement" && U.openingElement.attributes.length > 1, ce = f(le) || Ae || ke || Ne, pe = ie.getParentNode().rootMarker === "mdx", de = G.singleQuote ? "{' '}" : '{" "}', ae = pe ? " " : m([de, u], " "), ve = U.openingElement && U.openingElement.name && U.openingElement.name.name === "fbt", K = y(ie, G, z, ae, ve), he = U.children.some((Fe) => X(Fe));
              for (let Fe = K.length - 2; Fe >= 0; Fe--) {
                let me = K[Fe] === "" && K[Fe + 1] === "", _ = K[Fe] === r && K[Fe + 1] === "" && K[Fe + 2] === r, J = (K[Fe] === u || K[Fe] === r) && K[Fe + 1] === "" && K[Fe + 2] === ae, ne = K[Fe] === ae && K[Fe + 1] === "" && (K[Fe + 2] === u || K[Fe + 2] === r), Ee = K[Fe] === ae && K[Fe + 1] === "" && K[Fe + 2] === ae, We = K[Fe] === u && K[Fe + 1] === "" && K[Fe + 2] === r || K[Fe] === r && K[Fe + 1] === "" && K[Fe + 2] === u;
                _ && he || me || J || Ee || We ? K.splice(Fe, 2) : ne && K.splice(Fe + 1, 2);
              }
              for (; K.length > 0 && l(h(K)); )
                K.pop();
              for (; K.length > 1 && l(K[0]) && l(K[1]); )
                K.shift(), K.shift();
              let ye = [];
              for (let [Fe, me] of K.entries()) {
                if (me === ae) {
                  if (Fe === 1 && K[Fe - 1] === "") {
                    if (K.length === 2) {
                      ye.push(de);
                      continue;
                    }
                    ye.push([de, r]);
                    continue;
                  } else if (Fe === K.length - 1) {
                    ye.push(de);
                    continue;
                  } else if (K[Fe - 1] === "" && K[Fe - 2] === r) {
                    ye.push(de);
                    continue;
                  }
                }
                ye.push(me), f(me) && (ce = true);
              }
              let Ce = he ? v(ye) : i(ye, { shouldBreak: true });
              if (pe)
                return Ce;
              let Ie = i([le, o([r, Ce]), r, ge]);
              return ce ? Ie : c([i([le, ...K, ge]), Ie]);
            }
            function y(ie, G, z, U, le) {
              let ge = [];
              return ie.each((Ae, Ne, ke) => {
                let ce = Ae.getValue();
                if (S(ce)) {
                  let pe = A(ce);
                  if (X(ce)) {
                    let de = pe.split(ee);
                    if (de[0] === "") {
                      if (ge.push(""), de.shift(), /\n/.test(de[0])) {
                        let ve = ke[Ne + 1];
                        ge.push(x(le, de[1], ce, ve));
                      } else
                        ge.push(U);
                      de.shift();
                    }
                    let ae;
                    if (h(de) === "" && (de.pop(), ae = de.pop()), de.length === 0)
                      return;
                    for (let [ve, K] of de.entries())
                      ve % 2 === 1 ? ge.push(a) : ge.push(K);
                    if (ae !== void 0)
                      if (/\n/.test(ae)) {
                        let ve = ke[Ne + 1];
                        ge.push(x(le, h(ge), ce, ve));
                      } else
                        ge.push(U);
                    else {
                      let ve = ke[Ne + 1];
                      ge.push(N(le, h(ge), ce, ve));
                    }
                  } else
                    /\n/.test(pe) ? pe.match(/\n/g).length > 1 && ge.push("", r) : ge.push("", U);
                } else {
                  let pe = z();
                  ge.push(pe);
                  let de = ke[Ne + 1];
                  if (de && X(de)) {
                    let ve = oe(A(de)).split(ee)[0];
                    ge.push(N(le, ve, ce, de));
                  } else
                    ge.push(r);
                }
              }, "children"), ge;
            }
            function N(ie, G, z, U) {
              return ie ? "" : z.type === "JSXElement" && !z.closingElement || U && U.type === "JSXElement" && !U.closingElement ? G.length === 1 ? u : r : u;
            }
            function x(ie, G, z, U) {
              return ie ? r : G.length === 1 ? z.type === "JSXElement" && !z.closingElement || U && U.type === "JSXElement" && !U.closingElement ? r : u : r;
            }
            function b(ie, G, z) {
              let U = ie.getParentNode();
              if (!U || { ArrayExpression: true, JSXAttribute: true, JSXElement: true, JSXExpressionContainer: true, JSXFragment: true, ExpressionStatement: true, CallExpression: true, OptionalCallExpression: true, ConditionalExpression: true, JsExpressionRoot: true }[U.type])
                return G;
              let ge = ie.match(void 0, (Ne) => Ne.type === "ArrowFunctionExpression", B, (Ne) => Ne.type === "JSXExpressionContainer"), Ae = g(ie, z);
              return i([Ae ? "" : m("("), o([u, G]), u, Ae ? "" : m(")")], { shouldBreak: ge });
            }
            function L(ie, G, z) {
              let U = ie.getValue(), le = [];
              if (le.push(z("name")), U.value) {
                let ge;
                if (I(U.value)) {
                  let Ne = A(U.value).slice(1, -1).replace(/&apos;/g, "'").replace(/&quot;/g, '"'), { escaped: ke, quote: ce, regex: pe } = w(Ne, G.jsxSingleQuote ? "'" : '"');
                  Ne = Ne.replace(pe, ke), ge = [ce, Ne, ce];
                } else
                  ge = z("value");
                le.push("=", ge);
              }
              return le;
            }
            function M(ie, G, z) {
              let U = ie.getValue(), le = (ge, Ae) => ge.type === "JSXEmptyExpression" || !P(ge) && (ge.type === "ArrayExpression" || ge.type === "ObjectExpression" || ge.type === "ArrowFunctionExpression" || ge.type === "AwaitExpression" && (le(ge.argument, ge) || ge.argument.type === "JSXElement") || B(ge) || ge.type === "FunctionExpression" || ge.type === "TemplateLiteral" || ge.type === "TaggedTemplateExpression" || ge.type === "DoExpression" || T(Ae) && (ge.type === "ConditionalExpression" || k(ge)));
              return le(U.expression, ie.getParentNode(0)) ? i(["{", z("expression"), d, "}"]) : i(["{", o([u, z("expression")]), u, d, "}"]);
            }
            function j(ie, G, z) {
              let U = ie.getValue(), le = U.name && P(U.name) || U.typeParameters && P(U.typeParameters);
              if (U.selfClosing && U.attributes.length === 0 && !le)
                return ["<", z("name"), z("typeParameters"), " />"];
              if (U.attributes && U.attributes.length === 1 && U.attributes[0].value && I(U.attributes[0].value) && !U.attributes[0].value.value.includes(`
`) && !le && !P(U.attributes[0]))
                return i(["<", z("name"), z("typeParameters"), " ", ...ie.map(z, "attributes"), U.selfClosing ? " />" : ">"]);
              let ge = U.attributes.length > 0 && P(h(U.attributes), C.Trailing), Ae = U.attributes.length === 0 && !le || (G.bracketSameLine || G.jsxBracketSameLine) && (!le || U.attributes.length > 0) && !ge, Ne = U.attributes && U.attributes.some((ce) => ce.value && I(ce.value) && ce.value.value.includes(`
`)), ke = G.singleAttributePerLine && U.attributes.length > 1 ? r : a;
              return i(["<", z("name"), z("typeParameters"), o(ie.map(() => [ke, z()], "attributes")), U.selfClosing ? a : Ae ? ">" : u, U.selfClosing ? "/>" : Ae ? "" : ">"], { shouldBreak: Ne });
            }
            function $(ie, G, z) {
              let U = ie.getValue(), le = [];
              le.push("</");
              let ge = z("name");
              return P(U.name, C.Leading | C.Line) ? le.push(o([r, ge]), r) : P(U.name, C.Leading | C.Block) ? le.push(" ", ge) : le.push(ge), le.push(">"), le;
            }
            function V(ie, G) {
              let z = ie.getValue(), U = P(z), le = P(z, C.Line), ge = z.type === "JSXOpeningFragment";
              return [ge ? "<" : "</", o([le ? r : U && !ge ? " " : "", s(ie, G, true)]), le ? r : "", ">"];
            }
            function q(ie, G, z) {
              let U = t3(ie, E(ie, G, z), G);
              return b(ie, U, G);
            }
            function Y(ie, G) {
              let z = ie.getValue(), U = P(z, C.Line);
              return [s(ie, G, !U), U ? r : ""];
            }
            function H(ie, G, z) {
              let U = ie.getValue();
              return ["{", ie.call((le) => {
                let ge = ["...", z()], Ae = le.getValue();
                return !P(Ae) || !F(le) ? ge : [o([u, t3(le, ge, G)]), u];
              }, U.type === "JSXSpreadAttribute" ? "argument" : "expression"), "}"];
            }
            function R(ie, G, z) {
              let U = ie.getValue();
              if (!!U.type.startsWith("JSX"))
                switch (U.type) {
                  case "JSXAttribute":
                    return L(ie, G, z);
                  case "JSXIdentifier":
                    return String(U.name);
                  case "JSXNamespacedName":
                    return p(":", [z("namespace"), z("name")]);
                  case "JSXMemberExpression":
                    return p(".", [z("object"), z("property")]);
                  case "JSXSpreadAttribute":
                    return H(ie, G, z);
                  case "JSXSpreadChild":
                    return H(ie, G, z);
                  case "JSXExpressionContainer":
                    return M(ie, G, z);
                  case "JSXFragment":
                  case "JSXElement":
                    return q(ie, G, z);
                  case "JSXOpeningElement":
                    return j(ie, G, z);
                  case "JSXClosingElement":
                    return $(ie, G, z);
                  case "JSXOpeningFragment":
                  case "JSXClosingFragment":
                    return V(ie, G);
                  case "JSXEmptyExpression":
                    return Y(ie, G);
                  case "JSXText":
                    throw new Error("JSXTest should be handled by JSXElement");
                  default:
                    throw new Error("Unknown JSX node type: ".concat(JSON.stringify(U.type), "."));
                }
            }
            var Q = ` 
\r	`, ee = new RegExp("([" + Q + "]+)"), te = new RegExp("[^" + Q + "]"), oe = (ie) => ie.replace(new RegExp("(?:^" + ee.source + "|" + ee.source + "$)"), "");
            function W(ie) {
              if (ie.children.length === 0)
                return true;
              if (ie.children.length > 1)
                return false;
              let G = ie.children[0];
              return S(G) && !X(G);
            }
            function X(ie) {
              return S(ie) && (te.test(A(ie)) || !/\n/.test(A(ie)));
            }
            function ue(ie) {
              return ie.type === "JSXExpressionContainer" && S(ie.expression) && ie.expression.value === " " && !P(ie.expression);
            }
            function De(ie) {
              let G = ie.getValue(), z = ie.getParentNode();
              if (!z || !G || !T(G) || !T(z))
                return false;
              let U = z.children.indexOf(G), le = null;
              for (let ge = U; ge > 0; ge--) {
                let Ae = z.children[ge - 1];
                if (!(Ae.type === "JSXText" && !X(Ae))) {
                  le = Ae;
                  break;
                }
              }
              return le && le.type === "JSXExpressionContainer" && le.expression.type === "JSXEmptyExpression" && D(le.expression);
            }
            n.exports = { hasJsxIgnoreComment: De, printJsx: R };
          } }), ct = Z({ "src/language-js/print/misc.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3 } = Ue(), { builders: { indent: s, join: a, line: r } } = Oe(), { isFlowAnnotationComment: u } = Ke();
            function i(h) {
              let w = h.getValue();
              return !w.optional || w.type === "Identifier" && w === h.getParentNode().key ? "" : w.type === "OptionalCallExpression" || w.type === "OptionalMemberExpression" && w.computed ? "?." : "?";
            }
            function o(h) {
              return h.getValue().definite || h.match(void 0, (w, T) => T === "id" && w.type === "VariableDeclarator" && w.definite) ? "!" : "";
            }
            function c(h, w, T) {
              let A = h.getValue();
              return A.typeArguments ? T("typeArguments") : A.typeParameters ? T("typeParameters") : "";
            }
            function v(h, w, T) {
              let A = h.getValue();
              if (!A.typeAnnotation)
                return "";
              let S = h.getParentNode(), B = S.type === "DeclareFunction" && S.id === A;
              return u(w.originalText, A.typeAnnotation) ? [" /*: ", T("typeAnnotation"), " */"] : [B ? "" : ": ", T("typeAnnotation")];
            }
            function m(h, w, T) {
              return ["::", T("callee")];
            }
            function d(h, w, T) {
              let A = h.getValue();
              return t3(A.modifiers) ? [a(" ", h.map(T, "modifiers")), " "] : "";
            }
            function p(h, w, T) {
              return h.type === "EmptyStatement" ? ";" : h.type === "BlockStatement" || T ? [" ", w] : s([r, w]);
            }
            function f(h, w, T) {
              return ["...", T("argument"), v(h, w, T)];
            }
            n.exports = { printOptionalToken: i, printDefiniteToken: o, printFunctionTypeParameters: c, printBindExpressionCallee: m, printTypeScriptModifiers: d, printTypeAnnotation: v, printRestSpread: f, adjustClause: p };
          } }), Kt = Z({ "src/language-js/print/array.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { builders: { line: s, softline: a, hardline: r, group: u, indent: i, ifBreak: o, fill: c } } = Oe(), { getLast: v, hasNewline: m } = Ue(), { shouldPrintComma: d, hasComment: p, CommentCheckFlags: f, isNextLineEmpty: h, isNumericLiteral: w, isSignedNumericLiteral: T } = Ke(), { locStart: A } = st(), { printOptionalToken: S, printTypeAnnotation: B } = ct();
            function I(D, g, F) {
              let l = D.getValue(), E = [], y = l.type === "TupleExpression" ? "#[" : "[", N = "]";
              if (l.elements.length === 0)
                p(l, f.Dangling) ? E.push(u([y, t3(D, g), a, N])) : E.push(y, N);
              else {
                let x = v(l.elements), b = !(x && x.type === "RestElement"), L = x === null, M = Symbol("array"), j = !g.__inJestEach && l.elements.length > 1 && l.elements.every((q, Y, H) => {
                  let R = q && q.type;
                  if (R !== "ArrayExpression" && R !== "ObjectExpression")
                    return false;
                  let Q = H[Y + 1];
                  if (Q && R !== Q.type)
                    return false;
                  let ee = R === "ArrayExpression" ? "elements" : "properties";
                  return q[ee] && q[ee].length > 1;
                }), $ = k(l, g), V = b ? L ? "," : d(g) ? $ ? o(",", "", { groupId: M }) : o(",") : "" : "";
                E.push(u([y, i([a, $ ? C(D, g, F, V) : [P(D, g, "elements", F), V], t3(D, g, true)]), a, N], { shouldBreak: j, id: M }));
              }
              return E.push(S(D), B(D, g, F)), E;
            }
            function k(D, g) {
              return D.elements.length > 1 && D.elements.every((F) => F && (w(F) || T(F) && !p(F.argument)) && !p(F, f.Trailing | f.Line, (l) => !m(g.originalText, A(l), { backwards: true })));
            }
            function P(D, g, F, l) {
              let E = [], y = [];
              return D.each((N) => {
                E.push(y, u(l())), y = [",", s], N.getValue() && h(N.getValue(), g) && y.push(a);
              }, F), E;
            }
            function C(D, g, F, l) {
              let E = [];
              return D.each((y, N, x) => {
                let b = N === x.length - 1;
                E.push([F(), b ? l : ","]), b || E.push(h(y.getValue(), g) ? [r, r] : p(x[N + 1], f.Leading | f.Line) ? r : s);
              }, "elements"), c(E);
            }
            n.exports = { printArray: I, printArrayItems: P, isConciselyPrintedArray: k };
          } }), io = Z({ "src/language-js/print/call-arguments.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { getLast: s, getPenultimate: a } = Ue(), { getFunctionParameters: r, hasComment: u, CommentCheckFlags: i, isFunctionCompositionArgs: o, isJsxNode: c, isLongCurriedCallExpression: v, shouldPrintComma: m, getCallArguments: d, iterateCallArgumentsPath: p, isNextLineEmpty: f, isCallExpression: h, isStringLiteral: w, isObjectProperty: T } = Ke(), { builders: { line: A, hardline: S, softline: B, group: I, indent: k, conditionalGroup: P, ifBreak: C, breakParent: D }, utils: { willBreak: g } } = Oe(), { ArgExpansionBailout: F } = zt(), { isConciselyPrintedArray: l } = Kt();
            function E(j, $, V) {
              let q = j.getValue(), Y = q.type === "ImportExpression", H = d(q);
              if (H.length === 0)
                return ["(", t3(j, $, true), ")"];
              if (b(H))
                return ["(", V(["arguments", 0]), ", ", V(["arguments", 1]), ")"];
              let R = false, Q = false, ee = H.length - 1, te = [];
              p(j, (ie, G) => {
                let z = ie.getNode(), U = [V()];
                G === ee || (f(z, $) ? (G === 0 && (Q = true), R = true, U.push(",", S, S)) : U.push(",", A)), te.push(U);
              });
              let oe = !(Y || q.callee && q.callee.type === "Import") && m($, "all") ? "," : "";
              function W() {
                return I(["(", k([A, ...te]), oe, A, ")"], { shouldBreak: true });
              }
              if (R || j.getParentNode().type !== "Decorator" && o(H))
                return W();
              let X = x(H), ue = N(H, $);
              if (X || ue) {
                if (X ? te.slice(1).some(g) : te.slice(0, -1).some(g))
                  return W();
                let ie = [];
                try {
                  j.try(() => {
                    p(j, (G, z) => {
                      X && z === 0 && (ie = [[V([], { expandFirstArg: true }), te.length > 1 ? "," : "", Q ? S : A, Q ? S : ""], ...te.slice(1)]), ue && z === ee && (ie = [...te.slice(0, -1), V([], { expandLastArg: true })]);
                    });
                  });
                } catch (G) {
                  if (G instanceof F)
                    return W();
                  throw G;
                }
                return [te.some(g) ? D : "", P([["(", ...ie, ")"], X ? ["(", I(ie[0], { shouldBreak: true }), ...ie.slice(1), ")"] : ["(", ...te.slice(0, -1), I(s(ie), { shouldBreak: true }), ")"], W()])];
              }
              let De = ["(", k([B, ...te]), C(oe), B, ")"];
              return v(j) ? De : I(De, { shouldBreak: te.some(g) || R });
            }
            function y(j) {
              let $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
              return j.type === "ObjectExpression" && (j.properties.length > 0 || u(j)) || j.type === "ArrayExpression" && (j.elements.length > 0 || u(j)) || j.type === "TSTypeAssertion" && y(j.expression) || j.type === "TSAsExpression" && y(j.expression) || j.type === "FunctionExpression" || j.type === "ArrowFunctionExpression" && (!j.returnType || !j.returnType.typeAnnotation || j.returnType.typeAnnotation.type !== "TSTypeReference" || L(j.body)) && (j.body.type === "BlockStatement" || j.body.type === "ArrowFunctionExpression" && y(j.body, true) || j.body.type === "ObjectExpression" || j.body.type === "ArrayExpression" || !$ && (h(j.body) || j.body.type === "ConditionalExpression") || c(j.body)) || j.type === "DoExpression" || j.type === "ModuleExpression";
            }
            function N(j, $) {
              let V = s(j), q = a(j);
              return !u(V, i.Leading) && !u(V, i.Trailing) && y(V) && (!q || q.type !== V.type) && (j.length !== 2 || q.type !== "ArrowFunctionExpression" || V.type !== "ArrayExpression") && !(j.length > 1 && V.type === "ArrayExpression" && l(V, $));
            }
            function x(j) {
              if (j.length !== 2)
                return false;
              let [$, V] = j;
              return $.type === "ModuleExpression" && M(V) ? true : !u($) && ($.type === "FunctionExpression" || $.type === "ArrowFunctionExpression" && $.body.type === "BlockStatement") && V.type !== "FunctionExpression" && V.type !== "ArrowFunctionExpression" && V.type !== "ConditionalExpression" && !y(V);
            }
            function b(j) {
              return j.length === 2 && j[0].type === "ArrowFunctionExpression" && r(j[0]).length === 0 && j[0].body.type === "BlockStatement" && j[1].type === "ArrayExpression" && !j.some(($) => u($));
            }
            function L(j) {
              return j.type === "BlockStatement" && (j.body.some(($) => $.type !== "EmptyStatement") || u(j, i.Dangling));
            }
            function M(j) {
              return j.type === "ObjectExpression" && j.properties.length === 1 && T(j.properties[0]) && j.properties[0].key.type === "Identifier" && j.properties[0].key.name === "type" && w(j.properties[0].value) && j.properties[0].value.value === "module";
            }
            n.exports = E;
          } }), ao = Z({ "src/language-js/print/member.js"(e, n) {
            "use strict";
            re();
            var { builders: { softline: t3, group: s, indent: a, label: r } } = Oe(), { isNumericLiteral: u, isMemberExpression: i, isCallExpression: o } = Ke(), { printOptionalToken: c } = ct();
            function v(d, p, f) {
              let h = d.getValue(), w = d.getParentNode(), T, A = 0;
              do
                T = d.getParentNode(A), A++;
              while (T && (i(T) || T.type === "TSNonNullExpression"));
              let S = f("object"), B = m(d, p, f), I = T && (T.type === "NewExpression" || T.type === "BindExpression" || T.type === "AssignmentExpression" && T.left.type !== "Identifier") || h.computed || h.object.type === "Identifier" && h.property.type === "Identifier" && !i(w) || (w.type === "AssignmentExpression" || w.type === "VariableDeclarator") && (o(h.object) && h.object.arguments.length > 0 || h.object.type === "TSNonNullExpression" && o(h.object.expression) && h.object.expression.arguments.length > 0 || S.label === "member-chain");
              return r(S.label === "member-chain" ? "member-chain" : "member", [S, I ? B : s(a([t3, B]))]);
            }
            function m(d, p, f) {
              let h = f("property"), w = d.getValue(), T = c(d);
              return w.computed ? !w.property || u(w.property) ? [T, "[", h, "]"] : s([T, "[", a([t3, h]), t3, "]"]) : [T, ".", h];
            }
            n.exports = { printMemberExpression: v, printMemberLookup: m };
          } }), Jm = Z({ "src/language-js/print/member-chain.js"(e, n) {
            "use strict";
            re();
            var { printComments: t3 } = et(), { getLast: s, isNextLineEmptyAfterIndex: a, getNextNonSpaceNonCommentCharacterIndex: r } = Ue(), u = jt(), { isCallExpression: i, isMemberExpression: o, isFunctionOrArrowExpression: c, isLongCurriedCallExpression: v, isMemberish: m, isNumericLiteral: d, isSimpleCallArgument: p, hasComment: f, CommentCheckFlags: h, isNextLineEmpty: w } = Ke(), { locEnd: T } = st(), { builders: { join: A, hardline: S, group: B, indent: I, conditionalGroup: k, breakParent: P, label: C }, utils: { willBreak: D } } = Oe(), g = io(), { printMemberLookup: F } = ao(), { printOptionalToken: l, printFunctionTypeParameters: E, printBindExpressionCallee: y } = ct();
            function N(x, b, L) {
              let M = x.getParentNode(), j = !M || M.type === "ExpressionStatement", $ = [];
              function V(de) {
                let { originalText: ae } = b, ve = r(ae, de, T);
                return ae.charAt(ve) === ")" ? ve !== false && a(ae, ve + 1) : w(de, b);
              }
              function q(de) {
                let ae = de.getValue();
                i(ae) && (m(ae.callee) || i(ae.callee)) ? ($.unshift({ node: ae, printed: [t3(de, [l(de), E(de, b, L), g(de, b, L)], b), V(ae) ? S : ""] }), de.call((ve) => q(ve), "callee")) : m(ae) ? ($.unshift({ node: ae, needsParens: u(de, b), printed: t3(de, o(ae) ? F(de, b, L) : y(de, b, L), b) }), de.call((ve) => q(ve), "object")) : ae.type === "TSNonNullExpression" ? ($.unshift({ node: ae, printed: t3(de, "!", b) }), de.call((ve) => q(ve), "expression")) : $.unshift({ node: ae, printed: L() });
              }
              let Y = x.getValue();
              $.unshift({ node: Y, printed: [l(x), E(x, b, L), g(x, b, L)] }), Y.callee && x.call((de) => q(de), "callee");
              let H = [], R = [$[0]], Q = 1;
              for (; Q < $.length && ($[Q].node.type === "TSNonNullExpression" || i($[Q].node) || o($[Q].node) && $[Q].node.computed && d($[Q].node.property)); ++Q)
                R.push($[Q]);
              if (!i($[0].node))
                for (; Q + 1 < $.length && (m($[Q].node) && m($[Q + 1].node)); ++Q)
                  R.push($[Q]);
              H.push(R), R = [];
              let ee = false;
              for (; Q < $.length; ++Q) {
                if (ee && m($[Q].node)) {
                  if ($[Q].node.computed && d($[Q].node.property)) {
                    R.push($[Q]);
                    continue;
                  }
                  H.push(R), R = [], ee = false;
                }
                (i($[Q].node) || $[Q].node.type === "ImportExpression") && (ee = true), R.push($[Q]), f($[Q].node, h.Trailing) && (H.push(R), R = [], ee = false);
              }
              R.length > 0 && H.push(R);
              function te(de) {
                return /^[A-Z]|^[$_]+$/.test(de);
              }
              function oe(de) {
                return de.length <= b.tabWidth;
              }
              function W(de) {
                let ae = de[1].length > 0 && de[1][0].node.computed;
                if (de[0].length === 1) {
                  let K = de[0][0].node;
                  return K.type === "ThisExpression" || K.type === "Identifier" && (te(K.name) || j && oe(K.name) || ae);
                }
                let ve = s(de[0]).node;
                return o(ve) && ve.property.type === "Identifier" && (te(ve.property.name) || ae);
              }
              let X = H.length >= 2 && !f(H[1][0].node) && W(H);
              function ue(de) {
                let ae = de.map((ve) => ve.printed);
                return de.length > 0 && s(de).needsParens ? ["(", ...ae, ")"] : ae;
              }
              function De(de) {
                return de.length === 0 ? "" : I(B([S, A(S, de.map(ue))]));
              }
              let ie = H.map(ue), G = ie, z = X ? 3 : 2, U = H.flat(), le = U.slice(1, -1).some((de) => f(de.node, h.Leading)) || U.slice(0, -1).some((de) => f(de.node, h.Trailing)) || H[z] && f(H[z][0].node, h.Leading);
              if (H.length <= z && !le)
                return v(x) ? G : B(G);
              let ge = s(H[X ? 1 : 0]).node, Ae = !i(ge) && V(ge), Ne = [ue(H[0]), X ? H.slice(1, 2).map(ue) : "", Ae ? S : "", De(H.slice(X ? 2 : 1))], ke = $.map((de) => {
                let { node: ae } = de;
                return ae;
              }).filter(i);
              function ce() {
                let de = s(s(H)).node, ae = s(ie);
                return i(de) && D(ae) && ke.slice(0, -1).some((ve) => ve.arguments.some(c));
              }
              let pe;
              return le || ke.length > 2 && ke.some((de) => !de.arguments.every((ae) => p(ae, 0))) || ie.slice(0, -1).some(D) || ce() ? pe = B(Ne) : pe = [D(G) || Ae ? P : "", k([G, Ne])], C("member-chain", pe);
            }
            n.exports = N;
          } }), oo = Z({ "src/language-js/print/call-expression.js"(e, n) {
            "use strict";
            re();
            var { builders: { join: t3, group: s } } = Oe(), a = jt(), { getCallArguments: r, hasFlowAnnotationComment: u, isCallExpression: i, isMemberish: o, isStringLiteral: c, isTemplateOnItsOwnLine: v, isTestCall: m, iterateCallArgumentsPath: d } = Ke(), p = Jm(), f = io(), { printOptionalToken: h, printFunctionTypeParameters: w } = ct();
            function T(S, B, I) {
              let k = S.getValue(), P = S.getParentNode(), C = k.type === "NewExpression", D = k.type === "ImportExpression", g = h(S), F = r(k);
              if (F.length > 0 && (!D && !C && A(k, P) || F.length === 1 && v(F[0], B.originalText) || !C && m(k, P))) {
                let y = [];
                return d(S, () => {
                  y.push(I());
                }), [C ? "new " : "", I("callee"), g, w(S, B, I), "(", t3(", ", y), ")"];
              }
              let l = (B.parser === "babel" || B.parser === "babel-flow") && k.callee && k.callee.type === "Identifier" && u(k.callee.trailingComments);
              if (l && (k.callee.trailingComments[0].printed = true), !D && !C && o(k.callee) && !S.call((y) => a(y, B), "callee"))
                return p(S, B, I);
              let E = [C ? "new " : "", D ? "import" : I("callee"), g, l ? "/*:: ".concat(k.callee.trailingComments[0].value.slice(2).trim(), " */") : "", w(S, B, I), f(S, B, I)];
              return D || i(k.callee) ? s(E) : E;
            }
            function A(S, B) {
              if (S.callee.type !== "Identifier")
                return false;
              if (S.callee.name === "require")
                return true;
              if (S.callee.name === "define") {
                let I = r(S);
                return B.type === "ExpressionStatement" && (I.length === 1 || I.length === 2 && I[0].type === "ArrayExpression" || I.length === 3 && c(I[0]) && I[1].type === "ArrayExpression");
              }
              return false;
            }
            n.exports = { printCallExpression: T };
          } }), Yt = Z({ "src/language-js/print/assignment.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3, getStringWidth: s } = Ue(), { builders: { line: a, group: r, indent: u, indentIfBreak: i, lineSuffixBoundary: o }, utils: { cleanDoc: c, willBreak: v, canBreak: m } } = Oe(), { hasLeadingOwnLineComment: d, isBinaryish: p, isStringLiteral: f, isLiteral: h, isNumericLiteral: w, isCallExpression: T, isMemberExpression: A, getCallArguments: S, rawText: B, hasComment: I, isSignedNumericLiteral: k, isObjectProperty: P } = Ke(), { shouldInlineLogicalExpression: C } = Jn(), { printCallExpression: D } = oo();
            function g(W, X, ue, De, ie, G) {
              let z = E(W, X, ue, De, G), U = ue(G, { assignmentLayout: z });
              switch (z) {
                case "break-after-operator":
                  return r([r(De), ie, r(u([a, U]))]);
                case "never-break-after-operator":
                  return r([r(De), ie, " ", U]);
                case "fluid": {
                  let le = Symbol("assignment");
                  return r([r(De), ie, r(u(a), { id: le }), o, i(U, { groupId: le })]);
                }
                case "break-lhs":
                  return r([De, ie, " ", r(U)]);
                case "chain":
                  return [r(De), ie, a, U];
                case "chain-tail":
                  return [r(De), ie, u([a, U])];
                case "chain-tail-arrow-chain":
                  return [r(De), ie, U];
                case "only-left":
                  return De;
              }
            }
            function F(W, X, ue) {
              let De = W.getValue();
              return g(W, X, ue, ue("left"), [" ", De.operator], "right");
            }
            function l(W, X, ue) {
              return g(W, X, ue, ue("id"), " =", "init");
            }
            function E(W, X, ue, De, ie) {
              let G = W.getValue(), z = G[ie];
              if (!z)
                return "only-left";
              let U = !x(z);
              if (W.match(x, b, (Ne) => !U || Ne.type !== "ExpressionStatement" && Ne.type !== "VariableDeclaration"))
                return U ? z.type === "ArrowFunctionExpression" && z.body.type === "ArrowFunctionExpression" ? "chain-tail-arrow-chain" : "chain-tail" : "chain";
              if (!U && x(z.right) || d(X.originalText, z))
                return "break-after-operator";
              if (z.type === "CallExpression" && z.callee.name === "require" || X.parser === "json5" || X.parser === "json")
                return "never-break-after-operator";
              if (N(G) || L(G) || $(G) || V(G) && m(De))
                return "break-lhs";
              let Ae = ee(G, De, X);
              return W.call(() => y(W, X, ue, Ae), ie) ? "break-after-operator" : Ae || z.type === "TemplateLiteral" || z.type === "TaggedTemplateExpression" || z.type === "BooleanLiteral" || w(z) || z.type === "ClassExpression" ? "never-break-after-operator" : "fluid";
            }
            function y(W, X, ue, De) {
              let ie = W.getValue();
              if (p(ie) && !C(ie))
                return true;
              switch (ie.type) {
                case "StringLiteralTypeAnnotation":
                case "SequenceExpression":
                  return true;
                case "ConditionalExpression": {
                  let { test: U } = ie;
                  return p(U) && !C(U);
                }
                case "ClassExpression":
                  return t3(ie.decorators);
              }
              if (De)
                return false;
              let G = ie, z = [];
              for (; ; )
                if (G.type === "UnaryExpression")
                  G = G.argument, z.push("argument");
                else if (G.type === "TSNonNullExpression")
                  G = G.expression, z.push("expression");
                else
                  break;
              return !!(f(G) || W.call(() => H(W, X, ue), ...z));
            }
            function N(W) {
              if (b(W)) {
                let X = W.left || W.id;
                return X.type === "ObjectPattern" && X.properties.length > 2 && X.properties.some((ue) => P(ue) && (!ue.shorthand || ue.value && ue.value.type === "AssignmentPattern"));
              }
              return false;
            }
            function x(W) {
              return W.type === "AssignmentExpression";
            }
            function b(W) {
              return x(W) || W.type === "VariableDeclarator";
            }
            function L(W) {
              let X = M(W);
              if (t3(X)) {
                let ue = W.type === "TSTypeAliasDeclaration" ? "constraint" : "bound";
                if (X.length > 1 && X.some((De) => De[ue] || De.default))
                  return true;
              }
              return false;
            }
            function M(W) {
              return j(W) && W.typeParameters && W.typeParameters.params ? W.typeParameters.params : null;
            }
            function j(W) {
              return W.type === "TSTypeAliasDeclaration" || W.type === "TypeAlias";
            }
            function $(W) {
              if (W.type !== "VariableDeclarator")
                return false;
              let { typeAnnotation: X } = W.id;
              if (!X || !X.typeAnnotation)
                return false;
              let ue = q(X.typeAnnotation);
              return t3(ue) && ue.length > 1 && ue.some((De) => t3(q(De)) || De.type === "TSConditionalType");
            }
            function V(W) {
              return W.type === "VariableDeclarator" && W.init && W.init.type === "ArrowFunctionExpression";
            }
            function q(W) {
              return Y(W) && W.typeParameters && W.typeParameters.params ? W.typeParameters.params : null;
            }
            function Y(W) {
              return W.type === "TSTypeReference" || W.type === "GenericTypeAnnotation";
            }
            function H(W, X, ue) {
              let De = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, ie = W.getValue(), G = () => H(W, X, ue, true);
              if (ie.type === "TSNonNullExpression")
                return W.call(G, "expression");
              if (T(ie)) {
                if (D(W, X, ue).label === "member-chain")
                  return false;
                let U = S(ie);
                return !(U.length === 0 || U.length === 1 && Q(U[0], X)) || te(ie, ue) ? false : W.call(G, "callee");
              }
              return A(ie) ? W.call(G, "object") : De && (ie.type === "Identifier" || ie.type === "ThisExpression");
            }
            var R = 0.25;
            function Q(W, X) {
              let { printWidth: ue } = X;
              if (I(W))
                return false;
              let De = ue * R;
              if (W.type === "ThisExpression" || W.type === "Identifier" && W.name.length <= De || k(W) && !I(W.argument))
                return true;
              let ie = W.type === "Literal" && "regex" in W && W.regex.pattern || W.type === "RegExpLiteral" && W.pattern;
              return ie ? ie.length <= De : f(W) ? B(W).length <= De : W.type === "TemplateLiteral" ? W.expressions.length === 0 && W.quasis[0].value.raw.length <= De && !W.quasis[0].value.raw.includes(`
`) : h(W);
            }
            function ee(W, X, ue) {
              if (!P(W))
                return false;
              X = c(X);
              let De = 3;
              return typeof X == "string" && s(X) < ue.tabWidth + De;
            }
            function te(W, X) {
              let ue = oe(W);
              if (t3(ue)) {
                if (ue.length > 1)
                  return true;
                if (ue.length === 1) {
                  let ie = ue[0];
                  if (ie.type === "TSUnionType" || ie.type === "UnionTypeAnnotation" || ie.type === "TSIntersectionType" || ie.type === "IntersectionTypeAnnotation" || ie.type === "TSTypeLiteral" || ie.type === "ObjectTypeAnnotation")
                    return true;
                }
                let De = W.typeParameters ? "typeParameters" : "typeArguments";
                if (v(X(De)))
                  return true;
              }
              return false;
            }
            function oe(W) {
              return W.typeParameters && W.typeParameters.params || W.typeArguments && W.typeArguments.params;
            }
            n.exports = { printVariableDeclarator: l, printAssignmentExpression: F, printAssignment: g, isArrowFunctionVariableDeclarator: V };
          } }), Pr = Z({ "src/language-js/print/function-parameters.js"(e, n) {
            "use strict";
            re();
            var { getNextNonSpaceNonCommentCharacter: t3 } = Ue(), { printDanglingComments: s } = et(), { builders: { line: a, hardline: r, softline: u, group: i, indent: o, ifBreak: c }, utils: { removeLines: v, willBreak: m } } = Oe(), { getFunctionParameters: d, iterateFunctionParametersPath: p, isSimpleType: f, isTestCall: h, isTypeAnnotationAFunction: w, isObjectType: T, isObjectTypePropertyAFunction: A, hasRestParameter: S, shouldPrintComma: B, hasComment: I, isNextLineEmpty: k } = Ke(), { locEnd: P } = st(), { ArgExpansionBailout: C } = zt(), { printFunctionTypeParameters: D } = ct();
            function g(y, N, x, b, L) {
              let M = y.getValue(), j = d(M), $ = L ? D(y, x, N) : "";
              if (j.length === 0)
                return [$, "(", s(y, x, true, (ee) => t3(x.originalText, ee, P) === ")"), ")"];
              let V = y.getParentNode(), q = h(V), Y = F(M), H = [];
              if (p(y, (ee, te) => {
                let oe = te === j.length - 1;
                oe && M.rest && H.push("..."), H.push(N()), !oe && (H.push(","), q || Y ? H.push(" ") : k(j[te], x) ? H.push(r, r) : H.push(a));
              }), b) {
                if (m($) || m(H))
                  throw new C();
                return i([v($), "(", v(H), ")"]);
              }
              let R = j.every((ee) => !ee.decorators);
              return Y && R ? [$, "(", ...H, ")"] : q ? [$, "(", ...H, ")"] : (A(V) || w(V) || V.type === "TypeAlias" || V.type === "UnionTypeAnnotation" || V.type === "TSUnionType" || V.type === "IntersectionTypeAnnotation" || V.type === "FunctionTypeAnnotation" && V.returnType === M) && j.length === 1 && j[0].name === null && M.this !== j[0] && j[0].typeAnnotation && M.typeParameters === null && f(j[0].typeAnnotation) && !M.rest ? x.arrowParens === "always" ? ["(", ...H, ")"] : H : [$, "(", o([u, ...H]), c(!S(M) && B(x, "all") ? "," : ""), u, ")"];
            }
            function F(y) {
              if (!y)
                return false;
              let N = d(y);
              if (N.length !== 1)
                return false;
              let [x] = N;
              return !I(x) && (x.type === "ObjectPattern" || x.type === "ArrayPattern" || x.type === "Identifier" && x.typeAnnotation && (x.typeAnnotation.type === "TypeAnnotation" || x.typeAnnotation.type === "TSTypeAnnotation") && T(x.typeAnnotation.typeAnnotation) || x.type === "FunctionTypeParam" && T(x.typeAnnotation) || x.type === "AssignmentPattern" && (x.left.type === "ObjectPattern" || x.left.type === "ArrayPattern") && (x.right.type === "Identifier" || x.right.type === "ObjectExpression" && x.right.properties.length === 0 || x.right.type === "ArrayExpression" && x.right.elements.length === 0));
            }
            function l(y) {
              let N;
              return y.returnType ? (N = y.returnType, N.typeAnnotation && (N = N.typeAnnotation)) : y.typeAnnotation && (N = y.typeAnnotation), N;
            }
            function E(y, N) {
              let x = l(y);
              if (!x)
                return false;
              let b = y.typeParameters && y.typeParameters.params;
              if (b) {
                if (b.length > 1)
                  return false;
                if (b.length === 1) {
                  let L = b[0];
                  if (L.constraint || L.default)
                    return false;
                }
              }
              return d(y).length === 1 && (T(x) || m(N));
            }
            n.exports = { printFunctionParameters: g, shouldHugFunctionParameters: F, shouldGroupFunctionParameters: E };
          } }), kr = Z({ "src/language-js/print/type-annotation.js"(e, n) {
            "use strict";
            re();
            var { printComments: t3, printDanglingComments: s } = et(), { isNonEmptyArray: a } = Ue(), { builders: { group: r, join: u, line: i, softline: o, indent: c, align: v, ifBreak: m } } = Oe(), d = jt(), { locStart: p } = st(), { isSimpleType: f, isObjectType: h, hasLeadingOwnLineComment: w, isObjectTypePropertyAFunction: T, shouldPrintComma: A } = Ke(), { printAssignment: S } = Yt(), { printFunctionParameters: B, shouldGroupFunctionParameters: I } = Pr(), { printArrayItems: k } = Kt();
            function P(x) {
              if (f(x) || h(x))
                return true;
              if (x.type === "UnionTypeAnnotation" || x.type === "TSUnionType") {
                let b = x.types.filter((M) => M.type === "VoidTypeAnnotation" || M.type === "TSVoidKeyword" || M.type === "NullLiteralTypeAnnotation" || M.type === "TSNullKeyword").length, L = x.types.some((M) => M.type === "ObjectTypeAnnotation" || M.type === "TSTypeLiteral" || M.type === "GenericTypeAnnotation" || M.type === "TSTypeReference");
                if (x.types.length - 1 === b && L)
                  return true;
              }
              return false;
            }
            function C(x, b, L) {
              let M = b.semi ? ";" : "", j = x.getValue(), $ = [];
              return $.push("opaque type ", L("id"), L("typeParameters")), j.supertype && $.push(": ", L("supertype")), j.impltype && $.push(" = ", L("impltype")), $.push(M), $;
            }
            function D(x, b, L) {
              let M = b.semi ? ";" : "", j = x.getValue(), $ = [];
              j.declare && $.push("declare "), $.push("type ", L("id"), L("typeParameters"));
              let V = j.type === "TSTypeAliasDeclaration" ? "typeAnnotation" : "right";
              return [S(x, b, L, $, " =", V), M];
            }
            function g(x, b, L) {
              let M = x.getValue(), j = x.map(L, "types"), $ = [], V = false;
              for (let q = 0; q < j.length; ++q)
                q === 0 ? $.push(j[q]) : h(M.types[q - 1]) && h(M.types[q]) ? $.push([" & ", V ? c(j[q]) : j[q]]) : !h(M.types[q - 1]) && !h(M.types[q]) ? $.push(c([" &", i, j[q]])) : (q > 1 && (V = true), $.push(" & ", q > 1 ? c(j[q]) : j[q]));
              return r($);
            }
            function F(x, b, L) {
              let M = x.getValue(), j = x.getParentNode(), $ = j.type !== "TypeParameterInstantiation" && j.type !== "TSTypeParameterInstantiation" && j.type !== "GenericTypeAnnotation" && j.type !== "TSTypeReference" && j.type !== "TSTypeAssertion" && j.type !== "TupleTypeAnnotation" && j.type !== "TSTupleType" && !(j.type === "FunctionTypeParam" && !j.name && x.getParentNode(1).this !== j) && !((j.type === "TypeAlias" || j.type === "VariableDeclarator" || j.type === "TSTypeAliasDeclaration") && w(b.originalText, M)), V = P(M), q = x.map((R) => {
                let Q = L();
                return V || (Q = v(2, Q)), t3(R, Q, b);
              }, "types");
              if (V)
                return u(" | ", q);
              let Y = $ && !w(b.originalText, M), H = [m([Y ? i : "", "| "]), u([i, "| "], q)];
              return d(x, b) ? r([c(H), o]) : j.type === "TupleTypeAnnotation" && j.types.length > 1 || j.type === "TSTupleType" && j.elementTypes.length > 1 ? r([c([m(["(", o]), H]), o, m(")")]) : r($ ? c(H) : H);
            }
            function l(x, b, L) {
              let M = x.getValue(), j = [], $ = x.getParentNode(0), V = x.getParentNode(1), q = x.getParentNode(2), Y = M.type === "TSFunctionType" || !(($.type === "ObjectTypeProperty" || $.type === "ObjectTypeInternalSlot") && !$.variance && !$.optional && p($) === p(M) || $.type === "ObjectTypeCallProperty" || q && q.type === "DeclareFunction"), H = Y && ($.type === "TypeAnnotation" || $.type === "TSTypeAnnotation"), R = H && Y && ($.type === "TypeAnnotation" || $.type === "TSTypeAnnotation") && V.type === "ArrowFunctionExpression";
              T($) && (Y = true, H = true), R && j.push("(");
              let Q = B(x, L, b, false, true), ee = M.returnType || M.predicate || M.typeAnnotation ? [Y ? " => " : ": ", L("returnType"), L("predicate"), L("typeAnnotation")] : "", te = I(M, ee);
              return j.push(te ? r(Q) : Q), ee && j.push(ee), R && j.push(")"), r(j);
            }
            function E(x, b, L) {
              let M = x.getValue(), j = M.type === "TSTupleType" ? "elementTypes" : "types", $ = M[j], V = a($), q = V ? o : "";
              return r(["[", c([q, k(x, b, j, L)]), m(V && A(b, "all") ? "," : ""), s(x, b, true), q, "]"]);
            }
            function y(x, b, L) {
              let M = x.getValue(), j = M.type === "OptionalIndexedAccessType" && M.optional ? "?.[" : "[";
              return [L("objectType"), j, L("indexType"), "]"];
            }
            function N(x, b, L) {
              let M = x.getValue();
              return [M.postfix ? "" : L, b("typeAnnotation"), M.postfix ? L : ""];
            }
            n.exports = { printOpaqueType: C, printTypeAlias: D, printIntersectionType: g, printUnionType: F, printFunctionType: l, printTupleType: E, printIndexedAccessType: y, shouldHugType: P, printJSDocType: N };
          } }), Ir = Z({ "src/language-js/print/type-parameters.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { builders: { join: s, line: a, hardline: r, softline: u, group: i, indent: o, ifBreak: c } } = Oe(), { isTestCall: v, hasComment: m, CommentCheckFlags: d, isTSXFile: p, shouldPrintComma: f, getFunctionParameters: h, isObjectType: w } = Ke(), { createGroupIdMapper: T } = Ue(), { shouldHugType: A } = kr(), { isArrowFunctionVariableDeclarator: S } = Yt(), B = T("typeParameters");
            function I(C, D, g, F) {
              let l = C.getValue();
              if (!l[F])
                return "";
              if (!Array.isArray(l[F]))
                return g(F);
              let E = C.getNode(2), y = E && v(E);
              if (!C.match((L) => !(L[F].length === 1 && w(L[F][0])), void 0, (L, M) => M === "typeAnnotation", (L) => L.type === "Identifier", S) && (y || l[F].length === 0 || l[F].length === 1 && (l[F][0].type === "NullableTypeAnnotation" || A(l[F][0]))))
                return ["<", s(", ", C.map(g, F)), k(C, D), ">"];
              let b = l.type === "TSTypeParameterInstantiation" ? "" : h(l).length === 1 && p(D) && !l[F][0].constraint && C.getParentNode().type === "ArrowFunctionExpression" ? "," : f(D, "all") ? c(",") : "";
              return i(["<", o([u, s([",", a], C.map(g, F))]), b, u, ">"], { id: B(l) });
            }
            function k(C, D) {
              let g = C.getValue();
              if (!m(g, d.Dangling))
                return "";
              let F = !m(g, d.Line), l = t3(C, D, F);
              return F ? l : [l, r];
            }
            function P(C, D, g) {
              let F = C.getValue(), l = [], E = C.getParentNode();
              return E.type === "TSMappedType" ? (l.push("[", g("name")), F.constraint && l.push(" in ", g("constraint")), E.nameType && l.push(" as ", C.callParent(() => g("nameType"))), l.push("]"), l) : (F.variance && l.push(g("variance")), F.in && l.push("in "), F.out && l.push("out "), l.push(g("name")), F.bound && l.push(": ", g("bound")), F.constraint && l.push(" extends ", g("constraint")), F.default && l.push(" = ", g("default")), l);
            }
            n.exports = { printTypeParameter: P, printTypeParameters: I, getTypeParametersGroupId: B };
          } }), Qt = Z({ "src/language-js/print/property.js"(e, n) {
            "use strict";
            re();
            var { printComments: t3 } = et(), { printString: s, printNumber: a } = Ue(), { isNumericLiteral: r, isSimpleNumber: u, isStringLiteral: i, isStringPropSafeToUnquote: o, rawText: c } = Ke(), { printAssignment: v } = Yt(), m = /* @__PURE__ */ new WeakMap();
            function d(f, h, w) {
              let T = f.getNode();
              if (T.computed)
                return ["[", w("key"), "]"];
              let A = f.getParentNode(), { key: S } = T;
              if (T.type === "ClassPrivateProperty" && S.type === "Identifier")
                return ["#", w("key")];
              if (h.quoteProps === "consistent" && !m.has(A)) {
                let B = (A.properties || A.body || A.members).some((I) => !I.computed && I.key && i(I.key) && !o(I, h));
                m.set(A, B);
              }
              if ((S.type === "Identifier" || r(S) && u(a(c(S))) && String(S.value) === a(c(S)) && !(h.parser === "typescript" || h.parser === "babel-ts")) && (h.parser === "json" || h.quoteProps === "consistent" && m.get(A))) {
                let B = s(JSON.stringify(S.type === "Identifier" ? S.name : S.value.toString()), h);
                return f.call((I) => t3(I, B, h), "key");
              }
              return o(T, h) && (h.quoteProps === "as-needed" || h.quoteProps === "consistent" && !m.get(A)) ? f.call((B) => t3(B, /^\d/.test(S.value) ? a(S.value) : S.value, h), "key") : w("key");
            }
            function p(f, h, w) {
              return f.getValue().shorthand ? w("value") : v(f, h, w, d(f, h, w), ":", "value");
            }
            n.exports = { printProperty: p, printPropertyKey: d };
          } }), Lr = Z({ "src/language-js/print/function.js"(e, n) {
            "use strict";
            re();
            var t3 = Xt(), { printDanglingComments: s, printCommentsSeparately: a } = et(), r = it(), { getNextNonSpaceNonCommentCharacterIndex: u } = Ue(), { builders: { line: i, softline: o, group: c, indent: v, ifBreak: m, hardline: d, join: p, indentIfBreak: f }, utils: { removeLines: h, willBreak: w } } = Oe(), { ArgExpansionBailout: T } = zt(), { getFunctionParameters: A, hasLeadingOwnLineComment: S, isFlowAnnotationComment: B, isJsxNode: I, isTemplateOnItsOwnLine: k, shouldPrintComma: P, startsWithNoLookaheadToken: C, isBinaryish: D, isLineComment: g, hasComment: F, getComments: l, CommentCheckFlags: E, isCallLikeExpression: y, isCallExpression: N, getCallArguments: x, hasNakedLeftSide: b, getLeftSide: L } = Ke(), { locEnd: M } = st(), { printFunctionParameters: j, shouldGroupFunctionParameters: $ } = Pr(), { printPropertyKey: V } = Qt(), { printFunctionTypeParameters: q } = ct();
            function Y(z, U, le, ge) {
              let Ae = z.getValue(), Ne = false;
              if ((Ae.type === "FunctionDeclaration" || Ae.type === "FunctionExpression") && ge && ge.expandLastArg) {
                let ae = z.getParentNode();
                N(ae) && x(ae).length > 1 && (Ne = true);
              }
              let ke = [];
              Ae.type === "TSDeclareFunction" && Ae.declare && ke.push("declare "), Ae.async && ke.push("async "), Ae.generator ? ke.push("function* ") : ke.push("function "), Ae.id && ke.push(U("id"));
              let ce = j(z, U, le, Ne), pe = X(z, U, le), de = $(Ae, pe);
              return ke.push(q(z, le, U), c([de ? c(ce) : ce, pe]), Ae.body ? " " : "", U("body")), le.semi && (Ae.declare || !Ae.body) && ke.push(";"), ke;
            }
            function H(z, U, le) {
              let ge = z.getNode(), { kind: Ae } = ge, Ne = ge.value || ge, ke = [];
              return !Ae || Ae === "init" || Ae === "method" || Ae === "constructor" ? Ne.async && ke.push("async ") : (t3.ok(Ae === "get" || Ae === "set"), ke.push(Ae, " ")), Ne.generator && ke.push("*"), ke.push(V(z, U, le), ge.optional || ge.key.optional ? "?" : ""), ge === Ne ? ke.push(R(z, U, le)) : Ne.type === "FunctionExpression" ? ke.push(z.call((ce) => R(ce, U, le), "value")) : ke.push(le("value")), ke;
            }
            function R(z, U, le) {
              let ge = z.getNode(), Ae = j(z, le, U), Ne = X(z, le, U), ke = $(ge, Ne), ce = [q(z, U, le), c([ke ? c(Ae) : Ae, Ne])];
              return ge.body ? ce.push(" ", le("body")) : ce.push(U.semi ? ";" : ""), ce;
            }
            function Q(z, U, le, ge) {
              let Ae = z.getValue(), Ne = [];
              if (Ae.async && Ne.push("async "), W(z, U))
                Ne.push(le(["params", 0]));
              else {
                let ce = ge && (ge.expandLastArg || ge.expandFirstArg), pe = X(z, le, U);
                if (ce) {
                  if (w(pe))
                    throw new T();
                  pe = c(h(pe));
                }
                Ne.push(c([j(z, le, U, ce, true), pe]));
              }
              let ke = s(z, U, true, (ce) => {
                let pe = u(U.originalText, ce, M);
                return pe !== false && U.originalText.slice(pe, pe + 2) === "=>";
              });
              return ke && Ne.push(" ", ke), Ne;
            }
            function ee(z, U, le, ge, Ae, Ne) {
              let ke = z.getName(), ce = z.getParentNode(), pe = y(ce) && ke === "callee", de = Boolean(U && U.assignmentLayout), ae = Ne.body.type !== "BlockStatement" && Ne.body.type !== "ObjectExpression" && Ne.body.type !== "SequenceExpression", ve = pe && ae || U && U.assignmentLayout === "chain-tail-arrow-chain", K = Symbol("arrow-chain");
              return Ne.body.type === "SequenceExpression" && (Ae = c(["(", v([o, Ae]), o, ")"])), c([c(v([pe || de ? o : "", c(p([" =>", i], le), { shouldBreak: ge })]), { id: K, shouldBreak: ve }), " =>", f(ae ? v([i, Ae]) : [" ", Ae], { groupId: K }), pe ? m(o, "", { groupId: K }) : ""]);
            }
            function te(z, U, le, ge) {
              let Ae = z.getValue(), Ne = [], ke = [], ce = false;
              if (function K() {
                let he = Q(z, U, le, ge);
                if (Ne.length === 0)
                  Ne.push(he);
                else {
                  let { leading: ye, trailing: Ce } = a(z, U);
                  Ne.push([ye, he]), ke.unshift(Ce);
                }
                ce = ce || Ae.returnType && A(Ae).length > 0 || Ae.typeParameters || A(Ae).some((ye) => ye.type !== "Identifier"), Ae.body.type !== "ArrowFunctionExpression" || ge && ge.expandLastArg ? ke.unshift(le("body", ge)) : (Ae = Ae.body, z.call(K, "body"));
              }(), Ne.length > 1)
                return ee(z, ge, Ne, ce, ke, Ae);
              let pe = Ne;
              if (pe.push(" =>"), !S(U.originalText, Ae.body) && (Ae.body.type === "ArrayExpression" || Ae.body.type === "ObjectExpression" || Ae.body.type === "BlockStatement" || I(Ae.body) || k(Ae.body, U.originalText) || Ae.body.type === "ArrowFunctionExpression" || Ae.body.type === "DoExpression"))
                return c([...pe, " ", ke]);
              if (Ae.body.type === "SequenceExpression")
                return c([...pe, c([" (", v([o, ke]), o, ")"])]);
              let de = (ge && ge.expandLastArg || z.getParentNode().type === "JSXExpressionContainer") && !F(Ae), ae = ge && ge.expandLastArg && P(U, "all"), ve = Ae.body.type === "ConditionalExpression" && !C(Ae.body, false);
              return c([...pe, c([v([i, ve ? m("", "(") : "", ke, ve ? m("", ")") : ""]), de ? [m(ae ? "," : ""), o] : ""])]);
            }
            function oe(z) {
              let U = A(z);
              return U.length === 1 && !z.typeParameters && !F(z, E.Dangling) && U[0].type === "Identifier" && !U[0].typeAnnotation && !F(U[0]) && !U[0].optional && !z.predicate && !z.returnType;
            }
            function W(z, U) {
              if (U.arrowParens === "always")
                return false;
              if (U.arrowParens === "avoid") {
                let le = z.getValue();
                return oe(le);
              }
              return false;
            }
            function X(z, U, le) {
              let ge = z.getValue(), Ae = U("returnType");
              if (ge.returnType && B(le.originalText, ge.returnType))
                return [" /*: ", Ae, " */"];
              let Ne = [Ae];
              return ge.returnType && ge.returnType.typeAnnotation && Ne.unshift(": "), ge.predicate && Ne.push(ge.returnType ? " " : ": ", U("predicate")), Ne;
            }
            function ue(z, U, le) {
              let ge = z.getValue(), Ae = U.semi ? ";" : "", Ne = [];
              ge.argument && (G(U, ge.argument) ? Ne.push([" (", v([d, le("argument")]), d, ")"]) : D(ge.argument) || ge.argument.type === "SequenceExpression" ? Ne.push(c([m(" (", " "), v([o, le("argument")]), o, m(")")])) : Ne.push(" ", le("argument")));
              let ke = l(ge), ce = r(ke), pe = ce && g(ce);
              return pe && Ne.push(Ae), F(ge, E.Dangling) && Ne.push(" ", s(z, U, true)), pe || Ne.push(Ae), Ne;
            }
            function De(z, U, le) {
              return ["return", ue(z, U, le)];
            }
            function ie(z, U, le) {
              return ["throw", ue(z, U, le)];
            }
            function G(z, U) {
              if (S(z.originalText, U))
                return true;
              if (b(U)) {
                let le = U, ge;
                for (; ge = L(le); )
                  if (le = ge, S(z.originalText, le))
                    return true;
              }
              return false;
            }
            n.exports = { printFunction: Y, printArrowFunction: te, printMethod: H, printReturnStatement: De, printThrowStatement: ie, printMethodInternal: R, shouldPrintParamsWithoutParens: W };
          } }), Un = Z({ "src/language-js/print/decorators.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3, hasNewline: s } = Ue(), { builders: { line: a, hardline: r, join: u, breakParent: i, group: o } } = Oe(), { locStart: c, locEnd: v } = st(), { getParentExportDeclaration: m } = Ke();
            function d(T, A, S) {
              let B = T.getValue();
              return o([u(a, T.map(S, "decorators")), h(B, A) ? r : a]);
            }
            function p(T, A, S) {
              return [u(r, T.map(S, "declaration", "decorators")), r];
            }
            function f(T, A, S) {
              let B = T.getValue(), { decorators: I } = B;
              if (!t3(I) || w(T.getParentNode()))
                return;
              let k = B.type === "ClassExpression" || B.type === "ClassDeclaration" || h(B, A);
              return [m(T) ? r : k ? i : "", u(a, T.map(S, "decorators")), a];
            }
            function h(T, A) {
              return T.decorators.some((S) => s(A.originalText, v(S)));
            }
            function w(T) {
              if (T.type !== "ExportDefaultDeclaration" && T.type !== "ExportNamedDeclaration" && T.type !== "DeclareExportDeclaration")
                return false;
              let A = T.declaration && T.declaration.decorators;
              return t3(A) && c(T, { ignoreDecorators: true }) > c(A[0]);
            }
            n.exports = { printDecorators: f, printClassMemberDecorators: d, printDecoratorsBeforeExport: p, hasDecoratorsBeforeExport: w };
          } }), Zt = Z({ "src/language-js/print/class.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3, createGroupIdMapper: s } = Ue(), { printComments: a, printDanglingComments: r } = et(), { builders: { join: u, line: i, hardline: o, softline: c, group: v, indent: m, ifBreak: d } } = Oe(), { hasComment: p, CommentCheckFlags: f } = Ke(), { getTypeParametersGroupId: h } = Ir(), { printMethod: w } = Lr(), { printOptionalToken: T, printTypeAnnotation: A, printDefiniteToken: S } = ct(), { printPropertyKey: B } = Qt(), { printAssignment: I } = Yt(), { printClassMemberDecorators: k } = Un();
            function P(x, b, L) {
              let M = x.getValue(), j = [];
              M.declare && j.push("declare "), M.abstract && j.push("abstract "), j.push("class");
              let $ = M.id && p(M.id, f.Trailing) || M.typeParameters && p(M.typeParameters, f.Trailing) || M.superClass && p(M.superClass) || t3(M.extends) || t3(M.mixins) || t3(M.implements), V = [], q = [];
              if (M.id && V.push(" ", L("id")), V.push(L("typeParameters")), M.superClass) {
                let Y = [E(x, b, L), L("superTypeParameters")], H = x.call((R) => ["extends ", a(R, Y, b)], "superClass");
                $ ? q.push(i, v(H)) : q.push(" ", H);
              } else
                q.push(l(x, b, L, "extends"));
              if (q.push(l(x, b, L, "mixins"), l(x, b, L, "implements")), $) {
                let Y;
                F(M) ? Y = [...V, m(q)] : Y = m([...V, q]), j.push(v(Y, { id: C(M) }));
              } else
                j.push(...V, ...q);
              return j.push(" ", L("body")), j;
            }
            var C = s("heritageGroup");
            function D(x) {
              return d(o, "", { groupId: C(x) });
            }
            function g(x) {
              return ["superClass", "extends", "mixins", "implements"].filter((b) => Boolean(x[b])).length > 1;
            }
            function F(x) {
              return x.typeParameters && !p(x.typeParameters, f.Trailing | f.Line) && !g(x);
            }
            function l(x, b, L, M) {
              let j = x.getValue();
              if (!t3(j[M]))
                return "";
              let $ = r(x, b, true, (V) => {
                let { marker: q } = V;
                return q === M;
              });
              return [F(j) ? d(" ", i, { groupId: h(j.typeParameters) }) : i, $, $ && o, M, v(m([i, u([",", i], x.map(L, M))]))];
            }
            function E(x, b, L) {
              let M = L("superClass");
              return x.getParentNode().type === "AssignmentExpression" ? v(d(["(", m([c, M]), c, ")"], M)) : M;
            }
            function y(x, b, L) {
              let M = x.getValue(), j = [];
              return t3(M.decorators) && j.push(k(x, b, L)), M.accessibility && j.push(M.accessibility + " "), M.readonly && j.push("readonly "), M.declare && j.push("declare "), M.static && j.push("static "), (M.type === "TSAbstractMethodDefinition" || M.abstract) && j.push("abstract "), M.override && j.push("override "), j.push(w(x, b, L)), j;
            }
            function N(x, b, L) {
              let M = x.getValue(), j = [], $ = b.semi ? ";" : "";
              return t3(M.decorators) && j.push(k(x, b, L)), M.accessibility && j.push(M.accessibility + " "), M.declare && j.push("declare "), M.static && j.push("static "), (M.type === "TSAbstractPropertyDefinition" || M.abstract) && j.push("abstract "), M.override && j.push("override "), M.readonly && j.push("readonly "), M.variance && j.push(L("variance")), M.type === "ClassAccessorProperty" && j.push("accessor "), j.push(B(x, b, L), T(x), S(x), A(x, b, L)), [I(x, b, L, j, " =", "value"), $];
            }
            n.exports = { printClass: P, printClassMethod: y, printClassProperty: N, printHardlineAfterHeritage: D };
          } }), lo = Z({ "src/language-js/print/interface.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3 } = Ue(), { builders: { join: s, line: a, group: r, indent: u, ifBreak: i } } = Oe(), { hasComment: o, identity: c, CommentCheckFlags: v } = Ke(), { getTypeParametersGroupId: m } = Ir(), { printTypeScriptModifiers: d } = ct();
            function p(f, h, w) {
              let T = f.getValue(), A = [];
              T.declare && A.push("declare "), T.type === "TSInterfaceDeclaration" && A.push(T.abstract ? "abstract " : "", d(f, h, w)), A.push("interface");
              let S = [], B = [];
              T.type !== "InterfaceTypeAnnotation" && S.push(" ", w("id"), w("typeParameters"));
              let I = T.typeParameters && !o(T.typeParameters, v.Trailing | v.Line);
              return t3(T.extends) && B.push(I ? i(" ", a, { groupId: m(T.typeParameters) }) : a, "extends ", (T.extends.length === 1 ? c : u)(s([",", a], f.map(w, "extends")))), T.id && o(T.id, v.Trailing) || t3(T.extends) ? I ? A.push(r([...S, u(B)])) : A.push(r(u([...S, ...B]))) : A.push(...S, ...B), A.push(" ", w("body")), r(A);
            }
            n.exports = { printInterface: p };
          } }), co = Z({ "src/language-js/print/module.js"(e, n) {
            "use strict";
            re();
            var { isNonEmptyArray: t3 } = Ue(), { builders: { softline: s, group: a, indent: r, join: u, line: i, ifBreak: o, hardline: c } } = Oe(), { printDanglingComments: v } = et(), { hasComment: m, CommentCheckFlags: d, shouldPrintComma: p, needsHardlineAfterDanglingComment: f, isStringLiteral: h, rawText: w } = Ke(), { locStart: T, hasSameLoc: A } = st(), { hasDecoratorsBeforeExport: S, printDecoratorsBeforeExport: B } = Un();
            function I(N, x, b) {
              let L = N.getValue(), M = x.semi ? ";" : "", j = [], { importKind: $ } = L;
              return j.push("import"), $ && $ !== "value" && j.push(" ", $), j.push(g(N, x, b), D(N, x, b), l(N, x, b), M), j;
            }
            function k(N, x, b) {
              let L = N.getValue(), M = [];
              S(L) && M.push(B(N, x, b));
              let { type: j, exportKind: $, declaration: V } = L;
              return M.push("export"), (L.default || j === "ExportDefaultDeclaration") && M.push(" default"), m(L, d.Dangling) && (M.push(" ", v(N, x, true)), f(L) && M.push(c)), V ? M.push(" ", b("declaration")) : M.push($ === "type" ? " type" : "", g(N, x, b), D(N, x, b), l(N, x, b)), C(L, x) && M.push(";"), M;
            }
            function P(N, x, b) {
              let L = N.getValue(), M = x.semi ? ";" : "", j = [], { exportKind: $, exported: V } = L;
              return j.push("export"), $ === "type" && j.push(" type"), j.push(" *"), V && j.push(" as ", b("exported")), j.push(D(N, x, b), l(N, x, b), M), j;
            }
            function C(N, x) {
              if (!x.semi)
                return false;
              let { type: b, declaration: L } = N, M = N.default || b === "ExportDefaultDeclaration";
              if (!L)
                return true;
              let { type: j } = L;
              return !!(M && j !== "ClassDeclaration" && j !== "FunctionDeclaration" && j !== "TSInterfaceDeclaration" && j !== "DeclareClass" && j !== "DeclareFunction" && j !== "TSDeclareFunction" && j !== "EnumDeclaration");
            }
            function D(N, x, b) {
              let L = N.getValue();
              if (!L.source)
                return "";
              let M = [];
              return F(L, x) || M.push(" from"), M.push(" ", b("source")), M;
            }
            function g(N, x, b) {
              let L = N.getValue();
              if (F(L, x))
                return "";
              let M = [" "];
              if (t3(L.specifiers)) {
                let j = [], $ = [];
                N.each(() => {
                  let V = N.getValue().type;
                  if (V === "ExportNamespaceSpecifier" || V === "ExportDefaultSpecifier" || V === "ImportNamespaceSpecifier" || V === "ImportDefaultSpecifier")
                    j.push(b());
                  else if (V === "ExportSpecifier" || V === "ImportSpecifier")
                    $.push(b());
                  else
                    throw new Error("Unknown specifier type ".concat(JSON.stringify(V)));
                }, "specifiers"), M.push(u(", ", j)), $.length > 0 && (j.length > 0 && M.push(", "), $.length > 1 || j.length > 0 || L.specifiers.some((q) => m(q)) ? M.push(a(["{", r([x.bracketSpacing ? i : s, u([",", i], $)]), o(p(x) ? "," : ""), x.bracketSpacing ? i : s, "}"])) : M.push(["{", x.bracketSpacing ? " " : "", ...$, x.bracketSpacing ? " " : "", "}"]));
              } else
                M.push("{}");
              return M;
            }
            function F(N, x) {
              let { type: b, importKind: L, source: M, specifiers: j } = N;
              return b !== "ImportDeclaration" || t3(j) || L === "type" ? false : !/{\s*}/.test(x.originalText.slice(T(N), T(M)));
            }
            function l(N, x, b) {
              let L = N.getNode();
              return t3(L.assertions) ? [" assert {", x.bracketSpacing ? " " : "", u(", ", N.map(b, "assertions")), x.bracketSpacing ? " " : "", "}"] : "";
            }
            function E(N, x, b) {
              let L = N.getNode(), { type: M } = L, j = [], $ = M === "ImportSpecifier" ? L.importKind : L.exportKind;
              $ && $ !== "value" && j.push($, " ");
              let V = M.startsWith("Import"), q = V ? "imported" : "local", Y = V ? "local" : "exported", H = L[q], R = L[Y], Q = "", ee = "";
              return M === "ExportNamespaceSpecifier" || M === "ImportNamespaceSpecifier" ? Q = "*" : H && (Q = b(q)), R && !y(L) && (ee = b(Y)), j.push(Q, Q && ee ? " as " : "", ee), j;
            }
            function y(N) {
              if (N.type !== "ImportSpecifier" && N.type !== "ExportSpecifier")
                return false;
              let { local: x, [N.type === "ImportSpecifier" ? "imported" : "exported"]: b } = N;
              if (x.type !== b.type || !A(x, b))
                return false;
              if (h(x))
                return x.value === b.value && w(x) === w(b);
              switch (x.type) {
                case "Identifier":
                  return x.name === b.name;
                default:
                  return false;
              }
            }
            n.exports = { printImportDeclaration: I, printExportDeclaration: k, printExportAllDeclaration: P, printModuleSpecifier: E };
          } }), zn = Z({ "src/language-js/print/object.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { builders: { line: s, softline: a, group: r, indent: u, ifBreak: i, hardline: o } } = Oe(), { getLast: c, hasNewlineInRange: v, hasNewline: m, isNonEmptyArray: d } = Ue(), { shouldPrintComma: p, hasComment: f, getComments: h, CommentCheckFlags: w, isNextLineEmpty: T } = Ke(), { locStart: A, locEnd: S } = st(), { printOptionalToken: B, printTypeAnnotation: I } = ct(), { shouldHugFunctionParameters: k } = Pr(), { shouldHugType: P } = kr(), { printHardlineAfterHeritage: C } = Zt();
            function D(g, F, l) {
              let E = F.semi ? ";" : "", y = g.getValue(), N;
              y.type === "TSTypeLiteral" ? N = "members" : y.type === "TSInterfaceBody" ? N = "body" : N = "properties";
              let x = y.type === "ObjectTypeAnnotation", b = [N];
              x && b.push("indexers", "callProperties", "internalSlots");
              let L = b.map((W) => y[W][0]).sort((W, X) => A(W) - A(X))[0], M = g.getParentNode(0), j = x && M && (M.type === "InterfaceDeclaration" || M.type === "DeclareInterface" || M.type === "DeclareClass") && g.getName() === "body", $ = y.type === "TSInterfaceBody" || j || y.type === "ObjectPattern" && M.type !== "FunctionDeclaration" && M.type !== "FunctionExpression" && M.type !== "ArrowFunctionExpression" && M.type !== "ObjectMethod" && M.type !== "ClassMethod" && M.type !== "ClassPrivateMethod" && M.type !== "AssignmentPattern" && M.type !== "CatchClause" && y.properties.some((W) => W.value && (W.value.type === "ObjectPattern" || W.value.type === "ArrayPattern")) || y.type !== "ObjectPattern" && L && v(F.originalText, A(y), A(L)), V = j ? ";" : y.type === "TSInterfaceBody" || y.type === "TSTypeLiteral" ? i(E, ";") : ",", q = y.type === "RecordExpression" ? "#{" : y.exact ? "{|" : "{", Y = y.exact ? "|}" : "}", H = [];
              for (let W of b)
                g.each((X) => {
                  let ue = X.getValue();
                  H.push({ node: ue, printed: l(), loc: A(ue) });
                }, W);
              b.length > 1 && H.sort((W, X) => W.loc - X.loc);
              let R = [], Q = H.map((W) => {
                let X = [...R, r(W.printed)];
                return R = [V, s], (W.node.type === "TSPropertySignature" || W.node.type === "TSMethodSignature" || W.node.type === "TSConstructSignatureDeclaration") && f(W.node, w.PrettierIgnore) && R.shift(), T(W.node, F) && R.push(o), X;
              });
              if (y.inexact) {
                let W;
                if (f(y, w.Dangling)) {
                  let X = f(y, w.Line);
                  W = [t3(g, F, true), X || m(F.originalText, S(c(h(y)))) ? o : s, "..."];
                } else
                  W = ["..."];
                Q.push([...R, ...W]);
              }
              let ee = c(y[N]), te = !(y.inexact || ee && ee.type === "RestElement" || ee && (ee.type === "TSPropertySignature" || ee.type === "TSCallSignatureDeclaration" || ee.type === "TSMethodSignature" || ee.type === "TSConstructSignatureDeclaration") && f(ee, w.PrettierIgnore)), oe;
              if (Q.length === 0) {
                if (!f(y, w.Dangling))
                  return [q, Y, I(g, F, l)];
                oe = r([q, t3(g, F), a, Y, B(g), I(g, F, l)]);
              } else
                oe = [j && d(y.properties) ? C(M) : "", q, u([F.bracketSpacing ? s : a, ...Q]), i(te && (V !== "," || p(F)) ? V : ""), F.bracketSpacing ? s : a, Y, B(g), I(g, F, l)];
              return g.match((W) => W.type === "ObjectPattern" && !W.decorators, (W, X, ue) => k(W) && (X === "params" || X === "parameters" || X === "this" || X === "rest") && ue === 0) || g.match(P, (W, X) => X === "typeAnnotation", (W, X) => X === "typeAnnotation", (W, X, ue) => k(W) && (X === "params" || X === "parameters" || X === "this" || X === "rest") && ue === 0) || !$ && g.match((W) => W.type === "ObjectPattern", (W) => W.type === "AssignmentExpression" || W.type === "VariableDeclarator") ? oe : r(oe, { shouldBreak: $ });
            }
            n.exports = { printObject: D };
          } }), Um = Z({ "src/language-js/print/flow.js"(e, n) {
            "use strict";
            re();
            var t3 = Xt(), { printDanglingComments: s } = et(), { printString: a, printNumber: r } = Ue(), { builders: { hardline: u, softline: i, group: o, indent: c } } = Oe(), { getParentExportDeclaration: v, isFunctionNotation: m, isGetterOrSetter: d, rawText: p, shouldPrintComma: f } = Ke(), { locStart: h, locEnd: w } = st(), { printClass: T } = Zt(), { printOpaqueType: A, printTypeAlias: S, printIntersectionType: B, printUnionType: I, printFunctionType: k, printTupleType: P, printIndexedAccessType: C } = kr(), { printInterface: D } = lo(), { printTypeParameter: g, printTypeParameters: F } = Ir(), { printExportDeclaration: l, printExportAllDeclaration: E } = co(), { printArrayItems: y } = Kt(), { printObject: N } = zn(), { printPropertyKey: x } = Qt(), { printOptionalToken: b, printTypeAnnotation: L, printRestSpread: M } = ct();
            function j(V, q, Y) {
              let H = V.getValue(), R = q.semi ? ";" : "", Q = [];
              switch (H.type) {
                case "DeclareClass":
                  return $(V, T(V, q, Y));
                case "DeclareFunction":
                  return $(V, ["function ", Y("id"), H.predicate ? " " : "", Y("predicate"), R]);
                case "DeclareModule":
                  return $(V, ["module ", Y("id"), " ", Y("body")]);
                case "DeclareModuleExports":
                  return $(V, ["module.exports", ": ", Y("typeAnnotation"), R]);
                case "DeclareVariable":
                  return $(V, ["var ", Y("id"), R]);
                case "DeclareOpaqueType":
                  return $(V, A(V, q, Y));
                case "DeclareInterface":
                  return $(V, D(V, q, Y));
                case "DeclareTypeAlias":
                  return $(V, S(V, q, Y));
                case "DeclareExportDeclaration":
                  return $(V, l(V, q, Y));
                case "DeclareExportAllDeclaration":
                  return $(V, E(V, q, Y));
                case "OpaqueType":
                  return A(V, q, Y);
                case "TypeAlias":
                  return S(V, q, Y);
                case "IntersectionTypeAnnotation":
                  return B(V, q, Y);
                case "UnionTypeAnnotation":
                  return I(V, q, Y);
                case "FunctionTypeAnnotation":
                  return k(V, q, Y);
                case "TupleTypeAnnotation":
                  return P(V, q, Y);
                case "GenericTypeAnnotation":
                  return [Y("id"), F(V, q, Y, "typeParameters")];
                case "IndexedAccessType":
                case "OptionalIndexedAccessType":
                  return C(V, q, Y);
                case "TypeAnnotation":
                  return Y("typeAnnotation");
                case "TypeParameter":
                  return g(V, q, Y);
                case "TypeofTypeAnnotation":
                  return ["typeof ", Y("argument")];
                case "ExistsTypeAnnotation":
                  return "*";
                case "EmptyTypeAnnotation":
                  return "empty";
                case "MixedTypeAnnotation":
                  return "mixed";
                case "ArrayTypeAnnotation":
                  return [Y("elementType"), "[]"];
                case "BooleanLiteralTypeAnnotation":
                  return String(H.value);
                case "EnumDeclaration":
                  return ["enum ", Y("id"), " ", Y("body")];
                case "EnumBooleanBody":
                case "EnumNumberBody":
                case "EnumStringBody":
                case "EnumSymbolBody": {
                  if (H.type === "EnumSymbolBody" || H.explicitType) {
                    let ee = null;
                    switch (H.type) {
                      case "EnumBooleanBody":
                        ee = "boolean";
                        break;
                      case "EnumNumberBody":
                        ee = "number";
                        break;
                      case "EnumStringBody":
                        ee = "string";
                        break;
                      case "EnumSymbolBody":
                        ee = "symbol";
                        break;
                    }
                    Q.push("of ", ee, " ");
                  }
                  if (H.members.length === 0 && !H.hasUnknownMembers)
                    Q.push(o(["{", s(V, q), i, "}"]));
                  else {
                    let ee = H.members.length > 0 ? [u, y(V, q, "members", Y), H.hasUnknownMembers || f(q) ? "," : ""] : [];
                    Q.push(o(["{", c([...ee, ...H.hasUnknownMembers ? [u, "..."] : []]), s(V, q, true), u, "}"]));
                  }
                  return Q;
                }
                case "EnumBooleanMember":
                case "EnumNumberMember":
                case "EnumStringMember":
                  return [Y("id"), " = ", typeof H.init == "object" ? Y("init") : String(H.init)];
                case "EnumDefaultedMember":
                  return Y("id");
                case "FunctionTypeParam": {
                  let ee = H.name ? Y("name") : V.getParentNode().this === H ? "this" : "";
                  return [ee, b(V), ee ? ": " : "", Y("typeAnnotation")];
                }
                case "InterfaceDeclaration":
                case "InterfaceTypeAnnotation":
                  return D(V, q, Y);
                case "ClassImplements":
                case "InterfaceExtends":
                  return [Y("id"), Y("typeParameters")];
                case "NullableTypeAnnotation":
                  return ["?", Y("typeAnnotation")];
                case "Variance": {
                  let { kind: ee } = H;
                  return t3.ok(ee === "plus" || ee === "minus"), ee === "plus" ? "+" : "-";
                }
                case "ObjectTypeCallProperty":
                  return H.static && Q.push("static "), Q.push(Y("value")), Q;
                case "ObjectTypeIndexer":
                  return [H.static ? "static " : "", H.variance ? Y("variance") : "", "[", Y("id"), H.id ? ": " : "", Y("key"), "]: ", Y("value")];
                case "ObjectTypeProperty": {
                  let ee = "";
                  return H.proto ? ee = "proto " : H.static && (ee = "static "), [ee, d(H) ? H.kind + " " : "", H.variance ? Y("variance") : "", x(V, q, Y), b(V), m(H) ? "" : ": ", Y("value")];
                }
                case "ObjectTypeAnnotation":
                  return N(V, q, Y);
                case "ObjectTypeInternalSlot":
                  return [H.static ? "static " : "", "[[", Y("id"), "]]", b(V), H.method ? "" : ": ", Y("value")];
                case "ObjectTypeSpreadProperty":
                  return M(V, q, Y);
                case "QualifiedTypeofIdentifier":
                case "QualifiedTypeIdentifier":
                  return [Y("qualification"), ".", Y("id")];
                case "StringLiteralTypeAnnotation":
                  return a(p(H), q);
                case "NumberLiteralTypeAnnotation":
                  t3.strictEqual(typeof H.value, "number");
                case "BigIntLiteralTypeAnnotation":
                  return H.extra ? r(H.extra.raw) : r(H.raw);
                case "TypeCastExpression":
                  return ["(", Y("expression"), L(V, q, Y), ")"];
                case "TypeParameterDeclaration":
                case "TypeParameterInstantiation": {
                  let ee = F(V, q, Y, "params");
                  if (q.parser === "flow") {
                    let te = h(H), oe = w(H), W = q.originalText.lastIndexOf("/*", te), X = q.originalText.indexOf("*/", oe);
                    if (W !== -1 && X !== -1) {
                      let ue = q.originalText.slice(W + 2, X).trim();
                      if (ue.startsWith("::") && !ue.includes("/*") && !ue.includes("*/"))
                        return ["/*:: ", ee, " */"];
                    }
                  }
                  return ee;
                }
                case "InferredPredicate":
                  return "%checks";
                case "DeclaredPredicate":
                  return ["%checks(", Y("value"), ")"];
                case "AnyTypeAnnotation":
                  return "any";
                case "BooleanTypeAnnotation":
                  return "boolean";
                case "BigIntTypeAnnotation":
                  return "bigint";
                case "NullLiteralTypeAnnotation":
                  return "null";
                case "NumberTypeAnnotation":
                  return "number";
                case "SymbolTypeAnnotation":
                  return "symbol";
                case "StringTypeAnnotation":
                  return "string";
                case "VoidTypeAnnotation":
                  return "void";
                case "ThisTypeAnnotation":
                  return "this";
                case "Node":
                case "Printable":
                case "SourceLocation":
                case "Position":
                case "Statement":
                case "Function":
                case "Pattern":
                case "Expression":
                case "Declaration":
                case "Specifier":
                case "NamedSpecifier":
                case "Comment":
                case "MemberTypeAnnotation":
                case "Type":
                  throw new Error("unprintable type: " + JSON.stringify(H.type));
              }
            }
            function $(V, q) {
              let Y = v(V);
              return Y ? (t3.strictEqual(Y.type, "DeclareExportDeclaration"), q) : ["declare ", q];
            }
            n.exports = { printFlow: j };
          } }), zm = Z({ "src/language-js/utils/is-ts-keyword-type.js"(e, n) {
            "use strict";
            re();
            function t3(s) {
              let { type: a } = s;
              return a.startsWith("TS") && a.endsWith("Keyword");
            }
            n.exports = t3;
          } }), po = Z({ "src/language-js/print/ternary.js"(e, n) {
            "use strict";
            re();
            var { hasNewlineInRange: t3 } = Ue(), { isJsxNode: s, getComments: a, isCallExpression: r, isMemberExpression: u } = Ke(), { locStart: i, locEnd: o } = st(), c = It(), { builders: { line: v, softline: m, group: d, indent: p, align: f, ifBreak: h, dedent: w, breakParent: T } } = Oe();
            function A(P) {
              let C = [P];
              for (let D = 0; D < C.length; D++) {
                let g = C[D];
                for (let F of ["test", "consequent", "alternate"]) {
                  let l = g[F];
                  if (s(l))
                    return true;
                  l.type === "ConditionalExpression" && C.push(l);
                }
              }
              return false;
            }
            function S(P, C, D) {
              let g = P.getValue(), F = g.type === "ConditionalExpression", l = F ? "alternate" : "falseType", E = P.getParentNode(), y = F ? D("test") : [D("checkType"), " ", "extends", " ", D("extendsType")];
              return E.type === g.type && E[l] === g ? f(2, y) : y;
            }
            var B = /* @__PURE__ */ new Map([["AssignmentExpression", "right"], ["VariableDeclarator", "init"], ["ReturnStatement", "argument"], ["ThrowStatement", "argument"], ["UnaryExpression", "argument"], ["YieldExpression", "argument"]]);
            function I(P) {
              let C = P.getValue();
              if (C.type !== "ConditionalExpression")
                return false;
              let D, g = C;
              for (let F = 0; !D; F++) {
                let l = P.getParentNode(F);
                if (r(l) && l.callee === g || u(l) && l.object === g || l.type === "TSNonNullExpression" && l.expression === g) {
                  g = l;
                  continue;
                }
                l.type === "NewExpression" && l.callee === g || l.type === "TSAsExpression" && l.expression === g ? (D = P.getParentNode(F + 1), g = l) : D = l;
              }
              return g === C ? false : D[B.get(D.type)] === g;
            }
            function k(P, C, D) {
              let g = P.getValue(), F = g.type === "ConditionalExpression", l = F ? "consequent" : "trueType", E = F ? "alternate" : "falseType", y = F ? ["test"] : ["checkType", "extendsType"], N = g[l], x = g[E], b = [], L = false, M = P.getParentNode(), j = M.type === g.type && y.some((ue) => M[ue] === g), $ = M.type === g.type && !j, V, q, Y = 0;
              do
                q = V || g, V = P.getParentNode(Y), Y++;
              while (V && V.type === g.type && y.every((ue) => V[ue] !== q));
              let H = V || M, R = q;
              if (F && (s(g[y[0]]) || s(N) || s(x) || A(R))) {
                L = true, $ = true;
                let ue = (ie) => [h("("), p([m, ie]), m, h(")")], De = (ie) => ie.type === "NullLiteral" || ie.type === "Literal" && ie.value === null || ie.type === "Identifier" && ie.name === "undefined";
                b.push(" ? ", De(N) ? D(l) : ue(D(l)), " : ", x.type === g.type || De(x) ? D(E) : ue(D(E)));
              } else {
                let ue = [v, "? ", N.type === g.type ? h("", "(") : "", f(2, D(l)), N.type === g.type ? h("", ")") : "", v, ": ", x.type === g.type ? D(E) : f(2, D(E))];
                b.push(M.type !== g.type || M[E] === g || j ? ue : C.useTabs ? w(p(ue)) : f(Math.max(0, C.tabWidth - 2), ue));
              }
              let ee = [...y.map((ue) => a(g[ue])), a(N), a(x)].flat().some((ue) => c(ue) && t3(C.originalText, i(ue), o(ue))), te = (ue) => M === H ? d(ue, { shouldBreak: ee }) : ee ? [ue, T] : ue, oe = !L && (u(M) || M.type === "NGPipeExpression" && M.left === g) && !M.computed, W = I(P), X = te([S(P, C, D), $ ? b : p(b), F && oe && !W ? m : ""]);
              return j || W ? d([p([m, X]), m]) : X;
            }
            n.exports = { printTernary: k };
          } }), fo = Z({ "src/language-js/print/statement.js"(e, n) {
            "use strict";
            re();
            var { builders: { hardline: t3 } } = Oe(), s = jt(), { getLeftSidePathName: a, hasNakedLeftSide: r, isJsxNode: u, isTheOnlyJsxElementInMarkdown: i, hasComment: o, CommentCheckFlags: c, isNextLineEmpty: v } = Ke(), { shouldPrintParamsWithoutParens: m } = Lr();
            function d(B, I, k, P) {
              let C = B.getValue(), D = [], g = C.type === "ClassBody", F = p(C[P]);
              return B.each((l, E, y) => {
                let N = l.getValue();
                if (N.type === "EmptyStatement")
                  return;
                let x = k();
                !I.semi && !g && !i(I, l) && f(l, I) ? o(N, c.Leading) ? D.push(k([], { needsSemi: true })) : D.push(";", x) : D.push(x), !I.semi && g && A(N) && S(N, y[E + 1]) && D.push(";"), N !== F && (D.push(t3), v(N, I) && D.push(t3));
              }, P), D;
            }
            function p(B) {
              for (let I = B.length - 1; I >= 0; I--) {
                let k = B[I];
                if (k.type !== "EmptyStatement")
                  return k;
              }
            }
            function f(B, I) {
              return B.getNode().type !== "ExpressionStatement" ? false : B.call((P) => h(P, I), "expression");
            }
            function h(B, I) {
              let k = B.getValue();
              switch (k.type) {
                case "ParenthesizedExpression":
                case "TypeCastExpression":
                case "ArrayExpression":
                case "ArrayPattern":
                case "TemplateLiteral":
                case "TemplateElement":
                case "RegExpLiteral":
                  return true;
                case "ArrowFunctionExpression": {
                  if (!m(B, I))
                    return true;
                  break;
                }
                case "UnaryExpression": {
                  let { prefix: P, operator: C } = k;
                  if (P && (C === "+" || C === "-"))
                    return true;
                  break;
                }
                case "BindExpression": {
                  if (!k.object)
                    return true;
                  break;
                }
                case "Literal": {
                  if (k.regex)
                    return true;
                  break;
                }
                default:
                  if (u(k))
                    return true;
              }
              return s(B, I) ? true : r(k) ? B.call((P) => h(P, I), ...a(B, k)) : false;
            }
            function w(B, I, k) {
              return d(B, I, k, "body");
            }
            function T(B, I, k) {
              return d(B, I, k, "consequent");
            }
            var A = (B) => {
              let { type: I } = B;
              return I === "ClassProperty" || I === "PropertyDefinition" || I === "ClassPrivateProperty" || I === "ClassAccessorProperty";
            };
            function S(B, I) {
              let k = B.key && B.key.name;
              if ((k === "static" || k === "get" || k === "set") && !B.value && !B.typeAnnotation)
                return true;
              if (!I || I.static || I.accessibility)
                return false;
              if (!I.computed) {
                let P = I.key && I.key.name;
                if (P === "in" || P === "instanceof")
                  return true;
              }
              if (A(I) && I.variance && !I.static && !I.declare)
                return true;
              switch (I.type) {
                case "ClassProperty":
                case "PropertyDefinition":
                case "TSAbstractPropertyDefinition":
                  return I.computed;
                case "MethodDefinition":
                case "TSAbstractMethodDefinition":
                case "ClassMethod":
                case "ClassPrivateMethod": {
                  if ((I.value ? I.value.async : I.async) || I.kind === "get" || I.kind === "set")
                    return false;
                  let C = I.value ? I.value.generator : I.generator;
                  return !!(I.computed || C);
                }
                case "TSIndexSignature":
                  return true;
              }
              return false;
            }
            n.exports = { printBody: w, printSwitchCaseConsequent: T };
          } }), Do = Z({ "src/language-js/print/block.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { isNonEmptyArray: s } = Ue(), { builders: { hardline: a, indent: r } } = Oe(), { hasComment: u, CommentCheckFlags: i, isNextLineEmpty: o } = Ke(), { printHardlineAfterHeritage: c } = Zt(), { printBody: v } = fo();
            function m(p, f, h) {
              let w = p.getValue(), T = [];
              if (w.type === "StaticBlock" && T.push("static "), w.type === "ClassBody" && s(w.body)) {
                let S = p.getParentNode();
                T.push(c(S));
              }
              T.push("{");
              let A = d(p, f, h);
              if (A)
                T.push(r([a, A]), a);
              else {
                let S = p.getParentNode(), B = p.getParentNode(1);
                S.type === "ArrowFunctionExpression" || S.type === "FunctionExpression" || S.type === "FunctionDeclaration" || S.type === "ObjectMethod" || S.type === "ClassMethod" || S.type === "ClassPrivateMethod" || S.type === "ForStatement" || S.type === "WhileStatement" || S.type === "DoWhileStatement" || S.type === "DoExpression" || S.type === "CatchClause" && !B.finalizer || S.type === "TSModuleDeclaration" || S.type === "TSDeclareFunction" || w.type === "StaticBlock" || w.type === "ClassBody" || T.push(a);
              }
              return T.push("}"), T;
            }
            function d(p, f, h) {
              let w = p.getValue(), T = s(w.directives), A = w.body.some((I) => I.type !== "EmptyStatement"), S = u(w, i.Dangling);
              if (!T && !A && !S)
                return "";
              let B = [];
              if (T && p.each((I, k, P) => {
                B.push(h()), (k < P.length - 1 || A || S) && (B.push(a), o(I.getValue(), f) && B.push(a));
              }, "directives"), A && B.push(v(p, f, h)), S && B.push(t3(p, f, true)), w.type === "Program") {
                let I = p.getParentNode();
                (!I || I.type !== "ModuleExpression") && B.push(a);
              }
              return B;
            }
            n.exports = { printBlock: m, printBlockBody: d };
          } }), Xm = Z({ "src/language-js/print/typescript.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { hasNewlineInRange: s } = Ue(), { builders: { join: a, line: r, hardline: u, softline: i, group: o, indent: c, conditionalGroup: v, ifBreak: m } } = Oe(), { isLiteral: d, getTypeScriptMappedTypeModifier: p, shouldPrintComma: f, isCallExpression: h, isMemberExpression: w } = Ke(), T = zm(), { locStart: A, locEnd: S } = st(), { printOptionalToken: B, printTypeScriptModifiers: I } = ct(), { printTernary: k } = po(), { printFunctionParameters: P, shouldGroupFunctionParameters: C } = Pr(), { printTemplateLiteral: D } = Lt(), { printArrayItems: g } = Kt(), { printObject: F } = zn(), { printClassProperty: l, printClassMethod: E } = Zt(), { printTypeParameter: y, printTypeParameters: N } = Ir(), { printPropertyKey: x } = Qt(), { printFunction: b, printMethodInternal: L } = Lr(), { printInterface: M } = lo(), { printBlock: j } = Do(), { printTypeAlias: $, printIntersectionType: V, printUnionType: q, printFunctionType: Y, printTupleType: H, printIndexedAccessType: R, printJSDocType: Q } = kr();
            function ee(te, oe, W) {
              let X = te.getValue();
              if (!X.type.startsWith("TS"))
                return;
              if (T(X))
                return X.type.slice(2, -7).toLowerCase();
              let ue = oe.semi ? ";" : "", De = [];
              switch (X.type) {
                case "TSThisType":
                  return "this";
                case "TSTypeAssertion": {
                  let ie = !(X.expression.type === "ArrayExpression" || X.expression.type === "ObjectExpression"), G = o(["<", c([i, W("typeAnnotation")]), i, ">"]), z = [m("("), c([i, W("expression")]), i, m(")")];
                  return ie ? v([[G, W("expression")], [G, o(z, { shouldBreak: true })], [G, W("expression")]]) : o([G, W("expression")]);
                }
                case "TSDeclareFunction":
                  return b(te, W, oe);
                case "TSExportAssignment":
                  return ["export = ", W("expression"), ue];
                case "TSModuleBlock":
                  return j(te, oe, W);
                case "TSInterfaceBody":
                case "TSTypeLiteral":
                  return F(te, oe, W);
                case "TSTypeAliasDeclaration":
                  return $(te, oe, W);
                case "TSQualifiedName":
                  return a(".", [W("left"), W("right")]);
                case "TSAbstractMethodDefinition":
                case "TSDeclareMethod":
                  return E(te, oe, W);
                case "TSAbstractPropertyDefinition":
                  return l(te, oe, W);
                case "TSInterfaceHeritage":
                case "TSExpressionWithTypeArguments":
                  return De.push(W("expression")), X.typeParameters && De.push(W("typeParameters")), De;
                case "TSTemplateLiteralType":
                  return D(te, W, oe);
                case "TSNamedTupleMember":
                  return [W("label"), X.optional ? "?" : "", ": ", W("elementType")];
                case "TSRestType":
                  return ["...", W("typeAnnotation")];
                case "TSOptionalType":
                  return [W("typeAnnotation"), "?"];
                case "TSInterfaceDeclaration":
                  return M(te, oe, W);
                case "TSClassImplements":
                  return [W("expression"), W("typeParameters")];
                case "TSTypeParameterDeclaration":
                case "TSTypeParameterInstantiation":
                  return N(te, oe, W, "params");
                case "TSTypeParameter":
                  return y(te, oe, W);
                case "TSAsExpression": {
                  De.push(W("expression"), " as ", W("typeAnnotation"));
                  let ie = te.getParentNode();
                  return h(ie) && ie.callee === X || w(ie) && ie.object === X ? o([c([i, ...De]), i]) : De;
                }
                case "TSArrayType":
                  return [W("elementType"), "[]"];
                case "TSPropertySignature":
                  return X.readonly && De.push("readonly "), De.push(x(te, oe, W), B(te)), X.typeAnnotation && De.push(": ", W("typeAnnotation")), X.initializer && De.push(" = ", W("initializer")), De;
                case "TSParameterProperty":
                  return X.accessibility && De.push(X.accessibility + " "), X.export && De.push("export "), X.static && De.push("static "), X.override && De.push("override "), X.readonly && De.push("readonly "), De.push(W("parameter")), De;
                case "TSTypeQuery":
                  return ["typeof ", W("exprName"), W("typeParameters")];
                case "TSIndexSignature": {
                  let ie = te.getParentNode(), G = X.parameters.length > 1 ? m(f(oe) ? "," : "") : "", z = o([c([i, a([", ", i], te.map(W, "parameters"))]), G, i]);
                  return [X.export ? "export " : "", X.accessibility ? [X.accessibility, " "] : "", X.static ? "static " : "", X.readonly ? "readonly " : "", X.declare ? "declare " : "", "[", X.parameters ? z : "", X.typeAnnotation ? "]: " : "]", X.typeAnnotation ? W("typeAnnotation") : "", ie.type === "ClassBody" ? ue : ""];
                }
                case "TSTypePredicate":
                  return [X.asserts ? "asserts " : "", W("parameterName"), X.typeAnnotation ? [" is ", W("typeAnnotation")] : ""];
                case "TSNonNullExpression":
                  return [W("expression"), "!"];
                case "TSImportType":
                  return [X.isTypeOf ? "typeof " : "", "import(", W(X.parameter ? "parameter" : "argument"), ")", X.qualifier ? [".", W("qualifier")] : "", N(te, oe, W, "typeParameters")];
                case "TSLiteralType":
                  return W("literal");
                case "TSIndexedAccessType":
                  return R(te, oe, W);
                case "TSConstructSignatureDeclaration":
                case "TSCallSignatureDeclaration":
                case "TSConstructorType": {
                  if (X.type === "TSConstructorType" && X.abstract && De.push("abstract "), X.type !== "TSCallSignatureDeclaration" && De.push("new "), De.push(o(P(te, W, oe, false, true))), X.returnType || X.typeAnnotation) {
                    let ie = X.type === "TSConstructorType";
                    De.push(ie ? " => " : ": ", W("returnType"), W("typeAnnotation"));
                  }
                  return De;
                }
                case "TSTypeOperator":
                  return [X.operator, " ", W("typeAnnotation")];
                case "TSMappedType": {
                  let ie = s(oe.originalText, A(X), S(X));
                  return o(["{", c([oe.bracketSpacing ? r : i, X.readonly ? [p(X.readonly, "readonly"), " "] : "", I(te, oe, W), W("typeParameter"), X.optional ? p(X.optional, "?") : "", X.typeAnnotation ? ": " : "", W("typeAnnotation"), m(ue)]), t3(te, oe, true), oe.bracketSpacing ? r : i, "}"], { shouldBreak: ie });
                }
                case "TSMethodSignature": {
                  let ie = X.kind && X.kind !== "method" ? "".concat(X.kind, " ") : "";
                  De.push(X.accessibility ? [X.accessibility, " "] : "", ie, X.export ? "export " : "", X.static ? "static " : "", X.readonly ? "readonly " : "", X.abstract ? "abstract " : "", X.declare ? "declare " : "", X.computed ? "[" : "", W("key"), X.computed ? "]" : "", B(te));
                  let G = P(te, W, oe, false, true), z = X.returnType ? "returnType" : "typeAnnotation", U = X[z], le = U ? W(z) : "", ge = C(X, le);
                  return De.push(ge ? o(G) : G), U && De.push(": ", o(le)), o(De);
                }
                case "TSNamespaceExportDeclaration":
                  return De.push("export as namespace ", W("id")), oe.semi && De.push(";"), o(De);
                case "TSEnumDeclaration":
                  return X.declare && De.push("declare "), X.modifiers && De.push(I(te, oe, W)), X.const && De.push("const "), De.push("enum ", W("id"), " "), X.members.length === 0 ? De.push(o(["{", t3(te, oe), i, "}"])) : De.push(o(["{", c([u, g(te, oe, "members", W), f(oe, "es5") ? "," : ""]), t3(te, oe, true), u, "}"])), De;
                case "TSEnumMember":
                  return X.computed ? De.push("[", W("id"), "]") : De.push(W("id")), X.initializer && De.push(" = ", W("initializer")), De;
                case "TSImportEqualsDeclaration":
                  return X.isExport && De.push("export "), De.push("import "), X.importKind && X.importKind !== "value" && De.push(X.importKind, " "), De.push(W("id"), " = ", W("moduleReference")), oe.semi && De.push(";"), o(De);
                case "TSExternalModuleReference":
                  return ["require(", W("expression"), ")"];
                case "TSModuleDeclaration": {
                  let ie = te.getParentNode(), G = d(X.id), z = ie.type === "TSModuleDeclaration", U = X.body && X.body.type === "TSModuleDeclaration";
                  if (z)
                    De.push(".");
                  else {
                    X.declare && De.push("declare "), De.push(I(te, oe, W));
                    let le = oe.originalText.slice(A(X), A(X.id));
                    X.id.type === "Identifier" && X.id.name === "global" && !/namespace|module/.test(le) || De.push(G || /(?:^|\s)module(?:\s|$)/.test(le) ? "module " : "namespace ");
                  }
                  return De.push(W("id")), U ? De.push(W("body")) : X.body ? De.push(" ", o(W("body"))) : De.push(ue), De;
                }
                case "TSConditionalType":
                  return k(te, oe, W);
                case "TSInferType":
                  return ["infer", " ", W("typeParameter")];
                case "TSIntersectionType":
                  return V(te, oe, W);
                case "TSUnionType":
                  return q(te, oe, W);
                case "TSFunctionType":
                  return Y(te, oe, W);
                case "TSTupleType":
                  return H(te, oe, W);
                case "TSTypeReference":
                  return [W("typeName"), N(te, oe, W, "typeParameters")];
                case "TSTypeAnnotation":
                  return W("typeAnnotation");
                case "TSEmptyBodyFunctionExpression":
                  return L(te, oe, W);
                case "TSJSDocAllType":
                  return "*";
                case "TSJSDocUnknownType":
                  return "?";
                case "TSJSDocNullableType":
                  return Q(te, W, "?");
                case "TSJSDocNonNullableType":
                  return Q(te, W, "!");
                case "TSInstantiationExpression":
                  return [W("expression"), W("typeParameters")];
                default:
                  throw new Error("Unknown TypeScript node type: ".concat(JSON.stringify(X.type), "."));
              }
            }
            n.exports = { printTypescript: ee };
          } }), Km = Z({ "src/language-js/print/comment.js"(e, n) {
            "use strict";
            re();
            var { hasNewline: t3 } = Ue(), { builders: { join: s, hardline: a }, utils: { replaceTextEndOfLine: r } } = Oe(), { isLineComment: u } = Ke(), { locStart: i, locEnd: o } = st(), c = It();
            function v(p, f) {
              let h = p.getValue();
              if (u(h))
                return f.originalText.slice(i(h), o(h)).trimEnd();
              if (c(h)) {
                if (m(h)) {
                  let A = d(h);
                  return h.trailing && !t3(f.originalText, i(h), { backwards: true }) ? [a, A] : A;
                }
                let w = o(h), T = f.originalText.slice(w - 3, w) === "*-/";
                return ["/*", r(h.value), T ? "*-/" : "*/"];
              }
              throw new Error("Not a comment: " + JSON.stringify(h));
            }
            function m(p) {
              let f = "*".concat(p.value, "*").split(`
`);
              return f.length > 1 && f.every((h) => h.trim()[0] === "*");
            }
            function d(p) {
              let f = p.value.split(`
`);
              return ["/*", s(a, f.map((h, w) => w === 0 ? h.trimEnd() : " " + (w < f.length - 1 ? h.trim() : h.trimStart()))), "*/"];
            }
            n.exports = { printComment: v };
          } }), Ym = Z({ "src/language-js/print/literal.js"(e, n) {
            "use strict";
            re();
            var { printString: t3, printNumber: s } = Ue();
            function a(i, o) {
              let c = i.getNode();
              switch (c.type) {
                case "RegExpLiteral":
                  return u(c);
                case "BigIntLiteral":
                  return r(c.bigint || c.extra.raw);
                case "NumericLiteral":
                  return s(c.extra.raw);
                case "StringLiteral":
                  return t3(c.extra.raw, o);
                case "NullLiteral":
                  return "null";
                case "BooleanLiteral":
                  return String(c.value);
                case "DecimalLiteral":
                  return s(c.value) + "m";
                case "Literal": {
                  if (c.regex)
                    return u(c.regex);
                  if (c.bigint)
                    return r(c.raw);
                  if (c.decimal)
                    return s(c.decimal) + "m";
                  let { value: v } = c;
                  return typeof v == "number" ? s(c.raw) : typeof v == "string" ? t3(c.raw, o) : String(v);
                }
              }
            }
            function r(i) {
              return i.toLowerCase();
            }
            function u(i) {
              let { pattern: o, flags: c } = i;
              return c = [...c].sort().join(""), "/".concat(o, "/").concat(c);
            }
            n.exports = { printLiteral: a };
          } }), Qm = Z({ "src/language-js/printer-estree.js"(e, n) {
            "use strict";
            re();
            var { printDanglingComments: t3 } = et(), { hasNewline: s } = Ue(), { builders: { join: a, line: r, hardline: u, softline: i, group: o, indent: c }, utils: { replaceTextEndOfLine: v } } = Oe(), m = Im(), d = Lm(), { insertPragma: p } = no(), f = uo(), h = jt(), w = so(), { hasFlowShorthandAnnotationComment: T, hasComment: A, CommentCheckFlags: S, isTheOnlyJsxElementInMarkdown: B, isLineComment: I, isNextLineEmpty: k, needsHardlineAfterDanglingComment: P, rawText: C, hasIgnoreComment: D, isCallExpression: g, isMemberExpression: F, markerForIfWithoutBlockAndSameLineComment: l } = Ke(), { locStart: E, locEnd: y } = st(), N = It(), { printHtmlBinding: x, isVueEventBindingExpression: b } = $m(), { printAngular: L } = Hm(), { printJsx: M, hasJsxIgnoreComment: j } = Gm(), { printFlow: $ } = Um(), { printTypescript: V } = Xm(), { printOptionalToken: q, printBindExpressionCallee: Y, printTypeAnnotation: H, adjustClause: R, printRestSpread: Q, printDefiniteToken: ee } = ct(), { printImportDeclaration: te, printExportDeclaration: oe, printExportAllDeclaration: W, printModuleSpecifier: X } = co(), { printTernary: ue } = po(), { printTemplateLiteral: De } = Lt(), { printArray: ie } = Kt(), { printObject: G } = zn(), { printClass: z, printClassMethod: U, printClassProperty: le } = Zt(), { printProperty: ge } = Qt(), { printFunction: Ae, printArrowFunction: Ne, printMethod: ke, printReturnStatement: ce, printThrowStatement: pe } = Lr(), { printCallExpression: de } = oo(), { printVariableDeclarator: ae, printAssignmentExpression: ve } = Yt(), { printBinaryishExpression: K } = Jn(), { printSwitchCaseConsequent: he } = fo(), { printMemberExpression: ye } = ao(), { printBlock: Ce, printBlockBody: Ie } = Do(), { printComment: Fe } = Km(), { printLiteral: me } = Ym(), { printDecorators: _ } = Un();
            function J(Be, Pe, Se, Qe) {
              let xe = ne(Be, Pe, Se, Qe);
              if (!xe)
                return "";
              let Xe = Be.getValue(), { type: _e } = Xe;
              if (_e === "ClassMethod" || _e === "ClassPrivateMethod" || _e === "ClassProperty" || _e === "ClassAccessorProperty" || _e === "PropertyDefinition" || _e === "TSAbstractPropertyDefinition" || _e === "ClassPrivateProperty" || _e === "MethodDefinition" || _e === "TSAbstractMethodDefinition" || _e === "TSDeclareMethod")
                return xe;
              let je = [xe], Re = _(Be, Pe, Se), be = Xe.type === "ClassExpression" && Re;
              if (Re && (je = [...Re, xe], !be))
                return o(je);
              if (!h(Be, Pe))
                return Qe && Qe.needsSemi && je.unshift(";"), je.length === 1 && je[0] === xe ? xe : je;
              if (be && (je = [c([r, ...je])]), je.unshift("("), Qe && Qe.needsSemi && je.unshift(";"), T(Xe)) {
                let [qe] = Xe.trailingComments;
                je.push(" /*", qe.value.trimStart(), "*/"), qe.printed = true;
              }
              return be && je.push(r), je.push(")"), je;
            }
            function ne(Be, Pe, Se, Qe) {
              let xe = Be.getValue(), Xe = Pe.semi ? ";" : "";
              if (!xe)
                return "";
              if (typeof xe == "string")
                return xe;
              for (let je of [me, x, L, M, $, V]) {
                let Re = je(Be, Pe, Se);
                if (typeof Re < "u")
                  return Re;
              }
              let _e = [];
              switch (xe.type) {
                case "JsExpressionRoot":
                  return Se("node");
                case "JsonRoot":
                  return [Se("node"), u];
                case "File":
                  return xe.program && xe.program.interpreter && _e.push(Se(["program", "interpreter"])), _e.push(Se("program")), _e;
                case "Program":
                  return Ie(Be, Pe, Se);
                case "EmptyStatement":
                  return "";
                case "ExpressionStatement": {
                  if (xe.directive)
                    return [Ee(xe.expression, Pe), Xe];
                  if (Pe.parser === "__vue_event_binding" || Pe.parser === "__vue_ts_event_binding") {
                    let Re = Be.getParentNode();
                    if (Re.type === "Program" && Re.body.length === 1 && Re.body[0] === xe)
                      return [Se("expression"), b(xe.expression) ? ";" : ""];
                  }
                  let je = t3(Be, Pe, true, (Re) => {
                    let { marker: be } = Re;
                    return be === l;
                  });
                  return [Se("expression"), B(Pe, Be) ? "" : Xe, je ? [" ", je] : ""];
                }
                case "ParenthesizedExpression":
                  return !A(xe.expression) && (xe.expression.type === "ObjectExpression" || xe.expression.type === "ArrayExpression") ? ["(", Se("expression"), ")"] : o(["(", c([i, Se("expression")]), i, ")"]);
                case "AssignmentExpression":
                  return ve(Be, Pe, Se);
                case "VariableDeclarator":
                  return ae(Be, Pe, Se);
                case "BinaryExpression":
                case "LogicalExpression":
                  return K(Be, Pe, Se);
                case "AssignmentPattern":
                  return [Se("left"), " = ", Se("right")];
                case "OptionalMemberExpression":
                case "MemberExpression":
                  return ye(Be, Pe, Se);
                case "MetaProperty":
                  return [Se("meta"), ".", Se("property")];
                case "BindExpression":
                  return xe.object && _e.push(Se("object")), _e.push(o(c([i, Y(Be, Pe, Se)]))), _e;
                case "Identifier":
                  return [xe.name, q(Be), ee(Be), H(Be, Pe, Se)];
                case "V8IntrinsicIdentifier":
                  return ["%", xe.name];
                case "SpreadElement":
                case "SpreadElementPattern":
                case "SpreadProperty":
                case "SpreadPropertyPattern":
                case "RestElement":
                  return Q(Be, Pe, Se);
                case "FunctionDeclaration":
                case "FunctionExpression":
                  return Ae(Be, Se, Pe, Qe);
                case "ArrowFunctionExpression":
                  return Ne(Be, Pe, Se, Qe);
                case "YieldExpression":
                  return _e.push("yield"), xe.delegate && _e.push("*"), xe.argument && _e.push(" ", Se("argument")), _e;
                case "AwaitExpression": {
                  if (_e.push("await"), xe.argument) {
                    _e.push(" ", Se("argument"));
                    let je = Be.getParentNode();
                    if (g(je) && je.callee === xe || F(je) && je.object === xe) {
                      _e = [c([i, ..._e]), i];
                      let Re = Be.findAncestor((be) => be.type === "AwaitExpression" || be.type === "BlockStatement");
                      if (!Re || Re.type !== "AwaitExpression")
                        return o(_e);
                    }
                  }
                  return _e;
                }
                case "ExportDefaultDeclaration":
                case "ExportNamedDeclaration":
                  return oe(Be, Pe, Se);
                case "ExportAllDeclaration":
                  return W(Be, Pe, Se);
                case "ImportDeclaration":
                  return te(Be, Pe, Se);
                case "ImportSpecifier":
                case "ExportSpecifier":
                case "ImportNamespaceSpecifier":
                case "ExportNamespaceSpecifier":
                case "ImportDefaultSpecifier":
                case "ExportDefaultSpecifier":
                  return X(Be, Pe, Se);
                case "ImportAttribute":
                  return [Se("key"), ": ", Se("value")];
                case "Import":
                  return "import";
                case "BlockStatement":
                case "StaticBlock":
                case "ClassBody":
                  return Ce(Be, Pe, Se);
                case "ThrowStatement":
                  return pe(Be, Pe, Se);
                case "ReturnStatement":
                  return ce(Be, Pe, Se);
                case "NewExpression":
                case "ImportExpression":
                case "OptionalCallExpression":
                case "CallExpression":
                  return de(Be, Pe, Se);
                case "ObjectExpression":
                case "ObjectPattern":
                case "RecordExpression":
                  return G(Be, Pe, Se);
                case "ObjectProperty":
                case "Property":
                  return xe.method || xe.kind === "get" || xe.kind === "set" ? ke(Be, Pe, Se) : ge(Be, Pe, Se);
                case "ObjectMethod":
                  return ke(Be, Pe, Se);
                case "Decorator":
                  return ["@", Se("expression")];
                case "ArrayExpression":
                case "ArrayPattern":
                case "TupleExpression":
                  return ie(Be, Pe, Se);
                case "SequenceExpression": {
                  let je = Be.getParentNode(0);
                  if (je.type === "ExpressionStatement" || je.type === "ForStatement") {
                    let Re = [];
                    return Be.each((be, Le) => {
                      Le === 0 ? Re.push(Se()) : Re.push(",", c([r, Se()]));
                    }, "expressions"), o(Re);
                  }
                  return o(a([",", r], Be.map(Se, "expressions")));
                }
                case "ThisExpression":
                  return "this";
                case "Super":
                  return "super";
                case "Directive":
                  return [Se("value"), Xe];
                case "DirectiveLiteral":
                  return Ee(xe, Pe);
                case "UnaryExpression":
                  return _e.push(xe.operator), /[a-z]$/.test(xe.operator) && _e.push(" "), A(xe.argument) ? _e.push(o(["(", c([i, Se("argument")]), i, ")"])) : _e.push(Se("argument")), _e;
                case "UpdateExpression":
                  return _e.push(Se("argument"), xe.operator), xe.prefix && _e.reverse(), _e;
                case "ConditionalExpression":
                  return ue(Be, Pe, Se);
                case "VariableDeclaration": {
                  let je = Be.map(Se, "declarations"), Re = Be.getParentNode(), be = Re.type === "ForStatement" || Re.type === "ForInStatement" || Re.type === "ForOfStatement", Le = xe.declarations.some((se) => se.init), qe;
                  return je.length === 1 && !A(xe.declarations[0]) ? qe = je[0] : je.length > 0 && (qe = c(je[0])), _e = [xe.declare ? "declare " : "", xe.kind, qe ? [" ", qe] : "", c(je.slice(1).map((se) => [",", Le && !be ? u : r, se]))], be && Re.body !== xe || _e.push(Xe), o(_e);
                }
                case "WithStatement":
                  return o(["with (", Se("object"), ")", R(xe.body, Se("body"))]);
                case "IfStatement": {
                  let je = R(xe.consequent, Se("consequent")), Re = o(["if (", o([c([i, Se("test")]), i]), ")", je]);
                  if (_e.push(Re), xe.alternate) {
                    let be = A(xe.consequent, S.Trailing | S.Line) || P(xe), Le = xe.consequent.type === "BlockStatement" && !be;
                    _e.push(Le ? " " : u), A(xe, S.Dangling) && _e.push(t3(Be, Pe, true), be ? u : " "), _e.push("else", o(R(xe.alternate, Se("alternate"), xe.alternate.type === "IfStatement")));
                  }
                  return _e;
                }
                case "ForStatement": {
                  let je = R(xe.body, Se("body")), Re = t3(Be, Pe, true), be = Re ? [Re, i] : "";
                  return !xe.init && !xe.test && !xe.update ? [be, o(["for (;;)", je])] : [be, o(["for (", o([c([i, Se("init"), ";", r, Se("test"), ";", r, Se("update")]), i]), ")", je])];
                }
                case "WhileStatement":
                  return o(["while (", o([c([i, Se("test")]), i]), ")", R(xe.body, Se("body"))]);
                case "ForInStatement":
                  return o(["for (", Se("left"), " in ", Se("right"), ")", R(xe.body, Se("body"))]);
                case "ForOfStatement":
                  return o(["for", xe.await ? " await" : "", " (", Se("left"), " of ", Se("right"), ")", R(xe.body, Se("body"))]);
                case "DoWhileStatement": {
                  let je = R(xe.body, Se("body"));
                  return _e = [o(["do", je])], xe.body.type === "BlockStatement" ? _e.push(" ") : _e.push(u), _e.push("while (", o([c([i, Se("test")]), i]), ")", Xe), _e;
                }
                case "DoExpression":
                  return [xe.async ? "async " : "", "do ", Se("body")];
                case "BreakStatement":
                  return _e.push("break"), xe.label && _e.push(" ", Se("label")), _e.push(Xe), _e;
                case "ContinueStatement":
                  return _e.push("continue"), xe.label && _e.push(" ", Se("label")), _e.push(Xe), _e;
                case "LabeledStatement":
                  return xe.body.type === "EmptyStatement" ? [Se("label"), ":;"] : [Se("label"), ": ", Se("body")];
                case "TryStatement":
                  return ["try ", Se("block"), xe.handler ? [" ", Se("handler")] : "", xe.finalizer ? [" finally ", Se("finalizer")] : ""];
                case "CatchClause":
                  if (xe.param) {
                    let je = A(xe.param, (be) => !N(be) || be.leading && s(Pe.originalText, y(be)) || be.trailing && s(Pe.originalText, E(be), { backwards: true })), Re = Se("param");
                    return ["catch ", je ? ["(", c([i, Re]), i, ") "] : ["(", Re, ") "], Se("body")];
                  }
                  return ["catch ", Se("body")];
                case "SwitchStatement":
                  return [o(["switch (", c([i, Se("discriminant")]), i, ")"]), " {", xe.cases.length > 0 ? c([u, a(u, Be.map((je, Re, be) => {
                    let Le = je.getValue();
                    return [Se(), Re !== be.length - 1 && k(Le, Pe) ? u : ""];
                  }, "cases"))]) : "", u, "}"];
                case "SwitchCase": {
                  xe.test ? _e.push("case ", Se("test"), ":") : _e.push("default:"), A(xe, S.Dangling) && _e.push(" ", t3(Be, Pe, true));
                  let je = xe.consequent.filter((Re) => Re.type !== "EmptyStatement");
                  if (je.length > 0) {
                    let Re = he(Be, Pe, Se);
                    _e.push(je.length === 1 && je[0].type === "BlockStatement" ? [" ", Re] : c([u, Re]));
                  }
                  return _e;
                }
                case "DebuggerStatement":
                  return ["debugger", Xe];
                case "ClassDeclaration":
                case "ClassExpression":
                  return z(Be, Pe, Se);
                case "ClassMethod":
                case "ClassPrivateMethod":
                case "MethodDefinition":
                  return U(Be, Pe, Se);
                case "ClassProperty":
                case "PropertyDefinition":
                case "ClassPrivateProperty":
                case "ClassAccessorProperty":
                  return le(Be, Pe, Se);
                case "TemplateElement":
                  return v(xe.value.raw);
                case "TemplateLiteral":
                  return De(Be, Se, Pe);
                case "TaggedTemplateExpression":
                  return [Se("tag"), Se("typeParameters"), Se("quasi")];
                case "PrivateIdentifier":
                  return ["#", Se("name")];
                case "PrivateName":
                  return ["#", Se("id")];
                case "InterpreterDirective":
                  return _e.push("#!", xe.value, u), k(xe, Pe) && _e.push(u), _e;
                case "TopicReference":
                  return "%";
                case "ArgumentPlaceholder":
                  return "?";
                case "ModuleExpression": {
                  _e.push("module {");
                  let je = Se("body");
                  return je && _e.push(c([u, je]), u), _e.push("}"), _e;
                }
                default:
                  throw new Error("unknown type: " + JSON.stringify(xe.type));
              }
            }
            function Ee(Be, Pe) {
              let Se = C(Be), Qe = Se.slice(1, -1);
              if (Qe.includes('"') || Qe.includes("'"))
                return Se;
              let xe = Pe.singleQuote ? "'" : '"';
              return xe + Qe + xe;
            }
            function We(Be) {
              return Be.type && !N(Be) && !I(Be) && Be.type !== "EmptyStatement" && Be.type !== "TemplateElement" && Be.type !== "Import" && Be.type !== "TSEmptyBodyFunctionExpression";
            }
            n.exports = { preprocess: w, print: J, embed: m, insertPragma: p, massageAstNode: d, hasPrettierIgnore(Be) {
              return D(Be) || j(Be);
            }, willPrintOwnComments: f.willPrintOwnComments, canAttachComment: We, printComment: Fe, isBlockComment: N, handleComments: { avoidAstMutation: true, ownLine: f.handleOwnLineComment, endOfLine: f.handleEndOfLineComment, remaining: f.handleRemainingComment }, getCommentChildNodes: f.getCommentChildNodes };
          } }), Zm = Z({ "src/language-js/printer-estree-json.js"(e, n) {
            "use strict";
            re();
            var { builders: { hardline: t3, indent: s, join: a } } = Oe(), r = so();
            function u(c, v, m) {
              let d = c.getValue();
              switch (d.type) {
                case "JsonRoot":
                  return [m("node"), t3];
                case "ArrayExpression": {
                  if (d.elements.length === 0)
                    return "[]";
                  let p = c.map(() => c.getValue() === null ? "null" : m(), "elements");
                  return ["[", s([t3, a([",", t3], p)]), t3, "]"];
                }
                case "ObjectExpression":
                  return d.properties.length === 0 ? "{}" : ["{", s([t3, a([",", t3], c.map(m, "properties"))]), t3, "}"];
                case "ObjectProperty":
                  return [m("key"), ": ", m("value")];
                case "UnaryExpression":
                  return [d.operator === "+" ? "" : d.operator, m("argument")];
                case "NullLiteral":
                  return "null";
                case "BooleanLiteral":
                  return d.value ? "true" : "false";
                case "StringLiteral":
                case "NumericLiteral":
                  return JSON.stringify(d.value);
                case "Identifier": {
                  let p = c.getParentNode();
                  return p && p.type === "ObjectProperty" && p.key === d ? JSON.stringify(d.name) : d.name;
                }
                case "TemplateLiteral":
                  return m(["quasis", 0]);
                case "TemplateElement":
                  return JSON.stringify(d.value.cooked);
                default:
                  throw new Error("unknown type: " + JSON.stringify(d.type));
              }
            }
            var i = /* @__PURE__ */ new Set(["start", "end", "extra", "loc", "comments", "leadingComments", "trailingComments", "innerComments", "errors", "range", "tokens"]);
            function o(c, v) {
              let { type: m } = c;
              if (m === "ObjectProperty" && c.key.type === "Identifier") {
                v.key = { type: "StringLiteral", value: c.key.name };
                return;
              }
              if (m === "UnaryExpression" && c.operator === "+")
                return v.argument;
              if (m === "ArrayExpression") {
                for (let [d, p] of c.elements.entries())
                  p === null && v.elements.splice(d, 0, { type: "NullLiteral" });
                return;
              }
              if (m === "TemplateLiteral")
                return { type: "StringLiteral", value: c.quasis[0].value.cooked };
            }
            o.ignoredProperties = i, n.exports = { preprocess: r, print: u, massageAstNode: o };
          } }), Ot = Z({ "src/common/common-options.js"(e, n) {
            "use strict";
            re();
            var t3 = "Common";
            n.exports = { bracketSpacing: { since: "0.0.0", category: t3, type: "boolean", default: true, description: "Print spaces between brackets.", oppositeDescription: "Do not print spaces between brackets." }, singleQuote: { since: "0.0.0", category: t3, type: "boolean", default: false, description: "Use single quotes instead of double quotes." }, proseWrap: { since: "1.8.2", category: t3, type: "choice", default: [{ since: "1.8.2", value: true }, { since: "1.9.0", value: "preserve" }], description: "How to wrap prose.", choices: [{ since: "1.9.0", value: "always", description: "Wrap prose if it exceeds the print width." }, { since: "1.9.0", value: "never", description: "Do not wrap prose." }, { since: "1.9.0", value: "preserve", description: "Wrap prose as-is." }] }, bracketSameLine: { since: "2.4.0", category: t3, type: "boolean", default: false, description: "Put > of opening tags on the last line instead of on a new line." }, singleAttributePerLine: { since: "2.6.0", category: t3, type: "boolean", default: false, description: "Enforce single attribute per line in HTML, Vue and JSX." } };
          } }), ed = Z({ "src/language-js/options.js"(e, n) {
            "use strict";
            re();
            var t3 = Ot(), s = "JavaScript";
            n.exports = { arrowParens: { since: "1.9.0", category: s, type: "choice", default: [{ since: "1.9.0", value: "avoid" }, { since: "2.0.0", value: "always" }], description: "Include parentheses around a sole arrow function parameter.", choices: [{ value: "always", description: "Always include parens. Example: `(x) => x`" }, { value: "avoid", description: "Omit parens when possible. Example: `x => x`" }] }, bracketSameLine: t3.bracketSameLine, bracketSpacing: t3.bracketSpacing, jsxBracketSameLine: { since: "0.17.0", category: s, type: "boolean", description: "Put > on the last line instead of at a new line.", deprecated: "2.4.0" }, semi: { since: "1.0.0", category: s, type: "boolean", default: true, description: "Print semicolons.", oppositeDescription: "Do not print semicolons, except at the beginning of lines which may need them." }, singleQuote: t3.singleQuote, jsxSingleQuote: { since: "1.15.0", category: s, type: "boolean", default: false, description: "Use single quotes in JSX." }, quoteProps: { since: "1.17.0", category: s, type: "choice", default: "as-needed", description: "Change when properties in objects are quoted.", choices: [{ value: "as-needed", description: "Only add quotes around object properties where required." }, { value: "consistent", description: "If at least one property in an object requires quotes, quote all properties." }, { value: "preserve", description: "Respect the input use of quotes in object properties." }] }, trailingComma: { since: "0.0.0", category: s, type: "choice", default: [{ since: "0.0.0", value: false }, { since: "0.19.0", value: "none" }, { since: "2.0.0", value: "es5" }], description: "Print trailing commas wherever possible when multi-line.", choices: [{ value: "es5", description: "Trailing commas where valid in ES5 (objects, arrays, etc.)" }, { value: "none", description: "No trailing commas." }, { value: "all", description: "Trailing commas wherever possible (including function arguments)." }] }, singleAttributePerLine: t3.singleAttributePerLine };
          } }), td = Z({ "src/language-js/parse/parsers.js"() {
            re();
          } }), Sn = Z({ "node_modules/linguist-languages/data/JavaScript.json"(e, n) {
            n.exports = { name: "JavaScript", type: "programming", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", color: "#f1e05a", aliases: ["js", "node"], extensions: [".js", "._js", ".bones", ".cjs", ".es", ".es6", ".frag", ".gs", ".jake", ".javascript", ".jsb", ".jscad", ".jsfl", ".jslib", ".jsm", ".jspre", ".jss", ".jsx", ".mjs", ".njs", ".pac", ".sjs", ".ssjs", ".xsjs", ".xsjslib"], filenames: ["Jakefile"], interpreters: ["chakra", "d8", "gjs", "js", "node", "nodejs", "qjs", "rhino", "v8", "v8-shell"], languageId: 183 };
          } }), rd = Z({ "node_modules/linguist-languages/data/TypeScript.json"(e, n) {
            n.exports = { name: "TypeScript", type: "programming", color: "#3178c6", aliases: ["ts"], interpreters: ["deno", "ts-node"], extensions: [".ts", ".cts", ".mts"], tmScope: "source.ts", aceMode: "typescript", codemirrorMode: "javascript", codemirrorMimeType: "application/typescript", languageId: 378 };
          } }), nd = Z({ "node_modules/linguist-languages/data/TSX.json"(e, n) {
            n.exports = { name: "TSX", type: "programming", color: "#3178c6", group: "TypeScript", extensions: [".tsx"], tmScope: "source.tsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", languageId: 94901924 };
          } }), ma = Z({ "node_modules/linguist-languages/data/JSON.json"(e, n) {
            n.exports = { name: "JSON", type: "data", color: "#292929", tmScope: "source.json", aceMode: "json", codemirrorMode: "javascript", codemirrorMimeType: "application/json", aliases: ["geojson", "jsonl", "topojson"], extensions: [".json", ".4DForm", ".4DProject", ".avsc", ".geojson", ".gltf", ".har", ".ice", ".JSON-tmLanguage", ".jsonl", ".mcmeta", ".tfstate", ".tfstate.backup", ".topojson", ".webapp", ".webmanifest", ".yy", ".yyp"], filenames: [".arcconfig", ".auto-changelog", ".c8rc", ".htmlhintrc", ".imgbotconfig", ".nycrc", ".tern-config", ".tern-project", ".watchmanconfig", "Pipfile.lock", "composer.lock", "mcmod.info"], languageId: 174 };
          } }), ud = Z({ "node_modules/linguist-languages/data/JSON with Comments.json"(e, n) {
            n.exports = { name: "JSON with Comments", type: "data", color: "#292929", group: "JSON", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", aliases: ["jsonc"], extensions: [".jsonc", ".code-snippets", ".sublime-build", ".sublime-commands", ".sublime-completions", ".sublime-keymap", ".sublime-macro", ".sublime-menu", ".sublime-mousemap", ".sublime-project", ".sublime-settings", ".sublime-theme", ".sublime-workspace", ".sublime_metrics", ".sublime_session"], filenames: [".babelrc", ".devcontainer.json", ".eslintrc.json", ".jscsrc", ".jshintrc", ".jslintrc", "api-extractor.json", "devcontainer.json", "jsconfig.json", "language-configuration.json", "tsconfig.json", "tslint.json"], languageId: 423 };
          } }), sd = Z({ "node_modules/linguist-languages/data/JSON5.json"(e, n) {
            n.exports = { name: "JSON5", type: "data", color: "#267CB9", extensions: [".json5"], tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "application/json", languageId: 175 };
          } }), id = Z({ "src/language-js/index.js"(e, n) {
            "use strict";
            re();
            var t3 = Bt(), s = Qm(), a = Zm(), r = ed(), u = td(), i = [t3(Sn(), (c) => ({ since: "0.0.0", parsers: ["babel", "acorn", "espree", "meriyah", "babel-flow", "babel-ts", "flow", "typescript"], vscodeLanguageIds: ["javascript", "mongo"], interpreters: [...c.interpreters, "zx"], extensions: [...c.extensions.filter((v) => v !== ".jsx"), ".wxs"] })), t3(Sn(), () => ({ name: "Flow", since: "0.0.0", parsers: ["flow", "babel-flow"], vscodeLanguageIds: ["javascript"], aliases: [], filenames: [], extensions: [".js.flow"] })), t3(Sn(), () => ({ name: "JSX", since: "0.0.0", parsers: ["babel", "babel-flow", "babel-ts", "flow", "typescript", "espree", "meriyah"], vscodeLanguageIds: ["javascriptreact"], aliases: void 0, filenames: void 0, extensions: [".jsx"], group: "JavaScript", interpreters: void 0, tmScope: "source.js.jsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", color: void 0 })), t3(rd(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescript"] })), t3(nd(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescriptreact"] })), t3(ma(), () => ({ name: "JSON.stringify", since: "1.13.0", parsers: ["json-stringify"], vscodeLanguageIds: ["json"], extensions: [".importmap"], filenames: ["package.json", "package-lock.json", "composer.json"] })), t3(ma(), (c) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["json"], extensions: c.extensions.filter((v) => v !== ".jsonl") })), t3(ud(), (c) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["jsonc"], filenames: [...c.filenames, ".eslintrc", ".swcrc"] })), t3(sd(), () => ({ since: "1.13.0", parsers: ["json5"], vscodeLanguageIds: ["json5"] }))], o = { estree: s, "estree-json": a };
            n.exports = { languages: i, options: r, printers: o, parsers: u };
          } }), ad = Z({ "src/language-css/clean.js"(e, n) {
            "use strict";
            re();
            var { isFrontMatterNode: t3 } = Ue(), s = it(), a = /* @__PURE__ */ new Set(["raw", "raws", "sourceIndex", "source", "before", "after", "trailingComma"]);
            function r(i, o, c) {
              if (t3(i) && i.lang === "yaml" && delete o.value, i.type === "css-comment" && c.type === "css-root" && c.nodes.length > 0 && ((c.nodes[0] === i || t3(c.nodes[0]) && c.nodes[1] === i) && (delete o.text, /^\*\s*@(?:format|prettier)\s*$/.test(i.text)) || c.type === "css-root" && s(c.nodes) === i))
                return null;
              if (i.type === "value-root" && delete o.text, (i.type === "media-query" || i.type === "media-query-list" || i.type === "media-feature-expression") && delete o.value, i.type === "css-rule" && delete o.params, i.type === "selector-combinator" && (o.value = o.value.replace(/\s+/g, " ")), i.type === "media-feature" && (o.value = o.value.replace(/ /g, "")), (i.type === "value-word" && (i.isColor && i.isHex || ["initial", "inherit", "unset", "revert"].includes(o.value.replace().toLowerCase())) || i.type === "media-feature" || i.type === "selector-root-invalid" || i.type === "selector-pseudo") && (o.value = o.value.toLowerCase()), i.type === "css-decl" && (o.prop = o.prop.toLowerCase()), (i.type === "css-atrule" || i.type === "css-import") && (o.name = o.name.toLowerCase()), i.type === "value-number" && (o.unit = o.unit.toLowerCase()), (i.type === "media-feature" || i.type === "media-keyword" || i.type === "media-type" || i.type === "media-unknown" || i.type === "media-url" || i.type === "media-value" || i.type === "selector-attribute" || i.type === "selector-string" || i.type === "selector-class" || i.type === "selector-combinator" || i.type === "value-string") && o.value && (o.value = u(o.value)), i.type === "selector-attribute" && (o.attribute = o.attribute.trim(), o.namespace && typeof o.namespace == "string" && (o.namespace = o.namespace.trim(), o.namespace.length === 0 && (o.namespace = true)), o.value && (o.value = o.value.trim().replace(/^["']|["']$/g, ""), delete o.quoted)), (i.type === "media-value" || i.type === "media-type" || i.type === "value-number" || i.type === "selector-root-invalid" || i.type === "selector-class" || i.type === "selector-combinator" || i.type === "selector-tag") && o.value && (o.value = o.value.replace(/([\d+.Ee-]+)([A-Za-z]*)/g, (v, m, d) => {
                let p = Number(m);
                return Number.isNaN(p) ? v : p + d.toLowerCase();
              })), i.type === "selector-tag") {
                let v = i.value.toLowerCase();
                ["from", "to"].includes(v) && (o.value = v);
              }
              if (i.type === "css-atrule" && i.name.toLowerCase() === "supports" && delete o.value, i.type === "selector-unknown" && delete o.value, i.type === "value-comma_group") {
                let v = i.groups.findIndex((m) => m.type === "value-number" && m.unit === "...");
                v !== -1 && (o.groups[v].unit = "", o.groups.splice(v + 1, 0, { type: "value-word", value: "...", isColor: false, isHex: false }));
              }
            }
            r.ignoredProperties = a;
            function u(i) {
              return i.replace(/'/g, '"').replace(/\\([^\dA-Fa-f])/g, "$1");
            }
            n.exports = r;
          } }), Xn = Z({ "src/utils/front-matter/print.js"(e, n) {
            "use strict";
            re();
            var { builders: { hardline: t3, markAsRoot: s } } = Oe();
            function a(r, u) {
              if (r.lang === "yaml") {
                let i = r.value.trim(), o = i ? u(i, { parser: "yaml" }, { stripTrailingHardline: true }) : "";
                return s([r.startDelimiter, t3, o, o ? t3 : "", r.endDelimiter]);
              }
            }
            n.exports = a;
          } }), od = Z({ "src/language-css/embed.js"(e, n) {
            "use strict";
            re();
            var { builders: { hardline: t3 } } = Oe(), s = Xn();
            function a(r, u, i) {
              let o = r.getValue();
              if (o.type === "front-matter") {
                let c = s(o, i);
                return c ? [c, t3] : "";
              }
            }
            n.exports = a;
          } }), mo = Z({ "src/utils/front-matter/parse.js"(e, n) {
            "use strict";
            re();
            var t3 = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
            function s(a) {
              let r = a.match(t3);
              if (!r)
                return { content: a };
              let { startDelimiter: u, language: i, value: o = "", endDelimiter: c } = r.groups, v = i.trim() || "yaml";
              if (u === "+++" && (v = "toml"), v !== "yaml" && u !== c)
                return { content: a };
              let [m] = r;
              return { frontMatter: { type: "front-matter", lang: v, value: o, startDelimiter: u, endDelimiter: c, raw: m.replace(/\n$/, "") }, content: m.replace(/[^\n]/g, " ") + a.slice(m.length) };
            }
            n.exports = s;
          } }), ld = Z({ "src/language-css/pragma.js"(e, n) {
            "use strict";
            re();
            var t3 = no(), s = mo();
            function a(u) {
              return t3.hasPragma(s(u).content);
            }
            function r(u) {
              let { frontMatter: i, content: o } = s(u);
              return (i ? i.raw + `

` : "") + t3.insertPragma(o);
            }
            n.exports = { hasPragma: a, insertPragma: r };
          } }), cd = Z({ "src/language-css/utils/index.js"(e, n) {
            "use strict";
            re();
            var t3 = /* @__PURE__ */ new Set(["red", "green", "blue", "alpha", "a", "rgb", "hue", "h", "saturation", "s", "lightness", "l", "whiteness", "w", "blackness", "b", "tint", "shade", "blend", "blenda", "contrast", "hsl", "hsla", "hwb", "hwba"]);
            function s(G, z) {
              let U = Array.isArray(z) ? z : [z], le = -1, ge;
              for (; ge = G.getParentNode(++le); )
                if (U.includes(ge.type))
                  return le;
              return -1;
            }
            function a(G, z) {
              let U = s(G, z);
              return U === -1 ? null : G.getParentNode(U);
            }
            function r(G) {
              var z;
              let U = a(G, "css-decl");
              return U == null || (z = U.prop) === null || z === void 0 ? void 0 : z.toLowerCase();
            }
            var u = /* @__PURE__ */ new Set(["initial", "inherit", "unset", "revert"]);
            function i(G) {
              return u.has(G.toLowerCase());
            }
            function o(G, z) {
              let U = a(G, "css-atrule");
              return (U == null ? void 0 : U.name) && U.name.toLowerCase().endsWith("keyframes") && ["from", "to"].includes(z.toLowerCase());
            }
            function c(G) {
              return G.includes("$") || G.includes("@") || G.includes("#") || G.startsWith("%") || G.startsWith("--") || G.startsWith(":--") || G.includes("(") && G.includes(")") ? G : G.toLowerCase();
            }
            function v(G, z) {
              var U;
              let le = a(G, "value-func");
              return (le == null || (U = le.value) === null || U === void 0 ? void 0 : U.toLowerCase()) === z;
            }
            function m(G) {
              var z;
              let U = a(G, "css-rule"), le = U == null || (z = U.raws) === null || z === void 0 ? void 0 : z.selector;
              return le && (le.startsWith(":import") || le.startsWith(":export"));
            }
            function d(G, z) {
              let U = Array.isArray(z) ? z : [z], le = a(G, "css-atrule");
              return le && U.includes(le.name.toLowerCase());
            }
            function p(G) {
              let z = G.getValue(), U = a(G, "css-atrule");
              return (U == null ? void 0 : U.name) === "import" && z.groups[0].value === "url" && z.groups.length === 2;
            }
            function f(G) {
              return G.type === "value-func" && G.value.toLowerCase() === "url";
            }
            function h(G, z) {
              var U;
              let le = (U = G.getParentNode()) === null || U === void 0 ? void 0 : U.nodes;
              return le && le.indexOf(z) === le.length - 1;
            }
            function w(G) {
              let { selector: z } = G;
              return z ? typeof z == "string" && /^@.+:.*$/.test(z) || z.value && /^@.+:.*$/.test(z.value) : false;
            }
            function T(G) {
              return G.type === "value-word" && ["from", "through", "end"].includes(G.value);
            }
            function A(G) {
              return G.type === "value-word" && ["and", "or", "not"].includes(G.value);
            }
            function S(G) {
              return G.type === "value-word" && G.value === "in";
            }
            function B(G) {
              return G.type === "value-operator" && G.value === "*";
            }
            function I(G) {
              return G.type === "value-operator" && G.value === "/";
            }
            function k(G) {
              return G.type === "value-operator" && G.value === "+";
            }
            function P(G) {
              return G.type === "value-operator" && G.value === "-";
            }
            function C(G) {
              return G.type === "value-operator" && G.value === "%";
            }
            function D(G) {
              return B(G) || I(G) || k(G) || P(G) || C(G);
            }
            function g(G) {
              return G.type === "value-word" && ["==", "!="].includes(G.value);
            }
            function F(G) {
              return G.type === "value-word" && ["<", ">", "<=", ">="].includes(G.value);
            }
            function l(G) {
              return G.type === "css-atrule" && ["if", "else", "for", "each", "while"].includes(G.name);
            }
            function E(G) {
              var z;
              return ((z = G.raws) === null || z === void 0 ? void 0 : z.params) && /^\(\s*\)$/.test(G.raws.params);
            }
            function y(G) {
              return G.name.startsWith("prettier-placeholder");
            }
            function N(G) {
              return G.prop.startsWith("@prettier-placeholder");
            }
            function x(G, z) {
              return G.value === "$$" && G.type === "value-func" && (z == null ? void 0 : z.type) === "value-word" && !z.raws.before;
            }
            function b(G) {
              var z, U;
              return ((z = G.value) === null || z === void 0 ? void 0 : z.type) === "value-root" && ((U = G.value.group) === null || U === void 0 ? void 0 : U.type) === "value-value" && G.prop.toLowerCase() === "composes";
            }
            function L(G) {
              var z, U, le;
              return ((z = G.value) === null || z === void 0 || (U = z.group) === null || U === void 0 || (le = U.group) === null || le === void 0 ? void 0 : le.type) === "value-paren_group" && G.value.group.group.open !== null && G.value.group.group.close !== null;
            }
            function M(G) {
              var z;
              return ((z = G.raws) === null || z === void 0 ? void 0 : z.before) === "";
            }
            function j(G) {
              var z, U;
              return G.type === "value-comma_group" && ((z = G.groups) === null || z === void 0 || (U = z[1]) === null || U === void 0 ? void 0 : U.type) === "value-colon";
            }
            function $(G) {
              var z;
              return G.type === "value-paren_group" && ((z = G.groups) === null || z === void 0 ? void 0 : z[0]) && j(G.groups[0]);
            }
            function V(G) {
              var z;
              let U = G.getValue();
              if (U.groups.length === 0)
                return false;
              let le = G.getParentNode(1);
              if (!$(U) && !(le && $(le)))
                return false;
              let ge = a(G, "css-decl");
              return !!(ge != null && (z = ge.prop) !== null && z !== void 0 && z.startsWith("$") || $(le) || le.type === "value-func");
            }
            function q(G) {
              return G.type === "value-comment" && G.inline;
            }
            function Y(G) {
              return G.type === "value-word" && G.value === "#";
            }
            function H(G) {
              return G.type === "value-word" && G.value === "{";
            }
            function R(G) {
              return G.type === "value-word" && G.value === "}";
            }
            function Q(G) {
              return ["value-word", "value-atword"].includes(G.type);
            }
            function ee(G) {
              return (G == null ? void 0 : G.type) === "value-colon";
            }
            function te(G, z) {
              if (!j(z))
                return false;
              let { groups: U } = z, le = U.indexOf(G);
              return le === -1 ? false : ee(U[le + 1]);
            }
            function oe(G) {
              return G.value && ["not", "and", "or"].includes(G.value.toLowerCase());
            }
            function W(G) {
              return G.type !== "value-func" ? false : t3.has(G.value.toLowerCase());
            }
            function X(G) {
              return /\/\//.test(G.split(/[\n\r]/).pop());
            }
            function ue(G) {
              return (G == null ? void 0 : G.type) === "value-atword" && G.value.startsWith("prettier-placeholder-");
            }
            function De(G, z) {
              var U, le;
              if (((U = G.open) === null || U === void 0 ? void 0 : U.value) !== "(" || ((le = G.close) === null || le === void 0 ? void 0 : le.value) !== ")" || G.groups.some((ge) => ge.type !== "value-comma_group"))
                return false;
              if (z.type === "value-comma_group") {
                let ge = z.groups.indexOf(G) - 1, Ae = z.groups[ge];
                if ((Ae == null ? void 0 : Ae.type) === "value-word" && Ae.value === "with")
                  return true;
              }
              return false;
            }
            function ie(G) {
              var z, U;
              return G.type === "value-paren_group" && ((z = G.open) === null || z === void 0 ? void 0 : z.value) === "(" && ((U = G.close) === null || U === void 0 ? void 0 : U.value) === ")";
            }
            n.exports = { getAncestorCounter: s, getAncestorNode: a, getPropOfDeclNode: r, maybeToLowerCase: c, insideValueFunctionNode: v, insideICSSRuleNode: m, insideAtRuleNode: d, insideURLFunctionInImportAtRuleNode: p, isKeyframeAtRuleKeywords: o, isWideKeywords: i, isLastNode: h, isSCSSControlDirectiveNode: l, isDetachedRulesetDeclarationNode: w, isRelationalOperatorNode: F, isEqualityOperatorNode: g, isMultiplicationNode: B, isDivisionNode: I, isAdditionNode: k, isSubtractionNode: P, isModuloNode: C, isMathOperatorNode: D, isEachKeywordNode: S, isForKeywordNode: T, isURLFunctionNode: f, isIfElseKeywordNode: A, hasComposesNode: b, hasParensAroundNode: L, hasEmptyRawBefore: M, isDetachedRulesetCallNode: E, isTemplatePlaceholderNode: y, isTemplatePropNode: N, isPostcssSimpleVarNode: x, isKeyValuePairNode: j, isKeyValuePairInParenGroupNode: $, isKeyInValuePairNode: te, isSCSSMapItemNode: V, isInlineValueCommentNode: q, isHashNode: Y, isLeftCurlyBraceNode: H, isRightCurlyBraceNode: R, isWordNode: Q, isColonNode: ee, isMediaAndSupportsKeywords: oe, isColorAdjusterFuncNode: W, lastLineHasInlineComment: X, isAtWordPlaceholderNode: ue, isConfigurationNode: De, isParenGroupNode: ie };
          } }), pd = Z({ "src/utils/line-column-to-index.js"(e, n) {
            "use strict";
            re(), n.exports = function(t3, s) {
              let a = 0;
              for (let r = 0; r < t3.line - 1; ++r)
                a = s.indexOf(`
`, a) + 1;
              return a + t3.column;
            };
          } }), fd = Z({ "src/language-css/loc.js"(e, n) {
            "use strict";
            re();
            var { skipEverythingButNewLine: t3 } = Nr(), s = it(), a = pd();
            function r(p, f) {
              return typeof p.sourceIndex == "number" ? p.sourceIndex : p.source ? a(p.source.start, f) - 1 : null;
            }
            function u(p, f) {
              if (p.type === "css-comment" && p.inline)
                return t3(f, p.source.startOffset);
              let h = p.nodes && s(p.nodes);
              return h && p.source && !p.source.end && (p = h), p.source && p.source.end ? a(p.source.end, f) : null;
            }
            function i(p, f) {
              p.source && (p.source.startOffset = r(p, f), p.source.endOffset = u(p, f));
              for (let h in p) {
                let w = p[h];
                h === "source" || !w || typeof w != "object" || (w.type === "value-root" || w.type === "value-unknown" ? o(w, c(p), w.text || w.value) : i(w, f));
              }
            }
            function o(p, f, h) {
              p.source && (p.source.startOffset = r(p, h) + f, p.source.endOffset = u(p, h) + f);
              for (let w in p) {
                let T = p[w];
                w === "source" || !T || typeof T != "object" || o(T, f, h);
              }
            }
            function c(p) {
              let f = p.source.startOffset;
              return typeof p.prop == "string" && (f += p.prop.length), p.type === "css-atrule" && typeof p.name == "string" && (f += 1 + p.name.length + p.raws.afterName.match(/^\s*:?\s*/)[0].length), p.type !== "css-atrule" && p.raws && typeof p.raws.between == "string" && (f += p.raws.between.length), f;
            }
            function v(p) {
              let f = "initial", h = "initial", w, T = false, A = [];
              for (let S = 0; S < p.length; S++) {
                let B = p[S];
                switch (f) {
                  case "initial":
                    if (B === "'") {
                      f = "single-quotes";
                      continue;
                    }
                    if (B === '"') {
                      f = "double-quotes";
                      continue;
                    }
                    if ((B === "u" || B === "U") && p.slice(S, S + 4).toLowerCase() === "url(") {
                      f = "url", S += 3;
                      continue;
                    }
                    if (B === "*" && p[S - 1] === "/") {
                      f = "comment-block";
                      continue;
                    }
                    if (B === "/" && p[S - 1] === "/") {
                      f = "comment-inline", w = S - 1;
                      continue;
                    }
                    continue;
                  case "single-quotes":
                    if (B === "'" && p[S - 1] !== "\\" && (f = h, h = "initial"), B === `
` || B === "\r")
                      return p;
                    continue;
                  case "double-quotes":
                    if (B === '"' && p[S - 1] !== "\\" && (f = h, h = "initial"), B === `
` || B === "\r")
                      return p;
                    continue;
                  case "url":
                    if (B === ")" && (f = "initial"), B === `
` || B === "\r")
                      return p;
                    if (B === "'") {
                      f = "single-quotes", h = "url";
                      continue;
                    }
                    if (B === '"') {
                      f = "double-quotes", h = "url";
                      continue;
                    }
                    continue;
                  case "comment-block":
                    B === "/" && p[S - 1] === "*" && (f = "initial");
                    continue;
                  case "comment-inline":
                    (B === '"' || B === "'" || B === "*") && (T = true), (B === `
` || B === "\r") && (T && A.push([w, S]), f = "initial", T = false);
                    continue;
                }
              }
              for (let [S, B] of A)
                p = p.slice(0, S) + p.slice(S, B).replace(/["'*]/g, " ") + p.slice(B);
              return p;
            }
            function m(p) {
              return p.source.startOffset;
            }
            function d(p) {
              return p.source.endOffset;
            }
            n.exports = { locStart: m, locEnd: d, calculateLoc: i, replaceQuotesInInlineComments: v };
          } }), Dd = Z({ "src/language-css/utils/is-less-parser.js"(e, n) {
            "use strict";
            re();
            function t3(s) {
              return s.parser === "css" || s.parser === "less";
            }
            n.exports = t3;
          } }), md = Z({ "src/language-css/utils/is-scss.js"(e, n) {
            "use strict";
            re();
            function t3(s, a) {
              return s === "less" || s === "scss" ? s === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(a);
            }
            n.exports = t3;
          } }), dd = Z({ "src/language-css/utils/css-units.evaluate.js"(e, n) {
            n.exports = { em: "em", rem: "rem", ex: "ex", rex: "rex", cap: "cap", rcap: "rcap", ch: "ch", rch: "rch", ic: "ic", ric: "ric", lh: "lh", rlh: "rlh", vw: "vw", svw: "svw", lvw: "lvw", dvw: "dvw", vh: "vh", svh: "svh", lvh: "lvh", dvh: "dvh", vi: "vi", svi: "svi", lvi: "lvi", dvi: "dvi", vb: "vb", svb: "svb", lvb: "lvb", dvb: "dvb", vmin: "vmin", svmin: "svmin", lvmin: "lvmin", dvmin: "dvmin", vmax: "vmax", svmax: "svmax", lvmax: "lvmax", dvmax: "dvmax", cm: "cm", mm: "mm", q: "Q", in: "in", pt: "pt", pc: "pc", px: "px", deg: "deg", grad: "grad", rad: "rad", turn: "turn", s: "s", ms: "ms", hz: "Hz", khz: "kHz", dpi: "dpi", dpcm: "dpcm", dppx: "dppx", x: "x" };
          } }), gd = Z({ "src/language-css/utils/print-unit.js"(e, n) {
            "use strict";
            re();
            var t3 = dd();
            function s(a) {
              let r = a.toLowerCase();
              return Object.prototype.hasOwnProperty.call(t3, r) ? t3[r] : a;
            }
            n.exports = s;
          } }), yd = Z({ "src/language-css/printer-postcss.js"(e, n) {
            "use strict";
            re();
            var t3 = it(), { printNumber: s, printString: a, hasNewline: r, isFrontMatterNode: u, isNextLineEmpty: i, isNonEmptyArray: o } = Ue(), { builders: { join: c, line: v, hardline: m, softline: d, group: p, fill: f, indent: h, dedent: w, ifBreak: T, breakParent: A }, utils: { removeLines: S, getDocParts: B } } = Oe(), I = ad(), k = od(), { insertPragma: P } = ld(), { getAncestorNode: C, getPropOfDeclNode: D, maybeToLowerCase: g, insideValueFunctionNode: F, insideICSSRuleNode: l, insideAtRuleNode: E, insideURLFunctionInImportAtRuleNode: y, isKeyframeAtRuleKeywords: N, isWideKeywords: x, isLastNode: b, isSCSSControlDirectiveNode: L, isDetachedRulesetDeclarationNode: M, isRelationalOperatorNode: j, isEqualityOperatorNode: $, isMultiplicationNode: V, isDivisionNode: q, isAdditionNode: Y, isSubtractionNode: H, isMathOperatorNode: R, isEachKeywordNode: Q, isForKeywordNode: ee, isURLFunctionNode: te, isIfElseKeywordNode: oe, hasComposesNode: W, hasParensAroundNode: X, hasEmptyRawBefore: ue, isKeyValuePairNode: De, isKeyInValuePairNode: ie, isDetachedRulesetCallNode: G, isTemplatePlaceholderNode: z, isTemplatePropNode: U, isPostcssSimpleVarNode: le, isSCSSMapItemNode: ge, isInlineValueCommentNode: Ae, isHashNode: Ne, isLeftCurlyBraceNode: ke, isRightCurlyBraceNode: ce, isWordNode: pe, isColonNode: de, isMediaAndSupportsKeywords: ae, isColorAdjusterFuncNode: ve, lastLineHasInlineComment: K, isAtWordPlaceholderNode: he, isConfigurationNode: ye, isParenGroupNode: Ce } = cd(), { locStart: Ie, locEnd: Fe } = fd(), me = Dd(), _ = md(), J = gd();
            function ne(be) {
              return be.trailingComma === "es5" || be.trailingComma === "all";
            }
            function Ee(be, Le, qe) {
              let se = be.getValue();
              if (!se)
                return "";
              if (typeof se == "string")
                return se;
              switch (se.type) {
                case "front-matter":
                  return [se.raw, m];
                case "css-root": {
                  let He = We(be, Le, qe), Me = se.raws.after.trim();
                  return [He, Me ? " ".concat(Me) : "", B(He).length > 0 ? m : ""];
                }
                case "css-comment": {
                  let He = se.inline || se.raws.inline, Me = Le.originalText.slice(Ie(se), Fe(se));
                  return He ? Me.trimEnd() : Me;
                }
                case "css-rule":
                  return [qe("selector"), se.important ? " !important" : "", se.nodes ? [se.selector && se.selector.type === "selector-unknown" && K(se.selector.value) ? v : " ", "{", se.nodes.length > 0 ? h([m, We(be, Le, qe)]) : "", m, "}", M(se) ? ";" : ""] : ";"];
                case "css-decl": {
                  let He = be.getParentNode(), { between: Me } = se.raws, ze = Me.trim(), nt = ze === ":", tt = W(se) ? S(qe("value")) : qe("value");
                  return !nt && K(ze) && (tt = h([m, w(tt)])), [se.raws.before.replace(/[\s;]/g, ""), l(be) ? se.prop : g(se.prop), ze.startsWith("//") ? " " : "", ze, se.extend ? "" : " ", me(Le) && se.extend && se.selector ? ["extend(", qe("selector"), ")"] : "", tt, se.raws.important ? se.raws.important.replace(/\s*!\s*important/i, " !important") : se.important ? " !important" : "", se.raws.scssDefault ? se.raws.scssDefault.replace(/\s*!default/i, " !default") : se.scssDefault ? " !default" : "", se.raws.scssGlobal ? se.raws.scssGlobal.replace(/\s*!global/i, " !global") : se.scssGlobal ? " !global" : "", se.nodes ? [" {", h([d, We(be, Le, qe)]), d, "}"] : U(se) && !He.raws.semicolon && Le.originalText[Fe(se) - 1] !== ";" ? "" : Le.__isHTMLStyleAttribute && b(be, se) ? T(";") : ";"];
                }
                case "css-atrule": {
                  let He = be.getParentNode(), Me = z(se) && !He.raws.semicolon && Le.originalText[Fe(se) - 1] !== ";";
                  if (me(Le)) {
                    if (se.mixin)
                      return [qe("selector"), se.important ? " !important" : "", Me ? "" : ";"];
                    if (se.function)
                      return [se.name, qe("params"), Me ? "" : ";"];
                    if (se.variable)
                      return ["@", se.name, ": ", se.value ? qe("value") : "", se.raws.between.trim() ? se.raws.between.trim() + " " : "", se.nodes ? ["{", h([se.nodes.length > 0 ? d : "", We(be, Le, qe)]), d, "}"] : "", Me ? "" : ";"];
                  }
                  return ["@", G(se) || se.name.endsWith(":") ? se.name : g(se.name), se.params ? [G(se) ? "" : z(se) ? se.raws.afterName === "" ? "" : se.name.endsWith(":") ? " " : /^\s*\n\s*\n/.test(se.raws.afterName) ? [m, m] : /^\s*\n/.test(se.raws.afterName) ? m : " " : " ", qe("params")] : "", se.selector ? h([" ", qe("selector")]) : "", se.value ? p([" ", qe("value"), L(se) ? X(se) ? " " : v : ""]) : se.name === "else" ? " " : "", se.nodes ? [L(se) ? "" : se.selector && !se.selector.nodes && typeof se.selector.value == "string" && K(se.selector.value) || !se.selector && typeof se.params == "string" && K(se.params) ? v : " ", "{", h([se.nodes.length > 0 ? d : "", We(be, Le, qe)]), d, "}"] : Me ? "" : ";"];
                }
                case "media-query-list": {
                  let He = [];
                  return be.each((Me) => {
                    let ze = Me.getValue();
                    ze.type === "media-query" && ze.value === "" || He.push(qe());
                  }, "nodes"), p(h(c(v, He)));
                }
                case "media-query":
                  return [c(" ", be.map(qe, "nodes")), b(be, se) ? "" : ","];
                case "media-type":
                  return je(Xe(se.value, Le));
                case "media-feature-expression":
                  return se.nodes ? ["(", ...be.map(qe, "nodes"), ")"] : se.value;
                case "media-feature":
                  return g(Xe(se.value.replace(/ +/g, " "), Le));
                case "media-colon":
                  return [se.value, " "];
                case "media-value":
                  return je(Xe(se.value, Le));
                case "media-keyword":
                  return Xe(se.value, Le);
                case "media-url":
                  return Xe(se.value.replace(/^url\(\s+/gi, "url(").replace(/\s+\)$/g, ")"), Le);
                case "media-unknown":
                  return se.value;
                case "selector-root":
                  return p([E(be, "custom-selector") ? [C(be, "css-atrule").customSelector, v] : "", c([",", E(be, ["extend", "custom-selector", "nest"]) ? v : m], be.map(qe, "nodes"))]);
                case "selector-selector":
                  return p(h(be.map(qe, "nodes")));
                case "selector-comment":
                  return se.value;
                case "selector-string":
                  return Xe(se.value, Le);
                case "selector-tag": {
                  let He = be.getParentNode(), Me = He && He.nodes.indexOf(se), ze = Me && He.nodes[Me - 1];
                  return [se.namespace ? [se.namespace === true ? "" : se.namespace.trim(), "|"] : "", ze.type === "selector-nesting" ? se.value : je(N(be, se.value) ? se.value.toLowerCase() : se.value)];
                }
                case "selector-id":
                  return ["#", se.value];
                case "selector-class":
                  return [".", je(Xe(se.value, Le))];
                case "selector-attribute":
                  return ["[", se.namespace ? [se.namespace === true ? "" : se.namespace.trim(), "|"] : "", se.attribute.trim(), se.operator ? se.operator : "", se.value ? _e(Xe(se.value.trim(), Le), Le) : "", se.insensitive ? " i" : "", "]"];
                case "selector-combinator": {
                  if (se.value === "+" || se.value === ">" || se.value === "~" || se.value === ">>>") {
                    let ze = be.getParentNode();
                    return [ze.type === "selector-selector" && ze.nodes[0] === se ? "" : v, se.value, b(be, se) ? "" : " "];
                  }
                  let He = se.value.trim().startsWith("(") ? v : "", Me = je(Xe(se.value.trim(), Le)) || v;
                  return [He, Me];
                }
                case "selector-universal":
                  return [se.namespace ? [se.namespace === true ? "" : se.namespace.trim(), "|"] : "", se.value];
                case "selector-pseudo":
                  return [g(se.value), o(se.nodes) ? ["(", c(", ", be.map(qe, "nodes")), ")"] : ""];
                case "selector-nesting":
                  return se.value;
                case "selector-unknown": {
                  let He = C(be, "css-rule");
                  if (He && He.isSCSSNesterProperty)
                    return je(Xe(g(se.value), Le));
                  let Me = be.getParentNode();
                  if (Me.raws && Me.raws.selector) {
                    let nt = Ie(Me), tt = nt + Me.raws.selector.length;
                    return Le.originalText.slice(nt, tt).trim();
                  }
                  let ze = be.getParentNode(1);
                  if (Me.type === "value-paren_group" && ze && ze.type === "value-func" && ze.value === "selector") {
                    let nt = Fe(Me.open) + 1, tt = Ie(Me.close), pt = Le.originalText.slice(nt, tt).trim();
                    return K(pt) ? [A, pt] : pt;
                  }
                  return se.value;
                }
                case "value-value":
                case "value-root":
                  return qe("group");
                case "value-comment":
                  return Le.originalText.slice(Ie(se), Fe(se));
                case "value-comma_group": {
                  let He = be.getParentNode(), Me = be.getParentNode(1), ze = D(be), nt = ze && He.type === "value-value" && (ze === "grid" || ze.startsWith("grid-template")), tt = C(be, "css-atrule"), pt = tt && L(tt), O = se.groups.some((ut) => Ae(ut)), fe = be.map(qe, "groups"), Te = [], $e = F(be, "url"), Je = false, Ze = false;
                  for (let ut = 0; ut < se.groups.length; ++ut) {
                    Te.push(fe[ut]);
                    let rt = se.groups[ut - 1], Ve = se.groups[ut], Ge = se.groups[ut + 1], tr = se.groups[ut + 2];
                    if ($e) {
                      (Ge && Y(Ge) || Y(Ve)) && Te.push(" ");
                      continue;
                    }
                    if (E(be, "forward") && Ve.type === "value-word" && Ve.value && rt !== void 0 && rt.type === "value-word" && rt.value === "as" && Ge.type === "value-operator" && Ge.value === "*" || !Ge || Ve.type === "value-word" && Ve.value.endsWith("-") && he(Ge))
                      continue;
                    let Eo = Ve.type === "value-string" && Ve.value.startsWith("#{"), Fo = Je && Ge.type === "value-string" && Ge.value.endsWith("}");
                    if (Eo || Fo) {
                      Je = !Je;
                      continue;
                    }
                    if (Je || de(Ve) || de(Ge) || Ve.type === "value-atword" && Ve.value === "" || Ve.value === "~" || Ve.value && Ve.value.includes("\\") && Ge && Ge.type !== "value-comment" || rt && rt.value && rt.value.indexOf("\\") === rt.value.length - 1 && Ve.type === "value-operator" && Ve.value === "/" || Ve.value === "\\" || le(Ve, Ge) || Ne(Ve) || ke(Ve) || ce(Ge) || ke(Ge) && ue(Ge) || ce(Ve) && ue(Ge) || Ve.value === "--" && Ne(Ge))
                      continue;
                    let Qn = R(Ve), Zn = R(Ge);
                    if ((Qn && Ne(Ge) || Zn && ce(Ve)) && ue(Ge) || !rt && q(Ve) || F(be, "calc") && (Y(Ve) || Y(Ge) || H(Ve) || H(Ge)) && ue(Ge))
                      continue;
                    let Ao = (Y(Ve) || H(Ve)) && ut === 0 && (Ge.type === "value-number" || Ge.isHex) && Me && ve(Me) && !ue(Ge), eu = tr && tr.type === "value-func" || tr && pe(tr) || Ve.type === "value-func" || pe(Ve), tu = Ge.type === "value-func" || pe(Ge) || rt && rt.type === "value-func" || rt && pe(rt);
                    if (!(!(V(Ge) || V(Ve)) && !F(be, "calc") && !Ao && (q(Ge) && !eu || q(Ve) && !tu || Y(Ge) && !eu || Y(Ve) && !tu || H(Ge) || H(Ve)) && (ue(Ge) || Qn && (!rt || rt && R(rt))))) {
                      if (Ae(Ve)) {
                        if (He.type === "value-paren_group") {
                          Te.push(w(m));
                          continue;
                        }
                        Te.push(m);
                        continue;
                      }
                      if (pt && ($(Ge) || j(Ge) || oe(Ge) || Q(Ve) || ee(Ve))) {
                        Te.push(" ");
                        continue;
                      }
                      if (tt && tt.name.toLowerCase() === "namespace") {
                        Te.push(" ");
                        continue;
                      }
                      if (nt) {
                        Ve.source && Ge.source && Ve.source.start.line !== Ge.source.start.line ? (Te.push(m), Ze = true) : Te.push(" ");
                        continue;
                      }
                      if (Zn) {
                        Te.push(" ");
                        continue;
                      }
                      if (!(Ge && Ge.value === "...") && !(he(Ve) && he(Ge) && Fe(Ve) === Ie(Ge))) {
                        if (he(Ve) && Ce(Ge) && Fe(Ve) === Ie(Ge.open)) {
                          Te.push(d);
                          continue;
                        }
                        if (Ve.value === "with" && Ce(Ge)) {
                          Te.push(" ");
                          continue;
                        }
                        Te.push(v);
                      }
                    }
                  }
                  return O && Te.push(A), Ze && Te.unshift(m), pt ? p(h(Te)) : y(be) ? p(f(Te)) : p(h(f(Te)));
                }
                case "value-paren_group": {
                  let He = be.getParentNode();
                  if (He && te(He) && (se.groups.length === 1 || se.groups.length > 0 && se.groups[0].type === "value-comma_group" && se.groups[0].groups.length > 0 && se.groups[0].groups[0].type === "value-word" && se.groups[0].groups[0].value.startsWith("data:")))
                    return [se.open ? qe("open") : "", c(",", be.map(qe, "groups")), se.close ? qe("close") : ""];
                  if (!se.open) {
                    let $e = be.map(qe, "groups"), Je = [];
                    for (let Ze = 0; Ze < $e.length; Ze++)
                      Ze !== 0 && Je.push([",", v]), Je.push($e[Ze]);
                    return p(h(f(Je)));
                  }
                  let Me = ge(be), ze = t3(se.groups), nt = ze && ze.type === "value-comment", tt = ie(se, He), pt = ye(se, He), O = pt || Me && !tt, fe = pt || tt, Te = p([se.open ? qe("open") : "", h([d, c([v], be.map(($e, Je) => {
                    let Ze = $e.getValue(), ut = Je === se.groups.length - 1, rt = [qe(), ut ? "" : ","];
                    if (De(Ze) && Ze.type === "value-comma_group" && Ze.groups && Ze.groups[0].type !== "value-paren_group" && Ze.groups[2] && Ze.groups[2].type === "value-paren_group") {
                      let Ve = B(rt[0].contents.contents);
                      return Ve[1] = p(Ve[1]), p(w(rt));
                    }
                    if (!ut && Ze.type === "value-comma_group" && o(Ze.groups)) {
                      let Ve = t3(Ze.groups);
                      Ve.source && i(Le.originalText, Ve, Fe) && rt.push(m);
                    }
                    return rt;
                  }, "groups"))]), T(!nt && _(Le.parser, Le.originalText) && Me && ne(Le) ? "," : ""), d, se.close ? qe("close") : ""], { shouldBreak: O });
                  return fe ? w(Te) : Te;
                }
                case "value-func":
                  return [se.value, E(be, "supports") && ae(se) ? " " : "", qe("group")];
                case "value-paren":
                  return se.value;
                case "value-number":
                  return [Re(se.value), J(se.unit)];
                case "value-operator":
                  return se.value;
                case "value-word":
                  return se.isColor && se.isHex || x(se.value) ? se.value.toLowerCase() : se.value;
                case "value-colon": {
                  let He = be.getParentNode(), Me = He && He.groups.indexOf(se), ze = Me && He.groups[Me - 1];
                  return [se.value, ze && typeof ze.value == "string" && t3(ze.value) === "\\" || F(be, "url") ? "" : v];
                }
                case "value-comma":
                  return [se.value, " "];
                case "value-string":
                  return a(se.raws.quote + se.value + se.raws.quote, Le);
                case "value-atword":
                  return ["@", se.value];
                case "value-unicode-range":
                  return se.value;
                case "value-unknown":
                  return se.value;
                default:
                  throw new Error("Unknown postcss type ".concat(JSON.stringify(se.type)));
              }
            }
            function We(be, Le, qe) {
              let se = [];
              return be.each((He, Me, ze) => {
                let nt = ze[Me - 1];
                if (nt && nt.type === "css-comment" && nt.text.trim() === "prettier-ignore") {
                  let tt = He.getValue();
                  se.push(Le.originalText.slice(Ie(tt), Fe(tt)));
                } else
                  se.push(qe());
                Me !== ze.length - 1 && (ze[Me + 1].type === "css-comment" && !r(Le.originalText, Ie(ze[Me + 1]), { backwards: true }) && !u(ze[Me]) || ze[Me + 1].type === "css-atrule" && ze[Me + 1].name === "else" && ze[Me].type !== "css-comment" ? se.push(" ") : (se.push(Le.__isHTMLStyleAttribute ? v : m), i(Le.originalText, He.getValue(), Fe) && !u(ze[Me]) && se.push(m)));
              }, "nodes"), se;
            }
            var Be = /(["'])(?:(?!\1)[^\\]|\\.)*\1/gs, Pe = /(?:\d*\.\d+|\d+\.?)(?:[Ee][+-]?\d+)?/g, Se = /[A-Za-z]+/g, Qe = /[$@]?[A-Z_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/g, xe = new RegExp(Be.source + "|(".concat(Qe.source, ")?(").concat(Pe.source, ")(").concat(Se.source, ")?"), "g");
            function Xe(be, Le) {
              return be.replace(Be, (qe) => a(qe, Le));
            }
            function _e(be, Le) {
              let qe = Le.singleQuote ? "'" : '"';
              return be.includes('"') || be.includes("'") ? be : qe + be + qe;
            }
            function je(be) {
              return be.replace(xe, (Le, qe, se, He, Me) => !se && He ? Re(He) + g(Me || "") : Le);
            }
            function Re(be) {
              return s(be).replace(/\.0(?=$|e)/, "");
            }
            n.exports = { print: Ee, embed: k, insertPragma: P, massageAstNode: I };
          } }), hd = Z({ "src/language-css/options.js"(e, n) {
            "use strict";
            re();
            var t3 = Ot();
            n.exports = { singleQuote: t3.singleQuote };
          } }), vd = Z({ "src/language-css/parsers.js"() {
            re();
          } }), Cd = Z({ "node_modules/linguist-languages/data/CSS.json"(e, n) {
            n.exports = { name: "CSS", type: "markup", tmScope: "source.css", aceMode: "css", codemirrorMode: "css", codemirrorMimeType: "text/css", color: "#563d7c", extensions: [".css"], languageId: 50 };
          } }), Ed = Z({ "node_modules/linguist-languages/data/PostCSS.json"(e, n) {
            n.exports = { name: "PostCSS", type: "markup", color: "#dc3a0c", tmScope: "source.postcss", group: "CSS", extensions: [".pcss", ".postcss"], aceMode: "text", languageId: 262764437 };
          } }), Fd = Z({ "node_modules/linguist-languages/data/Less.json"(e, n) {
            n.exports = { name: "Less", type: "markup", color: "#1d365d", aliases: ["less-css"], extensions: [".less"], tmScope: "source.css.less", aceMode: "less", codemirrorMode: "css", codemirrorMimeType: "text/css", languageId: 198 };
          } }), Ad = Z({ "node_modules/linguist-languages/data/SCSS.json"(e, n) {
            n.exports = { name: "SCSS", type: "markup", color: "#c6538c", tmScope: "source.css.scss", aceMode: "scss", codemirrorMode: "css", codemirrorMimeType: "text/x-scss", extensions: [".scss"], languageId: 329 };
          } }), Sd = Z({ "src/language-css/index.js"(e, n) {
            "use strict";
            re();
            var t3 = Bt(), s = yd(), a = hd(), r = vd(), u = [t3(Cd(), (o) => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["css"], extensions: [...o.extensions, ".wxss"] })), t3(Ed(), () => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["postcss"] })), t3(Fd(), () => ({ since: "1.4.0", parsers: ["less"], vscodeLanguageIds: ["less"] })), t3(Ad(), () => ({ since: "1.4.0", parsers: ["scss"], vscodeLanguageIds: ["scss"] }))], i = { postcss: s };
            n.exports = { languages: u, options: a, printers: i, parsers: r };
          } }), xd = Z({ "src/language-handlebars/loc.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return a.loc.start.offset;
            }
            function s(a) {
              return a.loc.end.offset;
            }
            n.exports = { locStart: t3, locEnd: s };
          } }), bd = Z({ "src/language-handlebars/clean.js"(e, n) {
            "use strict";
            re();
            function t3(s, a) {
              if (s.type === "TextNode") {
                let r = s.chars.trim();
                if (!r)
                  return null;
                a.chars = r.replace(/[\t\n\f\r ]+/g, " ");
              }
              s.type === "AttrNode" && s.name.toLowerCase() === "class" && delete a.value;
            }
            t3.ignoredProperties = /* @__PURE__ */ new Set(["loc", "selfClosing"]), n.exports = t3;
          } }), Td = Z({ "vendors/html-void-elements.json"(e, n) {
            n.exports = { htmlVoidElements: ["area", "base", "basefont", "bgsound", "br", "col", "command", "embed", "frame", "hr", "image", "img", "input", "isindex", "keygen", "link", "menuitem", "meta", "nextid", "param", "source", "track", "wbr"] };
          } }), Bd = Z({ "src/language-handlebars/utils.js"(e, n) {
            "use strict";
            re();
            var { htmlVoidElements: t3 } = Td(), s = it();
            function a(S) {
              let B = S.getValue(), I = S.getParentNode(0);
              return !!(m(S, ["ElementNode"]) && s(I.children) === B || m(S, ["Block"]) && s(I.body) === B);
            }
            function r(S) {
              return S.toUpperCase() === S;
            }
            function u(S) {
              return v(S, ["ElementNode"]) && typeof S.tag == "string" && !S.tag.startsWith(":") && (r(S.tag[0]) || S.tag.includes("."));
            }
            var i = new Set(t3);
            function o(S) {
              return i.has(S.tag) || u(S) && S.children.every((B) => c(B));
            }
            function c(S) {
              return v(S, ["TextNode"]) && !/\S/.test(S.chars);
            }
            function v(S, B) {
              return S && B.includes(S.type);
            }
            function m(S, B) {
              let I = S.getParentNode(0);
              return v(I, B);
            }
            function d(S, B) {
              let I = h(S);
              return v(I, B);
            }
            function p(S, B) {
              let I = w(S);
              return v(I, B);
            }
            function f(S, B) {
              var I, k, P, C;
              let D = S.getValue(), g = (I = S.getParentNode(0)) !== null && I !== void 0 ? I : {}, F = (k = (P = (C = g.children) !== null && C !== void 0 ? C : g.body) !== null && P !== void 0 ? P : g.parts) !== null && k !== void 0 ? k : [], l = F.indexOf(D);
              return l !== -1 && F[l + B];
            }
            function h(S) {
              let B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
              return f(S, -B);
            }
            function w(S) {
              return f(S, 1);
            }
            function T(S) {
              return v(S, ["MustacheCommentStatement"]) && typeof S.value == "string" && S.value.trim() === "prettier-ignore";
            }
            function A(S) {
              let B = S.getValue(), I = h(S, 2);
              return T(B) || T(I);
            }
            n.exports = { getNextNode: w, getPreviousNode: h, hasPrettierIgnore: A, isLastNodeOfSiblings: a, isNextNodeOfSomeType: p, isNodeOfSomeType: v, isParentOfSomeType: m, isPreviousNodeOfSomeType: d, isVoid: o, isWhitespaceNode: c };
          } }), Nd = Z({ "src/language-handlebars/printer-glimmer.js"(e, n) {
            "use strict";
            re();
            var { builders: { dedent: t3, fill: s, group: a, hardline: r, ifBreak: u, indent: i, join: o, line: c, softline: v }, utils: { getDocParts: m, replaceTextEndOfLine: d } } = Oe(), { getPreferredQuote: p, isNonEmptyArray: f } = Ue(), { locStart: h, locEnd: w } = xd(), T = bd(), { getNextNode: A, getPreviousNode: S, hasPrettierIgnore: B, isLastNodeOfSiblings: I, isNextNodeOfSomeType: k, isNodeOfSomeType: P, isParentOfSomeType: C, isPreviousNodeOfSomeType: D, isVoid: g, isWhitespaceNode: F } = Bd(), l = 2;
            function E(K, he, ye) {
              let Ce = K.getValue();
              if (!Ce)
                return "";
              if (B(K))
                return he.originalText.slice(h(Ce), w(Ce));
              let Ie = he.singleQuote ? "'" : '"';
              switch (Ce.type) {
                case "Block":
                case "Program":
                case "Template":
                  return a(K.map(ye, "body"));
                case "ElementNode": {
                  let Fe = a(N(K, ye)), me = he.htmlWhitespaceSensitivity === "ignore" && k(K, ["ElementNode"]) ? v : "";
                  if (g(Ce))
                    return [Fe, me];
                  let _ = ["</", Ce.tag, ">"];
                  return Ce.children.length === 0 ? [Fe, i(_), me] : he.htmlWhitespaceSensitivity === "ignore" ? [Fe, i(x(K, he, ye)), r, i(_), me] : [Fe, i(a(x(K, he, ye))), i(_), me];
                }
                case "BlockStatement": {
                  let Fe = K.getParentNode(1);
                  return Fe && Fe.inverse && Fe.inverse.body.length === 1 && Fe.inverse.body[0] === Ce && Fe.inverse.body[0].path.parts[0] === "if" ? [ee(K, ye), ue(K, ye, he), De(K, ye, he)] : [R(K, ye), a([ue(K, ye, he), De(K, ye, he), te(K, ye, he)])];
                }
                case "ElementModifierStatement":
                  return a(["{{", pe(K, ye), "}}"]);
                case "MustacheStatement":
                  return a([L(Ce), pe(K, ye), M(Ce)]);
                case "SubExpression":
                  return a(["(", ce(K, ye), v, ")"]);
                case "AttrNode": {
                  let Fe = Ce.value.type === "TextNode";
                  if (Fe && Ce.value.chars === "" && h(Ce.value) === w(Ce.value))
                    return Ce.name;
                  let _ = Fe ? p(Ce.value.chars, Ie).quote : Ce.value.type === "ConcatStatement" ? p(Ce.value.parts.filter((ne) => ne.type === "TextNode").map((ne) => ne.chars).join(""), Ie).quote : "", J = ye("value");
                  return [Ce.name, "=", _, Ce.name === "class" && _ ? a(i(J)) : J, _];
                }
                case "ConcatStatement":
                  return K.map(ye, "parts");
                case "Hash":
                  return o(c, K.map(ye, "pairs"));
                case "HashPair":
                  return [Ce.key, "=", ye("value")];
                case "TextNode": {
                  let Fe = Ce.chars.replace(/{{/g, "\\{{"), me = z(K);
                  if (me) {
                    if (me === "class") {
                      let xe = Fe.trim().split(/\s+/).join(" "), Xe = false, _e = false;
                      return C(K, ["ConcatStatement"]) && (D(K, ["MustacheStatement"]) && /^\s/.test(Fe) && (Xe = true), k(K, ["MustacheStatement"]) && /\s$/.test(Fe) && xe !== "" && (_e = true)), [Xe ? c : "", xe, _e ? c : ""];
                    }
                    return d(Fe);
                  }
                  let J = /^[\t\n\f\r ]*$/.test(Fe), ne = !S(K), Ee = !A(K);
                  if (he.htmlWhitespaceSensitivity !== "ignore") {
                    let xe = /^[\t\n\f\r ]*/, Xe = /[\t\n\f\r ]*$/, _e = Ee && C(K, ["Template"]), je = ne && C(K, ["Template"]);
                    if (J) {
                      if (je || _e)
                        return "";
                      let se = [c], He = U(Fe);
                      return He && (se = Ae(He)), I(K) && (se = se.map((Me) => t3(Me))), se;
                    }
                    let [Re] = Fe.match(xe), [be] = Fe.match(Xe), Le = [];
                    if (Re) {
                      Le = [c];
                      let se = U(Re);
                      se && (Le = Ae(se)), Fe = Fe.replace(xe, "");
                    }
                    let qe = [];
                    if (be) {
                      if (!_e) {
                        qe = [c];
                        let se = U(be);
                        se && (qe = Ae(se)), I(K) && (qe = qe.map((He) => t3(He)));
                      }
                      Fe = Fe.replace(Xe, "");
                    }
                    return [...Le, s(ie(Fe)), ...qe];
                  }
                  let We = U(Fe), Be = le(Fe), Pe = ge(Fe);
                  if ((ne || Ee) && J && C(K, ["Block", "ElementNode", "Template"]))
                    return "";
                  J && We ? (Be = Math.min(We, l), Pe = 0) : (k(K, ["BlockStatement", "ElementNode"]) && (Pe = Math.max(Pe, 1)), D(K, ["BlockStatement", "ElementNode"]) && (Be = Math.max(Be, 1)));
                  let Se = "", Qe = "";
                  return Pe === 0 && k(K, ["MustacheStatement"]) && (Qe = " "), Be === 0 && D(K, ["MustacheStatement"]) && (Se = " "), ne && (Be = 0, Se = ""), Ee && (Pe = 0, Qe = ""), Fe = Fe.replace(/^[\t\n\f\r ]+/g, Se).replace(/[\t\n\f\r ]+$/, Qe), [...Ae(Be), s(ie(Fe)), ...Ae(Pe)];
                }
                case "MustacheCommentStatement": {
                  let Fe = h(Ce), me = w(Ce), _ = he.originalText.charAt(Fe + 2) === "~", J = he.originalText.charAt(me - 3) === "~", ne = Ce.value.includes("}}") ? "--" : "";
                  return ["{{", _ ? "~" : "", "!", ne, Ce.value, ne, J ? "~" : "", "}}"];
                }
                case "PathExpression":
                  return Ce.original;
                case "BooleanLiteral":
                  return String(Ce.value);
                case "CommentStatement":
                  return ["<!--", Ce.value, "-->"];
                case "StringLiteral": {
                  if (ke(K)) {
                    let Fe = he.singleQuote ? '"' : "'";
                    return Ne(Ce.value, Fe);
                  }
                  return Ne(Ce.value, Ie);
                }
                case "NumberLiteral":
                  return String(Ce.value);
                case "UndefinedLiteral":
                  return "undefined";
                case "NullLiteral":
                  return "null";
                default:
                  throw new Error("unknown glimmer type: " + JSON.stringify(Ce.type));
              }
            }
            function y(K, he) {
              return h(K) - h(he);
            }
            function N(K, he) {
              let ye = K.getValue(), Ce = ["attributes", "modifiers", "comments"].filter((Fe) => f(ye[Fe])), Ie = Ce.flatMap((Fe) => ye[Fe]).sort(y);
              for (let Fe of Ce)
                K.each((me) => {
                  let _ = Ie.indexOf(me.getValue());
                  Ie.splice(_, 1, [c, he()]);
                }, Fe);
              return f(ye.blockParams) && Ie.push(c, ve(ye)), ["<", ye.tag, i(Ie), b(ye)];
            }
            function x(K, he, ye) {
              let Ie = K.getValue().children.every((Fe) => F(Fe));
              return he.htmlWhitespaceSensitivity === "ignore" && Ie ? "" : K.map((Fe, me) => {
                let _ = ye();
                return me === 0 && he.htmlWhitespaceSensitivity === "ignore" ? [v, _] : _;
              }, "children");
            }
            function b(K) {
              return g(K) ? u([v, "/>"], [" />", v]) : u([v, ">"], ">");
            }
            function L(K) {
              let he = K.escaped === false ? "{{{" : "{{", ye = K.strip && K.strip.open ? "~" : "";
              return [he, ye];
            }
            function M(K) {
              let he = K.escaped === false ? "}}}" : "}}";
              return [K.strip && K.strip.close ? "~" : "", he];
            }
            function j(K) {
              let he = L(K), ye = K.openStrip.open ? "~" : "";
              return [he, ye, "#"];
            }
            function $(K) {
              let he = M(K);
              return [K.openStrip.close ? "~" : "", he];
            }
            function V(K) {
              let he = L(K), ye = K.closeStrip.open ? "~" : "";
              return [he, ye, "/"];
            }
            function q(K) {
              let he = M(K);
              return [K.closeStrip.close ? "~" : "", he];
            }
            function Y(K) {
              let he = L(K), ye = K.inverseStrip.open ? "~" : "";
              return [he, ye];
            }
            function H(K) {
              let he = M(K);
              return [K.inverseStrip.close ? "~" : "", he];
            }
            function R(K, he) {
              let ye = K.getValue(), Ce = j(ye), Ie = $(ye), Fe = [de(K, he)], me = ae(K, he);
              if (me && Fe.push(c, me), f(ye.program.blockParams)) {
                let _ = ve(ye.program);
                Fe.push(c, _);
              }
              return a([Ce, i(Fe), v, Ie]);
            }
            function Q(K, he) {
              return [he.htmlWhitespaceSensitivity === "ignore" ? r : "", Y(K), "else", H(K)];
            }
            function ee(K, he) {
              let ye = K.getParentNode(1);
              return [Y(ye), "else if ", ae(K, he), H(ye)];
            }
            function te(K, he, ye) {
              let Ce = K.getValue();
              return ye.htmlWhitespaceSensitivity === "ignore" ? [oe(Ce) ? v : r, V(Ce), he("path"), q(Ce)] : [V(Ce), he("path"), q(Ce)];
            }
            function oe(K) {
              return P(K, ["BlockStatement"]) && K.program.body.every((he) => F(he));
            }
            function W(K) {
              return X(K) && K.inverse.body.length === 1 && P(K.inverse.body[0], ["BlockStatement"]) && K.inverse.body[0].path.parts[0] === "if";
            }
            function X(K) {
              return P(K, ["BlockStatement"]) && K.inverse;
            }
            function ue(K, he, ye) {
              let Ce = K.getValue();
              if (oe(Ce))
                return "";
              let Ie = he("program");
              return ye.htmlWhitespaceSensitivity === "ignore" ? i([r, Ie]) : i(Ie);
            }
            function De(K, he, ye) {
              let Ce = K.getValue(), Ie = he("inverse"), Fe = ye.htmlWhitespaceSensitivity === "ignore" ? [r, Ie] : Ie;
              return W(Ce) ? Fe : X(Ce) ? [Q(Ce, ye), i(Fe)] : "";
            }
            function ie(K) {
              return m(o(c, G(K)));
            }
            function G(K) {
              return K.split(/[\t\n\f\r ]+/);
            }
            function z(K) {
              for (let he = 0; he < 2; he++) {
                let ye = K.getParentNode(he);
                if (ye && ye.type === "AttrNode")
                  return ye.name.toLowerCase();
              }
            }
            function U(K) {
              return K = typeof K == "string" ? K : "", K.split(`
`).length - 1;
            }
            function le(K) {
              K = typeof K == "string" ? K : "";
              let he = (K.match(/^([^\S\n\r]*[\n\r])+/g) || [])[0] || "";
              return U(he);
            }
            function ge(K) {
              K = typeof K == "string" ? K : "";
              let he = (K.match(/([\n\r][^\S\n\r]*)+$/g) || [])[0] || "";
              return U(he);
            }
            function Ae() {
              let K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
              return Array.from({ length: Math.min(K, l) }).fill(r);
            }
            function Ne(K, he) {
              let { quote: ye, regex: Ce } = p(K, he);
              return [ye, K.replace(Ce, "\\".concat(ye)), ye];
            }
            function ke(K) {
              let he = 0, ye = K.getParentNode(he);
              for (; ye && P(ye, ["SubExpression"]); )
                he++, ye = K.getParentNode(he);
              return !!(ye && P(K.getParentNode(he + 1), ["ConcatStatement"]) && P(K.getParentNode(he + 2), ["AttrNode"]));
            }
            function ce(K, he) {
              let ye = de(K, he), Ce = ae(K, he);
              return Ce ? i([ye, c, a(Ce)]) : ye;
            }
            function pe(K, he) {
              let ye = de(K, he), Ce = ae(K, he);
              return Ce ? [i([ye, c, Ce]), v] : ye;
            }
            function de(K, he) {
              return he("path");
            }
            function ae(K, he) {
              let ye = K.getValue(), Ce = [];
              if (ye.params.length > 0) {
                let Ie = K.map(he, "params");
                Ce.push(...Ie);
              }
              if (ye.hash && ye.hash.pairs.length > 0) {
                let Ie = he("hash");
                Ce.push(Ie);
              }
              return Ce.length === 0 ? "" : o(c, Ce);
            }
            function ve(K) {
              return ["as |", K.blockParams.join(" "), "|"];
            }
            n.exports = { print: E, massageAstNode: T };
          } }), wd = Z({ "src/language-handlebars/parsers.js"() {
            re();
          } }), _d = Z({ "node_modules/linguist-languages/data/Handlebars.json"(e, n) {
            n.exports = { name: "Handlebars", type: "markup", color: "#f7931e", aliases: ["hbs", "htmlbars"], extensions: [".handlebars", ".hbs"], tmScope: "text.html.handlebars", aceMode: "handlebars", languageId: 155 };
          } }), Pd = Z({ "src/language-handlebars/index.js"(e, n) {
            "use strict";
            re();
            var t3 = Bt(), s = Nd(), a = wd(), r = [t3(_d(), () => ({ since: "2.3.0", parsers: ["glimmer"], vscodeLanguageIds: ["handlebars"] }))], u = { glimmer: s };
            n.exports = { languages: r, printers: u, parsers: a };
          } }), kd = Z({ "src/language-graphql/pragma.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return /^\s*#[^\S\n]*@(?:format|prettier)\s*(?:\n|$)/.test(a);
            }
            function s(a) {
              return `# @format

` + a;
            }
            n.exports = { hasPragma: t3, insertPragma: s };
          } }), Id = Z({ "src/language-graphql/loc.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return typeof a.start == "number" ? a.start : a.loc && a.loc.start;
            }
            function s(a) {
              return typeof a.end == "number" ? a.end : a.loc && a.loc.end;
            }
            n.exports = { locStart: t3, locEnd: s };
          } }), Ld = Z({ "src/language-graphql/printer-graphql.js"(e, n) {
            "use strict";
            re();
            var { builders: { join: t3, hardline: s, line: a, softline: r, group: u, indent: i, ifBreak: o } } = Oe(), { isNextLineEmpty: c, isNonEmptyArray: v } = Ue(), { insertPragma: m } = kd(), { locStart: d, locEnd: p } = Id();
            function f(k, P, C) {
              let D = k.getValue();
              if (!D)
                return "";
              if (typeof D == "string")
                return D;
              switch (D.kind) {
                case "Document": {
                  let g = [];
                  return k.each((F, l, E) => {
                    g.push(C()), l !== E.length - 1 && (g.push(s), c(P.originalText, F.getValue(), p) && g.push(s));
                  }, "definitions"), [...g, s];
                }
                case "OperationDefinition": {
                  let g = P.originalText[d(D)] !== "{", F = Boolean(D.name);
                  return [g ? D.operation : "", g && F ? [" ", C("name")] : "", g && !F && v(D.variableDefinitions) ? " " : "", v(D.variableDefinitions) ? u(["(", i([r, t3([o("", ", "), r], k.map(C, "variableDefinitions"))]), r, ")"]) : "", h(k, C, D), D.selectionSet ? !g && !F ? "" : " " : "", C("selectionSet")];
                }
                case "FragmentDefinition":
                  return ["fragment ", C("name"), v(D.variableDefinitions) ? u(["(", i([r, t3([o("", ", "), r], k.map(C, "variableDefinitions"))]), r, ")"]) : "", " on ", C("typeCondition"), h(k, C, D), " ", C("selectionSet")];
                case "SelectionSet":
                  return ["{", i([s, t3(s, w(k, P, C, "selections"))]), s, "}"];
                case "Field":
                  return u([D.alias ? [C("alias"), ": "] : "", C("name"), D.arguments.length > 0 ? u(["(", i([r, t3([o("", ", "), r], w(k, P, C, "arguments"))]), r, ")"]) : "", h(k, C, D), D.selectionSet ? " " : "", C("selectionSet")]);
                case "Name":
                  return D.value;
                case "StringValue": {
                  if (D.block) {
                    let g = D.value.replace(/"""/g, "\\$&").split(`
`);
                    return g.length === 1 && (g[0] = g[0].trim()), g.every((F) => F === "") && (g.length = 0), t3(s, ['"""', ...g, '"""']);
                  }
                  return ['"', D.value.replace(/["\\]/g, "\\$&").replace(/\n/g, "\\n"), '"'];
                }
                case "IntValue":
                case "FloatValue":
                case "EnumValue":
                  return D.value;
                case "BooleanValue":
                  return D.value ? "true" : "false";
                case "NullValue":
                  return "null";
                case "Variable":
                  return ["$", C("name")];
                case "ListValue":
                  return u(["[", i([r, t3([o("", ", "), r], k.map(C, "values"))]), r, "]"]);
                case "ObjectValue":
                  return u(["{", P.bracketSpacing && D.fields.length > 0 ? " " : "", i([r, t3([o("", ", "), r], k.map(C, "fields"))]), r, o("", P.bracketSpacing && D.fields.length > 0 ? " " : ""), "}"]);
                case "ObjectField":
                case "Argument":
                  return [C("name"), ": ", C("value")];
                case "Directive":
                  return ["@", C("name"), D.arguments.length > 0 ? u(["(", i([r, t3([o("", ", "), r], w(k, P, C, "arguments"))]), r, ")"]) : ""];
                case "NamedType":
                  return C("name");
                case "VariableDefinition":
                  return [C("variable"), ": ", C("type"), D.defaultValue ? [" = ", C("defaultValue")] : "", h(k, C, D)];
                case "ObjectTypeExtension":
                case "ObjectTypeDefinition":
                  return [C("description"), D.description ? s : "", D.kind === "ObjectTypeExtension" ? "extend " : "", "type ", C("name"), D.interfaces.length > 0 ? [" implements ", ...S(k, P, C)] : "", h(k, C, D), D.fields.length > 0 ? [" {", i([s, t3(s, w(k, P, C, "fields"))]), s, "}"] : ""];
                case "FieldDefinition":
                  return [C("description"), D.description ? s : "", C("name"), D.arguments.length > 0 ? u(["(", i([r, t3([o("", ", "), r], w(k, P, C, "arguments"))]), r, ")"]) : "", ": ", C("type"), h(k, C, D)];
                case "DirectiveDefinition":
                  return [C("description"), D.description ? s : "", "directive ", "@", C("name"), D.arguments.length > 0 ? u(["(", i([r, t3([o("", ", "), r], w(k, P, C, "arguments"))]), r, ")"]) : "", D.repeatable ? " repeatable" : "", " on ", t3(" | ", k.map(C, "locations"))];
                case "EnumTypeExtension":
                case "EnumTypeDefinition":
                  return [C("description"), D.description ? s : "", D.kind === "EnumTypeExtension" ? "extend " : "", "enum ", C("name"), h(k, C, D), D.values.length > 0 ? [" {", i([s, t3(s, w(k, P, C, "values"))]), s, "}"] : ""];
                case "EnumValueDefinition":
                  return [C("description"), D.description ? s : "", C("name"), h(k, C, D)];
                case "InputValueDefinition":
                  return [C("description"), D.description ? D.description.block ? s : a : "", C("name"), ": ", C("type"), D.defaultValue ? [" = ", C("defaultValue")] : "", h(k, C, D)];
                case "InputObjectTypeExtension":
                case "InputObjectTypeDefinition":
                  return [C("description"), D.description ? s : "", D.kind === "InputObjectTypeExtension" ? "extend " : "", "input ", C("name"), h(k, C, D), D.fields.length > 0 ? [" {", i([s, t3(s, w(k, P, C, "fields"))]), s, "}"] : ""];
                case "SchemaExtension":
                  return ["extend schema", h(k, C, D), ...D.operationTypes.length > 0 ? [" {", i([s, t3(s, w(k, P, C, "operationTypes"))]), s, "}"] : []];
                case "SchemaDefinition":
                  return [C("description"), D.description ? s : "", "schema", h(k, C, D), " {", D.operationTypes.length > 0 ? i([s, t3(s, w(k, P, C, "operationTypes"))]) : "", s, "}"];
                case "OperationTypeDefinition":
                  return [C("operation"), ": ", C("type")];
                case "InterfaceTypeExtension":
                case "InterfaceTypeDefinition":
                  return [C("description"), D.description ? s : "", D.kind === "InterfaceTypeExtension" ? "extend " : "", "interface ", C("name"), D.interfaces.length > 0 ? [" implements ", ...S(k, P, C)] : "", h(k, C, D), D.fields.length > 0 ? [" {", i([s, t3(s, w(k, P, C, "fields"))]), s, "}"] : ""];
                case "FragmentSpread":
                  return ["...", C("name"), h(k, C, D)];
                case "InlineFragment":
                  return ["...", D.typeCondition ? [" on ", C("typeCondition")] : "", h(k, C, D), " ", C("selectionSet")];
                case "UnionTypeExtension":
                case "UnionTypeDefinition":
                  return u([C("description"), D.description ? s : "", u([D.kind === "UnionTypeExtension" ? "extend " : "", "union ", C("name"), h(k, C, D), D.types.length > 0 ? [" =", o("", " "), i([o([a, "  "]), t3([a, "| "], k.map(C, "types"))])] : ""])]);
                case "ScalarTypeExtension":
                case "ScalarTypeDefinition":
                  return [C("description"), D.description ? s : "", D.kind === "ScalarTypeExtension" ? "extend " : "", "scalar ", C("name"), h(k, C, D)];
                case "NonNullType":
                  return [C("type"), "!"];
                case "ListType":
                  return ["[", C("type"), "]"];
                default:
                  throw new Error("unknown graphql type: " + JSON.stringify(D.kind));
              }
            }
            function h(k, P, C) {
              if (C.directives.length === 0)
                return "";
              let D = t3(a, k.map(P, "directives"));
              return C.kind === "FragmentDefinition" || C.kind === "OperationDefinition" ? u([a, D]) : [" ", u(i([r, D]))];
            }
            function w(k, P, C, D) {
              return k.map((g, F, l) => {
                let E = C();
                return F < l.length - 1 && c(P.originalText, g.getValue(), p) ? [E, s] : E;
              }, D);
            }
            function T(k) {
              return k.kind && k.kind !== "Comment";
            }
            function A(k) {
              let P = k.getValue();
              if (P.kind === "Comment")
                return "#" + P.value.trimEnd();
              throw new Error("Not a comment: " + JSON.stringify(P));
            }
            function S(k, P, C) {
              let D = k.getNode(), g = [], { interfaces: F } = D, l = k.map((E) => C(E), "interfaces");
              for (let E = 0; E < F.length; E++) {
                let y = F[E];
                g.push(l[E]);
                let N = F[E + 1];
                if (N) {
                  let x = P.originalText.slice(y.loc.end, N.loc.start), b = x.includes("#"), L = x.replace(/#.*/g, "").trim();
                  g.push(L === "," ? "," : " &", b ? a : " ");
                }
              }
              return g;
            }
            function B(k, P) {
              k.kind === "StringValue" && k.block && !k.value.includes(`
`) && (P.value = P.value.trim());
            }
            B.ignoredProperties = /* @__PURE__ */ new Set(["loc", "comments"]);
            function I(k) {
              var P;
              let C = k.getValue();
              return C == null || (P = C.comments) === null || P === void 0 ? void 0 : P.some((D) => D.value.trim() === "prettier-ignore");
            }
            n.exports = { print: f, massageAstNode: B, hasPrettierIgnore: I, insertPragma: m, printComment: A, canAttachComment: T };
          } }), jd = Z({ "src/language-graphql/options.js"(e, n) {
            "use strict";
            re();
            var t3 = Ot();
            n.exports = { bracketSpacing: t3.bracketSpacing };
          } }), Od = Z({ "src/language-graphql/parsers.js"() {
            re();
          } }), qd = Z({ "node_modules/linguist-languages/data/GraphQL.json"(e, n) {
            n.exports = { name: "GraphQL", type: "data", color: "#e10098", extensions: [".graphql", ".gql", ".graphqls"], tmScope: "source.graphql", aceMode: "text", languageId: 139 };
          } }), Md = Z({ "src/language-graphql/index.js"(e, n) {
            "use strict";
            re();
            var t3 = Bt(), s = Ld(), a = jd(), r = Od(), u = [t3(qd(), () => ({ since: "1.5.0", parsers: ["graphql"], vscodeLanguageIds: ["graphql"] }))], i = { graphql: s };
            n.exports = { languages: u, options: a, printers: i, parsers: r };
          } }), go = Z({ "src/language-markdown/loc.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return a.position.start.offset;
            }
            function s(a) {
              return a.position.end.offset;
            }
            n.exports = { locStart: t3, locEnd: s };
          } }), Rd = Z({ "src/language-markdown/constants.evaluate.js"(e, n) {
            n.exports = { cjkPattern: "(?:[\\u02ea-\\u02eb\\u1100-\\u11ff\\u2e80-\\u2e99\\u2e9b-\\u2ef3\\u2f00-\\u2fd5\\u2ff0-\\u303f\\u3041-\\u3096\\u3099-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312f\\u3131-\\u318e\\u3190-\\u3191\\u3196-\\u31ba\\u31c0-\\u31e3\\u31f0-\\u321e\\u322a-\\u3247\\u3260-\\u327e\\u328a-\\u32b0\\u32c0-\\u32cb\\u32d0-\\u3370\\u337b-\\u337f\\u33e0-\\u33fe\\u3400-\\u4db5\\u4e00-\\u9fef\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufe10-\\ufe1f\\ufe30-\\ufe6f\\uff00-\\uffef]|[\\ud840-\\ud868\\ud86a-\\ud86c\\ud86f-\\ud872\\ud874-\\ud879][\\udc00-\\udfff]|\\ud82c[\\udc00-\\udd1e\\udd50-\\udd52\\udd64-\\udd67]|\\ud83c[\\ude00\\ude50-\\ude51]|\\ud869[\\udc00-\\uded6\\udf00-\\udfff]|\\ud86d[\\udc00-\\udf34\\udf40-\\udfff]|\\ud86e[\\udc00-\\udc1d\\udc20-\\udfff]|\\ud873[\\udc00-\\udea1\\udeb0-\\udfff]|\\ud87a[\\udc00-\\udfe0]|\\ud87e[\\udc00-\\ude1d])(?:[\\ufe00-\\ufe0f]|\\udb40[\\udd00-\\uddef])?", kPattern: "[\\u1100-\\u11ff\\u3001-\\u3003\\u3008-\\u3011\\u3013-\\u301f\\u302e-\\u3030\\u3037\\u30fb\\u3131-\\u318e\\u3200-\\u321e\\u3260-\\u327e\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\ufe45-\\ufe46\\uff61-\\uff65\\uffa0-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc]", punctuationPattern: "[\\u0021-\\u002f\\u003a-\\u0040\\u005b-\\u0060\\u007b-\\u007e\\u00a1\\u00a7\\u00ab\\u00b6-\\u00b7\\u00bb\\u00bf\\u037e\\u0387\\u055a-\\u055f\\u0589-\\u058a\\u05be\\u05c0\\u05c3\\u05c6\\u05f3-\\u05f4\\u0609-\\u060a\\u060c-\\u060d\\u061b\\u061e-\\u061f\\u066a-\\u066d\\u06d4\\u0700-\\u070d\\u07f7-\\u07f9\\u0830-\\u083e\\u085e\\u0964-\\u0965\\u0970\\u09fd\\u0a76\\u0af0\\u0c77\\u0c84\\u0df4\\u0e4f\\u0e5a-\\u0e5b\\u0f04-\\u0f12\\u0f14\\u0f3a-\\u0f3d\\u0f85\\u0fd0-\\u0fd4\\u0fd9-\\u0fda\\u104a-\\u104f\\u10fb\\u1360-\\u1368\\u1400\\u166e\\u169b-\\u169c\\u16eb-\\u16ed\\u1735-\\u1736\\u17d4-\\u17d6\\u17d8-\\u17da\\u1800-\\u180a\\u1944-\\u1945\\u1a1e-\\u1a1f\\u1aa0-\\u1aa6\\u1aa8-\\u1aad\\u1b5a-\\u1b60\\u1bfc-\\u1bff\\u1c3b-\\u1c3f\\u1c7e-\\u1c7f\\u1cc0-\\u1cc7\\u1cd3\\u2010-\\u2027\\u2030-\\u2043\\u2045-\\u2051\\u2053-\\u205e\\u207d-\\u207e\\u208d-\\u208e\\u2308-\\u230b\\u2329-\\u232a\\u2768-\\u2775\\u27c5-\\u27c6\\u27e6-\\u27ef\\u2983-\\u2998\\u29d8-\\u29db\\u29fc-\\u29fd\\u2cf9-\\u2cfc\\u2cfe-\\u2cff\\u2d70\\u2e00-\\u2e2e\\u2e30-\\u2e4f\\u3001-\\u3003\\u3008-\\u3011\\u3014-\\u301f\\u3030\\u303d\\u30a0\\u30fb\\ua4fe-\\ua4ff\\ua60d-\\ua60f\\ua673\\ua67e\\ua6f2-\\ua6f7\\ua874-\\ua877\\ua8ce-\\ua8cf\\ua8f8-\\ua8fa\\ua8fc\\ua92e-\\ua92f\\ua95f\\ua9c1-\\ua9cd\\ua9de-\\ua9df\\uaa5c-\\uaa5f\\uaade-\\uaadf\\uaaf0-\\uaaf1\\uabeb\\ufd3e-\\ufd3f\\ufe10-\\ufe19\\ufe30-\\ufe52\\ufe54-\\ufe61\\ufe63\\ufe68\\ufe6a-\\ufe6b\\uff01-\\uff03\\uff05-\\uff0a\\uff0c-\\uff0f\\uff1a-\\uff1b\\uff1f-\\uff20\\uff3b-\\uff3d\\uff3f\\uff5b\\uff5d\\uff5f-\\uff65]|\\ud800[\\udd00-\\udd02\\udf9f\\udfd0]|\\ud801[\\udd6f]|\\ud802[\\udc57\\udd1f\\udd3f\\ude50-\\ude58\\ude7f\\udef0-\\udef6\\udf39-\\udf3f\\udf99-\\udf9c]|\\ud803[\\udf55-\\udf59]|\\ud804[\\udc47-\\udc4d\\udcbb-\\udcbc\\udcbe-\\udcc1\\udd40-\\udd43\\udd74-\\udd75\\uddc5-\\uddc8\\uddcd\\udddb\\udddd-\\udddf\\ude38-\\ude3d\\udea9]|\\ud805[\\udc4b-\\udc4f\\udc5b\\udc5d\\udcc6\\uddc1-\\uddd7\\ude41-\\ude43\\ude60-\\ude6c\\udf3c-\\udf3e]|\\ud806[\\udc3b\\udde2\\ude3f-\\ude46\\ude9a-\\ude9c\\ude9e-\\udea2]|\\ud807[\\udc41-\\udc45\\udc70-\\udc71\\udef7-\\udef8\\udfff]|\\ud809[\\udc70-\\udc74]|\\ud81a[\\ude6e-\\ude6f\\udef5\\udf37-\\udf3b\\udf44]|\\ud81b[\\ude97-\\ude9a\\udfe2]|\\ud82f[\\udc9f]|\\ud836[\\ude87-\\ude8b]|\\ud83a[\\udd5e-\\udd5f]" };
          } }), Kn = Z({ "src/language-markdown/utils.js"(e, n) {
            "use strict";
            re();
            var { getLast: t3 } = Ue(), { locStart: s, locEnd: a } = go(), { cjkPattern: r, kPattern: u, punctuationPattern: i } = Rd(), o = ["liquidNode", "inlineCode", "emphasis", "esComment", "strong", "delete", "wikiLink", "link", "linkReference", "image", "imageReference", "footnote", "footnoteReference", "sentence", "whitespace", "word", "break", "inlineMath"], c = [...o, "tableCell", "paragraph", "heading"], v = new RegExp(u), m = new RegExp(i);
            function d(A, S) {
              let B = "non-cjk", I = "cj-letter", k = "k-letter", P = "cjk-punctuation", C = [], D = (S.proseWrap === "preserve" ? A : A.replace(new RegExp("(".concat(r, `)
(`).concat(r, ")"), "g"), "$1$2")).split(/([\t\n ]+)/);
              for (let [F, l] of D.entries()) {
                if (F % 2 === 1) {
                  C.push({ type: "whitespace", value: /\n/.test(l) ? `
` : " " });
                  continue;
                }
                if ((F === 0 || F === D.length - 1) && l === "")
                  continue;
                let E = l.split(new RegExp("(".concat(r, ")")));
                for (let [y, N] of E.entries())
                  if (!((y === 0 || y === E.length - 1) && N === "")) {
                    if (y % 2 === 0) {
                      N !== "" && g({ type: "word", value: N, kind: B, hasLeadingPunctuation: m.test(N[0]), hasTrailingPunctuation: m.test(t3(N)) });
                      continue;
                    }
                    g(m.test(N) ? { type: "word", value: N, kind: P, hasLeadingPunctuation: true, hasTrailingPunctuation: true } : { type: "word", value: N, kind: v.test(N) ? k : I, hasLeadingPunctuation: false, hasTrailingPunctuation: false });
                  }
              }
              return C;
              function g(F) {
                let l = t3(C);
                l && l.type === "word" && (l.kind === B && F.kind === I && !l.hasTrailingPunctuation || l.kind === I && F.kind === B && !F.hasLeadingPunctuation ? C.push({ type: "whitespace", value: " " }) : !E(B, P) && ![l.value, F.value].some((y) => /\u3000/.test(y)) && C.push({ type: "whitespace", value: "" })), C.push(F);
                function E(y, N) {
                  return l.kind === y && F.kind === N || l.kind === N && F.kind === y;
                }
              }
            }
            function p(A, S) {
              let [, B, I, k] = S.slice(A.position.start.offset, A.position.end.offset).match(/^\s*(\d+)(\.|\))(\s*)/);
              return { numberText: B, marker: I, leadingSpaces: k };
            }
            function f(A, S) {
              if (!A.ordered || A.children.length < 2)
                return false;
              let B = Number(p(A.children[0], S.originalText).numberText), I = Number(p(A.children[1], S.originalText).numberText);
              if (B === 0 && A.children.length > 2) {
                let k = Number(p(A.children[2], S.originalText).numberText);
                return I === 1 && k === 1;
              }
              return I === 1;
            }
            function h(A, S) {
              let { value: B } = A;
              return A.position.end.offset === S.length && B.endsWith(`
`) && S.endsWith(`
`) ? B.slice(0, -1) : B;
            }
            function w(A, S) {
              return function B(I, k, P) {
                let C = Object.assign({}, S(I, k, P));
                return C.children && (C.children = C.children.map((D, g) => B(D, g, [C, ...P]))), C;
              }(A, null, []);
            }
            function T(A) {
              if ((A == null ? void 0 : A.type) !== "link" || A.children.length !== 1)
                return false;
              let [S] = A.children;
              return s(A) === s(S) && a(A) === a(S);
            }
            n.exports = { mapAst: w, splitText: d, punctuationPattern: i, getFencedCodeBlockValue: h, getOrderedListItemInfo: p, hasGitDiffFriendlyOrderedList: f, INLINE_NODE_TYPES: o, INLINE_NODE_WRAPPER_TYPES: c, isAutolink: T };
          } }), Vd = Z({ "src/language-markdown/embed.js"(e, n) {
            "use strict";
            re();
            var { inferParserByLanguage: t3, getMaxContinuousCount: s } = Ue(), { builders: { hardline: a, markAsRoot: r }, utils: { replaceEndOfLine: u } } = Oe(), i = Xn(), { getFencedCodeBlockValue: o } = Kn();
            function c(v, m, d, p) {
              let f = v.getValue();
              if (f.type === "code" && f.lang !== null) {
                let h = t3(f.lang, p);
                if (h) {
                  let w = p.__inJsTemplate ? "~" : "`", T = w.repeat(Math.max(3, s(f.value, w) + 1)), A = { parser: h };
                  f.lang === "tsx" && (A.filepath = "dummy.tsx");
                  let S = d(o(f, p.originalText), A, { stripTrailingHardline: true });
                  return r([T, f.lang, f.meta ? " " + f.meta : "", a, u(S), a, T]);
                }
              }
              switch (f.type) {
                case "front-matter":
                  return i(f, d);
                case "importExport":
                  return [d(f.value, { parser: "babel" }, { stripTrailingHardline: true }), a];
                case "jsx":
                  return d("<$>".concat(f.value, "</$>"), { parser: "__js_expression", rootMarker: "mdx" }, { stripTrailingHardline: true });
              }
              return null;
            }
            n.exports = c;
          } }), yo = Z({ "src/language-markdown/pragma.js"(e, n) {
            "use strict";
            re();
            var t3 = mo(), s = ["format", "prettier"];
            function a(r) {
              let u = "@(".concat(s.join("|"), ")"), i = new RegExp(["<!--\\s*".concat(u, "\\s*-->"), "{\\s*\\/\\*\\s*".concat(u, "\\s*\\*\\/\\s*}"), `<!--.*\r?
[\\s\\S]*(^|
)[^\\S
]*`.concat(u, `[^\\S
]*($|
)[\\s\\S]*
.*-->`)].join("|"), "m"), o = r.match(i);
              return (o == null ? void 0 : o.index) === 0;
            }
            n.exports = { startWithPragma: a, hasPragma: (r) => a(t3(r).content.trimStart()), insertPragma: (r) => {
              let u = t3(r), i = "<!-- @".concat(s[0], " -->");
              return u.frontMatter ? "".concat(u.frontMatter.raw, `

`).concat(i, `

`).concat(u.content) : "".concat(i, `

`).concat(u.content);
            } };
          } }), Wd = Z({ "src/language-markdown/print-preprocess.js"(e, n) {
            "use strict";
            re();
            var t3 = it(), { getOrderedListItemInfo: s, mapAst: a, splitText: r } = Kn(), u = /^.$/su;
            function i(T, A) {
              return T = v(T, A), T = p(T), T = c(T), T = h(T, A), T = w(T, A), T = f(T, A), T = o(T), T = m(T), T;
            }
            function o(T) {
              return a(T, (A) => A.type !== "import" && A.type !== "export" ? A : Object.assign(Object.assign({}, A), {}, { type: "importExport" }));
            }
            function c(T) {
              return a(T, (A) => A.type !== "inlineCode" ? A : Object.assign(Object.assign({}, A), {}, { value: A.value.replace(/\s+/g, " ") }));
            }
            function v(T, A) {
              return a(T, (S) => S.type !== "text" || S.value === "*" || S.value === "_" || !u.test(S.value) || S.position.end.offset - S.position.start.offset === S.value.length ? S : Object.assign(Object.assign({}, S), {}, { value: A.originalText.slice(S.position.start.offset, S.position.end.offset) }));
            }
            function m(T) {
              return d(T, (A, S) => A.type === "importExport" && S.type === "importExport", (A, S) => ({ type: "importExport", value: A.value + `

` + S.value, position: { start: A.position.start, end: S.position.end } }));
            }
            function d(T, A, S) {
              return a(T, (B) => {
                if (!B.children)
                  return B;
                let I = B.children.reduce((k, P) => {
                  let C = t3(k);
                  return C && A(C, P) ? k.splice(-1, 1, S(C, P)) : k.push(P), k;
                }, []);
                return Object.assign(Object.assign({}, B), {}, { children: I });
              });
            }
            function p(T) {
              return d(T, (A, S) => A.type === "text" && S.type === "text", (A, S) => ({ type: "text", value: A.value + S.value, position: { start: A.position.start, end: S.position.end } }));
            }
            function f(T, A) {
              return a(T, (S, B, I) => {
                let [k] = I;
                if (S.type !== "text")
                  return S;
                let { value: P } = S;
                return k.type === "paragraph" && (B === 0 && (P = P.trimStart()), B === k.children.length - 1 && (P = P.trimEnd())), { type: "sentence", position: S.position, children: r(P, A) };
              });
            }
            function h(T, A) {
              return a(T, (S, B, I) => {
                if (S.type === "code") {
                  let k = /^\n?(?: {4,}|\t)/.test(A.originalText.slice(S.position.start.offset, S.position.end.offset));
                  if (S.isIndented = k, k)
                    for (let P = 0; P < I.length; P++) {
                      let C = I[P];
                      if (C.hasIndentedCodeblock)
                        break;
                      C.type === "list" && (C.hasIndentedCodeblock = true);
                    }
                }
                return S;
              });
            }
            function w(T, A) {
              return a(T, (I, k, P) => {
                if (I.type === "list" && I.children.length > 0) {
                  for (let C = 0; C < P.length; C++) {
                    let D = P[C];
                    if (D.type === "list" && !D.isAligned)
                      return I.isAligned = false, I;
                  }
                  I.isAligned = B(I);
                }
                return I;
              });
              function S(I) {
                return I.children.length === 0 ? -1 : I.children[0].position.start.column - 1;
              }
              function B(I) {
                if (!I.ordered)
                  return true;
                let [k, P] = I.children;
                if (s(k, A.originalText).leadingSpaces.length > 1)
                  return true;
                let D = S(k);
                if (D === -1)
                  return false;
                if (I.children.length === 1)
                  return D % A.tabWidth === 0;
                let g = S(P);
                return D !== g ? false : D % A.tabWidth === 0 ? true : s(P, A.originalText).leadingSpaces.length > 1;
              }
            }
            n.exports = i;
          } }), $d = Z({ "src/language-markdown/clean.js"(e, n) {
            "use strict";
            re();
            var { isFrontMatterNode: t3 } = Ue(), { startWithPragma: s } = yo(), a = /* @__PURE__ */ new Set(["position", "raw"]);
            function r(u, i, o) {
              if ((u.type === "front-matter" || u.type === "code" || u.type === "yaml" || u.type === "import" || u.type === "export" || u.type === "jsx") && delete i.value, u.type === "list" && delete i.isAligned, (u.type === "list" || u.type === "listItem") && (delete i.spread, delete i.loose), u.type === "text" || (u.type === "inlineCode" && (i.value = u.value.replace(/[\t\n ]+/g, " ")), u.type === "wikiLink" && (i.value = u.value.trim().replace(/[\t\n]+/g, " ")), (u.type === "definition" || u.type === "linkReference") && (i.label = u.label.trim().replace(/[\t\n ]+/g, " ").toLowerCase()), (u.type === "definition" || u.type === "link" || u.type === "image") && u.title && (i.title = u.title.replace(/\\(["')])/g, "$1")), o && o.type === "root" && o.children.length > 0 && (o.children[0] === u || t3(o.children[0]) && o.children[1] === u) && u.type === "html" && s(u.value)))
                return null;
            }
            r.ignoredProperties = a, n.exports = r;
          } }), Hd = Z({ "src/language-markdown/printer-markdown.js"(e, n) {
            "use strict";
            re();
            var { getLast: t3, getMinNotPresentContinuousCount: s, getMaxContinuousCount: a, getStringWidth: r, isNonEmptyArray: u } = Ue(), { builders: { breakParent: i, join: o, line: c, literalline: v, markAsRoot: m, hardline: d, softline: p, ifBreak: f, fill: h, align: w, indent: T, group: A, hardlineWithoutBreakParent: S }, utils: { normalizeDoc: B, replaceTextEndOfLine: I }, printer: { printDocToString: k } } = Oe(), P = Vd(), { insertPragma: C } = yo(), { locStart: D, locEnd: g } = go(), F = Wd(), l = $d(), { getFencedCodeBlockValue: E, hasGitDiffFriendlyOrderedList: y, splitText: N, punctuationPattern: x, INLINE_NODE_TYPES: b, INLINE_NODE_WRAPPER_TYPES: L, isAutolink: M } = Kn(), j = /* @__PURE__ */ new Set(["importExport"]), $ = ["heading", "tableCell", "link", "wikiLink"], V = /* @__PURE__ */ new Set(["listItem", "definition", "footnoteDefinition"]);
            function q(ce, pe, de) {
              let ae = ce.getValue();
              if (le(ce))
                return N(pe.originalText.slice(ae.position.start.offset, ae.position.end.offset), pe).map((ve) => ve.type === "word" ? ve.value : ve.value === "" ? "" : oe(ce, ve.value, pe));
              switch (ae.type) {
                case "front-matter":
                  return pe.originalText.slice(ae.position.start.offset, ae.position.end.offset);
                case "root":
                  return ae.children.length === 0 ? "" : [B(X(ce, pe, de)), j.has(De(ae).type) ? "" : d];
                case "paragraph":
                  return ue(ce, pe, de, { postprocessor: h });
                case "sentence":
                  return ue(ce, pe, de);
                case "word": {
                  let ve = ae.value.replace(/\*/g, "\\$&").replace(new RegExp(["(^|".concat(x, ")(_+)"), "(_+)(".concat(x, "|$)")].join("|"), "g"), (ye, Ce, Ie, Fe, me) => (Ie ? "".concat(Ce).concat(Ie) : "".concat(Fe).concat(me)).replace(/_/g, "\\_")), K = (ye, Ce, Ie) => ye.type === "sentence" && Ie === 0, he = (ye, Ce, Ie) => M(ye.children[Ie - 1]);
                  return ve !== ae.value && (ce.match(void 0, K, he) || ce.match(void 0, K, (ye, Ce, Ie) => ye.type === "emphasis" && Ie === 0, he)) && (ve = ve.replace(/^(\\?[*_])+/, (ye) => ye.replace(/\\/g, ""))), ve;
                }
                case "whitespace": {
                  let ve = ce.getParentNode(), K = ve.children.indexOf(ae), he = ve.children[K + 1], ye = he && /^>|^(?:[*+-]|#{1,6}|\d+[).])$/.test(he.value) ? "never" : pe.proseWrap;
                  return oe(ce, ae.value, { proseWrap: ye });
                }
                case "emphasis": {
                  let ve;
                  if (M(ae.children[0]))
                    ve = pe.originalText[ae.position.start.offset];
                  else {
                    let K = ce.getParentNode(), he = K.children.indexOf(ae), ye = K.children[he - 1], Ce = K.children[he + 1];
                    ve = ye && ye.type === "sentence" && ye.children.length > 0 && t3(ye.children).type === "word" && !t3(ye.children).hasTrailingPunctuation || Ce && Ce.type === "sentence" && Ce.children.length > 0 && Ce.children[0].type === "word" && !Ce.children[0].hasLeadingPunctuation || te(ce, "emphasis") ? "*" : "_";
                  }
                  return [ve, ue(ce, pe, de), ve];
                }
                case "strong":
                  return ["**", ue(ce, pe, de), "**"];
                case "delete":
                  return ["~~", ue(ce, pe, de), "~~"];
                case "inlineCode": {
                  let ve = s(ae.value, "`"), K = "`".repeat(ve || 1), he = ve && !/^\s/.test(ae.value) ? " " : "";
                  return [K, he, ae.value, he, K];
                }
                case "wikiLink": {
                  let ve = "";
                  return pe.proseWrap === "preserve" ? ve = ae.value : ve = ae.value.replace(/[\t\n]+/g, " "), ["[[", ve, "]]"];
                }
                case "link":
                  switch (pe.originalText[ae.position.start.offset]) {
                    case "<": {
                      let ve = "mailto:", K = ae.url.startsWith(ve) && pe.originalText.slice(ae.position.start.offset + 1, ae.position.start.offset + 1 + ve.length) !== ve ? ae.url.slice(ve.length) : ae.url;
                      return ["<", K, ">"];
                    }
                    case "[":
                      return ["[", ue(ce, pe, de), "](", ge(ae.url, ")"), Ae(ae.title, pe), ")"];
                    default:
                      return pe.originalText.slice(ae.position.start.offset, ae.position.end.offset);
                  }
                case "image":
                  return ["![", ae.alt || "", "](", ge(ae.url, ")"), Ae(ae.title, pe), ")"];
                case "blockquote":
                  return ["> ", w("> ", ue(ce, pe, de))];
                case "heading":
                  return ["#".repeat(ae.depth) + " ", ue(ce, pe, de)];
                case "code": {
                  if (ae.isIndented) {
                    let he = " ".repeat(4);
                    return w(he, [he, ...I(ae.value, d)]);
                  }
                  let ve = pe.__inJsTemplate ? "~" : "`", K = ve.repeat(Math.max(3, a(ae.value, ve) + 1));
                  return [K, ae.lang || "", ae.meta ? " " + ae.meta : "", d, ...I(E(ae, pe.originalText), d), d, K];
                }
                case "html": {
                  let ve = ce.getParentNode(), K = ve.type === "root" && t3(ve.children) === ae ? ae.value.trimEnd() : ae.value, he = /^<!--.*-->$/s.test(K);
                  return I(K, he ? d : m(v));
                }
                case "list": {
                  let ve = R(ae, ce.getParentNode()), K = y(ae, pe);
                  return ue(ce, pe, de, { processor: (he, ye) => {
                    let Ce = Fe(), Ie = he.getValue();
                    if (Ie.children.length === 2 && Ie.children[1].type === "html" && Ie.children[0].position.start.column !== Ie.children[1].position.start.column)
                      return [Ce, Y(he, pe, de, Ce)];
                    return [Ce, w(" ".repeat(Ce.length), Y(he, pe, de, Ce))];
                    function Fe() {
                      let me = ae.ordered ? (ye === 0 ? ae.start : K ? 1 : ae.start + ye) + (ve % 2 === 0 ? ". " : ") ") : ve % 2 === 0 ? "- " : "* ";
                      return ae.isAligned || ae.hasIndentedCodeblock ? H(me, pe) : me;
                    }
                  } });
                }
                case "thematicBreak": {
                  let ve = ee(ce, "list");
                  return ve === -1 ? "---" : R(ce.getParentNode(ve), ce.getParentNode(ve + 1)) % 2 === 0 ? "***" : "---";
                }
                case "linkReference":
                  return ["[", ue(ce, pe, de), "]", ae.referenceType === "full" ? ["[", ae.identifier, "]"] : ae.referenceType === "collapsed" ? "[]" : ""];
                case "imageReference":
                  switch (ae.referenceType) {
                    case "full":
                      return ["![", ae.alt || "", "][", ae.identifier, "]"];
                    default:
                      return ["![", ae.alt, "]", ae.referenceType === "collapsed" ? "[]" : ""];
                  }
                case "definition": {
                  let ve = pe.proseWrap === "always" ? c : " ";
                  return A(["[", ae.identifier, "]:", T([ve, ge(ae.url), ae.title === null ? "" : [ve, Ae(ae.title, pe, false)]])]);
                }
                case "footnote":
                  return ["[^", ue(ce, pe, de), "]"];
                case "footnoteReference":
                  return ["[^", ae.identifier, "]"];
                case "footnoteDefinition": {
                  let ve = ce.getParentNode().children[ce.getName() + 1], K = ae.children.length === 1 && ae.children[0].type === "paragraph" && (pe.proseWrap === "never" || pe.proseWrap === "preserve" && ae.children[0].position.start.line === ae.children[0].position.end.line);
                  return ["[^", ae.identifier, "]: ", K ? ue(ce, pe, de) : A([w(" ".repeat(4), ue(ce, pe, de, { processor: (he, ye) => ye === 0 ? A([p, de()]) : de() })), ve && ve.type === "footnoteDefinition" ? p : ""])];
                }
                case "table":
                  return W(ce, pe, de);
                case "tableCell":
                  return ue(ce, pe, de);
                case "break":
                  return /\s/.test(pe.originalText[ae.position.start.offset]) ? ["  ", m(v)] : ["\\", d];
                case "liquidNode":
                  return I(ae.value, d);
                case "importExport":
                  return [ae.value, d];
                case "esComment":
                  return ["{/* ", ae.value, " */}"];
                case "jsx":
                  return ae.value;
                case "math":
                  return ["$$", d, ae.value ? [...I(ae.value, d), d] : "", "$$"];
                case "inlineMath":
                  return pe.originalText.slice(D(ae), g(ae));
                case "tableRow":
                case "listItem":
                default:
                  throw new Error("Unknown markdown type ".concat(JSON.stringify(ae.type)));
              }
            }
            function Y(ce, pe, de, ae) {
              let ve = ce.getValue(), K = ve.checked === null ? "" : ve.checked ? "[x] " : "[ ] ";
              return [K, ue(ce, pe, de, { processor: (he, ye) => {
                if (ye === 0 && he.getValue().type !== "list")
                  return w(" ".repeat(K.length), de());
                let Ce = " ".repeat(Ne(pe.tabWidth - ae.length, 0, 3));
                return [Ce, w(Ce, de())];
              } })];
            }
            function H(ce, pe) {
              let de = ae();
              return ce + " ".repeat(de >= 4 ? 0 : de);
              function ae() {
                let ve = ce.length % pe.tabWidth;
                return ve === 0 ? 0 : pe.tabWidth - ve;
              }
            }
            function R(ce, pe) {
              return Q(ce, pe, (de) => de.ordered === ce.ordered);
            }
            function Q(ce, pe, de) {
              let ae = -1;
              for (let ve of pe.children)
                if (ve.type === ce.type && de(ve) ? ae++ : ae = -1, ve === ce)
                  return ae;
            }
            function ee(ce, pe) {
              let de = Array.isArray(pe) ? pe : [pe], ae = -1, ve;
              for (; ve = ce.getParentNode(++ae); )
                if (de.includes(ve.type))
                  return ae;
              return -1;
            }
            function te(ce, pe) {
              let de = ee(ce, pe);
              return de === -1 ? null : ce.getParentNode(de);
            }
            function oe(ce, pe, de) {
              if (de.proseWrap === "preserve" && pe === `
`)
                return d;
              let ae = de.proseWrap === "always" && !te(ce, $);
              return pe !== "" ? ae ? c : " " : ae ? p : "";
            }
            function W(ce, pe, de) {
              let ae = ce.getValue(), ve = [], K = ce.map((me) => me.map((_, J) => {
                let ne = k(de(), pe).formatted, Ee = r(ne);
                return ve[J] = Math.max(ve[J] || 3, Ee), { text: ne, width: Ee };
              }, "children"), "children"), he = Ce(false);
              if (pe.proseWrap !== "never")
                return [i, he];
              let ye = Ce(true);
              return [i, A(f(ye, he))];
              function Ce(me) {
                let _ = [Fe(K[0], me), Ie(me)];
                return K.length > 1 && _.push(o(S, K.slice(1).map((J) => Fe(J, me)))), o(S, _);
              }
              function Ie(me) {
                let _ = ve.map((J, ne) => {
                  let Ee = ae.align[ne], We = Ee === "center" || Ee === "left" ? ":" : "-", Be = Ee === "center" || Ee === "right" ? ":" : "-", Pe = me ? "-" : "-".repeat(J - 2);
                  return "".concat(We).concat(Pe).concat(Be);
                });
                return "| ".concat(_.join(" | "), " |");
              }
              function Fe(me, _) {
                let J = me.map((ne, Ee) => {
                  let { text: We, width: Be } = ne;
                  if (_)
                    return We;
                  let Pe = ve[Ee] - Be, Se = ae.align[Ee], Qe = 0;
                  Se === "right" ? Qe = Pe : Se === "center" && (Qe = Math.floor(Pe / 2));
                  let xe = Pe - Qe;
                  return "".concat(" ".repeat(Qe)).concat(We).concat(" ".repeat(xe));
                });
                return "| ".concat(J.join(" | "), " |");
              }
            }
            function X(ce, pe, de) {
              let ae = [], ve = null, { children: K } = ce.getValue();
              for (let [he, ye] of K.entries())
                switch (ie(ye)) {
                  case "start":
                    ve === null && (ve = { index: he, offset: ye.position.end.offset });
                    break;
                  case "end":
                    ve !== null && (ae.push({ start: ve, end: { index: he, offset: ye.position.start.offset } }), ve = null);
                    break;
                  default:
                    break;
                }
              return ue(ce, pe, de, { processor: (he, ye) => {
                if (ae.length > 0) {
                  let Ce = ae[0];
                  if (ye === Ce.start.index)
                    return [K[Ce.start.index].value, pe.originalText.slice(Ce.start.offset, Ce.end.offset), K[Ce.end.index].value];
                  if (Ce.start.index < ye && ye < Ce.end.index)
                    return false;
                  if (ye === Ce.end.index)
                    return ae.shift(), false;
                }
                return de();
              } });
            }
            function ue(ce, pe, de) {
              let ae = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, { postprocessor: ve } = ae, K = ae.processor || (() => de()), he = ce.getValue(), ye = [], Ce;
              return ce.each((Ie, Fe) => {
                let me = Ie.getValue(), _ = K(Ie, Fe);
                if (_ !== false) {
                  let J = { parts: ye, prevNode: Ce, parentNode: he, options: pe };
                  G(me, J) && (ye.push(d), Ce && j.has(Ce.type) || (z(me, J) || U(me, J)) && ye.push(d), U(me, J) && ye.push(d)), ye.push(_), Ce = me;
                }
              }, "children"), ve ? ve(ye) : ye;
            }
            function De(ce) {
              let pe = ce;
              for (; u(pe.children); )
                pe = t3(pe.children);
              return pe;
            }
            function ie(ce) {
              let pe;
              if (ce.type === "html")
                pe = ce.value.match(/^<!--\s*prettier-ignore(?:-(start|end))?\s*-->$/);
              else {
                let de;
                ce.type === "esComment" ? de = ce : ce.type === "paragraph" && ce.children.length === 1 && ce.children[0].type === "esComment" && (de = ce.children[0]), de && (pe = de.value.match(/^prettier-ignore(?:-(start|end))?$/));
              }
              return pe ? pe[1] || "next" : false;
            }
            function G(ce, pe) {
              let de = pe.parts.length === 0, ae = b.includes(ce.type), ve = ce.type === "html" && L.includes(pe.parentNode.type);
              return !de && !ae && !ve;
            }
            function z(ce, pe) {
              var de, ae, ve;
              let he = (pe.prevNode && pe.prevNode.type) === ce.type && V.has(ce.type), ye = pe.parentNode.type === "listItem" && !pe.parentNode.loose, Ce = ((de = pe.prevNode) === null || de === void 0 ? void 0 : de.type) === "listItem" && pe.prevNode.loose, Ie = ie(pe.prevNode) === "next", Fe = ce.type === "html" && ((ae = pe.prevNode) === null || ae === void 0 ? void 0 : ae.type) === "html" && pe.prevNode.position.end.line + 1 === ce.position.start.line, me = ce.type === "html" && pe.parentNode.type === "listItem" && ((ve = pe.prevNode) === null || ve === void 0 ? void 0 : ve.type) === "paragraph" && pe.prevNode.position.end.line + 1 === ce.position.start.line;
              return Ce || !(he || ye || Ie || Fe || me);
            }
            function U(ce, pe) {
              let de = pe.prevNode && pe.prevNode.type === "list", ae = ce.type === "code" && ce.isIndented;
              return de && ae;
            }
            function le(ce) {
              let pe = te(ce, ["linkReference", "imageReference"]);
              return pe && (pe.type !== "linkReference" || pe.referenceType !== "full");
            }
            function ge(ce) {
              let pe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], de = [" ", ...Array.isArray(pe) ? pe : [pe]];
              return new RegExp(de.map((ae) => "\\".concat(ae)).join("|")).test(ce) ? "<".concat(ce, ">") : ce;
            }
            function Ae(ce, pe) {
              let de = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
              if (!ce)
                return "";
              if (de)
                return " " + Ae(ce, pe, false);
              if (ce = ce.replace(/\\(["')])/g, "$1"), ce.includes('"') && ce.includes("'") && !ce.includes(")"))
                return "(".concat(ce, ")");
              let ae = ce.split("'").length - 1, ve = ce.split('"').length - 1, K = ae > ve ? '"' : ve > ae || pe.singleQuote ? "'" : '"';
              return ce = ce.replace(/\\/, "\\\\"), ce = ce.replace(new RegExp("(".concat(K, ")"), "g"), "\\$1"), "".concat(K).concat(ce).concat(K);
            }
            function Ne(ce, pe, de) {
              return ce < pe ? pe : ce > de ? de : ce;
            }
            function ke(ce) {
              let pe = Number(ce.getName());
              if (pe === 0)
                return false;
              let de = ce.getParentNode().children[pe - 1];
              return ie(de) === "next";
            }
            n.exports = { preprocess: F, print: q, embed: P, massageAstNode: l, hasPrettierIgnore: ke, insertPragma: C };
          } }), Gd = Z({ "src/language-markdown/options.js"(e, n) {
            "use strict";
            re();
            var t3 = Ot();
            n.exports = { proseWrap: t3.proseWrap, singleQuote: t3.singleQuote };
          } }), Jd = Z({ "src/language-markdown/parsers.js"() {
            re();
          } }), da = Z({ "node_modules/linguist-languages/data/Markdown.json"(e, n) {
            n.exports = { name: "Markdown", type: "prose", color: "#083fa1", aliases: ["pandoc"], aceMode: "markdown", codemirrorMode: "gfm", codemirrorMimeType: "text/x-gfm", wrap: true, extensions: [".md", ".livemd", ".markdown", ".mdown", ".mdwn", ".mdx", ".mkd", ".mkdn", ".mkdown", ".ronn", ".scd", ".workbook"], filenames: ["contents.lr"], tmScope: "source.gfm", languageId: 222 };
          } }), Ud = Z({ "src/language-markdown/index.js"(e, n) {
            "use strict";
            re();
            var t3 = Bt(), s = Hd(), a = Gd(), r = Jd(), u = [t3(da(), (o) => ({ since: "1.8.0", parsers: ["markdown"], vscodeLanguageIds: ["markdown"], filenames: [...o.filenames, "README"], extensions: o.extensions.filter((c) => c !== ".mdx") })), t3(da(), () => ({ name: "MDX", since: "1.15.0", parsers: ["mdx"], vscodeLanguageIds: ["mdx"], filenames: [], extensions: [".mdx"] }))], i = { mdast: s };
            n.exports = { languages: u, options: a, printers: i, parsers: r };
          } }), zd = Z({ "src/language-html/clean.js"(e, n) {
            "use strict";
            re();
            var { isFrontMatterNode: t3 } = Ue(), s = /* @__PURE__ */ new Set(["sourceSpan", "startSourceSpan", "endSourceSpan", "nameSpan", "valueSpan"]);
            function a(r, u) {
              if (r.type === "text" || r.type === "comment" || t3(r) || r.type === "yaml" || r.type === "toml")
                return null;
              r.type === "attribute" && delete u.value, r.type === "docType" && delete u.value;
            }
            a.ignoredProperties = s, n.exports = a;
          } }), Xd = Z({ "src/language-html/constants.evaluate.js"(e, n) {
            n.exports = { CSS_DISPLAY_TAGS: { area: "none", base: "none", basefont: "none", datalist: "none", head: "none", link: "none", meta: "none", noembed: "none", noframes: "none", param: "block", rp: "none", script: "block", source: "block", style: "none", template: "inline", track: "block", title: "none", html: "block", body: "block", address: "block", blockquote: "block", center: "block", div: "block", figure: "block", figcaption: "block", footer: "block", form: "block", header: "block", hr: "block", legend: "block", listing: "block", main: "block", p: "block", plaintext: "block", pre: "block", xmp: "block", slot: "contents", ruby: "ruby", rt: "ruby-text", article: "block", aside: "block", h1: "block", h2: "block", h3: "block", h4: "block", h5: "block", h6: "block", hgroup: "block", nav: "block", section: "block", dir: "block", dd: "block", dl: "block", dt: "block", ol: "block", ul: "block", li: "list-item", table: "table", caption: "table-caption", colgroup: "table-column-group", col: "table-column", thead: "table-header-group", tbody: "table-row-group", tfoot: "table-footer-group", tr: "table-row", td: "table-cell", th: "table-cell", fieldset: "block", button: "inline-block", details: "block", summary: "block", dialog: "block", meter: "inline-block", progress: "inline-block", object: "inline-block", video: "inline-block", audio: "inline-block", select: "inline-block", option: "block", optgroup: "block" }, CSS_DISPLAY_DEFAULT: "inline", CSS_WHITE_SPACE_TAGS: { listing: "pre", plaintext: "pre", pre: "pre", xmp: "pre", nobr: "nowrap", table: "initial", textarea: "pre-wrap" }, CSS_WHITE_SPACE_DEFAULT: "normal" };
          } }), Kd = Z({ "src/language-html/utils/is-unknown-namespace.js"(e, n) {
            "use strict";
            re();
            function t3(s) {
              return s.type === "element" && !s.hasExplicitNamespace && !["html", "svg"].includes(s.namespace);
            }
            n.exports = t3;
          } }), qt = Z({ "src/language-html/utils/index.js"(e, n) {
            "use strict";
            re();
            var { inferParserByLanguage: t3, isFrontMatterNode: s } = Ue(), { builders: { line: a, hardline: r, join: u }, utils: { getDocParts: i, replaceTextEndOfLine: o } } = Oe(), { CSS_DISPLAY_TAGS: c, CSS_DISPLAY_DEFAULT: v, CSS_WHITE_SPACE_TAGS: m, CSS_WHITE_SPACE_DEFAULT: d } = Xd(), p = Kd(), f = /* @__PURE__ */ new Set(["	", `
`, "\f", "\r", " "]), h = (_) => _.replace(/^[\t\n\f\r ]+/, ""), w = (_) => _.replace(/[\t\n\f\r ]+$/, ""), T = (_) => h(w(_)), A = (_) => _.replace(/^[\t\f\r ]*\n/g, ""), S = (_) => A(w(_)), B = (_) => _.split(/[\t\n\f\r ]+/), I = (_) => _.match(/^[\t\n\f\r ]*/)[0], k = (_) => {
              let [, J, ne, Ee] = _.match(/^([\t\n\f\r ]*)(.*?)([\t\n\f\r ]*)$/s);
              return { leadingWhitespace: J, trailingWhitespace: Ee, text: ne };
            }, P = (_) => /[\t\n\f\r ]/.test(_);
            function C(_, J) {
              return !!(_.type === "ieConditionalComment" && _.lastChild && !_.lastChild.isSelfClosing && !_.lastChild.endSourceSpan || _.type === "ieConditionalComment" && !_.complete || le(_) && _.children.some((ne) => ne.type !== "text" && ne.type !== "interpolation") || ye(_, J) && !l(_) && _.type !== "interpolation");
            }
            function D(_) {
              return _.type === "attribute" || !_.parent || !_.prev ? false : g(_.prev);
            }
            function g(_) {
              return _.type === "comment" && _.value.trim() === "prettier-ignore";
            }
            function F(_) {
              return _.type === "text" || _.type === "comment";
            }
            function l(_) {
              return _.type === "element" && (_.fullName === "script" || _.fullName === "style" || _.fullName === "svg:style" || p(_) && (_.name === "script" || _.name === "style"));
            }
            function E(_) {
              return _.children && !l(_);
            }
            function y(_) {
              return l(_) || _.type === "interpolation" || N(_);
            }
            function N(_) {
              return ke(_).startsWith("pre");
            }
            function x(_, J) {
              let ne = Ee();
              if (ne && !_.prev && _.parent && _.parent.tagDefinition && _.parent.tagDefinition.ignoreFirstLf)
                return _.type === "interpolation";
              return ne;
              function Ee() {
                return s(_) ? false : (_.type === "text" || _.type === "interpolation") && _.prev && (_.prev.type === "text" || _.prev.type === "interpolation") ? true : !_.parent || _.parent.cssDisplay === "none" ? false : le(_.parent) ? true : !(!_.prev && (_.parent.type === "root" || le(_) && _.parent || l(_.parent) || K(_.parent, J) || !De(_.parent.cssDisplay)) || _.prev && !z(_.prev.cssDisplay));
              }
            }
            function b(_, J) {
              return s(_) ? false : (_.type === "text" || _.type === "interpolation") && _.next && (_.next.type === "text" || _.next.type === "interpolation") ? true : !_.parent || _.parent.cssDisplay === "none" ? false : le(_.parent) ? true : !(!_.next && (_.parent.type === "root" || le(_) && _.parent || l(_.parent) || K(_.parent, J) || !ie(_.parent.cssDisplay)) || _.next && !G(_.next.cssDisplay));
            }
            function L(_) {
              return U(_.cssDisplay) && !l(_);
            }
            function M(_) {
              return s(_) || _.next && _.sourceSpan.end && _.sourceSpan.end.line + 1 < _.next.sourceSpan.start.line;
            }
            function j(_) {
              return $(_) || _.type === "element" && _.children.length > 0 && (["body", "script", "style"].includes(_.name) || _.children.some((J) => te(J))) || _.firstChild && _.firstChild === _.lastChild && _.firstChild.type !== "text" && H(_.firstChild) && (!_.lastChild.isTrailingSpaceSensitive || R(_.lastChild));
            }
            function $(_) {
              return _.type === "element" && _.children.length > 0 && (["html", "head", "ul", "ol", "select"].includes(_.name) || _.cssDisplay.startsWith("table") && _.cssDisplay !== "table-cell");
            }
            function V(_) {
              return Q(_) || _.prev && q(_.prev) || Y(_);
            }
            function q(_) {
              return Q(_) || _.type === "element" && _.fullName === "br" || Y(_);
            }
            function Y(_) {
              return H(_) && R(_);
            }
            function H(_) {
              return _.hasLeadingSpaces && (_.prev ? _.prev.sourceSpan.end.line < _.sourceSpan.start.line : _.parent.type === "root" || _.parent.startSourceSpan.end.line < _.sourceSpan.start.line);
            }
            function R(_) {
              return _.hasTrailingSpaces && (_.next ? _.next.sourceSpan.start.line > _.sourceSpan.end.line : _.parent.type === "root" || _.parent.endSourceSpan && _.parent.endSourceSpan.start.line > _.sourceSpan.end.line);
            }
            function Q(_) {
              switch (_.type) {
                case "ieConditionalComment":
                case "comment":
                case "directive":
                  return true;
                case "element":
                  return ["script", "select"].includes(_.name);
              }
              return false;
            }
            function ee(_) {
              return _.lastChild ? ee(_.lastChild) : _;
            }
            function te(_) {
              return _.children && _.children.some((J) => J.type !== "text");
            }
            function oe(_) {
              let { type: J, lang: ne } = _.attrMap;
              if (J === "module" || J === "text/javascript" || J === "text/babel" || J === "application/javascript" || ne === "jsx")
                return "babel";
              if (J === "application/x-typescript" || ne === "ts" || ne === "tsx")
                return "typescript";
              if (J === "text/markdown")
                return "markdown";
              if (J === "text/html")
                return "html";
              if (J && (J.endsWith("json") || J.endsWith("importmap")) || J === "speculationrules")
                return "json";
              if (J === "text/x-handlebars-template")
                return "glimmer";
            }
            function W(_, J) {
              let { lang: ne } = _.attrMap;
              if (!ne || ne === "postcss" || ne === "css")
                return "css";
              if (ne === "scss")
                return "scss";
              if (ne === "less")
                return "less";
              if (ne === "stylus")
                return t3("stylus", J);
            }
            function X(_, J) {
              if (_.name === "script" && !_.attrMap.src)
                return !_.attrMap.lang && !_.attrMap.type ? "babel" : oe(_);
              if (_.name === "style")
                return W(_, J);
              if (J && ye(_, J))
                return oe(_) || !("src" in _.attrMap) && t3(_.attrMap.lang, J);
            }
            function ue(_) {
              return _ === "block" || _ === "list-item" || _.startsWith("table");
            }
            function De(_) {
              return !ue(_) && _ !== "inline-block";
            }
            function ie(_) {
              return !ue(_) && _ !== "inline-block";
            }
            function G(_) {
              return !ue(_);
            }
            function z(_) {
              return !ue(_);
            }
            function U(_) {
              return !ue(_) && _ !== "inline-block";
            }
            function le(_) {
              return ke(_).startsWith("pre");
            }
            function ge(_, J) {
              let ne = 0;
              for (let Ee = _.stack.length - 1; Ee >= 0; Ee--) {
                let We = _.stack[Ee];
                We && typeof We == "object" && !Array.isArray(We) && J(We) && ne++;
              }
              return ne;
            }
            function Ae(_, J) {
              let ne = _;
              for (; ne; ) {
                if (J(ne))
                  return true;
                ne = ne.parent;
              }
              return false;
            }
            function Ne(_, J) {
              if (_.prev && _.prev.type === "comment") {
                let Ee = _.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);
                if (Ee)
                  return Ee[1];
              }
              let ne = false;
              if (_.type === "element" && _.namespace === "svg")
                if (Ae(_, (Ee) => Ee.fullName === "svg:foreignObject"))
                  ne = true;
                else
                  return _.name === "svg" ? "inline-block" : "block";
              switch (J.htmlWhitespaceSensitivity) {
                case "strict":
                  return "inline";
                case "ignore":
                  return "block";
                default:
                  return J.parser === "vue" && _.parent && _.parent.type === "root" ? "block" : _.type === "element" && (!_.namespace || ne || p(_)) && c[_.name] || v;
              }
            }
            function ke(_) {
              return _.type === "element" && (!_.namespace || p(_)) && m[_.name] || d;
            }
            function ce(_) {
              let J = Number.POSITIVE_INFINITY;
              for (let ne of _.split(`
`)) {
                if (ne.length === 0)
                  continue;
                if (!f.has(ne[0]))
                  return 0;
                let Ee = I(ne).length;
                ne.length !== Ee && Ee < J && (J = Ee);
              }
              return J === Number.POSITIVE_INFINITY ? 0 : J;
            }
            function pe(_) {
              let J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ce(_);
              return J === 0 ? _ : _.split(`
`).map((ne) => ne.slice(J)).join(`
`);
            }
            function de(_, J) {
              let ne = 0;
              for (let Ee = 0; Ee < _.length; Ee++)
                _[Ee] === J && ne++;
              return ne;
            }
            function ae(_) {
              return _.replace(/&apos;/g, "'").replace(/&quot;/g, '"');
            }
            var ve = /* @__PURE__ */ new Set(["template", "style", "script"]);
            function K(_, J) {
              return he(_, J) && !ve.has(_.fullName);
            }
            function he(_, J) {
              return J.parser === "vue" && _.type === "element" && _.parent.type === "root" && _.fullName.toLowerCase() !== "html";
            }
            function ye(_, J) {
              return he(_, J) && (K(_, J) || _.attrMap.lang && _.attrMap.lang !== "html");
            }
            function Ce(_) {
              let J = _.fullName;
              return J.charAt(0) === "#" || J === "slot-scope" || J === "v-slot" || J.startsWith("v-slot:");
            }
            function Ie(_, J) {
              let ne = _.parent;
              if (!he(ne, J))
                return false;
              let Ee = ne.fullName, We = _.fullName;
              return Ee === "script" && We === "setup" || Ee === "style" && We === "vars";
            }
            function Fe(_) {
              let J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _.value;
              return _.parent.isWhitespaceSensitive ? _.parent.isIndentationSensitive ? o(J) : o(pe(S(J)), r) : i(u(a, B(J)));
            }
            function me(_, J) {
              return he(_, J) && _.name === "script";
            }
            n.exports = { htmlTrim: T, htmlTrimPreserveIndentation: S, hasHtmlWhitespace: P, getLeadingAndTrailingHtmlWhitespace: k, canHaveInterpolation: E, countChars: de, countParents: ge, dedentString: pe, forceBreakChildren: $, forceBreakContent: j, forceNextEmptyLine: M, getLastDescendant: ee, getNodeCssStyleDisplay: Ne, getNodeCssStyleWhiteSpace: ke, hasPrettierIgnore: D, inferScriptParser: X, isVueCustomBlock: K, isVueNonHtmlBlock: ye, isVueScriptTag: me, isVueSlotAttribute: Ce, isVueSfcBindingsAttribute: Ie, isVueSfcBlock: he, isDanglingSpaceSensitiveNode: L, isIndentationSensitiveNode: N, isLeadingSpaceSensitiveNode: x, isPreLikeNode: le, isScriptLikeTag: l, isTextLikeNode: F, isTrailingSpaceSensitiveNode: b, isWhitespaceSensitiveNode: y, isUnknownNamespace: p, preferHardlineAsLeadingSpaces: V, preferHardlineAsTrailingSpaces: q, shouldPreserveContent: C, unescapeQuoteEntities: ae, getTextValueParts: Fe };
          } }), Yd = Z({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true }), e.$EOF = 0, e.$BSPACE = 8, e.$TAB = 9, e.$LF = 10, e.$VTAB = 11, e.$FF = 12, e.$CR = 13, e.$SPACE = 32, e.$BANG = 33, e.$DQ = 34, e.$HASH = 35, e.$$ = 36, e.$PERCENT = 37, e.$AMPERSAND = 38, e.$SQ = 39, e.$LPAREN = 40, e.$RPAREN = 41, e.$STAR = 42, e.$PLUS = 43, e.$COMMA = 44, e.$MINUS = 45, e.$PERIOD = 46, e.$SLASH = 47, e.$COLON = 58, e.$SEMICOLON = 59, e.$LT = 60, e.$EQ = 61, e.$GT = 62, e.$QUESTION = 63, e.$0 = 48, e.$7 = 55, e.$9 = 57, e.$A = 65, e.$E = 69, e.$F = 70, e.$X = 88, e.$Z = 90, e.$LBRACKET = 91, e.$BACKSLASH = 92, e.$RBRACKET = 93, e.$CARET = 94, e.$_ = 95, e.$a = 97, e.$b = 98, e.$e = 101, e.$f = 102, e.$n = 110, e.$r = 114, e.$t = 116, e.$u = 117, e.$v = 118, e.$x = 120, e.$z = 122, e.$LBRACE = 123, e.$BAR = 124, e.$RBRACE = 125, e.$NBSP = 160, e.$PIPE = 124, e.$TILDA = 126, e.$AT = 64, e.$BT = 96;
            function n(i) {
              return i >= e.$TAB && i <= e.$SPACE || i == e.$NBSP;
            }
            e.isWhitespace = n;
            function t3(i) {
              return e.$0 <= i && i <= e.$9;
            }
            e.isDigit = t3;
            function s(i) {
              return i >= e.$a && i <= e.$z || i >= e.$A && i <= e.$Z;
            }
            e.isAsciiLetter = s;
            function a(i) {
              return i >= e.$a && i <= e.$f || i >= e.$A && i <= e.$F || t3(i);
            }
            e.isAsciiHexDigit = a;
            function r(i) {
              return i === e.$LF || i === e.$CR;
            }
            e.isNewLine = r;
            function u(i) {
              return e.$0 <= i && i <= e.$7;
            }
            e.isOctalDigit = u;
          } }), Qd = Z({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = class {
              constructor(s, a, r) {
                this.filePath = s, this.name = a, this.members = r;
              }
              assertNoMembers() {
                if (this.members.length)
                  throw new Error("Illegal state: symbol without members expected, but got ".concat(JSON.stringify(this), "."));
              }
            };
            e.StaticSymbol = n;
            var t3 = class {
              constructor() {
                this.cache = /* @__PURE__ */ new Map();
              }
              get(s, a, r) {
                r = r || [];
                let u = r.length ? ".".concat(r.join(".")) : "", i = '"'.concat(s, '".').concat(a).concat(u), o = this.cache.get(i);
                return o || (o = new n(s, a, r), this.cache.set(i, o)), o;
              }
            };
            e.StaticSymbolCache = t3;
          } }), Zd = Z({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = /-+([a-z0-9])/g;
            function t3(l) {
              return l.replace(n, function() {
                for (var E = arguments.length, y = new Array(E), N = 0; N < E; N++)
                  y[N] = arguments[N];
                return y[1].toUpperCase();
              });
            }
            e.dashCaseToCamelCase = t3;
            function s(l, E) {
              return r(l, ":", E);
            }
            e.splitAtColon = s;
            function a(l, E) {
              return r(l, ".", E);
            }
            e.splitAtPeriod = a;
            function r(l, E, y) {
              let N = l.indexOf(E);
              return N == -1 ? y : [l.slice(0, N).trim(), l.slice(N + 1).trim()];
            }
            function u(l, E, y) {
              return Array.isArray(l) ? E.visitArray(l, y) : A(l) ? E.visitStringMap(l, y) : l == null || typeof l == "string" || typeof l == "number" || typeof l == "boolean" ? E.visitPrimitive(l, y) : E.visitOther(l, y);
            }
            e.visitValue = u;
            function i(l) {
              return l != null;
            }
            e.isDefined = i;
            function o(l) {
              return l === void 0 ? null : l;
            }
            e.noUndefined = o;
            var c = class {
              visitArray(l, E) {
                return l.map((y) => u(y, this, E));
              }
              visitStringMap(l, E) {
                let y = {};
                return Object.keys(l).forEach((N) => {
                  y[N] = u(l[N], this, E);
                }), y;
              }
              visitPrimitive(l, E) {
                return l;
              }
              visitOther(l, E) {
                return l;
              }
            };
            e.ValueTransformer = c, e.SyncAsync = { assertSync: (l) => {
              if (k(l))
                throw new Error("Illegal state: value cannot be a promise");
              return l;
            }, then: (l, E) => k(l) ? l.then(E) : E(l), all: (l) => l.some(k) ? Promise.all(l) : l };
            function v(l) {
              throw new Error("Internal Error: ".concat(l));
            }
            e.error = v;
            function m(l, E) {
              let y = Error(l);
              return y[d] = true, E && (y[p] = E), y;
            }
            e.syntaxError = m;
            var d = "ngSyntaxError", p = "ngParseErrors";
            function f(l) {
              return l[d];
            }
            e.isSyntaxError = f;
            function h(l) {
              return l[p] || [];
            }
            e.getParseErrors = h;
            function w(l) {
              return l.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
            }
            e.escapeRegExp = w;
            var T = Object.getPrototypeOf({});
            function A(l) {
              return typeof l == "object" && l !== null && Object.getPrototypeOf(l) === T;
            }
            function S(l) {
              let E = "";
              for (let y = 0; y < l.length; y++) {
                let N = l.charCodeAt(y);
                if (N >= 55296 && N <= 56319 && l.length > y + 1) {
                  let x = l.charCodeAt(y + 1);
                  x >= 56320 && x <= 57343 && (y++, N = (N - 55296 << 10) + x - 56320 + 65536);
                }
                N <= 127 ? E += String.fromCharCode(N) : N <= 2047 ? E += String.fromCharCode(N >> 6 & 31 | 192, N & 63 | 128) : N <= 65535 ? E += String.fromCharCode(N >> 12 | 224, N >> 6 & 63 | 128, N & 63 | 128) : N <= 2097151 && (E += String.fromCharCode(N >> 18 & 7 | 240, N >> 12 & 63 | 128, N >> 6 & 63 | 128, N & 63 | 128));
              }
              return E;
            }
            e.utf8Encode = S;
            function B(l) {
              if (typeof l == "string")
                return l;
              if (l instanceof Array)
                return "[" + l.map(B).join(", ") + "]";
              if (l == null)
                return "" + l;
              if (l.overriddenName)
                return "".concat(l.overriddenName);
              if (l.name)
                return "".concat(l.name);
              if (!l.toString)
                return "object";
              let E = l.toString();
              if (E == null)
                return "" + E;
              let y = E.indexOf(`
`);
              return y === -1 ? E : E.substring(0, y);
            }
            e.stringify = B;
            function I(l) {
              return typeof l == "function" && l.hasOwnProperty("__forward_ref__") ? l() : l;
            }
            e.resolveForwardRef = I;
            function k(l) {
              return !!l && typeof l.then == "function";
            }
            e.isPromise = k;
            var P = class {
              constructor(l) {
                this.full = l;
                let E = l.split(".");
                this.major = E[0], this.minor = E[1], this.patch = E.slice(2).join(".");
              }
            };
            e.Version = P;
            var C = typeof window < "u" && window, D = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, g = typeof globalThis < "u" && globalThis, F = g || C || D;
            e.global = F;
          } }), eg = Z({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Qd(), t3 = Zd(), s = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
            function a(y) {
              return y.replace(/\W/g, "_");
            }
            e.sanitizeIdentifier = a;
            var r = 0;
            function u(y) {
              if (!y || !y.reference)
                return null;
              let N = y.reference;
              if (N instanceof n.StaticSymbol)
                return N.name;
              if (N.__anonymousType)
                return N.__anonymousType;
              let x = t3.stringify(N);
              return x.indexOf("(") >= 0 ? (x = "anonymous_".concat(r++), N.__anonymousType = x) : x = a(x), x;
            }
            e.identifierName = u;
            function i(y) {
              let N = y.reference;
              return N instanceof n.StaticSymbol ? N.filePath : "./".concat(t3.stringify(N));
            }
            e.identifierModuleUrl = i;
            function o(y, N) {
              return "View_".concat(u({ reference: y }), "_").concat(N);
            }
            e.viewClassName = o;
            function c(y) {
              return "RenderType_".concat(u({ reference: y }));
            }
            e.rendererTypeName = c;
            function v(y) {
              return "HostView_".concat(u({ reference: y }));
            }
            e.hostViewClassName = v;
            function m(y) {
              return "".concat(u({ reference: y }), "NgFactory");
            }
            e.componentFactoryName = m;
            var d;
            (function(y) {
              y[y.Pipe = 0] = "Pipe", y[y.Directive = 1] = "Directive", y[y.NgModule = 2] = "NgModule", y[y.Injectable = 3] = "Injectable";
            })(d = e.CompileSummaryKind || (e.CompileSummaryKind = {}));
            function p(y) {
              return y.value != null ? a(y.value) : u(y.identifier);
            }
            e.tokenName = p;
            function f(y) {
              return y.identifier != null ? y.identifier.reference : y.value;
            }
            e.tokenReference = f;
            var h = class {
              constructor() {
                let { moduleUrl: y, styles: N, styleUrls: x } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.moduleUrl = y || null, this.styles = k(N), this.styleUrls = k(x);
              }
            };
            e.CompileStylesheetMetadata = h;
            var w = class {
              constructor(y) {
                let { encapsulation: N, template: x, templateUrl: b, htmlAst: L, styles: M, styleUrls: j, externalStylesheets: $, animations: V, ngContentSelectors: q, interpolation: Y, isInline: H, preserveWhitespaces: R } = y;
                if (this.encapsulation = N, this.template = x, this.templateUrl = b, this.htmlAst = L, this.styles = k(M), this.styleUrls = k(j), this.externalStylesheets = k($), this.animations = V ? C(V) : [], this.ngContentSelectors = q || [], Y && Y.length != 2)
                  throw new Error("'interpolation' should have a start and an end symbol.");
                this.interpolation = Y, this.isInline = H, this.preserveWhitespaces = R;
              }
              toSummary() {
                return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
              }
            };
            e.CompileTemplateMetadata = w;
            var T = class {
              static create(y) {
                let { isHost: N, type: x, isComponent: b, selector: L, exportAs: M, changeDetection: j, inputs: $, outputs: V, host: q, providers: Y, viewProviders: H, queries: R, guards: Q, viewQueries: ee, entryComponents: te, template: oe, componentViewType: W, rendererType: X, componentFactory: ue } = y, De = {}, ie = {}, G = {};
                q != null && Object.keys(q).forEach((le) => {
                  let ge = q[le], Ae = le.match(s);
                  Ae === null ? G[le] = ge : Ae[1] != null ? ie[Ae[1]] = ge : Ae[2] != null && (De[Ae[2]] = ge);
                });
                let z = {};
                $ != null && $.forEach((le) => {
                  let ge = t3.splitAtColon(le, [le, le]);
                  z[ge[0]] = ge[1];
                });
                let U = {};
                return V != null && V.forEach((le) => {
                  let ge = t3.splitAtColon(le, [le, le]);
                  U[ge[0]] = ge[1];
                }), new T({ isHost: N, type: x, isComponent: !!b, selector: L, exportAs: M, changeDetection: j, inputs: z, outputs: U, hostListeners: De, hostProperties: ie, hostAttributes: G, providers: Y, viewProviders: H, queries: R, guards: Q, viewQueries: ee, entryComponents: te, template: oe, componentViewType: W, rendererType: X, componentFactory: ue });
              }
              constructor(y) {
                let { isHost: N, type: x, isComponent: b, selector: L, exportAs: M, changeDetection: j, inputs: $, outputs: V, hostListeners: q, hostProperties: Y, hostAttributes: H, providers: R, viewProviders: Q, queries: ee, guards: te, viewQueries: oe, entryComponents: W, template: X, componentViewType: ue, rendererType: De, componentFactory: ie } = y;
                this.isHost = !!N, this.type = x, this.isComponent = b, this.selector = L, this.exportAs = M, this.changeDetection = j, this.inputs = $, this.outputs = V, this.hostListeners = q, this.hostProperties = Y, this.hostAttributes = H, this.providers = k(R), this.viewProviders = k(Q), this.queries = k(ee), this.guards = te, this.viewQueries = k(oe), this.entryComponents = k(W), this.template = X, this.componentViewType = ue, this.rendererType = De, this.componentFactory = ie;
              }
              toSummary() {
                return { summaryKind: d.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
              }
            };
            e.CompileDirectiveMetadata = T;
            var A = class {
              constructor(y) {
                let { type: N, name: x, pure: b } = y;
                this.type = N, this.name = x, this.pure = !!b;
              }
              toSummary() {
                return { summaryKind: d.Pipe, type: this.type, name: this.name, pure: this.pure };
              }
            };
            e.CompilePipeMetadata = A;
            var S = class {
            };
            e.CompileShallowModuleMetadata = S;
            var B = class {
              constructor(y) {
                let { type: N, providers: x, declaredDirectives: b, exportedDirectives: L, declaredPipes: M, exportedPipes: j, entryComponents: $, bootstrapComponents: V, importedModules: q, exportedModules: Y, schemas: H, transitiveModule: R, id: Q } = y;
                this.type = N || null, this.declaredDirectives = k(b), this.exportedDirectives = k(L), this.declaredPipes = k(M), this.exportedPipes = k(j), this.providers = k(x), this.entryComponents = k($), this.bootstrapComponents = k(V), this.importedModules = k(q), this.exportedModules = k(Y), this.schemas = k(H), this.id = Q || null, this.transitiveModule = R || null;
              }
              toSummary() {
                let y = this.transitiveModule;
                return { summaryKind: d.NgModule, type: this.type, entryComponents: y.entryComponents, providers: y.providers, modules: y.modules, exportedDirectives: y.exportedDirectives, exportedPipes: y.exportedPipes };
              }
            };
            e.CompileNgModuleMetadata = B;
            var I = class {
              constructor() {
                this.directivesSet = /* @__PURE__ */ new Set(), this.directives = [], this.exportedDirectivesSet = /* @__PURE__ */ new Set(), this.exportedDirectives = [], this.pipesSet = /* @__PURE__ */ new Set(), this.pipes = [], this.exportedPipesSet = /* @__PURE__ */ new Set(), this.exportedPipes = [], this.modulesSet = /* @__PURE__ */ new Set(), this.modules = [], this.entryComponentsSet = /* @__PURE__ */ new Set(), this.entryComponents = [], this.providers = [];
              }
              addProvider(y, N) {
                this.providers.push({ provider: y, module: N });
              }
              addDirective(y) {
                this.directivesSet.has(y.reference) || (this.directivesSet.add(y.reference), this.directives.push(y));
              }
              addExportedDirective(y) {
                this.exportedDirectivesSet.has(y.reference) || (this.exportedDirectivesSet.add(y.reference), this.exportedDirectives.push(y));
              }
              addPipe(y) {
                this.pipesSet.has(y.reference) || (this.pipesSet.add(y.reference), this.pipes.push(y));
              }
              addExportedPipe(y) {
                this.exportedPipesSet.has(y.reference) || (this.exportedPipesSet.add(y.reference), this.exportedPipes.push(y));
              }
              addModule(y) {
                this.modulesSet.has(y.reference) || (this.modulesSet.add(y.reference), this.modules.push(y));
              }
              addEntryComponent(y) {
                this.entryComponentsSet.has(y.componentType) || (this.entryComponentsSet.add(y.componentType), this.entryComponents.push(y));
              }
            };
            e.TransitiveCompileNgModuleMetadata = I;
            function k(y) {
              return y || [];
            }
            var P = class {
              constructor(y, N) {
                let { useClass: x, useValue: b, useExisting: L, useFactory: M, deps: j, multi: $ } = N;
                this.token = y, this.useClass = x || null, this.useValue = b, this.useExisting = L, this.useFactory = M || null, this.dependencies = j || null, this.multi = !!$;
              }
            };
            e.ProviderMeta = P;
            function C(y) {
              return y.reduce((N, x) => {
                let b = Array.isArray(x) ? C(x) : x;
                return N.concat(b);
              }, []);
            }
            e.flatten = C;
            function D(y) {
              return y.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
            }
            function g(y, N, x) {
              let b;
              return x.isInline ? N.type.reference instanceof n.StaticSymbol ? b = "".concat(N.type.reference.filePath, ".").concat(N.type.reference.name, ".html") : b = "".concat(u(y), "/").concat(u(N.type), ".html") : b = x.templateUrl, N.type.reference instanceof n.StaticSymbol ? b : D(b);
            }
            e.templateSourceUrl = g;
            function F(y, N) {
              let x = y.moduleUrl.split(/\/\\/g), b = x[x.length - 1];
              return D("css/".concat(N).concat(b, ".ngstyle.js"));
            }
            e.sharedStylesheetJitUrl = F;
            function l(y) {
              return D("".concat(u(y.type), "/module.ngfactory.js"));
            }
            e.ngModuleJitUrl = l;
            function E(y, N) {
              return D("".concat(u(y), "/").concat(u(N.type), ".ngfactory.js"));
            }
            e.templateJitUrl = E;
          } }), tg = Z({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e) {
            "use strict";
            re(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Yd(), t3 = eg(), s = class {
              constructor(v, m, d, p) {
                this.file = v, this.offset = m, this.line = d, this.col = p;
              }
              toString() {
                return this.offset != null ? "".concat(this.file.url, "@").concat(this.line, ":").concat(this.col) : this.file.url;
              }
              moveBy(v) {
                let m = this.file.content, d = m.length, p = this.offset, f = this.line, h = this.col;
                for (; p > 0 && v < 0; )
                  if (p--, v++, m.charCodeAt(p) == n.$LF) {
                    f--;
                    let T = m.substr(0, p - 1).lastIndexOf(String.fromCharCode(n.$LF));
                    h = T > 0 ? p - T : p;
                  } else
                    h--;
                for (; p < d && v > 0; ) {
                  let w = m.charCodeAt(p);
                  p++, v--, w == n.$LF ? (f++, h = 0) : h++;
                }
                return new s(this.file, p, f, h);
              }
              getContext(v, m) {
                let d = this.file.content, p = this.offset;
                if (p != null) {
                  p > d.length - 1 && (p = d.length - 1);
                  let f = p, h = 0, w = 0;
                  for (; h < v && p > 0 && (p--, h++, !(d[p] == `
` && ++w == m)); )
                    ;
                  for (h = 0, w = 0; h < v && f < d.length - 1 && (f++, h++, !(d[f] == `
` && ++w == m)); )
                    ;
                  return { before: d.substring(p, this.offset), after: d.substring(this.offset, f + 1) };
                }
                return null;
              }
            };
            e.ParseLocation = s;
            var a = class {
              constructor(v, m) {
                this.content = v, this.url = m;
              }
            };
            e.ParseSourceFile = a;
            var r = class {
              constructor(v, m) {
                let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                this.start = v, this.end = m, this.details = d;
              }
              toString() {
                return this.start.file.content.substring(this.start.offset, this.end.offset);
              }
            };
            e.ParseSourceSpan = r, e.EMPTY_PARSE_LOCATION = new s(new a("", ""), 0, 0, 0), e.EMPTY_SOURCE_SPAN = new r(e.EMPTY_PARSE_LOCATION, e.EMPTY_PARSE_LOCATION);
            var u;
            (function(v) {
              v[v.WARNING = 0] = "WARNING", v[v.ERROR = 1] = "ERROR";
            })(u = e.ParseErrorLevel || (e.ParseErrorLevel = {}));
            var i = class {
              constructor(v, m) {
                let d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : u.ERROR;
                this.span = v, this.msg = m, this.level = d;
              }
              contextualMessage() {
                let v = this.span.start.getContext(100, 3);
                return v ? "".concat(this.msg, ' ("').concat(v.before, "[").concat(u[this.level], " ->]").concat(v.after, '")') : this.msg;
              }
              toString() {
                let v = this.span.details ? ", ".concat(this.span.details) : "";
                return "".concat(this.contextualMessage(), ": ").concat(this.span.start).concat(v);
              }
            };
            e.ParseError = i;
            function o(v, m) {
              let d = t3.identifierModuleUrl(m), p = d != null ? "in ".concat(v, " ").concat(t3.identifierName(m), " in ").concat(d) : "in ".concat(v, " ").concat(t3.identifierName(m)), f = new a("", p);
              return new r(new s(f, -1, -1, -1), new s(f, -1, -1, -1));
            }
            e.typeSourceSpan = o;
            function c(v, m, d) {
              let p = "in ".concat(v, " ").concat(m, " in ").concat(d), f = new a("", p);
              return new r(new s(f, -1, -1, -1), new s(f, -1, -1, -1));
            }
            e.r3JitTypeSourceSpan = c;
          } }), rg = Z({ "src/language-html/print-preprocess.js"(e, n) {
            "use strict";
            re();
            var { ParseSourceSpan: t3 } = tg(), { htmlTrim: s, getLeadingAndTrailingHtmlWhitespace: a, hasHtmlWhitespace: r, canHaveInterpolation: u, getNodeCssStyleDisplay: i, isDanglingSpaceSensitiveNode: o, isIndentationSensitiveNode: c, isLeadingSpaceSensitiveNode: v, isTrailingSpaceSensitiveNode: m, isWhitespaceSensitiveNode: d, isVueScriptTag: p } = qt(), f = [w, T, S, I, k, D, P, C, g, B, F];
            function h(l, E) {
              for (let y of f)
                y(l, E);
              return l;
            }
            function w(l) {
              l.walk((E) => {
                if (E.type === "element" && E.tagDefinition.ignoreFirstLf && E.children.length > 0 && E.children[0].type === "text" && E.children[0].value[0] === `
`) {
                  let y = E.children[0];
                  y.value.length === 1 ? E.removeChild(y) : y.value = y.value.slice(1);
                }
              });
            }
            function T(l) {
              let E = (y) => y.type === "element" && y.prev && y.prev.type === "ieConditionalStartComment" && y.prev.sourceSpan.end.offset === y.startSourceSpan.start.offset && y.firstChild && y.firstChild.type === "ieConditionalEndComment" && y.firstChild.sourceSpan.start.offset === y.startSourceSpan.end.offset;
              l.walk((y) => {
                if (y.children)
                  for (let N = 0; N < y.children.length; N++) {
                    let x = y.children[N];
                    if (!E(x))
                      continue;
                    let b = x.prev, L = x.firstChild;
                    y.removeChild(b), N--;
                    let M = new t3(b.sourceSpan.start, L.sourceSpan.end), j = new t3(M.start, x.sourceSpan.end);
                    x.condition = b.condition, x.sourceSpan = j, x.startSourceSpan = M, x.removeChild(L);
                  }
              });
            }
            function A(l, E, y) {
              l.walk((N) => {
                if (N.children)
                  for (let x = 0; x < N.children.length; x++) {
                    let b = N.children[x];
                    if (b.type !== "text" && !E(b))
                      continue;
                    b.type !== "text" && (b.type = "text", b.value = y(b));
                    let L = b.prev;
                    !L || L.type !== "text" || (L.value += b.value, L.sourceSpan = new t3(L.sourceSpan.start, b.sourceSpan.end), N.removeChild(b), x--);
                  }
              });
            }
            function S(l) {
              return A(l, (E) => E.type === "cdata", (E) => "<![CDATA[".concat(E.value, "]]>"));
            }
            function B(l) {
              let E = (y) => y.type === "element" && y.attrs.length === 0 && y.children.length === 1 && y.firstChild.type === "text" && !r(y.children[0].value) && !y.firstChild.hasLeadingSpaces && !y.firstChild.hasTrailingSpaces && y.isLeadingSpaceSensitive && !y.hasLeadingSpaces && y.isTrailingSpaceSensitive && !y.hasTrailingSpaces && y.prev && y.prev.type === "text" && y.next && y.next.type === "text";
              l.walk((y) => {
                if (y.children)
                  for (let N = 0; N < y.children.length; N++) {
                    let x = y.children[N];
                    if (!E(x))
                      continue;
                    let b = x.prev, L = x.next;
                    b.value += "<".concat(x.rawName, ">") + x.firstChild.value + "</".concat(x.rawName, ">") + L.value, b.sourceSpan = new t3(b.sourceSpan.start, L.sourceSpan.end), b.isTrailingSpaceSensitive = L.isTrailingSpaceSensitive, b.hasTrailingSpaces = L.hasTrailingSpaces, y.removeChild(x), N--, y.removeChild(L);
                  }
              });
            }
            function I(l, E) {
              if (E.parser === "html")
                return;
              let y = /{{(.+?)}}/s;
              l.walk((N) => {
                if (!!u(N))
                  for (let x of N.children) {
                    if (x.type !== "text")
                      continue;
                    let b = x.sourceSpan.start, L = null, M = x.value.split(y);
                    for (let j = 0; j < M.length; j++, b = L) {
                      let $ = M[j];
                      if (j % 2 === 0) {
                        L = b.moveBy($.length), $.length > 0 && N.insertChildBefore(x, { type: "text", value: $, sourceSpan: new t3(b, L) });
                        continue;
                      }
                      L = b.moveBy($.length + 4), N.insertChildBefore(x, { type: "interpolation", sourceSpan: new t3(b, L), children: $.length === 0 ? [] : [{ type: "text", value: $, sourceSpan: new t3(b.moveBy(2), L.moveBy(-2)) }] });
                    }
                    N.removeChild(x);
                  }
              });
            }
            function k(l) {
              l.walk((E) => {
                if (!E.children)
                  return;
                if (E.children.length === 0 || E.children.length === 1 && E.children[0].type === "text" && s(E.children[0].value).length === 0) {
                  E.hasDanglingSpaces = E.children.length > 0, E.children = [];
                  return;
                }
                let y = d(E), N = c(E);
                if (!y)
                  for (let x = 0; x < E.children.length; x++) {
                    let b = E.children[x];
                    if (b.type !== "text")
                      continue;
                    let { leadingWhitespace: L, text: M, trailingWhitespace: j } = a(b.value), $ = b.prev, V = b.next;
                    M ? (b.value = M, b.sourceSpan = new t3(b.sourceSpan.start.moveBy(L.length), b.sourceSpan.end.moveBy(-j.length)), L && ($ && ($.hasTrailingSpaces = true), b.hasLeadingSpaces = true), j && (b.hasTrailingSpaces = true, V && (V.hasLeadingSpaces = true))) : (E.removeChild(b), x--, (L || j) && ($ && ($.hasTrailingSpaces = true), V && (V.hasLeadingSpaces = true)));
                  }
                E.isWhitespaceSensitive = y, E.isIndentationSensitive = N;
              });
            }
            function P(l) {
              l.walk((E) => {
                E.isSelfClosing = !E.children || E.type === "element" && (E.tagDefinition.isVoid || E.startSourceSpan === E.endSourceSpan);
              });
            }
            function C(l, E) {
              l.walk((y) => {
                y.type === "element" && (y.hasHtmComponentClosingTag = y.endSourceSpan && /^<\s*\/\s*\/\s*>$/.test(E.originalText.slice(y.endSourceSpan.start.offset, y.endSourceSpan.end.offset)));
              });
            }
            function D(l, E) {
              l.walk((y) => {
                y.cssDisplay = i(y, E);
              });
            }
            function g(l, E) {
              l.walk((y) => {
                let { children: N } = y;
                if (!!N) {
                  if (N.length === 0) {
                    y.isDanglingSpaceSensitive = o(y);
                    return;
                  }
                  for (let x of N)
                    x.isLeadingSpaceSensitive = v(x, E), x.isTrailingSpaceSensitive = m(x, E);
                  for (let x = 0; x < N.length; x++) {
                    let b = N[x];
                    b.isLeadingSpaceSensitive = (x === 0 || b.prev.isTrailingSpaceSensitive) && b.isLeadingSpaceSensitive, b.isTrailingSpaceSensitive = (x === N.length - 1 || b.next.isLeadingSpaceSensitive) && b.isTrailingSpaceSensitive;
                  }
                }
              });
            }
            function F(l, E) {
              if (E.parser === "vue") {
                let y = l.children.find((x) => p(x, E));
                if (!y)
                  return;
                let { lang: N } = y.attrMap;
                (N === "ts" || N === "typescript") && (E.__should_parse_vue_template_with_ts = true);
              }
            }
            n.exports = h;
          } }), ng = Z({ "src/language-html/pragma.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(a);
            }
            function s(a) {
              return `<!-- @format -->

` + a.replace(/^\s*\n/, "");
            }
            n.exports = { hasPragma: t3, insertPragma: s };
          } }), Yn = Z({ "src/language-html/loc.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return a.sourceSpan.start.offset;
            }
            function s(a) {
              return a.sourceSpan.end.offset;
            }
            n.exports = { locStart: t3, locEnd: s };
          } }), er = Z({ "src/language-html/print/tag.js"(e, n) {
            "use strict";
            re();
            var t3 = Xt(), { isNonEmptyArray: s } = Ue(), { builders: { indent: a, join: r, line: u, softline: i, hardline: o }, utils: { replaceTextEndOfLine: c } } = Oe(), { locStart: v, locEnd: m } = Yn(), { isTextLikeNode: d, getLastDescendant: p, isPreLikeNode: f, hasPrettierIgnore: h, shouldPreserveContent: w, isVueSfcBlock: T } = qt();
            function A(q, Y) {
              return [q.isSelfClosing ? "" : S(q, Y), B(q, Y)];
            }
            function S(q, Y) {
              return q.lastChild && l(q.lastChild) ? "" : [I(q, Y), P(q, Y)];
            }
            function B(q, Y) {
              return (q.next ? g(q.next) : F(q.parent)) ? "" : [C(q, Y), k(q, Y)];
            }
            function I(q, Y) {
              return F(q) ? C(q.lastChild, Y) : "";
            }
            function k(q, Y) {
              return l(q) ? P(q.parent, Y) : E(q) ? $(q.next) : "";
            }
            function P(q, Y) {
              if (t3(!q.isSelfClosing), D(q, Y))
                return "";
              switch (q.type) {
                case "ieConditionalComment":
                  return "<!";
                case "element":
                  if (q.hasHtmComponentClosingTag)
                    return "<//";
                default:
                  return "</".concat(q.rawName);
              }
            }
            function C(q, Y) {
              if (D(q, Y))
                return "";
              switch (q.type) {
                case "ieConditionalComment":
                case "ieConditionalEndComment":
                  return "[endif]-->";
                case "ieConditionalStartComment":
                  return "]><!-->";
                case "interpolation":
                  return "}}";
                case "element":
                  if (q.isSelfClosing)
                    return "/>";
                default:
                  return ">";
              }
            }
            function D(q, Y) {
              return !q.isSelfClosing && !q.endSourceSpan && (h(q) || w(q.parent, Y));
            }
            function g(q) {
              return q.prev && q.prev.type !== "docType" && !d(q.prev) && q.isLeadingSpaceSensitive && !q.hasLeadingSpaces;
            }
            function F(q) {
              return q.lastChild && q.lastChild.isTrailingSpaceSensitive && !q.lastChild.hasTrailingSpaces && !d(p(q.lastChild)) && !f(q);
            }
            function l(q) {
              return !q.next && !q.hasTrailingSpaces && q.isTrailingSpaceSensitive && d(p(q));
            }
            function E(q) {
              return q.next && !d(q.next) && d(q) && q.isTrailingSpaceSensitive && !q.hasTrailingSpaces;
            }
            function y(q) {
              let Y = q.trim().match(/^prettier-ignore-attribute(?:\s+(.+))?$/s);
              return Y ? Y[1] ? Y[1].split(/\s+/) : true : false;
            }
            function N(q) {
              return !q.prev && q.isLeadingSpaceSensitive && !q.hasLeadingSpaces;
            }
            function x(q, Y, H) {
              let R = q.getValue();
              if (!s(R.attrs))
                return R.isSelfClosing ? " " : "";
              let Q = R.prev && R.prev.type === "comment" && y(R.prev.value), ee = typeof Q == "boolean" ? () => Q : Array.isArray(Q) ? (De) => Q.includes(De.rawName) : () => false, te = q.map((De) => {
                let ie = De.getValue();
                return ee(ie) ? c(Y.originalText.slice(v(ie), m(ie))) : H();
              }, "attrs"), oe = R.type === "element" && R.fullName === "script" && R.attrs.length === 1 && R.attrs[0].fullName === "src" && R.children.length === 0, X = Y.singleAttributePerLine && R.attrs.length > 1 && !T(R, Y) ? o : u, ue = [a([oe ? " " : u, r(X, te)])];
              return R.firstChild && N(R.firstChild) || R.isSelfClosing && F(R.parent) || oe ? ue.push(R.isSelfClosing ? " " : "") : ue.push(Y.bracketSameLine ? R.isSelfClosing ? " " : "" : R.isSelfClosing ? u : i), ue;
            }
            function b(q) {
              return q.firstChild && N(q.firstChild) ? "" : V(q);
            }
            function L(q, Y, H) {
              let R = q.getValue();
              return [M(R, Y), x(q, Y, H), R.isSelfClosing ? "" : b(R)];
            }
            function M(q, Y) {
              return q.prev && E(q.prev) ? "" : [j(q, Y), $(q)];
            }
            function j(q, Y) {
              return N(q) ? V(q.parent) : g(q) ? C(q.prev, Y) : "";
            }
            function $(q) {
              switch (q.type) {
                case "ieConditionalComment":
                case "ieConditionalStartComment":
                  return "<!--[if ".concat(q.condition);
                case "ieConditionalEndComment":
                  return "<!--<!";
                case "interpolation":
                  return "{{";
                case "docType":
                  return "<!DOCTYPE";
                case "element":
                  if (q.condition)
                    return "<!--[if ".concat(q.condition, "]><!--><").concat(q.rawName);
                default:
                  return "<".concat(q.rawName);
              }
            }
            function V(q) {
              switch (t3(!q.isSelfClosing), q.type) {
                case "ieConditionalComment":
                  return "]>";
                case "element":
                  if (q.condition)
                    return "><!--<![endif]-->";
                default:
                  return ">";
              }
            }
            n.exports = { printClosingTag: A, printClosingTagStart: S, printClosingTagStartMarker: P, printClosingTagEndMarker: C, printClosingTagSuffix: k, printClosingTagEnd: B, needsToBorrowLastChildClosingTagEndMarker: F, needsToBorrowParentClosingTagStartMarker: l, needsToBorrowPrevClosingTagEndMarker: g, printOpeningTag: L, printOpeningTagStart: M, printOpeningTagPrefix: j, printOpeningTagStartMarker: $, printOpeningTagEndMarker: V, needsToBorrowNextOpeningTagStartMarker: E, needsToBorrowParentOpeningTagEndMarker: N };
          } }), ug = Z({ "node_modules/parse-srcset/src/parse-srcset.js"(e, n) {
            re(), function(t3, s) {
              typeof define == "function" && define.amd ? define([], s) : typeof n == "object" && n.exports ? n.exports = s() : t3.parseSrcset = s();
            }(e, function() {
              return function(t3, s) {
                var a = s && s.logger || console;
                function r(P) {
                  return P === " " || P === "	" || P === `
` || P === "\f" || P === "\r";
                }
                function u(P) {
                  var C, D = P.exec(t3.substring(S));
                  if (D)
                    return C = D[0], S += C.length, C;
                }
                for (var i = t3.length, o = /^[ \t\n\r\u000c]+/, c = /^[, \t\n\r\u000c]+/, v = /^[^ \t\n\r\u000c]+/, m = /[,]+$/, d = /^\d+$/, p = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, f, h, w, T, A, S = 0, B = []; ; ) {
                  if (u(c), S >= i)
                    return B;
                  f = u(v), h = [], f.slice(-1) === "," ? (f = f.replace(m, ""), k()) : I();
                }
                function I() {
                  for (u(o), w = "", T = "in descriptor"; ; ) {
                    if (A = t3.charAt(S), T === "in descriptor")
                      if (r(A))
                        w && (h.push(w), w = "", T = "after descriptor");
                      else if (A === ",") {
                        S += 1, w && h.push(w), k();
                        return;
                      } else if (A === "(")
                        w = w + A, T = "in parens";
                      else if (A === "") {
                        w && h.push(w), k();
                        return;
                      } else
                        w = w + A;
                    else if (T === "in parens")
                      if (A === ")")
                        w = w + A, T = "in descriptor";
                      else if (A === "") {
                        h.push(w), k();
                        return;
                      } else
                        w = w + A;
                    else if (T === "after descriptor" && !r(A))
                      if (A === "") {
                        k();
                        return;
                      } else
                        T = "in descriptor", S -= 1;
                    S += 1;
                  }
                }
                function k() {
                  var P = false, C, D, g, F, l = {}, E, y, N, x, b;
                  for (F = 0; F < h.length; F++)
                    E = h[F], y = E[E.length - 1], N = E.substring(0, E.length - 1), x = parseInt(N, 10), b = parseFloat(N), d.test(N) && y === "w" ? ((C || D) && (P = true), x === 0 ? P = true : C = x) : p.test(N) && y === "x" ? ((C || D || g) && (P = true), b < 0 ? P = true : D = b) : d.test(N) && y === "h" ? ((g || D) && (P = true), x === 0 ? P = true : g = x) : P = true;
                  P ? a && a.error && a.error("Invalid srcset descriptor found in '" + t3 + "' at '" + E + "'.") : (l.url = f, C && (l.w = C), D && (l.d = D), g && (l.h = g), B.push(l));
                }
              };
            });
          } }), sg = Z({ "src/language-html/syntax-attribute.js"(e, n) {
            "use strict";
            re();
            var t3 = ug(), { builders: { ifBreak: s, join: a, line: r } } = Oe();
            function u(o) {
              let c = t3(o, { logger: { error(I) {
                throw new Error(I);
              } } }), v = c.some((I) => {
                let { w: k } = I;
                return k;
              }), m = c.some((I) => {
                let { h: k } = I;
                return k;
              }), d = c.some((I) => {
                let { d: k } = I;
                return k;
              });
              if (v + m + d > 1)
                throw new Error("Mixed descriptor in srcset is not supported");
              let p = v ? "w" : m ? "h" : "d", f = v ? "w" : m ? "h" : "x", h = (I) => Math.max(...I), w = c.map((I) => I.url), T = h(w.map((I) => I.length)), A = c.map((I) => I[p]).map((I) => I ? I.toString() : ""), S = A.map((I) => {
                let k = I.indexOf(".");
                return k === -1 ? I.length : k;
              }), B = h(S);
              return a([",", r], w.map((I, k) => {
                let P = [I], C = A[k];
                if (C) {
                  let D = T - I.length + 1, g = B - S[k], F = " ".repeat(D + g);
                  P.push(s(F, " "), C + f);
                }
                return P;
              }));
            }
            function i(o) {
              return o.trim().split(/\s+/).join(" ");
            }
            n.exports = { printImgSrcset: u, printClassNames: i };
          } }), ig = Z({ "src/language-html/syntax-vue.js"(e, n) {
            "use strict";
            re();
            var { builders: { group: t3 } } = Oe();
            function s(i, o) {
              let { left: c, operator: v, right: m } = a(i);
              return [t3(o("function _(".concat(c, ") {}"), { parser: "babel", __isVueForBindingLeft: true })), " ", v, " ", o(m, { parser: "__js_expression" }, { stripTrailingHardline: true })];
            }
            function a(i) {
              let o = /(.*?)\s+(in|of)\s+(.*)/s, c = /,([^,\]}]*)(?:,([^,\]}]*))?$/, v = /^\(|\)$/g, m = i.match(o);
              if (!m)
                return;
              let d = {};
              if (d.for = m[3].trim(), !d.for)
                return;
              let p = m[1].trim().replace(v, ""), f = p.match(c);
              f ? (d.alias = p.replace(c, ""), d.iterator1 = f[1].trim(), f[2] && (d.iterator2 = f[2].trim())) : d.alias = p;
              let h = [d.alias, d.iterator1, d.iterator2];
              if (!h.some((w, T) => !w && (T === 0 || h.slice(T + 1).some(Boolean))))
                return { left: h.filter(Boolean).join(","), operator: m[2], right: d.for };
            }
            function r(i, o) {
              return o("function _(".concat(i, ") {}"), { parser: "babel", __isVueBindings: true });
            }
            function u(i) {
              let o = /^(?:[\w$]+|\([^)]*\))\s*=>|^function\s*\(/, c = /^[$A-Z_a-z][\w$]*(?:\.[$A-Z_a-z][\w$]*|\['[^']*']|\["[^"]*"]|\[\d+]|\[[$A-Z_a-z][\w$]*])*$/, v = i.trim();
              return o.test(v) || c.test(v);
            }
            n.exports = { isVueEventBindingExpression: u, printVueFor: s, printVueBindings: r };
          } }), ho = Z({ "src/language-html/get-node-content.js"(e, n) {
            "use strict";
            re();
            var { needsToBorrowParentClosingTagStartMarker: t3, printClosingTagStartMarker: s, needsToBorrowLastChildClosingTagEndMarker: a, printClosingTagEndMarker: r, needsToBorrowParentOpeningTagEndMarker: u, printOpeningTagEndMarker: i } = er();
            function o(c, v) {
              let m = c.startSourceSpan.end.offset;
              c.firstChild && u(c.firstChild) && (m -= i(c).length);
              let d = c.endSourceSpan.start.offset;
              return c.lastChild && t3(c.lastChild) ? d += s(c, v).length : a(c) && (d -= r(c.lastChild, v).length), v.originalText.slice(m, d);
            }
            n.exports = o;
          } }), ag = Z({ "src/language-html/embed.js"(e, n) {
            "use strict";
            re();
            var { builders: { breakParent: t3, group: s, hardline: a, indent: r, line: u, fill: i, softline: o }, utils: { mapDoc: c, replaceTextEndOfLine: v } } = Oe(), m = Xn(), { printClosingTag: d, printClosingTagSuffix: p, needsToBorrowPrevClosingTagEndMarker: f, printOpeningTagPrefix: h, printOpeningTag: w } = er(), { printImgSrcset: T, printClassNames: A } = sg(), { printVueFor: S, printVueBindings: B, isVueEventBindingExpression: I } = ig(), { isScriptLikeTag: k, isVueNonHtmlBlock: P, inferScriptParser: C, htmlTrimPreserveIndentation: D, dedentString: g, unescapeQuoteEntities: F, isVueSlotAttribute: l, isVueSfcBindingsAttribute: E, getTextValueParts: y } = qt(), N = ho();
            function x(L, M, j) {
              let $ = (te) => new RegExp(te.join("|")).test(L.fullName), V = () => F(L.value), q = false, Y = (te, oe) => {
                let W = te.type === "NGRoot" ? te.node.type === "NGMicrosyntax" && te.node.body.length === 1 && te.node.body[0].type === "NGMicrosyntaxExpression" ? te.node.body[0].expression : te.node : te.type === "JsExpressionRoot" ? te.node : te;
                W && (W.type === "ObjectExpression" || W.type === "ArrayExpression" || oe.parser === "__vue_expression" && (W.type === "TemplateLiteral" || W.type === "StringLiteral")) && (q = true);
              }, H = (te) => s(te), R = function(te) {
                let oe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                return s([r([o, te]), oe ? o : ""]);
              }, Q = (te) => q ? H(te) : R(te), ee = (te, oe) => M(te, Object.assign({ __onHtmlBindingRoot: Y, __embeddedInHtml: true }, oe));
              if (L.fullName === "srcset" && (L.parent.fullName === "img" || L.parent.fullName === "source"))
                return R(T(V()));
              if (L.fullName === "class" && !j.parentParser) {
                let te = V();
                if (!te.includes("{{"))
                  return A(te);
              }
              if (L.fullName === "style" && !j.parentParser) {
                let te = V();
                if (!te.includes("{{"))
                  return R(ee(te, { parser: "css", __isHTMLStyleAttribute: true }));
              }
              if (j.parser === "vue") {
                if (L.fullName === "v-for")
                  return S(V(), ee);
                if (l(L) || E(L, j))
                  return B(V(), ee);
                let te = ["^@", "^v-on:"], oe = ["^:", "^v-bind:"], W = ["^v-"];
                if ($(te)) {
                  let X = V(), ue = I(X) ? "__js_expression" : j.__should_parse_vue_template_with_ts ? "__vue_ts_event_binding" : "__vue_event_binding";
                  return Q(ee(X, { parser: ue }));
                }
                if ($(oe))
                  return Q(ee(V(), { parser: "__vue_expression" }));
                if ($(W))
                  return Q(ee(V(), { parser: "__js_expression" }));
              }
              if (j.parser === "angular") {
                let te = (G, z) => ee(G, Object.assign(Object.assign({}, z), {}, { trailingComma: "none" })), oe = ["^\\*"], W = ["^\\(.+\\)$", "^on-"], X = ["^\\[.+\\]$", "^bind(on)?-", "^ng-(if|show|hide|class|style)$"], ue = ["^i18n(-.+)?$"];
                if ($(W))
                  return Q(te(V(), { parser: "__ng_action" }));
                if ($(X))
                  return Q(te(V(), { parser: "__ng_binding" }));
                if ($(ue)) {
                  let G = V().trim();
                  return R(i(y(L, G)), !G.includes("@@"));
                }
                if ($(oe))
                  return Q(te(V(), { parser: "__ng_directive" }));
                let De = /{{(.+?)}}/s, ie = V();
                if (De.test(ie)) {
                  let G = [];
                  for (let [z, U] of ie.split(De).entries())
                    if (z % 2 === 0)
                      G.push(v(U));
                    else
                      try {
                        G.push(s(["{{", r([u, te(U, { parser: "__ng_interpolation", __isInHtmlInterpolation: true })]), u, "}}"]));
                      } catch {
                        G.push("{{", v(U), "}}");
                      }
                  return s(G);
                }
              }
              return null;
            }
            function b(L, M, j, $) {
              let V = L.getValue();
              switch (V.type) {
                case "element": {
                  if (k(V) || V.type === "interpolation")
                    return;
                  if (!V.isSelfClosing && P(V, $)) {
                    let q = C(V, $);
                    if (!q)
                      return;
                    let Y = N(V, $), H = /^\s*$/.test(Y), R = "";
                    return H || (R = j(D(Y), { parser: q, __embeddedInHtml: true }, { stripTrailingHardline: true }), H = R === ""), [h(V, $), s(w(L, $, M)), H ? "" : a, R, H ? "" : a, d(V, $), p(V, $)];
                  }
                  break;
                }
                case "text": {
                  if (k(V.parent)) {
                    let q = C(V.parent, $);
                    if (q) {
                      let Y = q === "markdown" ? g(V.value.replace(/^[^\S\n]*\n/, "")) : V.value, H = { parser: q, __embeddedInHtml: true };
                      if ($.parser === "html" && q === "babel") {
                        let R = "script", { attrMap: Q } = V.parent;
                        Q && (Q.type === "module" || Q.type === "text/babel" && Q["data-type"] === "module") && (R = "module"), H.__babelSourceType = R;
                      }
                      return [t3, h(V, $), j(Y, H, { stripTrailingHardline: true }), p(V, $)];
                    }
                  } else if (V.parent.type === "interpolation") {
                    let q = { __isInHtmlInterpolation: true, __embeddedInHtml: true };
                    return $.parser === "angular" ? (q.parser = "__ng_interpolation", q.trailingComma = "none") : $.parser === "vue" ? q.parser = $.__should_parse_vue_template_with_ts ? "__vue_ts_expression" : "__vue_expression" : q.parser = "__js_expression", [r([u, j(V.value, q, { stripTrailingHardline: true })]), V.parent.next && f(V.parent.next) ? " " : u];
                  }
                  break;
                }
                case "attribute": {
                  if (!V.value)
                    break;
                  if (/^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test($.originalText.slice(V.valueSpan.start.offset, V.valueSpan.end.offset)))
                    return [V.rawName, "=", V.value];
                  if ($.parser === "lwc" && /^{.*}$/s.test($.originalText.slice(V.valueSpan.start.offset, V.valueSpan.end.offset)))
                    return [V.rawName, "=", V.value];
                  let q = x(V, (Y, H) => j(Y, Object.assign({ __isInHtmlAttribute: true, __embeddedInHtml: true }, H), { stripTrailingHardline: true }), $);
                  if (q)
                    return [V.rawName, '="', s(c(q, (Y) => typeof Y == "string" ? Y.replace(/"/g, "&quot;") : Y)), '"'];
                  break;
                }
                case "front-matter":
                  return m(V, j);
              }
            }
            n.exports = b;
          } }), vo = Z({ "src/language-html/print/children.js"(e, n) {
            "use strict";
            re();
            var { builders: { breakParent: t3, group: s, ifBreak: a, line: r, softline: u, hardline: i }, utils: { replaceTextEndOfLine: o } } = Oe(), { locStart: c, locEnd: v } = Yn(), { forceBreakChildren: m, forceNextEmptyLine: d, isTextLikeNode: p, hasPrettierIgnore: f, preferHardlineAsLeadingSpaces: h } = qt(), { printOpeningTagPrefix: w, needsToBorrowNextOpeningTagStartMarker: T, printOpeningTagStartMarker: A, needsToBorrowPrevClosingTagEndMarker: S, printClosingTagEndMarker: B, printClosingTagSuffix: I, needsToBorrowParentClosingTagStartMarker: k } = er();
            function P(g, F, l) {
              let E = g.getValue();
              return f(E) ? [w(E, F), ...o(F.originalText.slice(c(E) + (E.prev && T(E.prev) ? A(E).length : 0), v(E) - (E.next && S(E.next) ? B(E, F).length : 0))), I(E, F)] : l();
            }
            function C(g, F) {
              return p(g) && p(F) ? g.isTrailingSpaceSensitive ? g.hasTrailingSpaces ? h(F) ? i : r : "" : h(F) ? i : u : T(g) && (f(F) || F.firstChild || F.isSelfClosing || F.type === "element" && F.attrs.length > 0) || g.type === "element" && g.isSelfClosing && S(F) ? "" : !F.isLeadingSpaceSensitive || h(F) || S(F) && g.lastChild && k(g.lastChild) && g.lastChild.lastChild && k(g.lastChild.lastChild) ? i : F.hasLeadingSpaces ? r : u;
            }
            function D(g, F, l) {
              let E = g.getValue();
              if (m(E))
                return [t3, ...g.map((N) => {
                  let x = N.getValue(), b = x.prev ? C(x.prev, x) : "";
                  return [b ? [b, d(x.prev) ? i : ""] : "", P(N, F, l)];
                }, "children")];
              let y = E.children.map(() => Symbol(""));
              return g.map((N, x) => {
                let b = N.getValue();
                if (p(b)) {
                  if (b.prev && p(b.prev)) {
                    let Y = C(b.prev, b);
                    if (Y)
                      return d(b.prev) ? [i, i, P(N, F, l)] : [Y, P(N, F, l)];
                  }
                  return P(N, F, l);
                }
                let L = [], M = [], j = [], $ = [], V = b.prev ? C(b.prev, b) : "", q = b.next ? C(b, b.next) : "";
                return V && (d(b.prev) ? L.push(i, i) : V === i ? L.push(i) : p(b.prev) ? M.push(V) : M.push(a("", u, { groupId: y[x - 1] }))), q && (d(b) ? p(b.next) && $.push(i, i) : q === i ? p(b.next) && $.push(i) : j.push(q)), [...L, s([...M, s([P(N, F, l), ...j], { id: y[x] })]), ...$];
              }, "children");
            }
            n.exports = { printChildren: D };
          } }), og = Z({ "src/language-html/print/element.js"(e, n) {
            "use strict";
            re();
            var { builders: { breakParent: t3, dedentToRoot: s, group: a, ifBreak: r, indentIfBreak: u, indent: i, line: o, softline: c }, utils: { replaceTextEndOfLine: v } } = Oe(), m = ho(), { shouldPreserveContent: d, isScriptLikeTag: p, isVueCustomBlock: f, countParents: h, forceBreakContent: w } = qt(), { printOpeningTagPrefix: T, printOpeningTag: A, printClosingTagSuffix: S, printClosingTag: B, needsToBorrowPrevClosingTagEndMarker: I, needsToBorrowLastChildClosingTagEndMarker: k } = er(), { printChildren: P } = vo();
            function C(D, g, F) {
              let l = D.getValue();
              if (d(l, g))
                return [T(l, g), a(A(D, g, F)), ...v(m(l, g)), ...B(l, g), S(l, g)];
              let E = l.children.length === 1 && l.firstChild.type === "interpolation" && l.firstChild.isLeadingSpaceSensitive && !l.firstChild.hasLeadingSpaces && l.lastChild.isTrailingSpaceSensitive && !l.lastChild.hasTrailingSpaces, y = Symbol("element-attr-group-id"), N = (M) => a([a(A(D, g, F), { id: y }), M, B(l, g)]), x = (M) => E ? u(M, { groupId: y }) : (p(l) || f(l, g)) && l.parent.type === "root" && g.parser === "vue" && !g.vueIndentScriptAndStyle ? M : i(M), b = () => E ? r(c, "", { groupId: y }) : l.firstChild.hasLeadingSpaces && l.firstChild.isLeadingSpaceSensitive ? o : l.firstChild.type === "text" && l.isWhitespaceSensitive && l.isIndentationSensitive ? s(c) : c, L = () => (l.next ? I(l.next) : k(l.parent)) ? l.lastChild.hasTrailingSpaces && l.lastChild.isTrailingSpaceSensitive ? " " : "" : E ? r(c, "", { groupId: y }) : l.lastChild.hasTrailingSpaces && l.lastChild.isTrailingSpaceSensitive ? o : (l.lastChild.type === "comment" || l.lastChild.type === "text" && l.isWhitespaceSensitive && l.isIndentationSensitive) && new RegExp("\\n[\\t ]{".concat(g.tabWidth * h(D, (j) => j.parent && j.parent.type !== "root"), "}$")).test(l.lastChild.value) ? "" : c;
              return l.children.length === 0 ? N(l.hasDanglingSpaces && l.isDanglingSpaceSensitive ? o : "") : N([w(l) ? t3 : "", x([b(), P(D, g, F)]), L()]);
            }
            n.exports = { printElement: C };
          } }), lg = Z({ "src/language-html/printer-html.js"(e, n) {
            "use strict";
            re();
            var { builders: { fill: t3, group: s, hardline: a, literalline: r }, utils: { cleanDoc: u, getDocParts: i, isConcat: o, replaceTextEndOfLine: c } } = Oe(), v = zd(), { countChars: m, unescapeQuoteEntities: d, getTextValueParts: p } = qt(), f = rg(), { insertPragma: h } = ng(), { locStart: w, locEnd: T } = Yn(), A = ag(), { printClosingTagSuffix: S, printClosingTagEnd: B, printOpeningTagPrefix: I, printOpeningTagStart: k } = er(), { printElement: P } = og(), { printChildren: C } = vo();
            function D(g, F, l) {
              let E = g.getValue();
              switch (E.type) {
                case "front-matter":
                  return c(E.raw);
                case "root":
                  return F.__onHtmlRoot && F.__onHtmlRoot(E), [s(C(g, F, l)), a];
                case "element":
                case "ieConditionalComment":
                  return P(g, F, l);
                case "ieConditionalStartComment":
                case "ieConditionalEndComment":
                  return [k(E), B(E)];
                case "interpolation":
                  return [k(E, F), ...g.map(l, "children"), B(E, F)];
                case "text": {
                  if (E.parent.type === "interpolation") {
                    let N = /\n[^\S\n]*$/, x = N.test(E.value), b = x ? E.value.replace(N, "") : E.value;
                    return [...c(b), x ? a : ""];
                  }
                  let y = u([I(E, F), ...p(E), S(E, F)]);
                  return o(y) || y.type === "fill" ? t3(i(y)) : y;
                }
                case "docType":
                  return [s([k(E, F), " ", E.value.replace(/^html\b/i, "html").replace(/\s+/g, " ")]), B(E, F)];
                case "comment":
                  return [I(E, F), ...c(F.originalText.slice(w(E), T(E)), r), S(E, F)];
                case "attribute": {
                  if (E.value === null)
                    return E.rawName;
                  let y = d(E.value), N = m(y, "'"), x = m(y, '"'), b = N < x ? "'" : '"';
                  return [E.rawName, "=", b, ...c(b === '"' ? y.replace(/"/g, "&quot;") : y.replace(/'/g, "&apos;")), b];
                }
                default:
                  throw new Error("Unexpected node type ".concat(E.type));
              }
            }
            n.exports = { preprocess: f, print: D, insertPragma: h, massageAstNode: v, embed: A };
          } }), cg = Z({ "src/language-html/options.js"(e, n) {
            "use strict";
            re();
            var t3 = Ot(), s = "HTML";
            n.exports = { bracketSameLine: t3.bracketSameLine, htmlWhitespaceSensitivity: { since: "1.15.0", category: s, type: "choice", default: "css", description: "How to handle whitespaces in HTML.", choices: [{ value: "css", description: "Respect the default value of CSS display property." }, { value: "strict", description: "Whitespaces are considered sensitive." }, { value: "ignore", description: "Whitespaces are considered insensitive." }] }, singleAttributePerLine: t3.singleAttributePerLine, vueIndentScriptAndStyle: { since: "1.19.0", category: s, type: "boolean", default: false, description: "Indent script and style tags in Vue files." } };
          } }), pg = Z({ "src/language-html/parsers.js"() {
            re();
          } }), xn = Z({ "node_modules/linguist-languages/data/HTML.json"(e, n) {
            n.exports = { name: "HTML", type: "markup", tmScope: "text.html.basic", aceMode: "html", codemirrorMode: "htmlmixed", codemirrorMimeType: "text/html", color: "#e34c26", aliases: ["xhtml"], extensions: [".html", ".hta", ".htm", ".html.hl", ".inc", ".xht", ".xhtml"], languageId: 146 };
          } }), fg = Z({ "node_modules/linguist-languages/data/Vue.json"(e, n) {
            n.exports = { name: "Vue", type: "markup", color: "#41b883", extensions: [".vue"], tmScope: "text.html.vue", aceMode: "html", languageId: 391 };
          } }), Dg = Z({ "src/language-html/index.js"(e, n) {
            "use strict";
            re();
            var t3 = Bt(), s = lg(), a = cg(), r = pg(), u = [t3(xn(), () => ({ name: "Angular", since: "1.15.0", parsers: ["angular"], vscodeLanguageIds: ["html"], extensions: [".component.html"], filenames: [] })), t3(xn(), (o) => ({ since: "1.15.0", parsers: ["html"], vscodeLanguageIds: ["html"], extensions: [...o.extensions, ".mjml"] })), t3(xn(), () => ({ name: "Lightning Web Components", since: "1.17.0", parsers: ["lwc"], vscodeLanguageIds: ["html"], extensions: [], filenames: [] })), t3(fg(), () => ({ since: "1.10.0", parsers: ["vue"], vscodeLanguageIds: ["vue"] }))], i = { html: s };
            n.exports = { languages: u, printers: i, options: a, parsers: r };
          } }), mg = Z({ "src/language-yaml/pragma.js"(e, n) {
            "use strict";
            re();
            function t3(r) {
              return /^\s*@(?:prettier|format)\s*$/.test(r);
            }
            function s(r) {
              return /^\s*#[^\S\n]*@(?:prettier|format)\s*?(?:\n|$)/.test(r);
            }
            function a(r) {
              return `# @format

`.concat(r);
            }
            n.exports = { isPragma: t3, hasPragma: s, insertPragma: a };
          } }), dg = Z({ "src/language-yaml/loc.js"(e, n) {
            "use strict";
            re();
            function t3(a) {
              return a.position.start.offset;
            }
            function s(a) {
              return a.position.end.offset;
            }
            n.exports = { locStart: t3, locEnd: s };
          } }), gg = Z({ "src/language-yaml/embed.js"(e, n) {
            "use strict";
            re();
            function t3(s, a, r, u) {
              if (s.getValue().type === "root" && u.filepath && /(?:[/\\]|^)\.(?:prettier|stylelint)rc$/.test(u.filepath))
                return r(u.originalText, Object.assign(Object.assign({}, u), {}, { parser: "json" }));
            }
            n.exports = t3;
          } }), Mt = Z({ "src/language-yaml/utils.js"(e, n) {
            "use strict";
            re();
            var { getLast: t3, isNonEmptyArray: s } = Ue();
            function a(C, D) {
              let g = 0, F = C.stack.length - 1;
              for (let l = 0; l < F; l++) {
                let E = C.stack[l];
                r(E) && D(E) && g++;
              }
              return g;
            }
            function r(C, D) {
              return C && typeof C.type == "string" && (!D || D.includes(C.type));
            }
            function u(C, D, g) {
              return D("children" in C ? Object.assign(Object.assign({}, C), {}, { children: C.children.map((F) => u(F, D, C)) }) : C, g);
            }
            function i(C, D, g) {
              Object.defineProperty(C, D, { get: g, enumerable: false });
            }
            function o(C, D) {
              let g = 0, F = D.length;
              for (let l = C.position.end.offset - 1; l < F; l++) {
                let E = D[l];
                if (E === `
` && g++, g === 1 && /\S/.test(E))
                  return false;
                if (g === 2)
                  return true;
              }
              return false;
            }
            function c(C) {
              switch (C.getValue().type) {
                case "tag":
                case "anchor":
                case "comment":
                  return false;
              }
              let g = C.stack.length;
              for (let F = 1; F < g; F++) {
                let l = C.stack[F], E = C.stack[F - 1];
                if (Array.isArray(E) && typeof l == "number" && l !== E.length - 1)
                  return false;
              }
              return true;
            }
            function v(C) {
              return s(C.children) ? v(t3(C.children)) : C;
            }
            function m(C) {
              return C.value.trim() === "prettier-ignore";
            }
            function d(C) {
              let D = C.getValue();
              if (D.type === "documentBody") {
                let g = C.getParentNode();
                return S(g.head) && m(t3(g.head.endComments));
              }
              return h(D) && m(t3(D.leadingComments));
            }
            function p(C) {
              return !s(C.children) && !f(C);
            }
            function f(C) {
              return h(C) || w(C) || T(C) || A(C) || S(C);
            }
            function h(C) {
              return s(C == null ? void 0 : C.leadingComments);
            }
            function w(C) {
              return s(C == null ? void 0 : C.middleComments);
            }
            function T(C) {
              return C == null ? void 0 : C.indicatorComment;
            }
            function A(C) {
              return C == null ? void 0 : C.trailingComment;
            }
            function S(C) {
              return s(C == null ? void 0 : C.endComments);
            }
            function B(C) {
              let D = [], g;
              for (let F of C.split(/( +)/))
                F !== " " ? g === " " ? D.push(F) : D.push((D.pop() || "") + F) : g === void 0 && D.unshift(""), g = F;
              return g === " " && D.push((D.pop() || "") + " "), D[0] === "" && (D.shift(), D.unshift(" " + (D.shift() || ""))), D;
            }
            function I(C, D, g) {
              let F = D.split(`
`).map((l, E, y) => E === 0 && E === y.length - 1 ? l : E !== 0 && E !== y.length - 1 ? l.trim() : E === 0 ? l.trimEnd() : l.trimStart());
              return g.proseWrap === "preserve" ? F.map((l) => l.length === 0 ? [] : [l]) : F.map((l) => l.length === 0 ? [] : B(l)).reduce((l, E, y) => y !== 0 && F[y - 1].length > 0 && E.length > 0 && !(C === "quoteDouble" && t3(t3(l)).endsWith("\\")) ? [...l.slice(0, -1), [...t3(l), ...E]] : [...l, E], []).map((l) => g.proseWrap === "never" ? [l.join(" ")] : l);
            }
            function k(C, D) {
              let { parentIndent: g, isLastDescendant: F, options: l } = D, E = C.position.start.line === C.position.end.line ? "" : l.originalText.slice(C.position.start.offset, C.position.end.offset).match(/^[^\n]*\n(.*)$/s)[1], y;
              if (C.indent === null) {
                let b = E.match(/^(?<leadingSpace> *)[^\n\r ]/m);
                y = b ? b.groups.leadingSpace.length : Number.POSITIVE_INFINITY;
              } else
                y = C.indent - 1 + g;
              let N = E.split(`
`).map((b) => b.slice(y));
              if (l.proseWrap === "preserve" || C.type === "blockLiteral")
                return x(N.map((b) => b.length === 0 ? [] : [b]));
              return x(N.map((b) => b.length === 0 ? [] : B(b)).reduce((b, L, M) => M !== 0 && N[M - 1].length > 0 && L.length > 0 && !/^\s/.test(L[0]) && !/^\s|\s$/.test(t3(b)) ? [...b.slice(0, -1), [...t3(b), ...L]] : [...b, L], []).map((b) => b.reduce((L, M) => L.length > 0 && /\s$/.test(t3(L)) ? [...L.slice(0, -1), t3(L) + " " + M] : [...L, M], [])).map((b) => l.proseWrap === "never" ? [b.join(" ")] : b));
              function x(b) {
                if (C.chomping === "keep")
                  return t3(b).length === 0 ? b.slice(0, -1) : b;
                let L = 0;
                for (let M = b.length - 1; M >= 0 && b[M].length === 0; M--)
                  L++;
                return L === 0 ? b : L >= 2 && !F ? b.slice(0, -(L - 1)) : b.slice(0, -L);
              }
            }
            function P(C) {
              if (!C)
                return true;
              switch (C.type) {
                case "plain":
                case "quoteDouble":
                case "quoteSingle":
                case "alias":
                case "flowMapping":
                case "flowSequence":
                  return true;
                default:
                  return false;
              }
            }
            n.exports = { getLast: t3, getAncestorCount: a, isNode: r, isEmptyNode: p, isInlineNode: P, mapNode: u, defineShortcut: i, isNextLineEmpty: o, isLastDescendantNode: c, getBlockValueLineContents: k, getFlowScalarLineContents: I, getLastDescendantNode: v, hasPrettierIgnore: d, hasLeadingComments: h, hasMiddleComments: w, hasIndicatorComment: T, hasTrailingComment: A, hasEndComments: S };
          } }), yg = Z({ "src/language-yaml/print-preprocess.js"(e, n) {
            "use strict";
            re();
            var { defineShortcut: t3, mapNode: s } = Mt();
            function a(u) {
              return s(u, r);
            }
            function r(u) {
              switch (u.type) {
                case "document":
                  t3(u, "head", () => u.children[0]), t3(u, "body", () => u.children[1]);
                  break;
                case "documentBody":
                case "sequenceItem":
                case "flowSequenceItem":
                case "mappingKey":
                case "mappingValue":
                  t3(u, "content", () => u.children[0]);
                  break;
                case "mappingItem":
                case "flowMappingItem":
                  t3(u, "key", () => u.children[0]), t3(u, "value", () => u.children[1]);
                  break;
              }
              return u;
            }
            n.exports = a;
          } }), jr = Z({ "src/language-yaml/print/misc.js"(e, n) {
            "use strict";
            re();
            var { builders: { softline: t3, align: s } } = Oe(), { hasEndComments: a, isNextLineEmpty: r, isNode: u } = Mt(), i = /* @__PURE__ */ new WeakMap();
            function o(m, d) {
              let p = m.getValue(), f = m.stack[0], h;
              return i.has(f) ? h = i.get(f) : (h = /* @__PURE__ */ new Set(), i.set(f, h)), !h.has(p.position.end.line) && (h.add(p.position.end.line), r(p, d) && !c(m.getParentNode())) ? t3 : "";
            }
            function c(m) {
              return a(m) && !u(m, ["documentHead", "documentBody", "flowMapping", "flowSequence"]);
            }
            function v(m, d) {
              return s(" ".repeat(m), d);
            }
            n.exports = { alignWithSpaces: v, shouldPrintEndComments: c, printNextEmptyLine: o };
          } }), hg = Z({ "src/language-yaml/print/flow-mapping-sequence.js"(e, n) {
            "use strict";
            re();
            var { builders: { ifBreak: t3, line: s, softline: a, hardline: r, join: u } } = Oe(), { isEmptyNode: i, getLast: o, hasEndComments: c } = Mt(), { printNextEmptyLine: v, alignWithSpaces: m } = jr();
            function d(f, h, w) {
              let T = f.getValue(), A = T.type === "flowMapping", S = A ? "{" : "[", B = A ? "}" : "]", I = a;
              A && T.children.length > 0 && w.bracketSpacing && (I = s);
              let k = o(T.children), P = k && k.type === "flowMappingItem" && i(k.key) && i(k.value);
              return [S, m(w.tabWidth, [I, p(f, h, w), w.trailingComma === "none" ? "" : t3(","), c(T) ? [r, u(r, f.map(h, "endComments"))] : ""]), P ? "" : I, B];
            }
            function p(f, h, w) {
              let T = f.getValue();
              return f.map((S, B) => [h(), B === T.children.length - 1 ? "" : [",", s, T.children[B].position.start.line !== T.children[B + 1].position.start.line ? v(S, w.originalText) : ""]], "children");
            }
            n.exports = { printFlowMapping: d, printFlowSequence: d };
          } }), vg = Z({ "src/language-yaml/print/mapping-item.js"(e, n) {
            "use strict";
            re();
            var { builders: { conditionalGroup: t3, group: s, hardline: a, ifBreak: r, join: u, line: i } } = Oe(), { hasLeadingComments: o, hasMiddleComments: c, hasTrailingComment: v, hasEndComments: m, isNode: d, isEmptyNode: p, isInlineNode: f } = Mt(), { alignWithSpaces: h } = jr();
            function w(B, I, k, P, C) {
              let { key: D, value: g } = B, F = p(D), l = p(g);
              if (F && l)
                return ": ";
              let E = P("key"), y = A(B) ? " " : "";
              if (l)
                return B.type === "flowMappingItem" && I.type === "flowMapping" ? E : B.type === "mappingItem" && T(D.content, C) && !v(D.content) && (!I.tag || I.tag.value !== "tag:yaml.org,2002:set") ? [E, y, ":"] : ["? ", h(2, E)];
              let N = P("value");
              if (F)
                return [": ", h(2, N)];
              if (o(g) || !f(D.content))
                return ["? ", h(2, E), a, u("", k.map(P, "value", "leadingComments").map(($) => [$, a])), ": ", h(2, N)];
              if (S(D.content) && !o(D.content) && !c(D.content) && !v(D.content) && !m(D) && !o(g.content) && !c(g.content) && !m(g) && T(g.content, C))
                return [E, y, ": ", N];
              let x = Symbol("mappingKey"), b = s([r("? "), s(h(2, E), { id: x })]), L = [a, ": ", h(2, N)], M = [y, ":"];
              o(g.content) || m(g) && g.content && !d(g.content, ["mapping", "sequence"]) || I.type === "mapping" && v(D.content) && f(g.content) || d(g.content, ["mapping", "sequence"]) && g.content.tag === null && g.content.anchor === null ? M.push(a) : g.content && M.push(i), M.push(N);
              let j = h(C.tabWidth, M);
              return T(D.content, C) && !o(D.content) && !c(D.content) && !m(D) ? t3([[E, j]]) : t3([[b, r(L, j, { groupId: x })]]);
            }
            function T(B, I) {
              if (!B)
                return true;
              switch (B.type) {
                case "plain":
                case "quoteSingle":
                case "quoteDouble":
                  break;
                case "alias":
                  return true;
                default:
                  return false;
              }
              if (I.proseWrap === "preserve")
                return B.position.start.line === B.position.end.line;
              if (/\\$/m.test(I.originalText.slice(B.position.start.offset, B.position.end.offset)))
                return false;
              switch (I.proseWrap) {
                case "never":
                  return !B.value.includes(`
`);
                case "always":
                  return !/[\n ]/.test(B.value);
                default:
                  return false;
              }
            }
            function A(B) {
              return B.key.content && B.key.content.type === "alias";
            }
            function S(B) {
              if (!B)
                return true;
              switch (B.type) {
                case "plain":
                case "quoteDouble":
                case "quoteSingle":
                  return B.position.start.line === B.position.end.line;
                case "alias":
                  return true;
                default:
                  return false;
              }
            }
            n.exports = w;
          } }), Cg = Z({ "src/language-yaml/print/block.js"(e, n) {
            "use strict";
            re();
            var { builders: { dedent: t3, dedentToRoot: s, fill: a, hardline: r, join: u, line: i, literalline: o, markAsRoot: c }, utils: { getDocParts: v } } = Oe(), { getAncestorCount: m, getBlockValueLineContents: d, hasIndicatorComment: p, isLastDescendantNode: f, isNode: h } = Mt(), { alignWithSpaces: w } = jr();
            function T(A, S, B) {
              let I = A.getValue(), k = m(A, (F) => h(F, ["sequence", "mapping"])), P = f(A), C = [I.type === "blockFolded" ? ">" : "|"];
              I.indent !== null && C.push(I.indent.toString()), I.chomping !== "clip" && C.push(I.chomping === "keep" ? "+" : "-"), p(I) && C.push(" ", S("indicatorComment"));
              let D = d(I, { parentIndent: k, isLastDescendant: P, options: B }), g = [];
              for (let [F, l] of D.entries())
                F === 0 && g.push(r), g.push(a(v(u(i, l)))), F !== D.length - 1 ? g.push(l.length === 0 ? r : c(o)) : I.chomping === "keep" && P && g.push(s(l.length === 0 ? r : o));
              return I.indent === null ? C.push(t3(w(B.tabWidth, g))) : C.push(s(w(I.indent - 1 + k, g))), C;
            }
            n.exports = T;
          } }), Eg = Z({ "src/language-yaml/printer-yaml.js"(e, n) {
            "use strict";
            re();
            var { builders: { breakParent: t3, fill: s, group: a, hardline: r, join: u, line: i, lineSuffix: o, literalline: c }, utils: { getDocParts: v, replaceTextEndOfLine: m } } = Oe(), { isPreviousLineEmpty: d } = Ue(), { insertPragma: p, isPragma: f } = mg(), { locStart: h } = dg(), w = gg(), { getFlowScalarLineContents: T, getLastDescendantNode: A, hasLeadingComments: S, hasMiddleComments: B, hasTrailingComment: I, hasEndComments: k, hasPrettierIgnore: P, isLastDescendantNode: C, isNode: D, isInlineNode: g } = Mt(), F = yg(), { alignWithSpaces: l, printNextEmptyLine: E, shouldPrintEndComments: y } = jr(), { printFlowMapping: N, printFlowSequence: x } = hg(), b = vg(), L = Cg();
            function M(R, Q, ee) {
              let te = R.getValue(), oe = [];
              te.type !== "mappingValue" && S(te) && oe.push([u(r, R.map(ee, "leadingComments")), r]);
              let { tag: W, anchor: X } = te;
              W && oe.push(ee("tag")), W && X && oe.push(" "), X && oe.push(ee("anchor"));
              let ue = "";
              D(te, ["mapping", "sequence", "comment", "directive", "mappingItem", "sequenceItem"]) && !C(R) && (ue = E(R, Q.originalText)), (W || X) && (D(te, ["sequence", "mapping"]) && !B(te) ? oe.push(r) : oe.push(" ")), B(te) && oe.push([te.middleComments.length === 1 ? "" : r, u(r, R.map(ee, "middleComments")), r]);
              let De = R.getParentNode();
              return P(R) ? oe.push(m(Q.originalText.slice(te.position.start.offset, te.position.end.offset).trimEnd(), c)) : oe.push(a(j(te, De, R, Q, ee))), I(te) && !D(te, ["document", "documentHead"]) && oe.push(o([te.type === "mappingValue" && !te.content ? "" : " ", De.type === "mappingKey" && R.getParentNode(2).type === "mapping" && g(te) ? "" : t3, ee("trailingComment")])), y(te) && oe.push(l(te.type === "sequenceItem" ? 2 : 0, [r, u(r, R.map((ie) => [d(Q.originalText, ie.getValue(), h) ? r : "", ee()], "endComments"))])), oe.push(ue), oe;
            }
            function j(R, Q, ee, te, oe) {
              switch (R.type) {
                case "root": {
                  let { children: W } = R, X = [];
                  ee.each((De, ie) => {
                    let G = W[ie], z = W[ie + 1];
                    ie !== 0 && X.push(r), X.push(oe()), V(G, z) ? (X.push(r, "..."), I(G) && X.push(" ", oe("trailingComment"))) : z && !I(z.head) && X.push(r, "---");
                  }, "children");
                  let ue = A(R);
                  return (!D(ue, ["blockLiteral", "blockFolded"]) || ue.chomping !== "keep") && X.push(r), X;
                }
                case "document": {
                  let W = Q.children[ee.getName() + 1], X = [];
                  return q(R, W, Q, te) === "head" && ((R.head.children.length > 0 || R.head.endComments.length > 0) && X.push(oe("head")), I(R.head) ? X.push(["---", " ", oe(["head", "trailingComment"])]) : X.push("---")), $(R) && X.push(oe("body")), u(r, X);
                }
                case "documentHead":
                  return u(r, [...ee.map(oe, "children"), ...ee.map(oe, "endComments")]);
                case "documentBody": {
                  let { children: W, endComments: X } = R, ue = "";
                  if (W.length > 0 && X.length > 0) {
                    let De = A(R);
                    D(De, ["blockFolded", "blockLiteral"]) ? De.chomping !== "keep" && (ue = [r, r]) : ue = r;
                  }
                  return [u(r, ee.map(oe, "children")), ue, u(r, ee.map(oe, "endComments"))];
                }
                case "directive":
                  return ["%", u(" ", [R.name, ...R.parameters])];
                case "comment":
                  return ["#", R.value];
                case "alias":
                  return ["*", R.value];
                case "tag":
                  return te.originalText.slice(R.position.start.offset, R.position.end.offset);
                case "anchor":
                  return ["&", R.value];
                case "plain":
                  return Y(R.type, te.originalText.slice(R.position.start.offset, R.position.end.offset), te);
                case "quoteDouble":
                case "quoteSingle": {
                  let W = "'", X = '"', ue = te.originalText.slice(R.position.start.offset + 1, R.position.end.offset - 1);
                  if (R.type === "quoteSingle" && ue.includes("\\") || R.type === "quoteDouble" && /\\[^"]/.test(ue)) {
                    let ie = R.type === "quoteDouble" ? X : W;
                    return [ie, Y(R.type, ue, te), ie];
                  }
                  if (ue.includes(X))
                    return [W, Y(R.type, R.type === "quoteDouble" ? ue.replace(/\\"/g, X).replace(/'/g, W.repeat(2)) : ue, te), W];
                  if (ue.includes(W))
                    return [X, Y(R.type, R.type === "quoteSingle" ? ue.replace(/''/g, W) : ue, te), X];
                  let De = te.singleQuote ? W : X;
                  return [De, Y(R.type, ue, te), De];
                }
                case "blockFolded":
                case "blockLiteral":
                  return L(ee, oe, te);
                case "mapping":
                case "sequence":
                  return u(r, ee.map(oe, "children"));
                case "sequenceItem":
                  return ["- ", l(2, R.content ? oe("content") : "")];
                case "mappingKey":
                case "mappingValue":
                  return R.content ? oe("content") : "";
                case "mappingItem":
                case "flowMappingItem":
                  return b(R, Q, ee, oe, te);
                case "flowMapping":
                  return N(ee, oe, te);
                case "flowSequence":
                  return x(ee, oe, te);
                case "flowSequenceItem":
                  return oe("content");
                default:
                  throw new Error("Unexpected node type ".concat(R.type));
              }
            }
            function $(R) {
              return R.body.children.length > 0 || k(R.body);
            }
            function V(R, Q) {
              return I(R) || Q && (Q.head.children.length > 0 || k(Q.head));
            }
            function q(R, Q, ee, te) {
              return ee.children[0] === R && /---(?:\s|$)/.test(te.originalText.slice(h(R), h(R) + 4)) || R.head.children.length > 0 || k(R.head) || I(R.head) ? "head" : V(R, Q) ? false : Q ? "root" : false;
            }
            function Y(R, Q, ee) {
              let te = T(R, Q, ee);
              return u(r, te.map((oe) => s(v(u(i, oe)))));
            }
            function H(R, Q) {
              if (D(Q))
                switch (delete Q.position, Q.type) {
                  case "comment":
                    if (f(Q.value))
                      return null;
                    break;
                  case "quoteDouble":
                  case "quoteSingle":
                    Q.type = "quote";
                    break;
                }
            }
            n.exports = { preprocess: F, embed: w, print: M, massageAstNode: H, insertPragma: p };
          } }), Fg = Z({ "src/language-yaml/options.js"(e, n) {
            "use strict";
            re();
            var t3 = Ot();
            n.exports = { bracketSpacing: t3.bracketSpacing, singleQuote: t3.singleQuote, proseWrap: t3.proseWrap };
          } }), Ag = Z({ "src/language-yaml/parsers.js"() {
            re();
          } }), Sg = Z({ "node_modules/linguist-languages/data/YAML.json"(e, n) {
            n.exports = { name: "YAML", type: "data", color: "#cb171e", tmScope: "source.yaml", aliases: ["yml"], extensions: [".yml", ".mir", ".reek", ".rviz", ".sublime-syntax", ".syntax", ".yaml", ".yaml-tmlanguage", ".yaml.sed", ".yml.mysql"], filenames: [".clang-format", ".clang-tidy", ".gemrc", "CITATION.cff", "glide.lock", "yarn.lock"], aceMode: "yaml", codemirrorMode: "yaml", codemirrorMimeType: "text/x-yaml", languageId: 407 };
          } }), xg = Z({ "src/language-yaml/index.js"(e, n) {
            "use strict";
            re();
            var t3 = Bt(), s = Eg(), a = Fg(), r = Ag(), u = [t3(Sg(), (i) => ({ since: "1.14.0", parsers: ["yaml"], vscodeLanguageIds: ["yaml", "ansible", "home-assistant"], filenames: [...i.filenames.filter((o) => o !== "yarn.lock"), ".prettierrc", ".stylelintrc"] }))];
            n.exports = { languages: u, printers: { yaml: s }, options: a, parsers: r };
          } }), bg = Z({ "src/languages.js"(e, n) {
            "use strict";
            re(), n.exports = [id(), Sd(), Pd(), Md(), Ud(), Dg(), xg()];
          } });
          re();
          var { version: Tg } = ya(), kt = Sm(), { getSupportInfo: Bg } = Mn(), Ng = xm(), wg = bg(), _g = Oe();
          function bt(e) {
            let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            return function() {
              for (var t3 = arguments.length, s = new Array(t3), a = 0; a < t3; a++)
                s[a] = arguments[a];
              let r = s[n] || {}, u = r.plugins || [];
              return s[n] = Object.assign(Object.assign({}, r), {}, { plugins: [...wg, ...Array.isArray(u) ? u : Object.values(u)] }), e(...s);
            };
          }
          var bn = bt(kt.formatWithCursor);
          Co.exports = { formatWithCursor: bn, format(e, n) {
            return bn(e, n).formatted;
          }, check(e, n) {
            let { formatted: t3 } = bn(e, n);
            return t3 === e;
          }, doc: _g, getSupportInfo: bt(Bg, 0), version: Tg, util: Ng, __debug: { parse: bt(kt.parse), formatAST: bt(kt.formatAST), formatDoc: bt(kt.formatDoc), printToDoc: bt(kt.printToDoc), printDocToString: bt(kt.printDocToString) } };
        });
        return Pg();
      });
    }
  });

  // node_modules/prettier/parser-babel.js
  var require_parser_babel = __commonJS({
    "node_modules/prettier/parser-babel.js"(exports2, module2) {
      init_define_process();
      (function(e) {
        if (typeof exports2 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var i = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          i.prettierPlugins = i.prettierPlugins || {}, i.prettierPlugins.babel = e();
        }
      })(function() {
        "use strict";
        var b = (h, l) => () => (l || h((l = { exports: {} }).exports, l), l.exports);
        var G = b((zf, Jr) => {
          var Tt = function(h) {
            return h && h.Math == Math && h;
          };
          Jr.exports = Tt(typeof globalThis == "object" && globalThis) || Tt(typeof window == "object" && window) || Tt(typeof self == "object" && self) || Tt(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var Ae = b((Kf, Yr) => {
          Yr.exports = function(h) {
            try {
              return !!h();
            } catch {
              return true;
            }
          };
        });
        var ke = b((Vf, $r) => {
          var hl = Ae();
          $r.exports = !hl(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var Et = b((Hf, Qr) => {
          var ll = Ae();
          Qr.exports = !ll(function() {
            var h = function() {
            }.bind();
            return typeof h != "function" || h.hasOwnProperty("prototype");
          });
        });
        var bt = b((Wf, Zr) => {
          var ul = Et(), Ct = Function.prototype.call;
          Zr.exports = ul ? Ct.bind(Ct) : function() {
            return Ct.apply(Ct, arguments);
          };
        });
        var ri = b((si) => {
          "use strict";
          var ei = {}.propertyIsEnumerable, ti = Object.getOwnPropertyDescriptor, cl = ti && !ei.call({ 1: 2 }, 1);
          si.f = cl ? function(l) {
            var p = ti(this, l);
            return !!p && p.enumerable;
          } : ei;
        });
        var ms = b((Xf, ii) => {
          ii.exports = function(h, l) {
            return { enumerable: !(h & 1), configurable: !(h & 2), writable: !(h & 4), value: l };
          };
        });
        var ie = b((Jf, oi) => {
          var ai = Et(), ni = Function.prototype, pl = ni.bind, ys = ni.call, fl = ai && pl.bind(ys, ys);
          oi.exports = ai ? function(h) {
            return h && fl(h);
          } : function(h) {
            return h && function() {
              return ys.apply(h, arguments);
            };
          };
        });
        var vt = b((Yf, li) => {
          var hi = ie(), dl = hi({}.toString), ml = hi("".slice);
          li.exports = function(h) {
            return ml(dl(h), 8, -1);
          };
        });
        var ci = b(($f, ui) => {
          var yl = G(), xl = ie(), gl = Ae(), Al = vt(), xs = yl.Object, Pl = xl("".split);
          ui.exports = gl(function() {
            return !xs("z").propertyIsEnumerable(0);
          }) ? function(h) {
            return Al(h) == "String" ? Pl(h, "") : xs(h);
          } : xs;
        });
        var gs = b((Qf, pi) => {
          var Tl = G(), El = Tl.TypeError;
          pi.exports = function(h) {
            if (h == null)
              throw El("Can't call method on " + h);
            return h;
          };
        });
        var St = b((Zf, fi) => {
          var Cl = ci(), bl = gs();
          fi.exports = function(h) {
            return Cl(bl(h));
          };
        });
        var ae = b((ed, di) => {
          di.exports = function(h) {
            return typeof h == "function";
          };
        });
        var De = b((td, mi) => {
          var vl = ae();
          mi.exports = function(h) {
            return typeof h == "object" ? h !== null : vl(h);
          };
        });
        var Qe = b((sd, yi) => {
          var As = G(), Sl = ae(), wl = function(h) {
            return Sl(h) ? h : void 0;
          };
          yi.exports = function(h, l) {
            return arguments.length < 2 ? wl(As[h]) : As[h] && As[h][l];
          };
        });
        var gi = b((rd, xi) => {
          var Nl = ie();
          xi.exports = Nl({}.isPrototypeOf);
        });
        var Pi = b((id, Ai) => {
          var Il = Qe();
          Ai.exports = Il("navigator", "userAgent") || "";
        });
        var wi = b((ad, Si) => {
          var vi = G(), Ps = Pi(), Ti = vi.process, Ei = vi.Deno, Ci = Ti && Ti.versions || Ei && Ei.version, bi = Ci && Ci.v8, oe, wt;
          bi && (oe = bi.split("."), wt = oe[0] > 0 && oe[0] < 4 ? 1 : +(oe[0] + oe[1]));
          !wt && Ps && (oe = Ps.match(/Edge\/(\d+)/), (!oe || oe[1] >= 74) && (oe = Ps.match(/Chrome\/(\d+)/), oe && (wt = +oe[1])));
          Si.exports = wt;
        });
        var Ts = b((nd, Ii) => {
          var Ni = wi(), kl = Ae();
          Ii.exports = !!Object.getOwnPropertySymbols && !kl(function() {
            var h = Symbol();
            return !String(h) || !(Object(h) instanceof Symbol) || !Symbol.sham && Ni && Ni < 41;
          });
        });
        var Es = b((od, ki) => {
          var Dl = Ts();
          ki.exports = Dl && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var Cs = b((hd, Di) => {
          var Fl = G(), Ll = Qe(), Ol = ae(), Bl = gi(), Ml = Es(), Rl = Fl.Object;
          Di.exports = Ml ? function(h) {
            return typeof h == "symbol";
          } : function(h) {
            var l = Ll("Symbol");
            return Ol(l) && Bl(l.prototype, Rl(h));
          };
        });
        var Li = b((ld, Fi) => {
          var jl = G(), ql = jl.String;
          Fi.exports = function(h) {
            try {
              return ql(h);
            } catch {
              return "Object";
            }
          };
        });
        var Nt = b((ud, Oi) => {
          var Ul = G(), _l = ae(), zl = Li(), Kl = Ul.TypeError;
          Oi.exports = function(h) {
            if (_l(h))
              return h;
            throw Kl(zl(h) + " is not a function");
          };
        });
        var Mi = b((cd, Bi) => {
          var Vl = Nt();
          Bi.exports = function(h, l) {
            var p = h[l];
            return p == null ? void 0 : Vl(p);
          };
        });
        var ji = b((pd, Ri) => {
          var Hl = G(), bs = bt(), vs = ae(), Ss = De(), Wl = Hl.TypeError;
          Ri.exports = function(h, l) {
            var p, d;
            if (l === "string" && vs(p = h.toString) && !Ss(d = bs(p, h)) || vs(p = h.valueOf) && !Ss(d = bs(p, h)) || l !== "string" && vs(p = h.toString) && !Ss(d = bs(p, h)))
              return d;
            throw Wl("Can't convert object to primitive value");
          };
        });
        var Ui = b((fd, qi) => {
          qi.exports = false;
        });
        var It = b((dd, zi) => {
          var _i = G(), Gl = Object.defineProperty;
          zi.exports = function(h, l) {
            try {
              Gl(_i, h, { value: l, configurable: true, writable: true });
            } catch {
              _i[h] = l;
            }
            return l;
          };
        });
        var kt = b((md, Vi) => {
          var Xl = G(), Jl = It(), Ki = "__core-js_shared__", Yl = Xl[Ki] || Jl(Ki, {});
          Vi.exports = Yl;
        });
        var ws = b((yd, Wi) => {
          var $l = Ui(), Hi = kt();
          (Wi.exports = function(h, l) {
            return Hi[h] || (Hi[h] = l !== void 0 ? l : {});
          })("versions", []).push({ version: "3.22.2", mode: $l ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.22.2/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var Ns = b((xd, Gi) => {
          var Ql = G(), Zl = gs(), eu = Ql.Object;
          Gi.exports = function(h) {
            return eu(Zl(h));
          };
        });
        var be = b((gd, Xi) => {
          var tu = ie(), su = Ns(), ru = tu({}.hasOwnProperty);
          Xi.exports = Object.hasOwn || function(l, p) {
            return ru(su(l), p);
          };
        });
        var Is = b((Ad, Ji) => {
          var iu = ie(), au = 0, nu = Math.random(), ou = iu(1 .toString);
          Ji.exports = function(h) {
            return "Symbol(" + (h === void 0 ? "" : h) + ")_" + ou(++au + nu, 36);
          };
        });
        var Ze = b((Pd, ea) => {
          var hu = G(), lu = ws(), Yi = be(), uu = Is(), $i = Ts(), Zi = Es(), _e = lu("wks"), Fe = hu.Symbol, Qi = Fe && Fe.for, cu = Zi ? Fe : Fe && Fe.withoutSetter || uu;
          ea.exports = function(h) {
            if (!Yi(_e, h) || !($i || typeof _e[h] == "string")) {
              var l = "Symbol." + h;
              $i && Yi(Fe, h) ? _e[h] = Fe[h] : Zi && Qi ? _e[h] = Qi(l) : _e[h] = cu(l);
            }
            return _e[h];
          };
        });
        var ia = b((Td, ra) => {
          var pu = G(), fu = bt(), ta = De(), sa = Cs(), du = Mi(), mu = ji(), yu = Ze(), xu = pu.TypeError, gu = yu("toPrimitive");
          ra.exports = function(h, l) {
            if (!ta(h) || sa(h))
              return h;
            var p = du(h, gu), d;
            if (p) {
              if (l === void 0 && (l = "default"), d = fu(p, h, l), !ta(d) || sa(d))
                return d;
              throw xu("Can't convert object to primitive value");
            }
            return l === void 0 && (l = "number"), mu(h, l);
          };
        });
        var ks = b((Ed, aa) => {
          var Au = ia(), Pu = Cs();
          aa.exports = function(h) {
            var l = Au(h, "string");
            return Pu(l) ? l : l + "";
          };
        });
        var ha = b((Cd, oa) => {
          var Tu = G(), na = De(), Ds = Tu.document, Eu = na(Ds) && na(Ds.createElement);
          oa.exports = function(h) {
            return Eu ? Ds.createElement(h) : {};
          };
        });
        var Fs = b((bd, la) => {
          var Cu = ke(), bu = Ae(), vu = ha();
          la.exports = !Cu && !bu(function() {
            return Object.defineProperty(vu("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var Ls = b((ca) => {
          var Su = ke(), wu = bt(), Nu = ri(), Iu = ms(), ku = St(), Du = ks(), Fu = be(), Lu = Fs(), ua = Object.getOwnPropertyDescriptor;
          ca.f = Su ? ua : function(l, p) {
            if (l = ku(l), p = Du(p), Lu)
              try {
                return ua(l, p);
              } catch {
              }
            if (Fu(l, p))
              return Iu(!wu(Nu.f, l, p), l[p]);
          };
        });
        var fa = b((Sd, pa) => {
          var Ou = ke(), Bu = Ae();
          pa.exports = Ou && Bu(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var Os = b((wd, ma) => {
          var da = G(), Mu = De(), Ru = da.String, ju = da.TypeError;
          ma.exports = function(h) {
            if (Mu(h))
              return h;
            throw ju(Ru(h) + " is not an object");
          };
        });
        var qs = b((xa) => {
          var qu = G(), Uu = ke(), _u = Fs(), zu = fa(), Dt = Os(), ya = ks(), Ku = qu.TypeError, Bs = Object.defineProperty, Vu = Object.getOwnPropertyDescriptor, Ms = "enumerable", Rs = "configurable", js = "writable";
          xa.f = Uu ? zu ? function(l, p, d) {
            if (Dt(l), p = ya(p), Dt(d), typeof l == "function" && p === "prototype" && "value" in d && js in d && !d[js]) {
              var m = Vu(l, p);
              m && m[js] && (l[p] = d.value, d = { configurable: Rs in d ? d[Rs] : m[Rs], enumerable: Ms in d ? d[Ms] : m[Ms], writable: false });
            }
            return Bs(l, p, d);
          } : Bs : function(l, p, d) {
            if (Dt(l), p = ya(p), Dt(d), _u)
              try {
                return Bs(l, p, d);
              } catch {
              }
            if ("get" in d || "set" in d)
              throw Ku("Accessors not supported");
            return "value" in d && (l[p] = d.value), l;
          };
        });
        var Ft = b((Id, ga) => {
          var Hu = ke(), Wu = qs(), Gu = ms();
          ga.exports = Hu ? function(h, l, p) {
            return Wu.f(h, l, Gu(1, p));
          } : function(h, l, p) {
            return h[l] = p, h;
          };
        });
        var Lt = b((kd, Aa) => {
          var Xu = ie(), Ju = ae(), Us = kt(), Yu = Xu(Function.toString);
          Ju(Us.inspectSource) || (Us.inspectSource = function(h) {
            return Yu(h);
          });
          Aa.exports = Us.inspectSource;
        });
        var Ea = b((Dd, Ta) => {
          var $u = G(), Qu = ae(), Zu = Lt(), Pa = $u.WeakMap;
          Ta.exports = Qu(Pa) && /native code/.test(Zu(Pa));
        });
        var va = b((Fd, ba) => {
          var ec = ws(), tc = Is(), Ca = ec("keys");
          ba.exports = function(h) {
            return Ca[h] || (Ca[h] = tc(h));
          };
        });
        var _s = b((Ld, Sa) => {
          Sa.exports = {};
        });
        var Fa = b((Od, Da) => {
          var sc = Ea(), ka = G(), zs = ie(), rc = De(), ic = Ft(), Ks = be(), Vs = kt(), ac = va(), nc = _s(), wa = "Object already initialized", Ws = ka.TypeError, oc = ka.WeakMap, Ot, et, Bt, hc = function(h) {
            return Bt(h) ? et(h) : Ot(h, {});
          }, lc = function(h) {
            return function(l) {
              var p;
              if (!rc(l) || (p = et(l)).type !== h)
                throw Ws("Incompatible receiver, " + h + " required");
              return p;
            };
          };
          sc || Vs.state ? (ve = Vs.state || (Vs.state = new oc()), Na = zs(ve.get), Hs = zs(ve.has), Ia = zs(ve.set), Ot = function(h, l) {
            if (Hs(ve, h))
              throw new Ws(wa);
            return l.facade = h, Ia(ve, h, l), l;
          }, et = function(h) {
            return Na(ve, h) || {};
          }, Bt = function(h) {
            return Hs(ve, h);
          }) : (Le = ac("state"), nc[Le] = true, Ot = function(h, l) {
            if (Ks(h, Le))
              throw new Ws(wa);
            return l.facade = h, ic(h, Le, l), l;
          }, et = function(h) {
            return Ks(h, Le) ? h[Le] : {};
          }, Bt = function(h) {
            return Ks(h, Le);
          });
          var ve, Na, Hs, Ia, Le;
          Da.exports = { set: Ot, get: et, has: Bt, enforce: hc, getterFor: lc };
        });
        var Ba = b((Bd, Oa) => {
          var Gs = ke(), uc = be(), La = Function.prototype, cc = Gs && Object.getOwnPropertyDescriptor, Xs = uc(La, "name"), pc = Xs && function() {
          }.name === "something", fc = Xs && (!Gs || Gs && cc(La, "name").configurable);
          Oa.exports = { EXISTS: Xs, PROPER: pc, CONFIGURABLE: fc };
        });
        var Ua = b((Md, qa) => {
          var dc = G(), Ma = ae(), mc = be(), Ra = Ft(), yc = It(), xc = Lt(), ja = Fa(), gc = Ba().CONFIGURABLE, Ac = ja.get, Pc = ja.enforce, Tc = String(String).split("String");
          (qa.exports = function(h, l, p, d) {
            var m = d ? !!d.unsafe : false, A = d ? !!d.enumerable : false, g = d ? !!d.noTargetGet : false, x = d && d.name !== void 0 ? d.name : l, T;
            if (Ma(p) && (String(x).slice(0, 7) === "Symbol(" && (x = "[" + String(x).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!mc(p, "name") || gc && p.name !== x) && Ra(p, "name", x), T = Pc(p), T.source || (T.source = Tc.join(typeof x == "string" ? x : ""))), h === dc) {
              A ? h[l] = p : yc(l, p);
              return;
            } else
              m ? !g && h[l] && (A = true) : delete h[l];
            A ? h[l] = p : Ra(h, l, p);
          })(Function.prototype, "toString", function() {
            return Ma(this) && Ac(this).source || xc(this);
          });
        });
        var Js = b((Rd, _a) => {
          var Ec = Math.ceil, Cc = Math.floor;
          _a.exports = function(h) {
            var l = +h;
            return l !== l || l === 0 ? 0 : (l > 0 ? Cc : Ec)(l);
          };
        });
        var Ka = b((jd, za) => {
          var bc = Js(), vc = Math.max, Sc = Math.min;
          za.exports = function(h, l) {
            var p = bc(h);
            return p < 0 ? vc(p + l, 0) : Sc(p, l);
          };
        });
        var Ha = b((qd, Va) => {
          var wc = Js(), Nc = Math.min;
          Va.exports = function(h) {
            return h > 0 ? Nc(wc(h), 9007199254740991) : 0;
          };
        });
        var Mt = b((Ud, Wa) => {
          var Ic = Ha();
          Wa.exports = function(h) {
            return Ic(h.length);
          };
        });
        var Ja = b((_d, Xa) => {
          var kc = St(), Dc = Ka(), Fc = Mt(), Ga = function(h) {
            return function(l, p, d) {
              var m = kc(l), A = Fc(m), g = Dc(d, A), x;
              if (h && p != p) {
                for (; A > g; )
                  if (x = m[g++], x != x)
                    return true;
              } else
                for (; A > g; g++)
                  if ((h || g in m) && m[g] === p)
                    return h || g || 0;
              return !h && -1;
            };
          };
          Xa.exports = { includes: Ga(true), indexOf: Ga(false) };
        });
        var Qa = b((zd, $a) => {
          var Lc = ie(), Ys = be(), Oc = St(), Bc = Ja().indexOf, Mc = _s(), Ya = Lc([].push);
          $a.exports = function(h, l) {
            var p = Oc(h), d = 0, m = [], A;
            for (A in p)
              !Ys(Mc, A) && Ys(p, A) && Ya(m, A);
            for (; l.length > d; )
              Ys(p, A = l[d++]) && (~Bc(m, A) || Ya(m, A));
            return m;
          };
        });
        var en = b((Kd, Za) => {
          Za.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var sn = b((tn) => {
          var Rc = Qa(), jc = en(), qc = jc.concat("length", "prototype");
          tn.f = Object.getOwnPropertyNames || function(l) {
            return Rc(l, qc);
          };
        });
        var an = b((rn) => {
          rn.f = Object.getOwnPropertySymbols;
        });
        var on = b((Wd, nn) => {
          var Uc = Qe(), _c = ie(), zc = sn(), Kc = an(), Vc = Os(), Hc = _c([].concat);
          nn.exports = Uc("Reflect", "ownKeys") || function(l) {
            var p = zc.f(Vc(l)), d = Kc.f;
            return d ? Hc(p, d(l)) : p;
          };
        });
        var un = b((Gd, ln) => {
          var hn = be(), Wc = on(), Gc = Ls(), Xc = qs();
          ln.exports = function(h, l, p) {
            for (var d = Wc(l), m = Xc.f, A = Gc.f, g = 0; g < d.length; g++) {
              var x = d[g];
              !hn(h, x) && !(p && hn(p, x)) && m(h, x, A(l, x));
            }
          };
        });
        var pn = b((Xd, cn) => {
          var Jc = Ae(), Yc = ae(), $c = /#|\.prototype\./, tt = function(h, l) {
            var p = Zc[Qc(h)];
            return p == tp ? true : p == ep ? false : Yc(l) ? Jc(l) : !!l;
          }, Qc = tt.normalize = function(h) {
            return String(h).replace($c, ".").toLowerCase();
          }, Zc = tt.data = {}, ep = tt.NATIVE = "N", tp = tt.POLYFILL = "P";
          cn.exports = tt;
        });
        var Qs = b((Jd, fn) => {
          var $s = G(), sp = Ls().f, rp = Ft(), ip = Ua(), ap = It(), np = un(), op = pn();
          fn.exports = function(h, l) {
            var p = h.target, d = h.global, m = h.stat, A, g, x, T, k, D;
            if (d ? g = $s : m ? g = $s[p] || ap(p, {}) : g = ($s[p] || {}).prototype, g)
              for (x in l) {
                if (k = l[x], h.noTargetGet ? (D = sp(g, x), T = D && D.value) : T = g[x], A = op(d ? x : p + (m ? "." : "#") + x, h.forced), !A && T !== void 0) {
                  if (typeof k == typeof T)
                    continue;
                  np(k, T);
                }
                (h.sham || T && T.sham) && rp(k, "sham", true), ip(g, x, k, h);
              }
          };
        });
        var dn = b(() => {
          var hp = Qs(), lp = G();
          hp({ global: true }, { globalThis: lp });
        });
        var mn = b(() => {
          dn();
        });
        var Zs = b((em, yn) => {
          var up = vt();
          yn.exports = Array.isArray || function(l) {
            return up(l) == "Array";
          };
        });
        var An = b((tm, gn) => {
          var xn = ie(), cp = Nt(), pp = Et(), fp = xn(xn.bind);
          gn.exports = function(h, l) {
            return cp(h), l === void 0 ? h : pp ? fp(h, l) : function() {
              return h.apply(l, arguments);
            };
          };
        });
        var En = b((sm, Tn) => {
          "use strict";
          var dp = G(), mp = Zs(), yp = Mt(), xp = An(), gp = dp.TypeError, Pn = function(h, l, p, d, m, A, g, x) {
            for (var T = m, k = 0, D = g ? xp(g, x) : false, E, L; k < d; ) {
              if (k in p) {
                if (E = D ? D(p[k], k, l) : p[k], A > 0 && mp(E))
                  L = yp(E), T = Pn(h, l, E, L, T, A - 1) - 1;
                else {
                  if (T >= 9007199254740991)
                    throw gp("Exceed the acceptable array length");
                  h[T] = E;
                }
                T++;
              }
              k++;
            }
            return T;
          };
          Tn.exports = Pn;
        });
        var vn = b((rm, bn) => {
          var Ap = Ze(), Pp = Ap("toStringTag"), Cn = {};
          Cn[Pp] = "z";
          bn.exports = String(Cn) === "[object z]";
        });
        var wn = b((im, Sn) => {
          var Tp = G(), Ep = vn(), Cp = ae(), Rt = vt(), bp = Ze(), vp = bp("toStringTag"), Sp = Tp.Object, wp = Rt(function() {
            return arguments;
          }()) == "Arguments", Np = function(h, l) {
            try {
              return h[l];
            } catch {
            }
          };
          Sn.exports = Ep ? Rt : function(h) {
            var l, p, d;
            return h === void 0 ? "Undefined" : h === null ? "Null" : typeof (p = Np(l = Sp(h), vp)) == "string" ? p : wp ? Rt(l) : (d = Rt(l)) == "Object" && Cp(l.callee) ? "Arguments" : d;
          };
        });
        var Ln = b((am, Fn) => {
          var Ip = ie(), kp = Ae(), Nn = ae(), Dp = wn(), Fp = Qe(), Lp = Lt(), In = function() {
          }, Op = [], kn = Fp("Reflect", "construct"), er = /^\s*(?:class|function)\b/, Bp = Ip(er.exec), Mp = !er.exec(In), st = function(l) {
            if (!Nn(l))
              return false;
            try {
              return kn(In, Op, l), true;
            } catch {
              return false;
            }
          }, Dn = function(l) {
            if (!Nn(l))
              return false;
            switch (Dp(l)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return false;
            }
            try {
              return Mp || !!Bp(er, Lp(l));
            } catch {
              return true;
            }
          };
          Dn.sham = true;
          Fn.exports = !kn || kp(function() {
            var h;
            return st(st.call) || !st(Object) || !st(function() {
              h = true;
            }) || h;
          }) ? Dn : st;
        });
        var Rn = b((nm2, Mn) => {
          var Rp = G(), On = Zs(), jp = Ln(), qp = De(), Up = Ze(), _p = Up("species"), Bn = Rp.Array;
          Mn.exports = function(h) {
            var l;
            return On(h) && (l = h.constructor, jp(l) && (l === Bn || On(l.prototype)) ? l = void 0 : qp(l) && (l = l[_p], l === null && (l = void 0))), l === void 0 ? Bn : l;
          };
        });
        var qn = b((om, jn) => {
          var zp = Rn();
          jn.exports = function(h, l) {
            return new (zp(h))(l === 0 ? 0 : l);
          };
        });
        var Un = b(() => {
          "use strict";
          var Kp = Qs(), Vp = En(), Hp = Nt(), Wp = Ns(), Gp = Mt(), Xp = qn();
          Kp({ target: "Array", proto: true }, { flatMap: function(l) {
            var p = Wp(this), d = Gp(p), m;
            return Hp(l), m = Xp(p, 0), m.length = Vp(m, p, p, d, 0, 1, l, arguments.length > 1 ? arguments[1] : void 0), m;
          } });
        });
        var qf = b((um, Eo) => {
          var _n, zn, Kn, Vn, Hn;
          function rt(h, l) {
            return l || (l = h.slice(0)), Object.freeze(Object.defineProperties(h, { raw: { value: Object.freeze(l) } }));
          }
          mn();
          Un();
          var ir = Object.defineProperty, Jp = Object.getOwnPropertyDescriptor, ar = Object.getOwnPropertyNames, Yp = Object.prototype.hasOwnProperty, $n = (h, l) => function() {
            return h && (l = (0, h[ar(h)[0]])(h = 0)), l;
          }, H = (h, l) => function() {
            return l || (0, h[ar(h)[0]])((l = { exports: {} }).exports, l), l.exports;
          }, $p = (h, l) => {
            for (var p in l)
              ir(h, p, { get: l[p], enumerable: true });
          }, Qp = (h, l, p, d) => {
            if (l && typeof l == "object" || typeof l == "function")
              for (let m of ar(l))
                !Yp.call(h, m) && m !== p && ir(h, m, { get: () => l[m], enumerable: !(d = Jp(l, m)) || d.enumerable });
            return h;
          }, Zp = (h) => Qp(ir({}, "__esModule", { value: true }), h), V = $n({ "<define:process>"() {
          } }), ef = H({ "src/utils/try-combinations.js"(h, l) {
            "use strict";
            V();
            function p() {
              let d;
              for (var m = arguments.length, A = new Array(m), g = 0; g < m; g++)
                A[g] = arguments[g];
              for (let [x, T] of A.entries())
                try {
                  return { result: T() };
                } catch (k) {
                  x === 0 && (d = k);
                }
              return { error: d };
            }
            l.exports = p;
          } }), Qn = H({ "src/language-js/utils/get-shebang.js"(h, l) {
            "use strict";
            V();
            function p(d) {
              if (!d.startsWith("#!"))
                return "";
              let m = d.indexOf(`
`);
              return m === -1 ? d : d.slice(0, m);
            }
            l.exports = p;
          } }), tf = H({ "src/utils/text/skip-inline-comment.js"(h, l) {
            "use strict";
            V();
            function p(d, m) {
              if (m === false)
                return false;
              if (d.charAt(m) === "/" && d.charAt(m + 1) === "*") {
                for (let A = m + 2; A < d.length; ++A)
                  if (d.charAt(A) === "*" && d.charAt(A + 1) === "/")
                    return A + 2;
              }
              return m;
            }
            l.exports = p;
          } }), sf = H({ "src/utils/text/skip-newline.js"(h, l) {
            "use strict";
            V();
            function p(d, m, A) {
              let g = A && A.backwards;
              if (m === false)
                return false;
              let x = d.charAt(m);
              if (g) {
                if (d.charAt(m - 1) === "\r" && x === `
`)
                  return m - 2;
                if (x === `
` || x === "\r" || x === "\u2028" || x === "\u2029")
                  return m - 1;
              } else {
                if (x === "\r" && d.charAt(m + 1) === `
`)
                  return m + 2;
                if (x === `
` || x === "\r" || x === "\u2028" || x === "\u2029")
                  return m + 1;
              }
              return m;
            }
            l.exports = p;
          } }), Zn = H({ "src/utils/text/skip.js"(h, l) {
            "use strict";
            V();
            function p(x) {
              return (T, k, D) => {
                let E = D && D.backwards;
                if (k === false)
                  return false;
                let { length: L } = T, R = k;
                for (; R >= 0 && R < L; ) {
                  let F = T.charAt(R);
                  if (x instanceof RegExp) {
                    if (!x.test(F))
                      return R;
                  } else if (!x.includes(F))
                    return R;
                  E ? R-- : R++;
                }
                return R === -1 || R === L ? R : false;
              };
            }
            var d = p(/\s/), m = p(" 	"), A = p(",; 	"), g = p(/[^\n\r]/);
            l.exports = { skipWhitespace: d, skipSpaces: m, skipToLineEnd: A, skipEverythingButNewLine: g };
          } }), rf = H({ "src/utils/text/skip-trailing-comment.js"(h, l) {
            "use strict";
            V();
            var { skipEverythingButNewLine: p } = Zn();
            function d(m, A) {
              return A === false ? false : m.charAt(A) === "/" && m.charAt(A + 1) === "/" ? p(m, A) : A;
            }
            l.exports = d;
          } }), af = H({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(h, l) {
            "use strict";
            V();
            var p = tf(), d = sf(), m = rf(), { skipSpaces: A } = Zn();
            function g(x, T) {
              let k = null, D = T;
              for (; D !== k; )
                k = D, D = A(x, D), D = p(x, D), D = m(x, D), D = d(x, D);
              return D;
            }
            l.exports = g;
          } }), eo = {};
          $p(eo, { EOL: () => rr, arch: () => nf, cpus: () => oo, default: () => po, endianness: () => to, freemem: () => ao, getNetworkInterfaces: () => co, hostname: () => so, loadavg: () => ro, networkInterfaces: () => uo, platform: () => of, release: () => lo, tmpDir: () => tr, tmpdir: () => sr, totalmem: () => no, type: () => ho, uptime: () => io });
          function to() {
            if (typeof jt > "u") {
              var h = new ArrayBuffer(2), l = new Uint8Array(h), p = new Uint16Array(h);
              if (l[0] = 1, l[1] = 2, p[0] === 258)
                jt = "BE";
              else if (p[0] === 513)
                jt = "LE";
              else
                throw new Error("unable to figure out endianess");
            }
            return jt;
          }
          function so() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
          }
          function ro() {
            return [];
          }
          function io() {
            return 0;
          }
          function ao() {
            return Number.MAX_VALUE;
          }
          function no() {
            return Number.MAX_VALUE;
          }
          function oo() {
            return [];
          }
          function ho() {
            return "Browser";
          }
          function lo() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
          }
          function uo() {
          }
          function co() {
          }
          function nf() {
            return "javascript";
          }
          function of() {
            return "browser";
          }
          function tr() {
            return "/tmp";
          }
          var jt, sr, rr, po, hf = $n({ "node-modules-polyfills:os"() {
            V(), sr = tr, rr = `
`, po = { EOL: rr, tmpdir: sr, tmpDir: tr, networkInterfaces: uo, getNetworkInterfaces: co, release: lo, type: ho, cpus: oo, totalmem: no, freemem: ao, uptime: io, loadavg: ro, hostname: so, endianness: to };
          } }), lf = H({ "node-modules-polyfills-commonjs:os"(h, l) {
            V();
            var p = (hf(), Zp(eo));
            if (p && p.default) {
              l.exports = p.default;
              for (let d in p)
                l.exports[d] = p[d];
            } else
              p && (l.exports = p);
          } }), uf = H({ "node_modules/detect-newline/index.js"(h, l) {
            "use strict";
            V();
            var p = (d) => {
              if (typeof d != "string")
                throw new TypeError("Expected a string");
              let m = d.match(/(?:\r?\n)/g) || [];
              if (m.length === 0)
                return;
              let A = m.filter((x) => x === `\r
`).length, g = m.length - A;
              return A > g ? `\r
` : `
`;
            };
            l.exports = p, l.exports.graceful = (d) => typeof d == "string" && p(d) || `
`;
          } }), cf = H({ "node_modules/jest-docblock/build/index.js"(h) {
            "use strict";
            V(), Object.defineProperty(h, "__esModule", { value: true }), h.extract = R, h.parse = W, h.parseWithComments = Y, h.print = M, h.strip = F;
            function l() {
              let u = lf();
              return l = function() {
                return u;
              }, u;
            }
            function p() {
              let u = d(uf());
              return p = function() {
                return u;
              }, u;
            }
            function d(u) {
              return u && u.__esModule ? u : { default: u };
            }
            var m = /\*\/$/, A = /^\/\*\*/, g = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, x = /(^|\s+)\/\/([^\r\n]*)/g, T = /^(\r?\n)+/, k = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, D = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, E = /(\r?\n|^) *\* ?/g, L = [];
            function R(u) {
              let X = u.match(g);
              return X ? X[0].trimLeft() : "";
            }
            function F(u) {
              let X = u.match(g);
              return X && X[0] ? u.substring(X[0].length) : u;
            }
            function W(u) {
              return Y(u).pragmas;
            }
            function Y(u) {
              let X = (0, p().default)(u) || l().EOL;
              u = u.replace(A, "").replace(m, "").replace(E, "$1");
              let se = "";
              for (; se !== u; )
                se = u, u = u.replace(k, "".concat(X, "$1 $2").concat(X));
              u = u.replace(T, "").trimRight();
              let J = /* @__PURE__ */ Object.create(null), Oe = u.replace(D, "").replace(T, "").trimRight(), $;
              for (; $ = D.exec(u); ) {
                let z = $[2].replace(x, "");
                typeof J[$[1]] == "string" || Array.isArray(J[$[1]]) ? J[$[1]] = L.concat(J[$[1]], z) : J[$[1]] = z;
              }
              return { comments: Oe, pragmas: J };
            }
            function M(u) {
              let { comments: X = "", pragmas: se = {} } = u, J = (0, p().default)(X) || l().EOL, Oe = "/**", $ = " *", z = " */", O = Object.keys(se), C = O.map((Z) => j(Z, se[Z])).reduce((Z, he) => Z.concat(he), []).map((Z) => $ + " " + Z + J).join("");
              if (!X) {
                if (O.length === 0)
                  return "";
                if (O.length === 1 && !Array.isArray(se[O[0]])) {
                  let Z = se[O[0]];
                  return "".concat(Oe, " ").concat(j(O[0], Z)[0]).concat(z);
                }
              }
              let Ve = X.split(J).map((Z) => "".concat($, " ").concat(Z)).join(J) + J;
              return Oe + J + (X ? Ve : "") + (X && O.length ? $ + J : "") + C + z;
            }
            function j(u, X) {
              return L.concat(X).map((se) => "@".concat(u, " ").concat(se).trim());
            }
          } }), pf = H({ "src/common/end-of-line.js"(h, l) {
            "use strict";
            V();
            function p(g) {
              let x = g.indexOf("\r");
              return x >= 0 ? g.charAt(x + 1) === `
` ? "crlf" : "cr" : "lf";
            }
            function d(g) {
              switch (g) {
                case "cr":
                  return "\r";
                case "crlf":
                  return `\r
`;
                default:
                  return `
`;
              }
            }
            function m(g, x) {
              let T;
              switch (x) {
                case `
`:
                  T = /\n/g;
                  break;
                case "\r":
                  T = /\r/g;
                  break;
                case `\r
`:
                  T = /\r\n/g;
                  break;
                default:
                  throw new Error('Unexpected "eol" '.concat(JSON.stringify(x), "."));
              }
              let k = g.match(T);
              return k ? k.length : 0;
            }
            function A(g) {
              return g.replace(/\r\n?/g, `
`);
            }
            l.exports = { guessEndOfLine: p, convertEndOfLineToChars: d, countEndOfLineChars: m, normalizeEndOfLine: A };
          } }), ff = H({ "src/language-js/pragma.js"(h, l) {
            "use strict";
            V();
            var { parseWithComments: p, strip: d, extract: m, print: A } = cf(), { normalizeEndOfLine: g } = pf(), x = Qn();
            function T(E) {
              let L = x(E);
              L && (E = E.slice(L.length + 1));
              let R = m(E), { pragmas: F, comments: W } = p(R);
              return { shebang: L, text: E, pragmas: F, comments: W };
            }
            function k(E) {
              let L = Object.keys(T(E).pragmas);
              return L.includes("prettier") || L.includes("format");
            }
            function D(E) {
              let { shebang: L, text: R, pragmas: F, comments: W } = T(E), Y = d(R), M = A({ pragmas: Object.assign({ format: "" }, F), comments: W.trimStart() });
              return (L ? "".concat(L, `
`) : "") + g(M) + (Y.startsWith(`
`) ? `
` : `

`) + Y;
            }
            l.exports = { hasPragma: k, insertPragma: D };
          } }), fo = H({ "src/utils/is-non-empty-array.js"(h, l) {
            "use strict";
            V();
            function p(d) {
              return Array.isArray(d) && d.length > 0;
            }
            l.exports = p;
          } }), mo = H({ "src/language-js/loc.js"(h, l) {
            "use strict";
            V();
            var p = fo();
            function d(T, k) {
              let { ignoreDecorators: D } = k || {};
              if (!D) {
                let E = T.declaration && T.declaration.decorators || T.decorators;
                if (p(E))
                  return d(E[0]);
              }
              return T.range ? T.range[0] : T.start;
            }
            function m(T) {
              return T.range ? T.range[1] : T.end;
            }
            function A(T, k) {
              let D = d(T);
              return Number.isInteger(D) && D === d(k);
            }
            function g(T, k) {
              let D = m(T);
              return Number.isInteger(D) && D === m(k);
            }
            function x(T, k) {
              return A(T, k) && g(T, k);
            }
            l.exports = { locStart: d, locEnd: m, hasSameLocStart: A, hasSameLoc: x };
          } }), yo = H({ "src/language-js/parse/utils/create-parser.js"(h, l) {
            "use strict";
            V();
            var { hasPragma: p } = ff(), { locStart: d, locEnd: m } = mo();
            function A(g) {
              return g = typeof g == "function" ? { parse: g } : g, Object.assign({ astFormat: "estree", hasPragma: p, locStart: d, locEnd: m }, g);
            }
            l.exports = A;
          } }), nr = H({ "src/common/parser-create-error.js"(h, l) {
            "use strict";
            V();
            function p(d, m) {
              let A = new SyntaxError(d + " (" + m.start.line + ":" + m.start.column + ")");
              return A.loc = m, A;
            }
            l.exports = p;
          } }), xo = H({ "src/language-js/parse/utils/create-babel-parse-error.js"(h, l) {
            "use strict";
            V();
            var p = nr();
            function d(m) {
              let { message: A, loc: g } = m;
              return p(A.replace(/ \(.*\)/, ""), { start: { line: g ? g.line : 0, column: g ? g.column + 1 : 0 } });
            }
            l.exports = d;
          } }), df = H({ "src/language-js/utils/is-ts-keyword-type.js"(h, l) {
            "use strict";
            V();
            function p(d) {
              let { type: m } = d;
              return m.startsWith("TS") && m.endsWith("Keyword");
            }
            l.exports = p;
          } }), mf = H({ "src/language-js/utils/is-block-comment.js"(h, l) {
            "use strict";
            V();
            var p = /* @__PURE__ */ new Set(["Block", "CommentBlock", "MultiLine"]), d = (m) => p.has(m == null ? void 0 : m.type);
            l.exports = d;
          } }), yf = H({ "src/language-js/utils/is-type-cast-comment.js"(h, l) {
            "use strict";
            V();
            var p = mf();
            function d(m) {
              return p(m) && m.value[0] === "*" && /@type\b/.test(m.value);
            }
            l.exports = d;
          } }), xf = H({ "src/utils/get-last.js"(h, l) {
            "use strict";
            V();
            var p = (d) => d[d.length - 1];
            l.exports = p;
          } }), go = H({ "src/language-js/parse/postprocess/visit-node.js"(h, l) {
            "use strict";
            V();
            function p(d, m) {
              if (Array.isArray(d)) {
                for (let A = 0; A < d.length; A++)
                  d[A] = p(d[A], m);
                return d;
              }
              if (d && typeof d == "object" && typeof d.type == "string") {
                let A = Object.keys(d);
                for (let g = 0; g < A.length; g++)
                  d[A[g]] = p(d[A[g]], m);
                return m(d) || d;
              }
              return d;
            }
            l.exports = p;
          } }), Ao = H({ "src/language-js/parse/postprocess/throw-syntax-error.js"(h, l) {
            "use strict";
            V();
            var p = nr();
            function d(m, A) {
              let { start: g, end: x } = m.loc;
              throw p(A, { start: { line: g.line, column: g.column + 1 }, end: { line: x.line, column: x.column + 1 } });
            }
            l.exports = d;
          } }), gf = H({ "src/language-js/parse/postprocess/typescript.js"(h, l) {
            "use strict";
            V();
            var p = go(), d = Ao();
            function m(x, T, k) {
              let D = x.decorators;
              if (!Array.isArray(D))
                return;
              let E = T.decorators;
              (!Array.isArray(E) || E.length !== D.length || D.some((L) => {
                let R = k.get(L);
                return !R || !E.includes(R);
              })) && d(T, "Leading decorators must be attached to a class declaration");
            }
            function A(x, T) {
              x.kind !== 167 || x.modifiers && !x.modifiers.some((E) => E.kind === 126) || x.initializer && T.value === null && d(T, "Abstract property cannot have an initializer");
            }
            function g(x, T) {
              let { esTreeNodeToTSNodeMap: k, tsNodeToESTreeNodeMap: D } = T.tsParseResult;
              p(x, (E) => {
                let L = k.get(E);
                if (!L)
                  return;
                let R = D.get(L);
                R === E && (m(L, R, D), A(L, R));
              });
            }
            l.exports = { throwErrorForInvalidNodes: g };
          } }), Af = H({ "src/language-js/parse/postprocess/index.js"(h, l) {
            "use strict";
            V();
            var { locStart: p, locEnd: d } = mo(), m = df(), A = yf(), g = xf(), x = go(), { throwErrorForInvalidNodes: T } = gf(), k = Ao();
            function D(F, W) {
              if (W.parser === "typescript" && /@|abstract/.test(W.originalText) && T(F, W), W.parser !== "typescript" && W.parser !== "flow" && W.parser !== "acorn" && W.parser !== "espree" && W.parser !== "meriyah") {
                let M = /* @__PURE__ */ new Set();
                F = x(F, (j) => {
                  j.leadingComments && j.leadingComments.some(A) && M.add(p(j));
                }), F = x(F, (j) => {
                  if (j.type === "ParenthesizedExpression") {
                    let { expression: u } = j;
                    if (u.type === "TypeCastExpression")
                      return u.range = j.range, u;
                    let X = p(j);
                    if (!M.has(X))
                      return u.extra = Object.assign(Object.assign({}, u.extra), {}, { parenthesized: true }), u;
                  }
                });
              }
              return F = x(F, (M) => {
                switch (M.type) {
                  case "ChainExpression":
                    return E(M.expression);
                  case "LogicalExpression": {
                    if (L(M))
                      return R(M);
                    break;
                  }
                  case "VariableDeclaration": {
                    let j = g(M.declarations);
                    j && j.init && Y(M, j);
                    break;
                  }
                  case "TSParenthesizedType":
                    return m(M.typeAnnotation) || M.typeAnnotation.type === "TSThisType" || (M.typeAnnotation.range = [p(M), d(M)]), M.typeAnnotation;
                  case "TSTypeParameter":
                    if (typeof M.name == "string") {
                      let j = p(M);
                      M.name = { type: "Identifier", name: M.name, range: [j, j + M.name.length] };
                    }
                    break;
                  case "ObjectExpression":
                    if (W.parser === "typescript") {
                      let j = M.properties.find((u) => u.type === "Property" && u.value.type === "TSEmptyBodyFunctionExpression");
                      j && k(j.value, "Unexpected token.");
                    }
                    break;
                  case "SequenceExpression": {
                    let j = g(M.expressions);
                    M.range = [p(M), Math.min(d(j), d(M))];
                    break;
                  }
                  case "TopicReference":
                    W.__isUsingHackPipeline = true;
                    break;
                  case "ExportAllDeclaration": {
                    let { exported: j } = M;
                    if (W.parser === "meriyah" && j && j.type === "Identifier") {
                      let u = W.originalText.slice(p(j), d(j));
                      (u.startsWith('"') || u.startsWith("'")) && (M.exported = Object.assign(Object.assign({}, M.exported), {}, { type: "Literal", value: M.exported.name, raw: u }));
                    }
                    break;
                  }
                }
              }), F;
              function Y(M, j) {
                W.originalText[d(j)] !== ";" && (M.range = [p(M), d(j)]);
              }
            }
            function E(F) {
              switch (F.type) {
                case "CallExpression":
                  F.type = "OptionalCallExpression", F.callee = E(F.callee);
                  break;
                case "MemberExpression":
                  F.type = "OptionalMemberExpression", F.object = E(F.object);
                  break;
                case "TSNonNullExpression":
                  F.expression = E(F.expression);
                  break;
              }
              return F;
            }
            function L(F) {
              return F.type === "LogicalExpression" && F.right.type === "LogicalExpression" && F.operator === F.right.operator;
            }
            function R(F) {
              return L(F) ? R({ type: "LogicalExpression", operator: F.operator, left: R({ type: "LogicalExpression", operator: F.operator, left: F.left, right: F.right.left, range: [p(F.left), d(F.right.left)] }), right: F.right.right, range: [p(F), d(F)] }) : F;
            }
            l.exports = D;
          } }), Po = H({ "node_modules/@babel/parser/lib/index.js"(h) {
            "use strict";
            V(), Object.defineProperty(h, "__esModule", { value: true });
            function l(t3, e) {
              if (t3 == null)
                return {};
              var s = {}, r = Object.keys(t3), i, a;
              for (a = 0; a < r.length; a++)
                i = r[a], !(e.indexOf(i) >= 0) && (s[i] = t3[i]);
              return s;
            }
            var p = class {
              constructor(t3, e, s) {
                this.line = void 0, this.column = void 0, this.index = void 0, this.line = t3, this.column = e, this.index = s;
              }
            }, d = class {
              constructor(t3, e) {
                this.start = void 0, this.end = void 0, this.filename = void 0, this.identifierName = void 0, this.start = t3, this.end = e;
              }
            };
            function m(t3, e) {
              let { line: s, column: r, index: i } = t3;
              return new p(s, r + e, i + e);
            }
            var A = Object.freeze({ SyntaxError: "BABEL_PARSER_SYNTAX_ERROR", SourceTypeModuleError: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED" }), g = function(t3) {
              let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t3.length - 1;
              return { get() {
                return t3.reduce((s, r) => s[r], this);
              }, set(s) {
                t3.reduce((r, i, a) => a === e ? r[i] = s : r[i], this);
              } };
            }, x = (t3, e, s) => Object.keys(s).map((r) => [r, s[r]]).filter((r) => {
              let [, i] = r;
              return !!i;
            }).map((r) => {
              let [i, a] = r;
              return [i, typeof a == "function" ? { value: a, enumerable: false } : typeof a.reflect == "string" ? Object.assign({}, a, g(a.reflect.split("."))) : a];
            }).reduce((r, i) => {
              let [a, n] = i;
              return Object.defineProperty(r, a, Object.assign({ configurable: true }, n));
            }, Object.assign(new t3(), e)), T = (t3) => ({ ImportMetaOutsideModule: t3(`import.meta may appear only with 'sourceType: "module"'`, { code: A.SourceTypeModuleError }), ImportOutsideModule: t3(`'import' and 'export' may appear only with 'sourceType: "module"'`, { code: A.SourceTypeModuleError }) }), k = { ArrayPattern: "array destructuring pattern", AssignmentExpression: "assignment expression", AssignmentPattern: "assignment expression", ArrowFunctionExpression: "arrow function expression", ConditionalExpression: "conditional expression", ForOfStatement: "for-of statement", ForInStatement: "for-in statement", ForStatement: "for-loop", FormalParameters: "function parameter list", Identifier: "identifier", ObjectPattern: "object destructuring pattern", ParenthesizedExpression: "parenthesized expression", RestElement: "rest element", UpdateExpression: { true: "prefix operation", false: "postfix operation" }, VariableDeclarator: "variable declaration", YieldExpression: "yield expression" }, D = (t3) => {
              let { type: e, prefix: s } = t3;
              return e === "UpdateExpression" ? k.UpdateExpression[String(s)] : k[e];
            }, E = (t3) => ({ AccessorIsGenerator: t3((e) => {
              let { kind: s } = e;
              return "A ".concat(s, "ter cannot be a generator.");
            }), ArgumentsInClass: t3("'arguments' is only allowed in functions and class methods."), AsyncFunctionInSingleStatementContext: t3("Async functions can only be declared at the top level or inside a block."), AwaitBindingIdentifier: t3("Can not use 'await' as identifier inside an async function."), AwaitBindingIdentifierInStaticBlock: t3("Can not use 'await' as identifier inside a static block."), AwaitExpressionFormalParameter: t3("'await' is not allowed in async function parameters."), AwaitNotInAsyncContext: t3("'await' is only allowed within async functions and at the top levels of modules."), AwaitNotInAsyncFunction: t3("'await' is only allowed within async functions."), BadGetterArity: t3("A 'get' accesor must not have any formal parameters."), BadSetterArity: t3("A 'set' accesor must have exactly one formal parameter."), BadSetterRestParameter: t3("A 'set' accesor function argument must not be a rest parameter."), ConstructorClassField: t3("Classes may not have a field named 'constructor'."), ConstructorClassPrivateField: t3("Classes may not have a private field named '#constructor'."), ConstructorIsAccessor: t3("Class constructor may not be an accessor."), ConstructorIsAsync: t3("Constructor can't be an async function."), ConstructorIsGenerator: t3("Constructor can't be a generator."), DeclarationMissingInitializer: t3((e) => {
              let { kind: s } = e;
              return "Missing initializer in ".concat(s, " declaration.");
            }), DecoratorBeforeExport: t3("Decorators must be placed *before* the 'export' keyword. You can set the 'decoratorsBeforeExport' option to false to use the 'export @decorator class {}' syntax."), DecoratorConstructor: t3("Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?"), DecoratorExportClass: t3("Using the export keyword between a decorator and a class is not allowed. Please use `export @dec class` instead."), DecoratorSemicolon: t3("Decorators must not be followed by a semicolon."), DecoratorStaticBlock: t3("Decorators can't be used with a static block."), DeletePrivateField: t3("Deleting a private field is not allowed."), DestructureNamedImport: t3("ES2015 named imports do not destructure. Use another statement for destructuring after the import."), DuplicateConstructor: t3("Duplicate constructor in the same class."), DuplicateDefaultExport: t3("Only one default export allowed per module."), DuplicateExport: t3((e) => {
              let { exportName: s } = e;
              return "`".concat(s, "` has already been exported. Exported identifiers must be unique.");
            }), DuplicateProto: t3("Redefinition of __proto__ property."), DuplicateRegExpFlags: t3("Duplicate regular expression flag."), ElementAfterRest: t3("Rest element must be last element."), EscapedCharNotAnIdentifier: t3("Invalid Unicode escape."), ExportBindingIsString: t3((e) => {
              let { localName: s, exportName: r } = e;
              return "A string literal cannot be used as an exported binding without `from`.\n- Did you mean `export { '".concat(s, "' as '").concat(r, "' } from 'some-module'`?");
            }), ExportDefaultFromAsIdentifier: t3("'from' is not allowed as an identifier after 'export default'."), ForInOfLoopInitializer: t3((e) => {
              let { type: s } = e;
              return "'".concat(s === "ForInStatement" ? "for-in" : "for-of", "' loop variable declaration may not have an initializer.");
            }), ForOfAsync: t3("The left-hand side of a for-of loop may not be 'async'."), ForOfLet: t3("The left-hand side of a for-of loop may not start with 'let'."), GeneratorInSingleStatementContext: t3("Generators can only be declared at the top level or inside a block."), IllegalBreakContinue: t3((e) => {
              let { type: s } = e;
              return "Unsyntactic ".concat(s === "BreakStatement" ? "break" : "continue", ".");
            }), IllegalLanguageModeDirective: t3("Illegal 'use strict' directive in function with non-simple parameter list."), IllegalReturn: t3("'return' outside of function."), ImportBindingIsString: t3((e) => {
              let { importName: s } = e;
              return 'A string literal cannot be used as an imported binding.\n- Did you mean `import { "'.concat(s, '" as foo }`?');
            }), ImportCallArgumentTrailingComma: t3("Trailing comma is disallowed inside import(...) arguments."), ImportCallArity: t3((e) => {
              let { maxArgumentCount: s } = e;
              return "`import()` requires exactly ".concat(s === 1 ? "one argument" : "one or two arguments", ".");
            }), ImportCallNotNewExpression: t3("Cannot use new with import(...)."), ImportCallSpreadArgument: t3("`...` is not allowed in `import()`."), IncompatibleRegExpUVFlags: t3("The 'u' and 'v' regular expression flags cannot be enabled at the same time."), InvalidBigIntLiteral: t3("Invalid BigIntLiteral."), InvalidCodePoint: t3("Code point out of bounds."), InvalidCoverInitializedName: t3("Invalid shorthand property initializer."), InvalidDecimal: t3("Invalid decimal."), InvalidDigit: t3((e) => {
              let { radix: s } = e;
              return "Expected number in radix ".concat(s, ".");
            }), InvalidEscapeSequence: t3("Bad character escape sequence."), InvalidEscapeSequenceTemplate: t3("Invalid escape sequence in template."), InvalidEscapedReservedWord: t3((e) => {
              let { reservedWord: s } = e;
              return "Escape sequence in keyword ".concat(s, ".");
            }), InvalidIdentifier: t3((e) => {
              let { identifierName: s } = e;
              return "Invalid identifier ".concat(s, ".");
            }), InvalidLhs: t3((e) => {
              let { ancestor: s } = e;
              return "Invalid left-hand side in ".concat(D(s), ".");
            }), InvalidLhsBinding: t3((e) => {
              let { ancestor: s } = e;
              return "Binding invalid left-hand side in ".concat(D(s), ".");
            }), InvalidNumber: t3("Invalid number."), InvalidOrMissingExponent: t3("Floating-point numbers require a valid exponent after the 'e'."), InvalidOrUnexpectedToken: t3((e) => {
              let { unexpected: s } = e;
              return "Unexpected character '".concat(s, "'.");
            }), InvalidParenthesizedAssignment: t3("Invalid parenthesized assignment pattern."), InvalidPrivateFieldResolution: t3((e) => {
              let { identifierName: s } = e;
              return "Private name #".concat(s, " is not defined.");
            }), InvalidPropertyBindingPattern: t3("Binding member expression."), InvalidRecordProperty: t3("Only properties and spread elements are allowed in record definitions."), InvalidRestAssignmentPattern: t3("Invalid rest operator's argument."), LabelRedeclaration: t3((e) => {
              let { labelName: s } = e;
              return "Label '".concat(s, "' is already declared.");
            }), LetInLexicalBinding: t3("'let' is not allowed to be used as a name in 'let' or 'const' declarations."), LineTerminatorBeforeArrow: t3("No line break is allowed before '=>'."), MalformedRegExpFlags: t3("Invalid regular expression flag."), MissingClassName: t3("A class name is required."), MissingEqInAssignment: t3("Only '=' operator can be used for specifying default value."), MissingSemicolon: t3("Missing semicolon."), MissingPlugin: t3((e) => {
              let { missingPlugin: s } = e;
              return "This experimental syntax requires enabling the parser plugin: ".concat(s.map((r) => JSON.stringify(r)).join(", "), ".");
            }), MissingOneOfPlugins: t3((e) => {
              let { missingPlugin: s } = e;
              return "This experimental syntax requires enabling one of the following parser plugin(s): ".concat(s.map((r) => JSON.stringify(r)).join(", "), ".");
            }), MissingUnicodeEscape: t3("Expecting Unicode escape sequence \\uXXXX."), MixingCoalesceWithLogical: t3("Nullish coalescing operator(??) requires parens when mixing with logical operators."), ModuleAttributeDifferentFromType: t3("The only accepted module attribute is `type`."), ModuleAttributeInvalidValue: t3("Only string literals are allowed as module attribute values."), ModuleAttributesWithDuplicateKeys: t3((e) => {
              let { key: s } = e;
              return 'Duplicate key "'.concat(s, '" is not allowed in module attributes.');
            }), ModuleExportNameHasLoneSurrogate: t3((e) => {
              let { surrogateCharCode: s } = e;
              return "An export name cannot include a lone surrogate, found '\\u".concat(s.toString(16), "'.");
            }), ModuleExportUndefined: t3((e) => {
              let { localName: s } = e;
              return "Export '".concat(s, "' is not defined.");
            }), MultipleDefaultsInSwitch: t3("Multiple default clauses."), NewlineAfterThrow: t3("Illegal newline after throw."), NoCatchOrFinally: t3("Missing catch or finally clause."), NumberIdentifier: t3("Identifier directly after number."), NumericSeparatorInEscapeSequence: t3("Numeric separators are not allowed inside unicode escape sequences or hex escape sequences."), ObsoleteAwaitStar: t3("'await*' has been removed from the async functions proposal. Use Promise.all() instead."), OptionalChainingNoNew: t3("Constructors in/after an Optional Chain are not allowed."), OptionalChainingNoTemplate: t3("Tagged Template Literals are not allowed in optionalChain."), OverrideOnConstructor: t3("'override' modifier cannot appear on a constructor declaration."), ParamDupe: t3("Argument name clash."), PatternHasAccessor: t3("Object pattern can't contain getter or setter."), PatternHasMethod: t3("Object pattern can't contain methods."), PrivateInExpectedIn: t3((e) => {
              let { identifierName: s } = e;
              return "Private names are only allowed in property accesses (`obj.#".concat(s, "`) or in `in` expressions (`#").concat(s, " in obj`).");
            }), PrivateNameRedeclaration: t3((e) => {
              let { identifierName: s } = e;
              return "Duplicate private name #".concat(s, ".");
            }), RecordExpressionBarIncorrectEndSyntaxType: t3("Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'."), RecordExpressionBarIncorrectStartSyntaxType: t3("Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'."), RecordExpressionHashIncorrectStartSyntaxType: t3("Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'."), RecordNoProto: t3("'__proto__' is not allowed in Record expressions."), RestTrailingComma: t3("Unexpected trailing comma after rest element."), SloppyFunction: t3("In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement."), StaticPrototype: t3("Classes may not have static property named prototype."), SuperNotAllowed: t3("`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?"), SuperPrivateField: t3("Private fields can't be accessed on super."), TrailingDecorator: t3("Decorators must be attached to a class element."), TupleExpressionBarIncorrectEndSyntaxType: t3("Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'."), TupleExpressionBarIncorrectStartSyntaxType: t3("Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'."), TupleExpressionHashIncorrectStartSyntaxType: t3("Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'."), UnexpectedArgumentPlaceholder: t3("Unexpected argument placeholder."), UnexpectedAwaitAfterPipelineBody: t3('Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.'), UnexpectedDigitAfterHash: t3("Unexpected digit after hash token."), UnexpectedImportExport: t3("'import' and 'export' may only appear at the top level."), UnexpectedKeyword: t3((e) => {
              let { keyword: s } = e;
              return "Unexpected keyword '".concat(s, "'.");
            }), UnexpectedLeadingDecorator: t3("Leading decorators must be attached to a class declaration."), UnexpectedLexicalDeclaration: t3("Lexical declaration cannot appear in a single-statement context."), UnexpectedNewTarget: t3("`new.target` can only be used in functions or class properties."), UnexpectedNumericSeparator: t3("A numeric separator is only allowed between two digits."), UnexpectedPrivateField: t3("Unexpected private name."), UnexpectedReservedWord: t3((e) => {
              let { reservedWord: s } = e;
              return "Unexpected reserved word '".concat(s, "'.");
            }), UnexpectedSuper: t3("'super' is only allowed in object methods and classes."), UnexpectedToken: t3((e) => {
              let { expected: s, unexpected: r } = e;
              return "Unexpected token".concat(r ? " '".concat(r, "'.") : "").concat(s ? ', expected "'.concat(s, '"') : "");
            }), UnexpectedTokenUnaryExponentiation: t3("Illegal expression. Wrap left hand side or entire exponentiation in parentheses."), UnsupportedBind: t3("Binding should be performed on object property."), UnsupportedDecoratorExport: t3("A decorated export must export a class declaration."), UnsupportedDefaultExport: t3("Only expressions, functions or classes are allowed as the `default` export."), UnsupportedImport: t3("`import` can only be used in `import()` or `import.meta`."), UnsupportedMetaProperty: t3((e) => {
              let { target: s, onlyValidPropertyName: r } = e;
              return "The only valid meta property for ".concat(s, " is ").concat(s, ".").concat(r, ".");
            }), UnsupportedParameterDecorator: t3("Decorators cannot be used to decorate parameters."), UnsupportedPropertyDecorator: t3("Decorators cannot be used to decorate object literal properties."), UnsupportedSuper: t3("'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop])."), UnterminatedComment: t3("Unterminated comment."), UnterminatedRegExp: t3("Unterminated regular expression."), UnterminatedString: t3("Unterminated string constant."), UnterminatedTemplate: t3("Unterminated template."), VarRedeclaration: t3((e) => {
              let { identifierName: s } = e;
              return "Identifier '".concat(s, "' has already been declared.");
            }), YieldBindingIdentifier: t3("Can not use 'yield' as identifier inside a generator."), YieldInParameter: t3("Yield expression is not allowed in formal parameters."), ZeroDigitNumericSeparator: t3("Numeric separator can not be used after leading 0.") }), L = (t3) => ({ StrictDelete: t3("Deleting local variable in strict mode."), StrictEvalArguments: t3((e) => {
              let { referenceName: s } = e;
              return "Assigning to '".concat(s, "' in strict mode.");
            }), StrictEvalArgumentsBinding: t3((e) => {
              let { bindingName: s } = e;
              return "Binding '".concat(s, "' in strict mode.");
            }), StrictFunction: t3("In strict mode code, functions can only be declared at top level or inside a block."), StrictNumericEscape: t3("The only valid numeric escape in strict mode is '\\0'."), StrictOctalLiteral: t3("Legacy octal literals are not allowed in strict mode."), StrictWith: t3("'with' in strict mode.") }), R = /* @__PURE__ */ new Set(["ArrowFunctionExpression", "AssignmentExpression", "ConditionalExpression", "YieldExpression"]), F = (t3) => ({ PipeBodyIsTighter: t3("Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence."), PipeTopicRequiresHackPipes: t3('Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.'), PipeTopicUnbound: t3("Topic reference is unbound; it must be inside a pipe body."), PipeTopicUnconfiguredToken: t3((e) => {
              let { token: s } = e;
              return "Invalid topic token ".concat(s, ". In order to use ").concat(s, ' as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "').concat(s, '" }.');
            }), PipeTopicUnused: t3("Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once."), PipeUnparenthesizedBody: t3((e) => {
              let { type: s } = e;
              return "Hack-style pipe body cannot be an unparenthesized ".concat(D({ type: s }), "; please wrap it in parentheses.");
            }), PipelineBodyNoArrow: t3('Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.'), PipelineBodySequenceExpression: t3("Pipeline body may not be a comma-separated sequence expression."), PipelineHeadSequenceExpression: t3("Pipeline head should not be a comma-separated sequence expression."), PipelineTopicUnused: t3("Pipeline is in topic style but does not use topic reference."), PrimaryTopicNotAllowed: t3("Topic reference was used in a lexical context without topic binding."), PrimaryTopicRequiresSmartPipeline: t3('Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.') }), W = ["toMessage"];
            function Y(t3) {
              let { toMessage: e } = t3, s = l(t3, W);
              return function r(i) {
                let { loc: a, details: n } = i;
                return x(SyntaxError, Object.assign({}, s, { loc: a }), { clone() {
                  let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = o.loc || {};
                  return r({ loc: new p("line" in c ? c.line : this.loc.line, "column" in c ? c.column : this.loc.column, "index" in c ? c.index : this.loc.index), details: Object.assign({}, this.details, o.details) });
                }, details: { value: n, enumerable: false }, message: { get() {
                  return "".concat(e(this.details), " (").concat(this.loc.line, ":").concat(this.loc.column, ")");
                }, set(o) {
                  Object.defineProperty(this, "message", { value: o });
                } }, pos: { reflect: "loc.index", enumerable: true }, missingPlugin: "missingPlugin" in n && { reflect: "details.missingPlugin", enumerable: true } });
              };
            }
            function M(t3, e) {
              return Object.assign({ toMessage: typeof t3 == "string" ? () => t3 : t3 }, e);
            }
            function j(t3, e) {
              if (Array.isArray(t3))
                return (i) => j(i, t3[0]);
              let s = t3(M), r = {};
              for (let i of Object.keys(s))
                r[i] = Y(Object.assign({ code: A.SyntaxError, reasonCode: i }, e ? { syntaxPlugin: e } : {}, s[i]));
              return r;
            }
            var u = Object.assign({}, j(T), j(E), j(L), j(_n || (_n = rt(["pipelineOperator"])))(F)), { defineProperty: X } = Object, se = (t3, e) => X(t3, e, { enumerable: false, value: t3[e] });
            function J(t3) {
              return se(t3.loc.start, "index"), se(t3.loc.end, "index"), t3;
            }
            var Oe = (t3) => class extends t3 {
              parse() {
                let e = J(super.parse());
                return this.options.tokens && (e.tokens = e.tokens.map(J)), e;
              }
              parseRegExpLiteral(e) {
                let { pattern: s, flags: r } = e, i = null;
                try {
                  i = new RegExp(s, r);
                } catch {
                }
                let a = this.estreeParseLiteral(i);
                return a.regex = { pattern: s, flags: r }, a;
              }
              parseBigIntLiteral(e) {
                let s;
                try {
                  s = BigInt(e);
                } catch {
                  s = null;
                }
                let r = this.estreeParseLiteral(s);
                return r.bigint = String(r.value || e), r;
              }
              parseDecimalLiteral(e) {
                let r = this.estreeParseLiteral(null);
                return r.decimal = String(r.value || e), r;
              }
              estreeParseLiteral(e) {
                return this.parseLiteral(e, "Literal");
              }
              parseStringLiteral(e) {
                return this.estreeParseLiteral(e);
              }
              parseNumericLiteral(e) {
                return this.estreeParseLiteral(e);
              }
              parseNullLiteral() {
                return this.estreeParseLiteral(null);
              }
              parseBooleanLiteral(e) {
                return this.estreeParseLiteral(e);
              }
              directiveToStmt(e) {
                let s = e.value, r = this.startNodeAt(e.start, e.loc.start), i = this.startNodeAt(s.start, s.loc.start);
                return i.value = s.extra.expressionValue, i.raw = s.extra.raw, r.expression = this.finishNodeAt(i, "Literal", s.loc.end), r.directive = s.extra.raw.slice(1, -1), this.finishNodeAt(r, "ExpressionStatement", e.loc.end);
              }
              initFunction(e, s) {
                super.initFunction(e, s), e.expression = false;
              }
              checkDeclaration(e) {
                e != null && this.isObjectProperty(e) ? this.checkDeclaration(e.value) : super.checkDeclaration(e);
              }
              getObjectOrClassMethodParams(e) {
                return e.value.params;
              }
              isValidDirective(e) {
                var s;
                return e.type === "ExpressionStatement" && e.expression.type === "Literal" && typeof e.expression.value == "string" && !((s = e.expression.extra) != null && s.parenthesized);
              }
              parseBlockBody(e) {
                for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), i = 1; i < s; i++)
                  r[i - 1] = arguments[i];
                super.parseBlockBody(e, ...r);
                let a = e.directives.map((n) => this.directiveToStmt(n));
                e.body = a.concat(e.body), delete e.directives;
              }
              pushClassMethod(e, s, r, i, a, n) {
                this.parseMethod(s, r, i, a, n, "ClassMethod", true), s.typeParameters && (s.value.typeParameters = s.typeParameters, delete s.typeParameters), e.body.push(s);
              }
              parsePrivateName() {
                let e = super.parsePrivateName();
                return this.getPluginOption("estree", "classFeatures") ? this.convertPrivateNameToPrivateIdentifier(e) : e;
              }
              convertPrivateNameToPrivateIdentifier(e) {
                let s = super.getPrivateNameSV(e);
                return e = e, delete e.id, e.name = s, e.type = "PrivateIdentifier", e;
              }
              isPrivateName(e) {
                return this.getPluginOption("estree", "classFeatures") ? e.type === "PrivateIdentifier" : super.isPrivateName(e);
              }
              getPrivateNameSV(e) {
                return this.getPluginOption("estree", "classFeatures") ? e.name : super.getPrivateNameSV(e);
              }
              parseLiteral(e, s) {
                let r = super.parseLiteral(e, s);
                return r.raw = r.extra.raw, delete r.extra, r;
              }
              parseFunctionBody(e, s) {
                let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                super.parseFunctionBody(e, s, r), e.expression = e.body.type !== "BlockStatement";
              }
              parseMethod(e, s, r, i, a, n) {
                let o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, c = this.startNode();
                return c.kind = e.kind, c = super.parseMethod(c, s, r, i, a, n, o), c.type = "FunctionExpression", delete c.kind, e.value = c, n === "ClassPrivateMethod" && (e.computed = false), n = "MethodDefinition", this.finishNode(e, n);
              }
              parseClassProperty() {
                let e = super.parseClassProperty(...arguments);
                return this.getPluginOption("estree", "classFeatures") && (e.type = "PropertyDefinition"), e;
              }
              parseClassPrivateProperty() {
                let e = super.parseClassPrivateProperty(...arguments);
                return this.getPluginOption("estree", "classFeatures") && (e.type = "PropertyDefinition", e.computed = false), e;
              }
              parseObjectMethod(e, s, r, i, a) {
                let n = super.parseObjectMethod(e, s, r, i, a);
                return n && (n.type = "Property", n.kind === "method" && (n.kind = "init"), n.shorthand = false), n;
              }
              parseObjectProperty(e, s, r, i, a) {
                let n = super.parseObjectProperty(e, s, r, i, a);
                return n && (n.kind = "init", n.type = "Property"), n;
              }
              isValidLVal(e) {
                for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), i = 1; i < s; i++)
                  r[i - 1] = arguments[i];
                return e === "Property" ? "value" : super.isValidLVal(e, ...r);
              }
              isAssignable(e, s) {
                return e != null && this.isObjectProperty(e) ? this.isAssignable(e.value, s) : super.isAssignable(e, s);
              }
              toAssignable(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (e != null && this.isObjectProperty(e)) {
                  let { key: r, value: i } = e;
                  this.isPrivateName(r) && this.classScope.usePrivateName(this.getPrivateNameSV(r), r.loc.start), this.toAssignable(i, s);
                } else
                  super.toAssignable(e, s);
              }
              toAssignableObjectExpressionProp(e) {
                e.kind === "get" || e.kind === "set" ? this.raise(u.PatternHasAccessor, { at: e.key }) : e.method ? this.raise(u.PatternHasMethod, { at: e.key }) : super.toAssignableObjectExpressionProp(...arguments);
              }
              finishCallExpression(e, s) {
                if (super.finishCallExpression(e, s), e.callee.type === "Import") {
                  if (e.type = "ImportExpression", e.source = e.arguments[0], this.hasPlugin("importAssertions")) {
                    var r;
                    e.attributes = (r = e.arguments[1]) != null ? r : null;
                  }
                  delete e.arguments, delete e.callee;
                }
                return e;
              }
              toReferencedArguments(e) {
                e.type !== "ImportExpression" && super.toReferencedArguments(e);
              }
              parseExport(e) {
                switch (super.parseExport(e), e.type) {
                  case "ExportAllDeclaration":
                    e.exported = null;
                    break;
                  case "ExportNamedDeclaration":
                    e.specifiers.length === 1 && e.specifiers[0].type === "ExportNamespaceSpecifier" && (e.type = "ExportAllDeclaration", e.exported = e.specifiers[0].exported, delete e.specifiers);
                    break;
                }
                return e;
              }
              parseSubscript(e, s, r, i, a) {
                let n = super.parseSubscript(e, s, r, i, a);
                if (a.optionalChainMember) {
                  if ((n.type === "OptionalMemberExpression" || n.type === "OptionalCallExpression") && (n.type = n.type.substring(8)), a.stop) {
                    let o = this.startNodeAtNode(n);
                    return o.expression = n, this.finishNode(o, "ChainExpression");
                  }
                } else
                  (n.type === "MemberExpression" || n.type === "CallExpression") && (n.optional = false);
                return n;
              }
              hasPropertyAsPrivateName(e) {
                return e.type === "ChainExpression" && (e = e.expression), super.hasPropertyAsPrivateName(e);
              }
              isOptionalChain(e) {
                return e.type === "ChainExpression";
              }
              isObjectProperty(e) {
                return e.type === "Property" && e.kind === "init" && !e.method;
              }
              isObjectMethod(e) {
                return e.method || e.kind === "get" || e.kind === "set";
              }
              finishNodeAt(e, s, r) {
                return J(super.finishNodeAt(e, s, r));
              }
              resetEndLocation(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
                super.resetEndLocation(e, s), J(e);
              }
            }, $ = class {
              constructor(t3, e) {
                this.token = void 0, this.preserveSpace = void 0, this.token = t3, this.preserveSpace = !!e;
              }
            }, z = { brace: new $("{"), j_oTag: new $("<tag"), j_cTag: new $("</tag"), j_expr: new $("<tag>...</tag>", true) };
            z.template = new $("`", true);
            var O = true, C = true, Ve = true, Z = true, he = true, Co = true, or = class {
              constructor(t3) {
                let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.label = void 0, this.keyword = void 0, this.beforeExpr = void 0, this.startsExpr = void 0, this.rightAssociative = void 0, this.isLoop = void 0, this.isAssign = void 0, this.prefix = void 0, this.postfix = void 0, this.binop = void 0, this.label = t3, this.keyword = e.keyword, this.beforeExpr = !!e.beforeExpr, this.startsExpr = !!e.startsExpr, this.rightAssociative = !!e.rightAssociative, this.isLoop = !!e.isLoop, this.isAssign = !!e.isAssign, this.prefix = !!e.prefix, this.postfix = !!e.postfix, this.binop = e.binop != null ? e.binop : null, this.updateContext = null;
              }
            }, qt = /* @__PURE__ */ new Map();
            function q(t3) {
              let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              e.keyword = t3;
              let s = w(t3, e);
              return qt.set(t3, s), s;
            }
            function te(t3, e) {
              return w(t3, { beforeExpr: O, binop: e });
            }
            var He = -1, ce = [], Ut = [], it = [], _t = [], zt = [], Kt = [];
            function w(t3) {
              let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              var s, r, i, a;
              return ++He, Ut.push(t3), it.push((s = e.binop) != null ? s : -1), _t.push((r = e.beforeExpr) != null ? r : false), zt.push((i = e.startsExpr) != null ? i : false), Kt.push((a = e.prefix) != null ? a : false), ce.push(new or(t3, e)), He;
            }
            function U(t3) {
              let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              var s, r, i, a;
              return ++He, qt.set(t3, He), Ut.push(t3), it.push((s = e.binop) != null ? s : -1), _t.push((r = e.beforeExpr) != null ? r : false), zt.push((i = e.startsExpr) != null ? i : false), Kt.push((a = e.prefix) != null ? a : false), ce.push(new or("name", e)), He;
            }
            var bo = { bracketL: w("[", { beforeExpr: O, startsExpr: C }), bracketHashL: w("#[", { beforeExpr: O, startsExpr: C }), bracketBarL: w("[|", { beforeExpr: O, startsExpr: C }), bracketR: w("]"), bracketBarR: w("|]"), braceL: w("{", { beforeExpr: O, startsExpr: C }), braceBarL: w("{|", { beforeExpr: O, startsExpr: C }), braceHashL: w("#{", { beforeExpr: O, startsExpr: C }), braceR: w("}"), braceBarR: w("|}"), parenL: w("(", { beforeExpr: O, startsExpr: C }), parenR: w(")"), comma: w(",", { beforeExpr: O }), semi: w(";", { beforeExpr: O }), colon: w(":", { beforeExpr: O }), doubleColon: w("::", { beforeExpr: O }), dot: w("."), question: w("?", { beforeExpr: O }), questionDot: w("?."), arrow: w("=>", { beforeExpr: O }), template: w("template"), ellipsis: w("...", { beforeExpr: O }), backQuote: w("`", { startsExpr: C }), dollarBraceL: w("${", { beforeExpr: O, startsExpr: C }), templateTail: w("...`", { startsExpr: C }), templateNonTail: w("...${", { beforeExpr: O, startsExpr: C }), at: w("@"), hash: w("#", { startsExpr: C }), interpreterDirective: w("#!..."), eq: w("=", { beforeExpr: O, isAssign: Z }), assign: w("_=", { beforeExpr: O, isAssign: Z }), slashAssign: w("_=", { beforeExpr: O, isAssign: Z }), xorAssign: w("_=", { beforeExpr: O, isAssign: Z }), moduloAssign: w("_=", { beforeExpr: O, isAssign: Z }), incDec: w("++/--", { prefix: he, postfix: Co, startsExpr: C }), bang: w("!", { beforeExpr: O, prefix: he, startsExpr: C }), tilde: w("~", { beforeExpr: O, prefix: he, startsExpr: C }), doubleCaret: w("^^", { startsExpr: C }), doubleAt: w("@@", { startsExpr: C }), pipeline: te("|>", 0), nullishCoalescing: te("??", 1), logicalOR: te("||", 1), logicalAND: te("&&", 2), bitwiseOR: te("|", 3), bitwiseXOR: te("^", 4), bitwiseAND: te("&", 5), equality: te("==/!=/===/!==", 6), lt: te("</>/<=/>=", 7), gt: te("</>/<=/>=", 7), relational: te("</>/<=/>=", 7), bitShift: te("<</>>/>>>", 8), bitShiftL: te("<</>>/>>>", 8), bitShiftR: te("<</>>/>>>", 8), plusMin: w("+/-", { beforeExpr: O, binop: 9, prefix: he, startsExpr: C }), modulo: w("%", { binop: 10, startsExpr: C }), star: w("*", { binop: 10 }), slash: te("/", 10), exponent: w("**", { beforeExpr: O, binop: 11, rightAssociative: true }), _in: q("in", { beforeExpr: O, binop: 7 }), _instanceof: q("instanceof", { beforeExpr: O, binop: 7 }), _break: q("break"), _case: q("case", { beforeExpr: O }), _catch: q("catch"), _continue: q("continue"), _debugger: q("debugger"), _default: q("default", { beforeExpr: O }), _else: q("else", { beforeExpr: O }), _finally: q("finally"), _function: q("function", { startsExpr: C }), _if: q("if"), _return: q("return", { beforeExpr: O }), _switch: q("switch"), _throw: q("throw", { beforeExpr: O, prefix: he, startsExpr: C }), _try: q("try"), _var: q("var"), _const: q("const"), _with: q("with"), _new: q("new", { beforeExpr: O, startsExpr: C }), _this: q("this", { startsExpr: C }), _super: q("super", { startsExpr: C }), _class: q("class", { startsExpr: C }), _extends: q("extends", { beforeExpr: O }), _export: q("export"), _import: q("import", { startsExpr: C }), _null: q("null", { startsExpr: C }), _true: q("true", { startsExpr: C }), _false: q("false", { startsExpr: C }), _typeof: q("typeof", { beforeExpr: O, prefix: he, startsExpr: C }), _void: q("void", { beforeExpr: O, prefix: he, startsExpr: C }), _delete: q("delete", { beforeExpr: O, prefix: he, startsExpr: C }), _do: q("do", { isLoop: Ve, beforeExpr: O }), _for: q("for", { isLoop: Ve }), _while: q("while", { isLoop: Ve }), _as: U("as", { startsExpr: C }), _assert: U("assert", { startsExpr: C }), _async: U("async", { startsExpr: C }), _await: U("await", { startsExpr: C }), _from: U("from", { startsExpr: C }), _get: U("get", { startsExpr: C }), _let: U("let", { startsExpr: C }), _meta: U("meta", { startsExpr: C }), _of: U("of", { startsExpr: C }), _sent: U("sent", { startsExpr: C }), _set: U("set", { startsExpr: C }), _static: U("static", { startsExpr: C }), _yield: U("yield", { startsExpr: C }), _asserts: U("asserts", { startsExpr: C }), _checks: U("checks", { startsExpr: C }), _exports: U("exports", { startsExpr: C }), _global: U("global", { startsExpr: C }), _implements: U("implements", { startsExpr: C }), _intrinsic: U("intrinsic", { startsExpr: C }), _infer: U("infer", { startsExpr: C }), _is: U("is", { startsExpr: C }), _mixins: U("mixins", { startsExpr: C }), _proto: U("proto", { startsExpr: C }), _require: U("require", { startsExpr: C }), _keyof: U("keyof", { startsExpr: C }), _readonly: U("readonly", { startsExpr: C }), _unique: U("unique", { startsExpr: C }), _abstract: U("abstract", { startsExpr: C }), _declare: U("declare", { startsExpr: C }), _enum: U("enum", { startsExpr: C }), _module: U("module", { startsExpr: C }), _namespace: U("namespace", { startsExpr: C }), _interface: U("interface", { startsExpr: C }), _type: U("type", { startsExpr: C }), _opaque: U("opaque", { startsExpr: C }), name: w("name", { startsExpr: C }), string: w("string", { startsExpr: C }), num: w("num", { startsExpr: C }), bigint: w("bigint", { startsExpr: C }), decimal: w("decimal", { startsExpr: C }), regexp: w("regexp", { startsExpr: C }), privateName: w("#name", { startsExpr: C }), eof: w("eof"), jsxName: w("jsxName"), jsxText: w("jsxText", { beforeExpr: true }), jsxTagStart: w("jsxTagStart", { startsExpr: true }), jsxTagEnd: w("jsxTagEnd"), placeholder: w("%%", { startsExpr: true }) };
            function K(t3) {
              return t3 >= 93 && t3 <= 128;
            }
            function vo(t3) {
              return t3 <= 92;
            }
            function pe(t3) {
              return t3 >= 58 && t3 <= 128;
            }
            function hr(t3) {
              return t3 >= 58 && t3 <= 132;
            }
            function So(t3) {
              return _t[t3];
            }
            function Vt(t3) {
              return zt[t3];
            }
            function wo(t3) {
              return t3 >= 29 && t3 <= 33;
            }
            function lr(t3) {
              return t3 >= 125 && t3 <= 127;
            }
            function No(t3) {
              return t3 >= 90 && t3 <= 92;
            }
            function Ht(t3) {
              return t3 >= 58 && t3 <= 92;
            }
            function Io(t3) {
              return t3 >= 39 && t3 <= 59;
            }
            function ko(t3) {
              return t3 === 34;
            }
            function Do(t3) {
              return Kt[t3];
            }
            function Fo(t3) {
              return t3 >= 117 && t3 <= 119;
            }
            function Lo(t3) {
              return t3 >= 120 && t3 <= 126;
            }
            function Pe(t3) {
              return Ut[t3];
            }
            function at2(t3) {
              return it[t3];
            }
            function Oo(t3) {
              return it[t3] !== -1;
            }
            function Bo(t3) {
              return t3 === 57;
            }
            function nt(t3) {
              return t3 >= 24 && t3 <= 25;
            }
            function fe(t3) {
              return ce[t3];
            }
            ce[8].updateContext = (t3) => {
              t3.pop();
            }, ce[5].updateContext = ce[7].updateContext = ce[23].updateContext = (t3) => {
              t3.push(z.brace);
            }, ce[22].updateContext = (t3) => {
              t3[t3.length - 1] === z.template ? t3.pop() : t3.push(z.template);
            }, ce[138].updateContext = (t3) => {
              t3.push(z.j_expr, z.j_oTag);
            };
            var Wt = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", ur = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", Mo = new RegExp("[" + Wt + "]"), Ro = new RegExp("[" + Wt + ur + "]");
            Wt = ur = null;
            var cr = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 190, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1070, 4050, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 46, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 482, 44, 11, 6, 17, 0, 322, 29, 19, 43, 1269, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4152, 8, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938], jo = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 154, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 357, 0, 62, 13, 1495, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
            function Gt(t3, e) {
              let s = 65536;
              for (let r = 0, i = e.length; r < i; r += 2) {
                if (s += e[r], s > t3)
                  return false;
                if (s += e[r + 1], s >= t3)
                  return true;
              }
              return false;
            }
            function de(t3) {
              return t3 < 65 ? t3 === 36 : t3 <= 90 ? true : t3 < 97 ? t3 === 95 : t3 <= 122 ? true : t3 <= 65535 ? t3 >= 170 && Mo.test(String.fromCharCode(t3)) : Gt(t3, cr);
            }
            function Be(t3) {
              return t3 < 48 ? t3 === 36 : t3 < 58 ? true : t3 < 65 ? false : t3 <= 90 ? true : t3 < 97 ? t3 === 95 : t3 <= 122 ? true : t3 <= 65535 ? t3 >= 170 && Ro.test(String.fromCharCode(t3)) : Gt(t3, cr) || Gt(t3, jo);
            }
            var Xt = { keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"], strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"], strictBind: ["eval", "arguments"] }, qo = new Set(Xt.keyword), Uo = new Set(Xt.strict), _o = new Set(Xt.strictBind);
            function pr(t3, e) {
              return e && t3 === "await" || t3 === "enum";
            }
            function fr(t3, e) {
              return pr(t3, e) || Uo.has(t3);
            }
            function dr(t3) {
              return _o.has(t3);
            }
            function mr(t3, e) {
              return fr(t3, e) || dr(t3);
            }
            function zo(t3) {
              return qo.has(t3);
            }
            function Ko(t3, e, s) {
              return t3 === 64 && e === 64 && de(s);
            }
            var Vo = /* @__PURE__ */ new Set(["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete", "implements", "interface", "let", "package", "private", "protected", "public", "static", "yield", "eval", "arguments", "enum", "await"]);
            function Ho(t3) {
              return Vo.has(t3);
            }
            var Me = 0, We = 1, me = 2, Jt = 4, yr = 8, ot = 16, xr = 32, Se = 64, Yt = 128, ht = 256, lt2 = We | me | ht, ye = 1, Re = 2, gr = 4, Te = 8, ut = 16, Ar = 64, ct = 128, $t = 256, Qt = 512, Zt = 1024, es = 2048, Pr = ye | Re | Te | ct, xe = ye | 0 | Te | 0, pt = ye | 0 | gr | 0, Tr = ye | 0 | ut | 0, Wo = 0 | Re | 0 | ct, Go = 0 | Re | 0 | 0, Er = ye | Re | Te | $t, Cr = 0 | Zt, we = 0 | Ar, Xo = ye | 0 | 0 | Ar, Jo = Er | Qt, Yo = 0 | Zt, $o = es, ft = 4, ts = 2, ss = 1, rs = ts | ss, Qo = ts | ft, Zo = ss | ft, eh = ts, th = ss, is = 0, sh = class {
              constructor() {
                this.sawUnambiguousESM = false, this.ambiguousScriptDifferentAst = false;
              }
              hasPlugin(t3) {
                if (typeof t3 == "string")
                  return this.plugins.has(t3);
                {
                  let [e, s] = t3;
                  if (!this.hasPlugin(e))
                    return false;
                  let r = this.plugins.get(e);
                  for (let i of Object.keys(s))
                    if ((r == null ? void 0 : r[i]) !== s[i])
                      return false;
                  return true;
                }
              }
              getPluginOption(t3, e) {
                var s;
                return (s = this.plugins.get(t3)) == null ? void 0 : s[e];
              }
            };
            function br(t3, e) {
              t3.trailingComments === void 0 ? t3.trailingComments = e : t3.trailingComments.unshift(...e);
            }
            function rh(t3, e) {
              t3.leadingComments === void 0 ? t3.leadingComments = e : t3.leadingComments.unshift(...e);
            }
            function Ge(t3, e) {
              t3.innerComments === void 0 ? t3.innerComments = e : t3.innerComments.unshift(...e);
            }
            function Xe(t3, e, s) {
              let r = null, i = e.length;
              for (; r === null && i > 0; )
                r = e[--i];
              r === null || r.start > s.start ? Ge(t3, s.comments) : br(r, s.comments);
            }
            var ih = class extends sh {
              addComment(t3) {
                this.filename && (t3.loc.filename = this.filename), this.state.comments.push(t3);
              }
              processComment(t3) {
                let { commentStack: e } = this.state, s = e.length;
                if (s === 0)
                  return;
                let r = s - 1, i = e[r];
                i.start === t3.end && (i.leadingNode = t3, r--);
                let { start: a } = t3;
                for (; r >= 0; r--) {
                  let n = e[r], o = n.end;
                  if (o > a)
                    n.containingNode = t3, this.finalizeComment(n), e.splice(r, 1);
                  else {
                    o === a && (n.trailingNode = t3);
                    break;
                  }
                }
              }
              finalizeComment(t3) {
                let { comments: e } = t3;
                if (t3.leadingNode !== null || t3.trailingNode !== null)
                  t3.leadingNode !== null && br(t3.leadingNode, e), t3.trailingNode !== null && rh(t3.trailingNode, e);
                else {
                  let { containingNode: s, start: r } = t3;
                  if (this.input.charCodeAt(r - 1) === 44)
                    switch (s.type) {
                      case "ObjectExpression":
                      case "ObjectPattern":
                      case "RecordExpression":
                        Xe(s, s.properties, t3);
                        break;
                      case "CallExpression":
                      case "OptionalCallExpression":
                        Xe(s, s.arguments, t3);
                        break;
                      case "FunctionDeclaration":
                      case "FunctionExpression":
                      case "ArrowFunctionExpression":
                      case "ObjectMethod":
                      case "ClassMethod":
                      case "ClassPrivateMethod":
                        Xe(s, s.params, t3);
                        break;
                      case "ArrayExpression":
                      case "ArrayPattern":
                      case "TupleExpression":
                        Xe(s, s.elements, t3);
                        break;
                      case "ExportNamedDeclaration":
                      case "ImportDeclaration":
                        Xe(s, s.specifiers, t3);
                        break;
                      default:
                        Ge(s, e);
                    }
                  else
                    Ge(s, e);
                }
              }
              finalizeRemainingComments() {
                let { commentStack: t3 } = this.state;
                for (let e = t3.length - 1; e >= 0; e--)
                  this.finalizeComment(t3[e]);
                this.state.commentStack = [];
              }
              resetPreviousNodeTrailingComments(t3) {
                let { commentStack: e } = this.state, { length: s } = e;
                if (s === 0)
                  return;
                let r = e[s - 1];
                r.leadingNode === t3 && (r.leadingNode = null);
              }
              takeSurroundingComments(t3, e, s) {
                let { commentStack: r } = this.state, i = r.length;
                if (i === 0)
                  return;
                let a = i - 1;
                for (; a >= 0; a--) {
                  let n = r[a], o = n.end;
                  if (n.start === s)
                    n.leadingNode = t3;
                  else if (o === e)
                    n.trailingNode = t3;
                  else if (o < e)
                    break;
                }
              }
            }, as = /\r\n?|[\n\u2028\u2029]/, dt = new RegExp(as.source, "g");
            function Ne(t3) {
              switch (t3) {
                case 10:
                case 13:
                case 8232:
                case 8233:
                  return true;
                default:
                  return false;
              }
            }
            var ns = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, ah = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/y, vr = new RegExp("(?=(" + ah.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source, "y");
            function nh(t3) {
              switch (t3) {
                case 9:
                case 11:
                case 12:
                case 32:
                case 160:
                case 5760:
                case 8192:
                case 8193:
                case 8194:
                case 8195:
                case 8196:
                case 8197:
                case 8198:
                case 8199:
                case 8200:
                case 8201:
                case 8202:
                case 8239:
                case 8287:
                case 12288:
                case 65279:
                  return true;
                default:
                  return false;
              }
            }
            var Sr = class {
              constructor() {
                this.strict = void 0, this.curLine = void 0, this.lineStart = void 0, this.startLoc = void 0, this.endLoc = void 0, this.errors = [], this.potentialArrowAt = -1, this.noArrowAt = [], this.noArrowParamsConversionAt = [], this.maybeInArrowParameters = false, this.inType = false, this.noAnonFunctionType = false, this.hasFlowComment = false, this.isAmbientContext = false, this.inAbstractClass = false, this.inDisallowConditionalTypesContext = false, this.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null }, this.soloAwait = false, this.inFSharpPipelineDirectBody = false, this.labels = [], this.decoratorStack = [[]], this.comments = [], this.commentStack = [], this.pos = 0, this.type = 135, this.value = null, this.start = 0, this.end = 0, this.lastTokEndLoc = null, this.lastTokStartLoc = null, this.lastTokStart = 0, this.context = [z.brace], this.canStartJSXElement = true, this.containsEsc = false, this.strictErrors = /* @__PURE__ */ new Map(), this.tokensLength = 0;
              }
              init(t3) {
                let { strictMode: e, sourceType: s, startLine: r, startColumn: i } = t3;
                this.strict = e === false ? false : e === true ? true : s === "module", this.curLine = r, this.lineStart = -i, this.startLoc = this.endLoc = new p(r, i, 0);
              }
              curPosition() {
                return new p(this.curLine, this.pos - this.lineStart, this.pos);
              }
              clone(t3) {
                let e = new Sr(), s = Object.keys(this);
                for (let r = 0, i = s.length; r < i; r++) {
                  let a = s[r], n = this[a];
                  !t3 && Array.isArray(n) && (n = n.slice()), e[a] = n;
                }
                return e;
              }
            }, oh = ["at"], hh = ["at"], lh = function(e) {
              return e >= 48 && e <= 57;
            }, uh = /* @__PURE__ */ new Set([103, 109, 115, 105, 121, 117, 100, 118]), wr = { decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]), hex: /* @__PURE__ */ new Set([46, 88, 95, 120]) }, mt = { bin: (t3) => t3 === 48 || t3 === 49, oct: (t3) => t3 >= 48 && t3 <= 55, dec: (t3) => t3 >= 48 && t3 <= 57, hex: (t3) => t3 >= 48 && t3 <= 57 || t3 >= 65 && t3 <= 70 || t3 >= 97 && t3 <= 102 }, Ee = class {
              constructor(t3) {
                this.type = t3.type, this.value = t3.value, this.start = t3.start, this.end = t3.end, this.loc = new d(t3.startLoc, t3.endLoc);
              }
            }, ch = class extends ih {
              constructor(t3, e) {
                super(), this.isLookahead = void 0, this.tokens = [], this.state = new Sr(), this.state.init(t3), this.input = e, this.length = e.length, this.isLookahead = false;
              }
              pushToken(t3) {
                this.tokens.length = this.state.tokensLength, this.tokens.push(t3), ++this.state.tokensLength;
              }
              next() {
                this.checkKeywordEscapes(), this.options.tokens && this.pushToken(new Ee(this.state)), this.state.lastTokStart = this.state.start, this.state.lastTokEndLoc = this.state.endLoc, this.state.lastTokStartLoc = this.state.startLoc, this.nextToken();
              }
              eat(t3) {
                return this.match(t3) ? (this.next(), true) : false;
              }
              match(t3) {
                return this.state.type === t3;
              }
              createLookaheadState(t3) {
                return { pos: t3.pos, value: null, type: t3.type, start: t3.start, end: t3.end, context: [this.curContext()], inType: t3.inType, startLoc: t3.startLoc, lastTokEndLoc: t3.lastTokEndLoc, curLine: t3.curLine, lineStart: t3.lineStart, curPosition: t3.curPosition };
              }
              lookahead() {
                let t3 = this.state;
                this.state = this.createLookaheadState(t3), this.isLookahead = true, this.nextToken(), this.isLookahead = false;
                let e = this.state;
                return this.state = t3, e;
              }
              nextTokenStart() {
                return this.nextTokenStartSince(this.state.pos);
              }
              nextTokenStartSince(t3) {
                return ns.lastIndex = t3, ns.test(this.input) ? ns.lastIndex : t3;
              }
              lookaheadCharCode() {
                return this.input.charCodeAt(this.nextTokenStart());
              }
              codePointAtPos(t3) {
                let e = this.input.charCodeAt(t3);
                if ((e & 64512) === 55296 && ++t3 < this.input.length) {
                  let s = this.input.charCodeAt(t3);
                  (s & 64512) === 56320 && (e = 65536 + ((e & 1023) << 10) + (s & 1023));
                }
                return e;
              }
              setStrict(t3) {
                this.state.strict = t3, t3 && (this.state.strictErrors.forEach((e) => {
                  let [s, r] = e;
                  return this.raise(s, { at: r });
                }), this.state.strictErrors.clear());
              }
              curContext() {
                return this.state.context[this.state.context.length - 1];
              }
              nextToken() {
                if (this.skipSpace(), this.state.start = this.state.pos, this.isLookahead || (this.state.startLoc = this.state.curPosition()), this.state.pos >= this.length) {
                  this.finishToken(135);
                  return;
                }
                this.getTokenFromCode(this.codePointAtPos(this.state.pos));
              }
              skipBlockComment() {
                let t3;
                this.isLookahead || (t3 = this.state.curPosition());
                let e = this.state.pos, s = this.input.indexOf("*/", e + 2);
                if (s === -1)
                  throw this.raise(u.UnterminatedComment, { at: this.state.curPosition() });
                for (this.state.pos = s + 2, dt.lastIndex = e + 2; dt.test(this.input) && dt.lastIndex <= s; )
                  ++this.state.curLine, this.state.lineStart = dt.lastIndex;
                if (this.isLookahead)
                  return;
                let r = { type: "CommentBlock", value: this.input.slice(e + 2, s), start: e, end: s + 2, loc: new d(t3, this.state.curPosition()) };
                return this.options.tokens && this.pushToken(r), r;
              }
              skipLineComment(t3) {
                let e = this.state.pos, s;
                this.isLookahead || (s = this.state.curPosition());
                let r = this.input.charCodeAt(this.state.pos += t3);
                if (this.state.pos < this.length)
                  for (; !Ne(r) && ++this.state.pos < this.length; )
                    r = this.input.charCodeAt(this.state.pos);
                if (this.isLookahead)
                  return;
                let i = this.state.pos, a = this.input.slice(e + t3, i), n = { type: "CommentLine", value: a, start: e, end: i, loc: new d(s, this.state.curPosition()) };
                return this.options.tokens && this.pushToken(n), n;
              }
              skipSpace() {
                let t3 = this.state.pos, e = [];
                e:
                  for (; this.state.pos < this.length; ) {
                    let s = this.input.charCodeAt(this.state.pos);
                    switch (s) {
                      case 32:
                      case 160:
                      case 9:
                        ++this.state.pos;
                        break;
                      case 13:
                        this.input.charCodeAt(this.state.pos + 1) === 10 && ++this.state.pos;
                      case 10:
                      case 8232:
                      case 8233:
                        ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;
                        break;
                      case 47:
                        switch (this.input.charCodeAt(this.state.pos + 1)) {
                          case 42: {
                            let r = this.skipBlockComment();
                            r !== void 0 && (this.addComment(r), this.options.attachComment && e.push(r));
                            break;
                          }
                          case 47: {
                            let r = this.skipLineComment(2);
                            r !== void 0 && (this.addComment(r), this.options.attachComment && e.push(r));
                            break;
                          }
                          default:
                            break e;
                        }
                        break;
                      default:
                        if (nh(s))
                          ++this.state.pos;
                        else if (s === 45 && !this.inModule) {
                          let r = this.state.pos;
                          if (this.input.charCodeAt(r + 1) === 45 && this.input.charCodeAt(r + 2) === 62 && (t3 === 0 || this.state.lineStart > t3)) {
                            let i = this.skipLineComment(3);
                            i !== void 0 && (this.addComment(i), this.options.attachComment && e.push(i));
                          } else
                            break e;
                        } else if (s === 60 && !this.inModule) {
                          let r = this.state.pos;
                          if (this.input.charCodeAt(r + 1) === 33 && this.input.charCodeAt(r + 2) === 45 && this.input.charCodeAt(r + 3) === 45) {
                            let i = this.skipLineComment(4);
                            i !== void 0 && (this.addComment(i), this.options.attachComment && e.push(i));
                          } else
                            break e;
                        } else
                          break e;
                    }
                  }
                if (e.length > 0) {
                  let s = this.state.pos, r = { start: t3, end: s, comments: e, leadingNode: null, trailingNode: null, containingNode: null };
                  this.state.commentStack.push(r);
                }
              }
              finishToken(t3, e) {
                this.state.end = this.state.pos, this.state.endLoc = this.state.curPosition();
                let s = this.state.type;
                this.state.type = t3, this.state.value = e, this.isLookahead || this.updateContext(s);
              }
              replaceToken(t3) {
                this.state.type = t3, this.updateContext();
              }
              readToken_numberSign() {
                if (this.state.pos === 0 && this.readToken_interpreter())
                  return;
                let t3 = this.state.pos + 1, e = this.codePointAtPos(t3);
                if (e >= 48 && e <= 57)
                  throw this.raise(u.UnexpectedDigitAfterHash, { at: this.state.curPosition() });
                if (e === 123 || e === 91 && this.hasPlugin("recordAndTuple")) {
                  if (this.expectPlugin("recordAndTuple"), this.getPluginOption("recordAndTuple", "syntaxType") !== "hash")
                    throw this.raise(e === 123 ? u.RecordExpressionHashIncorrectStartSyntaxType : u.TupleExpressionHashIncorrectStartSyntaxType, { at: this.state.curPosition() });
                  this.state.pos += 2, e === 123 ? this.finishToken(7) : this.finishToken(1);
                } else
                  de(e) ? (++this.state.pos, this.finishToken(134, this.readWord1(e))) : e === 92 ? (++this.state.pos, this.finishToken(134, this.readWord1())) : this.finishOp(27, 1);
              }
              readToken_dot() {
                let t3 = this.input.charCodeAt(this.state.pos + 1);
                if (t3 >= 48 && t3 <= 57) {
                  this.readNumber(true);
                  return;
                }
                t3 === 46 && this.input.charCodeAt(this.state.pos + 2) === 46 ? (this.state.pos += 3, this.finishToken(21)) : (++this.state.pos, this.finishToken(16));
              }
              readToken_slash() {
                this.input.charCodeAt(this.state.pos + 1) === 61 ? this.finishOp(31, 2) : this.finishOp(56, 1);
              }
              readToken_interpreter() {
                if (this.state.pos !== 0 || this.length < 2)
                  return false;
                let t3 = this.input.charCodeAt(this.state.pos + 1);
                if (t3 !== 33)
                  return false;
                let e = this.state.pos;
                for (this.state.pos += 1; !Ne(t3) && ++this.state.pos < this.length; )
                  t3 = this.input.charCodeAt(this.state.pos);
                let s = this.input.slice(e + 2, this.state.pos);
                return this.finishToken(28, s), true;
              }
              readToken_mult_modulo(t3) {
                let e = t3 === 42 ? 55 : 54, s = 1, r = this.input.charCodeAt(this.state.pos + 1);
                t3 === 42 && r === 42 && (s++, r = this.input.charCodeAt(this.state.pos + 2), e = 57), r === 61 && !this.state.inType && (s++, e = t3 === 37 ? 33 : 30), this.finishOp(e, s);
              }
              readToken_pipe_amp(t3) {
                let e = this.input.charCodeAt(this.state.pos + 1);
                if (e === t3) {
                  this.input.charCodeAt(this.state.pos + 2) === 61 ? this.finishOp(30, 3) : this.finishOp(t3 === 124 ? 41 : 42, 2);
                  return;
                }
                if (t3 === 124) {
                  if (e === 62) {
                    this.finishOp(39, 2);
                    return;
                  }
                  if (this.hasPlugin("recordAndTuple") && e === 125) {
                    if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                      throw this.raise(u.RecordExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                    this.state.pos += 2, this.finishToken(9);
                    return;
                  }
                  if (this.hasPlugin("recordAndTuple") && e === 93) {
                    if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                      throw this.raise(u.TupleExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                    this.state.pos += 2, this.finishToken(4);
                    return;
                  }
                }
                if (e === 61) {
                  this.finishOp(30, 2);
                  return;
                }
                this.finishOp(t3 === 124 ? 43 : 45, 1);
              }
              readToken_caret() {
                let t3 = this.input.charCodeAt(this.state.pos + 1);
                if (t3 === 61 && !this.state.inType)
                  this.finishOp(32, 2);
                else if (t3 === 94 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "^^" }])) {
                  if (this.finishOp(37, 2), this.input.codePointAt(this.state.pos) === 94)
                    throw this.unexpected();
                } else
                  this.finishOp(44, 1);
              }
              readToken_atSign() {
                this.input.charCodeAt(this.state.pos + 1) === 64 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "@@" }]) ? this.finishOp(38, 2) : this.finishOp(26, 1);
              }
              readToken_plus_min(t3) {
                let e = this.input.charCodeAt(this.state.pos + 1);
                if (e === t3) {
                  this.finishOp(34, 2);
                  return;
                }
                e === 61 ? this.finishOp(30, 2) : this.finishOp(53, 1);
              }
              readToken_lt() {
                let { pos: t3 } = this.state, e = this.input.charCodeAt(t3 + 1);
                if (e === 60) {
                  if (this.input.charCodeAt(t3 + 2) === 61) {
                    this.finishOp(30, 3);
                    return;
                  }
                  this.finishOp(51, 2);
                  return;
                }
                if (e === 61) {
                  this.finishOp(49, 2);
                  return;
                }
                this.finishOp(47, 1);
              }
              readToken_gt() {
                let { pos: t3 } = this.state, e = this.input.charCodeAt(t3 + 1);
                if (e === 62) {
                  let s = this.input.charCodeAt(t3 + 2) === 62 ? 3 : 2;
                  if (this.input.charCodeAt(t3 + s) === 61) {
                    this.finishOp(30, s + 1);
                    return;
                  }
                  this.finishOp(52, s);
                  return;
                }
                if (e === 61) {
                  this.finishOp(49, 2);
                  return;
                }
                this.finishOp(48, 1);
              }
              readToken_eq_excl(t3) {
                let e = this.input.charCodeAt(this.state.pos + 1);
                if (e === 61) {
                  this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
                  return;
                }
                if (t3 === 61 && e === 62) {
                  this.state.pos += 2, this.finishToken(19);
                  return;
                }
                this.finishOp(t3 === 61 ? 29 : 35, 1);
              }
              readToken_question() {
                let t3 = this.input.charCodeAt(this.state.pos + 1), e = this.input.charCodeAt(this.state.pos + 2);
                t3 === 63 ? e === 61 ? this.finishOp(30, 3) : this.finishOp(40, 2) : t3 === 46 && !(e >= 48 && e <= 57) ? (this.state.pos += 2, this.finishToken(18)) : (++this.state.pos, this.finishToken(17));
              }
              getTokenFromCode(t3) {
                switch (t3) {
                  case 46:
                    this.readToken_dot();
                    return;
                  case 40:
                    ++this.state.pos, this.finishToken(10);
                    return;
                  case 41:
                    ++this.state.pos, this.finishToken(11);
                    return;
                  case 59:
                    ++this.state.pos, this.finishToken(13);
                    return;
                  case 44:
                    ++this.state.pos, this.finishToken(12);
                    return;
                  case 91:
                    if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                      if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                        throw this.raise(u.TupleExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                      this.state.pos += 2, this.finishToken(2);
                    } else
                      ++this.state.pos, this.finishToken(0);
                    return;
                  case 93:
                    ++this.state.pos, this.finishToken(3);
                    return;
                  case 123:
                    if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                      if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                        throw this.raise(u.RecordExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                      this.state.pos += 2, this.finishToken(6);
                    } else
                      ++this.state.pos, this.finishToken(5);
                    return;
                  case 125:
                    ++this.state.pos, this.finishToken(8);
                    return;
                  case 58:
                    this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58 ? this.finishOp(15, 2) : (++this.state.pos, this.finishToken(14));
                    return;
                  case 63:
                    this.readToken_question();
                    return;
                  case 96:
                    this.readTemplateToken();
                    return;
                  case 48: {
                    let e = this.input.charCodeAt(this.state.pos + 1);
                    if (e === 120 || e === 88) {
                      this.readRadixNumber(16);
                      return;
                    }
                    if (e === 111 || e === 79) {
                      this.readRadixNumber(8);
                      return;
                    }
                    if (e === 98 || e === 66) {
                      this.readRadixNumber(2);
                      return;
                    }
                  }
                  case 49:
                  case 50:
                  case 51:
                  case 52:
                  case 53:
                  case 54:
                  case 55:
                  case 56:
                  case 57:
                    this.readNumber(false);
                    return;
                  case 34:
                  case 39:
                    this.readString(t3);
                    return;
                  case 47:
                    this.readToken_slash();
                    return;
                  case 37:
                  case 42:
                    this.readToken_mult_modulo(t3);
                    return;
                  case 124:
                  case 38:
                    this.readToken_pipe_amp(t3);
                    return;
                  case 94:
                    this.readToken_caret();
                    return;
                  case 43:
                  case 45:
                    this.readToken_plus_min(t3);
                    return;
                  case 60:
                    this.readToken_lt();
                    return;
                  case 62:
                    this.readToken_gt();
                    return;
                  case 61:
                  case 33:
                    this.readToken_eq_excl(t3);
                    return;
                  case 126:
                    this.finishOp(36, 1);
                    return;
                  case 64:
                    this.readToken_atSign();
                    return;
                  case 35:
                    this.readToken_numberSign();
                    return;
                  case 92:
                    this.readWord();
                    return;
                  default:
                    if (de(t3)) {
                      this.readWord(t3);
                      return;
                    }
                }
                throw this.raise(u.InvalidOrUnexpectedToken, { at: this.state.curPosition(), unexpected: String.fromCodePoint(t3) });
              }
              finishOp(t3, e) {
                let s = this.input.slice(this.state.pos, this.state.pos + e);
                this.state.pos += e, this.finishToken(t3, s);
              }
              readRegexp() {
                let t3 = this.state.startLoc, e = this.state.start + 1, s, r, { pos: i } = this.state;
                for (; ; ++i) {
                  if (i >= this.length)
                    throw this.raise(u.UnterminatedRegExp, { at: m(t3, 1) });
                  let c = this.input.charCodeAt(i);
                  if (Ne(c))
                    throw this.raise(u.UnterminatedRegExp, { at: m(t3, 1) });
                  if (s)
                    s = false;
                  else {
                    if (c === 91)
                      r = true;
                    else if (c === 93 && r)
                      r = false;
                    else if (c === 47 && !r)
                      break;
                    s = c === 92;
                  }
                }
                let a = this.input.slice(e, i);
                ++i;
                let n = "", o = () => m(t3, i + 2 - e);
                for (; i < this.length; ) {
                  let c = this.codePointAtPos(i), f = String.fromCharCode(c);
                  if (uh.has(c))
                    c === 118 ? (this.expectPlugin("regexpUnicodeSets", o()), n.includes("u") && this.raise(u.IncompatibleRegExpUVFlags, { at: o() })) : c === 117 && n.includes("v") && this.raise(u.IncompatibleRegExpUVFlags, { at: o() }), n.includes(f) && this.raise(u.DuplicateRegExpFlags, { at: o() });
                  else if (Be(c) || c === 92)
                    this.raise(u.MalformedRegExpFlags, { at: o() });
                  else
                    break;
                  ++i, n += f;
                }
                this.state.pos = i, this.finishToken(133, { pattern: a, flags: n });
              }
              readInt(t3, e, s) {
                let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, i = this.state.pos, a = t3 === 16 ? wr.hex : wr.decBinOct, n = t3 === 16 ? mt.hex : t3 === 10 ? mt.dec : t3 === 8 ? mt.oct : mt.bin, o = false, c = 0;
                for (let f = 0, y = e == null ? 1 / 0 : e; f < y; ++f) {
                  let P = this.input.charCodeAt(this.state.pos), v;
                  if (P === 95 && r !== "bail") {
                    let N = this.input.charCodeAt(this.state.pos - 1), B = this.input.charCodeAt(this.state.pos + 1);
                    r ? (Number.isNaN(B) || !n(B) || a.has(N) || a.has(B)) && this.raise(u.UnexpectedNumericSeparator, { at: this.state.curPosition() }) : this.raise(u.NumericSeparatorInEscapeSequence, { at: this.state.curPosition() }), ++this.state.pos;
                    continue;
                  }
                  if (P >= 97 ? v = P - 97 + 10 : P >= 65 ? v = P - 65 + 10 : lh(P) ? v = P - 48 : v = 1 / 0, v >= t3)
                    if (this.options.errorRecovery && v <= 9)
                      v = 0, this.raise(u.InvalidDigit, { at: this.state.curPosition(), radix: t3 });
                    else if (s)
                      v = 0, o = true;
                    else
                      break;
                  ++this.state.pos, c = c * t3 + v;
                }
                return this.state.pos === i || e != null && this.state.pos - i !== e || o ? null : c;
              }
              readRadixNumber(t3) {
                let e = this.state.curPosition(), s = false;
                this.state.pos += 2;
                let r = this.readInt(t3);
                r == null && this.raise(u.InvalidDigit, { at: m(e, 2), radix: t3 });
                let i = this.input.charCodeAt(this.state.pos);
                if (i === 110)
                  ++this.state.pos, s = true;
                else if (i === 109)
                  throw this.raise(u.InvalidDecimal, { at: e });
                if (de(this.codePointAtPos(this.state.pos)))
                  throw this.raise(u.NumberIdentifier, { at: this.state.curPosition() });
                if (s) {
                  let a = this.input.slice(e.index, this.state.pos).replace(/[_n]/g, "");
                  this.finishToken(131, a);
                  return;
                }
                this.finishToken(130, r);
              }
              readNumber(t3) {
                let e = this.state.pos, s = this.state.curPosition(), r = false, i = false, a = false, n = false, o = false;
                !t3 && this.readInt(10) === null && this.raise(u.InvalidNumber, { at: this.state.curPosition() });
                let c = this.state.pos - e >= 2 && this.input.charCodeAt(e) === 48;
                if (c) {
                  let v = this.input.slice(e, this.state.pos);
                  if (this.recordStrictModeErrors(u.StrictOctalLiteral, { at: s }), !this.state.strict) {
                    let N = v.indexOf("_");
                    N > 0 && this.raise(u.ZeroDigitNumericSeparator, { at: m(s, N) });
                  }
                  o = c && !/[89]/.test(v);
                }
                let f = this.input.charCodeAt(this.state.pos);
                if (f === 46 && !o && (++this.state.pos, this.readInt(10), r = true, f = this.input.charCodeAt(this.state.pos)), (f === 69 || f === 101) && !o && (f = this.input.charCodeAt(++this.state.pos), (f === 43 || f === 45) && ++this.state.pos, this.readInt(10) === null && this.raise(u.InvalidOrMissingExponent, { at: s }), r = true, n = true, f = this.input.charCodeAt(this.state.pos)), f === 110 && ((r || c) && this.raise(u.InvalidBigIntLiteral, { at: s }), ++this.state.pos, i = true), f === 109 && (this.expectPlugin("decimal", this.state.curPosition()), (n || c) && this.raise(u.InvalidDecimal, { at: s }), ++this.state.pos, a = true), de(this.codePointAtPos(this.state.pos)))
                  throw this.raise(u.NumberIdentifier, { at: this.state.curPosition() });
                let y = this.input.slice(e, this.state.pos).replace(/[_mn]/g, "");
                if (i) {
                  this.finishToken(131, y);
                  return;
                }
                if (a) {
                  this.finishToken(132, y);
                  return;
                }
                let P = o ? parseInt(y, 8) : parseFloat(y);
                this.finishToken(130, P);
              }
              readCodePoint(t3) {
                let e = this.input.charCodeAt(this.state.pos), s;
                if (e === 123) {
                  if (++this.state.pos, s = this.readHexChar(this.input.indexOf("}", this.state.pos) - this.state.pos, true, t3), ++this.state.pos, s !== null && s > 1114111)
                    if (t3)
                      this.raise(u.InvalidCodePoint, { at: this.state.curPosition() });
                    else
                      return null;
                } else
                  s = this.readHexChar(4, false, t3);
                return s;
              }
              readString(t3) {
                let e = "", s = ++this.state.pos;
                for (; ; ) {
                  if (this.state.pos >= this.length)
                    throw this.raise(u.UnterminatedString, { at: this.state.startLoc });
                  let r = this.input.charCodeAt(this.state.pos);
                  if (r === t3)
                    break;
                  if (r === 92)
                    e += this.input.slice(s, this.state.pos), e += this.readEscapedChar(false), s = this.state.pos;
                  else if (r === 8232 || r === 8233)
                    ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;
                  else {
                    if (Ne(r))
                      throw this.raise(u.UnterminatedString, { at: this.state.startLoc });
                    ++this.state.pos;
                  }
                }
                e += this.input.slice(s, this.state.pos++), this.finishToken(129, e);
              }
              readTemplateContinuation() {
                this.match(8) || this.unexpected(null, 8), this.state.pos--, this.readTemplateToken();
              }
              readTemplateToken() {
                let t3 = "", e = this.state.pos, s = false;
                for (++this.state.pos; ; ) {
                  if (this.state.pos >= this.length)
                    throw this.raise(u.UnterminatedTemplate, { at: m(this.state.startLoc, 1) });
                  let r = this.input.charCodeAt(this.state.pos);
                  if (r === 96) {
                    ++this.state.pos, t3 += this.input.slice(e, this.state.pos), this.finishToken(24, s ? null : t3);
                    return;
                  }
                  if (r === 36 && this.input.charCodeAt(this.state.pos + 1) === 123) {
                    this.state.pos += 2, t3 += this.input.slice(e, this.state.pos), this.finishToken(25, s ? null : t3);
                    return;
                  }
                  if (r === 92) {
                    t3 += this.input.slice(e, this.state.pos);
                    let i = this.readEscapedChar(true);
                    i === null ? s = true : t3 += i, e = this.state.pos;
                  } else if (Ne(r)) {
                    switch (t3 += this.input.slice(e, this.state.pos), ++this.state.pos, r) {
                      case 13:
                        this.input.charCodeAt(this.state.pos) === 10 && ++this.state.pos;
                      case 10:
                        t3 += `
`;
                        break;
                      default:
                        t3 += String.fromCharCode(r);
                        break;
                    }
                    ++this.state.curLine, this.state.lineStart = this.state.pos, e = this.state.pos;
                  } else
                    ++this.state.pos;
                }
              }
              recordStrictModeErrors(t3, e) {
                let { at: s } = e, r = s.index;
                this.state.strict && !this.state.strictErrors.has(r) ? this.raise(t3, { at: s }) : this.state.strictErrors.set(r, [t3, s]);
              }
              readEscapedChar(t3) {
                let e = !t3, s = this.input.charCodeAt(++this.state.pos);
                switch (++this.state.pos, s) {
                  case 110:
                    return `
`;
                  case 114:
                    return "\r";
                  case 120: {
                    let r = this.readHexChar(2, false, e);
                    return r === null ? null : String.fromCharCode(r);
                  }
                  case 117: {
                    let r = this.readCodePoint(e);
                    return r === null ? null : String.fromCodePoint(r);
                  }
                  case 116:
                    return "	";
                  case 98:
                    return "\b";
                  case 118:
                    return "\v";
                  case 102:
                    return "\f";
                  case 13:
                    this.input.charCodeAt(this.state.pos) === 10 && ++this.state.pos;
                  case 10:
                    this.state.lineStart = this.state.pos, ++this.state.curLine;
                  case 8232:
                  case 8233:
                    return "";
                  case 56:
                  case 57:
                    if (t3)
                      return null;
                    this.recordStrictModeErrors(u.StrictNumericEscape, { at: m(this.state.curPosition(), -1) });
                  default:
                    if (s >= 48 && s <= 55) {
                      let r = m(this.state.curPosition(), -1), a = this.input.slice(this.state.pos - 1, this.state.pos + 2).match(/^[0-7]+/)[0], n = parseInt(a, 8);
                      n > 255 && (a = a.slice(0, -1), n = parseInt(a, 8)), this.state.pos += a.length - 1;
                      let o = this.input.charCodeAt(this.state.pos);
                      if (a !== "0" || o === 56 || o === 57) {
                        if (t3)
                          return null;
                        this.recordStrictModeErrors(u.StrictNumericEscape, { at: r });
                      }
                      return String.fromCharCode(n);
                    }
                    return String.fromCharCode(s);
                }
              }
              readHexChar(t3, e, s) {
                let r = this.state.curPosition(), i = this.readInt(16, t3, e, false);
                return i === null && (s ? this.raise(u.InvalidEscapeSequence, { at: r }) : this.state.pos = r.index - 1), i;
              }
              readWord1(t3) {
                this.state.containsEsc = false;
                let e = "", s = this.state.pos, r = this.state.pos;
                for (t3 !== void 0 && (this.state.pos += t3 <= 65535 ? 1 : 2); this.state.pos < this.length; ) {
                  let i = this.codePointAtPos(this.state.pos);
                  if (Be(i))
                    this.state.pos += i <= 65535 ? 1 : 2;
                  else if (i === 92) {
                    this.state.containsEsc = true, e += this.input.slice(r, this.state.pos);
                    let a = this.state.curPosition(), n = this.state.pos === s ? de : Be;
                    if (this.input.charCodeAt(++this.state.pos) !== 117) {
                      this.raise(u.MissingUnicodeEscape, { at: this.state.curPosition() }), r = this.state.pos - 1;
                      continue;
                    }
                    ++this.state.pos;
                    let o = this.readCodePoint(true);
                    o !== null && (n(o) || this.raise(u.EscapedCharNotAnIdentifier, { at: a }), e += String.fromCodePoint(o)), r = this.state.pos;
                  } else
                    break;
                }
                return e + this.input.slice(r, this.state.pos);
              }
              readWord(t3) {
                let e = this.readWord1(t3), s = qt.get(e);
                s !== void 0 ? this.finishToken(s, Pe(s)) : this.finishToken(128, e);
              }
              checkKeywordEscapes() {
                let { type: t3 } = this.state;
                Ht(t3) && this.state.containsEsc && this.raise(u.InvalidEscapedReservedWord, { at: this.state.startLoc, reservedWord: Pe(t3) });
              }
              raise(t3, e) {
                let { at: s } = e, r = l(e, oh), i = s instanceof p ? s : s.loc.start, a = t3({ loc: i, details: r });
                if (!this.options.errorRecovery)
                  throw a;
                return this.isLookahead || this.state.errors.push(a), a;
              }
              raiseOverwrite(t3, e) {
                let { at: s } = e, r = l(e, hh), i = s instanceof p ? s : s.loc.start, a = i.index, n = this.state.errors;
                for (let o = n.length - 1; o >= 0; o--) {
                  let c = n[o];
                  if (c.loc.index === a)
                    return n[o] = t3({ loc: i, details: r });
                  if (c.loc.index < a)
                    break;
                }
                return this.raise(t3, e);
              }
              updateContext(t3) {
              }
              unexpected(t3, e) {
                throw this.raise(u.UnexpectedToken, { expected: e ? Pe(e) : null, at: t3 != null ? t3 : this.state.startLoc });
              }
              expectPlugin(t3, e) {
                if (this.hasPlugin(t3))
                  return true;
                throw this.raise(u.MissingPlugin, { at: e != null ? e : this.state.startLoc, missingPlugin: [t3] });
              }
              expectOnePlugin(t3) {
                if (!t3.some((e) => this.hasPlugin(e)))
                  throw this.raise(u.MissingOneOfPlugins, { at: this.state.startLoc, missingPlugin: t3 });
              }
            }, os = class {
              constructor(t3) {
                this.var = /* @__PURE__ */ new Set(), this.lexical = /* @__PURE__ */ new Set(), this.functions = /* @__PURE__ */ new Set(), this.flags = t3;
              }
            }, hs = class {
              constructor(t3, e) {
                this.parser = void 0, this.scopeStack = [], this.inModule = void 0, this.undefinedExports = /* @__PURE__ */ new Map(), this.parser = t3, this.inModule = e;
              }
              get inFunction() {
                return (this.currentVarScopeFlags() & me) > 0;
              }
              get allowSuper() {
                return (this.currentThisScopeFlags() & ot) > 0;
              }
              get allowDirectSuper() {
                return (this.currentThisScopeFlags() & xr) > 0;
              }
              get inClass() {
                return (this.currentThisScopeFlags() & Se) > 0;
              }
              get inClassAndNotInNonArrowFunction() {
                let t3 = this.currentThisScopeFlags();
                return (t3 & Se) > 0 && (t3 & me) === 0;
              }
              get inStaticBlock() {
                for (let t3 = this.scopeStack.length - 1; ; t3--) {
                  let { flags: e } = this.scopeStack[t3];
                  if (e & Yt)
                    return true;
                  if (e & (lt2 | Se))
                    return false;
                }
              }
              get inNonArrowFunction() {
                return (this.currentThisScopeFlags() & me) > 0;
              }
              get treatFunctionsAsVar() {
                return this.treatFunctionsAsVarInScope(this.currentScope());
              }
              createScope(t3) {
                return new os(t3);
              }
              enter(t3) {
                this.scopeStack.push(this.createScope(t3));
              }
              exit() {
                this.scopeStack.pop();
              }
              treatFunctionsAsVarInScope(t3) {
                return !!(t3.flags & (me | Yt) || !this.parser.inModule && t3.flags & We);
              }
              declareName(t3, e, s) {
                let r = this.currentScope();
                if (e & Te || e & ut)
                  this.checkRedeclarationInScope(r, t3, e, s), e & ut ? r.functions.add(t3) : r.lexical.add(t3), e & Te && this.maybeExportDefined(r, t3);
                else if (e & gr)
                  for (let i = this.scopeStack.length - 1; i >= 0 && (r = this.scopeStack[i], this.checkRedeclarationInScope(r, t3, e, s), r.var.add(t3), this.maybeExportDefined(r, t3), !(r.flags & lt2)); --i)
                    ;
                this.parser.inModule && r.flags & We && this.undefinedExports.delete(t3);
              }
              maybeExportDefined(t3, e) {
                this.parser.inModule && t3.flags & We && this.undefinedExports.delete(e);
              }
              checkRedeclarationInScope(t3, e, s, r) {
                this.isRedeclaredInScope(t3, e, s) && this.parser.raise(u.VarRedeclaration, { at: r, identifierName: e });
              }
              isRedeclaredInScope(t3, e, s) {
                return s & ye ? s & Te ? t3.lexical.has(e) || t3.functions.has(e) || t3.var.has(e) : s & ut ? t3.lexical.has(e) || !this.treatFunctionsAsVarInScope(t3) && t3.var.has(e) : t3.lexical.has(e) && !(t3.flags & yr && t3.lexical.values().next().value === e) || !this.treatFunctionsAsVarInScope(t3) && t3.functions.has(e) : false;
              }
              checkLocalExport(t3) {
                let { name: e } = t3, s = this.scopeStack[0];
                !s.lexical.has(e) && !s.var.has(e) && !s.functions.has(e) && this.undefinedExports.set(e, t3.loc.start);
              }
              currentScope() {
                return this.scopeStack[this.scopeStack.length - 1];
              }
              currentVarScopeFlags() {
                for (let t3 = this.scopeStack.length - 1; ; t3--) {
                  let { flags: e } = this.scopeStack[t3];
                  if (e & lt2)
                    return e;
                }
              }
              currentThisScopeFlags() {
                for (let t3 = this.scopeStack.length - 1; ; t3--) {
                  let { flags: e } = this.scopeStack[t3];
                  if (e & (lt2 | Se) && !(e & Jt))
                    return e;
                }
              }
            }, ph = class extends os {
              constructor() {
                super(...arguments), this.declareFunctions = /* @__PURE__ */ new Set();
              }
            }, fh = class extends hs {
              createScope(t3) {
                return new ph(t3);
              }
              declareName(t3, e, s) {
                let r = this.currentScope();
                if (e & es) {
                  this.checkRedeclarationInScope(r, t3, e, s), this.maybeExportDefined(r, t3), r.declareFunctions.add(t3);
                  return;
                }
                super.declareName(...arguments);
              }
              isRedeclaredInScope(t3, e, s) {
                return super.isRedeclaredInScope(...arguments) ? true : s & es ? !t3.declareFunctions.has(e) && (t3.lexical.has(e) || t3.functions.has(e)) : false;
              }
              checkLocalExport(t3) {
                this.scopeStack[0].declareFunctions.has(t3.name) || super.checkLocalExport(t3);
              }
            }, dh = class {
              constructor() {
                this.privateNames = /* @__PURE__ */ new Set(), this.loneAccessors = /* @__PURE__ */ new Map(), this.undefinedPrivateNames = /* @__PURE__ */ new Map();
              }
            }, mh = class {
              constructor(t3) {
                this.parser = void 0, this.stack = [], this.undefinedPrivateNames = /* @__PURE__ */ new Map(), this.parser = t3;
              }
              current() {
                return this.stack[this.stack.length - 1];
              }
              enter() {
                this.stack.push(new dh());
              }
              exit() {
                let t3 = this.stack.pop(), e = this.current();
                for (let [s, r] of Array.from(t3.undefinedPrivateNames))
                  e ? e.undefinedPrivateNames.has(s) || e.undefinedPrivateNames.set(s, r) : this.parser.raise(u.InvalidPrivateFieldResolution, { at: r, identifierName: s });
              }
              declarePrivateName(t3, e, s) {
                let { privateNames: r, loneAccessors: i, undefinedPrivateNames: a } = this.current(), n = r.has(t3);
                if (e & rs) {
                  let o = n && i.get(t3);
                  if (o) {
                    let c = o & ft, f = e & ft, y = o & rs, P = e & rs;
                    n = y === P || c !== f, n || i.delete(t3);
                  } else
                    n || i.set(t3, e);
                }
                n && this.parser.raise(u.PrivateNameRedeclaration, { at: s, identifierName: t3 }), r.add(t3), a.delete(t3);
              }
              usePrivateName(t3, e) {
                let s;
                for (s of this.stack)
                  if (s.privateNames.has(t3))
                    return;
                s ? s.undefinedPrivateNames.set(t3, e) : this.parser.raise(u.InvalidPrivateFieldResolution, { at: e, identifierName: t3 });
              }
            }, yh = 0, Nr = 1, ls = 2, Ir = 3, yt = class {
              constructor() {
                let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : yh;
                this.type = void 0, this.type = t3;
              }
              canBeArrowParameterDeclaration() {
                return this.type === ls || this.type === Nr;
              }
              isCertainlyParameterDeclaration() {
                return this.type === Ir;
              }
            }, kr = class extends yt {
              constructor(t3) {
                super(t3), this.declarationErrors = /* @__PURE__ */ new Map();
              }
              recordDeclarationError(t3, e) {
                let { at: s } = e, r = s.index;
                this.declarationErrors.set(r, [t3, s]);
              }
              clearDeclarationError(t3) {
                this.declarationErrors.delete(t3);
              }
              iterateErrors(t3) {
                this.declarationErrors.forEach(t3);
              }
            }, xh = class {
              constructor(t3) {
                this.parser = void 0, this.stack = [new yt()], this.parser = t3;
              }
              enter(t3) {
                this.stack.push(t3);
              }
              exit() {
                this.stack.pop();
              }
              recordParameterInitializerError(t3, e) {
                let { at: s } = e, r = { at: s.loc.start }, { stack: i } = this, a = i.length - 1, n = i[a];
                for (; !n.isCertainlyParameterDeclaration(); ) {
                  if (n.canBeArrowParameterDeclaration())
                    n.recordDeclarationError(t3, r);
                  else
                    return;
                  n = i[--a];
                }
                this.parser.raise(t3, r);
              }
              recordArrowParemeterBindingError(t3, e) {
                let { at: s } = e, { stack: r } = this, i = r[r.length - 1], a = { at: s.loc.start };
                if (i.isCertainlyParameterDeclaration())
                  this.parser.raise(t3, a);
                else if (i.canBeArrowParameterDeclaration())
                  i.recordDeclarationError(t3, a);
                else
                  return;
              }
              recordAsyncArrowParametersError(t3) {
                let { at: e } = t3, { stack: s } = this, r = s.length - 1, i = s[r];
                for (; i.canBeArrowParameterDeclaration(); )
                  i.type === ls && i.recordDeclarationError(u.AwaitBindingIdentifier, { at: e }), i = s[--r];
              }
              validateAsPattern() {
                let { stack: t3 } = this, e = t3[t3.length - 1];
                !e.canBeArrowParameterDeclaration() || e.iterateErrors((s) => {
                  let [r, i] = s;
                  this.parser.raise(r, { at: i });
                  let a = t3.length - 2, n = t3[a];
                  for (; n.canBeArrowParameterDeclaration(); )
                    n.clearDeclarationError(i.index), n = t3[--a];
                });
              }
            };
            function gh() {
              return new yt(Ir);
            }
            function Ah() {
              return new kr(Nr);
            }
            function Ph() {
              return new kr(ls);
            }
            function Dr() {
              return new yt();
            }
            var je = 0, Fr = 1, xt = 2, Lr = 4, qe = 8, Th = class {
              constructor() {
                this.stacks = [];
              }
              enter(t3) {
                this.stacks.push(t3);
              }
              exit() {
                this.stacks.pop();
              }
              currentFlags() {
                return this.stacks[this.stacks.length - 1];
              }
              get hasAwait() {
                return (this.currentFlags() & xt) > 0;
              }
              get hasYield() {
                return (this.currentFlags() & Fr) > 0;
              }
              get hasReturn() {
                return (this.currentFlags() & Lr) > 0;
              }
              get hasIn() {
                return (this.currentFlags() & qe) > 0;
              }
            };
            function gt2(t3, e) {
              return (t3 ? xt : 0) | (e ? Fr : 0);
            }
            var Eh = class extends ch {
              addExtra(t3, e, s) {
                let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
                if (!t3)
                  return;
                let i = t3.extra = t3.extra || {};
                r ? i[e] = s : Object.defineProperty(i, e, { enumerable: r, value: s });
              }
              isContextual(t3) {
                return this.state.type === t3 && !this.state.containsEsc;
              }
              isUnparsedContextual(t3, e) {
                let s = t3 + e.length;
                if (this.input.slice(t3, s) === e) {
                  let r = this.input.charCodeAt(s);
                  return !(Be(r) || (r & 64512) === 55296);
                }
                return false;
              }
              isLookaheadContextual(t3) {
                let e = this.nextTokenStart();
                return this.isUnparsedContextual(e, t3);
              }
              eatContextual(t3) {
                return this.isContextual(t3) ? (this.next(), true) : false;
              }
              expectContextual(t3, e) {
                if (!this.eatContextual(t3))
                  throw e != null ? this.raise(e, { at: this.state.startLoc }) : this.unexpected(null, t3);
              }
              canInsertSemicolon() {
                return this.match(135) || this.match(8) || this.hasPrecedingLineBreak();
              }
              hasPrecedingLineBreak() {
                return as.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
              }
              hasFollowingLineBreak() {
                return vr.lastIndex = this.state.end, vr.test(this.input);
              }
              isLineTerminator() {
                return this.eat(13) || this.canInsertSemicolon();
              }
              semicolon() {
                ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true) ? this.isLineTerminator() : this.eat(13)) || this.raise(u.MissingSemicolon, { at: this.state.lastTokEndLoc });
              }
              expect(t3, e) {
                this.eat(t3) || this.unexpected(e, t3);
              }
              tryParse(t3) {
                let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.clone(), s = { node: null };
                try {
                  let r = t3(function() {
                    let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                    throw s.node = i, s;
                  });
                  if (this.state.errors.length > e.errors.length) {
                    let i = this.state;
                    return this.state = e, this.state.tokensLength = i.tokensLength, { node: r, error: i.errors[e.errors.length], thrown: false, aborted: false, failState: i };
                  }
                  return { node: r, error: null, thrown: false, aborted: false, failState: null };
                } catch (r) {
                  let i = this.state;
                  if (this.state = e, r instanceof SyntaxError)
                    return { node: null, error: r, thrown: true, aborted: false, failState: i };
                  if (r === s)
                    return { node: s.node, error: null, thrown: false, aborted: true, failState: i };
                  throw r;
                }
              }
              checkExpressionErrors(t3, e) {
                if (!t3)
                  return false;
                let { shorthandAssignLoc: s, doubleProtoLoc: r, privateKeyLoc: i, optionalParametersLoc: a } = t3, n = !!s || !!r || !!a || !!i;
                if (!e)
                  return n;
                s != null && this.raise(u.InvalidCoverInitializedName, { at: s }), r != null && this.raise(u.DuplicateProto, { at: r }), i != null && this.raise(u.UnexpectedPrivateField, { at: i }), a != null && this.unexpected(a);
              }
              isLiteralPropertyName() {
                return hr(this.state.type);
              }
              isPrivateName(t3) {
                return t3.type === "PrivateName";
              }
              getPrivateNameSV(t3) {
                return t3.id.name;
              }
              hasPropertyAsPrivateName(t3) {
                return (t3.type === "MemberExpression" || t3.type === "OptionalMemberExpression") && this.isPrivateName(t3.property);
              }
              isOptionalChain(t3) {
                return t3.type === "OptionalMemberExpression" || t3.type === "OptionalCallExpression";
              }
              isObjectProperty(t3) {
                return t3.type === "ObjectProperty";
              }
              isObjectMethod(t3) {
                return t3.type === "ObjectMethod";
              }
              initializeScopes() {
                let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.sourceType === "module", e = this.state.labels;
                this.state.labels = [];
                let s = this.exportedIdentifiers;
                this.exportedIdentifiers = /* @__PURE__ */ new Set();
                let r = this.inModule;
                this.inModule = t3;
                let i = this.scope, a = this.getScopeHandler();
                this.scope = new a(this, t3);
                let n = this.prodParam;
                this.prodParam = new Th();
                let o = this.classScope;
                this.classScope = new mh(this);
                let c = this.expressionScope;
                return this.expressionScope = new xh(this), () => {
                  this.state.labels = e, this.exportedIdentifiers = s, this.inModule = r, this.scope = i, this.prodParam = n, this.classScope = o, this.expressionScope = c;
                };
              }
              enterInitialScopes() {
                let t3 = je;
                this.inModule && (t3 |= xt), this.scope.enter(We), this.prodParam.enter(t3);
              }
              checkDestructuringPrivate(t3) {
                let { privateKeyLoc: e } = t3;
                e !== null && this.expectPlugin("destructuringPrivate", e);
              }
            }, At = class {
              constructor() {
                this.shorthandAssignLoc = null, this.doubleProtoLoc = null, this.privateKeyLoc = null, this.optionalParametersLoc = null;
              }
            }, Pt = class {
              constructor(t3, e, s) {
                this.type = "", this.start = e, this.end = 0, this.loc = new d(s), t3 != null && t3.options.ranges && (this.range = [e, 0]), t3 != null && t3.filename && (this.loc.filename = t3.filename);
              }
            }, us = Pt.prototype;
            us.__clone = function() {
              let t3 = new Pt(), e = Object.keys(this);
              for (let s = 0, r = e.length; s < r; s++) {
                let i = e[s];
                i !== "leadingComments" && i !== "trailingComments" && i !== "innerComments" && (t3[i] = this[i]);
              }
              return t3;
            };
            function Ch(t3) {
              return ge(t3);
            }
            function ge(t3) {
              let { type: e, start: s, end: r, loc: i, range: a, extra: n, name: o } = t3, c = Object.create(us);
              return c.type = e, c.start = s, c.end = r, c.loc = i, c.range = a, c.extra = n, c.name = o, e === "Placeholder" && (c.expectedNode = t3.expectedNode), c;
            }
            function bh(t3) {
              let { type: e, start: s, end: r, loc: i, range: a, extra: n } = t3;
              if (e === "Placeholder")
                return Ch(t3);
              let o = Object.create(us);
              return o.type = e, o.start = s, o.end = r, o.loc = i, o.range = a, t3.raw !== void 0 ? o.raw = t3.raw : o.extra = n, o.value = t3.value, o;
            }
            var vh = class extends Eh {
              startNode() {
                return new Pt(this, this.state.start, this.state.startLoc);
              }
              startNodeAt(t3, e) {
                return new Pt(this, t3, e);
              }
              startNodeAtNode(t3) {
                return this.startNodeAt(t3.start, t3.loc.start);
              }
              finishNode(t3, e) {
                return this.finishNodeAt(t3, e, this.state.lastTokEndLoc);
              }
              finishNodeAt(t3, e, s) {
                return t3.type = e, t3.end = s.index, t3.loc.end = s, this.options.ranges && (t3.range[1] = s.index), this.options.attachComment && this.processComment(t3), t3;
              }
              resetStartLocation(t3, e, s) {
                t3.start = e, t3.loc.start = s, this.options.ranges && (t3.range[0] = e);
              }
              resetEndLocation(t3) {
                let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
                t3.end = e.index, t3.loc.end = e, this.options.ranges && (t3.range[1] = e.index);
              }
              resetStartLocationFromNode(t3, e) {
                this.resetStartLocation(t3, e.start, e.loc.start);
              }
            }, Sh = /* @__PURE__ */ new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]), I = j(zn || (zn = rt(["flow"])))((t3) => ({ AmbiguousConditionalArrow: t3("Ambiguous expression: wrap the arrow functions in parentheses to disambiguate."), AmbiguousDeclareModuleKind: t3("Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module."), AssignReservedType: t3((e) => {
              let { reservedType: s } = e;
              return "Cannot overwrite reserved type ".concat(s, ".");
            }), DeclareClassElement: t3("The `declare` modifier can only appear on class fields."), DeclareClassFieldInitializer: t3("Initializers are not allowed in fields with the `declare` modifier."), DuplicateDeclareModuleExports: t3("Duplicate `declare module.exports` statement."), EnumBooleanMemberNotInitialized: t3((e) => {
              let { memberName: s, enumName: r } = e;
              return "Boolean enum members need to be initialized. Use either `".concat(s, " = true,` or `").concat(s, " = false,` in enum `").concat(r, "`.");
            }), EnumDuplicateMemberName: t3((e) => {
              let { memberName: s, enumName: r } = e;
              return "Enum member names need to be unique, but the name `".concat(s, "` has already been used before in enum `").concat(r, "`.");
            }), EnumInconsistentMemberValues: t3((e) => {
              let { enumName: s } = e;
              return "Enum `".concat(s, "` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.");
            }), EnumInvalidExplicitType: t3((e) => {
              let { invalidEnumType: s, enumName: r } = e;
              return "Enum type `".concat(s, "` is not valid. Use one of `boolean`, `number`, `string`, or `symbol` in enum `").concat(r, "`.");
            }), EnumInvalidExplicitTypeUnknownSupplied: t3((e) => {
              let { enumName: s } = e;
              return "Supplied enum type is not valid. Use one of `boolean`, `number`, `string`, or `symbol` in enum `".concat(s, "`.");
            }), EnumInvalidMemberInitializerPrimaryType: t3((e) => {
              let { enumName: s, memberName: r, explicitType: i } = e;
              return "Enum `".concat(s, "` has type `").concat(i, "`, so the initializer of `").concat(r, "` needs to be a ").concat(i, " literal.");
            }), EnumInvalidMemberInitializerSymbolType: t3((e) => {
              let { enumName: s, memberName: r } = e;
              return "Symbol enum members cannot be initialized. Use `".concat(r, ",` in enum `").concat(s, "`.");
            }), EnumInvalidMemberInitializerUnknownType: t3((e) => {
              let { enumName: s, memberName: r } = e;
              return "The enum member initializer for `".concat(r, "` needs to be a literal (either a boolean, number, or string) in enum `").concat(s, "`.");
            }), EnumInvalidMemberName: t3((e) => {
              let { enumName: s, memberName: r, suggestion: i } = e;
              return "Enum member names cannot start with lowercase 'a' through 'z'. Instead of using `".concat(r, "`, consider using `").concat(i, "`, in enum `").concat(s, "`.");
            }), EnumNumberMemberNotInitialized: t3((e) => {
              let { enumName: s, memberName: r } = e;
              return "Number enum members need to be initialized, e.g. `".concat(r, " = 1` in enum `").concat(s, "`.");
            }), EnumStringMemberInconsistentlyInitailized: t3((e) => {
              let { enumName: s } = e;
              return "String enum members need to consistently either all use initializers, or use no initializers, in enum `".concat(s, "`.");
            }), GetterMayNotHaveThisParam: t3("A getter cannot have a `this` parameter."), ImportTypeShorthandOnlyInPureImport: t3("The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements."), InexactInsideExact: t3("Explicit inexact syntax cannot appear inside an explicit exact object type."), InexactInsideNonObject: t3("Explicit inexact syntax cannot appear in class or interface definitions."), InexactVariance: t3("Explicit inexact syntax cannot have variance."), InvalidNonTypeImportInDeclareModule: t3("Imports within a `declare module` body must always be `import type` or `import typeof`."), MissingTypeParamDefault: t3("Type parameter declaration needs a default, since a preceding type parameter declaration has a default."), NestedDeclareModule: t3("`declare module` cannot be used inside another `declare module`."), NestedFlowComment: t3("Cannot have a flow comment inside another flow comment."), PatternIsOptional: t3("A binding pattern parameter cannot be optional in an implementation signature.", { reasonCode: "OptionalBindingPattern" }), SetterMayNotHaveThisParam: t3("A setter cannot have a `this` parameter."), SpreadVariance: t3("Spread properties cannot have variance."), ThisParamAnnotationRequired: t3("A type annotation is required for the `this` parameter."), ThisParamBannedInConstructor: t3("Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions."), ThisParamMayNotBeOptional: t3("The `this` parameter cannot be optional."), ThisParamMustBeFirst: t3("The `this` parameter must be the first function parameter."), ThisParamNoDefault: t3("The `this` parameter may not have a default value."), TypeBeforeInitializer: t3("Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`."), TypeCastInPattern: t3("The type cast expression is expected to be wrapped with parenthesis."), UnexpectedExplicitInexactInObject: t3("Explicit inexact syntax must appear at the end of an inexact object."), UnexpectedReservedType: t3((e) => {
              let { reservedType: s } = e;
              return "Unexpected reserved type ".concat(s, ".");
            }), UnexpectedReservedUnderscore: t3("`_` is only allowed as a type argument to call or new."), UnexpectedSpaceBetweenModuloChecks: t3("Spaces between `%` and `checks` are not allowed here."), UnexpectedSpreadType: t3("Spread operator cannot appear in class or interface definitions."), UnexpectedSubtractionOperand: t3('Unexpected token, expected "number" or "bigint".'), UnexpectedTokenAfterTypeParameter: t3("Expected an arrow function after this type parameter declaration."), UnexpectedTypeParameterBeforeAsyncArrowFunction: t3("Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`."), UnsupportedDeclareExportKind: t3((e) => {
              let { unsupportedExportKind: s, suggestion: r } = e;
              return "`declare export ".concat(s, "` is not supported. Use `").concat(r, "` instead.");
            }), UnsupportedStatementInDeclareModule: t3("Only declares and type imports are allowed inside declare module."), UnterminatedFlowComment: t3("Unterminated flow-comment.") }));
            function wh(t3) {
              return t3.type === "DeclareExportAllDeclaration" || t3.type === "DeclareExportDeclaration" && (!t3.declaration || t3.declaration.type !== "TypeAlias" && t3.declaration.type !== "InterfaceDeclaration");
            }
            function cs(t3) {
              return t3.importKind === "type" || t3.importKind === "typeof";
            }
            function Or(t3) {
              return pe(t3) && t3 !== 97;
            }
            var Nh = { const: "declare export var", let: "declare export var", type: "export type", interface: "export interface" };
            function Ih(t3, e) {
              let s = [], r = [];
              for (let i = 0; i < t3.length; i++)
                (e(t3[i], i, t3) ? s : r).push(t3[i]);
              return [s, r];
            }
            var kh = /\*?\s*@((?:no)?flow)\b/, Dh = (t3) => class extends t3 {
              constructor() {
                super(...arguments), this.flowPragma = void 0;
              }
              getScopeHandler() {
                return fh;
              }
              shouldParseTypes() {
                return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
              }
              shouldParseEnums() {
                return !!this.getPluginOption("flow", "enums");
              }
              finishToken(e, s) {
                return e !== 129 && e !== 13 && e !== 28 && this.flowPragma === void 0 && (this.flowPragma = null), super.finishToken(e, s);
              }
              addComment(e) {
                if (this.flowPragma === void 0) {
                  let s = kh.exec(e.value);
                  if (s)
                    if (s[1] === "flow")
                      this.flowPragma = "flow";
                    else if (s[1] === "noflow")
                      this.flowPragma = "noflow";
                    else
                      throw new Error("Unexpected flow pragma");
                }
                return super.addComment(e);
              }
              flowParseTypeInitialiser(e) {
                let s = this.state.inType;
                this.state.inType = true, this.expect(e || 14);
                let r = this.flowParseType();
                return this.state.inType = s, r;
              }
              flowParsePredicate() {
                let e = this.startNode(), s = this.state.startLoc;
                return this.next(), this.expectContextual(107), this.state.lastTokStart > s.index + 1 && this.raise(I.UnexpectedSpaceBetweenModuloChecks, { at: s }), this.eat(10) ? (e.value = this.parseExpression(), this.expect(11), this.finishNode(e, "DeclaredPredicate")) : this.finishNode(e, "InferredPredicate");
              }
              flowParseTypeAndPredicateInitialiser() {
                let e = this.state.inType;
                this.state.inType = true, this.expect(14);
                let s = null, r = null;
                return this.match(54) ? (this.state.inType = e, r = this.flowParsePredicate()) : (s = this.flowParseType(), this.state.inType = e, this.match(54) && (r = this.flowParsePredicate())), [s, r];
              }
              flowParseDeclareClass(e) {
                return this.next(), this.flowParseInterfaceish(e, true), this.finishNode(e, "DeclareClass");
              }
              flowParseDeclareFunction(e) {
                this.next();
                let s = e.id = this.parseIdentifier(), r = this.startNode(), i = this.startNode();
                this.match(47) ? r.typeParameters = this.flowParseTypeParameterDeclaration() : r.typeParameters = null, this.expect(10);
                let a = this.flowParseFunctionTypeParams();
                return r.params = a.params, r.rest = a.rest, r.this = a._this, this.expect(11), [r.returnType, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), i.typeAnnotation = this.finishNode(r, "FunctionTypeAnnotation"), s.typeAnnotation = this.finishNode(i, "TypeAnnotation"), this.resetEndLocation(s), this.semicolon(), this.scope.declareName(e.id.name, $o, e.id.loc.start), this.finishNode(e, "DeclareFunction");
              }
              flowParseDeclare(e, s) {
                if (this.match(80))
                  return this.flowParseDeclareClass(e);
                if (this.match(68))
                  return this.flowParseDeclareFunction(e);
                if (this.match(74))
                  return this.flowParseDeclareVariable(e);
                if (this.eatContextual(123))
                  return this.match(16) ? this.flowParseDeclareModuleExports(e) : (s && this.raise(I.NestedDeclareModule, { at: this.state.lastTokStartLoc }), this.flowParseDeclareModule(e));
                if (this.isContextual(126))
                  return this.flowParseDeclareTypeAlias(e);
                if (this.isContextual(127))
                  return this.flowParseDeclareOpaqueType(e);
                if (this.isContextual(125))
                  return this.flowParseDeclareInterface(e);
                if (this.match(82))
                  return this.flowParseDeclareExportDeclaration(e, s);
                throw this.unexpected();
              }
              flowParseDeclareVariable(e) {
                return this.next(), e.id = this.flowParseTypeAnnotatableIdentifier(true), this.scope.declareName(e.id.name, pt, e.id.loc.start), this.semicolon(), this.finishNode(e, "DeclareVariable");
              }
              flowParseDeclareModule(e) {
                this.scope.enter(Me), this.match(129) ? e.id = this.parseExprAtom() : e.id = this.parseIdentifier();
                let s = e.body = this.startNode(), r = s.body = [];
                for (this.expect(5); !this.match(8); ) {
                  let n = this.startNode();
                  this.match(83) ? (this.next(), !this.isContextual(126) && !this.match(87) && this.raise(I.InvalidNonTypeImportInDeclareModule, { at: this.state.lastTokStartLoc }), this.parseImport(n)) : (this.expectContextual(121, I.UnsupportedStatementInDeclareModule), n = this.flowParseDeclare(n, true)), r.push(n);
                }
                this.scope.exit(), this.expect(8), this.finishNode(s, "BlockStatement");
                let i = null, a = false;
                return r.forEach((n) => {
                  wh(n) ? (i === "CommonJS" && this.raise(I.AmbiguousDeclareModuleKind, { at: n }), i = "ES") : n.type === "DeclareModuleExports" && (a && this.raise(I.DuplicateDeclareModuleExports, { at: n }), i === "ES" && this.raise(I.AmbiguousDeclareModuleKind, { at: n }), i = "CommonJS", a = true);
                }), e.kind = i || "CommonJS", this.finishNode(e, "DeclareModule");
              }
              flowParseDeclareExportDeclaration(e, s) {
                if (this.expect(82), this.eat(65))
                  return this.match(68) || this.match(80) ? e.declaration = this.flowParseDeclare(this.startNode()) : (e.declaration = this.flowParseType(), this.semicolon()), e.default = true, this.finishNode(e, "DeclareExportDeclaration");
                if (this.match(75) || this.isLet() || (this.isContextual(126) || this.isContextual(125)) && !s) {
                  let r = this.state.value;
                  throw this.raise(I.UnsupportedDeclareExportKind, { at: this.state.startLoc, unsupportedExportKind: r, suggestion: Nh[r] });
                }
                if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(127))
                  return e.declaration = this.flowParseDeclare(this.startNode()), e.default = false, this.finishNode(e, "DeclareExportDeclaration");
                if (this.match(55) || this.match(5) || this.isContextual(125) || this.isContextual(126) || this.isContextual(127))
                  return e = this.parseExport(e), e.type === "ExportNamedDeclaration" && (e.type = "ExportDeclaration", e.default = false, delete e.exportKind), e.type = "Declare" + e.type, e;
                throw this.unexpected();
              }
              flowParseDeclareModuleExports(e) {
                return this.next(), this.expectContextual(108), e.typeAnnotation = this.flowParseTypeAnnotation(), this.semicolon(), this.finishNode(e, "DeclareModuleExports");
              }
              flowParseDeclareTypeAlias(e) {
                return this.next(), this.flowParseTypeAlias(e), e.type = "DeclareTypeAlias", e;
              }
              flowParseDeclareOpaqueType(e) {
                return this.next(), this.flowParseOpaqueType(e, true), e.type = "DeclareOpaqueType", e;
              }
              flowParseDeclareInterface(e) {
                return this.next(), this.flowParseInterfaceish(e), this.finishNode(e, "DeclareInterface");
              }
              flowParseInterfaceish(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (e.id = this.flowParseRestrictedIdentifier(!s, true), this.scope.declareName(e.id.name, s ? Tr : xe, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.extends = [], e.implements = [], e.mixins = [], this.eat(81))
                  do
                    e.extends.push(this.flowParseInterfaceExtends());
                  while (!s && this.eat(12));
                if (this.isContextual(114)) {
                  this.next();
                  do
                    e.mixins.push(this.flowParseInterfaceExtends());
                  while (this.eat(12));
                }
                if (this.isContextual(110)) {
                  this.next();
                  do
                    e.implements.push(this.flowParseInterfaceExtends());
                  while (this.eat(12));
                }
                e.body = this.flowParseObjectType({ allowStatic: s, allowExact: false, allowSpread: false, allowProto: s, allowInexact: false });
              }
              flowParseInterfaceExtends() {
                let e = this.startNode();
                return e.id = this.flowParseQualifiedTypeIdentifier(), this.match(47) ? e.typeParameters = this.flowParseTypeParameterInstantiation() : e.typeParameters = null, this.finishNode(e, "InterfaceExtends");
              }
              flowParseInterface(e) {
                return this.flowParseInterfaceish(e), this.finishNode(e, "InterfaceDeclaration");
              }
              checkNotUnderscore(e) {
                e === "_" && this.raise(I.UnexpectedReservedUnderscore, { at: this.state.startLoc });
              }
              checkReservedType(e, s, r) {
                !Sh.has(e) || this.raise(r ? I.AssignReservedType : I.UnexpectedReservedType, { at: s, reservedType: e });
              }
              flowParseRestrictedIdentifier(e, s) {
                return this.checkReservedType(this.state.value, this.state.startLoc, s), this.parseIdentifier(e);
              }
              flowParseTypeAlias(e) {
                return e.id = this.flowParseRestrictedIdentifier(false, true), this.scope.declareName(e.id.name, xe, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.right = this.flowParseTypeInitialiser(29), this.semicolon(), this.finishNode(e, "TypeAlias");
              }
              flowParseOpaqueType(e, s) {
                return this.expectContextual(126), e.id = this.flowParseRestrictedIdentifier(true, true), this.scope.declareName(e.id.name, xe, e.id.loc.start), this.match(47) ? e.typeParameters = this.flowParseTypeParameterDeclaration() : e.typeParameters = null, e.supertype = null, this.match(14) && (e.supertype = this.flowParseTypeInitialiser(14)), e.impltype = null, s || (e.impltype = this.flowParseTypeInitialiser(29)), this.semicolon(), this.finishNode(e, "OpaqueType");
              }
              flowParseTypeParameter() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, s = this.state.startLoc, r = this.startNode(), i = this.flowParseVariance(), a = this.flowParseTypeAnnotatableIdentifier();
                return r.name = a.name, r.variance = i, r.bound = a.typeAnnotation, this.match(29) ? (this.eat(29), r.default = this.flowParseType()) : e && this.raise(I.MissingTypeParamDefault, { at: s }), this.finishNode(r, "TypeParameter");
              }
              flowParseTypeParameterDeclaration() {
                let e = this.state.inType, s = this.startNode();
                s.params = [], this.state.inType = true, this.match(47) || this.match(138) ? this.next() : this.unexpected();
                let r = false;
                do {
                  let i = this.flowParseTypeParameter(r);
                  s.params.push(i), i.default && (r = true), this.match(48) || this.expect(12);
                } while (!this.match(48));
                return this.expect(48), this.state.inType = e, this.finishNode(s, "TypeParameterDeclaration");
              }
              flowParseTypeParameterInstantiation() {
                let e = this.startNode(), s = this.state.inType;
                e.params = [], this.state.inType = true, this.expect(47);
                let r = this.state.noAnonFunctionType;
                for (this.state.noAnonFunctionType = false; !this.match(48); )
                  e.params.push(this.flowParseType()), this.match(48) || this.expect(12);
                return this.state.noAnonFunctionType = r, this.expect(48), this.state.inType = s, this.finishNode(e, "TypeParameterInstantiation");
              }
              flowParseTypeParameterInstantiationCallOrNew() {
                let e = this.startNode(), s = this.state.inType;
                for (e.params = [], this.state.inType = true, this.expect(47); !this.match(48); )
                  e.params.push(this.flowParseTypeOrImplicitInstantiation()), this.match(48) || this.expect(12);
                return this.expect(48), this.state.inType = s, this.finishNode(e, "TypeParameterInstantiation");
              }
              flowParseInterfaceType() {
                let e = this.startNode();
                if (this.expectContextual(125), e.extends = [], this.eat(81))
                  do
                    e.extends.push(this.flowParseInterfaceExtends());
                  while (this.eat(12));
                return e.body = this.flowParseObjectType({ allowStatic: false, allowExact: false, allowSpread: false, allowProto: false, allowInexact: false }), this.finishNode(e, "InterfaceTypeAnnotation");
              }
              flowParseObjectPropertyKey() {
                return this.match(130) || this.match(129) ? this.parseExprAtom() : this.parseIdentifier(true);
              }
              flowParseObjectTypeIndexer(e, s, r) {
                return e.static = s, this.lookahead().type === 14 ? (e.id = this.flowParseObjectPropertyKey(), e.key = this.flowParseTypeInitialiser()) : (e.id = null, e.key = this.flowParseType()), this.expect(3), e.value = this.flowParseTypeInitialiser(), e.variance = r, this.finishNode(e, "ObjectTypeIndexer");
              }
              flowParseObjectTypeInternalSlot(e, s) {
                return e.static = s, e.id = this.flowParseObjectPropertyKey(), this.expect(3), this.expect(3), this.match(47) || this.match(10) ? (e.method = true, e.optional = false, e.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e.start, e.loc.start))) : (e.method = false, this.eat(17) && (e.optional = true), e.value = this.flowParseTypeInitialiser()), this.finishNode(e, "ObjectTypeInternalSlot");
              }
              flowParseObjectTypeMethodish(e) {
                for (e.params = [], e.rest = null, e.typeParameters = null, e.this = null, this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration()), this.expect(10), this.match(78) && (e.this = this.flowParseFunctionTypeParam(true), e.this.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
                  e.params.push(this.flowParseFunctionTypeParam(false)), this.match(11) || this.expect(12);
                return this.eat(21) && (e.rest = this.flowParseFunctionTypeParam(false)), this.expect(11), e.returnType = this.flowParseTypeInitialiser(), this.finishNode(e, "FunctionTypeAnnotation");
              }
              flowParseObjectTypeCallProperty(e, s) {
                let r = this.startNode();
                return e.static = s, e.value = this.flowParseObjectTypeMethodish(r), this.finishNode(e, "ObjectTypeCallProperty");
              }
              flowParseObjectType(e) {
                let { allowStatic: s, allowExact: r, allowSpread: i, allowProto: a, allowInexact: n } = e, o = this.state.inType;
                this.state.inType = true;
                let c = this.startNode();
                c.callProperties = [], c.properties = [], c.indexers = [], c.internalSlots = [];
                let f, y, P = false;
                for (r && this.match(6) ? (this.expect(6), f = 9, y = true) : (this.expect(5), f = 8, y = false), c.exact = y; !this.match(f); ) {
                  let N = false, B = null, _ = null, Q = this.startNode();
                  if (a && this.isContextual(115)) {
                    let ne = this.lookahead();
                    ne.type !== 14 && ne.type !== 17 && (this.next(), B = this.state.startLoc, s = false);
                  }
                  if (s && this.isContextual(104)) {
                    let ne = this.lookahead();
                    ne.type !== 14 && ne.type !== 17 && (this.next(), N = true);
                  }
                  let re = this.flowParseVariance();
                  if (this.eat(0))
                    B != null && this.unexpected(B), this.eat(0) ? (re && this.unexpected(re.loc.start), c.internalSlots.push(this.flowParseObjectTypeInternalSlot(Q, N))) : c.indexers.push(this.flowParseObjectTypeIndexer(Q, N, re));
                  else if (this.match(10) || this.match(47))
                    B != null && this.unexpected(B), re && this.unexpected(re.loc.start), c.callProperties.push(this.flowParseObjectTypeCallProperty(Q, N));
                  else {
                    let ne = "init";
                    if (this.isContextual(98) || this.isContextual(103)) {
                      let le = this.lookahead();
                      hr(le.type) && (ne = this.state.value, this.next());
                    }
                    let $e = this.flowParseObjectTypeProperty(Q, N, B, re, ne, i, n != null ? n : !y);
                    $e === null ? (P = true, _ = this.state.lastTokStartLoc) : c.properties.push($e);
                  }
                  this.flowObjectTypeSemicolon(), _ && !this.match(8) && !this.match(9) && this.raise(I.UnexpectedExplicitInexactInObject, { at: _ });
                }
                this.expect(f), i && (c.inexact = P);
                let v = this.finishNode(c, "ObjectTypeAnnotation");
                return this.state.inType = o, v;
              }
              flowParseObjectTypeProperty(e, s, r, i, a, n, o) {
                if (this.eat(21))
                  return this.match(12) || this.match(13) || this.match(8) || this.match(9) ? (n ? o || this.raise(I.InexactInsideExact, { at: this.state.lastTokStartLoc }) : this.raise(I.InexactInsideNonObject, { at: this.state.lastTokStartLoc }), i && this.raise(I.InexactVariance, { at: i }), null) : (n || this.raise(I.UnexpectedSpreadType, { at: this.state.lastTokStartLoc }), r != null && this.unexpected(r), i && this.raise(I.SpreadVariance, { at: i }), e.argument = this.flowParseType(), this.finishNode(e, "ObjectTypeSpreadProperty"));
                {
                  e.key = this.flowParseObjectPropertyKey(), e.static = s, e.proto = r != null, e.kind = a;
                  let c = false;
                  return this.match(47) || this.match(10) ? (e.method = true, r != null && this.unexpected(r), i && this.unexpected(i.loc.start), e.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e.start, e.loc.start)), (a === "get" || a === "set") && this.flowCheckGetterSetterParams(e), !n && e.key.name === "constructor" && e.value.this && this.raise(I.ThisParamBannedInConstructor, { at: e.value.this })) : (a !== "init" && this.unexpected(), e.method = false, this.eat(17) && (c = true), e.value = this.flowParseTypeInitialiser(), e.variance = i), e.optional = c, this.finishNode(e, "ObjectTypeProperty");
                }
              }
              flowCheckGetterSetterParams(e) {
                let s = e.kind === "get" ? 0 : 1, r = e.value.params.length + (e.value.rest ? 1 : 0);
                e.value.this && this.raise(e.kind === "get" ? I.GetterMayNotHaveThisParam : I.SetterMayNotHaveThisParam, { at: e.value.this }), r !== s && this.raise(e.kind === "get" ? u.BadGetterArity : u.BadSetterArity, { at: e }), e.kind === "set" && e.value.rest && this.raise(u.BadSetterRestParameter, { at: e });
              }
              flowObjectTypeSemicolon() {
                !this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9) && this.unexpected();
              }
              flowParseQualifiedTypeIdentifier(e, s, r) {
                e = e || this.state.start, s = s || this.state.startLoc;
                let i = r || this.flowParseRestrictedIdentifier(true);
                for (; this.eat(16); ) {
                  let a = this.startNodeAt(e, s);
                  a.qualification = i, a.id = this.flowParseRestrictedIdentifier(true), i = this.finishNode(a, "QualifiedTypeIdentifier");
                }
                return i;
              }
              flowParseGenericType(e, s, r) {
                let i = this.startNodeAt(e, s);
                return i.typeParameters = null, i.id = this.flowParseQualifiedTypeIdentifier(e, s, r), this.match(47) && (i.typeParameters = this.flowParseTypeParameterInstantiation()), this.finishNode(i, "GenericTypeAnnotation");
              }
              flowParseTypeofType() {
                let e = this.startNode();
                return this.expect(87), e.argument = this.flowParsePrimaryType(), this.finishNode(e, "TypeofTypeAnnotation");
              }
              flowParseTupleType() {
                let e = this.startNode();
                for (e.types = [], this.expect(0); this.state.pos < this.length && !this.match(3) && (e.types.push(this.flowParseType()), !this.match(3)); )
                  this.expect(12);
                return this.expect(3), this.finishNode(e, "TupleTypeAnnotation");
              }
              flowParseFunctionTypeParam(e) {
                let s = null, r = false, i = null, a = this.startNode(), n = this.lookahead(), o = this.state.type === 78;
                return n.type === 14 || n.type === 17 ? (o && !e && this.raise(I.ThisParamMustBeFirst, { at: a }), s = this.parseIdentifier(o), this.eat(17) && (r = true, o && this.raise(I.ThisParamMayNotBeOptional, { at: a })), i = this.flowParseTypeInitialiser()) : i = this.flowParseType(), a.name = s, a.optional = r, a.typeAnnotation = i, this.finishNode(a, "FunctionTypeParam");
              }
              reinterpretTypeAsFunctionTypeParam(e) {
                let s = this.startNodeAt(e.start, e.loc.start);
                return s.name = null, s.optional = false, s.typeAnnotation = e, this.finishNode(s, "FunctionTypeParam");
              }
              flowParseFunctionTypeParams() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = null, r = null;
                for (this.match(78) && (r = this.flowParseFunctionTypeParam(true), r.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
                  e.push(this.flowParseFunctionTypeParam(false)), this.match(11) || this.expect(12);
                return this.eat(21) && (s = this.flowParseFunctionTypeParam(false)), { params: e, rest: s, _this: r };
              }
              flowIdentToTypeAnnotation(e, s, r, i) {
                switch (i.name) {
                  case "any":
                    return this.finishNode(r, "AnyTypeAnnotation");
                  case "bool":
                  case "boolean":
                    return this.finishNode(r, "BooleanTypeAnnotation");
                  case "mixed":
                    return this.finishNode(r, "MixedTypeAnnotation");
                  case "empty":
                    return this.finishNode(r, "EmptyTypeAnnotation");
                  case "number":
                    return this.finishNode(r, "NumberTypeAnnotation");
                  case "string":
                    return this.finishNode(r, "StringTypeAnnotation");
                  case "symbol":
                    return this.finishNode(r, "SymbolTypeAnnotation");
                  default:
                    return this.checkNotUnderscore(i.name), this.flowParseGenericType(e, s, i);
                }
              }
              flowParsePrimaryType() {
                let e = this.state.start, s = this.state.startLoc, r = this.startNode(), i, a, n = false, o = this.state.noAnonFunctionType;
                switch (this.state.type) {
                  case 5:
                    return this.flowParseObjectType({ allowStatic: false, allowExact: false, allowSpread: true, allowProto: false, allowInexact: true });
                  case 6:
                    return this.flowParseObjectType({ allowStatic: false, allowExact: true, allowSpread: true, allowProto: false, allowInexact: false });
                  case 0:
                    return this.state.noAnonFunctionType = false, a = this.flowParseTupleType(), this.state.noAnonFunctionType = o, a;
                  case 47:
                    return r.typeParameters = this.flowParseTypeParameterDeclaration(), this.expect(10), i = this.flowParseFunctionTypeParams(), r.params = i.params, r.rest = i.rest, r.this = i._this, this.expect(11), this.expect(19), r.returnType = this.flowParseType(), this.finishNode(r, "FunctionTypeAnnotation");
                  case 10:
                    if (this.next(), !this.match(11) && !this.match(21))
                      if (K(this.state.type) || this.match(78)) {
                        let c = this.lookahead().type;
                        n = c !== 17 && c !== 14;
                      } else
                        n = true;
                    if (n) {
                      if (this.state.noAnonFunctionType = false, a = this.flowParseType(), this.state.noAnonFunctionType = o, this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19))
                        return this.expect(11), a;
                      this.eat(12);
                    }
                    return a ? i = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(a)]) : i = this.flowParseFunctionTypeParams(), r.params = i.params, r.rest = i.rest, r.this = i._this, this.expect(11), this.expect(19), r.returnType = this.flowParseType(), r.typeParameters = null, this.finishNode(r, "FunctionTypeAnnotation");
                  case 129:
                    return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
                  case 85:
                  case 86:
                    return r.value = this.match(85), this.next(), this.finishNode(r, "BooleanLiteralTypeAnnotation");
                  case 53:
                    if (this.state.value === "-") {
                      if (this.next(), this.match(130))
                        return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", r);
                      if (this.match(131))
                        return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", r);
                      throw this.raise(I.UnexpectedSubtractionOperand, { at: this.state.startLoc });
                    }
                    throw this.unexpected();
                  case 130:
                    return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
                  case 131:
                    return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
                  case 88:
                    return this.next(), this.finishNode(r, "VoidTypeAnnotation");
                  case 84:
                    return this.next(), this.finishNode(r, "NullLiteralTypeAnnotation");
                  case 78:
                    return this.next(), this.finishNode(r, "ThisTypeAnnotation");
                  case 55:
                    return this.next(), this.finishNode(r, "ExistsTypeAnnotation");
                  case 87:
                    return this.flowParseTypeofType();
                  default:
                    if (Ht(this.state.type)) {
                      let c = Pe(this.state.type);
                      return this.next(), super.createIdentifier(r, c);
                    } else if (K(this.state.type))
                      return this.isContextual(125) ? this.flowParseInterfaceType() : this.flowIdentToTypeAnnotation(e, s, r, this.parseIdentifier());
                }
                throw this.unexpected();
              }
              flowParsePostfixType() {
                let e = this.state.start, s = this.state.startLoc, r = this.flowParsePrimaryType(), i = false;
                for (; (this.match(0) || this.match(18)) && !this.canInsertSemicolon(); ) {
                  let a = this.startNodeAt(e, s), n = this.eat(18);
                  i = i || n, this.expect(0), !n && this.match(3) ? (a.elementType = r, this.next(), r = this.finishNode(a, "ArrayTypeAnnotation")) : (a.objectType = r, a.indexType = this.flowParseType(), this.expect(3), i ? (a.optional = n, r = this.finishNode(a, "OptionalIndexedAccessType")) : r = this.finishNode(a, "IndexedAccessType"));
                }
                return r;
              }
              flowParsePrefixType() {
                let e = this.startNode();
                return this.eat(17) ? (e.typeAnnotation = this.flowParsePrefixType(), this.finishNode(e, "NullableTypeAnnotation")) : this.flowParsePostfixType();
              }
              flowParseAnonFunctionWithoutParens() {
                let e = this.flowParsePrefixType();
                if (!this.state.noAnonFunctionType && this.eat(19)) {
                  let s = this.startNodeAt(e.start, e.loc.start);
                  return s.params = [this.reinterpretTypeAsFunctionTypeParam(e)], s.rest = null, s.this = null, s.returnType = this.flowParseType(), s.typeParameters = null, this.finishNode(s, "FunctionTypeAnnotation");
                }
                return e;
              }
              flowParseIntersectionType() {
                let e = this.startNode();
                this.eat(45);
                let s = this.flowParseAnonFunctionWithoutParens();
                for (e.types = [s]; this.eat(45); )
                  e.types.push(this.flowParseAnonFunctionWithoutParens());
                return e.types.length === 1 ? s : this.finishNode(e, "IntersectionTypeAnnotation");
              }
              flowParseUnionType() {
                let e = this.startNode();
                this.eat(43);
                let s = this.flowParseIntersectionType();
                for (e.types = [s]; this.eat(43); )
                  e.types.push(this.flowParseIntersectionType());
                return e.types.length === 1 ? s : this.finishNode(e, "UnionTypeAnnotation");
              }
              flowParseType() {
                let e = this.state.inType;
                this.state.inType = true;
                let s = this.flowParseUnionType();
                return this.state.inType = e, s;
              }
              flowParseTypeOrImplicitInstantiation() {
                if (this.state.type === 128 && this.state.value === "_") {
                  let e = this.state.start, s = this.state.startLoc, r = this.parseIdentifier();
                  return this.flowParseGenericType(e, s, r);
                } else
                  return this.flowParseType();
              }
              flowParseTypeAnnotation() {
                let e = this.startNode();
                return e.typeAnnotation = this.flowParseTypeInitialiser(), this.finishNode(e, "TypeAnnotation");
              }
              flowParseTypeAnnotatableIdentifier(e) {
                let s = e ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
                return this.match(14) && (s.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(s)), s;
              }
              typeCastToParameter(e) {
                return e.expression.typeAnnotation = e.typeAnnotation, this.resetEndLocation(e.expression, e.typeAnnotation.loc.end), e.expression;
              }
              flowParseVariance() {
                let e = null;
                return this.match(53) && (e = this.startNode(), this.state.value === "+" ? e.kind = "plus" : e.kind = "minus", this.next(), this.finishNode(e, "Variance")), e;
              }
              parseFunctionBody(e, s) {
                let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return s ? this.forwardNoArrowParamsConversionAt(e, () => super.parseFunctionBody(e, true, r)) : super.parseFunctionBody(e, false, r);
              }
              parseFunctionBodyAndFinish(e, s) {
                let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (this.match(14)) {
                  let i = this.startNode();
                  [i.typeAnnotation, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), e.returnType = i.typeAnnotation ? this.finishNode(i, "TypeAnnotation") : null;
                }
                super.parseFunctionBodyAndFinish(e, s, r);
              }
              parseStatement(e, s) {
                if (this.state.strict && this.isContextual(125)) {
                  let i = this.lookahead();
                  if (pe(i.type)) {
                    let a = this.startNode();
                    return this.next(), this.flowParseInterface(a);
                  }
                } else if (this.shouldParseEnums() && this.isContextual(122)) {
                  let i = this.startNode();
                  return this.next(), this.flowParseEnumDeclaration(i);
                }
                let r = super.parseStatement(e, s);
                return this.flowPragma === void 0 && !this.isValidDirective(r) && (this.flowPragma = null), r;
              }
              parseExpressionStatement(e, s) {
                if (s.type === "Identifier") {
                  if (s.name === "declare") {
                    if (this.match(80) || K(this.state.type) || this.match(68) || this.match(74) || this.match(82))
                      return this.flowParseDeclare(e);
                  } else if (K(this.state.type)) {
                    if (s.name === "interface")
                      return this.flowParseInterface(e);
                    if (s.name === "type")
                      return this.flowParseTypeAlias(e);
                    if (s.name === "opaque")
                      return this.flowParseOpaqueType(e, false);
                  }
                }
                return super.parseExpressionStatement(e, s);
              }
              shouldParseExportDeclaration() {
                let { type: e } = this.state;
                return lr(e) || this.shouldParseEnums() && e === 122 ? !this.state.containsEsc : super.shouldParseExportDeclaration();
              }
              isExportDefaultSpecifier() {
                let { type: e } = this.state;
                return lr(e) || this.shouldParseEnums() && e === 122 ? this.state.containsEsc : super.isExportDefaultSpecifier();
              }
              parseExportDefaultExpression() {
                if (this.shouldParseEnums() && this.isContextual(122)) {
                  let e = this.startNode();
                  return this.next(), this.flowParseEnumDeclaration(e);
                }
                return super.parseExportDefaultExpression();
              }
              parseConditional(e, s, r, i) {
                if (!this.match(17))
                  return e;
                if (this.state.maybeInArrowParameters) {
                  let v = this.lookaheadCharCode();
                  if (v === 44 || v === 61 || v === 58 || v === 41)
                    return this.setOptionalParametersError(i), e;
                }
                this.expect(17);
                let a = this.state.clone(), n = this.state.noArrowAt, o = this.startNodeAt(s, r), { consequent: c, failed: f } = this.tryParseConditionalConsequent(), [y, P] = this.getArrowLikeExpressions(c);
                if (f || P.length > 0) {
                  let v = [...n];
                  if (P.length > 0) {
                    this.state = a, this.state.noArrowAt = v;
                    for (let N = 0; N < P.length; N++)
                      v.push(P[N].start);
                    ({ consequent: c, failed: f } = this.tryParseConditionalConsequent()), [y, P] = this.getArrowLikeExpressions(c);
                  }
                  f && y.length > 1 && this.raise(I.AmbiguousConditionalArrow, { at: a.startLoc }), f && y.length === 1 && (this.state = a, v.push(y[0].start), this.state.noArrowAt = v, { consequent: c, failed: f } = this.tryParseConditionalConsequent());
                }
                return this.getArrowLikeExpressions(c, true), this.state.noArrowAt = n, this.expect(14), o.test = e, o.consequent = c, o.alternate = this.forwardNoArrowParamsConversionAt(o, () => this.parseMaybeAssign(void 0, void 0)), this.finishNode(o, "ConditionalExpression");
              }
              tryParseConditionalConsequent() {
                this.state.noArrowParamsConversionAt.push(this.state.start);
                let e = this.parseMaybeAssignAllowIn(), s = !this.match(14);
                return this.state.noArrowParamsConversionAt.pop(), { consequent: e, failed: s };
              }
              getArrowLikeExpressions(e, s) {
                let r = [e], i = [];
                for (; r.length !== 0; ) {
                  let a = r.pop();
                  a.type === "ArrowFunctionExpression" ? (a.typeParameters || !a.returnType ? this.finishArrowValidation(a) : i.push(a), r.push(a.body)) : a.type === "ConditionalExpression" && (r.push(a.consequent), r.push(a.alternate));
                }
                return s ? (i.forEach((a) => this.finishArrowValidation(a)), [i, []]) : Ih(i, (a) => a.params.every((n) => this.isAssignable(n, true)));
              }
              finishArrowValidation(e) {
                var s;
                this.toAssignableList(e.params, (s = e.extra) == null ? void 0 : s.trailingCommaLoc, false), this.scope.enter(me | Jt), super.checkParams(e, false, true), this.scope.exit();
              }
              forwardNoArrowParamsConversionAt(e, s) {
                let r;
                return this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1 ? (this.state.noArrowParamsConversionAt.push(this.state.start), r = s(), this.state.noArrowParamsConversionAt.pop()) : r = s(), r;
              }
              parseParenItem(e, s, r) {
                if (e = super.parseParenItem(e, s, r), this.eat(17) && (e.optional = true, this.resetEndLocation(e)), this.match(14)) {
                  let i = this.startNodeAt(s, r);
                  return i.expression = e, i.typeAnnotation = this.flowParseTypeAnnotation(), this.finishNode(i, "TypeCastExpression");
                }
                return e;
              }
              assertModuleNodeAllowed(e) {
                e.type === "ImportDeclaration" && (e.importKind === "type" || e.importKind === "typeof") || e.type === "ExportNamedDeclaration" && e.exportKind === "type" || e.type === "ExportAllDeclaration" && e.exportKind === "type" || super.assertModuleNodeAllowed(e);
              }
              parseExport(e) {
                let s = super.parseExport(e);
                return (s.type === "ExportNamedDeclaration" || s.type === "ExportAllDeclaration") && (s.exportKind = s.exportKind || "value"), s;
              }
              parseExportDeclaration(e) {
                if (this.isContextual(126)) {
                  e.exportKind = "type";
                  let s = this.startNode();
                  return this.next(), this.match(5) ? (e.specifiers = this.parseExportSpecifiers(true), this.parseExportFrom(e), null) : this.flowParseTypeAlias(s);
                } else if (this.isContextual(127)) {
                  e.exportKind = "type";
                  let s = this.startNode();
                  return this.next(), this.flowParseOpaqueType(s, false);
                } else if (this.isContextual(125)) {
                  e.exportKind = "type";
                  let s = this.startNode();
                  return this.next(), this.flowParseInterface(s);
                } else if (this.shouldParseEnums() && this.isContextual(122)) {
                  e.exportKind = "value";
                  let s = this.startNode();
                  return this.next(), this.flowParseEnumDeclaration(s);
                } else
                  return super.parseExportDeclaration(e);
              }
              eatExportStar(e) {
                return super.eatExportStar(...arguments) ? true : this.isContextual(126) && this.lookahead().type === 55 ? (e.exportKind = "type", this.next(), this.next(), true) : false;
              }
              maybeParseExportNamespaceSpecifier(e) {
                let { startLoc: s } = this.state, r = super.maybeParseExportNamespaceSpecifier(e);
                return r && e.exportKind === "type" && this.unexpected(s), r;
              }
              parseClassId(e, s, r) {
                super.parseClassId(e, s, r), this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration());
              }
              parseClassMember(e, s, r) {
                let { startLoc: i } = this.state;
                if (this.isContextual(121)) {
                  if (this.parseClassMemberFromModifier(e, s))
                    return;
                  s.declare = true;
                }
                super.parseClassMember(e, s, r), s.declare && (s.type !== "ClassProperty" && s.type !== "ClassPrivateProperty" && s.type !== "PropertyDefinition" ? this.raise(I.DeclareClassElement, { at: i }) : s.value && this.raise(I.DeclareClassFieldInitializer, { at: s.value }));
              }
              isIterator(e) {
                return e === "iterator" || e === "asyncIterator";
              }
              readIterator() {
                let e = super.readWord1(), s = "@@" + e;
                (!this.isIterator(e) || !this.state.inType) && this.raise(u.InvalidIdentifier, { at: this.state.curPosition(), identifierName: s }), this.finishToken(128, s);
              }
              getTokenFromCode(e) {
                let s = this.input.charCodeAt(this.state.pos + 1);
                return e === 123 && s === 124 ? this.finishOp(6, 2) : this.state.inType && (e === 62 || e === 60) ? this.finishOp(e === 62 ? 48 : 47, 1) : this.state.inType && e === 63 ? s === 46 ? this.finishOp(18, 2) : this.finishOp(17, 1) : Ko(e, s, this.input.charCodeAt(this.state.pos + 2)) ? (this.state.pos += 2, this.readIterator()) : super.getTokenFromCode(e);
              }
              isAssignable(e, s) {
                return e.type === "TypeCastExpression" ? this.isAssignable(e.expression, s) : super.isAssignable(e, s);
              }
              toAssignable(e) {
                !(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false) && e.type === "AssignmentExpression" && e.left.type === "TypeCastExpression" && (e.left = this.typeCastToParameter(e.left)), super.toAssignable(...arguments);
              }
              toAssignableList(e, s, r) {
                for (let i = 0; i < e.length; i++) {
                  let a = e[i];
                  (a == null ? void 0 : a.type) === "TypeCastExpression" && (e[i] = this.typeCastToParameter(a));
                }
                super.toAssignableList(e, s, r);
              }
              toReferencedList(e, s) {
                for (let i = 0; i < e.length; i++) {
                  var r;
                  let a = e[i];
                  a && a.type === "TypeCastExpression" && !((r = a.extra) != null && r.parenthesized) && (e.length > 1 || !s) && this.raise(I.TypeCastInPattern, { at: a.typeAnnotation });
                }
                return e;
              }
              parseArrayLike(e, s, r, i) {
                let a = super.parseArrayLike(e, s, r, i);
                return s && !this.state.maybeInArrowParameters && this.toReferencedList(a.elements), a;
              }
              isValidLVal(e) {
                for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), i = 1; i < s; i++)
                  r[i - 1] = arguments[i];
                return e === "TypeCastExpression" || super.isValidLVal(e, ...r);
              }
              parseClassProperty(e) {
                return this.match(14) && (e.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassProperty(e);
              }
              parseClassPrivateProperty(e) {
                return this.match(14) && (e.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassPrivateProperty(e);
              }
              isClassMethod() {
                return this.match(47) || super.isClassMethod();
              }
              isClassProperty() {
                return this.match(14) || super.isClassProperty();
              }
              isNonstaticConstructor(e) {
                return !this.match(14) && super.isNonstaticConstructor(e);
              }
              pushClassMethod(e, s, r, i, a, n) {
                if (s.variance && this.unexpected(s.variance.loc.start), delete s.variance, this.match(47) && (s.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassMethod(e, s, r, i, a, n), s.params && a) {
                  let o = s.params;
                  o.length > 0 && this.isThisParam(o[0]) && this.raise(I.ThisParamBannedInConstructor, { at: s });
                } else if (s.type === "MethodDefinition" && a && s.value.params) {
                  let o = s.value.params;
                  o.length > 0 && this.isThisParam(o[0]) && this.raise(I.ThisParamBannedInConstructor, { at: s });
                }
              }
              pushClassPrivateMethod(e, s, r, i) {
                s.variance && this.unexpected(s.variance.loc.start), delete s.variance, this.match(47) && (s.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassPrivateMethod(e, s, r, i);
              }
              parseClassSuper(e) {
                if (super.parseClassSuper(e), e.superClass && this.match(47) && (e.superTypeParameters = this.flowParseTypeParameterInstantiation()), this.isContextual(110)) {
                  this.next();
                  let s = e.implements = [];
                  do {
                    let r = this.startNode();
                    r.id = this.flowParseRestrictedIdentifier(true), this.match(47) ? r.typeParameters = this.flowParseTypeParameterInstantiation() : r.typeParameters = null, s.push(this.finishNode(r, "ClassImplements"));
                  } while (this.eat(12));
                }
              }
              checkGetterSetterParams(e) {
                super.checkGetterSetterParams(e);
                let s = this.getObjectOrClassMethodParams(e);
                if (s.length > 0) {
                  let r = s[0];
                  this.isThisParam(r) && e.kind === "get" ? this.raise(I.GetterMayNotHaveThisParam, { at: r }) : this.isThisParam(r) && this.raise(I.SetterMayNotHaveThisParam, { at: r });
                }
              }
              parsePropertyNamePrefixOperator(e) {
                e.variance = this.flowParseVariance();
              }
              parseObjPropValue(e, s, r, i, a, n, o, c) {
                e.variance && this.unexpected(e.variance.loc.start), delete e.variance;
                let f;
                this.match(47) && !o && (f = this.flowParseTypeParameterDeclaration(), this.match(10) || this.unexpected()), super.parseObjPropValue(e, s, r, i, a, n, o, c), f && ((e.value || e).typeParameters = f);
              }
              parseAssignableListItemTypes(e) {
                return this.eat(17) && (e.type !== "Identifier" && this.raise(I.PatternIsOptional, { at: e }), this.isThisParam(e) && this.raise(I.ThisParamMayNotBeOptional, { at: e }), e.optional = true), this.match(14) ? e.typeAnnotation = this.flowParseTypeAnnotation() : this.isThisParam(e) && this.raise(I.ThisParamAnnotationRequired, { at: e }), this.match(29) && this.isThisParam(e) && this.raise(I.ThisParamNoDefault, { at: e }), this.resetEndLocation(e), e;
              }
              parseMaybeDefault(e, s, r) {
                let i = super.parseMaybeDefault(e, s, r);
                return i.type === "AssignmentPattern" && i.typeAnnotation && i.right.start < i.typeAnnotation.start && this.raise(I.TypeBeforeInitializer, { at: i.typeAnnotation }), i;
              }
              shouldParseDefaultImport(e) {
                return cs(e) ? Or(this.state.type) : super.shouldParseDefaultImport(e);
              }
              parseImportSpecifierLocal(e, s, r) {
                s.local = cs(e) ? this.flowParseRestrictedIdentifier(true, true) : this.parseIdentifier(), e.specifiers.push(this.finishImportSpecifier(s, r));
              }
              maybeParseDefaultImportSpecifier(e) {
                e.importKind = "value";
                let s = null;
                if (this.match(87) ? s = "typeof" : this.isContextual(126) && (s = "type"), s) {
                  let r = this.lookahead(), { type: i } = r;
                  s === "type" && i === 55 && this.unexpected(null, r.type), (Or(i) || i === 5 || i === 55) && (this.next(), e.importKind = s);
                }
                return super.maybeParseDefaultImportSpecifier(e);
              }
              parseImportSpecifier(e, s, r, i) {
                let a = e.imported, n = null;
                a.type === "Identifier" && (a.name === "type" ? n = "type" : a.name === "typeof" && (n = "typeof"));
                let o = false;
                if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
                  let f = this.parseIdentifier(true);
                  n !== null && !pe(this.state.type) ? (e.imported = f, e.importKind = n, e.local = ge(f)) : (e.imported = a, e.importKind = null, e.local = this.parseIdentifier());
                } else {
                  if (n !== null && pe(this.state.type))
                    e.imported = this.parseIdentifier(true), e.importKind = n;
                  else {
                    if (s)
                      throw this.raise(u.ImportBindingIsString, { at: e, importName: a.value });
                    e.imported = a, e.importKind = null;
                  }
                  this.eatContextual(93) ? e.local = this.parseIdentifier() : (o = true, e.local = ge(e.imported));
                }
                let c = cs(e);
                return r && c && this.raise(I.ImportTypeShorthandOnlyInPureImport, { at: e }), (r || c) && this.checkReservedType(e.local.name, e.local.loc.start, true), o && !r && !c && this.checkReservedWord(e.local.name, e.loc.start, true, true), this.finishImportSpecifier(e, "ImportSpecifier");
              }
              parseBindingAtom() {
                switch (this.state.type) {
                  case 78:
                    return this.parseIdentifier(true);
                  default:
                    return super.parseBindingAtom();
                }
              }
              parseFunctionParams(e, s) {
                let r = e.kind;
                r !== "get" && r !== "set" && this.match(47) && (e.typeParameters = this.flowParseTypeParameterDeclaration()), super.parseFunctionParams(e, s);
              }
              parseVarId(e, s) {
                super.parseVarId(e, s), this.match(14) && (e.id.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(e.id));
              }
              parseAsyncArrowFromCallExpression(e, s) {
                if (this.match(14)) {
                  let r = this.state.noAnonFunctionType;
                  this.state.noAnonFunctionType = true, e.returnType = this.flowParseTypeAnnotation(), this.state.noAnonFunctionType = r;
                }
                return super.parseAsyncArrowFromCallExpression(e, s);
              }
              shouldParseAsyncArrow() {
                return this.match(14) || super.shouldParseAsyncArrow();
              }
              parseMaybeAssign(e, s) {
                var r;
                let i = null, a;
                if (this.hasPlugin("jsx") && (this.match(138) || this.match(47))) {
                  if (i = this.state.clone(), a = this.tryParse(() => super.parseMaybeAssign(e, s), i), !a.error)
                    return a.node;
                  let { context: c } = this.state, f = c[c.length - 1];
                  (f === z.j_oTag || f === z.j_expr) && c.pop();
                }
                if ((r = a) != null && r.error || this.match(47)) {
                  var n, o;
                  i = i || this.state.clone();
                  let c, f = this.tryParse((P) => {
                    var v;
                    c = this.flowParseTypeParameterDeclaration();
                    let N = this.forwardNoArrowParamsConversionAt(c, () => {
                      let _ = super.parseMaybeAssign(e, s);
                      return this.resetStartLocationFromNode(_, c), _;
                    });
                    (v = N.extra) != null && v.parenthesized && P();
                    let B = this.maybeUnwrapTypeCastExpression(N);
                    return B.type !== "ArrowFunctionExpression" && P(), B.typeParameters = c, this.resetStartLocationFromNode(B, c), N;
                  }, i), y = null;
                  if (f.node && this.maybeUnwrapTypeCastExpression(f.node).type === "ArrowFunctionExpression") {
                    if (!f.error && !f.aborted)
                      return f.node.async && this.raise(I.UnexpectedTypeParameterBeforeAsyncArrowFunction, { at: c }), f.node;
                    y = f.node;
                  }
                  if ((n = a) != null && n.node)
                    return this.state = a.failState, a.node;
                  if (y)
                    return this.state = f.failState, y;
                  throw (o = a) != null && o.thrown ? a.error : f.thrown ? f.error : this.raise(I.UnexpectedTokenAfterTypeParameter, { at: c });
                }
                return super.parseMaybeAssign(e, s);
              }
              parseArrow(e) {
                if (this.match(14)) {
                  let s = this.tryParse(() => {
                    let r = this.state.noAnonFunctionType;
                    this.state.noAnonFunctionType = true;
                    let i = this.startNode();
                    return [i.typeAnnotation, e.predicate] = this.flowParseTypeAndPredicateInitialiser(), this.state.noAnonFunctionType = r, this.canInsertSemicolon() && this.unexpected(), this.match(19) || this.unexpected(), i;
                  });
                  if (s.thrown)
                    return null;
                  s.error && (this.state = s.failState), e.returnType = s.node.typeAnnotation ? this.finishNode(s.node, "TypeAnnotation") : null;
                }
                return super.parseArrow(e);
              }
              shouldParseArrow(e) {
                return this.match(14) || super.shouldParseArrow(e);
              }
              setArrowFunctionParameters(e, s) {
                this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1 ? e.params = s : super.setArrowFunctionParameters(e, s);
              }
              checkParams(e, s, r) {
                if (!(r && this.state.noArrowParamsConversionAt.indexOf(e.start) !== -1)) {
                  for (let i = 0; i < e.params.length; i++)
                    this.isThisParam(e.params[i]) && i > 0 && this.raise(I.ThisParamMustBeFirst, { at: e.params[i] });
                  return super.checkParams(...arguments);
                }
              }
              parseParenAndDistinguishExpression(e) {
                return super.parseParenAndDistinguishExpression(e && this.state.noArrowAt.indexOf(this.state.start) === -1);
              }
              parseSubscripts(e, s, r, i) {
                if (e.type === "Identifier" && e.name === "async" && this.state.noArrowAt.indexOf(s) !== -1) {
                  this.next();
                  let a = this.startNodeAt(s, r);
                  a.callee = e, a.arguments = this.parseCallExpressionArguments(11, false), e = this.finishNode(a, "CallExpression");
                } else if (e.type === "Identifier" && e.name === "async" && this.match(47)) {
                  let a = this.state.clone(), n = this.tryParse((c) => this.parseAsyncArrowWithTypeParameters(s, r) || c(), a);
                  if (!n.error && !n.aborted)
                    return n.node;
                  let o = this.tryParse(() => super.parseSubscripts(e, s, r, i), a);
                  if (o.node && !o.error)
                    return o.node;
                  if (n.node)
                    return this.state = n.failState, n.node;
                  if (o.node)
                    return this.state = o.failState, o.node;
                  throw n.error || o.error;
                }
                return super.parseSubscripts(e, s, r, i);
              }
              parseSubscript(e, s, r, i, a) {
                if (this.match(18) && this.isLookaheadToken_lt()) {
                  if (a.optionalChainMember = true, i)
                    return a.stop = true, e;
                  this.next();
                  let n = this.startNodeAt(s, r);
                  return n.callee = e, n.typeArguments = this.flowParseTypeParameterInstantiation(), this.expect(10), n.arguments = this.parseCallExpressionArguments(11, false), n.optional = true, this.finishCallExpression(n, true);
                } else if (!i && this.shouldParseTypes() && this.match(47)) {
                  let n = this.startNodeAt(s, r);
                  n.callee = e;
                  let o = this.tryParse(() => (n.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew(), this.expect(10), n.arguments = this.parseCallExpressionArguments(11, false), a.optionalChainMember && (n.optional = false), this.finishCallExpression(n, a.optionalChainMember)));
                  if (o.node)
                    return o.error && (this.state = o.failState), o.node;
                }
                return super.parseSubscript(e, s, r, i, a);
              }
              parseNewCallee(e) {
                super.parseNewCallee(e);
                let s = null;
                this.shouldParseTypes() && this.match(47) && (s = this.tryParse(() => this.flowParseTypeParameterInstantiationCallOrNew()).node), e.typeArguments = s;
              }
              parseAsyncArrowWithTypeParameters(e, s) {
                let r = this.startNodeAt(e, s);
                if (this.parseFunctionParams(r), !!this.parseArrow(r))
                  return this.parseArrowExpression(r, void 0, true);
              }
              readToken_mult_modulo(e) {
                let s = this.input.charCodeAt(this.state.pos + 1);
                if (e === 42 && s === 47 && this.state.hasFlowComment) {
                  this.state.hasFlowComment = false, this.state.pos += 2, this.nextToken();
                  return;
                }
                super.readToken_mult_modulo(e);
              }
              readToken_pipe_amp(e) {
                let s = this.input.charCodeAt(this.state.pos + 1);
                if (e === 124 && s === 125) {
                  this.finishOp(9, 2);
                  return;
                }
                super.readToken_pipe_amp(e);
              }
              parseTopLevel(e, s) {
                let r = super.parseTopLevel(e, s);
                return this.state.hasFlowComment && this.raise(I.UnterminatedFlowComment, { at: this.state.curPosition() }), r;
              }
              skipBlockComment() {
                if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
                  if (this.state.hasFlowComment)
                    throw this.raise(I.NestedFlowComment, { at: this.state.startLoc });
                  this.hasFlowCommentCompletion(), this.state.pos += this.skipFlowComment(), this.state.hasFlowComment = true;
                  return;
                }
                if (this.state.hasFlowComment) {
                  let e = this.input.indexOf("*-/", this.state.pos + 2);
                  if (e === -1)
                    throw this.raise(u.UnterminatedComment, { at: this.state.curPosition() });
                  this.state.pos = e + 2 + 3;
                  return;
                }
                return super.skipBlockComment();
              }
              skipFlowComment() {
                let { pos: e } = this.state, s = 2;
                for (; [32, 9].includes(this.input.charCodeAt(e + s)); )
                  s++;
                let r = this.input.charCodeAt(s + e), i = this.input.charCodeAt(s + e + 1);
                return r === 58 && i === 58 ? s + 2 : this.input.slice(s + e, s + e + 12) === "flow-include" ? s + 12 : r === 58 && i !== 58 ? s : false;
              }
              hasFlowCommentCompletion() {
                if (this.input.indexOf("*/", this.state.pos) === -1)
                  throw this.raise(u.UnterminatedComment, { at: this.state.curPosition() });
              }
              flowEnumErrorBooleanMemberNotInitialized(e, s) {
                let { enumName: r, memberName: i } = s;
                this.raise(I.EnumBooleanMemberNotInitialized, { at: e, memberName: i, enumName: r });
              }
              flowEnumErrorInvalidMemberInitializer(e, s) {
                return this.raise(s.explicitType ? s.explicitType === "symbol" ? I.EnumInvalidMemberInitializerSymbolType : I.EnumInvalidMemberInitializerPrimaryType : I.EnumInvalidMemberInitializerUnknownType, Object.assign({ at: e }, s));
              }
              flowEnumErrorNumberMemberNotInitialized(e, s) {
                let { enumName: r, memberName: i } = s;
                this.raise(I.EnumNumberMemberNotInitialized, { at: e, enumName: r, memberName: i });
              }
              flowEnumErrorStringMemberInconsistentlyInitailized(e, s) {
                let { enumName: r } = s;
                this.raise(I.EnumStringMemberInconsistentlyInitailized, { at: e, enumName: r });
              }
              flowEnumMemberInit() {
                let e = this.state.startLoc, s = () => this.match(12) || this.match(8);
                switch (this.state.type) {
                  case 130: {
                    let r = this.parseNumericLiteral(this.state.value);
                    return s() ? { type: "number", loc: r.loc.start, value: r } : { type: "invalid", loc: e };
                  }
                  case 129: {
                    let r = this.parseStringLiteral(this.state.value);
                    return s() ? { type: "string", loc: r.loc.start, value: r } : { type: "invalid", loc: e };
                  }
                  case 85:
                  case 86: {
                    let r = this.parseBooleanLiteral(this.match(85));
                    return s() ? { type: "boolean", loc: r.loc.start, value: r } : { type: "invalid", loc: e };
                  }
                  default:
                    return { type: "invalid", loc: e };
                }
              }
              flowEnumMemberRaw() {
                let e = this.state.startLoc, s = this.parseIdentifier(true), r = this.eat(29) ? this.flowEnumMemberInit() : { type: "none", loc: e };
                return { id: s, init: r };
              }
              flowEnumCheckExplicitTypeMismatch(e, s, r) {
                let { explicitType: i } = s;
                i !== null && i !== r && this.flowEnumErrorInvalidMemberInitializer(e, s);
              }
              flowEnumMembers(e) {
                let { enumName: s, explicitType: r } = e, i = /* @__PURE__ */ new Set(), a = { booleanMembers: [], numberMembers: [], stringMembers: [], defaultedMembers: [] }, n = false;
                for (; !this.match(8); ) {
                  if (this.eat(21)) {
                    n = true;
                    break;
                  }
                  let o = this.startNode(), { id: c, init: f } = this.flowEnumMemberRaw(), y = c.name;
                  if (y === "")
                    continue;
                  /^[a-z]/.test(y) && this.raise(I.EnumInvalidMemberName, { at: c, memberName: y, suggestion: y[0].toUpperCase() + y.slice(1), enumName: s }), i.has(y) && this.raise(I.EnumDuplicateMemberName, { at: c, memberName: y, enumName: s }), i.add(y);
                  let P = { enumName: s, explicitType: r, memberName: y };
                  switch (o.id = c, f.type) {
                    case "boolean": {
                      this.flowEnumCheckExplicitTypeMismatch(f.loc, P, "boolean"), o.init = f.value, a.booleanMembers.push(this.finishNode(o, "EnumBooleanMember"));
                      break;
                    }
                    case "number": {
                      this.flowEnumCheckExplicitTypeMismatch(f.loc, P, "number"), o.init = f.value, a.numberMembers.push(this.finishNode(o, "EnumNumberMember"));
                      break;
                    }
                    case "string": {
                      this.flowEnumCheckExplicitTypeMismatch(f.loc, P, "string"), o.init = f.value, a.stringMembers.push(this.finishNode(o, "EnumStringMember"));
                      break;
                    }
                    case "invalid":
                      throw this.flowEnumErrorInvalidMemberInitializer(f.loc, P);
                    case "none":
                      switch (r) {
                        case "boolean":
                          this.flowEnumErrorBooleanMemberNotInitialized(f.loc, P);
                          break;
                        case "number":
                          this.flowEnumErrorNumberMemberNotInitialized(f.loc, P);
                          break;
                        default:
                          a.defaultedMembers.push(this.finishNode(o, "EnumDefaultedMember"));
                      }
                  }
                  this.match(8) || this.expect(12);
                }
                return { members: a, hasUnknownMembers: n };
              }
              flowEnumStringMembers(e, s, r) {
                let { enumName: i } = r;
                if (e.length === 0)
                  return s;
                if (s.length === 0)
                  return e;
                if (s.length > e.length) {
                  for (let a of e)
                    this.flowEnumErrorStringMemberInconsistentlyInitailized(a, { enumName: i });
                  return s;
                } else {
                  for (let a of s)
                    this.flowEnumErrorStringMemberInconsistentlyInitailized(a, { enumName: i });
                  return e;
                }
              }
              flowEnumParseExplicitType(e) {
                let { enumName: s } = e;
                if (!this.eatContextual(101))
                  return null;
                if (!K(this.state.type))
                  throw this.raise(I.EnumInvalidExplicitTypeUnknownSupplied, { at: this.state.startLoc, enumName: s });
                let { value: r } = this.state;
                return this.next(), r !== "boolean" && r !== "number" && r !== "string" && r !== "symbol" && this.raise(I.EnumInvalidExplicitType, { at: this.state.startLoc, enumName: s, invalidEnumType: r }), r;
              }
              flowEnumBody(e, s) {
                let r = s.name, i = s.loc.start, a = this.flowEnumParseExplicitType({ enumName: r });
                this.expect(5);
                let { members: n, hasUnknownMembers: o } = this.flowEnumMembers({ enumName: r, explicitType: a });
                switch (e.hasUnknownMembers = o, a) {
                  case "boolean":
                    return e.explicitType = true, e.members = n.booleanMembers, this.expect(8), this.finishNode(e, "EnumBooleanBody");
                  case "number":
                    return e.explicitType = true, e.members = n.numberMembers, this.expect(8), this.finishNode(e, "EnumNumberBody");
                  case "string":
                    return e.explicitType = true, e.members = this.flowEnumStringMembers(n.stringMembers, n.defaultedMembers, { enumName: r }), this.expect(8), this.finishNode(e, "EnumStringBody");
                  case "symbol":
                    return e.members = n.defaultedMembers, this.expect(8), this.finishNode(e, "EnumSymbolBody");
                  default: {
                    let c = () => (e.members = [], this.expect(8), this.finishNode(e, "EnumStringBody"));
                    e.explicitType = false;
                    let f = n.booleanMembers.length, y = n.numberMembers.length, P = n.stringMembers.length, v = n.defaultedMembers.length;
                    if (!f && !y && !P && !v)
                      return c();
                    if (!f && !y)
                      return e.members = this.flowEnumStringMembers(n.stringMembers, n.defaultedMembers, { enumName: r }), this.expect(8), this.finishNode(e, "EnumStringBody");
                    if (!y && !P && f >= v) {
                      for (let N of n.defaultedMembers)
                        this.flowEnumErrorBooleanMemberNotInitialized(N.loc.start, { enumName: r, memberName: N.id.name });
                      return e.members = n.booleanMembers, this.expect(8), this.finishNode(e, "EnumBooleanBody");
                    } else if (!f && !P && y >= v) {
                      for (let N of n.defaultedMembers)
                        this.flowEnumErrorNumberMemberNotInitialized(N.loc.start, { enumName: r, memberName: N.id.name });
                      return e.members = n.numberMembers, this.expect(8), this.finishNode(e, "EnumNumberBody");
                    } else
                      return this.raise(I.EnumInconsistentMemberValues, { at: i, enumName: r }), c();
                  }
                }
              }
              flowParseEnumDeclaration(e) {
                let s = this.parseIdentifier();
                return e.id = s, e.body = this.flowEnumBody(this.startNode(), s), this.finishNode(e, "EnumDeclaration");
              }
              isLookaheadToken_lt() {
                let e = this.nextTokenStart();
                if (this.input.charCodeAt(e) === 60) {
                  let s = this.input.charCodeAt(e + 1);
                  return s !== 60 && s !== 61;
                }
                return false;
              }
              maybeUnwrapTypeCastExpression(e) {
                return e.type === "TypeCastExpression" ? e.expression : e;
              }
            }, Fh = { __proto__: null, quot: '"', amp: "&", apos: "'", lt: "<", gt: ">", nbsp: "\xA0", iexcl: "\xA1", cent: "\xA2", pound: "\xA3", curren: "\xA4", yen: "\xA5", brvbar: "\xA6", sect: "\xA7", uml: "\xA8", copy: "\xA9", ordf: "\xAA", laquo: "\xAB", not: "\xAC", shy: "\xAD", reg: "\xAE", macr: "\xAF", deg: "\xB0", plusmn: "\xB1", sup2: "\xB2", sup3: "\xB3", acute: "\xB4", micro: "\xB5", para: "\xB6", middot: "\xB7", cedil: "\xB8", sup1: "\xB9", ordm: "\xBA", raquo: "\xBB", frac14: "\xBC", frac12: "\xBD", frac34: "\xBE", iquest: "\xBF", Agrave: "\xC0", Aacute: "\xC1", Acirc: "\xC2", Atilde: "\xC3", Auml: "\xC4", Aring: "\xC5", AElig: "\xC6", Ccedil: "\xC7", Egrave: "\xC8", Eacute: "\xC9", Ecirc: "\xCA", Euml: "\xCB", Igrave: "\xCC", Iacute: "\xCD", Icirc: "\xCE", Iuml: "\xCF", ETH: "\xD0", Ntilde: "\xD1", Ograve: "\xD2", Oacute: "\xD3", Ocirc: "\xD4", Otilde: "\xD5", Ouml: "\xD6", times: "\xD7", Oslash: "\xD8", Ugrave: "\xD9", Uacute: "\xDA", Ucirc: "\xDB", Uuml: "\xDC", Yacute: "\xDD", THORN: "\xDE", szlig: "\xDF", agrave: "\xE0", aacute: "\xE1", acirc: "\xE2", atilde: "\xE3", auml: "\xE4", aring: "\xE5", aelig: "\xE6", ccedil: "\xE7", egrave: "\xE8", eacute: "\xE9", ecirc: "\xEA", euml: "\xEB", igrave: "\xEC", iacute: "\xED", icirc: "\xEE", iuml: "\xEF", eth: "\xF0", ntilde: "\xF1", ograve: "\xF2", oacute: "\xF3", ocirc: "\xF4", otilde: "\xF5", ouml: "\xF6", divide: "\xF7", oslash: "\xF8", ugrave: "\xF9", uacute: "\xFA", ucirc: "\xFB", uuml: "\xFC", yacute: "\xFD", thorn: "\xFE", yuml: "\xFF", OElig: "\u0152", oelig: "\u0153", Scaron: "\u0160", scaron: "\u0161", Yuml: "\u0178", fnof: "\u0192", circ: "\u02C6", tilde: "\u02DC", Alpha: "\u0391", Beta: "\u0392", Gamma: "\u0393", Delta: "\u0394", Epsilon: "\u0395", Zeta: "\u0396", Eta: "\u0397", Theta: "\u0398", Iota: "\u0399", Kappa: "\u039A", Lambda: "\u039B", Mu: "\u039C", Nu: "\u039D", Xi: "\u039E", Omicron: "\u039F", Pi: "\u03A0", Rho: "\u03A1", Sigma: "\u03A3", Tau: "\u03A4", Upsilon: "\u03A5", Phi: "\u03A6", Chi: "\u03A7", Psi: "\u03A8", Omega: "\u03A9", alpha: "\u03B1", beta: "\u03B2", gamma: "\u03B3", delta: "\u03B4", epsilon: "\u03B5", zeta: "\u03B6", eta: "\u03B7", theta: "\u03B8", iota: "\u03B9", kappa: "\u03BA", lambda: "\u03BB", mu: "\u03BC", nu: "\u03BD", xi: "\u03BE", omicron: "\u03BF", pi: "\u03C0", rho: "\u03C1", sigmaf: "\u03C2", sigma: "\u03C3", tau: "\u03C4", upsilon: "\u03C5", phi: "\u03C6", chi: "\u03C7", psi: "\u03C8", omega: "\u03C9", thetasym: "\u03D1", upsih: "\u03D2", piv: "\u03D6", ensp: "\u2002", emsp: "\u2003", thinsp: "\u2009", zwnj: "\u200C", zwj: "\u200D", lrm: "\u200E", rlm: "\u200F", ndash: "\u2013", mdash: "\u2014", lsquo: "\u2018", rsquo: "\u2019", sbquo: "\u201A", ldquo: "\u201C", rdquo: "\u201D", bdquo: "\u201E", dagger: "\u2020", Dagger: "\u2021", bull: "\u2022", hellip: "\u2026", permil: "\u2030", prime: "\u2032", Prime: "\u2033", lsaquo: "\u2039", rsaquo: "\u203A", oline: "\u203E", frasl: "\u2044", euro: "\u20AC", image: "\u2111", weierp: "\u2118", real: "\u211C", trade: "\u2122", alefsym: "\u2135", larr: "\u2190", uarr: "\u2191", rarr: "\u2192", darr: "\u2193", harr: "\u2194", crarr: "\u21B5", lArr: "\u21D0", uArr: "\u21D1", rArr: "\u21D2", dArr: "\u21D3", hArr: "\u21D4", forall: "\u2200", part: "\u2202", exist: "\u2203", empty: "\u2205", nabla: "\u2207", isin: "\u2208", notin: "\u2209", ni: "\u220B", prod: "\u220F", sum: "\u2211", minus: "\u2212", lowast: "\u2217", radic: "\u221A", prop: "\u221D", infin: "\u221E", ang: "\u2220", and: "\u2227", or: "\u2228", cap: "\u2229", cup: "\u222A", int: "\u222B", there4: "\u2234", sim: "\u223C", cong: "\u2245", asymp: "\u2248", ne: "\u2260", equiv: "\u2261", le: "\u2264", ge: "\u2265", sub: "\u2282", sup: "\u2283", nsub: "\u2284", sube: "\u2286", supe: "\u2287", oplus: "\u2295", otimes: "\u2297", perp: "\u22A5", sdot: "\u22C5", lceil: "\u2308", rceil: "\u2309", lfloor: "\u230A", rfloor: "\u230B", lang: "\u2329", rang: "\u232A", loz: "\u25CA", spades: "\u2660", clubs: "\u2663", hearts: "\u2665", diams: "\u2666" }, Ie = j(Kn || (Kn = rt(["jsx"])))((t3) => ({ AttributeIsEmpty: t3("JSX attributes must only be assigned a non-empty expression."), MissingClosingTagElement: t3((e) => {
              let { openingTagName: s } = e;
              return "Expected corresponding JSX closing tag for <".concat(s, ">.");
            }), MissingClosingTagFragment: t3("Expected corresponding JSX closing tag for <>."), UnexpectedSequenceExpression: t3("Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?"), UnexpectedToken: t3((e) => {
              let { unexpected: s, HTMLEntity: r } = e;
              return "Unexpected token `".concat(s, "`. Did you mean `").concat(r, "` or `{'").concat(s, "'}`?");
            }), UnsupportedJsxValue: t3("JSX value should be either an expression or a quoted JSX text."), UnterminatedJsxContent: t3("Unterminated JSX contents."), UnwrappedAdjacentJSXElements: t3("Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?") }));
            function Ce(t3) {
              return t3 ? t3.type === "JSXOpeningFragment" || t3.type === "JSXClosingFragment" : false;
            }
            function Ue(t3) {
              if (t3.type === "JSXIdentifier")
                return t3.name;
              if (t3.type === "JSXNamespacedName")
                return t3.namespace.name + ":" + t3.name.name;
              if (t3.type === "JSXMemberExpression")
                return Ue(t3.object) + "." + Ue(t3.property);
              throw new Error("Node had unexpected type: " + t3.type);
            }
            var Lh = (t3) => class extends t3 {
              jsxReadToken() {
                let e = "", s = this.state.pos;
                for (; ; ) {
                  if (this.state.pos >= this.length)
                    throw this.raise(Ie.UnterminatedJsxContent, { at: this.state.startLoc });
                  let r = this.input.charCodeAt(this.state.pos);
                  switch (r) {
                    case 60:
                    case 123:
                      return this.state.pos === this.state.start ? r === 60 && this.state.canStartJSXElement ? (++this.state.pos, this.finishToken(138)) : super.getTokenFromCode(r) : (e += this.input.slice(s, this.state.pos), this.finishToken(137, e));
                    case 38:
                      e += this.input.slice(s, this.state.pos), e += this.jsxReadEntity(), s = this.state.pos;
                      break;
                    case 62:
                    case 125:
                    default:
                      Ne(r) ? (e += this.input.slice(s, this.state.pos), e += this.jsxReadNewLine(true), s = this.state.pos) : ++this.state.pos;
                  }
                }
              }
              jsxReadNewLine(e) {
                let s = this.input.charCodeAt(this.state.pos), r;
                return ++this.state.pos, s === 13 && this.input.charCodeAt(this.state.pos) === 10 ? (++this.state.pos, r = e ? `
` : `\r
`) : r = String.fromCharCode(s), ++this.state.curLine, this.state.lineStart = this.state.pos, r;
              }
              jsxReadString(e) {
                let s = "", r = ++this.state.pos;
                for (; ; ) {
                  if (this.state.pos >= this.length)
                    throw this.raise(u.UnterminatedString, { at: this.state.startLoc });
                  let i = this.input.charCodeAt(this.state.pos);
                  if (i === e)
                    break;
                  i === 38 ? (s += this.input.slice(r, this.state.pos), s += this.jsxReadEntity(), r = this.state.pos) : Ne(i) ? (s += this.input.slice(r, this.state.pos), s += this.jsxReadNewLine(false), r = this.state.pos) : ++this.state.pos;
                }
                return s += this.input.slice(r, this.state.pos++), this.finishToken(129, s);
              }
              jsxReadEntity() {
                let e = ++this.state.pos;
                if (this.codePointAtPos(this.state.pos) === 35) {
                  ++this.state.pos;
                  let s = 10;
                  this.codePointAtPos(this.state.pos) === 120 && (s = 16, ++this.state.pos);
                  let r = this.readInt(s, void 0, false, "bail");
                  if (r !== null && this.codePointAtPos(this.state.pos) === 59)
                    return ++this.state.pos, String.fromCodePoint(r);
                } else {
                  let s = 0, r = false;
                  for (; s++ < 10 && this.state.pos < this.length && !(r = this.codePointAtPos(this.state.pos) == 59); )
                    ++this.state.pos;
                  if (r) {
                    let i = this.input.slice(e, this.state.pos), a = Fh[i];
                    if (++this.state.pos, a)
                      return a;
                  }
                }
                return this.state.pos = e, "&";
              }
              jsxReadWord() {
                let e, s = this.state.pos;
                do
                  e = this.input.charCodeAt(++this.state.pos);
                while (Be(e) || e === 45);
                return this.finishToken(136, this.input.slice(s, this.state.pos));
              }
              jsxParseIdentifier() {
                let e = this.startNode();
                return this.match(136) ? e.name = this.state.value : Ht(this.state.type) ? e.name = Pe(this.state.type) : this.unexpected(), this.next(), this.finishNode(e, "JSXIdentifier");
              }
              jsxParseNamespacedName() {
                let e = this.state.start, s = this.state.startLoc, r = this.jsxParseIdentifier();
                if (!this.eat(14))
                  return r;
                let i = this.startNodeAt(e, s);
                return i.namespace = r, i.name = this.jsxParseIdentifier(), this.finishNode(i, "JSXNamespacedName");
              }
              jsxParseElementName() {
                let e = this.state.start, s = this.state.startLoc, r = this.jsxParseNamespacedName();
                if (r.type === "JSXNamespacedName")
                  return r;
                for (; this.eat(16); ) {
                  let i = this.startNodeAt(e, s);
                  i.object = r, i.property = this.jsxParseIdentifier(), r = this.finishNode(i, "JSXMemberExpression");
                }
                return r;
              }
              jsxParseAttributeValue() {
                let e;
                switch (this.state.type) {
                  case 5:
                    return e = this.startNode(), this.setContext(z.brace), this.next(), e = this.jsxParseExpressionContainer(e, z.j_oTag), e.expression.type === "JSXEmptyExpression" && this.raise(Ie.AttributeIsEmpty, { at: e }), e;
                  case 138:
                  case 129:
                    return this.parseExprAtom();
                  default:
                    throw this.raise(Ie.UnsupportedJsxValue, { at: this.state.startLoc });
                }
              }
              jsxParseEmptyExpression() {
                let e = this.startNodeAt(this.state.lastTokEndLoc.index, this.state.lastTokEndLoc);
                return this.finishNodeAt(e, "JSXEmptyExpression", this.state.startLoc);
              }
              jsxParseSpreadChild(e) {
                return this.next(), e.expression = this.parseExpression(), this.setContext(z.j_oTag), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e, "JSXSpreadChild");
              }
              jsxParseExpressionContainer(e, s) {
                if (this.match(8))
                  e.expression = this.jsxParseEmptyExpression();
                else {
                  let r = this.parseExpression();
                  e.expression = r;
                }
                return this.setContext(s), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e, "JSXExpressionContainer");
              }
              jsxParseAttribute() {
                let e = this.startNode();
                return this.match(5) ? (this.setContext(z.brace), this.next(), this.expect(21), e.argument = this.parseMaybeAssignAllowIn(), this.setContext(z.j_oTag), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e, "JSXSpreadAttribute")) : (e.name = this.jsxParseNamespacedName(), e.value = this.eat(29) ? this.jsxParseAttributeValue() : null, this.finishNode(e, "JSXAttribute"));
              }
              jsxParseOpeningElementAt(e, s) {
                let r = this.startNodeAt(e, s);
                return this.eat(139) ? this.finishNode(r, "JSXOpeningFragment") : (r.name = this.jsxParseElementName(), this.jsxParseOpeningElementAfterName(r));
              }
              jsxParseOpeningElementAfterName(e) {
                let s = [];
                for (; !this.match(56) && !this.match(139); )
                  s.push(this.jsxParseAttribute());
                return e.attributes = s, e.selfClosing = this.eat(56), this.expect(139), this.finishNode(e, "JSXOpeningElement");
              }
              jsxParseClosingElementAt(e, s) {
                let r = this.startNodeAt(e, s);
                return this.eat(139) ? this.finishNode(r, "JSXClosingFragment") : (r.name = this.jsxParseElementName(), this.expect(139), this.finishNode(r, "JSXClosingElement"));
              }
              jsxParseElementAt(e, s) {
                let r = this.startNodeAt(e, s), i = [], a = this.jsxParseOpeningElementAt(e, s), n = null;
                if (!a.selfClosing) {
                  e:
                    for (; ; )
                      switch (this.state.type) {
                        case 138:
                          if (e = this.state.start, s = this.state.startLoc, this.next(), this.eat(56)) {
                            n = this.jsxParseClosingElementAt(e, s);
                            break e;
                          }
                          i.push(this.jsxParseElementAt(e, s));
                          break;
                        case 137:
                          i.push(this.parseExprAtom());
                          break;
                        case 5: {
                          let o = this.startNode();
                          this.setContext(z.brace), this.next(), this.match(21) ? i.push(this.jsxParseSpreadChild(o)) : i.push(this.jsxParseExpressionContainer(o, z.j_expr));
                          break;
                        }
                        default:
                          throw this.unexpected();
                      }
                  Ce(a) && !Ce(n) && n !== null ? this.raise(Ie.MissingClosingTagFragment, { at: n }) : !Ce(a) && Ce(n) ? this.raise(Ie.MissingClosingTagElement, { at: n, openingTagName: Ue(a.name) }) : !Ce(a) && !Ce(n) && Ue(n.name) !== Ue(a.name) && this.raise(Ie.MissingClosingTagElement, { at: n, openingTagName: Ue(a.name) });
                }
                if (Ce(a) ? (r.openingFragment = a, r.closingFragment = n) : (r.openingElement = a, r.closingElement = n), r.children = i, this.match(47))
                  throw this.raise(Ie.UnwrappedAdjacentJSXElements, { at: this.state.startLoc });
                return Ce(a) ? this.finishNode(r, "JSXFragment") : this.finishNode(r, "JSXElement");
              }
              jsxParseElement() {
                let e = this.state.start, s = this.state.startLoc;
                return this.next(), this.jsxParseElementAt(e, s);
              }
              setContext(e) {
                let { context: s } = this.state;
                s[s.length - 1] = e;
              }
              parseExprAtom(e) {
                return this.match(137) ? this.parseLiteral(this.state.value, "JSXText") : this.match(138) ? this.jsxParseElement() : this.match(47) && this.input.charCodeAt(this.state.pos) !== 33 ? (this.replaceToken(138), this.jsxParseElement()) : super.parseExprAtom(e);
              }
              skipSpace() {
                this.curContext().preserveSpace || super.skipSpace();
              }
              getTokenFromCode(e) {
                let s = this.curContext();
                if (s === z.j_expr)
                  return this.jsxReadToken();
                if (s === z.j_oTag || s === z.j_cTag) {
                  if (de(e))
                    return this.jsxReadWord();
                  if (e === 62)
                    return ++this.state.pos, this.finishToken(139);
                  if ((e === 34 || e === 39) && s === z.j_oTag)
                    return this.jsxReadString(e);
                }
                return e === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33 ? (++this.state.pos, this.finishToken(138)) : super.getTokenFromCode(e);
              }
              updateContext(e) {
                let { context: s, type: r } = this.state;
                if (r === 56 && e === 138)
                  s.splice(-2, 2, z.j_cTag), this.state.canStartJSXElement = false;
                else if (r === 138)
                  s.push(z.j_oTag);
                else if (r === 139) {
                  let i = s[s.length - 1];
                  i === z.j_oTag && e === 56 || i === z.j_cTag ? (s.pop(), this.state.canStartJSXElement = s[s.length - 1] === z.j_expr) : (this.setContext(z.j_expr), this.state.canStartJSXElement = true);
                } else
                  this.state.canStartJSXElement = So(r);
              }
            }, Oh = class extends os {
              constructor() {
                super(...arguments), this.types = /* @__PURE__ */ new Set(), this.enums = /* @__PURE__ */ new Set(), this.constEnums = /* @__PURE__ */ new Set(), this.classes = /* @__PURE__ */ new Set(), this.exportOnlyBindings = /* @__PURE__ */ new Set();
              }
            }, Bh = class extends hs {
              createScope(t3) {
                return new Oh(t3);
              }
              declareName(t3, e, s) {
                let r = this.currentScope();
                if (e & Zt) {
                  this.maybeExportDefined(r, t3), r.exportOnlyBindings.add(t3);
                  return;
                }
                super.declareName(...arguments), e & Re && (e & ye || (this.checkRedeclarationInScope(r, t3, e, s), this.maybeExportDefined(r, t3)), r.types.add(t3)), e & $t && r.enums.add(t3), e & Qt && r.constEnums.add(t3), e & ct && r.classes.add(t3);
              }
              isRedeclaredInScope(t3, e, s) {
                if (t3.enums.has(e)) {
                  if (s & $t) {
                    let r = !!(s & Qt), i = t3.constEnums.has(e);
                    return r !== i;
                  }
                  return true;
                }
                return s & ct && t3.classes.has(e) ? t3.lexical.has(e) ? !!(s & ye) : false : s & Re && t3.types.has(e) ? true : super.isRedeclaredInScope(...arguments);
              }
              checkLocalExport(t3) {
                let e = this.scopeStack[0], { name: s } = t3;
                !e.types.has(s) && !e.exportOnlyBindings.has(s) && super.checkLocalExport(t3);
              }
            }, Mh = (t3, e) => Object.hasOwnProperty.call(t3, e) && t3[e];
            function Rh(t3) {
              if (t3 == null)
                throw new Error("Unexpected ".concat(t3, " value."));
              return t3;
            }
            function Br(t3) {
              if (!t3)
                throw new Error("Assert fail");
            }
            function jh(t3) {
              return Vt(t3) || Oo(t3);
            }
            var S = j(Vn || (Vn = rt(["typescript"])))((t3) => ({ AbstractMethodHasImplementation: t3((e) => {
              let { methodName: s } = e;
              return "Method '".concat(s, "' cannot have an implementation because it is marked abstract.");
            }), AbstractPropertyHasInitializer: t3((e) => {
              let { propertyName: s } = e;
              return "Property '".concat(s, "' cannot have an initializer because it is marked abstract.");
            }), AccesorCannotDeclareThisParameter: t3("'get' and 'set' accessors cannot declare 'this' parameters."), AccesorCannotHaveTypeParameters: t3("An accessor cannot have type parameters."), CannotFindName: t3((e) => {
              let { name: s } = e;
              return "Cannot find name '".concat(s, "'.");
            }), ClassMethodHasDeclare: t3("Class methods cannot have the 'declare' modifier."), ClassMethodHasReadonly: t3("Class methods cannot have the 'readonly' modifier."), ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: t3("A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference."), ConstructorHasTypeParameters: t3("Type parameters cannot appear on a constructor declaration."), DeclareAccessor: t3((e) => {
              let { kind: s } = e;
              return "'declare' is not allowed in ".concat(s, "ters.");
            }), DeclareClassFieldHasInitializer: t3("Initializers are not allowed in ambient contexts."), DeclareFunctionHasImplementation: t3("An implementation cannot be declared in ambient contexts."), DuplicateAccessibilityModifier: t3((e) => {
              let { modifier: s } = e;
              return "Accessibility modifier already seen.";
            }), DuplicateModifier: t3((e) => {
              let { modifier: s } = e;
              return "Duplicate modifier: '".concat(s, "'.");
            }), EmptyHeritageClauseType: t3((e) => {
              let { token: s } = e;
              return "'".concat(s, "' list cannot be empty.");
            }), EmptyTypeArguments: t3("Type argument list cannot be empty."), EmptyTypeParameters: t3("Type parameter list cannot be empty."), ExpectedAmbientAfterExportDeclare: t3("'export declare' must be followed by an ambient declaration."), ImportAliasHasImportType: t3("An import alias can not use 'import type'."), IncompatibleModifiers: t3((e) => {
              let { modifiers: s } = e;
              return "'".concat(s[0], "' modifier cannot be used with '").concat(s[1], "' modifier.");
            }), IndexSignatureHasAbstract: t3("Index signatures cannot have the 'abstract' modifier."), IndexSignatureHasAccessibility: t3((e) => {
              let { modifier: s } = e;
              return "Index signatures cannot have an accessibility modifier ('".concat(s, "').");
            }), IndexSignatureHasDeclare: t3("Index signatures cannot have the 'declare' modifier."), IndexSignatureHasOverride: t3("'override' modifier cannot appear on an index signature."), IndexSignatureHasStatic: t3("Index signatures cannot have the 'static' modifier."), InitializerNotAllowedInAmbientContext: t3("Initializers are not allowed in ambient contexts."), InvalidModifierOnTypeMember: t3((e) => {
              let { modifier: s } = e;
              return "'".concat(s, "' modifier cannot appear on a type member.");
            }), InvalidModifierOnTypeParameter: t3((e) => {
              let { modifier: s } = e;
              return "'".concat(s, "' modifier cannot appear on a type parameter.");
            }), InvalidModifierOnTypeParameterPositions: t3((e) => {
              let { modifier: s } = e;
              return "'".concat(s, "' modifier can only appear on a type parameter of a class, interface or type alias.");
            }), InvalidModifiersOrder: t3((e) => {
              let { orderedModifiers: s } = e;
              return "'".concat(s[0], "' modifier must precede '").concat(s[1], "' modifier.");
            }), InvalidTupleMemberLabel: t3("Tuple members must be labeled with a simple identifier."), MissingInterfaceName: t3("'interface' declarations must be followed by an identifier."), MixedLabeledAndUnlabeledElements: t3("Tuple members must all have names or all not have names."), NonAbstractClassHasAbstractMethod: t3("Abstract methods can only appear within an abstract class."), NonClassMethodPropertyHasAbstractModifer: t3("'abstract' modifier can only appear on a class, method, or property declaration."), OptionalTypeBeforeRequired: t3("A required element cannot follow an optional element."), OverrideNotInSubClass: t3("This member cannot have an 'override' modifier because its containing class does not extend another class."), PatternIsOptional: t3("A binding pattern parameter cannot be optional in an implementation signature."), PrivateElementHasAbstract: t3("Private elements cannot have the 'abstract' modifier."), PrivateElementHasAccessibility: t3((e) => {
              let { modifier: s } = e;
              return "Private elements cannot have an accessibility modifier ('".concat(s, "').");
            }), ReadonlyForMethodSignature: t3("'readonly' modifier can only appear on a property declaration or index signature."), ReservedArrowTypeParam: t3("This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`."), ReservedTypeAssertion: t3("This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead."), SetAccesorCannotHaveOptionalParameter: t3("A 'set' accessor cannot have an optional parameter."), SetAccesorCannotHaveRestParameter: t3("A 'set' accessor cannot have rest parameter."), SetAccesorCannotHaveReturnType: t3("A 'set' accessor cannot have a return type annotation."), SingleTypeParameterWithoutTrailingComma: t3((e) => {
              let { typeParameterName: s } = e;
              return "Single type parameter ".concat(s, " should have a trailing comma. Example usage: <").concat(s, ",>.");
            }), StaticBlockCannotHaveModifier: t3("Static class blocks cannot have any modifier."), TypeAnnotationAfterAssign: t3("Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`."), TypeImportCannotSpecifyDefaultAndNamed: t3("A type-only import can specify a default import or named bindings, but not both."), TypeModifierIsUsedInTypeExports: t3("The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement."), TypeModifierIsUsedInTypeImports: t3("The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement."), UnexpectedParameterModifier: t3("A parameter property is only allowed in a constructor implementation."), UnexpectedReadonly: t3("'readonly' type modifier is only permitted on array and tuple literal types."), UnexpectedTypeAnnotation: t3("Did not expect a type annotation here."), UnexpectedTypeCastInParameter: t3("Unexpected type cast in parameter position."), UnsupportedImportTypeArgument: t3("Argument in a type import must be a string literal."), UnsupportedParameterPropertyKind: t3("A parameter property may not be declared using a binding pattern."), UnsupportedSignatureParameterKind: t3((e) => {
              let { type: s } = e;
              return "Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ".concat(s, ".");
            }) }));
            function qh(t3) {
              switch (t3) {
                case "any":
                  return "TSAnyKeyword";
                case "boolean":
                  return "TSBooleanKeyword";
                case "bigint":
                  return "TSBigIntKeyword";
                case "never":
                  return "TSNeverKeyword";
                case "number":
                  return "TSNumberKeyword";
                case "object":
                  return "TSObjectKeyword";
                case "string":
                  return "TSStringKeyword";
                case "symbol":
                  return "TSSymbolKeyword";
                case "undefined":
                  return "TSUndefinedKeyword";
                case "unknown":
                  return "TSUnknownKeyword";
                default:
                  return;
              }
            }
            function Mr(t3) {
              return t3 === "private" || t3 === "public" || t3 === "protected";
            }
            function Uh(t3) {
              return t3 === "in" || t3 === "out";
            }
            var _h = (t3) => class extends t3 {
              getScopeHandler() {
                return Bh;
              }
              tsIsIdentifier() {
                return K(this.state.type);
              }
              tsTokenCanFollowModifier() {
                return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(134) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
              }
              tsNextTokenCanFollowModifier() {
                return this.next(), this.tsTokenCanFollowModifier();
              }
              tsParseModifier(e, s) {
                if (!K(this.state.type) && this.state.type !== 58)
                  return;
                let r = this.state.value;
                if (e.indexOf(r) !== -1) {
                  if (s && this.tsIsStartOfStaticBlocks())
                    return;
                  if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this)))
                    return r;
                }
              }
              tsParseModifiers(e) {
                let { modified: s, allowedModifiers: r, disallowedModifiers: i, stopOnStartOfClassStaticBlock: a, errorTemplate: n = S.InvalidModifierOnTypeMember } = e, o = (f, y, P, v) => {
                  y === P && s[v] && this.raise(S.InvalidModifiersOrder, { at: f, orderedModifiers: [P, v] });
                }, c = (f, y, P, v) => {
                  (s[P] && y === v || s[v] && y === P) && this.raise(S.IncompatibleModifiers, { at: f, modifiers: [P, v] });
                };
                for (; ; ) {
                  let { startLoc: f } = this.state, y = this.tsParseModifier(r.concat(i != null ? i : []), a);
                  if (!y)
                    break;
                  Mr(y) ? s.accessibility ? this.raise(S.DuplicateAccessibilityModifier, { at: f, modifier: y }) : (o(f, y, y, "override"), o(f, y, y, "static"), o(f, y, y, "readonly"), s.accessibility = y) : Uh(y) ? (s[y] && this.raise(S.DuplicateModifier, { at: f, modifier: y }), s[y] = true, o(f, y, "in", "out")) : (Object.hasOwnProperty.call(s, y) ? this.raise(S.DuplicateModifier, { at: f, modifier: y }) : (o(f, y, "static", "readonly"), o(f, y, "static", "override"), o(f, y, "override", "readonly"), o(f, y, "abstract", "override"), c(f, y, "declare", "override"), c(f, y, "static", "abstract")), s[y] = true), i != null && i.includes(y) && this.raise(n, { at: f, modifier: y });
                }
              }
              tsIsListTerminator(e) {
                switch (e) {
                  case "EnumMembers":
                  case "TypeMembers":
                    return this.match(8);
                  case "HeritageClauseElement":
                    return this.match(5);
                  case "TupleElementTypes":
                    return this.match(3);
                  case "TypeParametersOrArguments":
                    return this.match(48);
                }
                throw new Error("Unreachable");
              }
              tsParseList(e, s) {
                let r = [];
                for (; !this.tsIsListTerminator(e); )
                  r.push(s());
                return r;
              }
              tsParseDelimitedList(e, s, r) {
                return Rh(this.tsParseDelimitedListWorker(e, s, true, r));
              }
              tsParseDelimitedListWorker(e, s, r, i) {
                let a = [], n = -1;
                for (; !this.tsIsListTerminator(e); ) {
                  n = -1;
                  let o = s();
                  if (o == null)
                    return;
                  if (a.push(o), this.eat(12)) {
                    n = this.state.lastTokStart;
                    continue;
                  }
                  if (this.tsIsListTerminator(e))
                    break;
                  r && this.expect(12);
                  return;
                }
                return i && (i.value = n), a;
              }
              tsParseBracketedList(e, s, r, i, a) {
                i || (r ? this.expect(0) : this.expect(47));
                let n = this.tsParseDelimitedList(e, s, a);
                return r ? this.expect(3) : this.expect(48), n;
              }
              tsParseImportType() {
                let e = this.startNode();
                return this.expect(83), this.expect(10), this.match(129) || this.raise(S.UnsupportedImportTypeArgument, { at: this.state.startLoc }), e.argument = this.parseExprAtom(), this.expect(11), this.eat(16) && (e.qualifier = this.tsParseEntityName()), this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSImportType");
              }
              tsParseEntityName() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, s = this.parseIdentifier(e);
                for (; this.eat(16); ) {
                  let r = this.startNodeAtNode(s);
                  r.left = s, r.right = this.parseIdentifier(e), s = this.finishNode(r, "TSQualifiedName");
                }
                return s;
              }
              tsParseTypeReference() {
                let e = this.startNode();
                return e.typeName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSTypeReference");
              }
              tsParseThisTypePredicate(e) {
                this.next();
                let s = this.startNodeAtNode(e);
                return s.parameterName = e, s.typeAnnotation = this.tsParseTypeAnnotation(false), s.asserts = false, this.finishNode(s, "TSTypePredicate");
              }
              tsParseThisTypeNode() {
                let e = this.startNode();
                return this.next(), this.finishNode(e, "TSThisType");
              }
              tsParseTypeQuery() {
                let e = this.startNode();
                return this.expect(87), this.match(83) ? e.exprName = this.tsParseImportType() : e.exprName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e.typeParameters = this.tsParseTypeArguments()), this.finishNode(e, "TSTypeQuery");
              }
              tsParseInOutModifiers(e) {
                this.tsParseModifiers({ modified: e, allowedModifiers: ["in", "out"], disallowedModifiers: ["public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: S.InvalidModifierOnTypeParameter });
              }
              tsParseNoneModifiers(e) {
                this.tsParseModifiers({ modified: e, allowedModifiers: [], disallowedModifiers: ["in", "out"], errorTemplate: S.InvalidModifierOnTypeParameterPositions });
              }
              tsParseTypeParameter() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.tsParseNoneModifiers.bind(this), s = this.startNode();
                return e(s), s.name = this.tsParseTypeParameterName(), s.constraint = this.tsEatThenParseType(81), s.default = this.tsEatThenParseType(29), this.finishNode(s, "TSTypeParameter");
              }
              tsTryParseTypeParameters(e) {
                if (this.match(47))
                  return this.tsParseTypeParameters(e);
              }
              tsParseTypeParameters(e) {
                let s = this.startNode();
                this.match(47) || this.match(138) ? this.next() : this.unexpected();
                let r = { value: -1 };
                return s.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this, e), false, true, r), s.params.length === 0 && this.raise(S.EmptyTypeParameters, { at: s }), r.value !== -1 && this.addExtra(s, "trailingComma", r.value), this.finishNode(s, "TSTypeParameterDeclaration");
              }
              tsTryNextParseConstantContext() {
                if (this.lookahead().type !== 75)
                  return null;
                this.next();
                let e = this.tsParseTypeReference();
                return e.typeParameters && this.raise(S.CannotFindName, { at: e.typeName, name: "const" }), e;
              }
              tsFillSignature(e, s) {
                let r = e === 19, i = "parameters", a = "typeAnnotation";
                s.typeParameters = this.tsTryParseTypeParameters(), this.expect(10), s[i] = this.tsParseBindingListForSignature(), r ? s[a] = this.tsParseTypeOrTypePredicateAnnotation(e) : this.match(e) && (s[a] = this.tsParseTypeOrTypePredicateAnnotation(e));
              }
              tsParseBindingListForSignature() {
                return this.parseBindingList(11, 41).map((e) => (e.type !== "Identifier" && e.type !== "RestElement" && e.type !== "ObjectPattern" && e.type !== "ArrayPattern" && this.raise(S.UnsupportedSignatureParameterKind, { at: e, type: e.type }), e));
              }
              tsParseTypeMemberSemicolon() {
                !this.eat(12) && !this.isLineTerminator() && this.expect(13);
              }
              tsParseSignatureMember(e, s) {
                return this.tsFillSignature(14, s), this.tsParseTypeMemberSemicolon(), this.finishNode(s, e);
              }
              tsIsUnambiguouslyIndexSignature() {
                return this.next(), K(this.state.type) ? (this.next(), this.match(14)) : false;
              }
              tsTryParseIndexSignature(e) {
                if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this))))
                  return;
                this.expect(0);
                let s = this.parseIdentifier();
                s.typeAnnotation = this.tsParseTypeAnnotation(), this.resetEndLocation(s), this.expect(3), e.parameters = [s];
                let r = this.tsTryParseTypeAnnotation();
                return r && (e.typeAnnotation = r), this.tsParseTypeMemberSemicolon(), this.finishNode(e, "TSIndexSignature");
              }
              tsParsePropertyOrMethodSignature(e, s) {
                this.eat(17) && (e.optional = true);
                let r = e;
                if (this.match(10) || this.match(47)) {
                  s && this.raise(S.ReadonlyForMethodSignature, { at: e });
                  let i = r;
                  i.kind && this.match(47) && this.raise(S.AccesorCannotHaveTypeParameters, { at: this.state.curPosition() }), this.tsFillSignature(14, i), this.tsParseTypeMemberSemicolon();
                  let a = "parameters", n = "typeAnnotation";
                  if (i.kind === "get")
                    i[a].length > 0 && (this.raise(u.BadGetterArity, { at: this.state.curPosition() }), this.isThisParam(i[a][0]) && this.raise(S.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }));
                  else if (i.kind === "set") {
                    if (i[a].length !== 1)
                      this.raise(u.BadSetterArity, { at: this.state.curPosition() });
                    else {
                      let o = i[a][0];
                      this.isThisParam(o) && this.raise(S.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }), o.type === "Identifier" && o.optional && this.raise(S.SetAccesorCannotHaveOptionalParameter, { at: this.state.curPosition() }), o.type === "RestElement" && this.raise(S.SetAccesorCannotHaveRestParameter, { at: this.state.curPosition() });
                    }
                    i[n] && this.raise(S.SetAccesorCannotHaveReturnType, { at: i[n] });
                  } else
                    i.kind = "method";
                  return this.finishNode(i, "TSMethodSignature");
                } else {
                  let i = r;
                  s && (i.readonly = true);
                  let a = this.tsTryParseTypeAnnotation();
                  return a && (i.typeAnnotation = a), this.tsParseTypeMemberSemicolon(), this.finishNode(i, "TSPropertySignature");
                }
              }
              tsParseTypeMember() {
                let e = this.startNode();
                if (this.match(10) || this.match(47))
                  return this.tsParseSignatureMember("TSCallSignatureDeclaration", e);
                if (this.match(77)) {
                  let r = this.startNode();
                  return this.next(), this.match(10) || this.match(47) ? this.tsParseSignatureMember("TSConstructSignatureDeclaration", e) : (e.key = this.createIdentifier(r, "new"), this.tsParsePropertyOrMethodSignature(e, false));
                }
                this.tsParseModifiers({ modified: e, allowedModifiers: ["readonly"], disallowedModifiers: ["declare", "abstract", "private", "protected", "public", "static", "override"] });
                let s = this.tsTryParseIndexSignature(e);
                return s || (this.parsePropertyName(e), !e.computed && e.key.type === "Identifier" && (e.key.name === "get" || e.key.name === "set") && this.tsTokenCanFollowModifier() && (e.kind = e.key.name, this.parsePropertyName(e)), this.tsParsePropertyOrMethodSignature(e, !!e.readonly));
              }
              tsParseTypeLiteral() {
                let e = this.startNode();
                return e.members = this.tsParseObjectTypeMembers(), this.finishNode(e, "TSTypeLiteral");
              }
              tsParseObjectTypeMembers() {
                this.expect(5);
                let e = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
                return this.expect(8), e;
              }
              tsIsStartOfMappedType() {
                return this.next(), this.eat(53) ? this.isContextual(118) : (this.isContextual(118) && this.next(), !this.match(0) || (this.next(), !this.tsIsIdentifier()) ? false : (this.next(), this.match(58)));
              }
              tsParseMappedTypeParameter() {
                let e = this.startNode();
                return e.name = this.tsParseTypeParameterName(), e.constraint = this.tsExpectThenParseType(58), this.finishNode(e, "TSTypeParameter");
              }
              tsParseMappedType() {
                let e = this.startNode();
                return this.expect(5), this.match(53) ? (e.readonly = this.state.value, this.next(), this.expectContextual(118)) : this.eatContextual(118) && (e.readonly = true), this.expect(0), e.typeParameter = this.tsParseMappedTypeParameter(), e.nameType = this.eatContextual(93) ? this.tsParseType() : null, this.expect(3), this.match(53) ? (e.optional = this.state.value, this.next(), this.expect(17)) : this.eat(17) && (e.optional = true), e.typeAnnotation = this.tsTryParseType(), this.semicolon(), this.expect(8), this.finishNode(e, "TSMappedType");
              }
              tsParseTupleType() {
                let e = this.startNode();
                e.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), true, false);
                let s = false, r = null;
                return e.elementTypes.forEach((i) => {
                  var a;
                  let { type: n } = i;
                  s && n !== "TSRestType" && n !== "TSOptionalType" && !(n === "TSNamedTupleMember" && i.optional) && this.raise(S.OptionalTypeBeforeRequired, { at: i }), s = s || n === "TSNamedTupleMember" && i.optional || n === "TSOptionalType", n === "TSRestType" && (i = i.typeAnnotation, n = i.type);
                  let o = n === "TSNamedTupleMember";
                  r = (a = r) != null ? a : o, r !== o && this.raise(S.MixedLabeledAndUnlabeledElements, { at: i });
                }), this.finishNode(e, "TSTupleType");
              }
              tsParseTupleElementType() {
                let { start: e, startLoc: s } = this.state, r = this.eat(21), i = this.tsParseType(), a = this.eat(17);
                if (this.eat(14)) {
                  let o = this.startNodeAtNode(i);
                  o.optional = a, i.type === "TSTypeReference" && !i.typeParameters && i.typeName.type === "Identifier" ? o.label = i.typeName : (this.raise(S.InvalidTupleMemberLabel, { at: i }), o.label = i), o.elementType = this.tsParseType(), i = this.finishNode(o, "TSNamedTupleMember");
                } else if (a) {
                  let o = this.startNodeAtNode(i);
                  o.typeAnnotation = i, i = this.finishNode(o, "TSOptionalType");
                }
                if (r) {
                  let o = this.startNodeAt(e, s);
                  o.typeAnnotation = i, i = this.finishNode(o, "TSRestType");
                }
                return i;
              }
              tsParseParenthesizedType() {
                let e = this.startNode();
                return this.expect(10), e.typeAnnotation = this.tsParseType(), this.expect(11), this.finishNode(e, "TSParenthesizedType");
              }
              tsParseFunctionOrConstructorType(e, s) {
                let r = this.startNode();
                return e === "TSConstructorType" && (r.abstract = !!s, s && this.next(), this.next()), this.tsFillSignature(19, r), this.finishNode(r, e);
              }
              tsParseLiteralTypeNode() {
                let e = this.startNode();
                return e.literal = (() => {
                  switch (this.state.type) {
                    case 130:
                    case 131:
                    case 129:
                    case 85:
                    case 86:
                      return this.parseExprAtom();
                    default:
                      throw this.unexpected();
                  }
                })(), this.finishNode(e, "TSLiteralType");
              }
              tsParseTemplateLiteralType() {
                let e = this.startNode();
                return e.literal = this.parseTemplate(false), this.finishNode(e, "TSLiteralType");
              }
              parseTemplateSubstitution() {
                return this.state.inType ? this.tsParseType() : super.parseTemplateSubstitution();
              }
              tsParseThisTypeOrThisTypePredicate() {
                let e = this.tsParseThisTypeNode();
                return this.isContextual(113) && !this.hasPrecedingLineBreak() ? this.tsParseThisTypePredicate(e) : e;
              }
              tsParseNonArrayType() {
                switch (this.state.type) {
                  case 129:
                  case 130:
                  case 131:
                  case 85:
                  case 86:
                    return this.tsParseLiteralTypeNode();
                  case 53:
                    if (this.state.value === "-") {
                      let e = this.startNode(), s = this.lookahead();
                      if (s.type !== 130 && s.type !== 131)
                        throw this.unexpected();
                      return e.literal = this.parseMaybeUnary(), this.finishNode(e, "TSLiteralType");
                    }
                    break;
                  case 78:
                    return this.tsParseThisTypeOrThisTypePredicate();
                  case 87:
                    return this.tsParseTypeQuery();
                  case 83:
                    return this.tsParseImportType();
                  case 5:
                    return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
                  case 0:
                    return this.tsParseTupleType();
                  case 10:
                    return this.tsParseParenthesizedType();
                  case 25:
                  case 24:
                    return this.tsParseTemplateLiteralType();
                  default: {
                    let { type: e } = this.state;
                    if (K(e) || e === 88 || e === 84) {
                      let s = e === 88 ? "TSVoidKeyword" : e === 84 ? "TSNullKeyword" : qh(this.state.value);
                      if (s !== void 0 && this.lookaheadCharCode() !== 46) {
                        let r = this.startNode();
                        return this.next(), this.finishNode(r, s);
                      }
                      return this.tsParseTypeReference();
                    }
                  }
                }
                throw this.unexpected();
              }
              tsParseArrayTypeOrHigher() {
                let e = this.tsParseNonArrayType();
                for (; !this.hasPrecedingLineBreak() && this.eat(0); )
                  if (this.match(3)) {
                    let s = this.startNodeAtNode(e);
                    s.elementType = e, this.expect(3), e = this.finishNode(s, "TSArrayType");
                  } else {
                    let s = this.startNodeAtNode(e);
                    s.objectType = e, s.indexType = this.tsParseType(), this.expect(3), e = this.finishNode(s, "TSIndexedAccessType");
                  }
                return e;
              }
              tsParseTypeOperator() {
                let e = this.startNode(), s = this.state.value;
                return this.next(), e.operator = s, e.typeAnnotation = this.tsParseTypeOperatorOrHigher(), s === "readonly" && this.tsCheckTypeAnnotationForReadOnly(e), this.finishNode(e, "TSTypeOperator");
              }
              tsCheckTypeAnnotationForReadOnly(e) {
                switch (e.typeAnnotation.type) {
                  case "TSTupleType":
                  case "TSArrayType":
                    return;
                  default:
                    this.raise(S.UnexpectedReadonly, { at: e });
                }
              }
              tsParseInferType() {
                let e = this.startNode();
                this.expectContextual(112);
                let s = this.startNode();
                return s.name = this.tsParseTypeParameterName(), s.constraint = this.tsTryParse(() => this.tsParseConstraintForInferType()), e.typeParameter = this.finishNode(s, "TSTypeParameter"), this.finishNode(e, "TSInferType");
              }
              tsParseConstraintForInferType() {
                if (this.eat(81)) {
                  let e = this.tsInDisallowConditionalTypesContext(() => this.tsParseType());
                  if (this.state.inDisallowConditionalTypesContext || !this.match(17))
                    return e;
                }
              }
              tsParseTypeOperatorOrHigher() {
                return Fo(this.state.type) && !this.state.containsEsc ? this.tsParseTypeOperator() : this.isContextual(112) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(() => this.tsParseArrayTypeOrHigher());
              }
              tsParseUnionOrIntersectionType(e, s, r) {
                let i = this.startNode(), a = this.eat(r), n = [];
                do
                  n.push(s());
                while (this.eat(r));
                return n.length === 1 && !a ? n[0] : (i.types = n, this.finishNode(i, e));
              }
              tsParseIntersectionTypeOrHigher() {
                return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
              }
              tsParseUnionTypeOrHigher() {
                return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
              }
              tsIsStartOfFunctionType() {
                return this.match(47) ? true : this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
              }
              tsSkipParameterStart() {
                if (K(this.state.type) || this.match(78))
                  return this.next(), true;
                if (this.match(5)) {
                  let { errors: e } = this.state, s = e.length;
                  try {
                    return this.parseObjectLike(8, true), e.length === s;
                  } catch {
                    return false;
                  }
                }
                if (this.match(0)) {
                  this.next();
                  let { errors: e } = this.state, s = e.length;
                  try {
                    return this.parseBindingList(3, 93, true), e.length === s;
                  } catch {
                    return false;
                  }
                }
                return false;
              }
              tsIsUnambiguouslyStartOfFunctionType() {
                return this.next(), !!(this.match(11) || this.match(21) || this.tsSkipParameterStart() && (this.match(14) || this.match(12) || this.match(17) || this.match(29) || this.match(11) && (this.next(), this.match(19))));
              }
              tsParseTypeOrTypePredicateAnnotation(e) {
                return this.tsInType(() => {
                  let s = this.startNode();
                  this.expect(e);
                  let r = this.startNode(), i = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
                  if (i && this.match(78)) {
                    let o = this.tsParseThisTypeOrThisTypePredicate();
                    return o.type === "TSThisType" ? (r.parameterName = o, r.asserts = true, r.typeAnnotation = null, o = this.finishNode(r, "TSTypePredicate")) : (this.resetStartLocationFromNode(o, r), o.asserts = true), s.typeAnnotation = o, this.finishNode(s, "TSTypeAnnotation");
                  }
                  let a = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
                  if (!a)
                    return i ? (r.parameterName = this.parseIdentifier(), r.asserts = i, r.typeAnnotation = null, s.typeAnnotation = this.finishNode(r, "TSTypePredicate"), this.finishNode(s, "TSTypeAnnotation")) : this.tsParseTypeAnnotation(false, s);
                  let n = this.tsParseTypeAnnotation(false);
                  return r.parameterName = a, r.typeAnnotation = n, r.asserts = i, s.typeAnnotation = this.finishNode(r, "TSTypePredicate"), this.finishNode(s, "TSTypeAnnotation");
                });
              }
              tsTryParseTypeOrTypePredicateAnnotation() {
                return this.match(14) ? this.tsParseTypeOrTypePredicateAnnotation(14) : void 0;
              }
              tsTryParseTypeAnnotation() {
                return this.match(14) ? this.tsParseTypeAnnotation() : void 0;
              }
              tsTryParseType() {
                return this.tsEatThenParseType(14);
              }
              tsParseTypePredicatePrefix() {
                let e = this.parseIdentifier();
                if (this.isContextual(113) && !this.hasPrecedingLineBreak())
                  return this.next(), e;
              }
              tsParseTypePredicateAsserts() {
                if (this.state.type !== 106)
                  return false;
                let e = this.state.containsEsc;
                return this.next(), !K(this.state.type) && !this.match(78) ? false : (e && this.raise(u.InvalidEscapedReservedWord, { at: this.state.lastTokStartLoc, reservedWord: "asserts" }), true);
              }
              tsParseTypeAnnotation() {
                let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.startNode();
                return this.tsInType(() => {
                  e && this.expect(14), s.typeAnnotation = this.tsParseType();
                }), this.finishNode(s, "TSTypeAnnotation");
              }
              tsParseType() {
                Br(this.state.inType);
                let e = this.tsParseNonConditionalType();
                if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81))
                  return e;
                let s = this.startNodeAtNode(e);
                return s.checkType = e, s.extendsType = this.tsInDisallowConditionalTypesContext(() => this.tsParseNonConditionalType()), this.expect(17), s.trueType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.expect(14), s.falseType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.finishNode(s, "TSConditionalType");
              }
              isAbstractConstructorSignature() {
                return this.isContextual(120) && this.lookahead().type === 77;
              }
              tsParseNonConditionalType() {
                return this.tsIsStartOfFunctionType() ? this.tsParseFunctionOrConstructorType("TSFunctionType") : this.match(77) ? this.tsParseFunctionOrConstructorType("TSConstructorType") : this.isAbstractConstructorSignature() ? this.tsParseFunctionOrConstructorType("TSConstructorType", true) : this.tsParseUnionTypeOrHigher();
              }
              tsParseTypeAssertion() {
                this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(S.ReservedTypeAssertion, { at: this.state.startLoc });
                let e = this.startNode(), s = this.tsTryNextParseConstantContext();
                return e.typeAnnotation = s || this.tsNextThenParseType(), this.expect(48), e.expression = this.parseMaybeUnary(), this.finishNode(e, "TSTypeAssertion");
              }
              tsParseHeritageClause(e) {
                let s = this.state.startLoc, r = this.tsParseDelimitedList("HeritageClauseElement", () => {
                  let i = this.startNode();
                  return i.expression = this.tsParseEntityName(), this.match(47) && (i.typeParameters = this.tsParseTypeArguments()), this.finishNode(i, "TSExpressionWithTypeArguments");
                });
                return r.length || this.raise(S.EmptyHeritageClauseType, { at: s, token: e }), r;
              }
              tsParseInterfaceDeclaration(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.hasFollowingLineBreak())
                  return null;
                this.expectContextual(125), s.declare && (e.declare = true), K(this.state.type) ? (e.id = this.parseIdentifier(), this.checkIdentifier(e.id, Wo)) : (e.id = null, this.raise(S.MissingInterfaceName, { at: this.state.startLoc })), e.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this)), this.eat(81) && (e.extends = this.tsParseHeritageClause("extends"));
                let r = this.startNode();
                return r.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this)), e.body = this.finishNode(r, "TSInterfaceBody"), this.finishNode(e, "TSInterfaceDeclaration");
              }
              tsParseTypeAliasDeclaration(e) {
                return e.id = this.parseIdentifier(), this.checkIdentifier(e.id, Go), e.typeAnnotation = this.tsInType(() => {
                  if (e.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this)), this.expect(29), this.isContextual(111) && this.lookahead().type !== 16) {
                    let s = this.startNode();
                    return this.next(), this.finishNode(s, "TSIntrinsicKeyword");
                  }
                  return this.tsParseType();
                }), this.semicolon(), this.finishNode(e, "TSTypeAliasDeclaration");
              }
              tsInNoContext(e) {
                let s = this.state.context;
                this.state.context = [s[0]];
                try {
                  return e();
                } finally {
                  this.state.context = s;
                }
              }
              tsInType(e) {
                let s = this.state.inType;
                this.state.inType = true;
                try {
                  return e();
                } finally {
                  this.state.inType = s;
                }
              }
              tsInDisallowConditionalTypesContext(e) {
                let s = this.state.inDisallowConditionalTypesContext;
                this.state.inDisallowConditionalTypesContext = true;
                try {
                  return e();
                } finally {
                  this.state.inDisallowConditionalTypesContext = s;
                }
              }
              tsInAllowConditionalTypesContext(e) {
                let s = this.state.inDisallowConditionalTypesContext;
                this.state.inDisallowConditionalTypesContext = false;
                try {
                  return e();
                } finally {
                  this.state.inDisallowConditionalTypesContext = s;
                }
              }
              tsEatThenParseType(e) {
                return this.match(e) ? this.tsNextThenParseType() : void 0;
              }
              tsExpectThenParseType(e) {
                return this.tsDoThenParseType(() => this.expect(e));
              }
              tsNextThenParseType() {
                return this.tsDoThenParseType(() => this.next());
              }
              tsDoThenParseType(e) {
                return this.tsInType(() => (e(), this.tsParseType()));
              }
              tsParseEnumMember() {
                let e = this.startNode();
                return e.id = this.match(129) ? this.parseExprAtom() : this.parseIdentifier(true), this.eat(29) && (e.initializer = this.parseMaybeAssignAllowIn()), this.finishNode(e, "TSEnumMember");
              }
              tsParseEnumDeclaration(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return s.const && (e.const = true), s.declare && (e.declare = true), this.expectContextual(122), e.id = this.parseIdentifier(), this.checkIdentifier(e.id, e.const ? Jo : Er), this.expect(5), e.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this)), this.expect(8), this.finishNode(e, "TSEnumDeclaration");
              }
              tsParseModuleBlock() {
                let e = this.startNode();
                return this.scope.enter(Me), this.expect(5), this.parseBlockOrModuleBlockBody(e.body = [], void 0, true, 8), this.scope.exit(), this.finishNode(e, "TSModuleBlock");
              }
              tsParseModuleOrNamespaceDeclaration(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (e.id = this.parseIdentifier(), s || this.checkIdentifier(e.id, Yo), this.eat(16)) {
                  let r = this.startNode();
                  this.tsParseModuleOrNamespaceDeclaration(r, true), e.body = r;
                } else
                  this.scope.enter(ht), this.prodParam.enter(je), e.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit();
                return this.finishNode(e, "TSModuleDeclaration");
              }
              tsParseAmbientExternalModuleDeclaration(e) {
                return this.isContextual(109) ? (e.global = true, e.id = this.parseIdentifier()) : this.match(129) ? e.id = this.parseExprAtom() : this.unexpected(), this.match(5) ? (this.scope.enter(ht), this.prodParam.enter(je), e.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit()) : this.semicolon(), this.finishNode(e, "TSModuleDeclaration");
              }
              tsParseImportEqualsDeclaration(e, s) {
                e.isExport = s || false, e.id = this.parseIdentifier(), this.checkIdentifier(e.id, xe), this.expect(29);
                let r = this.tsParseModuleReference();
                return e.importKind === "type" && r.type !== "TSExternalModuleReference" && this.raise(S.ImportAliasHasImportType, { at: r }), e.moduleReference = r, this.semicolon(), this.finishNode(e, "TSImportEqualsDeclaration");
              }
              tsIsExternalModuleReference() {
                return this.isContextual(116) && this.lookaheadCharCode() === 40;
              }
              tsParseModuleReference() {
                return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(false);
              }
              tsParseExternalModuleReference() {
                let e = this.startNode();
                if (this.expectContextual(116), this.expect(10), !this.match(129))
                  throw this.unexpected();
                return e.expression = this.parseExprAtom(), this.expect(11), this.finishNode(e, "TSExternalModuleReference");
              }
              tsLookAhead(e) {
                let s = this.state.clone(), r = e();
                return this.state = s, r;
              }
              tsTryParseAndCatch(e) {
                let s = this.tryParse((r) => e() || r());
                if (!(s.aborted || !s.node))
                  return s.error && (this.state = s.failState), s.node;
              }
              tsTryParse(e) {
                let s = this.state.clone(), r = e();
                if (r !== void 0 && r !== false)
                  return r;
                this.state = s;
              }
              tsTryParseDeclare(e) {
                if (this.isLineTerminator())
                  return;
                let s = this.state.type, r;
                return this.isContextual(99) && (s = 74, r = "let"), this.tsInAmbientContext(() => {
                  if (s === 68)
                    return e.declare = true, this.parseFunctionStatement(e, false, true);
                  if (s === 80)
                    return e.declare = true, this.parseClass(e, true, false);
                  if (s === 122)
                    return this.tsParseEnumDeclaration(e, { declare: true });
                  if (s === 109)
                    return this.tsParseAmbientExternalModuleDeclaration(e);
                  if (s === 75 || s === 74)
                    return !this.match(75) || !this.isLookaheadContextual("enum") ? (e.declare = true, this.parseVarStatement(e, r || this.state.value, true)) : (this.expect(75), this.tsParseEnumDeclaration(e, { const: true, declare: true }));
                  if (s === 125) {
                    let i = this.tsParseInterfaceDeclaration(e, { declare: true });
                    if (i)
                      return i;
                  }
                  if (K(s))
                    return this.tsParseDeclaration(e, this.state.value, true);
                });
              }
              tsTryParseExportDeclaration() {
                return this.tsParseDeclaration(this.startNode(), this.state.value, true);
              }
              tsParseExpressionStatement(e, s) {
                switch (s.name) {
                  case "declare": {
                    let r = this.tsTryParseDeclare(e);
                    if (r)
                      return r.declare = true, r;
                    break;
                  }
                  case "global":
                    if (this.match(5)) {
                      this.scope.enter(ht), this.prodParam.enter(je);
                      let r = e;
                      return r.global = true, r.id = s, r.body = this.tsParseModuleBlock(), this.scope.exit(), this.prodParam.exit(), this.finishNode(r, "TSModuleDeclaration");
                    }
                    break;
                  default:
                    return this.tsParseDeclaration(e, s.name, false);
                }
              }
              tsParseDeclaration(e, s, r) {
                switch (s) {
                  case "abstract":
                    if (this.tsCheckLineTerminator(r) && (this.match(80) || K(this.state.type)))
                      return this.tsParseAbstractDeclaration(e);
                    break;
                  case "module":
                    if (this.tsCheckLineTerminator(r)) {
                      if (this.match(129))
                        return this.tsParseAmbientExternalModuleDeclaration(e);
                      if (K(this.state.type))
                        return this.tsParseModuleOrNamespaceDeclaration(e);
                    }
                    break;
                  case "namespace":
                    if (this.tsCheckLineTerminator(r) && K(this.state.type))
                      return this.tsParseModuleOrNamespaceDeclaration(e);
                    break;
                  case "type":
                    if (this.tsCheckLineTerminator(r) && K(this.state.type))
                      return this.tsParseTypeAliasDeclaration(e);
                    break;
                }
              }
              tsCheckLineTerminator(e) {
                return e ? this.hasFollowingLineBreak() ? false : (this.next(), true) : !this.isLineTerminator();
              }
              tsTryParseGenericAsyncArrowFunction(e, s) {
                if (!this.match(47))
                  return;
                let r = this.state.maybeInArrowParameters;
                this.state.maybeInArrowParameters = true;
                let i = this.tsTryParseAndCatch(() => {
                  let a = this.startNodeAt(e, s);
                  return a.typeParameters = this.tsParseTypeParameters(), super.parseFunctionParams(a), a.returnType = this.tsTryParseTypeOrTypePredicateAnnotation(), this.expect(19), a;
                });
                if (this.state.maybeInArrowParameters = r, !!i)
                  return this.parseArrowExpression(i, null, true);
              }
              tsParseTypeArgumentsInExpression() {
                if (this.reScan_lt() === 47)
                  return this.tsParseTypeArguments();
              }
              tsParseTypeArguments() {
                let e = this.startNode();
                return e.params = this.tsInType(() => this.tsInNoContext(() => (this.expect(47), this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this))))), e.params.length === 0 && this.raise(S.EmptyTypeArguments, { at: e }), this.expect(48), this.finishNode(e, "TSTypeParameterInstantiation");
              }
              tsIsDeclarationStart() {
                return Lo(this.state.type);
              }
              isExportDefaultSpecifier() {
                return this.tsIsDeclarationStart() ? false : super.isExportDefaultSpecifier();
              }
              parseAssignableListItem(e, s) {
                let r = this.state.start, i = this.state.startLoc, a, n = false, o = false;
                if (e !== void 0) {
                  let y = {};
                  this.tsParseModifiers({ modified: y, allowedModifiers: ["public", "private", "protected", "override", "readonly"] }), a = y.accessibility, o = y.override, n = y.readonly, e === false && (a || n || o) && this.raise(S.UnexpectedParameterModifier, { at: i });
                }
                let c = this.parseMaybeDefault();
                this.parseAssignableListItemTypes(c);
                let f = this.parseMaybeDefault(c.start, c.loc.start, c);
                if (a || n || o) {
                  let y = this.startNodeAt(r, i);
                  return s.length && (y.decorators = s), a && (y.accessibility = a), n && (y.readonly = n), o && (y.override = o), f.type !== "Identifier" && f.type !== "AssignmentPattern" && this.raise(S.UnsupportedParameterPropertyKind, { at: y }), y.parameter = f, this.finishNode(y, "TSParameterProperty");
                }
                return s.length && (c.decorators = s), f;
              }
              isSimpleParameter(e) {
                return e.type === "TSParameterProperty" && super.isSimpleParameter(e.parameter) || super.isSimpleParameter(e);
              }
              parseFunctionBodyAndFinish(e, s) {
                let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                this.match(14) && (e.returnType = this.tsParseTypeOrTypePredicateAnnotation(14));
                let i = s === "FunctionDeclaration" ? "TSDeclareFunction" : s === "ClassMethod" || s === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
                if (i && !this.match(5) && this.isLineTerminator()) {
                  this.finishNode(e, i);
                  return;
                }
                if (i === "TSDeclareFunction" && this.state.isAmbientContext && (this.raise(S.DeclareFunctionHasImplementation, { at: e }), e.declare)) {
                  super.parseFunctionBodyAndFinish(e, i, r);
                  return;
                }
                super.parseFunctionBodyAndFinish(e, s, r);
              }
              registerFunctionStatementId(e) {
                !e.body && e.id ? this.checkIdentifier(e.id, Cr) : super.registerFunctionStatementId(...arguments);
              }
              tsCheckForInvalidTypeCasts(e) {
                e.forEach((s) => {
                  (s == null ? void 0 : s.type) === "TSTypeCastExpression" && this.raise(S.UnexpectedTypeAnnotation, { at: s.typeAnnotation });
                });
              }
              toReferencedList(e, s) {
                return this.tsCheckForInvalidTypeCasts(e), e;
              }
              parseArrayLike() {
                let e = super.parseArrayLike(...arguments);
                return e.type === "ArrayExpression" && this.tsCheckForInvalidTypeCasts(e.elements), e;
              }
              parseSubscript(e, s, r, i, a) {
                if (!this.hasPrecedingLineBreak() && this.match(35)) {
                  this.state.canStartJSXElement = false, this.next();
                  let o = this.startNodeAt(s, r);
                  return o.expression = e, this.finishNode(o, "TSNonNullExpression");
                }
                let n = false;
                if (this.match(18) && this.lookaheadCharCode() === 60) {
                  if (i)
                    return a.stop = true, e;
                  a.optionalChainMember = n = true, this.next();
                }
                if (this.match(47) || this.match(51)) {
                  let o, c = this.tsTryParseAndCatch(() => {
                    if (!i && this.atPossibleAsyncArrow(e)) {
                      let P = this.tsTryParseGenericAsyncArrowFunction(s, r);
                      if (P)
                        return P;
                    }
                    let f = this.tsParseTypeArgumentsInExpression();
                    if (!f)
                      throw this.unexpected();
                    if (n && !this.match(10))
                      throw o = this.state.curPosition(), this.unexpected();
                    if (nt(this.state.type)) {
                      let P = this.parseTaggedTemplateExpression(e, s, r, a);
                      return P.typeParameters = f, P;
                    }
                    if (!i && this.eat(10)) {
                      let P = this.startNodeAt(s, r);
                      return P.callee = e, P.arguments = this.parseCallExpressionArguments(11, false), this.tsCheckForInvalidTypeCasts(P.arguments), P.typeParameters = f, a.optionalChainMember && (P.optional = n), this.finishCallExpression(P, a.optionalChainMember);
                    }
                    if (jh(this.state.type) && this.state.type !== 10)
                      throw this.unexpected();
                    let y = this.startNodeAt(s, r);
                    return y.expression = e, y.typeParameters = f, this.finishNode(y, "TSInstantiationExpression");
                  });
                  if (o && this.unexpected(o, 10), c)
                    return c;
                }
                return super.parseSubscript(e, s, r, i, a);
              }
              parseNewCallee(e) {
                var s;
                super.parseNewCallee(e);
                let { callee: r } = e;
                r.type === "TSInstantiationExpression" && !((s = r.extra) != null && s.parenthesized) && (e.typeParameters = r.typeParameters, e.callee = r.expression);
              }
              parseExprOp(e, s, r, i) {
                if (at2(58) > i && !this.hasPrecedingLineBreak() && this.isContextual(93)) {
                  let a = this.startNodeAt(s, r);
                  a.expression = e;
                  let n = this.tsTryNextParseConstantContext();
                  return n ? a.typeAnnotation = n : a.typeAnnotation = this.tsNextThenParseType(), this.finishNode(a, "TSAsExpression"), this.reScan_lt_gt(), this.parseExprOp(a, s, r, i);
                }
                return super.parseExprOp(e, s, r, i);
              }
              checkReservedWord(e, s, r, i) {
                this.state.isAmbientContext || super.checkReservedWord(e, s, r, i);
              }
              checkDuplicateExports() {
              }
              parseImport(e) {
                if (e.importKind = "value", K(this.state.type) || this.match(55) || this.match(5)) {
                  let r = this.lookahead();
                  if (this.isContextual(126) && r.type !== 12 && r.type !== 97 && r.type !== 29 && (e.importKind = "type", this.next(), r = this.lookahead()), K(this.state.type) && r.type === 29)
                    return this.tsParseImportEqualsDeclaration(e);
                }
                let s = super.parseImport(e);
                return s.importKind === "type" && s.specifiers.length > 1 && s.specifiers[0].type === "ImportDefaultSpecifier" && this.raise(S.TypeImportCannotSpecifyDefaultAndNamed, { at: s }), s;
              }
              parseExport(e) {
                if (this.match(83))
                  return this.next(), this.isContextual(126) && this.lookaheadCharCode() !== 61 ? (e.importKind = "type", this.next()) : e.importKind = "value", this.tsParseImportEqualsDeclaration(e, true);
                if (this.eat(29)) {
                  let s = e;
                  return s.expression = this.parseExpression(), this.semicolon(), this.finishNode(s, "TSExportAssignment");
                } else if (this.eatContextual(93)) {
                  let s = e;
                  return this.expectContextual(124), s.id = this.parseIdentifier(), this.semicolon(), this.finishNode(s, "TSNamespaceExportDeclaration");
                } else
                  return this.isContextual(126) && this.lookahead().type === 5 ? (this.next(), e.exportKind = "type") : e.exportKind = "value", super.parseExport(e);
              }
              isAbstractClass() {
                return this.isContextual(120) && this.lookahead().type === 80;
              }
              parseExportDefaultExpression() {
                if (this.isAbstractClass()) {
                  let e = this.startNode();
                  return this.next(), e.abstract = true, this.parseClass(e, true, true), e;
                }
                if (this.match(125)) {
                  let e = this.tsParseInterfaceDeclaration(this.startNode());
                  if (e)
                    return e;
                }
                return super.parseExportDefaultExpression();
              }
              parseVarStatement(e, s) {
                let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, { isAmbientContext: i } = this.state, a = super.parseVarStatement(e, s, r || i);
                if (!i)
                  return a;
                for (let { id: n, init: o } of a.declarations)
                  !o || (s !== "const" || !!n.typeAnnotation ? this.raise(S.InitializerNotAllowedInAmbientContext, { at: o }) : o.type !== "StringLiteral" && o.type !== "BooleanLiteral" && o.type !== "NumericLiteral" && o.type !== "BigIntLiteral" && (o.type !== "TemplateLiteral" || o.expressions.length > 0) && !zh(o) && this.raise(S.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, { at: o }));
                return a;
              }
              parseStatementContent(e, s) {
                if (this.match(75) && this.isLookaheadContextual("enum")) {
                  let r = this.startNode();
                  return this.expect(75), this.tsParseEnumDeclaration(r, { const: true });
                }
                if (this.isContextual(122))
                  return this.tsParseEnumDeclaration(this.startNode());
                if (this.isContextual(125)) {
                  let r = this.tsParseInterfaceDeclaration(this.startNode());
                  if (r)
                    return r;
                }
                return super.parseStatementContent(e, s);
              }
              parseAccessModifier() {
                return this.tsParseModifier(["public", "protected", "private"]);
              }
              tsHasSomeModifiers(e, s) {
                return s.some((r) => Mr(r) ? e.accessibility === r : !!e[r]);
              }
              tsIsStartOfStaticBlocks() {
                return this.isContextual(104) && this.lookaheadCharCode() === 123;
              }
              parseClassMember(e, s, r) {
                let i = ["declare", "private", "public", "protected", "override", "abstract", "readonly", "static"];
                this.tsParseModifiers({ modified: s, allowedModifiers: i, disallowedModifiers: ["in", "out"], stopOnStartOfClassStaticBlock: true, errorTemplate: S.InvalidModifierOnTypeParameterPositions });
                let a = () => {
                  this.tsIsStartOfStaticBlocks() ? (this.next(), this.next(), this.tsHasSomeModifiers(s, i) && this.raise(S.StaticBlockCannotHaveModifier, { at: this.state.curPosition() }), this.parseClassStaticBlock(e, s)) : this.parseClassMemberWithIsStatic(e, s, r, !!s.static);
                };
                s.declare ? this.tsInAmbientContext(a) : a();
              }
              parseClassMemberWithIsStatic(e, s, r, i) {
                let a = this.tsTryParseIndexSignature(s);
                if (a) {
                  e.body.push(a), s.abstract && this.raise(S.IndexSignatureHasAbstract, { at: s }), s.accessibility && this.raise(S.IndexSignatureHasAccessibility, { at: s, modifier: s.accessibility }), s.declare && this.raise(S.IndexSignatureHasDeclare, { at: s }), s.override && this.raise(S.IndexSignatureHasOverride, { at: s });
                  return;
                }
                !this.state.inAbstractClass && s.abstract && this.raise(S.NonAbstractClassHasAbstractMethod, { at: s }), s.override && (r.hadSuperClass || this.raise(S.OverrideNotInSubClass, { at: s })), super.parseClassMemberWithIsStatic(e, s, r, i);
              }
              parsePostMemberNameModifiers(e) {
                this.eat(17) && (e.optional = true), e.readonly && this.match(10) && this.raise(S.ClassMethodHasReadonly, { at: e }), e.declare && this.match(10) && this.raise(S.ClassMethodHasDeclare, { at: e });
              }
              parseExpressionStatement(e, s) {
                return (s.type === "Identifier" ? this.tsParseExpressionStatement(e, s) : void 0) || super.parseExpressionStatement(e, s);
              }
              shouldParseExportDeclaration() {
                return this.tsIsDeclarationStart() ? true : super.shouldParseExportDeclaration();
              }
              parseConditional(e, s, r, i) {
                if (!this.state.maybeInArrowParameters || !this.match(17))
                  return super.parseConditional(e, s, r, i);
                let a = this.tryParse(() => super.parseConditional(e, s, r));
                return a.node ? (a.error && (this.state = a.failState), a.node) : (a.error && super.setOptionalParametersError(i, a.error), e);
              }
              parseParenItem(e, s, r) {
                if (e = super.parseParenItem(e, s, r), this.eat(17) && (e.optional = true, this.resetEndLocation(e)), this.match(14)) {
                  let i = this.startNodeAt(s, r);
                  return i.expression = e, i.typeAnnotation = this.tsParseTypeAnnotation(), this.finishNode(i, "TSTypeCastExpression");
                }
                return e;
              }
              parseExportDeclaration(e) {
                if (!this.state.isAmbientContext && this.isContextual(121))
                  return this.tsInAmbientContext(() => this.parseExportDeclaration(e));
                let s = this.state.start, r = this.state.startLoc, i = this.eatContextual(121);
                if (i && (this.isContextual(121) || !this.shouldParseExportDeclaration()))
                  throw this.raise(S.ExpectedAmbientAfterExportDeclare, { at: this.state.startLoc });
                let n = K(this.state.type) && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(e);
                return n ? ((n.type === "TSInterfaceDeclaration" || n.type === "TSTypeAliasDeclaration" || i) && (e.exportKind = "type"), i && (this.resetStartLocation(n, s, r), n.declare = true), n) : null;
              }
              parseClassId(e, s, r) {
                if ((!s || r) && this.isContextual(110))
                  return;
                super.parseClassId(e, s, r, e.declare ? Cr : Pr);
                let i = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this));
                i && (e.typeParameters = i);
              }
              parseClassPropertyAnnotation(e) {
                !e.optional && this.eat(35) && (e.definite = true);
                let s = this.tsTryParseTypeAnnotation();
                s && (e.typeAnnotation = s);
              }
              parseClassProperty(e) {
                if (this.parseClassPropertyAnnotation(e), this.state.isAmbientContext && this.match(29) && this.raise(S.DeclareClassFieldHasInitializer, { at: this.state.startLoc }), e.abstract && this.match(29)) {
                  let { key: s } = e;
                  this.raise(S.AbstractPropertyHasInitializer, { at: this.state.startLoc, propertyName: s.type === "Identifier" && !e.computed ? s.name : "[".concat(this.input.slice(s.start, s.end), "]") });
                }
                return super.parseClassProperty(e);
              }
              parseClassPrivateProperty(e) {
                return e.abstract && this.raise(S.PrivateElementHasAbstract, { at: e }), e.accessibility && this.raise(S.PrivateElementHasAccessibility, { at: e, modifier: e.accessibility }), this.parseClassPropertyAnnotation(e), super.parseClassPrivateProperty(e);
              }
              pushClassMethod(e, s, r, i, a, n) {
                let o = this.tsTryParseTypeParameters();
                o && a && this.raise(S.ConstructorHasTypeParameters, { at: o });
                let { declare: c = false, kind: f } = s;
                c && (f === "get" || f === "set") && this.raise(S.DeclareAccessor, { at: s, kind: f }), o && (s.typeParameters = o), super.pushClassMethod(e, s, r, i, a, n);
              }
              pushClassPrivateMethod(e, s, r, i) {
                let a = this.tsTryParseTypeParameters();
                a && (s.typeParameters = a), super.pushClassPrivateMethod(e, s, r, i);
              }
              declareClassPrivateMethodInScope(e, s) {
                e.type !== "TSDeclareMethod" && (e.type === "MethodDefinition" && !e.value.body || super.declareClassPrivateMethodInScope(e, s));
              }
              parseClassSuper(e) {
                super.parseClassSuper(e), e.superClass && (this.match(47) || this.match(51)) && (e.superTypeParameters = this.tsParseTypeArgumentsInExpression()), this.eatContextual(110) && (e.implements = this.tsParseHeritageClause("implements"));
              }
              parseObjPropValue(e) {
                let s = this.tsTryParseTypeParameters();
                s && (e.typeParameters = s);
                for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
                  i[a - 1] = arguments[a];
                super.parseObjPropValue(e, ...i);
              }
              parseFunctionParams(e, s) {
                let r = this.tsTryParseTypeParameters();
                r && (e.typeParameters = r), super.parseFunctionParams(e, s);
              }
              parseVarId(e, s) {
                super.parseVarId(e, s), e.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35) && (e.definite = true);
                let r = this.tsTryParseTypeAnnotation();
                r && (e.id.typeAnnotation = r, this.resetEndLocation(e.id));
              }
              parseAsyncArrowFromCallExpression(e, s) {
                return this.match(14) && (e.returnType = this.tsParseTypeAnnotation()), super.parseAsyncArrowFromCallExpression(e, s);
              }
              parseMaybeAssign() {
                for (var e = arguments.length, s = new Array(e), r = 0; r < e; r++)
                  s[r] = arguments[r];
                var i, a, n, o, c, f, y;
                let P, v, N;
                if (this.hasPlugin("jsx") && (this.match(138) || this.match(47))) {
                  if (P = this.state.clone(), v = this.tryParse(() => super.parseMaybeAssign(...s), P), !v.error)
                    return v.node;
                  let { context: Q } = this.state, re = Q[Q.length - 1];
                  (re === z.j_oTag || re === z.j_expr) && Q.pop();
                }
                if (!((i = v) != null && i.error) && !this.match(47))
                  return super.parseMaybeAssign(...s);
                let B;
                P = P || this.state.clone();
                let _ = this.tryParse((Q) => {
                  var re, ne, $e;
                  B = this.tsParseTypeParameters();
                  let le = super.parseMaybeAssign(...s);
                  return (le.type !== "ArrowFunctionExpression" || (re = le.extra) != null && re.parenthesized) && Q(), ((ne = B) == null ? void 0 : ne.params.length) !== 0 && this.resetStartLocationFromNode(le, B), le.typeParameters = B, this.hasPlugin("jsx") && le.typeParameters.params.length === 1 && !(($e = le.typeParameters.extra) != null && $e.trailingComma) && le.typeParameters.params[0].constraint, le;
                }, P);
                if (!_.error && !_.aborted)
                  return B && this.reportReservedArrowTypeParam(B), _.node;
                if (!v && (Br(!this.hasPlugin("jsx")), N = this.tryParse(() => super.parseMaybeAssign(...s), P), !N.error))
                  return N.node;
                if ((a = v) != null && a.node)
                  return this.state = v.failState, v.node;
                if (_.node)
                  return this.state = _.failState, B && this.reportReservedArrowTypeParam(B), _.node;
                if ((n = N) != null && n.node)
                  return this.state = N.failState, N.node;
                throw (o = v) != null && o.thrown ? v.error : _.thrown ? _.error : (c = N) != null && c.thrown ? N.error : ((f = v) == null ? void 0 : f.error) || _.error || ((y = N) == null ? void 0 : y.error);
              }
              reportReservedArrowTypeParam(e) {
                var s;
                e.params.length === 1 && !((s = e.extra) != null && s.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(S.ReservedArrowTypeParam, { at: e });
              }
              parseMaybeUnary(e) {
                return !this.hasPlugin("jsx") && this.match(47) ? this.tsParseTypeAssertion() : super.parseMaybeUnary(e);
              }
              parseArrow(e) {
                if (this.match(14)) {
                  let s = this.tryParse((r) => {
                    let i = this.tsParseTypeOrTypePredicateAnnotation(14);
                    return (this.canInsertSemicolon() || !this.match(19)) && r(), i;
                  });
                  if (s.aborted)
                    return;
                  s.thrown || (s.error && (this.state = s.failState), e.returnType = s.node);
                }
                return super.parseArrow(e);
              }
              parseAssignableListItemTypes(e) {
                this.eat(17) && (e.type !== "Identifier" && !this.state.isAmbientContext && !this.state.inType && this.raise(S.PatternIsOptional, { at: e }), e.optional = true);
                let s = this.tsTryParseTypeAnnotation();
                return s && (e.typeAnnotation = s), this.resetEndLocation(e), e;
              }
              isAssignable(e, s) {
                switch (e.type) {
                  case "TSTypeCastExpression":
                    return this.isAssignable(e.expression, s);
                  case "TSParameterProperty":
                    return true;
                  default:
                    return super.isAssignable(e, s);
                }
              }
              toAssignable(e) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                switch (e.type) {
                  case "ParenthesizedExpression":
                    this.toAssignableParenthesizedExpression(e, s);
                    break;
                  case "TSAsExpression":
                  case "TSNonNullExpression":
                  case "TSTypeAssertion":
                    s ? this.expressionScope.recordArrowParemeterBindingError(S.UnexpectedTypeCastInParameter, { at: e }) : this.raise(S.UnexpectedTypeCastInParameter, { at: e }), this.toAssignable(e.expression, s);
                    break;
                  case "AssignmentExpression":
                    !s && e.left.type === "TSTypeCastExpression" && (e.left = this.typeCastToParameter(e.left));
                  default:
                    super.toAssignable(e, s);
                }
              }
              toAssignableParenthesizedExpression(e, s) {
                switch (e.expression.type) {
                  case "TSAsExpression":
                  case "TSNonNullExpression":
                  case "TSTypeAssertion":
                  case "ParenthesizedExpression":
                    this.toAssignable(e.expression, s);
                    break;
                  default:
                    super.toAssignable(e, s);
                }
              }
              checkToRestConversion(e, s) {
                switch (e.type) {
                  case "TSAsExpression":
                  case "TSTypeAssertion":
                  case "TSNonNullExpression":
                    this.checkToRestConversion(e.expression, false);
                    break;
                  default:
                    super.checkToRestConversion(e, s);
                }
              }
              isValidLVal(e, s, r) {
                return Mh({ TSTypeCastExpression: true, TSParameterProperty: "parameter", TSNonNullExpression: "expression", TSAsExpression: (r !== we || !s) && ["expression", true], TSTypeAssertion: (r !== we || !s) && ["expression", true] }, e) || super.isValidLVal(e, s, r);
              }
              parseBindingAtom() {
                switch (this.state.type) {
                  case 78:
                    return this.parseIdentifier(true);
                  default:
                    return super.parseBindingAtom();
                }
              }
              parseMaybeDecoratorArguments(e) {
                if (this.match(47) || this.match(51)) {
                  let s = this.tsParseTypeArgumentsInExpression();
                  if (this.match(10)) {
                    let r = super.parseMaybeDecoratorArguments(e);
                    return r.typeParameters = s, r;
                  }
                  this.unexpected(null, 10);
                }
                return super.parseMaybeDecoratorArguments(e);
              }
              checkCommaAfterRest(e) {
                return this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === e ? (this.next(), false) : super.checkCommaAfterRest(e);
              }
              isClassMethod() {
                return this.match(47) || super.isClassMethod();
              }
              isClassProperty() {
                return this.match(35) || this.match(14) || super.isClassProperty();
              }
              parseMaybeDefault() {
                let e = super.parseMaybeDefault(...arguments);
                return e.type === "AssignmentPattern" && e.typeAnnotation && e.right.start < e.typeAnnotation.start && this.raise(S.TypeAnnotationAfterAssign, { at: e.typeAnnotation }), e;
              }
              getTokenFromCode(e) {
                if (this.state.inType) {
                  if (e === 62)
                    return this.finishOp(48, 1);
                  if (e === 60)
                    return this.finishOp(47, 1);
                }
                return super.getTokenFromCode(e);
              }
              reScan_lt_gt() {
                let { type: e } = this.state;
                e === 47 ? (this.state.pos -= 1, this.readToken_lt()) : e === 48 && (this.state.pos -= 1, this.readToken_gt());
              }
              reScan_lt() {
                let { type: e } = this.state;
                return e === 51 ? (this.state.pos -= 2, this.finishOp(47, 1), 47) : e;
              }
              toAssignableList(e) {
                for (let s = 0; s < e.length; s++) {
                  let r = e[s];
                  (r == null ? void 0 : r.type) === "TSTypeCastExpression" && (e[s] = this.typeCastToParameter(r));
                }
                super.toAssignableList(...arguments);
              }
              typeCastToParameter(e) {
                return e.expression.typeAnnotation = e.typeAnnotation, this.resetEndLocation(e.expression, e.typeAnnotation.loc.end), e.expression;
              }
              shouldParseArrow(e) {
                return this.match(14) ? e.every((s) => this.isAssignable(s, true)) : super.shouldParseArrow(e);
              }
              shouldParseAsyncArrow() {
                return this.match(14) || super.shouldParseAsyncArrow();
              }
              canHaveLeadingDecorator() {
                return super.canHaveLeadingDecorator() || this.isAbstractClass();
              }
              jsxParseOpeningElementAfterName(e) {
                if (this.match(47) || this.match(51)) {
                  let s = this.tsTryParseAndCatch(() => this.tsParseTypeArgumentsInExpression());
                  s && (e.typeParameters = s);
                }
                return super.jsxParseOpeningElementAfterName(e);
              }
              getGetterSetterExpectedParamCount(e) {
                let s = super.getGetterSetterExpectedParamCount(e), i = this.getObjectOrClassMethodParams(e)[0];
                return i && this.isThisParam(i) ? s + 1 : s;
              }
              parseCatchClauseParam() {
                let e = super.parseCatchClauseParam(), s = this.tsTryParseTypeAnnotation();
                return s && (e.typeAnnotation = s, this.resetEndLocation(e)), e;
              }
              tsInAmbientContext(e) {
                let s = this.state.isAmbientContext;
                this.state.isAmbientContext = true;
                try {
                  return e();
                } finally {
                  this.state.isAmbientContext = s;
                }
              }
              parseClass(e) {
                let s = this.state.inAbstractClass;
                this.state.inAbstractClass = !!e.abstract;
                try {
                  for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
                    i[a - 1] = arguments[a];
                  return super.parseClass(e, ...i);
                } finally {
                  this.state.inAbstractClass = s;
                }
              }
              tsParseAbstractDeclaration(e) {
                if (this.match(80))
                  return e.abstract = true, this.parseClass(e, true, false);
                if (this.isContextual(125)) {
                  if (!this.hasFollowingLineBreak())
                    return e.abstract = true, this.raise(S.NonClassMethodPropertyHasAbstractModifer, { at: e }), this.tsParseInterfaceDeclaration(e);
                } else
                  this.unexpected(null, 80);
              }
              parseMethod() {
                let e = super.parseMethod(...arguments);
                if (e.abstract && (this.hasPlugin("estree") ? !!e.value.body : !!e.body)) {
                  let { key: r } = e;
                  this.raise(S.AbstractMethodHasImplementation, { at: e, methodName: r.type === "Identifier" && !e.computed ? r.name : "[".concat(this.input.slice(r.start, r.end), "]") });
                }
                return e;
              }
              tsParseTypeParameterName() {
                return this.parseIdentifier().name;
              }
              shouldParseAsAmbientContext() {
                return !!this.getPluginOption("typescript", "dts");
              }
              parse() {
                return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = true), super.parse();
              }
              getExpression() {
                return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = true), super.getExpression();
              }
              parseExportSpecifier(e, s, r, i) {
                return !s && i ? (this.parseTypeOnlyImportExportSpecifier(e, false, r), this.finishNode(e, "ExportSpecifier")) : (e.exportKind = "value", super.parseExportSpecifier(e, s, r, i));
              }
              parseImportSpecifier(e, s, r, i) {
                return !s && i ? (this.parseTypeOnlyImportExportSpecifier(e, true, r), this.finishNode(e, "ImportSpecifier")) : (e.importKind = "value", super.parseImportSpecifier(e, s, r, i));
              }
              parseTypeOnlyImportExportSpecifier(e, s, r) {
                let i = s ? "imported" : "local", a = s ? "local" : "exported", n = e[i], o, c = false, f = true, y = n.loc.start;
                if (this.isContextual(93)) {
                  let v = this.parseIdentifier();
                  if (this.isContextual(93)) {
                    let N = this.parseIdentifier();
                    pe(this.state.type) ? (c = true, n = v, o = s ? this.parseIdentifier() : this.parseModuleExportName(), f = false) : (o = N, f = false);
                  } else
                    pe(this.state.type) ? (f = false, o = s ? this.parseIdentifier() : this.parseModuleExportName()) : (c = true, n = v);
                } else
                  pe(this.state.type) && (c = true, s ? (n = this.parseIdentifier(true), this.isContextual(93) || this.checkReservedWord(n.name, n.loc.start, true, true)) : n = this.parseModuleExportName());
                c && r && this.raise(s ? S.TypeModifierIsUsedInTypeImports : S.TypeModifierIsUsedInTypeExports, { at: y }), e[i] = n, e[a] = o;
                let P = s ? "importKind" : "exportKind";
                e[P] = c ? "type" : "value", f && this.eatContextual(93) && (e[a] = s ? this.parseIdentifier() : this.parseModuleExportName()), e[a] || (e[a] = ge(e[i])), s && this.checkIdentifier(e[a], xe);
              }
            };
            function zh(t3) {
              if (t3.type !== "MemberExpression")
                return false;
              let { computed: e, property: s } = t3;
              return e && s.type !== "StringLiteral" && (s.type !== "TemplateLiteral" || s.expressions.length > 0) ? false : Rr(t3.object);
            }
            function Rr(t3) {
              return t3.type === "Identifier" ? true : t3.type !== "MemberExpression" || t3.computed ? false : Rr(t3.object);
            }
            var jr = j(Hn || (Hn = rt(["placeholders"])))((t3) => ({ ClassNameIsRequired: t3("A class name is required."), UnexpectedSpace: t3("Unexpected space in placeholder.") })), Kh = (t3) => class extends t3 {
              parsePlaceholder(e) {
                if (this.match(140)) {
                  let s = this.startNode();
                  return this.next(), this.assertNoSpace(), s.name = super.parseIdentifier(true), this.assertNoSpace(), this.expect(140), this.finishPlaceholder(s, e);
                }
              }
              finishPlaceholder(e, s) {
                let r = !!(e.expectedNode && e.type === "Placeholder");
                return e.expectedNode = s, r ? e : this.finishNode(e, "Placeholder");
              }
              getTokenFromCode(e) {
                return e === 37 && this.input.charCodeAt(this.state.pos + 1) === 37 ? this.finishOp(140, 2) : super.getTokenFromCode(...arguments);
              }
              parseExprAtom() {
                return this.parsePlaceholder("Expression") || super.parseExprAtom(...arguments);
              }
              parseIdentifier() {
                return this.parsePlaceholder("Identifier") || super.parseIdentifier(...arguments);
              }
              checkReservedWord(e) {
                e !== void 0 && super.checkReservedWord(...arguments);
              }
              parseBindingAtom() {
                return this.parsePlaceholder("Pattern") || super.parseBindingAtom(...arguments);
              }
              isValidLVal(e) {
                for (var s = arguments.length, r = new Array(s > 1 ? s - 1 : 0), i = 1; i < s; i++)
                  r[i - 1] = arguments[i];
                return e === "Placeholder" || super.isValidLVal(e, ...r);
              }
              toAssignable(e) {
                e && e.type === "Placeholder" && e.expectedNode === "Expression" ? e.expectedNode = "Pattern" : super.toAssignable(...arguments);
              }
              isLet(e) {
                return super.isLet(e) ? true : !this.isContextual(99) || e ? false : this.lookahead().type === 140;
              }
              verifyBreakContinue(e) {
                e.label && e.label.type === "Placeholder" || super.verifyBreakContinue(...arguments);
              }
              parseExpressionStatement(e, s) {
                if (s.type !== "Placeholder" || s.extra && s.extra.parenthesized)
                  return super.parseExpressionStatement(...arguments);
                if (this.match(14)) {
                  let r = e;
                  return r.label = this.finishPlaceholder(s, "Identifier"), this.next(), r.body = this.parseStatement("label"), this.finishNode(r, "LabeledStatement");
                }
                return this.semicolon(), e.name = s.name, this.finishPlaceholder(e, "Statement");
              }
              parseBlock() {
                return this.parsePlaceholder("BlockStatement") || super.parseBlock(...arguments);
              }
              parseFunctionId() {
                return this.parsePlaceholder("Identifier") || super.parseFunctionId(...arguments);
              }
              parseClass(e, s, r) {
                let i = s ? "ClassDeclaration" : "ClassExpression";
                this.next(), this.takeDecorators(e);
                let a = this.state.strict, n = this.parsePlaceholder("Identifier");
                if (n)
                  if (this.match(81) || this.match(140) || this.match(5))
                    e.id = n;
                  else {
                    if (r || !s)
                      return e.id = null, e.body = this.finishPlaceholder(n, "ClassBody"), this.finishNode(e, i);
                    throw this.raise(jr.ClassNameIsRequired, { at: this.state.startLoc });
                  }
                else
                  this.parseClassId(e, s, r);
                return this.parseClassSuper(e), e.body = this.parsePlaceholder("ClassBody") || this.parseClassBody(!!e.superClass, a), this.finishNode(e, i);
              }
              parseExport(e) {
                let s = this.parsePlaceholder("Identifier");
                if (!s)
                  return super.parseExport(...arguments);
                if (!this.isContextual(97) && !this.match(12))
                  return e.specifiers = [], e.source = null, e.declaration = this.finishPlaceholder(s, "Declaration"), this.finishNode(e, "ExportNamedDeclaration");
                this.expectPlugin("exportDefaultFrom");
                let r = this.startNode();
                return r.exported = s, e.specifiers = [this.finishNode(r, "ExportDefaultSpecifier")], super.parseExport(e);
              }
              isExportDefaultSpecifier() {
                if (this.match(65)) {
                  let e = this.nextTokenStart();
                  if (this.isUnparsedContextual(e, "from") && this.input.startsWith(Pe(140), this.nextTokenStartSince(e + 4)))
                    return true;
                }
                return super.isExportDefaultSpecifier();
              }
              maybeParseExportDefaultSpecifier(e) {
                return e.specifiers && e.specifiers.length > 0 ? true : super.maybeParseExportDefaultSpecifier(...arguments);
              }
              checkExport(e) {
                let { specifiers: s } = e;
                s != null && s.length && (e.specifiers = s.filter((r) => r.exported.type === "Placeholder")), super.checkExport(e), e.specifiers = s;
              }
              parseImport(e) {
                let s = this.parsePlaceholder("Identifier");
                if (!s)
                  return super.parseImport(...arguments);
                if (e.specifiers = [], !this.isContextual(97) && !this.match(12))
                  return e.source = this.finishPlaceholder(s, "StringLiteral"), this.semicolon(), this.finishNode(e, "ImportDeclaration");
                let r = this.startNodeAtNode(s);
                return r.local = s, this.finishNode(r, "ImportDefaultSpecifier"), e.specifiers.push(r), this.eat(12) && (this.maybeParseStarImportSpecifier(e) || this.parseNamedImportSpecifiers(e)), this.expectContextual(97), e.source = this.parseImportSource(), this.semicolon(), this.finishNode(e, "ImportDeclaration");
              }
              parseImportSource() {
                return this.parsePlaceholder("StringLiteral") || super.parseImportSource(...arguments);
              }
              assertNoSpace() {
                this.state.start > this.state.lastTokEndLoc.index && this.raise(jr.UnexpectedSpace, { at: this.state.lastTokEndLoc });
              }
            }, Vh = (t3) => class extends t3 {
              parseV8Intrinsic() {
                if (this.match(54)) {
                  let e = this.state.startLoc, s = this.startNode();
                  if (this.next(), K(this.state.type)) {
                    let r = this.parseIdentifierName(this.state.start), i = this.createIdentifier(s, r);
                    if (i.type = "V8IntrinsicIdentifier", this.match(10))
                      return i;
                  }
                  this.unexpected(e);
                }
              }
              parseExprAtom() {
                return this.parseV8Intrinsic() || super.parseExprAtom(...arguments);
              }
            };
            function ee(t3, e) {
              let [s, r] = typeof e == "string" ? [e, {}] : e, i = Object.keys(r), a = i.length === 0;
              return t3.some((n) => {
                if (typeof n == "string")
                  return a && n === s;
                {
                  let [o, c] = n;
                  if (o !== s)
                    return false;
                  for (let f of i)
                    if (c[f] !== r[f])
                      return false;
                  return true;
                }
              });
            }
            function Je(t3, e, s) {
              let r = t3.find((i) => Array.isArray(i) ? i[0] === e : i === e);
              return r && Array.isArray(r) ? r[1][s] : null;
            }
            var qr = ["minimal", "fsharp", "hack", "smart"], Ur = ["^^", "@@", "^", "%", "#"], _r = ["hash", "bar"];
            function Hh(t3) {
              if (ee(t3, "decorators")) {
                if (ee(t3, "decorators-legacy"))
                  throw new Error("Cannot use the decorators and decorators-legacy plugin together");
                let e = Je(t3, "decorators", "decoratorsBeforeExport");
                if (e == null)
                  throw new Error("The 'decorators' plugin requires a 'decoratorsBeforeExport' option, whose value must be a boolean. If you are migrating from Babylon/Babel 6 or want to use the old decorators proposal, you should use the 'decorators-legacy' plugin instead of 'decorators'.");
                if (typeof e != "boolean")
                  throw new Error("'decoratorsBeforeExport' must be a boolean.");
              }
              if (ee(t3, "flow") && ee(t3, "typescript"))
                throw new Error("Cannot combine flow and typescript plugins.");
              if (ee(t3, "placeholders") && ee(t3, "v8intrinsic"))
                throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
              if (ee(t3, "pipelineOperator")) {
                let e = Je(t3, "pipelineOperator", "proposal");
                if (!qr.includes(e)) {
                  let r = qr.map((i) => '"'.concat(i, '"')).join(", ");
                  throw new Error('"pipelineOperator" requires "proposal" option whose value must be one of: '.concat(r, "."));
                }
                let s = ee(t3, ["recordAndTuple", { syntaxType: "hash" }]);
                if (e === "hack") {
                  if (ee(t3, "placeholders"))
                    throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
                  if (ee(t3, "v8intrinsic"))
                    throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
                  let r = Je(t3, "pipelineOperator", "topicToken");
                  if (!Ur.includes(r)) {
                    let i = Ur.map((a) => '"'.concat(a, '"')).join(", ");
                    throw new Error('"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: '.concat(i, "."));
                  }
                  if (r === "#" && s)
                    throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "hack", topicToken: "#" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
                } else if (e === "smart" && s)
                  throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "smart" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
              }
              if (ee(t3, "moduleAttributes")) {
                if (ee(t3, "importAssertions"))
                  throw new Error("Cannot combine importAssertions and moduleAttributes plugins.");
                if (Je(t3, "moduleAttributes", "version") !== "may-2020")
                  throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
              }
              if (ee(t3, "recordAndTuple") && !_r.includes(Je(t3, "recordAndTuple", "syntaxType")))
                throw new Error("'recordAndTuple' requires 'syntaxType' option whose value should be one of: " + _r.map((e) => "'".concat(e, "'")).join(", "));
              if (ee(t3, "asyncDoExpressions") && !ee(t3, "doExpressions")) {
                let e = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
                throw e.missingPlugins = "doExpressions", e;
              }
            }
            var zr = { estree: Oe, jsx: Lh, flow: Dh, typescript: _h, v8intrinsic: Vh, placeholders: Kh }, Wh = Object.keys(zr), Kr = { sourceType: "script", sourceFilename: void 0, startColumn: 0, startLine: 1, allowAwaitOutsideFunction: false, allowReturnOutsideFunction: false, allowImportExportEverywhere: false, allowSuperOutsideMethod: false, allowUndeclaredExports: false, plugins: [], strictMode: null, ranges: false, tokens: false, createParenthesizedExpressions: false, errorRecovery: false, attachComment: true };
            function Gh(t3) {
              let e = {};
              for (let s of Object.keys(Kr))
                e[s] = t3 && t3[s] != null ? t3[s] : Kr[s];
              return e;
            }
            var Xh = (t3, e) => Object.hasOwnProperty.call(t3, e) && t3[e], Vr = (t3) => t3.type === "ParenthesizedExpression" ? Vr(t3.expression) : t3, Jh = class extends vh {
              toAssignable(t3) {
                let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var s, r;
                let i;
                switch ((t3.type === "ParenthesizedExpression" || (s = t3.extra) != null && s.parenthesized) && (i = Vr(t3), e ? i.type === "Identifier" ? this.expressionScope.recordArrowParemeterBindingError(u.InvalidParenthesizedAssignment, { at: t3 }) : i.type !== "MemberExpression" && this.raise(u.InvalidParenthesizedAssignment, { at: t3 }) : this.raise(u.InvalidParenthesizedAssignment, { at: t3 })), t3.type) {
                  case "Identifier":
                  case "ObjectPattern":
                  case "ArrayPattern":
                  case "AssignmentPattern":
                  case "RestElement":
                    break;
                  case "ObjectExpression":
                    t3.type = "ObjectPattern";
                    for (let n = 0, o = t3.properties.length, c = o - 1; n < o; n++) {
                      var a;
                      let f = t3.properties[n], y = n === c;
                      this.toAssignableObjectExpressionProp(f, y, e), y && f.type === "RestElement" && (a = t3.extra) != null && a.trailingCommaLoc && this.raise(u.RestTrailingComma, { at: t3.extra.trailingCommaLoc });
                    }
                    break;
                  case "ObjectProperty": {
                    let { key: n, value: o } = t3;
                    this.isPrivateName(n) && this.classScope.usePrivateName(this.getPrivateNameSV(n), n.loc.start), this.toAssignable(o, e);
                    break;
                  }
                  case "SpreadElement":
                    throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
                  case "ArrayExpression":
                    t3.type = "ArrayPattern", this.toAssignableList(t3.elements, (r = t3.extra) == null ? void 0 : r.trailingCommaLoc, e);
                    break;
                  case "AssignmentExpression":
                    t3.operator !== "=" && this.raise(u.MissingEqInAssignment, { at: t3.left.loc.end }), t3.type = "AssignmentPattern", delete t3.operator, this.toAssignable(t3.left, e);
                    break;
                  case "ParenthesizedExpression":
                    this.toAssignable(i, e);
                    break;
                }
              }
              toAssignableObjectExpressionProp(t3, e, s) {
                if (t3.type === "ObjectMethod")
                  this.raise(t3.kind === "get" || t3.kind === "set" ? u.PatternHasAccessor : u.PatternHasMethod, { at: t3.key });
                else if (t3.type === "SpreadElement") {
                  t3.type = "RestElement";
                  let r = t3.argument;
                  this.checkToRestConversion(r, false), this.toAssignable(r, s), e || this.raise(u.RestTrailingComma, { at: t3 });
                } else
                  this.toAssignable(t3, s);
              }
              toAssignableList(t3, e, s) {
                let r = t3.length - 1;
                for (let i = 0; i <= r; i++) {
                  let a = t3[i];
                  if (!!a) {
                    if (a.type === "SpreadElement") {
                      a.type = "RestElement";
                      let n = a.argument;
                      this.checkToRestConversion(n, true), this.toAssignable(n, s);
                    } else
                      this.toAssignable(a, s);
                    a.type === "RestElement" && (i < r ? this.raise(u.RestTrailingComma, { at: a }) : e && this.raise(u.RestTrailingComma, { at: e }));
                  }
                }
              }
              isAssignable(t3, e) {
                switch (t3.type) {
                  case "Identifier":
                  case "ObjectPattern":
                  case "ArrayPattern":
                  case "AssignmentPattern":
                  case "RestElement":
                    return true;
                  case "ObjectExpression": {
                    let s = t3.properties.length - 1;
                    return t3.properties.every((r, i) => r.type !== "ObjectMethod" && (i === s || r.type !== "SpreadElement") && this.isAssignable(r));
                  }
                  case "ObjectProperty":
                    return this.isAssignable(t3.value);
                  case "SpreadElement":
                    return this.isAssignable(t3.argument);
                  case "ArrayExpression":
                    return t3.elements.every((s) => s === null || this.isAssignable(s));
                  case "AssignmentExpression":
                    return t3.operator === "=";
                  case "ParenthesizedExpression":
                    return this.isAssignable(t3.expression);
                  case "MemberExpression":
                  case "OptionalMemberExpression":
                    return !e;
                  default:
                    return false;
                }
              }
              toReferencedList(t3, e) {
                return t3;
              }
              toReferencedListDeep(t3, e) {
                this.toReferencedList(t3, e);
                for (let s of t3)
                  (s == null ? void 0 : s.type) === "ArrayExpression" && this.toReferencedListDeep(s.elements);
              }
              parseSpread(t3, e) {
                let s = this.startNode();
                return this.next(), s.argument = this.parseMaybeAssignAllowIn(t3, void 0, e), this.finishNode(s, "SpreadElement");
              }
              parseRestBinding() {
                let t3 = this.startNode();
                return this.next(), t3.argument = this.parseBindingAtom(), this.finishNode(t3, "RestElement");
              }
              parseBindingAtom() {
                switch (this.state.type) {
                  case 0: {
                    let t3 = this.startNode();
                    return this.next(), t3.elements = this.parseBindingList(3, 93, true), this.finishNode(t3, "ArrayPattern");
                  }
                  case 5:
                    return this.parseObjectLike(8, true);
                }
                return this.parseIdentifier();
              }
              parseBindingList(t3, e, s, r) {
                let i = [], a = true;
                for (; !this.eat(t3); )
                  if (a ? a = false : this.expect(12), s && this.match(12))
                    i.push(null);
                  else {
                    if (this.eat(t3))
                      break;
                    if (this.match(21)) {
                      if (i.push(this.parseAssignableListItemTypes(this.parseRestBinding())), !this.checkCommaAfterRest(e)) {
                        this.expect(t3);
                        break;
                      }
                    } else {
                      let n = [];
                      for (this.match(26) && this.hasPlugin("decorators") && this.raise(u.UnsupportedParameterDecorator, { at: this.state.startLoc }); this.match(26); )
                        n.push(this.parseDecorator());
                      i.push(this.parseAssignableListItem(r, n));
                    }
                  }
                return i;
              }
              parseBindingRestProperty(t3) {
                return this.next(), t3.argument = this.parseIdentifier(), this.checkCommaAfterRest(125), this.finishNode(t3, "RestElement");
              }
              parseBindingProperty() {
                let t3 = this.startNode(), { type: e, start: s, startLoc: r } = this.state;
                return e === 21 ? this.parseBindingRestProperty(t3) : (e === 134 ? (this.expectPlugin("destructuringPrivate", r), this.classScope.usePrivateName(this.state.value, r), t3.key = this.parsePrivateName()) : this.parsePropertyName(t3), t3.method = false, this.parseObjPropValue(t3, s, r, false, false, true, false), t3);
              }
              parseAssignableListItem(t3, e) {
                let s = this.parseMaybeDefault();
                this.parseAssignableListItemTypes(s);
                let r = this.parseMaybeDefault(s.start, s.loc.start, s);
                return e.length && (s.decorators = e), r;
              }
              parseAssignableListItemTypes(t3) {
                return t3;
              }
              parseMaybeDefault(t3, e, s) {
                var r, i, a;
                if (e = (r = e) != null ? r : this.state.startLoc, t3 = (i = t3) != null ? i : this.state.start, s = (a = s) != null ? a : this.parseBindingAtom(), !this.eat(29))
                  return s;
                let n = this.startNodeAt(t3, e);
                return n.left = s, n.right = this.parseMaybeAssignAllowIn(), this.finishNode(n, "AssignmentPattern");
              }
              isValidLVal(t3, e, s) {
                return Xh({ AssignmentPattern: "left", RestElement: "argument", ObjectProperty: "value", ParenthesizedExpression: "expression", ArrayPattern: "elements", ObjectPattern: "properties" }, t3);
              }
              checkLVal(t3, e) {
                let { in: s, binding: r = we, checkClashes: i = false, strictModeChanged: a = false, allowingSloppyLetBinding: n = !(r & Te), hasParenthesizedAncestor: o = false } = e;
                var c;
                let f = t3.type;
                if (this.isObjectMethod(t3))
                  return;
                if (f === "MemberExpression") {
                  r !== we && this.raise(u.InvalidPropertyBindingPattern, { at: t3 });
                  return;
                }
                if (t3.type === "Identifier") {
                  this.checkIdentifier(t3, r, a, n);
                  let { name: B } = t3;
                  i && (i.has(B) ? this.raise(u.ParamDupe, { at: t3 }) : i.add(B));
                  return;
                }
                let y = this.isValidLVal(t3.type, !(o || (c = t3.extra) != null && c.parenthesized) && s.type === "AssignmentExpression", r);
                if (y === true)
                  return;
                if (y === false) {
                  let B = r === we ? u.InvalidLhs : u.InvalidLhsBinding;
                  this.raise(B, { at: t3, ancestor: s.type === "UpdateExpression" ? { type: "UpdateExpression", prefix: s.prefix } : { type: s.type } });
                  return;
                }
                let [P, v] = Array.isArray(y) ? y : [y, f === "ParenthesizedExpression"], N = t3.type === "ArrayPattern" || t3.type === "ObjectPattern" || t3.type === "ParenthesizedExpression" ? t3 : s;
                for (let B of [].concat(t3[P]))
                  B && this.checkLVal(B, { in: N, binding: r, checkClashes: i, allowingSloppyLetBinding: n, strictModeChanged: a, hasParenthesizedAncestor: v });
              }
              checkIdentifier(t3, e) {
                let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !(e & Te);
                this.state.strict && (s ? mr(t3.name, this.inModule) : dr(t3.name)) && (e === we ? this.raise(u.StrictEvalArguments, { at: t3, referenceName: t3.name }) : this.raise(u.StrictEvalArgumentsBinding, { at: t3, bindingName: t3.name })), !r && t3.name === "let" && this.raise(u.LetInLexicalBinding, { at: t3 }), e & we || this.declareNameFromIdentifier(t3, e);
              }
              declareNameFromIdentifier(t3, e) {
                this.scope.declareName(t3.name, e, t3.loc.start);
              }
              checkToRestConversion(t3, e) {
                switch (t3.type) {
                  case "ParenthesizedExpression":
                    this.checkToRestConversion(t3.expression, e);
                    break;
                  case "Identifier":
                  case "MemberExpression":
                    break;
                  case "ArrayExpression":
                  case "ObjectExpression":
                    if (e)
                      break;
                  default:
                    this.raise(u.InvalidRestAssignmentPattern, { at: t3 });
                }
              }
              checkCommaAfterRest(t3) {
                return this.match(12) ? (this.raise(this.lookaheadCharCode() === t3 ? u.RestTrailingComma : u.ElementAfterRest, { at: this.state.startLoc }), true) : false;
              }
            }, Yh = class extends Jh {
              checkProto(t3, e, s, r) {
                if (t3.type === "SpreadElement" || this.isObjectMethod(t3) || t3.computed || t3.shorthand)
                  return;
                let i = t3.key;
                if ((i.type === "Identifier" ? i.name : i.value) === "__proto__") {
                  if (e) {
                    this.raise(u.RecordNoProto, { at: i });
                    return;
                  }
                  s.used && (r ? r.doubleProtoLoc === null && (r.doubleProtoLoc = i.loc.start) : this.raise(u.DuplicateProto, { at: i })), s.used = true;
                }
              }
              shouldExitDescending(t3, e) {
                return t3.type === "ArrowFunctionExpression" && t3.start === e;
              }
              getExpression() {
                this.enterInitialScopes(), this.nextToken();
                let t3 = this.parseExpression();
                return this.match(135) || this.unexpected(), this.finalizeRemainingComments(), t3.comments = this.state.comments, t3.errors = this.state.errors, this.options.tokens && (t3.tokens = this.tokens), t3;
              }
              parseExpression(t3, e) {
                return t3 ? this.disallowInAnd(() => this.parseExpressionBase(e)) : this.allowInAnd(() => this.parseExpressionBase(e));
              }
              parseExpressionBase(t3) {
                let e = this.state.start, s = this.state.startLoc, r = this.parseMaybeAssign(t3);
                if (this.match(12)) {
                  let i = this.startNodeAt(e, s);
                  for (i.expressions = [r]; this.eat(12); )
                    i.expressions.push(this.parseMaybeAssign(t3));
                  return this.toReferencedList(i.expressions), this.finishNode(i, "SequenceExpression");
                }
                return r;
              }
              parseMaybeAssignDisallowIn(t3, e) {
                return this.disallowInAnd(() => this.parseMaybeAssign(t3, e));
              }
              parseMaybeAssignAllowIn(t3, e) {
                return this.allowInAnd(() => this.parseMaybeAssign(t3, e));
              }
              setOptionalParametersError(t3, e) {
                var s;
                t3.optionalParametersLoc = (s = e == null ? void 0 : e.loc) != null ? s : this.state.startLoc;
              }
              parseMaybeAssign(t3, e) {
                let s = this.state.start, r = this.state.startLoc;
                if (this.isContextual(105) && this.prodParam.hasYield) {
                  let o = this.parseYield();
                  return e && (o = e.call(this, o, s, r)), o;
                }
                let i;
                t3 ? i = false : (t3 = new At(), i = true);
                let { type: a } = this.state;
                (a === 10 || K(a)) && (this.state.potentialArrowAt = this.state.start);
                let n = this.parseMaybeConditional(t3);
                if (e && (n = e.call(this, n, s, r)), wo(this.state.type)) {
                  let o = this.startNodeAt(s, r), c = this.state.value;
                  return o.operator = c, this.match(29) ? (this.toAssignable(n, true), o.left = n, t3.doubleProtoLoc != null && t3.doubleProtoLoc.index >= s && (t3.doubleProtoLoc = null), t3.shorthandAssignLoc != null && t3.shorthandAssignLoc.index >= s && (t3.shorthandAssignLoc = null), t3.privateKeyLoc != null && t3.privateKeyLoc.index >= s && (this.checkDestructuringPrivate(t3), t3.privateKeyLoc = null)) : o.left = n, this.next(), o.right = this.parseMaybeAssign(), this.checkLVal(n, { in: this.finishNode(o, "AssignmentExpression") }), o;
                } else
                  i && this.checkExpressionErrors(t3, true);
                return n;
              }
              parseMaybeConditional(t3) {
                let e = this.state.start, s = this.state.startLoc, r = this.state.potentialArrowAt, i = this.parseExprOps(t3);
                return this.shouldExitDescending(i, r) ? i : this.parseConditional(i, e, s, t3);
              }
              parseConditional(t3, e, s, r) {
                if (this.eat(17)) {
                  let i = this.startNodeAt(e, s);
                  return i.test = t3, i.consequent = this.parseMaybeAssignAllowIn(), this.expect(14), i.alternate = this.parseMaybeAssign(), this.finishNode(i, "ConditionalExpression");
                }
                return t3;
              }
              parseMaybeUnaryOrPrivate(t3) {
                return this.match(134) ? this.parsePrivateName() : this.parseMaybeUnary(t3);
              }
              parseExprOps(t3) {
                let e = this.state.start, s = this.state.startLoc, r = this.state.potentialArrowAt, i = this.parseMaybeUnaryOrPrivate(t3);
                return this.shouldExitDescending(i, r) ? i : this.parseExprOp(i, e, s, -1);
              }
              parseExprOp(t3, e, s, r) {
                if (this.isPrivateName(t3)) {
                  let a = this.getPrivateNameSV(t3);
                  (r >= at2(58) || !this.prodParam.hasIn || !this.match(58)) && this.raise(u.PrivateInExpectedIn, { at: t3, identifierName: a }), this.classScope.usePrivateName(a, t3.loc.start);
                }
                let i = this.state.type;
                if (Io(i) && (this.prodParam.hasIn || !this.match(58))) {
                  let a = at2(i);
                  if (a > r) {
                    if (i === 39) {
                      if (this.expectPlugin("pipelineOperator"), this.state.inFSharpPipelineDirectBody)
                        return t3;
                      this.checkPipelineAtInfixOperator(t3, s);
                    }
                    let n = this.startNodeAt(e, s);
                    n.left = t3, n.operator = this.state.value;
                    let o = i === 41 || i === 42, c = i === 40;
                    if (c && (a = at2(42)), this.next(), i === 39 && this.hasPlugin(["pipelineOperator", { proposal: "minimal" }]) && this.state.type === 96 && this.prodParam.hasAwait)
                      throw this.raise(u.UnexpectedAwaitAfterPipelineBody, { at: this.state.startLoc });
                    n.right = this.parseExprOpRightExpr(i, a), this.finishNode(n, o || c ? "LogicalExpression" : "BinaryExpression");
                    let f = this.state.type;
                    if (c && (f === 41 || f === 42) || o && f === 40)
                      throw this.raise(u.MixingCoalesceWithLogical, { at: this.state.startLoc });
                    return this.parseExprOp(n, e, s, r);
                  }
                }
                return t3;
              }
              parseExprOpRightExpr(t3, e) {
                let s = this.state.start, r = this.state.startLoc;
                switch (t3) {
                  case 39:
                    switch (this.getPluginOption("pipelineOperator", "proposal")) {
                      case "hack":
                        return this.withTopicBindingContext(() => this.parseHackPipeBody());
                      case "smart":
                        return this.withTopicBindingContext(() => {
                          if (this.prodParam.hasYield && this.isContextual(105))
                            throw this.raise(u.PipeBodyIsTighter, { at: this.state.startLoc });
                          return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(t3, e), s, r);
                        });
                      case "fsharp":
                        return this.withSoloAwaitPermittingContext(() => this.parseFSharpPipelineBody(e));
                    }
                  default:
                    return this.parseExprOpBaseRightExpr(t3, e);
                }
              }
              parseExprOpBaseRightExpr(t3, e) {
                let s = this.state.start, r = this.state.startLoc;
                return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), s, r, Bo(t3) ? e - 1 : e);
              }
              parseHackPipeBody() {
                var t3;
                let { startLoc: e } = this.state, s = this.parseMaybeAssign();
                return R.has(s.type) && !((t3 = s.extra) != null && t3.parenthesized) && this.raise(u.PipeUnparenthesizedBody, { at: e, type: s.type }), this.topicReferenceWasUsedInCurrentContext() || this.raise(u.PipeTopicUnused, { at: e }), s;
              }
              checkExponentialAfterUnary(t3) {
                this.match(57) && this.raise(u.UnexpectedTokenUnaryExponentiation, { at: t3.argument });
              }
              parseMaybeUnary(t3, e) {
                let s = this.state.start, r = this.state.startLoc, i = this.isContextual(96);
                if (i && this.isAwaitAllowed()) {
                  this.next();
                  let c = this.parseAwait(s, r);
                  return e || this.checkExponentialAfterUnary(c), c;
                }
                let a = this.match(34), n = this.startNode();
                if (Do(this.state.type)) {
                  n.operator = this.state.value, n.prefix = true, this.match(72) && this.expectPlugin("throwExpressions");
                  let c = this.match(89);
                  if (this.next(), n.argument = this.parseMaybeUnary(null, true), this.checkExpressionErrors(t3, true), this.state.strict && c) {
                    let f = n.argument;
                    f.type === "Identifier" ? this.raise(u.StrictDelete, { at: n }) : this.hasPropertyAsPrivateName(f) && this.raise(u.DeletePrivateField, { at: n });
                  }
                  if (!a)
                    return e || this.checkExponentialAfterUnary(n), this.finishNode(n, "UnaryExpression");
                }
                let o = this.parseUpdate(n, a, t3);
                if (i) {
                  let { type: c } = this.state;
                  if ((this.hasPlugin("v8intrinsic") ? Vt(c) : Vt(c) && !this.match(54)) && !this.isAmbiguousAwait())
                    return this.raiseOverwrite(u.AwaitNotInAsyncContext, { at: r }), this.parseAwait(s, r);
                }
                return o;
              }
              parseUpdate(t3, e, s) {
                if (e)
                  return this.checkLVal(t3.argument, { in: this.finishNode(t3, "UpdateExpression") }), t3;
                let r = this.state.start, i = this.state.startLoc, a = this.parseExprSubscripts(s);
                if (this.checkExpressionErrors(s, false))
                  return a;
                for (; ko(this.state.type) && !this.canInsertSemicolon(); ) {
                  let n = this.startNodeAt(r, i);
                  n.operator = this.state.value, n.prefix = false, n.argument = a, this.next(), this.checkLVal(a, { in: a = this.finishNode(n, "UpdateExpression") });
                }
                return a;
              }
              parseExprSubscripts(t3) {
                let e = this.state.start, s = this.state.startLoc, r = this.state.potentialArrowAt, i = this.parseExprAtom(t3);
                return this.shouldExitDescending(i, r) ? i : this.parseSubscripts(i, e, s);
              }
              parseSubscripts(t3, e, s, r) {
                let i = { optionalChainMember: false, maybeAsyncArrow: this.atPossibleAsyncArrow(t3), stop: false };
                do
                  t3 = this.parseSubscript(t3, e, s, r, i), i.maybeAsyncArrow = false;
                while (!i.stop);
                return t3;
              }
              parseSubscript(t3, e, s, r, i) {
                let { type: a } = this.state;
                if (!r && a === 15)
                  return this.parseBind(t3, e, s, r, i);
                if (nt(a))
                  return this.parseTaggedTemplateExpression(t3, e, s, i);
                let n = false;
                if (a === 18) {
                  if (r && this.lookaheadCharCode() === 40)
                    return i.stop = true, t3;
                  i.optionalChainMember = n = true, this.next();
                }
                if (!r && this.match(10))
                  return this.parseCoverCallAndAsyncArrowHead(t3, e, s, i, n);
                {
                  let o = this.eat(0);
                  return o || n || this.eat(16) ? this.parseMember(t3, e, s, i, o, n) : (i.stop = true, t3);
                }
              }
              parseMember(t3, e, s, r, i, a) {
                let n = this.startNodeAt(e, s);
                return n.object = t3, n.computed = i, i ? (n.property = this.parseExpression(), this.expect(3)) : this.match(134) ? (t3.type === "Super" && this.raise(u.SuperPrivateField, { at: s }), this.classScope.usePrivateName(this.state.value, this.state.startLoc), n.property = this.parsePrivateName()) : n.property = this.parseIdentifier(true), r.optionalChainMember ? (n.optional = a, this.finishNode(n, "OptionalMemberExpression")) : this.finishNode(n, "MemberExpression");
              }
              parseBind(t3, e, s, r, i) {
                let a = this.startNodeAt(e, s);
                return a.object = t3, this.next(), a.callee = this.parseNoCallExpr(), i.stop = true, this.parseSubscripts(this.finishNode(a, "BindExpression"), e, s, r);
              }
              parseCoverCallAndAsyncArrowHead(t3, e, s, r, i) {
                let a = this.state.maybeInArrowParameters, n = null;
                this.state.maybeInArrowParameters = true, this.next();
                let o = this.startNodeAt(e, s);
                o.callee = t3;
                let { maybeAsyncArrow: c, optionalChainMember: f } = r;
                return c && (this.expressionScope.enter(Ph()), n = new At()), f && (o.optional = i), i ? o.arguments = this.parseCallExpressionArguments(11) : o.arguments = this.parseCallExpressionArguments(11, t3.type === "Import", t3.type !== "Super", o, n), this.finishCallExpression(o, f), c && this.shouldParseAsyncArrow() && !i ? (r.stop = true, this.checkDestructuringPrivate(n), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), o = this.parseAsyncArrowFromCallExpression(this.startNodeAt(e, s), o)) : (c && (this.checkExpressionErrors(n, true), this.expressionScope.exit()), this.toReferencedArguments(o)), this.state.maybeInArrowParameters = a, o;
              }
              toReferencedArguments(t3, e) {
                this.toReferencedListDeep(t3.arguments, e);
              }
              parseTaggedTemplateExpression(t3, e, s, r) {
                let i = this.startNodeAt(e, s);
                return i.tag = t3, i.quasi = this.parseTemplate(true), r.optionalChainMember && this.raise(u.OptionalChainingNoTemplate, { at: s }), this.finishNode(i, "TaggedTemplateExpression");
              }
              atPossibleAsyncArrow(t3) {
                return t3.type === "Identifier" && t3.name === "async" && this.state.lastTokEndLoc.index === t3.end && !this.canInsertSemicolon() && t3.end - t3.start === 5 && t3.start === this.state.potentialArrowAt;
              }
              finishCallExpression(t3, e) {
                if (t3.callee.type === "Import")
                  if (t3.arguments.length === 2 && (this.hasPlugin("moduleAttributes") || this.expectPlugin("importAssertions")), t3.arguments.length === 0 || t3.arguments.length > 2)
                    this.raise(u.ImportCallArity, { at: t3, maxArgumentCount: this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1 });
                  else
                    for (let s of t3.arguments)
                      s.type === "SpreadElement" && this.raise(u.ImportCallSpreadArgument, { at: s });
                return this.finishNode(t3, e ? "OptionalCallExpression" : "CallExpression");
              }
              parseCallExpressionArguments(t3, e, s, r, i) {
                let a = [], n = true, o = this.state.inFSharpPipelineDirectBody;
                for (this.state.inFSharpPipelineDirectBody = false; !this.eat(t3); ) {
                  if (n)
                    n = false;
                  else if (this.expect(12), this.match(t3)) {
                    e && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes") && this.raise(u.ImportCallArgumentTrailingComma, { at: this.state.lastTokStartLoc }), r && this.addTrailingCommaExtraToNode(r), this.next();
                    break;
                  }
                  a.push(this.parseExprListItem(false, i, s));
                }
                return this.state.inFSharpPipelineDirectBody = o, a;
              }
              shouldParseAsyncArrow() {
                return this.match(19) && !this.canInsertSemicolon();
              }
              parseAsyncArrowFromCallExpression(t3, e) {
                var s;
                return this.resetPreviousNodeTrailingComments(e), this.expect(19), this.parseArrowExpression(t3, e.arguments, true, (s = e.extra) == null ? void 0 : s.trailingCommaLoc), e.innerComments && Ge(t3, e.innerComments), e.callee.trailingComments && Ge(t3, e.callee.trailingComments), t3;
              }
              parseNoCallExpr() {
                let t3 = this.state.start, e = this.state.startLoc;
                return this.parseSubscripts(this.parseExprAtom(), t3, e, true);
              }
              parseExprAtom(t3) {
                let e, { type: s } = this.state;
                switch (s) {
                  case 79:
                    return this.parseSuper();
                  case 83:
                    return e = this.startNode(), this.next(), this.match(16) ? this.parseImportMetaProperty(e) : (this.match(10) || this.raise(u.UnsupportedImport, { at: this.state.lastTokStartLoc }), this.finishNode(e, "Import"));
                  case 78:
                    return e = this.startNode(), this.next(), this.finishNode(e, "ThisExpression");
                  case 90:
                    return this.parseDo(this.startNode(), false);
                  case 56:
                  case 31:
                    return this.readRegexp(), this.parseRegExpLiteral(this.state.value);
                  case 130:
                    return this.parseNumericLiteral(this.state.value);
                  case 131:
                    return this.parseBigIntLiteral(this.state.value);
                  case 132:
                    return this.parseDecimalLiteral(this.state.value);
                  case 129:
                    return this.parseStringLiteral(this.state.value);
                  case 84:
                    return this.parseNullLiteral();
                  case 85:
                    return this.parseBooleanLiteral(true);
                  case 86:
                    return this.parseBooleanLiteral(false);
                  case 10: {
                    let r = this.state.potentialArrowAt === this.state.start;
                    return this.parseParenAndDistinguishExpression(r);
                  }
                  case 2:
                  case 1:
                    return this.parseArrayLike(this.state.type === 2 ? 4 : 3, false, true);
                  case 0:
                    return this.parseArrayLike(3, true, false, t3);
                  case 6:
                  case 7:
                    return this.parseObjectLike(this.state.type === 6 ? 9 : 8, false, true);
                  case 5:
                    return this.parseObjectLike(8, false, false, t3);
                  case 68:
                    return this.parseFunctionOrFunctionSent();
                  case 26:
                    this.parseDecorators();
                  case 80:
                    return e = this.startNode(), this.takeDecorators(e), this.parseClass(e, false);
                  case 77:
                    return this.parseNewOrNewTarget();
                  case 25:
                  case 24:
                    return this.parseTemplate(false);
                  case 15: {
                    e = this.startNode(), this.next(), e.object = null;
                    let r = e.callee = this.parseNoCallExpr();
                    if (r.type === "MemberExpression")
                      return this.finishNode(e, "BindExpression");
                    throw this.raise(u.UnsupportedBind, { at: r });
                  }
                  case 134:
                    return this.raise(u.PrivateInExpectedIn, { at: this.state.startLoc, identifierName: this.state.value }), this.parsePrivateName();
                  case 33:
                    return this.parseTopicReferenceThenEqualsSign(54, "%");
                  case 32:
                    return this.parseTopicReferenceThenEqualsSign(44, "^");
                  case 37:
                  case 38:
                    return this.parseTopicReference("hack");
                  case 44:
                  case 54:
                  case 27: {
                    let r = this.getPluginOption("pipelineOperator", "proposal");
                    if (r)
                      return this.parseTopicReference(r);
                    throw this.unexpected();
                  }
                  case 47: {
                    let r = this.input.codePointAt(this.nextTokenStart());
                    if (de(r) || r === 62) {
                      this.expectOnePlugin(["jsx", "flow", "typescript"]);
                      break;
                    } else
                      throw this.unexpected();
                  }
                  default:
                    if (K(s)) {
                      if (this.isContextual(123) && this.lookaheadCharCode() === 123 && !this.hasFollowingLineBreak())
                        return this.parseModuleExpression();
                      let r = this.state.potentialArrowAt === this.state.start, i = this.state.containsEsc, a = this.parseIdentifier();
                      if (!i && a.name === "async" && !this.canInsertSemicolon()) {
                        let { type: n } = this.state;
                        if (n === 68)
                          return this.resetPreviousNodeTrailingComments(a), this.next(), this.parseFunction(this.startNodeAtNode(a), void 0, true);
                        if (K(n))
                          return this.lookaheadCharCode() === 61 ? this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(a)) : a;
                        if (n === 90)
                          return this.resetPreviousNodeTrailingComments(a), this.parseDo(this.startNodeAtNode(a), true);
                      }
                      return r && this.match(19) && !this.canInsertSemicolon() ? (this.next(), this.parseArrowExpression(this.startNodeAtNode(a), [a], false)) : a;
                    } else
                      throw this.unexpected();
                }
              }
              parseTopicReferenceThenEqualsSign(t3, e) {
                let s = this.getPluginOption("pipelineOperator", "proposal");
                if (s)
                  return this.state.type = t3, this.state.value = e, this.state.pos--, this.state.end--, this.state.endLoc = m(this.state.endLoc, -1), this.parseTopicReference(s);
                throw this.unexpected();
              }
              parseTopicReference(t3) {
                let e = this.startNode(), s = this.state.startLoc, r = this.state.type;
                return this.next(), this.finishTopicReference(e, s, t3, r);
              }
              finishTopicReference(t3, e, s, r) {
                if (this.testTopicReferenceConfiguration(s, e, r)) {
                  let i = s === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
                  return this.topicReferenceIsAllowedInCurrentContext() || this.raise(s === "smart" ? u.PrimaryTopicNotAllowed : u.PipeTopicUnbound, { at: e }), this.registerTopicReference(), this.finishNode(t3, i);
                } else
                  throw this.raise(u.PipeTopicUnconfiguredToken, { at: e, token: Pe(r) });
              }
              testTopicReferenceConfiguration(t3, e, s) {
                switch (t3) {
                  case "hack":
                    return this.hasPlugin(["pipelineOperator", { topicToken: Pe(s) }]);
                  case "smart":
                    return s === 27;
                  default:
                    throw this.raise(u.PipeTopicRequiresHackPipes, { at: e });
                }
              }
              parseAsyncArrowUnaryFunction(t3) {
                this.prodParam.enter(gt2(true, this.prodParam.hasYield));
                let e = [this.parseIdentifier()];
                return this.prodParam.exit(), this.hasPrecedingLineBreak() && this.raise(u.LineTerminatorBeforeArrow, { at: this.state.curPosition() }), this.expect(19), this.parseArrowExpression(t3, e, true), t3;
              }
              parseDo(t3, e) {
                this.expectPlugin("doExpressions"), e && this.expectPlugin("asyncDoExpressions"), t3.async = e, this.next();
                let s = this.state.labels;
                return this.state.labels = [], e ? (this.prodParam.enter(xt), t3.body = this.parseBlock(), this.prodParam.exit()) : t3.body = this.parseBlock(), this.state.labels = s, this.finishNode(t3, "DoExpression");
              }
              parseSuper() {
                let t3 = this.startNode();
                return this.next(), this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod ? this.raise(u.SuperNotAllowed, { at: t3 }) : !this.scope.allowSuper && !this.options.allowSuperOutsideMethod && this.raise(u.UnexpectedSuper, { at: t3 }), !this.match(10) && !this.match(0) && !this.match(16) && this.raise(u.UnsupportedSuper, { at: t3 }), this.finishNode(t3, "Super");
              }
              parsePrivateName() {
                let t3 = this.startNode(), e = this.startNodeAt(this.state.start + 1, new p(this.state.curLine, this.state.start + 1 - this.state.lineStart, this.state.start + 1)), s = this.state.value;
                return this.next(), t3.id = this.createIdentifier(e, s), this.finishNode(t3, "PrivateName");
              }
              parseFunctionOrFunctionSent() {
                let t3 = this.startNode();
                if (this.next(), this.prodParam.hasYield && this.match(16)) {
                  let e = this.createIdentifier(this.startNodeAtNode(t3), "function");
                  return this.next(), this.match(102) ? this.expectPlugin("functionSent") : this.hasPlugin("functionSent") || this.unexpected(), this.parseMetaProperty(t3, e, "sent");
                }
                return this.parseFunction(t3);
              }
              parseMetaProperty(t3, e, s) {
                t3.meta = e;
                let r = this.state.containsEsc;
                return t3.property = this.parseIdentifier(true), (t3.property.name !== s || r) && this.raise(u.UnsupportedMetaProperty, { at: t3.property, target: e.name, onlyValidPropertyName: s }), this.finishNode(t3, "MetaProperty");
              }
              parseImportMetaProperty(t3) {
                let e = this.createIdentifier(this.startNodeAtNode(t3), "import");
                return this.next(), this.isContextual(100) && (this.inModule || this.raise(u.ImportMetaOutsideModule, { at: e }), this.sawUnambiguousESM = true), this.parseMetaProperty(t3, e, "meta");
              }
              parseLiteralAtNode(t3, e, s) {
                return this.addExtra(s, "rawValue", t3), this.addExtra(s, "raw", this.input.slice(s.start, this.state.end)), s.value = t3, this.next(), this.finishNode(s, e);
              }
              parseLiteral(t3, e) {
                let s = this.startNode();
                return this.parseLiteralAtNode(t3, e, s);
              }
              parseStringLiteral(t3) {
                return this.parseLiteral(t3, "StringLiteral");
              }
              parseNumericLiteral(t3) {
                return this.parseLiteral(t3, "NumericLiteral");
              }
              parseBigIntLiteral(t3) {
                return this.parseLiteral(t3, "BigIntLiteral");
              }
              parseDecimalLiteral(t3) {
                return this.parseLiteral(t3, "DecimalLiteral");
              }
              parseRegExpLiteral(t3) {
                let e = this.parseLiteral(t3.value, "RegExpLiteral");
                return e.pattern = t3.pattern, e.flags = t3.flags, e;
              }
              parseBooleanLiteral(t3) {
                let e = this.startNode();
                return e.value = t3, this.next(), this.finishNode(e, "BooleanLiteral");
              }
              parseNullLiteral() {
                let t3 = this.startNode();
                return this.next(), this.finishNode(t3, "NullLiteral");
              }
              parseParenAndDistinguishExpression(t3) {
                let e = this.state.start, s = this.state.startLoc, r;
                this.next(), this.expressionScope.enter(Ah());
                let i = this.state.maybeInArrowParameters, a = this.state.inFSharpPipelineDirectBody;
                this.state.maybeInArrowParameters = true, this.state.inFSharpPipelineDirectBody = false;
                let n = this.state.start, o = this.state.startLoc, c = [], f = new At(), y = true, P, v;
                for (; !this.match(11); ) {
                  if (y)
                    y = false;
                  else if (this.expect(12, f.optionalParametersLoc === null ? null : f.optionalParametersLoc), this.match(11)) {
                    v = this.state.startLoc;
                    break;
                  }
                  if (this.match(21)) {
                    let _ = this.state.start, Q = this.state.startLoc;
                    if (P = this.state.startLoc, c.push(this.parseParenItem(this.parseRestBinding(), _, Q)), !this.checkCommaAfterRest(41))
                      break;
                  } else
                    c.push(this.parseMaybeAssignAllowIn(f, this.parseParenItem));
                }
                let N = this.state.lastTokEndLoc;
                this.expect(11), this.state.maybeInArrowParameters = i, this.state.inFSharpPipelineDirectBody = a;
                let B = this.startNodeAt(e, s);
                return t3 && this.shouldParseArrow(c) && (B = this.parseArrow(B)) ? (this.checkDestructuringPrivate(f), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), this.parseArrowExpression(B, c, false), B) : (this.expressionScope.exit(), c.length || this.unexpected(this.state.lastTokStartLoc), v && this.unexpected(v), P && this.unexpected(P), this.checkExpressionErrors(f, true), this.toReferencedListDeep(c, true), c.length > 1 ? (r = this.startNodeAt(n, o), r.expressions = c, this.finishNode(r, "SequenceExpression"), this.resetEndLocation(r, N)) : r = c[0], this.wrapParenthesis(e, s, r));
              }
              wrapParenthesis(t3, e, s) {
                if (!this.options.createParenthesizedExpressions)
                  return this.addExtra(s, "parenthesized", true), this.addExtra(s, "parenStart", t3), this.takeSurroundingComments(s, t3, this.state.lastTokEndLoc.index), s;
                let r = this.startNodeAt(t3, e);
                return r.expression = s, this.finishNode(r, "ParenthesizedExpression"), r;
              }
              shouldParseArrow(t3) {
                return !this.canInsertSemicolon();
              }
              parseArrow(t3) {
                if (this.eat(19))
                  return t3;
              }
              parseParenItem(t3, e, s) {
                return t3;
              }
              parseNewOrNewTarget() {
                let t3 = this.startNode();
                if (this.next(), this.match(16)) {
                  let e = this.createIdentifier(this.startNodeAtNode(t3), "new");
                  this.next();
                  let s = this.parseMetaProperty(t3, e, "target");
                  return !this.scope.inNonArrowFunction && !this.scope.inClass && this.raise(u.UnexpectedNewTarget, { at: s }), s;
                }
                return this.parseNew(t3);
              }
              parseNew(t3) {
                if (this.parseNewCallee(t3), this.eat(10)) {
                  let e = this.parseExprList(11);
                  this.toReferencedList(e), t3.arguments = e;
                } else
                  t3.arguments = [];
                return this.finishNode(t3, "NewExpression");
              }
              parseNewCallee(t3) {
                t3.callee = this.parseNoCallExpr(), t3.callee.type === "Import" ? this.raise(u.ImportCallNotNewExpression, { at: t3.callee }) : this.isOptionalChain(t3.callee) ? this.raise(u.OptionalChainingNoNew, { at: this.state.lastTokEndLoc }) : this.eat(18) && this.raise(u.OptionalChainingNoNew, { at: this.state.startLoc });
              }
              parseTemplateElement(t3) {
                let { start: e, startLoc: s, end: r, value: i } = this.state, a = e + 1, n = this.startNodeAt(a, m(s, 1));
                i === null && (t3 || this.raise(u.InvalidEscapeSequenceTemplate, { at: m(s, 2) }));
                let o = this.match(24), c = o ? -1 : -2, f = r + c;
                return n.value = { raw: this.input.slice(a, f).replace(/\r\n?/g, `
`), cooked: i === null ? null : i.slice(1, c) }, n.tail = o, this.next(), this.finishNode(n, "TemplateElement"), this.resetEndLocation(n, m(this.state.lastTokEndLoc, c)), n;
              }
              parseTemplate(t3) {
                let e = this.startNode();
                e.expressions = [];
                let s = this.parseTemplateElement(t3);
                for (e.quasis = [s]; !s.tail; )
                  e.expressions.push(this.parseTemplateSubstitution()), this.readTemplateContinuation(), e.quasis.push(s = this.parseTemplateElement(t3));
                return this.finishNode(e, "TemplateLiteral");
              }
              parseTemplateSubstitution() {
                return this.parseExpression();
              }
              parseObjectLike(t3, e, s, r) {
                s && this.expectPlugin("recordAndTuple");
                let i = this.state.inFSharpPipelineDirectBody;
                this.state.inFSharpPipelineDirectBody = false;
                let a = /* @__PURE__ */ Object.create(null), n = true, o = this.startNode();
                for (o.properties = [], this.next(); !this.match(t3); ) {
                  if (n)
                    n = false;
                  else if (this.expect(12), this.match(t3)) {
                    this.addTrailingCommaExtraToNode(o);
                    break;
                  }
                  let f;
                  e ? f = this.parseBindingProperty() : (f = this.parsePropertyDefinition(r), this.checkProto(f, s, a, r)), s && !this.isObjectProperty(f) && f.type !== "SpreadElement" && this.raise(u.InvalidRecordProperty, { at: f }), f.shorthand && this.addExtra(f, "shorthand", true), o.properties.push(f);
                }
                this.next(), this.state.inFSharpPipelineDirectBody = i;
                let c = "ObjectExpression";
                return e ? c = "ObjectPattern" : s && (c = "RecordExpression"), this.finishNode(o, c);
              }
              addTrailingCommaExtraToNode(t3) {
                this.addExtra(t3, "trailingComma", this.state.lastTokStart), this.addExtra(t3, "trailingCommaLoc", this.state.lastTokStartLoc, false);
              }
              maybeAsyncOrAccessorProp(t3) {
                return !t3.computed && t3.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
              }
              parsePropertyDefinition(t3) {
                let e = [];
                if (this.match(26))
                  for (this.hasPlugin("decorators") && this.raise(u.UnsupportedPropertyDecorator, { at: this.state.startLoc }); this.match(26); )
                    e.push(this.parseDecorator());
                let s = this.startNode(), r = false, i = false, a, n;
                if (this.match(21))
                  return e.length && this.unexpected(), this.parseSpread();
                e.length && (s.decorators = e, e = []), s.method = false, t3 && (a = this.state.start, n = this.state.startLoc);
                let o = this.eat(55);
                this.parsePropertyNamePrefixOperator(s);
                let c = this.state.containsEsc, f = this.parsePropertyName(s, t3);
                if (!o && !c && this.maybeAsyncOrAccessorProp(s)) {
                  let y = f.name;
                  y === "async" && !this.hasPrecedingLineBreak() && (r = true, this.resetPreviousNodeTrailingComments(f), o = this.eat(55), this.parsePropertyName(s)), (y === "get" || y === "set") && (i = true, this.resetPreviousNodeTrailingComments(f), s.kind = y, this.match(55) && (o = true, this.raise(u.AccessorIsGenerator, { at: this.state.curPosition(), kind: y }), this.next()), this.parsePropertyName(s));
                }
                return this.parseObjPropValue(s, a, n, o, r, false, i, t3), s;
              }
              getGetterSetterExpectedParamCount(t3) {
                return t3.kind === "get" ? 0 : 1;
              }
              getObjectOrClassMethodParams(t3) {
                return t3.params;
              }
              checkGetterSetterParams(t3) {
                var e;
                let s = this.getGetterSetterExpectedParamCount(t3), r = this.getObjectOrClassMethodParams(t3);
                r.length !== s && this.raise(t3.kind === "get" ? u.BadGetterArity : u.BadSetterArity, { at: t3 }), t3.kind === "set" && ((e = r[r.length - 1]) == null ? void 0 : e.type) === "RestElement" && this.raise(u.BadSetterRestParameter, { at: t3 });
              }
              parseObjectMethod(t3, e, s, r, i) {
                if (i)
                  return this.parseMethod(t3, e, false, false, false, "ObjectMethod"), this.checkGetterSetterParams(t3), t3;
                if (s || e || this.match(10))
                  return r && this.unexpected(), t3.kind = "method", t3.method = true, this.parseMethod(t3, e, s, false, false, "ObjectMethod");
              }
              parseObjectProperty(t3, e, s, r, i) {
                if (t3.shorthand = false, this.eat(14))
                  return t3.value = r ? this.parseMaybeDefault(this.state.start, this.state.startLoc) : this.parseMaybeAssignAllowIn(i), this.finishNode(t3, "ObjectProperty");
                if (!t3.computed && t3.key.type === "Identifier") {
                  if (this.checkReservedWord(t3.key.name, t3.key.loc.start, true, false), r)
                    t3.value = this.parseMaybeDefault(e, s, ge(t3.key));
                  else if (this.match(29)) {
                    let a = this.state.startLoc;
                    i != null ? i.shorthandAssignLoc === null && (i.shorthandAssignLoc = a) : this.raise(u.InvalidCoverInitializedName, { at: a }), t3.value = this.parseMaybeDefault(e, s, ge(t3.key));
                  } else
                    t3.value = ge(t3.key);
                  return t3.shorthand = true, this.finishNode(t3, "ObjectProperty");
                }
              }
              parseObjPropValue(t3, e, s, r, i, a, n, o) {
                let c = this.parseObjectMethod(t3, r, i, a, n) || this.parseObjectProperty(t3, e, s, a, o);
                return c || this.unexpected(), c;
              }
              parsePropertyName(t3, e) {
                if (this.eat(0))
                  t3.computed = true, t3.key = this.parseMaybeAssignAllowIn(), this.expect(3);
                else {
                  let { type: s, value: r } = this.state, i;
                  if (pe(s))
                    i = this.parseIdentifier(true);
                  else
                    switch (s) {
                      case 130:
                        i = this.parseNumericLiteral(r);
                        break;
                      case 129:
                        i = this.parseStringLiteral(r);
                        break;
                      case 131:
                        i = this.parseBigIntLiteral(r);
                        break;
                      case 132:
                        i = this.parseDecimalLiteral(r);
                        break;
                      case 134: {
                        let a = this.state.startLoc;
                        e != null ? e.privateKeyLoc === null && (e.privateKeyLoc = a) : this.raise(u.UnexpectedPrivateField, { at: a }), i = this.parsePrivateName();
                        break;
                      }
                      default:
                        throw this.unexpected();
                    }
                  t3.key = i, s !== 134 && (t3.computed = false);
                }
                return t3.key;
              }
              initFunction(t3, e) {
                t3.id = null, t3.generator = false, t3.async = !!e;
              }
              parseMethod(t3, e, s, r, i, a) {
                let n = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
                this.initFunction(t3, s), t3.generator = !!e;
                let o = r;
                return this.scope.enter(me | ot | (n ? Se : 0) | (i ? xr : 0)), this.prodParam.enter(gt2(s, t3.generator)), this.parseFunctionParams(t3, o), this.parseFunctionBodyAndFinish(t3, a, true), this.prodParam.exit(), this.scope.exit(), t3;
              }
              parseArrayLike(t3, e, s, r) {
                s && this.expectPlugin("recordAndTuple");
                let i = this.state.inFSharpPipelineDirectBody;
                this.state.inFSharpPipelineDirectBody = false;
                let a = this.startNode();
                return this.next(), a.elements = this.parseExprList(t3, !s, r, a), this.state.inFSharpPipelineDirectBody = i, this.finishNode(a, s ? "TupleExpression" : "ArrayExpression");
              }
              parseArrowExpression(t3, e, s, r) {
                this.scope.enter(me | Jt);
                let i = gt2(s, false);
                !this.match(5) && this.prodParam.hasIn && (i |= qe), this.prodParam.enter(i), this.initFunction(t3, s);
                let a = this.state.maybeInArrowParameters;
                return e && (this.state.maybeInArrowParameters = true, this.setArrowFunctionParameters(t3, e, r)), this.state.maybeInArrowParameters = false, this.parseFunctionBody(t3, true), this.prodParam.exit(), this.scope.exit(), this.state.maybeInArrowParameters = a, this.finishNode(t3, "ArrowFunctionExpression");
              }
              setArrowFunctionParameters(t3, e, s) {
                this.toAssignableList(e, s, false), t3.params = e;
              }
              parseFunctionBodyAndFinish(t3, e) {
                let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                this.parseFunctionBody(t3, false, s), this.finishNode(t3, e);
              }
              parseFunctionBody(t3, e) {
                let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r = e && !this.match(5);
                if (this.expressionScope.enter(Dr()), r)
                  t3.body = this.parseMaybeAssign(), this.checkParams(t3, false, e, false);
                else {
                  let i = this.state.strict, a = this.state.labels;
                  this.state.labels = [], this.prodParam.enter(this.prodParam.currentFlags() | Lr), t3.body = this.parseBlock(true, false, (n) => {
                    let o = !this.isSimpleParamList(t3.params);
                    n && o && this.raise(u.IllegalLanguageModeDirective, { at: (t3.kind === "method" || t3.kind === "constructor") && !!t3.key ? t3.key.loc.end : t3 });
                    let c = !i && this.state.strict;
                    this.checkParams(t3, !this.state.strict && !e && !s && !o, e, c), this.state.strict && t3.id && this.checkIdentifier(t3.id, Xo, c);
                  }), this.prodParam.exit(), this.state.labels = a;
                }
                this.expressionScope.exit();
              }
              isSimpleParameter(t3) {
                return t3.type === "Identifier";
              }
              isSimpleParamList(t3) {
                for (let e = 0, s = t3.length; e < s; e++)
                  if (!this.isSimpleParameter(t3[e]))
                    return false;
                return true;
              }
              checkParams(t3, e, s) {
                let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, i = !e && /* @__PURE__ */ new Set(), a = { type: "FormalParameters" };
                for (let n of t3.params)
                  this.checkLVal(n, { in: a, binding: pt, checkClashes: i, strictModeChanged: r });
              }
              parseExprList(t3, e, s, r) {
                let i = [], a = true;
                for (; !this.eat(t3); ) {
                  if (a)
                    a = false;
                  else if (this.expect(12), this.match(t3)) {
                    r && this.addTrailingCommaExtraToNode(r), this.next();
                    break;
                  }
                  i.push(this.parseExprListItem(e, s));
                }
                return i;
              }
              parseExprListItem(t3, e, s) {
                let r;
                if (this.match(12))
                  t3 || this.raise(u.UnexpectedToken, { at: this.state.curPosition(), unexpected: "," }), r = null;
                else if (this.match(21)) {
                  let i = this.state.start, a = this.state.startLoc;
                  r = this.parseParenItem(this.parseSpread(e), i, a);
                } else if (this.match(17)) {
                  this.expectPlugin("partialApplication"), s || this.raise(u.UnexpectedArgumentPlaceholder, { at: this.state.startLoc });
                  let i = this.startNode();
                  this.next(), r = this.finishNode(i, "ArgumentPlaceholder");
                } else
                  r = this.parseMaybeAssignAllowIn(e, this.parseParenItem);
                return r;
              }
              parseIdentifier(t3) {
                let e = this.startNode(), s = this.parseIdentifierName(e.start, t3);
                return this.createIdentifier(e, s);
              }
              createIdentifier(t3, e) {
                return t3.name = e, t3.loc.identifierName = e, this.finishNode(t3, "Identifier");
              }
              parseIdentifierName(t3, e) {
                let s, { startLoc: r, type: i } = this.state;
                if (pe(i))
                  s = this.state.value;
                else
                  throw this.unexpected();
                let a = vo(i);
                return e ? a && this.replaceToken(128) : this.checkReservedWord(s, r, a, false), this.next(), s;
              }
              checkReservedWord(t3, e, s, r) {
                if (t3.length > 10 || !Ho(t3))
                  return;
                if (t3 === "yield") {
                  if (this.prodParam.hasYield) {
                    this.raise(u.YieldBindingIdentifier, { at: e });
                    return;
                  }
                } else if (t3 === "await") {
                  if (this.prodParam.hasAwait) {
                    this.raise(u.AwaitBindingIdentifier, { at: e });
                    return;
                  }
                  if (this.scope.inStaticBlock) {
                    this.raise(u.AwaitBindingIdentifierInStaticBlock, { at: e });
                    return;
                  }
                  this.expressionScope.recordAsyncArrowParametersError({ at: e });
                } else if (t3 === "arguments" && this.scope.inClassAndNotInNonArrowFunction) {
                  this.raise(u.ArgumentsInClass, { at: e });
                  return;
                }
                if (s && zo(t3)) {
                  this.raise(u.UnexpectedKeyword, { at: e, keyword: t3 });
                  return;
                }
                (this.state.strict ? r ? mr : fr : pr)(t3, this.inModule) && this.raise(u.UnexpectedReservedWord, { at: e, reservedWord: t3 });
              }
              isAwaitAllowed() {
                return !!(this.prodParam.hasAwait || this.options.allowAwaitOutsideFunction && !this.scope.inFunction);
              }
              parseAwait(t3, e) {
                let s = this.startNodeAt(t3, e);
                return this.expressionScope.recordParameterInitializerError(u.AwaitExpressionFormalParameter, { at: s }), this.eat(55) && this.raise(u.ObsoleteAwaitStar, { at: s }), !this.scope.inFunction && !this.options.allowAwaitOutsideFunction && (this.isAmbiguousAwait() ? this.ambiguousScriptDifferentAst = true : this.sawUnambiguousESM = true), this.state.soloAwait || (s.argument = this.parseMaybeUnary(null, true)), this.finishNode(s, "AwaitExpression");
              }
              isAmbiguousAwait() {
                if (this.hasPrecedingLineBreak())
                  return true;
                let { type: t3 } = this.state;
                return t3 === 53 || t3 === 10 || t3 === 0 || nt(t3) || t3 === 133 || t3 === 56 || this.hasPlugin("v8intrinsic") && t3 === 54;
              }
              parseYield() {
                let t3 = this.startNode();
                this.expressionScope.recordParameterInitializerError(u.YieldInParameter, { at: t3 }), this.next();
                let e = false, s = null;
                if (!this.hasPrecedingLineBreak())
                  switch (e = this.eat(55), this.state.type) {
                    case 13:
                    case 135:
                    case 8:
                    case 11:
                    case 3:
                    case 9:
                    case 14:
                    case 12:
                      if (!e)
                        break;
                    default:
                      s = this.parseMaybeAssign();
                  }
                return t3.delegate = e, t3.argument = s, this.finishNode(t3, "YieldExpression");
              }
              checkPipelineAtInfixOperator(t3, e) {
                this.hasPlugin(["pipelineOperator", { proposal: "smart" }]) && t3.type === "SequenceExpression" && this.raise(u.PipelineHeadSequenceExpression, { at: e });
              }
              parseSmartPipelineBodyInStyle(t3, e, s) {
                let r = this.startNodeAt(e, s);
                return this.isSimpleReference(t3) ? (r.callee = t3, this.finishNode(r, "PipelineBareFunction")) : (this.checkSmartPipeTopicBodyEarlyErrors(s), r.expression = t3, this.finishNode(r, "PipelineTopicExpression"));
              }
              isSimpleReference(t3) {
                switch (t3.type) {
                  case "MemberExpression":
                    return !t3.computed && this.isSimpleReference(t3.object);
                  case "Identifier":
                    return true;
                  default:
                    return false;
                }
              }
              checkSmartPipeTopicBodyEarlyErrors(t3) {
                if (this.match(19))
                  throw this.raise(u.PipelineBodyNoArrow, { at: this.state.startLoc });
                this.topicReferenceWasUsedInCurrentContext() || this.raise(u.PipelineTopicUnused, { at: t3 });
              }
              withTopicBindingContext(t3) {
                let e = this.state.topicContext;
                this.state.topicContext = { maxNumOfResolvableTopics: 1, maxTopicIndex: null };
                try {
                  return t3();
                } finally {
                  this.state.topicContext = e;
                }
              }
              withSmartMixTopicForbiddingContext(t3) {
                if (this.hasPlugin(["pipelineOperator", { proposal: "smart" }])) {
                  let e = this.state.topicContext;
                  this.state.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null };
                  try {
                    return t3();
                  } finally {
                    this.state.topicContext = e;
                  }
                } else
                  return t3();
              }
              withSoloAwaitPermittingContext(t3) {
                let e = this.state.soloAwait;
                this.state.soloAwait = true;
                try {
                  return t3();
                } finally {
                  this.state.soloAwait = e;
                }
              }
              allowInAnd(t3) {
                let e = this.prodParam.currentFlags();
                if (qe & ~e) {
                  this.prodParam.enter(e | qe);
                  try {
                    return t3();
                  } finally {
                    this.prodParam.exit();
                  }
                }
                return t3();
              }
              disallowInAnd(t3) {
                let e = this.prodParam.currentFlags();
                if (qe & e) {
                  this.prodParam.enter(e & ~qe);
                  try {
                    return t3();
                  } finally {
                    this.prodParam.exit();
                  }
                }
                return t3();
              }
              registerTopicReference() {
                this.state.topicContext.maxTopicIndex = 0;
              }
              topicReferenceIsAllowedInCurrentContext() {
                return this.state.topicContext.maxNumOfResolvableTopics >= 1;
              }
              topicReferenceWasUsedInCurrentContext() {
                return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
              }
              parseFSharpPipelineBody(t3) {
                let e = this.state.start, s = this.state.startLoc;
                this.state.potentialArrowAt = this.state.start;
                let r = this.state.inFSharpPipelineDirectBody;
                this.state.inFSharpPipelineDirectBody = true;
                let i = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), e, s, t3);
                return this.state.inFSharpPipelineDirectBody = r, i;
              }
              parseModuleExpression() {
                this.expectPlugin("moduleBlocks");
                let t3 = this.startNode();
                this.next(), this.eat(5);
                let e = this.initializeScopes(true);
                this.enterInitialScopes();
                let s = this.startNode();
                try {
                  t3.body = this.parseProgram(s, 8, "module");
                } finally {
                  e();
                }
                return this.eat(8), this.finishNode(t3, "ModuleExpression");
              }
              parsePropertyNamePrefixOperator(t3) {
              }
            }, ps = { kind: "loop" }, $h = { kind: "switch" }, Qh = 0, fs = 1, Hr = 2, Wr = 4, Zh = /[\uD800-\uDFFF]/u, ds = /in(?:stanceof)?/y;
            function el(t3, e) {
              for (let s = 0; s < t3.length; s++) {
                let r = t3[s], { type: i } = r;
                if (typeof i == "number") {
                  {
                    if (i === 134) {
                      let { loc: a, start: n, value: o, end: c } = r, f = n + 1, y = m(a.start, 1);
                      t3.splice(s, 1, new Ee({ type: fe(27), value: "#", start: n, end: f, startLoc: a.start, endLoc: y }), new Ee({ type: fe(128), value: o, start: f, end: c, startLoc: y, endLoc: a.end })), s++;
                      continue;
                    }
                    if (nt(i)) {
                      let { loc: a, start: n, value: o, end: c } = r, f = n + 1, y = m(a.start, 1), P;
                      e.charCodeAt(n) === 96 ? P = new Ee({ type: fe(22), value: "`", start: n, end: f, startLoc: a.start, endLoc: y }) : P = new Ee({ type: fe(8), value: "}", start: n, end: f, startLoc: a.start, endLoc: y });
                      let v, N, B, _;
                      i === 24 ? (N = c - 1, B = m(a.end, -1), v = o === null ? null : o.slice(1, -1), _ = new Ee({ type: fe(22), value: "`", start: N, end: c, startLoc: B, endLoc: a.end })) : (N = c - 2, B = m(a.end, -2), v = o === null ? null : o.slice(1, -2), _ = new Ee({ type: fe(23), value: "${", start: N, end: c, startLoc: B, endLoc: a.end })), t3.splice(s, 1, P, new Ee({ type: fe(20), value: v, start: f, end: N, startLoc: y, endLoc: B }), _), s += 2;
                      continue;
                    }
                  }
                  r.type = fe(i);
                }
              }
              return t3;
            }
            var tl = class extends Yh {
              parseTopLevel(t3, e) {
                return t3.program = this.parseProgram(e), t3.comments = this.state.comments, this.options.tokens && (t3.tokens = el(this.tokens, this.input)), this.finishNode(t3, "File");
              }
              parseProgram(t3) {
                let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 135, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.options.sourceType;
                if (t3.sourceType = s, t3.interpreter = this.parseInterpreterDirective(), this.parseBlockBody(t3, true, true, e), this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0)
                  for (let [r, i] of Array.from(this.scope.undefinedExports))
                    this.raise(u.ModuleExportUndefined, { at: i, localName: r });
                return this.finishNode(t3, "Program");
              }
              stmtToDirective(t3) {
                let e = t3;
                e.type = "Directive", e.value = e.expression, delete e.expression;
                let s = e.value, r = s.value, i = this.input.slice(s.start, s.end), a = s.value = i.slice(1, -1);
                return this.addExtra(s, "raw", i), this.addExtra(s, "rawValue", a), this.addExtra(s, "expressionValue", r), s.type = "DirectiveLiteral", e;
              }
              parseInterpreterDirective() {
                if (!this.match(28))
                  return null;
                let t3 = this.startNode();
                return t3.value = this.state.value, this.next(), this.finishNode(t3, "InterpreterDirective");
              }
              isLet(t3) {
                return this.isContextual(99) ? this.isLetKeyword(t3) : false;
              }
              isLetKeyword(t3) {
                let e = this.nextTokenStart(), s = this.codePointAtPos(e);
                if (s === 92 || s === 91)
                  return true;
                if (t3)
                  return false;
                if (s === 123)
                  return true;
                if (de(s)) {
                  if (ds.lastIndex = e, ds.test(this.input)) {
                    let r = this.codePointAtPos(ds.lastIndex);
                    if (!Be(r) && r !== 92)
                      return false;
                  }
                  return true;
                }
                return false;
              }
              parseStatement(t3, e) {
                return this.match(26) && this.parseDecorators(true), this.parseStatementContent(t3, e);
              }
              parseStatementContent(t3, e) {
                let s = this.state.type, r = this.startNode(), i;
                switch (this.isLet(t3) && (s = 74, i = "let"), s) {
                  case 60:
                    return this.parseBreakContinueStatement(r, true);
                  case 63:
                    return this.parseBreakContinueStatement(r, false);
                  case 64:
                    return this.parseDebuggerStatement(r);
                  case 90:
                    return this.parseDoStatement(r);
                  case 91:
                    return this.parseForStatement(r);
                  case 68:
                    if (this.lookaheadCharCode() === 46)
                      break;
                    return t3 && (this.state.strict ? this.raise(u.StrictFunction, { at: this.state.startLoc }) : t3 !== "if" && t3 !== "label" && this.raise(u.SloppyFunction, { at: this.state.startLoc })), this.parseFunctionStatement(r, false, !t3);
                  case 80:
                    return t3 && this.unexpected(), this.parseClass(r, true);
                  case 69:
                    return this.parseIfStatement(r);
                  case 70:
                    return this.parseReturnStatement(r);
                  case 71:
                    return this.parseSwitchStatement(r);
                  case 72:
                    return this.parseThrowStatement(r);
                  case 73:
                    return this.parseTryStatement(r);
                  case 75:
                  case 74:
                    return i = i || this.state.value, t3 && i !== "var" && this.raise(u.UnexpectedLexicalDeclaration, { at: this.state.startLoc }), this.parseVarStatement(r, i);
                  case 92:
                    return this.parseWhileStatement(r);
                  case 76:
                    return this.parseWithStatement(r);
                  case 5:
                    return this.parseBlock();
                  case 13:
                    return this.parseEmptyStatement(r);
                  case 83: {
                    let o = this.lookaheadCharCode();
                    if (o === 40 || o === 46)
                      break;
                  }
                  case 82: {
                    !this.options.allowImportExportEverywhere && !e && this.raise(u.UnexpectedImportExport, { at: this.state.startLoc }), this.next();
                    let o;
                    return s === 83 ? (o = this.parseImport(r), o.type === "ImportDeclaration" && (!o.importKind || o.importKind === "value") && (this.sawUnambiguousESM = true)) : (o = this.parseExport(r), (o.type === "ExportNamedDeclaration" && (!o.exportKind || o.exportKind === "value") || o.type === "ExportAllDeclaration" && (!o.exportKind || o.exportKind === "value") || o.type === "ExportDefaultDeclaration") && (this.sawUnambiguousESM = true)), this.assertModuleNodeAllowed(r), o;
                  }
                  default:
                    if (this.isAsyncFunction())
                      return t3 && this.raise(u.AsyncFunctionInSingleStatementContext, { at: this.state.startLoc }), this.next(), this.parseFunctionStatement(r, true, !t3);
                }
                let a = this.state.value, n = this.parseExpression();
                return K(s) && n.type === "Identifier" && this.eat(14) ? this.parseLabeledStatement(r, a, n, t3) : this.parseExpressionStatement(r, n);
              }
              assertModuleNodeAllowed(t3) {
                !this.options.allowImportExportEverywhere && !this.inModule && this.raise(u.ImportOutsideModule, { at: t3 });
              }
              takeDecorators(t3) {
                let e = this.state.decoratorStack[this.state.decoratorStack.length - 1];
                e.length && (t3.decorators = e, this.resetStartLocationFromNode(t3, e[0]), this.state.decoratorStack[this.state.decoratorStack.length - 1] = []);
              }
              canHaveLeadingDecorator() {
                return this.match(80);
              }
              parseDecorators(t3) {
                let e = this.state.decoratorStack[this.state.decoratorStack.length - 1];
                for (; this.match(26); ) {
                  let s = this.parseDecorator();
                  e.push(s);
                }
                if (this.match(82))
                  t3 || this.unexpected(), this.hasPlugin("decorators") && !this.getPluginOption("decorators", "decoratorsBeforeExport") && this.raise(u.DecoratorExportClass, { at: this.state.startLoc });
                else if (!this.canHaveLeadingDecorator())
                  throw this.raise(u.UnexpectedLeadingDecorator, { at: this.state.startLoc });
              }
              parseDecorator() {
                this.expectOnePlugin(["decorators-legacy", "decorators"]);
                let t3 = this.startNode();
                if (this.next(), this.hasPlugin("decorators")) {
                  this.state.decoratorStack.push([]);
                  let e = this.state.start, s = this.state.startLoc, r;
                  if (this.match(10)) {
                    let i = this.state.start, a = this.state.startLoc;
                    this.next(), r = this.parseExpression(), this.expect(11), r = this.wrapParenthesis(i, a, r);
                  } else
                    for (r = this.parseIdentifier(false); this.eat(16); ) {
                      let i = this.startNodeAt(e, s);
                      i.object = r, i.property = this.parseIdentifier(true), i.computed = false, r = this.finishNode(i, "MemberExpression");
                    }
                  t3.expression = this.parseMaybeDecoratorArguments(r), this.state.decoratorStack.pop();
                } else
                  t3.expression = this.parseExprSubscripts();
                return this.finishNode(t3, "Decorator");
              }
              parseMaybeDecoratorArguments(t3) {
                if (this.eat(10)) {
                  let e = this.startNodeAtNode(t3);
                  return e.callee = t3, e.arguments = this.parseCallExpressionArguments(11, false), this.toReferencedList(e.arguments), this.finishNode(e, "CallExpression");
                }
                return t3;
              }
              parseBreakContinueStatement(t3, e) {
                return this.next(), this.isLineTerminator() ? t3.label = null : (t3.label = this.parseIdentifier(), this.semicolon()), this.verifyBreakContinue(t3, e), this.finishNode(t3, e ? "BreakStatement" : "ContinueStatement");
              }
              verifyBreakContinue(t3, e) {
                let s;
                for (s = 0; s < this.state.labels.length; ++s) {
                  let r = this.state.labels[s];
                  if ((t3.label == null || r.name === t3.label.name) && (r.kind != null && (e || r.kind === "loop") || t3.label && e))
                    break;
                }
                if (s === this.state.labels.length) {
                  let r = e ? "BreakStatement" : "ContinueStatement";
                  this.raise(u.IllegalBreakContinue, { at: t3, type: r });
                }
              }
              parseDebuggerStatement(t3) {
                return this.next(), this.semicolon(), this.finishNode(t3, "DebuggerStatement");
              }
              parseHeaderExpression() {
                this.expect(10);
                let t3 = this.parseExpression();
                return this.expect(11), t3;
              }
              parseDoStatement(t3) {
                return this.next(), this.state.labels.push(ps), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("do")), this.state.labels.pop(), this.expect(92), t3.test = this.parseHeaderExpression(), this.eat(13), this.finishNode(t3, "DoWhileStatement");
              }
              parseForStatement(t3) {
                this.next(), this.state.labels.push(ps);
                let e = null;
                if (this.isAwaitAllowed() && this.eatContextual(96) && (e = this.state.lastTokStartLoc), this.scope.enter(Me), this.expect(10), this.match(13))
                  return e !== null && this.unexpected(e), this.parseFor(t3, null);
                let s = this.isContextual(99), r = s && this.isLetKeyword();
                if (this.match(74) || this.match(75) || r) {
                  let c = this.startNode(), f = r ? "let" : this.state.value;
                  return this.next(), this.parseVar(c, true, f), this.finishNode(c, "VariableDeclaration"), (this.match(58) || this.isContextual(101)) && c.declarations.length === 1 ? this.parseForIn(t3, c, e) : (e !== null && this.unexpected(e), this.parseFor(t3, c));
                }
                let i = this.isContextual(95), a = new At(), n = this.parseExpression(true, a), o = this.isContextual(101);
                if (o && (s && this.raise(u.ForOfLet, { at: n }), e === null && i && n.type === "Identifier" && this.raise(u.ForOfAsync, { at: n })), o || this.match(58)) {
                  this.checkDestructuringPrivate(a), this.toAssignable(n, true);
                  let c = o ? "ForOfStatement" : "ForInStatement";
                  return this.checkLVal(n, { in: { type: c } }), this.parseForIn(t3, n, e);
                } else
                  this.checkExpressionErrors(a, true);
                return e !== null && this.unexpected(e), this.parseFor(t3, n);
              }
              parseFunctionStatement(t3, e, s) {
                return this.next(), this.parseFunction(t3, fs | (s ? 0 : Hr), e);
              }
              parseIfStatement(t3) {
                return this.next(), t3.test = this.parseHeaderExpression(), t3.consequent = this.parseStatement("if"), t3.alternate = this.eat(66) ? this.parseStatement("if") : null, this.finishNode(t3, "IfStatement");
              }
              parseReturnStatement(t3) {
                return !this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction && this.raise(u.IllegalReturn, { at: this.state.startLoc }), this.next(), this.isLineTerminator() ? t3.argument = null : (t3.argument = this.parseExpression(), this.semicolon()), this.finishNode(t3, "ReturnStatement");
              }
              parseSwitchStatement(t3) {
                this.next(), t3.discriminant = this.parseHeaderExpression();
                let e = t3.cases = [];
                this.expect(5), this.state.labels.push($h), this.scope.enter(Me);
                let s;
                for (let r; !this.match(8); )
                  if (this.match(61) || this.match(65)) {
                    let i = this.match(61);
                    s && this.finishNode(s, "SwitchCase"), e.push(s = this.startNode()), s.consequent = [], this.next(), i ? s.test = this.parseExpression() : (r && this.raise(u.MultipleDefaultsInSwitch, { at: this.state.lastTokStartLoc }), r = true, s.test = null), this.expect(14);
                  } else
                    s ? s.consequent.push(this.parseStatement(null)) : this.unexpected();
                return this.scope.exit(), s && this.finishNode(s, "SwitchCase"), this.next(), this.state.labels.pop(), this.finishNode(t3, "SwitchStatement");
              }
              parseThrowStatement(t3) {
                return this.next(), this.hasPrecedingLineBreak() && this.raise(u.NewlineAfterThrow, { at: this.state.lastTokEndLoc }), t3.argument = this.parseExpression(), this.semicolon(), this.finishNode(t3, "ThrowStatement");
              }
              parseCatchClauseParam() {
                let t3 = this.parseBindingAtom(), e = t3.type === "Identifier";
                return this.scope.enter(e ? yr : 0), this.checkLVal(t3, { in: { type: "CatchClause" }, binding: xe, allowingSloppyLetBinding: true }), t3;
              }
              parseTryStatement(t3) {
                if (this.next(), t3.block = this.parseBlock(), t3.handler = null, this.match(62)) {
                  let e = this.startNode();
                  this.next(), this.match(10) ? (this.expect(10), e.param = this.parseCatchClauseParam(), this.expect(11)) : (e.param = null, this.scope.enter(Me)), e.body = this.withSmartMixTopicForbiddingContext(() => this.parseBlock(false, false)), this.scope.exit(), t3.handler = this.finishNode(e, "CatchClause");
                }
                return t3.finalizer = this.eat(67) ? this.parseBlock() : null, !t3.handler && !t3.finalizer && this.raise(u.NoCatchOrFinally, { at: t3 }), this.finishNode(t3, "TryStatement");
              }
              parseVarStatement(t3, e) {
                let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return this.next(), this.parseVar(t3, false, e, s), this.semicolon(), this.finishNode(t3, "VariableDeclaration");
              }
              parseWhileStatement(t3) {
                return this.next(), t3.test = this.parseHeaderExpression(), this.state.labels.push(ps), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("while")), this.state.labels.pop(), this.finishNode(t3, "WhileStatement");
              }
              parseWithStatement(t3) {
                return this.state.strict && this.raise(u.StrictWith, { at: this.state.startLoc }), this.next(), t3.object = this.parseHeaderExpression(), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("with")), this.finishNode(t3, "WithStatement");
              }
              parseEmptyStatement(t3) {
                return this.next(), this.finishNode(t3, "EmptyStatement");
              }
              parseLabeledStatement(t3, e, s, r) {
                for (let a of this.state.labels)
                  a.name === e && this.raise(u.LabelRedeclaration, { at: s, labelName: e });
                let i = No(this.state.type) ? "loop" : this.match(71) ? "switch" : null;
                for (let a = this.state.labels.length - 1; a >= 0; a--) {
                  let n = this.state.labels[a];
                  if (n.statementStart === t3.start)
                    n.statementStart = this.state.start, n.kind = i;
                  else
                    break;
                }
                return this.state.labels.push({ name: e, kind: i, statementStart: this.state.start }), t3.body = this.parseStatement(r ? r.indexOf("label") === -1 ? r + "label" : r : "label"), this.state.labels.pop(), t3.label = s, this.finishNode(t3, "LabeledStatement");
              }
              parseExpressionStatement(t3, e) {
                return t3.expression = e, this.semicolon(), this.finishNode(t3, "ExpressionStatement");
              }
              parseBlock() {
                let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, s = arguments.length > 2 ? arguments[2] : void 0, r = this.startNode();
                return t3 && this.state.strictErrors.clear(), this.expect(5), e && this.scope.enter(Me), this.parseBlockBody(r, t3, false, 8, s), e && this.scope.exit(), this.finishNode(r, "BlockStatement");
              }
              isValidDirective(t3) {
                return t3.type === "ExpressionStatement" && t3.expression.type === "StringLiteral" && !t3.expression.extra.parenthesized;
              }
              parseBlockBody(t3, e, s, r, i) {
                let a = t3.body = [], n = t3.directives = [];
                this.parseBlockOrModuleBlockBody(a, e ? n : void 0, s, r, i);
              }
              parseBlockOrModuleBlockBody(t3, e, s, r, i) {
                let a = this.state.strict, n = false, o = false;
                for (; !this.match(r); ) {
                  let c = this.parseStatement(null, s);
                  if (e && !o) {
                    if (this.isValidDirective(c)) {
                      let f = this.stmtToDirective(c);
                      e.push(f), !n && f.value.value === "use strict" && (n = true, this.setStrict(true));
                      continue;
                    }
                    o = true, this.state.strictErrors.clear();
                  }
                  t3.push(c);
                }
                i && i.call(this, n), a || this.setStrict(false), this.next();
              }
              parseFor(t3, e) {
                return t3.init = e, this.semicolon(false), t3.test = this.match(13) ? null : this.parseExpression(), this.semicolon(false), t3.update = this.match(11) ? null : this.parseExpression(), this.expect(11), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("for")), this.scope.exit(), this.state.labels.pop(), this.finishNode(t3, "ForStatement");
              }
              parseForIn(t3, e, s) {
                let r = this.match(58);
                return this.next(), r ? s !== null && this.unexpected(s) : t3.await = s !== null, e.type === "VariableDeclaration" && e.declarations[0].init != null && (!r || this.state.strict || e.kind !== "var" || e.declarations[0].id.type !== "Identifier") && this.raise(u.ForInOfLoopInitializer, { at: e, type: r ? "ForInStatement" : "ForOfStatement" }), e.type === "AssignmentPattern" && this.raise(u.InvalidLhs, { at: e, ancestor: { type: "ForStatement" } }), t3.left = e, t3.right = r ? this.parseExpression() : this.parseMaybeAssignAllowIn(), this.expect(11), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement("for")), this.scope.exit(), this.state.labels.pop(), this.finishNode(t3, r ? "ForInStatement" : "ForOfStatement");
              }
              parseVar(t3, e, s) {
                let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, i = t3.declarations = [];
                for (t3.kind = s; ; ) {
                  let a = this.startNode();
                  if (this.parseVarId(a, s), a.init = this.eat(29) ? e ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn() : null, a.init === null && !r && (a.id.type !== "Identifier" && !(e && (this.match(58) || this.isContextual(101))) ? this.raise(u.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "destructuring" }) : s === "const" && !(this.match(58) || this.isContextual(101)) && this.raise(u.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "const" })), i.push(this.finishNode(a, "VariableDeclarator")), !this.eat(12))
                    break;
                }
                return t3;
              }
              parseVarId(t3, e) {
                t3.id = this.parseBindingAtom(), this.checkLVal(t3.id, { in: { type: "VariableDeclarator" }, binding: e === "var" ? pt : xe });
              }
              parseFunction(t3) {
                let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Qh, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r = e & fs, i = e & Hr, a = !!r && !(e & Wr);
                this.initFunction(t3, s), this.match(55) && i && this.raise(u.GeneratorInSingleStatementContext, { at: this.state.startLoc }), t3.generator = this.eat(55), r && (t3.id = this.parseFunctionId(a));
                let n = this.state.maybeInArrowParameters;
                return this.state.maybeInArrowParameters = false, this.scope.enter(me), this.prodParam.enter(gt2(s, t3.generator)), r || (t3.id = this.parseFunctionId()), this.parseFunctionParams(t3, false), this.withSmartMixTopicForbiddingContext(() => {
                  this.parseFunctionBodyAndFinish(t3, r ? "FunctionDeclaration" : "FunctionExpression");
                }), this.prodParam.exit(), this.scope.exit(), r && !i && this.registerFunctionStatementId(t3), this.state.maybeInArrowParameters = n, t3;
              }
              parseFunctionId(t3) {
                return t3 || K(this.state.type) ? this.parseIdentifier() : null;
              }
              parseFunctionParams(t3, e) {
                this.expect(10), this.expressionScope.enter(gh()), t3.params = this.parseBindingList(11, 41, false, e), this.expressionScope.exit();
              }
              registerFunctionStatementId(t3) {
                !t3.id || this.scope.declareName(t3.id.name, this.state.strict || t3.generator || t3.async ? this.scope.treatFunctionsAsVar ? pt : xe : Tr, t3.id.loc.start);
              }
              parseClass(t3, e, s) {
                this.next(), this.takeDecorators(t3);
                let r = this.state.strict;
                return this.state.strict = true, this.parseClassId(t3, e, s), this.parseClassSuper(t3), t3.body = this.parseClassBody(!!t3.superClass, r), this.finishNode(t3, e ? "ClassDeclaration" : "ClassExpression");
              }
              isClassProperty() {
                return this.match(29) || this.match(13) || this.match(8);
              }
              isClassMethod() {
                return this.match(10);
              }
              isNonstaticConstructor(t3) {
                return !t3.computed && !t3.static && (t3.key.name === "constructor" || t3.key.value === "constructor");
              }
              parseClassBody(t3, e) {
                this.classScope.enter();
                let s = { hadConstructor: false, hadSuperClass: t3 }, r = [], i = this.startNode();
                if (i.body = [], this.expect(5), this.withSmartMixTopicForbiddingContext(() => {
                  for (; !this.match(8); ) {
                    if (this.eat(13)) {
                      if (r.length > 0)
                        throw this.raise(u.DecoratorSemicolon, { at: this.state.lastTokEndLoc });
                      continue;
                    }
                    if (this.match(26)) {
                      r.push(this.parseDecorator());
                      continue;
                    }
                    let a = this.startNode();
                    r.length && (a.decorators = r, this.resetStartLocationFromNode(a, r[0]), r = []), this.parseClassMember(i, a, s), a.kind === "constructor" && a.decorators && a.decorators.length > 0 && this.raise(u.DecoratorConstructor, { at: a });
                  }
                }), this.state.strict = e, this.next(), r.length)
                  throw this.raise(u.TrailingDecorator, { at: this.state.startLoc });
                return this.classScope.exit(), this.finishNode(i, "ClassBody");
              }
              parseClassMemberFromModifier(t3, e) {
                let s = this.parseIdentifier(true);
                if (this.isClassMethod()) {
                  let r = e;
                  return r.kind = "method", r.computed = false, r.key = s, r.static = false, this.pushClassMethod(t3, r, false, false, false, false), true;
                } else if (this.isClassProperty()) {
                  let r = e;
                  return r.computed = false, r.key = s, r.static = false, t3.body.push(this.parseClassProperty(r)), true;
                }
                return this.resetPreviousNodeTrailingComments(s), false;
              }
              parseClassMember(t3, e, s) {
                let r = this.isContextual(104);
                if (r) {
                  if (this.parseClassMemberFromModifier(t3, e))
                    return;
                  if (this.eat(5)) {
                    this.parseClassStaticBlock(t3, e);
                    return;
                  }
                }
                this.parseClassMemberWithIsStatic(t3, e, s, r);
              }
              parseClassMemberWithIsStatic(t3, e, s, r) {
                let i = e, a = e, n = e, o = e, c = e, f = i, y = i;
                if (e.static = r, this.parsePropertyNamePrefixOperator(e), this.eat(55)) {
                  f.kind = "method";
                  let _ = this.match(134);
                  if (this.parseClassElementName(f), _) {
                    this.pushClassPrivateMethod(t3, a, true, false);
                    return;
                  }
                  this.isNonstaticConstructor(i) && this.raise(u.ConstructorIsGenerator, { at: i.key }), this.pushClassMethod(t3, i, true, false, false, false);
                  return;
                }
                let P = K(this.state.type) && !this.state.containsEsc, v = this.match(134), N = this.parseClassElementName(e), B = this.state.startLoc;
                if (this.parsePostMemberNameModifiers(y), this.isClassMethod()) {
                  if (f.kind = "method", v) {
                    this.pushClassPrivateMethod(t3, a, false, false);
                    return;
                  }
                  let _ = this.isNonstaticConstructor(i), Q = false;
                  _ && (i.kind = "constructor", s.hadConstructor && !this.hasPlugin("typescript") && this.raise(u.DuplicateConstructor, { at: N }), _ && this.hasPlugin("typescript") && e.override && this.raise(u.OverrideOnConstructor, { at: N }), s.hadConstructor = true, Q = s.hadSuperClass), this.pushClassMethod(t3, i, false, false, _, Q);
                } else if (this.isClassProperty())
                  v ? this.pushClassPrivateProperty(t3, o) : this.pushClassProperty(t3, n);
                else if (P && N.name === "async" && !this.isLineTerminator()) {
                  this.resetPreviousNodeTrailingComments(N);
                  let _ = this.eat(55);
                  y.optional && this.unexpected(B), f.kind = "method";
                  let Q = this.match(134);
                  this.parseClassElementName(f), this.parsePostMemberNameModifiers(y), Q ? this.pushClassPrivateMethod(t3, a, _, true) : (this.isNonstaticConstructor(i) && this.raise(u.ConstructorIsAsync, { at: i.key }), this.pushClassMethod(t3, i, _, true, false, false));
                } else if (P && (N.name === "get" || N.name === "set") && !(this.match(55) && this.isLineTerminator())) {
                  this.resetPreviousNodeTrailingComments(N), f.kind = N.name;
                  let _ = this.match(134);
                  this.parseClassElementName(i), _ ? this.pushClassPrivateMethod(t3, a, false, false) : (this.isNonstaticConstructor(i) && this.raise(u.ConstructorIsAccessor, { at: i.key }), this.pushClassMethod(t3, i, false, false, false, false)), this.checkGetterSetterParams(i);
                } else if (P && N.name === "accessor" && !this.isLineTerminator()) {
                  this.expectPlugin("decoratorAutoAccessors"), this.resetPreviousNodeTrailingComments(N);
                  let _ = this.match(134);
                  this.parseClassElementName(n), this.pushClassAccessorProperty(t3, c, _);
                } else
                  this.isLineTerminator() ? v ? this.pushClassPrivateProperty(t3, o) : this.pushClassProperty(t3, n) : this.unexpected();
              }
              parseClassElementName(t3) {
                let { type: e, value: s } = this.state;
                if ((e === 128 || e === 129) && t3.static && s === "prototype" && this.raise(u.StaticPrototype, { at: this.state.startLoc }), e === 134) {
                  s === "constructor" && this.raise(u.ConstructorClassPrivateField, { at: this.state.startLoc });
                  let r = this.parsePrivateName();
                  return t3.key = r, r;
                }
                return this.parsePropertyName(t3);
              }
              parseClassStaticBlock(t3, e) {
                var s;
                this.scope.enter(Se | Yt | ot);
                let r = this.state.labels;
                this.state.labels = [], this.prodParam.enter(je);
                let i = e.body = [];
                this.parseBlockOrModuleBlockBody(i, void 0, false, 8), this.prodParam.exit(), this.scope.exit(), this.state.labels = r, t3.body.push(this.finishNode(e, "StaticBlock")), (s = e.decorators) != null && s.length && this.raise(u.DecoratorStaticBlock, { at: e });
              }
              pushClassProperty(t3, e) {
                !e.computed && (e.key.name === "constructor" || e.key.value === "constructor") && this.raise(u.ConstructorClassField, { at: e.key }), t3.body.push(this.parseClassProperty(e));
              }
              pushClassPrivateProperty(t3, e) {
                let s = this.parseClassPrivateProperty(e);
                t3.body.push(s), this.classScope.declarePrivateName(this.getPrivateNameSV(s.key), is, s.key.loc.start);
              }
              pushClassAccessorProperty(t3, e, s) {
                if (!s && !e.computed) {
                  let i = e.key;
                  (i.name === "constructor" || i.value === "constructor") && this.raise(u.ConstructorClassField, { at: i });
                }
                let r = this.parseClassAccessorProperty(e);
                t3.body.push(r), s && this.classScope.declarePrivateName(this.getPrivateNameSV(r.key), is, r.key.loc.start);
              }
              pushClassMethod(t3, e, s, r, i, a) {
                t3.body.push(this.parseMethod(e, s, r, i, a, "ClassMethod", true));
              }
              pushClassPrivateMethod(t3, e, s, r) {
                let i = this.parseMethod(e, s, r, false, false, "ClassPrivateMethod", true);
                t3.body.push(i);
                let a = i.kind === "get" ? i.static ? Qo : eh : i.kind === "set" ? i.static ? Zo : th : is;
                this.declareClassPrivateMethodInScope(i, a);
              }
              declareClassPrivateMethodInScope(t3, e) {
                this.classScope.declarePrivateName(this.getPrivateNameSV(t3.key), e, t3.key.loc.start);
              }
              parsePostMemberNameModifiers(t3) {
              }
              parseClassPrivateProperty(t3) {
                return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassPrivateProperty");
              }
              parseClassProperty(t3) {
                return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassProperty");
              }
              parseClassAccessorProperty(t3) {
                return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassAccessorProperty");
              }
              parseInitializer(t3) {
                this.scope.enter(Se | ot), this.expressionScope.enter(Dr()), this.prodParam.enter(je), t3.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null, this.expressionScope.exit(), this.prodParam.exit(), this.scope.exit();
              }
              parseClassId(t3, e, s) {
                let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Pr;
                if (K(this.state.type))
                  t3.id = this.parseIdentifier(), e && this.declareNameFromIdentifier(t3.id, r);
                else if (s || !e)
                  t3.id = null;
                else
                  throw this.raise(u.MissingClassName, { at: this.state.startLoc });
              }
              parseClassSuper(t3) {
                t3.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
              }
              parseExport(t3) {
                let e = this.maybeParseExportDefaultSpecifier(t3), s = !e || this.eat(12), r = s && this.eatExportStar(t3), i = r && this.maybeParseExportNamespaceSpecifier(t3), a = s && (!i || this.eat(12)), n = e || r;
                if (r && !i)
                  return e && this.unexpected(), this.parseExportFrom(t3, true), this.finishNode(t3, "ExportAllDeclaration");
                let o = this.maybeParseExportNamedSpecifiers(t3);
                if (e && s && !r && !o || i && a && !o)
                  throw this.unexpected(null, 5);
                let c;
                if (n || o ? (c = false, this.parseExportFrom(t3, n)) : c = this.maybeParseExportDeclaration(t3), n || o || c)
                  return this.checkExport(t3, true, false, !!t3.source), this.finishNode(t3, "ExportNamedDeclaration");
                if (this.eat(65))
                  return t3.declaration = this.parseExportDefaultExpression(), this.checkExport(t3, true, true), this.finishNode(t3, "ExportDefaultDeclaration");
                throw this.unexpected(null, 5);
              }
              eatExportStar(t3) {
                return this.eat(55);
              }
              maybeParseExportDefaultSpecifier(t3) {
                if (this.isExportDefaultSpecifier()) {
                  this.expectPlugin("exportDefaultFrom");
                  let e = this.startNode();
                  return e.exported = this.parseIdentifier(true), t3.specifiers = [this.finishNode(e, "ExportDefaultSpecifier")], true;
                }
                return false;
              }
              maybeParseExportNamespaceSpecifier(t3) {
                if (this.isContextual(93)) {
                  t3.specifiers || (t3.specifiers = []);
                  let e = this.startNodeAt(this.state.lastTokStart, this.state.lastTokStartLoc);
                  return this.next(), e.exported = this.parseModuleExportName(), t3.specifiers.push(this.finishNode(e, "ExportNamespaceSpecifier")), true;
                }
                return false;
              }
              maybeParseExportNamedSpecifiers(t3) {
                if (this.match(5)) {
                  t3.specifiers || (t3.specifiers = []);
                  let e = t3.exportKind === "type";
                  return t3.specifiers.push(...this.parseExportSpecifiers(e)), t3.source = null, t3.declaration = null, this.hasPlugin("importAssertions") && (t3.assertions = []), true;
                }
                return false;
              }
              maybeParseExportDeclaration(t3) {
                return this.shouldParseExportDeclaration() ? (t3.specifiers = [], t3.source = null, this.hasPlugin("importAssertions") && (t3.assertions = []), t3.declaration = this.parseExportDeclaration(t3), true) : false;
              }
              isAsyncFunction() {
                if (!this.isContextual(95))
                  return false;
                let t3 = this.nextTokenStart();
                return !as.test(this.input.slice(this.state.pos, t3)) && this.isUnparsedContextual(t3, "function");
              }
              parseExportDefaultExpression() {
                let t3 = this.startNode(), e = this.isAsyncFunction();
                if (this.match(68) || e)
                  return this.next(), e && this.next(), this.parseFunction(t3, fs | Wr, e);
                if (this.match(80))
                  return this.parseClass(t3, true, true);
                if (this.match(26))
                  return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") && this.raise(u.DecoratorBeforeExport, { at: this.state.startLoc }), this.parseDecorators(false), this.parseClass(t3, true, true);
                if (this.match(75) || this.match(74) || this.isLet())
                  throw this.raise(u.UnsupportedDefaultExport, { at: this.state.startLoc });
                let s = this.parseMaybeAssignAllowIn();
                return this.semicolon(), s;
              }
              parseExportDeclaration(t3) {
                return this.parseStatement(null);
              }
              isExportDefaultSpecifier() {
                let { type: t3 } = this.state;
                if (K(t3)) {
                  if (t3 === 95 && !this.state.containsEsc || t3 === 99)
                    return false;
                  if ((t3 === 126 || t3 === 125) && !this.state.containsEsc) {
                    let { type: r } = this.lookahead();
                    if (K(r) && r !== 97 || r === 5)
                      return this.expectOnePlugin(["flow", "typescript"]), false;
                  }
                } else if (!this.match(65))
                  return false;
                let e = this.nextTokenStart(), s = this.isUnparsedContextual(e, "from");
                if (this.input.charCodeAt(e) === 44 || K(this.state.type) && s)
                  return true;
                if (this.match(65) && s) {
                  let r = this.input.charCodeAt(this.nextTokenStartSince(e + 4));
                  return r === 34 || r === 39;
                }
                return false;
              }
              parseExportFrom(t3, e) {
                if (this.eatContextual(97)) {
                  t3.source = this.parseImportSource(), this.checkExport(t3);
                  let s = this.maybeParseImportAssertions();
                  s && (t3.assertions = s);
                } else
                  e && this.unexpected();
                this.semicolon();
              }
              shouldParseExportDeclaration() {
                let { type: t3 } = this.state;
                if (t3 === 26 && (this.expectOnePlugin(["decorators", "decorators-legacy"]), this.hasPlugin("decorators"))) {
                  if (this.getPluginOption("decorators", "decoratorsBeforeExport"))
                    throw this.raise(u.DecoratorBeforeExport, { at: this.state.startLoc });
                  return true;
                }
                return t3 === 74 || t3 === 75 || t3 === 68 || t3 === 80 || this.isLet() || this.isAsyncFunction();
              }
              checkExport(t3, e, s, r) {
                if (e) {
                  if (s) {
                    if (this.checkDuplicateExports(t3, "default"), this.hasPlugin("exportDefaultFrom")) {
                      var i;
                      let n = t3.declaration;
                      n.type === "Identifier" && n.name === "from" && n.end - n.start === 4 && !((i = n.extra) != null && i.parenthesized) && this.raise(u.ExportDefaultFromAsIdentifier, { at: n });
                    }
                  } else if (t3.specifiers && t3.specifiers.length)
                    for (let n of t3.specifiers) {
                      let { exported: o } = n, c = o.type === "Identifier" ? o.name : o.value;
                      if (this.checkDuplicateExports(n, c), !r && n.local) {
                        let { local: f } = n;
                        f.type !== "Identifier" ? this.raise(u.ExportBindingIsString, { at: n, localName: f.value, exportName: c }) : (this.checkReservedWord(f.name, f.loc.start, true, false), this.scope.checkLocalExport(f));
                      }
                    }
                  else if (t3.declaration) {
                    if (t3.declaration.type === "FunctionDeclaration" || t3.declaration.type === "ClassDeclaration") {
                      let n = t3.declaration.id;
                      if (!n)
                        throw new Error("Assertion failure");
                      this.checkDuplicateExports(t3, n.name);
                    } else if (t3.declaration.type === "VariableDeclaration")
                      for (let n of t3.declaration.declarations)
                        this.checkDeclaration(n.id);
                  }
                }
                if (this.state.decoratorStack[this.state.decoratorStack.length - 1].length)
                  throw this.raise(u.UnsupportedDecoratorExport, { at: t3 });
              }
              checkDeclaration(t3) {
                if (t3.type === "Identifier")
                  this.checkDuplicateExports(t3, t3.name);
                else if (t3.type === "ObjectPattern")
                  for (let e of t3.properties)
                    this.checkDeclaration(e);
                else if (t3.type === "ArrayPattern")
                  for (let e of t3.elements)
                    e && this.checkDeclaration(e);
                else
                  t3.type === "ObjectProperty" ? this.checkDeclaration(t3.value) : t3.type === "RestElement" ? this.checkDeclaration(t3.argument) : t3.type === "AssignmentPattern" && this.checkDeclaration(t3.left);
              }
              checkDuplicateExports(t3, e) {
                this.exportedIdentifiers.has(e) && (e === "default" ? this.raise(u.DuplicateDefaultExport, { at: t3 }) : this.raise(u.DuplicateExport, { at: t3, exportName: e })), this.exportedIdentifiers.add(e);
              }
              parseExportSpecifiers(t3) {
                let e = [], s = true;
                for (this.expect(5); !this.eat(8); ) {
                  if (s)
                    s = false;
                  else if (this.expect(12), this.eat(8))
                    break;
                  let r = this.isContextual(126), i = this.match(129), a = this.startNode();
                  a.local = this.parseModuleExportName(), e.push(this.parseExportSpecifier(a, i, t3, r));
                }
                return e;
              }
              parseExportSpecifier(t3, e, s, r) {
                return this.eatContextual(93) ? t3.exported = this.parseModuleExportName() : e ? t3.exported = bh(t3.local) : t3.exported || (t3.exported = ge(t3.local)), this.finishNode(t3, "ExportSpecifier");
              }
              parseModuleExportName() {
                if (this.match(129)) {
                  let t3 = this.parseStringLiteral(this.state.value), e = t3.value.match(Zh);
                  return e && this.raise(u.ModuleExportNameHasLoneSurrogate, { at: t3, surrogateCharCode: e[0].charCodeAt(0) }), t3;
                }
                return this.parseIdentifier(true);
              }
              parseImport(t3) {
                if (t3.specifiers = [], !this.match(129)) {
                  let r = !this.maybeParseDefaultImportSpecifier(t3) || this.eat(12), i = r && this.maybeParseStarImportSpecifier(t3);
                  r && !i && this.parseNamedImportSpecifiers(t3), this.expectContextual(97);
                }
                t3.source = this.parseImportSource();
                let e = this.maybeParseImportAssertions();
                if (e)
                  t3.assertions = e;
                else {
                  let s = this.maybeParseModuleAttributes();
                  s && (t3.attributes = s);
                }
                return this.semicolon(), this.finishNode(t3, "ImportDeclaration");
              }
              parseImportSource() {
                return this.match(129) || this.unexpected(), this.parseExprAtom();
              }
              shouldParseDefaultImport(t3) {
                return K(this.state.type);
              }
              parseImportSpecifierLocal(t3, e, s) {
                e.local = this.parseIdentifier(), t3.specifiers.push(this.finishImportSpecifier(e, s));
              }
              finishImportSpecifier(t3, e) {
                return this.checkLVal(t3.local, { in: t3, binding: xe }), this.finishNode(t3, e);
              }
              parseAssertEntries() {
                let t3 = [], e = /* @__PURE__ */ new Set();
                do {
                  if (this.match(8))
                    break;
                  let s = this.startNode(), r = this.state.value;
                  if (e.has(r) && this.raise(u.ModuleAttributesWithDuplicateKeys, { at: this.state.startLoc, key: r }), e.add(r), this.match(129) ? s.key = this.parseStringLiteral(r) : s.key = this.parseIdentifier(true), this.expect(14), !this.match(129))
                    throw this.raise(u.ModuleAttributeInvalidValue, { at: this.state.startLoc });
                  s.value = this.parseStringLiteral(this.state.value), this.finishNode(s, "ImportAttribute"), t3.push(s);
                } while (this.eat(12));
                return t3;
              }
              maybeParseModuleAttributes() {
                if (this.match(76) && !this.hasPrecedingLineBreak())
                  this.expectPlugin("moduleAttributes"), this.next();
                else
                  return this.hasPlugin("moduleAttributes") ? [] : null;
                let t3 = [], e = /* @__PURE__ */ new Set();
                do {
                  let s = this.startNode();
                  if (s.key = this.parseIdentifier(true), s.key.name !== "type" && this.raise(u.ModuleAttributeDifferentFromType, { at: s.key }), e.has(s.key.name) && this.raise(u.ModuleAttributesWithDuplicateKeys, { at: s.key, key: s.key.name }), e.add(s.key.name), this.expect(14), !this.match(129))
                    throw this.raise(u.ModuleAttributeInvalidValue, { at: this.state.startLoc });
                  s.value = this.parseStringLiteral(this.state.value), this.finishNode(s, "ImportAttribute"), t3.push(s);
                } while (this.eat(12));
                return t3;
              }
              maybeParseImportAssertions() {
                if (this.isContextual(94) && !this.hasPrecedingLineBreak())
                  this.expectPlugin("importAssertions"), this.next();
                else
                  return this.hasPlugin("importAssertions") ? [] : null;
                this.eat(5);
                let t3 = this.parseAssertEntries();
                return this.eat(8), t3;
              }
              maybeParseDefaultImportSpecifier(t3) {
                return this.shouldParseDefaultImport(t3) ? (this.parseImportSpecifierLocal(t3, this.startNode(), "ImportDefaultSpecifier"), true) : false;
              }
              maybeParseStarImportSpecifier(t3) {
                if (this.match(55)) {
                  let e = this.startNode();
                  return this.next(), this.expectContextual(93), this.parseImportSpecifierLocal(t3, e, "ImportNamespaceSpecifier"), true;
                }
                return false;
              }
              parseNamedImportSpecifiers(t3) {
                let e = true;
                for (this.expect(5); !this.eat(8); ) {
                  if (e)
                    e = false;
                  else {
                    if (this.eat(14))
                      throw this.raise(u.DestructureNamedImport, { at: this.state.startLoc });
                    if (this.expect(12), this.eat(8))
                      break;
                  }
                  let s = this.startNode(), r = this.match(129), i = this.isContextual(126);
                  s.imported = this.parseModuleExportName();
                  let a = this.parseImportSpecifier(s, r, t3.importKind === "type" || t3.importKind === "typeof", i);
                  t3.specifiers.push(a);
                }
              }
              parseImportSpecifier(t3, e, s, r) {
                if (this.eatContextual(93))
                  t3.local = this.parseIdentifier();
                else {
                  let { imported: i } = t3;
                  if (e)
                    throw this.raise(u.ImportBindingIsString, { at: t3, importName: i.value });
                  this.checkReservedWord(i.name, t3.loc.start, true, true), t3.local || (t3.local = ge(i));
                }
                return this.finishImportSpecifier(t3, "ImportSpecifier");
              }
              isThisParam(t3) {
                return t3.type === "Identifier" && t3.name === "this";
              }
            }, Gr = class extends tl {
              constructor(t3, e) {
                t3 = Gh(t3), super(t3, e), this.options = t3, this.initializeScopes(), this.plugins = sl(this.options.plugins), this.filename = t3.sourceFilename;
              }
              getScopeHandler() {
                return hs;
              }
              parse() {
                this.enterInitialScopes();
                let t3 = this.startNode(), e = this.startNode();
                return this.nextToken(), t3.errors = null, this.parseTopLevel(t3, e), t3.errors = this.state.errors, t3;
              }
            };
            function sl(t3) {
              let e = /* @__PURE__ */ new Map();
              for (let s of t3) {
                let [r, i] = Array.isArray(s) ? s : [s, {}];
                e.has(r) || e.set(r, i || {});
              }
              return e;
            }
            function rl(t3, e) {
              var s;
              if (((s = e) == null ? void 0 : s.sourceType) === "unambiguous") {
                e = Object.assign({}, e);
                try {
                  e.sourceType = "module";
                  let r = Ye(e, t3), i = r.parse();
                  if (r.sawUnambiguousESM)
                    return i;
                  if (r.ambiguousScriptDifferentAst)
                    try {
                      return e.sourceType = "script", Ye(e, t3).parse();
                    } catch {
                    }
                  else
                    i.program.sourceType = "script";
                  return i;
                } catch (r) {
                  try {
                    return e.sourceType = "script", Ye(e, t3).parse();
                  } catch {
                  }
                  throw r;
                }
              } else
                return Ye(e, t3).parse();
            }
            function il(t3, e) {
              let s = Ye(e, t3);
              return s.options.strictMode && (s.state.strict = true), s.getExpression();
            }
            function al(t3) {
              let e = {};
              for (let s of Object.keys(t3))
                e[s] = fe(t3[s]);
              return e;
            }
            var nl = al(bo);
            function Ye(t3, e) {
              let s = Gr;
              return t3 != null && t3.plugins && (Hh(t3.plugins), s = ol(t3.plugins)), new s(t3, e);
            }
            var Xr = {};
            function ol(t3) {
              let e = Wh.filter((i) => ee(t3, i)), s = e.join("/"), r = Xr[s];
              if (!r) {
                r = Gr;
                for (let i of e)
                  r = zr[i](r);
                Xr[s] = r;
              }
              return r;
            }
            h.parse = rl, h.parseExpression = il, h.tokTypes = nl;
          } }), Pf = H({ "src/language-js/parse/json.js"(h, l) {
            "use strict";
            V();
            var p = fo(), d = nr(), m = yo(), A = xo();
            function g() {
              let E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { allowComments: L = true } = E;
              return function(F) {
                let { parseExpression: W } = Po(), Y;
                try {
                  Y = W(F, { tokens: true, ranges: true });
                } catch (M) {
                  throw A(M);
                }
                if (!L && p(Y.comments))
                  throw x(Y.comments[0], "Comment");
                return T(Y), Y;
              };
            }
            function x(E, L) {
              let [R, F] = [E.loc.start, E.loc.end].map((W) => {
                let { line: Y, column: M } = W;
                return { line: Y, column: M + 1 };
              });
              return d("".concat(L, " is not allowed in JSON."), { start: R, end: F });
            }
            function T(E) {
              switch (E.type) {
                case "ArrayExpression":
                  for (let L of E.elements)
                    L !== null && T(L);
                  return;
                case "ObjectExpression":
                  for (let L of E.properties)
                    T(L);
                  return;
                case "ObjectProperty":
                  if (E.computed)
                    throw x(E.key, "Computed key");
                  if (E.shorthand)
                    throw x(E.key, "Shorthand property");
                  E.key.type !== "Identifier" && T(E.key), T(E.value);
                  return;
                case "UnaryExpression": {
                  let { operator: L, argument: R } = E;
                  if (L !== "+" && L !== "-")
                    throw x(E, "Operator '".concat(E.operator, "'"));
                  if (R.type === "NumericLiteral" || R.type === "Identifier" && (R.name === "Infinity" || R.name === "NaN"))
                    return;
                  throw x(R, "Operator '".concat(L, "' before '").concat(R.type, "'"));
                }
                case "Identifier":
                  if (E.name !== "Infinity" && E.name !== "NaN" && E.name !== "undefined")
                    throw x(E, "Identifier '".concat(E.name, "'"));
                  return;
                case "TemplateLiteral":
                  if (p(E.expressions))
                    throw x(E.expressions[0], "'TemplateLiteral' with expression");
                  for (let L of E.quasis)
                    T(L);
                  return;
                case "NullLiteral":
                case "BooleanLiteral":
                case "NumericLiteral":
                case "StringLiteral":
                case "TemplateElement":
                  return;
                default:
                  throw x(E, "'".concat(E.type, "'"));
              }
            }
            var k = g(), D = { json: m({ parse: k, hasPragma() {
              return true;
            } }), json5: m(k), "json-stringify": m({ parse: g({ allowComments: false }), astFormat: "estree-json" }) };
            l.exports = D;
          } });
          V();
          var Tf = ef(), Ef = Qn(), Cf = af(), ze = yo(), bf = xo(), vf = Af(), Sf = Pf(), wf = { sourceType: "module", allowImportExportEverywhere: true, allowReturnOutsideFunction: true, allowSuperOutsideMethod: true, allowUndeclaredExports: true, errorRecovery: true, createParenthesizedExpressions: true, plugins: ["doExpressions", "exportDefaultFrom", "functionBind", "functionSent", "throwExpressions", "partialApplication", ["decorators", { decoratorsBeforeExport: false }], "importAssertions", "decimal", "moduleBlocks", "asyncDoExpressions", "regexpUnicodeSets", "destructuringPrivate", "decoratorAutoAccessors"], tokens: true, ranges: true }, Nf = ["recordAndTuple", { syntaxType: "hash" }], Wn = "v8intrinsic", Gn = [["pipelineOperator", { proposal: "hack", topicToken: "%" }], ["pipelineOperator", { proposal: "minimal" }], ["pipelineOperator", { proposal: "fsharp" }]], ue = function(h) {
            let l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : wf;
            return Object.assign(Object.assign({}, l), {}, { plugins: [...l.plugins, ...h] });
          }, If = /@(?:no)?flow\b/;
          function kf(h, l) {
            if (l.filepath && l.filepath.endsWith(".js.flow"))
              return true;
            let p = Ef(h);
            p && (h = h.slice(p.length));
            let d = Cf(h, 0);
            return d !== false && (h = h.slice(0, d)), If.test(h);
          }
          function Df(h, l, p) {
            let m = Po()[h](l, p), A = m.errors.find((g) => !Rf.has(g.reasonCode));
            if (A)
              throw A;
            return m;
          }
          function Ke(h) {
            for (var l = arguments.length, p = new Array(l > 1 ? l - 1 : 0), d = 1; d < l; d++)
              p[d - 1] = arguments[d];
            return function(m, A) {
              let g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              if ((g.parser === "babel" || g.parser === "__babel_estree") && kf(m, g))
                return g.parser = "babel-flow", To(m, A, g);
              let x = p;
              g.__babelSourceType === "script" && (x = x.map((E) => Object.assign(Object.assign({}, E), {}, { sourceType: "script" }))), /#[[{]/.test(m) && (x = x.map((E) => ue([Nf], E)));
              let T = /%[A-Z]/.test(m);
              m.includes("|>") ? x = (T ? [...Gn, Wn] : Gn).flatMap((L) => x.map((R) => ue([L], R))) : T && (x = x.map((E) => ue([Wn], E)));
              let { result: k, error: D } = Tf(...x.map((E) => () => Df(h, m, E)));
              if (!k)
                throw bf(D);
              return g.originalText = m, vf(k, g);
            };
          }
          var Ff = Ke("parse", ue(["jsx", "flow"])), To = Ke("parse", ue(["jsx", ["flow", { all: true, enums: true }]])), Lf = Ke("parse", ue(["jsx", "typescript"]), ue(["typescript"])), Of = Ke("parse", ue(["jsx", "flow", "estree"])), Bf = Ke("parseExpression", ue(["jsx"])), Mf = Ke("parseExpression", ue(["typescript"])), Rf = /* @__PURE__ */ new Set(["StrictNumericEscape", "StrictWith", "StrictOctalLiteral", "StrictDelete", "StrictEvalArguments", "StrictEvalArgumentsBinding", "StrictFunction", "EmptyTypeArguments", "EmptyTypeParameters", "ConstructorHasTypeParameters", "UnsupportedParameterPropertyKind", "UnexpectedParameterModifier", "MixedLabeledAndUnlabeledElements", "InvalidTupleMemberLabel", "NonClassMethodPropertyHasAbstractModifer", "ReadonlyForMethodSignature", "ClassMethodHasDeclare", "ClassMethodHasReadonly", "InvalidModifierOnTypeMember", "DuplicateAccessibilityModifier", "IndexSignatureHasDeclare", "DecoratorExportClass", "ParamDupe", "InvalidDecimal", "RestTrailingComma", "UnsupportedParameterDecorator", "UnterminatedJsxContent", "UnexpectedReservedWord", "ModuleAttributesWithDuplicateKeys", "LineTerminatorBeforeArrow", "InvalidEscapeSequenceTemplate", "NonAbstractClassHasAbstractMethod", "UnsupportedPropertyDecorator", "OptionalTypeBeforeRequired", "PatternIsOptional", "OptionalBindingPattern", "DeclareClassFieldHasInitializer", "TypeImportCannotSpecifyDefaultAndNamed", "DeclareFunctionHasImplementation", "ConstructorClassField", "VarRedeclaration", "InvalidPrivateFieldResolution", "DuplicateExport"]), Xn = ze(Ff), Jn = ze(Lf), Yn = ze(Bf), jf = ze(Mf);
          Eo.exports = { parsers: Object.assign(Object.assign({ babel: Xn, "babel-flow": ze(To), "babel-ts": Jn }, Sf), {}, { __js_expression: Yn, __vue_expression: Yn, __vue_ts_expression: jf, __vue_event_binding: Xn, __vue_ts_event_binding: Jn, __babel_estree: ze(Of) }) };
        });
        return qf();
      });
    }
  });

  // node_modules/prettier/parser-postcss.js
  var require_parser_postcss = __commonJS({
    "node_modules/prettier/parser-postcss.js"(exports2, module2) {
      init_define_process();
      (function(e) {
        if (typeof exports2 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var i = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          i.prettierPlugins = i.prettierPlugins || {}, i.prettierPlugins.postcss = e();
        }
      })(function() {
        "use strict";
        var V = (e, n) => () => (n || e((n = { exports: {} }).exports, n), n.exports);
        var ee = V((pp, Ut) => {
          var er = function(e) {
            return e && e.Math == Math && e;
          };
          Ut.exports = er(typeof globalThis == "object" && globalThis) || er(typeof window == "object" && window) || er(typeof self == "object" && self) || er(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var ke = V((hp, Wt) => {
          Wt.exports = function(e) {
            try {
              return !!e();
            } catch {
              return true;
            }
          };
        });
        var Te = V((dp, $t) => {
          var fa = ke();
          $t.exports = !fa(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var Sr = V((vp, Vt) => {
          var pa = ke();
          Vt.exports = !pa(function() {
            var e = function() {
            }.bind();
            return typeof e != "function" || e.hasOwnProperty("prototype");
          });
        });
        var tr = V((mp, Gt) => {
          var ha = Sr(), rr = Function.prototype.call;
          Gt.exports = ha ? rr.bind(rr) : function() {
            return rr.apply(rr, arguments);
          };
        });
        var Qt = V((Kt) => {
          "use strict";
          var Ht = {}.propertyIsEnumerable, Jt = Object.getOwnPropertyDescriptor, da = Jt && !Ht.call({ 1: 2 }, 1);
          Kt.f = da ? function(n) {
            var i = Jt(this, n);
            return !!i && i.enumerable;
          } : Ht;
        });
        var Or = V((yp, Yt) => {
          Yt.exports = function(e, n) {
            return { enumerable: !(e & 1), configurable: !(e & 2), writable: !(e & 4), value: n };
          };
        });
        var de = V((wp, en) => {
          var Xt = Sr(), Zt = Function.prototype, va = Zt.bind, Tr = Zt.call, ma = Xt && va.bind(Tr, Tr);
          en.exports = Xt ? function(e) {
            return e && ma(e);
          } : function(e) {
            return e && function() {
              return Tr.apply(e, arguments);
            };
          };
        });
        var nn = V((_p, tn) => {
          var rn = de(), ga = rn({}.toString), ya = rn("".slice);
          tn.exports = function(e) {
            return ya(ga(e), 8, -1);
          };
        });
        var on = V((bp, sn) => {
          var wa = ee(), _a = de(), ba = ke(), xa = nn(), Er = wa.Object, ka = _a("".split);
          sn.exports = ba(function() {
            return !Er("z").propertyIsEnumerable(0);
          }) ? function(e) {
            return xa(e) == "String" ? ka(e, "") : Er(e);
          } : Er;
        });
        var qr = V((xp, an) => {
          var Sa = ee(), Oa = Sa.TypeError;
          an.exports = function(e) {
            if (e == null)
              throw Oa("Can't call method on " + e);
            return e;
          };
        });
        var nr = V((kp, un) => {
          var Ta = on(), Ea = qr();
          un.exports = function(e) {
            return Ta(Ea(e));
          };
        });
        var ve = V((Sp, cn) => {
          cn.exports = function(e) {
            return typeof e == "function";
          };
        });
        var Me = V((Op, ln) => {
          var qa = ve();
          ln.exports = function(e) {
            return typeof e == "object" ? e !== null : qa(e);
          };
        });
        var ir = V((Tp, fn) => {
          var Ar = ee(), Aa = ve(), Pa = function(e) {
            return Aa(e) ? e : void 0;
          };
          fn.exports = function(e, n) {
            return arguments.length < 2 ? Pa(Ar[e]) : Ar[e] && Ar[e][n];
          };
        });
        var hn = V((Ep, pn) => {
          var Ra = de();
          pn.exports = Ra({}.isPrototypeOf);
        });
        var vn = V((qp, dn) => {
          var Ia = ir();
          dn.exports = Ia("navigator", "userAgent") || "";
        });
        var xn = V((Ap, bn) => {
          var _n = ee(), Pr = vn(), mn = _n.process, gn = _n.Deno, yn = mn && mn.versions || gn && gn.version, wn = yn && yn.v8, he, sr;
          wn && (he = wn.split("."), sr = he[0] > 0 && he[0] < 4 ? 1 : +(he[0] + he[1]));
          !sr && Pr && (he = Pr.match(/Edge\/(\d+)/), (!he || he[1] >= 74) && (he = Pr.match(/Chrome\/(\d+)/), he && (sr = +he[1])));
          bn.exports = sr;
        });
        var Rr = V((Pp, Sn) => {
          var kn = xn(), Ca = ke();
          Sn.exports = !!Object.getOwnPropertySymbols && !Ca(function() {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && kn && kn < 41;
          });
        });
        var Ir = V((Rp, On) => {
          var Na = Rr();
          On.exports = Na && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var Cr = V((Ip, Tn) => {
          var ja = ee(), Ma = ir(), Da = ve(), La = hn(), za = Ir(), Ba = ja.Object;
          Tn.exports = za ? function(e) {
            return typeof e == "symbol";
          } : function(e) {
            var n = Ma("Symbol");
            return Da(n) && La(n.prototype, Ba(e));
          };
        });
        var qn = V((Cp, En) => {
          var Fa = ee(), Ua = Fa.String;
          En.exports = function(e) {
            try {
              return Ua(e);
            } catch {
              return "Object";
            }
          };
        });
        var Pn = V((Np, An) => {
          var Wa = ee(), $a = ve(), Va = qn(), Ga = Wa.TypeError;
          An.exports = function(e) {
            if ($a(e))
              return e;
            throw Ga(Va(e) + " is not a function");
          };
        });
        var In = V((jp, Rn) => {
          var Ha = Pn();
          Rn.exports = function(e, n) {
            var i = e[n];
            return i == null ? void 0 : Ha(i);
          };
        });
        var Nn = V((Mp, Cn) => {
          var Ja = ee(), Nr = tr(), jr = ve(), Mr = Me(), Ka = Ja.TypeError;
          Cn.exports = function(e, n) {
            var i, a;
            if (n === "string" && jr(i = e.toString) && !Mr(a = Nr(i, e)) || jr(i = e.valueOf) && !Mr(a = Nr(i, e)) || n !== "string" && jr(i = e.toString) && !Mr(a = Nr(i, e)))
              return a;
            throw Ka("Can't convert object to primitive value");
          };
        });
        var Mn = V((Dp, jn) => {
          jn.exports = false;
        });
        var or = V((Lp, Ln) => {
          var Dn = ee(), Qa = Object.defineProperty;
          Ln.exports = function(e, n) {
            try {
              Qa(Dn, e, { value: n, configurable: true, writable: true });
            } catch {
              Dn[e] = n;
            }
            return n;
          };
        });
        var ar = V((zp, Bn) => {
          var Ya = ee(), Xa = or(), zn = "__core-js_shared__", Za = Ya[zn] || Xa(zn, {});
          Bn.exports = Za;
        });
        var Dr = V((Bp, Un) => {
          var eu = Mn(), Fn = ar();
          (Un.exports = function(e, n) {
            return Fn[e] || (Fn[e] = n !== void 0 ? n : {});
          })("versions", []).push({ version: "3.22.2", mode: eu ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.22.2/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var $n = V((Fp, Wn) => {
          var ru = ee(), tu = qr(), nu = ru.Object;
          Wn.exports = function(e) {
            return nu(tu(e));
          };
        });
        var Se = V((Up, Vn) => {
          var iu = de(), su = $n(), ou = iu({}.hasOwnProperty);
          Vn.exports = Object.hasOwn || function(n, i) {
            return ou(su(n), i);
          };
        });
        var Lr = V((Wp, Gn) => {
          var au = de(), uu = 0, cu = Math.random(), lu = au(1 .toString);
          Gn.exports = function(e) {
            return "Symbol(" + (e === void 0 ? "" : e) + ")_" + lu(++uu + cu, 36);
          };
        });
        var Xn = V(($p, Yn) => {
          var fu = ee(), pu = Dr(), Hn = Se(), hu = Lr(), Jn = Rr(), Qn = Ir(), De = pu("wks"), Ee = fu.Symbol, Kn = Ee && Ee.for, du = Qn ? Ee : Ee && Ee.withoutSetter || hu;
          Yn.exports = function(e) {
            if (!Hn(De, e) || !(Jn || typeof De[e] == "string")) {
              var n = "Symbol." + e;
              Jn && Hn(Ee, e) ? De[e] = Ee[e] : Qn && Kn ? De[e] = Kn(n) : De[e] = du(n);
            }
            return De[e];
          };
        });
        var ti = V((Vp, ri) => {
          var vu = ee(), mu = tr(), Zn = Me(), ei = Cr(), gu = In(), yu = Nn(), wu = Xn(), _u = vu.TypeError, bu = wu("toPrimitive");
          ri.exports = function(e, n) {
            if (!Zn(e) || ei(e))
              return e;
            var i = gu(e, bu), a;
            if (i) {
              if (n === void 0 && (n = "default"), a = mu(i, e, n), !Zn(a) || ei(a))
                return a;
              throw _u("Can't convert object to primitive value");
            }
            return n === void 0 && (n = "number"), yu(e, n);
          };
        });
        var zr = V((Gp, ni) => {
          var xu = ti(), ku = Cr();
          ni.exports = function(e) {
            var n = xu(e, "string");
            return ku(n) ? n : n + "";
          };
        });
        var oi = V((Hp, si) => {
          var Su = ee(), ii = Me(), Br = Su.document, Ou = ii(Br) && ii(Br.createElement);
          si.exports = function(e) {
            return Ou ? Br.createElement(e) : {};
          };
        });
        var Fr = V((Jp, ai) => {
          var Tu = Te(), Eu = ke(), qu = oi();
          ai.exports = !Tu && !Eu(function() {
            return Object.defineProperty(qu("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var Ur = V((ci) => {
          var Au = Te(), Pu = tr(), Ru = Qt(), Iu = Or(), Cu = nr(), Nu = zr(), ju = Se(), Mu = Fr(), ui = Object.getOwnPropertyDescriptor;
          ci.f = Au ? ui : function(n, i) {
            if (n = Cu(n), i = Nu(i), Mu)
              try {
                return ui(n, i);
              } catch {
              }
            if (ju(n, i))
              return Iu(!Pu(Ru.f, n, i), n[i]);
          };
        });
        var fi = V((Qp, li) => {
          var Du = Te(), Lu = ke();
          li.exports = Du && Lu(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var Wr = V((Yp, hi) => {
          var pi = ee(), zu = Me(), Bu = pi.String, Fu = pi.TypeError;
          hi.exports = function(e) {
            if (zu(e))
              return e;
            throw Fu(Bu(e) + " is not an object");
          };
        });
        var Jr = V((vi) => {
          var Uu = ee(), Wu = Te(), $u = Fr(), Vu = fi(), ur = Wr(), di = zr(), Gu = Uu.TypeError, $r = Object.defineProperty, Hu = Object.getOwnPropertyDescriptor, Vr = "enumerable", Gr = "configurable", Hr = "writable";
          vi.f = Wu ? Vu ? function(n, i, a) {
            if (ur(n), i = di(i), ur(a), typeof n == "function" && i === "prototype" && "value" in a && Hr in a && !a[Hr]) {
              var o = Hu(n, i);
              o && o[Hr] && (n[i] = a.value, a = { configurable: Gr in a ? a[Gr] : o[Gr], enumerable: Vr in a ? a[Vr] : o[Vr], writable: false });
            }
            return $r(n, i, a);
          } : $r : function(n, i, a) {
            if (ur(n), i = di(i), ur(a), $u)
              try {
                return $r(n, i, a);
              } catch {
              }
            if ("get" in a || "set" in a)
              throw Gu("Accessors not supported");
            return "value" in a && (n[i] = a.value), n;
          };
        });
        var cr = V((Zp, mi) => {
          var Ju = Te(), Ku = Jr(), Qu = Or();
          mi.exports = Ju ? function(e, n, i) {
            return Ku.f(e, n, Qu(1, i));
          } : function(e, n, i) {
            return e[n] = i, e;
          };
        });
        var Qr = V((eh, gi) => {
          var Yu = de(), Xu = ve(), Kr = ar(), Zu = Yu(Function.toString);
          Xu(Kr.inspectSource) || (Kr.inspectSource = function(e) {
            return Zu(e);
          });
          gi.exports = Kr.inspectSource;
        });
        var _i = V((rh, wi) => {
          var ec = ee(), rc = ve(), tc = Qr(), yi = ec.WeakMap;
          wi.exports = rc(yi) && /native code/.test(tc(yi));
        });
        var ki = V((th, xi) => {
          var nc = Dr(), ic = Lr(), bi = nc("keys");
          xi.exports = function(e) {
            return bi[e] || (bi[e] = ic(e));
          };
        });
        var Yr = V((nh, Si) => {
          Si.exports = {};
        });
        var Pi = V((ih, Ai) => {
          var sc = _i(), qi = ee(), Xr = de(), oc = Me(), ac = cr(), Zr = Se(), et = ar(), uc = ki(), cc = Yr(), Oi = "Object already initialized", tt = qi.TypeError, lc = qi.WeakMap, lr, Fe, fr, fc = function(e) {
            return fr(e) ? Fe(e) : lr(e, {});
          }, pc = function(e) {
            return function(n) {
              var i;
              if (!oc(n) || (i = Fe(n)).type !== e)
                throw tt("Incompatible receiver, " + e + " required");
              return i;
            };
          };
          sc || et.state ? (Oe = et.state || (et.state = new lc()), Ti = Xr(Oe.get), rt = Xr(Oe.has), Ei = Xr(Oe.set), lr = function(e, n) {
            if (rt(Oe, e))
              throw new tt(Oi);
            return n.facade = e, Ei(Oe, e, n), n;
          }, Fe = function(e) {
            return Ti(Oe, e) || {};
          }, fr = function(e) {
            return rt(Oe, e);
          }) : (qe = uc("state"), cc[qe] = true, lr = function(e, n) {
            if (Zr(e, qe))
              throw new tt(Oi);
            return n.facade = e, ac(e, qe, n), n;
          }, Fe = function(e) {
            return Zr(e, qe) ? e[qe] : {};
          }, fr = function(e) {
            return Zr(e, qe);
          });
          var Oe, Ti, rt, Ei, qe;
          Ai.exports = { set: lr, get: Fe, has: fr, enforce: fc, getterFor: pc };
        });
        var Ci = V((sh, Ii) => {
          var nt = Te(), hc = Se(), Ri = Function.prototype, dc = nt && Object.getOwnPropertyDescriptor, it = hc(Ri, "name"), vc = it && function() {
          }.name === "something", mc = it && (!nt || nt && dc(Ri, "name").configurable);
          Ii.exports = { EXISTS: it, PROPER: vc, CONFIGURABLE: mc };
        });
        var Li = V((oh, Di) => {
          var gc = ee(), Ni = ve(), yc = Se(), ji = cr(), wc = or(), _c = Qr(), Mi = Pi(), bc = Ci().CONFIGURABLE, xc = Mi.get, kc = Mi.enforce, Sc = String(String).split("String");
          (Di.exports = function(e, n, i, a) {
            var o = a ? !!a.unsafe : false, f = a ? !!a.enumerable : false, p = a ? !!a.noTargetGet : false, h = a && a.name !== void 0 ? a.name : n, g;
            if (Ni(i) && (String(h).slice(0, 7) === "Symbol(" && (h = "[" + String(h).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!yc(i, "name") || bc && i.name !== h) && ji(i, "name", h), g = kc(i), g.source || (g.source = Sc.join(typeof h == "string" ? h : ""))), e === gc) {
              f ? e[n] = i : wc(n, i);
              return;
            } else
              o ? !p && e[n] && (f = true) : delete e[n];
            f ? e[n] = i : ji(e, n, i);
          })(Function.prototype, "toString", function() {
            return Ni(this) && xc(this).source || _c(this);
          });
        });
        var st = V((ah, zi) => {
          var Oc = Math.ceil, Tc = Math.floor;
          zi.exports = function(e) {
            var n = +e;
            return n !== n || n === 0 ? 0 : (n > 0 ? Tc : Oc)(n);
          };
        });
        var Fi = V((uh, Bi) => {
          var Ec = st(), qc = Math.max, Ac = Math.min;
          Bi.exports = function(e, n) {
            var i = Ec(e);
            return i < 0 ? qc(i + n, 0) : Ac(i, n);
          };
        });
        var Wi = V((ch, Ui) => {
          var Pc = st(), Rc = Math.min;
          Ui.exports = function(e) {
            return e > 0 ? Rc(Pc(e), 9007199254740991) : 0;
          };
        });
        var Vi = V((lh, $i) => {
          var Ic = Wi();
          $i.exports = function(e) {
            return Ic(e.length);
          };
        });
        var Ji = V((fh, Hi) => {
          var Cc = nr(), Nc = Fi(), jc = Vi(), Gi = function(e) {
            return function(n, i, a) {
              var o = Cc(n), f = jc(o), p = Nc(a, f), h;
              if (e && i != i) {
                for (; f > p; )
                  if (h = o[p++], h != h)
                    return true;
              } else
                for (; f > p; p++)
                  if ((e || p in o) && o[p] === i)
                    return e || p || 0;
              return !e && -1;
            };
          };
          Hi.exports = { includes: Gi(true), indexOf: Gi(false) };
        });
        var Yi = V((ph, Qi) => {
          var Mc = de(), ot = Se(), Dc = nr(), Lc = Ji().indexOf, zc = Yr(), Ki = Mc([].push);
          Qi.exports = function(e, n) {
            var i = Dc(e), a = 0, o = [], f;
            for (f in i)
              !ot(zc, f) && ot(i, f) && Ki(o, f);
            for (; n.length > a; )
              ot(i, f = n[a++]) && (~Lc(o, f) || Ki(o, f));
            return o;
          };
        });
        var Zi = V((hh, Xi) => {
          Xi.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var rs = V((es) => {
          var Bc = Yi(), Fc = Zi(), Uc = Fc.concat("length", "prototype");
          es.f = Object.getOwnPropertyNames || function(n) {
            return Bc(n, Uc);
          };
        });
        var ns = V((ts) => {
          ts.f = Object.getOwnPropertySymbols;
        });
        var ss = V((mh, is) => {
          var Wc = ir(), $c = de(), Vc = rs(), Gc = ns(), Hc = Wr(), Jc = $c([].concat);
          is.exports = Wc("Reflect", "ownKeys") || function(n) {
            var i = Vc.f(Hc(n)), a = Gc.f;
            return a ? Jc(i, a(n)) : i;
          };
        });
        var us = V((gh, as) => {
          var os = Se(), Kc = ss(), Qc = Ur(), Yc = Jr();
          as.exports = function(e, n, i) {
            for (var a = Kc(n), o = Yc.f, f = Qc.f, p = 0; p < a.length; p++) {
              var h = a[p];
              !os(e, h) && !(i && os(i, h)) && o(e, h, f(n, h));
            }
          };
        });
        var ls = V((yh, cs) => {
          var Xc = ke(), Zc = ve(), el = /#|\.prototype\./, Ue = function(e, n) {
            var i = tl[rl(e)];
            return i == il ? true : i == nl ? false : Zc(n) ? Xc(n) : !!n;
          }, rl = Ue.normalize = function(e) {
            return String(e).replace(el, ".").toLowerCase();
          }, tl = Ue.data = {}, nl = Ue.NATIVE = "N", il = Ue.POLYFILL = "P";
          cs.exports = Ue;
        });
        var ps = V((wh, fs) => {
          var at2 = ee(), sl = Ur().f, ol = cr(), al = Li(), ul = or(), cl = us(), ll = ls();
          fs.exports = function(e, n) {
            var i = e.target, a = e.global, o = e.stat, f, p, h, g, c, t3;
            if (a ? p = at2 : o ? p = at2[i] || ul(i, {}) : p = (at2[i] || {}).prototype, p)
              for (h in n) {
                if (c = n[h], e.noTargetGet ? (t3 = sl(p, h), g = t3 && t3.value) : g = p[h], f = ll(a ? h : i + (o ? "." : "#") + h, e.forced), !f && g !== void 0) {
                  if (typeof c == typeof g)
                    continue;
                  cl(c, g);
                }
                (e.sham || g && g.sham) && ol(c, "sham", true), al(p, h, c, e);
              }
          };
        });
        var hs = V(() => {
          var fl = ps(), pl = ee();
          fl({ global: true }, { globalThis: pl });
        });
        var ds = V(() => {
          hs();
        });
        var lp = V((Ph, la) => {
          ds();
          var kt = Object.defineProperty, hl = Object.getOwnPropertyDescriptor, St = Object.getOwnPropertyNames, dl = Object.prototype.hasOwnProperty, Le = (e, n) => function() {
            return e && (n = (0, e[St(e)[0]])(e = 0)), n;
          }, R = (e, n) => function() {
            return n || (0, e[St(e)[0]])((n = { exports: {} }).exports, n), n.exports;
          }, Ot = (e, n) => {
            for (var i in n)
              kt(e, i, { get: n[i], enumerable: true });
          }, vl = (e, n, i, a) => {
            if (n && typeof n == "object" || typeof n == "function")
              for (let o of St(n))
                !dl.call(e, o) && o !== i && kt(e, o, { get: () => n[o], enumerable: !(a = hl(n, o)) || a.enumerable });
            return e;
          }, Tt = (e) => vl(kt({}, "__esModule", { value: true }), e), A = Le({ "<define:process>"() {
          } }), ml = R({ "src/common/parser-create-error.js"(e, n) {
            "use strict";
            A();
            function i(a, o) {
              let f = new SyntaxError(a + " (" + o.start.line + ":" + o.start.column + ")");
              return f.loc = o, f;
            }
            n.exports = i;
          } }), Cs = R({ "src/utils/get-last.js"(e, n) {
            "use strict";
            A();
            var i = (a) => a[a.length - 1];
            n.exports = i;
          } }), Ns = R({ "src/utils/front-matter/parse.js"(e, n) {
            "use strict";
            A();
            var i = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
            function a(o) {
              let f = o.match(i);
              if (!f)
                return { content: o };
              let { startDelimiter: p, language: h, value: g = "", endDelimiter: c } = f.groups, t3 = h.trim() || "yaml";
              if (p === "+++" && (t3 = "toml"), t3 !== "yaml" && p !== c)
                return { content: o };
              let [r] = f;
              return { frontMatter: { type: "front-matter", lang: t3, value: g, startDelimiter: p, endDelimiter: c, raw: r.replace(/\n$/, "") }, content: r.replace(/[^\n]/g, " ") + o.slice(r.length) };
            }
            n.exports = a;
          } }), js = {};
          Ot(js, { EOL: () => gt2, arch: () => gl, cpus: () => Us, default: () => Hs, endianness: () => Ms, freemem: () => Bs, getNetworkInterfaces: () => Gs, hostname: () => Ds, loadavg: () => Ls, networkInterfaces: () => Vs, platform: () => yl, release: () => $s, tmpDir: () => vt, tmpdir: () => mt, totalmem: () => Fs, type: () => Ws, uptime: () => zs });
          function Ms() {
            if (typeof pr > "u") {
              var e = new ArrayBuffer(2), n = new Uint8Array(e), i = new Uint16Array(e);
              if (n[0] = 1, n[1] = 2, i[0] === 258)
                pr = "BE";
              else if (i[0] === 513)
                pr = "LE";
              else
                throw new Error("unable to figure out endianess");
            }
            return pr;
          }
          function Ds() {
            return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
          }
          function Ls() {
            return [];
          }
          function zs() {
            return 0;
          }
          function Bs() {
            return Number.MAX_VALUE;
          }
          function Fs() {
            return Number.MAX_VALUE;
          }
          function Us() {
            return [];
          }
          function Ws() {
            return "Browser";
          }
          function $s() {
            return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
          }
          function Vs() {
          }
          function Gs() {
          }
          function gl() {
            return "javascript";
          }
          function yl() {
            return "browser";
          }
          function vt() {
            return "/tmp";
          }
          var pr, mt, gt2, Hs, wl = Le({ "node-modules-polyfills:os"() {
            A(), mt = vt, gt2 = `
`, Hs = { EOL: gt2, tmpdir: mt, tmpDir: vt, networkInterfaces: Vs, getNetworkInterfaces: Gs, release: $s, type: Ws, cpus: Us, totalmem: Fs, freemem: Bs, uptime: zs, loadavg: Ls, hostname: Ds, endianness: Ms };
          } }), _l = R({ "node-modules-polyfills-commonjs:os"(e, n) {
            A();
            var i = (wl(), Tt(js));
            if (i && i.default) {
              n.exports = i.default;
              for (let a in i)
                n.exports[a] = i[a];
            } else
              i && (n.exports = i);
          } }), bl = R({ "node_modules/detect-newline/index.js"(e, n) {
            "use strict";
            A();
            var i = (a) => {
              if (typeof a != "string")
                throw new TypeError("Expected a string");
              let o = a.match(/(?:\r?\n)/g) || [];
              if (o.length === 0)
                return;
              let f = o.filter((h) => h === `\r
`).length, p = o.length - f;
              return f > p ? `\r
` : `
`;
            };
            n.exports = i, n.exports.graceful = (a) => typeof a == "string" && i(a) || `
`;
          } }), xl = R({ "node_modules/jest-docblock/build/index.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true }), e.extract = s, e.parse = m, e.parseWithComments = v, e.print = y, e.strip = l;
            function n() {
              let d = _l();
              return n = function() {
                return d;
              }, d;
            }
            function i() {
              let d = a(bl());
              return i = function() {
                return d;
              }, d;
            }
            function a(d) {
              return d && d.__esModule ? d : { default: d };
            }
            var o = /\*\/$/, f = /^\/\*\*/, p = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, h = /(^|\s+)\/\/([^\r\n]*)/g, g = /^(\r?\n)+/, c = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, t3 = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, r = /(\r?\n|^) *\* ?/g, u = [];
            function s(d) {
              let _ = d.match(p);
              return _ ? _[0].trimLeft() : "";
            }
            function l(d) {
              let _ = d.match(p);
              return _ && _[0] ? d.substring(_[0].length) : d;
            }
            function m(d) {
              return v(d).pragmas;
            }
            function v(d) {
              let _ = (0, i().default)(d) || n().EOL;
              d = d.replace(f, "").replace(o, "").replace(r, "$1");
              let S = "";
              for (; S !== d; )
                S = d, d = d.replace(c, "".concat(_, "$1 $2").concat(_));
              d = d.replace(g, "").trimRight();
              let x = /* @__PURE__ */ Object.create(null), N = d.replace(t3, "").replace(g, "").trimRight(), P;
              for (; P = t3.exec(d); ) {
                let W = P[2].replace(h, "");
                typeof x[P[1]] == "string" || Array.isArray(x[P[1]]) ? x[P[1]] = u.concat(x[P[1]], W) : x[P[1]] = W;
              }
              return { comments: N, pragmas: x };
            }
            function y(d) {
              let { comments: _ = "", pragmas: S = {} } = d, x = (0, i().default)(_) || n().EOL, N = "/**", P = " *", W = " */", U = Object.keys(S), H = U.map(($) => w($, S[$])).reduce(($, B) => $.concat(B), []).map(($) => P + " " + $ + x).join("");
              if (!_) {
                if (U.length === 0)
                  return "";
                if (U.length === 1 && !Array.isArray(S[U[0]])) {
                  let $ = S[U[0]];
                  return "".concat(N, " ").concat(w(U[0], $)[0]).concat(W);
                }
              }
              let D = _.split(x).map(($) => "".concat(P, " ").concat($)).join(x) + x;
              return N + x + (_ ? D : "") + (_ && U.length ? P + x : "") + H + W;
            }
            function w(d, _) {
              return u.concat(_).map((S) => "@".concat(d, " ").concat(S).trim());
            }
          } }), kl = R({ "src/common/end-of-line.js"(e, n) {
            "use strict";
            A();
            function i(p) {
              let h = p.indexOf("\r");
              return h >= 0 ? p.charAt(h + 1) === `
` ? "crlf" : "cr" : "lf";
            }
            function a(p) {
              switch (p) {
                case "cr":
                  return "\r";
                case "crlf":
                  return `\r
`;
                default:
                  return `
`;
              }
            }
            function o(p, h) {
              let g;
              switch (h) {
                case `
`:
                  g = /\n/g;
                  break;
                case "\r":
                  g = /\r/g;
                  break;
                case `\r
`:
                  g = /\r\n/g;
                  break;
                default:
                  throw new Error('Unexpected "eol" '.concat(JSON.stringify(h), "."));
              }
              let c = p.match(g);
              return c ? c.length : 0;
            }
            function f(p) {
              return p.replace(/\r\n?/g, `
`);
            }
            n.exports = { guessEndOfLine: i, convertEndOfLineToChars: a, countEndOfLineChars: o, normalizeEndOfLine: f };
          } }), Sl = R({ "src/language-js/utils/get-shebang.js"(e, n) {
            "use strict";
            A();
            function i(a) {
              if (!a.startsWith("#!"))
                return "";
              let o = a.indexOf(`
`);
              return o === -1 ? a : a.slice(0, o);
            }
            n.exports = i;
          } }), Ol = R({ "src/language-js/pragma.js"(e, n) {
            "use strict";
            A();
            var { parseWithComments: i, strip: a, extract: o, print: f } = xl(), { normalizeEndOfLine: p } = kl(), h = Sl();
            function g(r) {
              let u = h(r);
              u && (r = r.slice(u.length + 1));
              let s = o(r), { pragmas: l, comments: m } = i(s);
              return { shebang: u, text: r, pragmas: l, comments: m };
            }
            function c(r) {
              let u = Object.keys(g(r).pragmas);
              return u.includes("prettier") || u.includes("format");
            }
            function t3(r) {
              let { shebang: u, text: s, pragmas: l, comments: m } = g(r), v = a(s), y = f({ pragmas: Object.assign({ format: "" }, l), comments: m.trimStart() });
              return (u ? "".concat(u, `
`) : "") + p(y) + (v.startsWith(`
`) ? `
` : `

`) + v;
            }
            n.exports = { hasPragma: c, insertPragma: t3 };
          } }), Tl = R({ "src/language-css/pragma.js"(e, n) {
            "use strict";
            A();
            var i = Ol(), a = Ns();
            function o(p) {
              return i.hasPragma(a(p).content);
            }
            function f(p) {
              let { frontMatter: h, content: g } = a(p);
              return (h ? h.raw + `

` : "") + i.insertPragma(g);
            }
            n.exports = { hasPragma: o, insertPragma: f };
          } }), El = R({ "src/utils/text/skip.js"(e, n) {
            "use strict";
            A();
            function i(h) {
              return (g, c, t3) => {
                let r = t3 && t3.backwards;
                if (c === false)
                  return false;
                let { length: u } = g, s = c;
                for (; s >= 0 && s < u; ) {
                  let l = g.charAt(s);
                  if (h instanceof RegExp) {
                    if (!h.test(l))
                      return s;
                  } else if (!h.includes(l))
                    return s;
                  r ? s-- : s++;
                }
                return s === -1 || s === u ? s : false;
              };
            }
            var a = i(/\s/), o = i(" 	"), f = i(",; 	"), p = i(/[^\n\r]/);
            n.exports = { skipWhitespace: a, skipSpaces: o, skipToLineEnd: f, skipEverythingButNewLine: p };
          } }), ql = R({ "src/utils/line-column-to-index.js"(e, n) {
            "use strict";
            A(), n.exports = function(i, a) {
              let o = 0;
              for (let f = 0; f < i.line - 1; ++f)
                o = a.indexOf(`
`, o) + 1;
              return o + i.column;
            };
          } }), Js = R({ "src/language-css/loc.js"(e, n) {
            "use strict";
            A();
            var { skipEverythingButNewLine: i } = El(), a = Cs(), o = ql();
            function f(s, l) {
              return typeof s.sourceIndex == "number" ? s.sourceIndex : s.source ? o(s.source.start, l) - 1 : null;
            }
            function p(s, l) {
              if (s.type === "css-comment" && s.inline)
                return i(l, s.source.startOffset);
              let m = s.nodes && a(s.nodes);
              return m && s.source && !s.source.end && (s = m), s.source && s.source.end ? o(s.source.end, l) : null;
            }
            function h(s, l) {
              s.source && (s.source.startOffset = f(s, l), s.source.endOffset = p(s, l));
              for (let m in s) {
                let v = s[m];
                m === "source" || !v || typeof v != "object" || (v.type === "value-root" || v.type === "value-unknown" ? g(v, c(s), v.text || v.value) : h(v, l));
              }
            }
            function g(s, l, m) {
              s.source && (s.source.startOffset = f(s, m) + l, s.source.endOffset = p(s, m) + l);
              for (let v in s) {
                let y = s[v];
                v === "source" || !y || typeof y != "object" || g(y, l, m);
              }
            }
            function c(s) {
              let l = s.source.startOffset;
              return typeof s.prop == "string" && (l += s.prop.length), s.type === "css-atrule" && typeof s.name == "string" && (l += 1 + s.name.length + s.raws.afterName.match(/^\s*:?\s*/)[0].length), s.type !== "css-atrule" && s.raws && typeof s.raws.between == "string" && (l += s.raws.between.length), l;
            }
            function t3(s) {
              let l = "initial", m = "initial", v, y = false, w = [];
              for (let d = 0; d < s.length; d++) {
                let _ = s[d];
                switch (l) {
                  case "initial":
                    if (_ === "'") {
                      l = "single-quotes";
                      continue;
                    }
                    if (_ === '"') {
                      l = "double-quotes";
                      continue;
                    }
                    if ((_ === "u" || _ === "U") && s.slice(d, d + 4).toLowerCase() === "url(") {
                      l = "url", d += 3;
                      continue;
                    }
                    if (_ === "*" && s[d - 1] === "/") {
                      l = "comment-block";
                      continue;
                    }
                    if (_ === "/" && s[d - 1] === "/") {
                      l = "comment-inline", v = d - 1;
                      continue;
                    }
                    continue;
                  case "single-quotes":
                    if (_ === "'" && s[d - 1] !== "\\" && (l = m, m = "initial"), _ === `
` || _ === "\r")
                      return s;
                    continue;
                  case "double-quotes":
                    if (_ === '"' && s[d - 1] !== "\\" && (l = m, m = "initial"), _ === `
` || _ === "\r")
                      return s;
                    continue;
                  case "url":
                    if (_ === ")" && (l = "initial"), _ === `
` || _ === "\r")
                      return s;
                    if (_ === "'") {
                      l = "single-quotes", m = "url";
                      continue;
                    }
                    if (_ === '"') {
                      l = "double-quotes", m = "url";
                      continue;
                    }
                    continue;
                  case "comment-block":
                    _ === "/" && s[d - 1] === "*" && (l = "initial");
                    continue;
                  case "comment-inline":
                    (_ === '"' || _ === "'" || _ === "*") && (y = true), (_ === `
` || _ === "\r") && (y && w.push([v, d]), l = "initial", y = false);
                    continue;
                }
              }
              for (let [d, _] of w)
                s = s.slice(0, d) + s.slice(d, _).replace(/["'*]/g, " ") + s.slice(_);
              return s;
            }
            function r(s) {
              return s.source.startOffset;
            }
            function u(s) {
              return s.source.endOffset;
            }
            n.exports = { locStart: r, locEnd: u, calculateLoc: h, replaceQuotesInInlineComments: t3 };
          } }), Al = R({ "src/utils/is-non-empty-array.js"(e, n) {
            "use strict";
            A();
            function i(a) {
              return Array.isArray(a) && a.length > 0;
            }
            n.exports = i;
          } }), Pl = R({ "src/language-css/utils/has-scss-interpolation.js"(e, n) {
            "use strict";
            A();
            var i = Al();
            function a(o) {
              if (i(o)) {
                for (let f = o.length - 1; f > 0; f--)
                  if (o[f].type === "word" && o[f].value === "{" && o[f - 1].type === "word" && o[f - 1].value.endsWith("#"))
                    return true;
              }
              return false;
            }
            n.exports = a;
          } }), Rl = R({ "src/language-css/utils/has-string-or-function.js"(e, n) {
            "use strict";
            A();
            function i(a) {
              return a.some((o) => o.type === "string" || o.type === "func");
            }
            n.exports = i;
          } }), Il = R({ "src/language-css/utils/is-less-parser.js"(e, n) {
            "use strict";
            A();
            function i(a) {
              return a.parser === "css" || a.parser === "less";
            }
            n.exports = i;
          } }), Cl = R({ "src/language-css/utils/is-scss.js"(e, n) {
            "use strict";
            A();
            function i(a, o) {
              return a === "less" || a === "scss" ? a === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(o);
            }
            n.exports = i;
          } }), Nl = R({ "src/language-css/utils/is-scss-nested-property-node.js"(e, n) {
            "use strict";
            A();
            function i(a) {
              return a.selector ? a.selector.replace(/\/\*.*?\*\//, "").replace(/\/\/.*\n/, "").trim().endsWith(":") : false;
            }
            n.exports = i;
          } }), jl = R({ "src/language-css/utils/is-scss-variable.js"(e, n) {
            "use strict";
            A();
            function i(a) {
              return Boolean((a == null ? void 0 : a.type) === "word" && a.value.startsWith("$"));
            }
            n.exports = i;
          } }), Ml = R({ "src/language-css/utils/stringify-node.js"(e, n) {
            "use strict";
            A();
            function i(a) {
              var o, f, p;
              if (a.groups) {
                var h, g, c;
                let y = ((h = a.open) === null || h === void 0 ? void 0 : h.value) || "", w = a.groups.map((_) => i(_)).join(((g = a.groups[0]) === null || g === void 0 ? void 0 : g.type) === "comma_group" ? "," : ""), d = ((c = a.close) === null || c === void 0 ? void 0 : c.value) || "";
                return y + w + d;
              }
              let t3 = ((o = a.raws) === null || o === void 0 ? void 0 : o.before) || "", r = ((f = a.raws) === null || f === void 0 ? void 0 : f.quote) || "", u = a.type === "atword" ? "@" : "", s = a.value || "", l = a.unit || "", m = a.group ? i(a.group) : "", v = ((p = a.raws) === null || p === void 0 ? void 0 : p.after) || "";
              return t3 + r + u + s + r + l + m + v;
            }
            n.exports = i;
          } }), Dl = R({ "src/language-css/utils/is-module-rule-name.js"(e, n) {
            "use strict";
            A();
            var i = /* @__PURE__ */ new Set(["import", "use", "forward"]);
            function a(o) {
              return i.has(o);
            }
            n.exports = a;
          } }), we = R({ "node_modules/postcss-values-parser/lib/node.js"(e, n) {
            "use strict";
            A();
            var i = function(a, o) {
              let f = new a.constructor();
              for (let p in a) {
                if (!a.hasOwnProperty(p))
                  continue;
                let h = a[p], g = typeof h;
                p === "parent" && g === "object" ? o && (f[p] = o) : p === "source" ? f[p] = h : h instanceof Array ? f[p] = h.map((c) => i(c, f)) : p !== "before" && p !== "after" && p !== "between" && p !== "semicolon" && (g === "object" && h !== null && (h = i(h)), f[p] = h);
              }
              return f;
            };
            n.exports = class {
              constructor(o) {
                o = o || {}, this.raws = { before: "", after: "" };
                for (let f in o)
                  this[f] = o[f];
              }
              remove() {
                return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
              }
              toString() {
                return [this.raws.before, String(this.value), this.raws.after].join("");
              }
              clone(o) {
                o = o || {};
                let f = i(this);
                for (let p in o)
                  f[p] = o[p];
                return f;
              }
              cloneBefore(o) {
                o = o || {};
                let f = this.clone(o);
                return this.parent.insertBefore(this, f), f;
              }
              cloneAfter(o) {
                o = o || {};
                let f = this.clone(o);
                return this.parent.insertAfter(this, f), f;
              }
              replaceWith() {
                let o = Array.prototype.slice.call(arguments);
                if (this.parent) {
                  for (let f of o)
                    this.parent.insertBefore(this, f);
                  this.remove();
                }
                return this;
              }
              moveTo(o) {
                return this.cleanRaws(this.root() === o.root()), this.remove(), o.append(this), this;
              }
              moveBefore(o) {
                return this.cleanRaws(this.root() === o.root()), this.remove(), o.parent.insertBefore(o, this), this;
              }
              moveAfter(o) {
                return this.cleanRaws(this.root() === o.root()), this.remove(), o.parent.insertAfter(o, this), this;
              }
              next() {
                let o = this.parent.index(this);
                return this.parent.nodes[o + 1];
              }
              prev() {
                let o = this.parent.index(this);
                return this.parent.nodes[o - 1];
              }
              toJSON() {
                let o = {};
                for (let f in this) {
                  if (!this.hasOwnProperty(f) || f === "parent")
                    continue;
                  let p = this[f];
                  p instanceof Array ? o[f] = p.map((h) => typeof h == "object" && h.toJSON ? h.toJSON() : h) : typeof p == "object" && p.toJSON ? o[f] = p.toJSON() : o[f] = p;
                }
                return o;
              }
              root() {
                let o = this;
                for (; o.parent; )
                  o = o.parent;
                return o;
              }
              cleanRaws(o) {
                delete this.raws.before, delete this.raws.after, o || delete this.raws.between;
              }
              positionInside(o) {
                let f = this.toString(), p = this.source.start.column, h = this.source.start.line;
                for (let g = 0; g < o; g++)
                  f[g] === `
` ? (p = 1, h += 1) : p += 1;
                return { line: h, column: p };
              }
              positionBy(o) {
                let f = this.source.start;
                if (Object(o).index)
                  f = this.positionInside(o.index);
                else if (Object(o).word) {
                  let p = this.toString().indexOf(o.word);
                  p !== -1 && (f = this.positionInside(p));
                }
                return f;
              }
            };
          } }), ue = R({ "node_modules/postcss-values-parser/lib/container.js"(e, n) {
            "use strict";
            A();
            var i = we(), a = class extends i {
              constructor(o) {
                super(o), this.nodes || (this.nodes = []);
              }
              push(o) {
                return o.parent = this, this.nodes.push(o), this;
              }
              each(o) {
                this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
                let f = this.lastEach, p, h;
                if (this.indexes[f] = 0, !!this.nodes) {
                  for (; this.indexes[f] < this.nodes.length && (p = this.indexes[f], h = o(this.nodes[p], p), h !== false); )
                    this.indexes[f] += 1;
                  return delete this.indexes[f], h;
                }
              }
              walk(o) {
                return this.each((f, p) => {
                  let h = o(f, p);
                  return h !== false && f.walk && (h = f.walk(o)), h;
                });
              }
              walkType(o, f) {
                if (!o || !f)
                  throw new Error("Parameters {type} and {callback} are required.");
                let p = typeof o == "function";
                return this.walk((h, g) => {
                  if (p && h instanceof o || !p && h.type === o)
                    return f.call(this, h, g);
                });
              }
              append(o) {
                return o.parent = this, this.nodes.push(o), this;
              }
              prepend(o) {
                return o.parent = this, this.nodes.unshift(o), this;
              }
              cleanRaws(o) {
                if (super.cleanRaws(o), this.nodes)
                  for (let f of this.nodes)
                    f.cleanRaws(o);
              }
              insertAfter(o, f) {
                let p = this.index(o), h;
                this.nodes.splice(p + 1, 0, f);
                for (let g in this.indexes)
                  h = this.indexes[g], p <= h && (this.indexes[g] = h + this.nodes.length);
                return this;
              }
              insertBefore(o, f) {
                let p = this.index(o), h;
                this.nodes.splice(p, 0, f);
                for (let g in this.indexes)
                  h = this.indexes[g], p <= h && (this.indexes[g] = h + this.nodes.length);
                return this;
              }
              removeChild(o) {
                o = this.index(o), this.nodes[o].parent = void 0, this.nodes.splice(o, 1);
                let f;
                for (let p in this.indexes)
                  f = this.indexes[p], f >= o && (this.indexes[p] = f - 1);
                return this;
              }
              removeAll() {
                for (let o of this.nodes)
                  o.parent = void 0;
                return this.nodes = [], this;
              }
              every(o) {
                return this.nodes.every(o);
              }
              some(o) {
                return this.nodes.some(o);
              }
              index(o) {
                return typeof o == "number" ? o : this.nodes.indexOf(o);
              }
              get first() {
                if (!!this.nodes)
                  return this.nodes[0];
              }
              get last() {
                if (!!this.nodes)
                  return this.nodes[this.nodes.length - 1];
              }
              toString() {
                let o = this.nodes.map(String).join("");
                return this.value && (o = this.value + o), this.raws.before && (o = this.raws.before + o), this.raws.after && (o += this.raws.after), o;
              }
            };
            a.registerWalker = (o) => {
              let f = "walk" + o.name;
              f.lastIndexOf("s") !== f.length - 1 && (f += "s"), !a.prototype[f] && (a.prototype[f] = function(p) {
                return this.walkType(o, p);
              });
            }, n.exports = a;
          } }), Ll = R({ "node_modules/postcss-values-parser/lib/root.js"(e, n) {
            "use strict";
            A();
            var i = ue();
            n.exports = class extends i {
              constructor(o) {
                super(o), this.type = "root";
              }
            };
          } }), Ks = R({ "node_modules/postcss-values-parser/lib/value.js"(e, n) {
            "use strict";
            A();
            var i = ue();
            n.exports = class extends i {
              constructor(o) {
                super(o), this.type = "value", this.unbalanced = 0;
              }
            };
          } }), Qs = R({ "node_modules/postcss-values-parser/lib/atword.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = class extends i {
              constructor(o) {
                super(o), this.type = "atword";
              }
              toString() {
                let o = this.quoted ? this.raws.quote : "";
                return [this.raws.before, "@", String.prototype.toString.call(this.value), this.raws.after].join("");
              }
            };
            i.registerWalker(a), n.exports = a;
          } }), Ys = R({ "node_modules/postcss-values-parser/lib/colon.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = we(), o = class extends a {
              constructor(f) {
                super(f), this.type = "colon";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), Xs = R({ "node_modules/postcss-values-parser/lib/comma.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = we(), o = class extends a {
              constructor(f) {
                super(f), this.type = "comma";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), Zs = R({ "node_modules/postcss-values-parser/lib/comment.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = we(), o = class extends a {
              constructor(f) {
                super(f), this.type = "comment", this.inline = Object(f).inline || false;
              }
              toString() {
                return [this.raws.before, this.inline ? "//" : "/*", String(this.value), this.inline ? "" : "*/", this.raws.after].join("");
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), eo = R({ "node_modules/postcss-values-parser/lib/function.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = class extends i {
              constructor(o) {
                super(o), this.type = "func", this.unbalanced = -1;
              }
            };
            i.registerWalker(a), n.exports = a;
          } }), ro = R({ "node_modules/postcss-values-parser/lib/number.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = we(), o = class extends a {
              constructor(f) {
                super(f), this.type = "number", this.unit = Object(f).unit || "";
              }
              toString() {
                return [this.raws.before, String(this.value), this.unit, this.raws.after].join("");
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), to = R({ "node_modules/postcss-values-parser/lib/operator.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = we(), o = class extends a {
              constructor(f) {
                super(f), this.type = "operator";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), no = R({ "node_modules/postcss-values-parser/lib/paren.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = we(), o = class extends a {
              constructor(f) {
                super(f), this.type = "paren", this.parenType = "";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), io = R({ "node_modules/postcss-values-parser/lib/string.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = we(), o = class extends a {
              constructor(f) {
                super(f), this.type = "string";
              }
              toString() {
                let f = this.quoted ? this.raws.quote : "";
                return [this.raws.before, f, this.value + "", f, this.raws.after].join("");
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), so = R({ "node_modules/postcss-values-parser/lib/word.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = we(), o = class extends a {
              constructor(f) {
                super(f), this.type = "word";
              }
            };
            i.registerWalker(o), n.exports = o;
          } }), oo = R({ "node_modules/postcss-values-parser/lib/unicode-range.js"(e, n) {
            "use strict";
            A();
            var i = ue(), a = we(), o = class extends a {
              constructor(f) {
                super(f), this.type = "unicode-range";
              }
            };
            i.registerWalker(o), n.exports = o;
          } });
          function ao() {
            throw new Error("setTimeout has not been defined");
          }
          function uo() {
            throw new Error("clearTimeout has not been defined");
          }
          function co(e) {
            if (be === setTimeout)
              return setTimeout(e, 0);
            if ((be === ao || !be) && setTimeout)
              return be = setTimeout, setTimeout(e, 0);
            try {
              return be(e, 0);
            } catch {
              try {
                return be.call(null, e, 0);
              } catch {
                return be.call(this, e, 0);
              }
            }
          }
          function zl(e) {
            if (xe === clearTimeout)
              return clearTimeout(e);
            if ((xe === uo || !xe) && clearTimeout)
              return xe = clearTimeout, clearTimeout(e);
            try {
              return xe(e);
            } catch {
              try {
                return xe.call(null, e);
              } catch {
                return xe.call(this, e);
              }
            }
          }
          function Bl() {
            !Ne || !Ce || (Ne = false, Ce.length ? me = Ce.concat(me) : $e = -1, me.length && lo());
          }
          function lo() {
            if (!Ne) {
              var e = co(Bl);
              Ne = true;
              for (var n = me.length; n; ) {
                for (Ce = me, me = []; ++$e < n; )
                  Ce && Ce[$e].run();
                $e = -1, n = me.length;
              }
              Ce = null, Ne = false, zl(e);
            }
          }
          function Fl(e) {
            var n = new Array(arguments.length - 1);
            if (arguments.length > 1)
              for (var i = 1; i < arguments.length; i++)
                n[i - 1] = arguments[i];
            me.push(new fo(e, n)), me.length === 1 && !Ne && co(lo);
          }
          function fo(e, n) {
            this.fun = e, this.array = n;
          }
          function Ae() {
          }
          function Ul(e) {
            throw new Error("process.binding is not supported");
          }
          function Wl() {
            return "/";
          }
          function $l(e) {
            throw new Error("process.chdir is not supported");
          }
          function Vl() {
            return 0;
          }
          function Gl(e) {
            var n = po.call(Re) * 1e-3, i = Math.floor(n), a = Math.floor(n % 1 * 1e9);
            return e && (i = i - e[0], a = a - e[1], a < 0 && (i--, a += 1e9)), [i, a];
          }
          function Hl() {
            var e = new Date(), n = e - ho;
            return n / 1e3;
          }
          var be, xe, me, Ne, Ce, $e, vs, ms, gs, ys, ws, _s, bs, xs, ks, Ss, Os, Ts, Es, qs, As, Ps, Re, po, ho, Rs, Ve, Jl = Le({ "node-modules-polyfills:process"() {
            A(), be = ao, xe = uo, typeof globalThis.setTimeout == "function" && (be = setTimeout), typeof globalThis.clearTimeout == "function" && (xe = clearTimeout), me = [], Ne = false, $e = -1, fo.prototype.run = function() {
              this.fun.apply(null, this.array);
            }, vs = "browser", ms = "browser", gs = true, ys = {}, ws = [], _s = "", bs = {}, xs = {}, ks = {}, Ss = Ae, Os = Ae, Ts = Ae, Es = Ae, qs = Ae, As = Ae, Ps = Ae, Re = globalThis.performance || {}, po = Re.now || Re.mozNow || Re.msNow || Re.oNow || Re.webkitNow || function() {
              return new Date().getTime();
            }, ho = new Date(), Rs = { nextTick: Fl, title: vs, browser: gs, env: ys, argv: ws, version: _s, versions: bs, on: Ss, addListener: Os, once: Ts, off: Es, removeListener: qs, removeAllListeners: As, emit: Ps, binding: Ul, cwd: Wl, chdir: $l, umask: Vl, hrtime: Gl, platform: ms, release: xs, config: ks, uptime: Hl }, Ve = Rs;
          } }), ut, Et, Kl = Le({ "node_modules/rollup-plugin-node-polyfills/polyfills/inherits.js"() {
            A(), typeof Object.create == "function" ? ut = function(n, i) {
              n.super_ = i, n.prototype = Object.create(i.prototype, { constructor: { value: n, enumerable: false, writable: true, configurable: true } });
            } : ut = function(n, i) {
              n.super_ = i;
              var a = function() {
              };
              a.prototype = i.prototype, n.prototype = new a(), n.prototype.constructor = n;
            }, Et = ut;
          } }), vo = {};
          Ot(vo, { _extend: () => It, debuglog: () => mo, default: () => Oo, deprecate: () => qt, format: () => gr, inherits: () => Et, inspect: () => ye, isArray: () => At, isBoolean: () => yr, isBuffer: () => _o, isDate: () => vr, isError: () => He, isFunction: () => Je, isNull: () => Ke, isNullOrUndefined: () => go, isNumber: () => Pt, isObject: () => je, isPrimitive: () => wo, isRegExp: () => Ge, isString: () => Qe, isSymbol: () => yo, isUndefined: () => ge, log: () => bo });
          function gr(e) {
            if (!Qe(e)) {
              for (var n = [], i = 0; i < arguments.length; i++)
                n.push(ye(arguments[i]));
              return n.join(" ");
            }
            for (var i = 1, a = arguments, o = a.length, f = String(e).replace(ko, function(h) {
              if (h === "%%")
                return "%";
              if (i >= o)
                return h;
              switch (h) {
                case "%s":
                  return String(a[i++]);
                case "%d":
                  return Number(a[i++]);
                case "%j":
                  try {
                    return JSON.stringify(a[i++]);
                  } catch {
                    return "[Circular]";
                  }
                default:
                  return h;
              }
            }), p = a[i]; i < o; p = a[++i])
              Ke(p) || !je(p) ? f += " " + p : f += " " + ye(p);
            return f;
          }
          function qt(e, n) {
            if (ge(globalThis.process))
              return function() {
                return qt(e, n).apply(this, arguments);
              };
            if (Ve.noDeprecation === true)
              return e;
            var i = false;
            function a() {
              if (!i) {
                if (Ve.throwDeprecation)
                  throw new Error(n);
                Ve.traceDeprecation ? console.trace(n) : console.error(n), i = true;
              }
              return e.apply(this, arguments);
            }
            return a;
          }
          function mo(e) {
            if (ge(ft) && (ft = Ve.env.NODE_DEBUG || ""), e = e.toUpperCase(), !We[e])
              if (new RegExp("\\b" + e + "\\b", "i").test(ft)) {
                var n = 0;
                We[e] = function() {
                  var i = gr.apply(null, arguments);
                  console.error("%s %d: %s", e, n, i);
                };
              } else
                We[e] = function() {
                };
            return We[e];
          }
          function ye(e, n) {
            var i = { seen: [], stylize: Yl };
            return arguments.length >= 3 && (i.depth = arguments[2]), arguments.length >= 4 && (i.colors = arguments[3]), yr(n) ? i.showHidden = n : n && It(i, n), ge(i.showHidden) && (i.showHidden = false), ge(i.depth) && (i.depth = 2), ge(i.colors) && (i.colors = false), ge(i.customInspect) && (i.customInspect = true), i.colors && (i.stylize = Ql), dr(i, e, i.depth);
          }
          function Ql(e, n) {
            var i = ye.styles[n];
            return i ? "\x1B[" + ye.colors[i][0] + "m" + e + "\x1B[" + ye.colors[i][1] + "m" : e;
          }
          function Yl(e, n) {
            return e;
          }
          function Xl(e) {
            var n = {};
            return e.forEach(function(i, a) {
              n[i] = true;
            }), n;
          }
          function dr(e, n, i) {
            if (e.customInspect && n && Je(n.inspect) && n.inspect !== ye && !(n.constructor && n.constructor.prototype === n)) {
              var a = n.inspect(i, e);
              return Qe(a) || (a = dr(e, a, i)), a;
            }
            var o = Zl(e, n);
            if (o)
              return o;
            var f = Object.keys(n), p = Xl(f);
            if (e.showHidden && (f = Object.getOwnPropertyNames(n)), He(n) && (f.indexOf("message") >= 0 || f.indexOf("description") >= 0))
              return ct(n);
            if (f.length === 0) {
              if (Je(n)) {
                var h = n.name ? ": " + n.name : "";
                return e.stylize("[Function" + h + "]", "special");
              }
              if (Ge(n))
                return e.stylize(RegExp.prototype.toString.call(n), "regexp");
              if (vr(n))
                return e.stylize(Date.prototype.toString.call(n), "date");
              if (He(n))
                return ct(n);
            }
            var g = "", c = false, t3 = ["{", "}"];
            if (At(n) && (c = true, t3 = ["[", "]"]), Je(n)) {
              var r = n.name ? ": " + n.name : "";
              g = " [Function" + r + "]";
            }
            if (Ge(n) && (g = " " + RegExp.prototype.toString.call(n)), vr(n) && (g = " " + Date.prototype.toUTCString.call(n)), He(n) && (g = " " + ct(n)), f.length === 0 && (!c || n.length == 0))
              return t3[0] + g + t3[1];
            if (i < 0)
              return Ge(n) ? e.stylize(RegExp.prototype.toString.call(n), "regexp") : e.stylize("[Object]", "special");
            e.seen.push(n);
            var u;
            return c ? u = ef(e, n, i, p, f) : u = f.map(function(s) {
              return yt(e, n, i, p, s, c);
            }), e.seen.pop(), rf(u, g, t3);
          }
          function Zl(e, n) {
            if (ge(n))
              return e.stylize("undefined", "undefined");
            if (Qe(n)) {
              var i = "'" + JSON.stringify(n).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
              return e.stylize(i, "string");
            }
            if (Pt(n))
              return e.stylize("" + n, "number");
            if (yr(n))
              return e.stylize("" + n, "boolean");
            if (Ke(n))
              return e.stylize("null", "null");
          }
          function ct(e) {
            return "[" + Error.prototype.toString.call(e) + "]";
          }
          function ef(e, n, i, a, o) {
            for (var f = [], p = 0, h = n.length; p < h; ++p)
              xo(n, String(p)) ? f.push(yt(e, n, i, a, String(p), true)) : f.push("");
            return o.forEach(function(g) {
              g.match(/^\d+$/) || f.push(yt(e, n, i, a, g, true));
            }), f;
          }
          function yt(e, n, i, a, o, f) {
            var p, h, g;
            if (g = Object.getOwnPropertyDescriptor(n, o) || { value: n[o] }, g.get ? g.set ? h = e.stylize("[Getter/Setter]", "special") : h = e.stylize("[Getter]", "special") : g.set && (h = e.stylize("[Setter]", "special")), xo(a, o) || (p = "[" + o + "]"), h || (e.seen.indexOf(g.value) < 0 ? (Ke(i) ? h = dr(e, g.value, null) : h = dr(e, g.value, i - 1), h.indexOf(`
`) > -1 && (f ? h = h.split(`
`).map(function(c) {
              return "  " + c;
            }).join(`
`).substr(2) : h = `
` + h.split(`
`).map(function(c) {
              return "   " + c;
            }).join(`
`))) : h = e.stylize("[Circular]", "special")), ge(p)) {
              if (f && o.match(/^\d+$/))
                return h;
              p = JSON.stringify("" + o), p.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (p = p.substr(1, p.length - 2), p = e.stylize(p, "name")) : (p = p.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), p = e.stylize(p, "string"));
            }
            return p + ": " + h;
          }
          function rf(e, n, i) {
            var a = 0, o = e.reduce(function(f, p) {
              return a++, p.indexOf(`
`) >= 0 && a++, f + p.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0);
            return o > 60 ? i[0] + (n === "" ? "" : n + `
 `) + " " + e.join(`,
  `) + " " + i[1] : i[0] + n + " " + e.join(", ") + " " + i[1];
          }
          function At(e) {
            return Array.isArray(e);
          }
          function yr(e) {
            return typeof e == "boolean";
          }
          function Ke(e) {
            return e === null;
          }
          function go(e) {
            return e == null;
          }
          function Pt(e) {
            return typeof e == "number";
          }
          function Qe(e) {
            return typeof e == "string";
          }
          function yo(e) {
            return typeof e == "symbol";
          }
          function ge(e) {
            return e === void 0;
          }
          function Ge(e) {
            return je(e) && Rt(e) === "[object RegExp]";
          }
          function je(e) {
            return typeof e == "object" && e !== null;
          }
          function vr(e) {
            return je(e) && Rt(e) === "[object Date]";
          }
          function He(e) {
            return je(e) && (Rt(e) === "[object Error]" || e instanceof Error);
          }
          function Je(e) {
            return typeof e == "function";
          }
          function wo(e) {
            return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || typeof e > "u";
          }
          function _o(e) {
            return Buffer.isBuffer(e);
          }
          function Rt(e) {
            return Object.prototype.toString.call(e);
          }
          function lt2(e) {
            return e < 10 ? "0" + e.toString(10) : e.toString(10);
          }
          function tf() {
            var e = new Date(), n = [lt2(e.getHours()), lt2(e.getMinutes()), lt2(e.getSeconds())].join(":");
            return [e.getDate(), So[e.getMonth()], n].join(" ");
          }
          function bo() {
            console.log("%s - %s", tf(), gr.apply(null, arguments));
          }
          function It(e, n) {
            if (!n || !je(n))
              return e;
            for (var i = Object.keys(n), a = i.length; a--; )
              e[i[a]] = n[i[a]];
            return e;
          }
          function xo(e, n) {
            return Object.prototype.hasOwnProperty.call(e, n);
          }
          var ko, We, ft, So, Oo, nf = Le({ "node-modules-polyfills:util"() {
            A(), Jl(), Kl(), ko = /%[sdj%]/g, We = {}, ye.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, ye.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" }, So = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], Oo = { inherits: Et, _extend: It, log: bo, isBuffer: _o, isPrimitive: wo, isFunction: Je, isError: He, isDate: vr, isObject: je, isRegExp: Ge, isUndefined: ge, isSymbol: yo, isString: Qe, isNumber: Pt, isNullOrUndefined: go, isNull: Ke, isBoolean: yr, isArray: At, inspect: ye, deprecate: qt, format: gr, debuglog: mo };
          } }), sf = R({ "node-modules-polyfills-commonjs:util"(e, n) {
            A();
            var i = (nf(), Tt(vo));
            if (i && i.default) {
              n.exports = i.default;
              for (let a in i)
                n.exports[a] = i[a];
            } else
              i && (n.exports = i);
          } }), of = R({ "node_modules/postcss-values-parser/lib/errors/TokenizeError.js"(e, n) {
            "use strict";
            A();
            var i = class extends Error {
              constructor(a) {
                super(a), this.name = this.constructor.name, this.message = a || "An error ocurred while tokzenizing.", typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(a).stack;
              }
            };
            n.exports = i;
          } }), af = R({ "node_modules/postcss-values-parser/lib/tokenize.js"(e, n) {
            "use strict";
            A();
            var i = "{".charCodeAt(0), a = "}".charCodeAt(0), o = "(".charCodeAt(0), f = ")".charCodeAt(0), p = "'".charCodeAt(0), h = '"'.charCodeAt(0), g = "\\".charCodeAt(0), c = "/".charCodeAt(0), t3 = ".".charCodeAt(0), r = ",".charCodeAt(0), u = ":".charCodeAt(0), s = "*".charCodeAt(0), l = "-".charCodeAt(0), m = "+".charCodeAt(0), v = "#".charCodeAt(0), y = `
`.charCodeAt(0), w = " ".charCodeAt(0), d = "\f".charCodeAt(0), _ = "	".charCodeAt(0), S = "\r".charCodeAt(0), x = "@".charCodeAt(0), N = "e".charCodeAt(0), P = "E".charCodeAt(0), W = "0".charCodeAt(0), U = "9".charCodeAt(0), H = "u".charCodeAt(0), D = "U".charCodeAt(0), $ = /[ \n\t\r\{\(\)'"\\;,/]/g, B = /[ \n\t\r\(\)\{\}\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g, O = /[ \n\t\r\(\)\{\}\*:;@!&'"\-\+\|~>,\[\]\\]|\//g, j = /^[a-z0-9]/i, C = /^[a-f0-9?\-]/i, I = sf(), X = of();
            n.exports = function(Q, K) {
              K = K || {};
              let J = [], M = Q.valueOf(), Y = M.length, G = -1, E = 1, k = 0, b = 0, L = null, q, T, F, z, re, ne, ce, fe, te, ie, ae, se;
              function le(Ze) {
                let _e = I.format("Unclosed %s at line: %d, column: %d, token: %d", Ze, E, k - G, k);
                throw new X(_e);
              }
              function pe() {
                let Ze = I.format("Syntax error at line: %d, column: %d, token: %d", E, k - G, k);
                throw new X(Ze);
              }
              for (; k < Y; ) {
                switch (q = M.charCodeAt(k), q === y && (G = k, E += 1), q) {
                  case y:
                  case w:
                  case _:
                  case S:
                  case d:
                    T = k;
                    do
                      T += 1, q = M.charCodeAt(T), q === y && (G = T, E += 1);
                    while (q === w || q === y || q === _ || q === S || q === d);
                    J.push(["space", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    break;
                  case u:
                    T = k + 1, J.push(["colon", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    break;
                  case r:
                    T = k + 1, J.push(["comma", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    break;
                  case i:
                    J.push(["{", "{", E, k - G, E, T - G, k]);
                    break;
                  case a:
                    J.push(["}", "}", E, k - G, E, T - G, k]);
                    break;
                  case o:
                    b++, L = !L && b === 1 && J.length > 0 && J[J.length - 1][0] === "word" && J[J.length - 1][1] === "url", J.push(["(", "(", E, k - G, E, T - G, k]);
                    break;
                  case f:
                    b--, L = L && b > 0, J.push([")", ")", E, k - G, E, T - G, k]);
                    break;
                  case p:
                  case h:
                    F = q === p ? "'" : '"', T = k;
                    do
                      for (ie = false, T = M.indexOf(F, T + 1), T === -1 && le("quote", F), ae = T; M.charCodeAt(ae - 1) === g; )
                        ae -= 1, ie = !ie;
                    while (ie);
                    J.push(["string", M.slice(k, T + 1), E, k - G, E, T - G, k]), k = T;
                    break;
                  case x:
                    $.lastIndex = k + 1, $.test(M), $.lastIndex === 0 ? T = M.length - 1 : T = $.lastIndex - 2, J.push(["atword", M.slice(k, T + 1), E, k - G, E, T - G, k]), k = T;
                    break;
                  case g:
                    T = k, q = M.charCodeAt(T + 1), ce && q !== c && q !== w && q !== y && q !== _ && q !== S && q !== d && (T += 1), J.push(["word", M.slice(k, T + 1), E, k - G, E, T - G, k]), k = T;
                    break;
                  case m:
                  case l:
                  case s:
                    T = k + 1, se = M.slice(k + 1, T + 1);
                    let Ze = M.slice(k - 1, k);
                    if (q === l && se.charCodeAt(0) === l) {
                      T++, J.push(["word", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                      break;
                    }
                    J.push(["operator", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    break;
                  default:
                    if (q === c && (M.charCodeAt(k + 1) === s || K.loose && !L && M.charCodeAt(k + 1) === c)) {
                      if (M.charCodeAt(k + 1) === s)
                        T = M.indexOf("*/", k + 2) + 1, T === 0 && le("comment", "*/");
                      else {
                        let Be = M.indexOf(`
`, k + 2);
                        T = Be !== -1 ? Be - 1 : Y;
                      }
                      ne = M.slice(k, T + 1), z = ne.split(`
`), re = z.length - 1, re > 0 ? (fe = E + re, te = T - z[re].length) : (fe = E, te = G), J.push(["comment", ne, E, k - G, fe, T - te, k]), G = te, E = fe, k = T;
                    } else if (q === v && !j.test(M.slice(k + 1, k + 2)))
                      T = k + 1, J.push(["#", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    else if ((q === H || q === D) && M.charCodeAt(k + 1) === m) {
                      T = k + 2;
                      do
                        T += 1, q = M.charCodeAt(T);
                      while (T < Y && C.test(M.slice(T, T + 1)));
                      J.push(["unicoderange", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    } else if (q === c)
                      T = k + 1, J.push(["operator", M.slice(k, T), E, k - G, E, T - G, k]), k = T - 1;
                    else {
                      let _e = B;
                      if (q >= W && q <= U && (_e = O), _e.lastIndex = k + 1, _e.test(M), _e.lastIndex === 0 ? T = M.length - 1 : T = _e.lastIndex - 2, _e === O || q === t3) {
                        let Be = M.charCodeAt(T), Bt = M.charCodeAt(T + 1), Ft = M.charCodeAt(T + 2);
                        (Be === N || Be === P) && (Bt === l || Bt === m) && Ft >= W && Ft <= U && (O.lastIndex = T + 2, O.test(M), O.lastIndex === 0 ? T = M.length - 1 : T = O.lastIndex - 2);
                      }
                      J.push(["word", M.slice(k, T + 1), E, k - G, E, T - G, k]), k = T;
                    }
                    break;
                }
                k++;
              }
              return J;
            };
          } }), To = R({ "node_modules/flatten/index.js"(e, n) {
            A(), n.exports = function(a, o) {
              if (o = typeof o == "number" ? o : 1 / 0, !o)
                return Array.isArray(a) ? a.map(function(p) {
                  return p;
                }) : a;
              return f(a, 1);
              function f(p, h) {
                return p.reduce(function(g, c) {
                  return Array.isArray(c) && h < o ? g.concat(f(c, h + 1)) : g.concat(c);
                }, []);
              }
            };
          } }), Eo = R({ "node_modules/indexes-of/index.js"(e, n) {
            A(), n.exports = function(i, a) {
              for (var o = -1, f = []; (o = i.indexOf(a, o + 1)) !== -1; )
                f.push(o);
              return f;
            };
          } }), qo = R({ "node_modules/uniq/uniq.js"(e, n) {
            "use strict";
            A();
            function i(f, p) {
              for (var h = 1, g = f.length, c = f[0], t3 = f[0], r = 1; r < g; ++r)
                if (t3 = c, c = f[r], p(c, t3)) {
                  if (r === h) {
                    h++;
                    continue;
                  }
                  f[h++] = c;
                }
              return f.length = h, f;
            }
            function a(f) {
              for (var p = 1, h = f.length, g = f[0], c = f[0], t3 = 1; t3 < h; ++t3, c = g)
                if (c = g, g = f[t3], g !== c) {
                  if (t3 === p) {
                    p++;
                    continue;
                  }
                  f[p++] = g;
                }
              return f.length = p, f;
            }
            function o(f, p, h) {
              return f.length === 0 ? f : p ? (h || f.sort(p), i(f, p)) : (h || f.sort(), a(f));
            }
            n.exports = o;
          } }), uf = R({ "node_modules/postcss-values-parser/lib/errors/ParserError.js"(e, n) {
            "use strict";
            A();
            var i = class extends Error {
              constructor(a) {
                super(a), this.name = this.constructor.name, this.message = a || "An error ocurred while parsing.", typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(a).stack;
              }
            };
            n.exports = i;
          } }), cf = R({ "node_modules/postcss-values-parser/lib/parser.js"(e, n) {
            "use strict";
            A();
            var i = Ll(), a = Ks(), o = Qs(), f = Ys(), p = Xs(), h = Zs(), g = eo(), c = ro(), t3 = to(), r = no(), u = io(), s = so(), l = oo(), m = af(), v = To(), y = Eo(), w = qo(), d = uf();
            function _(S) {
              return S.sort((x, N) => x - N);
            }
            n.exports = class {
              constructor(x, N) {
                let P = { loose: false };
                this.cache = [], this.input = x, this.options = Object.assign({}, P, N), this.position = 0, this.unbalanced = 0, this.root = new i();
                let W = new a();
                this.root.append(W), this.current = W, this.tokens = m(x, this.options);
              }
              parse() {
                return this.loop();
              }
              colon() {
                let x = this.currToken;
                this.newNode(new f({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++;
              }
              comma() {
                let x = this.currToken;
                this.newNode(new p({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++;
              }
              comment() {
                let x = false, N = this.currToken[1].replace(/\/\*|\*\//g, ""), P;
                this.options.loose && N.startsWith("//") && (N = N.substring(2), x = true), P = new h({ value: N, inline: x, source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] }), this.newNode(P), this.position++;
              }
              error(x, N) {
                throw new d(x + " at line: ".concat(N[2], ", column ").concat(N[3]));
              }
              loop() {
                for (; this.position < this.tokens.length; )
                  this.parseTokens();
                return !this.current.last && this.spaces ? this.current.raws.before += this.spaces : this.spaces && (this.current.last.raws.after += this.spaces), this.spaces = "", this.root;
              }
              operator() {
                let x = this.currToken[1], N;
                if (x === "+" || x === "-") {
                  if (this.options.loose || this.position > 0 && (this.current.type === "func" && this.current.value === "calc" ? this.prevToken[0] !== "space" && this.prevToken[0] !== "(" ? this.error("Syntax Error", this.currToken) : this.nextToken[0] !== "space" && this.nextToken[0] !== "word" ? this.error("Syntax Error", this.currToken) : this.nextToken[0] === "word" && this.current.last.type !== "operator" && this.current.last.value !== "(" && this.error("Syntax Error", this.currToken) : (this.nextToken[0] === "space" || this.nextToken[0] === "operator" || this.prevToken[0] === "operator") && this.error("Syntax Error", this.currToken)), this.options.loose) {
                    if ((!this.current.nodes.length || this.current.last && this.current.last.type === "operator") && this.nextToken[0] === "word")
                      return this.word();
                  } else if (this.nextToken[0] === "word")
                    return this.word();
                }
                return N = new t3({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }), this.position++, this.newNode(N);
              }
              parseTokens() {
                switch (this.currToken[0]) {
                  case "space":
                    this.space();
                    break;
                  case "colon":
                    this.colon();
                    break;
                  case "comma":
                    this.comma();
                    break;
                  case "comment":
                    this.comment();
                    break;
                  case "(":
                    this.parenOpen();
                    break;
                  case ")":
                    this.parenClose();
                    break;
                  case "atword":
                  case "word":
                    this.word();
                    break;
                  case "operator":
                    this.operator();
                    break;
                  case "string":
                    this.string();
                    break;
                  case "unicoderange":
                    this.unicodeRange();
                    break;
                  default:
                    this.word();
                    break;
                }
              }
              parenOpen() {
                let x = 1, N = this.position + 1, P = this.currToken, W;
                for (; N < this.tokens.length && x; ) {
                  let U = this.tokens[N];
                  U[0] === "(" && x++, U[0] === ")" && x--, N++;
                }
                if (x && this.error("Expected closing parenthesis", P), W = this.current.last, W && W.type === "func" && W.unbalanced < 0 && (W.unbalanced = 0, this.current = W), this.current.unbalanced++, this.newNode(new r({ value: P[1], source: { start: { line: P[2], column: P[3] }, end: { line: P[4], column: P[5] } }, sourceIndex: P[6] })), this.position++, this.current.type === "func" && this.current.unbalanced && this.current.value === "url" && this.currToken[0] !== "string" && this.currToken[0] !== ")" && !this.options.loose) {
                  let U = this.nextToken, H = this.currToken[1], D = { line: this.currToken[2], column: this.currToken[3] };
                  for (; U && U[0] !== ")" && this.current.unbalanced; )
                    this.position++, H += this.currToken[1], U = this.nextToken;
                  this.position !== this.tokens.length - 1 && (this.position++, this.newNode(new s({ value: H, source: { start: D, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] })));
                }
              }
              parenClose() {
                let x = this.currToken;
                this.newNode(new r({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++, !(this.position >= this.tokens.length - 1 && !this.current.unbalanced) && (this.current.unbalanced--, this.current.unbalanced < 0 && this.error("Expected opening parenthesis", x), !this.current.unbalanced && this.cache.length && (this.current = this.cache.pop()));
              }
              space() {
                let x = this.currToken;
                this.position === this.tokens.length - 1 || this.nextToken[0] === "," || this.nextToken[0] === ")" ? (this.current.last.raws.after += x[1], this.position++) : (this.spaces = x[1], this.position++);
              }
              unicodeRange() {
                let x = this.currToken;
                this.newNode(new l({ value: x[1], source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6] })), this.position++;
              }
              splitWord() {
                let x = this.nextToken, N = this.currToken[1], P = /^[\+\-]?((\d+(\.\d*)?)|(\.\d+))([eE][\+\-]?\d+)?/, W = /^(?!\#([a-z0-9]+))[\#\{\}]/gi, U, H;
                if (!W.test(N))
                  for (; x && x[0] === "word"; )
                    this.position++, N += this.currToken[1], x = this.nextToken;
                U = y(N, "@"), H = _(w(v([[0], U]))), H.forEach((D, $) => {
                  let B = H[$ + 1] || N.length, O = N.slice(D, B), j;
                  if (~U.indexOf(D))
                    j = new o({ value: O.slice(1), source: { start: { line: this.currToken[2], column: this.currToken[3] + D }, end: { line: this.currToken[4], column: this.currToken[3] + (B - 1) } }, sourceIndex: this.currToken[6] + H[$] });
                  else if (P.test(this.currToken[1])) {
                    let C = O.replace(P, "");
                    j = new c({ value: O.replace(C, ""), source: { start: { line: this.currToken[2], column: this.currToken[3] + D }, end: { line: this.currToken[4], column: this.currToken[3] + (B - 1) } }, sourceIndex: this.currToken[6] + H[$], unit: C });
                  } else
                    j = new (x && x[0] === "(" ? g : s)({ value: O, source: { start: { line: this.currToken[2], column: this.currToken[3] + D }, end: { line: this.currToken[4], column: this.currToken[3] + (B - 1) } }, sourceIndex: this.currToken[6] + H[$] }), j.type === "word" ? (j.isHex = /^#(.+)/.test(O), j.isColor = /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(O)) : this.cache.push(this.current);
                  this.newNode(j);
                }), this.position++;
              }
              string() {
                let x = this.currToken, N = this.currToken[1], P = /^(\"|\')/, W = P.test(N), U = "", H;
                W && (U = N.match(P)[0], N = N.slice(1, N.length - 1)), H = new u({ value: N, source: { start: { line: x[2], column: x[3] }, end: { line: x[4], column: x[5] } }, sourceIndex: x[6], quoted: W }), H.raws.quote = U, this.newNode(H), this.position++;
              }
              word() {
                return this.splitWord();
              }
              newNode(x) {
                return this.spaces && (x.raws.before += this.spaces, this.spaces = ""), this.current.append(x);
              }
              get currToken() {
                return this.tokens[this.position];
              }
              get nextToken() {
                return this.tokens[this.position + 1];
              }
              get prevToken() {
                return this.tokens[this.position - 1];
              }
            };
          } }), lf = R({ "node_modules/postcss-values-parser/lib/index.js"(e, n) {
            "use strict";
            A();
            var i = cf(), a = Qs(), o = Ys(), f = Xs(), p = Zs(), h = eo(), g = ro(), c = to(), t3 = no(), r = io(), u = oo(), s = Ks(), l = so(), m = function(v, y) {
              return new i(v, y);
            };
            m.atword = function(v) {
              return new a(v);
            }, m.colon = function(v) {
              return new o(Object.assign({ value: ":" }, v));
            }, m.comma = function(v) {
              return new f(Object.assign({ value: "," }, v));
            }, m.comment = function(v) {
              return new p(v);
            }, m.func = function(v) {
              return new h(v);
            }, m.number = function(v) {
              return new g(v);
            }, m.operator = function(v) {
              return new c(v);
            }, m.paren = function(v) {
              return new t3(Object.assign({ value: "(" }, v));
            }, m.string = function(v) {
              return new r(Object.assign({ quote: "'" }, v));
            }, m.value = function(v) {
              return new s(v);
            }, m.word = function(v) {
              return new l(v);
            }, m.unicodeRange = function(v) {
              return new u(v);
            }, n.exports = m;
          } }), ze = R({ "node_modules/postcss-selector-parser/dist/selectors/node.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
              return typeof p;
            } : function(p) {
              return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
            };
            function a(p, h) {
              if (!(p instanceof h))
                throw new TypeError("Cannot call a class as a function");
            }
            var o = function p(h, g) {
              if ((typeof h > "u" ? "undefined" : i(h)) !== "object")
                return h;
              var c = new h.constructor();
              for (var t3 in h)
                if (!!h.hasOwnProperty(t3)) {
                  var r = h[t3], u = typeof r > "u" ? "undefined" : i(r);
                  t3 === "parent" && u === "object" ? g && (c[t3] = g) : r instanceof Array ? c[t3] = r.map(function(s) {
                    return p(s, c);
                  }) : c[t3] = p(r, c);
                }
              return c;
            }, f = function() {
              function p() {
                var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                a(this, p);
                for (var g in h)
                  this[g] = h[g];
                var c = h.spaces;
                c = c === void 0 ? {} : c;
                var t3 = c.before, r = t3 === void 0 ? "" : t3, u = c.after, s = u === void 0 ? "" : u;
                this.spaces = { before: r, after: s };
              }
              return p.prototype.remove = function() {
                return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
              }, p.prototype.replaceWith = function() {
                if (this.parent) {
                  for (var g in arguments)
                    this.parent.insertBefore(this, arguments[g]);
                  this.remove();
                }
                return this;
              }, p.prototype.next = function() {
                return this.parent.at(this.parent.index(this) + 1);
              }, p.prototype.prev = function() {
                return this.parent.at(this.parent.index(this) - 1);
              }, p.prototype.clone = function() {
                var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = o(this);
                for (var t3 in g)
                  c[t3] = g[t3];
                return c;
              }, p.prototype.toString = function() {
                return [this.spaces.before, String(this.value), this.spaces.after].join("");
              }, p;
            }();
            e.default = f, n.exports = e.default;
          } }), oe = R({ "node_modules/postcss-selector-parser/dist/selectors/types.js"(e) {
            "use strict";
            A(), e.__esModule = true;
            var n = e.TAG = "tag", i = e.STRING = "string", a = e.SELECTOR = "selector", o = e.ROOT = "root", f = e.PSEUDO = "pseudo", p = e.NESTING = "nesting", h = e.ID = "id", g = e.COMMENT = "comment", c = e.COMBINATOR = "combinator", t3 = e.CLASS = "class", r = e.ATTRIBUTE = "attribute", u = e.UNIVERSAL = "universal";
          } }), Ct = R({ "node_modules/postcss-selector-parser/dist/selectors/container.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function s(l, m) {
                for (var v = 0; v < m.length; v++) {
                  var y = m[v];
                  y.enumerable = y.enumerable || false, y.configurable = true, "value" in y && (y.writable = true), Object.defineProperty(l, y.key, y);
                }
              }
              return function(l, m, v) {
                return m && s(l.prototype, m), v && s(l, v), l;
              };
            }(), a = ze(), o = g(a), f = oe(), p = h(f);
            function h(s) {
              if (s && s.__esModule)
                return s;
              var l = {};
              if (s != null)
                for (var m in s)
                  Object.prototype.hasOwnProperty.call(s, m) && (l[m] = s[m]);
              return l.default = s, l;
            }
            function g(s) {
              return s && s.__esModule ? s : { default: s };
            }
            function c(s, l) {
              if (!(s instanceof l))
                throw new TypeError("Cannot call a class as a function");
            }
            function t3(s, l) {
              if (!s)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return l && (typeof l == "object" || typeof l == "function") ? l : s;
            }
            function r(s, l) {
              if (typeof l != "function" && l !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof l);
              s.prototype = Object.create(l && l.prototype, { constructor: { value: s, enumerable: false, writable: true, configurable: true } }), l && (Object.setPrototypeOf ? Object.setPrototypeOf(s, l) : s.__proto__ = l);
            }
            var u = function(s) {
              r(l, s);
              function l(m) {
                c(this, l);
                var v = t3(this, s.call(this, m));
                return v.nodes || (v.nodes = []), v;
              }
              return l.prototype.append = function(v) {
                return v.parent = this, this.nodes.push(v), this;
              }, l.prototype.prepend = function(v) {
                return v.parent = this, this.nodes.unshift(v), this;
              }, l.prototype.at = function(v) {
                return this.nodes[v];
              }, l.prototype.index = function(v) {
                return typeof v == "number" ? v : this.nodes.indexOf(v);
              }, l.prototype.removeChild = function(v) {
                v = this.index(v), this.at(v).parent = void 0, this.nodes.splice(v, 1);
                var y = void 0;
                for (var w in this.indexes)
                  y = this.indexes[w], y >= v && (this.indexes[w] = y - 1);
                return this;
              }, l.prototype.removeAll = function() {
                for (var w = this.nodes, v = Array.isArray(w), y = 0, w = v ? w : w[Symbol.iterator](); ; ) {
                  var d;
                  if (v) {
                    if (y >= w.length)
                      break;
                    d = w[y++];
                  } else {
                    if (y = w.next(), y.done)
                      break;
                    d = y.value;
                  }
                  var _ = d;
                  _.parent = void 0;
                }
                return this.nodes = [], this;
              }, l.prototype.empty = function() {
                return this.removeAll();
              }, l.prototype.insertAfter = function(v, y) {
                var w = this.index(v);
                this.nodes.splice(w + 1, 0, y);
                var d = void 0;
                for (var _ in this.indexes)
                  d = this.indexes[_], w <= d && (this.indexes[_] = d + this.nodes.length);
                return this;
              }, l.prototype.insertBefore = function(v, y) {
                var w = this.index(v);
                this.nodes.splice(w, 0, y);
                var d = void 0;
                for (var _ in this.indexes)
                  d = this.indexes[_], w <= d && (this.indexes[_] = d + this.nodes.length);
                return this;
              }, l.prototype.each = function(v) {
                this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach++;
                var y = this.lastEach;
                if (this.indexes[y] = 0, !!this.length) {
                  for (var w = void 0, d = void 0; this.indexes[y] < this.length && (w = this.indexes[y], d = v(this.at(w), w), d !== false); )
                    this.indexes[y] += 1;
                  if (delete this.indexes[y], d === false)
                    return false;
                }
              }, l.prototype.walk = function(v) {
                return this.each(function(y, w) {
                  var d = v(y, w);
                  if (d !== false && y.length && (d = y.walk(v)), d === false)
                    return false;
                });
              }, l.prototype.walkAttributes = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === p.ATTRIBUTE)
                    return v.call(y, w);
                });
              }, l.prototype.walkClasses = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === p.CLASS)
                    return v.call(y, w);
                });
              }, l.prototype.walkCombinators = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === p.COMBINATOR)
                    return v.call(y, w);
                });
              }, l.prototype.walkComments = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === p.COMMENT)
                    return v.call(y, w);
                });
              }, l.prototype.walkIds = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === p.ID)
                    return v.call(y, w);
                });
              }, l.prototype.walkNesting = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === p.NESTING)
                    return v.call(y, w);
                });
              }, l.prototype.walkPseudos = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === p.PSEUDO)
                    return v.call(y, w);
                });
              }, l.prototype.walkTags = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === p.TAG)
                    return v.call(y, w);
                });
              }, l.prototype.walkUniversals = function(v) {
                var y = this;
                return this.walk(function(w) {
                  if (w.type === p.UNIVERSAL)
                    return v.call(y, w);
                });
              }, l.prototype.split = function(v) {
                var y = this, w = [];
                return this.reduce(function(d, _, S) {
                  var x = v.call(y, _);
                  return w.push(_), x ? (d.push(w), w = []) : S === y.length - 1 && d.push(w), d;
                }, []);
              }, l.prototype.map = function(v) {
                return this.nodes.map(v);
              }, l.prototype.reduce = function(v, y) {
                return this.nodes.reduce(v, y);
              }, l.prototype.every = function(v) {
                return this.nodes.every(v);
              }, l.prototype.some = function(v) {
                return this.nodes.some(v);
              }, l.prototype.filter = function(v) {
                return this.nodes.filter(v);
              }, l.prototype.sort = function(v) {
                return this.nodes.sort(v);
              }, l.prototype.toString = function() {
                return this.map(String).join("");
              }, i(l, [{ key: "first", get: function() {
                return this.at(0);
              } }, { key: "last", get: function() {
                return this.at(this.length - 1);
              } }, { key: "length", get: function() {
                return this.nodes.length;
              } }]), l;
            }(o.default);
            e.default = u, n.exports = e.default;
          } }), Ao = R({ "node_modules/postcss-selector-parser/dist/selectors/root.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ct(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.ROOT, s;
              }
              return r.prototype.toString = function() {
                var s = this.reduce(function(l, m) {
                  var v = String(m);
                  return v ? l + v + "," : "";
                }, "").slice(0, -1);
                return this.trailingComma ? s + "," : s;
              }, r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), Po = R({ "node_modules/postcss-selector-parser/dist/selectors/selector.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ct(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.SELECTOR, s;
              }
              return r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), Ye = R({ "node_modules/postcss-selector-parser/dist/selectors/namespace.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function t3(r, u) {
                for (var s = 0; s < u.length; s++) {
                  var l = u[s];
                  l.enumerable = l.enumerable || false, l.configurable = true, "value" in l && (l.writable = true), Object.defineProperty(r, l.key, l);
                }
              }
              return function(r, u, s) {
                return u && t3(r.prototype, u), s && t3(r, s), r;
              };
            }(), a = ze(), o = f(a);
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r() {
                return p(this, r), h(this, t3.apply(this, arguments));
              }
              return r.prototype.toString = function() {
                return [this.spaces.before, this.ns, String(this.value), this.spaces.after].join("");
              }, i(r, [{ key: "ns", get: function() {
                var s = this.namespace;
                return s ? (typeof s == "string" ? s : "") + "|" : "";
              } }]), r;
            }(o.default);
            e.default = c, n.exports = e.default;
          } }), Ro = R({ "node_modules/postcss-selector-parser/dist/selectors/className.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.CLASS, s;
              }
              return r.prototype.toString = function() {
                return [this.spaces.before, this.ns, String("." + this.value), this.spaces.after].join("");
              }, r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), Io = R({ "node_modules/postcss-selector-parser/dist/selectors/comment.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.COMMENT, s;
              }
              return r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), Co = R({ "node_modules/postcss-selector-parser/dist/selectors/id.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.ID, s;
              }
              return r.prototype.toString = function() {
                return [this.spaces.before, this.ns, String("#" + this.value), this.spaces.after].join("");
              }, r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), No = R({ "node_modules/postcss-selector-parser/dist/selectors/tag.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.TAG, s;
              }
              return r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), jo = R({ "node_modules/postcss-selector-parser/dist/selectors/string.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.STRING, s;
              }
              return r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), Mo = R({ "node_modules/postcss-selector-parser/dist/selectors/pseudo.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ct(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.PSEUDO, s;
              }
              return r.prototype.toString = function() {
                var s = this.length ? "(" + this.map(String).join(",") + ")" : "";
                return [this.spaces.before, String(this.value), s, this.spaces.after].join("");
              }, r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), Do = R({ "node_modules/postcss-selector-parser/dist/selectors/attribute.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.ATTRIBUTE, s.raws = {}, s;
              }
              return r.prototype.toString = function() {
                var s = [this.spaces.before, "[", this.ns, this.attribute];
                return this.operator && s.push(this.operator), this.value && s.push(this.value), this.raws.insensitive ? s.push(this.raws.insensitive) : this.insensitive && s.push(" i"), s.push("]"), s.concat(this.spaces.after).join("");
              }, r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), Lo = R({ "node_modules/postcss-selector-parser/dist/selectors/universal.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = Ye(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.UNIVERSAL, s.value = "*", s;
              }
              return r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), zo = R({ "node_modules/postcss-selector-parser/dist/selectors/combinator.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.COMBINATOR, s;
              }
              return r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), Bo = R({ "node_modules/postcss-selector-parser/dist/selectors/nesting.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = ze(), a = f(i), o = oe();
            function f(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function p(t3, r) {
              if (!(t3 instanceof r))
                throw new TypeError("Cannot call a class as a function");
            }
            function h(t3, r) {
              if (!t3)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return r && (typeof r == "object" || typeof r == "function") ? r : t3;
            }
            function g(t3, r) {
              if (typeof r != "function" && r !== null)
                throw new TypeError("Super expression must either be null or a function, not " + typeof r);
              t3.prototype = Object.create(r && r.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t3, r) : t3.__proto__ = r);
            }
            var c = function(t3) {
              g(r, t3);
              function r(u) {
                p(this, r);
                var s = h(this, t3.call(this, u));
                return s.type = o.NESTING, s.value = "&", s;
              }
              return r;
            }(a.default);
            e.default = c, n.exports = e.default;
          } }), ff = R({ "node_modules/postcss-selector-parser/dist/sortAscending.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = i;
            function i(a) {
              return a.sort(function(o, f) {
                return o - f;
              });
            }
            n.exports = e.default;
          } }), pf = R({ "node_modules/postcss-selector-parser/dist/tokenize.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = H;
            var i = 39, a = 34, o = 92, f = 47, p = 10, h = 32, g = 12, c = 9, t3 = 13, r = 43, u = 62, s = 126, l = 124, m = 44, v = 40, y = 41, w = 91, d = 93, _ = 59, S = 42, x = 58, N = 38, P = 64, W = /[ \n\t\r\{\(\)'"\\;/]/g, U = /[ \n\t\r\(\)\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g;
            function H(D) {
              for (var $ = [], B = D.css.valueOf(), O = void 0, j = void 0, C = void 0, I = void 0, X = void 0, Z = void 0, Q = void 0, K = void 0, J = void 0, M = void 0, Y = void 0, G = B.length, E = -1, k = 1, b = 0, L = function(T, F) {
                if (D.safe)
                  B += F, j = B.length - 1;
                else
                  throw D.error("Unclosed " + T, k, b - E, b);
              }; b < G; ) {
                switch (O = B.charCodeAt(b), O === p && (E = b, k += 1), O) {
                  case p:
                  case h:
                  case c:
                  case t3:
                  case g:
                    j = b;
                    do
                      j += 1, O = B.charCodeAt(j), O === p && (E = j, k += 1);
                    while (O === h || O === p || O === c || O === t3 || O === g);
                    $.push(["space", B.slice(b, j), k, b - E, b]), b = j - 1;
                    break;
                  case r:
                  case u:
                  case s:
                  case l:
                    j = b;
                    do
                      j += 1, O = B.charCodeAt(j);
                    while (O === r || O === u || O === s || O === l);
                    $.push(["combinator", B.slice(b, j), k, b - E, b]), b = j - 1;
                    break;
                  case S:
                    $.push(["*", "*", k, b - E, b]);
                    break;
                  case N:
                    $.push(["&", "&", k, b - E, b]);
                    break;
                  case m:
                    $.push([",", ",", k, b - E, b]);
                    break;
                  case w:
                    $.push(["[", "[", k, b - E, b]);
                    break;
                  case d:
                    $.push(["]", "]", k, b - E, b]);
                    break;
                  case x:
                    $.push([":", ":", k, b - E, b]);
                    break;
                  case _:
                    $.push([";", ";", k, b - E, b]);
                    break;
                  case v:
                    $.push(["(", "(", k, b - E, b]);
                    break;
                  case y:
                    $.push([")", ")", k, b - E, b]);
                    break;
                  case i:
                  case a:
                    C = O === i ? "'" : '"', j = b;
                    do
                      for (M = false, j = B.indexOf(C, j + 1), j === -1 && L("quote", C), Y = j; B.charCodeAt(Y - 1) === o; )
                        Y -= 1, M = !M;
                    while (M);
                    $.push(["string", B.slice(b, j + 1), k, b - E, k, j - E, b]), b = j;
                    break;
                  case P:
                    W.lastIndex = b + 1, W.test(B), W.lastIndex === 0 ? j = B.length - 1 : j = W.lastIndex - 2, $.push(["at-word", B.slice(b, j + 1), k, b - E, k, j - E, b]), b = j;
                    break;
                  case o:
                    for (j = b, Q = true; B.charCodeAt(j + 1) === o; )
                      j += 1, Q = !Q;
                    O = B.charCodeAt(j + 1), Q && O !== f && O !== h && O !== p && O !== c && O !== t3 && O !== g && (j += 1), $.push(["word", B.slice(b, j + 1), k, b - E, k, j - E, b]), b = j;
                    break;
                  default:
                    O === f && B.charCodeAt(b + 1) === S ? (j = B.indexOf("*/", b + 2) + 1, j === 0 && L("comment", "*/"), Z = B.slice(b, j + 1), I = Z.split(`
`), X = I.length - 1, X > 0 ? (K = k + X, J = j - I[X].length) : (K = k, J = E), $.push(["comment", Z, k, b - E, K, j - J, b]), E = J, k = K, b = j) : (U.lastIndex = b + 1, U.test(B), U.lastIndex === 0 ? j = B.length - 1 : j = U.lastIndex - 2, $.push(["word", B.slice(b, j + 1), k, b - E, k, j - E, b]), b = j);
                    break;
                }
                b++;
              }
              return $;
            }
            n.exports = e.default;
          } }), hf = R({ "node_modules/postcss-selector-parser/dist/parser.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function E(k, b) {
                for (var L = 0; L < b.length; L++) {
                  var q = b[L];
                  q.enumerable = q.enumerable || false, q.configurable = true, "value" in q && (q.writable = true), Object.defineProperty(k, q.key, q);
                }
              }
              return function(k, b, L) {
                return b && E(k.prototype, b), L && E(k, L), k;
              };
            }(), a = To(), o = M(a), f = Eo(), p = M(f), h = qo(), g = M(h), c = Ao(), t3 = M(c), r = Po(), u = M(r), s = Ro(), l = M(s), m = Io(), v = M(m), y = Co(), w = M(y), d = No(), _ = M(d), S = jo(), x = M(S), N = Mo(), P = M(N), W = Do(), U = M(W), H = Lo(), D = M(H), $ = zo(), B = M($), O = Bo(), j = M(O), C = ff(), I = M(C), X = pf(), Z = M(X), Q = oe(), K = J(Q);
            function J(E) {
              if (E && E.__esModule)
                return E;
              var k = {};
              if (E != null)
                for (var b in E)
                  Object.prototype.hasOwnProperty.call(E, b) && (k[b] = E[b]);
              return k.default = E, k;
            }
            function M(E) {
              return E && E.__esModule ? E : { default: E };
            }
            function Y(E, k) {
              if (!(E instanceof k))
                throw new TypeError("Cannot call a class as a function");
            }
            var G = function() {
              function E(k) {
                Y(this, E), this.input = k, this.lossy = k.options.lossless === false, this.position = 0, this.root = new t3.default();
                var b = new u.default();
                return this.root.append(b), this.current = b, this.lossy ? this.tokens = (0, Z.default)({ safe: k.safe, css: k.css.trim() }) : this.tokens = (0, Z.default)(k), this.loop();
              }
              return E.prototype.attribute = function() {
                var b = "", L = void 0, q = this.currToken;
                for (this.position++; this.position < this.tokens.length && this.currToken[0] !== "]"; )
                  b += this.tokens[this.position][1], this.position++;
                this.position === this.tokens.length && !~b.indexOf("]") && this.error("Expected a closing square bracket.");
                var T = b.split(/((?:[*~^$|]?=))([^]*)/), F = T[0].split(/(\|)/g), z = { operator: T[1], value: T[2], source: { start: { line: q[2], column: q[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: q[4] };
                if (F.length > 1 ? (F[0] === "" && (F[0] = true), z.attribute = this.parseValue(F[2]), z.namespace = this.parseNamespace(F[0])) : z.attribute = this.parseValue(T[0]), L = new U.default(z), T[2]) {
                  var re = T[2].split(/(\s+i\s*?)$/), ne = re[0].trim();
                  L.value = this.lossy ? ne : re[0], re[1] && (L.insensitive = true, this.lossy || (L.raws.insensitive = re[1])), L.quoted = ne[0] === "'" || ne[0] === '"', L.raws.unquoted = L.quoted ? ne.slice(1, -1) : ne;
                }
                this.newNode(L), this.position++;
              }, E.prototype.combinator = function() {
                if (this.currToken[1] === "|")
                  return this.namespace();
                for (var b = new B.default({ value: "", source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }); this.position < this.tokens.length && this.currToken && (this.currToken[0] === "space" || this.currToken[0] === "combinator"); )
                  this.nextToken && this.nextToken[0] === "combinator" ? (b.spaces.before = this.parseSpace(this.currToken[1]), b.source.start.line = this.nextToken[2], b.source.start.column = this.nextToken[3], b.source.end.column = this.nextToken[3], b.source.end.line = this.nextToken[2], b.sourceIndex = this.nextToken[4]) : this.prevToken && this.prevToken[0] === "combinator" ? b.spaces.after = this.parseSpace(this.currToken[1]) : this.currToken[0] === "combinator" ? b.value = this.currToken[1] : this.currToken[0] === "space" && (b.value = this.parseSpace(this.currToken[1], " ")), this.position++;
                return this.newNode(b);
              }, E.prototype.comma = function() {
                if (this.position === this.tokens.length - 1) {
                  this.root.trailingComma = true, this.position++;
                  return;
                }
                var b = new u.default();
                this.current.parent.append(b), this.current = b, this.position++;
              }, E.prototype.comment = function() {
                var b = new v.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] });
                this.newNode(b), this.position++;
              }, E.prototype.error = function(b) {
                throw new this.input.error(b);
              }, E.prototype.missingBackslash = function() {
                return this.error("Expected a backslash preceding the semicolon.");
              }, E.prototype.missingParenthesis = function() {
                return this.error("Expected opening parenthesis.");
              }, E.prototype.missingSquareBracket = function() {
                return this.error("Expected opening square bracket.");
              }, E.prototype.namespace = function() {
                var b = this.prevToken && this.prevToken[1] || true;
                if (this.nextToken[0] === "word")
                  return this.position++, this.word(b);
                if (this.nextToken[0] === "*")
                  return this.position++, this.universal(b);
              }, E.prototype.nesting = function() {
                this.newNode(new j.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] })), this.position++;
              }, E.prototype.parentheses = function() {
                var b = this.current.last;
                if (b && b.type === K.PSEUDO) {
                  var L = new u.default(), q = this.current;
                  b.append(L), this.current = L;
                  var T = 1;
                  for (this.position++; this.position < this.tokens.length && T; )
                    this.currToken[0] === "(" && T++, this.currToken[0] === ")" && T--, T ? this.parse() : (L.parent.source.end.line = this.currToken[2], L.parent.source.end.column = this.currToken[3], this.position++);
                  T && this.error("Expected closing parenthesis."), this.current = q;
                } else {
                  var F = 1;
                  for (this.position++, b.value += "("; this.position < this.tokens.length && F; )
                    this.currToken[0] === "(" && F++, this.currToken[0] === ")" && F--, b.value += this.parseParenthesisToken(this.currToken), this.position++;
                  F && this.error("Expected closing parenthesis.");
                }
              }, E.prototype.pseudo = function() {
                for (var b = this, L = "", q = this.currToken; this.currToken && this.currToken[0] === ":"; )
                  L += this.currToken[1], this.position++;
                if (!this.currToken)
                  return this.error("Expected pseudo-class or pseudo-element");
                if (this.currToken[0] === "word") {
                  var T = void 0;
                  this.splitWord(false, function(F, z) {
                    L += F, T = new P.default({ value: L, source: { start: { line: q[2], column: q[3] }, end: { line: b.currToken[4], column: b.currToken[5] } }, sourceIndex: q[4] }), b.newNode(T), z > 1 && b.nextToken && b.nextToken[0] === "(" && b.error("Misplaced parenthesis.");
                  });
                } else
                  this.error('Unexpected "' + this.currToken[0] + '" found.');
              }, E.prototype.space = function() {
                var b = this.currToken;
                this.position === 0 || this.prevToken[0] === "," || this.prevToken[0] === "(" ? (this.spaces = this.parseSpace(b[1]), this.position++) : this.position === this.tokens.length - 1 || this.nextToken[0] === "," || this.nextToken[0] === ")" ? (this.current.last.spaces.after = this.parseSpace(b[1]), this.position++) : this.combinator();
              }, E.prototype.string = function() {
                var b = this.currToken;
                this.newNode(new x.default({ value: this.currToken[1], source: { start: { line: b[2], column: b[3] }, end: { line: b[4], column: b[5] } }, sourceIndex: b[6] })), this.position++;
              }, E.prototype.universal = function(b) {
                var L = this.nextToken;
                if (L && L[1] === "|")
                  return this.position++, this.namespace();
                this.newNode(new D.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }), b), this.position++;
              }, E.prototype.splitWord = function(b, L) {
                for (var q = this, T = this.nextToken, F = this.currToken[1]; T && T[0] === "word"; ) {
                  this.position++;
                  var z = this.currToken[1];
                  if (F += z, z.lastIndexOf("\\") === z.length - 1) {
                    var re = this.nextToken;
                    re && re[0] === "space" && (F += this.parseSpace(re[1], " "), this.position++);
                  }
                  T = this.nextToken;
                }
                var ne = (0, p.default)(F, "."), ce = (0, p.default)(F, "#"), fe = (0, p.default)(F, "#{");
                fe.length && (ce = ce.filter(function(ie) {
                  return !~fe.indexOf(ie);
                }));
                var te = (0, I.default)((0, g.default)((0, o.default)([[0], ne, ce])));
                te.forEach(function(ie, ae) {
                  var se = te[ae + 1] || F.length, le = F.slice(ie, se);
                  if (ae === 0 && L)
                    return L.call(q, le, te.length);
                  var pe = void 0;
                  ~ne.indexOf(ie) ? pe = new l.default({ value: le.slice(1), source: { start: { line: q.currToken[2], column: q.currToken[3] + ie }, end: { line: q.currToken[4], column: q.currToken[3] + (se - 1) } }, sourceIndex: q.currToken[6] + te[ae] }) : ~ce.indexOf(ie) ? pe = new w.default({ value: le.slice(1), source: { start: { line: q.currToken[2], column: q.currToken[3] + ie }, end: { line: q.currToken[4], column: q.currToken[3] + (se - 1) } }, sourceIndex: q.currToken[6] + te[ae] }) : pe = new _.default({ value: le, source: { start: { line: q.currToken[2], column: q.currToken[3] + ie }, end: { line: q.currToken[4], column: q.currToken[3] + (se - 1) } }, sourceIndex: q.currToken[6] + te[ae] }), q.newNode(pe, b);
                }), this.position++;
              }, E.prototype.word = function(b) {
                var L = this.nextToken;
                return L && L[1] === "|" ? (this.position++, this.namespace()) : this.splitWord(b);
              }, E.prototype.loop = function() {
                for (; this.position < this.tokens.length; )
                  this.parse(true);
                return this.root;
              }, E.prototype.parse = function(b) {
                switch (this.currToken[0]) {
                  case "space":
                    this.space();
                    break;
                  case "comment":
                    this.comment();
                    break;
                  case "(":
                    this.parentheses();
                    break;
                  case ")":
                    b && this.missingParenthesis();
                    break;
                  case "[":
                    this.attribute();
                    break;
                  case "]":
                    this.missingSquareBracket();
                    break;
                  case "at-word":
                  case "word":
                    this.word();
                    break;
                  case ":":
                    this.pseudo();
                    break;
                  case ";":
                    this.missingBackslash();
                    break;
                  case ",":
                    this.comma();
                    break;
                  case "*":
                    this.universal();
                    break;
                  case "&":
                    this.nesting();
                    break;
                  case "combinator":
                    this.combinator();
                    break;
                  case "string":
                    this.string();
                    break;
                }
              }, E.prototype.parseNamespace = function(b) {
                if (this.lossy && typeof b == "string") {
                  var L = b.trim();
                  return L.length ? L : true;
                }
                return b;
              }, E.prototype.parseSpace = function(b, L) {
                return this.lossy ? L || "" : b;
              }, E.prototype.parseValue = function(b) {
                return this.lossy && b && typeof b == "string" ? b.trim() : b;
              }, E.prototype.parseParenthesisToken = function(b) {
                return this.lossy ? b[0] === "space" ? this.parseSpace(b[1], " ") : this.parseValue(b[1]) : b[1];
              }, E.prototype.newNode = function(b, L) {
                return L && (b.namespace = this.parseNamespace(L)), this.spaces && (b.spaces.before = this.spaces, this.spaces = ""), this.current.append(b);
              }, i(E, [{ key: "currToken", get: function() {
                return this.tokens[this.position];
              } }, { key: "nextToken", get: function() {
                return this.tokens[this.position + 1];
              } }, { key: "prevToken", get: function() {
                return this.tokens[this.position - 1];
              } }]), E;
            }();
            e.default = G, n.exports = e.default;
          } }), df = R({ "node_modules/postcss-selector-parser/dist/processor.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = function() {
              function g(c, t3) {
                for (var r = 0; r < t3.length; r++) {
                  var u = t3[r];
                  u.enumerable = u.enumerable || false, u.configurable = true, "value" in u && (u.writable = true), Object.defineProperty(c, u.key, u);
                }
              }
              return function(c, t3, r) {
                return t3 && g(c.prototype, t3), r && g(c, r), c;
              };
            }(), a = hf(), o = f(a);
            function f(g) {
              return g && g.__esModule ? g : { default: g };
            }
            function p(g, c) {
              if (!(g instanceof c))
                throw new TypeError("Cannot call a class as a function");
            }
            var h = function() {
              function g(c) {
                return p(this, g), this.func = c || function() {
                }, this;
              }
              return g.prototype.process = function(t3) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = new o.default({ css: t3, error: function(l) {
                  throw new Error(l);
                }, options: r });
                return this.res = u, this.func(u), this;
              }, i(g, [{ key: "result", get: function() {
                return String(this.res);
              } }]), g;
            }();
            e.default = h, n.exports = e.default;
          } }), vf = R({ "node_modules/postcss-selector-parser/dist/index.js"(e, n) {
            "use strict";
            A(), e.__esModule = true;
            var i = df(), a = O(i), o = Do(), f = O(o), p = Ro(), h = O(p), g = zo(), c = O(g), t3 = Io(), r = O(t3), u = Co(), s = O(u), l = Bo(), m = O(l), v = Mo(), y = O(v), w = Ao(), d = O(w), _ = Po(), S = O(_), x = jo(), N = O(x), P = No(), W = O(P), U = Lo(), H = O(U), D = oe(), $ = B(D);
            function B(C) {
              if (C && C.__esModule)
                return C;
              var I = {};
              if (C != null)
                for (var X in C)
                  Object.prototype.hasOwnProperty.call(C, X) && (I[X] = C[X]);
              return I.default = C, I;
            }
            function O(C) {
              return C && C.__esModule ? C : { default: C };
            }
            var j = function(I) {
              return new a.default(I);
            };
            j.attribute = function(C) {
              return new f.default(C);
            }, j.className = function(C) {
              return new h.default(C);
            }, j.combinator = function(C) {
              return new c.default(C);
            }, j.comment = function(C) {
              return new r.default(C);
            }, j.id = function(C) {
              return new s.default(C);
            }, j.nesting = function(C) {
              return new m.default(C);
            }, j.pseudo = function(C) {
              return new y.default(C);
            }, j.root = function(C) {
              return new d.default(C);
            }, j.selector = function(C) {
              return new S.default(C);
            }, j.string = function(C) {
              return new N.default(C);
            }, j.tag = function(C) {
              return new W.default(C);
            }, j.universal = function(C) {
              return new H.default(C);
            }, Object.keys($).forEach(function(C) {
              C !== "__esModule" && (j[C] = $[C]);
            }), e.default = j, n.exports = e.default;
          } }), Fo = R({ "node_modules/postcss-media-query-parser/dist/nodes/Node.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true });
            function n(i) {
              this.after = i.after, this.before = i.before, this.type = i.type, this.value = i.value, this.sourceIndex = i.sourceIndex;
            }
            e.default = n;
          } }), Uo = R({ "node_modules/postcss-media-query-parser/dist/nodes/Container.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true });
            var n = Fo(), i = a(n);
            function a(f) {
              return f && f.__esModule ? f : { default: f };
            }
            function o(f) {
              var p = this;
              this.constructor(f), this.nodes = f.nodes, this.after === void 0 && (this.after = this.nodes.length > 0 ? this.nodes[this.nodes.length - 1].after : ""), this.before === void 0 && (this.before = this.nodes.length > 0 ? this.nodes[0].before : ""), this.sourceIndex === void 0 && (this.sourceIndex = this.before.length), this.nodes.forEach(function(h) {
                h.parent = p;
              });
            }
            o.prototype = Object.create(i.default.prototype), o.constructor = i.default, o.prototype.walk = function(p, h) {
              for (var g = typeof p == "string" || p instanceof RegExp, c = g ? h : p, t3 = typeof p == "string" ? new RegExp(p) : p, r = 0; r < this.nodes.length; r++) {
                var u = this.nodes[r], s = g ? t3.test(u.type) : true;
                if (s && c && c(u, r, this.nodes) === false || u.nodes && u.walk(p, h) === false)
                  return false;
              }
              return true;
            }, o.prototype.each = function() {
              for (var p = arguments.length <= 0 || arguments[0] === void 0 ? function() {
              } : arguments[0], h = 0; h < this.nodes.length; h++) {
                var g = this.nodes[h];
                if (p(g, h, this.nodes) === false)
                  return false;
              }
              return true;
            }, e.default = o;
          } }), mf = R({ "node_modules/postcss-media-query-parser/dist/parsers.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true }), e.parseMediaFeature = p, e.parseMediaQuery = h, e.parseMediaList = g;
            var n = Fo(), i = f(n), a = Uo(), o = f(a);
            function f(c) {
              return c && c.__esModule ? c : { default: c };
            }
            function p(c) {
              var t3 = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1], r = [{ mode: "normal", character: null }], u = [], s = 0, l = "", m = null, v = null, y = t3, w = c;
              c[0] === "(" && c[c.length - 1] === ")" && (w = c.substring(1, c.length - 1), y++);
              for (var d = 0; d < w.length; d++) {
                var _ = w[d];
                if ((_ === "'" || _ === '"') && (r[s].isCalculationEnabled === true ? (r.push({ mode: "string", isCalculationEnabled: false, character: _ }), s++) : r[s].mode === "string" && r[s].character === _ && w[d - 1] !== "\\" && (r.pop(), s--)), _ === "{" ? (r.push({ mode: "interpolation", isCalculationEnabled: true }), s++) : _ === "}" && (r.pop(), s--), r[s].mode === "normal" && _ === ":") {
                  var S = w.substring(d + 1);
                  v = { type: "value", before: /^(\s*)/.exec(S)[1], after: /(\s*)$/.exec(S)[1], value: S.trim() }, v.sourceIndex = v.before.length + d + 1 + y, m = { type: "colon", sourceIndex: d + y, after: v.before, value: ":" };
                  break;
                }
                l += _;
              }
              return l = { type: "media-feature", before: /^(\s*)/.exec(l)[1], after: /(\s*)$/.exec(l)[1], value: l.trim() }, l.sourceIndex = l.before.length + y, u.push(l), m !== null && (m.before = l.after, u.push(m)), v !== null && u.push(v), u;
            }
            function h(c) {
              var t3 = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1], r = [], u = 0, s = false, l = void 0;
              function m() {
                return { before: "", after: "", value: "" };
              }
              l = m();
              for (var v = 0; v < c.length; v++) {
                var y = c[v];
                s ? (l.value += y, (y === "{" || y === "(") && u++, (y === ")" || y === "}") && u--) : y.search(/\s/) !== -1 ? l.before += y : (y === "(" && (l.type = "media-feature-expression", u++), l.value = y, l.sourceIndex = t3 + v, s = true), s && u === 0 && (y === ")" || v === c.length - 1 || c[v + 1].search(/\s/) !== -1) && (["not", "only", "and"].indexOf(l.value) !== -1 && (l.type = "keyword"), l.type === "media-feature-expression" && (l.nodes = p(l.value, l.sourceIndex)), r.push(Array.isArray(l.nodes) ? new o.default(l) : new i.default(l)), l = m(), s = false);
              }
              for (var w = 0; w < r.length; w++)
                if (l = r[w], w > 0 && (r[w - 1].after = l.before), l.type === void 0) {
                  if (w > 0) {
                    if (r[w - 1].type === "media-feature-expression") {
                      l.type = "keyword";
                      continue;
                    }
                    if (r[w - 1].value === "not" || r[w - 1].value === "only") {
                      l.type = "media-type";
                      continue;
                    }
                    if (r[w - 1].value === "and") {
                      l.type = "media-feature-expression";
                      continue;
                    }
                    r[w - 1].type === "media-type" && (r[w + 1] ? l.type = r[w + 1].type === "media-feature-expression" ? "keyword" : "media-feature-expression" : l.type = "media-feature-expression");
                  }
                  if (w === 0) {
                    if (!r[w + 1]) {
                      l.type = "media-type";
                      continue;
                    }
                    if (r[w + 1] && (r[w + 1].type === "media-feature-expression" || r[w + 1].type === "keyword")) {
                      l.type = "media-type";
                      continue;
                    }
                    if (r[w + 2]) {
                      if (r[w + 2].type === "media-feature-expression") {
                        l.type = "media-type", r[w + 1].type = "keyword";
                        continue;
                      }
                      if (r[w + 2].type === "keyword") {
                        l.type = "keyword", r[w + 1].type = "media-type";
                        continue;
                      }
                    }
                    if (r[w + 3] && r[w + 3].type === "media-feature-expression") {
                      l.type = "keyword", r[w + 1].type = "media-type", r[w + 2].type = "keyword";
                      continue;
                    }
                  }
                }
              return r;
            }
            function g(c) {
              var t3 = [], r = 0, u = 0, s = /^(\s*)url\s*\(/.exec(c);
              if (s !== null) {
                for (var l = s[0].length, m = 1; m > 0; ) {
                  var v = c[l];
                  v === "(" && m++, v === ")" && m--, l++;
                }
                t3.unshift(new i.default({ type: "url", value: c.substring(0, l).trim(), sourceIndex: s[1].length, before: s[1], after: /^(\s*)/.exec(c.substring(l))[1] })), r = l;
              }
              for (var y = r; y < c.length; y++) {
                var w = c[y];
                if (w === "(" && u++, w === ")" && u--, u === 0 && w === ",") {
                  var d = c.substring(r, y), _ = /^(\s*)/.exec(d)[1];
                  t3.push(new o.default({ type: "media-query", value: d.trim(), sourceIndex: r + _.length, nodes: h(d, r), before: _, after: /(\s*)$/.exec(d)[1] })), r = y + 1;
                }
              }
              var S = c.substring(r), x = /^(\s*)/.exec(S)[1];
              return t3.push(new o.default({ type: "media-query", value: S.trim(), sourceIndex: r + x.length, nodes: h(S, r), before: x, after: /(\s*)$/.exec(S)[1] })), t3;
            }
          } }), gf = R({ "node_modules/postcss-media-query-parser/dist/index.js"(e) {
            "use strict";
            A(), Object.defineProperty(e, "__esModule", { value: true }), e.default = f;
            var n = Uo(), i = o(n), a = mf();
            function o(p) {
              return p && p.__esModule ? p : { default: p };
            }
            function f(p) {
              return new i.default({ nodes: (0, a.parseMediaList)(p), type: "media-query-list", value: p.trim() });
            }
          } }), Wo = {};
          Ot(Wo, { basename: () => Jo, default: () => Qo, delimiter: () => _t, dirname: () => Ho, extname: () => Ko, isAbsolute: () => jt, join: () => Vo, normalize: () => Nt, relative: () => Go, resolve: () => mr, sep: () => wt });
          function $o(e, n) {
            for (var i = 0, a = e.length - 1; a >= 0; a--) {
              var o = e[a];
              o === "." ? e.splice(a, 1) : o === ".." ? (e.splice(a, 1), i++) : i && (e.splice(a, 1), i--);
            }
            if (n)
              for (; i--; i)
                e.unshift("..");
            return e;
          }
          function mr() {
            for (var e = "", n = false, i = arguments.length - 1; i >= -1 && !n; i--) {
              var a = i >= 0 ? arguments[i] : "/";
              if (typeof a != "string")
                throw new TypeError("Arguments to path.resolve must be strings");
              if (!a)
                continue;
              e = a + "/" + e, n = a.charAt(0) === "/";
            }
            return e = $o(Mt(e.split("/"), function(o) {
              return !!o;
            }), !n).join("/"), (n ? "/" : "") + e || ".";
          }
          function Nt(e) {
            var n = jt(e), i = Yo(e, -1) === "/";
            return e = $o(Mt(e.split("/"), function(a) {
              return !!a;
            }), !n).join("/"), !e && !n && (e = "."), e && i && (e += "/"), (n ? "/" : "") + e;
          }
          function jt(e) {
            return e.charAt(0) === "/";
          }
          function Vo() {
            var e = Array.prototype.slice.call(arguments, 0);
            return Nt(Mt(e, function(n, i) {
              if (typeof n != "string")
                throw new TypeError("Arguments to path.join must be strings");
              return n;
            }).join("/"));
          }
          function Go(e, n) {
            e = mr(e).substr(1), n = mr(n).substr(1);
            function i(c) {
              for (var t3 = 0; t3 < c.length && c[t3] === ""; t3++)
                ;
              for (var r = c.length - 1; r >= 0 && c[r] === ""; r--)
                ;
              return t3 > r ? [] : c.slice(t3, r - t3 + 1);
            }
            for (var a = i(e.split("/")), o = i(n.split("/")), f = Math.min(a.length, o.length), p = f, h = 0; h < f; h++)
              if (a[h] !== o[h]) {
                p = h;
                break;
              }
            for (var g = [], h = p; h < a.length; h++)
              g.push("..");
            return g = g.concat(o.slice(p)), g.join("/");
          }
          function Ho(e) {
            var n = wr(e), i = n[0], a = n[1];
            return !i && !a ? "." : (a && (a = a.substr(0, a.length - 1)), i + a);
          }
          function Jo(e, n) {
            var i = wr(e)[2];
            return n && i.substr(-1 * n.length) === n && (i = i.substr(0, i.length - n.length)), i;
          }
          function Ko(e) {
            return wr(e)[3];
          }
          function Mt(e, n) {
            if (e.filter)
              return e.filter(n);
            for (var i = [], a = 0; a < e.length; a++)
              n(e[a], a, e) && i.push(e[a]);
            return i;
          }
          var Is, wr, wt, _t, Qo, Yo, yf = Le({ "node-modules-polyfills:path"() {
            A(), Is = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, wr = function(e) {
              return Is.exec(e).slice(1);
            }, wt = "/", _t = ":", Qo = { extname: Ko, basename: Jo, dirname: Ho, sep: wt, delimiter: _t, relative: Go, join: Vo, isAbsolute: jt, normalize: Nt, resolve: mr }, Yo = "ab".substr(-1) === "b" ? function(e, n, i) {
              return e.substr(n, i);
            } : function(e, n, i) {
              return n < 0 && (n = e.length + n), e.substr(n, i);
            };
          } }), wf = R({ "node-modules-polyfills-commonjs:path"(e, n) {
            A();
            var i = (yf(), Tt(Wo));
            if (i && i.default) {
              n.exports = i.default;
              for (let a in i)
                n.exports[a] = i[a];
            } else
              i && (n.exports = i);
          } }), _f = R({ "node_modules/picocolors/picocolors.browser.js"(e, n) {
            A();
            var i = String, a = function() {
              return { isColorSupported: false, reset: i, bold: i, dim: i, italic: i, underline: i, inverse: i, hidden: i, strikethrough: i, black: i, red: i, green: i, yellow: i, blue: i, magenta: i, cyan: i, white: i, gray: i, bgBlack: i, bgRed: i, bgGreen: i, bgYellow: i, bgBlue: i, bgMagenta: i, bgCyan: i, bgWhite: i };
            };
            n.exports = a(), n.exports.createColors = a;
          } }), bf = R({ "(disabled):node_modules/postcss/lib/terminal-highlight"() {
            A();
          } }), Xo = R({ "node_modules/postcss/lib/css-syntax-error.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = o(_f()), a = o(bf());
            function o(m) {
              return m && m.__esModule ? m : { default: m };
            }
            function f(m) {
              if (m === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return m;
            }
            function p(m, v) {
              m.prototype = Object.create(v.prototype), m.prototype.constructor = m, m.__proto__ = v;
            }
            function h(m) {
              var v = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
              return h = function(w) {
                if (w === null || !t3(w))
                  return w;
                if (typeof w != "function")
                  throw new TypeError("Super expression must either be null or a function");
                if (typeof v < "u") {
                  if (v.has(w))
                    return v.get(w);
                  v.set(w, d);
                }
                function d() {
                  return g(w, arguments, u(this).constructor);
                }
                return d.prototype = Object.create(w.prototype, { constructor: { value: d, enumerable: false, writable: true, configurable: true } }), r(d, w);
              }, h(m);
            }
            function g(m, v, y) {
              return c() ? g = Reflect.construct : g = function(d, _, S) {
                var x = [null];
                x.push.apply(x, _);
                var N = Function.bind.apply(d, x), P = new N();
                return S && r(P, S.prototype), P;
              }, g.apply(null, arguments);
            }
            function c() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return false;
              if (typeof Proxy == "function")
                return true;
              try {
                return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
                })), true;
              } catch {
                return false;
              }
            }
            function t3(m) {
              return Function.toString.call(m).indexOf("[native code]") !== -1;
            }
            function r(m, v) {
              return r = Object.setPrototypeOf || function(w, d) {
                return w.__proto__ = d, w;
              }, r(m, v);
            }
            function u(m) {
              return u = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
                return y.__proto__ || Object.getPrototypeOf(y);
              }, u(m);
            }
            var s = function(m) {
              p(v, m);
              function v(w, d, _, S, x, N) {
                var P;
                return P = m.call(this, w) || this, P.name = "CssSyntaxError", P.reason = w, x && (P.file = x), S && (P.source = S), N && (P.plugin = N), typeof d < "u" && typeof _ < "u" && (P.line = d, P.column = _), P.setMessage(), Error.captureStackTrace && Error.captureStackTrace(f(P), v), P;
              }
              var y = v.prototype;
              return y.setMessage = function() {
                this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
              }, y.showSourceCode = function(d) {
                var _ = this;
                if (!this.source)
                  return "";
                var S = this.source;
                a.default && (typeof d > "u" && (d = i.default.isColorSupported), d && (S = (0, a.default)(S)));
                var x = S.split(/\r?\n/), N = Math.max(this.line - 3, 0), P = Math.min(this.line + 2, x.length), W = String(P).length;
                function U(D) {
                  return d && i.default.red ? i.default.red(i.default.bold(D)) : D;
                }
                function H(D) {
                  return d && i.default.gray ? i.default.gray(D) : D;
                }
                return x.slice(N, P).map(function(D, $) {
                  var B = N + 1 + $, O = " " + (" " + B).slice(-W) + " | ";
                  if (B === _.line) {
                    var j = H(O.replace(/\d/g, " ")) + D.slice(0, _.column - 1).replace(/[^\t]/g, " ");
                    return U(">") + H(O) + D + `
 ` + j + U("^");
                  }
                  return " " + H(O) + D;
                }).join(`
`);
              }, y.toString = function() {
                var d = this.showSourceCode();
                return d && (d = `

` + d + `
`), this.name + ": " + this.message + d;
              }, v;
            }(h(Error)), l = s;
            e.default = l, n.exports = e.default;
          } }), xf = R({ "node_modules/postcss/lib/previous-map.js"(e, n) {
            A(), n.exports = class {
            };
          } }), _r = R({ "node_modules/postcss/lib/input.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = f(wf()), a = f(Xo()), o = f(xf());
            function f(r) {
              return r && r.__esModule ? r : { default: r };
            }
            function p(r, u) {
              for (var s = 0; s < u.length; s++) {
                var l = u[s];
                l.enumerable = l.enumerable || false, l.configurable = true, "value" in l && (l.writable = true), Object.defineProperty(r, l.key, l);
              }
            }
            function h(r, u, s) {
              return u && p(r.prototype, u), s && p(r, s), r;
            }
            var g = 0, c = function() {
              function r(s, l) {
                if (l === void 0 && (l = {}), s === null || typeof s > "u" || typeof s == "object" && !s.toString)
                  throw new Error("PostCSS received " + s + " instead of CSS string");
                this.css = s.toString(), this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE" ? (this.hasBOM = true, this.css = this.css.slice(1)) : this.hasBOM = false, l.from && (/^\w+:\/\//.test(l.from) || i.default.isAbsolute(l.from) ? this.file = l.from : this.file = i.default.resolve(l.from));
                var m = new o.default(this.css, l);
                if (m.text) {
                  this.map = m;
                  var v = m.consumer().file;
                  !this.file && v && (this.file = this.mapResolve(v));
                }
                this.file || (g += 1, this.id = "<input css " + g + ">"), this.map && (this.map.file = this.from);
              }
              var u = r.prototype;
              return u.error = function(l, m, v, y) {
                y === void 0 && (y = {});
                var w, d = this.origin(m, v);
                return d ? w = new a.default(l, d.line, d.column, d.source, d.file, y.plugin) : w = new a.default(l, m, v, this.css, this.file, y.plugin), w.input = { line: m, column: v, source: this.css }, this.file && (w.input.file = this.file), w;
              }, u.origin = function(l, m) {
                if (!this.map)
                  return false;
                var v = this.map.consumer(), y = v.originalPositionFor({ line: l, column: m });
                if (!y.source)
                  return false;
                var w = { file: this.mapResolve(y.source), line: y.line, column: y.column }, d = v.sourceContentFor(y.source);
                return d && (w.source = d), w;
              }, u.mapResolve = function(l) {
                return /^\w+:\/\//.test(l) ? l : i.default.resolve(this.map.consumer().sourceRoot || ".", l);
              }, h(r, [{ key: "from", get: function() {
                return this.file || this.id;
              } }]), r;
            }(), t3 = c;
            e.default = t3, n.exports = e.default;
          } }), br = R({ "node_modules/postcss/lib/stringifier.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = { colon: ": ", indent: "    ", beforeDecl: `
`, beforeRule: `
`, beforeOpen: " ", beforeClose: `
`, beforeComment: `
`, after: `
`, emptyBody: "", commentLeft: " ", commentRight: " ", semicolon: false };
            function a(p) {
              return p[0].toUpperCase() + p.slice(1);
            }
            var o = function() {
              function p(g) {
                this.builder = g;
              }
              var h = p.prototype;
              return h.stringify = function(c, t3) {
                this[c.type](c, t3);
              }, h.root = function(c) {
                this.body(c), c.raws.after && this.builder(c.raws.after);
              }, h.comment = function(c) {
                var t3 = this.raw(c, "left", "commentLeft"), r = this.raw(c, "right", "commentRight");
                this.builder("/*" + t3 + c.text + r + "*/", c);
              }, h.decl = function(c, t3) {
                var r = this.raw(c, "between", "colon"), u = c.prop + r + this.rawValue(c, "value");
                c.important && (u += c.raws.important || " !important"), t3 && (u += ";"), this.builder(u, c);
              }, h.rule = function(c) {
                this.block(c, this.rawValue(c, "selector")), c.raws.ownSemicolon && this.builder(c.raws.ownSemicolon, c, "end");
              }, h.atrule = function(c, t3) {
                var r = "@" + c.name, u = c.params ? this.rawValue(c, "params") : "";
                if (typeof c.raws.afterName < "u" ? r += c.raws.afterName : u && (r += " "), c.nodes)
                  this.block(c, r + u);
                else {
                  var s = (c.raws.between || "") + (t3 ? ";" : "");
                  this.builder(r + u + s, c);
                }
              }, h.body = function(c) {
                for (var t3 = c.nodes.length - 1; t3 > 0 && c.nodes[t3].type === "comment"; )
                  t3 -= 1;
                for (var r = this.raw(c, "semicolon"), u = 0; u < c.nodes.length; u++) {
                  var s = c.nodes[u], l = this.raw(s, "before");
                  l && this.builder(l), this.stringify(s, t3 !== u || r);
                }
              }, h.block = function(c, t3) {
                var r = this.raw(c, "between", "beforeOpen");
                this.builder(t3 + r + "{", c, "start");
                var u;
                c.nodes && c.nodes.length ? (this.body(c), u = this.raw(c, "after")) : u = this.raw(c, "after", "emptyBody"), u && this.builder(u), this.builder("}", c, "end");
              }, h.raw = function(c, t3, r) {
                var u;
                if (r || (r = t3), t3 && (u = c.raws[t3], typeof u < "u"))
                  return u;
                var s = c.parent;
                if (r === "before" && (!s || s.type === "root" && s.first === c))
                  return "";
                if (!s)
                  return i[r];
                var l = c.root();
                if (l.rawCache || (l.rawCache = {}), typeof l.rawCache[r] < "u")
                  return l.rawCache[r];
                if (r === "before" || r === "after")
                  return this.beforeAfter(c, r);
                var m = "raw" + a(r);
                return this[m] ? u = this[m](l, c) : l.walk(function(v) {
                  if (u = v.raws[t3], typeof u < "u")
                    return false;
                }), typeof u > "u" && (u = i[r]), l.rawCache[r] = u, u;
              }, h.rawSemicolon = function(c) {
                var t3;
                return c.walk(function(r) {
                  if (r.nodes && r.nodes.length && r.last.type === "decl" && (t3 = r.raws.semicolon, typeof t3 < "u"))
                    return false;
                }), t3;
              }, h.rawEmptyBody = function(c) {
                var t3;
                return c.walk(function(r) {
                  if (r.nodes && r.nodes.length === 0 && (t3 = r.raws.after, typeof t3 < "u"))
                    return false;
                }), t3;
              }, h.rawIndent = function(c) {
                if (c.raws.indent)
                  return c.raws.indent;
                var t3;
                return c.walk(function(r) {
                  var u = r.parent;
                  if (u && u !== c && u.parent && u.parent === c && typeof r.raws.before < "u") {
                    var s = r.raws.before.split(`
`);
                    return t3 = s[s.length - 1], t3 = t3.replace(/[^\s]/g, ""), false;
                  }
                }), t3;
              }, h.rawBeforeComment = function(c, t3) {
                var r;
                return c.walkComments(function(u) {
                  if (typeof u.raws.before < "u")
                    return r = u.raws.before, r.indexOf(`
`) !== -1 && (r = r.replace(/[^\n]+$/, "")), false;
                }), typeof r > "u" ? r = this.raw(t3, null, "beforeDecl") : r && (r = r.replace(/[^\s]/g, "")), r;
              }, h.rawBeforeDecl = function(c, t3) {
                var r;
                return c.walkDecls(function(u) {
                  if (typeof u.raws.before < "u")
                    return r = u.raws.before, r.indexOf(`
`) !== -1 && (r = r.replace(/[^\n]+$/, "")), false;
                }), typeof r > "u" ? r = this.raw(t3, null, "beforeRule") : r && (r = r.replace(/[^\s]/g, "")), r;
              }, h.rawBeforeRule = function(c) {
                var t3;
                return c.walk(function(r) {
                  if (r.nodes && (r.parent !== c || c.first !== r) && typeof r.raws.before < "u")
                    return t3 = r.raws.before, t3.indexOf(`
`) !== -1 && (t3 = t3.replace(/[^\n]+$/, "")), false;
                }), t3 && (t3 = t3.replace(/[^\s]/g, "")), t3;
              }, h.rawBeforeClose = function(c) {
                var t3;
                return c.walk(function(r) {
                  if (r.nodes && r.nodes.length > 0 && typeof r.raws.after < "u")
                    return t3 = r.raws.after, t3.indexOf(`
`) !== -1 && (t3 = t3.replace(/[^\n]+$/, "")), false;
                }), t3 && (t3 = t3.replace(/[^\s]/g, "")), t3;
              }, h.rawBeforeOpen = function(c) {
                var t3;
                return c.walk(function(r) {
                  if (r.type !== "decl" && (t3 = r.raws.between, typeof t3 < "u"))
                    return false;
                }), t3;
              }, h.rawColon = function(c) {
                var t3;
                return c.walkDecls(function(r) {
                  if (typeof r.raws.between < "u")
                    return t3 = r.raws.between.replace(/[^\s:]/g, ""), false;
                }), t3;
              }, h.beforeAfter = function(c, t3) {
                var r;
                c.type === "decl" ? r = this.raw(c, null, "beforeDecl") : c.type === "comment" ? r = this.raw(c, null, "beforeComment") : t3 === "before" ? r = this.raw(c, null, "beforeRule") : r = this.raw(c, null, "beforeClose");
                for (var u = c.parent, s = 0; u && u.type !== "root"; )
                  s += 1, u = u.parent;
                if (r.indexOf(`
`) !== -1) {
                  var l = this.raw(c, null, "indent");
                  if (l.length)
                    for (var m = 0; m < s; m++)
                      r += l;
                }
                return r;
              }, h.rawValue = function(c, t3) {
                var r = c[t3], u = c.raws[t3];
                return u && u.value === r ? u.raw : r;
              }, p;
            }(), f = o;
            e.default = f, n.exports = e.default;
          } }), Zo = R({ "node_modules/postcss/lib/stringify.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = a(br());
            function a(p) {
              return p && p.__esModule ? p : { default: p };
            }
            function o(p, h) {
              var g = new i.default(h);
              g.stringify(p);
            }
            var f = o;
            e.default = f, n.exports = e.default;
          } }), Dt = R({ "node_modules/postcss/lib/node.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = f(Xo()), a = f(br()), o = f(Zo());
            function f(c) {
              return c && c.__esModule ? c : { default: c };
            }
            function p(c, t3) {
              var r = new c.constructor();
              for (var u in c)
                if (!!c.hasOwnProperty(u)) {
                  var s = c[u], l = typeof s;
                  u === "parent" && l === "object" ? t3 && (r[u] = t3) : u === "source" ? r[u] = s : s instanceof Array ? r[u] = s.map(function(m) {
                    return p(m, r);
                  }) : (l === "object" && s !== null && (s = p(s)), r[u] = s);
                }
              return r;
            }
            var h = function() {
              function c(r) {
                r === void 0 && (r = {}), this.raws = {};
                for (var u in r)
                  this[u] = r[u];
              }
              var t3 = c.prototype;
              return t3.error = function(u, s) {
                if (s === void 0 && (s = {}), this.source) {
                  var l = this.positionBy(s);
                  return this.source.input.error(u, l.line, l.column, s);
                }
                return new i.default(u);
              }, t3.warn = function(u, s, l) {
                var m = { node: this };
                for (var v in l)
                  m[v] = l[v];
                return u.warn(s, m);
              }, t3.remove = function() {
                return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
              }, t3.toString = function(u) {
                u === void 0 && (u = o.default), u.stringify && (u = u.stringify);
                var s = "";
                return u(this, function(l) {
                  s += l;
                }), s;
              }, t3.clone = function(u) {
                u === void 0 && (u = {});
                var s = p(this);
                for (var l in u)
                  s[l] = u[l];
                return s;
              }, t3.cloneBefore = function(u) {
                u === void 0 && (u = {});
                var s = this.clone(u);
                return this.parent.insertBefore(this, s), s;
              }, t3.cloneAfter = function(u) {
                u === void 0 && (u = {});
                var s = this.clone(u);
                return this.parent.insertAfter(this, s), s;
              }, t3.replaceWith = function() {
                if (this.parent) {
                  for (var u = arguments.length, s = new Array(u), l = 0; l < u; l++)
                    s[l] = arguments[l];
                  for (var m = 0, v = s; m < v.length; m++) {
                    var y = v[m];
                    this.parent.insertBefore(this, y);
                  }
                  this.remove();
                }
                return this;
              }, t3.next = function() {
                if (!!this.parent) {
                  var u = this.parent.index(this);
                  return this.parent.nodes[u + 1];
                }
              }, t3.prev = function() {
                if (!!this.parent) {
                  var u = this.parent.index(this);
                  return this.parent.nodes[u - 1];
                }
              }, t3.before = function(u) {
                return this.parent.insertBefore(this, u), this;
              }, t3.after = function(u) {
                return this.parent.insertAfter(this, u), this;
              }, t3.toJSON = function() {
                var u = {};
                for (var s in this)
                  if (!!this.hasOwnProperty(s) && s !== "parent") {
                    var l = this[s];
                    l instanceof Array ? u[s] = l.map(function(m) {
                      return typeof m == "object" && m.toJSON ? m.toJSON() : m;
                    }) : typeof l == "object" && l.toJSON ? u[s] = l.toJSON() : u[s] = l;
                  }
                return u;
              }, t3.raw = function(u, s) {
                var l = new a.default();
                return l.raw(this, u, s);
              }, t3.root = function() {
                for (var u = this; u.parent; )
                  u = u.parent;
                return u;
              }, t3.cleanRaws = function(u) {
                delete this.raws.before, delete this.raws.after, u || delete this.raws.between;
              }, t3.positionInside = function(u) {
                for (var s = this.toString(), l = this.source.start.column, m = this.source.start.line, v = 0; v < u; v++)
                  s[v] === `
` ? (l = 1, m += 1) : l += 1;
                return { line: m, column: l };
              }, t3.positionBy = function(u) {
                var s = this.source.start;
                if (u.index)
                  s = this.positionInside(u.index);
                else if (u.word) {
                  var l = this.toString().indexOf(u.word);
                  l !== -1 && (s = this.positionInside(l));
                }
                return s;
              }, c;
            }(), g = h;
            e.default = g, n.exports = e.default;
          } }), xr = R({ "node_modules/postcss/lib/comment.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = a(Dt());
            function a(h) {
              return h && h.__esModule ? h : { default: h };
            }
            function o(h, g) {
              h.prototype = Object.create(g.prototype), h.prototype.constructor = h, h.__proto__ = g;
            }
            var f = function(h) {
              o(g, h);
              function g(c) {
                var t3;
                return t3 = h.call(this, c) || this, t3.type = "comment", t3;
              }
              return g;
            }(i.default), p = f;
            e.default = p, n.exports = e.default;
          } }), ea = R({ "node_modules/postcss/lib/declaration.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = a(Dt());
            function a(h) {
              return h && h.__esModule ? h : { default: h };
            }
            function o(h, g) {
              h.prototype = Object.create(g.prototype), h.prototype.constructor = h, h.__proto__ = g;
            }
            var f = function(h) {
              o(g, h);
              function g(c) {
                var t3;
                return t3 = h.call(this, c) || this, t3.type = "decl", t3;
              }
              return g;
            }(i.default), p = f;
            e.default = p, n.exports = e.default;
          } }), Lt = R({ "node_modules/postcss/lib/tokenize.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = W;
            var i = "'".charCodeAt(0), a = '"'.charCodeAt(0), o = "\\".charCodeAt(0), f = "/".charCodeAt(0), p = `
`.charCodeAt(0), h = " ".charCodeAt(0), g = "\f".charCodeAt(0), c = "	".charCodeAt(0), t3 = "\r".charCodeAt(0), r = "[".charCodeAt(0), u = "]".charCodeAt(0), s = "(".charCodeAt(0), l = ")".charCodeAt(0), m = "{".charCodeAt(0), v = "}".charCodeAt(0), y = ";".charCodeAt(0), w = "*".charCodeAt(0), d = ":".charCodeAt(0), _ = "@".charCodeAt(0), S = /[ \n\t\r\f{}()'"\\;/[\]#]/g, x = /[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g, N = /.[\\/("'\n]/, P = /[a-f0-9]/i;
            function W(U, H) {
              H === void 0 && (H = {});
              var D = U.css.valueOf(), $ = H.ignoreErrors, B, O, j, C, I, X, Z, Q, K, J, M, Y, G, E, k = D.length, b = -1, L = 1, q = 0, T = [], F = [];
              function z() {
                return q;
              }
              function re(te) {
                throw U.error("Unclosed " + te, L, q - b);
              }
              function ne() {
                return F.length === 0 && q >= k;
              }
              function ce(te) {
                if (F.length)
                  return F.pop();
                if (!(q >= k)) {
                  var ie = te ? te.ignoreUnclosed : false;
                  switch (B = D.charCodeAt(q), (B === p || B === g || B === t3 && D.charCodeAt(q + 1) !== p) && (b = q, L += 1), B) {
                    case p:
                    case h:
                    case c:
                    case t3:
                    case g:
                      O = q;
                      do
                        O += 1, B = D.charCodeAt(O), B === p && (b = O, L += 1);
                      while (B === h || B === p || B === c || B === t3 || B === g);
                      E = ["space", D.slice(q, O)], q = O - 1;
                      break;
                    case r:
                    case u:
                    case m:
                    case v:
                    case d:
                    case y:
                    case l:
                      var ae = String.fromCharCode(B);
                      E = [ae, ae, L, q - b];
                      break;
                    case s:
                      if (Y = T.length ? T.pop()[1] : "", G = D.charCodeAt(q + 1), Y === "url" && G !== i && G !== a && G !== h && G !== p && G !== c && G !== g && G !== t3) {
                        O = q;
                        do {
                          if (J = false, O = D.indexOf(")", O + 1), O === -1)
                            if ($ || ie) {
                              O = q;
                              break;
                            } else
                              re("bracket");
                          for (M = O; D.charCodeAt(M - 1) === o; )
                            M -= 1, J = !J;
                        } while (J);
                        E = ["brackets", D.slice(q, O + 1), L, q - b, L, O - b], q = O;
                      } else
                        O = D.indexOf(")", q + 1), X = D.slice(q, O + 1), O === -1 || N.test(X) ? E = ["(", "(", L, q - b] : (E = ["brackets", X, L, q - b, L, O - b], q = O);
                      break;
                    case i:
                    case a:
                      j = B === i ? "'" : '"', O = q;
                      do {
                        if (J = false, O = D.indexOf(j, O + 1), O === -1)
                          if ($ || ie) {
                            O = q + 1;
                            break;
                          } else
                            re("string");
                        for (M = O; D.charCodeAt(M - 1) === o; )
                          M -= 1, J = !J;
                      } while (J);
                      X = D.slice(q, O + 1), C = X.split(`
`), I = C.length - 1, I > 0 ? (Q = L + I, K = O - C[I].length) : (Q = L, K = b), E = ["string", D.slice(q, O + 1), L, q - b, Q, O - K], b = K, L = Q, q = O;
                      break;
                    case _:
                      S.lastIndex = q + 1, S.test(D), S.lastIndex === 0 ? O = D.length - 1 : O = S.lastIndex - 2, E = ["at-word", D.slice(q, O + 1), L, q - b, L, O - b], q = O;
                      break;
                    case o:
                      for (O = q, Z = true; D.charCodeAt(O + 1) === o; )
                        O += 1, Z = !Z;
                      if (B = D.charCodeAt(O + 1), Z && B !== f && B !== h && B !== p && B !== c && B !== t3 && B !== g && (O += 1, P.test(D.charAt(O)))) {
                        for (; P.test(D.charAt(O + 1)); )
                          O += 1;
                        D.charCodeAt(O + 1) === h && (O += 1);
                      }
                      E = ["word", D.slice(q, O + 1), L, q - b, L, O - b], q = O;
                      break;
                    default:
                      B === f && D.charCodeAt(q + 1) === w ? (O = D.indexOf("*/", q + 2) + 1, O === 0 && ($ || ie ? O = D.length : re("comment")), X = D.slice(q, O + 1), C = X.split(`
`), I = C.length - 1, I > 0 ? (Q = L + I, K = O - C[I].length) : (Q = L, K = b), E = ["comment", X, L, q - b, Q, O - K], b = K, L = Q, q = O) : (x.lastIndex = q + 1, x.test(D), x.lastIndex === 0 ? O = D.length - 1 : O = x.lastIndex - 2, E = ["word", D.slice(q, O + 1), L, q - b, L, O - b], T.push(E), q = O);
                      break;
                  }
                  return q++, E;
                }
              }
              function fe(te) {
                F.push(te);
              }
              return { back: fe, nextToken: ce, endOfFile: ne, position: z };
            }
            n.exports = e.default;
          } }), ra = R({ "node_modules/postcss/lib/parse.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = o(zt()), a = o(_r());
            function o(h) {
              return h && h.__esModule ? h : { default: h };
            }
            function f(h, g) {
              var c = new a.default(h, g), t3 = new i.default(c);
              try {
                t3.parse();
              } catch (r) {
                throw r;
              }
              return t3.root;
            }
            var p = f;
            e.default = p, n.exports = e.default;
          } }), kf = R({ "node_modules/postcss/lib/list.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = { split: function(f, p, h) {
              for (var g = [], c = "", t3 = false, r = 0, u = false, s = false, l = 0; l < f.length; l++) {
                var m = f[l];
                u ? s ? s = false : m === "\\" ? s = true : m === u && (u = false) : m === '"' || m === "'" ? u = m : m === "(" ? r += 1 : m === ")" ? r > 0 && (r -= 1) : r === 0 && p.indexOf(m) !== -1 && (t3 = true), t3 ? (c !== "" && g.push(c.trim()), c = "", t3 = false) : c += m;
              }
              return (h || c !== "") && g.push(c.trim()), g;
            }, space: function(f) {
              var p = [" ", `
`, "	"];
              return i.split(f, p);
            }, comma: function(f) {
              return i.split(f, [","], true);
            } }, a = i;
            e.default = a, n.exports = e.default;
          } }), ta = R({ "node_modules/postcss/lib/rule.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = o(kr()), a = o(kf());
            function o(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function f(t3, r) {
              for (var u = 0; u < r.length; u++) {
                var s = r[u];
                s.enumerable = s.enumerable || false, s.configurable = true, "value" in s && (s.writable = true), Object.defineProperty(t3, s.key, s);
              }
            }
            function p(t3, r, u) {
              return r && f(t3.prototype, r), u && f(t3, u), t3;
            }
            function h(t3, r) {
              t3.prototype = Object.create(r.prototype), t3.prototype.constructor = t3, t3.__proto__ = r;
            }
            var g = function(t3) {
              h(r, t3);
              function r(u) {
                var s;
                return s = t3.call(this, u) || this, s.type = "rule", s.nodes || (s.nodes = []), s;
              }
              return p(r, [{ key: "selectors", get: function() {
                return a.default.comma(this.selector);
              }, set: function(s) {
                var l = this.selector ? this.selector.match(/,\s*/) : null, m = l ? l[0] : "," + this.raw("between", "beforeOpen");
                this.selector = s.join(m);
              } }]), r;
            }(i.default), c = g;
            e.default = c, n.exports = e.default;
          } }), kr = R({ "node_modules/postcss/lib/container.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = f(ea()), a = f(xr()), o = f(Dt());
            function f(m) {
              return m && m.__esModule ? m : { default: m };
            }
            function p(m, v) {
              var y;
              if (typeof Symbol > "u" || m[Symbol.iterator] == null) {
                if (Array.isArray(m) || (y = h(m)) || v && m && typeof m.length == "number") {
                  y && (m = y);
                  var w = 0;
                  return function() {
                    return w >= m.length ? { done: true } : { done: false, value: m[w++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return y = m[Symbol.iterator](), y.next.bind(y);
            }
            function h(m, v) {
              if (!!m) {
                if (typeof m == "string")
                  return g(m, v);
                var y = Object.prototype.toString.call(m).slice(8, -1);
                if (y === "Object" && m.constructor && (y = m.constructor.name), y === "Map" || y === "Set")
                  return Array.from(m);
                if (y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y))
                  return g(m, v);
              }
            }
            function g(m, v) {
              (v == null || v > m.length) && (v = m.length);
              for (var y = 0, w = new Array(v); y < v; y++)
                w[y] = m[y];
              return w;
            }
            function c(m, v) {
              for (var y = 0; y < v.length; y++) {
                var w = v[y];
                w.enumerable = w.enumerable || false, w.configurable = true, "value" in w && (w.writable = true), Object.defineProperty(m, w.key, w);
              }
            }
            function t3(m, v, y) {
              return v && c(m.prototype, v), y && c(m, y), m;
            }
            function r(m, v) {
              m.prototype = Object.create(v.prototype), m.prototype.constructor = m, m.__proto__ = v;
            }
            function u(m) {
              return m.map(function(v) {
                return v.nodes && (v.nodes = u(v.nodes)), delete v.source, v;
              });
            }
            var s = function(m) {
              r(v, m);
              function v() {
                return m.apply(this, arguments) || this;
              }
              var y = v.prototype;
              return y.push = function(d) {
                return d.parent = this, this.nodes.push(d), this;
              }, y.each = function(d) {
                this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
                var _ = this.lastEach;
                if (this.indexes[_] = 0, !!this.nodes) {
                  for (var S, x; this.indexes[_] < this.nodes.length && (S = this.indexes[_], x = d(this.nodes[S], S), x !== false); )
                    this.indexes[_] += 1;
                  return delete this.indexes[_], x;
                }
              }, y.walk = function(d) {
                return this.each(function(_, S) {
                  var x;
                  try {
                    x = d(_, S);
                  } catch (P) {
                    if (P.postcssNode = _, P.stack && _.source && /\n\s{4}at /.test(P.stack)) {
                      var N = _.source;
                      P.stack = P.stack.replace(/\n\s{4}at /, "$&" + N.input.from + ":" + N.start.line + ":" + N.start.column + "$&");
                    }
                    throw P;
                  }
                  return x !== false && _.walk && (x = _.walk(d)), x;
                });
              }, y.walkDecls = function(d, _) {
                return _ ? d instanceof RegExp ? this.walk(function(S, x) {
                  if (S.type === "decl" && d.test(S.prop))
                    return _(S, x);
                }) : this.walk(function(S, x) {
                  if (S.type === "decl" && S.prop === d)
                    return _(S, x);
                }) : (_ = d, this.walk(function(S, x) {
                  if (S.type === "decl")
                    return _(S, x);
                }));
              }, y.walkRules = function(d, _) {
                return _ ? d instanceof RegExp ? this.walk(function(S, x) {
                  if (S.type === "rule" && d.test(S.selector))
                    return _(S, x);
                }) : this.walk(function(S, x) {
                  if (S.type === "rule" && S.selector === d)
                    return _(S, x);
                }) : (_ = d, this.walk(function(S, x) {
                  if (S.type === "rule")
                    return _(S, x);
                }));
              }, y.walkAtRules = function(d, _) {
                return _ ? d instanceof RegExp ? this.walk(function(S, x) {
                  if (S.type === "atrule" && d.test(S.name))
                    return _(S, x);
                }) : this.walk(function(S, x) {
                  if (S.type === "atrule" && S.name === d)
                    return _(S, x);
                }) : (_ = d, this.walk(function(S, x) {
                  if (S.type === "atrule")
                    return _(S, x);
                }));
              }, y.walkComments = function(d) {
                return this.walk(function(_, S) {
                  if (_.type === "comment")
                    return d(_, S);
                });
              }, y.append = function() {
                for (var d = arguments.length, _ = new Array(d), S = 0; S < d; S++)
                  _[S] = arguments[S];
                for (var x = 0, N = _; x < N.length; x++)
                  for (var P = N[x], W = this.normalize(P, this.last), U = p(W), H; !(H = U()).done; ) {
                    var D = H.value;
                    this.nodes.push(D);
                  }
                return this;
              }, y.prepend = function() {
                for (var d = arguments.length, _ = new Array(d), S = 0; S < d; S++)
                  _[S] = arguments[S];
                _ = _.reverse();
                for (var x = p(_), N; !(N = x()).done; ) {
                  for (var P = N.value, W = this.normalize(P, this.first, "prepend").reverse(), U = p(W), H; !(H = U()).done; ) {
                    var D = H.value;
                    this.nodes.unshift(D);
                  }
                  for (var $ in this.indexes)
                    this.indexes[$] = this.indexes[$] + W.length;
                }
                return this;
              }, y.cleanRaws = function(d) {
                if (m.prototype.cleanRaws.call(this, d), this.nodes)
                  for (var _ = p(this.nodes), S; !(S = _()).done; ) {
                    var x = S.value;
                    x.cleanRaws(d);
                  }
              }, y.insertBefore = function(d, _) {
                d = this.index(d);
                for (var S = d === 0 ? "prepend" : false, x = this.normalize(_, this.nodes[d], S).reverse(), N = p(x), P; !(P = N()).done; ) {
                  var W = P.value;
                  this.nodes.splice(d, 0, W);
                }
                var U;
                for (var H in this.indexes)
                  U = this.indexes[H], d <= U && (this.indexes[H] = U + x.length);
                return this;
              }, y.insertAfter = function(d, _) {
                d = this.index(d);
                for (var S = this.normalize(_, this.nodes[d]).reverse(), x = p(S), N; !(N = x()).done; ) {
                  var P = N.value;
                  this.nodes.splice(d + 1, 0, P);
                }
                var W;
                for (var U in this.indexes)
                  W = this.indexes[U], d < W && (this.indexes[U] = W + S.length);
                return this;
              }, y.removeChild = function(d) {
                d = this.index(d), this.nodes[d].parent = void 0, this.nodes.splice(d, 1);
                var _;
                for (var S in this.indexes)
                  _ = this.indexes[S], _ >= d && (this.indexes[S] = _ - 1);
                return this;
              }, y.removeAll = function() {
                for (var d = p(this.nodes), _; !(_ = d()).done; ) {
                  var S = _.value;
                  S.parent = void 0;
                }
                return this.nodes = [], this;
              }, y.replaceValues = function(d, _, S) {
                return S || (S = _, _ = {}), this.walkDecls(function(x) {
                  _.props && _.props.indexOf(x.prop) === -1 || _.fast && x.value.indexOf(_.fast) === -1 || (x.value = x.value.replace(d, S));
                }), this;
              }, y.every = function(d) {
                return this.nodes.every(d);
              }, y.some = function(d) {
                return this.nodes.some(d);
              }, y.index = function(d) {
                return typeof d == "number" ? d : this.nodes.indexOf(d);
              }, y.normalize = function(d, _) {
                var S = this;
                if (typeof d == "string") {
                  var x = ra();
                  d = u(x(d).nodes);
                } else if (Array.isArray(d)) {
                  d = d.slice(0);
                  for (var N = p(d), P; !(P = N()).done; ) {
                    var W = P.value;
                    W.parent && W.parent.removeChild(W, "ignore");
                  }
                } else if (d.type === "root") {
                  d = d.nodes.slice(0);
                  for (var U = p(d), H; !(H = U()).done; ) {
                    var D = H.value;
                    D.parent && D.parent.removeChild(D, "ignore");
                  }
                } else if (d.type)
                  d = [d];
                else if (d.prop) {
                  if (typeof d.value > "u")
                    throw new Error("Value field is missed in node creation");
                  typeof d.value != "string" && (d.value = String(d.value)), d = [new i.default(d)];
                } else if (d.selector) {
                  var $ = ta();
                  d = [new $(d)];
                } else if (d.name) {
                  var B = na();
                  d = [new B(d)];
                } else if (d.text)
                  d = [new a.default(d)];
                else
                  throw new Error("Unknown node type in node creation");
                var O = d.map(function(j) {
                  return j.parent && j.parent.removeChild(j), typeof j.raws.before > "u" && _ && typeof _.raws.before < "u" && (j.raws.before = _.raws.before.replace(/[^\s]/g, "")), j.parent = S, j;
                });
                return O;
              }, t3(v, [{ key: "first", get: function() {
                if (!!this.nodes)
                  return this.nodes[0];
              } }, { key: "last", get: function() {
                if (!!this.nodes)
                  return this.nodes[this.nodes.length - 1];
              } }]), v;
            }(o.default), l = s;
            e.default = l, n.exports = e.default;
          } }), na = R({ "node_modules/postcss/lib/at-rule.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = a(kr());
            function a(h) {
              return h && h.__esModule ? h : { default: h };
            }
            function o(h, g) {
              h.prototype = Object.create(g.prototype), h.prototype.constructor = h, h.__proto__ = g;
            }
            var f = function(h) {
              o(g, h);
              function g(t3) {
                var r;
                return r = h.call(this, t3) || this, r.type = "atrule", r;
              }
              var c = g.prototype;
              return c.append = function() {
                var r;
                this.nodes || (this.nodes = []);
                for (var u = arguments.length, s = new Array(u), l = 0; l < u; l++)
                  s[l] = arguments[l];
                return (r = h.prototype.append).call.apply(r, [this].concat(s));
              }, c.prepend = function() {
                var r;
                this.nodes || (this.nodes = []);
                for (var u = arguments.length, s = new Array(u), l = 0; l < u; l++)
                  s[l] = arguments[l];
                return (r = h.prototype.prepend).call.apply(r, [this].concat(s));
              }, g;
            }(i.default), p = f;
            e.default = p, n.exports = e.default;
          } }), Sf = R({ "node_modules/postcss/lib/map-generator.js"(e, n) {
            A(), n.exports = class {
              generate() {
              }
            };
          } }), Of = R({ "node_modules/postcss/lib/warn-once.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = a;
            var i = {};
            function a(o) {
              i[o] || (i[o] = true, typeof console < "u" && console.warn && console.warn(o));
            }
            n.exports = e.default;
          } }), Tf = R({ "node_modules/postcss/lib/warning.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = function() {
              function o(p, h) {
                if (h === void 0 && (h = {}), this.type = "warning", this.text = p, h.node && h.node.source) {
                  var g = h.node.positionBy(h);
                  this.line = g.line, this.column = g.column;
                }
                for (var c in h)
                  this[c] = h[c];
              }
              var f = o.prototype;
              return f.toString = function() {
                return this.node ? this.node.error(this.text, { plugin: this.plugin, index: this.index, word: this.word }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
              }, o;
            }(), a = i;
            e.default = a, n.exports = e.default;
          } }), Ef = R({ "node_modules/postcss/lib/result.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = a(Tf());
            function a(g) {
              return g && g.__esModule ? g : { default: g };
            }
            function o(g, c) {
              for (var t3 = 0; t3 < c.length; t3++) {
                var r = c[t3];
                r.enumerable = r.enumerable || false, r.configurable = true, "value" in r && (r.writable = true), Object.defineProperty(g, r.key, r);
              }
            }
            function f(g, c, t3) {
              return c && o(g.prototype, c), t3 && o(g, t3), g;
            }
            var p = function() {
              function g(t3, r, u) {
                this.processor = t3, this.messages = [], this.root = r, this.opts = u, this.css = void 0, this.map = void 0;
              }
              var c = g.prototype;
              return c.toString = function() {
                return this.css;
              }, c.warn = function(r, u) {
                u === void 0 && (u = {}), u.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (u.plugin = this.lastPlugin.postcssPlugin);
                var s = new i.default(r, u);
                return this.messages.push(s), s;
              }, c.warnings = function() {
                return this.messages.filter(function(r) {
                  return r.type === "warning";
                });
              }, f(g, [{ key: "content", get: function() {
                return this.css;
              } }]), g;
            }(), h = p;
            e.default = h, n.exports = e.default;
          } }), ia = R({ "node_modules/postcss/lib/lazy-result.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = h(Sf()), a = h(Zo()), o = h(Of()), f = h(Ef()), p = h(ra());
            function h(v) {
              return v && v.__esModule ? v : { default: v };
            }
            function g(v, y) {
              var w;
              if (typeof Symbol > "u" || v[Symbol.iterator] == null) {
                if (Array.isArray(v) || (w = c(v)) || y && v && typeof v.length == "number") {
                  w && (v = w);
                  var d = 0;
                  return function() {
                    return d >= v.length ? { done: true } : { done: false, value: v[d++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return w = v[Symbol.iterator](), w.next.bind(w);
            }
            function c(v, y) {
              if (!!v) {
                if (typeof v == "string")
                  return t3(v, y);
                var w = Object.prototype.toString.call(v).slice(8, -1);
                if (w === "Object" && v.constructor && (w = v.constructor.name), w === "Map" || w === "Set")
                  return Array.from(v);
                if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w))
                  return t3(v, y);
              }
            }
            function t3(v, y) {
              (y == null || y > v.length) && (y = v.length);
              for (var w = 0, d = new Array(y); w < y; w++)
                d[w] = v[w];
              return d;
            }
            function r(v, y) {
              for (var w = 0; w < y.length; w++) {
                var d = y[w];
                d.enumerable = d.enumerable || false, d.configurable = true, "value" in d && (d.writable = true), Object.defineProperty(v, d.key, d);
              }
            }
            function u(v, y, w) {
              return y && r(v.prototype, y), w && r(v, w), v;
            }
            function s(v) {
              return typeof v == "object" && typeof v.then == "function";
            }
            var l = function() {
              function v(w, d, _) {
                this.stringified = false, this.processed = false;
                var S;
                if (typeof d == "object" && d !== null && d.type === "root")
                  S = d;
                else if (d instanceof v || d instanceof f.default)
                  S = d.root, d.map && (typeof _.map > "u" && (_.map = {}), _.map.inline || (_.map.inline = false), _.map.prev = d.map);
                else {
                  var x = p.default;
                  _.syntax && (x = _.syntax.parse), _.parser && (x = _.parser), x.parse && (x = x.parse);
                  try {
                    S = x(d, _);
                  } catch (N) {
                    this.error = N;
                  }
                }
                this.result = new f.default(w, S, _);
              }
              var y = v.prototype;
              return y.warnings = function() {
                return this.sync().warnings();
              }, y.toString = function() {
                return this.css;
              }, y.then = function(d, _) {
                return this.async().then(d, _);
              }, y.catch = function(d) {
                return this.async().catch(d);
              }, y.finally = function(d) {
                return this.async().then(d, d);
              }, y.handleError = function(d, _) {
                try {
                  if (this.error = d, d.name === "CssSyntaxError" && !d.plugin)
                    d.plugin = _.postcssPlugin, d.setMessage();
                  else if (_.postcssVersion && false)
                    var S, x, N, P, W;
                } catch (U) {
                  console && console.error && console.error(U);
                }
              }, y.asyncTick = function(d, _) {
                var S = this;
                if (this.plugin >= this.processor.plugins.length)
                  return this.processed = true, d();
                try {
                  var x = this.processor.plugins[this.plugin], N = this.run(x);
                  this.plugin += 1, s(N) ? N.then(function() {
                    S.asyncTick(d, _);
                  }).catch(function(P) {
                    S.handleError(P, x), S.processed = true, _(P);
                  }) : this.asyncTick(d, _);
                } catch (P) {
                  this.processed = true, _(P);
                }
              }, y.async = function() {
                var d = this;
                return this.processed ? new Promise(function(_, S) {
                  d.error ? S(d.error) : _(d.stringify());
                }) : this.processing ? this.processing : (this.processing = new Promise(function(_, S) {
                  if (d.error)
                    return S(d.error);
                  d.plugin = 0, d.asyncTick(_, S);
                }).then(function() {
                  return d.processed = true, d.stringify();
                }), this.processing);
              }, y.sync = function() {
                if (this.processed)
                  return this.result;
                if (this.processed = true, this.processing)
                  throw new Error("Use process(css).then(cb) to work with async plugins");
                if (this.error)
                  throw this.error;
                for (var d = g(this.result.processor.plugins), _; !(_ = d()).done; ) {
                  var S = _.value, x = this.run(S);
                  if (s(x))
                    throw new Error("Use process(css).then(cb) to work with async plugins");
                }
                return this.result;
              }, y.run = function(d) {
                this.result.lastPlugin = d;
                try {
                  return d(this.result.root, this.result);
                } catch (_) {
                  throw this.handleError(_, d), _;
                }
              }, y.stringify = function() {
                if (this.stringified)
                  return this.result;
                this.stringified = true, this.sync();
                var d = this.result.opts, _ = a.default;
                d.syntax && (_ = d.syntax.stringify), d.stringifier && (_ = d.stringifier), _.stringify && (_ = _.stringify);
                var S = new i.default(_, this.result.root, this.result.opts), x = S.generate();
                return this.result.css = x[0], this.result.map = x[1], this.result;
              }, u(v, [{ key: "processor", get: function() {
                return this.result.processor;
              } }, { key: "opts", get: function() {
                return this.result.opts;
              } }, { key: "css", get: function() {
                return this.stringify().css;
              } }, { key: "content", get: function() {
                return this.stringify().content;
              } }, { key: "map", get: function() {
                return this.stringify().map;
              } }, { key: "root", get: function() {
                return this.sync().root;
              } }, { key: "messages", get: function() {
                return this.sync().messages;
              } }]), v;
            }(), m = l;
            e.default = m, n.exports = e.default;
          } }), qf = R({ "node_modules/postcss/lib/processor.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = a(ia());
            function a(c) {
              return c && c.__esModule ? c : { default: c };
            }
            function o(c, t3) {
              var r;
              if (typeof Symbol > "u" || c[Symbol.iterator] == null) {
                if (Array.isArray(c) || (r = f(c)) || t3 && c && typeof c.length == "number") {
                  r && (c = r);
                  var u = 0;
                  return function() {
                    return u >= c.length ? { done: true } : { done: false, value: c[u++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return r = c[Symbol.iterator](), r.next.bind(r);
            }
            function f(c, t3) {
              if (!!c) {
                if (typeof c == "string")
                  return p(c, t3);
                var r = Object.prototype.toString.call(c).slice(8, -1);
                if (r === "Object" && c.constructor && (r = c.constructor.name), r === "Map" || r === "Set")
                  return Array.from(c);
                if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
                  return p(c, t3);
              }
            }
            function p(c, t3) {
              (t3 == null || t3 > c.length) && (t3 = c.length);
              for (var r = 0, u = new Array(t3); r < t3; r++)
                u[r] = c[r];
              return u;
            }
            var h = function() {
              function c(r) {
                r === void 0 && (r = []), this.version = "7.0.39", this.plugins = this.normalize(r);
              }
              var t3 = c.prototype;
              return t3.use = function(u) {
                return this.plugins = this.plugins.concat(this.normalize([u])), this;
              }, t3.process = function(r) {
                function u(s) {
                  return r.apply(this, arguments);
                }
                return u.toString = function() {
                  return r.toString();
                }, u;
              }(function(r, u) {
                return u === void 0 && (u = {}), this.plugins.length === 0 && (u.parser, u.stringifier), new i.default(this, r, u);
              }), t3.normalize = function(u) {
                for (var s = [], l = o(u), m; !(m = l()).done; ) {
                  var v = m.value;
                  if (v.postcss === true) {
                    var y = v();
                    throw new Error("PostCSS plugin " + y.postcssPlugin + ` requires PostCSS 8.
Migration guide for end-users:
https://github.com/postcss/postcss/wiki/PostCSS-8-for-end-users`);
                  }
                  if (v.postcss && (v = v.postcss), typeof v == "object" && Array.isArray(v.plugins))
                    s = s.concat(v.plugins);
                  else if (typeof v == "function")
                    s.push(v);
                  else if (!(typeof v == "object" && (v.parse || v.stringify)))
                    throw typeof v == "object" && v.postcssPlugin ? new Error("PostCSS plugin " + v.postcssPlugin + ` requires PostCSS 8.
Migration guide for end-users:
https://github.com/postcss/postcss/wiki/PostCSS-8-for-end-users`) : new Error(v + " is not a PostCSS plugin");
                }
                return s;
              }, c;
            }(), g = h;
            e.default = g, n.exports = e.default;
          } }), Af = R({ "node_modules/postcss/lib/root.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = a(kr());
            function a(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            function o(t3, r) {
              var u;
              if (typeof Symbol > "u" || t3[Symbol.iterator] == null) {
                if (Array.isArray(t3) || (u = f(t3)) || r && t3 && typeof t3.length == "number") {
                  u && (t3 = u);
                  var s = 0;
                  return function() {
                    return s >= t3.length ? { done: true } : { done: false, value: t3[s++] };
                  };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              return u = t3[Symbol.iterator](), u.next.bind(u);
            }
            function f(t3, r) {
              if (!!t3) {
                if (typeof t3 == "string")
                  return p(t3, r);
                var u = Object.prototype.toString.call(t3).slice(8, -1);
                if (u === "Object" && t3.constructor && (u = t3.constructor.name), u === "Map" || u === "Set")
                  return Array.from(t3);
                if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u))
                  return p(t3, r);
              }
            }
            function p(t3, r) {
              (r == null || r > t3.length) && (r = t3.length);
              for (var u = 0, s = new Array(r); u < r; u++)
                s[u] = t3[u];
              return s;
            }
            function h(t3, r) {
              t3.prototype = Object.create(r.prototype), t3.prototype.constructor = t3, t3.__proto__ = r;
            }
            var g = function(t3) {
              h(r, t3);
              function r(s) {
                var l;
                return l = t3.call(this, s) || this, l.type = "root", l.nodes || (l.nodes = []), l;
              }
              var u = r.prototype;
              return u.removeChild = function(l, m) {
                var v = this.index(l);
                return !m && v === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[v].raws.before), t3.prototype.removeChild.call(this, l);
              }, u.normalize = function(l, m, v) {
                var y = t3.prototype.normalize.call(this, l);
                if (m) {
                  if (v === "prepend")
                    this.nodes.length > 1 ? m.raws.before = this.nodes[1].raws.before : delete m.raws.before;
                  else if (this.first !== m)
                    for (var w = o(y), d; !(d = w()).done; ) {
                      var _ = d.value;
                      _.raws.before = m.raws.before;
                    }
                }
                return y;
              }, u.toResult = function(l) {
                l === void 0 && (l = {});
                var m = ia(), v = qf(), y = new m(new v(), this, l);
                return y.stringify();
              }, r;
            }(i.default), c = g;
            e.default = c, n.exports = e.default;
          } }), zt = R({ "node_modules/postcss/lib/parser.js"(e, n) {
            "use strict";
            A(), e.__esModule = true, e.default = void 0;
            var i = g(ea()), a = g(Lt()), o = g(xr()), f = g(na()), p = g(Af()), h = g(ta());
            function g(t3) {
              return t3 && t3.__esModule ? t3 : { default: t3 };
            }
            var c = function() {
              function t3(u) {
                this.input = u, this.root = new p.default(), this.current = this.root, this.spaces = "", this.semicolon = false, this.createTokenizer(), this.root.source = { input: u, start: { line: 1, column: 1 } };
              }
              var r = t3.prototype;
              return r.createTokenizer = function() {
                this.tokenizer = (0, a.default)(this.input);
              }, r.parse = function() {
                for (var s; !this.tokenizer.endOfFile(); )
                  switch (s = this.tokenizer.nextToken(), s[0]) {
                    case "space":
                      this.spaces += s[1];
                      break;
                    case ";":
                      this.freeSemicolon(s);
                      break;
                    case "}":
                      this.end(s);
                      break;
                    case "comment":
                      this.comment(s);
                      break;
                    case "at-word":
                      this.atrule(s);
                      break;
                    case "{":
                      this.emptyRule(s);
                      break;
                    default:
                      this.other(s);
                      break;
                  }
                this.endFile();
              }, r.comment = function(s) {
                var l = new o.default();
                this.init(l, s[2], s[3]), l.source.end = { line: s[4], column: s[5] };
                var m = s[1].slice(2, -2);
                if (/^\s*$/.test(m))
                  l.text = "", l.raws.left = m, l.raws.right = "";
                else {
                  var v = m.match(/^(\s*)([^]*[^\s])(\s*)$/);
                  l.text = v[2], l.raws.left = v[1], l.raws.right = v[3];
                }
              }, r.emptyRule = function(s) {
                var l = new h.default();
                this.init(l, s[2], s[3]), l.selector = "", l.raws.between = "", this.current = l;
              }, r.other = function(s) {
                for (var l = false, m = null, v = false, y = null, w = [], d = [], _ = s; _; ) {
                  if (m = _[0], d.push(_), m === "(" || m === "[")
                    y || (y = _), w.push(m === "(" ? ")" : "]");
                  else if (w.length === 0)
                    if (m === ";")
                      if (v) {
                        this.decl(d);
                        return;
                      } else
                        break;
                    else if (m === "{") {
                      this.rule(d);
                      return;
                    } else if (m === "}") {
                      this.tokenizer.back(d.pop()), l = true;
                      break;
                    } else
                      m === ":" && (v = true);
                  else
                    m === w[w.length - 1] && (w.pop(), w.length === 0 && (y = null));
                  _ = this.tokenizer.nextToken();
                }
                if (this.tokenizer.endOfFile() && (l = true), w.length > 0 && this.unclosedBracket(y), l && v) {
                  for (; d.length && (_ = d[d.length - 1][0], !(_ !== "space" && _ !== "comment")); )
                    this.tokenizer.back(d.pop());
                  this.decl(d);
                } else
                  this.unknownWord(d);
              }, r.rule = function(s) {
                s.pop();
                var l = new h.default();
                this.init(l, s[0][2], s[0][3]), l.raws.between = this.spacesAndCommentsFromEnd(s), this.raw(l, "selector", s), this.current = l;
              }, r.decl = function(s) {
                var l = new i.default();
                this.init(l);
                var m = s[s.length - 1];
                for (m[0] === ";" && (this.semicolon = true, s.pop()), m[4] ? l.source.end = { line: m[4], column: m[5] } : l.source.end = { line: m[2], column: m[3] }; s[0][0] !== "word"; )
                  s.length === 1 && this.unknownWord(s), l.raws.before += s.shift()[1];
                for (l.source.start = { line: s[0][2], column: s[0][3] }, l.prop = ""; s.length; ) {
                  var v = s[0][0];
                  if (v === ":" || v === "space" || v === "comment")
                    break;
                  l.prop += s.shift()[1];
                }
                l.raws.between = "";
                for (var y; s.length; )
                  if (y = s.shift(), y[0] === ":") {
                    l.raws.between += y[1];
                    break;
                  } else
                    y[0] === "word" && /\w/.test(y[1]) && this.unknownWord([y]), l.raws.between += y[1];
                (l.prop[0] === "_" || l.prop[0] === "*") && (l.raws.before += l.prop[0], l.prop = l.prop.slice(1)), l.raws.between += this.spacesAndCommentsFromStart(s), this.precheckMissedSemicolon(s);
                for (var w = s.length - 1; w > 0; w--) {
                  if (y = s[w], y[1].toLowerCase() === "!important") {
                    l.important = true;
                    var d = this.stringFrom(s, w);
                    d = this.spacesFromEnd(s) + d, d !== " !important" && (l.raws.important = d);
                    break;
                  } else if (y[1].toLowerCase() === "important") {
                    for (var _ = s.slice(0), S = "", x = w; x > 0; x--) {
                      var N = _[x][0];
                      if (S.trim().indexOf("!") === 0 && N !== "space")
                        break;
                      S = _.pop()[1] + S;
                    }
                    S.trim().indexOf("!") === 0 && (l.important = true, l.raws.important = S, s = _);
                  }
                  if (y[0] !== "space" && y[0] !== "comment")
                    break;
                }
                this.raw(l, "value", s), l.value.indexOf(":") !== -1 && this.checkMissedSemicolon(s);
              }, r.atrule = function(s) {
                var l = new f.default();
                l.name = s[1].slice(1), l.name === "" && this.unnamedAtrule(l, s), this.init(l, s[2], s[3]);
                for (var m, v, y = false, w = false, d = []; !this.tokenizer.endOfFile(); ) {
                  if (s = this.tokenizer.nextToken(), s[0] === ";") {
                    l.source.end = { line: s[2], column: s[3] }, this.semicolon = true;
                    break;
                  } else if (s[0] === "{") {
                    w = true;
                    break;
                  } else if (s[0] === "}") {
                    if (d.length > 0) {
                      for (v = d.length - 1, m = d[v]; m && m[0] === "space"; )
                        m = d[--v];
                      m && (l.source.end = { line: m[4], column: m[5] });
                    }
                    this.end(s);
                    break;
                  } else
                    d.push(s);
                  if (this.tokenizer.endOfFile()) {
                    y = true;
                    break;
                  }
                }
                l.raws.between = this.spacesAndCommentsFromEnd(d), d.length ? (l.raws.afterName = this.spacesAndCommentsFromStart(d), this.raw(l, "params", d), y && (s = d[d.length - 1], l.source.end = { line: s[4], column: s[5] }, this.spaces = l.raws.between, l.raws.between = "")) : (l.raws.afterName = "", l.params = ""), w && (l.nodes = [], this.current = l);
              }, r.end = function(s) {
                this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = false, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = { line: s[2], column: s[3] }, this.current = this.current.parent) : this.unexpectedClose(s);
              }, r.endFile = function() {
                this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces;
              }, r.freeSemicolon = function(s) {
                if (this.spaces += s[1], this.current.nodes) {
                  var l = this.current.nodes[this.current.nodes.length - 1];
                  l && l.type === "rule" && !l.raws.ownSemicolon && (l.raws.ownSemicolon = this.spaces, this.spaces = "");
                }
              }, r.init = function(s, l, m) {
                this.current.push(s), s.source = { start: { line: l, column: m }, input: this.input }, s.raws.before = this.spaces, this.spaces = "", s.type !== "comment" && (this.semicolon = false);
              }, r.raw = function(s, l, m) {
                for (var v, y, w = m.length, d = "", _ = true, S, x, N = /^([.|#])?([\w])+/i, P = 0; P < w; P += 1) {
                  if (v = m[P], y = v[0], y === "comment" && s.type === "rule") {
                    x = m[P - 1], S = m[P + 1], x[0] !== "space" && S[0] !== "space" && N.test(x[1]) && N.test(S[1]) ? d += v[1] : _ = false;
                    continue;
                  }
                  y === "comment" || y === "space" && P === w - 1 ? _ = false : d += v[1];
                }
                if (!_) {
                  var W = m.reduce(function(U, H) {
                    return U + H[1];
                  }, "");
                  s.raws[l] = { value: d, raw: W };
                }
                s[l] = d;
              }, r.spacesAndCommentsFromEnd = function(s) {
                for (var l, m = ""; s.length && (l = s[s.length - 1][0], !(l !== "space" && l !== "comment")); )
                  m = s.pop()[1] + m;
                return m;
              }, r.spacesAndCommentsFromStart = function(s) {
                for (var l, m = ""; s.length && (l = s[0][0], !(l !== "space" && l !== "comment")); )
                  m += s.shift()[1];
                return m;
              }, r.spacesFromEnd = function(s) {
                for (var l, m = ""; s.length && (l = s[s.length - 1][0], l === "space"); )
                  m = s.pop()[1] + m;
                return m;
              }, r.stringFrom = function(s, l) {
                for (var m = "", v = l; v < s.length; v++)
                  m += s[v][1];
                return s.splice(l, s.length - l), m;
              }, r.colon = function(s) {
                for (var l = 0, m, v, y, w = 0; w < s.length; w++) {
                  if (m = s[w], v = m[0], v === "(" && (l += 1), v === ")" && (l -= 1), l === 0 && v === ":")
                    if (!y)
                      this.doubleColon(m);
                    else {
                      if (y[0] === "word" && y[1] === "progid")
                        continue;
                      return w;
                    }
                  y = m;
                }
                return false;
              }, r.unclosedBracket = function(s) {
                throw this.input.error("Unclosed bracket", s[2], s[3]);
              }, r.unknownWord = function(s) {
                throw this.input.error("Unknown word", s[0][2], s[0][3]);
              }, r.unexpectedClose = function(s) {
                throw this.input.error("Unexpected }", s[2], s[3]);
              }, r.unclosedBlock = function() {
                var s = this.current.source.start;
                throw this.input.error("Unclosed block", s.line, s.column);
              }, r.doubleColon = function(s) {
                throw this.input.error("Double colon", s[2], s[3]);
              }, r.unnamedAtrule = function(s, l) {
                throw this.input.error("At-rule without name", l[2], l[3]);
              }, r.precheckMissedSemicolon = function() {
              }, r.checkMissedSemicolon = function(s) {
                var l = this.colon(s);
                if (l !== false) {
                  for (var m = 0, v, y = l - 1; y >= 0 && (v = s[y], !(v[0] !== "space" && (m += 1, m === 2))); y--)
                    ;
                  throw this.input.error("Missed semicolon", v[2], v[3]);
                }
              }, t3;
            }();
            e.default = c, n.exports = e.default;
          } }), Pf = R({ "node_modules/postcss-less/lib/nodes/inline-comment.js"(e, n) {
            A();
            var i = Lt(), a = _r();
            n.exports = { isInlineComment(o) {
              if (o[0] === "word" && o[1].slice(0, 2) === "//") {
                let f = o, p = [], h;
                for (; o; ) {
                  if (/\r?\n/.test(o[1])) {
                    if (/['"].*\r?\n/.test(o[1])) {
                      p.push(o[1].substring(0, o[1].indexOf(`
`)));
                      let c = o[1].substring(o[1].indexOf(`
`));
                      c += this.input.css.valueOf().substring(this.tokenizer.position()), this.input = new a(c), this.tokenizer = i(this.input);
                    } else
                      this.tokenizer.back(o);
                    break;
                  }
                  p.push(o[1]), h = o, o = this.tokenizer.nextToken({ ignoreUnclosed: true });
                }
                let g = ["comment", p.join(""), f[2], f[3], h[2], h[3]];
                return this.inlineComment(g), true;
              } else if (o[1] === "/") {
                let f = this.tokenizer.nextToken({ ignoreUnclosed: true });
                if (f[0] === "comment" && /^\/\*/.test(f[1]))
                  return f[0] = "word", f[1] = f[1].slice(1), o[1] = "//", this.tokenizer.back(f), n.exports.isInlineComment.bind(this)(o);
              }
              return false;
            } };
          } }), Rf = R({ "node_modules/postcss-less/lib/nodes/interpolation.js"(e, n) {
            A(), n.exports = { interpolation(i) {
              let a = i, o = [i], f = ["word", "{", "}"];
              if (i = this.tokenizer.nextToken(), a[1].length > 1 || i[0] !== "{")
                return this.tokenizer.back(i), false;
              for (; i && f.includes(i[0]); )
                o.push(i), i = this.tokenizer.nextToken();
              let p = o.map((r) => r[1]);
              [a] = o;
              let h = o.pop(), g = [a[2], a[3]], c = [h[4] || h[2], h[5] || h[3]], t3 = ["word", p.join("")].concat(g, c);
              return this.tokenizer.back(i), this.tokenizer.back(t3), true;
            } };
          } }), If = R({ "node_modules/postcss-less/lib/nodes/mixin.js"(e, n) {
            A();
            var i = /^#[0-9a-fA-F]{6}$|^#[0-9a-fA-F]{3}$/, a = /\.[0-9]/, o = (f) => {
              let [, p] = f, [h] = p;
              return (h === "." || h === "#") && i.test(p) === false && a.test(p) === false;
            };
            n.exports = { isMixinToken: o };
          } }), Cf = R({ "node_modules/postcss-less/lib/nodes/import.js"(e, n) {
            A();
            var i = Lt(), a = /^url\((.+)\)/;
            n.exports = (o) => {
              let { name: f, params: p = "" } = o;
              if (f === "import" && p.length) {
                o.import = true;
                let h = i({ css: p });
                for (o.filename = p.replace(a, "$1"); !h.endOfFile(); ) {
                  let [g, c] = h.nextToken();
                  if (g === "word" && c === "url")
                    return;
                  if (g === "brackets") {
                    o.options = c, o.filename = p.replace(c, "").trim();
                    break;
                  }
                }
              }
            };
          } }), Nf = R({ "node_modules/postcss-less/lib/nodes/variable.js"(e, n) {
            A();
            var i = /:$/, a = /^:(\s+)?/;
            n.exports = (o) => {
              let { name: f, params: p = "" } = o;
              if (o.name.slice(-1) === ":") {
                if (i.test(f)) {
                  let [h] = f.match(i);
                  o.name = f.replace(h, ""), o.raws.afterName = h + (o.raws.afterName || ""), o.variable = true, o.value = o.params;
                }
                if (a.test(p)) {
                  let [h] = p.match(a);
                  o.value = p.replace(h, ""), o.raws.afterName = (o.raws.afterName || "") + h, o.variable = true;
                }
              }
            };
          } }), jf = R({ "node_modules/postcss-less/lib/LessParser.js"(e, n) {
            A();
            var i = xr(), a = zt(), { isInlineComment: o } = Pf(), { interpolation: f } = Rf(), { isMixinToken: p } = If(), h = Cf(), g = Nf(), c = /(!\s*important)$/i;
            n.exports = class extends a {
              constructor() {
                super(...arguments), this.lastNode = null;
              }
              atrule(r) {
                f.bind(this)(r) || (super.atrule(r), h(this.lastNode), g(this.lastNode));
              }
              decl() {
                super.decl(...arguments), /extend\(.+\)/i.test(this.lastNode.value) && (this.lastNode.extend = true);
              }
              each(r) {
                r[0][1] = " ".concat(r[0][1]);
                let u = r.findIndex((y) => y[0] === "("), s = r.reverse().find((y) => y[0] === ")"), l = r.reverse().indexOf(s), v = r.splice(u, l).map((y) => y[1]).join("");
                for (let y of r.reverse())
                  this.tokenizer.back(y);
                this.atrule(this.tokenizer.nextToken()), this.lastNode.function = true, this.lastNode.params = v;
              }
              init(r, u, s) {
                super.init(r, u, s), this.lastNode = r;
              }
              inlineComment(r) {
                let u = new i(), s = r[1].slice(2);
                if (this.init(u, r[2], r[3]), u.source.end = { line: r[4], column: r[5] }, u.inline = true, u.raws.begin = "//", /^\s*$/.test(s))
                  u.text = "", u.raws.left = s, u.raws.right = "";
                else {
                  let l = s.match(/^(\s*)([^]*[^\s])(\s*)$/);
                  [, u.raws.left, u.text, u.raws.right] = l;
                }
              }
              mixin(r) {
                let [u] = r, s = u[1].slice(0, 1), l = r.findIndex((d) => d[0] === "brackets"), m = r.findIndex((d) => d[0] === "("), v = "";
                if ((l < 0 || l > 3) && m > 0) {
                  let d = r.reduce(($, B, O) => B[0] === ")" ? O : $), S = r.slice(m, d + m).map(($) => $[1]).join(""), [x] = r.slice(m), N = [x[2], x[3]], [P] = r.slice(d, d + 1), W = [P[2], P[3]], U = ["brackets", S].concat(N, W), H = r.slice(0, m), D = r.slice(d + 1);
                  r = H, r.push(U), r = r.concat(D);
                }
                let y = [];
                for (let d of r)
                  if ((d[1] === "!" || y.length) && y.push(d), d[1] === "important")
                    break;
                if (y.length) {
                  let [d] = y, _ = r.indexOf(d), S = y[y.length - 1], x = [d[2], d[3]], N = [S[4], S[5]], P = y.map((U) => U[1]).join(""), W = ["word", P].concat(x, N);
                  r.splice(_, y.length, W);
                }
                let w = r.findIndex((d) => c.test(d[1]));
                w > 0 && ([, v] = r[w], r.splice(w, 1));
                for (let d of r.reverse())
                  this.tokenizer.back(d);
                this.atrule(this.tokenizer.nextToken()), this.lastNode.mixin = true, this.lastNode.raws.identifier = s, v && (this.lastNode.important = true, this.lastNode.raws.important = v);
              }
              other(r) {
                o.bind(this)(r) || super.other(r);
              }
              rule(r) {
                let u = r[r.length - 1], s = r[r.length - 2];
                if (s[0] === "at-word" && u[0] === "{" && (this.tokenizer.back(u), f.bind(this)(s))) {
                  let m = this.tokenizer.nextToken();
                  r = r.slice(0, r.length - 2).concat([m]);
                  for (let v of r.reverse())
                    this.tokenizer.back(v);
                  return;
                }
                super.rule(r), /:extend\(.+\)/i.test(this.lastNode.selector) && (this.lastNode.extend = true);
              }
              unknownWord(r) {
                let [u] = r;
                if (r[0][1] === "each" && r[1][0] === "(") {
                  this.each(r);
                  return;
                }
                if (p(u)) {
                  this.mixin(r);
                  return;
                }
                super.unknownWord(r);
              }
            };
          } }), Mf = R({ "node_modules/postcss-less/lib/LessStringifier.js"(e, n) {
            A();
            var i = br();
            n.exports = class extends i {
              atrule(o, f) {
                if (!o.mixin && !o.variable && !o.function) {
                  super.atrule(o, f);
                  return;
                }
                let p = o.function ? "" : o.raws.identifier || "@", h = "".concat(p).concat(o.name), g = o.params ? this.rawValue(o, "params") : "", c = o.raws.important || "";
                if (o.variable && (g = o.value), typeof o.raws.afterName < "u" ? h += o.raws.afterName : g && (h += " "), o.nodes)
                  this.block(o, h + g + c);
                else {
                  let t3 = (o.raws.between || "") + c + (f ? ";" : "");
                  this.builder(h + g + t3, o);
                }
              }
              comment(o) {
                if (o.inline) {
                  let f = this.raw(o, "left", "commentLeft"), p = this.raw(o, "right", "commentRight");
                  this.builder("//".concat(f).concat(o.text).concat(p), o);
                } else
                  super.comment(o);
              }
            };
          } }), Df = R({ "node_modules/postcss-less/lib/index.js"(e, n) {
            A();
            var i = _r(), a = jf(), o = Mf();
            n.exports = { parse(f, p) {
              let h = new i(f, p), g = new a(h);
              return g.parse(), g.root;
            }, stringify(f, p) {
              new o(p).stringify(f);
            }, nodeToString(f) {
              let p = "";
              return n.exports.stringify(f, (h) => {
                p += h;
              }), p;
            } };
          } }), Lf = R({ "node_modules/postcss-scss/lib/scss-stringifier.js"(e, n) {
            "use strict";
            A();
            function i(f, p) {
              f.prototype = Object.create(p.prototype), f.prototype.constructor = f, f.__proto__ = p;
            }
            var a = br(), o = function(f) {
              i(p, f);
              function p() {
                return f.apply(this, arguments) || this;
              }
              var h = p.prototype;
              return h.comment = function(c) {
                var t3 = this.raw(c, "left", "commentLeft"), r = this.raw(c, "right", "commentRight");
                if (c.raws.inline) {
                  var u = c.raws.text || c.text;
                  this.builder("//" + t3 + u + r, c);
                } else
                  this.builder("/*" + t3 + c.text + r + "*/", c);
              }, h.decl = function(c, t3) {
                if (!c.isNested)
                  f.prototype.decl.call(this, c, t3);
                else {
                  var r = this.raw(c, "between", "colon"), u = c.prop + r + this.rawValue(c, "value");
                  c.important && (u += c.raws.important || " !important"), this.builder(u + "{", c, "start");
                  var s;
                  c.nodes && c.nodes.length ? (this.body(c), s = this.raw(c, "after")) : s = this.raw(c, "after", "emptyBody"), s && this.builder(s), this.builder("}", c, "end");
                }
              }, h.rawValue = function(c, t3) {
                var r = c[t3], u = c.raws[t3];
                return u && u.value === r ? u.scss ? u.scss : u.raw : r;
              }, p;
            }(a);
            n.exports = o;
          } }), zf = R({ "node_modules/postcss-scss/lib/scss-stringify.js"(e, n) {
            "use strict";
            A();
            var i = Lf();
            n.exports = function(o, f) {
              var p = new i(f);
              p.stringify(o);
            };
          } }), Bf = R({ "node_modules/postcss-scss/lib/nested-declaration.js"(e, n) {
            "use strict";
            A();
            function i(f, p) {
              f.prototype = Object.create(p.prototype), f.prototype.constructor = f, f.__proto__ = p;
            }
            var a = kr(), o = function(f) {
              i(p, f);
              function p(h) {
                var g;
                return g = f.call(this, h) || this, g.type = "decl", g.isNested = true, g.nodes || (g.nodes = []), g;
              }
              return p;
            }(a);
            n.exports = o;
          } }), Ff = R({ "node_modules/postcss-scss/lib/scss-tokenize.js"(e, n) {
            "use strict";
            A();
            var i = "'".charCodeAt(0), a = '"'.charCodeAt(0), o = "\\".charCodeAt(0), f = "/".charCodeAt(0), p = `
`.charCodeAt(0), h = " ".charCodeAt(0), g = "\f".charCodeAt(0), c = "	".charCodeAt(0), t3 = "\r".charCodeAt(0), r = "[".charCodeAt(0), u = "]".charCodeAt(0), s = "(".charCodeAt(0), l = ")".charCodeAt(0), m = "{".charCodeAt(0), v = "}".charCodeAt(0), y = ";".charCodeAt(0), w = "*".charCodeAt(0), d = ":".charCodeAt(0), _ = "@".charCodeAt(0), S = ",".charCodeAt(0), x = "#".charCodeAt(0), N = /[ \n\t\r\f{}()'"\\;/[\]#]/g, P = /[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g, W = /.[\\/("'\n]/, U = /[a-f0-9]/i, H = /[\r\f\n]/g;
            n.exports = function($, B) {
              B === void 0 && (B = {});
              var O = $.css.valueOf(), j = B.ignoreErrors, C, I, X, Z, Q, K, J, M, Y, G, E, k, b, L, q = O.length, T = -1, F = 1, z = 0, re = [], ne = [];
              function ce(se) {
                throw $.error("Unclosed " + se, F, z - T);
              }
              function fe() {
                return ne.length === 0 && z >= q;
              }
              function te() {
                for (var se = 1, le = false, pe = false; se > 0; )
                  I += 1, O.length <= I && ce("interpolation"), C = O.charCodeAt(I), k = O.charCodeAt(I + 1), le ? !pe && C === le ? (le = false, pe = false) : C === o ? pe = !G : pe && (pe = false) : C === i || C === a ? le = C : C === v ? se -= 1 : C === x && k === m && (se += 1);
              }
              function ie() {
                if (ne.length)
                  return ne.pop();
                if (!(z >= q)) {
                  switch (C = O.charCodeAt(z), (C === p || C === g || C === t3 && O.charCodeAt(z + 1) !== p) && (T = z, F += 1), C) {
                    case p:
                    case h:
                    case c:
                    case t3:
                    case g:
                      I = z;
                      do
                        I += 1, C = O.charCodeAt(I), C === p && (T = I, F += 1);
                      while (C === h || C === p || C === c || C === t3 || C === g);
                      b = ["space", O.slice(z, I)], z = I - 1;
                      break;
                    case r:
                      b = ["[", "[", F, z - T];
                      break;
                    case u:
                      b = ["]", "]", F, z - T];
                      break;
                    case m:
                      b = ["{", "{", F, z - T];
                      break;
                    case v:
                      b = ["}", "}", F, z - T];
                      break;
                    case S:
                      b = ["word", ",", F, z - T, F, z - T + 1];
                      break;
                    case d:
                      b = [":", ":", F, z - T];
                      break;
                    case y:
                      b = [";", ";", F, z - T];
                      break;
                    case s:
                      if (E = re.length ? re.pop()[1] : "", k = O.charCodeAt(z + 1), E === "url" && k !== i && k !== a) {
                        for (L = 1, G = false, I = z + 1; I <= O.length - 1; ) {
                          if (k = O.charCodeAt(I), k === o)
                            G = !G;
                          else if (k === s)
                            L += 1;
                          else if (k === l && (L -= 1, L === 0))
                            break;
                          I += 1;
                        }
                        K = O.slice(z, I + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = I - Z[Q].length) : (M = F, Y = T), b = ["brackets", K, F, z - T, M, I - Y], T = Y, F = M, z = I;
                      } else
                        I = O.indexOf(")", z + 1), K = O.slice(z, I + 1), I === -1 || W.test(K) ? b = ["(", "(", F, z - T] : (b = ["brackets", K, F, z - T, F, I - T], z = I);
                      break;
                    case l:
                      b = [")", ")", F, z - T];
                      break;
                    case i:
                    case a:
                      for (X = C, I = z, G = false; I < q && (I++, I === q && ce("string"), C = O.charCodeAt(I), k = O.charCodeAt(I + 1), !(!G && C === X)); )
                        C === o ? G = !G : G ? G = false : C === x && k === m && te();
                      K = O.slice(z, I + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = I - Z[Q].length) : (M = F, Y = T), b = ["string", O.slice(z, I + 1), F, z - T, M, I - Y], T = Y, F = M, z = I;
                      break;
                    case _:
                      N.lastIndex = z + 1, N.test(O), N.lastIndex === 0 ? I = O.length - 1 : I = N.lastIndex - 2, b = ["at-word", O.slice(z, I + 1), F, z - T, F, I - T], z = I;
                      break;
                    case o:
                      for (I = z, J = true; O.charCodeAt(I + 1) === o; )
                        I += 1, J = !J;
                      if (C = O.charCodeAt(I + 1), J && C !== f && C !== h && C !== p && C !== c && C !== t3 && C !== g && (I += 1, U.test(O.charAt(I)))) {
                        for (; U.test(O.charAt(I + 1)); )
                          I += 1;
                        O.charCodeAt(I + 1) === h && (I += 1);
                      }
                      b = ["word", O.slice(z, I + 1), F, z - T, F, I - T], z = I;
                      break;
                    default:
                      k = O.charCodeAt(z + 1), C === x && k === m ? (I = z, te(), K = O.slice(z, I + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = I - Z[Q].length) : (M = F, Y = T), b = ["word", K, F, z - T, M, I - Y], T = Y, F = M, z = I) : C === f && k === w ? (I = O.indexOf("*/", z + 2) + 1, I === 0 && (j ? I = O.length : ce("comment")), K = O.slice(z, I + 1), Z = K.split(`
`), Q = Z.length - 1, Q > 0 ? (M = F + Q, Y = I - Z[Q].length) : (M = F, Y = T), b = ["comment", K, F, z - T, M, I - Y], T = Y, F = M, z = I) : C === f && k === f ? (H.lastIndex = z + 1, H.test(O), H.lastIndex === 0 ? I = O.length - 1 : I = H.lastIndex - 2, K = O.slice(z, I + 1), b = ["comment", K, F, z - T, F, I - T, "inline"], z = I) : (P.lastIndex = z + 1, P.test(O), P.lastIndex === 0 ? I = O.length - 1 : I = P.lastIndex - 2, b = ["word", O.slice(z, I + 1), F, z - T, F, I - T], re.push(b), z = I);
                      break;
                  }
                  return z++, b;
                }
              }
              function ae(se) {
                ne.push(se);
              }
              return { back: ae, nextToken: ie, endOfFile: fe };
            };
          } }), Uf = R({ "node_modules/postcss-scss/lib/scss-parser.js"(e, n) {
            "use strict";
            A();
            function i(g, c) {
              g.prototype = Object.create(c.prototype), g.prototype.constructor = g, g.__proto__ = c;
            }
            var a = xr(), o = zt(), f = Bf(), p = Ff(), h = function(g) {
              i(c, g);
              function c() {
                return g.apply(this, arguments) || this;
              }
              var t3 = c.prototype;
              return t3.createTokenizer = function() {
                this.tokenizer = p(this.input);
              }, t3.rule = function(u) {
                for (var s = false, l = 0, m = "", w = u, v = Array.isArray(w), y = 0, w = v ? w : w[Symbol.iterator](); ; ) {
                  var d;
                  if (v) {
                    if (y >= w.length)
                      break;
                    d = w[y++];
                  } else {
                    if (y = w.next(), y.done)
                      break;
                    d = y.value;
                  }
                  var _ = d;
                  if (s)
                    _[0] !== "comment" && _[0] !== "{" && (m += _[1]);
                  else {
                    if (_[0] === "space" && _[1].indexOf(`
`) !== -1)
                      break;
                    _[0] === "(" ? l += 1 : _[0] === ")" ? l -= 1 : l === 0 && _[0] === ":" && (s = true);
                  }
                }
                if (!s || m.trim() === "" || /^[a-zA-Z-:#]/.test(m))
                  g.prototype.rule.call(this, u);
                else {
                  u.pop();
                  var S = new f();
                  this.init(S);
                  var x = u[u.length - 1];
                  for (x[4] ? S.source.end = { line: x[4], column: x[5] } : S.source.end = { line: x[2], column: x[3] }; u[0][0] !== "word"; )
                    S.raws.before += u.shift()[1];
                  for (S.source.start = { line: u[0][2], column: u[0][3] }, S.prop = ""; u.length; ) {
                    var N = u[0][0];
                    if (N === ":" || N === "space" || N === "comment")
                      break;
                    S.prop += u.shift()[1];
                  }
                  S.raws.between = "";
                  for (var P; u.length; )
                    if (P = u.shift(), P[0] === ":") {
                      S.raws.between += P[1];
                      break;
                    } else
                      S.raws.between += P[1];
                  (S.prop[0] === "_" || S.prop[0] === "*") && (S.raws.before += S.prop[0], S.prop = S.prop.slice(1)), S.raws.between += this.spacesAndCommentsFromStart(u), this.precheckMissedSemicolon(u);
                  for (var W = u.length - 1; W > 0; W--) {
                    if (P = u[W], P[1] === "!important") {
                      S.important = true;
                      var U = this.stringFrom(u, W);
                      U = this.spacesFromEnd(u) + U, U !== " !important" && (S.raws.important = U);
                      break;
                    } else if (P[1] === "important") {
                      for (var H = u.slice(0), D = "", $ = W; $ > 0; $--) {
                        var B = H[$][0];
                        if (D.trim().indexOf("!") === 0 && B !== "space")
                          break;
                        D = H.pop()[1] + D;
                      }
                      D.trim().indexOf("!") === 0 && (S.important = true, S.raws.important = D, u = H);
                    }
                    if (P[0] !== "space" && P[0] !== "comment")
                      break;
                  }
                  this.raw(S, "value", u), S.value.indexOf(":") !== -1 && this.checkMissedSemicolon(u), this.current = S;
                }
              }, t3.comment = function(u) {
                if (u[6] === "inline") {
                  var s = new a();
                  this.init(s, u[2], u[3]), s.raws.inline = true, s.source.end = { line: u[4], column: u[5] };
                  var l = u[1].slice(2);
                  if (/^\s*$/.test(l))
                    s.text = "", s.raws.left = l, s.raws.right = "";
                  else {
                    var m = l.match(/^(\s*)([^]*[^\s])(\s*)$/), v = m[2].replace(/(\*\/|\/\*)/g, "*//*");
                    s.text = v, s.raws.left = m[1], s.raws.right = m[3], s.raws.text = m[2];
                  }
                } else
                  g.prototype.comment.call(this, u);
              }, t3.raw = function(u, s, l) {
                if (g.prototype.raw.call(this, u, s, l), u.raws[s]) {
                  var m = u.raws[s].raw;
                  u.raws[s].raw = l.reduce(function(v, y) {
                    if (y[0] === "comment" && y[6] === "inline") {
                      var w = y[1].slice(2).replace(/(\*\/|\/\*)/g, "*//*");
                      return v + "/*" + w + "*/";
                    } else
                      return v + y[1];
                  }, ""), m !== u.raws[s].raw && (u.raws[s].scss = m);
                }
              }, c;
            }(o);
            n.exports = h;
          } }), Wf = R({ "node_modules/postcss-scss/lib/scss-parse.js"(e, n) {
            "use strict";
            A();
            var i = _r(), a = Uf();
            n.exports = function(f, p) {
              var h = new i(f, p), g = new a(h);
              return g.parse(), g.root;
            };
          } }), $f = R({ "node_modules/postcss-scss/lib/scss-syntax.js"(e, n) {
            "use strict";
            A();
            var i = zf(), a = Wf();
            n.exports = { parse: a, stringify: i };
          } });
          A();
          var Vf = ml(), pt = Cs(), Gf = Ns(), { hasPragma: Hf } = Tl(), { locStart: Jf, locEnd: Kf } = Js(), { calculateLoc: Qf, replaceQuotesInInlineComments: Yf } = Js(), Xf = Pl(), Zf = Rl(), ht = Il(), sa = Cl(), ep = Nl(), rp = jl(), tp = Ml(), np = Dl(), ip = (e) => {
            for (; e.parent; )
              e = e.parent;
            return e;
          };
          function sp(e, n) {
            let { nodes: i } = e, a = { open: null, close: null, groups: [], type: "paren_group" }, o = [a], f = a, p = { groups: [], type: "comma_group" }, h = [p];
            for (let g = 0; g < i.length; ++g) {
              let c = i[g];
              if (sa(n.parser, c.value) && c.type === "number" && c.unit === ".." && pt(c.value) === "." && (c.value = c.value.slice(0, -1), c.unit = "..."), c.type === "func" && c.value === "selector" && (c.group.groups = [Ie(ip(e).text.slice(c.group.open.sourceIndex + 1, c.group.close.sourceIndex))]), c.type === "func" && c.value === "url") {
                let t3 = c.group && c.group.groups || [], r = [];
                for (let u = 0; u < t3.length; u++) {
                  let s = t3[u];
                  s.type === "comma_group" ? r = [...r, ...s.groups] : r.push(s);
                }
                if (Xf(r) || !Zf(r) && !rp(r[0])) {
                  let u = tp({ groups: c.group.groups });
                  c.group.groups = [u.trim()];
                }
              }
              if (c.type === "paren" && c.value === "(")
                a = { open: c, close: null, groups: [], type: "paren_group" }, o.push(a), p = { groups: [], type: "comma_group" }, h.push(p);
              else if (c.type === "paren" && c.value === ")") {
                if (p.groups.length > 0 && a.groups.push(p), a.close = c, h.length === 1)
                  throw new Error("Unbalanced parenthesis");
                h.pop(), p = pt(h), p.groups.push(a), o.pop(), a = pt(o);
              } else
                c.type === "comma" ? (a.groups.push(p), p = { groups: [], type: "comma_group" }, h[h.length - 1] = p) : p.groups.push(c);
            }
            return p.groups.length > 0 && a.groups.push(p), f;
          }
          function hr(e) {
            return e.type === "paren_group" && !e.open && !e.close && e.groups.length === 1 || e.type === "comma_group" && e.groups.length === 1 ? hr(e.groups[0]) : e.type === "paren_group" || e.type === "comma_group" ? Object.assign(Object.assign({}, e), {}, { groups: e.groups.map(hr) }) : e;
          }
          function Xe(e, n, i) {
            if (e && typeof e == "object") {
              delete e.parent;
              for (let a in e)
                Xe(e[a], n, i), a === "type" && typeof e[a] == "string" && !e[a].startsWith(n) && (!i || !i.test(e[a])) && (e[a] = n + e[a]);
            }
            return e;
          }
          function oa(e) {
            if (e && typeof e == "object") {
              delete e.parent;
              for (let n in e)
                oa(e[n]);
              !Array.isArray(e) && e.value && !e.type && (e.type = "unknown");
            }
            return e;
          }
          function aa(e, n) {
            if (e && typeof e == "object") {
              for (let i in e)
                i !== "parent" && (aa(e[i], n), i === "nodes" && (e.group = hr(sp(e, n)), delete e[i]));
              delete e.parent;
            }
            return e;
          }
          function Pe(e, n) {
            let i = lf(), a = null;
            try {
              a = i(e, { loose: true }).parse();
            } catch {
              return { type: "value-unknown", value: e };
            }
            a.text = e;
            let o = aa(a, n);
            return Xe(o, "value-", /^selector-/);
          }
          function Ie(e) {
            if (/\/\/|\/\*/.test(e))
              return { type: "selector-unknown", value: e.trim() };
            let n = vf(), i = null;
            try {
              n((a) => {
                i = a;
              }).process(e);
            } catch {
              return { type: "selector-unknown", value: e };
            }
            return Xe(i, "selector-");
          }
          function op(e) {
            let n = gf().default, i = null;
            try {
              i = n(e);
            } catch {
              return { type: "selector-unknown", value: e };
            }
            return Xe(oa(i), "media-");
          }
          var ap = /(\s*)(!default).*$/, up = /(\s*)(!global).*$/;
          function ua(e, n) {
            if (e && typeof e == "object") {
              delete e.parent;
              for (let f in e)
                ua(e[f], n);
              if (!e.type)
                return e;
              e.raws || (e.raws = {});
              let i = "";
              typeof e.selector == "string" && (i = e.raws.selector ? e.raws.selector.scss ? e.raws.selector.scss : e.raws.selector.raw : e.selector, e.raws.between && e.raws.between.trim().length > 0 && (i += e.raws.between), e.raws.selector = i);
              let a = "";
              typeof e.value == "string" && (a = e.raws.value ? e.raws.value.scss ? e.raws.value.scss : e.raws.value.raw : e.value, a = a.trim(), e.raws.value = a);
              let o = "";
              if (typeof e.params == "string" && (o = e.raws.params ? e.raws.params.scss ? e.raws.params.scss : e.raws.params.raw : e.params, e.raws.afterName && e.raws.afterName.trim().length > 0 && (o = e.raws.afterName + o), e.raws.between && e.raws.between.trim().length > 0 && (o = o + e.raws.between), o = o.trim(), e.raws.params = o), i.trim().length > 0)
                return i.startsWith("@") && i.endsWith(":") ? e : e.mixin ? (e.selector = Pe(i, n), e) : (ep(e) && (e.isSCSSNesterProperty = true), e.selector = Ie(i), e);
              if (a.length > 0) {
                let f = a.match(ap);
                f && (a = a.slice(0, f.index), e.scssDefault = true, f[0].trim() !== "!default" && (e.raws.scssDefault = f[0]));
                let p = a.match(up);
                if (p && (a = a.slice(0, p.index), e.scssGlobal = true, p[0].trim() !== "!global" && (e.raws.scssGlobal = p[0])), a.startsWith("progid:"))
                  return { type: "value-unknown", value: a };
                e.value = Pe(a, n);
              }
              if (ht(n) && e.type === "css-decl" && a.startsWith("extend(") && (e.extend || (e.extend = e.raws.between === ":"), e.extend && !e.selector && (delete e.value, e.selector = Ie(a.slice(7, -1)))), e.type === "css-atrule") {
                if (ht(n)) {
                  if (e.mixin) {
                    let f = e.raws.identifier + e.name + e.raws.afterName + e.raws.params;
                    return e.selector = Ie(f), delete e.params, e;
                  }
                  if (e.function)
                    return e;
                }
                if (n.parser === "css" && e.name === "custom-selector") {
                  let f = e.params.match(/:--\S+\s+/)[0].trim();
                  return e.customSelector = f, e.selector = Ie(e.params.slice(f.length).trim()), delete e.params, e;
                }
                if (ht(n)) {
                  if (e.name.includes(":") && !e.params) {
                    e.variable = true;
                    let f = e.name.split(":");
                    e.name = f[0], e.value = Pe(f.slice(1).join(":"), n);
                  }
                  if (!["page", "nest", "keyframes"].includes(e.name) && e.params && e.params[0] === ":" && (e.variable = true, e.value = Pe(e.params.slice(1), n), e.raws.afterName += ":"), e.variable)
                    return delete e.params, e;
                }
              }
              if (e.type === "css-atrule" && o.length > 0) {
                let { name: f } = e, p = e.name.toLowerCase();
                return f === "warn" || f === "error" ? (e.params = { type: "media-unknown", value: o }, e) : f === "extend" || f === "nest" ? (e.selector = Ie(o), delete e.params, e) : f === "at-root" ? (/^\(\s*(?:without|with)\s*:.+\)$/s.test(o) ? e.params = Pe(o, n) : (e.selector = Ie(o), delete e.params), e) : np(p) ? (e.import = true, delete e.filename, e.params = Pe(o, n), e) : ["namespace", "supports", "if", "else", "for", "each", "while", "debug", "mixin", "include", "function", "return", "define-mixin", "add-mixin"].includes(f) ? (o = o.replace(/(\$\S+?)(\s+)?\.{3}/, "$1...$2"), o = o.replace(/^(?!if)(\S+)(\s+)\(/, "$1($2"), e.value = Pe(o, n), delete e.params, e) : ["media", "custom-media"].includes(p) ? o.includes("#{") ? { type: "media-unknown", value: o } : (e.params = op(o), e) : (e.params = o, e);
              }
            }
            return e;
          }
          function ca(e, n, i) {
            let a = Gf(n), { frontMatter: o } = a;
            n = a.content;
            let f;
            try {
              f = e(n);
            } catch (p) {
              let { name: h, reason: g, line: c, column: t3 } = p;
              throw typeof c != "number" ? p : Vf("".concat(h, ": ").concat(g), { start: { line: c, column: t3 } });
            }
            return f = ua(Xe(f, "css-"), i), Qf(f, n), o && (o.source = { startOffset: 0, endOffset: o.raw.length }, f.nodes.unshift(o)), f;
          }
          function cp(e, n) {
            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = sa(i.parser, e) ? [xt, bt] : [bt, xt], f;
            for (let p of o)
              try {
                return p(e, n, i);
              } catch (h) {
                f = f || h;
              }
            if (f)
              throw f;
          }
          function bt(e, n) {
            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = Df();
            return ca((o) => a.parse(Yf(o)), e, i);
          }
          function xt(e, n) {
            let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, { parse: a } = $f();
            return ca(a, e, i);
          }
          var dt = { astFormat: "postcss", hasPragma: Hf, locStart: Jf, locEnd: Kf };
          la.exports = { parsers: { css: Object.assign(Object.assign({}, dt), {}, { parse: cp }), less: Object.assign(Object.assign({}, dt), {}, { parse: bt }), scss: Object.assign(Object.assign({}, dt), {}, { parse: xt }) } };
        });
        return lp();
      });
    }
  });

  // node_modules/prettier/parser-html.js
  var require_parser_html = __commonJS({
    "node_modules/prettier/parser-html.js"(exports2, module2) {
      init_define_process();
      (function(e) {
        if (typeof exports2 == "object" && typeof module2 == "object")
          module2.exports = e();
        else if (typeof define == "function" && define.amd)
          define(e);
        else {
          var i = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof self < "u" ? self : this || {};
          i.prettierPlugins = i.prettierPlugins || {}, i.prettierPlugins.html = e();
        }
      })(function() {
        "use strict";
        var y = (e, r) => () => (r || e((r = { exports: {} }).exports, r), r.exports);
        var G = y((cl, zr) => {
          var we = function(e) {
            return e && e.Math == Math && e;
          };
          zr.exports = we(typeof globalThis == "object" && globalThis) || we(typeof window == "object" && window) || we(typeof self == "object" && self) || we(typeof global == "object" && global) || function() {
            return this;
          }() || Function("return this")();
        });
        var se = y((Dl, Wr) => {
          Wr.exports = function(e) {
            try {
              return !!e();
            } catch {
              return true;
            }
          };
        });
        var oe = y((ll, Yr) => {
          var bs = se();
          Yr.exports = !bs(function() {
            return Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1] != 7;
          });
        });
        var Ne = y((hl, Qr) => {
          var ws = se();
          Qr.exports = !ws(function() {
            var e = function() {
            }.bind();
            return typeof e != "function" || e.hasOwnProperty("prototype");
          });
        });
        var ce = y((pl, Kr) => {
          var Ns = Ne(), Oe = Function.prototype.call;
          Kr.exports = Ns ? Oe.bind(Oe) : function() {
            return Oe.apply(Oe, arguments);
          };
        });
        var rt = y((et) => {
          "use strict";
          var Jr = {}.propertyIsEnumerable, Zr = Object.getOwnPropertyDescriptor, Os = Zr && !Jr.call({ 1: 2 }, 1);
          et.f = Os ? function(r) {
            var t3 = Zr(this, r);
            return !!t3 && t3.enumerable;
          } : Jr;
        });
        var qe = y((dl, tt) => {
          tt.exports = function(e, r) {
            return { enumerable: !(e & 1), configurable: !(e & 2), writable: !(e & 4), value: r };
          };
        });
        var Q = y((El, st) => {
          var ut = Ne(), nt = Function.prototype, qs = nt.bind, er = nt.call, Is = ut && qs.bind(er, er);
          st.exports = ut ? function(e) {
            return e && Is(e);
          } : function(e) {
            return e && function() {
              return er.apply(e, arguments);
            };
          };
        });
        var Ie = y((Cl, it) => {
          var at2 = Q(), Rs = at2({}.toString), xs = at2("".slice);
          it.exports = function(e) {
            return xs(Rs(e), 8, -1);
          };
        });
        var ct = y((ml, ot) => {
          var Ps = G(), ks = Q(), Ls = se(), Ms = Ie(), rr = Ps.Object, js = ks("".split);
          ot.exports = Ls(function() {
            return !rr("z").propertyIsEnumerable(0);
          }) ? function(e) {
            return Ms(e) == "String" ? js(e, "") : rr(e);
          } : rr;
        });
        var tr = y((gl, Dt) => {
          var $s = G(), Us = $s.TypeError;
          Dt.exports = function(e) {
            if (e == null)
              throw Us("Can't call method on " + e);
            return e;
          };
        });
        var Re = y((Fl, lt2) => {
          var Gs = ct(), Vs = tr();
          lt2.exports = function(e) {
            return Gs(Vs(e));
          };
        });
        var K = y((Al, ht) => {
          ht.exports = function(e) {
            return typeof e == "function";
          };
        });
        var De = y((vl, pt) => {
          var Xs = K();
          pt.exports = function(e) {
            return typeof e == "object" ? e !== null : Xs(e);
          };
        });
        var ge = y((_l, ft) => {
          var ur = G(), Hs = K(), zs = function(e) {
            return Hs(e) ? e : void 0;
          };
          ft.exports = function(e, r) {
            return arguments.length < 2 ? zs(ur[e]) : ur[e] && ur[e][r];
          };
        });
        var nr = y((Sl, dt) => {
          var Ws = Q();
          dt.exports = Ws({}.isPrototypeOf);
        });
        var Ct = y((yl, Et) => {
          var Ys = ge();
          Et.exports = Ys("navigator", "userAgent") || "";
        });
        var St = y((Tl, _t) => {
          var vt = G(), sr = Ct(), mt = vt.process, gt2 = vt.Deno, Ft = mt && mt.versions || gt2 && gt2.version, At = Ft && Ft.v8, te, xe;
          At && (te = At.split("."), xe = te[0] > 0 && te[0] < 4 ? 1 : +(te[0] + te[1]));
          !xe && sr && (te = sr.match(/Edge\/(\d+)/), (!te || te[1] >= 74) && (te = sr.match(/Chrome\/(\d+)/), te && (xe = +te[1])));
          _t.exports = xe;
        });
        var ar = y((Bl, Tt) => {
          var yt = St(), Qs = se();
          Tt.exports = !!Object.getOwnPropertySymbols && !Qs(function() {
            var e = Symbol();
            return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && yt && yt < 41;
          });
        });
        var ir = y((bl, Bt) => {
          var Ks = ar();
          Bt.exports = Ks && !Symbol.sham && typeof Symbol.iterator == "symbol";
        });
        var or = y((wl, bt) => {
          var Js = G(), Zs = ge(), ea = K(), ra = nr(), ta = ir(), ua = Js.Object;
          bt.exports = ta ? function(e) {
            return typeof e == "symbol";
          } : function(e) {
            var r = Zs("Symbol");
            return ea(r) && ra(r.prototype, ua(e));
          };
        });
        var Pe = y((Nl, wt) => {
          var na = G(), sa = na.String;
          wt.exports = function(e) {
            try {
              return sa(e);
            } catch {
              return "Object";
            }
          };
        });
        var Fe = y((Ol, Nt) => {
          var aa = G(), ia = K(), oa = Pe(), ca = aa.TypeError;
          Nt.exports = function(e) {
            if (ia(e))
              return e;
            throw ca(oa(e) + " is not a function");
          };
        });
        var ke = y((ql, Ot) => {
          var Da = Fe();
          Ot.exports = function(e, r) {
            var t3 = e[r];
            return t3 == null ? void 0 : Da(t3);
          };
        });
        var It = y((Il, qt) => {
          var la = G(), cr = ce(), Dr = K(), lr = De(), ha = la.TypeError;
          qt.exports = function(e, r) {
            var t3, s;
            if (r === "string" && Dr(t3 = e.toString) && !lr(s = cr(t3, e)) || Dr(t3 = e.valueOf) && !lr(s = cr(t3, e)) || r !== "string" && Dr(t3 = e.toString) && !lr(s = cr(t3, e)))
              return s;
            throw ha("Can't convert object to primitive value");
          };
        });
        var xt = y((Rl, Rt) => {
          Rt.exports = false;
        });
        var Le = y((xl, kt) => {
          var Pt = G(), pa = Object.defineProperty;
          kt.exports = function(e, r) {
            try {
              pa(Pt, e, { value: r, configurable: true, writable: true });
            } catch {
              Pt[e] = r;
            }
            return r;
          };
        });
        var Me = y((Pl, Mt) => {
          var fa = G(), da = Le(), Lt = "__core-js_shared__", Ea = fa[Lt] || da(Lt, {});
          Mt.exports = Ea;
        });
        var hr = y((kl, $t) => {
          var Ca = xt(), jt = Me();
          ($t.exports = function(e, r) {
            return jt[e] || (jt[e] = r !== void 0 ? r : {});
          })("versions", []).push({ version: "3.22.2", mode: Ca ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.22.2/LICENSE", source: "https://github.com/zloirock/core-js" });
        });
        var pr = y((Ll, Ut) => {
          var ma = G(), ga = tr(), Fa = ma.Object;
          Ut.exports = function(e) {
            return Fa(ga(e));
          };
        });
        var ae = y((Ml, Gt) => {
          var Aa = Q(), va = pr(), _a = Aa({}.hasOwnProperty);
          Gt.exports = Object.hasOwn || function(r, t3) {
            return _a(va(r), t3);
          };
        });
        var fr = y((jl, Vt) => {
          var Sa = Q(), ya = 0, Ta = Math.random(), Ba = Sa(1 .toString);
          Vt.exports = function(e) {
            return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Ba(++ya + Ta, 36);
          };
        });
        var he = y(($l, Yt) => {
          var ba = G(), wa = hr(), Xt = ae(), Na = fr(), Ht = ar(), Wt = ir(), fe = wa("wks"), le = ba.Symbol, zt = le && le.for, Oa = Wt ? le : le && le.withoutSetter || Na;
          Yt.exports = function(e) {
            if (!Xt(fe, e) || !(Ht || typeof fe[e] == "string")) {
              var r = "Symbol." + e;
              Ht && Xt(le, e) ? fe[e] = le[e] : Wt && zt ? fe[e] = zt(r) : fe[e] = Oa(r);
            }
            return fe[e];
          };
        });
        var Zt = y((Ul, Jt) => {
          var qa = G(), Ia = ce(), Qt = De(), Kt = or(), Ra = ke(), xa = It(), Pa = he(), ka = qa.TypeError, La = Pa("toPrimitive");
          Jt.exports = function(e, r) {
            if (!Qt(e) || Kt(e))
              return e;
            var t3 = Ra(e, La), s;
            if (t3) {
              if (r === void 0 && (r = "default"), s = Ia(t3, e, r), !Qt(s) || Kt(s))
                return s;
              throw ka("Can't convert object to primitive value");
            }
            return r === void 0 && (r = "number"), xa(e, r);
          };
        });
        var je = y((Gl, eu) => {
          var Ma = Zt(), ja = or();
          eu.exports = function(e) {
            var r = Ma(e, "string");
            return ja(r) ? r : r + "";
          };
        });
        var uu = y((Vl, tu) => {
          var $a = G(), ru = De(), dr = $a.document, Ua = ru(dr) && ru(dr.createElement);
          tu.exports = function(e) {
            return Ua ? dr.createElement(e) : {};
          };
        });
        var Er = y((Xl, nu) => {
          var Ga = oe(), Va = se(), Xa = uu();
          nu.exports = !Ga && !Va(function() {
            return Object.defineProperty(Xa("div"), "a", { get: function() {
              return 7;
            } }).a != 7;
          });
        });
        var Cr = y((au) => {
          var Ha = oe(), za = ce(), Wa = rt(), Ya = qe(), Qa = Re(), Ka = je(), Ja = ae(), Za = Er(), su = Object.getOwnPropertyDescriptor;
          au.f = Ha ? su : function(r, t3) {
            if (r = Qa(r), t3 = Ka(t3), Za)
              try {
                return su(r, t3);
              } catch {
              }
            if (Ja(r, t3))
              return Ya(!za(Wa.f, r, t3), r[t3]);
          };
        });
        var ou = y((zl, iu) => {
          var ei = oe(), ri = se();
          iu.exports = ei && ri(function() {
            return Object.defineProperty(function() {
            }, "prototype", { value: 42, writable: false }).prototype != 42;
          });
        });
        var de = y((Wl, Du) => {
          var cu = G(), ti = De(), ui = cu.String, ni = cu.TypeError;
          Du.exports = function(e) {
            if (ti(e))
              return e;
            throw ni(ui(e) + " is not an object");
          };
        });
        var Ue = y((hu) => {
          var si = G(), ai = oe(), ii = Er(), oi = ou(), $e = de(), lu = je(), ci = si.TypeError, mr = Object.defineProperty, Di = Object.getOwnPropertyDescriptor, gr = "enumerable", Fr = "configurable", Ar = "writable";
          hu.f = ai ? oi ? function(r, t3, s) {
            if ($e(r), t3 = lu(t3), $e(s), typeof r == "function" && t3 === "prototype" && "value" in s && Ar in s && !s[Ar]) {
              var c = Di(r, t3);
              c && c[Ar] && (r[t3] = s.value, s = { configurable: Fr in s ? s[Fr] : c[Fr], enumerable: gr in s ? s[gr] : c[gr], writable: false });
            }
            return mr(r, t3, s);
          } : mr : function(r, t3, s) {
            if ($e(r), t3 = lu(t3), $e(s), ii)
              try {
                return mr(r, t3, s);
              } catch {
              }
            if ("get" in s || "set" in s)
              throw ci("Accessors not supported");
            return "value" in s && (r[t3] = s.value), r;
          };
        });
        var Ge = y((Ql, pu) => {
          var li = oe(), hi = Ue(), pi = qe();
          pu.exports = li ? function(e, r, t3) {
            return hi.f(e, r, pi(1, t3));
          } : function(e, r, t3) {
            return e[r] = t3, e;
          };
        });
        var Ve = y((Kl, fu) => {
          var fi = Q(), di = K(), vr = Me(), Ei = fi(Function.toString);
          di(vr.inspectSource) || (vr.inspectSource = function(e) {
            return Ei(e);
          });
          fu.exports = vr.inspectSource;
        });
        var Cu = y((Jl, Eu) => {
          var Ci = G(), mi = K(), gi = Ve(), du = Ci.WeakMap;
          Eu.exports = mi(du) && /native code/.test(gi(du));
        });
        var Fu = y((Zl, gu) => {
          var Fi = hr(), Ai = fr(), mu = Fi("keys");
          gu.exports = function(e) {
            return mu[e] || (mu[e] = Ai(e));
          };
        });
        var _r = y((e2, Au) => {
          Au.exports = {};
        });
        var Bu = y((r2, Tu) => {
          var vi = Cu(), yu = G(), Sr = Q(), _i = De(), Si = Ge(), yr = ae(), Tr = Me(), yi = Fu(), Ti = _r(), vu = "Object already initialized", br = yu.TypeError, Bi = yu.WeakMap, Xe, Ae, He, bi = function(e) {
            return He(e) ? Ae(e) : Xe(e, {});
          }, wi = function(e) {
            return function(r) {
              var t3;
              if (!_i(r) || (t3 = Ae(r)).type !== e)
                throw br("Incompatible receiver, " + e + " required");
              return t3;
            };
          };
          vi || Tr.state ? (ie = Tr.state || (Tr.state = new Bi()), _u = Sr(ie.get), Br = Sr(ie.has), Su = Sr(ie.set), Xe = function(e, r) {
            if (Br(ie, e))
              throw new br(vu);
            return r.facade = e, Su(ie, e, r), r;
          }, Ae = function(e) {
            return _u(ie, e) || {};
          }, He = function(e) {
            return Br(ie, e);
          }) : (pe = yi("state"), Ti[pe] = true, Xe = function(e, r) {
            if (yr(e, pe))
              throw new br(vu);
            return r.facade = e, Si(e, pe, r), r;
          }, Ae = function(e) {
            return yr(e, pe) ? e[pe] : {};
          }, He = function(e) {
            return yr(e, pe);
          });
          var ie, _u, Br, Su, pe;
          Tu.exports = { set: Xe, get: Ae, has: He, enforce: bi, getterFor: wi };
        });
        var Nu = y((t22, wu) => {
          var wr = oe(), Ni = ae(), bu = Function.prototype, Oi = wr && Object.getOwnPropertyDescriptor, Nr = Ni(bu, "name"), qi = Nr && function() {
          }.name === "something", Ii = Nr && (!wr || wr && Oi(bu, "name").configurable);
          wu.exports = { EXISTS: Nr, PROPER: qi, CONFIGURABLE: Ii };
        });
        var xu = y((u2, Ru) => {
          var Ri = G(), Ou = K(), xi = ae(), qu = Ge(), Pi = Le(), ki = Ve(), Iu = Bu(), Li = Nu().CONFIGURABLE, Mi = Iu.get, ji = Iu.enforce, $i = String(String).split("String");
          (Ru.exports = function(e, r, t3, s) {
            var c = s ? !!s.unsafe : false, n = s ? !!s.enumerable : false, a = s ? !!s.noTargetGet : false, p = s && s.name !== void 0 ? s.name : r, D;
            if (Ou(t3) && (String(p).slice(0, 7) === "Symbol(" && (p = "[" + String(p).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!xi(t3, "name") || Li && t3.name !== p) && qu(t3, "name", p), D = ji(t3), D.source || (D.source = $i.join(typeof p == "string" ? p : ""))), e === Ri) {
              n ? e[r] = t3 : Pi(r, t3);
              return;
            } else
              c ? !a && e[r] && (n = true) : delete e[r];
            n ? e[r] = t3 : qu(e, r, t3);
          })(Function.prototype, "toString", function() {
            return Ou(this) && Mi(this).source || ki(this);
          });
        });
        var Or = y((n2, Pu) => {
          var Ui = Math.ceil, Gi = Math.floor;
          Pu.exports = function(e) {
            var r = +e;
            return r !== r || r === 0 ? 0 : (r > 0 ? Gi : Ui)(r);
          };
        });
        var Lu = y((s2, ku) => {
          var Vi = Or(), Xi = Math.max, Hi = Math.min;
          ku.exports = function(e, r) {
            var t3 = Vi(e);
            return t3 < 0 ? Xi(t3 + r, 0) : Hi(t3, r);
          };
        });
        var ju = y((a2, Mu) => {
          var zi = Or(), Wi = Math.min;
          Mu.exports = function(e) {
            return e > 0 ? Wi(zi(e), 9007199254740991) : 0;
          };
        });
        var ve = y((i2, $u) => {
          var Yi = ju();
          $u.exports = function(e) {
            return Yi(e.length);
          };
        });
        var Vu = y((o2, Gu) => {
          var Qi = Re(), Ki = Lu(), Ji = ve(), Uu = function(e) {
            return function(r, t3, s) {
              var c = Qi(r), n = Ji(c), a = Ki(s, n), p;
              if (e && t3 != t3) {
                for (; n > a; )
                  if (p = c[a++], p != p)
                    return true;
              } else
                for (; n > a; a++)
                  if ((e || a in c) && c[a] === t3)
                    return e || a || 0;
              return !e && -1;
            };
          };
          Gu.exports = { includes: Uu(true), indexOf: Uu(false) };
        });
        var zu = y((c2, Hu) => {
          var Zi = Q(), qr = ae(), eo = Re(), ro = Vu().indexOf, to = _r(), Xu = Zi([].push);
          Hu.exports = function(e, r) {
            var t3 = eo(e), s = 0, c = [], n;
            for (n in t3)
              !qr(to, n) && qr(t3, n) && Xu(c, n);
            for (; r.length > s; )
              qr(t3, n = r[s++]) && (~ro(c, n) || Xu(c, n));
            return c;
          };
        });
        var Yu = y((D2, Wu) => {
          Wu.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
        });
        var Ku = y((Qu) => {
          var uo = zu(), no = Yu(), so = no.concat("length", "prototype");
          Qu.f = Object.getOwnPropertyNames || function(r) {
            return uo(r, so);
          };
        });
        var Zu = y((Ju) => {
          Ju.f = Object.getOwnPropertySymbols;
        });
        var rn = y((p2, en) => {
          var ao = ge(), io = Q(), oo = Ku(), co = Zu(), Do = de(), lo = io([].concat);
          en.exports = ao("Reflect", "ownKeys") || function(r) {
            var t3 = oo.f(Do(r)), s = co.f;
            return s ? lo(t3, s(r)) : t3;
          };
        });
        var nn = y((f2, un) => {
          var tn = ae(), ho = rn(), po = Cr(), fo = Ue();
          un.exports = function(e, r, t3) {
            for (var s = ho(r), c = fo.f, n = po.f, a = 0; a < s.length; a++) {
              var p = s[a];
              !tn(e, p) && !(t3 && tn(t3, p)) && c(e, p, n(r, p));
            }
          };
        });
        var an = y((d2, sn) => {
          var Eo = se(), Co = K(), mo = /#|\.prototype\./, _e = function(e, r) {
            var t3 = Fo[go(e)];
            return t3 == vo ? true : t3 == Ao ? false : Co(r) ? Eo(r) : !!r;
          }, go = _e.normalize = function(e) {
            return String(e).replace(mo, ".").toLowerCase();
          }, Fo = _e.data = {}, Ao = _e.NATIVE = "N", vo = _e.POLYFILL = "P";
          sn.exports = _e;
        });
        var ze = y((E2, on) => {
          var Ir = G(), _o = Cr().f, So = Ge(), yo = xu(), To = Le(), Bo = nn(), bo = an();
          on.exports = function(e, r) {
            var t3 = e.target, s = e.global, c = e.stat, n, a, p, D, g, i;
            if (s ? a = Ir : c ? a = Ir[t3] || To(t3, {}) : a = (Ir[t3] || {}).prototype, a)
              for (p in r) {
                if (g = r[p], e.noTargetGet ? (i = _o(a, p), D = i && i.value) : D = a[p], n = bo(s ? p : t3 + (c ? "." : "#") + p, e.forced), !n && D !== void 0) {
                  if (typeof g == typeof D)
                    continue;
                  Bo(g, D);
                }
                (e.sham || D && D.sham) && So(g, "sham", true), yo(a, p, g, e);
              }
          };
        });
        var cn = y(() => {
          var wo = ze(), No = G();
          wo({ global: true }, { globalThis: No });
        });
        var Dn = y(() => {
          cn();
        });
        var Rr = y((A2, ln) => {
          var Oo = Ie();
          ln.exports = Array.isArray || function(r) {
            return Oo(r) == "Array";
          };
        });
        var xr = y((v2, pn) => {
          var hn = Q(), qo = Fe(), Io = Ne(), Ro = hn(hn.bind);
          pn.exports = function(e, r) {
            return qo(e), r === void 0 ? e : Io ? Ro(e, r) : function() {
              return e.apply(r, arguments);
            };
          };
        });
        var En = y((_2, dn) => {
          "use strict";
          var xo = G(), Po = Rr(), ko = ve(), Lo = xr(), Mo = xo.TypeError, fn = function(e, r, t3, s, c, n, a, p) {
            for (var D = c, g = 0, i = a ? Lo(a, p) : false, l, h; g < s; ) {
              if (g in t3) {
                if (l = i ? i(t3[g], g, r) : t3[g], n > 0 && Po(l))
                  h = ko(l), D = fn(e, r, l, h, D, n - 1) - 1;
                else {
                  if (D >= 9007199254740991)
                    throw Mo("Exceed the acceptable array length");
                  e[D] = l;
                }
                D++;
              }
              g++;
            }
            return D;
          };
          dn.exports = fn;
        });
        var gn = y((S2, mn) => {
          var jo = he(), $o = jo("toStringTag"), Cn = {};
          Cn[$o] = "z";
          mn.exports = String(Cn) === "[object z]";
        });
        var Pr = y((y2, Fn) => {
          var Uo = G(), Go = gn(), Vo = K(), We = Ie(), Xo = he(), Ho = Xo("toStringTag"), zo = Uo.Object, Wo = We(function() {
            return arguments;
          }()) == "Arguments", Yo = function(e, r) {
            try {
              return e[r];
            } catch {
            }
          };
          Fn.exports = Go ? We : function(e) {
            var r, t3, s;
            return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t3 = Yo(r = zo(e), Ho)) == "string" ? t3 : Wo ? We(r) : (s = We(r)) == "Object" && Vo(r.callee) ? "Arguments" : s;
          };
        });
        var Tn = y((T2, yn) => {
          var Qo = Q(), Ko = se(), An = K(), Jo = Pr(), Zo = ge(), ec = Ve(), vn = function() {
          }, rc = [], _n = Zo("Reflect", "construct"), kr = /^\s*(?:class|function)\b/, tc = Qo(kr.exec), uc = !kr.exec(vn), Se = function(r) {
            if (!An(r))
              return false;
            try {
              return _n(vn, rc, r), true;
            } catch {
              return false;
            }
          }, Sn = function(r) {
            if (!An(r))
              return false;
            switch (Jo(r)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return false;
            }
            try {
              return uc || !!tc(kr, ec(r));
            } catch {
              return true;
            }
          };
          Sn.sham = true;
          yn.exports = !_n || Ko(function() {
            var e;
            return Se(Se.call) || !Se(Object) || !Se(function() {
              e = true;
            }) || e;
          }) ? Sn : Se;
        });
        var Nn = y((B2, wn) => {
          var nc = G(), Bn = Rr(), sc = Tn(), ac = De(), ic = he(), oc = ic("species"), bn = nc.Array;
          wn.exports = function(e) {
            var r;
            return Bn(e) && (r = e.constructor, sc(r) && (r === bn || Bn(r.prototype)) ? r = void 0 : ac(r) && (r = r[oc], r === null && (r = void 0))), r === void 0 ? bn : r;
          };
        });
        var qn = y((b2, On) => {
          var cc = Nn();
          On.exports = function(e, r) {
            return new (cc(e))(r === 0 ? 0 : r);
          };
        });
        var In = y(() => {
          "use strict";
          var Dc = ze(), lc = En(), hc = Fe(), pc = pr(), fc = ve(), dc = qn();
          Dc({ target: "Array", proto: true }, { flatMap: function(r) {
            var t3 = pc(this), s = fc(t3), c;
            return hc(r), c = dc(t3, 0), c.length = lc(c, t3, t3, s, 0, 1, r, arguments.length > 1 ? arguments[1] : void 0), c;
          } });
        });
        var Lr = y((O2, Rn) => {
          Rn.exports = {};
        });
        var Pn = y((q2, xn) => {
          var Ec = he(), Cc = Lr(), mc = Ec("iterator"), gc = Array.prototype;
          xn.exports = function(e) {
            return e !== void 0 && (Cc.Array === e || gc[mc] === e);
          };
        });
        var Mr = y((I2, Ln) => {
          var Fc = Pr(), kn = ke(), Ac = Lr(), vc = he(), _c = vc("iterator");
          Ln.exports = function(e) {
            if (e != null)
              return kn(e, _c) || kn(e, "@@iterator") || Ac[Fc(e)];
          };
        });
        var jn = y((R2, Mn) => {
          var Sc = G(), yc = ce(), Tc = Fe(), Bc = de(), bc = Pe(), wc = Mr(), Nc = Sc.TypeError;
          Mn.exports = function(e, r) {
            var t3 = arguments.length < 2 ? wc(e) : r;
            if (Tc(t3))
              return Bc(yc(t3, e));
            throw Nc(bc(e) + " is not iterable");
          };
        });
        var Gn = y((x2, Un) => {
          var Oc = ce(), $n = de(), qc = ke();
          Un.exports = function(e, r, t3) {
            var s, c;
            $n(e);
            try {
              if (s = qc(e, "return"), !s) {
                if (r === "throw")
                  throw t3;
                return t3;
              }
              s = Oc(s, e);
            } catch (n) {
              c = true, s = n;
            }
            if (r === "throw")
              throw t3;
            if (c)
              throw s;
            return $n(s), t3;
          };
        });
        var Wn = y((P2, zn) => {
          var Ic = G(), Rc = xr(), xc = ce(), Pc = de(), kc = Pe(), Lc = Pn(), Mc = ve(), Vn = nr(), jc = jn(), $c = Mr(), Xn = Gn(), Uc = Ic.TypeError, Ye = function(e, r) {
            this.stopped = e, this.result = r;
          }, Hn = Ye.prototype;
          zn.exports = function(e, r, t3) {
            var s = t3 && t3.that, c = !!(t3 && t3.AS_ENTRIES), n = !!(t3 && t3.IS_ITERATOR), a = !!(t3 && t3.INTERRUPTED), p = Rc(r, s), D, g, i, l, h, C, d, m = function(B) {
              return D && Xn(D, "normal", B), new Ye(true, B);
            }, T = function(B) {
              return c ? (Pc(B), a ? p(B[0], B[1], m) : p(B[0], B[1])) : a ? p(B, m) : p(B);
            };
            if (n)
              D = e;
            else {
              if (g = $c(e), !g)
                throw Uc(kc(e) + " is not iterable");
              if (Lc(g)) {
                for (i = 0, l = Mc(e); l > i; i++)
                  if (h = T(e[i]), h && Vn(Hn, h))
                    return h;
                return new Ye(false);
              }
              D = jc(e, g);
            }
            for (C = D.next; !(d = xc(C, D)).done; ) {
              try {
                h = T(d.value);
              } catch (B) {
                Xn(D, "throw", B);
              }
              if (typeof h == "object" && h && Vn(Hn, h))
                return h;
            }
            return new Ye(false);
          };
        });
        var Qn = y((k2, Yn) => {
          "use strict";
          var Gc = je(), Vc = Ue(), Xc = qe();
          Yn.exports = function(e, r, t3) {
            var s = Gc(r);
            s in e ? Vc.f(e, s, Xc(0, t3)) : e[s] = t3;
          };
        });
        var Kn = y(() => {
          var Hc = ze(), zc = Wn(), Wc = Qn();
          Hc({ target: "Object", stat: true }, { fromEntries: function(r) {
            var t3 = {};
            return zc(r, function(s, c) {
              Wc(t3, s, c);
            }, { AS_ENTRIES: true }), t3;
          } });
        });
        var il = y((j2, Bs) => {
          var Yc = ["cliName", "cliCategory", "cliDescription"], Jn, Zn, es, rs, ts, us;
          function Qc(e, r) {
            if (e == null)
              return {};
            var t3 = Kc(e, r), s, c;
            if (Object.getOwnPropertySymbols) {
              var n = Object.getOwnPropertySymbols(e);
              for (c = 0; c < n.length; c++)
                s = n[c], !(r.indexOf(s) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, s) || (t3[s] = e[s]));
            }
            return t3;
          }
          function Kc(e, r) {
            if (e == null)
              return {};
            var t3 = {}, s = Object.keys(e), c, n;
            for (n = 0; n < s.length; n++)
              c = s[n], !(r.indexOf(c) >= 0) && (t3[c] = e[c]);
            return t3;
          }
          function Ee(e, r) {
            return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(r) } }));
          }
          Dn();
          In();
          Kn();
          var Jc = Object.create, Je = Object.defineProperty, Zc = Object.getOwnPropertyDescriptor, $r = Object.getOwnPropertyNames, eD = Object.getPrototypeOf, rD = Object.prototype.hasOwnProperty, Ce = (e, r) => function() {
            return e && (r = (0, e[$r(e)[0]])(e = 0)), r;
          }, I = (e, r) => function() {
            return r || (0, e[$r(e)[0]])((r = { exports: {} }).exports, r), r.exports;
          }, cs = (e, r) => {
            for (var t3 in r)
              Je(e, t3, { get: r[t3], enumerable: true });
          }, Ds = (e, r, t3, s) => {
            if (r && typeof r == "object" || typeof r == "function")
              for (let c of $r(r))
                !rD.call(e, c) && c !== t3 && Je(e, c, { get: () => r[c], enumerable: !(s = Zc(r, c)) || s.enumerable });
            return e;
          }, tD = (e, r, t3) => (t3 = e != null ? Jc(eD(e)) : {}, Ds(r || !e || !e.__esModule ? Je(t3, "default", { value: e, enumerable: true }) : t3, e)), ls = (e) => Ds(Je({}, "__esModule", { value: true }), e), ns, ss, ye, q = Ce({ "<define:process>"() {
            ns = {}, ss = [], ye = { env: ns, argv: ss };
          } }), hs = I({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true }), e.$EOF = 0, e.$BSPACE = 8, e.$TAB = 9, e.$LF = 10, e.$VTAB = 11, e.$FF = 12, e.$CR = 13, e.$SPACE = 32, e.$BANG = 33, e.$DQ = 34, e.$HASH = 35, e.$$ = 36, e.$PERCENT = 37, e.$AMPERSAND = 38, e.$SQ = 39, e.$LPAREN = 40, e.$RPAREN = 41, e.$STAR = 42, e.$PLUS = 43, e.$COMMA = 44, e.$MINUS = 45, e.$PERIOD = 46, e.$SLASH = 47, e.$COLON = 58, e.$SEMICOLON = 59, e.$LT = 60, e.$EQ = 61, e.$GT = 62, e.$QUESTION = 63, e.$0 = 48, e.$7 = 55, e.$9 = 57, e.$A = 65, e.$E = 69, e.$F = 70, e.$X = 88, e.$Z = 90, e.$LBRACKET = 91, e.$BACKSLASH = 92, e.$RBRACKET = 93, e.$CARET = 94, e.$_ = 95, e.$a = 97, e.$b = 98, e.$e = 101, e.$f = 102, e.$n = 110, e.$r = 114, e.$t = 116, e.$u = 117, e.$v = 118, e.$x = 120, e.$z = 122, e.$LBRACE = 123, e.$BAR = 124, e.$RBRACE = 125, e.$NBSP = 160, e.$PIPE = 124, e.$TILDA = 126, e.$AT = 64, e.$BT = 96;
            function r(p) {
              return p >= e.$TAB && p <= e.$SPACE || p == e.$NBSP;
            }
            e.isWhitespace = r;
            function t3(p) {
              return e.$0 <= p && p <= e.$9;
            }
            e.isDigit = t3;
            function s(p) {
              return p >= e.$a && p <= e.$z || p >= e.$A && p <= e.$Z;
            }
            e.isAsciiLetter = s;
            function c(p) {
              return p >= e.$a && p <= e.$f || p >= e.$A && p <= e.$F || t3(p);
            }
            e.isAsciiHexDigit = c;
            function n(p) {
              return p === e.$LF || p === e.$CR;
            }
            e.isNewLine = n;
            function a(p) {
              return e.$0 <= p && p <= e.$7;
            }
            e.isOctalDigit = a;
          } }), uD = I({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = class {
              constructor(s, c, n) {
                this.filePath = s, this.name = c, this.members = n;
              }
              assertNoMembers() {
                if (this.members.length)
                  throw new Error("Illegal state: symbol without members expected, but got ".concat(JSON.stringify(this), "."));
              }
            };
            e.StaticSymbol = r;
            var t3 = class {
              constructor() {
                this.cache = /* @__PURE__ */ new Map();
              }
              get(s, c, n) {
                n = n || [];
                let a = n.length ? ".".concat(n.join(".")) : "", p = '"'.concat(s, '".').concat(c).concat(a), D = this.cache.get(p);
                return D || (D = new r(s, c, n), this.cache.set(p, D)), D;
              }
            };
            e.StaticSymbolCache = t3;
          } }), nD = I({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = /-+([a-z0-9])/g;
            function t3(o) {
              return o.replace(r, function() {
                for (var E = arguments.length, f = new Array(E), F = 0; F < E; F++)
                  f[F] = arguments[F];
                return f[1].toUpperCase();
              });
            }
            e.dashCaseToCamelCase = t3;
            function s(o, E) {
              return n(o, ":", E);
            }
            e.splitAtColon = s;
            function c(o, E) {
              return n(o, ".", E);
            }
            e.splitAtPeriod = c;
            function n(o, E, f) {
              let F = o.indexOf(E);
              return F == -1 ? f : [o.slice(0, F).trim(), o.slice(F + 1).trim()];
            }
            function a(o, E, f) {
              return Array.isArray(o) ? E.visitArray(o, f) : A(o) ? E.visitStringMap(o, f) : o == null || typeof o == "string" || typeof o == "number" || typeof o == "boolean" ? E.visitPrimitive(o, f) : E.visitOther(o, f);
            }
            e.visitValue = a;
            function p(o) {
              return o != null;
            }
            e.isDefined = p;
            function D(o) {
              return o === void 0 ? null : o;
            }
            e.noUndefined = D;
            var g = class {
              visitArray(o, E) {
                return o.map((f) => a(f, this, E));
              }
              visitStringMap(o, E) {
                let f = {};
                return Object.keys(o).forEach((F) => {
                  f[F] = a(o[F], this, E);
                }), f;
              }
              visitPrimitive(o, E) {
                return o;
              }
              visitOther(o, E) {
                return o;
              }
            };
            e.ValueTransformer = g, e.SyncAsync = { assertSync: (o) => {
              if (_(o))
                throw new Error("Illegal state: value cannot be a promise");
              return o;
            }, then: (o, E) => _(o) ? o.then(E) : E(o), all: (o) => o.some(_) ? Promise.all(o) : o };
            function i(o) {
              throw new Error("Internal Error: ".concat(o));
            }
            e.error = i;
            function l(o, E) {
              let f = Error(o);
              return f[h] = true, E && (f[C] = E), f;
            }
            e.syntaxError = l;
            var h = "ngSyntaxError", C = "ngParseErrors";
            function d(o) {
              return o[h];
            }
            e.isSyntaxError = d;
            function m(o) {
              return o[C] || [];
            }
            e.getParseErrors = m;
            function T(o) {
              return o.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
            }
            e.escapeRegExp = T;
            var B = Object.getPrototypeOf({});
            function A(o) {
              return typeof o == "object" && o !== null && Object.getPrototypeOf(o) === B;
            }
            function N(o) {
              let E = "";
              for (let f = 0; f < o.length; f++) {
                let F = o.charCodeAt(f);
                if (F >= 55296 && F <= 56319 && o.length > f + 1) {
                  let P = o.charCodeAt(f + 1);
                  P >= 56320 && P <= 57343 && (f++, F = (F - 55296 << 10) + P - 56320 + 65536);
                }
                F <= 127 ? E += String.fromCharCode(F) : F <= 2047 ? E += String.fromCharCode(F >> 6 & 31 | 192, F & 63 | 128) : F <= 65535 ? E += String.fromCharCode(F >> 12 | 224, F >> 6 & 63 | 128, F & 63 | 128) : F <= 2097151 && (E += String.fromCharCode(F >> 18 & 7 | 240, F >> 12 & 63 | 128, F >> 6 & 63 | 128, F & 63 | 128));
              }
              return E;
            }
            e.utf8Encode = N;
            function R(o) {
              if (typeof o == "string")
                return o;
              if (o instanceof Array)
                return "[" + o.map(R).join(", ") + "]";
              if (o == null)
                return "" + o;
              if (o.overriddenName)
                return "".concat(o.overriddenName);
              if (o.name)
                return "".concat(o.name);
              if (!o.toString)
                return "object";
              let E = o.toString();
              if (E == null)
                return "" + E;
              let f = E.indexOf(`
`);
              return f === -1 ? E : E.substring(0, f);
            }
            e.stringify = R;
            function $(o) {
              return typeof o == "function" && o.hasOwnProperty("__forward_ref__") ? o() : o;
            }
            e.resolveForwardRef = $;
            function _(o) {
              return !!o && typeof o.then == "function";
            }
            e.isPromise = _;
            var O = class {
              constructor(o) {
                this.full = o;
                let E = o.split(".");
                this.major = E[0], this.minor = E[1], this.patch = E.slice(2).join(".");
              }
            };
            e.Version = O;
            var x = typeof window < "u" && window, k = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, M = typeof globalThis < "u" && globalThis, u = M || x || k;
            e.global = u;
          } }), sD = I({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = uD(), t3 = nD(), s = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
            function c(f) {
              return f.replace(/\W/g, "_");
            }
            e.sanitizeIdentifier = c;
            var n = 0;
            function a(f) {
              if (!f || !f.reference)
                return null;
              let F = f.reference;
              if (F instanceof r.StaticSymbol)
                return F.name;
              if (F.__anonymousType)
                return F.__anonymousType;
              let P = t3.stringify(F);
              return P.indexOf("(") >= 0 ? (P = "anonymous_".concat(n++), F.__anonymousType = P) : P = c(P), P;
            }
            e.identifierName = a;
            function p(f) {
              let F = f.reference;
              return F instanceof r.StaticSymbol ? F.filePath : "./".concat(t3.stringify(F));
            }
            e.identifierModuleUrl = p;
            function D(f, F) {
              return "View_".concat(a({ reference: f }), "_").concat(F);
            }
            e.viewClassName = D;
            function g(f) {
              return "RenderType_".concat(a({ reference: f }));
            }
            e.rendererTypeName = g;
            function i(f) {
              return "HostView_".concat(a({ reference: f }));
            }
            e.hostViewClassName = i;
            function l(f) {
              return "".concat(a({ reference: f }), "NgFactory");
            }
            e.componentFactoryName = l;
            var h;
            (function(f) {
              f[f.Pipe = 0] = "Pipe", f[f.Directive = 1] = "Directive", f[f.NgModule = 2] = "NgModule", f[f.Injectable = 3] = "Injectable";
            })(h = e.CompileSummaryKind || (e.CompileSummaryKind = {}));
            function C(f) {
              return f.value != null ? c(f.value) : a(f.identifier);
            }
            e.tokenName = C;
            function d(f) {
              return f.identifier != null ? f.identifier.reference : f.value;
            }
            e.tokenReference = d;
            var m = class {
              constructor() {
                let { moduleUrl: f, styles: F, styleUrls: P } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.moduleUrl = f || null, this.styles = _(F), this.styleUrls = _(P);
              }
            };
            e.CompileStylesheetMetadata = m;
            var T = class {
              constructor(f) {
                let { encapsulation: F, template: P, templateUrl: j, htmlAst: W, styles: X, styleUrls: H, externalStylesheets: z, animations: J, ngContentSelectors: Z, interpolation: ee, isInline: v, preserveWhitespaces: S } = f;
                if (this.encapsulation = F, this.template = P, this.templateUrl = j, this.htmlAst = W, this.styles = _(X), this.styleUrls = _(H), this.externalStylesheets = _(z), this.animations = J ? x(J) : [], this.ngContentSelectors = Z || [], ee && ee.length != 2)
                  throw new Error("'interpolation' should have a start and an end symbol.");
                this.interpolation = ee, this.isInline = v, this.preserveWhitespaces = S;
              }
              toSummary() {
                return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
              }
            };
            e.CompileTemplateMetadata = T;
            var B = class {
              static create(f) {
                let { isHost: F, type: P, isComponent: j, selector: W, exportAs: X, changeDetection: H, inputs: z, outputs: J, host: Z, providers: ee, viewProviders: v, queries: S, guards: b, viewQueries: w, entryComponents: L, template: U, componentViewType: V, rendererType: Y, componentFactory: ue } = f, Be = {}, be = {}, Vr = {};
                Z != null && Object.keys(Z).forEach((re) => {
                  let ne = Z[re], me = re.match(s);
                  me === null ? Vr[re] = ne : me[1] != null ? be[me[1]] = ne : me[2] != null && (Be[me[2]] = ne);
                });
                let Xr = {};
                z != null && z.forEach((re) => {
                  let ne = t3.splitAtColon(re, [re, re]);
                  Xr[ne[0]] = ne[1];
                });
                let Hr = {};
                return J != null && J.forEach((re) => {
                  let ne = t3.splitAtColon(re, [re, re]);
                  Hr[ne[0]] = ne[1];
                }), new B({ isHost: F, type: P, isComponent: !!j, selector: W, exportAs: X, changeDetection: H, inputs: Xr, outputs: Hr, hostListeners: Be, hostProperties: be, hostAttributes: Vr, providers: ee, viewProviders: v, queries: S, guards: b, viewQueries: w, entryComponents: L, template: U, componentViewType: V, rendererType: Y, componentFactory: ue });
              }
              constructor(f) {
                let { isHost: F, type: P, isComponent: j, selector: W, exportAs: X, changeDetection: H, inputs: z, outputs: J, hostListeners: Z, hostProperties: ee, hostAttributes: v, providers: S, viewProviders: b, queries: w, guards: L, viewQueries: U, entryComponents: V, template: Y, componentViewType: ue, rendererType: Be, componentFactory: be } = f;
                this.isHost = !!F, this.type = P, this.isComponent = j, this.selector = W, this.exportAs = X, this.changeDetection = H, this.inputs = z, this.outputs = J, this.hostListeners = Z, this.hostProperties = ee, this.hostAttributes = v, this.providers = _(S), this.viewProviders = _(b), this.queries = _(w), this.guards = L, this.viewQueries = _(U), this.entryComponents = _(V), this.template = Y, this.componentViewType = ue, this.rendererType = Be, this.componentFactory = be;
              }
              toSummary() {
                return { summaryKind: h.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
              }
            };
            e.CompileDirectiveMetadata = B;
            var A = class {
              constructor(f) {
                let { type: F, name: P, pure: j } = f;
                this.type = F, this.name = P, this.pure = !!j;
              }
              toSummary() {
                return { summaryKind: h.Pipe, type: this.type, name: this.name, pure: this.pure };
              }
            };
            e.CompilePipeMetadata = A;
            var N = class {
            };
            e.CompileShallowModuleMetadata = N;
            var R = class {
              constructor(f) {
                let { type: F, providers: P, declaredDirectives: j, exportedDirectives: W, declaredPipes: X, exportedPipes: H, entryComponents: z, bootstrapComponents: J, importedModules: Z, exportedModules: ee, schemas: v, transitiveModule: S, id: b } = f;
                this.type = F || null, this.declaredDirectives = _(j), this.exportedDirectives = _(W), this.declaredPipes = _(X), this.exportedPipes = _(H), this.providers = _(P), this.entryComponents = _(z), this.bootstrapComponents = _(J), this.importedModules = _(Z), this.exportedModules = _(ee), this.schemas = _(v), this.id = b || null, this.transitiveModule = S || null;
              }
              toSummary() {
                let f = this.transitiveModule;
                return { summaryKind: h.NgModule, type: this.type, entryComponents: f.entryComponents, providers: f.providers, modules: f.modules, exportedDirectives: f.exportedDirectives, exportedPipes: f.exportedPipes };
              }
            };
            e.CompileNgModuleMetadata = R;
            var $ = class {
              constructor() {
                this.directivesSet = /* @__PURE__ */ new Set(), this.directives = [], this.exportedDirectivesSet = /* @__PURE__ */ new Set(), this.exportedDirectives = [], this.pipesSet = /* @__PURE__ */ new Set(), this.pipes = [], this.exportedPipesSet = /* @__PURE__ */ new Set(), this.exportedPipes = [], this.modulesSet = /* @__PURE__ */ new Set(), this.modules = [], this.entryComponentsSet = /* @__PURE__ */ new Set(), this.entryComponents = [], this.providers = [];
              }
              addProvider(f, F) {
                this.providers.push({ provider: f, module: F });
              }
              addDirective(f) {
                this.directivesSet.has(f.reference) || (this.directivesSet.add(f.reference), this.directives.push(f));
              }
              addExportedDirective(f) {
                this.exportedDirectivesSet.has(f.reference) || (this.exportedDirectivesSet.add(f.reference), this.exportedDirectives.push(f));
              }
              addPipe(f) {
                this.pipesSet.has(f.reference) || (this.pipesSet.add(f.reference), this.pipes.push(f));
              }
              addExportedPipe(f) {
                this.exportedPipesSet.has(f.reference) || (this.exportedPipesSet.add(f.reference), this.exportedPipes.push(f));
              }
              addModule(f) {
                this.modulesSet.has(f.reference) || (this.modulesSet.add(f.reference), this.modules.push(f));
              }
              addEntryComponent(f) {
                this.entryComponentsSet.has(f.componentType) || (this.entryComponentsSet.add(f.componentType), this.entryComponents.push(f));
              }
            };
            e.TransitiveCompileNgModuleMetadata = $;
            function _(f) {
              return f || [];
            }
            var O = class {
              constructor(f, F) {
                let { useClass: P, useValue: j, useExisting: W, useFactory: X, deps: H, multi: z } = F;
                this.token = f, this.useClass = P || null, this.useValue = j, this.useExisting = W, this.useFactory = X || null, this.dependencies = H || null, this.multi = !!z;
              }
            };
            e.ProviderMeta = O;
            function x(f) {
              return f.reduce((F, P) => {
                let j = Array.isArray(P) ? x(P) : P;
                return F.concat(j);
              }, []);
            }
            e.flatten = x;
            function k(f) {
              return f.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
            }
            function M(f, F, P) {
              let j;
              return P.isInline ? F.type.reference instanceof r.StaticSymbol ? j = "".concat(F.type.reference.filePath, ".").concat(F.type.reference.name, ".html") : j = "".concat(a(f), "/").concat(a(F.type), ".html") : j = P.templateUrl, F.type.reference instanceof r.StaticSymbol ? j : k(j);
            }
            e.templateSourceUrl = M;
            function u(f, F) {
              let P = f.moduleUrl.split(/\/\\/g), j = P[P.length - 1];
              return k("css/".concat(F).concat(j, ".ngstyle.js"));
            }
            e.sharedStylesheetJitUrl = u;
            function o(f) {
              return k("".concat(a(f.type), "/module.ngfactory.js"));
            }
            e.ngModuleJitUrl = o;
            function E(f, F) {
              return k("".concat(a(f), "/").concat(a(F.type), ".ngfactory.js"));
            }
            e.templateJitUrl = E;
          } }), Te = I({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = hs(), t3 = sD(), s = class {
              constructor(i, l, h, C) {
                this.file = i, this.offset = l, this.line = h, this.col = C;
              }
              toString() {
                return this.offset != null ? "".concat(this.file.url, "@").concat(this.line, ":").concat(this.col) : this.file.url;
              }
              moveBy(i) {
                let l = this.file.content, h = l.length, C = this.offset, d = this.line, m = this.col;
                for (; C > 0 && i < 0; )
                  if (C--, i++, l.charCodeAt(C) == r.$LF) {
                    d--;
                    let B = l.substr(0, C - 1).lastIndexOf(String.fromCharCode(r.$LF));
                    m = B > 0 ? C - B : C;
                  } else
                    m--;
                for (; C < h && i > 0; ) {
                  let T = l.charCodeAt(C);
                  C++, i--, T == r.$LF ? (d++, m = 0) : m++;
                }
                return new s(this.file, C, d, m);
              }
              getContext(i, l) {
                let h = this.file.content, C = this.offset;
                if (C != null) {
                  C > h.length - 1 && (C = h.length - 1);
                  let d = C, m = 0, T = 0;
                  for (; m < i && C > 0 && (C--, m++, !(h[C] == `
` && ++T == l)); )
                    ;
                  for (m = 0, T = 0; m < i && d < h.length - 1 && (d++, m++, !(h[d] == `
` && ++T == l)); )
                    ;
                  return { before: h.substring(C, this.offset), after: h.substring(this.offset, d + 1) };
                }
                return null;
              }
            };
            e.ParseLocation = s;
            var c = class {
              constructor(i, l) {
                this.content = i, this.url = l;
              }
            };
            e.ParseSourceFile = c;
            var n = class {
              constructor(i, l) {
                let h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                this.start = i, this.end = l, this.details = h;
              }
              toString() {
                return this.start.file.content.substring(this.start.offset, this.end.offset);
              }
            };
            e.ParseSourceSpan = n, e.EMPTY_PARSE_LOCATION = new s(new c("", ""), 0, 0, 0), e.EMPTY_SOURCE_SPAN = new n(e.EMPTY_PARSE_LOCATION, e.EMPTY_PARSE_LOCATION);
            var a;
            (function(i) {
              i[i.WARNING = 0] = "WARNING", i[i.ERROR = 1] = "ERROR";
            })(a = e.ParseErrorLevel || (e.ParseErrorLevel = {}));
            var p = class {
              constructor(i, l) {
                let h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : a.ERROR;
                this.span = i, this.msg = l, this.level = h;
              }
              contextualMessage() {
                let i = this.span.start.getContext(100, 3);
                return i ? "".concat(this.msg, ' ("').concat(i.before, "[").concat(a[this.level], " ->]").concat(i.after, '")') : this.msg;
              }
              toString() {
                let i = this.span.details ? ", ".concat(this.span.details) : "";
                return "".concat(this.contextualMessage(), ": ").concat(this.span.start).concat(i);
              }
            };
            e.ParseError = p;
            function D(i, l) {
              let h = t3.identifierModuleUrl(l), C = h != null ? "in ".concat(i, " ").concat(t3.identifierName(l), " in ").concat(h) : "in ".concat(i, " ").concat(t3.identifierName(l)), d = new c("", C);
              return new n(new s(d, -1, -1, -1), new s(d, -1, -1, -1));
            }
            e.typeSourceSpan = D;
            function g(i, l, h) {
              let C = "in ".concat(i, " ").concat(l, " in ").concat(h), d = new c("", C);
              return new n(new s(d, -1, -1, -1), new s(d, -1, -1, -1));
            }
            e.r3JitTypeSourceSpan = g;
          } }), aD = I({ "src/utils/front-matter/parse.js"(e, r) {
            "use strict";
            q();
            var t3 = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
            function s(c) {
              let n = c.match(t3);
              if (!n)
                return { content: c };
              let { startDelimiter: a, language: p, value: D = "", endDelimiter: g } = n.groups, i = p.trim() || "yaml";
              if (a === "+++" && (i = "toml"), i !== "yaml" && a !== g)
                return { content: c };
              let [l] = n;
              return { frontMatter: { type: "front-matter", lang: i, value: D, startDelimiter: a, endDelimiter: g, raw: l.replace(/\n$/, "") }, content: l.replace(/[^\n]/g, " ") + c.slice(l.length) };
            }
            r.exports = s;
          } }), ps = I({ "src/utils/get-last.js"(e, r) {
            "use strict";
            q();
            var t3 = (s) => s[s.length - 1];
            r.exports = t3;
          } }), iD = I({ "src/common/parser-create-error.js"(e, r) {
            "use strict";
            q();
            function t3(s, c) {
              let n = new SyntaxError(s + " (" + c.start.line + ":" + c.start.column + ")");
              return n.loc = c, n;
            }
            r.exports = t3;
          } }), fs = {};
          cs(fs, { default: () => oD });
          function oD(e) {
            if (typeof e != "string")
              throw new TypeError("Expected a string");
            return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
          }
          var cD = Ce({ "node_modules/escape-string-regexp/index.js"() {
            q();
          } }), ds = I({ "node_modules/semver/internal/debug.js"(e, r) {
            q();
            var t3 = typeof ye == "object" && ye.env && ye.env.NODE_DEBUG && /\bsemver\b/i.test(ye.env.NODE_DEBUG) ? function() {
              for (var s = arguments.length, c = new Array(s), n = 0; n < s; n++)
                c[n] = arguments[n];
              return console.error("SEMVER", ...c);
            } : () => {
            };
            r.exports = t3;
          } }), Es = I({ "node_modules/semver/internal/constants.js"(e, r) {
            q();
            var t3 = "2.0.0", s = 256, c = Number.MAX_SAFE_INTEGER || 9007199254740991, n = 16;
            r.exports = { SEMVER_SPEC_VERSION: t3, MAX_LENGTH: s, MAX_SAFE_INTEGER: c, MAX_SAFE_COMPONENT_LENGTH: n };
          } }), DD = I({ "node_modules/semver/internal/re.js"(e, r) {
            q();
            var { MAX_SAFE_COMPONENT_LENGTH: t3 } = Es(), s = ds();
            e = r.exports = {};
            var c = e.re = [], n = e.src = [], a = e.t = {}, p = 0, D = (g, i, l) => {
              let h = p++;
              s(g, h, i), a[g] = h, n[h] = i, c[h] = new RegExp(i, l ? "g" : void 0);
            };
            D("NUMERICIDENTIFIER", "0|[1-9]\\d*"), D("NUMERICIDENTIFIERLOOSE", "[0-9]+"), D("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), D("MAINVERSION", "(".concat(n[a.NUMERICIDENTIFIER], ")\\.(").concat(n[a.NUMERICIDENTIFIER], ")\\.(").concat(n[a.NUMERICIDENTIFIER], ")")), D("MAINVERSIONLOOSE", "(".concat(n[a.NUMERICIDENTIFIERLOOSE], ")\\.(").concat(n[a.NUMERICIDENTIFIERLOOSE], ")\\.(").concat(n[a.NUMERICIDENTIFIERLOOSE], ")")), D("PRERELEASEIDENTIFIER", "(?:".concat(n[a.NUMERICIDENTIFIER], "|").concat(n[a.NONNUMERICIDENTIFIER], ")")), D("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(n[a.NUMERICIDENTIFIERLOOSE], "|").concat(n[a.NONNUMERICIDENTIFIER], ")")), D("PRERELEASE", "(?:-(".concat(n[a.PRERELEASEIDENTIFIER], "(?:\\.").concat(n[a.PRERELEASEIDENTIFIER], ")*))")), D("PRERELEASELOOSE", "(?:-?(".concat(n[a.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(n[a.PRERELEASEIDENTIFIERLOOSE], ")*))")), D("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), D("BUILD", "(?:\\+(".concat(n[a.BUILDIDENTIFIER], "(?:\\.").concat(n[a.BUILDIDENTIFIER], ")*))")), D("FULLPLAIN", "v?".concat(n[a.MAINVERSION]).concat(n[a.PRERELEASE], "?").concat(n[a.BUILD], "?")), D("FULL", "^".concat(n[a.FULLPLAIN], "$")), D("LOOSEPLAIN", "[v=\\s]*".concat(n[a.MAINVERSIONLOOSE]).concat(n[a.PRERELEASELOOSE], "?").concat(n[a.BUILD], "?")), D("LOOSE", "^".concat(n[a.LOOSEPLAIN], "$")), D("GTLT", "((?:<|>)?=?)"), D("XRANGEIDENTIFIERLOOSE", "".concat(n[a.NUMERICIDENTIFIERLOOSE], "|x|X|\\*")), D("XRANGEIDENTIFIER", "".concat(n[a.NUMERICIDENTIFIER], "|x|X|\\*")), D("XRANGEPLAIN", "[v=\\s]*(".concat(n[a.XRANGEIDENTIFIER], ")(?:\\.(").concat(n[a.XRANGEIDENTIFIER], ")(?:\\.(").concat(n[a.XRANGEIDENTIFIER], ")(?:").concat(n[a.PRERELEASE], ")?").concat(n[a.BUILD], "?)?)?")), D("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(n[a.XRANGEIDENTIFIERLOOSE], ")(?:\\.(").concat(n[a.XRANGEIDENTIFIERLOOSE], ")(?:\\.(").concat(n[a.XRANGEIDENTIFIERLOOSE], ")(?:").concat(n[a.PRERELEASELOOSE], ")?").concat(n[a.BUILD], "?)?)?")), D("XRANGE", "^".concat(n[a.GTLT], "\\s*").concat(n[a.XRANGEPLAIN], "$")), D("XRANGELOOSE", "^".concat(n[a.GTLT], "\\s*").concat(n[a.XRANGEPLAINLOOSE], "$")), D("COERCE", "(^|[^\\d])(\\d{1,".concat(t3, "})(?:\\.(\\d{1,").concat(t3, "}))?(?:\\.(\\d{1,").concat(t3, "}))?(?:$|[^\\d])")), D("COERCERTL", n[a.COERCE], true), D("LONETILDE", "(?:~>?)"), D("TILDETRIM", "(\\s*)".concat(n[a.LONETILDE], "\\s+"), true), e.tildeTrimReplace = "$1~", D("TILDE", "^".concat(n[a.LONETILDE]).concat(n[a.XRANGEPLAIN], "$")), D("TILDELOOSE", "^".concat(n[a.LONETILDE]).concat(n[a.XRANGEPLAINLOOSE], "$")), D("LONECARET", "(?:\\^)"), D("CARETTRIM", "(\\s*)".concat(n[a.LONECARET], "\\s+"), true), e.caretTrimReplace = "$1^", D("CARET", "^".concat(n[a.LONECARET]).concat(n[a.XRANGEPLAIN], "$")), D("CARETLOOSE", "^".concat(n[a.LONECARET]).concat(n[a.XRANGEPLAINLOOSE], "$")), D("COMPARATORLOOSE", "^".concat(n[a.GTLT], "\\s*(").concat(n[a.LOOSEPLAIN], ")$|^$")), D("COMPARATOR", "^".concat(n[a.GTLT], "\\s*(").concat(n[a.FULLPLAIN], ")$|^$")), D("COMPARATORTRIM", "(\\s*)".concat(n[a.GTLT], "\\s*(").concat(n[a.LOOSEPLAIN], "|").concat(n[a.XRANGEPLAIN], ")"), true), e.comparatorTrimReplace = "$1$2$3", D("HYPHENRANGE", "^\\s*(".concat(n[a.XRANGEPLAIN], ")\\s+-\\s+(").concat(n[a.XRANGEPLAIN], ")\\s*$")), D("HYPHENRANGELOOSE", "^\\s*(".concat(n[a.XRANGEPLAINLOOSE], ")\\s+-\\s+(").concat(n[a.XRANGEPLAINLOOSE], ")\\s*$")), D("STAR", "(<|>)?=?\\s*\\*"), D("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), D("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
          } }), lD = I({ "node_modules/semver/internal/parse-options.js"(e, r) {
            q();
            var t3 = ["includePrerelease", "loose", "rtl"], s = (c) => c ? typeof c != "object" ? { loose: true } : t3.filter((n) => c[n]).reduce((n, a) => (n[a] = true, n), {}) : {};
            r.exports = s;
          } }), hD = I({ "node_modules/semver/internal/identifiers.js"(e, r) {
            q();
            var t3 = /^[0-9]+$/, s = (n, a) => {
              let p = t3.test(n), D = t3.test(a);
              return p && D && (n = +n, a = +a), n === a ? 0 : p && !D ? -1 : D && !p ? 1 : n < a ? -1 : 1;
            }, c = (n, a) => s(a, n);
            r.exports = { compareIdentifiers: s, rcompareIdentifiers: c };
          } }), pD = I({ "node_modules/semver/classes/semver.js"(e, r) {
            q();
            var t3 = ds(), { MAX_LENGTH: s, MAX_SAFE_INTEGER: c } = Es(), { re: n, t: a } = DD(), p = lD(), { compareIdentifiers: D } = hD(), g = class {
              constructor(i, l) {
                if (l = p(l), i instanceof g) {
                  if (i.loose === !!l.loose && i.includePrerelease === !!l.includePrerelease)
                    return i;
                  i = i.version;
                } else if (typeof i != "string")
                  throw new TypeError("Invalid Version: ".concat(i));
                if (i.length > s)
                  throw new TypeError("version is longer than ".concat(s, " characters"));
                t3("SemVer", i, l), this.options = l, this.loose = !!l.loose, this.includePrerelease = !!l.includePrerelease;
                let h = i.trim().match(l.loose ? n[a.LOOSE] : n[a.FULL]);
                if (!h)
                  throw new TypeError("Invalid Version: ".concat(i));
                if (this.raw = i, this.major = +h[1], this.minor = +h[2], this.patch = +h[3], this.major > c || this.major < 0)
                  throw new TypeError("Invalid major version");
                if (this.minor > c || this.minor < 0)
                  throw new TypeError("Invalid minor version");
                if (this.patch > c || this.patch < 0)
                  throw new TypeError("Invalid patch version");
                h[4] ? this.prerelease = h[4].split(".").map((C) => {
                  if (/^[0-9]+$/.test(C)) {
                    let d = +C;
                    if (d >= 0 && d < c)
                      return d;
                  }
                  return C;
                }) : this.prerelease = [], this.build = h[5] ? h[5].split(".") : [], this.format();
              }
              format() {
                return this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch), this.prerelease.length && (this.version += "-".concat(this.prerelease.join("."))), this.version;
              }
              toString() {
                return this.version;
              }
              compare(i) {
                if (t3("SemVer.compare", this.version, this.options, i), !(i instanceof g)) {
                  if (typeof i == "string" && i === this.version)
                    return 0;
                  i = new g(i, this.options);
                }
                return i.version === this.version ? 0 : this.compareMain(i) || this.comparePre(i);
              }
              compareMain(i) {
                return i instanceof g || (i = new g(i, this.options)), D(this.major, i.major) || D(this.minor, i.minor) || D(this.patch, i.patch);
              }
              comparePre(i) {
                if (i instanceof g || (i = new g(i, this.options)), this.prerelease.length && !i.prerelease.length)
                  return -1;
                if (!this.prerelease.length && i.prerelease.length)
                  return 1;
                if (!this.prerelease.length && !i.prerelease.length)
                  return 0;
                let l = 0;
                do {
                  let h = this.prerelease[l], C = i.prerelease[l];
                  if (t3("prerelease compare", l, h, C), h === void 0 && C === void 0)
                    return 0;
                  if (C === void 0)
                    return 1;
                  if (h === void 0)
                    return -1;
                  if (h === C)
                    continue;
                  return D(h, C);
                } while (++l);
              }
              compareBuild(i) {
                i instanceof g || (i = new g(i, this.options));
                let l = 0;
                do {
                  let h = this.build[l], C = i.build[l];
                  if (t3("prerelease compare", l, h, C), h === void 0 && C === void 0)
                    return 0;
                  if (C === void 0)
                    return 1;
                  if (h === void 0)
                    return -1;
                  if (h === C)
                    continue;
                  return D(h, C);
                } while (++l);
              }
              inc(i, l) {
                switch (i) {
                  case "premajor":
                    this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", l);
                    break;
                  case "preminor":
                    this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", l);
                    break;
                  case "prepatch":
                    this.prerelease.length = 0, this.inc("patch", l), this.inc("pre", l);
                    break;
                  case "prerelease":
                    this.prerelease.length === 0 && this.inc("patch", l), this.inc("pre", l);
                    break;
                  case "major":
                    (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                    break;
                  case "minor":
                    (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                    break;
                  case "patch":
                    this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                    break;
                  case "pre":
                    if (this.prerelease.length === 0)
                      this.prerelease = [0];
                    else {
                      let h = this.prerelease.length;
                      for (; --h >= 0; )
                        typeof this.prerelease[h] == "number" && (this.prerelease[h]++, h = -2);
                      h === -1 && this.prerelease.push(0);
                    }
                    l && (D(this.prerelease[0], l) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [l, 0]) : this.prerelease = [l, 0]);
                    break;
                  default:
                    throw new Error("invalid increment argument: ".concat(i));
                }
                return this.format(), this.raw = this.version, this;
              }
            };
            r.exports = g;
          } }), Ur = I({ "node_modules/semver/functions/compare.js"(e, r) {
            q();
            var t3 = pD(), s = (c, n, a) => new t3(c, a).compare(new t3(n, a));
            r.exports = s;
          } }), fD = I({ "node_modules/semver/functions/lt.js"(e, r) {
            q();
            var t3 = Ur(), s = (c, n, a) => t3(c, n, a) < 0;
            r.exports = s;
          } }), dD = I({ "node_modules/semver/functions/gte.js"(e, r) {
            q();
            var t3 = Ur(), s = (c, n, a) => t3(c, n, a) >= 0;
            r.exports = s;
          } }), ED = I({ "src/utils/arrayify.js"(e, r) {
            "use strict";
            q(), r.exports = (t3, s) => Object.entries(t3).map((c) => {
              let [n, a] = c;
              return Object.assign({ [s]: n }, a);
            });
          } }), CD = I({ "package.json"(e, r) {
            r.exports = { version: "2.7.1" };
          } }), mD = I({ "node_modules/outdent/lib/index.js"(e, r) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true }), e.outdent = void 0;
            function t3() {
              for (var A = [], N = 0; N < arguments.length; N++)
                A[N] = arguments[N];
            }
            function s() {
              return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : c();
            }
            function c() {
              return { add: t3, delete: t3, get: t3, set: t3, has: function(A) {
                return false;
              } };
            }
            var n = Object.prototype.hasOwnProperty, a = function(A, N) {
              return n.call(A, N);
            };
            function p(A, N) {
              for (var R in N)
                a(N, R) && (A[R] = N[R]);
              return A;
            }
            var D = /^[ \t]*(?:\r\n|\r|\n)/, g = /(?:\r\n|\r|\n)[ \t]*$/, i = /^(?:[\r\n]|$)/, l = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, h = /^[ \t]*[\r\n][ \t\r\n]*$/;
            function C(A, N, R) {
              var $ = 0, _ = A[0].match(l);
              _ && ($ = _[1].length);
              var O = "(\\r\\n|\\r|\\n).{0," + $ + "}", x = new RegExp(O, "g");
              N && (A = A.slice(1));
              var k = R.newline, M = R.trimLeadingNewline, u = R.trimTrailingNewline, o = typeof k == "string", E = A.length, f = A.map(function(F, P) {
                return F = F.replace(x, "$1"), P === 0 && M && (F = F.replace(D, "")), P === E - 1 && u && (F = F.replace(g, "")), o && (F = F.replace(/\r\n|\n|\r/g, function(j) {
                  return k;
                })), F;
              });
              return f;
            }
            function d(A, N) {
              for (var R = "", $ = 0, _ = A.length; $ < _; $++)
                R += A[$], $ < _ - 1 && (R += N[$]);
              return R;
            }
            function m(A) {
              return a(A, "raw") && a(A, "length");
            }
            function T(A) {
              var N = s(), R = s();
              function $(O) {
                for (var x = [], k = 1; k < arguments.length; k++)
                  x[k - 1] = arguments[k];
                if (m(O)) {
                  var M = O, u = (x[0] === $ || x[0] === B) && h.test(M[0]) && i.test(M[1]), o = u ? R : N, E = o.get(M);
                  if (E || (E = C(M, u, A), o.set(M, E)), x.length === 0)
                    return E[0];
                  var f = d(E, u ? x.slice(1) : x);
                  return f;
                } else
                  return T(p(p({}, A), O || {}));
              }
              var _ = p($, { string: function(O) {
                return C([O], false, A)[0];
              } });
              return _;
            }
            var B = T({ trimLeadingNewline: true, trimTrailingNewline: true });
            if (e.outdent = B, e.default = B, typeof r < "u")
              try {
                r.exports = B, Object.defineProperty(B, "__esModule", { value: true }), B.default = B, B.outdent = B;
              } catch {
              }
          } }), gD = I({ "src/main/core-options.js"(e, r) {
            "use strict";
            q();
            var { outdent: t3 } = mD(), s = "Config", c = "Editor", n = "Format", a = "Other", p = "Output", D = "Global", g = "Special", i = { cursorOffset: { since: "1.4.0", category: g, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3(Jn || (Jn = Ee([`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `]))), cliCategory: c }, endOfLine: { since: "1.15.0", category: D, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: t3(Zn || (Zn = Ee([`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        `]))) }] }, filepath: { since: "1.4.0", category: g, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: a, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: g, type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: a }, parser: { since: "0.0.10", category: D, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (l) => typeof l == "string" || typeof l == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: true, default: [{ value: [] }], category: D, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (l) => typeof l == "string" || typeof l == "object", cliName: "plugin", cliCategory: s }, pluginSearchDirs: { since: "1.13.0", type: "path", array: true, default: [{ value: [] }], category: D, description: t3(es || (es = Ee([`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `]))), exception: (l) => typeof l == "string" || typeof l == "object", cliName: "plugin-search-dir", cliCategory: s }, printWidth: { since: "0.0.0", category: D, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: g, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3(rs || (rs = Ee([`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `]))), cliCategory: c }, rangeStart: { since: "1.4.0", category: g, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3(ts || (ts = Ee([`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `]))), cliCategory: c }, requirePragma: { since: "1.7.0", category: g, type: "boolean", default: false, description: t3(us || (us = Ee([`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `]))), cliCategory: a }, tabWidth: { type: "int", category: D, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: D, type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: D, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
            r.exports = { CATEGORY_CONFIG: s, CATEGORY_EDITOR: c, CATEGORY_FORMAT: n, CATEGORY_OTHER: a, CATEGORY_OUTPUT: p, CATEGORY_GLOBAL: D, CATEGORY_SPECIAL: g, options: i };
          } }), FD = I({ "src/main/support.js"(e, r) {
            "use strict";
            q();
            var t3 = { compare: Ur(), lt: fD(), gte: dD() }, s = ED(), c = CD().version, n = gD().options;
            function a() {
              let { plugins: D = [], showUnreleased: g = false, showDeprecated: i = false, showInternal: l = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h = c.split("-", 1)[0], C = D.flatMap((A) => A.languages || []).filter(m), d = s(Object.assign({}, ...D.map((A) => {
                let { options: N } = A;
                return N;
              }), n), "name").filter((A) => m(A) && T(A)).sort((A, N) => A.name === N.name ? 0 : A.name < N.name ? -1 : 1).map(B).map((A) => {
                A = Object.assign({}, A), Array.isArray(A.default) && (A.default = A.default.length === 1 ? A.default[0].value : A.default.filter(m).sort((R, $) => t3.compare($.since, R.since))[0].value), Array.isArray(A.choices) && (A.choices = A.choices.filter((R) => m(R) && T(R)), A.name === "parser" && p(A, C, D));
                let N = Object.fromEntries(D.filter((R) => R.defaultOptions && R.defaultOptions[A.name] !== void 0).map((R) => [R.name, R.defaultOptions[A.name]]));
                return Object.assign(Object.assign({}, A), {}, { pluginDefaults: N });
              });
              return { languages: C, options: d };
              function m(A) {
                return g || !("since" in A) || A.since && t3.gte(h, A.since);
              }
              function T(A) {
                return i || !("deprecated" in A) || A.deprecated && t3.lt(h, A.deprecated);
              }
              function B(A) {
                if (l)
                  return A;
                let { cliName: N, cliCategory: R, cliDescription: $ } = A;
                return Qc(A, Yc);
              }
            }
            function p(D, g, i) {
              let l = new Set(D.choices.map((h) => h.value));
              for (let h of g)
                if (h.parsers) {
                  for (let C of h.parsers)
                    if (!l.has(C)) {
                      l.add(C);
                      let d = i.find((T) => T.parsers && T.parsers[C]), m = h.name;
                      d && d.name && (m += " (plugin: ".concat(d.name, ")")), D.choices.push({ value: C, description: m });
                    }
                }
            }
            r.exports = { getSupportInfo: a };
          } }), AD = I({ "src/utils/is-non-empty-array.js"(e, r) {
            "use strict";
            q();
            function t3(s) {
              return Array.isArray(s) && s.length > 0;
            }
            r.exports = t3;
          } });
          function vD() {
            let { onlyFirst: e = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
            return new RegExp(r, e ? void 0 : "g");
          }
          var _D = Ce({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
            q();
          } });
          function SD(e) {
            if (typeof e != "string")
              throw new TypeError("Expected a `string`, got `".concat(typeof e, "`"));
            return e.replace(vD(), "");
          }
          var yD = Ce({ "node_modules/strip-ansi/index.js"() {
            q(), _D();
          } });
          function TD(e) {
            return Number.isInteger(e) ? e >= 4352 && (e <= 4447 || e === 9001 || e === 9002 || 11904 <= e && e <= 12871 && e !== 12351 || 12880 <= e && e <= 19903 || 19968 <= e && e <= 42182 || 43360 <= e && e <= 43388 || 44032 <= e && e <= 55203 || 63744 <= e && e <= 64255 || 65040 <= e && e <= 65049 || 65072 <= e && e <= 65131 || 65281 <= e && e <= 65376 || 65504 <= e && e <= 65510 || 110592 <= e && e <= 110593 || 127488 <= e && e <= 127569 || 131072 <= e && e <= 262141) : false;
          }
          var BD = Ce({ "node_modules/is-fullwidth-code-point/index.js"() {
            q();
          } }), bD = I({ "node_modules/emoji-regex/index.js"(e, r) {
            "use strict";
            q(), r.exports = function() {
              return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
            };
          } }), Cs = {};
          cs(Cs, { default: () => wD });
          function wD(e) {
            if (typeof e != "string" || e.length === 0 || (e = SD(e), e.length === 0))
              return 0;
            e = e.replace((0, ms.default)(), "  ");
            let r = 0;
            for (let t3 = 0; t3 < e.length; t3++) {
              let s = e.codePointAt(t3);
              s <= 31 || s >= 127 && s <= 159 || s >= 768 && s <= 879 || (s > 65535 && t3++, r += TD(s) ? 2 : 1);
            }
            return r;
          }
          var ms, ND = Ce({ "node_modules/string-width/index.js"() {
            q(), yD(), BD(), ms = tD(bD());
          } }), OD = I({ "src/utils/get-string-width.js"(e, r) {
            "use strict";
            q();
            var t3 = (ND(), ls(Cs)).default, s = /[^\x20-\x7F]/;
            function c(n) {
              return n ? s.test(n) ? t3(n) : n.length : 0;
            }
            r.exports = c;
          } }), Gr = I({ "src/utils/text/skip.js"(e, r) {
            "use strict";
            q();
            function t3(p) {
              return (D, g, i) => {
                let l = i && i.backwards;
                if (g === false)
                  return false;
                let { length: h } = D, C = g;
                for (; C >= 0 && C < h; ) {
                  let d = D.charAt(C);
                  if (p instanceof RegExp) {
                    if (!p.test(d))
                      return C;
                  } else if (!p.includes(d))
                    return C;
                  l ? C-- : C++;
                }
                return C === -1 || C === h ? C : false;
              };
            }
            var s = t3(/\s/), c = t3(" 	"), n = t3(",; 	"), a = t3(/[^\n\r]/);
            r.exports = { skipWhitespace: s, skipSpaces: c, skipToLineEnd: n, skipEverythingButNewLine: a };
          } }), gs = I({ "src/utils/text/skip-inline-comment.js"(e, r) {
            "use strict";
            q();
            function t3(s, c) {
              if (c === false)
                return false;
              if (s.charAt(c) === "/" && s.charAt(c + 1) === "*") {
                for (let n = c + 2; n < s.length; ++n)
                  if (s.charAt(n) === "*" && s.charAt(n + 1) === "/")
                    return n + 2;
              }
              return c;
            }
            r.exports = t3;
          } }), Fs = I({ "src/utils/text/skip-trailing-comment.js"(e, r) {
            "use strict";
            q();
            var { skipEverythingButNewLine: t3 } = Gr();
            function s(c, n) {
              return n === false ? false : c.charAt(n) === "/" && c.charAt(n + 1) === "/" ? t3(c, n) : n;
            }
            r.exports = s;
          } }), As = I({ "src/utils/text/skip-newline.js"(e, r) {
            "use strict";
            q();
            function t3(s, c, n) {
              let a = n && n.backwards;
              if (c === false)
                return false;
              let p = s.charAt(c);
              if (a) {
                if (s.charAt(c - 1) === "\r" && p === `
`)
                  return c - 2;
                if (p === `
` || p === "\r" || p === "\u2028" || p === "\u2029")
                  return c - 1;
              } else {
                if (p === "\r" && s.charAt(c + 1) === `
`)
                  return c + 2;
                if (p === `
` || p === "\r" || p === "\u2028" || p === "\u2029")
                  return c + 1;
              }
              return c;
            }
            r.exports = t3;
          } }), qD = I({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e, r) {
            "use strict";
            q();
            var t3 = gs(), s = As(), c = Fs(), { skipSpaces: n } = Gr();
            function a(p, D) {
              let g = null, i = D;
              for (; i !== g; )
                g = i, i = n(p, i), i = t3(p, i), i = c(p, i), i = s(p, i);
              return i;
            }
            r.exports = a;
          } }), ID = I({ "src/common/util.js"(e, r) {
            "use strict";
            q();
            var { default: t3 } = (cD(), ls(fs)), s = ps(), { getSupportInfo: c } = FD(), n = AD(), a = OD(), { skipWhitespace: p, skipSpaces: D, skipToLineEnd: g, skipEverythingButNewLine: i } = Gr(), l = gs(), h = Fs(), C = As(), d = qD(), m = (v) => v[v.length - 2];
            function T(v) {
              return (S, b, w) => {
                let L = w && w.backwards;
                if (b === false)
                  return false;
                let { length: U } = S, V = b;
                for (; V >= 0 && V < U; ) {
                  let Y = S.charAt(V);
                  if (v instanceof RegExp) {
                    if (!v.test(Y))
                      return V;
                  } else if (!v.includes(Y))
                    return V;
                  L ? V-- : V++;
                }
                return V === -1 || V === U ? V : false;
              };
            }
            function B(v, S) {
              let b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, w = D(v, b.backwards ? S - 1 : S, b), L = C(v, w, b);
              return w !== L;
            }
            function A(v, S, b) {
              for (let w = S; w < b; ++w)
                if (v.charAt(w) === `
`)
                  return true;
              return false;
            }
            function N(v, S, b) {
              let w = b(S) - 1;
              w = D(v, w, { backwards: true }), w = C(v, w, { backwards: true }), w = D(v, w, { backwards: true });
              let L = C(v, w, { backwards: true });
              return w !== L;
            }
            function R(v, S) {
              let b = null, w = S;
              for (; w !== b; )
                b = w, w = g(v, w), w = l(v, w), w = D(v, w);
              return w = h(v, w), w = C(v, w), w !== false && B(v, w);
            }
            function $(v, S, b) {
              return R(v, b(S));
            }
            function _(v, S, b) {
              return d(v, b(S));
            }
            function O(v, S, b) {
              return v.charAt(_(v, S, b));
            }
            function x(v, S) {
              let b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              return D(v, b.backwards ? S - 1 : S, b) !== S;
            }
            function k(v, S) {
              let b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, w = 0;
              for (let L = b; L < v.length; ++L)
                v[L] === "	" ? w = w + S - w % S : w++;
              return w;
            }
            function M(v, S) {
              let b = v.lastIndexOf(`
`);
              return b === -1 ? 0 : k(v.slice(b + 1).match(/^[\t ]*/)[0], S);
            }
            function u(v, S) {
              let b = { quote: '"', regex: /"/g, escaped: "&quot;" }, w = { quote: "'", regex: /'/g, escaped: "&apos;" }, L = S === "'" ? w : b, U = L === w ? b : w, V = L;
              if (v.includes(L.quote) || v.includes(U.quote)) {
                let Y = (v.match(L.regex) || []).length, ue = (v.match(U.regex) || []).length;
                V = Y > ue ? U : L;
              }
              return V;
            }
            function o(v, S) {
              let b = v.slice(1, -1), w = S.parser === "json" || S.parser === "json5" && S.quoteProps === "preserve" && !S.singleQuote ? '"' : S.__isInHtmlAttribute ? "'" : u(b, S.singleQuote ? "'" : '"').quote;
              return E(b, w, !(S.parser === "css" || S.parser === "less" || S.parser === "scss" || S.__embeddedInHtml));
            }
            function E(v, S, b) {
              let w = S === '"' ? "'" : '"', L = /\\(.)|(["'])/gs, U = v.replace(L, (V, Y, ue) => Y === w ? Y : ue === S ? "\\" + ue : ue || (b && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(Y) ? Y : "\\" + Y));
              return S + U + S;
            }
            function f(v) {
              return v.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
            }
            function F(v, S) {
              let b = v.match(new RegExp("(".concat(t3(S), ")+"), "g"));
              return b === null ? 0 : b.reduce((w, L) => Math.max(w, L.length / S.length), 0);
            }
            function P(v, S) {
              let b = v.match(new RegExp("(".concat(t3(S), ")+"), "g"));
              if (b === null)
                return 0;
              let w = /* @__PURE__ */ new Map(), L = 0;
              for (let U of b) {
                let V = U.length / S.length;
                w.set(V, true), V > L && (L = V);
              }
              for (let U = 1; U < L; U++)
                if (!w.get(U))
                  return U;
              return L + 1;
            }
            function j(v, S) {
              (v.comments || (v.comments = [])).push(S), S.printed = false, S.nodeDescription = ee(v);
            }
            function W(v, S) {
              S.leading = true, S.trailing = false, j(v, S);
            }
            function X(v, S, b) {
              S.leading = false, S.trailing = false, b && (S.marker = b), j(v, S);
            }
            function H(v, S) {
              S.leading = false, S.trailing = true, j(v, S);
            }
            function z(v, S) {
              let { languages: b } = c({ plugins: S.plugins }), w = b.find((L) => {
                let { name: U } = L;
                return U.toLowerCase() === v;
              }) || b.find((L) => {
                let { aliases: U } = L;
                return Array.isArray(U) && U.includes(v);
              }) || b.find((L) => {
                let { extensions: U } = L;
                return Array.isArray(U) && U.includes(".".concat(v));
              });
              return w && w.parsers[0];
            }
            function J(v) {
              return v && v.type === "front-matter";
            }
            function Z(v) {
              let S = /* @__PURE__ */ new WeakMap();
              return function(b) {
                return S.has(b) || S.set(b, Symbol(v)), S.get(b);
              };
            }
            function ee(v) {
              let S = v.type || v.kind || "(unknown type)", b = String(v.name || v.id && (typeof v.id == "object" ? v.id.name : v.id) || v.key && (typeof v.key == "object" ? v.key.name : v.key) || v.value && (typeof v.value == "object" ? "" : String(v.value)) || v.operator || "");
              return b.length > 20 && (b = b.slice(0, 19) + "\u2026"), S + (b ? " " + b : "");
            }
            r.exports = { inferParserByLanguage: z, getStringWidth: a, getMaxContinuousCount: F, getMinNotPresentContinuousCount: P, getPenultimate: m, getLast: s, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: d, getNextNonSpaceNonCommentCharacterIndex: _, getNextNonSpaceNonCommentCharacter: O, skip: T, skipWhitespace: p, skipSpaces: D, skipToLineEnd: g, skipEverythingButNewLine: i, skipInlineComment: l, skipTrailingComment: h, skipNewline: C, isNextLineEmptyAfterIndex: R, isNextLineEmpty: $, isPreviousLineEmpty: N, hasNewline: B, hasNewlineInRange: A, hasSpaces: x, getAlignmentSize: k, getIndentSize: M, getPreferredQuote: u, printString: o, printNumber: f, makeString: E, addLeadingComment: W, addDanglingComment: X, addTrailingComment: H, isFrontMatterNode: J, isNonEmptyArray: n, createGroupIdMapper: Z };
          } }), RD = I({ "vendors/html-tag-names.json"(e, r) {
            r.exports = { htmlTagNames: ["a", "abbr", "acronym", "address", "applet", "area", "article", "aside", "audio", "b", "base", "basefont", "bdi", "bdo", "bgsound", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "command", "content", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "embed", "fieldset", "figcaption", "figure", "font", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "image", "img", "input", "ins", "isindex", "kbd", "keygen", "label", "legend", "li", "link", "listing", "main", "map", "mark", "marquee", "math", "menu", "menuitem", "meta", "meter", "multicol", "nav", "nextid", "nobr", "noembed", "noframes", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "plaintext", "pre", "progress", "q", "rb", "rbc", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "tt", "u", "ul", "var", "video", "wbr", "xmp"] };
          } }), vs = I({ "src/language-html/utils/array-to-map.js"(e, r) {
            "use strict";
            q();
            function t3(s) {
              let c = /* @__PURE__ */ Object.create(null);
              for (let n of s)
                c[n] = true;
              return c;
            }
            r.exports = t3;
          } }), xD = I({ "src/language-html/utils/html-tag-names.js"(e, r) {
            "use strict";
            q();
            var { htmlTagNames: t3 } = RD(), s = vs(), c = s(t3);
            r.exports = c;
          } }), PD = I({ "vendors/html-element-attributes.json"(e, r) {
            r.exports = { htmlElementAttributes: { "*": ["accesskey", "autocapitalize", "autofocus", "class", "contenteditable", "dir", "draggable", "enterkeyhint", "hidden", "id", "inputmode", "is", "itemid", "itemprop", "itemref", "itemscope", "itemtype", "lang", "nonce", "slot", "spellcheck", "style", "tabindex", "title", "translate"], a: ["charset", "coords", "download", "href", "hreflang", "name", "ping", "referrerpolicy", "rel", "rev", "shape", "target", "type"], applet: ["align", "alt", "archive", "code", "codebase", "height", "hspace", "name", "object", "vspace", "width"], area: ["alt", "coords", "download", "href", "hreflang", "nohref", "ping", "referrerpolicy", "rel", "shape", "target", "type"], audio: ["autoplay", "controls", "crossorigin", "loop", "muted", "preload", "src"], base: ["href", "target"], basefont: ["color", "face", "size"], blockquote: ["cite"], body: ["alink", "background", "bgcolor", "link", "text", "vlink"], br: ["clear"], button: ["disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "name", "type", "value"], canvas: ["height", "width"], caption: ["align"], col: ["align", "char", "charoff", "span", "valign", "width"], colgroup: ["align", "char", "charoff", "span", "valign", "width"], data: ["value"], del: ["cite", "datetime"], details: ["open"], dialog: ["open"], dir: ["compact"], div: ["align"], dl: ["compact"], embed: ["height", "src", "type", "width"], fieldset: ["disabled", "form", "name"], font: ["color", "face", "size"], form: ["accept", "accept-charset", "action", "autocomplete", "enctype", "method", "name", "novalidate", "target"], frame: ["frameborder", "longdesc", "marginheight", "marginwidth", "name", "noresize", "scrolling", "src"], frameset: ["cols", "rows"], h1: ["align"], h2: ["align"], h3: ["align"], h4: ["align"], h5: ["align"], h6: ["align"], head: ["profile"], hr: ["align", "noshade", "size", "width"], html: ["manifest", "version"], iframe: ["align", "allow", "allowfullscreen", "allowpaymentrequest", "allowusermedia", "frameborder", "height", "loading", "longdesc", "marginheight", "marginwidth", "name", "referrerpolicy", "sandbox", "scrolling", "src", "srcdoc", "width"], img: ["align", "alt", "border", "crossorigin", "decoding", "height", "hspace", "ismap", "loading", "longdesc", "name", "referrerpolicy", "sizes", "src", "srcset", "usemap", "vspace", "width"], input: ["accept", "align", "alt", "autocomplete", "checked", "dirname", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "height", "ismap", "list", "max", "maxlength", "min", "minlength", "multiple", "name", "pattern", "placeholder", "readonly", "required", "size", "src", "step", "type", "usemap", "value", "width"], ins: ["cite", "datetime"], isindex: ["prompt"], label: ["for", "form"], legend: ["align"], li: ["type", "value"], link: ["as", "charset", "color", "crossorigin", "disabled", "href", "hreflang", "imagesizes", "imagesrcset", "integrity", "media", "referrerpolicy", "rel", "rev", "sizes", "target", "type"], map: ["name"], menu: ["compact"], meta: ["charset", "content", "http-equiv", "media", "name", "scheme"], meter: ["high", "low", "max", "min", "optimum", "value"], object: ["align", "archive", "border", "classid", "codebase", "codetype", "data", "declare", "form", "height", "hspace", "name", "standby", "type", "typemustmatch", "usemap", "vspace", "width"], ol: ["compact", "reversed", "start", "type"], optgroup: ["disabled", "label"], option: ["disabled", "label", "selected", "value"], output: ["for", "form", "name"], p: ["align"], param: ["name", "type", "value", "valuetype"], pre: ["width"], progress: ["max", "value"], q: ["cite"], script: ["async", "charset", "crossorigin", "defer", "integrity", "language", "nomodule", "referrerpolicy", "src", "type"], select: ["autocomplete", "disabled", "form", "multiple", "name", "required", "size"], slot: ["name"], source: ["height", "media", "sizes", "src", "srcset", "type", "width"], style: ["media", "type"], table: ["align", "bgcolor", "border", "cellpadding", "cellspacing", "frame", "rules", "summary", "width"], tbody: ["align", "char", "charoff", "valign"], td: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], textarea: ["autocomplete", "cols", "dirname", "disabled", "form", "maxlength", "minlength", "name", "placeholder", "readonly", "required", "rows", "wrap"], tfoot: ["align", "char", "charoff", "valign"], th: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], thead: ["align", "char", "charoff", "valign"], time: ["datetime"], tr: ["align", "bgcolor", "char", "charoff", "valign"], track: ["default", "kind", "label", "src", "srclang"], ul: ["compact", "type"], video: ["autoplay", "controls", "crossorigin", "height", "loop", "muted", "playsinline", "poster", "preload", "src", "width"] } };
          } }), kD = I({ "src/language-html/utils/map-object.js"(e, r) {
            "use strict";
            q();
            function t3(s, c) {
              let n = /* @__PURE__ */ Object.create(null);
              for (let [a, p] of Object.entries(s))
                n[a] = c(p, a);
              return n;
            }
            r.exports = t3;
          } }), LD = I({ "src/language-html/utils/html-elements-attributes.js"(e, r) {
            "use strict";
            q();
            var { htmlElementAttributes: t3 } = PD(), s = kD(), c = vs(), n = s(t3, c);
            r.exports = n;
          } }), MD = I({ "src/language-html/utils/is-unknown-namespace.js"(e, r) {
            "use strict";
            q();
            function t3(s) {
              return s.type === "element" && !s.hasExplicitNamespace && !["html", "svg"].includes(s.namespace);
            }
            r.exports = t3;
          } }), jD = I({ "src/language-html/pragma.js"(e, r) {
            "use strict";
            q();
            function t3(c) {
              return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(c);
            }
            function s(c) {
              return `<!-- @format -->

` + c.replace(/^\s*\n/, "");
            }
            r.exports = { hasPragma: t3, insertPragma: s };
          } }), $D = I({ "src/language-html/ast.js"(e, r) {
            "use strict";
            q();
            var t3 = { attrs: true, children: true }, s = /* @__PURE__ */ new Set(["parent"]), c = class {
              constructor() {
                let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                for (let p of /* @__PURE__ */ new Set([...s, ...Object.keys(a)]))
                  this.setProperty(p, a[p]);
              }
              setProperty(a, p) {
                if (this[a] !== p) {
                  if (a in t3 && (p = p.map((D) => this.createChild(D))), !s.has(a)) {
                    this[a] = p;
                    return;
                  }
                  Object.defineProperty(this, a, { value: p, enumerable: false, configurable: true });
                }
              }
              map(a) {
                let p;
                for (let D in t3) {
                  let g = this[D];
                  if (g) {
                    let i = n(g, (l) => l.map(a));
                    p !== g && (p || (p = new c({ parent: this.parent })), p.setProperty(D, i));
                  }
                }
                if (p)
                  for (let D in this)
                    D in t3 || (p[D] = this[D]);
                return a(p || this);
              }
              walk(a) {
                for (let p in t3) {
                  let D = this[p];
                  if (D)
                    for (let g = 0; g < D.length; g++)
                      D[g].walk(a);
                }
                a(this);
              }
              createChild(a) {
                let p = a instanceof c ? a.clone() : new c(a);
                return p.setProperty("parent", this), p;
              }
              insertChildBefore(a, p) {
                this.children.splice(this.children.indexOf(a), 0, this.createChild(p));
              }
              removeChild(a) {
                this.children.splice(this.children.indexOf(a), 1);
              }
              replaceChild(a, p) {
                this.children[this.children.indexOf(a)] = this.createChild(p);
              }
              clone() {
                return new c(this);
              }
              get firstChild() {
                var a;
                return (a = this.children) === null || a === void 0 ? void 0 : a[0];
              }
              get lastChild() {
                var a;
                return (a = this.children) === null || a === void 0 ? void 0 : a[this.children.length - 1];
              }
              get prev() {
                var a;
                return (a = this.parent) === null || a === void 0 ? void 0 : a.children[this.parent.children.indexOf(this) - 1];
              }
              get next() {
                var a;
                return (a = this.parent) === null || a === void 0 ? void 0 : a.children[this.parent.children.indexOf(this) + 1];
              }
              get rawName() {
                return this.hasExplicitNamespace ? this.fullName : this.name;
              }
              get fullName() {
                return this.namespace ? this.namespace + ":" + this.name : this.name;
              }
              get attrMap() {
                return Object.fromEntries(this.attrs.map((a) => [a.fullName, a.value]));
              }
            };
            function n(a, p) {
              let D = a.map(p);
              return D.some((g, i) => g !== a[i]) ? D : a;
            }
            r.exports = { Node: c };
          } }), UD = I({ "src/language-html/conditional-comment.js"(e, r) {
            "use strict";
            q();
            var { ParseSourceSpan: t3 } = Te(), s = [{ regex: /^(\[if([^\]]*)]>)(.*?)<!\s*\[endif]$/s, parse: n }, { regex: /^\[if([^\]]*)]><!$/, parse: a }, { regex: /^<!\s*\[endif]$/, parse: p }];
            function c(D, g) {
              if (D.value)
                for (let { regex: i, parse: l } of s) {
                  let h = D.value.match(i);
                  if (h)
                    return l(D, g, h);
                }
              return null;
            }
            function n(D, g, i) {
              let [, l, h, C] = i, d = 4 + l.length, m = D.sourceSpan.start.moveBy(d), T = m.moveBy(C.length), [B, A] = (() => {
                try {
                  return [true, g(C, m).children];
                } catch {
                  let N = { type: "text", value: C, sourceSpan: new t3(m, T) };
                  return [false, [N]];
                }
              })();
              return { type: "ieConditionalComment", complete: B, children: A, condition: h.trim().replace(/\s+/g, " "), sourceSpan: D.sourceSpan, startSourceSpan: new t3(D.sourceSpan.start, m), endSourceSpan: new t3(T, D.sourceSpan.end) };
            }
            function a(D, g, i) {
              let [, l] = i;
              return { type: "ieConditionalStartComment", condition: l.trim().replace(/\s+/g, " "), sourceSpan: D.sourceSpan };
            }
            function p(D) {
              return { type: "ieConditionalEndComment", sourceSpan: D.sourceSpan };
            }
            r.exports = { parseIeConditionalComment: c };
          } }), GD = I({ "src/language-html/loc.js"(e, r) {
            "use strict";
            q();
            function t3(c) {
              return c.sourceSpan.start.offset;
            }
            function s(c) {
              return c.sourceSpan.end.offset;
            }
            r.exports = { locStart: t3, locEnd: s };
          } }), Ze = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/tags.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r;
            (function(D) {
              D[D.RAW_TEXT = 0] = "RAW_TEXT", D[D.ESCAPABLE_RAW_TEXT = 1] = "ESCAPABLE_RAW_TEXT", D[D.PARSABLE_DATA = 2] = "PARSABLE_DATA";
            })(r = e.TagContentType || (e.TagContentType = {}));
            function t3(D) {
              if (D[0] != ":")
                return [null, D];
              let g = D.indexOf(":", 1);
              if (g == -1)
                throw new Error('Unsupported format "'.concat(D, '" expecting ":namespace:name"'));
              return [D.slice(1, g), D.slice(g + 1)];
            }
            e.splitNsName = t3;
            function s(D) {
              return t3(D)[1] === "ng-container";
            }
            e.isNgContainer = s;
            function c(D) {
              return t3(D)[1] === "ng-content";
            }
            e.isNgContent = c;
            function n(D) {
              return t3(D)[1] === "ng-template";
            }
            e.isNgTemplate = n;
            function a(D) {
              return D === null ? null : t3(D)[0];
            }
            e.getNsPrefix = a;
            function p(D, g) {
              return D ? ":".concat(D, ":").concat(g) : g;
            }
            e.mergeNsAndName = p, e.NAMED_ENTITIES = { Aacute: "\xC1", aacute: "\xE1", Abreve: "\u0102", abreve: "\u0103", ac: "\u223E", acd: "\u223F", acE: "\u223E\u0333", Acirc: "\xC2", acirc: "\xE2", acute: "\xB4", Acy: "\u0410", acy: "\u0430", AElig: "\xC6", aelig: "\xE6", af: "\u2061", Afr: "\u{1D504}", afr: "\u{1D51E}", Agrave: "\xC0", agrave: "\xE0", alefsym: "\u2135", aleph: "\u2135", Alpha: "\u0391", alpha: "\u03B1", Amacr: "\u0100", amacr: "\u0101", amalg: "\u2A3F", AMP: "&", amp: "&", And: "\u2A53", and: "\u2227", andand: "\u2A55", andd: "\u2A5C", andslope: "\u2A58", andv: "\u2A5A", ang: "\u2220", ange: "\u29A4", angle: "\u2220", angmsd: "\u2221", angmsdaa: "\u29A8", angmsdab: "\u29A9", angmsdac: "\u29AA", angmsdad: "\u29AB", angmsdae: "\u29AC", angmsdaf: "\u29AD", angmsdag: "\u29AE", angmsdah: "\u29AF", angrt: "\u221F", angrtvb: "\u22BE", angrtvbd: "\u299D", angsph: "\u2222", angst: "\xC5", angzarr: "\u237C", Aogon: "\u0104", aogon: "\u0105", Aopf: "\u{1D538}", aopf: "\u{1D552}", ap: "\u2248", apacir: "\u2A6F", apE: "\u2A70", ape: "\u224A", apid: "\u224B", apos: "'", ApplyFunction: "\u2061", approx: "\u2248", approxeq: "\u224A", Aring: "\xC5", aring: "\xE5", Ascr: "\u{1D49C}", ascr: "\u{1D4B6}", Assign: "\u2254", ast: "*", asymp: "\u2248", asympeq: "\u224D", Atilde: "\xC3", atilde: "\xE3", Auml: "\xC4", auml: "\xE4", awconint: "\u2233", awint: "\u2A11", backcong: "\u224C", backepsilon: "\u03F6", backprime: "\u2035", backsim: "\u223D", backsimeq: "\u22CD", Backslash: "\u2216", Barv: "\u2AE7", barvee: "\u22BD", Barwed: "\u2306", barwed: "\u2305", barwedge: "\u2305", bbrk: "\u23B5", bbrktbrk: "\u23B6", bcong: "\u224C", Bcy: "\u0411", bcy: "\u0431", bdquo: "\u201E", becaus: "\u2235", Because: "\u2235", because: "\u2235", bemptyv: "\u29B0", bepsi: "\u03F6", bernou: "\u212C", Bernoullis: "\u212C", Beta: "\u0392", beta: "\u03B2", beth: "\u2136", between: "\u226C", Bfr: "\u{1D505}", bfr: "\u{1D51F}", bigcap: "\u22C2", bigcirc: "\u25EF", bigcup: "\u22C3", bigodot: "\u2A00", bigoplus: "\u2A01", bigotimes: "\u2A02", bigsqcup: "\u2A06", bigstar: "\u2605", bigtriangledown: "\u25BD", bigtriangleup: "\u25B3", biguplus: "\u2A04", bigvee: "\u22C1", bigwedge: "\u22C0", bkarow: "\u290D", blacklozenge: "\u29EB", blacksquare: "\u25AA", blacktriangle: "\u25B4", blacktriangledown: "\u25BE", blacktriangleleft: "\u25C2", blacktriangleright: "\u25B8", blank: "\u2423", blk12: "\u2592", blk14: "\u2591", blk34: "\u2593", block: "\u2588", bne: "=\u20E5", bnequiv: "\u2261\u20E5", bNot: "\u2AED", bnot: "\u2310", Bopf: "\u{1D539}", bopf: "\u{1D553}", bot: "\u22A5", bottom: "\u22A5", bowtie: "\u22C8", boxbox: "\u29C9", boxDL: "\u2557", boxDl: "\u2556", boxdL: "\u2555", boxdl: "\u2510", boxDR: "\u2554", boxDr: "\u2553", boxdR: "\u2552", boxdr: "\u250C", boxH: "\u2550", boxh: "\u2500", boxHD: "\u2566", boxHd: "\u2564", boxhD: "\u2565", boxhd: "\u252C", boxHU: "\u2569", boxHu: "\u2567", boxhU: "\u2568", boxhu: "\u2534", boxminus: "\u229F", boxplus: "\u229E", boxtimes: "\u22A0", boxUL: "\u255D", boxUl: "\u255C", boxuL: "\u255B", boxul: "\u2518", boxUR: "\u255A", boxUr: "\u2559", boxuR: "\u2558", boxur: "\u2514", boxV: "\u2551", boxv: "\u2502", boxVH: "\u256C", boxVh: "\u256B", boxvH: "\u256A", boxvh: "\u253C", boxVL: "\u2563", boxVl: "\u2562", boxvL: "\u2561", boxvl: "\u2524", boxVR: "\u2560", boxVr: "\u255F", boxvR: "\u255E", boxvr: "\u251C", bprime: "\u2035", Breve: "\u02D8", breve: "\u02D8", brvbar: "\xA6", Bscr: "\u212C", bscr: "\u{1D4B7}", bsemi: "\u204F", bsim: "\u223D", bsime: "\u22CD", bsol: "\\", bsolb: "\u29C5", bsolhsub: "\u27C8", bull: "\u2022", bullet: "\u2022", bump: "\u224E", bumpE: "\u2AAE", bumpe: "\u224F", Bumpeq: "\u224E", bumpeq: "\u224F", Cacute: "\u0106", cacute: "\u0107", Cap: "\u22D2", cap: "\u2229", capand: "\u2A44", capbrcup: "\u2A49", capcap: "\u2A4B", capcup: "\u2A47", capdot: "\u2A40", CapitalDifferentialD: "\u2145", caps: "\u2229\uFE00", caret: "\u2041", caron: "\u02C7", Cayleys: "\u212D", ccaps: "\u2A4D", Ccaron: "\u010C", ccaron: "\u010D", Ccedil: "\xC7", ccedil: "\xE7", Ccirc: "\u0108", ccirc: "\u0109", Cconint: "\u2230", ccups: "\u2A4C", ccupssm: "\u2A50", Cdot: "\u010A", cdot: "\u010B", cedil: "\xB8", Cedilla: "\xB8", cemptyv: "\u29B2", cent: "\xA2", CenterDot: "\xB7", centerdot: "\xB7", Cfr: "\u212D", cfr: "\u{1D520}", CHcy: "\u0427", chcy: "\u0447", check: "\u2713", checkmark: "\u2713", Chi: "\u03A7", chi: "\u03C7", cir: "\u25CB", circ: "\u02C6", circeq: "\u2257", circlearrowleft: "\u21BA", circlearrowright: "\u21BB", circledast: "\u229B", circledcirc: "\u229A", circleddash: "\u229D", CircleDot: "\u2299", circledR: "\xAE", circledS: "\u24C8", CircleMinus: "\u2296", CirclePlus: "\u2295", CircleTimes: "\u2297", cirE: "\u29C3", cire: "\u2257", cirfnint: "\u2A10", cirmid: "\u2AEF", cirscir: "\u29C2", ClockwiseContourIntegral: "\u2232", CloseCurlyDoubleQuote: "\u201D", CloseCurlyQuote: "\u2019", clubs: "\u2663", clubsuit: "\u2663", Colon: "\u2237", colon: ":", Colone: "\u2A74", colone: "\u2254", coloneq: "\u2254", comma: ",", commat: "@", comp: "\u2201", compfn: "\u2218", complement: "\u2201", complexes: "\u2102", cong: "\u2245", congdot: "\u2A6D", Congruent: "\u2261", Conint: "\u222F", conint: "\u222E", ContourIntegral: "\u222E", Copf: "\u2102", copf: "\u{1D554}", coprod: "\u2210", Coproduct: "\u2210", COPY: "\xA9", copy: "\xA9", copysr: "\u2117", CounterClockwiseContourIntegral: "\u2233", crarr: "\u21B5", Cross: "\u2A2F", cross: "\u2717", Cscr: "\u{1D49E}", cscr: "\u{1D4B8}", csub: "\u2ACF", csube: "\u2AD1", csup: "\u2AD0", csupe: "\u2AD2", ctdot: "\u22EF", cudarrl: "\u2938", cudarrr: "\u2935", cuepr: "\u22DE", cuesc: "\u22DF", cularr: "\u21B6", cularrp: "\u293D", Cup: "\u22D3", cup: "\u222A", cupbrcap: "\u2A48", CupCap: "\u224D", cupcap: "\u2A46", cupcup: "\u2A4A", cupdot: "\u228D", cupor: "\u2A45", cups: "\u222A\uFE00", curarr: "\u21B7", curarrm: "\u293C", curlyeqprec: "\u22DE", curlyeqsucc: "\u22DF", curlyvee: "\u22CE", curlywedge: "\u22CF", curren: "\xA4", curvearrowleft: "\u21B6", curvearrowright: "\u21B7", cuvee: "\u22CE", cuwed: "\u22CF", cwconint: "\u2232", cwint: "\u2231", cylcty: "\u232D", Dagger: "\u2021", dagger: "\u2020", daleth: "\u2138", Darr: "\u21A1", dArr: "\u21D3", darr: "\u2193", dash: "\u2010", Dashv: "\u2AE4", dashv: "\u22A3", dbkarow: "\u290F", dblac: "\u02DD", Dcaron: "\u010E", dcaron: "\u010F", Dcy: "\u0414", dcy: "\u0434", DD: "\u2145", dd: "\u2146", ddagger: "\u2021", ddarr: "\u21CA", DDotrahd: "\u2911", ddotseq: "\u2A77", deg: "\xB0", Del: "\u2207", Delta: "\u0394", delta: "\u03B4", demptyv: "\u29B1", dfisht: "\u297F", Dfr: "\u{1D507}", dfr: "\u{1D521}", dHar: "\u2965", dharl: "\u21C3", dharr: "\u21C2", DiacriticalAcute: "\xB4", DiacriticalDot: "\u02D9", DiacriticalDoubleAcute: "\u02DD", DiacriticalGrave: "`", DiacriticalTilde: "\u02DC", diam: "\u22C4", Diamond: "\u22C4", diamond: "\u22C4", diamondsuit: "\u2666", diams: "\u2666", die: "\xA8", DifferentialD: "\u2146", digamma: "\u03DD", disin: "\u22F2", div: "\xF7", divide: "\xF7", divideontimes: "\u22C7", divonx: "\u22C7", DJcy: "\u0402", djcy: "\u0452", dlcorn: "\u231E", dlcrop: "\u230D", dollar: "$", Dopf: "\u{1D53B}", dopf: "\u{1D555}", Dot: "\xA8", dot: "\u02D9", DotDot: "\u20DC", doteq: "\u2250", doteqdot: "\u2251", DotEqual: "\u2250", dotminus: "\u2238", dotplus: "\u2214", dotsquare: "\u22A1", doublebarwedge: "\u2306", DoubleContourIntegral: "\u222F", DoubleDot: "\xA8", DoubleDownArrow: "\u21D3", DoubleLeftArrow: "\u21D0", DoubleLeftRightArrow: "\u21D4", DoubleLeftTee: "\u2AE4", DoubleLongLeftArrow: "\u27F8", DoubleLongLeftRightArrow: "\u27FA", DoubleLongRightArrow: "\u27F9", DoubleRightArrow: "\u21D2", DoubleRightTee: "\u22A8", DoubleUpArrow: "\u21D1", DoubleUpDownArrow: "\u21D5", DoubleVerticalBar: "\u2225", DownArrow: "\u2193", Downarrow: "\u21D3", downarrow: "\u2193", DownArrowBar: "\u2913", DownArrowUpArrow: "\u21F5", DownBreve: "\u0311", downdownarrows: "\u21CA", downharpoonleft: "\u21C3", downharpoonright: "\u21C2", DownLeftRightVector: "\u2950", DownLeftTeeVector: "\u295E", DownLeftVector: "\u21BD", DownLeftVectorBar: "\u2956", DownRightTeeVector: "\u295F", DownRightVector: "\u21C1", DownRightVectorBar: "\u2957", DownTee: "\u22A4", DownTeeArrow: "\u21A7", drbkarow: "\u2910", drcorn: "\u231F", drcrop: "\u230C", Dscr: "\u{1D49F}", dscr: "\u{1D4B9}", DScy: "\u0405", dscy: "\u0455", dsol: "\u29F6", Dstrok: "\u0110", dstrok: "\u0111", dtdot: "\u22F1", dtri: "\u25BF", dtrif: "\u25BE", duarr: "\u21F5", duhar: "\u296F", dwangle: "\u29A6", DZcy: "\u040F", dzcy: "\u045F", dzigrarr: "\u27FF", Eacute: "\xC9", eacute: "\xE9", easter: "\u2A6E", Ecaron: "\u011A", ecaron: "\u011B", ecir: "\u2256", Ecirc: "\xCA", ecirc: "\xEA", ecolon: "\u2255", Ecy: "\u042D", ecy: "\u044D", eDDot: "\u2A77", Edot: "\u0116", eDot: "\u2251", edot: "\u0117", ee: "\u2147", efDot: "\u2252", Efr: "\u{1D508}", efr: "\u{1D522}", eg: "\u2A9A", Egrave: "\xC8", egrave: "\xE8", egs: "\u2A96", egsdot: "\u2A98", el: "\u2A99", Element: "\u2208", elinters: "\u23E7", ell: "\u2113", els: "\u2A95", elsdot: "\u2A97", Emacr: "\u0112", emacr: "\u0113", empty: "\u2205", emptyset: "\u2205", EmptySmallSquare: "\u25FB", emptyv: "\u2205", EmptyVerySmallSquare: "\u25AB", emsp: "\u2003", emsp13: "\u2004", emsp14: "\u2005", ENG: "\u014A", eng: "\u014B", ensp: "\u2002", Eogon: "\u0118", eogon: "\u0119", Eopf: "\u{1D53C}", eopf: "\u{1D556}", epar: "\u22D5", eparsl: "\u29E3", eplus: "\u2A71", epsi: "\u03B5", Epsilon: "\u0395", epsilon: "\u03B5", epsiv: "\u03F5", eqcirc: "\u2256", eqcolon: "\u2255", eqsim: "\u2242", eqslantgtr: "\u2A96", eqslantless: "\u2A95", Equal: "\u2A75", equals: "=", EqualTilde: "\u2242", equest: "\u225F", Equilibrium: "\u21CC", equiv: "\u2261", equivDD: "\u2A78", eqvparsl: "\u29E5", erarr: "\u2971", erDot: "\u2253", Escr: "\u2130", escr: "\u212F", esdot: "\u2250", Esim: "\u2A73", esim: "\u2242", Eta: "\u0397", eta: "\u03B7", ETH: "\xD0", eth: "\xF0", Euml: "\xCB", euml: "\xEB", euro: "\u20AC", excl: "!", exist: "\u2203", Exists: "\u2203", expectation: "\u2130", ExponentialE: "\u2147", exponentiale: "\u2147", fallingdotseq: "\u2252", Fcy: "\u0424", fcy: "\u0444", female: "\u2640", ffilig: "\uFB03", fflig: "\uFB00", ffllig: "\uFB04", Ffr: "\u{1D509}", ffr: "\u{1D523}", filig: "\uFB01", FilledSmallSquare: "\u25FC", FilledVerySmallSquare: "\u25AA", fjlig: "fj", flat: "\u266D", fllig: "\uFB02", fltns: "\u25B1", fnof: "\u0192", Fopf: "\u{1D53D}", fopf: "\u{1D557}", ForAll: "\u2200", forall: "\u2200", fork: "\u22D4", forkv: "\u2AD9", Fouriertrf: "\u2131", fpartint: "\u2A0D", frac12: "\xBD", frac13: "\u2153", frac14: "\xBC", frac15: "\u2155", frac16: "\u2159", frac18: "\u215B", frac23: "\u2154", frac25: "\u2156", frac34: "\xBE", frac35: "\u2157", frac38: "\u215C", frac45: "\u2158", frac56: "\u215A", frac58: "\u215D", frac78: "\u215E", frasl: "\u2044", frown: "\u2322", Fscr: "\u2131", fscr: "\u{1D4BB}", gacute: "\u01F5", Gamma: "\u0393", gamma: "\u03B3", Gammad: "\u03DC", gammad: "\u03DD", gap: "\u2A86", Gbreve: "\u011E", gbreve: "\u011F", Gcedil: "\u0122", Gcirc: "\u011C", gcirc: "\u011D", Gcy: "\u0413", gcy: "\u0433", Gdot: "\u0120", gdot: "\u0121", gE: "\u2267", ge: "\u2265", gEl: "\u2A8C", gel: "\u22DB", geq: "\u2265", geqq: "\u2267", geqslant: "\u2A7E", ges: "\u2A7E", gescc: "\u2AA9", gesdot: "\u2A80", gesdoto: "\u2A82", gesdotol: "\u2A84", gesl: "\u22DB\uFE00", gesles: "\u2A94", Gfr: "\u{1D50A}", gfr: "\u{1D524}", Gg: "\u22D9", gg: "\u226B", ggg: "\u22D9", gimel: "\u2137", GJcy: "\u0403", gjcy: "\u0453", gl: "\u2277", gla: "\u2AA5", glE: "\u2A92", glj: "\u2AA4", gnap: "\u2A8A", gnapprox: "\u2A8A", gnE: "\u2269", gne: "\u2A88", gneq: "\u2A88", gneqq: "\u2269", gnsim: "\u22E7", Gopf: "\u{1D53E}", gopf: "\u{1D558}", grave: "`", GreaterEqual: "\u2265", GreaterEqualLess: "\u22DB", GreaterFullEqual: "\u2267", GreaterGreater: "\u2AA2", GreaterLess: "\u2277", GreaterSlantEqual: "\u2A7E", GreaterTilde: "\u2273", Gscr: "\u{1D4A2}", gscr: "\u210A", gsim: "\u2273", gsime: "\u2A8E", gsiml: "\u2A90", GT: ">", Gt: "\u226B", gt: ">", gtcc: "\u2AA7", gtcir: "\u2A7A", gtdot: "\u22D7", gtlPar: "\u2995", gtquest: "\u2A7C", gtrapprox: "\u2A86", gtrarr: "\u2978", gtrdot: "\u22D7", gtreqless: "\u22DB", gtreqqless: "\u2A8C", gtrless: "\u2277", gtrsim: "\u2273", gvertneqq: "\u2269\uFE00", gvnE: "\u2269\uFE00", Hacek: "\u02C7", hairsp: "\u200A", half: "\xBD", hamilt: "\u210B", HARDcy: "\u042A", hardcy: "\u044A", hArr: "\u21D4", harr: "\u2194", harrcir: "\u2948", harrw: "\u21AD", Hat: "^", hbar: "\u210F", Hcirc: "\u0124", hcirc: "\u0125", hearts: "\u2665", heartsuit: "\u2665", hellip: "\u2026", hercon: "\u22B9", Hfr: "\u210C", hfr: "\u{1D525}", HilbertSpace: "\u210B", hksearow: "\u2925", hkswarow: "\u2926", hoarr: "\u21FF", homtht: "\u223B", hookleftarrow: "\u21A9", hookrightarrow: "\u21AA", Hopf: "\u210D", hopf: "\u{1D559}", horbar: "\u2015", HorizontalLine: "\u2500", Hscr: "\u210B", hscr: "\u{1D4BD}", hslash: "\u210F", Hstrok: "\u0126", hstrok: "\u0127", HumpDownHump: "\u224E", HumpEqual: "\u224F", hybull: "\u2043", hyphen: "\u2010", Iacute: "\xCD", iacute: "\xED", ic: "\u2063", Icirc: "\xCE", icirc: "\xEE", Icy: "\u0418", icy: "\u0438", Idot: "\u0130", IEcy: "\u0415", iecy: "\u0435", iexcl: "\xA1", iff: "\u21D4", Ifr: "\u2111", ifr: "\u{1D526}", Igrave: "\xCC", igrave: "\xEC", ii: "\u2148", iiiint: "\u2A0C", iiint: "\u222D", iinfin: "\u29DC", iiota: "\u2129", IJlig: "\u0132", ijlig: "\u0133", Im: "\u2111", Imacr: "\u012A", imacr: "\u012B", image: "\u2111", ImaginaryI: "\u2148", imagline: "\u2110", imagpart: "\u2111", imath: "\u0131", imof: "\u22B7", imped: "\u01B5", Implies: "\u21D2", in: "\u2208", incare: "\u2105", infin: "\u221E", infintie: "\u29DD", inodot: "\u0131", Int: "\u222C", int: "\u222B", intcal: "\u22BA", integers: "\u2124", Integral: "\u222B", intercal: "\u22BA", Intersection: "\u22C2", intlarhk: "\u2A17", intprod: "\u2A3C", InvisibleComma: "\u2063", InvisibleTimes: "\u2062", IOcy: "\u0401", iocy: "\u0451", Iogon: "\u012E", iogon: "\u012F", Iopf: "\u{1D540}", iopf: "\u{1D55A}", Iota: "\u0399", iota: "\u03B9", iprod: "\u2A3C", iquest: "\xBF", Iscr: "\u2110", iscr: "\u{1D4BE}", isin: "\u2208", isindot: "\u22F5", isinE: "\u22F9", isins: "\u22F4", isinsv: "\u22F3", isinv: "\u2208", it: "\u2062", Itilde: "\u0128", itilde: "\u0129", Iukcy: "\u0406", iukcy: "\u0456", Iuml: "\xCF", iuml: "\xEF", Jcirc: "\u0134", jcirc: "\u0135", Jcy: "\u0419", jcy: "\u0439", Jfr: "\u{1D50D}", jfr: "\u{1D527}", jmath: "\u0237", Jopf: "\u{1D541}", jopf: "\u{1D55B}", Jscr: "\u{1D4A5}", jscr: "\u{1D4BF}", Jsercy: "\u0408", jsercy: "\u0458", Jukcy: "\u0404", jukcy: "\u0454", Kappa: "\u039A", kappa: "\u03BA", kappav: "\u03F0", Kcedil: "\u0136", kcedil: "\u0137", Kcy: "\u041A", kcy: "\u043A", Kfr: "\u{1D50E}", kfr: "\u{1D528}", kgreen: "\u0138", KHcy: "\u0425", khcy: "\u0445", KJcy: "\u040C", kjcy: "\u045C", Kopf: "\u{1D542}", kopf: "\u{1D55C}", Kscr: "\u{1D4A6}", kscr: "\u{1D4C0}", lAarr: "\u21DA", Lacute: "\u0139", lacute: "\u013A", laemptyv: "\u29B4", lagran: "\u2112", Lambda: "\u039B", lambda: "\u03BB", Lang: "\u27EA", lang: "\u27E8", langd: "\u2991", langle: "\u27E8", lap: "\u2A85", Laplacetrf: "\u2112", laquo: "\xAB", Larr: "\u219E", lArr: "\u21D0", larr: "\u2190", larrb: "\u21E4", larrbfs: "\u291F", larrfs: "\u291D", larrhk: "\u21A9", larrlp: "\u21AB", larrpl: "\u2939", larrsim: "\u2973", larrtl: "\u21A2", lat: "\u2AAB", lAtail: "\u291B", latail: "\u2919", late: "\u2AAD", lates: "\u2AAD\uFE00", lBarr: "\u290E", lbarr: "\u290C", lbbrk: "\u2772", lbrace: "{", lbrack: "[", lbrke: "\u298B", lbrksld: "\u298F", lbrkslu: "\u298D", Lcaron: "\u013D", lcaron: "\u013E", Lcedil: "\u013B", lcedil: "\u013C", lceil: "\u2308", lcub: "{", Lcy: "\u041B", lcy: "\u043B", ldca: "\u2936", ldquo: "\u201C", ldquor: "\u201E", ldrdhar: "\u2967", ldrushar: "\u294B", ldsh: "\u21B2", lE: "\u2266", le: "\u2264", LeftAngleBracket: "\u27E8", LeftArrow: "\u2190", Leftarrow: "\u21D0", leftarrow: "\u2190", LeftArrowBar: "\u21E4", LeftArrowRightArrow: "\u21C6", leftarrowtail: "\u21A2", LeftCeiling: "\u2308", LeftDoubleBracket: "\u27E6", LeftDownTeeVector: "\u2961", LeftDownVector: "\u21C3", LeftDownVectorBar: "\u2959", LeftFloor: "\u230A", leftharpoondown: "\u21BD", leftharpoonup: "\u21BC", leftleftarrows: "\u21C7", LeftRightArrow: "\u2194", Leftrightarrow: "\u21D4", leftrightarrow: "\u2194", leftrightarrows: "\u21C6", leftrightharpoons: "\u21CB", leftrightsquigarrow: "\u21AD", LeftRightVector: "\u294E", LeftTee: "\u22A3", LeftTeeArrow: "\u21A4", LeftTeeVector: "\u295A", leftthreetimes: "\u22CB", LeftTriangle: "\u22B2", LeftTriangleBar: "\u29CF", LeftTriangleEqual: "\u22B4", LeftUpDownVector: "\u2951", LeftUpTeeVector: "\u2960", LeftUpVector: "\u21BF", LeftUpVectorBar: "\u2958", LeftVector: "\u21BC", LeftVectorBar: "\u2952", lEg: "\u2A8B", leg: "\u22DA", leq: "\u2264", leqq: "\u2266", leqslant: "\u2A7D", les: "\u2A7D", lescc: "\u2AA8", lesdot: "\u2A7F", lesdoto: "\u2A81", lesdotor: "\u2A83", lesg: "\u22DA\uFE00", lesges: "\u2A93", lessapprox: "\u2A85", lessdot: "\u22D6", lesseqgtr: "\u22DA", lesseqqgtr: "\u2A8B", LessEqualGreater: "\u22DA", LessFullEqual: "\u2266", LessGreater: "\u2276", lessgtr: "\u2276", LessLess: "\u2AA1", lesssim: "\u2272", LessSlantEqual: "\u2A7D", LessTilde: "\u2272", lfisht: "\u297C", lfloor: "\u230A", Lfr: "\u{1D50F}", lfr: "\u{1D529}", lg: "\u2276", lgE: "\u2A91", lHar: "\u2962", lhard: "\u21BD", lharu: "\u21BC", lharul: "\u296A", lhblk: "\u2584", LJcy: "\u0409", ljcy: "\u0459", Ll: "\u22D8", ll: "\u226A", llarr: "\u21C7", llcorner: "\u231E", Lleftarrow: "\u21DA", llhard: "\u296B", lltri: "\u25FA", Lmidot: "\u013F", lmidot: "\u0140", lmoust: "\u23B0", lmoustache: "\u23B0", lnap: "\u2A89", lnapprox: "\u2A89", lnE: "\u2268", lne: "\u2A87", lneq: "\u2A87", lneqq: "\u2268", lnsim: "\u22E6", loang: "\u27EC", loarr: "\u21FD", lobrk: "\u27E6", LongLeftArrow: "\u27F5", Longleftarrow: "\u27F8", longleftarrow: "\u27F5", LongLeftRightArrow: "\u27F7", Longleftrightarrow: "\u27FA", longleftrightarrow: "\u27F7", longmapsto: "\u27FC", LongRightArrow: "\u27F6", Longrightarrow: "\u27F9", longrightarrow: "\u27F6", looparrowleft: "\u21AB", looparrowright: "\u21AC", lopar: "\u2985", Lopf: "\u{1D543}", lopf: "\u{1D55D}", loplus: "\u2A2D", lotimes: "\u2A34", lowast: "\u2217", lowbar: "_", LowerLeftArrow: "\u2199", LowerRightArrow: "\u2198", loz: "\u25CA", lozenge: "\u25CA", lozf: "\u29EB", lpar: "(", lparlt: "\u2993", lrarr: "\u21C6", lrcorner: "\u231F", lrhar: "\u21CB", lrhard: "\u296D", lrm: "\u200E", lrtri: "\u22BF", lsaquo: "\u2039", Lscr: "\u2112", lscr: "\u{1D4C1}", Lsh: "\u21B0", lsh: "\u21B0", lsim: "\u2272", lsime: "\u2A8D", lsimg: "\u2A8F", lsqb: "[", lsquo: "\u2018", lsquor: "\u201A", Lstrok: "\u0141", lstrok: "\u0142", LT: "<", Lt: "\u226A", lt: "<", ltcc: "\u2AA6", ltcir: "\u2A79", ltdot: "\u22D6", lthree: "\u22CB", ltimes: "\u22C9", ltlarr: "\u2976", ltquest: "\u2A7B", ltri: "\u25C3", ltrie: "\u22B4", ltrif: "\u25C2", ltrPar: "\u2996", lurdshar: "\u294A", luruhar: "\u2966", lvertneqq: "\u2268\uFE00", lvnE: "\u2268\uFE00", macr: "\xAF", male: "\u2642", malt: "\u2720", maltese: "\u2720", Map: "\u2905", map: "\u21A6", mapsto: "\u21A6", mapstodown: "\u21A7", mapstoleft: "\u21A4", mapstoup: "\u21A5", marker: "\u25AE", mcomma: "\u2A29", Mcy: "\u041C", mcy: "\u043C", mdash: "\u2014", mDDot: "\u223A", measuredangle: "\u2221", MediumSpace: "\u205F", Mellintrf: "\u2133", Mfr: "\u{1D510}", mfr: "\u{1D52A}", mho: "\u2127", micro: "\xB5", mid: "\u2223", midast: "*", midcir: "\u2AF0", middot: "\xB7", minus: "\u2212", minusb: "\u229F", minusd: "\u2238", minusdu: "\u2A2A", MinusPlus: "\u2213", mlcp: "\u2ADB", mldr: "\u2026", mnplus: "\u2213", models: "\u22A7", Mopf: "\u{1D544}", mopf: "\u{1D55E}", mp: "\u2213", Mscr: "\u2133", mscr: "\u{1D4C2}", mstpos: "\u223E", Mu: "\u039C", mu: "\u03BC", multimap: "\u22B8", mumap: "\u22B8", nabla: "\u2207", Nacute: "\u0143", nacute: "\u0144", nang: "\u2220\u20D2", nap: "\u2249", napE: "\u2A70\u0338", napid: "\u224B\u0338", napos: "\u0149", napprox: "\u2249", natur: "\u266E", natural: "\u266E", naturals: "\u2115", nbsp: "\xA0", nbump: "\u224E\u0338", nbumpe: "\u224F\u0338", ncap: "\u2A43", Ncaron: "\u0147", ncaron: "\u0148", Ncedil: "\u0145", ncedil: "\u0146", ncong: "\u2247", ncongdot: "\u2A6D\u0338", ncup: "\u2A42", Ncy: "\u041D", ncy: "\u043D", ndash: "\u2013", ne: "\u2260", nearhk: "\u2924", neArr: "\u21D7", nearr: "\u2197", nearrow: "\u2197", nedot: "\u2250\u0338", NegativeMediumSpace: "\u200B", NegativeThickSpace: "\u200B", NegativeThinSpace: "\u200B", NegativeVeryThinSpace: "\u200B", nequiv: "\u2262", nesear: "\u2928", nesim: "\u2242\u0338", NestedGreaterGreater: "\u226B", NestedLessLess: "\u226A", NewLine: `
`, nexist: "\u2204", nexists: "\u2204", Nfr: "\u{1D511}", nfr: "\u{1D52B}", ngE: "\u2267\u0338", nge: "\u2271", ngeq: "\u2271", ngeqq: "\u2267\u0338", ngeqslant: "\u2A7E\u0338", nges: "\u2A7E\u0338", nGg: "\u22D9\u0338", ngsim: "\u2275", nGt: "\u226B\u20D2", ngt: "\u226F", ngtr: "\u226F", nGtv: "\u226B\u0338", nhArr: "\u21CE", nharr: "\u21AE", nhpar: "\u2AF2", ni: "\u220B", nis: "\u22FC", nisd: "\u22FA", niv: "\u220B", NJcy: "\u040A", njcy: "\u045A", nlArr: "\u21CD", nlarr: "\u219A", nldr: "\u2025", nlE: "\u2266\u0338", nle: "\u2270", nLeftarrow: "\u21CD", nleftarrow: "\u219A", nLeftrightarrow: "\u21CE", nleftrightarrow: "\u21AE", nleq: "\u2270", nleqq: "\u2266\u0338", nleqslant: "\u2A7D\u0338", nles: "\u2A7D\u0338", nless: "\u226E", nLl: "\u22D8\u0338", nlsim: "\u2274", nLt: "\u226A\u20D2", nlt: "\u226E", nltri: "\u22EA", nltrie: "\u22EC", nLtv: "\u226A\u0338", nmid: "\u2224", NoBreak: "\u2060", NonBreakingSpace: "\xA0", Nopf: "\u2115", nopf: "\u{1D55F}", Not: "\u2AEC", not: "\xAC", NotCongruent: "\u2262", NotCupCap: "\u226D", NotDoubleVerticalBar: "\u2226", NotElement: "\u2209", NotEqual: "\u2260", NotEqualTilde: "\u2242\u0338", NotExists: "\u2204", NotGreater: "\u226F", NotGreaterEqual: "\u2271", NotGreaterFullEqual: "\u2267\u0338", NotGreaterGreater: "\u226B\u0338", NotGreaterLess: "\u2279", NotGreaterSlantEqual: "\u2A7E\u0338", NotGreaterTilde: "\u2275", NotHumpDownHump: "\u224E\u0338", NotHumpEqual: "\u224F\u0338", notin: "\u2209", notindot: "\u22F5\u0338", notinE: "\u22F9\u0338", notinva: "\u2209", notinvb: "\u22F7", notinvc: "\u22F6", NotLeftTriangle: "\u22EA", NotLeftTriangleBar: "\u29CF\u0338", NotLeftTriangleEqual: "\u22EC", NotLess: "\u226E", NotLessEqual: "\u2270", NotLessGreater: "\u2278", NotLessLess: "\u226A\u0338", NotLessSlantEqual: "\u2A7D\u0338", NotLessTilde: "\u2274", NotNestedGreaterGreater: "\u2AA2\u0338", NotNestedLessLess: "\u2AA1\u0338", notni: "\u220C", notniva: "\u220C", notnivb: "\u22FE", notnivc: "\u22FD", NotPrecedes: "\u2280", NotPrecedesEqual: "\u2AAF\u0338", NotPrecedesSlantEqual: "\u22E0", NotReverseElement: "\u220C", NotRightTriangle: "\u22EB", NotRightTriangleBar: "\u29D0\u0338", NotRightTriangleEqual: "\u22ED", NotSquareSubset: "\u228F\u0338", NotSquareSubsetEqual: "\u22E2", NotSquareSuperset: "\u2290\u0338", NotSquareSupersetEqual: "\u22E3", NotSubset: "\u2282\u20D2", NotSubsetEqual: "\u2288", NotSucceeds: "\u2281", NotSucceedsEqual: "\u2AB0\u0338", NotSucceedsSlantEqual: "\u22E1", NotSucceedsTilde: "\u227F\u0338", NotSuperset: "\u2283\u20D2", NotSupersetEqual: "\u2289", NotTilde: "\u2241", NotTildeEqual: "\u2244", NotTildeFullEqual: "\u2247", NotTildeTilde: "\u2249", NotVerticalBar: "\u2224", npar: "\u2226", nparallel: "\u2226", nparsl: "\u2AFD\u20E5", npart: "\u2202\u0338", npolint: "\u2A14", npr: "\u2280", nprcue: "\u22E0", npre: "\u2AAF\u0338", nprec: "\u2280", npreceq: "\u2AAF\u0338", nrArr: "\u21CF", nrarr: "\u219B", nrarrc: "\u2933\u0338", nrarrw: "\u219D\u0338", nRightarrow: "\u21CF", nrightarrow: "\u219B", nrtri: "\u22EB", nrtrie: "\u22ED", nsc: "\u2281", nsccue: "\u22E1", nsce: "\u2AB0\u0338", Nscr: "\u{1D4A9}", nscr: "\u{1D4C3}", nshortmid: "\u2224", nshortparallel: "\u2226", nsim: "\u2241", nsime: "\u2244", nsimeq: "\u2244", nsmid: "\u2224", nspar: "\u2226", nsqsube: "\u22E2", nsqsupe: "\u22E3", nsub: "\u2284", nsubE: "\u2AC5\u0338", nsube: "\u2288", nsubset: "\u2282\u20D2", nsubseteq: "\u2288", nsubseteqq: "\u2AC5\u0338", nsucc: "\u2281", nsucceq: "\u2AB0\u0338", nsup: "\u2285", nsupE: "\u2AC6\u0338", nsupe: "\u2289", nsupset: "\u2283\u20D2", nsupseteq: "\u2289", nsupseteqq: "\u2AC6\u0338", ntgl: "\u2279", Ntilde: "\xD1", ntilde: "\xF1", ntlg: "\u2278", ntriangleleft: "\u22EA", ntrianglelefteq: "\u22EC", ntriangleright: "\u22EB", ntrianglerighteq: "\u22ED", Nu: "\u039D", nu: "\u03BD", num: "#", numero: "\u2116", numsp: "\u2007", nvap: "\u224D\u20D2", nVDash: "\u22AF", nVdash: "\u22AE", nvDash: "\u22AD", nvdash: "\u22AC", nvge: "\u2265\u20D2", nvgt: ">\u20D2", nvHarr: "\u2904", nvinfin: "\u29DE", nvlArr: "\u2902", nvle: "\u2264\u20D2", nvlt: "<\u20D2", nvltrie: "\u22B4\u20D2", nvrArr: "\u2903", nvrtrie: "\u22B5\u20D2", nvsim: "\u223C\u20D2", nwarhk: "\u2923", nwArr: "\u21D6", nwarr: "\u2196", nwarrow: "\u2196", nwnear: "\u2927", Oacute: "\xD3", oacute: "\xF3", oast: "\u229B", ocir: "\u229A", Ocirc: "\xD4", ocirc: "\xF4", Ocy: "\u041E", ocy: "\u043E", odash: "\u229D", Odblac: "\u0150", odblac: "\u0151", odiv: "\u2A38", odot: "\u2299", odsold: "\u29BC", OElig: "\u0152", oelig: "\u0153", ofcir: "\u29BF", Ofr: "\u{1D512}", ofr: "\u{1D52C}", ogon: "\u02DB", Ograve: "\xD2", ograve: "\xF2", ogt: "\u29C1", ohbar: "\u29B5", ohm: "\u03A9", oint: "\u222E", olarr: "\u21BA", olcir: "\u29BE", olcross: "\u29BB", oline: "\u203E", olt: "\u29C0", Omacr: "\u014C", omacr: "\u014D", Omega: "\u03A9", omega: "\u03C9", Omicron: "\u039F", omicron: "\u03BF", omid: "\u29B6", ominus: "\u2296", Oopf: "\u{1D546}", oopf: "\u{1D560}", opar: "\u29B7", OpenCurlyDoubleQuote: "\u201C", OpenCurlyQuote: "\u2018", operp: "\u29B9", oplus: "\u2295", Or: "\u2A54", or: "\u2228", orarr: "\u21BB", ord: "\u2A5D", order: "\u2134", orderof: "\u2134", ordf: "\xAA", ordm: "\xBA", origof: "\u22B6", oror: "\u2A56", orslope: "\u2A57", orv: "\u2A5B", oS: "\u24C8", Oscr: "\u{1D4AA}", oscr: "\u2134", Oslash: "\xD8", oslash: "\xF8", osol: "\u2298", Otilde: "\xD5", otilde: "\xF5", Otimes: "\u2A37", otimes: "\u2297", otimesas: "\u2A36", Ouml: "\xD6", ouml: "\xF6", ovbar: "\u233D", OverBar: "\u203E", OverBrace: "\u23DE", OverBracket: "\u23B4", OverParenthesis: "\u23DC", par: "\u2225", para: "\xB6", parallel: "\u2225", parsim: "\u2AF3", parsl: "\u2AFD", part: "\u2202", PartialD: "\u2202", Pcy: "\u041F", pcy: "\u043F", percnt: "%", period: ".", permil: "\u2030", perp: "\u22A5", pertenk: "\u2031", Pfr: "\u{1D513}", pfr: "\u{1D52D}", Phi: "\u03A6", phi: "\u03C6", phiv: "\u03D5", phmmat: "\u2133", phone: "\u260E", Pi: "\u03A0", pi: "\u03C0", pitchfork: "\u22D4", piv: "\u03D6", planck: "\u210F", planckh: "\u210E", plankv: "\u210F", plus: "+", plusacir: "\u2A23", plusb: "\u229E", pluscir: "\u2A22", plusdo: "\u2214", plusdu: "\u2A25", pluse: "\u2A72", PlusMinus: "\xB1", plusmn: "\xB1", plussim: "\u2A26", plustwo: "\u2A27", pm: "\xB1", Poincareplane: "\u210C", pointint: "\u2A15", Popf: "\u2119", popf: "\u{1D561}", pound: "\xA3", Pr: "\u2ABB", pr: "\u227A", prap: "\u2AB7", prcue: "\u227C", prE: "\u2AB3", pre: "\u2AAF", prec: "\u227A", precapprox: "\u2AB7", preccurlyeq: "\u227C", Precedes: "\u227A", PrecedesEqual: "\u2AAF", PrecedesSlantEqual: "\u227C", PrecedesTilde: "\u227E", preceq: "\u2AAF", precnapprox: "\u2AB9", precneqq: "\u2AB5", precnsim: "\u22E8", precsim: "\u227E", Prime: "\u2033", prime: "\u2032", primes: "\u2119", prnap: "\u2AB9", prnE: "\u2AB5", prnsim: "\u22E8", prod: "\u220F", Product: "\u220F", profalar: "\u232E", profline: "\u2312", profsurf: "\u2313", prop: "\u221D", Proportion: "\u2237", Proportional: "\u221D", propto: "\u221D", prsim: "\u227E", prurel: "\u22B0", Pscr: "\u{1D4AB}", pscr: "\u{1D4C5}", Psi: "\u03A8", psi: "\u03C8", puncsp: "\u2008", Qfr: "\u{1D514}", qfr: "\u{1D52E}", qint: "\u2A0C", Qopf: "\u211A", qopf: "\u{1D562}", qprime: "\u2057", Qscr: "\u{1D4AC}", qscr: "\u{1D4C6}", quaternions: "\u210D", quatint: "\u2A16", quest: "?", questeq: "\u225F", QUOT: '"', quot: '"', rAarr: "\u21DB", race: "\u223D\u0331", Racute: "\u0154", racute: "\u0155", radic: "\u221A", raemptyv: "\u29B3", Rang: "\u27EB", rang: "\u27E9", rangd: "\u2992", range: "\u29A5", rangle: "\u27E9", raquo: "\xBB", Rarr: "\u21A0", rArr: "\u21D2", rarr: "\u2192", rarrap: "\u2975", rarrb: "\u21E5", rarrbfs: "\u2920", rarrc: "\u2933", rarrfs: "\u291E", rarrhk: "\u21AA", rarrlp: "\u21AC", rarrpl: "\u2945", rarrsim: "\u2974", Rarrtl: "\u2916", rarrtl: "\u21A3", rarrw: "\u219D", rAtail: "\u291C", ratail: "\u291A", ratio: "\u2236", rationals: "\u211A", RBarr: "\u2910", rBarr: "\u290F", rbarr: "\u290D", rbbrk: "\u2773", rbrace: "}", rbrack: "]", rbrke: "\u298C", rbrksld: "\u298E", rbrkslu: "\u2990", Rcaron: "\u0158", rcaron: "\u0159", Rcedil: "\u0156", rcedil: "\u0157", rceil: "\u2309", rcub: "}", Rcy: "\u0420", rcy: "\u0440", rdca: "\u2937", rdldhar: "\u2969", rdquo: "\u201D", rdquor: "\u201D", rdsh: "\u21B3", Re: "\u211C", real: "\u211C", realine: "\u211B", realpart: "\u211C", reals: "\u211D", rect: "\u25AD", REG: "\xAE", reg: "\xAE", ReverseElement: "\u220B", ReverseEquilibrium: "\u21CB", ReverseUpEquilibrium: "\u296F", rfisht: "\u297D", rfloor: "\u230B", Rfr: "\u211C", rfr: "\u{1D52F}", rHar: "\u2964", rhard: "\u21C1", rharu: "\u21C0", rharul: "\u296C", Rho: "\u03A1", rho: "\u03C1", rhov: "\u03F1", RightAngleBracket: "\u27E9", RightArrow: "\u2192", Rightarrow: "\u21D2", rightarrow: "\u2192", RightArrowBar: "\u21E5", RightArrowLeftArrow: "\u21C4", rightarrowtail: "\u21A3", RightCeiling: "\u2309", RightDoubleBracket: "\u27E7", RightDownTeeVector: "\u295D", RightDownVector: "\u21C2", RightDownVectorBar: "\u2955", RightFloor: "\u230B", rightharpoondown: "\u21C1", rightharpoonup: "\u21C0", rightleftarrows: "\u21C4", rightleftharpoons: "\u21CC", rightrightarrows: "\u21C9", rightsquigarrow: "\u219D", RightTee: "\u22A2", RightTeeArrow: "\u21A6", RightTeeVector: "\u295B", rightthreetimes: "\u22CC", RightTriangle: "\u22B3", RightTriangleBar: "\u29D0", RightTriangleEqual: "\u22B5", RightUpDownVector: "\u294F", RightUpTeeVector: "\u295C", RightUpVector: "\u21BE", RightUpVectorBar: "\u2954", RightVector: "\u21C0", RightVectorBar: "\u2953", ring: "\u02DA", risingdotseq: "\u2253", rlarr: "\u21C4", rlhar: "\u21CC", rlm: "\u200F", rmoust: "\u23B1", rmoustache: "\u23B1", rnmid: "\u2AEE", roang: "\u27ED", roarr: "\u21FE", robrk: "\u27E7", ropar: "\u2986", Ropf: "\u211D", ropf: "\u{1D563}", roplus: "\u2A2E", rotimes: "\u2A35", RoundImplies: "\u2970", rpar: ")", rpargt: "\u2994", rppolint: "\u2A12", rrarr: "\u21C9", Rrightarrow: "\u21DB", rsaquo: "\u203A", Rscr: "\u211B", rscr: "\u{1D4C7}", Rsh: "\u21B1", rsh: "\u21B1", rsqb: "]", rsquo: "\u2019", rsquor: "\u2019", rthree: "\u22CC", rtimes: "\u22CA", rtri: "\u25B9", rtrie: "\u22B5", rtrif: "\u25B8", rtriltri: "\u29CE", RuleDelayed: "\u29F4", ruluhar: "\u2968", rx: "\u211E", Sacute: "\u015A", sacute: "\u015B", sbquo: "\u201A", Sc: "\u2ABC", sc: "\u227B", scap: "\u2AB8", Scaron: "\u0160", scaron: "\u0161", sccue: "\u227D", scE: "\u2AB4", sce: "\u2AB0", Scedil: "\u015E", scedil: "\u015F", Scirc: "\u015C", scirc: "\u015D", scnap: "\u2ABA", scnE: "\u2AB6", scnsim: "\u22E9", scpolint: "\u2A13", scsim: "\u227F", Scy: "\u0421", scy: "\u0441", sdot: "\u22C5", sdotb: "\u22A1", sdote: "\u2A66", searhk: "\u2925", seArr: "\u21D8", searr: "\u2198", searrow: "\u2198", sect: "\xA7", semi: ";", seswar: "\u2929", setminus: "\u2216", setmn: "\u2216", sext: "\u2736", Sfr: "\u{1D516}", sfr: "\u{1D530}", sfrown: "\u2322", sharp: "\u266F", SHCHcy: "\u0429", shchcy: "\u0449", SHcy: "\u0428", shcy: "\u0448", ShortDownArrow: "\u2193", ShortLeftArrow: "\u2190", shortmid: "\u2223", shortparallel: "\u2225", ShortRightArrow: "\u2192", ShortUpArrow: "\u2191", shy: "\xAD", Sigma: "\u03A3", sigma: "\u03C3", sigmaf: "\u03C2", sigmav: "\u03C2", sim: "\u223C", simdot: "\u2A6A", sime: "\u2243", simeq: "\u2243", simg: "\u2A9E", simgE: "\u2AA0", siml: "\u2A9D", simlE: "\u2A9F", simne: "\u2246", simplus: "\u2A24", simrarr: "\u2972", slarr: "\u2190", SmallCircle: "\u2218", smallsetminus: "\u2216", smashp: "\u2A33", smeparsl: "\u29E4", smid: "\u2223", smile: "\u2323", smt: "\u2AAA", smte: "\u2AAC", smtes: "\u2AAC\uFE00", SOFTcy: "\u042C", softcy: "\u044C", sol: "/", solb: "\u29C4", solbar: "\u233F", Sopf: "\u{1D54A}", sopf: "\u{1D564}", spades: "\u2660", spadesuit: "\u2660", spar: "\u2225", sqcap: "\u2293", sqcaps: "\u2293\uFE00", sqcup: "\u2294", sqcups: "\u2294\uFE00", Sqrt: "\u221A", sqsub: "\u228F", sqsube: "\u2291", sqsubset: "\u228F", sqsubseteq: "\u2291", sqsup: "\u2290", sqsupe: "\u2292", sqsupset: "\u2290", sqsupseteq: "\u2292", squ: "\u25A1", Square: "\u25A1", square: "\u25A1", SquareIntersection: "\u2293", SquareSubset: "\u228F", SquareSubsetEqual: "\u2291", SquareSuperset: "\u2290", SquareSupersetEqual: "\u2292", SquareUnion: "\u2294", squarf: "\u25AA", squf: "\u25AA", srarr: "\u2192", Sscr: "\u{1D4AE}", sscr: "\u{1D4C8}", ssetmn: "\u2216", ssmile: "\u2323", sstarf: "\u22C6", Star: "\u22C6", star: "\u2606", starf: "\u2605", straightepsilon: "\u03F5", straightphi: "\u03D5", strns: "\xAF", Sub: "\u22D0", sub: "\u2282", subdot: "\u2ABD", subE: "\u2AC5", sube: "\u2286", subedot: "\u2AC3", submult: "\u2AC1", subnE: "\u2ACB", subne: "\u228A", subplus: "\u2ABF", subrarr: "\u2979", Subset: "\u22D0", subset: "\u2282", subseteq: "\u2286", subseteqq: "\u2AC5", SubsetEqual: "\u2286", subsetneq: "\u228A", subsetneqq: "\u2ACB", subsim: "\u2AC7", subsub: "\u2AD5", subsup: "\u2AD3", succ: "\u227B", succapprox: "\u2AB8", succcurlyeq: "\u227D", Succeeds: "\u227B", SucceedsEqual: "\u2AB0", SucceedsSlantEqual: "\u227D", SucceedsTilde: "\u227F", succeq: "\u2AB0", succnapprox: "\u2ABA", succneqq: "\u2AB6", succnsim: "\u22E9", succsim: "\u227F", SuchThat: "\u220B", Sum: "\u2211", sum: "\u2211", sung: "\u266A", Sup: "\u22D1", sup: "\u2283", sup1: "\xB9", sup2: "\xB2", sup3: "\xB3", supdot: "\u2ABE", supdsub: "\u2AD8", supE: "\u2AC6", supe: "\u2287", supedot: "\u2AC4", Superset: "\u2283", SupersetEqual: "\u2287", suphsol: "\u27C9", suphsub: "\u2AD7", suplarr: "\u297B", supmult: "\u2AC2", supnE: "\u2ACC", supne: "\u228B", supplus: "\u2AC0", Supset: "\u22D1", supset: "\u2283", supseteq: "\u2287", supseteqq: "\u2AC6", supsetneq: "\u228B", supsetneqq: "\u2ACC", supsim: "\u2AC8", supsub: "\u2AD4", supsup: "\u2AD6", swarhk: "\u2926", swArr: "\u21D9", swarr: "\u2199", swarrow: "\u2199", swnwar: "\u292A", szlig: "\xDF", Tab: "	", target: "\u2316", Tau: "\u03A4", tau: "\u03C4", tbrk: "\u23B4", Tcaron: "\u0164", tcaron: "\u0165", Tcedil: "\u0162", tcedil: "\u0163", Tcy: "\u0422", tcy: "\u0442", tdot: "\u20DB", telrec: "\u2315", Tfr: "\u{1D517}", tfr: "\u{1D531}", there4: "\u2234", Therefore: "\u2234", therefore: "\u2234", Theta: "\u0398", theta: "\u03B8", thetasym: "\u03D1", thetav: "\u03D1", thickapprox: "\u2248", thicksim: "\u223C", ThickSpace: "\u205F\u200A", thinsp: "\u2009", ThinSpace: "\u2009", thkap: "\u2248", thksim: "\u223C", THORN: "\xDE", thorn: "\xFE", Tilde: "\u223C", tilde: "\u02DC", TildeEqual: "\u2243", TildeFullEqual: "\u2245", TildeTilde: "\u2248", times: "\xD7", timesb: "\u22A0", timesbar: "\u2A31", timesd: "\u2A30", tint: "\u222D", toea: "\u2928", top: "\u22A4", topbot: "\u2336", topcir: "\u2AF1", Topf: "\u{1D54B}", topf: "\u{1D565}", topfork: "\u2ADA", tosa: "\u2929", tprime: "\u2034", TRADE: "\u2122", trade: "\u2122", triangle: "\u25B5", triangledown: "\u25BF", triangleleft: "\u25C3", trianglelefteq: "\u22B4", triangleq: "\u225C", triangleright: "\u25B9", trianglerighteq: "\u22B5", tridot: "\u25EC", trie: "\u225C", triminus: "\u2A3A", TripleDot: "\u20DB", triplus: "\u2A39", trisb: "\u29CD", tritime: "\u2A3B", trpezium: "\u23E2", Tscr: "\u{1D4AF}", tscr: "\u{1D4C9}", TScy: "\u0426", tscy: "\u0446", TSHcy: "\u040B", tshcy: "\u045B", Tstrok: "\u0166", tstrok: "\u0167", twixt: "\u226C", twoheadleftarrow: "\u219E", twoheadrightarrow: "\u21A0", Uacute: "\xDA", uacute: "\xFA", Uarr: "\u219F", uArr: "\u21D1", uarr: "\u2191", Uarrocir: "\u2949", Ubrcy: "\u040E", ubrcy: "\u045E", Ubreve: "\u016C", ubreve: "\u016D", Ucirc: "\xDB", ucirc: "\xFB", Ucy: "\u0423", ucy: "\u0443", udarr: "\u21C5", Udblac: "\u0170", udblac: "\u0171", udhar: "\u296E", ufisht: "\u297E", Ufr: "\u{1D518}", ufr: "\u{1D532}", Ugrave: "\xD9", ugrave: "\xF9", uHar: "\u2963", uharl: "\u21BF", uharr: "\u21BE", uhblk: "\u2580", ulcorn: "\u231C", ulcorner: "\u231C", ulcrop: "\u230F", ultri: "\u25F8", Umacr: "\u016A", umacr: "\u016B", uml: "\xA8", UnderBar: "_", UnderBrace: "\u23DF", UnderBracket: "\u23B5", UnderParenthesis: "\u23DD", Union: "\u22C3", UnionPlus: "\u228E", Uogon: "\u0172", uogon: "\u0173", Uopf: "\u{1D54C}", uopf: "\u{1D566}", UpArrow: "\u2191", Uparrow: "\u21D1", uparrow: "\u2191", UpArrowBar: "\u2912", UpArrowDownArrow: "\u21C5", UpDownArrow: "\u2195", Updownarrow: "\u21D5", updownarrow: "\u2195", UpEquilibrium: "\u296E", upharpoonleft: "\u21BF", upharpoonright: "\u21BE", uplus: "\u228E", UpperLeftArrow: "\u2196", UpperRightArrow: "\u2197", Upsi: "\u03D2", upsi: "\u03C5", upsih: "\u03D2", Upsilon: "\u03A5", upsilon: "\u03C5", UpTee: "\u22A5", UpTeeArrow: "\u21A5", upuparrows: "\u21C8", urcorn: "\u231D", urcorner: "\u231D", urcrop: "\u230E", Uring: "\u016E", uring: "\u016F", urtri: "\u25F9", Uscr: "\u{1D4B0}", uscr: "\u{1D4CA}", utdot: "\u22F0", Utilde: "\u0168", utilde: "\u0169", utri: "\u25B5", utrif: "\u25B4", uuarr: "\u21C8", Uuml: "\xDC", uuml: "\xFC", uwangle: "\u29A7", vangrt: "\u299C", varepsilon: "\u03F5", varkappa: "\u03F0", varnothing: "\u2205", varphi: "\u03D5", varpi: "\u03D6", varpropto: "\u221D", vArr: "\u21D5", varr: "\u2195", varrho: "\u03F1", varsigma: "\u03C2", varsubsetneq: "\u228A\uFE00", varsubsetneqq: "\u2ACB\uFE00", varsupsetneq: "\u228B\uFE00", varsupsetneqq: "\u2ACC\uFE00", vartheta: "\u03D1", vartriangleleft: "\u22B2", vartriangleright: "\u22B3", Vbar: "\u2AEB", vBar: "\u2AE8", vBarv: "\u2AE9", Vcy: "\u0412", vcy: "\u0432", VDash: "\u22AB", Vdash: "\u22A9", vDash: "\u22A8", vdash: "\u22A2", Vdashl: "\u2AE6", Vee: "\u22C1", vee: "\u2228", veebar: "\u22BB", veeeq: "\u225A", vellip: "\u22EE", Verbar: "\u2016", verbar: "|", Vert: "\u2016", vert: "|", VerticalBar: "\u2223", VerticalLine: "|", VerticalSeparator: "\u2758", VerticalTilde: "\u2240", VeryThinSpace: "\u200A", Vfr: "\u{1D519}", vfr: "\u{1D533}", vltri: "\u22B2", vnsub: "\u2282\u20D2", vnsup: "\u2283\u20D2", Vopf: "\u{1D54D}", vopf: "\u{1D567}", vprop: "\u221D", vrtri: "\u22B3", Vscr: "\u{1D4B1}", vscr: "\u{1D4CB}", vsubnE: "\u2ACB\uFE00", vsubne: "\u228A\uFE00", vsupnE: "\u2ACC\uFE00", vsupne: "\u228B\uFE00", Vvdash: "\u22AA", vzigzag: "\u299A", Wcirc: "\u0174", wcirc: "\u0175", wedbar: "\u2A5F", Wedge: "\u22C0", wedge: "\u2227", wedgeq: "\u2259", weierp: "\u2118", Wfr: "\u{1D51A}", wfr: "\u{1D534}", Wopf: "\u{1D54E}", wopf: "\u{1D568}", wp: "\u2118", wr: "\u2240", wreath: "\u2240", Wscr: "\u{1D4B2}", wscr: "\u{1D4CC}", xcap: "\u22C2", xcirc: "\u25EF", xcup: "\u22C3", xdtri: "\u25BD", Xfr: "\u{1D51B}", xfr: "\u{1D535}", xhArr: "\u27FA", xharr: "\u27F7", Xi: "\u039E", xi: "\u03BE", xlArr: "\u27F8", xlarr: "\u27F5", xmap: "\u27FC", xnis: "\u22FB", xodot: "\u2A00", Xopf: "\u{1D54F}", xopf: "\u{1D569}", xoplus: "\u2A01", xotime: "\u2A02", xrArr: "\u27F9", xrarr: "\u27F6", Xscr: "\u{1D4B3}", xscr: "\u{1D4CD}", xsqcup: "\u2A06", xuplus: "\u2A04", xutri: "\u25B3", xvee: "\u22C1", xwedge: "\u22C0", Yacute: "\xDD", yacute: "\xFD", YAcy: "\u042F", yacy: "\u044F", Ycirc: "\u0176", ycirc: "\u0177", Ycy: "\u042B", ycy: "\u044B", yen: "\xA5", Yfr: "\u{1D51C}", yfr: "\u{1D536}", YIcy: "\u0407", yicy: "\u0457", Yopf: "\u{1D550}", yopf: "\u{1D56A}", Yscr: "\u{1D4B4}", yscr: "\u{1D4CE}", YUcy: "\u042E", yucy: "\u044E", Yuml: "\u0178", yuml: "\xFF", Zacute: "\u0179", zacute: "\u017A", Zcaron: "\u017D", zcaron: "\u017E", Zcy: "\u0417", zcy: "\u0437", Zdot: "\u017B", zdot: "\u017C", zeetrf: "\u2128", ZeroWidthSpace: "\u200B", Zeta: "\u0396", zeta: "\u03B6", Zfr: "\u2128", zfr: "\u{1D537}", ZHcy: "\u0416", zhcy: "\u0436", zigrarr: "\u21DD", Zopf: "\u2124", zopf: "\u{1D56B}", Zscr: "\u{1D4B5}", zscr: "\u{1D4CF}", zwj: "\u200D", zwnj: "\u200C" }, e.NGSP_UNICODE = "\uE500", e.NAMED_ENTITIES.ngsp = e.NGSP_UNICODE;
          } }), _s = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_tags.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Ze(), t3 = class {
              constructor() {
                let { closedByChildren: a, implicitNamespacePrefix: p, contentType: D = r.TagContentType.PARSABLE_DATA, closedByParent: g = false, isVoid: i = false, ignoreFirstLf: l = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.closedByChildren = {}, this.closedByParent = false, this.canSelfClose = false, a && a.length > 0 && a.forEach((h) => this.closedByChildren[h] = true), this.isVoid = i, this.closedByParent = g || i, this.implicitNamespacePrefix = p || null, this.contentType = D, this.ignoreFirstLf = l;
              }
              isClosedByChild(a) {
                return this.isVoid || a.toLowerCase() in this.closedByChildren;
              }
            };
            e.HtmlTagDefinition = t3;
            var s, c;
            function n(a) {
              return c || (s = new t3(), c = { base: new t3({ isVoid: true }), meta: new t3({ isVoid: true }), area: new t3({ isVoid: true }), embed: new t3({ isVoid: true }), link: new t3({ isVoid: true }), img: new t3({ isVoid: true }), input: new t3({ isVoid: true }), param: new t3({ isVoid: true }), hr: new t3({ isVoid: true }), br: new t3({ isVoid: true }), source: new t3({ isVoid: true }), track: new t3({ isVoid: true }), wbr: new t3({ isVoid: true }), p: new t3({ closedByChildren: ["address", "article", "aside", "blockquote", "div", "dl", "fieldset", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "main", "nav", "ol", "p", "pre", "section", "table", "ul"], closedByParent: true }), thead: new t3({ closedByChildren: ["tbody", "tfoot"] }), tbody: new t3({ closedByChildren: ["tbody", "tfoot"], closedByParent: true }), tfoot: new t3({ closedByChildren: ["tbody"], closedByParent: true }), tr: new t3({ closedByChildren: ["tr"], closedByParent: true }), td: new t3({ closedByChildren: ["td", "th"], closedByParent: true }), th: new t3({ closedByChildren: ["td", "th"], closedByParent: true }), col: new t3({ isVoid: true }), svg: new t3({ implicitNamespacePrefix: "svg" }), math: new t3({ implicitNamespacePrefix: "math" }), li: new t3({ closedByChildren: ["li"], closedByParent: true }), dt: new t3({ closedByChildren: ["dt", "dd"] }), dd: new t3({ closedByChildren: ["dt", "dd"], closedByParent: true }), rb: new t3({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), rt: new t3({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), rtc: new t3({ closedByChildren: ["rb", "rtc", "rp"], closedByParent: true }), rp: new t3({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), optgroup: new t3({ closedByChildren: ["optgroup"], closedByParent: true }), option: new t3({ closedByChildren: ["option", "optgroup"], closedByParent: true }), pre: new t3({ ignoreFirstLf: true }), listing: new t3({ ignoreFirstLf: true }), style: new t3({ contentType: r.TagContentType.RAW_TEXT }), script: new t3({ contentType: r.TagContentType.RAW_TEXT }), title: new t3({ contentType: r.TagContentType.ESCAPABLE_RAW_TEXT }), textarea: new t3({ contentType: r.TagContentType.ESCAPABLE_RAW_TEXT, ignoreFirstLf: true }) }), c[a] || s;
            }
            e.getHtmlTagDefinition = n;
          } }), VD = I({ "node_modules/angular-html-parser/lib/compiler/src/ast_path.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = class {
              constructor(t3) {
                let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
                this.path = t3, this.position = s;
              }
              get empty() {
                return !this.path || !this.path.length;
              }
              get head() {
                return this.path[0];
              }
              get tail() {
                return this.path[this.path.length - 1];
              }
              parentOf(t3) {
                return t3 && this.path[this.path.indexOf(t3) - 1];
              }
              childOf(t3) {
                return this.path[this.path.indexOf(t3) + 1];
              }
              first(t3) {
                for (let s = this.path.length - 1; s >= 0; s--) {
                  let c = this.path[s];
                  if (c instanceof t3)
                    return c;
                }
              }
              push(t3) {
                this.path.push(t3);
              }
              pop() {
                return this.path.pop();
              }
            };
            e.AstPath = r;
          } }), Ss = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/ast.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = VD(), t3 = class {
              constructor(d, m, T) {
                this.value = d, this.sourceSpan = m, this.i18n = T, this.type = "text";
              }
              visit(d, m) {
                return d.visitText(this, m);
              }
            };
            e.Text = t3;
            var s = class {
              constructor(d, m) {
                this.value = d, this.sourceSpan = m, this.type = "cdata";
              }
              visit(d, m) {
                return d.visitCdata(this, m);
              }
            };
            e.CDATA = s;
            var c = class {
              constructor(d, m, T, B, A, N) {
                this.switchValue = d, this.type = m, this.cases = T, this.sourceSpan = B, this.switchValueSourceSpan = A, this.i18n = N;
              }
              visit(d, m) {
                return d.visitExpansion(this, m);
              }
            };
            e.Expansion = c;
            var n = class {
              constructor(d, m, T, B, A) {
                this.value = d, this.expression = m, this.sourceSpan = T, this.valueSourceSpan = B, this.expSourceSpan = A;
              }
              visit(d, m) {
                return d.visitExpansionCase(this, m);
              }
            };
            e.ExpansionCase = n;
            var a = class {
              constructor(d, m, T) {
                let B = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, N = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
                this.name = d, this.value = m, this.sourceSpan = T, this.valueSpan = B, this.nameSpan = A, this.i18n = N, this.type = "attribute";
              }
              visit(d, m) {
                return d.visitAttribute(this, m);
              }
            };
            e.Attribute = a;
            var p = class {
              constructor(d, m, T, B) {
                let A = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, N = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, R = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, $ = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
                this.name = d, this.attrs = m, this.children = T, this.sourceSpan = B, this.startSourceSpan = A, this.endSourceSpan = N, this.nameSpan = R, this.i18n = $, this.type = "element";
              }
              visit(d, m) {
                return d.visitElement(this, m);
              }
            };
            e.Element = p;
            var D = class {
              constructor(d, m) {
                this.value = d, this.sourceSpan = m, this.type = "comment";
              }
              visit(d, m) {
                return d.visitComment(this, m);
              }
            };
            e.Comment = D;
            var g = class {
              constructor(d, m) {
                this.value = d, this.sourceSpan = m, this.type = "docType";
              }
              visit(d, m) {
                return d.visitDocType(this, m);
              }
            };
            e.DocType = g;
            function i(d, m) {
              let T = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, B = [], A = d.visit ? (N) => d.visit(N, T) || N.visit(d, T) : (N) => N.visit(d, T);
              return m.forEach((N) => {
                let R = A(N);
                R && B.push(R);
              }), B;
            }
            e.visitAll = i;
            var l = class {
              constructor() {
              }
              visitElement(d, m) {
                this.visitChildren(m, (T) => {
                  T(d.attrs), T(d.children);
                });
              }
              visitAttribute(d, m) {
              }
              visitText(d, m) {
              }
              visitCdata(d, m) {
              }
              visitComment(d, m) {
              }
              visitDocType(d, m) {
              }
              visitExpansion(d, m) {
                return this.visitChildren(m, (T) => {
                  T(d.cases);
                });
              }
              visitExpansionCase(d, m) {
              }
              visitChildren(d, m) {
                let T = [], B = this;
                function A(N) {
                  N && T.push(i(B, N, d));
                }
                return m(A), Array.prototype.concat.apply([], T);
              }
            };
            e.RecursiveVisitor = l;
            function h(d) {
              let m = d.sourceSpan.start.offset, T = d.sourceSpan.end.offset;
              return d instanceof p && (d.endSourceSpan ? T = d.endSourceSpan.end.offset : d.children && d.children.length && (T = h(d.children[d.children.length - 1]).end)), { start: m, end: T };
            }
            function C(d, m) {
              let T = [], B = new class extends l {
                visit(A, N) {
                  let R = h(A);
                  if (R.start <= m && m < R.end)
                    T.push(A);
                  else
                    return true;
                }
              }();
              return i(B, d), new r.AstPath(T, m);
            }
            e.findNode = C;
          } }), XD = I({ "node_modules/angular-html-parser/lib/compiler/src/assertions.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            function r(c, n) {
              if (n != null) {
                if (!Array.isArray(n))
                  throw new Error("Expected '".concat(c, "' to be an array of strings."));
                for (let a = 0; a < n.length; a += 1)
                  if (typeof n[a] != "string")
                    throw new Error("Expected '".concat(c, "' to be an array of strings."));
              }
            }
            e.assertArrayOfStrings = r;
            var t3 = [/^\s*$/, /[<>]/, /^[{}]$/, /&(#|[a-z])/i, /^\/\//];
            function s(c, n) {
              if (n != null && !(Array.isArray(n) && n.length == 2))
                throw new Error("Expected '".concat(c, "' to be an array, [start, end]."));
              if (n != null) {
                let a = n[0], p = n[1];
                t3.forEach((D) => {
                  if (D.test(a) || D.test(p))
                    throw new Error("['".concat(a, "', '").concat(p, "'] contains unusable interpolation symbol."));
                });
              }
            }
            e.assertInterpolationSymbols = s;
          } }), HD = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/interpolation_config.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = XD(), t3 = class {
              constructor(s, c) {
                this.start = s, this.end = c;
              }
              static fromArray(s) {
                return s ? (r.assertInterpolationSymbols("interpolation", s), new t3(s[0], s[1])) : e.DEFAULT_INTERPOLATION_CONFIG;
              }
            };
            e.InterpolationConfig = t3, e.DEFAULT_INTERPOLATION_CONFIG = new t3("{{", "}}");
          } }), zD = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/lexer.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = hs(), t3 = Te(), s = HD(), c = Ze(), n;
            (function(u) {
              u[u.TAG_OPEN_START = 0] = "TAG_OPEN_START", u[u.TAG_OPEN_END = 1] = "TAG_OPEN_END", u[u.TAG_OPEN_END_VOID = 2] = "TAG_OPEN_END_VOID", u[u.TAG_CLOSE = 3] = "TAG_CLOSE", u[u.TEXT = 4] = "TEXT", u[u.ESCAPABLE_RAW_TEXT = 5] = "ESCAPABLE_RAW_TEXT", u[u.RAW_TEXT = 6] = "RAW_TEXT", u[u.COMMENT_START = 7] = "COMMENT_START", u[u.COMMENT_END = 8] = "COMMENT_END", u[u.CDATA_START = 9] = "CDATA_START", u[u.CDATA_END = 10] = "CDATA_END", u[u.ATTR_NAME = 11] = "ATTR_NAME", u[u.ATTR_QUOTE = 12] = "ATTR_QUOTE", u[u.ATTR_VALUE = 13] = "ATTR_VALUE", u[u.DOC_TYPE_START = 14] = "DOC_TYPE_START", u[u.DOC_TYPE_END = 15] = "DOC_TYPE_END", u[u.EXPANSION_FORM_START = 16] = "EXPANSION_FORM_START", u[u.EXPANSION_CASE_VALUE = 17] = "EXPANSION_CASE_VALUE", u[u.EXPANSION_CASE_EXP_START = 18] = "EXPANSION_CASE_EXP_START", u[u.EXPANSION_CASE_EXP_END = 19] = "EXPANSION_CASE_EXP_END", u[u.EXPANSION_FORM_END = 20] = "EXPANSION_FORM_END", u[u.EOF = 21] = "EOF";
            })(n = e.TokenType || (e.TokenType = {}));
            var a = class {
              constructor(u, o, E) {
                this.type = u, this.parts = o, this.sourceSpan = E;
              }
            };
            e.Token = a;
            var p = class extends t3.ParseError {
              constructor(u, o, E) {
                super(E, u), this.tokenType = o;
              }
            };
            e.TokenError = p;
            var D = class {
              constructor(u, o) {
                this.tokens = u, this.errors = o;
              }
            };
            e.TokenizeResult = D;
            function g(u, o, E) {
              let f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
              return new d(new t3.ParseSourceFile(u, o), E, f).tokenize();
            }
            e.tokenize = g;
            var i = /\r\n?/g;
            function l(u) {
              let o = u === r.$EOF ? "EOF" : String.fromCharCode(u);
              return 'Unexpected character "'.concat(o, '"');
            }
            function h(u) {
              return 'Unknown entity "'.concat(u, '" - use the "&#<decimal>;" or  "&#x<hex>;" syntax');
            }
            var C = class {
              constructor(u) {
                this.error = u;
              }
            }, d = class {
              constructor(u, o, E) {
                this._getTagContentType = o, this._currentTokenStart = null, this._currentTokenType = null, this._expansionCaseStack = [], this._inInterpolation = false, this._fullNameStack = [], this.tokens = [], this.errors = [], this._tokenizeIcu = E.tokenizeExpansionForms || false, this._interpolationConfig = E.interpolationConfig || s.DEFAULT_INTERPOLATION_CONFIG, this._leadingTriviaCodePoints = E.leadingTriviaChars && E.leadingTriviaChars.map((F) => F.codePointAt(0) || 0), this._canSelfClose = E.canSelfClose || false, this._allowHtmComponentClosingTags = E.allowHtmComponentClosingTags || false;
                let f = E.range || { endPos: u.content.length, startPos: 0, startLine: 0, startCol: 0 };
                this._cursor = E.escapedString ? new k(u, f) : new x(u, f);
                try {
                  this._cursor.init();
                } catch (F) {
                  this.handleError(F);
                }
              }
              _processCarriageReturns(u) {
                return u.replace(i, `
`);
              }
              tokenize() {
                for (; this._cursor.peek() !== r.$EOF; ) {
                  let u = this._cursor.clone();
                  try {
                    if (this._attemptCharCode(r.$LT))
                      if (this._attemptCharCode(r.$BANG))
                        this._attemptStr("[CDATA[") ? this._consumeCdata(u) : this._attemptStr("--") ? this._consumeComment(u) : this._attemptStrCaseInsensitive("doctype") ? this._consumeDocType(u) : this._consumeBogusComment(u);
                      else if (this._attemptCharCode(r.$SLASH))
                        this._consumeTagClose(u);
                      else {
                        let o = this._cursor.clone();
                        this._attemptCharCode(r.$QUESTION) ? (this._cursor = o, this._consumeBogusComment(u)) : this._consumeTagOpen(u);
                      }
                    else
                      this._tokenizeIcu && this._tokenizeExpansionForm() || this._consumeText();
                  } catch (o) {
                    this.handleError(o);
                  }
                }
                return this._beginToken(n.EOF), this._endToken([]), new D(O(this.tokens), this.errors);
              }
              _tokenizeExpansionForm() {
                if (this.isExpansionFormStart())
                  return this._consumeExpansionFormStart(), true;
                if (R(this._cursor.peek()) && this._isInExpansionForm())
                  return this._consumeExpansionCaseStart(), true;
                if (this._cursor.peek() === r.$RBRACE) {
                  if (this._isInExpansionCase())
                    return this._consumeExpansionCaseEnd(), true;
                  if (this._isInExpansionForm())
                    return this._consumeExpansionFormEnd(), true;
                }
                return false;
              }
              _beginToken(u) {
                let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
                this._currentTokenStart = o, this._currentTokenType = u;
              }
              _endToken(u) {
                let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
                if (this._currentTokenStart === null)
                  throw new p("Programming error - attempted to end a token when there was no start to the token", this._currentTokenType, this._cursor.getSpan(o));
                if (this._currentTokenType === null)
                  throw new p("Programming error - attempted to end a token which has no token type", null, this._cursor.getSpan(this._currentTokenStart));
                let E = new a(this._currentTokenType, u, this._cursor.getSpan(this._currentTokenStart, this._leadingTriviaCodePoints));
                return this.tokens.push(E), this._currentTokenStart = null, this._currentTokenType = null, E;
              }
              _createError(u, o) {
                this._isInExpansionForm() && (u += ` (Do you have an unescaped "{" in your template? Use "{{ '{' }}") to escape it.)`);
                let E = new p(u, this._currentTokenType, o);
                return this._currentTokenStart = null, this._currentTokenType = null, new C(E);
              }
              handleError(u) {
                if (u instanceof M && (u = this._createError(u.msg, this._cursor.getSpan(u.cursor))), u instanceof C)
                  this.errors.push(u.error);
                else
                  throw u;
              }
              _attemptCharCode(u) {
                return this._cursor.peek() === u ? (this._cursor.advance(), true) : false;
              }
              _attemptCharCodeCaseInsensitive(u) {
                return $(this._cursor.peek(), u) ? (this._cursor.advance(), true) : false;
              }
              _requireCharCode(u) {
                let o = this._cursor.clone();
                if (!this._attemptCharCode(u))
                  throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(o));
              }
              _attemptStr(u) {
                let o = u.length;
                if (this._cursor.charsLeft() < o)
                  return false;
                let E = this._cursor.clone();
                for (let f = 0; f < o; f++)
                  if (!this._attemptCharCode(u.charCodeAt(f)))
                    return this._cursor = E, false;
                return true;
              }
              _attemptStrCaseInsensitive(u) {
                for (let o = 0; o < u.length; o++)
                  if (!this._attemptCharCodeCaseInsensitive(u.charCodeAt(o)))
                    return false;
                return true;
              }
              _requireStr(u) {
                let o = this._cursor.clone();
                if (!this._attemptStr(u))
                  throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(o));
              }
              _requireStrCaseInsensitive(u) {
                let o = this._cursor.clone();
                if (!this._attemptStrCaseInsensitive(u))
                  throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(o));
              }
              _attemptCharCodeUntilFn(u) {
                for (; !u(this._cursor.peek()); )
                  this._cursor.advance();
              }
              _requireCharCodeUntilFn(u, o) {
                let E = this._cursor.clone();
                if (this._attemptCharCodeUntilFn(u), this._cursor.clone().diff(E) < o)
                  throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(E));
              }
              _attemptUntilChar(u) {
                for (; this._cursor.peek() !== u; )
                  this._cursor.advance();
              }
              _readChar(u) {
                if (u && this._cursor.peek() === r.$AMPERSAND)
                  return this._decodeEntity();
                {
                  let o = String.fromCodePoint(this._cursor.peek());
                  return this._cursor.advance(), o;
                }
              }
              _decodeEntity() {
                let u = this._cursor.clone();
                if (this._cursor.advance(), this._attemptCharCode(r.$HASH)) {
                  let o = this._attemptCharCode(r.$x) || this._attemptCharCode(r.$X), E = this._cursor.clone();
                  if (this._attemptCharCodeUntilFn(A), this._cursor.peek() != r.$SEMICOLON)
                    throw this._createError(l(this._cursor.peek()), this._cursor.getSpan());
                  let f = this._cursor.getChars(E);
                  this._cursor.advance();
                  try {
                    let F = parseInt(f, o ? 16 : 10);
                    return String.fromCharCode(F);
                  } catch {
                    throw this._createError(h(this._cursor.getChars(u)), this._cursor.getSpan());
                  }
                } else {
                  let o = this._cursor.clone();
                  if (this._attemptCharCodeUntilFn(N), this._cursor.peek() != r.$SEMICOLON)
                    return this._cursor = o, "&";
                  let E = this._cursor.getChars(o);
                  this._cursor.advance();
                  let f = c.NAMED_ENTITIES[E];
                  if (!f)
                    throw this._createError(h(E), this._cursor.getSpan(u));
                  return f;
                }
              }
              _consumeRawText(u, o) {
                this._beginToken(u ? n.ESCAPABLE_RAW_TEXT : n.RAW_TEXT);
                let E = [];
                for (; ; ) {
                  let f = this._cursor.clone(), F = o();
                  if (this._cursor = f, F)
                    break;
                  E.push(this._readChar(u));
                }
                return this._endToken([this._processCarriageReturns(E.join(""))]);
              }
              _consumeComment(u) {
                this._beginToken(n.COMMENT_START, u), this._endToken([]), this._consumeRawText(false, () => this._attemptStr("-->")), this._beginToken(n.COMMENT_END), this._requireStr("-->"), this._endToken([]);
              }
              _consumeBogusComment(u) {
                this._beginToken(n.COMMENT_START, u), this._endToken([]), this._consumeRawText(false, () => this._cursor.peek() === r.$GT), this._beginToken(n.COMMENT_END), this._cursor.advance(), this._endToken([]);
              }
              _consumeCdata(u) {
                this._beginToken(n.CDATA_START, u), this._endToken([]), this._consumeRawText(false, () => this._attemptStr("]]>")), this._beginToken(n.CDATA_END), this._requireStr("]]>"), this._endToken([]);
              }
              _consumeDocType(u) {
                this._beginToken(n.DOC_TYPE_START, u), this._endToken([]), this._consumeRawText(false, () => this._cursor.peek() === r.$GT), this._beginToken(n.DOC_TYPE_END), this._cursor.advance(), this._endToken([]);
              }
              _consumePrefixAndName() {
                let u = this._cursor.clone(), o = "";
                for (; this._cursor.peek() !== r.$COLON && !B(this._cursor.peek()); )
                  this._cursor.advance();
                let E;
                this._cursor.peek() === r.$COLON ? (o = this._cursor.getChars(u), this._cursor.advance(), E = this._cursor.clone()) : E = u, this._requireCharCodeUntilFn(T, o === "" ? 0 : 1);
                let f = this._cursor.getChars(E);
                return [o, f];
              }
              _consumeTagOpen(u) {
                let o, E, f, F = this.tokens.length, P = this._cursor.clone(), j = [];
                try {
                  if (!r.isAsciiLetter(this._cursor.peek()))
                    throw this._createError(l(this._cursor.peek()), this._cursor.getSpan(u));
                  for (f = this._consumeTagOpenStart(u), E = f.parts[0], o = f.parts[1], this._attemptCharCodeUntilFn(m); this._cursor.peek() !== r.$SLASH && this._cursor.peek() !== r.$GT; ) {
                    let [X, H] = this._consumeAttributeName();
                    if (this._attemptCharCodeUntilFn(m), this._attemptCharCode(r.$EQ)) {
                      this._attemptCharCodeUntilFn(m);
                      let z = this._consumeAttributeValue();
                      j.push({ prefix: X, name: H, value: z });
                    } else
                      j.push({ prefix: X, name: H });
                    this._attemptCharCodeUntilFn(m);
                  }
                  this._consumeTagOpenEnd();
                } catch (X) {
                  if (X instanceof C) {
                    this._cursor = P, f && (this.tokens.length = F), this._beginToken(n.TEXT, u), this._endToken(["<"]);
                    return;
                  }
                  throw X;
                }
                if (this._canSelfClose && this.tokens[this.tokens.length - 1].type === n.TAG_OPEN_END_VOID)
                  return;
                let W = this._getTagContentType(o, E, this._fullNameStack.length > 0, j);
                this._handleFullNameStackForTagOpen(E, o), W === c.TagContentType.RAW_TEXT ? this._consumeRawTextWithTagClose(E, o, false) : W === c.TagContentType.ESCAPABLE_RAW_TEXT && this._consumeRawTextWithTagClose(E, o, true);
              }
              _consumeRawTextWithTagClose(u, o, E) {
                let f = this._consumeRawText(E, () => !this._attemptCharCode(r.$LT) || !this._attemptCharCode(r.$SLASH) || (this._attemptCharCodeUntilFn(m), !this._attemptStrCaseInsensitive(u ? "".concat(u, ":").concat(o) : o)) ? false : (this._attemptCharCodeUntilFn(m), this._attemptCharCode(r.$GT)));
                this._beginToken(n.TAG_CLOSE), this._requireCharCodeUntilFn((F) => F === r.$GT, 3), this._cursor.advance(), this._endToken([u, o]), this._handleFullNameStackForTagClose(u, o);
              }
              _consumeTagOpenStart(u) {
                this._beginToken(n.TAG_OPEN_START, u);
                let o = this._consumePrefixAndName();
                return this._endToken(o);
              }
              _consumeAttributeName() {
                let u = this._cursor.peek();
                if (u === r.$SQ || u === r.$DQ)
                  throw this._createError(l(u), this._cursor.getSpan());
                this._beginToken(n.ATTR_NAME);
                let o = this._consumePrefixAndName();
                return this._endToken(o), o;
              }
              _consumeAttributeValue() {
                let u;
                if (this._cursor.peek() === r.$SQ || this._cursor.peek() === r.$DQ) {
                  this._beginToken(n.ATTR_QUOTE);
                  let o = this._cursor.peek();
                  this._cursor.advance(), this._endToken([String.fromCodePoint(o)]), this._beginToken(n.ATTR_VALUE);
                  let E = [];
                  for (; this._cursor.peek() !== o; )
                    E.push(this._readChar(true));
                  u = this._processCarriageReturns(E.join("")), this._endToken([u]), this._beginToken(n.ATTR_QUOTE), this._cursor.advance(), this._endToken([String.fromCodePoint(o)]);
                } else {
                  this._beginToken(n.ATTR_VALUE);
                  let o = this._cursor.clone();
                  this._requireCharCodeUntilFn(T, 1), u = this._processCarriageReturns(this._cursor.getChars(o)), this._endToken([u]);
                }
                return u;
              }
              _consumeTagOpenEnd() {
                let u = this._attemptCharCode(r.$SLASH) ? n.TAG_OPEN_END_VOID : n.TAG_OPEN_END;
                this._beginToken(u), this._requireCharCode(r.$GT), this._endToken([]);
              }
              _consumeTagClose(u) {
                if (this._beginToken(n.TAG_CLOSE, u), this._attemptCharCodeUntilFn(m), this._allowHtmComponentClosingTags && this._attemptCharCode(r.$SLASH))
                  this._attemptCharCodeUntilFn(m), this._requireCharCode(r.$GT), this._endToken([]);
                else {
                  let [o, E] = this._consumePrefixAndName();
                  this._attemptCharCodeUntilFn(m), this._requireCharCode(r.$GT), this._endToken([o, E]), this._handleFullNameStackForTagClose(o, E);
                }
              }
              _consumeExpansionFormStart() {
                this._beginToken(n.EXPANSION_FORM_START), this._requireCharCode(r.$LBRACE), this._endToken([]), this._expansionCaseStack.push(n.EXPANSION_FORM_START), this._beginToken(n.RAW_TEXT);
                let u = this._readUntil(r.$COMMA);
                this._endToken([u]), this._requireCharCode(r.$COMMA), this._attemptCharCodeUntilFn(m), this._beginToken(n.RAW_TEXT);
                let o = this._readUntil(r.$COMMA);
                this._endToken([o]), this._requireCharCode(r.$COMMA), this._attemptCharCodeUntilFn(m);
              }
              _consumeExpansionCaseStart() {
                this._beginToken(n.EXPANSION_CASE_VALUE);
                let u = this._readUntil(r.$LBRACE).trim();
                this._endToken([u]), this._attemptCharCodeUntilFn(m), this._beginToken(n.EXPANSION_CASE_EXP_START), this._requireCharCode(r.$LBRACE), this._endToken([]), this._attemptCharCodeUntilFn(m), this._expansionCaseStack.push(n.EXPANSION_CASE_EXP_START);
              }
              _consumeExpansionCaseEnd() {
                this._beginToken(n.EXPANSION_CASE_EXP_END), this._requireCharCode(r.$RBRACE), this._endToken([]), this._attemptCharCodeUntilFn(m), this._expansionCaseStack.pop();
              }
              _consumeExpansionFormEnd() {
                this._beginToken(n.EXPANSION_FORM_END), this._requireCharCode(r.$RBRACE), this._endToken([]), this._expansionCaseStack.pop();
              }
              _consumeText() {
                let u = this._cursor.clone();
                this._beginToken(n.TEXT, u);
                let o = [];
                do
                  this._interpolationConfig && this._attemptStr(this._interpolationConfig.start) ? (o.push(this._interpolationConfig.start), this._inInterpolation = true) : this._interpolationConfig && this._inInterpolation && this._attemptStr(this._interpolationConfig.end) ? (o.push(this._interpolationConfig.end), this._inInterpolation = false) : o.push(this._readChar(true));
                while (!this._isTextEnd());
                this._endToken([this._processCarriageReturns(o.join(""))]);
              }
              _isTextEnd() {
                return !!(this._cursor.peek() === r.$LT || this._cursor.peek() === r.$EOF || this._tokenizeIcu && !this._inInterpolation && (this.isExpansionFormStart() || this._cursor.peek() === r.$RBRACE && this._isInExpansionCase()));
              }
              _readUntil(u) {
                let o = this._cursor.clone();
                return this._attemptUntilChar(u), this._cursor.getChars(o);
              }
              _isInExpansionCase() {
                return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === n.EXPANSION_CASE_EXP_START;
              }
              _isInExpansionForm() {
                return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === n.EXPANSION_FORM_START;
              }
              isExpansionFormStart() {
                if (this._cursor.peek() !== r.$LBRACE)
                  return false;
                if (this._interpolationConfig) {
                  let u = this._cursor.clone(), o = this._attemptStr(this._interpolationConfig.start);
                  return this._cursor = u, !o;
                }
                return true;
              }
              _handleFullNameStackForTagOpen(u, o) {
                let E = c.mergeNsAndName(u, o);
                (this._fullNameStack.length === 0 || this._fullNameStack[this._fullNameStack.length - 1] === E) && this._fullNameStack.push(E);
              }
              _handleFullNameStackForTagClose(u, o) {
                let E = c.mergeNsAndName(u, o);
                this._fullNameStack.length !== 0 && this._fullNameStack[this._fullNameStack.length - 1] === E && this._fullNameStack.pop();
              }
            };
            function m(u) {
              return !r.isWhitespace(u) || u === r.$EOF;
            }
            function T(u) {
              return r.isWhitespace(u) || u === r.$GT || u === r.$SLASH || u === r.$SQ || u === r.$DQ || u === r.$EQ;
            }
            function B(u) {
              return (u < r.$a || r.$z < u) && (u < r.$A || r.$Z < u) && (u < r.$0 || u > r.$9);
            }
            function A(u) {
              return u == r.$SEMICOLON || u == r.$EOF || !r.isAsciiHexDigit(u);
            }
            function N(u) {
              return u == r.$SEMICOLON || u == r.$EOF || !r.isAsciiLetter(u);
            }
            function R(u) {
              return u === r.$EQ || r.isAsciiLetter(u) || r.isDigit(u);
            }
            function $(u, o) {
              return _(u) == _(o);
            }
            function _(u) {
              return u >= r.$a && u <= r.$z ? u - r.$a + r.$A : u;
            }
            function O(u) {
              let o = [], E;
              for (let f = 0; f < u.length; f++) {
                let F = u[f];
                E && E.type == n.TEXT && F.type == n.TEXT ? (E.parts[0] += F.parts[0], E.sourceSpan.end = F.sourceSpan.end) : (E = F, o.push(E));
              }
              return o;
            }
            var x = class {
              constructor(u, o) {
                if (u instanceof x)
                  this.file = u.file, this.input = u.input, this.end = u.end, this.state = Object.assign({}, u.state);
                else {
                  if (!o)
                    throw new Error("Programming error: the range argument must be provided with a file argument.");
                  this.file = u, this.input = u.content, this.end = o.endPos, this.state = { peek: -1, offset: o.startPos, line: o.startLine, column: o.startCol };
                }
              }
              clone() {
                return new x(this);
              }
              peek() {
                return this.state.peek;
              }
              charsLeft() {
                return this.end - this.state.offset;
              }
              diff(u) {
                return this.state.offset - u.state.offset;
              }
              advance() {
                this.advanceState(this.state);
              }
              init() {
                this.updatePeek(this.state);
              }
              getSpan(u, o) {
                if (u = u || this, o)
                  for (u = u.clone(); this.diff(u) > 0 && o.indexOf(u.peek()) !== -1; )
                    u.advance();
                return new t3.ParseSourceSpan(new t3.ParseLocation(u.file, u.state.offset, u.state.line, u.state.column), new t3.ParseLocation(this.file, this.state.offset, this.state.line, this.state.column));
              }
              getChars(u) {
                return this.input.substring(u.state.offset, this.state.offset);
              }
              charAt(u) {
                return this.input.charCodeAt(u);
              }
              advanceState(u) {
                if (u.offset >= this.end)
                  throw this.state = u, new M('Unexpected character "EOF"', this);
                let o = this.charAt(u.offset);
                o === r.$LF ? (u.line++, u.column = 0) : r.isNewLine(o) || u.column++, u.offset++, this.updatePeek(u);
              }
              updatePeek(u) {
                u.peek = u.offset >= this.end ? r.$EOF : this.charAt(u.offset);
              }
            }, k = class extends x {
              constructor(u, o) {
                u instanceof k ? (super(u), this.internalState = Object.assign({}, u.internalState)) : (super(u, o), this.internalState = this.state);
              }
              advance() {
                this.state = this.internalState, super.advance(), this.processEscapeSequence();
              }
              init() {
                super.init(), this.processEscapeSequence();
              }
              clone() {
                return new k(this);
              }
              getChars(u) {
                let o = u.clone(), E = "";
                for (; o.internalState.offset < this.internalState.offset; )
                  E += String.fromCodePoint(o.peek()), o.advance();
                return E;
              }
              processEscapeSequence() {
                let u = () => this.internalState.peek;
                if (u() === r.$BACKSLASH)
                  if (this.internalState = Object.assign({}, this.state), this.advanceState(this.internalState), u() === r.$n)
                    this.state.peek = r.$LF;
                  else if (u() === r.$r)
                    this.state.peek = r.$CR;
                  else if (u() === r.$v)
                    this.state.peek = r.$VTAB;
                  else if (u() === r.$t)
                    this.state.peek = r.$TAB;
                  else if (u() === r.$b)
                    this.state.peek = r.$BSPACE;
                  else if (u() === r.$f)
                    this.state.peek = r.$FF;
                  else if (u() === r.$u)
                    if (this.advanceState(this.internalState), u() === r.$LBRACE) {
                      this.advanceState(this.internalState);
                      let o = this.clone(), E = 0;
                      for (; u() !== r.$RBRACE; )
                        this.advanceState(this.internalState), E++;
                      this.state.peek = this.decodeHexDigits(o, E);
                    } else {
                      let o = this.clone();
                      this.advanceState(this.internalState), this.advanceState(this.internalState), this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(o, 4);
                    }
                  else if (u() === r.$x) {
                    this.advanceState(this.internalState);
                    let o = this.clone();
                    this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(o, 2);
                  } else if (r.isOctalDigit(u())) {
                    let o = "", E = 0, f = this.clone();
                    for (; r.isOctalDigit(u()) && E < 3; )
                      f = this.clone(), o += String.fromCodePoint(u()), this.advanceState(this.internalState), E++;
                    this.state.peek = parseInt(o, 8), this.internalState = f.internalState;
                  } else
                    r.isNewLine(this.internalState.peek) ? (this.advanceState(this.internalState), this.state = this.internalState) : this.state.peek = this.internalState.peek;
              }
              decodeHexDigits(u, o) {
                let E = this.input.substr(u.internalState.offset, o), f = parseInt(E, 16);
                if (isNaN(f))
                  throw u.state = u.internalState, new M("Invalid hexadecimal escape sequence", u);
                return f;
              }
            }, M = class {
              constructor(u, o) {
                this.msg = u, this.cursor = o;
              }
            };
            e.CursorError = M;
          } }), as = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/parser.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = Te(), t3 = Ss(), s = zD(), c = Ze(), n = class extends r.ParseError {
              constructor(i, l, h) {
                super(l, h), this.elementName = i;
              }
              static create(i, l, h) {
                return new n(i, l, h);
              }
            };
            e.TreeError = n;
            var a = class {
              constructor(i, l) {
                this.rootNodes = i, this.errors = l;
              }
            };
            e.ParseTreeResult = a;
            var p = class {
              constructor(i) {
                this.getTagDefinition = i;
              }
              parse(i, l, h) {
                let C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, d = arguments.length > 4 ? arguments[4] : void 0, m = (x) => function(k) {
                  for (var M = arguments.length, u = new Array(M > 1 ? M - 1 : 0), o = 1; o < M; o++)
                    u[o - 1] = arguments[o];
                  return x(k.toLowerCase(), ...u);
                }, T = C ? this.getTagDefinition : m(this.getTagDefinition), B = (x) => T(x).contentType, A = C ? d : m(d), N = d ? (x, k, M, u) => {
                  let o = A(x, k, M, u);
                  return o !== void 0 ? o : B(x);
                } : B, R = s.tokenize(i, l, N, h), $ = h && h.canSelfClose || false, _ = h && h.allowHtmComponentClosingTags || false, O = new D(R.tokens, T, $, _, C).build();
                return new a(O.rootNodes, R.errors.concat(O.errors));
              }
            };
            e.Parser = p;
            var D = class {
              constructor(i, l, h, C, d) {
                this.tokens = i, this.getTagDefinition = l, this.canSelfClose = h, this.allowHtmComponentClosingTags = C, this.isTagNameCaseSensitive = d, this._index = -1, this._rootNodes = [], this._errors = [], this._elementStack = [], this._advance();
              }
              build() {
                for (; this._peek.type !== s.TokenType.EOF; )
                  this._peek.type === s.TokenType.TAG_OPEN_START ? this._consumeStartTag(this._advance()) : this._peek.type === s.TokenType.TAG_CLOSE ? (this._closeVoidElement(), this._consumeEndTag(this._advance())) : this._peek.type === s.TokenType.CDATA_START ? (this._closeVoidElement(), this._consumeCdata(this._advance())) : this._peek.type === s.TokenType.COMMENT_START ? (this._closeVoidElement(), this._consumeComment(this._advance())) : this._peek.type === s.TokenType.TEXT || this._peek.type === s.TokenType.RAW_TEXT || this._peek.type === s.TokenType.ESCAPABLE_RAW_TEXT ? (this._closeVoidElement(), this._consumeText(this._advance())) : this._peek.type === s.TokenType.EXPANSION_FORM_START ? this._consumeExpansion(this._advance()) : this._peek.type === s.TokenType.DOC_TYPE_START ? this._consumeDocType(this._advance()) : this._advance();
                return new a(this._rootNodes, this._errors);
              }
              _advance() {
                let i = this._peek;
                return this._index < this.tokens.length - 1 && this._index++, this._peek = this.tokens[this._index], i;
              }
              _advanceIf(i) {
                return this._peek.type === i ? this._advance() : null;
              }
              _consumeCdata(i) {
                let l = this._advance(), h = this._getText(l), C = this._advanceIf(s.TokenType.CDATA_END);
                this._addToParent(new t3.CDATA(h, new r.ParseSourceSpan(i.sourceSpan.start, (C || l).sourceSpan.end)));
              }
              _consumeComment(i) {
                let l = this._advanceIf(s.TokenType.RAW_TEXT), h = this._advanceIf(s.TokenType.COMMENT_END), C = l != null ? l.parts[0].trim() : null, d = new r.ParseSourceSpan(i.sourceSpan.start, (h || l || i).sourceSpan.end);
                this._addToParent(new t3.Comment(C, d));
              }
              _consumeDocType(i) {
                let l = this._advanceIf(s.TokenType.RAW_TEXT), h = this._advanceIf(s.TokenType.DOC_TYPE_END), C = l != null ? l.parts[0].trim() : null, d = new r.ParseSourceSpan(i.sourceSpan.start, (h || l || i).sourceSpan.end);
                this._addToParent(new t3.DocType(C, d));
              }
              _consumeExpansion(i) {
                let l = this._advance(), h = this._advance(), C = [];
                for (; this._peek.type === s.TokenType.EXPANSION_CASE_VALUE; ) {
                  let m = this._parseExpansionCase();
                  if (!m)
                    return;
                  C.push(m);
                }
                if (this._peek.type !== s.TokenType.EXPANSION_FORM_END) {
                  this._errors.push(n.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '}'."));
                  return;
                }
                let d = new r.ParseSourceSpan(i.sourceSpan.start, this._peek.sourceSpan.end);
                this._addToParent(new t3.Expansion(l.parts[0], h.parts[0], C, d, l.sourceSpan)), this._advance();
              }
              _parseExpansionCase() {
                let i = this._advance();
                if (this._peek.type !== s.TokenType.EXPANSION_CASE_EXP_START)
                  return this._errors.push(n.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '{'.")), null;
                let l = this._advance(), h = this._collectExpansionExpTokens(l);
                if (!h)
                  return null;
                let C = this._advance();
                h.push(new s.Token(s.TokenType.EOF, [], C.sourceSpan));
                let d = new D(h, this.getTagDefinition, this.canSelfClose, this.allowHtmComponentClosingTags, this.isTagNameCaseSensitive).build();
                if (d.errors.length > 0)
                  return this._errors = this._errors.concat(d.errors), null;
                let m = new r.ParseSourceSpan(i.sourceSpan.start, C.sourceSpan.end), T = new r.ParseSourceSpan(l.sourceSpan.start, C.sourceSpan.end);
                return new t3.ExpansionCase(i.parts[0], d.rootNodes, m, i.sourceSpan, T);
              }
              _collectExpansionExpTokens(i) {
                let l = [], h = [s.TokenType.EXPANSION_CASE_EXP_START];
                for (; ; ) {
                  if ((this._peek.type === s.TokenType.EXPANSION_FORM_START || this._peek.type === s.TokenType.EXPANSION_CASE_EXP_START) && h.push(this._peek.type), this._peek.type === s.TokenType.EXPANSION_CASE_EXP_END)
                    if (g(h, s.TokenType.EXPANSION_CASE_EXP_START)) {
                      if (h.pop(), h.length == 0)
                        return l;
                    } else
                      return this._errors.push(n.create(null, i.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
                  if (this._peek.type === s.TokenType.EXPANSION_FORM_END)
                    if (g(h, s.TokenType.EXPANSION_FORM_START))
                      h.pop();
                    else
                      return this._errors.push(n.create(null, i.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
                  if (this._peek.type === s.TokenType.EOF)
                    return this._errors.push(n.create(null, i.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
                  l.push(this._advance());
                }
              }
              _getText(i) {
                let l = i.parts[0];
                if (l.length > 0 && l[0] == `
`) {
                  let h = this._getParentElement();
                  h != null && h.children.length == 0 && this.getTagDefinition(h.name).ignoreFirstLf && (l = l.substring(1));
                }
                return l;
              }
              _consumeText(i) {
                let l = this._getText(i);
                l.length > 0 && this._addToParent(new t3.Text(l, i.sourceSpan));
              }
              _closeVoidElement() {
                let i = this._getParentElement();
                i && this.getTagDefinition(i.name).isVoid && this._elementStack.pop();
              }
              _consumeStartTag(i) {
                let l = i.parts[0], h = i.parts[1], C = [];
                for (; this._peek.type === s.TokenType.ATTR_NAME; )
                  C.push(this._consumeAttr(this._advance()));
                let d = this._getElementFullName(l, h, this._getParentElement()), m = false;
                if (this._peek.type === s.TokenType.TAG_OPEN_END_VOID) {
                  this._advance(), m = true;
                  let R = this.getTagDefinition(d);
                  this.canSelfClose || R.canSelfClose || c.getNsPrefix(d) !== null || R.isVoid || this._errors.push(n.create(d, i.sourceSpan, 'Only void and foreign elements can be self closed "'.concat(i.parts[1], '"')));
                } else
                  this._peek.type === s.TokenType.TAG_OPEN_END && (this._advance(), m = false);
                let T = this._peek.sourceSpan.start, B = new r.ParseSourceSpan(i.sourceSpan.start, T), A = new r.ParseSourceSpan(i.sourceSpan.start.moveBy(1), i.sourceSpan.end), N = new t3.Element(d, C, [], B, B, void 0, A);
                this._pushElement(N), m && (this._popElement(d), N.endSourceSpan = B);
              }
              _pushElement(i) {
                let l = this._getParentElement();
                l && this.getTagDefinition(l.name).isClosedByChild(i.name) && this._elementStack.pop(), this._addToParent(i), this._elementStack.push(i);
              }
              _consumeEndTag(i) {
                let l = this.allowHtmComponentClosingTags && i.parts.length === 0 ? null : this._getElementFullName(i.parts[0], i.parts[1], this._getParentElement());
                if (this._getParentElement() && (this._getParentElement().endSourceSpan = i.sourceSpan), l && this.getTagDefinition(l).isVoid)
                  this._errors.push(n.create(l, i.sourceSpan, 'Void elements do not have end tags "'.concat(i.parts[1], '"')));
                else if (!this._popElement(l)) {
                  let h = 'Unexpected closing tag "'.concat(l, '". It may happen when the tag has already been closed by another tag. For more info see https://www.w3.org/TR/html5/syntax.html#closing-elements-that-have-implied-end-tags');
                  this._errors.push(n.create(l, i.sourceSpan, h));
                }
              }
              _popElement(i) {
                for (let l = this._elementStack.length - 1; l >= 0; l--) {
                  let h = this._elementStack[l];
                  if (!i || (c.getNsPrefix(h.name) ? h.name == i : h.name.toLowerCase() == i.toLowerCase()))
                    return this._elementStack.splice(l, this._elementStack.length - l), true;
                  if (!this.getTagDefinition(h.name).closedByParent)
                    return false;
                }
                return false;
              }
              _consumeAttr(i) {
                let l = c.mergeNsAndName(i.parts[0], i.parts[1]), h = i.sourceSpan.end, C = "", d, m;
                if (this._peek.type === s.TokenType.ATTR_QUOTE && (m = this._advance().sourceSpan.start), this._peek.type === s.TokenType.ATTR_VALUE) {
                  let T = this._advance();
                  C = T.parts[0], h = T.sourceSpan.end, d = T.sourceSpan;
                }
                return this._peek.type === s.TokenType.ATTR_QUOTE && (h = this._advance().sourceSpan.end, d = new r.ParseSourceSpan(m, h)), new t3.Attribute(l, C, new r.ParseSourceSpan(i.sourceSpan.start, h), d, i.sourceSpan);
              }
              _getParentElement() {
                return this._elementStack.length > 0 ? this._elementStack[this._elementStack.length - 1] : null;
              }
              _getParentElementSkippingContainers() {
                let i = null;
                for (let l = this._elementStack.length - 1; l >= 0; l--) {
                  if (!c.isNgContainer(this._elementStack[l].name))
                    return { parent: this._elementStack[l], container: i };
                  i = this._elementStack[l];
                }
                return { parent: null, container: i };
              }
              _addToParent(i) {
                let l = this._getParentElement();
                l != null ? l.children.push(i) : this._rootNodes.push(i);
              }
              _insertBeforeContainer(i, l, h) {
                if (!l)
                  this._addToParent(h), this._elementStack.push(h);
                else {
                  if (i) {
                    let C = i.children.indexOf(l);
                    i.children[C] = h;
                  } else
                    this._rootNodes.push(h);
                  h.children.push(l), this._elementStack.splice(this._elementStack.indexOf(l), 0, h);
                }
              }
              _getElementFullName(i, l, h) {
                return i === "" && (i = this.getTagDefinition(l).implicitNamespacePrefix || "", i === "" && h != null && (i = c.getNsPrefix(h.name))), c.mergeNsAndName(i, l);
              }
            };
            function g(i, l) {
              return i.length > 0 && i[i.length - 1] === l;
            }
          } }), WD = I({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_parser.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = _s(), t3 = as(), s = as();
            e.ParseTreeResult = s.ParseTreeResult, e.TreeError = s.TreeError;
            var c = class extends t3.Parser {
              constructor() {
                super(r.getHtmlTagDefinition);
              }
              parse(n, a, p) {
                let D = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, g = arguments.length > 4 ? arguments[4] : void 0;
                return super.parse(n, a, p, D, g);
              }
            };
            e.HtmlParser = c;
          } }), ys = I({ "node_modules/angular-html-parser/lib/angular-html-parser/src/index.js"(e) {
            "use strict";
            q(), Object.defineProperty(e, "__esModule", { value: true });
            var r = WD(), t3 = Ze();
            e.TagContentType = t3.TagContentType;
            var s = null, c = () => (s || (s = new r.HtmlParser()), s);
            function n(a) {
              let p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { canSelfClose: D = false, allowHtmComponentClosingTags: g = false, isTagNameCaseSensitive: i = false, getTagContentType: l } = p;
              return c().parse(a, "angular-html-parser", { tokenizeExpansionForms: false, interpolationConfig: void 0, canSelfClose: D, allowHtmComponentClosingTags: g }, i, l);
            }
            e.parse = n;
          } });
          q();
          var { ParseSourceSpan: Qe, ParseLocation: is, ParseSourceFile: YD } = Te(), QD = aD(), KD = ps(), JD = iD(), { inferParserByLanguage: ZD } = ID(), el = xD(), jr = LD(), os = MD(), { hasPragma: rl } = jD(), { Node: tl } = $D(), { parseIeConditionalComment: ul } = UD(), { locStart: nl, locEnd: sl } = GD();
          function al(e, r, t3) {
            let { recognizeSelfClosing: s, normalizeTagName: c, normalizeAttributeName: n, allowHtmComponentClosingTags: a, isTagNameCaseSensitive: p, getTagContentType: D } = r, g = ys(), { RecursiveVisitor: i, visitAll: l } = Ss(), { ParseSourceSpan: h } = Te(), { getHtmlTagDefinition: C } = _s(), { rootNodes: d, errors: m } = g.parse(e, { canSelfClose: s, allowHtmComponentClosingTags: a, isTagNameCaseSensitive: p, getTagContentType: D });
            if (t3.parser === "vue")
              if (d.some((O) => O.type === "docType" && O.value === "html" || O.type === "element" && O.name.toLowerCase() === "html")) {
                s = true, c = true, n = true, a = true, p = false;
                let O = g.parse(e, { canSelfClose: s, allowHtmComponentClosingTags: a, isTagNameCaseSensitive: p });
                d = O.rootNodes, m = O.errors;
              } else {
                let O = (x) => {
                  if (!x || x.type !== "element" || x.name !== "template")
                    return false;
                  let k = x.attrs.find((u) => u.name === "lang"), M = k && k.value;
                  return !M || ZD(M, t3) === "html";
                };
                if (d.some(O)) {
                  let x, k = () => g.parse(e, { canSelfClose: s, allowHtmComponentClosingTags: a, isTagNameCaseSensitive: p }), M = () => x || (x = k()), u = (o) => M().rootNodes.find((E) => {
                    let { startSourceSpan: f } = E;
                    return f && f.start.offset === o.startSourceSpan.start.offset;
                  });
                  for (let o = 0; o < d.length; o++) {
                    let E = d[o], { endSourceSpan: f, startSourceSpan: F } = E;
                    if (f === null)
                      m = M().errors, d[o] = u(E) || E;
                    else if (O(E)) {
                      let j = M(), W = F.end.offset, X = f.start.offset;
                      for (let H of j.errors) {
                        let { offset: z } = H.span.start;
                        if (W < z && z < X) {
                          m = [H];
                          break;
                        }
                      }
                      d[o] = u(E) || E;
                    }
                  }
                }
              }
            if (m.length > 0) {
              let { msg: _, span: { start: O, end: x } } = m[0];
              throw JD(_, { start: { line: O.line + 1, column: O.col + 1 }, end: { line: x.line + 1, column: x.col + 1 } });
            }
            let T = (_) => {
              let O = _.name.startsWith(":") ? _.name.slice(1).split(":")[0] : null, x = _.nameSpan.toString(), k = O !== null && x.startsWith("".concat(O, ":")), M = k ? x.slice(O.length + 1) : x;
              _.name = M, _.namespace = O, _.hasExplicitNamespace = k;
            }, B = (_) => {
              switch (_.type) {
                case "element":
                  T(_);
                  for (let O of _.attrs)
                    T(O), O.valueSpan ? (O.value = O.valueSpan.toString(), /["']/.test(O.value[0]) && (O.value = O.value.slice(1, -1))) : O.value = null;
                  break;
                case "comment":
                  _.value = _.sourceSpan.toString().slice(4, -3);
                  break;
                case "text":
                  _.value = _.sourceSpan.toString();
                  break;
              }
            }, A = (_, O) => {
              let x = _.toLowerCase();
              return O(x) ? x : _;
            }, N = (_) => {
              if (_.type === "element" && (c && (!_.namespace || _.namespace === _.tagDefinition.implicitNamespacePrefix || os(_)) && (_.name = A(_.name, (O) => O in el)), n)) {
                let O = jr[_.name] || /* @__PURE__ */ Object.create(null);
                for (let x of _.attrs)
                  x.namespace || (x.name = A(x.name, (k) => _.name in jr && (k in jr["*"] || k in O)));
              }
            }, R = (_) => {
              _.sourceSpan && _.endSourceSpan && (_.sourceSpan = new h(_.sourceSpan.start, _.endSourceSpan.end));
            }, $ = (_) => {
              if (_.type === "element") {
                let O = C(p ? _.name : _.name.toLowerCase());
                !_.namespace || _.namespace === O.implicitNamespacePrefix || os(_) ? _.tagDefinition = O : _.tagDefinition = C("");
              }
            };
            return l(new class extends i {
              visit(_) {
                B(_), $(_), N(_), R(_);
              }
            }(), d), d;
          }
          function Ts(e, r, t3) {
            let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, { frontMatter: c, content: n } = s ? QD(e) : { frontMatter: null, content: e }, a = new YD(e, r.filepath), p = new is(a, 0, 0, 0), D = p.moveBy(e.length), g = { type: "root", sourceSpan: new Qe(p, D), children: al(n, t3, r) };
            if (c) {
              let h = new is(a, 0, 0, 0), C = h.moveBy(c.raw.length);
              c.sourceSpan = new Qe(h, C), g.children.unshift(c);
            }
            let i = new tl(g), l = (h, C) => {
              let { offset: d } = C, m = e.slice(0, d).replace(/[^\n\r]/g, " "), B = Ts(m + h, r, t3, false);
              B.sourceSpan = new Qe(C, KD(B.children).sourceSpan.end);
              let A = B.children[0];
              return A.length === d ? B.children.shift() : (A.sourceSpan = new Qe(A.sourceSpan.start.moveBy(d), A.sourceSpan.end), A.value = A.value.slice(d)), B;
            };
            return i.walk((h) => {
              if (h.type === "comment") {
                let C = ul(h, l);
                C && h.parent.replaceChild(h, C);
              }
            }), i;
          }
          function Ke() {
            let { name: e, recognizeSelfClosing: r = false, normalizeTagName: t3 = false, normalizeAttributeName: s = false, allowHtmComponentClosingTags: c = false, isTagNameCaseSensitive: n = false, getTagContentType: a } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return { parse: (p, D, g) => Ts(p, Object.assign({ parser: e }, g), { recognizeSelfClosing: r, normalizeTagName: t3, normalizeAttributeName: s, allowHtmComponentClosingTags: c, isTagNameCaseSensitive: n, getTagContentType: a }), hasPragma: rl, astFormat: "html", locStart: nl, locEnd: sl };
          }
          Bs.exports = { parsers: { html: Ke({ name: "html", recognizeSelfClosing: true, normalizeTagName: true, normalizeAttributeName: true, allowHtmComponentClosingTags: true }), angular: Ke({ name: "angular" }), vue: Ke({ name: "vue", recognizeSelfClosing: true, isTagNameCaseSensitive: true, getTagContentType: (e, r, t3, s) => {
            if (e.toLowerCase() !== "html" && !t3 && (e !== "template" || s.some((c) => {
              let { name: n, value: a } = c;
              return n === "lang" && a !== "html" && a !== "" && a !== void 0;
            })))
              return ys().TagContentType.RAW_TEXT;
          } }), lwc: Ke({ name: "lwc" }) } };
        });
        return il();
      });
    }
  });

  // node_modules/semver/internal/constants.js
  var require_constants2 = __commonJS({
    "node_modules/semver/internal/constants.js"(exports2, module2) {
      init_define_process();
      var SEMVER_SPEC_VERSION = "2.0.0";
      var MAX_LENGTH = 256;
      var MAX_SAFE_INTEGER7 = Number.MAX_SAFE_INTEGER || 9007199254740991;
      var MAX_SAFE_COMPONENT_LENGTH = 16;
      module2.exports = {
        SEMVER_SPEC_VERSION,
        MAX_LENGTH,
        MAX_SAFE_INTEGER: MAX_SAFE_INTEGER7,
        MAX_SAFE_COMPONENT_LENGTH
      };
    }
  });

  // node_modules/semver/internal/debug.js
  var require_debug2 = __commonJS({
    "node_modules/semver/internal/debug.js"(exports2, module2) {
      init_define_process();
      var debug2 = typeof define_process_default === "object" && define_process_default.env && define_process_default.env.NODE_DEBUG && /\bsemver\b/i.test(define_process_default.env.NODE_DEBUG) ? (...args) => console.error("SEMVER", ...args) : () => {
      };
      module2.exports = debug2;
    }
  });

  // node_modules/semver/internal/re.js
  var require_re = __commonJS({
    "node_modules/semver/internal/re.js"(exports2, module2) {
      init_define_process();
      var { MAX_SAFE_COMPONENT_LENGTH } = require_constants2();
      var debug2 = require_debug2();
      exports2 = module2.exports = {};
      var re = exports2.re = [];
      var src = exports2.src = [];
      var t3 = exports2.t = {};
      var R = 0;
      var createToken = (name, value, isGlobal) => {
        const index = R++;
        debug2(name, index, value);
        t3[name] = index;
        src[index] = value;
        re[index] = new RegExp(value, isGlobal ? "g" : void 0);
      };
      createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
      createToken("NUMERICIDENTIFIERLOOSE", "[0-9]+");
      createToken("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*");
      createToken("MAINVERSION", `(${src[t3.NUMERICIDENTIFIER]})\\.(${src[t3.NUMERICIDENTIFIER]})\\.(${src[t3.NUMERICIDENTIFIER]})`);
      createToken("MAINVERSIONLOOSE", `(${src[t3.NUMERICIDENTIFIERLOOSE]})\\.(${src[t3.NUMERICIDENTIFIERLOOSE]})\\.(${src[t3.NUMERICIDENTIFIERLOOSE]})`);
      createToken("PRERELEASEIDENTIFIER", `(?:${src[t3.NUMERICIDENTIFIER]}|${src[t3.NONNUMERICIDENTIFIER]})`);
      createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t3.NUMERICIDENTIFIERLOOSE]}|${src[t3.NONNUMERICIDENTIFIER]})`);
      createToken("PRERELEASE", `(?:-(${src[t3.PRERELEASEIDENTIFIER]}(?:\\.${src[t3.PRERELEASEIDENTIFIER]})*))`);
      createToken("PRERELEASELOOSE", `(?:-?(${src[t3.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t3.PRERELEASEIDENTIFIERLOOSE]})*))`);
      createToken("BUILDIDENTIFIER", "[0-9A-Za-z-]+");
      createToken("BUILD", `(?:\\+(${src[t3.BUILDIDENTIFIER]}(?:\\.${src[t3.BUILDIDENTIFIER]})*))`);
      createToken("FULLPLAIN", `v?${src[t3.MAINVERSION]}${src[t3.PRERELEASE]}?${src[t3.BUILD]}?`);
      createToken("FULL", `^${src[t3.FULLPLAIN]}$`);
      createToken("LOOSEPLAIN", `[v=\\s]*${src[t3.MAINVERSIONLOOSE]}${src[t3.PRERELEASELOOSE]}?${src[t3.BUILD]}?`);
      createToken("LOOSE", `^${src[t3.LOOSEPLAIN]}$`);
      createToken("GTLT", "((?:<|>)?=?)");
      createToken("XRANGEIDENTIFIERLOOSE", `${src[t3.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
      createToken("XRANGEIDENTIFIER", `${src[t3.NUMERICIDENTIFIER]}|x|X|\\*`);
      createToken("XRANGEPLAIN", `[v=\\s]*(${src[t3.XRANGEIDENTIFIER]})(?:\\.(${src[t3.XRANGEIDENTIFIER]})(?:\\.(${src[t3.XRANGEIDENTIFIER]})(?:${src[t3.PRERELEASE]})?${src[t3.BUILD]}?)?)?`);
      createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t3.XRANGEIDENTIFIERLOOSE]})(?:${src[t3.PRERELEASELOOSE]})?${src[t3.BUILD]}?)?)?`);
      createToken("XRANGE", `^${src[t3.GTLT]}\\s*${src[t3.XRANGEPLAIN]}$`);
      createToken("XRANGELOOSE", `^${src[t3.GTLT]}\\s*${src[t3.XRANGEPLAINLOOSE]}$`);
      createToken("COERCE", `${"(^|[^\\d])(\\d{1,"}${MAX_SAFE_COMPONENT_LENGTH}})(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?(?:$|[^\\d])`);
      createToken("COERCERTL", src[t3.COERCE], true);
      createToken("LONETILDE", "(?:~>?)");
      createToken("TILDETRIM", `(\\s*)${src[t3.LONETILDE]}\\s+`, true);
      exports2.tildeTrimReplace = "$1~";
      createToken("TILDE", `^${src[t3.LONETILDE]}${src[t3.XRANGEPLAIN]}$`);
      createToken("TILDELOOSE", `^${src[t3.LONETILDE]}${src[t3.XRANGEPLAINLOOSE]}$`);
      createToken("LONECARET", "(?:\\^)");
      createToken("CARETTRIM", `(\\s*)${src[t3.LONECARET]}\\s+`, true);
      exports2.caretTrimReplace = "$1^";
      createToken("CARET", `^${src[t3.LONECARET]}${src[t3.XRANGEPLAIN]}$`);
      createToken("CARETLOOSE", `^${src[t3.LONECARET]}${src[t3.XRANGEPLAINLOOSE]}$`);
      createToken("COMPARATORLOOSE", `^${src[t3.GTLT]}\\s*(${src[t3.LOOSEPLAIN]})$|^$`);
      createToken("COMPARATOR", `^${src[t3.GTLT]}\\s*(${src[t3.FULLPLAIN]})$|^$`);
      createToken("COMPARATORTRIM", `(\\s*)${src[t3.GTLT]}\\s*(${src[t3.LOOSEPLAIN]}|${src[t3.XRANGEPLAIN]})`, true);
      exports2.comparatorTrimReplace = "$1$2$3";
      createToken("HYPHENRANGE", `^\\s*(${src[t3.XRANGEPLAIN]})\\s+-\\s+(${src[t3.XRANGEPLAIN]})\\s*$`);
      createToken("HYPHENRANGELOOSE", `^\\s*(${src[t3.XRANGEPLAINLOOSE]})\\s+-\\s+(${src[t3.XRANGEPLAINLOOSE]})\\s*$`);
      createToken("STAR", "(<|>)?=?\\s*\\*");
      createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
      createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
    }
  });

  // node_modules/semver/internal/parse-options.js
  var require_parse_options = __commonJS({
    "node_modules/semver/internal/parse-options.js"(exports2, module2) {
      init_define_process();
      var opts = ["includePrerelease", "loose", "rtl"];
      var parseOptions = (options) => !options ? {} : typeof options !== "object" ? { loose: true } : opts.filter((k) => options[k]).reduce((o, k) => {
        o[k] = true;
        return o;
      }, {});
      module2.exports = parseOptions;
    }
  });

  // node_modules/semver/internal/identifiers.js
  var require_identifiers = __commonJS({
    "node_modules/semver/internal/identifiers.js"(exports2, module2) {
      init_define_process();
      var numeric = /^[0-9]+$/;
      var compareIdentifiers = (a, b) => {
        const anum = numeric.test(a);
        const bnum = numeric.test(b);
        if (anum && bnum) {
          a = +a;
          b = +b;
        }
        return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
      };
      var rcompareIdentifiers = (a, b) => compareIdentifiers(b, a);
      module2.exports = {
        compareIdentifiers,
        rcompareIdentifiers
      };
    }
  });

  // node_modules/semver/classes/semver.js
  var require_semver = __commonJS({
    "node_modules/semver/classes/semver.js"(exports2, module2) {
      init_define_process();
      var debug2 = require_debug2();
      var { MAX_LENGTH, MAX_SAFE_INTEGER: MAX_SAFE_INTEGER7 } = require_constants2();
      var { re, t: t3 } = require_re();
      var parseOptions = require_parse_options();
      var { compareIdentifiers } = require_identifiers();
      var SemVer = class {
        constructor(version, options) {
          options = parseOptions(options);
          if (version instanceof SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) {
              return version;
            } else {
              version = version.version;
            }
          } else if (typeof version !== "string") {
            throw new TypeError(`Invalid Version: ${version}`);
          }
          if (version.length > MAX_LENGTH) {
            throw new TypeError(
              `version is longer than ${MAX_LENGTH} characters`
            );
          }
          debug2("SemVer", version, options);
          this.options = options;
          this.loose = !!options.loose;
          this.includePrerelease = !!options.includePrerelease;
          const m = version.trim().match(options.loose ? re[t3.LOOSE] : re[t3.FULL]);
          if (!m) {
            throw new TypeError(`Invalid Version: ${version}`);
          }
          this.raw = version;
          this.major = +m[1];
          this.minor = +m[2];
          this.patch = +m[3];
          if (this.major > MAX_SAFE_INTEGER7 || this.major < 0) {
            throw new TypeError("Invalid major version");
          }
          if (this.minor > MAX_SAFE_INTEGER7 || this.minor < 0) {
            throw new TypeError("Invalid minor version");
          }
          if (this.patch > MAX_SAFE_INTEGER7 || this.patch < 0) {
            throw new TypeError("Invalid patch version");
          }
          if (!m[4]) {
            this.prerelease = [];
          } else {
            this.prerelease = m[4].split(".").map((id) => {
              if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < MAX_SAFE_INTEGER7) {
                  return num;
                }
              }
              return id;
            });
          }
          this.build = m[5] ? m[5].split(".") : [];
          this.format();
        }
        format() {
          this.version = `${this.major}.${this.minor}.${this.patch}`;
          if (this.prerelease.length) {
            this.version += `-${this.prerelease.join(".")}`;
          }
          return this.version;
        }
        toString() {
          return this.version;
        }
        compare(other) {
          debug2("SemVer.compare", this.version, this.options, other);
          if (!(other instanceof SemVer)) {
            if (typeof other === "string" && other === this.version) {
              return 0;
            }
            other = new SemVer(other, this.options);
          }
          if (other.version === this.version) {
            return 0;
          }
          return this.compareMain(other) || this.comparePre(other);
        }
        compareMain(other) {
          if (!(other instanceof SemVer)) {
            other = new SemVer(other, this.options);
          }
          return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
        }
        comparePre(other) {
          if (!(other instanceof SemVer)) {
            other = new SemVer(other, this.options);
          }
          if (this.prerelease.length && !other.prerelease.length) {
            return -1;
          } else if (!this.prerelease.length && other.prerelease.length) {
            return 1;
          } else if (!this.prerelease.length && !other.prerelease.length) {
            return 0;
          }
          let i = 0;
          do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            debug2("prerelease compare", i, a, b);
            if (a === void 0 && b === void 0) {
              return 0;
            } else if (b === void 0) {
              return 1;
            } else if (a === void 0) {
              return -1;
            } else if (a === b) {
              continue;
            } else {
              return compareIdentifiers(a, b);
            }
          } while (++i);
        }
        compareBuild(other) {
          if (!(other instanceof SemVer)) {
            other = new SemVer(other, this.options);
          }
          let i = 0;
          do {
            const a = this.build[i];
            const b = other.build[i];
            debug2("prerelease compare", i, a, b);
            if (a === void 0 && b === void 0) {
              return 0;
            } else if (b === void 0) {
              return 1;
            } else if (a === void 0) {
              return -1;
            } else if (a === b) {
              continue;
            } else {
              return compareIdentifiers(a, b);
            }
          } while (++i);
        }
        inc(release, identifier3) {
          switch (release) {
            case "premajor":
              this.prerelease.length = 0;
              this.patch = 0;
              this.minor = 0;
              this.major++;
              this.inc("pre", identifier3);
              break;
            case "preminor":
              this.prerelease.length = 0;
              this.patch = 0;
              this.minor++;
              this.inc("pre", identifier3);
              break;
            case "prepatch":
              this.prerelease.length = 0;
              this.inc("patch", identifier3);
              this.inc("pre", identifier3);
              break;
            case "prerelease":
              if (this.prerelease.length === 0) {
                this.inc("patch", identifier3);
              }
              this.inc("pre", identifier3);
              break;
            case "major":
              if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) {
                this.major++;
              }
              this.minor = 0;
              this.patch = 0;
              this.prerelease = [];
              break;
            case "minor":
              if (this.patch !== 0 || this.prerelease.length === 0) {
                this.minor++;
              }
              this.patch = 0;
              this.prerelease = [];
              break;
            case "patch":
              if (this.prerelease.length === 0) {
                this.patch++;
              }
              this.prerelease = [];
              break;
            case "pre":
              if (this.prerelease.length === 0) {
                this.prerelease = [0];
              } else {
                let i = this.prerelease.length;
                while (--i >= 0) {
                  if (typeof this.prerelease[i] === "number") {
                    this.prerelease[i]++;
                    i = -2;
                  }
                }
                if (i === -1) {
                  this.prerelease.push(0);
                }
              }
              if (identifier3) {
                if (compareIdentifiers(this.prerelease[0], identifier3) === 0) {
                  if (isNaN(this.prerelease[1])) {
                    this.prerelease = [identifier3, 0];
                  }
                } else {
                  this.prerelease = [identifier3, 0];
                }
              }
              break;
            default:
              throw new Error(`invalid increment argument: ${release}`);
          }
          this.format();
          this.raw = this.version;
          return this;
        }
      };
      module2.exports = SemVer;
    }
  });

  // node_modules/semver/functions/parse.js
  var require_parse2 = __commonJS({
    "node_modules/semver/functions/parse.js"(exports2, module2) {
      init_define_process();
      var { MAX_LENGTH } = require_constants2();
      var { re, t: t3 } = require_re();
      var SemVer = require_semver();
      var parseOptions = require_parse_options();
      var parse3 = (version, options) => {
        options = parseOptions(options);
        if (version instanceof SemVer) {
          return version;
        }
        if (typeof version !== "string") {
          return null;
        }
        if (version.length > MAX_LENGTH) {
          return null;
        }
        const r = options.loose ? re[t3.LOOSE] : re[t3.FULL];
        if (!r.test(version)) {
          return null;
        }
        try {
          return new SemVer(version, options);
        } catch (er) {
          return null;
        }
      };
      module2.exports = parse3;
    }
  });

  // node_modules/semver/functions/valid.js
  var require_valid = __commonJS({
    "node_modules/semver/functions/valid.js"(exports2, module2) {
      init_define_process();
      var parse3 = require_parse2();
      var valid = (version, options) => {
        const v = parse3(version, options);
        return v ? v.version : null;
      };
      module2.exports = valid;
    }
  });

  // node_modules/semver/functions/clean.js
  var require_clean = __commonJS({
    "node_modules/semver/functions/clean.js"(exports2, module2) {
      init_define_process();
      var parse3 = require_parse2();
      var clean = (version, options) => {
        const s = parse3(version.trim().replace(/^[=v]+/, ""), options);
        return s ? s.version : null;
      };
      module2.exports = clean;
    }
  });

  // node_modules/semver/functions/inc.js
  var require_inc = __commonJS({
    "node_modules/semver/functions/inc.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var inc = (version, release, options, identifier3) => {
        if (typeof options === "string") {
          identifier3 = options;
          options = void 0;
        }
        try {
          return new SemVer(
            version instanceof SemVer ? version.version : version,
            options
          ).inc(release, identifier3).version;
        } catch (er) {
          return null;
        }
      };
      module2.exports = inc;
    }
  });

  // node_modules/semver/functions/compare.js
  var require_compare = __commonJS({
    "node_modules/semver/functions/compare.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var compare = (a, b, loose) => new SemVer(a, loose).compare(new SemVer(b, loose));
      module2.exports = compare;
    }
  });

  // node_modules/semver/functions/eq.js
  var require_eq = __commonJS({
    "node_modules/semver/functions/eq.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var eq2 = (a, b, loose) => compare(a, b, loose) === 0;
      module2.exports = eq2;
    }
  });

  // node_modules/semver/functions/diff.js
  var require_diff = __commonJS({
    "node_modules/semver/functions/diff.js"(exports2, module2) {
      init_define_process();
      var parse3 = require_parse2();
      var eq2 = require_eq();
      var diff = (version1, version2) => {
        if (eq2(version1, version2)) {
          return null;
        } else {
          const v1 = parse3(version1);
          const v2 = parse3(version2);
          const hasPre = v1.prerelease.length || v2.prerelease.length;
          const prefix = hasPre ? "pre" : "";
          const defaultResult = hasPre ? "prerelease" : "";
          for (const key in v1) {
            if (key === "major" || key === "minor" || key === "patch") {
              if (v1[key] !== v2[key]) {
                return prefix + key;
              }
            }
          }
          return defaultResult;
        }
      };
      module2.exports = diff;
    }
  });

  // node_modules/semver/functions/major.js
  var require_major = __commonJS({
    "node_modules/semver/functions/major.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var major = (a, loose) => new SemVer(a, loose).major;
      module2.exports = major;
    }
  });

  // node_modules/semver/functions/minor.js
  var require_minor = __commonJS({
    "node_modules/semver/functions/minor.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var minor = (a, loose) => new SemVer(a, loose).minor;
      module2.exports = minor;
    }
  });

  // node_modules/semver/functions/patch.js
  var require_patch = __commonJS({
    "node_modules/semver/functions/patch.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var patch = (a, loose) => new SemVer(a, loose).patch;
      module2.exports = patch;
    }
  });

  // node_modules/semver/functions/prerelease.js
  var require_prerelease = __commonJS({
    "node_modules/semver/functions/prerelease.js"(exports2, module2) {
      init_define_process();
      var parse3 = require_parse2();
      var prerelease = (version, options) => {
        const parsed = parse3(version, options);
        return parsed && parsed.prerelease.length ? parsed.prerelease : null;
      };
      module2.exports = prerelease;
    }
  });

  // node_modules/semver/functions/rcompare.js
  var require_rcompare = __commonJS({
    "node_modules/semver/functions/rcompare.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var rcompare = (a, b, loose) => compare(b, a, loose);
      module2.exports = rcompare;
    }
  });

  // node_modules/semver/functions/compare-loose.js
  var require_compare_loose = __commonJS({
    "node_modules/semver/functions/compare-loose.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var compareLoose = (a, b) => compare(a, b, true);
      module2.exports = compareLoose;
    }
  });

  // node_modules/semver/functions/compare-build.js
  var require_compare_build = __commonJS({
    "node_modules/semver/functions/compare-build.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var compareBuild = (a, b, loose) => {
        const versionA = new SemVer(a, loose);
        const versionB = new SemVer(b, loose);
        return versionA.compare(versionB) || versionA.compareBuild(versionB);
      };
      module2.exports = compareBuild;
    }
  });

  // node_modules/semver/functions/sort.js
  var require_sort = __commonJS({
    "node_modules/semver/functions/sort.js"(exports2, module2) {
      init_define_process();
      var compareBuild = require_compare_build();
      var sort = (list, loose) => list.sort((a, b) => compareBuild(a, b, loose));
      module2.exports = sort;
    }
  });

  // node_modules/semver/functions/rsort.js
  var require_rsort = __commonJS({
    "node_modules/semver/functions/rsort.js"(exports2, module2) {
      init_define_process();
      var compareBuild = require_compare_build();
      var rsort = (list, loose) => list.sort((a, b) => compareBuild(b, a, loose));
      module2.exports = rsort;
    }
  });

  // node_modules/semver/functions/gt.js
  var require_gt = __commonJS({
    "node_modules/semver/functions/gt.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var gt2 = (a, b, loose) => compare(a, b, loose) > 0;
      module2.exports = gt2;
    }
  });

  // node_modules/semver/functions/lt.js
  var require_lt = __commonJS({
    "node_modules/semver/functions/lt.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var lt2 = (a, b, loose) => compare(a, b, loose) < 0;
      module2.exports = lt2;
    }
  });

  // node_modules/semver/functions/neq.js
  var require_neq = __commonJS({
    "node_modules/semver/functions/neq.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var neq = (a, b, loose) => compare(a, b, loose) !== 0;
      module2.exports = neq;
    }
  });

  // node_modules/semver/functions/gte.js
  var require_gte = __commonJS({
    "node_modules/semver/functions/gte.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var gte2 = (a, b, loose) => compare(a, b, loose) >= 0;
      module2.exports = gte2;
    }
  });

  // node_modules/semver/functions/lte.js
  var require_lte = __commonJS({
    "node_modules/semver/functions/lte.js"(exports2, module2) {
      init_define_process();
      var compare = require_compare();
      var lte2 = (a, b, loose) => compare(a, b, loose) <= 0;
      module2.exports = lte2;
    }
  });

  // node_modules/semver/functions/cmp.js
  var require_cmp = __commonJS({
    "node_modules/semver/functions/cmp.js"(exports2, module2) {
      init_define_process();
      var eq2 = require_eq();
      var neq = require_neq();
      var gt2 = require_gt();
      var gte2 = require_gte();
      var lt2 = require_lt();
      var lte2 = require_lte();
      var cmp = (a, op, b, loose) => {
        switch (op) {
          case "===":
            if (typeof a === "object") {
              a = a.version;
            }
            if (typeof b === "object") {
              b = b.version;
            }
            return a === b;
          case "!==":
            if (typeof a === "object") {
              a = a.version;
            }
            if (typeof b === "object") {
              b = b.version;
            }
            return a !== b;
          case "":
          case "=":
          case "==":
            return eq2(a, b, loose);
          case "!=":
            return neq(a, b, loose);
          case ">":
            return gt2(a, b, loose);
          case ">=":
            return gte2(a, b, loose);
          case "<":
            return lt2(a, b, loose);
          case "<=":
            return lte2(a, b, loose);
          default:
            throw new TypeError(`Invalid operator: ${op}`);
        }
      };
      module2.exports = cmp;
    }
  });

  // node_modules/semver/functions/coerce.js
  var require_coerce = __commonJS({
    "node_modules/semver/functions/coerce.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var parse3 = require_parse2();
      var { re, t: t3 } = require_re();
      var coerce = (version, options) => {
        if (version instanceof SemVer) {
          return version;
        }
        if (typeof version === "number") {
          version = String(version);
        }
        if (typeof version !== "string") {
          return null;
        }
        options = options || {};
        let match = null;
        if (!options.rtl) {
          match = version.match(re[t3.COERCE]);
        } else {
          let next;
          while ((next = re[t3.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)) {
            if (!match || next.index + next[0].length !== match.index + match[0].length) {
              match = next;
            }
            re[t3.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
          }
          re[t3.COERCERTL].lastIndex = -1;
        }
        if (match === null) {
          return null;
        }
        return parse3(`${match[2]}.${match[3] || "0"}.${match[4] || "0"}`, options);
      };
      module2.exports = coerce;
    }
  });

  // node_modules/yallist/iterator.js
  var require_iterator = __commonJS({
    "node_modules/yallist/iterator.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = function(Yallist) {
        Yallist.prototype[Symbol.iterator] = function* () {
          for (let walker = this.head; walker; walker = walker.next) {
            yield walker.value;
          }
        };
      };
    }
  });

  // node_modules/yallist/yallist.js
  var require_yallist = __commonJS({
    "node_modules/yallist/yallist.js"(exports2, module2) {
      "use strict";
      init_define_process();
      module2.exports = Yallist;
      Yallist.Node = Node2;
      Yallist.create = Yallist;
      function Yallist(list) {
        var self2 = this;
        if (!(self2 instanceof Yallist)) {
          self2 = new Yallist();
        }
        self2.tail = null;
        self2.head = null;
        self2.length = 0;
        if (list && typeof list.forEach === "function") {
          list.forEach(function(item) {
            self2.push(item);
          });
        } else if (arguments.length > 0) {
          for (var i = 0, l = arguments.length; i < l; i++) {
            self2.push(arguments[i]);
          }
        }
        return self2;
      }
      Yallist.prototype.removeNode = function(node) {
        if (node.list !== this) {
          throw new Error("removing node which does not belong to this list");
        }
        var next = node.next;
        var prev = node.prev;
        if (next) {
          next.prev = prev;
        }
        if (prev) {
          prev.next = next;
        }
        if (node === this.head) {
          this.head = next;
        }
        if (node === this.tail) {
          this.tail = prev;
        }
        node.list.length--;
        node.next = null;
        node.prev = null;
        node.list = null;
        return next;
      };
      Yallist.prototype.unshiftNode = function(node) {
        if (node === this.head) {
          return;
        }
        if (node.list) {
          node.list.removeNode(node);
        }
        var head2 = this.head;
        node.list = this;
        node.next = head2;
        if (head2) {
          head2.prev = node;
        }
        this.head = node;
        if (!this.tail) {
          this.tail = node;
        }
        this.length++;
      };
      Yallist.prototype.pushNode = function(node) {
        if (node === this.tail) {
          return;
        }
        if (node.list) {
          node.list.removeNode(node);
        }
        var tail2 = this.tail;
        node.list = this;
        node.prev = tail2;
        if (tail2) {
          tail2.next = node;
        }
        this.tail = node;
        if (!this.head) {
          this.head = node;
        }
        this.length++;
      };
      Yallist.prototype.push = function() {
        for (var i = 0, l = arguments.length; i < l; i++) {
          push(this, arguments[i]);
        }
        return this.length;
      };
      Yallist.prototype.unshift = function() {
        for (var i = 0, l = arguments.length; i < l; i++) {
          unshift(this, arguments[i]);
        }
        return this.length;
      };
      Yallist.prototype.pop = function() {
        if (!this.tail) {
          return void 0;
        }
        var res = this.tail.value;
        this.tail = this.tail.prev;
        if (this.tail) {
          this.tail.next = null;
        } else {
          this.head = null;
        }
        this.length--;
        return res;
      };
      Yallist.prototype.shift = function() {
        if (!this.head) {
          return void 0;
        }
        var res = this.head.value;
        this.head = this.head.next;
        if (this.head) {
          this.head.prev = null;
        } else {
          this.tail = null;
        }
        this.length--;
        return res;
      };
      Yallist.prototype.forEach = function(fn, thisp) {
        thisp = thisp || this;
        for (var walker = this.head, i = 0; walker !== null; i++) {
          fn.call(thisp, walker.value, i, this);
          walker = walker.next;
        }
      };
      Yallist.prototype.forEachReverse = function(fn, thisp) {
        thisp = thisp || this;
        for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
          fn.call(thisp, walker.value, i, this);
          walker = walker.prev;
        }
      };
      Yallist.prototype.get = function(n) {
        for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
          walker = walker.next;
        }
        if (i === n && walker !== null) {
          return walker.value;
        }
      };
      Yallist.prototype.getReverse = function(n) {
        for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
          walker = walker.prev;
        }
        if (i === n && walker !== null) {
          return walker.value;
        }
      };
      Yallist.prototype.map = function(fn, thisp) {
        thisp = thisp || this;
        var res = new Yallist();
        for (var walker = this.head; walker !== null; ) {
          res.push(fn.call(thisp, walker.value, this));
          walker = walker.next;
        }
        return res;
      };
      Yallist.prototype.mapReverse = function(fn, thisp) {
        thisp = thisp || this;
        var res = new Yallist();
        for (var walker = this.tail; walker !== null; ) {
          res.push(fn.call(thisp, walker.value, this));
          walker = walker.prev;
        }
        return res;
      };
      Yallist.prototype.reduce = function(fn, initial2) {
        var acc;
        var walker = this.head;
        if (arguments.length > 1) {
          acc = initial2;
        } else if (this.head) {
          walker = this.head.next;
          acc = this.head.value;
        } else {
          throw new TypeError("Reduce of empty list with no initial value");
        }
        for (var i = 0; walker !== null; i++) {
          acc = fn(acc, walker.value, i);
          walker = walker.next;
        }
        return acc;
      };
      Yallist.prototype.reduceReverse = function(fn, initial2) {
        var acc;
        var walker = this.tail;
        if (arguments.length > 1) {
          acc = initial2;
        } else if (this.tail) {
          walker = this.tail.prev;
          acc = this.tail.value;
        } else {
          throw new TypeError("Reduce of empty list with no initial value");
        }
        for (var i = this.length - 1; walker !== null; i--) {
          acc = fn(acc, walker.value, i);
          walker = walker.prev;
        }
        return acc;
      };
      Yallist.prototype.toArray = function() {
        var arr = new Array(this.length);
        for (var i = 0, walker = this.head; walker !== null; i++) {
          arr[i] = walker.value;
          walker = walker.next;
        }
        return arr;
      };
      Yallist.prototype.toArrayReverse = function() {
        var arr = new Array(this.length);
        for (var i = 0, walker = this.tail; walker !== null; i++) {
          arr[i] = walker.value;
          walker = walker.prev;
        }
        return arr;
      };
      Yallist.prototype.slice = function(from, to) {
        to = to || this.length;
        if (to < 0) {
          to += this.length;
        }
        from = from || 0;
        if (from < 0) {
          from += this.length;
        }
        var ret = new Yallist();
        if (to < from || to < 0) {
          return ret;
        }
        if (from < 0) {
          from = 0;
        }
        if (to > this.length) {
          to = this.length;
        }
        for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
          walker = walker.next;
        }
        for (; walker !== null && i < to; i++, walker = walker.next) {
          ret.push(walker.value);
        }
        return ret;
      };
      Yallist.prototype.sliceReverse = function(from, to) {
        to = to || this.length;
        if (to < 0) {
          to += this.length;
        }
        from = from || 0;
        if (from < 0) {
          from += this.length;
        }
        var ret = new Yallist();
        if (to < from || to < 0) {
          return ret;
        }
        if (from < 0) {
          from = 0;
        }
        if (to > this.length) {
          to = this.length;
        }
        for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
          walker = walker.prev;
        }
        for (; walker !== null && i > from; i--, walker = walker.prev) {
          ret.push(walker.value);
        }
        return ret;
      };
      Yallist.prototype.splice = function(start, deleteCount, ...nodes) {
        if (start > this.length) {
          start = this.length - 1;
        }
        if (start < 0) {
          start = this.length + start;
        }
        for (var i = 0, walker = this.head; walker !== null && i < start; i++) {
          walker = walker.next;
        }
        var ret = [];
        for (var i = 0; walker && i < deleteCount; i++) {
          ret.push(walker.value);
          walker = this.removeNode(walker);
        }
        if (walker === null) {
          walker = this.tail;
        }
        if (walker !== this.head && walker !== this.tail) {
          walker = walker.prev;
        }
        for (var i = 0; i < nodes.length; i++) {
          walker = insert(this, walker, nodes[i]);
        }
        return ret;
      };
      Yallist.prototype.reverse = function() {
        var head2 = this.head;
        var tail2 = this.tail;
        for (var walker = head2; walker !== null; walker = walker.prev) {
          var p = walker.prev;
          walker.prev = walker.next;
          walker.next = p;
        }
        this.head = tail2;
        this.tail = head2;
        return this;
      };
      function insert(self2, node, value) {
        var inserted = node === self2.head ? new Node2(value, null, node, self2) : new Node2(value, node, node.next, self2);
        if (inserted.next === null) {
          self2.tail = inserted;
        }
        if (inserted.prev === null) {
          self2.head = inserted;
        }
        self2.length++;
        return inserted;
      }
      function push(self2, item) {
        self2.tail = new Node2(item, self2.tail, null, self2);
        if (!self2.head) {
          self2.head = self2.tail;
        }
        self2.length++;
      }
      function unshift(self2, item) {
        self2.head = new Node2(item, null, self2.head, self2);
        if (!self2.tail) {
          self2.tail = self2.head;
        }
        self2.length++;
      }
      function Node2(value, prev, next, list) {
        if (!(this instanceof Node2)) {
          return new Node2(value, prev, next, list);
        }
        this.list = list;
        this.value = value;
        if (prev) {
          prev.next = this;
          this.prev = prev;
        } else {
          this.prev = null;
        }
        if (next) {
          next.prev = this;
          this.next = next;
        } else {
          this.next = null;
        }
      }
      try {
        require_iterator()(Yallist);
      } catch (er) {
      }
    }
  });

  // node_modules/lru-cache/index.js
  var require_lru_cache = __commonJS({
    "node_modules/lru-cache/index.js"(exports2, module2) {
      "use strict";
      init_define_process();
      var Yallist = require_yallist();
      var MAX = Symbol("max");
      var LENGTH = Symbol("length");
      var LENGTH_CALCULATOR = Symbol("lengthCalculator");
      var ALLOW_STALE = Symbol("allowStale");
      var MAX_AGE = Symbol("maxAge");
      var DISPOSE = Symbol("dispose");
      var NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
      var LRU_LIST = Symbol("lruList");
      var CACHE = Symbol("cache");
      var UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
      var naiveLength = () => 1;
      var LRUCache = class {
        constructor(options) {
          if (typeof options === "number")
            options = { max: options };
          if (!options)
            options = {};
          if (options.max && (typeof options.max !== "number" || options.max < 0))
            throw new TypeError("max must be a non-negative number");
          const max2 = this[MAX] = options.max || Infinity;
          const lc = options.length || naiveLength;
          this[LENGTH_CALCULATOR] = typeof lc !== "function" ? naiveLength : lc;
          this[ALLOW_STALE] = options.stale || false;
          if (options.maxAge && typeof options.maxAge !== "number")
            throw new TypeError("maxAge must be a number");
          this[MAX_AGE] = options.maxAge || 0;
          this[DISPOSE] = options.dispose;
          this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
          this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
          this.reset();
        }
        set max(mL) {
          if (typeof mL !== "number" || mL < 0)
            throw new TypeError("max must be a non-negative number");
          this[MAX] = mL || Infinity;
          trim2(this);
        }
        get max() {
          return this[MAX];
        }
        set allowStale(allowStale) {
          this[ALLOW_STALE] = !!allowStale;
        }
        get allowStale() {
          return this[ALLOW_STALE];
        }
        set maxAge(mA) {
          if (typeof mA !== "number")
            throw new TypeError("maxAge must be a non-negative number");
          this[MAX_AGE] = mA;
          trim2(this);
        }
        get maxAge() {
          return this[MAX_AGE];
        }
        set lengthCalculator(lC) {
          if (typeof lC !== "function")
            lC = naiveLength;
          if (lC !== this[LENGTH_CALCULATOR]) {
            this[LENGTH_CALCULATOR] = lC;
            this[LENGTH] = 0;
            this[LRU_LIST].forEach((hit) => {
              hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
              this[LENGTH] += hit.length;
            });
          }
          trim2(this);
        }
        get lengthCalculator() {
          return this[LENGTH_CALCULATOR];
        }
        get length() {
          return this[LENGTH];
        }
        get itemCount() {
          return this[LRU_LIST].length;
        }
        rforEach(fn, thisp) {
          thisp = thisp || this;
          for (let walker = this[LRU_LIST].tail; walker !== null; ) {
            const prev = walker.prev;
            forEachStep(this, fn, walker, thisp);
            walker = prev;
          }
        }
        forEach(fn, thisp) {
          thisp = thisp || this;
          for (let walker = this[LRU_LIST].head; walker !== null; ) {
            const next = walker.next;
            forEachStep(this, fn, walker, thisp);
            walker = next;
          }
        }
        keys() {
          return this[LRU_LIST].toArray().map((k) => k.key);
        }
        values() {
          return this[LRU_LIST].toArray().map((k) => k.value);
        }
        reset() {
          if (this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length) {
            this[LRU_LIST].forEach((hit) => this[DISPOSE](hit.key, hit.value));
          }
          this[CACHE] = /* @__PURE__ */ new Map();
          this[LRU_LIST] = new Yallist();
          this[LENGTH] = 0;
        }
        dump() {
          return this[LRU_LIST].map((hit) => isStale(this, hit) ? false : {
            k: hit.key,
            v: hit.value,
            e: hit.now + (hit.maxAge || 0)
          }).toArray().filter((h) => h);
        }
        dumpLru() {
          return this[LRU_LIST];
        }
        set(key, value, maxAge) {
          maxAge = maxAge || this[MAX_AGE];
          if (maxAge && typeof maxAge !== "number")
            throw new TypeError("maxAge must be a number");
          const now2 = maxAge ? Date.now() : 0;
          const len = this[LENGTH_CALCULATOR](value, key);
          if (this[CACHE].has(key)) {
            if (len > this[MAX]) {
              del(this, this[CACHE].get(key));
              return false;
            }
            const node = this[CACHE].get(key);
            const item = node.value;
            if (this[DISPOSE]) {
              if (!this[NO_DISPOSE_ON_SET])
                this[DISPOSE](key, item.value);
            }
            item.now = now2;
            item.maxAge = maxAge;
            item.value = value;
            this[LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            trim2(this);
            return true;
          }
          const hit = new Entry(key, value, len, now2, maxAge);
          if (hit.length > this[MAX]) {
            if (this[DISPOSE])
              this[DISPOSE](key, value);
            return false;
          }
          this[LENGTH] += hit.length;
          this[LRU_LIST].unshift(hit);
          this[CACHE].set(key, this[LRU_LIST].head);
          trim2(this);
          return true;
        }
        has(key) {
          if (!this[CACHE].has(key))
            return false;
          const hit = this[CACHE].get(key).value;
          return !isStale(this, hit);
        }
        get(key) {
          return get2(this, key, true);
        }
        peek(key) {
          return get2(this, key, false);
        }
        pop() {
          const node = this[LRU_LIST].tail;
          if (!node)
            return null;
          del(this, node);
          return node.value;
        }
        del(key) {
          del(this, this[CACHE].get(key));
        }
        load(arr) {
          this.reset();
          const now2 = Date.now();
          for (let l = arr.length - 1; l >= 0; l--) {
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0)
              this.set(hit.k, hit.v);
            else {
              const maxAge = expiresAt - now2;
              if (maxAge > 0) {
                this.set(hit.k, hit.v, maxAge);
              }
            }
          }
        }
        prune() {
          this[CACHE].forEach((value, key) => get2(this, key, false));
        }
      };
      var get2 = (self2, key, doUse) => {
        const node = self2[CACHE].get(key);
        if (node) {
          const hit = node.value;
          if (isStale(self2, hit)) {
            del(self2, node);
            if (!self2[ALLOW_STALE])
              return void 0;
          } else {
            if (doUse) {
              if (self2[UPDATE_AGE_ON_GET])
                node.value.now = Date.now();
              self2[LRU_LIST].unshiftNode(node);
            }
          }
          return hit.value;
        }
      };
      var isStale = (self2, hit) => {
        if (!hit || !hit.maxAge && !self2[MAX_AGE])
          return false;
        const diff = Date.now() - hit.now;
        return hit.maxAge ? diff > hit.maxAge : self2[MAX_AGE] && diff > self2[MAX_AGE];
      };
      var trim2 = (self2) => {
        if (self2[LENGTH] > self2[MAX]) {
          for (let walker = self2[LRU_LIST].tail; self2[LENGTH] > self2[MAX] && walker !== null; ) {
            const prev = walker.prev;
            del(self2, walker);
            walker = prev;
          }
        }
      };
      var del = (self2, node) => {
        if (node) {
          const hit = node.value;
          if (self2[DISPOSE])
            self2[DISPOSE](hit.key, hit.value);
          self2[LENGTH] -= hit.length;
          self2[CACHE].delete(hit.key);
          self2[LRU_LIST].removeNode(node);
        }
      };
      var Entry = class {
        constructor(key, value, length, now2, maxAge) {
          this.key = key;
          this.value = value;
          this.length = length;
          this.now = now2;
          this.maxAge = maxAge || 0;
        }
      };
      var forEachStep = (self2, fn, node, thisp) => {
        let hit = node.value;
        if (isStale(self2, hit)) {
          del(self2, node);
          if (!self2[ALLOW_STALE])
            hit = void 0;
        }
        if (hit)
          fn.call(thisp, hit.value, hit.key, self2);
      };
      module2.exports = LRUCache;
    }
  });

  // node_modules/semver/classes/range.js
  var require_range = __commonJS({
    "node_modules/semver/classes/range.js"(exports2, module2) {
      init_define_process();
      var Range = class {
        constructor(range2, options) {
          options = parseOptions(options);
          if (range2 instanceof Range) {
            if (range2.loose === !!options.loose && range2.includePrerelease === !!options.includePrerelease) {
              return range2;
            } else {
              return new Range(range2.raw, options);
            }
          }
          if (range2 instanceof Comparator) {
            this.raw = range2.value;
            this.set = [[range2]];
            this.format();
            return this;
          }
          this.options = options;
          this.loose = !!options.loose;
          this.includePrerelease = !!options.includePrerelease;
          this.raw = range2;
          this.set = range2.split("||").map((r) => this.parseRange(r.trim())).filter((c) => c.length);
          if (!this.set.length) {
            throw new TypeError(`Invalid SemVer Range: ${range2}`);
          }
          if (this.set.length > 1) {
            const first = this.set[0];
            this.set = this.set.filter((c) => !isNullSet(c[0]));
            if (this.set.length === 0) {
              this.set = [first];
            } else if (this.set.length > 1) {
              for (const c of this.set) {
                if (c.length === 1 && isAny(c[0])) {
                  this.set = [c];
                  break;
                }
              }
            }
          }
          this.format();
        }
        format() {
          this.range = this.set.map((comps) => {
            return comps.join(" ").trim();
          }).join("||").trim();
          return this.range;
        }
        toString() {
          return this.range;
        }
        parseRange(range2) {
          range2 = range2.trim();
          const memoOpts = Object.keys(this.options).join(",");
          const memoKey = `parseRange:${memoOpts}:${range2}`;
          const cached = cache.get(memoKey);
          if (cached) {
            return cached;
          }
          const loose = this.options.loose;
          const hr = loose ? re[t3.HYPHENRANGELOOSE] : re[t3.HYPHENRANGE];
          range2 = range2.replace(hr, hyphenReplace(this.options.includePrerelease));
          debug2("hyphen replace", range2);
          range2 = range2.replace(re[t3.COMPARATORTRIM], comparatorTrimReplace);
          debug2("comparator trim", range2);
          range2 = range2.replace(re[t3.TILDETRIM], tildeTrimReplace);
          range2 = range2.replace(re[t3.CARETTRIM], caretTrimReplace);
          range2 = range2.split(/\s+/).join(" ");
          let rangeList = range2.split(" ").map((comp) => parseComparator(comp, this.options)).join(" ").split(/\s+/).map((comp) => replaceGTE0(comp, this.options));
          if (loose) {
            rangeList = rangeList.filter((comp) => {
              debug2("loose invalid filter", comp, this.options);
              return !!comp.match(re[t3.COMPARATORLOOSE]);
            });
          }
          debug2("range list", rangeList);
          const rangeMap = /* @__PURE__ */ new Map();
          const comparators = rangeList.map((comp) => new Comparator(comp, this.options));
          for (const comp of comparators) {
            if (isNullSet(comp)) {
              return [comp];
            }
            rangeMap.set(comp.value, comp);
          }
          if (rangeMap.size > 1 && rangeMap.has("")) {
            rangeMap.delete("");
          }
          const result2 = [...rangeMap.values()];
          cache.set(memoKey, result2);
          return result2;
        }
        intersects(range2, options) {
          if (!(range2 instanceof Range)) {
            throw new TypeError("a Range is required");
          }
          return this.set.some((thisComparators) => {
            return isSatisfiable(thisComparators, options) && range2.set.some((rangeComparators) => {
              return isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator) => {
                return rangeComparators.every((rangeComparator) => {
                  return thisComparator.intersects(rangeComparator, options);
                });
              });
            });
          });
        }
        test(version) {
          if (!version) {
            return false;
          }
          if (typeof version === "string") {
            try {
              version = new SemVer(version, this.options);
            } catch (er) {
              return false;
            }
          }
          for (let i = 0; i < this.set.length; i++) {
            if (testSet(this.set[i], version, this.options)) {
              return true;
            }
          }
          return false;
        }
      };
      module2.exports = Range;
      var LRU = require_lru_cache();
      var cache = new LRU({ max: 1e3 });
      var parseOptions = require_parse_options();
      var Comparator = require_comparator();
      var debug2 = require_debug2();
      var SemVer = require_semver();
      var {
        re,
        t: t3,
        comparatorTrimReplace,
        tildeTrimReplace,
        caretTrimReplace
      } = require_re();
      var isNullSet = (c) => c.value === "<0.0.0-0";
      var isAny = (c) => c.value === "";
      var isSatisfiable = (comparators, options) => {
        let result2 = true;
        const remainingComparators = comparators.slice();
        let testComparator = remainingComparators.pop();
        while (result2 && remainingComparators.length) {
          result2 = remainingComparators.every((otherComparator) => {
            return testComparator.intersects(otherComparator, options);
          });
          testComparator = remainingComparators.pop();
        }
        return result2;
      };
      var parseComparator = (comp, options) => {
        debug2("comp", comp, options);
        comp = replaceCarets(comp, options);
        debug2("caret", comp);
        comp = replaceTildes(comp, options);
        debug2("tildes", comp);
        comp = replaceXRanges(comp, options);
        debug2("xrange", comp);
        comp = replaceStars(comp, options);
        debug2("stars", comp);
        return comp;
      };
      var isX = (id) => !id || id.toLowerCase() === "x" || id === "*";
      var replaceTildes = (comp, options) => comp.trim().split(/\s+/).map((c) => {
        return replaceTilde(c, options);
      }).join(" ");
      var replaceTilde = (comp, options) => {
        const r = options.loose ? re[t3.TILDELOOSE] : re[t3.TILDE];
        return comp.replace(r, (_, M, m, p, pr) => {
          debug2("tilde", comp, _, M, m, p, pr);
          let ret;
          if (isX(M)) {
            ret = "";
          } else if (isX(m)) {
            ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
          } else if (isX(p)) {
            ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
          } else if (pr) {
            debug2("replaceTilde pr", pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
          } else {
            ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
          }
          debug2("tilde return", ret);
          return ret;
        });
      };
      var replaceCarets = (comp, options) => comp.trim().split(/\s+/).map((c) => {
        return replaceCaret(c, options);
      }).join(" ");
      var replaceCaret = (comp, options) => {
        debug2("caret", comp, options);
        const r = options.loose ? re[t3.CARETLOOSE] : re[t3.CARET];
        const z = options.includePrerelease ? "-0" : "";
        return comp.replace(r, (_, M, m, p, pr) => {
          debug2("caret", comp, _, M, m, p, pr);
          let ret;
          if (isX(M)) {
            ret = "";
          } else if (isX(m)) {
            ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
          } else if (isX(p)) {
            if (M === "0") {
              ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            } else {
              ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
            }
          } else if (pr) {
            debug2("replaceCaret pr", pr);
            if (M === "0") {
              if (m === "0") {
                ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
              } else {
                ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
              }
            } else {
              ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
            }
          } else {
            debug2("no pr");
            if (M === "0") {
              if (m === "0") {
                ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
              } else {
                ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
              }
            } else {
              ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
            }
          }
          debug2("caret return", ret);
          return ret;
        });
      };
      var replaceXRanges = (comp, options) => {
        debug2("replaceXRanges", comp, options);
        return comp.split(/\s+/).map((c) => {
          return replaceXRange(c, options);
        }).join(" ");
      };
      var replaceXRange = (comp, options) => {
        comp = comp.trim();
        const r = options.loose ? re[t3.XRANGELOOSE] : re[t3.XRANGE];
        return comp.replace(r, (ret, gtlt, M, m, p, pr) => {
          debug2("xRange", comp, ret, gtlt, M, m, p, pr);
          const xM = isX(M);
          const xm = xM || isX(m);
          const xp = xm || isX(p);
          const anyX = xp;
          if (gtlt === "=" && anyX) {
            gtlt = "";
          }
          pr = options.includePrerelease ? "-0" : "";
          if (xM) {
            if (gtlt === ">" || gtlt === "<") {
              ret = "<0.0.0-0";
            } else {
              ret = "*";
            }
          } else if (gtlt && anyX) {
            if (xm) {
              m = 0;
            }
            p = 0;
            if (gtlt === ">") {
              gtlt = ">=";
              if (xm) {
                M = +M + 1;
                m = 0;
                p = 0;
              } else {
                m = +m + 1;
                p = 0;
              }
            } else if (gtlt === "<=") {
              gtlt = "<";
              if (xm) {
                M = +M + 1;
              } else {
                m = +m + 1;
              }
            }
            if (gtlt === "<") {
              pr = "-0";
            }
            ret = `${gtlt + M}.${m}.${p}${pr}`;
          } else if (xm) {
            ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
          } else if (xp) {
            ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
          }
          debug2("xRange return", ret);
          return ret;
        });
      };
      var replaceStars = (comp, options) => {
        debug2("replaceStars", comp, options);
        return comp.trim().replace(re[t3.STAR], "");
      };
      var replaceGTE0 = (comp, options) => {
        debug2("replaceGTE0", comp, options);
        return comp.trim().replace(re[options.includePrerelease ? t3.GTE0PRE : t3.GTE0], "");
      };
      var hyphenReplace = (incPr) => ($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) => {
        if (isX(fM)) {
          from = "";
        } else if (isX(fm)) {
          from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
        } else if (isX(fp)) {
          from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
        } else if (fpr) {
          from = `>=${from}`;
        } else {
          from = `>=${from}${incPr ? "-0" : ""}`;
        }
        if (isX(tM)) {
          to = "";
        } else if (isX(tm)) {
          to = `<${+tM + 1}.0.0-0`;
        } else if (isX(tp)) {
          to = `<${tM}.${+tm + 1}.0-0`;
        } else if (tpr) {
          to = `<=${tM}.${tm}.${tp}-${tpr}`;
        } else if (incPr) {
          to = `<${tM}.${tm}.${+tp + 1}-0`;
        } else {
          to = `<=${to}`;
        }
        return `${from} ${to}`.trim();
      };
      var testSet = (set2, version, options) => {
        for (let i = 0; i < set2.length; i++) {
          if (!set2[i].test(version)) {
            return false;
          }
        }
        if (version.prerelease.length && !options.includePrerelease) {
          for (let i = 0; i < set2.length; i++) {
            debug2(set2[i].semver);
            if (set2[i].semver === Comparator.ANY) {
              continue;
            }
            if (set2[i].semver.prerelease.length > 0) {
              const allowed = set2[i].semver;
              if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) {
                return true;
              }
            }
          }
          return false;
        }
        return true;
      };
    }
  });

  // node_modules/semver/classes/comparator.js
  var require_comparator = __commonJS({
    "node_modules/semver/classes/comparator.js"(exports2, module2) {
      init_define_process();
      var ANY = Symbol("SemVer ANY");
      var Comparator = class {
        static get ANY() {
          return ANY;
        }
        constructor(comp, options) {
          options = parseOptions(options);
          if (comp instanceof Comparator) {
            if (comp.loose === !!options.loose) {
              return comp;
            } else {
              comp = comp.value;
            }
          }
          debug2("comparator", comp, options);
          this.options = options;
          this.loose = !!options.loose;
          this.parse(comp);
          if (this.semver === ANY) {
            this.value = "";
          } else {
            this.value = this.operator + this.semver.version;
          }
          debug2("comp", this);
        }
        parse(comp) {
          const r = this.options.loose ? re[t3.COMPARATORLOOSE] : re[t3.COMPARATOR];
          const m = comp.match(r);
          if (!m) {
            throw new TypeError(`Invalid comparator: ${comp}`);
          }
          this.operator = m[1] !== void 0 ? m[1] : "";
          if (this.operator === "=") {
            this.operator = "";
          }
          if (!m[2]) {
            this.semver = ANY;
          } else {
            this.semver = new SemVer(m[2], this.options.loose);
          }
        }
        toString() {
          return this.value;
        }
        test(version) {
          debug2("Comparator.test", version, this.options.loose);
          if (this.semver === ANY || version === ANY) {
            return true;
          }
          if (typeof version === "string") {
            try {
              version = new SemVer(version, this.options);
            } catch (er) {
              return false;
            }
          }
          return cmp(version, this.operator, this.semver, this.options);
        }
        intersects(comp, options) {
          if (!(comp instanceof Comparator)) {
            throw new TypeError("a Comparator is required");
          }
          if (!options || typeof options !== "object") {
            options = {
              loose: !!options,
              includePrerelease: false
            };
          }
          if (this.operator === "") {
            if (this.value === "") {
              return true;
            }
            return new Range(comp.value, options).test(this.value);
          } else if (comp.operator === "") {
            if (comp.value === "") {
              return true;
            }
            return new Range(this.value, options).test(comp.semver);
          }
          const sameDirectionIncreasing = (this.operator === ">=" || this.operator === ">") && (comp.operator === ">=" || comp.operator === ">");
          const sameDirectionDecreasing = (this.operator === "<=" || this.operator === "<") && (comp.operator === "<=" || comp.operator === "<");
          const sameSemVer = this.semver.version === comp.semver.version;
          const differentDirectionsInclusive = (this.operator === ">=" || this.operator === "<=") && (comp.operator === ">=" || comp.operator === "<=");
          const oppositeDirectionsLessThan = cmp(this.semver, "<", comp.semver, options) && (this.operator === ">=" || this.operator === ">") && (comp.operator === "<=" || comp.operator === "<");
          const oppositeDirectionsGreaterThan = cmp(this.semver, ">", comp.semver, options) && (this.operator === "<=" || this.operator === "<") && (comp.operator === ">=" || comp.operator === ">");
          return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
        }
      };
      module2.exports = Comparator;
      var parseOptions = require_parse_options();
      var { re, t: t3 } = require_re();
      var cmp = require_cmp();
      var debug2 = require_debug2();
      var SemVer = require_semver();
      var Range = require_range();
    }
  });

  // node_modules/semver/functions/satisfies.js
  var require_satisfies = __commonJS({
    "node_modules/semver/functions/satisfies.js"(exports2, module2) {
      init_define_process();
      var Range = require_range();
      var satisfies = (version, range2, options) => {
        try {
          range2 = new Range(range2, options);
        } catch (er) {
          return false;
        }
        return range2.test(version);
      };
      module2.exports = satisfies;
    }
  });

  // node_modules/semver/ranges/to-comparators.js
  var require_to_comparators = __commonJS({
    "node_modules/semver/ranges/to-comparators.js"(exports2, module2) {
      init_define_process();
      var Range = require_range();
      var toComparators = (range2, options) => new Range(range2, options).set.map((comp) => comp.map((c) => c.value).join(" ").trim().split(" "));
      module2.exports = toComparators;
    }
  });

  // node_modules/semver/ranges/max-satisfying.js
  var require_max_satisfying = __commonJS({
    "node_modules/semver/ranges/max-satisfying.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var Range = require_range();
      var maxSatisfying = (versions, range2, options) => {
        let max2 = null;
        let maxSV = null;
        let rangeObj = null;
        try {
          rangeObj = new Range(range2, options);
        } catch (er) {
          return null;
        }
        versions.forEach((v) => {
          if (rangeObj.test(v)) {
            if (!max2 || maxSV.compare(v) === -1) {
              max2 = v;
              maxSV = new SemVer(max2, options);
            }
          }
        });
        return max2;
      };
      module2.exports = maxSatisfying;
    }
  });

  // node_modules/semver/ranges/min-satisfying.js
  var require_min_satisfying = __commonJS({
    "node_modules/semver/ranges/min-satisfying.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var Range = require_range();
      var minSatisfying = (versions, range2, options) => {
        let min2 = null;
        let minSV = null;
        let rangeObj = null;
        try {
          rangeObj = new Range(range2, options);
        } catch (er) {
          return null;
        }
        versions.forEach((v) => {
          if (rangeObj.test(v)) {
            if (!min2 || minSV.compare(v) === 1) {
              min2 = v;
              minSV = new SemVer(min2, options);
            }
          }
        });
        return min2;
      };
      module2.exports = minSatisfying;
    }
  });

  // node_modules/semver/ranges/min-version.js
  var require_min_version = __commonJS({
    "node_modules/semver/ranges/min-version.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var Range = require_range();
      var gt2 = require_gt();
      var minVersion = (range2, loose) => {
        range2 = new Range(range2, loose);
        let minver = new SemVer("0.0.0");
        if (range2.test(minver)) {
          return minver;
        }
        minver = new SemVer("0.0.0-0");
        if (range2.test(minver)) {
          return minver;
        }
        minver = null;
        for (let i = 0; i < range2.set.length; ++i) {
          const comparators = range2.set[i];
          let setMin = null;
          comparators.forEach((comparator) => {
            const compver = new SemVer(comparator.semver.version);
            switch (comparator.operator) {
              case ">":
                if (compver.prerelease.length === 0) {
                  compver.patch++;
                } else {
                  compver.prerelease.push(0);
                }
                compver.raw = compver.format();
              case "":
              case ">=":
                if (!setMin || gt2(compver, setMin)) {
                  setMin = compver;
                }
                break;
              case "<":
              case "<=":
                break;
              default:
                throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
          });
          if (setMin && (!minver || gt2(minver, setMin))) {
            minver = setMin;
          }
        }
        if (minver && range2.test(minver)) {
          return minver;
        }
        return null;
      };
      module2.exports = minVersion;
    }
  });

  // node_modules/semver/ranges/valid.js
  var require_valid2 = __commonJS({
    "node_modules/semver/ranges/valid.js"(exports2, module2) {
      init_define_process();
      var Range = require_range();
      var validRange = (range2, options) => {
        try {
          return new Range(range2, options).range || "*";
        } catch (er) {
          return null;
        }
      };
      module2.exports = validRange;
    }
  });

  // node_modules/semver/ranges/outside.js
  var require_outside = __commonJS({
    "node_modules/semver/ranges/outside.js"(exports2, module2) {
      init_define_process();
      var SemVer = require_semver();
      var Comparator = require_comparator();
      var { ANY } = Comparator;
      var Range = require_range();
      var satisfies = require_satisfies();
      var gt2 = require_gt();
      var lt2 = require_lt();
      var lte2 = require_lte();
      var gte2 = require_gte();
      var outside = (version, range2, hilo, options) => {
        version = new SemVer(version, options);
        range2 = new Range(range2, options);
        let gtfn, ltefn, ltfn, comp, ecomp;
        switch (hilo) {
          case ">":
            gtfn = gt2;
            ltefn = lte2;
            ltfn = lt2;
            comp = ">";
            ecomp = ">=";
            break;
          case "<":
            gtfn = lt2;
            ltefn = gte2;
            ltfn = gt2;
            comp = "<";
            ecomp = "<=";
            break;
          default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
        }
        if (satisfies(version, range2, options)) {
          return false;
        }
        for (let i = 0; i < range2.set.length; ++i) {
          const comparators = range2.set[i];
          let high = null;
          let low = null;
          comparators.forEach((comparator) => {
            if (comparator.semver === ANY) {
              comparator = new Comparator(">=0.0.0");
            }
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) {
              high = comparator;
            } else if (ltfn(comparator.semver, low.semver, options)) {
              low = comparator;
            }
          });
          if (high.operator === comp || high.operator === ecomp) {
            return false;
          }
          if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) {
            return false;
          } else if (low.operator === ecomp && ltfn(version, low.semver)) {
            return false;
          }
        }
        return true;
      };
      module2.exports = outside;
    }
  });

  // node_modules/semver/ranges/gtr.js
  var require_gtr = __commonJS({
    "node_modules/semver/ranges/gtr.js"(exports2, module2) {
      init_define_process();
      var outside = require_outside();
      var gtr = (version, range2, options) => outside(version, range2, ">", options);
      module2.exports = gtr;
    }
  });

  // node_modules/semver/ranges/ltr.js
  var require_ltr = __commonJS({
    "node_modules/semver/ranges/ltr.js"(exports2, module2) {
      init_define_process();
      var outside = require_outside();
      var ltr = (version, range2, options) => outside(version, range2, "<", options);
      module2.exports = ltr;
    }
  });

  // node_modules/semver/ranges/intersects.js
  var require_intersects = __commonJS({
    "node_modules/semver/ranges/intersects.js"(exports2, module2) {
      init_define_process();
      var Range = require_range();
      var intersects = (r1, r2, options) => {
        r1 = new Range(r1, options);
        r2 = new Range(r2, options);
        return r1.intersects(r2);
      };
      module2.exports = intersects;
    }
  });

  // node_modules/semver/ranges/simplify.js
  var require_simplify = __commonJS({
    "node_modules/semver/ranges/simplify.js"(exports2, module2) {
      init_define_process();
      var satisfies = require_satisfies();
      var compare = require_compare();
      module2.exports = (versions, range2, options) => {
        const set2 = [];
        let first = null;
        let prev = null;
        const v = versions.sort((a, b) => compare(a, b, options));
        for (const version of v) {
          const included = satisfies(version, range2, options);
          if (included) {
            prev = version;
            if (!first) {
              first = version;
            }
          } else {
            if (prev) {
              set2.push([first, prev]);
            }
            prev = null;
            first = null;
          }
        }
        if (first) {
          set2.push([first, null]);
        }
        const ranges = [];
        for (const [min2, max2] of set2) {
          if (min2 === max2) {
            ranges.push(min2);
          } else if (!max2 && min2 === v[0]) {
            ranges.push("*");
          } else if (!max2) {
            ranges.push(`>=${min2}`);
          } else if (min2 === v[0]) {
            ranges.push(`<=${max2}`);
          } else {
            ranges.push(`${min2} - ${max2}`);
          }
        }
        const simplified = ranges.join(" || ");
        const original = typeof range2.raw === "string" ? range2.raw : String(range2);
        return simplified.length < original.length ? simplified : range2;
      };
    }
  });

  // node_modules/semver/ranges/subset.js
  var require_subset = __commonJS({
    "node_modules/semver/ranges/subset.js"(exports2, module2) {
      init_define_process();
      var Range = require_range();
      var Comparator = require_comparator();
      var { ANY } = Comparator;
      var satisfies = require_satisfies();
      var compare = require_compare();
      var subset = (sub, dom, options = {}) => {
        if (sub === dom) {
          return true;
        }
        sub = new Range(sub, options);
        dom = new Range(dom, options);
        let sawNonNull = false;
        OUTER:
          for (const simpleSub of sub.set) {
            for (const simpleDom of dom.set) {
              const isSub = simpleSubset(simpleSub, simpleDom, options);
              sawNonNull = sawNonNull || isSub !== null;
              if (isSub) {
                continue OUTER;
              }
            }
            if (sawNonNull) {
              return false;
            }
          }
        return true;
      };
      var simpleSubset = (sub, dom, options) => {
        if (sub === dom) {
          return true;
        }
        if (sub.length === 1 && sub[0].semver === ANY) {
          if (dom.length === 1 && dom[0].semver === ANY) {
            return true;
          } else if (options.includePrerelease) {
            sub = [new Comparator(">=0.0.0-0")];
          } else {
            sub = [new Comparator(">=0.0.0")];
          }
        }
        if (dom.length === 1 && dom[0].semver === ANY) {
          if (options.includePrerelease) {
            return true;
          } else {
            dom = [new Comparator(">=0.0.0")];
          }
        }
        const eqSet = /* @__PURE__ */ new Set();
        let gt2, lt2;
        for (const c of sub) {
          if (c.operator === ">" || c.operator === ">=") {
            gt2 = higherGT(gt2, c, options);
          } else if (c.operator === "<" || c.operator === "<=") {
            lt2 = lowerLT(lt2, c, options);
          } else {
            eqSet.add(c.semver);
          }
        }
        if (eqSet.size > 1) {
          return null;
        }
        let gtltComp;
        if (gt2 && lt2) {
          gtltComp = compare(gt2.semver, lt2.semver, options);
          if (gtltComp > 0) {
            return null;
          } else if (gtltComp === 0 && (gt2.operator !== ">=" || lt2.operator !== "<=")) {
            return null;
          }
        }
        for (const eq2 of eqSet) {
          if (gt2 && !satisfies(eq2, String(gt2), options)) {
            return null;
          }
          if (lt2 && !satisfies(eq2, String(lt2), options)) {
            return null;
          }
          for (const c of dom) {
            if (!satisfies(eq2, String(c), options)) {
              return false;
            }
          }
          return true;
        }
        let higher, lower;
        let hasDomLT, hasDomGT;
        let needDomLTPre = lt2 && !options.includePrerelease && lt2.semver.prerelease.length ? lt2.semver : false;
        let needDomGTPre = gt2 && !options.includePrerelease && gt2.semver.prerelease.length ? gt2.semver : false;
        if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt2.operator === "<" && needDomLTPre.prerelease[0] === 0) {
          needDomLTPre = false;
        }
        for (const c of dom) {
          hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=";
          hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=";
          if (gt2) {
            if (needDomGTPre) {
              if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) {
                needDomGTPre = false;
              }
            }
            if (c.operator === ">" || c.operator === ">=") {
              higher = higherGT(gt2, c, options);
              if (higher === c && higher !== gt2) {
                return false;
              }
            } else if (gt2.operator === ">=" && !satisfies(gt2.semver, String(c), options)) {
              return false;
            }
          }
          if (lt2) {
            if (needDomLTPre) {
              if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) {
                needDomLTPre = false;
              }
            }
            if (c.operator === "<" || c.operator === "<=") {
              lower = lowerLT(lt2, c, options);
              if (lower === c && lower !== lt2) {
                return false;
              }
            } else if (lt2.operator === "<=" && !satisfies(lt2.semver, String(c), options)) {
              return false;
            }
          }
          if (!c.operator && (lt2 || gt2) && gtltComp !== 0) {
            return false;
          }
        }
        if (gt2 && hasDomLT && !lt2 && gtltComp !== 0) {
          return false;
        }
        if (lt2 && hasDomGT && !gt2 && gtltComp !== 0) {
          return false;
        }
        if (needDomGTPre || needDomLTPre) {
          return false;
        }
        return true;
      };
      var higherGT = (a, b, options) => {
        if (!a) {
          return b;
        }
        const comp = compare(a.semver, b.semver, options);
        return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
      };
      var lowerLT = (a, b, options) => {
        if (!a) {
          return b;
        }
        const comp = compare(a.semver, b.semver, options);
        return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
      };
      module2.exports = subset;
    }
  });

  // node_modules/semver/index.js
  var require_semver2 = __commonJS({
    "node_modules/semver/index.js"(exports2, module2) {
      init_define_process();
      var internalRe = require_re();
      var constants = require_constants2();
      var SemVer = require_semver();
      var identifiers = require_identifiers();
      var parse3 = require_parse2();
      var valid = require_valid();
      var clean = require_clean();
      var inc = require_inc();
      var diff = require_diff();
      var major = require_major();
      var minor = require_minor();
      var patch = require_patch();
      var prerelease = require_prerelease();
      var compare = require_compare();
      var rcompare = require_rcompare();
      var compareLoose = require_compare_loose();
      var compareBuild = require_compare_build();
      var sort = require_sort();
      var rsort = require_rsort();
      var gt2 = require_gt();
      var lt2 = require_lt();
      var eq2 = require_eq();
      var neq = require_neq();
      var gte2 = require_gte();
      var lte2 = require_lte();
      var cmp = require_cmp();
      var coerce = require_coerce();
      var Comparator = require_comparator();
      var Range = require_range();
      var satisfies = require_satisfies();
      var toComparators = require_to_comparators();
      var maxSatisfying = require_max_satisfying();
      var minSatisfying = require_min_satisfying();
      var minVersion = require_min_version();
      var validRange = require_valid2();
      var outside = require_outside();
      var gtr = require_gtr();
      var ltr = require_ltr();
      var intersects = require_intersects();
      var simplifyRange = require_simplify();
      var subset = require_subset();
      module2.exports = {
        parse: parse3,
        valid,
        clean,
        inc,
        diff,
        major,
        minor,
        patch,
        prerelease,
        compare,
        rcompare,
        compareLoose,
        compareBuild,
        sort,
        rsort,
        gt: gt2,
        lt: lt2,
        eq: eq2,
        neq,
        gte: gte2,
        lte: lte2,
        cmp,
        coerce,
        Comparator,
        Range,
        satisfies,
        toComparators,
        maxSatisfying,
        minSatisfying,
        minVersion,
        validRange,
        outside,
        gtr,
        ltr,
        intersects,
        simplifyRange,
        subset,
        SemVer,
        re: internalRe.re,
        src: internalRe.src,
        tokens: internalRe.t,
        SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
        compareIdentifiers: identifiers.compareIdentifiers,
        rcompareIdentifiers: identifiers.rcompareIdentifiers
      };
    }
  });

  // src/standalone-worker.ts
  init_define_process();

  // src/standalone.ts
  init_define_process();

  // src/polyfills/buffer.ts
  init_define_process();
  var import_buffer = __toESM(require_buffer());
  if (self && !self.Buffer) {
    Object.assign(self, {
      Buffer: import_buffer.Buffer
    });
  }

  // src/generator/ProjectBuilder.ts
  init_define_process();

  // src/parser/SchemaParser.ts
  init_define_process();
  var import_change_case2 = __toESM(require_change_case());

  // src/types/index.ts
  init_define_process();

  // src/types/core.ts
  init_define_process();

  // src/types/deps.ts
  init_define_process();

  // src/types/error.ts
  init_define_process();
  var CodeGeneratorError = class extends Error {
    constructor(message, detail) {
      super(message);
      __publicField(this, "detail");
      this.name = this.constructor.name;
      this.detail = detail;
      Object.setPrototypeOf(this, new.target.prototype);
    }
  };
  var CompatibilityError = class extends CodeGeneratorError {
  };
  var PublisherError = class extends CodeGeneratorError {
  };

  // src/types/analyze.ts
  init_define_process();

  // src/types/intermediate.ts
  init_define_process();

  // src/types/publisher.ts
  init_define_process();

  // src/types/jsx.ts
  init_define_process();

  // src/const/index.ts
  var const_exports = {};
  __export(const_exports, {
    CLASS_DEFINE_CHUNK_NAME: () => CLASS_DEFINE_CHUNK_NAME,
    COMMON_CHUNK_NAME: () => COMMON_CHUNK_NAME,
    COMMON_SUB_MODULE_NAME: () => COMMON_SUB_MODULE_NAME,
    CONTAINER_TYPE: () => CONTAINER_TYPE,
    DEFAULT_LINK_AFTER: () => DEFAULT_LINK_AFTER,
    FILE_TYPE_FAMILY: () => FILE_TYPE_FAMILY,
    NATIVE_ELE_PKG: () => NATIVE_ELE_PKG,
    SUPPORT_SCHEMA_VERSION_LIST: () => SUPPORT_SCHEMA_VERSION_LIST
  });
  init_define_process();

  // src/const/file.ts
  init_define_process();
  var FILE_TYPE_FAMILY = [["tsx" /* TSX */, "ts" /* TS */, "jsx" /* JSX */, "js" /* JS */]];

  // src/const/generator.ts
  init_define_process();
  var COMMON_CHUNK_NAME = {
    ExternalDepsImport: "CommonExternalDependencyImport",
    InternalDepsImport: "CommonInternalDependencyImport",
    ImportAliasDefine: "CommonImportAliasDefine",
    FileVarDefine: "CommonFileScopeVarDefine",
    FileUtilDefine: "CommonFileScopeMethodDefine",
    FileMainContent: "CommonFileMainContent",
    FileExport: "CommonFileExport",
    StyleDepsImport: "CommonStyleDepsImport",
    StyleCssContent: "CommonStyleCssContent",
    HtmlContent: "CommonHtmlContent",
    CustomContent: "CommonCustomContent"
  };
  var CLASS_DEFINE_CHUNK_NAME = {
    Start: "CommonClassDefineStart",
    ConstructorStart: "CommonClassDefineConstructorStart",
    ConstructorContent: "CommonClassDefineConstructorContent",
    ConstructorEnd: "CommonClassDefineConstructorEnd",
    StaticVar: "CommonClassDefineStaticVar",
    StaticMethod: "CommonClassDefineStaticMethod",
    InsVar: "CommonClassDefineInsVar",
    InsVarMethod: "CommonClassDefineInsVarMethod",
    InsMethod: "CommonClassDefineInsMethod",
    InsPrivateMethod: "CommonClassDefineInsPrivateMethod",
    End: "CommonClassDefineEnd"
  };
  var DEFAULT_LINK_AFTER = {
    [COMMON_CHUNK_NAME.ExternalDepsImport]: [],
    [COMMON_CHUNK_NAME.InternalDepsImport]: [COMMON_CHUNK_NAME.ExternalDepsImport],
    [COMMON_CHUNK_NAME.ImportAliasDefine]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport
    ],
    [COMMON_CHUNK_NAME.FileVarDefine]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine
    ],
    [COMMON_CHUNK_NAME.FileUtilDefine]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine
    ],
    [CLASS_DEFINE_CHUNK_NAME.Start]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine,
      COMMON_CHUNK_NAME.FileUtilDefine
    ],
    [CLASS_DEFINE_CHUNK_NAME.ConstructorStart]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod
    ],
    [CLASS_DEFINE_CHUNK_NAME.ConstructorContent]: [CLASS_DEFINE_CHUNK_NAME.ConstructorStart],
    [CLASS_DEFINE_CHUNK_NAME.ConstructorEnd]: [
      CLASS_DEFINE_CHUNK_NAME.ConstructorStart,
      CLASS_DEFINE_CHUNK_NAME.ConstructorContent
    ],
    [CLASS_DEFINE_CHUNK_NAME.StaticVar]: [CLASS_DEFINE_CHUNK_NAME.Start],
    [CLASS_DEFINE_CHUNK_NAME.StaticMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsVar]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsVarMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod,
      CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
    ],
    [CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod,
      CLASS_DEFINE_CHUNK_NAME.InsMethod,
      CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
    ],
    [CLASS_DEFINE_CHUNK_NAME.End]: [
      CLASS_DEFINE_CHUNK_NAME.Start,
      CLASS_DEFINE_CHUNK_NAME.StaticVar,
      CLASS_DEFINE_CHUNK_NAME.StaticMethod,
      CLASS_DEFINE_CHUNK_NAME.InsVar,
      CLASS_DEFINE_CHUNK_NAME.InsVarMethod,
      CLASS_DEFINE_CHUNK_NAME.InsMethod,
      CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
      CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
    ],
    [COMMON_CHUNK_NAME.FileMainContent]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine,
      COMMON_CHUNK_NAME.FileUtilDefine,
      CLASS_DEFINE_CHUNK_NAME.End
    ],
    [COMMON_CHUNK_NAME.FileExport]: [
      COMMON_CHUNK_NAME.ExternalDepsImport,
      COMMON_CHUNK_NAME.InternalDepsImport,
      COMMON_CHUNK_NAME.ImportAliasDefine,
      COMMON_CHUNK_NAME.FileVarDefine,
      COMMON_CHUNK_NAME.FileUtilDefine,
      CLASS_DEFINE_CHUNK_NAME.End,
      COMMON_CHUNK_NAME.FileMainContent
    ],
    [COMMON_CHUNK_NAME.StyleDepsImport]: [],
    [COMMON_CHUNK_NAME.StyleCssContent]: [COMMON_CHUNK_NAME.StyleDepsImport],
    [COMMON_CHUNK_NAME.HtmlContent]: []
  };
  var COMMON_SUB_MODULE_NAME = "index";

  // src/const/index.ts
  var NATIVE_ELE_PKG = "native";
  var CONTAINER_TYPE = {
    COMPONENT: "Component",
    BLOCK: "Block",
    PAGE: "Page"
  };
  var SUPPORT_SCHEMA_VERSION_LIST = ["0.0.1", "1.0.0"];

  // src/utils/errors.ts
  init_define_process();
  function getErrorMessage(error) {
    if (!error) {
      return null;
    }
    if (error instanceof Error) {
      return error.message;
    }
    if (typeof error === "string") {
      return error;
    }
    if (typeof error === "object" && error !== null) {
      return getErrorMessage(error.message) || getErrorMessage(error.errorMessage) || getErrorMessage(error.detail);
    }
    return null;
  }

  // src/utils/schema.ts
  var schema_exports = {};
  __export(schema_exports, {
    handleSubNodes: () => handleSubNodes,
    isContainerSchema: () => isContainerSchema,
    isNpmInfo: () => isNpmInfo
  });
  init_define_process();

  // node_modules/lodash-es/lodash.js
  init_define_process();

  // node_modules/lodash-es/add.js
  init_define_process();

  // node_modules/lodash-es/_createMathOperation.js
  init_define_process();

  // node_modules/lodash-es/_baseToNumber.js
  init_define_process();

  // node_modules/lodash-es/isSymbol.js
  init_define_process();

  // node_modules/lodash-es/_baseGetTag.js
  init_define_process();

  // node_modules/lodash-es/_Symbol.js
  init_define_process();

  // node_modules/lodash-es/_root.js
  init_define_process();

  // node_modules/lodash-es/_freeGlobal.js
  init_define_process();
  var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
  var freeGlobal_default = freeGlobal;

  // node_modules/lodash-es/_root.js
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal_default || freeSelf || Function("return this")();
  var root_default = root;

  // node_modules/lodash-es/_Symbol.js
  var Symbol2 = root_default.Symbol;
  var Symbol_default = Symbol2;

  // node_modules/lodash-es/_getRawTag.js
  init_define_process();
  var objectProto = Object.prototype;
  var hasOwnProperty = objectProto.hasOwnProperty;
  var nativeObjectToString = objectProto.toString;
  var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result2 = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result2;
  }
  var getRawTag_default = getRawTag;

  // node_modules/lodash-es/_objectToString.js
  init_define_process();
  var objectProto2 = Object.prototype;
  var nativeObjectToString2 = objectProto2.toString;
  function objectToString(value) {
    return nativeObjectToString2.call(value);
  }
  var objectToString_default = objectToString;

  // node_modules/lodash-es/_baseGetTag.js
  var nullTag = "[object Null]";
  var undefinedTag = "[object Undefined]";
  var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
  }
  var baseGetTag_default = baseGetTag;

  // node_modules/lodash-es/isObjectLike.js
  init_define_process();
  function isObjectLike(value) {
    return value != null && typeof value == "object";
  }
  var isObjectLike_default = isObjectLike;

  // node_modules/lodash-es/isSymbol.js
  var symbolTag = "[object Symbol]";
  function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
  }
  var isSymbol_default = isSymbol;

  // node_modules/lodash-es/_baseToNumber.js
  var NAN = 0 / 0;
  function baseToNumber(value) {
    if (typeof value == "number") {
      return value;
    }
    if (isSymbol_default(value)) {
      return NAN;
    }
    return +value;
  }
  var baseToNumber_default = baseToNumber;

  // node_modules/lodash-es/_baseToString.js
  init_define_process();

  // node_modules/lodash-es/_arrayMap.js
  init_define_process();
  function arrayMap(array, iteratee2) {
    var index = -1, length = array == null ? 0 : array.length, result2 = Array(length);
    while (++index < length) {
      result2[index] = iteratee2(array[index], index, array);
    }
    return result2;
  }
  var arrayMap_default = arrayMap;

  // node_modules/lodash-es/isArray.js
  init_define_process();
  var isArray = Array.isArray;
  var isArray_default = isArray;

  // node_modules/lodash-es/_baseToString.js
  var INFINITY = 1 / 0;
  var symbolProto = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolToString = symbolProto ? symbolProto.toString : void 0;
  function baseToString(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isArray_default(value)) {
      return arrayMap_default(value, baseToString) + "";
    }
    if (isSymbol_default(value)) {
      return symbolToString ? symbolToString.call(value) : "";
    }
    var result2 = value + "";
    return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
  }
  var baseToString_default = baseToString;

  // node_modules/lodash-es/_createMathOperation.js
  function createMathOperation(operator, defaultValue) {
    return function(value, other) {
      var result2;
      if (value === void 0 && other === void 0) {
        return defaultValue;
      }
      if (value !== void 0) {
        result2 = value;
      }
      if (other !== void 0) {
        if (result2 === void 0) {
          return other;
        }
        if (typeof value == "string" || typeof other == "string") {
          value = baseToString_default(value);
          other = baseToString_default(other);
        } else {
          value = baseToNumber_default(value);
          other = baseToNumber_default(other);
        }
        result2 = operator(value, other);
      }
      return result2;
    };
  }
  var createMathOperation_default = createMathOperation;

  // node_modules/lodash-es/add.js
  var add = createMathOperation_default(function(augend, addend) {
    return augend + addend;
  }, 0);
  var add_default = add;

  // node_modules/lodash-es/after.js
  init_define_process();

  // node_modules/lodash-es/toInteger.js
  init_define_process();

  // node_modules/lodash-es/toFinite.js
  init_define_process();

  // node_modules/lodash-es/toNumber.js
  init_define_process();

  // node_modules/lodash-es/_baseTrim.js
  init_define_process();

  // node_modules/lodash-es/_trimmedEndIndex.js
  init_define_process();
  var reWhitespace = /\s/;
  function trimmedEndIndex(string) {
    var index = string.length;
    while (index-- && reWhitespace.test(string.charAt(index))) {
    }
    return index;
  }
  var trimmedEndIndex_default = trimmedEndIndex;

  // node_modules/lodash-es/_baseTrim.js
  var reTrimStart = /^\s+/;
  function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex_default(string) + 1).replace(reTrimStart, "") : string;
  }
  var baseTrim_default = baseTrim;

  // node_modules/lodash-es/isObject.js
  init_define_process();
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
  var isObject_default = isObject;

  // node_modules/lodash-es/toNumber.js
  var NAN2 = 0 / 0;
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  var reIsBinary = /^0b[01]+$/i;
  var reIsOctal = /^0o[0-7]+$/i;
  var freeParseInt = parseInt;
  function toNumber(value) {
    if (typeof value == "number") {
      return value;
    }
    if (isSymbol_default(value)) {
      return NAN2;
    }
    if (isObject_default(value)) {
      var other = typeof value.valueOf == "function" ? value.valueOf() : value;
      value = isObject_default(other) ? other + "" : other;
    }
    if (typeof value != "string") {
      return value === 0 ? value : +value;
    }
    value = baseTrim_default(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN2 : +value;
  }
  var toNumber_default = toNumber;

  // node_modules/lodash-es/toFinite.js
  var INFINITY2 = 1 / 0;
  var MAX_INTEGER = 17976931348623157e292;
  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }
    value = toNumber_default(value);
    if (value === INFINITY2 || value === -INFINITY2) {
      var sign = value < 0 ? -1 : 1;
      return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
  }
  var toFinite_default = toFinite;

  // node_modules/lodash-es/toInteger.js
  function toInteger(value) {
    var result2 = toFinite_default(value), remainder = result2 % 1;
    return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
  }
  var toInteger_default = toInteger;

  // node_modules/lodash-es/after.js
  var FUNC_ERROR_TEXT = "Expected a function";
  function after(n, func) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    n = toInteger_default(n);
    return function() {
      if (--n < 1) {
        return func.apply(this, arguments);
      }
    };
  }
  var after_default = after;

  // node_modules/lodash-es/ary.js
  init_define_process();

  // node_modules/lodash-es/_createWrap.js
  init_define_process();

  // node_modules/lodash-es/_baseSetData.js
  init_define_process();

  // node_modules/lodash-es/identity.js
  init_define_process();
  function identity(value) {
    return value;
  }
  var identity_default = identity;

  // node_modules/lodash-es/_metaMap.js
  init_define_process();

  // node_modules/lodash-es/_WeakMap.js
  init_define_process();

  // node_modules/lodash-es/_getNative.js
  init_define_process();

  // node_modules/lodash-es/_baseIsNative.js
  init_define_process();

  // node_modules/lodash-es/isFunction.js
  init_define_process();
  var asyncTag = "[object AsyncFunction]";
  var funcTag = "[object Function]";
  var genTag = "[object GeneratorFunction]";
  var proxyTag = "[object Proxy]";
  function isFunction(value) {
    if (!isObject_default(value)) {
      return false;
    }
    var tag = baseGetTag_default(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  var isFunction_default = isFunction;

  // node_modules/lodash-es/_isMasked.js
  init_define_process();

  // node_modules/lodash-es/_coreJsData.js
  init_define_process();
  var coreJsData = root_default["__core-js_shared__"];
  var coreJsData_default = coreJsData;

  // node_modules/lodash-es/_isMasked.js
  var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData_default && coreJsData_default.keys && coreJsData_default.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  var isMasked_default = isMasked;

  // node_modules/lodash-es/_toSource.js
  init_define_process();
  var funcProto = Function.prototype;
  var funcToString = funcProto.toString;
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  var toSource_default = toSource;

  // node_modules/lodash-es/_baseIsNative.js
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var funcProto2 = Function.prototype;
  var objectProto3 = Object.prototype;
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto3.hasOwnProperty;
  var reIsNative = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function baseIsNative(value) {
    if (!isObject_default(value) || isMasked_default(value)) {
      return false;
    }
    var pattern = isFunction_default(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource_default(value));
  }
  var baseIsNative_default = baseIsNative;

  // node_modules/lodash-es/_getValue.js
  init_define_process();
  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }
  var getValue_default = getValue;

  // node_modules/lodash-es/_getNative.js
  function getNative(object, key) {
    var value = getValue_default(object, key);
    return baseIsNative_default(value) ? value : void 0;
  }
  var getNative_default = getNative;

  // node_modules/lodash-es/_WeakMap.js
  var WeakMap2 = getNative_default(root_default, "WeakMap");
  var WeakMap_default = WeakMap2;

  // node_modules/lodash-es/_metaMap.js
  var metaMap = WeakMap_default && new WeakMap_default();
  var metaMap_default = metaMap;

  // node_modules/lodash-es/_baseSetData.js
  var baseSetData = !metaMap_default ? identity_default : function(func, data) {
    metaMap_default.set(func, data);
    return func;
  };
  var baseSetData_default = baseSetData;

  // node_modules/lodash-es/_createBind.js
  init_define_process();

  // node_modules/lodash-es/_createCtor.js
  init_define_process();

  // node_modules/lodash-es/_baseCreate.js
  init_define_process();
  var objectCreate = Object.create;
  var baseCreate = function() {
    function object() {
    }
    return function(proto) {
      if (!isObject_default(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result2 = new object();
      object.prototype = void 0;
      return result2;
    };
  }();
  var baseCreate_default = baseCreate;

  // node_modules/lodash-es/_createCtor.js
  function createCtor(Ctor) {
    return function() {
      var args = arguments;
      switch (args.length) {
        case 0:
          return new Ctor();
        case 1:
          return new Ctor(args[0]);
        case 2:
          return new Ctor(args[0], args[1]);
        case 3:
          return new Ctor(args[0], args[1], args[2]);
        case 4:
          return new Ctor(args[0], args[1], args[2], args[3]);
        case 5:
          return new Ctor(args[0], args[1], args[2], args[3], args[4]);
        case 6:
          return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
        case 7:
          return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
      }
      var thisBinding = baseCreate_default(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
      return isObject_default(result2) ? result2 : thisBinding;
    };
  }
  var createCtor_default = createCtor;

  // node_modules/lodash-es/_createBind.js
  var WRAP_BIND_FLAG = 1;
  function createBind(func, bitmask, thisArg) {
    var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor_default(func);
    function wrapper() {
      var fn = this && this !== root_default && this instanceof wrapper ? Ctor : func;
      return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
  }
  var createBind_default = createBind;

  // node_modules/lodash-es/_createCurry.js
  init_define_process();

  // node_modules/lodash-es/_apply.js
  init_define_process();
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  var apply_default = apply;

  // node_modules/lodash-es/_createHybrid.js
  init_define_process();

  // node_modules/lodash-es/_composeArgs.js
  init_define_process();
  var nativeMax = Math.max;
  function composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while (++leftIndex < leftLength) {
      result2[leftIndex] = partials[leftIndex];
    }
    while (++argsIndex < holdersLength) {
      if (isUncurried || argsIndex < argsLength) {
        result2[holders[argsIndex]] = args[argsIndex];
      }
    }
    while (rangeLength--) {
      result2[leftIndex++] = args[argsIndex++];
    }
    return result2;
  }
  var composeArgs_default = composeArgs;

  // node_modules/lodash-es/_composeArgsRight.js
  init_define_process();
  var nativeMax2 = Math.max;
  function composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while (++argsIndex < rangeLength) {
      result2[argsIndex] = args[argsIndex];
    }
    var offset = argsIndex;
    while (++rightIndex < rightLength) {
      result2[offset + rightIndex] = partials[rightIndex];
    }
    while (++holdersIndex < holdersLength) {
      if (isUncurried || argsIndex < argsLength) {
        result2[offset + holders[holdersIndex]] = args[argsIndex++];
      }
    }
    return result2;
  }
  var composeArgsRight_default = composeArgsRight;

  // node_modules/lodash-es/_countHolders.js
  init_define_process();
  function countHolders(array, placeholder) {
    var length = array.length, result2 = 0;
    while (length--) {
      if (array[length] === placeholder) {
        ++result2;
      }
    }
    return result2;
  }
  var countHolders_default = countHolders;

  // node_modules/lodash-es/_createRecurry.js
  init_define_process();

  // node_modules/lodash-es/_isLaziable.js
  init_define_process();

  // node_modules/lodash-es/_LazyWrapper.js
  init_define_process();

  // node_modules/lodash-es/_baseLodash.js
  init_define_process();
  function baseLodash() {
  }
  var baseLodash_default = baseLodash;

  // node_modules/lodash-es/_LazyWrapper.js
  var MAX_ARRAY_LENGTH = 4294967295;
  function LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = MAX_ARRAY_LENGTH;
    this.__views__ = [];
  }
  LazyWrapper.prototype = baseCreate_default(baseLodash_default.prototype);
  LazyWrapper.prototype.constructor = LazyWrapper;
  var LazyWrapper_default = LazyWrapper;

  // node_modules/lodash-es/_getData.js
  init_define_process();

  // node_modules/lodash-es/noop.js
  init_define_process();
  function noop() {
  }
  var noop_default = noop;

  // node_modules/lodash-es/_getData.js
  var getData = !metaMap_default ? noop_default : function(func) {
    return metaMap_default.get(func);
  };
  var getData_default = getData;

  // node_modules/lodash-es/_getFuncName.js
  init_define_process();

  // node_modules/lodash-es/_realNames.js
  init_define_process();
  var realNames = {};
  var realNames_default = realNames;

  // node_modules/lodash-es/_getFuncName.js
  var objectProto4 = Object.prototype;
  var hasOwnProperty3 = objectProto4.hasOwnProperty;
  function getFuncName(func) {
    var result2 = func.name + "", array = realNames_default[result2], length = hasOwnProperty3.call(realNames_default, result2) ? array.length : 0;
    while (length--) {
      var data = array[length], otherFunc = data.func;
      if (otherFunc == null || otherFunc == func) {
        return data.name;
      }
    }
    return result2;
  }
  var getFuncName_default = getFuncName;

  // node_modules/lodash-es/wrapperLodash.js
  init_define_process();

  // node_modules/lodash-es/_LodashWrapper.js
  init_define_process();
  function LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = void 0;
  }
  LodashWrapper.prototype = baseCreate_default(baseLodash_default.prototype);
  LodashWrapper.prototype.constructor = LodashWrapper;
  var LodashWrapper_default = LodashWrapper;

  // node_modules/lodash-es/_wrapperClone.js
  init_define_process();

  // node_modules/lodash-es/_copyArray.js
  init_define_process();
  function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }
  var copyArray_default = copyArray;

  // node_modules/lodash-es/_wrapperClone.js
  function wrapperClone(wrapper) {
    if (wrapper instanceof LazyWrapper_default) {
      return wrapper.clone();
    }
    var result2 = new LodashWrapper_default(wrapper.__wrapped__, wrapper.__chain__);
    result2.__actions__ = copyArray_default(wrapper.__actions__);
    result2.__index__ = wrapper.__index__;
    result2.__values__ = wrapper.__values__;
    return result2;
  }
  var wrapperClone_default = wrapperClone;

  // node_modules/lodash-es/wrapperLodash.js
  var objectProto5 = Object.prototype;
  var hasOwnProperty4 = objectProto5.hasOwnProperty;
  function lodash(value) {
    if (isObjectLike_default(value) && !isArray_default(value) && !(value instanceof LazyWrapper_default)) {
      if (value instanceof LodashWrapper_default) {
        return value;
      }
      if (hasOwnProperty4.call(value, "__wrapped__")) {
        return wrapperClone_default(value);
      }
    }
    return new LodashWrapper_default(value);
  }
  lodash.prototype = baseLodash_default.prototype;
  lodash.prototype.constructor = lodash;
  var wrapperLodash_default = lodash;

  // node_modules/lodash-es/_isLaziable.js
  function isLaziable(func) {
    var funcName = getFuncName_default(func), other = wrapperLodash_default[funcName];
    if (typeof other != "function" || !(funcName in LazyWrapper_default.prototype)) {
      return false;
    }
    if (func === other) {
      return true;
    }
    var data = getData_default(other);
    return !!data && func === data[0];
  }
  var isLaziable_default = isLaziable;

  // node_modules/lodash-es/_setData.js
  init_define_process();

  // node_modules/lodash-es/_shortOut.js
  init_define_process();
  var HOT_COUNT = 800;
  var HOT_SPAN = 16;
  var nativeNow = Date.now;
  function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
      var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(void 0, arguments);
    };
  }
  var shortOut_default = shortOut;

  // node_modules/lodash-es/_setData.js
  var setData = shortOut_default(baseSetData_default);
  var setData_default = setData;

  // node_modules/lodash-es/_setWrapToString.js
  init_define_process();

  // node_modules/lodash-es/_getWrapDetails.js
  init_define_process();
  var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/;
  var reSplitDetails = /,? & /;
  function getWrapDetails(source) {
    var match = source.match(reWrapDetails);
    return match ? match[1].split(reSplitDetails) : [];
  }
  var getWrapDetails_default = getWrapDetails;

  // node_modules/lodash-es/_insertWrapDetails.js
  init_define_process();
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
  function insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) {
      return source;
    }
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
    details = details.join(length > 2 ? ", " : " ");
    return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
  }
  var insertWrapDetails_default = insertWrapDetails;

  // node_modules/lodash-es/_setToString.js
  init_define_process();

  // node_modules/lodash-es/_baseSetToString.js
  init_define_process();

  // node_modules/lodash-es/constant.js
  init_define_process();
  function constant(value) {
    return function() {
      return value;
    };
  }
  var constant_default = constant;

  // node_modules/lodash-es/_defineProperty.js
  init_define_process();
  var defineProperty = function() {
    try {
      var func = getNative_default(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e) {
    }
  }();
  var defineProperty_default = defineProperty;

  // node_modules/lodash-es/_baseSetToString.js
  var baseSetToString = !defineProperty_default ? identity_default : function(func, string) {
    return defineProperty_default(func, "toString", {
      "configurable": true,
      "enumerable": false,
      "value": constant_default(string),
      "writable": true
    });
  };
  var baseSetToString_default = baseSetToString;

  // node_modules/lodash-es/_setToString.js
  var setToString = shortOut_default(baseSetToString_default);
  var setToString_default = setToString;

  // node_modules/lodash-es/_updateWrapDetails.js
  init_define_process();

  // node_modules/lodash-es/_arrayEach.js
  init_define_process();
  function arrayEach(array, iteratee2) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (iteratee2(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }
  var arrayEach_default = arrayEach;

  // node_modules/lodash-es/_arrayIncludes.js
  init_define_process();

  // node_modules/lodash-es/_baseIndexOf.js
  init_define_process();

  // node_modules/lodash-es/_baseFindIndex.js
  init_define_process();
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }
  var baseFindIndex_default = baseFindIndex;

  // node_modules/lodash-es/_baseIsNaN.js
  init_define_process();
  function baseIsNaN(value) {
    return value !== value;
  }
  var baseIsNaN_default = baseIsNaN;

  // node_modules/lodash-es/_strictIndexOf.js
  init_define_process();
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }
  var strictIndexOf_default = strictIndexOf;

  // node_modules/lodash-es/_baseIndexOf.js
  function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf_default(array, value, fromIndex) : baseFindIndex_default(array, baseIsNaN_default, fromIndex);
  }
  var baseIndexOf_default = baseIndexOf;

  // node_modules/lodash-es/_arrayIncludes.js
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf_default(array, value, 0) > -1;
  }
  var arrayIncludes_default = arrayIncludes;

  // node_modules/lodash-es/_updateWrapDetails.js
  var WRAP_BIND_FLAG2 = 1;
  var WRAP_BIND_KEY_FLAG = 2;
  var WRAP_CURRY_FLAG = 8;
  var WRAP_CURRY_RIGHT_FLAG = 16;
  var WRAP_PARTIAL_FLAG = 32;
  var WRAP_PARTIAL_RIGHT_FLAG = 64;
  var WRAP_ARY_FLAG = 128;
  var WRAP_REARG_FLAG = 256;
  var WRAP_FLIP_FLAG = 512;
  var wrapFlags = [
    ["ary", WRAP_ARY_FLAG],
    ["bind", WRAP_BIND_FLAG2],
    ["bindKey", WRAP_BIND_KEY_FLAG],
    ["curry", WRAP_CURRY_FLAG],
    ["curryRight", WRAP_CURRY_RIGHT_FLAG],
    ["flip", WRAP_FLIP_FLAG],
    ["partial", WRAP_PARTIAL_FLAG],
    ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
    ["rearg", WRAP_REARG_FLAG]
  ];
  function updateWrapDetails(details, bitmask) {
    arrayEach_default(wrapFlags, function(pair) {
      var value = "_." + pair[0];
      if (bitmask & pair[1] && !arrayIncludes_default(details, value)) {
        details.push(value);
      }
    });
    return details.sort();
  }
  var updateWrapDetails_default = updateWrapDetails;

  // node_modules/lodash-es/_setWrapToString.js
  function setWrapToString(wrapper, reference, bitmask) {
    var source = reference + "";
    return setToString_default(wrapper, insertWrapDetails_default(source, updateWrapDetails_default(getWrapDetails_default(source), bitmask)));
  }
  var setWrapToString_default = setWrapToString;

  // node_modules/lodash-es/_createRecurry.js
  var WRAP_BIND_FLAG3 = 1;
  var WRAP_BIND_KEY_FLAG2 = 2;
  var WRAP_CURRY_BOUND_FLAG = 4;
  var WRAP_CURRY_FLAG2 = 8;
  var WRAP_PARTIAL_FLAG2 = 32;
  var WRAP_PARTIAL_RIGHT_FLAG2 = 64;
  function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
    var isCurry = bitmask & WRAP_CURRY_FLAG2, newHolders = isCurry ? holders : void 0, newHoldersRight = isCurry ? void 0 : holders, newPartials = isCurry ? partials : void 0, newPartialsRight = isCurry ? void 0 : partials;
    bitmask |= isCurry ? WRAP_PARTIAL_FLAG2 : WRAP_PARTIAL_RIGHT_FLAG2;
    bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG2 : WRAP_PARTIAL_FLAG2);
    if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
      bitmask &= ~(WRAP_BIND_FLAG3 | WRAP_BIND_KEY_FLAG2);
    }
    var newData = [
      func,
      bitmask,
      thisArg,
      newPartials,
      newHolders,
      newPartialsRight,
      newHoldersRight,
      argPos,
      ary2,
      arity
    ];
    var result2 = wrapFunc.apply(void 0, newData);
    if (isLaziable_default(func)) {
      setData_default(result2, newData);
    }
    result2.placeholder = placeholder;
    return setWrapToString_default(result2, func, bitmask);
  }
  var createRecurry_default = createRecurry;

  // node_modules/lodash-es/_getHolder.js
  init_define_process();
  function getHolder(func) {
    var object = func;
    return object.placeholder;
  }
  var getHolder_default = getHolder;

  // node_modules/lodash-es/_reorder.js
  init_define_process();

  // node_modules/lodash-es/_isIndex.js
  init_define_process();
  var MAX_SAFE_INTEGER = 9007199254740991;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  var isIndex_default = isIndex;

  // node_modules/lodash-es/_reorder.js
  var nativeMin = Math.min;
  function reorder(array, indexes) {
    var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray_default(array);
    while (length--) {
      var index = indexes[length];
      array[length] = isIndex_default(index, arrLength) ? oldArray[index] : void 0;
    }
    return array;
  }
  var reorder_default = reorder;

  // node_modules/lodash-es/_replaceHolders.js
  init_define_process();
  var PLACEHOLDER = "__lodash_placeholder__";
  function replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result2[resIndex++] = index;
      }
    }
    return result2;
  }
  var replaceHolders_default = replaceHolders;

  // node_modules/lodash-es/_createHybrid.js
  var WRAP_BIND_FLAG4 = 1;
  var WRAP_BIND_KEY_FLAG3 = 2;
  var WRAP_CURRY_FLAG3 = 8;
  var WRAP_CURRY_RIGHT_FLAG2 = 16;
  var WRAP_ARY_FLAG2 = 128;
  var WRAP_FLIP_FLAG2 = 512;
  function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
    var isAry = bitmask & WRAP_ARY_FLAG2, isBind = bitmask & WRAP_BIND_FLAG4, isBindKey = bitmask & WRAP_BIND_KEY_FLAG3, isCurried = bitmask & (WRAP_CURRY_FLAG3 | WRAP_CURRY_RIGHT_FLAG2), isFlip = bitmask & WRAP_FLIP_FLAG2, Ctor = isBindKey ? void 0 : createCtor_default(func);
    function wrapper() {
      var length = arguments.length, args = Array(length), index = length;
      while (index--) {
        args[index] = arguments[index];
      }
      if (isCurried) {
        var placeholder = getHolder_default(wrapper), holdersCount = countHolders_default(args, placeholder);
      }
      if (partials) {
        args = composeArgs_default(args, partials, holders, isCurried);
      }
      if (partialsRight) {
        args = composeArgsRight_default(args, partialsRight, holdersRight, isCurried);
      }
      length -= holdersCount;
      if (isCurried && length < arity) {
        var newHolders = replaceHolders_default(args, placeholder);
        return createRecurry_default(
          func,
          bitmask,
          createHybrid,
          wrapper.placeholder,
          thisArg,
          args,
          newHolders,
          argPos,
          ary2,
          arity - length
        );
      }
      var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
      length = args.length;
      if (argPos) {
        args = reorder_default(args, argPos);
      } else if (isFlip && length > 1) {
        args.reverse();
      }
      if (isAry && ary2 < length) {
        args.length = ary2;
      }
      if (this && this !== root_default && this instanceof wrapper) {
        fn = Ctor || createCtor_default(fn);
      }
      return fn.apply(thisBinding, args);
    }
    return wrapper;
  }
  var createHybrid_default = createHybrid;

  // node_modules/lodash-es/_createCurry.js
  function createCurry(func, bitmask, arity) {
    var Ctor = createCtor_default(func);
    function wrapper() {
      var length = arguments.length, args = Array(length), index = length, placeholder = getHolder_default(wrapper);
      while (index--) {
        args[index] = arguments[index];
      }
      var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders_default(args, placeholder);
      length -= holders.length;
      if (length < arity) {
        return createRecurry_default(
          func,
          bitmask,
          createHybrid_default,
          wrapper.placeholder,
          void 0,
          args,
          holders,
          void 0,
          void 0,
          arity - length
        );
      }
      var fn = this && this !== root_default && this instanceof wrapper ? Ctor : func;
      return apply_default(fn, this, args);
    }
    return wrapper;
  }
  var createCurry_default = createCurry;

  // node_modules/lodash-es/_createPartial.js
  init_define_process();
  var WRAP_BIND_FLAG5 = 1;
  function createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & WRAP_BIND_FLAG5, Ctor = createCtor_default(func);
    function wrapper() {
      var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== root_default && this instanceof wrapper ? Ctor : func;
      while (++leftIndex < leftLength) {
        args[leftIndex] = partials[leftIndex];
      }
      while (argsLength--) {
        args[leftIndex++] = arguments[++argsIndex];
      }
      return apply_default(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
  }
  var createPartial_default = createPartial;

  // node_modules/lodash-es/_mergeData.js
  init_define_process();
  var PLACEHOLDER2 = "__lodash_placeholder__";
  var WRAP_BIND_FLAG6 = 1;
  var WRAP_BIND_KEY_FLAG4 = 2;
  var WRAP_CURRY_BOUND_FLAG2 = 4;
  var WRAP_CURRY_FLAG4 = 8;
  var WRAP_ARY_FLAG3 = 128;
  var WRAP_REARG_FLAG2 = 256;
  var nativeMin2 = Math.min;
  function mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG6 | WRAP_BIND_KEY_FLAG4 | WRAP_ARY_FLAG3);
    var isCombo = srcBitmask == WRAP_ARY_FLAG3 && bitmask == WRAP_CURRY_FLAG4 || srcBitmask == WRAP_ARY_FLAG3 && bitmask == WRAP_REARG_FLAG2 && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG3 | WRAP_REARG_FLAG2) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG4;
    if (!(isCommon || isCombo)) {
      return data;
    }
    if (srcBitmask & WRAP_BIND_FLAG6) {
      data[2] = source[2];
      newBitmask |= bitmask & WRAP_BIND_FLAG6 ? 0 : WRAP_CURRY_BOUND_FLAG2;
    }
    var value = source[3];
    if (value) {
      var partials = data[3];
      data[3] = partials ? composeArgs_default(partials, value, source[4]) : value;
      data[4] = partials ? replaceHolders_default(data[3], PLACEHOLDER2) : source[4];
    }
    value = source[5];
    if (value) {
      partials = data[5];
      data[5] = partials ? composeArgsRight_default(partials, value, source[6]) : value;
      data[6] = partials ? replaceHolders_default(data[5], PLACEHOLDER2) : source[6];
    }
    value = source[7];
    if (value) {
      data[7] = value;
    }
    if (srcBitmask & WRAP_ARY_FLAG3) {
      data[8] = data[8] == null ? source[8] : nativeMin2(data[8], source[8]);
    }
    if (data[9] == null) {
      data[9] = source[9];
    }
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
  }
  var mergeData_default = mergeData;

  // node_modules/lodash-es/_createWrap.js
  var FUNC_ERROR_TEXT2 = "Expected a function";
  var WRAP_BIND_FLAG7 = 1;
  var WRAP_BIND_KEY_FLAG5 = 2;
  var WRAP_CURRY_FLAG5 = 8;
  var WRAP_CURRY_RIGHT_FLAG3 = 16;
  var WRAP_PARTIAL_FLAG3 = 32;
  var WRAP_PARTIAL_RIGHT_FLAG3 = 64;
  var nativeMax3 = Math.max;
  function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
    var isBindKey = bitmask & WRAP_BIND_KEY_FLAG5;
    if (!isBindKey && typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT2);
    }
    var length = partials ? partials.length : 0;
    if (!length) {
      bitmask &= ~(WRAP_PARTIAL_FLAG3 | WRAP_PARTIAL_RIGHT_FLAG3);
      partials = holders = void 0;
    }
    ary2 = ary2 === void 0 ? ary2 : nativeMax3(toInteger_default(ary2), 0);
    arity = arity === void 0 ? arity : toInteger_default(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & WRAP_PARTIAL_RIGHT_FLAG3) {
      var partialsRight = partials, holdersRight = holders;
      partials = holders = void 0;
    }
    var data = isBindKey ? void 0 : getData_default(func);
    var newData = [
      func,
      bitmask,
      thisArg,
      partials,
      holders,
      partialsRight,
      holdersRight,
      argPos,
      ary2,
      arity
    ];
    if (data) {
      mergeData_default(newData, data);
    }
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === void 0 ? isBindKey ? 0 : func.length : nativeMax3(newData[9] - length, 0);
    if (!arity && bitmask & (WRAP_CURRY_FLAG5 | WRAP_CURRY_RIGHT_FLAG3)) {
      bitmask &= ~(WRAP_CURRY_FLAG5 | WRAP_CURRY_RIGHT_FLAG3);
    }
    if (!bitmask || bitmask == WRAP_BIND_FLAG7) {
      var result2 = createBind_default(func, bitmask, thisArg);
    } else if (bitmask == WRAP_CURRY_FLAG5 || bitmask == WRAP_CURRY_RIGHT_FLAG3) {
      result2 = createCurry_default(func, bitmask, arity);
    } else if ((bitmask == WRAP_PARTIAL_FLAG3 || bitmask == (WRAP_BIND_FLAG7 | WRAP_PARTIAL_FLAG3)) && !holders.length) {
      result2 = createPartial_default(func, bitmask, thisArg, partials);
    } else {
      result2 = createHybrid_default.apply(void 0, newData);
    }
    var setter = data ? baseSetData_default : setData_default;
    return setWrapToString_default(setter(result2, newData), func, bitmask);
  }
  var createWrap_default = createWrap;

  // node_modules/lodash-es/ary.js
  var WRAP_ARY_FLAG4 = 128;
  function ary(func, n, guard) {
    n = guard ? void 0 : n;
    n = func && n == null ? func.length : n;
    return createWrap_default(func, WRAP_ARY_FLAG4, void 0, void 0, void 0, void 0, n);
  }
  var ary_default = ary;

  // node_modules/lodash-es/assign.js
  init_define_process();

  // node_modules/lodash-es/_assignValue.js
  init_define_process();

  // node_modules/lodash-es/_baseAssignValue.js
  init_define_process();
  function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty_default) {
      defineProperty_default(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
      });
    } else {
      object[key] = value;
    }
  }
  var baseAssignValue_default = baseAssignValue;

  // node_modules/lodash-es/eq.js
  init_define_process();
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  var eq_default = eq;

  // node_modules/lodash-es/_assignValue.js
  var objectProto6 = Object.prototype;
  var hasOwnProperty5 = objectProto6.hasOwnProperty;
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty5.call(object, key) && eq_default(objValue, value)) || value === void 0 && !(key in object)) {
      baseAssignValue_default(object, key, value);
    }
  }
  var assignValue_default = assignValue;

  // node_modules/lodash-es/_copyObject.js
  init_define_process();
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
      if (newValue === void 0) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue_default(object, key, newValue);
      } else {
        assignValue_default(object, key, newValue);
      }
    }
    return object;
  }
  var copyObject_default = copyObject;

  // node_modules/lodash-es/_createAssigner.js
  init_define_process();

  // node_modules/lodash-es/_baseRest.js
  init_define_process();

  // node_modules/lodash-es/_overRest.js
  init_define_process();
  var nativeMax4 = Math.max;
  function overRest(func, start, transform2) {
    start = nativeMax4(start === void 0 ? func.length - 1 : start, 0);
    return function() {
      var args = arguments, index = -1, length = nativeMax4(args.length - start, 0), array = Array(length);
      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform2(array);
      return apply_default(func, this, otherArgs);
    };
  }
  var overRest_default = overRest;

  // node_modules/lodash-es/_baseRest.js
  function baseRest(func, start) {
    return setToString_default(overRest_default(func, start, identity_default), func + "");
  }
  var baseRest_default = baseRest;

  // node_modules/lodash-es/_isIterateeCall.js
  init_define_process();

  // node_modules/lodash-es/isArrayLike.js
  init_define_process();

  // node_modules/lodash-es/isLength.js
  init_define_process();
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  var isLength_default = isLength;

  // node_modules/lodash-es/isArrayLike.js
  function isArrayLike(value) {
    return value != null && isLength_default(value.length) && !isFunction_default(value);
  }
  var isArrayLike_default = isArrayLike;

  // node_modules/lodash-es/_isIterateeCall.js
  function isIterateeCall(value, index, object) {
    if (!isObject_default(object)) {
      return false;
    }
    var type = typeof index;
    if (type == "number" ? isArrayLike_default(object) && isIndex_default(index, object.length) : type == "string" && index in object) {
      return eq_default(object[index], value);
    }
    return false;
  }
  var isIterateeCall_default = isIterateeCall;

  // node_modules/lodash-es/_createAssigner.js
  function createAssigner(assigner) {
    return baseRest_default(function(object, sources) {
      var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
      customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
      if (guard && isIterateeCall_default(sources[0], sources[1], guard)) {
        customizer = length < 3 ? void 0 : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }
  var createAssigner_default = createAssigner;

  // node_modules/lodash-es/_isPrototype.js
  init_define_process();
  var objectProto7 = Object.prototype;
  function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto7;
    return value === proto;
  }
  var isPrototype_default = isPrototype;

  // node_modules/lodash-es/keys.js
  init_define_process();

  // node_modules/lodash-es/_arrayLikeKeys.js
  init_define_process();

  // node_modules/lodash-es/_baseTimes.js
  init_define_process();
  function baseTimes(n, iteratee2) {
    var index = -1, result2 = Array(n);
    while (++index < n) {
      result2[index] = iteratee2(index);
    }
    return result2;
  }
  var baseTimes_default = baseTimes;

  // node_modules/lodash-es/isArguments.js
  init_define_process();

  // node_modules/lodash-es/_baseIsArguments.js
  init_define_process();
  var argsTag = "[object Arguments]";
  function baseIsArguments(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == argsTag;
  }
  var baseIsArguments_default = baseIsArguments;

  // node_modules/lodash-es/isArguments.js
  var objectProto8 = Object.prototype;
  var hasOwnProperty6 = objectProto8.hasOwnProperty;
  var propertyIsEnumerable = objectProto8.propertyIsEnumerable;
  var isArguments = baseIsArguments_default(function() {
    return arguments;
  }()) ? baseIsArguments_default : function(value) {
    return isObjectLike_default(value) && hasOwnProperty6.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
  };
  var isArguments_default = isArguments;

  // node_modules/lodash-es/isBuffer.js
  init_define_process();

  // node_modules/lodash-es/stubFalse.js
  init_define_process();
  function stubFalse() {
    return false;
  }
  var stubFalse_default = stubFalse;

  // node_modules/lodash-es/isBuffer.js
  var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer3 = moduleExports ? root_default.Buffer : void 0;
  var nativeIsBuffer = Buffer3 ? Buffer3.isBuffer : void 0;
  var isBuffer = nativeIsBuffer || stubFalse_default;
  var isBuffer_default = isBuffer;

  // node_modules/lodash-es/isTypedArray.js
  init_define_process();

  // node_modules/lodash-es/_baseIsTypedArray.js
  init_define_process();
  var argsTag2 = "[object Arguments]";
  var arrayTag = "[object Array]";
  var boolTag = "[object Boolean]";
  var dateTag = "[object Date]";
  var errorTag = "[object Error]";
  var funcTag2 = "[object Function]";
  var mapTag = "[object Map]";
  var numberTag = "[object Number]";
  var objectTag = "[object Object]";
  var regexpTag = "[object RegExp]";
  var setTag = "[object Set]";
  var stringTag = "[object String]";
  var weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]";
  var dataViewTag = "[object DataView]";
  var float32Tag = "[object Float32Array]";
  var float64Tag = "[object Float64Array]";
  var int8Tag = "[object Int8Array]";
  var int16Tag = "[object Int16Array]";
  var int32Tag = "[object Int32Array]";
  var uint8Tag = "[object Uint8Array]";
  var uint8ClampedTag = "[object Uint8ClampedArray]";
  var uint16Tag = "[object Uint16Array]";
  var uint32Tag = "[object Uint32Array]";
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  function baseIsTypedArray(value) {
    return isObjectLike_default(value) && isLength_default(value.length) && !!typedArrayTags[baseGetTag_default(value)];
  }
  var baseIsTypedArray_default = baseIsTypedArray;

  // node_modules/lodash-es/_baseUnary.js
  init_define_process();
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }
  var baseUnary_default = baseUnary;

  // node_modules/lodash-es/_nodeUtil.js
  init_define_process();
  var freeExports2 = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule2 = freeExports2 && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var freeProcess = moduleExports2 && freeGlobal_default.process;
  var nodeUtil = function() {
    try {
      var types = freeModule2 && freeModule2.require && freeModule2.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeUtil_default = nodeUtil;

  // node_modules/lodash-es/isTypedArray.js
  var nodeIsTypedArray = nodeUtil_default && nodeUtil_default.isTypedArray;
  var isTypedArray = nodeIsTypedArray ? baseUnary_default(nodeIsTypedArray) : baseIsTypedArray_default;
  var isTypedArray_default = isTypedArray;

  // node_modules/lodash-es/_arrayLikeKeys.js
  var objectProto9 = Object.prototype;
  var hasOwnProperty7 = objectProto9.hasOwnProperty;
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray_default(value), isArg = !isArr && isArguments_default(value), isBuff = !isArr && !isArg && isBuffer_default(value), isType = !isArr && !isArg && !isBuff && isTypedArray_default(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes_default(value.length, String) : [], length = result2.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty7.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex_default(key, length)))) {
        result2.push(key);
      }
    }
    return result2;
  }
  var arrayLikeKeys_default = arrayLikeKeys;

  // node_modules/lodash-es/_baseKeys.js
  init_define_process();

  // node_modules/lodash-es/_nativeKeys.js
  init_define_process();

  // node_modules/lodash-es/_overArg.js
  init_define_process();
  function overArg(func, transform2) {
    return function(arg) {
      return func(transform2(arg));
    };
  }
  var overArg_default = overArg;

  // node_modules/lodash-es/_nativeKeys.js
  var nativeKeys = overArg_default(Object.keys, Object);
  var nativeKeys_default = nativeKeys;

  // node_modules/lodash-es/_baseKeys.js
  var objectProto10 = Object.prototype;
  var hasOwnProperty8 = objectProto10.hasOwnProperty;
  function baseKeys(object) {
    if (!isPrototype_default(object)) {
      return nativeKeys_default(object);
    }
    var result2 = [];
    for (var key in Object(object)) {
      if (hasOwnProperty8.call(object, key) && key != "constructor") {
        result2.push(key);
      }
    }
    return result2;
  }
  var baseKeys_default = baseKeys;

  // node_modules/lodash-es/keys.js
  function keys(object) {
    return isArrayLike_default(object) ? arrayLikeKeys_default(object) : baseKeys_default(object);
  }
  var keys_default = keys;

  // node_modules/lodash-es/assign.js
  var objectProto11 = Object.prototype;
  var hasOwnProperty9 = objectProto11.hasOwnProperty;
  var assign = createAssigner_default(function(object, source) {
    if (isPrototype_default(source) || isArrayLike_default(source)) {
      copyObject_default(source, keys_default(source), object);
      return;
    }
    for (var key in source) {
      if (hasOwnProperty9.call(source, key)) {
        assignValue_default(object, key, source[key]);
      }
    }
  });
  var assign_default = assign;

  // node_modules/lodash-es/assignIn.js
  init_define_process();

  // node_modules/lodash-es/keysIn.js
  init_define_process();

  // node_modules/lodash-es/_baseKeysIn.js
  init_define_process();

  // node_modules/lodash-es/_nativeKeysIn.js
  init_define_process();
  function nativeKeysIn(object) {
    var result2 = [];
    if (object != null) {
      for (var key in Object(object)) {
        result2.push(key);
      }
    }
    return result2;
  }
  var nativeKeysIn_default = nativeKeysIn;

  // node_modules/lodash-es/_baseKeysIn.js
  var objectProto12 = Object.prototype;
  var hasOwnProperty10 = objectProto12.hasOwnProperty;
  function baseKeysIn(object) {
    if (!isObject_default(object)) {
      return nativeKeysIn_default(object);
    }
    var isProto = isPrototype_default(object), result2 = [];
    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty10.call(object, key)))) {
        result2.push(key);
      }
    }
    return result2;
  }
  var baseKeysIn_default = baseKeysIn;

  // node_modules/lodash-es/keysIn.js
  function keysIn(object) {
    return isArrayLike_default(object) ? arrayLikeKeys_default(object, true) : baseKeysIn_default(object);
  }
  var keysIn_default = keysIn;

  // node_modules/lodash-es/assignIn.js
  var assignIn = createAssigner_default(function(object, source) {
    copyObject_default(source, keysIn_default(source), object);
  });
  var assignIn_default = assignIn;

  // node_modules/lodash-es/assignInWith.js
  init_define_process();
  var assignInWith = createAssigner_default(function(object, source, srcIndex, customizer) {
    copyObject_default(source, keysIn_default(source), object, customizer);
  });
  var assignInWith_default = assignInWith;

  // node_modules/lodash-es/assignWith.js
  init_define_process();
  var assignWith = createAssigner_default(function(object, source, srcIndex, customizer) {
    copyObject_default(source, keys_default(source), object, customizer);
  });
  var assignWith_default = assignWith;

  // node_modules/lodash-es/at.js
  init_define_process();

  // node_modules/lodash-es/_baseAt.js
  init_define_process();

  // node_modules/lodash-es/get.js
  init_define_process();

  // node_modules/lodash-es/_baseGet.js
  init_define_process();

  // node_modules/lodash-es/_castPath.js
  init_define_process();

  // node_modules/lodash-es/_isKey.js
  init_define_process();
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
  var reIsPlainProp = /^\w*$/;
  function isKey(value, object) {
    if (isArray_default(value)) {
      return false;
    }
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol_default(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  var isKey_default = isKey;

  // node_modules/lodash-es/_stringToPath.js
  init_define_process();

  // node_modules/lodash-es/_memoizeCapped.js
  init_define_process();

  // node_modules/lodash-es/memoize.js
  init_define_process();

  // node_modules/lodash-es/_MapCache.js
  init_define_process();

  // node_modules/lodash-es/_mapCacheClear.js
  init_define_process();

  // node_modules/lodash-es/_Hash.js
  init_define_process();

  // node_modules/lodash-es/_hashClear.js
  init_define_process();

  // node_modules/lodash-es/_nativeCreate.js
  init_define_process();
  var nativeCreate = getNative_default(Object, "create");
  var nativeCreate_default = nativeCreate;

  // node_modules/lodash-es/_hashClear.js
  function hashClear() {
    this.__data__ = nativeCreate_default ? nativeCreate_default(null) : {};
    this.size = 0;
  }
  var hashClear_default = hashClear;

  // node_modules/lodash-es/_hashDelete.js
  init_define_process();
  function hashDelete(key) {
    var result2 = this.has(key) && delete this.__data__[key];
    this.size -= result2 ? 1 : 0;
    return result2;
  }
  var hashDelete_default = hashDelete;

  // node_modules/lodash-es/_hashGet.js
  init_define_process();
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var objectProto13 = Object.prototype;
  var hasOwnProperty11 = objectProto13.hasOwnProperty;
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate_default) {
      var result2 = data[key];
      return result2 === HASH_UNDEFINED ? void 0 : result2;
    }
    return hasOwnProperty11.call(data, key) ? data[key] : void 0;
  }
  var hashGet_default = hashGet;

  // node_modules/lodash-es/_hashHas.js
  init_define_process();
  var objectProto14 = Object.prototype;
  var hasOwnProperty12 = objectProto14.hasOwnProperty;
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate_default ? data[key] !== void 0 : hasOwnProperty12.call(data, key);
  }
  var hashHas_default = hashHas;

  // node_modules/lodash-es/_hashSet.js
  init_define_process();
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate_default && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  var hashSet_default = hashSet;

  // node_modules/lodash-es/_Hash.js
  function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  Hash.prototype.clear = hashClear_default;
  Hash.prototype["delete"] = hashDelete_default;
  Hash.prototype.get = hashGet_default;
  Hash.prototype.has = hashHas_default;
  Hash.prototype.set = hashSet_default;
  var Hash_default = Hash;

  // node_modules/lodash-es/_ListCache.js
  init_define_process();

  // node_modules/lodash-es/_listCacheClear.js
  init_define_process();
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  var listCacheClear_default = listCacheClear;

  // node_modules/lodash-es/_listCacheDelete.js
  init_define_process();

  // node_modules/lodash-es/_assocIndexOf.js
  init_define_process();
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq_default(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  var assocIndexOf_default = assocIndexOf;

  // node_modules/lodash-es/_listCacheDelete.js
  var arrayProto = Array.prototype;
  var splice = arrayProto.splice;
  function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  var listCacheDelete_default = listCacheDelete;

  // node_modules/lodash-es/_listCacheGet.js
  init_define_process();
  function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  var listCacheGet_default = listCacheGet;

  // node_modules/lodash-es/_listCacheHas.js
  init_define_process();
  function listCacheHas(key) {
    return assocIndexOf_default(this.__data__, key) > -1;
  }
  var listCacheHas_default = listCacheHas;

  // node_modules/lodash-es/_listCacheSet.js
  init_define_process();
  function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf_default(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  var listCacheSet_default = listCacheSet;

  // node_modules/lodash-es/_ListCache.js
  function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  ListCache.prototype.clear = listCacheClear_default;
  ListCache.prototype["delete"] = listCacheDelete_default;
  ListCache.prototype.get = listCacheGet_default;
  ListCache.prototype.has = listCacheHas_default;
  ListCache.prototype.set = listCacheSet_default;
  var ListCache_default = ListCache;

  // node_modules/lodash-es/_Map.js
  init_define_process();
  var Map2 = getNative_default(root_default, "Map");
  var Map_default = Map2;

  // node_modules/lodash-es/_mapCacheClear.js
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash_default(),
      "map": new (Map_default || ListCache_default)(),
      "string": new Hash_default()
    };
  }
  var mapCacheClear_default = mapCacheClear;

  // node_modules/lodash-es/_mapCacheDelete.js
  init_define_process();

  // node_modules/lodash-es/_getMapData.js
  init_define_process();

  // node_modules/lodash-es/_isKeyable.js
  init_define_process();
  function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  var isKeyable_default = isKeyable;

  // node_modules/lodash-es/_getMapData.js
  function getMapData(map2, key) {
    var data = map2.__data__;
    return isKeyable_default(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  var getMapData_default = getMapData;

  // node_modules/lodash-es/_mapCacheDelete.js
  function mapCacheDelete(key) {
    var result2 = getMapData_default(this, key)["delete"](key);
    this.size -= result2 ? 1 : 0;
    return result2;
  }
  var mapCacheDelete_default = mapCacheDelete;

  // node_modules/lodash-es/_mapCacheGet.js
  init_define_process();
  function mapCacheGet(key) {
    return getMapData_default(this, key).get(key);
  }
  var mapCacheGet_default = mapCacheGet;

  // node_modules/lodash-es/_mapCacheHas.js
  init_define_process();
  function mapCacheHas(key) {
    return getMapData_default(this, key).has(key);
  }
  var mapCacheHas_default = mapCacheHas;

  // node_modules/lodash-es/_mapCacheSet.js
  init_define_process();
  function mapCacheSet(key, value) {
    var data = getMapData_default(this, key), size2 = data.size;
    data.set(key, value);
    this.size += data.size == size2 ? 0 : 1;
    return this;
  }
  var mapCacheSet_default = mapCacheSet;

  // node_modules/lodash-es/_MapCache.js
  function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  MapCache.prototype.clear = mapCacheClear_default;
  MapCache.prototype["delete"] = mapCacheDelete_default;
  MapCache.prototype.get = mapCacheGet_default;
  MapCache.prototype.has = mapCacheHas_default;
  MapCache.prototype.set = mapCacheSet_default;
  var MapCache_default = MapCache;

  // node_modules/lodash-es/memoize.js
  var FUNC_ERROR_TEXT3 = "Expected a function";
  function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") {
      throw new TypeError(FUNC_ERROR_TEXT3);
    }
    var memoized = function() {
      var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result2 = func.apply(this, args);
      memoized.cache = cache.set(key, result2) || cache;
      return result2;
    };
    memoized.cache = new (memoize.Cache || MapCache_default)();
    return memoized;
  }
  memoize.Cache = MapCache_default;
  var memoize_default = memoize;

  // node_modules/lodash-es/_memoizeCapped.js
  var MAX_MEMOIZE_SIZE = 500;
  function memoizeCapped(func) {
    var result2 = memoize_default(func, function(key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });
    var cache = result2.cache;
    return result2;
  }
  var memoizeCapped_default = memoizeCapped;

  // node_modules/lodash-es/_stringToPath.js
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  var reEscapeChar = /\\(\\)?/g;
  var stringToPath = memoizeCapped_default(function(string) {
    var result2 = [];
    if (string.charCodeAt(0) === 46) {
      result2.push("");
    }
    string.replace(rePropName, function(match, number, quote, subString) {
      result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result2;
  });
  var stringToPath_default = stringToPath;

  // node_modules/lodash-es/toString.js
  init_define_process();
  function toString(value) {
    return value == null ? "" : baseToString_default(value);
  }
  var toString_default = toString;

  // node_modules/lodash-es/_castPath.js
  function castPath(value, object) {
    if (isArray_default(value)) {
      return value;
    }
    return isKey_default(value, object) ? [value] : stringToPath_default(toString_default(value));
  }
  var castPath_default = castPath;

  // node_modules/lodash-es/_toKey.js
  init_define_process();
  var INFINITY3 = 1 / 0;
  function toKey(value) {
    if (typeof value == "string" || isSymbol_default(value)) {
      return value;
    }
    var result2 = value + "";
    return result2 == "0" && 1 / value == -INFINITY3 ? "-0" : result2;
  }
  var toKey_default = toKey;

  // node_modules/lodash-es/_baseGet.js
  function baseGet(object, path) {
    path = castPath_default(path, object);
    var index = 0, length = path.length;
    while (object != null && index < length) {
      object = object[toKey_default(path[index++])];
    }
    return index && index == length ? object : void 0;
  }
  var baseGet_default = baseGet;

  // node_modules/lodash-es/get.js
  function get(object, path, defaultValue) {
    var result2 = object == null ? void 0 : baseGet_default(object, path);
    return result2 === void 0 ? defaultValue : result2;
  }
  var get_default = get;

  // node_modules/lodash-es/_baseAt.js
  function baseAt(object, paths) {
    var index = -1, length = paths.length, result2 = Array(length), skip = object == null;
    while (++index < length) {
      result2[index] = skip ? void 0 : get_default(object, paths[index]);
    }
    return result2;
  }
  var baseAt_default = baseAt;

  // node_modules/lodash-es/_flatRest.js
  init_define_process();

  // node_modules/lodash-es/flatten.js
  init_define_process();

  // node_modules/lodash-es/_baseFlatten.js
  init_define_process();

  // node_modules/lodash-es/_arrayPush.js
  init_define_process();
  function arrayPush(array, values2) {
    var index = -1, length = values2.length, offset = array.length;
    while (++index < length) {
      array[offset + index] = values2[index];
    }
    return array;
  }
  var arrayPush_default = arrayPush;

  // node_modules/lodash-es/_isFlattenable.js
  init_define_process();
  var spreadableSymbol = Symbol_default ? Symbol_default.isConcatSpreadable : void 0;
  function isFlattenable(value) {
    return isArray_default(value) || isArguments_default(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }
  var isFlattenable_default = isFlattenable;

  // node_modules/lodash-es/_baseFlatten.js
  function baseFlatten(array, depth, predicate, isStrict, result2) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable_default);
    result2 || (result2 = []);
    while (++index < length) {
      var value = array[index];
      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          baseFlatten(value, depth - 1, predicate, isStrict, result2);
        } else {
          arrayPush_default(result2, value);
        }
      } else if (!isStrict) {
        result2[result2.length] = value;
      }
    }
    return result2;
  }
  var baseFlatten_default = baseFlatten;

  // node_modules/lodash-es/flatten.js
  function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten_default(array, 1) : [];
  }
  var flatten_default = flatten;

  // node_modules/lodash-es/_flatRest.js
  function flatRest(func) {
    return setToString_default(overRest_default(func, void 0, flatten_default), func + "");
  }
  var flatRest_default = flatRest;

  // node_modules/lodash-es/at.js
  var at = flatRest_default(baseAt_default);
  var at_default = at;

  // node_modules/lodash-es/attempt.js
  init_define_process();

  // node_modules/lodash-es/isError.js
  init_define_process();

  // node_modules/lodash-es/isPlainObject.js
  init_define_process();

  // node_modules/lodash-es/_getPrototype.js
  init_define_process();
  var getPrototype = overArg_default(Object.getPrototypeOf, Object);
  var getPrototype_default = getPrototype;

  // node_modules/lodash-es/isPlainObject.js
  var objectTag2 = "[object Object]";
  var funcProto3 = Function.prototype;
  var objectProto15 = Object.prototype;
  var funcToString3 = funcProto3.toString;
  var hasOwnProperty13 = objectProto15.hasOwnProperty;
  var objectCtorString = funcToString3.call(Object);
  function isPlainObject(value) {
    if (!isObjectLike_default(value) || baseGetTag_default(value) != objectTag2) {
      return false;
    }
    var proto = getPrototype_default(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty13.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString3.call(Ctor) == objectCtorString;
  }
  var isPlainObject_default = isPlainObject;

  // node_modules/lodash-es/isError.js
  var domExcTag = "[object DOMException]";
  var errorTag2 = "[object Error]";
  function isError(value) {
    if (!isObjectLike_default(value)) {
      return false;
    }
    var tag = baseGetTag_default(value);
    return tag == errorTag2 || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject_default(value);
  }
  var isError_default = isError;

  // node_modules/lodash-es/attempt.js
  var attempt = baseRest_default(function(func, args) {
    try {
      return apply_default(func, void 0, args);
    } catch (e) {
      return isError_default(e) ? e : new Error(e);
    }
  });
  var attempt_default = attempt;

  // node_modules/lodash-es/before.js
  init_define_process();
  var FUNC_ERROR_TEXT4 = "Expected a function";
  function before(n, func) {
    var result2;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT4);
    }
    n = toInteger_default(n);
    return function() {
      if (--n > 0) {
        result2 = func.apply(this, arguments);
      }
      if (n <= 1) {
        func = void 0;
      }
      return result2;
    };
  }
  var before_default = before;

  // node_modules/lodash-es/bind.js
  init_define_process();
  var WRAP_BIND_FLAG8 = 1;
  var WRAP_PARTIAL_FLAG4 = 32;
  var bind = baseRest_default(function(func, thisArg, partials) {
    var bitmask = WRAP_BIND_FLAG8;
    if (partials.length) {
      var holders = replaceHolders_default(partials, getHolder_default(bind));
      bitmask |= WRAP_PARTIAL_FLAG4;
    }
    return createWrap_default(func, bitmask, thisArg, partials, holders);
  });
  bind.placeholder = {};
  var bind_default = bind;

  // node_modules/lodash-es/bindAll.js
  init_define_process();
  var bindAll = flatRest_default(function(object, methodNames) {
    arrayEach_default(methodNames, function(key) {
      key = toKey_default(key);
      baseAssignValue_default(object, key, bind_default(object[key], object));
    });
    return object;
  });
  var bindAll_default = bindAll;

  // node_modules/lodash-es/bindKey.js
  init_define_process();
  var WRAP_BIND_FLAG9 = 1;
  var WRAP_BIND_KEY_FLAG6 = 2;
  var WRAP_PARTIAL_FLAG5 = 32;
  var bindKey = baseRest_default(function(object, key, partials) {
    var bitmask = WRAP_BIND_FLAG9 | WRAP_BIND_KEY_FLAG6;
    if (partials.length) {
      var holders = replaceHolders_default(partials, getHolder_default(bindKey));
      bitmask |= WRAP_PARTIAL_FLAG5;
    }
    return createWrap_default(key, bitmask, object, partials, holders);
  });
  bindKey.placeholder = {};
  var bindKey_default = bindKey;

  // node_modules/lodash-es/camelCase.js
  init_define_process();

  // node_modules/lodash-es/capitalize.js
  init_define_process();

  // node_modules/lodash-es/upperFirst.js
  init_define_process();

  // node_modules/lodash-es/_createCaseFirst.js
  init_define_process();

  // node_modules/lodash-es/_castSlice.js
  init_define_process();

  // node_modules/lodash-es/_baseSlice.js
  init_define_process();
  function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result2 = Array(length);
    while (++index < length) {
      result2[index] = array[index + start];
    }
    return result2;
  }
  var baseSlice_default = baseSlice;

  // node_modules/lodash-es/_castSlice.js
  function castSlice(array, start, end) {
    var length = array.length;
    end = end === void 0 ? length : end;
    return !start && end >= length ? array : baseSlice_default(array, start, end);
  }
  var castSlice_default = castSlice;

  // node_modules/lodash-es/_hasUnicode.js
  init_define_process();
  var rsAstralRange = "\\ud800-\\udfff";
  var rsComboMarksRange = "\\u0300-\\u036f";
  var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange = "\\u20d0-\\u20ff";
  var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
  var rsVarRange = "\\ufe0e\\ufe0f";
  var rsZWJ = "\\u200d";
  var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }
  var hasUnicode_default = hasUnicode;

  // node_modules/lodash-es/_stringToArray.js
  init_define_process();

  // node_modules/lodash-es/_asciiToArray.js
  init_define_process();
  function asciiToArray(string) {
    return string.split("");
  }
  var asciiToArray_default = asciiToArray;

  // node_modules/lodash-es/_unicodeToArray.js
  init_define_process();
  var rsAstralRange2 = "\\ud800-\\udfff";
  var rsComboMarksRange2 = "\\u0300-\\u036f";
  var reComboHalfMarksRange2 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange2 = "\\u20d0-\\u20ff";
  var rsComboRange2 = rsComboMarksRange2 + reComboHalfMarksRange2 + rsComboSymbolsRange2;
  var rsVarRange2 = "\\ufe0e\\ufe0f";
  var rsAstral = "[" + rsAstralRange2 + "]";
  var rsCombo = "[" + rsComboRange2 + "]";
  var rsFitz = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
  var rsNonAstral = "[^" + rsAstralRange2 + "]";
  var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsZWJ2 = "\\u200d";
  var reOptMod = rsModifier + "?";
  var rsOptVar = "[" + rsVarRange2 + "]?";
  var rsOptJoin = "(?:" + rsZWJ2 + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
  var rsSeq = rsOptVar + reOptMod + rsOptJoin;
  var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
  var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }
  var unicodeToArray_default = unicodeToArray;

  // node_modules/lodash-es/_stringToArray.js
  function stringToArray(string) {
    return hasUnicode_default(string) ? unicodeToArray_default(string) : asciiToArray_default(string);
  }
  var stringToArray_default = stringToArray;

  // node_modules/lodash-es/_createCaseFirst.js
  function createCaseFirst(methodName) {
    return function(string) {
      string = toString_default(string);
      var strSymbols = hasUnicode_default(string) ? stringToArray_default(string) : void 0;
      var chr = strSymbols ? strSymbols[0] : string.charAt(0);
      var trailing = strSymbols ? castSlice_default(strSymbols, 1).join("") : string.slice(1);
      return chr[methodName]() + trailing;
    };
  }
  var createCaseFirst_default = createCaseFirst;

  // node_modules/lodash-es/upperFirst.js
  var upperFirst = createCaseFirst_default("toUpperCase");
  var upperFirst_default = upperFirst;

  // node_modules/lodash-es/capitalize.js
  function capitalize(string) {
    return upperFirst_default(toString_default(string).toLowerCase());
  }
  var capitalize_default = capitalize;

  // node_modules/lodash-es/_createCompounder.js
  init_define_process();

  // node_modules/lodash-es/_arrayReduce.js
  init_define_process();
  function arrayReduce(array, iteratee2, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee2(accumulator, array[index], index, array);
    }
    return accumulator;
  }
  var arrayReduce_default = arrayReduce;

  // node_modules/lodash-es/deburr.js
  init_define_process();

  // node_modules/lodash-es/_deburrLetter.js
  init_define_process();

  // node_modules/lodash-es/_basePropertyOf.js
  init_define_process();
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? void 0 : object[key];
    };
  }
  var basePropertyOf_default = basePropertyOf;

  // node_modules/lodash-es/_deburrLetter.js
  var deburredLetters = {
    "\xC0": "A",
    "\xC1": "A",
    "\xC2": "A",
    "\xC3": "A",
    "\xC4": "A",
    "\xC5": "A",
    "\xE0": "a",
    "\xE1": "a",
    "\xE2": "a",
    "\xE3": "a",
    "\xE4": "a",
    "\xE5": "a",
    "\xC7": "C",
    "\xE7": "c",
    "\xD0": "D",
    "\xF0": "d",
    "\xC8": "E",
    "\xC9": "E",
    "\xCA": "E",
    "\xCB": "E",
    "\xE8": "e",
    "\xE9": "e",
    "\xEA": "e",
    "\xEB": "e",
    "\xCC": "I",
    "\xCD": "I",
    "\xCE": "I",
    "\xCF": "I",
    "\xEC": "i",
    "\xED": "i",
    "\xEE": "i",
    "\xEF": "i",
    "\xD1": "N",
    "\xF1": "n",
    "\xD2": "O",
    "\xD3": "O",
    "\xD4": "O",
    "\xD5": "O",
    "\xD6": "O",
    "\xD8": "O",
    "\xF2": "o",
    "\xF3": "o",
    "\xF4": "o",
    "\xF5": "o",
    "\xF6": "o",
    "\xF8": "o",
    "\xD9": "U",
    "\xDA": "U",
    "\xDB": "U",
    "\xDC": "U",
    "\xF9": "u",
    "\xFA": "u",
    "\xFB": "u",
    "\xFC": "u",
    "\xDD": "Y",
    "\xFD": "y",
    "\xFF": "y",
    "\xC6": "Ae",
    "\xE6": "ae",
    "\xDE": "Th",
    "\xFE": "th",
    "\xDF": "ss",
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
  };
  var deburrLetter = basePropertyOf_default(deburredLetters);
  var deburrLetter_default = deburrLetter;

  // node_modules/lodash-es/deburr.js
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
  var rsComboMarksRange3 = "\\u0300-\\u036f";
  var reComboHalfMarksRange3 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange3 = "\\u20d0-\\u20ff";
  var rsComboRange3 = rsComboMarksRange3 + reComboHalfMarksRange3 + rsComboSymbolsRange3;
  var rsCombo2 = "[" + rsComboRange3 + "]";
  var reComboMark = RegExp(rsCombo2, "g");
  function deburr(string) {
    string = toString_default(string);
    return string && string.replace(reLatin, deburrLetter_default).replace(reComboMark, "");
  }
  var deburr_default = deburr;

  // node_modules/lodash-es/words.js
  init_define_process();

  // node_modules/lodash-es/_asciiWords.js
  init_define_process();
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }
  var asciiWords_default = asciiWords;

  // node_modules/lodash-es/_hasUnicodeWord.js
  init_define_process();
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }
  var hasUnicodeWord_default = hasUnicodeWord;

  // node_modules/lodash-es/_unicodeWords.js
  init_define_process();
  var rsAstralRange3 = "\\ud800-\\udfff";
  var rsComboMarksRange4 = "\\u0300-\\u036f";
  var reComboHalfMarksRange4 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange4 = "\\u20d0-\\u20ff";
  var rsComboRange4 = rsComboMarksRange4 + reComboHalfMarksRange4 + rsComboSymbolsRange4;
  var rsDingbatRange = "\\u2700-\\u27bf";
  var rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff";
  var rsMathOpRange = "\\xac\\xb1\\xd7\\xf7";
  var rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf";
  var rsPunctuationRange = "\\u2000-\\u206f";
  var rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000";
  var rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde";
  var rsVarRange3 = "\\ufe0e\\ufe0f";
  var rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
  var rsApos = "['\u2019]";
  var rsBreak = "[" + rsBreakRange + "]";
  var rsCombo3 = "[" + rsComboRange4 + "]";
  var rsDigits = "\\d+";
  var rsDingbat = "[" + rsDingbatRange + "]";
  var rsLower = "[" + rsLowerRange + "]";
  var rsMisc = "[^" + rsAstralRange3 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]";
  var rsFitz2 = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier2 = "(?:" + rsCombo3 + "|" + rsFitz2 + ")";
  var rsNonAstral2 = "[^" + rsAstralRange3 + "]";
  var rsRegional2 = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair2 = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsUpper = "[" + rsUpperRange + "]";
  var rsZWJ3 = "\\u200d";
  var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")";
  var rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")";
  var rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?";
  var rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?";
  var reOptMod2 = rsModifier2 + "?";
  var rsOptVar2 = "[" + rsVarRange3 + "]?";
  var rsOptJoin2 = "(?:" + rsZWJ3 + "(?:" + [rsNonAstral2, rsRegional2, rsSurrPair2].join("|") + ")" + rsOptVar2 + reOptMod2 + ")*";
  var rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])";
  var rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])";
  var rsSeq2 = rsOptVar2 + reOptMod2 + rsOptJoin2;
  var rsEmoji = "(?:" + [rsDingbat, rsRegional2, rsSurrPair2].join("|") + ")" + rsSeq2;
  var reUnicodeWord = RegExp([
    rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
    rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
    rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
    rsUpper + "+" + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join("|"), "g");
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }
  var unicodeWords_default = unicodeWords;

  // node_modules/lodash-es/words.js
  function words(string, pattern, guard) {
    string = toString_default(string);
    pattern = guard ? void 0 : pattern;
    if (pattern === void 0) {
      return hasUnicodeWord_default(string) ? unicodeWords_default(string) : asciiWords_default(string);
    }
    return string.match(pattern) || [];
  }
  var words_default = words;

  // node_modules/lodash-es/_createCompounder.js
  var rsApos2 = "['\u2019]";
  var reApos = RegExp(rsApos2, "g");
  function createCompounder(callback) {
    return function(string) {
      return arrayReduce_default(words_default(deburr_default(string).replace(reApos, "")), callback, "");
    };
  }
  var createCompounder_default = createCompounder;

  // node_modules/lodash-es/camelCase.js
  var camelCase = createCompounder_default(function(result2, word, index) {
    word = word.toLowerCase();
    return result2 + (index ? capitalize_default(word) : word);
  });
  var camelCase_default = camelCase;

  // node_modules/lodash-es/castArray.js
  init_define_process();
  function castArray() {
    if (!arguments.length) {
      return [];
    }
    var value = arguments[0];
    return isArray_default(value) ? value : [value];
  }
  var castArray_default = castArray;

  // node_modules/lodash-es/ceil.js
  init_define_process();

  // node_modules/lodash-es/_createRound.js
  init_define_process();
  var nativeIsFinite = root_default.isFinite;
  var nativeMin3 = Math.min;
  function createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
      number = toNumber_default(number);
      precision = precision == null ? 0 : nativeMin3(toInteger_default(precision), 292);
      if (precision && nativeIsFinite(number)) {
        var pair = (toString_default(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
        pair = (toString_default(value) + "e").split("e");
        return +(pair[0] + "e" + (+pair[1] - precision));
      }
      return func(number);
    };
  }
  var createRound_default = createRound;

  // node_modules/lodash-es/ceil.js
  var ceil = createRound_default("ceil");
  var ceil_default = ceil;

  // node_modules/lodash-es/chain.js
  init_define_process();
  function chain(value) {
    var result2 = wrapperLodash_default(value);
    result2.__chain__ = true;
    return result2;
  }
  var chain_default = chain;

  // node_modules/lodash-es/chunk.js
  init_define_process();
  var nativeCeil = Math.ceil;
  var nativeMax5 = Math.max;
  function chunk(array, size2, guard) {
    if (guard ? isIterateeCall_default(array, size2, guard) : size2 === void 0) {
      size2 = 1;
    } else {
      size2 = nativeMax5(toInteger_default(size2), 0);
    }
    var length = array == null ? 0 : array.length;
    if (!length || size2 < 1) {
      return [];
    }
    var index = 0, resIndex = 0, result2 = Array(nativeCeil(length / size2));
    while (index < length) {
      result2[resIndex++] = baseSlice_default(array, index, index += size2);
    }
    return result2;
  }
  var chunk_default = chunk;

  // node_modules/lodash-es/clamp.js
  init_define_process();

  // node_modules/lodash-es/_baseClamp.js
  init_define_process();
  function baseClamp(number, lower, upper) {
    if (number === number) {
      if (upper !== void 0) {
        number = number <= upper ? number : upper;
      }
      if (lower !== void 0) {
        number = number >= lower ? number : lower;
      }
    }
    return number;
  }
  var baseClamp_default = baseClamp;

  // node_modules/lodash-es/clamp.js
  function clamp(number, lower, upper) {
    if (upper === void 0) {
      upper = lower;
      lower = void 0;
    }
    if (upper !== void 0) {
      upper = toNumber_default(upper);
      upper = upper === upper ? upper : 0;
    }
    if (lower !== void 0) {
      lower = toNumber_default(lower);
      lower = lower === lower ? lower : 0;
    }
    return baseClamp_default(toNumber_default(number), lower, upper);
  }
  var clamp_default = clamp;

  // node_modules/lodash-es/clone.js
  init_define_process();

  // node_modules/lodash-es/_baseClone.js
  init_define_process();

  // node_modules/lodash-es/_Stack.js
  init_define_process();

  // node_modules/lodash-es/_stackClear.js
  init_define_process();
  function stackClear() {
    this.__data__ = new ListCache_default();
    this.size = 0;
  }
  var stackClear_default = stackClear;

  // node_modules/lodash-es/_stackDelete.js
  init_define_process();
  function stackDelete(key) {
    var data = this.__data__, result2 = data["delete"](key);
    this.size = data.size;
    return result2;
  }
  var stackDelete_default = stackDelete;

  // node_modules/lodash-es/_stackGet.js
  init_define_process();
  function stackGet(key) {
    return this.__data__.get(key);
  }
  var stackGet_default = stackGet;

  // node_modules/lodash-es/_stackHas.js
  init_define_process();
  function stackHas(key) {
    return this.__data__.has(key);
  }
  var stackHas_default = stackHas;

  // node_modules/lodash-es/_stackSet.js
  init_define_process();
  var LARGE_ARRAY_SIZE = 200;
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache_default) {
      var pairs = data.__data__;
      if (!Map_default || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache_default(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  var stackSet_default = stackSet;

  // node_modules/lodash-es/_Stack.js
  function Stack(entries) {
    var data = this.__data__ = new ListCache_default(entries);
    this.size = data.size;
  }
  Stack.prototype.clear = stackClear_default;
  Stack.prototype["delete"] = stackDelete_default;
  Stack.prototype.get = stackGet_default;
  Stack.prototype.has = stackHas_default;
  Stack.prototype.set = stackSet_default;
  var Stack_default = Stack;

  // node_modules/lodash-es/_baseAssign.js
  init_define_process();
  function baseAssign(object, source) {
    return object && copyObject_default(source, keys_default(source), object);
  }
  var baseAssign_default = baseAssign;

  // node_modules/lodash-es/_baseAssignIn.js
  init_define_process();
  function baseAssignIn(object, source) {
    return object && copyObject_default(source, keysIn_default(source), object);
  }
  var baseAssignIn_default = baseAssignIn;

  // node_modules/lodash-es/_cloneBuffer.js
  init_define_process();
  var freeExports3 = typeof exports == "object" && exports && !exports.nodeType && exports;
  var freeModule3 = freeExports3 && typeof module == "object" && module && !module.nodeType && module;
  var moduleExports3 = freeModule3 && freeModule3.exports === freeExports3;
  var Buffer4 = moduleExports3 ? root_default.Buffer : void 0;
  var allocUnsafe = Buffer4 ? Buffer4.allocUnsafe : void 0;
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result2);
    return result2;
  }
  var cloneBuffer_default = cloneBuffer;

  // node_modules/lodash-es/_copySymbols.js
  init_define_process();

  // node_modules/lodash-es/_getSymbols.js
  init_define_process();

  // node_modules/lodash-es/_arrayFilter.js
  init_define_process();
  function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result2[resIndex++] = value;
      }
    }
    return result2;
  }
  var arrayFilter_default = arrayFilter;

  // node_modules/lodash-es/stubArray.js
  init_define_process();
  function stubArray() {
    return [];
  }
  var stubArray_default = stubArray;

  // node_modules/lodash-es/_getSymbols.js
  var objectProto16 = Object.prototype;
  var propertyIsEnumerable2 = objectProto16.propertyIsEnumerable;
  var nativeGetSymbols = Object.getOwnPropertySymbols;
  var getSymbols = !nativeGetSymbols ? stubArray_default : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter_default(nativeGetSymbols(object), function(symbol) {
      return propertyIsEnumerable2.call(object, symbol);
    });
  };
  var getSymbols_default = getSymbols;

  // node_modules/lodash-es/_copySymbols.js
  function copySymbols(source, object) {
    return copyObject_default(source, getSymbols_default(source), object);
  }
  var copySymbols_default = copySymbols;

  // node_modules/lodash-es/_copySymbolsIn.js
  init_define_process();

  // node_modules/lodash-es/_getSymbolsIn.js
  init_define_process();
  var nativeGetSymbols2 = Object.getOwnPropertySymbols;
  var getSymbolsIn = !nativeGetSymbols2 ? stubArray_default : function(object) {
    var result2 = [];
    while (object) {
      arrayPush_default(result2, getSymbols_default(object));
      object = getPrototype_default(object);
    }
    return result2;
  };
  var getSymbolsIn_default = getSymbolsIn;

  // node_modules/lodash-es/_copySymbolsIn.js
  function copySymbolsIn(source, object) {
    return copyObject_default(source, getSymbolsIn_default(source), object);
  }
  var copySymbolsIn_default = copySymbolsIn;

  // node_modules/lodash-es/_getAllKeys.js
  init_define_process();

  // node_modules/lodash-es/_baseGetAllKeys.js
  init_define_process();
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result2 = keysFunc(object);
    return isArray_default(object) ? result2 : arrayPush_default(result2, symbolsFunc(object));
  }
  var baseGetAllKeys_default = baseGetAllKeys;

  // node_modules/lodash-es/_getAllKeys.js
  function getAllKeys(object) {
    return baseGetAllKeys_default(object, keys_default, getSymbols_default);
  }
  var getAllKeys_default = getAllKeys;

  // node_modules/lodash-es/_getAllKeysIn.js
  init_define_process();
  function getAllKeysIn(object) {
    return baseGetAllKeys_default(object, keysIn_default, getSymbolsIn_default);
  }
  var getAllKeysIn_default = getAllKeysIn;

  // node_modules/lodash-es/_getTag.js
  init_define_process();

  // node_modules/lodash-es/_DataView.js
  init_define_process();
  var DataView2 = getNative_default(root_default, "DataView");
  var DataView_default = DataView2;

  // node_modules/lodash-es/_Promise.js
  init_define_process();
  var Promise2 = getNative_default(root_default, "Promise");
  var Promise_default = Promise2;

  // node_modules/lodash-es/_Set.js
  init_define_process();
  var Set2 = getNative_default(root_default, "Set");
  var Set_default = Set2;

  // node_modules/lodash-es/_getTag.js
  var mapTag2 = "[object Map]";
  var objectTag3 = "[object Object]";
  var promiseTag = "[object Promise]";
  var setTag2 = "[object Set]";
  var weakMapTag2 = "[object WeakMap]";
  var dataViewTag2 = "[object DataView]";
  var dataViewCtorString = toSource_default(DataView_default);
  var mapCtorString = toSource_default(Map_default);
  var promiseCtorString = toSource_default(Promise_default);
  var setCtorString = toSource_default(Set_default);
  var weakMapCtorString = toSource_default(WeakMap_default);
  var getTag = baseGetTag_default;
  if (DataView_default && getTag(new DataView_default(new ArrayBuffer(1))) != dataViewTag2 || Map_default && getTag(new Map_default()) != mapTag2 || Promise_default && getTag(Promise_default.resolve()) != promiseTag || Set_default && getTag(new Set_default()) != setTag2 || WeakMap_default && getTag(new WeakMap_default()) != weakMapTag2) {
    getTag = function(value) {
      var result2 = baseGetTag_default(value), Ctor = result2 == objectTag3 ? value.constructor : void 0, ctorString = Ctor ? toSource_default(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag2;
          case mapCtorString:
            return mapTag2;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag2;
          case weakMapCtorString:
            return weakMapTag2;
        }
      }
      return result2;
    };
  }
  var getTag_default = getTag;

  // node_modules/lodash-es/_initCloneArray.js
  init_define_process();
  var objectProto17 = Object.prototype;
  var hasOwnProperty14 = objectProto17.hasOwnProperty;
  function initCloneArray(array) {
    var length = array.length, result2 = new array.constructor(length);
    if (length && typeof array[0] == "string" && hasOwnProperty14.call(array, "index")) {
      result2.index = array.index;
      result2.input = array.input;
    }
    return result2;
  }
  var initCloneArray_default = initCloneArray;

  // node_modules/lodash-es/_initCloneByTag.js
  init_define_process();

  // node_modules/lodash-es/_cloneArrayBuffer.js
  init_define_process();

  // node_modules/lodash-es/_Uint8Array.js
  init_define_process();
  var Uint8Array2 = root_default.Uint8Array;
  var Uint8Array_default = Uint8Array2;

  // node_modules/lodash-es/_cloneArrayBuffer.js
  function cloneArrayBuffer(arrayBuffer) {
    var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array_default(result2).set(new Uint8Array_default(arrayBuffer));
    return result2;
  }
  var cloneArrayBuffer_default = cloneArrayBuffer;

  // node_modules/lodash-es/_cloneDataView.js
  init_define_process();
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer_default(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  var cloneDataView_default = cloneDataView;

  // node_modules/lodash-es/_cloneRegExp.js
  init_define_process();
  var reFlags = /\w*$/;
  function cloneRegExp(regexp) {
    var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result2.lastIndex = regexp.lastIndex;
    return result2;
  }
  var cloneRegExp_default = cloneRegExp;

  // node_modules/lodash-es/_cloneSymbol.js
  init_define_process();
  var symbolProto2 = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0;
  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  var cloneSymbol_default = cloneSymbol;

  // node_modules/lodash-es/_cloneTypedArray.js
  init_define_process();
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer_default(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  var cloneTypedArray_default = cloneTypedArray;

  // node_modules/lodash-es/_initCloneByTag.js
  var boolTag2 = "[object Boolean]";
  var dateTag2 = "[object Date]";
  var mapTag3 = "[object Map]";
  var numberTag2 = "[object Number]";
  var regexpTag2 = "[object RegExp]";
  var setTag3 = "[object Set]";
  var stringTag2 = "[object String]";
  var symbolTag2 = "[object Symbol]";
  var arrayBufferTag2 = "[object ArrayBuffer]";
  var dataViewTag3 = "[object DataView]";
  var float32Tag2 = "[object Float32Array]";
  var float64Tag2 = "[object Float64Array]";
  var int8Tag2 = "[object Int8Array]";
  var int16Tag2 = "[object Int16Array]";
  var int32Tag2 = "[object Int32Array]";
  var uint8Tag2 = "[object Uint8Array]";
  var uint8ClampedTag2 = "[object Uint8ClampedArray]";
  var uint16Tag2 = "[object Uint16Array]";
  var uint32Tag2 = "[object Uint32Array]";
  function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag2:
        return cloneArrayBuffer_default(object);
      case boolTag2:
      case dateTag2:
        return new Ctor(+object);
      case dataViewTag3:
        return cloneDataView_default(object, isDeep);
      case float32Tag2:
      case float64Tag2:
      case int8Tag2:
      case int16Tag2:
      case int32Tag2:
      case uint8Tag2:
      case uint8ClampedTag2:
      case uint16Tag2:
      case uint32Tag2:
        return cloneTypedArray_default(object, isDeep);
      case mapTag3:
        return new Ctor();
      case numberTag2:
      case stringTag2:
        return new Ctor(object);
      case regexpTag2:
        return cloneRegExp_default(object);
      case setTag3:
        return new Ctor();
      case symbolTag2:
        return cloneSymbol_default(object);
    }
  }
  var initCloneByTag_default = initCloneByTag;

  // node_modules/lodash-es/_initCloneObject.js
  init_define_process();
  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype_default(object) ? baseCreate_default(getPrototype_default(object)) : {};
  }
  var initCloneObject_default = initCloneObject;

  // node_modules/lodash-es/isMap.js
  init_define_process();

  // node_modules/lodash-es/_baseIsMap.js
  init_define_process();
  var mapTag4 = "[object Map]";
  function baseIsMap(value) {
    return isObjectLike_default(value) && getTag_default(value) == mapTag4;
  }
  var baseIsMap_default = baseIsMap;

  // node_modules/lodash-es/isMap.js
  var nodeIsMap = nodeUtil_default && nodeUtil_default.isMap;
  var isMap = nodeIsMap ? baseUnary_default(nodeIsMap) : baseIsMap_default;
  var isMap_default = isMap;

  // node_modules/lodash-es/isSet.js
  init_define_process();

  // node_modules/lodash-es/_baseIsSet.js
  init_define_process();
  var setTag4 = "[object Set]";
  function baseIsSet(value) {
    return isObjectLike_default(value) && getTag_default(value) == setTag4;
  }
  var baseIsSet_default = baseIsSet;

  // node_modules/lodash-es/isSet.js
  var nodeIsSet = nodeUtil_default && nodeUtil_default.isSet;
  var isSet = nodeIsSet ? baseUnary_default(nodeIsSet) : baseIsSet_default;
  var isSet_default = isSet;

  // node_modules/lodash-es/_baseClone.js
  var CLONE_DEEP_FLAG = 1;
  var CLONE_FLAT_FLAG = 2;
  var CLONE_SYMBOLS_FLAG = 4;
  var argsTag3 = "[object Arguments]";
  var arrayTag2 = "[object Array]";
  var boolTag3 = "[object Boolean]";
  var dateTag3 = "[object Date]";
  var errorTag3 = "[object Error]";
  var funcTag3 = "[object Function]";
  var genTag2 = "[object GeneratorFunction]";
  var mapTag5 = "[object Map]";
  var numberTag3 = "[object Number]";
  var objectTag4 = "[object Object]";
  var regexpTag3 = "[object RegExp]";
  var setTag5 = "[object Set]";
  var stringTag3 = "[object String]";
  var symbolTag3 = "[object Symbol]";
  var weakMapTag3 = "[object WeakMap]";
  var arrayBufferTag3 = "[object ArrayBuffer]";
  var dataViewTag4 = "[object DataView]";
  var float32Tag3 = "[object Float32Array]";
  var float64Tag3 = "[object Float64Array]";
  var int8Tag3 = "[object Int8Array]";
  var int16Tag3 = "[object Int16Array]";
  var int32Tag3 = "[object Int32Array]";
  var uint8Tag3 = "[object Uint8Array]";
  var uint8ClampedTag3 = "[object Uint8ClampedArray]";
  var uint16Tag3 = "[object Uint16Array]";
  var uint32Tag3 = "[object Uint32Array]";
  var cloneableTags = {};
  cloneableTags[argsTag3] = cloneableTags[arrayTag2] = cloneableTags[arrayBufferTag3] = cloneableTags[dataViewTag4] = cloneableTags[boolTag3] = cloneableTags[dateTag3] = cloneableTags[float32Tag3] = cloneableTags[float64Tag3] = cloneableTags[int8Tag3] = cloneableTags[int16Tag3] = cloneableTags[int32Tag3] = cloneableTags[mapTag5] = cloneableTags[numberTag3] = cloneableTags[objectTag4] = cloneableTags[regexpTag3] = cloneableTags[setTag5] = cloneableTags[stringTag3] = cloneableTags[symbolTag3] = cloneableTags[uint8Tag3] = cloneableTags[uint8ClampedTag3] = cloneableTags[uint16Tag3] = cloneableTags[uint32Tag3] = true;
  cloneableTags[errorTag3] = cloneableTags[funcTag3] = cloneableTags[weakMapTag3] = false;
  function baseClone(value, bitmask, customizer, key, object, stack) {
    var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) {
      result2 = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result2 !== void 0) {
      return result2;
    }
    if (!isObject_default(value)) {
      return value;
    }
    var isArr = isArray_default(value);
    if (isArr) {
      result2 = initCloneArray_default(value);
      if (!isDeep) {
        return copyArray_default(value, result2);
      }
    } else {
      var tag = getTag_default(value), isFunc = tag == funcTag3 || tag == genTag2;
      if (isBuffer_default(value)) {
        return cloneBuffer_default(value, isDeep);
      }
      if (tag == objectTag4 || tag == argsTag3 || isFunc && !object) {
        result2 = isFlat || isFunc ? {} : initCloneObject_default(value);
        if (!isDeep) {
          return isFlat ? copySymbolsIn_default(value, baseAssignIn_default(result2, value)) : copySymbols_default(value, baseAssign_default(result2, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }
        result2 = initCloneByTag_default(value, tag, isDeep);
      }
    }
    stack || (stack = new Stack_default());
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result2);
    if (isSet_default(value)) {
      value.forEach(function(subValue) {
        result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
      });
    } else if (isMap_default(value)) {
      value.forEach(function(subValue, key2) {
        result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
      });
    }
    var keysFunc = isFull ? isFlat ? getAllKeysIn_default : getAllKeys_default : isFlat ? keysIn_default : keys_default;
    var props = isArr ? void 0 : keysFunc(value);
    arrayEach_default(props || value, function(subValue, key2) {
      if (props) {
        key2 = subValue;
        subValue = value[key2];
      }
      assignValue_default(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
    });
    return result2;
  }
  var baseClone_default = baseClone;

  // node_modules/lodash-es/clone.js
  var CLONE_SYMBOLS_FLAG2 = 4;
  function clone(value) {
    return baseClone_default(value, CLONE_SYMBOLS_FLAG2);
  }
  var clone_default = clone;

  // node_modules/lodash-es/cloneDeep.js
  init_define_process();
  var CLONE_DEEP_FLAG2 = 1;
  var CLONE_SYMBOLS_FLAG3 = 4;
  function cloneDeep(value) {
    return baseClone_default(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG3);
  }
  var cloneDeep_default = cloneDeep;

  // node_modules/lodash-es/cloneDeepWith.js
  init_define_process();
  var CLONE_DEEP_FLAG3 = 1;
  var CLONE_SYMBOLS_FLAG4 = 4;
  function cloneDeepWith(value, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return baseClone_default(value, CLONE_DEEP_FLAG3 | CLONE_SYMBOLS_FLAG4, customizer);
  }
  var cloneDeepWith_default = cloneDeepWith;

  // node_modules/lodash-es/cloneWith.js
  init_define_process();
  var CLONE_SYMBOLS_FLAG5 = 4;
  function cloneWith(value, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return baseClone_default(value, CLONE_SYMBOLS_FLAG5, customizer);
  }
  var cloneWith_default = cloneWith;

  // node_modules/lodash-es/commit.js
  init_define_process();
  function wrapperCommit() {
    return new LodashWrapper_default(this.value(), this.__chain__);
  }
  var commit_default = wrapperCommit;

  // node_modules/lodash-es/compact.js
  init_define_process();
  function compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index];
      if (value) {
        result2[resIndex++] = value;
      }
    }
    return result2;
  }
  var compact_default = compact;

  // node_modules/lodash-es/concat.js
  init_define_process();
  function concat() {
    var length = arguments.length;
    if (!length) {
      return [];
    }
    var args = Array(length - 1), array = arguments[0], index = length;
    while (index--) {
      args[index - 1] = arguments[index];
    }
    return arrayPush_default(isArray_default(array) ? copyArray_default(array) : [array], baseFlatten_default(args, 1));
  }
  var concat_default = concat;

  // node_modules/lodash-es/cond.js
  init_define_process();

  // node_modules/lodash-es/_baseIteratee.js
  init_define_process();

  // node_modules/lodash-es/_baseMatches.js
  init_define_process();

  // node_modules/lodash-es/_baseIsMatch.js
  init_define_process();

  // node_modules/lodash-es/_baseIsEqual.js
  init_define_process();

  // node_modules/lodash-es/_baseIsEqualDeep.js
  init_define_process();

  // node_modules/lodash-es/_equalArrays.js
  init_define_process();

  // node_modules/lodash-es/_SetCache.js
  init_define_process();

  // node_modules/lodash-es/_setCacheAdd.js
  init_define_process();
  var HASH_UNDEFINED3 = "__lodash_hash_undefined__";
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED3);
    return this;
  }
  var setCacheAdd_default = setCacheAdd;

  // node_modules/lodash-es/_setCacheHas.js
  init_define_process();
  function setCacheHas(value) {
    return this.__data__.has(value);
  }
  var setCacheHas_default = setCacheHas;

  // node_modules/lodash-es/_SetCache.js
  function SetCache(values2) {
    var index = -1, length = values2 == null ? 0 : values2.length;
    this.__data__ = new MapCache_default();
    while (++index < length) {
      this.add(values2[index]);
    }
  }
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd_default;
  SetCache.prototype.has = setCacheHas_default;
  var SetCache_default = SetCache;

  // node_modules/lodash-es/_arraySome.js
  init_define_process();
  function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  var arraySome_default = arraySome;

  // node_modules/lodash-es/_cacheHas.js
  init_define_process();
  function cacheHas(cache, key) {
    return cache.has(key);
  }
  var cacheHas_default = cacheHas;

  // node_modules/lodash-es/_equalArrays.js
  var COMPARE_PARTIAL_FLAG = 1;
  var COMPARE_UNORDERED_FLAG = 2;
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }
    var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache_default() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result2 = false;
        break;
      }
      if (seen) {
        if (!arraySome_default(other, function(othValue2, othIndex) {
          if (!cacheHas_default(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result2 = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result2 = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result2;
  }
  var equalArrays_default = equalArrays;

  // node_modules/lodash-es/_equalByTag.js
  init_define_process();

  // node_modules/lodash-es/_mapToArray.js
  init_define_process();
  function mapToArray(map2) {
    var index = -1, result2 = Array(map2.size);
    map2.forEach(function(value, key) {
      result2[++index] = [key, value];
    });
    return result2;
  }
  var mapToArray_default = mapToArray;

  // node_modules/lodash-es/_setToArray.js
  init_define_process();
  function setToArray(set2) {
    var index = -1, result2 = Array(set2.size);
    set2.forEach(function(value) {
      result2[++index] = value;
    });
    return result2;
  }
  var setToArray_default = setToArray;

  // node_modules/lodash-es/_equalByTag.js
  var COMPARE_PARTIAL_FLAG2 = 1;
  var COMPARE_UNORDERED_FLAG2 = 2;
  var boolTag4 = "[object Boolean]";
  var dateTag4 = "[object Date]";
  var errorTag4 = "[object Error]";
  var mapTag6 = "[object Map]";
  var numberTag4 = "[object Number]";
  var regexpTag4 = "[object RegExp]";
  var setTag6 = "[object Set]";
  var stringTag4 = "[object String]";
  var symbolTag4 = "[object Symbol]";
  var arrayBufferTag4 = "[object ArrayBuffer]";
  var dataViewTag5 = "[object DataView]";
  var symbolProto3 = Symbol_default ? Symbol_default.prototype : void 0;
  var symbolValueOf2 = symbolProto3 ? symbolProto3.valueOf : void 0;
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag5:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag4:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array_default(object), new Uint8Array_default(other))) {
          return false;
        }
        return true;
      case boolTag4:
      case dateTag4:
      case numberTag4:
        return eq_default(+object, +other);
      case errorTag4:
        return object.name == other.name && object.message == other.message;
      case regexpTag4:
      case stringTag4:
        return object == other + "";
      case mapTag6:
        var convert = mapToArray_default;
      case setTag6:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
        convert || (convert = setToArray_default);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG2;
        stack.set(object, other);
        var result2 = equalArrays_default(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object);
        return result2;
      case symbolTag4:
        if (symbolValueOf2) {
          return symbolValueOf2.call(object) == symbolValueOf2.call(other);
        }
    }
    return false;
  }
  var equalByTag_default = equalByTag;

  // node_modules/lodash-es/_equalObjects.js
  init_define_process();
  var COMPARE_PARTIAL_FLAG3 = 1;
  var objectProto18 = Object.prototype;
  var hasOwnProperty15 = objectProto18.hasOwnProperty;
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG3, objProps = getAllKeys_default(object), objLength = objProps.length, othProps = getAllKeys_default(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty15.call(other, key))) {
        return false;
      }
    }
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object;
    }
    var result2 = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result2 = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result2 && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result2 = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result2;
  }
  var equalObjects_default = equalObjects;

  // node_modules/lodash-es/_baseIsEqualDeep.js
  var COMPARE_PARTIAL_FLAG4 = 1;
  var argsTag4 = "[object Arguments]";
  var arrayTag3 = "[object Array]";
  var objectTag5 = "[object Object]";
  var objectProto19 = Object.prototype;
  var hasOwnProperty16 = objectProto19.hasOwnProperty;
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray_default(object), othIsArr = isArray_default(other), objTag = objIsArr ? arrayTag3 : getTag_default(object), othTag = othIsArr ? arrayTag3 : getTag_default(other);
    objTag = objTag == argsTag4 ? objectTag5 : objTag;
    othTag = othTag == argsTag4 ? objectTag5 : othTag;
    var objIsObj = objTag == objectTag5, othIsObj = othTag == objectTag5, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer_default(object)) {
      if (!isBuffer_default(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack_default());
      return objIsArr || isTypedArray_default(object) ? equalArrays_default(object, other, bitmask, customizer, equalFunc, stack) : equalByTag_default(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG4)) {
      var objIsWrapped = objIsObj && hasOwnProperty16.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty16.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack_default());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack_default());
    return equalObjects_default(object, other, bitmask, customizer, equalFunc, stack);
  }
  var baseIsEqualDeep_default = baseIsEqualDeep;

  // node_modules/lodash-es/_baseIsEqual.js
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike_default(value) && !isObjectLike_default(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep_default(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  var baseIsEqual_default = baseIsEqual;

  // node_modules/lodash-es/_baseIsMatch.js
  var COMPARE_PARTIAL_FLAG5 = 1;
  var COMPARE_UNORDERED_FLAG3 = 2;
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0], objValue = object[key], srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === void 0 && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack_default();
        if (customizer) {
          var result2 = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result2 === void 0 ? baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG5 | COMPARE_UNORDERED_FLAG3, customizer, stack) : result2)) {
          return false;
        }
      }
    }
    return true;
  }
  var baseIsMatch_default = baseIsMatch;

  // node_modules/lodash-es/_getMatchData.js
  init_define_process();

  // node_modules/lodash-es/_isStrictComparable.js
  init_define_process();
  function isStrictComparable(value) {
    return value === value && !isObject_default(value);
  }
  var isStrictComparable_default = isStrictComparable;

  // node_modules/lodash-es/_getMatchData.js
  function getMatchData(object) {
    var result2 = keys_default(object), length = result2.length;
    while (length--) {
      var key = result2[length], value = object[key];
      result2[length] = [key, value, isStrictComparable_default(value)];
    }
    return result2;
  }
  var getMatchData_default = getMatchData;

  // node_modules/lodash-es/_matchesStrictComparable.js
  init_define_process();
  function matchesStrictComparable(key, srcValue) {
    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
    };
  }
  var matchesStrictComparable_default = matchesStrictComparable;

  // node_modules/lodash-es/_baseMatches.js
  function baseMatches(source) {
    var matchData = getMatchData_default(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable_default(matchData[0][0], matchData[0][1]);
    }
    return function(object) {
      return object === source || baseIsMatch_default(object, source, matchData);
    };
  }
  var baseMatches_default = baseMatches;

  // node_modules/lodash-es/_baseMatchesProperty.js
  init_define_process();

  // node_modules/lodash-es/hasIn.js
  init_define_process();

  // node_modules/lodash-es/_baseHasIn.js
  init_define_process();
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  var baseHasIn_default = baseHasIn;

  // node_modules/lodash-es/_hasPath.js
  init_define_process();
  function hasPath(object, path, hasFunc) {
    path = castPath_default(path, object);
    var index = -1, length = path.length, result2 = false;
    while (++index < length) {
      var key = toKey_default(path[index]);
      if (!(result2 = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result2 || ++index != length) {
      return result2;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength_default(length) && isIndex_default(key, length) && (isArray_default(object) || isArguments_default(object));
  }
  var hasPath_default = hasPath;

  // node_modules/lodash-es/hasIn.js
  function hasIn(object, path) {
    return object != null && hasPath_default(object, path, baseHasIn_default);
  }
  var hasIn_default = hasIn;

  // node_modules/lodash-es/_baseMatchesProperty.js
  var COMPARE_PARTIAL_FLAG6 = 1;
  var COMPARE_UNORDERED_FLAG4 = 2;
  function baseMatchesProperty(path, srcValue) {
    if (isKey_default(path) && isStrictComparable_default(srcValue)) {
      return matchesStrictComparable_default(toKey_default(path), srcValue);
    }
    return function(object) {
      var objValue = get_default(object, path);
      return objValue === void 0 && objValue === srcValue ? hasIn_default(object, path) : baseIsEqual_default(srcValue, objValue, COMPARE_PARTIAL_FLAG6 | COMPARE_UNORDERED_FLAG4);
    };
  }
  var baseMatchesProperty_default = baseMatchesProperty;

  // node_modules/lodash-es/property.js
  init_define_process();

  // node_modules/lodash-es/_baseProperty.js
  init_define_process();
  function baseProperty(key) {
    return function(object) {
      return object == null ? void 0 : object[key];
    };
  }
  var baseProperty_default = baseProperty;

  // node_modules/lodash-es/_basePropertyDeep.js
  init_define_process();
  function basePropertyDeep(path) {
    return function(object) {
      return baseGet_default(object, path);
    };
  }
  var basePropertyDeep_default = basePropertyDeep;

  // node_modules/lodash-es/property.js
  function property(path) {
    return isKey_default(path) ? baseProperty_default(toKey_default(path)) : basePropertyDeep_default(path);
  }
  var property_default = property;

  // node_modules/lodash-es/_baseIteratee.js
  function baseIteratee(value) {
    if (typeof value == "function") {
      return value;
    }
    if (value == null) {
      return identity_default;
    }
    if (typeof value == "object") {
      return isArray_default(value) ? baseMatchesProperty_default(value[0], value[1]) : baseMatches_default(value);
    }
    return property_default(value);
  }
  var baseIteratee_default = baseIteratee;

  // node_modules/lodash-es/cond.js
  var FUNC_ERROR_TEXT5 = "Expected a function";
  function cond(pairs) {
    var length = pairs == null ? 0 : pairs.length, toIteratee = baseIteratee_default;
    pairs = !length ? [] : arrayMap_default(pairs, function(pair) {
      if (typeof pair[1] != "function") {
        throw new TypeError(FUNC_ERROR_TEXT5);
      }
      return [toIteratee(pair[0]), pair[1]];
    });
    return baseRest_default(function(args) {
      var index = -1;
      while (++index < length) {
        var pair = pairs[index];
        if (apply_default(pair[0], this, args)) {
          return apply_default(pair[1], this, args);
        }
      }
    });
  }
  var cond_default = cond;

  // node_modules/lodash-es/conforms.js
  init_define_process();

  // node_modules/lodash-es/_baseConforms.js
  init_define_process();

  // node_modules/lodash-es/_baseConformsTo.js
  init_define_process();
  function baseConformsTo(object, source, props) {
    var length = props.length;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (length--) {
      var key = props[length], predicate = source[key], value = object[key];
      if (value === void 0 && !(key in object) || !predicate(value)) {
        return false;
      }
    }
    return true;
  }
  var baseConformsTo_default = baseConformsTo;

  // node_modules/lodash-es/_baseConforms.js
  function baseConforms(source) {
    var props = keys_default(source);
    return function(object) {
      return baseConformsTo_default(object, source, props);
    };
  }
  var baseConforms_default = baseConforms;

  // node_modules/lodash-es/conforms.js
  var CLONE_DEEP_FLAG4 = 1;
  function conforms(source) {
    return baseConforms_default(baseClone_default(source, CLONE_DEEP_FLAG4));
  }
  var conforms_default = conforms;

  // node_modules/lodash-es/conformsTo.js
  init_define_process();
  function conformsTo(object, source) {
    return source == null || baseConformsTo_default(object, source, keys_default(source));
  }
  var conformsTo_default = conformsTo;

  // node_modules/lodash-es/countBy.js
  init_define_process();

  // node_modules/lodash-es/_createAggregator.js
  init_define_process();

  // node_modules/lodash-es/_arrayAggregator.js
  init_define_process();
  function arrayAggregator(array, setter, iteratee2, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee2(value), array);
    }
    return accumulator;
  }
  var arrayAggregator_default = arrayAggregator;

  // node_modules/lodash-es/_baseAggregator.js
  init_define_process();

  // node_modules/lodash-es/_baseEach.js
  init_define_process();

  // node_modules/lodash-es/_baseForOwn.js
  init_define_process();

  // node_modules/lodash-es/_baseFor.js
  init_define_process();

  // node_modules/lodash-es/_createBaseFor.js
  init_define_process();
  function createBaseFor(fromRight) {
    return function(object, iteratee2, keysFunc) {
      var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee2(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  var createBaseFor_default = createBaseFor;

  // node_modules/lodash-es/_baseFor.js
  var baseFor = createBaseFor_default();
  var baseFor_default = baseFor;

  // node_modules/lodash-es/_baseForOwn.js
  function baseForOwn(object, iteratee2) {
    return object && baseFor_default(object, iteratee2, keys_default);
  }
  var baseForOwn_default = baseForOwn;

  // node_modules/lodash-es/_createBaseEach.js
  init_define_process();
  function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee2) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike_default(collection)) {
        return eachFunc(collection, iteratee2);
      }
      var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
      while (fromRight ? index-- : ++index < length) {
        if (iteratee2(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }
  var createBaseEach_default = createBaseEach;

  // node_modules/lodash-es/_baseEach.js
  var baseEach = createBaseEach_default(baseForOwn_default);
  var baseEach_default = baseEach;

  // node_modules/lodash-es/_baseAggregator.js
  function baseAggregator(collection, setter, iteratee2, accumulator) {
    baseEach_default(collection, function(value, key, collection2) {
      setter(accumulator, value, iteratee2(value), collection2);
    });
    return accumulator;
  }
  var baseAggregator_default = baseAggregator;

  // node_modules/lodash-es/_createAggregator.js
  function createAggregator(setter, initializer) {
    return function(collection, iteratee2) {
      var func = isArray_default(collection) ? arrayAggregator_default : baseAggregator_default, accumulator = initializer ? initializer() : {};
      return func(collection, setter, baseIteratee_default(iteratee2, 2), accumulator);
    };
  }
  var createAggregator_default = createAggregator;

  // node_modules/lodash-es/countBy.js
  var objectProto20 = Object.prototype;
  var hasOwnProperty17 = objectProto20.hasOwnProperty;
  var countBy = createAggregator_default(function(result2, value, key) {
    if (hasOwnProperty17.call(result2, key)) {
      ++result2[key];
    } else {
      baseAssignValue_default(result2, key, 1);
    }
  });
  var countBy_default = countBy;

  // node_modules/lodash-es/create.js
  init_define_process();
  function create(prototype, properties) {
    var result2 = baseCreate_default(prototype);
    return properties == null ? result2 : baseAssign_default(result2, properties);
  }
  var create_default = create;

  // node_modules/lodash-es/curry.js
  init_define_process();
  var WRAP_CURRY_FLAG6 = 8;
  function curry(func, arity, guard) {
    arity = guard ? void 0 : arity;
    var result2 = createWrap_default(func, WRAP_CURRY_FLAG6, void 0, void 0, void 0, void 0, void 0, arity);
    result2.placeholder = curry.placeholder;
    return result2;
  }
  curry.placeholder = {};
  var curry_default = curry;

  // node_modules/lodash-es/curryRight.js
  init_define_process();
  var WRAP_CURRY_RIGHT_FLAG4 = 16;
  function curryRight(func, arity, guard) {
    arity = guard ? void 0 : arity;
    var result2 = createWrap_default(func, WRAP_CURRY_RIGHT_FLAG4, void 0, void 0, void 0, void 0, void 0, arity);
    result2.placeholder = curryRight.placeholder;
    return result2;
  }
  curryRight.placeholder = {};
  var curryRight_default = curryRight;

  // node_modules/lodash-es/debounce.js
  init_define_process();

  // node_modules/lodash-es/now.js
  init_define_process();
  var now = function() {
    return root_default.Date.now();
  };
  var now_default = now;

  // node_modules/lodash-es/debounce.js
  var FUNC_ERROR_TEXT6 = "Expected a function";
  var nativeMax6 = Math.max;
  var nativeMin4 = Math.min;
  function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT6);
    }
    wait = toNumber_default(wait) || 0;
    if (isObject_default(options)) {
      leading = !!options.leading;
      maxing = "maxWait" in options;
      maxWait = maxing ? nativeMax6(toNumber_default(options.maxWait) || 0, wait) : maxWait;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
      var args = lastArgs, thisArg = lastThis;
      lastArgs = lastThis = void 0;
      lastInvokeTime = time;
      result2 = func.apply(thisArg, args);
      return result2;
    }
    function leadingEdge(time) {
      lastInvokeTime = time;
      timerId = setTimeout(timerExpired, wait);
      return leading ? invokeFunc(time) : result2;
    }
    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
      return maxing ? nativeMin4(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
      return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
      var time = now_default();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
      timerId = void 0;
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = void 0;
      return result2;
    }
    function cancel() {
      if (timerId !== void 0) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = void 0;
    }
    function flush() {
      return timerId === void 0 ? result2 : trailingEdge(now_default());
    }
    function debounced() {
      var time = now_default(), isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;
      if (isInvoking) {
        if (timerId === void 0) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          clearTimeout(timerId);
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === void 0) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result2;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }
  var debounce_default = debounce;

  // node_modules/lodash-es/defaultTo.js
  init_define_process();
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
  var defaultTo_default = defaultTo;

  // node_modules/lodash-es/defaults.js
  init_define_process();
  var objectProto21 = Object.prototype;
  var hasOwnProperty18 = objectProto21.hasOwnProperty;
  var defaults = baseRest_default(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : void 0;
    if (guard && isIterateeCall_default(sources[0], sources[1], guard)) {
      length = 1;
    }
    while (++index < length) {
      var source = sources[index];
      var props = keysIn_default(source);
      var propsIndex = -1;
      var propsLength = props.length;
      while (++propsIndex < propsLength) {
        var key = props[propsIndex];
        var value = object[key];
        if (value === void 0 || eq_default(value, objectProto21[key]) && !hasOwnProperty18.call(object, key)) {
          object[key] = source[key];
        }
      }
    }
    return object;
  });
  var defaults_default = defaults;

  // node_modules/lodash-es/defaultsDeep.js
  init_define_process();

  // node_modules/lodash-es/_customDefaultsMerge.js
  init_define_process();

  // node_modules/lodash-es/_baseMerge.js
  init_define_process();

  // node_modules/lodash-es/_assignMergeValue.js
  init_define_process();
  function assignMergeValue(object, key, value) {
    if (value !== void 0 && !eq_default(object[key], value) || value === void 0 && !(key in object)) {
      baseAssignValue_default(object, key, value);
    }
  }
  var assignMergeValue_default = assignMergeValue;

  // node_modules/lodash-es/_baseMergeDeep.js
  init_define_process();

  // node_modules/lodash-es/isArrayLikeObject.js
  init_define_process();
  function isArrayLikeObject(value) {
    return isObjectLike_default(value) && isArrayLike_default(value);
  }
  var isArrayLikeObject_default = isArrayLikeObject;

  // node_modules/lodash-es/_safeGet.js
  init_define_process();
  function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") {
      return;
    }
    if (key == "__proto__") {
      return;
    }
    return object[key];
  }
  var safeGet_default = safeGet;

  // node_modules/lodash-es/toPlainObject.js
  init_define_process();
  function toPlainObject(value) {
    return copyObject_default(value, keysIn_default(value));
  }
  var toPlainObject_default = toPlainObject;

  // node_modules/lodash-es/_baseMergeDeep.js
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet_default(object, key), srcValue = safeGet_default(source, key), stacked = stack.get(srcValue);
    if (stacked) {
      assignMergeValue_default(object, key, stacked);
      return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
    var isCommon = newValue === void 0;
    if (isCommon) {
      var isArr = isArray_default(srcValue), isBuff = !isArr && isBuffer_default(srcValue), isTyped = !isArr && !isBuff && isTypedArray_default(srcValue);
      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray_default(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject_default(objValue)) {
          newValue = copyArray_default(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer_default(srcValue, true);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray_default(srcValue, true);
        } else {
          newValue = [];
        }
      } else if (isPlainObject_default(srcValue) || isArguments_default(srcValue)) {
        newValue = objValue;
        if (isArguments_default(objValue)) {
          newValue = toPlainObject_default(objValue);
        } else if (!isObject_default(objValue) || isFunction_default(objValue)) {
          newValue = initCloneObject_default(srcValue);
        }
      } else {
        isCommon = false;
      }
    }
    if (isCommon) {
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack["delete"](srcValue);
    }
    assignMergeValue_default(object, key, newValue);
  }
  var baseMergeDeep_default = baseMergeDeep;

  // node_modules/lodash-es/_baseMerge.js
  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }
    baseFor_default(source, function(srcValue, key) {
      stack || (stack = new Stack_default());
      if (isObject_default(srcValue)) {
        baseMergeDeep_default(object, source, key, srcIndex, baseMerge, customizer, stack);
      } else {
        var newValue = customizer ? customizer(safeGet_default(object, key), srcValue, key + "", object, source, stack) : void 0;
        if (newValue === void 0) {
          newValue = srcValue;
        }
        assignMergeValue_default(object, key, newValue);
      }
    }, keysIn_default);
  }
  var baseMerge_default = baseMerge;

  // node_modules/lodash-es/_customDefaultsMerge.js
  function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if (isObject_default(objValue) && isObject_default(srcValue)) {
      stack.set(srcValue, objValue);
      baseMerge_default(objValue, srcValue, void 0, customDefaultsMerge, stack);
      stack["delete"](srcValue);
    }
    return objValue;
  }
  var customDefaultsMerge_default = customDefaultsMerge;

  // node_modules/lodash-es/mergeWith.js
  init_define_process();
  var mergeWith = createAssigner_default(function(object, source, srcIndex, customizer) {
    baseMerge_default(object, source, srcIndex, customizer);
  });
  var mergeWith_default = mergeWith;

  // node_modules/lodash-es/defaultsDeep.js
  var defaultsDeep = baseRest_default(function(args) {
    args.push(void 0, customDefaultsMerge_default);
    return apply_default(mergeWith_default, void 0, args);
  });
  var defaultsDeep_default = defaultsDeep;

  // node_modules/lodash-es/defer.js
  init_define_process();

  // node_modules/lodash-es/_baseDelay.js
  init_define_process();
  var FUNC_ERROR_TEXT7 = "Expected a function";
  function baseDelay(func, wait, args) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT7);
    }
    return setTimeout(function() {
      func.apply(void 0, args);
    }, wait);
  }
  var baseDelay_default = baseDelay;

  // node_modules/lodash-es/defer.js
  var defer = baseRest_default(function(func, args) {
    return baseDelay_default(func, 1, args);
  });
  var defer_default = defer;

  // node_modules/lodash-es/delay.js
  init_define_process();
  var delay = baseRest_default(function(func, wait, args) {
    return baseDelay_default(func, toNumber_default(wait) || 0, args);
  });
  var delay_default = delay;

  // node_modules/lodash-es/difference.js
  init_define_process();

  // node_modules/lodash-es/_baseDifference.js
  init_define_process();

  // node_modules/lodash-es/_arrayIncludesWith.js
  init_define_process();
  function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }
  var arrayIncludesWith_default = arrayIncludesWith;

  // node_modules/lodash-es/_baseDifference.js
  var LARGE_ARRAY_SIZE2 = 200;
  function baseDifference(array, values2, iteratee2, comparator) {
    var index = -1, includes2 = arrayIncludes_default, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
    if (!length) {
      return result2;
    }
    if (iteratee2) {
      values2 = arrayMap_default(values2, baseUnary_default(iteratee2));
    }
    if (comparator) {
      includes2 = arrayIncludesWith_default;
      isCommon = false;
    } else if (values2.length >= LARGE_ARRAY_SIZE2) {
      includes2 = cacheHas_default;
      isCommon = false;
      values2 = new SetCache_default(values2);
    }
    outer:
      while (++index < length) {
        var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values2[valuesIndex] === computed) {
              continue outer;
            }
          }
          result2.push(value);
        } else if (!includes2(values2, computed, comparator)) {
          result2.push(value);
        }
      }
    return result2;
  }
  var baseDifference_default = baseDifference;

  // node_modules/lodash-es/difference.js
  var difference = baseRest_default(function(array, values2) {
    return isArrayLikeObject_default(array) ? baseDifference_default(array, baseFlatten_default(values2, 1, isArrayLikeObject_default, true)) : [];
  });
  var difference_default = difference;

  // node_modules/lodash-es/differenceBy.js
  init_define_process();

  // node_modules/lodash-es/last.js
  init_define_process();
  function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
  }
  var last_default = last;

  // node_modules/lodash-es/differenceBy.js
  var differenceBy = baseRest_default(function(array, values2) {
    var iteratee2 = last_default(values2);
    if (isArrayLikeObject_default(iteratee2)) {
      iteratee2 = void 0;
    }
    return isArrayLikeObject_default(array) ? baseDifference_default(array, baseFlatten_default(values2, 1, isArrayLikeObject_default, true), baseIteratee_default(iteratee2, 2)) : [];
  });
  var differenceBy_default = differenceBy;

  // node_modules/lodash-es/differenceWith.js
  init_define_process();
  var differenceWith = baseRest_default(function(array, values2) {
    var comparator = last_default(values2);
    if (isArrayLikeObject_default(comparator)) {
      comparator = void 0;
    }
    return isArrayLikeObject_default(array) ? baseDifference_default(array, baseFlatten_default(values2, 1, isArrayLikeObject_default, true), void 0, comparator) : [];
  });
  var differenceWith_default = differenceWith;

  // node_modules/lodash-es/divide.js
  init_define_process();
  var divide = createMathOperation_default(function(dividend, divisor) {
    return dividend / divisor;
  }, 1);
  var divide_default = divide;

  // node_modules/lodash-es/drop.js
  init_define_process();
  function drop(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    return baseSlice_default(array, n < 0 ? 0 : n, length);
  }
  var drop_default = drop;

  // node_modules/lodash-es/dropRight.js
  init_define_process();
  function dropRight(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    n = length - n;
    return baseSlice_default(array, 0, n < 0 ? 0 : n);
  }
  var dropRight_default = dropRight;

  // node_modules/lodash-es/dropRightWhile.js
  init_define_process();

  // node_modules/lodash-es/_baseWhile.js
  init_define_process();
  function baseWhile(array, predicate, isDrop, fromRight) {
    var length = array.length, index = fromRight ? length : -1;
    while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
    }
    return isDrop ? baseSlice_default(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice_default(array, fromRight ? index + 1 : 0, fromRight ? length : index);
  }
  var baseWhile_default = baseWhile;

  // node_modules/lodash-es/dropRightWhile.js
  function dropRightWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3), true, true) : [];
  }
  var dropRightWhile_default = dropRightWhile;

  // node_modules/lodash-es/dropWhile.js
  init_define_process();
  function dropWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3), true) : [];
  }
  var dropWhile_default = dropWhile;

  // node_modules/lodash-es/each.js
  init_define_process();

  // node_modules/lodash-es/forEach.js
  init_define_process();

  // node_modules/lodash-es/_castFunction.js
  init_define_process();
  function castFunction(value) {
    return typeof value == "function" ? value : identity_default;
  }
  var castFunction_default = castFunction;

  // node_modules/lodash-es/forEach.js
  function forEach(collection, iteratee2) {
    var func = isArray_default(collection) ? arrayEach_default : baseEach_default;
    return func(collection, castFunction_default(iteratee2));
  }
  var forEach_default = forEach;

  // node_modules/lodash-es/eachRight.js
  init_define_process();

  // node_modules/lodash-es/forEachRight.js
  init_define_process();

  // node_modules/lodash-es/_arrayEachRight.js
  init_define_process();
  function arrayEachRight(array, iteratee2) {
    var length = array == null ? 0 : array.length;
    while (length--) {
      if (iteratee2(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }
  var arrayEachRight_default = arrayEachRight;

  // node_modules/lodash-es/_baseEachRight.js
  init_define_process();

  // node_modules/lodash-es/_baseForOwnRight.js
  init_define_process();

  // node_modules/lodash-es/_baseForRight.js
  init_define_process();
  var baseForRight = createBaseFor_default(true);
  var baseForRight_default = baseForRight;

  // node_modules/lodash-es/_baseForOwnRight.js
  function baseForOwnRight(object, iteratee2) {
    return object && baseForRight_default(object, iteratee2, keys_default);
  }
  var baseForOwnRight_default = baseForOwnRight;

  // node_modules/lodash-es/_baseEachRight.js
  var baseEachRight = createBaseEach_default(baseForOwnRight_default, true);
  var baseEachRight_default = baseEachRight;

  // node_modules/lodash-es/forEachRight.js
  function forEachRight(collection, iteratee2) {
    var func = isArray_default(collection) ? arrayEachRight_default : baseEachRight_default;
    return func(collection, castFunction_default(iteratee2));
  }
  var forEachRight_default = forEachRight;

  // node_modules/lodash-es/endsWith.js
  init_define_process();
  function endsWith(string, target, position) {
    string = toString_default(string);
    target = baseToString_default(target);
    var length = string.length;
    position = position === void 0 ? length : baseClamp_default(toInteger_default(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
  }
  var endsWith_default = endsWith;

  // node_modules/lodash-es/entries.js
  init_define_process();

  // node_modules/lodash-es/toPairs.js
  init_define_process();

  // node_modules/lodash-es/_createToPairs.js
  init_define_process();

  // node_modules/lodash-es/_baseToPairs.js
  init_define_process();
  function baseToPairs(object, props) {
    return arrayMap_default(props, function(key) {
      return [key, object[key]];
    });
  }
  var baseToPairs_default = baseToPairs;

  // node_modules/lodash-es/_setToPairs.js
  init_define_process();
  function setToPairs(set2) {
    var index = -1, result2 = Array(set2.size);
    set2.forEach(function(value) {
      result2[++index] = [value, value];
    });
    return result2;
  }
  var setToPairs_default = setToPairs;

  // node_modules/lodash-es/_createToPairs.js
  var mapTag7 = "[object Map]";
  var setTag7 = "[object Set]";
  function createToPairs(keysFunc) {
    return function(object) {
      var tag = getTag_default(object);
      if (tag == mapTag7) {
        return mapToArray_default(object);
      }
      if (tag == setTag7) {
        return setToPairs_default(object);
      }
      return baseToPairs_default(object, keysFunc(object));
    };
  }
  var createToPairs_default = createToPairs;

  // node_modules/lodash-es/toPairs.js
  var toPairs = createToPairs_default(keys_default);
  var toPairs_default = toPairs;

  // node_modules/lodash-es/entriesIn.js
  init_define_process();

  // node_modules/lodash-es/toPairsIn.js
  init_define_process();
  var toPairsIn = createToPairs_default(keysIn_default);
  var toPairsIn_default = toPairsIn;

  // node_modules/lodash-es/escape.js
  init_define_process();

  // node_modules/lodash-es/_escapeHtmlChar.js
  init_define_process();
  var htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  };
  var escapeHtmlChar = basePropertyOf_default(htmlEscapes);
  var escapeHtmlChar_default = escapeHtmlChar;

  // node_modules/lodash-es/escape.js
  var reUnescapedHtml = /[&<>"']/g;
  var reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
  function escape(string) {
    string = toString_default(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar_default) : string;
  }
  var escape_default = escape;

  // node_modules/lodash-es/escapeRegExp.js
  init_define_process();
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reHasRegExpChar = RegExp(reRegExpChar2.source);
  function escapeRegExp(string) {
    string = toString_default(string);
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar2, "\\$&") : string;
  }
  var escapeRegExp_default = escapeRegExp;

  // node_modules/lodash-es/every.js
  init_define_process();

  // node_modules/lodash-es/_arrayEvery.js
  init_define_process();
  function arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }
  var arrayEvery_default = arrayEvery;

  // node_modules/lodash-es/_baseEvery.js
  init_define_process();
  function baseEvery(collection, predicate) {
    var result2 = true;
    baseEach_default(collection, function(value, index, collection2) {
      result2 = !!predicate(value, index, collection2);
      return result2;
    });
    return result2;
  }
  var baseEvery_default = baseEvery;

  // node_modules/lodash-es/every.js
  function every(collection, predicate, guard) {
    var func = isArray_default(collection) ? arrayEvery_default : baseEvery_default;
    if (guard && isIterateeCall_default(collection, predicate, guard)) {
      predicate = void 0;
    }
    return func(collection, baseIteratee_default(predicate, 3));
  }
  var every_default = every;

  // node_modules/lodash-es/extend.js
  init_define_process();

  // node_modules/lodash-es/extendWith.js
  init_define_process();

  // node_modules/lodash-es/fill.js
  init_define_process();

  // node_modules/lodash-es/_baseFill.js
  init_define_process();

  // node_modules/lodash-es/toLength.js
  init_define_process();
  var MAX_ARRAY_LENGTH2 = 4294967295;
  function toLength(value) {
    return value ? baseClamp_default(toInteger_default(value), 0, MAX_ARRAY_LENGTH2) : 0;
  }
  var toLength_default = toLength;

  // node_modules/lodash-es/_baseFill.js
  function baseFill(array, value, start, end) {
    var length = array.length;
    start = toInteger_default(start);
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end === void 0 || end > length ? length : toInteger_default(end);
    if (end < 0) {
      end += length;
    }
    end = start > end ? 0 : toLength_default(end);
    while (start < end) {
      array[start++] = value;
    }
    return array;
  }
  var baseFill_default = baseFill;

  // node_modules/lodash-es/fill.js
  function fill(array, value, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    if (start && typeof start != "number" && isIterateeCall_default(array, value, start)) {
      start = 0;
      end = length;
    }
    return baseFill_default(array, value, start, end);
  }
  var fill_default = fill;

  // node_modules/lodash-es/filter.js
  init_define_process();

  // node_modules/lodash-es/_baseFilter.js
  init_define_process();
  function baseFilter(collection, predicate) {
    var result2 = [];
    baseEach_default(collection, function(value, index, collection2) {
      if (predicate(value, index, collection2)) {
        result2.push(value);
      }
    });
    return result2;
  }
  var baseFilter_default = baseFilter;

  // node_modules/lodash-es/filter.js
  function filter(collection, predicate) {
    var func = isArray_default(collection) ? arrayFilter_default : baseFilter_default;
    return func(collection, baseIteratee_default(predicate, 3));
  }
  var filter_default = filter;

  // node_modules/lodash-es/find.js
  init_define_process();

  // node_modules/lodash-es/_createFind.js
  init_define_process();
  function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
      var iterable = Object(collection);
      if (!isArrayLike_default(collection)) {
        var iteratee2 = baseIteratee_default(predicate, 3);
        collection = keys_default(collection);
        predicate = function(key) {
          return iteratee2(iterable[key], key, iterable);
        };
      }
      var index = findIndexFunc(collection, predicate, fromIndex);
      return index > -1 ? iterable[iteratee2 ? collection[index] : index] : void 0;
    };
  }
  var createFind_default = createFind;

  // node_modules/lodash-es/findIndex.js
  init_define_process();
  var nativeMax7 = Math.max;
  function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = fromIndex == null ? 0 : toInteger_default(fromIndex);
    if (index < 0) {
      index = nativeMax7(length + index, 0);
    }
    return baseFindIndex_default(array, baseIteratee_default(predicate, 3), index);
  }
  var findIndex_default = findIndex;

  // node_modules/lodash-es/find.js
  var find = createFind_default(findIndex_default);
  var find_default = find;

  // node_modules/lodash-es/findKey.js
  init_define_process();

  // node_modules/lodash-es/_baseFindKey.js
  init_define_process();
  function baseFindKey(collection, predicate, eachFunc) {
    var result2;
    eachFunc(collection, function(value, key, collection2) {
      if (predicate(value, key, collection2)) {
        result2 = key;
        return false;
      }
    });
    return result2;
  }
  var baseFindKey_default = baseFindKey;

  // node_modules/lodash-es/findKey.js
  function findKey(object, predicate) {
    return baseFindKey_default(object, baseIteratee_default(predicate, 3), baseForOwn_default);
  }
  var findKey_default = findKey;

  // node_modules/lodash-es/findLast.js
  init_define_process();

  // node_modules/lodash-es/findLastIndex.js
  init_define_process();
  var nativeMax8 = Math.max;
  var nativeMin5 = Math.min;
  function findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = length - 1;
    if (fromIndex !== void 0) {
      index = toInteger_default(fromIndex);
      index = fromIndex < 0 ? nativeMax8(length + index, 0) : nativeMin5(index, length - 1);
    }
    return baseFindIndex_default(array, baseIteratee_default(predicate, 3), index, true);
  }
  var findLastIndex_default = findLastIndex;

  // node_modules/lodash-es/findLast.js
  var findLast = createFind_default(findLastIndex_default);
  var findLast_default = findLast;

  // node_modules/lodash-es/findLastKey.js
  init_define_process();
  function findLastKey(object, predicate) {
    return baseFindKey_default(object, baseIteratee_default(predicate, 3), baseForOwnRight_default);
  }
  var findLastKey_default = findLastKey;

  // node_modules/lodash-es/first.js
  init_define_process();

  // node_modules/lodash-es/head.js
  init_define_process();
  function head(array) {
    return array && array.length ? array[0] : void 0;
  }
  var head_default = head;

  // node_modules/lodash-es/flatMap.js
  init_define_process();

  // node_modules/lodash-es/map.js
  init_define_process();

  // node_modules/lodash-es/_baseMap.js
  init_define_process();
  function baseMap(collection, iteratee2) {
    var index = -1, result2 = isArrayLike_default(collection) ? Array(collection.length) : [];
    baseEach_default(collection, function(value, key, collection2) {
      result2[++index] = iteratee2(value, key, collection2);
    });
    return result2;
  }
  var baseMap_default = baseMap;

  // node_modules/lodash-es/map.js
  function map(collection, iteratee2) {
    var func = isArray_default(collection) ? arrayMap_default : baseMap_default;
    return func(collection, baseIteratee_default(iteratee2, 3));
  }
  var map_default = map;

  // node_modules/lodash-es/flatMap.js
  function flatMap(collection, iteratee2) {
    return baseFlatten_default(map_default(collection, iteratee2), 1);
  }
  var flatMap_default = flatMap;

  // node_modules/lodash-es/flatMapDeep.js
  init_define_process();
  var INFINITY4 = 1 / 0;
  function flatMapDeep(collection, iteratee2) {
    return baseFlatten_default(map_default(collection, iteratee2), INFINITY4);
  }
  var flatMapDeep_default = flatMapDeep;

  // node_modules/lodash-es/flatMapDepth.js
  init_define_process();
  function flatMapDepth(collection, iteratee2, depth) {
    depth = depth === void 0 ? 1 : toInteger_default(depth);
    return baseFlatten_default(map_default(collection, iteratee2), depth);
  }
  var flatMapDepth_default = flatMapDepth;

  // node_modules/lodash-es/flattenDeep.js
  init_define_process();
  var INFINITY5 = 1 / 0;
  function flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten_default(array, INFINITY5) : [];
  }
  var flattenDeep_default = flattenDeep;

  // node_modules/lodash-es/flattenDepth.js
  init_define_process();
  function flattenDepth(array, depth) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    depth = depth === void 0 ? 1 : toInteger_default(depth);
    return baseFlatten_default(array, depth);
  }
  var flattenDepth_default = flattenDepth;

  // node_modules/lodash-es/flip.js
  init_define_process();
  var WRAP_FLIP_FLAG3 = 512;
  function flip(func) {
    return createWrap_default(func, WRAP_FLIP_FLAG3);
  }
  var flip_default = flip;

  // node_modules/lodash-es/floor.js
  init_define_process();
  var floor = createRound_default("floor");
  var floor_default = floor;

  // node_modules/lodash-es/flow.js
  init_define_process();

  // node_modules/lodash-es/_createFlow.js
  init_define_process();
  var FUNC_ERROR_TEXT8 = "Expected a function";
  var WRAP_CURRY_FLAG7 = 8;
  var WRAP_PARTIAL_FLAG6 = 32;
  var WRAP_ARY_FLAG5 = 128;
  var WRAP_REARG_FLAG3 = 256;
  function createFlow(fromRight) {
    return flatRest_default(function(funcs) {
      var length = funcs.length, index = length, prereq = LodashWrapper_default.prototype.thru;
      if (fromRight) {
        funcs.reverse();
      }
      while (index--) {
        var func = funcs[index];
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT8);
        }
        if (prereq && !wrapper && getFuncName_default(func) == "wrapper") {
          var wrapper = new LodashWrapper_default([], true);
        }
      }
      index = wrapper ? index : length;
      while (++index < length) {
        func = funcs[index];
        var funcName = getFuncName_default(func), data = funcName == "wrapper" ? getData_default(func) : void 0;
        if (data && isLaziable_default(data[0]) && data[1] == (WRAP_ARY_FLAG5 | WRAP_CURRY_FLAG7 | WRAP_PARTIAL_FLAG6 | WRAP_REARG_FLAG3) && !data[4].length && data[9] == 1) {
          wrapper = wrapper[getFuncName_default(data[0])].apply(wrapper, data[3]);
        } else {
          wrapper = func.length == 1 && isLaziable_default(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
      }
      return function() {
        var args = arguments, value = args[0];
        if (wrapper && args.length == 1 && isArray_default(value)) {
          return wrapper.plant(value).value();
        }
        var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
        while (++index2 < length) {
          result2 = funcs[index2].call(this, result2);
        }
        return result2;
      };
    });
  }
  var createFlow_default = createFlow;

  // node_modules/lodash-es/flow.js
  var flow = createFlow_default();
  var flow_default = flow;

  // node_modules/lodash-es/flowRight.js
  init_define_process();
  var flowRight = createFlow_default(true);
  var flowRight_default = flowRight;

  // node_modules/lodash-es/forIn.js
  init_define_process();
  function forIn(object, iteratee2) {
    return object == null ? object : baseFor_default(object, castFunction_default(iteratee2), keysIn_default);
  }
  var forIn_default = forIn;

  // node_modules/lodash-es/forInRight.js
  init_define_process();
  function forInRight(object, iteratee2) {
    return object == null ? object : baseForRight_default(object, castFunction_default(iteratee2), keysIn_default);
  }
  var forInRight_default = forInRight;

  // node_modules/lodash-es/forOwn.js
  init_define_process();
  function forOwn(object, iteratee2) {
    return object && baseForOwn_default(object, castFunction_default(iteratee2));
  }
  var forOwn_default = forOwn;

  // node_modules/lodash-es/forOwnRight.js
  init_define_process();
  function forOwnRight(object, iteratee2) {
    return object && baseForOwnRight_default(object, castFunction_default(iteratee2));
  }
  var forOwnRight_default = forOwnRight;

  // node_modules/lodash-es/fromPairs.js
  init_define_process();
  function fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
    while (++index < length) {
      var pair = pairs[index];
      result2[pair[0]] = pair[1];
    }
    return result2;
  }
  var fromPairs_default = fromPairs;

  // node_modules/lodash-es/functions.js
  init_define_process();

  // node_modules/lodash-es/_baseFunctions.js
  init_define_process();
  function baseFunctions(object, props) {
    return arrayFilter_default(props, function(key) {
      return isFunction_default(object[key]);
    });
  }
  var baseFunctions_default = baseFunctions;

  // node_modules/lodash-es/functions.js
  function functions(object) {
    return object == null ? [] : baseFunctions_default(object, keys_default(object));
  }
  var functions_default = functions;

  // node_modules/lodash-es/functionsIn.js
  init_define_process();
  function functionsIn(object) {
    return object == null ? [] : baseFunctions_default(object, keysIn_default(object));
  }
  var functionsIn_default = functionsIn;

  // node_modules/lodash-es/groupBy.js
  init_define_process();
  var objectProto22 = Object.prototype;
  var hasOwnProperty19 = objectProto22.hasOwnProperty;
  var groupBy = createAggregator_default(function(result2, value, key) {
    if (hasOwnProperty19.call(result2, key)) {
      result2[key].push(value);
    } else {
      baseAssignValue_default(result2, key, [value]);
    }
  });
  var groupBy_default = groupBy;

  // node_modules/lodash-es/gt.js
  init_define_process();

  // node_modules/lodash-es/_baseGt.js
  init_define_process();
  function baseGt(value, other) {
    return value > other;
  }
  var baseGt_default = baseGt;

  // node_modules/lodash-es/_createRelationalOperation.js
  init_define_process();
  function createRelationalOperation(operator) {
    return function(value, other) {
      if (!(typeof value == "string" && typeof other == "string")) {
        value = toNumber_default(value);
        other = toNumber_default(other);
      }
      return operator(value, other);
    };
  }
  var createRelationalOperation_default = createRelationalOperation;

  // node_modules/lodash-es/gt.js
  var gt = createRelationalOperation_default(baseGt_default);
  var gt_default = gt;

  // node_modules/lodash-es/gte.js
  init_define_process();
  var gte = createRelationalOperation_default(function(value, other) {
    return value >= other;
  });
  var gte_default = gte;

  // node_modules/lodash-es/has.js
  init_define_process();

  // node_modules/lodash-es/_baseHas.js
  init_define_process();
  var objectProto23 = Object.prototype;
  var hasOwnProperty20 = objectProto23.hasOwnProperty;
  function baseHas(object, key) {
    return object != null && hasOwnProperty20.call(object, key);
  }
  var baseHas_default = baseHas;

  // node_modules/lodash-es/has.js
  function has(object, path) {
    return object != null && hasPath_default(object, path, baseHas_default);
  }
  var has_default = has;

  // node_modules/lodash-es/inRange.js
  init_define_process();

  // node_modules/lodash-es/_baseInRange.js
  init_define_process();
  var nativeMax9 = Math.max;
  var nativeMin6 = Math.min;
  function baseInRange(number, start, end) {
    return number >= nativeMin6(start, end) && number < nativeMax9(start, end);
  }
  var baseInRange_default = baseInRange;

  // node_modules/lodash-es/inRange.js
  function inRange(number, start, end) {
    start = toFinite_default(start);
    if (end === void 0) {
      end = start;
      start = 0;
    } else {
      end = toFinite_default(end);
    }
    number = toNumber_default(number);
    return baseInRange_default(number, start, end);
  }
  var inRange_default = inRange;

  // node_modules/lodash-es/includes.js
  init_define_process();

  // node_modules/lodash-es/isString.js
  init_define_process();
  var stringTag5 = "[object String]";
  function isString(value) {
    return typeof value == "string" || !isArray_default(value) && isObjectLike_default(value) && baseGetTag_default(value) == stringTag5;
  }
  var isString_default = isString;

  // node_modules/lodash-es/values.js
  init_define_process();

  // node_modules/lodash-es/_baseValues.js
  init_define_process();
  function baseValues(object, props) {
    return arrayMap_default(props, function(key) {
      return object[key];
    });
  }
  var baseValues_default = baseValues;

  // node_modules/lodash-es/values.js
  function values(object) {
    return object == null ? [] : baseValues_default(object, keys_default(object));
  }
  var values_default = values;

  // node_modules/lodash-es/includes.js
  var nativeMax10 = Math.max;
  function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike_default(collection) ? collection : values_default(collection);
    fromIndex = fromIndex && !guard ? toInteger_default(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) {
      fromIndex = nativeMax10(length + fromIndex, 0);
    }
    return isString_default(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf_default(collection, value, fromIndex) > -1;
  }
  var includes_default = includes;

  // node_modules/lodash-es/indexOf.js
  init_define_process();
  var nativeMax11 = Math.max;
  function indexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = fromIndex == null ? 0 : toInteger_default(fromIndex);
    if (index < 0) {
      index = nativeMax11(length + index, 0);
    }
    return baseIndexOf_default(array, value, index);
  }
  var indexOf_default = indexOf;

  // node_modules/lodash-es/initial.js
  init_define_process();
  function initial(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseSlice_default(array, 0, -1) : [];
  }
  var initial_default = initial;

  // node_modules/lodash-es/intersection.js
  init_define_process();

  // node_modules/lodash-es/_baseIntersection.js
  init_define_process();
  var nativeMin7 = Math.min;
  function baseIntersection(arrays, iteratee2, comparator) {
    var includes2 = comparator ? arrayIncludesWith_default : arrayIncludes_default, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result2 = [];
    while (othIndex--) {
      var array = arrays[othIndex];
      if (othIndex && iteratee2) {
        array = arrayMap_default(array, baseUnary_default(iteratee2));
      }
      maxLength = nativeMin7(array.length, maxLength);
      caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache_default(othIndex && array) : void 0;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer:
      while (++index < length && result2.length < maxLength) {
        var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? cacheHas_default(seen, computed) : includes2(result2, computed, comparator))) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache ? cacheHas_default(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result2.push(value);
        }
      }
    return result2;
  }
  var baseIntersection_default = baseIntersection;

  // node_modules/lodash-es/_castArrayLikeObject.js
  init_define_process();
  function castArrayLikeObject(value) {
    return isArrayLikeObject_default(value) ? value : [];
  }
  var castArrayLikeObject_default = castArrayLikeObject;

  // node_modules/lodash-es/intersection.js
  var intersection = baseRest_default(function(arrays) {
    var mapped = arrayMap_default(arrays, castArrayLikeObject_default);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection_default(mapped) : [];
  });
  var intersection_default = intersection;

  // node_modules/lodash-es/intersectionBy.js
  init_define_process();
  var intersectionBy = baseRest_default(function(arrays) {
    var iteratee2 = last_default(arrays), mapped = arrayMap_default(arrays, castArrayLikeObject_default);
    if (iteratee2 === last_default(mapped)) {
      iteratee2 = void 0;
    } else {
      mapped.pop();
    }
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection_default(mapped, baseIteratee_default(iteratee2, 2)) : [];
  });
  var intersectionBy_default = intersectionBy;

  // node_modules/lodash-es/intersectionWith.js
  init_define_process();
  var intersectionWith = baseRest_default(function(arrays) {
    var comparator = last_default(arrays), mapped = arrayMap_default(arrays, castArrayLikeObject_default);
    comparator = typeof comparator == "function" ? comparator : void 0;
    if (comparator) {
      mapped.pop();
    }
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection_default(mapped, void 0, comparator) : [];
  });
  var intersectionWith_default = intersectionWith;

  // node_modules/lodash-es/invert.js
  init_define_process();

  // node_modules/lodash-es/_createInverter.js
  init_define_process();

  // node_modules/lodash-es/_baseInverter.js
  init_define_process();
  function baseInverter(object, setter, iteratee2, accumulator) {
    baseForOwn_default(object, function(value, key, object2) {
      setter(accumulator, iteratee2(value), key, object2);
    });
    return accumulator;
  }
  var baseInverter_default = baseInverter;

  // node_modules/lodash-es/_createInverter.js
  function createInverter(setter, toIteratee) {
    return function(object, iteratee2) {
      return baseInverter_default(object, setter, toIteratee(iteratee2), {});
    };
  }
  var createInverter_default = createInverter;

  // node_modules/lodash-es/invert.js
  var objectProto24 = Object.prototype;
  var nativeObjectToString3 = objectProto24.toString;
  var invert = createInverter_default(function(result2, value, key) {
    if (value != null && typeof value.toString != "function") {
      value = nativeObjectToString3.call(value);
    }
    result2[value] = key;
  }, constant_default(identity_default));
  var invert_default = invert;

  // node_modules/lodash-es/invertBy.js
  init_define_process();
  var objectProto25 = Object.prototype;
  var hasOwnProperty21 = objectProto25.hasOwnProperty;
  var nativeObjectToString4 = objectProto25.toString;
  var invertBy = createInverter_default(function(result2, value, key) {
    if (value != null && typeof value.toString != "function") {
      value = nativeObjectToString4.call(value);
    }
    if (hasOwnProperty21.call(result2, value)) {
      result2[value].push(key);
    } else {
      result2[value] = [key];
    }
  }, baseIteratee_default);
  var invertBy_default = invertBy;

  // node_modules/lodash-es/invoke.js
  init_define_process();

  // node_modules/lodash-es/_baseInvoke.js
  init_define_process();

  // node_modules/lodash-es/_parent.js
  init_define_process();
  function parent(object, path) {
    return path.length < 2 ? object : baseGet_default(object, baseSlice_default(path, 0, -1));
  }
  var parent_default = parent;

  // node_modules/lodash-es/_baseInvoke.js
  function baseInvoke(object, path, args) {
    path = castPath_default(path, object);
    object = parent_default(object, path);
    var func = object == null ? object : object[toKey_default(last_default(path))];
    return func == null ? void 0 : apply_default(func, object, args);
  }
  var baseInvoke_default = baseInvoke;

  // node_modules/lodash-es/invoke.js
  var invoke = baseRest_default(baseInvoke_default);
  var invoke_default = invoke;

  // node_modules/lodash-es/invokeMap.js
  init_define_process();
  var invokeMap = baseRest_default(function(collection, path, args) {
    var index = -1, isFunc = typeof path == "function", result2 = isArrayLike_default(collection) ? Array(collection.length) : [];
    baseEach_default(collection, function(value) {
      result2[++index] = isFunc ? apply_default(path, value, args) : baseInvoke_default(value, path, args);
    });
    return result2;
  });
  var invokeMap_default = invokeMap;

  // node_modules/lodash-es/isArrayBuffer.js
  init_define_process();

  // node_modules/lodash-es/_baseIsArrayBuffer.js
  init_define_process();
  var arrayBufferTag5 = "[object ArrayBuffer]";
  function baseIsArrayBuffer(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == arrayBufferTag5;
  }
  var baseIsArrayBuffer_default = baseIsArrayBuffer;

  // node_modules/lodash-es/isArrayBuffer.js
  var nodeIsArrayBuffer = nodeUtil_default && nodeUtil_default.isArrayBuffer;
  var isArrayBuffer = nodeIsArrayBuffer ? baseUnary_default(nodeIsArrayBuffer) : baseIsArrayBuffer_default;
  var isArrayBuffer_default = isArrayBuffer;

  // node_modules/lodash-es/isBoolean.js
  init_define_process();
  var boolTag5 = "[object Boolean]";
  function isBoolean(value) {
    return value === true || value === false || isObjectLike_default(value) && baseGetTag_default(value) == boolTag5;
  }
  var isBoolean_default = isBoolean;

  // node_modules/lodash-es/isDate.js
  init_define_process();

  // node_modules/lodash-es/_baseIsDate.js
  init_define_process();
  var dateTag5 = "[object Date]";
  function baseIsDate(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == dateTag5;
  }
  var baseIsDate_default = baseIsDate;

  // node_modules/lodash-es/isDate.js
  var nodeIsDate = nodeUtil_default && nodeUtil_default.isDate;
  var isDate = nodeIsDate ? baseUnary_default(nodeIsDate) : baseIsDate_default;
  var isDate_default = isDate;

  // node_modules/lodash-es/isElement.js
  init_define_process();
  function isElement(value) {
    return isObjectLike_default(value) && value.nodeType === 1 && !isPlainObject_default(value);
  }
  var isElement_default = isElement;

  // node_modules/lodash-es/isEmpty.js
  init_define_process();
  var mapTag8 = "[object Map]";
  var setTag8 = "[object Set]";
  var objectProto26 = Object.prototype;
  var hasOwnProperty22 = objectProto26.hasOwnProperty;
  function isEmpty(value) {
    if (value == null) {
      return true;
    }
    if (isArrayLike_default(value) && (isArray_default(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer_default(value) || isTypedArray_default(value) || isArguments_default(value))) {
      return !value.length;
    }
    var tag = getTag_default(value);
    if (tag == mapTag8 || tag == setTag8) {
      return !value.size;
    }
    if (isPrototype_default(value)) {
      return !baseKeys_default(value).length;
    }
    for (var key in value) {
      if (hasOwnProperty22.call(value, key)) {
        return false;
      }
    }
    return true;
  }
  var isEmpty_default = isEmpty;

  // node_modules/lodash-es/isEqual.js
  init_define_process();
  function isEqual(value, other) {
    return baseIsEqual_default(value, other);
  }
  var isEqual_default = isEqual;

  // node_modules/lodash-es/isEqualWith.js
  init_define_process();
  function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    var result2 = customizer ? customizer(value, other) : void 0;
    return result2 === void 0 ? baseIsEqual_default(value, other, void 0, customizer) : !!result2;
  }
  var isEqualWith_default = isEqualWith;

  // node_modules/lodash-es/isFinite.js
  init_define_process();
  var nativeIsFinite2 = root_default.isFinite;
  function isFinite2(value) {
    return typeof value == "number" && nativeIsFinite2(value);
  }
  var isFinite_default = isFinite2;

  // node_modules/lodash-es/isInteger.js
  init_define_process();
  function isInteger(value) {
    return typeof value == "number" && value == toInteger_default(value);
  }
  var isInteger_default = isInteger;

  // node_modules/lodash-es/isMatch.js
  init_define_process();
  function isMatch(object, source) {
    return object === source || baseIsMatch_default(object, source, getMatchData_default(source));
  }
  var isMatch_default = isMatch;

  // node_modules/lodash-es/isMatchWith.js
  init_define_process();
  function isMatchWith(object, source, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return baseIsMatch_default(object, source, getMatchData_default(source), customizer);
  }
  var isMatchWith_default = isMatchWith;

  // node_modules/lodash-es/isNaN.js
  init_define_process();

  // node_modules/lodash-es/isNumber.js
  init_define_process();
  var numberTag5 = "[object Number]";
  function isNumber(value) {
    return typeof value == "number" || isObjectLike_default(value) && baseGetTag_default(value) == numberTag5;
  }
  var isNumber_default = isNumber;

  // node_modules/lodash-es/isNaN.js
  function isNaN2(value) {
    return isNumber_default(value) && value != +value;
  }
  var isNaN_default = isNaN2;

  // node_modules/lodash-es/isNative.js
  init_define_process();

  // node_modules/lodash-es/_isMaskable.js
  init_define_process();
  var isMaskable = coreJsData_default ? isFunction_default : stubFalse_default;
  var isMaskable_default = isMaskable;

  // node_modules/lodash-es/isNative.js
  var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.";
  function isNative(value) {
    if (isMaskable_default(value)) {
      throw new Error(CORE_ERROR_TEXT);
    }
    return baseIsNative_default(value);
  }
  var isNative_default = isNative;

  // node_modules/lodash-es/isNil.js
  init_define_process();
  function isNil(value) {
    return value == null;
  }
  var isNil_default = isNil;

  // node_modules/lodash-es/isNull.js
  init_define_process();
  function isNull(value) {
    return value === null;
  }
  var isNull_default = isNull;

  // node_modules/lodash-es/isRegExp.js
  init_define_process();

  // node_modules/lodash-es/_baseIsRegExp.js
  init_define_process();
  var regexpTag5 = "[object RegExp]";
  function baseIsRegExp(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == regexpTag5;
  }
  var baseIsRegExp_default = baseIsRegExp;

  // node_modules/lodash-es/isRegExp.js
  var nodeIsRegExp = nodeUtil_default && nodeUtil_default.isRegExp;
  var isRegExp = nodeIsRegExp ? baseUnary_default(nodeIsRegExp) : baseIsRegExp_default;
  var isRegExp_default = isRegExp;

  // node_modules/lodash-es/isSafeInteger.js
  init_define_process();
  var MAX_SAFE_INTEGER3 = 9007199254740991;
  function isSafeInteger(value) {
    return isInteger_default(value) && value >= -MAX_SAFE_INTEGER3 && value <= MAX_SAFE_INTEGER3;
  }
  var isSafeInteger_default = isSafeInteger;

  // node_modules/lodash-es/isUndefined.js
  init_define_process();
  function isUndefined(value) {
    return value === void 0;
  }
  var isUndefined_default = isUndefined;

  // node_modules/lodash-es/isWeakMap.js
  init_define_process();
  var weakMapTag4 = "[object WeakMap]";
  function isWeakMap(value) {
    return isObjectLike_default(value) && getTag_default(value) == weakMapTag4;
  }
  var isWeakMap_default = isWeakMap;

  // node_modules/lodash-es/isWeakSet.js
  init_define_process();
  var weakSetTag = "[object WeakSet]";
  function isWeakSet(value) {
    return isObjectLike_default(value) && baseGetTag_default(value) == weakSetTag;
  }
  var isWeakSet_default = isWeakSet;

  // node_modules/lodash-es/iteratee.js
  init_define_process();
  var CLONE_DEEP_FLAG5 = 1;
  function iteratee(func) {
    return baseIteratee_default(typeof func == "function" ? func : baseClone_default(func, CLONE_DEEP_FLAG5));
  }
  var iteratee_default = iteratee;

  // node_modules/lodash-es/join.js
  init_define_process();
  var arrayProto2 = Array.prototype;
  var nativeJoin = arrayProto2.join;
  function join(array, separator) {
    return array == null ? "" : nativeJoin.call(array, separator);
  }
  var join_default = join;

  // node_modules/lodash-es/kebabCase.js
  init_define_process();
  var kebabCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? "-" : "") + word.toLowerCase();
  });
  var kebabCase_default = kebabCase;

  // node_modules/lodash-es/keyBy.js
  init_define_process();
  var keyBy = createAggregator_default(function(result2, value, key) {
    baseAssignValue_default(result2, key, value);
  });
  var keyBy_default = keyBy;

  // node_modules/lodash-es/lastIndexOf.js
  init_define_process();

  // node_modules/lodash-es/_strictLastIndexOf.js
  init_define_process();
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }
  var strictLastIndexOf_default = strictLastIndexOf;

  // node_modules/lodash-es/lastIndexOf.js
  var nativeMax12 = Math.max;
  var nativeMin8 = Math.min;
  function lastIndexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return -1;
    }
    var index = length;
    if (fromIndex !== void 0) {
      index = toInteger_default(fromIndex);
      index = index < 0 ? nativeMax12(length + index, 0) : nativeMin8(index, length - 1);
    }
    return value === value ? strictLastIndexOf_default(array, value, index) : baseFindIndex_default(array, baseIsNaN_default, index, true);
  }
  var lastIndexOf_default = lastIndexOf;

  // node_modules/lodash-es/lowerCase.js
  init_define_process();
  var lowerCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? " " : "") + word.toLowerCase();
  });
  var lowerCase_default = lowerCase;

  // node_modules/lodash-es/lowerFirst.js
  init_define_process();
  var lowerFirst = createCaseFirst_default("toLowerCase");
  var lowerFirst_default = lowerFirst;

  // node_modules/lodash-es/lt.js
  init_define_process();

  // node_modules/lodash-es/_baseLt.js
  init_define_process();
  function baseLt(value, other) {
    return value < other;
  }
  var baseLt_default = baseLt;

  // node_modules/lodash-es/lt.js
  var lt = createRelationalOperation_default(baseLt_default);
  var lt_default = lt;

  // node_modules/lodash-es/lte.js
  init_define_process();
  var lte = createRelationalOperation_default(function(value, other) {
    return value <= other;
  });
  var lte_default = lte;

  // node_modules/lodash-es/mapKeys.js
  init_define_process();
  function mapKeys(object, iteratee2) {
    var result2 = {};
    iteratee2 = baseIteratee_default(iteratee2, 3);
    baseForOwn_default(object, function(value, key, object2) {
      baseAssignValue_default(result2, iteratee2(value, key, object2), value);
    });
    return result2;
  }
  var mapKeys_default = mapKeys;

  // node_modules/lodash-es/mapValues.js
  init_define_process();
  function mapValues(object, iteratee2) {
    var result2 = {};
    iteratee2 = baseIteratee_default(iteratee2, 3);
    baseForOwn_default(object, function(value, key, object2) {
      baseAssignValue_default(result2, key, iteratee2(value, key, object2));
    });
    return result2;
  }
  var mapValues_default = mapValues;

  // node_modules/lodash-es/matches.js
  init_define_process();
  var CLONE_DEEP_FLAG6 = 1;
  function matches(source) {
    return baseMatches_default(baseClone_default(source, CLONE_DEEP_FLAG6));
  }
  var matches_default = matches;

  // node_modules/lodash-es/matchesProperty.js
  init_define_process();
  var CLONE_DEEP_FLAG7 = 1;
  function matchesProperty(path, srcValue) {
    return baseMatchesProperty_default(path, baseClone_default(srcValue, CLONE_DEEP_FLAG7));
  }
  var matchesProperty_default = matchesProperty;

  // node_modules/lodash-es/max.js
  init_define_process();

  // node_modules/lodash-es/_baseExtremum.js
  init_define_process();
  function baseExtremum(array, iteratee2, comparator) {
    var index = -1, length = array.length;
    while (++index < length) {
      var value = array[index], current = iteratee2(value);
      if (current != null && (computed === void 0 ? current === current && !isSymbol_default(current) : comparator(current, computed))) {
        var computed = current, result2 = value;
      }
    }
    return result2;
  }
  var baseExtremum_default = baseExtremum;

  // node_modules/lodash-es/max.js
  function max(array) {
    return array && array.length ? baseExtremum_default(array, identity_default, baseGt_default) : void 0;
  }
  var max_default = max;

  // node_modules/lodash-es/maxBy.js
  init_define_process();
  function maxBy(array, iteratee2) {
    return array && array.length ? baseExtremum_default(array, baseIteratee_default(iteratee2, 2), baseGt_default) : void 0;
  }
  var maxBy_default = maxBy;

  // node_modules/lodash-es/mean.js
  init_define_process();

  // node_modules/lodash-es/_baseMean.js
  init_define_process();

  // node_modules/lodash-es/_baseSum.js
  init_define_process();
  function baseSum(array, iteratee2) {
    var result2, index = -1, length = array.length;
    while (++index < length) {
      var current = iteratee2(array[index]);
      if (current !== void 0) {
        result2 = result2 === void 0 ? current : result2 + current;
      }
    }
    return result2;
  }
  var baseSum_default = baseSum;

  // node_modules/lodash-es/_baseMean.js
  var NAN3 = 0 / 0;
  function baseMean(array, iteratee2) {
    var length = array == null ? 0 : array.length;
    return length ? baseSum_default(array, iteratee2) / length : NAN3;
  }
  var baseMean_default = baseMean;

  // node_modules/lodash-es/mean.js
  function mean(array) {
    return baseMean_default(array, identity_default);
  }
  var mean_default = mean;

  // node_modules/lodash-es/meanBy.js
  init_define_process();
  function meanBy(array, iteratee2) {
    return baseMean_default(array, baseIteratee_default(iteratee2, 2));
  }
  var meanBy_default = meanBy;

  // node_modules/lodash-es/merge.js
  init_define_process();
  var merge = createAssigner_default(function(object, source, srcIndex) {
    baseMerge_default(object, source, srcIndex);
  });
  var merge_default = merge;

  // node_modules/lodash-es/method.js
  init_define_process();
  var method = baseRest_default(function(path, args) {
    return function(object) {
      return baseInvoke_default(object, path, args);
    };
  });
  var method_default = method;

  // node_modules/lodash-es/methodOf.js
  init_define_process();
  var methodOf = baseRest_default(function(object, args) {
    return function(path) {
      return baseInvoke_default(object, path, args);
    };
  });
  var methodOf_default = methodOf;

  // node_modules/lodash-es/min.js
  init_define_process();
  function min(array) {
    return array && array.length ? baseExtremum_default(array, identity_default, baseLt_default) : void 0;
  }
  var min_default = min;

  // node_modules/lodash-es/minBy.js
  init_define_process();
  function minBy(array, iteratee2) {
    return array && array.length ? baseExtremum_default(array, baseIteratee_default(iteratee2, 2), baseLt_default) : void 0;
  }
  var minBy_default = minBy;

  // node_modules/lodash-es/mixin.js
  init_define_process();
  function mixin(object, source, options) {
    var props = keys_default(source), methodNames = baseFunctions_default(source, props);
    var chain2 = !(isObject_default(options) && "chain" in options) || !!options.chain, isFunc = isFunction_default(object);
    arrayEach_default(methodNames, function(methodName) {
      var func = source[methodName];
      object[methodName] = func;
      if (isFunc) {
        object.prototype[methodName] = function() {
          var chainAll = this.__chain__;
          if (chain2 || chainAll) {
            var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray_default(this.__actions__);
            actions.push({ "func": func, "args": arguments, "thisArg": object });
            result2.__chain__ = chainAll;
            return result2;
          }
          return func.apply(object, arrayPush_default([this.value()], arguments));
        };
      }
    });
    return object;
  }
  var mixin_default = mixin;

  // node_modules/lodash-es/multiply.js
  init_define_process();
  var multiply = createMathOperation_default(function(multiplier, multiplicand) {
    return multiplier * multiplicand;
  }, 1);
  var multiply_default = multiply;

  // node_modules/lodash-es/negate.js
  init_define_process();
  var FUNC_ERROR_TEXT9 = "Expected a function";
  function negate(predicate) {
    if (typeof predicate != "function") {
      throw new TypeError(FUNC_ERROR_TEXT9);
    }
    return function() {
      var args = arguments;
      switch (args.length) {
        case 0:
          return !predicate.call(this);
        case 1:
          return !predicate.call(this, args[0]);
        case 2:
          return !predicate.call(this, args[0], args[1]);
        case 3:
          return !predicate.call(this, args[0], args[1], args[2]);
      }
      return !predicate.apply(this, args);
    };
  }
  var negate_default = negate;

  // node_modules/lodash-es/next.js
  init_define_process();

  // node_modules/lodash-es/toArray.js
  init_define_process();

  // node_modules/lodash-es/_iteratorToArray.js
  init_define_process();
  function iteratorToArray(iterator) {
    var data, result2 = [];
    while (!(data = iterator.next()).done) {
      result2.push(data.value);
    }
    return result2;
  }
  var iteratorToArray_default = iteratorToArray;

  // node_modules/lodash-es/toArray.js
  var mapTag9 = "[object Map]";
  var setTag9 = "[object Set]";
  var symIterator = Symbol_default ? Symbol_default.iterator : void 0;
  function toArray(value) {
    if (!value) {
      return [];
    }
    if (isArrayLike_default(value)) {
      return isString_default(value) ? stringToArray_default(value) : copyArray_default(value);
    }
    if (symIterator && value[symIterator]) {
      return iteratorToArray_default(value[symIterator]());
    }
    var tag = getTag_default(value), func = tag == mapTag9 ? mapToArray_default : tag == setTag9 ? setToArray_default : values_default;
    return func(value);
  }
  var toArray_default = toArray;

  // node_modules/lodash-es/next.js
  function wrapperNext() {
    if (this.__values__ === void 0) {
      this.__values__ = toArray_default(this.value());
    }
    var done = this.__index__ >= this.__values__.length, value = done ? void 0 : this.__values__[this.__index__++];
    return { "done": done, "value": value };
  }
  var next_default = wrapperNext;

  // node_modules/lodash-es/nth.js
  init_define_process();

  // node_modules/lodash-es/_baseNth.js
  init_define_process();
  function baseNth(array, n) {
    var length = array.length;
    if (!length) {
      return;
    }
    n += n < 0 ? length : 0;
    return isIndex_default(n, length) ? array[n] : void 0;
  }
  var baseNth_default = baseNth;

  // node_modules/lodash-es/nth.js
  function nth(array, n) {
    return array && array.length ? baseNth_default(array, toInteger_default(n)) : void 0;
  }
  var nth_default = nth;

  // node_modules/lodash-es/nthArg.js
  init_define_process();
  function nthArg(n) {
    n = toInteger_default(n);
    return baseRest_default(function(args) {
      return baseNth_default(args, n);
    });
  }
  var nthArg_default = nthArg;

  // node_modules/lodash-es/omit.js
  init_define_process();

  // node_modules/lodash-es/_baseUnset.js
  init_define_process();
  function baseUnset(object, path) {
    path = castPath_default(path, object);
    object = parent_default(object, path);
    return object == null || delete object[toKey_default(last_default(path))];
  }
  var baseUnset_default = baseUnset;

  // node_modules/lodash-es/_customOmitClone.js
  init_define_process();
  function customOmitClone(value) {
    return isPlainObject_default(value) ? void 0 : value;
  }
  var customOmitClone_default = customOmitClone;

  // node_modules/lodash-es/omit.js
  var CLONE_DEEP_FLAG8 = 1;
  var CLONE_FLAT_FLAG2 = 2;
  var CLONE_SYMBOLS_FLAG6 = 4;
  var omit = flatRest_default(function(object, paths) {
    var result2 = {};
    if (object == null) {
      return result2;
    }
    var isDeep = false;
    paths = arrayMap_default(paths, function(path) {
      path = castPath_default(path, object);
      isDeep || (isDeep = path.length > 1);
      return path;
    });
    copyObject_default(object, getAllKeysIn_default(object), result2);
    if (isDeep) {
      result2 = baseClone_default(result2, CLONE_DEEP_FLAG8 | CLONE_FLAT_FLAG2 | CLONE_SYMBOLS_FLAG6, customOmitClone_default);
    }
    var length = paths.length;
    while (length--) {
      baseUnset_default(result2, paths[length]);
    }
    return result2;
  });
  var omit_default = omit;

  // node_modules/lodash-es/omitBy.js
  init_define_process();

  // node_modules/lodash-es/pickBy.js
  init_define_process();

  // node_modules/lodash-es/_basePickBy.js
  init_define_process();

  // node_modules/lodash-es/_baseSet.js
  init_define_process();
  function baseSet(object, path, value, customizer) {
    if (!isObject_default(object)) {
      return object;
    }
    path = castPath_default(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while (nested != null && ++index < length) {
      var key = toKey_default(path[index]), newValue = value;
      if (key === "__proto__" || key === "constructor" || key === "prototype") {
        return object;
      }
      if (index != lastIndex) {
        var objValue = nested[key];
        newValue = customizer ? customizer(objValue, key, nested) : void 0;
        if (newValue === void 0) {
          newValue = isObject_default(objValue) ? objValue : isIndex_default(path[index + 1]) ? [] : {};
        }
      }
      assignValue_default(nested, key, newValue);
      nested = nested[key];
    }
    return object;
  }
  var baseSet_default = baseSet;

  // node_modules/lodash-es/_basePickBy.js
  function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result2 = {};
    while (++index < length) {
      var path = paths[index], value = baseGet_default(object, path);
      if (predicate(value, path)) {
        baseSet_default(result2, castPath_default(path, object), value);
      }
    }
    return result2;
  }
  var basePickBy_default = basePickBy;

  // node_modules/lodash-es/pickBy.js
  function pickBy(object, predicate) {
    if (object == null) {
      return {};
    }
    var props = arrayMap_default(getAllKeysIn_default(object), function(prop) {
      return [prop];
    });
    predicate = baseIteratee_default(predicate);
    return basePickBy_default(object, props, function(value, path) {
      return predicate(value, path[0]);
    });
  }
  var pickBy_default = pickBy;

  // node_modules/lodash-es/omitBy.js
  function omitBy(object, predicate) {
    return pickBy_default(object, negate_default(baseIteratee_default(predicate)));
  }
  var omitBy_default = omitBy;

  // node_modules/lodash-es/once.js
  init_define_process();
  function once(func) {
    return before_default(2, func);
  }
  var once_default = once;

  // node_modules/lodash-es/orderBy.js
  init_define_process();

  // node_modules/lodash-es/_baseOrderBy.js
  init_define_process();

  // node_modules/lodash-es/_baseSortBy.js
  init_define_process();
  function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }
  var baseSortBy_default = baseSortBy;

  // node_modules/lodash-es/_compareMultiple.js
  init_define_process();

  // node_modules/lodash-es/_compareAscending.js
  init_define_process();
  function compareAscending(value, other) {
    if (value !== other) {
      var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol_default(value);
      var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol_default(other);
      if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
        return 1;
      }
      if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
        return -1;
      }
    }
    return 0;
  }
  var compareAscending_default = compareAscending;

  // node_modules/lodash-es/_compareMultiple.js
  function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while (++index < length) {
      var result2 = compareAscending_default(objCriteria[index], othCriteria[index]);
      if (result2) {
        if (index >= ordersLength) {
          return result2;
        }
        var order = orders[index];
        return result2 * (order == "desc" ? -1 : 1);
      }
    }
    return object.index - other.index;
  }
  var compareMultiple_default = compareMultiple;

  // node_modules/lodash-es/_baseOrderBy.js
  function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) {
      iteratees = arrayMap_default(iteratees, function(iteratee2) {
        if (isArray_default(iteratee2)) {
          return function(value) {
            return baseGet_default(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
          };
        }
        return iteratee2;
      });
    } else {
      iteratees = [identity_default];
    }
    var index = -1;
    iteratees = arrayMap_default(iteratees, baseUnary_default(baseIteratee_default));
    var result2 = baseMap_default(collection, function(value, key, collection2) {
      var criteria = arrayMap_default(iteratees, function(iteratee2) {
        return iteratee2(value);
      });
      return { "criteria": criteria, "index": ++index, "value": value };
    });
    return baseSortBy_default(result2, function(object, other) {
      return compareMultiple_default(object, other, orders);
    });
  }
  var baseOrderBy_default = baseOrderBy;

  // node_modules/lodash-es/orderBy.js
  function orderBy(collection, iteratees, orders, guard) {
    if (collection == null) {
      return [];
    }
    if (!isArray_default(iteratees)) {
      iteratees = iteratees == null ? [] : [iteratees];
    }
    orders = guard ? void 0 : orders;
    if (!isArray_default(orders)) {
      orders = orders == null ? [] : [orders];
    }
    return baseOrderBy_default(collection, iteratees, orders);
  }
  var orderBy_default = orderBy;

  // node_modules/lodash-es/over.js
  init_define_process();

  // node_modules/lodash-es/_createOver.js
  init_define_process();
  function createOver(arrayFunc) {
    return flatRest_default(function(iteratees) {
      iteratees = arrayMap_default(iteratees, baseUnary_default(baseIteratee_default));
      return baseRest_default(function(args) {
        var thisArg = this;
        return arrayFunc(iteratees, function(iteratee2) {
          return apply_default(iteratee2, thisArg, args);
        });
      });
    });
  }
  var createOver_default = createOver;

  // node_modules/lodash-es/over.js
  var over = createOver_default(arrayMap_default);
  var over_default = over;

  // node_modules/lodash-es/overArgs.js
  init_define_process();

  // node_modules/lodash-es/_castRest.js
  init_define_process();
  var castRest = baseRest_default;
  var castRest_default = castRest;

  // node_modules/lodash-es/overArgs.js
  var nativeMin9 = Math.min;
  var overArgs = castRest_default(function(func, transforms) {
    transforms = transforms.length == 1 && isArray_default(transforms[0]) ? arrayMap_default(transforms[0], baseUnary_default(baseIteratee_default)) : arrayMap_default(baseFlatten_default(transforms, 1), baseUnary_default(baseIteratee_default));
    var funcsLength = transforms.length;
    return baseRest_default(function(args) {
      var index = -1, length = nativeMin9(args.length, funcsLength);
      while (++index < length) {
        args[index] = transforms[index].call(this, args[index]);
      }
      return apply_default(func, this, args);
    });
  });
  var overArgs_default = overArgs;

  // node_modules/lodash-es/overEvery.js
  init_define_process();
  var overEvery = createOver_default(arrayEvery_default);
  var overEvery_default = overEvery;

  // node_modules/lodash-es/overSome.js
  init_define_process();
  var overSome = createOver_default(arraySome_default);
  var overSome_default = overSome;

  // node_modules/lodash-es/pad.js
  init_define_process();

  // node_modules/lodash-es/_createPadding.js
  init_define_process();

  // node_modules/lodash-es/_baseRepeat.js
  init_define_process();
  var MAX_SAFE_INTEGER4 = 9007199254740991;
  var nativeFloor = Math.floor;
  function baseRepeat(string, n) {
    var result2 = "";
    if (!string || n < 1 || n > MAX_SAFE_INTEGER4) {
      return result2;
    }
    do {
      if (n % 2) {
        result2 += string;
      }
      n = nativeFloor(n / 2);
      if (n) {
        string += string;
      }
    } while (n);
    return result2;
  }
  var baseRepeat_default = baseRepeat;

  // node_modules/lodash-es/_stringSize.js
  init_define_process();

  // node_modules/lodash-es/_asciiSize.js
  init_define_process();
  var asciiSize = baseProperty_default("length");
  var asciiSize_default = asciiSize;

  // node_modules/lodash-es/_unicodeSize.js
  init_define_process();
  var rsAstralRange4 = "\\ud800-\\udfff";
  var rsComboMarksRange5 = "\\u0300-\\u036f";
  var reComboHalfMarksRange5 = "\\ufe20-\\ufe2f";
  var rsComboSymbolsRange5 = "\\u20d0-\\u20ff";
  var rsComboRange5 = rsComboMarksRange5 + reComboHalfMarksRange5 + rsComboSymbolsRange5;
  var rsVarRange4 = "\\ufe0e\\ufe0f";
  var rsAstral2 = "[" + rsAstralRange4 + "]";
  var rsCombo4 = "[" + rsComboRange5 + "]";
  var rsFitz3 = "\\ud83c[\\udffb-\\udfff]";
  var rsModifier3 = "(?:" + rsCombo4 + "|" + rsFitz3 + ")";
  var rsNonAstral3 = "[^" + rsAstralRange4 + "]";
  var rsRegional3 = "(?:\\ud83c[\\udde6-\\uddff]){2}";
  var rsSurrPair3 = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var rsZWJ4 = "\\u200d";
  var reOptMod3 = rsModifier3 + "?";
  var rsOptVar3 = "[" + rsVarRange4 + "]?";
  var rsOptJoin3 = "(?:" + rsZWJ4 + "(?:" + [rsNonAstral3, rsRegional3, rsSurrPair3].join("|") + ")" + rsOptVar3 + reOptMod3 + ")*";
  var rsSeq3 = rsOptVar3 + reOptMod3 + rsOptJoin3;
  var rsSymbol2 = "(?:" + [rsNonAstral3 + rsCombo4 + "?", rsCombo4, rsRegional3, rsSurrPair3, rsAstral2].join("|") + ")";
  var reUnicode2 = RegExp(rsFitz3 + "(?=" + rsFitz3 + ")|" + rsSymbol2 + rsSeq3, "g");
  function unicodeSize(string) {
    var result2 = reUnicode2.lastIndex = 0;
    while (reUnicode2.test(string)) {
      ++result2;
    }
    return result2;
  }
  var unicodeSize_default = unicodeSize;

  // node_modules/lodash-es/_stringSize.js
  function stringSize(string) {
    return hasUnicode_default(string) ? unicodeSize_default(string) : asciiSize_default(string);
  }
  var stringSize_default = stringSize;

  // node_modules/lodash-es/_createPadding.js
  var nativeCeil2 = Math.ceil;
  function createPadding(length, chars) {
    chars = chars === void 0 ? " " : baseToString_default(chars);
    var charsLength = chars.length;
    if (charsLength < 2) {
      return charsLength ? baseRepeat_default(chars, length) : chars;
    }
    var result2 = baseRepeat_default(chars, nativeCeil2(length / stringSize_default(chars)));
    return hasUnicode_default(chars) ? castSlice_default(stringToArray_default(result2), 0, length).join("") : result2.slice(0, length);
  }
  var createPadding_default = createPadding;

  // node_modules/lodash-es/pad.js
  var nativeCeil3 = Math.ceil;
  var nativeFloor2 = Math.floor;
  function pad(string, length, chars) {
    string = toString_default(string);
    length = toInteger_default(length);
    var strLength = length ? stringSize_default(string) : 0;
    if (!length || strLength >= length) {
      return string;
    }
    var mid = (length - strLength) / 2;
    return createPadding_default(nativeFloor2(mid), chars) + string + createPadding_default(nativeCeil3(mid), chars);
  }
  var pad_default = pad;

  // node_modules/lodash-es/padEnd.js
  init_define_process();
  function padEnd(string, length, chars) {
    string = toString_default(string);
    length = toInteger_default(length);
    var strLength = length ? stringSize_default(string) : 0;
    return length && strLength < length ? string + createPadding_default(length - strLength, chars) : string;
  }
  var padEnd_default = padEnd;

  // node_modules/lodash-es/padStart.js
  init_define_process();
  function padStart(string, length, chars) {
    string = toString_default(string);
    length = toInteger_default(length);
    var strLength = length ? stringSize_default(string) : 0;
    return length && strLength < length ? createPadding_default(length - strLength, chars) + string : string;
  }
  var padStart_default = padStart;

  // node_modules/lodash-es/parseInt.js
  init_define_process();
  var reTrimStart2 = /^\s+/;
  var nativeParseInt = root_default.parseInt;
  function parseInt2(string, radix, guard) {
    if (guard || radix == null) {
      radix = 0;
    } else if (radix) {
      radix = +radix;
    }
    return nativeParseInt(toString_default(string).replace(reTrimStart2, ""), radix || 0);
  }
  var parseInt_default = parseInt2;

  // node_modules/lodash-es/partial.js
  init_define_process();
  var WRAP_PARTIAL_FLAG7 = 32;
  var partial = baseRest_default(function(func, partials) {
    var holders = replaceHolders_default(partials, getHolder_default(partial));
    return createWrap_default(func, WRAP_PARTIAL_FLAG7, void 0, partials, holders);
  });
  partial.placeholder = {};
  var partial_default = partial;

  // node_modules/lodash-es/partialRight.js
  init_define_process();
  var WRAP_PARTIAL_RIGHT_FLAG4 = 64;
  var partialRight = baseRest_default(function(func, partials) {
    var holders = replaceHolders_default(partials, getHolder_default(partialRight));
    return createWrap_default(func, WRAP_PARTIAL_RIGHT_FLAG4, void 0, partials, holders);
  });
  partialRight.placeholder = {};
  var partialRight_default = partialRight;

  // node_modules/lodash-es/partition.js
  init_define_process();
  var partition = createAggregator_default(function(result2, value, key) {
    result2[key ? 0 : 1].push(value);
  }, function() {
    return [[], []];
  });
  var partition_default = partition;

  // node_modules/lodash-es/pick.js
  init_define_process();

  // node_modules/lodash-es/_basePick.js
  init_define_process();
  function basePick(object, paths) {
    return basePickBy_default(object, paths, function(value, path) {
      return hasIn_default(object, path);
    });
  }
  var basePick_default = basePick;

  // node_modules/lodash-es/pick.js
  var pick = flatRest_default(function(object, paths) {
    return object == null ? {} : basePick_default(object, paths);
  });
  var pick_default = pick;

  // node_modules/lodash-es/plant.js
  init_define_process();
  function wrapperPlant(value) {
    var result2, parent2 = this;
    while (parent2 instanceof baseLodash_default) {
      var clone2 = wrapperClone_default(parent2);
      clone2.__index__ = 0;
      clone2.__values__ = void 0;
      if (result2) {
        previous.__wrapped__ = clone2;
      } else {
        result2 = clone2;
      }
      var previous = clone2;
      parent2 = parent2.__wrapped__;
    }
    previous.__wrapped__ = value;
    return result2;
  }
  var plant_default = wrapperPlant;

  // node_modules/lodash-es/propertyOf.js
  init_define_process();
  function propertyOf(object) {
    return function(path) {
      return object == null ? void 0 : baseGet_default(object, path);
    };
  }
  var propertyOf_default = propertyOf;

  // node_modules/lodash-es/pull.js
  init_define_process();

  // node_modules/lodash-es/pullAll.js
  init_define_process();

  // node_modules/lodash-es/_basePullAll.js
  init_define_process();

  // node_modules/lodash-es/_baseIndexOfWith.js
  init_define_process();
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }
  var baseIndexOfWith_default = baseIndexOfWith;

  // node_modules/lodash-es/_basePullAll.js
  var arrayProto3 = Array.prototype;
  var splice2 = arrayProto3.splice;
  function basePullAll(array, values2, iteratee2, comparator) {
    var indexOf2 = comparator ? baseIndexOfWith_default : baseIndexOf_default, index = -1, length = values2.length, seen = array;
    if (array === values2) {
      values2 = copyArray_default(values2);
    }
    if (iteratee2) {
      seen = arrayMap_default(array, baseUnary_default(iteratee2));
    }
    while (++index < length) {
      var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
      while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
        if (seen !== array) {
          splice2.call(seen, fromIndex, 1);
        }
        splice2.call(array, fromIndex, 1);
      }
    }
    return array;
  }
  var basePullAll_default = basePullAll;

  // node_modules/lodash-es/pullAll.js
  function pullAll(array, values2) {
    return array && array.length && values2 && values2.length ? basePullAll_default(array, values2) : array;
  }
  var pullAll_default = pullAll;

  // node_modules/lodash-es/pull.js
  var pull = baseRest_default(pullAll_default);
  var pull_default = pull;

  // node_modules/lodash-es/pullAllBy.js
  init_define_process();
  function pullAllBy(array, values2, iteratee2) {
    return array && array.length && values2 && values2.length ? basePullAll_default(array, values2, baseIteratee_default(iteratee2, 2)) : array;
  }
  var pullAllBy_default = pullAllBy;

  // node_modules/lodash-es/pullAllWith.js
  init_define_process();
  function pullAllWith(array, values2, comparator) {
    return array && array.length && values2 && values2.length ? basePullAll_default(array, values2, void 0, comparator) : array;
  }
  var pullAllWith_default = pullAllWith;

  // node_modules/lodash-es/pullAt.js
  init_define_process();

  // node_modules/lodash-es/_basePullAt.js
  init_define_process();
  var arrayProto4 = Array.prototype;
  var splice3 = arrayProto4.splice;
  function basePullAt(array, indexes) {
    var length = array ? indexes.length : 0, lastIndex = length - 1;
    while (length--) {
      var index = indexes[length];
      if (length == lastIndex || index !== previous) {
        var previous = index;
        if (isIndex_default(index)) {
          splice3.call(array, index, 1);
        } else {
          baseUnset_default(array, index);
        }
      }
    }
    return array;
  }
  var basePullAt_default = basePullAt;

  // node_modules/lodash-es/pullAt.js
  var pullAt = flatRest_default(function(array, indexes) {
    var length = array == null ? 0 : array.length, result2 = baseAt_default(array, indexes);
    basePullAt_default(array, arrayMap_default(indexes, function(index) {
      return isIndex_default(index, length) ? +index : index;
    }).sort(compareAscending_default));
    return result2;
  });
  var pullAt_default = pullAt;

  // node_modules/lodash-es/random.js
  init_define_process();

  // node_modules/lodash-es/_baseRandom.js
  init_define_process();
  var nativeFloor3 = Math.floor;
  var nativeRandom = Math.random;
  function baseRandom(lower, upper) {
    return lower + nativeFloor3(nativeRandom() * (upper - lower + 1));
  }
  var baseRandom_default = baseRandom;

  // node_modules/lodash-es/random.js
  var freeParseFloat = parseFloat;
  var nativeMin10 = Math.min;
  var nativeRandom2 = Math.random;
  function random(lower, upper, floating) {
    if (floating && typeof floating != "boolean" && isIterateeCall_default(lower, upper, floating)) {
      upper = floating = void 0;
    }
    if (floating === void 0) {
      if (typeof upper == "boolean") {
        floating = upper;
        upper = void 0;
      } else if (typeof lower == "boolean") {
        floating = lower;
        lower = void 0;
      }
    }
    if (lower === void 0 && upper === void 0) {
      lower = 0;
      upper = 1;
    } else {
      lower = toFinite_default(lower);
      if (upper === void 0) {
        upper = lower;
        lower = 0;
      } else {
        upper = toFinite_default(upper);
      }
    }
    if (lower > upper) {
      var temp = lower;
      lower = upper;
      upper = temp;
    }
    if (floating || lower % 1 || upper % 1) {
      var rand = nativeRandom2();
      return nativeMin10(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
    }
    return baseRandom_default(lower, upper);
  }
  var random_default = random;

  // node_modules/lodash-es/range.js
  init_define_process();

  // node_modules/lodash-es/_createRange.js
  init_define_process();

  // node_modules/lodash-es/_baseRange.js
  init_define_process();
  var nativeCeil4 = Math.ceil;
  var nativeMax13 = Math.max;
  function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax13(nativeCeil4((end - start) / (step || 1)), 0), result2 = Array(length);
    while (length--) {
      result2[fromRight ? length : ++index] = start;
      start += step;
    }
    return result2;
  }
  var baseRange_default = baseRange;

  // node_modules/lodash-es/_createRange.js
  function createRange(fromRight) {
    return function(start, end, step) {
      if (step && typeof step != "number" && isIterateeCall_default(start, end, step)) {
        end = step = void 0;
      }
      start = toFinite_default(start);
      if (end === void 0) {
        end = start;
        start = 0;
      } else {
        end = toFinite_default(end);
      }
      step = step === void 0 ? start < end ? 1 : -1 : toFinite_default(step);
      return baseRange_default(start, end, step, fromRight);
    };
  }
  var createRange_default = createRange;

  // node_modules/lodash-es/range.js
  var range = createRange_default();
  var range_default = range;

  // node_modules/lodash-es/rangeRight.js
  init_define_process();
  var rangeRight = createRange_default(true);
  var rangeRight_default = rangeRight;

  // node_modules/lodash-es/rearg.js
  init_define_process();
  var WRAP_REARG_FLAG4 = 256;
  var rearg = flatRest_default(function(func, indexes) {
    return createWrap_default(func, WRAP_REARG_FLAG4, void 0, void 0, void 0, indexes);
  });
  var rearg_default = rearg;

  // node_modules/lodash-es/reduce.js
  init_define_process();

  // node_modules/lodash-es/_baseReduce.js
  init_define_process();
  function baseReduce(collection, iteratee2, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection2) {
      accumulator = initAccum ? (initAccum = false, value) : iteratee2(accumulator, value, index, collection2);
    });
    return accumulator;
  }
  var baseReduce_default = baseReduce;

  // node_modules/lodash-es/reduce.js
  function reduce(collection, iteratee2, accumulator) {
    var func = isArray_default(collection) ? arrayReduce_default : baseReduce_default, initAccum = arguments.length < 3;
    return func(collection, baseIteratee_default(iteratee2, 4), accumulator, initAccum, baseEach_default);
  }
  var reduce_default = reduce;

  // node_modules/lodash-es/reduceRight.js
  init_define_process();

  // node_modules/lodash-es/_arrayReduceRight.js
  init_define_process();
  function arrayReduceRight(array, iteratee2, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee2(accumulator, array[length], length, array);
    }
    return accumulator;
  }
  var arrayReduceRight_default = arrayReduceRight;

  // node_modules/lodash-es/reduceRight.js
  function reduceRight(collection, iteratee2, accumulator) {
    var func = isArray_default(collection) ? arrayReduceRight_default : baseReduce_default, initAccum = arguments.length < 3;
    return func(collection, baseIteratee_default(iteratee2, 4), accumulator, initAccum, baseEachRight_default);
  }
  var reduceRight_default = reduceRight;

  // node_modules/lodash-es/reject.js
  init_define_process();
  function reject(collection, predicate) {
    var func = isArray_default(collection) ? arrayFilter_default : baseFilter_default;
    return func(collection, negate_default(baseIteratee_default(predicate, 3)));
  }
  var reject_default = reject;

  // node_modules/lodash-es/remove.js
  init_define_process();
  function remove(array, predicate) {
    var result2 = [];
    if (!(array && array.length)) {
      return result2;
    }
    var index = -1, indexes = [], length = array.length;
    predicate = baseIteratee_default(predicate, 3);
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result2.push(value);
        indexes.push(index);
      }
    }
    basePullAt_default(array, indexes);
    return result2;
  }
  var remove_default = remove;

  // node_modules/lodash-es/repeat.js
  init_define_process();
  function repeat(string, n, guard) {
    if (guard ? isIterateeCall_default(string, n, guard) : n === void 0) {
      n = 1;
    } else {
      n = toInteger_default(n);
    }
    return baseRepeat_default(toString_default(string), n);
  }
  var repeat_default = repeat;

  // node_modules/lodash-es/replace.js
  init_define_process();
  function replace() {
    var args = arguments, string = toString_default(args[0]);
    return args.length < 3 ? string : string.replace(args[1], args[2]);
  }
  var replace_default = replace;

  // node_modules/lodash-es/rest.js
  init_define_process();
  var FUNC_ERROR_TEXT10 = "Expected a function";
  function rest(func, start) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT10);
    }
    start = start === void 0 ? start : toInteger_default(start);
    return baseRest_default(func, start);
  }
  var rest_default = rest;

  // node_modules/lodash-es/result.js
  init_define_process();
  function result(object, path, defaultValue) {
    path = castPath_default(path, object);
    var index = -1, length = path.length;
    if (!length) {
      length = 1;
      object = void 0;
    }
    while (++index < length) {
      var value = object == null ? void 0 : object[toKey_default(path[index])];
      if (value === void 0) {
        index = length;
        value = defaultValue;
      }
      object = isFunction_default(value) ? value.call(object) : value;
    }
    return object;
  }
  var result_default = result;

  // node_modules/lodash-es/reverse.js
  init_define_process();
  var arrayProto5 = Array.prototype;
  var nativeReverse = arrayProto5.reverse;
  function reverse(array) {
    return array == null ? array : nativeReverse.call(array);
  }
  var reverse_default = reverse;

  // node_modules/lodash-es/round.js
  init_define_process();
  var round = createRound_default("round");
  var round_default = round;

  // node_modules/lodash-es/sample.js
  init_define_process();

  // node_modules/lodash-es/_arraySample.js
  init_define_process();
  function arraySample(array) {
    var length = array.length;
    return length ? array[baseRandom_default(0, length - 1)] : void 0;
  }
  var arraySample_default = arraySample;

  // node_modules/lodash-es/_baseSample.js
  init_define_process();
  function baseSample(collection) {
    return arraySample_default(values_default(collection));
  }
  var baseSample_default = baseSample;

  // node_modules/lodash-es/sample.js
  function sample(collection) {
    var func = isArray_default(collection) ? arraySample_default : baseSample_default;
    return func(collection);
  }
  var sample_default = sample;

  // node_modules/lodash-es/sampleSize.js
  init_define_process();

  // node_modules/lodash-es/_arraySampleSize.js
  init_define_process();

  // node_modules/lodash-es/_shuffleSelf.js
  init_define_process();
  function shuffleSelf(array, size2) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size2 = size2 === void 0 ? length : size2;
    while (++index < size2) {
      var rand = baseRandom_default(index, lastIndex), value = array[rand];
      array[rand] = array[index];
      array[index] = value;
    }
    array.length = size2;
    return array;
  }
  var shuffleSelf_default = shuffleSelf;

  // node_modules/lodash-es/_arraySampleSize.js
  function arraySampleSize(array, n) {
    return shuffleSelf_default(copyArray_default(array), baseClamp_default(n, 0, array.length));
  }
  var arraySampleSize_default = arraySampleSize;

  // node_modules/lodash-es/_baseSampleSize.js
  init_define_process();
  function baseSampleSize(collection, n) {
    var array = values_default(collection);
    return shuffleSelf_default(array, baseClamp_default(n, 0, array.length));
  }
  var baseSampleSize_default = baseSampleSize;

  // node_modules/lodash-es/sampleSize.js
  function sampleSize(collection, n, guard) {
    if (guard ? isIterateeCall_default(collection, n, guard) : n === void 0) {
      n = 1;
    } else {
      n = toInteger_default(n);
    }
    var func = isArray_default(collection) ? arraySampleSize_default : baseSampleSize_default;
    return func(collection, n);
  }
  var sampleSize_default = sampleSize;

  // node_modules/lodash-es/set.js
  init_define_process();
  function set(object, path, value) {
    return object == null ? object : baseSet_default(object, path, value);
  }
  var set_default = set;

  // node_modules/lodash-es/setWith.js
  init_define_process();
  function setWith(object, path, value, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return object == null ? object : baseSet_default(object, path, value, customizer);
  }
  var setWith_default = setWith;

  // node_modules/lodash-es/shuffle.js
  init_define_process();

  // node_modules/lodash-es/_arrayShuffle.js
  init_define_process();
  function arrayShuffle(array) {
    return shuffleSelf_default(copyArray_default(array));
  }
  var arrayShuffle_default = arrayShuffle;

  // node_modules/lodash-es/_baseShuffle.js
  init_define_process();
  function baseShuffle(collection) {
    return shuffleSelf_default(values_default(collection));
  }
  var baseShuffle_default = baseShuffle;

  // node_modules/lodash-es/shuffle.js
  function shuffle(collection) {
    var func = isArray_default(collection) ? arrayShuffle_default : baseShuffle_default;
    return func(collection);
  }
  var shuffle_default = shuffle;

  // node_modules/lodash-es/size.js
  init_define_process();
  var mapTag10 = "[object Map]";
  var setTag10 = "[object Set]";
  function size(collection) {
    if (collection == null) {
      return 0;
    }
    if (isArrayLike_default(collection)) {
      return isString_default(collection) ? stringSize_default(collection) : collection.length;
    }
    var tag = getTag_default(collection);
    if (tag == mapTag10 || tag == setTag10) {
      return collection.size;
    }
    return baseKeys_default(collection).length;
  }
  var size_default = size;

  // node_modules/lodash-es/slice.js
  init_define_process();
  function slice(array, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    if (end && typeof end != "number" && isIterateeCall_default(array, start, end)) {
      start = 0;
      end = length;
    } else {
      start = start == null ? 0 : toInteger_default(start);
      end = end === void 0 ? length : toInteger_default(end);
    }
    return baseSlice_default(array, start, end);
  }
  var slice_default = slice;

  // node_modules/lodash-es/snakeCase.js
  init_define_process();
  var snakeCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? "_" : "") + word.toLowerCase();
  });
  var snakeCase_default = snakeCase;

  // node_modules/lodash-es/some.js
  init_define_process();

  // node_modules/lodash-es/_baseSome.js
  init_define_process();
  function baseSome(collection, predicate) {
    var result2;
    baseEach_default(collection, function(value, index, collection2) {
      result2 = predicate(value, index, collection2);
      return !result2;
    });
    return !!result2;
  }
  var baseSome_default = baseSome;

  // node_modules/lodash-es/some.js
  function some(collection, predicate, guard) {
    var func = isArray_default(collection) ? arraySome_default : baseSome_default;
    if (guard && isIterateeCall_default(collection, predicate, guard)) {
      predicate = void 0;
    }
    return func(collection, baseIteratee_default(predicate, 3));
  }
  var some_default = some;

  // node_modules/lodash-es/sortBy.js
  init_define_process();
  var sortBy = baseRest_default(function(collection, iteratees) {
    if (collection == null) {
      return [];
    }
    var length = iteratees.length;
    if (length > 1 && isIterateeCall_default(collection, iteratees[0], iteratees[1])) {
      iteratees = [];
    } else if (length > 2 && isIterateeCall_default(iteratees[0], iteratees[1], iteratees[2])) {
      iteratees = [iteratees[0]];
    }
    return baseOrderBy_default(collection, baseFlatten_default(iteratees, 1), []);
  });
  var sortBy_default = sortBy;

  // node_modules/lodash-es/sortedIndex.js
  init_define_process();

  // node_modules/lodash-es/_baseSortedIndex.js
  init_define_process();

  // node_modules/lodash-es/_baseSortedIndexBy.js
  init_define_process();
  var MAX_ARRAY_LENGTH3 = 4294967295;
  var MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH3 - 1;
  var nativeFloor4 = Math.floor;
  var nativeMin11 = Math.min;
  function baseSortedIndexBy(array, value, iteratee2, retHighest) {
    var low = 0, high = array == null ? 0 : array.length;
    if (high === 0) {
      return 0;
    }
    value = iteratee2(value);
    var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol_default(value), valIsUndefined = value === void 0;
    while (low < high) {
      var mid = nativeFloor4((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== void 0, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol_default(computed);
      if (valIsNaN) {
        var setLow = retHighest || othIsReflexive;
      } else if (valIsUndefined) {
        setLow = othIsReflexive && (retHighest || othIsDefined);
      } else if (valIsNull) {
        setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
      } else if (valIsSymbol) {
        setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
      } else if (othIsNull || othIsSymbol) {
        setLow = false;
      } else {
        setLow = retHighest ? computed <= value : computed < value;
      }
      if (setLow) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return nativeMin11(high, MAX_ARRAY_INDEX);
  }
  var baseSortedIndexBy_default = baseSortedIndexBy;

  // node_modules/lodash-es/_baseSortedIndex.js
  var MAX_ARRAY_LENGTH4 = 4294967295;
  var HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH4 >>> 1;
  function baseSortedIndex(array, value, retHighest) {
    var low = 0, high = array == null ? low : array.length;
    if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
      while (low < high) {
        var mid = low + high >>> 1, computed = array[mid];
        if (computed !== null && !isSymbol_default(computed) && (retHighest ? computed <= value : computed < value)) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return high;
    }
    return baseSortedIndexBy_default(array, value, identity_default, retHighest);
  }
  var baseSortedIndex_default = baseSortedIndex;

  // node_modules/lodash-es/sortedIndex.js
  function sortedIndex(array, value) {
    return baseSortedIndex_default(array, value);
  }
  var sortedIndex_default = sortedIndex;

  // node_modules/lodash-es/sortedIndexBy.js
  init_define_process();
  function sortedIndexBy(array, value, iteratee2) {
    return baseSortedIndexBy_default(array, value, baseIteratee_default(iteratee2, 2));
  }
  var sortedIndexBy_default = sortedIndexBy;

  // node_modules/lodash-es/sortedIndexOf.js
  init_define_process();
  function sortedIndexOf(array, value) {
    var length = array == null ? 0 : array.length;
    if (length) {
      var index = baseSortedIndex_default(array, value);
      if (index < length && eq_default(array[index], value)) {
        return index;
      }
    }
    return -1;
  }
  var sortedIndexOf_default = sortedIndexOf;

  // node_modules/lodash-es/sortedLastIndex.js
  init_define_process();
  function sortedLastIndex(array, value) {
    return baseSortedIndex_default(array, value, true);
  }
  var sortedLastIndex_default = sortedLastIndex;

  // node_modules/lodash-es/sortedLastIndexBy.js
  init_define_process();
  function sortedLastIndexBy(array, value, iteratee2) {
    return baseSortedIndexBy_default(array, value, baseIteratee_default(iteratee2, 2), true);
  }
  var sortedLastIndexBy_default = sortedLastIndexBy;

  // node_modules/lodash-es/sortedLastIndexOf.js
  init_define_process();
  function sortedLastIndexOf(array, value) {
    var length = array == null ? 0 : array.length;
    if (length) {
      var index = baseSortedIndex_default(array, value, true) - 1;
      if (eq_default(array[index], value)) {
        return index;
      }
    }
    return -1;
  }
  var sortedLastIndexOf_default = sortedLastIndexOf;

  // node_modules/lodash-es/sortedUniq.js
  init_define_process();

  // node_modules/lodash-es/_baseSortedUniq.js
  init_define_process();
  function baseSortedUniq(array, iteratee2) {
    var index = -1, length = array.length, resIndex = 0, result2 = [];
    while (++index < length) {
      var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
      if (!index || !eq_default(computed, seen)) {
        var seen = computed;
        result2[resIndex++] = value === 0 ? 0 : value;
      }
    }
    return result2;
  }
  var baseSortedUniq_default = baseSortedUniq;

  // node_modules/lodash-es/sortedUniq.js
  function sortedUniq(array) {
    return array && array.length ? baseSortedUniq_default(array) : [];
  }
  var sortedUniq_default = sortedUniq;

  // node_modules/lodash-es/sortedUniqBy.js
  init_define_process();
  function sortedUniqBy(array, iteratee2) {
    return array && array.length ? baseSortedUniq_default(array, baseIteratee_default(iteratee2, 2)) : [];
  }
  var sortedUniqBy_default = sortedUniqBy;

  // node_modules/lodash-es/split.js
  init_define_process();
  var MAX_ARRAY_LENGTH5 = 4294967295;
  function split(string, separator, limit) {
    if (limit && typeof limit != "number" && isIterateeCall_default(string, separator, limit)) {
      separator = limit = void 0;
    }
    limit = limit === void 0 ? MAX_ARRAY_LENGTH5 : limit >>> 0;
    if (!limit) {
      return [];
    }
    string = toString_default(string);
    if (string && (typeof separator == "string" || separator != null && !isRegExp_default(separator))) {
      separator = baseToString_default(separator);
      if (!separator && hasUnicode_default(string)) {
        return castSlice_default(stringToArray_default(string), 0, limit);
      }
    }
    return string.split(separator, limit);
  }
  var split_default = split;

  // node_modules/lodash-es/spread.js
  init_define_process();
  var FUNC_ERROR_TEXT11 = "Expected a function";
  var nativeMax14 = Math.max;
  function spread(func, start) {
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT11);
    }
    start = start == null ? 0 : nativeMax14(toInteger_default(start), 0);
    return baseRest_default(function(args) {
      var array = args[start], otherArgs = castSlice_default(args, 0, start);
      if (array) {
        arrayPush_default(otherArgs, array);
      }
      return apply_default(func, this, otherArgs);
    });
  }
  var spread_default = spread;

  // node_modules/lodash-es/startCase.js
  init_define_process();
  var startCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? " " : "") + upperFirst_default(word);
  });
  var startCase_default = startCase;

  // node_modules/lodash-es/startsWith.js
  init_define_process();
  function startsWith(string, target, position) {
    string = toString_default(string);
    position = position == null ? 0 : baseClamp_default(toInteger_default(position), 0, string.length);
    target = baseToString_default(target);
    return string.slice(position, position + target.length) == target;
  }
  var startsWith_default = startsWith;

  // node_modules/lodash-es/stubObject.js
  init_define_process();
  function stubObject() {
    return {};
  }
  var stubObject_default = stubObject;

  // node_modules/lodash-es/stubString.js
  init_define_process();
  function stubString() {
    return "";
  }
  var stubString_default = stubString;

  // node_modules/lodash-es/stubTrue.js
  init_define_process();
  function stubTrue() {
    return true;
  }
  var stubTrue_default = stubTrue;

  // node_modules/lodash-es/subtract.js
  init_define_process();
  var subtract = createMathOperation_default(function(minuend, subtrahend) {
    return minuend - subtrahend;
  }, 0);
  var subtract_default = subtract;

  // node_modules/lodash-es/sum.js
  init_define_process();
  function sum(array) {
    return array && array.length ? baseSum_default(array, identity_default) : 0;
  }
  var sum_default = sum;

  // node_modules/lodash-es/sumBy.js
  init_define_process();
  function sumBy(array, iteratee2) {
    return array && array.length ? baseSum_default(array, baseIteratee_default(iteratee2, 2)) : 0;
  }
  var sumBy_default = sumBy;

  // node_modules/lodash-es/tail.js
  init_define_process();
  function tail(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseSlice_default(array, 1, length) : [];
  }
  var tail_default = tail;

  // node_modules/lodash-es/take.js
  init_define_process();
  function take(array, n, guard) {
    if (!(array && array.length)) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    return baseSlice_default(array, 0, n < 0 ? 0 : n);
  }
  var take_default = take;

  // node_modules/lodash-es/takeRight.js
  init_define_process();
  function takeRight(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) {
      return [];
    }
    n = guard || n === void 0 ? 1 : toInteger_default(n);
    n = length - n;
    return baseSlice_default(array, n < 0 ? 0 : n, length);
  }
  var takeRight_default = takeRight;

  // node_modules/lodash-es/takeRightWhile.js
  init_define_process();
  function takeRightWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3), false, true) : [];
  }
  var takeRightWhile_default = takeRightWhile;

  // node_modules/lodash-es/takeWhile.js
  init_define_process();
  function takeWhile(array, predicate) {
    return array && array.length ? baseWhile_default(array, baseIteratee_default(predicate, 3)) : [];
  }
  var takeWhile_default = takeWhile;

  // node_modules/lodash-es/tap.js
  init_define_process();
  function tap(value, interceptor) {
    interceptor(value);
    return value;
  }
  var tap_default = tap;

  // node_modules/lodash-es/template.js
  init_define_process();

  // node_modules/lodash-es/_customDefaultsAssignIn.js
  init_define_process();
  var objectProto27 = Object.prototype;
  var hasOwnProperty23 = objectProto27.hasOwnProperty;
  function customDefaultsAssignIn(objValue, srcValue, key, object) {
    if (objValue === void 0 || eq_default(objValue, objectProto27[key]) && !hasOwnProperty23.call(object, key)) {
      return srcValue;
    }
    return objValue;
  }
  var customDefaultsAssignIn_default = customDefaultsAssignIn;

  // node_modules/lodash-es/_escapeStringChar.js
  init_define_process();
  var stringEscapes = {
    "\\": "\\",
    "'": "'",
    "\n": "n",
    "\r": "r",
    "\u2028": "u2028",
    "\u2029": "u2029"
  };
  function escapeStringChar(chr) {
    return "\\" + stringEscapes[chr];
  }
  var escapeStringChar_default = escapeStringChar;

  // node_modules/lodash-es/_reInterpolate.js
  init_define_process();
  var reInterpolate = /<%=([\s\S]+?)%>/g;
  var reInterpolate_default = reInterpolate;

  // node_modules/lodash-es/templateSettings.js
  init_define_process();

  // node_modules/lodash-es/_reEscape.js
  init_define_process();
  var reEscape = /<%-([\s\S]+?)%>/g;
  var reEscape_default = reEscape;

  // node_modules/lodash-es/_reEvaluate.js
  init_define_process();
  var reEvaluate = /<%([\s\S]+?)%>/g;
  var reEvaluate_default = reEvaluate;

  // node_modules/lodash-es/templateSettings.js
  var templateSettings = {
    "escape": reEscape_default,
    "evaluate": reEvaluate_default,
    "interpolate": reInterpolate_default,
    "variable": "",
    "imports": {
      "_": { "escape": escape_default }
    }
  };
  var templateSettings_default = templateSettings;

  // node_modules/lodash-es/template.js
  var INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
  var reEmptyStringLeading = /\b__p \+= '';/g;
  var reEmptyStringMiddle = /\b(__p \+=) '' \+/g;
  var reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
  var reNoMatch = /($^)/;
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
  var objectProto28 = Object.prototype;
  var hasOwnProperty24 = objectProto28.hasOwnProperty;
  function template(string, options, guard) {
    var settings = templateSettings_default.imports._.templateSettings || templateSettings_default;
    if (guard && isIterateeCall_default(string, options, guard)) {
      options = void 0;
    }
    string = toString_default(string);
    options = assignInWith_default({}, options, settings, customDefaultsAssignIn_default);
    var imports = assignInWith_default({}, options.imports, settings.imports, customDefaultsAssignIn_default), importsKeys = keys_default(imports), importsValues = baseValues_default(imports, importsKeys);
    var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
    var reDelimiters = RegExp(
      (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate_default ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
      "g"
    );
    var sourceURL = hasOwnProperty24.call(options, "sourceURL") ? "//# sourceURL=" + (options.sourceURL + "").replace(/\s/g, " ") + "\n" : "";
    string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
      interpolateValue || (interpolateValue = esTemplateValue);
      source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar_default);
      if (escapeValue) {
        isEscaping = true;
        source += "' +\n__e(" + escapeValue + ") +\n'";
      }
      if (evaluateValue) {
        isEvaluating = true;
        source += "';\n" + evaluateValue + ";\n__p += '";
      }
      if (interpolateValue) {
        source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
      }
      index = offset + match.length;
      return match;
    });
    source += "';\n";
    var variable = hasOwnProperty24.call(options, "variable") && options.variable;
    if (!variable) {
      source = "with (obj) {\n" + source + "\n}\n";
    } else if (reForbiddenIdentifierChars.test(variable)) {
      throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
    }
    source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
    source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
    var result2 = attempt_default(function() {
      return Function(importsKeys, sourceURL + "return " + source).apply(void 0, importsValues);
    });
    result2.source = source;
    if (isError_default(result2)) {
      throw result2;
    }
    return result2;
  }
  var template_default = template;

  // node_modules/lodash-es/throttle.js
  init_define_process();
  var FUNC_ERROR_TEXT12 = "Expected a function";
  function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT12);
    }
    if (isObject_default(options)) {
      leading = "leading" in options ? !!options.leading : leading;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return debounce_default(func, wait, {
      "leading": leading,
      "maxWait": wait,
      "trailing": trailing
    });
  }
  var throttle_default = throttle;

  // node_modules/lodash-es/thru.js
  init_define_process();
  function thru(value, interceptor) {
    return interceptor(value);
  }
  var thru_default = thru;

  // node_modules/lodash-es/times.js
  init_define_process();
  var MAX_SAFE_INTEGER5 = 9007199254740991;
  var MAX_ARRAY_LENGTH6 = 4294967295;
  var nativeMin12 = Math.min;
  function times(n, iteratee2) {
    n = toInteger_default(n);
    if (n < 1 || n > MAX_SAFE_INTEGER5) {
      return [];
    }
    var index = MAX_ARRAY_LENGTH6, length = nativeMin12(n, MAX_ARRAY_LENGTH6);
    iteratee2 = castFunction_default(iteratee2);
    n -= MAX_ARRAY_LENGTH6;
    var result2 = baseTimes_default(length, iteratee2);
    while (++index < n) {
      iteratee2(index);
    }
    return result2;
  }
  var times_default = times;

  // node_modules/lodash-es/toIterator.js
  init_define_process();
  function wrapperToIterator() {
    return this;
  }
  var toIterator_default = wrapperToIterator;

  // node_modules/lodash-es/toJSON.js
  init_define_process();

  // node_modules/lodash-es/wrapperValue.js
  init_define_process();

  // node_modules/lodash-es/_baseWrapperValue.js
  init_define_process();
  function baseWrapperValue(value, actions) {
    var result2 = value;
    if (result2 instanceof LazyWrapper_default) {
      result2 = result2.value();
    }
    return arrayReduce_default(actions, function(result3, action) {
      return action.func.apply(action.thisArg, arrayPush_default([result3], action.args));
    }, result2);
  }
  var baseWrapperValue_default = baseWrapperValue;

  // node_modules/lodash-es/wrapperValue.js
  function wrapperValue() {
    return baseWrapperValue_default(this.__wrapped__, this.__actions__);
  }
  var wrapperValue_default = wrapperValue;

  // node_modules/lodash-es/toLower.js
  init_define_process();
  function toLower(value) {
    return toString_default(value).toLowerCase();
  }
  var toLower_default = toLower;

  // node_modules/lodash-es/toPath.js
  init_define_process();
  function toPath(value) {
    if (isArray_default(value)) {
      return arrayMap_default(value, toKey_default);
    }
    return isSymbol_default(value) ? [value] : copyArray_default(stringToPath_default(toString_default(value)));
  }
  var toPath_default = toPath;

  // node_modules/lodash-es/toSafeInteger.js
  init_define_process();
  var MAX_SAFE_INTEGER6 = 9007199254740991;
  function toSafeInteger(value) {
    return value ? baseClamp_default(toInteger_default(value), -MAX_SAFE_INTEGER6, MAX_SAFE_INTEGER6) : value === 0 ? value : 0;
  }
  var toSafeInteger_default = toSafeInteger;

  // node_modules/lodash-es/toUpper.js
  init_define_process();
  function toUpper(value) {
    return toString_default(value).toUpperCase();
  }
  var toUpper_default = toUpper;

  // node_modules/lodash-es/transform.js
  init_define_process();
  function transform(object, iteratee2, accumulator) {
    var isArr = isArray_default(object), isArrLike = isArr || isBuffer_default(object) || isTypedArray_default(object);
    iteratee2 = baseIteratee_default(iteratee2, 4);
    if (accumulator == null) {
      var Ctor = object && object.constructor;
      if (isArrLike) {
        accumulator = isArr ? new Ctor() : [];
      } else if (isObject_default(object)) {
        accumulator = isFunction_default(Ctor) ? baseCreate_default(getPrototype_default(object)) : {};
      } else {
        accumulator = {};
      }
    }
    (isArrLike ? arrayEach_default : baseForOwn_default)(object, function(value, index, object2) {
      return iteratee2(accumulator, value, index, object2);
    });
    return accumulator;
  }
  var transform_default = transform;

  // node_modules/lodash-es/trim.js
  init_define_process();

  // node_modules/lodash-es/_charsEndIndex.js
  init_define_process();
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while (index-- && baseIndexOf_default(chrSymbols, strSymbols[index], 0) > -1) {
    }
    return index;
  }
  var charsEndIndex_default = charsEndIndex;

  // node_modules/lodash-es/_charsStartIndex.js
  init_define_process();
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while (++index < length && baseIndexOf_default(chrSymbols, strSymbols[index], 0) > -1) {
    }
    return index;
  }
  var charsStartIndex_default = charsStartIndex;

  // node_modules/lodash-es/trim.js
  function trim(string, chars, guard) {
    string = toString_default(string);
    if (string && (guard || chars === void 0)) {
      return baseTrim_default(string);
    }
    if (!string || !(chars = baseToString_default(chars))) {
      return string;
    }
    var strSymbols = stringToArray_default(string), chrSymbols = stringToArray_default(chars), start = charsStartIndex_default(strSymbols, chrSymbols), end = charsEndIndex_default(strSymbols, chrSymbols) + 1;
    return castSlice_default(strSymbols, start, end).join("");
  }
  var trim_default = trim;

  // node_modules/lodash-es/trimEnd.js
  init_define_process();
  function trimEnd(string, chars, guard) {
    string = toString_default(string);
    if (string && (guard || chars === void 0)) {
      return string.slice(0, trimmedEndIndex_default(string) + 1);
    }
    if (!string || !(chars = baseToString_default(chars))) {
      return string;
    }
    var strSymbols = stringToArray_default(string), end = charsEndIndex_default(strSymbols, stringToArray_default(chars)) + 1;
    return castSlice_default(strSymbols, 0, end).join("");
  }
  var trimEnd_default = trimEnd;

  // node_modules/lodash-es/trimStart.js
  init_define_process();
  var reTrimStart3 = /^\s+/;
  function trimStart(string, chars, guard) {
    string = toString_default(string);
    if (string && (guard || chars === void 0)) {
      return string.replace(reTrimStart3, "");
    }
    if (!string || !(chars = baseToString_default(chars))) {
      return string;
    }
    var strSymbols = stringToArray_default(string), start = charsStartIndex_default(strSymbols, stringToArray_default(chars));
    return castSlice_default(strSymbols, start).join("");
  }
  var trimStart_default = trimStart;

  // node_modules/lodash-es/truncate.js
  init_define_process();
  var DEFAULT_TRUNC_LENGTH = 30;
  var DEFAULT_TRUNC_OMISSION = "...";
  var reFlags2 = /\w*$/;
  function truncate(string, options) {
    var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
    if (isObject_default(options)) {
      var separator = "separator" in options ? options.separator : separator;
      length = "length" in options ? toInteger_default(options.length) : length;
      omission = "omission" in options ? baseToString_default(options.omission) : omission;
    }
    string = toString_default(string);
    var strLength = string.length;
    if (hasUnicode_default(string)) {
      var strSymbols = stringToArray_default(string);
      strLength = strSymbols.length;
    }
    if (length >= strLength) {
      return string;
    }
    var end = length - stringSize_default(omission);
    if (end < 1) {
      return omission;
    }
    var result2 = strSymbols ? castSlice_default(strSymbols, 0, end).join("") : string.slice(0, end);
    if (separator === void 0) {
      return result2 + omission;
    }
    if (strSymbols) {
      end += result2.length - end;
    }
    if (isRegExp_default(separator)) {
      if (string.slice(end).search(separator)) {
        var match, substring = result2;
        if (!separator.global) {
          separator = RegExp(separator.source, toString_default(reFlags2.exec(separator)) + "g");
        }
        separator.lastIndex = 0;
        while (match = separator.exec(substring)) {
          var newEnd = match.index;
        }
        result2 = result2.slice(0, newEnd === void 0 ? end : newEnd);
      }
    } else if (string.indexOf(baseToString_default(separator), end) != end) {
      var index = result2.lastIndexOf(separator);
      if (index > -1) {
        result2 = result2.slice(0, index);
      }
    }
    return result2 + omission;
  }
  var truncate_default = truncate;

  // node_modules/lodash-es/unary.js
  init_define_process();
  function unary(func) {
    return ary_default(func, 1);
  }
  var unary_default = unary;

  // node_modules/lodash-es/unescape.js
  init_define_process();

  // node_modules/lodash-es/_unescapeHtmlChar.js
  init_define_process();
  var htmlUnescapes = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
  };
  var unescapeHtmlChar = basePropertyOf_default(htmlUnescapes);
  var unescapeHtmlChar_default = unescapeHtmlChar;

  // node_modules/lodash-es/unescape.js
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g;
  var reHasEscapedHtml = RegExp(reEscapedHtml.source);
  function unescape(string) {
    string = toString_default(string);
    return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar_default) : string;
  }
  var unescape_default = unescape;

  // node_modules/lodash-es/union.js
  init_define_process();

  // node_modules/lodash-es/_baseUniq.js
  init_define_process();

  // node_modules/lodash-es/_createSet.js
  init_define_process();
  var INFINITY6 = 1 / 0;
  var createSet = !(Set_default && 1 / setToArray_default(new Set_default([, -0]))[1] == INFINITY6) ? noop_default : function(values2) {
    return new Set_default(values2);
  };
  var createSet_default = createSet;

  // node_modules/lodash-es/_baseUniq.js
  var LARGE_ARRAY_SIZE3 = 200;
  function baseUniq(array, iteratee2, comparator) {
    var index = -1, includes2 = arrayIncludes_default, length = array.length, isCommon = true, result2 = [], seen = result2;
    if (comparator) {
      isCommon = false;
      includes2 = arrayIncludesWith_default;
    } else if (length >= LARGE_ARRAY_SIZE3) {
      var set2 = iteratee2 ? null : createSet_default(array);
      if (set2) {
        return setToArray_default(set2);
      }
      isCommon = false;
      includes2 = cacheHas_default;
      seen = new SetCache_default();
    } else {
      seen = iteratee2 ? [] : result2;
    }
    outer:
      while (++index < length) {
        var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee2) {
            seen.push(computed);
          }
          result2.push(value);
        } else if (!includes2(seen, computed, comparator)) {
          if (seen !== result2) {
            seen.push(computed);
          }
          result2.push(value);
        }
      }
    return result2;
  }
  var baseUniq_default = baseUniq;

  // node_modules/lodash-es/union.js
  var union = baseRest_default(function(arrays) {
    return baseUniq_default(baseFlatten_default(arrays, 1, isArrayLikeObject_default, true));
  });
  var union_default = union;

  // node_modules/lodash-es/unionBy.js
  init_define_process();
  var unionBy = baseRest_default(function(arrays) {
    var iteratee2 = last_default(arrays);
    if (isArrayLikeObject_default(iteratee2)) {
      iteratee2 = void 0;
    }
    return baseUniq_default(baseFlatten_default(arrays, 1, isArrayLikeObject_default, true), baseIteratee_default(iteratee2, 2));
  });
  var unionBy_default = unionBy;

  // node_modules/lodash-es/unionWith.js
  init_define_process();
  var unionWith = baseRest_default(function(arrays) {
    var comparator = last_default(arrays);
    comparator = typeof comparator == "function" ? comparator : void 0;
    return baseUniq_default(baseFlatten_default(arrays, 1, isArrayLikeObject_default, true), void 0, comparator);
  });
  var unionWith_default = unionWith;

  // node_modules/lodash-es/uniq.js
  init_define_process();
  function uniq(array) {
    return array && array.length ? baseUniq_default(array) : [];
  }
  var uniq_default = uniq;

  // node_modules/lodash-es/uniqBy.js
  init_define_process();
  function uniqBy(array, iteratee2) {
    return array && array.length ? baseUniq_default(array, baseIteratee_default(iteratee2, 2)) : [];
  }
  var uniqBy_default = uniqBy;

  // node_modules/lodash-es/uniqWith.js
  init_define_process();
  function uniqWith(array, comparator) {
    comparator = typeof comparator == "function" ? comparator : void 0;
    return array && array.length ? baseUniq_default(array, void 0, comparator) : [];
  }
  var uniqWith_default = uniqWith;

  // node_modules/lodash-es/uniqueId.js
  init_define_process();
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter;
    return toString_default(prefix) + id;
  }
  var uniqueId_default = uniqueId;

  // node_modules/lodash-es/unset.js
  init_define_process();
  function unset(object, path) {
    return object == null ? true : baseUnset_default(object, path);
  }
  var unset_default = unset;

  // node_modules/lodash-es/unzip.js
  init_define_process();
  var nativeMax15 = Math.max;
  function unzip(array) {
    if (!(array && array.length)) {
      return [];
    }
    var length = 0;
    array = arrayFilter_default(array, function(group) {
      if (isArrayLikeObject_default(group)) {
        length = nativeMax15(group.length, length);
        return true;
      }
    });
    return baseTimes_default(length, function(index) {
      return arrayMap_default(array, baseProperty_default(index));
    });
  }
  var unzip_default = unzip;

  // node_modules/lodash-es/unzipWith.js
  init_define_process();
  function unzipWith(array, iteratee2) {
    if (!(array && array.length)) {
      return [];
    }
    var result2 = unzip_default(array);
    if (iteratee2 == null) {
      return result2;
    }
    return arrayMap_default(result2, function(group) {
      return apply_default(iteratee2, void 0, group);
    });
  }
  var unzipWith_default = unzipWith;

  // node_modules/lodash-es/update.js
  init_define_process();

  // node_modules/lodash-es/_baseUpdate.js
  init_define_process();
  function baseUpdate(object, path, updater, customizer) {
    return baseSet_default(object, path, updater(baseGet_default(object, path)), customizer);
  }
  var baseUpdate_default = baseUpdate;

  // node_modules/lodash-es/update.js
  function update(object, path, updater) {
    return object == null ? object : baseUpdate_default(object, path, castFunction_default(updater));
  }
  var update_default = update;

  // node_modules/lodash-es/updateWith.js
  init_define_process();
  function updateWith(object, path, updater, customizer) {
    customizer = typeof customizer == "function" ? customizer : void 0;
    return object == null ? object : baseUpdate_default(object, path, castFunction_default(updater), customizer);
  }
  var updateWith_default = updateWith;

  // node_modules/lodash-es/upperCase.js
  init_define_process();
  var upperCase = createCompounder_default(function(result2, word, index) {
    return result2 + (index ? " " : "") + word.toUpperCase();
  });
  var upperCase_default = upperCase;

  // node_modules/lodash-es/valueOf.js
  init_define_process();

  // node_modules/lodash-es/valuesIn.js
  init_define_process();
  function valuesIn(object) {
    return object == null ? [] : baseValues_default(object, keysIn_default(object));
  }
  var valuesIn_default = valuesIn;

  // node_modules/lodash-es/without.js
  init_define_process();
  var without = baseRest_default(function(array, values2) {
    return isArrayLikeObject_default(array) ? baseDifference_default(array, values2) : [];
  });
  var without_default = without;

  // node_modules/lodash-es/wrap.js
  init_define_process();
  function wrap(value, wrapper) {
    return partial_default(castFunction_default(wrapper), value);
  }
  var wrap_default = wrap;

  // node_modules/lodash-es/wrapperAt.js
  init_define_process();
  var wrapperAt = flatRest_default(function(paths) {
    var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
      return baseAt_default(object, paths);
    };
    if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper_default) || !isIndex_default(start)) {
      return this.thru(interceptor);
    }
    value = value.slice(start, +start + (length ? 1 : 0));
    value.__actions__.push({
      "func": thru_default,
      "args": [interceptor],
      "thisArg": void 0
    });
    return new LodashWrapper_default(value, this.__chain__).thru(function(array) {
      if (length && !array.length) {
        array.push(void 0);
      }
      return array;
    });
  });
  var wrapperAt_default = wrapperAt;

  // node_modules/lodash-es/wrapperChain.js
  init_define_process();
  function wrapperChain() {
    return chain_default(this);
  }
  var wrapperChain_default = wrapperChain;

  // node_modules/lodash-es/wrapperReverse.js
  init_define_process();
  function wrapperReverse() {
    var value = this.__wrapped__;
    if (value instanceof LazyWrapper_default) {
      var wrapped = value;
      if (this.__actions__.length) {
        wrapped = new LazyWrapper_default(this);
      }
      wrapped = wrapped.reverse();
      wrapped.__actions__.push({
        "func": thru_default,
        "args": [reverse_default],
        "thisArg": void 0
      });
      return new LodashWrapper_default(wrapped, this.__chain__);
    }
    return this.thru(reverse_default);
  }
  var wrapperReverse_default = wrapperReverse;

  // node_modules/lodash-es/xor.js
  init_define_process();

  // node_modules/lodash-es/_baseXor.js
  init_define_process();
  function baseXor(arrays, iteratee2, comparator) {
    var length = arrays.length;
    if (length < 2) {
      return length ? baseUniq_default(arrays[0]) : [];
    }
    var index = -1, result2 = Array(length);
    while (++index < length) {
      var array = arrays[index], othIndex = -1;
      while (++othIndex < length) {
        if (othIndex != index) {
          result2[index] = baseDifference_default(result2[index] || array, arrays[othIndex], iteratee2, comparator);
        }
      }
    }
    return baseUniq_default(baseFlatten_default(result2, 1), iteratee2, comparator);
  }
  var baseXor_default = baseXor;

  // node_modules/lodash-es/xor.js
  var xor = baseRest_default(function(arrays) {
    return baseXor_default(arrayFilter_default(arrays, isArrayLikeObject_default));
  });
  var xor_default = xor;

  // node_modules/lodash-es/xorBy.js
  init_define_process();
  var xorBy = baseRest_default(function(arrays) {
    var iteratee2 = last_default(arrays);
    if (isArrayLikeObject_default(iteratee2)) {
      iteratee2 = void 0;
    }
    return baseXor_default(arrayFilter_default(arrays, isArrayLikeObject_default), baseIteratee_default(iteratee2, 2));
  });
  var xorBy_default = xorBy;

  // node_modules/lodash-es/xorWith.js
  init_define_process();
  var xorWith = baseRest_default(function(arrays) {
    var comparator = last_default(arrays);
    comparator = typeof comparator == "function" ? comparator : void 0;
    return baseXor_default(arrayFilter_default(arrays, isArrayLikeObject_default), void 0, comparator);
  });
  var xorWith_default = xorWith;

  // node_modules/lodash-es/zip.js
  init_define_process();
  var zip = baseRest_default(unzip_default);
  var zip_default = zip;

  // node_modules/lodash-es/zipObject.js
  init_define_process();

  // node_modules/lodash-es/_baseZipObject.js
  init_define_process();
  function baseZipObject(props, values2, assignFunc) {
    var index = -1, length = props.length, valsLength = values2.length, result2 = {};
    while (++index < length) {
      var value = index < valsLength ? values2[index] : void 0;
      assignFunc(result2, props[index], value);
    }
    return result2;
  }
  var baseZipObject_default = baseZipObject;

  // node_modules/lodash-es/zipObject.js
  function zipObject(props, values2) {
    return baseZipObject_default(props || [], values2 || [], assignValue_default);
  }
  var zipObject_default = zipObject;

  // node_modules/lodash-es/zipObjectDeep.js
  init_define_process();
  function zipObjectDeep(props, values2) {
    return baseZipObject_default(props || [], values2 || [], baseSet_default);
  }
  var zipObjectDeep_default = zipObjectDeep;

  // node_modules/lodash-es/zipWith.js
  init_define_process();
  var zipWith = baseRest_default(function(arrays) {
    var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : void 0;
    iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : void 0;
    return unzipWith_default(arrays, iteratee2);
  });
  var zipWith_default = zipWith;

  // node_modules/lodash-es/lodash.default.js
  init_define_process();

  // node_modules/lodash-es/array.js
  init_define_process();

  // node_modules/lodash-es/array.default.js
  init_define_process();
  var array_default_default = {
    chunk: chunk_default,
    compact: compact_default,
    concat: concat_default,
    difference: difference_default,
    differenceBy: differenceBy_default,
    differenceWith: differenceWith_default,
    drop: drop_default,
    dropRight: dropRight_default,
    dropRightWhile: dropRightWhile_default,
    dropWhile: dropWhile_default,
    fill: fill_default,
    findIndex: findIndex_default,
    findLastIndex: findLastIndex_default,
    first: head_default,
    flatten: flatten_default,
    flattenDeep: flattenDeep_default,
    flattenDepth: flattenDepth_default,
    fromPairs: fromPairs_default,
    head: head_default,
    indexOf: indexOf_default,
    initial: initial_default,
    intersection: intersection_default,
    intersectionBy: intersectionBy_default,
    intersectionWith: intersectionWith_default,
    join: join_default,
    last: last_default,
    lastIndexOf: lastIndexOf_default,
    nth: nth_default,
    pull: pull_default,
    pullAll: pullAll_default,
    pullAllBy: pullAllBy_default,
    pullAllWith: pullAllWith_default,
    pullAt: pullAt_default,
    remove: remove_default,
    reverse: reverse_default,
    slice: slice_default,
    sortedIndex: sortedIndex_default,
    sortedIndexBy: sortedIndexBy_default,
    sortedIndexOf: sortedIndexOf_default,
    sortedLastIndex: sortedLastIndex_default,
    sortedLastIndexBy: sortedLastIndexBy_default,
    sortedLastIndexOf: sortedLastIndexOf_default,
    sortedUniq: sortedUniq_default,
    sortedUniqBy: sortedUniqBy_default,
    tail: tail_default,
    take: take_default,
    takeRight: takeRight_default,
    takeRightWhile: takeRightWhile_default,
    takeWhile: takeWhile_default,
    union: union_default,
    unionBy: unionBy_default,
    unionWith: unionWith_default,
    uniq: uniq_default,
    uniqBy: uniqBy_default,
    uniqWith: uniqWith_default,
    unzip: unzip_default,
    unzipWith: unzipWith_default,
    without: without_default,
    xor: xor_default,
    xorBy: xorBy_default,
    xorWith: xorWith_default,
    zip: zip_default,
    zipObject: zipObject_default,
    zipObjectDeep: zipObjectDeep_default,
    zipWith: zipWith_default
  };

  // node_modules/lodash-es/collection.js
  init_define_process();

  // node_modules/lodash-es/collection.default.js
  init_define_process();
  var collection_default_default = {
    countBy: countBy_default,
    each: forEach_default,
    eachRight: forEachRight_default,
    every: every_default,
    filter: filter_default,
    find: find_default,
    findLast: findLast_default,
    flatMap: flatMap_default,
    flatMapDeep: flatMapDeep_default,
    flatMapDepth: flatMapDepth_default,
    forEach: forEach_default,
    forEachRight: forEachRight_default,
    groupBy: groupBy_default,
    includes: includes_default,
    invokeMap: invokeMap_default,
    keyBy: keyBy_default,
    map: map_default,
    orderBy: orderBy_default,
    partition: partition_default,
    reduce: reduce_default,
    reduceRight: reduceRight_default,
    reject: reject_default,
    sample: sample_default,
    sampleSize: sampleSize_default,
    shuffle: shuffle_default,
    size: size_default,
    some: some_default,
    sortBy: sortBy_default
  };

  // node_modules/lodash-es/date.js
  init_define_process();

  // node_modules/lodash-es/date.default.js
  init_define_process();
  var date_default_default = {
    now: now_default
  };

  // node_modules/lodash-es/function.js
  init_define_process();

  // node_modules/lodash-es/function.default.js
  init_define_process();
  var function_default_default = {
    after: after_default,
    ary: ary_default,
    before: before_default,
    bind: bind_default,
    bindKey: bindKey_default,
    curry: curry_default,
    curryRight: curryRight_default,
    debounce: debounce_default,
    defer: defer_default,
    delay: delay_default,
    flip: flip_default,
    memoize: memoize_default,
    negate: negate_default,
    once: once_default,
    overArgs: overArgs_default,
    partial: partial_default,
    partialRight: partialRight_default,
    rearg: rearg_default,
    rest: rest_default,
    spread: spread_default,
    throttle: throttle_default,
    unary: unary_default,
    wrap: wrap_default
  };

  // node_modules/lodash-es/lang.js
  init_define_process();

  // node_modules/lodash-es/lang.default.js
  init_define_process();
  var lang_default_default = {
    castArray: castArray_default,
    clone: clone_default,
    cloneDeep: cloneDeep_default,
    cloneDeepWith: cloneDeepWith_default,
    cloneWith: cloneWith_default,
    conformsTo: conformsTo_default,
    eq: eq_default,
    gt: gt_default,
    gte: gte_default,
    isArguments: isArguments_default,
    isArray: isArray_default,
    isArrayBuffer: isArrayBuffer_default,
    isArrayLike: isArrayLike_default,
    isArrayLikeObject: isArrayLikeObject_default,
    isBoolean: isBoolean_default,
    isBuffer: isBuffer_default,
    isDate: isDate_default,
    isElement: isElement_default,
    isEmpty: isEmpty_default,
    isEqual: isEqual_default,
    isEqualWith: isEqualWith_default,
    isError: isError_default,
    isFinite: isFinite_default,
    isFunction: isFunction_default,
    isInteger: isInteger_default,
    isLength: isLength_default,
    isMap: isMap_default,
    isMatch: isMatch_default,
    isMatchWith: isMatchWith_default,
    isNaN: isNaN_default,
    isNative: isNative_default,
    isNil: isNil_default,
    isNull: isNull_default,
    isNumber: isNumber_default,
    isObject: isObject_default,
    isObjectLike: isObjectLike_default,
    isPlainObject: isPlainObject_default,
    isRegExp: isRegExp_default,
    isSafeInteger: isSafeInteger_default,
    isSet: isSet_default,
    isString: isString_default,
    isSymbol: isSymbol_default,
    isTypedArray: isTypedArray_default,
    isUndefined: isUndefined_default,
    isWeakMap: isWeakMap_default,
    isWeakSet: isWeakSet_default,
    lt: lt_default,
    lte: lte_default,
    toArray: toArray_default,
    toFinite: toFinite_default,
    toInteger: toInteger_default,
    toLength: toLength_default,
    toNumber: toNumber_default,
    toPlainObject: toPlainObject_default,
    toSafeInteger: toSafeInteger_default,
    toString: toString_default
  };

  // node_modules/lodash-es/math.js
  init_define_process();

  // node_modules/lodash-es/math.default.js
  init_define_process();
  var math_default_default = {
    add: add_default,
    ceil: ceil_default,
    divide: divide_default,
    floor: floor_default,
    max: max_default,
    maxBy: maxBy_default,
    mean: mean_default,
    meanBy: meanBy_default,
    min: min_default,
    minBy: minBy_default,
    multiply: multiply_default,
    round: round_default,
    subtract: subtract_default,
    sum: sum_default,
    sumBy: sumBy_default
  };

  // node_modules/lodash-es/number.js
  init_define_process();

  // node_modules/lodash-es/number.default.js
  init_define_process();
  var number_default_default = {
    clamp: clamp_default,
    inRange: inRange_default,
    random: random_default
  };

  // node_modules/lodash-es/object.js
  init_define_process();

  // node_modules/lodash-es/object.default.js
  init_define_process();
  var object_default_default = {
    assign: assign_default,
    assignIn: assignIn_default,
    assignInWith: assignInWith_default,
    assignWith: assignWith_default,
    at: at_default,
    create: create_default,
    defaults: defaults_default,
    defaultsDeep: defaultsDeep_default,
    entries: toPairs_default,
    entriesIn: toPairsIn_default,
    extend: assignIn_default,
    extendWith: assignInWith_default,
    findKey: findKey_default,
    findLastKey: findLastKey_default,
    forIn: forIn_default,
    forInRight: forInRight_default,
    forOwn: forOwn_default,
    forOwnRight: forOwnRight_default,
    functions: functions_default,
    functionsIn: functionsIn_default,
    get: get_default,
    has: has_default,
    hasIn: hasIn_default,
    invert: invert_default,
    invertBy: invertBy_default,
    invoke: invoke_default,
    keys: keys_default,
    keysIn: keysIn_default,
    mapKeys: mapKeys_default,
    mapValues: mapValues_default,
    merge: merge_default,
    mergeWith: mergeWith_default,
    omit: omit_default,
    omitBy: omitBy_default,
    pick: pick_default,
    pickBy: pickBy_default,
    result: result_default,
    set: set_default,
    setWith: setWith_default,
    toPairs: toPairs_default,
    toPairsIn: toPairsIn_default,
    transform: transform_default,
    unset: unset_default,
    update: update_default,
    updateWith: updateWith_default,
    values: values_default,
    valuesIn: valuesIn_default
  };

  // node_modules/lodash-es/seq.js
  init_define_process();

  // node_modules/lodash-es/seq.default.js
  init_define_process();
  var seq_default_default = {
    at: wrapperAt_default,
    chain: chain_default,
    commit: commit_default,
    lodash: wrapperLodash_default,
    next: next_default,
    plant: plant_default,
    reverse: wrapperReverse_default,
    tap: tap_default,
    thru: thru_default,
    toIterator: toIterator_default,
    toJSON: wrapperValue_default,
    value: wrapperValue_default,
    valueOf: wrapperValue_default,
    wrapperChain: wrapperChain_default
  };

  // node_modules/lodash-es/string.js
  init_define_process();

  // node_modules/lodash-es/string.default.js
  init_define_process();
  var string_default_default = {
    camelCase: camelCase_default,
    capitalize: capitalize_default,
    deburr: deburr_default,
    endsWith: endsWith_default,
    escape: escape_default,
    escapeRegExp: escapeRegExp_default,
    kebabCase: kebabCase_default,
    lowerCase: lowerCase_default,
    lowerFirst: lowerFirst_default,
    pad: pad_default,
    padEnd: padEnd_default,
    padStart: padStart_default,
    parseInt: parseInt_default,
    repeat: repeat_default,
    replace: replace_default,
    snakeCase: snakeCase_default,
    split: split_default,
    startCase: startCase_default,
    startsWith: startsWith_default,
    template: template_default,
    templateSettings: templateSettings_default,
    toLower: toLower_default,
    toUpper: toUpper_default,
    trim: trim_default,
    trimEnd: trimEnd_default,
    trimStart: trimStart_default,
    truncate: truncate_default,
    unescape: unescape_default,
    upperCase: upperCase_default,
    upperFirst: upperFirst_default,
    words: words_default
  };

  // node_modules/lodash-es/util.js
  init_define_process();

  // node_modules/lodash-es/util.default.js
  init_define_process();
  var util_default_default = {
    attempt: attempt_default,
    bindAll: bindAll_default,
    cond: cond_default,
    conforms: conforms_default,
    constant: constant_default,
    defaultTo: defaultTo_default,
    flow: flow_default,
    flowRight: flowRight_default,
    identity: identity_default,
    iteratee: iteratee_default,
    matches: matches_default,
    matchesProperty: matchesProperty_default,
    method: method_default,
    methodOf: methodOf_default,
    mixin: mixin_default,
    noop: noop_default,
    nthArg: nthArg_default,
    over: over_default,
    overEvery: overEvery_default,
    overSome: overSome_default,
    property: property_default,
    propertyOf: propertyOf_default,
    range: range_default,
    rangeRight: rangeRight_default,
    stubArray: stubArray_default,
    stubFalse: stubFalse_default,
    stubObject: stubObject_default,
    stubString: stubString_default,
    stubTrue: stubTrue_default,
    times: times_default,
    toPath: toPath_default,
    uniqueId: uniqueId_default
  };

  // node_modules/lodash-es/_lazyClone.js
  init_define_process();
  function lazyClone() {
    var result2 = new LazyWrapper_default(this.__wrapped__);
    result2.__actions__ = copyArray_default(this.__actions__);
    result2.__dir__ = this.__dir__;
    result2.__filtered__ = this.__filtered__;
    result2.__iteratees__ = copyArray_default(this.__iteratees__);
    result2.__takeCount__ = this.__takeCount__;
    result2.__views__ = copyArray_default(this.__views__);
    return result2;
  }
  var lazyClone_default = lazyClone;

  // node_modules/lodash-es/_lazyReverse.js
  init_define_process();
  function lazyReverse() {
    if (this.__filtered__) {
      var result2 = new LazyWrapper_default(this);
      result2.__dir__ = -1;
      result2.__filtered__ = true;
    } else {
      result2 = this.clone();
      result2.__dir__ *= -1;
    }
    return result2;
  }
  var lazyReverse_default = lazyReverse;

  // node_modules/lodash-es/_lazyValue.js
  init_define_process();

  // node_modules/lodash-es/_getView.js
  init_define_process();
  var nativeMax16 = Math.max;
  var nativeMin13 = Math.min;
  function getView(start, end, transforms) {
    var index = -1, length = transforms.length;
    while (++index < length) {
      var data = transforms[index], size2 = data.size;
      switch (data.type) {
        case "drop":
          start += size2;
          break;
        case "dropRight":
          end -= size2;
          break;
        case "take":
          end = nativeMin13(end, start + size2);
          break;
        case "takeRight":
          start = nativeMax16(start, end - size2);
          break;
      }
    }
    return { "start": start, "end": end };
  }
  var getView_default = getView;

  // node_modules/lodash-es/_lazyValue.js
  var LAZY_FILTER_FLAG = 1;
  var LAZY_MAP_FLAG = 2;
  var nativeMin14 = Math.min;
  function lazyValue() {
    var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray_default(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView_default(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin14(length, this.__takeCount__);
    if (!isArr || !isRight && arrLength == length && takeCount == length) {
      return baseWrapperValue_default(array, this.__actions__);
    }
    var result2 = [];
    outer:
      while (length-- && resIndex < takeCount) {
        index += dir;
        var iterIndex = -1, value = array[index];
        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result2[resIndex++] = value;
      }
    return result2;
  }
  var lazyValue_default = lazyValue;

  // node_modules/lodash-es/lodash.default.js
  var VERSION = "4.17.21";
  var WRAP_BIND_KEY_FLAG7 = 2;
  var LAZY_FILTER_FLAG2 = 1;
  var LAZY_WHILE_FLAG = 3;
  var MAX_ARRAY_LENGTH7 = 4294967295;
  var arrayProto6 = Array.prototype;
  var objectProto29 = Object.prototype;
  var hasOwnProperty25 = objectProto29.hasOwnProperty;
  var symIterator2 = Symbol_default ? Symbol_default.iterator : void 0;
  var nativeMax17 = Math.max;
  var nativeMin15 = Math.min;
  var mixin2 = function(func) {
    return function(object, source, options) {
      if (options == null) {
        var isObj = isObject_default(source), props = isObj && keys_default(source), methodNames = props && props.length && baseFunctions_default(source, props);
        if (!(methodNames ? methodNames.length : isObj)) {
          options = source;
          source = object;
          object = this;
        }
      }
      return func(object, source, options);
    };
  }(mixin_default);
  wrapperLodash_default.after = function_default_default.after;
  wrapperLodash_default.ary = function_default_default.ary;
  wrapperLodash_default.assign = object_default_default.assign;
  wrapperLodash_default.assignIn = object_default_default.assignIn;
  wrapperLodash_default.assignInWith = object_default_default.assignInWith;
  wrapperLodash_default.assignWith = object_default_default.assignWith;
  wrapperLodash_default.at = object_default_default.at;
  wrapperLodash_default.before = function_default_default.before;
  wrapperLodash_default.bind = function_default_default.bind;
  wrapperLodash_default.bindAll = util_default_default.bindAll;
  wrapperLodash_default.bindKey = function_default_default.bindKey;
  wrapperLodash_default.castArray = lang_default_default.castArray;
  wrapperLodash_default.chain = seq_default_default.chain;
  wrapperLodash_default.chunk = array_default_default.chunk;
  wrapperLodash_default.compact = array_default_default.compact;
  wrapperLodash_default.concat = array_default_default.concat;
  wrapperLodash_default.cond = util_default_default.cond;
  wrapperLodash_default.conforms = util_default_default.conforms;
  wrapperLodash_default.constant = util_default_default.constant;
  wrapperLodash_default.countBy = collection_default_default.countBy;
  wrapperLodash_default.create = object_default_default.create;
  wrapperLodash_default.curry = function_default_default.curry;
  wrapperLodash_default.curryRight = function_default_default.curryRight;
  wrapperLodash_default.debounce = function_default_default.debounce;
  wrapperLodash_default.defaults = object_default_default.defaults;
  wrapperLodash_default.defaultsDeep = object_default_default.defaultsDeep;
  wrapperLodash_default.defer = function_default_default.defer;
  wrapperLodash_default.delay = function_default_default.delay;
  wrapperLodash_default.difference = array_default_default.difference;
  wrapperLodash_default.differenceBy = array_default_default.differenceBy;
  wrapperLodash_default.differenceWith = array_default_default.differenceWith;
  wrapperLodash_default.drop = array_default_default.drop;
  wrapperLodash_default.dropRight = array_default_default.dropRight;
  wrapperLodash_default.dropRightWhile = array_default_default.dropRightWhile;
  wrapperLodash_default.dropWhile = array_default_default.dropWhile;
  wrapperLodash_default.fill = array_default_default.fill;
  wrapperLodash_default.filter = collection_default_default.filter;
  wrapperLodash_default.flatMap = collection_default_default.flatMap;
  wrapperLodash_default.flatMapDeep = collection_default_default.flatMapDeep;
  wrapperLodash_default.flatMapDepth = collection_default_default.flatMapDepth;
  wrapperLodash_default.flatten = array_default_default.flatten;
  wrapperLodash_default.flattenDeep = array_default_default.flattenDeep;
  wrapperLodash_default.flattenDepth = array_default_default.flattenDepth;
  wrapperLodash_default.flip = function_default_default.flip;
  wrapperLodash_default.flow = util_default_default.flow;
  wrapperLodash_default.flowRight = util_default_default.flowRight;
  wrapperLodash_default.fromPairs = array_default_default.fromPairs;
  wrapperLodash_default.functions = object_default_default.functions;
  wrapperLodash_default.functionsIn = object_default_default.functionsIn;
  wrapperLodash_default.groupBy = collection_default_default.groupBy;
  wrapperLodash_default.initial = array_default_default.initial;
  wrapperLodash_default.intersection = array_default_default.intersection;
  wrapperLodash_default.intersectionBy = array_default_default.intersectionBy;
  wrapperLodash_default.intersectionWith = array_default_default.intersectionWith;
  wrapperLodash_default.invert = object_default_default.invert;
  wrapperLodash_default.invertBy = object_default_default.invertBy;
  wrapperLodash_default.invokeMap = collection_default_default.invokeMap;
  wrapperLodash_default.iteratee = util_default_default.iteratee;
  wrapperLodash_default.keyBy = collection_default_default.keyBy;
  wrapperLodash_default.keys = keys_default;
  wrapperLodash_default.keysIn = object_default_default.keysIn;
  wrapperLodash_default.map = collection_default_default.map;
  wrapperLodash_default.mapKeys = object_default_default.mapKeys;
  wrapperLodash_default.mapValues = object_default_default.mapValues;
  wrapperLodash_default.matches = util_default_default.matches;
  wrapperLodash_default.matchesProperty = util_default_default.matchesProperty;
  wrapperLodash_default.memoize = function_default_default.memoize;
  wrapperLodash_default.merge = object_default_default.merge;
  wrapperLodash_default.mergeWith = object_default_default.mergeWith;
  wrapperLodash_default.method = util_default_default.method;
  wrapperLodash_default.methodOf = util_default_default.methodOf;
  wrapperLodash_default.mixin = mixin2;
  wrapperLodash_default.negate = negate_default;
  wrapperLodash_default.nthArg = util_default_default.nthArg;
  wrapperLodash_default.omit = object_default_default.omit;
  wrapperLodash_default.omitBy = object_default_default.omitBy;
  wrapperLodash_default.once = function_default_default.once;
  wrapperLodash_default.orderBy = collection_default_default.orderBy;
  wrapperLodash_default.over = util_default_default.over;
  wrapperLodash_default.overArgs = function_default_default.overArgs;
  wrapperLodash_default.overEvery = util_default_default.overEvery;
  wrapperLodash_default.overSome = util_default_default.overSome;
  wrapperLodash_default.partial = function_default_default.partial;
  wrapperLodash_default.partialRight = function_default_default.partialRight;
  wrapperLodash_default.partition = collection_default_default.partition;
  wrapperLodash_default.pick = object_default_default.pick;
  wrapperLodash_default.pickBy = object_default_default.pickBy;
  wrapperLodash_default.property = util_default_default.property;
  wrapperLodash_default.propertyOf = util_default_default.propertyOf;
  wrapperLodash_default.pull = array_default_default.pull;
  wrapperLodash_default.pullAll = array_default_default.pullAll;
  wrapperLodash_default.pullAllBy = array_default_default.pullAllBy;
  wrapperLodash_default.pullAllWith = array_default_default.pullAllWith;
  wrapperLodash_default.pullAt = array_default_default.pullAt;
  wrapperLodash_default.range = util_default_default.range;
  wrapperLodash_default.rangeRight = util_default_default.rangeRight;
  wrapperLodash_default.rearg = function_default_default.rearg;
  wrapperLodash_default.reject = collection_default_default.reject;
  wrapperLodash_default.remove = array_default_default.remove;
  wrapperLodash_default.rest = function_default_default.rest;
  wrapperLodash_default.reverse = array_default_default.reverse;
  wrapperLodash_default.sampleSize = collection_default_default.sampleSize;
  wrapperLodash_default.set = object_default_default.set;
  wrapperLodash_default.setWith = object_default_default.setWith;
  wrapperLodash_default.shuffle = collection_default_default.shuffle;
  wrapperLodash_default.slice = array_default_default.slice;
  wrapperLodash_default.sortBy = collection_default_default.sortBy;
  wrapperLodash_default.sortedUniq = array_default_default.sortedUniq;
  wrapperLodash_default.sortedUniqBy = array_default_default.sortedUniqBy;
  wrapperLodash_default.split = string_default_default.split;
  wrapperLodash_default.spread = function_default_default.spread;
  wrapperLodash_default.tail = array_default_default.tail;
  wrapperLodash_default.take = array_default_default.take;
  wrapperLodash_default.takeRight = array_default_default.takeRight;
  wrapperLodash_default.takeRightWhile = array_default_default.takeRightWhile;
  wrapperLodash_default.takeWhile = array_default_default.takeWhile;
  wrapperLodash_default.tap = seq_default_default.tap;
  wrapperLodash_default.throttle = function_default_default.throttle;
  wrapperLodash_default.thru = thru_default;
  wrapperLodash_default.toArray = lang_default_default.toArray;
  wrapperLodash_default.toPairs = object_default_default.toPairs;
  wrapperLodash_default.toPairsIn = object_default_default.toPairsIn;
  wrapperLodash_default.toPath = util_default_default.toPath;
  wrapperLodash_default.toPlainObject = lang_default_default.toPlainObject;
  wrapperLodash_default.transform = object_default_default.transform;
  wrapperLodash_default.unary = function_default_default.unary;
  wrapperLodash_default.union = array_default_default.union;
  wrapperLodash_default.unionBy = array_default_default.unionBy;
  wrapperLodash_default.unionWith = array_default_default.unionWith;
  wrapperLodash_default.uniq = array_default_default.uniq;
  wrapperLodash_default.uniqBy = array_default_default.uniqBy;
  wrapperLodash_default.uniqWith = array_default_default.uniqWith;
  wrapperLodash_default.unset = object_default_default.unset;
  wrapperLodash_default.unzip = array_default_default.unzip;
  wrapperLodash_default.unzipWith = array_default_default.unzipWith;
  wrapperLodash_default.update = object_default_default.update;
  wrapperLodash_default.updateWith = object_default_default.updateWith;
  wrapperLodash_default.values = object_default_default.values;
  wrapperLodash_default.valuesIn = object_default_default.valuesIn;
  wrapperLodash_default.without = array_default_default.without;
  wrapperLodash_default.words = string_default_default.words;
  wrapperLodash_default.wrap = function_default_default.wrap;
  wrapperLodash_default.xor = array_default_default.xor;
  wrapperLodash_default.xorBy = array_default_default.xorBy;
  wrapperLodash_default.xorWith = array_default_default.xorWith;
  wrapperLodash_default.zip = array_default_default.zip;
  wrapperLodash_default.zipObject = array_default_default.zipObject;
  wrapperLodash_default.zipObjectDeep = array_default_default.zipObjectDeep;
  wrapperLodash_default.zipWith = array_default_default.zipWith;
  wrapperLodash_default.entries = object_default_default.toPairs;
  wrapperLodash_default.entriesIn = object_default_default.toPairsIn;
  wrapperLodash_default.extend = object_default_default.assignIn;
  wrapperLodash_default.extendWith = object_default_default.assignInWith;
  mixin2(wrapperLodash_default, wrapperLodash_default);
  wrapperLodash_default.add = math_default_default.add;
  wrapperLodash_default.attempt = util_default_default.attempt;
  wrapperLodash_default.camelCase = string_default_default.camelCase;
  wrapperLodash_default.capitalize = string_default_default.capitalize;
  wrapperLodash_default.ceil = math_default_default.ceil;
  wrapperLodash_default.clamp = number_default_default.clamp;
  wrapperLodash_default.clone = lang_default_default.clone;
  wrapperLodash_default.cloneDeep = lang_default_default.cloneDeep;
  wrapperLodash_default.cloneDeepWith = lang_default_default.cloneDeepWith;
  wrapperLodash_default.cloneWith = lang_default_default.cloneWith;
  wrapperLodash_default.conformsTo = lang_default_default.conformsTo;
  wrapperLodash_default.deburr = string_default_default.deburr;
  wrapperLodash_default.defaultTo = util_default_default.defaultTo;
  wrapperLodash_default.divide = math_default_default.divide;
  wrapperLodash_default.endsWith = string_default_default.endsWith;
  wrapperLodash_default.eq = lang_default_default.eq;
  wrapperLodash_default.escape = string_default_default.escape;
  wrapperLodash_default.escapeRegExp = string_default_default.escapeRegExp;
  wrapperLodash_default.every = collection_default_default.every;
  wrapperLodash_default.find = collection_default_default.find;
  wrapperLodash_default.findIndex = array_default_default.findIndex;
  wrapperLodash_default.findKey = object_default_default.findKey;
  wrapperLodash_default.findLast = collection_default_default.findLast;
  wrapperLodash_default.findLastIndex = array_default_default.findLastIndex;
  wrapperLodash_default.findLastKey = object_default_default.findLastKey;
  wrapperLodash_default.floor = math_default_default.floor;
  wrapperLodash_default.forEach = collection_default_default.forEach;
  wrapperLodash_default.forEachRight = collection_default_default.forEachRight;
  wrapperLodash_default.forIn = object_default_default.forIn;
  wrapperLodash_default.forInRight = object_default_default.forInRight;
  wrapperLodash_default.forOwn = object_default_default.forOwn;
  wrapperLodash_default.forOwnRight = object_default_default.forOwnRight;
  wrapperLodash_default.get = object_default_default.get;
  wrapperLodash_default.gt = lang_default_default.gt;
  wrapperLodash_default.gte = lang_default_default.gte;
  wrapperLodash_default.has = object_default_default.has;
  wrapperLodash_default.hasIn = object_default_default.hasIn;
  wrapperLodash_default.head = array_default_default.head;
  wrapperLodash_default.identity = identity_default;
  wrapperLodash_default.includes = collection_default_default.includes;
  wrapperLodash_default.indexOf = array_default_default.indexOf;
  wrapperLodash_default.inRange = number_default_default.inRange;
  wrapperLodash_default.invoke = object_default_default.invoke;
  wrapperLodash_default.isArguments = lang_default_default.isArguments;
  wrapperLodash_default.isArray = isArray_default;
  wrapperLodash_default.isArrayBuffer = lang_default_default.isArrayBuffer;
  wrapperLodash_default.isArrayLike = lang_default_default.isArrayLike;
  wrapperLodash_default.isArrayLikeObject = lang_default_default.isArrayLikeObject;
  wrapperLodash_default.isBoolean = lang_default_default.isBoolean;
  wrapperLodash_default.isBuffer = lang_default_default.isBuffer;
  wrapperLodash_default.isDate = lang_default_default.isDate;
  wrapperLodash_default.isElement = lang_default_default.isElement;
  wrapperLodash_default.isEmpty = lang_default_default.isEmpty;
  wrapperLodash_default.isEqual = lang_default_default.isEqual;
  wrapperLodash_default.isEqualWith = lang_default_default.isEqualWith;
  wrapperLodash_default.isError = lang_default_default.isError;
  wrapperLodash_default.isFinite = lang_default_default.isFinite;
  wrapperLodash_default.isFunction = lang_default_default.isFunction;
  wrapperLodash_default.isInteger = lang_default_default.isInteger;
  wrapperLodash_default.isLength = lang_default_default.isLength;
  wrapperLodash_default.isMap = lang_default_default.isMap;
  wrapperLodash_default.isMatch = lang_default_default.isMatch;
  wrapperLodash_default.isMatchWith = lang_default_default.isMatchWith;
  wrapperLodash_default.isNaN = lang_default_default.isNaN;
  wrapperLodash_default.isNative = lang_default_default.isNative;
  wrapperLodash_default.isNil = lang_default_default.isNil;
  wrapperLodash_default.isNull = lang_default_default.isNull;
  wrapperLodash_default.isNumber = lang_default_default.isNumber;
  wrapperLodash_default.isObject = isObject_default;
  wrapperLodash_default.isObjectLike = lang_default_default.isObjectLike;
  wrapperLodash_default.isPlainObject = lang_default_default.isPlainObject;
  wrapperLodash_default.isRegExp = lang_default_default.isRegExp;
  wrapperLodash_default.isSafeInteger = lang_default_default.isSafeInteger;
  wrapperLodash_default.isSet = lang_default_default.isSet;
  wrapperLodash_default.isString = lang_default_default.isString;
  wrapperLodash_default.isSymbol = lang_default_default.isSymbol;
  wrapperLodash_default.isTypedArray = lang_default_default.isTypedArray;
  wrapperLodash_default.isUndefined = lang_default_default.isUndefined;
  wrapperLodash_default.isWeakMap = lang_default_default.isWeakMap;
  wrapperLodash_default.isWeakSet = lang_default_default.isWeakSet;
  wrapperLodash_default.join = array_default_default.join;
  wrapperLodash_default.kebabCase = string_default_default.kebabCase;
  wrapperLodash_default.last = last_default;
  wrapperLodash_default.lastIndexOf = array_default_default.lastIndexOf;
  wrapperLodash_default.lowerCase = string_default_default.lowerCase;
  wrapperLodash_default.lowerFirst = string_default_default.lowerFirst;
  wrapperLodash_default.lt = lang_default_default.lt;
  wrapperLodash_default.lte = lang_default_default.lte;
  wrapperLodash_default.max = math_default_default.max;
  wrapperLodash_default.maxBy = math_default_default.maxBy;
  wrapperLodash_default.mean = math_default_default.mean;
  wrapperLodash_default.meanBy = math_default_default.meanBy;
  wrapperLodash_default.min = math_default_default.min;
  wrapperLodash_default.minBy = math_default_default.minBy;
  wrapperLodash_default.stubArray = util_default_default.stubArray;
  wrapperLodash_default.stubFalse = util_default_default.stubFalse;
  wrapperLodash_default.stubObject = util_default_default.stubObject;
  wrapperLodash_default.stubString = util_default_default.stubString;
  wrapperLodash_default.stubTrue = util_default_default.stubTrue;
  wrapperLodash_default.multiply = math_default_default.multiply;
  wrapperLodash_default.nth = array_default_default.nth;
  wrapperLodash_default.noop = util_default_default.noop;
  wrapperLodash_default.now = date_default_default.now;
  wrapperLodash_default.pad = string_default_default.pad;
  wrapperLodash_default.padEnd = string_default_default.padEnd;
  wrapperLodash_default.padStart = string_default_default.padStart;
  wrapperLodash_default.parseInt = string_default_default.parseInt;
  wrapperLodash_default.random = number_default_default.random;
  wrapperLodash_default.reduce = collection_default_default.reduce;
  wrapperLodash_default.reduceRight = collection_default_default.reduceRight;
  wrapperLodash_default.repeat = string_default_default.repeat;
  wrapperLodash_default.replace = string_default_default.replace;
  wrapperLodash_default.result = object_default_default.result;
  wrapperLodash_default.round = math_default_default.round;
  wrapperLodash_default.sample = collection_default_default.sample;
  wrapperLodash_default.size = collection_default_default.size;
  wrapperLodash_default.snakeCase = string_default_default.snakeCase;
  wrapperLodash_default.some = collection_default_default.some;
  wrapperLodash_default.sortedIndex = array_default_default.sortedIndex;
  wrapperLodash_default.sortedIndexBy = array_default_default.sortedIndexBy;
  wrapperLodash_default.sortedIndexOf = array_default_default.sortedIndexOf;
  wrapperLodash_default.sortedLastIndex = array_default_default.sortedLastIndex;
  wrapperLodash_default.sortedLastIndexBy = array_default_default.sortedLastIndexBy;
  wrapperLodash_default.sortedLastIndexOf = array_default_default.sortedLastIndexOf;
  wrapperLodash_default.startCase = string_default_default.startCase;
  wrapperLodash_default.startsWith = string_default_default.startsWith;
  wrapperLodash_default.subtract = math_default_default.subtract;
  wrapperLodash_default.sum = math_default_default.sum;
  wrapperLodash_default.sumBy = math_default_default.sumBy;
  wrapperLodash_default.template = string_default_default.template;
  wrapperLodash_default.times = util_default_default.times;
  wrapperLodash_default.toFinite = lang_default_default.toFinite;
  wrapperLodash_default.toInteger = toInteger_default;
  wrapperLodash_default.toLength = lang_default_default.toLength;
  wrapperLodash_default.toLower = string_default_default.toLower;
  wrapperLodash_default.toNumber = lang_default_default.toNumber;
  wrapperLodash_default.toSafeInteger = lang_default_default.toSafeInteger;
  wrapperLodash_default.toString = lang_default_default.toString;
  wrapperLodash_default.toUpper = string_default_default.toUpper;
  wrapperLodash_default.trim = string_default_default.trim;
  wrapperLodash_default.trimEnd = string_default_default.trimEnd;
  wrapperLodash_default.trimStart = string_default_default.trimStart;
  wrapperLodash_default.truncate = string_default_default.truncate;
  wrapperLodash_default.unescape = string_default_default.unescape;
  wrapperLodash_default.uniqueId = util_default_default.uniqueId;
  wrapperLodash_default.upperCase = string_default_default.upperCase;
  wrapperLodash_default.upperFirst = string_default_default.upperFirst;
  wrapperLodash_default.each = collection_default_default.forEach;
  wrapperLodash_default.eachRight = collection_default_default.forEachRight;
  wrapperLodash_default.first = array_default_default.head;
  mixin2(wrapperLodash_default, function() {
    var source = {};
    baseForOwn_default(wrapperLodash_default, function(func, methodName) {
      if (!hasOwnProperty25.call(wrapperLodash_default.prototype, methodName)) {
        source[methodName] = func;
      }
    });
    return source;
  }(), { "chain": false });
  wrapperLodash_default.VERSION = VERSION;
  (wrapperLodash_default.templateSettings = string_default_default.templateSettings).imports._ = wrapperLodash_default;
  arrayEach_default(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
    wrapperLodash_default[methodName].placeholder = wrapperLodash_default;
  });
  arrayEach_default(["drop", "take"], function(methodName, index) {
    LazyWrapper_default.prototype[methodName] = function(n) {
      n = n === void 0 ? 1 : nativeMax17(toInteger_default(n), 0);
      var result2 = this.__filtered__ && !index ? new LazyWrapper_default(this) : this.clone();
      if (result2.__filtered__) {
        result2.__takeCount__ = nativeMin15(n, result2.__takeCount__);
      } else {
        result2.__views__.push({
          "size": nativeMin15(n, MAX_ARRAY_LENGTH7),
          "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
        });
      }
      return result2;
    };
    LazyWrapper_default.prototype[methodName + "Right"] = function(n) {
      return this.reverse()[methodName](n).reverse();
    };
  });
  arrayEach_default(["filter", "map", "takeWhile"], function(methodName, index) {
    var type = index + 1, isFilter = type == LAZY_FILTER_FLAG2 || type == LAZY_WHILE_FLAG;
    LazyWrapper_default.prototype[methodName] = function(iteratee2) {
      var result2 = this.clone();
      result2.__iteratees__.push({
        "iteratee": baseIteratee_default(iteratee2, 3),
        "type": type
      });
      result2.__filtered__ = result2.__filtered__ || isFilter;
      return result2;
    };
  });
  arrayEach_default(["head", "last"], function(methodName, index) {
    var takeName = "take" + (index ? "Right" : "");
    LazyWrapper_default.prototype[methodName] = function() {
      return this[takeName](1).value()[0];
    };
  });
  arrayEach_default(["initial", "tail"], function(methodName, index) {
    var dropName = "drop" + (index ? "" : "Right");
    LazyWrapper_default.prototype[methodName] = function() {
      return this.__filtered__ ? new LazyWrapper_default(this) : this[dropName](1);
    };
  });
  LazyWrapper_default.prototype.compact = function() {
    return this.filter(identity_default);
  };
  LazyWrapper_default.prototype.find = function(predicate) {
    return this.filter(predicate).head();
  };
  LazyWrapper_default.prototype.findLast = function(predicate) {
    return this.reverse().find(predicate);
  };
  LazyWrapper_default.prototype.invokeMap = baseRest_default(function(path, args) {
    if (typeof path == "function") {
      return new LazyWrapper_default(this);
    }
    return this.map(function(value) {
      return baseInvoke_default(value, path, args);
    });
  });
  LazyWrapper_default.prototype.reject = function(predicate) {
    return this.filter(negate_default(baseIteratee_default(predicate)));
  };
  LazyWrapper_default.prototype.slice = function(start, end) {
    start = toInteger_default(start);
    var result2 = this;
    if (result2.__filtered__ && (start > 0 || end < 0)) {
      return new LazyWrapper_default(result2);
    }
    if (start < 0) {
      result2 = result2.takeRight(-start);
    } else if (start) {
      result2 = result2.drop(start);
    }
    if (end !== void 0) {
      end = toInteger_default(end);
      result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
    }
    return result2;
  };
  LazyWrapper_default.prototype.takeRightWhile = function(predicate) {
    return this.reverse().takeWhile(predicate).reverse();
  };
  LazyWrapper_default.prototype.toArray = function() {
    return this.take(MAX_ARRAY_LENGTH7);
  };
  baseForOwn_default(LazyWrapper_default.prototype, function(func, methodName) {
    var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = wrapperLodash_default[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
    if (!lodashFunc) {
      return;
    }
    wrapperLodash_default.prototype[methodName] = function() {
      var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper_default, iteratee2 = args[0], useLazy = isLazy || isArray_default(value);
      var interceptor = function(value2) {
        var result3 = lodashFunc.apply(wrapperLodash_default, arrayPush_default([value2], args));
        return isTaker && chainAll ? result3[0] : result3;
      };
      if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
        isLazy = useLazy = false;
      }
      var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
      if (!retUnwrapped && useLazy) {
        value = onlyLazy ? value : new LazyWrapper_default(this);
        var result2 = func.apply(value, args);
        result2.__actions__.push({ "func": thru_default, "args": [interceptor], "thisArg": void 0 });
        return new LodashWrapper_default(result2, chainAll);
      }
      if (isUnwrapped && onlyLazy) {
        return func.apply(this, args);
      }
      result2 = this.thru(interceptor);
      return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
    };
  });
  arrayEach_default(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
    var func = arrayProto6[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
    wrapperLodash_default.prototype[methodName] = function() {
      var args = arguments;
      if (retUnwrapped && !this.__chain__) {
        var value = this.value();
        return func.apply(isArray_default(value) ? value : [], args);
      }
      return this[chainName](function(value2) {
        return func.apply(isArray_default(value2) ? value2 : [], args);
      });
    };
  });
  baseForOwn_default(LazyWrapper_default.prototype, function(func, methodName) {
    var lodashFunc = wrapperLodash_default[methodName];
    if (lodashFunc) {
      var key = lodashFunc.name + "";
      if (!hasOwnProperty25.call(realNames_default, key)) {
        realNames_default[key] = [];
      }
      realNames_default[key].push({ "name": methodName, "func": lodashFunc });
    }
  });
  realNames_default[createHybrid_default(void 0, WRAP_BIND_KEY_FLAG7).name] = [{
    "name": "wrapper",
    "func": void 0
  }];
  LazyWrapper_default.prototype.clone = lazyClone_default;
  LazyWrapper_default.prototype.reverse = lazyReverse_default;
  LazyWrapper_default.prototype.value = lazyValue_default;
  wrapperLodash_default.prototype.at = seq_default_default.at;
  wrapperLodash_default.prototype.chain = seq_default_default.wrapperChain;
  wrapperLodash_default.prototype.commit = seq_default_default.commit;
  wrapperLodash_default.prototype.next = seq_default_default.next;
  wrapperLodash_default.prototype.plant = seq_default_default.plant;
  wrapperLodash_default.prototype.reverse = seq_default_default.reverse;
  wrapperLodash_default.prototype.toJSON = wrapperLodash_default.prototype.valueOf = wrapperLodash_default.prototype.value = seq_default_default.value;
  wrapperLodash_default.prototype.first = wrapperLodash_default.prototype.head;
  if (symIterator2) {
    wrapperLodash_default.prototype[symIterator2] = seq_default_default.toIterator;
  }
  var lodash_default_default = wrapperLodash_default;

  // node_modules/@alilc/lowcode-types/es/index.js
  init_define_process();

  // node_modules/@alilc/lowcode-datasource-types/es/index.js
  init_define_process();

  // node_modules/@alilc/lowcode-datasource-types/es/data-source.js
  init_define_process();
  var RuntimeDataSourceStatus;
  (function(RuntimeDataSourceStatus2) {
    RuntimeDataSourceStatus2["Initial"] = "init";
    RuntimeDataSourceStatus2["Loading"] = "loading";
    RuntimeDataSourceStatus2["Loaded"] = "loaded";
    RuntimeDataSourceStatus2["Error"] = "error";
  })(RuntimeDataSourceStatus || (RuntimeDataSourceStatus = {}));

  // node_modules/@alilc/lowcode-datasource-types/es/data-source-handlers.js
  init_define_process();

  // node_modules/@alilc/lowcode-datasource-types/es/data-source-interpret.js
  init_define_process();

  // node_modules/@alilc/lowcode-datasource-types/es/data-source-runtime.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/editor.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/field-config.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/i18n.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/icon.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/metadata.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/npm.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/prop-config.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/schema.js
  init_define_process();
  function isDOMText(data) {
    return typeof data === "string";
  }
  function isNodeSchema(data) {
    return data && data.componentName;
  }

  // node_modules/@alilc/lowcode-types/es/activity.js
  init_define_process();
  var ActivityType;
  (function(ActivityType2) {
    ActivityType2["ADDED"] = "added";
    ActivityType2["DELETED"] = "deleted";
    ActivityType2["MODIFIED"] = "modified";
    ActivityType2["COMPOSITE"] = "composite";
  })(ActivityType || (ActivityType = {}));

  // node_modules/@alilc/lowcode-types/es/tip.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/title.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/utils.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/value-type.js
  init_define_process();
  function isJSExpression(data) {
    return data && data.type === "JSExpression";
  }
  function isJSFunction(x) {
    return typeof x === "object" && x && x.type === "JSFunction";
  }
  function isJSSlot(data) {
    return data && data.type === "JSSlot";
  }

  // ignore:./setter-config
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/setting-target.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/node.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/transform-stage.js
  init_define_process();
  var TransformStage;
  (function(TransformStage2) {
    TransformStage2["Render"] = "render";
    TransformStage2["Serilize"] = "serilize";
    TransformStage2["Save"] = "save";
    TransformStage2["Clone"] = "clone";
    TransformStage2["Init"] = "init";
    TransformStage2["Upgrade"] = "upgrade";
  })(TransformStage || (TransformStage = {}));

  // node_modules/@alilc/lowcode-types/es/code-intermediate.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/code-result.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/assets.js
  init_define_process();
  var AssetLevel;
  (function(AssetLevel2) {
    AssetLevel2[AssetLevel2["Environment"] = 1] = "Environment";
    AssetLevel2[AssetLevel2["Library"] = 2] = "Library";
    AssetLevel2[AssetLevel2["Theme"] = 3] = "Theme";
    AssetLevel2[AssetLevel2["Runtime"] = 4] = "Runtime";
    AssetLevel2[AssetLevel2["Components"] = 5] = "Components";
    AssetLevel2[AssetLevel2["App"] = 6] = "App";
  })(AssetLevel || (AssetLevel = {}));
  var AssetLevels = [AssetLevel.Environment, AssetLevel.Library, AssetLevel.Theme, AssetLevel.Runtime, AssetLevel.Components, AssetLevel.App];
  var AssetType;
  (function(AssetType2) {
    AssetType2["JSUrl"] = "jsUrl";
    AssetType2["CSSUrl"] = "cssUrl";
    AssetType2["CSSText"] = "cssText";
    AssetType2["JSText"] = "jsText";
    AssetType2["Bundle"] = "bundle";
  })(AssetType || (AssetType = {}));

  // node_modules/@alilc/lowcode-types/es/event/index.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/event/node.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/event/prop.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/disposable.js
  init_define_process();

  // node_modules/@alilc/lowcode-types/es/start-transaction.js
  init_define_process();
  var TransitionType;
  (function(TransitionType2) {
    TransitionType2[TransitionType2["REPAINT"] = 0] = "REPAINT";
  })(TransitionType || (TransitionType = {}));

  // src/utils/schema.ts
  function isContainerSchema(x) {
    return typeof x === "object" && x && typeof x.componentName === "string" && typeof x.fileName === "string";
  }
  function isNpmInfo(x) {
    return typeof x === "object" && x && typeof x.package === "string";
  }
  var noop2 = () => void 0;
  var handleChildrenDefaultOptions = {
    rerun: false
  };
  var DEFAULT_MAX_DEPTH = 1e5;
  function handleSubNodes(children, handlers, options) {
    var _a;
    const opt = {
      ...handleChildrenDefaultOptions,
      ...options || {}
    };
    const maxDepth = (_a = opt.maxDepth) != null ? _a : DEFAULT_MAX_DEPTH;
    if (maxDepth <= 0) {
      throw new Error("handleSubNodes maxDepth reached");
    }
    if (Array.isArray(children)) {
      const list = children;
      return list.map((child) => handleSubNodes(child, handlers, { ...opt, maxDepth: maxDepth - 1 })).reduce((p, c) => p.concat(c), []);
    }
    let result2;
    const childrenRes = [];
    if (children === null || children === void 0) {
      return [];
    } else if (isDOMText(children)) {
      const handler = handlers.string || noop2;
      result2 = handler(children);
    } else if (isJSExpression(children)) {
      const handler = handlers.expression || noop2;
      result2 = handler(children);
    } else if (isJSSlot(children)) {
      return handleSubNodes(children.value, handlers, { ...opt, maxDepth: maxDepth - 1 });
    } else if (isNodeSchema(children)) {
      const handler = handlers.node || noop2;
      const child = children;
      result2 = handler(child);
      if (child.children) {
        const childRes = handleSubNodes(child.children, handlers, opt);
        childrenRes.push(...childRes);
      }
      if (child.props) {
        if (Array.isArray(child.props)) {
          child.props.forEach(({ value }) => {
            const childRes = handleCompositeValueInProps(value);
            childrenRes.push(...childRes);
          });
        } else {
          Object.values(child.props).forEach((value) => {
            const childRes = handleCompositeValueInProps(value);
            childrenRes.push(...childRes);
          });
        }
      }
    } else {
      throw new CodeGeneratorError("handleSubNodes got invalid NodeData", children);
    }
    if (result2 !== void 0) {
      childrenRes.unshift(result2);
    }
    return childrenRes;
    function handleCompositeValueInProps(value) {
      if (isJSSlot(value)) {
        return handleSubNodes(value.value, handlers, { ...opt, maxDepth: maxDepth - 1 });
      }
      if (Array.isArray(value)) {
        return flatMap_default(value, (v) => handleCompositeValueInProps(v));
      }
      if (!isJSExpression(value) && !isJSFunction(value) && typeof value === "object" && value !== null) {
        return flatMap_default(Object.values(value), (v) => handleCompositeValueInProps(v));
      }
      return [];
    }
  }

  // src/utils/common.ts
  var common_exports = {};
  __export(common_exports, {
    camel2dash: () => camel2dash,
    camelize: () => camelize,
    generateID: () => generateID,
    getStaticExprValue: () => getStaticExprValue,
    uniqueArray: () => uniqueArray,
    upperCaseFirst: () => upperCaseFirst
  });
  init_define_process();
  var import_change_case = __toESM(require_change_case());
  var import_short_uuid = __toESM(require_short_uuid());
  function camel2dash(input) {
    return import_change_case.default.paramCase(input);
  }
  function camelize(str) {
    return import_change_case.default.camelCase(str);
  }
  function generateID() {
    return import_short_uuid.default.generate();
  }
  function upperCaseFirst(inputValue) {
    return import_change_case.default.upperCaseFirst(inputValue);
  }
  function uniqueArray(arr, by) {
    const map2 = {};
    arr.forEach((item) => {
      map2[by(item)] = item;
    });
    const uniqueKeys = Array.from(new Set(Object.keys(map2)));
    const uniqueItems = uniqueKeys.map((key) => map2[key]);
    return uniqueItems;
  }
  function getStaticExprValue(expr) {
    return Function(`"use strict";return (${expr})`)();
  }

  // src/analyzer/componentAnalyzer.ts
  init_define_process();
  var componentAnalyzer = (container) => {
    let hasRefAttr = false;
    const nodeValidator = (n) => {
      if (n.props) {
        const props = n.props;
        if (props.ref) {
          hasRefAttr = true;
        }
      }
    };
    nodeValidator(container);
    if (!hasRefAttr && container.children) {
      handleSubNodes(
        container.children,
        {
          node: nodeValidator
        },
        {
          rerun: true
        }
      );
    }
    return {
      isUsingRef: hasRefAttr
    };
  };

  // src/utils/validate.ts
  var validate_exports = {};
  __export(validate_exports, {
    ensureValidClassName: () => ensureValidClassName,
    isValidIdentifier: () => isValidIdentifier
  });
  init_define_process();
  var isValidIdentifier = (name) => {
    return /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/.test(name);
  };
  var ensureValidClassName = (name) => {
    if (!isValidIdentifier(name)) {
      return `$${name.replace(/[^_$a-zA-Z0-9]/g, "")}`;
    }
    return name;
  };

  // src/parser/SchemaParser.ts
  var defaultContainer = {
    containerType: "Component",
    componentName: "Component",
    moduleName: "Index",
    fileName: "Index",
    css: "",
    props: {}
  };
  function getRootComponentName(typeName, maps) {
    if (maps[typeName]) {
      const rec = maps[typeName];
      if (rec.destructuring) {
        return rec.componentName || typeName;
      }
      const peerName = Object.keys(maps).find((depName) => {
        const depInfo = maps[depName];
        return depName !== typeName && !depInfo.destructuring && depInfo.package === rec.package && depInfo.version === rec.version && depInfo.main === rec.main && depInfo.exportName === rec.exportName && depInfo.subName === rec.subName;
      });
      return peerName || typeName;
    }
    return typeName;
  }
  function processChildren(schema) {
    if (schema.props) {
      if (Array.isArray(schema.props)) {
      } else {
        const nodeProps = schema.props;
        if (nodeProps.children) {
          if (!schema.children) {
            schema.children = nodeProps.children;
          } else {
            let _children = [];
            if (Array.isArray(schema.children)) {
              _children = _children.concat(schema.children);
            } else {
              _children.push(schema.children);
            }
            if (Array.isArray(nodeProps.children)) {
              _children = _children.concat(nodeProps.children);
            } else {
              _children.push(nodeProps.children);
            }
            schema.children = _children;
          }
          delete nodeProps.children;
        }
      }
    }
  }
  var SchemaParser = class {
    validate(schema) {
      if (SUPPORT_SCHEMA_VERSION_LIST.indexOf(schema.version) < 0) {
        throw new CompatibilityError(`Not support schema with version [${schema.version}]`);
      }
      return true;
    }
    parse(schemaSrc) {
      const compDeps = {};
      const internalDeps = {};
      let utilsDeps = [];
      const schema = this.decodeSchema(schemaSrc);
      schema.componentsMap.forEach((info) => {
        var _a, _b;
        if (info.componentName) {
          compDeps[info.componentName] = {
            ...info,
            dependencyType: "External" /* External */,
            componentName: info.componentName,
            exportName: (_a = info.exportName) != null ? _a : info.componentName,
            version: info.version || "*",
            destructuring: (_b = info.destructuring) != null ? _b : false
          };
        }
      });
      let containers;
      if (schema.componentsTree.length > 0) {
        const firstRoot = schema.componentsTree[0];
        if (!("fileName" in firstRoot) || !firstRoot.fileName) {
          const container = {
            ...firstRoot,
            ...defaultContainer,
            props: firstRoot.props || defaultContainer.props,
            css: firstRoot.css || defaultContainer.css,
            moduleName: firstRoot.moduleName || defaultContainer.moduleName,
            children: schema.componentsTree
          };
          containers = [container];
        } else {
          containers = schema.componentsTree.map((n) => {
            const subRoot = n;
            const container = {
              ...subRoot,
              componentName: getRootComponentName(subRoot.componentName, compDeps),
              containerType: subRoot.componentName,
              moduleName: ensureValidClassName(import_change_case2.default.pascalCase(subRoot.fileName))
            };
            return container;
          });
        }
      } else {
        throw new CodeGeneratorError("Can't find anything to generate.");
      }
      containers = containers.map((con) => ({
        ...con,
        analyzeResult: componentAnalyzer(con)
      }));
      containers.forEach((container) => {
        let type;
        switch (container.containerType) {
          case "Page":
            type = "pages" /* PAGE */;
            break;
          case "Block":
            type = "components" /* BLOCK */;
            break;
          default:
            type = "components" /* COMPONENT */;
            break;
        }
        const dep = {
          type,
          moduleName: container.moduleName,
          destructuring: false,
          exportName: container.moduleName,
          dependencyType: "Internal" /* Internal */
        };
        internalDeps[dep.moduleName] = dep;
      });
      const containersDeps = [].concat(...containers.map((c) => c.deps || []));
      containers.forEach((container) => {
        if (container.children) {
          handleSubNodes(
            container.children,
            {
              node: (i) => processChildren(i)
            },
            {
              rerun: true
            }
          );
        }
      });
      containers.forEach((container) => {
        const depNames = this.getComponentNames(container);
        container.deps = uniqueArray(depNames, (i) => i).map((depName) => internalDeps[depName] || compDeps[depName]).filter(Boolean);
      });
      const routes = containers.filter((container) => container.containerType === "Page").map((page) => {
        const { meta } = page;
        if (meta) {
          return {
            path: meta.router || `/${page.fileName}`,
            fileName: page.fileName,
            componentName: page.moduleName
          };
        }
        return {
          path: "",
          fileName: page.fileName,
          componentName: page.moduleName
        };
      });
      const routerDeps = routes.map((r) => internalDeps[r.componentName] || compDeps[r.componentName]).filter((dep) => !!dep);
      let utils;
      if (schema.utils) {
        utils = schema.utils;
        utilsDeps = schema.utils.filter(
          (u) => u.type !== "function"
        ).map(
          (u) => {
            var _a, _b;
            return {
              ...u.content,
              componentName: u.name,
              version: u.content.version || "*",
              destructuring: (_a = u.content.destructuring) != null ? _a : false,
              exportName: (_b = u.content.exportName) != null ? _b : u.name
            };
          }
        );
      } else {
        utils = [];
      }
      let npms = [];
      containers.forEach((con) => {
        const p = (con.deps || []).map((dep) => {
          return dep.dependencyType === "External" /* External */ ? dep : null;
        }).filter((dep) => dep !== null);
        const npmInfos = p.filter(Boolean).map((i) => ({
          package: i.package,
          version: i.version
        }));
        npms.push(...npmInfos);
      });
      npms.push(
        ...utilsDeps.map((utilsDep) => ({
          package: utilsDep.package,
          version: utilsDep.version
        }))
      );
      npms = uniqueArray(npms, (i) => i.package || "").filter(Boolean);
      return {
        containers,
        globalUtils: {
          utils,
          deps: utilsDeps
        },
        globalI18n: schema.i18n,
        globalRouter: {
          routes,
          deps: routerDeps
        },
        project: {
          css: schema.css,
          constants: schema.constants,
          config: schema.config || {},
          meta: schema.meta || {},
          i18n: schema.i18n,
          containersDeps,
          utilsDeps,
          packages: npms || [],
          dataSourcesTypes: this.collectDataSourcesTypes(schema)
        }
      };
    }
    getComponentNames(children) {
      return handleSubNodes(
        children,
        {
          node: (i) => i.componentName
        },
        {
          rerun: true
        }
      );
    }
    decodeSchema(schemaSrc) {
      let schema;
      if (typeof schemaSrc === "string") {
        try {
          schema = JSON.parse(schemaSrc);
        } catch (error) {
          throw new CodeGeneratorError(
            `Parse schema failed: ${getErrorMessage(error) || "unknown reason"}`
          );
        }
      } else {
        schema = schemaSrc;
      }
      return schema;
    }
    collectDataSourcesTypes(schema) {
      var _a, _b;
      const dataSourcesTypes = /* @__PURE__ */ new Set();
      const defaultDataSourceType = "fetch";
      (_b = (_a = schema.dataSource) == null ? void 0 : _a.list) == null ? void 0 : _b.forEach((ds) => {
        dataSourcesTypes.add(ds.type || defaultDataSourceType);
      });
      schema.componentsTree.forEach((rootNode) => {
        var _a2, _b2;
        (_b2 = (_a2 = rootNode.dataSource) == null ? void 0 : _a2.list) == null ? void 0 : _b2.forEach((ds) => {
          dataSourcesTypes.add(ds.type || defaultDataSourceType);
        });
      });
      return Array.from(dataSourcesTypes.values());
    }
  };

  // src/utils/resultHelper.ts
  var resultHelper_exports = {};
  __export(resultHelper_exports, {
    addDirectory: () => addDirectory,
    addFile: () => addFile,
    createResultDir: () => createResultDir,
    createResultFile: () => createResultFile,
    findDir: () => findDir,
    findFile: () => findFile,
    flattenResult: () => flattenResult,
    getFileNameWithExt: () => getFileNameWithExt,
    globDirs: () => globDirs,
    globFiles: () => globFiles,
    removeDirsFromResult: () => removeDirsFromResult,
    removeFilesFromResult: () => removeFilesFromResult,
    scanDirs: () => scanDirs,
    scanFiles: () => scanFiles
  });
  init_define_process();
  var import_nanomatch = __toESM(require_nanomatch());
  function createResultFile(name, ext = "jsx", content = "") {
    return {
      name,
      ext,
      content
    };
  }
  function createResultDir(name) {
    return {
      name,
      dirs: [],
      files: []
    };
  }
  function addDirectory(target, dir) {
    if (target.dirs.findIndex((d) => d.name === dir.name) < 0) {
      target.dirs.push(dir);
    } else {
      throw new CodeGeneratorError(
        `Adding same directory to one directory: ${dir.name} -> ${target.name}`
      );
    }
  }
  function addFile(target, file2) {
    if (target.files.findIndex((f) => f.name === file2.name && f.ext === file2.ext) < 0) {
      target.files.push(file2);
    } else {
      throw new CodeGeneratorError(
        `Adding same file to one directory: ${file2.name} -> ${target.name}`
      );
    }
  }
  function flattenResult(dir, cwd = "") {
    if (!dir.files.length && !dir.dirs.length) {
      return [];
    }
    return [
      ...dir.files.map(
        (file2) => ({
          pathName: joinPath(cwd, `${file2.name}${file2.ext ? `.${file2.ext}` : ""}`),
          content: file2.content
        })
      )
    ].concat(...dir.dirs.map((subDir) => flattenResult(subDir, joinPath(cwd, subDir.name))));
  }
  function findFile(result2, fileGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const maxDepth = !/\/|\*\*/.test(fileGlobExpr) ? 1 : void 0;
    const files = scanFiles(result2, resultDirPath, maxDepth);
    for (let [filePath, file2] of files) {
      if (import_nanomatch.default.isMatch(filePath, fileGlobExpr, options)) {
        return file2;
      }
    }
    return null;
  }
  function* globFiles(result2, fileGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const files = scanFiles(result2, resultDirPath);
    for (let [filePath, file2] of files) {
      if (import_nanomatch.default.isMatch(filePath, fileGlobExpr, options)) {
        yield [filePath, file2];
      }
    }
  }
  function* scanFiles(result2, resultDirPath = getResultNameOrDefault(result2, ""), maxDepth = 1e4) {
    for (let file2 of result2.files) {
      const fileName = getFileNameWithExt(file2);
      yield [joinPath(resultDirPath, fileName), file2];
    }
    for (let subDir of result2.dirs) {
      yield* scanFiles(subDir, joinPath(resultDirPath, subDir.name), maxDepth - 1);
    }
  }
  function getFileNameWithExt(file2) {
    return `${file2.name}${file2.ext ? `.${file2.ext}` : ""}`;
  }
  function getResultNameOrDefault(result2, defaultDir = "/") {
    return result2.name && result2.name !== "." ? result2.name : defaultDir;
  }
  function joinPath(...pathParts) {
    return pathParts.filter((x) => x !== "" && x !== ".").join("/").replace(/\\+/g, "/").replace(/\/+/g, "/");
  }
  function* scanDirs(result2, resultDirPath = getResultNameOrDefault(result2, ""), maxDepth = 1e4) {
    yield [resultDirPath, result2];
    for (let subDir of result2.dirs) {
      yield* scanDirs(subDir, joinPath(resultDirPath, subDir.name), maxDepth - 1);
    }
  }
  function* globDirs(result2, dirGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const dirs = scanDirs(result2, resultDirPath);
    for (let [dirPath, dir] of dirs) {
      if (import_nanomatch.default.isMatch(dirPath, dirGlobExpr, options)) {
        yield [dirPath, dir];
      }
    }
  }
  function findDir(result2, dirGlobExpr, options = {}, resultDirPath = getResultNameOrDefault(result2, "")) {
    const dirs = scanDirs(result2, resultDirPath);
    for (let [dirPath, dir] of dirs) {
      if (import_nanomatch.default.isMatch(dirPath, dirGlobExpr, options)) {
        return dir;
      }
    }
    return null;
  }
  function removeFilesFromResult(result2, filePathGlobExpr, globOptions = {}) {
    let removedCount = 0;
    const [dirPath, fileName] = splitPath(filePathGlobExpr);
    const dirs = dirPath ? globDirs(result2, dirPath) : [["", result2]];
    for (let [, dir] of dirs) {
      const files = globFiles(dir, fileName, globOptions, ".");
      for (let [, file2] of files) {
        dir.files.splice(dir.files.indexOf(file2), 1);
        removedCount += 1;
      }
    }
    return removedCount;
  }
  function removeDirsFromResult(result2, dirPathGlobExpr, globOptions = {}) {
    let removedCount = 0;
    const [dirPath, fileName] = splitPath(dirPathGlobExpr);
    const dirs = dirPath ? globDirs(result2, dirPath) : [["", result2]];
    for (let [, dir] of dirs) {
      const foundDirs = globDirs(dir, fileName, globOptions, ".");
      for (let [, foundDir] of foundDirs) {
        dir.dirs.splice(dir.dirs.indexOf(foundDir), 1);
        removedCount += 1;
      }
    }
    return removedCount;
  }
  function splitPath(filePath) {
    const parts = filePath.split("/");
    const fileName = parts.pop() || "";
    return [joinPath(...parts), fileName];
  }

  // src/generator/ModuleBuilder.ts
  init_define_process();

  // src/generator/ChunkBuilder.ts
  init_define_process();
  function whichFamily(type) {
    const idx = FILE_TYPE_FAMILY.findIndex((family) => family.indexOf(type) >= 0);
    if (idx < 0) {
      return void 0;
    }
    return [idx, FILE_TYPE_FAMILY[idx]];
  }
  var groupChunks = (chunks) => {
    const tmp = {};
    const col = chunks.reduce((chunksSet, chunk2) => {
      const fileKey = chunk2.subModule || COMMON_SUB_MODULE_NAME;
      if (!chunksSet[fileKey]) {
        chunksSet[fileKey] = [];
      }
      const res = whichFamily(chunk2.fileType);
      const info = {
        chunk: chunk2
      };
      if (res) {
        const [familyIdx, family] = res;
        const rank = family.indexOf(chunk2.fileType);
        if (tmp[fileKey]) {
          if (tmp[fileKey][familyIdx] !== void 0) {
            if (tmp[fileKey][familyIdx] > rank) {
              tmp[fileKey][familyIdx] = rank;
            }
          } else {
            tmp[fileKey][familyIdx] = rank;
          }
        } else {
          tmp[fileKey] = {};
          tmp[fileKey][familyIdx] = rank;
        }
        info.familyIdx = familyIdx;
      }
      chunksSet[fileKey].push(info);
      return chunksSet;
    }, {});
    const result2 = [];
    Object.keys(col).forEach((key) => {
      const byType = {};
      col[key].forEach((info) => {
        let t3 = info.chunk.fileType;
        if (info.familyIdx !== void 0) {
          t3 = FILE_TYPE_FAMILY[info.familyIdx][tmp[key][info.familyIdx]];
          info.chunk.fileType = t3;
        }
        if (!byType[t3]) {
          byType[t3] = [];
        }
        byType[t3].push(info.chunk);
      });
      result2.push(...Object.keys(byType).map((t3) => byType[t3]));
    });
    return result2;
  };
  var ChunkBuilder = class {
    constructor(plugins5 = []) {
      __publicField(this, "plugins");
      this.plugins = plugins5;
    }
    async run(ir, initialStructure = {
      ir,
      chunks: [],
      depNames: [],
      contextData: {}
    }) {
      const structure = initialStructure;
      const finalStructure = await this.plugins.reduce(
        async (previousPluginOperation, plugin) => {
          const modifiedStructure = await previousPluginOperation;
          return plugin(modifiedStructure);
        },
        Promise.resolve(structure)
      );
      const chunks = groupChunks(finalStructure.chunks);
      return {
        chunks
      };
    }
    getPlugins() {
      return this.plugins;
    }
    addPlugin(plugin) {
      this.plugins.push(plugin);
    }
  };

  // src/generator/CodeBuilder.ts
  init_define_process();
  var CodeBuilder = class {
    constructor(chunkDefinitions = []) {
      __publicField(this, "chunkDefinitions", []);
      __publicField(this, "generators", {
        ["string" /* STRING */]: (str) => str,
        ["json" /* JSON */]: (json) => JSON.stringify(json)
      });
      this.chunkDefinitions = chunkDefinitions;
    }
    link(chunkDefinitions = []) {
      const chunks = chunkDefinitions || this.chunkDefinitions;
      if (chunks.length <= 0) {
        return "";
      }
      const unprocessedChunks = chunks.map((chunk2) => {
        return {
          name: chunk2.name,
          type: chunk2.type,
          content: chunk2.content,
          linkAfter: this.cleanupInvalidChunks(chunk2.linkAfter, chunks)
        };
      });
      const resultingString = [];
      while (unprocessedChunks.length > 0) {
        let indexToRemove = 0;
        for (let index = 0; index < unprocessedChunks.length; index++) {
          if (unprocessedChunks[index].linkAfter.length <= 0) {
            indexToRemove = index;
            break;
          }
        }
        if (unprocessedChunks[indexToRemove].linkAfter.length > 0) {
          throw new CodeGeneratorError(
            "Operation aborted. Reason: cyclic dependency between chunks."
          );
        }
        const { type, content, name } = unprocessedChunks[indexToRemove];
        const compiledContent = this.generateByType(type, content);
        if (compiledContent) {
          resultingString.push(`${compiledContent}
`);
        }
        unprocessedChunks.splice(indexToRemove, 1);
        if (!unprocessedChunks.some((ch) => ch.name === name)) {
          unprocessedChunks.forEach(
            (ch) => {
              ch.linkAfter = ch.linkAfter.filter((after2) => after2 !== name);
            }
          );
        }
      }
      return resultingString.join("\n");
    }
    generateByType(type, content) {
      if (!content) {
        return "";
      }
      if (Array.isArray(content)) {
        return content.map((contentItem) => this.generateByType(type, contentItem)).join("\n");
      }
      if (!this.generators[type]) {
        throw new Error(
          `Attempted to generate unknown type ${type}. Please register a generator for this type in builder/index.ts`
        );
      }
      return this.generators[type](content);
    }
    cleanupInvalidChunks(linkAfter, chunks) {
      return linkAfter.filter((chunkName) => chunks.some((chunk2) => chunk2.name === chunkName));
    }
  };

  // src/generator/ModuleBuilder.ts
  function createModuleBuilder(options = {
    plugins: [],
    postProcessors: []
  }) {
    const chunkGenerator = new ChunkBuilder(options.plugins);
    const linker = new CodeBuilder();
    const generateModule = async (input) => {
      const moduleMainName = options.mainFileName || COMMON_SUB_MODULE_NAME;
      if (chunkGenerator.getPlugins().length <= 0) {
        throw new CodeGeneratorError(
          "No plugins found. Component generation cannot work without any plugins!"
        );
      }
      let files = [];
      const { chunks } = await chunkGenerator.run(input, {
        ir: input,
        chunks: [],
        depNames: [],
        contextData: options.contextData || {}
      });
      chunks.forEach((fileChunkList) => {
        const content = linker.link(fileChunkList);
        const file2 = createResultFile(
          fileChunkList[0].subModule || moduleMainName,
          fileChunkList[0].fileType,
          content
        );
        files.push(file2);
      });
      if (options.postProcessors.length > 0) {
        files = files.map((file2) => {
          let { content } = file2;
          const type = file2.ext;
          options.postProcessors.forEach((processer) => {
            content = processer(content, type);
          });
          return createResultFile(file2.name, type, content);
        });
      }
      return {
        files
      };
    };
    const generateModuleCode = async (schema) => {
      const schemaParser = new SchemaParser();
      const parseResult = schemaParser.parse(schema);
      const containerInfo = parseResult.containers[0];
      const { files } = await generateModule(containerInfo);
      const dir = createResultDir(containerInfo.moduleName);
      files.forEach((file2) => addFile(dir, file2));
      return dir;
    };
    const linkCodeChunks = (chunks, fileName) => {
      const files = [];
      Object.keys(chunks).forEach((fileKey) => {
        const fileChunkList = chunks[fileKey];
        const content = linker.link(fileChunkList);
        const file2 = createResultFile(
          fileChunkList[0].subModule || fileName,
          fileChunkList[0].fileType,
          content
        );
        files.push(file2);
      });
      return files;
    };
    return {
      generateModule,
      generateModuleCode,
      linkCodeChunks,
      addPlugin: chunkGenerator.addPlugin.bind(chunkGenerator)
    };
  }

  // src/generator/ProjectBuilder.ts
  var ProjectBuilder = class {
    constructor({
      template: template2,
      plugins: plugins5,
      postProcessors,
      schemaParser = new SchemaParser(),
      projectPreProcessors = [],
      projectPostProcessors = [],
      inStrictMode = false,
      extraContextData = {}
    }) {
      __publicField(this, "template");
      __publicField(this, "plugins");
      __publicField(this, "postProcessors");
      __publicField(this, "schemaParser");
      __publicField(this, "projectPreProcessors");
      __publicField(this, "projectPostProcessors");
      __publicField(this, "inStrictMode");
      __publicField(this, "extraContextData");
      this.template = template2;
      this.plugins = plugins5;
      this.postProcessors = postProcessors;
      this.schemaParser = schemaParser;
      this.projectPreProcessors = projectPreProcessors;
      this.projectPostProcessors = projectPostProcessors;
      this.inStrictMode = inStrictMode;
      this.extraContextData = extraContextData;
    }
    async generateProject(originalSchema) {
      const { schemaParser } = this;
      const builders = this.createModuleBuilders();
      const projectRoot = await this.template.generateTemplate();
      let schema = typeof originalSchema === "string" ? JSON.parse(originalSchema) : originalSchema;
      if (!schemaParser.validate(schema)) {
        throw new CodeGeneratorError("Schema is invalid");
      }
      for (const preProcessor of this.projectPreProcessors) {
        schema = await preProcessor(schema);
      }
      const parseResult = schemaParser.parse(schema);
      let buildResult = [];
      const containerBuildResult = await Promise.all(
        parseResult.containers.map(async (containerInfo) => {
          let builder;
          let path;
          if (containerInfo.containerType === "Page") {
            builder = builders.pages;
            path = this.template.slots.pages.path;
          } else {
            builder = builders.components;
            path = this.template.slots.components.path;
          }
          const { files } = await builder.generateModule(containerInfo);
          return {
            moduleName: containerInfo.moduleName,
            path,
            files
          };
        })
      );
      buildResult = buildResult.concat(containerBuildResult);
      if (parseResult.globalRouter && builders.router) {
        const { files } = await builders.router.generateModule(parseResult.globalRouter);
        buildResult.push({
          path: this.template.slots.router.path,
          files
        });
      }
      if (parseResult.project && builders.entry) {
        const { files } = await builders.entry.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.entry.path,
          files
        });
      }
      if (builders.appConfig) {
        const { files } = await builders.appConfig.generateModule(parseResult);
        buildResult.push({
          path: this.template.slots.appConfig.path,
          files
        });
      }
      if (builders.buildConfig) {
        const { files } = await builders.buildConfig.generateModule(parseResult);
        buildResult.push({
          path: this.template.slots.buildConfig.path,
          files
        });
      }
      if (parseResult.project && builders.constants && this.template.slots.constants) {
        const { files } = await builders.constants.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.constants.path,
          files
        });
      }
      if (parseResult.globalUtils && builders.utils && this.template.slots.utils) {
        const { files } = await builders.utils.generateModule(parseResult.globalUtils);
        buildResult.push({
          path: this.template.slots.utils.path,
          files
        });
      }
      if (builders.i18n && this.template.slots.i18n) {
        const { files } = await builders.i18n.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.i18n.path,
          files
        });
      }
      if (parseResult.project && builders.globalStyle) {
        const { files } = await builders.globalStyle.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.globalStyle.path,
          files
        });
      }
      if (parseResult.project && builders.htmlEntry) {
        const { files } = await builders.htmlEntry.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.htmlEntry.path,
          files
        });
      }
      if (parseResult.project && builders.packageJSON) {
        const { files } = await builders.packageJSON.generateModule(parseResult.project);
        buildResult.push({
          path: this.template.slots.packageJSON.path,
          files
        });
      }
      if (parseResult.globalRouter && builders.menuData) {
        const { files } = await builders.menuData.generateModule(parseResult.globalRouter);
        buildResult.push({
          path: this.template.slots.menuData.path,
          files
        });
      }
      buildResult.forEach((moduleInfo) => {
        let targetDir = getDirFromRoot(projectRoot, moduleInfo.path);
        if (moduleInfo.moduleName) {
          const dir = createResultDir(moduleInfo.moduleName);
          addDirectory(targetDir, dir);
          targetDir = dir;
        }
        moduleInfo.files.forEach((file2) => addFile(targetDir, file2));
      });
      let finalResult = projectRoot;
      for (const projectPostProcessor of this.projectPostProcessors) {
        finalResult = await projectPostProcessor(finalResult, schema, originalSchema);
      }
      return finalResult;
    }
    createModuleBuilders() {
      const builders = {};
      Object.keys(this.plugins).forEach((pluginName) => {
        if (this.plugins[pluginName].length > 0) {
          const options = {};
          if (this.template.slots[pluginName] && this.template.slots[pluginName].fileName) {
            options.mainFileName = this.template.slots[pluginName].fileName;
          }
          builders[pluginName] = createModuleBuilder({
            plugins: this.plugins[pluginName],
            postProcessors: this.postProcessors,
            contextData: {
              inStrictMode: this.inStrictMode,
              tolerateEvalErrors: true,
              evalErrorsHandler: "",
              ...this.extraContextData
            },
            ...options
          });
        }
      });
      return builders;
    }
  };
  function createProjectBuilder(initOptions) {
    return new ProjectBuilder(initOptions);
  }
  function getDirFromRoot(root2, path) {
    let current = root2;
    path.forEach((p) => {
      const exist = current.dirs.find((d) => d.name === p);
      if (exist) {
        current = exist;
      } else {
        const newDir = createResultDir(p);
        addDirectory(current, newDir);
        current = newDir;
      }
    });
    return current;
  }

  // src/publisher/zip/index.ts
  init_define_process();

  // src/publisher/zip/utils.ts
  init_define_process();
  var import_jszip = __toESM(require_jszip_min());
  var isNodeProcess = () => {
    return typeof define_process_default === "object" && typeof define_process_default.versions === "object" && typeof define_process_default.versions.node !== "undefined";
  };
  var writeZipToDisk = (zipFolderPath, content, zipName) => {
    if (!isNodeProcess()) {
      throw new Error("ZipPublisher: writeZipToDisk is only available in NodeJS");
    }
    const fs = require_fs();
    const path = require_path_browserify();
    if (!fs.existsSync(zipFolderPath)) {
      fs.mkdirSync(zipFolderPath, { recursive: true });
    }
    const zipPath = path.join(zipFolderPath, `${zipName}.zip`);
    const writeStream = fs.createWriteStream(zipPath);
    writeStream.write(content);
    writeStream.end();
  };
  var generateProjectZip = async (project) => {
    let zip2 = new import_jszip.default();
    zip2 = writeFolderToZip(project, zip2, true);
    const zipType = "nodebuffer";
    return zip2.generateAsync({ type: zipType });
  };
  var writeFolderToZip = (folder, parentFolder, ignoreFolder = false) => {
    const zipFolder = ignoreFolder ? parentFolder : parentFolder.folder(folder.name);
    if (zipFolder !== null) {
      folder.files.forEach((file2) => {
        const options = {};
        const fileName = file2.ext ? `${file2.name}.${file2.ext}` : file2.name;
        zipFolder.file(fileName, file2.content, options);
      });
      folder.dirs.forEach((subFolder) => {
        writeFolderToZip(subFolder, zipFolder);
      });
    }
    return parentFolder;
  };

  // src/publisher/zip/index.ts
  var createZipPublisher = (params = {}) => {
    let { project, outputPath } = params;
    const getProject = () => project;
    const setProject = (projectToSet) => {
      project = projectToSet;
    };
    const getOutputPath = () => outputPath;
    const setOutputPath = (path) => {
      outputPath = path;
    };
    const publish = async (options = {}) => {
      const projectToPublish = options.project || project;
      if (!projectToPublish) {
        throw new PublisherError("MissingProject");
      }
      const zipName = options.projectSlug || params.projectSlug || projectToPublish.name;
      try {
        const zipContent = await generateProjectZip(projectToPublish);
        const projectOutputPath = options.outputPath || outputPath;
        if (projectOutputPath && isNodeProcess()) {
          await writeZipToDisk(projectOutputPath, zipContent, zipName);
        }
        return { success: true, payload: zipContent };
      } catch (error) {
        throw new PublisherError(getErrorMessage(error) || "UnknownError");
      }
    };
    return {
      publish,
      getProject,
      setProject,
      getOutputPath,
      setOutputPath
    };
  };

  // src/solutions/icejs.ts
  init_define_process();

  // src/plugins/common/esmodule.ts
  init_define_process();
  var DEP_MAIN_BLOCKLIST = ["lib", "lib/index", "es", "es/index", "main"];
  var DEFAULT_EXPORT_NAME = "__default__";
  function groupDepsByPack(deps) {
    const depMap = {};
    const addDep = (pkg, dep) => {
      if (!depMap[pkg]) {
        depMap[pkg] = [];
      }
      depMap[pkg].push(dep);
    };
    deps.forEach((dep) => {
      if (dep.dependencyType === "Internal" /* Internal */) {
        addDep(`${dep.moduleName}${dep.main ? `/${dep.main}` : ""}`, dep);
      } else {
        let depMain = "";
        if (dep.main && DEP_MAIN_BLOCKLIST.indexOf(dep.main) < 0) {
          depMain = dep.main;
        }
        if (depMain.substring(0, 1) === "/") {
          depMain = depMain.substring(1);
        }
        addDep(`${dep.package}${depMain ? `/${depMain}` : ""}`, dep);
      }
    });
    return depMap;
  }
  function getDependencyIdentifier(info) {
    return info.aliasName || info.exportName;
  }
  function getExportNameOfDep(dep) {
    if (dep.destructuring) {
      return dep.exportName || dep.componentName || throwNewError("destructuring dependency must have exportName or componentName");
    }
    if (!dep.subName) {
      return dep.componentName || dep.exportName || throwNewError("dependency item must have componentName or exportName");
    }
    return dep.exportName || `__$${camelCase_default(
      get_default(dep, "moduleName") || get_default(dep, "package") || throwNewError("dep.moduleName or dep.package is undefined")
    )}_default`;
  }
  function throwNewError(msg) {
    throw new Error(msg);
  }
  function buildPackageImport(pkg, deps, targetFileType, useAliasName) {
    if (!pkg || pkg === "undefined" || pkg === "null") {
      return [];
    }
    const chunks = [];
    const exportItems = {};
    const defaultExportNames = [];
    const depsInfo = deps.map((dep) => {
      const info = {
        exportName: getExportNameOfDep(dep),
        isDefault: !dep.destructuring,
        subName: dep.subName || void 0,
        nodeIdentifier: dep.componentName || void 0,
        source: dep
      };
      if (info.isDefault) {
        if (defaultExportNames.indexOf(info.exportName) < 0) {
          defaultExportNames.push(info.exportName);
        }
      }
      if (!info.subName) {
        if (info.nodeIdentifier === info.exportName) {
          info.nodeIdentifier = void 0;
        }
        if (info.isDefault) {
          info.aliasName = info.nodeIdentifier || info.exportName;
          info.exportName = DEFAULT_EXPORT_NAME;
        }
        if (info.nodeIdentifier) {
          info.aliasName = info.nodeIdentifier;
          info.nodeIdentifier = void 0;
        }
      } else {
        if (info.isDefault) {
          info.aliasName = info.exportName;
          info.exportName = DEFAULT_EXPORT_NAME;
        }
        if (info.nodeIdentifier === `${info.exportName}.${info.subName}`) {
          info.nodeIdentifier = void 0;
        }
      }
      return info;
    });
    depsInfo.forEach((info) => {
      if (!exportItems[info.exportName]) {
        exportItems[info.exportName] = {
          exportName: info.exportName,
          isDefault: info.isDefault,
          aliasNames: [],
          needOriginExport: false
        };
      }
      if (!info.nodeIdentifier && !info.aliasName) {
        exportItems[info.exportName].needOriginExport = true;
      }
    });
    depsInfo.forEach((info) => {
      if (info.aliasName) {
        const { aliasNames } = exportItems[info.exportName];
        if (aliasNames.indexOf(info.aliasName) < 0) {
          aliasNames.push(info.aliasName);
        }
      }
    });
    depsInfo.forEach((info) => {
      if (info.nodeIdentifier) {
        const exportItem = exportItems[info.exportName];
        if (!exportItem.needOriginExport && exportItem.aliasNames.length > 0) {
          info.aliasName = exportItem.aliasNames[0];
        }
      }
    });
    const nodeIdentifiers = depsInfo.map((info) => info.nodeIdentifier).filter(Boolean);
    const conflictInfos = flatMap_default(Object.keys(exportItems), (exportName) => {
      const exportItem = exportItems[exportName];
      const usedNames = [
        ...exportItem.aliasNames,
        ...exportItem.needOriginExport || exportItem.aliasNames.length <= 0 ? [exportName] : []
      ];
      const conflictNames = usedNames.filter((n) => nodeIdentifiers.indexOf(n) >= 0);
      if (conflictNames.length > 0) {
        return [
          ...conflictNames.indexOf(exportName) >= 0 ? [[exportName, true, exportItem]] : [],
          ...conflictNames.filter((n) => n !== exportName).map((n) => [n, false, exportItem])
        ];
      }
      return [];
    });
    const conflictExports = conflictInfos.filter((c) => c[1]).map((c) => c[0]);
    const conflictAlias = conflictInfos.filter((c) => !c[1]).map((c) => c[0]);
    const solutions = {};
    depsInfo.forEach((info) => {
      if (info.aliasName && conflictAlias.indexOf(info.aliasName) >= 0) {
        let solution = solutions[info.aliasName];
        if (!solution) {
          solution = `${info.aliasName}Alias`;
          const conflictItem = (conflictInfos.find((c) => c[0] === info.aliasName) || [])[2];
          conflictItem.aliasNames = conflictItem.aliasNames.filter((a) => a !== info.aliasName);
          conflictItem.aliasNames.push(solution);
          solutions[info.aliasName] = solution;
        }
        info.aliasName = solution;
      }
      if (conflictExports.indexOf(info.exportName) >= 0) {
        let solution = solutions[info.exportName];
        if (!solution) {
          solution = `${info.exportName}Export`;
          const conflictItem = (conflictInfos.find((c) => c[0] === info.exportName) || [])[2];
          conflictItem.aliasNames.push(solution);
          conflictItem.needOriginExport = false;
          solutions[info.exportName] = solution;
        }
        info.aliasName = solution;
      }
    });
    depsInfo.forEach((info) => {
      const name = info.aliasName || info.exportName;
      if (!isValidIdentifier(name)) {
        throw new CodeGeneratorError(`Invalid Identifier [${name}]`);
      }
      if (info.nodeIdentifier && !isValidIdentifier(info.nodeIdentifier)) {
        throw new CodeGeneratorError(`Invalid Identifier [${info.nodeIdentifier}]`);
      }
    });
    const aliasDefineStatements = {};
    if (useAliasName) {
      Object.keys(exportItems).forEach((exportName) => {
        var _a;
        const aliasList = ((_a = exportItems[exportName]) == null ? void 0 : _a.aliasNames) || [];
        if (aliasList.length > 0) {
          const srcName = exportItems[exportName].needOriginExport ? exportName : aliasList[0];
          const aliasNameList = exportItems[exportName].needOriginExport ? aliasList : aliasList.slice(1);
          aliasNameList.forEach((a) => {
            if (!aliasDefineStatements[a]) {
              aliasDefineStatements[a] = `const ${a} = ${srcName};`;
            }
          });
        }
      });
    }
    function getDefaultExportName(info) {
      if (info.isDefault) {
        return defaultExportNames[0];
      }
      return info.exportName;
    }
    depsInfo.forEach((info) => {
      if (info.nodeIdentifier) {
        const ownerName = getDependencyIdentifier(info);
        chunks.push({
          type: "string" /* STRING */,
          fileType: targetFileType,
          name: COMMON_CHUNK_NAME.ImportAliasDefine,
          content: useAliasName ? `const ${info.nodeIdentifier} = ${ownerName}.${info.subName};` : "",
          linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport, COMMON_CHUNK_NAME.InternalDepsImport],
          ext: {
            originalName: `${getDefaultExportName(info)}.${info.subName}`,
            aliasName: info.nodeIdentifier,
            dependency: info.source
          }
        });
      } else if (info.aliasName) {
        if (info.isDefault && defaultExportNames.find((n) => n === info.aliasName)) {
          delete aliasDefineStatements[info.aliasName];
          return;
        }
        let contentStatement = "";
        if (aliasDefineStatements[info.aliasName]) {
          contentStatement = aliasDefineStatements[info.aliasName];
          delete aliasDefineStatements[info.aliasName];
        }
        chunks.push({
          type: "string" /* STRING */,
          fileType: targetFileType,
          name: COMMON_CHUNK_NAME.ImportAliasDefine,
          content: contentStatement,
          linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport, COMMON_CHUNK_NAME.InternalDepsImport],
          ext: {
            originalName: getDefaultExportName(info),
            aliasName: info.aliasName,
            dependency: info.source
          }
        });
      }
    });
    Object.keys(aliasDefineStatements).forEach((a) => {
      chunks.push({
        type: "string" /* STRING */,
        fileType: targetFileType,
        name: COMMON_CHUNK_NAME.ImportAliasDefine,
        content: aliasDefineStatements[a],
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport, COMMON_CHUNK_NAME.InternalDepsImport]
      });
    });
    const exportItemList = Object.keys(exportItems).map((k) => exportItems[k]);
    const defaultExport = exportItemList.filter((item) => item.isDefault);
    const otherExports = exportItemList.filter((item) => !item.isDefault);
    const statementL = ["import"];
    if (defaultExport.length > 0) {
      if (useAliasName) {
        statementL.push(defaultExportNames[0]);
      } else {
        statementL.push(defaultExport[0].aliasNames[0]);
      }
      if (otherExports.length > 0) {
        statementL.push(", ");
      }
    }
    if (otherExports.length > 0) {
      const items = otherExports.map((item) => {
        return !useAliasName || item.needOriginExport || item.aliasNames.length <= 0 ? item.exportName : `${item.exportName} as ${item.aliasNames[0]}`;
      });
      statementL.push(`{ ${items.join(", ")} }`);
    }
    statementL.push("from");
    const getInternalDependencyModuleId = () => `@src/${deps[0].type}/${pkg}`;
    if (deps[0].dependencyType === "Internal" /* Internal */) {
      statementL.push(`'${getInternalDependencyModuleId()}';`);
      chunks.push({
        type: "string" /* STRING */,
        fileType: targetFileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: statementL.join(" "),
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
    } else {
      statementL.push(`'${pkg}';`);
      chunks.push({
        type: "string" /* STRING */,
        fileType: targetFileType,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: statementL.join(" "),
        linkAfter: []
      });
    }
    if (defaultExportNames.length > 1) {
      if (deps[0].dependencyType === "Internal" /* Internal */) {
        defaultExportNames.slice(1).forEach((exportName) => {
          chunks.push({
            type: "string" /* STRING */,
            fileType: targetFileType,
            name: COMMON_CHUNK_NAME.InternalDepsImport,
            content: `import ${exportName} from '${getInternalDependencyModuleId()}';`,
            linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
          });
        });
      } else {
        defaultExportNames.slice(1).forEach((exportName) => {
          chunks.push({
            type: "string" /* STRING */,
            fileType: targetFileType,
            name: COMMON_CHUNK_NAME.ExternalDepsImport,
            content: `import ${exportName} from '${pkg}';`,
            linkAfter: []
          });
          chunks.push({
            type: "string" /* STRING */,
            fileType: targetFileType,
            name: COMMON_CHUNK_NAME.ImportAliasDefine,
            content: "",
            linkAfter: [],
            ext: {
              aliasName: exportName,
              originalName: exportName,
              dependency: {
                package: pkg,
                componentName: exportName
              }
            }
          });
        });
      }
    }
    return chunks;
  }
  var pluginFactory = (config) => {
    const cfg = {
      fileType: "js" /* JS */,
      useAliasName: true,
      ...config || {}
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (ir && ir.deps && ir.deps.length > 0) {
        const packs = groupDepsByPack(ir.deps);
        Object.keys(packs).forEach((pkg) => {
          const chunks = buildPackageImport(pkg, packs[pkg], cfg.fileType, cfg.useAliasName);
          next.chunks.push(...chunks);
        });
      }
      return next;
    };
    return plugin;
  };
  var esmodule_default = pluginFactory;

  // src/plugins/component/react/containerClass.ts
  init_define_process();
  var import_change_case3 = __toESM(require_change_case());

  // src/plugins/component/react/const.ts
  init_define_process();
  var REACT_CHUNK_NAME = {
    ClassRenderStart: "ReactComponentClassRenderStart",
    ClassRenderPre: "ReactComponentClassRenderPre",
    ClassRenderEnd: "ReactComponentClassRenderEnd",
    ClassRenderJSX: "ReactComponentClassRenderJSX",
    ClassDidMountStart: "ReactComponentClassDidMountStart",
    ClassDidMountEnd: "ReactComponentClassDidMountEnd",
    ClassDidMountContent: "ReactComponentClassDidMountContent"
  };

  // src/plugins/component/react/containerClass.ts
  var pluginFactory2 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const componentClassName = ensureValidClassName(
        `${import_change_case3.default.pascalCase(ir.moduleName)}$$Page`
      );
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.Start,
        content: `class ${componentClassName} extends React.Component {`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.End,
        content: "}",
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End],
          REACT_CHUNK_NAME.ClassRenderEnd,
          REACT_CHUNK_NAME.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorStart,
        content: "constructor(props, context) { super(props); ",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorEnd,
        content: "}",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorEnd]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassDidMountStart,
        content: "componentDidMount() {",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassDidMountEnd,
        content: "}",
        linkAfter: [REACT_CHUNK_NAME.ClassDidMountContent, REACT_CHUNK_NAME.ClassDidMountStart]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassRenderStart,
        content: "render() {",
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End],
          REACT_CHUNK_NAME.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME.ClassRenderEnd,
        content: "}",
        linkAfter: [
          REACT_CHUNK_NAME.ClassRenderStart,
          REACT_CHUNK_NAME.ClassRenderPre,
          REACT_CHUNK_NAME.ClassRenderJSX
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `export default ${componentClassName};`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          CLASS_DEFINE_CHUNK_NAME.End
        ]
      });
      return next;
    };
    return plugin;
  };
  var containerClass_default = pluginFactory2;

  // src/plugins/component/react/containerInitState.ts
  init_define_process();

  // src/utils/compositeType.ts
  var compositeType_exports = {};
  __export(compositeType_exports, {
    generateCompositeType: () => generateCompositeType
  });
  init_define_process();

  // src/utils/jsExpression.ts
  var jsExpression_exports = {};
  __export(jsExpression_exports, {
    generateExpression: () => generateExpression,
    generateFunction: () => generateFunction,
    isJsCode: () => isJsCode
  });
  init_define_process();
  var parser2 = __toESM(require_lib2());
  var import_generator6 = __toESM(require_lib6());
  var import_traverse2 = __toESM(require_lib14());
  var t2 = __toESM(require_lib5());

  // src/utils/expressionParser.ts
  var expressionParser_exports = {};
  __export(expressionParser_exports, {
    ParseError: () => ParseError,
    parseExpression: () => parseExpression2,
    parseExpressionConvertThis2Context: () => parseExpressionConvertThis2Context,
    parseExpressionGetGlobalVariables: () => parseExpressionGetGlobalVariables,
    parseExpressionGetKeywords: () => parseExpressionGetKeywords,
    transformExpressionLocalRef: () => transformExpressionLocalRef
  });
  init_define_process();
  var parser = __toESM(require_lib2());
  var import_generator5 = __toESM(require_lib6());
  var import_traverse = __toESM(require_lib14());
  var t = __toESM(require_lib5());
  var import_types7 = __toESM(require_lib5());

  // src/utils/OrderedSet.ts
  init_define_process();
  var OrderedSet = class {
    constructor(items) {
      __publicField(this, "_set", /* @__PURE__ */ new Set());
      __publicField(this, "_arr", []);
      if (items) {
        this._set = new Set(items);
        this._arr = items.slice(0);
      }
    }
    add(item) {
      if (!this._set.has(item)) {
        this._set.add(item);
        this._arr.push(item);
      }
    }
    delete(item) {
      if (this._set.has(item)) {
        this._set.delete(item);
        this._arr.splice(this._arr.indexOf(item), 1);
      }
    }
    has(item) {
      return this._set.has(item);
    }
    toArray() {
      return this._arr.slice(0);
    }
  };

  // src/utils/expressionParser.ts
  var ParseError = class extends Error {
    constructor(expr, detail) {
      super(`Failed to parse expression "${typeof expr === "string" ? expr : (0, import_generator5.default)(expr)}"`);
      __publicField(this, "expr");
      __publicField(this, "detail");
      this.expr = expr;
      this.detail = detail;
      Object.setPrototypeOf(this, new.target.prototype);
    }
  };
  var MAYBE_EXPRESSIONS = {
    ArrayExpression: { fields: ["elements"] },
    AssignmentExpression: { fields: ["left", "right"] },
    BinaryExpression: { fields: ["left", "right"] },
    CallExpression: { fields: ["arguments", "callee"] },
    ConditionalExpression: { fields: ["test", "consequent", "alternate"] },
    DoWhileStatement: { fields: ["test"] },
    ExpressionStatement: { fields: ["expression"] },
    ForInStatement: { fields: ["right"] },
    ForStatement: { fields: ["init", "test", "update"] },
    IfStatement: { fields: ["test"] },
    LogicalExpression: { fields: ["left", "right"] },
    MemberExpression: {
      fields: (node) => {
        return node.type === "MemberExpression" && node.computed ? ["object", "property"] : ["object"];
      }
    },
    NewExpression: { fields: ["callee", "arguments"] },
    ObjectMethod: {
      fields: (node) => {
        return node.type === "ObjectMethod" && node.computed ? ["key"] : [];
      }
    },
    ObjectProperty: {
      fields: (node) => {
        return node.type === "ObjectProperty" && node.computed ? ["key", "value"] : ["value"];
      }
    },
    ReturnStatement: { fields: ["argument"] },
    SequenceExpression: { fields: ["expressions"] },
    ParenthesizedExpression: { fields: ["expression"] },
    SwitchCase: { fields: ["test"] },
    SwitchStatement: { fields: ["discriminant"] },
    ThrowStatement: { fields: ["argument"] },
    UnaryExpression: { fields: ["argument"] },
    UpdateExpression: { fields: ["argument"] },
    VariableDeclarator: { fields: ["init"] },
    WhileStatement: { fields: ["test"] },
    WithStatement: { fields: ["object"] },
    AssignmentPattern: { fields: ["right"] },
    ArrowFunctionExpression: { fields: ["body"] },
    ClassExpression: { fields: ["superClass"] },
    ClassDeclaration: { fields: ["superClass"] },
    ExportDefaultDeclaration: { fields: ["declaration"] },
    ForOfStatement: { fields: ["right"] },
    ClassMethod: {
      fields: (node) => {
        return node.type === "ClassMethod" && node.computed ? ["key"] : [];
      }
    },
    SpreadElement: { fields: ["argument"] },
    TaggedTemplateExpression: { fields: ["tag"] },
    TemplateLiteral: { fields: ["expressions"] },
    YieldExpression: { fields: ["argument"] },
    AwaitExpression: { fields: ["argument"] },
    OptionalMemberExpression: {
      fields: (node) => {
        return node.type === "OptionalMemberExpression" && node.computed ? ["object", "property"] : ["object"];
      }
    },
    OptionalCallExpression: { fields: ["callee", "arguments"] },
    JSXSpreadAttribute: { fields: ["argument"] },
    BindExpression: { fields: ["object", "callee"] },
    ClassProperty: {
      fields: (node) => {
        return node.type === "ClassProperty" && node.computed ? ["key", "value"] : ["value"];
      }
    },
    PipelineTopicExpression: { fields: ["expression"] },
    PipelineBareFunction: { fields: ["callee"] },
    ClassPrivateProperty: { fields: ["value"] },
    Decorator: { fields: ["expression"] },
    TupleExpression: { fields: ["elements"] },
    TSDeclareMethod: {
      fields: (node) => {
        return node.type === "TSDeclareMethod" && node.computed ? ["key"] : [];
      }
    },
    TSPropertySignature: {
      fields: (node) => {
        return node.type === "TSPropertySignature" && node.computed ? ["key", "initializer"] : ["initializer"];
      }
    },
    TSMethodSignature: {
      fields: (node) => {
        return node.type === "TSMethodSignature" && node.computed ? ["key"] : [];
      }
    },
    TSAsExpression: { fields: ["expression"] },
    TSTypeAssertion: { fields: ["expression"] },
    TSEnumDeclaration: { fields: ["initializer"] },
    TSEnumMember: { fields: ["initializer"] },
    TSNonNullExpression: { fields: ["expression"] },
    TSExportAssignment: { fields: ["expression"] }
  };
  var CROSS_THIS_SCOPE_TYPE_NODE = {
    ArrowFunctionExpression: false,
    FunctionExpression: true,
    FunctionDeclaration: true,
    ClassDeclaration: true,
    ClassExpression: true,
    ClassBody: true,
    ClassImplements: true,
    ClassMethod: true,
    ClassPrivateMethod: true,
    ClassProperty: true,
    ClassPrivateProperty: true,
    DeclareClass: true
  };
  var JS_KEYWORDS = ["arguments", "this", "super"];
  function parseExpressionGetKeywords(expr) {
    if (!expr) {
      return [];
    }
    try {
      const keywordVars = new OrderedSet();
      const ast = parser.parse(`!(${expr});`);
      const addIdentifierIfNeeded = (x) => {
        if (typeof x === "object" && (0, import_types7.isIdentifier)(x) && JS_KEYWORDS.includes(x.name)) {
          keywordVars.add(x.name);
        }
      };
      (0, import_traverse.default)(ast, {
        enter(path) {
          var _a;
          const { node } = path;
          const expressionFields = (_a = MAYBE_EXPRESSIONS[node.type]) == null ? void 0 : _a.fields;
          if (expressionFields) {
            (typeof expressionFields === "function" ? expressionFields(node) : expressionFields).forEach((fieldName) => {
              const fieldValue = node[fieldName];
              if (typeof fieldValue === "object") {
                if (Array.isArray(fieldValue)) {
                  fieldValue.forEach((item) => {
                    addIdentifierIfNeeded(item);
                  });
                } else {
                  addIdentifierIfNeeded(fieldValue);
                }
              }
            });
          }
        }
      });
      return keywordVars.toArray().filter(Boolean);
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function parseExpressionGetGlobalVariables(expr, { filter: filter2 = () => true } = {}) {
    if (!expr) {
      return [];
    }
    try {
      const undeclaredVars = new OrderedSet();
      const ast = parser.parse(`!(${expr});`);
      const addUndeclaredIdentifierIfNeeded = (x, path) => {
        if (typeof x === "object" && (0, import_types7.isIdentifier)(x) && !path.scope.hasBinding(x.name)) {
          undeclaredVars.add(x.name);
        }
      };
      (0, import_traverse.default)(ast, {
        enter(path) {
          var _a;
          const { node } = path;
          const expressionFields = (_a = MAYBE_EXPRESSIONS[node.type]) == null ? void 0 : _a.fields;
          if (expressionFields) {
            (typeof expressionFields === "function" ? expressionFields(node) : expressionFields).forEach((fieldName) => {
              const fieldValue = node[fieldName];
              if (typeof fieldValue === "object") {
                if (Array.isArray(fieldValue)) {
                  fieldValue.forEach((item) => {
                    addUndeclaredIdentifierIfNeeded(item, path);
                  });
                } else {
                  addUndeclaredIdentifierIfNeeded(fieldValue, path);
                }
              }
            });
          }
        }
      });
      return undeclaredVars.toArray().filter(filter2);
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function parseExpressionConvertThis2Context(expr, contextName = "__$$context", localVariables = []) {
    if (!expr) {
      return expr;
    }
    try {
      const exprAst = typeof expr === "string" ? parser.parseExpression(expr) : expr;
      const exprWrapAst = t.expressionStatement(exprAst);
      const fileAst = t.file(t.program([exprWrapAst]));
      const localVariablesSet = new Set(localVariables);
      let thisScopeLevel = CROSS_THIS_SCOPE_TYPE_NODE[exprAst.type] ? -1 : 0;
      (0, import_traverse.default)(fileAst, {
        enter(path) {
          if (CROSS_THIS_SCOPE_TYPE_NODE[path.node.type]) {
            thisScopeLevel++;
          }
        },
        exit(path) {
          if (CROSS_THIS_SCOPE_TYPE_NODE[path.node.type]) {
            thisScopeLevel--;
          }
        },
        MemberExpression(path) {
          if (!path.isMemberExpression()) {
            return;
          }
          const obj = path.get("object");
          if (!obj.isThisExpression()) {
            return;
          }
          if (!path.node.computed) {
            const prop = path.get("property");
            if (prop.isIdentifier() && localVariablesSet.has(prop.node.name)) {
              path.replaceWith(t.identifier(prop.node.name));
              return;
            }
          }
          if (thisScopeLevel <= 0) {
            obj.replaceWith(t.identifier(contextName));
          }
        },
        ThisExpression(path) {
          if (!path.isThisExpression()) {
            return;
          }
          if (path.parent.type === "MemberExpression") {
            return;
          }
          if (thisScopeLevel <= 0) {
            path.replaceWith(t.identifier(contextName));
          }
        }
      });
      const { code } = (0, import_generator5.default)(exprWrapAst.expression, { sourceMaps: false });
      return code;
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function parseExpression2(expr) {
    try {
      return parser.parseExpression(expr);
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }
  function transformExpressionLocalRef(expr, scope) {
    if (!expr) {
      return expr;
    }
    if (!scope) {
      throw new Error("transform expression without scope");
    }
    try {
      const exprAst = typeof expr === "string" ? parser.parseExpression(expr) : expr;
      const exprWrapAst = t.expressionStatement(exprAst);
      const fileAst = t.file(t.program([exprWrapAst]));
      (0, import_traverse.default)(fileAst, {
        MemberExpression(path) {
          if (!path.isMemberExpression()) {
            return;
          }
          const obj = path.get("object");
          if (!obj.isThisExpression()) {
            return;
          }
          const prop = path.get("property");
          let memberName = "";
          if (!path.node.computed && prop.isIdentifier()) {
            memberName = prop.node.name;
          } else if (path.node.computed && prop.isStringLiteral()) {
            memberName = prop.node.value;
          }
          if (memberName && scope.bindings && scope.bindings.hasBinding(memberName)) {
            path.replaceWith(t.identifier(memberName));
          }
        }
      });
      const { code } = (0, import_generator5.default)(exprWrapAst.expression, { sourceMaps: false });
      return code;
    } catch (e) {
      throw new ParseError(expr, e);
    }
  }

  // src/utils/jsExpression.ts
  function parseFunction(content) {
    try {
      const ast = parser2.parse(`(${content});`);
      let resultNode = null;
      (0, import_traverse2.default)(ast, {
        FunctionExpression(path) {
          resultNode = path.node;
          path.stop();
        }
      });
      return resultNode;
    } catch (e) {
      throw new ParseError(content, e);
    }
  }
  function transformFuncExpr2MethodMember(methodName, content) {
    const funcNode = parseFunction(content);
    if (funcNode) {
      const targetNode = t2.classMethod(
        "method",
        methodName && t2.identifier(methodName) || funcNode.id || t2.identifier("notDefineName"),
        funcNode.params,
        funcNode.body,
        void 0,
        void 0,
        void 0,
        funcNode.async || void 0
      );
      const { code: resultCode } = (0, import_generator6.default)(targetNode, { sourceMaps: false });
      return resultCode;
    }
    throw new Error("Can not find Function Statement");
  }
  function getArrowFunction(content) {
    const funcNode = parseFunction(content);
    if (funcNode) {
      const targetNode = t2.arrowFunctionExpression(
        funcNode.params,
        funcNode.body,
        funcNode.async || void 0
      );
      const { code: resultCode } = (0, import_generator6.default)(targetNode, { sourceMaps: false });
      return resultCode;
    }
    throw new Error("Can not find Function Statement");
  }
  function getBodyStatements(content) {
    const funcNode = parseFunction(content);
    if (funcNode) {
      const statements = funcNode.body.body;
      const targetNode = t2.program(statements, void 0, "module", void 0);
      const { code: resultCode } = (0, import_generator6.default)(targetNode, { sourceMaps: false });
      return resultCode;
    }
    throw new Error("Can not find Function Statement");
  }
  function isJsCode(value) {
    return isJSExpression(value) || isJSFunction(value);
  }
  function generateExpression(value, scope) {
    if (isJSExpression(value)) {
      const exprVal = value.value.trim();
      if (!exprVal) {
        return "null";
      }
      const afterProcessWithLocals = transformExpressionLocalRef(exprVal, scope);
      return afterProcessWithLocals;
    }
    throw new CodeGeneratorError("Not a JSExpression");
  }
  function generateFunction(value, config = {
    name: void 0,
    isMember: false,
    isBlock: false,
    isArrow: false,
    isBindExpr: false
  }) {
    if (isJsCode(value)) {
      const functionCfg = value;
      if (config.isMember) {
        return transformFuncExpr2MethodMember(config.name || "", functionCfg.value);
      }
      if (config.isBlock) {
        return getBodyStatements(functionCfg.value);
      }
      if (config.isArrow) {
        return getArrowFunction(functionCfg.value);
      }
      if (config.isBindExpr) {
        return `(${functionCfg.value}).bind(this)`;
      }
      return functionCfg.value;
    }
    throw new CodeGeneratorError("Not a JSFunction or JSExpression");
  }

  // src/utils/jsSlot.ts
  var jsSlot_exports = {};
  __export(jsSlot_exports, {
    generateJsSlot: () => generateJsSlot
  });
  init_define_process();

  // src/utils/jsxHelpers.ts
  init_define_process();
  function unwrapJsExprQuoteInJsx(jsxExpr) {
    if (jsxExpr.length >= 2 && jsxExpr[0] === "{" && jsxExpr[jsxExpr.length - 1] === "}") {
      return jsxExpr.slice(1, jsxExpr.length - 1);
    }
    return jsxExpr;
  }

  // src/utils/jsSlot.ts
  function generateSingleLineComment(commentText) {
    return `/* ${commentText.split("\n").join(" ").replace(/\*\//g, "*-/")}*/`;
  }
  function generateJsSlot(slot, scope, generator) {
    if (isJSSlot(slot)) {
      const { title, params, value } = slot;
      const slotScope = params ? scope.createSubScope(params || []) : scope;
      const contentExpr = !value ? "null" : generateNodeDataOrArrayForJsSlot(value, generator, slotScope);
      if (params) {
        return [
          title && generateSingleLineComment(title),
          "(",
          (params || []).join(", "),
          ") => ((__$$context) => (",
          contentExpr,
          "))(",
          `  __$$createChildContext(__$$context, { ${(params || []).join(", ")} }`,
          "))"
        ].filter(Boolean).join("");
      }
      return contentExpr || "[]";
    }
    throw new CodeGeneratorError("Not a JSSlot");
  }
  function generateNodeDataOrArrayForJsSlot(value, generator, scope) {
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return "[]";
      }
      if (value.length === 1) {
        return unwrapJsExprQuoteInJsx(generator(value, scope)) || "null";
      }
      return `[
${value.map((v) => {
        if (typeof v === "string") {
          return JSON.stringify(v);
        }
        return unwrapJsExprQuoteInJsx(generator(v, scope)) || "null";
      }).join(",\n") || "null"}
]`;
    }
    return unwrapJsExprQuoteInJsx(generator(value, scope)) || "null";
  }

  // src/utils/aopHelper.ts
  init_define_process();
  function executeFunctionStack(input, scope, funcs, baseFunc, config) {
    const funcList = [];
    if (Array.isArray(funcs)) {
      funcList.push(...funcs);
    } else {
      funcList.push(funcs);
    }
    let next = baseFunc;
    while (funcList.length > 0) {
      const func = funcList.pop();
      if (func) {
        const warppedFunc = ((nextFunc) => (i, s, cfg) => func(i, s, cfg, nextFunc))(next);
        next = warppedFunc;
      }
    }
    return next(input, scope, config);
  }

  // src/utils/compositeType.ts
  function isVariable(v) {
    if (lodash_default_default.isObject(v) && v.type === "variable") {
      return true;
    }
    return false;
  }
  function isDataSource(v) {
    return typeof v === "object" && v != null && v.type === "DataSource";
  }
  function generateArray(value, scope, options = {}) {
    const body = value.map((v) => generateUnknownType(v, scope, options)).join(",");
    return `[${body}]`;
  }
  function generateObject(value, scope, options = {}) {
    if (value.type === "i18n") {
      if (value.params && typeof value.params === "object") {
        return `this._i18nText(${generateUnknownType(lodash_default_default.omit(value, "type"), scope, options)})`;
      }
      return `this._i18nText(${JSON.stringify(lodash_default_default.omit(value, "type"))})`;
    }
    const body = Object.keys(value).map((key) => {
      const propName = JSON.stringify(key);
      const v = generateUnknownType(value[key], scope, options);
      return `${propName}: ${v}`;
    }).join(",\n");
    return `{${body}}`;
  }
  function generateString(value) {
    return JSON.stringify(value);
  }
  function generateNumber(value) {
    return String(value);
  }
  function generateBool(value) {
    return value ? "true" : "false";
  }
  function genFunction(value) {
    const globalVars = parseExpressionGetKeywords(value.value);
    if (globalVars.includes("arguments")) {
      return generateFunction(value, { isBindExpr: true });
    }
    return generateFunction(value, { isArrow: true });
  }
  function genJsSlot(value, scope, options = {}) {
    if (options.nodeGenerator) {
      return generateJsSlot(value, scope, options.nodeGenerator);
    }
    return "";
  }
  function generateUnknownType(value, scope, options = {}) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    if (lodash_default_default.isUndefined(value)) {
      return "undefined";
    }
    if (lodash_default_default.isNull(value)) {
      return "null";
    }
    if (lodash_default_default.isArray(value)) {
      if ((_a = options.handlers) == null ? void 0 : _a.array) {
        return executeFunctionStack(value, scope, options.handlers.array, generateArray, options);
      }
      return generateArray(value, scope, options);
    }
    if (isVariable(value)) {
      const transValue = {
        type: "JSExpression",
        value: value.variable
      };
      if ((_b = options.handlers) == null ? void 0 : _b.expression) {
        return executeFunctionStack(
          transValue,
          scope,
          options.handlers.expression,
          generateExpression,
          options
        );
      }
      return generateExpression(transValue, scope);
    }
    if (isJSExpression(value)) {
      if ((_c = options.handlers) == null ? void 0 : _c.expression) {
        return executeFunctionStack(
          value,
          scope,
          options.handlers.expression,
          generateExpression,
          options
        );
      }
      return generateExpression(value, scope);
    }
    if (isJSFunction(value)) {
      if ((_d = options.handlers) == null ? void 0 : _d.function) {
        return executeFunctionStack(value, scope, options.handlers.function, genFunction, options);
      }
      return genFunction(value);
    }
    if (isJSSlot(value)) {
      if ((_e = options.handlers) == null ? void 0 : _e.slot) {
        return executeFunctionStack(value, scope, options.handlers.slot, genJsSlot, options);
      }
      return genJsSlot(value, scope, options);
    }
    if (isDataSource(value)) {
      return generateUnknownType(
        {
          type: "JSExpression",
          value: `this.dataSourceMap[${JSON.stringify(value.id)}]`
        },
        scope,
        options
      );
    }
    if (lodash_default_default.isObject(value)) {
      if ((_f = options.handlers) == null ? void 0 : _f.object) {
        return executeFunctionStack(value, scope, options.handlers.object, generateObject, options);
      }
      return generateObject(value, scope, options);
    }
    if (lodash_default_default.isString(value)) {
      if ((_g = options.handlers) == null ? void 0 : _g.string) {
        return executeFunctionStack(value, scope, options.handlers.string, generateString, options);
      }
      return generateString(value);
    }
    if (lodash_default_default.isNumber(value)) {
      if ((_h = options.handlers) == null ? void 0 : _h.number) {
        return executeFunctionStack(value, scope, options.handlers.number, generateNumber, options);
      }
      return generateNumber(value);
    }
    if (lodash_default_default.isBoolean(value)) {
      if ((_i = options.handlers) == null ? void 0 : _i.boolean) {
        return executeFunctionStack(value, scope, options.handlers.boolean, generateBool, options);
      }
      return generateBool(value);
    }
    throw new CodeGeneratorError("Meet unknown composite value type");
  }
  function generateCompositeType(value, scope, options = {}) {
    const result2 = generateUnknownType(value, scope, options);
    return result2;
  }

  // src/utils/Scope.ts
  var Scope_exports = {};
  __export(Scope_exports, {
    Scope: () => Scope
  });
  init_define_process();

  // src/utils/ScopeBindings.ts
  init_define_process();
  var ScopeBindings = class {
    constructor(p = null) {
      __publicField(this, "parent");
      __publicField(this, "_bindings", new OrderedSet());
      this.parent = p;
    }
    hasBinding(varName) {
      var _a;
      return this._bindings.has(varName) || !!((_a = this.parent) == null ? void 0 : _a.hasBinding(varName));
    }
    hasOwnBinding(varName) {
      return this._bindings.has(varName);
    }
    addBinding(varName) {
      this._bindings.add(varName);
    }
    removeBinding(varName) {
      this._bindings.delete(varName);
    }
    getAllBindings() {
      const allBindings = new OrderedSet(this._bindings.toArray());
      for (let { parent: parent2 } = this; parent2; parent2 = parent2 == null ? void 0 : parent2.parent) {
        parent2.getAllOwnedBindings().forEach((varName) => {
          allBindings.add(varName);
        });
      }
      return allBindings.toArray();
    }
    getAllOwnedBindings() {
      return this._bindings.toArray();
    }
  };

  // src/utils/Scope.ts
  var Scope = class {
    constructor(parent2 = null) {
      this.parent = parent2;
      __publicField(this, "bindings");
      this.bindings = void 0;
    }
    static createRootScope() {
      return new Scope();
    }
    createSubScope(ownIdentifiers) {
      const originalScopeBindings = this.bindings;
      const newScopeBindings = new ScopeBindings(originalScopeBindings);
      ownIdentifiers.forEach((identifier3) => {
        newScopeBindings.addBinding(identifier3);
      });
      const newScope = new Scope(this);
      newScope.bindings = newScopeBindings;
      return newScope;
    }
  };

  // src/plugins/component/react/containerInitState.ts
  var pluginFactory3 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      implementType: "inConstructor",
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const state = ir.state || {};
      const fields = Object.keys(state).map((stateName) => {
        const value = generateCompositeType(state[stateName], scope);
        return `${stateName}: ${value},`;
      });
      if (cfg.implementType === "inConstructor") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: `this.state = { ${fields.join("")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      } else if (cfg.implementType === "insMember") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `state = { ${fields.join("")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInitState_default = pluginFactory3;

  // src/plugins/component/react/containerInjectContext.ts
  init_define_process();
  var pluginFactory4 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const { inStrictMode } = next.contextData;
      if (!inStrictMode) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _context = this;
        `,
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
      } else {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _context = this._createContext();
        `,
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
          content: `
          _createContext() {
            const self = this;
            const context = {
              get state() { return self.state; },
              setState(newState, callback) { self.setState(newState, callback); },
              get dataSourceMap() { return self._dataSourceEngine.dataSourceMap || {}; },
              async reloadDataSource() { await self._dataSourceEngine.reloadDataSource(); },
              get utils() { return self.utils; },
              get page() { return context; },
              get component() { return context; },
              get props() { return self.props; },
              get constants() { return self.constants; },
              get $() { return self.$ },
              get $$() { return self.$$ },
              ...this._methods,
            };
  
            return context;
          }
        `,
          linkAfter: DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectContext_default = pluginFactory4;

  // src/plugins/component/react/containerInjectUtils.ts
  init_define_process();
  var pluginFactory5 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.contextData.useRefApi = true;
      const useRef = !!((_a = ir.analyzeResult) == null ? void 0 : _a.isUsingRef);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import utils${useRef ? ", { RefsManager }" : ""} from '../../utils';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: "this.utils = utils;",
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.ConstructorStart]
      });
      if (useRef) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: "this._refsManager = new RefsManager();",
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
          $ = (refName) => {
            return this._refsManager.get(refName);
          }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
          $$ = (refName) => {
            return this._refsManager.getAll(refName);
          }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      } else {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: ` $ = () => null; `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: ` $$ = () => [];        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectUtils_default = pluginFactory5;

  // src/plugins/component/react/containerInjectDataSourceEngine.ts
  init_define_process();
  var import_change_case4 = __toESM(require_change_case());
  var pluginFactory6 = (config) => {
    const cfg = {
      ...config,
      fileType: (config == null ? void 0 : config.fileType) || "jsx" /* JSX */
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const scope = Scope.createRootScope();
      const dataSourceConfig = isContainerSchema(pre.ir) ? pre.ir.dataSource : null;
      const dataSourceItems = dataSourceConfig && dataSourceConfig.list || [];
      const dataSourceEngineOptions = { runtimeConfig: true };
      if (dataSourceItems.length > 0) {
        const requestHandlersMap = {};
        dataSourceItems.forEach((ds) => {
          var _a, _b;
          const dsType = ds.type || "fetch";
          if (!(dsType in requestHandlersMap) && dsType !== "custom") {
            const handlerFactoryName = `__$$create${import_change_case4.default.pascal(dsType)}RequestHandler`;
            requestHandlersMap[dsType] = {
              type: "JSExpression",
              value: handlerFactoryName + (dsType === "urlParams" ? "(window.location.search)" : "()")
            };
            const handlerFactoryExportName = `create${import_change_case4.default.pascal(dsType)}Handler`;
            const handlerPkgName = ((_b = (_a = cfg.datasourceConfig) == null ? void 0 : _a.handlersPackages) == null ? void 0 : _b[dsType]) || `@alilc/lowcode-datasource-${import_change_case4.default.kebab(dsType)}-handler`;
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: "jsx" /* JSX */,
              name: COMMON_CHUNK_NAME.ExternalDepsImport,
              content: `
              import { ${handlerFactoryExportName} as ${handlerFactoryName} } from '${handlerPkgName}';
            `,
              linkAfter: []
            });
          }
        });
        Object.assign(dataSourceEngineOptions, { requestHandlersMap });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "jsx" /* JSX */,
          name: COMMON_CHUNK_NAME.ExternalDepsImport,
          content: `
          import { create as __$$createDataSourceEngine } from '@alilc/lowcode-datasource-engine/runtime';
        `,
          linkAfter: []
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _dataSourceConfig = this._defineDataSourceConfig();
          _dataSourceEngine = __$$createDataSourceEngine(
            this._dataSourceConfig,
            this,
            ${generateCompositeType(dataSourceEngineOptions, scope)}
          );

          get dataSourceMap() {
            return this._dataSourceEngine.dataSourceMap || {};
          }

          reloadDataSource = async () => {
            await this._dataSourceEngine.reloadDataSource();
          }

          `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
        next.chunks.unshift({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: REACT_CHUNK_NAME.ClassDidMountContent,
          content: `
          this._dataSourceEngine.reloadDataSource();
        `,
          linkAfter: [REACT_CHUNK_NAME.ClassDidMountStart]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
  _defineDataSourceConfig() {
    const _this = this;
    return (${generateCompositeType(
            {
              ...dataSourceConfig,
              list: [
                ...dataSourceItems.map((item) => ({
                  ...item,
                  isInit: wrapAsFunction(item.isInit, scope),
                  options: wrapAsFunction(item.options, scope)
                }))
              ]
            },
            scope,
            {
              handlers: {
                function: (jsFunc) => parseExpressionConvertThis2Context(jsFunc.value, "_this"),
                expression: (jsExpr) => parseExpressionConvertThis2Context(jsExpr.value, "_this")
              }
            }
          )});
  }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectDataSourceEngine_default = pluginFactory6;
  function wrapAsFunction(value, scope) {
    if (isJSExpression(value) || isJSFunction(value)) {
      return {
        type: "JSExpression",
        value: `function(){ return ((${value.value}))}`
      };
    }
    return {
      type: "JSExpression",
      value: `function(){return((${generateCompositeType(value, scope)}))}`
    };
  }

  // src/plugins/component/react/containerInjectI18n.ts
  init_define_process();
  var pluginFactory7 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import * as __$$i18n from '../../i18n';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: `
        __$$i18n._inject2(this);
      `,
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectI18n_default = pluginFactory7;

  // src/plugins/component/react/containerLifeCycle.ts
  init_define_process();
  var pluginFactory8 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      exportNameMapping: {},
      normalizeNameMapping: {},
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (ir.lifeCycles) {
        const { lifeCycles } = ir;
        const chunks = Object.keys(lifeCycles).map((lifeCycleName) => {
          if (!isJSFunction(lifeCycles[lifeCycleName]) && !isJSExpression(lifeCycles[lifeCycleName])) {
            return null;
          }
          let normalizeName;
          if (lifeCycleName === "constructor") {
            normalizeName = lifeCycleName;
          } else {
            normalizeName = cfg.normalizeNameMapping[lifeCycleName] || lifeCycleName;
          }
          const exportName = cfg.exportNameMapping[lifeCycleName] || lifeCycleName;
          if (normalizeName === "constructor") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]]
            };
          }
          if (normalizeName === "componentDidMount") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: REACT_CHUNK_NAME.ClassDidMountContent,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [REACT_CHUNK_NAME.ClassDidMountStart]
            };
          }
          if (normalizeName === "render") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: REACT_CHUNK_NAME.ClassRenderPre,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [REACT_CHUNK_NAME.ClassRenderStart]
            };
          }
          return {
            type: "string" /* STRING */,
            fileType: cfg.fileType,
            name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
            content: generateFunction(lifeCycles[lifeCycleName], {
              name: exportName,
              isMember: true
            }),
            linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
          };
        });
        next.chunks.push(...chunks.filter((x) => x !== null));
      }
      return next;
    };
    return plugin;
  };
  var containerLifeCycle_default = pluginFactory8;

  // src/plugins/component/react/containerMethod.ts
  init_define_process();
  var pluginFactory9 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const { inStrictMode } = next.contextData;
      if (!ir.methods) {
        return next;
      }
      const { methods } = ir;
      const chunks = Object.keys(methods).map((methodName) => ({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
        content: generateFunction(methods[methodName], { name: methodName, isMember: true }),
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
      }));
      next.chunks.push(...chunks);
      if (inStrictMode) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: Object.keys(ir.methods).map(
            (methodName) => isValidIdentifier(methodName) ? `.${methodName}` : `[${JSON.stringify(methodName)}]`
          ).map((method2) => `this._context${method2} = this${method2};`).join("\n"),
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerMethod_default = pluginFactory9;

  // src/plugins/component/react/jsx.ts
  init_define_process();

  // src/utils/nodeToJSX.ts
  var nodeToJSX_exports = {};
  __export(nodeToJSX_exports, {
    createNodeGenerator: () => createNodeGenerator,
    createReactNodeGenerator: () => createReactNodeGenerator,
    generateConditionReactCtrl: () => generateConditionReactCtrl,
    generateReactExprInJS: () => generateReactExprInJS,
    generateReactLoopCtrl: () => generateReactLoopCtrl,
    isPureString: () => isPureString
  });
  init_define_process();

  // node_modules/fp-ts/es6/function.js
  init_define_process();
  function pipe(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch (arguments.length) {
      case 1:
        return a;
      case 2:
        return ab(a);
      case 3:
        return bc(ab(a));
      case 4:
        return cd(bc(ab(a)));
      case 5:
        return de(cd(bc(ab(a))));
      case 6:
        return ef(de(cd(bc(ab(a)))));
      case 7:
        return fg(ef(de(cd(bc(ab(a))))));
      case 8:
        return gh(fg(ef(de(cd(bc(ab(a)))))));
      case 9:
        return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
      default: {
        var ret = arguments[0];
        for (var i = 1; i < arguments.length; i++) {
          ret = arguments[i](ret);
        }
        return ret;
      }
    }
  }

  // src/utils/encodeJsxAttrString.ts
  init_define_process();
  var SPECIAL_CHARS = `
\r'"<>&`;
  var SPECIAL_CHARS_REG = new RegExp(
    `[${SPECIAL_CHARS.split("").map((c) => `\\x${lodash_default_default.padStart(c.charCodeAt(0).toString(16), 2, "0")}`).join("")}]`,
    "g"
  );
  function encodeJsxStringNode(str) {
    return str.replace(SPECIAL_CHARS_REG, (c) => `&#${c.charCodeAt(0)};`);
  }

  // src/core/jsx/handlers/transformThis2Context.ts
  init_define_process();
  var import_generator14 = __toESM(require_lib6());
  function transformThis2Context(expr, scope, { ignoreRootScope = false } = {}) {
    var _a;
    if (ignoreRootScope && scope.parent == null) {
      return typeof expr === "string" ? expr : (0, import_generator14.default)(expr).code;
    }
    return parseExpressionConvertThis2Context(
      expr,
      "__$$context",
      ((_a = scope.bindings) == null ? void 0 : _a.getAllBindings()) || []
    );
  }

  // src/utils/nodeToJSX.ts
  function mergeNodeGeneratorConfig(cfg1, cfg2 = {}) {
    const resCfg = {};
    if (cfg1.handlers || cfg2.handlers) {
      resCfg.handlers = {
        ...cfg1.handlers || {},
        ...cfg2.handlers || {}
      };
    }
    if (cfg1.tagMapping || cfg2.tagMapping) {
      resCfg.tagMapping = cfg2.tagMapping || cfg1.tagMapping;
    }
    if (cfg1.attrPlugins || cfg2.attrPlugins) {
      resCfg.attrPlugins = [];
      resCfg.attrPlugins.push(...cfg2.attrPlugins || []);
      resCfg.attrPlugins.push(...cfg1.attrPlugins || []);
    }
    if (cfg1.nodePlugins || cfg2.nodePlugins) {
      resCfg.nodePlugins = [];
      resCfg.nodePlugins.push(...cfg2.nodePlugins || []);
      resCfg.nodePlugins.push(...cfg1.nodePlugins || []);
    }
    return resCfg;
  }
  function isPureString(v) {
    return v[0] === "'" && v[v.length - 1] === "'" || v[0] === '"' && v[v.length - 1] === '"';
  }
  function generateAttrValue(attrData, scope, config) {
    const valueStr = generateCompositeType(attrData.attrValue, scope, {
      handlers: config == null ? void 0 : config.handlers,
      nodeGenerator: config == null ? void 0 : config.self
    });
    return [
      {
        type: "NodeCodePieceAttr" /* ATTR */,
        name: attrData.attrName,
        value: valueStr
      }
    ];
  }
  function generateAttr(attrName, attrValue, scope, config) {
    let pieces;
    if (config == null ? void 0 : config.attrPlugins) {
      pieces = executeFunctionStack(
        { attrName, attrValue },
        scope,
        config.attrPlugins,
        generateAttrValue,
        config
      );
    } else {
      pieces = generateAttrValue({ attrName, attrValue }, scope, config);
    }
    pieces = pieces.map((p) => {
      let newValue;
      if (p.value && isPureString(p.value)) {
        const content = getStaticExprValue(p.value);
        newValue = JSON.stringify(encodeJsxStringNode(content));
      } else {
        newValue = `{${p.value}}`;
      }
      return {
        value: `${p.name}=${newValue}`,
        type: "NodeCodePieceAttr" /* ATTR */
      };
    });
    return pieces;
  }
  function generateAttrs(nodeItem, scope, config) {
    const { props } = nodeItem;
    let pieces = [];
    if (props) {
      if (!Array.isArray(props)) {
        Object.keys(props).forEach((propName) => {
          pieces = pieces.concat(generateAttr(propName, props[propName], scope, config));
        });
      } else {
        props.forEach((prop) => {
          if (prop.name && !prop.spread) {
            pieces = pieces.concat(generateAttr(prop.name, prop.value, scope, config));
          }
        });
      }
    }
    return pieces;
  }
  function generateBasicNode(nodeItem, scope, config) {
    const pieces = [];
    const tagName = ((config == null ? void 0 : config.tagMapping) || lodash_default_default.identity)(nodeItem.componentName);
    pieces.push({
      value: tagName || "",
      type: "NodeCodePieceTag" /* TAG */
    });
    return pieces;
  }
  function generateSimpleNode(nodeItem, scope, config) {
    const basicParts = generateBasicNode(nodeItem, scope, config) || [];
    const attrParts = generateAttrs(nodeItem, scope, config) || [];
    const childrenParts = [];
    if (nodeItem.children && (config == null ? void 0 : config.self)) {
      const childrenStr = config.self(nodeItem.children, scope);
      childrenParts.push({
        type: "NodeCodePieceChildren" /* CHILDREN */,
        value: childrenStr
      });
    }
    return [...basicParts, ...attrParts, ...childrenParts];
  }
  function linkPieces(pieces) {
    const tagsPieces = pieces.filter((p) => p.type === "NodeCodePieceTag" /* TAG */);
    if (tagsPieces.length !== 1) {
      throw new CodeGeneratorError("One node only need one tag define");
    }
    const tagName = tagsPieces[0].value;
    const beforeParts = pieces.filter((p) => p.type === "NodeCodePieceBefore" /* BEFORE */).map((p) => p.value).join("");
    const afterParts = pieces.filter((p) => p.type === "NodeCodePieceAfter" /* AFTER */).map((p) => p.value).join("");
    const childrenParts = pieces.filter((p) => p.type === "NodeCodePieceChildren" /* CHILDREN */).map((p) => p.value).join("");
    let attrsParts = pieces.filter((p) => p.type === "NodeCodePieceAttr" /* ATTR */).map((p) => p.value).join(" ");
    attrsParts = attrsParts ? ` ${attrsParts}` : "";
    if (childrenParts) {
      return `${beforeParts}<${tagName}${attrsParts}>${childrenParts}</${tagName}>${afterParts}`;
    }
    return `${beforeParts}<${tagName}${attrsParts} />${afterParts}`;
  }
  function generateNodeSchema(nodeItem, scope, config) {
    const pieces = [];
    if (config == null ? void 0 : config.nodePlugins) {
      const res = executeFunctionStack(
        nodeItem,
        scope,
        config.nodePlugins,
        generateSimpleNode,
        config
      );
      pieces.push(...res);
    } else {
      pieces.push(...generateSimpleNode(nodeItem, scope, config));
    }
    return linkPieces(pieces);
  }
  function generateReactLoopCtrl(nodeItem, scope, config, next) {
    var _a, _b, _c;
    if (nodeItem.loop) {
      const tolerateEvalErrors = (_a = config == null ? void 0 : config.tolerateEvalErrors) != null ? _a : true;
      const loopItemName = ((_b = nodeItem.loopArgs) == null ? void 0 : _b[0]) || "item";
      const loopIndexName = ((_c = nodeItem.loopArgs) == null ? void 0 : _c[1]) || "index";
      const subScope = scope.createSubScope([loopItemName, loopIndexName]);
      const pieces = next ? next(nodeItem, subScope, config) : [];
      const loopDataExpr = pipe(
        nodeItem.loop,
        (expr) => generateCompositeType(expr, scope, {
          handlers: config == null ? void 0 : config.handlers,
          tolerateEvalErrors: false
        }),
        (expr) => transformThis2Context(expr, scope, { ignoreRootScope: true }),
        (expr) => tolerateEvalErrors ? `__$$evalArray(() => (${expr}))` : expr
      );
      pieces.unshift({
        value: `(${loopDataExpr}).map((${loopItemName}, ${loopIndexName}) => ((__$$context) => (`,
        type: "NodeCodePieceBefore" /* BEFORE */
      });
      pieces.push({
        value: `))(__$$createChildContext(__$$context, { ${loopItemName}, ${loopIndexName} })))`,
        type: "NodeCodePieceAfter" /* AFTER */
      });
      return pieces;
    }
    return next ? next(nodeItem, scope, config) : [];
  }
  function generateConditionReactCtrl(nodeItem, scope, config, next) {
    const pieces = next ? next(nodeItem, scope, config) : [];
    if (nodeItem.condition != null && nodeItem.condition !== true) {
      const value = generateCompositeType(nodeItem.condition, scope, {
        handlers: config == null ? void 0 : config.handlers
      });
      pieces.unshift({
        value: `!!(${value}) && (`,
        type: "NodeCodePieceBefore" /* BEFORE */
      });
      pieces.push({
        value: ")",
        type: "NodeCodePieceAfter" /* AFTER */
      });
    }
    return pieces;
  }
  function generateReactExprInJS(nodeItem, scope, config, next) {
    const pieces = next ? next(nodeItem, scope, config) : [];
    if (nodeItem.condition != null && nodeItem.condition !== true || nodeItem.loop != null) {
      pieces.unshift({
        value: "{",
        type: "NodeCodePieceBefore" /* BEFORE */
      });
      pieces.push({
        value: "}",
        type: "NodeCodePieceAfter" /* AFTER */
      });
    }
    return pieces;
  }
  var handleChildren = (v) => v.join("");
  function createNodeGenerator(cfg = {}) {
    const generateNode = (nodeItem, scope) => {
      if (lodash_default_default.isArray(nodeItem)) {
        const resList = nodeItem.map((n) => generateNode(n, scope));
        return handleChildren(resList);
      }
      if (isNodeSchema(nodeItem)) {
        return generateNodeSchema(nodeItem, scope, {
          ...cfg,
          self: generateNode
        });
      }
      const valueStr = generateCompositeType(nodeItem, scope, {
        handlers: cfg.handlers,
        nodeGenerator: generateNode
      });
      if (isPureString(valueStr)) {
        return encodeJsxStringNode(getStaticExprValue(valueStr));
      }
      return `{${valueStr}}`;
    };
    return (nodeItem, scope) => unwrapJsExprQuoteInJsx(generateNode(nodeItem, scope));
  }
  var defaultReactGeneratorConfig = {
    nodePlugins: [generateReactExprInJS, generateReactLoopCtrl, generateConditionReactCtrl]
  };
  function createReactNodeGenerator(cfg) {
    const newCfg = mergeNodeGeneratorConfig(defaultReactGeneratorConfig, cfg);
    return createNodeGenerator(newCfg);
  }

  // src/core/jsx/handlers/transformJsExpression.ts
  init_define_process();

  // src/core/jsx/util/isLiteralAtomicExpr.ts
  init_define_process();
  function isLiteralAtomicExpr(expr) {
    return expr === "null" || expr === "undefined" || expr === "true" || expr === "false" || /^-?\d+(\.\d+)?$/.test(expr);
  }

  // src/core/jsx/util/isSimpleStraightLiteral.ts
  init_define_process();
  function isSimpleStraightLiteral(expr) {
    switch (expr.type) {
      case "BigIntLiteral":
      case "BooleanLiteral":
      case "DecimalLiteral":
      case "NullLiteral":
      case "NumericLiteral":
      case "RegExpLiteral":
      case "StringLiteral":
        return true;
      default:
        return false;
    }
  }

  // src/core/jsx/handlers/transformJsExpression.ts
  function transformJsExpr(expr, scope, { dontWrapEval = false, dontTransformThis2ContextAtRootScope = false } = {}) {
    if (!expr) {
      return "undefined";
    }
    if (isLiteralAtomicExpr(expr)) {
      return expr;
    }
    const exprAst = parseExpression2(expr);
    if (isSimpleStraightLiteral(exprAst)) {
      return expr;
    }
    if (dontWrapEval) {
      return transformThis2Context(exprAst, scope, {
        ignoreRootScope: dontTransformThis2ContextAtRootScope
      });
    }
    switch (exprAst.type) {
      case "ArrowFunctionExpression":
      case "FunctionExpression":
        return transformThis2Context(exprAst, scope, {
          ignoreRootScope: dontTransformThis2ContextAtRootScope
        });
      default:
        break;
    }
    return `__$$eval(() => (${transformThis2Context(exprAst, scope, {
      ignoreRootScope: dontTransformThis2ContextAtRootScope
    })}))`;
  }

  // src/plugins/component/react/jsx.ts
  var pluginFactory10 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      nodeTypeMapping: {},
      ...config
    };
    const { nodeTypeMapping } = cfg;
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const { tolerateEvalErrors = true, evalErrorsHandler = "" } = next.contextData;
      const customHandlers = {
        expression(input, scope2, config2) {
          var _a;
          return transformJsExpr(generateExpression(input, scope2), scope2, {
            dontWrapEval: !((_a = config2 == null ? void 0 : config2.tolerateEvalErrors) != null ? _a : tolerateEvalErrors),
            dontTransformThis2ContextAtRootScope: true
          });
        },
        function(input, scope2) {
          return transformThis2Context(
            generateCompositeType(
              {
                type: "JSFunction",
                value: input.value || "null"
              },
              Scope.createRootScope()
            ),
            scope2,
            { ignoreRootScope: true }
          );
        }
      };
      const generatorPlugins = {
        handlers: customHandlers,
        tagMapping: (v) => nodeTypeMapping[v] || v,
        tolerateEvalErrors
      };
      if (next.contextData.useRefApi) {
        generatorPlugins.attrPlugins = [
          (attrData, scope2, pluginCfg, nextFunc) => {
            if (attrData.attrName === "ref") {
              return [
                {
                  name: attrData.attrName,
                  value: `this._refsManager.linkRef('${attrData.attrValue}')`,
                  type: "NodeCodePieceAttr" /* ATTR */
                }
              ];
            }
            return nextFunc ? nextFunc(attrData, scope2, pluginCfg) : [];
          }
        ];
      }
      const generator = createReactNodeGenerator(generatorPlugins);
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const jsxContent = generator(ir, scope);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: REACT_CHUNK_NAME.ClassRenderJSX,
        content: `
        const __$$context = this._context || this;
        const { state } = __$$context;
        return ${jsxContent};
      `,
        linkAfter: [REACT_CHUNK_NAME.ClassRenderStart, REACT_CHUNK_NAME.ClassRenderPre]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: [
          tolerateEvalErrors && `
          function __$$eval(expr) {
            try {
              return expr();
            } catch (error) { 
              ${evalErrorsHandler}
            }
          }

          function __$$evalArray(expr) {
            const res = __$$eval(expr);
            return Array.isArray(res) ? res : [];
          }
      `,
          `
        function __$$createChildContext(oldContext, ext) {
          const childContext = {
            ...oldContext,
            ...ext,
          };
          childContext.__proto__ = oldContext;
          return childContext;
        }
      `
        ].filter(Boolean).join("\n"),
        linkAfter: [COMMON_CHUNK_NAME.FileExport]
      });
      return next;
    };
    return plugin;
  };
  var jsx_default = pluginFactory10;

  // src/plugins/component/react/reactCommonDeps.ts
  init_define_process();
  var pluginFactory11 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
// \u6CE8\u610F: \u51FA\u7801\u5F15\u64CE\u6CE8\u5165\u7684\u4E34\u65F6\u53D8\u91CF\u9ED8\u8BA4\u90FD\u4EE5 "__$$" \u5F00\u5934\uFF0C\u7981\u6B62\u5728\u642D\u5EFA\u7684\u4EE3\u7801\u4E2D\u76F4\u63A5\u8BBF\u95EE\u3002
// \u4F8B\u5916\uFF1Areact \u6846\u67B6\u7684\u5BFC\u51FA\u540D\u548C\u5404\u79CD\u7EC4\u4EF6\u540D\u9664\u5916\u3002
import React from 'react';`,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var reactCommonDeps_default = pluginFactory11;

  // src/plugins/component/style/css.ts
  init_define_process();
  var pluginFactory12 = (config) => {
    const cfg = {
      fileType: "css" /* CSS */,
      moduleFileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.moduleFileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `import './index.${cfg.fileType}';`,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var css_default = pluginFactory12;

  // src/plugins/project/constants.ts
  init_define_process();
  var pluginFactory13 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const constantStr = generateCompositeType(ir.constants || {}, scope);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileVarDefine,
        content: `
        const __$$constants = (${constantStr});
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export default __$$constants;
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var constants_default = pluginFactory13;

  // src/plugins/project/i18n.ts
  init_define_process();
  var pluginFactory14 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const i18nStr = ir.i18n ? JSON.stringify(ir.i18n, null, 2) : "{}";
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
        const i18nConfig = ${i18nStr};

        let locale = typeof navigator === 'object' && typeof navigator.language === 'string' ? navigator.language : 'zh-CN';

        const getLocale = () => locale;

        const setLocale = (target) => {
          locale = target;
        };

        const isEmptyVariables = variables => (
          Array.isArray(variables) && variables.length === 0 
          || typeof variables === 'object' && (!variables || Object.keys(variables).length === 0)
        );

        // \u6309\u4F4E\u4EE3\u7801\u89C4\u8303\u91CC\u9762\u7684\u8981\u6C42\u8FDB\u884C\u53D8\u91CF\u66FF\u6362
        const format = (msg, variables) => (
          typeof msg === 'string' 
            ? msg.replace(/\\$\\{(\\w+)\\}/g, (match, key) => variables?.[key] ?? '')
            : msg
        );

        const i18nFormat = ({ id, defaultMessage, fallback }, variables) => {
          const msg = i18nConfig[locale]?.[id] ??  i18nConfig[locale.replace('-', '_')]?.[id] ??  defaultMessage;
          if (msg == null) {
            console.warn('[i18n]: unknown message id: %o (locale=%o)', id, locale);
            return fallback === undefined ? \`\${id}\` : fallback;
          }

          return format(msg, variables);
        }

        const i18n = (id, params) => {
          return i18nFormat({ id }, params);
        };

        // \u5C06\u56FD\u9645\u5316\u7684\u4E00\u4E9B\u65B9\u6CD5\u6CE8\u5165\u5230\u76EE\u6807\u5BF9\u8C61&\u4E0A\u4E0B\u6587\u4E2D
        const _inject2 = (target) => {
          target.i18n = i18n;
          target.getLocale = getLocale;
          target.setLocale = (locale) => {
            setLocale(locale);
            target.forceUpdate();
          };
          target._i18nText = (t) => {
            // \u4F18\u5148\u53D6\u76F4\u63A5\u4F20\u8FC7\u6765\u7684\u8BED\u6599
            const localMsg = t[locale] ?? t[String(locale).replace('-', '_')] 
            if (localMsg != null) {
              return format(localMsg, t.params);
            }

            // \u5176\u6B21\u7528\u9879\u76EE\u7EA7\u522B\u7684
            const projectMsg = i18nFormat({ id: t.key, fallback: null }, t.params);
            if (projectMsg != null) {
              return projectMsg;
            }

            // \u515C\u5E95\u7528 use \u6307\u5B9A\u7684\u6216\u9ED8\u8BA4\u8BED\u8A00\u7684
            return format(t[t.use || "zh_CN"] ?? t.en_US, t.params);
          }

          // \u6CE8\u5165\u5230\u4E0A\u4E0B\u6587\u4E2D\u53BB
          if (target._context && target._context !== target) {
            Object.assign(target._context, {
              i18n,
              getLocale, setLocale: target.setLocale
            });
          }
        }
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export {
          getLocale,
          setLocale,
          i18n,
          i18nFormat,
          _inject2,
        };
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var i18n_default = pluginFactory14;

  // src/plugins/project/utils.ts
  init_define_process();
  var pluginFactory15 = (baseFramework) => {
    const plugin = async (pre) => {
      const framework = baseFramework || "react";
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import { createRef } from '${framework}';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileUtilDefine,
        content: `
        export class RefsManager {
          constructor() {
            this.refInsStore = {};
          }

          clearNullRefs() {
            Object.keys(this.refInsStore).forEach((refName) => {
              const filteredInsList = this.refInsStore[refName].filter(insRef => !!insRef.current);
              if (filteredInsList.length > 0) {
                this.refInsStore[refName] = filteredInsList;
              } else {
                delete this.refInsStore[refName];
              }
            });
          }

          get(refName) {
            this.clearNullRefs();
            if (this.refInsStore[refName] && this.refInsStore[refName].length > 0) {
              return this.refInsStore[refName][0].current;
            }

            return null;
          }

          getAll(refName) {
            this.clearNullRefs();
            if (this.refInsStore[refName] && this.refInsStore[refName].length > 0) {
              return this.refInsStore[refName].map(i => i.current);
            }

            return [];
          }

          linkRef(refName) {
            const refIns = createRef();
            this.refInsStore[refName] = this.refInsStore[refName] || [];
            this.refInsStore[refName].push(refIns);
            return refIns;
          }
        }
      `,
        linkAfter: [...DEFAULT_LINK_AFTER[COMMON_CHUNK_NAME.FileUtilDefine]]
      });
      if (ir.utils) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "js" /* JS */,
          name: COMMON_CHUNK_NAME.FileExport,
          content: `
          export default {
        `,
          linkAfter: [
            COMMON_CHUNK_NAME.ExternalDepsImport,
            COMMON_CHUNK_NAME.InternalDepsImport,
            COMMON_CHUNK_NAME.ImportAliasDefine,
            COMMON_CHUNK_NAME.FileVarDefine,
            COMMON_CHUNK_NAME.FileUtilDefine,
            COMMON_CHUNK_NAME.FileMainContent
          ]
        });
        ir.utils.forEach((util) => {
          if (util.type === "function") {
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: "js" /* JS */,
              name: COMMON_CHUNK_NAME.FileVarDefine,
              content: `
              const ${util.name} = ${util.content.value};
            `,
              linkAfter: [
                COMMON_CHUNK_NAME.ExternalDepsImport,
                COMMON_CHUNK_NAME.InternalDepsImport,
                COMMON_CHUNK_NAME.ImportAliasDefine
              ]
            });
          }
          next.chunks.push({
            type: "string" /* STRING */,
            fileType: "js" /* JS */,
            name: COMMON_CHUNK_NAME.FileExport,
            content: `${util.name},`,
            linkAfter: [
              COMMON_CHUNK_NAME.ExternalDepsImport,
              COMMON_CHUNK_NAME.InternalDepsImport,
              COMMON_CHUNK_NAME.ImportAliasDefine,
              COMMON_CHUNK_NAME.FileVarDefine,
              COMMON_CHUNK_NAME.FileUtilDefine,
              COMMON_CHUNK_NAME.FileMainContent
            ]
          });
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "js" /* JS */,
          name: COMMON_CHUNK_NAME.FileExport,
          content: `
          };
        `,
          linkAfter: [
            COMMON_CHUNK_NAME.ExternalDepsImport,
            COMMON_CHUNK_NAME.InternalDepsImport,
            COMMON_CHUNK_NAME.ImportAliasDefine,
            COMMON_CHUNK_NAME.FileVarDefine,
            COMMON_CHUNK_NAME.FileUtilDefine,
            COMMON_CHUNK_NAME.FileMainContent
          ]
        });
      }
      return next;
    };
    return plugin;
  };
  var utils_default = pluginFactory15;

  // src/plugins/project/framework/icejs/index.ts
  init_define_process();

  // src/plugins/project/framework/icejs/template/index.ts
  init_define_process();

  // src/plugins/project/framework/icejs/template/static-files.ts
  init_define_process();

  // src/utils/templateHelper.ts
  var templateHelper_exports = {};
  __export(templateHelper_exports, {
    insertFile: () => insertFile,
    runFileGenerator: () => runFileGenerator
  });
  init_define_process();
  function insertFile(root2, path, file2) {
    let current = root2;
    path.forEach((pathNode) => {
      const dir = current.dirs.find((d) => d.name === pathNode);
      if (dir) {
        current = dir;
      } else {
        const newDir = createResultDir(pathNode);
        addDirectory(current, newDir);
        current = newDir;
      }
    });
    addFile(current, file2);
  }
  function runFileGenerator(root2, fun) {
    try {
      const result2 = fun();
      const [path, file2] = result2;
      insertFile(root2, path, file2);
    } catch (error) {
      throw new Error(`Error: ${typeof fun}`);
    }
  }

  // src/plugins/project/framework/icejs/template/files/abc.json.ts
  init_define_process();
  function getFile() {
    return [
      [],
      {
        name: "abc",
        ext: "json",
        content: `
{
  "type": "ice-app",
  "builder": "@ali/builder-ice-app"
}
    `
      }
    ];
  }

  // src/plugins/project/framework/icejs/template/files/build.json.ts
  init_define_process();
  function getFile2() {
    return [
      [],
      {
        name: "build",
        ext: "json",
        content: `
{
  "entry": "src/app.js",
  "plugins": [
    [
      "build-plugin-fusion",
      {
        "themePackage": "@alifd/theme-design-pro"
      }
    ],
    [
      "build-plugin-moment-locales",
      {
        "locales": [
          "zh-cn"
        ]
      }
    ]
  ]
}
      `
      }
    ];
  }

  // src/plugins/project/framework/icejs/template/files/editorconfig.ts
  init_define_process();
  function getFile3() {
    const file2 = createResultFile(
      ".editorconfig",
      "",
      `
# http://editorconfig.org
root = true

[*]
indent_style = space
indent_size = 2
charset = utf-8
trim_trailing_whitespace = true
insert_final_newline = true

[*.md]
trim_trailing_whitespace = false
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/files/eslintignore.ts
  init_define_process();
  function getFile4() {
    const file2 = createResultFile(
      ".eslintignore",
      "",
      `
# \u5FFD\u7565\u76EE\u5F55
build/
tests/
demo/
.ice/

# node \u8986\u76D6\u7387\u6587\u4EF6
coverage/

# \u5FFD\u7565\u6587\u4EF6
**/*-min.js
**/*.min.js

package-lock.json
yarn.lock
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/files/eslintrc.js.ts
  init_define_process();
  function getFile5() {
    const file2 = createResultFile(
      ".eslintrc",
      "js",
      `
const { eslint } = require('@ice/spec');

module.exports = eslint;
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/files/gitignore.ts
  init_define_process();
  function getFile6() {
    const file2 = createResultFile(
      ".gitignore",
      "",
      `
# See https://help.github.com/ignore-files/ for more about ignoring files.

# dependencies
node_modules/

# production
build/
dist/
tmp/
lib/

# misc
.idea/
.happypack
.DS_Store
*.swp
*.dia~
.ice

npm-debug.log*
yarn-debug.log*
yarn-error.log*
index.module.scss.d.ts
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/files/jsconfig.json.ts
  init_define_process();
  function getFile7() {
    const file2 = createResultFile(
      "jsconfig",
      "json",
      `
{
  "compilerOptions": {
    "baseUrl": ".",
    "jsx": "react",
    "paths": {
      "@/*": ["./src/*"],
      "ice": [".ice/index.ts"],
      "ice/*": [".ice/pages/*"]
    }
  }
}
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/files/prettierignore.ts
  init_define_process();
  function getFile8() {
    const file2 = createResultFile(
      ".prettierignore",
      "",
      `
build/
tests/
demo/
.ice/
coverage/
**/*-min.js
**/*.min.js
package-lock.json
yarn.lock
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/files/prettierrc.js.ts
  init_define_process();
  function getFile9() {
    const file2 = createResultFile(
      ".prettierrc",
      "js",
      `
const { prettier } = require('@ice/spec');

module.exports = prettier;
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/files/README.md.ts
  init_define_process();
  function getFile10() {
    const file2 = createResultFile(
      "README",
      "md",
      `
## Scaffold Lite

> \u8F7B\u91CF\u7EA7\u6A21\u677F\uFF0C\u4F7F\u7528 JavaScript\uFF0C\u4EC5\u5305\u542B\u57FA\u7840\u7684 Layout\u3002

## \u4F7F\u7528

\`\`\`bash
# \u5B89\u88C5\u4F9D\u8D56
$ npm install

# \u542F\u52A8\u670D\u52A1
$ npm start  # visit http://localhost:3333
\`\`\`

[More docs](https://ice.work/docs/guide/about).

## \u76EE\u5F55

\`\`\`md
\u251C\u2500\u2500 build/                         # \u6784\u5EFA\u4EA7\u7269
\u251C\u2500\u2500 mock/                          # \u672C\u5730\u6A21\u62DF\u6570\u636E
\u2502   \u251C\u2500\u2500 index.[j,t]s
\u251C\u2500\u2500 public/
\u2502   \u251C\u2500\u2500 index.html                 # \u5E94\u7528\u5165\u53E3 HTML
\u2502   \u2514\u2500\u2500 favicon.png                # Favicon
\u251C\u2500\u2500 src/                           # \u6E90\u7801\u8DEF\u5F84
\u2502   \u251C\u2500\u2500 components/                # \u81EA\u5B9A\u4E49\u4E1A\u52A1\u7EC4\u4EF6
\u2502   \u2502   \u2514\u2500\u2500 Guide/
\u2502   \u2502       \u251C\u2500\u2500 index.[j,t]sx
\u2502   \u2502       \u251C\u2500\u2500 index.module.scss
\u2502   \u251C\u2500\u2500 layouts/                   # \u5E03\u5C40\u7EC4\u4EF6
\u2502   \u2502   \u2514\u2500\u2500 BasicLayout/
\u2502   \u2502       \u251C\u2500\u2500 index.[j,t]sx
\u2502   \u2502       \u2514\u2500\u2500 index.module.scss
\u2502   \u251C\u2500\u2500 pages/                     # \u9875\u9762
\u2502   \u2502   \u2514\u2500\u2500 Home/                  # home \u9875\u9762\uFF0C\u7EA6\u5B9A\u8DEF\u7531\u8F6C\u6210\u5C0F\u5199
\u2502   \u2502       \u251C\u2500\u2500 components/        # \u9875\u9762\u7EA7\u81EA\u5B9A\u4E49\u4E1A\u52A1\u7EC4\u4EF6
\u2502   \u2502       \u251C\u2500\u2500 models.[j,t]sx     # \u9875\u9762\u7EA7\u6570\u636E\u72B6\u6001
\u2502   \u2502       \u251C\u2500\u2500 index.[j,t]sx      # \u9875\u9762\u5165\u53E3
\u2502   \u2502       \u2514\u2500\u2500 index.module.scss  # \u9875\u9762\u6837\u5F0F\u6587\u4EF6
\u2502   \u251C\u2500\u2500 configs/                   # [\u53EF\u9009] \u914D\u7F6E\u6587\u4EF6
\u2502   \u2502   \u2514\u2500\u2500 menu.[j,t]s            # [\u53EF\u9009] \u83DC\u5355\u914D\u7F6E
\u2502   \u251C\u2500\u2500 models/                    # [\u53EF\u9009] \u5E94\u7528\u7EA7\u6570\u636E\u72B6\u6001
\u2502   \u2502   \u2514\u2500\u2500 user.[j,t]s
\u2502   \u251C\u2500\u2500 utils/                     # [\u53EF\u9009] \u5DE5\u5177\u5E93
\u2502   \u251C\u2500\u2500 global.scss                # \u5168\u5C40\u6837\u5F0F
\u2502   \u251C\u2500\u2500 routes.[j,t]s              # \u8DEF\u7531\u914D\u7F6E
\u2502   \u2514\u2500\u2500 app.[j,t]s[x]              # \u5E94\u7528\u5165\u53E3\u811A\u672C
\u251C\u2500\u2500 build.json                     # \u5DE5\u7A0B\u914D\u7F6E
\u251C\u2500\u2500 README.md
\u251C\u2500\u2500 package.json
\u251C\u2500\u2500 .editorconfig
\u251C\u2500\u2500 .eslintignore
\u251C\u2500\u2500 .eslintrc.[j,t]s
\u251C\u2500\u2500 .gitignore
\u251C\u2500\u2500 .stylelintignore
\u251C\u2500\u2500 .stylelintrc.[j,t]s
\u251C\u2500\u2500 .gitignore
\u2514\u2500\u2500 [j,t]sconfig.json
\`\`\`
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/files/src/layouts/BasicLayout/components/Footer/index.jsx.ts
  init_define_process();
  function getFile11() {
    const file2 = createResultFile(
      "index",
      "jsx",
      `
import React from 'react';
import styles from './index.module.scss';

export default function Footer() {
  return (
    <p className={styles.footer}>
      <span className={styles.logo}>Alibaba Fusion</span>
      <br />
      <span className={styles.copyright}>\xA9 2019-\u73B0\u5728 Alibaba Fusion & ICE</span>
    </p>
  );
}
    `
    );
    return [["src", "layouts", "BasicLayout", "components", "Footer"], file2];
  }

  // src/plugins/project/framework/icejs/template/files/src/layouts/BasicLayout/components/Footer/index.style.ts
  init_define_process();
  function getFile12() {
    const file2 = createResultFile(
      "index",
      "module.scss",
      `
.footer {
  line-height: 20px;
  text-align: center;
}

.logo {
  font-weight: bold;
  font-size: 16px;
}

.copyright {
  font-size: 12px;
}
    `
    );
    return [["src", "layouts", "BasicLayout", "components", "Footer"], file2];
  }

  // src/plugins/project/framework/icejs/template/files/src/layouts/BasicLayout/components/Logo/index.jsx.ts
  init_define_process();
  function getFile13() {
    const file2 = createResultFile(
      "index",
      "jsx",
      `
import React from 'react';
import { Link } from 'ice';
import styles from './index.module.scss';

export default function Logo({ image, text, url }) {
  return (
    <div className="logo">
      <Link to={url || '/'} className={styles.logo}>
        {image && <img src={image} alt="logo" />}
        <span>{text}</span>
      </Link>
    </div>
  );
}
    `
    );
    return [["src", "layouts", "BasicLayout", "components", "Logo"], file2];
  }

  // src/plugins/project/framework/icejs/template/files/src/layouts/BasicLayout/components/Logo/index.style.ts
  init_define_process();
  function getFile14() {
    const file2 = createResultFile(
      "index",
      "module.scss",
      `
.logo{
  display: flex;
  align-items: center;
  justify-content: center;
  color: $color-text1-1;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;

  &:visited, &:link {
    color: $color-text1-1;
  }

  img {
    height: 24px;
    margin-right: 10px;
  }
}
    `
    );
    return [["src", "layouts", "BasicLayout", "components", "Logo"], file2];
  }

  // src/plugins/project/framework/icejs/template/files/src/layouts/BasicLayout/components/PageNav/index.jsx.ts
  init_define_process();
  function getFile15() {
    const file2 = createResultFile(
      "index",
      "jsx",
      `
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'ice';
import { Nav } from '@alifd/next';
import { asideMenuConfig } from '../../menuConfig';

const { SubNav } = Nav;
const NavItem = Nav.Item;

function getNavMenuItems(menusData) {
  if (!menusData) {
    return [];
  }

  return menusData
    .filter(item => item.name && !item.hideInMenu)
    .map((item, index) => getSubMenuOrItem(item, index));
}

function getSubMenuOrItem(item, index) {
  if (item.children && item.children.some(child => child.name)) {
    const childrenItems = getNavMenuItems(item.children);

    if (childrenItems && childrenItems.length > 0) {
      const subNav = (
        <SubNav key={index} icon={item.icon} label={item.name}>
          {childrenItems}
        </SubNav>
      );
      return subNav;
    }

    return null;
  }

  const navItem = (
    <NavItem key={item.path} icon={item.icon}>
      <Link to={item.path}>{item.name}</Link>
    </NavItem>
  );
  return navItem;
}

const Navigation = (props, context) => {
  const { location } = props;
  const { pathname } = location;
  const { isCollapse } = context;
  return (
    <Nav
      type="primary"
      selectedKeys={[pathname]}
      defaultSelectedKeys={[pathname]}
      embeddable
      openMode="single"
      iconOnly={isCollapse}
      hasArrow={false}
      mode={isCollapse ? 'popup' : 'inline'}
    >
      {getNavMenuItems(asideMenuConfig)}
    </Nav>
  );
};

Navigation.contextTypes = {
  isCollapse: PropTypes.bool,
};
const PageNav = withRouter(Navigation);
export default PageNav;
    `
    );
    return [["src", "layouts", "BasicLayout", "components", "PageNav"], file2];
  }

  // src/plugins/project/framework/icejs/template/files/src/layouts/BasicLayout/index.jsx.ts
  init_define_process();
  function getFile16() {
    const file2 = createResultFile(
      "index",
      "jsx",
      `
import React, { useState } from 'react';
import { Shell, ConfigProvider } from '@alifd/next';
import PageNav from './components/PageNav';
import Logo from './components/Logo';
import Footer from './components/Footer';

(function() {
  const throttle = function(type, name, obj = window) {
    let running = false;

    const func = () => {
      if (running) {
        return;
      }

      running = true;
      requestAnimationFrame(() => {
        obj.dispatchEvent(new CustomEvent(name));
        running = false;
      });
    };

    obj.addEventListener(type, func);
  };

  throttle('resize', 'optimizedResize');
})();

export default function BasicLayout({ children }) {
  const getDevice = width => {
    const isPhone =
      typeof navigator !== 'undefined' && navigator && navigator.userAgent.match(/phone/gi);

    if (width < 680 || isPhone) {
      return 'phone';
    }
    if (width < 1280 && width > 680) {
      return 'tablet';
    }
    return 'desktop';
  };

  const [device, setDevice] = useState(getDevice(NaN));
  window.addEventListener('optimizedResize', e => {
    setDevice(getDevice(e && e.target && e.target.innerWidth));
  });
  return (
    <ConfigProvider device={device}>
      <Shell
        type="dark"
        style={{
          minHeight: '100vh',
        }}
      >
        <Shell.Branding>
          <Logo
            image="https://img.alicdn.com/tfs/TB1.ZBecq67gK0jSZFHXXa9jVXa-904-826.png"
            text="Logo"
          />
        </Shell.Branding>
        <Shell.Navigation
          direction="hoz"
          style={{
            marginRight: 10,
          }}
        ></Shell.Navigation>
        <Shell.Action></Shell.Action>
        <Shell.Navigation>
          <PageNav />
        </Shell.Navigation>

        <Shell.Content>{children}</Shell.Content>
        <Shell.Footer>
          <Footer />
        </Shell.Footer>
      </Shell>
    </ConfigProvider>
  );
}
    `
    );
    return [["src", "layouts", "BasicLayout"], file2];
  }

  // src/plugins/project/framework/icejs/template/files/src/layouts/BasicLayout/menuConfig.js.ts
  init_define_process();
  function getFile17() {
    const file2 = createResultFile(
      "menuConfig",
      "js",
      `
const headerMenuConfig = [];
const asideMenuConfig = [
  {
    name: 'Dashboard',
    path: '/',
    icon: 'smile',
  },
];
export { headerMenuConfig, asideMenuConfig };
    `
    );
    return [["src", "layouts", "BasicLayout"], file2];
  }

  // src/plugins/project/framework/icejs/template/files/stylelintignore.ts
  init_define_process();
  function getFile18() {
    const file2 = createResultFile(
      ".stylelintignore",
      "",
      `
# \u5FFD\u7565\u76EE\u5F55
build/
tests/
demo/

# node \u8986\u76D6\u7387\u6587\u4EF6
coverage/
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/files/stylelintrc.js.ts
  init_define_process();
  function getFile19() {
    const file2 = createResultFile(
      ".stylelintrc",
      "js",
      `
const { stylelint } = require('@ice/spec');

module.exports = stylelint;
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/files/tsconfig.json.ts
  init_define_process();
  function getFile20() {
    const file2 = createResultFile(
      "tsconfig",
      "json",
      `
{
  "compileOnSave": false,
  "buildOnSave": false,
  "compilerOptions": {
    "baseUrl": ".",
    "outDir": "build",
    "module": "esnext",
    "target": "es6",
    "jsx": "react",
    "moduleResolution": "node",
    "allowSyntheticDefaultImports": true,
    "lib": ["es6", "dom"],
    "sourceMap": true,
    "allowJs": true,
    "rootDir": "./",
    "forceConsistentCasingInFileNames": true,
    "noImplicitReturns": true,
    "noImplicitThis": true,
    "noImplicitAny": false,
    "importHelpers": true,
    "strictNullChecks": true,
    "suppressImplicitAnyIndexErrors": true,
    "noUnusedLocals": true,
    "skipLibCheck": true,
    "paths": {
      "@/*": ["./src/*"],
      "ice": [".ice/index.ts"],
      "ice/*": [".ice/pages/*"]
    }
  },
  "include": ["src/*", ".ice"],
  "exclude": ["node_modules", "build", "public"]
}
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejs/template/static-files.ts
  function generateStaticFiles(root2 = createResultDir(".")) {
    runFileGenerator(root2, getFile20);
    runFileGenerator(root2, getFile19);
    runFileGenerator(root2, getFile18);
    runFileGenerator(root2, getFile9);
    runFileGenerator(root2, getFile8);
    runFileGenerator(root2, getFile7);
    runFileGenerator(root2, getFile6);
    runFileGenerator(root2, getFile5);
    runFileGenerator(root2, getFile4);
    runFileGenerator(root2, getFile3);
    runFileGenerator(root2, getFile2);
    runFileGenerator(root2, getFile);
    runFileGenerator(root2, getFile10);
    runFileGenerator(root2, getFile16);
    runFileGenerator(root2, getFile17);
    runFileGenerator(root2, getFile11);
    runFileGenerator(root2, getFile12);
    runFileGenerator(root2, getFile13);
    runFileGenerator(root2, getFile14);
    runFileGenerator(root2, getFile15);
    return root2;
  }

  // src/plugins/project/framework/icejs/template/index.ts
  var icejsTemplate = {
    slots: {
      components: {
        path: ["src", "components"]
      },
      pages: {
        path: ["src", "pages"]
      },
      router: {
        path: ["src"],
        fileName: "routes"
      },
      entry: {
        path: ["src"],
        fileName: "app"
      },
      constants: {
        path: ["src"],
        fileName: "constants"
      },
      utils: {
        path: ["src"],
        fileName: "utils"
      },
      i18n: {
        path: ["src"],
        fileName: "i18n"
      },
      globalStyle: {
        path: ["src"],
        fileName: "global"
      },
      htmlEntry: {
        path: ["public"],
        fileName: "index"
      },
      packageJSON: {
        path: [],
        fileName: "package"
      }
    },
    generateTemplate() {
      return generateStaticFiles();
    }
  };
  var template_default2 = icejsTemplate;

  // src/plugins/project/framework/icejs/plugins/entry.ts
  init_define_process();
  var pluginFactory16 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import { createApp } from 'ice';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
        const appConfig = {
          app: {
            rootId: 'app',
          },
          router: {
            type: 'hash',
          },
        };
        createApp(appConfig);
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      return next;
    };
    return plugin;
  };
  var entry_default = pluginFactory16;

  // src/plugins/project/framework/icejs/plugins/entryHtml.ts
  init_define_process();
  var pluginFactory17 = () => {
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "html" /* HTML */,
        name: COMMON_CHUNK_NAME.HtmlContent,
        content: `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8" />
            <meta http-equiv="x-ua-compatible" content="ie=edge,chrome=1" />
            <meta name="viewport" content="width=device-width" />
            <title>${((_a = ir == null ? void 0 : ir.meta) == null ? void 0 : _a.name) || "Ice App"}</title>
          </head>
          <body>
            <div id="app"></div>
          </body>
        </html>
      `,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var entryHtml_default = pluginFactory17;

  // src/plugins/project/framework/icejs/plugins/globalStyle.ts
  init_define_process();
  var pluginFactory18 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleDepsImport,
        content: `
        // \u5F15\u5165\u9ED8\u8BA4\u5168\u5C40\u6837\u5F0F
        @import '@alifd/next/reset.scss';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: `
        body {
          -webkit-font-smoothing: antialiased;
        }
      `,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css || "",
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var globalStyle_default = pluginFactory18;

  // src/plugins/project/framework/icejs/plugins/packageJSON.ts
  init_define_process();

  // src/utils/dataSource.ts
  init_define_process();
  var import_change_case5 = __toESM(require_change_case());
  function buildDataSourceDependencies(ir, cfg = {}) {
    return {
      [cfg.enginePackage || "@alilc/lowcode-datasource-engine"]: cfg.engineVersion || "latest",
      ...(ir.dataSourcesTypes || []).reduce(
        (acc, dsType) => {
          var _a;
          return {
            ...acc,
            [getDataSourceHandlerPackageName(dsType)]: ((_a = cfg.handlersVersion) == null ? void 0 : _a[dsType]) || "latest"
          };
        },
        {}
      )
    };
    function getDataSourceHandlerPackageName(dsType) {
      var _a;
      return ((_a = cfg.handlersPackages) == null ? void 0 : _a[dsType]) || `@alilc/lowcode-datasource-${import_change_case5.default.kebab(dsType)}-handler`;
    }
  }

  // src/plugins/project/framework/icejs/plugins/packageJSON.ts
  var pluginFactory19 = (cfg) => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const packageJson = {
        name: (cfg == null ? void 0 : cfg.packageName) || "icejs-demo-app",
        version: (cfg == null ? void 0 : cfg.packageVersion) || "0.1.5",
        description: "\u8F7B\u91CF\u7EA7\u6A21\u677F\uFF0C\u4F7F\u7528 JavaScript\uFF0C\u4EC5\u5305\u542B\u57FA\u7840\u7684 Layout\u3002",
        dependencies: {
          moment: "^2.24.0",
          react: "^16.4.1",
          "react-dom": "^16.4.1",
          "react-router": "^5.2.1",
          "@alifd/theme-design-pro": "^0.x",
          "intl-messageformat": "^9.3.6",
          "@ice/store": "^1.4.3",
          "@loadable/component": "^5.15.2",
          ...buildDataSourceDependencies(ir, cfg == null ? void 0 : cfg.datasourceConfig)
        },
        devDependencies: {
          "@ice/spec": "^1.0.0",
          "build-plugin-fusion": "^0.1.0",
          "build-plugin-moment-locales": "^0.1.0",
          eslint: "^6.0.1",
          "ice.js": "^1.0.0",
          stylelint: "^13.2.0"
        },
        scripts: {
          start: "icejs start",
          build: "icejs build",
          lint: "npm run eslint && npm run stylelint",
          eslint: "eslint --cache --ext .js,.jsx ./",
          stylelint: "stylelint ./**/*.scss"
        },
        ideMode: {
          name: "ice-react"
        },
        iceworks: {
          type: "react",
          adapter: "adapter-react-v3"
        },
        engines: {
          node: ">=8.0.0"
        },
        repository: {
          type: "git",
          url: "http://gitlab.xxx.com/msd/leak-scan/tree/master"
        },
        private: true,
        originTemplate: "@alifd/scaffold-lite-js"
      };
      ir.packages.forEach((packageInfo) => {
        packageJson.dependencies[packageInfo.package || ""] = packageInfo.version;
      });
      next.chunks.push({
        type: "json" /* JSON */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: packageJson,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var packageJSON_default = pluginFactory19;

  // src/plugins/project/framework/icejs/plugins/router.ts
  init_define_process();
  var pluginFactory20 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import BasicLayout from '@/layouts/BasicLayout';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileVarDefine,
        content: `
        const routerConfig = [
          {
            path: '/',
            component: BasicLayout,
            children: [
              ${ir.routes.map(
          (route) => `
                    {
                      path: '${route.path}',
                      component: ${route.componentName},
                    }
                  `
        ).join(",")}
            ],
          },
        ];
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export default routerConfig;
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var router_default = pluginFactory20;

  // src/plugins/project/framework/icejs/index.ts
  var icejs_default = {
    template: template_default2,
    plugins: {
      entry: entry_default,
      entryHtml: entryHtml_default,
      globalStyle: globalStyle_default,
      packageJSON: packageJSON_default,
      router: router_default
    }
  };

  // src/postprocessor/index.ts
  init_define_process();

  // src/postprocessor/prettier/index.ts
  init_define_process();
  var import_prettier = __toESM(require_standalone());
  var import_parser_babel = __toESM(require_parser_babel());
  var import_parser_postcss = __toESM(require_parser_postcss());
  var import_parser_html = __toESM(require_parser_html());
  var PARSERS = ["css", "scss", "less", "json", "html", "vue"];
  var factory = (config) => {
    const cfg = {
      customFileTypeParser: {},
      ...config
    };
    const codePrettier = (content, fileType) => {
      let parser3;
      if (fileType === "js" || fileType === "jsx") {
        parser3 = "babel";
      } else if (PARSERS.indexOf(fileType) >= 0) {
        parser3 = fileType;
      } else if (cfg.customFileTypeParser[fileType]) {
        parser3 = cfg.customFileTypeParser[fileType];
      } else {
        return content;
      }
      return import_prettier.default.format(content, {
        parser: parser3,
        plugins: [import_parser_babel.default, import_parser_postcss.default, import_parser_html.default, ...cfg.plugins || []]
      });
    };
    return codePrettier;
  };
  var prettier_default = factory;

  // src/solutions/icejs.ts
  function createIceJsProjectBuilder(options) {
    return createProjectBuilder({
      inStrictMode: options == null ? void 0 : options.inStrictMode,
      extraContextData: { ...options },
      template: icejs_default.template,
      plugins: {
        components: [
          reactCommonDeps_default(),
          esmodule_default({
            fileType: "jsx"
          }),
          containerClass_default(),
          containerInjectContext_default(),
          containerInjectUtils_default(),
          containerInjectDataSourceEngine_default(),
          containerInjectI18n_default(),
          containerInitState_default(),
          containerLifeCycle_default(),
          containerMethod_default(),
          jsx_default({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "div",
              Block: "div"
            }
          }),
          css_default()
        ],
        pages: [
          reactCommonDeps_default(),
          esmodule_default({
            fileType: "jsx"
          }),
          containerClass_default(),
          containerInjectContext_default(),
          containerInjectUtils_default(),
          containerInjectDataSourceEngine_default(),
          containerInjectI18n_default(),
          containerInitState_default(),
          containerLifeCycle_default(),
          containerMethod_default(),
          jsx_default({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "div",
              Block: "div"
            }
          }),
          css_default()
        ],
        router: [esmodule_default(), icejs_default.plugins.router()],
        entry: [icejs_default.plugins.entry()],
        constants: [constants_default()],
        utils: [esmodule_default(), utils_default("react")],
        i18n: [i18n_default()],
        globalStyle: [icejs_default.plugins.globalStyle()],
        htmlEntry: [icejs_default.plugins.entryHtml()],
        packageJSON: [icejs_default.plugins.packageJSON()]
      },
      postProcessors: [prettier_default()]
    });
  }
  var plugins = {
    containerClass: containerClass_default,
    containerInitState: containerInitState_default,
    containerInjectContext: containerInjectContext_default,
    containerInjectUtils: containerInjectUtils_default,
    containerInjectI18n: containerInjectI18n_default,
    containerInjectDataSourceEngine: containerInjectDataSourceEngine_default,
    containerLifeCycle: containerLifeCycle_default,
    containerMethod: containerMethod_default,
    jsx: jsx_default,
    commonDeps: reactCommonDeps_default,
    reactCommonDeps: reactCommonDeps_default
  };

  // src/solutions/rax-app.ts
  init_define_process();

  // src/plugins/component/rax/containerClass.ts
  init_define_process();
  var import_change_case6 = __toESM(require_change_case());

  // src/plugins/component/rax/const.ts
  init_define_process();
  var RAX_CHUNK_NAME = {
    ClassDidMountBegin: "RaxComponentClassDidMountBegin",
    ClassDidMountContent: "RaxComponentClassDidMountContent",
    ClassDidMountEnd: "RaxComponentClassDidMountEnd",
    ClassWillUnmountBegin: "RaxComponentClassWillUnmountBegin",
    ClassWillUnmountContent: "RaxComponentClassWillUnmountContent",
    ClassWillUnmountEnd: "RaxComponentClassWillUnmountEnd",
    ClassRenderBegin: "RaxComponentClassRenderBegin",
    ClassRenderPre: "RaxComponentClassRenderPre",
    ClassRenderJSX: "RaxComponentClassRenderJSX",
    ClassRenderEnd: "RaxComponentClassRenderEnd",
    MethodsBegin: "RaxComponentMethodsBegin",
    MethodsContent: "RaxComponentMethodsContent",
    MethodsEnd: "RaxComponentMethodsEnd",
    LifeCyclesBegin: "RaxComponentLifeCyclesBegin",
    LifeCyclesContent: "RaxComponentLifeCyclesContent",
    LifeCyclesEnd: "RaxComponentLifeCyclesEnd"
  };

  // src/plugins/component/rax/containerClass.ts
  var pluginFactory21 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const componentClassName = ensureValidClassName(
        `${import_change_case6.default.pascalCase(ir.moduleName)}$$Page`
      );
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.Start,
        content: `class ${componentClassName} extends Component {`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.End,
        content: "}",
        linkAfter: [
          CLASS_DEFINE_CHUNK_NAME.Start,
          CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
          RAX_CHUNK_NAME.ClassRenderEnd,
          RAX_CHUNK_NAME.MethodsEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorStart,
        content: "constructor(props, context) { super(props); ",
        linkAfter: DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorEnd,
        content: "} /* end of constructor */",
        linkAfter: DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorEnd]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassDidMountBegin,
        content: "componentDidMount() {",
        linkAfter: [
          CLASS_DEFINE_CHUNK_NAME.Start,
          CLASS_DEFINE_CHUNK_NAME.InsVar,
          CLASS_DEFINE_CHUNK_NAME.InsMethod,
          CLASS_DEFINE_CHUNK_NAME.ConstructorEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassDidMountEnd,
        content: "} /* end of componentDidMount */",
        linkAfter: [RAX_CHUNK_NAME.ClassDidMountBegin, RAX_CHUNK_NAME.ClassDidMountContent]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassWillUnmountBegin,
        content: "componentWillUnmount() {",
        linkAfter: [
          CLASS_DEFINE_CHUNK_NAME.Start,
          CLASS_DEFINE_CHUNK_NAME.InsVar,
          CLASS_DEFINE_CHUNK_NAME.InsMethod,
          RAX_CHUNK_NAME.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassWillUnmountEnd,
        content: "} /* end of componentWillUnmount */",
        linkAfter: [RAX_CHUNK_NAME.ClassWillUnmountBegin, RAX_CHUNK_NAME.ClassWillUnmountContent]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassRenderBegin,
        content: "render() {",
        linkAfter: [RAX_CHUNK_NAME.ClassDidMountEnd, RAX_CHUNK_NAME.ClassWillUnmountEnd]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: RAX_CHUNK_NAME.ClassRenderEnd,
        content: "} /* end of render */",
        linkAfter: [
          RAX_CHUNK_NAME.ClassRenderBegin,
          RAX_CHUNK_NAME.ClassRenderPre,
          RAX_CHUNK_NAME.ClassRenderJSX
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `export default ${componentClassName};`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          CLASS_DEFINE_CHUNK_NAME.End
        ]
      });
      return next;
    };
    return plugin;
  };
  var containerClass_default2 = pluginFactory21;

  // src/plugins/component/rax/containerLifeCycle.ts
  init_define_process();

  // src/utils/debug.ts
  init_define_process();
  var import_debug = __toESM(require_browser2());
  var debug = (0, import_debug.default)("code-generator");

  // src/plugins/component/rax/containerLifeCycle.ts
  var pluginFactory22 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      exportNameMapping: {},
      normalizeNameMapping: {
        didMount: "componentDidMount",
        willUnmount: "componentWillUnmount"
      },
      ...config
    };
    const exportNameMapping = new Map(Object.entries(cfg.exportNameMapping));
    const normalizeNameMapping = new Map(Object.entries(cfg.normalizeNameMapping));
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const { lifeCycles } = ir;
      if (lifeCycles && !lodash_default_default.isEmpty(lifeCycles)) {
        Object.entries(lifeCycles).forEach(([lifeCycleName, lifeCycleMethodExpr]) => {
          if (!isJSFunction(lifeCycles[lifeCycleName]) && !isJSExpression(lifeCycles[lifeCycleName])) {
            return;
          }
          const normalizeName = normalizeNameMapping.get(lifeCycleName) || lifeCycleName;
          const exportName = exportNameMapping.get(lifeCycleName) || lifeCycleName;
          next.chunks.push({
            type: "string" /* STRING */,
            fileType: cfg.fileType,
            name: RAX_CHUNK_NAME.LifeCyclesContent,
            content: `${exportName}: (${lifeCycleMethodExpr.value}),`,
            linkAfter: [RAX_CHUNK_NAME.LifeCyclesBegin]
          });
          if (normalizeName === "constructor") {
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
              content: `this._lifeCycles.${exportName}();`,
              linkAfter: [CLASS_DEFINE_CHUNK_NAME.ConstructorStart]
            });
          } else if (normalizeName === "componentDidMount") {
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: RAX_CHUNK_NAME.ClassDidMountContent,
              content: `this._lifeCycles.${exportName}();`,
              linkAfter: [RAX_CHUNK_NAME.ClassDidMountBegin]
            });
          } else if (normalizeName === "componentWillUnmount") {
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: RAX_CHUNK_NAME.ClassWillUnmountContent,
              content: `this._lifeCycles.${exportName}();`,
              linkAfter: [RAX_CHUNK_NAME.ClassWillUnmountBegin]
            });
          } else {
            debug(`[CodeGen]: unknown life cycle: ${lifeCycleName}`);
          }
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: "_lifeCycles = this._defineLifeCycles();",
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: RAX_CHUNK_NAME.LifeCyclesBegin,
          content: `
          _defineLifeCycles() {
            const __$$lifeCycles = ({
        `,
          linkAfter: [RAX_CHUNK_NAME.ClassRenderEnd, CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: RAX_CHUNK_NAME.LifeCyclesEnd,
          content: `
            });

            // \u4E3A\u6240\u6709\u7684\u65B9\u6CD5\u7ED1\u5B9A\u4E0A\u4E0B\u6587
            Object.entries(__$$lifeCycles).forEach(([lifeCycleName, lifeCycleMethod]) => {
              if (typeof lifeCycleMethod === 'function') {
                __$$lifeCycles[lifeCycleName] = (...args) => {
                  return lifeCycleMethod.apply(this._context, args);
                }
              }
            });

            return __$$lifeCycles;
          }
        `,
          linkAfter: [RAX_CHUNK_NAME.LifeCyclesBegin, RAX_CHUNK_NAME.LifeCyclesContent]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerLifeCycle_default2 = pluginFactory22;

  // src/plugins/component/rax/containerMethods.ts
  init_define_process();
  var pluginFactory23 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsVar,
        content: `
         _methods = this._defineMethods();
      `,
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: RAX_CHUNK_NAME.MethodsBegin,
        content: `
        _defineMethods() {
          return ({
      `,
        linkAfter: [
          RAX_CHUNK_NAME.ClassRenderEnd,
          CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
          RAX_CHUNK_NAME.LifeCyclesEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: RAX_CHUNK_NAME.MethodsEnd,
        content: `
          });
        }
      `,
        linkAfter: [RAX_CHUNK_NAME.MethodsBegin, RAX_CHUNK_NAME.MethodsContent]
      });
      if (ir.methods && Object.keys(ir.methods).length > 0) {
        Object.entries(ir.methods).forEach(([methodName, methodDefine]) => {
          next.chunks.push({
            type: "string" /* STRING */,
            fileType: cfg.fileType,
            name: RAX_CHUNK_NAME.MethodsContent,
            content: `${methodName}: (${methodDefine.value}),`,
            linkAfter: [RAX_CHUNK_NAME.MethodsBegin]
          });
        });
      }
      return next;
    };
    return plugin;
  };
  var containerMethods_default = pluginFactory23;

  // src/plugins/component/rax/containerInitState.ts
  init_define_process();
  var pluginFactory24 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      implementType: "insMember",
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const state = ir.state || {};
      const fields = Object.keys(state).map((stateName) => {
        const value = generateCompositeType(state[stateName], scope);
        return `${JSON.stringify(stateName)}: ${value}`;
      });
      if (cfg.implementType === "inConstructor") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: `this.state = { ${fields.join(",")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      } else if (cfg.implementType === "insMember") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `state = { ${fields.join(",")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInitState_default2 = pluginFactory24;

  // src/plugins/component/rax/containerInjectContext.ts
  init_define_process();
  var pluginFactory25 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const useRef = !!((_a = ir.analyzeResult) == null ? void 0 : _a.isUsingRef);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: "import __$$constants from '../../constants';",
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: "import * as __$$i18n from '../../i18n';",
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: `
        __$$i18n._inject2(this);
      `,
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsVar,
        content: `
        _context = this._createContext();
      `,
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
        content: `
        _createContext() {
          const self = this;
          const context = {
            get state() {
              return self.state;
            },
            setState(newState, callback) {
              self.setState(newState, callback);
            },
            get dataSourceMap() {
              return self._dataSourceEngine.dataSourceMap || {};
            },
            async reloadDataSource() {
              await self._dataSourceEngine.reloadDataSource();
            },
            get utils() {
              return self._utils;
            },
            get page() {
              return context;
            },
            get component() {
              return context;
            },
            get props() {
              return self.props;
            },
            get constants() {
              return __$$constants;
            },
            i18n: __$$i18n.i18n,
            i18nFormat: __$$i18n.i18nFormat,
            getLocale: __$$i18n.getLocale,
            setLocale(locale) {
              __$$i18n.setLocale(locale);
              self.forceUpdate();
            },${useRef ? `
                  $(refName) {
                    return self._refsManager.get(refName);
                  },
                  $$(refName) {
                    return self._refsManager.getAll(refName);
                  },
                  get _refsManager() {
                    if (!self._refsManager) {
                      self._refsManager = new RefsManager();
                    }
                    return self._refsManager;
                  },
                ` : ""}
            ...this._methods,
          };

          return context;
        }
      `,
        linkAfter: [RAX_CHUNK_NAME.ClassRenderEnd]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectContext_default2 = pluginFactory25;

  // src/plugins/component/rax/containerInjectDataSourceEngine.ts
  init_define_process();
  var import_change_case7 = __toESM(require_change_case());
  var pluginFactory26 = (config) => {
    var _a;
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config,
      dataSourceHandlersPackageMap: (config == null ? void 0 : config.dataSourceHandlersPackageMap) || ((_a = config == null ? void 0 : config.datasourceConfig) == null ? void 0 : _a.handlersPackages)
    };
    const plugin = async (pre) => {
      var _a2;
      const next = {
        ...pre
      };
      const scope = Scope.createRootScope();
      const dataSourceConfig = isContainerSchema(pre.ir) ? pre.ir.dataSource : null;
      const dataSourceItems = dataSourceConfig && dataSourceConfig.list || [];
      const dataSourceEngineOptions = { runtimeConfig: true };
      if (dataSourceItems.length > 0) {
        const requestHandlersMap = {};
        dataSourceItems.forEach((ds) => {
          var _a3;
          const dsType = ds.type || "fetch";
          if (!(dsType in requestHandlersMap) && dsType !== "custom") {
            const handlerFactoryName = `__$$create${import_change_case7.default.pascal(dsType)}RequestHandler`;
            requestHandlersMap[dsType] = {
              type: "JSExpression",
              value: `${handlerFactoryName}(${dsType === "urlParams" ? "__$$getSearchParams()" : ""})`
            };
            const handlerFactoryExportName = `create${import_change_case7.default.pascal(dsType)}Handler`;
            const handlerPkgName = ((_a3 = cfg.dataSourceHandlersPackageMap) == null ? void 0 : _a3[dsType]) || `@alilc/lowcode-datasource-${import_change_case7.default.kebab(dsType)}-handler`;
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: "jsx" /* JSX */,
              name: COMMON_CHUNK_NAME.ExternalDepsImport,
              content: `
              import { ${handlerFactoryExportName} as ${handlerFactoryName} } from '${handlerPkgName}';
            `,
              linkAfter: []
            });
          }
        });
        Object.assign(dataSourceEngineOptions, { requestHandlersMap });
      }
      const datasourceEnginePackageName = ((_a2 = cfg.datasourceConfig) == null ? void 0 : _a2.enginePackage) || "@alilc/lowcode-datasource-engine";
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import { create as __$$createDataSourceEngine } from '${datasourceEnginePackageName}/runtime';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsVar,
        content: `
        _dataSourceConfig = this._defineDataSourceConfig();
        _dataSourceEngine = __$$createDataSourceEngine(
          this._dataSourceConfig,
          this._context,
          ${generateCompositeType(dataSourceEngineOptions, scope)}
        );`,
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: RAX_CHUNK_NAME.ClassDidMountContent,
        content: `
        this._dataSourceEngine.reloadDataSource();
      `,
        linkAfter: [RAX_CHUNK_NAME.ClassDidMountBegin]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
        content: `
_defineDataSourceConfig() {
  const __$$context = this._context;
  return (${generateCompositeType(
          {
            ...dataSourceConfig,
            list: [
              ...dataSourceItems.map((item) => {
                var _a3;
                return {
                  errorHandler: {
                    type: "JSFunction",
                    value: `function (err){
              setTimeout(() => {
                this.setState({ __refresh: Date.now() + Math.random() });
              }, 0);
              throw err;
            }`
                  },
                  ...item,
                  isInit: typeof item.isInit === "boolean" || typeof item.isInit === "undefined" ? (_a3 = item.isInit) != null ? _a3 : true : wrapAsFunction2(item.isInit, scope),
                  options: wrapAsFunction2(item.options, scope)
                };
              })
            ]
          },
          scope,
          {
            handlers: {
              function: (jsFunc) => parseExpressionConvertThis2Context(jsFunc.value, "__$$context"),
              expression: (jsExpr) => parseExpressionConvertThis2Context(jsExpr.value, "__$$context")
            }
          }
        )});
}
      `,
        linkAfter: [RAX_CHUNK_NAME.ClassRenderEnd]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectDataSourceEngine_default2 = pluginFactory26;
  function wrapAsFunction2(value, scope) {
    if (isJSExpression(value) || isJSFunction(value)) {
      return {
        type: "JSExpression",
        value: `function(){ return ((${value.value}))}`
      };
    }
    return {
      type: "JSExpression",
      value: `function(){return((${generateCompositeType(value, scope)}))}`
    };
  }

  // src/plugins/component/rax/containerInjectUtils.ts
  init_define_process();
  var pluginFactory27 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const useRef = !!((_a = ir.analyzeResult) == null ? void 0 : _a.isUsingRef);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import __$$projectUtils${useRef ? ", { RefsManager }" : ""} from '../../utils';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsVar,
        content: "_utils = this._defineUtils();",
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
        content: `
        _defineUtils() {
          return {
            ...__$$projectUtils,
          };
        }`,
        linkAfter: [RAX_CHUNK_NAME.ClassRenderEnd]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectUtils_default2 = pluginFactory27;

  // src/plugins/component/rax/jsx.ts
  init_define_process();
  var import_change_case8 = __toESM(require_change_case());
  var pluginFactory28 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const rootScope = Scope.createRootScope();
      const { tolerateEvalErrors = true, evalErrorsHandler = "" } = next.contextData;
      const componentsNameAliasMap = /* @__PURE__ */ new Map();
      next.chunks.forEach((chunk2) => {
        if (isImportAliasDefineChunk(chunk2)) {
          componentsNameAliasMap.set(chunk2.ext.aliasName, chunk2.ext.originalName);
        }
      });
      const mapComponentNameToAliasOrKeepIt = (componentName) => componentsNameAliasMap.get(componentName) || componentName;
      next.chunks = next.chunks.filter((chunk2) => !isImportAliasDefineChunk(chunk2));
      const customHandlers = {
        expression(input, scope) {
          return transformJsExpr(generateExpression(input, scope), scope, {
            dontWrapEval: !tolerateEvalErrors
          });
        },
        function(input, scope) {
          return transformThis2Context(input.value || "null", scope);
        }
      };
      const commonNodeGenerator = createNodeGenerator({
        handlers: customHandlers,
        tagMapping: mapComponentNameToAliasOrKeepIt,
        nodePlugins: [generateReactExprInJS, generateConditionReactCtrl, generateRaxLoopCtrl],
        attrPlugins: [generateNodeAttrForRax.bind({ cfg })]
      });
      const jsxContent = commonNodeGenerator(ir, rootScope);
      if (!cfg.ignoreMiniApp) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: COMMON_CHUNK_NAME.ExternalDepsImport,
          content: "import { isMiniApp as __$$isMiniApp } from 'universal-env';",
          linkAfter: []
        });
      }
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: RAX_CHUNK_NAME.ClassRenderPre,
        content: `
        const __$$context = this._context;
        const { state, setState, dataSourceMap, reloadDataSource, utils, constants, i18n, i18nFormat, getLocale, setLocale } = __$$context;
      `,
        linkAfter: [RAX_CHUNK_NAME.ClassRenderBegin]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: RAX_CHUNK_NAME.ClassRenderJSX,
        content: `return ${jsxContent};`,
        linkAfter: [RAX_CHUNK_NAME.ClassRenderBegin, RAX_CHUNK_NAME.ClassRenderPre]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: [
          tolerateEvalErrors && `
        function __$$eval(expr) {
          try {
            return expr();
          } catch (error) { 
            ${evalErrorsHandler}
          }
        }

        function __$$evalArray(expr) {
          const res = __$$eval(expr);
          return Array.isArray(res) ? res : [];
        }
        `,
          `
        function __$$createChildContext(oldContext, ext) {
          return Object.assign({}, oldContext, ext);
        }
      `
        ].filter(Boolean).join("\n"),
        linkAfter: [COMMON_CHUNK_NAME.FileExport]
      });
      return next;
      function generateRaxLoopCtrl(nodeItem, scope, config2, next2) {
        var _a, _b;
        if (nodeItem.loop) {
          const loopItemName = ((_a = nodeItem.loopArgs) == null ? void 0 : _a[0]) || "item";
          const loopIndexName = ((_b = nodeItem.loopArgs) == null ? void 0 : _b[1]) || "index";
          const subScope = scope.createSubScope([loopItemName, loopIndexName]);
          const pieces = next2 ? next2(nodeItem, subScope, config2) : [];
          const loopDataExpr = tolerateEvalErrors ? `__$$evalArray(() => (${transformThis2Context(
            generateCompositeType(nodeItem.loop, scope, { handlers: config2 == null ? void 0 : config2.handlers }),
            scope
          )}))` : `(${transformThis2Context(
            generateCompositeType(nodeItem.loop, scope, { handlers: config2 == null ? void 0 : config2.handlers }),
            scope
          )})`;
          pieces.unshift({
            value: `${loopDataExpr}.map((${loopItemName}, ${loopIndexName}) => ((__$$context) => (`,
            type: "NodeCodePieceBefore" /* BEFORE */
          });
          pieces.push({
            value: `))(__$$createChildContext(__$$context, { ${loopItemName}, ${loopIndexName} })))`,
            type: "NodeCodePieceAfter" /* AFTER */
          });
          return pieces;
        }
        return next2 ? next2(nodeItem, scope, config2) : [];
      }
    };
    return plugin;
  };
  var jsx_default2 = pluginFactory28;
  function isImportAliasDefineChunk(chunk2) {
    var _a;
    return chunk2.name === COMMON_CHUNK_NAME.ImportAliasDefine && !!chunk2.ext && typeof chunk2.ext.aliasName === "string" && typeof chunk2.ext.originalName === "string" && !!((_a = chunk2.ext.dependency) == null ? void 0 : _a.componentName);
  }
  function generateNodeAttrForRax(attrData, scope, config, next) {
    if (!this.cfg.ignoreMiniApp && /^on/.test(attrData.attrName)) {
      return generateEventHandlerAttrForRax(attrData.attrName, attrData.attrValue, scope, config);
    }
    if (attrData.attrName === "ref") {
      return [
        {
          name: attrData.attrName,
          value: `__$$context._refsManager.linkRef('${attrData.attrValue}')`,
          type: "NodeCodePieceAttr" /* ATTR */
        }
      ];
    }
    return next ? next(attrData, scope, config) : [];
  }
  function generateEventHandlerAttrForRax(attrName, attrValue, scope, config) {
    var _a;
    const valueExpr = generateCompositeType(
      isJSExpression(attrValue) ? { type: "JSFunction", value: attrValue.value } : attrValue,
      scope,
      {
        handlers: config == null ? void 0 : config.handlers
      }
    );
    const currentScopeVariables = ((_a = scope.bindings) == null ? void 0 : _a.getAllBindings()) || [];
    if (currentScopeVariables.length <= 0) {
      return [
        {
          type: "NodeCodePieceAttr" /* ATTR */,
          name: attrName,
          value: valueExpr
        }
      ];
    }
    const undeclaredVariablesInValueExpr = parseExpressionGetGlobalVariables(valueExpr);
    const referencedLocalVariables = lodash_default_default.intersection(
      undeclaredVariablesInValueExpr,
      currentScopeVariables
    );
    if (referencedLocalVariables.length <= 0) {
      return [
        {
          type: "NodeCodePieceAttr" /* ATTR */,
          name: attrName,
          value: valueExpr
        }
      ];
    }
    const wrappedAttrValueExpr = [
      "(...__$$args) => {",
      "  if (__$$isMiniApp) {",
      "    const __$$event = __$$args[0];",
      ...referencedLocalVariables.map(
        (localVar) => `const ${localVar} = __$$event.target.dataset.${localVar};`
      ),
      `    return (${valueExpr}).apply(this, __$$args);`,
      "  } else {",
      `    return (${valueExpr}).apply(this, __$$args);`,
      "  }",
      "}"
    ].join("\n");
    return [
      ...referencedLocalVariables.map((localVar) => ({
        type: "NodeCodePieceAttr" /* ATTR */,
        name: `data-${import_change_case8.default.snake(localVar)}`,
        value: localVar
      })),
      {
        type: "NodeCodePieceAttr" /* ATTR */,
        name: attrName,
        value: wrappedAttrValueExpr
      }
    ];
  }

  // src/plugins/component/rax/commonDeps.ts
  init_define_process();
  var pluginFactory29 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        // \u6CE8\u610F: \u51FA\u7801\u5F15\u64CE\u6CE8\u5165\u7684\u4E34\u65F6\u53D8\u91CF\u9ED8\u8BA4\u90FD\u4EE5 "__$$" \u5F00\u5934\uFF0C\u7981\u6B62\u5728\u642D\u5EFA\u7684\u4EE3\u7801\u4E2D\u76F4\u63A5\u8BBF\u95EE\u3002
        // \u4F8B\u5916\uFF1Arax \u6846\u67B6\u7684\u5BFC\u51FA\u540D\u548C\u5404\u79CD\u7EC4\u4EF6\u540D\u9664\u5916\u3002
        import { createElement, Component } from 'rax';
        import { getSearchParams as __$$getSearchParams } from 'rax-app';
      `,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var commonDeps_default = pluginFactory29;

  // src/plugins/project/framework/rax/index.ts
  init_define_process();

  // src/plugins/project/framework/rax/template/index.ts
  init_define_process();

  // src/plugins/project/framework/rax/template/static-files.ts
  init_define_process();

  // src/plugins/project/framework/rax/template/files/.eslintignore.ts
  init_define_process();
  function getFile21() {
    return [
      ["."],
      {
        name: ".eslintignore",
        ext: "",
        content: "node_modules/\nlib/\ndist/\nbuild/\ncoverage/\ndemo/\nes/\n.rax/\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.eslintrc.js.ts
  init_define_process();
  function getFile22() {
    return [
      ["."],
      {
        name: ".eslintrc",
        ext: "js",
        content: "const { getESLintConfig } = require('@iceworks/spec');\n\n// https://www.npmjs.com/package/@iceworks/spec\nmodule.exports = {\n  ...getESLintConfig('rax'),\n  rules: {\n    'max-len': ['error', { code: 200 }],\n    'function-paren-newline': 'off',\n    '@typescript-eslint/indent': 'off',\n    'prettier/prettier': 'off',\n    'no-empty': 'off',\n    'no-unused-vars': 'off',\n    '@iceworks/best-practices/recommend-functional-component': 'off',\n  },\n};\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.gitignore.ts
  init_define_process();
  function getFile23() {
    return [
      ["."],
      {
        name: ".gitignore",
        ext: "",
        content: "# See https://help.github.com/articles/ignoring-files/ for more about ignoring files.\n\n*~\n*.swp\n*.log\n\n.DS_Store\n.idea/\n.temp/\n\nbuild/\ndist/\nlib/\ncoverage/\nnode_modules/\n.rax/\n\ntemplate.yml"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.prettierignore.ts
  init_define_process();
  function getFile24() {
    return [
      ["."],
      {
        name: ".prettierignore",
        ext: "",
        content: "node_modules/\nlib/\ndist/\nbuild/\ncoverage/\ndemo/\nes/\n.rax/\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.prettierrc.js.ts
  init_define_process();
  function getFile25() {
    return [
      ["."],
      {
        name: ".prettierrc",
        ext: "js",
        content: "const { getPrettierConfig } = require('@iceworks/spec');\n\nmodule.exports = getPrettierConfig('rax');\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.stylelintignore.ts
  init_define_process();
  function getFile26() {
    return [
      ["."],
      {
        name: ".stylelintignore",
        ext: "",
        content: "node_modules/\nlib/\ndist/\nbuild/\ncoverage/\ndemo/\nes/\n.rax/\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/.stylelintrc.js.ts
  init_define_process();
  function getFile27() {
    return [
      ["."],
      {
        name: ".stylelintrc",
        ext: "js",
        content: "const { getStylelintConfig } = require('@iceworks/spec');\n\nmodule.exports = getStylelintConfig('rax');\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/jsconfig.json.ts
  init_define_process();
  function getFile28() {
    return [
      ["."],
      {
        name: "jsconfig",
        ext: "json",
        content: '{\n  "compilerOptions": {\n    "baseUrl": ".",\n    "jsx": "react",\n    "paths": {\n      "@/*": ["./src/*"],\n      "rax-app": [".rax/index.ts"]\n    }\n  }\n}\n'
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/README.md.ts
  init_define_process();
  function getFile29() {
    return [
      ["."],
      {
        name: "README",
        ext: "md",
        content: "# rax-materials-basic-app\n\n## Getting Started\n\n### `npm run start`\n\nRuns the app in development mode.\n\nOpen [http://localhost:3333](http://localhost:3333) to view it in the browser.\n\nThe page will reload if you make edits.\n\n### `npm run build`\n\nBuilds the app for production to the `build` folder.\n"
      }
    ];
  }

  // src/plugins/project/framework/rax/template/files/tsconfig.json.ts
  init_define_process();
  function getFile30() {
    return [
      ["."],
      {
        name: "tsconfig",
        ext: "json",
        content: '{\n  "compileOnSave": false,\n  "buildOnSave": false,\n  "compilerOptions": {\n    "baseUrl": ".",\n    "outDir": "build",\n    "module": "esnext",\n    "target": "es6",\n    "jsx": "preserve",\n    "jsxFactory": "createElement",\n    "moduleResolution": "node",\n    "allowSyntheticDefaultImports": true,\n    "lib": ["es6", "dom"],\n    "sourceMap": true,\n    "allowJs": true,\n    "rootDir": "./",\n    "forceConsistentCasingInFileNames": true,\n    "noImplicitReturns": true,\n    "noImplicitThis": true,\n    "noImplicitAny": false,\n    "importHelpers": true,\n    "strictNullChecks": true,\n    "suppressImplicitAnyIndexErrors": true,\n    "noUnusedLocals": true,\n    "skipLibCheck": true,\n    "paths": {\n      "@/*": ["./src/*"],\n      "rax-app": [".rax/index.ts"]\n    }\n  },\n  "include": ["src", ".rax"],\n  "exclude": ["node_modules", "build", "public"]\n}'
      }
    ];
  }

  // src/plugins/project/framework/rax/template/static-files.ts
  function generateStaticFiles2(root2 = createResultDir(".")) {
    runFileGenerator(root2, getFile21);
    runFileGenerator(root2, getFile22);
    runFileGenerator(root2, getFile23);
    runFileGenerator(root2, getFile24);
    runFileGenerator(root2, getFile25);
    runFileGenerator(root2, getFile26);
    runFileGenerator(root2, getFile27);
    runFileGenerator(root2, getFile28);
    runFileGenerator(root2, getFile29);
    runFileGenerator(root2, getFile30);
    return root2;
  }

  // src/plugins/project/framework/rax/template/index.ts
  var raxAppTemplate = {
    slots: {
      components: {
        path: ["src", "components"]
      },
      pages: {
        path: ["src", "pages"]
      },
      router: {
        path: ["src"],
        fileName: "router"
      },
      entry: {
        path: ["src"],
        fileName: "app"
      },
      appConfig: {
        path: ["src"],
        fileName: "app"
      },
      buildConfig: {
        path: [],
        fileName: "build"
      },
      constants: {
        path: ["src"],
        fileName: "constants"
      },
      utils: {
        path: ["src"],
        fileName: "utils"
      },
      i18n: {
        path: ["src"],
        fileName: "i18n"
      },
      globalStyle: {
        path: ["src"],
        fileName: "global"
      },
      htmlEntry: {
        path: ["src", "document"],
        fileName: "index"
      },
      packageJSON: {
        path: [],
        fileName: "package"
      }
    },
    async generateTemplate() {
      return generateStaticFiles2();
    }
  };
  var template_default3 = raxAppTemplate;

  // src/plugins/project/framework/rax/plugins/entry.ts
  init_define_process();
  var pluginFactory30 = (cfg) => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
import { runApp } from 'rax-app';

import './global.${(cfg == null ? void 0 : cfg.globalStylesFileType) || "css"}';
`,
        linkAfter: []
      });
      const appConfig = (cfg == null ? void 0 : cfg.appConfig) || {};
      Object.assign(appConfig, {
        router: {
          mode: "hash",
          ...appConfig.router
        }
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
runApp(${JSON.stringify(appConfig, null, 2)});
`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      return next;
    };
    return plugin;
  };
  var entry_default2 = pluginFactory30;

  // src/plugins/project/framework/rax/plugins/appConfig.ts
  init_define_process();
  var import_change_case9 = __toESM(require_change_case());
  var pluginFactory31 = (cfg) => {
    const plugin = async (pre) => {
      var _a, _b, _c, _d, _e, _f;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const routes = ((_b = (_a = ir.globalRouter) == null ? void 0 : _a.routes) == null ? void 0 : _b.map((route) => ({
        path: route.path,
        source: `pages/${ensureValidClassName(import_change_case9.default.pascalCase(route.fileName))}/index`
      }))) || [{ path: "/", source: "pages/Home/index" }];
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: `
{
  "routes": ${JSON.stringify(routes, null, 2)},
  "window": {
    "title": ${JSON.stringify(
          (cfg == null ? void 0 : cfg.title) || ((_d = (_c = ir.project) == null ? void 0 : _c.meta) == null ? void 0 : _d.title) || ((_f = (_e = ir.project) == null ? void 0 : _e.meta) == null ? void 0 : _f.name) || ""
        )}
  }
}
      `,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var appConfig_default = pluginFactory31;

  // src/plugins/project/framework/rax/plugins/buildConfig.ts
  init_define_process();
  var pluginFactory32 = (cfg) => {
    const plugin = async (pre) => {
      var _a, _b, _c, _d, _e;
      const next = {
        ...pre
      };
      const ir = next.ir;
      const miniAppBuildType = ((_a = cfg == null ? void 0 : cfg.buildConfig) == null ? void 0 : _a.miniAppBuildType) || ((_c = (_b = ir.project) == null ? void 0 : _b.config) == null ? void 0 : _c.miniAppBuildType);
      const targets = (cfg == null ? void 0 : cfg.targets) || ["web"];
      const buildCfg = {
        inlineStyle: false,
        plugins: [],
        targets,
        miniapp: miniAppBuildType ? {
          buildType: miniAppBuildType,
          ...(_d = cfg == null ? void 0 : cfg.buildConfig) == null ? void 0 : _d.miniapp
        } : (_e = cfg == null ? void 0 : cfg.buildConfig) == null ? void 0 : _e.miniapp,
        ...cfg == null ? void 0 : cfg.buildConfig
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: `${JSON.stringify(buildCfg, null, 2)}
`,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var buildConfig_default = pluginFactory32;

  // src/plugins/project/framework/rax/plugins/entryDocument.ts
  init_define_process();
  var pluginFactory33 = (cfg) => {
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: `
import { createElement } from 'rax';
import { Root, Style, Script } from 'rax-document';

function Document() {
  return (
    <html>
      <head>
        <meta charset="utf-8" />
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no,viewport-fit=cover"
        />
        <title>${(cfg == null ? void 0 : cfg.title) || ((_a = ir == null ? void 0 : ir.meta) == null ? void 0 : _a.name) || "Rax App"}</title>
        <Style />
      </head>
      <body>
        {/* root container */}
        <Root />
        <Script />
      </body>
    </html>
  );
}

export default Document;
`,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var entryDocument_default = pluginFactory33;

  // src/plugins/project/framework/rax/plugins/globalStyle.ts
  init_define_process();
  var pluginFactory34 = (config) => {
    const cfg = {
      fileType: "scss" /* SCSS */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.StyleDepsImport,
        content: "",
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: `
body {
  -webkit-font-smoothing: antialiased;
}
`,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css || "",
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var globalStyle_default2 = pluginFactory34;

  // src/plugins/project/framework/rax/plugins/packageJSON.ts
  init_define_process();

  // src/utils/version.ts
  var version_exports = {};
  __export(version_exports, {
    calcCompatibleVersion: () => calcCompatibleVersion
  });
  init_define_process();
  var import_semver = __toESM(require_semver2());
  function calcCompatibleVersion(v1, v2) {
    if (!v1 && !v2) {
      return "*";
    }
    if (!v1 || v1 === "*") {
      return v2 || "*";
    }
    if (!v2 || v2 === "*") {
      return v1;
    }
    if (v1 === v2) {
      return v1;
    }
    if (!import_semver.default.intersects(v1, v2, { loose: true })) {
      throw new Error(`no compatible versions for "${v1}" and "${v2}"`);
    }
    if (import_semver.default.subset(v1, v2, { loose: true })) {
      return v1;
    }
    return v2;
  }

  // src/plugins/project/framework/rax/plugins/packageJSON.ts
  var pluginFactory35 = (cfg) => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const npmDeps = getNpmDependencies(ir);
      const packageJson = {
        name: (cfg == null ? void 0 : cfg.packageName) || "rax-demo-app",
        private: true,
        version: (cfg == null ? void 0 : cfg.packageVersion) || "1.0.0",
        scripts: {
          start: "rax-app start",
          build: "rax-app build",
          eslint: "eslint --ext .js,.jsx ./",
          stylelint: 'stylelint "**/*.{css,scss,less}"',
          prettier: "prettier **/* --write",
          lint: "npm run eslint && npm run stylelint"
        },
        dependencies: {
          ...buildDataSourceDependencies(ir, cfg == null ? void 0 : cfg.datasourceConfig),
          "universal-env": "^3.2.0",
          "intl-messageformat": "^9.3.6",
          rax: "^1.1.0",
          "rax-document": "^0.1.6",
          ...npmDeps.reduce(
            (acc, npm) => ({
              ...acc,
              [npm.package]: npm.version || "*"
            }),
            {}
          )
        },
        devDependencies: {
          "@iceworks/spec": "^1.0.0",
          "rax-app": "^3.0.0",
          eslint: "^6.8.0",
          prettier: "^2.1.2",
          stylelint: "^13.7.2"
        }
      };
      next.chunks.push({
        type: "json" /* JSON */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: packageJson,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var packageJSON_default2 = pluginFactory35;
  function getNpmDependencies(project) {
    const npmDeps = [];
    const npmNameToPkgMap = /* @__PURE__ */ new Map();
    const allDeps = project.packages;
    allDeps.forEach((dep) => {
      if (!isNpmInfo(dep)) {
        return;
      }
      const existing = npmNameToPkgMap.get(dep.package);
      if (!existing) {
        npmNameToPkgMap.set(dep.package, dep);
        npmDeps.push(dep);
        return;
      }
      if (existing.version !== dep.version) {
        try {
          npmNameToPkgMap.set(dep.package, {
            ...existing,
            version: calcCompatibleVersion(existing.version, dep.version)
          });
        } catch (e) {
          throw new Error(
            `Cannot find compatible version for ${dep.package}. Detail: ${getErrorMessage(e)}`
          );
        }
      }
    });
    return npmDeps;
  }

  // src/plugins/project/framework/rax/index.ts
  var rax_default = {
    template: template_default3,
    plugins: {
      appConfig: appConfig_default,
      buildConfig: buildConfig_default,
      entry: entry_default2,
      entryDocument: entryDocument_default,
      globalStyle: globalStyle_default2,
      packageJSON: packageJSON_default2
    }
  };

  // src/solutions/rax-app.ts
  function createRaxProjectBuilder(options) {
    return createProjectBuilder({
      inStrictMode: options == null ? void 0 : options.inStrictMode,
      extraContextData: { ...options },
      template: rax_default.template,
      plugins: {
        components: [
          commonDeps_default(),
          esmodule_default({ fileType: "jsx", useAliasName: false }),
          containerClass_default2(),
          containerInitState_default2(),
          containerMethods_default(),
          containerInjectContext_default2(),
          containerInjectDataSourceEngine_default2(options),
          containerInjectUtils_default2(),
          containerLifeCycle_default2(),
          jsx_default2(),
          css_default()
        ],
        pages: [
          commonDeps_default(),
          esmodule_default({ fileType: "jsx" }),
          containerClass_default2(),
          containerInitState_default2(),
          containerMethods_default(),
          containerInjectContext_default2(),
          containerInjectDataSourceEngine_default2(options),
          containerInjectUtils_default2(),
          containerLifeCycle_default2(),
          jsx_default2(),
          css_default()
        ],
        appConfig: [rax_default.plugins.appConfig(options)],
        buildConfig: [rax_default.plugins.buildConfig(options)],
        entry: [rax_default.plugins.entry(options)],
        constants: [constants_default()],
        utils: [esmodule_default(), utils_default("rax")],
        i18n: [i18n_default()],
        globalStyle: [
          rax_default.plugins.globalStyle({ fileType: (options == null ? void 0 : options.globalStylesFileType) || "css" })
        ],
        htmlEntry: [rax_default.plugins.entryDocument(options)],
        packageJSON: [rax_default.plugins.packageJSON(options)]
      },
      postProcessors: [prettier_default()]
    });
  }
  var plugins2 = {
    containerClass: containerClass_default2,
    containerLifeCycles: containerLifeCycle_default2,
    containerMethods: containerMethods_default,
    containerInitState: containerInitState_default2,
    containerInjectContext: containerInjectContext_default2,
    containerInjectDataSourceEngine: containerInjectDataSourceEngine_default2,
    containerInjectUtils: containerInjectUtils_default2,
    jsx: jsx_default2,
    commonDeps: commonDeps_default,
    raxApp: rax_default
  };

  // src/solutions/icejsccs.ts
  init_define_process();

  // src/plugins/component/reactccs/containerClass.ts
  init_define_process();
  var import_change_case10 = __toESM(require_change_case());

  // src/plugins/component/reactccs/const.ts
  init_define_process();
  var REACT_CHUNK_NAME2 = {
    ClassRenderStart: "ReactComponentClassRenderStart",
    ClassRenderPre: "ReactComponentClassRenderPre",
    ClassRenderEnd: "ReactComponentClassRenderEnd",
    ClassRenderJSX: "ReactComponentClassRenderJSX",
    ClassDidMountStart: "ReactComponentClassDidMountStart",
    ClassDidMountEnd: "ReactComponentClassDidMountEnd",
    ClassDidMountContent: "ReactComponentClassDidMountContent"
  };

  // src/plugins/component/reactccs/containerClass.ts
  var pluginFactory36 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const componentClassName = ensureValidClassName(
        `${import_change_case10.default.pascalCase(ir.moduleName)}$$Page`
      );
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.Start,
        content: `class ${componentClassName} extends React.Component {`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.End,
        content: "}",
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End],
          REACT_CHUNK_NAME2.ClassRenderEnd,
          REACT_CHUNK_NAME2.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorStart,
        content: "constructor(props, context) { super(props); ",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorEnd,
        content: "}",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorEnd]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME2.ClassDidMountStart,
        content: "componentDidMount() {",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME2.ClassDidMountEnd,
        content: "}",
        linkAfter: [REACT_CHUNK_NAME2.ClassDidMountContent, REACT_CHUNK_NAME2.ClassDidMountStart]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME2.ClassRenderStart,
        content: "render() {",
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End],
          REACT_CHUNK_NAME2.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME2.ClassRenderEnd,
        content: "}",
        linkAfter: [
          REACT_CHUNK_NAME2.ClassRenderStart,
          REACT_CHUNK_NAME2.ClassRenderPre,
          REACT_CHUNK_NAME2.ClassRenderJSX
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `export default ${componentClassName};`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          CLASS_DEFINE_CHUNK_NAME.End
        ]
      });
      return next;
    };
    return plugin;
  };
  var containerClass_default3 = pluginFactory36;

  // src/plugins/component/reactccs/containerInitState.ts
  init_define_process();
  var pluginFactory37 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      implementType: "inConstructor",
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const state = ir.state || {};
      const fields = Object.keys(state).map((stateName) => {
        const value = generateCompositeType(state[stateName], scope);
        return `${stateName}: ${value},`;
      });
      if (cfg.implementType === "inConstructor") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: `this.state = { ${fields.join("")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      } else if (cfg.implementType === "insMember") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `state = { ${fields.join("")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInitState_default3 = pluginFactory37;

  // src/plugins/component/reactccs/containerInjectContext.ts
  init_define_process();
  var pluginFactory38 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const { inStrictMode } = next.contextData;
      if (!inStrictMode) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _context = this;
        `,
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
      } else {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _context = this._createContext();
        `,
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
          content: `
          _createContext() {
          //ccs custom code.......
            const self = this;
            const context = {
              get state() { return self.state; },
              setState(newState, callback) { self.setState(newState, callback); },
              get dataSourceMap() { return self._dataSourceEngine.dataSourceMap || {}; },
              async reloadDataSource() { await self._dataSourceEngine.reloadDataSource(); },
              get utils() { return self.utils; },
              get page() { return context; },
              get component() { return context; },
              get props() { return self.props; },
              get constants() { return self.constants; },
              get $() { return self.$ },
              get $$() { return self.$$ },
              ...this._methods,
            };

            return context;
          }
        `,
          linkAfter: DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectContext_default3 = pluginFactory38;

  // src/plugins/component/reactccs/containerInjectUtils.ts
  init_define_process();
  var pluginFactory39 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.contextData.useRefApi = true;
      const useRef = !!((_a = ir.analyzeResult) == null ? void 0 : _a.isUsingRef);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import utils${useRef ? ", { RefsManager }" : ""} from '../../utils';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: "this.utils = utils;",
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.ConstructorStart]
      });
      if (useRef) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: "this._refsManager = new RefsManager();",
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
          $ = (refName) => {
            return this._refsManager.get(refName);
          }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
          $$ = (refName) => {
            return this._refsManager.getAll(refName);
          }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      } else {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: ` $ = () => null; `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: ` $$ = () => [];        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectUtils_default3 = pluginFactory39;

  // src/plugins/component/reactccs/containerInjectDataSourceEngine.ts
  init_define_process();
  var import_change_case11 = __toESM(require_change_case());
  var pluginFactory40 = (config) => {
    const cfg = {
      ...config,
      fileType: (config == null ? void 0 : config.fileType) || "jsx" /* JSX */
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const scope = Scope.createRootScope();
      const dataSourceConfig = isContainerSchema(pre.ir) ? pre.ir.dataSource : null;
      const dataSourceItems = dataSourceConfig && dataSourceConfig.list || [];
      const dataSourceEngineOptions = { runtimeConfig: true };
      if (dataSourceItems.length > 0) {
        const requestHandlersMap = {};
        dataSourceItems.forEach((ds) => {
          var _a, _b;
          const dsType = ds.type || "fetch";
          if (!(dsType in requestHandlersMap) && dsType !== "custom") {
            const handlerFactoryName = `__$$create${import_change_case11.default.pascal(dsType)}RequestHandler`;
            requestHandlersMap[dsType] = {
              type: "JSExpression",
              value: handlerFactoryName + (dsType === "urlParams" ? "(window.location.search)" : "()")
            };
            const handlerFactoryExportName = `create${import_change_case11.default.pascal(dsType)}Handler`;
            const handlerPkgName = ((_b = (_a = cfg.datasourceConfig) == null ? void 0 : _a.handlersPackages) == null ? void 0 : _b[dsType]) || `@alilc/lowcode-datasource-${import_change_case11.default.kebab(dsType)}-handler`;
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: "jsx" /* JSX */,
              name: COMMON_CHUNK_NAME.ExternalDepsImport,
              content: `
              import { ${handlerFactoryExportName} as ${handlerFactoryName} } from '${handlerPkgName}';
            `,
              linkAfter: []
            });
          }
        });
        Object.assign(dataSourceEngineOptions, { requestHandlersMap });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "jsx" /* JSX */,
          name: COMMON_CHUNK_NAME.ExternalDepsImport,
          content: `
          import { create as __$$createDataSourceEngine } from '@alilc/lowcode-datasource-engine/runtime';
        `,
          linkAfter: []
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _dataSourceConfig = this._defineDataSourceConfig();
          _dataSourceEngine = __$$createDataSourceEngine(
            this._dataSourceConfig,
            this,
            ${generateCompositeType(dataSourceEngineOptions, scope)}
          );

          get dataSourceMap() {
            return this._dataSourceEngine.dataSourceMap || {};
          }

          reloadDataSource = async () => {
            await this._dataSourceEngine.reloadDataSource();
          }

          `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
        next.chunks.unshift({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: REACT_CHUNK_NAME2.ClassDidMountContent,
          content: `
          this._dataSourceEngine.reloadDataSource();
        `,
          linkAfter: [REACT_CHUNK_NAME2.ClassDidMountStart]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
  _defineDataSourceConfig() {
    const _this = this;
    return (${generateCompositeType(
            {
              ...dataSourceConfig,
              list: [
                ...dataSourceItems.map((item) => ({
                  ...item,
                  isInit: wrapAsFunction3(item.isInit, scope),
                  options: wrapAsFunction3(item.options, scope)
                }))
              ]
            },
            scope,
            {
              handlers: {
                function: (jsFunc) => parseExpressionConvertThis2Context(jsFunc.value, "_this"),
                expression: (jsExpr) => parseExpressionConvertThis2Context(jsExpr.value, "_this")
              }
            }
          )});
  }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectDataSourceEngine_default3 = pluginFactory40;
  function wrapAsFunction3(value, scope) {
    if (isJSExpression(value) || isJSFunction(value)) {
      return {
        type: "JSExpression",
        value: `function(){ return ((${value.value}))}`
      };
    }
    return {
      type: "JSExpression",
      value: `function(){return((${generateCompositeType(value, scope)}))}`
    };
  }

  // src/plugins/component/reactccs/containerInjectI18n.ts
  init_define_process();
  var pluginFactory41 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import * as __$$i18n from '../../i18n';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: `
        __$$i18n._inject2(this);
      `,
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectI18n_default2 = pluginFactory41;

  // src/plugins/component/reactccs/containerLifeCycle.ts
  init_define_process();
  var pluginFactory42 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      exportNameMapping: {},
      normalizeNameMapping: {},
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (ir.lifeCycles) {
        const { lifeCycles } = ir;
        const chunks = Object.keys(lifeCycles).map((lifeCycleName) => {
          if (!isJSFunction(lifeCycles[lifeCycleName]) && !isJSExpression(lifeCycles[lifeCycleName])) {
            return null;
          }
          let normalizeName;
          if (lifeCycleName === "constructor") {
            normalizeName = lifeCycleName;
          } else {
            normalizeName = cfg.normalizeNameMapping[lifeCycleName] || lifeCycleName;
          }
          const exportName = cfg.exportNameMapping[lifeCycleName] || lifeCycleName;
          if (normalizeName === "constructor") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]]
            };
          }
          if (normalizeName === "componentDidMount") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: REACT_CHUNK_NAME2.ClassDidMountContent,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [REACT_CHUNK_NAME2.ClassDidMountStart]
            };
          }
          if (normalizeName === "render") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: REACT_CHUNK_NAME2.ClassRenderPre,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [REACT_CHUNK_NAME2.ClassRenderStart]
            };
          }
          return {
            type: "string" /* STRING */,
            fileType: cfg.fileType,
            name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
            content: generateFunction(lifeCycles[lifeCycleName], {
              name: exportName,
              isMember: true
            }),
            linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
          };
        });
        next.chunks.push(...chunks.filter((x) => x !== null));
      }
      return next;
    };
    return plugin;
  };
  var containerLifeCycle_default3 = pluginFactory42;

  // src/plugins/component/reactccs/containerMethod.ts
  init_define_process();
  var pluginFactory43 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const { inStrictMode } = next.contextData;
      if (!ir.methods) {
        return next;
      }
      const { methods } = ir;
      const chunks = Object.keys(methods).map((methodName) => ({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
        content: generateFunction(methods[methodName], { name: methodName, isMember: true }),
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
      }));
      next.chunks.push(...chunks);
      if (inStrictMode) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: Object.keys(ir.methods).map(
            (methodName) => isValidIdentifier(methodName) ? `.${methodName}` : `[${JSON.stringify(methodName)}]`
          ).map((method2) => `this._context${method2} = this${method2};`).join("\n"),
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerMethod_default2 = pluginFactory43;

  // src/plugins/component/reactccs/jsx.ts
  init_define_process();
  var pluginFactory44 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      nodeTypeMapping: {},
      ...config
    };
    const { nodeTypeMapping } = cfg;
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const { tolerateEvalErrors = true, evalErrorsHandler = "" } = next.contextData;
      const customHandlers = {
        expression(input, scope2, config2) {
          var _a;
          return transformJsExpr(generateExpression(input, scope2), scope2, {
            dontWrapEval: !((_a = config2 == null ? void 0 : config2.tolerateEvalErrors) != null ? _a : tolerateEvalErrors),
            dontTransformThis2ContextAtRootScope: true
          });
        },
        function(input, scope2) {
          return transformThis2Context(
            generateCompositeType(
              {
                type: "JSFunction",
                value: input.value || "null"
              },
              Scope.createRootScope()
            ),
            scope2,
            { ignoreRootScope: true }
          );
        }
      };
      const generatorPlugins = {
        handlers: customHandlers,
        tagMapping: (v) => nodeTypeMapping[v] || v,
        tolerateEvalErrors
      };
      if (next.contextData.useRefApi) {
        generatorPlugins.attrPlugins = [
          (attrData, scope2, pluginCfg, nextFunc) => {
            if (attrData.attrName === "ref") {
              return [
                {
                  name: attrData.attrName,
                  value: `this._refsManager.linkRef('${attrData.attrValue}')`,
                  type: "NodeCodePieceAttr" /* ATTR */
                }
              ];
            }
            return nextFunc ? nextFunc(attrData, scope2, pluginCfg) : [];
          }
        ];
      }
      const generator = createReactNodeGenerator(generatorPlugins);
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const jsxContent = generator(ir, scope);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: REACT_CHUNK_NAME2.ClassRenderJSX,
        content: `
        const __$$context = this._context || this;
        const { state } = __$$context;
        return ${jsxContent};
      `,
        linkAfter: [REACT_CHUNK_NAME2.ClassRenderStart, REACT_CHUNK_NAME2.ClassRenderPre]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: [
          tolerateEvalErrors && `
          function __$$eval(expr) {
            try {
              return expr();
            } catch (error) { 
              ${evalErrorsHandler}
            }
          }

          function __$$evalArray(expr) {
            const res = __$$eval(expr);
            return Array.isArray(res) ? res : [];
          }
      `,
          `
        function __$$createChildContext(oldContext, ext) {
          const childContext = {
            ...oldContext,
            ...ext,
          };
          childContext.__proto__ = oldContext;
          return childContext;
        }
      `
        ].filter(Boolean).join("\n"),
        linkAfter: [COMMON_CHUNK_NAME.FileExport]
      });
      return next;
    };
    return plugin;
  };
  var jsx_default3 = pluginFactory44;

  // src/plugins/component/reactccs/reactCommonDeps.ts
  init_define_process();
  var pluginFactory45 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
// \u7814\u53D1\u4E2D\u5FC3\u5B9A\u5236\u51FA\u7801
// \u6CE8\u610F: \u51FA\u7801\u5F15\u64CE\u6CE8\u5165\u7684\u4E34\u65F6\u53D8\u91CF\u9ED8\u8BA4\u90FD\u4EE5 "__$$" \u5F00\u5934\uFF0C\u7981\u6B62\u5728\u642D\u5EFA\u7684\u4EE3\u7801\u4E2D\u76F4\u63A5\u8BBF\u95EE\u3002
// \u4F8B\u5916\uFF1Areact \u6846\u67B6\u7684\u5BFC\u51FA\u540D\u548C\u5404\u79CD\u7EC4\u4EF6\u540D\u9664\u5916\u3002
import React from 'react';`,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var reactCommonDeps_default2 = pluginFactory45;

  // src/plugins/project/framework/icejsccs/index.ts
  init_define_process();

  // src/plugins/project/framework/icejsccs/template/index.ts
  init_define_process();

  // src/plugins/project/framework/icejsccs/template/static-files.ts
  init_define_process();

  // src/plugins/project/framework/icejsccs/template/files/abc.json.ts
  init_define_process();
  function getFile31() {
    return [
      [],
      {
        name: "abc",
        ext: "json",
        content: `
{
  "type": "ice-app",
  "builder": "@ali/builder-ice-app"
}
    `
      }
    ];
  }

  // src/plugins/project/framework/icejsccs/template/files/build.json.ts
  init_define_process();
  function getFile32() {
    return [
      [],
      {
        name: "build",
        ext: "json",
        content: `
{
  "entry": "src/app.js",
  "plugins": [
    [
      "build-plugin-fusion",
      {
        "themePackage": "@alifd/theme-design-pro"
      }
    ],
    [
      "build-plugin-moment-locales",
      {
        "locales": [
          "zh-cn"
        ]
      }
    ]
  ]
}
      `
      }
    ];
  }

  // src/plugins/project/framework/icejsccs/template/files/editorconfig.ts
  init_define_process();
  function getFile33() {
    const file2 = createResultFile(
      ".editorconfig",
      "",
      `
# http://editorconfig.org
root = true

[*]
indent_style = space
indent_size = 2
charset = utf-8
trim_trailing_whitespace = true
insert_final_newline = true

[*.md]
trim_trailing_whitespace = false
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/eslintignore.ts
  init_define_process();
  function getFile34() {
    const file2 = createResultFile(
      ".eslintignore",
      "",
      `
# \u5FFD\u7565\u76EE\u5F55
build/
tests/
demo/
.ice/

# node \u8986\u76D6\u7387\u6587\u4EF6
coverage/

# \u5FFD\u7565\u6587\u4EF6
**/*-min.js
**/*.min.js

package-lock.json
yarn.lock
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/eslintrc.js.ts
  init_define_process();
  function getFile35() {
    const file2 = createResultFile(
      ".eslintrc",
      "js",
      `
const { eslint } = require('@ice/spec');

module.exports = eslint;
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/gitignore.ts
  init_define_process();
  function getFile36() {
    const file2 = createResultFile(
      ".gitignore",
      "",
      `
# See https://help.github.com/ignore-files/ for more about ignoring files.

# dependencies
node_modules/

# production
build/
dist/
tmp/
lib/

# misc
.idea/
.happypack
.DS_Store
*.swp
*.dia~
.ice

npm-debug.log*
yarn-debug.log*
yarn-error.log*
index.module.scss.d.ts
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/jsconfig.json.ts
  init_define_process();
  function getFile37() {
    const file2 = createResultFile(
      "jsconfig",
      "json",
      `
{
  "compilerOptions": {
    "baseUrl": ".",
    "jsx": "react",
    "paths": {
      "@/*": ["./src/*"],
      "ice": [".ice/index.ts"],
      "ice/*": [".ice/pages/*"]
    }
  }
}
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/prettierignore.ts
  init_define_process();
  function getFile38() {
    const file2 = createResultFile(
      ".prettierignore",
      "",
      `
build/
tests/
demo/
.ice/
coverage/
**/*-min.js
**/*.min.js
package-lock.json
yarn.lock
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/prettierrc.js.ts
  init_define_process();
  function getFile39() {
    const file2 = createResultFile(
      ".prettierrc",
      "js",
      `
const { prettier } = require('@ice/spec');

module.exports = prettier;
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/README.md.ts
  init_define_process();
  function getFile40() {
    const file2 = createResultFile(
      "README",
      "md",
      `
## Scaffold Lite

> \u8F7B\u91CF\u7EA7\u6A21\u677F\uFF0C\u4F7F\u7528 JavaScript\uFF0C\u4EC5\u5305\u542B\u57FA\u7840\u7684 Layout\u3002

## \u4F7F\u7528

\`\`\`bash
# \u5B89\u88C5\u4F9D\u8D56
$ npm install

# \u542F\u52A8\u670D\u52A1
$ npm start  # visit http://localhost:3333
\`\`\`

[More docs](https://ice.work/docs/guide/about).

## \u76EE\u5F55

\`\`\`md
\u251C\u2500\u2500 build/                         # \u6784\u5EFA\u4EA7\u7269
\u251C\u2500\u2500 mock/                          # \u672C\u5730\u6A21\u62DF\u6570\u636E
\u2502   \u251C\u2500\u2500 index.[j,t]s
\u251C\u2500\u2500 public/
\u2502   \u251C\u2500\u2500 index.html                 # \u5E94\u7528\u5165\u53E3 HTML
\u2502   \u2514\u2500\u2500 favicon.png                # Favicon
\u251C\u2500\u2500 src/                           # \u6E90\u7801\u8DEF\u5F84
\u2502   \u251C\u2500\u2500 components/                # \u81EA\u5B9A\u4E49\u4E1A\u52A1\u7EC4\u4EF6
\u2502   \u2502   \u2514\u2500\u2500 Guide/
\u2502   \u2502       \u251C\u2500\u2500 index.[j,t]sx
\u2502   \u2502       \u251C\u2500\u2500 index.module.scss
\u2502   \u251C\u2500\u2500 layouts/                   # \u5E03\u5C40\u7EC4\u4EF6
\u2502   \u2502   \u2514\u2500\u2500 BasicLayout/
\u2502   \u2502       \u251C\u2500\u2500 index.[j,t]sx
\u2502   \u2502       \u2514\u2500\u2500 index.module.scss
\u2502   \u251C\u2500\u2500 pages/                     # \u9875\u9762
\u2502   \u2502   \u2514\u2500\u2500 Home/                  # home \u9875\u9762\uFF0C\u7EA6\u5B9A\u8DEF\u7531\u8F6C\u6210\u5C0F\u5199
\u2502   \u2502       \u251C\u2500\u2500 components/        # \u9875\u9762\u7EA7\u81EA\u5B9A\u4E49\u4E1A\u52A1\u7EC4\u4EF6
\u2502   \u2502       \u251C\u2500\u2500 models.[j,t]sx     # \u9875\u9762\u7EA7\u6570\u636E\u72B6\u6001
\u2502   \u2502       \u251C\u2500\u2500 index.[j,t]sx      # \u9875\u9762\u5165\u53E3
\u2502   \u2502       \u2514\u2500\u2500 index.module.scss  # \u9875\u9762\u6837\u5F0F\u6587\u4EF6
\u2502   \u251C\u2500\u2500 configs/                   # [\u53EF\u9009] \u914D\u7F6E\u6587\u4EF6
\u2502   \u2502   \u2514\u2500\u2500 menu.[j,t]s            # [\u53EF\u9009] \u83DC\u5355\u914D\u7F6E
\u2502   \u251C\u2500\u2500 models/                    # [\u53EF\u9009] \u5E94\u7528\u7EA7\u6570\u636E\u72B6\u6001
\u2502   \u2502   \u2514\u2500\u2500 user.[j,t]s
\u2502   \u251C\u2500\u2500 utils/                     # [\u53EF\u9009] \u5DE5\u5177\u5E93
\u2502   \u251C\u2500\u2500 global.scss                # \u5168\u5C40\u6837\u5F0F
\u2502   \u251C\u2500\u2500 routes.[j,t]s              # \u8DEF\u7531\u914D\u7F6E
\u2502   \u2514\u2500\u2500 app.[j,t]s[x]              # \u5E94\u7528\u5165\u53E3\u811A\u672C
\u251C\u2500\u2500 build.json                     # \u5DE5\u7A0B\u914D\u7F6E
\u251C\u2500\u2500 README.md
\u251C\u2500\u2500 package.json
\u251C\u2500\u2500 .editorconfig
\u251C\u2500\u2500 .eslintignore
\u251C\u2500\u2500 .eslintrc.[j,t]s
\u251C\u2500\u2500 .gitignore
\u251C\u2500\u2500 .stylelintignore
\u251C\u2500\u2500 .stylelintrc.[j,t]s
\u251C\u2500\u2500 .gitignore
\u2514\u2500\u2500 [j,t]sconfig.json
\`\`\`
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/src/layouts/BasicLayout/components/Footer/index.jsx.ts
  init_define_process();
  function getFile41() {
    const file2 = createResultFile(
      "index",
      "jsx",
      `
import React from 'react';
import styles from './index.module.scss';

export default function Footer() {
  return (
    <p className={styles.footer}>
      <span className={styles.logo}>Alibaba Fusion</span>
      <br />
      <span className={styles.copyright}>\xA9 2019-\u73B0\u5728 Alibaba Fusion & ICE</span>
    </p>
  );
}
    `
    );
    return [["src", "layouts", "BasicLayout", "components", "Footer"], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/src/layouts/BasicLayout/components/Footer/index.style.ts
  init_define_process();
  function getFile42() {
    const file2 = createResultFile(
      "index",
      "module.scss",
      `
.footer {
  line-height: 20px;
  text-align: center;
}

.logo {
  font-weight: bold;
  font-size: 16px;
}

.copyright {
  font-size: 12px;
}
    `
    );
    return [["src", "layouts", "BasicLayout", "components", "Footer"], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/src/layouts/BasicLayout/components/Logo/index.jsx.ts
  init_define_process();
  function getFile43() {
    const file2 = createResultFile(
      "index",
      "jsx",
      `
import React from 'react';
import { Link } from 'ice';
import styles from './index.module.scss';

export default function Logo({ image, text, url }) {
  return (
    <div className="logo">
      <Link to={url || '/'} className={styles.logo}>
        {image && <img src={image} alt="logo" />}
        <span>{text}</span>
      </Link>
    </div>
  );
}
    `
    );
    return [["src", "layouts", "BasicLayout", "components", "Logo"], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/src/layouts/BasicLayout/components/Logo/index.style.ts
  init_define_process();
  function getFile44() {
    const file2 = createResultFile(
      "index",
      "module.scss",
      `
.logo{
  display: flex;
  align-items: center;
  justify-content: center;
  color: $color-text1-1;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;

  &:visited, &:link {
    color: $color-text1-1;
  }

  img {
    height: 24px;
    margin-right: 10px;
  }
}
    `
    );
    return [["src", "layouts", "BasicLayout", "components", "Logo"], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/src/layouts/BasicLayout/components/PageNav/index.jsx.ts
  init_define_process();
  function getFile45() {
    const file2 = createResultFile(
      "index",
      "jsx",
      `
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'ice';
import { Nav } from '@alifd/next';
import { asideMenuConfig } from '../../menuConfig';

const { SubNav } = Nav;
const NavItem = Nav.Item;

function getNavMenuItems(menusData) {
  if (!menusData) {
    return [];
  }

  return menusData
    .filter(item => item.name && !item.hideInMenu)
    .map((item, index) => getSubMenuOrItem(item, index));
}

function getSubMenuOrItem(item, index) {
  if (item.children && item.children.some(child => child.name)) {
    const childrenItems = getNavMenuItems(item.children);

    if (childrenItems && childrenItems.length > 0) {
      const subNav = (
        <SubNav key={index} icon={item.icon} label={item.name}>
          {childrenItems}
        </SubNav>
      );
      return subNav;
    }

    return null;
  }

  const navItem = (
    <NavItem key={item.path} icon={item.icon}>
      <Link to={item.path}>{item.name}</Link>
    </NavItem>
  );
  return navItem;
}

const Navigation = (props, context) => {
  const { location } = props;
  const { pathname } = location;
  const { isCollapse } = context;
  return (
    <Nav
      type="primary"
      selectedKeys={[pathname]}
      defaultSelectedKeys={[pathname]}
      embeddable
      openMode="single"
      iconOnly={isCollapse}
      hasArrow={false}
      mode={isCollapse ? 'popup' : 'inline'}
    >
      {getNavMenuItems(asideMenuConfig)}
    </Nav>
  );
};

Navigation.contextTypes = {
  isCollapse: PropTypes.bool,
};
const PageNav = withRouter(Navigation);
export default PageNav;
    `
    );
    return [["src", "layouts", "BasicLayout", "components", "PageNav"], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/src/layouts/BasicLayout/index.jsx.ts
  init_define_process();
  function getFile46() {
    const file2 = createResultFile(
      "index",
      "jsx",
      `
import React, { useState } from 'react';
import { Shell, ConfigProvider } from '@alifd/next';
import PageNav from './components/PageNav';
import Logo from './components/Logo';
import Footer from './components/Footer';

(function() {
  const throttle = function(type, name, obj = window) {
    let running = false;

    const func = () => {
      if (running) {
        return;
      }

      running = true;
      requestAnimationFrame(() => {
        obj.dispatchEvent(new CustomEvent(name));
        running = false;
      });
    };

    obj.addEventListener(type, func);
  };

  throttle('resize', 'optimizedResize');
})();

export default function BasicLayout({ children }) {
  const getDevice = width => {
    const isPhone =
      typeof navigator !== 'undefined' && navigator && navigator.userAgent.match(/phone/gi);

    if (width < 680 || isPhone) {
      return 'phone';
    }
    if (width < 1280 && width > 680) {
      return 'tablet';
    }
    return 'desktop';
  };

  const [device, setDevice] = useState(getDevice(NaN));
  window.addEventListener('optimizedResize', e => {
    setDevice(getDevice(e && e.target && e.target.innerWidth));
  });
  return (
    <ConfigProvider device={device}>
      <Shell
        type="dark"
        style={{
          minHeight: '100vh',
        }}
      >
        <Shell.Branding>
          <Logo
            image="https://img.alicdn.com/tfs/TB1.ZBecq67gK0jSZFHXXa9jVXa-904-826.png"
            text="Logo"
          />
        </Shell.Branding>
        <Shell.Navigation
          direction="hoz"
          style={{
            marginRight: 10,
          }}
        ></Shell.Navigation>
        <Shell.Action></Shell.Action>
        <Shell.Navigation>
          <PageNav />
        </Shell.Navigation>

        <Shell.Content>{children}</Shell.Content>
        <Shell.Footer>
          <Footer />
        </Shell.Footer>
      </Shell>
    </ConfigProvider>
  );
}
    `
    );
    return [["src", "layouts", "BasicLayout"], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/src/layouts/BasicLayout/menuConfig.js.ts
  init_define_process();
  function getFile47() {
    const file2 = createResultFile(
      "menuConfig",
      "js",
      `
const headerMenuConfig = [];
const asideMenuConfig = [
  {
    name: 'Dashboard',
    path: '/',
    icon: 'smile',
  },
];
export { headerMenuConfig, asideMenuConfig };
    `
    );
    return [["src", "layouts", "BasicLayout"], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/stylelintignore.ts
  init_define_process();
  function getFile48() {
    const file2 = createResultFile(
      ".stylelintignore",
      "",
      `
# \u5FFD\u7565\u76EE\u5F55
build/
tests/
demo/

# node \u8986\u76D6\u7387\u6587\u4EF6
coverage/
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/stylelintrc.js.ts
  init_define_process();
  function getFile49() {
    const file2 = createResultFile(
      ".stylelintrc",
      "js",
      `
const { stylelint } = require('@ice/spec');

module.exports = stylelint;
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/files/tsconfig.json.ts
  init_define_process();
  function getFile50() {
    const file2 = createResultFile(
      "tsconfig",
      "json",
      `
{
  "compileOnSave": false,
  "buildOnSave": false,
  "compilerOptions": {
    "baseUrl": ".",
    "outDir": "build",
    "module": "esnext",
    "target": "es6",
    "jsx": "react",
    "moduleResolution": "node",
    "allowSyntheticDefaultImports": true,
    "lib": ["es6", "dom"],
    "sourceMap": true,
    "allowJs": true,
    "rootDir": "./",
    "forceConsistentCasingInFileNames": true,
    "noImplicitReturns": true,
    "noImplicitThis": true,
    "noImplicitAny": false,
    "importHelpers": true,
    "strictNullChecks": true,
    "suppressImplicitAnyIndexErrors": true,
    "noUnusedLocals": true,
    "skipLibCheck": true,
    "paths": {
      "@/*": ["./src/*"],
      "ice": [".ice/index.ts"],
      "ice/*": [".ice/pages/*"]
    }
  },
  "include": ["src/*", ".ice"],
  "exclude": ["node_modules", "build", "public"]
}
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/icejsccs/template/static-files.ts
  function generateStaticFiles3(root2 = createResultDir(".")) {
    runFileGenerator(root2, getFile50);
    runFileGenerator(root2, getFile49);
    runFileGenerator(root2, getFile48);
    runFileGenerator(root2, getFile39);
    runFileGenerator(root2, getFile38);
    runFileGenerator(root2, getFile37);
    runFileGenerator(root2, getFile36);
    runFileGenerator(root2, getFile35);
    runFileGenerator(root2, getFile34);
    runFileGenerator(root2, getFile33);
    runFileGenerator(root2, getFile32);
    runFileGenerator(root2, getFile31);
    runFileGenerator(root2, getFile40);
    runFileGenerator(root2, getFile46);
    runFileGenerator(root2, getFile47);
    runFileGenerator(root2, getFile41);
    runFileGenerator(root2, getFile42);
    runFileGenerator(root2, getFile43);
    runFileGenerator(root2, getFile44);
    runFileGenerator(root2, getFile45);
    return root2;
  }

  // src/plugins/project/framework/icejsccs/template/index.ts
  var icejsTemplate2 = {
    slots: {
      components: {
        path: ["src", "components"]
      },
      pages: {
        path: ["src", "pages"]
      },
      router: {
        path: ["src"],
        fileName: "routes"
      },
      entry: {
        path: ["src"],
        fileName: "app"
      },
      constants: {
        path: ["src"],
        fileName: "constants"
      },
      utils: {
        path: ["src"],
        fileName: "utils"
      },
      i18n: {
        path: ["src"],
        fileName: "i18n"
      },
      globalStyle: {
        path: ["src"],
        fileName: "global"
      },
      htmlEntry: {
        path: ["public"],
        fileName: "index"
      },
      packageJSON: {
        path: [],
        fileName: "package"
      }
    },
    generateTemplate() {
      return generateStaticFiles3();
    }
  };
  var template_default4 = icejsTemplate2;

  // src/plugins/project/framework/icejsccs/plugins/entry.ts
  init_define_process();
  var pluginFactory46 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import { createApp } from 'ice';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
        const appConfig = {
          app: {
            rootId: 'app',
          },
          router: {
            type: 'hash',
          },
        };
        createApp(appConfig);
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      return next;
    };
    return plugin;
  };
  var entry_default3 = pluginFactory46;

  // src/plugins/project/framework/icejsccs/plugins/entryHtml.ts
  init_define_process();
  var pluginFactory47 = () => {
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "html" /* HTML */,
        name: COMMON_CHUNK_NAME.HtmlContent,
        content: `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8" />
            <meta http-equiv="x-ua-compatible" content="ie=edge,chrome=1" />
            <meta name="viewport" content="width=device-width" />
            <title>${((_a = ir == null ? void 0 : ir.meta) == null ? void 0 : _a.name) || "Ccs App"}</title>
          </head>
          <body>
            <div id="app"></div>
          </body>
        </html>
      `,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var entryHtml_default2 = pluginFactory47;

  // src/plugins/project/framework/icejsccs/plugins/globalStyle.ts
  init_define_process();
  var pluginFactory48 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleDepsImport,
        content: `
        // \u5F15\u5165\u9ED8\u8BA4\u5168\u5C40\u6837\u5F0F
        @import '@alifd/next/reset.scss';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: `
        body {
          -webkit-font-smoothing: antialiased;
        }
      `,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "scss" /* SCSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css || "",
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var globalStyle_default3 = pluginFactory48;

  // src/plugins/project/framework/icejsccs/plugins/packageJSON.ts
  init_define_process();
  var pluginFactory49 = (cfg) => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const packageJson = {
        name: (cfg == null ? void 0 : cfg.packageName) || "icejs-demo-app",
        version: (cfg == null ? void 0 : cfg.packageVersion) || "0.1.5",
        description: "\u8F7B\u91CF\u7EA7\u6A21\u677F\uFF0C\u4F7F\u7528 JavaScript\uFF0C\u4EC5\u5305\u542B\u57FA\u7840\u7684 Layout\u3002",
        peerDependencies: {
          "react-sortablejs": "~6.0.0"
        },
        dependencies: {
          moment: "^2.24.0",
          react: "^16.4.1",
          "react-dom": "^16.4.1",
          "react-router": "^5.2.1",
          "@alifd/theme-design-pro": "^0.x",
          "intl-messageformat": "^9.3.6",
          "@ice/store": "^1.4.3",
          "@loadable/component": "^5.15.2",
          ...buildDataSourceDependencies(ir, cfg == null ? void 0 : cfg.datasourceConfig)
        },
        devDependencies: {
          "@ice/spec": "^1.0.0",
          "build-plugin-fusion": "^0.1.0",
          "build-plugin-moment-locales": "^0.1.0",
          eslint: "^6.0.1",
          "ice.js": "^1.0.0",
          stylelint: "^13.2.0"
        },
        scripts: {
          start: "icejs start",
          build: "icejs build",
          lint: "npm run eslint && npm run stylelint",
          eslint: "eslint --cache --ext .js,.jsx ./",
          stylelint: "stylelint ./**/*.scss"
        },
        ideMode: {
          name: "ice-react"
        },
        iceworks: {
          type: "react",
          adapter: "adapter-react-v3"
        },
        engines: {
          node: ">=8.0.0"
        },
        repository: {
          type: "git",
          url: "http://gitlab.xxx.com/msd/leak-scan/tree/master"
        },
        private: true,
        originTemplate: "@alifd/scaffold-lite-js"
      };
      ir.packages.forEach((packageInfo) => {
        packageJson.dependencies[packageInfo.package] = packageInfo.version;
      });
      next.chunks.push({
        type: "json" /* JSON */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: packageJson,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var packageJSON_default3 = pluginFactory49;

  // src/plugins/project/framework/icejsccs/plugins/router.ts
  init_define_process();
  var pluginFactory50 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import BasicLayout from '@/layouts/BasicLayout';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileVarDefine,
        content: `
        const routerConfig = [
          {
            path: '/',
            component: BasicLayout,
            children: [
              ${ir.routes.map(
          (route) => `
                    {
                      path: '${route.path}',
                      component: ${route.componentName},
                    }
                  `
        ).join(",")}
            ],
          },
        ];
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export default routerConfig;
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var router_default2 = pluginFactory50;

  // src/plugins/project/framework/icejsccs/index.ts
  var icejsccs_default = {
    template: template_default4,
    plugins: {
      entry: entry_default3,
      entryHtml: entryHtml_default2,
      globalStyle: globalStyle_default3,
      packageJSON: packageJSON_default3,
      router: router_default2
    }
  };

  // src/solutions/icejsccs.ts
  function createIceJsCcsProjectBuilder(options) {
    return createProjectBuilder({
      inStrictMode: options == null ? void 0 : options.inStrictMode,
      extraContextData: { ...options },
      template: icejsccs_default.template,
      plugins: {
        components: [
          reactCommonDeps_default2(),
          esmodule_default({
            fileType: "jsx"
          }),
          containerClass_default3(),
          containerInjectContext_default3(),
          containerInjectUtils_default3(),
          containerInjectDataSourceEngine_default3(),
          containerInjectI18n_default2(),
          containerInitState_default3(),
          containerLifeCycle_default3(),
          containerMethod_default2(),
          jsx_default3({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "div",
              Block: "div"
            }
          }),
          css_default()
        ],
        pages: [
          reactCommonDeps_default2(),
          esmodule_default({
            fileType: "jsx"
          }),
          containerClass_default3(),
          containerInjectContext_default3(),
          containerInjectUtils_default3(),
          containerInjectDataSourceEngine_default3(),
          containerInjectI18n_default2(),
          containerInitState_default3(),
          containerLifeCycle_default3(),
          containerMethod_default2(),
          jsx_default3({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "div",
              Block: "div"
            }
          }),
          css_default()
        ],
        router: [esmodule_default(), icejsccs_default.plugins.router()],
        entry: [icejsccs_default.plugins.entry()],
        constants: [constants_default()],
        utils: [esmodule_default(), utils_default("react")],
        i18n: [i18n_default()],
        globalStyle: [icejsccs_default.plugins.globalStyle()],
        htmlEntry: [icejsccs_default.plugins.entryHtml()],
        packageJSON: [icejsccs_default.plugins.packageJSON()]
      },
      postProcessors: [prettier_default()]
    });
  }
  var plugins3 = {
    containerClass: containerClass_default3,
    containerInitState: containerInitState_default3,
    containerInjectContext: containerInjectContext_default3,
    containerInjectUtils: containerInjectUtils_default3,
    containerInjectI18n: containerInjectI18n_default2,
    containerInjectDataSourceEngine: containerInjectDataSourceEngine_default3,
    containerLifeCycle: containerLifeCycle_default3,
    containerMethod: containerMethod_default2,
    jsx: jsx_default3,
    commonDeps: reactCommonDeps_default2,
    reactCommonDeps: reactCommonDeps_default2
  };

  // src/solutions/normal.ts
  init_define_process();

  // src/plugins/component/normalreact/containerClass.ts
  init_define_process();
  var import_change_case12 = __toESM(require_change_case());

  // src/plugins/component/normalreact/const.ts
  init_define_process();
  var REACT_CHUNK_NAME3 = {
    ClassRenderStart: "ReactComponentClassRenderStart",
    ClassRenderPre: "ReactComponentClassRenderPre",
    ClassRenderEnd: "ReactComponentClassRenderEnd",
    ClassRenderJSX: "ReactComponentClassRenderJSX",
    ClassDidMountStart: "ReactComponentClassDidMountStart",
    ClassDidMountEnd: "ReactComponentClassDidMountEnd",
    ClassDidMountContent: "ReactComponentClassDidMountContent"
  };

  // src/plugins/component/normalreact/containerClass.ts
  var pluginFactory51 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const componentClassName = ensureValidClassName(
        `${import_change_case12.default.pascalCase(ir.moduleName)}$$Page`
      );
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.Start,
        content: `class ${componentClassName} extends React.Component {`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.End,
        content: "}",
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End],
          REACT_CHUNK_NAME3.ClassRenderEnd,
          REACT_CHUNK_NAME3.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorStart,
        content: "constructor(props, context) { super(props); ",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorEnd,
        content: "}",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorEnd]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME3.ClassDidMountStart,
        content: "componentDidMount() {",
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End]]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME3.ClassDidMountEnd,
        content: "}",
        linkAfter: [REACT_CHUNK_NAME3.ClassDidMountContent, REACT_CHUNK_NAME3.ClassDidMountStart]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME3.ClassRenderStart,
        content: "render() {",
        linkAfter: [
          ...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.End],
          REACT_CHUNK_NAME3.ClassDidMountEnd
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: REACT_CHUNK_NAME3.ClassRenderEnd,
        content: "}",
        linkAfter: [
          REACT_CHUNK_NAME3.ClassRenderStart,
          REACT_CHUNK_NAME3.ClassRenderPre,
          REACT_CHUNK_NAME3.ClassRenderJSX
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `export default ${componentClassName};`,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine,
          CLASS_DEFINE_CHUNK_NAME.End
        ]
      });
      return next;
    };
    return plugin;
  };
  var containerClass_default4 = pluginFactory51;

  // src/plugins/component/normalreact/containerInitState.ts
  init_define_process();
  var pluginFactory52 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      implementType: "inConstructor",
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const state = ir.state || {};
      const fields = Object.keys(state).map((stateName) => {
        const value = generateCompositeType(state[stateName], scope);
        return `${stateName}: ${value},`;
      });
      if (cfg.implementType === "inConstructor") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: `this.state = { ${fields.join("")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      } else if (cfg.implementType === "insMember") {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `state = { ${fields.join("")} };`,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInitState_default4 = pluginFactory52;

  // src/plugins/component/normalreact/containerInjectContext.ts
  init_define_process();
  var pluginFactory53 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const { inStrictMode } = next.contextData;
      if (!inStrictMode) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _context = this;
        `,
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
      } else {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _context = this._createContext();
        `,
          linkAfter: [CLASS_DEFINE_CHUNK_NAME.Start]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod,
          content: `
          _createContext() {
          //ccs custom code.......
            const self = this;
            const context = {
              get state() { return self.state; },
              setState(newState, callback) { self.setState(newState, callback); },
              get dataSourceMap() { return self._dataSourceEngine.dataSourceMap || {}; },
              async reloadDataSource() { await self._dataSourceEngine.reloadDataSource(); },
              get utils() { return self.utils; },
              get page() { return context; },
              get component() { return context; },
              get props() { return self.props; },
              get constants() { return self.constants; },
              get $() { return self.$ },
              get $$() { return self.$$ },
              ...this._methods,
            };

            return context;
          }
        `,
          linkAfter: DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsPrivateMethod]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectContext_default4 = pluginFactory53;

  // src/plugins/component/normalreact/containerInjectUtils.ts
  init_define_process();
  var pluginFactory54 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      var _a;
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.contextData.useRefApi = true;
      const useRef = !!((_a = ir.analyzeResult) == null ? void 0 : _a.isUsingRef);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import utils${useRef ? ", { RefsManager }" : ""} from '../../utils';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: "this.utils = utils;",
        linkAfter: [CLASS_DEFINE_CHUNK_NAME.ConstructorStart]
      });
      if (useRef) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: "this._refsManager = new RefsManager();",
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
          $ = (refName) => {
            return this._refsManager.get(refName);
          }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
          $$ = (refName) => {
            return this._refsManager.getAll(refName);
          }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      } else {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: ` $ = () => null; `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: ` $$ = () => [];        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectUtils_default4 = pluginFactory54;

  // src/plugins/component/normalreact/containerInjectDataSourceEngine.ts
  init_define_process();
  var import_change_case13 = __toESM(require_change_case());
  var pluginFactory55 = (config) => {
    const cfg = {
      ...config,
      fileType: (config == null ? void 0 : config.fileType) || "jsx" /* JSX */
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const scope = Scope.createRootScope();
      const dataSourceConfig = isContainerSchema(pre.ir) ? pre.ir.dataSource : null;
      const dataSourceItems = dataSourceConfig && dataSourceConfig.list || [];
      const dataSourceEngineOptions = { runtimeConfig: true };
      if (dataSourceItems.length > 0) {
        const requestHandlersMap = {};
        dataSourceItems.forEach((ds) => {
          var _a, _b;
          const dsType = ds.type || "fetch";
          if (!(dsType in requestHandlersMap) && dsType !== "custom") {
            const handlerFactoryName = `__$$create${import_change_case13.default.pascal(dsType)}RequestHandler`;
            requestHandlersMap[dsType] = {
              type: "JSExpression",
              value: handlerFactoryName + (dsType === "urlParams" ? "(window.location.search)" : "()")
            };
            const handlerFactoryExportName = `create${import_change_case13.default.pascal(dsType)}Handler`;
            const handlerPkgName = ((_b = (_a = cfg.datasourceConfig) == null ? void 0 : _a.handlersPackages) == null ? void 0 : _b[dsType]) || `@alilc/lowcode-datasource-${import_change_case13.default.kebab(dsType)}-handler`;
            next.chunks.push({
              type: "string" /* STRING */,
              fileType: "jsx" /* JSX */,
              name: COMMON_CHUNK_NAME.ExternalDepsImport,
              content: `
              import { ${handlerFactoryExportName} as ${handlerFactoryName} } from '${handlerPkgName}';
            `,
              linkAfter: []
            });
          }
        });
        Object.assign(dataSourceEngineOptions, { requestHandlersMap });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "jsx" /* JSX */,
          name: COMMON_CHUNK_NAME.ExternalDepsImport,
          content: `
          import { create as __$$createDataSourceEngine } from '@alilc/lowcode-datasource-engine/runtime';
        `,
          linkAfter: []
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsVar,
          content: `
          _dataSourceConfig = this._defineDataSourceConfig();
          _dataSourceEngine = __$$createDataSourceEngine(
            this._dataSourceConfig,
            this,
            ${generateCompositeType(dataSourceEngineOptions, scope)}
          );

          get dataSourceMap() {
            return this._dataSourceEngine.dataSourceMap || {};
          }

          reloadDataSource = async () => {
            await this._dataSourceEngine.reloadDataSource();
          }

          `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsVar]]
        });
        next.chunks.unshift({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: REACT_CHUNK_NAME3.ClassDidMountContent,
          content: `
          this._dataSourceEngine.reloadDataSource();
        `,
          linkAfter: [REACT_CHUNK_NAME3.ClassDidMountStart]
        });
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
          content: `
  _defineDataSourceConfig() {
    const _this = this;
    return (${generateCompositeType(
            {
              ...dataSourceConfig,
              list: [
                ...dataSourceItems.map((item) => ({
                  ...item,
                  isInit: wrapAsFunction4(item.isInit, scope),
                  options: wrapAsFunction4(item.options, scope)
                }))
              ]
            },
            scope,
            {
              handlers: {
                function: (jsFunc) => parseExpressionConvertThis2Context(jsFunc.value, "_this"),
                expression: (jsExpr) => parseExpressionConvertThis2Context(jsExpr.value, "_this")
              }
            }
          )});
  }
        `,
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerInjectDataSourceEngine_default4 = pluginFactory55;
  function wrapAsFunction4(value, scope) {
    if (isJSExpression(value) || isJSFunction(value)) {
      return {
        type: "JSExpression",
        value: `function(){ return ((${value.value}))}`
      };
    }
    return {
      type: "JSExpression",
      value: `function(){return((${generateCompositeType(value, scope)}))}`
    };
  }

  // src/plugins/component/normalreact/containerInjectI18n.ts
  init_define_process();
  var pluginFactory56 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import * as __$$i18n from '../../i18n';
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
        content: `
        __$$i18n._inject2(this);
      `,
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
      });
      return next;
    };
    return plugin;
  };
  var containerInjectI18n_default3 = pluginFactory56;

  // src/plugins/component/normalreact/containerLifeCycle.ts
  init_define_process();
  var pluginFactory57 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      exportNameMapping: {},
      normalizeNameMapping: {},
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      if (ir.lifeCycles) {
        const { lifeCycles } = ir;
        const chunks = Object.keys(lifeCycles).map((lifeCycleName) => {
          if (!isJSFunction(lifeCycles[lifeCycleName]) && !isJSExpression(lifeCycles[lifeCycleName])) {
            return null;
          }
          let normalizeName;
          if (lifeCycleName === "constructor") {
            normalizeName = lifeCycleName;
          } else {
            normalizeName = cfg.normalizeNameMapping[lifeCycleName] || lifeCycleName;
          }
          const exportName = cfg.exportNameMapping[lifeCycleName] || lifeCycleName;
          if (normalizeName === "constructor") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorStart]]
            };
          }
          if (normalizeName === "componentDidMount") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: REACT_CHUNK_NAME3.ClassDidMountContent,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [REACT_CHUNK_NAME3.ClassDidMountStart]
            };
          }
          if (normalizeName === "render") {
            return {
              type: "string" /* STRING */,
              fileType: cfg.fileType,
              name: REACT_CHUNK_NAME3.ClassRenderPre,
              content: generateFunction(lifeCycles[lifeCycleName], { isBlock: true }),
              linkAfter: [REACT_CHUNK_NAME3.ClassRenderStart]
            };
          }
          return {
            type: "string" /* STRING */,
            fileType: cfg.fileType,
            name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
            content: generateFunction(lifeCycles[lifeCycleName], {
              name: exportName,
              isMember: true
            }),
            linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
          };
        });
        next.chunks.push(...chunks.filter((x) => x !== null));
      }
      return next;
    };
    return plugin;
  };
  var containerLifeCycle_default4 = pluginFactory57;

  // src/plugins/component/normalreact/containerMethod.ts
  init_define_process();
  var pluginFactory58 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      ...config
    };
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const { inStrictMode } = next.contextData;
      if (!ir.methods) {
        return next;
      }
      const { methods } = ir;
      const chunks = Object.keys(methods).map((methodName) => ({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: CLASS_DEFINE_CHUNK_NAME.InsMethod,
        content: generateFunction(methods[methodName], { name: methodName, isMember: true }),
        linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.InsMethod]]
      }));
      next.chunks.push(...chunks);
      if (inStrictMode) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: cfg.fileType,
          name: CLASS_DEFINE_CHUNK_NAME.ConstructorContent,
          content: Object.keys(ir.methods).map(
            (methodName) => isValidIdentifier(methodName) ? `.${methodName}` : `[${JSON.stringify(methodName)}]`
          ).map((method2) => `this._context${method2} = this${method2};`).join("\n"),
          linkAfter: [...DEFAULT_LINK_AFTER[CLASS_DEFINE_CHUNK_NAME.ConstructorContent]]
        });
      }
      return next;
    };
    return plugin;
  };
  var containerMethod_default3 = pluginFactory58;

  // src/plugins/component/normalreact/jsx.ts
  init_define_process();
  var pluginFactory59 = (config) => {
    const cfg = {
      fileType: "jsx" /* JSX */,
      nodeTypeMapping: {},
      ...config
    };
    const { nodeTypeMapping } = cfg;
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const { tolerateEvalErrors = true, evalErrorsHandler = "" } = next.contextData;
      const customHandlers = {
        expression(input, scope2, config2) {
          var _a;
          return transformJsExpr(generateExpression(input, scope2), scope2, {
            dontWrapEval: !((_a = config2 == null ? void 0 : config2.tolerateEvalErrors) != null ? _a : tolerateEvalErrors),
            dontTransformThis2ContextAtRootScope: true
          });
        },
        function(input, scope2) {
          return transformThis2Context(
            generateCompositeType(
              {
                type: "JSFunction",
                value: input.value || "null"
              },
              Scope.createRootScope()
            ),
            scope2,
            { ignoreRootScope: true }
          );
        }
      };
      const generatorPlugins = {
        handlers: customHandlers,
        tagMapping: (v) => nodeTypeMapping[v] || v,
        tolerateEvalErrors
      };
      if (next.contextData.useRefApi) {
        generatorPlugins.attrPlugins = [
          (attrData, scope2, pluginCfg, nextFunc) => {
            if (attrData.attrName === "ref") {
              return [
                {
                  name: attrData.attrName,
                  value: `this._refsManager.linkRef('${attrData.attrValue}')`,
                  type: "NodeCodePieceAttr" /* ATTR */
                }
              ];
            }
            return nextFunc ? nextFunc(attrData, scope2, pluginCfg) : [];
          }
        ];
      }
      const generator = createReactNodeGenerator(generatorPlugins);
      const ir = next.ir;
      const scope = Scope.createRootScope();
      const jsxContent = generator(ir, scope);
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: REACT_CHUNK_NAME3.ClassRenderJSX,
        content: `
        const __$$context = this._context || this;
        const { state } = __$$context;
        return ${jsxContent};
      `,
        linkAfter: [REACT_CHUNK_NAME3.ClassRenderStart, REACT_CHUNK_NAME3.ClassRenderPre]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: cfg.fileType,
        name: COMMON_CHUNK_NAME.CustomContent,
        content: [
          tolerateEvalErrors && `
          function __$$eval(expr) {
            try {
              return expr();
            } catch (error) { 
              ${evalErrorsHandler}
            }
          }

          function __$$evalArray(expr) {
            const res = __$$eval(expr);
            return Array.isArray(res) ? res : [];
          }
      `,
          `
        function __$$createChildContext(oldContext, ext) {
          const childContext = {
            ...oldContext,
            ...ext,
          };
          childContext.__proto__ = oldContext;
          return childContext;
        }
      `
        ].filter(Boolean).join("\n"),
        linkAfter: [COMMON_CHUNK_NAME.FileExport]
      });
      return next;
    };
    return plugin;
  };
  var jsx_default4 = pluginFactory59;

  // src/plugins/component/normalreact/reactCommonDeps.ts
  init_define_process();
  var pluginFactory60 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
// \u7814\u53D1\u4E2D\u5FC3\u5B9A\u5236\u51FA\u7801normal
// \u6CE8\u610F: \u51FA\u7801\u5F15\u64CE\u6CE8\u5165\u7684\u4E34\u65F6\u53D8\u91CF\u9ED8\u8BA4\u90FD\u4EE5 "__$$" \u5F00\u5934\uFF0C\u7981\u6B62\u5728\u642D\u5EFA\u7684\u4EE3\u7801\u4E2D\u76F4\u63A5\u8BBF\u95EE\u3002
// \u4F8B\u5916\uFF1Areact \u6846\u67B6\u7684\u5BFC\u51FA\u540D\u548C\u5404\u79CD\u7EC4\u4EF6\u540D\u9664\u5916\u3002
import React from 'react';`,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var reactCommonDeps_default3 = pluginFactory60;

  // src/plugins/project/framework/normal/index.ts
  init_define_process();

  // src/plugins/project/framework/normal/template/index.ts
  init_define_process();

  // src/plugins/project/framework/normal/template/static-files.ts
  init_define_process();

  // src/plugins/project/framework/normal/template/files/src/layouts/BasicLayout/index.less.ts
  init_define_process();
  function getFile51() {
    const file2 = createResultFile(
      "index",
      "less",
      `
.layout-console {
  height: 100vh;

  #components-layout-demo-top-side-2 .logo {
    float: left;
    width: 120px;
    height: 31px;
    margin: 16px 24px 16px 0;
    background: rgba(255, 255, 255, 0.3);
  }

  .ant-row-rtl #components-layout-demo-top-side-2 .logo {
    float: right;
    margin: 16px 0 16px 24px;
  }

  .site-layout-background {
    background: #fff;
  }

  .header {
    background: #fff;
    font-size: 18px;
    padding: 0 0 0 10px;
    margin-bottom: 3px;
    line-height: 54px;
    height: 54px;
  }

  .logo {
    height: 32px;
    margin: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 32px;
    }
    span {
      width: 100px;
      height: 30px;
      overflow: hidden;
      margin-left: 12px;
      font-size: 16px;
      color: #000000d9;
      font-weight: 700;
      vertical-align: text-bottom;
      text-transform: uppercase;
      display: inline-block;
    }
  }
}
    `
    );
    return [["src", "layouts", "BasicLayout"], file2];
  }

  // src/plugins/project/framework/normal/template/files/src/App.js.ts
  init_define_process();
  function getFile52() {
    const file2 = createResultFile(
      "App",
      "js",
      `
import './globalStyle.css';
import {Switch, BrowserRouter} from "react-router-dom";
import {routes, RouteWithSubRoutes} from "@src/routes";

function App() {
  return (
      <div>
        <BrowserRouter>
          <Switch>
            {routes.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
            ))}
          </Switch>
        </BrowserRouter>
      </div>
  );
}

export default App;
    `
    );
    return [["src"], file2];
  }

  // src/plugins/project/framework/normal/template/files/src/craco.config.js.ts
  init_define_process();
  function getFile53() {
    const file2 = createResultFile(
      "craco.config",
      "js",
      `
const CracoLessPlugin = require('craco-less');
const { loaderByName } = require("@craco/craco");
const CracoAlias = require("craco-alias");
// \u66F4\u591A craco\u914D\u7F6E https://craco.js.org/docs/
module.exports = {
    eslint: {
        enable: false /* (default value) */,
    },
    // \u66F4\u591Awebpak\u914D\u7F6E https://webpack.docschina.org/
    // webpack:{
    //     configure:{
    //     }
    // },
    plugins: [
        {
            plugin: CracoAlias,
            options: {
                source: "options",
                baseUrl: "./",
                aliases: {
                    "@src": "./src",
                    "@utils": "./src/utils",
                    "@assets": "./src/assets",
                }
            }
        },
        {
            plugin: CracoLessPlugin,
            options: {
                modifyLessRule(lessRule, context) {
                    // You have to exclude these file suffixes first,
                    // if you want to modify the less module's suffix
                    lessRule.exclude = /\\.m\\.less$/;
                    return lessRule;
                },
                modifyLessModuleRule(lessModuleRule, context) {
                    // Configure the file suffix
                    lessModuleRule.test = /\\.m\\.less$/;
                    // Configure the generated local ident name.
                    const cssLoader = lessModuleRule.use.find(loaderByName("css-loader"));
                    cssLoader.options.modules = {
                        localIdentName: "[local]_[hash:base64:5]",
                    };
        
                    return lessModuleRule;
                },
                lessLoaderOptions: {
                    lessOptions: {
                        modifyVars: { '@primary-color': '#1DA57A' },
                        javascriptEnabled: true,
                    },
                },
            },
        }
    ],
};
    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/normal/template/files/src/README.md.ts
  init_define_process();
  function getFile54() {
    const file2 = createResultFile(
      "README",
      "md",
      `
# Use antd in create-react-app \u2728

[Create React App](https://facebook.github.io/create-react-app/) + [Ant Design](https://ant.design).

## Step by Step Documentation

- \u{1F1FA}\u{1F1F8} English: https://ant.design/docs/react/use-with-create-react-app
- \u{1F1E8}\u{1F1F3} \u4E2D\u6587\uFF1Ahttps://ant.design/docs/react/use-with-create-react-app-cn

## Preview

\`\`\`bash
$ npm install
$ npm start

or:

\`\`\`bash
$ yarn
$ yarn start
\`\`\`

## See more

- [antd](http://github.com/ant-design/ant-design/)
- [create-react-app](https://github.com/facebookincubator/create-react-app)
- [craco](https://github.com/gsoft-inc/craco)
- [craco-less](https://github.com/DocSpring/craco-less)

---

This project was bootstrapped with [Create React App](https://github.com/facebook/create-react-app).

## Available Scripts

In the project directory, you can run:

### \`npm start\`



    `
    );
    return [[], file2];
  }

  // src/plugins/project/framework/normal/template/files/src/layouts/BasicLayout/index.jsx.ts
  init_define_process();
  function getFile55() {
    const file2 = createResultFile(
      "index",
      "jsx",
      `
import {Layout, Menu, Breadcrumb, Row, Col,Result} from 'antd';
import "./index.less";
import {
    UserOutlined, MenuUnfoldOutlined, MenuFoldOutlined,SmileOutlined
} from '@ant-design/icons';
import {Switch} from "react-router-dom";
import {createElement,  useState} from "react";
import {menuData} from '@src/menuData'
import {getMenu,  fcGetMenuPath} from '@src/menu/menu'
import {RouteWithSubRoutes} from "@src/routes";

const {SubMenu} = Menu;
const {Header, Content, Sider} = Layout;

export default function BasicLayout(props) {

    let [state, setState] = useState({collapsed: false})
    let [breadcrumbMap, setBreadcrumbMap] = useState([])


    let toggle = () => {
        setState({
            collapsed: !state.collapsed,
        });
    };

    const handleMenuSelect = ({keyPath}) => {
        console.log(keyPath)
        const menuPath =  fcGetMenuPath(keyPath,menuData)
        setBreadcrumbMap(menuPath)
    }

    return <Layout theme="light" className="layout-console">

        <Sider width={200} trigger={null} className="site-layout-background" onCollapse={() => {
            console.log("test")
        }} collapsed={state.collapsed}>
            <div className="logo">
                {!state.collapsed && <span>Lowcode</span>}
            </div>
            {getMenu(menuData, handleMenuSelect)}
        </Sider>
        <Layout style={{padding: '0 5px 5px 5px '}}>
            <Header className="header">
                <Row>
                    <Col span={18} style={{display: "flex", justifyContent: "left", alignItems: "center"}}>
                        {createElement(state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                            className: 'trigger',
                            onClick: toggle,
                        })}

                        {breadcrumbMap && <Breadcrumb style={{margin: '16px 10px', display: "inline-block"}}>
                            <Breadcrumb.Item>\u9996\u9875</Breadcrumb.Item>
                            {breadcrumbMap.map(item => {
                                return <Breadcrumb.Item>{item.name}</Breadcrumb.Item>
                            })}

                        </Breadcrumb>
                        }
                    </Col>
                    <Col span={6}>
                        <Menu style={{justifyContent: "right"}} mode='horizontal'>
                            <SubMenu key={"logout_submenu"} style={{float: "right"}}
                                     title={<span><UserOutlined/>{"\u8BF7\u767B\u5F55"}</span>}>
                                <Menu.Item key="logout">
                                    <a onClick="#">\u6CE8\u9500</a>
                                </Menu.Item>
                            </SubMenu>
                        </Menu>
                    </Col>
                </Row>

            </Header>

            <Content
                style={{
                    margin: 0,
                    minHeight: 280,
                }}
            >
                <Switch>
                    {props.routes.map((route, i) => (
                        <RouteWithSubRoutes key={i} {...route} />
                    ))}
                </Switch>
                <Row>
                    <Col span={8}></Col>
                    <Col span={8}><Result
                        icon={<SmileOutlined />}
                        title="\u6B22\u8FCE\u4F7F\u7528\u4F4E\u4EE3\u7801\u5E73\u53F0!"

                    /></Col>
                    <Col span={8}></Col>
                </Row>
            </Content>
        </Layout>
        {/*</Layout>*/}
    </Layout>;
}
    `
    );
    return [["src", "layouts", "BasicLayout"], file2];
  }

  // src/plugins/project/framework/normal/template/files/src/menu/menu.js.ts
  init_define_process();
  function getFile56() {
    const file2 = createResultFile(
      "menu",
      "js",
      `
import {Menu} from "antd";
import Icon from "@ant-design/icons";
import {Link} from "react-router-dom";
let SubMenu = Menu.SubMenu
const compose = (f, g) => ((x,y) => f(x,g(y)));


//\u83B7\u53D6\u83DC\u5355\u9879
const getMenuItem = (menuArray) => {
    let menuItemArr =[]
    menuArray.map(item => {
            if (item.to) {
                menuItemArr.push (<Menu.Item key={item.key} icon={item.icon&&<Icon component={item.icon}></Icon>}>
                    <Link to={item.to}>{item.name}</Link>
                </Menu.Item>)
            } else {
                menuItemArr.push ( <SubMenu key={item.key} icon={item.icon&&<Icon component={item.icon}></Icon>} title={item.name}>
                    {getMenuItem(item.child)}
                </SubMenu>)
            }
        }
    )
    return menuItemArr

}

export const getOpenKeys=(menuArray)=>{
    return menuArray.map(i=> i.key)
}

//\u83B7\u53D6\u83DC\u5355
export const getMenu = (menuArray, onSelect) => {
    return (<Menu
        onSelect={onSelect}
        mode="inline"
        defaultOpenKeys={getOpenKeys(menuArray)}
        defaultSelectedKeys={["dashboard"]}
        style={{ borderRight: 0}}
    >
        {getMenuItem(menuArray)}
    </Menu>)
}

export const flattenMenu = (arr) => {
    return arr.reduce((acc, cur) => {
        if (Array.isArray(cur.child)) {
            return acc.concat([...flattenMenu(cur.child), cur])
        } else {
            acc.push(cur)
        }
        return acc
    }, [])
}

export const getMenuPath = (keyPath, flatMenu) => {
    let array = []
    keyPath.map(key => {
        const fMenu = flatMenu.filter(menu => {
            return key == menu.key
        })
        if(fMenu.length){
            array.push(fMenu[0])
        }
    })
    return array.reverse()
}

export const fcGetMenuPath = compose(getMenuPath,flattenMenu)

    `
    );
    return [["src", "menu"], file2];
  }

  // src/plugins/project/framework/normal/template/static-files.ts
  function generateStaticFiles4(root2 = createResultDir(".")) {
    runFileGenerator(root2, getFile56);
    runFileGenerator(root2, getFile55);
    runFileGenerator(root2, getFile54);
    runFileGenerator(root2, getFile53);
    runFileGenerator(root2, getFile52);
    runFileGenerator(root2, getFile51);
    return root2;
  }

  // src/plugins/project/framework/normal/template/index.ts
  var normalTemplate = {
    slots: {
      components: {
        path: ["src", "components"]
      },
      pages: {
        path: ["src", "pages"]
      },
      router: {
        path: ["src"],
        fileName: "routes"
      },
      entry: {
        path: ["src"],
        fileName: "index"
      },
      constants: {
        path: ["src"],
        fileName: "constants"
      },
      utils: {
        path: ["src"],
        fileName: "utils"
      },
      i18n: {
        path: ["src"],
        fileName: "i18n"
      },
      globalStyle: {
        path: ["src"],
        fileName: "globalStyle"
      },
      htmlEntry: {
        path: ["public"],
        fileName: "index"
      },
      packageJSON: {
        path: [],
        fileName: "package"
      },
      menuData: {
        path: ["src"],
        fileName: "menuData"
      }
    },
    generateTemplate() {
      return generateStaticFiles4();
    }
  };
  var template_default5 = normalTemplate;

  // src/plugins/project/framework/normal/plugins/entry.ts
  init_define_process();
  var pluginFactory61 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.ExternalDepsImport,
        content: `
        import React from 'react';
        import ReactDOM from 'react-dom';
        import App from './App';
      `,
        linkAfter: []
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: `
        ReactDOM.render(
    <App />,
  document.getElementById('root')
);
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      return next;
    };
    return plugin;
  };
  var entry_default4 = pluginFactory61;

  // src/plugins/project/framework/normal/plugins/entryHtml.ts
  init_define_process();
  var pluginFactory62 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "html" /* HTML */,
        name: COMMON_CHUNK_NAME.HtmlContent,
        content: `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8" />
            <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#000000" />
            <meta
                  name="description"
                  content="Web site created using create-react-app"
            />
            <link rel="apple-touch-icon" href="%PUBLIC_URL%/logo192.png" />
            <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
            <title>React App</title>
          </head>
          <body>
            <div id="root"></div>
          </body>
        </html>
      `,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var entryHtml_default3 = pluginFactory62;

  // src/plugins/project/framework/normal/plugins/packageJSON.ts
  init_define_process();
  var pluginFactory63 = (cfg) => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      const packageJson = {
        name: (cfg == null ? void 0 : cfg.packageName) || "create-react-app-antd",
        version: (cfg == null ? void 0 : cfg.packageVersion) || "0.1.0",
        description: "normal react",
        peerDependencies: {
          "react-sortablejs": "~6.0.0"
        },
        dependencies: {
          react: "^17.0.2",
          "@craco/craco": "^6.4.3",
          "@testing-library/jest-dom": "^5.14.1",
          "@testing-library/react": "^12.0.0",
          "@testing-library/user-event": "^13.2.1",
          "antd": "^4.19.2",
          "craco-less": "^2.0.0",
          "query-string": "^7.1.1",
          "react-dom": "^17.0.2",
          "react-router-dom": "^5.3.4",
          "react-scripts": "5.0.0",
          "web-vitals": "^2.1.0",
          ...buildDataSourceDependencies(ir, cfg == null ? void 0 : cfg.datasourceConfig),
          "react-sortablejs": "~6.0.0"
        },
        devDependencies: {
          "craco-alias": "^3.0.1",
          "@craco/craco": "^7.0.0",
          "@testing-library/jest-dom": "^5.16.5",
          "@testing-library/react": "^13.4.0",
          "@testing-library/user-event": "^14.4.3"
        },
        scripts: {
          "start": "craco start",
          "build": "craco build",
          "test": "craco test"
        },
        private: true,
        browserslist: {
          "production": [
            ">0.2%",
            "not dead",
            "not op_mini all"
          ],
          "development": [
            "last 1 chrome version",
            "last 1 firefox version",
            "last 1 safari version"
          ]
        },
        eslintConfig: {
          "extends": [
            "react-app",
            "react-app/jest"
          ]
        }
      };
      ir.packages.forEach((packageInfo) => {
        console.log("dependencies.................");
        console.log(packageInfo.package);
        packageJson.dependencies[packageInfo.package] = packageInfo.version;
      });
      next.chunks.push({
        type: "json" /* JSON */,
        fileType: "json" /* JSON */,
        name: COMMON_CHUNK_NAME.FileMainContent,
        content: packageJson,
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var packageJSON_default4 = pluginFactory63;

  // src/plugins/project/framework/normal/plugins/router.ts
  init_define_process();
  var pluginFactory64 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import {Route} from "react-router-dom";
        import BasicLayout from "@src/layouts/BasicLayout/index";
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileVarDefine,
        content: `
        export const routes = [
          {
            path: '/',
            component: BasicLayout,
            child: [
              ${ir.routes.map(
          (route) => `
                    {
                      path: '${route.path}',
                      component: ${route.componentName},
                    }
                  `
        ).join(",")}
            ],
          },
        ];
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
        export function RouteWithSubRoutes(route) {
    return (
        <Route path={route.path} exact={route.exact}
               render={(props) => {
                   return <route.component {...props} routes={route.child}/>
               }}
        />
    );
}
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.FileUtilDefine,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileVarDefine,
          COMMON_CHUNK_NAME.FileMainContent
        ]
      });
      return next;
    };
    return plugin;
  };
  var router_default3 = pluginFactory64;

  // src/plugins/project/framework/normal/plugins/menuData.ts
  init_define_process();
  var pluginFactory65 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: `
        import {RollbackOutlined,AppstoreOutlined} from "@ant-design/icons";
      `,
        linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "js" /* JS */,
        name: COMMON_CHUNK_NAME.FileExport,
        content: `
export const menuData = [{

    key: 'backIndex',
    name: '\u8FD4\u56DE',
    icon: RollbackOutlined,
    to: "/"
},${ir.routes.map(
          (route) => `
                    {
                      key:${route.componentName},
                      name: '${route.fileName}',
                      component: ${route.componentName},
                      icon: AppstoreOutlined,
                      to: "${route.path}"
                    }
                  `
        ).join(",")}
];
      `,
        linkAfter: [
          COMMON_CHUNK_NAME.ExternalDepsImport,
          COMMON_CHUNK_NAME.InternalDepsImport,
          COMMON_CHUNK_NAME.ImportAliasDefine,
          COMMON_CHUNK_NAME.FileUtilDefine
        ]
      });
      return next;
    };
    return plugin;
  };
  var menuData_default = pluginFactory65;

  // src/plugins/project/framework/normal/plugins/globalStyle.ts
  init_define_process();
  var pluginFactory66 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      const ir = next.ir;
      let hasFusion = false;
      ir.packages.forEach((packageInfo) => {
        console.log("dependencies.................");
        console.log(packageInfo.package);
        if ("@alifd/fusion-ui" === packageInfo.package) {
          hasFusion = true;
        }
      });
      if (hasFusion) {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "css" /* CSS */,
          name: COMMON_CHUNK_NAME.StyleDepsImport,
          content: `
        @import '~antd/dist/antd.css';
        @import '~@alifd/next/dist/next.css';
        @import "~@alifd/pro-layout/dist/AlifdProLayout.css";
      `,
          linkAfter: []
        });
      } else {
        next.chunks.push({
          type: "string" /* STRING */,
          fileType: "css" /* CSS */,
          name: COMMON_CHUNK_NAME.StyleDepsImport,
          content: `
        @import '~antd/dist/antd.css';
      `,
          linkAfter: []
        });
      }
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "css" /* CSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: `
        body {
          -webkit-font-smoothing: antialiased;
        }
      `,
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "css" /* CSS */,
        name: COMMON_CHUNK_NAME.StyleCssContent,
        content: ir.css || "",
        linkAfter: [COMMON_CHUNK_NAME.StyleDepsImport]
      });
      return next;
    };
    return plugin;
  };
  var globalStyle_default4 = pluginFactory66;

  // src/plugins/project/framework/normal/index.ts
  var normal_default = {
    template: template_default5,
    plugins: {
      entry: entry_default4,
      entryHtml: entryHtml_default3,
      packageJSON: packageJSON_default4,
      router: router_default3,
      menuData: menuData_default,
      globalStyle: globalStyle_default4
    }
  };

  // src/solutions/normal.ts
  function createNormalReactProjectBuilder(options) {
    return createProjectBuilder({
      inStrictMode: options == null ? void 0 : options.inStrictMode,
      extraContextData: { ...options },
      template: normal_default.template,
      plugins: {
        components: [
          reactCommonDeps_default3(),
          esmodule_default({
            fileType: "jsx"
          }),
          containerClass_default4(),
          containerInjectContext_default4(),
          containerInjectUtils_default4(),
          containerInjectDataSourceEngine_default4(),
          containerInjectI18n_default3(),
          containerInitState_default4(),
          containerLifeCycle_default4(),
          containerMethod_default3(),
          jsx_default4({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "div",
              Block: "div"
            }
          }),
          css_default()
        ],
        pages: [
          reactCommonDeps_default3(),
          esmodule_default({
            fileType: "jsx"
          }),
          containerClass_default4(),
          containerInjectContext_default4(),
          containerInjectUtils_default4(),
          containerInjectDataSourceEngine_default4(),
          containerInjectI18n_default3(),
          containerInitState_default4(),
          containerLifeCycle_default4(),
          containerMethod_default3(),
          jsx_default4({
            nodeTypeMapping: {
              Div: "div",
              Component: "div",
              Page: "div",
              Block: "div"
            }
          }),
          css_default()
        ],
        router: [esmodule_default(), normal_default.plugins.router()],
        entry: [normal_default.plugins.entry()],
        constants: [constants_default()],
        utils: [esmodule_default(), utils_default("react")],
        i18n: [i18n_default()],
        menuData: [esmodule_default(), normal_default.plugins.menuData()],
        globalStyle: [normal_default.plugins.globalStyle("css")],
        htmlEntry: [normal_default.plugins.entryHtml()],
        packageJSON: [normal_default.plugins.packageJSON()]
      },
      postProcessors: [prettier_default()]
    });
  }
  var plugins4 = {
    containerClass: containerClass_default4,
    containerInitState: containerInitState_default4,
    containerInjectContext: containerInjectContext_default4,
    containerInjectUtils: containerInjectUtils_default4,
    containerInjectI18n: containerInjectI18n_default3,
    containerInjectDataSourceEngine: containerInjectDataSourceEngine_default4,
    containerLifeCycle: containerLifeCycle_default4,
    containerMethod: containerMethod_default3,
    jsx: jsx_default4,
    commonDeps: reactCommonDeps_default3,
    reactCommonDeps: reactCommonDeps_default3
  };

  // src/plugins/common/requireUtils.ts
  init_define_process();
  var pluginFactory67 = () => {
    const plugin = async (pre) => {
      const next = {
        ...pre
      };
      next.chunks.push({
        type: "string" /* STRING */,
        fileType: "jsx" /* JSX */,
        name: COMMON_CHUNK_NAME.InternalDepsImport,
        content: "import * from 'react';",
        linkAfter: []
      });
      return next;
    };
    return plugin;
  };
  var requireUtils_default = pluginFactory67;

  // src/utils/index.ts
  var utils_exports = {};
  __export(utils_exports, {
    common: () => common_exports,
    compositeType: () => compositeType_exports,
    expressionParser: () => expressionParser_exports,
    jsExpression: () => jsExpression_exports,
    jsSlot: () => jsSlot_exports,
    nodeToJSX: () => nodeToJSX_exports,
    resultHelper: () => resultHelper_exports,
    schema: () => schema_exports,
    scope: () => Scope_exports,
    templateHelper: () => templateHelper_exports,
    validate: () => validate_exports,
    version: () => version_exports
  });
  init_define_process();

  // src/standalone.ts
  var standalone_default = {
    createProjectBuilder,
    createModuleBuilder,
    solutions: {
      icejsccs: createIceJsCcsProjectBuilder,
      icejs: createIceJsProjectBuilder,
      rax: createRaxProjectBuilder,
      normal: createNormalReactProjectBuilder
    },
    solutionParts: {
      icejsccs: icejsccs_default,
      icejs: icejs_default,
      rax: rax_default,
      normal: normal_default
    },
    publishers: {
      zip: createZipPublisher
    },
    plugins: {
      common: {
        esmodule: esmodule_default,
        esModule: esmodule_default,
        requireUtils: requireUtils_default
      },
      react: {
        ...plugins
      },
      reactccs: {
        ...plugins3
      },
      rax: {
        ...plugins2
      },
      normal: {
        ...plugins4
      },
      style: {
        css: css_default
      },
      project: {
        constants: constants_default,
        i18n: i18n_default,
        utils: utils_default
      }
    },
    postprocessor: {
      prettier: prettier_default
    },
    utils: utils_exports,
    chunkNames: {
      COMMON_CHUNK_NAME,
      CLASS_DEFINE_CHUNK_NAME,
      REACT_CHUNK_NAME
    },
    defaultLinkAfter: {
      COMMON_DEFAULT_LINK_AFTER: DEFAULT_LINK_AFTER
    },
    constants: const_exports
  };

  // src/standalone-worker.ts
  self.onmessage = (event) => {
    const msg = event.data || {};
    if (msg.type === "run") {
      run(msg);
    }
  };
  self.postMessage({ type: "ready" });
  async function run(msg) {
    try {
      print("begin run...");
      self.postMessage({ type: "run:begin" });
      const { solution } = msg;
      if (!solution) {
        throw new Error("solution is required");
      }
      const createAppBuilder = standalone_default.solutions[solution];
      if (typeof createAppBuilder !== "function") {
        throw new Error(`solution '${solution}' is invalid`);
      }
      const appBuilder = createAppBuilder();
      print("generating from schema: %o", msg.schema);
      const result2 = await appBuilder.generateProject(msg.schema);
      print("generated result: %o", result2);
      const finalResult = msg.flattenResult ? standalone_default.utils.resultHelper.flattenResult(result2) : result2;
      if (msg.flattenResult) {
        print("flatten result: %o", finalResult);
      }
      self.postMessage({
        type: "run:end",
        result: finalResult
      });
    } catch (e) {
      printErr(`${e}`);
      self.postMessage({
        type: "run:error",
        errorMsg: `${(e == null ? void 0 : e.message) || e}`,
        errorDetail: `${e}`
      });
    }
  }
  function print(text, ...args) {
    console.debug(`[code-generator/worker]: ${text}`, ...args);
    self.postMessage({
      type: "stdout",
      data: text,
      args
    });
  }
  function printErr(text, ...args) {
    console.debug(`[code-generator/worker]: %c${text}`, "color:red", ...args);
    self.postMessage({
      type: "stderr",
      data: text,
      args
    });
  }
})();
//# sourceMappingURL=standalone-worker.js.map
